(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 55333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_cache_browser_esm; }
});

;// CONCATENATED MODULE: ../../node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ../../node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Enum.js
var MS = '-ms-'
var MOZ = '-moz-'
var WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Prefixer.js



/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix (value, length) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (Utility_strlen(value) - 1 - length > 6)
				switch (Utility_charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (Utility_charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if (Utility_charat(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex)
		case 6444:
			switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
				// stic(k)y
				case 107:
					return replace(value, ':', ':' + WEBKIT) + value
				// (inline-)?fl(e)x
				case 101:
					return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch (Utility_charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return WEBKIT + value + MS + value + value
	}

	return value
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length)
					break
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case Enum_RULESET:
					if (element.length)
						return Utility_combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && characters.charCodeAt(length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ../../node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);


/***/ }),

/***/ 86015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86894);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,_emotion_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ __webpack_exports__["Z"] = (isPropValid);


/***/ }),

/***/ 86894:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (memoize);


/***/ }),

/***/ 72138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ CacheProvider; },
/* harmony export */   "E": function() { return /* binding */ Emotion; },
/* harmony export */   "T": function() { return /* binding */ ThemeContext; },
/* harmony export */   "c": function() { return /* binding */ createEmotionProps; },
/* harmony export */   "h": function() { return /* binding */ hasOwnProperty; },
/* harmony export */   "u": function() { return /* binding */ useInsertionEffectMaybe; },
/* harmony export */   "w": function() { return /* binding */ withEmotionCache; }
/* harmony export */ });
/* unused harmony exports _, a, b, d */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55333);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82792);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40653);









var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});

if (false) {}

var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = useContext(ThemeContext);
    return /*#__PURE__*/createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe(create) {

  useInsertionEffect(create);
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_3__/* .registerStyles */ .hC)(cache, serialized, isStringTag);
  var rules = useInsertionEffectMaybe(function () {
    return (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_3__/* .insertStyles */ .My)(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_3__/* .getRegisteredStyles */ .fp)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(registeredStyles, undefined, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WrappedComponent, newProps));
});

if (false) {}




/***/ }),

/***/ 28165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "ms": function() { return /* binding */ ClassNames; },
/* harmony export */   "tZ": function() { return /* binding */ jsx; }
/* harmony export */ });
/* unused harmony exports Global, createElement */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55333);
/* harmony import */ var _emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72138);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73463);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82792);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40653);












var pkg = {
	name: "@emotion/react",
	version: "11.10.0",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": "./macro.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.10.0",
		"@emotion/cache": "^11.10.0",
		"@emotion/serialize": "^1.1.0",
		"@emotion/utils": "^1.2.0",
		"@emotion/weak-memoize": "^0.3.0",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.18.5",
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.10.0",
		"@emotion/css-prettifier": "1.1.0",
		"@emotion/server": "11.10.0",
		"@emotion/styled": "11.10.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": "./macro.js"
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !_emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__.h.call(props, 'css')) {
    // $FlowFixMe
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = _emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__.E;
  createElementArgArray[1] = (0,_emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__.c)(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, createElementArgArray);
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, useContext(ThemeContext));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = useRef();
  useInsertionEffect(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffect(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
})));

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_5__/* .getRegisteredStyles */ .fp)(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = (0,_emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__.u)(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      var res = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_5__/* .insertStyles */ .My)(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(0,_emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__.w)(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_5__/* .registerStyles */ .hC)(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_emotion_element_cbed451f_browser_esm_js__WEBPACK_IMPORTED_MODULE_4__.T)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

if (false) {}

if (false) { var globalKey, globalContext, isJest, isBrowser; }




/***/ }),

/***/ 40653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ../../node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var emotion_hash_esm = (murmur2);

;// CONCATENATED MODULE: ../../node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var emotion_unitless_esm = (unitlessKeys);

// EXTERNAL MODULE: ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(86894);
;// CONCATENATED MODULE: ../../node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (emotion_unitless_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = emotion_hash_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 82792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 28223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aN": function() { return /* binding */ Loader; }
/* harmony export */ });
/* unused harmony exports DEFAULT_ID, LoaderStatus */
// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ID = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */
var LoaderStatus;
(function (LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})(LoaderStatus || (LoaderStatus = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */
class Loader {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */
    constructor({ apiKey, authReferrerPolicy, channel, client, id = DEFAULT_ID, language, libraries = [], mapIds, nonce, region, retries = 3, url = "https://maps.googleapis.com/maps/api/js", version, }) {
        this.CALLBACK = "__googleMapsCallback";
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || DEFAULT_ID; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if (Loader.instance) {
            if (!fastDeepEqual(this.options, Loader.instance.options)) {
                throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Loader.instance.options)}`);
            }
            return Loader.instance;
        }
        Loader.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy,
        };
    }
    get status() {
        if (this.errors.length) {
            return LoaderStatus.FAILURE;
        }
        if (this.done) {
            return LoaderStatus.SUCCESS;
        }
        if (this.loading) {
            return LoaderStatus.LOADING;
        }
        return LoaderStatus.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     */
    createUrl() {
        let url = this.url;
        url += `?callback=${this.CALLBACK}`;
        if (this.apiKey) {
            url += `&key=${this.apiKey}`;
        }
        if (this.channel) {
            url += `&channel=${this.channel}`;
        }
        if (this.client) {
            url += `&client=${this.client}`;
        }
        if (this.libraries.length > 0) {
            url += `&libraries=${this.libraries.join(",")}`;
        }
        if (this.language) {
            url += `&language=${this.language}`;
        }
        if (this.region) {
            url += `&region=${this.region}`;
        }
        if (this.version) {
            url += `&v=${this.version}`;
        }
        if (this.mapIds) {
            url += `&map_ids=${this.mapIds.join(",")}`;
        }
        if (this.authReferrerPolicy) {
            url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        }
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) {
            script.remove();
        }
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     */
    load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     */
    loadPromise() {
        return new Promise((resolve, reject) => {
            this.loadCallback((err) => {
                if (!err) {
                    resolve(window.google);
                }
                else {
                    reject(err.error);
                }
            });
        });
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     */
    loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */
    setScript() {
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const url = this.createUrl();
        const script = document.createElement("script");
        script.id = this.id;
        script.type = "text/javascript";
        script.src = url;
        script.onerror = this.loadErrorCallback.bind(this);
        script.defer = true;
        script.async = true;
        if (this.nonce) {
            script.nonce = this.nonce;
        }
        document.head.appendChild(script);
    }
    /**
     * Reset the loader state.
     */
    reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) {
            this.reset();
        }
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.log(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(() => {
                this.deleteScript();
                this.setScript();
            }, delay);
        }
        else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    setCallback() {
        window.__googleMapsCallback = this.callback.bind(this);
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb) => {
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) {
            this.callback();
        }
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader." +
                    "This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setCallback();
                this.setScript();
            }
        }
    }
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 19249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XL": function() { return /* binding */ MarkerClusterer; }
});

// UNUSED EXPORTS: AbstractAlgorithm, AbstractViewportAlgorithm, Cluster, ClusterStats, DefaultRenderer, GridAlgorithm, MarkerClustererEvents, NoopAlgorithm, SuperClusterAlgorithm, defaultOnClusterClickHandler, distanceBetweenPoints, extendBoundsToPaddedViewport, extendPixelBounds, filterMarkersToPaddedViewport, noop, pixelBoundsToLatLngBounds

// EXTERNAL MODULE: ../../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(69378);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ../../node_modules/kdbush/src/sort.js

function sortKD(ids, coords, nodeSize, left, right, depth) {
    if (right - left <= nodeSize) return;

    const m = (left + right) >> 1;

    sort_select(ids, coords, m, left, right, depth % 2);

    sortKD(ids, coords, nodeSize, left, m - 1, depth + 1);
    sortKD(ids, coords, nodeSize, m + 1, right, depth + 1);
}

function sort_select(ids, coords, k, left, right, inc) {

    while (right > left) {
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            sort_select(ids, coords, k, newLeft, newRight, inc);
        }

        const t = coords[2 * k + inc];
        let i = left;
        let j = right;

        swapItem(ids, coords, left, k);
        if (coords[2 * right + inc] > t) swapItem(ids, coords, left, right);

        while (i < j) {
            swapItem(ids, coords, i, j);
            i++;
            j--;
            while (coords[2 * i + inc] < t) i++;
            while (coords[2 * j + inc] > t) j--;
        }

        if (coords[2 * left + inc] === t) swapItem(ids, coords, left, j);
        else {
            j++;
            swapItem(ids, coords, j, right);
        }

        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}

function swapItem(ids, coords, i, j) {
    swap(ids, i, j);
    swap(coords, 2 * i, 2 * j);
    swap(coords, 2 * i + 1, 2 * j + 1);
}

function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}

;// CONCATENATED MODULE: ../../node_modules/kdbush/src/range.js

function range(ids, coords, minX, minY, maxX, maxY, nodeSize) {
    const stack = [0, ids.length - 1, 0];
    const result = [];
    let x, y;

    while (stack.length) {
        const axis = stack.pop();
        const right = stack.pop();
        const left = stack.pop();

        if (right - left <= nodeSize) {
            for (let i = left; i <= right; i++) {
                x = coords[2 * i];
                y = coords[2 * i + 1];
                if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
            }
            continue;
        }

        const m = Math.floor((left + right) / 2);

        x = coords[2 * m];
        y = coords[2 * m + 1];

        if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);

        const nextAxis = (axis + 1) % 2;

        if (axis === 0 ? minX <= x : minY <= y) {
            stack.push(left);
            stack.push(m - 1);
            stack.push(nextAxis);
        }
        if (axis === 0 ? maxX >= x : maxY >= y) {
            stack.push(m + 1);
            stack.push(right);
            stack.push(nextAxis);
        }
    }

    return result;
}

;// CONCATENATED MODULE: ../../node_modules/kdbush/src/within.js

function within(ids, coords, qx, qy, r, nodeSize) {
    const stack = [0, ids.length - 1, 0];
    const result = [];
    const r2 = r * r;

    while (stack.length) {
        const axis = stack.pop();
        const right = stack.pop();
        const left = stack.pop();

        if (right - left <= nodeSize) {
            for (let i = left; i <= right; i++) {
                if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
            }
            continue;
        }

        const m = Math.floor((left + right) / 2);

        const x = coords[2 * m];
        const y = coords[2 * m + 1];

        if (sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);

        const nextAxis = (axis + 1) % 2;

        if (axis === 0 ? qx - r <= x : qy - r <= y) {
            stack.push(left);
            stack.push(m - 1);
            stack.push(nextAxis);
        }
        if (axis === 0 ? qx + r >= x : qy + r >= y) {
            stack.push(m + 1);
            stack.push(right);
            stack.push(nextAxis);
        }
    }

    return result;
}

function sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}

;// CONCATENATED MODULE: ../../node_modules/kdbush/src/index.js





const defaultGetX = p => p[0];
const defaultGetY = p => p[1];

class KDBush {
    constructor(points, getX = defaultGetX, getY = defaultGetY, nodeSize = 64, ArrayType = Float64Array) {
        this.nodeSize = nodeSize;
        this.points = points;

        const IndexArrayType = points.length < 65536 ? Uint16Array : Uint32Array;

        const ids = this.ids = new IndexArrayType(points.length);
        const coords = this.coords = new ArrayType(points.length * 2);

        for (let i = 0; i < points.length; i++) {
            ids[i] = i;
            coords[2 * i] = getX(points[i]);
            coords[2 * i + 1] = getY(points[i]);
        }

        sortKD(ids, coords, nodeSize, 0, ids.length - 1, 0);
    }

    range(minX, minY, maxX, maxY) {
        return range(this.ids, this.coords, minX, minY, maxX, maxY, this.nodeSize);
    }

    within(x, y, r) {
        return within(this.ids, this.coords, x, y, r, this.nodeSize);
    }
}

;// CONCATENATED MODULE: ../../node_modules/supercluster/index.js



const defaultOptions = {
    minZoom: 0,   // min zoom to generate clusters on
    maxZoom: 16,  // max zoom level to cluster the points on
    minPoints: 2, // minimum points to form a cluster
    radius: 40,   // cluster radius in pixels
    extent: 512,  // tile extent (radius is calculated relative to it)
    nodeSize: 64, // size of the KD-tree leaf node, affects performance
    log: false,   // whether to log timing info

    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,

    // a reduce function for calculating custom cluster properties
    reduce: null, // (accumulated, props) => { accumulated.sum += props.sum; }

    // properties to use for individual points when running the reducer
    map: props => props // props => ({sum: props.my_value})
};

const fround = Math.fround || (tmp => ((x) => { tmp[0] = +x; return tmp[0]; }))(new Float32Array(1));

class Supercluster {
    constructor(options) {
        this.options = extend(Object.create(defaultOptions), options);
        this.trees = new Array(this.options.maxZoom + 1);
    }

    load(points) {
        const {log, minZoom, maxZoom, nodeSize} = this.options;

        if (log) console.time('total time');

        const timerId = `prepare ${  points.length  } points`;
        if (log) console.time(timerId);

        this.points = points;

        // generate a cluster object for each point and index input points into a KD-tree
        let clusters = [];
        for (let i = 0; i < points.length; i++) {
            if (!points[i].geometry) continue;
            clusters.push(createPointCluster(points[i], i));
        }
        this.trees[maxZoom + 1] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);

        if (log) console.timeEnd(timerId);

        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for (let z = maxZoom; z >= minZoom; z--) {
            const now = +Date.now();

            // create a new set of clusters for the zoom and index them with a KD-tree
            clusters = this._cluster(clusters, z);
            this.trees[z] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);

            if (log) console.log('z%d: %d clusters in %dms', z, clusters.length, +Date.now() - now);
        }

        if (log) console.timeEnd('total time');

        return this;
    }

    getClusters(bbox, zoom) {
        let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        const minLat = Math.max(-90, Math.min(90, bbox[1]));
        let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        const maxLat = Math.max(-90, Math.min(90, bbox[3]));

        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            const easternHem = this.getClusters([minLng, minLat, 180, maxLat], zoom);
            const westernHem = this.getClusters([-180, minLat, maxLng, maxLat], zoom);
            return easternHem.concat(westernHem);
        }

        const tree = this.trees[this._limitZoom(zoom)];
        const ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
        const clusters = [];
        for (const id of ids) {
            const c = tree.points[id];
            clusters.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
        }
        return clusters;
    }

    getChildren(clusterId) {
        const originId = this._getOriginId(clusterId);
        const originZoom = this._getOriginZoom(clusterId);
        const errorMsg = 'No cluster with the specified id.';

        const index = this.trees[originZoom];
        if (!index) throw new Error(errorMsg);

        const origin = index.points[originId];
        if (!origin) throw new Error(errorMsg);

        const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        const ids = index.within(origin.x, origin.y, r);
        const children = [];
        for (const id of ids) {
            const c = index.points[id];
            if (c.parentId === clusterId) {
                children.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
            }
        }

        if (children.length === 0) throw new Error(errorMsg);

        return children;
    }

    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;

        const leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);

        return leaves;
    }

    getTile(z, x, y) {
        const tree = this.trees[this._limitZoom(z)];
        const z2 = Math.pow(2, z);
        const {extent, radius} = this.options;
        const p = radius / extent;
        const top = (y - p) / z2;
        const bottom = (y + 1 + p) / z2;

        const tile = {
            features: []
        };

        this._addTileFeatures(
            tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom),
            tree.points, x, y, z2, tile);

        if (x === 0) {
            this._addTileFeatures(
                tree.range(1 - p / z2, top, 1, bottom),
                tree.points, z2, y, z2, tile);
        }
        if (x === z2 - 1) {
            this._addTileFeatures(
                tree.range(0, top, p / z2, bottom),
                tree.points, -1, y, z2, tile);
        }

        return tile.features.length ? tile : null;
    }

    getClusterExpansionZoom(clusterId) {
        let expansionZoom = this._getOriginZoom(clusterId) - 1;
        while (expansionZoom <= this.options.maxZoom) {
            const children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }

    _appendLeaves(result, clusterId, limit, offset, skipped) {
        const children = this.getChildren(clusterId);

        for (const child of children) {
            const props = child.properties;

            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) {
                    // skip the whole cluster
                    skipped += props.point_count;
                } else {
                    // enter the cluster
                    skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
                    // exit the cluster
                }
            } else if (skipped < offset) {
                // skip a single point
                skipped++;
            } else {
                // add a single point
                result.push(child);
            }
            if (result.length === limit) break;
        }

        return skipped;
    }

    _addTileFeatures(ids, points, x, y, z2, tile) {
        for (const i of ids) {
            const c = points[i];
            const isCluster = c.numPoints;

            let tags, px, py;
            if (isCluster) {
                tags = getClusterProperties(c);
                px = c.x;
                py = c.y;
            } else {
                const p = this.points[c.index];
                tags = p.properties;
                px = lngX(p.geometry.coordinates[0]);
                py = latY(p.geometry.coordinates[1]);
            }

            const f = {
                type: 1,
                geometry: [[
                    Math.round(this.options.extent * (px * z2 - x)),
                    Math.round(this.options.extent * (py * z2 - y))
                ]],
                tags
            };

            // assign id
            let id;
            if (isCluster) {
                id = c.id;
            } else if (this.options.generateId) {
                // optionally generate id
                id = c.index;
            } else if (this.points[c.index].id) {
                // keep id if already assigned
                id = this.points[c.index].id;
            }

            if (id !== undefined) f.id = id;

            tile.features.push(f);
        }
    }

    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }

    _cluster(points, zoom) {
        const clusters = [];
        const {radius, extent, reduce, minPoints} = this.options;
        const r = radius / (extent * Math.pow(2, zoom));

        // loop through each point
        for (let i = 0; i < points.length; i++) {
            const p = points[i];
            // if we've already visited the point at this zoom level, skip it
            if (p.zoom <= zoom) continue;
            p.zoom = zoom;

            // find all nearby points
            const tree = this.trees[zoom + 1];
            const neighborIds = tree.within(p.x, p.y, r);

            const numPointsOrigin = p.numPoints || 1;
            let numPoints = numPointsOrigin;

            // count the number of points in a potential cluster
            for (const neighborId of neighborIds) {
                const b = tree.points[neighborId];
                // filter out neighbors that are already processed
                if (b.zoom > zoom) numPoints += b.numPoints || 1;
            }

            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                let wx = p.x * numPointsOrigin;
                let wy = p.y * numPointsOrigin;

                let clusterProperties = reduce && numPointsOrigin > 1 ? this._map(p, true) : null;

                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                const id = (i << 5) + (zoom + 1) + this.points.length;

                for (const neighborId of neighborIds) {
                    const b = tree.points[neighborId];

                    if (b.zoom <= zoom) continue;
                    b.zoom = zoom; // save the zoom (so it doesn't get processed twice)

                    const numPoints2 = b.numPoints || 1;
                    wx += b.x * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += b.y * numPoints2;

                    b.parentId = id;

                    if (reduce) {
                        if (!clusterProperties) clusterProperties = this._map(p, true);
                        reduce(clusterProperties, this._map(b));
                    }
                }

                p.parentId = id;
                clusters.push(createCluster(wx / numPoints, wy / numPoints, id, numPoints, clusterProperties));

            } else { // left points as unclustered
                clusters.push(p);

                if (numPoints > 1) {
                    for (const neighborId of neighborIds) {
                        const b = tree.points[neighborId];
                        if (b.zoom <= zoom) continue;
                        b.zoom = zoom;
                        clusters.push(b);
                    }
                }
            }
        }

        return clusters;
    }

    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return (clusterId - this.points.length) >> 5;
    }

    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }

    _map(point, clone) {
        if (point.numPoints) {
            return clone ? extend({}, point.properties) : point.properties;
        }
        const original = this.points[point.index].properties;
        const result = this.options.map(original);
        return clone && result === original ? extend({}, result) : result;
    }
}

function createCluster(x, y, id, numPoints, properties) {
    return {
        x: fround(x), // weighted cluster center; round for consistency with Float32Array index
        y: fround(y),
        zoom: Infinity, // the last zoom the cluster was processed at
        id, // encodes index of the first child of the cluster and its zoom level
        parentId: -1, // parent cluster id
        numPoints,
        properties
    };
}

function createPointCluster(p, id) {
    const [x, y] = p.geometry.coordinates;
    return {
        x: fround(lngX(x)), // projected point coordinates
        y: fround(latY(y)),
        zoom: Infinity, // the last zoom the point was processed at
        index: id, // index of the source feature in the original input array,
        parentId: -1 // parent cluster id
    };
}

function getClusterJSON(cluster) {
    return {
        type: 'Feature',
        id: cluster.id,
        properties: getClusterProperties(cluster),
        geometry: {
            type: 'Point',
            coordinates: [xLng(cluster.x), yLat(cluster.y)]
        }
    };
}

function getClusterProperties(cluster) {
    const count = cluster.numPoints;
    const abbrev =
        count >= 10000 ? `${Math.round(count / 1000)  }k` :
        count >= 1000 ? `${Math.round(count / 100) / 10  }k` : count;
    return extend(extend({}, cluster.properties), {
        cluster: true,
        cluster_id: cluster.id,
        point_count: count,
        point_count_abbreviated: abbrev
    });
}

// longitude/latitude to spherical mercator in [0..1] range
function lngX(lng) {
    return lng / 360 + 0.5;
}
function latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = (0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI);
    return y < 0 ? 0 : y > 1 ? 1 : y;
}

// spherical mercator to longitude/latitude
function xLng(x) {
    return (x - 0.5) * 360;
}
function yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}

function extend(dest, src) {
    for (const id in src) dest[id] = src[id];
    return dest;
}

function getX(p) {
    return p.x;
}
function getY(p) {
    return p.y;
}

;// CONCATENATED MODULE: ../../node_modules/@googlemaps/markerclusterer/dist/index.esm.js



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Cluster {
    constructor({ markers, position }) {
        this.markers = markers;
        if (position) {
            if (position instanceof google.maps.LatLng) {
                this._position = position;
            }
            else {
                this._position = new google.maps.LatLng(position);
            }
        }
    }
    get bounds() {
        if (this.markers.length === 0 && !this._position) {
            return undefined;
        }
        return this.markers.reduce((bounds, marker) => {
            return bounds.extend(marker.getPosition());
        }, new google.maps.LatLngBounds(this._position, this._position));
    }
    get position() {
        return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */
    get count() {
        return this.markers.filter((m) => m.getVisible())
            .length;
    }
    /**
     * Add a marker to the cluster.
     */
    push(marker) {
        this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */
    delete() {
        if (this.marker) {
            this.marker.setMap(null);
            delete this.marker;
        }
        this.markers.length = 0;
    }
}

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const filterMarkersToPaddedViewport = (map, mapCanvasProjection, markers, viewportPadding) => {
    const extendedMapBounds = extendBoundsToPaddedViewport(map.getBounds(), mapCanvasProjection, viewportPadding);
    return markers.filter((marker) => extendedMapBounds.contains(marker.getPosition()));
};
/**
 * Extends a bounds by a number of pixels in each direction.
 */
const extendBoundsToPaddedViewport = (bounds, projection, pixels) => {
    const { northEast, southWest } = latLngBoundsToPixelBounds(bounds, projection);
    const extendedPixelBounds = extendPixelBounds({ northEast, southWest }, pixels);
    return pixelBoundsToLatLngBounds(extendedPixelBounds, projection);
};
/**
 * @hidden
 */
const distanceBetweenPoints = (p1, p2) => {
    const R = 6371; // Radius of the Earth in km
    const dLat = ((p2.lat - p1.lat) * Math.PI) / 180;
    const dLon = ((p2.lng - p1.lng) * Math.PI) / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((p1.lat * Math.PI) / 180) *
            Math.cos((p2.lat * Math.PI) / 180) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
/**
 * @hidden
 */
const latLngBoundsToPixelBounds = (bounds, projection) => {
    return {
        northEast: projection.fromLatLngToDivPixel(bounds.getNorthEast()),
        southWest: projection.fromLatLngToDivPixel(bounds.getSouthWest()),
    };
};
/**
 * @hidden
 */
const extendPixelBounds = ({ northEast, southWest }, pixels) => {
    northEast.x += pixels;
    northEast.y -= pixels;
    southWest.x -= pixels;
    southWest.y += pixels;
    return { northEast, southWest };
};
/**
 * @hidden
 */
const pixelBoundsToLatLngBounds = ({ northEast, southWest }, projection) => {
    const bounds = new google.maps.LatLngBounds();
    bounds.extend(projection.fromDivPixelToLatLng(northEast));
    bounds.extend(projection.fromDivPixelToLatLng(southWest));
    return bounds;
};

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @hidden
 */
class AbstractAlgorithm {
    constructor({ maxZoom = 16 }) {
        this.maxZoom = maxZoom;
    }
    /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers, map})
     *    }
     * }
     * ```
     */
    noop({ markers }) {
        return noop(markers);
    }
}
/**
 * Abstract viewport algorithm proves a class to filter markers by a padded
 * viewport. This is a common optimization.
 *
 * @hidden
 */
class AbstractViewportAlgorithm extends (/* unused pure expression or super */ null && (AbstractAlgorithm)) {
    constructor(_a) {
        var { viewportPadding = 60 } = _a, options = __rest(_a, ["viewportPadding"]);
        super(options);
        this.viewportPadding = 60;
        this.viewportPadding = viewportPadding;
    }
    calculate({ markers, map, mapCanvasProjection, }) {
        if (map.getZoom() >= this.maxZoom) {
            return {
                clusters: this.noop({
                    markers,
                    map,
                    mapCanvasProjection,
                }),
                changed: false,
            };
        }
        return {
            clusters: this.cluster({
                markers: filterMarkersToPaddedViewport(map, mapCanvasProjection, markers, this.viewportPadding),
                map,
                mapCanvasProjection,
            }),
        };
    }
}
/**
 * @hidden
 */
const noop = (markers) => {
    const clusters = markers.map((marker) => new Cluster({
        position: marker.getPosition(),
        markers: [marker],
    }));
    return clusters;
};

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The default Grid algorithm historically used in Google Maps marker
 * clustering.
 *
 * The Grid algorithm does not implement caching and markers may flash as the
 * viewport changes. Instead use {@link SuperClusterAlgorithm}.
 */
class GridAlgorithm extends (/* unused pure expression or super */ null && (AbstractViewportAlgorithm)) {
    constructor(_a) {
        var { maxDistance = 40000, gridSize = 40 } = _a, options = __rest(_a, ["maxDistance", "gridSize"]);
        super(options);
        this.clusters = [];
        this.maxDistance = maxDistance;
        this.gridSize = gridSize;
        this.state = { zoom: null };
    }
    calculate({ markers, map, mapCanvasProjection, }) {
        const state = { zoom: map.getZoom() };
        let changed = false;
        if (this.state.zoom > this.maxZoom && state.zoom > this.maxZoom) ;
        else {
            changed = !equal(this.state, state);
        }
        this.state = state;
        if (map.getZoom() >= this.maxZoom) {
            return {
                clusters: this.noop({
                    markers,
                    map,
                    mapCanvasProjection,
                }),
                changed: changed,
            };
        }
        return {
            clusters: this.cluster({
                markers: filterMarkersToPaddedViewport(map, mapCanvasProjection, markers, this.viewportPadding),
                map,
                mapCanvasProjection,
            }),
        };
    }
    cluster({ markers, map, mapCanvasProjection, }) {
        this.clusters = [];
        markers.forEach((marker) => {
            this.addToClosestCluster(marker, map, mapCanvasProjection);
        });
        return this.clusters;
    }
    addToClosestCluster(marker, map, projection) {
        let maxDistance = this.maxDistance; // Some large number
        let cluster = null;
        for (let i = 0; i < this.clusters.length; i++) {
            const candidate = this.clusters[i];
            const distance = distanceBetweenPoints(candidate.bounds.getCenter().toJSON(), marker.getPosition().toJSON());
            if (distance < maxDistance) {
                maxDistance = distance;
                cluster = candidate;
            }
        }
        if (cluster &&
            extendBoundsToPaddedViewport(cluster.bounds, projection, this.gridSize).contains(marker.getPosition())) {
            cluster.push(marker);
        }
        else {
            const cluster = new Cluster({ markers: [marker] });
            this.clusters.push(cluster);
        }
    }
}

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Noop algorithm does not generate any clusters or filter markers by the an extended viewport.
 */
class NoopAlgorithm extends (/* unused pure expression or super */ null && (AbstractAlgorithm)) {
    constructor(_a) {
        var options = __rest(_a, []);
        super(options);
    }
    calculate({ markers, map, mapCanvasProjection, }) {
        return {
            clusters: this.cluster({ markers, map, mapCanvasProjection }),
            changed: false,
        };
    }
    cluster(input) {
        return this.noop(input);
    }
}

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */
class SuperClusterAlgorithm extends AbstractAlgorithm {
    constructor(_a) {
        var { maxZoom, radius = 60 } = _a, options = __rest(_a, ["maxZoom", "radius"]);
        super({ maxZoom });
        this.superCluster = new Supercluster(Object.assign({ maxZoom: this.maxZoom, radius }, options));
        this.state = { zoom: null };
    }
    calculate(input) {
        let changed = false;
        if (!fast_deep_equal_default()(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [...input.markers];
            const points = this.markers.map((marker) => {
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [
                            marker.getPosition().lng(),
                            marker.getPosition().lat(),
                        ],
                    },
                    properties: { marker },
                };
            });
            this.superCluster.load(points);
        }
        const state = { zoom: input.map.getZoom() };
        if (!changed) {
            if (this.state.zoom > this.maxZoom && state.zoom > this.maxZoom) ;
            else {
                changed = changed || !fast_deep_equal_default()(this.state, state);
            }
        }
        this.state = state;
        if (changed) {
            this.clusters = this.cluster(input);
        }
        return { clusters: this.clusters, changed };
    }
    cluster({ map }) {
        return this.superCluster
            .getClusters([-180, -90, 180, 90], Math.round(map.getZoom()))
            .map(this.transformCluster.bind(this));
    }
    transformCluster({ geometry: { coordinates: [lng, lat], }, properties, }) {
        if (properties.cluster) {
            return new Cluster({
                markers: this.superCluster
                    .getLeaves(properties.cluster_id, Infinity)
                    .map((leaf) => leaf.properties.marker),
                position: new google.maps.LatLng({ lat, lng }),
            });
        }
        else {
            const marker = properties.marker;
            return new Cluster({
                markers: [marker],
                position: marker.getPosition(),
            });
        }
    }
}

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */
class ClusterStats {
    constructor(markers, clusters) {
        this.markers = { sum: markers.length };
        const clusterMarkerCounts = clusters.map((a) => a.count);
        const clusterMarkerSum = clusterMarkerCounts.reduce((a, b) => a + b, 0);
        this.clusters = {
            count: clusters.length,
            markers: {
                mean: clusterMarkerSum / clusters.length,
                sum: clusterMarkerSum,
                min: Math.min(...clusterMarkerCounts),
                max: Math.max(...clusterMarkerCounts),
            },
        };
    }
}
class DefaultRenderer {
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */
    render({ count, position }, stats) {
        // change color if this cluster has more markers than the mean cluster
        const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
        // create svg url with fill color
        const svg = window.btoa(`
  <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
    <circle cx="120" cy="120" opacity=".6" r="70" />
    <circle cx="120" cy="120" opacity=".3" r="90" />
    <circle cx="120" cy="120" opacity=".2" r="110" />
  </svg>`);
        // create marker using svg icon
        return new google.maps.Marker({
            position,
            icon: {
                url: `data:image/svg+xml;base64,${svg}`,
                scaledSize: new google.maps.Size(45, 45),
            },
            label: {
                text: String(count),
                color: "rgba(255,255,255,0.9)",
                fontSize: "12px",
            },
            title: `Cluster of ${count} markers`,
            // adjust zIndex to be above other markers
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        });
    }
}

/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function index_esm_extend(type1, type2) {
    /* istanbul ignore next */
    // eslint-disable-next-line prefer-const
    for (let property in type2.prototype) {
        type1.prototype[property] = type2.prototype[property];
    }
}
/**
 * @ignore
 */
class OverlayViewSafe {
    constructor() {
        // MarkerClusterer implements google.maps.OverlayView interface. We use the
        // extend function to extend MarkerClusterer with google.maps.OverlayView
        // because it might not always be available when the code is defined so we
        // look for it at the last possible moment. If it doesn't exist now then
        // there is no point going ahead :)
        index_esm_extend(OverlayViewSafe, google.maps.OverlayView);
    }
}

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MarkerClustererEvents;
(function (MarkerClustererEvents) {
    MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})(MarkerClustererEvents || (MarkerClustererEvents = {}));
const defaultOnClusterClickHandler = (_, cluster, map) => {
    map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */
class MarkerClusterer extends OverlayViewSafe {
    constructor({ map, markers = [], algorithm = new SuperClusterAlgorithm({}), renderer = new DefaultRenderer(), onClusterClick = defaultOnClusterClickHandler, }) {
        super();
        this.markers = [...markers];
        this.clusters = [];
        this.algorithm = algorithm;
        this.renderer = renderer;
        this.onClusterClick = onClusterClick;
        if (map) {
            this.setMap(map);
        }
    }
    addMarker(marker, noDraw) {
        if (this.markers.includes(marker)) {
            return;
        }
        this.markers.push(marker);
        if (!noDraw) {
            this.render();
        }
    }
    addMarkers(markers, noDraw) {
        markers.forEach((marker) => {
            this.addMarker(marker, true);
        });
        if (!noDraw) {
            this.render();
        }
    }
    removeMarker(marker, noDraw) {
        const index = this.markers.indexOf(marker);
        if (index === -1) {
            // Marker is not in our list of markers, so do nothing:
            return false;
        }
        marker.setMap(null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        if (!noDraw) {
            this.render();
        }
        return true;
    }
    removeMarkers(markers, noDraw) {
        let removed = false;
        markers.forEach((marker) => {
            removed = this.removeMarker(marker, true) || removed;
        });
        if (removed && !noDraw) {
            this.render();
        }
        return removed;
    }
    clearMarkers(noDraw) {
        this.markers.length = 0;
        if (!noDraw) {
            this.render();
        }
    }
    /**
     * Recalculates and draws all the marker clusters.
     */
    render() {
        const map = this.getMap();
        if (map instanceof google.maps.Map && this.getProjection()) {
            google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_BEGIN, this);
            const { clusters, changed } = this.algorithm.calculate({
                markers: this.markers,
                map,
                mapCanvasProjection: this.getProjection(),
            });
            // allow algorithms to return flag on whether the clusters/markers have changed
            if (changed || changed == undefined) {
                // reset visibility of markers and clusters
                this.reset();
                // store new clusters
                this.clusters = clusters;
                this.renderClusters();
            }
            google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_END, this);
        }
    }
    onAdd() {
        this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
        this.render();
    }
    onRemove() {
        google.maps.event.removeListener(this.idleListener);
        this.reset();
    }
    reset() {
        this.markers.forEach((marker) => marker.setMap(null));
        this.clusters.forEach((cluster) => cluster.delete());
        this.clusters = [];
    }
    renderClusters() {
        // generate stats to pass to renderers
        const stats = new ClusterStats(this.markers, this.clusters);
        const map = this.getMap();
        this.clusters.forEach((cluster) => {
            if (cluster.markers.length === 1) {
                cluster.marker = cluster.markers[0];
            }
            else {
                cluster.marker = this.renderer.render(cluster, stats);
                if (this.onClusterClick) {
                    cluster.marker.addListener("click", 
                    /* istanbul ignore next */
                    (event) => {
                        google.maps.event.trigger(this, MarkerClustererEvents.CLUSTER_CLICK, cluster);
                        this.onClusterClick(event, cluster, map);
                    });
                }
            }
            cluster.marker.setMap(map);
        });
    }
}


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 47988:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

exports.Z = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
  );
};

/***/ }),

/***/ 16331:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

exports.Z = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
  );
};

/***/ }),

/***/ 14415:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.N = void 0;
const typeUtils_1 = __webpack_require__(34434);
/**
 * A Fetch WebAPI implementation based on the Axios client
 */
const axiosFetch = (axios, 
// Convert the `fetch` style arguments into a Axios style config
transformer = (config) => config) => async (input, init) => {
    const rawHeaders = (0, typeUtils_1.createAxiosHeaders)(init === null || init === void 0 ? void 0 : init.headers);
    const lowerCasedHeaders = {};
    Object.entries(rawHeaders).forEach(([name, value]) => {
        lowerCasedHeaders[name.toLowerCase()] = value;
    });
    if (!('content-type' in lowerCasedHeaders)) {
        lowerCasedHeaders['content-type'] = 'text/plain;charset=UTF-8';
    }
    const rawConfig = {
        url: (0, typeUtils_1.getUrl)(input),
        method: (init === null || init === void 0 ? void 0 : init.method) || 'GET',
        data: init === null || init === void 0 ? void 0 : init.body,
        headers: lowerCasedHeaders,
        // Force the response to an arraybuffer type. Without this, the Response
        // object will try to guess the content type and add headers that weren't in
        // the response.
        // NOTE: Don't use 'stream' because it's not supported in the browser
        responseType: 'arraybuffer'
    };
    const config = transformer(rawConfig, input, init);
    let result;
    try {
        result = await axios.request(config);
    }
    catch (err) {
        if (err.response) {
            result = err.response;
        }
        else {
            throw err;
        }
    }
    return new Response(result.data, {
        status: result.status,
        statusText: result.statusText,
        headers: (0, typeUtils_1.createFetchHeaders)(result.headers)
    });
};
const buildAxiosFetch = (axios, transformer) => axiosFetch(axios, transformer);
exports.N = buildAxiosFetch;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 34434:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getUrl = exports.createAxiosHeaders = exports.createFetchHeaders = void 0;
function createFetchHeaders(axiosHeaders = {}) {
    const headers = [];
    Object.entries(axiosHeaders).forEach(([name, value]) => {
        headers.push([name, value]);
    });
    return headers;
}
exports.createFetchHeaders = createFetchHeaders;
const isHeaders = (headers) => { var _a; return ((_a = headers.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'Headers'; };
function createAxiosHeaders(headers = {}) {
    const rawHeaders = {};
    if (isHeaders(headers)) {
        headers.forEach((value, name) => {
            rawHeaders[name] = value;
        });
    }
    else if (Array.isArray(headers)) {
        headers.forEach(([name, value]) => {
            if (value) {
                rawHeaders[name] = value;
            }
        });
    }
    else {
        Object.entries(headers).forEach(([name, value]) => {
            if (value) {
                rawHeaders[name] = value;
            }
        });
    }
    return rawHeaders;
}
exports.createAxiosHeaders = createAxiosHeaders;
function getUrl(input) {
    let url;
    if (typeof input === 'string') {
        url = input;
    }
    else if (input === null || input === void 0 ? void 0 : input.href) {
        url = input.href;
    }
    else if (input === null || input === void 0 ? void 0 : input.url) {
        url = input.url;
    }
    return url;
}
exports.getUrl = getUrl;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 27911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SV": function() { return /* reexport */ es_DiffEditor; },
  "ZP": function() { return /* reexport */ es_Editor; }
});

// UNUSED EXPORTS: loader, useMonaco

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/loader/lib/es/_virtual/_rollupPluginBabelHelpers.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



;// CONCATENATED MODULE: ../../node_modules/state-local/lib/es/state-local.js
function state_local_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function state_local_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function state_local_objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      state_local_ownKeys(Object(source), true).forEach(function (key) {
        state_local_defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      state_local_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function compose() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    return fns.reduceRight(function (y, f) {
      return f(y);
    }, x);
  };
}

function curry(fn) {
  return function curried() {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return args.length >= fn.length ? fn.apply(this, args) : function () {
      for (var _len3 = arguments.length, nextArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        nextArgs[_key3] = arguments[_key3];
      }

      return curried.apply(_this, [].concat(args, nextArgs));
    };
  };
}

function isObject(value) {
  return {}.toString.call(value).includes('Object');
}

function isEmpty(obj) {
  return !Object.keys(obj).length;
}

function isFunction(value) {
  return typeof value === 'function';
}

function state_local_hasOwnProperty(object, property) {
  return Object.prototype.hasOwnProperty.call(object, property);
}

function validateChanges(initial, changes) {
  if (!isObject(changes)) errorHandler('changeType');
  if (Object.keys(changes).some(function (field) {
    return !state_local_hasOwnProperty(initial, field);
  })) errorHandler('changeField');
  return changes;
}

function validateSelector(selector) {
  if (!isFunction(selector)) errorHandler('selectorType');
}

function validateHandler(handler) {
  if (!(isFunction(handler) || isObject(handler))) errorHandler('handlerType');
  if (isObject(handler) && Object.values(handler).some(function (_handler) {
    return !isFunction(_handler);
  })) errorHandler('handlersType');
}

function validateInitial(initial) {
  if (!initial) errorHandler('initialIsRequired');
  if (!isObject(initial)) errorHandler('initialType');
  if (isEmpty(initial)) errorHandler('initialContent');
}

function throwError(errorMessages, type) {
  throw new Error(errorMessages[type] || errorMessages["default"]);
}

var errorMessages = {
  initialIsRequired: 'initial state is required',
  initialType: 'initial state should be an object',
  initialContent: 'initial state shouldn\'t be an empty object',
  handlerType: 'handler should be an object or a function',
  handlersType: 'all handlers should be a functions',
  selectorType: 'selector should be a function',
  changeType: 'provided value of changes should be an object',
  changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
  "default": 'an unknown error accured in `state-local` package'
};
var errorHandler = curry(throwError)(errorMessages);
var validators = {
  changes: validateChanges,
  selector: validateSelector,
  handler: validateHandler,
  initial: validateInitial
};

function create(initial) {
  var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  validators.initial(initial);
  validators.handler(handler);
  var state = {
    current: initial
  };
  var didUpdate = curry(didStateUpdate)(state, handler);
  var update = curry(updateState)(state);
  var validate = curry(validators.changes)(initial);
  var getChanges = curry(extractChanges)(state);

  function getState() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (state) {
      return state;
    };
    validators.selector(selector);
    return selector(state.current);
  }

  function setState(causedChanges) {
    compose(didUpdate, update, validate, getChanges)(causedChanges);
  }

  return [getState, setState];
}

function extractChanges(state, causedChanges) {
  return isFunction(causedChanges) ? causedChanges(state.current) : causedChanges;
}

function updateState(state, changes) {
  state.current = state_local_objectSpread2(state_local_objectSpread2({}, state.current), changes);
  return changes;
}

function didStateUpdate(state, handler, changes) {
  isFunction(handler) ? handler(state.current) : Object.keys(changes).forEach(function (field) {
    var _handler$field;

    return (_handler$field = handler[field]) === null || _handler$field === void 0 ? void 0 : _handler$field.call(handler, state.current[field]);
  });
  return changes;
}

var index = {
  create: create
};

/* harmony default export */ var state_local = (index);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/loader/lib/es/config/index.js
var config = {
  paths: {
    vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.33.0/min/vs'
  }
};

/* harmony default export */ var es_config = (config);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/loader/lib/es/utils/curry.js
function curry_curry(fn) {
  return function curried() {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.length >= fn.length ? fn.apply(this, args) : function () {
      for (var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        nextArgs[_key2] = arguments[_key2];
      }

      return curried.apply(_this, [].concat(args, nextArgs));
    };
  };
}

/* harmony default export */ var utils_curry = (curry_curry);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/loader/lib/es/utils/isObject.js
function isObject_isObject(value) {
  return {}.toString.call(value).includes('Object');
}

/* harmony default export */ var utils_isObject = (isObject_isObject);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/loader/lib/es/validators/index.js



/**
 * validates the configuration object and informs about deprecation
 * @param {Object} config - the configuration object 
 * @return {Object} config - the validated configuration object
 */

function validateConfig(config) {
  if (!config) validators_errorHandler('configIsRequired');
  if (!utils_isObject(config)) validators_errorHandler('configType');

  if (config.urls) {
    informAboutDeprecation();
    return {
      paths: {
        vs: config.urls.monacoBase
      }
    };
  }

  return config;
}
/**
 * logs deprecation message
 */


function informAboutDeprecation() {
  console.warn(validators_errorMessages.deprecation);
}

function validators_throwError(errorMessages, type) {
  throw new Error(errorMessages[type] || errorMessages["default"]);
}

var validators_errorMessages = {
  configIsRequired: 'the configuration object is required',
  configType: 'the configuration object should be an object',
  "default": 'an unknown error accured in `@monaco-editor/loader` package',
  deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
};
var validators_errorHandler = utils_curry(validators_throwError)(validators_errorMessages);
var validators_validators = {
  config: validateConfig
};

/* harmony default export */ var es_validators = (validators_validators);


;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/loader/lib/es/utils/compose.js
var compose_compose = function compose() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    return fns.reduceRight(function (y, f) {
      return f(y);
    }, x);
  };
};

/* harmony default export */ var utils_compose = (compose_compose);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/loader/lib/es/utils/deepMerge.js


function merge(target, source) {
  Object.keys(source).forEach(function (key) {
    if (source[key] instanceof Object) {
      if (target[key]) {
        Object.assign(source[key], merge(target[key], source[key]));
      }
    }
  });
  return _objectSpread2(_objectSpread2({}, target), source);
}

/* harmony default export */ var deepMerge = (merge);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/loader/lib/es/utils/makeCancelable.js
// The source (has been changed) is https://github.com/facebook/react/issues/5465#issuecomment-157888325
var CANCELATION_MESSAGE = {
  type: 'cancelation',
  msg: 'operation is manually canceled'
};

function makeCancelable(promise) {
  var hasCanceled_ = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled_ ? reject(CANCELATION_MESSAGE) : resolve(val);
    });
    promise["catch"](reject);
  });
  return wrappedPromise.cancel = function () {
    return hasCanceled_ = true;
  }, wrappedPromise;
}

/* harmony default export */ var utils_makeCancelable = (makeCancelable);


;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/loader/lib/es/loader/index.js








/** the local state of the module */

var _state$create = state_local.create({
  config: es_config,
  isInitialized: false,
  resolve: null,
  reject: null,
  monaco: null
}),
    _state$create2 = _slicedToArray(_state$create, 2),
    getState = _state$create2[0],
    setState = _state$create2[1];
/**
 * set the loader configuration
 * @param {Object} config - the configuration object
 */


function loader_config(globalConfig) {
  var _validators$config = es_validators.config(globalConfig),
      monaco = _validators$config.monaco,
      config = _objectWithoutProperties(_validators$config, ["monaco"]);

  setState(function (state) {
    return {
      config: deepMerge(state.config, config),
      monaco: monaco
    };
  });
}
/**
 * handles the initialization of the monaco-editor
 * @return {Promise} - returns an instance of monaco (with a cancelable promise)
 */


function init() {
  var state = getState(function (_ref) {
    var monaco = _ref.monaco,
        isInitialized = _ref.isInitialized,
        resolve = _ref.resolve;
    return {
      monaco: monaco,
      isInitialized: isInitialized,
      resolve: resolve
    };
  });

  if (!state.isInitialized) {
    setState({
      isInitialized: true
    });

    if (state.monaco) {
      state.resolve(state.monaco);
      return utils_makeCancelable(wrapperPromise);
    }

    if (window.monaco && window.monaco.editor) {
      storeMonacoInstance(window.monaco);
      state.resolve(window.monaco);
      return utils_makeCancelable(wrapperPromise);
    }

    utils_compose(injectScripts, getMonacoLoaderScript)(configureLoader);
  }

  return utils_makeCancelable(wrapperPromise);
}
/**
 * injects provided scripts into the document.body
 * @param {Object} script - an HTML script element
 * @return {Object} - the injected HTML script element
 */


function injectScripts(script) {
  return document.body.appendChild(script);
}
/**
 * creates an HTML script element with/without provided src
 * @param {string} [src] - the source path of the script
 * @return {Object} - the created HTML script element
 */


function createScript(src) {
  var script = document.createElement('script');
  return src && (script.src = src), script;
}
/**
 * creates an HTML script element with the monaco loader src
 * @return {Object} - the created HTML script element
 */


function getMonacoLoaderScript(configureLoader) {
  var state = getState(function (_ref2) {
    var config = _ref2.config,
        reject = _ref2.reject;
    return {
      config: config,
      reject: reject
    };
  });
  var loaderScript = createScript("".concat(state.config.paths.vs, "/loader.js"));

  loaderScript.onload = function () {
    return configureLoader();
  };

  loaderScript.onerror = state.reject;
  return loaderScript;
}
/**
 * configures the monaco loader
 */


function configureLoader() {
  var state = getState(function (_ref3) {
    var config = _ref3.config,
        resolve = _ref3.resolve,
        reject = _ref3.reject;
    return {
      config: config,
      resolve: resolve,
      reject: reject
    };
  });
  var require = window.require;

  require.config(state.config);

  require(['vs/editor/editor.main'], function (monaco) {
    storeMonacoInstance(monaco);
    state.resolve(monaco);
  }, function (error) {
    state.reject(error);
  });
}
/**
 * store monaco instance in local state
 */


function storeMonacoInstance(monaco) {
  if (!getState().monaco) {
    setState({
      monaco: monaco
    });
  }
}
/**
 * internal helper function
 * extracts stored monaco instance
 * @return {Object|null} - the monaco instance
 */


function __getMonacoInstance() {
  return getState(function (_ref4) {
    var monaco = _ref4.monaco;
    return monaco;
  });
}

var wrapperPromise = new Promise(function (resolve, reject) {
  return setState({
    resolve: resolve,
    reject: reject
  });
});
var loader_loader = {
  config: loader_config,
  init: init,
  __getMonacoInstance: __getMonacoInstance
};

/* harmony default export */ var es_loader = (loader_loader);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/loader/lib/es/index.js



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/_virtual/_rollupPluginBabelHelpers.js
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}



;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/Loading/Loading.js


const loadingStyles = {
  display: 'flex',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center'
};

function Loading({
  content
}) {
  return /*#__PURE__*/react.createElement("div", {
    style: loadingStyles
  }, content);
}

/* harmony default export */ var Loading_Loading = (Loading);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/MonacoContainer/styles.js
const styles = {
  wrapper: {
    display: 'flex',
    position: 'relative',
    textAlign: 'initial'
  },
  fullWidth: {
    width: '100%'
  },
  hide: {
    display: 'none'
  }
};

/* harmony default export */ var MonacoContainer_styles = (styles);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/MonacoContainer/MonacoContainer.js






// one of the reasons why we use a separate prop for passing ref instead of using forwardref

function MonacoContainer({
  width,
  height,
  isEditorReady,
  loading,
  _ref,
  className,
  wrapperProps
}) {
  return /*#__PURE__*/react.createElement("section", _extends({
    style: { ...MonacoContainer_styles.wrapper,
      width,
      height
    }
  }, wrapperProps), !isEditorReady && /*#__PURE__*/react.createElement(Loading_Loading, {
    content: loading
  }), /*#__PURE__*/react.createElement("div", {
    ref: _ref,
    style: { ...MonacoContainer_styles.fullWidth,
      ...(!isEditorReady && MonacoContainer_styles.hide)
    },
    className: className
  }));
}

MonacoContainer.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]).isRequired,
  height: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]).isRequired,
  loading: prop_types_default().oneOfType([(prop_types_default()).element, (prop_types_default()).string]).isRequired,
  isEditorReady: (prop_types_default()).bool.isRequired,
  className: (prop_types_default()).string,
  wrapperProps: (prop_types_default()).object
};

/* harmony default export */ var MonacoContainer_MonacoContainer = (MonacoContainer);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/MonacoContainer/index.js



var es_MonacoContainer_MonacoContainer = /*#__PURE__*/(0,react.memo)(MonacoContainer_MonacoContainer);

/* harmony default export */ var es_MonacoContainer = (es_MonacoContainer_MonacoContainer);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/hooks/useMount/index.js


function useMount_useMount(effect) {
  (0,react.useEffect)(effect, []);
}

/* harmony default export */ var hooks_useMount = (useMount_useMount);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/hooks/useUpdate/index.js


function useUpdate(effect, deps, applyChanges = true) {
  const isInitialMount = (0,react.useRef)(true);
  (0,react.useEffect)(isInitialMount.current || !applyChanges ? () => {
    isInitialMount.current = false;
  } : effect, deps);
}

/* harmony default export */ var hooks_useUpdate = (useUpdate);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/utils/index.js
function noop() {}

function getOrCreateModel(monaco, value, language, path) {
  return getModel(monaco, path) || createModel(monaco, value, language, path);
}

function getModel(monaco, path) {
  return monaco.editor.getModel(createModelUri(monaco, path));
}

function createModel(monaco, value, language, path) {
  return monaco.editor.createModel(value, language, path && createModelUri(monaco, path));
}

function createModelUri(monaco, path) {
  return monaco.Uri.parse(path);
}

function isUndefined(input) {
  return input === undefined;
}



;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/DiffEditor/DiffEditor.js








function DiffEditor({
  original,
  modified,
  language,
  originalLanguage,
  modifiedLanguage,

  /* === */
  originalModelPath,
  modifiedModelPath,
  keepCurrentOriginalModel,
  keepCurrentModifiedModel,
  theme,
  loading,
  options,

  /* === */
  height,
  width,
  className,
  wrapperProps,

  /* === */
  beforeMount,
  onMount
}) {
  const [isEditorReady, setIsEditorReady] = (0,react.useState)(false);
  const [isMonacoMounting, setIsMonacoMounting] = (0,react.useState)(true);
  const editorRef = (0,react.useRef)(null);
  const monacoRef = (0,react.useRef)(null);
  const containerRef = (0,react.useRef)(null);
  const onMountRef = (0,react.useRef)(onMount);
  const beforeMountRef = (0,react.useRef)(beforeMount);
  hooks_useMount(() => {
    const cancelable = es_loader.init();
    cancelable.then(monaco => (monacoRef.current = monaco) && setIsMonacoMounting(false)).catch(error => (error === null || error === void 0 ? void 0 : error.type) !== 'cancelation' && console.error('Monaco initialization: error:', error));
    return () => editorRef.current ? disposeEditor() : cancelable.cancel();
  });
  hooks_useUpdate(() => {
    const modifiedEditor = editorRef.current.getModifiedEditor();

    if (modifiedEditor.getOption(monacoRef.current.editor.EditorOption.readOnly)) {
      modifiedEditor.setValue(modified);
    } else {
      if (modified !== modifiedEditor.getValue()) {
        modifiedEditor.executeEdits('', [{
          range: modifiedEditor.getModel().getFullModelRange(),
          text: modified,
          forceMoveMarkers: true
        }]);
        modifiedEditor.pushUndoStop();
      }
    }
  }, [modified], isEditorReady);
  hooks_useUpdate(() => {
    editorRef.current.getModel().original.setValue(original);
  }, [original], isEditorReady);
  hooks_useUpdate(() => {
    const {
      original,
      modified
    } = editorRef.current.getModel();
    monacoRef.current.editor.setModelLanguage(original, originalLanguage || language);
    monacoRef.current.editor.setModelLanguage(modified, modifiedLanguage || language);
  }, [language, originalLanguage, modifiedLanguage], isEditorReady);
  hooks_useUpdate(() => {
    monacoRef.current.editor.setTheme(theme);
  }, [theme], isEditorReady);
  hooks_useUpdate(() => {
    editorRef.current.updateOptions(options);
  }, [options], isEditorReady);
  const setModels = (0,react.useCallback)(() => {
    beforeMountRef.current(monacoRef.current);
    const originalModel = getOrCreateModel(monacoRef.current, original, originalLanguage || language, originalModelPath);
    const modifiedModel = getOrCreateModel(monacoRef.current, modified, modifiedLanguage || language, modifiedModelPath);
    editorRef.current.setModel({
      original: originalModel,
      modified: modifiedModel
    });
  }, [language, modified, modifiedLanguage, original, originalLanguage, originalModelPath, modifiedModelPath]);
  const createEditor = (0,react.useCallback)(() => {
    editorRef.current = monacoRef.current.editor.createDiffEditor(containerRef.current, {
      automaticLayout: true,
      ...options
    });
    setModels();
    monacoRef.current.editor.setTheme(theme);
    setIsEditorReady(true);
  }, [options, theme, setModels]);
  (0,react.useEffect)(() => {
    if (isEditorReady) {
      onMountRef.current(editorRef.current, monacoRef.current);
    }
  }, [isEditorReady]);
  (0,react.useEffect)(() => {
    !isMonacoMounting && !isEditorReady && createEditor();
  }, [isMonacoMounting, isEditorReady, createEditor]);

  function disposeEditor() {
    const models = editorRef.current.getModel();

    if (!keepCurrentOriginalModel) {
      var _models$original;

      (_models$original = models.original) === null || _models$original === void 0 ? void 0 : _models$original.dispose();
    }

    if (!keepCurrentModifiedModel) {
      var _models$modified;

      (_models$modified = models.modified) === null || _models$modified === void 0 ? void 0 : _models$modified.dispose();
    }

    editorRef.current.dispose();
  }

  return /*#__PURE__*/react.createElement(es_MonacoContainer, {
    width: width,
    height: height,
    isEditorReady: isEditorReady,
    loading: loading,
    _ref: containerRef,
    className: className,
    wrapperProps: wrapperProps
  });
}

DiffEditor.propTypes = {
  original: (prop_types_default()).string,
  modified: (prop_types_default()).string,
  language: (prop_types_default()).string,
  originalLanguage: (prop_types_default()).string,
  modifiedLanguage: (prop_types_default()).string,

  /* === */
  originalModelPath: (prop_types_default()).string,
  modifiedModelPath: (prop_types_default()).string,
  keepCurrentOriginalModel: (prop_types_default()).bool,
  keepCurrentModifiedModel: (prop_types_default()).bool,
  theme: (prop_types_default()).string,
  loading: prop_types_default().oneOfType([(prop_types_default()).element, (prop_types_default()).string]),
  options: (prop_types_default()).object,

  /* === */
  width: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  height: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  className: (prop_types_default()).string,
  wrapperProps: (prop_types_default()).object,

  /* === */
  beforeMount: (prop_types_default()).func,
  onMount: (prop_types_default()).func
};
DiffEditor.defaultProps = {
  theme: 'light',
  loading: 'Loading...',
  options: {},
  keepCurrentOriginalModel: false,
  keepCurrentModifiedModel: false,

  /* === */
  width: '100%',
  height: '100%',
  wrapperProps: {},

  /* === */
  beforeMount: noop,
  onMount: noop
};

/* harmony default export */ var DiffEditor_DiffEditor = (DiffEditor);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/DiffEditor/index.js



var DiffEditor_index = /*#__PURE__*/(0,react.memo)(DiffEditor_DiffEditor);

/* harmony default export */ var es_DiffEditor = (DiffEditor_index);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/hooks/useMonaco/index.js




function useMonaco() {
  const [monaco, setMonaco] = useState(loader.__getMonacoInstance());
  useMount(() => {
    let cancelable;

    if (!monaco) {
      cancelable = loader.init();
      cancelable.then(monaco => {
        setMonaco(monaco);
      });
    }

    return () => {
      var _cancelable;

      return (_cancelable = cancelable) === null || _cancelable === void 0 ? void 0 : _cancelable.cancel();
    };
  });
  return monaco;
}

/* harmony default export */ var hooks_useMonaco = ((/* unused pure expression or super */ null && (useMonaco)));

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/hooks/usePrevious/index.js


function usePrevious(value) {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

/* harmony default export */ var hooks_usePrevious = (usePrevious);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/Editor/Editor.js









const viewStates = new Map();

function Editor({
  defaultValue,
  defaultLanguage,
  defaultPath,
  value,
  language,
  path,

  /* === */
  theme,
  line,
  loading,
  options,
  overrideServices,
  saveViewState,
  keepCurrentModel,

  /* === */
  width,
  height,
  className,
  wrapperProps,

  /* === */
  beforeMount,
  onMount,
  onChange,
  onValidate
}) {
  const [isEditorReady, setIsEditorReady] = (0,react.useState)(false);
  const [isMonacoMounting, setIsMonacoMounting] = (0,react.useState)(true);
  const monacoRef = (0,react.useRef)(null);
  const editorRef = (0,react.useRef)(null);
  const containerRef = (0,react.useRef)(null);
  const onMountRef = (0,react.useRef)(onMount);
  const beforeMountRef = (0,react.useRef)(beforeMount);
  const subscriptionRef = (0,react.useRef)(null);
  const valueRef = (0,react.useRef)(value);
  const previousPath = hooks_usePrevious(path);
  const preventCreation = (0,react.useRef)(false);
  hooks_useMount(() => {
    const cancelable = es_loader.init();
    cancelable.then(monaco => (monacoRef.current = monaco) && setIsMonacoMounting(false)).catch(error => (error === null || error === void 0 ? void 0 : error.type) !== 'cancelation' && console.error('Monaco initialization: error:', error));
    return () => editorRef.current ? disposeEditor() : cancelable.cancel();
  });
  hooks_useUpdate(() => {
    const model = getOrCreateModel(monacoRef.current, defaultValue || value, defaultLanguage || language, path);

    if (model !== editorRef.current.getModel()) {
      saveViewState && viewStates.set(previousPath, editorRef.current.saveViewState());
      editorRef.current.setModel(model);
      saveViewState && editorRef.current.restoreViewState(viewStates.get(path));
    }
  }, [path], isEditorReady);
  hooks_useUpdate(() => {
    editorRef.current.updateOptions(options);
  }, [options], isEditorReady);
  hooks_useUpdate(() => {
    if (editorRef.current.getOption(monacoRef.current.editor.EditorOption.readOnly)) {
      editorRef.current.setValue(value);
    } else {
      if (value !== editorRef.current.getValue()) {
        editorRef.current.executeEdits('', [{
          range: editorRef.current.getModel().getFullModelRange(),
          text: value,
          forceMoveMarkers: true
        }]);
        editorRef.current.pushUndoStop();
      }
    }
  }, [value], isEditorReady);
  hooks_useUpdate(() => {
    monacoRef.current.editor.setModelLanguage(editorRef.current.getModel(), language);
  }, [language], isEditorReady);
  hooks_useUpdate(() => {
    // reason for undefined check: https://github.com/suren-atoyan/monaco-react/pull/188
    if (!isUndefined(line)) {
      editorRef.current.revealLine(line);
    }
  }, [line], isEditorReady);
  hooks_useUpdate(() => {
    monacoRef.current.editor.setTheme(theme);
  }, [theme], isEditorReady);
  const createEditor = (0,react.useCallback)(() => {
    if (!preventCreation.current) {
      beforeMountRef.current(monacoRef.current);
      const autoCreatedModelPath = path || defaultPath;
      const defaultModel = getOrCreateModel(monacoRef.current, value || defaultValue, defaultLanguage || language, autoCreatedModelPath);
      editorRef.current = monacoRef.current.editor.create(containerRef.current, {
        model: defaultModel,
        automaticLayout: true,
        ...options
      }, overrideServices);
      saveViewState && editorRef.current.restoreViewState(viewStates.get(autoCreatedModelPath));
      monacoRef.current.editor.setTheme(theme);
      setIsEditorReady(true);
      preventCreation.current = true;
    }
  }, [defaultValue, defaultLanguage, defaultPath, value, language, path, options, overrideServices, saveViewState, theme]);
  (0,react.useEffect)(() => {
    if (isEditorReady) {
      onMountRef.current(editorRef.current, monacoRef.current);
    }
  }, [isEditorReady]);
  (0,react.useEffect)(() => {
    !isMonacoMounting && !isEditorReady && createEditor();
  }, [isMonacoMounting, isEditorReady, createEditor]); // subscription
  // to avoid unnecessary updates (attach - dispose listener) in subscription

  valueRef.current = value; // onChange

  (0,react.useEffect)(() => {
    if (isEditorReady && onChange) {
      var _subscriptionRef$curr, _editorRef$current;

      (_subscriptionRef$curr = subscriptionRef.current) === null || _subscriptionRef$curr === void 0 ? void 0 : _subscriptionRef$curr.dispose();
      subscriptionRef.current = (_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 ? void 0 : _editorRef$current.onDidChangeModelContent(event => {
        onChange(editorRef.current.getValue(), event);
      });
    }
  }, [isEditorReady, onChange]); // onValidate

  (0,react.useEffect)(() => {
    if (isEditorReady) {
      const changeMarkersListener = monacoRef.current.editor.onDidChangeMarkers(uris => {
        var _editorRef$current$ge;

        const editorUri = (_editorRef$current$ge = editorRef.current.getModel()) === null || _editorRef$current$ge === void 0 ? void 0 : _editorRef$current$ge.uri;

        if (editorUri) {
          const currentEditorHasMarkerChanges = uris.find(uri => uri.path === editorUri.path);

          if (currentEditorHasMarkerChanges) {
            const markers = monacoRef.current.editor.getModelMarkers({
              resource: editorUri
            });
            onValidate === null || onValidate === void 0 ? void 0 : onValidate(markers);
          }
        }
      });
      return () => {
        changeMarkersListener === null || changeMarkersListener === void 0 ? void 0 : changeMarkersListener.dispose();
      };
    }
  }, [isEditorReady, onValidate]);

  function disposeEditor() {
    var _subscriptionRef$curr2;

    (_subscriptionRef$curr2 = subscriptionRef.current) === null || _subscriptionRef$curr2 === void 0 ? void 0 : _subscriptionRef$curr2.dispose();

    if (keepCurrentModel) {
      saveViewState && viewStates.set(path, editorRef.current.saveViewState());
    } else {
      var _editorRef$current$ge2;

      (_editorRef$current$ge2 = editorRef.current.getModel()) === null || _editorRef$current$ge2 === void 0 ? void 0 : _editorRef$current$ge2.dispose();
    }

    editorRef.current.dispose();
  }

  return /*#__PURE__*/react.createElement(es_MonacoContainer, {
    width: width,
    height: height,
    isEditorReady: isEditorReady,
    loading: loading,
    _ref: containerRef,
    className: className,
    wrapperProps: wrapperProps
  });
}

Editor.propTypes = {
  defaultValue: (prop_types_default()).string,
  defaultPath: (prop_types_default()).string,
  defaultLanguage: (prop_types_default()).string,
  value: (prop_types_default()).string,
  language: (prop_types_default()).string,
  path: (prop_types_default()).string,

  /* === */
  theme: (prop_types_default()).string,
  line: (prop_types_default()).number,
  loading: prop_types_default().oneOfType([(prop_types_default()).element, (prop_types_default()).string]),
  options: (prop_types_default()).object,
  overrideServices: (prop_types_default()).object,
  saveViewState: (prop_types_default()).bool,
  keepCurrentModel: (prop_types_default()).bool,

  /* === */
  width: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  height: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]),
  className: (prop_types_default()).string,
  wrapperProps: (prop_types_default()).object,

  /* === */
  beforeMount: (prop_types_default()).func,
  onMount: (prop_types_default()).func,
  onChange: (prop_types_default()).func,
  onValidate: (prop_types_default()).func
};
Editor.defaultProps = {
  theme: 'light',
  loading: 'Loading...',
  options: {},
  overrideServices: {},
  saveViewState: true,
  keepCurrentModel: false,

  /* === */
  width: '100%',
  height: '100%',
  wrapperProps: {},

  /* === */
  beforeMount: noop,
  onMount: noop,
  onValidate: noop
};

/* harmony default export */ var Editor_Editor = (Editor);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/Editor/index.js



var Editor_index = /*#__PURE__*/(0,react.memo)(Editor_Editor);

/* harmony default export */ var es_Editor = (Editor_index);

;// CONCATENATED MODULE: ../../node_modules/@monaco-editor/react/lib/es/index.js






/***/ }),

/***/ 83820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28316);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84501);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21399);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75377);





function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */


const Portal = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Portal(props, ref) {
  const {
    children,
    container,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const handleRef = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children) ? children.ref : null, ref);
  (0,_mui_utils__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(() => {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  (0,_mui_utils__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(() => {
    if (mountNode && !disablePortal) {
      (0,_mui_utils__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ref, mountNode);
      return () => {
        (0,_mui_utils__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children)) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, mountNode) : mountNode;
});
 false ? 0 : void 0;

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (Portal);

/***/ }),

/***/ 65444:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */
function isHostComponent(element) {
  return typeof element === 'string';
}

/* harmony default export */ __webpack_exports__["Z"] = (isHostComponent);

/***/ }),

/***/ 5584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ resolveComponentProps; }
/* harmony export */ });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */
function resolveComponentProps(componentProps, ownerState) {
  if (typeof componentProps === 'function') {
    return componentProps(ownerState);
  }

  return componentProps;
}

/***/ }),

/***/ 70586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useSlotProps; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/useForkRef.js
var useForkRef = __webpack_require__(84501);
// EXTERNAL MODULE: ../../node_modules/@mui/base/utils/isHostComponent.js
var isHostComponent = __webpack_require__(65444);
;// CONCATENATED MODULE: ../../node_modules/@mui/base/utils/appendOwnerState.js


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */

/**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */
function appendOwnerState(elementType, otherProps = {}, ownerState) {
  if ((0,isHostComponent/* default */.Z)(elementType)) {
    return otherProps;
  }

  return (0,esm_extends/* default */.Z)({}, otherProps, {
    ownerState: (0,esm_extends/* default */.Z)({}, otherProps.ownerState, ownerState)
  });
}
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
;// CONCATENATED MODULE: ../../node_modules/@mui/base/utils/extractEventHandlers.js
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */
function extractEventHandlers(object, excludeKeys = []) {
  if (object === undefined) {
    return {};
  }

  const result = {};
  Object.keys(object).filter(prop => prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach(prop => {
    result[prop] = object[prop];
  });
  return result;
}
;// CONCATENATED MODULE: ../../node_modules/@mui/base/utils/omitEventHandlers.js
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */
function omitEventHandlers(object) {
  if (object === undefined) {
    return {};
  }

  const result = {};
  Object.keys(object).filter(prop => !(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach(prop => {
    result[prop] = object[prop];
  });
  return result;
}
;// CONCATENATED MODULE: ../../node_modules/@mui/base/utils/mergeSlotProps.js





/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on an unstyled component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `componentsProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */
function mergeSlotProps(parameters) {
  const {
    getSlotProps,
    additionalProps,
    externalSlotProps,
    externalForwardedProps,
    className
  } = parameters;

  if (!getSlotProps) {
    // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
    // so we can simply merge all the props without having to worry about extracting event handlers.
    const joinedClasses = (0,clsx_m["default"])(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);

    const mergedStyle = (0,esm_extends/* default */.Z)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);

    const props = (0,esm_extends/* default */.Z)({}, additionalProps, externalForwardedProps, externalSlotProps);

    if (joinedClasses.length > 0) {
      props.className = joinedClasses;
    }

    if (Object.keys(mergedStyle).length > 0) {
      props.style = mergedStyle;
    }

    return {
      props,
      internalRef: undefined
    };
  } // In this case, getSlotProps is responsible for calling the external event handlers.
  // We don't need to include them in the merged props because of this.


  const eventHandlers = extractEventHandlers((0,esm_extends/* default */.Z)({}, externalForwardedProps, externalSlotProps));
  const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
  const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
  const internalSlotProps = getSlotProps(eventHandlers); // The order of classes is important here.
  // Emotion (that we use in libraries consuming MUI Base) depends on this order
  // to properly override style. It requires the most important classes to be last
  // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.

  const joinedClasses = (0,clsx_m["default"])(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);

  const mergedStyle = (0,esm_extends/* default */.Z)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);

  const props = (0,esm_extends/* default */.Z)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);

  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }

  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }

  return {
    props,
    internalRef: internalSlotProps.ref
  };
}
// EXTERNAL MODULE: ../../node_modules/@mui/base/utils/resolveComponentProps.js
var resolveComponentProps = __webpack_require__(5584);
;// CONCATENATED MODULE: ../../node_modules/@mui/base/utils/useSlotProps.js


const _excluded = ["elementType", "externalSlotProps", "ownerState"];





/**
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */
function useSlotProps(parameters) {
  var _parameters$additiona;

  const {
    elementType,
    externalSlotProps,
    ownerState
  } = parameters,
        rest = (0,objectWithoutPropertiesLoose/* default */.Z)(parameters, _excluded);

  const resolvedComponentsProps = (0,resolveComponentProps/* default */.Z)(externalSlotProps, ownerState);
  const {
    props: mergedProps,
    internalRef
  } = mergeSlotProps((0,esm_extends/* default */.Z)({}, rest, {
    externalSlotProps: resolvedComponentsProps
  }));
  const ref = (0,useForkRef/* default */.Z)(internalRef, (0,useForkRef/* default */.Z)(resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref));
  const props = appendOwnerState(elementType, (0,esm_extends/* default */.Z)({}, mergedProps, {
    ref
  }), ownerState);
  return props;
}

/***/ }),

/***/ 9077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styles_defaultTheme; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(81512);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(48970);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/createTheme/createTheme.js + 3 modules
var createTheme = __webpack_require__(52423);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/styles/createMixins.js

function createMixins(breakpoints, mixins) {
  return (0,esm_extends/* default */.Z)({
    toolbar: {
      minHeight: 56,
      [breakpoints.up('xs')]: {
        '@media (orientation: landscape)': {
          minHeight: 48
        }
      },
      [breakpoints.up('sm')]: {
        minHeight: 64
      }
    }
  }, mixins);
}
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(47591);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/colors/common.js
const common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ var colors_common = (common);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/colors/grey.js
const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161'
};
/* harmony default export */ var colors_grey = (grey);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/colors/purple.js
const purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
/* harmony default export */ var colors_purple = (purple);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/colors/red.js
const red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ var colors_red = (red);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/colors/orange.js
const orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ var colors_orange = (orange);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/colors/blue.js
const blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ var colors_blue = (blue);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/colors/lightBlue.js
const lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
/* harmony default export */ var colors_lightBlue = (lightBlue);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/colors/green.js
const green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ var colors_green = (green);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/styles/createPalette.js



const _excluded = ["mode", "contrastThreshold", "tonalOffset"];










const light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.6)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: colors_common.white,
    default: colors_common.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: colors_common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#121212',
    default: '#121212'
  },
  action: {
    active: colors_common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0,colorManipulator/* lighten */.$n)(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = (0,colorManipulator/* darken */._j)(intent.main, tonalOffsetDark);
    }
  }
}

function getDefaultPrimary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_blue[200],
      light: colors_blue[50],
      dark: colors_blue[400]
    };
  }

  return {
    main: colors_blue[700],
    light: colors_blue[400],
    dark: colors_blue[800]
  };
}

function getDefaultSecondary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_purple[200],
      light: colors_purple[50],
      dark: colors_purple[400]
    };
  }

  return {
    main: colors_purple[500],
    light: colors_purple[300],
    dark: colors_purple[700]
  };
}

function getDefaultError(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_red[500],
      light: colors_red[300],
      dark: colors_red[700]
    };
  }

  return {
    main: colors_red[700],
    light: colors_red[400],
    dark: colors_red[800]
  };
}

function getDefaultInfo(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_lightBlue[400],
      light: colors_lightBlue[300],
      dark: colors_lightBlue[700]
    };
  }

  return {
    main: colors_lightBlue[700],
    light: colors_lightBlue[500],
    dark: colors_lightBlue[900]
  };
}

function getDefaultSuccess(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_green[400],
      light: colors_green[300],
      dark: colors_green[700]
    };
  }

  return {
    main: colors_green[800],
    light: colors_green[500],
    dark: colors_green[900]
  };
}

function getDefaultWarning(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: colors_orange[400],
      light: colors_orange[300],
      dark: colors_orange[700]
    };
  }

  return {
    main: '#ed6c02',
    // closest to orange[800] that pass 3:1.
    light: colors_orange[500],
    dark: colors_orange[900]
  };
}

function createPalette(palette) {
  const {
    mode = 'light',
    contrastThreshold = 3,
    tonalOffset = 0.2
  } = palette,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(palette, _excluded);

  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54

  function getContrastText(background) {
    const contrastText = (0,colorManipulator/* getContrastRatio */.mi)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {}

    return contrastText;
  }

  const augmentColor = ({
    color,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color = (0,esm_extends/* default */.Z)({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.hasOwnProperty('main')) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(11, name ? ` (${name})` : '', mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  const modes = {
    dark,
    light
  };

  if (false) {}

  const paletteOutput = (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    // A collection of common colors.
    common: (0,esm_extends/* default */.Z)({}, colors_common),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: 'primary'
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: 'secondary',
      mainShade: 'A400',
      lightShade: 'A200',
      darkShade: 'A700'
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: 'error'
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: 'warning'
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: 'info'
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: 'success'
    }),
    // The grey colors.
    grey: colors_grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}
;// CONCATENATED MODULE: ../../node_modules/@mui/material/styles/createTypography.js


const createTypography_excluded = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];


function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

const caseAllCaps = {
  textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  const _ref = typeof typography === 'function' ? typography(palette) : typography,
        {
    fontFamily = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize = 14,
    // px
    fontWeightLight = 300,
    fontWeightRegular = 400,
    fontWeightMedium = 500,
    fontWeightBold = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16,
    // Apply the CSS properties to all the variants.
    allVariants,
    pxToRem: pxToRem2
  } = _ref,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, createTypography_excluded);

  if (false) {}

  const coef = fontSize / 14;

  const pxToRem = pxToRem2 || (size => `${size / htmlFontSize * coef}rem`);

  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => (0,esm_extends/* default */.Z)({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round(letterSpacing / size)}em`
  } : {}, casing, allVariants);

  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}
;// CONCATENATED MODULE: ../../node_modules/@mui/material/styles/shadows.js
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;

function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


const shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ var styles_shadows = (shadows);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/styles/createTransitions.js


const createTransitions_excluded = ["duration", "easing", "delay"];
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}

function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }

  const constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}

function createTransitions(inputTransitions) {
  const mergedEasing = (0,esm_extends/* default */.Z)({}, easing, inputTransitions.easing);

  const mergedDuration = (0,esm_extends/* default */.Z)({}, duration, inputTransitions.duration);

  const create = (props = ['all'], options = {}) => {
    const {
      duration: durationOption = mergedDuration.standard,
      easing: easingOption = mergedEasing.easeInOut,
      delay = 0
    } = options,
          other = (0,objectWithoutPropertiesLoose/* default */.Z)(options, createTransitions_excluded);

    if (false) {}

    return (Array.isArray(props) ? props : [props]).map(animatedProp => `${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
  };

  return (0,esm_extends/* default */.Z)({
    getAutoHeightDuration,
    create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}
;// CONCATENATED MODULE: ../../node_modules/@mui/material/styles/zIndex.js
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ var styles_zIndex = (zIndex);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/styles/createTheme.js



const createTheme_excluded = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];










function createTheme_createTheme(options = {}, ...args) {
  const {
    mixins: mixinsInput = {},
    palette: paletteInput = {},
    transitions: transitionsInput = {},
    typography: typographyInput = {}
  } = options,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(options, createTheme_excluded);

  if (options.vars) {
    throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(18));
  }

  const palette = createPalette(paletteInput);
  const systemTheme = (0,createTheme/* default */.Z)(options);
  let muiTheme = (0,deepmerge/* default */.Z)(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: styles_shadows.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: (0,esm_extends/* default */.Z)({}, styles_zIndex)
  });
  muiTheme = (0,deepmerge/* default */.Z)(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => (0,deepmerge/* default */.Z)(acc, argument), muiTheme);

  if (false) {}

  return muiTheme;
}

let warnedOnce = false;
function createMuiTheme(...args) {
  if (false) {}

  return createTheme_createTheme(...args);
}
/* harmony default export */ var styles_createTheme = (createTheme_createTheme);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/styles/defaultTheme.js

const defaultTheme = styles_createTheme();
/* harmony default export */ var styles_defaultTheme = (defaultTheme);

/***/ }),

/***/ 60414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ styles_styled; },
  "FO": function() { return /* binding */ rootShouldForwardProp; }
});

// UNUSED EXPORTS: slotShouldForwardProp

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js
var emotion_is_prop_valid_esm = __webpack_require__(86015);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js
var emotion_element_cbed451f_browser_esm = __webpack_require__(72138);
// EXTERNAL MODULE: ../../node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(82792);
// EXTERNAL MODULE: ../../node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 2 modules
var emotion_serialize_browser_esm = __webpack_require__(40653);
;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var testOmitPropsOnStringTag = emotion_is_prop_valid_esm/* default */.Z;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var useInsertionEffect = react_namespaceObject['useInsertion' + 'Effect'] ? react_namespaceObject['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe(create) {

  useInsertionEffect(create);
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  var rules = useInsertionEffectMaybe(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_cbed451f_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = (0,react.useContext)(emotion_element_cbed451f_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, /*#__PURE__*/(0,react.createElement)(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/(0,react.createElement)(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

/* harmony default export */ var emotion_styled_base_browser_esm = (createStyled);

;// CONCATENATED MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js








var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = emotion_styled_base_browser_esm.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

/* harmony default export */ var emotion_styled_browser_esm = (newStyled);

;// CONCATENATED MODULE: ../../node_modules/@mui/styled-engine/index.js
/** @license MUI v5.10.1
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* eslint-disable no-underscore-dangle */

function styled(tag, options) {
  const stylesFactory = emotion_styled_browser_esm(tag, options);

  if (false) {}

  return stylesFactory;
} // eslint-disable-next-line @typescript-eslint/naming-convention

const internal_processStyles = (tag, processor) => {
  // Emotion attaches all the styles as `__emotion_styles`.
  // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};



// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/createTheme/createTheme.js + 3 modules
var createTheme = __webpack_require__(52423);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/capitalize.js
var capitalize = __webpack_require__(1290);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/propsToClassKey.js

const _excluded = ["variant"];


function isEmpty(string) {
  return string.length === 0;
}
/**
 * Generates string classKey based on the properties provided. It starts with the
 * variant if defined, and then it appends all other properties in alphabetical order.
 * @param {object} props - the properties for which the classKey should be created.
 */


function propsToClassKey(props) {
  const {
    variant
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  let classKey = variant || '';
  Object.keys(other).sort().forEach(key => {
    if (key === 'color') {
      classKey += isEmpty(classKey) ? props[key] : (0,capitalize/* default */.Z)(props[key]);
    } else {
      classKey += `${isEmpty(classKey) ? key : (0,capitalize/* default */.Z)(key)}${(0,capitalize/* default */.Z)(props[key].toString())}`;
    }
  });
  return classKey;
}
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/merge.js
var merge = __webpack_require__(8329);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/style.js
var style = __webpack_require__(2818);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/compose.js


function compose(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return (0,merge/* default */.Z)(acc, handlers[prop](props));
      }

      return acc;
    }, {});
  };

  fn.propTypes =  false ? 0 : {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}

/* harmony default export */ var esm_compose = (compose);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/spacing.js + 1 modules
var spacing = __webpack_require__(58862);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(99929);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/borders.js






function getBorder(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return `${value}px solid`;
}

const border = (0,style/* default */.Z)({
  prop: 'border',
  themeKey: 'borders',
  transform: getBorder
});
const borderTop = (0,style/* default */.Z)({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: getBorder
});
const borderRight = (0,style/* default */.Z)({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: getBorder
});
const borderBottom = (0,style/* default */.Z)({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: getBorder
});
const borderLeft = (0,style/* default */.Z)({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: getBorder
});
const borderColor = (0,style/* default */.Z)({
  prop: 'borderColor',
  themeKey: 'palette'
});
const borderTopColor = (0,style/* default */.Z)({
  prop: 'borderTopColor',
  themeKey: 'palette'
});
const borderRightColor = (0,style/* default */.Z)({
  prop: 'borderRightColor',
  themeKey: 'palette'
});
const borderBottomColor = (0,style/* default */.Z)({
  prop: 'borderBottomColor',
  themeKey: 'palette'
});
const borderLeftColor = (0,style/* default */.Z)({
  prop: 'borderLeftColor',
  themeKey: 'palette'
});
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'shape.borderRadius', 4, 'borderRadius');

    const styleFromPropValue = propValue => ({
      borderRadius: (0,spacing/* getValue */.NA)(transformer, propValue)
    });

    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.borderRadius, styleFromPropValue);
  }

  return null;
};
borderRadius.propTypes =  false ? 0 : {};
borderRadius.filterProps = ['borderRadius'];
const borders = esm_compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius);
/* harmony default export */ var esm_borders = (borders);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/display.js


const displayPrint = (0,style/* default */.Z)({
  prop: 'displayPrint',
  cssProperty: false,
  transform: value => ({
    '@media print': {
      display: value
    }
  })
});
const displayRaw = (0,style/* default */.Z)({
  prop: 'display'
});
const overflow = (0,style/* default */.Z)({
  prop: 'overflow'
});
const textOverflow = (0,style/* default */.Z)({
  prop: 'textOverflow'
});
const visibility = (0,style/* default */.Z)({
  prop: 'visibility'
});
const whiteSpace = (0,style/* default */.Z)({
  prop: 'whiteSpace'
});
/* harmony default export */ var display = (esm_compose(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace));
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/flexbox.js


const flexBasis = (0,style/* default */.Z)({
  prop: 'flexBasis'
});
const flexDirection = (0,style/* default */.Z)({
  prop: 'flexDirection'
});
const flexWrap = (0,style/* default */.Z)({
  prop: 'flexWrap'
});
const justifyContent = (0,style/* default */.Z)({
  prop: 'justifyContent'
});
const alignItems = (0,style/* default */.Z)({
  prop: 'alignItems'
});
const alignContent = (0,style/* default */.Z)({
  prop: 'alignContent'
});
const order = (0,style/* default */.Z)({
  prop: 'order'
});
const flex = (0,style/* default */.Z)({
  prop: 'flex'
});
const flexGrow = (0,style/* default */.Z)({
  prop: 'flexGrow'
});
const flexShrink = (0,style/* default */.Z)({
  prop: 'flexShrink'
});
const alignSelf = (0,style/* default */.Z)({
  prop: 'alignSelf'
});
const justifyItems = (0,style/* default */.Z)({
  prop: 'justifyItems'
});
const justifySelf = (0,style/* default */.Z)({
  prop: 'justifySelf'
});
const flexbox = esm_compose(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
/* harmony default export */ var esm_flexbox = (flexbox);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/cssGrid.js





const gap = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'gap');

    const styleFromPropValue = propValue => ({
      gap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });

    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.gap, styleFromPropValue);
  }

  return null;
};
gap.propTypes =  false ? 0 : {};
gap.filterProps = ['gap'];
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'columnGap');

    const styleFromPropValue = propValue => ({
      columnGap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });

    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.columnGap, styleFromPropValue);
  }

  return null;
};
columnGap.propTypes =  false ? 0 : {};
columnGap.filterProps = ['columnGap'];
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'rowGap');

    const styleFromPropValue = propValue => ({
      rowGap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });

    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.rowGap, styleFromPropValue);
  }

  return null;
};
rowGap.propTypes =  false ? 0 : {};
rowGap.filterProps = ['rowGap'];
const gridColumn = (0,style/* default */.Z)({
  prop: 'gridColumn'
});
const gridRow = (0,style/* default */.Z)({
  prop: 'gridRow'
});
const gridAutoFlow = (0,style/* default */.Z)({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = (0,style/* default */.Z)({
  prop: 'gridAutoColumns'
});
const gridAutoRows = (0,style/* default */.Z)({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = (0,style/* default */.Z)({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = (0,style/* default */.Z)({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = (0,style/* default */.Z)({
  prop: 'gridTemplateAreas'
});
const gridArea = (0,style/* default */.Z)({
  prop: 'gridArea'
});
const grid = esm_compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
/* harmony default export */ var cssGrid = (grid);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/positions.js


const position = (0,style/* default */.Z)({
  prop: 'position'
});
const zIndex = (0,style/* default */.Z)({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
const positions_top = (0,style/* default */.Z)({
  prop: 'top'
});
const right = (0,style/* default */.Z)({
  prop: 'right'
});
const bottom = (0,style/* default */.Z)({
  prop: 'bottom'
});
const left = (0,style/* default */.Z)({
  prop: 'left'
});
/* harmony default export */ var positions = (esm_compose(position, zIndex, positions_top, right, bottom, left));
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/palette.js


const color = (0,style/* default */.Z)({
  prop: 'color',
  themeKey: 'palette'
});
const bgcolor = (0,style/* default */.Z)({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
const backgroundColor = (0,style/* default */.Z)({
  prop: 'backgroundColor',
  themeKey: 'palette'
});
const palette = esm_compose(color, bgcolor, backgroundColor);
/* harmony default export */ var esm_palette = (palette);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/shadows.js

const boxShadow = (0,style/* default */.Z)({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
/* harmony default export */ var shadows = (boxShadow);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/sizing.js




function transform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}

const width = (0,style/* default */.Z)({
  prop: 'width',
  transform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;

      const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || breakpoints/* values */.VO[propValue];
      return {
        maxWidth: breakpoint || transform(propValue)
      };
    };

    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.maxWidth, styleFromPropValue);
  }

  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = (0,style/* default */.Z)({
  prop: 'minWidth',
  transform
});
const height = (0,style/* default */.Z)({
  prop: 'height',
  transform
});
const maxHeight = (0,style/* default */.Z)({
  prop: 'maxHeight',
  transform
});
const minHeight = (0,style/* default */.Z)({
  prop: 'minHeight',
  transform
});
const sizeWidth = (0,style/* default */.Z)({
  prop: 'size',
  cssProperty: 'width',
  transform
});
const sizeHeight = (0,style/* default */.Z)({
  prop: 'size',
  cssProperty: 'height',
  transform
});
const boxSizing = (0,style/* default */.Z)({
  prop: 'boxSizing'
});
const sizing = esm_compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
/* harmony default export */ var esm_sizing = (sizing);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/typography.js


const fontFamily = (0,style/* default */.Z)({
  prop: 'fontFamily',
  themeKey: 'typography'
});
const fontSize = (0,style/* default */.Z)({
  prop: 'fontSize',
  themeKey: 'typography'
});
const fontStyle = (0,style/* default */.Z)({
  prop: 'fontStyle',
  themeKey: 'typography'
});
const fontWeight = (0,style/* default */.Z)({
  prop: 'fontWeight',
  themeKey: 'typography'
});
const letterSpacing = (0,style/* default */.Z)({
  prop: 'letterSpacing'
});
const textTransform = (0,style/* default */.Z)({
  prop: 'textTransform'
});
const lineHeight = (0,style/* default */.Z)({
  prop: 'lineHeight'
});
const textAlign = (0,style/* default */.Z)({
  prop: 'textAlign'
});
const typographyVariant = (0,style/* default */.Z)({
  prop: 'typography',
  cssProperty: false,
  themeKey: 'typography'
});
const typography = esm_compose(typographyVariant, fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign, textTransform);
/* harmony default export */ var esm_typography = (typography);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/getThemeValue.js










const filterPropsMapping = {
  borders: esm_borders.filterProps,
  display: display.filterProps,
  flexbox: esm_flexbox.filterProps,
  grid: cssGrid.filterProps,
  positions: positions.filterProps,
  palette: esm_palette.filterProps,
  shadows: shadows.filterProps,
  sizing: esm_sizing.filterProps,
  spacing: spacing/* default.filterProps */.ZP.filterProps,
  typography: esm_typography.filterProps
};
const getThemeValue_styleFunctionMapping = {
  borders: esm_borders,
  display: display,
  flexbox: esm_flexbox,
  grid: cssGrid,
  positions: positions,
  palette: esm_palette,
  shadows: shadows,
  sizing: esm_sizing,
  spacing: spacing/* default */.ZP,
  typography: esm_typography
};
const propToStyleFunction = Object.keys(filterPropsMapping).reduce((acc, styleFnName) => {
  filterPropsMapping[styleFnName].forEach(propName => {
    acc[propName] = getThemeValue_styleFunctionMapping[styleFnName];
  });
  return acc;
}, {});

function getThemeValue(prop, value, theme) {
  const inputProps = {
    [prop]: value,
    theme
  };
  const styleFunction = propToStyleFunction[prop];
  return styleFunction ? styleFunction(inputProps) : {
    [prop]: value
  };
}

/* harmony default export */ var esm_getThemeValue = ((/* unused pure expression or super */ null && (getThemeValue)));
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js




function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}

function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
} // eslint-disable-next-line @typescript-eslint/naming-convention


function unstable_createStyleFunctionSx(styleFunctionMapping = getThemeValue_styleFunctionMapping) {
  const propToStyleFunction = Object.keys(styleFunctionMapping).reduce((acc, styleFnName) => {
    styleFunctionMapping[styleFnName].filterProps.forEach(propName => {
      acc[propName] = styleFunctionMapping[styleFnName];
    });
    return acc;
  }, {});

  function getThemeValue(prop, value, theme) {
    const inputProps = {
      [prop]: value,
      theme
    };
    const styleFunction = propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : {
      [prop]: value
    };
  }

  function styleFunctionSx(props) {
    const {
      sx,
      theme = {}
    } = props || {};

    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }
    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */


    function traverse(sxInput) {
      let sxObject = sxInput;

      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }

      if (!sxObject) {
        return null;
      }

      const emptyBreakpoints = (0,breakpoints/* createEmptyBreakpointObject */.W8)(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach(styleKey => {
        const value = callIfFn(sxObject[styleKey], theme);

        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (propToStyleFunction[styleKey]) {
              css = (0,merge/* default */.Z)(css, getThemeValue(styleKey, value, theme));
            } else {
              const breakpointsValues = (0,breakpoints/* handleBreakpoints */.k9)({
                theme
              }, value, x => ({
                [styleKey]: x
              }));

              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme
                });
              } else {
                css = (0,merge/* default */.Z)(css, breakpointsValues);
              }
            }
          } else {
            css = (0,merge/* default */.Z)(css, getThemeValue(styleKey, value, theme));
          }
        }
      });
      return (0,breakpoints/* removeUnusedBreakpoints */.L7)(breakpointsKeys, css);
    }

    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }

  return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ['sx'];
/* harmony default export */ var styleFunctionSx_styleFunctionSx = (styleFunctionSx);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/createStyled.js


const createStyled_excluded = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"],
      _excluded2 = ["theme"],
      _excluded3 = ["theme"];

/* eslint-disable no-underscore-dangle */






function createStyled_isEmpty(obj) {
  return Object.keys(obj).length === 0;
} // https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40


function isStringTag(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}

const getStyleOverrides = (name, theme) => {
  if (theme.components && theme.components[name] && theme.components[name].styleOverrides) {
    return theme.components[name].styleOverrides;
  }

  return null;
};

const getVariantStyles = (name, theme) => {
  let variants = [];

  if (theme && theme.components && theme.components[name] && theme.components[name].variants) {
    variants = theme.components[name].variants;
  }

  const variantsStyles = {};
  variants.forEach(definition => {
    const key = propsToClassKey(definition.props);
    variantsStyles[key] = definition.style;
  });
  return variantsStyles;
};

const variantsResolver = (props, styles, theme, name) => {
  var _theme$components, _theme$components$nam;

  const {
    ownerState = {}
  } = props;
  const variantsStyles = [];
  const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;

  if (themeVariants) {
    themeVariants.forEach(themeVariant => {
      let isMatch = true;
      Object.keys(themeVariant.props).forEach(key => {
        if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) {
          isMatch = false;
        }
      });

      if (isMatch) {
        variantsStyles.push(styles[propsToClassKey(themeVariant.props)]);
      }
    });
  }

  return variantsStyles;
}; // Update /system/styled/#api in case if this changes


function createStyled_shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = (0,createTheme/* default */.Z)();

const lowercaseFirstLetter = string => {
  return string.charAt(0).toLowerCase() + string.slice(1);
};

function createStyled_createStyled(input = {}) {
  const {
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = createStyled_shouldForwardProp,
    slotShouldForwardProp = createStyled_shouldForwardProp,
    styleFunctionSx = styleFunctionSx_styleFunctionSx
  } = input;

  const systemSx = props => {
    const theme = createStyled_isEmpty(props.theme) ? defaultTheme : props.theme;
    return styleFunctionSx((0,esm_extends/* default */.Z)({}, props, {
      theme
    }));
  };

  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    internal_processStyles(tag, styles => styles.filter(style => !(style != null && style.__mui_systemSx)));

    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      overridesResolver
    } = inputOptions,
          options = (0,objectWithoutPropertiesLoose/* default */.Z)(inputOptions, createStyled_excluded); // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.


    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== 'Root' || false;
    const skipSx = inputSkipSx || false;
    let label;

    if (false) {}

    let shouldForwardPropOption = createStyled_shouldForwardProp;

    if (componentSlot === 'Root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }

    const defaultStyledResolver = styled(tag, (0,esm_extends/* default */.Z)({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));

    const muiStyledResolver = (styleArg, ...expressions) => {
      const expressionsWithDefaultTheme = expressions ? expressions.map(stylesArg => {
        // On the server Emotion doesn't use React.forwardRef for creating components, so the created
        // component stays as a function. This condition makes sure that we do not interpolate functions
        // which are basically components used as a selectors.
        return typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg ? _ref => {
          let {
            theme: themeInput
          } = _ref,
              other = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded2);

          return stylesArg((0,esm_extends/* default */.Z)({
            theme: createStyled_isEmpty(themeInput) ? defaultTheme : themeInput
          }, other));
        } : stylesArg;
      }) : [];
      let transformedStyleArg = styleArg;

      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = createStyled_isEmpty(props.theme) ? defaultTheme : props.theme;
          const styleOverrides = getStyleOverrides(componentName, theme);

          if (styleOverrides) {
            const resolvedStyleOverrides = {};
            Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
              resolvedStyleOverrides[slotKey] = typeof slotStyle === 'function' ? slotStyle((0,esm_extends/* default */.Z)({}, props, {
                theme
              })) : slotStyle;
            });
            return overridesResolver(props, resolvedStyleOverrides);
          }

          return null;
        });
      }

      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = createStyled_isEmpty(props.theme) ? defaultTheme : props.theme;
          return variantsResolver(props, getVariantStyles(componentName, theme), theme, componentName);
        });
      }

      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }

      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;

      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill(''); // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.

        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      } else if (typeof styleArg === 'function' && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      styleArg.__emotion_real !== styleArg) {
        // If the type is function, we need to define the default theme.
        transformedStyleArg = _ref2 => {
          let {
            theme: themeInput
          } = _ref2,
              other = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded3);

          return styleArg((0,esm_extends/* default */.Z)({
            theme: createStyled_isEmpty(themeInput) ? defaultTheme : themeInput
          }, other));
        };
      }

      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);

      if (false) {}

      return Component;
    };

    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }

    return muiStyledResolver;
  };
}
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/defaultTheme.js + 15 modules
var defaultTheme = __webpack_require__(9077);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/styles/styled.js


const rootShouldForwardProp = prop => createStyled_shouldForwardProp(prop) && prop !== 'classes';
const slotShouldForwardProp = (/* unused pure expression or super */ null && (shouldForwardProp));
const styled_styled = createStyled_createStyled({
  defaultTheme: defaultTheme/* default */.Z,
  rootShouldForwardProp
});
/* harmony default export */ var styles_styled = (styled_styled);

/***/ }),

/***/ 95285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useThemeProps_useThemeProps; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
;// CONCATENATED MODULE: ../../node_modules/@mui/utils/esm/resolveProps.js


/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */
function resolveProps(defaultProps, props) {
  const output = (0,esm_extends/* default */.Z)({}, props);

  Object.keys(defaultProps).forEach(propName => {
    if (output[propName] === undefined) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/useThemeProps/getThemeProps.js

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;

  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }

  return resolveProps(theme.components[name].defaultProps, props);
}
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/useTheme.js
var useTheme = __webpack_require__(16933);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/useThemeProps/useThemeProps.js


function useThemeProps({
  props,
  name,
  defaultTheme
}) {
  const theme = (0,useTheme/* default */.Z)(defaultTheme);
  const mergedProps = getThemeProps({
    theme,
    name,
    props
  });
  return mergedProps;
}
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/defaultTheme.js + 15 modules
var defaultTheme = __webpack_require__(9077);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/styles/useThemeProps.js


function useThemeProps_useThemeProps({
  props,
  name
}) {
  return useThemeProps({
    props,
    name,
    defaultTheme: defaultTheme/* default */.Z
  });
}

/***/ }),

/***/ 99929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L7": function() { return /* binding */ removeUnusedBreakpoints; },
/* harmony export */   "VO": function() { return /* binding */ values; },
/* harmony export */   "W8": function() { return /* binding */ createEmptyBreakpointObject; },
/* harmony export */   "k9": function() { return /* binding */ handleBreakpoints; }
/* harmony export */ });
/* unused harmony exports mergeBreakpointsInOrder, computeBreakpointsBase, resolveBreakpointValues */



 // The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.

const values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen

};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};

  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }

      return acc;
    }, {});
  }

  const output = styleFromPropValue(propValue);
  return output;
}

function breakpoints(styleFunction) {
  const newStyleFunction = props => {
    const theme = props.theme || {};
    const base = styleFunction(props);
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    const extended = themeBreakpoints.keys.reduce((acc, key) => {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(_extends({
          theme
        }, props[key]));
      }

      return acc;
    }, null);
    return merge(base, extended);
  };

  newStyleFunction.propTypes =  false ? 0 : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl', ...styleFunction.filterProps];
  return newStyleFunction;
}

function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;

  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;

    if (isBreakpointUnused) {
      delete acc[key];
    }

    return acc;
  }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
  const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
  const mergedOutput = [emptyBreakpoints, ...styles].reduce((prev, next) => deepmerge(prev, next), {});
  return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
} // compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}

function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
  // fixed value
  if (typeof breakpointValues !== 'object') {
    return {};
  }

  const base = {};
  const breakpointsKeys = Object.keys(themeBreakpoints);

  if (Array.isArray(breakpointValues)) {
    breakpointsKeys.forEach((breakpoint, i) => {
      if (i < breakpointValues.length) {
        base[breakpoint] = true;
      }
    });
  } else {
    breakpointsKeys.forEach(breakpoint => {
      if (breakpointValues[breakpoint] != null) {
        base[breakpoint] = true;
      }
    });
  }

  return base;
}
function resolveBreakpointValues({
  values: breakpointValues,
  breakpoints: themeBreakpoints,
  base: customBase
}) {
  const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
  const keys = Object.keys(base);

  if (keys.length === 0) {
    return breakpointValues;
  }

  let previous;
  return keys.reduce((acc, breakpoint, i) => {
    if (Array.isArray(breakpointValues)) {
      acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
      previous = i;
    } else if (typeof breakpointValues === 'object') {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
      previous = breakpoint;
    } else {
      acc[breakpoint] = breakpointValues;
    }

    return acc;
  }, {});
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (breakpoints)));

/***/ }),

/***/ 47591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ lighten; },
/* harmony export */   "Fq": function() { return /* binding */ alpha; },
/* harmony export */   "_j": function() { return /* binding */ darken; },
/* harmony export */   "mi": function() { return /* binding */ getContrastRatio; }
/* harmony export */ });
/* unused harmony exports hexToRgb, decomposeColor, colorChannel, recomposeColor, rgbToHex, hslToRgb, getLuminance, emphasize */
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81512);


/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min = 0, max = 1) {
  if (false) {}

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }

  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}

function intToHex(int) {
  const hex = int.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  const marker = color.indexOf('(');
  const type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(9, color));
  }

  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;

  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();

    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }

    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error( false ? 0 : (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }

  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */

const colorChannel = color => {
  const decomposedColor = decomposeColor(color);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }

  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }

  return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */

function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  const {
    values
  } = decomposeColor(color);
  return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);

  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);

  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  let rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }

    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }

  return recomposeColor(color);
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/***/ }),

/***/ 52423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createTheme_createTheme; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(48970);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/createTheme/createBreakpoints.js


const _excluded = ["values", "unit", "step"];
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const breakpointKeys = (/* unused pure expression or super */ null && (['xs', 'sm', 'md', 'lg', 'xl']));

const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || []; // Sort in ascending order

  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return (0,esm_extends/* default */.Z)({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
}; // Keep in mind that @media is inclusive by the CSS specification.


function createBreakpoints(breakpoints) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536 // large screen

    },
    unit = 'px',
    step = 5
  } = breakpoints,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(breakpoints, _excluded);

  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);

  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }

  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }

  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }

  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }

    return up(key);
  }

  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);

    if (keyIndex === 0) {
      return up(keys[1]);
    }

    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }

    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }

  return (0,esm_extends/* default */.Z)({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/createTheme/shape.js
const shape = {
  borderRadius: 4
};
/* harmony default export */ var createTheme_shape = (shape);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/spacing.js + 1 modules
var esm_spacing = __webpack_require__(58862);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/createTheme/createSpacing.js


/* tslint:enable:unified-signatures */
function createSpacing(spacingInput = 8) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  const transform = (0,esm_spacing/* createUnarySpacing */.hB)({
    spacing: spacingInput
  });

  const spacing = (...argsInput) => {
    if (false) {}

    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };

  spacing.mui = true;
  return spacing;
}
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/createTheme/createTheme.js


const createTheme_excluded = ["breakpoints", "palette", "spacing", "shape"];





function createTheme(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {}
  } = options,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(options, createTheme_excluded);

  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = (0,deepmerge/* default */.Z)({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: (0,esm_extends/* default */.Z)({
      mode: 'light'
    }, paletteInput),
    spacing,
    shape: (0,esm_extends/* default */.Z)({}, createTheme_shape, shapeInput)
  }, other);
  muiTheme = args.reduce((acc, argument) => (0,deepmerge/* default */.Z)(acc, argument), muiTheme);
  return muiTheme;
}

/* harmony default export */ var createTheme_createTheme = (createTheme);

/***/ }),

/***/ 8329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48970);


function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

/* harmony default export */ __webpack_exports__["Z"] = (merge);

/***/ }),

/***/ 58862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hB": function() { return /* binding */ createUnarySpacing; },
  "eI": function() { return /* binding */ createUnaryUnit; },
  "ZP": function() { return /* binding */ esm_spacing; },
  "NA": function() { return /* binding */ getValue; }
});

// UNUSED EXPORTS: getStyleFromPropValue, margin, padding

// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(99929);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/style.js
var style = __webpack_require__(2818);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/merge.js
var merge = __webpack_require__(8329);
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/memoize.js
function memoize(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/spacing.js





const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

const getCssProperties = memoize(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  const [a, b] = prop.split('');
  const property = properties[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;

  const themeSpacing = (_getPath = (0,style/* getPath */.D)(theme, themeKey, false)) != null ? _getPath : defaultValue;

  if (typeof themeSpacing === 'number') {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }

      if (false) {}

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }

      if (false) {}

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (false) {}

  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  const abs = Math.abs(propValue);
  const transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}

function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }

  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return (0,breakpoints/* handleBreakpoints */.k9)(props, propValue, styleFromPropValue);
}

function spacing_style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(merge/* default */.Z, {});
}

function margin(props) {
  return spacing_style(props, marginKeys);
}
margin.propTypes =  false ? 0 : {};
margin.filterProps = marginKeys;
function padding(props) {
  return spacing_style(props, paddingKeys);
}
padding.propTypes =  false ? 0 : {};
padding.filterProps = paddingKeys;

function spacing(props) {
  return spacing_style(props, spacingKeys);
}

spacing.propTypes =  false ? 0 : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ var esm_spacing = (spacing);

/***/ }),

/***/ 2818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getPath; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1290);
/* harmony import */ var _breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99929);



function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  } // Check if CSS variables are used


  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);

    if (val != null) {
      return val;
    }
  }

  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }

    return null;
  }, obj);
}

function getValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;

  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }

  if (transform) {
    value = transform(value);
  }

  return value;
}

function style(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  const fn = props => {
    if (props[prop] == null) {
      return null;
    }

    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};

    const styleFromPropValue = propValueFinal => {
      let value = getValue(themeMapping, transform, propValueFinal);

      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0,_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(propValueFinal)}`, propValueFinal);
      }

      if (cssProperty === false) {
        return value;
      }

      return {
        [cssProperty]: value
      };
    };

    return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .handleBreakpoints */ .k9)(props, propValue, styleFromPropValue);
  };

  fn.propTypes =  false ? 0 : {};
  fn.filterProps = [prop];
  return fn;
}

/* harmony default export */ __webpack_exports__["Z"] = (style);

/***/ }),

/***/ 16933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export systemDefaultTheme */
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52423);
/* harmony import */ var _useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10123);


const systemDefaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();

function useTheme(defaultTheme = systemDefaultTheme) {
  return (0,_useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(defaultTheme);
}

/* harmony default export */ __webpack_exports__["Z"] = (useTheme);

/***/ }),

/***/ 10123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useThemeWithoutDefault; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/@mui/private-theming/useTheme/ThemeContext.js

const ThemeContext = /*#__PURE__*/react.createContext(null);

if (false) {}

/* harmony default export */ var useTheme_ThemeContext = (ThemeContext);
;// CONCATENATED MODULE: ../../node_modules/@mui/private-theming/useTheme/useTheme.js


function useTheme() {
  const theme = react.useContext(useTheme_ThemeContext);

  if (false) {}

  return theme;
}
;// CONCATENATED MODULE: ../../node_modules/@mui/system/esm/useThemeWithoutDefault.js


function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}

function useThemeWithoutDefault_useTheme(defaultTheme = null) {
  const contextTheme = useTheme();
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}

/* harmony default export */ var useThemeWithoutDefault = (useThemeWithoutDefault_useTheme);

/***/ }),

/***/ 1290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ capitalize; }
/* harmony export */ });
/* harmony import */ var _formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81512);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? 0 : (0,_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),

/***/ 69075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ composeClasses; }
/* harmony export */ });
function composeClasses(slots, getUtilityClass, classes) {
  const output = {};
  Object.keys(slots).forEach( // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  slot => {
    output[slot] = slots[slot].reduce((acc, key) => {
      if (key) {
        acc.push(getUtilityClass(key));

        if (classes && classes[key]) {
          acc.push(classes[key]);
        }
      }

      return acc;
    }, []).join(' ');
  });
  return output;
}

/***/ }),

/***/ 48970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ deepmerge; }
/* harmony export */ });
/* unused harmony export isPlainObject */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

function isPlainObject(item) {
  return item !== null && typeof item === 'object' && item.constructor === Object;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(key => {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/***/ }),

/***/ 81512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatMuiErrorMessage; }
/* harmony export */ });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;

  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),

/***/ 61069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ generateUtilityClass; }
});

;// CONCATENATED MODULE: ../../node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
const defaultGenerator = componentName => componentName;

const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },

    generate(componentName) {
      return generate(componentName);
    },

    reset() {
      generate = defaultGenerator;
    }

  };
};

const ClassNameGenerator = createClassNameGenerator();
/* harmony default export */ var ClassNameGenerator_ClassNameGenerator = (ClassNameGenerator);
;// CONCATENATED MODULE: ../../node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js

const globalStateClassesMapping = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  required: 'required',
  selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
  const globalStateClass = globalStateClassesMapping[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator_ClassNameGenerator.generate(componentName)}-${slot}`;
}

/***/ }),

/***/ 69222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ generateUtilityClasses; }
/* harmony export */ });
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61069);

function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
  const result = {};
  slots.forEach(slot => {
    result[slot] = (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(componentName, slot, globalStatePrefix);
  });
  return result;
}

/***/ }),

/***/ 36855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerDocument; }
/* harmony export */ });
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),

/***/ 75377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ setRef; }
/* harmony export */ });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),

/***/ 21399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/* harmony default export */ __webpack_exports__["Z"] = (useEnhancedEffect);

/***/ }),

/***/ 57817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21399);


/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */

function useEventCallback(fn) {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fn);
  (0,_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    ref.current = fn;
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback((...args) => // @ts-expect-error hide `this`
  // tslint:disable-next-line:ban-comma-operator
  (0, ref.current)(...args), []);
}

/***/ }),

/***/ 84501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForkRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _setRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75377);


function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (refA == null && refB == null) {
      return null;
    }

    return refValue => {
      (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(refA, refValue);
      (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(refB, refValue);
    };
  }, [refA, refB]);
}

/***/ }),

/***/ 66208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fi": function() { return /* binding */ popper_createPopper; }
});

// UNUSED EXPORTS: applyStyles, arrow, computeStyles, createPopperLite, defaultModifiers, detectOverflow, eventListeners, flip, hide, offset, popperGenerator, popperOffsets, preventOverflow

;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/createPopper.js














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) { var _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft, flipModifier, modifiers; }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {}

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {}

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) {}

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (false) { var transitionProperty; }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) {}
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/arrow.js









 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) {}

  if (!contains(state.elements.popper, arrowElement)) {
    if (false) {}

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ../../node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules



/***/ }),

/***/ 77298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2U": function() { return /* binding */ MagicWandIcon; },
/* harmony export */   "$9P": function() { return /* binding */ CardStackIcon; },
/* harmony export */   "$Pd": function() { return /* binding */ DropdownMenuIcon; },
/* harmony export */   "$bm": function() { return /* binding */ MixIcon; },
/* harmony export */   "$eq": function() { return /* binding */ TableIcon; },
/* harmony export */   "AMp": function() { return /* binding */ QuestionMarkIcon; },
/* harmony export */   "ANZ": function() { return /* binding */ TimerIcon; },
/* harmony export */   "Adg": function() { return /* binding */ UnderlineIcon; },
/* harmony export */   "AjK": function() { return /* binding */ DotsVerticalIcon; },
/* harmony export */   "BFJ": function() { return /* binding */ GroupIcon; },
/* harmony export */   "BGW": function() { return /* binding */ ReloadIcon; },
/* harmony export */   "BxK": function() { return /* binding */ LinkBreak1Icon; },
/* harmony export */   "Czr": function() { return /* binding */ ScissorsIcon; },
/* harmony export */   "DjT": function() { return /* binding */ LoopIcon; },
/* harmony export */   "Dkj": function() { return /* binding */ BellIcon; },
/* harmony export */   "DrZ": function() { return /* binding */ Link1Icon; },
/* harmony export */   "EGi": function() { return /* binding */ BlendingModeIcon; },
/* harmony export */   "Eik": function() { return /* binding */ ButtonIcon; },
/* harmony export */   "Evf": function() { return /* binding */ LinkNone2Icon; },
/* harmony export */   "FMB": function() { return /* binding */ CubeIcon; },
/* harmony export */   "Fds": function() { return /* binding */ RadiobuttonIcon; },
/* harmony export */   "Gtn": function() { return /* binding */ DragHandleDots1Icon; },
/* harmony export */   "GwC": function() { return /* binding */ Component2Icon; },
/* harmony export */   "HT7": function() { return /* binding */ CookieIcon; },
/* harmony export */   "Hf3": function() { return /* binding */ ArrowUpIcon; },
/* harmony export */   "I6k": function() { return /* binding */ LetterCaseCapitalizeIcon; },
/* harmony export */   "IPL": function() { return /* binding */ BorderAllIcon; },
/* harmony export */   "JMc": function() { return /* binding */ Component1Icon; },
/* harmony export */   "Jot": function() { return /* binding */ LockOpen1Icon; },
/* harmony export */   "Jq": function() { return /* binding */ ContainerIcon; },
/* harmony export */   "JtS": function() { return /* binding */ Pencil1Icon; },
/* harmony export */   "LAO": function() { return /* binding */ EyeClosedIcon; },
/* harmony export */   "LPM": function() { return /* binding */ ExclamationTriangleIcon; },
/* harmony export */   "LZ3": function() { return /* binding */ ArrowRightIcon; },
/* harmony export */   "MzY": function() { return /* binding */ FontItalicIcon; },
/* harmony export */   "NWY": function() { return /* binding */ SunIcon; },
/* harmony export */   "NhS": function() { return /* binding */ CheckCircledIcon; },
/* harmony export */   "Nn4": function() { return /* binding */ TokensIcon; },
/* harmony export */   "NoV": function() { return /* binding */ RowsIcon; },
/* harmony export */   "Odl": function() { return /* binding */ VideoIcon; },
/* harmony export */   "PDu": function() { return /* binding */ CheckboxIcon; },
/* harmony export */   "PEf": function() { return /* binding */ QuoteIcon; },
/* harmony export */   "PQg": function() { return /* binding */ BorderBottomIcon; },
/* harmony export */   "Ps4": function() { return /* binding */ SquareIcon; },
/* harmony export */   "Pxu": function() { return /* binding */ Cross2Icon; },
/* harmony export */   "QGC": function() { return /* binding */ DashboardIcon; },
/* harmony export */   "Que": function() { return /* binding */ CalendarIcon; },
/* harmony export */   "SPS": function() { return /* binding */ PlusCircledIcon; },
/* harmony export */   "SQj": function() { return /* binding */ InputIcon; },
/* harmony export */   "SeN": function() { return /* binding */ ColumnsIcon; },
/* harmony export */   "T39": function() { return /* binding */ ClockIcon; },
/* harmony export */   "TIy": function() { return /* binding */ CopyIcon; },
/* harmony export */   "Tk0": function() { return /* binding */ PersonIcon; },
/* harmony export */   "UDV": function() { return /* binding */ SectionIcon; },
/* harmony export */   "UG6": function() { return /* binding */ GearIcon; },
/* harmony export */   "URn": function() { return /* binding */ SwitchIcon; },
/* harmony export */   "Ui3": function() { return /* binding */ MarginIcon; },
/* harmony export */   "VFo": function() { return /* binding */ SketchLogoIcon; },
/* harmony export */   "VL1": function() { return /* binding */ TextIcon; },
/* harmony export */   "VsP": function() { return /* binding */ LetterCaseUppercaseIcon; },
/* harmony export */   "WCv": function() { return /* binding */ RocketIcon; },
/* harmony export */   "WID": function() { return /* binding */ SymbolIcon; },
/* harmony export */   "X$k": function() { return /* binding */ BoxIcon; },
/* harmony export */   "X20": function() { return /* binding */ FontBoldIcon; },
/* harmony export */   "X5P": function() { return /* binding */ ResetIcon; },
/* harmony export */   "XBm": function() { return /* binding */ ImageIcon; },
/* harmony export */   "XCv": function() { return /* binding */ ChevronRightIcon; },
/* harmony export */   "XHJ": function() { return /* binding */ TrashIcon; },
/* harmony export */   "XOb": function() { return /* binding */ ViewGridIcon; },
/* harmony export */   "Y4O": function() { return /* binding */ ArrowLeftIcon; },
/* harmony export */   "YGl": function() { return /* binding */ LightningBoltIcon; },
/* harmony export */   "YIj": function() { return /* binding */ TransparencyGridIcon; },
/* harmony export */   "Ymj": function() { return /* binding */ CursorArrowIcon; },
/* harmony export */   "ZNd": function() { return /* binding */ DotIcon; },
/* harmony export */   "ZVg": function() { return /* binding */ FontRomanIcon; },
/* harmony export */   "_8t": function() { return /* binding */ DownloadIcon; },
/* harmony export */   "_MN": function() { return /* binding */ EnvelopeClosedIcon; },
/* harmony export */   "_Ve": function() { return /* binding */ MagnifyingGlassIcon; },
/* harmony export */   "a4p": function() { return /* binding */ EnvelopeOpenIcon; },
/* harmony export */   "aAW": function() { return /* binding */ FileIcon; },
/* harmony export */   "am$": function() { return /* binding */ FontFamilyIcon; },
/* harmony export */   "bHp": function() { return /* binding */ HeadingIcon; },
/* harmony export */   "c1q": function() { return /* binding */ MixerVerticalIcon; },
/* harmony export */   "cK5": function() { return /* binding */ TargetIcon; },
/* harmony export */   "cMY": function() { return /* binding */ StackIcon; },
/* harmony export */   "dNJ": function() { return /* binding */ CodeIcon; },
/* harmony export */   "dgb": function() { return /* binding */ ComponentInstanceIcon; },
/* harmony export */   "e0l": function() { return /* binding */ StarFilledIcon; },
/* harmony export */   "eJP": function() { return /* binding */ BarChartIcon; },
/* harmony export */   "el1": function() { return /* binding */ SizeIcon; },
/* harmony export */   "ey0": function() { return /* binding */ LetterCaseLowercaseIcon; },
/* harmony export */   "g8U": function() { return /* binding */ ChevronUpIcon; },
/* harmony export */   "h0n": function() { return /* binding */ ExternalLinkIcon; },
/* harmony export */   "hHp": function() { return /* binding */ PaddingIcon; },
/* harmony export */   "hNW": function() { return /* binding */ PinTopIcon; },
/* harmony export */   "h_8": function() { return /* binding */ HeartIcon; },
/* harmony export */   "haS": function() { return /* binding */ BorderStyleIcon; },
/* harmony export */   "hsE": function() { return /* binding */ EyeOpenIcon; },
/* harmony export */   "hsZ": function() { return /* binding */ MixerHorizontalIcon; },
/* harmony export */   "j9w": function() { return /* binding */ SliderIcon; },
/* harmony export */   "jVc": function() { return /* binding */ ListBulletIcon; },
/* harmony export */   "kDh": function() { return /* binding */ OpenInNewWindowIcon; },
/* harmony export */   "kLh": function() { return /* binding */ MoonIcon; },
/* harmony export */   "khe": function() { return /* binding */ LockClosedIcon; },
/* harmony export */   "mTE": function() { return /* binding */ ChatBubbleIcon; },
/* harmony export */   "nQG": function() { return /* binding */ CheckIcon; },
/* harmony export */   "nWS": function() { return /* binding */ DotsHorizontalIcon; },
/* harmony export */   "ngI": function() { return /* binding */ PieChartIcon; },
/* harmony export */   "nmT": function() { return /* binding */ LaptopIcon; },
/* harmony export */   "o3f": function() { return /* binding */ TextAlignCenterIcon; },
/* harmony export */   "oTK": function() { return /* binding */ TextAlignRightIcon; },
/* harmony export */   "pOD": function() { return /* binding */ PlusIcon; },
/* harmony export */   "pY8": function() { return /* binding */ MobileIcon; },
/* harmony export */   "pjG": function() { return /* binding */ QuestionMarkCircledIcon; },
/* harmony export */   "plf": function() { return /* binding */ BookmarkIcon; },
/* harmony export */   "pso": function() { return /* binding */ GridIcon; },
/* harmony export */   "qDj": function() { return /* binding */ Link2Icon; },
/* harmony export */   "qKs": function() { return /* binding */ BorderTopIcon; },
/* harmony export */   "r7p": function() { return /* binding */ StarIcon; },
/* harmony export */   "rGJ": function() { return /* binding */ DimensionsIcon; },
/* harmony export */   "rLr": function() { return /* binding */ Share1Icon; },
/* harmony export */   "rrd": function() { return /* binding */ TextAlignLeftIcon; },
/* harmony export */   "s7Z": function() { return /* binding */ ArrowTopRightIcon; },
/* harmony export */   "tPC": function() { return /* binding */ MoveIcon; },
/* harmony export */   "tvw": function() { return /* binding */ HomeIcon; },
/* harmony export */   "ugZ": function() { return /* binding */ DesktopIcon; },
/* harmony export */   "ux3": function() { return /* binding */ TextAlignJustifyIcon; },
/* harmony export */   "v4q": function() { return /* binding */ ChevronDownIcon; },
/* harmony export */   "veu": function() { return /* binding */ ArrowDownIcon; },
/* harmony export */   "vfO": function() { return /* binding */ ShadowIcon; },
/* harmony export */   "wyc": function() { return /* binding */ ChevronLeftIcon; },
/* harmony export */   "xrR": function() { return /* binding */ CrossCircledIcon; },
/* harmony export */   "yr4": function() { return /* binding */ DoubleArrowRightIcon; },
/* harmony export */   "yt2": function() { return /* binding */ CornersIcon; },
/* harmony export */   "zPP": function() { return /* binding */ FileTextIcon; },
/* harmony export */   "zrd": function() { return /* binding */ WidthIcon; }
/* harmony export */ });
/* unused harmony exports AccessibilityIcon, ActivityLogIcon, AlignBaselineIcon, AlignBottomIcon, AlignCenterHorizontallyIcon, AlignCenterVerticallyIcon, AlignLeftIcon, AlignRightIcon, AlignTopIcon, AllSidesIcon, AngleIcon, ArchiveIcon, ArrowBottomLeftIcon, ArrowBottomRightIcon, ArrowTopLeftIcon, AspectRatioIcon, AvatarIcon, BackpackIcon, BadgeIcon, BookmarkFilledIcon, BorderDashedIcon, BorderDottedIcon, BorderLeftIcon, BorderNoneIcon, BorderRightIcon, BorderSolidIcon, BorderSplitIcon, BorderWidthIcon, BoxModelIcon, CameraIcon, CardStackMinusIcon, CardStackPlusIcon, CaretDownIcon, CaretLeftIcon, CaretRightIcon, CaretSortIcon, CaretUpIcon, CircleBackslashIcon, CircleIcon, ClipboardCopyIcon, ClipboardIcon, CodeSandboxLogoIcon, ColorWheelIcon, ColumnSpacingIcon, CommitIcon, ComponentBooleanIcon, ComponentNoneIcon, ComponentPlaceholderIcon, CornerBottomLeftIcon, CornerBottomRightIcon, CornerTopLeftIcon, CornerTopRightIcon, CountdownTimerIcon, CounterClockwiseClockIcon, CropIcon, Cross1Icon, Crosshair1Icon, Crosshair2Icon, CrumpledPaperIcon, CursorTextIcon, DashIcon, DiscIcon, DiscordLogoIcon, DividerHorizontalIcon, DividerVerticalIcon, DotFilledIcon, DoubleArrowDownIcon, DoubleArrowLeftIcon, DoubleArrowUpIcon, DragHandleDots2Icon, DragHandleHorizontalIcon, DragHandleVerticalIcon, DrawingPinFilledIcon, DrawingPinIcon, EnterFullScreenIcon, EnterIcon, EraserIcon, ExitFullScreenIcon, ExitIcon, EyeNoneIcon, FaceIcon, FigmaLogoIcon, FileMinusIcon, FilePlusIcon, FontSizeIcon, FontStyleIcon, FrameIcon, FramerLogoIcon, GitHubLogoIcon, GlobeIcon, Half1Icon, Half2Icon, HamburgerMenuIcon, HandIcon, HeartFilledIcon, HeightIcon, HobbyKnifeIcon, IconJarLogoIcon, IdCardIcon, InfoCircledIcon, InstagramLogoIcon, KeyboardIcon, LapTimerIcon, LayersIcon, LayoutIcon, LetterCaseToggleIcon, LetterSpacingIcon, LineHeightIcon, LinkBreak2Icon, LinkNone1Icon, LinkedInLogoIcon, LockOpen2Icon, MaskOffIcon, MaskOnIcon, MinusCircledIcon, MinusIcon, ModulzLogoIcon, NotionLogoIcon, OpacityIcon, OverlineIcon, PaperPlaneIcon, PauseIcon, Pencil2Icon, PilcrowIcon, PinBottomIcon, PinLeftIcon, PinRightIcon, PlayIcon, ReaderIcon, ResumeIcon, RotateCounterClockwiseIcon, RowSpacingIcon, RulerHorizontalIcon, RulerSquareIcon, SewingPinFilledIcon, SewingPinIcon, ShadowInnerIcon, ShadowNoneIcon, ShadowOuterIcon, Share2Icon, ShuffleIcon, SlashIcon, SpaceBetweenHorizontallyIcon, SpaceBetweenVerticallyIcon, SpaceEvenlyHorizontallyIcon, SpaceEvenlyVerticallyIcon, SpeakerLoudIcon, SpeakerModerateIcon, SpeakerOffIcon, SpeakerQuietIcon, StitchesLogoIcon, StopIcon, StopwatchIcon, StretchHorizontallyIcon, StretchVerticallyIcon, StrikethroughIcon, TextAlignBottomIcon, TextAlignMiddleIcon, TextAlignTopIcon, TextNoneIcon, ThickArrowDownIcon, ThickArrowLeftIcon, ThickArrowRightIcon, ThickArrowUpIcon, TrackNextIcon, TrackPreviousIcon, TransformIcon, TriangleDownIcon, TriangleLeftIcon, TriangleRightIcon, TriangleUpIcon, TwitterLogoIcon, UpdateIcon, UploadIcon, ValueIcon, ValueNoneIcon, VercelLogoIcon, ViewHorizontalIcon, ViewNoneIcon, ViewVerticalIcon, ZoomInIcon, ZoomOutIcon */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = (/* unused pure expression or super */ null && (["color"]));
var AccessibilityIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.877197 7.49984C0.877197 3.84216 3.84234 0.877014 7.50003 0.877014C11.1577 0.877014 14.1229 3.84216 14.1229 7.49984C14.1229 11.1575 11.1577 14.1227 7.50003 14.1227C3.84234 14.1227 0.877197 11.1575 0.877197 7.49984ZM7.50003 1.82701C4.36702 1.82701 1.8272 4.36683 1.8272 7.49984C1.8272 10.6328 4.36702 13.1727 7.50003 13.1727C10.633 13.1727 13.1729 10.6328 13.1729 7.49984C13.1729 4.36683 10.633 1.82701 7.50003 1.82701ZM7.12457 9.00001C7.06994 9.12735 6.33165 11.9592 6.33165 11.9592C6.26018 12.226 5.98601 12.3843 5.71928 12.3128C5.45255 12.2413 5.29425 11.9672 5.36573 11.7004C5.36573 11.7004 6.24661 8.87268 6.24661 8.27007V6.80099L4.28763 6.27608C4.0209 6.20461 3.86261 5.93045 3.93408 5.66371C4.00555 5.39698 4.27972 5.23869 4.54645 5.31016C4.54645 5.31016 6.20042 5.87268 6.84579 5.87268H8.15505C8.80042 5.87268 10.4534 5.31042 10.4534 5.31042C10.7202 5.23895 10.9943 5.39724 11.0658 5.66397C11.1373 5.93071 10.979 6.20487 10.7122 6.27635L8.74661 6.80303V8.27007C8.74661 8.87268 9.62663 11.6971 9.62663 11.6971C9.6981 11.9639 9.5398 12.238 9.27307 12.3095C9.00634 12.381 8.73217 12.2227 8.6607 11.956C8.6607 11.956 7.91994 9.12735 7.86866 9.00001C7.81994 8.87268 7.65006 8.87268 7.65006 8.87268H7.34317C7.34317 8.87268 7.16994 8.87268 7.12457 9.00001ZM7.50043 5.12007C8.12175 5.12007 8.62543 4.61639 8.62543 3.99507C8.62543 3.37375 8.12175 2.87007 7.50043 2.87007C6.87911 2.87007 6.37543 3.37375 6.37543 3.99507C6.37543 4.61639 6.87911 5.12007 7.50043 5.12007Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1 = (/* unused pure expression or super */ null && (["color"]));
var ActivityLogIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0 1.5C0 1.22386 0.223858 1 0.5 1H2.5C2.77614 1 3 1.22386 3 1.5C3 1.77614 2.77614 2 2.5 2H0.5C0.223858 2 0 1.77614 0 1.5ZM4 1.5C4 1.22386 4.22386 1 4.5 1H14.5C14.7761 1 15 1.22386 15 1.5C15 1.77614 14.7761 2 14.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H11.5C11.7761 4 12 4.22386 12 4.5C12 4.77614 11.7761 5 11.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM0 7.5C0 7.22386 0.223858 7 0.5 7H2.5C2.77614 7 3 7.22386 3 7.5C3 7.77614 2.77614 8 2.5 8H0.5C0.223858 8 0 7.77614 0 7.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H4.5C4.22386 11 4 10.7761 4 10.5ZM0 13.5C0 13.2239 0.223858 13 0.5 13H2.5C2.77614 13 3 13.2239 3 13.5C3 13.7761 2.77614 14 2.5 14H0.5C0.223858 14 0 13.7761 0 13.5ZM4 13.5C4 13.2239 4.22386 13 4.5 13H14.5C14.7761 13 15 13.2239 15 13.5C15 13.7761 14.7761 14 14.5 14H4.5C4.22386 14 4 13.7761 4 13.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2 = (/* unused pure expression or super */ null && (["color"]));
var AlignBaselineIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M10.5 1.75003C10.7107 1.75003 10.8988 1.88217 10.9703 2.08042L13.9703 10.4C14.064 10.6598 13.9293 10.9463 13.6696 11.04C13.4098 11.1336 13.1233 10.999 13.0296 10.7392L12.0477 8.01606H8.95227L7.97031 10.7392C7.87664 10.999 7.59012 11.1336 7.33035 11.04C7.07058 10.9463 6.93593 10.6598 7.0296 10.4L10.0296 2.08042C10.1011 1.88217 10.2892 1.75003 10.5 1.75003ZM10.5 3.72402L11.7411 7.16606H9.25877L10.5 3.72402ZM2.49949 2.09997C2.7204 2.09997 2.89949 2.27906 2.89949 2.49997L2.89949 9.53428L4.21664 8.21713C4.37285 8.06092 4.62612 8.06092 4.78233 8.21713C4.93854 8.37334 4.93854 8.6266 4.78233 8.78281L2.78233 10.7828C2.70732 10.8578 2.60557 10.9 2.49949 10.9C2.3934 10.9 2.29166 10.8578 2.21664 10.7828L0.216645 8.78281C0.0604349 8.6266 0.0604349 8.37334 0.216645 8.21713C0.372854 8.06092 0.62612 8.06092 0.78233 8.21713L2.09949 9.53428L2.09949 2.49997C2.09949 2.27906 2.27857 2.09997 2.49949 2.09997ZM0.0999695 13.5001C0.0999695 13.2791 0.279056 13.1001 0.499969 13.1001H14.5C14.7209 13.1001 14.9 13.2791 14.9 13.5001C14.9 13.721 14.7209 13.9001 14.5 13.9001H0.499969C0.279056 13.9001 0.0999695 13.721 0.0999695 13.5001Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3 = (/* unused pure expression or super */ null && (["color"]));
var AlignBottomIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M9 3C9 2.44772 8.55229 2 8 2H7C6.44772 2 6 2.44772 6 3L6 14H1.5C1.22386 14 1 14.2239 1 14.5C1 14.7761 1.22386 15 1.5 15L6 15H9H13.5C13.7761 15 14 14.7761 14 14.5C14 14.2239 13.7761 14 13.5 14H9V3Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4 = (/* unused pure expression or super */ null && (["color"]));
var AlignCenterHorizontallyIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.99988 6C1.44759 6 0.999877 6.44772 0.999877 7L0.999877 8C0.999877 8.55228 1.44759 9 1.99988 9L6.99988 9L6.99988 13.5C6.99988 13.7761 7.22374 14 7.49988 14C7.77602 14 7.99988 13.7761 7.99988 13.5L7.99988 9L12.9999 9C13.5522 9 13.9999 8.55228 13.9999 8L13.9999 7C13.9999 6.44772 13.5522 6 12.9999 6L7.99988 6L7.99988 1.5C7.99988 1.22386 7.77602 1 7.49988 1C7.22373 1 6.99988 1.22386 6.99988 1.5L6.99988 6L1.99988 6Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$5 = (/* unused pure expression or super */ null && (["color"]));
var AlignCenterVerticallyIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M6.99988 1C6.44759 1 5.99988 1.44772 5.99988 2V7H1.49988C1.22374 7 0.999878 7.22386 0.999878 7.5C0.999878 7.77614 1.22374 8 1.49988 8H5.99988V13C5.99988 13.5523 6.44759 14 6.99988 14H7.99988C8.55216 14 8.99988 13.5523 8.99988 13V8H13.4999C13.776 8 13.9999 7.77614 13.9999 7.5C13.9999 7.22386 13.776 7 13.4999 7H8.99988V2C8.99988 1.44772 8.55216 1 7.99988 1L6.99988 1Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$6 = (/* unused pure expression or super */ null && (["color"]));
var AlignLeftIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$6);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.499995 0.999995C0.223855 0.999995 -5.58458e-07 1.22385 -5.46388e-07 1.49999L-2.18554e-08 13.4999C-9.78492e-09 13.776 0.223855 13.9999 0.499995 13.9999C0.776136 13.9999 0.999991 13.776 0.999991 13.4999L0.999991 8.99993L12 8.99993C12.5523 8.99993 13 8.55222 13 7.99993L13 6.99994C13 6.44766 12.5523 5.99995 12 5.99995L0.999991 5.99995L0.999991 1.49999C0.999991 1.22385 0.776135 0.999995 0.499995 0.999995Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$7 = (/* unused pure expression or super */ null && (["color"]));
var AlignRightIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M14.4999 1C14.2237 1 13.9999 1.22386 13.9999 1.5L13.9999 6L2.99988 6C2.44759 6 1.99988 6.44772 1.99988 7L1.99988 8C1.99988 8.55228 2.44759 9 2.99988 9L13.9999 9L13.9999 13.5C13.9999 13.7761 14.2237 14 14.4999 14C14.776 14 14.9999 13.7761 14.9999 13.5L14.9999 9L14.9999 6L14.9999 1.5C14.9999 1.22386 14.776 1 14.4999 1Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$8 = (/* unused pure expression or super */ null && (["color"]));
var AlignTopIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$8);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.5 0C1.22386 0 1 0.223858 1 0.5C1 0.776142 1.22386 1 1.5 1H6V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V1H13.5C13.7761 1 14 0.776142 14 0.5C14 0.223858 13.7761 0 13.5 0H9H6H1.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$9 = (/* unused pure expression or super */ null && (["color"]));
var AllSidesIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$9);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.5 0.75L9.75 3H5.25L7.5 0.75ZM7.5 14.25L9.75 12H5.25L7.5 14.25ZM3 5.25L0.75 7.5L3 9.75V5.25ZM14.25 7.5L12 5.25V9.75L14.25 7.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$a = (/* unused pure expression or super */ null && (["color"]));
var AngleIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$a);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M8.8914 2.1937C9.1158 2.35464 9.16725 2.66701 9.00631 2.89141L2.47388 12H13.5C13.7761 12 14 12.2239 14 12.5C14 12.7762 13.7761 13 13.5 13H1.5C1.31254 13 1.14082 12.8952 1.0552 12.7284C0.969578 12.5616 0.984438 12.361 1.09369 12.2086L8.19369 2.30862C8.35462 2.08422 8.667 2.03277 8.8914 2.1937ZM11.1 6.50001C11.1 6.22387 11.3238 6.00001 11.6 6.00001C11.8761 6.00001 12.1 6.22387 12.1 6.50001C12.1 6.77615 11.8761 7.00001 11.6 7.00001C11.3238 7.00001 11.1 6.77615 11.1 6.50001ZM10.4 4.00001C10.1239 4.00001 9.90003 4.22387 9.90003 4.50001C9.90003 4.77615 10.1239 5.00001 10.4 5.00001C10.6762 5.00001 10.9 4.77615 10.9 4.50001C10.9 4.22387 10.6762 4.00001 10.4 4.00001ZM12.1 8.50001C12.1 8.22387 12.3238 8.00001 12.6 8.00001C12.8761 8.00001 13.1 8.22387 13.1 8.50001C13.1 8.77615 12.8761 9.00001 12.6 9.00001C12.3238 9.00001 12.1 8.77615 12.1 8.50001ZM13.4 10C13.1239 10 12.9 10.2239 12.9 10.5C12.9 10.7761 13.1239 11 13.4 11C13.6762 11 13.9 10.7761 13.9 10.5C13.9 10.2239 13.6762 10 13.4 10Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$b = (/* unused pure expression or super */ null && (["color"]));
var ArchiveIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$b);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.30902 1C2.93025 1 2.58398 1.214 2.41459 1.55279L1.05279 4.27639C1.01807 4.34582 1 4.42238 1 4.5V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V4.5C14 4.42238 13.9819 4.34582 13.9472 4.27639L12.5854 1.55281C12.416 1.21403 12.0698 1.00003 11.691 1.00003L7.5 1.00001L3.30902 1ZM3.30902 2L7 2.00001V4H2.30902L3.30902 2ZM8 4V2.00002L11.691 2.00003L12.691 4H8ZM7.5 5H13V13H2V5H7.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H9.5C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7H5.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$c = (/* unused pure expression or super */ null && (["color"]));
var ArrowBottomLeftIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$c);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M11.3536 3.64644C11.5488 3.8417 11.5488 4.15828 11.3536 4.35354L4.70711 11L9 11C9.27614 11 9.5 11.2239 9.5 11.5C9.5 11.7761 9.27614 12 9 12L3.5 12C3.36739 12 3.24021 11.9473 3.14645 11.8536C3.05268 11.7598 3 11.6326 3 11.5L3 5.99999C3 5.72385 3.22386 5.49999 3.5 5.49999C3.77614 5.49999 4 5.72385 4 5.99999V10.2929L10.6464 3.64643C10.8417 3.45117 11.1583 3.45117 11.3536 3.64644Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$d = (/* unused pure expression or super */ null && (["color"]));
var ArrowBottomRightIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$d);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.64645 3.64644C3.45118 3.8417 3.45118 4.15828 3.64645 4.35354L10.2929 11L6 11C5.72386 11 5.5 11.2239 5.5 11.5C5.5 11.7761 5.72386 12 6 12L11.5 12C11.6326 12 11.7598 11.9473 11.8536 11.8536C11.9473 11.7598 12 11.6326 12 11.5L12 5.99999C12 5.72385 11.7761 5.49999 11.5 5.49999C11.2239 5.49999 11 5.72385 11 5.99999V10.2929L4.35355 3.64643C4.15829 3.45117 3.84171 3.45117 3.64645 3.64644Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$e = ["color"];
var ArrowDownIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$e);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 11.2929L11.1464 8.14645C11.3417 7.95118 11.6583 7.95118 11.8536 8.14645C12.0488 8.34171 12.0488 8.65829 11.8536 8.85355L7.85355 12.8536C7.75979 12.9473 7.63261 13 7.5 13C7.36739 13 7.24021 12.9473 7.14645 12.8536L3.14645 8.85355C2.95118 8.65829 2.95118 8.34171 3.14645 8.14645C3.34171 7.95118 3.65829 7.95118 3.85355 8.14645L7 11.2929L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$f = ["color"];
var ArrowLeftIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$f);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$g = ["color"];
var ArrowRightIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$g);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$h = (/* unused pure expression or super */ null && (["color"]));
var ArrowTopLeftIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$h);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M11.3536 11.3536C11.5488 11.1583 11.5488 10.8417 11.3536 10.6465L4.70711 4L9 4C9.27614 4 9.5 3.77614 9.5 3.5C9.5 3.22386 9.27614 3 9 3L3.5 3C3.36739 3 3.24021 3.05268 3.14645 3.14645C3.05268 3.24022 3 3.36739 3 3.5L3 9.00001C3 9.27615 3.22386 9.50001 3.5 9.50001C3.77614 9.50001 4 9.27615 4 9.00001V4.70711L10.6464 11.3536C10.8417 11.5488 11.1583 11.5488 11.3536 11.3536Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$i = ["color"];
var ArrowTopRightIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$i);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.64645 11.3536C3.45118 11.1583 3.45118 10.8417 3.64645 10.6465L10.2929 4L6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3L11.5 3C11.6326 3 11.7598 3.05268 11.8536 3.14645C11.9473 3.24022 12 3.36739 12 3.5L12 9.00001C12 9.27615 11.7761 9.50001 11.5 9.50001C11.2239 9.50001 11 9.27615 11 9.00001V4.70711L4.35355 11.3536C4.15829 11.5488 3.84171 11.5488 3.64645 11.3536Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$j = ["color"];
var ArrowUpIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$j);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.14645 2.14645C7.34171 1.95118 7.65829 1.95118 7.85355 2.14645L11.8536 6.14645C12.0488 6.34171 12.0488 6.65829 11.8536 6.85355C11.6583 7.04882 11.3417 7.04882 11.1464 6.85355L8 3.70711L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 3.70711L3.85355 6.85355C3.65829 7.04882 3.34171 7.04882 3.14645 6.85355C2.95118 6.65829 2.95118 6.34171 3.14645 6.14645L7.14645 2.14645Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$k = (/* unused pure expression or super */ null && (["color"]));
var AspectRatioIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$k);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M2.5 2H12.5C12.7761 2 13 2.22386 13 2.5V12.5C13 12.7761 12.7761 13 12.5 13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5ZM7.5 4C7.77614 4 8 3.77614 8 3.5C8 3.22386 7.77614 3 7.5 3C7.22386 3 7 3.22386 7 3.5C7 3.77614 7.22386 4 7.5 4ZM8 5.5C8 5.77614 7.77614 6 7.5 6C7.22386 6 7 5.77614 7 5.5C7 5.22386 7.22386 5 7.5 5C7.77614 5 8 5.22386 8 5.5ZM7.5 8C7.77614 8 8 7.77614 8 7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8ZM10 7.5C10 7.77614 9.77614 8 9.5 8C9.22386 8 9 7.77614 9 7.5C9 7.22386 9.22386 7 9.5 7C9.77614 7 10 7.22386 10 7.5ZM11.5 8C11.7761 8 12 7.77614 12 7.5C12 7.22386 11.7761 7 11.5 7C11.2239 7 11 7.22386 11 7.5C11 7.77614 11.2239 8 11.5 8Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$l = (/* unused pure expression or super */ null && (["color"]));
var AvatarIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$l);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$m = (/* unused pure expression or super */ null && (["color"]));
var BackpackIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$m);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M5 1C5 0.447715 5.44772 0 6 0H9C9.55228 0 10 0.447715 10 1V2H14C14.5523 2 15 2.44772 15 3V6C15 6.8888 14.6131 7.68734 14 8.23608V11.5C14 12.3284 13.3284 13 12.5 13H2.5C1.67157 13 1 12.3284 1 11.5V8.2359C0.38697 7.68721 0 6.88883 0 6V3C0 2.44772 0.447716 2 1 2H5V1ZM9 1V2H6V1H9ZM1 3H5H5.5H9.5H10H14V6C14 6.654 13.6866 7.23467 13.1997 7.6004C12.8655 7.85144 12.4508 8 12 8H8V7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5V8H3C2.5493 8 2.1346 7.85133 1.80029 7.60022C1.31335 7.23446 1 6.65396 1 6V3ZM7 9H3C2.64961 9 2.31292 8.93972 2 8.82905V11.5C2 11.7761 2.22386 12 2.5 12H12.5C12.7761 12 13 11.7761 13 11.5V8.82915C12.6871 8.93978 12.3504 9 12 9H8V9.5C8 9.77614 7.77614 10 7.5 10C7.22386 10 7 9.77614 7 9.5V9Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$n = (/* unused pure expression or super */ null && (["color"]));
var BadgeIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$n);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.5 6H11.5C12.3284 6 13 6.67157 13 7.5C13 8.32843 12.3284 9 11.5 9H3.5C2.67157 9 2 8.32843 2 7.5C2 6.67157 2.67157 6 3.5 6ZM1 7.5C1 6.11929 2.11929 5 3.5 5H11.5C12.8807 5 14 6.11929 14 7.5C14 8.88071 12.8807 10 11.5 10H3.5C2.11929 10 1 8.88071 1 7.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$o = ["color"];
var BarChartIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$o);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M11.5 1C11.7761 1 12 1.22386 12 1.5V13.5C12 13.7761 11.7761 14 11.5 14C11.2239 14 11 13.7761 11 13.5V1.5C11 1.22386 11.2239 1 11.5 1ZM9.5 3C9.77614 3 10 3.22386 10 3.5V13.5C10 13.7761 9.77614 14 9.5 14C9.22386 14 9 13.7761 9 13.5V3.5C9 3.22386 9.22386 3 9.5 3ZM13.5 3C13.7761 3 14 3.22386 14 3.5V13.5C14 13.7761 13.7761 14 13.5 14C13.2239 14 13 13.7761 13 13.5V3.5C13 3.22386 13.2239 3 13.5 3ZM5.5 4C5.77614 4 6 4.22386 6 4.5V13.5C6 13.7761 5.77614 14 5.5 14C5.22386 14 5 13.7761 5 13.5V4.5C5 4.22386 5.22386 4 5.5 4ZM1.5 5C1.77614 5 2 5.22386 2 5.5V13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5V5.5C1 5.22386 1.22386 5 1.5 5ZM7.5 5C7.77614 5 8 5.22386 8 5.5V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.5C7 5.22386 7.22386 5 7.5 5ZM3.5 7C3.77614 7 4 7.22386 4 7.5V13.5C4 13.7761 3.77614 14 3.5 14C3.22386 14 3 13.7761 3 13.5V7.5C3 7.22386 3.22386 7 3.5 7Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$p = ["color"];
var BellIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$p);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M8.60124 1.25086C8.60124 1.75459 8.26278 2.17927 7.80087 2.30989C10.1459 2.4647 12 4.41582 12 6.79999V10.25C12 11.0563 12.0329 11.7074 12.7236 12.0528C12.931 12.1565 13.0399 12.3892 12.9866 12.6149C12.9333 12.8406 12.7319 13 12.5 13H8.16144C8.36904 13.1832 8.49997 13.4513 8.49997 13.75C8.49997 14.3023 8.05226 14.75 7.49997 14.75C6.94769 14.75 6.49997 14.3023 6.49997 13.75C6.49997 13.4513 6.63091 13.1832 6.83851 13H2.49999C2.2681 13 2.06664 12.8406 2.01336 12.6149C1.96009 12.3892 2.06897 12.1565 2.27638 12.0528C2.96708 11.7074 2.99999 11.0563 2.99999 10.25V6.79999C2.99999 4.41537 4.85481 2.46396 7.20042 2.3098C6.73867 2.17908 6.40036 1.75448 6.40036 1.25086C6.40036 0.643104 6.89304 0.150421 7.5008 0.150421C8.10855 0.150421 8.60124 0.643104 8.60124 1.25086ZM7.49999 3.29999C5.56699 3.29999 3.99999 4.86699 3.99999 6.79999V10.25L4.00002 10.3009C4.0005 10.7463 4.00121 11.4084 3.69929 12H11.3007C10.9988 11.4084 10.9995 10.7463 11 10.3009L11 10.25V6.79999C11 4.86699 9.43299 3.29999 7.49999 3.29999Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$q = ["color"];
var BlendingModeIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$q);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3 9C3 6.5 4.5 4.25 7.5 1.5C10.5 4.25 12 6.5 12 9C12 11.4853 9.98528 13.5 7.5 13.5C5.01472 13.5 3 11.4853 3 9ZM10.9524 8.30307C9.67347 7.82121 8.2879 8.46208 6.98956 9.06259C5.9327 9.55142 4.93365 10.0135 4.09695 9.82153C4.03357 9.55804 4 9.28294 4 9C4 7.11203 5.02686 5.27195 7.5 2.87357C9.66837 4.97639 10.725 6.65004 10.9524 8.30307Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$r = ["color"];
var BookmarkIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$r);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H11.5C11.7761 2 12 2.22386 12 2.5V13.5C12 13.6818 11.9014 13.8492 11.7424 13.9373C11.5834 14.0254 11.3891 14.0203 11.235 13.924L7.5 11.5896L3.765 13.924C3.61087 14.0203 3.41659 14.0254 3.25762 13.9373C3.09864 13.8492 3 13.6818 3 13.5V2.5ZM4 3V12.5979L6.97 10.7416C7.29427 10.539 7.70573 10.539 8.03 10.7416L11 12.5979V3H4Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$s = (/* unused pure expression or super */ null && (["color"]));
var BookmarkFilledIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$s);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V13.5C3 13.6818 3.09864 13.8492 3.25762 13.9373C3.41659 14.0254 3.61087 14.0203 3.765 13.924L7.5 11.5896L11.235 13.924C11.3891 14.0203 11.5834 14.0254 11.7424 13.9373C11.9014 13.8492 12 13.6818 12 13.5V2.5C12 2.22386 11.7761 2 11.5 2H3.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$t = ["color"];
var BorderAllIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$t);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M0.25 1C0.25 0.585786 0.585786 0.25 1 0.25H14C14.4142 0.25 14.75 0.585786 14.75 1V14C14.75 14.4142 14.4142 14.75 14 14.75H1C0.585786 14.75 0.25 14.4142 0.25 14V1ZM1.75 1.75V13.25H13.25V1.75H1.75Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "7",
    y: "5",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "7",
    y: "3",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "7",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "5",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "3",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "9",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "11",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "7",
    y: "9",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "7",
    y: "11",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }));
});

var _excluded$u = ["color"];
var BorderBottomIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$u);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1 13.25L14 13.25V14.75L1 14.75V13.25Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "7",
    y: "5",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "13",
    y: "5",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "7",
    y: "3",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "13",
    y: "3",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "7",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "7",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "13",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "13",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "5",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "5",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "3",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "3",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "9",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "9",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "11",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "11",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "7",
    y: "9",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "13",
    y: "9",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "7",
    y: "11",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "13",
    y: "11",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "1",
    y: "5",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "1",
    y: "3",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "1",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "1",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "1",
    y: "9",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "1",
    y: "11",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }));
});

var _excluded$v = (/* unused pure expression or super */ null && (["color"]));
var BorderDashedIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$v);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$w = (/* unused pure expression or super */ null && (["color"]));
var BorderDottedIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$w);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.5 6.625C1.01675 6.625 0.625 7.01675 0.625 7.5C0.625 7.98325 1.01675 8.375 1.5 8.375C1.98325 8.375 2.375 7.98325 2.375 7.5C2.375 7.01675 1.98325 6.625 1.5 6.625ZM5.5 6.625C5.01675 6.625 4.625 7.01675 4.625 7.5C4.625 7.98325 5.01675 8.375 5.5 8.375C5.98325 8.375 6.375 7.98325 6.375 7.5C6.375 7.01675 5.98325 6.625 5.5 6.625ZM9.5 6.625C9.01675 6.625 8.625 7.01675 8.625 7.5C8.625 7.98325 9.01675 8.375 9.5 8.375C9.98325 8.375 10.375 7.98325 10.375 7.5C10.375 7.01675 9.98325 6.625 9.5 6.625ZM12.625 7.5C12.625 7.01675 13.0168 6.625 13.5 6.625C13.9832 6.625 14.375 7.01675 14.375 7.5C14.375 7.98325 13.9832 8.375 13.5 8.375C13.0168 8.375 12.625 7.98325 12.625 7.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$x = (/* unused pure expression or super */ null && (["color"]));
var BorderLeftIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$x);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.75 1L1.75 14L0.249999 14L0.25 1L1.75 1Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("rect", {
    x: "10",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 10 7)",
    fill: color
  }), createElement("rect", {
    x: "10",
    y: "13",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 10 13)",
    fill: color
  }), createElement("rect", {
    x: "12",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 12 7)",
    fill: color
  }), createElement("rect", {
    x: "12",
    y: "13",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 12 13)",
    fill: color
  }), createElement("rect", {
    x: "8",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 8 7)",
    fill: color
  }), createElement("rect", {
    x: "14",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 14 7)",
    fill: color
  }), createElement("rect", {
    x: "8",
    y: "13",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 8 13)",
    fill: color
  }), createElement("rect", {
    x: "14",
    y: "13",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 14 13)",
    fill: color
  }), createElement("rect", {
    x: "8",
    y: "5",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 8 5)",
    fill: color
  }), createElement("rect", {
    x: "14",
    y: "5",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 14 5)",
    fill: color
  }), createElement("rect", {
    x: "8",
    y: "3",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 8 3)",
    fill: color
  }), createElement("rect", {
    x: "14",
    y: "3",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 14 3)",
    fill: color
  }), createElement("rect", {
    x: "8",
    y: "9",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 8 9)",
    fill: color
  }), createElement("rect", {
    x: "14",
    y: "9",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 14 9)",
    fill: color
  }), createElement("rect", {
    x: "8",
    y: "11",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 8 11)",
    fill: color
  }), createElement("rect", {
    x: "14",
    y: "11",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 14 11)",
    fill: color
  }), createElement("rect", {
    x: "6",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 6 7)",
    fill: color
  }), createElement("rect", {
    x: "6",
    y: "13",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 6 13)",
    fill: color
  }), createElement("rect", {
    x: "4",
    y: "7",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 4 7)",
    fill: color
  }), createElement("rect", {
    x: "4",
    y: "13",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 4 13)",
    fill: color
  }), createElement("rect", {
    x: "10",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 10 1)",
    fill: color
  }), createElement("rect", {
    x: "12",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 12 1)",
    fill: color
  }), createElement("rect", {
    x: "8",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 8 1)",
    fill: color
  }), createElement("rect", {
    x: "14",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 14 1)",
    fill: color
  }), createElement("rect", {
    x: "6",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 6 1)",
    fill: color
  }), createElement("rect", {
    x: "4",
    y: "1",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(90 4 1)",
    fill: color
  }));
})));

var _excluded$y = (/* unused pure expression or super */ null && (["color"]));
var BorderNoneIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$y);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("rect", {
    x: "7",
    y: "5.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "13",
    y: "5.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "7",
    y: "3.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "13",
    y: "3.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "7",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "7",
    y: "13.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "7",
    y: "1.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "13",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "13",
    y: "13.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "13",
    y: "1.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "5",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "5",
    y: "13.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "5",
    y: "1.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "3",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "3",
    y: "13.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "3",
    y: "1.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "9",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "9",
    y: "13.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "9",
    y: "1.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "11",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "11",
    y: "13.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "11",
    y: "1.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "7",
    y: "9.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "13",
    y: "9.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "7",
    y: "11.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "13",
    y: "11.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "1",
    y: "5.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "1",
    y: "3.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "1",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "1",
    y: "13.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "1",
    y: "1.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "1",
    y: "9.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "1",
    y: "11.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }));
})));

var _excluded$z = (/* unused pure expression or super */ null && (["color"]));
var BorderRightIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$z);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M13.25 1L13.25 14L14.75 14L14.75 1L13.25 1Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 5 7)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 5 13)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 3 7)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 3 13)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 7 7)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 1 7)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 7 13)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 1 13)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 7 5)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 1 5)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 7 3)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 1 3)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 7 9)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 1 9)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 7 11)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 1 11)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 9 7)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 9 13)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 11 7)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 11 13)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 5 1)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 3 1)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 7 1)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 1 1)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 9 1)",
    fill: color
  }), createElement("rect", {
    width: "1",
    height: "1",
    rx: ".5",
    transform: "matrix(0 1 1 0 11 1)",
    fill: color
  }));
})));

var _excluded$A = (/* unused pure expression or super */ null && (["color"]));
var BorderSolidIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$A);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$B = (/* unused pure expression or super */ null && (["color"]));
var BorderSplitIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$B);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("rect", {
    x: "7",
    y: "5.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "7",
    y: "3.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "7",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "7",
    y: "13.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "7",
    y: "1.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "13",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "5",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "3",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "9",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "11",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "7",
    y: "9.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "7",
    y: "11.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("rect", {
    x: "1",
    y: "7.025",
    width: "1",
    height: "1",
    rx: ".5",
    fill: color
  }), createElement("path", {
    d: "M1 1.49994C1 1.2238 1.22386 0.999939 1.5 0.999939H6V1.99994H2V5.99994H1V1.49994ZM13 1.99994H9V0.999939H13.5C13.7761 0.999939 14 1.2238 14 1.49994V5.99994H13V1.99994ZM1 13.4999V8.99994H2V12.9999H6V13.9999H1.5C1.22386 13.9999 1 13.7761 1 13.4999ZM13 12.9999V8.99994H14V13.4999C14 13.7761 13.7761 13.9999 13.5 13.9999H9.5V12.9999H13Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$C = ["color"];
var BorderStyleIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$C);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H3.5C3.77614 7 4 7.22386 4 7.5C4 7.77614 3.77614 8 3.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11ZM11 11.5C11 11.2239 11.2239 11 11.5 11C11.7761 11 12 11.2239 12 11.5C12 11.7761 11.7761 12 11.5 12C11.2239 12 11 11.7761 11 11.5ZM13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11ZM6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H8.5C8.77614 8 9 7.77614 9 7.5C9 7.22386 8.77614 7 8.5 7H6.5ZM11 7.5C11 7.22386 11.2239 7 11.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H11.5C11.2239 8 11 7.77614 11 7.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$D = ["color"];
var BorderTopIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$D);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M14 1.75L1 1.75L1 0.249999L14 0.25L14 1.75Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "8",
    y: "10",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 8 10)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "2",
    y: "10",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 2 10)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "8",
    y: "12",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 8 12)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "2",
    y: "12",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 2 12)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "8",
    y: "8",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 8 8)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "8",
    y: "14",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 8 14)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "2",
    y: "8",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 2 8)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "2",
    y: "14",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 2 14)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "10",
    y: "8",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 10 8)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "10",
    y: "14",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 10 14)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "12",
    y: "8",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 12 8)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "12",
    y: "14",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 12 14)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "6",
    y: "8",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 6 8)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "6",
    y: "14",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 6 14)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "4",
    y: "8",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 4 8)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "4",
    y: "14",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 4 14)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "8",
    y: "6",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 8 6)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "2",
    y: "6",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 2 6)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "8",
    y: "4",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 8 4)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "2",
    y: "4",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 2 4)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "14",
    y: "10",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 14 10)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "14",
    y: "12",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 14 12)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "14",
    y: "8",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 14 8)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "14",
    y: "14",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 14 14)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "14",
    y: "6",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 14 6)",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("rect", {
    x: "14",
    y: "4",
    width: "1",
    height: "1",
    rx: ".5",
    transform: "rotate(-180 14 4)",
    fill: color
  }));
});

var _excluded$E = (/* unused pure expression or super */ null && (["color"]));
var BorderWidthIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$E);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1 3H14V4H1V3ZM1 6H14V8H1V6ZM14 10.25H1V12.75H14V10.25Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$F = ["color"];
var BoxIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$F);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M12.5 2H2.5C2.22386 2 2 2.22386 2 2.5V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$G = (/* unused pure expression or super */ null && (["color"]));
var BoxModelIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$G);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.99998 0.999976C1.44769 0.999976 0.999976 1.44769 0.999976 1.99998V13C0.999976 13.5523 1.44769 14 1.99998 14H13C13.5523 14 14 13.5523 14 13V1.99998C14 1.44769 13.5523 0.999976 13 0.999976H1.99998ZM1.99998 1.99998L13 1.99998V13H1.99998V1.99998ZM4.49996 3.99996C4.22382 3.99996 3.99996 4.22382 3.99996 4.49996V10.5C3.99996 10.7761 4.22382 11 4.49996 11H10.5C10.7761 11 11 10.7761 11 10.5V4.49996C11 4.22382 10.7761 3.99996 10.5 3.99996H4.49996ZM4.99996 9.99996V4.99996H9.99996V9.99996H4.99996Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$H = ["color"];
var ButtonIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$H);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2 5H13C13.5523 5 14 5.44772 14 6V9C14 9.55228 13.5523 10 13 10H2C1.44772 10 1 9.55228 1 9V6C1 5.44772 1.44772 5 2 5ZM0 6C0 4.89543 0.895431 4 2 4H13C14.1046 4 15 4.89543 15 6V9C15 10.1046 14.1046 11 13 11H2C0.89543 11 0 10.1046 0 9V6ZM4.5 6.75C4.08579 6.75 3.75 7.08579 3.75 7.5C3.75 7.91421 4.08579 8.25 4.5 8.25C4.91421 8.25 5.25 7.91421 5.25 7.5C5.25 7.08579 4.91421 6.75 4.5 6.75ZM6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75C7.91421 6.75 8.25 7.08579 8.25 7.5C8.25 7.91421 7.91421 8.25 7.5 8.25C7.08579 8.25 6.75 7.91421 6.75 7.5ZM10.5 6.75C10.0858 6.75 9.75 7.08579 9.75 7.5C9.75 7.91421 10.0858 8.25 10.5 8.25C10.9142 8.25 11.25 7.91421 11.25 7.5C11.25 7.08579 10.9142 6.75 10.5 6.75Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$I = ["color"];
var CalendarIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$I);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M4.5 1C4.77614 1 5 1.22386 5 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12.5C13.3284 2 14 2.67157 14 3.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V3.5C1 2.67157 1.67157 2 2.5 2H4V1.5C4 1.22386 4.22386 1 4.5 1ZM10 3V3.5C10 3.77614 10.2239 4 10.5 4C10.7761 4 11 3.77614 11 3.5V3H12.5C12.7761 3 13 3.22386 13 3.5V5H2V3.5C2 3.22386 2.22386 3 2.5 3H4V3.5C4 3.77614 4.22386 4 4.5 4C4.77614 4 5 3.77614 5 3.5V3H10ZM2 6V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V6H2ZM7 7.5C7 7.22386 7.22386 7 7.5 7C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8C7.22386 8 7 7.77614 7 7.5ZM9.5 7C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7ZM11 7.5C11 7.22386 11.2239 7 11.5 7C11.7761 7 12 7.22386 12 7.5C12 7.77614 11.7761 8 11.5 8C11.2239 8 11 7.77614 11 7.5ZM11.5 9C11.2239 9 11 9.22386 11 9.5C11 9.77614 11.2239 10 11.5 10C11.7761 10 12 9.77614 12 9.5C12 9.22386 11.7761 9 11.5 9ZM9 9.5C9 9.22386 9.22386 9 9.5 9C9.77614 9 10 9.22386 10 9.5C10 9.77614 9.77614 10 9.5 10C9.22386 10 9 9.77614 9 9.5ZM7.5 9C7.22386 9 7 9.22386 7 9.5C7 9.77614 7.22386 10 7.5 10C7.77614 10 8 9.77614 8 9.5C8 9.22386 7.77614 9 7.5 9ZM5 9.5C5 9.22386 5.22386 9 5.5 9C5.77614 9 6 9.22386 6 9.5C6 9.77614 5.77614 10 5.5 10C5.22386 10 5 9.77614 5 9.5ZM3.5 9C3.22386 9 3 9.22386 3 9.5C3 9.77614 3.22386 10 3.5 10C3.77614 10 4 9.77614 4 9.5C4 9.22386 3.77614 9 3.5 9ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$J = (/* unused pure expression or super */ null && (["color"]));
var CameraIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$J);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M2 3C1.44772 3 1 3.44772 1 4V11C1 11.5523 1.44772 12 2 12H13C13.5523 12 14 11.5523 14 11V4C14 3.44772 13.5523 3 13 3H2ZM0 4C0 2.89543 0.895431 2 2 2H13C14.1046 2 15 2.89543 15 4V11C15 12.1046 14.1046 13 13 13H2C0.895431 13 0 12.1046 0 11V4ZM2 4.25C2 4.11193 2.11193 4 2.25 4H4.75C4.88807 4 5 4.11193 5 4.25V5.75454C5 5.89261 4.88807 6.00454 4.75 6.00454H2.25C2.11193 6.00454 2 5.89261 2 5.75454V4.25ZM12.101 7.58421C12.101 9.02073 10.9365 10.1853 9.49998 10.1853C8.06346 10.1853 6.89893 9.02073 6.89893 7.58421C6.89893 6.14769 8.06346 4.98315 9.49998 4.98315C10.9365 4.98315 12.101 6.14769 12.101 7.58421ZM13.101 7.58421C13.101 9.57302 11.4888 11.1853 9.49998 11.1853C7.51117 11.1853 5.89893 9.57302 5.89893 7.58421C5.89893 5.5954 7.51117 3.98315 9.49998 3.98315C11.4888 3.98315 13.101 5.5954 13.101 7.58421Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$K = ["color"];
var CardStackIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$K);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$L = (/* unused pure expression or super */ null && (["color"]));
var CardStackMinusIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$L);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M2.5 3C2.22386 3 2 3.22386 2 3.5V9.5C2 9.77614 2.22386 10 2.5 10H12.5C12.7761 10 13 9.77614 13 9.5V3.5C13 3.22386 12.7761 3 12.5 3H2.5ZM1 9.5C1 10.1531 1.4174 10.7087 2 10.9146V11.5C2 12.3284 2.67157 13 3.5 13H11.5C12.3284 13 13 12.3284 13 11.5V10.9146C13.5826 10.7087 14 10.1531 14 9.5V3.5C14 2.67157 13.3284 2 12.5 2H2.5C1.67157 2 1 2.67157 1 3.5V9.5ZM12 11.5V11H3V11.5C3 11.7761 3.22386 12 3.5 12H11.5C11.7761 12 12 11.7761 12 11.5ZM5.5 6C5.22386 6 5 6.22386 5 6.5C5 6.77614 5.22386 7 5.5 7H9.5C9.77614 7 10 6.77614 10 6.5C10 6.22386 9.77614 6 9.5 6H5.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$M = (/* unused pure expression or super */ null && (["color"]));
var CardStackPlusIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$M);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12ZM5 6.5C5 6.22386 5.22386 6 5.5 6H7V4.5C7 4.22386 7.22386 4 7.5 4C7.77614 4 8 4.22386 8 4.5V6H9.5C9.77614 6 10 6.22386 10 6.5C10 6.77614 9.77614 7 9.5 7H8V8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5V7H5.5C5.22386 7 5 6.77614 5 6.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$N = (/* unused pure expression or super */ null && (["color"]));
var CaretDownIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$N);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.73379 9.9026 7.61934 9.95001 7.49999 9.95001C7.38064 9.95001 7.26618 9.9026 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$O = (/* unused pure expression or super */ null && (["color"]));
var CaretLeftIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$O);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M8.81809 4.18179C8.99383 4.35753 8.99383 4.64245 8.81809 4.81819L6.13629 7.49999L8.81809 10.1818C8.99383 10.3575 8.99383 10.6424 8.81809 10.8182C8.64236 10.9939 8.35743 10.9939 8.1817 10.8182L5.1817 7.81819C5.09731 7.73379 5.0499 7.61933 5.0499 7.49999C5.0499 7.38064 5.09731 7.26618 5.1817 7.18179L8.1817 4.18179C8.35743 4.00605 8.64236 4.00605 8.81809 4.18179Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$P = (/* unused pure expression or super */ null && (["color"]));
var CaretRightIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$P);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M6.18194 4.18185C6.35767 4.00611 6.6426 4.00611 6.81833 4.18185L9.81833 7.18185C9.90272 7.26624 9.95013 7.3807 9.95013 7.50005C9.95013 7.6194 9.90272 7.73386 9.81833 7.81825L6.81833 10.8182C6.6426 10.994 6.35767 10.994 6.18194 10.8182C6.0062 10.6425 6.0062 10.3576 6.18194 10.1819L8.86374 7.50005L6.18194 4.81825C6.0062 4.64251 6.0062 4.35759 6.18194 4.18185Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$Q = (/* unused pure expression or super */ null && (["color"]));
var CaretSortIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$Q);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$R = (/* unused pure expression or super */ null && (["color"]));
var CaretUpIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$R);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4.18179 8.81819C4.00605 8.64245 4.00605 8.35753 4.18179 8.18179L7.18179 5.18179C7.26618 5.0974 7.38064 5.04999 7.49999 5.04999C7.61933 5.04999 7.73379 5.0974 7.81819 5.18179L10.8182 8.18179C10.9939 8.35753 10.9939 8.64245 10.8182 8.81819C10.6424 8.99392 10.3575 8.99392 10.1818 8.81819L7.49999 6.13638L4.81819 8.81819C4.64245 8.99392 4.35753 8.99392 4.18179 8.81819Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$S = ["color"];
var ChatBubbleIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$S);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M12.5 3L2.5 3.00002C1.67157 3.00002 1 3.6716 1 4.50002V9.50003C1 10.3285 1.67157 11 2.5 11H7.50003C7.63264 11 7.75982 11.0527 7.85358 11.1465L10 13.2929V11.5C10 11.2239 10.2239 11 10.5 11H12.5C13.3284 11 14 10.3285 14 9.50003V4.5C14 3.67157 13.3284 3 12.5 3ZM2.49999 2.00002L12.5 2C13.8807 2 15 3.11929 15 4.5V9.50003C15 10.8807 13.8807 12 12.5 12H11V14.5C11 14.7022 10.8782 14.8845 10.6913 14.9619C10.5045 15.0393 10.2894 14.9965 10.1464 14.8536L7.29292 12H2.5C1.11929 12 0 10.8807 0 9.50003V4.50002C0 3.11931 1.11928 2.00003 2.49999 2.00002Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$T = ["color"];
var CheckIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$T);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$U = ["color"];
var CheckCircledIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$U);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$V = ["color"];
var CheckboxIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$V);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3 3H12V12H3L3 3ZM2 3C2 2.44771 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44771 13 2 12.5523 2 12V3ZM10.3498 5.51105C10.506 5.28337 10.4481 4.97212 10.2204 4.81587C9.99275 4.65961 9.6815 4.71751 9.52525 4.94519L6.64048 9.14857L5.19733 7.40889C5.02102 7.19635 4.7058 7.16699 4.49327 7.34329C4.28073 7.5196 4.25137 7.83482 4.42767 8.04735L6.2934 10.2964C6.39348 10.4171 6.54437 10.4838 6.70097 10.4767C6.85757 10.4695 7.00177 10.3894 7.09047 10.2601L10.3498 5.51105Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$W = ["color"];
var ChevronDownIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$W);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$X = ["color"];
var ChevronLeftIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$X);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$Y = ["color"];
var ChevronRightIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$Y);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$Z = ["color"];
var ChevronUpIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$Z);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.13523 8.84197C3.3241 9.04343 3.64052 9.05363 3.84197 8.86477L7.5 5.43536L11.158 8.86477C11.3595 9.05363 11.6759 9.04343 11.8648 8.84197C12.0536 8.64051 12.0434 8.32409 11.842 8.13523L7.84197 4.38523C7.64964 4.20492 7.35036 4.20492 7.15803 4.38523L3.15803 8.13523C2.95657 8.32409 2.94637 8.64051 3.13523 8.84197Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$_ = (/* unused pure expression or super */ null && (["color"]));
var CircleIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$_);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.877075 7.49991C0.877075 3.84222 3.84222 0.877075 7.49991 0.877075C11.1576 0.877075 14.1227 3.84222 14.1227 7.49991C14.1227 11.1576 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1576 0.877075 7.49991ZM7.49991 1.82708C4.36689 1.82708 1.82708 4.36689 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49991C13.1727 4.36689 10.6329 1.82708 7.49991 1.82708Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$$ = (/* unused pure expression or super */ null && (["color"]));
var CircleBackslashIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$$);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM3.85768 3.15057C4.84311 2.32448 6.11342 1.82708 7.49991 1.82708C10.6329 1.82708 13.1727 4.36689 13.1727 7.49991C13.1727 8.88638 12.6753 10.1567 11.8492 11.1421L3.85768 3.15057ZM3.15057 3.85768C2.32448 4.84311 1.82708 6.11342 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C8.88638 13.1727 10.1567 12.6753 11.1421 11.8492L3.15057 3.85768Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$10 = (/* unused pure expression or super */ null && (["color"]));
var ClipboardIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$10);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM11 2V2.25C11 2.66421 10.6642 3 10.25 3H4.75C4.33579 3 4 2.66421 4 2.25V2H3.5C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V2.5C12 2.22386 11.7761 2 11.5 2H11Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$11 = (/* unused pure expression or super */ null && (["color"]));
var ClipboardCopyIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$11);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H7V13H3.5C3.22386 13 3 12.7761 3 12.5V2.5C3 2.22386 3.22386 2 3.5 2H4V2.25C4 2.66421 4.33579 3 4.75 3H10.25C10.6642 3 11 2.66421 11 2.25V2H11.5C11.7761 2 12 2.22386 12 2.5V7H13V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM9 8.5C9 8.77614 8.77614 9 8.5 9C8.22386 9 8 8.77614 8 8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5ZM10.5 9C10.7761 9 11 8.77614 11 8.5C11 8.22386 10.7761 8 10.5 8C10.2239 8 10 8.22386 10 8.5C10 8.77614 10.2239 9 10.5 9ZM13 8.5C13 8.77614 12.7761 9 12.5 9C12.2239 9 12 8.77614 12 8.5C12 8.22386 12.2239 8 12.5 8C12.7761 8 13 8.22386 13 8.5ZM14.5 9C14.7761 9 15 8.77614 15 8.5C15 8.22386 14.7761 8 14.5 8C14.2239 8 14 8.22386 14 8.5C14 8.77614 14.2239 9 14.5 9ZM15 10.5C15 10.7761 14.7761 11 14.5 11C14.2239 11 14 10.7761 14 10.5C14 10.2239 14.2239 10 14.5 10C14.7761 10 15 10.2239 15 10.5ZM14.5 13C14.7761 13 15 12.7761 15 12.5C15 12.2239 14.7761 12 14.5 12C14.2239 12 14 12.2239 14 12.5C14 12.7761 14.2239 13 14.5 13ZM14.5 15C14.7761 15 15 14.7761 15 14.5C15 14.2239 14.7761 14 14.5 14C14.2239 14 14 14.2239 14 14.5C14 14.7761 14.2239 15 14.5 15ZM8.5 11C8.77614 11 9 10.7761 9 10.5C9 10.2239 8.77614 10 8.5 10C8.22386 10 8 10.2239 8 10.5C8 10.7761 8.22386 11 8.5 11ZM9 12.5C9 12.7761 8.77614 13 8.5 13C8.22386 13 8 12.7761 8 12.5C8 12.2239 8.22386 12 8.5 12C8.77614 12 9 12.2239 9 12.5ZM8.5 15C8.77614 15 9 14.7761 9 14.5C9 14.2239 8.77614 14 8.5 14C8.22386 14 8 14.2239 8 14.5C8 14.7761 8.22386 15 8.5 15ZM11 14.5C11 14.7761 10.7761 15 10.5 15C10.2239 15 10 14.7761 10 14.5C10 14.2239 10.2239 14 10.5 14C10.7761 14 11 14.2239 11 14.5ZM12.5 15C12.7761 15 13 14.7761 13 14.5C13 14.2239 12.7761 14 12.5 14C12.2239 14 12 14.2239 12 14.5C12 14.7761 12.2239 15 12.5 15Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$12 = ["color"];
var ClockIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$12);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.50009 0.877014C3.84241 0.877014 0.877258 3.84216 0.877258 7.49984C0.877258 11.1575 3.8424 14.1227 7.50009 14.1227C11.1578 14.1227 14.1229 11.1575 14.1229 7.49984C14.1229 3.84216 11.1577 0.877014 7.50009 0.877014ZM1.82726 7.49984C1.82726 4.36683 4.36708 1.82701 7.50009 1.82701C10.6331 1.82701 13.1729 4.36683 13.1729 7.49984C13.1729 10.6328 10.6331 13.1727 7.50009 13.1727C4.36708 13.1727 1.82726 10.6328 1.82726 7.49984ZM8 4.50001C8 4.22387 7.77614 4.00001 7.5 4.00001C7.22386 4.00001 7 4.22387 7 4.50001V7.50001C7 7.63262 7.05268 7.7598 7.14645 7.85357L9.14645 9.85357C9.34171 10.0488 9.65829 10.0488 9.85355 9.85357C10.0488 9.65831 10.0488 9.34172 9.85355 9.14646L8 7.29291V4.50001Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$13 = ["color"];
var CodeIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$13);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$14 = (/* unused pure expression or super */ null && (["color"]));
var CodeSandboxLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$14);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.71144 0.796902C7.57741 0.734357 7.42257 0.734357 7.28855 0.796902L1.28855 3.5969C1.11251 3.67905 0.999993 3.85573 0.999993 4.04999V10.95C0.999993 11.1443 1.11251 11.3209 1.28855 11.4031L7.28855 14.2031C7.42257 14.2656 7.57741 14.2656 7.71144 14.2031L13.7114 11.4031C13.8875 11.3209 14 11.1443 14 10.95V4.04999C14 3.85573 13.8875 3.67905 13.7114 3.5969L7.71144 0.796902ZM7.49999 3.15674L5.98039 2.51091L7.49999 1.80176L9.01959 2.51091L7.49999 3.15674ZM7.69556 4.16018L10.2382 3.07958L12.2719 4.02865L7.49999 6.05671L2.72808 4.02865L4.76181 3.07958L7.30442 4.16018C7.42939 4.2133 7.57059 4.2133 7.69556 4.16018ZM7.99999 6.93078L13 4.80578V7.92966L11.0821 8.8119C10.7273 8.97509 10.5 9.32988 10.5 9.72039V11.7982L7.99999 12.9649V6.93078ZM11.5 11.3316L13 10.6316V9.03039L11.5 9.72039V11.3316ZM6.99999 6.93078V12.9649L4.50231 11.7993V9.72036C4.50231 9.32985 4.27499 8.97506 3.92022 8.81187L1.99999 7.92856V4.80578L6.99999 6.93078ZM1.99999 10.6316L3.50231 11.3326L3.50231 9.72036L1.99999 9.02929V10.6316Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$15 = (/* unused pure expression or super */ null && (["color"]));
var ColorWheelIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$15);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.877075 7.49985C0.877075 3.84216 3.84222 0.877014 7.49991 0.877014C11.1576 0.877014 14.1227 3.84216 14.1227 7.49985C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49985ZM3.78135 3.21565C4.68298 2.43239 5.83429 1.92904 7.09998 1.84089V6.53429L3.78135 3.21565ZM3.21567 3.78134C2.43242 4.68298 1.92909 5.83428 1.84095 7.09997H6.5343L3.21567 3.78134ZM6.5343 7.89997H1.84097C1.92916 9.16562 2.43253 10.3169 3.21579 11.2185L6.5343 7.89997ZM3.78149 11.7842C4.6831 12.5673 5.83435 13.0707 7.09998 13.1588V8.46566L3.78149 11.7842ZM7.89998 8.46566V13.1588C9.16559 13.0706 10.3168 12.5673 11.2184 11.7841L7.89998 8.46566ZM11.7841 11.2184C12.5673 10.3168 13.0707 9.16558 13.1588 7.89997H8.46567L11.7841 11.2184ZM8.46567 7.09997H13.1589C13.0707 5.83432 12.5674 4.68305 11.7842 3.78143L8.46567 7.09997ZM11.2185 3.21573C10.3169 2.43246 9.16565 1.92909 7.89998 1.8409V6.53429L11.2185 3.21573Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$16 = (/* unused pure expression or super */ null && (["color"]));
var ColumnSpacingIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$16);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M8.00012 1.5C8.00012 1.22386 7.77626 1 7.50012 1C7.22398 1 7.00012 1.22386 7.00012 1.5V13.5C7.00012 13.7761 7.22398 14 7.50012 14C7.77626 14 8.00012 13.7761 8.00012 13.5V1.5ZM3.31812 5.818C3.49386 5.64227 3.49386 5.35734 3.31812 5.18161C3.14239 5.00587 2.85746 5.00587 2.68173 5.18161L0.681729 7.18161C0.505993 7.35734 0.505993 7.64227 0.681729 7.818L2.68173 9.818C2.85746 9.99374 3.14239 9.99374 3.31812 9.818C3.49386 9.64227 3.49386 9.35734 3.31812 9.18161L2.08632 7.9498H5.50017C5.7487 7.9498 5.95017 7.74833 5.95017 7.4998C5.95017 7.25128 5.7487 7.0498 5.50017 7.0498H2.08632L3.31812 5.818ZM12.3181 5.18161C12.1424 5.00587 11.8575 5.00587 11.6817 5.18161C11.506 5.35734 11.506 5.64227 11.6817 5.818L12.9135 7.0498H9.50017C9.25164 7.0498 9.05017 7.25128 9.05017 7.4998C9.05017 7.74833 9.25164 7.9498 9.50017 7.9498H12.9135L11.6817 9.18161C11.506 9.35734 11.506 9.64227 11.6817 9.818C11.8575 9.99374 12.1424 9.99374 12.3181 9.818L14.3181 7.818C14.4939 7.64227 14.4939 7.35734 14.3181 7.18161L12.3181 5.18161Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$17 = ["color"];
var ColumnsIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$17);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2.14998 14V1H0.849976V14H2.14998ZM6.14998 14V1H4.84998V14H6.14998ZM10.15 1V14H8.84998V1H10.15ZM14.15 14V1H12.85V14H14.15Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$18 = (/* unused pure expression or super */ null && (["color"]));
var CommitIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$18);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M9.94969 7.49989C9.94969 8.85288 8.85288 9.94969 7.49989 9.94969C6.14691 9.94969 5.0501 8.85288 5.0501 7.49989C5.0501 6.14691 6.14691 5.0501 7.49989 5.0501C8.85288 5.0501 9.94969 6.14691 9.94969 7.49989ZM10.8632 8C10.6213 9.64055 9.20764 10.8997 7.49989 10.8997C5.79214 10.8997 4.37847 9.64055 4.13662 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H4.13659C4.37835 5.35935 5.79206 4.1001 7.49989 4.1001C9.20772 4.1001 10.6214 5.35935 10.8632 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H10.8632Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$19 = ["color"];
var Component1Icon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$19);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M4.67129 3.14634C4.47603 3.34161 4.47603 3.65819 4.67129 3.85345L7.14616 6.32833C7.34142 6.52359 7.65801 6.52359 7.85327 6.32833L10.3281 3.85345C10.5234 3.65819 10.5234 3.34161 10.3281 3.14634L7.85327 0.671471C7.65801 0.476209 7.34142 0.476209 7.14616 0.671471L4.67129 3.14634ZM7.49971 5.26766L5.73195 3.4999L7.49971 1.73213L9.26748 3.4999L7.49971 5.26766ZM8.67129 7.14634C8.47603 7.34161 8.47603 7.65819 8.67129 7.85345L11.1462 10.3283C11.3414 10.5236 11.658 10.5236 11.8533 10.3283L14.3281 7.85345C14.5234 7.65819 14.5234 7.34161 14.3281 7.14634L11.8533 4.67147C11.658 4.47621 11.3414 4.47621 11.1462 4.67147L8.67129 7.14634ZM11.4997 9.26766L9.73195 7.4999L11.4997 5.73213L13.2675 7.4999L11.4997 9.26766ZM4.67129 11.8535C4.47603 11.6582 4.47603 11.3416 4.67129 11.1463L7.14616 8.67147C7.34142 8.47621 7.65801 8.47621 7.85327 8.67147L10.3281 11.1463C10.5234 11.3416 10.5234 11.6582 10.3281 11.8535L7.85327 14.3283C7.65801 14.5236 7.34142 14.5236 7.14616 14.3283L4.67129 11.8535ZM5.73195 11.4999L7.49971 13.2677L9.26748 11.4999L7.49971 9.73213L5.73195 11.4999ZM0.671288 7.14649C0.476026 7.34175 0.476026 7.65834 0.671288 7.8536L3.14616 10.3285C3.34142 10.5237 3.65801 10.5237 3.85327 10.3285L6.32814 7.8536C6.5234 7.65834 6.5234 7.34175 6.32814 7.14649L3.85327 4.67162C3.65801 4.47636 3.34142 4.47636 3.14616 4.67162L0.671288 7.14649ZM3.49972 9.26781L1.73195 7.50005L3.49972 5.73228L5.26748 7.50005L3.49972 9.26781Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1a = ["color"];
var Component2Icon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1a);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.87935 1H3.9H11.1H11.1207C11.5231 0.999994 11.8553 0.999989 12.1259 1.0221C12.407 1.04506 12.6653 1.09434 12.908 1.21799C13.2843 1.40973 13.5903 1.7157 13.782 2.09202C13.9057 2.33469 13.9549 2.59304 13.9779 2.87409C14 3.14468 14 3.47686 14 3.87934V3.9V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H3.9H3.87934C3.47686 14 3.14468 14 2.87409 13.9779C2.59304 13.9549 2.33469 13.9057 2.09202 13.782C1.7157 13.5903 1.40973 13.2843 1.21799 12.908C1.09434 12.6653 1.04506 12.407 1.0221 12.1259C0.999989 11.8553 0.999994 11.5231 1 11.1207V11.1207V11.1V3.9V3.87935V3.87934C0.999994 3.47686 0.999989 3.14468 1.0221 2.87409C1.04506 2.59304 1.09434 2.33469 1.21799 2.09202C1.40973 1.7157 1.7157 1.40973 2.09202 1.21799C2.33469 1.09434 2.59304 1.04506 2.87409 1.0221C3.14469 0.999989 3.47687 0.999994 3.87935 1ZM2.95552 2.01878C2.73631 2.03669 2.62421 2.06915 2.54601 2.10899C2.35785 2.20487 2.20487 2.35785 2.10899 2.54601C2.06915 2.62421 2.03669 2.73631 2.01878 2.95552C2.00039 3.18056 2 3.47171 2 3.9V7H7V2H3.9C3.47171 2 3.18056 2.00039 2.95552 2.01878ZM7 8H2V11.1C2 11.5283 2.00039 11.8194 2.01878 12.0445C2.03669 12.2637 2.06915 12.3758 2.10899 12.454C2.20487 12.6422 2.35785 12.7951 2.54601 12.891C2.62421 12.9309 2.73631 12.9633 2.95552 12.9812C3.18056 12.9996 3.47171 13 3.9 13H7V8ZM8 8H13V11.1C13 11.5283 12.9996 11.8194 12.9812 12.0445C12.9633 12.2637 12.9309 12.3758 12.891 12.454C12.7951 12.6422 12.6422 12.7951 12.454 12.891C12.3758 12.9309 12.2637 12.9633 12.0445 12.9812C11.8194 12.9996 11.5283 13 11.1 13H8V8ZM13 7H8V2H11.1C11.5283 2 11.8194 2.00039 12.0445 2.01878C12.2637 2.03669 12.3758 2.06915 12.454 2.10899C12.6422 2.20487 12.7951 2.35785 12.891 2.54601C12.9309 2.62421 12.9633 2.73631 12.9812 2.95552C12.9996 3.18056 13 3.47171 13 3.9V7Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1b = (/* unused pure expression or super */ null && (["color"]));
var ComponentBooleanIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1b);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.85367 1.48956C7.65841 1.29429 7.34182 1.29429 7.14656 1.48956L1.48971 7.14641C1.29445 7.34167 1.29445 7.65825 1.48971 7.85352L7.14656 13.5104C7.34182 13.7056 7.65841 13.7056 7.85367 13.5104L13.5105 7.85352C13.7058 7.65825 13.7058 7.34167 13.5105 7.14641L7.85367 1.48956ZM7.5 2.55033L2.55037 7.49996L7.5 12.4496V2.55033Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1c = ["color"];
var ComponentInstanceIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1c);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.1465 1.48959C7.34176 1.29432 7.65835 1.29432 7.85361 1.48959L13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355L7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104L1.48965 7.85355C1.29439 7.65829 1.29439 7.3417 1.48965 7.14644L7.1465 1.48959ZM7.50005 2.55025L2.55031 7.49999L7.50005 12.4497L12.4498 7.49999L7.50005 2.55025Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1d = (/* unused pure expression or super */ null && (["color"]));
var ComponentNoneIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1d);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959L1.48965 7.14644C1.29439 7.3417 1.29439 7.65829 1.48965 7.85355L3.9645 10.3284L1.64644 12.6464C1.45118 12.8417 1.45118 13.1583 1.64644 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.6716 11.0355L7.1465 13.5104C7.34176 13.7057 7.65835 13.7057 7.85361 13.5104L13.5105 7.85355C13.7057 7.65829 13.7057 7.3417 13.5105 7.14644L11.0356 4.67154L13.3535 2.35355C13.5488 2.15829 13.5488 1.84171 13.3535 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.3285 3.96443L7.85361 1.48959ZM9.62135 4.67154L7.50005 2.55025L2.55031 7.49999L4.6716 9.62129L9.62135 4.67154ZM5.37871 10.3284L7.50005 12.4497L12.4498 7.49999L10.3285 5.37865L5.37871 10.3284Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1e = (/* unused pure expression or super */ null && (["color"]));
var ComponentPlaceholderIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1e);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M12.8034 7.14644C12.9986 6.95118 13.3152 6.95118 13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355C13.3152 8.04881 12.9986 8.04881 12.8034 7.85355C12.6081 7.65828 12.6081 7.3417 12.8034 7.14644ZM12.0962 8.56065C12.2915 8.75592 12.2915 9.0725 12.0962 9.26776C11.901 9.46302 11.5844 9.46302 11.3891 9.26776C11.1939 9.0725 11.1939 8.75592 11.3891 8.56065C11.5844 8.36539 11.901 8.36539 12.0962 8.56065ZM10.682 9.97487C10.8773 10.1701 10.8773 10.4867 10.682 10.682C10.4868 10.8772 10.1702 10.8772 9.97493 10.682C9.77967 10.4867 9.77967 10.1701 9.97493 9.97487C10.1702 9.7796 10.4868 9.7796 10.682 9.97487ZM9.26782 11.3891C9.46308 11.5843 9.46308 11.9009 9.26782 12.0962C9.07256 12.2915 8.75598 12.2915 8.56071 12.0962C8.36545 11.9009 8.36545 11.5843 8.56072 11.3891C8.75598 11.1938 9.07256 11.1938 9.26782 11.3891ZM7.1465 13.5104C6.95124 13.3151 6.95124 12.9986 7.1465 12.8033C7.17091 12.7789 7.19721 12.7575 7.22494 12.7392C7.41901 12.6111 7.68275 12.6324 7.85361 12.8033C8.04887 12.9986 8.04887 13.3151 7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    d: "M2.90386 8.56065C2.7086 8.75592 2.7086 9.0725 2.90386 9.26776 3.09912 9.46302 3.41571 9.46302 3.61097 9.26776 3.80623 9.0725 3.80623 8.75592 3.61097 8.56065 3.41571 8.36539 3.09912 8.36539 2.90386 8.56065zM4.31807 9.97487C4.12281 10.1701 4.12281 10.4867 4.31807 10.682 4.51334 10.8772 4.82992 10.8772 5.02518 10.682 5.22044 10.4867 5.22044 10.1701 5.02518 9.97487 4.82992 9.7796 4.51334 9.7796 4.31807 9.97487zM5.73229 11.3891C5.53703 11.5843 5.53703 11.9009 5.73229 12.0962 5.92755 12.2914 6.24413 12.2915 6.43939 12.0962 6.63466 11.9009 6.63466 11.5843 6.43939 11.3891 6.24413 11.1938 5.92755 11.1938 5.73229 11.3891zM2.19675 7.85355C2.36761 7.68269 2.38897 7.41895 2.26082 7.22488 2.09046 6.96684 1.71063 6.92546 1.48965 7.14644 1.29439 7.3417 1.29439 7.65829 1.48965 7.85355 1.68491 8.04881 2.00149 8.04881 2.19675 7.85355zM3.61097 5.73223C3.41571 5.53696 3.09912 5.53696 2.90386 5.73223 2.7086 5.92749 2.7086 6.24407 2.90386 6.43933 3.09912 6.6346 3.41571 6.6346 3.61097 6.43933 3.80623 6.24407 3.80623 5.92749 3.61097 5.73223zM5.02518 4.31801C4.82992 4.12275 4.51334 4.12275 4.31807 4.31801 4.12281 4.51328 4.12281 4.82986 4.31807 5.02512 4.51334 5.22038 4.82992 5.22038 5.02518 5.02512 5.22044 4.82986 5.22044 4.51328 5.02518 4.31801zM6.43939 2.9038C6.24413 2.70854 5.92755 2.70854 5.73229 2.9038 5.53703 3.09906 5.53703 3.41564 5.73229 3.61091 5.92755 3.80617 6.24413 3.80617 6.43939 3.61091 6.63466 3.41564 6.63466 3.09906 6.43939 2.9038zM7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959 6.95124 1.68485 6.95124 2.00143 7.1465 2.19669 7.34176 2.39196 7.65835 2.39196 7.85361 2.19669 8.04887 2.00143 8.04887 1.68485 7.85361 1.48959zM9.26782 2.9038C9.07256 2.70854 8.75598 2.70854 8.56071 2.9038 8.36545 3.09906 8.36545 3.41564 8.56071 3.61091 8.75598 3.80617 9.07256 3.80617 9.26782 3.61091 9.46308 3.41564 9.46308 3.09906 9.26782 2.9038zM10.682 4.31801C10.4868 4.12275 10.1702 4.12275 9.97493 4.31801 9.77967 4.51328 9.77967 4.82986 9.97493 5.02512 10.1702 5.22038 10.4868 5.22038 10.682 5.02512 10.8773 4.82986 10.8773 4.51328 10.682 4.31801zM12.0962 5.73223C11.901 5.53696 11.5844 5.53696 11.3891 5.73223 11.1939 5.92749 11.1939 6.24407 11.3891 6.43933 11.5844 6.6346 11.901 6.6346 12.0962 6.43933 12.2915 6.24407 12.2915 5.92749 12.0962 5.73223z",
    fill: color
  }));
})));

var _excluded$1f = ["color"];
var ContainerIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1f);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM5 13H10V2L5 2L5 13ZM4 13C4 13.5523 4.44772 14 5 14H10C10.5523 14 11 13.5523 11 13V2C11 1.44772 10.5523 1 10 1H5C4.44772 1 4 1.44771 4 2V13ZM13.5 2C13.7761 2 14 1.77614 14 1.5C14 1.22386 13.7761 1 13.5 1C13.2239 1 13 1.22386 13 1.5C13 1.77614 13.2239 2 13.5 2ZM2 3.5C2 3.77614 1.77614 4 1.5 4C1.22386 4 1 3.77614 1 3.5C1 3.22386 1.22386 3 1.5 3C1.77614 3 2 3.22386 2 3.5ZM13.5 4C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3C13.2239 3 13 3.22386 13 3.5C13 3.77614 13.2239 4 13.5 4ZM2 5.5C2 5.77614 1.77614 6 1.5 6C1.22386 6 1 5.77614 1 5.5C1 5.22386 1.22386 5 1.5 5C1.77614 5 2 5.22386 2 5.5ZM13.5 6C13.7761 6 14 5.77614 14 5.5C14 5.22386 13.7761 5 13.5 5C13.2239 5 13 5.22386 13 5.5C13 5.77614 13.2239 6 13.5 6ZM2 7.5C2 7.77614 1.77614 8 1.5 8C1.22386 8 1 7.77614 1 7.5C1 7.22386 1.22386 7 1.5 7C1.77614 7 2 7.22386 2 7.5ZM13.5 8C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7C13.2239 7 13 7.22386 13 7.5C13 7.77614 13.2239 8 13.5 8ZM2 9.5C2 9.77614 1.77614 10 1.5 10C1.22386 10 1 9.77614 1 9.5C1 9.22386 1.22386 9 1.5 9C1.77614 9 2 9.22386 2 9.5ZM13.5 10C13.7761 10 14 9.77614 14 9.5C14 9.22386 13.7761 9 13.5 9C13.2239 9 13 9.22386 13 9.5C13 9.77614 13.2239 10 13.5 10ZM2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5ZM13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12ZM2 13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5C1 13.2239 1.22386 13 1.5 13C1.77614 13 2 13.2239 2 13.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1g = ["color"];
var CookieIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1g);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M12.0697 1.76746C12.4807 1.21947 11.4605 0.454311 11.0495 1.0023C10.6385 1.55028 11.6588 2.31544 12.0697 1.76746ZM8.39263 1.07811C7.15585 0.950602 5.7823 1.16348 4.58433 1.70937C3.38552 2.25563 2.32735 3.15309 1.78844 4.41832C1.37574 5.38724 1.01715 6.28113 1.00088 7.44354C0.984724 8.59844 1.30522 9.96898 2.13174 11.928C2.61142 13.0649 4.03963 13.5446 5.13895 13.8079C6.40836 14.1119 7.80857 14.1914 8.6644 14.0742C9.36515 13.9782 10.1448 13.8284 10.7987 13.297C11.8977 12.4039 12.9009 11.3955 13.4994 10.3393C14.104 9.27221 14.3256 8.09207 13.7216 6.95324C13.5628 6.65373 13.316 6.57734 13.0412 6.4923C12.9374 6.46016 12.8295 6.42678 12.7209 6.37966C11.6211 5.90234 10.9646 5.34963 10.9135 5.02876C10.8656 4.72808 10.9221 4.51463 10.9811 4.29181C11.0129 4.17199 11.0453 4.04947 11.0626 3.90922C11.0838 3.73737 11.0814 3.33319 10.6996 3.12761C10.4048 2.96888 10.2164 2.65843 10.0407 2.36904C9.99742 2.29775 9.95492 2.22773 9.9118 2.16158C9.62634 1.72367 9.20769 1.16213 8.39263 1.07811ZM4.99899 2.61935C3.96483 3.09058 3.12554 3.83097 2.70846 4.81018C2.29808 5.77368 2.01406 6.50873 2.00079 7.45753C1.98741 8.41385 2.25043 9.6368 3.0531 11.5393C3.39181 12.3421 4.62167 12.6557 5.37186 12.8354C6.5493 13.1174 7.822 13.1802 8.52868 13.0834C9.21271 12.9897 9.74568 12.8642 10.1681 12.5209C11.229 11.6587 12.121 10.7435 12.6293 9.84635C12.9349 9.30709 13.5141 7.7028 12.6292 7.3873C10.7539 6.71875 10.262 6.06669 9.99011 5.41268C9.80915 4.97744 9.82868 4.52282 9.95741 4.07885L9.95741 4.07884C9.97662 4.0126 9.99538 3.94791 10.0334 3.88882C9.81857 3.73676 9.6515 3.55195 9.51464 3.3715C9.42876 3.25828 9.3469 3.12099 9.26197 2.97856C9.01866 2.57052 8.75018 2.12027 8.29008 2.07283C7.22889 1.96343 6.03398 2.14772 4.99899 2.61935ZM13.2081 3.77471C13.441 3.22671 12.4547 2.63606 12.0822 3.10163C11.5817 3.72732 12.9029 4.49281 13.2081 3.77471ZM14.3672 2.26031C14.9668 2.27493 15.1551 1.11603 14.5718 0.949371C13.8076 0.731026 13.5918 2.24139 14.3672 2.26031ZM14.2857 5.09098C14.8644 5.10004 15.0462 4.38222 14.4832 4.27899C13.7455 4.14375 13.5373 5.07927 14.2857 5.09098ZM6.9075 4.28672C6.46898 4.66754 6.0522 4.15185 5.97983 3.7365C5.86848 3.09744 6.33696 2.56856 6.94823 2.91156C7.43344 3.18382 7.26678 3.97471 6.9075 4.28672ZM4.94455 5.88184C5.40885 5.41754 4.59567 4.57013 4.11425 5.05154C3.83338 5.33242 4.00936 5.65376 4.23744 5.88184C4.43271 6.0771 4.74929 6.0771 4.94455 5.88184ZM6.97716 6.71984C7.31181 7.38914 8.48804 6.79159 7.99413 6.14788C7.86519 5.97983 7.68657 5.9494 7.62145 5.94207C7.21217 5.89601 6.76349 6.2925 6.97716 6.71984ZM6.98798 8.72461C7.14066 9.1188 7.51122 9.3187 7.91915 9.1633C8.27434 9.02799 8.33186 8.39689 8.17175 8.07427C8.02331 7.77514 7.63956 7.67793 7.33747 7.79417C6.98512 7.92976 6.85672 8.38708 6.98576 8.71889L6.98798 8.72461ZM10.3885 8.84081C10.7575 8.6566 11.4617 8.82771 11.4617 9.31199C11.4617 9.71286 10.9587 10.2165 10.5634 10.2826C10.1813 10.3465 9.70515 9.97581 9.76648 9.57718C9.81445 9.26539 10.1217 8.97401 10.3885 8.84081ZM7.56704 10.8432C7.33461 10.7502 7.14353 10.8601 7.11437 10.8769L7.11279 10.8778C6.90782 10.9949 6.71383 11.2439 6.6747 11.4842C6.59018 12.0034 7.13199 12.1239 7.52661 12.0987C8.2074 12.0553 8.06547 11.0426 7.56704 10.8432ZM4.8805 10.8932C5.0674 10.7723 5.15658 10.5363 5.08293 10.3153C4.93046 9.79687 4.3246 9.71252 3.96561 10.1297C3.79336 10.3299 3.80749 10.6274 3.99214 10.8105L3.99495 10.814L3.9979 10.8176C4.22025 11.0942 4.63624 11.1857 4.8805 10.8932ZM3.04695 7.81318C3.33147 8.0977 3.60077 8.15067 3.98443 8.05859C4.60826 7.90887 4.13814 6.24299 3.047 6.87296C2.70939 7.06788 2.86716 7.63339 3.04695 7.81318Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1h = ["color"];
var CopyIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1h);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V4.00002H5.5C4.67158 4.00002 4 4.67159 4 5.50002V12.5C4 13.3284 4.67158 14 5.5 14H12.5C13.3284 14 14 13.3284 14 12.5V5.50002C14 4.67159 13.3284 4.00002 12.5 4.00002H11V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM5 5.50002C5 5.22388 5.22386 5.00002 5.5 5.00002H12.5C12.7761 5.00002 13 5.22388 13 5.50002V12.5C13 12.7762 12.7761 13 12.5 13H5.5C5.22386 13 5 12.7762 5 12.5V5.50002Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1i = (/* unused pure expression or super */ null && (["color"]));
var CornerBottomLeftIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1i);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M9.87737 12H9.9H11.5C11.7761 12 12 11.7761 12 11.5C12 11.2239 11.7761 11 11.5 11H9.9C8.77164 11 7.95545 10.9996 7.31352 10.9472C6.67744 10.8952 6.25662 10.7946 5.91103 10.6185C5.25247 10.283 4.71703 9.74753 4.38148 9.08897C4.20539 8.74338 4.10481 8.32256 4.05284 7.68648C4.00039 7.04455 4 6.22836 4 5.1V3.5C4 3.22386 3.77614 3 3.5 3C3.22386 3 3 3.22386 3 3.5V5.1V5.12263C3 6.22359 3 7.08052 3.05616 7.76791C3.11318 8.46584 3.23058 9.0329 3.49047 9.54296C3.9219 10.3897 4.61031 11.0781 5.45704 11.5095C5.9671 11.7694 6.53416 11.8868 7.23209 11.9438C7.91948 12 8.77641 12 9.87737 12Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1j = (/* unused pure expression or super */ null && (["color"]));
var CornerBottomRightIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1j);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M5.12263 12H5.1H3.5C3.22386 12 3 11.7761 3 11.5C3 11.2239 3.22386 11 3.5 11H5.1C6.22836 11 7.04455 10.9996 7.68648 10.9472C8.32256 10.8952 8.74338 10.7946 9.08897 10.6185C9.74753 10.283 10.283 9.74753 10.6185 9.08897C10.7946 8.74338 10.8952 8.32256 10.9472 7.68648C10.9996 7.04455 11 6.22836 11 5.1V3.5C11 3.22386 11.2239 3 11.5 3C11.7761 3 12 3.22386 12 3.5V5.1V5.12263C12 6.22359 12 7.08052 11.9438 7.76791C11.8868 8.46584 11.7694 9.0329 11.5095 9.54296C11.0781 10.3897 10.3897 11.0781 9.54296 11.5095C9.0329 11.7694 8.46584 11.8868 7.76791 11.9438C7.08052 12 6.22359 12 5.12263 12Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1k = (/* unused pure expression or super */ null && (["color"]));
var CornerTopLeftIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1k);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M9.87737 3H9.9H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H9.9C8.77164 4 7.95545 4.00039 7.31352 4.05284C6.67744 4.10481 6.25662 4.20539 5.91103 4.38148C5.25247 4.71703 4.71703 5.25247 4.38148 5.91103C4.20539 6.25662 4.10481 6.67744 4.05284 7.31352C4.00039 7.95545 4 8.77164 4 9.9V11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5V9.9V9.87737C3 8.77641 3 7.91948 3.05616 7.23209C3.11318 6.53416 3.23058 5.9671 3.49047 5.45704C3.9219 4.61031 4.61031 3.9219 5.45704 3.49047C5.9671 3.23058 6.53416 3.11318 7.23209 3.05616C7.91948 3 8.77641 3 9.87737 3Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1l = (/* unused pure expression or super */ null && (["color"]));
var CornerTopRightIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1l);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M5.12263 3H5.1H3.5C3.22386 3 3 3.22386 3 3.5C3 3.77614 3.22386 4 3.5 4H5.1C6.22836 4 7.04455 4.00039 7.68648 4.05284C8.32256 4.10481 8.74338 4.20539 9.08897 4.38148C9.74753 4.71703 10.283 5.25247 10.6185 5.91103C10.7946 6.25662 10.8952 6.67744 10.9472 7.31352C10.9996 7.95545 11 8.77164 11 9.9V11.5C11 11.7761 11.2239 12 11.5 12C11.7761 12 12 11.7761 12 11.5V9.9V9.87737C12 8.77641 12 7.91948 11.9438 7.23209C11.8868 6.53416 11.7694 5.9671 11.5095 5.45704C11.0781 4.61031 10.3897 3.9219 9.54296 3.49047C9.0329 3.23058 8.46584 3.11318 7.76791 3.05616C7.08052 3 6.22359 3 5.12263 3Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1m = ["color"];
var CornersIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1m);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M5.5 2L4.87935 2C4.47687 1.99999 4.14469 1.99999 3.87409 2.0221C3.59304 2.04506 3.33469 2.09434 3.09202 2.21799C2.7157 2.40973 2.40973 2.7157 2.21799 3.09202C2.09434 3.33469 2.04506 3.59304 2.0221 3.87409C1.99999 4.14468 1.99999 4.47686 2 4.87933V4.87935V5.5C2 5.77614 2.22386 6 2.5 6C2.77614 6 3 5.77614 3 5.5V4.9C3 4.47171 3.00039 4.18056 3.01878 3.95552C3.03669 3.73631 3.06915 3.62421 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.62421 3.06915 3.73631 3.03669 3.95552 3.01878C4.18056 3.00039 4.47171 3 4.9 3H5.5C5.77614 3 6 2.77614 6 2.5C6 2.22386 5.77614 2 5.5 2ZM13 9.5C13 9.22386 12.7761 9 12.5 9C12.2239 9 12 9.22386 12 9.5V10.1C12 10.5283 11.9996 10.8194 11.9812 11.0445C11.9633 11.2637 11.9309 11.3758 11.891 11.454C11.7951 11.6422 11.6422 11.7951 11.454 11.891C11.3758 11.9309 11.2637 11.9633 11.0445 11.9812C10.8194 11.9996 10.5283 12 10.1 12H9.5C9.22386 12 9 12.2239 9 12.5C9 12.7761 9.22386 13 9.5 13H10.1206C10.5231 13 10.8553 13 11.1259 12.9779C11.407 12.9549 11.6653 12.9057 11.908 12.782C12.2843 12.5903 12.5903 12.2843 12.782 11.908C12.9057 11.6653 12.9549 11.407 12.9779 11.1259C13 10.8553 13 10.5232 13 10.1207V10.1207V10.1207V10.1206V9.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V10.1C3 10.5283 3.00039 10.8194 3.01878 11.0445C3.03669 11.2637 3.06915 11.3758 3.10899 11.454C3.20487 11.6422 3.35785 11.7951 3.54601 11.891C3.62421 11.9309 3.73631 11.9633 3.95552 11.9812C4.18056 11.9996 4.47171 12 4.9 12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H4.87935C4.47687 13 4.14469 13 3.87409 12.9779C3.59304 12.9549 3.33469 12.9057 3.09202 12.782C2.7157 12.5903 2.40973 12.2843 2.21799 11.908C2.09434 11.6653 2.04506 11.407 2.0221 11.1259C1.99999 10.8553 1.99999 10.5231 2 10.1207V10.1206V10.1V9.5C2 9.22386 2.22386 9 2.5 9ZM10.1 3C10.5283 3 10.8194 3.00039 11.0445 3.01878C11.2637 3.03669 11.3758 3.06915 11.454 3.10899C11.6422 3.20487 11.7951 3.35785 11.891 3.54601C11.9309 3.62421 11.9633 3.73631 11.9812 3.95552C11.9996 4.18056 12 4.47171 12 4.9V5.5C12 5.77614 12.2239 6 12.5 6C12.7761 6 13 5.77614 13 5.5V4.87935V4.87934C13 4.47686 13 4.14468 12.9779 3.87409C12.9549 3.59304 12.9057 3.33469 12.782 3.09202C12.5903 2.7157 12.2843 2.40973 11.908 2.21799C11.6653 2.09434 11.407 2.04506 11.1259 2.0221C10.8553 1.99999 10.5231 1.99999 10.1206 2L10.1 2H9.5C9.22386 2 9 2.22386 9 2.5C9 2.77614 9.22386 3 9.5 3H10.1Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1n = (/* unused pure expression or super */ null && (["color"]));
var CountdownTimerIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1n);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.7217 1.84998 3.34851 3.90636 2.76336 4.99997H4.5C4.77614 4.99997 5 5.22383 5 5.49997C5 5.77611 4.77614 5.99997 4.5 5.99997H1.5C1.22386 5.99997 1 5.77611 1 5.49997V2.49997C1 2.22383 1.22386 1.99997 1.5 1.99997C1.77614 1.99997 2 2.22383 2 2.49997V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7 10V5.00001H8V10H7Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1o = (/* unused pure expression or super */ null && (["color"]));
var CounterClockwiseClockIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1o);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.72167 1.84998 3.34849 3.9064 2.76335 5H4.5C4.77614 5 5 5.22386 5 5.5C5 5.77614 4.77614 6 4.5 6H1.5C1.22386 6 1 5.77614 1 5.5V2.5C1 2.22386 1.22386 2 1.5 2C1.77614 2 2 2.22386 2 2.5V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7.5 4.00001C7.77614 4.00001 8 4.22387 8 4.50001V7.29291L9.85355 9.14646C10.0488 9.34172 10.0488 9.65831 9.85355 9.85357C9.65829 10.0488 9.34171 10.0488 9.14645 9.85357L7.14645 7.85357C7.05268 7.7598 7 7.63262 7 7.50001V4.50001C7 4.22387 7.22386 4.00001 7.5 4.00001Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1p = (/* unused pure expression or super */ null && (["color"]));
var CropIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1p);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.5 8.00684e-07C3.77614 7.88614e-07 4 0.223859 4 0.500001L4 3.00006L11.5 3.00006C11.7761 3.00006 12 3.22392 12 3.50006L12 11.0001L14.5 11C14.7761 11 15 11.2238 15 11.5C15 11.7761 14.7762 12 14.5 12L12 12.0001L12 14.5C12 14.7761 11.7761 15 11.5 15C11.2239 15 11 14.7761 11 14.5L11 12.0001L3.5 12.0001C3.22386 12.0001 3 11.7762 3 11.5001L3 4.00005L0.499989 4C0.223847 4 -6.10541e-06 3.77613 -5.02576e-07 3.49999C5.13006e-06 3.22385 0.223867 3 0.50001 3L3 3.00005L3 0.500001C3 0.223859 3.22386 8.12755e-07 3.5 8.00684e-07ZM4 4.00006L4 11.0001L11 11.0001L11 4.00006L4 4.00006Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1q = (/* unused pure expression or super */ null && (["color"]));
var Cross1Icon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1q);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M12.8536 2.85355C13.0488 2.65829 13.0488 2.34171 12.8536 2.14645C12.6583 1.95118 12.3417 1.95118 12.1464 2.14645L7.5 6.79289L2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95118 2.34171 1.95118 2.65829 2.14645 2.85355L6.79289 7.5L2.14645 12.1464C1.95118 12.3417 1.95118 12.6583 2.14645 12.8536C2.34171 13.0488 2.65829 13.0488 2.85355 12.8536L7.5 8.20711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.20711 7.5L12.8536 2.85355Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1r = ["color"];
var Cross2Icon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1r);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1s = ["color"];
var CrossCircledIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1s);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704ZM9.85358 5.14644C10.0488 5.3417 10.0488 5.65829 9.85358 5.85355L8.20713 7.49999L9.85358 9.14644C10.0488 9.3417 10.0488 9.65829 9.85358 9.85355C9.65832 10.0488 9.34173 10.0488 9.14647 9.85355L7.50002 8.2071L5.85358 9.85355C5.65832 10.0488 5.34173 10.0488 5.14647 9.85355C4.95121 9.65829 4.95121 9.3417 5.14647 9.14644L6.79292 7.49999L5.14647 5.85355C4.95121 5.65829 4.95121 5.3417 5.14647 5.14644C5.34173 4.95118 5.65832 4.95118 5.85358 5.14644L7.50002 6.79289L9.14647 5.14644C9.34173 4.95118 9.65832 4.95118 9.85358 5.14644Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1t = (/* unused pure expression or super */ null && (["color"]));
var Crosshair1Icon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1t);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.877075 7.50207C0.877075 3.84319 3.84319 0.877075 7.50208 0.877075C11.1609 0.877075 14.1271 3.84319 14.1271 7.50207C14.1271 11.1609 11.1609 14.1271 7.50208 14.1271C3.84319 14.1271 0.877075 11.1609 0.877075 7.50207ZM1.84898 7.00003C2.0886 4.26639 4.26639 2.0886 7.00003 1.84898V4.50003C7.00003 4.77617 7.22388 5.00003 7.50003 5.00003C7.77617 5.00003 8.00003 4.77617 8.00003 4.50003V1.84862C10.7356 2.08643 12.9154 4.26502 13.1552 7.00003H10.5C10.2239 7.00003 10 7.22388 10 7.50003C10 7.77617 10.2239 8.00003 10.5 8.00003H13.1555C12.9176 10.7369 10.7369 12.9176 8.00003 13.1555V10.5C8.00003 10.2239 7.77617 10 7.50003 10C7.22388 10 7.00003 10.2239 7.00003 10.5V13.1552C4.26502 12.9154 2.08643 10.7356 1.84862 8.00003H4.50003C4.77617 8.00003 5.00003 7.77617 5.00003 7.50003C5.00003 7.22388 4.77617 7.00003 4.50003 7.00003H1.84898Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1u = (/* unused pure expression or super */ null && (["color"]));
var Crosshair2Icon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1u);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V1.80687C10.6922 2.0935 12.8167 4.28012 13.0068 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H12.9888C12.7094 10.6244 10.6244 12.7094 8 12.9888V14.5C8 14.7761 7.77614 15 7.5 15C7.22386 15 7 14.7761 7 14.5V13.0068C4.28012 12.8167 2.0935 10.6922 1.80687 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H1.78886C1.98376 4.21166 4.21166 1.98376 7 1.78886V0.5C7 0.223858 7.22386 0 7.5 0ZM8 12.0322V9.5C8 9.22386 7.77614 9 7.5 9C7.22386 9 7 9.22386 7 9.5V12.054C4.80517 11.8689 3.04222 10.1668 2.76344 8H5.5C5.77614 8 6 7.77614 6 7.5C6 7.22386 5.77614 7 5.5 7H2.7417C2.93252 4.73662 4.73662 2.93252 7 2.7417V5.5C7 5.77614 7.22386 6 7.5 6C7.77614 6 8 5.77614 8 5.5V2.76344C10.1668 3.04222 11.8689 4.80517 12.054 7H9.5C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8H12.0322C11.7621 10.0991 10.0991 11.7621 8 12.0322Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1v = (/* unused pure expression or super */ null && (["color"]));
var CrumpledPaperIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1v);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4.60913 0.0634287C4.39082 0.0088505 4.16575 0.12393 4.08218 0.332867L3.1538 2.6538L0.832866 3.58218C0.702884 3.63417 0.604504 3.7437 0.566705 3.87849C0.528906 4.01329 0.555994 4.158 0.639992 4.26999L2.01148 6.09864L1.06343 9.89085C1.00944 10.1068 1.12145 10.3298 1.32691 10.4154L4.20115 11.613L5.62557 13.7496C5.73412 13.9124 5.93545 13.9864 6.12362 13.9327L9.62362 12.9327C9.62988 12.9309 9.63611 12.929 9.64229 12.9269L12.6423 11.9269C12.7923 11.8769 12.905 11.7519 12.9393 11.5976L13.9393 7.09761C13.9776 6.92506 13.9114 6.74605 13.77 6.63999L11.95 5.27499V2.99999C11.95 2.82955 11.8537 2.67373 11.7012 2.5975L8.70124 1.0975C8.67187 1.08282 8.64098 1.07139 8.60913 1.06343L4.60913 0.0634287ZM11.4323 6.01173L12.7748 7.01858L10.2119 9.15429C10.1476 9.20786 10.0995 9.2783 10.0731 9.35769L9.25382 11.8155L7.73849 10.8684C7.52774 10.7367 7.25011 10.8007 7.11839 11.0115C6.98667 11.2222 7.05074 11.4999 7.26149 11.6316L8.40341 12.3453L6.19221 12.9771L4.87441 11.0004C4.82513 10.9265 4.75508 10.8688 4.67307 10.8346L2.03046 9.73352L2.85134 6.44999H4.99999C5.24852 6.44999 5.44999 6.24852 5.44999 5.99999C5.44999 5.75146 5.24852 5.54999 4.99999 5.54999H2.72499L1.7123 4.19974L3.51407 3.47903L6.35769 4.4269C6.53655 4.48652 6.73361 4.42832 6.85138 4.28111L8.62413 2.06518L11.05 3.27811V5.19533L8.83287 6.08218C8.70996 6.13134 8.61494 6.23212 8.57308 6.35769L8.07308 7.85769C7.99449 8.09346 8.12191 8.34831 8.35769 8.4269C8.59346 8.50549 8.84831 8.37807 8.9269 8.14229L9.3609 6.84029L11.4323 6.01173ZM7.71052 1.76648L6.34462 3.47386L4.09505 2.724L4.77192 1.03183L7.71052 1.76648ZM10.2115 11.7885L12.116 11.1537L12.7745 8.19034L10.8864 9.76374L10.2115 11.7885Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1w = ["color"];
var CubeIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1w);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1x = ["color"];
var CursorArrowIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1x);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.29227 0.048984C3.47033 -0.032338 3.67946 -0.00228214 3.8274 0.125891L12.8587 7.95026C13.0134 8.08432 13.0708 8.29916 13.0035 8.49251C12.9362 8.68586 12.7578 8.81866 12.5533 8.82768L9.21887 8.97474L11.1504 13.2187C11.2648 13.47 11.1538 13.7664 10.9026 13.8808L8.75024 14.8613C8.499 14.9758 8.20255 14.8649 8.08802 14.6137L6.15339 10.3703L3.86279 12.7855C3.72196 12.934 3.50487 12.9817 3.31479 12.9059C3.1247 12.8301 3 12.6461 3 12.4414V0.503792C3 0.308048 3.11422 0.130306 3.29227 0.048984ZM4 1.59852V11.1877L5.93799 9.14425C6.05238 9.02363 6.21924 8.96776 6.38319 8.99516C6.54715 9.02256 6.68677 9.12965 6.75573 9.2809L8.79056 13.7441L10.0332 13.178L8.00195 8.71497C7.93313 8.56376 7.94391 8.38824 8.03072 8.24659C8.11753 8.10494 8.26903 8.01566 8.435 8.00834L11.2549 7.88397L4 1.59852Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1y = (/* unused pure expression or super */ null && (["color"]));
var CursorTextIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1y);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2C5.42215 2 6.0399 2.23054 6.42075 2.56379C6.79286 2.88939 7 3.36626 7 4V7H5.75C5.47386 7 5.25 7.22386 5.25 7.5C5.25 7.77614 5.47386 8 5.75 8H7V11C7 11.6337 6.79286 12.1106 6.42075 12.4362C6.0399 12.7695 5.42215 13 4.5 13C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14C5.57785 14 6.4601 13.7305 7.07925 13.1888C7.24168 13.0467 7.38169 12.8896 7.5 12.7198C7.61832 12.8896 7.75832 13.0467 7.92075 13.1888C8.5399 13.7305 9.42215 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.57785 13 8.9601 12.7695 8.57925 12.4362C8.20714 12.1106 8 11.6337 8 11V8H9.25C9.52614 8 9.75 7.77614 9.75 7.5C9.75 7.22386 9.52614 7 9.25 7H8V4C8 3.36626 8.20714 2.88939 8.57925 2.56379C8.9601 2.23054 9.57785 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.42215 1 8.5399 1.26946 7.92075 1.81121C7.75832 1.95333 7.61832 2.11043 7.5 2.28023C7.38168 2.11043 7.24168 1.95333 7.07925 1.81121C6.4601 1.26946 5.57785 1 4.5 1Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1z = (/* unused pure expression or super */ null && (["color"]));
var DashIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1z);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M5 7.5C5 7.22386 5.22386 7 5.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H5.5C5.22386 8 5 7.77614 5 7.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1A = ["color"];
var DashboardIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1A);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2.8 1L2.74967 0.99997C2.52122 0.999752 2.32429 0.999564 2.14983 1.04145C1.60136 1.17312 1.17312 1.60136 1.04145 2.14983C0.999564 2.32429 0.999752 2.52122 0.99997 2.74967L1 2.8V5.2L0.99997 5.25033C0.999752 5.47878 0.999564 5.67572 1.04145 5.85017C1.17312 6.39864 1.60136 6.82688 2.14983 6.95856C2.32429 7.00044 2.52122 7.00025 2.74967 7.00003L2.8 7H5.2L5.25033 7.00003C5.47878 7.00025 5.67572 7.00044 5.85017 6.95856C6.39864 6.82688 6.82688 6.39864 6.95856 5.85017C7.00044 5.67572 7.00025 5.47878 7.00003 5.25033L7 5.2V2.8L7.00003 2.74967C7.00025 2.52122 7.00044 2.32429 6.95856 2.14983C6.82688 1.60136 6.39864 1.17312 5.85017 1.04145C5.67572 0.999564 5.47878 0.999752 5.25033 0.99997L5.2 1H2.8ZM2.38328 2.01382C2.42632 2.00348 2.49222 2 2.8 2H5.2C5.50779 2 5.57369 2.00348 5.61672 2.01382C5.79955 2.05771 5.94229 2.20045 5.98619 2.38328C5.99652 2.42632 6 2.49222 6 2.8V5.2C6 5.50779 5.99652 5.57369 5.98619 5.61672C5.94229 5.79955 5.79955 5.94229 5.61672 5.98619C5.57369 5.99652 5.50779 6 5.2 6H2.8C2.49222 6 2.42632 5.99652 2.38328 5.98619C2.20045 5.94229 2.05771 5.79955 2.01382 5.61672C2.00348 5.57369 2 5.50779 2 5.2V2.8C2 2.49222 2.00348 2.42632 2.01382 2.38328C2.05771 2.20045 2.20045 2.05771 2.38328 2.01382ZM9.8 1L9.74967 0.99997C9.52122 0.999752 9.32429 0.999564 9.14983 1.04145C8.60136 1.17312 8.17312 1.60136 8.04145 2.14983C7.99956 2.32429 7.99975 2.52122 7.99997 2.74967L8 2.8V5.2L7.99997 5.25033C7.99975 5.47878 7.99956 5.67572 8.04145 5.85017C8.17312 6.39864 8.60136 6.82688 9.14983 6.95856C9.32429 7.00044 9.52122 7.00025 9.74967 7.00003L9.8 7H12.2L12.2503 7.00003C12.4788 7.00025 12.6757 7.00044 12.8502 6.95856C13.3986 6.82688 13.8269 6.39864 13.9586 5.85017C14.0004 5.67572 14.0003 5.47878 14 5.25033L14 5.2V2.8L14 2.74967C14.0003 2.52122 14.0004 2.32429 13.9586 2.14983C13.8269 1.60136 13.3986 1.17312 12.8502 1.04145C12.6757 0.999564 12.4788 0.999752 12.2503 0.99997L12.2 1H9.8ZM9.38328 2.01382C9.42632 2.00348 9.49222 2 9.8 2H12.2C12.5078 2 12.5737 2.00348 12.6167 2.01382C12.7995 2.05771 12.9423 2.20045 12.9862 2.38328C12.9965 2.42632 13 2.49222 13 2.8V5.2C13 5.50779 12.9965 5.57369 12.9862 5.61672C12.9423 5.79955 12.7995 5.94229 12.6167 5.98619C12.5737 5.99652 12.5078 6 12.2 6H9.8C9.49222 6 9.42632 5.99652 9.38328 5.98619C9.20045 5.94229 9.05771 5.79955 9.01382 5.61672C9.00348 5.57369 9 5.50779 9 5.2V2.8C9 2.49222 9.00348 2.42632 9.01382 2.38328C9.05771 2.20045 9.20045 2.05771 9.38328 2.01382ZM2.74967 7.99997L2.8 8H5.2L5.25033 7.99997C5.47878 7.99975 5.67572 7.99956 5.85017 8.04145C6.39864 8.17312 6.82688 8.60136 6.95856 9.14983C7.00044 9.32429 7.00025 9.52122 7.00003 9.74967L7 9.8V12.2L7.00003 12.2503C7.00025 12.4788 7.00044 12.6757 6.95856 12.8502C6.82688 13.3986 6.39864 13.8269 5.85017 13.9586C5.67572 14.0004 5.47878 14.0003 5.25033 14L5.2 14H2.8L2.74967 14C2.52122 14.0003 2.32429 14.0004 2.14983 13.9586C1.60136 13.8269 1.17312 13.3986 1.04145 12.8502C0.999564 12.6757 0.999752 12.4788 0.99997 12.2503L1 12.2V9.8L0.99997 9.74967C0.999752 9.52122 0.999564 9.32429 1.04145 9.14983C1.17312 8.60136 1.60136 8.17312 2.14983 8.04145C2.32429 7.99956 2.52122 7.99975 2.74967 7.99997ZM2.8 9C2.49222 9 2.42632 9.00348 2.38328 9.01382C2.20045 9.05771 2.05771 9.20045 2.01382 9.38328C2.00348 9.42632 2 9.49222 2 9.8V12.2C2 12.5078 2.00348 12.5737 2.01382 12.6167C2.05771 12.7995 2.20045 12.9423 2.38328 12.9862C2.42632 12.9965 2.49222 13 2.8 13H5.2C5.50779 13 5.57369 12.9965 5.61672 12.9862C5.79955 12.9423 5.94229 12.7995 5.98619 12.6167C5.99652 12.5737 6 12.5078 6 12.2V9.8C6 9.49222 5.99652 9.42632 5.98619 9.38328C5.94229 9.20045 5.79955 9.05771 5.61672 9.01382C5.57369 9.00348 5.50779 9 5.2 9H2.8ZM9.8 8L9.74967 7.99997C9.52122 7.99975 9.32429 7.99956 9.14983 8.04145C8.60136 8.17312 8.17312 8.60136 8.04145 9.14983C7.99956 9.32429 7.99975 9.52122 7.99997 9.74967L8 9.8V12.2L7.99997 12.2503C7.99975 12.4788 7.99956 12.6757 8.04145 12.8502C8.17312 13.3986 8.60136 13.8269 9.14983 13.9586C9.32429 14.0004 9.52122 14.0003 9.74967 14L9.8 14H12.2L12.2503 14C12.4788 14.0003 12.6757 14.0004 12.8502 13.9586C13.3986 13.8269 13.8269 13.3986 13.9586 12.8502C14.0004 12.6757 14.0003 12.4788 14 12.2503L14 12.2V9.8L14 9.74967C14.0003 9.52122 14.0004 9.32429 13.9586 9.14983C13.8269 8.60136 13.3986 8.17312 12.8502 8.04145C12.6757 7.99956 12.4788 7.99975 12.2503 7.99997L12.2 8H9.8ZM9.38328 9.01382C9.42632 9.00348 9.49222 9 9.8 9H12.2C12.5078 9 12.5737 9.00348 12.6167 9.01382C12.7995 9.05771 12.9423 9.20045 12.9862 9.38328C12.9965 9.42632 13 9.49222 13 9.8V12.2C13 12.5078 12.9965 12.5737 12.9862 12.6167C12.9423 12.7995 12.7995 12.9423 12.6167 12.9862C12.5737 12.9965 12.5078 13 12.2 13H9.8C9.49222 13 9.42632 12.9965 9.38328 12.9862C9.20045 12.9423 9.05771 12.7995 9.01382 12.6167C9.00348 12.5737 9 12.5078 9 12.2V9.8C9 9.49222 9.00348 9.42632 9.01382 9.38328C9.05771 9.20045 9.20045 9.05771 9.38328 9.01382Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1B = ["color"];
var DesktopIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1B);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1 3.25C1 3.11193 1.11193 3 1.25 3H13.75C13.8881 3 14 3.11193 14 3.25V10.75C14 10.8881 13.8881 11 13.75 11H1.25C1.11193 11 1 10.8881 1 10.75V3.25ZM1.25 2C0.559643 2 0 2.55964 0 3.25V10.75C0 11.4404 0.559644 12 1.25 12H5.07341L4.82991 13.2986C4.76645 13.6371 5.02612 13.95 5.37049 13.95H9.62951C9.97389 13.95 10.2336 13.6371 10.1701 13.2986L9.92659 12H13.75C14.4404 12 15 11.4404 15 10.75V3.25C15 2.55964 14.4404 2 13.75 2H1.25ZM9.01091 12H5.98909L5.79222 13.05H9.20778L9.01091 12Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1C = ["color"];
var DimensionsIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1C);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1D = (/* unused pure expression or super */ null && (["color"]));
var DiscIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1D);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM1.82708 7.49991C1.82708 4.36689 4.36689 1.82707 7.49991 1.82707C10.6329 1.82707 13.1727 4.36689 13.1727 7.49991C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49991ZM8.37287 7.50006C8.37287 7.98196 7.98221 8.37263 7.5003 8.37263C7.01839 8.37263 6.62773 7.98196 6.62773 7.50006C6.62773 7.01815 7.01839 6.62748 7.5003 6.62748C7.98221 6.62748 8.37287 7.01815 8.37287 7.50006ZM9.32287 7.50006C9.32287 8.50664 8.50688 9.32263 7.5003 9.32263C6.49372 9.32263 5.67773 8.50664 5.67773 7.50006C5.67773 6.49348 6.49372 5.67748 7.5003 5.67748C8.50688 5.67748 9.32287 6.49348 9.32287 7.50006Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1E = (/* unused pure expression or super */ null && (["color"]));
var DiscordLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1E);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07451 1.82584C5.03267 1.81926 4.99014 1.81825 4.94803 1.82284C4.10683 1.91446 2.82673 2.36828 2.07115 2.77808C2.02106 2.80525 1.97621 2.84112 1.93869 2.88402C1.62502 3.24266 1.34046 3.82836 1.11706 4.38186C0.887447 4.95076 0.697293 5.55032 0.588937 5.98354C0.236232 7.39369 0.042502 9.08728 0.0174948 10.6925C0.0162429 10.7729 0.0351883 10.8523 0.0725931 10.9234C0.373679 11.496 1.02015 12.027 1.66809 12.4152C2.32332 12.8078 3.08732 13.1182 3.70385 13.1778C3.85335 13.1922 4.00098 13.1358 4.10282 13.0255C4.2572 12.8581 4.5193 12.4676 4.71745 12.1643C4.80739 12.0267 4.89157 11.8953 4.95845 11.7901C5.62023 11.9106 6.45043 11.9801 7.50002 11.9801C8.54844 11.9801 9.37796 11.9107 10.0394 11.7905C10.1062 11.8957 10.1903 12.0269 10.2801 12.1643C10.4783 12.4676 10.7404 12.8581 10.8947 13.0255C10.9966 13.1358 11.1442 13.1922 11.2937 13.1778C11.9102 13.1182 12.6742 12.8078 13.3295 12.4152C13.9774 12.027 14.6239 11.496 14.925 10.9234C14.9624 10.8523 14.9813 10.7729 14.9801 10.6925C14.9551 9.08728 14.7613 7.39369 14.4086 5.98354C14.3003 5.55032 14.1101 4.95076 13.8805 4.38186C13.6571 3.82836 13.3725 3.24266 13.0589 2.88402C13.0214 2.84112 12.9765 2.80525 12.9264 2.77808C12.1708 2.36828 10.8907 1.91446 10.0495 1.82284C10.0074 1.81825 9.96489 1.81926 9.92305 1.82584C9.71676 1.85825 9.5391 1.96458 9.40809 2.06355C9.26977 2.16804 9.1413 2.29668 9.0304 2.42682C8.86968 2.61544 8.71437 2.84488 8.61428 3.06225C8.27237 3.03501 7.90138 3.02 7.5 3.02C7.0977 3.02 6.72593 3.03508 6.38337 3.06244C6.28328 2.84501 6.12792 2.61549 5.96716 2.42682C5.85626 2.29668 5.72778 2.16804 5.58947 2.06355C5.45846 1.96458 5.2808 1.85825 5.07451 1.82584ZM11.0181 11.5382C11.0395 11.5713 11.0615 11.6051 11.0838 11.6392C11.2169 11.843 11.3487 12.0385 11.4508 12.1809C11.8475 12.0916 12.352 11.8818 12.8361 11.5917C13.3795 11.2661 13.8098 10.8918 14.0177 10.5739C13.9852 9.06758 13.7993 7.50369 13.4773 6.21648C13.38 5.82759 13.2038 5.27021 12.9903 4.74117C12.7893 4.24326 12.5753 3.82162 12.388 3.5792C11.7376 3.24219 10.7129 2.88582 10.0454 2.78987C10.0308 2.79839 10.0113 2.81102 9.98675 2.82955C9.91863 2.881 9.84018 2.95666 9.76111 3.04945C9.71959 3.09817 9.68166 3.1471 9.64768 3.19449C9.953 3.25031 10.2253 3.3171 10.4662 3.39123C11.1499 3.6016 11.6428 3.89039 11.884 4.212C12.0431 4.42408 12.0001 4.72494 11.788 4.884C11.5759 5.04306 11.2751 5.00008 11.116 4.788C11.0572 4.70961 10.8001 4.4984 10.1838 4.30877C9.58933 4.12585 8.71356 3.98 7.5 3.98C6.28644 3.98 5.41067 4.12585 4.81616 4.30877C4.19988 4.4984 3.94279 4.70961 3.884 4.788C3.72494 5.00008 3.42408 5.04306 3.212 4.884C2.99992 4.72494 2.95694 4.42408 3.116 4.212C3.35721 3.89039 3.85011 3.6016 4.53383 3.39123C4.77418 3.31727 5.04571 3.25062 5.35016 3.19488C5.31611 3.14738 5.27808 3.09831 5.23645 3.04945C5.15738 2.95666 5.07893 2.881 5.01081 2.82955C4.98628 2.81102 4.96674 2.79839 4.95217 2.78987C4.28464 2.88582 3.25999 3.24219 2.60954 3.5792C2.42226 3.82162 2.20825 4.24326 2.00729 4.74117C1.79376 5.27021 1.61752 5.82759 1.52025 6.21648C1.19829 7.50369 1.01236 9.06758 0.97986 10.5739C1.18772 10.8918 1.61807 11.2661 2.16148 11.5917C2.64557 11.8818 3.15003 12.0916 3.5468 12.1809C3.64885 12.0385 3.78065 11.843 3.9138 11.6392C3.93626 11.6048 3.95838 11.5708 3.97996 11.5375C3.19521 11.2591 2.77361 10.8758 2.50064 10.4664C2.35359 10.2458 2.4132 9.94778 2.63377 9.80074C2.85435 9.65369 3.15236 9.71329 3.29941 9.93387C3.56077 10.3259 4.24355 11.0201 7.50002 11.0201C10.7565 11.0201 11.4392 10.326 11.7006 9.93386C11.8477 9.71329 12.1457 9.65369 12.3663 9.80074C12.5869 9.94779 12.6465 10.2458 12.4994 10.4664C12.2262 10.8762 11.8041 11.2598 11.0181 11.5382ZM4.08049 7.01221C4.32412 6.74984 4.65476 6.60162 5.00007 6.59998C5.34538 6.60162 5.67603 6.74984 5.91966 7.01221C6.16329 7.27459 6.30007 7.62974 6.30007 7.99998C6.30007 8.37021 6.16329 8.72536 5.91966 8.98774C5.67603 9.25011 5.34538 9.39833 5.00007 9.39998C4.65476 9.39833 4.32412 9.25011 4.08049 8.98774C3.83685 8.72536 3.70007 8.37021 3.70007 7.99998C3.70007 7.62974 3.83685 7.27459 4.08049 7.01221ZM9.99885 6.59998C9.65354 6.60162 9.3229 6.74984 9.07926 7.01221C8.83563 7.27459 8.69885 7.62974 8.69885 7.99998C8.69885 8.37021 8.83563 8.72536 9.07926 8.98774C9.3229 9.25011 9.65354 9.39833 9.99885 9.39998C10.3442 9.39833 10.6748 9.25011 10.9184 8.98774C11.1621 8.72536 11.2989 8.37021 11.2989 7.99998C11.2989 7.62974 11.1621 7.27459 10.9184 7.01221C10.6748 6.74984 10.3442 6.60162 9.99885 6.59998Z",
    fill: color
  }));
})));

var _excluded$1F = (/* unused pure expression or super */ null && (["color"]));
var DividerHorizontalIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1F);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1G = (/* unused pure expression or super */ null && (["color"]));
var DividerVerticalIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1G);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1H = ["color"];
var DotIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1H);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.5 9.125C8.39746 9.125 9.125 8.39746 9.125 7.5C9.125 6.60254 8.39746 5.875 7.5 5.875C6.60254 5.875 5.875 6.60254 5.875 7.5C5.875 8.39746 6.60254 9.125 7.5 9.125ZM7.5 10.125C8.94975 10.125 10.125 8.94975 10.125 7.5C10.125 6.05025 8.94975 4.875 7.5 4.875C6.05025 4.875 4.875 6.05025 4.875 7.5C4.875 8.94975 6.05025 10.125 7.5 10.125Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1I = (/* unused pure expression or super */ null && (["color"]));
var DotFilledIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1I);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M9.875 7.5C9.875 8.81168 8.81168 9.875 7.5 9.875C6.18832 9.875 5.125 8.81168 5.125 7.5C5.125 6.18832 6.18832 5.125 7.5 5.125C8.81168 5.125 9.875 6.18832 9.875 7.5Z",
    fill: color
  }));
})));

var _excluded$1J = ["color"];
var DotsHorizontalIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1J);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1K = ["color"];
var DotsVerticalIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1K);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M8.625 2.5C8.625 3.12132 8.12132 3.625 7.5 3.625C6.87868 3.625 6.375 3.12132 6.375 2.5C6.375 1.87868 6.87868 1.375 7.5 1.375C8.12132 1.375 8.625 1.87868 8.625 2.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM7.5 13.625C8.12132 13.625 8.625 13.1213 8.625 12.5C8.625 11.8787 8.12132 11.375 7.5 11.375C6.87868 11.375 6.375 11.8787 6.375 12.5C6.375 13.1213 6.87868 13.625 7.5 13.625Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1L = (/* unused pure expression or super */ null && (["color"]));
var DoubleArrowDownIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1L);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.85355 2.14645C3.65829 1.95118 3.34171 1.95118 3.14645 2.14645C2.95118 2.34171 2.95118 2.65829 3.14645 2.85355L7.14645 6.85355C7.34171 7.04882 7.65829 7.04882 7.85355 6.85355L11.8536 2.85355C12.0488 2.65829 12.0488 2.34171 11.8536 2.14645C11.6583 1.95118 11.3417 1.95118 11.1464 2.14645L7.5 5.79289L3.85355 2.14645ZM3.85355 8.14645C3.65829 7.95118 3.34171 7.95118 3.14645 8.14645C2.95118 8.34171 2.95118 8.65829 3.14645 8.85355L7.14645 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L11.8536 8.85355C12.0488 8.65829 12.0488 8.34171 11.8536 8.14645C11.6583 7.95118 11.3417 7.95118 11.1464 8.14645L7.5 11.7929L3.85355 8.14645Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1M = (/* unused pure expression or super */ null && (["color"]));
var DoubleArrowLeftIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1M);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.14645 7.14645C1.95118 7.34171 1.95118 7.65829 2.14645 7.85355L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355ZM12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355L12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464L9.20711 7.5L12.8536 3.85355Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1N = ["color"];
var DoubleArrowRightIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1N);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536C2.34171 12.0488 2.65829 12.0488 2.85355 11.8536L6.85355 7.85355C7.04882 7.65829 7.04882 7.34171 6.85355 7.14645L2.85355 3.14645C2.65829 2.95118 2.34171 2.95118 2.14645 3.14645C1.95118 3.34171 1.95118 3.65829 2.14645 3.85355L5.79289 7.5L2.14645 11.1464ZM8.14645 11.1464C7.95118 11.3417 7.95118 11.6583 8.14645 11.8536C8.34171 12.0488 8.65829 12.0488 8.85355 11.8536L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645L8.85355 3.14645C8.65829 2.95118 8.34171 2.95118 8.14645 3.14645C7.95118 3.34171 7.95118 3.65829 8.14645 3.85355L11.7929 7.5L8.14645 11.1464Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1O = (/* unused pure expression or super */ null && (["color"]));
var DoubleArrowUpIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1O);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M11.1464 6.85355C11.3417 7.04882 11.6583 7.04882 11.8536 6.85355C12.0488 6.65829 12.0488 6.34171 11.8536 6.14645L7.85355 2.14645C7.65829 1.95118 7.34171 1.95118 7.14645 2.14645L3.14645 6.14645C2.95118 6.34171 2.95118 6.65829 3.14645 6.85355C3.34171 7.04882 3.65829 7.04882 3.85355 6.85355L7.5 3.20711L11.1464 6.85355ZM11.1464 12.8536C11.3417 13.0488 11.6583 13.0488 11.8536 12.8536C12.0488 12.6583 12.0488 12.3417 11.8536 12.1464L7.85355 8.14645C7.65829 7.95118 7.34171 7.95118 7.14645 8.14645L3.14645 12.1464C2.95118 12.3417 2.95118 12.6583 3.14645 12.8536C3.34171 13.0488 3.65829 13.0488 3.85355 12.8536L7.5 9.20711L11.1464 12.8536Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1P = ["color"];
var DownloadIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1P);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1Q = ["color"];
var DragHandleDots1Icon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1Q);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "4.5",
    cy: "2.5",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "4.5",
    cy: "4.5",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "4.5",
    cy: "6.499",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "4.5",
    cy: "8.499",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "4.5",
    cy: "10.498",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "4.5",
    cy: "12.498",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "6.5",
    cy: "2.5",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "6.5",
    cy: "4.5",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "6.5",
    cy: "6.499",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "6.5",
    cy: "8.499",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "6.5",
    cy: "10.498",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "6.5",
    cy: "12.498",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "8.499",
    cy: "2.5",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "8.499",
    cy: "4.5",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "8.499",
    cy: "6.499",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "8.499",
    cy: "8.499",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "8.499",
    cy: "10.498",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "8.499",
    cy: "12.498",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "10.499",
    cy: "2.5",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "10.499",
    cy: "4.5",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "10.499",
    cy: "6.499",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "10.499",
    cy: "8.499",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "10.499",
    cy: "10.498",
    r: ".6",
    fill: color
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("circle", {
    cx: "10.499",
    cy: "12.498",
    r: ".6",
    fill: color
  }));
});

var _excluded$1R = (/* unused pure expression or super */ null && (["color"]));
var DragHandleDots2Icon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1R);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M5.5 4.625C6.12132 4.625 6.625 4.12132 6.625 3.5C6.625 2.87868 6.12132 2.375 5.5 2.375C4.87868 2.375 4.375 2.87868 4.375 3.5C4.375 4.12132 4.87868 4.625 5.5 4.625ZM9.5 4.625C10.1213 4.625 10.625 4.12132 10.625 3.5C10.625 2.87868 10.1213 2.375 9.5 2.375C8.87868 2.375 8.375 2.87868 8.375 3.5C8.375 4.12132 8.87868 4.625 9.5 4.625ZM10.625 7.5C10.625 8.12132 10.1213 8.625 9.5 8.625C8.87868 8.625 8.375 8.12132 8.375 7.5C8.375 6.87868 8.87868 6.375 9.5 6.375C10.1213 6.375 10.625 6.87868 10.625 7.5ZM5.5 8.625C6.12132 8.625 6.625 8.12132 6.625 7.5C6.625 6.87868 6.12132 6.375 5.5 6.375C4.87868 6.375 4.375 6.87868 4.375 7.5C4.375 8.12132 4.87868 8.625 5.5 8.625ZM10.625 11.5C10.625 12.1213 10.1213 12.625 9.5 12.625C8.87868 12.625 8.375 12.1213 8.375 11.5C8.375 10.8787 8.87868 10.375 9.5 10.375C10.1213 10.375 10.625 10.8787 10.625 11.5ZM5.5 12.625C6.12132 12.625 6.625 12.1213 6.625 11.5C6.625 10.8787 6.12132 10.375 5.5 10.375C4.87868 10.375 4.375 10.8787 4.375 11.5C4.375 12.1213 4.87868 12.625 5.5 12.625Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1S = (/* unused pure expression or super */ null && (["color"]));
var DragHandleHorizontalIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1S);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M2.49998 4.09998C2.27906 4.09998 2.09998 4.27906 2.09998 4.49998C2.09998 4.72089 2.27906 4.89998 2.49998 4.89998H12.5C12.7209 4.89998 12.9 4.72089 12.9 4.49998C12.9 4.27906 12.7209 4.09998 12.5 4.09998H2.49998ZM2.49998 6.09998C2.27906 6.09998 2.09998 6.27906 2.09998 6.49998C2.09998 6.72089 2.27906 6.89998 2.49998 6.89998H12.5C12.7209 6.89998 12.9 6.72089 12.9 6.49998C12.9 6.27906 12.7209 6.09998 12.5 6.09998H2.49998ZM2.09998 8.49998C2.09998 8.27906 2.27906 8.09998 2.49998 8.09998H12.5C12.7209 8.09998 12.9 8.27906 12.9 8.49998C12.9 8.72089 12.7209 8.89998 12.5 8.89998H2.49998C2.27906 8.89998 2.09998 8.72089 2.09998 8.49998ZM2.49998 10.1C2.27906 10.1 2.09998 10.2791 2.09998 10.5C2.09998 10.7209 2.27906 10.9 2.49998 10.9H12.5C12.7209 10.9 12.9 10.7209 12.9 10.5C12.9 10.2791 12.7209 10.1 12.5 10.1H2.49998Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1T = (/* unused pure expression or super */ null && (["color"]));
var DragHandleVerticalIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1T);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4.09998 12.5C4.09998 12.7209 4.27906 12.9 4.49998 12.9C4.72089 12.9 4.89998 12.7209 4.89998 12.5L4.89998 2.50002C4.89998 2.27911 4.72089 2.10003 4.49998 2.10003C4.27906 2.10003 4.09998 2.27911 4.09998 2.50002L4.09998 12.5ZM6.09998 12.5C6.09998 12.7209 6.27906 12.9 6.49998 12.9C6.72089 12.9 6.89998 12.7209 6.89998 12.5L6.89998 2.50002C6.89998 2.27911 6.72089 2.10003 6.49998 2.10003C6.27906 2.10003 6.09998 2.27911 6.09998 2.50002L6.09998 12.5ZM8.49998 12.9C8.27906 12.9 8.09998 12.7209 8.09998 12.5L8.09998 2.50002C8.09998 2.27911 8.27906 2.10002 8.49998 2.10002C8.72089 2.10002 8.89998 2.27911 8.89998 2.50002L8.89998 12.5C8.89998 12.7209 8.72089 12.9 8.49998 12.9ZM10.1 12.5C10.1 12.7209 10.2791 12.9 10.5 12.9C10.7209 12.9 10.9 12.7209 10.9 12.5L10.9 2.50002C10.9 2.27911 10.7209 2.10002 10.5 2.10002C10.2791 2.10002 10.1 2.27911 10.1 2.50002L10.1 12.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1U = (/* unused pure expression or super */ null && (["color"]));
var DrawingPinIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1U);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M10.3285 1.13607C10.1332 0.940809 9.81662 0.940808 9.62136 1.13607C9.42609 1.33133 9.42609 1.64792 9.62136 1.84318L10.2744 2.49619L5.42563 6.13274L4.31805 5.02516C4.12279 4.8299 3.80621 4.8299 3.61095 5.02516C3.41569 5.22042 3.41569 5.537 3.61095 5.73226L5.02516 7.14648L6.08582 8.20714L2.81545 11.4775C2.62019 11.6728 2.62019 11.9894 2.81545 12.1846C3.01072 12.3799 3.3273 12.3799 3.52256 12.1846L6.79293 8.91425L7.85359 9.97491L9.2678 11.3891C9.46306 11.5844 9.77965 11.5844 9.97491 11.3891C10.1702 11.1939 10.1702 10.8773 9.97491 10.682L8.86733 9.57443L12.5039 4.7257L13.1569 5.37871C13.3522 5.57397 13.6687 5.57397 13.864 5.37871C14.0593 5.18345 14.0593 4.86687 13.864 4.6716L12.8033 3.61094L11.3891 2.19673L10.3285 1.13607ZM6.13992 6.84702L10.9887 3.21047L11.7896 4.01142L8.15305 8.86015L6.13992 6.84702Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1V = (/* unused pure expression or super */ null && (["color"]));
var DrawingPinFilledIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1V);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    d: "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1W = ["color"];
var DropdownMenuIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1W);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.49999 3.09998C7.27907 3.09998 7.09999 3.27906 7.09999 3.49998C7.09999 3.72089 7.27907 3.89998 7.49999 3.89998H14.5C14.7209 3.89998 14.9 3.72089 14.9 3.49998C14.9 3.27906 14.7209 3.09998 14.5 3.09998H7.49999ZM7.49998 5.1C7.27907 5.1 7.09998 5.27908 7.09998 5.5C7.09998 5.72091 7.27907 5.9 7.49998 5.9H14.5C14.7209 5.9 14.9 5.72091 14.9 5.5C14.9 5.27908 14.7209 5.1 14.5 5.1H7.49998ZM7.1 7.5C7.1 7.27908 7.27909 7.1 7.5 7.1H14.5C14.7209 7.1 14.9 7.27908 14.9 7.5C14.9 7.72091 14.7209 7.9 14.5 7.9H7.5C7.27909 7.9 7.1 7.72091 7.1 7.5ZM7.49998 9.1C7.27907 9.1 7.09998 9.27908 7.09998 9.5C7.09998 9.72091 7.27907 9.9 7.49998 9.9H14.5C14.7209 9.9 14.9 9.72091 14.9 9.5C14.9 9.27908 14.7209 9.1 14.5 9.1H7.49998ZM7.09998 11.5C7.09998 11.2791 7.27907 11.1 7.49998 11.1H14.5C14.7209 11.1 14.9 11.2791 14.9 11.5C14.9 11.7209 14.7209 11.9 14.5 11.9H7.49998C7.27907 11.9 7.09998 11.7209 7.09998 11.5ZM2.5 9.25003L5 6.00003H0L2.5 9.25003Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1X = (/* unused pure expression or super */ null && (["color"]));
var EnterIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1X);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2H12V13H4.5C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14H12C12.5523 14 13 13.5523 13 13V2C13 1.44772 12.5523 1 12 1H4.5ZM6.60355 4.89645C6.40829 4.70118 6.09171 4.70118 5.89645 4.89645C5.70118 5.09171 5.70118 5.40829 5.89645 5.60355L7.29289 7H0.5C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H7.29289L5.89645 9.39645C5.70118 9.59171 5.70118 9.90829 5.89645 10.1036C6.09171 10.2988 6.40829 10.2988 6.60355 10.1036L8.85355 7.85355C9.04882 7.65829 9.04882 7.34171 8.85355 7.14645L6.60355 4.89645Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1Y = (/* unused pure expression or super */ null && (["color"]));
var EnterFullScreenIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1Y);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M2 2.5C2 2.22386 2.22386 2 2.5 2H5.5C5.77614 2 6 2.22386 6 2.5C6 2.77614 5.77614 3 5.5 3H3V5.5C3 5.77614 2.77614 6 2.5 6C2.22386 6 2 5.77614 2 5.5V2.5ZM9 2.5C9 2.22386 9.22386 2 9.5 2H12.5C12.7761 2 13 2.22386 13 2.5V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3H9.5C9.22386 3 9 2.77614 9 2.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H2.5C2.22386 13 2 12.7761 2 12.5V9.5C2 9.22386 2.22386 9 2.5 9ZM12.5 9C12.7761 9 13 9.22386 13 9.5V12.5C13 12.7761 12.7761 13 12.5 13H9.5C9.22386 13 9 12.7761 9 12.5C9 12.2239 9.22386 12 9.5 12H12V9.5C12 9.22386 12.2239 9 12.5 9Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$1Z = ["color"];
var EnvelopeClosedIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1Z);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1_ = ["color"];
var EnvelopeOpenIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1_);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.94721 0.164594C7.66569 0.0238299 7.33431 0.0238302 7.05279 0.164594L0.552786 3.41459C0.214002 3.58399 0 3.93025 0 4.30902V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V4.30902C15 3.93025 14.786 3.58399 14.4472 3.41459L7.94721 0.164594ZM13.5689 4.09349L7.5 1.05902L1.43105 4.09349L7.5 7.29136L13.5689 4.09349ZM1 4.88366V12H14V4.88366L7.70977 8.19813C7.57848 8.26731 7.42152 8.26731 7.29023 8.19813L1 4.88366Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$1$ = (/* unused pure expression or super */ null && (["color"]));
var EraserIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1$);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M8.36052 0.72921C8.55578 0.533948 8.87236 0.533948 9.06763 0.72921L14.2708 5.93235C14.466 6.12761 14.466 6.4442 14.2708 6.63946L8.95513 11.9551L7.3466 13.5636C6.76081 14.1494 5.81106 14.1494 5.22528 13.5636L1.43635 9.7747C0.850563 9.18891 0.850563 8.23917 1.43635 7.65338L3.04488 6.04485L8.36052 0.72921ZM8.71407 1.78987L4.10554 6.3984L8.60157 10.8944L13.2101 6.28591L8.71407 1.78987ZM7.89447 11.6015L3.39843 7.10551L2.14346 8.36049C1.94819 8.55575 1.94819 8.87233 2.14346 9.06759L5.93238 12.8565C6.12765 13.0518 6.44423 13.0518 6.63949 12.8565L7.89447 11.6015Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$20 = ["color"];
var ExclamationTriangleIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$20);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M8.4449 0.608765C8.0183 -0.107015 6.9817 -0.107015 6.55509 0.608766L0.161178 11.3368C-0.275824 12.07 0.252503 13 1.10608 13H13.8939C14.7475 13 15.2758 12.07 14.8388 11.3368L8.4449 0.608765ZM7.4141 1.12073C7.45288 1.05566 7.54712 1.05566 7.5859 1.12073L13.9798 11.8488C14.0196 11.9154 13.9715 12 13.8939 12H1.10608C1.02849 12 0.980454 11.9154 1.02018 11.8488L7.4141 1.12073ZM6.8269 4.48611C6.81221 4.10423 7.11783 3.78663 7.5 3.78663C7.88217 3.78663 8.18778 4.10423 8.1731 4.48612L8.01921 8.48701C8.00848 8.766 7.7792 8.98664 7.5 8.98664C7.2208 8.98664 6.99151 8.766 6.98078 8.48701L6.8269 4.48611ZM8.24989 10.476C8.24989 10.8902 7.9141 11.226 7.49989 11.226C7.08567 11.226 6.74989 10.8902 6.74989 10.476C6.74989 10.0618 7.08567 9.72599 7.49989 9.72599C7.9141 9.72599 8.24989 10.0618 8.24989 10.476Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$21 = (/* unused pure expression or super */ null && (["color"]));
var ExitIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$21);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3 1C2.44771 1 2 1.44772 2 2V13C2 13.5523 2.44772 14 3 14H10.5C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13H3V2L10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1H3ZM12.6036 4.89645C12.4083 4.70118 12.0917 4.70118 11.8964 4.89645C11.7012 5.09171 11.7012 5.40829 11.8964 5.60355L13.2929 7H6.5C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H13.2929L11.8964 9.39645C11.7012 9.59171 11.7012 9.90829 11.8964 10.1036C12.0917 10.2988 12.4083 10.2988 12.6036 10.1036L14.8536 7.85355C15.0488 7.65829 15.0488 7.34171 14.8536 7.14645L12.6036 4.89645Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$22 = (/* unused pure expression or super */ null && (["color"]));
var ExitFullScreenIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$22);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M5.5 2C5.77614 2 6 2.22386 6 2.5V5.5C6 5.77614 5.77614 6 5.5 6H2.5C2.22386 6 2 5.77614 2 5.5C2 5.22386 2.22386 5 2.5 5H5V2.5C5 2.22386 5.22386 2 5.5 2ZM9.5 2C9.77614 2 10 2.22386 10 2.5V5H12.5C12.7761 5 13 5.22386 13 5.5C13 5.77614 12.7761 6 12.5 6H9.5C9.22386 6 9 5.77614 9 5.5V2.5C9 2.22386 9.22386 2 9.5 2ZM2 9.5C2 9.22386 2.22386 9 2.5 9H5.5C5.77614 9 6 9.22386 6 9.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5V10H2.5C2.22386 10 2 9.77614 2 9.5ZM9 9.5C9 9.22386 9.22386 9 9.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H10V12.5C10 12.7761 9.77614 13 9.5 13C9.22386 13 9 12.7761 9 12.5V9.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$23 = ["color"];
var ExternalLinkIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$23);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$24 = ["color"];
var EyeClosedIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$24);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M14.7649 6.07596C14.9991 6.22231 15.0703 6.53079 14.9239 6.76495C14.4849 7.46743 13.9632 8.10645 13.3702 8.66305L14.5712 9.86406C14.7664 10.0593 14.7664 10.3759 14.5712 10.5712C14.3759 10.7664 14.0593 10.7664 13.8641 10.5712L12.6011 9.30817C11.805 9.90283 10.9089 10.3621 9.93375 10.651L10.383 12.3277C10.4544 12.5944 10.2961 12.8685 10.0294 12.94C9.76267 13.0115 9.4885 12.8532 9.41704 12.5865L8.95917 10.8775C8.48743 10.958 8.00036 10.9999 7.50001 10.9999C6.99965 10.9999 6.51257 10.958 6.04082 10.8775L5.58299 12.5864C5.51153 12.8532 5.23737 13.0115 4.97064 12.94C4.7039 12.8686 4.5456 12.5944 4.61706 12.3277L5.06625 10.651C4.09111 10.3621 3.19503 9.90282 2.3989 9.30815L1.1359 10.5712C0.940638 10.7664 0.624058 10.7664 0.428798 10.5712C0.233537 10.3759 0.233537 10.0593 0.428798 9.86405L1.62982 8.66303C1.03682 8.10643 0.515113 7.46742 0.0760677 6.76495C-0.0702867 6.53079 0.000898544 6.22231 0.235065 6.07596C0.469231 5.9296 0.777703 6.00079 0.924058 6.23496C1.40354 7.00213 1.989 7.68057 2.66233 8.2427C2.67315 8.25096 2.6837 8.25972 2.69397 8.26898C4.00897 9.35527 5.65537 9.99991 7.50001 9.99991C10.3078 9.99991 12.6564 8.5063 14.076 6.23495C14.2223 6.00079 14.5308 5.9296 14.7649 6.07596Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$25 = (/* unused pure expression or super */ null && (["color"]));
var EyeNoneIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$25);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$26 = ["color"];
var EyeOpenIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$26);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$27 = (/* unused pure expression or super */ null && (["color"]));
var FaceIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$27);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82708 7.49972C1.82708 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82708 10.6327 1.82708 7.49972ZM5.03747 9.21395C4.87949 8.98746 4.56782 8.93193 4.34133 9.08991C4.11484 9.24789 4.05931 9.55956 4.21729 9.78605C4.93926 10.8211 6.14033 11.5 7.50004 11.5C8.85974 11.5 10.0608 10.8211 10.7828 9.78605C10.9408 9.55956 10.8852 9.24789 10.6587 9.08991C10.4323 8.93193 10.1206 8.98746 9.9626 9.21395C9.41963 9.99238 8.51907 10.5 7.50004 10.5C6.481 10.5 5.58044 9.99238 5.03747 9.21395ZM5.37503 6.84998C5.85828 6.84998 6.25003 6.45815 6.25003 5.97498C6.25003 5.4918 5.85828 5.09998 5.37503 5.09998C4.89179 5.09998 4.50003 5.4918 4.50003 5.97498C4.50003 6.45815 4.89179 6.84998 5.37503 6.84998ZM10.5 5.97498C10.5 6.45815 10.1083 6.84998 9.62503 6.84998C9.14179 6.84998 8.75003 6.45815 8.75003 5.97498C8.75003 5.4918 9.14179 5.09998 9.62503 5.09998C10.1083 5.09998 10.5 5.4918 10.5 5.97498Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$28 = (/* unused pure expression or super */ null && (["color"]));
var FigmaLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$28);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.00005 2.04999H5.52505C4.71043 2.04999 4.05005 2.71037 4.05005 3.52499C4.05005 4.33961 4.71043 4.99999 5.52505 4.99999H7.00005V2.04999ZM7.00005 1.04999H8.00005H9.47505C10.842 1.04999 11.95 2.15808 11.95 3.52499C11.95 4.33163 11.5642 5.04815 10.9669 5.49999C11.5642 5.95184 11.95 6.66836 11.95 7.475C11.95 8.8419 10.842 9.95 9.47505 9.95C8.92236 9.95 8.41198 9.76884 8.00005 9.46266V9.95L8.00005 11.425C8.00005 12.7919 6.89195 13.9 5.52505 13.9C4.15814 13.9 3.05005 12.7919 3.05005 11.425C3.05005 10.6183 3.43593 9.90184 4.03317 9.44999C3.43593 8.99814 3.05005 8.28163 3.05005 7.475C3.05005 6.66836 3.43594 5.95184 4.03319 5.5C3.43594 5.04815 3.05005 4.33163 3.05005 3.52499C3.05005 2.15808 4.15814 1.04999 5.52505 1.04999H7.00005ZM8.00005 2.04999V4.99999H9.47505C10.2897 4.99999 10.95 4.33961 10.95 3.52499C10.95 2.71037 10.2897 2.04999 9.47505 2.04999H8.00005ZM5.52505 8.94998H7.00005L7.00005 7.4788L7.00005 7.475L7.00005 7.4712V6H5.52505C4.71043 6 4.05005 6.66038 4.05005 7.475C4.05005 8.28767 4.70727 8.94684 5.5192 8.94999L5.52505 8.94998ZM4.05005 11.425C4.05005 10.6123 4.70727 9.95315 5.5192 9.94999L5.52505 9.95H7.00005L7.00005 11.425C7.00005 12.2396 6.33967 12.9 5.52505 12.9C4.71043 12.9 4.05005 12.2396 4.05005 11.425ZM8.00005 7.47206C8.00164 6.65879 8.66141 6 9.47505 6C10.2897 6 10.95 6.66038 10.95 7.475C10.95 8.28962 10.2897 8.95 9.47505 8.95C8.66141 8.95 8.00164 8.29121 8.00005 7.47794V7.47206Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$29 = ["color"];
var FileIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$29);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V6H8.5C8.22386 6 8 5.77614 8 5.5V2H3.5ZM9 2.70711L11.2929 5H9V2.70711ZM2 2.5C2 1.67157 2.67157 1 3.5 1H8.5C8.63261 1 8.75979 1.05268 8.85355 1.14645L12.8536 5.14645C12.9473 5.24021 13 5.36739 13 5.5V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2a = (/* unused pure expression or super */ null && (["color"]));
var FileMinusIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2a);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.29289L12 4.70711V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.60355C13 4.40464 12.921 4.21388 12.7803 4.07322L9.85355 1.14645C9.75979 1.05268 9.63261 1 9.5 1H3.5ZM5.25 7C4.97386 7 4.75 7.22386 4.75 7.5C4.75 7.77614 4.97386 8 5.25 8H9.75C10.0261 8 10.25 7.77614 10.25 7.5C10.25 7.22386 10.0261 7 9.75 7H5.25Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2b = (/* unused pure expression or super */ null && (["color"]));
var FilePlusIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2b);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V4.70711L9.29289 2H3.5ZM2 2.5C2 1.67157 2.67157 1 3.5 1H9.5C9.63261 1 9.75979 1.05268 9.85355 1.14645L12.7803 4.07322C12.921 4.21388 13 4.40464 13 4.60355V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5ZM4.75 7.5C4.75 7.22386 4.97386 7 5.25 7H7V5.25C7 4.97386 7.22386 4.75 7.5 4.75C7.77614 4.75 8 4.97386 8 5.25V7H9.75C10.0261 7 10.25 7.22386 10.25 7.5C10.25 7.77614 10.0261 8 9.75 8H8V9.75C8 10.0261 7.77614 10.25 7.5 10.25C7.22386 10.25 7 10.0261 7 9.75V8H5.25C4.97386 8 4.75 7.77614 4.75 7.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2c = ["color"];
var FileTextIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2c);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.08579C9.21839 2 9.34557 2.05268 9.43934 2.14645L11.8536 4.56066C11.9473 4.65443 12 4.78161 12 4.91421V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.91421C13 4.51639 12.842 4.13486 12.5607 3.85355L10.1464 1.43934C9.86514 1.15804 9.48361 1 9.08579 1H3.5ZM4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5H7.5C7.77614 5 8 4.77614 8 4.5C8 4.22386 7.77614 4 7.5 4H4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H10.5C10.7761 11 11 10.7761 11 10.5C11 10.2239 10.7761 10 10.5 10H4.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2d = ["color"];
var FontBoldIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2d);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M5.10505 12C4.70805 12 4.4236 11.912 4.25171 11.736C4.0839 11.5559 4 11.2715 4 10.8827V4.11733C4 3.72033 4.08595 3.43588 4.25784 3.26398C4.43383 3.08799 4.71623 3 5.10505 3C6.42741 3 8.25591 3 9.02852 3C10.1373 3 11.0539 3.98153 11.0539 5.1846C11.0539 6.08501 10.6037 6.81855 9.70327 7.23602C10.8657 7.44851 11.5176 8.62787 11.5176 9.48128C11.5176 10.5125 10.9902 12 9.27734 12C8.77742 12 6.42626 12 5.10505 12ZM8.37891 8.00341H5.8V10.631H8.37891C8.9 10.631 9.6296 10.1211 9.6296 9.29877C9.6296 8.47643 8.9 8.00341 8.37891 8.00341ZM5.8 4.36903V6.69577H8.17969C8.53906 6.69577 9.27734 6.35939 9.27734 5.50002C9.27734 4.64064 8.48047 4.36903 8.17969 4.36903H5.8Z",
    fill: color
  }));
});

var _excluded$2e = ["color"];
var FontFamilyIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2e);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2.5 4.5C2.5 3.09886 3.59886 2 5 2H12.499C12.7752 2 13 2.22386 13 2.5C13 2.77614 12.7761 3 12.5 3H8.69244L8.40509 3.85458C8.18869 4.49752 7.89401 5.37197 7.58091 6.29794C7.50259 6.52956 7.42308 6.76453 7.34332 7H8.5C8.77614 7 9 7.22386 9 7.5C9 7.77614 8.77614 8 8.5 8H7.00407C6.56724 9.28543 6.16435 10.4613 5.95799 11.0386C5.63627 11.9386 5.20712 12.4857 4.66741 12.7778C4.16335 13.0507 3.64154 13.0503 3.28378 13.05L3.25 13.05C2.94624 13.05 2.7 12.8037 2.7 12.5C2.7 12.1962 2.94624 11.95 3.25 11.95C3.64182 11.95 3.9035 11.9405 4.14374 11.8105C4.36443 11.691 4.65532 11.4148 4.92217 10.6683C5.10695 10.1514 5.45375 9.14134 5.8422 8H4.5C4.22386 8 4 7.77614 4 7.5C4 7.22386 4.22386 7 4.5 7H6.18187C6.30127 6.64785 6.42132 6.29323 6.53887 5.94559C6.85175 5.02025 7.14627 4.14631 7.36256 3.50368L7.53192 3H5C4.15114 3 3.5 3.65114 3.5 4.5C3.5 4.77614 3.27614 5 3 5C2.72386 5 2.5 4.77614 2.5 4.5Z",
    fill: color
  }));
});

var _excluded$2f = ["color"];
var FontItalicIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2f);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M5.67494 3.50017C5.67494 3.25164 5.87641 3.05017 6.12494 3.05017H10.6249C10.8735 3.05017 11.0749 3.25164 11.0749 3.50017C11.0749 3.7487 10.8735 3.95017 10.6249 3.95017H9.00587L7.2309 11.05H8.87493C9.12345 11.05 9.32493 11.2515 9.32493 11.5C9.32493 11.7486 9.12345 11.95 8.87493 11.95H4.37493C4.1264 11.95 3.92493 11.7486 3.92493 11.5C3.92493 11.2515 4.1264 11.05 4.37493 11.05H5.99397L7.76894 3.95017H6.12494C5.87641 3.95017 5.67494 3.7487 5.67494 3.50017Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2g = ["color"];
var FontRomanIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2g);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M4.79993 3.50017C4.79993 3.25164 5.0014 3.05017 5.24993 3.05017H9.74993C9.99845 3.05017 10.1999 3.25164 10.1999 3.50017C10.1999 3.7487 9.99845 3.95017 9.74993 3.95017H8.09993V11.05H9.74994C9.99847 11.05 10.1999 11.2515 10.1999 11.5C10.1999 11.7486 9.99847 11.95 9.74994 11.95H5.24994C5.00141 11.95 4.79994 11.7486 4.79994 11.5C4.79994 11.2515 5.00141 11.05 5.24994 11.05H6.89993V3.95017H5.24993C5.0014 3.95017 4.79993 3.7487 4.79993 3.50017Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2h = (/* unused pure expression or super */ null && (["color"]));
var FontSizeIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2h);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M2.78233 2.21707C2.70732 2.14206 2.60557 2.09991 2.49949 2.09991C2.3934 2.09991 2.29166 2.14206 2.21664 2.21707L0.216645 4.21707C0.0604351 4.37328 0.0604351 4.62655 0.216645 4.78276C0.372855 4.93897 0.626121 4.93897 0.78233 4.78276L2.09949 3.4656L2.09949 11.5342L0.78233 10.2171C0.62612 10.0609 0.372854 10.0609 0.216645 10.2171C0.0604349 10.3733 0.0604349 10.6265 0.216645 10.7828L2.21664 12.7828C2.29166 12.8578 2.3934 12.8999 2.49949 12.8999C2.60557 12.8999 2.70731 12.8578 2.78233 12.7828L4.78233 10.7828C4.93854 10.6265 4.93854 10.3733 4.78233 10.2171C4.62612 10.0609 4.37285 10.0609 4.21664 10.2171L2.89949 11.5342L2.89949 3.4656L4.21664 4.78276C4.37285 4.93897 4.62612 4.93897 4.78233 4.78276C4.93854 4.62655 4.93854 4.37328 4.78233 4.21707L2.78233 2.21707ZM10.5 2.74997C10.7107 2.74997 10.8988 2.88211 10.9703 3.08036L13.9703 11.3999C14.064 11.6597 13.9293 11.9462 13.6696 12.0399C13.4098 12.1336 13.1233 11.9989 13.0296 11.7392L12.0477 9.016H8.95228L7.97033 11.7392C7.87666 11.9989 7.59013 12.1336 7.33036 12.0399C7.07059 11.9462 6.93595 11.6597 7.02962 11.3999L10.0296 3.08036C10.1011 2.88211 10.2892 2.74997 10.5 2.74997ZM10.5 4.72396L11.7412 8.166H9.25879L10.5 4.72396Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2i = (/* unused pure expression or super */ null && (["color"]));
var FontStyleIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2i);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.03791 9.98075C0.934777 9.6583 1.11603 9.37719 1.40005 9.24871C1.68408 9.12022 2.09463 9.13412 2.27071 9.45426C2.85393 10.5147 3.64599 10.7282 4.48665 10.7282C5.52721 10.7282 6.29659 10.2615 6.29659 9.45426C6.29659 8.8047 5.9119 8.46416 4.87134 8.14253L4.15872 7.92181C2.64518 7.44883 1.88842 6.69206 1.88842 5.45601C1.88842 3.79743 3.27583 2.6875 5.24342 2.6875C6.91733 2.6875 7.97409 3.33536 8.43833 4.31065C8.57087 4.58909 8.57614 4.91294 8.22794 5.19114C7.87974 5.46934 7.52351 5.34799 7.23327 5.03839C6.47215 4.22653 5.99545 4.04968 5.25604 4.04968C4.1398 4.04968 3.547 4.63618 3.547 5.27943C3.547 5.86592 3.96322 6.23169 4.94702 6.5344L5.67856 6.76143C7.22994 7.23441 7.97409 7.95964 7.97409 9.17047C7.97409 10.7723 6.69389 12.0903 4.46143 12.0903C2.86612 12.0903 1.40005 11.1131 1.03791 9.98075ZM11.8491 8.77985C10.661 8.39543 10.1649 7.86114 10.1649 6.98805C10.1649 5.86736 11.1636 5.04639 12.6128 5.04639C13.8546 5.04639 14.6629 5.63345 14.9778 6.6346C15.0443 6.84599 14.9593 6.98006 14.7475 7.0491C14.5394 7.11697 14.3176 7.09974 14.238 6.89611C13.9356 6.12273 13.352 5.76311 12.5998 5.76311C11.6467 5.76311 11.0135 6.25178 11.0135 6.91638C11.0135 7.45066 11.3464 7.75038 12.2473 8.04358L12.8348 8.23254C14.062 8.62999 14.5516 9.13821 14.5516 10.0178C14.5516 11.1972 13.481 12.0442 11.9927 12.0442C10.6439 12.0442 9.65644 11.2809 9.41979 10.3361C9.36535 10.1188 9.41192 10.0287 9.70039 9.96184C9.98886 9.89499 10.0714 9.89918 10.1715 10.1369C10.4555 10.8114 11.1531 11.3275 12.0318 11.3275C12.9914 11.3275 13.6834 10.7802 13.6834 10.0634C13.6834 9.53567 13.3961 9.28807 12.4366 8.97532L11.8491 8.77985Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2j = (/* unused pure expression or super */ null && (["color"]));
var FrameIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2j);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V4H5V1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5V4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H4V10H1.5C1.22386 10 1 10.2239 1 10.5C1 10.7761 1.22386 11 1.5 11H4V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V11H10V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H11V5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H11V1.5ZM10 10V5H5V10H10Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2k = (/* unused pure expression or super */ null && (["color"]));
var FramerLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2k);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.3825 1.29567C3.46241 1.11432 3.64188 0.997284 3.84005 0.997284H11.5C11.7761 0.997284 12 1.22114 12 1.49728V5.5C12 5.77614 11.7761 6 11.5 6H8.63521L11.5288 9.16247C11.6626 9.3087 11.6974 9.52015 11.6175 9.70154C11.5376 9.88293 11.3582 10 11.16 10H8V13.5C8 13.7022 7.87818 13.8845 7.69134 13.9619C7.5045 14.0393 7.28945 13.9966 7.14645 13.8536L3.14645 9.85355C3.05268 9.75979 3 9.63261 3 9.5V5.5C3 5.22386 3.22386 5 3.5 5H6.36531L3.47105 1.83468C3.33732 1.68844 3.30259 1.47701 3.3825 1.29567ZM7.72032 5L4.97474 1.99728H11V5H7.72032ZM7.27978 6H4V9H7.5H10.0247L7.27978 6ZM4.70711 10L7 12.2929V10H4.70711Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2l = ["color"];
var GearIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2l);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.07095 0.650238C6.67391 0.650238 6.32977 0.925096 6.24198 1.31231L6.0039 2.36247C5.6249 2.47269 5.26335 2.62363 4.92436 2.81013L4.01335 2.23585C3.67748 2.02413 3.23978 2.07312 2.95903 2.35386L2.35294 2.95996C2.0722 3.2407 2.0232 3.6784 2.23493 4.01427L2.80942 4.92561C2.62307 5.2645 2.47227 5.62594 2.36216 6.00481L1.31209 6.24287C0.924883 6.33065 0.650024 6.6748 0.650024 7.07183V7.92897C0.650024 8.32601 0.924883 8.67015 1.31209 8.75794L2.36228 8.99603C2.47246 9.375 2.62335 9.73652 2.80979 10.0755L2.2354 10.9867C2.02367 11.3225 2.07267 11.7602 2.35341 12.041L2.95951 12.6471C3.24025 12.9278 3.67795 12.9768 4.01382 12.7651L4.92506 12.1907C5.26384 12.377 5.62516 12.5278 6.0039 12.6379L6.24198 13.6881C6.32977 14.0753 6.67391 14.3502 7.07095 14.3502H7.92809C8.32512 14.3502 8.66927 14.0753 8.75705 13.6881L8.99505 12.6383C9.37411 12.5282 9.73573 12.3773 10.0748 12.1909L10.986 12.7653C11.3218 12.977 11.7595 12.928 12.0403 12.6473L12.6464 12.0412C12.9271 11.7604 12.9761 11.3227 12.7644 10.9869L12.1902 10.076C12.3768 9.73688 12.5278 9.37515 12.638 8.99596L13.6879 8.75794C14.0751 8.67015 14.35 8.32601 14.35 7.92897V7.07183C14.35 6.6748 14.0751 6.33065 13.6879 6.24287L12.6381 6.00488C12.528 5.62578 12.3771 5.26414 12.1906 4.92507L12.7648 4.01407C12.9766 3.6782 12.9276 3.2405 12.6468 2.95975L12.0407 2.35366C11.76 2.07292 11.3223 2.02392 10.9864 2.23565L10.0755 2.80989C9.73622 2.62328 9.37437 2.47229 8.99505 2.36209L8.75705 1.31231C8.66927 0.925096 8.32512 0.650238 7.92809 0.650238H7.07095ZM4.92053 3.81251C5.44724 3.44339 6.05665 3.18424 6.71543 3.06839L7.07095 1.50024H7.92809L8.28355 3.06816C8.94267 3.18387 9.5524 3.44302 10.0794 3.81224L11.4397 2.9547L12.0458 3.56079L11.1882 4.92117C11.5573 5.44798 11.8164 6.0575 11.9321 6.71638L13.5 7.07183V7.92897L11.932 8.28444C11.8162 8.94342 11.557 9.55301 11.1878 10.0798L12.0453 11.4402L11.4392 12.0462L10.0787 11.1886C9.55192 11.5576 8.94241 11.8166 8.28355 11.9323L7.92809 13.5002H7.07095L6.71543 11.932C6.0569 11.8162 5.44772 11.5572 4.92116 11.1883L3.56055 12.046L2.95445 11.4399L3.81213 10.0794C3.4431 9.55266 3.18403 8.94326 3.06825 8.2845L1.50002 7.92897V7.07183L3.06818 6.71632C3.18388 6.05765 3.44283 5.44833 3.81171 4.92165L2.95398 3.561L3.56008 2.95491L4.92053 3.81251ZM9.02496 7.50008C9.02496 8.34226 8.34223 9.02499 7.50005 9.02499C6.65786 9.02499 5.97513 8.34226 5.97513 7.50008C5.97513 6.65789 6.65786 5.97516 7.50005 5.97516C8.34223 5.97516 9.02496 6.65789 9.02496 7.50008ZM9.92496 7.50008C9.92496 8.83932 8.83929 9.92499 7.50005 9.92499C6.1608 9.92499 5.07513 8.83932 5.07513 7.50008C5.07513 6.16084 6.1608 5.07516 7.50005 5.07516C8.83929 5.07516 9.92496 6.16084 9.92496 7.50008Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2m = (/* unused pure expression or super */ null && (["color"]));
var GitHubLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2m);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49933 0.25C3.49635 0.25 0.25 3.49593 0.25 7.50024C0.25 10.703 2.32715 13.4206 5.2081 14.3797C5.57084 14.446 5.70302 14.2222 5.70302 14.0299C5.70302 13.8576 5.69679 13.4019 5.69323 12.797C3.67661 13.235 3.25112 11.825 3.25112 11.825C2.92132 10.9874 2.44599 10.7644 2.44599 10.7644C1.78773 10.3149 2.49584 10.3238 2.49584 10.3238C3.22353 10.375 3.60629 11.0711 3.60629 11.0711C4.25298 12.1788 5.30335 11.8588 5.71638 11.6732C5.78225 11.205 5.96962 10.8854 6.17658 10.7043C4.56675 10.5209 2.87415 9.89918 2.87415 7.12104C2.87415 6.32925 3.15677 5.68257 3.62053 5.17563C3.54576 4.99226 3.29697 4.25521 3.69174 3.25691C3.69174 3.25691 4.30015 3.06196 5.68522 3.99973C6.26337 3.83906 6.8838 3.75895 7.50022 3.75583C8.1162 3.75895 8.73619 3.83906 9.31523 3.99973C10.6994 3.06196 11.3069 3.25691 11.3069 3.25691C11.7026 4.25521 11.4538 4.99226 11.3795 5.17563C11.8441 5.68257 12.1245 6.32925 12.1245 7.12104C12.1245 9.9063 10.4292 10.5192 8.81452 10.6985C9.07444 10.9224 9.30633 11.3648 9.30633 12.0413C9.30633 13.0102 9.29742 13.7922 9.29742 14.0299C9.29742 14.2239 9.42828 14.4496 9.79591 14.3788C12.6746 13.4179 14.75 10.7025 14.75 7.50024C14.75 3.49593 11.5036 0.25 7.49933 0.25Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2n = (/* unused pure expression or super */ null && (["color"]));
var GlobeIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2n);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49996 1.80002C4.35194 1.80002 1.79996 4.352 1.79996 7.50002C1.79996 10.648 4.35194 13.2 7.49996 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.352 10.648 1.80002 7.49996 1.80002ZM0.899963 7.50002C0.899963 3.85494 3.85488 0.900024 7.49996 0.900024C11.145 0.900024 14.1 3.85494 14.1 7.50002C14.1 11.1451 11.145 14.1 7.49996 14.1C3.85488 14.1 0.899963 11.1451 0.899963 7.50002Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    d: "M13.4999 7.89998H1.49994V7.09998H13.4999V7.89998Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    d: "M7.09991 13.5V1.5H7.89991V13.5H7.09991zM10.375 7.49998C10.375 5.32724 9.59364 3.17778 8.06183 1.75656L8.53793 1.24341C10.2396 2.82218 11.075 5.17273 11.075 7.49998 11.075 9.82724 10.2396 12.1778 8.53793 13.7566L8.06183 13.2434C9.59364 11.8222 10.375 9.67273 10.375 7.49998zM3.99969 7.5C3.99969 5.17611 4.80786 2.82678 6.45768 1.24719L6.94177 1.75281C5.4582 3.17323 4.69969 5.32389 4.69969 7.5 4.6997 9.67611 5.45822 11.8268 6.94179 13.2472L6.45769 13.7528C4.80788 12.1732 3.9997 9.8239 3.99969 7.5z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    d: "M7.49996 3.95801C9.66928 3.95801 11.8753 4.35915 13.3706 5.19448 13.5394 5.28875 13.5998 5.50197 13.5055 5.67073 13.4113 5.83948 13.198 5.89987 13.0293 5.8056 11.6794 5.05155 9.60799 4.65801 7.49996 4.65801 5.39192 4.65801 3.32052 5.05155 1.97064 5.8056 1.80188 5.89987 1.58866 5.83948 1.49439 5.67073 1.40013 5.50197 1.46051 5.28875 1.62927 5.19448 3.12466 4.35915 5.33063 3.95801 7.49996 3.95801zM7.49996 10.85C9.66928 10.85 11.8753 10.4488 13.3706 9.6135 13.5394 9.51924 13.5998 9.30601 13.5055 9.13726 13.4113 8.9685 13.198 8.90812 13.0293 9.00238 11.6794 9.75643 9.60799 10.15 7.49996 10.15 5.39192 10.15 3.32052 9.75643 1.97064 9.00239 1.80188 8.90812 1.58866 8.9685 1.49439 9.13726 1.40013 9.30601 1.46051 9.51924 1.62927 9.6135 3.12466 10.4488 5.33063 10.85 7.49996 10.85z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2o = ["color"];
var GridIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2o);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M12.5 2H8V7H13V2.5C13 2.22386 12.7761 2 12.5 2ZM13 8H8V13H12.5C12.7761 13 13 12.7761 13 12.5V8ZM7 7V2H2.5C2.22386 2 2 2.22386 2 2.5V7H7ZM2 8V12.5C2 12.7761 2.22386 13 2.5 13H7V8H2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2p = ["color"];
var GroupIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2p);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1.44995 0.949951C1.31734 0.949951 1.19016 1.00263 1.0964 1.0964C1.00263 1.19017 0.949951 1.31735 0.949951 1.44995L0.949966 3.44995C0.949969 3.7261 1.17383 3.94995 1.44997 3.94995C1.72611 3.94995 1.94997 3.72609 1.94997 3.44995L1.94995 1.94995H3.44997C3.72611 1.94995 3.94997 1.72609 3.94997 1.44995C3.94997 1.17381 3.72611 0.949951 3.44997 0.949951H1.44995ZM5.94995 0.949951C5.67381 0.949951 5.44995 1.17381 5.44995 1.44995C5.44995 1.72609 5.67381 1.94995 5.94995 1.94995H8.94995C9.22609 1.94995 9.44995 1.72609 9.44995 1.44995C9.44995 1.17381 9.22609 0.949951 8.94995 0.949951H5.94995ZM5.44995 13.45C5.44995 13.1738 5.67381 12.95 5.94995 12.95H8.94995C9.22609 12.95 9.44995 13.1738 9.44995 13.45C9.44995 13.7261 9.22609 13.95 8.94995 13.95H5.94995C5.67381 13.95 5.44995 13.7261 5.44995 13.45ZM1.94995 5.94995C1.94995 5.67381 1.72609 5.44995 1.44995 5.44995C1.17381 5.44995 0.949951 5.67381 0.949951 5.94995V8.94995C0.949951 9.22609 1.17381 9.44995 1.44995 9.44995C1.72609 9.44995 1.94995 9.22609 1.94995 8.94995V5.94995ZM13.45 5.44995C13.7261 5.44995 13.95 5.67381 13.95 5.94995V8.94995C13.95 9.22609 13.7261 9.44995 13.45 9.44995C13.1738 9.44995 12.95 9.22609 12.95 8.94995V5.94995C12.95 5.67381 13.1738 5.44995 13.45 5.44995ZM11.45 0.949951C11.1738 0.949951 10.95 1.17381 10.95 1.44995C10.95 1.72609 11.1738 1.94995 11.45 1.94995H12.9499V3.44995C12.9499 3.72609 13.1738 3.94995 13.4499 3.94995C13.7261 3.94995 13.9499 3.72609 13.9499 3.44995V1.44995C13.9499 1.17381 13.7252 0.949951 13.449 0.949951H11.45ZM1.44995 10.95C1.72609 10.95 1.94995 11.1738 1.94995 11.45V12.95H3.44997C3.72611 12.95 3.94997 13.1738 3.94997 13.45C3.94997 13.7261 3.72611 13.95 3.44997 13.95H1.44995C1.17381 13.95 0.949951 13.7261 0.949951 13.45V11.45C0.949951 11.1738 1.17381 10.95 1.44995 10.95ZM13.95 11.45C13.95 11.1738 13.7261 10.95 13.45 10.95C13.1738 10.9499 12.95 11.1738 12.95 11.4499L12.9491 12.95H11.45C11.1738 12.95 10.95 13.1738 10.95 13.45C10.95 13.7261 11.1738 13.95 11.45 13.95H13.4499C13.7261 13.95 13.9499 13.7261 13.9499 13.45L13.95 11.45Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2q = (/* unused pure expression or super */ null && (["color"]));
var Half1Icon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2q);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.00003 1.84861C4.10114 2.1017 1.82707 4.53515 1.82707 7.49972C1.82707 10.4643 4.10114 12.8977 7.00003 13.1508V1.84861ZM8.00003 13.1508C10.8988 12.8976 13.1727 10.4642 13.1727 7.49972C13.1727 4.53524 10.8988 2.10185 8.00003 1.84864V13.1508Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2r = (/* unused pure expression or super */ null && (["color"]));
var Half2Icon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2r);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.49988 1.82689C4.36688 1.8269 1.82707 4.36672 1.82707 7.49972C1.82707 10.6327 4.36688 13.1725 7.49988 13.1726V1.82689Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2s = (/* unused pure expression or super */ null && (["color"]));
var HamburgerMenuIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2s);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2t = (/* unused pure expression or super */ null && (["color"]));
var HandIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2t);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M6.8113 1.64706C6.62188 2.87918 6.68268 3.88523 6.76848 5.30499C6.78415 5.56426 6.80065 5.83732 6.81661 6.12808C6.83111 6.39208 6.63758 6.62172 6.37495 6.65217C6.11232 6.68262 5.87138 6.50334 5.82509 6.24304L5.74754 5.80698C5.64402 5.16529 5.48355 4.25481 5.17807 3.44741C4.86241 2.61312 4.4486 2.04121 3.93436 1.86044C3.64994 1.76104 3.41901 1.84279 3.25868 2.01052C3.08746 2.18962 2.9976 2.47065 3.0627 2.75399C3.2146 3.34424 3.44627 3.9167 3.69836 4.51802C3.72082 4.57158 3.74346 4.62543 3.76621 4.67954C3.9954 5.22457 4.23619 5.7972 4.41644 6.39081L4.41691 6.39238C4.562 6.87586 4.65646 7.2595 4.73086 7.56165C4.76034 7.68138 4.78667 7.78831 4.81175 7.88359C4.86768 8.09606 4.77836 8.32014 4.59161 8.43588C4.40486 8.55161 4.16445 8.53188 3.99907 8.38725C3.73749 8.15848 3.515 7.92784 3.31817 7.71802C3.27627 7.67335 3.23602 7.63018 3.19705 7.58838C3.04777 7.42826 2.91712 7.28812 2.78334 7.16029C2.45989 6.85122 2.18398 6.68004 1.80585 6.64369L1.80324 6.64343C1.56117 6.61888 1.41402 6.66441 1.31756 6.72627C1.21899 6.78947 1.11988 6.90414 1.03784 7.1123C0.976576 7.28492 1.01515 7.62987 1.1929 7.96911L1.19728 7.97747C1.40086 8.38452 1.74475 8.81587 2.18141 9.29299C2.39739 9.52898 2.62872 9.76849 2.86934 10.0174L2.87966 10.0281C3.11546 10.2721 3.35962 10.5247 3.59713 10.7827C4.4288 11.6863 5.27706 12.7538 5.4627 14H11.5087C11.5636 12.4353 11.8756 11.268 12.2875 10.1346C12.4454 9.70041 12.6121 9.28412 12.7826 8.85829C13.1097 8.04139 13.4509 7.18937 13.7705 6.10824C14.0989 4.99737 14.0097 4.37033 13.8613 4.03984C13.717 3.71858 13.4914 3.61786 13.3816 3.59606C13.1381 3.54774 13.0384 3.60947 12.9698 3.67901C12.867 3.78316 12.7698 3.98273 12.6921 4.30269C12.6166 4.61345 12.5752 4.96517 12.533 5.32501L12.5298 5.35285C12.4924 5.67242 12.4505 6.03016 12.3665 6.30098C12.3383 6.40699 12.2819 6.50407 12.1979 6.57539C12.1382 6.6261 12.0104 6.70818 11.8309 6.69312C11.5424 6.66891 11.3712 6.42143 11.365 6.14783C11.356 5.75454 11.3883 5.35864 11.4074 4.96608C11.4428 4.23646 11.477 3.5337 11.4245 2.8342L11.4242 2.82934C11.3916 2.32997 11.0493 2.00228 10.7007 1.9228C10.5305 1.88401 10.369 1.90601 10.2347 1.9835C10.103 2.05946 9.95535 2.21318 9.8574 2.51394L9.85631 2.51726C9.81525 2.6404 9.77298 2.87753 9.73606 3.2124C9.70044 3.53542 9.67337 3.91279 9.65156 4.29418C9.6329 4.62033 9.61785 4.9584 9.60434 5.26194C9.58728 5.64529 9.57267 5.97357 9.55633 6.1532C9.54983 6.22459 9.52939 6.29493 9.49501 6.35785C9.47356 6.39711 9.36115 6.60947 9.07106 6.61843C8.77917 6.62744 8.63975 6.40057 8.61698 6.35919C8.55634 6.24899 8.55066 6.11807 8.54754 5.99283C8.54474 5.88064 8.54294 5.71798 8.54174 5.54767C8.53935 5.20582 8.53935 4.81919 8.53935 4.70952C8.53935 3.6657 8.53838 2.65372 8.44714 1.64372C8.39183 1.24127 8.06278 1.00455 7.6436 1.00005C7.22399 0.995552 6.87918 1.22704 6.8113 1.64706ZM9.41219 1.3617C9.21469 0.448484 8.39913 0.00810324 7.65433 0.00011154C6.86452 -0.00836308 5.98761 0.465881 5.82365 1.49037L5.82318 1.49334C5.78239 1.7584 5.75229 2.01481 5.7309 2.26652C5.39423 1.67364 4.92622 1.14894 4.2655 0.916859C3.58661 0.679312 2.9492 0.887087 2.53582 1.31952C2.13415 1.73971 1.94438 2.36742 2.09031 2.98746L2.09269 2.99713C2.26478 3.66808 2.52396 4.30316 2.77613 4.90465C2.79814 4.95717 2.8201 5.00941 2.84194 5.06139C3.02139 5.48842 3.19378 5.89866 3.33871 6.31256C2.96404 5.98142 2.51925 5.70796 1.90276 5.6484C1.48865 5.60663 1.10391 5.67536 0.777805 5.88444C0.454239 6.0919 0.240671 6.40405 0.104187 6.75406L0.100868 6.76281C-0.10184 7.31286 0.0663312 7.97157 0.304895 8.42897C0.573704 8.96474 0.996104 9.47904 1.44372 9.96813C1.67046 10.2159 1.91136 10.4652 2.15033 10.7124L2.15682 10.7191C2.39524 10.9658 2.63217 11.2109 2.86134 11.4599C3.80937 12.49 4.50002 13.4632 4.50002 14.5C4.50002 14.7761 4.72388 15 5.00002 15H12C12.2762 15 12.5 14.7761 12.5 14.5C12.5 12.8212 12.8021 11.6462 13.2274 10.4762C13.3653 10.0968 13.5216 9.70579 13.6868 9.29247C14.0238 8.44922 14.398 7.51298 14.7295 6.39175C15.0956 5.15324 15.0559 4.25904 14.7735 3.63017C14.487 2.99208 13.9798 2.6953 13.5763 2.6152C13.1276 2.52614 12.7367 2.60475 12.4268 2.83081C12.4253 2.80773 12.4236 2.78468 12.4219 2.76167C12.3587 1.8105 11.6907 1.12285 10.923 0.947821C10.5346 0.859287 10.1111 0.900393 9.73509 1.11724C9.61852 1.18446 9.51055 1.26623 9.41219 1.3617Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2u = ["color"];
var HeadingIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2u);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M8.75432 2.0502C8.50579 2.0502 8.30432 2.25167 8.30432 2.5002C8.30432 2.74873 8.50579 2.9502 8.75432 2.9502H9.94997V7.05004H5.04997V2.9502H6.25432C6.50285 2.9502 6.70432 2.74873 6.70432 2.5002C6.70432 2.25167 6.50285 2.0502 6.25432 2.0502H2.75432C2.50579 2.0502 2.30432 2.25167 2.30432 2.5002C2.30432 2.74873 2.50579 2.9502 2.75432 2.9502H3.94997V12.0502H2.75432C2.50579 12.0502 2.30432 12.2517 2.30432 12.5002C2.30432 12.7487 2.50579 12.9502 2.75432 12.9502H6.25432C6.50285 12.9502 6.70432 12.7487 6.70432 12.5002C6.70432 12.2517 6.50285 12.0502 6.25432 12.0502H5.04997V7.95004H9.94997V12.0502H8.75432C8.50579 12.0502 8.30432 12.2517 8.30432 12.5002C8.30432 12.7487 8.50579 12.9502 8.75432 12.9502H12.2543C12.5028 12.9502 12.7043 12.7487 12.7043 12.5002C12.7043 12.2517 12.5028 12.0502 12.2543 12.0502H11.05V2.9502H12.2543C12.5028 2.9502 12.7043 2.74873 12.7043 2.5002C12.7043 2.25167 12.5028 2.0502 12.2543 2.0502H8.75432Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2v = ["color"];
var HeartIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2v);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M4.89346 2.35248C3.49195 2.35248 2.35248 3.49359 2.35248 4.90532C2.35248 6.38164 3.20954 7.9168 4.37255 9.33522C5.39396 10.581 6.59464 11.6702 7.50002 12.4778C8.4054 11.6702 9.60608 10.581 10.6275 9.33522C11.7905 7.9168 12.6476 6.38164 12.6476 4.90532C12.6476 3.49359 11.5081 2.35248 10.1066 2.35248C9.27059 2.35248 8.81894 2.64323 8.5397 2.95843C8.27877 3.25295 8.14623 3.58566 8.02501 3.88993C8.00391 3.9429 7.98315 3.99501 7.96211 4.04591C7.88482 4.23294 7.7024 4.35494 7.50002 4.35494C7.29765 4.35494 7.11523 4.23295 7.03793 4.04592C7.01689 3.99501 6.99612 3.94289 6.97502 3.8899C6.8538 3.58564 6.72126 3.25294 6.46034 2.95843C6.18109 2.64323 5.72945 2.35248 4.89346 2.35248ZM1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.0084 1.35248 6.73504 1.76049 7.20884 2.2953C7.32062 2.42147 7.41686 2.55382 7.50002 2.68545C7.58318 2.55382 7.67941 2.42147 7.79119 2.2953C8.265 1.76049 8.99164 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2w = (/* unused pure expression or super */ null && (["color"]));
var HeartFilledIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2w);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.25769 1.35248 6.86058 1.92336 7.50002 2.93545C8.13946 1.92336 8.74235 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2x = (/* unused pure expression or super */ null && (["color"]));
var HeightIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2x);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.1813 1.68179C7.35704 1.50605 7.64196 1.50605 7.8177 1.68179L10.3177 4.18179C10.4934 4.35753 10.4934 4.64245 10.3177 4.81819C10.142 4.99392 9.85704 4.99392 9.6813 4.81819L7.9495 3.08638L7.9495 11.9136L9.6813 10.1818C9.85704 10.0061 10.142 10.0061 10.3177 10.1818C10.4934 10.3575 10.4934 10.6424 10.3177 10.8182L7.8177 13.3182C7.73331 13.4026 7.61885 13.45 7.4995 13.45C7.38015 13.45 7.26569 13.4026 7.1813 13.3182L4.6813 10.8182C4.50557 10.6424 4.50557 10.3575 4.6813 10.1818C4.85704 10.0061 5.14196 10.0061 5.3177 10.1818L7.0495 11.9136L7.0495 3.08638L5.3177 4.81819C5.14196 4.99392 4.85704 4.99392 4.6813 4.81819C4.50557 4.64245 4.50557 4.35753 4.6813 4.18179L7.1813 1.68179Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2y = (/* unused pure expression or super */ null && (["color"]));
var HobbyKnifeIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2y);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M12.3536 13.3536C12.1583 13.5488 11.8417 13.5488 11.6465 13.3536L6.39645 8.10355C6.36478 8.07188 6.33824 8.03702 6.31685 8H5.00002C4.78719 8 4.59769 7.86528 4.52777 7.66426L2.12777 0.764277C2.05268 0.548387 2.13355 0.309061 2.3242 0.182972C2.51486 0.0568819 2.76674 0.0761337 2.93602 0.229734L8.336 5.12972C8.44044 5.22449 8.50001 5.35897 8.50001 5.5V5.81684C8.53702 5.83824 8.57189 5.86478 8.60356 5.89645L13.8536 11.1464C14.0488 11.3417 14.0488 11.6583 13.8536 11.8536L12.3536 13.3536ZM8.25 6.95711L7.45711 7.75L12 12.2929L12.7929 11.5L8.25 6.95711ZM3.71669 2.28845L5.35549 7H6.2929L7.50001 5.79289V5.72146L3.71669 2.28845Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2z = ["color"];
var HomeIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2z);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.07926 0.222253C7.31275 -0.007434 7.6873 -0.007434 7.92079 0.222253L14.6708 6.86227C14.907 7.09465 14.9101 7.47453 14.6778 7.71076C14.4454 7.947 14.0655 7.95012 13.8293 7.71773L13 6.90201V12.5C13 12.7761 12.7762 13 12.5 13H2.50002C2.22388 13 2.00002 12.7761 2.00002 12.5V6.90201L1.17079 7.71773C0.934558 7.95012 0.554672 7.947 0.32229 7.71076C0.0899079 7.47453 0.0930283 7.09465 0.32926 6.86227L7.07926 0.222253ZM7.50002 1.49163L12 5.91831V12H10V8.49999C10 8.22385 9.77617 7.99999 9.50002 7.99999H6.50002C6.22388 7.99999 6.00002 8.22385 6.00002 8.49999V12H3.00002V5.91831L7.50002 1.49163ZM7.00002 12H9.00002V8.99999H7.00002V12Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2A = (/* unused pure expression or super */ null && (["color"]));
var IconJarLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2A);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.5 0.0032959C6.80473 0.0032959 6.24953 0.281106 6.25 0.749995C6.25 0.997258 6.42446 1.12014 6.57687 1.22749C6.69507 1.31074 6.8 1.38465 6.8 1.5C6.8 1.7071 6.06224 1.74264 5.19789 1.78427C3.97553 1.84314 2.5 1.91421 2.5 2.5C2.5 2.77614 2.72386 3 3 3H12C12.2761 3 12.5 2.77614 12.5 2.5C12.5 1.91421 11.0245 1.84314 9.80211 1.78427C8.93776 1.74264 8.2 1.7071 8.2 1.5C8.2 1.38465 8.30493 1.31074 8.42313 1.22749C8.57554 1.12014 8.75 0.997258 8.75 0.749995C8.75047 0.281106 8.19527 0.0032959 7.5 0.0032959ZM2.89451 6.12266C2.25806 6.52471 1.90417 7.31118 2.02473 8.0556L2.83588 12.4772C3.00993 13.3562 3.7629 14 4.66061 14H10.3373C11.2354 14 11.9884 13.3562 12.1625 12.4772L12.9736 8.05607C13.089 7.32358 12.8284 6.53276 12.1331 6.09373C11.7283 5.83013 11.6412 5.33231 12.1331 5.12796C12.8284 4.86435 12.6948 4 12 4H10.3001H6.80005H2.99996C2.30469 4 2.19878 4.89328 2.89451 5.15689C3.38642 5.33231 3.29939 5.83013 2.89451 6.12266ZM8.20006 6.25C8.20006 5.81769 8.08572 5.37615 7.90635 5L4.11093 5C4.20626 5.21312 4.2419 5.43889 4.22904 5.65521C4.19522 6.22412 3.84587 6.66899 3.48016 6.93322L3.45492 6.95146L3.42858 6.9681C3.13407 7.15414 2.95801 7.53989 3.01058 7.88749L3.81797 12.2886C3.90513 12.7154 4.26148 13 4.66061 13H10.3373C10.737 13 11.0932 12.7153 11.1804 12.2886L11.9874 7.8898C12.048 7.48247 11.8954 7.12631 11.5992 6.93927L11.5875 6.93184L11.5875 6.93176C11.1947 6.67602 10.8331 6.22785 10.7986 5.64798C10.7846 5.412 10.8264 5.19397 10.9112 5H9.05517C9.01987 5.14611 9.00006 5.31201 9.00006 5.5C9.00006 5.9745 9.21679 6.37127 9.44367 6.78662C9.69284 7.24278 9.95425 7.72136 9.95425 8.34993C9.95425 9.2698 9.49868 9.84205 8.62189 9.84205C8.13206 9.84205 7.57818 9.46097 7.57818 8.75781C7.57818 8.35279 7.71558 8.01646 7.86121 7.65998C8.0254 7.25806 8.20006 6.83051 8.20006 6.25Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2B = (/* unused pure expression or super */ null && (["color"]));
var IdCardIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2B);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M14 11.0001V4.00006L1 4.00006L1 11.0001H14ZM15 4.00006V11.0001C15 11.5523 14.5523 12.0001 14 12.0001H1C0.447715 12.0001 0 11.5523 0 11.0001V4.00006C0 3.44778 0.447715 3.00006 1 3.00006H14C14.5523 3.00006 15 3.44778 15 4.00006ZM2 5.25C2 5.11193 2.11193 5 2.25 5H5.75C5.88807 5 6 5.11193 6 5.25V9.75C6 9.88807 5.88807 10 5.75 10H2.25C2.11193 10 2 9.88807 2 9.75V5.25ZM7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H7.5ZM7 9.5C7 9.22386 7.22386 9 7.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H7.5C7.22386 10 7 9.77614 7 9.5ZM7.5 5C7.22386 5 7 5.22386 7 5.5C7 5.77614 7.22386 6 7.5 6H11.5C11.7761 6 12 5.77614 12 5.5C12 5.22386 11.7761 5 11.5 5H7.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2C = ["color"];
var ImageIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2C);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2D = (/* unused pure expression or super */ null && (["color"]));
var InfoCircledIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2D);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2E = ["color"];
var InputIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2E);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M6.5 1C6.22386 1 6 1.22386 6 1.5C6 1.77614 6.22386 2 6.5 2C7.12671 2 7.45718 2.20028 7.65563 2.47812C7.8781 2.78957 8 3.28837 8 4V11C8 11.7116 7.8781 12.2104 7.65563 12.5219C7.45718 12.7997 7.12671 13 6.5 13C6.22386 13 6 13.2239 6 13.5C6 13.7761 6.22386 14 6.5 14C7.37329 14 8.04282 13.7003 8.46937 13.1031C8.47976 13.0886 8.48997 13.0739 8.5 13.0591C8.51003 13.0739 8.52024 13.0886 8.53063 13.1031C8.95718 13.7003 9.62671 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.87329 13 9.54282 12.7997 9.34437 12.5219C9.1219 12.2104 9 11.7116 9 11V4C9 3.28837 9.1219 2.78957 9.34437 2.47812C9.54282 2.20028 9.87329 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.62671 1 8.95718 1.29972 8.53063 1.89688C8.52024 1.91143 8.51003 1.92611 8.5 1.9409C8.48997 1.92611 8.47976 1.91143 8.46937 1.89688C8.04282 1.29972 7.37329 1 6.5 1ZM14 5H11V4H14C14.5523 4 15 4.44772 15 5V10C15 10.5523 14.5523 11 14 11H11V10H14V5ZM6 4V5H1L1 10H6V11H1C0.447715 11 0 10.5523 0 10V5C0 4.44772 0.447715 4 1 4H6Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2F = (/* unused pure expression or super */ null && (["color"]));
var InstagramLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2F);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9091 12.909C13.2365 12.5817 13.4918 12.1895 13.6588 11.7577C13.8195 11.3443 13.9294 10.8718 13.961 10.1799C13.9926 9.48665 14.0001 9.26529 14.0001 7.50001C14.0001 5.73473 13.9926 5.51328 13.961 4.82008C13.9294 4.12821 13.8195 3.65573 13.6588 3.24228C13.4956 2.80857 13.2398 2.41567 12.9091 2.091C12.5844 1.76028 12.1915 1.50437 11.7578 1.34113C11.3443 1.18056 10.8718 1.0707 10.1799 1.03924C9.48675 1.00748 9.26537 1 7.50006 1C5.73476 1 5.51333 1.00748 4.82014 1.03912C4.12826 1.0707 3.65578 1.18056 3.24233 1.34125C2.80862 1.50447 2.41573 1.76032 2.09105 2.09098C1.76032 2.41563 1.5044 2.80852 1.34113 3.24225C1.18056 3.65573 1.0707 4.12821 1.03924 4.82008C1.00748 5.51328 1 5.73471 1 7.50001C1 9.26532 1.00748 9.48675 1.03924 10.1799C1.07083 10.8718 1.18069 11.3443 1.34138 11.7577C1.5046 12.1915 1.76045 12.5843 2.09111 12.909C2.41578 13.2397 2.80867 13.4955 3.24238 13.6587C3.65586 13.8194 4.12834 13.9293 4.82019 13.9609C5.51348 13.9925 5.73483 14 7.50012 14C9.2654 14 9.48685 13.9925 10.18 13.9609C10.8719 13.9293 11.3444 13.8194 11.7578 13.6587C12.1896 13.4917 12.5818 13.2364 12.9091 12.909ZM1.99949 6.73496C1.99974 6.94524 2.00005 7.19543 2.00005 7.50002C2.00005 7.80461 1.99974 8.0548 1.99949 8.26507C1.99849 9.08596 1.99824 9.29856 2.01963 9.7655C2.04625 10.3509 2.07823 10.7811 2.17588 11.1053C2.26976 11.417 2.37505 11.7342 2.7188 12.1171C3.06255 12.4999 3.39411 12.6733 3.81645 12.8007C4.23879 12.928 4.7696 12.9554 5.23052 12.9764C5.75332 13.0003 5.96052 13.0002 7.05714 12.9999L7.50006 12.9999C7.79304 12.9999 8.03569 13.0001 8.2409 13.0004C9.08195 13.0013 9.29425 13.0015 9.76575 12.9799C10.3512 12.9533 10.7814 12.9213 11.1056 12.8237C11.4173 12.7298 11.7345 12.6245 12.1173 12.2807C12.5001 11.937 12.6735 11.6054 12.8009 11.1831C12.9283 10.7607 12.9557 10.2299 12.9767 9.76902C13.0005 9.24689 13.0004 9.04027 13.0002 7.94749V7.94738L13.0001 7.50039L13.0001 7.05747C13.0004 5.96085 13.0005 5.75365 12.9766 5.23085C12.9556 4.76993 12.9282 4.23912 12.8009 3.81678C12.6735 3.39445 12.5001 3.06288 12.1173 2.71913C11.7345 2.37538 11.4172 2.27009 11.1056 2.17621C10.7813 2.07856 10.3511 2.04658 9.76571 2.01996C9.29421 1.99836 9.08194 1.99859 8.24092 1.99951H8.24092C8.0357 1.99974 7.79305 2.00001 7.50006 2.00001L7.05704 1.99993C5.96051 1.99964 5.75331 1.99958 5.23052 2.02343C4.7696 2.04446 4.23879 2.07183 3.81645 2.19921C3.39411 2.32659 3.06255 2.49999 2.7188 2.88281C2.37505 3.26562 2.26976 3.58286 2.17588 3.89453C2.07823 4.21874 2.04625 4.64894 2.01963 5.23437C1.99824 5.70131 1.99849 5.91401 1.99949 6.73496ZM7.49996 5.25015C6.25741 5.25015 5.25012 6.25744 5.25012 7.49999C5.25012 8.74254 6.25741 9.74983 7.49996 9.74983C8.74251 9.74983 9.7498 8.74254 9.7498 7.49999C9.7498 6.25744 8.74251 5.25015 7.49996 5.25015ZM4.25012 7.49999C4.25012 5.70515 5.70512 4.25015 7.49996 4.25015C9.2948 4.25015 10.7498 5.70515 10.7498 7.49999C10.7498 9.29483 9.2948 10.7498 7.49996 10.7498C5.70512 10.7498 4.25012 9.29483 4.25012 7.49999ZM10.9697 4.7803C11.3839 4.7803 11.7197 4.44452 11.7197 4.0303C11.7197 3.61609 11.3839 3.2803 10.9697 3.2803C10.5555 3.2803 10.2197 3.61609 10.2197 4.0303C10.2197 4.44452 10.5555 4.7803 10.9697 4.7803Z",
    fill: color
  }));
})));

var _excluded$2G = (/* unused pure expression or super */ null && (["color"]));
var KeyboardIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2G);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 4H1.5C1.22386 4 1 4.22386 1 4.5V10.5C1 10.7761 1.22386 11 1.5 11H13.5C13.7761 11 14 10.7761 14 10.5V4.5C14 4.22386 13.7761 4 13.5 4ZM1.5 3C0.671573 3 0 3.67157 0 4.5V10.5C0 11.3284 0.671573 12 1.5 12H13.5C14.3284 12 15 11.3284 15 10.5V4.5C15 3.67157 14.3284 3 13.5 3H1.5ZM2 5H3V6H2V5ZM5 5H4V6H5V5ZM6 5H7V6H6V5ZM9 5H8V6H9V5ZM10 5H11V6H10V5ZM13 5H12V6H13V5ZM11 7H12V8H11V7ZM13 9H12V10H13V9ZM9 7H10V8H9V7ZM8 7H7V8H8V7ZM5 7H6V8H5V7ZM4 7H3V8H4V7ZM2 9H3V10H2V9ZM11 9H4V10H11V9Z",
    fill: color
  }));
})));

var _excluded$2H = (/* unused pure expression or super */ null && (["color"]));
var LapTimerIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2H);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L12.058 2.05806C12.3021 1.81398 12.6978 1.81398 12.9419 2.05806C13.186 2.30214 13.186 2.69786 12.9419 2.94194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13361 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.49998 8.49998V4.09998C5.06992 4.09998 3.09998 6.06992 3.09998 8.49998C3.09998 10.93 5.06992 12.9 7.49998 12.9C8.715 12.9 9.815 12.4075 10.6112 11.6112L7.49998 8.49998Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2I = ["color"];
var LaptopIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2I);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2 4.25C2 4.11193 2.11193 4 2.25 4H12.75C12.8881 4 13 4.11193 13 4.25V11.5H2V4.25ZM2.25 3C1.55964 3 1 3.55964 1 4.25V12H0V12.5C0 12.7761 0.223858 13 0.5 13H14.5C14.7761 13 15 12.7761 15 12.5V12H14V4.25C14 3.55964 13.4404 3 12.75 3H2.25Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2J = (/* unused pure expression or super */ null && (["color"]));
var LayersIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2J);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.75432 0.819537C7.59742 0.726821 7.4025 0.726821 7.24559 0.819537L1.74559 4.06954C1.59336 4.15949 1.49996 4.32317 1.49996 4.5C1.49996 4.67683 1.59336 4.84051 1.74559 4.93046L7.24559 8.18046C7.4025 8.27318 7.59742 8.27318 7.75432 8.18046L13.2543 4.93046C13.4066 4.84051 13.5 4.67683 13.5 4.5C13.5 4.32317 13.4066 4.15949 13.2543 4.06954L7.75432 0.819537ZM7.49996 7.16923L2.9828 4.5L7.49996 1.83077L12.0171 4.5L7.49996 7.16923ZM1.5695 7.49564C1.70998 7.2579 2.01659 7.17906 2.25432 7.31954L7.49996 10.4192L12.7456 7.31954C12.9833 7.17906 13.2899 7.2579 13.4304 7.49564C13.5709 7.73337 13.4921 8.03998 13.2543 8.18046L7.75432 11.4305C7.59742 11.5232 7.4025 11.5232 7.24559 11.4305L1.74559 8.18046C1.50786 8.03998 1.42901 7.73337 1.5695 7.49564ZM1.56949 10.4956C1.70998 10.2579 2.01658 10.1791 2.25432 10.3195L7.49996 13.4192L12.7456 10.3195C12.9833 10.1791 13.2899 10.2579 13.4304 10.4956C13.5709 10.7334 13.4921 11.04 13.2543 11.1805L7.75432 14.4305C7.59742 14.5232 7.4025 14.5232 7.24559 14.4305L1.74559 11.1805C1.50785 11.04 1.42901 10.7334 1.56949 10.4956Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2K = (/* unused pure expression or super */ null && (["color"]));
var LayoutIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2K);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M9 2H6V13H9V2ZM10 2V13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2H10ZM2.5 2H5V13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2L = ["color"];
var LetterCaseCapitalizeIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2L);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.68979 2.75C3.89667 2.74979 4.08232 2.87701 4.15679 3.07003L7.36662 11.39C7.46602 11.6477 7.33774 11.9371 7.0801 12.0365C6.82247 12.1359 6.53304 12.0076 6.43365 11.75L5.3825 9.02537H2.01133L0.966992 11.749C0.868128 12.0068 0.578964 12.1357 0.321126 12.0369C0.0632878 11.938 -0.0655864 11.6488 0.0332774 11.391L3.22344 3.07099C3.29751 2.87782 3.4829 2.75021 3.68979 2.75ZM3.69174 4.64284L5.05458 8.17537H2.33724L3.69174 4.64284ZM10.8989 5.20703C9.25818 5.20703 8.00915 6.68569 8.00915 8.60972C8.00915 10.6337 9.35818 12.0124 10.8989 12.0124C11.7214 12.0124 12.5744 11.6692 13.1543 11.0219V11.53C13.1543 11.7785 13.3557 11.98 13.6043 11.98C13.8528 11.98 14.0543 11.7785 14.0543 11.53V5.72C14.0543 5.47147 13.8528 5.27 13.6043 5.27C13.3557 5.27 13.1543 5.47147 13.1543 5.72V6.22317C12.6054 5.60095 11.7924 5.20703 10.8989 5.20703ZM13.1543 9.79823V7.30195C12.7639 6.58101 11.9414 6.05757 11.0868 6.05757C10.1088 6.05757 9.03503 6.96581 9.03503 8.60955C9.03503 10.1533 10.0088 11.1615 11.0868 11.1615C11.9701 11.1615 12.7719 10.4952 13.1543 9.79823Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2M = ["color"];
var LetterCaseLowercaseIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2M);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.69899 5.20703C2.05823 5.20703 0.809204 6.68569 0.809204 8.60972C0.809204 10.6337 2.15823 12.0124 3.69899 12.0124C4.52126 12.0124 5.37402 11.6693 5.9539 11.0223V11.53C5.9539 11.7785 6.15537 11.98 6.4039 11.98C6.65243 11.98 6.8539 11.7785 6.8539 11.53V5.72001C6.8539 5.47149 6.65243 5.27001 6.4039 5.27001C6.15537 5.27001 5.9539 5.47149 5.9539 5.72001V6.22269C5.40506 5.60075 4.59218 5.20703 3.69899 5.20703ZM5.9539 9.799V7.30117C5.56339 6.58064 4.74118 6.05757 3.8868 6.05757C2.9089 6.05757 1.83508 6.96581 1.83508 8.60955C1.83508 10.1533 2.80889 11.1615 3.8868 11.1615C4.76984 11.1615 5.57141 10.4957 5.9539 9.799ZM10.799 5.20703C9.15823 5.20703 7.9092 6.68569 7.9092 8.60972C7.9092 10.6337 9.25823 12.0124 10.799 12.0124C11.6215 12.0124 12.4744 11.6692 13.0543 11.0218V11.53C13.0543 11.7785 13.2558 11.98 13.5043 11.98C13.7529 11.98 13.9543 11.7785 13.9543 11.53V5.72C13.9543 5.47147 13.7529 5.27 13.5043 5.27C13.2558 5.27 13.0543 5.47147 13.0543 5.72V6.22318C12.5055 5.60095 11.6924 5.20703 10.799 5.20703ZM13.0543 9.79822V7.30196C12.664 6.58102 11.8415 6.05757 10.9868 6.05757C10.0089 6.05757 8.93508 6.96581 8.93508 8.60955C8.93508 10.1533 9.90889 11.1615 10.9868 11.1615C11.8702 11.1615 12.672 10.4952 13.0543 9.79822Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2N = (/* unused pure expression or super */ null && (["color"]));
var LetterCaseToggleIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2N);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M11.2895 2.75C11.4964 2.74979 11.6821 2.87701 11.7565 3.07003L14.9664 11.39C15.0657 11.6477 14.9375 11.9371 14.6798 12.0365C14.4222 12.1359 14.1328 12.0076 14.0334 11.75L12.9822 9.02537H9.61106L8.56672 11.749C8.46786 12.0068 8.1787 12.1357 7.92086 12.0369C7.66302 11.938 7.53415 11.6488 7.63301 11.391L10.8232 3.07099C10.8972 2.87782 11.0826 2.75021 11.2895 2.75ZM11.2915 4.64284L12.6543 8.17537H9.93698L11.2915 4.64284ZM2.89895 5.20703C1.25818 5.20703 0.00915527 6.68569 0.00915527 8.60972C0.00915527 10.6337 1.35818 12.0124 2.89895 12.0124C3.72141 12.0124 4.57438 11.6692 5.15427 11.0219V11.53C5.15427 11.7785 5.35574 11.98 5.60427 11.98C5.8528 11.98 6.05427 11.7785 6.05427 11.53V5.72C6.05427 5.47147 5.8528 5.27 5.60427 5.27C5.35574 5.27 5.15427 5.47147 5.15427 5.72V6.22317C4.60543 5.60095 3.79236 5.20703 2.89895 5.20703ZM5.15427 9.79823V7.30195C4.76393 6.58101 3.94144 6.05757 3.08675 6.05757C2.10885 6.05757 1.03503 6.96581 1.03503 8.60955C1.03503 10.1533 2.00885 11.1615 3.08675 11.1615C3.97011 11.1615 4.77195 10.4952 5.15427 9.79823Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2O = ["color"];
var LetterCaseUppercaseIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2O);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.6255 2.75C3.83478 2.75 4.02192 2.88034 4.09448 3.07664L7.16985 11.3962C7.2656 11.6552 7.13324 11.9428 6.87423 12.0386C6.61522 12.1343 6.32763 12.002 6.23188 11.7429L5.22387 9.01603H2.02712L1.01911 11.7429C0.923362 12.002 0.635774 12.1343 0.376762 12.0386C0.117749 11.9428 -0.0146052 11.6552 0.0811401 11.3962L3.15651 3.07664C3.22908 2.88034 3.41621 2.75 3.6255 2.75ZM3.6255 4.69207L4.90966 8.16603H2.34133L3.6255 4.69207ZM11.3719 2.75C11.5811 2.75 11.7683 2.88034 11.8408 3.07664L14.9162 11.3962C15.012 11.6552 14.8796 11.9428 14.6206 12.0386C14.3616 12.1343 14.074 12.002 13.9782 11.7429L12.9702 9.01603H9.77348L8.76547 11.7429C8.66972 12.002 8.38213 12.1343 8.12312 12.0386C7.86411 11.9428 7.73175 11.6552 7.8275 11.3962L10.9029 3.07664C10.9754 2.88034 11.1626 2.75 11.3719 2.75ZM11.3719 4.69207L12.656 8.16603H10.0877L11.3719 4.69207Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2P = (/* unused pure expression or super */ null && (["color"]));
var LetterSpacingIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2P);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4.55293 0.999969C4.75295 0.999969 4.93372 1.11917 5.0125 1.30301L8.01106 8.29982C8.11984 8.55363 8.00226 8.84757 7.74844 8.95635C7.49463 9.06512 7.20069 8.94754 7.09191 8.69373L6.11613 6.41685H2.98973L2.01395 8.69373C1.90517 8.94754 1.61123 9.06512 1.35742 8.95635C1.1036 8.84757 0.986023 8.55363 1.0948 8.29982L4.09336 1.30301C4.17214 1.11917 4.35291 0.999969 4.55293 0.999969ZM4.55293 2.76929L5.75186 5.56685H3.354L4.55293 2.76929ZM11.0562 9.00214C11.2617 9.00214 11.4463 8.87633 11.5215 8.68502L14.2733 1.68299C14.3743 1.42598 14.2478 1.13575 13.9908 1.03475C13.7338 0.933747 13.4436 1.06021 13.3426 1.31722L11.0562 7.13514L8.76973 1.31722C8.66873 1.06021 8.3785 0.933747 8.1215 1.03475C7.86449 1.13575 7.73802 1.42598 7.83902 1.68299L10.5908 8.68502C10.666 8.87633 10.8506 9.00214 11.0562 9.00214ZM14.9537 12.4999C14.9537 12.606 14.9115 12.7077 14.8365 12.7828L12.8365 14.7828C12.6803 14.939 12.4271 14.939 12.2708 14.7828C12.1146 14.6265 12.1146 14.3733 12.2708 14.2171L13.588 12.8999H1.51937L2.83653 14.2171C2.99274 14.3733 2.99274 14.6265 2.83653 14.7828C2.68032 14.939 2.42705 14.939 2.27084 14.7828L0.270843 12.7828C0.195828 12.7077 0.153687 12.606 0.153687 12.4999C0.153687 12.3938 0.195828 12.2921 0.270843 12.2171L2.27084 10.2171C2.42705 10.0609 2.68032 10.0609 2.83653 10.2171C2.99274 10.3733 2.99274 10.6265 2.83653 10.7828L1.51937 12.0999L13.588 12.0999L12.2708 10.7828C12.1146 10.6265 12.1146 10.3733 12.2708 10.2171C12.4271 10.0609 12.6803 10.0609 12.8365 10.2171L14.8365 12.2171C14.9115 12.2921 14.9537 12.3938 14.9537 12.4999Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2Q = ["color"];
var LightningBoltIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2Q);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M8.69667 0.0403541C8.90859 0.131038 9.03106 0.354857 8.99316 0.582235L8.0902 6.00001H12.5C12.6893 6.00001 12.8625 6.10701 12.9472 6.27641C13.0319 6.4458 13.0136 6.6485 12.8999 6.80001L6.89997 14.8C6.76167 14.9844 6.51521 15.0503 6.30328 14.9597C6.09135 14.869 5.96888 14.6452 6.00678 14.4178L6.90974 9H2.49999C2.31061 9 2.13748 8.893 2.05278 8.72361C1.96809 8.55422 1.98636 8.35151 2.09999 8.2L8.09997 0.200038C8.23828 0.0156255 8.48474 -0.0503301 8.69667 0.0403541ZM3.49999 8.00001H7.49997C7.64695 8.00001 7.78648 8.06467 7.88148 8.17682C7.97648 8.28896 8.01733 8.43723 7.99317 8.5822L7.33027 12.5596L11.5 7.00001H7.49997C7.353 7.00001 7.21347 6.93534 7.11846 6.8232C7.02346 6.71105 6.98261 6.56279 7.00678 6.41781L7.66968 2.44042L3.49999 8.00001Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2R = (/* unused pure expression or super */ null && (["color"]));
var LineHeightIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2R);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.78233 2.21713C3.70732 2.14212 3.60557 2.09998 3.49949 2.09998C3.3934 2.09998 3.29166 2.14212 3.21664 2.21713L1.21664 4.21713C1.06044 4.37334 1.06044 4.62661 1.21664 4.78282C1.37285 4.93903 1.62612 4.93903 1.78233 4.78282L3.09949 3.46566L3.09949 11.5343L1.78233 10.2171C1.62612 10.0609 1.37285 10.0609 1.21664 10.2171C1.06043 10.3733 1.06043 10.6266 1.21664 10.7828L3.21664 12.7828C3.29166 12.8578 3.3934 12.9 3.49949 12.9C3.60557 12.9 3.70731 12.8578 3.78233 12.7828L5.78233 10.7828C5.93854 10.6266 5.93854 10.3733 5.78233 10.2171C5.62612 10.0609 5.37285 10.0609 5.21664 10.2171L3.89949 11.5343L3.89949 3.46566L5.21664 4.78282C5.37285 4.93903 5.62612 4.93903 5.78233 4.78282C5.93854 4.62661 5.93854 4.37334 5.78233 4.21713L3.78233 2.21713ZM8.49998 3.99997C8.22383 3.99997 7.99998 4.22382 7.99998 4.49997C7.99998 4.77611 8.22383 4.99997 8.49998 4.99997H14.5C14.7761 4.99997 15 4.77611 15 4.49997C15 4.22382 14.7761 3.99997 14.5 3.99997H8.49998ZM7.99998 7.49997C7.99998 7.22382 8.22383 6.99997 8.49998 6.99997H14.5C14.7761 6.99997 15 7.22382 15 7.49997C15 7.77611 14.7761 7.99997 14.5 7.99997H8.49998C8.22383 7.99997 7.99998 7.77611 7.99998 7.49997ZM8.49998 9.99997C8.22383 9.99997 7.99998 10.2238 7.99998 10.5C7.99998 10.7761 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7761 15 10.5C15 10.2238 14.7761 9.99997 14.5 9.99997H8.49998Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2S = ["color"];
var Link1Icon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2S);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M4.62471 4.00001L4.56402 4.00001C4.04134 3.99993 3.70687 3.99988 3.4182 4.055C2.2379 4.28039 1.29846 5.17053 1.05815 6.33035C0.999538 6.61321 0.999604 6.93998 0.999703 7.43689L0.999711 7.50001L0.999703 7.56313C0.999604 8.06004 0.999538 8.38681 1.05815 8.66967C1.29846 9.8295 2.2379 10.7196 3.4182 10.945C3.70688 11.0001 4.04135 11.0001 4.56403 11L4.62471 11H5.49971C5.77585 11 5.99971 10.7762 5.99971 10.5C5.99971 10.2239 5.77585 10 5.49971 10H4.62471C4.02084 10 3.78907 9.99777 3.60577 9.96277C2.80262 9.8094 2.19157 9.21108 2.03735 8.46678C2.00233 8.29778 1.99971 8.08251 1.99971 7.50001C1.99971 6.91752 2.00233 6.70225 2.03735 6.53324C2.19157 5.78895 2.80262 5.19062 3.60577 5.03725C3.78907 5.00225 4.02084 5.00001 4.62471 5.00001H5.49971C5.77585 5.00001 5.99971 4.77615 5.99971 4.50001C5.99971 4.22387 5.77585 4.00001 5.49971 4.00001H4.62471ZM10.3747 5.00001C10.9786 5.00001 11.2104 5.00225 11.3937 5.03725C12.1968 5.19062 12.8079 5.78895 12.9621 6.53324C12.9971 6.70225 12.9997 6.91752 12.9997 7.50001C12.9997 8.08251 12.9971 8.29778 12.9621 8.46678C12.8079 9.21108 12.1968 9.8094 11.3937 9.96277C11.2104 9.99777 10.9786 10 10.3747 10H9.49971C9.22357 10 8.99971 10.2239 8.99971 10.5C8.99971 10.7762 9.22357 11 9.49971 11H10.3747L10.4354 11C10.9581 11.0001 11.2925 11.0001 11.5812 10.945C12.7615 10.7196 13.701 9.8295 13.9413 8.66967C13.9999 8.38681 13.9998 8.06005 13.9997 7.56314L13.9997 7.50001L13.9997 7.43688C13.9998 6.93998 13.9999 6.61321 13.9413 6.33035C13.701 5.17053 12.7615 4.28039 11.5812 4.055C11.2925 3.99988 10.9581 3.99993 10.4354 4.00001L10.3747 4.00001H9.49971C9.22357 4.00001 8.99971 4.22387 8.99971 4.50001C8.99971 4.77615 9.22357 5.00001 9.49971 5.00001H10.3747ZM5.00038 7C4.72424 7 4.50038 7.22386 4.50038 7.5C4.50038 7.77614 4.72424 8 5.00038 8H10.0004C10.2765 8 10.5004 7.77614 10.5004 7.5C10.5004 7.22386 10.2765 7 10.0004 7H5.00038Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2T = ["color"];
var Link2Icon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2T);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M8.51194 3.00541C9.18829 2.54594 10.0435 2.53694 10.6788 2.95419C10.8231 3.04893 10.9771 3.1993 11.389 3.61119C11.8009 4.02307 11.9513 4.17714 12.046 4.32141C12.4633 4.95675 12.4543 5.81192 11.9948 6.48827C11.8899 6.64264 11.7276 6.80811 11.3006 7.23511L10.6819 7.85383C10.4867 8.04909 10.4867 8.36567 10.6819 8.56093C10.8772 8.7562 11.1938 8.7562 11.389 8.56093L12.0077 7.94221L12.0507 7.89929C12.4203 7.52976 12.6568 7.2933 12.822 7.0502C13.4972 6.05623 13.5321 4.76252 12.8819 3.77248C12.7233 3.53102 12.4922 3.30001 12.1408 2.94871L12.0961 2.90408L12.0515 2.85942C11.7002 2.508 11.4692 2.27689 11.2277 2.11832C10.2377 1.46813 8.94398 1.50299 7.95001 2.17822C7.70691 2.34336 7.47044 2.57991 7.1009 2.94955L7.058 2.99247L6.43928 3.61119C6.24401 3.80645 6.24401 4.12303 6.43928 4.31829C6.63454 4.51355 6.95112 4.51355 7.14638 4.31829L7.7651 3.69957C8.1921 3.27257 8.35757 3.11027 8.51194 3.00541ZM4.31796 7.14672C4.51322 6.95146 4.51322 6.63487 4.31796 6.43961C4.12269 6.24435 3.80611 6.24435 3.61085 6.43961L2.99213 7.05833L2.94922 7.10124C2.57957 7.47077 2.34303 7.70724 2.17788 7.95035C1.50265 8.94432 1.4678 10.238 2.11799 11.2281C2.27656 11.4695 2.50766 11.7005 2.8591 12.0518L2.90374 12.0965L2.94837 12.1411C3.29967 12.4925 3.53068 12.7237 3.77214 12.8822C4.76219 13.5324 6.05589 13.4976 7.04986 12.8223C7.29296 12.6572 7.52943 12.4206 7.89896 12.051L7.89897 12.051L7.94188 12.0081L8.5606 11.3894C8.75586 11.1941 8.75586 10.8775 8.5606 10.6823C8.36533 10.487 8.04875 10.487 7.85349 10.6823L7.23477 11.301C6.80777 11.728 6.6423 11.8903 6.48794 11.9951C5.81158 12.4546 4.95642 12.4636 4.32107 12.0464C4.17681 11.9516 4.02274 11.8012 3.61085 11.3894C3.19896 10.9775 3.0486 10.8234 2.95385 10.6791C2.53661 10.0438 2.54561 9.18863 3.00507 8.51227C3.10993 8.35791 3.27224 8.19244 3.69924 7.76544L4.31796 7.14672ZM9.62172 6.08558C9.81698 5.89032 9.81698 5.57373 9.62172 5.37847C9.42646 5.18321 9.10988 5.18321 8.91461 5.37847L5.37908 8.91401C5.18382 9.10927 5.18382 9.42585 5.37908 9.62111C5.57434 9.81637 5.89092 9.81637 6.08619 9.62111L9.62172 6.08558Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2U = ["color"];
var LinkBreak1Icon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2U);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L13.3536 2.35355ZM2.03735 8.46678C2.17398 9.12619 2.66918 9.67103 3.33886 9.89338L2.57833 10.6539C1.80843 10.2534 1.23784 9.53693 1.05815 8.66967C0.999538 8.38681 0.999604 8.06004 0.999703 7.56313L0.999711 7.50001L0.999703 7.43689C0.999604 6.93998 0.999538 6.61321 1.05815 6.33035C1.29846 5.17053 2.2379 4.28039 3.4182 4.055C3.70687 3.99988 4.04134 3.99993 4.56402 4.00001L4.62471 4.00001H5.49971C5.77585 4.00001 5.99971 4.22387 5.99971 4.50001C5.99971 4.77615 5.77585 5.00001 5.49971 5.00001H4.62471C4.02084 5.00001 3.78907 5.00225 3.60577 5.03725C2.80262 5.19062 2.19157 5.78895 2.03735 6.53324C2.00233 6.70225 1.99971 6.91752 1.99971 7.50001C1.99971 8.08251 2.00233 8.29778 2.03735 8.46678ZM12.9621 6.53324C12.8255 5.87397 12.3304 5.32922 11.661 5.10679L12.4215 4.34631C13.1912 4.74686 13.7616 5.46323 13.9413 6.33035C13.9999 6.61321 13.9998 6.93998 13.9997 7.43688L13.9997 7.50001L13.9997 7.56314C13.9998 8.06005 13.9999 8.38681 13.9413 8.66967C13.701 9.8295 12.7615 10.7196 11.5812 10.945C11.2925 11.0001 10.9581 11.0001 10.4354 11L10.3747 11H9.49971C9.22357 11 8.99971 10.7762 8.99971 10.5C8.99971 10.2239 9.22357 10 9.49971 10H10.3747C10.9786 10 11.2104 9.99777 11.3937 9.96277C12.1968 9.8094 12.8079 9.21108 12.9621 8.46678C12.9971 8.29778 12.9997 8.08251 12.9997 7.50001C12.9997 6.91752 12.9971 6.70225 12.9621 6.53324Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2V = (/* unused pure expression or super */ null && (["color"]));
var LinkBreak2Icon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2V);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4.50021 0C4.77635 0 5.0002 0.223853 5.0002 0.49999V2.49995C5.0002 2.77609 4.77635 2.99994 4.50021 2.99994C4.22408 2.99994 4.00022 2.77609 4.00022 2.49995V0.49999C4.00022 0.223853 4.22408 0 4.50021 0ZM0.646451 0.64647C0.84171 0.451212 1.15829 0.451212 1.35354 0.64647L2.85351 2.14644C3.04877 2.3417 3.04877 2.65827 2.85351 2.85353C2.65826 3.04879 2.34168 3.04879 2.14642 2.85353L0.646452 1.35356C0.451193 1.1583 0.451193 0.841728 0.646451 0.64647ZM0.00030517 4.49991C0.00030517 4.22377 0.224158 3.99992 0.500295 3.99992H2.50025C2.77639 3.99992 3.00024 4.22377 3.00024 4.49991C3.00024 4.77605 2.77639 4.9999 2.50025 4.9999H0.500295C0.224158 4.9999 0.00030517 4.77605 0.00030517 4.49991ZM12.0001 10.4998C12.0001 10.2236 12.2239 9.9998 12.5001 9.9998H14.5C14.7761 9.9998 15 10.2236 15 10.4998C15 10.7759 14.7761 10.9998 14.5 10.9998H12.5001C12.2239 10.9998 12.0001 10.7759 12.0001 10.4998ZM10.5001 11.9998C10.7762 11.9998 11.0001 12.2236 11.0001 12.4997V14.4997C11.0001 14.7758 10.7762 14.9997 10.5001 14.9997C10.224 14.9997 10.0001 14.7758 10.0001 14.4997V12.4997C10.0001 12.2236 10.224 11.9998 10.5001 11.9998ZM12.1462 12.1462C12.3415 11.951 12.658 11.951 12.8533 12.1462L14.3533 13.6462C14.5485 13.8415 14.5485 14.158 14.3533 14.3533C14.158 14.5485 13.8414 14.5485 13.6462 14.3533L12.1462 12.8533C11.951 12.6581 11.951 12.3415 12.1462 12.1462ZM7.76478 3.69938C8.19177 3.27238 8.35724 3.11008 8.5116 3.00522C9.18794 2.54577 10.0431 2.53677 10.6784 2.95401C10.8227 3.04875 10.9767 3.19911 11.3886 3.61099C11.8005 4.02287 11.9509 4.17694 12.0456 4.3212C12.4628 4.95653 12.4539 5.81168 11.9944 6.48802C11.8895 6.64238 11.7272 6.80785 11.3002 7.23484L10.6815 7.85354C10.4863 8.0488 10.4863 8.36538 10.6815 8.56064C10.8768 8.75589 11.1934 8.75589 11.3886 8.56064L12.0073 7.94193L12.0502 7.89903C12.4199 7.5295 12.6564 7.29303 12.8216 7.04993C13.4968 6.05598 13.5316 4.7623 12.8815 3.77228C12.7229 3.53083 12.4918 3.29982 12.1404 2.94853L12.0957 2.9039L12.0511 2.85925C11.6998 2.50782 11.4688 2.27672 11.2273 2.11816C10.2373 1.46798 8.94364 1.50284 7.94968 2.17805C7.70659 2.34319 7.47012 2.57973 7.1006 2.94936L7.1006 2.94937L7.05769 2.99228L6.43898 3.61099C6.24372 3.80625 6.24372 4.12282 6.43898 4.31808C6.63424 4.51334 6.95081 4.51334 7.14607 4.31808L7.76478 3.69938ZM2.99191 7.05807L2.94899 7.10097C2.57935 7.4705 2.34282 7.70697 2.17767 7.95006C1.50246 8.94401 1.4676 10.2377 2.11778 11.2277C2.27634 11.4692 2.50744 11.7002 2.85886 12.0515L2.85888 12.0515L2.90352 12.0961L2.94815 12.1407L2.94815 12.1407L2.94817 12.1408C3.29945 12.4922 3.53045 12.7233 3.7719 12.8818C4.76193 13.532 6.0556 13.4972 7.04956 12.8219C7.29265 12.6568 7.52912 12.4203 7.89865 12.0506L7.94155 12.0077L8.56026 11.389C8.75552 11.1937 8.75552 10.8772 8.56026 10.6819C8.365 10.4867 8.04842 10.4867 7.85317 10.6819L7.23446 11.3006C6.80747 11.7276 6.642 11.8899 6.48764 11.9948C5.8113 12.4542 4.95615 12.4632 4.32082 12.046C4.17656 11.9512 4.02249 11.8009 3.61061 11.389C3.19873 10.9771 3.04837 10.8231 2.95363 10.6788C2.53639 10.0435 2.54539 9.18832 3.00484 8.51198C3.10971 8.35761 3.27201 8.19215 3.699 7.76516L4.3177 7.14645C4.51296 6.95119 4.51296 6.63462 4.3177 6.43936C4.12245 6.2441 3.80587 6.2441 3.61061 6.43936L2.99191 7.05807Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2W = (/* unused pure expression or super */ null && (["color"]));
var LinkNone1Icon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2W);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4.56427 3.99988C4.58422 3.99989 4.60445 3.99989 4.62496 3.99989H5.49996C5.7761 3.99989 5.99996 4.22375 5.99996 4.49989C5.99996 4.77603 5.7761 4.99989 5.49996 4.99989H4.62496C4.02108 4.99989 3.78932 5.00213 3.60601 5.03713C2.80287 5.1905 2.19181 5.78883 2.03759 6.53312C2.00257 6.70212 1.99996 6.91739 1.99996 7.49989C1.99996 8.08239 2.00257 8.29766 2.03759 8.46666C2.19181 9.21095 2.80287 9.80928 3.60601 9.96265C3.78932 9.99765 4.02108 9.99989 4.62496 9.99989H5.49996C5.7761 9.99989 5.99996 10.2237 5.99996 10.4999C5.99996 10.776 5.7761 10.9999 5.49996 10.9999H4.62496C4.60445 10.9999 4.58422 10.9999 4.56427 10.9999C4.04159 11 3.70712 11 3.41845 10.9449C2.23814 10.7195 1.29871 9.82937 1.05839 8.66955C0.999782 8.38669 0.999848 8.05992 0.999947 7.56301C0.999951 7.54227 0.999955 7.52123 0.999955 7.49989C0.999955 7.47855 0.999951 7.45751 0.999947 7.43677C0.999848 6.93986 0.999782 6.61309 1.05839 6.33023C1.29871 5.17041 2.23814 4.28027 3.41845 4.05488C3.70712 3.99976 4.04159 3.99981 4.56427 3.99988ZM11.3939 5.03713C11.2106 5.00213 10.9788 4.99989 10.375 4.99989H9.49996C9.22381 4.99989 8.99996 4.77603 8.99996 4.49989C8.99996 4.22375 9.22381 3.99989 9.49996 3.99989H10.375C10.3955 3.99989 10.4157 3.99989 10.4356 3.99988C10.9583 3.99981 11.2928 3.99976 11.5815 4.05488C12.7618 4.28027 13.7012 5.17041 13.9415 6.33023C14.0001 6.61309 14.0001 6.93985 14 7.43676C14 7.4575 14 7.47854 14 7.49989C14 7.52124 14 7.54228 14 7.56302C14.0001 8.05992 14.0001 8.38669 13.9415 8.66955C13.7012 9.82937 12.7618 10.7195 11.5815 10.9449C11.2928 11 10.9583 11 10.4356 10.9999C10.4157 10.9999 10.3955 10.9999 10.375 10.9999H9.49996C9.22381 10.9999 8.99996 10.776 8.99996 10.4999C8.99996 10.2237 9.22381 9.99989 9.49996 9.99989H10.375C10.9788 9.99989 11.2106 9.99765 11.3939 9.96265C12.197 9.80928 12.8081 9.21095 12.9623 8.46666C12.9973 8.29766 13 8.08239 13 7.49989C13 6.91739 12.9973 6.70212 12.9623 6.53312C12.8081 5.78883 12.197 5.1905 11.3939 5.03713Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2X = ["color"];
var LinkNone2Icon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2X);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M10.6788 2.95419C10.0435 2.53694 9.18829 2.54594 8.51194 3.00541C8.35757 3.11027 8.1921 3.27257 7.7651 3.69957L7.14638 4.31829C6.95112 4.51355 6.63454 4.51355 6.43928 4.31829C6.24401 4.12303 6.24401 3.80645 6.43928 3.61119L7.058 2.99247C7.0725 2.97797 7.08679 2.96366 7.1009 2.94955C7.47044 2.57991 7.70691 2.34336 7.95001 2.17822C8.94398 1.50299 10.2377 1.46813 11.2277 2.11832C11.4692 2.27689 11.7002 2.508 12.0515 2.85942C12.0662 2.8741 12.081 2.88898 12.0961 2.90408C12.1112 2.91917 12.1261 2.93405 12.1408 2.94871C12.4922 3.30001 12.7233 3.53102 12.8819 3.77248C13.5321 4.76252 13.4972 6.05623 12.822 7.0502C12.6568 7.2933 12.4203 7.52976 12.0507 7.89929C12.0366 7.9134 12.0222 7.92771 12.0077 7.94221L11.389 8.56093C11.1938 8.7562 10.8772 8.7562 10.6819 8.56093C10.4867 8.36567 10.4867 8.04909 10.6819 7.85383L11.3006 7.23511C11.7276 6.80811 11.8899 6.64264 11.9948 6.48827C12.4543 5.81192 12.4633 4.95675 12.046 4.32141C11.9513 4.17714 11.8009 4.02307 11.389 3.61119C10.9771 3.1993 10.8231 3.04893 10.6788 2.95419ZM4.31796 6.43961C4.51322 6.63487 4.51322 6.95146 4.31796 7.14672L3.69924 7.76544C3.27224 8.19244 3.10993 8.35791 3.00507 8.51227C2.54561 9.18863 2.53661 10.0438 2.95385 10.6791C3.0486 10.8234 3.19896 10.9775 3.61085 11.3894C4.02274 11.8012 4.17681 11.9516 4.32107 12.0464C4.95642 12.4636 5.81158 12.4546 6.48794 11.9951C6.6423 11.8903 6.80777 11.728 7.23477 11.301L7.85349 10.6823C8.04875 10.487 8.36533 10.487 8.5606 10.6823C8.75586 10.8775 8.75586 11.1941 8.5606 11.3894L7.94188 12.0081C7.92738 12.0226 7.91307 12.0369 7.89897 12.051C7.52943 12.4206 7.29296 12.6572 7.04986 12.8223C6.05589 13.4976 4.76219 13.5324 3.77214 12.8822C3.53068 12.7237 3.29967 12.4925 2.94837 12.1411C2.93371 12.1264 2.91883 12.1116 2.90374 12.0965C2.88865 12.0814 2.87377 12.0665 2.8591 12.0518C2.50766 11.7005 2.27656 11.4695 2.11799 11.2281C1.4678 10.238 1.50265 8.94432 2.17788 7.95035C2.34303 7.70724 2.57957 7.47077 2.94922 7.10124C2.96333 7.08713 2.97763 7.07283 2.99213 7.05833L3.61085 6.43961C3.80611 6.24435 4.12269 6.24435 4.31796 6.43961Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2Y = (/* unused pure expression or super */ null && (["color"]));
var LinkedInLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2Y);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M2 1C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V2C14 1.44772 13.5523 1 13 1H2ZM3.05 6H4.95V12H3.05V6ZM5.075 4.005C5.075 4.59871 4.59371 5.08 4 5.08C3.4063 5.08 2.925 4.59871 2.925 4.005C2.925 3.41129 3.4063 2.93 4 2.93C4.59371 2.93 5.075 3.41129 5.075 4.005ZM12 8.35713C12 6.55208 10.8334 5.85033 9.67449 5.85033C9.29502 5.83163 8.91721 5.91119 8.57874 6.08107C8.32172 6.21007 8.05265 6.50523 7.84516 7.01853H7.79179V6.00044H6V12.0047H7.90616V8.8112C7.8786 8.48413 7.98327 8.06142 8.19741 7.80987C8.41156 7.55832 8.71789 7.49825 8.95015 7.46774H9.02258C9.62874 7.46774 10.0786 7.84301 10.0786 8.78868V12.0047H11.9847L12 8.35713Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$2Z = ["color"];
var ListBulletIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2Z);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1.5 5.25C1.91421 5.25 2.25 4.91421 2.25 4.5C2.25 4.08579 1.91421 3.75 1.5 3.75C1.08579 3.75 0.75 4.08579 0.75 4.5C0.75 4.91421 1.08579 5.25 1.5 5.25ZM4 4.5C4 4.22386 4.22386 4 4.5 4H13.5C13.7761 4 14 4.22386 14 4.5C14 4.77614 13.7761 5 13.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H13.5C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H4.5ZM2.25 7.5C2.25 7.91421 1.91421 8.25 1.5 8.25C1.08579 8.25 0.75 7.91421 0.75 7.5C0.75 7.08579 1.08579 6.75 1.5 6.75C1.91421 6.75 2.25 7.08579 2.25 7.5ZM1.5 11.25C1.91421 11.25 2.25 10.9142 2.25 10.5C2.25 10.0858 1.91421 9.75 1.5 9.75C1.08579 9.75 0.75 10.0858 0.75 10.5C0.75 10.9142 1.08579 11.25 1.5 11.25Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2_ = ["color"];
var LockClosedIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2_);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M5 4.63601C5 3.76031 5.24219 3.1054 5.64323 2.67357C6.03934 2.24705 6.64582 1.9783 7.5014 1.9783C8.35745 1.9783 8.96306 2.24652 9.35823 2.67208C9.75838 3.10299 10 3.75708 10 4.63325V5.99999H5V4.63601ZM4 5.99999V4.63601C4 3.58148 4.29339 2.65754 4.91049 1.99307C5.53252 1.32329 6.42675 0.978302 7.5014 0.978302C8.57583 0.978302 9.46952 1.32233 10.091 1.99162C10.7076 2.65557 11 3.57896 11 4.63325V5.99999H12C12.5523 5.99999 13 6.44771 13 6.99999V13C13 13.5523 12.5523 14 12 14H3C2.44772 14 2 13.5523 2 13V6.99999C2 6.44771 2.44772 5.99999 3 5.99999H4ZM3 6.99999H12V13H3V6.99999Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$2$ = ["color"];
var LockOpen1Icon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2$);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.4986 0C6.3257 0 5.36107 0.38943 4.73753 1.19361C4.23745 1.83856 4 2.68242 4 3.63325H5C5 2.84313 5.19691 2.23312 5.5278 1.80636C5.91615 1.30552 6.55152 1 7.4986 1C8.35683 1 8.96336 1.26502 9.35846 1.68623C9.75793 2.11211 10 2.76044 10 3.63601V6H3C2.44772 6 2 6.44772 2 7V13C2 13.5523 2.44772 14 3 14H12C12.5523 14 13 13.5523 13 13V7C13 6.44771 12.5523 6 12 6H11V3.63601C11 2.58135 10.7065 1.66167 10.0878 1.0021C9.46477 0.337871 8.57061 0 7.4986 0ZM3 7H12V13H3V7Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$30 = (/* unused pure expression or super */ null && (["color"]));
var LockOpen2Icon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$30);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M9 3.63601C9 2.76044 9.24207 2.11211 9.64154 1.68623C10.0366 1.26502 10.6432 1 11.5014 1C12.4485 1 13.0839 1.30552 13.4722 1.80636C13.8031 2.23312 14 2.84313 14 3.63325H15C15 2.68242 14.7626 1.83856 14.2625 1.19361C13.6389 0.38943 12.6743 0 11.5014 0C10.4294 0 9.53523 0.337871 8.91218 1.0021C8.29351 1.66167 8 2.58135 8 3.63601V6H1C0.447715 6 0 6.44772 0 7V13C0 13.5523 0.447715 14 1 14H10C10.5523 14 11 13.5523 11 13V7C11 6.44772 10.5523 6 10 6H9V3.63601ZM1 7H10V13H1V7Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$31 = ["color"];
var LoopIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$31);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.35355 1.85355C3.54882 1.65829 3.54882 1.34171 3.35355 1.14645C3.15829 0.951184 2.84171 0.951184 2.64645 1.14645L0.646447 3.14645C0.451184 3.34171 0.451184 3.65829 0.646447 3.85355L2.64645 5.85355C2.84171 6.04882 3.15829 6.04882 3.35355 5.85355C3.54882 5.65829 3.54882 5.34171 3.35355 5.14645L2.20711 4H9.5C11.433 4 13 5.567 13 7.5C13 7.77614 13.2239 8 13.5 8C13.7761 8 14 7.77614 14 7.5C14 5.01472 11.9853 3 9.5 3H2.20711L3.35355 1.85355ZM2 7.5C2 7.22386 1.77614 7 1.5 7C1.22386 7 1 7.22386 1 7.5C1 9.98528 3.01472 12 5.5 12H12.7929L11.6464 13.1464C11.4512 13.3417 11.4512 13.6583 11.6464 13.8536C11.8417 14.0488 12.1583 14.0488 12.3536 13.8536L14.3536 11.8536C14.5488 11.6583 14.5488 11.3417 14.3536 11.1464L12.3536 9.14645C12.1583 8.95118 11.8417 8.95118 11.6464 9.14645C11.4512 9.34171 11.4512 9.65829 11.6464 9.85355L12.7929 11H5.5C3.567 11 2 9.433 2 7.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$32 = ["color"];
var MagicWandIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$32);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M13.9 0.499976C13.9 0.279062 13.7209 0.0999756 13.5 0.0999756C13.2791 0.0999756 13.1 0.279062 13.1 0.499976V1.09998H12.5C12.2791 1.09998 12.1 1.27906 12.1 1.49998C12.1 1.72089 12.2791 1.89998 12.5 1.89998H13.1V2.49998C13.1 2.72089 13.2791 2.89998 13.5 2.89998C13.7209 2.89998 13.9 2.72089 13.9 2.49998V1.89998H14.5C14.7209 1.89998 14.9 1.72089 14.9 1.49998C14.9 1.27906 14.7209 1.09998 14.5 1.09998H13.9V0.499976ZM11.8536 3.14642C12.0488 3.34168 12.0488 3.65826 11.8536 3.85353L10.8536 4.85353C10.6583 5.04879 10.3417 5.04879 10.1465 4.85353C9.9512 4.65827 9.9512 4.34169 10.1465 4.14642L11.1464 3.14643C11.3417 2.95116 11.6583 2.95116 11.8536 3.14642ZM9.85357 5.14642C10.0488 5.34168 10.0488 5.65827 9.85357 5.85353L2.85355 12.8535C2.65829 13.0488 2.34171 13.0488 2.14645 12.8535C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L9.14646 5.14642C9.34172 4.95116 9.65831 4.95116 9.85357 5.14642ZM13.5 5.09998C13.7209 5.09998 13.9 5.27906 13.9 5.49998V6.09998H14.5C14.7209 6.09998 14.9 6.27906 14.9 6.49998C14.9 6.72089 14.7209 6.89998 14.5 6.89998H13.9V7.49998C13.9 7.72089 13.7209 7.89998 13.5 7.89998C13.2791 7.89998 13.1 7.72089 13.1 7.49998V6.89998H12.5C12.2791 6.89998 12.1 6.72089 12.1 6.49998C12.1 6.27906 12.2791 6.09998 12.5 6.09998H13.1V5.49998C13.1 5.27906 13.2791 5.09998 13.5 5.09998ZM8.90002 0.499976C8.90002 0.279062 8.72093 0.0999756 8.50002 0.0999756C8.2791 0.0999756 8.10002 0.279062 8.10002 0.499976V1.09998H7.50002C7.2791 1.09998 7.10002 1.27906 7.10002 1.49998C7.10002 1.72089 7.2791 1.89998 7.50002 1.89998H8.10002V2.49998C8.10002 2.72089 8.2791 2.89998 8.50002 2.89998C8.72093 2.89998 8.90002 2.72089 8.90002 2.49998V1.89998H9.50002C9.72093 1.89998 9.90002 1.72089 9.90002 1.49998C9.90002 1.27906 9.72093 1.09998 9.50002 1.09998H8.90002V0.499976Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$33 = ["color"];
var MagnifyingGlassIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$33);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$34 = ["color"];
var MarginIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$34);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1.49988 2.00012C1.77602 2.00012 1.99988 1.77626 1.99988 1.50012C1.99988 1.22398 1.77602 1.00012 1.49988 1.00012C1.22374 1.00012 0.999878 1.22398 0.999878 1.50012C0.999878 1.77626 1.22374 2.00012 1.49988 2.00012ZM4.49988 2.00012C4.77602 2.00012 4.99988 1.77626 4.99988 1.50012C4.99988 1.22398 4.77602 1.00012 4.49988 1.00012C4.22374 1.00012 3.99988 1.22398 3.99988 1.50012C3.99988 1.77626 4.22374 2.00012 4.49988 2.00012ZM7.99988 1.50012C7.99988 1.77626 7.77602 2.00012 7.49988 2.00012C7.22374 2.00012 6.99988 1.77626 6.99988 1.50012C6.99988 1.22398 7.22374 1.00012 7.49988 1.00012C7.77602 1.00012 7.99988 1.22398 7.99988 1.50012ZM10.4999 2.00012C10.776 2.00012 10.9999 1.77626 10.9999 1.50012C10.9999 1.22398 10.776 1.00012 10.4999 1.00012C10.2237 1.00012 9.99988 1.22398 9.99988 1.50012C9.99988 1.77626 10.2237 2.00012 10.4999 2.00012ZM13.9999 1.50012C13.9999 1.77626 13.776 2.00012 13.4999 2.00012C13.2237 2.00012 12.9999 1.77626 12.9999 1.50012C12.9999 1.22398 13.2237 1.00012 13.4999 1.00012C13.776 1.00012 13.9999 1.22398 13.9999 1.50012ZM1.49988 14.0001C1.77602 14.0001 1.99988 13.7763 1.99988 13.5001C1.99988 13.224 1.77602 13.0001 1.49988 13.0001C1.22374 13.0001 0.999878 13.224 0.999878 13.5001C0.999878 13.7763 1.22374 14.0001 1.49988 14.0001ZM1.99988 10.5001C1.99988 10.7763 1.77602 11.0001 1.49988 11.0001C1.22374 11.0001 0.999878 10.7763 0.999878 10.5001C0.999878 10.224 1.22374 10.0001 1.49988 10.0001C1.77602 10.0001 1.99988 10.224 1.99988 10.5001ZM1.49988 8.00012C1.77602 8.00012 1.99988 7.77626 1.99988 7.50012C1.99988 7.22398 1.77602 7.00012 1.49988 7.00012C1.22374 7.00012 0.999878 7.22398 0.999878 7.50012C0.999878 7.77626 1.22374 8.00012 1.49988 8.00012ZM1.99988 4.50012C1.99988 4.77626 1.77602 5.00012 1.49988 5.00012C1.22374 5.00012 0.999878 4.77626 0.999878 4.50012C0.999878 4.22398 1.22374 4.00012 1.49988 4.00012C1.77602 4.00012 1.99988 4.22398 1.99988 4.50012ZM13.4999 11.0001C13.776 11.0001 13.9999 10.7763 13.9999 10.5001C13.9999 10.224 13.776 10.0001 13.4999 10.0001C13.2237 10.0001 12.9999 10.224 12.9999 10.5001C12.9999 10.7763 13.2237 11.0001 13.4999 11.0001ZM13.9999 7.50012C13.9999 7.77626 13.776 8.00012 13.4999 8.00012C13.2237 8.00012 12.9999 7.77626 12.9999 7.50012C12.9999 7.22398 13.2237 7.00012 13.4999 7.00012C13.776 7.00012 13.9999 7.22398 13.9999 7.50012ZM13.4999 5.00012C13.776 5.00012 13.9999 4.77626 13.9999 4.50012C13.9999 4.22398 13.776 4.00012 13.4999 4.00012C13.2237 4.00012 12.9999 4.22398 12.9999 4.50012C12.9999 4.77626 13.2237 5.00012 13.4999 5.00012ZM4.99988 13.5001C4.99988 13.7763 4.77602 14.0001 4.49988 14.0001C4.22374 14.0001 3.99988 13.7763 3.99988 13.5001C3.99988 13.224 4.22374 13.0001 4.49988 13.0001C4.77602 13.0001 4.99988 13.224 4.99988 13.5001ZM7.49988 14.0001C7.77602 14.0001 7.99988 13.7763 7.99988 13.5001C7.99988 13.224 7.77602 13.0001 7.49988 13.0001C7.22374 13.0001 6.99988 13.224 6.99988 13.5001C6.99988 13.7763 7.22374 14.0001 7.49988 14.0001ZM10.9999 13.5001C10.9999 13.7763 10.776 14.0001 10.4999 14.0001C10.2237 14.0001 9.99988 13.7763 9.99988 13.5001C9.99988 13.224 10.2237 13.0001 10.4999 13.0001C10.776 13.0001 10.9999 13.224 10.9999 13.5001ZM13.4999 14.0001C13.776 14.0001 13.9999 13.7763 13.9999 13.5001C13.9999 13.224 13.776 13.0001 13.4999 13.0001C13.2237 13.0001 12.9999 13.224 12.9999 13.5001C12.9999 13.7763 13.2237 14.0001 13.4999 14.0001ZM3.99988 5.00012C3.99988 4.44784 4.44759 4.00012 4.99988 4.00012H9.99988C10.5522 4.00012 10.9999 4.44784 10.9999 5.00012V10.0001C10.9999 10.5524 10.5522 11.0001 9.99988 11.0001H4.99988C4.44759 11.0001 3.99988 10.5524 3.99988 10.0001V5.00012ZM4.99988 5.00012H9.99988V10.0001H4.99988V5.00012Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$35 = (/* unused pure expression or super */ null && (["color"]));
var MaskOffIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$35);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1 2H14V13H1L1 2ZM0 2C0 1.44772 0.447715 1 1 1H14C14.5523 1 15 1.44772 15 2V13C15 13.5523 14.5523 14 14 14H1C0.447715 14 0 13.5523 0 13V2ZM4.875 7.5C4.875 6.05025 6.05025 4.875 7.5 4.875C8.94975 4.875 10.125 6.05025 10.125 7.5C10.125 8.94975 8.94975 10.125 7.5 10.125C6.05025 10.125 4.875 8.94975 4.875 7.5ZM7.5 3.875C5.49797 3.875 3.875 5.49797 3.875 7.5C3.875 9.50203 5.49797 11.125 7.5 11.125C9.50203 11.125 11.125 9.50203 11.125 7.5C11.125 5.49797 9.50203 3.875 7.5 3.875Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$36 = (/* unused pure expression or super */ null && (["color"]));
var MaskOnIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$36);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1 1C0.447715 1 0 1.44772 0 2V13C0 13.5523 0.447715 14 1 14H14C14.5523 14 15 13.5523 15 13V2C15 1.44772 14.5523 1 14 1H1ZM7.5 10.625C9.22589 10.625 10.625 9.22589 10.625 7.5C10.625 5.77411 9.22589 4.375 7.5 4.375C5.77411 4.375 4.375 5.77411 4.375 7.5C4.375 9.22589 5.77411 10.625 7.5 10.625Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$37 = (/* unused pure expression or super */ null && (["color"]));
var MinusIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$37);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M2.25 7.5C2.25 7.22386 2.47386 7 2.75 7H12.25C12.5261 7 12.75 7.22386 12.75 7.5C12.75 7.77614 12.5261 8 12.25 8H2.75C2.47386 8 2.25 7.77614 2.25 7.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$38 = (/* unused pure expression or super */ null && (["color"]));
var MinusCircledIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$38);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM4.50003 7C4.22389 7 4.00003 7.22386 4.00003 7.5C4.00003 7.77614 4.22389 8 4.50003 8H10.5C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7H4.50003Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$39 = ["color"];
var MixIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$39);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2.14921 3.99996C2.14921 2.97778 2.97784 2.14915 4.00002 2.14915C5.02219 2.14915 5.85083 2.97778 5.85083 3.99996C5.85083 5.02213 5.02219 5.85077 4.00002 5.85077C2.97784 5.85077 2.14921 5.02213 2.14921 3.99996ZM4.00002 1.24915C2.48079 1.24915 1.24921 2.48073 1.24921 3.99996C1.24921 5.51919 2.48079 6.75077 4.00002 6.75077C5.51925 6.75077 6.75083 5.51919 6.75083 3.99996C6.75083 2.48073 5.51925 1.24915 4.00002 1.24915ZM5.82034 11.0001L2.49998 12.8369V9.16331L5.82034 11.0001ZM2.63883 8.21159C2.17228 7.9535 1.59998 8.29093 1.59998 8.82411V13.1761C1.59998 13.7093 2.17228 14.0467 2.63883 13.7886L6.57235 11.6126C7.05389 11.3462 7.05389 10.654 6.57235 10.3876L2.63883 8.21159ZM8.30001 9.00003C8.30001 8.61343 8.61341 8.30003 9.00001 8.30003H13C13.3866 8.30003 13.7 8.61343 13.7 9.00003V13C13.7 13.3866 13.3866 13.7 13 13.7H9.00001C8.61341 13.7 8.30001 13.3866 8.30001 13V9.00003ZM9.20001 9.20003V12.8H12.8V9.20003H9.20001ZM13.4432 2.19311C13.6189 2.01737 13.6189 1.73245 13.4432 1.55671C13.2675 1.38098 12.9826 1.38098 12.8068 1.55671L11 3.36353L9.19321 1.55674C9.01748 1.381 8.73255 1.381 8.55682 1.55674C8.38108 1.73247 8.38108 2.0174 8.55682 2.19313L10.3636 3.99992L8.55682 5.80671C8.38108 5.98245 8.38108 6.26737 8.55682 6.44311C8.73255 6.61885 9.01748 6.61885 9.19321 6.44311L11 4.63632L12.8068 6.44314C12.9826 6.61887 13.2675 6.61887 13.4432 6.44314C13.6189 6.2674 13.6189 5.98247 13.4432 5.80674L11.6364 3.99992L13.4432 2.19311Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3a = ["color"];
var MixerHorizontalIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3a);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3b = ["color"];
var MixerVerticalIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3b);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M5 1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5L4 7C4 7.01671 4.00082 7.03323 4.00242 7.04952C2.86009 7.28022 2 8.28967 2 9.5C2 10.7103 2.86009 11.7198 4.00242 11.9505C4.00082 11.9668 4 11.9833 4 12V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V12C5 11.9833 4.99918 11.9668 4.99758 11.9505C6.1399 11.7198 7 10.7103 7 9.5C7 8.28967 6.1399 7.28022 4.99758 7.04952C4.99918 7.03323 5 7.01671 5 7L5 1.5ZM11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V3C10 3.01671 10.0008 3.03323 10.0024 3.04952C8.8601 3.28022 8 4.28967 8 5.5C8 6.71033 8.8601 7.71978 10.0024 7.95048C10.0008 7.96677 10 7.98329 10 8V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V8C11 7.98329 10.9992 7.96677 10.9976 7.95048C12.1399 7.71978 13 6.71033 13 5.5C13 4.28967 12.1399 3.28022 10.9976 3.04952C10.9992 3.03323 11 3.01671 11 3V1.5ZM4.5 8C3.67157 8 3 8.67157 3 9.5C3 10.3284 3.67157 11 4.5 11C5.32843 11 6 10.3284 6 9.5C6 8.67157 5.32843 8 4.5 8ZM9 5.5C9 4.67157 9.67157 4 10.5 4C11.3284 4 12 4.67157 12 5.5C12 6.32843 11.3284 7 10.5 7C9.67157 7 9 6.32843 9 5.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3c = ["color"];
var MobileIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3c);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M4 2.5C4 2.22386 4.22386 2 4.5 2H10.5C10.7761 2 11 2.22386 11 2.5V12.5C11 12.7761 10.7761 13 10.5 13H4.5C4.22386 13 4 12.7761 4 12.5V2.5ZM4.5 1C3.67157 1 3 1.67157 3 2.5V12.5C3 13.3284 3.67157 14 4.5 14H10.5C11.3284 14 12 13.3284 12 12.5V2.5C12 1.67157 11.3284 1 10.5 1H4.5ZM6 11.65C5.8067 11.65 5.65 11.8067 5.65 12C5.65 12.1933 5.8067 12.35 6 12.35H9C9.1933 12.35 9.35 12.1933 9.35 12C9.35 11.8067 9.1933 11.65 9 11.65H6Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3d = (/* unused pure expression or super */ null && (["color"]));
var ModulzLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3d);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.25925 3.16667L4.37036 5.33333V1L7.25925 3.16667ZM1 8.22222L3.88889 6.05555L1 3.88889V8.22222ZM1 14L3.88889 11.8333L1 9.66666V14ZM7.74072 8.22222L10.6296 6.05555L7.74072 3.88889V8.22222ZM14 3.16667L11.1111 5.33333V1L14 3.16667ZM11.1111 11.1111L14 8.94444L11.1111 6.77777V11.1111ZM3.88889 11.1111L1 8.94444L3.88889 6.77777V11.1111ZM4.37036 6.05555L7.25925 8.22222V3.88889L4.37036 6.05555ZM3.88889 5.33333L1 3.16667L3.88889 1V5.33333ZM7.74072 3.16667L10.6296 5.33333V1L7.74072 3.16667ZM14 8.22222L11.1111 6.05555L14 3.88889V8.22222ZM11.1111 11.8333L14 14V9.66666L11.1111 11.8333Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3e = ["color"];
var MoonIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3e);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2.89998 0.499976C2.89998 0.279062 2.72089 0.0999756 2.49998 0.0999756C2.27906 0.0999756 2.09998 0.279062 2.09998 0.499976V1.09998H1.49998C1.27906 1.09998 1.09998 1.27906 1.09998 1.49998C1.09998 1.72089 1.27906 1.89998 1.49998 1.89998H2.09998V2.49998C2.09998 2.72089 2.27906 2.89998 2.49998 2.89998C2.72089 2.89998 2.89998 2.72089 2.89998 2.49998V1.89998H3.49998C3.72089 1.89998 3.89998 1.72089 3.89998 1.49998C3.89998 1.27906 3.72089 1.09998 3.49998 1.09998H2.89998V0.499976ZM5.89998 3.49998C5.89998 3.27906 5.72089 3.09998 5.49998 3.09998C5.27906 3.09998 5.09998 3.27906 5.09998 3.49998V4.09998H4.49998C4.27906 4.09998 4.09998 4.27906 4.09998 4.49998C4.09998 4.72089 4.27906 4.89998 4.49998 4.89998H5.09998V5.49998C5.09998 5.72089 5.27906 5.89998 5.49998 5.89998C5.72089 5.89998 5.89998 5.72089 5.89998 5.49998V4.89998H6.49998C6.72089 4.89998 6.89998 4.72089 6.89998 4.49998C6.89998 4.27906 6.72089 4.09998 6.49998 4.09998H5.89998V3.49998ZM1.89998 6.49998C1.89998 6.27906 1.72089 6.09998 1.49998 6.09998C1.27906 6.09998 1.09998 6.27906 1.09998 6.49998V7.09998H0.499976C0.279062 7.09998 0.0999756 7.27906 0.0999756 7.49998C0.0999756 7.72089 0.279062 7.89998 0.499976 7.89998H1.09998V8.49998C1.09998 8.72089 1.27906 8.89997 1.49998 8.89997C1.72089 8.89997 1.89998 8.72089 1.89998 8.49998V7.89998H2.49998C2.72089 7.89998 2.89998 7.72089 2.89998 7.49998C2.89998 7.27906 2.72089 7.09998 2.49998 7.09998H1.89998V6.49998ZM8.54406 0.98184L8.24618 0.941586C8.03275 0.917676 7.90692 1.1655 8.02936 1.34194C8.17013 1.54479 8.29981 1.75592 8.41754 1.97445C8.91878 2.90485 9.20322 3.96932 9.20322 5.10022C9.20322 8.37201 6.82247 11.0878 3.69887 11.6097C3.45736 11.65 3.20988 11.6772 2.96008 11.6906C2.74563 11.702 2.62729 11.9535 2.77721 12.1072C2.84551 12.1773 2.91535 12.2458 2.98667 12.3128L3.05883 12.3795L3.31883 12.6045L3.50684 12.7532L3.62796 12.8433L3.81491 12.9742L3.99079 13.089C4.11175 13.1651 4.23536 13.2375 4.36157 13.3059L4.62496 13.4412L4.88553 13.5607L5.18837 13.6828L5.43169 13.7686C5.56564 13.8128 5.70149 13.8529 5.83857 13.8885C5.94262 13.9155 6.04767 13.9401 6.15405 13.9622C6.27993 13.9883 6.40713 14.0109 6.53544 14.0298L6.85241 14.0685L7.11934 14.0892C7.24637 14.0965 7.37436 14.1002 7.50322 14.1002C11.1483 14.1002 14.1032 11.1453 14.1032 7.50023C14.1032 7.25044 14.0893 7.00389 14.0623 6.76131L14.0255 6.48407C13.991 6.26083 13.9453 6.04129 13.8891 5.82642C13.8213 5.56709 13.7382 5.31398 13.6409 5.06881L13.5279 4.80132L13.4507 4.63542L13.3766 4.48666C13.2178 4.17773 13.0353 3.88295 12.8312 3.60423L12.6782 3.40352L12.4793 3.16432L12.3157 2.98361L12.1961 2.85951L12.0355 2.70246L11.8134 2.50184L11.4925 2.24191L11.2483 2.06498L10.9562 1.87446L10.6346 1.68894L10.3073 1.52378L10.1938 1.47176L9.95488 1.3706L9.67791 1.2669L9.42566 1.1846L9.10075 1.09489L8.83599 1.03486L8.54406 0.98184ZM10.4032 5.30023C10.4032 4.27588 10.2002 3.29829 9.83244 2.40604C11.7623 3.28995 13.1032 5.23862 13.1032 7.50023C13.1032 10.593 10.596 13.1002 7.50322 13.1002C6.63646 13.1002 5.81597 12.9036 5.08355 12.5522C6.5419 12.0941 7.81081 11.2082 8.74322 10.0416C8.87963 10.2284 9.10028 10.3497 9.34928 10.3497C9.76349 10.3497 10.0993 10.0139 10.0993 9.59971C10.0993 9.24256 9.84965 8.94373 9.51535 8.86816C9.57741 8.75165 9.63653 8.63334 9.6926 8.51332C9.88358 8.63163 10.1088 8.69993 10.35 8.69993C11.0403 8.69993 11.6 8.14028 11.6 7.44993C11.6 6.75976 11.0406 6.20024 10.3505 6.19993C10.3853 5.90487 10.4032 5.60464 10.4032 5.30023Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3f = ["color"];
var MoveIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3f);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.81819 0.93179C7.64245 0.756054 7.35753 0.756054 7.18179 0.93179L5.43179 2.68179C5.25605 2.85753 5.25605 3.14245 5.43179 3.31819C5.60753 3.49392 5.89245 3.49392 6.06819 3.31819L6.99999 2.38638V5.49999C6.99999 5.77613 7.22385 5.99999 7.49999 5.99999C7.77613 5.99999 7.99999 5.77613 7.99999 5.49999V2.38638L8.93179 3.31819C9.10753 3.49392 9.39245 3.49392 9.56819 3.31819C9.74392 3.14245 9.74392 2.85753 9.56819 2.68179L7.81819 0.93179ZM7.99999 9.49999C7.99999 9.22385 7.77613 8.99999 7.49999 8.99999C7.22385 8.99999 6.99999 9.22385 6.99999 9.49999V12.6136L6.06819 11.6818C5.89245 11.5061 5.60753 11.5061 5.43179 11.6818C5.25605 11.8575 5.25605 12.1424 5.43179 12.3182L7.18179 14.0682C7.35753 14.2439 7.64245 14.2439 7.81819 14.0682L9.56819 12.3182C9.74392 12.1424 9.74392 11.8575 9.56819 11.6818C9.39245 11.5061 9.10753 11.5061 8.93179 11.6818L7.99999 12.6136V9.49999ZM8.99999 7.49999C8.99999 7.22385 9.22385 6.99999 9.49999 6.99999H12.6136L11.6818 6.06819C11.5061 5.89245 11.5061 5.60753 11.6818 5.43179C11.8575 5.25605 12.1424 5.25605 12.3182 5.43179L14.0682 7.18179C14.2439 7.35753 14.2439 7.64245 14.0682 7.81819L12.3182 9.56819C12.1424 9.74392 11.8575 9.74392 11.6818 9.56819C11.5061 9.39245 11.5061 9.10753 11.6818 8.93179L12.6136 7.99999H9.49999C9.22385 7.99999 8.99999 7.77613 8.99999 7.49999ZM3.31819 6.06819L2.38638 6.99999H5.49999C5.77613 6.99999 5.99999 7.22385 5.99999 7.49999C5.99999 7.77613 5.77613 7.99999 5.49999 7.99999H2.38638L3.31819 8.93179C3.49392 9.10753 3.49392 9.39245 3.31819 9.56819C3.14245 9.74392 2.85753 9.74392 2.68179 9.56819L0.93179 7.81819C0.756054 7.64245 0.756054 7.35753 0.93179 7.18179L2.68179 5.43179C2.85753 5.25605 3.14245 5.25605 3.31819 5.43179C3.49392 5.60753 3.49392 5.89245 3.31819 6.06819Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3g = (/* unused pure expression or super */ null && (["color"]));
var NotionLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3g);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.25781 3.11684C3.67771 3.45796 3.83523 3.43193 4.62369 3.37933L12.0571 2.93299C12.2147 2.93299 12.0836 2.77571 12.0311 2.74957L10.7965 1.85711C10.56 1.67347 10.2448 1.46315 9.64083 1.51576L2.44308 2.04074C2.18059 2.06677 2.12815 2.19801 2.2327 2.30322L3.25781 3.11684ZM3.7041 4.84917V12.6704C3.7041 13.0907 3.91415 13.248 4.38693 13.222L12.5562 12.7493C13.0292 12.7233 13.0819 12.4341 13.0819 12.0927V4.32397C13.0819 3.98306 12.9508 3.79921 12.6612 3.82545L4.12422 4.32397C3.80918 4.35044 3.7041 4.50803 3.7041 4.84917ZM11.7688 5.26872C11.8212 5.50518 11.7688 5.74142 11.5319 5.76799L11.1383 5.84641V11.6205C10.7965 11.8042 10.4814 11.9092 10.2188 11.9092C9.79835 11.9092 9.69305 11.7779 9.37812 11.3844L6.80345 7.34249V11.2532L7.61816 11.437C7.61816 11.437 7.61816 11.9092 6.96086 11.9092L5.14879 12.0143C5.09615 11.9092 5.14879 11.647 5.33259 11.5944L5.80546 11.4634V6.29276L5.1489 6.24015C5.09625 6.00369 5.22739 5.66278 5.5954 5.63631L7.53935 5.50528L10.2188 9.5998V5.97765L9.53564 5.89924C9.4832 5.61018 9.69305 5.40028 9.95576 5.37425L11.7688 5.26872ZM1.83874 1.33212L9.32557 0.780787C10.245 0.701932 10.4815 0.754753 11.0594 1.17452L13.4492 2.85424C13.8436 3.14309 13.975 3.22173 13.975 3.53661V12.7493C13.975 13.3266 13.7647 13.6681 13.0293 13.7203L4.33492 14.2454C3.78291 14.2717 3.52019 14.193 3.23111 13.8253L1.47116 11.5419C1.1558 11.1216 1.02466 10.8071 1.02466 10.4392V2.25041C1.02466 1.77825 1.23504 1.38441 1.83874 1.33212Z",
    fill: color
  }));
})));

var _excluded$3h = (/* unused pure expression or super */ null && (["color"]));
var OpacityIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3h);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.5 1.5C4.5 4.25 3 6.5 3 9C3 11.4853 5.01472 13.5 7.5 13.5C9.98528 13.5 12 11.4853 12 9C12 6.5 10.5 4.25 7.5 1.5ZM11 9C11 7.11203 9.97315 5.27195 7.5 2.87357C5.02686 5.27195 4 7.11203 4 9C4 10.933 5.567 12.5 7.5 12.5C9.433 12.5 11 10.933 11 9Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3i = ["color"];
var OpenInNewWindowIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3i);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13C12.5523 13 13 12.5523 13 12V3C13 2.44771 12.5523 2 12 2H3C2.44771 2 2 2.44771 2 3V6.5C2 6.77614 2.22386 7 2.5 7C2.77614 7 3 6.77614 3 6.5V3H12V12H8.5C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13H12ZM9 6.5C9 6.5001 9 6.50021 9 6.50031V6.50035V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V7.70711L2.85355 12.8536C2.65829 13.0488 2.34171 13.0488 2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L7.29289 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6H8.5C8.56779 6 8.63244 6.01349 8.69139 6.03794C8.74949 6.06198 8.80398 6.09744 8.85143 6.14433C8.94251 6.23434 8.9992 6.35909 8.99999 6.49708L8.99999 6.49738",
    fill: color
  }));
});

var _excluded$3j = (/* unused pure expression or super */ null && (["color"]));
var OverlineIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3j);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.49985 1.10001C3.27894 1.10001 3.09985 1.27909 3.09985 1.50001C3.09985 1.72092 3.27894 1.90001 3.49985 1.90001H11.4999C11.7208 1.90001 11.8999 1.72092 11.8999 1.50001C11.8999 1.27909 11.7208 1.10001 11.4999 1.10001H3.49985ZM4.99995 4.25001C4.99995 3.97387 4.77609 3.75001 4.49995 3.75001C4.22381 3.75001 3.99995 3.97387 3.99995 4.25001V9.55001C3.99995 11.483 5.56695 13.05 7.49995 13.05C9.43295 13.05 11 11.483 11 9.55001V4.25001C11 3.97387 10.7761 3.75001 10.5 3.75001C10.2238 3.75001 9.99995 3.97387 9.99995 4.25001V9.55001C9.99995 10.9307 8.88066 12.05 7.49995 12.05C6.11924 12.05 4.99995 10.9307 4.99995 9.55001V4.25001Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3k = ["color"];
var PaddingIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3k);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2.85714 2H12.1429C12.6162 2 13 2.38376 13 2.85714V12.1429C13 12.6162 12.6162 13 12.1429 13H2.85714C2.38376 13 2 12.6162 2 12.1429V2.85714C2 2.38376 2.38376 2 2.85714 2ZM1 2.85714C1 1.83147 1.83147 1 2.85714 1H12.1429C13.1685 1 14 1.83147 14 2.85714V12.1429C14 13.1685 13.1685 14 12.1429 14H2.85714C1.83147 14 1 13.1685 1 12.1429V2.85714ZM7.49988 5.00012C7.77602 5.00012 7.99988 4.77626 7.99988 4.50012C7.99988 4.22398 7.77602 4.00012 7.49988 4.00012C7.22374 4.00012 6.99988 4.22398 6.99988 4.50012C6.99988 4.77626 7.22374 5.00012 7.49988 5.00012ZM4.49988 11.0001C4.77602 11.0001 4.99988 10.7763 4.99988 10.5001C4.99988 10.224 4.77602 10.0001 4.49988 10.0001C4.22374 10.0001 3.99988 10.224 3.99988 10.5001C3.99988 10.7763 4.22374 11.0001 4.49988 11.0001ZM4.99988 7.50012C4.99988 7.77626 4.77602 8.00012 4.49988 8.00012C4.22374 8.00012 3.99988 7.77626 3.99988 7.50012C3.99988 7.22398 4.22374 7.00012 4.49988 7.00012C4.77602 7.00012 4.99988 7.22398 4.99988 7.50012ZM4.49988 5.00012C4.77602 5.00012 4.99988 4.77626 4.99988 4.50012C4.99988 4.22398 4.77602 4.00012 4.49988 4.00012C4.22374 4.00012 3.99988 4.22398 3.99988 4.50012C3.99988 4.77626 4.22374 5.00012 4.49988 5.00012ZM10.9999 10.5001C10.9999 10.7763 10.776 11.0001 10.4999 11.0001C10.2237 11.0001 9.99988 10.7763 9.99988 10.5001C9.99988 10.224 10.2237 10.0001 10.4999 10.0001C10.776 10.0001 10.9999 10.224 10.9999 10.5001ZM10.4999 8.00012C10.776 8.00012 10.9999 7.77626 10.9999 7.50012C10.9999 7.22398 10.776 7.00012 10.4999 7.00012C10.2237 7.00012 9.99988 7.22398 9.99988 7.50012C9.99988 7.77626 10.2237 8.00012 10.4999 8.00012ZM10.9999 4.50012C10.9999 4.77626 10.776 5.00012 10.4999 5.00012C10.2237 5.00012 9.99988 4.77626 9.99988 4.50012C9.99988 4.22398 10.2237 4.00012 10.4999 4.00012C10.776 4.00012 10.9999 4.22398 10.9999 4.50012ZM7.49988 11.0001C7.77602 11.0001 7.99988 10.7763 7.99988 10.5001C7.99988 10.224 7.77602 10.0001 7.49988 10.0001C7.22374 10.0001 6.99988 10.224 6.99988 10.5001C6.99988 10.7763 7.22374 11.0001 7.49988 11.0001Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3l = (/* unused pure expression or super */ null && (["color"]));
var PaperPlaneIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3l);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.20308 1.04312C1.00481 0.954998 0.772341 1.0048 0.627577 1.16641C0.482813 1.32802 0.458794 1.56455 0.568117 1.75196L3.92115 7.50002L0.568117 13.2481C0.458794 13.4355 0.482813 13.672 0.627577 13.8336C0.772341 13.9952 1.00481 14.045 1.20308 13.9569L14.7031 7.95693C14.8836 7.87668 15 7.69762 15 7.50002C15 7.30243 14.8836 7.12337 14.7031 7.04312L1.20308 1.04312ZM4.84553 7.10002L2.21234 2.586L13.2689 7.50002L2.21234 12.414L4.84552 7.90002H9C9.22092 7.90002 9.4 7.72094 9.4 7.50002C9.4 7.27911 9.22092 7.10002 9 7.10002H4.84553Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3m = (/* unused pure expression or super */ null && (["color"]));
var PauseIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3m);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M6.04995 2.74998C6.04995 2.44623 5.80371 2.19998 5.49995 2.19998C5.19619 2.19998 4.94995 2.44623 4.94995 2.74998V12.25C4.94995 12.5537 5.19619 12.8 5.49995 12.8C5.80371 12.8 6.04995 12.5537 6.04995 12.25V2.74998ZM10.05 2.74998C10.05 2.44623 9.80371 2.19998 9.49995 2.19998C9.19619 2.19998 8.94995 2.44623 8.94995 2.74998V12.25C8.94995 12.5537 9.19619 12.8 9.49995 12.8C9.80371 12.8 10.05 12.5537 10.05 12.25V2.74998Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3n = ["color"];
var Pencil1Icon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3n);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M11.8536 1.14645C11.6583 0.951184 11.3417 0.951184 11.1465 1.14645L3.71455 8.57836C3.62459 8.66832 3.55263 8.77461 3.50251 8.89155L2.04044 12.303C1.9599 12.491 2.00189 12.709 2.14646 12.8536C2.29103 12.9981 2.50905 13.0401 2.69697 12.9596L6.10847 11.4975C6.2254 11.4474 6.3317 11.3754 6.42166 11.2855L13.8536 3.85355C14.0488 3.65829 14.0488 3.34171 13.8536 3.14645L11.8536 1.14645ZM4.42166 9.28547L11.5 2.20711L12.7929 3.5L5.71455 10.5784L4.21924 11.2192L3.78081 10.7808L4.42166 9.28547Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3o = (/* unused pure expression or super */ null && (["color"]));
var Pencil2Icon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3o);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M12.1464 1.14645C12.3417 0.951184 12.6583 0.951184 12.8535 1.14645L14.8535 3.14645C15.0488 3.34171 15.0488 3.65829 14.8535 3.85355L10.9109 7.79618C10.8349 7.87218 10.7471 7.93543 10.651 7.9835L6.72359 9.94721C6.53109 10.0435 6.29861 10.0057 6.14643 9.85355C5.99425 9.70137 5.95652 9.46889 6.05277 9.27639L8.01648 5.34897C8.06455 5.25283 8.1278 5.16507 8.2038 5.08907L12.1464 1.14645ZM12.5 2.20711L8.91091 5.79618L7.87266 7.87267L8.12731 8.12732L10.2038 7.08907L13.7929 3.5L12.5 2.20711ZM9.99998 2L8.99998 3H4.9C4.47171 3 4.18056 3.00039 3.95552 3.01877C3.73631 3.03668 3.62421 3.06915 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3.06915 3.62421 3.03669 3.73631 3.01878 3.95552C3.00039 4.18056 3 4.47171 3 4.9V11.1C3 11.5283 3.00039 11.8194 3.01878 12.0445C3.03669 12.2637 3.06915 12.3758 3.10899 12.454C3.20487 12.6422 3.35785 12.7951 3.54601 12.891C3.62421 12.9309 3.73631 12.9633 3.95552 12.9812C4.18056 12.9996 4.47171 13 4.9 13H11.1C11.5283 13 11.8194 12.9996 12.0445 12.9812C12.2637 12.9633 12.3758 12.9309 12.454 12.891C12.6422 12.7951 12.7951 12.6422 12.891 12.454C12.9309 12.3758 12.9633 12.2637 12.9812 12.0445C12.9996 11.8194 13 11.5283 13 11.1V6.99998L14 5.99998V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H4.9H4.87934C4.47686 14 4.14468 14 3.87409 13.9779C3.59304 13.9549 3.33469 13.9057 3.09202 13.782C2.7157 13.5903 2.40973 13.2843 2.21799 12.908C2.09434 12.6653 2.04506 12.407 2.0221 12.1259C1.99999 11.8553 1.99999 11.5231 2 11.1207V11.1206V11.1V4.9V4.87935V4.87932V4.87931C1.99999 4.47685 1.99999 4.14468 2.0221 3.87409C2.04506 3.59304 2.09434 3.33469 2.21799 3.09202C2.40973 2.71569 2.7157 2.40973 3.09202 2.21799C3.33469 2.09434 3.59304 2.04506 3.87409 2.0221C4.14468 1.99999 4.47685 1.99999 4.87932 2H4.87935H4.9H9.99998Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3p = ["color"];
var PersonIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3p);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.15288 4.98124 7.54738 6.49373 7.98351C5.2997 8.12901 4.27557 8.55134 3.50407 9.31167C2.52216 10.2794 2.02502 11.72 2.02502 13.5999C2.02502 13.8623 2.23769 14.0749 2.50002 14.0749C2.76236 14.0749 2.97502 13.8623 2.97502 13.5999C2.97502 11.8799 3.42786 10.7206 4.17091 9.9883C4.91536 9.25463 6.02674 8.87499 7.49995 8.87499C8.97317 8.87499 10.0846 9.25463 10.8291 9.98831C11.5721 10.7206 12.025 11.8799 12.025 13.5999C12.025 13.8623 12.2376 14.0749 12.5 14.0749C12.7623 14.075 12.975 13.8623 12.975 13.6C12.975 11.72 12.4778 10.2794 11.4959 9.31166C10.7244 8.55135 9.70025 8.12903 8.50625 7.98352C10.0187 7.5474 11.125 6.15289 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM4.825 4.5C4.825 3.02264 6.02264 1.825 7.5 1.825C8.97736 1.825 10.175 3.02264 10.175 4.5C10.175 5.97736 8.97736 7.175 7.5 7.175C6.02264 7.175 4.825 5.97736 4.825 4.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3q = ["color"];
var PieChartIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3q);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1.85001 7.50043C1.85001 4.37975 4.37963 1.85001 7.50001 1.85001C10.6204 1.85001 13.15 4.37975 13.15 7.50043C13.15 10.6211 10.6204 13.1509 7.50001 13.1509C4.37963 13.1509 1.85001 10.6211 1.85001 7.50043ZM7.50001 0.850006C3.82728 0.850006 0.850006 3.82753 0.850006 7.50043C0.850006 11.1733 3.82728 14.1509 7.50001 14.1509C11.1727 14.1509 14.15 11.1733 14.15 7.50043C14.15 3.82753 11.1727 0.850006 7.50001 0.850006ZM7.00001 8.00001V3.12811C7.16411 3.10954 7.33094 3.10001 7.50001 3.10001C9.93006 3.10001 11.9 5.07014 11.9 7.50043C11.9 7.66935 11.8905 7.83604 11.872 8.00001H7.00001Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3r = (/* unused pure expression or super */ null && (["color"]));
var PilcrowIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3r);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3 5.5C3 7.983 4.99169 9 7 9V12.5C7 12.7761 7.22386 13 7.5 13C7.77614 13 8 12.7761 8 12.5V9V3.1H9V12.5C9 12.7761 9.22386 13 9.5 13C9.77614 13 10 12.7761 10 12.5V3.1H11.5C11.8038 3.1 12.05 2.85376 12.05 2.55C12.05 2.24624 11.8038 2 11.5 2H9.5H8H7.5H7C4.99169 2 3 3.017 3 5.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3s = (/* unused pure expression or super */ null && (["color"]));
var PinBottomIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3s);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M13.5 13.95C13.7485 13.95 13.95 13.7485 13.95 13.5C13.95 13.2514 13.7485 13.05 13.5 13.05L1.49995 13.05C1.25142 13.05 1.04995 13.2514 1.04995 13.5C1.04995 13.7485 1.25142 13.95 1.49995 13.95L13.5 13.95ZM11.0681 7.5683C11.2439 7.39257 11.2439 7.10764 11.0681 6.93191C10.8924 6.75617 10.6075 6.75617 10.4317 6.93191L7.94993 9.41371L7.94993 1.49998C7.94993 1.25146 7.74846 1.04998 7.49993 1.04998C7.2514 1.04998 7.04993 1.25146 7.04993 1.49998L7.04993 9.41371L4.56813 6.93191C4.39239 6.75617 4.10746 6.75617 3.93173 6.93191C3.75599 7.10764 3.75599 7.39257 3.93173 7.5683L7.18173 10.8183C7.35746 10.994 7.64239 10.994 7.81812 10.8183L11.0681 7.5683Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3t = (/* unused pure expression or super */ null && (["color"]));
var PinLeftIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3t);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M2.05005 13.5C2.05005 13.7485 2.25152 13.95 2.50005 13.95C2.74858 13.95 2.95005 13.7485 2.95005 13.5L2.95005 1.49995C2.95005 1.25142 2.74858 1.04995 2.50005 1.04995C2.25152 1.04995 2.05005 1.25142 2.05005 1.49995L2.05005 13.5ZM8.4317 11.0681C8.60743 11.2439 8.89236 11.2439 9.06809 11.0681C9.24383 10.8924 9.24383 10.6075 9.06809 10.4317L6.58629 7.94993L14.5 7.94993C14.7485 7.94993 14.95 7.74846 14.95 7.49993C14.95 7.2514 14.7485 7.04993 14.5 7.04993L6.58629 7.04993L9.06809 4.56813C9.24383 4.39239 9.24383 4.10746 9.06809 3.93173C8.89236 3.75599 8.60743 3.75599 8.4317 3.93173L5.1817 7.18173C5.00596 7.35746 5.00596 7.64239 5.1817 7.81812L8.4317 11.0681Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3u = (/* unused pure expression or super */ null && (["color"]));
var PinRightIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3u);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M12.95 1.50005C12.95 1.25152 12.7485 1.05005 12.5 1.05005C12.2514 1.05005 12.05 1.25152 12.05 1.50005L12.05 13.5C12.05 13.7486 12.2514 13.95 12.5 13.95C12.7485 13.95 12.95 13.7486 12.95 13.5L12.95 1.50005ZM6.5683 3.93188C6.39257 3.75614 6.10764 3.75614 5.93191 3.93188C5.75617 4.10761 5.75617 4.39254 5.93191 4.56827L8.41371 7.05007L0.499984 7.05007C0.251456 7.05007 0.0499847 7.25155 0.0499847 7.50007C0.0499846 7.7486 0.251457 7.95007 0.499984 7.95007L8.41371 7.95007L5.93191 10.4319C5.75617 10.6076 5.75617 10.8925 5.93191 11.0683C6.10764 11.244 6.39257 11.244 6.56831 11.0683L9.8183 7.81827C9.99404 7.64254 9.99404 7.35761 9.8183 7.18188L6.5683 3.93188Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3v = ["color"];
var PinTopIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3v);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1.50005 1.05005C1.25152 1.05005 1.05005 1.25152 1.05005 1.50005C1.05005 1.74858 1.25152 1.95005 1.50005 1.95005L13.5 1.95005C13.7486 1.95005 13.95 1.74858 13.95 1.50005C13.95 1.25152 13.7486 1.05005 13.5 1.05005H1.50005ZM3.93188 7.43169C3.75614 7.60743 3.75614 7.89236 3.93188 8.06809C4.10761 8.24383 4.39254 8.24383 4.56827 8.06809L7.05007 5.58629V13.5C7.05007 13.7485 7.25155 13.95 7.50007 13.95C7.7486 13.95 7.95007 13.7485 7.95007 13.5L7.95007 5.58629L10.4319 8.06809C10.6076 8.24383 10.8925 8.24383 11.0683 8.06809C11.244 7.89235 11.244 7.60743 11.0683 7.43169L7.81827 4.18169C7.64254 4.00596 7.35761 4.00596 7.18188 4.18169L3.93188 7.43169Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3w = (/* unused pure expression or super */ null && (["color"]));
var PlayIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3w);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.24182 2.32181C3.3919 2.23132 3.5784 2.22601 3.73338 2.30781L12.7334 7.05781C12.8974 7.14436 13 7.31457 13 7.5C13 7.68543 12.8974 7.85564 12.7334 7.94219L3.73338 12.6922C3.5784 12.774 3.3919 12.7687 3.24182 12.6782C3.09175 12.5877 3 12.4252 3 12.25V2.75C3 2.57476 3.09175 2.4123 3.24182 2.32181ZM4 3.57925V11.4207L11.4288 7.5L4 3.57925Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3x = ["color"];
var PlusIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3x);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3y = ["color"];
var PlusCircledIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3y);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM7.50003 4C7.77617 4 8.00003 4.22386 8.00003 4.5V7H10.5C10.7762 7 11 7.22386 11 7.5C11 7.77614 10.7762 8 10.5 8H8.00003V10.5C8.00003 10.7761 7.77617 11 7.50003 11C7.22389 11 7.00003 10.7761 7.00003 10.5V8H4.50003C4.22389 8 4.00003 7.77614 4.00003 7.5C4.00003 7.22386 4.22389 7 4.50003 7H7.00003V4.5C7.00003 4.22386 7.22389 4 7.50003 4Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3z = ["color"];
var QuestionMarkIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3z);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M5.07505 4.10001C5.07505 2.91103 6.25727 1.92502 7.50005 1.92502C8.74283 1.92502 9.92505 2.91103 9.92505 4.10001C9.92505 5.19861 9.36782 5.71436 8.61854 6.37884L8.58757 6.4063C7.84481 7.06467 6.92505 7.87995 6.92505 9.5C6.92505 9.81757 7.18248 10.075 7.50005 10.075C7.81761 10.075 8.07505 9.81757 8.07505 9.5C8.07505 8.41517 8.62945 7.90623 9.38156 7.23925L9.40238 7.22079C10.1496 6.55829 11.075 5.73775 11.075 4.10001C11.075 2.12757 9.21869 0.775024 7.50005 0.775024C5.7814 0.775024 3.92505 2.12757 3.92505 4.10001C3.92505 4.41758 4.18249 4.67501 4.50005 4.67501C4.81761 4.67501 5.07505 4.41758 5.07505 4.10001ZM7.50005 13.3575C7.9833 13.3575 8.37505 12.9657 8.37505 12.4825C8.37505 11.9992 7.9833 11.6075 7.50005 11.6075C7.0168 11.6075 6.62505 11.9992 6.62505 12.4825C6.62505 12.9657 7.0168 13.3575 7.50005 13.3575Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3A = ["color"];
var QuestionMarkCircledIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3A);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M0.877075 7.49972C0.877075 3.84204 3.84222 0.876892 7.49991 0.876892C11.1576 0.876892 14.1227 3.84204 14.1227 7.49972C14.1227 11.1574 11.1576 14.1226 7.49991 14.1226C3.84222 14.1226 0.877075 11.1574 0.877075 7.49972ZM7.49991 1.82689C4.36689 1.82689 1.82708 4.36671 1.82708 7.49972C1.82708 10.6327 4.36689 13.1726 7.49991 13.1726C10.6329 13.1726 13.1727 10.6327 13.1727 7.49972C13.1727 4.36671 10.6329 1.82689 7.49991 1.82689ZM8.24993 10.5C8.24993 10.9142 7.91414 11.25 7.49993 11.25C7.08571 11.25 6.74993 10.9142 6.74993 10.5C6.74993 10.0858 7.08571 9.75 7.49993 9.75C7.91414 9.75 8.24993 10.0858 8.24993 10.5ZM6.05003 6.25C6.05003 5.57211 6.63511 4.925 7.50003 4.925C8.36496 4.925 8.95003 5.57211 8.95003 6.25C8.95003 6.74118 8.68002 6.99212 8.21447 7.27494C8.16251 7.30651 8.10258 7.34131 8.03847 7.37854L8.03841 7.37858C7.85521 7.48497 7.63788 7.61119 7.47449 7.73849C7.23214 7.92732 6.95003 8.23198 6.95003 8.7C6.95004 9.00376 7.19628 9.25 7.50004 9.25C7.8024 9.25 8.04778 9.00601 8.05002 8.70417L8.05056 8.7033C8.05924 8.6896 8.08493 8.65735 8.15058 8.6062C8.25207 8.52712 8.36508 8.46163 8.51567 8.37436L8.51571 8.37433C8.59422 8.32883 8.68296 8.27741 8.78559 8.21506C9.32004 7.89038 10.05 7.35382 10.05 6.25C10.05 4.92789 8.93511 3.825 7.50003 3.825C6.06496 3.825 4.95003 4.92789 4.95003 6.25C4.95003 6.55376 5.19628 6.8 5.50003 6.8C5.80379 6.8 6.05003 6.55376 6.05003 6.25Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3B = ["color"];
var QuoteIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3B);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M9.42503 3.44136C10.0561 3.23654 10.7837 3.2402 11.3792 3.54623C12.7532 4.25224 13.3477 6.07191 12.7946 8C12.5465 8.8649 12.1102 9.70472 11.1861 10.5524C10.262 11.4 8.98034 11.9 8.38571 11.9C8.17269 11.9 8 11.7321 8 11.525C8 11.3179 8.17644 11.15 8.38571 11.15C9.06497 11.15 9.67189 10.7804 10.3906 10.236C10.9406 9.8193 11.3701 9.28633 11.608 8.82191C12.0628 7.93367 12.0782 6.68174 11.3433 6.34901C10.9904 6.73455 10.5295 6.95946 9.97725 6.95946C8.7773 6.95946 8.0701 5.99412 8.10051 5.12009C8.12957 4.28474 8.66032 3.68954 9.42503 3.44136ZM3.42503 3.44136C4.05614 3.23654 4.78366 3.2402 5.37923 3.54623C6.7532 4.25224 7.34766 6.07191 6.79462 8C6.54654 8.8649 6.11019 9.70472 5.1861 10.5524C4.26201 11.4 2.98034 11.9 2.38571 11.9C2.17269 11.9 2 11.7321 2 11.525C2 11.3179 2.17644 11.15 2.38571 11.15C3.06497 11.15 3.67189 10.7804 4.39058 10.236C4.94065 9.8193 5.37014 9.28633 5.60797 8.82191C6.06282 7.93367 6.07821 6.68174 5.3433 6.34901C4.99037 6.73455 4.52948 6.95946 3.97725 6.95946C2.7773 6.95946 2.0701 5.99412 2.10051 5.12009C2.12957 4.28474 2.66032 3.68954 3.42503 3.44136Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3C = ["color"];
var RadiobuttonIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3C);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 11.1575 3.84216 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1575 0.877045 7.49985 0.877045ZM1.82701 7.49988C1.82701 4.36686 4.36683 1.82704 7.49985 1.82704C10.6328 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6328 13.1727 7.49985 13.1727C4.36683 13.1727 1.82701 10.6329 1.82701 7.49988ZM7.49999 9.49999C8.60456 9.49999 9.49999 8.60456 9.49999 7.49999C9.49999 6.39542 8.60456 5.49999 7.49999 5.49999C6.39542 5.49999 5.49999 6.39542 5.49999 7.49999C5.49999 8.60456 6.39542 9.49999 7.49999 9.49999Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3D = (/* unused pure expression or super */ null && (["color"]));
var ReaderIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3D);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4.2 1H4.17741H4.1774C3.86936 0.999988 3.60368 0.999978 3.38609 1.02067C3.15576 1.04257 2.92825 1.09113 2.71625 1.22104C2.51442 1.34472 2.34473 1.51442 2.22104 1.71625C2.09113 1.92825 2.04257 2.15576 2.02067 2.38609C1.99998 2.60367 1.99999 2.86935 2 3.17738V3.1774V3.2V11.8V11.8226V11.8226C1.99999 12.1307 1.99998 12.3963 2.02067 12.6139C2.04257 12.8442 2.09113 13.0717 2.22104 13.2837C2.34473 13.4856 2.51442 13.6553 2.71625 13.779C2.92825 13.9089 3.15576 13.9574 3.38609 13.9793C3.60368 14 3.86937 14 4.17741 14H4.2H10.8H10.8226C11.1306 14 11.3963 14 11.6139 13.9793C11.8442 13.9574 12.0717 13.9089 12.2837 13.779C12.4856 13.6553 12.6553 13.4856 12.779 13.2837C12.9089 13.0717 12.9574 12.8442 12.9793 12.6139C13 12.3963 13 12.1306 13 11.8226V11.8V3.2V3.17741C13 2.86936 13 2.60368 12.9793 2.38609C12.9574 2.15576 12.9089 1.92825 12.779 1.71625C12.6553 1.51442 12.4856 1.34472 12.2837 1.22104C12.0717 1.09113 11.8442 1.04257 11.6139 1.02067C11.3963 0.999978 11.1306 0.999988 10.8226 1H10.8H4.2ZM3.23875 2.07368C3.26722 2.05623 3.32362 2.03112 3.48075 2.01618C3.64532 2.00053 3.86298 2 4.2 2H10.8C11.137 2 11.3547 2.00053 11.5193 2.01618C11.6764 2.03112 11.7328 2.05623 11.7613 2.07368C11.8285 2.11491 11.8851 2.17147 11.9263 2.23875C11.9438 2.26722 11.9689 2.32362 11.9838 2.48075C11.9995 2.64532 12 2.86298 12 3.2V11.8C12 12.137 11.9995 12.3547 11.9838 12.5193C11.9689 12.6764 11.9438 12.7328 11.9263 12.7613C11.8851 12.8285 11.8285 12.8851 11.7613 12.9263C11.7328 12.9438 11.6764 12.9689 11.5193 12.9838C11.3547 12.9995 11.137 13 10.8 13H4.2C3.86298 13 3.64532 12.9995 3.48075 12.9838C3.32362 12.9689 3.26722 12.9438 3.23875 12.9263C3.17147 12.8851 3.11491 12.8285 3.07368 12.7613C3.05624 12.7328 3.03112 12.6764 3.01618 12.5193C3.00053 12.3547 3 12.137 3 11.8V3.2C3 2.86298 3.00053 2.64532 3.01618 2.48075C3.03112 2.32362 3.05624 2.26722 3.07368 2.23875C3.11491 2.17147 3.17147 2.11491 3.23875 2.07368ZM5 10C4.72386 10 4.5 10.2239 4.5 10.5C4.5 10.7761 4.72386 11 5 11H8C8.27614 11 8.5 10.7761 8.5 10.5C8.5 10.2239 8.27614 10 8 10H5ZM4.5 7.5C4.5 7.22386 4.72386 7 5 7H10C10.2761 7 10.5 7.22386 10.5 7.5C10.5 7.77614 10.2761 8 10 8H5C4.72386 8 4.5 7.77614 4.5 7.5ZM5 4C4.72386 4 4.5 4.22386 4.5 4.5C4.5 4.77614 4.72386 5 5 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3E = ["color"];
var ReloadIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3E);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1.84998 7.49998C1.84998 4.66458 4.05979 1.84998 7.49998 1.84998C10.2783 1.84998 11.6515 3.9064 12.2367 5H10.5C10.2239 5 10 5.22386 10 5.5C10 5.77614 10.2239 6 10.5 6H13.5C13.7761 6 14 5.77614 14 5.5V2.5C14 2.22386 13.7761 2 13.5 2C13.2239 2 13 2.22386 13 2.5V4.31318C12.2955 3.07126 10.6659 0.849976 7.49998 0.849976C3.43716 0.849976 0.849976 4.18537 0.849976 7.49998C0.849976 10.8146 3.43716 14.15 7.49998 14.15C9.44382 14.15 11.0622 13.3808 12.2145 12.2084C12.8315 11.5806 13.3133 10.839 13.6418 10.0407C13.7469 9.78536 13.6251 9.49315 13.3698 9.38806C13.1144 9.28296 12.8222 9.40478 12.7171 9.66014C12.4363 10.3425 12.0251 10.9745 11.5013 11.5074C10.5295 12.4963 9.16504 13.15 7.49998 13.15C4.05979 13.15 1.84998 10.3354 1.84998 7.49998Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3F = ["color"];
var ResetIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3F);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M4.85355 2.14645C5.04882 2.34171 5.04882 2.65829 4.85355 2.85355L3.70711 4H9C11.4853 4 13.5 6.01472 13.5 8.5C13.5 10.9853 11.4853 13 9 13H5C4.72386 13 4.5 12.7761 4.5 12.5C4.5 12.2239 4.72386 12 5 12H9C10.933 12 12.5 10.433 12.5 8.5C12.5 6.567 10.933 5 9 5H3.70711L4.85355 6.14645C5.04882 6.34171 5.04882 6.65829 4.85355 6.85355C4.65829 7.04882 4.34171 7.04882 4.14645 6.85355L2.14645 4.85355C1.95118 4.65829 1.95118 4.34171 2.14645 4.14645L4.14645 2.14645C4.34171 1.95118 4.65829 1.95118 4.85355 2.14645Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3G = (/* unused pure expression or super */ null && (["color"]));
var ResumeIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3G);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.04995 2.74995C3.04995 2.44619 2.80371 2.19995 2.49995 2.19995C2.19619 2.19995 1.94995 2.44619 1.94995 2.74995V12.25C1.94995 12.5537 2.19619 12.8 2.49995 12.8C2.80371 12.8 3.04995 12.5537 3.04995 12.25V2.74995ZM5.73333 2.30776C5.57835 2.22596 5.39185 2.23127 5.24177 2.32176C5.0917 2.41225 4.99995 2.57471 4.99995 2.74995V12.25C4.99995 12.4252 5.0917 12.5877 5.24177 12.6781C5.39185 12.7686 5.57835 12.7739 5.73333 12.6921L14.7333 7.94214C14.8973 7.85559 15 7.68539 15 7.49995C15 7.31452 14.8973 7.14431 14.7333 7.05776L5.73333 2.30776ZM5.99995 11.4207V3.5792L13.4287 7.49995L5.99995 11.4207Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3H = ["color"];
var RocketIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3H);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M6.85357 3.85355L7.65355 3.05353C8.2981 2.40901 9.42858 1.96172 10.552 1.80125C11.1056 1.72217 11.6291 1.71725 12.0564 1.78124C12.4987 1.84748 12.7698 1.97696 12.8965 2.10357C13.0231 2.23018 13.1526 2.50125 13.2188 2.94357C13.2828 3.37086 13.2779 3.89439 13.1988 4.44801C13.0383 5.57139 12.591 6.70188 11.9464 7.34645L7.49999 11.7929L6.35354 10.6465C6.15827 10.4512 5.84169 10.4512 5.64643 10.6465C5.45117 10.8417 5.45117 11.1583 5.64643 11.3536L7.14644 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L8.40073 12.3064L9.57124 14.2572C9.65046 14.3893 9.78608 14.4774 9.9389 14.4963C10.0917 14.5151 10.2447 14.4624 10.3535 14.3536L12.3535 12.3536C12.4648 12.2423 12.5172 12.0851 12.495 11.9293L12.0303 8.67679L12.6536 8.05355C13.509 7.19808 14.0117 5.82855 14.1887 4.58943C14.2784 3.9618 14.2891 3.33847 14.2078 2.79546C14.1287 2.26748 13.9519 1.74482 13.6035 1.39645C13.2552 1.04809 12.7325 0.871332 12.2045 0.792264C11.6615 0.710945 11.0382 0.721644 10.4105 0.8113C9.17143 0.988306 7.80189 1.491 6.94644 2.34642L6.32322 2.96968L3.07071 2.50504C2.91492 2.48278 2.75773 2.53517 2.64645 2.64646L0.646451 4.64645C0.537579 4.75533 0.484938 4.90829 0.50375 5.0611C0.522563 5.21391 0.61073 5.34954 0.742757 5.42876L2.69364 6.59928L2.14646 7.14645C2.0527 7.24022 2.00002 7.3674 2.00002 7.50001C2.00002 7.63261 2.0527 7.75979 2.14646 7.85356L3.64647 9.35356C3.84173 9.54883 4.15831 9.54883 4.35357 9.35356C4.54884 9.1583 4.54884 8.84172 4.35357 8.64646L3.20712 7.50001L3.85357 6.85356L6.85357 3.85355ZM10.0993 13.1936L9.12959 11.5775L11.1464 9.56067L11.4697 11.8232L10.0993 13.1936ZM3.42251 5.87041L5.43935 3.85356L3.17678 3.53034L1.80638 4.90074L3.42251 5.87041ZM2.35356 10.3535C2.54882 10.1583 2.54882 9.8417 2.35356 9.64644C2.1583 9.45118 1.84171 9.45118 1.64645 9.64644L0.646451 10.6464C0.451188 10.8417 0.451188 11.1583 0.646451 11.3535C0.841713 11.5488 1.1583 11.5488 1.35356 11.3535L2.35356 10.3535ZM3.85358 11.8536C4.04884 11.6583 4.04885 11.3417 3.85359 11.1465C3.65833 10.9512 3.34175 10.9512 3.14648 11.1465L1.14645 13.1464C0.95119 13.3417 0.951187 13.6583 1.14645 13.8535C1.34171 14.0488 1.65829 14.0488 1.85355 13.8536L3.85358 11.8536ZM5.35356 13.3535C5.54882 13.1583 5.54882 12.8417 5.35356 12.6464C5.1583 12.4512 4.84171 12.4512 4.64645 12.6464L3.64645 13.6464C3.45119 13.8417 3.45119 14.1583 3.64645 14.3535C3.84171 14.5488 4.1583 14.5488 4.35356 14.3535L5.35356 13.3535ZM9.49997 6.74881C10.1897 6.74881 10.7488 6.1897 10.7488 5.5C10.7488 4.8103 10.1897 4.25118 9.49997 4.25118C8.81026 4.25118 8.25115 4.8103 8.25115 5.5C8.25115 6.1897 8.81026 6.74881 9.49997 6.74881Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3I = (/* unused pure expression or super */ null && (["color"]));
var RotateCounterClockwiseIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3I);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.59664 2.93628C7.76085 3.06401 8.00012 2.94698 8.00012 2.73895V1.99998C9.98143 2 11.1848 2.3637 11.9105 3.08945C12.6363 3.81522 13 5.0186 13 6.99998C13 7.27613 13.2239 7.49998 13.5 7.49998C13.7761 7.49998 14 7.27613 14 6.99998C14 4.9438 13.6325 3.39719 12.6176 2.38234C11.6028 1.36752 10.0562 0.999999 8.00012 0.999984V0.261266C8.00012 0.0532293 7.76085 -0.0637944 7.59664 0.063928L6.00384 1.30277C5.87516 1.40286 5.87516 1.59735 6.00384 1.69744L7.59664 2.93628ZM9.5 5H2.5C2.22386 5 2 5.22386 2 5.5V12.5C2 12.7761 2.22386 13 2.5 13H9.5C9.77614 13 10 12.7761 10 12.5V5.5C10 5.22386 9.77614 5 9.5 5ZM2.5 4C1.67157 4 1 4.67157 1 5.5V12.5C1 13.3284 1.67157 14 2.5 14H9.5C10.3284 14 11 13.3284 11 12.5V5.5C11 4.67157 10.3284 4 9.5 4H2.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3J = (/* unused pure expression or super */ null && (["color"]));
var RowSpacingIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3J);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.81832 0.68179C7.64258 0.506054 7.35766 0.506054 7.18192 0.68179L5.18192 2.68179C5.00619 2.85753 5.00619 3.14245 5.18192 3.31819C5.35766 3.49392 5.64258 3.49392 5.81832 3.31819L7.05012 2.08638L7.05012 5.50023C7.05012 5.74876 7.25159 5.95023 7.50012 5.95023C7.74865 5.95023 7.95012 5.74876 7.95012 5.50023L7.95012 2.08638L9.18192 3.31819C9.35766 3.49392 9.64258 3.49392 9.81832 3.31819C9.99406 3.14245 9.99406 2.85753 9.81832 2.68179L7.81832 0.68179ZM7.95012 12.9136V9.50023C7.95012 9.2517 7.74865 9.05023 7.50012 9.05023C7.25159 9.05023 7.05012 9.2517 7.05012 9.50023V12.9136L5.81832 11.6818C5.64258 11.5061 5.35766 11.5061 5.18192 11.6818C5.00619 11.8575 5.00619 12.1424 5.18192 12.3182L7.18192 14.3182C7.26632 14.4026 7.38077 14.45 7.50012 14.45C7.61947 14.45 7.73393 14.4026 7.81832 14.3182L9.81832 12.3182C9.99406 12.1424 9.99406 11.8575 9.81832 11.6818C9.64258 11.5061 9.35766 11.5061 9.18192 11.6818L7.95012 12.9136ZM1.49994 7.00017C1.2238 7.00017 0.999939 7.22403 0.999939 7.50017C0.999939 7.77631 1.2238 8.00017 1.49994 8.00017L13.4999 8.00017C13.7761 8.00017 13.9999 7.77631 13.9999 7.50017C13.9999 7.22403 13.7761 7.00017 13.4999 7.00017L1.49994 7.00017Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3K = ["color"];
var RowsIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3K);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M14 12.85L1 12.85L1 14.15L14 14.15L14 12.85ZM14 8.85002L1 8.85002L1 10.15L14 10.15L14 8.85002ZM1 4.85003L14 4.85003L14 6.15003L1 6.15002L1 4.85003ZM14 0.850025L1 0.850025L1 2.15002L14 2.15002L14 0.850025Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3L = (/* unused pure expression or super */ null && (["color"]));
var RulerHorizontalIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3L);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.5 4C0.223858 4 0 4.22386 0 4.5V10.5C0 10.7761 0.223858 11 0.5 11H14.5C14.7761 11 15 10.7761 15 10.5V4.5C15 4.22386 14.7761 4 14.5 4H0.5ZM1 10V5H2.075V7.5C2.075 7.73472 2.26528 7.925 2.5 7.925C2.73472 7.925 2.925 7.73472 2.925 7.5V5H4.075V6.5C4.075 6.73472 4.26528 6.925 4.5 6.925C4.73472 6.925 4.925 6.73472 4.925 6.5V5H6.075V6.5C6.075 6.73472 6.26528 6.925 6.5 6.925C6.73472 6.925 6.925 6.73472 6.925 6.5V5H8.075V7.5C8.075 7.73472 8.26528 7.925 8.5 7.925C8.73472 7.925 8.925 7.73472 8.925 7.5V5H10.075V6.5C10.075 6.73472 10.2653 6.925 10.5 6.925C10.7347 6.925 10.925 6.73472 10.925 6.5V5H12.075V6.5C12.075 6.73472 12.2653 6.925 12.5 6.925C12.7347 6.925 12.925 6.73472 12.925 6.5V5H14V10H1Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3M = (/* unused pure expression or super */ null && (["color"]));
var RulerSquareIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3M);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.5 0C0.223858 0 0 0.223858 0 0.5V14.5C0 14.7761 0.223858 15 0.5 15H4.5C4.77614 15 5 14.7761 5 14.5V5H14.5C14.7761 5 15 4.77614 15 4.5V0.5C15 0.223858 14.7761 0 14.5 0H0.5ZM1 4.07505L1 1H4.07502C4.07502 1 4.07502 1 4.07502 1L4.07505 4.07507L1 4.07505ZM0.999997 4.92505L1 14H4V12.925H2.75002C2.5153 12.925 2.32502 12.7348 2.32502 12.5C2.32502 12.2653 2.5153 12.075 2.75002 12.075H4V10.925H2.25002C2.0153 10.925 1.82502 10.7347 1.82502 10.5C1.82502 10.2653 2.0153 10.075 2.25002 10.075H4V8.92504L2.75002 8.92502C2.5153 8.92502 2.32502 8.73474 2.32502 8.50002C2.32503 8.26529 2.51531 8.07502 2.75003 8.07502L4 8.07504V6.92502L2.74999 6.925C2.51527 6.925 2.325 6.73472 2.325 6.5C2.325 6.26528 2.51529 6.075 2.75001 6.075L4 6.07502V4.92507L0.999997 4.92505ZM4.92505 4H6.075V2.75006C6.075 2.51534 6.26528 2.32506 6.5 2.32506C6.73472 2.32506 6.925 2.51534 6.925 2.75006V4H8.07502V2.75005C8.07502 2.51533 8.2653 2.32505 8.50002 2.32505C8.73474 2.32505 8.92502 2.51533 8.92502 2.75005V4H10.0751V2.25005C10.0751 2.01533 10.2653 1.82505 10.5001 1.82505C10.7348 1.82505 10.9251 2.01533 10.9251 2.25005V4H12.0751V2.75005C12.0751 2.51533 12.2654 2.32505 12.5001 2.32505C12.7348 2.32505 12.9251 2.51533 12.9251 2.75005V4H14V1H4.92502L4.92505 4Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3N = ["color"];
var ScissorsIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3N);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M0.949988 4.48455C0.949988 5.34059 1.64395 6.03455 2.49999 6.03455C3.35603 6.03455 4.04999 5.34059 4.04999 4.48455C4.04999 3.6285 3.35603 2.93455 2.49999 2.93455C1.64395 2.93455 0.949988 3.6285 0.949988 4.48455ZM2.49999 6.93455C1.14689 6.93455 0.0499878 5.83764 0.0499878 4.48455C0.0499878 3.13145 1.14689 2.03455 2.49999 2.03455C3.85309 2.03455 4.94999 3.13145 4.94999 4.48455C4.94999 4.80813 4.88726 5.11707 4.77329 5.39985L5.73655 6.04413C5.72943 6.06656 5.72269 6.08914 5.71635 6.11188L5.56288 6.66186L5.21005 6.89773L4.21554 6.23366C3.77357 6.6672 3.168 6.93455 2.49999 6.93455ZM0.949991 10.5C0.949991 9.64394 1.64395 8.94998 2.49999 8.94998C3.35603 8.94998 4.04999 9.64394 4.04999 10.5C4.04999 11.356 3.35603 12.05 2.49999 12.05C1.64395 12.05 0.949991 11.356 0.949991 10.5ZM2.49999 8.04998C1.14689 8.04998 0.0499908 9.14688 0.0499908 10.5C0.0499908 11.8531 1.14689 12.95 2.49999 12.95C3.85309 12.95 4.94999 11.8531 4.94999 10.5C4.94999 10.1803 4.88877 9.87497 4.77743 9.595L15 2.75737L14.0486 2.85737C12.7077 2.9983 11.4091 3.40895 10.231 4.06461L7.15646 5.77564C6.92307 5.90553 6.75134 6.12339 6.67955 6.38066L6.42653 7.28737L4.22437 8.75957C3.78166 8.32091 3.17246 8.04998 2.49999 8.04998ZM7.14435 9.2149L7.15646 9.22176L10.231 10.9328C11.4091 11.5884 12.7077 11.9991 14.0486 12.14L15 12.24L8.81072 8.1003L7.14435 9.2149Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3O = ["color"];
var SectionIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3O);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM2 5L2 10H13V5H2ZM2 4C1.44772 4 1 4.44772 1 5V10C1 10.5523 1.44772 11 2 11H13C13.5523 11 14 10.5523 14 10V5C14 4.44772 13.5523 4 13 4H2ZM1.5 14C1.77614 14 2 13.7761 2 13.5C2 13.2239 1.77614 13 1.5 13C1.22386 13 1 13.2239 1 13.5C1 13.7761 1.22386 14 1.5 14ZM4 1.5C4 1.77614 3.77614 2 3.5 2C3.22386 2 3 1.77614 3 1.5C3 1.22386 3.22386 1 3.5 1C3.77614 1 4 1.22386 4 1.5ZM3.5 14C3.77614 14 4 13.7761 4 13.5C4 13.2239 3.77614 13 3.5 13C3.22386 13 3 13.2239 3 13.5C3 13.7761 3.22386 14 3.5 14ZM6 1.5C6 1.77614 5.77614 2 5.5 2C5.22386 2 5 1.77614 5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5ZM5.5 14C5.77614 14 6 13.7761 6 13.5C6 13.2239 5.77614 13 5.5 13C5.22386 13 5 13.2239 5 13.5C5 13.7761 5.22386 14 5.5 14ZM8 1.5C8 1.77614 7.77614 2 7.5 2C7.22386 2 7 1.77614 7 1.5C7 1.22386 7.22386 1 7.5 1C7.77614 1 8 1.22386 8 1.5ZM7.5 14C7.77614 14 8 13.7761 8 13.5C8 13.2239 7.77614 13 7.5 13C7.22386 13 7 13.2239 7 13.5C7 13.7761 7.22386 14 7.5 14ZM10 1.5C10 1.77614 9.77614 2 9.5 2C9.22386 2 9 1.77614 9 1.5C9 1.22386 9.22386 1 9.5 1C9.77614 1 10 1.22386 10 1.5ZM9.5 14C9.77614 14 10 13.7761 10 13.5C10 13.2239 9.77614 13 9.5 13C9.22386 13 9 13.2239 9 13.5C9 13.7761 9.22386 14 9.5 14ZM12 1.5C12 1.77614 11.7761 2 11.5 2C11.2239 2 11 1.77614 11 1.5C11 1.22386 11.2239 1 11.5 1C11.7761 1 12 1.22386 12 1.5ZM11.5 14C11.7761 14 12 13.7761 12 13.5C12 13.2239 11.7761 13 11.5 13C11.2239 13 11 13.2239 11 13.5C11 13.7761 11.2239 14 11.5 14ZM14 1.5C14 1.77614 13.7761 2 13.5 2C13.2239 2 13 1.77614 13 1.5C13 1.22386 13.2239 1 13.5 1C13.7761 1 14 1.22386 14 1.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3P = (/* unused pure expression or super */ null && (["color"]));
var SewingPinIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3P);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M6 3.5C6 2.67157 6.67157 2 7.5 2C8.32843 2 9 2.67157 9 3.5C9 4.32843 8.32843 5 7.5 5C6.67157 5 6 4.32843 6 3.5ZM8 5.94999C9.14112 5.71836 10 4.70948 10 3.5C10 2.11929 8.88071 1 7.5 1C6.11929 1 5 2.11929 5 3.5C5 4.70948 5.85888 5.71836 7 5.94999V13.5C7 13.7761 7.22386 14 7.5 14C7.77614 14 8 13.7761 8 13.5V5.94999Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3Q = (/* unused pure expression or super */ null && (["color"]));
var SewingPinFilledIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3Q);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M10 3.5C10 4.70948 9.14112 5.71836 8 5.94999V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.94999C5.85888 5.71836 5 4.70948 5 3.5C5 2.11929 6.11929 1 7.5 1C8.88071 1 10 2.11929 10 3.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3R = ["color"];
var ShadowIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3R);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    opacity: ".05",
    d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    opacity: ".1",
    d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    opacity: ".15",
    d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    opacity: ".2",
    d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    opacity: ".25",
    d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    opacity: ".3",
    d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    opacity: ".35",
    d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    opacity: ".4",
    d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    opacity: ".45",
    d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    opacity: ".5",
    d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3S = (/* unused pure expression or super */ null && (["color"]));
var ShadowInnerIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3S);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    opacity: ".05",
    d: "M12.1619 3.85182C8.35817 4.88918 4.88936 8.358 3.85199 12.1617L3.3696 12.0301C4.45356 8.05564 8.05581 4.45339 12.0303 3.36943L12.1619 3.85182Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".1",
    d: "M11.8807 3.42707C8.03441 4.50542 4.50561 8.03422 3.42726 11.8805L2.94582 11.7456C4.07129 7.73121 7.7314 4.0711 11.7458 2.94563L11.8807 3.42707Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".15",
    d: "M11.5201 3.02556C7.69092 4.16199 4.16779 7.68323 3.02805 11.512L2.54883 11.3694C3.73676 7.37869 7.38659 3.73076 11.3778 2.54623L11.5201 3.02556Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".2",
    d: "M11.0468 2.66169C7.31117 3.87664 3.87918 7.3079 2.66298 11.0434L2.18754 10.8886C3.45324 7.00109 7.00445 3.45062 10.8921 2.18621L11.0468 2.66169Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".25",
    d: "M10.5201 2.32365C6.92091 3.61447 3.62391 6.90876 2.32845 10.5073L1.858 10.338C3.20398 6.59909 6.61155 3.19424 10.3513 1.85301L10.5201 2.32365Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".3",
    d: "M9.90222 2.03122C6.50003 3.39465 3.39968 6.49367 2.03399 9.89551L1.56998 9.70924C2.98651 6.18076 6.18728 2.98133 9.71622 1.5671L9.90222 2.03122Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".35",
    d: "M9.20727 1.78873C6.06136 3.20349 3.21103 6.05203 1.79331 9.19738L1.33747 8.99192C2.80536 5.73528 5.74485 2.7976 9.0022 1.33272L9.20727 1.78873Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".4",
    d: "M8.40713 1.62085C5.59323 3.05117 3.05794 5.58509 1.62544 8.39847L1.17987 8.1716C2.66036 5.26397 5.27232 2.6534 8.18057 1.17513L8.40713 1.62085Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".45",
    d: "M7.46207 1.56747C5.08689 2.94695 2.95362 5.07912 1.57249 7.45379L1.14028 7.20241C2.56503 4.75273 4.7607 2.55818 7.21096 1.1351L7.46207 1.56747Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".5",
    d: "M6.30407 1.70487C4.51964 2.91063 2.90983 4.52061 1.7043 6.30513L1.28998 6.02524C2.5313 4.18773 4.18673 2.53214 6.02413 1.29059L6.30407 1.70487Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3T = (/* unused pure expression or super */ null && (["color"]));
var ShadowNoneIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3T);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    opacity: ".05",
    d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".1",
    d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".15",
    d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".2",
    d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".25",
    d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".3",
    d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".35",
    d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".4",
    d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".45",
    d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".5",
    d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 9.1488 1.47969 10.657 2.4767 11.8162L1.64647 12.6464C1.45121 12.8417 1.45121 13.1583 1.64647 13.3535C1.84173 13.5488 2.15832 13.5488 2.35358 13.3535L3.18383 12.5233C4.34302 13.5202 5.8511 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34298 12.5233 3.1838L13.3536 2.35355C13.5488 2.15829 13.5488 1.8417 13.3536 1.64644C13.1583 1.45118 12.8417 1.45118 12.6465 1.64644L11.8162 2.47667C10.657 1.47966 9.14883 0.877045 7.49991 0.877045ZM11.1423 3.15065C10.1568 2.32449 8.88644 1.82704 7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 8.88641 2.32452 10.1568 3.15069 11.1422L11.1423 3.15065ZM3.85781 11.8493C4.84322 12.6753 6.11348 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11345 12.6754 4.84319 11.8493 3.85778L3.85781 11.8493Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3U = (/* unused pure expression or super */ null && (["color"]));
var ShadowOuterIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3U);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    opacity: ".05",
    d: "M12.1398 3.88617C13.8553 4.94159 15 6.83701 15 9.00001C15 12.3137 12.3137 15 9.00002 15C6.84351 15 4.95296 13.8621 3.89569 12.1552L4.32076 11.8919C5.29069 13.4578 7.02376 14.5 9.00002 14.5C12.0376 14.5 14.5 12.0375 14.5 9.00001C14.5 7.01781 13.4516 5.28027 11.8778 4.31203L12.1398 3.88617Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".2",
    d: "M12.851 5.07321C13.8684 6.07106 14.5 7.46199 14.5 9C14.5 12.0375 12.0376 14.5 9.00004 14.5C7.46215 14.5 6.07132 13.8685 5.07349 12.8513L5.43043 12.5011C6.3381 13.4264 7.60186 14 9.00004 14C11.7614 14 14 11.7614 14 9C14 7.60171 13.4264 6.33786 12.5009 5.43017L12.851 5.07321Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".35",
    d: "M13.3022 6.45071C13.7455 7.19737 14 8.06935 14 9.00001C14 11.7614 11.7614 14 9.00002 14C8.04868 14 7.15868 13.7341 6.40118 13.2724L6.66142 12.8454C7.34275 13.2607 8.14306 13.5 9.00002 13.5C11.4853 13.5 13.5 11.4853 13.5 9.00001C13.5 8.16165 13.271 7.37754 12.8722 6.70599L13.3022 6.45071Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".5",
    d: "M13.3745 7.94022C13.4566 8.28031 13.5 8.63525 13.5 9.00001C13.5 11.4853 11.4853 13.5 9.00003 13.5C8.61104 13.5 8.23323 13.4506 7.87268 13.3576L7.99759 12.8734C8.31768 12.956 8.65353 13 9.00003 13C11.2091 13 13 11.2091 13 9.00001C13 8.67509 12.9613 8.35953 12.8884 8.05757L13.3745 7.94022Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    opacity: ".65",
    d: "M12.9155 9.82133C12.5898 11.3813 11.3562 12.6072 9.79205 12.9215L9.69354 12.4313C11.0613 12.1565 12.1413 11.0834 12.4261 9.71915L12.9155 9.82133Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), createElement("path", {
    d: "M1.2771 7.50253C1.2771 4.06456 4.06413 1.27753 7.5021 1.27753C10.94 1.27753 13.7271 4.06456 13.7271 7.50253C13.7271 10.9405 10.94 13.7275 7.5021 13.7275C4.06413 13.7275 1.2771 10.9405 1.2771 7.50253ZM7.5021 2.22753C4.5888 2.22753 2.2271 4.58923 2.2271 7.50253C2.2271 10.4158 4.5888 12.7775 7.5021 12.7775C10.4154 12.7775 12.7771 10.4158 12.7771 7.50253C12.7771 4.58923 10.4154 2.22753 7.5021 2.22753Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3V = ["color"];
var Share1Icon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3V);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M5 7.50003C5 8.32845 4.32843 9.00003 3.5 9.00003C2.67157 9.00003 2 8.32845 2 7.50003C2 6.6716 2.67157 6.00003 3.5 6.00003C4.32843 6.00003 5 6.6716 5 7.50003ZM5.71313 8.66388C5.29445 9.45838 4.46048 10 3.5 10C2.11929 10 1 8.88074 1 7.50003C1 6.11931 2.11929 5.00003 3.5 5.00003C4.46048 5.00003 5.29445 5.54167 5.71313 6.33616L9.10424 4.21671C9.03643 3.98968 9 3.74911 9 3.50003C9 2.11932 10.1193 1.00003 11.5 1.00003C12.8807 1.00003 14 2.11932 14 3.50003C14 4.88074 12.8807 6.00003 11.5 6.00003C10.6915 6.00003 9.97264 5.61624 9.51566 5.0209L5.9853 7.22738C5.99502 7.31692 6 7.40789 6 7.50003C6 7.59216 5.99502 7.68312 5.9853 7.77267L9.51567 9.97915C9.97265 9.38382 10.6915 9.00003 11.5 9.00003C12.8807 9.00003 14 10.1193 14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5C9 11.2509 9.03643 11.0104 9.10425 10.7833L5.71313 8.66388ZM11.5 5.00003C12.3284 5.00003 13 4.32846 13 3.50003C13 2.6716 12.3284 2.00003 11.5 2.00003C10.6716 2.00003 10 2.6716 10 3.50003C10 4.32846 10.6716 5.00003 11.5 5.00003ZM13 11.5C13 12.3285 12.3284 13 11.5 13C10.6716 13 10 12.3285 10 11.5C10 10.6716 10.6716 10 11.5 10C12.3284 10 13 10.6716 13 11.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3W = (/* unused pure expression or super */ null && (["color"]));
var Share2Icon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3W);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.5 5.00006C3.22386 5.00006 3 5.22392 3 5.50006L3 11.5001C3 11.7762 3.22386 12.0001 3.5 12.0001L11.5 12.0001C11.7761 12.0001 12 11.7762 12 11.5001L12 5.50006C12 5.22392 11.7761 5.00006 11.5 5.00006L10.25 5.00006C9.97386 5.00006 9.75 4.7762 9.75 4.50006C9.75 4.22392 9.97386 4.00006 10.25 4.00006L11.5 4.00006C12.3284 4.00006 13 4.67163 13 5.50006L13 11.5001C13 12.3285 12.3284 13.0001 11.5 13.0001L3.5 13.0001C2.67157 13.0001 2 12.3285 2 11.5001L2 5.50006C2 4.67163 2.67157 4.00006 3.5 4.00006L4.75 4.00006C5.02614 4.00006 5.25 4.22392 5.25 4.50006C5.25 4.7762 5.02614 5.00006 4.75 5.00006L3.5 5.00006ZM7 1.6364L5.5682 3.0682C5.39246 3.24393 5.10754 3.24393 4.9318 3.0682C4.75607 2.89246 4.75607 2.60754 4.9318 2.4318L7.1818 0.181802C7.26619 0.09741 7.38065 0.049999 7.5 0.049999C7.61935 0.049999 7.73381 0.09741 7.8182 0.181802L10.0682 2.4318C10.2439 2.60754 10.2439 2.89246 10.0682 3.0682C9.89246 3.24393 9.60754 3.24393 9.4318 3.0682L8 1.6364L8 8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5L7 1.6364Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3X = (/* unused pure expression or super */ null && (["color"]));
var ShuffleIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3X);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M12.3536 1.14645C12.1583 0.951184 11.8417 0.951184 11.6464 1.14645C11.4512 1.34171 11.4512 1.65829 11.6464 1.85355L12.7929 3H12C10.7037 3 9.71111 3.58423 8.87248 4.38931C8.20065 5.03427 7.59349 5.85684 6.99461 6.6682C6.86287 6.84668 6.73154 7.02462 6.6 7.2C5.10874 9.18835 3.49037 11 0.5 11C0.223858 11 0 11.2239 0 11.5C0 11.7761 0.223858 12 0.5 12C4.00963 12 5.89126 9.81165 7.4 7.8C7.54367 7.60845 7.6832 7.41962 7.81996 7.23454L7.82005 7.23443L7.82006 7.23441C8.41674 6.42695 8.96069 5.69085 9.56502 5.11069C10.2889 4.41577 11.0463 4 12 4H12.7929L11.6464 5.14645C11.4512 5.34171 11.4512 5.65829 11.6464 5.85355C11.8417 6.04882 12.1583 6.04882 12.3536 5.85355L14.3536 3.85355C14.5488 3.65829 14.5488 3.34171 14.3536 3.14645L12.3536 1.14645ZM0.5 3C3.35278 3 5.12992 4.44588 6.50548 6.06746L6.3762 6.24266C6.2483 6.4161 6.12293 6.58609 6 6.75C5.96397 6.79804 5.92798 6.84581 5.892 6.89331C4.57348 5.29306 3.02637 4 0.5 4C0.223858 4 0 3.77614 0 3.5C0 3.22386 0.223858 3 0.5 3ZM8.87248 10.6107C8.37284 10.131 7.90897 9.55314 7.45767 8.95468C7.64688 8.71693 7.82704 8.48061 8 8.25L8.08987 8.12987C8.58412 8.79402 9.05288 9.39766 9.56502 9.88931C10.2889 10.5842 11.0463 11 12 11H12.7929L11.6464 9.85355C11.4512 9.65829 11.4512 9.34171 11.6464 9.14645C11.8417 8.95118 12.1583 8.95118 12.3536 9.14645L14.3536 11.1464C14.5488 11.3417 14.5488 11.6583 14.3536 11.8536L12.3536 13.8536C12.1583 14.0488 11.8417 14.0488 11.6464 13.8536C11.4512 13.6583 11.4512 13.3417 11.6464 13.1464L12.7929 12H12C10.7037 12 9.71111 11.4158 8.87248 10.6107Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3Y = ["color"];
var SizeIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3Y);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M11.5 3.04999C11.7485 3.04999 11.95 3.25146 11.95 3.49999V7.49999C11.95 7.74852 11.7485 7.94999 11.5 7.94999C11.2515 7.94999 11.05 7.74852 11.05 7.49999V4.58639L4.58638 11.05H7.49999C7.74852 11.05 7.94999 11.2515 7.94999 11.5C7.94999 11.7485 7.74852 11.95 7.49999 11.95L3.49999 11.95C3.38064 11.95 3.26618 11.9026 3.18179 11.8182C3.0974 11.7338 3.04999 11.6193 3.04999 11.5L3.04999 7.49999C3.04999 7.25146 3.25146 7.04999 3.49999 7.04999C3.74852 7.04999 3.94999 7.25146 3.94999 7.49999L3.94999 10.4136L10.4136 3.94999L7.49999 3.94999C7.25146 3.94999 7.04999 3.74852 7.04999 3.49999C7.04999 3.25146 7.25146 3.04999 7.49999 3.04999L11.5 3.04999Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3Z = ["color"];
var SketchLogoIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3Z);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.53731 0.826873C7.5125 0.824392 7.4875 0.824392 7.46269 0.826873L3.96269 1.17687C3.85672 1.18747 3.76025 1.24262 3.69736 1.32857L0.699771 5.42528C0.654046 5.48627 0.62647 5.56165 0.625057 5.6434C0.625019 5.6456 0.625 5.64781 0.625 5.65001C0.625 5.65052 0.625001 5.65103 0.625003 5.65153C0.625363 5.74237 0.658021 5.82559 0.712087 5.8903L7.21042 13.7883C7.28165 13.8749 7.38789 13.925 7.5 13.925C7.61211 13.925 7.71835 13.8749 7.78958 13.7883L14.2879 5.89031C14.342 5.8256 14.3746 5.74237 14.375 5.65153C14.375 5.65103 14.375 5.65052 14.375 5.65001C14.375 5.64849 14.375 5.64697 14.375 5.64545C14.3749 5.63963 14.3747 5.63382 14.3744 5.62801C14.37 5.55219 14.3431 5.48242 14.3002 5.42527L11.3026 1.32857C11.2397 1.24262 11.1433 1.18747 11.0373 1.17687L7.53731 0.826873ZM10.925 5.27501V5.25236L10.9223 5.27501H10.925ZM10.9342 5.17498H13.1877L11.2495 2.5261L10.9342 5.17498ZM10.5707 1.88395L8.04432 1.63131L10.1747 5.21034L10.5707 1.88395ZM6.95568 1.63131L4.42931 1.88395L4.82531 5.21034L6.95568 1.63131ZM3.75046 2.5261L1.81226 5.17498H4.0658L3.75046 2.5261ZM1.79416 6.02501L6.75861 12.0587L4.22371 6.0669C4.21787 6.0531 4.21314 6.0391 4.20949 6.02501H1.79416ZM5.15055 6.02501L7.49999 12.1085L9.84943 6.02501H9.78681H5.21319H5.15055ZM10.7905 6.02501C10.7869 6.0391 10.7821 6.0531 10.7763 6.0669L8.24139 12.0587L13.2058 6.02501H10.7905ZM7.5 2.18317L9.34038 5.27501H5.65962L7.5 2.18317Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$3_ = (/* unused pure expression or super */ null && (["color"]));
var SlashIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3_);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4.10876 14L9.46582 1H10.8178L5.46074 14H4.10876Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$3$ = ["color"];
var SliderIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3$);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M10.3004 7.49991C10.3004 8.4943 9.49426 9.30041 8.49988 9.30041C7.50549 9.30041 6.69938 8.4943 6.69938 7.49991C6.69938 6.50553 7.50549 5.69942 8.49988 5.69942C9.49426 5.69942 10.3004 6.50553 10.3004 7.49991ZM11.205 8C10.9699 9.28029 9.84816 10.2504 8.49988 10.2504C7.1516 10.2504 6.0299 9.28029 5.79473 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H5.7947C6.0298 5.71962 7.15154 4.74942 8.49988 4.74942C9.84822 4.74942 10.97 5.71962 11.2051 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H11.205Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$40 = (/* unused pure expression or super */ null && (["color"]));
var SpaceBetweenHorizontallyIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$40);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M14.4999 0.999994C14.2237 0.999994 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L9.99992 5.99995C9.44764 5.99995 8.99993 6.44766 8.99993 6.99994L8.99993 7.99994C8.99993 8.55222 9.44764 8.99993 9.99992 8.99993L13.9999 8.99993L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999994 14.4999 0.999994ZM4.99996 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999994 0.499996 0.999994C0.223856 0.999994 -9.7852e-09 1.22385 -2.18557e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99993L4.99996 8.99993C5.55224 8.99993 5.99995 8.55222 5.99995 7.99993L5.99995 6.99994C5.99995 6.44766 5.55224 5.99995 4.99996 5.99995Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$41 = (/* unused pure expression or super */ null && (["color"]));
var SpaceBetweenVerticallyIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$41);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1L9 1V5C9 5.55228 8.55228 6 8 6H7C6.44772 6 6 5.55228 6 5V1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 9C6.44772 9 6 9.44771 6 10V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9V10C9 9.44772 8.55228 9 8 9H7Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$42 = (/* unused pure expression or super */ null && (["color"]));
var SpaceEvenlyHorizontallyIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$42);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992ZM0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992ZM1.99998 6.99994C1.99998 6.44766 2.44769 5.99995 2.99998 5.99995L5.99995 5.99995C6.55223 5.99995 6.99994 6.44766 6.99994 6.99994L6.99994 7.99993C6.99994 8.55221 6.55223 8.99992 5.99995 8.99992L2.99998 8.99992C2.4477 8.99992 1.99998 8.55221 1.99998 7.99993L1.99998 6.99994ZM8.99993 5.99995C8.44765 5.99995 7.99993 6.44766 7.99993 6.99994L7.99993 7.99993C7.99993 8.55221 8.44765 8.99992 8.99993 8.99992L11.9999 8.99992C12.5522 8.99992 12.9999 8.55221 12.9999 7.99993L12.9999 6.99994C12.9999 6.44766 12.5522 5.99995 11.9999 5.99995L8.99993 5.99995Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$43 = (/* unused pure expression or super */ null && (["color"]));
var SpaceEvenlyVerticallyIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$43);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 2C6.44772 2 6 2.44772 6 3V6C6 6.55228 6.44772 7 7 7H8C8.55228 7 9 6.55228 9 6V3C9 2.44772 8.55228 2 8 2H7ZM7 8C6.44772 8 6 8.44771 6 9V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V9C9 8.44772 8.55228 8 8 8H7ZM1.49988 14C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H1.49988Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$44 = (/* unused pure expression or super */ null && (["color"]));
var SpeakerLoudIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$44);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.46968 1.05085C7.64122 1.13475 7.75 1.30904 7.75 1.5V13.5C7.75 13.691 7.64122 13.8653 7.46968 13.9492C7.29813 14.0331 7.09377 14.0119 6.94303 13.8947L3.2213 11H1.5C0.671571 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.2213L6.94303 1.10533C7.09377 0.988085 7.29813 0.966945 7.46968 1.05085ZM6.75 2.52232L3.69983 4.89468C3.61206 4.96294 3.50405 5 3.39286 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77615 1.22386 10 1.5 10H3.39286C3.50405 10 3.61206 10.0371 3.69983 10.1053L6.75 12.4777V2.52232ZM10.2784 3.84804C10.4623 3.72567 10.7106 3.77557 10.833 3.95949C12.2558 6.09798 12.2558 8.90199 10.833 11.0405C10.7106 11.2244 10.4623 11.2743 10.2784 11.1519C10.0944 11.0296 10.0445 10.7813 10.1669 10.5973C11.4111 8.72728 11.4111 6.27269 10.1669 4.40264C10.0445 4.21871 10.0944 3.97041 10.2784 3.84804ZM12.6785 1.43044C12.5356 1.2619 12.2832 1.24104 12.1147 1.38386C11.9462 1.52667 11.9253 1.77908 12.0681 1.94762C14.7773 5.14488 14.7773 9.85513 12.0681 13.0524C11.9253 13.2209 11.9462 13.4733 12.1147 13.6161C12.2832 13.759 12.5356 13.7381 12.6785 13.5696C15.6406 10.0739 15.6406 4.92612 12.6785 1.43044Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$45 = (/* unused pure expression or super */ null && (["color"]));
var SpeakerModerateIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$45);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.833 3.95949C10.7106 3.77557 10.4623 3.72567 10.2784 3.84804C10.0944 3.97041 10.0445 4.21871 10.1669 4.40264C11.4111 6.27268 11.4111 8.72728 10.1669 10.5973C10.0445 10.7813 10.0944 11.0296 10.2784 11.1519C10.4623 11.2743 10.7106 11.2244 10.833 11.0405C12.2558 8.90199 12.2558 6.09798 10.833 3.95949Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$46 = (/* unused pure expression or super */ null && (["color"]));
var SpeakerOffIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$46);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.72361 1.05279C7.893 1.13749 8 1.31062 8 1.5V13.5C8 13.6894 7.893 13.8625 7.72361 13.9472C7.55421 14.0319 7.35151 14.0136 7.2 13.9L3.33333 11H1.5C0.671573 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.33333L7.2 1.1C7.35151 0.986371 7.55421 0.968093 7.72361 1.05279ZM7 2.5L3.8 4.9C3.71345 4.96491 3.60819 5 3.5 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77614 1.22386 10 1.5 10H3.5C3.60819 10 3.71345 10.0351 3.8 10.1L7 12.5V2.5ZM14.8536 5.14645C15.0488 5.34171 15.0488 5.65829 14.8536 5.85355L13.2071 7.5L14.8536 9.14645C15.0488 9.34171 15.0488 9.65829 14.8536 9.85355C14.6583 10.0488 14.3417 10.0488 14.1464 9.85355L12.5 8.20711L10.8536 9.85355C10.6583 10.0488 10.3417 10.0488 10.1464 9.85355C9.95118 9.65829 9.95118 9.34171 10.1464 9.14645L11.7929 7.5L10.1464 5.85355C9.95118 5.65829 9.95118 5.34171 10.1464 5.14645C10.3417 4.95118 10.6583 4.95118 10.8536 5.14645L12.5 6.79289L14.1464 5.14645C14.3417 4.95118 14.6583 4.95118 14.8536 5.14645Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$47 = (/* unused pure expression or super */ null && (["color"]));
var SpeakerQuietIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$47);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.083 5.05577C9.96066 4.87185 9.71235 4.82195 9.52843 4.94432C9.3445 5.06669 9.2946 5.31499 9.41697 5.49892C10.2207 6.70693 10.2207 8.29303 9.41697 9.50104C9.2946 9.68496 9.3445 9.93326 9.52843 10.0556C9.71235 10.178 9.96066 10.1281 10.083 9.94418C11.0653 8.46773 11.0653 6.53222 10.083 5.05577Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$48 = ["color"];
var SquareIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$48);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1 1H1.5H13.5H14V1.5V13.5V14H13.5H1.5H1V13.5V1.5V1ZM2 2V13H13V2H2Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$49 = ["color"];
var StackIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$49);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.75432 1.81954C7.59742 1.72682 7.4025 1.72682 7.24559 1.81954L1.74559 5.06954C1.59336 5.15949 1.49996 5.32317 1.49996 5.5C1.49996 5.67683 1.59336 5.84051 1.74559 5.93046L7.24559 9.18046C7.4025 9.27318 7.59742 9.27318 7.75432 9.18046L13.2543 5.93046C13.4066 5.84051 13.5 5.67683 13.5 5.5C13.5 5.32317 13.4066 5.15949 13.2543 5.06954L7.75432 1.81954ZM7.49996 8.16923L2.9828 5.5L7.49996 2.83077L12.0171 5.5L7.49996 8.16923ZM2.25432 8.31954C2.01658 8.17906 1.70998 8.2579 1.56949 8.49564C1.42901 8.73337 1.50785 9.03998 1.74559 9.18046L7.24559 12.4305C7.4025 12.5232 7.59742 12.5232 7.75432 12.4305L13.2543 9.18046C13.4921 9.03998 13.5709 8.73337 13.4304 8.49564C13.2899 8.2579 12.9833 8.17906 12.7456 8.31954L7.49996 11.4192L2.25432 8.31954Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4a = ["color"];
var StarIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4a);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M6.97942 1.25171L6.9585 1.30199L5.58662 4.60039C5.54342 4.70426 5.44573 4.77523 5.3336 4.78422L1.7727 5.0697L1.71841 5.07405L1.38687 5.10063L1.08608 5.12475C0.820085 5.14607 0.712228 5.47802 0.914889 5.65162L1.14406 5.84793L1.39666 6.06431L1.43802 6.09974L4.15105 8.42374C4.23648 8.49692 4.2738 8.61176 4.24769 8.72118L3.41882 12.196L3.40618 12.249L3.32901 12.5725L3.25899 12.866C3.19708 13.1256 3.47945 13.3308 3.70718 13.1917L3.9647 13.0344L4.24854 12.861L4.29502 12.8326L7.34365 10.9705C7.43965 10.9119 7.5604 10.9119 7.6564 10.9705L10.705 12.8326L10.7515 12.861L11.0354 13.0344L11.2929 13.1917C11.5206 13.3308 11.803 13.1256 11.7411 12.866L11.671 12.5725L11.5939 12.249L11.5812 12.196L10.7524 8.72118C10.7263 8.61176 10.7636 8.49692 10.849 8.42374L13.562 6.09974L13.6034 6.06431L13.856 5.84793L14.0852 5.65162C14.2878 5.47802 14.18 5.14607 13.914 5.12475L13.6132 5.10063L13.2816 5.07405L13.2274 5.0697L9.66645 4.78422C9.55432 4.77523 9.45663 4.70426 9.41343 4.60039L8.04155 1.30199L8.02064 1.25171L7.89291 0.944609L7.77702 0.665992C7.67454 0.419604 7.32551 0.419604 7.22303 0.665992L7.10715 0.944609L6.97942 1.25171ZM7.50003 2.60397L6.50994 4.98442C6.32273 5.43453 5.89944 5.74207 5.41351 5.78103L2.84361 5.98705L4.8016 7.66428C5.17183 7.98142 5.33351 8.47903 5.2204 8.95321L4.62221 11.461L6.8224 10.1171C7.23842 9.86302 7.76164 9.86302 8.17766 10.1171L10.3778 11.461L9.77965 8.95321C9.66654 8.47903 9.82822 7.98142 10.1984 7.66428L12.1564 5.98705L9.58654 5.78103C9.10061 5.74207 8.67732 5.43453 8.49011 4.98442L7.50003 2.60397Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4b = ["color"];
var StarFilledIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4b);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z",
    fill: color
  }));
});

var _excluded$4c = (/* unused pure expression or super */ null && (["color"]));
var StitchesLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4c);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.84998 7.49998C1.84998 7.21321 1.87134 6.93143 1.91256 6.65615L9.56374 2.23875C9.86311 2.35627 10.15 2.49861 10.4219 2.66322L3.77065 6.50332C3.73669 6.52183 3.70482 6.5449 3.67602 6.57238C3.5911 6.65308 3.54245 6.76286 3.53682 6.87658C3.53359 6.9418 3.54451 7.00831 3.57086 7.07137C3.58927 7.1157 3.6149 7.15742 3.64744 7.19458C3.67306 7.22396 3.702 7.24941 3.73337 7.27069L7.32533 9.83813L3.87232 11.8317C2.63604 10.7953 1.84998 9.23944 1.84998 7.49998ZM8.36843 10.2751C8.37682 10.2706 8.38509 10.2659 8.39322 10.2608L9.84091 9.42499C9.84706 9.42163 9.85314 9.41812 9.85915 9.41446L11.3101 8.57677C11.3655 8.54649 11.4154 8.504 11.4554 8.44995C11.6034 8.25031 11.5616 7.96848 11.362 7.82046L7.82779 5.20017L11.2161 3.24393C12.4013 4.27963 13.15 5.80237 13.15 7.49998C13.15 7.83546 13.1207 8.16411 13.0647 8.48353L5.56875 12.8113C5.26138 12.6995 4.96646 12.5618 4.68662 12.4008L8.36843 10.2751ZM8.18149 9.34383L4.81659 6.93868L5.50918 6.53881L8.80604 8.98324L8.18149 9.34383ZM6.35875 6.04832L6.97822 5.69067L10.2751 8.13506L9.6556 8.49275L6.35875 6.04832ZM8.3318 1.91078L2.24263 5.42636C3.06941 3.33188 5.11164 1.84998 7.49998 1.84998C7.78258 1.84998 8.06033 1.87072 8.3318 1.91078ZM6.84684 13.1126C7.06114 13.1373 7.27908 13.15 7.49998 13.15C9.8246 13.15 11.8213 11.7461 12.6886 9.7399L6.84684 13.1126ZM7.49998 0.849976C3.82728 0.849976 0.849976 3.82728 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4d = (/* unused pure expression or super */ null && (["color"]));
var StopIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4d);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M2 3C2 2.44772 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44772 13 2 12.5523 2 12V3ZM12 3H3V12H12V3Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4e = (/* unused pure expression or super */ null && (["color"]));
var StopwatchIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4e);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L11.858 2.25806C12.1021 2.01398 12.4978 2.01398 12.7419 2.25806C12.986 2.50214 12.986 2.89786 12.7419 3.14194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13362 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.99998 4.5C7.99998 4.22386 7.77612 4 7.49998 4C7.22383 4 6.99998 4.22386 6.99998 4.5V9.5C6.99998 9.77614 7.22383 10 7.49998 10C7.77612 10 7.99998 9.77614 7.99998 9.5V4.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4f = (/* unused pure expression or super */ null && (["color"]));
var StretchHorizontallyIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4f);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99992L13.9999 8.99992L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4g = (/* unused pure expression or super */ null && (["color"]));
var StretchVerticallyIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4g);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H6H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM9 14V1L6 1V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4h = (/* unused pure expression or super */ null && (["color"]));
var StrikethroughIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4h);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M5.00003 3.25C5.00003 2.97386 4.77617 2.75 4.50003 2.75C4.22389 2.75 4.00003 2.97386 4.00003 3.25V7.10003H2.49998C2.27906 7.10003 2.09998 7.27912 2.09998 7.50003C2.09998 7.72094 2.27906 7.90003 2.49998 7.90003H4.00003V8.55C4.00003 10.483 5.56703 12.05 7.50003 12.05C9.43303 12.05 11 10.483 11 8.55V7.90003H12.5C12.7209 7.90003 12.9 7.72094 12.9 7.50003C12.9 7.27912 12.7209 7.10003 12.5 7.10003H11V3.25C11 2.97386 10.7762 2.75 10.5 2.75C10.2239 2.75 10 2.97386 10 3.25V7.10003H5.00003V3.25ZM5.00003 7.90003V8.55C5.00003 9.93071 6.11932 11.05 7.50003 11.05C8.88074 11.05 10 9.93071 10 8.55V7.90003H5.00003Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4i = ["color"];
var SunIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4i);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V2.5C8 2.77614 7.77614 3 7.5 3C7.22386 3 7 2.77614 7 2.5V0.5C7 0.223858 7.22386 0 7.5 0ZM2.1967 2.1967C2.39196 2.00144 2.70854 2.00144 2.90381 2.1967L4.31802 3.61091C4.51328 3.80617 4.51328 4.12276 4.31802 4.31802C4.12276 4.51328 3.80617 4.51328 3.61091 4.31802L2.1967 2.90381C2.00144 2.70854 2.00144 2.39196 2.1967 2.1967ZM0.5 7C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H2.5C2.77614 8 3 7.77614 3 7.5C3 7.22386 2.77614 7 2.5 7H0.5ZM2.1967 12.8033C2.00144 12.608 2.00144 12.2915 2.1967 12.0962L3.61091 10.682C3.80617 10.4867 4.12276 10.4867 4.31802 10.682C4.51328 10.8772 4.51328 11.1938 4.31802 11.3891L2.90381 12.8033C2.70854 12.9986 2.39196 12.9986 2.1967 12.8033ZM12.5 7C12.2239 7 12 7.22386 12 7.5C12 7.77614 12.2239 8 12.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12.5ZM10.682 4.31802C10.4867 4.12276 10.4867 3.80617 10.682 3.61091L12.0962 2.1967C12.2915 2.00144 12.608 2.00144 12.8033 2.1967C12.9986 2.39196 12.9986 2.70854 12.8033 2.90381L11.3891 4.31802C11.1938 4.51328 10.8772 4.51328 10.682 4.31802ZM8 12.5C8 12.2239 7.77614 12 7.5 12C7.22386 12 7 12.2239 7 12.5V14.5C7 14.7761 7.22386 15 7.5 15C7.77614 15 8 14.7761 8 14.5V12.5ZM10.682 10.682C10.8772 10.4867 11.1938 10.4867 11.3891 10.682L12.8033 12.0962C12.9986 12.2915 12.9986 12.608 12.8033 12.8033C12.608 12.9986 12.2915 12.9986 12.0962 12.8033L10.682 11.3891C10.4867 11.1938 10.4867 10.8772 10.682 10.682ZM5.5 7.5C5.5 6.39543 6.39543 5.5 7.5 5.5C8.60457 5.5 9.5 6.39543 9.5 7.5C9.5 8.60457 8.60457 9.5 7.5 9.5C6.39543 9.5 5.5 8.60457 5.5 7.5ZM7.5 4.5C5.84315 4.5 4.5 5.84315 4.5 7.5C4.5 9.15685 5.84315 10.5 7.5 10.5C9.15685 10.5 10.5 9.15685 10.5 7.5C10.5 5.84315 9.15685 4.5 7.5 4.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4j = ["color"];
var SwitchIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4j);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4ZM7.67133 11C6.65183 10.175 6 8.91363 6 7.5C6 6.08637 6.65183 4.82498 7.67133 4H4.5C2.567 4 1 5.567 1 7.5C1 9.433 2.567 11 4.5 11H7.67133ZM0 7.5C0 5.01472 2.01472 3 4.5 3H10.5C12.9853 3 15 5.01472 15 7.5C15 9.98528 12.9853 12 10.5 12H4.5C2.01472 12 0 9.98528 0 7.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4k = ["color"];
var SymbolIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4k);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4l = ["color"];
var TableIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4l);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M8 2H12.5C12.7761 2 13 2.22386 13 2.5V5H8V2ZM7 5V2H2.5C2.22386 2 2 2.22386 2 2.5V5H7ZM2 6V9H7V6H2ZM8 6H13V9H8V6ZM8 10H13V12.5C13 12.7761 12.7761 13 12.5 13H8V10ZM2 12.5V10H7V13H2.5C2.22386 13 2 12.7761 2 12.5ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4m = ["color"];
var TargetIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4m);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M0.900024 7.50002C0.900024 3.85495 3.85495 0.900024 7.50002 0.900024C11.1451 0.900024 14.1 3.85495 14.1 7.50002C14.1 11.1451 11.1451 14.1 7.50002 14.1C3.85495 14.1 0.900024 11.1451 0.900024 7.50002ZM7.50002 1.80002C4.35201 1.80002 1.80002 4.35201 1.80002 7.50002C1.80002 10.648 4.35201 13.2 7.50002 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.35201 10.648 1.80002 7.50002 1.80002ZM3.07504 7.50002C3.07504 5.05617 5.05618 3.07502 7.50004 3.07502C9.94388 3.07502 11.925 5.05617 11.925 7.50002C11.925 9.94386 9.94388 11.925 7.50004 11.925C5.05618 11.925 3.07504 9.94386 3.07504 7.50002ZM7.50004 3.92502C5.52562 3.92502 3.92504 5.52561 3.92504 7.50002C3.92504 9.47442 5.52563 11.075 7.50004 11.075C9.47444 11.075 11.075 9.47442 11.075 7.50002C11.075 5.52561 9.47444 3.92502 7.50004 3.92502ZM7.50004 5.25002C6.2574 5.25002 5.25004 6.25739 5.25004 7.50002C5.25004 8.74266 6.2574 9.75002 7.50004 9.75002C8.74267 9.75002 9.75004 8.74266 9.75004 7.50002C9.75004 6.25738 8.74267 5.25002 7.50004 5.25002ZM6.05004 7.50002C6.05004 6.69921 6.69923 6.05002 7.50004 6.05002C8.30084 6.05002 8.95004 6.69921 8.95004 7.50002C8.95004 8.30083 8.30084 8.95002 7.50004 8.95002C6.69923 8.95002 6.05004 8.30083 6.05004 7.50002Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4n = ["color"];
var TextIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4n);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M3.94993 2.95002L3.94993 4.49998C3.94993 4.74851 3.74845 4.94998 3.49993 4.94998C3.2514 4.94998 3.04993 4.74851 3.04993 4.49998V2.50004C3.04993 2.45246 3.05731 2.40661 3.07099 2.36357C3.12878 2.18175 3.29897 2.05002 3.49993 2.05002H11.4999C11.6553 2.05002 11.7922 2.12872 11.8731 2.24842C11.9216 2.32024 11.9499 2.40682 11.9499 2.50002L11.9499 2.50004V4.49998C11.9499 4.74851 11.7485 4.94998 11.4999 4.94998C11.2514 4.94998 11.0499 4.74851 11.0499 4.49998V2.95002H8.04993V12.05H9.25428C9.50281 12.05 9.70428 12.2515 9.70428 12.5C9.70428 12.7486 9.50281 12.95 9.25428 12.95H5.75428C5.50575 12.95 5.30428 12.7486 5.30428 12.5C5.30428 12.2515 5.50575 12.05 5.75428 12.05H6.94993V2.95002H3.94993Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4o = (/* unused pure expression or super */ null && (["color"]));
var TextAlignBottomIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4o);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.89949 5.50002C3.89949 5.27911 3.7204 5.10003 3.49949 5.10003C3.27857 5.10003 3.09949 5.27911 3.09949 5.50002L3.09949 12.5343L1.78233 11.2172C1.62612 11.061 1.37285 11.061 1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829L3.21664 13.7829C3.29166 13.8579 3.3934 13.9 3.49949 13.9C3.60557 13.9 3.70732 13.8579 3.78233 13.7829L5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172C5.62612 11.061 5.37285 11.061 5.21664 11.2172L3.89949 12.5343L3.89949 5.50002ZM8.49998 13C8.22383 13 7.99998 12.7762 7.99998 12.5C7.99998 12.2239 8.22383 12 8.49998 12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7762 14.7761 13 14.5 13H8.49998ZM8.49998 10C8.22383 10 7.99998 9.77617 7.99998 9.50002C7.99998 9.22388 8.22383 9.00002 8.49998 9.00002H14.5C14.7761 9.00002 15 9.22388 15 9.50002C15 9.77617 14.7761 10 14.5 10H8.49998ZM7.99998 6.50002C7.99998 6.77617 8.22383 7.00002 8.49998 7.00002H14.5C14.7761 7.00002 15 6.77617 15 6.50002C15 6.22388 14.7761 6.00002 14.5 6.00002H8.49998C8.22383 6.00002 7.99998 6.22388 7.99998 6.50002Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4p = ["color"];
var TextAlignCenterIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4p);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H10.5C10.7761 7 11 7.22386 11 7.5C11 7.77614 10.7761 8 10.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM3 10.5C3 10.2239 3.22386 10 3.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H3.5C3.22386 11 3 10.7761 3 10.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4q = ["color"];
var TextAlignJustifyIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4q);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2.5 4C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5H12.5C12.7761 5 13 4.77614 13 4.5C13 4.22386 12.7761 4 12.5 4H2.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4r = ["color"];
var TextAlignLeftIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4r);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H7.5C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4s = (/* unused pure expression or super */ null && (["color"]));
var TextAlignMiddleIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4s);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.49949 14.9C3.7204 14.9 3.89949 14.7209 3.89949 14.5L3.89949 10.4657L5.21664 11.7829C5.37285 11.9391 5.62612 11.9391 5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172L3.78233 9.21718C3.70732 9.14217 3.60557 9.10002 3.49949 9.10002C3.3934 9.10002 3.29166 9.14217 3.21664 9.21718L1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829C1.37285 11.9391 1.62612 11.9391 1.78233 11.7829L3.09949 10.4657L3.09949 14.5C3.09949 14.7209 3.27857 14.9 3.49949 14.9ZM7.99998 10.5C7.99998 10.7762 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7762 15 10.5C15 10.2239 14.7761 10 14.5 10H8.49998C8.22383 10 7.99998 10.2239 7.99998 10.5ZM7.99998 7.50002C7.99998 7.77617 8.22383 8.00002 8.49998 8.00002H14.5C14.7761 8.00002 15 7.77617 15 7.50002C15 7.22388 14.7761 7.00002 14.5 7.00002H8.49998C8.22383 7.00002 7.99998 7.22388 7.99998 7.50002ZM8.49998 5.00002C8.22383 5.00002 7.99998 4.77617 7.99998 4.50002C7.99998 4.22388 8.22383 4.00002 8.49998 4.00002H14.5C14.7761 4.00002 15 4.22388 15 4.50002C15 4.77617 14.7761 5.00002 14.5 5.00002H8.49998ZM3.89949 0.500025C3.89949 0.279111 3.7204 0.100025 3.49949 0.100025C3.27857 0.100025 3.09949 0.279111 3.09949 0.500025L3.09949 4.53434L1.78233 3.21718C1.62612 3.06097 1.37285 3.06097 1.21664 3.21718C1.06043 3.37339 1.06043 3.62666 1.21664 3.78287L3.21664 5.78287C3.29166 5.85788 3.3934 5.90002 3.49949 5.90002C3.60557 5.90002 3.70732 5.85788 3.78233 5.78287L5.78233 3.78287C5.93854 3.62666 5.93854 3.37339 5.78233 3.21718C5.62612 3.06097 5.37285 3.06097 5.21664 3.21718L3.89949 4.53434L3.89949 0.500025Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4t = ["color"];
var TextAlignRightIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4t);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM7 7.5C7 7.22386 7.22386 7 7.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H7.5C7.22386 8 7 7.77614 7 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H4.5C4.22386 11 4 10.7761 4 10.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4u = (/* unused pure expression or super */ null && (["color"]));
var TextAlignTopIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4u);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M3.89949 9.49998C3.89949 9.72089 3.7204 9.89997 3.49949 9.89997C3.27857 9.89997 3.09949 9.72089 3.09949 9.49998L3.09949 2.46566L1.78233 3.78282C1.62612 3.93903 1.37285 3.93903 1.21664 3.78282C1.06043 3.62661 1.06043 3.37334 1.21664 3.21713L3.21664 1.21713C3.29166 1.14212 3.3934 1.09998 3.49949 1.09998C3.60557 1.09998 3.70732 1.14212 3.78233 1.21713L5.78233 3.21713C5.93854 3.37334 5.93854 3.62661 5.78233 3.78282C5.62612 3.93903 5.37285 3.93903 5.21664 3.78282L3.89949 2.46566L3.89949 9.49998ZM8.49998 1.99998C8.22383 1.99998 7.99998 2.22383 7.99998 2.49998C7.99998 2.77612 8.22383 2.99998 8.49998 2.99998H14.5C14.7761 2.99998 15 2.77612 15 2.49998C15 2.22383 14.7761 1.99998 14.5 1.99998H8.49998ZM8.49998 4.99998C8.22383 4.99998 7.99998 5.22383 7.99998 5.49998C7.99998 5.77612 8.22383 5.99998 8.49998 5.99998H14.5C14.7761 5.99998 15 5.77612 15 5.49998C15 5.22383 14.7761 4.99998 14.5 4.99998H8.49998ZM7.99998 8.49998C7.99998 8.22383 8.22383 7.99998 8.49998 7.99998H14.5C14.7761 7.99998 15 8.22383 15 8.49998C15 8.77612 14.7761 8.99998 14.5 8.99998H8.49998C8.22383 8.99998 7.99998 8.77612 7.99998 8.49998Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4v = (/* unused pure expression or super */ null && (["color"]));
var TextNoneIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4v);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L11.9291 2.36383C11.9159 2.32246 11.897 2.28368 11.8732 2.24845C11.7923 2.12875 11.6554 2.05005 11.5001 2.05005H3.50005C3.29909 2.05005 3.1289 2.18178 3.07111 2.3636C3.05743 2.40665 3.05005 2.45249 3.05005 2.50007V4.50001C3.05005 4.74854 3.25152 4.95001 3.50005 4.95001C3.74858 4.95001 3.95005 4.74854 3.95005 4.50001V2.95005H6.95006V7.34284L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L6.95006 8.75705V12.0501H5.7544C5.50587 12.0501 5.3044 12.2515 5.3044 12.5001C5.3044 12.7486 5.50587 12.9501 5.7544 12.9501H9.2544C9.50293 12.9501 9.7044 12.7486 9.7044 12.5001C9.7044 12.2515 9.50293 12.0501 9.2544 12.0501H8.05006V7.65705L13.3536 2.35355ZM8.05006 6.24284L11.0501 3.24283V2.95005H8.05006V6.24284Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4w = (/* unused pure expression or super */ null && (["color"]));
var ThickArrowDownIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4w);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M5 3.5C5 3.22386 5.22386 3 5.5 3H9.5C9.77614 3 10 3.22386 10 3.5V6H12.5C12.6873 6 12.8589 6.10467 12.9446 6.27121C13.0303 6.43774 13.0157 6.63821 12.9069 6.79062L7.90687 13.7906C7.81301 13.922 7.66148 14 7.5 14C7.33853 14 7.18699 13.922 7.09314 13.7906L2.09314 6.79062C1.98427 6.63821 1.96972 6.43774 2.05542 6.27121C2.14112 6.10467 2.31271 6 2.5 6H5V3.5ZM6 4V6.5C6 6.77614 5.77614 7 5.5 7H3.4716L7.5 12.6398L11.5284 7H9.5C9.22386 7 9 6.77614 9 6.5V4H6Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4x = (/* unused pure expression or super */ null && (["color"]));
var ThickArrowLeftIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4x);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1 7.5C1 7.66148 1.07798 7.81301 1.20938 7.90687L8.20938 12.9069C8.36179 13.0157 8.56226 13.0303 8.72879 12.9446C8.89533 12.8589 9 12.6873 9 12.5L9 10L11.5 10C11.7761 10 12 9.77614 12 9.5L12 5.5C12 5.22386 11.7761 5 11.5 5L9 5L9 2.5C9 2.31271 8.89533 2.14112 8.72879 2.05542C8.56226 1.96972 8.36179 1.98427 8.20938 2.09313L1.20938 7.09314C1.07798 7.18699 1 7.33853 1 7.5ZM8 3.4716L8 5.5C8 5.77614 8.22386 6 8.5 6L11 6L11 9L8.5 9C8.22386 9 8 9.22386 8 9.5L8 11.5284L2.36023 7.5L8 3.4716Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4y = (/* unused pure expression or super */ null && (["color"]));
var ThickArrowRightIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4y);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M14 7.5C14 7.66148 13.922 7.81301 13.7906 7.90687L6.79062 12.9069C6.63821 13.0157 6.43774 13.0303 6.27121 12.9446C6.10467 12.8589 6 12.6873 6 12.5L6 10L3.5 10C3.22386 10 3 9.77614 3 9.5L3 5.5C3 5.22386 3.22386 5 3.5 5L6 5L6 2.5C6 2.31271 6.10467 2.14112 6.27121 2.05542C6.43774 1.96972 6.63821 1.98427 6.79062 2.09313L13.7906 7.09314C13.922 7.18699 14 7.33853 14 7.5ZM7 3.4716L7 5.5C7 5.77614 6.77614 6 6.5 6L4 6L4 9L6.5 9C6.77614 9 7 9.22386 7 9.5L7 11.5284L12.6398 7.5L7 3.4716Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4z = (/* unused pure expression or super */ null && (["color"]));
var ThickArrowUpIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4z);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.5 1C7.66148 1 7.81301 1.07798 7.90687 1.20938L12.9069 8.20938C13.0157 8.36179 13.0303 8.56226 12.9446 8.72879C12.8589 8.89533 12.6873 9 12.5 9H10V11.5C10 11.7761 9.77614 12 9.5 12H5.5C5.22386 12 5 11.7761 5 11.5V9H2.5C2.31271 9 2.14112 8.89533 2.05542 8.72879C1.96972 8.56226 1.98427 8.36179 2.09314 8.20938L7.09314 1.20938C7.18699 1.07798 7.33853 1 7.5 1ZM3.4716 8H5.5C5.77614 8 6 8.22386 6 8.5V11H9V8.5C9 8.22386 9.22386 8 9.5 8H11.5284L7.5 2.36023L3.4716 8Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4A = ["color"];
var TimerIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4A);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7.49998 0.849976C7.22383 0.849976 6.99998 1.07383 6.99998 1.34998V3.52234C6.99998 3.79848 7.22383 4.02234 7.49998 4.02234C7.77612 4.02234 7.99998 3.79848 7.99998 3.52234V1.8718C10.8862 2.12488 13.15 4.54806 13.15 7.49998C13.15 10.6204 10.6204 13.15 7.49998 13.15C4.37957 13.15 1.84998 10.6204 1.84998 7.49998C1.84998 6.10612 2.35407 4.83128 3.19049 3.8459C3.36919 3.63538 3.34339 3.31985 3.13286 3.14115C2.92234 2.96245 2.60681 2.98825 2.42811 3.19877C1.44405 4.35808 0.849976 5.86029 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976ZM6.74049 8.08072L4.22363 4.57237C4.15231 4.47295 4.16346 4.33652 4.24998 4.25C4.33649 4.16348 4.47293 4.15233 4.57234 4.22365L8.08069 6.74051C8.56227 7.08599 8.61906 7.78091 8.19998 8.2C7.78089 8.61909 7.08597 8.56229 6.74049 8.08072Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4B = ["color"];
var TokensIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4B);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4C = (/* unused pure expression or super */ null && (["color"]));
var TrackNextIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4C);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M13.0502 2.74989C13.0502 2.44613 12.804 2.19989 12.5002 2.19989C12.1965 2.19989 11.9502 2.44613 11.9502 2.74989V7.2825C11.9046 7.18802 11.8295 7.10851 11.7334 7.05776L2.73338 2.30776C2.5784 2.22596 2.3919 2.23127 2.24182 2.32176C2.09175 2.41225 2 2.57471 2 2.74995V12.25C2 12.4252 2.09175 12.5877 2.24182 12.6781C2.3919 12.7686 2.5784 12.7739 2.73338 12.6921L11.7334 7.94214C11.8295 7.89139 11.9046 7.81188 11.9502 7.7174V12.2499C11.9502 12.5536 12.1965 12.7999 12.5002 12.7999C12.804 12.7999 13.0502 12.5536 13.0502 12.2499V2.74989ZM3 11.4207V3.5792L10.4288 7.49995L3 11.4207Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4D = (/* unused pure expression or super */ null && (["color"]));
var TrackPreviousIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4D);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.94976 2.74989C1.94976 2.44613 2.196 2.19989 2.49976 2.19989C2.80351 2.19989 3.04976 2.44613 3.04976 2.74989V7.2825C3.0954 7.18802 3.17046 7.10851 3.26662 7.05776L12.2666 2.30776C12.4216 2.22596 12.6081 2.23127 12.7582 2.32176C12.9083 2.41225 13 2.57471 13 2.74995V12.25C13 12.4252 12.9083 12.5877 12.7582 12.6781C12.6081 12.7686 12.4216 12.7739 12.2666 12.6921L3.26662 7.94214C3.17046 7.89139 3.0954 7.81188 3.04976 7.7174V12.2499C3.04976 12.5536 2.80351 12.7999 2.49976 12.7999C2.196 12.7999 1.94976 12.5536 1.94976 12.2499V2.74989ZM4.57122 7.49995L12 11.4207V3.5792L4.57122 7.49995Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4E = (/* unused pure expression or super */ null && (["color"]));
var TransformIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4E);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4F = ["color"];
var TransparencyGridIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4F);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    opacity: ".25",
    d: "M0 0H3V3H0V0ZM6 3H3V6H0V9H3V12H0V15H3V12H6V15H9V12H12V15H15V12H12V9H15V6H12V3H15V0H12V3H9V0H6V3ZM6 6V3H9V6H6ZM6 9H3V6H6V9ZM9 9V6H12V9H9ZM9 9H6V12H9V9Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4G = ["color"];
var TrashIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4G);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M5.5 1C5.22386 1 5 1.22386 5 1.5C5 1.77614 5.22386 2 5.5 2H9.5C9.77614 2 10 1.77614 10 1.5C10 1.22386 9.77614 1 9.5 1H5.5ZM3 3.5C3 3.22386 3.22386 3 3.5 3H5H10H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H11V12C11 12.5523 10.5523 13 10 13H5C4.44772 13 4 12.5523 4 12V4L3.5 4C3.22386 4 3 3.77614 3 3.5ZM5 4H10V12H5V4Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4H = (/* unused pure expression or super */ null && (["color"]));
var TriangleDownIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4H);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4 6H11L7.5 10.5L4 6Z",
    fill: color
  }));
})));

var _excluded$4I = (/* unused pure expression or super */ null && (["color"]));
var TriangleLeftIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4I);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M9 4L9 11L4.5 7.5L9 4Z",
    fill: color
  }));
})));

var _excluded$4J = (/* unused pure expression or super */ null && (["color"]));
var TriangleRightIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4J);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M6 11L6 4L10.5 7.5L6 11Z",
    fill: color
  }));
})));

var _excluded$4K = (/* unused pure expression or super */ null && (["color"]));
var TriangleUpIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4K);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M4 9H11L7.5 4.5L4 9Z",
    fill: color
  }));
})));

var _excluded$4L = (/* unused pure expression or super */ null && (["color"]));
var TwitterLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4L);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.23336 4.69629C7.23336 2.96884 8.63335 1.56857 10.36 1.56857C11.3736 1.56857 12.183 2.04804 12.7254 2.74385C13.3079 2.62467 13.8557 2.40913 14.3513 2.11508C14.1559 2.72598 13.7424 3.2396 13.2033 3.56463C13.2038 3.56568 13.2042 3.56674 13.2047 3.56779C13.7334 3.50361 14.2364 3.36302 14.7048 3.15546L14.7037 3.15715C14.3667 3.66183 13.9431 4.10736 13.4561 4.47034C13.4823 4.64672 13.4956 4.82427 13.4956 5.00079C13.4956 8.6871 10.6873 12.9746 5.52122 12.9746C3.93906 12.9746 2.46544 12.511 1.22505 11.7152C0.992632 11.5661 0.925108 11.2568 1.07423 11.0244C1.0874 11.0038 1.10183 10.9846 1.11734 10.9666C1.20582 10.8202 1.37438 10.7309 1.5554 10.7522C2.47066 10.8601 3.38568 10.7485 4.19219 10.3962C3.39226 10.0434 2.77129 9.35975 2.50204 8.51974C2.45359 8.3686 2.48835 8.20311 2.59351 8.08422C2.59716 8.0801 2.60087 8.07606 2.60464 8.0721C1.96391 7.50819 1.55973 6.68208 1.55973 5.76143V5.72759C1.55973 5.56814 1.64411 5.42059 1.78155 5.33974C1.82671 5.31317 1.87537 5.29511 1.92532 5.28558C1.70549 4.86154 1.58116 4.37984 1.58116 3.86958C1.58116 3.40165 1.58384 2.81192 1.91332 2.28081C1.98718 2.16175 2.10758 2.08915 2.2364 2.07195C2.42588 2.01237 2.64087 2.06969 2.77406 2.23302C3.86536 3.57126 5.44066 4.49583 7.23366 4.73961L7.23336 4.69629ZM5.52122 11.9746C4.73387 11.9746 3.97781 11.8435 3.27248 11.6023C4.13012 11.4538 4.95307 11.1159 5.66218 10.5602C5.81211 10.4427 5.87182 10.2435 5.81126 10.0629C5.7507 9.88234 5.583 9.75943 5.39255 9.75607C4.68968 9.74366 4.06712 9.39716 3.67793 8.86845C3.86828 8.85306 4.05428 8.82039 4.23445 8.77167C4.43603 8.71716 4.57363 8.53114 4.56674 8.32243C4.55985 8.11372 4.41029 7.93718 4.20555 7.89607C3.42694 7.73977 2.79883 7.16764 2.56169 6.42174C2.76255 6.47025 2.97102 6.4991 3.18482 6.5061C3.38563 6.51267 3.56646 6.38533 3.62795 6.19405C3.68943 6.00277 3.61666 5.79391 3.44963 5.68224C2.86523 5.29155 2.48116 4.62464 2.48116 3.86958C2.48116 3.70213 2.48352 3.55268 2.49355 3.41719C3.85115 4.79913 5.70873 5.68931 7.77588 5.79338C7.93225 5.80126 8.08328 5.73543 8.18395 5.61553C8.28463 5.49562 8.32332 5.33548 8.28851 5.18284C8.25255 5.02517 8.23336 4.86284 8.23336 4.69629C8.23336 3.52085 9.18591 2.56857 10.36 2.56857C11.5943 2.56857 12.4956 3.71208 12.4956 5.00079C12.4956 8.25709 10.0202 11.9746 5.52122 11.9746Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4M = ["color"];
var UnderlineIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4M);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M5.00001 2.75C5.00001 2.47386 4.77615 2.25 4.50001 2.25C4.22387 2.25 4.00001 2.47386 4.00001 2.75V8.05C4.00001 9.983 5.56702 11.55 7.50001 11.55C9.43301 11.55 11 9.983 11 8.05V2.75C11 2.47386 10.7762 2.25 10.5 2.25C10.2239 2.25 10 2.47386 10 2.75V8.05C10 9.43071 8.88072 10.55 7.50001 10.55C6.1193 10.55 5.00001 9.43071 5.00001 8.05V2.75ZM3.49998 13.1001C3.27906 13.1001 3.09998 13.2791 3.09998 13.5001C3.09998 13.721 3.27906 13.9001 3.49998 13.9001H11.5C11.7209 13.9001 11.9 13.721 11.9 13.5001C11.9 13.2791 11.7209 13.1001 11.5 13.1001H3.49998Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4N = (/* unused pure expression or super */ null && (["color"]));
var UpdateIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4N);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4O = (/* unused pure expression or super */ null && (["color"]));
var UploadIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4O);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.81825 1.18188C7.64251 1.00615 7.35759 1.00615 7.18185 1.18188L4.18185 4.18188C4.00611 4.35762 4.00611 4.64254 4.18185 4.81828C4.35759 4.99401 4.64251 4.99401 4.81825 4.81828L7.05005 2.58648V9.49996C7.05005 9.74849 7.25152 9.94996 7.50005 9.94996C7.74858 9.94996 7.95005 9.74849 7.95005 9.49996V2.58648L10.1819 4.81828C10.3576 4.99401 10.6425 4.99401 10.8182 4.81828C10.994 4.64254 10.994 4.35762 10.8182 4.18188L7.81825 1.18188ZM2.5 9.99997C2.77614 9.99997 3 10.2238 3 10.5V12C3 12.5538 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2238 12.2239 9.99997 12.5 9.99997C12.7761 9.99997 13 10.2238 13 10.5V12C13 13.104 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2238 2.22386 9.99997 2.5 9.99997Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4P = (/* unused pure expression or super */ null && (["color"]));
var ValueIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4P);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4Q = (/* unused pure expression or super */ null && (["color"]));
var ValueNoneIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4Q);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 9.1488 1.47963 10.657 2.47665 11.8162L1.64643 12.6464C1.45117 12.8417 1.45117 13.1583 1.64643 13.3535C1.8417 13.5488 2.15828 13.5488 2.35354 13.3535L3.18377 12.5233C4.34296 13.5202 5.85104 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34299 12.5233 3.1838L13.3535 2.35354C13.5488 2.15827 13.5488 1.84169 13.3535 1.64643C13.1583 1.45117 12.8417 1.45117 12.6464 1.64643L11.8162 2.47668C10.657 1.47966 9.14877 0.877045 7.49985 0.877045ZM11.1422 3.15066C10.1567 2.32449 8.88639 1.82704 7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.88642 2.32446 10.1568 3.15063 11.1422L11.1422 3.15066ZM3.85776 11.8493C4.84317 12.6753 6.11343 13.1727 7.49985 13.1727C10.6328 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11346 12.6753 4.8432 11.8493 3.85779L3.85776 11.8493Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4R = (/* unused pure expression or super */ null && (["color"]));
var VercelLogoIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4R);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M7.49998 1L6.92321 2.00307L1.17498 12L0.599976 13H1.7535H13.2464H14.4L13.825 12L8.07674 2.00307L7.49998 1ZM7.49998 3.00613L2.3285 12H12.6714L7.49998 3.00613Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4S = ["color"];
var VideoIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4S);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M4.76447 3.12199C5.63151 3.04859 6.56082 3 7.5 3C8.43918 3 9.36849 3.04859 10.2355 3.12199C11.2796 3.21037 11.9553 3.27008 12.472 3.39203C12.9425 3.50304 13.2048 3.64976 13.4306 3.88086C13.4553 3.90618 13.4902 3.94414 13.5133 3.97092C13.7126 4.20149 13.8435 4.4887 13.918 5.03283C13.9978 5.6156 14 6.37644 14 7.52493C14 8.66026 13.9978 9.41019 13.9181 9.98538C13.8439 10.5206 13.7137 10.8061 13.5125 11.0387C13.4896 11.0651 13.4541 11.1038 13.4296 11.1287C13.2009 11.3625 12.9406 11.5076 12.4818 11.6164C11.9752 11.7365 11.3143 11.7942 10.2878 11.8797C9.41948 11.9521 8.47566 12 7.5 12C6.52434 12 5.58052 11.9521 4.7122 11.8797C3.68572 11.7942 3.02477 11.7365 2.51816 11.6164C2.05936 11.5076 1.7991 11.3625 1.57037 11.1287C1.54593 11.1038 1.51035 11.0651 1.48748 11.0387C1.28628 10.8061 1.15612 10.5206 1.08193 9.98538C1.00221 9.41019 1 8.66026 1 7.52493C1 6.37644 1.00216 5.6156 1.082 5.03283C1.15654 4.4887 1.28744 4.20149 1.48666 3.97092C1.5098 3.94414 1.54468 3.90618 1.56942 3.88086C1.7952 3.64976 2.05752 3.50304 2.52796 3.39203C3.04473 3.27008 3.7204 3.21037 4.76447 3.12199ZM0 7.52493C0 5.28296 0 4.16198 0.729985 3.31713C0.766457 3.27491 0.815139 3.22194 0.854123 3.18204C1.63439 2.38339 2.64963 2.29744 4.68012 2.12555C5.56923 2.05028 6.52724 2 7.5 2C8.47276 2 9.43077 2.05028 10.3199 2.12555C12.3504 2.29744 13.3656 2.38339 14.1459 3.18204C14.1849 3.22194 14.2335 3.27491 14.27 3.31713C15 4.16198 15 5.28296 15 7.52493C15 9.74012 15 10.8477 14.2688 11.6929C14.2326 11.7348 14.1832 11.7885 14.1444 11.8281C13.3629 12.6269 12.3655 12.71 10.3709 12.8763C9.47971 12.9505 8.50782 13 7.5 13C6.49218 13 5.52028 12.9505 4.62915 12.8763C2.63446 12.71 1.63712 12.6269 0.855558 11.8281C0.816844 11.7885 0.767442 11.7348 0.731221 11.6929C0 10.8477 0 9.74012 0 7.52493ZM5.25 5.38264C5.25 5.20225 5.43522 5.08124 5.60041 5.15369L10.428 7.27105C10.6274 7.35853 10.6274 7.64147 10.428 7.72895L5.60041 9.84631C5.43522 9.91876 5.25 9.79775 5.25 9.61736V5.38264Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4T = ["color"];
var ViewGridIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4T);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M7 2H1.5C1.22386 2 1 2.22386 1 2.5V7H7V2ZM8 2V7H14V2.5C14 2.22386 13.7761 2 13.5 2H8ZM7 8H1V12.5C1 12.7761 1.22386 13 1.5 13H7V8ZM8 13V8H14V12.5C14 12.7761 13.7761 13 13.5 13H8ZM1.5 1C0.671573 1 0 1.67157 0 2.5V12.5C0 13.3284 0.671573 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.67157 14.3284 1 13.5 1H1.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4U = (/* unused pure expression or super */ null && (["color"]));
var ViewHorizontalIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4U);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M1.5 2H13.5C13.7761 2 14 2.22386 14 2.5V7H1V2.5C1 2.22386 1.22386 2 1.5 2ZM1 8V12.5C1 12.7761 1.22386 13 1.5 13H13.5C13.7761 13 14 12.7761 14 12.5V8H1ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4V = (/* unused pure expression or super */ null && (["color"]));
var ViewNoneIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4V);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M14 2.58711L1.85163 13H13.5C13.7761 13 14 12.7761 14 12.5V2.58711ZM0.762879 13.8067L0.825396 13.8796L0.854717 13.8545C1.05017 13.9478 1.26899 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.93949 14.6926 1.45078 14.2371 1.19331L14.1746 1.12037L14.1453 1.1455C13.9498 1.05222 13.731 1 13.5 1H1.5C0.671573 1 0 1.67157 0 2.5V12.5C0 13.0605 0.307435 13.5492 0.762879 13.8067ZM1 12.4129L13.1484 2H1.5C1.22386 2 1 2.22386 1 2.5V12.4129Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4W = (/* unused pure expression or super */ null && (["color"]));
var ViewVerticalIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4W);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M8 2H13.5C13.7761 2 14 2.22386 14 2.5V12.5C14 12.7761 13.7761 13 13.5 13H8V2ZM7 2H1.5C1.22386 2 1 2.22386 1 2.5V12.5C1 12.7761 1.22386 13 1.5 13H7V2ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4X = ["color"];
var WidthIcon = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4X);

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M4.81812 4.68161C4.99386 4.85734 4.99386 5.14227 4.81812 5.318L3.08632 7.0498H11.9135L10.1817 5.318C10.006 5.14227 10.006 4.85734 10.1817 4.68161C10.3575 4.50587 10.6424 4.50587 10.8181 4.68161L13.3181 7.18161C13.4939 7.35734 13.4939 7.64227 13.3181 7.818L10.8181 10.318C10.6424 10.4937 10.3575 10.4937 10.1817 10.318C10.006 10.1423 10.006 9.85734 10.1817 9.68161L11.9135 7.9498H3.08632L4.81812 9.68161C4.99386 9.85734 4.99386 10.1423 4.81812 10.318C4.64239 10.4937 4.35746 10.4937 4.18173 10.318L1.68173 7.818C1.50599 7.64227 1.50599 7.35734 1.68173 7.18161L4.18173 4.68161C4.35746 4.50587 4.64239 4.50587 4.81812 4.68161Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});

var _excluded$4Y = (/* unused pure expression or super */ null && (["color"]));
var ZoomInIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4Y);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159ZM4.25 6.5C4.25 6.22386 4.47386 6 4.75 6H6V4.75C6 4.47386 6.22386 4.25 6.5 4.25C6.77614 4.25 7 4.47386 7 4.75V6H8.25C8.52614 6 8.75 6.22386 8.75 6.5C8.75 6.77614 8.52614 7 8.25 7H7V8.25C7 8.52614 6.77614 8.75 6.5 8.75C6.22386 8.75 6 8.52614 6 8.25V7H4.75C4.47386 7 4.25 6.77614 4.25 6.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));

var _excluded$4Z = (/* unused pure expression or super */ null && (["color"]));
var ZoomOutIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4Z);

  return createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), createElement("path", {
    d: "M6.5 10C8.433 10 10 8.433 10 6.5C10 4.567 8.433 3 6.5 3C4.567 3 3 4.567 3 6.5C3 8.433 4.567 10 6.5 10ZM6.5 11C7.56251 11 8.53901 10.6318 9.30884 10.0159L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L10.0159 9.30884C10.6318 8.53901 11 7.56251 11 6.5C11 4.01472 8.98528 2 6.5 2C4.01472 2 2 4.01472 2 6.5C2 8.98528 4.01472 11 6.5 11ZM4.75 6C4.47386 6 4.25 6.22386 4.25 6.5C4.25 6.77614 4.47386 7 4.75 7H8.25C8.52614 7 8.75 6.77614 8.75 6.5C8.75 6.22386 8.52614 6 8.25 6H4.75Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
})));


//# sourceMappingURL=react-icons.esm.js.map


/***/ }),

/***/ 45293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ invariant; }
/* harmony export */ });
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */
function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  if (false) {}

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
}


//# sourceMappingURL=invariant.esm.js.map


/***/ }),

/***/ 57320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ shallowEqual; }
/* harmony export */ });
function shallowEqual(objA, objB, compare, compareContext) {
  var compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (compareResult !== void 0) {
    return !!compareResult;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];
    compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (compareResult === false || compareResult === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
}


//# sourceMappingURL=shallowequal.esm.js.map


/***/ }),

/***/ 30195:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 62139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g7": function() { return /* binding */ Slot; }
/* harmony export */ });
/* unused harmony exports asyncFromGen, bind, noContext, setTimeout, wrapYieldingFiberMethods */
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE = {};
var idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context_1 !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = currentContext;
        currentContext = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = currentContext;
        return function () {
            var saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            var saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
function maybe(fn) {
    try {
        return fn();
    }
    catch (ignored) { }
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
var globalKey = "@wry/context:Slot";
var host = 
// Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
maybe(function () { return globalThis; }) ||
    // Fall back to global, which works in Node.js and may be converted by some
    // bundlers to the appropriate identifier (window, self, ...) depending on the
    // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
    maybe(function () { return __webpack_require__.g; }) ||
    // Otherwise, use a dummy host that's local to this module. We used to fall
    // back to using the Array constructor as a namespace, but that was flagged in
    // https://github.com/benjamn/wryware/issues/347, and can be avoided.
    Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
var globalHost = host;
var Slot = globalHost[globalKey] ||
    // Earlier versions of this package stored the globalKey property on the Array
    // constructor, so we check there as well, to prevent Slot class duplication.
    Array[globalKey] ||
    (function (Slot) {
        try {
            Object.defineProperty(globalHost, globalKey, {
                value: Slot,
                enumerable: false,
                writable: false,
                // When it was possible for globalHost to be the Array constructor (a
                // legacy Slot dedup strategy), it was important for the property to be
                // configurable:true so it could be deleted. That does not seem to be as
                // important when globalHost is the global object, but I don't want to
                // cause similar problems again, and configurable:true seems safest.
                // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
                configurable: true
            });
        }
        finally {
            return Slot;
        }
    })(makeSlotClass());

var bind = Slot.bind, noContext = Slot.noContext;
function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        var gen = genFn.apply(this, arguments);
        var boundNext = bind(gen.next);
        var boundThrow = bind(gen.throw);
        return new Promise(function (resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            var invokeNext = function (value) { return invoke(boundNext, value); };
            var invokeThrow = function (error) { return invoke(boundThrow, error); };
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var wrappedFibers = (/* unused pure expression or super */ null && ([]));
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function (obj, method) {
            var fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}


//# sourceMappingURL=context.esm.js.map


/***/ }),

/***/ 38229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ equal; }
/* harmony export */ });
/* unused harmony export default */
var _a = Object.prototype, toString = _a.toString, hasOwnProperty = _a.hasOwnProperty;
var fnToStr = Function.prototype.toString;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = toString.call(a);
    var bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            var aKeys = definedKeys(a);
            var bKeys = definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (var k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (var k = 0; k < keyCount; ++k) {
                var key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "".concat(b);
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while (true) {
                var info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
        case '[object Uint16Array]':
        case '[object Uint8Array]': // Buffer, in Node.js.
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]': {
            var len = a.byteLength;
            if (len === b.byteLength) {
                while (len-- && a[len] === b[len]) {
                    // Keep looping as long as the bytes are equal.
                }
            }
            return len === -1;
        }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]': {
            var aCode = fnToStr.call(a);
            if (aCode !== fnToStr.call(b)) {
                return false;
            }
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !endsWith(aCode, nativeCodeSuffix);
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
var nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    var fromIndex = full.length - suffix.length;
    return fromIndex >= 0 &&
        full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}


//# sourceMappingURL=equality.esm.js.map


/***/ }),

/***/ 3985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Trie; }
/* harmony export */ });
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var defaultMakeData = function () { return Object.create(null); };
// Useful for processing arguments objects as well as arrays.
var _a = Array.prototype, forEach = _a.forEach, slice = _a.slice;
var Trie = /** @class */ (function () {
    function Trie(weakness, makeData) {
        if (weakness === void 0) { weakness = true; }
        if (makeData === void 0) { makeData = defaultMakeData; }
        this.weakness = weakness;
        this.makeData = makeData;
    }
    Trie.prototype.lookup = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        return this.lookupArray(array);
    };
    Trie.prototype.lookupArray = function (array) {
        var node = this;
        forEach.call(array, function (key) { return node = node.getChildTrie(key); });
        return node.data || (node.data = this.makeData(slice.call(array)));
    };
    Trie.prototype.getChildTrie = function (key) {
        var map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    };
    return Trie;
}());
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}


//# sourceMappingURL=trie.esm.js.map


/***/ }),

/***/ 32418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "StyleSheet": function() { return /* binding */ es_StyleSheet; },
  "StyleSheetServer": function() { return /* binding */ es_StyleSheetServer; },
  "StyleSheetTestUtils": function() { return /* binding */ es_StyleSheetTestUtils; },
  "css": function() { return /* binding */ css; },
  "defaultSelectorHandlers": function() { return /* binding */ es_defaultSelectorHandlers; },
  "flushToStyleTag": function() { return /* binding */ es_flushToStyleTag; },
  "injectAndGetClassName": function() { return /* binding */ es_injectAndGetClassName; },
  "minify": function() { return /* binding */ minify; },
  "reset": function() { return /* binding */ es_reset; },
  "resetInjectedStyle": function() { return /* binding */ es_resetInjectedStyle; }
});

// EXTERNAL MODULE: ../../node_modules/string-hash/index.js
var string_hash = __webpack_require__(9839);
var string_hash_default = /*#__PURE__*/__webpack_require__.n(string_hash);
// EXTERNAL MODULE: ../../node_modules/asap/browser-asap.js
var browser_asap = __webpack_require__(60629);
var browser_asap_default = /*#__PURE__*/__webpack_require__.n(browser_asap);
;// CONCATENATED MODULE: ../../node_modules/aphrodite/es/chunk-febce46b.js



function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/* @flow */
/* ::
type ObjectMap = { [id:string]: any };
*/

var UPPERCASE_RE = /([A-Z])/g;

var UPPERCASE_RE_TO_KEBAB = function UPPERCASE_RE_TO_KEBAB(match
/* : string */
) {
  return (
    /* : string */
    "-".concat(match.toLowerCase())
  );
};

var kebabifyStyleName = function kebabifyStyleName(string
/* : string */
)
/* : string */
{
  var result = string.replace(UPPERCASE_RE, UPPERCASE_RE_TO_KEBAB);

  if (result[0] === 'm' && result[1] === 's' && result[2] === '-') {
    return "-".concat(result);
  }

  return result;
};
/**
 * CSS properties which accept numbers but are not in units of "px".
 * Taken from React's CSSProperty.js
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
/**
 * Taken from React's CSSProperty.js
 *
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */

function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 * Taken from React's CSSProperty.js
 */


var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
// Taken from React's CSSProperty.js

Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});
var stringifyValue = function stringifyValue(key
/* : string */
, prop
/* : any */
)
/* : string */
{
  if (typeof prop === "number") {
    if (isUnitlessNumber[key]) {
      return "" + prop;
    } else {
      return prop + "px";
    }
  } else {
    return '' + prop;
  }
};
var stringifyAndImportantifyValue = function stringifyAndImportantifyValue(key
/* : string */
, prop
/* : any */
) {
  return (
    /* : string */
    importantify(stringifyValue(key, prop))
  );
}; // Turn a string into a hash string of base-36 values (using letters and numbers)
// eslint-disable-next-line no-unused-vars

var hashString = function hashString(string
/* : string */
, key
/* : ?string */
) {
  return (
    /* string */
    string_hash_default()(string).toString(36)
  );
}; // Hash a javascript object using JSON.stringify. This is very fast, about 3
// microseconds on my computer for a sample object:
// http://jsperf.com/test-hashfnv32a-hash/5
//
// Note that this uses JSON.stringify to stringify the objects so in order for
// this to produce consistent hashes browsers need to have a consistent
// ordering of objects. Ben Alpert says that Facebook depends on this, so we
// can probably depend on this too.

var hashObject = function hashObject(object
/* : ObjectMap */
) {
  return (
    /* : string */
    hashString(JSON.stringify(object))
  );
}; // Given a single style value string like the "b" from "a: b;", adds !important
// to generate "b !important".

var importantify = function importantify(string
/* : string */
) {
  return (
    /* : string */
    // Bracket string character access is very fast, and in the default case we
    // normally don't expect there to be "!important" at the end of the string
    // so we can use this simple check to take an optimized path. If there
    // happens to be a "!" in this position, we follow up with a more thorough
    // check.
    string[string.length - 10] === '!' && string.slice(-11) === ' !important' ? string : "".concat(string, " !important")
  );
};

/* @flow */
var MAP_EXISTS = typeof Map !== 'undefined';

var OrderedElements =
/*#__PURE__*/
function () {
  /* ::
  elements: {[string]: any};
  keyOrder: string[];
  */
  function OrderedElements() {
    this.elements = {};
    this.keyOrder = [];
  }

  var _proto = OrderedElements.prototype;

  _proto.forEach = function forEach(callback
  /* : (string, any) => void */
  ) {
    for (var i = 0; i < this.keyOrder.length; i++) {
      // (value, key) to match Map's API
      callback(this.elements[this.keyOrder[i]], this.keyOrder[i]);
    }
  };

  _proto.set = function set(key
  /* : string */
  , value
  /* : any */
  , shouldReorder
  /* : ?boolean */
  ) {
    if (!this.elements.hasOwnProperty(key)) {
      this.keyOrder.push(key);
    } else if (shouldReorder) {
      var index = this.keyOrder.indexOf(key);
      this.keyOrder.splice(index, 1);
      this.keyOrder.push(key);
    }

    if (value == null) {
      this.elements[key] = value;
      return;
    }

    if (MAP_EXISTS && value instanceof Map || value instanceof OrderedElements) {
      // We have found a nested Map, so we need to recurse so that all
      // of the nested objects and Maps are merged properly.
      var nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();
      value.forEach(function (value, key) {
        nested.set(key, value, shouldReorder);
      });
      this.elements[key] = nested;
      return;
    }

    if (!Array.isArray(value) && _typeof(value) === 'object') {
      // We have found a nested object, so we need to recurse so that all
      // of the nested objects and Maps are merged properly.
      var _nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();

      var keys = Object.keys(value);

      for (var i = 0; i < keys.length; i += 1) {
        _nested.set(keys[i], value[keys[i]], shouldReorder);
      }

      this.elements[key] = _nested;
      return;
    }

    this.elements[key] = value;
  };

  _proto.get = function get(key
  /* : string */
  )
  /* : any */
  {
    return this.elements[key];
  };

  _proto.has = function has(key
  /* : string */
  )
  /* : boolean */
  {
    return this.elements.hasOwnProperty(key);
  };

  _proto.addStyleType = function addStyleType(styleType
  /* : any */
  )
  /* : void */
  {
    var _this = this;

    if (MAP_EXISTS && styleType instanceof Map || styleType instanceof OrderedElements) {
      styleType.forEach(function (value, key) {
        _this.set(key, value, true);
      });
    } else {
      var keys = Object.keys(styleType);

      for (var i = 0; i < keys.length; i++) {
        this.set(keys[i], styleType[keys[i]], true);
      }
    }
  };

  return OrderedElements;
}();

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n.default || n;
}

var capitalizeString_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
});

unwrapExports(capitalizeString_1);

var prefixProperty_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;



var _capitalizeString2 = _interopRequireDefault(capitalizeString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var newStyle = {};
    var requiredPrefixes = prefixProperties[property];
    var capitalizedProperty = (0, _capitalizeString2.default)(property);
    var keys = Object.keys(style);
    for (var i = 0; i < keys.length; i++) {
      var styleProperty = keys[i];
      if (styleProperty === property) {
        for (var j = 0; j < requiredPrefixes.length; j++) {
          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
        }
      }
      newStyle[styleProperty] = style[styleProperty];
    }
    return newStyle;
  }
  return style;
}
});

unwrapExports(prefixProperty_1);

var prefixValue_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
});

unwrapExports(prefixValue_1);

var addNewValuesOnly_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
});

unwrapExports(addNewValuesOnly_1);

var isObject_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
});

unwrapExports(isObject_1);

var createPrefixer_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;



var _prefixProperty2 = _interopRequireDefault(prefixProperty_1);



var _prefixValue2 = _interopRequireDefault(prefixValue_1);



var _addNewValuesOnly2 = _interopRequireDefault(addNewValuesOnly_1);



var _isObject2 = _interopRequireDefault(isObject_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  return function prefix(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefix(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        style = (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  };
}
});

var createPrefixer = unwrapExports(createPrefixer_1);

var backgroundClip_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = backgroundClip;

// https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip#Browser_compatibility
function backgroundClip(property, value) {
  if (typeof value === 'string' && value === 'text') {
    return ['-webkit-text', 'text'];
  }
}
});

var backgroundClip = unwrapExports(backgroundClip_1);

var isPrefixedValue_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];
});

unwrapExports(isPrefixedValue_1);

var calc_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];
function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
});

var calc = unwrapExports(calc_1);

var crossFade_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
});

var crossFade = unwrapExports(crossFade_1);

var cursor_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
});

var cursor = unwrapExports(cursor_1);

var filter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
});

var filter = unwrapExports(filter_1);

var flex_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
});

var flex = unwrapExports(flex_1);

var flexboxIE_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
  // Full expanded syntax is flex-grow | flex-shrink | flex-basis.
};var flexShorthandMappings = {
  auto: '1 1 auto',
  inherit: 'inherit',
  initial: '0 1 auto',
  none: '0 0 auto',
  unset: 'unset'
};
var isUnitlessNumber = /^\d+(\.\d+)?$/;

function flexboxIE(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
  if (property === 'flex') {
    // For certain values we can do straight mappings based on the spec
    // for the expansions.
    if (Object.prototype.hasOwnProperty.call(flexShorthandMappings, value)) {
      style.msFlex = flexShorthandMappings[value];
      return;
    }
    // Here we have no direct mapping, so we favor looking for a
    // unitless positive number as that will be the most common use-case.
    if (isUnitlessNumber.test(value)) {
      style.msFlex = value + ' 1 0%';
      return;
    }

    // The next thing we can look for is if there are multiple values.
    var flexValues = value.split(/\s/);
    // If we only have a single value that wasn't a positive unitless
    // or a pre-mapped value, then we can assume it is a unit value.
    switch (flexValues.length) {
      case 1:
        style.msFlex = '1 1 ' + value;
        return;
      case 2:
        // If we have 2 units, then we expect that the first will
        // always be a unitless number and represents flex-grow.
        // The second unit will represent flex-shrink for a unitless
        // value, or flex-basis otherwise.
        if (isUnitlessNumber.test(flexValues[1])) {
          style.msFlex = flexValues[0] + ' ' + flexValues[1] + ' 0%';
        } else {
          style.msFlex = flexValues[0] + ' 1 ' + flexValues[1];
        }
        return;
      default:
        style.msFlex = value;
    }
  }
}
});

var flexboxIE = unwrapExports(flexboxIE_1);

var flexboxOld_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines',
  flexGrow: 'WebkitBoxFlex'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
});

var flexboxOld = unwrapExports(flexboxOld_1);

var gradient_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return value.replace(values, function (grad) {
        return prefix + grad;
      });
    });
  }
}
});

var gradient = unwrapExports(gradient_1);

var grid_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = grid;
function isSimplePositionValue(value) {
  return typeof value === 'number' && !isNaN(value);
}

var alignmentValues = ['center', 'end', 'start', 'stretch'];

var displayValues = {
  'inline-grid': ['-ms-inline-grid', 'inline-grid'],
  grid: ['-ms-grid', 'grid']
};

var propertyConverters = {
  alignSelf: function alignSelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridRowAlign = value;
    }
  },

  gridColumn: function gridColumn(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    } else {
      var _value$split$map = value.split('/').map(function (position) {
        return +position;
      }),
          _value$split$map2 = _slicedToArray(_value$split$map, 2),
          start = _value$split$map2[0],
          end = _value$split$map2[1];

      propertyConverters.gridColumnStart(start, style);
      propertyConverters.gridColumnEnd(end, style);
    }
  },

  gridColumnEnd: function gridColumnEnd(value, style) {
    var msGridColumn = style.msGridColumn;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridColumn)) {
      style.msGridColumnSpan = value - msGridColumn;
    }
  },

  gridColumnStart: function gridColumnStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    }
  },

  gridRow: function gridRow(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    } else {
      var _value$split$map3 = value.split('/').map(function (position) {
        return +position;
      }),
          _value$split$map4 = _slicedToArray(_value$split$map3, 2),
          start = _value$split$map4[0],
          end = _value$split$map4[1];

      propertyConverters.gridRowStart(start, style);
      propertyConverters.gridRowEnd(end, style);
    }
  },

  gridRowEnd: function gridRowEnd(value, style) {
    var msGridRow = style.msGridRow;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridRow)) {
      style.msGridRowSpan = value - msGridRow;
    }
  },

  gridRowStart: function gridRowStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    }
  },

  gridTemplateColumns: function gridTemplateColumns(value, style) {
    style.msGridColumns = value;
  },

  gridTemplateRows: function gridTemplateRows(value, style) {
    style.msGridRows = value;
  },

  justifySelf: function justifySelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridColumnAlign = value;
    }
  }
};

function grid(property, value, style) {
  if (property === 'display' && value in displayValues) {
    return displayValues[value];
  }

  if (property in propertyConverters) {
    var propertyConverter = propertyConverters[property];
    propertyConverter(value, style);
  }
}
});

var grid = unwrapExports(grid_1);

var imageSet_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
});

var imageSet = unwrapExports(imageSet_1);

var logical_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = logical;
var alternativeProps = {
  marginBlockStart: ['WebkitMarginBefore'],
  marginBlockEnd: ['WebkitMarginAfter'],
  marginInlineStart: ['WebkitMarginStart', 'MozMarginStart'],
  marginInlineEnd: ['WebkitMarginEnd', 'MozMarginEnd'],
  paddingBlockStart: ['WebkitPaddingBefore'],
  paddingBlockEnd: ['WebkitPaddingAfter'],
  paddingInlineStart: ['WebkitPaddingStart', 'MozPaddingStart'],
  paddingInlineEnd: ['WebkitPaddingEnd', 'MozPaddingEnd'],
  borderBlockStart: ['WebkitBorderBefore'],
  borderBlockStartColor: ['WebkitBorderBeforeColor'],
  borderBlockStartStyle: ['WebkitBorderBeforeStyle'],
  borderBlockStartWidth: ['WebkitBorderBeforeWidth'],
  borderBlockEnd: ['WebkitBorderAfter'],
  borderBlockEndColor: ['WebkitBorderAfterColor'],
  borderBlockEndStyle: ['WebkitBorderAfterStyle'],
  borderBlockEndWidth: ['WebkitBorderAfterWidth'],
  borderInlineStart: ['WebkitBorderStart', 'MozBorderStart'],
  borderInlineStartColor: ['WebkitBorderStartColor', 'MozBorderStartColor'],
  borderInlineStartStyle: ['WebkitBorderStartStyle', 'MozBorderStartStyle'],
  borderInlineStartWidth: ['WebkitBorderStartWidth', 'MozBorderStartWidth'],
  borderInlineEnd: ['WebkitBorderEnd', 'MozBorderEnd'],
  borderInlineEndColor: ['WebkitBorderEndColor', 'MozBorderEndColor'],
  borderInlineEndStyle: ['WebkitBorderEndStyle', 'MozBorderEndStyle'],
  borderInlineEndWidth: ['WebkitBorderEndWidth', 'MozBorderEndWidth']
};

function logical(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
    var alternativePropList = alternativeProps[property];
    for (var i = 0, len = alternativePropList.length; i < len; ++i) {
      style[alternativePropList[i]] = value;
    }
  }
}
});

var logical = unwrapExports(logical_1);

var position_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
});

var position = unwrapExports(position_1);

var sizing_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
});

var sizing = unwrapExports(sizing_1);

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

var hyphenateStyleName$1 = /*#__PURE__*/Object.freeze({
  default: hyphenateStyleName
});

var _hyphenateStyleName = getCjsExportFromNamespace(hyphenateStyleName$1);

var hyphenateProperty_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;



var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];
});

unwrapExports(hyphenateProperty_1);

var transition_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;



var _hyphenateProperty2 = _interopRequireDefault(hyphenateProperty_1);



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);



var _capitalizeString2 = _interopRequireDefault(capitalizeString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
});

var transition = unwrapExports(transition_1);

var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];
var staticData = {
  plugins: [backgroundClip, calc, crossFade, cursor, filter, flex, flexboxIE, flexboxOld, gradient, grid, imageSet, logical, position, sizing, transition],
  prefixMap: {
    "transform": wms,
    "transformOrigin": wms,
    "transformOriginX": wms,
    "transformOriginY": wms,
    "backfaceVisibility": w,
    "perspective": w,
    "perspectiveOrigin": w,
    "transformStyle": w,
    "transformOriginZ": w,
    "animation": w,
    "animationDelay": w,
    "animationDirection": w,
    "animationFillMode": w,
    "animationDuration": w,
    "animationIterationCount": w,
    "animationName": w,
    "animationPlayState": w,
    "animationTimingFunction": w,
    "appearance": wm,
    "userSelect": wmms,
    "fontKerning": w,
    "textEmphasisPosition": w,
    "textEmphasis": w,
    "textEmphasisStyle": w,
    "textEmphasisColor": w,
    "boxDecorationBreak": w,
    "clipPath": w,
    "maskImage": w,
    "maskMode": w,
    "maskRepeat": w,
    "maskPosition": w,
    "maskClip": w,
    "maskOrigin": w,
    "maskSize": w,
    "maskComposite": w,
    "mask": w,
    "maskBorderSource": w,
    "maskBorderMode": w,
    "maskBorderSlice": w,
    "maskBorderWidth": w,
    "maskBorderOutset": w,
    "maskBorderRepeat": w,
    "maskBorder": w,
    "maskType": w,
    "textDecorationStyle": wm,
    "textDecorationSkip": wm,
    "textDecorationLine": wm,
    "textDecorationColor": wm,
    "filter": w,
    "fontFeatureSettings": wm,
    "breakAfter": wmms,
    "breakBefore": wmms,
    "breakInside": wmms,
    "columnCount": wm,
    "columnFill": wm,
    "columnGap": wm,
    "columnRule": wm,
    "columnRuleColor": wm,
    "columnRuleStyle": wm,
    "columnRuleWidth": wm,
    "columns": wm,
    "columnSpan": wm,
    "columnWidth": wm,
    "writingMode": wms,
    "flex": wms,
    "flexBasis": w,
    "flexDirection": wms,
    "flexGrow": w,
    "flexFlow": wms,
    "flexShrink": w,
    "flexWrap": wms,
    "alignContent": w,
    "alignItems": w,
    "alignSelf": w,
    "justifyContent": w,
    "order": w,
    "transitionDelay": w,
    "transitionDuration": w,
    "transitionProperty": w,
    "transitionTimingFunction": w,
    "backdropFilter": w,
    "scrollSnapType": wms,
    "scrollSnapPointsX": wms,
    "scrollSnapPointsY": wms,
    "scrollSnapDestination": wms,
    "scrollSnapCoordinate": wms,
    "shapeImageThreshold": w,
    "shapeImageMargin": w,
    "shapeImageOutside": w,
    "hyphens": wmms,
    "flowInto": wms,
    "flowFrom": wms,
    "regionFragment": wms,
    "textOrientation": w,
    "boxSizing": m,
    "textAlignLast": m,
    "tabSize": m,
    "wrapFlow": ms,
    "wrapThrough": ms,
    "wrapMargin": ms,
    "touchAction": ms,
    "textSizeAdjust": wms,
    "borderImage": w,
    "borderImageOutset": w,
    "borderImageRepeat": w,
    "borderImageSlice": w,
    "borderImageSource": w,
    "borderImageWidth": w
  }
};

var prefixAll = createPrefixer(staticData);
/* ::
import type { SheetDefinition } from './index.js';
type StringHandlers = { [id:string]: Function };
type SelectorCallback = (selector: string) => string[];
export type SelectorHandler = (
    selector: string,
    baseSelector: string,
    callback: SelectorCallback
) => string[] | string | null;
*/

/**
 * `selectorHandlers` are functions which handle special selectors which act
 * differently than normal style definitions. These functions look at the
 * current selector and can generate CSS for the styles in their subtree by
 * calling the callback with a new selector.
 *
 * For example, when generating styles with a base selector of '.foo' and the
 * following styles object:
 *
 *   {
 *     ':nth-child(2n)': {
 *       ':hover': {
 *         color: 'red'
 *       }
 *     }
 *   }
 *
 * when we reach the ':hover' style, we would call our selector handlers like
 *
 *   handler(':hover', '.foo:nth-child(2n)', callback)
 *
 * Since our `pseudoSelectors` handles ':hover' styles, that handler would call
 * the callback like
 *
 *   callback('.foo:nth-child(2n):hover')
 *
 * to generate its subtree `{ color: 'red' }` styles with a
 * '.foo:nth-child(2n):hover' selector. The callback would return an array of CSS
 * rules like
 *
 *   ['.foo:nth-child(2n):hover{color:red !important;}']
 *
 * and the handler would then return that resulting CSS.
 *
 * `defaultSelectorHandlers` is the list of default handlers used in a call to
 * `generateCSS`.
 *
 * @name SelectorHandler
 * @function
 * @param {string} selector: The currently inspected selector. ':hover' in the
 *     example above.
 * @param {string} baseSelector: The selector of the parent styles.
 *     '.foo:nth-child(2n)' in the example above.
 * @param {function} generateSubtreeStyles: A function which can be called to
 *     generate CSS for the subtree of styles corresponding to the selector.
 *     Accepts a new baseSelector to use for generating those styles.
 * @returns {string[] | string | null} The generated CSS for this selector, or
 *     null if we don't handle this selector.
 */

var defaultSelectorHandlers
/* : SelectorHandler[] */
= [// Handle pseudo-selectors, like :hover and :nth-child(3n)
function pseudoSelectors(selector, baseSelector, generateSubtreeStyles) {
  if (selector[0] !== ":") {
    return null;
  }

  return generateSubtreeStyles(baseSelector + selector);
}, // Handle media queries (or font-faces)
function mediaQueries(selector, baseSelector, generateSubtreeStyles) {
  if (selector[0] !== "@") {
    return null;
  } // Generate the styles normally, and then wrap them in the media query.


  var generated = generateSubtreeStyles(baseSelector);
  return ["".concat(selector, "{").concat(generated.join(''), "}")];
}];
/**
 * Generate CSS for a selector and some styles.
 *
 * This function handles the media queries and pseudo selectors that can be used
 * in aphrodite styles.
 *
 * @param {string} selector: A base CSS selector for the styles to be generated
 *     with.
 * @param {Object} styleTypes: A list of properties of the return type of
 *     StyleSheet.create, e.g. [styles.red, styles.blue].
 * @param {Array.<SelectorHandler>} selectorHandlers: A list of selector
 *     handlers to use for handling special selectors. See
 *     `defaultSelectorHandlers`.
 * @param stringHandlers: See `generateCSSRuleset`
 * @param useImportant: See `generateCSSRuleset`
 *
 * To actually generate the CSS special-construct-less styles are passed to
 * `generateCSSRuleset`.
 *
 * For instance, a call to
 *
 *     generateCSS(".foo", [{
 *       color: "red",
 *       "@media screen": {
 *         height: 20,
 *         ":hover": {
 *           backgroundColor: "black"
 *         }
 *       },
 *       ":active": {
 *         fontWeight: "bold"
 *       }
 *     }], defaultSelectorHandlers);
 *
 * with the default `selectorHandlers` will make 5 calls to
 * `generateCSSRuleset`:
 *
 *     generateCSSRuleset(".foo", { color: "red" }, ...)
 *     generateCSSRuleset(".foo:active", { fontWeight: "bold" }, ...)
 *     // These 2 will be wrapped in @media screen {}
 *     generateCSSRuleset(".foo", { height: 20 }, ...)
 *     generateCSSRuleset(".foo:hover", { backgroundColor: "black" }, ...)
 */

var generateCSS = function generateCSS(selector
/* : string */
, styleTypes
/* : SheetDefinition[] */
, selectorHandlers
/* : SelectorHandler[] */
, stringHandlers
/* : StringHandlers */
, useImportant
/* : boolean */
)
/* : string[] */
{
  var merged = new OrderedElements();

  for (var i = 0; i < styleTypes.length; i++) {
    merged.addStyleType(styleTypes[i]);
  }

  var plainDeclarations = new OrderedElements();
  var generatedStyles = []; // TODO(emily): benchmark this to see if a plain for loop would be faster.

  merged.forEach(function (val, key) {
    // For each key, see if one of the selector handlers will handle these
    // styles.
    var foundHandler = selectorHandlers.some(function (handler) {
      var result = handler(key, selector, function (newSelector) {
        return generateCSS(newSelector, [val], selectorHandlers, stringHandlers, useImportant);
      });

      if (result != null) {
        // If the handler returned something, add it to the generated
        // CSS and stop looking for another handler.
        if (Array.isArray(result)) {
          generatedStyles.push.apply(generatedStyles, _toConsumableArray(result));
        } else {
          // eslint-disable-next-line
          console.warn('WARNING: Selector handlers should return an array of rules.' + 'Returning a string containing multiple rules is deprecated.', handler);
          generatedStyles.push("@media all {".concat(result, "}"));
        }

        return true;
      }
    }); // If none of the handlers handled it, add it to the list of plain
    // style declarations.

    if (!foundHandler) {
      plainDeclarations.set(key, val, true);
    }
  });
  var generatedRuleset = generateCSSRuleset(selector, plainDeclarations, stringHandlers, useImportant, selectorHandlers);

  if (generatedRuleset) {
    generatedStyles.unshift(generatedRuleset);
  }

  return generatedStyles;
};
/**
 * Helper method of generateCSSRuleset to facilitate custom handling of certain
 * CSS properties. Used for e.g. font families.
 *
 * See generateCSSRuleset for usage and documentation of paramater types.
 */

var runStringHandlers = function runStringHandlers(declarations
/* : OrderedElements */
, stringHandlers
/* : StringHandlers */
, selectorHandlers
/* : SelectorHandler[] */
)
/* : void */
{
  if (!stringHandlers) {
    return;
  }

  var stringHandlerKeys = Object.keys(stringHandlers);

  for (var i = 0; i < stringHandlerKeys.length; i++) {
    var key = stringHandlerKeys[i];

    if (declarations.has(key)) {
      // A declaration exists for this particular string handler, so we
      // need to let the string handler interpret the declaration first
      // before proceeding.
      //
      // TODO(emily): Pass in a callback which generates CSS, similar to
      // how our selector handlers work, instead of passing in
      // `selectorHandlers` and have them make calls to `generateCSS`
      // themselves. Right now, this is impractical because our string
      // handlers are very specialized and do complex things.
      declarations.set(key, stringHandlers[key](declarations.get(key), selectorHandlers), // Preserve order here, since we are really replacing an
      // unprocessed style with a processed style, not overriding an
      // earlier style
      false);
    }
  }
};

var transformRule = function transformRule(key
/* : string */
, value
/* : string */
, transformValue
/* : function */
) {
  return (
    /* : string */
    "".concat(kebabifyStyleName(key), ":").concat(transformValue(key, value), ";")
  );
};

var arrayToObjectKeysReducer = function arrayToObjectKeysReducer(acc, val) {
  acc[val] = true;
  return acc;
};
/**
 * Generate a CSS ruleset with the selector and containing the declarations.
 *
 * This function assumes that the given declarations don't contain any special
 * children (such as media queries, pseudo-selectors, or descendant styles).
 *
 * Note that this method does not deal with nesting used for e.g.
 * psuedo-selectors or media queries. That responsibility is left to  the
 * `generateCSS` function.
 *
 * @param {string} selector: the selector associated with the ruleset
 * @param {Object} declarations: a map from camelCased CSS property name to CSS
 *     property value.
 * @param {Object.<string, function>} stringHandlers: a map from camelCased CSS
 *     property name to a function which will map the given value to the value
 *     that is output.
 * @param {bool} useImportant: A boolean saying whether to append "!important"
 *     to each of the CSS declarations.
 * @returns {string} A string of raw CSS.
 *
 * Examples:
 *
 *    generateCSSRuleset(".blah", { color: "red" })
 *    -> ".blah{color: red !important;}"
 *    generateCSSRuleset(".blah", { color: "red" }, {}, false)
 *    -> ".blah{color: red}"
 *    generateCSSRuleset(".blah", { color: "red" }, {color: c => c.toUpperCase})
 *    -> ".blah{color: RED}"
 *    generateCSSRuleset(".blah:hover", { color: "red" })
 *    -> ".blah:hover{color: red}"
 */


var generateCSSRuleset = function generateCSSRuleset(selector
/* : string */
, declarations
/* : OrderedElements */
, stringHandlers
/* : StringHandlers */
, useImportant
/* : boolean */
, selectorHandlers
/* : SelectorHandler[] */
)
/* : string */
{
  // Mutates declarations
  runStringHandlers(declarations, stringHandlers, selectorHandlers);
  var originalElements = Object.keys(declarations.elements).reduce(arrayToObjectKeysReducer, Object.create(null)); // NOTE(emily): This mutates handledDeclarations.elements.

  var prefixedElements = prefixAll(declarations.elements);
  var elementNames = Object.keys(prefixedElements);

  if (elementNames.length !== declarations.keyOrder.length) {
    // There are some prefixed values, so we need to figure out how to sort
    // them.
    //
    // Loop through prefixedElements, looking for anything that is not in
    // sortOrder, which means it was added by prefixAll. This means that we
    // need to figure out where it should appear in the sortOrder.
    for (var i = 0; i < elementNames.length; i++) {
      if (!originalElements[elementNames[i]]) {
        // This element is not in the sortOrder, which means it is a prefixed
        // value that was added by prefixAll. Let's try to figure out where it
        // goes.
        var originalStyle = void 0;

        if (elementNames[i][0] === 'W') {
          // This is a Webkit-prefixed style, like "WebkitTransition". Let's
          // find its original style's sort order.
          originalStyle = elementNames[i][6].toLowerCase() + elementNames[i].slice(7);
        } else if (elementNames[i][1] === 'o') {
          // This is a Moz-prefixed style, like "MozTransition". We check
          // the second character to avoid colliding with Ms-prefixed
          // styles. Let's find its original style's sort order.
          originalStyle = elementNames[i][3].toLowerCase() + elementNames[i].slice(4);
        } else {
          // if (elementNames[i][1] === 's') {
          // This is a Ms-prefixed style, like "MsTransition".
          originalStyle = elementNames[i][2].toLowerCase() + elementNames[i].slice(3);
        }

        if (originalStyle && originalElements[originalStyle]) {
          var originalIndex = declarations.keyOrder.indexOf(originalStyle);
          declarations.keyOrder.splice(originalIndex, 0, elementNames[i]);
        } else {
          // We don't know what the original style was, so sort it to
          // top. This can happen for styles that are added that don't
          // have the same base name as the original style.
          declarations.keyOrder.unshift(elementNames[i]);
        }
      }
    }
  }

  var transformValue = useImportant === false ? stringifyValue : stringifyAndImportantifyValue;
  var rules = [];

  for (var _i = 0; _i < declarations.keyOrder.length; _i++) {
    var key = declarations.keyOrder[_i];
    var value = prefixedElements[key];

    if (Array.isArray(value)) {
      // inline-style-prefixer returns an array when there should be
      // multiple rules for the same key. Here we flatten to multiple
      // pairs with the same key.
      for (var j = 0; j < value.length; j++) {
        rules.push(transformRule(key, value[j], transformValue));
      }
    } else {
      rules.push(transformRule(key, value, transformValue));
    }
  }

  if (rules.length) {
    return "".concat(selector, "{").concat(rules.join(""), "}");
  } else {
    return "";
  }
};

/* ::
import type { SheetDefinition, SheetDefinitions } from './index.js';
import type { MaybeSheetDefinition } from './exports.js';
import type { SelectorHandler } from './generate.js';
*/
// The current <style> tag we are inserting into, or null if we haven't
// inserted anything yet. We could find this each time using
// `document.querySelector("style[data-aphrodite"])`, but holding onto it is
// faster.

var styleTag
/* : ?HTMLStyleElement */
= null; // Inject a set of rules into a <style> tag in the head of the document. This
// will automatically create a style tag and then continue to use it for
// multiple injections. It will also use a style tag with the `data-aphrodite`
// tag on it if that exists in the DOM. This could be used for e.g. reusing the
// same style tag that server-side rendering inserts.

var injectStyleTag = function injectStyleTag(cssRules
/* : string[] */
) {
  if (styleTag == null) {
    // Try to find a style tag with the `data-aphrodite` attribute first.
    styleTag = document.querySelector("style[data-aphrodite]")
    /* : any */
    ; // If that doesn't work, generate a new style tag.

    if (styleTag == null) {
      // Taken from
      // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
      var head = document.head || document.getElementsByTagName('head')[0];
      styleTag = document.createElement('style');
      styleTag.type = 'text/css';
      styleTag.setAttribute("data-aphrodite", "");
      head.appendChild(styleTag);
    }
  } // $FlowFixMe


  var sheet = styleTag.styleSheet || styleTag.sheet
  /* : any */
  ;

  if (sheet.insertRule) {
    var numRules = sheet.cssRules.length;
    cssRules.forEach(function (rule) {
      try {
        sheet.insertRule(rule, numRules);
        numRules += 1;
      } catch (e) {// The selector for this rule wasn't compatible with the browser
      }
    });
  } else {
    styleTag.innerText = (styleTag.innerText || '') + cssRules.join('');
  }
}; // Custom handlers for stringifying CSS values that have side effects
// (such as fontFamily, which can cause @font-face rules to be injected)


var stringHandlers = {
  // With fontFamily we look for objects that are passed in and interpret
  // them as @font-face rules that we need to inject. The value of fontFamily
  // can either be a string (as normal), an object (a single font face), or
  // an array of objects and strings.
  fontFamily: function fontFamily(val) {
    if (Array.isArray(val)) {
      var nameMap = {};
      val.forEach(function (v) {
        nameMap[fontFamily(v)] = true;
      });
      return Object.keys(nameMap).join(",");
    } else if (_typeof(val) === "object") {
      injectStyleOnce(val.src, "@font-face", [val], false);
      return "\"".concat(val.fontFamily, "\"");
    } else {
      return val;
    }
  },
  // With animationName we look for an object that contains keyframes and
  // inject them as an `@keyframes` block, returning a uniquely generated
  // name. The keyframes object should look like
  //  animationName: {
  //    from: {
  //      left: 0,
  //      top: 0,
  //    },
  //    '50%': {
  //      left: 15,
  //      top: 5,
  //    },
  //    to: {
  //      left: 20,
  //      top: 20,
  //    }
  //  }
  // TODO(emily): `stringHandlers` doesn't let us rename the key, so I have
  // to use `animationName` here. Improve that so we can call this
  // `animation` instead of `animationName`.
  animationName: function animationName(val, selectorHandlers) {
    if (Array.isArray(val)) {
      return val.map(function (v) {
        return animationName(v, selectorHandlers);
      }).join(",");
    } else if (_typeof(val) === "object") {
      // Generate a unique name based on the hash of the object. We can't
      // just use the hash because the name can't start with a number.
      // TODO(emily): this probably makes debugging hard, allow a custom
      // name?
      var name = "keyframe_".concat(hashObject(val)); // Since keyframes need 3 layers of nesting, we use `generateCSS` to
      // build the inner layers and wrap it in `@keyframes` ourselves.

      var finalVal = "@keyframes ".concat(name, "{"); // TODO see if we can find a way where checking for OrderedElements
      // here is not necessary. Alternatively, perhaps we should have a
      // utility method that can iterate over either a plain object, an
      // instance of OrderedElements, or a Map, and then use that here and
      // elsewhere.

      if (val instanceof OrderedElements) {
        val.forEach(function (valVal, valKey) {
          finalVal += generateCSS(valKey, [valVal], selectorHandlers, stringHandlers, false).join('');
        });
      } else {
        Object.keys(val).forEach(function (key) {
          finalVal += generateCSS(key, [val[key]], selectorHandlers, stringHandlers, false).join('');
        });
      }

      finalVal += '}';
      injectGeneratedCSSOnce(name, [finalVal]);
      return name;
    } else {
      return val;
    }
  }
}; // This is a map from Aphrodite's generated class names to `true` (acting as a
// set of class names)

var alreadyInjected = {}; // This is the buffer of styles which have not yet been flushed.

var injectionBuffer
/* : string[] */
= []; // A flag to tell if we are already buffering styles. This could happen either
// because we scheduled a flush call already, so newly added styles will
// already be flushed, or because we are statically buffering on the server.

var isBuffering = false;

var injectGeneratedCSSOnce = function injectGeneratedCSSOnce(key, generatedCSS) {
  var _injectionBuffer;

  if (alreadyInjected[key]) {
    return;
  }

  if (!isBuffering) {
    // We should never be automatically buffering on the server (or any
    // place without a document), so guard against that.
    if (typeof document === "undefined") {
      throw new Error("Cannot automatically buffer without a document");
    } // If we're not already buffering, schedule a call to flush the
    // current styles.


    isBuffering = true;
    browser_asap_default()(flushToStyleTag);
  }

  (_injectionBuffer = injectionBuffer).push.apply(_injectionBuffer, _toConsumableArray(generatedCSS));

  alreadyInjected[key] = true;
};

var injectStyleOnce = function injectStyleOnce(key
/* : string */
, selector
/* : string */
, definitions
/* : SheetDefinition[] */
, useImportant
/* : boolean */
) {
  var selectorHandlers
  /* : SelectorHandler[] */
  = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  if (alreadyInjected[key]) {
    return;
  }

  var generated = generateCSS(selector, definitions, selectorHandlers, stringHandlers, useImportant);
  injectGeneratedCSSOnce(key, generated);
};
var chunk_febce46b_reset = function reset() {
  injectionBuffer = [];
  alreadyInjected = {};
  isBuffering = false;
  styleTag = null;
};
var resetInjectedStyle = function resetInjectedStyle(key
/* : string */
) {
  delete alreadyInjected[key];
};
var getBufferedStyles = function getBufferedStyles() {
  return injectionBuffer;
};
var startBuffering = function startBuffering() {
  if (isBuffering) {
    throw new Error("Cannot buffer while already buffering");
  }

  isBuffering = true;
};

var flushToArray = function flushToArray() {
  isBuffering = false;
  var ret = injectionBuffer;
  injectionBuffer = [];
  return ret;
};

var flushToString = function flushToString() {
  return flushToArray().join('');
};
var flushToStyleTag = function flushToStyleTag() {
  var cssRules = flushToArray();

  if (cssRules.length > 0) {
    injectStyleTag(cssRules);
  }
};
var getRenderedClassNames = function getRenderedClassNames()
/* : string[] */
{
  return Object.keys(alreadyInjected);
};
var addRenderedClassNames = function addRenderedClassNames(classNames
/* : string[] */
) {
  classNames.forEach(function (className) {
    alreadyInjected[className] = true;
  });
};

var isValidStyleDefinition = function isValidStyleDefinition(def
/* : Object */
) {
  return "_definition" in def && "_name" in def && "_len" in def;
};

var processStyleDefinitions = function processStyleDefinitions(styleDefinitions
/* : any[] */
, classNameBits
/* : string[] */
, definitionBits
/* : Object[] */
, length
/* : number */
)
/* : number */
{
  for (var i = 0; i < styleDefinitions.length; i += 1) {
    // Filter out falsy values from the input, to allow for
    // `css(a, test && c)`
    if (styleDefinitions[i]) {
      if (Array.isArray(styleDefinitions[i])) {
        // We've encountered an array, so let's recurse
        length += processStyleDefinitions(styleDefinitions[i], classNameBits, definitionBits, length);
      } else if (isValidStyleDefinition(styleDefinitions[i])) {
        classNameBits.push(styleDefinitions[i]._name);
        definitionBits.push(styleDefinitions[i]._definition);
        length += styleDefinitions[i]._len;
      } else {
        throw new Error("Invalid Style Definition: Styles should be defined using the StyleSheet.create method.");
      }
    }
  }

  return length;
};
/**
 * Inject styles associated with the passed style definition objects, and return
 * an associated CSS class name.
 *
 * @param {boolean} useImportant If true, will append !important to generated
 *     CSS output. e.g. {color: red} -> "color: red !important".
 * @param {(Object|Object[])[]} styleDefinitions style definition objects, or
 *     arbitrarily nested arrays of them, as returned as properties of the
 *     return value of StyleSheet.create().
 */


var injectAndGetClassName = function injectAndGetClassName(useImportant
/* : boolean */
, styleDefinitions
/* : MaybeSheetDefinition[] */
, selectorHandlers
/* : SelectorHandler[] */
)
/* : string */
{
  var classNameBits = [];
  var definitionBits = []; // Mutates classNameBits and definitionBits and returns a length which we
  // will append to the hash to decrease the chance of hash collisions.

  var length = processStyleDefinitions(styleDefinitions, classNameBits, definitionBits, 0); // Break if there aren't any valid styles.

  if (classNameBits.length === 0) {
    return "";
  }

  var className;

  if (true) {
    className = classNameBits.length === 1 ? "_".concat(classNameBits[0]) : "_".concat(hashString(classNameBits.join())).concat((length % 36).toString(36));
  } else {}

  injectStyleOnce(className, ".".concat(className), definitionBits, useImportant, selectorHandlers);
  return className;
};

/* ::
import type { SelectorHandler } from './generate.js';
export type SheetDefinition = { [id:string]: any };
export type SheetDefinitions = SheetDefinition | SheetDefinition[];
type RenderFunction = () => string;
type Extension = {
    selectorHandler: SelectorHandler
};
export type MaybeSheetDefinition = SheetDefinition | false | null | void
*/

var unminifiedHashFn = function unminifiedHashFn(str
/* : string */
, key
/* : string */
) {
  return "".concat(key, "_").concat(hashString(str));
}; // StyleSheet.create is in a hot path so we want to keep as much logic out of it
// as possible. So, we figure out which hash function to use once, and only
// switch it out via minify() as necessary.
//
// This is in an exported function to make it easier to test.


var initialHashFn = function initialHashFn() {
  return  true ? hashString : 0;
};
var hashFn = initialHashFn();
var StyleSheet = {
  create: function create(sheetDefinition
  /* : SheetDefinition */
  )
  /* : Object */
  {
    var mappedSheetDefinition = {};
    var keys = Object.keys(sheetDefinition);

    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var val = sheetDefinition[key];
      var stringVal = JSON.stringify(val);
      mappedSheetDefinition[key] = {
        _len: stringVal.length,
        _name: hashFn(stringVal, key),
        _definition: val
      };
    }

    return mappedSheetDefinition;
  },
  rehydrate: function rehydrate() {
    var renderedClassNames
    /* : string[] */
    = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    addRenderedClassNames(renderedClassNames);
  }
};
/**
 * Utilities for using Aphrodite server-side.
 *
 * This can be minified out in client-only bundles by replacing `typeof window`
 * with `"object"`, e.g. via Webpack's DefinePlugin:
 *
 *   new webpack.DefinePlugin({
 *     "typeof window": JSON.stringify("object")
 *   })
 */

var StyleSheetServer = typeof window !== 'undefined' ? null : {
  renderStatic: function renderStatic(renderFunc
  /* : RenderFunction */
  ) {
    chunk_febce46b_reset();
    startBuffering();
    var html = renderFunc();
    var cssContent = flushToString();
    return {
      html: html,
      css: {
        content: cssContent,
        renderedClassNames: getRenderedClassNames()
      }
    };
  }
};
/**
 * Utilities for using Aphrodite in tests.
 *
 * Not meant to be used in production.
 */

var StyleSheetTestUtils =  true ? null : 0;
/**
 * Generate the Aphrodite API exports, with given `selectorHandlers` and
 * `useImportant` state.
 */

function makeExports(useImportant
/* : boolean */
) {
  var selectorHandlers
  /* : SelectorHandler[] */
  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSelectorHandlers;
  return {
    StyleSheet: _objectSpread({}, StyleSheet, {
      /**
       * Returns a version of the exports of Aphrodite (i.e. an object
       * with `css` and `StyleSheet` properties) which have some
       * extensions included.
       *
       * @param {Array.<Object>} extensions: An array of extensions to
       *     add to this instance of Aphrodite. Each object should have a
       *     single property on it, defining which kind of extension to
       *     add.
       * @param {SelectorHandler} [extensions[].selectorHandler]: A
       *     selector handler extension. See `defaultSelectorHandlers` in
       *     generate.js.
       *
       * @returns {Object} An object containing the exports of the new
       *     instance of Aphrodite.
       */
      extend: function extend(extensions
      /* : Extension[] */
      ) {
        var extensionSelectorHandlers = extensions // Pull out extensions with a selectorHandler property
        .map(function (extension) {
          return extension.selectorHandler;
        }) // Remove nulls (i.e. extensions without a selectorHandler property).
        .filter(function (handler) {
          return handler;
        });
        return makeExports(useImportant, selectorHandlers.concat(extensionSelectorHandlers));
      }
    }),
    StyleSheetServer: StyleSheetServer,
    StyleSheetTestUtils: StyleSheetTestUtils,
    minify: function minify(shouldMinify
    /* : boolean */
    ) {
      hashFn = shouldMinify ? hashString : unminifiedHashFn;
    },
    css: function css()
    /* : MaybeSheetDefinition[] */
    {
      for (var _len = arguments.length, styleDefinitions = new Array(_len), _key = 0; _key < _len; _key++) {
        styleDefinitions[_key] = arguments[_key];
      }

      return injectAndGetClassName(useImportant, styleDefinitions, selectorHandlers);
    },
    flushToStyleTag: flushToStyleTag,
    injectAndGetClassName: injectAndGetClassName,
    defaultSelectorHandlers: defaultSelectorHandlers,
    reset: chunk_febce46b_reset,
    resetInjectedStyle: resetInjectedStyle
  };
}



;// CONCATENATED MODULE: ../../node_modules/aphrodite/es/index.js




var useImportant = true; // Add !important to all style definitions

var Aphrodite = makeExports(useImportant);
var es_StyleSheet = Aphrodite.StyleSheet,
    es_StyleSheetServer = Aphrodite.StyleSheetServer,
    es_StyleSheetTestUtils = Aphrodite.StyleSheetTestUtils,
    css = Aphrodite.css,
    minify = Aphrodite.minify,
    es_flushToStyleTag = Aphrodite.flushToStyleTag,
    es_injectAndGetClassName = Aphrodite.injectAndGetClassName,
    es_defaultSelectorHandlers = Aphrodite.defaultSelectorHandlers,
    es_reset = Aphrodite.reset,
    es_resetInjectedStyle = Aphrodite.resetInjectedStyle;




/***/ }),

/***/ 3579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var stringHash = _interopDefault(__webpack_require__(9839));
var asap = _interopDefault(__webpack_require__(60629));

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/* @flow */
/* ::
type ObjectMap = { [id:string]: any };
*/

var UPPERCASE_RE = /([A-Z])/g;

var UPPERCASE_RE_TO_KEBAB = function UPPERCASE_RE_TO_KEBAB(match
/* : string */
) {
  return (
    /* : string */
    "-".concat(match.toLowerCase())
  );
};

var kebabifyStyleName = function kebabifyStyleName(string
/* : string */
)
/* : string */
{
  var result = string.replace(UPPERCASE_RE, UPPERCASE_RE_TO_KEBAB);

  if (result[0] === 'm' && result[1] === 's' && result[2] === '-') {
    return "-".concat(result);
  }

  return result;
};
/**
 * CSS properties which accept numbers but are not in units of "px".
 * Taken from React's CSSProperty.js
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
/**
 * Taken from React's CSSProperty.js
 *
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */

function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 * Taken from React's CSSProperty.js
 */


var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
// Taken from React's CSSProperty.js

Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});
var stringifyValue = function stringifyValue(key
/* : string */
, prop
/* : any */
)
/* : string */
{
  if (typeof prop === "number") {
    if (isUnitlessNumber[key]) {
      return "" + prop;
    } else {
      return prop + "px";
    }
  } else {
    return '' + prop;
  }
};
var stringifyAndImportantifyValue = function stringifyAndImportantifyValue(key
/* : string */
, prop
/* : any */
) {
  return (
    /* : string */
    importantify(stringifyValue(key, prop))
  );
}; // Turn a string into a hash string of base-36 values (using letters and numbers)
// eslint-disable-next-line no-unused-vars

var hashString = function hashString(string
/* : string */
, key
/* : ?string */
) {
  return (
    /* string */
    stringHash(string).toString(36)
  );
}; // Hash a javascript object using JSON.stringify. This is very fast, about 3
// microseconds on my computer for a sample object:
// http://jsperf.com/test-hashfnv32a-hash/5
//
// Note that this uses JSON.stringify to stringify the objects so in order for
// this to produce consistent hashes browsers need to have a consistent
// ordering of objects. Ben Alpert says that Facebook depends on this, so we
// can probably depend on this too.

var hashObject = function hashObject(object
/* : ObjectMap */
) {
  return (
    /* : string */
    hashString(JSON.stringify(object))
  );
}; // Given a single style value string like the "b" from "a: b;", adds !important
// to generate "b !important".

var importantify = function importantify(string
/* : string */
) {
  return (
    /* : string */
    // Bracket string character access is very fast, and in the default case we
    // normally don't expect there to be "!important" at the end of the string
    // so we can use this simple check to take an optimized path. If there
    // happens to be a "!" in this position, we follow up with a more thorough
    // check.
    string[string.length - 10] === '!' && string.slice(-11) === ' !important' ? string : "".concat(string, " !important")
  );
};

/* @flow */
var MAP_EXISTS = typeof Map !== 'undefined';

var OrderedElements =
/*#__PURE__*/
function () {
  /* ::
  elements: {[string]: any};
  keyOrder: string[];
  */
  function OrderedElements() {
    this.elements = {};
    this.keyOrder = [];
  }

  var _proto = OrderedElements.prototype;

  _proto.forEach = function forEach(callback
  /* : (string, any) => void */
  ) {
    for (var i = 0; i < this.keyOrder.length; i++) {
      // (value, key) to match Map's API
      callback(this.elements[this.keyOrder[i]], this.keyOrder[i]);
    }
  };

  _proto.set = function set(key
  /* : string */
  , value
  /* : any */
  , shouldReorder
  /* : ?boolean */
  ) {
    if (!this.elements.hasOwnProperty(key)) {
      this.keyOrder.push(key);
    } else if (shouldReorder) {
      var index = this.keyOrder.indexOf(key);
      this.keyOrder.splice(index, 1);
      this.keyOrder.push(key);
    }

    if (value == null) {
      this.elements[key] = value;
      return;
    }

    if (MAP_EXISTS && value instanceof Map || value instanceof OrderedElements) {
      // We have found a nested Map, so we need to recurse so that all
      // of the nested objects and Maps are merged properly.
      var nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();
      value.forEach(function (value, key) {
        nested.set(key, value, shouldReorder);
      });
      this.elements[key] = nested;
      return;
    }

    if (!Array.isArray(value) && _typeof(value) === 'object') {
      // We have found a nested object, so we need to recurse so that all
      // of the nested objects and Maps are merged properly.
      var _nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();

      var keys = Object.keys(value);

      for (var i = 0; i < keys.length; i += 1) {
        _nested.set(keys[i], value[keys[i]], shouldReorder);
      }

      this.elements[key] = _nested;
      return;
    }

    this.elements[key] = value;
  };

  _proto.get = function get(key
  /* : string */
  )
  /* : any */
  {
    return this.elements[key];
  };

  _proto.has = function has(key
  /* : string */
  )
  /* : boolean */
  {
    return this.elements.hasOwnProperty(key);
  };

  _proto.addStyleType = function addStyleType(styleType
  /* : any */
  )
  /* : void */
  {
    var _this = this;

    if (MAP_EXISTS && styleType instanceof Map || styleType instanceof OrderedElements) {
      styleType.forEach(function (value, key) {
        _this.set(key, value, true);
      });
    } else {
      var keys = Object.keys(styleType);

      for (var i = 0; i < keys.length; i++) {
        this.set(keys[i], styleType[keys[i]], true);
      }
    }
  };

  return OrderedElements;
}();

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n.default || n;
}

var capitalizeString_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
});

unwrapExports(capitalizeString_1);

var prefixProperty_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;



var _capitalizeString2 = _interopRequireDefault(capitalizeString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var newStyle = {};
    var requiredPrefixes = prefixProperties[property];
    var capitalizedProperty = (0, _capitalizeString2.default)(property);
    var keys = Object.keys(style);
    for (var i = 0; i < keys.length; i++) {
      var styleProperty = keys[i];
      if (styleProperty === property) {
        for (var j = 0; j < requiredPrefixes.length; j++) {
          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
        }
      }
      newStyle[styleProperty] = style[styleProperty];
    }
    return newStyle;
  }
  return style;
}
});

unwrapExports(prefixProperty_1);

var prefixValue_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
});

unwrapExports(prefixValue_1);

var addNewValuesOnly_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
});

unwrapExports(addNewValuesOnly_1);

var isObject_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
});

unwrapExports(isObject_1);

var createPrefixer_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;



var _prefixProperty2 = _interopRequireDefault(prefixProperty_1);



var _prefixValue2 = _interopRequireDefault(prefixValue_1);



var _addNewValuesOnly2 = _interopRequireDefault(addNewValuesOnly_1);



var _isObject2 = _interopRequireDefault(isObject_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  return function prefix(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefix(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        style = (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  };
}
});

var createPrefixer = unwrapExports(createPrefixer_1);

var backgroundClip_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = backgroundClip;

// https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip#Browser_compatibility
function backgroundClip(property, value) {
  if (typeof value === 'string' && value === 'text') {
    return ['-webkit-text', 'text'];
  }
}
});

var backgroundClip = unwrapExports(backgroundClip_1);

var isPrefixedValue_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];
});

unwrapExports(isPrefixedValue_1);

var calc_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];
function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
});

var calc = unwrapExports(calc_1);

var crossFade_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
});

var crossFade = unwrapExports(crossFade_1);

var cursor_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
});

var cursor = unwrapExports(cursor_1);

var filter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
});

var filter = unwrapExports(filter_1);

var flex_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
});

var flex = unwrapExports(flex_1);

var flexboxIE_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
  // Full expanded syntax is flex-grow | flex-shrink | flex-basis.
};var flexShorthandMappings = {
  auto: '1 1 auto',
  inherit: 'inherit',
  initial: '0 1 auto',
  none: '0 0 auto',
  unset: 'unset'
};
var isUnitlessNumber = /^\d+(\.\d+)?$/;

function flexboxIE(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
  if (property === 'flex') {
    // For certain values we can do straight mappings based on the spec
    // for the expansions.
    if (Object.prototype.hasOwnProperty.call(flexShorthandMappings, value)) {
      style.msFlex = flexShorthandMappings[value];
      return;
    }
    // Here we have no direct mapping, so we favor looking for a
    // unitless positive number as that will be the most common use-case.
    if (isUnitlessNumber.test(value)) {
      style.msFlex = value + ' 1 0%';
      return;
    }

    // The next thing we can look for is if there are multiple values.
    var flexValues = value.split(/\s/);
    // If we only have a single value that wasn't a positive unitless
    // or a pre-mapped value, then we can assume it is a unit value.
    switch (flexValues.length) {
      case 1:
        style.msFlex = '1 1 ' + value;
        return;
      case 2:
        // If we have 2 units, then we expect that the first will
        // always be a unitless number and represents flex-grow.
        // The second unit will represent flex-shrink for a unitless
        // value, or flex-basis otherwise.
        if (isUnitlessNumber.test(flexValues[1])) {
          style.msFlex = flexValues[0] + ' ' + flexValues[1] + ' 0%';
        } else {
          style.msFlex = flexValues[0] + ' 1 ' + flexValues[1];
        }
        return;
      default:
        style.msFlex = value;
    }
  }
}
});

var flexboxIE = unwrapExports(flexboxIE_1);

var flexboxOld_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines',
  flexGrow: 'WebkitBoxFlex'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
});

var flexboxOld = unwrapExports(flexboxOld_1);

var gradient_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return value.replace(values, function (grad) {
        return prefix + grad;
      });
    });
  }
}
});

var gradient = unwrapExports(gradient_1);

var grid_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = grid;
function isSimplePositionValue(value) {
  return typeof value === 'number' && !isNaN(value);
}

var alignmentValues = ['center', 'end', 'start', 'stretch'];

var displayValues = {
  'inline-grid': ['-ms-inline-grid', 'inline-grid'],
  grid: ['-ms-grid', 'grid']
};

var propertyConverters = {
  alignSelf: function alignSelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridRowAlign = value;
    }
  },

  gridColumn: function gridColumn(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    } else {
      var _value$split$map = value.split('/').map(function (position) {
        return +position;
      }),
          _value$split$map2 = _slicedToArray(_value$split$map, 2),
          start = _value$split$map2[0],
          end = _value$split$map2[1];

      propertyConverters.gridColumnStart(start, style);
      propertyConverters.gridColumnEnd(end, style);
    }
  },

  gridColumnEnd: function gridColumnEnd(value, style) {
    var msGridColumn = style.msGridColumn;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridColumn)) {
      style.msGridColumnSpan = value - msGridColumn;
    }
  },

  gridColumnStart: function gridColumnStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    }
  },

  gridRow: function gridRow(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    } else {
      var _value$split$map3 = value.split('/').map(function (position) {
        return +position;
      }),
          _value$split$map4 = _slicedToArray(_value$split$map3, 2),
          start = _value$split$map4[0],
          end = _value$split$map4[1];

      propertyConverters.gridRowStart(start, style);
      propertyConverters.gridRowEnd(end, style);
    }
  },

  gridRowEnd: function gridRowEnd(value, style) {
    var msGridRow = style.msGridRow;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridRow)) {
      style.msGridRowSpan = value - msGridRow;
    }
  },

  gridRowStart: function gridRowStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    }
  },

  gridTemplateColumns: function gridTemplateColumns(value, style) {
    style.msGridColumns = value;
  },

  gridTemplateRows: function gridTemplateRows(value, style) {
    style.msGridRows = value;
  },

  justifySelf: function justifySelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridColumnAlign = value;
    }
  }
};

function grid(property, value, style) {
  if (property === 'display' && value in displayValues) {
    return displayValues[value];
  }

  if (property in propertyConverters) {
    var propertyConverter = propertyConverters[property];
    propertyConverter(value, style);
  }
}
});

var grid = unwrapExports(grid_1);

var imageSet_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
});

var imageSet = unwrapExports(imageSet_1);

var logical_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = logical;
var alternativeProps = {
  marginBlockStart: ['WebkitMarginBefore'],
  marginBlockEnd: ['WebkitMarginAfter'],
  marginInlineStart: ['WebkitMarginStart', 'MozMarginStart'],
  marginInlineEnd: ['WebkitMarginEnd', 'MozMarginEnd'],
  paddingBlockStart: ['WebkitPaddingBefore'],
  paddingBlockEnd: ['WebkitPaddingAfter'],
  paddingInlineStart: ['WebkitPaddingStart', 'MozPaddingStart'],
  paddingInlineEnd: ['WebkitPaddingEnd', 'MozPaddingEnd'],
  borderBlockStart: ['WebkitBorderBefore'],
  borderBlockStartColor: ['WebkitBorderBeforeColor'],
  borderBlockStartStyle: ['WebkitBorderBeforeStyle'],
  borderBlockStartWidth: ['WebkitBorderBeforeWidth'],
  borderBlockEnd: ['WebkitBorderAfter'],
  borderBlockEndColor: ['WebkitBorderAfterColor'],
  borderBlockEndStyle: ['WebkitBorderAfterStyle'],
  borderBlockEndWidth: ['WebkitBorderAfterWidth'],
  borderInlineStart: ['WebkitBorderStart', 'MozBorderStart'],
  borderInlineStartColor: ['WebkitBorderStartColor', 'MozBorderStartColor'],
  borderInlineStartStyle: ['WebkitBorderStartStyle', 'MozBorderStartStyle'],
  borderInlineStartWidth: ['WebkitBorderStartWidth', 'MozBorderStartWidth'],
  borderInlineEnd: ['WebkitBorderEnd', 'MozBorderEnd'],
  borderInlineEndColor: ['WebkitBorderEndColor', 'MozBorderEndColor'],
  borderInlineEndStyle: ['WebkitBorderEndStyle', 'MozBorderEndStyle'],
  borderInlineEndWidth: ['WebkitBorderEndWidth', 'MozBorderEndWidth']
};

function logical(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
    var alternativePropList = alternativeProps[property];
    for (var i = 0, len = alternativePropList.length; i < len; ++i) {
      style[alternativePropList[i]] = value;
    }
  }
}
});

var logical = unwrapExports(logical_1);

var position_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
});

var position = unwrapExports(position_1);

var sizing_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
});

var sizing = unwrapExports(sizing_1);

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

var hyphenateStyleName$1 = /*#__PURE__*/Object.freeze({
  default: hyphenateStyleName
});

var _hyphenateStyleName = getCjsExportFromNamespace(hyphenateStyleName$1);

var hyphenateProperty_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;



var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];
});

unwrapExports(hyphenateProperty_1);

var transition_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;



var _hyphenateProperty2 = _interopRequireDefault(hyphenateProperty_1);



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);



var _capitalizeString2 = _interopRequireDefault(capitalizeString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
});

var transition = unwrapExports(transition_1);

var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];
var staticData = {
  plugins: [backgroundClip, calc, crossFade, cursor, filter, flex, flexboxIE, flexboxOld, gradient, grid, imageSet, logical, position, sizing, transition],
  prefixMap: {
    "transform": wms,
    "transformOrigin": wms,
    "transformOriginX": wms,
    "transformOriginY": wms,
    "backfaceVisibility": w,
    "perspective": w,
    "perspectiveOrigin": w,
    "transformStyle": w,
    "transformOriginZ": w,
    "animation": w,
    "animationDelay": w,
    "animationDirection": w,
    "animationFillMode": w,
    "animationDuration": w,
    "animationIterationCount": w,
    "animationName": w,
    "animationPlayState": w,
    "animationTimingFunction": w,
    "appearance": wm,
    "userSelect": wmms,
    "fontKerning": w,
    "textEmphasisPosition": w,
    "textEmphasis": w,
    "textEmphasisStyle": w,
    "textEmphasisColor": w,
    "boxDecorationBreak": w,
    "clipPath": w,
    "maskImage": w,
    "maskMode": w,
    "maskRepeat": w,
    "maskPosition": w,
    "maskClip": w,
    "maskOrigin": w,
    "maskSize": w,
    "maskComposite": w,
    "mask": w,
    "maskBorderSource": w,
    "maskBorderMode": w,
    "maskBorderSlice": w,
    "maskBorderWidth": w,
    "maskBorderOutset": w,
    "maskBorderRepeat": w,
    "maskBorder": w,
    "maskType": w,
    "textDecorationStyle": wm,
    "textDecorationSkip": wm,
    "textDecorationLine": wm,
    "textDecorationColor": wm,
    "filter": w,
    "fontFeatureSettings": wm,
    "breakAfter": wmms,
    "breakBefore": wmms,
    "breakInside": wmms,
    "columnCount": wm,
    "columnFill": wm,
    "columnGap": wm,
    "columnRule": wm,
    "columnRuleColor": wm,
    "columnRuleStyle": wm,
    "columnRuleWidth": wm,
    "columns": wm,
    "columnSpan": wm,
    "columnWidth": wm,
    "writingMode": wms,
    "flex": wms,
    "flexBasis": w,
    "flexDirection": wms,
    "flexGrow": w,
    "flexFlow": wms,
    "flexShrink": w,
    "flexWrap": wms,
    "alignContent": w,
    "alignItems": w,
    "alignSelf": w,
    "justifyContent": w,
    "order": w,
    "transitionDelay": w,
    "transitionDuration": w,
    "transitionProperty": w,
    "transitionTimingFunction": w,
    "backdropFilter": w,
    "scrollSnapType": wms,
    "scrollSnapPointsX": wms,
    "scrollSnapPointsY": wms,
    "scrollSnapDestination": wms,
    "scrollSnapCoordinate": wms,
    "shapeImageThreshold": w,
    "shapeImageMargin": w,
    "shapeImageOutside": w,
    "hyphens": wmms,
    "flowInto": wms,
    "flowFrom": wms,
    "regionFragment": wms,
    "textOrientation": w,
    "boxSizing": m,
    "textAlignLast": m,
    "tabSize": m,
    "wrapFlow": ms,
    "wrapThrough": ms,
    "wrapMargin": ms,
    "touchAction": ms,
    "textSizeAdjust": wms,
    "borderImage": w,
    "borderImageOutset": w,
    "borderImageRepeat": w,
    "borderImageSlice": w,
    "borderImageSource": w,
    "borderImageWidth": w
  }
};

var prefixAll = createPrefixer(staticData);
/* ::
import type { SheetDefinition } from './index.js';
type StringHandlers = { [id:string]: Function };
type SelectorCallback = (selector: string) => string[];
export type SelectorHandler = (
    selector: string,
    baseSelector: string,
    callback: SelectorCallback
) => string[] | string | null;
*/

/**
 * `selectorHandlers` are functions which handle special selectors which act
 * differently than normal style definitions. These functions look at the
 * current selector and can generate CSS for the styles in their subtree by
 * calling the callback with a new selector.
 *
 * For example, when generating styles with a base selector of '.foo' and the
 * following styles object:
 *
 *   {
 *     ':nth-child(2n)': {
 *       ':hover': {
 *         color: 'red'
 *       }
 *     }
 *   }
 *
 * when we reach the ':hover' style, we would call our selector handlers like
 *
 *   handler(':hover', '.foo:nth-child(2n)', callback)
 *
 * Since our `pseudoSelectors` handles ':hover' styles, that handler would call
 * the callback like
 *
 *   callback('.foo:nth-child(2n):hover')
 *
 * to generate its subtree `{ color: 'red' }` styles with a
 * '.foo:nth-child(2n):hover' selector. The callback would return an array of CSS
 * rules like
 *
 *   ['.foo:nth-child(2n):hover{color:red !important;}']
 *
 * and the handler would then return that resulting CSS.
 *
 * `defaultSelectorHandlers` is the list of default handlers used in a call to
 * `generateCSS`.
 *
 * @name SelectorHandler
 * @function
 * @param {string} selector: The currently inspected selector. ':hover' in the
 *     example above.
 * @param {string} baseSelector: The selector of the parent styles.
 *     '.foo:nth-child(2n)' in the example above.
 * @param {function} generateSubtreeStyles: A function which can be called to
 *     generate CSS for the subtree of styles corresponding to the selector.
 *     Accepts a new baseSelector to use for generating those styles.
 * @returns {string[] | string | null} The generated CSS for this selector, or
 *     null if we don't handle this selector.
 */

var defaultSelectorHandlers
/* : SelectorHandler[] */
= [// Handle pseudo-selectors, like :hover and :nth-child(3n)
function pseudoSelectors(selector, baseSelector, generateSubtreeStyles) {
  if (selector[0] !== ":") {
    return null;
  }

  return generateSubtreeStyles(baseSelector + selector);
}, // Handle media queries (or font-faces)
function mediaQueries(selector, baseSelector, generateSubtreeStyles) {
  if (selector[0] !== "@") {
    return null;
  } // Generate the styles normally, and then wrap them in the media query.


  var generated = generateSubtreeStyles(baseSelector);
  return ["".concat(selector, "{").concat(generated.join(''), "}")];
}];
/**
 * Generate CSS for a selector and some styles.
 *
 * This function handles the media queries and pseudo selectors that can be used
 * in aphrodite styles.
 *
 * @param {string} selector: A base CSS selector for the styles to be generated
 *     with.
 * @param {Object} styleTypes: A list of properties of the return type of
 *     StyleSheet.create, e.g. [styles.red, styles.blue].
 * @param {Array.<SelectorHandler>} selectorHandlers: A list of selector
 *     handlers to use for handling special selectors. See
 *     `defaultSelectorHandlers`.
 * @param stringHandlers: See `generateCSSRuleset`
 * @param useImportant: See `generateCSSRuleset`
 *
 * To actually generate the CSS special-construct-less styles are passed to
 * `generateCSSRuleset`.
 *
 * For instance, a call to
 *
 *     generateCSS(".foo", [{
 *       color: "red",
 *       "@media screen": {
 *         height: 20,
 *         ":hover": {
 *           backgroundColor: "black"
 *         }
 *       },
 *       ":active": {
 *         fontWeight: "bold"
 *       }
 *     }], defaultSelectorHandlers);
 *
 * with the default `selectorHandlers` will make 5 calls to
 * `generateCSSRuleset`:
 *
 *     generateCSSRuleset(".foo", { color: "red" }, ...)
 *     generateCSSRuleset(".foo:active", { fontWeight: "bold" }, ...)
 *     // These 2 will be wrapped in @media screen {}
 *     generateCSSRuleset(".foo", { height: 20 }, ...)
 *     generateCSSRuleset(".foo:hover", { backgroundColor: "black" }, ...)
 */

var generateCSS = function generateCSS(selector
/* : string */
, styleTypes
/* : SheetDefinition[] */
, selectorHandlers
/* : SelectorHandler[] */
, stringHandlers
/* : StringHandlers */
, useImportant
/* : boolean */
)
/* : string[] */
{
  var merged = new OrderedElements();

  for (var i = 0; i < styleTypes.length; i++) {
    merged.addStyleType(styleTypes[i]);
  }

  var plainDeclarations = new OrderedElements();
  var generatedStyles = []; // TODO(emily): benchmark this to see if a plain for loop would be faster.

  merged.forEach(function (val, key) {
    // For each key, see if one of the selector handlers will handle these
    // styles.
    var foundHandler = selectorHandlers.some(function (handler) {
      var result = handler(key, selector, function (newSelector) {
        return generateCSS(newSelector, [val], selectorHandlers, stringHandlers, useImportant);
      });

      if (result != null) {
        // If the handler returned something, add it to the generated
        // CSS and stop looking for another handler.
        if (Array.isArray(result)) {
          generatedStyles.push.apply(generatedStyles, _toConsumableArray(result));
        } else {
          // eslint-disable-next-line
          console.warn('WARNING: Selector handlers should return an array of rules.' + 'Returning a string containing multiple rules is deprecated.', handler);
          generatedStyles.push("@media all {".concat(result, "}"));
        }

        return true;
      }
    }); // If none of the handlers handled it, add it to the list of plain
    // style declarations.

    if (!foundHandler) {
      plainDeclarations.set(key, val, true);
    }
  });
  var generatedRuleset = generateCSSRuleset(selector, plainDeclarations, stringHandlers, useImportant, selectorHandlers);

  if (generatedRuleset) {
    generatedStyles.unshift(generatedRuleset);
  }

  return generatedStyles;
};
/**
 * Helper method of generateCSSRuleset to facilitate custom handling of certain
 * CSS properties. Used for e.g. font families.
 *
 * See generateCSSRuleset for usage and documentation of paramater types.
 */

var runStringHandlers = function runStringHandlers(declarations
/* : OrderedElements */
, stringHandlers
/* : StringHandlers */
, selectorHandlers
/* : SelectorHandler[] */
)
/* : void */
{
  if (!stringHandlers) {
    return;
  }

  var stringHandlerKeys = Object.keys(stringHandlers);

  for (var i = 0; i < stringHandlerKeys.length; i++) {
    var key = stringHandlerKeys[i];

    if (declarations.has(key)) {
      // A declaration exists for this particular string handler, so we
      // need to let the string handler interpret the declaration first
      // before proceeding.
      //
      // TODO(emily): Pass in a callback which generates CSS, similar to
      // how our selector handlers work, instead of passing in
      // `selectorHandlers` and have them make calls to `generateCSS`
      // themselves. Right now, this is impractical because our string
      // handlers are very specialized and do complex things.
      declarations.set(key, stringHandlers[key](declarations.get(key), selectorHandlers), // Preserve order here, since we are really replacing an
      // unprocessed style with a processed style, not overriding an
      // earlier style
      false);
    }
  }
};

var transformRule = function transformRule(key
/* : string */
, value
/* : string */
, transformValue
/* : function */
) {
  return (
    /* : string */
    "".concat(kebabifyStyleName(key), ":").concat(transformValue(key, value), ";")
  );
};

var arrayToObjectKeysReducer = function arrayToObjectKeysReducer(acc, val) {
  acc[val] = true;
  return acc;
};
/**
 * Generate a CSS ruleset with the selector and containing the declarations.
 *
 * This function assumes that the given declarations don't contain any special
 * children (such as media queries, pseudo-selectors, or descendant styles).
 *
 * Note that this method does not deal with nesting used for e.g.
 * psuedo-selectors or media queries. That responsibility is left to  the
 * `generateCSS` function.
 *
 * @param {string} selector: the selector associated with the ruleset
 * @param {Object} declarations: a map from camelCased CSS property name to CSS
 *     property value.
 * @param {Object.<string, function>} stringHandlers: a map from camelCased CSS
 *     property name to a function which will map the given value to the value
 *     that is output.
 * @param {bool} useImportant: A boolean saying whether to append "!important"
 *     to each of the CSS declarations.
 * @returns {string} A string of raw CSS.
 *
 * Examples:
 *
 *    generateCSSRuleset(".blah", { color: "red" })
 *    -> ".blah{color: red !important;}"
 *    generateCSSRuleset(".blah", { color: "red" }, {}, false)
 *    -> ".blah{color: red}"
 *    generateCSSRuleset(".blah", { color: "red" }, {color: c => c.toUpperCase})
 *    -> ".blah{color: RED}"
 *    generateCSSRuleset(".blah:hover", { color: "red" })
 *    -> ".blah:hover{color: red}"
 */


var generateCSSRuleset = function generateCSSRuleset(selector
/* : string */
, declarations
/* : OrderedElements */
, stringHandlers
/* : StringHandlers */
, useImportant
/* : boolean */
, selectorHandlers
/* : SelectorHandler[] */
)
/* : string */
{
  // Mutates declarations
  runStringHandlers(declarations, stringHandlers, selectorHandlers);
  var originalElements = Object.keys(declarations.elements).reduce(arrayToObjectKeysReducer, Object.create(null)); // NOTE(emily): This mutates handledDeclarations.elements.

  var prefixedElements = prefixAll(declarations.elements);
  var elementNames = Object.keys(prefixedElements);

  if (elementNames.length !== declarations.keyOrder.length) {
    // There are some prefixed values, so we need to figure out how to sort
    // them.
    //
    // Loop through prefixedElements, looking for anything that is not in
    // sortOrder, which means it was added by prefixAll. This means that we
    // need to figure out where it should appear in the sortOrder.
    for (var i = 0; i < elementNames.length; i++) {
      if (!originalElements[elementNames[i]]) {
        // This element is not in the sortOrder, which means it is a prefixed
        // value that was added by prefixAll. Let's try to figure out where it
        // goes.
        var originalStyle = void 0;

        if (elementNames[i][0] === 'W') {
          // This is a Webkit-prefixed style, like "WebkitTransition". Let's
          // find its original style's sort order.
          originalStyle = elementNames[i][6].toLowerCase() + elementNames[i].slice(7);
        } else if (elementNames[i][1] === 'o') {
          // This is a Moz-prefixed style, like "MozTransition". We check
          // the second character to avoid colliding with Ms-prefixed
          // styles. Let's find its original style's sort order.
          originalStyle = elementNames[i][3].toLowerCase() + elementNames[i].slice(4);
        } else {
          // if (elementNames[i][1] === 's') {
          // This is a Ms-prefixed style, like "MsTransition".
          originalStyle = elementNames[i][2].toLowerCase() + elementNames[i].slice(3);
        }

        if (originalStyle && originalElements[originalStyle]) {
          var originalIndex = declarations.keyOrder.indexOf(originalStyle);
          declarations.keyOrder.splice(originalIndex, 0, elementNames[i]);
        } else {
          // We don't know what the original style was, so sort it to
          // top. This can happen for styles that are added that don't
          // have the same base name as the original style.
          declarations.keyOrder.unshift(elementNames[i]);
        }
      }
    }
  }

  var transformValue = useImportant === false ? stringifyValue : stringifyAndImportantifyValue;
  var rules = [];

  for (var _i = 0; _i < declarations.keyOrder.length; _i++) {
    var key = declarations.keyOrder[_i];
    var value = prefixedElements[key];

    if (Array.isArray(value)) {
      // inline-style-prefixer returns an array when there should be
      // multiple rules for the same key. Here we flatten to multiple
      // pairs with the same key.
      for (var j = 0; j < value.length; j++) {
        rules.push(transformRule(key, value[j], transformValue));
      }
    } else {
      rules.push(transformRule(key, value, transformValue));
    }
  }

  if (rules.length) {
    return "".concat(selector, "{").concat(rules.join(""), "}");
  } else {
    return "";
  }
};

/* ::
import type { SheetDefinition, SheetDefinitions } from './index.js';
import type { MaybeSheetDefinition } from './exports.js';
import type { SelectorHandler } from './generate.js';
*/
// The current <style> tag we are inserting into, or null if we haven't
// inserted anything yet. We could find this each time using
// `document.querySelector("style[data-aphrodite"])`, but holding onto it is
// faster.

var styleTag
/* : ?HTMLStyleElement */
= null; // Inject a set of rules into a <style> tag in the head of the document. This
// will automatically create a style tag and then continue to use it for
// multiple injections. It will also use a style tag with the `data-aphrodite`
// tag on it if that exists in the DOM. This could be used for e.g. reusing the
// same style tag that server-side rendering inserts.

var injectStyleTag = function injectStyleTag(cssRules
/* : string[] */
) {
  if (styleTag == null) {
    // Try to find a style tag with the `data-aphrodite` attribute first.
    styleTag = document.querySelector("style[data-aphrodite]")
    /* : any */
    ; // If that doesn't work, generate a new style tag.

    if (styleTag == null) {
      // Taken from
      // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
      var head = document.head || document.getElementsByTagName('head')[0];
      styleTag = document.createElement('style');
      styleTag.type = 'text/css';
      styleTag.setAttribute("data-aphrodite", "");
      head.appendChild(styleTag);
    }
  } // $FlowFixMe


  var sheet = styleTag.styleSheet || styleTag.sheet
  /* : any */
  ;

  if (sheet.insertRule) {
    var numRules = sheet.cssRules.length;
    cssRules.forEach(function (rule) {
      try {
        sheet.insertRule(rule, numRules);
        numRules += 1;
      } catch (e) {// The selector for this rule wasn't compatible with the browser
      }
    });
  } else {
    styleTag.innerText = (styleTag.innerText || '') + cssRules.join('');
  }
}; // Custom handlers for stringifying CSS values that have side effects
// (such as fontFamily, which can cause @font-face rules to be injected)


var stringHandlers = {
  // With fontFamily we look for objects that are passed in and interpret
  // them as @font-face rules that we need to inject. The value of fontFamily
  // can either be a string (as normal), an object (a single font face), or
  // an array of objects and strings.
  fontFamily: function fontFamily(val) {
    if (Array.isArray(val)) {
      var nameMap = {};
      val.forEach(function (v) {
        nameMap[fontFamily(v)] = true;
      });
      return Object.keys(nameMap).join(",");
    } else if (_typeof(val) === "object") {
      injectStyleOnce(val.src, "@font-face", [val], false);
      return "\"".concat(val.fontFamily, "\"");
    } else {
      return val;
    }
  },
  // With animationName we look for an object that contains keyframes and
  // inject them as an `@keyframes` block, returning a uniquely generated
  // name. The keyframes object should look like
  //  animationName: {
  //    from: {
  //      left: 0,
  //      top: 0,
  //    },
  //    '50%': {
  //      left: 15,
  //      top: 5,
  //    },
  //    to: {
  //      left: 20,
  //      top: 20,
  //    }
  //  }
  // TODO(emily): `stringHandlers` doesn't let us rename the key, so I have
  // to use `animationName` here. Improve that so we can call this
  // `animation` instead of `animationName`.
  animationName: function animationName(val, selectorHandlers) {
    if (Array.isArray(val)) {
      return val.map(function (v) {
        return animationName(v, selectorHandlers);
      }).join(",");
    } else if (_typeof(val) === "object") {
      // Generate a unique name based on the hash of the object. We can't
      // just use the hash because the name can't start with a number.
      // TODO(emily): this probably makes debugging hard, allow a custom
      // name?
      var name = "keyframe_".concat(hashObject(val)); // Since keyframes need 3 layers of nesting, we use `generateCSS` to
      // build the inner layers and wrap it in `@keyframes` ourselves.

      var finalVal = "@keyframes ".concat(name, "{"); // TODO see if we can find a way where checking for OrderedElements
      // here is not necessary. Alternatively, perhaps we should have a
      // utility method that can iterate over either a plain object, an
      // instance of OrderedElements, or a Map, and then use that here and
      // elsewhere.

      if (val instanceof OrderedElements) {
        val.forEach(function (valVal, valKey) {
          finalVal += generateCSS(valKey, [valVal], selectorHandlers, stringHandlers, false).join('');
        });
      } else {
        Object.keys(val).forEach(function (key) {
          finalVal += generateCSS(key, [val[key]], selectorHandlers, stringHandlers, false).join('');
        });
      }

      finalVal += '}';
      injectGeneratedCSSOnce(name, [finalVal]);
      return name;
    } else {
      return val;
    }
  }
}; // This is a map from Aphrodite's generated class names to `true` (acting as a
// set of class names)

var alreadyInjected = {}; // This is the buffer of styles which have not yet been flushed.

var injectionBuffer
/* : string[] */
= []; // A flag to tell if we are already buffering styles. This could happen either
// because we scheduled a flush call already, so newly added styles will
// already be flushed, or because we are statically buffering on the server.

var isBuffering = false;

var injectGeneratedCSSOnce = function injectGeneratedCSSOnce(key, generatedCSS) {
  var _injectionBuffer;

  if (alreadyInjected[key]) {
    return;
  }

  if (!isBuffering) {
    // We should never be automatically buffering on the server (or any
    // place without a document), so guard against that.
    if (typeof document === "undefined") {
      throw new Error("Cannot automatically buffer without a document");
    } // If we're not already buffering, schedule a call to flush the
    // current styles.


    isBuffering = true;
    asap(flushToStyleTag);
  }

  (_injectionBuffer = injectionBuffer).push.apply(_injectionBuffer, _toConsumableArray(generatedCSS));

  alreadyInjected[key] = true;
};

var injectStyleOnce = function injectStyleOnce(key
/* : string */
, selector
/* : string */
, definitions
/* : SheetDefinition[] */
, useImportant
/* : boolean */
) {
  var selectorHandlers
  /* : SelectorHandler[] */
  = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  if (alreadyInjected[key]) {
    return;
  }

  var generated = generateCSS(selector, definitions, selectorHandlers, stringHandlers, useImportant);
  injectGeneratedCSSOnce(key, generated);
};
var reset = function reset() {
  injectionBuffer = [];
  alreadyInjected = {};
  isBuffering = false;
  styleTag = null;
};
var resetInjectedStyle = function resetInjectedStyle(key
/* : string */
) {
  delete alreadyInjected[key];
};
var getBufferedStyles = function getBufferedStyles() {
  return injectionBuffer;
};
var startBuffering = function startBuffering() {
  if (isBuffering) {
    throw new Error("Cannot buffer while already buffering");
  }

  isBuffering = true;
};

var flushToArray = function flushToArray() {
  isBuffering = false;
  var ret = injectionBuffer;
  injectionBuffer = [];
  return ret;
};

var flushToString = function flushToString() {
  return flushToArray().join('');
};
var flushToStyleTag = function flushToStyleTag() {
  var cssRules = flushToArray();

  if (cssRules.length > 0) {
    injectStyleTag(cssRules);
  }
};
var getRenderedClassNames = function getRenderedClassNames()
/* : string[] */
{
  return Object.keys(alreadyInjected);
};
var addRenderedClassNames = function addRenderedClassNames(classNames
/* : string[] */
) {
  classNames.forEach(function (className) {
    alreadyInjected[className] = true;
  });
};

var isValidStyleDefinition = function isValidStyleDefinition(def
/* : Object */
) {
  return "_definition" in def && "_name" in def && "_len" in def;
};

var processStyleDefinitions = function processStyleDefinitions(styleDefinitions
/* : any[] */
, classNameBits
/* : string[] */
, definitionBits
/* : Object[] */
, length
/* : number */
)
/* : number */
{
  for (var i = 0; i < styleDefinitions.length; i += 1) {
    // Filter out falsy values from the input, to allow for
    // `css(a, test && c)`
    if (styleDefinitions[i]) {
      if (Array.isArray(styleDefinitions[i])) {
        // We've encountered an array, so let's recurse
        length += processStyleDefinitions(styleDefinitions[i], classNameBits, definitionBits, length);
      } else if (isValidStyleDefinition(styleDefinitions[i])) {
        classNameBits.push(styleDefinitions[i]._name);
        definitionBits.push(styleDefinitions[i]._definition);
        length += styleDefinitions[i]._len;
      } else {
        throw new Error("Invalid Style Definition: Styles should be defined using the StyleSheet.create method.");
      }
    }
  }

  return length;
};
/**
 * Inject styles associated with the passed style definition objects, and return
 * an associated CSS class name.
 *
 * @param {boolean} useImportant If true, will append !important to generated
 *     CSS output. e.g. {color: red} -> "color: red !important".
 * @param {(Object|Object[])[]} styleDefinitions style definition objects, or
 *     arbitrarily nested arrays of them, as returned as properties of the
 *     return value of StyleSheet.create().
 */


var injectAndGetClassName = function injectAndGetClassName(useImportant
/* : boolean */
, styleDefinitions
/* : MaybeSheetDefinition[] */
, selectorHandlers
/* : SelectorHandler[] */
)
/* : string */
{
  var classNameBits = [];
  var definitionBits = []; // Mutates classNameBits and definitionBits and returns a length which we
  // will append to the hash to decrease the chance of hash collisions.

  var length = processStyleDefinitions(styleDefinitions, classNameBits, definitionBits, 0); // Break if there aren't any valid styles.

  if (classNameBits.length === 0) {
    return "";
  }

  var className;

  if (true) {
    className = classNameBits.length === 1 ? "_".concat(classNameBits[0]) : "_".concat(hashString(classNameBits.join())).concat((length % 36).toString(36));
  } else {}

  injectStyleOnce(className, ".".concat(className), definitionBits, useImportant, selectorHandlers);
  return className;
};

/* ::
import type { SelectorHandler } from './generate.js';
export type SheetDefinition = { [id:string]: any };
export type SheetDefinitions = SheetDefinition | SheetDefinition[];
type RenderFunction = () => string;
type Extension = {
    selectorHandler: SelectorHandler
};
export type MaybeSheetDefinition = SheetDefinition | false | null | void
*/

var unminifiedHashFn = function unminifiedHashFn(str
/* : string */
, key
/* : string */
) {
  return "".concat(key, "_").concat(hashString(str));
}; // StyleSheet.create is in a hot path so we want to keep as much logic out of it
// as possible. So, we figure out which hash function to use once, and only
// switch it out via minify() as necessary.
//
// This is in an exported function to make it easier to test.


var initialHashFn = function initialHashFn() {
  return  true ? hashString : 0;
};
var hashFn = initialHashFn();
var StyleSheet = {
  create: function create(sheetDefinition
  /* : SheetDefinition */
  )
  /* : Object */
  {
    var mappedSheetDefinition = {};
    var keys = Object.keys(sheetDefinition);

    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var val = sheetDefinition[key];
      var stringVal = JSON.stringify(val);
      mappedSheetDefinition[key] = {
        _len: stringVal.length,
        _name: hashFn(stringVal, key),
        _definition: val
      };
    }

    return mappedSheetDefinition;
  },
  rehydrate: function rehydrate() {
    var renderedClassNames
    /* : string[] */
    = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    addRenderedClassNames(renderedClassNames);
  }
};
/**
 * Utilities for using Aphrodite server-side.
 *
 * This can be minified out in client-only bundles by replacing `typeof window`
 * with `"object"`, e.g. via Webpack's DefinePlugin:
 *
 *   new webpack.DefinePlugin({
 *     "typeof window": JSON.stringify("object")
 *   })
 */

var StyleSheetServer = typeof window !== 'undefined' ? null : {
  renderStatic: function renderStatic(renderFunc
  /* : RenderFunction */
  ) {
    reset();
    startBuffering();
    var html = renderFunc();
    var cssContent = flushToString();
    return {
      html: html,
      css: {
        content: cssContent,
        renderedClassNames: getRenderedClassNames()
      }
    };
  }
};
/**
 * Utilities for using Aphrodite in tests.
 *
 * Not meant to be used in production.
 */

var StyleSheetTestUtils =  true ? null : 0;
/**
 * Generate the Aphrodite API exports, with given `selectorHandlers` and
 * `useImportant` state.
 */

function makeExports(useImportant
/* : boolean */
) {
  var selectorHandlers
  /* : SelectorHandler[] */
  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSelectorHandlers;
  return {
    StyleSheet: _objectSpread({}, StyleSheet, {
      /**
       * Returns a version of the exports of Aphrodite (i.e. an object
       * with `css` and `StyleSheet` properties) which have some
       * extensions included.
       *
       * @param {Array.<Object>} extensions: An array of extensions to
       *     add to this instance of Aphrodite. Each object should have a
       *     single property on it, defining which kind of extension to
       *     add.
       * @param {SelectorHandler} [extensions[].selectorHandler]: A
       *     selector handler extension. See `defaultSelectorHandlers` in
       *     generate.js.
       *
       * @returns {Object} An object containing the exports of the new
       *     instance of Aphrodite.
       */
      extend: function extend(extensions
      /* : Extension[] */
      ) {
        var extensionSelectorHandlers = extensions // Pull out extensions with a selectorHandler property
        .map(function (extension) {
          return extension.selectorHandler;
        }) // Remove nulls (i.e. extensions without a selectorHandler property).
        .filter(function (handler) {
          return handler;
        });
        return makeExports(useImportant, selectorHandlers.concat(extensionSelectorHandlers));
      }
    }),
    StyleSheetServer: StyleSheetServer,
    StyleSheetTestUtils: StyleSheetTestUtils,
    minify: function minify(shouldMinify
    /* : boolean */
    ) {
      hashFn = shouldMinify ? hashString : unminifiedHashFn;
    },
    css: function css()
    /* : MaybeSheetDefinition[] */
    {
      for (var _len = arguments.length, styleDefinitions = new Array(_len), _key = 0; _key < _len; _key++) {
        styleDefinitions[_key] = arguments[_key];
      }

      return injectAndGetClassName(useImportant, styleDefinitions, selectorHandlers);
    },
    flushToStyleTag: flushToStyleTag,
    injectAndGetClassName: injectAndGetClassName,
    defaultSelectorHandlers: defaultSelectorHandlers,
    reset: reset,
    resetInjectedStyle: resetInjectedStyle
  };
}

exports.makeExports = makeExports;


/***/ }),

/***/ 22823:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var __chunk_1 = __webpack_require__(3579);
__webpack_require__(9839);
__webpack_require__(60629);

/* @flow */
var useImportant = false; // Don't add !important to style definitions

var Aphrodite = __chunk_1.makeExports(useImportant);
var StyleSheet = Aphrodite.StyleSheet,
    StyleSheetServer = Aphrodite.StyleSheetServer,
    StyleSheetTestUtils = Aphrodite.StyleSheetTestUtils,
    css = Aphrodite.css,
    minify = Aphrodite.minify,
    flushToStyleTag = Aphrodite.flushToStyleTag,
    injectAndGetClassName = Aphrodite.injectAndGetClassName,
    defaultSelectorHandlers = Aphrodite.defaultSelectorHandlers,
    reset = Aphrodite.reset,
    resetInjectedStyle = Aphrodite.resetInjectedStyle;

exports.StyleSheet = StyleSheet;
exports.StyleSheetServer = StyleSheetServer;
exports.StyleSheetTestUtils = StyleSheetTestUtils;
exports.css = css;
exports.minify = minify;
exports.flushToStyleTag = flushToStyleTag;
exports.injectAndGetClassName = injectAndGetClassName;
exports.defaultSelectorHandlers = defaultSelectorHandlers;
exports.reset = reset;
exports.resetInjectedStyle = resetInjectedStyle;


/***/ }),

/***/ 44884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(22823);


/***/ }),

/***/ 54131:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const { ApolloLink, Observable } = __webpack_require__(54814);
const {
  createSignalIfSupported,
  fallbackHttpConfig,
  parseAndCheckHttpResponse,
  rewriteURIForGET,
  selectHttpOptionsAndBody,
  selectURI,
  serializeFetchParameter,
} = __webpack_require__(2535);
const extractFiles = __webpack_require__(42929);
const formDataAppendFile = __webpack_require__(91056);
const isExtractableFile = __webpack_require__(87806);

/**
 * Creates a
 * [terminating Apollo Link](https://apollographql.com/docs/react/api/link/introduction/#the-terminating-link)
 * for [Apollo Client](https://apollographql.com/docs/react) that fetches a
 * [GraphQL multipart request](https://github.com/jaydenseric/graphql-multipart-request-spec)
 * if the GraphQL variables contain files (by default
 * [`FileList`](https://developer.mozilla.org/en-US/docs/Web/API/FileList),
 * [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File),
 * [`Blob`](https://developer.mozilla.org/en-US/docs/Web/API/Blob), or
 * [`ReactNativeFile`](#class-reactnativefile) instances), or else fetches a
 * regular
 * [GraphQL POST or GET request](https://apollographql.com/docs/apollo-server/requests)
 * (depending on the config and GraphQL operation).
 *
 * Some of the options are similar to the
 * [`createHttpLink` options](https://apollographql.com/docs/react/api/link/apollo-link-http/#httplink-constructor-options).
 * @see [GraphQL multipart request spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
 * @kind function
 * @name createUploadLink
 * @param {object} options Options.
 * @param {string} [options.uri="/graphql"] GraphQL endpoint URI.
 * @param {boolean} [options.useGETForQueries] Should GET be used to fetch queries, if there are no files to upload.
 * @param {ExtractableFileMatcher} [options.isExtractableFile=isExtractableFile] Customizes how files are matched in the GraphQL operation for extraction.
 * @param {class} [options.FormData] [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) implementation to use, defaulting to the [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) global.
 * @param {FormDataFileAppender} [options.formDataAppendFile=formDataAppendFile] Customizes how extracted files are appended to the [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) instance.
 * @param {Function} [options.fetch] [`fetch`](https://fetch.spec.whatwg.org) implementation to use, defaulting to the [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch) global.
 * @param {FetchOptions} [options.fetchOptions] [`fetch` options]{@link FetchOptions}; overridden by upload requirements.
 * @param {string} [options.credentials] Overrides `options.fetchOptions.credentials`.
 * @param {object} [options.headers] Merges with and overrides `options.fetchOptions.headers`.
 * @param {boolean} [options.includeExtensions=false] Toggles sending `extensions` fields to the GraphQL server.
 * @returns {ApolloLink} A [terminating Apollo Link](https://apollographql.com/docs/react/api/link/introduction/#the-terminating-link).
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { createUploadLink } from "apollo-upload-client";
 * ```
 *
 * ```js
 * import createUploadLink from "apollo-upload-client/public/createUploadLink.js";
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { createUploadLink } = require("apollo-upload-client");
 * ```
 *
 * ```js
 * const createUploadLink = require("apollo-upload-client/public/createUploadLink.js");
 * ```
 * @example <caption>A basic Apollo Client setup.</caption>
 * ```js
 * import { ApolloClient, InMemoryCache } from "@apollo/client";
 * import createUploadLink from "apollo-upload-client/public/createUploadLink.js";
 *
 * const client = new ApolloClient({
 *   cache: new InMemoryCache(),
 *   link: createUploadLink(),
 * });
 * ```
 */
module.exports = function createUploadLink({
  uri: fetchUri = "/graphql",
  useGETForQueries,
  isExtractableFile: customIsExtractableFile = isExtractableFile,
  FormData: CustomFormData,
  formDataAppendFile: customFormDataAppendFile = formDataAppendFile,
  fetch: customFetch,
  fetchOptions,
  credentials,
  headers,
  includeExtensions,
} = {}) {
  const linkConfig = {
    http: { includeExtensions },
    options: fetchOptions,
    credentials,
    headers,
  };

  return new ApolloLink((operation) => {
    const context = operation.getContext();
    const {
      // Apollo Studio client awareness `name` and `version` can be configured
      // via `ApolloClient` constructor options:
      // https://apollographql.com/docs/studio/client-awareness/#using-apollo-server-and-apollo-client
      clientAwareness: { name, version } = {},
      headers,
    } = context;

    const contextConfig = {
      http: context.http,
      options: context.fetchOptions,
      credentials: context.credentials,
      headers: {
        // Client awareness headers can be overridden by context `headers`.
        ...(name && { "apollographql-client-name": name }),
        ...(version && { "apollographql-client-version": version }),
        ...headers,
      },
    };

    const { options, body } = selectHttpOptionsAndBody(
      operation,
      fallbackHttpConfig,
      linkConfig,
      contextConfig
    );

    const { clone, files } = extractFiles(body, "", customIsExtractableFile);

    let uri = selectURI(operation, fetchUri);

    if (files.size) {
      // Automatically set by `fetch` when the `body` is a `FormData` instance.
      delete options.headers["content-type"];

      // GraphQL multipart request spec:
      // https://github.com/jaydenseric/graphql-multipart-request-spec

      const RuntimeFormData = CustomFormData || FormData;

      const form = new RuntimeFormData();

      form.append("operations", serializeFetchParameter(clone, "Payload"));

      const map = {};
      let i = 0;
      files.forEach((paths) => {
        map[++i] = paths;
      });
      form.append("map", JSON.stringify(map));

      i = 0;
      files.forEach((paths, file) => {
        customFormDataAppendFile(form, ++i, file);
      });

      options.body = form;
    } else {
      if (
        useGETForQueries &&
        // If the operation contains some mutations GET shouldn’t be used.
        !operation.query.definitions.some(
          (definition) =>
            definition.kind === "OperationDefinition" &&
            definition.operation === "mutation"
        )
      )
        options.method = "GET";

      if (options.method === "GET") {
        const { newURI, parseError } = rewriteURIForGET(uri, body);
        if (parseError)
          // Apollo’s `HttpLink` uses `fromError` for this, but it’s not
          // exported from `@apollo/client/link/http`.
          return new Observable((observer) => {
            observer.error(parseError);
          });
        uri = newURI;
      } else options.body = serializeFetchParameter(clone, "Payload");
    }

    const { controller } = createSignalIfSupported();

    if (controller) {
      if (options.signal)
        // Respect the user configured abort controller signal.
        options.signal.aborted
          ? // Signal already aborted, so immediately abort.
            controller.abort()
          : // Signal not already aborted, so setup a listener to abort when it
            // does.
            options.signal.addEventListener(
              "abort",
              () => {
                controller.abort();
              },
              {
                // Prevent a memory leak if the user configured abort controller
                // is long lasting, or controls multiple things.
                once: true,
              }
            );

      options.signal = controller.signal;
    }

    const runtimeFetch = customFetch || fetch;

    return new Observable((observer) => {
      // Used to track if the observable is being cleaned up.
      let cleaningUp;

      runtimeFetch(uri, options)
        .then((response) => {
          // Forward the response on the context.
          operation.setContext({ response });
          return response;
        })
        .then(parseAndCheckHttpResponse(operation))
        .then((result) => {
          observer.next(result);
          observer.complete();
        })
        .catch((error) => {
          // If the observable is being cleaned up, there is no need to call
          // next or error because there are no more subscribers. An error after
          // cleanup begins is likely from the cleanup function aborting the
          // fetch.
          if (!cleaningUp) {
            // For errors such as an invalid fetch URI there will be no GraphQL
            // result with errors or data to forward.
            if (error.result && error.result.errors && error.result.data)
              observer.next(error.result);

            observer.error(error);
          }
        });

      // Cleanup function.
      return () => {
        cleaningUp = true;

        // Abort fetch. It’s ok to signal an abort even when not fetching.
        if (controller) controller.abort();
      };
    });
  });
};


/***/ }),

/***/ 91056:
/***/ (function(module) {

"use strict";


/**
 * The default implementation for [`createUploadLink`]{@link createUploadLink}
 * `options.formDataAppendFile` that uses the standard
 * [`FormData.append`](https://developer.mozilla.org/en-US/docs/Web/API/FormData/append)
 * method.
 * @kind function
 * @name formDataAppendFile
 * @type {FormDataFileAppender}
 * @param {FormData} formData [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData) instance to append the specified file to.
 * @param {string} fieldName Field name for the file.
 * @param {*} file File to append.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { formDataAppendFile } from "apollo-upload-client";
 * ```
 *
 * ```js
 * import formDataAppendFile from "apollo-upload-client/public/formDataAppendFile.js";
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { formDataAppendFile } = require("apollo-upload-client");
 * ```
 *
 * ```js
 * const formDataAppendFile = require("apollo-upload-client/public/formDataAppendFile.js");
 * ```
 */
module.exports = function formDataAppendFile(formData, fieldName, file) {
  formData.append(fieldName, file, file.name);
};


/***/ }),

/***/ 87806:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/**
 * The default implementation for [`createUploadLink`]{@link createUploadLink}
 * `options.isExtractableFile`.
 * @kind function
 * @name isExtractableFile
 * @type {ExtractableFileMatcher}
 * @param {*} value Value to check.
 * @returns {boolean} Is the value an extractable file.
 * @see [`extract-files` `isExtractableFile` docs](https://github.com/jaydenseric/extract-files#function-isextractablefile).
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { isExtractableFile } from "apollo-upload-client";
 * ```
 *
 * ```js
 * import isExtractableFile from "apollo-upload-client/public/isExtractableFile.js";
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { isExtractableFile } = require("apollo-upload-client");
 * ```
 *
 * ```js
 * const isExtractableFile = require("apollo-upload-client/public/isExtractableFile.js");
 * ```
 */
module.exports = __webpack_require__(21278);


/***/ }),

/***/ 60629:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.
var rawAsap = __webpack_require__(42384);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};


/***/ }),

/***/ 42384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js


/***/ }),

/***/ 89644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(25644);

/***/ }),

/***/ 70353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(93044);
var settle = __webpack_require__(86955);
var cookies = __webpack_require__(92233);
var buildURL = __webpack_require__(68030);
var buildFullPath = __webpack_require__(97948);
var parseHeaders = __webpack_require__(51875);
var isURLSameOrigin = __webpack_require__(60842);
var createError = __webpack_require__(88618);
var defaults = __webpack_require__(1439);
var Cancel = __webpack_require__(26714);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 25644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(93044);
var bind = __webpack_require__(73644);
var Axios = __webpack_require__(62215);
var mergeConfig = __webpack_require__(92937);
var defaults = __webpack_require__(1439);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(26714);
axios.CancelToken = __webpack_require__(34089);
axios.isCancel = __webpack_require__(98041);
axios.VERSION = (__webpack_require__(29241).version);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(70783);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(65587);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 26714:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 34089:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(26714);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 98041:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 62215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(93044);
var buildURL = __webpack_require__(68030);
var InterceptorManager = __webpack_require__(946);
var dispatchRequest = __webpack_require__(6895);
var mergeConfig = __webpack_require__(92937);
var validator = __webpack_require__(17525);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 946:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(93044);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 97948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(99192);
var combineURLs = __webpack_require__(48762);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 88618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(11935);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 6895:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(93044);
var transformData = __webpack_require__(38556);
var isCancel = __webpack_require__(98041);
var defaults = __webpack_require__(1439);
var Cancel = __webpack_require__(26714);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 11935:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};


/***/ }),

/***/ 92937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(93044);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 86955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(88618);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 38556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(93044);
var defaults = __webpack_require__(1439);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 1439:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(93542);


var utils = __webpack_require__(93044);
var normalizeHeaderName = __webpack_require__(98868);
var enhanceError = __webpack_require__(11935);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(70353);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(70353);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 29241:
/***/ (function(module) {

module.exports = {
  "version": "0.24.0"
};

/***/ }),

/***/ 73644:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 68030:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(93044);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 48762:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 92233:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(93044);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 99192:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 65587:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 60842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(93044);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 98868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(93044);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 51875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(93044);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 70783:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 17525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(29241).version);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 93044:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(73644);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 72779:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 6277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clsx": function() { return /* binding */ clsx; }
/* harmony export */ });
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["default"] = (clsx);

/***/ }),

/***/ 14623:
/***/ (function(module) {

var exports = module.exports = function (doc) {
    if (!doc) doc = {};
    if (typeof doc === 'string') doc = { cookie: doc };
    if (doc.cookie === undefined) doc.cookie = '';
    
    var self = {};
    self.get = function (key) {
        var splat = doc.cookie.split(/;\s*/);
        for (var i = 0; i < splat.length; i++) {
            var ps = splat[i].split('=');
            var k = unescape(ps[0]);
            if (k === key) return unescape(ps[1]);
        }
        return undefined;
    };
    
    self.set = function (key, value, opts) {
        if (!opts) opts = {};
        var s = escape(key) + '=' + escape(value);
        if (opts.expires) s += '; expires=' + opts.expires;
        if (opts.path) s += '; path=' + escape(opts.path);
        if (opts.domain) s += '; domain=' + escape(opts.domain);
        if (opts.secure) s += '; secure';
        doc.cookie = s;
        return s;
    };
    return self;
};

if (typeof document !== 'undefined') {
    var cookie = exports(document);
    exports.get = cookie.get;
    exports.set = cookie.set;
}


/***/ }),

/***/ 72857:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else { var c; }})("undefined"==typeof globalThis?"undefined"==typeof self?this:self:globalThis,function(a){"use strict";function b(a,b){return g(a)||f(a,b)||d(a,b)||c()}function c(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function d(a,b){if(a){if("string"==typeof a)return e(a,b);var c=Object.prototype.toString.call(a).slice(8,-1);return"Object"===c&&a.constructor&&(c=a.constructor.name),"Map"===c||"Set"===c?Array.from(a):"Arguments"===c||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c)?e(a,b):void 0}}function e(a,b){(null==b||b>a.length)&&(b=a.length);for(var c=0,d=Array(b);c<b;c++)d[c]=a[c];return d}function f(a,b){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(a)){var c=[],d=!0,e=!1,f=void 0;try{for(var g,h=a[Symbol.iterator]();!(d=(g=h.next()).done)&&(c.push(g.value),!(b&&c.length===b));d=!0);}catch(a){e=!0,f=a}finally{try{d||null==h["return"]||h["return"]()}finally{if(e)throw f}}return c}}function g(a){if(Array.isArray(a))return a}function h(){throw"invalid media-query  :("}function i(){throw"invalid breakpoint :("}/**
   * get breakpoint list of css-in-js-media
   */function j(){return q}function k(a){var b=Object.keys(q),c=Object.keys(a);return c.every(function(a){return b.includes(a)})}/**
   * set break points of css-in-js-media library with custom param
   * @param customizedBreakPoints customized breakpoint param
   */function l(a){var b=k(a);return b?void(q=Object.assign(Object.assign({},q),a)):i()}/**
   * use css in js media (ex: includeMedia(">=phone", "<tablet"))
   * @param query
   * @param betweenQuery
   */function m(a){var c=n(a),d=b(c,2),e=d[0],f=d[1],g=!!e&&!!q[f];return g}function n(a){var b=a.match(r)?a.match(r)[0].trim():"",c=a.replace(r,"").trim();return[b,c]}function o(a,b){return a.includes("=")?q[b]:a.includes(">")?q[b]+1:q[b]-1}function p(a){var c=n(a),d=b(c,2),e=d[0],f=d[1],g=o(e,f),h="number"==typeof g?"px":"",i=e.includes(">")?"min-width":"max-width";return"(".concat(i,": ").concat(g).concat(h,")")}Object.defineProperty(a,"__esModule",{value:!0}),a.getBreakPoints=j,a.setBreakPoints=l,a["default"]=void 0;var q={smallPhone:320,phone:375,tablet:768,desktop:1024,largeDesktop:1440},r=/^[<=>]+/;a["default"]=function(a,b){var c=b?[a,b]:[a];return c.every(m)?"@media ".concat(c.map(p).join(" and ")):h()}});


/***/ }),

/***/ 15344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ defaultLocale; }
});

;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);

/***/ }),

/***/ 18667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getDefaultOptions; }
/* harmony export */ });
/* unused harmony export setDefaultOptions */
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 60429:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var dateLongFormatter = function (pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};

var timeLongFormatter = function (pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};

var dateTimeLongFormatter = function (pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["Z"] = (longFormatters);

/***/ }),

/***/ 1645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTimezoneOffsetInMilliseconds; }
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 17898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCISOWeek; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(55143);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(90257);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = (0,getUTCISOWeekYear/* default */.Z)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCISOWeek/* default */.Z)(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var diff = (0,startOfUTCISOWeek/* default */.Z)(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 90257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCISOWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55143);



function getUTCISOWeekYear(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 10663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCWeek; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(52329);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(72763);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(42765);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(18667);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = (0,getUTCWeekYear/* default */.Z)(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCWeek/* default */.Z)(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var diff = (0,startOfUTCWeek/* default */.Z)(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 72763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52329);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42765);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18667);





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultOptions */ .j)();
  var firstWeekContainsDate = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 13503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ isProtectedWeekYearToken; },
/* harmony export */   "Iu": function() { return /* binding */ isProtectedDayOfYearToken; },
/* harmony export */   "qp": function() { return /* binding */ throwProtectedError; }
/* harmony export */ });
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),

/***/ 19785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 55143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCISOWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


function startOfUTCISOWeek(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 52329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66700);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18667);




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 42765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 63761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 20578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addHours; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91310);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/***/ }),

/***/ 91310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addMilliseconds; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var timestamp = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getTime();
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),

/***/ 23107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addMinutes; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91310);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

/***/ }),

/***/ 28187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addMonths; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),

/***/ 85014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addWeeks; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63761);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  var days = amount * 7;
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, days);
}

/***/ }),

/***/ 52946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addYears; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28187);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, amount * 12);
}

/***/ }),

/***/ 64312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qk": function() { return /* binding */ millisecondsInSecond; },
/* harmony export */   "vh": function() { return /* binding */ millisecondsInHour; },
/* harmony export */   "yJ": function() { return /* binding */ millisecondsInMinute; }
/* harmony export */ });
/* unused harmony exports daysInWeek, daysInYear, maxTime, minTime, minutesInHour, monthsInQuarter, monthsInYear, quartersInYear, secondsInHour, secondsInMinute, secondsInDay, secondsInWeek, secondsInYear, secondsInMonth, secondsInQuarter */
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;
/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */

var daysInYear = 365.2425;
/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */

var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInSecond = 1000;
/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */

var minTime = -maxTime;
/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */

var minutesInHour = 60;
/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var monthsInQuarter = 3;
/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */

var monthsInYear = 12;
/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */

var quartersInYear = 4;
/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */

var secondsInHour = 3600;
/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var secondsInMinute = 60;
/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */

var secondsInDay = secondsInHour * 24;
/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */

var secondsInWeek = secondsInDay * 7;
/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */

var secondsInYear = secondsInDay * daysInYear;
/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */

var secondsInMonth = secondsInYear / 12;
/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var secondsInQuarter = secondsInMonth * 3;

/***/ }),

/***/ 8849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarDays; }
/* harmony export */ });
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1645);
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10405);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var startOfDayLeft = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var startOfDayRight = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),

/***/ 92082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarMonths; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/***/ }),

/***/ 50356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarWeeks; }
/* harmony export */ });
/* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49122);
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1645);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */

function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var startOfWeekLeft = (0,_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft, options);
  var startOfWeekRight = (0,_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight, options);
  var timestampLeft = startOfWeekLeft.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

/***/ }),

/***/ 93399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarYears; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/***/ }),

/***/ 11106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ endOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 8548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ endOfMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 10194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ endOfWeek; }
/* harmony export */ });
/* harmony import */ var _lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18667);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66700);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);





/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 73053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ format; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(4478);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(7610);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(17898);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(90257);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(10663);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(72763);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */
var formatters_formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = (0,getUTCWeekYear/* default */.Z)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = (0,getUTCISOWeekYear/* default */.Z)(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = (0,getUTCWeek/* default */.Z)(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = (0,getUTCISOWeek/* default */.Z)(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ var format_formatters = (formatters_formatters);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(60429);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(1645);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(13503);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(42765);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(18667);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(15344);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = (0,toDate["default"])(dirtyDate);

  if (!(0,isValid["default"])(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = (0,subMilliseconds/* default */.Z)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = format_formatters[firstCharacter];

    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 35459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getDate; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */

function getDate(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/***/ }),

/***/ 98465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var day = date.getDay();
  return day;
}

/***/ }),

/***/ 99994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getHours; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/***/ }),

/***/ 2800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ getISOWeek; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/startOfWeek/index.js
var startOfWeek = __webpack_require__(49122);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/startOfISOWeek/index.js


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return (0,startOfWeek["default"])(dirtyDate, {
    weekStartsOn: 1
  });
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/getISOWeekYear/index.js



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */

function getISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/startOfISOWeekYear/index.js



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/getISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */

function getISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 34908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getMinutes; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/***/ }),

/***/ 51981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var month = date.getMonth();
  return month;
}

/***/ }),

/***/ 81139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getQuarter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */

function getQuarter(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/***/ }),

/***/ 33963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getSeconds; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/***/ }),

/***/ 17254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getTime; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/***/ }),

/***/ 81914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ getYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getFullYear();
}

/***/ }),

/***/ 42598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isAfter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 63063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isBefore; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/***/ }),

/***/ 72968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/***/ }),

/***/ 46326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isEqual; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyLeftDate);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/***/ }),

/***/ 82276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isSameDay; }
/* harmony export */ });
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10405);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRightStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),

/***/ 53009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isSameMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/***/ }),

/***/ 80143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isSameQuarter; }
/* harmony export */ });
/* harmony import */ var _startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73116);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */

function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfQuarter = (0,_startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRightStartOfQuarter = (0,_startOfQuarter_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/***/ }),

/***/ 31794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isSameYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/***/ }),

/***/ 4478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isValid; }
/* harmony export */ });
/* harmony import */ var _isDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72968);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);

  if (!(0,_isDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),

/***/ 1713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isWithinInterval; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var time = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate).getTime();
  var startTime = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(interval.start).getTime();
  var endTime = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

/***/ }),

/***/ 13621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ max; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */

function max(dirtyDatesArray) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);

    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),

/***/ 97208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ min; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */

function min(dirtyDatesArray) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);

    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),

/***/ 65662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ parse; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(15344);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/subMilliseconds/index.js
var subMilliseconds = __webpack_require__(7610);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }

  return target;
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(60429);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(1645);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(13503);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(42765);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/Setter.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TIMEZONE_UNIT_PRIORITY = 10;
class Setter {
  constructor() {
    _defineProperty(this, "priority", void 0);

    _defineProperty(this, "subPriority", 0);
  }

  validate(_utcDate, _options) {
    return true;
  }

}
class ValueSetter extends Setter {
  constructor(value, validateValue, setValue, priority, subPriority) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;

    if (subPriority) {
      this.subPriority = subPriority;
    }
  }

  validate(utcDate, options) {
    return this.validateValue(utcDate, this.value, options);
  }

  set(utcDate, flags, options) {
    return this.setValue(utcDate, flags, this.value, options);
  }

}
class DateToSystemTimezoneSetter extends Setter {
  constructor() {
    super(...arguments);

    _defineProperty(this, "priority", TIMEZONE_UNIT_PRIORITY);

    _defineProperty(this, "subPriority", -1);
  }

  set(date, flags) {
    if (flags.timestampIsSet) {
      return date;
    }

    var convertedDate = new Date(0);
    convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    return convertedDate;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/Parser.js
function Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


class Parser {
  constructor() {
    Parser_defineProperty(this, "incompatibleTokens", void 0);

    Parser_defineProperty(this, "priority", void 0);

    Parser_defineProperty(this, "subPriority", void 0);
  }

  run(dateString, token, match, options) {
    var result = this.parse(dateString, token, match, options);

    if (!result) {
      return null;
    }

    return {
      setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
      rest: result.rest
    };
  }

  validate(_utcDate, _value, _options) {
    return true;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/EraParser.js
function EraParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


class EraParser extends Parser {
  constructor() {
    super(...arguments);

    EraParser_defineProperty(this, "priority", 140);

    EraParser_defineProperty(this, "incompatibleTokens", ['R', 'u', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return match.era(dateString, {
          width: 'abbreviated'
        }) || match.era(dateString, {
          width: 'narrow'
        });
      // A, B

      case 'GGGGG':
        return match.era(dateString, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return match.era(dateString, {
          width: 'wide'
        }) || match.era(dateString, {
          width: 'abbreviated'
        }) || match.era(dateString, {
          width: 'narrow'
        });
    }
  }

  set(date, flags, value) {
    flags.era = value;
    date.setUTCFullYear(value, 0, 1);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__(64312);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/constants.js
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/utils.js


function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }

  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * constants/* millisecondsInHour */.vh + minutes * constants/* millisecondsInMinute */.yJ + seconds * constants/* millisecondsInSecond */.qk),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/YearParser.js
function YearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class YearParser extends Parser {
  constructor() {
    super(...arguments);

    YearParser_defineProperty(this, "priority", 130);

    YearParser_defineProperty(this, "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
  }

  parse(dateString, token, match) {
    var valueCallback = function (year) {
      return {
        year: year,
        isTwoDigitYear: token === 'yy'
      };
    };

    switch (token) {
      case 'y':
        return mapValue(parseNDigits(4, dateString), valueCallback);

      case 'yo':
        return mapValue(match.ordinalNumber(dateString, {
          unit: 'year'
        }), valueCallback);

      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }

  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }

  set(date, flags, value) {
    var currentYear = date.getUTCFullYear();

    if (value.isTwoDigitYear) {
      var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
      date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }

    var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setUTCFullYear(year, 0, 1);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(72763);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(52329);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekYearParser.js
function LocalWeekYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





// Local week-numbering year
class LocalWeekYearParser extends Parser {
  constructor() {
    super(...arguments);

    LocalWeekYearParser_defineProperty(this, "priority", 130);

    LocalWeekYearParser_defineProperty(this, "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
  }

  parse(dateString, token, match) {
    var valueCallback = function (year) {
      return {
        year: year,
        isTwoDigitYear: token === 'YY'
      };
    };

    switch (token) {
      case 'Y':
        return mapValue(parseNDigits(4, dateString), valueCallback);

      case 'Yo':
        return mapValue(match.ordinalNumber(dateString, {
          unit: 'year'
        }), valueCallback);

      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }

  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }

  set(date, flags, value, options) {
    var currentYear = (0,getUTCWeekYear/* default */.Z)(date, options);

    if (value.isTwoDigitYear) {
      var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
      date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCWeek/* default */.Z)(date, options);
    }

    var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
    date.setUTCHours(0, 0, 0, 0);
    return (0,startOfUTCWeek/* default */.Z)(date, options);
  }

}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(55143);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekYearParser.js
function ISOWeekYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // ISO week-numbering year

class ISOWeekYearParser extends Parser {
  constructor() {
    super(...arguments);

    ISOWeekYearParser_defineProperty(this, "priority", 130);

    ISOWeekYearParser_defineProperty(this, "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
  }

  parse(dateString, token) {
    if (token === 'R') {
      return parseNDigitsSigned(4, dateString);
    }

    return parseNDigitsSigned(token.length, dateString);
  }

  set(_date, _flags, value) {
    var firstWeekOfYear = new Date(0);
    firstWeekOfYear.setUTCFullYear(value, 0, 4);
    firstWeekOfYear.setUTCHours(0, 0, 0, 0);
    return (0,startOfUTCISOWeek/* default */.Z)(firstWeekOfYear);
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/ExtendedYearParser.js
function ExtendedYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



class ExtendedYearParser extends Parser {
  constructor() {
    super(...arguments);

    ExtendedYearParser_defineProperty(this, "priority", 130);

    ExtendedYearParser_defineProperty(this, "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
  }

  parse(dateString, token) {
    if (token === 'u') {
      return parseNDigitsSigned(4, dateString);
    }

    return parseNDigitsSigned(token.length, dateString);
  }

  set(date, _flags, value) {
    date.setUTCFullYear(value, 0, 1);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/QuarterParser.js
function QuarterParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



class QuarterParser extends Parser {
  constructor() {
    super(...arguments);

    QuarterParser_defineProperty(this, "priority", 120);

    QuarterParser_defineProperty(this, "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
      case 'QQ':
        // 01, 02, 03, 04
        return parseNDigits(token.length, dateString);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return match.ordinalNumber(dateString, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return match.quarter(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.quarter(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return match.quarter(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return match.quarter(dateString, {
          width: 'wide',
          context: 'formatting'
        }) || match.quarter(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.quarter(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 4;
  }

  set(date, _flags, value) {
    date.setUTCMonth((value - 1) * 3, 1);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneQuarterParser.js
function StandAloneQuarterParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



class StandAloneQuarterParser extends Parser {
  constructor() {
    super(...arguments);

    StandAloneQuarterParser_defineProperty(this, "priority", 120);

    StandAloneQuarterParser_defineProperty(this, "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
      case 'qq':
        // 01, 02, 03, 04
        return parseNDigits(token.length, dateString);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return match.ordinalNumber(dateString, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return match.quarter(dateString, {
          width: 'abbreviated',
          context: 'standalone'
        }) || match.quarter(dateString, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return match.quarter(dateString, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return match.quarter(dateString, {
          width: 'wide',
          context: 'standalone'
        }) || match.quarter(dateString, {
          width: 'abbreviated',
          context: 'standalone'
        }) || match.quarter(dateString, {
          width: 'narrow',
          context: 'standalone'
        });
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 4;
  }

  set(date, _flags, value) {
    date.setUTCMonth((value - 1) * 3, 1);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/MonthParser.js
function MonthParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




class MonthParser extends Parser {
  constructor() {
    super(...arguments);

    MonthParser_defineProperty(this, "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    MonthParser_defineProperty(this, "priority", 110);
  }

  parse(dateString, token, match) {
    var valueCallback = function (value) {
      return value - 1;
    };

    switch (token) {
      // 1, 2, ..., 12
      case 'M':
        return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
      // 01, 02, ..., 12

      case 'MM':
        return mapValue(parseNDigits(2, dateString), valueCallback);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return mapValue(match.ordinalNumber(dateString, {
          unit: 'month'
        }), valueCallback);
      // Jan, Feb, ..., Dec

      case 'MMM':
        return match.month(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.month(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return match.month(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return match.month(dateString, {
          width: 'wide',
          context: 'formatting'
        }) || match.month(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.month(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    date.setUTCMonth(value, 1);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneMonthParser.js
function StandAloneMonthParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




class StandAloneMonthParser extends Parser {
  constructor() {
    super(...arguments);

    StandAloneMonthParser_defineProperty(this, "priority", 110);

    StandAloneMonthParser_defineProperty(this, "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
  }

  parse(dateString, token, match) {
    var valueCallback = function (value) {
      return value - 1;
    };

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
      // 01, 02, ..., 12

      case 'LL':
        return mapValue(parseNDigits(2, dateString), valueCallback);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return mapValue(match.ordinalNumber(dateString, {
          unit: 'month'
        }), valueCallback);
      // Jan, Feb, ..., Dec

      case 'LLL':
        return match.month(dateString, {
          width: 'abbreviated',
          context: 'standalone'
        }) || match.month(dateString, {
          width: 'narrow',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return match.month(dateString, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return match.month(dateString, {
          width: 'wide',
          context: 'standalone'
        }) || match.month(dateString, {
          width: 'abbreviated',
          context: 'standalone'
        }) || match.month(dateString, {
          width: 'narrow',
          context: 'standalone'
        });
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    date.setUTCMonth(value, 1);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(10663);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/setUTCWeek/index.js




function setUTCWeek(dirtyDate, dirtyWeek, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var week = (0,toInteger/* default */.Z)(dirtyWeek);
  var diff = (0,getUTCWeek/* default */.Z)(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekParser.js
function LocalWeekParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // Local week of year

class LocalWeekParser extends Parser {
  constructor() {
    super(...arguments);

    LocalWeekParser_defineProperty(this, "priority", 100);

    LocalWeekParser_defineProperty(this, "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 'w':
        return parseNumericPattern(numericPatterns.week, dateString);

      case 'wo':
        return match.ordinalNumber(dateString, {
          unit: 'week'
        });

      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 53;
  }

  set(date, _flags, value, options) {
    return (0,startOfUTCWeek/* default */.Z)(setUTCWeek(date, value, options), options);
  }

}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(17898);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js




function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var isoWeek = (0,toInteger/* default */.Z)(dirtyISOWeek);
  var diff = (0,getUTCISOWeek/* default */.Z)(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekParser.js
function ISOWeekParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // ISO week of year

class ISOWeekParser extends Parser {
  constructor() {
    super(...arguments);

    ISOWeekParser_defineProperty(this, "priority", 100);

    ISOWeekParser_defineProperty(this, "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 'I':
        return parseNumericPattern(numericPatterns.week, dateString);

      case 'Io':
        return match.ordinalNumber(dateString, {
          unit: 'week'
        });

      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 53;
  }

  set(date, _flags, value) {
    return (0,startOfUTCISOWeek/* default */.Z)(setUTCISOWeek(date, value));
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/DateParser.js
function DateParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Day of the month

class DateParser extends Parser {
  constructor() {
    super(...arguments);

    DateParser_defineProperty(this, "priority", 90);

    DateParser_defineProperty(this, "subPriority", 1);

    DateParser_defineProperty(this, "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 'd':
        return parseNumericPattern(numericPatterns.date, dateString);

      case 'do':
        return match.ordinalNumber(dateString, {
          unit: 'date'
        });

      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(date, value) {
    var year = date.getUTCFullYear();
    var isLeapYear = isLeapYearIndex(year);
    var month = date.getUTCMonth();

    if (isLeapYear) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
  }

  set(date, _flags, value) {
    date.setUTCDate(value);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/DayOfYearParser.js
function DayOfYearParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




class DayOfYearParser extends Parser {
  constructor() {
    super(...arguments);

    DayOfYearParser_defineProperty(this, "priority", 90);

    DayOfYearParser_defineProperty(this, "subpriority", 1);

    DayOfYearParser_defineProperty(this, "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 'D':
      case 'DD':
        return parseNumericPattern(numericPatterns.dayOfYear, dateString);

      case 'Do':
        return match.ordinalNumber(dateString, {
          unit: 'date'
        });

      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(date, value) {
    var year = date.getUTCFullYear();
    var isLeapYear = isLeapYearIndex(year);

    if (isLeapYear) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }

  set(date, _flags, value) {
    date.setUTCMonth(0, value);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(18667);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/setUTCDay/index.js




function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,toDate["default"])(dirtyDate);
  var day = (0,toInteger/* default */.Z)(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/DayParser.js
function DayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 // Day of week

class DayParser extends Parser {
  constructor() {
    super(...arguments);

    DayParser_defineProperty(this, "priority", 90);

    DayParser_defineProperty(this, "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return match.day(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'short',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return match.day(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return match.day(dateString, {
          width: 'short',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return match.day(dateString, {
          width: 'wide',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'short',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = setUTCDay(date, value, options);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/LocalDayParser.js
function LocalDayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Local day of week

class LocalDayParser extends Parser {
  constructor() {
    super(...arguments);

    LocalDayParser_defineProperty(this, "priority", 90);

    LocalDayParser_defineProperty(this, "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
  }

  parse(dateString, token, match, options) {
    var valueCallback = function (value) {
      var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };

    switch (token) {
      // 3
      case 'e':
      case 'ee':
        // 03
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      // 3rd

      case 'eo':
        return mapValue(match.ordinalNumber(dateString, {
          unit: 'day'
        }), valueCallback);
      // Tue

      case 'eee':
        return match.day(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'short',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return match.day(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return match.day(dateString, {
          width: 'short',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return match.day(dateString, {
          width: 'wide',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'short',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = setUTCDay(date, value, options);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneLocalDayParser.js
function StandAloneLocalDayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Stand-alone local day of week

class StandAloneLocalDayParser extends Parser {
  constructor() {
    super(...arguments);

    StandAloneLocalDayParser_defineProperty(this, "priority", 90);

    StandAloneLocalDayParser_defineProperty(this, "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
  }

  parse(dateString, token, match, options) {
    var valueCallback = function (value) {
      var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };

    switch (token) {
      // 3
      case 'c':
      case 'cc':
        // 03
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      // 3rd

      case 'co':
        return mapValue(match.ordinalNumber(dateString, {
          unit: 'day'
        }), valueCallback);
      // Tue

      case 'ccc':
        return match.day(dateString, {
          width: 'abbreviated',
          context: 'standalone'
        }) || match.day(dateString, {
          width: 'short',
          context: 'standalone'
        }) || match.day(dateString, {
          width: 'narrow',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return match.day(dateString, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return match.day(dateString, {
          width: 'short',
          context: 'standalone'
        }) || match.day(dateString, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return match.day(dateString, {
          width: 'wide',
          context: 'standalone'
        }) || match.day(dateString, {
          width: 'abbreviated',
          context: 'standalone'
        }) || match.day(dateString, {
          width: 'short',
          context: 'standalone'
        }) || match.day(dateString, {
          width: 'narrow',
          context: 'standalone'
        });
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = setUTCDay(date, value, options);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/setUTCISODay/index.js



function setUTCISODay(dirtyDate, dirtyDay) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var day = (0,toInteger/* default */.Z)(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = (0,toDate["default"])(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/ISODayParser.js
function ISODayParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // ISO day of week

class ISODayParser extends Parser {
  constructor() {
    super(...arguments);

    ISODayParser_defineProperty(this, "priority", 90);

    ISODayParser_defineProperty(this, "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
  }

  parse(dateString, token, match) {
    var valueCallback = function (value) {
      if (value === 0) {
        return 7;
      }

      return value;
    };

    switch (token) {
      // 2
      case 'i':
      case 'ii':
        // 02
        return parseNDigits(token.length, dateString);
      // 2nd

      case 'io':
        return match.ordinalNumber(dateString, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return mapValue(match.day(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'short',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'narrow',
          context: 'formatting'
        }), valueCallback);
      // T

      case 'iiiii':
        return mapValue(match.day(dateString, {
          width: 'narrow',
          context: 'formatting'
        }), valueCallback);
      // Tu

      case 'iiiiii':
        return mapValue(match.day(dateString, {
          width: 'short',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'narrow',
          context: 'formatting'
        }), valueCallback);
      // Tuesday

      case 'iiii':
      default:
        return mapValue(match.day(dateString, {
          width: 'wide',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'short',
          context: 'formatting'
        }) || match.day(dateString, {
          width: 'narrow',
          context: 'formatting'
        }), valueCallback);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 7;
  }

  set(date, _flags, value) {
    date = setUTCISODay(date, value);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/AMPMParser.js
function AMPMParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



class AMPMParser extends Parser {
  constructor() {
    super(...arguments);

    AMPMParser_defineProperty(this, "priority", 80);

    AMPMParser_defineProperty(this, "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return match.dayPeriod(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.dayPeriod(dateString, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaaa':
        return match.dayPeriod(dateString, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return match.dayPeriod(dateString, {
          width: 'wide',
          context: 'formatting'
        }) || match.dayPeriod(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.dayPeriod(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
    }
  }

  set(date, _flags, value) {
    date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/AMPMMidnightParser.js
function AMPMMidnightParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



class AMPMMidnightParser extends Parser {
  constructor() {
    super(...arguments);

    AMPMMidnightParser_defineProperty(this, "priority", 80);

    AMPMMidnightParser_defineProperty(this, "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 'b':
      case 'bb':
      case 'bbb':
        return match.dayPeriod(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.dayPeriod(dateString, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbbb':
        return match.dayPeriod(dateString, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return match.dayPeriod(dateString, {
          width: 'wide',
          context: 'formatting'
        }) || match.dayPeriod(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.dayPeriod(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
    }
  }

  set(date, _flags, value) {
    date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/DayPeriodParser.js
function DayPeriodParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 // in the morning, in the afternoon, in the evening, at night

class DayPeriodParser extends Parser {
  constructor() {
    super(...arguments);

    DayPeriodParser_defineProperty(this, "priority", 80);

    DayPeriodParser_defineProperty(this, "incompatibleTokens", ['a', 'b', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return match.dayPeriod(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.dayPeriod(dateString, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBBB':
        return match.dayPeriod(dateString, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return match.dayPeriod(dateString, {
          width: 'wide',
          context: 'formatting'
        }) || match.dayPeriod(dateString, {
          width: 'abbreviated',
          context: 'formatting'
        }) || match.dayPeriod(dateString, {
          width: 'narrow',
          context: 'formatting'
        });
    }
  }

  set(date, _flags, value) {
    date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/Hour1to12Parser.js
function Hour1to12Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




class Hour1to12Parser extends Parser {
  constructor() {
    super(...arguments);

    Hour1to12Parser_defineProperty(this, "priority", 70);

    Hour1to12Parser_defineProperty(this, "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 'h':
        return parseNumericPattern(numericPatterns.hour12h, dateString);

      case 'ho':
        return match.ordinalNumber(dateString, {
          unit: 'hour'
        });

      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 12;
  }

  set(date, _flags, value) {
    var isPM = date.getUTCHours() >= 12;

    if (isPM && value < 12) {
      date.setUTCHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date.setUTCHours(0, 0, 0, 0);
    } else {
      date.setUTCHours(value, 0, 0, 0);
    }

    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/Hour0to23Parser.js
function Hour0to23Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




class Hour0to23Parser extends Parser {
  constructor() {
    super(...arguments);

    Hour0to23Parser_defineProperty(this, "priority", 70);

    Hour0to23Parser_defineProperty(this, "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 'H':
        return parseNumericPattern(numericPatterns.hour23h, dateString);

      case 'Ho':
        return match.ordinalNumber(dateString, {
          unit: 'hour'
        });

      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 23;
  }

  set(date, _flags, value) {
    date.setUTCHours(value, 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/Hour0To11Parser.js
function Hour0To11Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




class Hour0To11Parser extends Parser {
  constructor() {
    super(...arguments);

    Hour0To11Parser_defineProperty(this, "priority", 70);

    Hour0To11Parser_defineProperty(this, "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 'K':
        return parseNumericPattern(numericPatterns.hour11h, dateString);

      case 'Ko':
        return match.ordinalNumber(dateString, {
          unit: 'hour'
        });

      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    var isPM = date.getUTCHours() >= 12;

    if (isPM && value < 12) {
      date.setUTCHours(value + 12, 0, 0, 0);
    } else {
      date.setUTCHours(value, 0, 0, 0);
    }

    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/Hour1To24Parser.js
function Hour1To24Parser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




class Hour1To24Parser extends Parser {
  constructor() {
    super(...arguments);

    Hour1To24Parser_defineProperty(this, "priority", 70);

    Hour1To24Parser_defineProperty(this, "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 'k':
        return parseNumericPattern(numericPatterns.hour24h, dateString);

      case 'ko':
        return match.ordinalNumber(dateString, {
          unit: 'hour'
        });

      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 24;
  }

  set(date, _flags, value) {
    var hours = value <= 24 ? value % 24 : value;
    date.setUTCHours(hours, 0, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/MinuteParser.js
function MinuteParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




class MinuteParser extends Parser {
  constructor() {
    super(...arguments);

    MinuteParser_defineProperty(this, "priority", 60);

    MinuteParser_defineProperty(this, "incompatibleTokens", ['t', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 'm':
        return parseNumericPattern(numericPatterns.minute, dateString);

      case 'mo':
        return match.ordinalNumber(dateString, {
          unit: 'minute'
        });

      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 59;
  }

  set(date, _flags, value) {
    date.setUTCMinutes(value, 0, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/SecondParser.js
function SecondParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




class SecondParser extends Parser {
  constructor() {
    super(...arguments);

    SecondParser_defineProperty(this, "priority", 50);

    SecondParser_defineProperty(this, "incompatibleTokens", ['t', 'T']);
  }

  parse(dateString, token, match) {
    switch (token) {
      case 's':
        return parseNumericPattern(numericPatterns.second, dateString);

      case 'so':
        return match.ordinalNumber(dateString, {
          unit: 'second'
        });

      default:
        return parseNDigits(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 59;
  }

  set(date, _flags, value) {
    date.setUTCSeconds(value, 0);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/FractionOfSecondParser.js
function FractionOfSecondParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



class FractionOfSecondParser extends Parser {
  constructor() {
    super(...arguments);

    FractionOfSecondParser_defineProperty(this, "priority", 30);

    FractionOfSecondParser_defineProperty(this, "incompatibleTokens", ['t', 'T']);
  }

  parse(dateString, token) {
    var valueCallback = function (value) {
      return Math.floor(value * Math.pow(10, -token.length + 3));
    };

    return mapValue(parseNDigits(token.length, dateString), valueCallback);
  }

  set(date, _flags, value) {
    date.setUTCMilliseconds(value);
    return date;
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneWithZParser.js
function ISOTimezoneWithZParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Timezone (ISO-8601. +00:00 is `'Z'`)

class ISOTimezoneWithZParser extends Parser {
  constructor() {
    super(...arguments);

    ISOTimezoneWithZParser_defineProperty(this, "priority", 10);

    ISOTimezoneWithZParser_defineProperty(this, "incompatibleTokens", ['t', 'T', 'x']);
  }

  parse(dateString, token) {
    switch (token) {
      case 'X':
        return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

      case 'XX':
        return parseTimezonePattern(timezonePatterns.basic, dateString);

      case 'XXXX':
        return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

      case 'XXXXX':
        return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

      case 'XXX':
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }

  set(date, flags, value) {
    if (flags.timestampIsSet) {
      return date;
    }

    return new Date(date.getTime() - value);
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneParser.js
function ISOTimezoneParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // Timezone (ISO-8601)

class ISOTimezoneParser extends Parser {
  constructor() {
    super(...arguments);

    ISOTimezoneParser_defineProperty(this, "priority", 10);

    ISOTimezoneParser_defineProperty(this, "incompatibleTokens", ['t', 'T', 'X']);
  }

  parse(dateString, token) {
    switch (token) {
      case 'x':
        return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

      case 'xx':
        return parseTimezonePattern(timezonePatterns.basic, dateString);

      case 'xxxx':
        return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

      case 'xxxxx':
        return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

      case 'xxx':
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }

  set(date, flags, value) {
    if (flags.timestampIsSet) {
      return date;
    }

    return new Date(date.getTime() - value);
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/TimestampSecondsParser.js
function TimestampSecondsParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



class TimestampSecondsParser extends Parser {
  constructor() {
    super(...arguments);

    TimestampSecondsParser_defineProperty(this, "priority", 40);

    TimestampSecondsParser_defineProperty(this, "incompatibleTokens", '*');
  }

  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }

  set(_date, _flags, value) {
    return [new Date(value * 1000), {
      timestampIsSet: true
    }];
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/TimestampMillisecondsParser.js
function TimestampMillisecondsParser_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



class TimestampMillisecondsParser extends Parser {
  constructor() {
    super(...arguments);

    TimestampMillisecondsParser_defineProperty(this, "priority", 20);

    TimestampMillisecondsParser_defineProperty(this, "incompatibleTokens", '*');
  }

  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }

  set(_date, _flags, value) {
    return [new Date(value), {
      timestampIsSet: true
    }];
  }

}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/index.js































/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */

var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/index.js











 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  (0,requiredArgs/* default */.Z)(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return (0,toDate["default"])(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter in longFormatters/* default */.Z) {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  var _loop = function (_token) {
    if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(_token)) {
      (0,protectedTokens/* throwProtectedError */.qp)(_token, formatString, dirtyDateString);
    }

    if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(_token)) {
      (0,protectedTokens/* throwProtectedError */.qp)(_token, formatString, dirtyDateString);
    }

    var firstCharacter = _token[0];
    var parser = parsers[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = usedTokens.find(function (usedToken) {
          return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
        });

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(_token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
        throw new RangeError("The format string mustn't contain `".concat(_token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: _token
      });
      var parseResult = parser.run(dateString, _token, locale.match, subFnOptions);

      if (!parseResult) {
        token = _token;
        return {
          v: new Date(NaN)
        };
      }

      setters.push(parseResult.setter);
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (_token === "''") {
        _token = "'";
      } else if (firstCharacter === "'") {
        _token = cleanEscapedString(_token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(_token) === 0) {
        dateString = dateString.slice(_token.length);
      } else {
        token = _token;
        return {
          v: new Date(NaN)
        };
      }
    }

    token = _token;
  };

  for (var token of tokens) {
    var _ret = _loop(token);

    if (typeof _ret === "object") return _ret.v;
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = (0,toDate["default"])(dirtyReferenceDate);

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.


  var utcDate = (0,subMilliseconds/* default */.Z)(date, (0,getTimezoneOffsetInMilliseconds/* default */.Z)(date));
  var flags = {};

  for (var setter of uniquePrioritySetters) {
    if (!setter.validate(utcDate, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, subFnOptions); // Result is tuple (date, flags)

    if (Array.isArray(result)) {
      utcDate = result[0];
      assign_assign(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 31807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ parseISO; }
/* harmony export */ });
/* harmony import */ var _constants_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64312);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, options) {
  var _options$additionalDi;

  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var additionalDigits = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInMinute */ .yJ + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInMinute */ .yJ);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),

/***/ 63673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setHours; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var hours = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyHours);
  date.setHours(hours);
  return date;
}

/***/ }),

/***/ 99791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setMinutes; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var minutes = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/***/ }),

/***/ 22110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ setMonth; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(42765);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/getDaysInMonth/index.js


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/setMonth/index.js




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate["default"])(dirtyDate);
  var month = (0,toInteger/* default */.Z)(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/***/ }),

/***/ 89968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setQuarter; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _setMonth_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22110);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);




/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */

function setQuarter(dirtyDate, dirtyQuarter) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var quarter = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return (0,_setMonth_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(date, date.getMonth() + diff * 3);
}

/***/ }),

/***/ 8868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setSeconds; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var seconds = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/***/ }),

/***/ 42019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ setYear; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var year = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

/***/ }),

/***/ 10405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 12414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 73116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfQuarter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */

function startOfQuarter(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 49122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66700);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18667);




/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 81290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var cleanDate = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 96913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subDays; }
/* harmony export */ });
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63761);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 75887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subHours; }
/* harmony export */ });
/* harmony import */ var _addHours_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20578);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);



/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */

function subHours(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addHours_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 7610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ subMilliseconds; }
/* harmony export */ });
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91310);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, -amount);
}

/***/ }),

/***/ 50272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subMinutes; }
/* harmony export */ });
/* harmony import */ var _addMinutes_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23107);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);



/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */

function subMinutes(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMinutes_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 94873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subMonths; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);
/* harmony import */ var _addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28187);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMonths_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 65032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subWeeks; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);
/* harmony import */ var _addWeeks_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85014);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */

function subWeeks(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addWeeks_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 46318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subYears; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);
/* harmony import */ var _addYears_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52946);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addYears_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 66700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 93636:
/***/ (function(module) {

"use strict";


module.exports = direction

var RTL = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC'
var LTR =
  'A-Za-z\u00C0-\u00D6\u00D8-\u00F6' +
  '\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C' +
  '\uFE00-\uFE6F\uFEFD-\uFFFF'

var rtl = new RegExp('^[^' + LTR + ']*[' + RTL + ']')
var ltr = new RegExp('^[^' + RTL + ']*[' + LTR + ']')

function direction(value) {
  value = String(value || '')

  if (rtl.test(value)) {
    return 'rtl'
  }

  if (ltr.test(value)) {
    return 'ltr'
  }

  return 'neutral'
}


/***/ }),

/***/ 27843:
/***/ (function(module) {

!function(t,n){ true?module.exports=function(t,n,e,i,o){for(n=n.split?n.split("."):n,i=0;i<n.length;i++)t=t?t[n[i]]:o;return t===o?e:t}:0}(this);
//# sourceMappingURL=dlv.umd.js.map


/***/ }),

/***/ 85978:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),

/***/ 17570:
/***/ (function(module) {

"use strict";


/**
 * Used to mark a
 * [React Native `File` substitute]{@link ReactNativeFileSubstitute}
 * in an object tree for [`extractFiles`]{@link extractFiles}. It’s too risky to
 * assume all objects with `uri`, `type` and `name` properties are files to
 * extract.
 * @kind class
 * @name ReactNativeFile
 * @param {ReactNativeFileSubstitute} file A [React Native](https://reactnative.dev) [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File) substitute.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { ReactNativeFile } from 'extract-files';
 * ```
 *
 * ```js
 * import ReactNativeFile from 'extract-files/public/ReactNativeFile.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { ReactNativeFile } = require('extract-files');
 * ```
 *
 * ```js
 * const ReactNativeFile = require('extract-files/public/ReactNativeFile.js');
 * ```
 * @example <caption>An extractable file in [React Native](https://reactnative.dev).</caption>
 * ```js
 * const file = new ReactNativeFile({
 *   uri: uriFromCameraRoll,
 *   name: 'a.jpg',
 *   type: 'image/jpeg',
 * });
 * ```
 */
module.exports = class ReactNativeFile {
  constructor({ uri, name, type }) {
    this.uri = uri;
    this.name = name;
    this.type = type;
  }
};


/***/ }),

/***/ 42929:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const defaultIsExtractableFile = __webpack_require__(21278);

/**
 * Clones a value, recursively extracting
 * [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File),
 * [`Blob`](https://developer.mozilla.org/en-US/docs/Web/API/Blob) and
 * [`ReactNativeFile`]{@link ReactNativeFile} instances with their
 * [object paths]{@link ObjectPath}, replacing them with `null`.
 * [`FileList`](https://developer.mozilla.org/en-US/docs/Web/API/Filelist) instances
 * are treated as [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File)
 * instance arrays.
 * @kind function
 * @name extractFiles
 * @param {*} value Value (typically an object tree) to extract files from.
 * @param {ObjectPath} [path=''] Prefix for object paths for extracted files.
 * @param {ExtractableFileMatcher} [isExtractableFile=isExtractableFile] The function used to identify extractable files.
 * @returns {ExtractFilesResult} Result.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { extractFiles } from 'extract-files';
 * ```
 *
 * ```js
 * import extractFiles from 'extract-files/public/extractFiles.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { extractFiles } = require('extract-files');
 * ```
 *
 * ```js
 * const extractFiles = require('extract-files/public/extractFiles.js');
 * ```
 * @example <caption>Extract files from an object.</caption>
 * For the following:
 *
 * ```js
 * const file1 = new File(['1'], '1.txt', { type: 'text/plain' });
 * const file2 = new File(['2'], '2.txt', { type: 'text/plain' });
 * const value = {
 *   a: file1,
 *   b: [file1, file2],
 * };
 *
 * const { clone, files } = extractFiles(value, 'prefix');
 * ```
 *
 * `value` remains the same.
 *
 * `clone` is:
 *
 * ```json
 * {
 *   "a": null,
 *   "b": [null, null]
 * }
 * ```
 *
 * `files` is a [`Map`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map) instance containing:
 *
 * | Key     | Value                        |
 * | :------ | :--------------------------- |
 * | `file1` | `['prefix.a', 'prefix.b.0']` |
 * | `file2` | `['prefix.b.1']`             |
 */
module.exports = function extractFiles(
  value,
  path = '',
  isExtractableFile = defaultIsExtractableFile
) {
  // Map of extracted files and their object paths within the input value.
  const files = new Map();

  // Map of arrays and objects recursed within the input value and their clones,
  // for reusing clones of values that are referenced multiple times within the
  // input value.
  const clones = new Map();

  /**
   * Recursively clones the value, extracting files.
   * @kind function
   * @name extractFiles~recurse
   * @param {*} value Value to extract files from.
   * @param {ObjectPath} path Prefix for object paths for extracted files.
   * @param {Set} recursed Recursed arrays and objects for avoiding infinite recursion of circular references within the input value.
   * @returns {*} Clone of the value with files replaced with `null`.
   * @ignore
   */
  function recurse(value, path, recursed) {
    let clone = value;

    if (isExtractableFile(value)) {
      clone = null;

      const filePaths = files.get(value);

      filePaths ? filePaths.push(path) : files.set(value, [path]);
    } else {
      const isList =
        Array.isArray(value) ||
        (typeof FileList !== 'undefined' && value instanceof FileList);
      const isObject = value && value.constructor === Object;

      if (isList || isObject) {
        const hasClone = clones.has(value);

        if (hasClone) clone = clones.get(value);
        else {
          clone = isList ? [] : {};

          clones.set(value, clone);
        }

        if (!recursed.has(value)) {
          const pathPrefix = path ? `${path}.` : '';
          const recursedDeeper = new Set(recursed).add(value);

          if (isList) {
            let index = 0;

            for (const item of value) {
              const itemClone = recurse(
                item,
                pathPrefix + index++,
                recursedDeeper
              );

              if (!hasClone) clone.push(itemClone);
            }
          } else
            for (const key in value) {
              const propertyClone = recurse(
                value[key],
                pathPrefix + key,
                recursedDeeper
              );

              if (!hasClone) clone[key] = propertyClone;
            }
        }
      }
    }

    return clone;
  }

  return {
    clone: recurse(value, path, new Set()),
    files,
  };
};


/***/ }),

/***/ 21278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const ReactNativeFile = __webpack_require__(17570);

/**
 * Checks if a value is an [extractable file]{@link ExtractableFile}.
 * @kind function
 * @name isExtractableFile
 * @type {ExtractableFileMatcher}
 * @param {*} value Value to check.
 * @returns {boolean} Is the value an [extractable file]{@link ExtractableFile}.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { isExtractableFile } from 'extract-files';
 * ```
 *
 * ```js
 * import isExtractableFile from 'extract-files/public/isExtractableFile.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { isExtractableFile } = require('extract-files');
 * ```
 *
 * ```js
 * const isExtractableFile = require('extract-files/public/isExtractableFile.js');
 * ```
 */
module.exports = function isExtractableFile(value) {
  return (
    (typeof File !== 'undefined' && value instanceof File) ||
    (typeof Blob !== 'undefined' && value instanceof Blob) ||
    value instanceof ReactNativeFile
  );
};


/***/ }),

/***/ 69378:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 60138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J9": function() { return /* binding */ disableExperimentalFragmentVariables; },
  "_t": function() { return /* binding */ disableFragmentWarnings; },
  "wO": function() { return /* binding */ enableExperimentalFragmentVariables; },
  "Ps": function() { return /* binding */ gql; },
  "HW": function() { return /* binding */ resetCaches; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
;// CONCATENATED MODULE: ../../node_modules/graphql/jsutils/isObjectLike.mjs
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

;// CONCATENATED MODULE: ../../node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/location.mjs

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/printLocation.mjs


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

;// CONCATENATED MODULE: ../../node_modules/graphql/error/GraphQLError.mjs




function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}

;// CONCATENATED MODULE: ../../node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

// EXTERNAL MODULE: ../../node_modules/graphql/language/ast.mjs
var ast = __webpack_require__(90781);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));


/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

// EXTERNAL MODULE: ../../node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(95115);
// EXTERNAL MODULE: ../../node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(85717);
// EXTERNAL MODULE: ../../node_modules/graphql/language/characterClasses.mjs
var characterClasses = __webpack_require__(51591);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(tokenKind_TokenKind || (tokenKind_TokenKind = {}));


/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ../../node_modules/graphql/language/lexer.mjs





/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === tokenKind_TokenKind.BANG ||
    kind === tokenKind_TokenKind.DOLLAR ||
    kind === tokenKind_TokenKind.AMP ||
    kind === tokenKind_TokenKind.PAREN_L ||
    kind === tokenKind_TokenKind.PAREN_R ||
    kind === tokenKind_TokenKind.SPREAD ||
    kind === tokenKind_TokenKind.COLON ||
    kind === tokenKind_TokenKind.EQUALS ||
    kind === tokenKind_TokenKind.AT ||
    kind === tokenKind_TokenKind.BRACKET_L ||
    kind === tokenKind_TokenKind.BRACKET_R ||
    kind === tokenKind_TokenKind.BRACE_L ||
    kind === tokenKind_TokenKind.PIPE ||
    kind === tokenKind_TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return tokenKind_TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new ast/* Token */.WU(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, tokenKind_TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, tokenKind_TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, tokenKind_TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, tokenKind_TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, tokenKind_TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, tokenKind_TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, tokenKind_TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, tokenKind_TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, tokenKind_TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, tokenKind_TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, tokenKind_TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, tokenKind_TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, tokenKind_TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, tokenKind_TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if ((0,characterClasses/* isDigit */.X1)(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if ((0,characterClasses/* isNameStart */.LQ)(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, tokenKind_TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if ((0,characterClasses/* isDigit */.X1)(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || (0,characterClasses/* isNameStart */.LQ)(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!(0,characterClasses/* isDigit */.X1)(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while ((0,characterClasses/* isDigit */.X1)(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, tokenKind_TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        tokenKind_TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        (0,blockString/* dedentBlockStringLines */.wv)(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if ((0,characterClasses/* isNameContinue */.HQ)(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

// EXTERNAL MODULE: ../../node_modules/graphql/language/source.mjs + 1 modules
var language_source = __webpack_require__(22744);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options = {}) {
    const sourceObj = (0,language_source/* isSource */.T)(source) ? source : new language_source/* Source */.H(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
    this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(tokenKind_TokenKind.NAME);
    return this.node(token, {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(
        tokenKind_TokenKind.SOF,
        this.parseDefinition,
        tokenKind_TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: ast/* OperationTypeNode.QUERY */.ku.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return ast/* OperationTypeNode.QUERY */.ku.QUERY;

      case 'mutation':
        return ast/* OperationTypeNode.MUTATION */.ku.MUTATION;

      case 'subscription':
        return ast/* OperationTypeNode.SUBSCRIPTION */.ku.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseVariableDefinition,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return this.node(start, {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(
        tokenKind_TokenKind.BRACE_L,
        this.parseSelection,
        tokenKind_TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
        });

      case tokenKind_TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
        });

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: kinds/* Kind.NULL */.h.NULL,
            });

          default:
            return this.node(token, {
              kind: kinds/* Kind.ENUM */.h.ENUM,
              value: token.value,
            });
        }

      case tokenKind_TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(tokenKind_TokenKind.DOLLAR);

          if (this._lexer.token.kind === tokenKind_TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return this.node(start, {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseFieldDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
      ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new ast/* Location */.Ye(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (maxTokens !== undefined && token.kind !== tokenKind_TokenKind.EOF) {
      ++this._tokenCounter;

      if (this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}

;// CONCATENATED MODULE: ../../node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = ((/* unused pure expression or super */ null && (gql)));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 73463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(73887);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 43459:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 73887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(43459);
} else {}


/***/ }),

/***/ 87202:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

/**
 * Constants.
 */

var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);

var MODIFIERS = {
  alt: 'altKey',
  control: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};

var ALIASES = {
  add: '+',
  break: 'pause',
  cmd: 'meta',
  command: 'meta',
  ctl: 'control',
  ctrl: 'control',
  del: 'delete',
  down: 'arrowdown',
  esc: 'escape',
  ins: 'insert',
  left: 'arrowleft',
  mod: IS_MAC ? 'meta' : 'control',
  opt: 'alt',
  option: 'alt',
  return: 'enter',
  right: 'arrowright',
  space: ' ',
  spacebar: ' ',
  up: 'arrowup',
  win: 'meta',
  windows: 'meta'
};

var CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  ' ': 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  '\'': 222
};

for (var f = 1; f < 20; f++) {
  CODES['f' + f] = 111 + f;
}

/**
 * Is hotkey?
 */

function isHotkey(hotkey, options, event) {
  if (options && !('byKey' in options)) {
    event = options;
    options = null;
  }

  if (!Array.isArray(hotkey)) {
    hotkey = [hotkey];
  }

  var array = hotkey.map(function (string) {
    return parseHotkey(string, options);
  });
  var check = function check(e) {
    return array.some(function (object) {
      return compareHotkey(object, e);
    });
  };
  var ret = event == null ? check : check(event);
  return ret;
}

function isCodeHotkey(hotkey, event) {
  return isHotkey(hotkey, event);
}

function isKeyHotkey(hotkey, event) {
  return isHotkey(hotkey, { byKey: true }, event);
}

/**
 * Parse.
 */

function parseHotkey(hotkey, options) {
  var byKey = options && options.byKey;
  var ret = {};

  // Special case to handle the `+` key since we use it as a separator.
  hotkey = hotkey.replace('++', '+add');
  var values = hotkey.split('+');
  var length = values.length;

  // Ensure that all the modifiers are set to false unless the hotkey has them.

  for (var k in MODIFIERS) {
    ret[MODIFIERS[k]] = false;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;

      var optional = value.endsWith('?') && value.length > 1;

      if (optional) {
        value = value.slice(0, -1);
      }

      var name = toKeyName(value);
      var modifier = MODIFIERS[name];

      if (value.length > 1 && !modifier && !ALIASES[value] && !CODES[name]) {
        throw new TypeError('Unknown modifier: "' + value + '"');
      }

      if (length === 1 || !modifier) {
        if (byKey) {
          ret.key = name;
        } else {
          ret.which = toKeyCode(value);
        }
      }

      if (modifier) {
        ret[modifier] = optional ? null : true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
}

/**
 * Compare.
 */

function compareHotkey(object, event) {
  for (var key in object) {
    var expected = object[key];
    var actual = void 0;

    if (expected == null) {
      continue;
    }

    if (key === 'key' && event.key != null) {
      actual = event.key.toLowerCase();
    } else if (key === 'which') {
      actual = expected === 91 && event.which === 93 ? 91 : event.which;
    } else {
      actual = event[key];
    }

    if (actual == null && expected === false) {
      continue;
    }

    if (actual !== expected) {
      return false;
    }
  }

  return true;
}

/**
 * Utils.
 */

function toKeyCode(name) {
  name = toKeyName(name);
  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
  return code;
}

function toKeyName(name) {
  name = name.toLowerCase();
  name = ALIASES[name] || name;
  return name;
}

/**
 * Export.
 */

__webpack_unused_export__ = isHotkey;
__webpack_unused_export__ = isHotkey;
__webpack_unused_export__ = isCodeHotkey;
exports.TB = isKeyHotkey;
__webpack_unused_export__ = parseHotkey;
__webpack_unused_export__ = compareHotkey;
__webpack_unused_export__ = toKeyCode;
__webpack_unused_export__ = toKeyName;

/***/ }),

/***/ 39515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 89612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(52118),
    hashDelete = __webpack_require__(96909),
    hashGet = __webpack_require__(98138),
    hashHas = __webpack_require__(4174),
    hashSet = __webpack_require__(7942);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 80235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(3945),
    listCacheDelete = __webpack_require__(21846),
    listCacheGet = __webpack_require__(88028),
    listCacheHas = __webpack_require__(72344),
    listCacheSet = __webpack_require__(94769);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 10326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 96738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(92411),
    mapCacheDelete = __webpack_require__(36417),
    mapCacheGet = __webpack_require__(86928),
    mapCacheHas = __webpack_require__(79493),
    mapCacheSet = __webpack_require__(24150);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 52760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 2143:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 45386:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(96738),
    setCacheAdd = __webpack_require__(52842),
    setCacheHas = __webpack_require__(52482);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 86571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80235),
    stackClear = __webpack_require__(15243),
    stackDelete = __webpack_require__(72858),
    stackGet = __webpack_require__(4417),
    stackHas = __webpack_require__(8605),
    stackSet = __webpack_require__(71418);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 50857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 79162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 93215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761),
    root = __webpack_require__(37772);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 49432:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 72517:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 67552:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 1634:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(36473),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152),
    isBuffer = __webpack_require__(73226),
    isIndex = __webpack_require__(39045),
    isTypedArray = __webpack_require__(77598);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 50343:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 65067:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 87064:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 28582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(13940),
    eq = __webpack_require__(41225);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 60091:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(13940),
    eq = __webpack_require__(41225);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 22218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(41225);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 67993:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(752),
    keys = __webpack_require__(90249);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 55906:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(752),
    keysIn = __webpack_require__(18582);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 13940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(83043);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 18874:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(86571),
    arrayEach = __webpack_require__(72517),
    assignValue = __webpack_require__(60091),
    baseAssign = __webpack_require__(67993),
    baseAssignIn = __webpack_require__(55906),
    cloneBuffer = __webpack_require__(92175),
    copyArray = __webpack_require__(51522),
    copySymbols = __webpack_require__(7680),
    copySymbolsIn = __webpack_require__(19987),
    getAllKeys = __webpack_require__(13483),
    getAllKeysIn = __webpack_require__(76939),
    getTag = __webpack_require__(70940),
    initCloneArray = __webpack_require__(99917),
    initCloneByTag = __webpack_require__(8222),
    initCloneObject = __webpack_require__(78725),
    isArray = __webpack_require__(86152),
    isBuffer = __webpack_require__(73226),
    isMap = __webpack_require__(4714),
    isObject = __webpack_require__(29259),
    isSet = __webpack_require__(43679),
    keys = __webpack_require__(90249),
    keysIn = __webpack_require__(18582);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 39413:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(29259);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 24303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(26548),
    createBaseEach = __webpack_require__(92019);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 15308:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(55463);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 26548:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(15308),
    keys = __webpack_require__(90249);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 13324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(17297),
    toKey = __webpack_require__(33812);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 1897:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(65067),
    isArray = __webpack_require__(86152);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 53366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    getRawTag = __webpack_require__(62107),
    objectToString = __webpack_require__(37157);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 20187:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 15183:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 88746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(51952),
    isObjectLike = __webpack_require__(15125);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 51952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(86571),
    equalArrays = __webpack_require__(74871),
    equalByTag = __webpack_require__(11491),
    equalObjects = __webpack_require__(17416),
    getTag = __webpack_require__(70940),
    isArray = __webpack_require__(86152),
    isBuffer = __webpack_require__(73226),
    isTypedArray = __webpack_require__(77598);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 74511:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(70940),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 37036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(86571),
    baseIsEqual = __webpack_require__(88746);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 6840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(61049),
    isMasked = __webpack_require__(47394),
    isObject = __webpack_require__(29259),
    toSource = __webpack_require__(87035);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 8109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(70940),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 35522:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isLength = __webpack_require__(61158),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 68286:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(26423),
    baseMatchesProperty = __webpack_require__(74716),
    identity = __webpack_require__(23059),
    isArray = __webpack_require__(86152),
    property = __webpack_require__(65798);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 86411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(16001),
    nativeKeys = __webpack_require__(54248);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 18390:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(29259),
    isPrototype = __webpack_require__(16001),
    nativeKeysIn = __webpack_require__(62966);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 93401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(24303),
    isArrayLike = __webpack_require__(67878);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 26423:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(37036),
    getMatchData = __webpack_require__(49882),
    matchesStrictComparable = __webpack_require__(73477);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 74716:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(88746),
    get = __webpack_require__(72579),
    hasIn = __webpack_require__(95041),
    isKey = __webpack_require__(21401),
    isStrictComparable = __webpack_require__(28792),
    matchesStrictComparable = __webpack_require__(73477),
    toKey = __webpack_require__(33812);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 84565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(86571),
    assignMergeValue = __webpack_require__(28582),
    baseFor = __webpack_require__(15308),
    baseMergeDeep = __webpack_require__(25561),
    isObject = __webpack_require__(29259),
    keysIn = __webpack_require__(18582),
    safeGet = __webpack_require__(52434);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 25561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(28582),
    cloneBuffer = __webpack_require__(92175),
    cloneTypedArray = __webpack_require__(6190),
    copyArray = __webpack_require__(51522),
    initCloneObject = __webpack_require__(78725),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152),
    isArrayLikeObject = __webpack_require__(93746),
    isBuffer = __webpack_require__(73226),
    isFunction = __webpack_require__(61049),
    isObject = __webpack_require__(29259),
    isPlainObject = __webpack_require__(97030),
    isTypedArray = __webpack_require__(77598),
    safeGet = __webpack_require__(52434),
    toPlainObject = __webpack_require__(63329);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 20256:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 82952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(13324);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 36060:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(23059),
    overRest = __webpack_require__(43114),
    setToString = __webpack_require__(75251);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 86532:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(86874),
    defineProperty = __webpack_require__(83043),
    identity = __webpack_require__(23059);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 36473:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 1054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    arrayMap = __webpack_require__(50343),
    isArray = __webpack_require__(86152),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 47826:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 59950:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 89419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(23059);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 17297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(86152),
    isKey = __webpack_require__(21401),
    stringToPath = __webpack_require__(54452),
    toString = __webpack_require__(66188);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 79882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(79162);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 92175:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(37772);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 34727:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(79882);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 96058:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 70169:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 6190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(79882);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 51522:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(60091),
    baseAssignValue = __webpack_require__(13940);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 7680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(752),
    getSymbols = __webpack_require__(80633);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 19987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(752),
    getSymbolsIn = __webpack_require__(12680);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 24019:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 97263:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(36060),
    isIterateeCall = __webpack_require__(82406);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 92019:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(67878);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 55463:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 83043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 74871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(45386),
    arraySome = __webpack_require__(87064),
    cacheHas = __webpack_require__(59950);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 11491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857),
    Uint8Array = __webpack_require__(79162),
    eq = __webpack_require__(41225),
    equalArrays = __webpack_require__(74871),
    mapToArray = __webpack_require__(75179),
    setToArray = __webpack_require__(16909);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 17416:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(13483);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 51242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 13483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1897),
    getSymbols = __webpack_require__(80633),
    keys = __webpack_require__(90249);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 76939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1897),
    getSymbolsIn = __webpack_require__(12680),
    keysIn = __webpack_require__(18582);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 27937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(98304);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 49882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(28792),
    keys = __webpack_require__(90249);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 38761:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(6840),
    getValue = __webpack_require__(98109);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 47353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(60241);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 62107:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(50857);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 80633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(67552),
    stubArray = __webpack_require__(30981);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 12680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(65067),
    getPrototype = __webpack_require__(47353),
    getSymbols = __webpack_require__(80633),
    stubArray = __webpack_require__(30981);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 70940:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(39515),
    Map = __webpack_require__(10326),
    Promise = __webpack_require__(52760),
    Set = __webpack_require__(2143),
    WeakMap = __webpack_require__(93215),
    baseGetTag = __webpack_require__(53366),
    toSource = __webpack_require__(87035);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 98109:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 1369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(17297),
    isArguments = __webpack_require__(79631),
    isArray = __webpack_require__(86152),
    isIndex = __webpack_require__(39045),
    isLength = __webpack_require__(61158),
    toKey = __webpack_require__(33812);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 52118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 96909:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 98138:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 4174:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 7942:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(99191);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 99917:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 8222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(79882),
    cloneDataView = __webpack_require__(34727),
    cloneRegExp = __webpack_require__(96058),
    cloneSymbol = __webpack_require__(70169),
    cloneTypedArray = __webpack_require__(6190);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 78725:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(39413),
    getPrototype = __webpack_require__(47353),
    isPrototype = __webpack_require__(16001);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 39045:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 82406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(41225),
    isArrayLike = __webpack_require__(67878),
    isIndex = __webpack_require__(39045),
    isObject = __webpack_require__(29259);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 21401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(86152),
    isSymbol = __webpack_require__(4795);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 98304:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 47394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(24019);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 16001:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 28792:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(29259);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 3945:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 21846:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 88028:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 72344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 94769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(22218);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 92411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(89612),
    ListCache = __webpack_require__(80235),
    Map = __webpack_require__(10326);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 36417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 86928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 79493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 24150:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(27937);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 75179:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 73477:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 77777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(30733);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 99191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(38761);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 54248:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(60241);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 62966:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 4146:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(51242);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 37157:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 60241:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 43114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(49432);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 37772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(51242);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 52434:
/***/ (function(module) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 52842:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 52482:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 16909:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 75251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(86532),
    shortOut = __webpack_require__(97787);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 97787:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 15243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80235);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 72858:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 4417:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 8605:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 71418:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(80235),
    Map = __webpack_require__(10326),
    MapCache = __webpack_require__(96738);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 54452:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(77777);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 33812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 87035:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 9850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(18874);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ 86874:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 54073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(29259),
    now = __webpack_require__(61100),
    toNumber = __webpack_require__(7642);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 79421:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(59756);


/***/ }),

/***/ 41225:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 59756:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(72517),
    baseEach = __webpack_require__(24303),
    castFunction = __webpack_require__(89419),
    isArray = __webpack_require__(86152);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 15253:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(26548),
    castFunction = __webpack_require__(89419);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),

/***/ 72579:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(13324);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 95041:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(20187),
    hasPath = __webpack_require__(1369);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 23059:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 79631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(15183),
    isObjectLike = __webpack_require__(15125);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 86152:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 67878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(61049),
    isLength = __webpack_require__(61158);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 93746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(67878),
    isObjectLike = __webpack_require__(15125);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 73226:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(37772),
    stubFalse = __webpack_require__(79207);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 61049:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isObject = __webpack_require__(29259);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 61158:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 4714:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(74511),
    baseUnary = __webpack_require__(47826),
    nodeUtil = __webpack_require__(4146);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 29259:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 15125:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 97030:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    getPrototype = __webpack_require__(47353),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 43679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(8109),
    baseUnary = __webpack_require__(47826),
    nodeUtil = __webpack_require__(4146);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 85505:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isArray = __webpack_require__(86152),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 4795:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 77598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(35522),
    baseUnary = __webpack_require__(47826),
    nodeUtil = __webpack_require__(4146);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 90249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1634),
    baseKeys = __webpack_require__(86411),
    isArrayLike = __webpack_require__(67878);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 18582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1634),
    baseKeysIn = __webpack_require__(18390),
    isArrayLike = __webpack_require__(67878);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 16760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(50343),
    baseIteratee = __webpack_require__(68286),
    baseMap = __webpack_require__(93401),
    isArray = __webpack_require__(86152);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 30733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(96738);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 98537:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(84565),
    createAssigner = __webpack_require__(97263);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 61100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 65798:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(20256),
    basePropertyDeep = __webpack_require__(82952),
    isKey = __webpack_require__(21401),
    toKey = __webpack_require__(33812);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 30981:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 79207:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 12436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(54073),
    isObject = __webpack_require__(29259);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 63329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(752),
    keysIn = __webpack_require__(18582);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 66188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(1054);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 36631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["default"] = (memoizeOne);


/***/ }),

/***/ 80002:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isPlainObject = exports.clone = exports.recursive = exports.merge = exports.main = void 0;
module.exports = exports = main;
exports["default"] = main;
function main() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return merge.apply(void 0, items);
}
exports.main = main;
main.clone = clone;
main.isPlainObject = isPlainObject;
main.recursive = recursive;
function merge() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return _merge(items[0] === true, false, items);
}
exports.merge = merge;
function recursive() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return _merge(items[0] === true, true, items);
}
exports.recursive = recursive;
function clone(input) {
    if (Array.isArray(input)) {
        var output = [];
        for (var index = 0; index < input.length; ++index)
            output.push(clone(input[index]));
        return output;
    }
    else if (isPlainObject(input)) {
        var output = {};
        for (var index in input)
            output[index] = clone(input[index]);
        return output;
    }
    else {
        return input;
    }
}
exports.clone = clone;
function isPlainObject(input) {
    return input && typeof input === 'object' && !Array.isArray(input);
}
exports.isPlainObject = isPlainObject;
function _recursiveMerge(base, extend) {
    if (!isPlainObject(base))
        return extend;
    for (var key in extend) {
        if (key === '__proto__' || key === 'constructor' || key === 'prototype')
            continue;
        base[key] = (isPlainObject(base[key]) && isPlainObject(extend[key])) ?
            _recursiveMerge(base[key], extend[key]) :
            extend[key];
    }
    return base;
}
function _merge(isClone, isRecursive, items) {
    var result;
    if (isClone || !isPlainObject(result = items.shift()))
        result = {};
    for (var index = 0; index < items.length; ++index) {
        var item = items[index];
        if (!isPlainObject(item))
            continue;
        for (var key in item) {
            if (key === '__proto__' || key === 'constructor' || key === 'prototype')
                continue;
            var value = isClone ? clone(item[key]) : item[key];
            result[key] = isRecursive ? _recursiveMerge(result[key], value) : value;
        }
    }
    return result;
}


/***/ }),

/***/ 59775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ createWrapper; },
/* harmony export */   "ju": function() { return /* binding */ HYDRATE; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


/**
 * Quick note on Next.js return types:
 *
 * Page.getInitialProps https://nextjs.org/docs/api-reference/data-fetching/getInitialProps
 * as-is
 *
 * App.getInitialProps: AppInitialProps https://nextjs.org/docs/advanced-features/custom-app
 * {pageProps: any}
 *
 * getStaticProps https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 * {props: any}
 *
 * getServerSideProps https://nextjs.org/docs/basic-features/data-fetching#getserversideprops-server-side-rendering
 * {props: any}
 */
var HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
var getIsServer = function () { return typeof window === 'undefined'; };
var getDeserializedState = function (initialState, _a) {
    var _b = _a === void 0 ? {} : _a, deserializeState = _b.deserializeState;
    return deserializeState ? deserializeState(initialState) : initialState;
};
var getSerializedState = function (state, _a) {
    var _b = _a === void 0 ? {} : _a, serializeState = _b.serializeState;
    return serializeState ? serializeState(state) : state;
};
var store;
var initStore = function (_a) {
    var makeStore = _a.makeStore, context = _a.context;
    var createStore = function () { return makeStore(context); };
    if (getIsServer()) {
        var c = context;
        var req = void 0;
        if (c.req)
            req = c.req;
        if (c.ctx && c.ctx.req)
            req = c.ctx.req;
        if (req) {
            // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
            // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
            if (!req.__nextReduxWrapperStore)
                req.__nextReduxWrapperStore = createStore();
            return req.__nextReduxWrapperStore;
        }
        return createStore();
    }
    // Memoize store if client
    if (!store) {
        store = createStore();
    }
    return store;
};
var createWrapper = function (makeStore, config) {
    if (config === void 0) { config = {}; }
    var makeProps = function (_a) {
        var callback = _a.callback, context = _a.context;
        return __awaiter(void 0, void 0, void 0, function () {
            var store, nextCallback, initialProps, _b, state;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        store = initStore({ context: context, makeStore: makeStore });
                        if (config.debug)
                            console.log("1. getProps created store with state", store.getState());
                        nextCallback = callback && callback(store);
                        _b = nextCallback;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, nextCallback(context)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        initialProps = (_b) || {};
                        if (config.debug)
                            console.log("3. getProps after dispatches has store state", store.getState());
                        state = store.getState();
                        return [2 /*return*/, {
                                initialProps: initialProps,
                                initialState: getIsServer() ? getSerializedState(state, config) : state,
                            }];
                }
            });
        });
    };
    var getInitialPageProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ('getState' in context) {
                return [2 /*return*/, callback && callback(context)];
            }
            return [2 /*return*/, makeProps({ callback: callback, context: context })];
        });
    }); }; };
    var getInitialAppProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { initialState: initialState })];
            }
        });
    }); }; };
    var getStaticProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { props: __assign(__assign({}, initialProps.props), { initialState: initialState }) })];
            }
        });
    }); }; };
    var getServerSideProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getStaticProps(callback)(context)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); }; }; // just not to repeat myself
    var withRedux = function (Component) {
        var _a;
        var displayName = "withRedux(" + (Component.displayName || Component.name || 'Component') + ")";
        var hasInitialProps = 'getInitialProps' in Component;
        //TODO Check if pages/_app was wrapped so there's no need to wrap a page itself
        return _a = /** @class */ (function (_super) {
                __extends(Wrapper, _super);
                function Wrapper(props, context) {
                    var _this = _super.call(this, props, context) || this;
                    _this.store = null;
                    _this.hydrate(props, context);
                    return _this;
                }
                Wrapper.prototype.hydrate = function (_a, context) {
                    var _b;
                    var initialState = _a.initialState, initialProps = _a.initialProps, props = __rest(_a, ["initialState", "initialProps"]);
                    // this happens when App has page with getServerSideProps/getStaticProps, initialState will be dumped twice:
                    // one incomplete and one complete
                    var initialStateFromGSPorGSSR = (_b = props === null || props === void 0 ? void 0 : props.pageProps) === null || _b === void 0 ? void 0 : _b.initialState;
                    if (!this.store) {
                        this.store = initStore({ makeStore: makeStore, context: context });
                        if (config.debug)
                            console.log('4. WrappedApp created new store with', displayName, {
                                initialState: initialState,
                                initialStateFromGSPorGSSR: initialStateFromGSPorGSSR,
                            });
                    }
                    if (initialState)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialState, config),
                        });
                    // ATTENTION! This code assumes that Page's getServerSideProps is executed after App.getInitialProps
                    // so we dispatch in this order
                    if (initialStateFromGSPorGSSR)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialStateFromGSPorGSSR, config),
                        });
                };
                Wrapper.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
                    var _a, _b, _c, _d;
                    if (((_a = nextProps === null || nextProps === void 0 ? void 0 : nextProps.pageProps) === null || _a === void 0 ? void 0 : _a.initialState) !== ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.pageProps) === null || _c === void 0 ? void 0 : _c.initialState) ||
                        (nextProps === null || nextProps === void 0 ? void 0 : nextProps.initialState) !== ((_d = this.props) === null || _d === void 0 ? void 0 : _d.initialState)) {
                        this.hydrate(nextProps, nextContext);
                    }
                    return true;
                };
                Wrapper.prototype.render = function () {
                    var _a, _b;
                    var _c = this.props, initialState = _c.initialState, initialProps = _c.initialProps, props = __rest(_c, ["initialState", "initialProps"]);
                    var resultProps = props;
                    // order is important! Next.js overwrites props from pages/_app with getStaticProps from page
                    // @see https://github.com/zeit/next.js/issues/11648
                    if (initialProps && initialProps.pageProps)
                        resultProps.pageProps = __assign(__assign({}, initialProps.pageProps), props.pageProps);
                    var initialStateFromGSPorGSSR = (_a = props === null || props === void 0 ? void 0 : props.pageProps) === null || _a === void 0 ? void 0 : _a.initialState;
                    // just some cleanup to prevent passing it as props, we need to clone props to safely delete initialState
                    if (initialStateFromGSPorGSSR) {
                        resultProps = __assign(__assign({}, props), { pageProps: __assign({}, props.pageProps) });
                        delete resultProps.pageProps.initialState;
                    }
                    // unwrap getInitialPageProps
                    if ((_b = resultProps === null || resultProps === void 0 ? void 0 : resultProps.pageProps) === null || _b === void 0 ? void 0 : _b.initialProps) {
                        resultProps.pageProps = __assign(__assign({}, resultProps.pageProps), resultProps.pageProps.initialProps);
                        delete resultProps.pageProps.initialProps;
                    }
                    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_redux__WEBPACK_IMPORTED_MODULE_1__/* .Provider */ .zt, { store: this.store },
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, __assign({}, initialProps, resultProps))));
                };
                return Wrapper;
            }(react__WEBPACK_IMPORTED_MODULE_0__.Component)),
            _a.displayName = displayName,
            _a.getInitialProps = hasInitialProps ? Component.getInitialProps : undefined,
            _a;
    };
    return {
        getServerSideProps: getServerSideProps,
        getStaticProps: getStaticProps,
        getInitialAppProps: getInitialAppProps,
        getInitialPageProps: getInitialPageProps,
        withRedux: withRedux,
    };
};
// Legacy
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (function (makeStore, config) {
    if (config === void 0) { config = {}; }
    console.warn('/!\\ You are using legacy implementaion. Please update your code: use createWrapper() and wrapper.withRedux().');
    return createWrapper(makeStore, config).withRedux;
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 93542:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(42351);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 90283:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(77783);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Lp": function() { return /* binding */ client; },
  "ZP": function() { return /* binding */ adapters_client; }
});

// UNUSED EXPORTS: getSSrClient

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ./src/adapters/address.js
/* provided dependency */ var process = __webpack_require__(93542);
/* Configuration imported from '.env' file */ var isServer = Boolean(process.env.BACKEND_APP_PROTOCOL);
var backendProtocol = isServer ? process.env.BACKEND_APP_PROTOCOL : "https";
var backendHost = isServer ? process.env.BACKEND_APP_HOST : "mosanic-fmkif.ondigitalocean";
var backendDomain = isServer ? process.env.BACKEND_APP_DOMAIN : "app";
var backendPort = isServer ? process.env.BACKEND_APP_PORT : "";
var backendGraphql = isServer ? process.env.BACKEND_APP_GRAPHQL : "/graphql";
var backendBase = "".concat(backendProtocol, "://").concat(backendHost);
var backendLocation = Boolean(backendPort) ? ":".concat(backendPort) : ".".concat(backendDomain);
var backendAddress = "".concat(backendBase).concat(backendLocation).concat(backendGraphql);
var backendSocketAddress = "ws://".concat(backendHost).concat(backendLocation, "/subscriptions");
/* harmony default export */ var address = (backendAddress);

// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/ApolloClient.js + 9 modules
var ApolloClient = __webpack_require__(93069);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 6 modules
var inMemoryCache = __webpack_require__(1342);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(33957);
// EXTERNAL MODULE: ../../node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(12129);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/context/index.js



function setContext(setter) {
    return new ApolloLink/* ApolloLink */.i(function (operation, forward) {
        var request = (0,tslib_es6.__rest)(operation, []);
        return new zen_observable_ts_module/* Observable */.y(function (observer) {
            var handle;
            var closed = false;
            Promise.resolve(request)
                .then(function (req) { return setter(req, operation.getContext()); })
                .then(operation.setContext)
                .then(function () {
                if (closed)
                    return;
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer),
                });
            })
                .catch(observer.error.bind(observer));
            return function () {
                closed = true;
                if (handle)
                    handle.unsubscribe();
            };
        });
    });
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../node_modules/apollo-upload-client/public/createUploadLink.js
var createUploadLink = __webpack_require__(54131);
var createUploadLink_default = /*#__PURE__*/__webpack_require__.n(createUploadLink);
// EXTERNAL MODULE: ../../node_modules/@lifeomic/axios-fetch/src/index.js
var src = __webpack_require__(14415);
// EXTERNAL MODULE: ../../node_modules/axios/index.js
var axios = __webpack_require__(89644);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/context/ApolloContext.js
var context_ApolloContext = __webpack_require__(42370);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/ssr/RenderPromises.js
function makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var RenderPromises = (function () {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
        this.stopped = false;
    }
    RenderPromises.prototype.stop = function () {
        if (!this.stopped) {
            this.queryPromises.clear();
            this.queryInfoTrie.clear();
            this.stopped = true;
        }
    };
    RenderPromises.prototype.registerSSRObservable = function (observable) {
        if (this.stopped)
            return;
        this.lookupQueryInfo(observable.options).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function (props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function (queryInstance, finish) {
        if (!this.stopped) {
            var info = this.lookupQueryInfo(queryInstance.getOptions());
            if (!info.seen) {
                this.queryPromises.set(queryInstance.getOptions(), new Promise(function (resolve) {
                    resolve(queryInstance.fetchData());
                }));
                return null;
            }
        }
        return finish ? finish() : null;
    };
    RenderPromises.prototype.addObservableQueryPromise = function (obsQuery) {
        return this.addQueryPromise({
            getOptions: function () { return obsQuery.options; },
            fetchData: function () { return new Promise(function (resolve) {
                var sub = obsQuery.subscribe({
                    next: function (result) {
                        if (!result.loading) {
                            resolve();
                            sub.unsubscribe();
                        }
                    },
                    error: function () {
                        resolve();
                        sub.unsubscribe();
                    },
                    complete: function () {
                        resolve();
                    },
                });
            }); },
        });
    };
    RenderPromises.prototype.hasPromises = function () {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function () {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function (promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function (props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query))
            queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || makeDefaultQueryInfo();
        if (!varMap.has(variablesString))
            varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}());

//# sourceMappingURL=RenderPromises.js.map
// EXTERNAL MODULE: ../../node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(48090);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/ssr/getDataFromTree.js





function getDataFromTree(tree, context) {
    if (context === void 0) { context = {}; }
    return getMarkupFromTree({
        tree: tree,
        context: context,
        renderFunction: server_browser.renderToStaticMarkup
    });
}
function getMarkupFromTree(_a) {
    var tree = _a.tree, _b = _a.context, context = _b === void 0 ? {} : _b, _c = _a.renderFunction, renderFunction = _c === void 0 ? server_browser.renderToStaticMarkup : _c;
    var renderPromises = new RenderPromises();
    function process() {
        var ApolloContext = (0,context_ApolloContext/* getApolloContext */.K)();
        return new Promise(function (resolve) {
            var element = react.createElement(ApolloContext.Provider, { value: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { renderPromises: renderPromises }) }, tree);
            resolve(renderFunction(element));
        }).then(function (html) {
            return renderPromises.hasPromises()
                ? renderPromises.consumeAndAwaitPromises().then(process)
                : html;
        }).finally(function () {
            renderPromises.stop();
        });
    }
    return Promise.resolve().then(process);
}
//# sourceMappingURL=getDataFromTree.js.map
// EXTERNAL MODULE: ./src/adapters/token.js + 1 modules
var adapters_token = __webpack_require__(94645);
;// CONCATENATED MODULE: ./src/adapters/client.js








// import { GraphQLWsLink } from '@apollo/client/link/subscriptions';






var combineHeaders = function(param) {
    var headers = param.headers;
    var token = (0,adapters_token/* recoverToken */.Sr)();
    var authorization = token ? "Bearer ".concat(token) : "";
    return {
        headers: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, headers), {
            authorization: authorization,
            "Apollo-Require-Preflight": "true"
        })
    };
};
var authLink = setContext(function(_, param) {
    var headers = param.headers;
    return combineHeaders({
        headers: headers
    });
});
//  createHttpLink
var httpLink = createUploadLink_default()({
    uri: address,
    fetch: (0,src/* buildAxiosFetch */.N)((axios_default()), function(config, input, init) {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, config), {
            onUploadProgress: init.onUploadProgress
        });
    })
});
// const wsLink =  typeof window !== "undefined" ? (
//     new GraphQLWsLink(createClient({
//         url: backendSocketAddress,
//     }))
// ) : null;
// const hasSocketLink = Boolean(typeof window !== "undefined" && wsLink != null)
// const splitLink = hasSocketLink ? split(({ query }) => {
//         const definition = getMainDefinition(query);
//         return (
//             definition.kind === 'OperationDefinition' &&
//             definition.operation === 'subscription'
//         );
//     },
//     wsLink,
//     httpLink,
// ) : (
//     httpLink
// );
var client = new ApolloClient/* ApolloClient */.f({
    link: authLink.concat(httpLink),
    cache: new inMemoryCache/* InMemoryCache */.h({
    }),
    defaultOptions: {
        watchQuery: {
            nextFetchPolicy: function(currentFetchPolicy) {
                return currentFetchPolicy === "network-only" || currentFetchPolicy === "cache-and-network" ? "cache-first" : currentFetchPolicy;
            }
        }
    },
    connectToDevTools: "production" !== "production"
});
// const validate = (headers) => isEmptyString(headers?.authorization) && !isServer()
// export const getGqlClient = () => {
// 	const requestHeaders = getHeaders();
// 	const client = new GraphQLClient(backendAddress, {
// 		headers: requestHeaders
//   	})
// 	if(validate(requestHeaders)) client.setHeader("authorization", getHeaders().authorization)
// 	const query = async (name, query, variables) => {
// 		if(validate(requestHeaders)) client.setHeader("authorization", getHeaders().authorization)
// 		try {
// 			const data = await client.request( query, variables );
// 			return hasAttr(data, name) ? data[name] : data;
// 		} catch (error) {
// 			return handleGqlErrors(error?.response)
// 		}
// 	}
// 	const mutate = async (name, mutation, variables) => {
// 		if(validate(requestHeaders)) client.setHeader("authorization", getHeaders().authorization)
// 		try {
// 			const data = await client.request( mutation, variables );
// 			return data[name];
// 		} catch (error) {
// 			return handleGqlErrors(error?.response)
// 		}
// 	}
// 	return {query, mutate};
// }
var getSSrClient = {
    query: getDataFromTree,
    mutate: getDataFromTree
};
// {
//     query : async (name, query, variables = null, multi = false) => {
// 		try {
// 			const data = await request(backendAddress, query, variables);
// 			return !multi ? data[name] : data;
// 		} catch (error) {
// 			handleGqlErrors(error.response)
// 		}
// 	},
// 	mutate : async (name, mutation, variables=  null) => {
// 		try {
// 			const data = await request(backendAddress, mutation, variables);
// 			return data[name];
// 		} catch (error) {
// 			handleGqlErrors(error.response)
// 		}
// 	}
// }
var handleGqlErrors = function(error) {
    var isProduction = Boolean( true || 0);
    if (Array.isArray(error === null || error === void 0 ? void 0 : error.errors)) {
        error.errors = error.errors.map(function(err, index) {
            //Authentication
            if (err.extensions.code === "UNAUTHENTICATED" || err.extensions.code === "FORBIDDEN") {
                deleteSession();
                if (window != "undefined") window.location.href = "/";
            }
            if (isProduction && index === 0) {
                if (containsSubstr(err.message, "Cannot query field")) {
                    return _object_spread_props(_object_spread({}, err), {
                        message: "".concat(subStringTill(err.message, "."), ".")
                    });
                }
                if (containsSubstr(err.message, 'Variable "$email"')) {
                    return _object_spread_props(_object_spread({}, err), {
                        message: "Something is wrong with the auth query. \n\n						We did not receive an valid email address."
                    });
                }
            }
            return err;
        // if (networkError && networkError.response === 'invalid_token') {
        //     deleteSession();
        //     window.location.href = '/';
        // }
        });
    }
    return error;
};
// const useClient = getGqlClient();
/* harmony default export */ var adapters_client = (client);


/***/ }),

/***/ 1418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ AUTH_TOKEN; },
/* harmony export */   "h": function() { return /* binding */ AUTH_EMAIL_REF; }
/* harmony export */ });
var AUTH_TOKEN = "MOSANIC_USR_TKN";
var AUTH_EMAIL_REF = "MOSANIC_EMAIL_REF";


/***/ }),

/***/ 31600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tM": function() { return /* binding */ SEO_FRAGMENT; }
/* harmony export */ });
/* unused harmony exports PAGE_CORE, PAGE_SEO */
var PAGE_CORE = "\n  title\n  unique\n  slug\n  description\n  date\n  status\n";
var PAGE_SEO = "\n  seo {\n    title\n    description\n    image\n    isIndexed\n    unique\n    slug\n  }\n";
var SEO_FRAGMENT = "\n  seo {\n    title\n    description\n    keywords\n\n    language\n    author\n    color\n    \n    image\n    icon\n    favicon\n\n    isIndexed\n    unique\n    slug\n    localized\n  }\n";


/***/ }),

/***/ 6539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jn": function() { return /* binding */ getImageUrl; },
/* harmony export */   "TI": function() { return /* binding */ getAppUrl; },
/* harmony export */   "V": function() { return /* binding */ getDocsUrl; },
/* harmony export */   "Xx": function() { return /* binding */ getNewsUrl; }
/* harmony export */ });
/* unused harmony exports getCoreUrl, getMailSecret, getSubDomainUrl */
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68311);
/* provided dependency */ var process = __webpack_require__(93542);

/* Configuration imported from '.env' file */ var isServer = Boolean(process.env.NEXT_APP_DOMAIN_HOST);
var appHost = isServer ? process.env.NEXT_APP_DOMAIN_HOST : "https://app.mosanic.io";
var coreHost = isServer ? process.env.NEXT_CORE_DOMAIN_HOST : "https://mosanic.io";
var imageLocation = isServer ? "https://".concat(process.env.BUCKET_NAME, ".").concat(process.env.IMAGE_LOCATION) : "https://".concat("mosanic-cdn", ".").concat("ams3.digitaloceanspaces.com");
var getImageUrl = function(imgPath) {
    if (!imgPath) return "";
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .containsSubstr */ .xX)(imgPath, "data:image") ? imgPath : "".concat(imageLocation).concat((0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .containsSubstr */ .xX)(imgPath, "/") ? imgPath : "/" + imgPath);
};
var getCoreUrl = function(slug) {
    return slug ? "".concat(coreHost).concat(slug) : coreHost;
};
var getAppUrl = function(slug) {
    return slug ? "".concat(appHost).concat(slug) : appHost;
};
var getMailSecret = function() {
    return isServer ? process.env.SENDGRID_KEY : "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";
};
var getSubDomainUrl = function(slug, sub) {
    return slug ? "".concat((0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .replacePart */ .bA)(appHost, "app", sub)).concat(slug) : (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .replacePart */ .bA)(appHost, "app", sub);
};
var getDocsUrl = function(slug) {
    return getSubDomainUrl(slug, "docs");
};
var getNewsUrl = function(slug) {
    return getSubDomainUrl(slug, "news");
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (appHost)));


/***/ }),

/***/ 37029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": function() { return /* binding */ AUTH_LOGIN; },
/* harmony export */   "IR": function() { return /* binding */ DELETE_ACCOUNT; },
/* harmony export */   "Nz": function() { return /* binding */ REGISTER; },
/* harmony export */   "bk": function() { return /* binding */ RESET_PASSWORD; },
/* harmony export */   "sO": function() { return /* binding */ AUTH_RESET_PASSWORD; },
/* harmony export */   "ym": function() { return /* binding */ LOGIN; }
/* harmony export */ });
/* unused harmony export CHANGE_PASSWORD */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation loginUser($email: String!, $password: String!, $verify: Boolean, $templateId: String, $mailData: MailDataInput, $from: String) {\n	loginUser (email: $email, password: $password, verify: $verify, templateId: $templateId, mailData: $mailData, from: $from) {\n		response\n		status\n		token\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation authUser($email: String!, $code: String!) {\n	authUser (email: $email, code: $code) {\n		token\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation resetPassword($email: String!, $templateId: String, $mailData: MailDataInput, $from: String ) {\n	resetPassword (email: $email, templateId: $templateId, mailData: $mailData, from: $from) {\n		response \n		status\n	}\n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation authResetPassword($email: String!, $code: String!, $newPassword: String) {\n	authResetPassword (email: $email, code: $code, newPassword: $newPassword) {\n		token\n	}\n}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation registerUser($email: String!, $password: String!, $firstName: String!, $lastName: String!) {\n	registerUser (email: $email, password: $password, firstName: $firstName, lastName: $lastName) {\n		token\n	}\n}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation authResetPassword($password: String!, $oldPassword: String!) {\n	authResetPassword (password: $password, oldPassword: $oldPassword) {\n		email\n	}\n}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation deleteMyUserAccount {\n	deleteMyUserAccount {\n		deletedCount\n	}\n}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

/** Auth login */ var LOGIN = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var AUTH_LOGIN = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
/** Forgot password rests */ var RESET_PASSWORD = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var AUTH_RESET_PASSWORD = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
/** Register */ var REGISTER = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
/** Account changes */ var CHANGE_PASSWORD = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());
var DELETE_ACCOUNT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6());


/***/ }),

/***/ 77522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ADD_BUILDER_ITEM; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);
// import { gql } from '@apollo/client';

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation builderItemCreateOne($record: CreateOneBuilderItemInput!) {\n	builderItemCreateOne (record: $record) {\n		recordId\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

//TODO refactor to new composer method
var ADD_BUILDER_ITEM = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 81970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ UPDATE_CHAT; },
/* harmony export */   "i": function() { return /* binding */ ADD_CHAT; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation chatCreateOne($record: CreateOneChatInput!) {\n	chatCreateOne (record: $record) {\n		recordId\n		record {\n			name\n			_id\n		}\n		error {\n			message\n		}\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation chatUpdateById($_id: MongoID!, $record: UpdateByIdChatInput!) {\n	chatUpdateById (_id: $_id, record: $record) {\n		recordId\n		record {\n			name\n			_id\n		}\n		error {\n			message\n		}\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var ADD_CHAT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var UPDATE_CHAT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());


/***/ }),

/***/ 73755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oy": function() { return /* binding */ UPDATE_COLLECTION; },
/* harmony export */   "nU": function() { return /* binding */ ADD_COLLECTION; },
/* harmony export */   "of": function() { return /* binding */ REMOVE_COLLECTION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation collectionCreateOne($record: CreateOneCollectionInput!) {\n	collectionCreateOne (record: $record) {\n		recordId\n		record {\n			title\n			description\n			schema\n			entries\n			excerpt \n			date \n			updatedAt \n			status \n			userId \n			siteId \n			_id\n		}\n		error {\n			message\n		}\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation collectionUpdateById($_id: MongoID!, $record: UpdateByIdCollectionInput!) {\n	collectionUpdateById (_id: $_id, record: $record) {\n		recordId\n		record {\n			title\n			description\n			schema\n			entries\n			excerpt \n			date \n			updatedAt  \n			status \n			userId \n			siteId \n			_id\n		}\n		error {\n			message\n		}\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation collectionRemoveById($_id: MongoID!) {\n	collectionRemoveById (_id: $_id) {\n		recordId\n	}\n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ADD_COLLECTION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var UPDATE_COLLECTION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var REMOVE_COLLECTION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());


/***/ }),

/***/ 54335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oT": function() { return /* binding */ REMOVE_ENTRY; },
/* harmony export */   "tr": function() { return /* binding */ ADD_ENTRY; },
/* harmony export */   "uE": function() { return /* binding */ REMOVE_ENTRIES; },
/* harmony export */   "yN": function() { return /* binding */ UPDATE_ENTRY; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation entryCreateOne($record: CreateOneEntryInput!) {\n	entryCreateOne (record: $record) {\n		recordId\n		record {\n			title\n			_id\n		}\n		error {\n			message\n		}\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation entryUpdateById($_id: MongoID!, $record: UpdateByIdEntryInput!) {\n	entryUpdateById (_id: $_id, record: $record) {\n		recordId\n		record {\n			title\n			_id\n		}\n		error {\n			message\n		}\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation entryRemoveMany($filter: FilterRemoveManyEntryInput!) {\n	entryRemoveMany (filter: $filter) {\n		numAffected\n		error {\n			message\n		}\n	}\n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation entryRemoveById($filter: FilterRemoveEntryByIdInput!) {\n	entryRemoveById (filter: $filter) {\n		error {\n			message\n		}\n	}\n}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var ADD_ENTRY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var UPDATE_ENTRY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var REMOVE_ENTRIES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var REMOVE_ENTRY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());


/***/ }),

/***/ 15566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ UPDATE_MAIL; },
/* harmony export */   "a": function() { return /* binding */ ADD_MAIL; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation mailCreateOne($record: CreateOneMailInput!) {\n	mailCreateOne (record: $record) {\n		recordId\n		record {\n			title\n			description\n			schema\n			userId \n			siteId \n			_id\n		}\n		error {\n			message\n		}\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation mailUpdateById($_id: MongoID!,$record: UpdateByIdMailInput!) {\n	mailUpdateById (_id: $_id, record: $record) {\n		recordId\n		record {\n			title\n			description\n			schema\n			userId \n			siteId \n			_id\n		}\n		error {\n			message\n		}\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var ADD_MAIL = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var UPDATE_MAIL = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());


/***/ }),

/***/ 96362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CI": function() { return /* binding */ DELETE_MEDIA; },
/* harmony export */   "DC": function() { return /* binding */ DELETE_UPLOAD; },
/* harmony export */   "b$": function() { return /* binding */ SINGLE_UPLOAD; },
/* harmony export */   "xM": function() { return /* binding */ ADD_MEDIA; }
/* harmony export */ });
/* unused harmony export FONT_UPLOAD */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation uploadFile($file: Upload!, $path: String) {\n	uploadFile (file: $file, path: $path) {\n		filename\n        mimetype\n        encoding\n        url\n		urlMin \n		urlThumb\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation uploadFont($file: Upload!) {\n	uploadFont (file: $file) {\n		filename\n        mimetype\n        encoding\n        url\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation mediaCreateOne($record: CreateOneMediaInput!) {\n	mediaCreateOne (record: $record) {\n		recordId\n		record {\n			title\n			alt\n            filename\n            folder \n            url\n			urlMin \n			urlThumb\n\n			_id\n		}\n		error {\n			message\n		}\n	}\n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation mediaRemoveById($_id: MongoID!) {\n	mediaRemoveById (_id: $_id) {\n		error {\n			message\n		}\n		recordId\n	}\n}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation deleteFile($filename: String!, $url: String!) {\n	deleteFile (filename: $filename, url: $url) {\n		message\n	}\n}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var SINGLE_UPLOAD = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var FONT_UPLOAD = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
// useUploadFile(file: Upload!): UploadedFileResponse!
var ADD_MEDIA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var DELETE_MEDIA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var DELETE_UPLOAD = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());


/***/ }),

/***/ 17074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ADD_TEAM; },
/* harmony export */   "x": function() { return /* binding */ UPDATE_TEAM; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation teamCreateOne($record: CreateOneTeamInput!) {\n	teamCreateOne (record: $record) {\n        record {\n            name\n        }\n        recordId\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation teamUpdateById($_id: MongoID!, $record: UpdateByIdTeamInput!) {\n	teamUpdateById (_id: $_id, record: $record) {\n		record {\n			name\n		}\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var ADD_TEAM = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var UPDATE_TEAM = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());


/***/ }),

/***/ 38374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A1": function() { return /* binding */ EDIT_PASSWORD; },
/* harmony export */   "AX": function() { return /* binding */ UPDATE_USER; },
/* harmony export */   "qK": function() { return /* binding */ CREATE_USER; }
/* harmony export */ });
/* unused harmony exports UPDATE_USERS, REMOVE_USERS */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation editUserPassword($_id: String!, $password: String!, $oldPassword: String!) {\n	editUserPassword (_id: $_id, password: $password, oldPassword: $oldPassword) {\n		email\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation userUpdateById($_id: MongoID!, $record: UpdateByIdUserInput!) {\n	userUpdateById(_id: $_id, record: $record) {\n		recordId\n		error {\n			message\n		}\n	} \n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation userUpdateMany($record: UpdateManyUserInput!) {\n	userUpdateById(record: $record) {\n		numAffected\n		error {\n			message\n		}\n	} \n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation userRemoveMany($filter: FilterRemoveManyUserInput!) {\n	userRemoveMany (filter: $filter) {\n		numAffected\n		error {\n			message\n		}\n	}\n}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation userCreateOne($record: CreateOneUserInput!) {\n	userCreateOne(record: $record) {\n		record {\n            _id\n        }\n	} \n}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

// export const EDIT_USER = gql`
// mutation editUserAccount($_id: String!,$firstName: String!, $lastName: String!, $bio: String!) {
// 	editUserAccount (_id: $_id,firstName: $firstName, lastName: $lastName, bio: $bio) {
// 		email
// 	}
// }
// `;
var EDIT_PASSWORD = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var UPDATE_USER = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var UPDATE_USERS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var REMOVE_USERS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var CREATE_USER = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());


/***/ }),

/***/ 87860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ BUILDER_ITEMS; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(60138);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
;// CONCATENATED MODULE: ./src/adapters/fragments/layouts.js
// import { gql } from '@apollo/client';
var BUILDER_ITEM_CORE = " \n  title\n  description\n  type\n  category\n  isUserGenerated\n  isBookmarked\n  _id\n";
var LAYOUT_ROW = "\n  title \n  type\n  status\n  _id\n  children {\n      title \n      type\n      status\n      _id\n      children {\n        title \n        type\n        status\n        _id\n          \n      }\n  }\n";
var COMPONENT_CORE = "\n  type\n  data\n  title\n  desc\n  icon\n  isFocus\n";
var COMPONENT_EDITOR = "\n  editor {\n    title\n    description\n    disableDnd\n  }\n";
var LAYOUT_VISIBILITY = "\n  visibility {\n    scrollEffect\n    offset\n    offsetMetric\n    display\n    displaySm\n    displayMd\n    displayLg\n    displayXl\n    anchor\n    anchorName\n    anchorId\n  }\n";
var LAYOUT_CONTAINER = "\n  container {\n    state {\n      xs\n      sm\n      md\n      lg\n      xl\n    }\n  }\n";
var CORE = "\n  title\n  type\n  _id\n";
var COLUMN_CORE = "\n  ".concat(CORE, "\n");
var ROW_CORE = "\n  ".concat(CORE, "\n");
var COLUMN_DATA = "\n  data {\n    reference\n    repeating\n    isCloned\n    isMain\n  }\n";
var COLUMN_GRID = "\n  grid {\n    responsive {\n      xs\n      sm\n      md\n      lg\n      xl\n    }\n    offset {\n      xs\n      sm\n      md\n      lg\n      xl\n    }\n    display {\n      xs\n      sm\n      md\n      lg\n      xl\n    }\n  }\n";
var DESIGN_STATES = "\n  design {\n    state\n    color {\n      hex\n      color\n      shade\n      opacity\n    }\n    background {\n      hex\n      color\n      shade\n      opacity\n    }\n    backgroundSrc {\n      filename\n      encoding\n      mimetype\n      url\n    }\n    border {\n      style\n      width\n      color\n      shade\n      opacity\n    }\n    radius {\n      top\n      bottom\n      left\n      right\n    }\n    shadow {\n      value\n    }\n  }\n";
var DISPLAY_MAIN = "\n  display {\n    displayType\n    position\n    flex {\n      direction\n      align\n      justify\n      wrap\n    }\n  }\n";
var DISPLAY_CHILD_SUB = "\n  display {\n    displayTypeParent\n    position\n    flex {\n      sizing\n      customSizing {\n        grow\n        shrink\n        basis\n      }\n      align\n      order\n    }\n  }\n";
var METRIC = "\n  {\n    value\n    metric\n    disabled\n    reason\n    label\n  }\n";
var LAYOUT_SIZING = "\n  sizing {\n    width ".concat(METRIC, "\n    height ").concat(METRIC, "\n    minWidth ").concat(METRIC, "\n    minHeight ").concat(METRIC, "\n    maxWidth ").concat(METRIC, "\n    maxHeight ").concat(METRIC, "\n  }\n");
var LAYOUT_PADDING = "\n  padding {\n    top ".concat(METRIC, "\n    bottom ").concat(METRIC, "\n    left ").concat(METRIC, "\n    right ").concat(METRIC, "\n  }\n");
var LAYOUT_MARGIN = "\n  margin {\n    top ".concat(METRIC, "\n    bottom ").concat(METRIC, "\n    left ").concat(METRIC, "\n    right ").concat(METRIC, "\n  }\n");
var LAYOUT_DOCKING = "\n  docking {\n    docked {\n      top\n      bottom\n      left\n      right\n    }\n    top ".concat(METRIC, "\n    bottom ").concat(METRIC, "\n    left ").concat(METRIC, "\n    right ").concat(METRIC, "\n  }\n");
var COMPONENT_FIELDS = "\n  ".concat(COMPONENT_CORE, "\n  ").concat(COMPONENT_EDITOR, "\n  ").concat(DESIGN_STATES, "\n\n  layout {\n    ").concat(LAYOUT_VISIBILITY, "\n  }\n  layouts {\n    state\n    ").concat(DISPLAY_CHILD_SUB, "\n    ").concat(LAYOUT_SIZING, "\n    ").concat(LAYOUT_PADDING, "\n    ").concat(LAYOUT_DOCKING, "\n  }\n");
var COMPONENTS_DATA = "\n  components {\n    ".concat(COMPONENT_FIELDS, "\n      _id\n  }\n");
var CONTAINER_FIELDS = "\n  ".concat(COLUMN_CORE, "\n  ").concat(DESIGN_STATES, "\n  ").concat(COLUMN_DATA, "\n  layout { \n    isLocked\n    ").concat(LAYOUT_VISIBILITY, "\n    ").concat(COLUMN_GRID, "\n  } \n  layouts {\n    state\n    ").concat(DISPLAY_MAIN, "\n    ").concat(LAYOUT_SIZING, "\n    ").concat(LAYOUT_PADDING, "\n    ").concat(LAYOUT_MARGIN, "\n  }\n");
var COLUMNS_DATA = "\n  columns {\n    ".concat(CONTAINER_FIELDS, "\n  }");
var CONTAINER_DATA = "\n  containers {\n    ".concat(CONTAINER_FIELDS, "\n  }");
var ROWS_DATA = "\n  rows {\n    ".concat(ROW_CORE, "\n    ").concat(DESIGN_STATES, "\n    layout {\n      ").concat(LAYOUT_VISIBILITY, "\n      ").concat(LAYOUT_CONTAINER, "\n    }\n    layouts {\n      state\n      ").concat(LAYOUT_SIZING, "\n      ").concat(LAYOUT_PADDING, "\n      ").concat(LAYOUT_MARGIN, "\n    }\n    repeating {\n      collection\n    }\n  }\n  ") // export const BUILDER_LAYOUT_FIELDS = gql`
 // fragment VisibilityFields on component {
 // fragment Components on page {
 //     components {
 //       type
 //       data
 //       title
 //       desc
 //       icon
 //       isFocus
 //       _id
 //       editor {
 //         title
 //         description
 //         disableDnd
 //       }
 //       layout {
 //         ...VisibilityFields
 //       }
 //       # Start design array
 //       design {
 //         state
 //         color {
 //           color
 //           shade
 //           opacity
 //         }
 //         background {
 //           color
 //           shade
 //           opacity
 //         }
 //         backgroundSrc {
 //           filename
 //           encoding
 //           mimetype
 //           url
 //         }
 //         border {
 //           style
 //           width
 //           color
 //           shade
 //           opacity
 //         }
 //         radius {
 //           top
 //           bottom
 //           left
 //           right
 //         }
 //         shadow {
 //           value
 //         }
 //       }
 //       # Start layouts array
 //       layouts {
 //         state
 //         display {
 //           displayTypeParent
 //           position
 //           flex {
 //             sizing
 //             customSizing {
 //               grow
 //               shrink
 //               basis
 //             }
 //             align
 //             order
 //           }
 //         }
 //         sizing {
 //           width {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           }
 //           height {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           }
 //           minWidth {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           }
 //           minHeight {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           maxWidth {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           maxHeight {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           }
 //         }
 //         docking {
 //           docked {
 //             top
 //             bottom
 //             left
 //             right
 //           }
 //           top {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           bottom {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           left {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           right {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //         }
 //         padding {
 //           top {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           bottom {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           left {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           right {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //         }
 //       }
 //     }
 //     # -----------------------
 //     # Start columns
 //     columns {
 //       title
 //       type
 //       _id
 //       # - start columns layout
 //       layout { 
 //         visibility {
 //           scrollEffect
 //           offset
 //           offsetMetric
 //           display
 //           displaySm
 //           displayMd
 //           displayLg
 //           displayXl
 //           anchor
 //           anchorName
 //           anchorId
 //         }
 //         grid {
 //           responsive {
 //             xs
 //             sm
 //             md
 //             lg
 //             xl
 //           }
 //           offset {
 //             xs
 //             sm
 //             md
 //             lg
 //             xl
 //           }
 //           display {
 //             xs
 //             sm
 //             md
 //             lg
 //             xl
 //           }
 //         }
 //       } 
 //       # Start col layouts array
 //       layouts {
 //         state
 //         display {
 //           displayType
 //           position
 //           flex {
 //             direction
 //             align
 //             justify
 //             wrap
 //           }
 //         }
 //         sizing {
 //           width {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           }
 //           height {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           }
 //           minWidth {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           }
 //           minHeight {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           maxWidth {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           maxHeight {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           }
 //         }
 //         margin {
 //           top {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           bottom {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           left {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           right {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //         }
 //         padding {
 //           top {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           bottom {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           left {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           right {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //         }
 //       }
 //       # - start columns design
 //       design {
 //         type
 //         state
 //         color {
 //           color
 //           shade
 //           opacity
 //         }
 //         background {
 //           color
 //           shade
 //           opacity
 //         }
 //         border {
 //           color
 //           shade
 //           opacity
 //         }
 //         backgroundSrc {
 //           filename
 //           url
 //           encoding
 //           mimetype
 //         }
 //         radius {
 //           top
 //           right
 //           bottom
 //           left
 //         }
 //         shadow {
 //           value
 //         }
 //       }
 //       isLocked
 // 		  data {
 // 			  reference
 //         repeating
 //         isCloned
 //         isMain
 //       }
 //     }
 //     # -----------------------
 //     # Start rows array
 //     rows {
 //       title
 //       type
 //       container
 //       _id
 //       # - start rows layout
 //       layout {
 //         visibility {
 //           scrollEffect
 //           offset
 //           offsetMetric
 //           display
 //           displaySm
 //           displayMd
 //           displayLg
 //           displayXl
 //           anchor
 //           anchorName
 //           anchorId
 //         }
 //         container {
 //           state {
 //             xs
 //             sm
 //             md
 //             lg
 //             xl
 //           }
 //         }
 //       }
 //       # - start rows layouts array
 //       layouts {
 //         state
 //         sizing {
 //           width {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           }
 //           height {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           }
 //           minWidth {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           }
 //           minHeight {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           maxWidth {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           maxHeight {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           }
 //         }
 //         margin {
 //           top {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           bottom {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           left {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           right {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //         }
 //         padding {
 //           top {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           bottom {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           left {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //           right {
 //             value
 //             metric
 //             disabled
 //             reason
 //             label
 //           } 
 //         }
 //       }
 //       # - start rows design
 //       design {
 //         type
 //         state
 //         color {
 //           color
 //           shade
 //           opacity
 //         }
 //         background {
 //           color
 //           shade
 //           opacity
 //         }
 //         border {
 //           color
 //           shade
 //           opacity
 //         }
 //         backgroundSrc {
 //           filename
 //           url
 //           encoding
 //           mimetype
 //         }
 //         radius {
 //           top
 //           right
 //           bottom
 //           left
 //         }
 //         shadow {
 //           value
 //         }
 //       }
 //       repeating {
 //         collection
 //       }
 //     }
 //   }
 // }
 // `;
;

;// CONCATENATED MODULE: ./src/adapters/queries/builderItems.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nquery builderItemMany{\n  builderItemMany {\n    ",
        "\n    component \n    map\n    data\n    siteId\n    date\n    updatedAt\n    updates\n  }\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

// const gql = dynamic(() => import("graphql-tag"))


var BUILDER_ITEMS = (0,lib/* gql */.Ps)(_templateObject(), BUILDER_ITEM_CORE);


/***/ }),

/***/ 94283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SC": function() { return /* binding */ COLLECTIONS_COUNT; },
/* harmony export */   "WN": function() { return /* binding */ FILTER_COLLECTIONS_INDEX; },
/* harmony export */   "YN": function() { return /* binding */ FILTER_COLLECTIONS; },
/* harmony export */   "du": function() { return /* binding */ COLLECTION; }
/* harmony export */ });
/* unused harmony export COLLECTIONS */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \nquery collectionCount($filter:FilterCountCollectionInput) {\n  collectionCount(filter:$filter) \n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery collectionMany{\n	collectionMany {\n		title\n\n		# singular\n      	description\n		catchRoutes\n		baseRoute\n		dynamicPage\n		config\n		schema\n		entries\n		excerpt \n		date \n		updatedAt \n		status \n		userId \n		siteId \n		_id\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery collectionMany($filter: FilterFindManyCollectionInput, $limit: Int, $skip: Int, $sort: SortFindManyCollectionInput) {\n	collectionMany(filter: $filter, limit: $limit, skip: $skip, sort: $sort){\n		title\n		singular\n		type\n		description\n		routing {\n			catchRoutes\n			frontEnd\n			baseRoute\n			editRoute\n			indexPage\n			editPage\n			notFoundPage\n			dynamicPage\n		}\n		catchRoutes\n		baseRoute\n		editRoute \n		editPage\n		dynamicPage\n		schema\n		entries\n		excerpt \n		date \n		updatedAt \n		status \n		userId \n		siteId \n		_id\n	}\n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery collectionMany($filter: FilterFindManyCollectionInput) {\n	collectionMany(filter: $filter){\n		title\n		singular\n		type\n		description\n		catchRoutes\n		baseRoute\n		dynamicPage\n		schema\n		entries\n		excerpt \n		date \n		updatedAt \n		status \n		userId \n		siteId \n		_id\n	}\n}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery collectionById($_id: MongoID!) {\n	collectionById(_id: $_id){\n		title\n		routing {\n			catchRoutes\n			frontEnd\n			baseRoute\n			editRoute\n			indexPage\n			editPage\n			notFoundPage\n			dynamicPage\n		}\n		singular\n      	description\n		catchRoutes\n		baseRoute\n		dynamicPage\n		config\n		schema\n		entries\n		excerpt \n		date \n		updatedAt \n		status \n		userId \n		siteId \n		_id\n	}\n}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

;
var COLLECTIONS_COUNT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var COLLECTIONS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var FILTER_COLLECTIONS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var FILTER_COLLECTIONS_INDEX = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var COLLECTION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());


/***/ }),

/***/ 78721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$z": function() { return /* binding */ MAP_ENTRIES; },
/* harmony export */   "Vz": function() { return /* binding */ ENTRY_COUNT; },
/* harmony export */   "cH": function() { return /* binding */ PAGINATION_ENTRIES; },
/* harmony export */   "hZ": function() { return /* binding */ ENTRY; },
/* harmony export */   "ji": function() { return /* binding */ ENTRIES_MAP; },
/* harmony export */   "r8": function() { return /* binding */ FILTER_ENTRIES; }
/* harmony export */ });
/* unused harmony export ENTRIES_SLUG */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery entryMany($filter: FilterFindManyEntryInput, $limit: Int, $skip: Int) {\n	entryMany(filter: $filter, limit: $limit, skip: $skip){\n		title\n		type\n		description\n        slug\n\n		catchRoute\n		baseRoute\n\n		\n        collectionId\n        siteId\n       	queryId\n		_id\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \nquery entryCount($filter:FilterCountEntryInput) {\n  entryCount(filter:$filter) \n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery entryMany($filter: FilterFindManyEntryInput, $limit: Int, $skip: Int) {\n	entryMany(filter: $filter, limit: $limit, skip: $skip){\n		title\n		type\n        slug\n		catchRoute\n		baseRoute\n\n		excerpt\n        collectionId\n        siteId\n        map\n		queryId\n		_id\n	}\n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery entryPagination($filter: FilterFindManyEntryInput,  $page: Int, $perPage: Int, $sort: SortFindManyEntryInput) {\n	entryPagination(filter: $filter, page: $page, perPage: $perPage, sort: $sort){\n		items{\n			title\n			type\n			description\n			slug\n\n			catchRoute\n			baseRoute\n\n			dynamicPage\n			schema\n\n			data \n\n			excerpt\n\n			date\n			updatedAt\n\n			status\n			userId\n			collectionId\n			siteId\n			trigger\n\n			updates\n			queryId\n			_id\n		}\n	}\n}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery entryMany($filter: FilterFindManyEntryInput, $limit: Int, $skip: Int,  $sort: SortFindManyEntryInput) {\n	entryMany(filter: $filter, limit: $limit, skip: $skip, sort: $sort){\n		title\n		type\n		description\n        slug\n\n		catchRoute\n		baseRoute\n\n		dynamicPage\n		schema\n\n		props\n        data \n		filters\n		map\n\n		excerpt\n\n        date\n        updatedAt\n\n        status\n        userId\n        collectionId\n        siteId\n        trigger\n\n        updates\n		queryId\n		_id\n	}\n}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery entryMany($filter: FilterFindManyEntryInput, $limit: Int, $skip: Int) {\n	entryMany(filter: $filter, limit: $limit, skip: $skip){\n		title\n		type\n		description\n        slug\n\n		catchRoute\n		baseRoute\n\n		dynamicPage\n		schema\n\n		props\n		filters\n		map\n\n		excerpt\n\n        date\n        updatedAt\n\n        status\n        userId\n        collectionId\n        siteId\n        trigger\n\n        updates\n		queryId\n		_id\n	}\n}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery entryById($_id: MongoID!) {\n	entryById(_id: $_id){\n		title\n		type\n		description\n        slug\n\n		catchRoute\n		baseRoute\n\n		dynamicPage\n		schema\n\n        data \n\n		excerpt\n\n        date\n        updatedAt\n\n        status\n        userId\n        collectionId\n        siteId\n        trigger\n        map\n        updates\n		queryId\n		_id\n	}\n}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

;
var ENTRIES_SLUG = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var ENTRY_COUNT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var ENTRIES_MAP = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var PAGINATION_ENTRIES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var FILTER_ENTRIES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
var MAP_ENTRIES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());
var ENTRY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6());


/***/ }),

/***/ 2782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UU": function() { return /* binding */ SEND_MAIL; },
/* harmony export */   "cy": function() { return /* binding */ MAIL; },
/* harmony export */   "lS": function() { return /* binding */ FILTER_MAILS; }
/* harmony export */ });
/* unused harmony export MAIL_COUNT */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery mailSendOne($to: String!, $from: String!, $mailData: MailDataInput!, $templateId: String) {\n	mailSendOne(to: $to, from: $from, mailData: $mailData, templateId: $templateId){\n		response\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \nquery mailCount($filter:FilterCountMailInput) {\n  mailCount(filter:$filter) \n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery mailMany($filter: FilterFindManyMailInput, $limit: Int, $skip: Int) {\n	mailMany(filter: $filter, limit: $limit, skip: $skip){\n		title\n		_id\n		description\n		type\n		limit\n		# config{\n		# 	senderName\n		# 	defaultSender \n		# 	defaultReceiver \n		# 	data \n		# }\n		collectionId \n		schema \n		entries \n		status \n		templates\n		date \n		updatedAt \n		userId \n		siteId \n\n		trigger \n		data \n		updates\n\n\n	}\n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery mailById($_id: MongoID!) {\n	mailById(_id: $_id){\n		title\n		_id\n		description\n		type\n		limit\n		templates\n		# config{\n		# 	senderName\n		# 	defaultSender \n		# 	defaultReceiver \n		# 	data \n		# }\n		collectionId \n		schema \n		entries \n		status \n		date \n		updatedAt \n		userId \n		siteId \n\n		trigger \n		data \n		updates\n\n\n	}\n}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var SEND_MAIL = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var MAIL_COUNT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var FILTER_MAILS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var MAIL = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());


/***/ }),

/***/ 64487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J3": function() { return /* binding */ FOLDERS_MEDIA; },
/* harmony export */   "bi": function() { return /* binding */ FILTER_MEDIA; },
/* harmony export */   "dP": function() { return /* binding */ MEDIA_COUNT; },
/* harmony export */   "iD": function() { return /* binding */ MEDIA; },
/* harmony export */   "pm": function() { return /* binding */ PAGINATION_MEDIA; }
/* harmony export */ });
/* unused harmony export MEDIA_ITEM */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \nquery mediaCount($filter:FilterCountMediaInput) {\n  mediaCount(filter:$filter) \n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery mediaMany{\n	mediaMany {\n		title\n		alt\n		filename\n		folder \n		url\n		urlMin \n		urlThumb\n		siteId\n		size\n		_id\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery mediaPagination($filter: FilterFindManyMediaInput,  $page: Int, $perPage: Int) {\n	mediaPagination(filter: $filter, page: $page, perPage: $perPage){\n		items{\n			title\n			alt\n			filename\n			folder \n			url\n			urlMin \n			urlThumb\n			siteId\n			size\n			_id\n		}\n	}\n}"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery mediaMany($filter: FilterFindManyMediaInput,  $limit: Int, $skip: Int) {\n	mediaMany(filter: $filter, skip: $skip, limit: $limit){\n		title\n		alt\n		filename\n		folder \n		url\n		urlMin \n		urlThumb\n		siteId\n		size\n		_id\n	}\n}"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery mediaMany($filter: FilterFindManyMediaInput) {\n	mediaMany(filter: $filter){\n		folder \n		size\n		siteId\n	}\n}"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery mediaById ($_id: MongoID!) {\n	mediaById(_id: $_id){\n		title\n		alt\n		filename\n		folder \n		url\n		urlMin \n		urlThumb\n		siteId\n		size\n		_id\n	}\n}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var MEDIA_COUNT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var MEDIA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var PAGINATION_MEDIA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var FILTER_MEDIA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var FOLDERS_MEDIA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
var MEDIA_ITEM = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());


/***/ }),

/***/ 81913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cw": function() { return /* binding */ PAGE_VERSIONS; },
/* harmony export */   "mS": function() { return /* binding */ FILTER_PAGES; },
/* harmony export */   "q5": function() { return /* binding */ PAGES; },
/* harmony export */   "qX": function() { return /* binding */ PAGE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60138);
/* harmony import */ var _fragments_pages__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31600);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery pageMany($filter: FilterFindManyPageInput) {\n	pageMany(filter: $filter){\n    ",
        "\n  }\n}"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery pageById($_id: MongoID!) {\n  pageById(_id: $_id) {\n    ",
        "\n  }\n}"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery pageById($_id: MongoID!) {\n  pageById(_id: $_id) {\n    ",
        "\n  }\n}"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var PAGE_FIELDS = " \n  title\n  description  \n  unique\n  slug \n\n  date \n  map \n  data \n  type\n  dynamic \n\n  ".concat(_fragments_pages__WEBPACK_IMPORTED_MODULE_1__/* .SEO_FRAGMENT */ .tM, "\n  \n  siteId \n  isEditing\n  status \n  \n  version\n  date\n  updatedAt \n  _id\n");
var PAGE_UPDATES = " \n  title\n  description \n  siteId \n  version\n  date\n  updatedAt \n  _id\n  updates\n";
var PAGES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), PAGE_FIELDS);
var FILTER_PAGES = PAGES;
var PAGE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1(), PAGE_FIELDS);
var PAGE_VERSIONS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject2(), PAGE_UPDATES);


/***/ }),

/***/ 71204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cz": function() { return /* binding */ PUBLIC_SITES; },
/* harmony export */   "Ey": function() { return /* binding */ SITE; },
/* harmony export */   "H6": function() { return /* binding */ FILTER_SITES; },
/* harmony export */   "I7": function() { return /* binding */ PUBLIC_SITE; },
/* harmony export */   "ZS": function() { return /* binding */ SITES; },
/* harmony export */   "j2": function() { return /* binding */ VALIDATE_SUBDOMAIN; },
/* harmony export */   "nX": function() { return /* binding */ SITE_TEAM; }
/* harmony export */ });
/* unused harmony exports DOMAINS, SITE_ONE */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _api_fragments_pages__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31600);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery siteMany{\n	siteMany {\n		name\n      	subdomain\n		customDomain\n		domains\n		nav\n		indexes \n		dynamic \n		themeId\n		footer \n		header\n		locales\n		logo\n		code \n		theme\n		analytics {\n			gaMeasurementId\n			disableTracking\n			respectPrivacy\n			analyticsId\n		}\n\n		_id\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery siteMany{\n	siteMany {\n		",
        "\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery siteMany($filter: FilterFindManySiteInput) {\n	siteMany(filter: $filter){\n		name\n      	description\n      	subdomain\n		customDomain\n		domains\n      	userId\n		pages\n		team\n		createdAt\n		updatedAt\n		users {\n			userId \n			role\n		}\n		_id\n	}\n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery siteById($_id: MongoID!) {\n	siteById(_id: $_id){\n		",
        "\n	}\n}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery siteMany($filter: FilterFindManySiteInput) {\n	siteMany(filter: $filter){\n		name\n      	description\n      	subdomain\n		customDomain\n		domains\n	}\n}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery siteById($_id: MongoID!) {\n	siteById(_id: $_id){\n		name\n      	description\n      	subdomain\n		customDomain\n		domains\n	}\n}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery siteById($_id: MongoID!) {\n	siteById(_id: $_id){\n		team\n		customDomain\n		domains\n		subdomain\n	}\n}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery siteOne($filter: FilterFindOneSiteInput) {\n	siteOne(filter: $filter){\n		name\n      	description\n      	subdomain\n		customDomain\n		domains\n      	userId\n		_id\n	}\n}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery siteValidateSubdomain($subdomain: String!){\n	siteValidateSubdomain(subdomain: $subdomain) {\n		response\n	}\n}\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var SITE_FIELDS = " \n	name\n	description\n	\n	mode\n	subdomain\n	customDomain\n	domains\n\n	userId\n	users {\n		userId \n		role\n	}\n	teams {\n		teamId\n		role\n	}\n	team\n\n\n	theme\n	themeId\n	locales\n	".concat(_api_fragments_pages__WEBPACK_IMPORTED_MODULE_1__/* .SEO_FRAGMENT */ .tM, "\n	logo\n	pages\n\n	code\n	header\n	footer\n\n	options\n	schemas\n\n	nav\n	indexes\n	dynamic\n\n	tokens\n	mixins\n	breakpoints\n	screens\n	notifications\n\n	createdAt\n	updatedAt\n\n	analytics {\n		gaMeasurementId\n		disableTracking\n		respectPrivacy\n		analyticsId\n		referenceSlug\n	}\n\n\n	_id\n");
var DOMAINS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject());
var SITES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1(), SITE_FIELDS);
var FILTER_SITES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject2());
var SITE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject3(), SITE_FIELDS);
var PUBLIC_SITES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject4());
var PUBLIC_SITE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject5());
var SITE_TEAM = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject6());
var SITE_ONE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject7());
var VALIDATE_SUBDOMAIN = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject8());


/***/ }),

/***/ 17302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FV": function() { return /* binding */ TEAM; },
/* harmony export */   "Vv": function() { return /* binding */ FIND_TEAM; },
/* harmony export */   "w1": function() { return /* binding */ LIST_ALL_TEAMS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery teamMany($filter: FilterFindManyTeamInput) {\n	teamMany(filter: $filter){\n		name\n		sector \n		description \n		superAdmin \n		isActive \n		subscription {\n			premium \n			active \n			ending \n			started \n			userCount \n			data \n			addons \n			trial \n		}\n		registrationDate \n		sites {\n			siteId \n		}\n		users {\n			userId \n			role \n		}\n		notifications \n		teamAuthor {\n			displayName \n			bio \n			biography\n		}\n		_id\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery teamMany($filter: FilterFindManyTeamInput) {\n	teamMany(filter: $filter){\n		name\n		sector \n		description \n		isActive \n		_id\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery teamById ($_id: MongoID!) {\n	teamById(_id: $_id){\n		name\n		sector \n		description \n		superAdmin \n		isActive \n		subscription {\n			premium \n			active \n			ending \n			started \n			userCount \n			data \n			addons \n			trial \n		}\n		registrationDate \n		sites {\n			siteId \n		}\n		users {\n			userId \n			role \n			roles\n		}\n		notifications \n		teamAuthor {\n			displayName \n			bio \n			biography\n		}\n		_id\n	}\n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var LIST_ALL_TEAMS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var FIND_TEAM = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var TEAM = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());


/***/ }),

/***/ 62641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EL": function() { return /* binding */ FIND_USER; },
/* harmony export */   "Fi": function() { return /* binding */ PUBLIC_USERS; },
/* harmony export */   "LW": function() { return /* binding */ FILTER_USERS; },
/* harmony export */   "c4": function() { return /* binding */ USER_COUNT; },
/* harmony export */   "xR": function() { return /* binding */ USER; },
/* harmony export */   "yN": function() { return /* binding */ LIST_ALL_USERS; }
/* harmony export */ });
/* unused harmony exports USER_IDS, PLATFORM_USERS */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery userMany($filter: FilterFindManyUserInput, $limit: Int, $skip: Int) {\n	userMany(filter: $filter, limit: $limit, skip: $skip){\n		email,\n		isAdmin,\n		isActive\n		registrationDate\n		lastLogin\n		sites {\n			siteId\n		}\n		teams {\n			_id\n			role\n		}\n		siteId\n		altId\n		role \n		stripeCustomer\n		subscription {\n			premium\n			active\n			ending\n			started\n			\n			data\n			addons\n			trial\n		}\n		data\n		author {\n			firstName\n			lastName\n			displayName\n			bio\n			biography\n			profilePicture\n		}\n		_id\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery userMany($filter: FilterFindManyUserInput, $limit: Int, $skip: Int) {\n	userMany(filter: $filter, limit: $limit, skip: $skip){\n		author { \n			firstName\n			lastName\n		}\n		_id \n		siteId\n	}\n}"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \nquery userCount($filter:FilterCountUserInput) {\n  userCount(filter:$filter) \n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery userMany($filter: FilterFindManyUserInput, $limit: Int, $skip: Int) {\n	userMany(filter: $filter, limit: $limit, skip: $skip){\n		email,\n		isAdmin,\n		isActive\n		registrationDate\n		lastLogin\n		sites {\n			siteId\n		}\n		teams {\n			_id\n			role\n		}\n		siteId\n		altId\n		role \n		status\n		stripeCustomer\n		subscription {\n			premium\n			active\n			ending\n			started\n			\n			data\n			addons\n			trial\n		}\n		author {\n			firstName\n			lastName\n			displayName\n			bio\n			biography\n			profilePicture\n		}\n		_id\n	}\n}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery userMany($filter: FilterFindManyUserInput, $limit: Int, $skip: Int) {\n	userMany(filter: $filter, limit: $limit, skip: $skip){\n		email,\n		altId\n		author {\n			firstName\n			lastName\n			displayName\n			profilePicture\n		}\n		_id\n	}\n}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery userMany($filter: FilterFindManyUserInput, $limit: Int, $skip: Int) {\n	userMany(filter: $filter, limit: $limit, skip: $skip){\n		email,\n		siteId\n		altId\n		role \n		subscription {\n			premium\n			active\n			ending\n			started\n			\n			data\n			addons\n			trial\n		}\n		author {\n			firstName\n			lastName\n			displayName\n		}\n		_id\n	}\n}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery userMany($filter: FilterFindManyUserInput) {\n	userMany(filter: $filter){\n		email \n		author {\n			firstName \n			lastName\n			profilePicture\n		}\n		status\n		siteId\n		altId\n		role \n		isActive \n		_id\n	}\n}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nquery userById ($_id: MongoID!) {\n	userById(_id: $_id){\n		email\n		isAdmin\n		isActive\n		registrationDate\n		lastLogin\n		_id\n		author {\n			firstName\n			lastName\n			displayName\n			bio\n			biography\n			profilePicture\n		}\n		sites {\n			siteId\n			role\n		}\n		teams {\n			_id\n			role\n		}\n		status\n		siteId\n		altId\n		role \n		data\n\n		stripeCustomer\n		pref\n		subscription {\n			premium\n			active\n			ending\n			started\n\n			data\n			addons\n			trial\n		}\n		security\n		notifications\n	}\n}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var LIST_ALL_USERS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var USER_IDS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var USER_COUNT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var FILTER_USERS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var PUBLIC_USERS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
var PLATFORM_USERS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());
var FIND_USER = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6());
var USER = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject7());


/***/ }),

/***/ 44375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ convertColumnsToSchema; },
/* harmony export */   "g": function() { return /* binding */ baseSchemaFields; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96670);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68311);



var baseSchemaFields = [
    {
        //     name: 'siteId',
        //     type: 'string',
        //     disabled: true
        // },{
        name: "_id",
        type: "string",
        disabled: true
    }
];
var convertColumnsToSchema = function(columnsSchema) {
    return columnsSchema.map(function(field) {
        return !(field === null || field === void 0 ? void 0 : field.overview) ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, field), {
            name: (field === null || field === void 0 ? void 0 : field.slug) ? field === null || field === void 0 ? void 0 : field.slug : (field === null || field === void 0 ? void 0 : field.name) ? field.name : field === null || field === void 0 ? void 0 : field.label,
            label: (field === null || field === void 0 ? void 0 : field.label) ? field.label : (0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .revertDevCases */ .Uw)(field === null || field === void 0 ? void 0 : field.name),
            disabled: false
        }) : null;
    });
};


/***/ }),

/***/ 18692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V_": function() { return /* binding */ collectionsSchema; },
/* harmony export */   "jm": function() { return /* binding */ collectionSchema; }
/* harmony export */ });
/* unused harmony export collectionColumns */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50930);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44375);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62570);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68311);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80309);
/* harmony import */ var _util_Num__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3121);



var StatusOptions = [
    "PLANNED",
    "PUBLISHED",
    "PENDING",
    "DRAFT",
    "DISABLED",
    "EDITING",
    "HIDDEN",
    "LOCKED",
    "TRASHED", 
];






var collectionColumns = [
    {
        name: "title",
        type: "text"
    },
    {
        name: "description",
        type: "text"
    },
    {
        name: "Fields",
        type: "custom"
    },
    {
        name: "Entries",
        type: "text"
    },
    {
        name: "Linked",
        type: "text"
    },
    {
        name: "Base route",
        slug: "baseRoute",
        type: "text"
    }
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_base__WEBPACK_IMPORTED_MODULE_1__/* .baseSchemaFields */ .g));
var overwrite = function(f) {
    if ((f === null || f === void 0 ? void 0 : f.name) === "Biography") return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, f), {
        type: "textarea"
    });
    return f;
};
var validate = function(props, option) {
    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "collection";
    return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_4__/* .get */ .U2)(props, option) && props.type === type;
};
var formatCollectionForDataGridColumns = function(c) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, c), {
        Fields: c === null || c === void 0 ? void 0 : (ref = c.schema) === null || ref === void 0 ? void 0 : (ref1 = ref.length) === null || ref1 === void 0 ? void 0 : ref1.toString(),
        Entries: (c === null || c === void 0 ? void 0 : (ref2 = c.entries) === null || ref2 === void 0 ? void 0 : ref2.length) ? c === null || c === void 0 ? void 0 : (ref3 = c.entries) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.length) === null || ref4 === void 0 ? void 0 : ref4.toString() : (0,_util_Num__WEBPACK_IMPORTED_MODULE_5__/* .isNumber */ .hj)(c === null || c === void 0 ? void 0 : c.entries) ? c === null || c === void 0 ? void 0 : c.entries : "0",
        Linked: (0,_util_Text__WEBPACK_IMPORTED_MODULE_6__/* .isString */ .HD)(c === null || c === void 0 ? void 0 : (ref5 = c.entries) === null || ref5 === void 0 ? void 0 : ref5[0]) || (c === null || c === void 0 ? void 0 : c.linked) ? "true" : "false"
    });
};
var collectionsSchema = {
    groups: [
        "base",
        "preview",
        "schema"
    ],
    formatting: {
        columns: formatCollectionForDataGridColumns,
        entries: function(entry) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, entry, entry === null || entry === void 0 ? void 0 : entry.data, entry === null || entry === void 0 ? void 0 : entry.map, entry === null || entry === void 0 ? void 0 : entry.filters, entry === null || entry === void 0 ? void 0 : entry.props), {
                map: undefined,
                data: undefined,
                filters: undefined,
                props: undefined
            });
        }
    },
    site: {
    },
    columns: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(collectionColumns),
    props: {
        multiple: "collections",
        singular: "collection",
        type: [
            "collection",
            "form"
        ],
        info: {
            title: "Collections",
            label: "Manage your data collections",
            help: "Mosanic collections are the place where you can store your data",
            slug: [
                {
                    href: "/site",
                    label: "Site"
                }
            ]
        },
        empty: {
            title: "No collections found.",
            label: "Let's start with creating your site's first data collection."
        },
        controls: {
            create: "create",
            update: "update",
            delete: "delete",
            view: "view"
        },
        routing: {
            indexPath: null,
            basePath: "collection"
        },
        editor: {
            schema: true,
            entry: "data_table"
        },
        entries: true
    },
    base: [
        {
            name: "status",
            type: "select",
            options: StatusOptions
        },
        {
            name: "singular",
            type: "text"
        },
        {
            name: "inside",
            type: "switch"
        },
        {
            name: "limit",
            type: "number",
            when: function(props) {
                return props.type != "collection";
            }
        }
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_base__WEBPACK_IMPORTED_MODULE_1__/* .convertColumnsToSchema */ .S)(collectionColumns).map(function(f) {
        return overwrite(f);
    })), [
        {
            label: "Form",
            name: "form",
            when: function(props) {
                return props.type === "form";
            },
            schema: [
                {
                    name: "type",
                    label: "Stepper flow",
                    helpText: "Each field is displayed in a separate step. To combine fields in a step, use a group field.",
                    type: "switch",
                    when: function(props) {
                        return props.type === "form";
                    }
                },
                {
                    name: "dataDelete",
                    label: "Auto delete",
                    type: "select",
                    options: "7 days|14 days|1 month|3 months|6 months|fill-up".split("|"),
                    when: function(props) {
                        return props.type === "form";
                    }
                }
            ]
        },
        {
            //     name: 'config',
            //     label: 'Entry config',
            //     schema: [{
            //         name: 'notLinked',
            //         label: 'Entries inside schema',
            //         helpText: 'Entries',
            //         type: 'switch',
            //         fullWidth: true
            //     }]
            // },{
            label: "Routing",
            name: "routing",
            when: function(props) {
                return props.type === "collection";
            },
            schema: [
                {
                    name: "catchRoutes",
                    label: "Catch routes",
                    type: "switch"
                },
                {
                    name: "frontEnd",
                    label: "Front end",
                    type: "switch"
                },
                {
                    name: "baseRoute",
                    label: "Base route",
                    type: "text",
                    when: function(props) {
                        return validate(props, "routing.catchRoutes");
                    }
                },
                {
                    name: "dynamicPage",
                    label: "Dynamic page",
                    type: "page",
                    when: function(props) {
                        return validate(props, "routing.catchRoutes");
                    }
                },
                {
                    name: "editRoute",
                    label: "Edit route",
                    type: "text",
                    when: function(props) {
                        return validate(props, "routing.frontEnd");
                    }
                },
                {
                    name: "editPage",
                    label: "Edit page",
                    type: "page",
                    when: function(props) {
                        return validate(props, "routing.frontEnd");
                    }
                },
                {
                    name: "indexPage",
                    label: "Index page",
                    type: "page",
                    when: function(props) {
                        return validate(props, "routing.catchRoutes");
                    }
                },
                {
                    name: "notFoundPage",
                    label: "404 page",
                    type: "page",
                    when: function(props) {
                        return validate(props, "routing.catchRoutes");
                    }
                }
            ]
        }
    ])
};
var getCollectionSchema = function() {
    var schema = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .updateSlug */ .eH)(collectionsSchema, [
        {
            href: "/site",
            label: "Site"
        },
        {
            href: "/site/collections",
            label: "Collections"
        }
    ]);
    schema = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .updateSchemaProp */ .F3)({
        schema: schema,
        path: "props.routing.indexPath",
        data: "/site/collections"
    });
    schema = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .updateSchemaProp */ .F3)({
        schema: schema,
        path: "props.editor.entry",
        data: "entry"
    });
    return schema;
};
var collectionSchema = getCollectionSchema();


/***/ }),

/***/ 80309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ae": function() { return /* binding */ combineIntoDataTableSchema; },
/* harmony export */   "F3": function() { return /* binding */ updateSchemaProp; },
/* harmony export */   "eH": function() { return /* binding */ updateSlug; },
/* harmony export */   "xl": function() { return /* binding */ removeSchemaInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96670);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62570);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76665);




var getIndexDetails = function(param) {
    var _title = param.title, title = _title === void 0 ? null : _title, _label = param.label, label = _label === void 0 ? null : _label, _help = param.help, help = _help === void 0 ? null : _help, slug = param.slug, data = param.data;
    return {
        title: (data === null || data === void 0 ? void 0 : data.title) ? data.title : title,
        label: (data === null || data === void 0 ? void 0 : data.description) ? data.description : (data === null || data === void 0 ? void 0 : data.label) ? data.label : label,
        help: (data === null || data === void 0 ? void 0 : data.help) ? data.help : help,
        slug: (data === null || data === void 0 ? void 0 : data.slug) ? data.slug : slug
    };
};
var getEmptyDetails = function(param) {
    var _title = param.title, title = _title === void 0 ? null : _title, _label = param.label, label = _label === void 0 ? null : _label, _help = param.help, help = _help === void 0 ? null : _help, slug = param.slug, data = param.data;
    return {
        title: (data === null || data === void 0 ? void 0 : data.title) ? data.title : title,
        label: (data === null || data === void 0 ? void 0 : data.description) ? data.description : (data === null || data === void 0 ? void 0 : data.label) ? data.label : label,
        help: (data === null || data === void 0 ? void 0 : data.help) ? data.help : help,
        slug: (data === null || data === void 0 ? void 0 : data.slug) ? data.slug : slug
    };
};
var getSubDataTableSchema = function(base) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, base), {
        props: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, base.props), {
            info: null,
            level: base.props.level + 1
        })
    });
};
var combineIntoDataTableSchema = function(param) {
    var dataTableSchema = param.dataTableSchema, config = param.config, data = param.data;
    return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(dataTableSchema, function(base) {
        var ref, ref1;
        base.singular = (data === null || data === void 0 ? void 0 : data.singular) ? data.singular : (0,_util_Obj__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(base, "props.singular");
        base.multiple = (data === null || data === void 0 ? void 0 : data.multiple) ? data.multiple : (0,_util_Obj__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(base, "props.multiple");
        base.info = getIndexDetails((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            data: data
        }, (0,_util_Obj__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(base, "props.info")));
        base.props.level = ((ref = base.props) === null || ref === void 0 ? void 0 : ref.level) ? (ref1 = base.props) === null || ref1 === void 0 ? void 0 : ref1.level : 1;
        base.props.empty = getEmptyDetails((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            data: data
        }, (0,_util_Obj__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(base, "props.info")));
        base.dataTable = getSubDataTableSchema(base);
    });
};
var updateSchemaProp = function(param) {
    var schema = param.schema, path = param.path, data = param.data;
    return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(schema, function(base) {
        (0,_util_Obj__WEBPACK_IMPORTED_MODULE_3__/* .set */ .t8)(base, path, data);
    });
};
var updateSlug = function(schema) {
    var slug = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return updateSchemaProp({
        schema: schema,
        path: "props.info.slug",
        data: slug
    });
};
var removePaths = function(param) {
    var schema = param.schema, paths = param.paths;
    paths.map(function(path) {
        schema = updateSchemaProp({
            schema: schema,
            path: path,
            data: null
        });
    });
    return schema;
};
var removeSchemaInfo = function(schema) {
    return updateSchemaProp({
        schema: removePaths({
            schema: schema,
            paths: [
                "props.info",
                "props.empty"
            ]
        }),
        path: "props.level",
        data: 4
    });
};


/***/ }),

/***/ 81841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ mailsSchema; },
/* harmony export */   "D": function() { return /* binding */ mailColumns; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50930);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44375);




var mailColumns = [
    {
        name: "title",
        type: "text"
    },
    {
        name: "description",
        type: "text"
    },
    {
        name: "type",
        type: "string"
    },
    {
        name: "defaultSender",
        type: "string"
    },
    {
        name: "collectionId",
        type: "text"
    },
    {
        name: "entries",
        type: "text"
    }
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_base__WEBPACK_IMPORTED_MODULE_1__/* .baseSchemaFields */ .g));
var shouldGet = function(f) {
    return !"_id|entries".split("|").includes(f === null || f === void 0 ? void 0 : f.name);
};
var overwrite = function(f) {
    if ((f === null || f === void 0 ? void 0 : f.name) === "Biography") return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, f), {
        type: "textarea"
    });
    return f;
};
var mailsSchema = {
    groups: [
        "base",
        "schema",
        "variables",
        "templates",
        "log"
    ],
    props: {
        multiple: "mails",
        singular: "mail",
        // types: list_roles,
        info: {
            title: "Mails",
            label: "Manage your platform mail templates",
            help: "Create mail templates which can be triggered manual or by a entry edit/ creation.",
            slug: [
                {
                    href: "/site",
                    label: "Site"
                }
            ]
        },
        empty: {
            title: "No mail templates found.",
            label: "Let's start with creating your site's first mail template."
        },
        controls: {
            create: "create",
            update: "update",
            delete: "delete",
            view: "view"
        },
        routing: {
            basePath: "mail"
        },
        editor: {
            schema: false,
            entry: "editor_provider"
        },
        entries: false
    },
    base: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_base__WEBPACK_IMPORTED_MODULE_1__/* .convertColumnsToSchema */ .S)(mailColumns).filter(function(f) {
        return shouldGet(f);
    }).flatMap(function(f) {
        return overwrite(f);
    })).concat([
        {
            name: "collectionId",
            label: "Linked Collection",
            type: "collections",
            base: true,
            fullWidth: true
        },
        {
            name: "type",
            label: "Template type",
            type: "text",
            base: true,
            fullWidth: true
        },
        {
            label: "Mail config",
            name: "data",
            schema: [
                {
                    name: "senderName",
                    label: "Sender name",
                    type: "text"
                },
                {
                    name: "templateId",
                    label: "Template id",
                    type: "text"
                },
                {
                    name: "defaultSender",
                    label: "Default sender",
                    type: "email"
                },
                {
                    name: "defaultReceiver",
                    label: "Default receiver",
                    type: "email"
                }
            ]
        }
    ]),
    schema: [
        {
            name: "template_name",
            type: "text"
        },
        {
            name: "subject",
            type: "text"
        },
        {
            name: "preHeader",
            type: "text"
        },
        {
            name: "content",
            type: "visual"
        },
        {
            name: "content",
            type: "visual"
        }
    ]
};


/***/ }),

/***/ 75211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IK": function() { return /* binding */ userSchema; }
/* harmony export */ });
/* unused harmony exports subscriptionColumns, userColumns, getSiteUserSchema */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50930);
/* harmony import */ var _mosanic_components_Team_roles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36563);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44375);






var subscriptionColumns = [
    {
        name: "gained",
        type: "number"
    },
    {
        name: "Gained Pending",
        slug: "gained_pending",
        type: "number"
    },
    {
        name: "spend",
        type: "number"
    },
    {
        name: "Spend Pending",
        slug: "spend_pending",
        type: "number"
    },
    {
        name: "credits",
        type: "number"
    }
].map(function(f) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, f), {
        slug: "subscription.data.".concat((f === null || f === void 0 ? void 0 : f.slug) ? f.slug : f.name)
    });
});
var userColumns = [
    {
        name: "First name",
        slug: "author.firstName",
        type: "text"
    },
    {
        name: "Last name",
        slug: "author.lastName",
        type: "text"
    },
    {
        name: "Biography",
        slug: "author.biography",
        type: "text"
    },
    {
        name: "Started",
        slug: "subscription.started",
        type: "date"
    },
    {
        name: "Ending",
        slug: "subscription.ending",
        type: "date"
    },
    {
        name: "role",
        type: "select",
        options: _mosanic_components_Team_roles__WEBPACK_IMPORTED_MODULE_2__/* .list_roles */ .cT,
        base: true
    },
    {
        name: "Stripe Identifier",
        slug: "stripeCustomer",
        type: "text",
        fullWidth: true
    },
    {
        name: "status",
        type: "select",
        options: [
            "active",
            "disabled"
        ]
    },
    {
        name: "email",
        type: "email",
        disabled: true
    }
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_base__WEBPACK_IMPORTED_MODULE_4__/* .baseSchemaFields */ .g));
var overwrite = function(f) {
    if ((f === null || f === void 0 ? void 0 : f.label) === "Biography") return [
        {
            label: "Profile picture",
            name: "author.profilePicture",
            type: "image",
            fullWidth: true,
            base: true
        },
        {
            label: "Short Bio",
            name: "author.bio",
            type: "text",
            fullWidth: true,
            base: true
        },
        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, f), {
            type: "textarea",
            fullWidth: true,
            base: true
        }), 
    ];
    if ((f === null || f === void 0 ? void 0 : f.name) === "role") return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, f), {
        fullWidth: true,
        base: true
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, f), {
        base: true
    });
};
var shouldGet = function(f) {
    return !"email|status|Ending|Started".split("|").includes(f === null || f === void 0 ? void 0 : f.name);
};
var formatUserForDataGridColumns = function(user) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, user), {
        // slug: `/user/${user?._id}`,
        date: user.registrationDate,
        status: (user === null || user === void 0 ? void 0 : user.isAdmin) ? "admin" : (user === null || user === void 0 ? void 0 : user.isActive) ? "active" : ""
    });
};
var getSiteUserSchema = function(site) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref, ref1, ref2;
    if (!(site === null || site === void 0 ? void 0 : site.schemas)) return {};
    var schema = (site === null || site === void 0 ? void 0 : (ref = site.schemas) === null || ref === void 0 ? void 0 : ref.users) ? site === null || site === void 0 ? void 0 : (ref1 = site.schemas) === null || ref1 === void 0 ? void 0 : ref1.users : site === null || site === void 0 ? void 0 : (ref2 = site.schemas) === null || ref2 === void 0 ? void 0 : ref2.user;
    return !schema ? schema : format ? schema.filter(function(o, i) {
        return i != 0;
    }) // todo --> move subscription data to: 'data.'
    .map(function(o) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, o), {
            slug: "subscription.data.".concat(o === null || o === void 0 ? void 0 : o.name),
            name: "subscription.data.".concat(o === null || o === void 0 ? void 0 : o.name),
            base: true,
            fullWidth: (o === null || o === void 0 ? void 0 : o.name) === "credits"
        });
    }) : schema;
};
var userSchema = {
    formatting: {
        columns: formatUserForDataGridColumns
    },
    site: {
        schema: getSiteUserSchema
    },
    columns: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(userColumns),
    groups: [
        "base",
        "mail"
    ],
    base: [
        {
            name: "email",
            type: "email",
            disabled: true,
            base: true,
            fullWidth: true
        },
        {
            name: "password",
            type: "password",
            base: true,
            fullWidth: true
        }
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_base__WEBPACK_IMPORTED_MODULE_4__/* .convertColumnsToSchema */ .S)(userColumns).filter(function(f) {
        return shouldGet(f);
    }).flatMap(function(f) {
        return overwrite(f);
    })), [
        {
            name: "siteId",
            type: "text",
            // type ===> // todo --> 'site'
            base: true,
            disabled: true,
            fullWidth: true
        }
    ]),
    props: {
        multiple: "users",
        singular: "user",
        types: _mosanic_components_Team_roles__WEBPACK_IMPORTED_MODULE_2__/* .list_roles */ .cT,
        info: {
            title: "Users",
            label: "Manage your platform users",
            help: "Mosanic users cms are the place where you can view an manage your user",
            slug: [
                {
                    href: "/site",
                    label: "Site"
                }
            ]
        },
        empty: {
            title: "No users found.",
            label: "Let's start with creating your site's first user."
        },
        controls: {
            create: "create",
            update: "update",
            delete: "delete",
            view: "view"
        },
        routing: {
            basePath: "user"
        },
        editor: {
            schema: false,
            entry: "editor_provider"
        },
        entries: false
    },
    schema: []
};


/***/ }),

/***/ 94645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ov": function() { return /* binding */ clearSession; },
  "TD": function() { return /* binding */ decodeToken; },
  "gS": function() { return /* binding */ getDecodedToken; },
  "$8": function() { return /* binding */ isAuthenticated; },
  "pw": function() { return /* binding */ isTokenExpired; },
  "Sr": function() { return /* binding */ recoverToken; },
  "mB": function() { return /* binding */ storeToken; }
});

// UNUSED EXPORTS: hasToken, isTokenValid

;// CONCATENATED MODULE: ../../node_modules/jwt-decode/build/jwt-decode.esm.js
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* harmony default export */ var jwt_decode_esm = (o);
//# sourceMappingURL=jwt-decode.esm.js.map

// EXTERNAL MODULE: ./src/utils/Date.js
var utils_Date = __webpack_require__(99787);
// EXTERNAL MODULE: ./src/utils/server/cookie.js
var cookie = __webpack_require__(18053);
// EXTERNAL MODULE: ./src/utils/server/session.js
var session = __webpack_require__(81866);
// EXTERNAL MODULE: ./src/adapters/constants.js
var constants = __webpack_require__(1418);
// EXTERNAL MODULE: ./src/utils/Empty.js
var Empty = __webpack_require__(75276);
// EXTERNAL MODULE: ./src/utils/Device.js
var Device = __webpack_require__(17629);
;// CONCATENATED MODULE: ./src/adapters/token.js







var decodeToken = function(token) {
    var decodedToken = token ? jwt_decode_esm(token) : {};
    if (!(decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken._id) || !(decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.email)) return false;
    return {
        email: decodedToken.email,
        isAdmin: decodedToken.isAdmin,
        isActive: decodedToken.isActive,
        _id: decodedToken._id,
        exp: decodedToken.exp
    };
};
var isTokenExpired = function(exp) {
    var expires = new Date(exp * 1000);
    var now = new Date();
    if (expires > now) return false;
    return (0,utils_Date/* getDif */.mD)(expires);
};
var isTokenValid = function(token) {
    var ref = decodeToken(token), exp = ref.exp, isActive = ref.isActive;
    return Boolean(!isTokenExpired(exp) && isActive);
};
var getToken = function() {
    return (0,cookie/* recoverCookie */.DX)(constants/* AUTH_TOKEN */.U);
};
var saveToken = function(token) {
    return (0,cookie/* saveCookie */.YB)(constants/* AUTH_TOKEN */.U, token);
};
var getSessionToken = function() {
    return (0,session/* recoverSession */.x7)(constants/* AUTH_TOKEN */.U);
};
var saveSessionToken = function(token) {
    return (0,session/* saveSession */.Aj)(constants/* AUTH_TOKEN */.U, token);
};
var getLocalToken = function() {
    return !(0,Device/* isServer */.sk)() && localStorage.getItem(constants/* AUTH_TOKEN */.U);
};
var saveLocalStorage = function(token) {
    return !(0,Device/* isServer */.sk)() && localStorage.setItem(constants/* AUTH_TOKEN */.U, token);
};
var recoverToken = function() {
    return getToken() || getSessionToken() || getLocalToken();
};
var hasToken = function() {
    return !(0,Empty/* default */.Z)(recoverToken());
};
var storeToken = function(token) {
    var remember = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (remember || true) saveToken(token);
    if (remember || true) saveLocalStorage(token);
    saveSessionToken(token);
};
var clearSession = function() {
    if (!(0,Device/* isServer */.sk)()) localStorage.removeItem(constants/* AUTH_TOKEN */.U);
    (0,cookie/* deleteCookie */.kT)(constants/* AUTH_TOKEN */.U);
    (0,session/* deleteSession */.SO)();
};
var isAuthenticated = function() {
    return Boolean(hasToken() && isTokenValid(recoverToken()));
};
var getDecodedToken = function() {
    return hasToken() ? decodeToken(recoverToken()) : null;
};


/***/ }),

/***/ 74079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ FONT_SCALES; },
/* harmony export */   "DZ": function() { return /* binding */ EDITOR_MODES; },
/* harmony export */   "Wj": function() { return /* binding */ MAIN_SHADE; },
/* harmony export */   "aC": function() { return /* binding */ COLUMN; },
/* harmony export */   "d8": function() { return /* binding */ SIDEBAR_ITEM; },
/* harmony export */   "gq": function() { return /* binding */ LARGEST_BP; },
/* harmony export */   "vo": function() { return /* binding */ SIDEBAR_LAYOUT; }
/* harmony export */ });
/* unused harmony exports SIDEBAR_STACK, SIDEBAR_REPEATER, SIDEBAR_PANEL, ADD_ITEM, ROW, STACK, COMPONENT, REPEATER, SMALLEST_BP, LAYOUT_STATES, DESIGN_STATES, DEFAULT_STATE, HOVER_STATE, COLOR_OPTIONS, COLOR_SHADES, INITIAL_METRICS, ADD_LAYOUTS */
var SIDEBAR_ITEM = "sidebarItem";
var SIDEBAR_STACK = "sidebarContainer";
var SIDEBAR_REPEATER = "sidebarRepeater";
var SIDEBAR_PANEL = "sidebarPanel";
var ADD_ITEM = "addItem";
var SIDEBAR_LAYOUT = "layoutItem";
var ROW = "ROW";
var COLUMN = "COLUMN";
var STACK = "STACK";
var COMPONENT = "COMPONENT";
var REPEATER = "REPEATER";
var SMALLEST_BP = "xs";
var LARGEST_BP = "xl";
var LAYOUT_STATES = "layouts";
var DESIGN_STATES = "design";
var DEFAULT_STATE = "default";
var HOVER_STATE = "hover";
var EDITOR_MODES = [
    {
        name: "Classic",
        value: "classic"
    },
    {
        name: "Inline",
        value: "inline"
    },
    {
        name: "Balloon",
        value: "balloon"
    },
    {
        name: "Follow",
        value: "balloon-always"
    }, 
];
var COLOR_OPTIONS = [
    {
        name: "Color",
        value: "#F8F8F8"
    },
    {
        name: "Color",
        value: "#F4F7FA"
    },
    {
        name: "Color",
        value: "#E7E9ED"
    },
    {
        name: "Color",
        value: "#D5D7DD"
    },
    {
        name: "Color",
        value: "#7D818D"
    },
    {
        name: "Color",
        value: "#666666"
    },
    {
        name: "Color",
        value: "#1E1E20"
    },
    {
        name: "Color",
        value: "#FF6900"
    },
    {
        name: "Color",
        value: "#FCB900"
    },
    {
        name: "Color",
        value: "#7BDCB5"
    },
    {
        name: "Color",
        value: "#00D084"
    },
    {
        name: "Color",
        value: "#8ED1FC"
    },
    {
        name: "Color",
        value: "#0693E3"
    },
    {
        name: "Color",
        value: "#ABB8C3"
    },
    {
        name: "Color",
        value: "#EB144C"
    },
    {
        name: "Color",
        value: "#F78DA7"
    },
    {
        name: "Color",
        value: "#9900EF"
    }
];
var FONT_SCALES = [
    {
        value: 1.067,
        label: "1.067 - Minor Second"
    },
    {
        value: 1.125,
        label: "1.125 - Major Second"
    },
    {
        value: 1.200,
        label: "1.200 - Minor Third"
    },
    {
        value: 1.250,
        label: "1.250 - Major Third"
    },
    {
        value: 1.333,
        label: "1.333 - Perfect Fourth"
    },
    {
        value: 1.414,
        label: "1.414 - Super Fourth"
    },
    {
        value: 1.500,
        label: "1.500 - Perfect Fifth"
    },
    {
        value: 1.618,
        label: "1.618 - Golden Ratio"
    }, 
];
var MAIN_SHADE = 3;
var COLOR_SHADES = [
    {
        name: "Main shades",
        type: "shades",
        colors: [
            {
                type: "10",
                inPalette: false,
                inShading: true,
                name: "snow",
                value: "#F4F7FA"
            },
            {
                type: "20",
                inPalette: false,
                inShading: true,
                name: "mist",
                value: "#E7E9ED"
            },
            {
                type: "30",
                inPalette: false,
                inShading: true,
                name: "storm",
                value: "#D5D7DD"
            },
            {
                type: "40",
                inPalette: false,
                inShading: true,
                name: "stone",
                value: "#7D818D"
            },
            {
                type: "50",
                inPalette: false,
                inShading: true,
                name: "night",
                value: "#5A5E68"
            },
            {
                type: "60",
                inPalette: false,
                inShading: true,
                name: "gone",
                value: "#1E1E20"
            }, 
        ]
    },
    {
        name: "Primary",
        type: "main",
        colors: [
            {
                type: "10",
                inPalette: false,
                inShading: true,
                name: "soft",
                value: "#D7EFFE"
            },
            {
                type: "20",
                inPalette: false,
                inShading: true,
                name: "sky",
                value: "#A5DBFD"
            },
            {
                type: "30",
                inPalette: false,
                inShading: true,
                name: "soft",
                value: "#8ED1FC"
            },
            {
                type: "40",
                inPalette: false,
                inShading: true,
                name: "bright",
                value: "#0693E3"
            },
            {
                type: "50",
                inPalette: false,
                inShading: true,
                name: "ocean",
                value: "#046095"
            },
            {
                type: "60",
                inPalette: false,
                inShading: true,
                name: "sea",
                value: "#023350"
            }, 
        ]
    },
    {
        name: "Secondary",
        type: "secondary",
        colors: [
            {
                type: "10",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#D7EFFE"
            },
            {
                type: "20",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#A5DBFD"
            },
            {
                type: "30",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#8ED1FC"
            },
            {
                type: "40",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#0693E3"
            },
            {
                type: "50",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#046095"
            },
            {
                type: "60",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#023350"
            }, 
        ]
    },
    {
        name: "Error",
        type: "error",
        colors: [
            {
                type: "10",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#EB144C"
            },
            {
                type: "20",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#EB144C"
            },
            {
                type: "30",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#EB144C"
            },
            {
                type: "40",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#EB144C"
            },
            {
                type: "50",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#EB144C"
            },
            {
                type: "60",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#EB144C"
            }, 
        ]
    },
    {
        name: "Warning",
        type: "warning",
        colors: [
            {
                type: "10",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#FCB900"
            },
            {
                type: "20",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#FF6900"
            },
            {
                type: "30",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#FCB900"
            },
            {
                type: "40",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#FCB900"
            },
            {
                type: "50",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#FCB900"
            },
            {
                type: "60",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#FCB900"
            }, 
        ]
    },
    {
        name: "Success",
        type: "success",
        colors: [
            {
                type: "10",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#7BDCB5"
            },
            {
                type: "20",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#7BDCB5"
            },
            {
                type: "30",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#7BDCB5"
            },
            {
                type: "40",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#00D084"
            },
            {
                type: "50",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#00D084"
            },
            {
                type: "60",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#00D084"
            }, 
        ]
    },
    {
        name: "Utility colors",
        type: "util",
        colors: [
            {
                type: "10",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#ABB8C3"
            },
            {
                type: "20",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#9900EF"
            },
            {
                type: "30",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#F78DA7"
            },
            {
                type: "40",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#EA0EA0"
            },
            {
                type: "50",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#9900EF"
            },
            {
                type: "60",
                inPalette: false,
                inShading: true,
                name: "Color",
                value: "#212121"
            }, 
        ]
    }, 
];
var INITIAL_METRICS = {
    width: {
        label: "Width",
        id: "width",
        metric: "px",
        value: null,
        isDisabled: false,
        isDisabledReason: ""
    },
    height: {
        label: "Height",
        id: "height",
        metric: "px",
        value: null,
        isDisabled: false,
        isDisabledReason: ""
    },
    minWidth: {
        label: "Min width",
        id: "minWidth",
        metric: "px",
        value: null,
        isDisabled: false,
        isDisabledReason: ""
    },
    minHeight: {
        label: "Min height",
        id: "minHeight",
        metric: "px",
        value: null,
        isDisabled: false,
        isDisabledReason: ""
    },
    maxWidth: {
        label: "Max width",
        id: "maxWidth",
        metric: "px",
        value: null,
        isDisabled: false,
        isDisabledReason: ""
    },
    maxHeight: {
        label: "Max height",
        id: "maxHeight",
        metric: "px",
        value: null,
        isDisabled: true,
        isDisabledReason: "Text can't have a maximum height"
    }
};
var ADD_LAYOUTS = [
    {
        type: SIDEBAR_LAYOUT,
        title: "test row",
        path: "0-0",
        children: [
            {
                type: COLUMN,
                _id: "foxed1",
                children: [
                    {
                        type: COMPONENT,
                        _id: "component6"
                    }
                ]
            },
            {
                type: COLUMN,
                _id: "foxed2",
                width: "60",
                children: [
                    {
                        type: COMPONENT,
                        _id: "component2"
                    },
                    {
                        type: COMPONENT,
                        _id: "component2"
                    }
                ]
            },
            {
                type: COLUMN,
                _id: "foxed2",
                width: "60",
                children: [
                    {
                        type: COMPONENT,
                        _id: "component2"
                    },
                    {
                        type: COMPONENT,
                        _id: "component2"
                    }
                ]
            }
        ]
    }
];


/***/ }),

/***/ 75406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Items_SaveLayout; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/hooks/useApi.js + 3 modules
var useApi = __webpack_require__(70210);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/hooks/useNotify.js
var useNotify = __webpack_require__(33346);
// EXTERNAL MODULE: ./src/mosanic/items/Hr.js
var Hr = __webpack_require__(47726);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/items/LoadingDots.tsx
var LoadingDots = __webpack_require__(4093);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/features/map/reducer.js
var map_reducer = __webpack_require__(78726);
// EXTERNAL MODULE: ./src/features/map/data/reducer.js
var data_reducer = __webpack_require__(94718);
// EXTERNAL MODULE: ./src/mosanic/fields/Form/FormGroup.js
var FormGroup = __webpack_require__(35345);
// EXTERNAL MODULE: ./src/mosanic/fields/Form/FormItems.js
var FormItems = __webpack_require__(56185);
// EXTERNAL MODULE: ./src/mosanic/utils/map/paths.js
var paths = __webpack_require__(21634);
// EXTERNAL MODULE: ./src/mosanic/utils/map/transform.js
var transform = __webpack_require__(8374);
// EXTERNAL MODULE: ./src/utils/Num.js
var Num = __webpack_require__(3121);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
// EXTERNAL MODULE: ./src/mosanic/constants/sidebar.elements.js
var sidebar_elements = __webpack_require__(73151);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(60138);
;// CONCATENATED MODULE: ./src/adapters/mutations/layoutItems.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nmutation builderLayoutCreateOne($record: CreateOneBuilderLayoutInput!) {\n	builderLayoutCreateOne (record: $record) {\n		recordId\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nmutation builderLayoutUpdateById($_id: MongoID!, $record: UpdateByIdBuilderLayoutInput!) {\n	builderLayoutUpdateById (_id: $_id, record: $record) {\n		recordId\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var ADD_BUILDER_LAYOUT = (0,lib/* gql */.Ps)(_templateObject());
var UPDATE_BUILDER_LAYOUT = (0,lib/* gql */.Ps)(_templateObject1());

;// CONCATENATED MODULE: ./src/components/Builder/Items/SaveLayout.js




function SaveLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: justify;\n    justify-content: space-between;\n\n    div {\n        display: inline-block;\n        width: 25%;\n    }\n"
    ]);
    SaveLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



















var DataRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-371756d5-0"
})(SaveLayout_templateObject());
var SaveLayout = function(param) {
    var state = param.state, close = param.close, path = param.path, component = param.component, _data = param.data, data = _data === void 0 ? null : _data;
    var ref;
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    var userId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetUser */.pg)({
        _id: userId
    }), 1), user = ref1[0];
    var ref2 = (0,index_esm/* useForm */.cI)({
        mode: "all",
        defaultValues: data
    }), handleSubmit = ref2.handleSubmit, control = ref2.control, watch = ref2.watch, _formState = ref2.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors
    };
    var storedData = (0,es/* useSelector */.v9)(data_reducer/* dataSelector */.Fb);
    var map = (0,es/* useSelector */.v9)(map_reducer/* mapSelector */.Od);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useApi/* useMutate */.Tu)("builderLayoutCreateOne", ADD_BUILDER_LAYOUT), 2), addBuilderLayout = ref3[0], ref4 = (0,_sliced_to_array/* default */.Z)(ref3[1], 3), dataAdd = ref4[0], loadingAdd = ref4[1], errorAdd = ref4[2];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useApi/* useMutate */.Tu)("builderLayoutUpdateById", UPDATE_BUILDER_LAYOUT), 2), updateBuilderLayout = ref5[0], ref6 = (0,_sliced_to_array/* default */.Z)(ref5[1], 3), dataUpdate = ref6[0], loadingUpdate = ref6[1], errorUpdate = ref6[2];
    var splittedPath = (0,paths/* splitPath */.uo)(path);
    var itemMap = (0,transform/* getPreSaveLayoutMap */.Bf)(map, path);
    var notify = (0,useNotify/* default */.Z)();
    var onSubmit = function(formData) {
        var ref;
        if (formData === null || formData === void 0 ? void 0 : (ref = formData.category) === null || ref === void 0 ? void 0 : ref.find(function(cat) {
            return (0,Num/* isNumber */.hj)(cat.value);
        })) {
            notify("Please select a valid layout category.");
            return;
        }
        var ref1 = (0,_sliced_to_array/* default */.Z)((0,transform/* convertPreSaveLayout */.cq)(storedData, itemMap), 3), newLayoutMap = ref1[0], layoutData = ref1[1], parent = ref1[2];
        var record = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
            layoutType: "section",
            isUserGenerated: user.userData.isAdmin && !(formData === null || formData === void 0 ? void 0 : formData.isUserGenerated) ? false : true,
            siteId: siteId,
            updatedAt: Date.now()
        });
        //On create
        if (!(data === null || data === void 0 ? void 0 : data._id)) {
            record = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, record), {
                date: Date.now(),
                component: parent,
                map: newLayoutMap,
                data: layoutData
            });
            dispatchAdd(record);
        } else {
            dispatchUpdate({
                record: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, record), {
                    _id: undefined
                }),
                recordId: data === null || data === void 0 ? void 0 : data._id
            });
        }
    };
    var dispatchAdd = function(record) {
        addBuilderLayout({
            record: record
        }).then(function(res) {
            var data = res.data, error = res.error;
            if (!error) {
                notify("Layout successfully saved.", "builder", "success");
                setTimeout(function() {
                    return close();
                }, 1000);
            } else if (error) {
                notify("Layout could not be saved, please try again.");
            }
        });
    };
    var dispatchUpdate = function(param) {
        var recordId = param.recordId, record = param.record;
        updateBuilderLayout({
            _id: recordId,
            record: record
        }).then(function(res) {
            var data = res.data, error = res.error;
            if (!error) {
                notify("Layout successfully updated.", "builder", "success");
                setTimeout(function() {
                    return close();
                }, 1000);
            } else if (error) {
                notify("Layout could not be updated, please try again.");
            }
        });
    };
    //Get a list of categories
    var list = sidebar_elements/* ELEMENTS_SIDEBAR.map */.e.map(function(item) {
        return {
            value: item === null || item === void 0 ? void 0 : item.value,
            label: item === null || item === void 0 ? void 0 : item.title
        };
    }).map(function(item, index) {
        return (item === null || item === void 0 ? void 0 : item.value) === "divider" ? {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hr/* default */.C, {}),
            value: index
        } : item;
    });
    var getSwitch = function(name) {
        return {
            name: name,
            label: (0,Text/* replacePart */.bA)((0,Text/* revertPascalCase */.rn)(name), "is", ""),
            type: "switch"
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        state: state,
        size: "xs",
        close: function() {
            return close();
        },
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedLabel/* AdvancedLabel */.qv, {
            as: "h5",
            helpText: "Save this layout in one of the layout categories to reuse across your pages. ",
            children: [
                "Save ",
                (0,Text/* capitalizeFirst */.Ez)(itemMap === null || itemMap === void 0 ? void 0 : itemMap.type),
                " Layout"
            ]
        }),
        children: [
            data === null || data === void 0 ? void 0 : data._id,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItems/* FormItems */.G, {
                        controls: inputProps,
                        fields: [
                            {
                                name: "title"
                            },
                            {
                                name: "category",
                                label: "Category",
                                type: "select",
                                options: list,
                                multiple: true
                            },
                            {
                                name: "description",
                                type: "textarea"
                            },
                            (user === null || user === void 0 ? void 0 : (ref = user.userData) === null || ref === void 0 ? void 0 : ref.isAdmin) ? getSwitch("isUserGenerated") : {
                                name: "type"
                            },
                            getSwitch("isBookmarked"), 
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Buttons, {
                        right: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                onClick: function() {
                                    return close();
                                },
                                ghost: true,
                                size: "small",
                                label: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                type: "submit",
                                size: "small",
                                label: data ? "Update" : loadingAdd || loadingUpdate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : "Save"
                            })
                        ]
                    })
                ]
            }),
            errorAdd,
            " ",
            errorUpdate
        ]
    });
};
/* harmony default export */ var Items_SaveLayout = (SaveLayout);


/***/ }),

/***/ 49873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ComponentControls; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/hooks/useInspect.js
var useInspect = __webpack_require__(74069);
// EXTERNAL MODULE: ./src/mosanic/hooks/useNotify.js
var useNotify = __webpack_require__(33346);
// EXTERNAL MODULE: ./src/mosanic/hooks/useControlPopper.js
var useControlPopper = __webpack_require__(39284);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Popper.js + 4 modules
var Popper = __webpack_require__(28932);
// EXTERNAL MODULE: ./src/mosanic/items/Tooltip/index.js + 2 modules
var Tooltip = __webpack_require__(94233);
// EXTERNAL MODULE: ./src/features/options/reducer.js + 1 modules
var reducer = __webpack_require__(51331);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/hooks/useApi.js + 3 modules
var useApi = __webpack_require__(70210);
// EXTERNAL MODULE: ./src/mosanic/fields/TextField/Fields.js
var Fields = __webpack_require__(91639);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ./src/adapters/mutations/builderItems.js
var builderItems = __webpack_require__(77522);
;// CONCATENATED MODULE: ./src/components/Builder/Items/SaveItem.js










var SaveItem = function(props) {
    var ref = (0,react.useState)(false), disabled = ref[0], setDisabled = ref[1];
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(null), data = ref2[0], setData = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useApi/* useMutate */.Tu)(builderItems/* ADD_BUILDER_ITEM */.e), 1), addBuilderItem = ref3[0];
    var ref4 = (0,react.useState)(false), modalState = ref4[0], setModalState = ref4[1];
    var ref5 = (0,react.useState)(props.component.title), title = ref5[0], setTitle = ref5[1];
    var ref6 = (0,react.useState)(props.component.desc), desc = ref6[0], setDesc = ref6[1];
    var handleTitle = function(event) {
        setTitle(event.target.value);
    };
    var handleDesc = function(event) {
        setDesc(event.target.value);
    };
    // const setComponentData = (content) => {
    //     setEditorData(content);
    // };
    var handleSubmit = function(event) {
        event.preventDefault();
        setDisabled(true);
        setError(null);
        var cleanComp = (0,Obj/* omitDeep */.Cd)(props.component, "__typename");
        cleanComp.title = title;
        cleanComp.desc = desc;
        cleanComp._id = undefined;
        var variables = {
            record: {
                type: "sidebarItem",
                isUserGenerated: true,
                isBookmarked: false,
                componentType: props.component.type,
                component: cleanComp
            }
        };
        addBuilderItem({
            variables: variables
        }).then(function(param) {
            var data = param.data;
            setData(data);
            setDisabled(false);
        // activateAuth(token);
        }).catch(function(e) {
            setError(e.message);
            setDisabled(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                state: modalState,
                close: function() {
                    return setModalState(false);
                },
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                    renderHelp: true,
                    helpText: "Enter a title and short description to save component as a 'builder- item' preset <a className=\"skyBlue float-right\">Learn more</a>",
                    children: "Save Component"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inputGroup -large",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inputGroup__item w-100",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                                        id: "component-title",
                                        label: "Component Title",
                                        variant: "outlined",
                                        value: title,
                                        onChange: handleTitle,
                                        size: "small",
                                        disabled: data
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inputGroup__item w-100",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                                    id: "component-title",
                                    label: "Short Description",
                                    variant: "outlined",
                                    value: desc,
                                    onChange: handleDesc,
                                    size: "small",
                                    className: "w-100",
                                    disabled: data
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "clearfix"
                    }),
                    !data && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                onClick: function() {
                                    return setModalState(false);
                                },
                                autoFocus: true,
                                size: "small",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                onClick: handleSubmit,
                                size: "small",
                                variant: "outlined",
                                children: "Save"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "clearfix"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "",
                disabled: disabled,
                onClick: function() {
                    return setModalState(true);
                },
                children: "Save"
            })
        ]
    });
};
/* harmony default export */ var Items_SaveItem = (SaveItem);

// EXTERNAL MODULE: ./src/mosanic/Icons/EditIcons.js
var EditIcons = __webpack_require__(75679);
// EXTERNAL MODULE: ./src/mosanic/Icons/EditorIcons.js
var EditorIcons = __webpack_require__(59688);
;// CONCATENATED MODULE: ./src/components/Builder/Tabs/Layout/Icons.js

var uniqueIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M7.146 1.49a.5.5 0 0 1 .708 0l5.657 5.656a.5.5 0 0 1 0 .708L7.854 13.51a.5.5 0 0 1-.708 0L1.49 7.854a.5.5 0 0 1 0-.708L7.146 1.49ZM7.5 2.55 2.55 7.5l4.95 4.95 4.95-4.95L7.5 2.55Z",
        fill: "#000"
    })
});
var uncloneIcon = (/* unused pure expression or super */ null && (uniqueIcon));
var mainRefIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M4.671 3.146a.5.5 0 0 0 0 .707l2.475 2.475a.5.5 0 0 0 .707 0l2.475-2.475a.5.5 0 0 0 0-.707L7.853.671a.5.5 0 0 0-.707 0L4.671 3.146ZM7.5 5.268 5.732 3.5 7.5 1.732 9.267 3.5 7.5 5.268ZM8.67 7.146a.5.5 0 0 0 0 .707l2.475 2.475a.5.5 0 0 0 .707 0l2.475-2.475a.5.5 0 0 0 0-.707l-2.475-2.475a.5.5 0 0 0-.707 0L8.671 7.146ZM11.5 9.268 9.732 7.5 11.5 5.732 13.268 7.5 11.5 9.268ZM4.67 11.853a.5.5 0 0 1 0-.707l2.475-2.475a.5.5 0 0 1 .707 0l2.475 2.475a.5.5 0 0 1 0 .707l-2.475 2.475a.5.5 0 0 1-.707 0l-2.475-2.474Zm1.061-.353L7.5 13.268 9.267 11.5 7.5 9.732 5.732 11.5ZM.672 7.146a.5.5 0 0 0 0 .708l2.474 2.474a.5.5 0 0 0 .707 0l2.475-2.474a.5.5 0 0 0 0-.708L3.853 4.672a.5.5 0 0 0-.707 0L.671 7.146ZM3.5 9.268 1.732 7.5 3.5 5.732 5.267 7.5 3.5 9.268Z",
        fill: "#000"
    })
});
var clonedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M7.854 1.49a.5.5 0 0 0-.707 0L1.49 7.146a.5.5 0 0 0 0 .708l5.657 5.656a.5.5 0 0 0 .707 0l5.657-5.656a.5.5 0 0 0 0-.708L7.854 1.49ZM7.5 2.55 2.55 7.5l4.95 4.95v-9.9Z",
        fill: "#000"
    })
});
var syncItemIcon = (/* unused pure expression or super */ null && (clonedIcon));
var cloneIcon = (/* unused pure expression or super */ null && (clonedIcon));
var componentIcon = mainRefIcon;
var elementFieldsIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M6.5 1a.5.5 0 0 0 0 1c.627 0 .957.2 1.156.478C7.878 2.79 8 3.288 8 4v7c0 .712-.122 1.21-.344 1.522-.199.278-.53.478-1.156.478a.5.5 0 0 0 0 1c.873 0 1.543-.3 1.97-.897l.03-.044.03.044c.427.597 1.097.897 1.97.897a.5.5 0 0 0 0-1c-.627 0-.957-.2-1.156-.478C9.122 12.21 9 11.712 9 11V4c0-.712.122-1.21.344-1.522C9.543 2.2 9.874 2 10.5 2a.5.5 0 0 0 0-1c-.873 0-1.543.3-1.97.897l-.03.044-.03-.044C8.042 1.3 7.372 1 6.5 1ZM14 5h-3V4h3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-3v-1h3V5ZM6 4v1H1v5h5v1H1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5Z",
        fill: "#000"
    })
});
var mainLinkDataIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M3 2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V8.5a.5.5 0 0 0-1 0V12H3V3h3.5a.5.5 0 0 0 0-1H3Zm9.854.146a.5.5 0 0 1 .146.351V5.5a.5.5 0 0 1-1 0V3.707L6.854 8.854a.5.5 0 1 1-.708-.708L11.293 3H9.5a.5.5 0 0 1 0-1h3a.499.499 0 0 1 .354.146Z",
        fill: "#000"
    })
});
var clonedLinkDataIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M8.512 3.005c.676-.46 1.531-.468 2.167-.05.144.094.298.244.71.656.412.412.562.566.657.71.417.636.408 1.49-.051 2.167-.105.155-.267.32-.694.747l-.62.619a.5.5 0 0 0 .708.707l.619-.619.043-.043c.37-.37.606-.606.771-.849.675-.994.71-2.287.06-3.278-.159-.241-.39-.472-.741-.823l-.045-.045-.044-.045c-.352-.351-.583-.582-.824-.74-.99-.65-2.284-.616-3.278.06-.243.164-.48.4-.85.77l-.042.043-.619.62a.5.5 0 1 0 .707.706l.62-.618c.426-.427.592-.59.746-.695ZM4.318 7.147a.5.5 0 0 0-.707-.707l-.619.618-.043.043c-.37.37-.606.606-.771.85-.675.993-.71 2.287-.06 3.277.159.242.39.473.741.824l.045.045.044.044c.352.351.583.583.824.741.99.65 2.284.616 3.278-.06.243-.165.48-.401.849-.771l.043-.043.619-.619a.5.5 0 1 0-.708-.707l-.618.619c-.427.427-.593.59-.747.694-.676.46-1.532.469-2.167.051-.144-.094-.298-.245-.71-.657-.412-.412-.562-.566-.657-.71-.417-.635-.408-1.49.051-2.167.105-.154.267-.32.694-.747l.619-.618Zm5.304-1.061a.5.5 0 0 0-.707-.708L5.379 8.914a.5.5 0 1 0 .707.707l3.536-3.535Z",
        fill: "#000"
    })
});
var linkDataIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M10.679 2.954c-.636-.417-1.49-.408-2.167.051-.154.105-.32.268-.747.695l-.619.618a.5.5 0 0 1-.707-.707l.619-.619.043-.042c.37-.37.606-.607.849-.772.994-.675 2.288-.71 3.278-.06.241.159.472.39.824.741l.044.045.045.045c.351.351.582.582.74.823.651.99.616 2.284-.059 3.278-.165.243-.402.48-.771.85l-.043.042-.619.619a.5.5 0 1 1-.707-.707l.619-.619c.427-.427.589-.592.694-.747.46-.676.468-1.531.051-2.167-.095-.144-.245-.298-.657-.71-.412-.412-.566-.562-.71-.657ZM4.318 6.44a.5.5 0 0 1 0 .707l-.619.618c-.427.427-.59.593-.694.747-.46.677-.468 1.532-.051 2.167.095.144.245.298.657.71.412.412.566.563.71.657.635.418 1.49.409 2.167-.05.154-.106.32-.268.747-.695l.618-.619a.5.5 0 1 1 .708.707l-.62.62-.042.042c-.37.37-.606.606-.85.771-.993.676-2.287.71-3.277.06-.241-.158-.472-.39-.824-.74-.014-.016-.03-.03-.044-.045a91.54 91.54 0 0 1-.045-.045c-.351-.351-.582-.582-.741-.824-.65-.99-.615-2.284.06-3.278.165-.243.402-.48.771-.849l.043-.043.619-.618a.5.5 0 0 1 .707 0Z",
        fill: "#000"
    })
});
var dataSourceIcon = mainLinkDataIcon;
var elementsMapIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M7.754 1.82a.5.5 0 0 0-.508 0l-5.5 3.25a.5.5 0 0 0 0 .86l5.5 3.25a.5.5 0 0 0 .508 0l5.5-3.25a.5.5 0 0 0 0-.86l-5.5-3.25ZM7.5 8.17 2.983 5.5 7.5 2.83l4.517 2.67L7.5 8.17Zm-5.246.15a.5.5 0 0 0-.508.86l5.5 3.25a.5.5 0 0 0 .508 0l5.5-3.25a.5.5 0 1 0-.508-.86L7.5 11.42l-5.246-3.1Z",
        fill: "#000"
    })
});
var layersIcon = (/* unused pure expression or super */ null && (elementsMapIcon));
var syncChildrenIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M1.903 7.297c0 3.044 2.207 5.118 4.686 5.547a.521.521 0 1 1-.178 1.027C3.5 13.367.861 10.913.861 7.297c0-1.537.699-2.745 1.515-3.663.585-.658 1.254-1.193 1.792-1.602H2.532a.5.5 0 0 1 0-1h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V2.686l-.001.002c-.572.43-1.27.957-1.875 1.638-.715.804-1.253 1.776-1.253 2.97Zm11.108.406c0-3.012-2.16-5.073-4.607-5.533a.521.521 0 1 1 .192-1.024c2.874.54 5.457 2.98 5.457 6.557 0 1.537-.699 2.744-1.515 3.663-.585.658-1.254 1.193-1.792 1.602h1.636a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 1 1 1 0v1.845h.002c.571-.432 1.27-.958 1.874-1.64.715-.803 1.253-1.775 1.253-2.97Z",
        fill: "#000"
    })
});
var unlinkDataIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M12.146 1.146a.5.5 0 0 1 .707 0l2 2a.5.5 0 0 1 0 .708l-3.942 3.942a1 1 0 0 1-.26.188L6.724 9.947a.5.5 0 0 1-.671-.67l1.963-3.928a1 1 0 0 1 .188-.26l3.942-3.943Zm.354 1.061-3.59 3.59-1.037 2.076.254.254 2.077-1.038L13.793 3.5 12.5 2.207ZM10 2 9 3H4.9c-.428 0-.72 0-.944.019-.22.018-.332.05-.41.09a1 1 0 0 0-.437.437c-.04.078-.072.19-.09.41C3 4.18 3 4.472 3 4.9v6.2c0 .428 0 .72.019.944.018.22.05.332.09.41a1 1 0 0 0 .437.437c.078.04.19.072.41.09.225.019.516.019.944.019h6.2c.428 0 .72 0 .944-.019.22-.018.332-.05.41-.09a1 1 0 0 0 .437-.437c.04-.078.072-.19.09-.41.019-.225.019-.516.019-.944V7l1-1V11.12c0 .403 0 .735-.022 1.006-.023.281-.072.54-.196.782a2 2 0 0 1-.874.874c-.243.124-.501.173-.782.196-.27.022-.603.022-1.005.022H4.88c-.403 0-.735 0-1.006-.022-.281-.023-.54-.072-.782-.196a2 2 0 0 1-.874-.874c-.124-.243-.173-.501-.196-.782C2 11.856 2 11.523 2 11.12V4.88c0-.403 0-.735.022-1.006.023-.281.072-.54.196-.782a2 2 0 0 1 .874-.874c.243-.124.501-.173.782-.196C4.144 2 4.477 2 4.88 2H10Z",
        fill: "#000"
    })
});
var editPencilSquareIcon = (/* unused pure expression or super */ null && (unlinkDataIcon));
var mixinIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm.713 1.164a2.5 2.5 0 1 1 0-2.328l3.391-2.12A2.5 2.5 0 1 1 14 3.5a2.5 2.5 0 0 1-4.484 1.52l-3.53 2.207a2.526 2.526 0 0 1 0 .546l3.53 2.206a2.5 2.5 0 1 1-.411.804l-3.392-2.12ZM11.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
        fill: "#000"
    })
});
var shareIcon = (/* unused pure expression or super */ null && (mixinIcon));
var circleCloseIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M.877 7.5a6.623 6.623 0 1 1 13.246 0 6.623 6.623 0 0 1-13.246 0ZM7.5 1.827a5.673 5.673 0 1 0 0 11.346 5.673 5.673 0 0 0 0-11.346Zm2.354 3.32a.5.5 0 0 1 0 .707L8.207 7.5l1.647 1.646a.5.5 0 0 1-.708.708L7.5 8.207 5.854 9.854a.5.5 0 0 1-.708-.708L6.793 7.5 5.146 5.854a.5.5 0 0 1 .708-.708L7.5 6.793l1.646-1.647a.5.5 0 0 1 .708 0Z",
        fill: "#000"
    })
});
var crossCloseIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M11.782 4.032a.575.575 0 1 0-.813-.814L7.5 6.687 4.032 3.218a.575.575 0 0 0-.814.814L6.687 7.5l-3.469 3.468a.575.575 0 0 0 .814.814L7.5 8.313l3.469 3.469a.575.575 0 0 0 .813-.814L8.313 7.5l3.469-3.468Z",
        fill: "#000"
    })
});
var stylingIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 1.5C4.5 4.25 3 6.5 3 9a4.5 4.5 0 1 0 9 0c0-2.5-1.5-4.75-4.5-7.5ZM11 9c0-1.888-1.027-3.728-3.5-6.126C5.027 5.272 4 7.112 4 9a3.5 3.5 0 1 0 7 0Z",
        fill: "#000"
    })
});
var layoutIcon = /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.5 1.8a5.7 5.7 0 1 0 0 11.4 5.7 5.7 0 0 0 0-11.4ZM.9 7.5a6.6 6.6 0 1 1 13.2 0 6.6 6.6 0 0 1-13.2 0Z",
            fill: "#000"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.5 7.9h-12v-.8h12v.8Z",
            fill: "#000"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.1 13.5v-12h.8v12h-.8ZM10.375 7.5c0-2.173-.781-4.322-2.313-5.743l.476-.514c1.702 1.58 2.537 3.93 2.537 6.257 0 2.327-.835 4.678-2.537 6.257l-.476-.514c1.532-1.42 2.313-3.57 2.313-5.743ZM4 7.5c0-2.324.808-4.673 2.458-6.253l.484.506C5.458 3.173 4.7 5.323 4.7 7.5c0 2.176.758 4.327 2.242 5.747l-.484.506C4.808 12.173 4 9.823 4 7.5Z",
            fill: "#000"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.5 3.958c2.17 0 4.375.401 5.87 1.236a.35.35 0 1 1-.34.612c-1.35-.754-3.422-1.148-5.53-1.148s-4.18.394-5.53 1.148a.35.35 0 1 1-.34-.612c1.495-.835 3.7-1.236 5.87-1.236ZM7.5 10.85c2.17 0 4.375-.401 5.87-1.236a.35.35 0 1 0-.34-.612c-1.35.754-3.422 1.148-5.53 1.148s-4.18-.394-5.53-1.148a.35.35 0 1 0-.34.611c1.495.836 3.7 1.237 5.87 1.237Z",
            fill: "#000"
        })
    ]
});
var globeIcon = layoutIcon;
// eslint-disable-next-line import/no-anonymous-default-export
/* harmony default export */ var Icons = ({
    uniqueIcon: uniqueIcon,
    mainRefIcon: mainRefIcon,
    clonedIcon: clonedIcon,
    componentIcon: componentIcon,
    elementFieldsIcon: elementFieldsIcon,
    mainLinkDataIcon: mainLinkDataIcon,
    clonedLinkDataIcon: clonedLinkDataIcon,
    linkDataIcon: linkDataIcon,
    dataSourceIcon: dataSourceIcon,
    elementsMapIcon: elementsMapIcon,
    syncChildrenIcon: syncChildrenIcon,
    mixinIcon: mixinIcon
});

// EXTERNAL MODULE: ./src/mosanic/fields/Select/Select.js + 3 modules
var Select = __webpack_require__(26074);
// EXTERNAL MODULE: ./src/components/Builder/Adapters/constants.js
var constants = __webpack_require__(74079);
;// CONCATENATED MODULE: ./src/components/Builder/Layout/Component/DataModal.js







// import SaveItem from "../Items/SaveItem";
function DataModal(param) {
    var state = param.state, close = param.close, component = param.component, cssStyle = param.cssStyle;
    var ref;
    var tooltips = (0,es/* useSelector */.v9)(reducer/* getTooltips */.Sm);
    var dispatch = (0,es/* useDispatch */.I0)();
    var elementData = component === null || component === void 0 ? void 0 : (ref = component.data) === null || ref === void 0 ? void 0 : ref.content;
    var ref1 = (0,react.useState)("classic"), value = ref1[0], setValue = ref1[1];
    var handleSelect = function(event) {
        setValue(event.target.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
            size: "sm",
            fullWidth: false,
            state: state,
            close: close,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                    renderHelp: true,
                    helpText: "Enter a title and short description to save component as a 'builder- item' preset <a className=\"skyBlue float-right\">Learn more</a>",
                    children: "Component data"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "inputGroup -large",
                    children: elementData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inputGroup__item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select.Select, {
                            className: "modeSelect",
                            size: "small",
                            value: value,
                            label: "Editor",
                            onChange: handleSelect,
                            MenuProps: {
                                style: {
                                    maxHeight: 400
                                }
                            },
                            options: constants/* EDITOR_MODES */.DZ
                        })
                    }) : null
                }),
                elementData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "-" + value
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: cssStyle
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/mosanic/constants/components.js
var components = __webpack_require__(46993);
// EXTERNAL MODULE: ./src/mosanic/Icons/ElementIcons.js
var ElementIcons = __webpack_require__(99559);
// EXTERNAL MODULE: ./src/mosanic/Icons/ScreenIcons.js
var ScreenIcons = __webpack_require__(4956);
// EXTERNAL MODULE: ./src/mosanic/Icons/StateIcons.js
var StateIcons = __webpack_require__(46669);
// EXTERNAL MODULE: ./src/mosanic/items/List/List.js + 2 modules
var List = __webpack_require__(62035);
// EXTERNAL MODULE: ./src/mosanic/items/MenuList/index.js + 2 modules
var MenuList = __webpack_require__(2775);
// EXTERNAL MODULE: ./src/mosanic/utils/map/controls.js
var map_controls = __webpack_require__(28703);
// EXTERNAL MODULE: ./src/mosanic/utils/map/paths.js
var paths = __webpack_require__(21634);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ./src/features/artboard/action.js
var action = __webpack_require__(78616);
// EXTERNAL MODULE: ./src/features/map/data/action.js
var data_action = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/features/map/drop/action.js
var drop_action = __webpack_require__(59357);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ./src/components/Builder/Items/SaveLayout.js + 1 modules
var SaveLayout = __webpack_require__(75406);
;// CONCATENATED MODULE: ./src/components/Builder/Layout/Component/Controls.js








// import SaveItem from "../Items/SaveItem";
// import SubMenuItem from "./SubMenuItem";




















var ControlList = MenuList/* default */.Z;
function ComponentControls(param) {
    var component = param.component, _listOnly = param.listOnly, listOnly = _listOnly === void 0 ? false : _listOnly, map = param.map;
    var ref;
    var tooltips = (0,es/* useSelector */.v9)(reducer/* getTooltips */.Sm);
    var dispatch = (0,es/* useDispatch */.I0)();
    // const data = useInspectedAttr()
    var path = (0,useInspect/* useInspectState */.F)().path;
    var ref1 = (0,react.useState)(false), saveLayout = ref1[0], setSaveLayout = ref1[1];
    var notify = (0,useNotify/* default */.Z)();
    // const [anchorEl, setAnchorEl] = React.useState(null);
    var ref2 = (0,useControlPopper/* useControlPopper */.Z)(), anchor = ref2.anchor, open = ref2.open, close = ref2.close, isOpen = ref2.isOpen;
    var controls = (0,map_controls/* useMapControls */.OU)();
    var handleDelete = (0,map_controls/* useMapItemDelete */.cb)();
    var setAllBreakpoints = function() {};
    var removeBreakpoints = function() {
    // dispatch(handleLayoutState(component, 'default'))
    // dispatch(deleteAllGroupStates())
    };
    var deleteGroupState = function() {
    // dispatch(handleLayoutState(component, 'default'))
    // dispatch(deleteGroupState({stateName: layoutState}));
    // resetState();
    };
    var wrapWithAction = function(wrapper) {
        return dispatch((0,drop_action/* handleDropWrap */.rx)({
            item: component,
            wrapItem: wrapper.component
        }));
    };
    var convertToComponent = function() {
        return dispatch((0,data_action/* convertDataAction */.HU)({
            _id: component._id,
            group: component.group
        }, path, "artboards"));
    };
    var viewInArtboard = function() {
        return dispatch((0,action/* initArtboardAction */.Eb)(component));
    };
    var ref3 = (0,react.useState)(false), modalState = ref3[0], setModalState = ref3[1];
    var menuMap = [
        {
            icon: EditIcons/* cut */.z7,
            label: "Cut",
            shortcut: "⌘X",
            action: controls.cut
        },
        {
            icon: EditIcons/* copy */.JG,
            label: "Copy",
            shortcut: "⌘C",
            action: controls.copy
        },
        {
            icon: EditIcons/* paste */.v,
            label: "Paste",
            shortcut: "⌘V",
            action: controls.paste
        },
        {
            icon: EditIcons/* save */.a1,
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Items_SaveItem, {
                component: component
            }),
            shortcut: "⌘S"
        },
        {
            icon: EditIcons/* duplicate */.OM,
            label: "Duplicate",
            action: function() {
                controls.copy();
                setTimeout(function() {
                    controls.paste();
                }, 500);
            }
        },
        {
            icon: EditIcons/* trash */._I,
            label: "Delete",
            shortcut: "⌫",
            action: controls.del
        },
        {
            type: "subMenu",
            label: "Set visibility:",
            toggle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItemIcon */.Q$, {
                        children: EditIcons/* hide */.Cp
                    }),
                    "Visibility"
                ]
            }),
            map: [
                {
                    icon: globeIcon,
                    label: "Visible on all breakpoints",
                    action: function() {
                        return setAllBreakpoints;
                    }
                },
                {
                    icon: EditIcons/* greenTrash */.fn,
                    label: "Hide on all breakpoints",
                    action: function() {
                        return removeBreakpoints;
                    }
                },
                {
                    label: "Hide on active breakpoint"
                }
            ]
        },
        {
            icon: EditIcons/* expand */.jn,
            label: "View item data",
            action: function() {
                return setModalState(true);
            }
        },
        {
            type: "divider"
        },
        !(0,Text/* isString */.HD)(component === null || component === void 0 ? void 0 : component.data) ? {
            icon: StateIcons/* mainRefIcon */.ZQ,
            label: "Convert to comp",
            action: convertToComponent
        } : {
            icon: ScreenIcons/* rulersIcon */.Fe,
            label: "View in artboard",
            action: viewInArtboard
        },
        ((ref = (0,paths/* splitPath */.uo)(path)) === null || ref === void 0 ? void 0 : ref.length) === 1 ? {
            icon: EditIcons/* save */.a1,
            label: saveLayout ? "Saving layout" : "Save layout",
            action: function() {
                return setSaveLayout(true);
            }
        } : {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* DotsHorizontalIcon */.nWS, {}),
            label: "Save comp. [Coming]"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ElementIcons/* LocalizedTextIcon */.t4, {}),
            label: "Enable Translate",
            action: null
        },
        {
            type: "subMenu",
            label: "Parent component:",
            toggle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItemIcon */.Q$, {
                        children: (0,ElementIcons/* elementIcon */.$N)("container")
                    }),
                    "Wrap with ..."
                ]
            }),
            map: [
                {
                    icon: (0,ElementIcons/* elementIcon */.$N)("repeater"),
                    label: "Repeater",
                    action: function() {
                        return wrapWithAction((0,components/* getAddItem */.uA)("repeater"));
                    }
                },
                {
                    //   icon: <Link1Icon />,
                    //   label: 'Data Link',
                    //   action: () => wrapWithAction('repeater')
                    // },{
                    icon: (0,ElementIcons/* elementIcon */.$N)("container"),
                    label: "Container",
                    action: function() {
                        return wrapWithAction((0,components/* getAddItem */.uA)("container"));
                    }
                },
                {
                    icon: (0,ElementIcons/* elementIcon */.$N)("stack"),
                    label: "Stack",
                    action: function() {
                        return wrapWithAction((0,components/* getAddItem */.uA)("stack"));
                    }
                },
                {
                    icon: (0,ElementIcons/* elementIcon */.$N)("link"),
                    label: "Link",
                    action: function() {
                        return wrapWithAction((0,components/* getAddItem */.uA)("link"));
                    }
                }
            ]
        },
        {
            type: "divider"
        },
        {
            type: "subMenu",
            label: "Align component:",
            toggle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItemIcon */.Q$, {
                        children: EditorIcons/* format_align_left */.ih
                    }),
                    "Align to"
                ]
            }),
            map: [
                {
                    icon: EditorIcons/* format_align_left */.ih,
                    label: "Left"
                },
                {
                    icon: EditorIcons/* format_align_center */.pZ,
                    label: "Center"
                },
                {
                    icon: EditorIcons/* format_align_right */.ZI,
                    label: "Right"
                },
                {
                    icon: EditorIcons/* align_top */.VL,
                    label: "Top"
                },
                {
                    icon: EditorIcons/* align_middle */.wC,
                    label: "Middle"
                },
                {
                    icon: EditorIcons/* align_bottom */.gr,
                    label: "Bottom"
                }
            ]
        },
        {
            type: "subMenu",
            label: "Rotate component:",
            toggle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItemIcon */.Q$, {
                        children: EditorIcons/* rotate_box */._E
                    }),
                    "Rotate"
                ]
            }),
            map: [
                {
                    icon: EditorIcons/* rotate */.U1,
                    label: "Rotate + 90\xb0"
                },
                {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            transform: "scaleY(-1);"
                        },
                        children: EditorIcons/* rotate */.U1
                    }),
                    label: "Rotate - 90\xb0"
                }
            ]
        }
    ];
    if (listOnly) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlList, {
        menuMap: menuMap
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DataModal, {
                state: modalState,
                close: function() {
                    return setModalState(false);
                },
                component: component,
                cssStyle: null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popper/* default */.Z, {
                anchor: anchor,
                close: close,
                placement: "bottom-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Component actions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlList, {
                        menuMap: menuMap
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveLayout/* default */.Z, {
                state: saveLayout,
                close: function() {
                    return setSaveLayout(false);
                },
                path: path,
                component: component
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                className: "component__controlsBtn",
                size: "small",
                variant: "text",
                id: "component-controls-btn",
                "aria-controls": "component-controls",
                onClick: open,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "add",
                    children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "15",
                        height: "15",
                        viewBox: "0 0 15 15",
                        fill: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704ZM9.85358 5.14644C10.0488 5.3417 10.0488 5.65829 9.85358 5.85355L8.20713 7.49999L9.85358 9.14644C10.0488 9.3417 10.0488 9.65829 9.85358 9.85355C9.65832 10.0488 9.34173 10.0488 9.14647 9.85355L7.50002 8.2071L5.85358 9.85355C5.65832 10.0488 5.34173 10.0488 5.14647 9.85355C4.95121 9.65829 4.95121 9.3417 5.14647 9.14644L6.79292 7.49999L5.14647 5.85355C4.95121 5.65829 4.95121 5.3417 5.14647 5.14644C5.34173 4.95118 5.65832 4.95118 5.85358 5.14644L7.50002 6.79289L9.14647 5.14644C9.34173 4.95118 9.65832 4.95118 9.85358 5.14644Z",
                            fill: "#fff"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        title: !tooltips ? "" : "Edit component",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 15 15",
                            fill: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M8.625 2.5C8.625 3.12132 8.12132 3.625 7.5 3.625C6.87868 3.625 6.375 3.12132 6.375 2.5C6.375 1.87868 6.87868 1.375 7.5 1.375C8.12132 1.375 8.625 1.87868 8.625 2.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM7.5 13.625C8.12132 13.625 8.625 13.1213 8.625 12.5C8.625 11.8787 8.12132 11.375 7.5 11.375C6.87868 11.375 6.375 11.8787 6.375 12.5C6.375 13.1213 6.87868 13.625 7.5 13.625Z",
                                fill: "#fff"
                            })
                        })
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 9589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Util_SelectLayout; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ./src/mosanic/Icons/GridIcons.js

var bottomFullFourCols = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "38",
    height: "29",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
        stroke: "#000624",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 19h10V1H1zM14 19h10V1H14zM1 28h36v-6H1zM27 19h10V1H27z"
        })
    })
});
var centerThreeCols = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "38",
    height: "29",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
        stroke: "#000624",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 1h6v27H1zM10 1h18v27H10zM31 1h6v27h-6z"
        })
    })
});
var customCols = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "40",
    height: "29",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#000624",
                d: "M1 1h38v27H1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.527 6h.01c.453.008.84.32.932.753l.003.017.003.018.24 1.661.002.002.002.001c.278.131.546.282.8.452l.044.03 1.608-.63.005-.003a.97.97 0 0 1 1.157.383l.007.013 1.53 2.578a.916.916 0 0 1-.217 1.187l-.011.009-1.364 1.043v.008c.014.172.021.327.021.481 0 .122-.005.244-.014.366l-.004.06-.004.048 1.366 1.044.01.007c.356.288.45.782.224 1.173l-.007.012-1.53 2.58a.97.97 0 0 1-1.15.4l-.02-.006-1.606-.63-.007.002c-.252.17-.517.32-.792.453l-.05.025-.241 1.67-.002.013a.96.96 0 0 1-.918.78H18.463a.962.962 0 0 1-.932-.753l-.003-.017-.003-.018-.24-1.661v-.001l-.004-.002a6.16 6.16 0 0 1-.755-.422l-.045-.03-.044-.03-1.608.63-.005.003a.97.97 0 0 1-1.157-.383l-.007-.013-1.53-2.578a.916.916 0 0 1 .217-1.187l.011-.009 1.363-1.041v-.006a5.133 5.133 0 0 1 0-.96l-1.365-1.043a.916.916 0 0 1-.234-1.18l.008-.012 1.53-2.58a.97.97 0 0 1 1.15-.4l.02.006 1.606.63a6.485 6.485 0 0 1 .798-.456l.051-.024.241-1.67.002-.013a.96.96 0 0 1 .918-.78h3.081Zm-.196 1.133h-2.733L18.38 8.64c-.051.357-.275.666-.6.833l-.016.008-.016.007a5.33 5.33 0 0 0-.65.366l-.041.027a1.17 1.17 0 0 1-1.065.127l-.017-.006-1.447-.569-1.364 2.305 1.226.94c.293.225.455.575.435.94v.018l-.002.017a4.096 4.096 0 0 0-.003.734l.004.047c.03.364-.126.72-.418.954l-.014.01-1.23.943 1.365 2.305 1.447-.569a1.167 1.167 0 0 1 1.05.1l.015.01.015.01c.204.14.419.264.645.373l.063.03c.328.162.557.468.615.824l.003.017.215 1.496h2.733l.218-1.508c.05-.357.274-.667.6-.833l.015-.008.016-.008a5.33 5.33 0 0 0 .65-.365l.042-.027a1.17 1.17 0 0 1 1.064-.128l.017.007 1.447.569 1.365-2.305-1.48-1.133a.552.552 0 0 1-.216-.492l.001-.013.002-.012c.031-.215.048-.433.049-.647 0-.11-.005-.227-.015-.36l-.003-.03v-.01a1.106 1.106 0 0 1 .42-.953l.013-.01 1.23-.944L25.4 9.424l-1.447.569a1.167 1.167 0 0 1-1.05-.1l-.015-.01-.015-.01a4.997 4.997 0 0 0-.64-.37l-.045-.022c-.34-.158-.58-.47-.639-.835l-.002-.017-.216-1.496Zm-1.084 4.12c1.362.133 2.439 1.181 2.575 2.508.12 1.175-.533 2.297-1.63 2.802a2.93 2.93 0 0 1-3.26-.55 2.742 2.742 0 0 1-.565-3.174c.519-1.067 1.671-1.703 2.88-1.586Zm-1.828 2.07a1.631 1.631 0 0 0 .336 1.889c.51.497 1.287.628 1.94.327.652-.3 1.04-.968.97-1.666-.082-.79-.723-1.414-1.533-1.493a1.718 1.718 0 0 0-1.713.944Z",
                fill: "#000624"
            })
        ]
    })
});
var fiveCols = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "40",
    height: "29",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
        stroke: "#000624",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M25 1h6v27h-6zM33 1h6v27h-6zM17 1h6v27h-6zM9 1h6v27H9zM1 1h6.154v27H1z"
        })
    })
});
var fourCols = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "40",
    height: "29",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
        stroke: "#000624",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M31 1h8v27h-8zM21 1h8v27h-8zM11 1h8v27h-8zM1 1h8v27H1z"
        })
    })
});
var oneCol = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "39",
    height: "29",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M1 1h37v27H1z",
        stroke: "#000624",
        fill: "none"
    })
});
var sideBarLeftCol = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "37",
    height: "29",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
        stroke: "#000624",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12 1h24v27H12zM1 1h8v27H1z"
        })
    })
});
var sideBarRightCol = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "37",
    height: "29",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
        stroke: "#000624",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M25 1H1v27h24zM36 1h-8v27h8z"
        })
    })
});
var threeCols = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "38",
    height: "29",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
        stroke: "#000624",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 1h10v27H1zM14 1h10v27H14zM27 1h10v27H27z"
        })
    })
});
var topFullFourCols = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "38",
    height: "29",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
        stroke: "#000624",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 10h10v18H1zM14 10h10v18H14zM1 1h36v6H1zM27 10h10v18H27z"
        })
    })
});
var twoCols = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "39",
    height: "29",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
        stroke: "#000624",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 1h17v27H1zM21 1h17v27H21z"
        })
    })
});
var ColIcons = {
    bottomFullFourCols: bottomFullFourCols,
    centerThreeCols: centerThreeCols,
    customCols: customCols,
    fiveCols: fiveCols,
    fourCols: fourCols,
    oneCol: oneCol,
    sideBarLeftCol: sideBarLeftCol,
    sideBarRightCol: sideBarRightCol,
    threeCols: threeCols,
    topFullFourCols: topFullFourCols,
    twoCols: twoCols
};

/* harmony default export */ var GridIcons = (ColIcons);

// EXTERNAL MODULE: ./src/mosanic/items/Tooltip/index.js + 2 modules
var Tooltip = __webpack_require__(94233);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/components/Builder/Adapters/constants.js
var constants = __webpack_require__(74079);
;// CONCATENATED MODULE: ./src/components/Builder/Util/SelectLayout.js





var SelectLayout = function(param) {
    var rowData = param.rowData, passHandleClose = param.passHandleClose, _hideOthers = param.hideOthers, hideOthers = _hideOthers === void 0 ? false : _hideOthers;
    // TODO receive --> this data as 'layouts'
    // ! Layouts are preset sections without much template content and styling.
    var data = [
        {
            id: GridIcons.oneCol,
            title: "1 column",
            cols: 1,
            grid: [
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: "12",
                        lg: "12",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                }
            ]
        },
        {
            id: GridIcons.twoCols,
            title: "2 columns",
            cols: 2,
            grid: [
                {
                    responsive: {
                        xs: "12",
                        sm: null,
                        md: "6",
                        lg: null,
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: "12",
                        sm: null,
                        md: "6",
                        lg: null,
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                }
            ]
        },
        {
            id: GridIcons.threeCols,
            title: "3 columns",
            cols: 3,
            grid: [
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "4",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "4",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "4",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                }
            ]
        },
        {
            id: GridIcons.fourCols,
            title: "4 columns",
            cols: 4,
            grid: [
                {
                    responsive: {
                        xs: "6",
                        sm: null,
                        md: null,
                        lg: "3",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: "6",
                        sm: null,
                        md: null,
                        lg: "3",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: "6",
                        sm: null,
                        md: null,
                        lg: "3",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: "6",
                        sm: null,
                        md: null,
                        lg: "3",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                }
            ]
        },
        {
            id: GridIcons.sideBarLeftCol,
            title: "Sidebar left + column",
            cols: 2,
            grid: [
                {
                    responsive: {
                        xs: "2",
                        sm: null,
                        md: null,
                        lg: "3",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: "10",
                        sm: null,
                        md: null,
                        lg: "9",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                }
            ]
        },
        {
            id: GridIcons.sideBarRightCol,
            title: "Sidebar right + column",
            cols: 2,
            grid: [
                {
                    responsive: {
                        xs: "10",
                        sm: null,
                        md: null,
                        lg: "9",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: "2",
                        sm: null,
                        md: null,
                        lg: "3",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                }
            ]
        },
        {
            id: GridIcons.centerThreeCols,
            title: "Column + Center + Column",
            cols: 3,
            grid: [
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "3",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "6",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "3",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                }
            ]
        },
        {
            id: GridIcons.fiveCols,
            title: "5 columns",
            cols: 5,
            grid: [
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "2",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "2",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "4",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "2",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "2",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                }
            ]
        },
        {
            id: GridIcons.topFullFourCols,
            title: "Center top + 3 columns",
            cols: 4,
            grid: [
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "12",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "4",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "4",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "4",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                }
            ]
        },
        {
            id: GridIcons.bottomFullFourCols,
            title: "Center bottom + 3 columns",
            cols: 4,
            grid: [
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "4",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "4",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "4",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "12",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                }
            ]
        },
        {
            id: GridIcons.customCols,
            title: "Custom columns",
            cols: 6,
            grid: [
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "2",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "2",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "2",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "2",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "2",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                },
                {
                    responsive: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: "2",
                        xl: null
                    },
                    offset: {
                        xs: null,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null
                    },
                    display: {
                        xs: true,
                        sm: true,
                        md: true,
                        lg: true,
                        xl: true
                    }
                }
            ]
        }
    ];
    if (!rowData || rowData === null) {
        rowData = {
            children: [
                {
                    items: "none"
                }
            ]
        };
    }
    var setRowData = function(item) {
        var index = 0;
        var ids = [];
        var pathValues = [];
        rowData.children.forEach(function(child) {
            ids.push(child._id);
            pathValues.push({
                path: "layout.grid.responsive",
                value: item.grid[index].responsive,
                _id: child._id,
                type: constants/* COLUMN */.aC
            }, {
                path: "layout.grid.offset",
                value: item.grid[index].offset,
                _id: child._id,
                type: constants/* COLUMN */.aC
            }, {
                path: "layout.grid.display",
                value: item.grid[index].display,
                _id: child._id,
                type: constants/* COLUMN */.aC
            });
            index++;
        });
        // dispatch(bulkUpdateFields({
        //     pathValues, 
        //     rerenderIds: ids
        // }));
        if (passHandleClose) passHandleClose();
    };
    //// ${rowData.children.length === item.cols ? '-active' : ''}
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "controlThumbnails -list -large",
        children: data.map(function(item) {
            return rowData.children.length === item.cols || !hideOthers ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "item thumbnail-wrapper",
                onClick: function() {
                    return setRowData(item);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    title: item.title,
                    children: item.id
                })
            }, item === null || item === void 0 ? void 0 : item.id) : null;
        })
    });
};
/* harmony default export */ var Util_SelectLayout = (SelectLayout);


/***/ }),

/***/ 31879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ getBreakpointIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77298);



var getBreakpointIcon = function(type) {
    var text = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            type === "xs" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .MobileIcon */ .pY8, {}),
            type === "sm" && text && "sm",
            type === "md" && text && "md",
            type === "lg" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .LaptopIcon */ .nmT, {}),
            type === "xl" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .DesktopIcon */ .ugZ, {})
        ]
    });
};


/***/ }),

/***/ 70159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Alert; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);




var Alert = function(_param) /*#__PURE__*/ {
    var message = _param.message, _type = _param.type, type = _type === void 0 ? "alert" : _type, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "message",
        "type"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "soo-alert -".concat(type),
        role: type
    }, other), {
        children: message
    }));
};


/***/ }),

/***/ 17980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ SuccessAlert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _Alert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70159);


var SuccessAlert = function(param) {
    var successMessage = param.successMessage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Alert__WEBPACK_IMPORTED_MODULE_1__/* .Alert */ .b, {
        message: successMessage,
        type: "success"
    });
};


/***/ }),

/***/ 64178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ CoreProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);




var CoreContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext();
var CoreProvider = function(param) {
    var children = param.children;
    /**
   * Snackbar Core
   */ var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        msg: "",
        active: false,
        timing: 3000
    }), snackbar = ref[0], setSnackbar = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), snackbarUndo = ref1[0], setSnackbarUndo = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), confirmModal = ref2[0], setConfirmModal = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), confirmData = ref3[0], setConfirmData = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), confirmInput = ref4[0], setConfirmInput = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), mediaModal = ref5[0], setMediaModal = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), mediaEditor = ref6[0], setMediaEditor = ref6[1];
    /**
   * Main snackbar initialization function
   * @param {*} msg snackbar message
   * @param {*} undoTrigger function reference: () => funcCall
   * @param {*} timing in ms, default: 3000
   * @param {*} active is snackbar visible
   * @returns 
   */ var setSnackbarData = function(msg) {
        var undoTrigger = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, timing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3000, active = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
        if (!msg) return;
        setSnackbar({
            msg: msg,
            active: active,
            timing: timing,
            undo: undoTrigger
        });
        undoTrigger ? setSnackbarUndo(undoTrigger) : setSnackbarUndo(null);
    };
    /**
   * Toggle snackbar at a later stadia
   * Note: snackbar data must have active set to false
   */ var toggleSnackbar = function() {
        setSnackbar((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, snackbar), {
            active: !snackbar.active
        }));
    };
    /**
   * Call from snackbar itself
   */ var toggleSnackbarUndo = function() {
        snackbarUndo();
    };
    /**
   * Get actual snackbar undo state
   * @returns True if snackbar has undo method
   */ var hasSnackbarUndo = function() {
        return snackbarUndo != null;
    };
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), contextPages = ref7[0], setPages = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), sideBarPanel = ref8[0], setPanel = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), sideBarPanelRight = ref9[0], setSideBarPanelRight = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), sideBarSubPanel = ref10[0], setSubPanel = ref10[1];
    var setSideBarPanel = function(panel) {
        (panel === null || panel === void 0 ? void 0 : panel.hasSubPanel) ? panel.subDefault != sideBarSubPanel ? setSubPanel(panel.subDefault) : setSubPanel(false) : setSubPanel("");
        if ((panel === null || panel === void 0 ? void 0 : panel.value) != null && panel.value.length >= 3) panel.value == sideBarPanel.value ? setPanel("") : setPanel(panel);
        else setPanel("");
    };
    // const toggleSideBarIcons = () => {
    //   // alert(panel.hasSubPanel)
    //   panel.hasSubPanel ? setSubPanel(panel.subDefault) : setSubPanel('');
    //   (panel.value == sideBarPanel.value) ? setPanel('') : setPanel(panel)
    // }
    // const [contextComponents, setContextComponents] = useState(initialComponents);
    // setActiveSnackbar
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CoreContext.Provider, {
        value: {
            contextPages: contextPages,
            setPages: setPages,
            snackbar: snackbar,
            setSnackbarData: setSnackbarData,
            toggleSnackbar: toggleSnackbar,
            toggleSnackbarUndo: toggleSnackbarUndo,
            hasSnackbarUndo: hasSnackbarUndo,
            sideBarPanel: sideBarPanel,
            setSideBarPanel: setSideBarPanel,
            setPanel: setPanel,
            sideBarPanelRight: sideBarPanelRight,
            setSideBarPanelRight: setSideBarPanelRight,
            sideBarSubPanel: sideBarSubPanel,
            setSubPanel: setSubPanel,
            mediaModal: mediaModal,
            setMediaModal: setMediaModal,
            mediaEditor: mediaEditor,
            setMediaEditor: setMediaEditor,
            confirmModal: confirmModal,
            setConfirmModal: setConfirmModal,
            confirmData: confirmData,
            setConfirmData: setConfirmData,
            confirmInput: confirmInput,
            setConfirmInput: setConfirmInput
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CoreContext);



/***/ }),

/***/ 44855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ GlobalProvider; },
  "Z": function() { return /* binding */ context_GlobalContext; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/features/ui/uiAction.js
var uiAction = __webpack_require__(19957);
// EXTERNAL MODULE: ./src/utils/Device.js
var Device = __webpack_require__(17629);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
;// CONCATENATED MODULE: ./src/hooks/usePrefColorSchema.js






// export type ColorScheme = 'light' | 'dark' | any | Array<any>;
// export interface PrefersColorSchemeOptions {
//   ssr?: boolean;
// }
function usePrefColorSchema() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var dispatch = (0,es/* useDispatch */.I0)();
    var savedAutomatic = !(0,Device/* isServer */.sk)() ? localStorage.getItem("automaticColorScheme") : null;
    var savedPreferred = !(0,Device/* isServer */.sk)() ? localStorage.getItem("preferredColorScheme") : null;
    //Initiate automatic
    var ref = (0,react.useState)(null), automatic = ref[0], setAutomatic = ref[1];
    var ref1 = (0,react.useState)(savedPreferred || savedAutomatic), _ = ref1[0], setCurrent = ref1[1];
    var setPref = function(mode) {
        localStorage.setItem("preferredColorScheme", mode);
        setCurrent(mode);
        dispatch((0,uiAction/* setThemeModeAction */.c3)(mode));
    };
    var clearMode = savedPreferred ? function() {
        localStorage.removeItem("preferredColorScheme");
        setCurrent(null);
        dispatch((0,uiAction/* setThemeModeAction */.c3)(null));
    } : null;
    //On switch window preference, reset automatic storage 
    (0,react.useEffect)(function() {
        if (savedAutomatic != automatic) localStorage.setItem("automaticColorScheme", automatic);
    }, [
        automatic,
        savedAutomatic
    ]);
    //Main handler for window mode
    (0,react.useEffect)(function() {
        var onChange = function onChange(event) {
            var autoMode = event.matches ? "dark" : "light";
            setAutomatic(autoMode);
            dispatch((0,uiAction/* setThemeModeAction */.c3)(savedPreferred ? savedPreferred : autoMode));
        };
        if (!window.matchMedia) {
            setAutomatic("light");
            return;
        }
        var mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
        setAutomatic(mediaQuery.matches ? "dark" : "light");
        mediaQuery.addEventListener("change", onChange);
        return function() {
            mediaQuery.removeEventListener("change", onChange);
        };
    }, [
        dispatch,
        savedPreferred
    ]);
    return [
        savedPreferred ? savedPreferred : savedAutomatic,
        setPref,
        clearMode
    ];
}

;// CONCATENATED MODULE: ./src/context/GlobalContext.js




var GlobalContext = /*#__PURE__*/ (0,react.createContext)();
var GlobalProvider = function(param) {
    var children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)(usePrefColorSchema(true), 3), mode = ref[0], setTheme = ref[1], clearMode = ref[2];
    var ref1 = (0,react.useState)(false), videoModalVisible = ref1[0], setVideoModalVisible = ref1[1];
    var ref2 = (0,react.useState)(false), visibleOffCanvas = ref2[0], setVisibleOffCanvas = ref2[1];
    var ref3 = (0,react.useState)({
        theme: "light",
        variant: "primary",
        align: "left",
        isFluid: false,
        button: "account"
    }), header = ref3[0], setHeader = ref3[1];
    var ref4 = (0,react.useState)({
        theme: "dark",
        style: "style1"
    }), footer = ref4[0], setFooter = ref4[1];
    var toggleVideoModal = function() {
        setVideoModalVisible(!videoModalVisible);
    };
    var toggleOffCanvas = function() {
        setVisibleOffCanvas(!visibleOffCanvas);
    };
    var closeOffCanvas = function() {
        setVisibleOffCanvas(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalContext.Provider, {
        value: {
            themeDark: mode != "light",
            mode: mode,
            setTheme: setTheme,
            clearMode: clearMode,
            videoModalVisible: videoModalVisible,
            toggleVideoModal: toggleVideoModal,
            visibleOffCanvas: visibleOffCanvas,
            toggleOffCanvas: toggleOffCanvas,
            closeOffCanvas: closeOffCanvas,
            header: header,
            setHeader: setHeader,
            footer: footer,
            setFooter: setFooter
        },
        children: children
    });
};
/* harmony default export */ var context_GlobalContext = (GlobalContext);



/***/ }),

/***/ 78616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eb": function() { return /* binding */ initArtboardAction; },
/* harmony export */   "Pg": function() { return /* binding */ addArtboardAction; },
/* harmony export */   "_8": function() { return /* binding */ setArtboardPointer; }
/* harmony export */ });
/* unused harmony exports ARTBOARD_ID, clearArtboardAction, artboardActions */
var ID = "[artboard]";
var ARTBOARD_ID = (/* unused pure expression or super */ null && (ID));
var ARTBOARD_SET = "".concat(ID, " Set");
var ARTBOARD_CLEAR = "".concat(ID, " Clear");
var ARTBOARD_ADD = "".concat(ID, " Add");
var ARTBOARD_SET_POINTER = "".concat(ID, " Pointer");
var addArtboardAction = function(param) {
    var _artboard = param.artboard, artboard = _artboard === void 0 ? null : _artboard, map = param.map, data = param.data;
    return {
        type: ARTBOARD_ADD,
        payload: {
            artboard: artboard,
            map: map,
            data: data
        }
    };
};
var initArtboardAction = function(param) {
    var artboard = param.artboard, map = param.map, data = param.data, handled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return {
        type: "".concat(ARTBOARD_SET, " ").concat(map.type),
        payload: {
            artboard: artboard,
            map: map,
            data: data
        },
        meta: {
            feature: ID
        },
        options: options
    };
};
var setArtboardPointer = function(param) {
    var _id = param._id, group = param.group;
    return {
        type: ARTBOARD_SET_POINTER,
        payload: {
            _id: _id,
            group: group
        }
    };
};
var clearArtboardAction = function() {
    return {
        type: ARTBOARD_CLEAR,
        meta: {
            feature: ID
        }
    };
};
var ARTBOARD_ACTION_IDS = {
    ARTBOARD_SET: ARTBOARD_SET,
    ARTBOARD_CLEAR: ARTBOARD_CLEAR,
    ARTBOARD_ADD: ARTBOARD_ADD,
    ARTBOARD_SET_POINTER: ARTBOARD_SET_POINTER
};
var artboardActions = {
    initArtboardAction: initArtboardAction,
    clearArtboardAction: clearArtboardAction
};
/* harmony default export */ __webpack_exports__["ZP"] = (ARTBOARD_ACTION_IDS);


/***/ }),

/***/ 41415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b2": function() { return /* binding */ artboardSelector; },
/* harmony export */   "wy": function() { return /* binding */ localArtboardsSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _redux_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99927);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78616);







var initialState = {
    _id: null,
    group: null,
    artboards: {}
};
var artboardReducer = function() {
    var artboard = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)(artboard, function(draft) {
        var pl = action === null || action === void 0 ? void 0 : action.payload;
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, artboard, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ARTBOARD_ADD */ .ZP.ARTBOARD_ADD:
                var ref;
                draft.artboards = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, draft.artboards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, pl === null || pl === void 0 ? void 0 : (ref = pl.artboard) === null || ref === void 0 ? void 0 : ref._id, pl));
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ARTBOARD_SET_POINTER */ .ZP.ARTBOARD_SET_POINTER:
                // if(draft.screen != action.payload.screen) 
                //     draft.screen = action.payload.screen;
                draft = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, action.payload), {
                    artboards: draft === null || draft === void 0 ? void 0 : draft.artboards
                });
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ARTBOARD_CLEAR */ .ZP.ARTBOARD_CLEAR:
                draft = initialState;
                return draft;
            default:
                return artboard;
        }
        ; //switch
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (artboardReducer);
// export const containsOverwrite = (source, overwrite) => {
//     if(!source) return false;
//     return source.filter(o => 
//         o?.value === overwrite?.value && 
//         o.type === overwrite?.type
//     )?.length >= 1
// }
var artboardSelector = function(state) {
    return (0,_redux_util__WEBPACK_IMPORTED_MODULE_6__/* .feature */ .z)("artboard", state);
};
var localArtboardsSelector = function(state) {
    var ref;
    return (ref = artboardSelector(state)) === null || ref === void 0 //Inspect element selectors
     // export const artboardIdSelector = (state) => artboardSelector(state)._id;
     // export const isInspectedSelector = (state, _id) => Boolean(artboardIdSelector(state) === _id)
     // export const hasInspectedSelector = (state, _id) => Boolean(artboardIdSelector(state))
     // //Editor selectors
     // export const isEditingSelector = (state, _id) => Boolean(artboardSelector(state).editor)
     // //Inspect overwrite selectors
     // export const artboardOverwriteSelector = (state) => artboardSelector(state).overwrite;
     ? void 0 : ref.artboards;
};


/***/ }),

/***/ 13213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Br": function() { return /* binding */ authRevalidate; },
/* harmony export */   "D5": function() { return /* binding */ storeAuthAction; },
/* harmony export */   "Iv": function() { return /* binding */ setUserId; },
/* harmony export */   "Mc": function() { return /* binding */ removeAuthAction; },
/* harmony export */   "Or": function() { return /* binding */ setSiteId; },
/* harmony export */   "sd": function() { return /* binding */ activateAuthAction; }
/* harmony export */ });
/* unused harmony export routerPushAction */
/* harmony import */ var _api_token__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94645);

var ID = "[auth]";
var STORE = "".concat(ID, " Store");
var ACTIVATE = "".concat(ID, " Activate");
var REMOVE = "".concat(ID, " Remove");
var SET_USER_ID = "".concat(ID, " Set userId");
var SET_SITE_ID = "".concat(ID, " Set siteId");
var REVALIDATE = "".concat(ID, " Revalidate");
var ROUTER_PUSH = "".concat(ID, " Router push");
var IDS = {
    STORE: STORE,
    ACTIVATE: ACTIVATE,
    REMOVE: REMOVE,
    SET_USER_ID: SET_USER_ID,
    SET_SITE_ID: SET_SITE_ID,
    REVALIDATE: REVALIDATE,
    ROUTER_PUSH: ROUTER_PUSH
};
/* harmony default export */ __webpack_exports__["ZP"] = (IDS);
var authRevalidate = function() {
    var source = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ID;
    return {
        type: REVALIDATE,
        meta: {
            feature: ID,
            source: source
        }
    };
};
var routerPushAction = function(param) {
    var pathname = param.pathname, query = param.query;
    return {
        type: ROUTER_PUSH,
        payload: {
            pathname: pathname,
            query: query
        },
        meta: {
            feature: ID
        }
    };
};
var activateAuthAction = function(param) {
    var token = param.token, redirect = param.redirect, remember = param.remember;
    return {
        type: ACTIVATE,
        payload: {
            token: token,
            redirect: redirect,
            remember: remember
        },
        meta: {
            feature: ID
        }
    };
};
var storeAuthAction = function(param) {
    var token = param.token, redirect = param.redirect, remember = param.remember, userData = param.userData, handled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        type: handled ? STORE : "".concat(STORE, " handle"),
        payload: {
            token: token,
            redirect: redirect,
            remember: remember,
            userData: userData
        },
        meta: {
            feature: ID
        }
    };
};
var removeAuthAction = function(param) {
    var _redirect = param.redirect, redirect = _redirect === void 0 ? "/login" : _redirect, src = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "No source", handled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    (0,_api_token__WEBPACK_IMPORTED_MODULE_0__/* .clearSession */ .Ov)();
    return {
        type: handled ? REMOVE : "".concat(REMOVE, " handle"),
        payload: {
            redirect: redirect
        },
        meta: {
            feature: ID,
            src: src
        }
    };
};
var setSiteId = function(param) {
    var siteId = param.siteId, handled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        type: handled ? SET_SITE_ID : "".concat(SET_SITE_ID, " handle"),
        payload: siteId,
        meta: {
            feature: ID
        }
    };
};
var setUserId = function(param) {
    var userId = param.userId;
    return {
        type: SET_USER_ID,
        payload: userId,
        meta: {
            feature: ID
        }
    };
};


/***/ }),

/***/ 25157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kj": function() { return /* binding */ isAuthSelector; },
/* harmony export */   "VF": function() { return /* binding */ routerSelector; },
/* harmony export */   "aF": function() { return /* binding */ authSelector; },
/* harmony export */   "ar": function() { return /* binding */ siteSelector; },
/* harmony export */   "dY": function() { return /* binding */ userIdSelector; },
/* harmony export */   "uL": function() { return /* binding */ siteIdSelector; }
/* harmony export */ });
/* unused harmony exports expSelector, userSelector */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _redux_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99927);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13213);
/* harmony import */ var _api_token__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94645);











var initialState = {
    isAuth: false,
    remember: false,
    userData: null,
    userId: null,
    teamId: null,
    siteId: null,
    router: null
};
var authReducer = function() {
    var auth = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)(auth, function(draft) {
        var pl = action.payload;
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, auth, action.payload), {
                    router: null
                });
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ROUTER_PUSH */ .ZP.ROUTER_PUSH:
                draft.router = action.payload;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].REMOVE */ .ZP.REMOVE:
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, initialState), {
                    router: (pl === null || pl === void 0 ? void 0 : pl.redirect) ? {
                        redirect: pl.redirect
                    } : null
                });
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ACTIVATE */ .ZP.ACTIVATE:
                draft.isAuth = true;
                draft.userData = pl.userData;
                draft.remember = pl.remember;
                draft.router = null;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].SET_USER_ID */ .ZP.SET_USER_ID:
                draft.userId = pl;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].SET_SITE_ID */ .ZP.SET_SITE_ID:
                draft.siteId = pl;
                return draft;
            default:
                return auth;
        }
        ; //switch
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (authReducer);
var authSelector = function(state) {
    return (0,_redux_util__WEBPACK_IMPORTED_MODULE_5__/* .feature */ .z)("auth", state);
};
var isAuthSelector = function(state) {
    var ref;
    return ((ref = (0,_api_token__WEBPACK_IMPORTED_MODULE_6__/* .getDecodedToken */ .gS)()) === null || ref === void 0 ? void 0 : ref._id) && authSelector(state).isAuth;
};
var expSelector = function(state) {
    var ref, ref1;
    return (ref = authSelector(state)) === null || ref === void 0 ? void 0 : (ref1 = ref.userData) === null || ref1 === void 0 ? void 0 : ref1.exp;
};
var userSelector = function(state) {
    var ref;
    return (ref = authSelector(state)) === null || ref === void 0 ? void 0 : ref.user;
};
var userIdSelector = function(state) {
    var ref, ref1;
    return ((ref = (0,_api_token__WEBPACK_IMPORTED_MODULE_6__/* .getDecodedToken */ .gS)()) === null || ref === void 0 ? void 0 : ref._id) && ((ref1 = authSelector(state)) === null || ref1 === void 0 ? void 0 : ref1.userId);
};
var siteIdSelector = function(state) {
    return authSelector(state).siteId;
};
var siteSelector = function(state) {
    return authSelector(state).site;
};
var routerSelector = function(state) {
    return authSelector(state).router;
};


/***/ }),

/***/ 32884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ featureSelector; }
/* harmony export */ });
/* unused harmony export presentSelector */
var presentSelector = function(state) {
    return state.present;
};
var featureSelector = function(state, feature) {
    return presentSelector(state)[feature];
};


/***/ }),

/***/ 42159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K1": function() { return /* binding */ TOGGLE_LAST_HOVER; },
/* harmony export */   "N6": function() { return /* binding */ toggleLastHover; },
/* harmony export */   "Nb": function() { return /* binding */ RESET_HOVER_BOUNDS; },
/* harmony export */   "Qe": function() { return /* binding */ updateInspectBounds; },
/* harmony export */   "Te": function() { return /* binding */ setHoverAction; },
/* harmony export */   "YE": function() { return /* binding */ SET_INSPECTED_BOUNDS; },
/* harmony export */   "ZB": function() { return /* binding */ resetBounds; },
/* harmony export */   "hj": function() { return /* binding */ RESET_BOUNDS_STATE; },
/* harmony export */   "nx": function() { return /* binding */ setHoverElement; },
/* harmony export */   "pB": function() { return /* binding */ SET_HOVER_ELEMENT; },
/* harmony export */   "ry": function() { return /* binding */ SET_INSPECT_SCREEN_BOUNDS; },
/* harmony export */   "rz": function() { return /* binding */ setInspectBoundsAction; },
/* harmony export */   "ui": function() { return /* binding */ UPDATE_INSPECT_BOUNDS; },
/* harmony export */   "wi": function() { return /* binding */ CLEAR_HOVER_BOUNDS; },
/* harmony export */   "x3": function() { return /* binding */ HANDLE_HOVER; },
/* harmony export */   "zF": function() { return /* binding */ resetHoverBounds; }
/* harmony export */ });
/* unused harmony exports HOVER_ID, ADD_BOUNDS_SCREEN, addBoundsScreenAction, setInspectScreenBounds */
var HOVER_ID = "[hover]";
var ID = HOVER_ID;
var HANDLE_HOVER = "".concat(ID, " Handle");
var SET_HOVER_ELEMENT = "".concat(ID, " Set");
var TOGGLE_LAST_HOVER = "".concat(ID, " Toggle last");
var RESET_HOVER_BOUNDS = "".concat(ID, " reset bounds");
var CLEAR_HOVER_BOUNDS = "".concat(ID, " clear bounds");
var RESET_BOUNDS_STATE = "".concat(ID, " reset state");
var ADD_BOUNDS_SCREEN = "".concat(ID, " add screen");
var SET_INSPECTED_BOUNDS = "".concat(ID, " Set i bounds");
var SET_INSPECT_SCREEN_BOUNDS = "".concat(ID, " Set inspect [screen] bounds");
var UPDATE_INSPECT_BOUNDS = "".concat(ID, " Update inspect bounds");
var setHoverAction = function(param) {
    var item = param.item, state = param.state, map = param.map, bounds = param.bounds, screen = param.screen;
    return function(dispatch) {
        var minified = {
            title: item === null || item === void 0 ? void 0 : item.title,
            type: item === null || item === void 0 ? void 0 : item.type,
            icon: item === null || item === void 0 ? void 0 : item.icon,
            _id: item === null || item === void 0 ? void 0 : item._id,
            clone: item === null || item === void 0 ? void 0 : item.clone
        };
        dispatch({
            type: HANDLE_HOVER,
            payload: minified,
            meta: {
                state: state,
                map: map,
                bounds: bounds,
                screen: screen
            }
        });
    };
};
var addBoundsScreenAction = function(param) {
    var screen = param.screen;
    return {
        type: ADD_BOUNDS_SCREEN,
        payload: screen,
        meta: {
            feature: ID
        }
    };
};
var updateInspectBounds = function(path, bounds) {
    var screen = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "base";
    return {
        type: UPDATE_INSPECT_BOUNDS,
        payload: bounds,
        meta: {
            feature: ID,
            path: path,
            screen: screen
        }
    };
};
var setInspectBoundsAction = function(param) {
    var component = param.component, screen = param.screen, bounds = param.bounds;
    return {
        type: SET_INSPECTED_BOUNDS,
        payload: {
            component: component,
            screen: screen,
            bounds: bounds
        },
        meta: {
            feature: ID
        }
    };
};
var setInspectScreenBounds = function(action) {
    return {
        type: SET_INSPECT_SCREEN_BOUNDS,
        payload: action.payload,
        meta: action.meta
    };
};
var toggleLastHover = function(action) {
    return {
        type: TOGGLE_LAST_HOVER,
        payload: action.payload,
        meta: action.meta
    };
};
var setHoverElement = function(action) {
    return {
        type: SET_HOVER_ELEMENT,
        payload: action.payload,
        meta: action.meta
    };
};
var resetHoverBounds = function(source) {
    return {
        type: RESET_HOVER_BOUNDS,
        payload: source,
        meta: {
            feature: "LAYOUT_ID"
        }
    };
};
var resetBounds = function(source) {
    return {
        type: RESET_BOUNDS_STATE,
        payload: source,
        meta: {
            feature: "LAYOUT_ID"
        }
    };
};


/***/ }),

/***/ 40394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Js": function() { return /* binding */ hoverSelector; },
/* harmony export */   "fN": function() { return /* binding */ hasHoverBoundsSelector; },
/* harmony export */   "q0": function() { return /* binding */ hoverBoundsSelector; },
/* harmony export */   "uG": function() { return /* binding */ inspectHoverSelector; }
/* harmony export */ });
/* unused harmony exports hoverScreenSelector, hoveringLayersSelector, sameBounds, hoverPathSelector, isAnComponentHovered, hasScreenBoundsSelector */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _mosanic_map_paths__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21634);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42159);








var initialState = {
    preventReset: false,
    element: null,
    bounds: null,
    map: null,
    screen: null,
    inspect: {
        _id: null,
        group: null,
        bounds: null,
        screen: null
    },
    history: []
};
var boundsReducer = function() {
    var bounds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)(bounds, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, bounds, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_3__/* .SET_HOVER_ELEMENT */ .pB:
                var ref, ref1;
                draft.element = action.payload;
                draft.bounds = action.meta.bounds;
                draft.map = action.meta.map;
                draft.screen = (ref = action.meta) === null || ref === void 0 ? void 0 : ref.screen;
                draft.history = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(draft.history).concat([
                    {
                        element: action.payload,
                        bounds: action.meta.bounds,
                        map: action.meta.map,
                        screen: (ref1 = action.meta) === null || ref1 === void 0 ? void 0 : ref1.screen
                    }
                ]);
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* .TOGGLE_LAST_HOVER */ .K1:
                var ref2, ref3, ref4;
                var levels = 0;
                //remove old
                draft.history = draft.history.filter(function(el) {
                    var ref, ref1;
                    return ((ref = el.map) === null || ref === void 0 ? void 0 : ref.path) != ((ref1 = draft.map) === null || ref1 === void 0 ? void 0 : ref1.path);
                });
                if ((ref2 = draft.map) === null || ref2 === void 0 ? void 0 : ref2.path) levels = (0,_mosanic_map_paths__WEBPACK_IMPORTED_MODULE_5__/* .splitPath */ .uo)(draft.map.path).length;
                //Remove last two
                if (levels >= 2) {
                    var ref5;
                    if ((ref5 = draft.map) === null || ref5 === void 0 ? void 0 : ref5.path) draft.map.path = draft.map.path.substring(0, draft.map.path.length - 2);
                } else {
                    var ref6;
                    if ((ref6 = draft.map) === null || ref6 === void 0 ? void 0 : ref6.path) draft.map.path = action.meta.map.path;
                }
                draft.history.map(function(item) {
                    var ref, ref1;
                    if ((item === null || item === void 0 ? void 0 : (ref = item.map) === null || ref === void 0 ? void 0 : ref.path) === (draft === null || draft === void 0 ? void 0 : (ref1 = draft.map) === null || ref1 === void 0 ? void 0 : ref1.path)) {
                        draft.element = item.element;
                        draft.bounds = item.bounds;
                        draft.map = item.map;
                        draft.screen = item.screen;
                    }
                });
                if (action === null || action === void 0 ? void 0 : (ref3 = action.meta) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.bounds) === null || ref4 === void 0 ? void 0 : ref4.reset) draft.bounds = null;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* .SET_INSPECT_SCREEN_BOUNDS */ .ry:
                var ref7;
                draft.inspect._id = (ref7 = action.payload.component) === null || ref7 === void 0 ? void 0 : ref7._id;
                ;
                draft.inspect.bounds = action.payload.bounds;
                // draft.inspect.map = action.payload.map;
                draft.inspect.group = "screens";
                draft.inspect.screen = action.payload.screen;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* .SET_INSPECTED_BOUNDS */ .YE:
                draft.inspect = {
                    _id: action.payload.component._id,
                    group: action.payload.component.group,
                    bounds: action.payload.bounds,
                    screen: action.payload.screen
                };
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* .UPDATE_INSPECT_BOUNDS */ .ui:
                var prev = null;
                draft.inspect.bounds = action.payload;
                draft.history.map(function(item) {
                    if (item.path === action.meta.path) prev = item;
                }); //store previous
                draft.history = draft.history.filter(function(el) {
                    return el.path != action.meta.path;
                }) //remove previous
                ;
                draft.history = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(draft.history).concat([
                    (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, prev), {
                        bounds: action.payload,
                        path: action.meta.path
                    })
                ]); //update
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* .RESET_HOVER_BOUNDS */ .Nb:
                draft.element = null;
                draft.map = null;
                draft.bounds = null;
                draft.history = [];
                draft.screen = null;
                draft.preventReset = false;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* .RESET_BOUNDS_STATE */ .hj:
                draft = initialState;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* .CLEAR_HOVER_BOUNDS */ .wi:
                draft.history = [];
                return draft;
            default:
                return bounds;
        }
        ; //switch
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (boundsReducer);
//Global bounds selectors
// export const featureSelector = state => state.present;
var hoverSelector = function(state) {
    return state.present.bounds;
};
var inspectHoverSelector = function(state) {
    return hoverSelector(state).inspect;
};
//Screen selectors
var hoverScreenSelector = function(state) {
    return hoverSelector(state).screen;
};
var hoveringLayersSelector = function(state) {
    return hoverSelector(state).screen === "layers";
};
var sameBounds = function(bounds, newBounds) {
    return (bounds === null || bounds === void 0 ? void 0 : bounds.top) && (newBounds === null || newBounds === void 0 ? void 0 : newBounds.top) ? bounds.top === newBounds.top && bounds.bottom === newBounds.bottom && bounds.left === newBounds.left && bounds.right === newBounds.right : false;
};
// const selectItems = state => state.items
// const selectItemId = (state, itemId) => itemId
// const selectItemById = createSelector(
//   [selectItems, selectItemId],
//   (items, itemId) => items[itemId]
// )
// const item = selectItemById(state, 42)
var hoverBoundsSelector = function(state) {
    return {
        element: hoverSelector(state).element,
        bounds: hoverSelector(state).bounds,
        screen: hoverSelector(state).screen,
        map: hoverSelector(state).map
    };
};
var hoverPathSelector = function(state) {
    var ref;
    return (ref = hoverSelector(state).map) === null || ref === void 0 ? void 0 : ref.path;
};
var isAnComponentHovered = function(state) {
    var ref, ref1;
    return ((ref = hoverSelector(state).map) === null || ref === void 0 ? void 0 : ref.type) && isComponent((ref1 = hoverSelector(state).map) === null || ref1 === void 0 ? void 0 : ref1.type);
};
var hasHoverBoundsSelector = function(state) {
    var ref, ref1;
    return Boolean(((ref = hoverSelector(state).history) === null || ref === void 0 ? void 0 : ref.length) >= 1) || Boolean(hoverSelector(state).bounds) || Boolean((ref1 = hoverSelector(state).element) === null || ref1 === void 0 ? void 0 : ref1.type);
};
var hasScreenBoundsSelector = function(state) {
    var ref, ref1;
    return Boolean(((ref = inspectedSelector(state)) === null || ref === void 0 ? void 0 : (ref1 = ref.element) === null || ref1 === void 0 ? void 0 : ref1.type) === "screen");
};


/***/ }),

/***/ 65229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ handleBreakpointAdd; },
/* harmony export */   "zS": function() { return /* binding */ reorderBreakpoints; }
/* harmony export */ });
/* unused harmony exports BREAKPOINTS_ID, handleBreakpointRemove, handleBreakpointUpdate, resetBreakpoints */
var ID = "[breakpoints]";
var BREAKPOINTS_ID = ID;
var BREAKPOINT_ADD = "".concat(ID, " Add breakpoint");
var BREAKPOINT_REMOVE = "".concat(ID, " Remove breakpoint");
var BREAKPOINT_UPDATE = "".concat(ID, " Update breakpoint");
var BREAKPOINTS_REORDER = "".concat(ID, " Reorder");
var BREAKPOINTS_RESET = "".concat(ID, " Reset");
var handleBreakpointAdd = function(breakpoint) {
    return {
        type: BREAKPOINT_ADD,
        payload: breakpoint,
        meta: {
            feature: BREAKPOINTS_ID
        }
    };
};
var handleBreakpointRemove = function(param) {
    var _id = param._id;
    return {
        type: BREAKPOINT_REMOVE,
        payload: _id,
        meta: {
            feature: BREAKPOINTS_ID
        }
    };
};
var handleBreakpointUpdate = function(param) {
    var breakpoint = param.breakpoint, _id = param._id;
    return {
        type: BREAKPOINT_UPDATE,
        payload: {
            breakpoint: breakpoint,
            _id: _id
        },
        meta: {
            feature: BREAKPOINTS_ID
        }
    };
};
var reorderBreakpoints = function() {
    return {
        type: BREAKPOINTS_REORDER,
        meta: {
            feature: BREAKPOINTS_ID
        }
    };
};
var resetBreakpoints = function() {
    return {
        type: BREAKPOINTS_RESET,
        meta: {
            feature: BREAKPOINTS_ID
        }
    };
};
var BREAKPOINTS_ACTION_IDS = {
    BREAKPOINT_ADD: BREAKPOINT_ADD,
    BREAKPOINT_REMOVE: BREAKPOINT_REMOVE,
    BREAKPOINT_UPDATE: BREAKPOINT_UPDATE,
    BREAKPOINTS_REORDER: BREAKPOINTS_REORDER,
    BREAKPOINTS_RESET: BREAKPOINTS_RESET
};
/* harmony default export */ __webpack_exports__["ZP"] = (BREAKPOINTS_ACTION_IDS);


/***/ }),

/***/ 95746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$g": function() { return /* binding */ getBreakpointById; },
/* harmony export */   "G0": function() { return /* binding */ getBreakpointsBySize; },
/* harmony export */   "Pg": function() { return /* binding */ getBreakpointsSelector; },
/* harmony export */   "Vj": function() { return /* binding */ getBreakPointByWidth; },
/* harmony export */   "_l": function() { return /* binding */ canReorderBreakpoints; },
/* harmony export */   "u": function() { return /* binding */ getBreakpointIn; }
/* harmony export */ });
/* unused harmony export DEFAULT_BREAKPOINTS */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50930);
/* harmony import */ var _util_Arr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72393);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65229);






var Action = _action__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP;
var DEFAULT_BREAKPOINTS = [
    {
        name: "Base",
        _id: "base",
        minWidth: 0,
        maxWidth: null,
        canDelete: false
    },
    {
        name: "Mobile",
        _id: "xs",
        minWidth: 0,
        maxWidth: null,
        canDelete: false
    },
    {
        name: "Landscape",
        _id: "sm",
        minWidth: 575,
        maxWidth: null,
        canDelete: true
    },
    {
        name: "Tablet",
        _id: "md",
        minWidth: 750,
        maxWidth: null,
        canDelete: false
    },
    {
        name: "Laptop",
        _id: "lg",
        minWidth: 975,
        maxWidth: null,
        canDelete: true
    },
    {
        name: "Desktop",
        _id: "xl",
        base: true,
        minWidth: 1200,
        maxWidth: null,
        canDelete: false
    }
];
var initialState = DEFAULT_BREAKPOINTS;
var breakpointsReducer = function() {
    var breakpoints = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* .produce */ .Uy)(breakpoints, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, breakpoints, action.payload);
            case Action.BREAKPOINTS_RESET:
                draft = DEFAULT_BREAKPOINTS;
                return draft;
            case Action.BREAKPOINTS_REORDER:
                return draft.sort(compareWidths);
            case Action.BREAKPOINT_ADD:
                if (breakpointExists(draft, action.payload._id)) return;
                draft.push(action.payload);
                return draft;
            case Action.BREAKPOINT_REMOVE:
                if (!breakpointExists(draft, action.payload)) return;
                draft = draft.filter(function(bp) {
                    return bp._id != action.payload;
                });
                return draft;
            case Action.BREAKPOINT_UPDATE:
                if (!breakpointExists(draft, action.payload._id)) return;
                draft = draft.map(function(bp) {
                    if (bp._id != action.payload._id) return bp;
                    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, bp, action.payload);
                });
                return draft;
            default:
                return breakpoints;
        }
        ;
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (breakpointsReducer);
/**
 * Check if breakpoint id exists
 * @param {redux} state breakpoints
 * @param {string} find id
 * @returns {boolean}
 */ var breakpointExists = function(state, find) {
    var ref;
    return ((ref = state.filter(function(bp) {
        return bp._id === find;
    })) === null || ref === void 0 ? void 0 : ref.length) >= 1;
};
/**
 * Sort breakpoints by min width
 * @param {bp} a 
 * @param {bp} b 
 * @returns {sorted array}
 */ function compareWidths(a, b) {
    if (a.minWidth < b.minWidth) return -1;
    if (a.minWidth > b.minWidth) return 1;
    return 0;
}
var canReorderBreakpoints = function(breakpoints) {
    var sortedCopy = (0,immer__WEBPACK_IMPORTED_MODULE_2__/* .produce */ .Uy)(breakpoints, function(copy) {
        copy.sort(compareWidths);
    });
    return !(0,_util_Arr__WEBPACK_IMPORTED_MODULE_4__/* .areEqual */ .wy)(sortedCopy, breakpoints, "minWidth");
};
//Select current redux feature
var breakpointsFeature = function(state) {
    var ref;
    return (ref = state.present) === null || ref === void 0 ? void 0 : ref.breakpoints;
};
//Get all breakpoints
var getBreakpointsSelector = function(state) {
    return breakpointsFeature(state);
};
var validateBp = function(bp, width) {
    return (bp === null || bp === void 0 ? void 0 : bp.minWidth) && (bp === null || bp === void 0 ? void 0 : bp.maxWidth) && (bp === null || bp === void 0 ? void 0 : bp.maxWidth) >= width && (bp === null || bp === void 0 ? void 0 : bp.minWidth) <= width || !(bp === null || bp === void 0 ? void 0 : bp.minWidth) && (bp === null || bp === void 0 ? void 0 : bp.maxWidth) >= width || !(bp === null || bp === void 0 ? void 0 : bp.maxWidth) && (bp === null || bp === void 0 ? void 0 : bp.minWidth) <= width;
};
var getBreakpointsBySize = function(state, width) {
    var breakpoints = (0,_util_Arr__WEBPACK_IMPORTED_MODULE_4__/* .canMap */ .is)(state) ? state : getBreakpointsSelector(state);
    var valid = [];
    breakpoints.map(function(bp) {
        if (validateBp(bp, width)) valid.push(bp);
    });
    return valid;
};
var getBreakPointByWidth = function(state, width) {
    var ref, ref1;
    var breakpoints = (0,_util_Arr__WEBPACK_IMPORTED_MODULE_4__/* .canMap */ .is)(state) ? state : getBreakpointsSelector(state);
    breakpoints = (ref1 = (ref = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(breakpoints)) === null || ref === void 0 ? void 0 : ref.reverse()) === null || ref1 === void 0 ? void 0 : ref1.filter(function(bp) {
        return (bp === null || bp === void 0 ? void 0 : bp._id) != "base";
    });
    var previous, start, current, next, index = 0;
    var last = breakpoints.length;
    breakpoints.map(function(bp) {
        index++;
        if (validateBp(bp, width) && !current) previous = bp;
        if (validateBp(bp, width) && !current) {
            current = previous;
            next = bp;
        }
        if (!current && index === last) current = previous;
    });
    return current;
};
var getBreakpointById = function(state, bp) {
    return getBreakpointIn(getBreakpointsSelector(state), bp);
};
var getBreakpointIn = function(arr, _id) {
    return arr.find(function(bp) {
        return bp._id === _id;
    });
};


/***/ }),

/***/ 55137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Az": function() { return /* binding */ setPageScale; },
/* harmony export */   "GC": function() { return /* binding */ SET_PAGE_SCALE; },
/* harmony export */   "RL": function() { return /* binding */ SET_IS_DRAGGING; },
/* harmony export */   "bz": function() { return /* binding */ SET_CANVAS; },
/* harmony export */   "oq": function() { return /* binding */ changePageScale; }
/* harmony export */ });
/* unused harmony exports CANVAS_ID, HANDLE_CANVAS, HANDLE_CANVAS_RESIZE, FETCH_LAYOUT_SUCCESS, FETCH_LAYOUT_ERROR */
var ID = "[canvas]";
var CANVAS_ID = ID;
var HANDLE_CANVAS = "".concat(ID, " Handle");
var HANDLE_CANVAS_RESIZE = "".concat(ID, " Handle resize");
var SET_CANVAS = "".concat(ID, " Set");
var SET_IS_DRAGGING = "".concat(ID, " isDragging");
var SET_PAGE_SCALE = "".concat(ID, " Set pageScale");
var FETCH_LAYOUT_SUCCESS = "".concat(ID, " Fetch: Success");
var FETCH_LAYOUT_ERROR = "".concat(ID, " Fetch: Error");
var setPageScale = function(scale) {
    var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "set";
    return {
        type: SET_PAGE_SCALE,
        payload: {
            scale: scale,
            source: source
        }
    };
};
var changePageScale = function(scale) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "+", source = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var newScale = type === "+" ? (scale * 10 + 0.1 * 10) / 10 : (scale * 10 - 0.1 * 10) / 10;
    return {
        type: SET_PAGE_SCALE,
        payload: {
            scale: newScale,
            source: source
        },
        meta: {
            feature: CANVAS_ID,
            oldScale: scale,
            type: type
        }
    };
};


/***/ }),

/***/ 64386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wv": function() { return /* binding */ getContainerOffset; },
/* harmony export */   "ZK": function() { return /* binding */ getPageScale; },
/* harmony export */   "iT": function() { return /* binding */ getMobileFirstScreens; },
/* harmony export */   "le": function() { return /* binding */ getBreakpoints; },
/* harmony export */   "sX": function() { return /* binding */ getScaleSource; }
/* harmony export */ });
/* unused harmony exports DYNAMIC_SCREEN, DEFAULT_BREAKPOINTS, getDesktopFirstScreens, getCanvasBreakpoint, getCanvasTheme, getScreensSelector, isSmaller, getContainerMaxWidth, getBreakPointByWidth */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76665);
/* harmony import */ var _util_Num__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3121);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _components_Builder_Adapters_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74079);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55137);








// import { generatePreviewPoints } from './middleware';
var DYNAMIC_SCREEN = "xl";
var DEFAULT_BREAKPOINTS = {
    xs: 0,
    sm: 600,
    md: 850,
    lg: 1200,
    xl: 1400
};
var getMobileFirstScreens = function() {
    return Object.keys(DEFAULT_BREAKPOINTS);
};
var getDesktopFirstScreens = function() {
    return Object.keys(DEFAULT_BREAKPOINTS).reverse();
};
var initialState = {
    isDragging: false,
    pageScale: 1,
    scaleSource: "init",
    canvasBreakpoint: _components_Builder_Adapters_constants__WEBPACK_IMPORTED_MODULE_1__/* .LARGEST_BP */ .gq,
    breakpoints: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, DEFAULT_BREAKPOINTS),
    previewPoints: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, DEFAULT_BREAKPOINTS),
    builderCanvas: {
        x: 0,
        y: 0,
        width: 900,
        height: "85vh"
    },
    screens: [
        {
            name: "base",
            breakPoint: DYNAMIC_SCREEN,
            points: null,
            scale: 0.9,
            ref: null
        },
        {
            name: "small",
            breakPoint: "sm",
            points: null,
            scale: 1.2,
            ref: null
        },
        {
            name: "mobile",
            breakPoint: "xs",
            points: null,
            scale: 1.2,
            ref: null
        }
    ],
    theme: null
};
var canvasReducer = function() {
    var canvas = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_3__/* .produce */ .Uy)(canvas, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, canvas, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_4__/* .SET_CANVAS */ .bz:
                var ref;
                var newWidth = getBreakpointWidth(action.payload, draft.breakpoints, (ref = action.meta) === null || ref === void 0 ? void 0 : ref.padding);
                draft.builderCanvas = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, draft.builderCanvas), {
                    width: newWidth
                });
                draft.screens = draft.screens.map(function(screen) {
                    if (screen.breakPoint === DYNAMIC_SCREEN) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, screen), {
                            canvas: draft.builderCanvas
                        });
                    }
                    var offset = getContainerOffset(screen.breakPoint) < 50 ? 60 : getContainerOffset(screen.breakPoint) * 1.15;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, screen), {
                        canvas: {
                            x: 0,
                            y: 0,
                            width: getBreakpointWidth(screen.breakPoint, draft.breakpoints, offset),
                            height: "auto"
                        }
                    });
                });
                return draft;
            // case SET_THEME:
            //     // draft.theme = action.payload;
            //     return draft;
            // case INIT_THEME:
            // draft.theme = action.payload;
            // return draft;
            // case SET_PREVIEW_POINTS:
            //     draft.previewPoints = action.payload;
            //     draft.screens = draft.screens.map(screen => {
            //         if(screen.breakPoint === DYNAMIC_SCREEN){
            //             return {...screen, points: action.payload}
            //         }
            //         return {...screen,
            //             // points: generatePreviewPoints(screen.breakPoint, draft.breakpoints)
            //         }
            //     })
            //     return draft;
            // case SET_CANVAS_BREAKPOINT:
            //     draft.canvasBreakpoint = action.payload;
            //     return draft;
            case _action__WEBPACK_IMPORTED_MODULE_4__/* .SET_IS_DRAGGING */ .RL:
                draft.isDragging = action.payload;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_4__/* .SET_PAGE_SCALE */ .GC:
                var ref1;
                draft.scaleSource = action === null || action === void 0 ? void 0 : (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.source;
                draft.pageScale = action.payload.scale;
                return draft;
            default:
                return canvas;
        }
        ; //switch
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (canvasReducer);
// export const getCap = state => state.present.options.caps;
var getBreakpoints = function(state) {
    return state.present.canvas.breakpoints;
};
var getCanvasBreakpoint = function(state) {
    return state.present.canvas.canvasBreakpoint;
};
var getPageScale = function(state) {
    return state.present.canvas.pageScale;
};
var getScaleSource = function(state) {
    return state.present.canvas.scaleSource;
};
var getCanvasTheme = function(state) {
    return state.present.canvas.theme;
};
var getScreensSelector = function(state) {
    return state.present.canvas.screens;
};
var isSmaller = function(state, bp) {
    var previewPoints = getBreakpoints(state);
    var canvasBreakpoint = getCanvasBreakpoint(state);
    var hit = 0;
    var current = 0;
    Object.entries(previewPoints).reverse().forEach(function(param, index) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (key === bp) hit = index;
        if (canvasBreakpoint === key) current = index;
    });
    return hit < current;
};
var getContainerOffset = function(breakpoint) {
    switch(breakpoint){
        case "xs":
            return 5;
        case "sm":
            return 25;
        case "md":
            return 50;
        case "lg":
            return 69;
        case "xl":
            return 90;
        case "default":
            return 100;
        default:
            return 0;
    }
};
var getBreakpointWidth = function(bp, breakpoints) {
    var padding = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return (0,_util_Num__WEBPACK_IMPORTED_MODULE_6__/* .isNumber */ .hj)(breakpoints[bp]) ? parseFloat(breakpoints[bp]) + padding : 0;
};
var getContainerMaxWidth = function(state) {
    var bp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "auto", maxWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var breakPoints = getBreakpoints(state);
    var canvasBreakpoint = getCanvasBreakpoint(state);
    if (bp === "auto" || bp === "xl") bp = canvasBreakpoint;
    if (maxWidth) return {
        maxWidth: breakPoints[bp] - getContainerOffset(bp) + "px"
    };
    if (bp === SMALLEST_BP) return {
        width: "350px"
    };
    return {
        width: breakPoints[bp] - getContainerOffset(bp) + "px"
    };
};
var isBpLarger = function(value, width) {
    return value <= width;
};
var isBpSmaller = function(value, width) {
    return value >= width;
};
var getBreakPointByWidth = function(width, breakpoints) {
    var previous, start, current, next, index = 0;
    var last = Object.entries(breakpoints).length;
    Object.entries(breakpoints).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        index++;
        if (isBpLarger(value, width) && !current) previous = key;
        if (isBpSmaller(value, width) && !current) {
            current = previous;
            next = key;
        }
        if (!current && index === last) current = previous;
    });
    return current;
};


/***/ }),

/***/ 48513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hx": function() { return /* binding */ addCartAction; },
/* harmony export */   "Rr": function() { return /* binding */ cartDataAction; },
/* harmony export */   "_V": function() { return /* binding */ removeCartAction; },
/* harmony export */   "r4": function() { return /* binding */ clearCartAction; }
/* harmony export */ });
/* unused harmony exports ADD, REMOVE, REMOVE_MULTIPLE, CLEAR, DATA, CHECKOUT_REQUEST, CHECKOUT_SUCCESS, CHECKOUT_FAILURE, RECEIVE_PRODUCTS, removeMultipleCartAction */
var ID = "[cart]";
var ADD = "".concat(ID, " Add");
var REMOVE = "".concat(ID, " Remove");
var REMOVE_MULTIPLE = "".concat(ID, " Remove x");
var CLEAR = "".concat(ID, " Clear");
var DATA = "".concat(ID, " Data");
var CHECKOUT_REQUEST = "".concat(ID, " CHECKOUT_REQUEST");
var CHECKOUT_SUCCESS = "".concat(ID, " CHECKOUT_SUCCESS");
var CHECKOUT_FAILURE = "".concat(ID, " CHECKOUT_FAILURE");
var RECEIVE_PRODUCTS = "".concat(ID, " RECEIVE_PRODUCTS");
var CART_IDS = {
    ADD: ADD,
    REMOVE: REMOVE,
    DATA: DATA,
    REMOVE_MULTIPLE: REMOVE_MULTIPLE,
    CLEAR: CLEAR
};
/* harmony default export */ __webpack_exports__["ZP"] = (CART_IDS);
var cartDataAction = function(attr, data) {
    return {
        type: DATA,
        payload: {
            attr: attr,
            data: data
        }
    };
};
var addCartAction = function(productId, priceId) {
    return {
        type: ADD,
        payload: {
            productId: productId,
            priceId: priceId
        }
    };
};
var removeCartAction = function(productId, priceId) {
    return {
        type: REMOVE,
        payload: {
            productId: productId,
            priceId: priceId
        }
    };
};
var removeMultipleCartAction = function(productIds) {
    return {
        type: REMOVE,
        payload: productIds
    };
};
var clearCartAction = function() {
    return {
        type: CLEAR
    };
};


/***/ }),

/***/ 59407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ activeContainProductSelector; },
/* harmony export */   "A5": function() { return /* binding */ planIdsSelector; },
/* harmony export */   "Am": function() { return /* binding */ annualSelector; },
/* harmony export */   "No": function() { return /* binding */ productQuantitySelector; },
/* harmony export */   "TP": function() { return /* binding */ cartDataSelector; },
/* harmony export */   "eV": function() { return /* binding */ productsSelector; },
/* harmony export */   "ej": function() { return /* binding */ productIdsSelector; },
/* harmony export */   "rp": function() { return /* binding */ addonIdsSelector; },
/* harmony export */   "yA": function() { return /* binding */ cartSumSelector; }
/* harmony export */ });
/* unused harmony exports cartSelector, containsOneProductSelector */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66383);
/* harmony import */ var _mosanic_utils_products__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25220);
/* harmony import */ var _redux_baseSelector__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32884);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62570);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48513);










var initialState = {
    products: {},
    prices: {},
    annual: true,
    data: []
};
var addProduct = function(draft, param) {
    var productId = param.productId, priceId = param.priceId;
    var product = (0,_util_Obj__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2)(draft.products, productId, 0);
    var price = (0,_util_Obj__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2)(draft.prices, priceId, 0);
    draft = (0,_util_Obj__WEBPACK_IMPORTED_MODULE_1__/* .set */ .t8)(draft.products, productId, (product || 0) + 1);
    draft = (0,_util_Obj__WEBPACK_IMPORTED_MODULE_1__/* .set */ .t8)(draft.prices, priceId, (price || 0) + 1);
    return draft;
};
var removeProduct = function(draft, productId) {
    var product = (0,_util_Obj__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U2)(draft.products, productId, null);
    if (!product) return draft;
    var count = product - 1;
    if (count === 0) (0,_util_Obj__WEBPACK_IMPORTED_MODULE_1__/* .set */ .t8)(draft.products, productId, undefined);
    else (0,_util_Obj__WEBPACK_IMPORTED_MODULE_1__/* .set */ .t8)(draft.products, productId, count);
    return draft;
};
var cartReducer = function() {
    var cart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(cart, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, cart, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].DATA */ .ZP.DATA:
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, draft), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, action.payload.attr, action.payload.data));
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ADD */ .ZP.ADD:
                return addProduct(draft, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].REMOVE */ .ZP.REMOVE:
                return removeProduct(draft, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].REMOVE_MULTIPLE */ .ZP.REMOVE_MULTIPLE:
                action.payload.map(function(productId) {
                    draft = removeProduct(draft, productId);
                });
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].CLEAR */ .ZP.CLEAR:
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, draft), {
                    products: {}
                });
            default:
                return cart;
        }
        ;
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (cartReducer);
var cartSelector = function(state) {
    return (0,_redux_baseSelector__WEBPACK_IMPORTED_MODULE_7__/* .featureSelector */ .g)(state, "cart");
};
var productsSelector = function(state) {
    return cartSelector(state).products;
};
var productIdsSelector = function(state) {
    return Object.keys(productsSelector(state));
};
var productQuantitySelector = function(state, productId) {
    var ref;
    return (ref = productsSelector(state)) === null || ref === void 0 ? void 0 : ref[productId];
};
var addPrice = function(total, item) {
    total.price += (item === null || item === void 0 ? void 0 : item.price) * (item === null || item === void 0 ? void 0 : item.count);
    total.count += item === null || item === void 0 ? void 0 : item.count;
    return total;
};
var cartSumSelector = function(state) {
    var priceData = cartDataSelector(state, "data");
    var annual = annualSelector(state);
    var data = productsSelector(state);
    var products = Object.entries(data).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(param, 2), id = _param[0], count = _param[1];
        var ref, ref1;
        return count ? {
            price: (ref1 = (0,_mosanic_utils_products__WEBPACK_IMPORTED_MODULE_9__/* .getPrice */ .aS)((ref = priceData[id]) === null || ref === void 0 ? void 0 : ref.prices, annual)) === null || ref1 === void 0 ? void 0 : ref1.unit_amount,
            count: count
        } : {
            price: 0,
            count: 0
        };
    });
    return products.reduce(addPrice, {
        price: 0,
        count: 0
    });
};
var containsOneProductSelector = function(state, productIds) {
    var ref;
    return (ref = productIdsSelector(state)) === null || ref === void 0 ? void 0 : ref.some(function(id) {
        return productIds === null || productIds === void 0 ? void 0 : productIds.includes(id);
    });
};
var activeContainProductSelector = function(state, productIds) {
    var ref;
    return (ref = productIdsSelector(state)) === null || ref === void 0 ? void 0 : ref.find(function(id) {
        return productIds === null || productIds === void 0 ? void 0 : productIds.includes(id);
    });
};
var cartDataSelector = function(state, attr) {
    var ref;
    return (ref = cartSelector(state)) === null || ref === void 0 ? void 0 : ref[attr];
};
var annualSelector = function(state) {
    return cartDataSelector(state, "annual");
};
var planIdsSelector = function(state) {
    return cartDataSelector(state, "plans");
};
var addonIdsSelector = function(state) {
    return cartDataSelector(state, "addons");
};


/***/ }),

/***/ 32360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ setSaturationAction; },
/* harmony export */   "Dz": function() { return /* binding */ setColorsAction; },
/* harmony export */   "E0": function() { return /* binding */ updateColorAction; },
/* harmony export */   "HY": function() { return /* binding */ setDesignColor; },
/* harmony export */   "Nb": function() { return /* binding */ togglePaletteShadeAction; },
/* harmony export */   "Qc": function() { return /* binding */ COLOR_ACTION_IDS; },
/* harmony export */   "Zx": function() { return /* binding */ resetColorsAction; },
/* harmony export */   "eG": function() { return /* binding */ CREATE_DESIGN_COLOR; },
/* harmony export */   "qN": function() { return /* binding */ updateShadeCountAction; },
/* harmony export */   "t8": function() { return /* binding */ updateHueAction; },
/* harmony export */   "xi": function() { return /* binding */ regenerateHueShadesAction; }
/* harmony export */ });
/* unused harmony exports COLOR_ID, RESET_TO_BASE, PALETTE_SHADE, CUSTOM_SHADE, REGENERATE_HUE, SET_SATURATION, SHADE_COUNT, UPDATE_COLOR, UPDATE_HUE, SET_DESIGN_COLOR, UPDATE_DESIGN_COLOR, DELETE_DESIGN_COLOR, createDesignColor, deleteDesignColor, updateDesignColor, updateDesignMetricColor */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);
/* harmony import */ var _mosanic_constants_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87269);




var COLOR_ID = "[colors]";
var RESET_TO_BASE = "".concat(COLOR_ID, " Reset base");
var PALETTE_SHADE = "".concat(COLOR_ID, " Toggle palette s");
var CUSTOM_SHADE = "".concat(COLOR_ID, " Custom shade");
var REGENERATE_HUE = "".concat(COLOR_ID, " Regenerate hue");
var SET_SATURATION = "".concat(COLOR_ID, " Set saturation");
var SHADE_COUNT = "".concat(COLOR_ID, " Shade count");
var UPDATE_COLOR = "".concat(COLOR_ID, " Update color");
var UPDATE_HUE = "".concat(COLOR_ID, " Update Hue");
var CREATE_DESIGN_COLOR = "".concat(COLOR_ID, " Create");
var SET_DESIGN_COLOR = "".concat(COLOR_ID, " Set");
var UPDATE_DESIGN_COLOR = "".concat(COLOR_ID, " Update");
var DELETE_DESIGN_COLOR = "".concat(COLOR_ID, " Delete");
var SET_COLORS = "".concat(COLOR_ID, " Set colors");
var COLOR_ACTION_IDS = {
    RESET_TO_BASE: RESET_TO_BASE,
    PALETTE_SHADE: PALETTE_SHADE,
    CUSTOM_SHADE: CUSTOM_SHADE,
    SHADE_COUNT: SHADE_COUNT,
    REGENERATE_HUE: REGENERATE_HUE,
    UPDATE_HUE: UPDATE_HUE,
    SET_SATURATION: SET_SATURATION,
    SET_COLORS: SET_COLORS
};
var setColorsAction = function(data) {
    return {
        type: SET_COLORS,
        payload: data,
        meta: {
            feature: COLOR_ID
        }
    };
};
var setSaturationAction = function(saturation) {
    var hue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, shadeIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _mosanic_constants_colors__WEBPACK_IMPORTED_MODULE_0__/* .MAIN_SHADE */ .W;
    return {
        type: SET_SATURATION,
        payload: {
            index: shadeIndex,
            saturation: saturation,
            hue: hue
        },
        meta: {
            feature: COLOR_ID
        }
    };
};
var updateShadeCountAction = function(hue) {
    var operator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "+";
    return {
        type: SHADE_COUNT,
        payload: {
            hue: hue,
            operator: operator
        },
        meta: {
            feature: COLOR_ID
        }
    };
};
var updateHueAction = function(hue) {
    return {
        type: UPDATE_HUE,
        payload: hue,
        meta: {
            feature: COLOR_ID
        }
    };
};
var togglePaletteShadeAction = function(hue, shade) {
    return {
        type: PALETTE_SHADE,
        payload: {
            hue: hue,
            shade: shade
        },
        meta: {
            feature: COLOR_ID
        }
    };
};
var updateColorAction = function(hue, type, color) {
    return {
        type: CUSTOM_SHADE,
        payload: {
            hue: hue,
            type: type,
            color: color
        },
        meta: {
            feature: COLOR_ID
        }
    };
};
var regenerateHueShadesAction = function(hue, mainShade) {
    var saturation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return {
        type: REGENERATE_HUE,
        payload: {
            hue: hue,
            mainShade: mainShade,
            saturation: saturation
        },
        meta: {
            feature: COLOR_ID
        }
    };
};
var resetColorsAction = function() {
    return {
        type: RESET_TO_BASE,
        meta: {
            feature: COLOR_ID
        }
    };
};
var createDesignColor = function(param) {
    var label = param.label, value = param.value, endValue = param.endValue, _type = param.type, type = _type === void 0 ? "metric" : _type;
    return {
        type: CREATE_DESIGN_COLOR,
        payload: {
            label: label,
            value: value,
            endValue: endValue,
            type: type
        },
        meta: {
            feature: COLOR_ID
        }
    };
};
var setDesignColor = function(param) {
    var color = param.color, _id = param._id, _meta = param.meta, meta = _meta === void 0 ? null : _meta;
    return {
        type: SET_DESIGN_COLOR,
        payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, color), {
            _id: _id
        }),
        meta: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            feature: COLOR_ID
        }, meta)
    };
};
var deleteDesignColor = function(param) {
    var _id = param._id;
    return {
        type: DELETE_DESIGN_COLOR,
        payload: _id,
        meta: {
            feature: COLOR_ID
        }
    };
};
var updateDesignColor = function(color) {
    return {
        type: UPDATE_DESIGN_COLOR,
        payload: color,
        meta: {
            feature: COLOR_ID
        }
    };
};
var updateDesignMetricColor = function(color, label, metric) {
    return {
        type: UPDATE_DESIGN_COLOR,
        payload: _object_spread_props(_object_spread({}, color), {
            label: label,
            value: metric.value,
            endValue: metric.metric,
            selector: toVarCase(label)
        }),
        meta: {
            feature: COLOR_ID,
            dispatched: "updateDesignMetricColor"
        }
    };
};


/***/ }),

/***/ 74329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fj": function() { return /* binding */ hueSelector; },
/* harmony export */   "NR": function() { return /* binding */ paletteColorsSelector; },
/* harmony export */   "cq": function() { return /* binding */ colorSelector; },
/* harmony export */   "dQ": function() { return /* binding */ colorByShadeSelector; },
/* harmony export */   "qQ": function() { return /* binding */ colorsSelector; },
/* harmony export */   "wt": function() { return /* binding */ colorByHexSelector; },
/* harmony export */   "xj": function() { return /* binding */ simplePaletteSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _mosanic_constants_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87269);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62570);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68311);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32360);










var initialState = _mosanic_constants_colors__WEBPACK_IMPORTED_MODULE_1__/* .COLOR_SHADES */ .N;
var mailColorShadeType = "40";
var colorsReducer = function() {
    var colors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* .produce */ .Uy)(colors, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, colors, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_4__/* .COLOR_ACTION_IDS.SET_COLORS */ .Qc.SET_COLORS:
                return action.payload;
            case _action__WEBPACK_IMPORTED_MODULE_4__/* .COLOR_ACTION_IDS.RESET_TO_BASE */ .Qc.RESET_TO_BASE:
                return initialState;
            case _action__WEBPACK_IMPORTED_MODULE_4__/* .COLOR_ACTION_IDS.PALETTE_SHADE */ .Qc.PALETTE_SHADE:
                var payloadHue = action.payload.hue;
                var payloadShade = action.payload.shade;
                draft = draft.map(function(hue) {
                    return hue.type === payloadHue ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, hue), {
                        colors: hue.colors.map(function(shade) {
                            if (shade.type != payloadShade.type) return shade;
                            var hasPrev = (0,_util_Obj__WEBPACK_IMPORTED_MODULE_6__/* .hasAttr */ .B$)(shade, "inPalette");
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, shade), {
                                inPalette: hasPrev ? !shade.inPalette : true
                            });
                        })
                    }) : hue;
                });
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_4__/* .COLOR_ACTION_IDS.UPDATE_HUE */ .Qc.UPDATE_HUE:
                return draft.map(function(hue) {
                    return hue.type === action.payload.type ? action.payload : hue;
                });
            case _action__WEBPACK_IMPORTED_MODULE_4__/* .COLOR_ACTION_IDS.CUSTOM_SHADE */ .Qc.CUSTOM_SHADE:
                var _payload = action.payload, hue = _payload.hue, type = _payload.type, color = _payload.color;
                return draft.map(function(h) {
                    if (h.type != hue) return h;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, h), {
                        colors: h.colors.map(function(c) {
                            var ref;
                            if ((c === null || c === void 0 ? void 0 : c.type) != type) return c;
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, c), {
                                value: color.hex,
                                rgba: (color === null || color === void 0 ? void 0 : (ref = color.rgb) === null || ref === void 0 ? void 0 : ref.a) != 1 ? color.rgb : undefined
                            });
                        })
                    });
                });
            default:
                return colors;
        }
        ;
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (colorsReducer);
var presentSelector = function(state) {
    return state.present;
};
var colorsSelector = function(state) {
    var ref;
    return (ref = presentSelector(state)) === null || ref === void 0 ? void 0 : ref.colors;
};
// export const metricColorsSelector = state => presentSelector(state).colors?.filter(t => t.type === 'metric')
var hueSelector = function(state, hue) {
    return colorsSelector(state).find(function(h) {
        return h.type === hue;
    });
};
var colorSelector = function(state, hue, shade) {
    var group = hueSelector(state, hue);
    if (!group) return "#fff";
    return group.colors.find(function(s) {
        return s.type === shade;
    });
};
var isEqual = function(valA, valB) {
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .toLowCase */ .Cc)(valA) === (0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .toLowCase */ .Cc)(valB);
};
var colorByHexSelector = function(colors, hex) {
    var color = null;
    colors.map(function(h) {
        if (h.colors.find(function(s) {
            return isEqual(s === null || s === void 0 ? void 0 : s.value, hex);
        })) {
            var ref;
            color = {
                shade: (ref = h.colors.find(function(s) {
                    return isEqual(s === null || s === void 0 ? void 0 : s.value, hex);
                })) === null || ref === void 0 ? void 0 : ref.type,
                hue: h.type,
                value: hex
            };
        }
    });
    return color;
};
var colorByShadeSelector = function(colors, hue, shade) {
    var ref;
    var group = colors.find(function(h) {
        return h.type === hue;
    });
    return group === null || group === void 0 ? void 0 : (ref = group.colors) === null || ref === void 0 ? void 0 : ref.find(function(c) {
        return c.type === shade;
    });
};
var paletteColorsSelector = function(state) {
    var colors = colorsSelector(state);
    var pallette = [];
    if (colors) {
        colors.map(function(hue) {
            hue.colors.map(function(color) {
                // if(color.inPalette) mailColorShadeType = c.type;
                if (color === null || color === void 0 ? void 0 : color.inPalette) pallette.push((0,_util_Obj__WEBPACK_IMPORTED_MODULE_6__/* .isObject */ .Kn)(color === null || color === void 0 ? void 0 : color.value) ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, color), {
                    value: "rgba(".concat(color.value.r, ", ").concat(color.value.g, ", ").concat(color.value.b, ", ").concat(color.value.a, ")")
                }) : color);
            });
        });
    }
    return pallette;
};
var simplePaletteSelector = function(state) {
    var ref;
    return (ref = paletteColorsSelector(state)) === null || ref === void 0 ? void 0 : ref.map(function(c) {
        return (0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .upperCase */ .Lw)(c === null || c === void 0 ? void 0 : c.value);
    });
};


/***/ }),

/***/ 10267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ INCREMENT_COUNTER; },
/* harmony export */   "l": function() { return /* binding */ DECREMENT_COUNTER; }
/* harmony export */ });
var INCREMENT_COUNTER = "incrementCounter";
var DECREMENT_COUNTER = "decrementCounter";


/***/ }),

/***/ 67319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F_": function() { return /* binding */ clearInspectAction; },
/* harmony export */   "Ks": function() { return /* binding */ inspectActions; },
/* harmony export */   "Vx": function() { return /* binding */ initInspectAction; },
/* harmony export */   "bC": function() { return /* binding */ resetInspectAction; },
/* harmony export */   "lN": function() { return /* binding */ setOverwriteAction; },
/* harmony export */   "qo": function() { return /* binding */ setEditorAction; }
/* harmony export */ });
/* unused harmony exports INSPECT_ID, EDITOR_ID */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);


var ID = "[inspect]";
var INSPECT_ID = (/* unused pure expression or super */ null && (ID));
var EDITOR_ID = "[editor]";
var INSPECT_SET = "".concat(ID, " Set");
var INSPECT_CLEAR = "".concat(ID, " Clear");
var EDITOR_SET = "".concat(EDITOR_ID, " Set");
var OVERWRITE_INSPECT = "".concat(ID, " Overwrite");
var resetInspectAction = function() {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, initInspectAction({}));
};
var initInspectAction = function(param) {
    var component = param.component, screen = param.screen, bounds = param.bounds, _path = param.path, path = _path === void 0 ? null : _path, handled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    component = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, component), {
        variants: undefined
    });
    return {
        type: !handled ? "".concat(INSPECT_SET, " ").concat((component === null || component === void 0 ? void 0 : component.type) ? component.type : "(empty)") : INSPECT_SET,
        payload: {
            component: component,
            screen: screen,
            bounds: bounds,
            path: path
        },
        meta: {
            feature: ID
        },
        options: options
    };
};
var clearInspectAction = function() {
    return {
        type: INSPECT_CLEAR,
        meta: {
            feature: ID
        }
    };
};
var setEditorAction = function(param) {
    var screen = param.screen, state = param.state;
    return {
        type: EDITOR_SET,
        payload: {
            screen: screen,
            state: state
        },
        meta: {
            feature: ID
        }
    };
};
var setOverwriteAction = function(value) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "breakpoint";
    return {
        type: OVERWRITE_INSPECT,
        payload: {
            value: value,
            type: type
        },
        meta: {
            feature: ID
        }
    };
};
var INSPECT_ACTION_IDS = {
    INSPECT_SET: INSPECT_SET,
    INSPECT_CLEAR: INSPECT_CLEAR,
    EDITOR_SET: EDITOR_SET,
    OVERWRITE_INSPECT: OVERWRITE_INSPECT
};
var inspectActions = {
    initInspectAction: initInspectAction,
    clearInspectAction: clearInspectAction,
    setOverwriteAction: setOverwriteAction,
    setEditorAction: setEditorAction
};
/* harmony default export */ __webpack_exports__["ZP"] = (INSPECT_ACTION_IDS);


/***/ }),

/***/ 57522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G2": function() { return /* binding */ inspectSelector; },
/* harmony export */   "K_": function() { return /* binding */ selectInspectDataProvider; },
/* harmony export */   "P": function() { return /* binding */ selectInspectContext; },
/* harmony export */   "QU": function() { return /* binding */ selectInspectItemState; },
/* harmony export */   "QX": function() { return /* binding */ isInspectedSelector; },
/* harmony export */   "SM": function() { return /* binding */ selectInspectItemId; },
/* harmony export */   "Yk": function() { return /* binding */ selectInspectRepeatProvider; },
/* harmony export */   "_J": function() { return /* binding */ containsOverwrite; },
/* harmony export */   "b8": function() { return /* binding */ inspectOverwriteSelector; },
/* harmony export */   "fP": function() { return /* binding */ selectInspectItemPath; },
/* harmony export */   "m7": function() { return /* binding */ isEditingSelector; },
/* harmony export */   "mL": function() { return /* binding */ selectInspectItemType; },
/* harmony export */   "ns": function() { return /* binding */ selectInspectItemScreen; },
/* harmony export */   "oW": function() { return /* binding */ selectInspectItemClone; },
/* harmony export */   "tm": function() { return /* binding */ hasInspectedSelector; }
/* harmony export */ });
/* unused harmony exports selectInspectItemGroup, selectInspectItemRepeat */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50930);
/* harmony import */ var _mosanic_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91051);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62570);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67319);









var initialState = {
    _id: null,
    group: null,
    type: null,
    screen: null,
    state: null,
    path: null,
    clone: null,
    repeat: null,
    overwrite: {
        variant: [
            _mosanic_constants__WEBPACK_IMPORTED_MODULE_1__/* .Variants.BASE */ .tr.BASE
        ],
        breakpoint: [],
        state: []
    },
    context: null,
    editor: false
};
var inspectReducer = function() {
    var inspect = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* .produce */ .Uy)(inspect, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, inspect, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].EDITOR_SET */ .ZP.EDITOR_SET:
                if (draft.screen != action.payload.screen) draft.screen = action.payload.screen;
                draft.editor = action.payload.state;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].OVERWRITE_INSPECT */ .ZP.OVERWRITE_INSPECT:
                var ref, ref1;
                var overwriteSelector = (ref = action.payload) === null || ref === void 0 ? void 0 : ref.type;
                var overwriteValue = (ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.value;
                if (!(0,_util_Obj__WEBPACK_IMPORTED_MODULE_5__/* .hasAttr */ .B$)(draft.overwrite, overwriteSelector)) return;
                var source = draft.overwrite[overwriteSelector];
                draft.overwrite[overwriteSelector] = containsOverwrite(source, overwriteValue) ? source.filter(function(s) {
                    return (s === null || s === void 0 ? void 0 : s.value) != (overwriteValue === null || overwriteValue === void 0 ? void 0 : overwriteValue.value);
                }) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(source).concat([
                    overwriteValue
                ]);
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].INSPECT_SET */ .ZP.INSPECT_SET:
                var _payload = action.payload, component = _payload.component, screen = _payload.screen, path = _payload.path;
                draft = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, initialState), {
                    _id: component._id,
                    type: component === null || component === void 0 ? void 0 : component.type,
                    group: component.group,
                    state: component === null || component === void 0 ? void 0 : component.state,
                    clone: component === null || component === void 0 ? void 0 : component.clone,
                    repeat: component === null || component === void 0 ? void 0 : component.repeat,
                    context: component === null || component === void 0 ? void 0 : component.context,
                    path: path,
                    screen: screen
                });
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].INSPECT_CLEAR */ .ZP.INSPECT_CLEAR:
                draft = initialState;
                return draft;
            default:
                return inspect;
        }
        ; //switch
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (inspectReducer);
var containsOverwrite = function(source, overwrite) {
    var ref;
    if (!source) return false;
    return ((ref = source.filter(function(o) {
        return (o === null || o === void 0 ? void 0 : o.value) === (overwrite === null || overwrite === void 0 ? void 0 : overwrite.value) && (o === null || o === void 0 ? void 0 : o.type) === (overwrite === null || overwrite === void 0 ? void 0 : overwrite.type);
    })) === null || ref === void 0 ? void 0 : ref.length) >= 1;
};
var inspectSelector = function(state) {
    return state.present.inspect;
}; //feature('inspect', state);
//Todo --> make all direct
// * it is to confusing to use a strange hook to receive this data
//Inspect element selectors
var selectInspectItemId = function(state) {
    return inspectSelector(state)._id;
};
var selectInspectItemType = function(state) {
    return inspectSelector(state).type;
};
var selectInspectItemGroup = function(state) {
    return inspectSelector(state).group;
};
var selectInspectItemPath = function(state) {
    return inspectSelector(state).path;
};
var selectInspectItemScreen = function(state) {
    var ref;
    return (ref = inspectSelector(state)) === null || ref === void 0 ? void 0 : ref.screen;
};
var selectInspectItemState = function(state) {
    return inspectSelector(state).state;
};
var selectInspectItemRepeat = function(state) {
    return inspectSelector(state).repeat;
};
var selectInspectItemClone = function(state) {
    return inspectSelector(state).clone;
};
var selectInspectContext = function(state) {
    var ref;
    return (ref = inspectSelector(state)) === null || ref === void 0 ? void 0 : ref.context;
};
var selectInspectDataProvider = function(state) {
    var ref;
    return (ref = selectInspectContext(state)) === null || ref === void 0 ? void 0 : ref.dataProvider;
};
var selectInspectRepeatProvider = function(state) {
    var ref;
    return (ref = selectInspectContext(state)) === null || ref === void 0 ? void 0 : ref.repeatProvider;
};
var isInspectedSelector = function(state, _id) {
    return Boolean(selectInspectItemId(state) === _id);
};
var hasInspectedSelector = function(state, _id) {
    return Boolean(selectInspectItemId(state));
};
//Editor selectors
var isEditingSelector = function(state, _id) {
    return Boolean(inspectSelector(state).editor);
};
//Inspect overwrite selectors
var inspectOverwriteSelector = function(state) {
    return inspectSelector(state).overwrite;
};


/***/ }),

/***/ 81903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cu": function() { return /* binding */ inspectedDataSelector; },
/* harmony export */   "Gv": function() { return /* binding */ inspectedItemSelector; },
/* harmony export */   "mj": function() { return /* binding */ inspectAttrSelector; }
/* harmony export */ });
/* harmony import */ var _map_data_reducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94718);
/* harmony import */ var _redux_screens_reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45260);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62570);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5994);





var parameters = function(state, obj) {
    return obj;
};
var isScreen = function(inspect) {
    return (inspect === null || inspect === void 0 ? void 0 : inspect.group) === "screens";
};
var hasInspect = function(inspect) {
    return (inspect === null || inspect === void 0 ? void 0 : inspect._id) && (inspect === null || inspect === void 0 ? void 0 : inspect.group);
};
var getScreen = function(screens, _id) {
    return screens.filter(function(screen) {
        return screen._id === _id;
    })[0];
};
//Get element from group
var inspectedItemSelector = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    _map_data_reducer__WEBPACK_IMPORTED_MODULE_1__/* .dataSelector */ .Fb,
    _redux_screens_reducer__WEBPACK_IMPORTED_MODULE_2__/* .getScreensSelector */ .n7,
    function(state) {
        return state.present.inspect;
    }
], function(data, screens, inspect) {
    return hasInspect(inspect) ? isScreen(inspect) ? getScreen(screens, inspect._id) : data[inspect.group][inspect._id] : {
        _id: null,
        type: null,
        itemType: null
    };
});
//Get attr from inspect
var inspectAttrSelector = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    function(state) {
        return state.present.inspect;
    },
    parameters
], function(inspect, attr) {
    return (inspect === null || inspect === void 0 ? void 0 : inspect._id) && (inspect === null || inspect === void 0 ? void 0 : inspect.group) ? inspect[attr] : null;
});
//Get from data reducer
var inspectedDataSelector = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    inspectedItemSelector,
    parameters
], function(item, path) {
    return item ? (0,_util_Obj__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(item, path) : null;
});


/***/ }),

/***/ 64234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DB": function() { return /* binding */ selectMapAction; },
/* harmony export */   "EG": function() { return /* binding */ MAP_ID; },
/* harmony export */   "aZ": function() { return /* binding */ updateMapAction; },
/* harmony export */   "fv": function() { return /* binding */ clearMapAction; },
/* harmony export */   "nv": function() { return /* binding */ mapActions; }
/* harmony export */ });
/* unused harmony exports addMapAction, moveMapAction, updateMapItemAction, removeMapAction */
var ID = "[map]";
var MAP_ID = ID;
var MAP_ADD = "".concat(ID, " Add");
var MAP_SELECT = "".concat(ID, " Select");
var MAP_MOVE = "".concat(ID, " Move");
var MAP_UPDATE = "".concat(ID, " Update");
var MAP_REMOVE = "".concat(ID, " Remove");
var addMapAction = function(param) {
    var itemMap = param.itemMap, dropPath = param.dropPath;
    return {
        type: "".concat(MAP_ADD, " ").concat(itemMap.itemType),
        payload: {
            item: itemMap,
            dropPath: dropPath
        },
        meta: {
            feature: ID
        }
    };
};
var selectMapAction = function(param) {
    var name = param.name;
    return {
        type: MAP_SELECT,
        payload: name,
        meta: {
            feature: ID
        }
    };
};
var clearMapAction = function() {
    return {
        type: MAP_SELECT,
        payload: "clear",
        meta: {
            feature: ID
        }
    };
};
var moveMapAction = function(param) {
    var item = param.item, itemPath = param.itemPath, dropPath = param.dropPath;
    return {
        type: "".concat(MAP_MOVE, " ").concat(item.itemType),
        payload: {
            item: item,
            itemPath: itemPath,
            dropPath: dropPath
        },
        meta: {
            feature: ID
        }
    };
};
var updateMapAction = function(param) {
    var map = param.map;
    return {
        type: "".concat(MAP_UPDATE),
        payload: map,
        meta: {
            feature: ID
        }
    };
};
var updateMapItemAction = function(param) {
    var itemMap = param.itemMap, path = param.path;
    return {
        type: "".concat(MAP_UPDATE, " ").concat(itemMap.type),
        payload: {
            itemMap: itemMap,
            path: path
        },
        meta: {
            feature: ID
        }
    };
};
var removeMapAction = function(param) {
    var item = param.item;
    return {
        type: "".concat(MAP_REMOVE, " ").concat(item.type),
        payload: item,
        meta: {
            feature: ID
        }
    };
};
var MAP_ACTION_IDS = {
    MAP_ADD: MAP_ADD,
    MAP_SELECT: MAP_SELECT,
    MAP_MOVE: MAP_MOVE,
    MAP_UPDATE: MAP_UPDATE,
    MAP_REMOVE: MAP_REMOVE
};
var mapActions = {
    addMapAction: addMapAction,
    selectMapAction: selectMapAction,
    moveMapAction: moveMapAction,
    updateMapAction: updateMapAction,
    updateMapItemAction: updateMapItemAction,
    removeMapAction: removeMapAction
};
/* harmony default export */ __webpack_exports__["ZP"] = (MAP_ACTION_IDS);


/***/ }),

/***/ 78364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HU": function() { return /* binding */ convertDataAction; },
/* harmony export */   "O$": function() { return /* binding */ replaceFullDataStoreAction; },
/* harmony export */   "aL": function() { return /* binding */ setDataAction; },
/* harmony export */   "tD": function() { return /* binding */ dataActions; },
/* harmony export */   "xC": function() { return /* binding */ removeDataAction; }
/* harmony export */ });
/* unused harmony exports DATA_ID, initDataAction, copyDataAction, addDataAction, updateDataAction, extendItemDataAction */
var ID = "[data]";
var DATA_ID = (/* unused pure expression or super */ null && (ID));
var DATA_INIT = "".concat(ID, " Init");
var DATA_COPY = "".concat(ID, " Copy");
var DATA_ADD = "".concat(ID, " Add");
var DATA_UPDATE = "".concat(ID, " Update");
var DATA_EXTEND = "".concat(ID, " Extend");
var DATA_REMOVE = "".concat(ID, " Remove");
var DATA_CONVERT = "".concat(ID, " Convert");
var DATA_SET = "".concat(ID, " Set");
var DATA_REPLACE_STORE = "".concat(ID, " Replace store");
var convertDataAction = function(param, path) {
    var _id = param._id, group = param.group, target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "items";
    return {
        type: "".concat(DATA_CONVERT, " to ").concat(target),
        payload: {
            _id: _id,
            group: group,
            path: path,
            target: target
        }
    };
};
var setDataAction = function(param) {
    var data = param.data;
    return {
        type: DATA_SET,
        payload: data,
        meta: {
            feature: ID
        }
    };
};
var initDataAction = function(param) {
    var component = param.component, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return {
        type: "".concat(DATA_INIT, " ").concat(component.type),
        payload: component,
        meta: {
            feature: ID
        },
        options: options
    };
};
var copyDataAction = function(param, sourceId) {
    var component = param.component, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return {
        type: "".concat(DATA_COPY, " ").concat(component.type),
        payload: component,
        meta: {
            feature: ID,
            sourceId: sourceId
        },
        options: options
    };
};
var addDataAction = function(param) {
    var component = param.component, handled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        type: !handled ? "".concat(DATA_ADD, " ").concat(component.type) : DATA_ADD,
        payload: component,
        meta: {
            feature: ID
        }
    };
};
var replaceFullDataStoreAction = function(param) {
    var data = param.data;
    return {
        type: DATA_REPLACE_STORE,
        payload: data,
        meta: {
            feature: ID
        }
    };
};
var updateDataAction = function(param) {
    var component = param.component, handled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        type: !handled ? "".concat(DATA_UPDATE, " ").concat(component.type) : DATA_UPDATE,
        payload: component,
        meta: {
            feature: ID
        }
    };
};
var extendItemDataAction = function(param) {
    var itemMap = param.itemMap, dropPath = param.dropPath;
    return {
        type: DATA_EXTEND,
        payload: {
            itemMap: itemMap,
            dropPath: dropPath
        },
        meta: {
            feature: ID
        }
    };
};
var removeDataAction = function(param, sourceId) {
    var component = param.component, handled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return {
        type: !handled ? "".concat(DATA_REMOVE, " ").concat(component.type) : DATA_REMOVE,
        payload: component,
        meta: {
            feature: ID,
            sourceId: sourceId
        }
    };
};
var DATA_ACTION_IDS = {
    DATA_INIT: DATA_INIT,
    DATA_COPY: DATA_COPY,
    DATA_ADD: DATA_ADD,
    DATA_UPDATE: DATA_UPDATE,
    DATA_REMOVE: DATA_REMOVE,
    DATA_EXTEND: DATA_EXTEND,
    DATA_SET: DATA_SET,
    DATA_CONVERT: DATA_CONVERT,
    DATA_REPLACE_STORE: DATA_REPLACE_STORE
};
var dataActions = {
    initDataAction: initDataAction,
    copyDataAction: copyDataAction,
    removeDataAction: removeDataAction,
    updateDataAction: updateDataAction,
    addDataAction: addDataAction,
    extendItemDataAction: extendItemDataAction,
    convertDataAction: convertDataAction
};
/* harmony default export */ __webpack_exports__["ZP"] = (DATA_ACTION_IDS);


/***/ }),

/***/ 94718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fb": function() { return /* binding */ dataSelector; },
/* harmony export */   "N6": function() { return /* binding */ dataMetaSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _redux_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99927);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62570);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);






var initialState = {};
var dataReducer = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)(data, function(draft) {
        var component = action.payload;
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, data, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].DATA_ADD */ .ZP.DATA_ADD:
                (0,_util_Obj__WEBPACK_IMPORTED_MODULE_4__/* .set */ .t8)(draft, "".concat(component.group, ".").concat(component._id), component);
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].DATA_REPLACE_STORE */ .ZP.DATA_REPLACE_STORE:
                return action.payload;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].DATA_UPDATE */ .ZP.DATA_UPDATE:
                (0,_util_Obj__WEBPACK_IMPORTED_MODULE_4__/* .set */ .t8)(draft, "".concat(component.group, ".").concat(component._id), component);
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].DATA_REMOVE */ .ZP.DATA_REMOVE:
                (0,_util_Obj__WEBPACK_IMPORTED_MODULE_4__/* .set */ .t8)(draft, "".concat(component.group, ".").concat(component._id), undefined);
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].DATA_SET */ .ZP.DATA_SET:
                return action.payload;
            default:
                return data;
        }
        ; //switch
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (dataReducer);
var dataSelector = function(state) {
    return (0,_redux_util__WEBPACK_IMPORTED_MODULE_5__/* .feature */ .z)("data", state);
};
var dataMetaSelector = function(state) {
    var ref, ref1;
    return (ref = (0,_redux_util__WEBPACK_IMPORTED_MODULE_5__/* .feature */ .z)("data", state)) === null || ref === void 0 ? void 0 : (ref1 = ref.meta) === null || ref1 === void 0 ? void 0 : ref1.pointer;
};


/***/ }),

/***/ 52478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lm": function() { return /* binding */ itemDataSelector; },
/* harmony export */   "O1": function() { return /* binding */ itemSelector; },
/* harmony export */   "rV": function() { return /* binding */ getItem; }
/* harmony export */ });
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62570);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5994);
/* harmony import */ var _reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94718);




var parameters = function(state, obj) {
    return obj;
};
var getItem = function(data, obj) {
    return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_0__/* .hasAttr */ .B$)(data, obj === null || obj === void 0 ? void 0 : obj.group, obj === null || obj === void 0 ? void 0 : obj._id) ? data[obj.group][obj._id] : null;
};
var itemSelector = (0,reselect__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)([
    _reducer__WEBPACK_IMPORTED_MODULE_2__/* .dataSelector */ .Fb,
    parameters
], function(data, obj) {
    return getItem(data, obj);
});
//Get from data reducer
var itemDataSelector = (0,reselect__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)([
    _reducer__WEBPACK_IMPORTED_MODULE_2__/* .dataSelector */ .Fb,
    parameters
], function(data, obj) {
    var ref, ref1;
    return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_0__/* .hasAttr */ .B$)(data, obj === null || obj === void 0 ? void 0 : (ref = obj.ref) === null || ref === void 0 ? void 0 : ref.group, obj === null || obj === void 0 ? void 0 : (ref1 = obj.ref) === null || ref1 === void 0 ? void 0 : ref1._id) ? (0,_util_Obj__WEBPACK_IMPORTED_MODULE_0__/* .get */ .U2)(data[obj.ref.group][obj.ref._id], obj.path, {}) : null;
});


/***/ }),

/***/ 59357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H8": function() { return /* binding */ DROP_ID; },
/* harmony export */   "PH": function() { return /* binding */ handleDropAction; },
/* harmony export */   "Tg": function() { return /* binding */ handleCopyAction; },
/* harmony export */   "Um": function() { return /* binding */ handlePasteAction; },
/* harmony export */   "Vw": function() { return /* binding */ handlePreStoreAction; },
/* harmony export */   "g": function() { return /* binding */ clearPreStoreAction; },
/* harmony export */   "j8": function() { return /* binding */ handleDeleteAction; },
/* harmony export */   "m9": function() { return /* binding */ handleCutAction; },
/* harmony export */   "rx": function() { return /* binding */ handleDropWrap; },
/* harmony export */   "to": function() { return /* binding */ dropActions; }
/* harmony export */ });
/* unused harmony export handleAutoPasteAction */
var ID = "[drop]";
var DROP_ID = ID;
var DROP_HANDLE = "".concat(ID, " Handle");
var DROP_COPY = "".concat(ID, " Copy");
var DROP_CUT = "".concat(ID, " Cut");
var DROP_WRAP = "".concat(ID, " Wrap");
var DROP_PASTE = "".concat(ID, " Paste");
var DELETE_HANDLE = "".concat(ID, " Delete");
var DROP_PRE_STORE = "".concat(ID, " Pre Store");
var DROP_CLEAR_STORE = "".concat(ID, " Clear Store");
//Default drop & move actions
var handleDropAction = function(param) {
    var dropZone = param.dropZone, item = param.item, handled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        type: !handled ? "".concat(DROP_HANDLE, " ").concat(item === null || item === void 0 ? void 0 : item.type) : DROP_HANDLE,
        payload: {
            dropZone: dropZone,
            item: item
        },
        meta: {
            feature: ID
        }
    };
};
//Delete item from canvas
var handleDeleteAction = function(param) {
    var _item = param.item, item = _item === void 0 ? null : _item;
    return {
        type: DELETE_HANDLE,
        payload: {
            item: item
        },
        meta: {
            feature: ID
        }
    };
};
var handleDropWrap = function(param) {
    var item = param.item, wrapItem = param.wrapItem, handled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        type: !handled ? "".concat(DROP_WRAP, " ").concat(item === null || item === void 0 ? void 0 : item.type) : DROP_WRAP,
        payload: {
            item: item,
            wrapItem: wrapItem
        },
        meta: {
            feature: ID
        }
    };
};
//Copy handling
var handleCopyAction = function(param) {
    var _preStore = param.preStore, preStore = _preStore === void 0 ? false : _preStore, handled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        type: !handled ? "".concat(DROP_COPY, " (PreStore)") : DROP_COPY,
        payload: {
            preStore: preStore
        },
        meta: {
            feature: ID
        }
    };
};
var handleAutoPasteAction = function(param) {
    var sourceItemPath = param.sourceItemPath, itemRef = param.itemRef, handled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        type: !handled ? "".concat(DROP_PASTE, " ").concat(itemRef === null || itemRef === void 0 ? void 0 : itemRef.type) : DROP_PASTE,
        payload: {
            sourceItemPath: sourceItemPath,
            itemRef: itemRef
        },
        meta: {
            feature: ID
        }
    };
};
var handleCutAction = function() {
    var handled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return {
        type: !handled ? "".concat(DROP_CUT, " (PreStore)") : DROP_CUT,
        meta: {
            feature: ID
        }
    };
};
var handlePasteAction = function() {
    var handled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, itemMap = arguments.length > 1 ? arguments[1] : void 0;
    return {
        type: !handled ? "".concat(DROP_PASTE, " (PreStore)") : DROP_PASTE,
        meta: {
            feature: ID
        }
    };
};
//Pre store on click sidebar item
var handlePreStoreAction = function(data) {
    return {
        type: DROP_PRE_STORE,
        payload: data,
        meta: {
            feature: ID
        }
    };
};
var clearPreStoreAction = function() {
    return {
        type: DROP_CLEAR_STORE,
        meta: {
            feature: ID
        }
    };
};
var DROP_ACTION_IDS = {
    DROP_HANDLE: DROP_HANDLE,
    DROP_COPY: DROP_COPY,
    DROP_CUT: DROP_CUT,
    DROP_PASTE: DROP_PASTE,
    DELETE_HANDLE: DELETE_HANDLE,
    DROP_PRE_STORE: DROP_PRE_STORE,
    DROP_CLEAR_STORE: DROP_CLEAR_STORE,
    DROP_WRAP: DROP_WRAP
};
var dropActions = {
    handleDropAction: handleDropAction,
    handleDeleteAction: handleDeleteAction,
    handleCutAction: handleCutAction,
    handleCopyAction: handleCopyAction,
    handlePasteAction: handlePasteAction,
    handleAutoPasteAction: handleAutoPasteAction,
    handlePreStoreAction: handlePreStoreAction,
    clearPreStoreAction: clearPreStoreAction
};
/* harmony default export */ __webpack_exports__["ZP"] = (DROP_ACTION_IDS);


/***/ }),

/***/ 93819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ preDropStoreSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _redux_baseSelector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32884);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59357);





var initialState = {};
var dropReducer = function() {
    var drop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)(drop, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, drop, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].DROP_HANDLE */ .ZP.DROP_HANDLE:
                return drop;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].DROP_PRE_STORE */ .ZP.DROP_PRE_STORE:
                draft.pre_store = action.payload;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].DROP_CLEAR_STORE */ .ZP.DROP_CLEAR_STORE:
                draft = {};
                return draft;
            default:
                return drop;
        }
        ; //switch
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (dropReducer);
var dropSelector = function(state) {
    return (0,_redux_baseSelector__WEBPACK_IMPORTED_MODULE_4__/* .featureSelector */ .g)(state, "drop");
};
var preDropStoreSelector = function(state) {
    var ref;
    return (ref = dropSelector(state)) === null || ref === void 0 ? void 0 : ref.pre_store;
};


/***/ }),

/***/ 78726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Od": function() { return /* binding */ mapSelector; },
/* harmony export */   "Yq": function() { return /* binding */ itemMapByPathSelector; },
/* harmony export */   "zE": function() { return /* binding */ currentMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _mosanic_utils_map_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84570);
/* harmony import */ var _redux_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99927);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62570);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64234);








var initialState = {
    currentMap: "root",
    maps: {
        root: []
    }
};
var mapReducer = function() {
    var map = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)(map, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, map, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].MAP_UPDATE */ .ZP.MAP_UPDATE:
                draft.maps[draft.currentMap] = action.payload;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].MAP_SELECT */ .ZP.MAP_SELECT:
                var name = action.payload;
                //Preset
                if (name === "clear") {
                    draft.currentMap = null;
                    return draft;
                }
                if (name === "artboards") {
                    draft.currentMap = "artboards";
                    return draft;
                }
                //Create new map if not initialized yet.
                if (!(0,_util_Obj__WEBPACK_IMPORTED_MODULE_4__/* .hasAttr */ .B$)(draft.maps, name)) {
                    draft.maps[name] = [];
                }
                draft.currentMap = name;
                return draft;
            default:
                return map;
        }
        ; //switch
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (mapReducer);
var mapStoreSelector = function(state) {
    return (0,_redux_util__WEBPACK_IMPORTED_MODULE_5__/* .feature */ .z)("map", state);
};
var currentMap = function(state) {
    var ref;
    return (ref = mapStoreSelector(state)) === null || ref === void 0 ? void 0 : ref.currentMap;
};
var mapSelector = function(state) {
    return mapStoreSelector(state).maps[currentMap(state)];
};
var itemMapByPathSelector = function(state, path) {
    return (0,_mosanic_utils_map_get__WEBPACK_IMPORTED_MODULE_6__/* .getItemByPath */ .R9)({
        map: mapSelector(state),
        path: path
    });
};


/***/ }),

/***/ 39623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ confirmModalAction; },
/* harmony export */   "Mr": function() { return /* binding */ closeModal; },
/* harmony export */   "Nb": function() { return /* binding */ declineModalAction; },
/* harmony export */   "nT": function() { return /* binding */ modalActions; }
/* harmony export */ });
/* unused harmony exports MODAL_ID, confirmationModalAction, choiceModalAction, storeModalAction, clearModalAction, submitModalAction, modalTypes */
var MODAL_ID = "[modal]";
var ID = MODAL_ID;
//Creation
var REQUEST = "".concat(ID, " Request");
//Store request
var SAVE = "".concat(ID, " Store");
var CLEAR = "".concat(ID, " Clear");
//Submit
var CONFIRM = "".concat(ID, " confirm");
var DECLINE = "".concat(ID, " Decline");
var SUBMIT = "".concat(ID, " Submit");
//Types
var CONFIRMATION = "(confirmation)";
var CHOICE = "(choice)";
//Creation
var confirmationModalAction = function(param) {
    var message = param.message, confirmAction = param.confirmAction, declineAction = param.declineAction, _title = param.title, title = _title === void 0 ? null : _title;
    return {
        type: "".concat(REQUEST, " ").concat(CONFIRMATION),
        payload: {
            title: title,
            message: message,
            confirmAction: confirmAction,
            declineAction: declineAction
        }
    };
};
var choiceModalAction = function(param) {
    var message = param.message, options = param.options, confirmAction = param.confirmAction, _declineAction = param.declineAction, declineAction = _declineAction === void 0 ? null : _declineAction;
    return {
        type: "".concat(REQUEST, " ").concat(CHOICE),
        payload: {
            message: message,
            options: options,
            confirmAction: confirmAction,
            declineAction: declineAction
        }
    };
};
//Storing
var storeModalAction = function(param) {
    var action = param.action, _type = param.type, type = _type === void 0 ? null : _type;
    return {
        type: SAVE,
        payload: action.payload,
        meta: type
    };
};
var clearModalAction = function() {
    return {
        type: CLEAR
    };
};
//Submitting
var submitModalAction = function(param) {
    var value = param.value;
    return {
        type: SUBMIT,
        payload: value
    };
};
var confirmModalAction = function() {
    return {
        type: CONFIRM
    };
};
var declineModalAction = function() {
    return {
        type: DECLINE
    };
};
var closeModal = function() {
    return {
        type: DECLINE
    };
};
var MODAL_ACTION_IDS = {
    REQUEST: REQUEST,
    SAVE: SAVE,
    CLEAR: CLEAR,
    SUBMIT: SUBMIT,
    CONFIRM: CONFIRM,
    DECLINE: DECLINE
};
var modalTypes = {
    confirmation: CONFIRMATION,
    choice: CHOICE
};
var modalActions = {
    confirmationModalAction: confirmationModalAction,
    choiceModalAction: choiceModalAction,
    storeModalAction: storeModalAction,
    clearModalAction: clearModalAction,
    submitModalAction: submitModalAction,
    confirmModalAction: confirmModalAction,
    declineModalAction: declineModalAction,
    closeModal: closeModal
};
/* harmony default export */ __webpack_exports__["ZP"] = (MODAL_ACTION_IDS);


/***/ }),

/***/ 18891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SY": function() { return /* binding */ getModalSelector; }
/* harmony export */ });
/* unused harmony exports getModalState, getModalStore */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _redux_baseSelector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32884);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39623);





var initialState = {
    title: null,
    message: null,
    options: null,
    confirmAction: null,
    declineAction: null
};
var modalReducer = function() {
    var modal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(modal, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return draft = action.payload;
            case _action__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SAVE */ .ZP.SAVE:
                draft = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, action.payload);
                return draft;
            // case MODAL_SET:
            //   draft = {
            //     ...draft,
            //     type: action?.payload,
            //     active: action?.meta?.state,
            //     data: action?.meta?.data,
            //     msg: action?.meta?.msg,
            //     store: action?.meta?.store,
            //     input: null,
            //   };
            //   return draft;
            // case MODAL_CONFIRM:
            //   draft.input = action.payload;
            //   draft.active = action?.payload?.state;
            //   return draft;
            case _action__WEBPACK_IMPORTED_MODULE_2__/* ["default"].CLEAR */ .ZP.CLEAR:
                draft = initialState;
                return draft;
            // case MODAL_UPDATE: 
            //   draft.input = action.payload;
            //   draft.active = action?.meta?.state;
            //   break;
            // case MODAL_STATE:
            //   draft.active = action.payload;
            //   return draft;
            default:
                return draft;
        }
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (modalReducer);
var isConfirmation = function(action) {
    return action.type === modalTypes.confirmation;
};
var getModalSelector = function(state) {
    return (0,_redux_baseSelector__WEBPACK_IMPORTED_MODULE_4__/* .featureSelector */ .g)(state, "modal");
};
// ! old !
var getModalState = function(state) {
    var ref;
    return state === null || state === void 0 ? void 0 : (ref = state.present) === null || ref === void 0 ? void 0 : ref.modal;
};
var getModalStore = function(state) {
    var ref, ref1;
    return state === null || state === void 0 ? void 0 : (ref = state.present) === null || ref === void 0 ? void 0 : (ref1 = ref.modal) === null || ref1 === void 0 ? void 0 : ref1.store;
};


/***/ }),

/***/ 59801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wl": function() { return /* binding */ setSubSideBarAction; },
/* harmony export */   "_W": function() { return /* binding */ setSidebarPanelAction; },
/* harmony export */   "aH": function() { return /* binding */ setMainSideBarAction; },
/* harmony export */   "tG": function() { return /* binding */ toggleMobileAction; }
/* harmony export */ });
/* unused harmony exports NAV_ID, NAV_SET, UPDATE_NAVIGATION, NAV_SET_PANEL, NAV_TOGGLE_MOBILE, TOGGLE_SMALL, setLeftSidebarPanelActive, setSubSidebarPanelActive */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26297);



var NAV_ID = "[nav]";
var NAV_SET = "".concat(NAV_ID, " [Sidebar] set");
var UPDATE_NAVIGATION = "".concat(NAV_ID, " Update");
var NAV_SET_PANEL = "".concat(NAV_ID, " Set Panel");
var NAV_TOGGLE_MOBILE = "".concat(NAV_ID, " Toggle Mobile");
var TOGGLE_SMALL = "".concat(NAV_ID, " Sidebar small");
var NAV_IDS = {
    NAV_SET_PANEL: NAV_SET_PANEL,
    NAV_TOGGLE_MOBILE: NAV_TOGGLE_MOBILE,
    TOGGLE_SMALL: TOGGLE_SMALL,
    NAV_SET: NAV_SET
};
var setMainSideBarAction = function(_param) {
    var _open = _param.open, open = _open === void 0 ? undefined : _open, _width = _param.width, width = _width === void 0 ? undefined : _width, _value = _param.value, value = _value === void 0 ? undefined : _value, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "open",
        "width",
        "value"
    ]);
    return {
        type: NAV_SET,
        payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            open: open,
            width: width,
            value: value
        }, other), {
            panel: "main"
        }),
        meta: {
            feature: NAV_ID
        }
    };
};
var setSubSideBarAction = function(_param) {
    var _open = _param.open, open = _open === void 0 ? undefined : _open, _width = _param.width, width = _width === void 0 ? undefined : _width, _value = _param.value, value = _value === void 0 ? undefined : _value, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "open",
        "width",
        "value"
    ]);
    return {
        type: NAV_SET,
        payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            open: open,
            width: width,
            value: value
        }, other), {
            panel: "sub"
        }),
        meta: {
            feature: NAV_ID
        }
    };
};
var toggleMobileAction = function() {
    return {
        type: NAV_TOGGLE_MOBILE,
        meta: {
            feature: NAV_ID
        }
    };
};
var setSidebarPanelAction = function(param) {
    var _value = param.value, value = _value === void 0 ? null : _value, _panel = param.panel, panel = _panel === void 0 ? "left" : _panel;
    return {
        type: NAV_SET_PANEL,
        payload: {
            value: value,
            panel: panel
        },
        meta: {
            feature: NAV_ID
        }
    };
};
//Short cuts
var setLeftSidebarPanelActive = function(panel, value) {
    return setSidebarPanelAction({
        value: _object_spread({}, panel, value),
        panel: "left"
    });
};
var setSubSidebarPanelActive = function(subPanel, value) {
    return setSidebarPanelAction({
        value: _object_spread({}, subPanel, value),
        panel: "subLeft"
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (NAV_IDS);


/***/ }),

/***/ 12594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ sideBarSelector; },
/* harmony export */   "k0": function() { return /* binding */ mobileNavSelector; },
/* harmony export */   "oo": function() { return /* binding */ leftPanelSelector; }
/* harmony export */ });
/* unused harmony exports initialPanel, navSelector, sideBarSmallSelector, leftSubPanelSelector, rightPanelSelector */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _redux_baseSelector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32884);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59801);






var initialPanel = {
    value: null,
    small: null,
    width: null,
    active: null,
    icon: false
};
var initialState = {
    main: {
        open: true,
        width: 150,
        value: "dashboard"
    },
    sub: {
        open: false,
        width: null,
        value: null
    },
    left: initialPanel,
    right: initialPanel,
    subLeft: initialPanel,
    subRight: initialPanel,
    small: true,
    large: true,
    mobileOpen: false
};
var navReducer = function() {
    var nav = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)(nav, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, nav, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].NAV_SET */ .ZP.NAV_SET:
                draft[action.payload.panel] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, draft[action.payload.panel], action.payload), {
                    panel: undefined
                });
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].NAV_SET_PANEL */ .ZP.NAV_SET_PANEL:
                draft[action.payload.panel] = action.payload.value;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].NAV_TOGGLE_MOBILE */ .ZP.NAV_TOGGLE_MOBILE:
                draft.mobileOpen = !draft.mobileOpen;
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].TOGGLE_SMALL */ .ZP.TOGGLE_SMALL:
                draft.small = !draft.small;
                return draft;
            default:
                return nav;
        }
        ; //switch
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (navReducer);
var navSelector = function(state) {
    return (0,_redux_baseSelector__WEBPACK_IMPORTED_MODULE_5__/* .featureSelector */ .g)(state, "nav");
};
var mobileNavSelector = function(state) {
    var ref;
    return (ref = navSelector(state)) === null || ref === void 0 ? void 0 : ref.mobileOpen;
};
var sideBarSmallSelector = function(state) {
    var ref;
    return (ref = navSelector(state)) === null || ref === void 0 ? void 0 : ref.small;
};
var leftPanelSelector = function(state) {
    var ref;
    return (ref = navSelector(state)) === null || ref === void 0 ? void 0 : ref.left;
};
var leftSubPanelSelector = function(state) {
    var ref;
    return (ref = navSelector(state)) === null || ref === void 0 ? void 0 : ref.subLeft;
};
var rightPanelSelector = function(state) {
    var ref;
    return (ref = navSelector(state)) === null || ref === void 0 ? void 0 : ref.right;
};
var mainPanelSelector = function(state) {
    var ref;
    return (ref = navSelector(state)) === null || ref === void 0 ? void 0 : ref.main;
};
var subPanelSelector = function(state) {
    var ref;
    return (ref = navSelector(state)) === null || ref === void 0 ? void 0 : ref.sub;
};
var sideBarSelector = function(state) {
    return {
        main: mainPanelSelector(state),
        sub: subPanelSelector(state)
    } // export const getCap = state => state.present.options.caps;
     // export const getBreakpoints = state => state.present.canvas.breakpoints;
    ;
};


/***/ }),

/***/ 64725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FV": function() { return /* binding */ removeNotification; },
/* harmony export */   "Kf": function() { return /* binding */ REMOVE_NOTIFICATION; },
/* harmony export */   "iK": function() { return /* binding */ DISMISS_NOTIFICATION; },
/* harmony export */   "sc": function() { return /* binding */ setNotification; },
/* harmony export */   "uP": function() { return /* binding */ SET_NOTIFICATION; }
/* harmony export */ });
/* unused harmony exports NOTIFICATION, TIMING_DELETE_NOTIFICATION, TIMING_DEFAULT_VARIANT, dismissNotification, presetNotification */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88932);


var NOTIFICATION = "[notification]";
var SET_NOTIFICATION = "".concat(NOTIFICATION, " set");
var REMOVE_NOTIFICATION = "".concat(NOTIFICATION, " remove");
var DISMISS_NOTIFICATION = "".concat(NOTIFICATION, " dismiss");
var TIMING_DELETE_NOTIFICATION = 3000; //ms
var TIMING_DEFAULT_VARIANT = "warning"; //ms
var setNotification = function(param) {
    var message = param.message, feature = param.feature, _duration = param.duration, duration = _duration === void 0 ? 300 : _duration, _variant = param.variant, variant = _variant === void 0 ? "warning" : _variant, _persist = param.persist, persist = _persist === void 0 ? false : _persist, _position = param.position, position = _position === void 0 ? "top-center" : _position, _delay = param.delay, delay = _delay === void 0 ? 0 : _delay, meta = param.meta;
    return {
        type: "".concat(feature, " ").concat(SET_NOTIFICATION),
        payload: message,
        meta: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            feature: feature,
            duration: duration,
            variant: variant,
            persist: persist,
            position: position,
            delay: delay
        }, meta)
    };
};
// export const setProgress = ({progress, feature = 'upload', meta = null}) => ({
//     type: `${feature} ${SET_NOTIFICATION}`,
//     payload: message,
//     meta: {feature, ...meta}
// });
var removeNotification = function(param) {
    var notificationId = param.notificationId, feature = param.feature;
    return {
        type: "".concat(feature, " ").concat(REMOVE_NOTIFICATION),
        payload: notificationId,
        meta: {
            feature: feature
        }
    };
};
var dismissNotification = function(param) {
    var notificationId = param.notificationId, _feature = param.feature, feature = _feature === void 0 ? "auto" : _feature;
    return {
        type: "".concat(feature, " ").concat(DISMISS_NOTIFICATION),
        payload: notificationId
    };
};
var presetNotification = function(preset) {
    var replaceString = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, feature = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "undefined";
    var presets = {
        "not-supported": "[replace] is not yet supported."
    };
    var message = replaceString ? presets[preset].replace("[replace]", replaceString) : presets[preset];
    setNotification({
        message: message,
        feature: feature
    });
};


/***/ }),

/***/ 91994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getNotificationsSelector; },
/* harmony export */   "e": function() { return /* binding */ notificationsReducer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50930);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64725);





var initState = [];
var notificationsReducer = function() {
    var notifications = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(true){
        case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, notifications, action.payload);
        case action.type.includes(_action__WEBPACK_IMPORTED_MODULE_2__/* .SET_NOTIFICATION */ .uP):
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(notifications).concat([
                action.payload
            ]);
        case action.type.includes(_action__WEBPACK_IMPORTED_MODULE_2__/* .REMOVE_NOTIFICATION */ .Kf):
            return notifications.filter(function(notification) {
                return notification._id !== action.payload;
            });
        case action.type.includes(_action__WEBPACK_IMPORTED_MODULE_2__/* .DISMISS_NOTIFICATION */ .iK):
            return notifications.map(function(notification) {
                return notification._id === action.payload ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, notification), {
                    dismissed: true
                }) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, notification);
            });
        default:
            return notifications;
    }
};
var getNotificationsSelector = function(state) {
    return state.present.notifications;
};


/***/ }),

/***/ 30850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cj": function() { return /* binding */ UPDATE_PREF; },
/* harmony export */   "M7": function() { return /* binding */ TOGGLE_ACCORDION; },
/* harmony export */   "Mc": function() { return /* binding */ updatePref; },
/* harmony export */   "NA": function() { return /* binding */ updateDragDropState; },
/* harmony export */   "WY": function() { return /* binding */ toggleAccordion; },
/* harmony export */   "i4": function() { return /* binding */ updateCap; },
/* harmony export */   "vV": function() { return /* binding */ UPDATE_CAP; }
/* harmony export */ });
/* unused harmony export OPTIONS_ID */
var ID = "[options]";
var OPTIONS_ID = ID;
var UPDATE_CAP = "".concat(ID, " UPDATE Cap");
var UPDATE_PREF = "".concat(ID, " UPDATE Pref");
var TOGGLE_ACCORDION = "".concat(ID, " Toggle Accordion");
var updateCap = function(param) {
    var group = param.group, sub = param.sub, cap = param.cap;
    return {
        type: UPDATE_CAP,
        payload: {
            group: group,
            sub: sub,
            cap: cap
        },
        meta: {
            feature: OPTIONS_ID
        }
    };
};
var updateDragDropState = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "auto";
    return {
        type: UPDATE_PREF,
        payload: state === "auto" ? {
            group: "builder",
            pref: "dragDrop"
        } : {
            group: "builder",
            pref: "dragDrop",
            state: state
        },
        meta: {
            feature: OPTIONS_ID,
            type: "drag drop"
        }
    };
};
var updatePref = function(param) {
    var group = param.group, pref = param.pref, state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "auto";
    return {
        type: UPDATE_PREF,
        payload: state === "auto" ? {
            group: group,
            pref: pref
        } : {
            group: group,
            pref: pref,
            state: state
        },
        meta: {
            feature: OPTIONS_ID
        }
    };
};
var toggleAccordion = function(param) {
    var field = param.field, state = param.state;
    return {
        type: TOGGLE_ACCORDION,
        payload: {
            field: field,
            state: state
        },
        meta: {
            feature: OPTIONS_ID
        }
    };
};


/***/ }),

/***/ 51331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CT": function() { return /* binding */ breakpointModeSelector; },
  "uV": function() { return /* binding */ canDevInspectCap; },
  "QE": function() { return /* binding */ canDragDropSelector; },
  "II": function() { return /* binding */ canEditColorsSelector; },
  "wg": function() { return /* binding */ canMoveCanvasSelector; },
  "Hv": function() { return /* binding */ canPalletteSelector; },
  "i2": function() { return /* binding */ canResizeCanvasSelector; },
  "rg": function() { return /* binding */ canRoundUpEditors; },
  "hq": function() { return /* binding */ canToggleColorDisplaySelector; },
  "WT": function() { return /* binding */ canVariantLocaleSelector; },
  "YL": function() { return /* binding */ canZoomPinchSelector; },
  "Im": function() { return /* binding */ colorCaps; },
  "ZP": function() { return /* binding */ reducer; },
  "iW": function() { return /* binding */ getAccordion; },
  "aX": function() { return /* binding */ getAutoOpenInspect; },
  "yp": function() { return /* binding */ getAutoOpenLayers; },
  "ui": function() { return /* binding */ getAutoSavePref; },
  "rb": function() { return /* binding */ getCap; },
  "Lj": function() { return /* binding */ getDevModePrefSelector; },
  "N8": function() { return /* binding */ getPref; },
  "Iz": function() { return /* binding */ getPreferences; },
  "qG": function() { return /* binding */ getShouldStartIntro; },
  "Sm": function() { return /* binding */ getTooltips; },
  "J": function() { return /* binding */ horizontalModeSelector; },
  "Qm": function() { return /* binding */ isOutlineCanvasSelector; },
  "CN": function() { return /* binding */ isPreviewCanvasSelector; },
  "dJ": function() { return /* binding */ screenPreviewModeSelector; },
  "Qc": function() { return /* binding */ showMultiScreenSelector; },
  "iu": function() { return /* binding */ sideBarHelpSelector; }
});

// UNUSED EXPORTS: getAutoCloseAccordion, showDynamicDataPreviewSelector, toggleColorDisplayPref

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ./src/mosanic/constants/inspector.js

var _obj;
var INITIAL_ACCORDION_STATE = (_obj = {
    align: false,
    repeater: true,
    clone: true,
    state: true,
    mixins: false,
    preview: false,
    layoutStates: true,
    dataState: false,
    layout: false,
    stack: false,
    grid: false,
    position: false,
    margin: false,
    tags: false,
    sizing: false,
    scroll: false,
    padding: false,
    visibility: false,
    anchor: false,
    css: false
}, (0,_define_property/* default */.Z)(_obj, "state", false), (0,_define_property/* default */.Z)(_obj, "colors", false), (0,_define_property/* default */.Z)(_obj, "background", false), (0,_define_property/* default */.Z)(_obj, "image", false), (0,_define_property/* default */.Z)(_obj, "border", false), (0,_define_property/* default */.Z)(_obj, "radius", false), (0,_define_property/* default */.Z)(_obj, "shadow", false), (0,_define_property/* default */.Z)(_obj, "interaction", false), _obj);

// EXTERNAL MODULE: ../../node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(76665);
// EXTERNAL MODULE: ../../node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(59775);
// EXTERNAL MODULE: ./src/features/options/action.js
var options_action = __webpack_require__(30850);
;// CONCATENATED MODULE: ./src/features/options/reducer.js







var initialState = {
    caps: {
        styling: {
            colors: {
                preferred: true,
                secondary: true,
                util: true,
                gradients: true,
                custom: true,
                palette: true,
                opacity: true,
                display: true,
                editing: true,
                count: true,
                saturation: true
            },
            background: {
                color: false,
                image: false,
                pattern: false,
                gradient: false
            }
        },
        builder: {
            canvas: {
                markers: true,
                advancedBps: true,
                resizeCanvas: true,
                zoomPinch: true,
                multipleScreens: false,
                contextDev: false,
                breakpointMode: true,
                outlines: false
            },
            dnd: {
                active: true,
                newCols: true
            }
        },
        util: {
            inspector: {
                expandable: true
            },
            smart: {
                autoSwitchState: true,
                autoCloseAccordion: true
            },
            helpers: {
                roundUp: true
            },
            dev: {
                dataPreview: true,
                devMode: true,
                inspector: false,
                devLabels: true,
                fps: false
            }
        }
    },
    preferences: {
        styling: {
            editor: "ChromePicker",
            secondary: false,
            util: false,
            colorDisplay: "pallette"
        },
        builder: {
            previewMode: false,
            dragDrop: true,
            moveCanvas: true,
            cleanView: false,
            resizeCanvas: false,
            newColumns: true,
            zoomPinch: true,
            multipleScreens: true,
            breakpointMode: true,
            horizontalMode: false,
            screenPreviewMode: false,
            dataPreview: false,
            outlines: false,
            ctxLocale: true
        },
        helpers: {
            intro: true
        },
        util: {
            // autoSwitchState: false,
            // roundUp: false,
            devMode: false,
            autoSave: false,
            expandedInspector: true
        }
    },
    accordion: (0,_object_spread/* default */.Z)({}, INITIAL_ACCORDION_STATE)
};
var optionReducer = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer_esm/* produce */.Uy)(options, function(draft) {
        var pl;
        var draftPref = draft === null || draft === void 0 ? void 0 : draft.preferences;
        switch(action.type){
            case es6/* HYDRATE */.ju:
                return (0,_object_spread/* default */.Z)({}, options, action.payload);
            case options_action/* UPDATE_CAP */.vV:
                pl = action.payload;
                draft.caps[pl.group][pl.sub][pl.cap] = !draft.caps[pl.group][pl.sub][pl.cap];
                return draft;
            case options_action/* UPDATE_PREF */.Cj:
                pl = action.payload;
                draft.preferences[pl.group][pl.pref] = !draft.preferences[pl.group][pl.pref];
                // draft.preferences[pl.group][pl.pref] = !action.meta?.state ? !draft.preferences[pl.group][pl.pref] : action.meta.state;
                return draft;
            case options_action/* TOGGLE_ACCORDION */.M7:
                var ref;
                if ((ref = draftPref.helpers) === null || ref === void 0 ? void 0 : ref.autoCloseAccordion) {
                    draft.accordion = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, INITIAL_ACCORDION_STATE), (0,_define_property/* default */.Z)({}, action.payload.field, !action.payload.state));
                } else {
                    draft.accordion[action.payload.field] = !action.payload.state;
                }
                return draft;
            default:
                return options;
        }
        ; //switch
    });
};
/* harmony default export */ var reducer = (optionReducer);
var getOptions = function(state) {
    var ref;
    return state === null || state === void 0 ? void 0 : (ref = state.present) === null || ref === void 0 ? void 0 : ref.options;
};
var getCap = function(state) {
    var ref;
    return (ref = getOptions(state)) === null || ref === void 0 ? void 0 : ref.caps;
};
var getPref = function(state) {
    var ref;
    return (ref = getOptions(state)) === null || ref === void 0 ? void 0 : ref.preferences;
};
var getPreferences = function(state) {
    return getPref(state);
};
var getAccordion = function(state) {
    var ref;
    return (ref = getOptions(state)) === null || ref === void 0 ? void 0 : ref.accordion;
};
var getTooltips = function(state) {
    var ref;
    return (ref = getPref(state)) === null || ref === void 0 ? void 0 : ref.helpers.tooltips;
};
var sideBarHelpSelector = function(state) {
    var ref;
    return (ref = getPref(state)) === null || ref === void 0 ? void 0 : ref.helpers.sidebarHelp;
};
var helperPref = function(state) {
    var ref;
    return (ref = getPref(state)) === null || ref === void 0 ? void 0 : ref.helpers;
};
var getAutoOpenInspect = function(state) {
    var ref;
    return (ref = helperPref(state)) === null || ref === void 0 ? void 0 : ref.autoOpenInspect;
};
var getAutoOpenLayers = function(state) {
    var ref;
    return (ref = helperPref(state)) === null || ref === void 0 ? void 0 : ref.autoOpenLayers;
};
var getAutoCloseAccordion = function(state) {
    var ref;
    return (ref = helperPref(state)) === null || ref === void 0 ? void 0 : ref.autoCloseAccordion;
};
var getShouldStartIntro = function(state) {
    var ref;
    return (ref = getPref(state)) === null || ref === void 0 ? void 0 : ref.helpers.intro;
};
var getAutoSavePref = function(state) {
    var ref;
    return (ref = getPref(state)) === null || ref === void 0 ? void 0 : ref.util.autoSave;
};
var getDevModePrefSelector = function(state) {
    var ref;
    return (ref = getPref(state)) === null || ref === void 0 ? void 0 : ref.util.devMode;
};
var colorCaps = function(state) {
    return getCap(state).styling.colors;
};
var canEditColorsSelector = function(state) {
    var ref;
    return (ref = colorCaps(state)) === null || ref === void 0 ? void 0 : ref.editing;
};
var canPalletteSelector = function(state) {
    return colorCaps(state).palette;
};
var canToggleColorDisplaySelector = function(state) {
    var ref;
    return (ref = colorCaps(state)) === null || ref === void 0 ? void 0 : ref.display;
};
var toggleColorDisplayPref = function(state) {
    var ref;
    return (ref = getPref(state)) === null || ref === void 0 ? void 0 : ref.styling.colorDisplay;
};
var canResizeCanvasSelector = function(state) {
    return getPref(state).builder.resizeCanvas;
};
var canDragDropSelector = function(state) {
    return getPref(state).builder.dragDrop;
};
// TODO  ++ ---> is not editing !! (text field, button, live editor)
var canDevInspectCap = function(state) {
    return getCap(state).builder.canvas.contextDev;
};
var isOutlineCanvasSelector = function(state) {
    return getPref(state).builder.outlines;
};
var canVariantLocaleSelector = function(state) {
    return getPref(state).builder.ctxLocale;
};
var isPreviewCanvasSelector = function(state) {
    return getPref(state).builder.previewMode;
};
var canZoomPinchSelector = function(state) {
    return getPref(state).builder.zoomPinch;
};
var canMoveCanvasSelector = function(state) {
    return getPref(state).builder.moveCanvas;
};
var showMultiScreenSelector = function(state) {
    return getPref(state).builder.multipleScreens;
};
var showDynamicDataPreviewSelector = function(state) {
    return getPref(state).builder.dataPreview;
};
var breakpointModeSelector = function(state) {
    return getPref(state).builder.breakpointMode;
};
var horizontalModeSelector = function(state) {
    var ref;
    return (ref = getPref(state)) === null || ref === void 0 ? void 0 : ref.builder.horizontalMode;
};
var screenPreviewModeSelector = function(state) {
    var ref;
    return (ref = getPref(state)) === null || ref === void 0 ? void 0 : ref.builder.screenPreviewMode;
};
var canRoundUpEditors = function(state) {
    return getPref(state).util.roundUp;
}; // ==> Get components / rows / columns --> based on current state 


/***/ }),

/***/ 80936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "by": function() { return /* binding */ updatePageAction; },
/* harmony export */   "m8": function() { return /* binding */ setPageAction; },
/* harmony export */   "sD": function() { return /* binding */ resetPagesAction; }
/* harmony export */ });
/* unused harmony exports PAGES_ID, SET_PAGE, UPDATE_PAGE, SELECT_PAGE, DELETE_PAGE, RESET_PAGES, selectPage, deletePage */
var ID = "[page]";
var PAGES_ID = (/* unused pure expression or super */ null && (ID));
var SET_PAGE = ID + " Set";
var UPDATE_PAGE = ID + " Update";
var SELECT_PAGE = ID + " Select";
var DELETE_PAGE = ID + " Delete";
var RESET_PAGES = ID + " Reset";
var PAGES_IDS = {
    SET_PAGE: SET_PAGE,
    UPDATE_PAGE: UPDATE_PAGE,
    SELECT_PAGE: SELECT_PAGE,
    RESET_PAGES: RESET_PAGES
};
/* harmony default export */ __webpack_exports__["ZP"] = (PAGES_IDS);
var updatePageAction = function(data) {
    return {
        type: UPDATE_PAGE,
        payload: data
    };
};
var selectPage = function(data) {
    return {
        type: SELECT_PAGE,
        payload: data
    };
};
var setPageAction = function(data) {
    return {
        type: SET_PAGE,
        payload: data
    };
};
var deletePage = function(data) {
    return {
        type: DELETE_PAGE,
        payload: data
    };
};
var resetPagesAction = function() {
    return {
        type: RESET_PAGES
    };
};


/***/ }),

/***/ 80762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kA": function() { return /* binding */ pageReducer; },
/* harmony export */   "nV": function() { return /* binding */ pageMetaSelector; },
/* harmony export */   "pt": function() { return /* binding */ getPagesArray; },
/* harmony export */   "vz": function() { return /* binding */ pageMetaAttrSelector; }
/* harmony export */ });
/* unused harmony exports pageNameSelector, getPresentPages, getSelectedPageId, getPagesIds, getSelectedPage, getFilteredPagesArray */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76665);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80936);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62570);
/* harmony import */ var _redux_baseSelector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32884);
// import { handleRemoveItemFromLayout } from "../../components/Builder/Util/Layout/helpers";






var initialState = {
    current: "root",
    pages: {
        root: {
            name: "root",
            seo: null
        }
    }
};
var updatePage = function(draft, action) {
    var ref;
    var pageId = (ref = action.payload) === null || ref === void 0 ? void 0 : ref._id;
    draft.current = pageId;
    draft = (0,_util_Obj__WEBPACK_IMPORTED_MODULE_1__/* .set */ .t8)(draft, "pages.".concat(pageId), action.payload);
    return draft;
};
var pageReducer = function() {
    var pages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* .produce */ .Uy)(pages, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, pages, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].UPDATE_PAGE */ .ZP.UPDATE_PAGE:
                return updatePage(draft, action);
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].SET_PAGE */ .ZP.SET_PAGE:
                return updatePage(draft, action);
            case _action__WEBPACK_IMPORTED_MODULE_4__/* ["default"].RESET_PAGES */ .ZP.RESET_PAGES:
                return initialState;
            default:
                return pages;
        }
        ; //switch
    });
};
var pagesFeature = function(state) {
    return (0,_redux_baseSelector__WEBPACK_IMPORTED_MODULE_5__/* .featureSelector */ .g)(state, "pages");
};
var pageNameSelector = function(state) {
    return pagesFeature(state).current;
};
var pageMetaSelector = function(state) {
    var ref, ref1;
    return (ref = pagesFeature(state)) === null || ref === void 0 ? void 0 : (ref1 = ref.pages) === null || ref1 === void 0 ? void 0 : ref1[pageNameSelector(state)];
};
var pageMetaAttrSelector = function(state, attr) {
    var ref;
    return attr ? (ref = pageMetaSelector(state)) === null || ref === void 0 ? void 0 : ref[attr] : pageMetaSelector(state);
};
var getPresentPages = function(state) {
    var ref;
    return (state === null || state === void 0 ? void 0 : (ref = state.pages) === null || ref === void 0 ? void 0 : ref.entities) ? state.pages.entities[PAGES_ID] : null;
};
var getSelectedPageId = function(state) {
    var ref;
    return (ref = getPresentPages(state)) === null || ref === void 0 ? void 0 : ref[0]._id;
};
var getPagesIds = function(state) {
    return getPresentPages(state) ? Object.keys(getPresentPages(state)) : null;
};
var getSelectedPage = function(state) {
    var pages = getPresentPages(state);
    var pageId = getSelectedPageId(state);
    return pages[pageId];
};
var getPagesArray = function(state) {
    var pages = getPresentPages(state);
    return pages ? Object.keys(pages).reduce(function() {
        var pageArray = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], pageId = arguments.length > 1 ? arguments[1] : void 0;
        pageArray.push(pages[pageId]);
        return pageArray;
    }, []) : null;
};
var getFilteredPagesArray = function(state) {
    var pages = getPresentPages(state);
    return pages ? Object.keys(pages).reduce(function() {
        var pageArray = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], pageId = arguments.length > 1 ? arguments[1] : void 0;
        var _pageId = pages[pageId], title = _pageId.title, _id = _pageId._id, author = _pageId.author;
        pageArray.push({
            title: title,
            _id: _id,
            author: author
        });
        return pageArray;
    }, []) : null;
};


/***/ }),

/***/ 21398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CV": function() { return /* binding */ initializeScreens; },
/* harmony export */   "D4": function() { return /* binding */ setCurrentPage; },
/* harmony export */   "DI": function() { return /* binding */ updateScreenMeta; },
/* harmony export */   "L4": function() { return /* binding */ setScreenBpAction; },
/* harmony export */   "Q2": function() { return /* binding */ initNewScreen; },
/* harmony export */   "Qg": function() { return /* binding */ initScreen; },
/* harmony export */   "Yk": function() { return /* binding */ setScreenDeviceAction; },
/* harmony export */   "cu": function() { return /* binding */ handleScreenAdd; },
/* harmony export */   "gd": function() { return /* binding */ handlePageAdd; },
/* harmony export */   "nt": function() { return /* binding */ handleInspectScreen; },
/* harmony export */   "ui": function() { return /* binding */ handleScreenRemove; },
/* harmony export */   "yl": function() { return /* binding */ reorderScreens; }
/* harmony export */ });
/* unused harmony exports SCREENS_ID, handleScreenResize, handleScreenPosition, updateSeoAction, setScreensScale, updateScreensScale, resetOffsetsScreens */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96670);


var ID = "[screens]";
var SCREENS_ID = ID;
//Individual
var SCREEN_HANDLE_RESIZE = "".concat(ID, " Handle resize screen");
var SCREEN_UPDATE_POSITION = "".concat(ID, " Update position screen");
var SCREEN_INSPECT = "".concat(ID, " Inspect screen");
var PAGE_UPDATE_SEO = "".concat(ID, " Update seo");
//Create + remove + update
var PAGE_ADD_NEW = "".concat(ID, " Add page");
var PAGE_SET = "".concat(ID, " Set page");
var SCREEN_ADD_NEW = "".concat(ID, " Add screen");
var SCREEN_REMOVE = "".concat(ID, " Remove screen");
var SCREENS_UPDATE_META = "".concat(ID, " Update screen meta");
//Global
var SCREENS_SET_SCALE = "".concat(ID, " Set scale");
var SCREENS_REORDER = "".concat(ID, " Reorder");
var SCREENS_RESET_OFFSETS = "".concat(ID, " Reset Offsets");
var SCREENS_INIT = "".concat(ID, " Initialize");
var SCREEN_INIT = "".concat(ID, " Init screen");
var SCREEN_INIT_NEW = "".concat(ID, " Init new screen");
var SCREEN_SET_BP = "".concat(ID, " Set bp");
var SCREEN_SET_DEVICE = "".concat(ID, " Set device");
var SCREENS_ACTION_IDS = {
    SCREEN_HANDLE_RESIZE: SCREEN_HANDLE_RESIZE,
    SCREEN_UPDATE_POSITION: SCREEN_UPDATE_POSITION,
    SCREEN_ADD_NEW: SCREEN_ADD_NEW,
    PAGE_ADD_NEW: PAGE_ADD_NEW,
    PAGE_UPDATE_SEO: PAGE_UPDATE_SEO,
    PAGE_SET: PAGE_SET,
    SCREEN_REMOVE: SCREEN_REMOVE,
    SCREENS_UPDATE_META: SCREENS_UPDATE_META,
    SCREEN_INIT_NEW: SCREEN_INIT_NEW,
    SCREENS_SET_SCALE: SCREENS_SET_SCALE,
    SCREENS_REORDER: SCREENS_REORDER,
    SCREENS_INIT: SCREENS_INIT,
    SCREEN_INIT: SCREEN_INIT,
    SCREEN_INSPECT: SCREEN_INSPECT,
    SCREEN_SET_BP: SCREEN_SET_BP,
    SCREEN_SET_DEVICE: SCREEN_SET_DEVICE
};
/* harmony default export */ __webpack_exports__["ZP"] = (SCREENS_ACTION_IDS);
//Live editing
var handleInspectScreen = function(param) {
    var screen = param.screen, bounds = param.bounds, size = param.size;
    return {
        type: SCREEN_INSPECT,
        payload: {
            component: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, screen), {
                type: "screen",
                group: "screens"
            }),
            bounds: bounds,
            screen: size
        },
        meta: {
            feature: SCREENS_ID
        }
    };
};
var handleScreenResize = function(param) {
    var width = param.width, height = param.height, _id = param._id;
    return {
        type: SCREEN_HANDLE_RESIZE,
        payload: {
            width: width,
            height: height,
            _id: _id
        },
        meta: {
            feature: SCREENS_ID
        }
    };
};
var handleScreenPosition = function(param) {
    var x = param.x, y = param.y, _id = param._id;
    return {
        type: SCREEN_UPDATE_POSITION,
        payload: {
            x: x,
            y: y,
            _id: _id
        },
        meta: {
            feature: SCREENS_ID
        }
    };
};
var setScreenBpAction = function(param) {
    var bp = param.bp;
    return {
        type: SCREEN_SET_BP,
        payload: bp,
        meta: {
            feature: SCREENS_ID
        }
    };
};
var setScreenDeviceAction = function(param) {
    var device = param.device;
    return {
        type: SCREEN_SET_DEVICE,
        payload: device,
        meta: {
            feature: SCREENS_ID
        }
    };
};
//Requests
var handlePageAdd = function(param) {
    var name = param.name, _id = param._id, meta = param.meta;
    return {
        type: PAGE_ADD_NEW,
        payload: {
            name: name,
            _id: _id,
            meta: meta
        },
        meta: {
            feature: SCREENS_ID
        }
    };
};
var setCurrentPage = function(param) {
    var _id = param._id;
    return {
        type: PAGE_SET,
        payload: _id,
        meta: {
            feature: SCREENS_ID
        }
    };
};
var handleScreenAdd = function(param) {
    var breakpoint = param.breakpoint;
    return {
        type: SCREEN_ADD_NEW,
        payload: breakpoint,
        meta: {
            feature: SCREENS_ID
        }
    };
};
var handleScreenRemove = function(param) {
    var _id = param._id;
    return {
        type: SCREEN_REMOVE,
        payload: _id,
        meta: {
            feature: SCREENS_ID
        }
    };
};
//handle screen changes
var updateScreenMeta = function(param) {
    var screen = param.screen, __id = param._id, _id = __id === void 0 ? null : __id;
    return {
        type: SCREENS_UPDATE_META,
        payload: _id ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, screen), {
            _id: _id
        }) : screen,
        meta: {
            feature: SCREENS_ID
        }
    };
};
var initNewScreen = function(param) {
    var screen = param.screen, __id = param._id, _id = __id === void 0 ? null : __id;
    return {
        type: SCREEN_INIT_NEW,
        payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, screen), {
            _id: _id
        }),
        meta: {
            feature: SCREENS_ID
        }
    };
};
var updateSeoAction = function(param) {
    var seo = param.seo, __id = param._id, _id = __id === void 0 ? null : __id;
    return {
        type: PAGE_UPDATE_SEO,
        payload: {
            seo: seo,
            _id: _id
        },
        meta: {
            feature: SCREENS_ID
        }
    };
};
//Controls
var setScreensScale = function(param) {
    var scale = param.scale;
    return {
        type: SCREENS_SET_SCALE,
        payload: scale,
        meta: {
            feature: SCREENS_ID
        }
    };
};
var updateScreensScale = function(param) {
    var scale = param.scale, _type = param.type, type = _type === void 0 ? "+" : _type;
    var newScale = type === "+" ? (scale * 10 + 0.1 * 10) / 10 : (scale * 10 - 0.1 * 10) / 10;
    return {
        type: SCREENS_SET_SCALE,
        payload: newScale,
        meta: {
            feature: SCREENS_ID,
            oldScale: scale,
            type: type
        }
    };
};
var reorderScreens = function() {
    return {
        type: SCREENS_REORDER,
        meta: {
            feature: SCREENS_ID
        }
    };
};
var resetOffsetsScreens = function() {
    return {
        type: SCREENS_RESET_OFFSETS,
        meta: {
            feature: SCREENS_ID
        }
    };
};
//Automatic middleware
var initializeScreens = function() {
    return {
        type: SCREENS_INIT,
        meta: {
            feature: SCREENS_ID
        }
    };
};
var initScreen = function(param) {
    var screen = param.screen, bp = param.bp;
    return {
        type: "".concat(SCREEN_INIT, " ").concat(bp),
        payload: screen,
        meta: {
            feature: SCREENS_ID
        }
    };
};


/***/ }),

/***/ 45260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DW": function() { return /* binding */ baseScreenScale; },
/* harmony export */   "K": function() { return /* binding */ currentPageName; },
/* harmony export */   "MS": function() { return /* binding */ screensOffset; },
/* harmony export */   "OD": function() { return /* binding */ getTotalScreensWidth; },
/* harmony export */   "U4": function() { return /* binding */ pagesSelector; },
/* harmony export */   "Xr": function() { return /* binding */ currentBpSelector; },
/* harmony export */   "lo": function() { return /* binding */ currentPage; },
/* harmony export */   "n7": function() { return /* binding */ getScreensSelector; },
/* harmony export */   "tL": function() { return /* binding */ smallestDefaultWidth; },
/* harmony export */   "vk": function() { return /* binding */ currentDeviceSelector; },
/* harmony export */   "yZ": function() { return /* binding */ getNonPreviewedScreensSelector; }
/* harmony export */ });
/* unused harmony export getScreensScale */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _redux_breakpoints_reducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95746);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5994);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21398);








var Action = _action__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP;
var screens = [
    {
        name: "Base",
        _id: null,
        type: "screen",
        breakPoint: "xl",
        scale: 0.9,
        size: {
            minWidth: 0,
            width: 0,
            maxWidth: 0
        },
        position: {
            x: 0,
            y: 0
        }
    },
    {
        name: "Mobile",
        _id: null,
        type: "screen",
        breakPoint: "xs",
        scale: 1.2,
        size: {
            minWidth: 0,
            width: 0,
            maxWidth: 0
        },
        position: {
            x: 0,
            y: 0
        }
    }
];
var screensOffset = 50;
var smallestDefaultWidth = 300;
var baseScreenScale = 1;
var initialState = {
    isDragging: false,
    scale: 1,
    currentBp: "xl",
    currentDevice: {
        type: "desktop",
        device: "Desktop"
    },
    current: "root",
    pages: {
        root: {
            name: "root",
            screens: screens
        },
        artboards: {
            name: "artboards",
            type: "artboard",
            screens: null
        }
    }
};
var screensReducer = function() {
    var screens = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* .produce */ .Uy)(screens, function(draft) {
        var payloadScreen = action.payload;
        var currentPage = draft.current;
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, screens, action.payload);
            case Action.SCREENS_SET_SCALE:
                draft.scale = action.payload;
                return draft;
            case Action.SCREEN_SET_BP:
                draft.currentBp = action.payload;
                return draft;
            case Action.SCREEN_SET_DEVICE:
                draft.currentDevice = action.payload;
                return draft;
            case Action.PAGE_UPDATE_SEO:
                draft.pages[currentPage].seo = action.payload.seo;
                return draft;
            case Action.SCREENS_UPDATE_META:
                draft.pages[currentPage].screens = draft.pages[currentPage].screens.map(function(screen) {
                    if (!screensAreEqual(screen, payloadScreen)) return screen;
                    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, screen, payloadScreen);
                });
                return draft;
            case Action.SCREEN_INIT_NEW:
                draft.pages[currentPage].screens.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, action.payload), {
                    new: undefined
                }));
                return draft;
            case Action.PAGE_SET:
                draft.current = action.payload;
                return draft;
            case Action.PAGE_ADD_NEW:
                var ref, ref1;
                draft.pages = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, draft.pages), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (ref = action.payload) === null || ref === void 0 ? void 0 : ref._id, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : (ref1 = draft.pages) === null || ref1 === void 0 ? void 0 : ref1.root), {
                    name: action.payload.name
                })));
                return draft;
            case Action.SCREEN_REMOVE:
                draft.pages[currentPage].screens = draft.pages[currentPage].screens.filter(function(screen) {
                    return screen._id != action.payload;
                });
                return draft;
            case Action.SCREENS_REORDER:
                draft.pages[currentPage].screens = draft.pages[currentPage].screens.slice().sort(compareWidths).reverse();
                return draft;
            default:
                return screens;
        }
        ; //switch
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (screensReducer);
/**
 * Sort screens by min width
 * @param {bp} a 
 * @param {bp} b 
 * @returns {sorted array}
 */ function compareWidths(a, b) {
    if (a.size.minWidth < b.size.minWidth) return -1;
    if (a.size.minWidth > b.size.minWidth) return 1;
    return 0;
}
//_id's are equal or _id is unset and bp is same.
var screensAreEqual = function(screen, payloadScreen) {
    return (screen === null || screen === void 0 ? void 0 : screen._id) === (payloadScreen === null || payloadScreen === void 0 ? void 0 : payloadScreen._id) || !(screen === null || screen === void 0 ? void 0 : screen._id) && screen.breakPoint === payloadScreen.breakPoint;
};
//Select current redux feature
var screensFeature = function(state) {
    return state.present.screens;
};
var currentBpSelector = function(state) {
    var ref;
    return (ref = screensFeature(state)) === null || ref === void 0 ? void 0 : ref.currentBp;
};
var currentDeviceSelector = function(state) {
    var ref;
    return (ref = screensFeature(state)) === null || ref === void 0 ? void 0 : ref.currentDevice;
};
//Select all pages
var pagesSelector = function(state) {
    return screensFeature(state).pages;
};
var currentPageName = function(state) {
    return screensFeature(state).current;
};
var currentPage = function(state) {
    return pagesSelector(state)[currentPageName(state)];
};
//Get screens
var getScreensSelector = function(state) {
    var ref, ref1;
    return ((ref = currentPage(state)) === null || ref === void 0 ? void 0 : ref.screens) ? (ref1 = currentPage(state)) === null || ref1 === void 0 ? void 0 : ref1.screens : pagesSelector(state).root.screens;
}; // fallback
// export const getScreenSelector = (state, bp) => 
//     getScreensSelector(state)?.filter(screen?.breakPoint === bp)[0];
var getNonPreviewedScreensSelector = (0,reselect__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(_redux_breakpoints_reducer__WEBPACK_IMPORTED_MODULE_7__/* .getBreakpointsSelector */ .Pg, getScreensSelector, function(breakpoints, screens) {
    return breakpoints.filter(function(bp) {
        if (screens.some(function(screen) {
            return (screen === null || screen === void 0 ? void 0 : screen.breakPoint) === (bp === null || bp === void 0 ? void 0 : bp._id);
        })) return;
        return bp;
    });
});
//Screens scale
var getScreensScale = function(state) {
    return screensFeature(state).scale;
};
var getTotalScreensWidth = (0,reselect__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(getScreensSelector, function(screens) {
    return screens.reduce(function(total, screen) {
        return total + screen.size.width + screensOffset;
    }, 0) - screensOffset // subtract last offset
    ;
});


/***/ }),

/***/ 55403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jU": function() { return /* binding */ setThemeAction; }
/* harmony export */ });
/* unused harmony export THEME_ID */
var THEME_ID = "[theme]";
var SET = "".concat(THEME_ID, " Set");
var THEME_ACTION_IDS = {
    SET: SET
};
var setThemeAction = function(data) {
    return {
        type: SET,
        payload: data,
        meta: {
            feature: THEME_ID
        }
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = (THEME_ACTION_IDS);


/***/ }),

/***/ 88316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ themeSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _redux_baseSelector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32884);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55403);





var initialState = {};
var themeReducer = function() {
    var theme = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)(theme, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, theme, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_3__/* ["default"].SET */ .ZP.SET:
                return action.payload;
            default:
                return theme;
        }
        ;
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (themeReducer);
var themeSelector = function(state) {
    return (0,_redux_baseSelector__WEBPACK_IMPORTED_MODULE_4__/* .featureSelector */ .g)(state, "theme");
}; // export const metricColorsSelector = state => presentSelector(state).colors?.filter(t => t.type === 'metric')


/***/ }),

/***/ 24385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F1": function() { return /* binding */ DELETE_DESIGN_TOKEN; },
/* harmony export */   "RA": function() { return /* binding */ SET_DESIGN_TOKEN; },
/* harmony export */   "Y0": function() { return /* binding */ UPDATE_DESIGN_TOKEN; },
/* harmony export */   "gz": function() { return /* binding */ setDesignToken; },
/* harmony export */   "pk": function() { return /* binding */ CREATE_DESIGN_TOKEN; }
/* harmony export */ });
/* unused harmony exports TOKEN_ID, createDesignToken, deleteDesignToken, updateDesignToken, updateDesignMetricToken */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96670);



var TOKEN_ID = "[tokens]";
var CREATE_DESIGN_TOKEN = "".concat(TOKEN_ID, " Create");
var SET_DESIGN_TOKEN = "".concat(TOKEN_ID, " Set");
var UPDATE_DESIGN_TOKEN = "".concat(TOKEN_ID, " Update");
var DELETE_DESIGN_TOKEN = "".concat(TOKEN_ID, " Delete");
var createDesignToken = function(param) {
    var label = param.label, value = param.value, endValue = param.endValue, _type = param.type, type = _type === void 0 ? "metric" : _type;
    return {
        type: CREATE_DESIGN_TOKEN,
        payload: {
            label: label,
            value: value,
            endValue: endValue,
            type: type
        },
        meta: {
            feature: TOKEN_ID
        }
    };
};
var setDesignToken = function(param) {
    var token = param.token, _id = param._id, _meta = param.meta, meta = _meta === void 0 ? null : _meta;
    return {
        type: SET_DESIGN_TOKEN,
        payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, token), {
            _id: _id
        }),
        meta: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            feature: TOKEN_ID
        }, meta)
    };
};
var deleteDesignToken = function(param) {
    var _id = param._id;
    return {
        type: DELETE_DESIGN_TOKEN,
        payload: _id,
        meta: {
            feature: TOKEN_ID
        }
    };
};
var updateDesignToken = function(token) {
    return {
        type: UPDATE_DESIGN_TOKEN,
        payload: token,
        meta: {
            feature: TOKEN_ID
        }
    };
};
var updateDesignMetricToken = function(token, label, metric) {
    return {
        type: UPDATE_DESIGN_TOKEN,
        payload: _object_spread_props(_object_spread({}, token), {
            label: label,
            value: metric.value,
            endValue: metric.metric,
            selector: toVarCase(label)
        }),
        meta: {
            feature: TOKEN_ID,
            dispatched: "updateDesignMetricToken"
        }
    };
};


/***/ }),

/***/ 80364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IV": function() { return /* binding */ tokensSelector; },
/* harmony export */   "bK": function() { return /* binding */ metricTokensSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76665);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24385);





var initialState = [];
var tokensReducer = function() {
    var tokens = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)(tokens, function(draft) {
        switch(action.type){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, tokens, action.payload);
            case _action__WEBPACK_IMPORTED_MODULE_3__/* .SET_DESIGN_TOKEN */ .RA:
                draft = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(draft).concat([
                    action.payload
                ]);
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* .DELETE_DESIGN_TOKEN */ .F1:
                draft = draft.filter(function(token) {
                    return token._id != action.payload;
                });
                return draft;
            case _action__WEBPACK_IMPORTED_MODULE_3__/* .UPDATE_DESIGN_TOKEN */ .Y0:
                var previous = draft.filter(function(token) {
                    return token._id === action.payload._id;
                });
                var filtered = draft.filter(function(token) {
                    return token._id != action.payload._id;
                });
                draft = [
                    (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, previous, action.payload)
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(filtered));
                return draft;
            default:
                return tokens;
        }
        ;
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (tokensReducer);
var presentSelector = function(state) {
    return state.present;
};
var tokensSelector = function(state) {
    return presentSelector(state).tokens;
};
var metricTokensSelector = function(state) {
    var ref;
    return (ref = presentSelector(state).tokens) === null || ref === void 0 ? void 0 : ref.filter(function(t) {
        return t.type === "metric";
    });
};


/***/ }),

/***/ 94860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EW": function() { return /* binding */ TYPE_ACTION_IDS; },
/* harmony export */   "GY": function() { return /* binding */ updateFontAction; },
/* harmony export */   "HF": function() { return /* binding */ regenerateFontSizesAction; },
/* harmony export */   "Np": function() { return /* binding */ deleteFontSourceAction; },
/* harmony export */   "P6": function() { return /* binding */ setTypesAction; },
/* harmony export */   "TK": function() { return /* binding */ resetTypesAction; },
/* harmony export */   "em": function() { return /* binding */ toggleFontFieldAction; },
/* harmony export */   "nz": function() { return /* binding */ setFontValue; },
/* harmony export */   "uf": function() { return /* binding */ addFontSourceAction; },
/* harmony export */   "vf": function() { return /* binding */ setFontsAction; }
/* harmony export */ });
/* unused harmony exports TYPE_ID, SET_VALUE, ADD_SOURCE, REMOVE_SOURCE, REGEN_SIZES, SET_FONTS, TOGGLE_FIELD, SET_FIELD, UPDATE_FONT, SET_CHANGE, RESET_TO_BASE, SET_TYPES, setFontFieldAction, setFontChangeAction */
var TYPE_ID = "[types]";
var SET_VALUE = "".concat(TYPE_ID, " Set value");
var ADD_SOURCE = "".concat(TYPE_ID, " Add source");
var REMOVE_SOURCE = "".concat(TYPE_ID, " Remove source");
var REGEN_SIZES = "".concat(TYPE_ID, " Regen sizes");
var SET_FONTS = "".concat(TYPE_ID, " Set fonts");
var TOGGLE_FIELD = "".concat(TYPE_ID, " Toggle field");
var SET_FIELD = "".concat(TYPE_ID, " Set field");
var UPDATE_FONT = "".concat(TYPE_ID, " Update font");
var SET_CHANGE = "".concat(TYPE_ID, " Set change");
var RESET_TO_BASE = "".concat(TYPE_ID, " Reset base");
var SET_TYPES = "".concat(TYPE_ID, " Set types");
var TYPE_ACTION_IDS = {
    SET_VALUE: SET_VALUE,
    ADD_SOURCE: ADD_SOURCE,
    REMOVE_SOURCE: REMOVE_SOURCE,
    REGEN_SIZES: REGEN_SIZES,
    SET_FONTS: SET_FONTS,
    TOGGLE_FIELD: TOGGLE_FIELD,
    SET_FIELD: SET_FIELD,
    SET_CHANGE: SET_CHANGE,
    UPDATE_FONT: UPDATE_FONT,
    RESET_TO_BASE: RESET_TO_BASE,
    SET_TYPES: SET_TYPES
};
var setTypesAction = function(data) {
    return {
        type: SET_TYPES,
        payload: data,
        meta: {
            feature: TYPE_ID
        }
    };
};
var setFontValue = function(param) {
    var field = param.field, value = param.value;
    return {
        type: SET_VALUE,
        payload: {
            field: field,
            value: value
        },
        meta: {
            feature: TYPE_ID
        }
    };
};
var resetTypesAction = function() {
    return {
        type: RESET_TO_BASE,
        meta: {
            feature: TYPE_ID
        }
    };
};
var addFontSourceAction = function(param) {
    var family = param.family, weight = param.weight, style = param.style, src = param.src;
    return {
        type: ADD_SOURCE,
        payload: {
            family: family,
            weight: weight,
            style: style,
            src: src
        },
        meta: {
            feature: TYPE_ID
        }
    };
};
var deleteFontSourceAction = function(param) {
    var src = param.src;
    return {
        type: REMOVE_SOURCE,
        payload: {
            src: src
        },
        meta: {
            feature: TYPE_ID
        }
    };
};
var regenerateFontSizesAction = function() {
    return {
        type: REGEN_SIZES,
        meta: {
            feature: TYPE_ID
        }
    };
};
var setFontsAction = function(param) {
    var fonts = param.fonts;
    return {
        type: SET_FONTS,
        payload: fonts,
        meta: {
            feature: TYPE_ID
        }
    };
};
var updateFontAction = function(param) {
    var font = param.font;
    return {
        type: UPDATE_FONT,
        payload: font,
        meta: {
            feature: TYPE_ID
        }
    };
};
var toggleFontFieldAction = function(param) {
    var field = param.field, current = param.current;
    return {
        type: TOGGLE_FIELD,
        payload: {
            field: field,
            current: current
        },
        meta: {
            feature: TYPE_ID
        }
    };
};
var setFontFieldAction = function(param) {
    var field = param.field, current = param.current, value = param.value;
    return {
        type: SET_FIELD,
        payload: {
            field: field,
            current: current,
            value: value
        },
        meta: {
            feature: TYPE_ID
        }
    };
};
var setFontChangeAction = function(param) {
    var font = param.font, currentItem = param.currentItem, _addSource = param.addSource, addSource = _addSource === void 0 ? true : _addSource, _fontType = param.fontType, fontType = _fontType === void 0 ? "regular" : _fontType;
    return {
        type: SET_CHANGE,
        payload: {
            font: font,
            currentItem: currentItem,
            addSource: addSource,
            fontType: fontType
        },
        meta: {
            feature: TYPE_ID
        }
    };
};


/***/ }),

/***/ 96117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VA": function() { return /* binding */ baseFontSizeSelector; },
  "ZP": function() { return /* binding */ reducer; },
  "Fm": function() { return /* binding */ fontScaleSelector; },
  "mX": function() { return /* binding */ fontSourcesSelector; },
  "Ai": function() { return /* binding */ fontsSelector; },
  "UP": function() { return /* binding */ typesSelector; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./src/mosanic/constants/typhography.js

var FONT_SCALES = [
    {
        value: 1.067,
        label: "1.067 - Minor Second"
    },
    {
        value: 1.125,
        label: "1.125 - Major Second"
    },
    {
        value: 1.200,
        label: "1.200 - Minor Third"
    },
    {
        value: 1.250,
        label: "1.250 - Major Third"
    },
    {
        value: 1.333,
        label: "1.333 - Perfect Fourth"
    },
    {
        value: 1.414,
        label: "1.414 - Super Fourth"
    },
    {
        value: 1.500,
        label: "1.500 - Perfect Fifth"
    },
    {
        value: 1.618,
        label: "1.618 - Golden Ratio"
    }, 
];
var _obj;
var DEFAULT_FONTS = [
    {
        //     type: 'title',
        //     heading: true,
        //     text: false,
        //     label: 'Title',
        //     font: 'Open Sans',
        //     scale: 6.5,
        //     size: '16',
        //     metric: 'px',
        //     color: 'shades',
        //     shade: '40',
        //     bold: false,
        //     weight: null,
        //     italic: false,
        //     underline: false,
        //     class:'title',
        //     lorem: 'For super clients.'
        // },{
        type: "h1",
        heading: true,
        label: "Heading 1",
        font: "Open Sans",
        scale: 5,
        size: "16",
        metric: "px",
        lorem: "For power clients."
    },
    {
        type: "h2",
        heading: true,
        label: "Heading 2",
        font: "Open Sans",
        scale: 4,
        size: "16",
        metric: "px",
        lorem: "For more power clients."
    },
    {
        type: "h3",
        heading: true,
        label: "Heading 3",
        font: "Open Sans",
        scale: 3,
        size: "16",
        metric: "px",
        lorem: "For more power clients."
    },
    {
        type: "h4",
        heading: true,
        label: "Heading 4",
        font: "Open Sans",
        scale: 2,
        size: "16",
        metric: "px",
        lorem: "For more power clients."
    },
    {
        type: "h5",
        heading: true,
        label: "Heading 5",
        font: "Open Sans",
        scale: 1,
        size: "16",
        metric: "px",
        lorem: "For more power clients."
    },
    {
        type: "h6",
        heading: true,
        label: "Heading 6",
        font: "Open Sans",
        scale: 0,
        size: "16",
        metric: "px",
        lorem: "For more power clients."
    },
    (_obj = {
        type: "p",
        text: true,
        label: "Paragraph",
        font: "Open Sans",
        size: "16",
        metric: "px"
    }, (0,_define_property/* default */.Z)(_obj, "text", "Paragraph"), (0,_define_property/* default */.Z)(_obj, "lorem", "Lorem ipsum dolar samit dola."), _obj),
    {
        type: "p",
        text: true,
        label: "Small paragraph",
        font: "Open Sans",
        scale: -1,
        size: "16",
        metric: "px",
        class: "small",
        lorem: "Lorem ipsum dolar samit dola."
    },
    {
        //     type: 'span',
        //     text: true,
        //     heading: false,
        //     label: 'Span tag',
        //     font: 'Open Sans',
        //     scale: 0,
        //     size: '16',
        //     metric: 'px',
        //     color: 'shades',
        //     shade: '40',
        //     bold: false,
        //     weight: null,
        //     italic: false,
        //     underline: false,
        //     lorem: 'Span',
        // },{
        type: "b",
        text: true,
        label: "Bold tag",
        font: "Open Sans",
        scale: 0,
        size: "16",
        metric: "px",
        bold: true,
        lorem: "Bold"
    },
    {
        type: "i",
        text: true,
        label: "Italic tag",
        font: "Open Sans",
        scale: 0,
        size: "16",
        metric: "px",
        italic: true,
        lorem: "Italic"
    },
    {
        type: "u",
        text: true,
        label: "Underline tag",
        font: "Open Sans",
        scale: 0,
        size: "16",
        metric: "px",
        underline: true,
        lorem: "Underline"
    },
    {
        type: "button",
        text: true,
        label: "Button",
        font: "Open Sans",
        scale: -1,
        size: "16",
        metric: "px",
        lorem: "Button text"
    },
    {
        type: "a",
        text: true,
        label: "Link tag",
        font: "Open Sans",
        scale: 0,
        size: "16",
        metric: "px",
        lorem: "Link"
    }
];

// EXTERNAL MODULE: ./src/features/baseSelector.js
var baseSelector = __webpack_require__(32884);
// EXTERNAL MODULE: ../../node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(76665);
// EXTERNAL MODULE: ../../node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(59775);
// EXTERNAL MODULE: ./src/features/typography/action.js
var typography_action = __webpack_require__(94860);
;// CONCATENATED MODULE: ./src/features/typography/reducer.js









var initialState = {
    fonts: DEFAULT_FONTS,
    sources: [],
    fontScale: 1.250,
    baseSize: 16
};
var typesReducer = function() {
    var types = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer_esm/* produce */.Uy)(types, function(draft) {
        var pl = action.payload;
        switch(action.type){
            case es6/* HYDRATE */.ju:
                return (0,_object_spread/* default */.Z)({}, types, action.payload);
            case typography_action/* TYPE_ACTION_IDS.SET_TYPES */.EW.SET_TYPES:
                return (0,_object_spread/* default */.Z)({}, types, action.payload);
            case typography_action/* TYPE_ACTION_IDS.RESET_TO_BASE */.EW.RESET_TO_BASE:
                return initialState;
            case typography_action/* TYPE_ACTION_IDS.ADD_SOURCE */.EW.ADD_SOURCE:
                var ref, ref1;
                if (((ref1 = draft === null || draft === void 0 ? void 0 : (ref = draft.sources) === null || ref === void 0 ? void 0 : ref.filter(function(s) {
                    return (s === null || s === void 0 ? void 0 : s.src) === (pl === null || pl === void 0 ? void 0 : pl.src);
                })) === null || ref1 === void 0 ? void 0 : ref1.length) >= 1) return draft;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft), {
                    sources: (0,_to_consumable_array/* default */.Z)(draft === null || draft === void 0 ? void 0 : draft.sources).concat([
                        action.payload
                    ])
                });
            case typography_action/* TYPE_ACTION_IDS.REMOVE_SOURCE */.EW.REMOVE_SOURCE:
                var ref2;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft), {
                    sources: draft === null || draft === void 0 ? void 0 : (ref2 = draft.sources) === null || ref2 === void 0 ? void 0 : ref2.filter(function(s) {
                        return s.src != pl.src;
                    })
                });
            case typography_action/* TYPE_ACTION_IDS.SET_FONTS */.EW.SET_FONTS:
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft), {
                    fonts: action.payload
                });
            case typography_action/* TYPE_ACTION_IDS.UPDATE_FONT */.EW.UPDATE_FONT:
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft), {
                    fonts: draft.fonts.map(function(f) {
                        if (f.type != pl.type) return f;
                        return (0,_object_spread/* default */.Z)({}, f, pl);
                    })
                });
            case typography_action/* TYPE_ACTION_IDS.TOGGLE_FIELD */.EW.TOGGLE_FIELD:
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft), {
                    fonts: draft.fonts.map(function(f) {
                        if (f.type != pl.current.type) return f;
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), (0,_define_property/* default */.Z)({}, pl.field, f[pl.field] ? false : true));
                    })
                });
            case typography_action/* TYPE_ACTION_IDS.SET_FIELD */.EW.SET_FIELD:
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft), {
                    fonts: draft.fonts.map(function(f) {
                        if (f.type != pl.current.type) return f;
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), (0,_define_property/* default */.Z)({}, pl.field, pl.value));
                    })
                });
            case typography_action/* TYPE_ACTION_IDS.SET_VALUE */.EW.SET_VALUE:
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft), (0,_define_property/* default */.Z)({}, pl.field, pl.value));
            default:
                return types;
        }
        ;
    });
};
/* harmony default export */ var reducer = (typesReducer);
var typesSelector = function(state) {
    return (0,baseSelector/* featureSelector */.g)(state, "types");
};
var fontSourcesSelector = function(state) {
    var ref;
    return (ref = typesSelector(state)) === null || ref === void 0 ? void 0 : ref.sources;
};
var fontsSelector = function(state) {
    return typesSelector(state).fonts;
};
var fontScaleSelector = function(state) {
    return typesSelector(state).fontScale;
};
var baseFontSizeSelector = function(state) {
    return typesSelector(state).baseSize;
};


/***/ }),

/***/ 19957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$w": function() { return /* binding */ hideSpinnerById; },
/* harmony export */   "AM": function() { return /* binding */ UI_ID; },
/* harmony export */   "Ki": function() { return /* binding */ END_ZOOM_PINCH; },
/* harmony export */   "Mk": function() { return /* binding */ START_DRAGGING; },
/* harmony export */   "Ty": function() { return /* binding */ START_ZOOM_PINCH; },
/* harmony export */   "UO": function() { return /* binding */ openInspectorPanel; },
/* harmony export */   "V": function() { return /* binding */ ENABLE_ZOOM_PINCH; },
/* harmony export */   "VQ": function() { return /* binding */ CLOSE_PANEL; },
/* harmony export */   "__": function() { return /* binding */ HIDE_SPINNER; },
/* harmony export */   "c3": function() { return /* binding */ setThemeModeAction; },
/* harmony export */   "dv": function() { return /* binding */ orderComplete; },
/* harmony export */   "jE": function() { return /* binding */ SET_THEME_MODE; },
/* harmony export */   "kW": function() { return /* binding */ SHOW_SPINNER; },
/* harmony export */   "mt": function() { return /* binding */ ORDER_COMPLETE; },
/* harmony export */   "no": function() { return /* binding */ OPEN_PANEL; },
/* harmony export */   "q6": function() { return /* binding */ setDragging; },
/* harmony export */   "s9": function() { return /* binding */ END_DRAGGING; },
/* harmony export */   "sC": function() { return /* binding */ TIMING_STOP_SPINNER; },
/* harmony export */   "sh": function() { return /* binding */ toggleInspectorPanel; },
/* harmony export */   "ue": function() { return /* binding */ SPINNER_ID; },
/* harmony export */   "v3": function() { return /* binding */ hideSpinner; },
/* harmony export */   "yh": function() { return /* binding */ showSpinner; },
/* harmony export */   "zQ": function() { return /* binding */ ORDER_IN_PROGRESS; }
/* harmony export */ });
/* unused harmony exports SPINNER_TARGETS, SET_PANEL, OPEN_INSPECT_PANEL, CLOSE_INSPECT_PANEL, OPEN_LEFT_PANEL, CLOSE_LEFT_PANEL, SET_LEFT_PANEL, SECONDS, closeInspectorPanel, orderInProgress, startDragging, endDragging, toggleDragging, enableZoomPinch, startZoomPinch, endZoomPinch */
var UI_ID = "[UI]";
var SHOW_SPINNER = "".concat(UI_ID, " show spinner");
var HIDE_SPINNER = "".concat(UI_ID, " hide spinner");
/**
 * Target locations
 */ var SPINNER_TARGETS = {
    GLOBAL: "global",
    CANVAS: "canvas",
    INSPECT: "inspect panel",
    SIDEBAR: "sidebar",
    PANEL: "panel",
    MODAL: "modal",
    DASHBOARD: "dashboard",
    EDITOR: "editor",
    LIBRARY: "library"
};
var SPINNER_ID = "_id";
var SET_THEME_MODE = "".concat(UI_ID, " Theme mode");
var ORDER_IN_PROGRESS = "".concat(UI_ID, " Order in progress");
var ORDER_COMPLETE = "".concat(UI_ID, " Order complete");
var OPEN_PANEL = "Open panel";
var CLOSE_PANEL = "Close panel";
var SET_PANEL = "Set panel";
var OPEN_INSPECT_PANEL = "".concat(UI_ID, " ").concat(OPEN_PANEL, " inspect");
var CLOSE_INSPECT_PANEL = "".concat(UI_ID, " ").concat(CLOSE_PANEL, " inspect");
var OPEN_LEFT_PANEL = "".concat(UI_ID, " ").concat(OPEN_PANEL, " left");
var CLOSE_LEFT_PANEL = "".concat(UI_ID, " ").concat(CLOSE_PANEL, " left");
var SET_LEFT_PANEL = "".concat(UI_ID, " ").concat(SET_PANEL, " left");
var START_DRAGGING = "".concat(UI_ID, " start dragging");
var END_DRAGGING = "".concat(UI_ID, " end dragging");
var ENABLE_ZOOM_PINCH = "".concat(UI_ID, " enable zoom pinch");
var START_ZOOM_PINCH = "".concat(UI_ID, " start zoom pinch");
var END_ZOOM_PINCH = "".concat(UI_ID, " end zoom pinch");
var SECONDS = 1000; //ms
var TIMING_STOP_SPINNER = 10 * SECONDS;
var showSpinner = function(param) {
    var location = param.location, feature = param.feature;
    if (!location) alert("no lcoation");
    if (!location) location = feature;
    return {
        type: "".concat(feature, " ").concat(SHOW_SPINNER),
        payload: location,
        meta: {
            feature: feature
        }
    };
};
var hideSpinner = function(param) {
    var location = param.location, feature = param.feature;
    return {
        type: "".concat(feature, " ").concat(HIDE_SPINNER),
        payload: location,
        meta: {
            feature: feature,
            attribute: "location"
        }
    };
};
var hideSpinnerById = function(param) {
    var spinnerId = param.spinnerId, feature = param.feature;
    return {
        type: "".concat(feature, " ").concat(HIDE_SPINNER),
        payload: spinnerId,
        meta: {
            feature: feature
        }
    };
};
var toggleInspectorPanel = function(isOpen) {
    return {
        type: isOpen ? CLOSE_INSPECT_PANEL : OPEN_INSPECT_PANEL,
        payload: "inspect",
        meta: {
            feature: UI_ID,
            mode: "toggle"
        }
    };
};
var openInspectorPanel = function() {
    return {
        type: OPEN_INSPECT_PANEL,
        payload: "inspect",
        meta: {
            feature: UI_ID
        }
    };
};
var closeInspectorPanel = function() {
    return {
        type: CLOSE_INSPECT_PANEL,
        payload: "inspect",
        meta: {
            feature: UI_ID
        }
    };
};
var setThemeModeAction = function(mode) {
    return {
        type: SET_THEME_MODE,
        payload: mode
    };
};
var orderInProgress = function() {
    return {
        type: ORDER_IN_PROGRESS
    };
};
var orderComplete = function() {
    return {
        type: ORDER_COMPLETE
    };
};
var startDragging = function() {
    return {
        type: START_DRAGGING
    };
};
var endDragging = function() {
    return {
        type: END_DRAGGING
    };
};
var toggleDragging = function(isDragging) {
    return {
        type: isDragging ? END_DRAGGING : START_DRAGGING
    };
};
var setDragging = function(isDragging) {
    return {
        type: isDragging ? START_DRAGGING : END_DRAGGING
    };
};
var enableZoomPinch = function() {
    var from = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return {
        type: ENABLE_ZOOM_PINCH,
        payload: from
    };
};
var startZoomPinch = function() {
    return {
        type: START_ZOOM_PINCH
    };
};
var endZoomPinch = function() {
    return {
        type: END_ZOOM_PINCH
    };
};


/***/ }),

/***/ 39336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eq": function() { return /* binding */ themeModeSelector; },
/* harmony export */   "w0": function() { return /* binding */ isDraggingSelector; },
/* harmony export */   "xW": function() { return /* binding */ isInspectorOpen; },
/* harmony export */   "zh": function() { return /* binding */ isActive; }
/* harmony export */ });
/* unused harmony exports isZoomPinchSelector, zoomPinchEnabledSelector */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _uiAction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19957);
/* harmony import */ var next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59775);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76665);





var initialUi = {
    pending: false,
    orderInProcess: false,
    spinners: [],
    isDragging: false,
    isZoomPinch: false,
    canZoomPinch: false,
    panels: {
        left: false,
        inspect: false
    },
    theme: "light"
};
var uiReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialUi, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(state, function(draft) {
        switch(true){
            case next_redux_wrapper__WEBPACK_IMPORTED_MODULE_0__/* .HYDRATE */ .ju:
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state, action.payload);
            case action.type === _uiAction__WEBPACK_IMPORTED_MODULE_3__/* .SET_THEME_MODE */ .jE:
                draft.theme = action.payload;
                break;
            case action.type.includes(_uiAction__WEBPACK_IMPORTED_MODULE_3__/* .SHOW_SPINNER */ .kW):
                draft.spinners.push(action.payload);
                break;
            case action.type.includes(_uiAction__WEBPACK_IMPORTED_MODULE_3__/* .HIDE_SPINNER */ .__):
                var ref, ref1;
                var attribute = (action === null || action === void 0 ? void 0 : (ref = action.meta) === null || ref === void 0 ? void 0 : ref.attribute) ? action.meta.attribute : _uiAction__WEBPACK_IMPORTED_MODULE_3__/* .SPINNER_ID */ .ue;
                draft.spinners = (ref1 = draft.spinners) === null || ref1 === void 0 ? void 0 : ref1.filter(function(spinner) {
                    return spinner[attribute] !== action.payload;
                });
                break;
            // return {...state, pending: false};
            case action.type.includes(_uiAction__WEBPACK_IMPORTED_MODULE_3__/* .OPEN_PANEL */ .no):
                if (draft.panels[action.payload] != undefined) draft.panels[action.payload] = true;
                break;
            case action.type.includes(_uiAction__WEBPACK_IMPORTED_MODULE_3__/* .CLOSE_PANEL */ .VQ):
                if (draft.panels[action.payload] != undefined) draft.panels[action.payload] = false;
                break;
            case action.type.includes(_uiAction__WEBPACK_IMPORTED_MODULE_3__/* .ORDER_IN_PROGRESS */ .zQ):
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    orderInProcess: true
                });
            case action.type.includes(_uiAction__WEBPACK_IMPORTED_MODULE_3__/* .ORDER_COMPLETE */ .mt):
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    orderInProcess: false
                });
            case action.type === _uiAction__WEBPACK_IMPORTED_MODULE_3__/* .START_DRAGGING */ .Mk:
                draft.isDragging = true;
                break;
            case action.type === _uiAction__WEBPACK_IMPORTED_MODULE_3__/* .END_DRAGGING */ .s9:
                draft.isDragging = false;
                break;
            case action.type === _uiAction__WEBPACK_IMPORTED_MODULE_3__/* .START_ZOOM_PINCH */ .Ty:
                draft.isZoomPinch = true;
                break;
            case action.type === _uiAction__WEBPACK_IMPORTED_MODULE_3__/* .END_ZOOM_PINCH */ .Ki:
                draft.isZoomPinch = false;
                draft.canZoomPinch = false;
                break;
            case action.type === _uiAction__WEBPACK_IMPORTED_MODULE_3__/* .ENABLE_ZOOM_PINCH */ .V:
                draft.canZoomPinch = true;
                break;
            default:
                return state;
        }
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (uiReducer);
var presentUI = function(state) {
    return state.present.ui;
};
var isActive = function(state, location) {
    var ref, ref1;
    return ((ref1 = (ref = presentUI(state).spinners) === null || ref === void 0 ? void 0 : ref.filter(function(s) {
        return s.location === location;
    })) === null || ref1 === void 0 ? void 0 : ref1.length) >= 1;
};
var isInspectorOpen = function(state) {
    return presentUI(state).panels.inspect;
};
var isDraggingSelector = function(state) {
    return presentUI(state).isDragging;
};
var isZoomPinchSelector = function(state) {
    return presentUI(state).isZoomPinch;
};
var zoomPinchEnabledSelector = function(state) {
    return presentUI(state).canZoomPinch;
};
var themeModeSelector = function(state) {
    return presentUI(state).theme;
};


/***/ }),

/***/ 94889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S5": function() { return /* binding */ UPDATE_ID; },
  "Wh": function() { return /* binding */ updateCurrentField; },
  "Bk": function() { return /* binding */ updateCurrentMetrics; },
  "Fo": function() { return /* binding */ updateIds; },
  "Mx": function() { return /* binding */ updateItemField; },
  "VZ": function() { return /* binding */ updateItemMetrics; }
});

// UNUSED EXPORTS: updateCurrentFields, updateCurrentMetric, updateCurrentToken, updateItemFields, updateItemMetric

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
;// CONCATENATED MODULE: ./src/features/update/action.enums.ts
var UpdateAction;
(function(UpdateAction) {
    UpdateAction["UPDATE"] = "update";
    UpdateAction["PUSH"] = "push";
    UpdateAction["POP"] = "pop";
    UpdateAction["REMOVE"] = "remove";
    UpdateAction["TOGGLE"] = "toggle";
    UpdateAction["SET"] = "set";
})(UpdateAction || (UpdateAction = {}));
var UpdateItem;
(function(UpdateItem) {
    UpdateItem["CURRENT"] = "current";
    UpdateItem["ITEM_PATHS"] = "item paths";
    UpdateItem["ITEM_PATH"] = "item path";
})(UpdateItem || (UpdateItem = {}));
var action_enums_UpdateField;
(function(UpdateField) {
    UpdateField["FIELD"] = "field";
    UpdateField["METRIC"] = "metric";
    UpdateField["METRICS"] = "metrics";
    UpdateField["FIELDS"] = "fields";
})(action_enums_UpdateField || (action_enums_UpdateField = {}));


;// CONCATENATED MODULE: ./src/features/update/action.tsx



var ID = "[update]";
var UPDATE_ID = ID;
var START = "".concat(ID, " >");
var HANDLE = "".concat(ID, " ~");
//Action type
var UPDATE = "update";
var PUSH = "push";
var POP = "pop";
var REMOVE = "remove";
var TOGGLE = "toggle";
var SET = "set";
//Selectors
var FIELD = "field";
var METRIC = "metric";
var METRICS = "metrics";
var FIELDS = "fields";
//Element
var CURRENT = "current";
var ITEM_PATHS = "item paths";
var ITEM_PATH = "item path";
var actionSelector = {
    update: UPDATE,
    push: PUSH,
    pop: POP,
    remove: REMOVE,
    toggle: TOGGLE,
    set: SET,
    start: START,
    handle: HANDLE
};
var fieldSelector = {
    field: FIELD,
    metric: METRIC,
    metrics: METRICS,
    fields: FIELDS
};
var itemSelector = {
    current: CURRENT,
    item: ITEM_PATH,
    items: ITEM_PATHS
};
var updateIds = {
    action: actionSelector,
    field: fieldSelector,
    item: itemSelector
};
// * Current inspect updaters
var updateCurrentField = function(value, from) {
    return updateCurrent({
        field: action_enums_UpdateField.FIELD,
        value: value
    }, from);
};
var updateCurrentFields = function(value, from) {
    return updateCurrent({
        field: UpdateField.FIELDS,
        value: value
    }, from);
};
var updateCurrentMetric = function(value, from) {
    return updateCurrent({
        field: UpdateField.METRIC,
        value: value
    }, from);
};
var updateCurrentMetrics = function(value, from) {
    return updateCurrent({
        field: action_enums_UpdateField.METRICS,
        value: value
    }, from);
};
var updateCurrentToken = function(value, from) {
    return updateCurrent({
        field: UpdateField.METRIC,
        value: value
    }, from);
};
//Current handler
var updateCurrent = function(param, from) {
    var _action = param.action, action = _action === void 0 ? UpdateAction.UPDATE : _action, field = param.field, value = param.value;
    return update({
        action: action,
        item: UpdateItem.CURRENT,
        field: field,
        value: value
    }, from);
};
// * Item update handlers
var updateItemField = function(value, itemPath) {
    return updateItem({
        field: action_enums_UpdateField.FIELD,
        value: value,
        itemPath: itemPath
    });
};
var updateItemFields = function(value, itemPath) {
    return updateItem({
        field: UpdateField.FIELD,
        value: value,
        itemPath: itemPath
    });
};
var updateItemMetric = function(value, itemPath) {
    return updateItem({
        field: UpdateField.METRIC,
        value: value,
        itemPath: itemPath
    });
};
var updateItemMetrics = function(value, itemPath) {
    return updateItem({
        field: action_enums_UpdateField.METRICS,
        value: value,
        itemPath: itemPath
    });
};
//Item handler
var updateItem = function(param) {
    var _action = param.action, action = _action === void 0 ? UpdateAction.UPDATE : _action, field = param.field, value = param.value, itemPath = param.itemPath;
    return update({
        action: action,
        item: UpdateItem.ITEM_PATH,
        field: field,
        value: value,
        other: {
            itemPath: itemPath
        }
    });
};
// * Items update handlers
// todo
//Items handler
// const updateItems = ({
//     action = UpdateAction.UPDATE, 
//     field = UpdateField.FIELD, 
//     value, 
//     itemPaths
// }: updateItemsProps) => ({
//     type: `${ID} ${action} ${ITEM_PATHS} ${field}`,
//     payload: {value, itemPaths},
//     meta: {
//         feature: ID, 
//         item: ITEM_PATHS, 
//         action, 
//         field
//     },
// });
//Combining all handler
var update = function(_param, from) {
    var action = _param.action, item = _param.item, field = _param.field, value = _param.value, other = (0,_object_without_properties/* default */.Z)(_param, [
        "action",
        "item",
        "field",
        "value"
    ]);
    return {
        type: "".concat(START, " ").concat(action, " ").concat(item, " ").concat(field),
        payload: Array.isArray(value) ? value : (0,_object_spread/* default */.Z)({}, value, other),
        meta: {
            feature: ID,
            item: item,
            action: action,
            field: field,
            from: from
        }
    };
};


/***/ }),

/***/ 99927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ feature; }
/* harmony export */ });
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62570);

var feature = function(feature, state) {
    return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_0__/* .hasAttr */ .B$)(state.present, feature) ? state.present[feature] : null;
};


/***/ }),

/***/ 91504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lm": function() { return /* binding */ useNumField; },
/* harmony export */   "hR": function() { return /* binding */ useTextField; }
/* harmony export */ });
/* unused harmony exports RenderTextFields, useTextFields */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68311);









var getVal = function(event) {
    var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref;
    return !((ref = event.target) === null || ref === void 0 ? void 0 : ref.value) ? null : strict === "extreme" ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .getSensitizedString */ .W_)((0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .removeSpaces */ .I8)((0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .toLowCase */ .Cc)(event.target.value))) : strict ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .getSensitizedString */ .W_)(event.target.value) : event.target.value;
};
var RenderTextFields = function(param) {
    var handlers = param.handlers;
    return handlers.map(function(handler, i) {
        return !(handler === null || handler === void 0 ? void 0 : handler.type) ? /*#__PURE__*/ _createElement(TextField, _object_spread_props(_object_spread({}, handler), {
            key: i,
            wrap: true
        })) : (handler === null || handler === void 0 ? void 0 : handler.type) === "text-area" ? /*#__PURE__*/ _createElement(TextArea, _object_spread_props(_object_spread({}, handler), {
            key: i,
            rows: 3,
            fullWidth: true,
            wrap: true
        })) : handler === null || handler === void 0 ? void 0 : handler.label;
    });
};
function useTextFields(param) {
    var _fields = param.fields, fields = _fields === void 0 ? [] : _fields, _initData = param.initData, initData = _initData === void 0 ? {} : _initData, _size = param.size, size = _size === void 0 ? "small" : _size, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _strict = param.strict, strict = _strict === void 0 ? false : _strict;
    var ref = useState(initData), data = ref[0], setData = ref[1];
    var update = function(lbl, val) {
        setData(_object_spread_props(_object_spread({}, data), _define_property({}, lbl, val)));
    };
    var handlers = [];
    handlers = canMap(fields) ? fields === null || fields === void 0 ? void 0 : fields.map(function(field) {
        return _object_spread_props(_object_spread({}, field), {
            label: field === null || field === void 0 ? void 0 : field.label,
            onChange: function(e) {
                return update(field === null || field === void 0 ? void 0 : field.label, getVal(e, strict));
            },
            value: (data === null || data === void 0 ? void 0 : data[field === null || field === void 0 ? void 0 : field.label]) ? data[field.label] : "",
            fullWidth: fullWidth,
            size: size
        });
    }) : [];
    return [
        handlers,
        setData
    ];
}
function useTextField(_param) {
    var _value = _param.value, value = _value === void 0 ? null : _value, label = _param.label, _handler = _param.handler, handler = _handler === void 0 ? null : _handler, _size = _param.size, size = _size === void 0 ? "small" : _size, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? null : _placeholder, _strict = _param.strict, strict = _strict === void 0 ? false : _strict, _autoFocus = _param.autoFocus, autoFocus = _autoFocus === void 0 ? false : _autoFocus, _type = _param.type, type = _type === void 0 ? "text" : _type, _validate = _param.validate, validate = _validate === void 0 ? null : _validate, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "value",
        "label",
        "handler",
        "size",
        "fullWidth",
        "placeholder",
        "strict",
        "autoFocus",
        "type",
        "validate"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value ? value : ""), updatedValue = ref[0], setUpdatedValue = ref[1];
    var onChange = function(event) {
        return !handler ? setUpdatedValue(getVal(event, strict)) : handler(getVal(event, strict));
    };
    var getValidated = function() {
        return (handler ? value : updatedValue) ? validate(handler ? value : updatedValue) ? "true" : "false" : null;
    };
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        label: label,
        value: handler ? value : updatedValue,
        onChange: onChange,
        size: size,
        fullWidth: fullWidth,
        placeholder: placeholder,
        autoFocus: autoFocus,
        type: type,
        valid: validate ? getValidated() : null,
        setValue: setUpdatedValue
    }, other);
}
function useNumField(param) {
    var value = param.value, label = param.label, _handler = param.handler, handler = _handler === void 0 ? null : _handler, _size = param.size, size = _size === void 0 ? "small" : _size, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), updatedValue = ref[0], setUpdatedValue = ref[1];
    var onChange = function(event) {
        if (!(0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .hasOnlyNumbers */ .io)(event.target.value)) return;
        handler ? handler(event.target.value) : setUpdatedValue(event.target.value);
    };
    return {
        label: label,
        value: updatedValue,
        onChange: onChange,
        size: size,
        fullWidth: fullWidth
    };
}


/***/ }),

/***/ 70210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "td": function() { return /* binding */ useApi_useLazyQuery; },
  "Tu": function() { return /* binding */ useMutate; },
  "aM": function() { return /* binding */ useApi_useQuery; },
  "tU": function() { return /* binding */ useVarQuery; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/adapters/client.js + 4 modules
var client = __webpack_require__(64792);
// EXTERNAL MODULE: ./src/mosanic/items/Spinner.js
var items_Spinner = __webpack_require__(36174);
// EXTERNAL MODULE: ./src/mosanic/items/ErrorAlert.js
var items_ErrorAlert = __webpack_require__(83482);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(64619);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(43869);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useSyncExternalStore.js



var didWarnUncachedGetSnapshot = false;
var uSESKey = "useSyncExternalStore";
var realHook = react_namespaceObject[uSESKey];
var useSyncExternalStore = realHook || (function (subscribe, getSnapshot, getServerSnapshot) {
    var value = getSnapshot();
    if (__DEV__ &&
        !didWarnUncachedGetSnapshot &&
        value !== getSnapshot()) {
        didWarnUncachedGetSnapshot = true;
        __DEV__ && globals/* invariant.error */.kG.error('The result of getSnapshot should be cached to avoid an infinite loop');
    }
    var _a = react.useState({ inst: { value: value, getSnapshot: getSnapshot } }), inst = _a[0].inst, forceUpdate = _a[1];
    if (canUse/* canUseLayoutEffect */.JC) {
        react.useLayoutEffect(function () {
            Object.assign(inst, { value: value, getSnapshot: getSnapshot });
            if (checkIfSnapshotChanged(inst)) {
                forceUpdate({ inst: inst });
            }
        }, [subscribe, value, getSnapshot]);
    }
    else {
        Object.assign(inst, { value: value, getSnapshot: getSnapshot });
    }
    react.useEffect(function () {
        if (checkIfSnapshotChanged(inst)) {
            forceUpdate({ inst: inst });
        }
        return subscribe(function handleStoreChange() {
            if (checkIfSnapshotChanged(inst)) {
                forceUpdate({ inst: inst });
            }
        });
    }, [subscribe]);
    return value;
});
function checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    }
    catch (_b) {
        return true;
    }
}
//# sourceMappingURL=useSyncExternalStore.js.map
// EXTERNAL MODULE: ../../node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(38229);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(58769);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/context/ApolloContext.js
var ApolloContext = __webpack_require__(42370);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(45832);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/networkStatus.js
var networkStatus = __webpack_require__(64368);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/parser/index.js
var parser = __webpack_require__(87274);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(56675);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(23180);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(9428);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(43056);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js












var useQuery_hasOwnProperty = Object.prototype.hasOwnProperty;
function useQuery(query, options) {
    if (options === void 0) { options = Object.create(null); }
    return useInternalState((0,useApolloClient/* useApolloClient */.x)(options.client), query).useQuery(options);
}
function useInternalState(client, query) {
    var stateRef = (0,react.useRef)();
    if (!stateRef.current ||
        client !== stateRef.current.client ||
        query !== stateRef.current.query) {
        stateRef.current = new InternalState(client, query, stateRef.current);
    }
    var state = stateRef.current;
    var _a = (0,react.useState)(0), _tick = _a[0], setTick = _a[1];
    state.forceUpdate = function () {
        setTick(function (tick) { return tick + 1; });
    };
    return state;
}
var InternalState = (function () {
    function InternalState(client, query, previous) {
        this.client = client;
        this.query = query;
        this.asyncResolveFns = new Set();
        this.optionsToIgnoreOnce = new (canUse/* canUseWeakSet */.sy ? WeakSet : Set)();
        this.ssrDisabledResult = (0,maybeDeepFreeze/* maybeDeepFreeze */.J)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus/* NetworkStatus.loading */.I.loading,
        });
        this.skipStandbyResult = (0,maybeDeepFreeze/* maybeDeepFreeze */.J)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus/* NetworkStatus.ready */.I.ready,
        });
        this.toQueryResultCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        (0,parser/* verifyDocumentType */.Vp)(query, parser/* DocumentType.Query */.n_.Query);
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) {
            this.previousData = previousData;
        }
    }
    InternalState.prototype.forceUpdate = function () {
        __DEV__ && globals/* invariant.warn */.kG.warn("Calling default no-op implementation of InternalState#forceUpdate");
    };
    InternalState.prototype.asyncUpdate = function (signal) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var watchQueryOptions = _this.watchQueryOptions;
            var handleAborted = function () {
                _this.asyncResolveFns.delete(resolve);
                _this.optionsToIgnoreOnce.delete(watchQueryOptions);
                signal.removeEventListener('abort', handleAborted);
                reject(signal.reason);
            };
            _this.asyncResolveFns.add(resolve);
            _this.optionsToIgnoreOnce.add(watchQueryOptions);
            signal.addEventListener('abort', handleAborted);
            _this.forceUpdate();
        });
    };
    InternalState.prototype.useQuery = function (options) {
        var _this = this;
        this.renderPromises = (0,react.useContext)((0,ApolloContext/* getApolloContext */.K)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = useSyncExternalStore((0,react.useCallback)(function () {
            if (_this.renderPromises) {
                return function () { };
            }
            var onNext = function () {
                var previousResult = _this.result;
                var result = obsQuery.getCurrentResult();
                if (previousResult &&
                    previousResult.loading === result.loading &&
                    previousResult.networkStatus === result.networkStatus &&
                    (0,equality_esm/* equal */.D)(previousResult.data, result.data)) {
                    return;
                }
                _this.setResult(result);
            };
            var onError = function (error) {
                var last = obsQuery["last"];
                subscription.unsubscribe();
                try {
                    obsQuery.resetLastResults();
                    subscription = obsQuery.subscribe(onNext, onError);
                }
                finally {
                    obsQuery["last"] = last;
                }
                if (!useQuery_hasOwnProperty.call(error, 'graphQLErrors')) {
                    throw error;
                }
                var previousResult = _this.result;
                if (!previousResult ||
                    (previousResult && previousResult.loading) ||
                    !(0,equality_esm/* equal */.D)(error, previousResult.error)) {
                    _this.setResult({
                        data: (previousResult && previousResult.data),
                        error: error,
                        loading: false,
                        networkStatus: networkStatus/* NetworkStatus.error */.I.error,
                    });
                }
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            return function () { return subscription.unsubscribe(); };
        }, [
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches,
        ]), function () { return _this.getCurrentResult(); }, function () { return _this.getCurrentResult(); });
        this.unsafeHandlePartialRefetch(result);
        var queryResult = this.toQueryResult(result);
        if (!queryResult.loading && this.asyncResolveFns.size) {
            this.asyncResolveFns.forEach(function (resolve) { return resolve(queryResult); });
            this.asyncResolveFns.clear();
        }
        return queryResult;
    };
    InternalState.prototype.useOptions = function (options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (this.optionsToIgnoreOnce.has(currentWatchQueryOptions) ||
            !(0,equality_esm/* equal */.D)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                this.optionsToIgnoreOnce.delete(currentWatchQueryOptions);
                this.observable.reobserve(this.getObsQueryOptions());
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) &&
            this.queryHookOptions.ssr === false &&
            !this.queryHookOptions.skip) {
            this.result = this.ssrDisabledResult;
        }
        else if (this.queryHookOptions.skip ||
            this.watchQueryOptions.fetchPolicy === 'standby') {
            this.result = this.skipStandbyResult;
        }
        else if (this.result === this.ssrDisabledResult ||
            this.result === this.skipStandbyResult) {
            this.result = void 0;
        }
    };
    InternalState.prototype.getObsQueryOptions = function () {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults)
            toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) {
            toMerge.push(this.queryHookOptions.defaultOptions);
        }
        toMerge.push((0,compact/* compact */.o)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce(mergeOptions/* mergeOptions */.J);
    };
    InternalState.prototype.createWatchQueryOptions = function (_a) {
        var _b;
        if (_a === void 0) { _a = {}; }
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, otherOptions = (0,tslib_es6.__rest)(_a, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]);
        var watchQueryOptions = Object.assign(otherOptions, { query: this.query });
        if (this.renderPromises &&
            (watchQueryOptions.fetchPolicy === 'network-only' ||
                watchQueryOptions.fetchPolicy === 'cache-and-network')) {
            watchQueryOptions.fetchPolicy = 'cache-first';
        }
        if (!watchQueryOptions.variables) {
            watchQueryOptions.variables = {};
        }
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: 'standby',
            });
        }
        else if (!watchQueryOptions.fetchPolicy) {
            watchQueryOptions.fetchPolicy =
                ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) ||
                    this.getDefaultFetchPolicy();
        }
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function () {
        var _a, _b;
        return (((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) ||
            ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) ||
            "cache-first");
    };
    InternalState.prototype.onCompleted = function (data) { };
    InternalState.prototype.onError = function (error) { };
    InternalState.prototype.useObservableQuery = function () {
        var obsQuery = this.observable =
            this.renderPromises
                && this.renderPromises.getSSRObservable(this.watchQueryOptions)
                || this.observable
                || this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = (0,react.useMemo)(function () { return ({
            refetch: obsQuery.refetch.bind(obsQuery),
            reobserve: obsQuery.reobserve.bind(obsQuery),
            fetchMore: obsQuery.fetchMore.bind(obsQuery),
            updateQuery: obsQuery.updateQuery.bind(obsQuery),
            startPolling: obsQuery.startPolling.bind(obsQuery),
            stopPolling: obsQuery.stopPolling.bind(obsQuery),
            subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery),
        }); }, [obsQuery]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false ||
            this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) {
                this.renderPromises.addObservableQueryPromise(obsQuery);
            }
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function (nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) {
            this.previousData = previousResult.data;
        }
        this.result = nextResult;
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function (result) {
        var _this = this;
        if (!result.loading) {
            var error_1 = this.toApolloError(result);
            Promise.resolve().then(function () {
                if (error_1) {
                    _this.onError(error_1);
                }
                else if (result.data) {
                    _this.onCompleted(result.data);
                }
            }).catch(function (error) {
                __DEV__ && globals/* invariant.warn */.kG.warn(error);
            });
        }
    };
    InternalState.prototype.toApolloError = function (result) {
        return (0,arrays/* isNonEmptyArray */.O)(result.errors)
            ? new errors/* ApolloError */.c({ graphQLErrors: result.errors })
            : result.error;
    };
    InternalState.prototype.getCurrentResult = function () {
        if (!this.result) {
            this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        }
        return this.result;
    };
    InternalState.prototype.toQueryResult = function (result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult)
            return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0,tslib_es6.__rest)(result, ["data", "partial"]);
        this.toQueryResultCache.set(result, queryResult = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({ data: data }, resultWithoutPartial), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: !this.queryHookOptions.skip, previousData: this.previousData }));
        if (!queryResult.error && (0,arrays/* isNonEmptyArray */.O)(result.errors)) {
            queryResult.error = new errors/* ApolloError */.c({ graphQLErrors: result.errors });
        }
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function (result) {
        if (result.partial &&
            this.queryHookOptions.partialRefetch &&
            !result.loading &&
            (!result.data || Object.keys(result.data).length === 0) &&
            this.observable.options.fetchPolicy !== 'cache-only') {
            Object.assign(result, {
                loading: true,
                networkStatus: networkStatus/* NetworkStatus.refetch */.I.refetch,
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}());
//# sourceMappingURL=useQuery.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/hooks/useLazyQuery.js





var EAGER_METHODS = [
    'refetch',
    'reobserve',
    'fetchMore',
    'updateQuery',
    'startPolling',
    'subscribeToMore',
];
function useLazyQuery(query, options) {
    var _a;
    var abortControllersRef = (0,react.useRef)(new Set());
    var execOptionsRef = (0,react.useRef)();
    var merged = execOptionsRef.current ? (0,mergeOptions/* mergeOptions */.J)(options, execOptionsRef.current) : options;
    var internalState = useInternalState((0,useApolloClient/* useApolloClient */.x)(options && options.client), (_a = merged === null || merged === void 0 ? void 0 : merged.query) !== null && _a !== void 0 ? _a : query);
    var useQueryResult = internalState.useQuery((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, merged), { skip: !execOptionsRef.current }));
    var initialFetchPolicy = useQueryResult.observable.options.initialFetchPolicy ||
        internalState.getDefaultFetchPolicy();
    var result = Object.assign(useQueryResult, {
        called: !!execOptionsRef.current,
    });
    var eagerMethods = (0,react.useMemo)(function () {
        var eagerMethods = {};
        var _loop_1 = function (key) {
            var method = result[key];
            eagerMethods[key] = function () {
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    internalState.forceUpdate();
                }
                return method.apply(this, arguments);
            };
        };
        for (var _i = 0, EAGER_METHODS_1 = EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++) {
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, []);
    Object.assign(result, eagerMethods);
    (0,react.useEffect)(function () {
        return function () {
            abortControllersRef.current.forEach(function (controller) {
                controller.abort();
            });
        };
    }, []);
    var execute = (0,react.useCallback)(function (executeOptions) {
        var controller = new AbortController();
        abortControllersRef.current.add(controller);
        execOptionsRef.current = executeOptions ? (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, executeOptions), { fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy }) : {
            fetchPolicy: initialFetchPolicy,
        };
        var promise = internalState
            .asyncUpdate(controller.signal)
            .then(function (queryResult) {
            abortControllersRef.current.delete(controller);
            return Object.assign(queryResult, eagerMethods);
        });
        promise.catch(function () {
            abortControllersRef.current.delete(controller);
        });
        return promise;
    }, []);
    return [execute, result];
}
//# sourceMappingURL=useLazyQuery.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(33379);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
;// CONCATENATED MODULE: ./src/hooks/useApi.js













var errorMessage = function(message) {
    return {
        message: message
    };
};
var interval = 100;
var checkResponseErrors = function(response) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var error = null;
    if (isEmpty(response) && (options === null || options === void 0 ? void 0 : options.mustReturn)) {
        error = errorMessage("No data retrieved.");
    } else if (Array.isArray(response === null || response === void 0 ? void 0 : response.errors)) {
        var ref;
        error = errorMessage((ref = response.errors[0]) === null || ref === void 0 ? void 0 : ref.message);
    } else if (response === null || response === void 0 ? void 0 : response.error) {
        var ref1;
        error = errorMessage(((ref1 = response.error) === null || ref1 === void 0 ? void 0 : ref1.message) ? response.error.message : response.error);
    }
    ;
    return error;
};
var fireApi = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(type, name, gql, vars) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(type === "query")) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 3;
                    return client/* default.query */.ZP.query(name, gql, vars);
                case 3:
                    _ctx.t0 = _ctx.sent;
                    _ctx.next = 28;
                    break;
                case 6:
                    if (!(type === "varQuery")) {
                        _ctx.next = 12;
                        break;
                    }
                    _ctx.next = 9;
                    return client/* default.query */.ZP.query(name, gql, vars);
                case 9:
                    _ctx.t1 = _ctx.sent;
                    _ctx.next = 27;
                    break;
                case 12:
                    if (!(type === "lazyQuery")) {
                        _ctx.next = 18;
                        break;
                    }
                    _ctx.next = 15;
                    return client/* default.query */.ZP.query(name, gql, vars);
                case 15:
                    _ctx.t2 = _ctx.sent;
                    _ctx.next = 26;
                    break;
                case 18:
                    if (!(type === "mutate")) {
                        _ctx.next = 24;
                        break;
                    }
                    _ctx.next = 21;
                    return client/* default.mutate */.ZP.mutate(name, gql, vars);
                case 21:
                    _ctx.t3 = _ctx.sent;
                    _ctx.next = 25;
                    break;
                case 24:
                    _ctx.t3 = errorMessage("Query type: ".concat(type, ", is unsupported."));
                case 25:
                    _ctx.t2 = _ctx.t3;
                case 26:
                    _ctx.t1 = _ctx.t2;
                case 27:
                    _ctx.t0 = _ctx.t1;
                case 28:
                    return _ctx.abrupt("return", _ctx.t0);
                case 29:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fireApi(type, name, gql, vars) {
        return _ref.apply(this, arguments);
    };
}();
// const fireApi = async (type, name, gql, vars) => {
// 	const useClient = (await import('@api/client')).default; 
// 	return (type === 'query') ? await useClient.query(name, gql, vars) :
// 	(type === 'varQuery') ? await useClient.query(name, gql, vars) :
// 	(type === 'lazyQuery') ? await useClient.query(name, gql, vars) :
// 	(type === 'mutate') ? await useClient.mutate(name, gql, vars) :
// 	errorMessage(`Query type: ${type}, is unsupported.`);
// }
var useApi = function(param, options) {
    var name = param.name, gql = param.gql, _vars = param.vars, vars = _vars === void 0 ? null : _vars;
    var ref = useState(null), data = ref[0], setData = ref[1];
    var ref1 = useState(null), loading = ref1[0], setLoading = ref1[1];
    var ref2 = useState(null), error = ref2[0], setError = ref2[1];
    usePolling({
        callback: function() {
            return getData(vars);
        },
        active: (options === null || options === void 0 ? void 0 : options.type) === "query"
    });
    //Api runner
    var getData = useCallback(function() {
        var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(queryVars) {
            var response, error, data;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return fireApi(options === null || options === void 0 ? void 0 : options.type, name, gql, queryVars);
                    case 3:
                        response = _ctx.sent;
                        error = checkResponseErrors(response, options);
                        data = error ? null : response;
                        if (isClone(response) || response) setData(response);
                        setLoading(false);
                        setError(error);
                        return _ctx.abrupt("return", {
                            data: data,
                            error: error
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(queryVars) {
            return _ref.apply(this, arguments);
        };
    }(), [
        options,
        name,
        gql
    ]);
    return [
        function(queryVars) {
            return getData(queryVars);
        },
        [
            data,
            Boolean(loading) ? /*#__PURE__*/ _jsx(Spinner, {}) : null,
            Boolean(error) ? /*#__PURE__*/ _jsx(ErrorAlert, {
                errorMessage: error.message
            }) : null, 
        ]
    ];
};
// {data, loading, error}
var useApi_useQuery = function(name, query) {
    var vars = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var ref = useQuery(query, {
        variables: vars
    }), loading = ref.loading, error = ref.error, data = ref.data;
    // const [callback, [data, loading, error]] = useApi({
    // 	gql: query, 
    // 	name, 
    // 	vars
    // }, {
    // 	type: 'query',
    // 	...options
    // });
    // if(!data && !loading && !error) callback(vars)
    return [
        data ? data === null || data === void 0 ? void 0 : data[name] : data,
        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(items_Spinner/* Spinner */.$, {}) : null,
        error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(items_ErrorAlert/* ErrorAlert */.h, {
            errorMessage: error.message
        }) : null
    ];
};
var useVarQuery = function(name, query, vars) {
    var hasVars = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    // const calls = useRef(0);
    var ref = useQuery(query, {
        variables: vars
    }), loading = ref.loading, error = ref.error, data = ref.data;
    // const [callback, [data, loading, error]] = useApi({
    // 	gql: query, 
    // 	name, 
    // 	vars
    // }, {
    // 	type: 'varQuery',
    // 	...options
    // });
    // if(!data && !loading && !error && calls.current === 0 && hasVars) {
    // 	calls.current++
    // 	callback(vars)
    // }
    // useEffect(() => {
    // 	if(hasVars) callback(vars)
    // },[hasVars])
    return [
        data ? data === null || data === void 0 ? void 0 : data[name] : data,
        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(items_Spinner/* Spinner */.$, {}) : null,
        error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(items_ErrorAlert/* ErrorAlert */.h, {
            errorMessage: error.message
        }) : null
    ];
};
// [getData, {data, loading, error}]
var useApi_useLazyQuery = function(name, query) {
    var vars = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var ref = (0,_sliced_to_array/* default */.Z)(useLazyQuery(query, {
        variables: vars
    }), 2), call = ref[0], ref1 = ref[1], loading = ref1.loading, error = ref1.error, data = ref1.data;
    var callback = function(variables) {
        return call({
            variables: variables
        });
    };
    // const [callback, [data, loading, error]] = useApi({
    // 	gql: query, 
    // 	name, 
    // 	vars
    // }, {
    // 	type: 'lazyQuery', 
    // 	...options
    // });
    return [
        callback,
        [
            data ? data === null || data === void 0 ? void 0 : data[name] : data,
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(items_Spinner/* Spinner */.$, {}) : null,
            error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(items_ErrorAlert/* ErrorAlert */.h, {
                errorMessage: error.message
            }) : null
        ]
    ];
};
// [getData, {data, loading, error}]
var useMutate = function(name, mutation) {
    var vars = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutation), 2), dispatch = ref[0], ref1 = ref[1], data = ref1.data, loading = ref1.loading, error = ref1.error;
    var mutate = function(variables) {
        var omit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        return dispatch({
            variables: omit ? (0,Obj/* omitDeep */.Cd)(variables, "__typename") : variables
        });
    };
    // const [callback, [data, loading, error]] = useApi({
    // 	gql: mutation, 
    // 	name, 
    // 	vars
    // }, {
    // 	type: 'mutate', 
    // 	...options
    // });
    return [
        mutate,
        [
            data ? data === null || data === void 0 ? void 0 : data[name] : data,
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(items_Spinner/* Spinner */.$, {}) : null,
            error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(items_ErrorAlert/* ErrorAlert */.h, {
                errorMessage: error.message
            }) : null
        ]
    ];
};


/***/ }),

/***/ 64485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

// Hook
var useWindowSize = function() {
    var isClient = "object" != "undefined";
    var getSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return {
            width: isClient ? window === null || window === void 0 ? void 0 : window.innerWidth : undefined,
            height: isClient ? window === null || window === void 0 ? void 0 : window.innerHeight : undefined
        };
    }, [
        isClient
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getSize()), windowSize = ref[0], setWindowSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isClient) {
            return false;
        }
        var handleResize = function() {
            setWindowSize(getSize());
        };
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, [
        getSize,
        isClient
    ]);
    return windowSize;
};


/***/ }),

/***/ 96344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ConditionalWrapper; }
/* harmony export */ });
/* unused harmony export Wrapper */
var ConditionalWrapper = function(param) {
    var when = param.when, wrapper = param.wrapper, children = param.children;
    return when ? wrapper(children) : children;
};
var Wrapper = function(param) {
    var condition = param.condition, when = param.when, otherwise = param.otherwise, children = param.children;
    return condition ? when(children) : otherwise(children);
};


/***/ }),

/***/ 706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "If": function() { return /* binding */ If; }
/* harmony export */ });
/* unused harmony exports Else, When, Choose */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var If = function(param) {
    var children = param.children, condition = param.condition;
    return condition ? children : null;
};
var Else = function(param) {
    var children = param.children, _condition = param.condition, condition = _condition === void 0 ? null : _condition, _invertCondition = param.invertCondition, invertCondition = _invertCondition === void 0 ? true : _invertCondition;
    return invertCondition ? !condition ? children : null : condition ? children : null;
};
var When = function(param) {
    var children = param.children, condition = param.condition;
    return /*#__PURE__*/ _jsx(If, {
        condition: condition,
        children: children
    });
};
var controls = {
    CHOOSE: "Choose",
    WHEN: "When",
    ELSE: "Else"
};
/**
 * Choose blocks are the wrapper for when and else statements
 */ var Choose = function(param) {
    var children = param.children, _condition = param.condition, condition = _condition === void 0 ? null : _condition;
    var whenRef = {
        hasStatement: false,
        hasTrueCondition: false
    };
    if (children.length <= 0) {
        console.warn("<".concat(controls.CHOOSE, "> block doesn't contain any children."));
    }
    var render = Children.map(children, function(child) {
        var childType = child.type.name;
        switch(childType){
            case controls.WHEN:
                whenRef.hasStatement = true;
                if (child.props.condition) whenRef.hasTrueCondition = true;
                return child;
            case controls.ELSE:
                if (!whenRef.hasTrueCondition) {
                    return /*#__PURE__*/ cloneElement(child, {
                        condition: true,
                        invertCondition: false
                    });
                } else {
                    return /*#__PURE__*/ cloneElement(child, {
                        condition: false,
                        invertCondition: false
                    });
                }
            default:
                console.error("Direct children of <".concat(controls.CHOOSE, "> statements can only be <").concat(controls.WHEN, "> and/or <").concat(controls.ELSE, ">."));
                break;
        }
    });
    if (!whenRef.hasStatement) {
        console.error("A <".concat(controls.CHOOSE, "> statement should always contain an When statement."));
    }
    return render;
};


/***/ }),

/***/ 3679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lb": function() { return /* binding */ HeadingTag; }
/* harmony export */ });
/* unused harmony export Element */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);





var Element = function(_param) /*#__PURE__*/ {
    var tag = _param.tag, children = _param.children, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "tag",
        "children"
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(tag, other, children);
};
var HeadingTag = function(_param) /*#__PURE__*/ {
    var level = _param.level, _other = _param.other, other = _other === void 0 ? null : _other, _children = _param.children, children = _children === void 0 ? null : _children, more = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "level",
        "other",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        tag: "h".concat(level)
    }, other, more), {
        children: children
    }));
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Element)));


/***/ }),

/***/ 75679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ circleMin; },
/* harmony export */   "Cp": function() { return /* binding */ hide; },
/* harmony export */   "JG": function() { return /* binding */ copy; },
/* harmony export */   "KH": function() { return /* binding */ dotOpen; },
/* harmony export */   "OM": function() { return /* binding */ duplicate; },
/* harmony export */   "PD": function() { return /* binding */ plus; },
/* harmony export */   "Tw": function() { return /* binding */ circlePlus; },
/* harmony export */   "Yr": function() { return /* binding */ editPencilBorder; },
/* harmony export */   "_I": function() { return /* binding */ trash; },
/* harmony export */   "_p": function() { return /* binding */ bookmarkIcon; },
/* harmony export */   "a1": function() { return /* binding */ save; },
/* harmony export */   "al": function() { return /* binding */ hidden; },
/* harmony export */   "ei": function() { return /* binding */ view; },
/* harmony export */   "fn": function() { return /* binding */ greenTrash; },
/* harmony export */   "h9": function() { return /* binding */ minus; },
/* harmony export */   "j7": function() { return /* binding */ editPencil; },
/* harmony export */   "jn": function() { return /* binding */ expand; },
/* harmony export */   "tO": function() { return /* binding */ warningIcon; },
/* harmony export */   "v": function() { return /* binding */ paste; },
/* harmony export */   "z7": function() { return /* binding */ cut; }
/* harmony export */ });
/* unused harmony exports removeFile, copyFile, pasteFile, download */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var editPencil = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M11.854 1.146a.5.5 0 0 0-.707 0L3.714 8.578a1 1 0 0 0-.212.314L2.04 12.303a.5.5 0 0 0 .657.657l3.411-1.463a1 1 0 0 0 .314-.211l7.432-7.432a.5.5 0 0 0 0-.708l-2-2Zm-7.432 8.14L11.5 2.206 12.793 3.5l-7.078 7.078-1.496.641-.438-.438.64-1.496Z",
        fill: "#000"
    })
});
var editPencilBorder = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M12.146 1.146a.5.5 0 0 1 .707 0l2 2a.5.5 0 0 1 0 .708l-3.942 3.942a1 1 0 0 1-.26.188L6.724 9.947a.5.5 0 0 1-.671-.67l1.963-3.928a1 1 0 0 1 .188-.26l3.942-3.943Zm.354 1.061-3.59 3.59-1.037 2.076.254.254 2.077-1.038L13.793 3.5 12.5 2.207ZM10 2 9 3H4.9c-.428 0-.72 0-.944.019-.22.018-.332.05-.41.09a1 1 0 0 0-.437.437c-.04.078-.072.19-.09.41C3 4.18 3 4.472 3 4.9v6.2c0 .428 0 .72.019.944.018.22.05.332.09.41a1 1 0 0 0 .437.437c.078.04.19.072.41.09.225.019.516.019.944.019h6.2c.428 0 .72 0 .944-.019.22-.018.332-.05.41-.09a1 1 0 0 0 .437-.437c.04-.078.072-.19.09-.41.019-.225.019-.516.019-.944V7l1-1V11.12c0 .403 0 .735-.022 1.006-.023.281-.072.54-.196.782a2 2 0 0 1-.874.874c-.243.124-.501.173-.782.196-.27.022-.603.022-1.005.022H4.88c-.403 0-.735 0-1.006-.022-.281-.023-.54-.072-.782-.196a2 2 0 0 1-.874-.874c-.124-.243-.173-.501-.196-.782C2 11.856 2 11.523 2 11.12V4.88c0-.403 0-.735.022-1.006.023-.281.072-.54.196-.782a2 2 0 0 1 .874-.874c.243-.124.501-.173.782-.196C4.144 2 4.477 2 4.88 2H10Z",
        fill: "#000"
    })
});
var circlePlus = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M7.5.877a6.623 6.623 0 1 0 0 13.246A6.623 6.623 0 0 0 7.5.877ZM1.827 7.5a5.673 5.673 0 1 1 11.346 0 5.673 5.673 0 0 1-11.346 0ZM7.5 4a.5.5 0 0 1 .5.5V7h2.5a.5.5 0 1 1 0 1H8v2.5a.5.5 0 0 1-1 0V8H4.5a.5.5 0 0 1 0-1H7V4.5a.5.5 0 0 1 .5-.5Z",
        fill: "#000"
    })
});
var plus = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 2.75a.5.5 0 0 0-1 0V7H2.75a.5.5 0 0 0 0 1H7v4.25a.5.5 0 0 0 1 0V8h4.25a.5.5 0 0 0 0-1H8V2.75Z",
        fill: "#000"
    })
});
var circleMin = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    version: "1.1",
    viewBox: "0 0 15 15",
    width: "15",
    height: "15",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M7.49991,0.876892c-3.65769,0 -6.62284,2.96515 -6.62284,6.62283c4.44089e-16,3.65768 2.96515,6.62288 6.62284,6.62288c3.65769,0 6.62279,-2.9652 6.62279,-6.62288c0,-3.65768 -2.9651,-6.62283 -6.62279,-6.62283Zm-5.67284,6.62283c0,-3.13301 2.53982,-5.67283 5.67284,-5.67283c3.13299,2.22045e-16 5.67279,2.53982 5.67279,5.67283c0,3.13298 -2.5398,5.67288 -5.67279,5.67288c-3.13302,0 -5.67284,-2.5399 -5.67284,-5.67288Zm2.67296,-0.49972c-0.27614,0 -0.5,0.22386 -0.5,0.5c0,0.27614 0.22386,0.5 0.5,0.5h5.99997c0.2762,0 0.5,-0.22386 0.5,-0.5c0,-0.27614 -0.2238,-0.5 -0.5,-0.5h-5.99997Z",
        fill: "#000",
        fillRule: "evenodd"
    })
});
var minus = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 7.5C2.25 7.22386 2.47386 7 2.75 7H12.25C12.5261 7 12.75 7.22386 12.75 7.5C12.75 7.77614 12.5261 8 12.25 8H2.75C2.47386 8 2.25 7.77614 2.25 7.5Z",
        fill: "black"
    })
});
;
var hide = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        d: "M13.354 2.354a.5.5 0 0 0-.708-.708L10.683 3.61A8.475 8.475 0 0 0 7.5 3C4.308 3 1.656 4.706.076 7.235a.5.5 0 0 0 0 .53c.827 1.323 1.947 2.421 3.285 3.167l-1.715 1.714a.5.5 0 0 0 .708.708l1.963-1.964c.976.393 2.045.61 3.183.61 3.192 0 5.844-1.706 7.424-4.235a.5.5 0 0 0 0-.53c-.827-1.323-1.947-2.421-3.285-3.167l1.715-1.714Zm-3.45 2.035A7.517 7.517 0 0 0 7.5 4C4.803 4 2.53 5.378 1.096 7.5c.777 1.15 1.8 2.081 3.004 2.693L9.904 4.39ZM5.096 10.61 10.9 4.807c1.204.612 2.227 1.543 3.004 2.693C12.47 9.622 10.197 11 7.5 11a7.518 7.518 0 0 1-2.404-.389Z",
        fill: "#000"
    })
});
var view = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        d: "M7.5 11c-2.697 0-4.97-1.378-6.404-3.5C2.53 5.378 4.803 4 7.5 4s4.97 1.378 6.404 3.5C12.47 9.622 10.197 11 7.5 11Zm0-8C4.308 3 1.656 4.706.076 7.235a.5.5 0 0 0 0 .53C1.656 10.294 4.308 12 7.5 12s5.844-1.706 7.424-4.235a.5.5 0 0 0 0-.53C13.344 4.706 10.692 3 7.5 3Zm0 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
        fill: "#000"
    })
});
var hidden = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.765 6.076a.5.5 0 0 1 .159.689 9.523 9.523 0 0 1-1.554 1.898l1.201 1.201a.5.5 0 1 1-.707.707l-1.263-1.263a8.472 8.472 0 0 1-2.667 1.343l.449 1.677a.5.5 0 1 1-.966.259l-.458-1.71a8.666 8.666 0 0 1-2.918 0l-.458 1.71a.5.5 0 1 1-.966-.26l.45-1.676a8.475 8.475 0 0 1-2.668-1.343l-1.263 1.263a.5.5 0 1 1-.707-.707l1.2-1.2A9.52 9.52 0 0 1 .077 6.764a.5.5 0 1 1 .848-.53 8.426 8.426 0 0 0 1.77 2.034A7.462 7.462 0 0 0 7.5 10c2.808 0 5.156-1.494 6.576-3.765a.5.5 0 0 1 .689-.159Z",
        fill: "#000"
    })
});
var trash = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        d: "M5.5 1a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM3 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H11v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4h-.5a.5.5 0 0 1-.5-.5ZM5 4h5v8H5V4Z",
        fill: "#000"
    })
});
var greenTrash = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M5.5 1a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM3 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H11v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4h-.5a.5.5 0 0 1-.5-.5ZM5 4h5v8H5V4Z",
        fill: "#2bd67b"
    })
});
var cut = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M3 2.5a.5.5 0 0 1 .5-.5h5.793L12 4.707V12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-10ZM3.5 1A1.5 1.5 0 0 0 2 2.5v10A1.5 1.5 0 0 0 3.5 14h8a1.5 1.5 0 0 0 1.5-1.5V4.604a.75.75 0 0 0-.22-.53L9.854 1.145A.5.5 0 0 0 9.5 1h-6Zm1.75 6a.5.5 0 0 0 0 1h4.5a.5.5 0 0 0 0-1h-4.5Z",
        fill: "#000"
    })
});
var removeFile = cut;
var copy = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M5 2V1h5v1H5Zm-.25-2A.75.75 0 0 0 4 .75V1h-.5A1.5 1.5 0 0 0 2 2.5v10A1.5 1.5 0 0 0 3.5 14H7v-1H3.5a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5H4v.25c0 .414.336.75.75.75h5.5a.75.75 0 0 0 .75-.75V2h.5a.5.5 0 0 1 .5.5V7h1V2.5A1.5 1.5 0 0 0 11.5 1H11V.75a.75.75 0 0 0-.75-.75h-5.5ZM9 8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm.5 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-.5 2.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm0 2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm-6-4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm.5 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM8.5 15a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z",
        fill: "#000"
    })
});
var copyFile = copy;
var paste = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M3.5 2a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V4.707L9.293 2H3.5ZM2 2.5A1.5 1.5 0 0 1 3.5 1h6a.5.5 0 0 1 .354.146l2.926 2.927c.141.14.22.332.22.53V12.5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 2 12.5v-10Zm2.75 5a.5.5 0 0 1 .5-.5H7V5.25a.5.5 0 0 1 1 0V7h1.75a.5.5 0 0 1 0 1H8v1.75a.5.5 0 0 1-1 0V8H5.25a.5.5 0 0 1-.5-.5Z",
        fill: "#000"
    })
});
var pasteFile = paste;
var save = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M7.5 1.05a.45.45 0 0 1 .45.45v6.914l2.232-2.232a.45.45 0 1 1 .636.636l-3 3a.45.45 0 0 1-.636 0l-3-3a.45.45 0 1 1 .636-.636L7.05 8.414V1.5a.45.45 0 0 1 .45-.45ZM2.5 10a.5.5 0 0 1 .5.5V12c0 .554.446 1 .996 1h7.005A.999.999 0 0 0 12 12v-1.5a.5.5 0 0 1 1 0V12c0 1.104-.894 2-1.999 2H3.996A1.997 1.997 0 0 1 2 12v-1.5a.5.5 0 0 1 .5-.5Z",
        fill: "#000"
    })
});
var download = save;
var duplicate = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M1 9.5A1.5 1.5 0 0 0 2.5 11H4v-1H2.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5V4H5.5A1.5 1.5 0 0 0 4 5.5v7A1.5 1.5 0 0 0 5.5 14h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 12.5 4H11V2.5A1.5 1.5 0 0 0 9.5 1h-7A1.5 1.5 0 0 0 1 2.5v7Zm4-4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7Z",
        fill: "#000"
    })
});
var expand = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M11.5 3.05a.45.45 0 0 1 .45.45v4a.45.45 0 0 1-.9 0V4.586L4.586 11.05H7.5a.45.45 0 0 1 0 .9h-4a.45.45 0 0 1-.45-.45v-4a.45.45 0 1 1 .9 0v2.914l6.464-6.464H7.5a.45.45 0 1 1 0-.9h4Z",
        fill: "#000"
    })
});
var dotOpen = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 9.125a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Z",
        fill: "#000"
    })
});
var warningIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
        "data-name": "Layer 2",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            "data-name": "alert-triangle",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M23 16 15 4a3 3 0 0 0-6 0L1 16a3 3 0 0 0 0 3 3 3 0 0 0 3 2h16a3 3 0 0 0 3-2 3 3 0 0 0 0-3zm-2 2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1 1 1 0 0 1 0-1l8-12a1 1 0 0 1 2 0l8 12a1 1 0 0 1 0 1z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "12",
                    cy: "16",
                    r: "1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12 8a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z"
                })
            ]
        })
    })
});
var bookmarkIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    version: "1.1",
    viewBox: "0 0 15 15",
    width: "15",
    height: "15",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M3,2.5c0,-0.27614 0.22386,-0.5 0.5,-0.5h8c0.2761,0 0.5,0.22386 0.5,0.5v11c0,0.1818 -0.0986,0.3492 -0.2576,0.4373c-0.159,0.0881 -0.3533,0.083 -0.5074,-0.0133l-3.735,-2.3344l-3.735,2.3344c-0.15413,0.0963 -0.34841,0.1014 -0.50738,0.0133c-0.15898,-0.0881 -0.25762,-0.2555 -0.25762,-0.4373v-11Zm1,0.5v9.5979l2.97,-1.8563c0.32427,-0.2026 0.73573,-0.2026 1.06,0l2.97,1.8563v-9.5979h-7Z",
        fill: "#000",
        fillRule: "evenodd"
    })
});
var EditIcons = {
    editPencil: editPencil,
    editPencilBorder: editPencilBorder,
    circlePlus: circlePlus,
    plus: plus,
    circleMin: circleMin,
    minus: minus,
    //Eyes
    hide: hide,
    view: view,
    hidden: hidden,
    trash: trash,
    greenTrash: greenTrash,
    cut: cut,
    removeFile: removeFile,
    copy: copy,
    copyFile: copyFile,
    paste: paste,
    pasteFile: pasteFile,
    save: save,
    download: download,
    duplicate: duplicate,
    expand: expand,
    dotOpen: dotOpen,
    warningIcon: warningIcon,
    bookmarkIcon: bookmarkIcon
};

/* harmony default export */ __webpack_exports__["ZP"] = (EditIcons);


/***/ }),

/***/ 59688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q4": function() { return /* binding */ targetIcon; },
/* harmony export */   "U1": function() { return /* binding */ rotate; },
/* harmony export */   "UG": function() { return /* binding */ format_align_justify; },
/* harmony export */   "VL": function() { return /* binding */ align_top; },
/* harmony export */   "ZI": function() { return /* binding */ format_align_right; },
/* harmony export */   "_E": function() { return /* binding */ rotate_box; },
/* harmony export */   "fL": function() { return /* binding */ text; },
/* harmony export */   "gr": function() { return /* binding */ align_bottom; },
/* harmony export */   "ih": function() { return /* binding */ format_align_left; },
/* harmony export */   "pZ": function() { return /* binding */ format_align_center; },
/* harmony export */   "qY": function() { return /* binding */ headings; },
/* harmony export */   "qz": function() { return /* binding */ source; },
/* harmony export */   "wC": function() { return /* binding */ align_middle; }
/* harmony export */ });
/* unused harmony exports format_bold, format_italic, format_underlined, code, looks_one, looks_two, format_quote, format_list_bulleted, format_list_numbered, image, link, link_off, smart_button, envelopeIcon, EditorIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77298);
/* harmony import */ var _EditIcons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75679);




var format_bold = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M5.105 12c-.397 0-.681-.088-.853-.264-.168-.18-.252-.465-.252-.853V4.117c0-.397.086-.681.258-.853.176-.176.458-.264.847-.264H9.03c1.108 0 2.025.982 2.025 2.185 0 .9-.45 1.634-1.35 2.051 1.162.213 1.814 1.392 1.814 2.245 0 1.031-.528 2.519-2.24 2.519H5.104Zm3.274-3.997H5.8v2.628h2.579c.521 0 1.25-.51 1.25-1.332 0-.823-.729-1.296-1.25-1.296ZM5.8 4.37v2.327h2.38c.36 0 1.097-.337 1.097-1.196 0-.86-.797-1.131-1.097-1.131H5.8Z",
        fill: "#000"
    })
});
var format_italic = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.675 3.5a.45.45 0 0 1 .45-.45h4.5a.45.45 0 1 1 0 .9h-1.62l-1.774 7.1h1.644a.45.45 0 0 1 0 .9h-4.5a.45.45 0 1 1 0-.9h1.619l1.775-7.1H6.125a.45.45 0 0 1-.45-.45Z",
        fill: "#000"
    })
});
var format_underlined = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 2.75a.5.5 0 0 0-1 0v5.3a3.5 3.5 0 0 0 7 0v-5.3a.5.5 0 1 0-1 0v5.3a2.5 2.5 0 1 1-5 0v-5.3ZM3.5 13.1a.4.4 0 1 0 0 .8h8a.4.4 0 0 0 0-.8h-8Z",
        fill: "#000"
    })
});
var code = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.964 2.686a.5.5 0 1 0-.928-.372l-4 10a.5.5 0 1 0 .928.372l4-10Zm-6.11 2.46a.5.5 0 0 1 0 .708L2.207 7.5l1.647 1.646a.5.5 0 1 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708 0Zm7.292 0a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L12.793 7.5l-1.647-1.646a.5.5 0 0 1 0-.708Z",
        fill: "#000"
    })
});
var text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.95 2.95V4.5a.45.45 0 0 1-.9 0v-2a.45.45 0 0 1 .45-.45h8a.45.45 0 0 1 .45.45v2a.45.45 0 1 1-.9 0V2.95h-3v9.1h1.204a.45.45 0 0 1 0 .9h-3.5a.45.45 0 1 1 0-.9H6.95v-9.1h-3Z",
        fill: "#000"
    })
});
var looks_one = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.754 2.05a.45.45 0 1 0 0 .9H9.95v4.1h-4.9v-4.1h1.204a.45.45 0 1 0 0-.9h-3.5a.45.45 0 1 0 0 .9H3.95v9.1H2.754a.45.45 0 0 0 0 .9h3.5a.45.45 0 0 0 0-.9H5.05v-4.1h4.9v4.1H8.754a.45.45 0 0 0 0 .9h3.5a.45.45 0 0 0 0-.9H11.05v-9.1h1.204a.45.45 0 0 0 0-.9h-3.5Z",
        fill: "#000"
    })
});
var looks_two = looks_one;
var headings = looks_one;
var format_quote = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.425 3.441c.631-.204 1.359-.2 1.954.105 1.374.706 1.969 2.526 1.416 4.454-.248.865-.685 1.705-1.609 2.552-.924.848-2.206 1.348-2.8 1.348A.38.38 0 0 1 8 11.525c0-.207.176-.375.386-.375.679 0 1.286-.37 2.005-.914.55-.417.98-.95 1.217-1.414.455-.888.47-2.14-.265-2.473-.353.386-.813.61-1.366.61-1.2 0-1.907-.965-1.876-1.839.029-.835.56-1.43 1.324-1.679Zm-6 0c.631-.204 1.359-.2 1.954.105C6.753 4.252 7.348 6.072 6.795 8c-.248.865-.685 1.705-1.609 2.552-.924.848-2.206 1.348-2.8 1.348A.38.38 0 0 1 2 11.525c0-.207.176-.375.386-.375.679 0 1.286-.37 2.005-.914.55-.417.98-.95 1.217-1.414.455-.888.47-2.14-.265-2.473-.353.386-.814.61-1.366.61-1.2 0-1.907-.965-1.876-1.839.029-.835.56-1.43 1.324-1.679Z",
        fill: "#000"
    })
});
var format_list_bulleted = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 5.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM4 4.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5ZM4.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Zm0 3a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9ZM2.25 7.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
        fill: "#000"
    })
});
var format_list_numbered = format_list_bulleted;
var format_align_left = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M2 4.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5Zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Z",
        fill: "#000"
    })
});
var format_align_center = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 4.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5Zm2 3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Zm-1 3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Z",
        fill: "#000"
    })
});
var format_align_right = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 4.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5Zm5 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm-3 3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Z",
        fill: "#000"
    })
});
var format_align_justify = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.5 4a.5.5 0 0 0 0 1h10a.5.5 0 0 0 0-1h-10ZM2 7.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5Zm0 3a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5Z",
        fill: "#000"
    })
});
var align_top = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M1.5 0a.5.5 0 0 0 0 1H6v11a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V1h4.5a.5.5 0 0 0 0-1h-12Z",
        fill: "#000"
    })
});
var align_middle = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M7 1a1 1 0 0 0-1 1v5H1.5a.5.5 0 0 0 0 1H6v5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V8h4.5a.5.5 0 0 0 0-1H9V2a1 1 0 0 0-1-1H7Z",
        fill: "#000"
    })
});
var align_bottom = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M9 3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v11H1.5a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1H9V3Z",
        fill: "#000"
    })
});
var rotate_box = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.597 2.936A.25.25 0 0 0 8 2.74V2c1.981 0 3.185.364 3.91 1.09C12.637 3.814 13 5.018 13 7a.5.5 0 0 0 1 0c0-2.056-.367-3.603-1.382-4.618C11.603 1.368 10.056 1 8 1V.261a.25.25 0 0 0-.403-.197L6.004 1.303a.25.25 0 0 0 0 .394l1.593 1.24ZM9.5 5h-7a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Zm-7-1A1.5 1.5 0 0 0 1 5.5v7A1.5 1.5 0 0 0 2.5 14h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 9.5 4h-7Z",
        fill: "#000"
    })
});
var rotate = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "15",
    height: "15",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M21.962 12.875A10.03 10.03 0 1 1 19.122 5H16a1 1 0 0 0-1 1 1 1 0 0 0 1 1h4.143A1.858 1.858 0 0 0 22 5.143V1a1 1 0 0 0-1-1 1 1 0 0 0-1 1v2.078A11.985 11.985 0 1 0 23.95 13.1a1.007 1.007 0 0 0-1-1.1.982.982 0 0 0-.988.875Z"
    })
});
var source = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.512 3.005c.676-.46 1.531-.468 2.167-.05.144.094.298.244.71.656.412.412.562.566.657.71.417.636.408 1.49-.051 2.167-.105.155-.267.32-.694.747l-.62.619a.5.5 0 0 0 .708.707l.619-.619.043-.043c.37-.37.606-.606.771-.849.675-.994.71-2.287.06-3.278-.159-.241-.39-.472-.741-.823l-.045-.045-.044-.045c-.352-.351-.583-.582-.824-.74-.99-.65-2.284-.616-3.278.06-.243.164-.48.4-.85.77l-.042.043-.619.62a.5.5 0 1 0 .707.706l.62-.618c.426-.427.592-.59.746-.695ZM4.318 7.147a.5.5 0 0 0-.707-.707l-.619.618-.043.043c-.37.37-.606.606-.771.85-.675.993-.71 2.287-.06 3.277.159.242.39.473.741.824l.045.045.044.044c.352.351.583.583.824.741.99.65 2.284.616 3.278-.06.243-.165.48-.401.849-.771l.043-.043.619-.619a.5.5 0 1 0-.708-.707l-.618.619c-.427.427-.593.59-.747.694-.676.46-1.532.469-2.167.051-.144-.094-.298-.245-.71-.657-.412-.412-.562-.566-.657-.71-.417-.635-.408-1.49.051-2.167.105-.154.267-.32.694-.747l.619-.618Zm5.304-1.061a.5.5 0 0 0-.707-.708L5.379 8.914a.5.5 0 1 0 .707.707l3.536-3.535Z",
        fill: "#000"
    })
});
var chain_link = (/* unused pure expression or super */ null && (source));
var link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.625 4h-.061c-.523 0-.857 0-1.146.055-1.18.225-2.12 1.116-2.36 2.275C1 6.613 1 6.94 1 7.437v.126c0 .497 0 .824.058 1.107.24 1.16 1.18 2.05 2.36 2.275.289.055.623.055 1.146.055H5.5a.5.5 0 1 0 0-1h-.875c-.604 0-.836-.002-1.02-.037-.802-.154-1.413-.752-1.568-1.496C2.002 8.297 2 8.083 2 7.5c0-.582.002-.798.037-.967.155-.744.766-1.342 1.569-1.496C3.789 5.002 4.02 5 4.625 5H5.5a.5.5 0 0 0 0-1h-.875Zm5.75 1c.604 0 .835.002 1.019.037.803.154 1.414.752 1.568 1.496.035.17.038.385.038.967 0 .583-.003.798-.038.967-.154.744-.765 1.342-1.568 1.496-.184.035-.415.037-1.02.037H9.5a.5.5 0 0 0 0 1h.935c.523 0 .857 0 1.146-.055 1.18-.225 2.12-1.116 2.36-2.275C14 8.387 14 8.06 14 7.563v-.126c0-.497 0-.824-.059-1.107-.24-1.16-1.18-2.05-2.36-2.275C11.293 4 10.958 4 10.435 4H9.5a.5.5 0 0 0 0 1h.875ZM5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1H5Z",
        fill: "#000"
    })
});
var link_off = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.354 2.354a.5.5 0 0 0-.708-.708l-11 11a.5.5 0 0 0 .708.708l11-11ZM2.037 8.467c.137.66.632 1.204 1.302 1.426l-.76.76a2.91 2.91 0 0 1-1.52-1.983c-.06-.283-.06-.61-.06-1.107v-.126c0-.497 0-.824.06-1.107.24-1.16 1.179-2.05 2.36-2.275C3.706 4 4.04 4 4.563 4H5.5a.5.5 0 0 1 0 1h-.875c-.604 0-.836.002-1.02.037-.802.154-1.413.752-1.568 1.496-.035.17-.037.385-.037.967 0 .583.002.798.037.967Zm10.925-1.934a1.935 1.935 0 0 0-1.301-1.426l.76-.76a2.91 2.91 0 0 1 1.52 1.983c.059.283.059.61.059 1.107v.126c0 .497 0 .824-.059 1.107-.24 1.16-1.18 2.05-2.36 2.275-.288.055-.623.055-1.146.055H9.5a.5.5 0 1 1 0-1h.875c.604 0 .835-.002 1.019-.037.803-.154 1.414-.752 1.568-1.496.035-.17.038-.384.038-.967 0-.582-.003-.798-.038-.967Z",
        fill: "#000"
    })
});
var smart_button = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 5h11a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1ZM0 6a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6Zm4.5.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm2.25.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm3.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z",
        fill: "#000"
    })
});
var envelopeIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    width: "15",
    height: "15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M1 2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H1Zm0 1h13v.925a.448.448 0 0 0-.241.07L7.5 7.967 1.241 3.995A.448.448 0 0 0 1 3.925V3Zm0 1.908V12h13V4.908L7.741 8.88a.45.45 0 0 1-.482 0L1 4.908Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    })
});
var targetIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    width: "15",
    height: "15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M.9 7.5a6.6 6.6 0 1 1 13.2 0 6.6 6.6 0 0 1-13.2 0Zm6.6-5.7a5.7 5.7 0 1 0 0 11.4 5.7 5.7 0 0 0 0-11.4ZM3.075 7.5a4.425 4.425 0 1 1 8.85 0 4.425 4.425 0 0 1-8.85 0ZM7.5 3.925a3.575 3.575 0 1 0 0 7.15 3.575 3.575 0 0 0 0-7.15Zm0 1.325a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM6.05 7.5a1.45 1.45 0 1 1 2.9 0 1.45 1.45 0 0 1-2.9 0Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    })
});
var image = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
        fill: "currentColor"
    })
});
var EditorIcons = {
    format_bold: format_bold,
    format_italic: format_italic,
    format_underlined: format_underlined,
    code: code,
    text: text,
    headings: headings,
    looks_one: looks_one,
    looks_two: looks_two,
    format_quote: format_quote,
    format_list_bulleted: format_list_bulleted,
    format_list_numbered: format_list_numbered,
    format_align_left: format_align_left,
    format_align_center: format_align_center,
    format_align_right: format_align_right,
    format_align_justify: format_align_justify,
    align_top: align_top,
    align_middle: align_middle,
    align_bottom: align_bottom,
    rotate_box: rotate_box,
    rotate: rotate,
    source: source,
    link: link,
    link_off: link_off,
    smart_button: smart_button,
    plus: _EditIcons__WEBPACK_IMPORTED_MODULE_2__/* .circlePlus */ .Tw,
    envelopeIcon: envelopeIcon,
    targetIcon: targetIcon
};

var EditorIcon = function(param) {
    var icon = param.icon;
    return hasAttr(EditorIcons, icon) ? EditorIcons[icon] : null;
};
/* harmony default export */ __webpack_exports__["ZP"] = (EditorIcons);


/***/ }),

/***/ 99559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$N": function() { return /* binding */ elementIcon; },
/* harmony export */   "Xt": function() { return /* binding */ NumList; },
/* harmony export */   "t4": function() { return /* binding */ LocalizedTextIcon; },
/* harmony export */   "tl": function() { return /* binding */ elementIcons; },
/* harmony export */   "zB": function() { return /* binding */ GalleryIcon; }
/* harmony export */ });
/* unused harmony exports ImageSliderIcon, HorizontalStack, VerticalStack, icons */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77298);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62570);
/* harmony import */ var _EditIcons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75679);





var AccordionGroupIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16px",
        height: "16px",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12 5.8c0 .1-.2.2-.5.2h-10c-.3 0-.5-.1-.5-.2V3.2c0-.1.2-.2.5-.2h10c.3 0 .5.1.5.2v2.6ZM13 1v5c0 .6-.7 1-1.5 1h-10C.7 7 0 6.6 0 6V1c0-.5.2-1 1-1h11c.8 0 1 .5 1 1ZM1.5 2v-.5c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5V2h-10Z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M13 6v3H0V6h13Zm-1 1H1v1h11V7Z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M13 8v3H0V8h13Zm-1 1H1v1h11V9Z"
                })
            ]
        })
    });
};
var AccordionIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "13",
        height: "8",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 6.7c0 .2-.2.3-.5.3h-10c-.3 0-.5-.1-.5-.3V3.3c0-.2.2-.3.5-.3h10c.3 0 .5.1.5.3v3.4Zm1-5.6v5.8c0 .6-.7 1.1-1.5 1.1h-10C.7 8 0 7.5 0 7V1c0-.4.2-1 1-1h11c.8 0 1 .6 1 1ZM1.5 2v-.5c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5V2h-10Z",
            fillRule: "evenodd"
        })
    });
};
var TabHeaderIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "13",
        height: "7",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 7H1V3h10.5c.3 0 .5.1.5.3V7Zm1-6v6H0V1c0-.5.2-1 1-1h11c.8 0 1 .5 1 1ZM1 3V2l.1-1H4v1.4c0 .3.3.6.6.6H1Zm4-1v-.5l.1-.5H8l.1.5V2H5Zm4 0v-.5l.1-.5H12l.1.5V2H9Z",
            fillRule: "evenodd"
        })
    });
};
var TabsIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "13",
        height: "11",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 9.5c0 .3-.2.5-.5.5h-10a.5.5 0 0 1-.5-.5V3h10.5c.3 0 .5.2.5.5v6Zm1-8v8c0 .8-.7 1.5-1.5 1.5h-10C.7 11 0 10.3 0 9.5v-8C0 .8.2 0 1 0h11c.8 0 1 .8 1 1.5ZM1 3V2l.1-1H4v1.4c0 .3.3.6.6.6H1Zm4-1v-.5l.1-.5H8l.1.5V2H5Zm4 0v-.5l.1-.5H12l.1.5V2H9Z",
            fillRule: "evenodd"
        })
    });
};
var ColumnIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "6",
        height: "13",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1 12h4V2.1C5 1.5 4.8 1 4.6 1H1v11ZM6 1.5C6 .7 5.7 0 5.3 0H.7C.3 0 0 .7 0 1.5v10c0 .8.3 1.5.7 1.5h4.6c.4 0 .7-.7.7-1.5v-10Z",
            fillRule: "evenodd"
        })
    });
};
var ImageSliderIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "22",
        height: "11",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.7 1h4.6c.4 0 .7.3.7.7v4.6c0 .4-.3.7-.7.7h-4.6a.7.7 0 0 1-.7-.7V1.7c0-.4.3-.7.7-.7Zm0 .5c-.1 0-.2 0-.2.2v2.7l.7-.8a.2.2 0 0 1 .3 0l1.7 1.8 1 1.1h1c.2 0 .3-.1.3-.3V1.7c0-.1 0-.2-.2-.2h-4.6Zm-.2 4.8V5l.9-1L19 5.9l.7.7h-3a.2.2 0 0 1-.2-.2Zm3.1-3.2a.4.4 0 1 1 .8 0 .4.4 0 0 1-.8 0Zm.4-.8a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6ZM5.3 1H.7c-.4 0-.7.3-.7.7v4.6c0 .4.3.7.7.7h4.6c.4 0 .7-.3.7-.7V1.7c0-.4-.3-.7-.7-.7Zm0 .5c.1 0 .2 0 .2.2v2.7l-.7-.8a.2.2 0 0 0-.3 0L2.8 5.4l-1 1.1h-1a.3.3 0 0 1-.3-.3V1.7c0-.1 0-.2.2-.2h4.6Zm.2 4.8V5l-.9-1L3 5.9l-.7.7h3c.1 0 .2 0 .2-.2ZM2.4 3.1a.4.4 0 1 0-.8 0 .4.4 0 0 0 .8 0ZM2 2.3a.8.8 0 1 1 0 1.6.8.8 0 0 1 0-1.6ZM14 0H8a1 1 0 0 0-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1Zm0 .6c.2 0 .4.2.4.3v6.2c0 .2-.1.3-.3.3H7.9a.3.3 0 0 1-.3-.3V.9L8 .6h6.2Zm-2.5 3.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Zm-.5-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8.6 11c.3 0 .6-.2.6-.5s-.3-.5-.6-.5-.6.2-.6.5.3.5.6.5Zm2.4 0c.3 0 .6-.2.6-.5s-.3-.5-.6-.5-.6.2-.6.5.3.5.6.5Zm2.4 0c.3 0 .6-.2.6-.5s-.3-.5-.6-.5-.6.2-.6.5.3.5.6.5Z",
            fillRrule: "evenodd"
        })
    });
};
var NumList = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "11",
        viewBox: "0 0 1352 829",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "currentcolor",
            fillRule: "evenodd",
            d: "M352 103c0-30 30-60 50-60h899.999998c27.61424 0 50 22.385762 50 50 0 27.614237-22.38576 50-50 50H402c-27.614237 0-50-22.385763-50-50v10Zm50 250c-27.614237 0-50 22.385763-50 50s22.385763 50 50 50h899.999998c27.61424 0 50-22.385763 50-50s-22.38576-50-50-50H402Zm0 300c-27.614237 0-50 22.385763-50 50s22.385763 50 50 50h899.999998c27.61424 0 50-22.385763 50-50s-22.38576-50-50-50H402ZM63.683787 22.16065C13.328305 47.658368-1.948076 65.790078 5.97301 88.454716c2.82896 8.49924 12.447423 18.698327 21.500094 23.231255 14.144798 6.799391 18.671134 6.232775 35.0791-1.699848l19.236925-9.065856v113.889807c0 42.922777.236957 78.499135.710871 106.729073 0 4.9213 12.529455 7.38195 37.588364 7.38195 27.274424 0 40.911636-2.46065 40.911636-7.38195V176.846805c0-147.886764-.565792-155.819387-11.315838-166.58509C133.276195-6.170148 112.907686-3.337068 63.683788 22.16065ZM7.63909 554.413486c0 13.587786 26.057563 36.800254 41.918688 36.800254 8.497031 0 19.259937-6.793893 28.889906-18.683206 19.259937-22.080152 30.022844-26.609414 47.016906-19.249364 28.889906 13.021629 23.225219 27.175573-45.3175 118.89313C-8.222036 789.368957-8.222036 789.368957 10.57382 817.593234c10.315904 11.406792 10.315904 11.406792 101.861989 11.406792 91.546085 0 83.270906-.566184 96.299687-14.15397 8.497031-19.261844 10.717615-31.374402 2.265875-50.388041-10.762906-13.587786-15.294656-14.720102-50.982187-14.720102H120.36637l33.421656-44.160305c66.276844-87.188295 75.340344-109.268448 63.4445-153.428753-7.364093-28.307888-35.687531-61.711196-60.612156-71.902036-20.959343-9.058524-66.276843-9.624682-86.669718-1.698473-27.756969 11.323155-62.311563 53.21883-62.311563 75.86514Z"
        })
    });
};
var LocalizedTextIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 16 10",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Icons",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "letter-case-capitalize",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M3.68979003,2.5894786e-07 C3.89667003,-0.000209481463 4.08232003,0.127010519 4.15679003,0.320030519 L7.36662003,8.64000052 C7.46602003,8.89770052 7.33774003,9.18710052 7.08010003,9.28650052 C6.82247003,9.38590052 6.53304003,9.25760052 6.43365003,9.00000026 L5.38250003,6.27537052 L2.01133003,6.27537052 L0.966992029,8.99900052 C0.868128029,9.25680052 0.578964029,9.38570052 0.321126029,9.28690052 C0.063287829,9.18800052 -0.065586371,8.89880052 0.033277429,8.64100052 L3.22344003,0.320990519 C3.29751003,0.127820519 3.48290003,0.000210518537 3.68979003,2.5894786e-07 Z M3.69174003,1.89284052 L5.05458003,5.42537052 L2.33724003,5.42537052 L3.69174003,1.89284052 Z",
                        id: "Shape",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        id: "文",
                        transform: "translate(8.000000, 1.000000)",
                        fill: "currentColor",
                        fillRule: "nonzero",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M0.155507559,1.47868505 L0.155507559,2.39406151 L1.46868251,2.39406151 C1.83153348,3.67030753 2.47948164,4.78812301 3.412527,5.75630965 C2.51403888,6.53085896 1.37365011,7.09416755 0,7.45503712 L0.483801296,8.26479321 C1.89200864,7.85991516 3.08423326,7.2173913 4.05183585,6.34602333 C4.96760259,7.12057264 6.11663067,7.7718982 7.49892009,8.3 L8,7.51664899 C6.68682505,7.02375398 5.58099352,6.4252386 4.69114471,5.70349947 C5.48596112,4.8145281 6.09071274,3.71431601 6.50539957,2.39406151 L7.80993521,2.39406151 L7.80993521,1.47868505 L4.54427646,1.47868505 C4.28509719,0.906574761 4,0.413679745 3.68898488,0 L2.78185745,0.334464475 C3.09287257,0.69533404 3.36069114,1.073807 3.57667387,1.47868505 L0.155507559,1.47868505 Z M2.33261339,2.39406151 L5.57235421,2.39406151 C5.23542117,3.45906681 4.72570194,4.37444327 4.05183585,5.13138918 C3.25701944,4.33923648 2.68682505,3.43266172 2.33261339,2.39406151 Z",
                            id: "Shape"
                        })
                    })
                ]
            })
        })
    });
};
var GalleryIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "13",
        height: "13",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.7 7h4.6c.39 0 .7.31.7.7v4.6a.7.7 0 0 1-.7.7H7.7a.7.7 0 0 1-.7-.7V7.7c0-.39.31-.7.7-.7Zm0 .46c-.14 0-.24.1-.24.23v2.7l.78-.77a.2.2 0 0 1 .3 0l1.63 1.76.94 1.16h1.13a.3.3 0 0 0 .3-.3V7.69c0-.13-.1-.23-.23-.23H7.69Zm-.24 4.85v-1.32l.92-.92L10 11.82l.66.72H7.69a.23.23 0 0 1-.23-.23Zm3.15-3.23a.4.4 0 1 1 .78 0 .4.4 0 0 1-.78 0Zm.39-.81a.8.8 0 1 0 0 1.61.8.8 0 0 0 0-1.61ZM5.3 0H.7a.7.7 0 0 0-.7.7v4.6c0 .39.31.7.7.7h4.6a.7.7 0 0 0 .7-.7V.7a.7.7 0 0 0-.7-.7Zm0 .46c.14 0 .24.1.24.23v2.7l-.78-.77a.2.2 0 0 0-.3 0L2.83 4.39l-.94 1.16H.76a.3.3 0 0 1-.3-.3V.69C.46.56.56.46.7.46h4.62Zm.24 4.85V3.99l-.92-.92L3 4.82l-.66.72h2.98c.13 0 .23-.1.23-.23ZM2.39 2.08a.4.4 0 1 0-.78 0 .4.4 0 0 0 .78 0ZM2 1.27a.8.8 0 1 1 0 1.61.8.8 0 0 1 0-1.61ZM5.3 7H.7a.7.7 0 0 0-.7.7v4.6c0 .39.31.7.7.7h4.6a.7.7 0 0 0 .7-.7V7.7a.7.7 0 0 0-.7-.7Zm0 .46c.14 0 .24.1.24.23v4.55a.3.3 0 0 1-.3.3H.76a.3.3 0 0 1-.3-.3V7.69c0-.13.1-.23.23-.23h4.62Zm-1.9 2.62a.4.4 0 1 0-.8 0 .4.4 0 0 0 .8 0ZM3 9.27a.8.8 0 1 1 0 1.61.8.8 0 0 1 0-1.61ZM12.3 0H7.7a.7.7 0 0 0-.7.7v4.6c0 .39.31.7.7.7h4.6a.7.7 0 0 0 .7-.7V.7a.7.7 0 0 0-.7-.7Zm0 .46c.14 0 .24.1.24.23v4.55a.3.3 0 0 1-.3.3H7.76a.3.3 0 0 1-.3-.3V.69c0-.13.1-.23.23-.23h4.62Zm-1.9 2.62a.4.4 0 1 0-.8 0 .4.4 0 0 0 .8 0Zm-.4-.81a.8.8 0 1 1 0 1.61.8.8 0 0 1 0-1.61Z"
        })
    });
};
var HorizontalStack = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "13px",
        height: "13px",
        viewBox: "0 0 13 13",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Icons",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "vertical_stack",
                transform: "translate(6.500000, 6.500000) rotate(90.000000) translate(-6.500000, -6.500000) ",
                fill: "#000000",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12,12 L12,8 L2.1,8 C1.492492,8 1,8.179088 1,8.4 L1,12 L12,12 Z M1.5,7 C0.67157,7 0,7.30995538 0,7.69230769 L0,12.3076923 C0,12.6900308 0.67157,13 1.5,13 L11.5,13 C12.3284,13 13,12.6900308 13,12.3076923 L13,7.69230769 C13,7.30995538 12.3284,7 11.5,7 L1.5,7 Z",
                        id: "Shape"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12,5 L12,1 L2.1,1 C1.492492,1 1,1.179088 1,1.4 L1,5 L12,5 Z M1.5,0 C0.67157,0 0,0.309955385 0,0.692307692 L0,5.30769231 C0,5.69003077 0.67157,6 1.5,6 L11.5,6 C12.3284,6 13,5.69003077 13,5.30769231 L13,0.692307692 C13,0.309955385 12.3284,0 11.5,0 L1.5,0 Z",
                        id: "Shape"
                    })
                ]
            })
        })
    });
};
var VerticalStack = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "13px",
        height: "13px",
        viewBox: "0 0 13 13",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Icons",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "vertical_stack",
                fill: "#000000",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12,12 L12,8 L2.1,8 C1.492492,8 1,8.179088 1,8.4 L1,12 L12,12 Z M1.5,7 C0.67157,7 0,7.30995538 0,7.69230769 L0,12.3076923 C0,12.6900308 0.67157,13 1.5,13 L11.5,13 C12.3284,13 13,12.6900308 13,12.3076923 L13,7.69230769 C13,7.30995538 12.3284,7 11.5,7 L1.5,7 Z",
                        id: "Shape"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12,5 L12,1 L2.1,1 C1.492492,1 1,1.179088 1,1.4 L1,5 L12,5 Z M1.5,0 C0.67157,0 0,0.309955385 0,0.692307692 L0,5.30769231 C0,5.69003077 0.67157,6 1.5,6 L11.5,6 C12.3284,6 13,5.69003077 13,5.30769231 L13,0.692307692 C13,0.309955385 12.3284,0 11.5,0 L1.5,0 Z",
                        id: "Shape"
                    })
                ]
            })
        })
    });
};
var elementIcon = function(type) {
    return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_2__/* .hasAttr */ .B$)(elementIcons, type) ? elementIcons[type] : elementIcons.unknown;
};
var icons = {
    visual: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .LetterCaseCapitalizeIcon */ .I6k, {}),
    translated: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocalizedTextIcon, {}),
    localizedtext: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocalizedTextIcon, {}),
    heading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .HeadingIcon */ .bHp, {}),
    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .HeadingIcon */ .bHp, {}),
    text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .TextIcon */ .VL1, {}),
    textarea: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .TextAlignLeftIcon */ .rrd, {}),
    email: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .EnvelopeClosedIcon */ ._MN, {}),
    number: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .Cross2Icon */ .Pxu, {}),
    imageslider: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageSliderIcon, {}),
    "archive": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            d: "M3.309 1a1 1 0 0 0-.894.553L1.053 4.276A.5.5 0 0 0 1 4.5V13a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V4.5a.5.5 0 0 0-.053-.224l-1.362-2.723A1 1 0 0 0 11.691 1H3.309Zm0 1H7v2H2.309l1-2ZM8 4V2h3.691l1 2H8Zm-.5 1H13v8H2V5h5.5Zm-2 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z",
            fill: "#000"
        })
    }),
    "row": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9 2H6v11h3V2Zm1 0v11h2.5a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5H10ZM2.5 2H5v11H2.5a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5Zm0-1A1.5 1.5 0 0 0 1 2.5v10A1.5 1.5 0 0 0 2.5 14h10a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 12.5 1h-10Z",
            fill: "#000"
        })
    }),
    container: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .SectionIcon */ .UDV, {}),
    repeater: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .LoopIcon */ .DjT, {}),
    stack: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .CardStackIcon */ .$9P, {}),
    "add": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.5.877a6.623 6.623 0 1 0 0 13.246A6.623 6.623 0 0 0 7.5.877ZM1.827 7.5a5.673 5.673 0 1 1 11.346 0 5.673 5.673 0 0 1-11.346 0ZM7.5 4a.5.5 0 0 1 .5.5V7h2.5a.5.5 0 1 1 0 1H8v2.5a.5.5 0 0 1-1 0V8H4.5a.5.5 0 0 1 0-1H7V4.5a.5.5 0 0 1 .5-.5Z",
            fill: "#000"
        })
    }),
    input: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .InputIcon */ .SQj, {}),
    button: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ButtonIcon */ .Eik, {}),
    slider: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .SliderIcon */ .j9w, {}),
    radio: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .RadiobuttonIcon */ .Fds, {}),
    checkbox: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .CheckboxIcon */ .PDu, {}),
    switch: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .SwitchIcon */ .URn, {}),
    select: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .DropdownMenuIcon */ .$Pd, {}),
    gallery: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GalleryIcon, {}),
    image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ImageIcon */ .XBm, {}),
    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .StarIcon */ .r7p, {}),
    link: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .Link2Icon */ .qDj, {}),
    relation: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .Link2Icon */ .qDj, {}),
    external: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ExternalLinkIcon */ .h0n, {}),
    file: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .FileIcon */ .aAW, {}),
    color: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .BlendingModeIcon */ .EGi, {}),
    id: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .Component1Icon */ .JMc, {}),
    component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ComponentInstanceIcon */ .dgb, {}),
    video: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .VideoIcon */ .Odl, {}),
    horizontalstack: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HorizontalStack, {}),
    verticalstack: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VerticalStack, {}),
    columns: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ColumnsIcon */ .SeN, {}),
    column: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ColumnIcon, {}),
    tabs: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabsIcon, {}),
    tabheader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabHeaderIcon, {}),
    tab: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .SquareIcon */ .Ps4, {}),
    expanders: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccordionGroupIcon, {}),
    expander: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        style: {
            transform: "rotate(180deg)"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .CardStackIcon */ .$9P, {})
    }),
    expanderheader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccordionIcon, {}),
    dialog: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .SizeIcon */ .el1, {}),
    form: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .InputIcon */ .SQj, {}),
    accordion: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccordionIcon, {}),
    panel: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .QuestionMarkCircledIcon */ .pjG, {}),
    menu: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .PinTopIcon */ .hNW, {}),
    list: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ListBulletIcon */ .jVc, {}),
    table: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .TableIcon */ .$eq, {}),
    chart: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .BarChartIcon */ .eJP, {}),
    pie: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .PieChartIcon */ .ngI, {}),
    timer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .TimerIcon */ .ANZ, {}),
    time: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .TimerIcon */ .ANZ, {}),
    calendar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .CalendarIcon */ .Que, {}),
    "date-time": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .CalendarIcon */ .Que, {}),
    date: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .CalendarIcon */ .Que, {}),
    layout: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ViewGridIcon */ .XOb, {}),
    grid: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .GridIcon */ .pso, {}),
    code: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .CodeIcon */ .dNJ, {}),
    script: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .CodeIcon */ .dNJ, {}),
    help: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .QuestionMarkIcon */ .AMp, {}),
    "hidden": _EditIcons__WEBPACK_IMPORTED_MODULE_3__/* .hide */ .Cp,
    "trans": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            opacity: ".25",
            d: "M0 0h3v3H0V0Zm6 3H3v3H0v3h3v3H0v3h3v-3h3v3h3v-3h3v3h3v-3h-3V9h3V6h-3V3h3V0h-3v3H9V0H6v3Zm0 3V3h3v3H6Zm0 3H3V6h3v3Zm3 0V6h3v3H9Zm0 0H6v3h3V9Z",
            fill: "#000"
        })
    }),
    "unknown": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.803 7.146a.5.5 0 1 1 .707.708.5.5 0 0 1-.707-.708Zm-.707 1.415a.5.5 0 1 1-.707.707.5.5 0 0 1 .707-.707Zm-1.414 1.414a.5.5 0 1 1-.707.707.5.5 0 0 1 .707-.707Zm-1.414 1.414a.5.5 0 1 1-.707.707.5.5 0 0 1 .707-.707ZM7.146 13.51a.5.5 0 1 1 .708-.707.5.5 0 0 1-.708.707ZM2.904 8.56a.5.5 0 1 0 .707.708.5.5 0 0 0-.707-.707ZM4.318 9.975a.5.5 0 1 0 .707.707.5.5 0 0 0-.707-.707ZM5.732 11.39a.5.5 0 1 0 .707.706.5.5 0 0 0-.707-.707ZM2.197 7.854a.5.5 0 0 0 .064-.63.506.506 0 0 0-.771-.078.5.5 0 0 0 .707.708ZM3.611 5.732a.5.5 0 1 0-.707.707.5.5 0 0 0 .707-.707ZM5.025 4.318a.5.5 0 1 0-.707.707.5.5 0 0 0 .707-.707ZM6.44 2.904a.5.5 0 1 0-.708.707.5.5 0 0 0 .707-.707ZM7.854 1.49a.5.5 0 1 0-.708.707.5.5 0 0 0 .708-.707ZM9.268 2.904a.5.5 0 1 0-.707.707.5.5 0 0 0 .707-.707ZM10.682 4.318a.5.5 0 1 0-.707.707.5.5 0 0 0 .707-.707ZM12.096 5.732a.5.5 0 1 0-.707.707.5.5 0 0 0 .707-.707Z",
            fill: "#000"
        })
    })
};
var elementIcons = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, icons);


/***/ }),

/***/ 87308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bn": function() { return /* binding */ largeCircle; },
/* harmony export */   "Hw": function() { return /* binding */ infoCircle; },
/* harmony export */   "MW": function() { return /* binding */ arrowDownIcon; },
/* harmony export */   "nj": function() { return /* binding */ arrowRightIcon; },
/* harmony export */   "pv": function() { return /* binding */ helpCircle; }
/* harmony export */ });
/* unused harmony exports smallCircle, smallMark, questionMark, smallInfo, arrowUpIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var smallCircle = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 15 15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.877075 7.49972C0.877075 3.84204 3.84222 0.876892 7.49991 0.876892C11.1576 0.876892 14.1227 3.84204 14.1227 7.49972C14.1227 11.1574 11.1576 14.1226 7.49991 14.1226C3.84222 14.1226 0.877075 11.1574 0.877075 7.49972ZM7.49991 1.82689C4.36689 1.82689 1.82708 4.36671 1.82708 7.49972C1.82708 10.6327 4.36689 13.1726 7.49991 13.1726C10.6329 13.1726 13.1727 10.6327 13.1727 7.49972C13.1727 4.36671 10.6329 1.82689 7.49991 1.82689ZM8.24993 10.5C8.24993 10.9142 7.91414 11.25 7.49993 11.25C7.08571 11.25 6.74993 10.9142 6.74993 10.5C6.74993 10.0858 7.08571 9.75 7.49993 9.75C7.91414 9.75 8.24993 10.0858 8.24993 10.5ZM6.05003 6.25C6.05003 5.57211 6.63511 4.925 7.50003 4.925C8.36496 4.925 8.95003 5.57211 8.95003 6.25C8.95003 6.74118 8.68002 6.99212 8.21447 7.27494C8.16251 7.30651 8.10258 7.34131 8.03847 7.37854L8.03841 7.37858C7.85521 7.48497 7.63788 7.61119 7.47449 7.73849C7.23214 7.92732 6.95003 8.23198 6.95003 8.7C6.95004 9.00376 7.19628 9.25 7.50004 9.25C7.8024 9.25 8.04778 9.00601 8.05002 8.70417L8.05056 8.7033C8.05924 8.6896 8.08493 8.65735 8.15058 8.6062C8.25207 8.52712 8.36508 8.46163 8.51567 8.37436L8.51571 8.37433C8.59422 8.32883 8.68296 8.27741 8.78559 8.21506C9.32004 7.89038 10.05 7.35382 10.05 6.25C10.05 4.92789 8.93511 3.825 7.50003 3.825C6.06496 3.825 4.95003 4.92789 4.95003 6.25C4.95003 6.55376 5.19628 6.8 5.50003 6.8C5.80379 6.8 6.05003 6.55376 6.05003 6.25Z",
        fill: "black"
    })
});
var helpCircle = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.877075 7.49972C0.877075 3.84204 3.84222 0.876892 7.49991 0.876892C11.1576 0.876892 14.1227 3.84204 14.1227 7.49972C14.1227 11.1574 11.1576 14.1226 7.49991 14.1226C3.84222 14.1226 0.877075 11.1574 0.877075 7.49972ZM7.49991 1.82689C4.36689 1.82689 1.82708 4.36671 1.82708 7.49972C1.82708 10.6327 4.36689 13.1726 7.49991 13.1726C10.6329 13.1726 13.1727 10.6327 13.1727 7.49972C13.1727 4.36671 10.6329 1.82689 7.49991 1.82689ZM8.24993 10.5C8.24993 10.9142 7.91414 11.25 7.49993 11.25C7.08571 11.25 6.74993 10.9142 6.74993 10.5C6.74993 10.0858 7.08571 9.75 7.49993 9.75C7.91414 9.75 8.24993 10.0858 8.24993 10.5ZM6.05003 6.25C6.05003 5.57211 6.63511 4.925 7.50003 4.925C8.36496 4.925 8.95003 5.57211 8.95003 6.25C8.95003 6.74118 8.68002 6.99212 8.21447 7.27494C8.16251 7.30651 8.10258 7.34131 8.03847 7.37854L8.03841 7.37858C7.85521 7.48497 7.63788 7.61119 7.47449 7.73849C7.23214 7.92732 6.95003 8.23198 6.95003 8.7C6.95004 9.00376 7.19628 9.25 7.50004 9.25C7.8024 9.25 8.04778 9.00601 8.05002 8.70417L8.05056 8.7033C8.05924 8.6896 8.08493 8.65735 8.15058 8.6062C8.25207 8.52712 8.36508 8.46163 8.51567 8.37436L8.51571 8.37433C8.59422 8.32883 8.68296 8.27741 8.78559 8.21506C9.32004 7.89038 10.05 7.35382 10.05 6.25C10.05 4.92789 8.93511 3.825 7.50003 3.825C6.06496 3.825 4.95003 4.92789 4.95003 6.25C4.95003 6.55376 5.19628 6.8 5.50003 6.8C5.80379 6.8 6.05003 6.55376 6.05003 6.25Z",
        fill: "black"
    })
});
var largeCircle = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    className: "largeCircleHelp",
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "22",
    viewBox: "0 0 15 15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.877075 7.49972C0.877075 3.84204 3.84222 0.876892 7.49991 0.876892C11.1576 0.876892 14.1227 3.84204 14.1227 7.49972C14.1227 11.1574 11.1576 14.1226 7.49991 14.1226C3.84222 14.1226 0.877075 11.1574 0.877075 7.49972ZM7.49991 1.82689C4.36689 1.82689 1.82708 4.36671 1.82708 7.49972C1.82708 10.6327 4.36689 13.1726 7.49991 13.1726C10.6329 13.1726 13.1727 10.6327 13.1727 7.49972C13.1727 4.36671 10.6329 1.82689 7.49991 1.82689ZM8.24993 10.5C8.24993 10.9142 7.91414 11.25 7.49993 11.25C7.08571 11.25 6.74993 10.9142 6.74993 10.5C6.74993 10.0858 7.08571 9.75 7.49993 9.75C7.91414 9.75 8.24993 10.0858 8.24993 10.5ZM6.05003 6.25C6.05003 5.57211 6.63511 4.925 7.50003 4.925C8.36496 4.925 8.95003 5.57211 8.95003 6.25C8.95003 6.74118 8.68002 6.99212 8.21447 7.27494C8.16251 7.30651 8.10258 7.34131 8.03847 7.37854L8.03841 7.37858C7.85521 7.48497 7.63788 7.61119 7.47449 7.73849C7.23214 7.92732 6.95003 8.23198 6.95003 8.7C6.95004 9.00376 7.19628 9.25 7.50004 9.25C7.8024 9.25 8.04778 9.00601 8.05002 8.70417L8.05056 8.7033C8.05924 8.6896 8.08493 8.65735 8.15058 8.6062C8.25207 8.52712 8.36508 8.46163 8.51567 8.37436L8.51571 8.37433C8.59422 8.32883 8.68296 8.27741 8.78559 8.21506C9.32004 7.89038 10.05 7.35382 10.05 6.25C10.05 4.92789 8.93511 3.825 7.50003 3.825C6.06496 3.825 4.95003 4.92789 4.95003 6.25C4.95003 6.55376 5.19628 6.8 5.50003 6.8C5.80379 6.8 6.05003 6.55376 6.05003 6.25Z",
        fill: "black"
    })
});
var smallMark = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M5.07505 4.10001C5.07505 2.91103 6.25727 1.92502 7.50005 1.92502C8.74283 1.92502 9.92505 2.91103 9.92505 4.10001C9.92505 5.19861 9.36782 5.71436 8.61854 6.37884L8.58757 6.4063C7.84481 7.06467 6.92505 7.87995 6.92505 9.5C6.92505 9.81757 7.18248 10.075 7.50005 10.075C7.81761 10.075 8.07505 9.81757 8.07505 9.5C8.07505 8.41517 8.62945 7.90623 9.38156 7.23925L9.40238 7.22079C10.1496 6.55829 11.075 5.73775 11.075 4.10001C11.075 2.12757 9.21869 0.775024 7.50005 0.775024C5.7814 0.775024 3.92505 2.12757 3.92505 4.10001C3.92505 4.41758 4.18249 4.67501 4.50005 4.67501C4.81761 4.67501 5.07505 4.41758 5.07505 4.10001ZM7.50005 13.3575C7.9833 13.3575 8.37505 12.9657 8.37505 12.4825C8.37505 11.9992 7.9833 11.6075 7.50005 11.6075C7.0168 11.6075 6.62505 11.9992 6.62505 12.4825C6.62505 12.9657 7.0168 13.3575 7.50005 13.3575Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    })
});
var questionMark = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M5.07505 4.10001C5.07505 2.91103 6.25727 1.92502 7.50005 1.92502C8.74283 1.92502 9.92505 2.91103 9.92505 4.10001C9.92505 5.19861 9.36782 5.71436 8.61854 6.37884L8.58757 6.4063C7.84481 7.06467 6.92505 7.87995 6.92505 9.5C6.92505 9.81757 7.18248 10.075 7.50005 10.075C7.81761 10.075 8.07505 9.81757 8.07505 9.5C8.07505 8.41517 8.62945 7.90623 9.38156 7.23925L9.40238 7.22079C10.1496 6.55829 11.075 5.73775 11.075 4.10001C11.075 2.12757 9.21869 0.775024 7.50005 0.775024C5.7814 0.775024 3.92505 2.12757 3.92505 4.10001C3.92505 4.41758 4.18249 4.67501 4.50005 4.67501C4.81761 4.67501 5.07505 4.41758 5.07505 4.10001ZM7.50005 13.3575C7.9833 13.3575 8.37505 12.9657 8.37505 12.4825C8.37505 11.9992 7.9833 11.6075 7.50005 11.6075C7.0168 11.6075 6.62505 11.9992 6.62505 12.4825C6.62505 12.9657 7.0168 13.3575 7.50005 13.3575Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    })
});
var smallInfo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z",
        fill: "#000",
        fillRule: "evenodd",
        clipRule: "evenodd"
    })
});
var infoCircle = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z",
        fill: "#000",
        fillRule: "evenodd",
        clipRule: "evenodd"
    })
});
var arrowDownIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    version: "1.1",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M4.18179,6.18181c0.17574,-0.17573 0.46066,-0.17573 0.6364,0l2.6818,2.68181l2.68181,-2.68181c0.1757,-0.17573 0.4606,-0.17573 0.6364,0c0.1757,0.17574 0.1757,0.46066 0,0.6364l-3.00001,3c-0.0844,0.08439 -0.19885,0.1318 -0.3182,0.1318c-0.11935,0 -0.23381,-0.04741 -0.3182,-0.1318l-3,-3c-0.17574,-0.17574 -0.17574,-0.46066 0,-0.6364Z",
        fill: "#000",
        fillRule: "evenodd"
    })
});
var arrowUpIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    version: "1.1",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M4.18179,8.81819c-0.17574,-0.17574 -0.17574,-0.46066 0,-0.6364l3,-3c0.08439,-0.08439 0.19885,-0.1318 0.3182,-0.1318c0.11934,0 0.2338,0.04741 0.3182,0.1318l3.00001,3c0.1757,0.17574 0.1757,0.46066 0,0.6364c-0.1758,0.17573 -0.4607,0.17573 -0.6364,0l-2.68181,-2.68181l-2.6818,2.68181c-0.17574,0.17573 -0.46066,0.17573 -0.6364,0Z",
        fill: "#000",
        fillRule: "evenodd"
    })
});
var arrowRightIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    version: "1.1",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M8.14645,3.14645c0.19526,-0.19527 0.51184,-0.19527 0.7071,0l4.00005,4c0.1952,0.19526 0.1952,0.51184 0,0.7071l-4.00005,4.00005c-0.19526,0.1952 -0.51184,0.1952 -0.7071,0c-0.19527,-0.1953 -0.19527,-0.5119 0,-0.7072l3.14645,-3.1464h-8.7929c-0.27614,0 -0.5,-0.22386 -0.5,-0.5c0,-0.27614 0.22386,-0.5 0.5,-0.5h8.7929l-3.14645,-3.14645c-0.19527,-0.19526 -0.19527,-0.51184 0,-0.7071Z",
        fill: "#000",
        fillRule: "evenodd"
    })
});
var HelpIcons = {
    smallCircle: smallCircle,
    helpCircle: helpCircle,
    largeCircle: largeCircle,
    smallMark: smallMark,
    questionMark: questionMark,
    smallInfo: smallInfo,
    infoCircle: infoCircle,
    arrowDownIcon: arrowDownIcon,
    arrowUpIcon: arrowUpIcon,
    arrowRightIcon: arrowRightIcon
};

/* harmony default export */ __webpack_exports__["ZP"] = (HelpIcons);


/***/ }),

/***/ 4956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ dragHandleIcon; },
/* harmony export */   "Fe": function() { return /* binding */ rulersIcon; },
/* harmony export */   "WQ": function() { return /* binding */ doubleArrowUpIcon; },
/* harmony export */   "_S": function() { return /* binding */ interactionIcon; },
/* harmony export */   "ej": function() { return /* binding */ cornersIcon; },
/* harmony export */   "lY": function() { return /* binding */ moveHandleIcon; }
/* harmony export */ });
/* unused harmony export bookmarkIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var cornersIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M10.1 3c.428 0 .72 0 .944.019.22.018.332.05.41.09a1 1 0 0 1 .437.437c.04.078.072.19.09.41.019.225.019.516.019.944v.6a.5.5 0 0 0 1 0v-.62c0-.403 0-.735-.022-1.006-.023-.281-.072-.54-.196-.782a2 2 0 0 0-.874-.874c-.243-.124-.501-.173-.782-.196C10.856 2 10.523 2 10.12 2H9.5a.5.5 0 0 0 0 1h.6ZM5.5 2h-.62c-.403 0-.735 0-1.006.022-.281.023-.54.072-.782.196a2 2 0 0 0-.874.874c-.124.243-.173.501-.196.782C2 4.144 2 4.477 2 4.88V5.5a.5.5 0 0 0 1 0v-.6c0-.428 0-.72.019-.944.018-.22.05-.332.09-.41a1 1 0 0 1 .437-.437c.078-.04.19-.072.41-.09C4.18 3 4.472 3 4.9 3h.6a.5.5 0 0 0 0-1ZM13 9.5a.5.5 0 0 0-1 0v.6c0 .428 0 .72-.019.944-.018.22-.05.332-.09.41a1 1 0 0 1-.437.437c-.078.04-.19.072-.41.09-.225.019-.516.019-.944.019h-.6a.5.5 0 0 0 0 1h.62c.403 0 .735 0 1.006-.022.281-.023.54-.072.782-.196a2 2 0 0 0 .874-.874c.124-.243.173-.501.196-.782.022-.27.022-.603.022-1.005V9.5ZM2.5 9a.5.5 0 0 1 .5.5v.6c0 .428 0 .72.019.944.018.22.05.332.09.41a1 1 0 0 0 .437.437c.078.04.19.072.41.09.225.019.516.019.944.019h.6a.5.5 0 0 1 0 1h-.62c-.403 0-.735 0-1.006-.022-.281-.023-.54-.072-.782-.196a2 2 0 0 1-.874-.874c-.124-.243-.173-.501-.196-.782C2 10.856 2 10.523 2 10.12V9.5a.5.5 0 0 1 .5-.5Z",
        fill: "#000"
    })
});
var rulersIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M.5 0a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V5h9.5a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5H.5ZM1 4.075V1h3.075v3.075H1Zm0 .85V14h3v-1.075H2.75a.425.425 0 1 1 0-.85H4v-1.15H2.25a.425.425 0 0 1 0-.85H4v-1.15H2.75a.425.425 0 1 1 0-.85H4v-1.15H2.75a.425.425 0 1 1 0-.85H4v-1.15H1ZM4.925 4h1.15V2.75a.425.425 0 0 1 .85 0V4h1.15V2.75a.425.425 0 0 1 .85 0V4h1.15V2.25a.425.425 0 1 1 .85 0V4h1.15V2.75a.425.425 0 0 1 .85 0V4H14V1H4.925v3Z",
        fill: "#000"
    })
});
var bookmarkIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.765.424L7.5 11.59l-3.735 2.334A.5.5 0 0 1 3 13.5v-11ZM4 3v9.598l2.97-1.856a1 1 0 0 1 1.06 0L11 12.598V3H4Z",
        fill: "#000"
    })
});
var interactionIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M8.697.04a.5.5 0 0 1 .296.542L8.09 6h4.41a.5.5 0 0 1 .4.8l-6 8a.5.5 0 0 1-.893-.382L6.91 9H2.5a.5.5 0 0 1-.4-.8l6-8a.5.5 0 0 1 .597-.16ZM3.5 8h4a.5.5 0 0 1 .493.582L7.33 12.56 11.5 7h-4a.5.5 0 0 1-.493-.582L7.67 2.44 3.5 8Z",
        fill: "#000"
    })
});
var dragHandleIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    width: "15",
    height: "15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M5.5 4.625a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm4 0a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM10.625 7.5a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0ZM5.5 8.625a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm5.125 2.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0ZM5.5 12.625a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    })
});
var moveHandleIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    width: "15",
    height: "15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M7.818.932a.45.45 0 0 0-.636 0l-1.75 1.75a.45.45 0 1 0 .636.636L7 2.386V5.5a.5.5 0 0 0 1 0V2.386l.932.932a.45.45 0 0 0 .636-.636L7.818.932ZM8 9.5a.5.5 0 0 0-1 0v3.114l-.932-.932a.45.45 0 0 0-.636.636l1.75 1.75a.45.45 0 0 0 .636 0l1.75-1.75a.45.45 0 0 0-.636-.636L8 12.614V9.5Zm1-2a.5.5 0 0 1 .5-.5h3.114l-.932-.932a.45.45 0 0 1 .636-.636l1.75 1.75a.45.45 0 0 1 0 .636l-1.75 1.75a.45.45 0 0 1-.636-.636L12.614 8H9.5a.5.5 0 0 1-.5-.5ZM3.318 6.068 2.386 7H5.5a.5.5 0 0 1 0 1H2.386l.932.932a.45.45 0 0 1-.636.636l-1.75-1.75a.45.45 0 0 1 0-.636l1.75-1.75a.45.45 0 1 1 .636.636Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    })
});
var doubleArrowUpIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    width: "15",
    height: "15",
    version: "1.1",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M11.1464,6.85355c0.1953,0.19527 0.5119,0.19527 0.7072,0c0.1952,-0.19526 0.1952,-0.51184 0,-0.7071l-4.00005,-4c-0.19526,-0.19527 -0.51184,-0.19527 -0.7071,0l-4,4c-0.19527,0.19526 -0.19527,0.51184 0,0.7071c0.19526,0.19527 0.51184,0.19527 0.7071,0l3.64645,-3.64644l3.6464,3.64644Zm0,6.00005c0.1953,0.1952 0.5119,0.1952 0.7072,0c0.1952,-0.1953 0.1952,-0.5119 0,-0.7072l-4.00005,-3.99995c-0.19526,-0.19527 -0.51184,-0.19527 -0.7071,0l-4,3.99995c-0.19527,0.1953 -0.19527,0.5119 0,0.7072c0.19526,0.1952 0.51184,0.1952 0.7071,0l3.64645,-3.64649l3.6464,3.64649Z",
        fill: "#000",
        fillRule: "evenodd"
    })
});
var ScreenIcons = {
    cornersIcon: cornersIcon,
    rulersIcon: rulersIcon,
    bookmarkIcon: bookmarkIcon,
    interactionIcon: interactionIcon,
    dragHandleIcon: dragHandleIcon,
    moveHandleIcon: moveHandleIcon,
    doubleArrowUpIcon: doubleArrowUpIcon
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ScreenIcons)));



/***/ }),

/***/ 26703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ tokenIcon; },
/* harmony export */   "PZ": function() { return /* binding */ collectionIcon; },
/* harmony export */   "_q": function() { return /* binding */ builderIcon; },
/* harmony export */   "cS": function() { return /* binding */ blendingIcon; },
/* harmony export */   "lO": function() { return /* binding */ userIcon; },
/* harmony export */   "yy": function() { return /* binding */ imageIcon; }
/* harmony export */ });
/* unused harmony exports homeIcon, layersIcon, boxIcon, userInput, lockIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var blendingIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 9c0-2.5 1.5-4.75 4.5-7.5 3 2.75 4.5 5 4.5 7.5 0 2.4853-2.0147 4.5-4.5 4.5S3 11.4853 3 9Zm7.9524-.697c-1.279-.4818-2.6645.159-3.9628.7596-1.0569.4888-2.056.9509-2.8927.759A3.5091 3.5091 0 0 1 4 9c0-1.888 1.0269-3.728 3.5-6.1264C9.6684 4.9764 10.725 6.65 10.9524 8.303Z",
        fill: "#000"
    })
});
var homeIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.0793.2223a.6.6 0 0 1 .8415 0l6.75 6.64a.6.6 0 0 1-.8415.8554L13 6.902V12.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5V6.902l-.8292.8157a.6.6 0 1 1-.8415-.8554l6.75-6.64ZM7.5 1.4916 12 5.9183V12h-2V8.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V12H3V5.9183l4.5-4.4267ZM7 12h2V9H7v3Z",
        fill: "#000"
    })
});
var tokenIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.5 2C3.1193 2 2 3.1193 2 4.5S3.1193 7 4.5 7 7 5.8807 7 4.5 5.8807 2 4.5 2ZM3 4.5C3 3.6716 3.6716 3 4.5 3S6 3.6716 6 4.5 5.3284 6 4.5 6 3 5.3284 3 4.5ZM10.5 2C9.1193 2 8 3.1193 8 4.5S9.1193 7 10.5 7 13 5.8807 13 4.5 11.8807 2 10.5 2ZM9 4.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5S11.3284 6 10.5 6 9 5.3284 9 4.5Zm-7 6C2 9.1193 3.1193 8 4.5 8S7 9.1193 7 10.5 5.8807 13 4.5 13 2 11.8807 2 10.5ZM4.5 9C3.6716 9 3 9.6716 3 10.5S3.6716 12 4.5 12 6 11.3284 6 10.5 5.3284 9 4.5 9Zm6-1C9.1193 8 8 9.1193 8 10.5S9.1193 13 10.5 13s2.5-1.1193 2.5-2.5S11.8807 8 10.5 8ZM9 10.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5S9 11.3284 9 10.5Z",
        fill: "#000"
    })
});
var layersIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M7.7543.8195a.5.5 0 0 0-.5087 0l-5.5 3.25a.5.5 0 0 0 0 .861l5.5 3.25a.5.5 0 0 0 .5087 0l5.5-3.25a.5.5 0 0 0 0-.861l-5.5-3.25ZM7.5 7.1692 2.9828 4.5 7.5 1.8308 12.017 4.5 7.5 7.1692Zm-5.9305.3264a.5.5 0 0 1 .6848-.176L7.5 10.4191l5.2456-3.0997a.5.5 0 1 1 .5087.861l-5.5 3.25a.5.5 0 0 1-.5087 0l-5.5-3.25a.5.5 0 0 1-.1761-.6849Zm0 3a.5001.5001 0 0 1 .6848-.1761L7.5 13.4192l5.2456-3.0997a.5.5 0 0 1 .5087.861l-5.5 3.25a.5.5 0 0 1-.5087 0l-5.5-3.25a.5.5 0 0 1-.1761-.6849Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "#000"
    })
});
var boxIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    width: "15px",
    height: "15px",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.2886.797a.5.5 0 0 1 .4228 0l6 2.8A.5.5 0 0 1 14 4.05v6.9a.5.5 0 0 1-.2886.4531l-6 2.8a.5003.5003 0 0 1-.4228 0l-6-2.8A.5.5 0 0 1 1 10.95v-6.9a.5.5 0 0 1 .2886-.453l6-2.8ZM2 4.8057l5 2.125v6.0341l-5-2.3333V4.8058Zm6 8.1591 5-2.3333V4.8058l-5 2.125v6.0341Zm-.5-6.9082 4.7719-2.028L7.5 1.8017l-4.772 2.227L7.5 6.0567Z",
        fill: "#000"
    })
});
var collectionIcon = boxIcon;
var imageIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    width: "15px",
    height: "15px",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.5 1h10c.8284 0 1.5.6716 1.5 1.5v10c0 .8284-.6716 1.5-1.5 1.5h-10c-.8284 0-1.5-.6716-1.5-1.5v-10C1 1.6716 1.6716 1 2.5 1Zm0 1a.5.5 0 0 0-.5.5v5.8636l1.6818-1.6818a.45.45 0 0 1 .6471.0111l3.5446 3.7972 2.8083-2.8083a.45.45 0 0 1 .6364 0L13 9.3636V2.5a.5.5 0 0 0-.5-.5h-10ZM2 12.5V9.6364l1.9889-1.9889 3.5422 3.7946L8.9411 13H2.5a.5.5 0 0 1-.5-.5Zm10.5.5h-2.345l-1.6716-1.847L11 8.6364l2 2V12.5a.5.5 0 0 1-.5.5ZM6.6492 5.5a.8508.8508 0 1 1 1.7016 0 .8508.8508 0 0 1-1.7016 0ZM7.5 3.7492c-.967 0-1.7508.7839-1.7508 1.7508 0 .967.7839 1.7508 1.7508 1.7508.967 0 1.7508-.7839 1.7508-1.7508 0-.967-.7839-1.7508-1.7508-1.7508Z",
        fill: "#000"
    })
});
var userInput = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    width: "15px",
    height: "15px",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 1a.5.5 0 0 0 0 1c.6267 0 .9572.2003 1.1556.4781C7.8781 2.7896 8 3.2884 8 4v7c0 .7116-.1219 1.2104-.3444 1.5219C7.4572 12.7997 7.1267 13 6.5 13a.5.5 0 0 0 0 1c.8733 0 1.5428-.2997 1.9694-.8969a2.0522 2.0522 0 0 0 .0306-.044c.01.0148.0202.0295.0306.044C8.9572 13.7003 9.6267 14 10.5 14a.5.5 0 0 0 0-1c-.6267 0-.9572-.2003-1.1556-.4781C9.1219 12.2104 9 11.7116 9 11V4c0-.7116.1219-1.2104.3444-1.5219C9.5428 2.2003 9.8733 2 10.5 2a.5.5 0 0 0 0-1c-.8733 0-1.5428.2997-1.9694.8969a2.2162 2.2162 0 0 0-.0306.044 2.2162 2.2162 0 0 0-.0306-.044C8.0428 1.2997 7.3733 1 6.5 1ZM14 5h-3V4h3c.5523 0 1 .4477 1 1v5c0 .5523-.4477 1-1 1h-3v-1h3V5ZM6 4v1H1v5h5v1H1c-.5523 0-1-.4477-1-1V5c0-.5523.4477-1 1-1h5Z",
        fill: "#000"
    })
});
var builderIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "15px",
    height: "15px",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M7 0H4a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h3a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4Zm2 7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2Zm-2 6H4a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h3a4 4 0 0 0 4-4v-3a4 4 0 0 0-4-4Zm2 7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2Zm11-7h-3a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h3a4 4 0 0 0 4-4v-3a4 4 0 0 0-4-4Zm2 7a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2ZM14 7h3v3a1 1 0 0 0 2 0V7h3a1 1 0 0 0 0-2h-3V2a1 1 0 0 0-2 0v3h-3a1 1 0 0 0 0 2Z"
    })
});
var userIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15px",
    height: "15px",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M23 11h-2V9a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2ZM9 12a6 6 0 1 0-6-6 6.006 6.006 0 0 0 6 6ZM9 2a4 4 0 1 1-4 4 4 4 0 0 1 4-4Zm0 12a9.01 9.01 0 0 0-9 9 1 1 0 1 0 2 0 7 7 0 0 1 14 0 1 1 0 1 0 2 0 9.01 9.01 0 0 0-9-9Z"
    })
});
var lockIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15px",
    height: "15px",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M5 4.636c0-.8757.2422-1.5306.6432-1.9624.3961-.4266 1.0026-.6953 1.8582-.6953.856 0 1.4617.2682 1.8568.6938C9.7584 3.103 10 3.757 10 4.6332V6H5V4.636ZM4 6V4.636c0-1.0545.2934-1.9785.9105-2.643.622-.6697 1.5163-1.0147 2.5909-1.0147 1.0744 0 1.9681.344 2.5896 1.0133.6166.664.909 1.5874.909 2.6417V6h1c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1H3c-.5523 0-1-.4477-1-1V7c0-.5523.4477-1 1-1h1ZM3 7h9v6H3V7Z",
        fillRule: "evenodd"
    })
});


/***/ }),

/***/ 46669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ stylingIcon; },
/* harmony export */   "J0": function() { return /* binding */ layoutIcon; },
/* harmony export */   "Jl": function() { return /* binding */ uniqueIcon; },
/* harmony export */   "OJ": function() { return /* binding */ layersIcon; },
/* harmony export */   "ZQ": function() { return /* binding */ mainRefIcon; },
/* harmony export */   "bw": function() { return /* binding */ clonedIcon; },
/* harmony export */   "eL": function() { return /* binding */ clonedLinkDataIcon; },
/* harmony export */   "me": function() { return /* binding */ crossCloseIcon; },
/* harmony export */   "n8": function() { return /* binding */ mixerIcon; },
/* harmony export */   "xu": function() { return /* binding */ mixinIcon; },
/* harmony export */   "zi": function() { return /* binding */ linkDataIcon; },
/* harmony export */   "zw": function() { return /* binding */ mainLinkDataIcon; }
/* harmony export */ });
/* unused harmony exports uncloneIcon, syncItemIcon, cloneIcon, componentIcon, elementFieldsIcon, dataSourceIcon, elementsMapIcon, syncChildrenIcon, unlinkDataIcon, editPencilSquareIcon, shareIcon, circleCloseIcon, globeIcon, inputIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var uniqueIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M7.146 1.49a.5.5 0 0 1 .708 0l5.657 5.656a.5.5 0 0 1 0 .708L7.854 13.51a.5.5 0 0 1-.708 0L1.49 7.854a.5.5 0 0 1 0-.708L7.146 1.49ZM7.5 2.55 2.55 7.5l4.95 4.95 4.95-4.95L7.5 2.55Z",
        fill: "#000"
    })
});
var uncloneIcon = (/* unused pure expression or super */ null && (uniqueIcon));
var mainRefIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M4.671 3.146a.5.5 0 0 0 0 .707l2.475 2.475a.5.5 0 0 0 .707 0l2.475-2.475a.5.5 0 0 0 0-.707L7.853.671a.5.5 0 0 0-.707 0L4.671 3.146ZM7.5 5.268 5.732 3.5 7.5 1.732 9.267 3.5 7.5 5.268ZM8.67 7.146a.5.5 0 0 0 0 .707l2.475 2.475a.5.5 0 0 0 .707 0l2.475-2.475a.5.5 0 0 0 0-.707l-2.475-2.475a.5.5 0 0 0-.707 0L8.671 7.146ZM11.5 9.268 9.732 7.5 11.5 5.732 13.268 7.5 11.5 9.268ZM4.67 11.853a.5.5 0 0 1 0-.707l2.475-2.475a.5.5 0 0 1 .707 0l2.475 2.475a.5.5 0 0 1 0 .707l-2.475 2.475a.5.5 0 0 1-.707 0l-2.475-2.474Zm1.061-.353L7.5 13.268 9.267 11.5 7.5 9.732 5.732 11.5ZM.672 7.146a.5.5 0 0 0 0 .708l2.474 2.474a.5.5 0 0 0 .707 0l2.475-2.474a.5.5 0 0 0 0-.708L3.853 4.672a.5.5 0 0 0-.707 0L.671 7.146ZM3.5 9.268 1.732 7.5 3.5 5.732 5.267 7.5 3.5 9.268Z",
        fill: "#000"
    })
});
var clonedIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M7.854 1.49a.5.5 0 0 0-.707 0L1.49 7.146a.5.5 0 0 0 0 .708l5.657 5.656a.5.5 0 0 0 .707 0l5.657-5.656a.5.5 0 0 0 0-.708L7.854 1.49ZM7.5 2.55 2.55 7.5l4.95 4.95v-9.9Z",
        fill: "#000"
    })
});
var syncItemIcon = (/* unused pure expression or super */ null && (clonedIcon));
var cloneIcon = (/* unused pure expression or super */ null && (clonedIcon));
var componentIcon = mainRefIcon;
var mixerIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM3 5c.017 0 .033 0 .05-.002a2.5 2.5 0 0 0 4.9 0A.507.507 0 0 0 8 5h5.5a.5.5 0 0 0 0-1H8c-.017 0-.033 0-.05.002a2.5 2.5 0 0 0-4.9 0A.507.507 0 0 0 3 4H1.5a.5.5 0 0 0 0 1H3Zm8.95 5.998a2.5 2.5 0 0 1-4.9 0A.507.507 0 0 1 7 11H1.5a.5.5 0 0 1 0-1H7c.017 0 .033 0 .05.002a2.5 2.5 0 0 1 4.9 0A.506.506 0 0 1 12 10h1.5a.5.5 0 0 1 0 1H12c-.017 0-.033 0-.05-.002ZM8 10.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
        fill: "#000"
    })
});
var elementFieldsIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M6.5 1a.5.5 0 0 0 0 1c.627 0 .957.2 1.156.478C7.878 2.79 8 3.288 8 4v7c0 .712-.122 1.21-.344 1.522-.199.278-.53.478-1.156.478a.5.5 0 0 0 0 1c.873 0 1.543-.3 1.97-.897l.03-.044.03.044c.427.597 1.097.897 1.97.897a.5.5 0 0 0 0-1c-.627 0-.957-.2-1.156-.478C9.122 12.21 9 11.712 9 11V4c0-.712.122-1.21.344-1.522C9.543 2.2 9.874 2 10.5 2a.5.5 0 0 0 0-1c-.873 0-1.543.3-1.97.897l-.03.044-.03-.044C8.042 1.3 7.372 1 6.5 1ZM14 5h-3V4h3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-3v-1h3V5ZM6 4v1H1v5h5v1H1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5Z",
        fill: "#000"
    })
});
var mainLinkDataIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M3 2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V8.5a.5.5 0 0 0-1 0V12H3V3h3.5a.5.5 0 0 0 0-1H3Zm9.854.146a.5.5 0 0 1 .146.351V5.5a.5.5 0 0 1-1 0V3.707L6.854 8.854a.5.5 0 1 1-.708-.708L11.293 3H9.5a.5.5 0 0 1 0-1h3a.499.499 0 0 1 .354.146Z",
        fill: "#000"
    })
});
var clonedLinkDataIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M8.512 3.005c.676-.46 1.531-.468 2.167-.05.144.094.298.244.71.656.412.412.562.566.657.71.417.636.408 1.49-.051 2.167-.105.155-.267.32-.694.747l-.62.619a.5.5 0 0 0 .708.707l.619-.619.043-.043c.37-.37.606-.606.771-.849.675-.994.71-2.287.06-3.278-.159-.241-.39-.472-.741-.823l-.045-.045-.044-.045c-.352-.351-.583-.582-.824-.74-.99-.65-2.284-.616-3.278.06-.243.164-.48.4-.85.77l-.042.043-.619.62a.5.5 0 1 0 .707.706l.62-.618c.426-.427.592-.59.746-.695ZM4.318 7.147a.5.5 0 0 0-.707-.707l-.619.618-.043.043c-.37.37-.606.606-.771.85-.675.993-.71 2.287-.06 3.277.159.242.39.473.741.824l.045.045.044.044c.352.351.583.583.824.741.99.65 2.284.616 3.278-.06.243-.165.48-.401.849-.771l.043-.043.619-.619a.5.5 0 1 0-.708-.707l-.618.619c-.427.427-.593.59-.747.694-.676.46-1.532.469-2.167.051-.144-.094-.298-.245-.71-.657-.412-.412-.562-.566-.657-.71-.417-.635-.408-1.49.051-2.167.105-.154.267-.32.694-.747l.619-.618Zm5.304-1.061a.5.5 0 0 0-.707-.708L5.379 8.914a.5.5 0 1 0 .707.707l3.536-3.535Z",
        fill: "#000"
    })
});
var linkDataIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M10.679 2.954c-.636-.417-1.49-.408-2.167.051-.154.105-.32.268-.747.695l-.619.618a.5.5 0 0 1-.707-.707l.619-.619.043-.042c.37-.37.606-.607.849-.772.994-.675 2.288-.71 3.278-.06.241.159.472.39.824.741l.044.045.045.045c.351.351.582.582.74.823.651.99.616 2.284-.059 3.278-.165.243-.402.48-.771.85l-.043.042-.619.619a.5.5 0 1 1-.707-.707l.619-.619c.427-.427.589-.592.694-.747.46-.676.468-1.531.051-2.167-.095-.144-.245-.298-.657-.71-.412-.412-.566-.562-.71-.657ZM4.318 6.44a.5.5 0 0 1 0 .707l-.619.618c-.427.427-.59.593-.694.747-.46.677-.468 1.532-.051 2.167.095.144.245.298.657.71.412.412.566.563.71.657.635.418 1.49.409 2.167-.05.154-.106.32-.268.747-.695l.618-.619a.5.5 0 1 1 .708.707l-.62.62-.042.042c-.37.37-.606.606-.85.771-.993.676-2.287.71-3.277.06-.241-.158-.472-.39-.824-.74-.014-.016-.03-.03-.044-.045a91.54 91.54 0 0 1-.045-.045c-.351-.351-.582-.582-.741-.824-.65-.99-.615-2.284.06-3.278.165-.243.402-.48.771-.849l.043-.043.619-.618a.5.5 0 0 1 .707 0Z",
        fill: "#000"
    })
});
var dataSourceIcon = mainLinkDataIcon;
var elementsMapIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M7.754 1.82a.5.5 0 0 0-.508 0l-5.5 3.25a.5.5 0 0 0 0 .86l5.5 3.25a.5.5 0 0 0 .508 0l5.5-3.25a.5.5 0 0 0 0-.86l-5.5-3.25ZM7.5 8.17 2.983 5.5 7.5 2.83l4.517 2.67L7.5 8.17Zm-5.246.15a.5.5 0 0 0-.508.86l5.5 3.25a.5.5 0 0 0 .508 0l5.5-3.25a.5.5 0 1 0-.508-.86L7.5 11.42l-5.246-3.1Z",
        fill: "#000"
    })
});
var layersIcon = elementsMapIcon;
var syncChildrenIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M1.903 7.297c0 3.044 2.207 5.118 4.686 5.547a.521.521 0 1 1-.178 1.027C3.5 13.367.861 10.913.861 7.297c0-1.537.699-2.745 1.515-3.663.585-.658 1.254-1.193 1.792-1.602H2.532a.5.5 0 0 1 0-1h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V2.686l-.001.002c-.572.43-1.27.957-1.875 1.638-.715.804-1.253 1.776-1.253 2.97Zm11.108.406c0-3.012-2.16-5.073-4.607-5.533a.521.521 0 1 1 .192-1.024c2.874.54 5.457 2.98 5.457 6.557 0 1.537-.699 2.744-1.515 3.663-.585.658-1.254 1.193-1.792 1.602h1.636a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 1 1 1 0v1.845h.002c.571-.432 1.27-.958 1.874-1.64.715-.803 1.253-1.775 1.253-2.97Z",
        fill: "#000"
    })
});
var unlinkDataIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M12.146 1.146a.5.5 0 0 1 .707 0l2 2a.5.5 0 0 1 0 .708l-3.942 3.942a1 1 0 0 1-.26.188L6.724 9.947a.5.5 0 0 1-.671-.67l1.963-3.928a1 1 0 0 1 .188-.26l3.942-3.943Zm.354 1.061-3.59 3.59-1.037 2.076.254.254 2.077-1.038L13.793 3.5 12.5 2.207ZM10 2 9 3H4.9c-.428 0-.72 0-.944.019-.22.018-.332.05-.41.09a1 1 0 0 0-.437.437c-.04.078-.072.19-.09.41C3 4.18 3 4.472 3 4.9v6.2c0 .428 0 .72.019.944.018.22.05.332.09.41a1 1 0 0 0 .437.437c.078.04.19.072.41.09.225.019.516.019.944.019h6.2c.428 0 .72 0 .944-.019.22-.018.332-.05.41-.09a1 1 0 0 0 .437-.437c.04-.078.072-.19.09-.41.019-.225.019-.516.019-.944V7l1-1V11.12c0 .403 0 .735-.022 1.006-.023.281-.072.54-.196.782a2 2 0 0 1-.874.874c-.243.124-.501.173-.782.196-.27.022-.603.022-1.005.022H4.88c-.403 0-.735 0-1.006-.022-.281-.023-.54-.072-.782-.196a2 2 0 0 1-.874-.874c-.124-.243-.173-.501-.196-.782C2 11.856 2 11.523 2 11.12V4.88c0-.403 0-.735.022-1.006.023-.281.072-.54.196-.782a2 2 0 0 1 .874-.874c.243-.124.501-.173.782-.196C4.144 2 4.477 2 4.88 2H10Z",
        fill: "#000"
    })
});
var editPencilSquareIcon = (/* unused pure expression or super */ null && (unlinkDataIcon));
var mixinIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm.713 1.164a2.5 2.5 0 1 1 0-2.328l3.391-2.12A2.5 2.5 0 1 1 14 3.5a2.5 2.5 0 0 1-4.484 1.52l-3.53 2.207a2.526 2.526 0 0 1 0 .546l3.53 2.206a2.5 2.5 0 1 1-.411.804l-3.392-2.12ZM11.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
        fill: "#000"
    })
});
var shareIcon = (/* unused pure expression or super */ null && (mixinIcon));
var circleCloseIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M.877 7.5a6.623 6.623 0 1 1 13.246 0 6.623 6.623 0 0 1-13.246 0ZM7.5 1.827a5.673 5.673 0 1 0 0 11.346 5.673 5.673 0 0 0 0-11.346Zm2.354 3.32a.5.5 0 0 1 0 .707L8.207 7.5l1.647 1.646a.5.5 0 0 1-.708.708L7.5 8.207 5.854 9.854a.5.5 0 0 1-.708-.708L6.793 7.5 5.146 5.854a.5.5 0 0 1 .708-.708L7.5 6.793l1.646-1.647a.5.5 0 0 1 .708 0Z",
        fill: "#000"
    })
});
var crossCloseIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M11.782 4.032a.575.575 0 1 0-.813-.814L7.5 6.687 4.032 3.218a.575.575 0 0 0-.814.814L6.687 7.5l-3.469 3.468a.575.575 0 0 0 .814.814L7.5 8.313l3.469 3.469a.575.575 0 0 0 .813-.814L8.313 7.5l3.469-3.468Z",
        fill: "#000"
    })
});
var stylingIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 1.5C4.5 4.25 3 6.5 3 9a4.5 4.5 0 1 0 9 0c0-2.5-1.5-4.75-4.5-7.5ZM11 9c0-1.888-1.027-3.728-3.5-6.126C5.027 5.272 4 7.112 4 9a3.5 3.5 0 1 0 7 0Z",
        fill: "#000"
    })
});
var layoutIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.5 1.8a5.7 5.7 0 1 0 0 11.4 5.7 5.7 0 0 0 0-11.4ZM.9 7.5a6.6 6.6 0 1 1 13.2 0 6.6 6.6 0 0 1-13.2 0Z",
            fill: "#000"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13.5 7.9h-12v-.8h12v.8Z",
            fill: "#000"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.1 13.5v-12h.8v12h-.8ZM10.375 7.5c0-2.173-.781-4.322-2.313-5.743l.476-.514c1.702 1.58 2.537 3.93 2.537 6.257 0 2.327-.835 4.678-2.537 6.257l-.476-.514c1.532-1.42 2.313-3.57 2.313-5.743ZM4 7.5c0-2.324.808-4.673 2.458-6.253l.484.506C5.458 3.173 4.7 5.323 4.7 7.5c0 2.176.758 4.327 2.242 5.747l-.484.506C4.808 12.173 4 9.823 4 7.5Z",
            fill: "#000"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.5 3.958c2.17 0 4.375.401 5.87 1.236a.35.35 0 1 1-.34.612c-1.35-.754-3.422-1.148-5.53-1.148s-4.18.394-5.53 1.148a.35.35 0 1 1-.34-.612c1.495-.835 3.7-1.236 5.87-1.236ZM7.5 10.85c2.17 0 4.375-.401 5.87-1.236a.35.35 0 1 0-.34-.612c-1.35.754-3.422 1.148-5.53 1.148s-4.18-.394-5.53-1.148a.35.35 0 1 0-.34.611c1.495.836 3.7 1.237 5.87 1.237Z",
            fill: "#000"
        })
    ]
});
var globeIcon = (/* unused pure expression or super */ null && (layoutIcon));
var inputIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M6.5 1a.5.5 0 0 0 0 1c.627 0 .957.2 1.156.478C7.878 2.79 8 3.288 8 4v7c0 .712-.122 1.21-.344 1.522-.199.278-.53.478-1.156.478a.5.5 0 0 0 0 1c.873 0 1.543-.3 1.97-.897l.03-.044.03.044c.427.597 1.097.897 1.97.897a.5.5 0 0 0 0-1c-.627 0-.957-.2-1.156-.478C9.122 12.21 9 11.712 9 11V4c0-.712.122-1.21.344-1.522C9.543 2.2 9.874 2 10.5 2a.5.5 0 0 0 0-1c-.873 0-1.543.3-1.97.897l-.03.044-.03-.044C8.042 1.3 7.372 1 6.5 1ZM14 5h-3V4h3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-3v-1h3V5ZM6 4v1H1v5h5v1H1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5Z",
        fill: "#000"
    })
});
var StateIcons = {
    uniqueIcon: uniqueIcon,
    mainRefIcon: mainRefIcon,
    clonedIcon: clonedIcon,
    componentIcon: componentIcon,
    elementFieldsIcon: elementFieldsIcon,
    mainLinkDataIcon: mainLinkDataIcon,
    clonedLinkDataIcon: clonedLinkDataIcon,
    linkDataIcon: linkDataIcon,
    dataSourceIcon: dataSourceIcon,
    elementsMapIcon: elementsMapIcon,
    syncChildrenIcon: syncChildrenIcon,
    mixinIcon: mixinIcon
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (StateIcons)));


/***/ }),

/***/ 42238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d5": function() { return /* binding */ IconSets; },
/* harmony export */   "qv": function() { return /* binding */ icon; }
/* harmony export */ });
/* harmony import */ var _EditIcons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75679);
/* harmony import */ var _HelpIcons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87308);
/* harmony import */ var _ElementIcons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99559);
/* harmony import */ var _EditorIcons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59688);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62570);






var IconSets = {
    elements: _ElementIcons__WEBPACK_IMPORTED_MODULE_0__/* .elementIcons */ .tl,
    editor: _EditorIcons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP,
    edit: _EditIcons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP,
    help: _HelpIcons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP
};
var icon = function(set, icon) {
    var ref;
    return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_4__/* .hasAttr */ .B$)(IconSets, set, icon) ? IconSets === null || IconSets === void 0 ? void 0 : (ref = IconSets[set]) === null || ref === void 0 ? void 0 : ref[icon] : _HelpIcons__WEBPACK_IMPORTED_MODULE_3__/* .helpCircle */ .pv;
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (icon)));


/***/ }),

/***/ 28585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B3": function() { return /* binding */ getFieldset; },
/* harmony export */   "GF": function() { return /* binding */ parseIcon; },
/* harmony export */   "Ih": function() { return /* binding */ defaultMetricArray; },
/* harmony export */   "fN": function() { return /* binding */ addUnset; },
/* harmony export */   "r5": function() { return /* binding */ defaultEndAdornmentValueFallback; },
/* harmony export */   "vo": function() { return /* binding */ quickArrowButtonPresets; },
/* harmony export */   "yL": function() { return /* binding */ getFieldsetFields; }
/* harmony export */ });
/* unused harmony exports DEFAULT_BREAKPOINTS, getMobileFirstScreens, defaultSizingArray, defaultMinimumArray, defaultMarginArray, advancedMetricArray, defaultTypographyMetricArray, FIELD_SETS, getFieldRules, getFieldsetFieldsAsObject */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _root__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61541);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77298);
/* harmony import */ var _util_Arr__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72393);







// import { getMobileFirstScreens } from "@redux/canvas/reducer";
var DEFAULT_BREAKPOINTS = {
    xs: 0,
    sm: 600,
    md: 850,
    lg: 1200,
    xl: 1400
};
var parseIcon = function(type) {
    return type === "parse/icons";
};
var getMobileFirstScreens = function() {
    return Object.keys(DEFAULT_BREAKPOINTS);
};


var SelectLayout = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9589));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9589)
            ];
        }
    }
});



var defaultEndAdornmentValueFallback = "px";
var quickArrowButtonPresets = [
    {
        id: "smallSet",
        values: [
            0,
            10,
            20,
            40
        ]
    },
    {
        id: "largeSet",
        values: [
            60,
            100,
            140,
            220
        ]
    }
];
var addUnset = function(arr) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(arr).concat([
        {
            value: null,
            label: "Unset"
        }
    ]);
};
var defaultSizingArray = [
    // {value:'none', tooltip: 'Unset field'}, 
    // {value: 'auto', tooltip: 'Set automatic'}, 
    {
        value: "stretch",
        tooltip: "Stretch content"
    },
    {
        value: "contain",
        tooltip: "Contain content"
    },
    "divider",
    {
        value: "%",
        convert: true,
        tooltip: "Percentage (%)"
    },
    {
        value: "px",
        convert: true,
        tooltip: "Pixels (px)"
    },
    {
        value: "vh",
        convert: true,
        tooltip: "Viewport height (vh)"
    },
    {
        value: "vw",
        convert: true,
        tooltip: "Viewport width (vw)"
    },
    "divider", 
];
var defaultMetricArray = [
    "divider",
    {
        value: "%",
        convert: true,
        tooltip: "Percentage (%)"
    },
    {
        value: "px",
        convert: true,
        tooltip: "Pixels (px)"
    },
    {
        value: "vh",
        convert: true,
        tooltip: "Viewport height (vh)"
    },
    {
        value: "vw",
        convert: true,
        tooltip: "Viewport width (vw)"
    },
    "divider", 
];
var defaultMinimumArray = [
    {
        value: "%",
        convert: true,
        tooltip: "Percentage (%)"
    },
    {
        value: "px",
        convert: true,
        tooltip: "Pixels (px)"
    },
    "divider", 
];
var defaultMarginArray = [
    {
        value: "auto",
        tooltip: "Set automatic"
    },
    "divider",
    {
        value: "%",
        convert: true,
        tooltip: "Percentage (%)"
    },
    {
        value: "px",
        convert: true,
        tooltip: "Pixels (px)"
    },
    {
        value: "vh",
        convert: true,
        tooltip: "Viewport height (vh)"
    },
    {
        value: "vw",
        convert: true,
        tooltip: "Viewport width (vw)"
    },
    "divider", 
];
var advancedMetricArray = [
    {
        value: "cm",
        convert: true,
        tooltip: "Centimeters (cm)"
    },
    {
        value: "mm",
        convert: true,
        tooltip: "Millimeters (mm)"
    },
    {
        value: "in",
        convert: true,
        tooltip: "Inches (in)"
    },
    {
        value: "pt",
        convert: true,
        tooltip: "Points (pt)"
    },
    "divider", 
];
var defaultTypographyMetricArray = [
    {
        value: "px",
        convert: true,
        tooltip: "Pixels (px)"
    },
    {
        value: "em",
        convert: true,
        tooltip: "Font size of the parent"
    },
    {
        value: "rem",
        convert: true,
        tooltip: "Font size of the root element"
    },
    {
        value: "ch",
        convert: true,
        tooltip: "Advance measure of '0' from current font"
    },
    {
        value: "lh",
        convert: true,
        tooltip: "Line height of the element"
    },
    {
        value: "ex",
        convert: true,
        tooltip: "X-Height of element's font"
    },
    "divider", 
];
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("sizing", {
    name: "sizing",
    meta: {
        description: "Element sizing",
        helpSource: "layout/sizing/inspector"
    },
    props: {
        fields: [
            "width",
            "height",
            "minWidth",
            "minHeight",
            "maxWidth",
            "maxHeight"
        ],
        endAdornment: {
            type: "list",
            options: defaultSizingArray,
            defaultValue: "px"
        }
    },
    labelFormat: "parse/camelCase",
    returnFormat: "parse/string/css",
    path: "data.sizing.[field]",
    expand: "slice",
    type: "metricInput",
    defaultValue: ""
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("padding", {
    name: "padding",
    meta: {
        description: "Element padding",
        helpSource: "layout/padding/inspector"
    },
    props: {
        fields: [
            "top",
            "bottom",
            "left",
            "right"
        ],
        endAdornment: {
            type: "list",
            options: defaultMetricArray,
            defaultValue: "px"
        },
        fieldArrows: true,
        inline: "four"
    },
    labelFormat: "parse/camelCase",
    returnFormat: "parse/string/css",
    path: "data.padding.[field]",
    type: "metricInput",
    minimize: {
        type: "inlineValues" //todo --> show in header tab
    },
    defaultValue: "0"
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("margin", {
    name: "margin",
    meta: {
        description: "Element margin",
        helpSource: "layout/margin/inspector"
    },
    props: {
        fields: [
            "top",
            "bottom",
            "left",
            "right"
        ],
        endAdornment: {
            type: "list",
            options: defaultMarginArray,
            defaultValue: "px"
        },
        fieldArrows: true,
        inline: "four"
    },
    labelFormat: "parse/camelCase",
    returnFormat: "parse/string/css",
    path: "data.margin.[field]",
    type: "metricInput",
    defaultValue: "0"
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("docking", {
    name: "docking",
    meta: {
        description: "Element docking",
        helpSource: "layout/docking/inspector"
    },
    props: {
        fields: [
            "top",
            "bottom",
            "left",
            "right"
        ],
        endAdornment: {
            type: "list",
            options: defaultMarginArray,
            defaultValue: "px"
        },
        fieldArrows: true,
        inline: "four"
    },
    labelFormat: "parse/camelCase",
    returnFormat: "parse/string/css",
    path: "data.docking.[field]",
    type: "metricInput",
    defaultValue: "0"
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("corner", {
    name: "corner",
    meta: {
        description: "Element Corners",
        helpSource: "layout/corners/inspector"
    },
    props: {
        fields: [
            "top-left",
            "bottom-right",
            "bottom-left",
            "top-right"
        ],
        endAdornment: {
            type: "list",
            options: defaultMinimumArray,
            defaultValue: "px"
        },
        fieldArrows: true,
        extra: "corners",
        inline: "four"
    },
    labelFormat: "parse/camelCase",
    returnFormat: "parse/string/css",
    path: "data.corner.[field]",
    type: "metricInput",
    defaultValue: "0"
});
// Registering Parallax Tilt as an attachment
// registerComponent(ReactParallaxTilt, {
//   name: 'Parallax Tilt',
//   isAttachment: true,
//   props: {
//     tiltEnabled: 'boolean',
//     tiltReverse: 'boolean',
//     tiltAngleX: 'number',
//     tiltAngleY: 'number',
//     children: 'slot'
//   }
// });
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("flex", {
    name: "flex",
    meta: {
        description: "Display flex",
        helpSource: "layout/flex/inspector"
    },
    props: {
        direction: {
            type: "choice",
            options: [
                "horizontal",
                "vertical"
            ],
            tooltip: "Column or row direction"
        },
        align: {
            type: "choice",
            options: [
                "start",
                "center",
                "end",
                "stretch",
                "baseline"
            ],
            wrapperClass: function(props) {
                return (props === null || props === void 0 ? void 0 : props.direction) === "vertical" ? "-rotate" : "";
            },
            labelFormat: "parse/icons",
            tooltip: "Align items"
        },
        justify: {
            type: "choice",
            options: [
                "start",
                "center",
                "end",
                "between",
                "around"
            ],
            wrapperClass: function(props) {
                return (props === null || props === void 0 ? void 0 : props.direction) === "vertical" ? "-rotate" : "";
            },
            labelFormat: "parse/icons",
            tooltip: "Justify spacing items"
        },
        group: {
            wrap: {
                type: "toggle",
                display: "choice"
            },
            reverse: "toggle",
            test: {
                type: "toggle",
                display: function(props) {
                    return props === null || props === void 0 ? void 0 : props.wrap;
                }
            }
        },
        // label: {
        //   type: 'text',
        //   placeholder: 'Test text'
        // },
        submit: "select"
    },
    // expand: 'slice',
    path: "data.display.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("container", {
    name: "container",
    meta: {
        description: "Section layout",
        helpSource: "layout/section/inspector"
    },
    props: {
        container: {
            tooltip: "Container toggles",
            helpText: "Select the order of this column relative to its parents children.",
            options: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(getMobileFirstScreens()).concat([
                "all"
            ]),
            type: "toggle"
        },
        layout: {
            tooltip: "Change this section layout",
            helpText: "Layout change can also by applied by clicking the preferred section.",
            render: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SelectLayout, {
                rowData: null,
                hideOthers: true
            }),
            type: "render"
        }
    },
    labelFormat: "parse/icons"
});
var bpOptions = {
    type: "incrementInput",
    options: getMobileFirstScreens(),
    baseOnly: true
};
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("columnGrid", {
    name: "columnGrid",
    meta: {
        description: "Section layout",
        helpSource: "layout/section/inspector"
    },
    props: {
        grid: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            tooltip: "Grid sizing"
        }, bpOptions),
        offset: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            tooltip: "Grid offset"
        }, bpOptions),
        order: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            tooltip: "Grid order"
        }, bpOptions),
        elements: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            tooltip: "Elements"
        }, bpOptions),
        hide: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, bpOptions)
    },
    expand: {
        type: "tab",
        defaultValue: "grid"
    },
    labelFormat: "parse/icons",
    iconGroup: "grid"
});
var sizes = [
    {
        value: "xs",
        label: "Extra small"
    },
    {
        value: "sm",
        label: "Small"
    },
    {
        value: "md",
        label: "Medium"
    },
    {
        value: "lg",
        label: "Large"
    },
    {
        value: "xl",
        label: "Extra large"
    },
    {
        value: "custom",
        label: "Custom"
    }
];
var customField = function() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "number";
    return {
        type: type,
        display: function(props) {
            return (props === null || props === void 0 ? void 0 : props.shadow) === "custom";
        }
    };
};
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("shadow", {
    name: "shadow",
    meta: {
        description: "Box shadow",
        helpSource: "layout/shadow/inspector"
    },
    props: {
        shadow: {
            type: "select",
            options: addUnset(sizes),
            tooltip: "Box shadow"
        },
        type: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, customField("select")), {
            options: [
                "outset",
                "inset"
            ]
        }),
        left: customField(),
        top: customField(),
        blur: customField(),
        spread: customField(),
        color: customField("color")
    },
    path: "data.shadow.[field]"
});
var cursors = "pointer|help|alias|none|not-allowed|context-menu|progress|text|crosshair|copy|move|grab|grabbing|zoom-in|zoom-out".split("|").map(function(c) {
    return {
        value: c,
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                cursor: c
            },
            children: c
        })
    };
});
// * Custom behavior 
// - Reveal on scroll
// - 3D parallax tilt 
// - Parallax scroll
// - Component store?
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("templates", {
    name: "templates",
    props: {
        template: {
            type: "select",
            options: "default|none|clear".split("|")
        },
        create: {
            type: "btn"
        }
    }
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("presets", {
    name: "presets",
    props: {
        animation: {
            type: "select",
            options: "3D Parallax tilt| Parallax scroll|Animate in".split("|")
        }
    }
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("animate", {
    name: "animate",
    props: {
        "Coming Soon": {
            type: "btn"
        }
    }
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("cursor", {
    name: "cursor",
    meta: {
        description: "Scroll",
        helpSource: "layout/scroll/inspector"
    },
    props: {
        cursor: {
            type: "select",
            options: [
                {
                    value: null,
                    label: "auto"
                }
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(cursors))
        },
        reveal: {
            type: "toggle",
            label: "Reveal on scroll"
        }
    }
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("position", {
    name: "position",
    meta: {
        description: "Position",
        helpSource: "layout/position/inspector"
    },
    props: {
        position: {
            type: "choice",
            options: [
                "relative",
                "absolute",
                "fixed",
                "sticky"
            ]
        },
        place: {
            type: "number",
            // type: 'top, right, bottom, left',
            // help icons: 
            display: function(props) {
                return (props === null || props === void 0 ? void 0 : props.position) === "absolute";
            }
        },
        zIndex: {
            type: "number"
        }
    }
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("display", {
    name: "display",
    meta: {
        description: "Display",
        helpSource: "layout/scroll/inspector"
    },
    props: {
        hidden: {
            tooltip: "Hidden on screen:",
            label: "Hidden on screen:",
            helpText: "Select the order of this column relative to its parents children.",
            options: [
                {
                    value: "all",
                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .EyeClosedIcon */ .LAO, {})
                }
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(getMobileFirstScreens())),
            type: "toggle"
        },
        opacity: {
            type: "slider",
            min: 0,
            max: 1,
            step: 0.1
        },
        objectFit: {
            type: "select",
            options: addUnset("fill|contain|cover|none|scaleDown".split("|"))
        },
        overflow: {
            type: "select",
            options: addUnset("visible|hidden|clip|scroll|overlay|auto".split("|"))
        }
    }
});
var filterOptions = function(type) {
    var _obj;
    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, "".concat(type, "Type"), {
        type: "select",
        options: addUnset("blur|brightness|contrast|grayscale|drop-shadow|hue-rotate|invert|opacity|sepia|saturate".split("|")),
        baseOnly: true
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, "amount", {
        type: "string"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, "color", {
        type: "color",
        display: function(props) {
            return (props === null || props === void 0 ? void 0 : props["".concat(type, "Type")]) === "drop-shadow";
        }
    }), _obj;
};
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("effect", {
    name: "effect",
    meta: {
        description: "Filter effect",
        helpSource: "layout/filter-effect/inspector"
    },
    props: {
        filterGroup: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, filterOptions("filter")),
        backdropGroup: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, filterOptions("backdrop"))
    },
    expand: {
        type: "tab",
        place: "inline",
        defaultValue: "filterGroup"
    },
    path: "data.effect.[field]"
});
// * Transform
// - Move, rotate, scale, skew (x y z)
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("transform", {
    name: "transform",
    meta: {
        description: "Transform",
        helpSource: "layout/transform/inspector"
    },
    props: {
        transform: {
            type: "transform",
            receive: [
                "image",
                "bg.repeat",
                "bg.size",
                "bg.sizeValue"
            ]
        }
    },
    path: "data.transform.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("transition", {
    name: "transition",
    meta: {
        description: "Transition",
        helpSource: "layout/transition/inspector"
    },
    props: {
        baseGroup: {
            target: {
                type: "select",
                options: addUnset("all|margin|padding|background|opacity|custom".split("|")),
                baseOnly: true
            },
            selector: {
                type: "string",
                baseOnly: true,
                display: function(props) {
                    return (props === null || props === void 0 ? void 0 : props.target) === "custom";
                }
            },
            duration: {
                type: "string",
                defaultValue: "0.3s"
            }
        },
        advancedGroup: {
            curve: {
                type: "select",
                options: addUnset("ease|ease-in-out|ease-in|ease-out|linear|custom".split("|")),
                baseOnly: true
            },
            bezier: {
                type: "bezier",
                baseOnly: true,
                display: function(props) {
                    return (props === null || props === void 0 ? void 0 : props.curve) === "custom";
                }
            },
            delay: {
                type: "string",
                defaultValue: "0s"
            }
        }
    },
    expand: {
        type: "tab",
        place: "inline",
        defaultValue: "baseGroup"
    },
    path: "data.transition.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("border", {
    name: "border",
    meta: {
        description: "Border",
        helpSource: "layout/shadow/inspector"
    },
    props: {
        width: {
            type: "slider",
            minDistance: 0.25,
            min: 0,
            max: 10
        },
        style: {
            type: "select",
            options: addUnset("solid|dashed|dotted".split("|"))
        },
        color: {
            type: "color"
        }
    },
    path: "data.border.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("background", {
    name: "background",
    meta: {
        description: "Background options",
        helpSource: "layout/background/inspector"
    },
    props: {
        background: {
            type: "color",
            tooltip: "Background color"
        },
        imageGroup: {
            image: {
                type: "imageUrl"
            },
            "bg.position": {
                label: "position",
                type: "focal",
                receive: [
                    "image",
                    "bg.repeat",
                    "bg.size",
                    "bg.sizeValue"
                ],
                receiveBaseOnly: true
            },
            "bg.size": {
                type: "select",
                label: "Size",
                options: addUnset("contain|cover|percentage".split("|"))
            },
            "bg.sizeValue": {
                type: "string",
                label: "Size value",
                display: function(props) {
                    var ref;
                    return (props === null || props === void 0 ? void 0 : (ref = props.bg) === null || ref === void 0 ? void 0 : ref.size) === "percentage";
                }
            },
            "bg.repeat": {
                type: "select",
                label: "Repeat",
                options: addUnset("repeat|repeat-x|repeat-y|no-repeat".split("|"))
            }
        },
        gradient: {
            type: "gradient"
        }
    },
    path: "data.[field]",
    expand: {
        type: "tab",
        place: "inline",
        defaultValue: "background"
    }
});
var align = "left|center|right|justify".split("|").map(function(a) {
    return {
        value: a,
        label: a
    };
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("text", {
    name: "text",
    meta: {
        description: "Text options",
        helpSource: "layout/text/inspector"
    },
    props: {
        textAlign: {
            type: "choice",
            options: addUnset(align),
            labelFormat: "parse/icons"
        },
        textColor: {
            type: "colorPlus"
        }
    },
    expand: {
        place: "inline"
    }
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("textColor", {
    name: "textColor",
    props: {
        textColor: {
            type: "colorPlus"
        }
    }
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("font", {
    name: "font",
    props: {
        font: {
            type: "font"
        },
        size: "number",
        weight: {
            type: "select",
            options: (0,_util_Arr__WEBPACK_IMPORTED_MODULE_8__/* .loopFunc */ .Jc)(4, function(i) {
                return {
                    value: i,
                    label: (i * 100).toString()
                };
            })
        }
    },
    path: "data.font.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("letters", {
    name: "letters",
    props: {
        textAlign: {
            type: "choice",
            options: addUnset(align),
            labelFormat: "parse/icons"
        },
        lineHeight: {
            label: "Line Height",
            type: "number"
        },
        letterSpacing: {
            label: "Letter spacing",
            type: "number"
        },
        style: {
            type: "choice",
            options: [
                {
                    value: null,
                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .FontRomanIcon */ .ZVg, {})
                },
                {
                    value: "italic",
                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .FontItalicIcon */ .MzY, {})
                },
                {
                    value: "bold",
                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .FontBoldIcon */ .X20, {})
                }
            ]
        },
        transform: {
            type: "choice",
            options: [
                {
                    value: "uppercase",
                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .LetterCaseUppercaseIcon */ .VsP, {})
                },
                {
                    value: "capitalize",
                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .LetterCaseCapitalizeIcon */ .I6k, {})
                },
                {
                    value: "lowercase",
                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .LetterCaseLowercaseIcon */ .ey0, {})
                },
                {
                    value: null,
                    label: "Unset"
                }
            ]
        },
        selectable: {
            type: "toggle",
            defaultValue: 1
        },
        clip: {
            type: "toggle",
            baseOnly: true
        },
        overflow: {
            type: "choice",
            display: function(props) {
                return (props === null || props === void 0 ? void 0 : props.clip) === 1;
            },
            options: [
                {
                    value: "excerpt",
                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .DotsHorizontalIcon */ .nWS, {})
                },
                {
                    value: "clip",
                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .ScissorsIcon */ .Czr, {})
                },
                {
                    value: null,
                    label: "Overflow"
                }
            ]
        }
    },
    path: "data.font.[field]"
});
var htmlTags = [
    {
        value: null,
        label: "Component"
    },
    {
        value: "div",
        label: "Box"
    },
    {
        value: "p",
        label: "Paragraph"
    },
    {
        value: "span",
        label: "Span"
    },
    {
        value: "article",
        label: "Article"
    },
    {
        value: "main",
        label: "Main"
    },
    {
        value: "section",
        label: "Section"
    },
    {
        value: "nav",
        label: "Nav"
    },
    {
        value: "header",
        label: "Header"
    },
    {
        value: "footer",
        label: "Footer"
    },
    {
        value: "aside",
        label: "Aside"
    },
    {
        value: "address",
        label: "Address"
    },
    {
        value: "blockquote",
        label: "Blockquote"
    },
    {
        value: "cite",
        label: "Citation"
    },
    {
        value: "dt",
        label: "Term"
    },
    {
        value: "ul",
        label: "Unordered list"
    },
    {
        value: "ol",
        label: "Ordered list"
    },
    {
        value: "dl",
        label: "Description list"
    },
    {
        value: "li",
        label: "List item"
    },
    {
        value: "a",
        label: "Link tag"
    },
    {
        value: "strong",
        label: "Strong"
    },
    {
        value: "italic",
        label: "Italic"
    },
    {
        value: "figure",
        label: "Figure"
    },
    {
        value: "figcaption",
        label: "Figure Caption"
    },
    {
        value: "pre",
        label: "Pre"
    },
    {
        value: "code",
        label: "Code"
    },
    {
        value: "dd",
        label: "Description"
    },
    {
        value: "form",
        label: "Form"
    },
    {
        value: "label",
        label: "Label"
    },
    {
        value: "input",
        label: "Input"
    },
    {
        value: "button",
        label: "Button"
    }
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_util_Arr__WEBPACK_IMPORTED_MODULE_8__/* .loopFunc */ .Jc)(6, function(i) {
    return {
        value: "h".concat(i + 1),
        label: "H".concat(i + 1)
    };
}))).map(function(o) {
    return o.value ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, o), {
        label: "".concat(o.label, " <").concat(o.value, ">"),
        tag: o.value
    }) : o;
});
var _obj;
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("tags", {
    name: "tags",
    meta: {
        description: "Attributes",
        helpSource: "layout/coding/inspector"
    },
    props: {
        mainGroup: {
            tag: {
                type: "select",
                options: htmlTags,
                baseOnly: true
            },
            type: {
                type: "select",
                searchable: true,
                baseOnly: true,
                options: "text|password|hidden|email|number|date|time|email|tel".split("|"),
                display: function(props) {
                    return (props === null || props === void 0 ? void 0 : props.tag) === "input";
                }
            },
            anchorId: "string",
            className: "string",
            identifier: "string",
            tabIndex: "string"
        },
        ariaGroup: (_obj = {
            role: "string",
            label: "string",
            describedBy: "string"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, "label", "string"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, "labelledBy", "string"), _obj)
    },
    expand: {
        type: "tab",
        defaultValue: "mainGroup"
    },
    path: "data.tags.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("coding", {
    name: "coding",
    meta: {
        description: "Coding",
        helpSource: "layout/coding/inspector"
    },
    props: {
        css: {
            type: "code",
            lang: "css"
        }
    }
});
_root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.registerFieldset */ .j.registerFieldset("html", {
    name: "html",
    meta: {
        description: "Html",
        helpSource: "layout/html/inspector"
    },
    props: {
        html: {
            type: "code",
            lang: "html"
        }
    }
});
var FIELD_SETS = _root__WEBPACK_IMPORTED_MODULE_4__/* .mosanic.fieldsets */ .j.fieldsets;
var getFieldRules = function(rules, field) {
    return rules && rules["sizing"][field];
};
var getFieldset = function(fieldset) {
    return FIELD_SETS[fieldset];
};
var getFieldsetFields = function(fieldset) {
    var ref, ref1, ref2, ref3, ref4;
    return !Array.isArray((ref = getFieldset(fieldset)) === null || ref === void 0 ? void 0 : (ref1 = ref.props) === null || ref1 === void 0 ? void 0 : ref1.fields) ? Object.entries((ref2 = getFieldset(fieldset)) === null || ref2 === void 0 ? void 0 : ref2.props).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(param, 2), fieldName = _param[0], fieldData = _param[1];
        return {
            fieldName: fieldName,
            fieldData: fieldData
        };
    }) : (ref3 = getFieldset(fieldset)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.props) === null || ref4 === void 0 ? void 0 : ref4.fields;
};
var getFieldsetFieldsAsObject = function(fieldset) {
    return arrToObj(getFieldsetFields(fieldset));
};


/***/ }),

/***/ 8515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dw": function() { return /* binding */ hideFieldset; },
/* harmony export */   "Fe": function() { return /* binding */ getMosanicFields; },
/* harmony export */   "P$": function() { return /* binding */ validateMosanicItem; },
/* harmony export */   "VY": function() { return /* binding */ getItemRules; },
/* harmony export */   "Wg": function() { return /* binding */ getItemSchema; },
/* harmony export */   "kn": function() { return /* binding */ showFieldset; },
/* harmony export */   "mS": function() { return /* binding */ getMosanicTemplate; },
/* harmony export */   "sT": function() { return /* binding */ getItemSchemaRules; },
/* harmony export */   "uc": function() { return /* binding */ fieldHasNoRules; }
/* harmony export */ });
/* unused harmony exports LAYOUT_SCHEMAS, getMosanicSlots */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50930);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62570);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68311);
/* harmony import */ var _fields_Editor_Handler_Content__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32801);
/* harmony import */ var _root__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61541);
/* harmony import */ var _Fieldsets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28585);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21286);
/* harmony import */ var _core_Collections_Field_FieldType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26168);













// const registery = dynamic(() => import("./builder/registery"));
//Rules template
var noWidthRules = function(type) {
    return {
        sizing: {
            width: {
                value: "auto",
                desc: "".concat(type, " width is always 100%.")
            },
            minWidth: {
                value: "auto",
                desc: "Min width can not be set to ".concat(type, ".")
            },
            maxWidth: {
                value: "auto",
                desc: "Max width can not be set to ".concat(type, ".")
            }
        }
    };
};
//Default padding template
var paddingTemplate = {
    top: {
        base: "10px"
    },
    bottom: {
        base: "10px"
    },
    left: {
        base: "10px"
    },
    right: {
        base: "10px"
    }
};
//Default padding box template
var boxTemplate = {
    template: {
        padding: paddingTemplate
    }
};
//Data slot that renders children
var managedSlot = {
    slots: {
        data: {
            manage: true,
            type: "slot"
        }
    }
};
//Identifier input field
var identifierField = {
    fields: {
        identifier: {
            type: "string"
        }
    }
};
//Identifier input and content field
var identifierFieldContent = {
    fields: {
        identifier: {
            type: "string"
        },
        content: {
            type: "string"
        }
    }
};
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "image",
    props: {
        fields: {
            imageUrl: "imageUrl",
            alt: "string",
            optionsGroup: {
                placeholder: {
                    type: "choice",
                    options: "blur|empty".split("|")
                },
                quality: {
                    type: "slider",
                    defaultValue: 100,
                    min: 1,
                    max: 100
                }
            }
        }
    },
    template: {
        sizing: {
            width: {
                base: "100px"
            },
            height: {
                base: "100px"
            }
        }
    },
    expand: "slice"
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "video",
    props: {
        fields: {
            videoUrl: "videoUrl",
            controlGroup: {
                alt: "string",
                controls: "toggle",
                autoplay: "toggle",
                loop: {
                    type: "toggle",
                    defaultValue: true
                },
                cover: "toggle",
                muted: "toggle",
                blur: "toggle",
                overlay: "toggle",
                youtubeUrl: "string"
            }
        }
    },
    expand: {
        type: "tab",
        defaultValue: "videoUrl"
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "imageslider",
    addQuick: true,
    displayName: "Image slider",
    props: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, managedSlot), {
        fields: {
            infinite: "toggle",
            centerMode: "toggle",
            dots: "toggle",
            arrows: "toggle",
            autoplay: "toggle",
            fade: "toggle",
            autoplaySpeed: {
                type: "number",
                defaultValue: 3000,
                baseOnly: true,
                hide: function(props) {
                    return (props === null || props === void 0 ? void 0 : props.autoplay) != 1;
                }
            },
            speed: {
                type: "number",
                defaultValue: 500,
                baseOnly: true
            },
            slidesToShow: {
                type: "number",
                defaultValue: 2
            },
            slidesToScroll: {
                type: "number",
                defaultValue: 1
            },
            devMode: {
                type: "toggle",
                baseOnly: true,
                defaultValue: 1
            }
        }
    }),
    template: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _templates__WEBPACK_IMPORTED_MODULE_3__/* .templates.height */ .z.height)
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "datalink",
    addQuick: true,
    displayName: "Data Link",
    props: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, managedSlot), {
        fields: {
            entry: {
                type: "entry"
            },
            dynamic: "toggle",
            // hasParentLink: "toggle",
            excerpt: "toggle",
            limit: {
                type: "string",
                defaultValue: "50",
                display: function(props) {
                    return props.excerpt;
                }
            },
            end: {
                type: "string",
                defaultValue: "...",
                display: function(props) {
                    return props.excerpt;
                }
            },
            iframe: "toggle",
            html: "toggle"
        }
    }),
    path: "fields.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "dataprovider",
    addQuick: true,
    displayName: "Data Provider",
    props: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, managedSlot), {
        fields: {
            entry: {
                type: "collection"
            }
        }
    }),
    path: "fields.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "stripeprovider",
    addQuick: true,
    displayName: "Stripe Provider",
    props: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, managedSlot), {
        fields: {
            stripe_key: {
                type: "string"
            }
        }
    }),
    path: "fields.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "repeater",
    addQuick: true,
    displayName: "Repeater",
    props: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, managedSlot), {
        fields: {
            collection: {
                type: "collection",
                display: function(props) {
                    return !(props === null || props === void 0 ? void 0 : props.hasParentLink);
                }
            },
            clones: {
                defaultValue: 2,
                type: "number"
            },
            info: {
                type: "label",
                label: "Enable this button also on the child data links to receive the data.",
                display: function(props) {
                    return props === null || props === void 0 ? void 0 : props.hasParentLink;
                }
            },
            hasParentLink: "toggle"
        }
    }),
    template: {
        padding: paddingTemplate
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "icon",
    addQuick: true,
    displayName: "Icon",
    description: "Select or drop an custom icon",
    props: {
        fields: {
            icon: {
                type: "icon"
            },
            invert: "toggle",
            fill: "color"
        },
        hide: [
            "stack",
            "grid",
            "scroll"
        ],
        selected: {
            sizing: [
                "width"
            ]
        }
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "dialog",
    props: {
        slots: {
            data: {
                manage: true,
                type: "slot"
            }
        },
        fields: {
            dialog: {
                type: "dialogSelector",
                baseOnly: true
            },
            title: {
                type: "string"
            },
            size: {
                type: "choice",
                baseOnly: true,
                defaultValue: "md",
                options: [
                    {
                        value: "xxs",
                        label: "Mini"
                    },
                    {
                        value: "xs",
                        label: "Extra small"
                    },
                    {
                        value: "sm",
                        label: "Small"
                    },
                    {
                        value: "md",
                        label: "Medium"
                    },
                    {
                        value: "lg",
                        label: "Large"
                    },
                    {
                        value: "xl",
                        label: "Extra Large"
                    },
                    {
                        value: "xxl",
                        label: "Oversized"
                    }, 
                ]
            }
        },
        hide: [
            "stack",
            "grid",
            "scroll"
        ]
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "gallery",
    addQuick: true,
    description: "Gallery for images",
    props: {
        fields: {
            baseGroup: {
                images: {
                    type: "imageUrls"
                },
                cols: {
                    type: "number",
                    defaultValue: 3
                }
            },
            controlGroup: {
                width: "string",
                height: "string",
                animate: {
                    type: "toggle",
                    defaultValue: true
                },
                scrollable: {
                    type: "toggle",
                    defaultValue: {
                        base: true
                    }
                }
            }
        }
    },
    expand: {
        type: "tab",
        defaultValue: "baseGroup"
    },
    template: {
        padding: paddingTemplate
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "tabheader",
    addQuick: true,
    description: "Header for custom tabs",
    props: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, managedSlot, identifierFieldContent)
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "googlemap",
    addQuick: true,
    description: "Google map",
    props: {
        fields: {
            apiKey: {
                type: "string",
                baseOnly: true
            },
            lat: {
                type: "string",
                baseOnly: true
            },
            lng: {
                type: "string",
                baseOnly: true
            },
            zoom: {
                type: "string",
                defaultValue: "8",
                baseOnly: true
            },
            theme: {
                type: "select",
                options: (0,_Fieldsets__WEBPACK_IMPORTED_MODULE_4__/* .addUnset */ .fN)("dark|light|minimal|custom".split("|"))
            },
            custom: {
                type: "code",
                display: function(props) {
                    return (props === null || props === void 0 ? void 0 : props.theme) === "custom";
                }
            }
        }
    },
    template: {
        sizing: {
            height: {
                base: "150px"
            },
            width: {
                base: "150px"
            }
        }
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    name: "tab",
    addQuick: true,
    description: "Multi purpose container",
    props: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, managedSlot, identifierField)
}, boxTemplate));
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    name: "tabs",
    addQuick: true,
    description: "Schema for custom tabs",
    props: {
        slots: {
            header: {
                manage: true,
                type: "slot",
                allowed: [
                    "tabheader",
                    "tabheaders",
                    "container"
                ]
            },
            tabs: {
                manage: true,
                type: "slot",
                allowed: [
                    "tab",
                    "container"
                ]
            }
        },
        fields: {
            content: {
                type: "string",
                defaultValue: "Tabs"
            },
            active: {
                type: "string",
                defaultValue: "1"
            }
        }
    }
}, boxTemplate));
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "expanderheader",
    addQuick: true,
    description: "Header for expander",
    props: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, managedSlot, identifierFieldContent)
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    name: "expander",
    addQuick: true,
    description: "Multi droppable accordion expander",
    props: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, managedSlot, identifierFieldContent)
}, boxTemplate));
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    name: "expanders",
    addQuick: true,
    description: "Schema for expanders",
    props: {
        slots: {
            expanders: {
                manage: true,
                type: "slot",
                allowed: [
                    "expander",
                    "expanderheader",
                    "container",
                    "stack"
                ]
            }
        },
        fields: {
            active: {
                type: "string",
                defaultValue: "1"
            },
            closeOther: {
                type: "toggle",
                label: "Auto close other expanders",
                defaultValue: "1"
            }
        }
    }
}, boxTemplate));
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "button",
    addQuick: true,
    description: "Schema for a customizable button",
    props: {
        slots: {
            start: {
                max: 1,
                type: "slot",
                allowed: [
                    "icon",
                    "image"
                ]
            },
            content: "render",
            // renderAter: "2after -  ",
            // preBuild: {
            //   type: "string",
            //   defaultValue: 'preBlTest '
            // },
            end: {
                max: 1,
                type: "slot",
                allowed: [
                    "icon",
                    "image"
                ]
            }
        },
        fields: {
            content: {
                type: "string",
                defaultValue: "Button",
                localized: function(props) {
                    return (props === null || props === void 0 ? void 0 : props.translate) === 1;
                },
                baseOnly: true
            },
            translate: {
                type: "toggle",
                label: "translate text",
                defaultValue: 0,
                baseOnly: true
            },
            action: {
                type: "choice",
                options: (0,_Fieldsets__WEBPACK_IMPORTED_MODULE_4__/* .addUnset */ .fN)([
                    "link",
                    "trigger"
                ]),
                baseOnly: true
            },
            href: {
                type: "link",
                baseOnly: true,
                display: function(props) {
                    return (props === null || props === void 0 ? void 0 : props.action) === "link";
                }
            },
            target: {
                type: "select",
                clearable: false,
                searchable: true,
                multiple: false,
                autoClose: true,
                baseOnly: true,
                options: [
                    "default",
                    "_blank",
                    "_window"
                ],
                display: function(props) {
                    return (props === null || props === void 0 ? void 0 : props.action) === "link";
                }
            },
            toTop: {
                type: "toggle",
                display: function(props) {
                    return (props === null || props === void 0 ? void 0 : props.action) === "link";
                }
            },
            type: {
                type: "select",
                clearable: false,
                searchable: true,
                multiple: false,
                autoClose: true,
                baseOnly: true,
                options: [
                    "locale",
                    "form submit",
                    "form toggle"
                ],
                display: function(props) {
                    return (props === null || props === void 0 ? void 0 : props.action) === "trigger";
                }
            }
        },
        hide: [
            "grid",
            "scroll"
        ],
        rules: {
            sizing: {
                height: {
                    value: "auto",
                    desc: "Height is always auto"
                },
                maxHeight: {
                    value: "auto",
                    desc: "Max height is always auto"
                }
            }
        }
    },
    fieldPath: "fields",
    template: {
        padding: paddingTemplate,
        sizing: {
            minWidth: {
                base: "100px"
            }
        }
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "link",
    addQuick: true,
    props: {
        // slots: {
        //   start: {
        //     type: "slot",
        //   },
        // },
        fields: {
            href: "link",
            target: {
                type: "select",
                clearable: false,
                searchable: true,
                multiple: false,
                autoClose: true,
                baseOnly: true,
                options: [
                    "default",
                    "_blank",
                    "_window"
                ]
            },
            toTop: "toggle"
        }
    },
    template: {
        sizing: {
            minHeight: {
                base: "10px"
            }
        }
    },
    fieldPath: "fields"
});
//Visual text area
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "text",
    props: {
        fields: {
            content: {
                type: "editor",
                display: function(props) {
                    return (props === null || props === void 0 ? void 0 : props.translate) != 1;
                },
                baseOnly: true,
                defaultValue: (0,_fields_Editor_Handler_Content__WEBPACK_IMPORTED_MODULE_5__/* .getInitialContent */ .M)("Mosanic visual text area", "p")
            },
            i18: {
                type: "editor",
                display: function(props) {
                    return props === null || props === void 0 ? void 0 : props.translate;
                },
                defaultValue: {
                    en: (0,_fields_Editor_Handler_Content__WEBPACK_IMPORTED_MODULE_5__/* .getInitialContent */ .M)("English visual area", "p"),
                    nl: (0,_fields_Editor_Handler_Content__WEBPACK_IMPORTED_MODULE_5__/* .getInitialContent */ .M)("Dutch visual area", "p")
                },
                localized: true
            },
            translate: {
                type: "toggle",
                label: "translate text",
                defaultValue: 0,
                baseOnly: true
            }
        },
        hide: [
            "stack",
            "grid",
            "scroll"
        ],
        rules: {
            sizing: {
                height: {
                    value: "auto",
                    desc: "Height is always auto"
                },
                maxHeight: {
                    value: "auto",
                    desc: "Max height is always auto"
                }
            }
        },
        selected: {
            sizing: [
                "maxWidth"
            ]
        }
    },
    fieldPath: "fields"
});
//Localized content
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "localizedtext",
    props: {
        fields: {
            content: {
                type: "editor",
                defaultValue: {
                    en: (0,_fields_Editor_Handler_Content__WEBPACK_IMPORTED_MODULE_5__/* .getInitialContent */ .M)("English visual area", "p"),
                    nl: (0,_fields_Editor_Handler_Content__WEBPACK_IMPORTED_MODULE_5__/* .getInitialContent */ .M)("Dutch visual area", "p")
                },
                localized: true
            }
        },
        hide: [
            "stack",
            "grid",
            "scroll"
        ]
    }
});
//Simple text area
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "content",
    props: {
        fields: {
            content: {
                type: "content",
                defaultValue: "Mosanic text area content."
            }
        },
        hide: [
            "stack",
            "grid",
            "scroll"
        ]
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "heading",
    props: {
        slots: {
            data: {
                manage: true,
                type: "slot",
                allowed: [
                    "datalink"
                ]
            }
        },
        fields: {
            content: {
                type: "string",
                defaultValue: "Mosanic Heading"
            },
            level: {
                type: "choice",
                baseOnly: true,
                defaultValue: "2",
                options: [
                    {
                        value: "1",
                        label: "H1"
                    },
                    {
                        value: "2",
                        label: "H2"
                    },
                    {
                        value: "3",
                        label: "H3"
                    },
                    {
                        value: "4",
                        label: "H4"
                    },
                    {
                        value: "5",
                        label: "H5"
                    },
                    {
                        value: "6",
                        label: "H6"
                    }, 
                ]
            }
        },
        hide: [
            "stack",
            "grid",
            "scroll"
        ]
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "code",
    addQuick: true,
    displayName: "Code editor",
    description: "Edit code.",
    props: {
        fields: {
            language: {
                type: "select",
                options: "js|html|css|json".split("|"),
                baseOnly: true
            },
            content: {
                type: "code"
            }
        },
        show: [
            "fields"
        ]
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "script",
    addQuick: true,
    displayName: "Script link",
    description: "Insert script tag.",
    props: {
        fields: {
            url: {
                type: "string"
            },
            strategy: {
                type: "select",
                options: "afterInteractive|beforeInteractive|lazyOnload|worker".split("|")
            },
            dataAttrObject: {
                type: "code"
            },
            inlineScriptCode: {
                type: "code"
            },
            onLoadCode: {
                type: "code"
            },
            onReadyCode: {
                type: "code"
            },
            onErrorFunc: {
                type: "code"
            },
            dangerCode: {
                type: "code"
            }
        },
        show: [
            "fields"
        ]
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "menu",
    addQuick: true,
    description: "Schema for a menu rendering",
    props: {
        fields: {
            menu: {
                type: "select",
                option: [
                    "main",
                    "sub",
                    "footer"
                ]
            }
        },
        hide: [
            "grid",
            "scroll"
        ]
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "form",
    addQuick: true,
    displayName: "Form",
    props: {
        slots: {
            data: {
                manage: true,
                type: "slot"
            }
        },
        fields: {
            formGroup: {
                form: {
                    type: "form",
                    display: function(props) {
                        return !props.login;
                    }
                },
                when: {
                    type: "form",
                    display: function(props) {
                        return !props.login;
                    }
                },
                verifyEmail: {
                    baseOnly: true,
                    type: "toggle",
                    display: function(props) {
                        return props.login;
                    }
                },
                registerLink: {
                    baseOnly: true,
                    type: "link",
                    display: function(props) {
                        return props.login;
                    }
                },
                forwardSlug: {
                    baseOnly: true,
                    type: "link",
                    display: function(props) {
                        return props.login;
                    }
                }
            },
            inputGroup: {
                background: "color",
                color: "color",
                border: "string",
                radius: {
                    type: "number",
                    baseOnly: true
                }
            },
            actionGroup: {
                respond: "string",
                advanced: "toggle",
                login: "toggle"
            }
        }
    },
    expand: {
        type: "tab",
        defaultValue: "formGroup"
    },
    path: "fields.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "account",
    addQuick: true,
    displayName: "Account",
    props: {
        fields: {
            pageGroup: {
                screen: {
                    baseOnly: true,
                    type: "select",
                    options: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("user|profile|account|preferences|security".split("|")).concat([
                        {
                            value: null,
                            label: "All"
                        }
                    ])
                },
                tab: {
                    type: "select",
                    baseOnly: true,
                    options: "user|profile|account|preferences|security".split("|"),
                    searchable: false,
                    display: function(props) {
                        return !props.screen;
                    }
                }
            },
            accountGroup: {
                settings: {
                    type: "string",
                    defaultValue: "Your personal details and information."
                },
                author: {
                    type: "string",
                    defaultValue: "This information is displayed under the articles created by you."
                },
                collections: {
                    type: "content"
                }
            },
            prefGroup: {
                interface: {
                    baseOnly: true,
                    type: "toggle"
                },
                help: {
                    baseOnly: true,
                    type: "toggle"
                },
                privacy: {
                    baseOnly: true,
                    type: "toggle"
                },
                builder: {
                    baseOnly: true,
                    type: "toggle"
                },
                dashboard: {
                    baseOnly: true,
                    type: "toggle"
                },
                mail: {
                    baseOnly: true,
                    type: "toggle"
                },
                platformName: {
                    type: "string"
                }
            },
            securityGroup: {
                twoStepsVerification: {
                    baseOnly: true,
                    type: "toggle"
                },
                passwordText: {
                    defaultValue: "Your password and login to your account.",
                    baseOnly: true,
                    type: "string"
                }
            },
            loginGroup: {
                loginText: {
                    type: "string",
                    baseOnly: true
                },
                verifyEmail: {
                    baseOnly: true,
                    type: "toggle"
                },
                registerText: {
                    type: "string",
                    baseOnly: true
                },
                registerLink: {
                    baseOnly: true,
                    type: "link"
                },
                forwardText: {
                    type: "string",
                    baseOnly: true
                },
                forwardSlug: {
                    baseOnly: true,
                    type: "link"
                }
            }
        }
    },
    expand: {
        type: "tab",
        defaultValue: "page"
    },
    path: "fields.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "auth",
    addQuick: true,
    displayName: "Auth forms",
    props: {
        fields: {
            type: {
                type: "select",
                baseOnly: true,
                options: "login|register|reset|all".split("|")
            },
            onePage: {
                type: "switch",
                baseOnly: true
            }
        }
    },
    // expand: {
    //   type: 'tab',
    //   defaultValue: 'page',
    // },
    path: "fields.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "user",
    addQuick: true,
    displayName: "User",
    props: {
        fields: {
            type: {
                type: "select",
                baseOnly: true,
                options: "login|register|reset|all".split("|")
            },
            onePage: {
                type: "switch",
                baseOnly: true
            }
        }
    },
    // expand: {
    //   type: 'tab',
    //   defaultValue: 'page',
    // },
    path: "fields.[field]"
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "inputfield",
    addQuick: true,
    displayName: "Input",
    props: {
        fields: {
            field: {
                type: "inputfield"
            },
            fieldType: {
                type: "select",
                options: _core_Collections_Field_FieldType__WEBPACK_IMPORTED_MODULE_7__/* .inputFields */ .N,
                baseOnly: true
            }
        }
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "screen",
    props: {
        hide: [
            "stack",
            "grid",
            "flex",
            "margin"
        ],
        fields: {
            name: "string"
        },
        rules: {
            sizing: {
                height: {
                    value: "auto",
                    desc: "Height is always auto"
                },
                minHeight: {
                    value: "auto",
                    desc: "Min height can't be defined yet"
                },
                maxHeight: {
                    value: "auto",
                    desc: "Max height can't be defined yet"
                }
            }
        },
        selected: {
            sizing: [
                "maxWidth"
            ]
        }
    }
});
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    name: "column",
    props: {
        // "hide": ["stack", "grid", "scroll"],
        rules: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, noWidthRules("column")),
        selected: {
            sizing: [
                "height"
            ]
        }
    }
}, boxTemplate));
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    name: "row",
    props: {
        // "hide": ["stack", "grid", "scroll"],
        fields: {},
        rules: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, noWidthRules("row")),
        selected: {
            sizing: [
                "height"
            ]
        }
    }
}, boxTemplate));
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    name: "columns",
    props: {
        fields: {
            containerMaxWidth: "string",
            containerMinWidth: "string"
        },
        // "hide": ["stack", "grid", "scroll"],
        rules: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, noWidthRules("columns")),
        selected: {
            sizing: [
                "height"
            ]
        }
    }
}, boxTemplate));
_root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.registerComponent */ .j.registerComponent({
    name: "socialgrid",
    addQuick: true,
    description: "Schema for social grid",
    props: {
        fields: {
            tokenKey: {
                type: "string",
                defaultValue: "IGQVJVa2pjM3pCbU9seENnaUQ0XzJRWXp2c0FYZAXA3b1RlbWlyYmpqMmJia0VTSzJvMEdjWkJkeXNnSWNON2ZAhT2tDeUNhS2xrenNfVHJwRFhKdF9COWdmd1dGT0xpRkZAyejJ3R3ZAlU0x4NEI3eDM3MgZDZD",
                baseOnly: true
            },
            show: {
                type: "number",
                baseOnly: true,
                defaultValue: 6
            }
        }
    },
    template: {
        paddingTemplate: paddingTemplate
    }
});
var LAYOUT_SCHEMAS = _root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.schemas */ .j.schemas;
var getItemSchema = function(type) {
    return LAYOUT_SCHEMAS[type];
};
var getRules = function(type) {
    var ref, ref1;
    return (ref = getItemSchema(type)) === null || ref === void 0 ? void 0 : (ref1 = ref.props) === null || ref1 === void 0 ? void 0 : ref1.rules;
};
var getItemRules = function(type, fieldset) {
    var ref;
    return getRules(type) && ((ref = getRules(type)) === null || ref === void 0 ? void 0 : ref[fieldset]);
};
var hideFieldset = function(type, fieldset) {
    var ref, ref1, ref2;
    return Boolean((ref = getItemSchema(type)) === null || ref === void 0 ? void 0 : (ref1 = ref.props) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.hide) === null || ref2 === void 0 ? void 0 : ref2.includes(fieldset));
};
var showFieldset = function(type, fieldset) {
    var ref, ref1;
    var show = (ref = getItemSchema(type)) === null || ref === void 0 ? void 0 : (ref1 = ref.props) === null || ref1 === void 0 ? void 0 : ref1.show;
    return Boolean(show) ? show === null || show === void 0 ? void 0 : show.includes(fieldset) : true;
};
var getItemSchemaRules = function(type, fieldset) {
    var ref;
    return getRules(type) && ((ref = getRules(type)) === null || ref === void 0 ? void 0 : ref[fieldset]);
};
var fieldHasNoRules = function(rules, field) {
    return !(0,_util_Obj__WEBPACK_IMPORTED_MODULE_8__/* .hasAttr */ .B$)(rules, field);
};
//Initialization
var getMosanicTemplate = function(type) {
    var ref;
    if ((0,_util_Text__WEBPACK_IMPORTED_MODULE_9__/* .containsSubstr */ .xX)(type, "stack")) type = "stack";
    return (ref = _root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.schemas */ .j.schemas[type]) === null || ref === void 0 ? void 0 : ref.template;
};
var getMosanicFields = function(type) {
    var ref, ref1;
    var fields = (ref = _root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.schemas */ .j.schemas[type]) === null || ref === void 0 ? void 0 : (ref1 = ref.props) === null || ref1 === void 0 ? void 0 : ref1.fields;
    if (!fields) return null;
    var data = {};
    Object.entries(fields).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(param, 2), attr = _param[0], field = _param[1];
        data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, data), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, attr, (field === null || field === void 0 ? void 0 : field.defaultValue) ? field.defaultValue : null));
    });
    return data;
};
var getMosanicSlots = function(type) {
    var ref, ref1;
    return (ref = _root__WEBPACK_IMPORTED_MODULE_0__/* .mosanic.schemas */ .j.schemas[type]) === null || ref === void 0 ? void 0 : (ref1 = ref.props) === null || ref1 === void 0 ? void 0 : ref1.slots;
};
var isField = function(child) {
    return child === "fields" || (child === null || child === void 0 ? void 0 : child.type) === "fields";
};
var isSlot = function(child) {
    return child === "slot" || (child === null || child === void 0 ? void 0 : child.type) === "slot";
};
var validateMosanicItem = function(item) {
    var slots = getMosanicSlots(item === null || item === void 0 ? void 0 : item.type);
    if (!slots) return item;
    var children = [];
    Object.entries(slots).map(function(param, index) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(param, 2), slot = _param[0], slotValue = _param[1];
        if (isField(slotValue)) return;
        if (isSlot(slotValue)) {
            children.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, slotValue), {
                position: slot
            }));
        } else {
            var field = {
                data: slot
            };
            field = !(0,_util_Text__WEBPACK_IMPORTED_MODULE_9__/* .isString */ .HD)(slotValue) ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, field, slotValue) : (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, field), {
                type: slotValue
            });
            children.push(field);
        }
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item), {
        children: children
    });
};


/***/ }),

/***/ 21286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ templates; }
/* harmony export */ });
var paddingTemplate = {
    top: {
        base: "10px"
    },
    bottom: {
        base: "10px"
    },
    left: {
        base: "10px"
    },
    right: {
        base: "10px"
    }
};
var verticalTemplate = {
    padding: paddingTemplate,
    display: {
        direction: {
            base: "vertical"
        },
        wrap: 1
    }
};
var horizontalTemplate = {
    padding: paddingTemplate,
    display: {
        direction: {
            base: "horizontal"
        }
    }
};
var containerTemplate = {
    padding: paddingTemplate
};
var minHeightTemplate = {
    sizing: {
        minHeight: {
            base: "10px"
        }
    }
};
var templates = {
    vertical: verticalTemplate,
    horizontal: horizontalTemplate,
    container: containerTemplate,
    height: minHeightTemplate
};


/***/ }),

/***/ 36086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ AuthForm; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/fields/Editor/Text.js
var Text = __webpack_require__(50703);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/adapters/mutations/auth.js
var auth = __webpack_require__(37029);
// EXTERNAL MODULE: ./src/hooks/useApi.js + 3 modules
var useApi = __webpack_require__(70210);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/index.js
var Input = __webpack_require__(6928);
// EXTERNAL MODULE: ./src/mosanic/hooks/useNotify.js
var useNotify = __webpack_require__(33346);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/items/LoadingDots.tsx
var LoadingDots = __webpack_require__(4093);
// EXTERNAL MODULE: ./src/mosanic/items/Link/index.js
var Link = __webpack_require__(8152);
// EXTERNAL MODULE: ./src/utils/server/cookie.js
var cookie = __webpack_require__(18053);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
;// CONCATENATED MODULE: ./src/components/Core/Utils/SubmitButtonHelper.js

var SubmitButtonHelper = function(param) {
    var mustShowHelper = param.mustShowHelper, _action = param.action, action = _action === void 0 ? "Submit" : _action;
    return mustShowHelper ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
        id: "submitHelp",
        className: "form-text text-muted",
        style: {
            opacity: 0.4
        },
        children: [
            action,
            " is disabled until valid data is entered in the form"
        ]
    }) : null;
};

// EXTERNAL MODULE: ./src/utils/server/validations.js
var validations = __webpack_require__(11095);
// EXTERNAL MODULE: ./src/adapters/constants.js
var constants = __webpack_require__(1418);
// EXTERNAL MODULE: ./src/features/auth/action.js
var action = __webpack_require__(13213);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
;// CONCATENATED MODULE: ./src/mosanic/auth/LoginForm.js



















var LoginForm = function(param) {
    var mode = param.mode, setMode = param.setMode, verify = param.verify, redirect = param.redirect, _accountActions = param.accountActions, accountActions = _accountActions === void 0 ? true : _accountActions, _setStep = param.setStep, setStep = _setStep === void 0 ? null : _setStep;
    var ref = (0,index_esm/* useForm */.cI)({
        mode: "all"
    }), handleSubmit = ref.handleSubmit, control = ref.control, watch = ref.watch, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors,
        size: "large"
    };
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useApi/* useMutate */.Tu)("loginUser", auth/* LOGIN */.ym), 2), loginUser = ref1[0], ref2 = (0,_sliced_to_array/* default */.Z)(ref1[1], 3), login = ref2[0], loading = ref2[1], error = ref2[2];
    var notify = (0,useNotify/* default */.Z)();
    var onSubmit = function(data) {
        var remember = data.remember;
        var variables = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            verify: verify,
            templateId: "d-44b2808280d04801b306a70f217c6bcd"
        });
        loginUser(variables).then(function(response) {
            var res = response;
            var _$data = res.data, error = res.error;
            if (_$data === null || _$data === void 0 ? void 0 : _$data.loginUser) _$data = _$data === null || _$data === void 0 ? void 0 : _$data.loginUser;
            if (_$data && !error) {
                if ((_$data === null || _$data === void 0 ? void 0 : _$data.status) === 200 && (_$data === null || _$data === void 0 ? void 0 : _$data.response)) {
                    if (verify) {
                        setMode({
                            step: "verification",
                            email: variables === null || variables === void 0 ? void 0 : variables.email,
                            remember: remember
                        });
                        notify("Verification code send to your email.", "[login]", "info");
                        (0,cookie/* saveCookie */.YB)(constants/* AUTH_EMAIL_REF */.h, variables === null || variables === void 0 ? void 0 : variables.email);
                    } else if ((_$data === null || _$data === void 0 ? void 0 : _$data.status) === 200) {
                        if (redirect) router.push(redirect);
                        dispatch((0,action/* activateAuthAction */.sd)({
                            token: _$data.token,
                            remember: true
                        }));
                    } else {
                        notify("Could not login, refresh and try again.", "login", "error");
                    }
                } else {
                    notify("Unknown response.", "[login]", "info");
                }
            }
            if (error) {
                notify("Could not login, refresh and try again.", "login", "error");
            }
        });
    };
    // useEffect(() => {
    // 	if(login?.token && login?.status === 200) {
    // 		activateAuth({token: login.token, remember:true});
    // 	}
    // },[login, activateAuth])
    // email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
    // /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!*^?+-_@#$%&]{8,}$/
    //form-row mb-3
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                        center: true,
                        style: {
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                style: {
                                    maxWidth: "300px"
                                },
                                name: "email",
                                type: "email"
                            }, inputProps), {
                                rules: {
                                    required: "You should enter in you're email"
                                }
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                style: {
                                    maxWidth: "300px"
                                },
                                name: "password",
                                placeholder: "****",
                                type: "password"
                            }, inputProps), {
                                rules: {
                                    required: "You should enter in you're password"
                                }
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroupItem */.oV, {
                                mb: 4,
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    label: " Remember me",
                                    name: "remember"
                                }, inputProps), {
                                    type: "checkbox"
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                width: [
                                    1,
                                    "200px",
                                    "250px"
                                ],
                                label: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : "Log in",
                                theme: "primary",
                                size: "large",
                                type: "submit",
                                disabled: Boolean(!isValid)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButtonHelper, {
                        action: "Login",
                        mustShowHelper: !(0,validations.validateLoginForm)(watch().email, watch().password)
                    })
                ]
            }),
            error,
            accountActions && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-bottom text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "sign-up-text",
                        children: [
                            "Don't have an account?",
                            " ",
                            setStep ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: function() {
                                    return setStep("register");
                                },
                                children: "Register"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "/register",
                                color: "primary",
                                children: "Register"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "sign-up-text",
                        style: {
                            opacity: 0.7,
                            fontSize: "70%"
                        },
                        children: [
                            "Want to reset your password?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "/reset",
                                color: "primary",
                                children: "Reset"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/adapters/token.js + 1 modules
var token = __webpack_require__(94645);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/adapters/host.js
var host = __webpack_require__(6539);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/utils/Text.js
var utils_Text = __webpack_require__(68311);
;// CONCATENATED MODULE: ./src/mosanic/auth/VerifyForm.js




















var VerifyForm = function(param) {
    var activateAuth = param.activateAuth, redirect = param.redirect, mode = param.mode, setMode = param.setMode, _verifyCode = param.verifyCode, verifyCode = _verifyCode === void 0 ? null : _verifyCode;
    var email = (mode === null || mode === void 0 ? void 0 : mode.email) || (0,cookie/* recoverCookie */.DX)(constants/* AUTH_EMAIL_REF */.h);
    var router = (0,next_router.useRouter)();
    var ref = (0,index_esm/* useForm */.cI)({
        mode: "all"
    }), handleSubmit = ref.handleSubmit, control = ref.control, watch = ref.watch, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors,
        size: "large"
    };
    var ref1 = (0,react.useState)(false), disabled = ref1[0], setDisabled = ref1[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useApi/* useMutate */.Tu)("authUser", auth/* AUTH_LOGIN */.C8), 2), authUser = ref2[0], ref3 = (0,_sliced_to_array/* default */.Z)(ref2[1], 3), token = ref3[0], loading = ref3[1], error = ref3[2];
    var notify = (0,useNotify/* default */.Z)();
    var onSubmit = (0,react.useCallback)(function(data) {
        setDisabled(true);
        if (!email) {
            notify("Did not receive an email.", "login", "error");
            return;
        }
        if (!(data === null || data === void 0 ? void 0 : data.code)) {
            notify("Did not receive an confirmation code.", "login", "error");
            return;
        }
        var variables = {
            code: data.code,
            email: email
        };
        authUser(variables).then(function(res) {
            var _$data = res.data, error = res.error;
            if (_$data === null || _$data === void 0 ? void 0 : _$data.authUser) _$data = _$data.authUser;
            if (_$data && !error) {
                dispatch((0,action/* activateAuthAction */.sd)({
                    token: _$data.token,
                    remember: true
                })) //mode.remember
                ;
                if (redirect) router.push(redirect);
                (0,cookie/* deleteCookie */.kT)(constants/* AUTH_EMAIL_REF */.h);
            }
            if (error) {
                setDisabled(false);
            }
        });
    }, [
        authUser,
        dispatch,
        email,
        mode.remember,
        notify,
        redirect,
        router
    ]);
    (0,react.useEffect)(function() {
        if (verifyCode && email) {
            onSubmit({
                code: verifyCode
            });
        }
    }, [
        email,
        verifyCode,
        onSubmit
    ]);
    //form-row mb-3
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                disabled: disabled,
                onSubmit: handleSubmit(onSubmit),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                    center: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            sanitize: function(e) {
                                return (0,utils_Text/* replacePart */.bA)(e, " ", "-");
                            },
                            style: {
                                maxWidth: "300px"
                            },
                            name: "code",
                            label: "Verification code"
                        }, inputProps), {
                            rules: {
                                required: "Enter the code received in your mail."
                            }
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            wrap: true,
                            width: [
                                1,
                                "200px"
                            ],
                            label: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : "Verify login",
                            theme: "primary",
                            size: "large",
                            type: "submit",
                            disabled: Boolean(loading || !isValid)
                        })
                    ]
                })
            }),
            error,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-bottom text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "sign-up-text",
                        children: [
                            "Don’t have an account?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "/register",
                                color: "primary",
                                children: "Register"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                        title: "\uD83D\uDCE9 Verification code help",
                        size: "sm",
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                            label: "Didn't receive a code? ",
                            span: true,
                            style: {
                                cursor: "pointer"
                            }
                        }),
                        children: [
                            "You should receive a verification email within 5 minutes after login. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Send to: ",
                            mode === null || mode === void 0 ? void 0 : mode.email,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "If you're not seeing it in your inbox, check out these suggestions:",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Refresh mailbox"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Check Spam & junk folder"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Check for typos in the login"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Add @mosanic.io to your contact safelist"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "If you've tried these steps without any success, ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: (0,host/* getDocsUrl */.V)("account/login"),
                                children: "learn more."
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Or ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "mailto:help@mosanic.io",
                                children: "contact our support team"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                        onClick: function() {
                            return setMode({
                                step: "login"
                            });
                        },
                        style: {
                            color: colors/* default.util.primary.base */.ZP.util.primary.base,
                            display: "block",
                            cursor: "pointer"
                        },
                        label: "Go back"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/mosanic/auth/AuthForm.js



// import { providers, signIn, useSession, signOut } from "next-auth/react"







var AuthForm = function(param) {
    var verifyCode = param.verifyCode, verify = param.verify, _accountActions = param.accountActions, accountActions = _accountActions === void 0 ? false : _accountActions, _setStep = param.setStep, setStep = _setStep === void 0 ? null : _setStep, _content = param.content, content = _content === void 0 ? {
        platformName: "Mosanic",
        header: null
    } : _content, _redirect = param.redirect, redirect = _redirect === void 0 ? "/" : _redirect;
    var isAuth = (0,es/* useSelector */.v9)(reducer/* isAuthSelector */.Kj) && (0,token/* isAuthenticated */.$8)();
    var ref = (0,react.useState)({
        step: "login"
    }), mode = ref[0], setMode = ref[1];
    var email = (mode === null || mode === void 0 ? void 0 : mode.email) || (0,cookie/* recoverCookie */.DX)(constants/* AUTH_EMAIL_REF */.h);
    var isLogin = (mode === null || mode === void 0 ? void 0 : mode.step) === "login" && !verifyCode || !email;
    var title = isAuth ? "Login successfully." : isLogin ? "Welcome Back" : "Verify login";
    var desc = isAuth ? "Hold on, we are redirecting you." : isLogin ? "Continue your work by singing in below." : "Enter your verification code below.";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            Array.isArray(content === null || content === void 0 ? void 0 : content.header) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                content: content.header
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: desc
                    })
                ]
            }),
            Array.isArray(content === null || content === void 0 ? void 0 : content.header) && !isAuth && !isLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: desc
            }),
            !isAuth ? isLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm, {
                setMode: setMode,
                verify: verify,
                redirect: redirect,
                accountActions: accountActions,
                setStep: setStep
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyForm, {
                redirect: redirect,
                mode: mode,
                setMode: setMode,
                verifyCode: verifyCode,
                setStep: setStep
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                href: redirect,
                label: "Dashboard",
                width: [
                    1,
                    "90%"
                ],
                size: "large",
                theme: "primary",
                style: {
                    color: "white"
                }
            })
        ]
    });
};


/***/ }),

/***/ 64201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ auth_Register; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/fields/Editor/Text.js
var Text = __webpack_require__(50703);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/items/Link/index.js
var Link = __webpack_require__(8152);
// EXTERNAL MODULE: ./src/features/auth/action.js
var action = __webpack_require__(13213);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/adapters/mutations/auth.js
var auth = __webpack_require__(37029);
// EXTERNAL MODULE: ./src/hooks/useApi.js + 3 modules
var useApi = __webpack_require__(70210);
// EXTERNAL MODULE: ./src/mosanic/components/Mail/useSendOne.js
var useSendOne = __webpack_require__(16956);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/index.js
var Input = __webpack_require__(6928);
// EXTERNAL MODULE: ./src/mosanic/hooks/useNotify.js
var useNotify = __webpack_require__(33346);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/utils/server/validations.js
var validations = __webpack_require__(11095);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ./src/mosanic/items/Progress/Progress.js + 1 modules
var Progress = __webpack_require__(85774);
;// CONCATENATED MODULE: ./src/mosanic/auth/RegisterForm.js






















var Images = function(param) {
    var urls = param.urls;
    return urls ? /*#__PURE__*/ _jsx(ImageStack, {
        width: (urls === null || urls === void 0 ? void 0 : urls.length) * 30,
        children: urls.map(function(url, index) {
            return /*#__PURE__*/ _jsx("span", {
                style: {
                    transitionDelay: index % 2 ? "0.9s" : 0,
                    transition: "all ease-out 0.3s",
                    margin: index % 2 ? "" : "0 -7.5px",
                    zIndex: index % 2 ? 1 : 0
                },
                children: /*#__PURE__*/ _jsx(RoundedImage, {
                    src: url,
                    width: index % 2 ? "40px" : "30px",
                    height: index % 2 ? "40px" : "30px",
                    alt: "img"
                })
            });
        })
    }) : null;
};
var RegisterForm = function(param) {
    var activateAuth = param.activateAuth, _accountActions = param.accountActions, accountActions = _accountActions === void 0 ? false : _accountActions;
    var ref, ref1, ref2;
    var ref3 = (0,index_esm/* useForm */.cI)({
        mode: "all"
    }), handleSubmit = ref3.handleSubmit, control = ref3.control, watch = ref3.watch, _formState = ref3.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useSendOne/* useSendOne */.x)(), 3), sendMail = ref4[0], sendData = ref4[1], sendLoading = ref4[2];
    var router = (0,next_router.useRouter)();
    var ref5 = (0,react.useState)(false), disabled = ref5[0], setDisabled = ref5[1];
    var ref6 = (0,react.useState)(null), error = ref6[0], setError = ref6[1];
    var ref7 = (0,react.useState)(false), agree = ref7[0], setAgree = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useApi/* useMutate */.Tu)("registerUser", auth/* REGISTER */.Nz), 2), registerUser = ref8[0], ref9 = (0,_sliced_to_array/* default */.Z)(ref8[1], 3), token = ref9[0], loading = ref9[1], registerError = ref9[2];
    // pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!*^?+-_@#$%&]{8,}$"
    var notify = (0,useNotify/* default */.Z)();
    var onSubmit = function(data) {
        setDisabled(true);
        setError(null);
        var variables = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            agree: undefined,
            repeatPassword: undefined
        });
        registerUser(variables).then(function(res) {
            var _$data = res.data, error = res.error;
            if (_$data === null || _$data === void 0 ? void 0 : _$data.registerUser) _$data = _$data.registerUser;
            if (!error) {
                var token = _$data.token;
                dispatch((0,action/* activateAuthAction */.sd)({
                    token: token,
                    redirect: false,
                    remember: true
                }));
                sendMail({
                    subject: "Welcome on Mosanic ".concat(variables.firstName, "!"),
                    to: variables.email,
                    preHeader: "You're journey starts today! Start exploring, start building and grow your online presence.",
                    subHeader: "Time to explore \uD83D\uDE80",
                    mainHeader: "Welcome ".concat(variables.firstName, " ").concat(variables.lastName, "."),
                    mainText: "We will guarantee you that the next steps will be as simple as the signup.\n\nYou're curious on how you can start as soon as possible, right?\n\nWe've setup a quick start guide that will explain the main topics and features. \n\nYou will find it in the header of your dashboard or at https://docs.mosanic.io/quick-start \n\nIt contains a few short visual pages so you know the basics and can start building.\n\nBut we really recommend you to dive deeper and explore the docs after.\n\n\nAin't a big fan of reading?\n\nMosanic offers a great experience out of the box, so if you prefer learning by try error.\n\nGo ahead! Just now that there is enough reference material to learn more..  \n \n Kind Regards, \n The Mosanic Team"
                });
                setTimeout(function() {
                    router.push({
                        pathname: "/",
                        query: {
                            type: "setup"
                        }
                    });
                }, 500);
            } else {
                notify("Registration failed, please reload and try again.");
                setError(e.message);
                setDisabled(false);
            }
        });
    };
    var isValidated = (0,validations.validateRegisterForm)(watch().email, watch().password, watch().repeatPassword);
    var status = watch();
    var step = function() {
        if (status === null || status === void 0 ? void 0 : status.group) return 1;
        if ((status === null || status === void 0 ? void 0 : status.firstName) && (status === null || status === void 0 ? void 0 : status.lastName) && (status === null || status === void 0 ? void 0 : status.email) && (status === null || status === void 0 ? void 0 : status.password) && (status === null || status === void 0 ? void 0 : status.repeatPassword)) return 2;
    };
    var percentage = ((ref1 = (ref = Object === null || Object === void 0 ? void 0 : Object.values(status)) === null || ref === void 0 ? void 0 : ref.filter(function(o) {
        return o;
    })) === null || ref1 === void 0 ? void 0 : ref1.length) / ((ref2 = Object.keys(status)) === null || ref2 === void 0 ? void 0 : ref2.length) * 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                disabled: disabled || !isValidated || !isValid,
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "firstName",
                                label: "First name",
                                type: "text"
                            }, inputProps), {
                                required: true,
                                rules: {
                                    required: "First name is required."
                                }
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "lastName",
                                label: "Last name",
                                type: "text"
                            }, inputProps), {
                                required: true,
                                rules: {
                                    required: "Your last name is required."
                                }
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "email",
                                type: "email",
                                label: "E-mail"
                            }, inputProps), {
                                required: true,
                                rules: {
                                    required: "You email is required since you login with it."
                                }
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "password",
                                type: "password"
                            }, inputProps), {
                                required: true,
                                rules: {
                                    required: "You email is required since you login with it."
                                }
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "repeatPassword",
                                label: "Repeat Password",
                                type: "password"
                            }, inputProps), {
                                required: true,
                                rules: {
                                    required: "Repeat and match entered password. Copy paste is not allowed"
                                }
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* Progress */.E, {
                        value: percentage
                    }),
                    step(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroupItem */.oV, {
                        mb: 4,
                        fullWidth: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            name: "agree",
                            type: "checkbox",
                            label: "I agree to the Terms & conditions"
                        }, inputProps), {
                            rules: {
                                required: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Required, more information can be found under ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                            href: "/terms",
                                            children: "/terms"
                                        })
                                    ]
                                })
                            }
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-2 ml-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            width: [
                                1,
                                "90%"
                            ],
                            size: "large",
                            theme: "primary",
                            type: "submit",
                            disabled: disabled || !isValidated || !isValid,
                            children: isValidated || isValid ? "Create account" : "Disabled, complete register"
                        })
                    }),
                    loading,
                    registerError
                ]
            }),
            error,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-bottom text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "sign-up-text",
                        children: [
                            "Already have an account?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "/login",
                                color: "primary",
                                style: {
                                    fontWeight: "bold"
                                },
                                children: "Login"
                            })
                        ]
                    }),
                    accountActions && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "sign-up-text",
                        style: {
                            opacity: 0.7,
                            fontSize: "70%"
                        },
                        children: [
                            "Want to reset your password?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "/reset",
                                color: "primary",
                                children: "Reset"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/mosanic/auth/Wrapper.js
var Wrapper = __webpack_require__(43049);
;// CONCATENATED MODULE: ./src/mosanic/auth/Register.js









//Welcome to mosanic.io
// Let's get started! Tell us a bit about yourself.
// How would you describe your role?
// We’ll use this information to customize your Builder experience. Select all that apply.
// Executive
// Designer
// Developer
// Product
// Marketer
// Other
// Your imagination has no limits. Your creations shouldn't either.
// Build the digital experiences of your dreams with our visual tools, drag-and-drop optimization, and one-click publish.
// how are you hoping to use mosanic 
// - landing - marketing - blog - shop - platform 
// Why did you sign up for Builder?
//im evaluating differten tools, just exploring, ready to start building
//How did you header about mosnaic
var Register = function(param) {
    var _onlyForm = param.onlyForm, onlyForm = _onlyForm === void 0 ? false : _onlyForm, _content = param.content, content = _content === void 0 ? {
        header: null
    } : _content;
    var dispatch = (0,es/* useDispatch */.I0)();
    var activateAuth = function(registerData) {
        return dispatch((0,action/* activateAuthAction */.sd)(registerData));
    };
    var isAuth = (0,es/* useSelector */.v9)(reducer/* isAuthSelector */.Kj);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper/* default */.Z, {
        colorSchema: "light",
        mt: "-40px",
        onlyForm: onlyForm,
        children: [
            Array.isArray(content === null || content === void 0 ? void 0 : content.header) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                content: content.header
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: !isAuth ? "Welcome on Mosanic" : "Account registered"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: !isAuth ? "Let's get started! Tell us a bit about yourself." : "Start exploring Mosanic!"
                    })
                ]
            }),
            !isAuth ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm, {
                activateAuth: activateAuth,
                accountActions: true
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                href: "/",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    size: "large",
                    m: "0 auto",
                    children: "Dashboard"
                })
            })
        ]
    });
};
/* harmony default export */ var auth_Register = (Register);


/***/ }),

/***/ 90690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ auth_Reset; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/adapters/constants.js
var constants = __webpack_require__(1418);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/items/Link/index.js
var Link = __webpack_require__(8152);
// EXTERNAL MODULE: ./src/features/auth/action.js
var action = __webpack_require__(13213);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/utils/server/cookie.js
var cookie = __webpack_require__(18053);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/adapters/mutations/auth.js
var auth = __webpack_require__(37029);
// EXTERNAL MODULE: ./src/hooks/useApi.js + 3 modules
var useApi = __webpack_require__(70210);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/index.js
var Input = __webpack_require__(6928);
// EXTERNAL MODULE: ./src/mosanic/hooks/useNotify.js
var useNotify = __webpack_require__(33346);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/items/LoadingDots.tsx
var LoadingDots = __webpack_require__(4093);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ./src/adapters/queries/users.js
var users = __webpack_require__(62641);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/useDataQuery.js
var useDataQuery = __webpack_require__(49974);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
// EXTERNAL MODULE: ./src/mosanic/utils/mail.js + 1 modules
var utils_mail = __webpack_require__(96346);
;// CONCATENATED MODULE: ./src/mosanic/auth/ResetForm.js
















var ResetForm = function(param) {
    var setMode = param.setMode, _accountActions = param.accountActions, accountActions = _accountActions === void 0 ? false : _accountActions, _mail = param.mail, mail = _mail === void 0 ? null : _mail;
    var ref, ref1, ref2;
    var ref3 = (0,_sliced_to_array/* default */.Z)(mail ? mail.split("|") : [
        null,
        null
    ], 2), mailId = ref3[0], templateId = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetMail */.bC)({
        _id: mailId,
        silent: true
    }), 2), mail_data = ref4[0], loadingMail = ref4[1];
    var template = (0,utils_mail/* convertTemplate */.T)({
        template: mail_data === null || mail_data === void 0 ? void 0 : (ref = mail_data.templates) === null || ref === void 0 ? void 0 : ref.find(function(t) {
            return templateId === templateId;
        }),
        entry: null
    });
    var ref5 = (0,index_esm/* useForm */.cI)({
        mode: "all"
    }), handleSubmit = ref5.handleSubmit, control = ref5.control, watch = ref5.watch, _formState = ref5.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors
    };
    var ref6 = (0,react.useState)(false), disabled = ref6[0], setDisabled = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useApi/* useMutate */.Tu)("resetPassword", auth/* RESET_PASSWORD */.bk), 2), resetPassword = ref7[0], ref8 = (0,_sliced_to_array/* default */.Z)(ref7[1], 3), rst = ref8[0], loading = ref8[1], resetError = ref8[2];
    var notify = (0,useNotify/* default */.Z)();
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useDataQuery/* useGet */.XD)({
        params: {
            filter: {
                siteId: "6303a9537f25bc1630afd84b"
            }
        },
        type: "user",
        method: "Many",
        query: users/* LIST_ALL_USERS */.yN,
        silent: true,
        siteCheck: false
    }), 2), getUsersMosanic = ref9[0], ref10 = (0,_sliced_to_array/* default */.Z)(ref9[1], 2), mos_users = ref10[0], loadingUsers = ref10[1];
    // const users = mos_users?.filter(u => [
    // 	'63e4af66349309012494ba04',
    // 	'63e4af66349309012494ba0d',
    // 	'63e4af66349309012494b9eb',
    // 	'63e4af66349309012494b9ed',
    // 	'63e4af66349309012494ba07'
    // ].includes(u?._id))
    var onSubmit = function(data) {
        var ref, ref1;
        setDisabled(true);
        var variables = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            templateId: mail_data === null || mail_data === void 0 ? void 0 : (ref = mail_data.data) === null || ref === void 0 ? void 0 : ref.templateId,
            mailData: (mail_data === null || mail_data === void 0 ? void 0 : mail_data.data) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, template), {
                mainText: (template === null || template === void 0 ? void 0 : template.mainText) ? template.mainText : template === null || template === void 0 ? void 0 : template.content,
                template_name: undefined,
                content: undefined,
                linkHref: "https://www.swopyourstay.com/reset?resetCode=",
                linkText: " ",
                // sectionFooterHeader: undefined,
                // sectionFooterText: undefined,
                template_id: undefined
            }) : undefined,
            from: mail_data === null || mail_data === void 0 ? void 0 : (ref1 = mail_data.data) === null || ref1 === void 0 ? void 0 : ref1.defaultSender
        });
        resetPassword(variables).then(function(res) {
            var _$data = res.data, error = res.error;
            // if(data?.resetPassword) data = data.resetPassword
            if (!error) {
                setMode({
                    step: "verification",
                    email: variables === null || variables === void 0 ? void 0 : variables.email
                });
                notify("Verification code send, check your email.", "login", "info");
            } else {
                notify("Reset send failed, please check your email.");
            }
            setDisabled(false);
        });
    };
    // const sendMails = () => {
    // 	users?.map(u => {
    // 		onSubmit({email: u?.email})
    // 	})
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                disabled: disabled,
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            name: "email",
                            type: "email",
                            label: "Account Email"
                        }, inputProps), {
                            required: true,
                            rules: {
                                required: "You registered email."
                            }
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-2 ml-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            width: [
                                1,
                                "100%"
                            ],
                            size: "large",
                            theme: "primary",
                            type: "submit",
                            disabled: disabled || !((ref1 = watch()) === null || ref1 === void 0 ? void 0 : ref1.email),
                            label: (rst === null || rst === void 0 ? void 0 : rst.response) ? rst === null || rst === void 0 ? void 0 : rst.response : loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : ((ref2 = watch()) === null || ref2 === void 0 ? void 0 : ref2.email) ? "Send reset code" : "Disabled, enter in email"
                        })
                    }),
                    loading,
                    resetError
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-bottom text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "sign-up-text",
                        children: [
                            "Remembered your password?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "/login",
                                color: "primary",
                                style: {
                                    fontWeight: "bold"
                                },
                                children: "Login"
                            })
                        ]
                    }),
                    accountActions && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "sign-up-text",
                        style: {
                            opacity: 0.7,
                            fontSize: "70%"
                        },
                        children: [
                            "Don't have a account?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "/register",
                                color: "primary",
                                children: "Register"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/adapters/host.js
var host = __webpack_require__(6539);
// EXTERNAL MODULE: ./src/mosanic/components/User/Handlers/usePasswordValidation.js
var usePasswordValidation = __webpack_require__(29134);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
;// CONCATENATED MODULE: ./src/mosanic/auth/VerifyResetForm.js




















var VerifyResetForm = function(param) {
    var activateAuth = param.activateAuth, mode = param.mode, setMode = param.setMode, _resetCode = param.resetCode, resetCode = _resetCode === void 0 ? null : _resetCode, _redirect = param.redirect, redirect = _redirect === void 0 ? "/" : _redirect;
    var ref, ref1, ref2, ref3, ref4;
    var email = (mode === null || mode === void 0 ? void 0 : mode.email) || (0,cookie/* recoverCookie */.DX)(constants/* AUTH_EMAIL_REF */.h);
    var ref5 = (0,index_esm/* useForm */.cI)({
        mode: "all"
    }), handleSubmit = ref5.handleSubmit, control = ref5.control, watch = ref5.watch, reset = ref5.reset, _formState = ref5.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors,
        size: "large"
    };
    var ref6 = (0,react.useState)(false), disabled = ref6[0], setDisabled = ref6[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useApi/* useMutate */.Tu)("authResetPassword", auth/* AUTH_RESET_PASSWORD */.sO), 2), authUserResetCode = ref7[0], ref8 = (0,_sliced_to_array/* default */.Z)(ref7[1], 3), token = ref8[0], loading = ref8[1], error = ref8[2];
    var notify = (0,useNotify/* default */.Z)();
    (0,react.useEffect)(function() {
        if (resetCode) {
            reset({
                code: resetCode,
                email: email
            });
        } else if (email) {
            reset((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, watch()), {
                email: email
            }));
        }
    }, [
        resetCode,
        email
    ]);
    var onSubmit = (0,react.useCallback)(function(data) {
        setDisabled(true);
        console.log(data);
        if (!email && !(data === null || data === void 0 ? void 0 : data.email)) {
            notify("Did not receive a email.", "login", "error");
            return;
        }
        if (!(data === null || data === void 0 ? void 0 : data.code)) {
            notify("Did not receive a reset confirmation code.", "login", "error");
            return;
        }
        var variables = {
            code: data.code,
            email: (data === null || data === void 0 ? void 0 : data.email) || email,
            newPassword: (data === null || data === void 0 ? void 0 : data.password) ? data.password : undefined
        };
        authUserResetCode(variables).then(function(res) {
            var _$data = res.data, error = res.error;
            if (_$data === null || _$data === void 0 ? void 0 : _$data.authResetPassword) _$data = _$data.authResetPassword;
            if (_$data && !error) {
                notify("The reset code you provided was correct.", "login", "info");
                setTimeout(function() {
                    notify("Your password has been reset.", "login", "success");
                    dispatch((0,action/* activateAuthAction */.sd)({
                        token: _$data.token,
                        redirect: false,
                        remember: true
                    }));
                    (0,cookie/* deleteCookie */.kT)(constants/* AUTH_EMAIL_REF */.h);
                }, 500);
            }
            if (error) {
                setDisabled(false);
            }
        });
    }, [
        activateAuth,
        authUserResetCode,
        email,
        notify
    ]);
    // useEffect(()=> {
    // 	if(resetCode && email) {
    // 		onSubmit({code: resetCode})
    // 	}
    // },[email, resetCode, onSubmit])
    //form-row mb-3
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,usePasswordValidation/* usePasswordValidation */.g)({
        password: (ref = watch()) === null || ref === void 0 ? void 0 : ref.password,
        repeat_password: (ref1 = watch()) === null || ref1 === void 0 ? void 0 : ref1.repeatNewPassword,
        firstOnly: true
    }), 3), errorMessage = ref9[0], Validations = ref9[1], strength = ref9[2];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                disabled: disabled,
                onSubmit: handleSubmit(onSubmit),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                    center: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            sanitize: function(e) {
                                return (0,Text/* replacePart */.bA)(e, " ", "-");
                            },
                            style: {
                                maxWidth: "300px"
                            },
                            name: "code",
                            label: "Verification reset code"
                        }, inputProps), {
                            rules: {
                                required: "Enter the reset code received in your mail."
                            }
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            type: "email",
                            name: "email",
                            style: {
                                maxWidth: "300px"
                            }
                        }, inputProps), {
                            rules: {
                                required: "Email address is required."
                            }
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            style: {
                                maxWidth: "300px"
                            },
                            type: "password",
                            name: "password",
                            label: "New password"
                        }, inputProps), {
                            rules: {
                                required: "Enter your new password."
                            }
                        })),
                        ((ref2 = watch()) === null || ref2 === void 0 ? void 0 : ref2.password) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            style: {
                                maxWidth: "300px"
                            },
                            type: "password",
                            name: "repeatNewPassword",
                            label: "Repeat New password"
                        }, inputProps), {
                            rules: {
                                required: "Repeat your new password."
                            }
                        })),
                        ((ref3 = watch()) === null || ref3 === void 0 ? void 0 : ref3.password) && ((ref4 = watch()) === null || ref4 === void 0 ? void 0 : ref4.repeatNewPassword) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Validations, {
                            center: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            wrap: true,
                            width: [
                                1,
                                "200px"
                            ],
                            label: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : "Verify Reset",
                            theme: "primary",
                            size: "large",
                            type: "submit",
                            disabled: Boolean(loading || !isValid || errorMessage)
                        })
                    ]
                })
            }),
            error,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-bottom text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "sign-up-text",
                        children: [
                            "Don’t have an account?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "/register",
                                color: "primary",
                                children: "Register"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                        title: "\uD83D\uDCE9 Verification code help",
                        size: "sm",
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                            label: "Didn't receive a code? ",
                            span: true,
                            style: {
                                cursor: "pointer"
                            }
                        }),
                        children: [
                            "You should receive a verification reset email within 5 minutes after login. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Send to: ",
                            mode === null || mode === void 0 ? void 0 : mode.email,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "If you're not seeing it in your inbox, check out these suggestions:",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Refresh mailbox"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Check Spam & junk folder"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Check for typos in the login"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Add @mosanic.io to your contact safelist"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "If you've tried these steps without any success, ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: (0,host/* getDocsUrl */.V)("account/login"),
                                children: "learn more."
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Or ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "mailto:help@mosanic.io",
                                children: "contact our support team"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                        onClick: function() {
                            return setMode({
                                step: "reset"
                            });
                        },
                        style: {
                            color: colors/* default.util.primary.base */.ZP.util.primary.base,
                            display: "block",
                            cursor: "pointer"
                        },
                        label: "Go back"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/mosanic/auth/Wrapper.js
var Wrapper = __webpack_require__(43049);
;// CONCATENATED MODULE: ./src/mosanic/auth/Reset.js












var Reset = function(param) {
    var _onlyForm = param.onlyForm, onlyForm = _onlyForm === void 0 ? false : _onlyForm, _resetCode = param.resetCode, resetCode = _resetCode === void 0 ? null : _resetCode, accountActions = param.accountActions, _content = param.content, content = _content === void 0 ? {
        mail: null
    } : _content, _redirect = param.redirect, redirect = _redirect === void 0 ? "/" : _redirect;
    var dispatch = (0,es/* useDispatch */.I0)();
    var activateAuth = function(resetData) {
        return dispatch((0,action/* activateAuthAction */.sd)(resetData));
    };
    var isAuth = (0,es/* useSelector */.v9)(reducer/* isAuthSelector */.Kj);
    var ref = (0,react.useState)({
        step: "reset"
    }), mode = ref[0], setMode = ref[1];
    var email = (mode === null || mode === void 0 ? void 0 : mode.email) || (0,cookie/* recoverCookie */.DX)(constants/* AUTH_EMAIL_REF */.h);
    var isReset = (mode === null || mode === void 0 ? void 0 : mode.step) === "reset" && !resetCode;
    var title = isAuth ? "Login successfully." : isReset ? "Reset your Password" : "Verify reset request";
    var desc = isAuth ? "Hold on, we are redirecting you." : isReset ? "Enter your email below to reset your account." : "Check your email to authenticate.";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper/* default */.Z, {
        colorSchema: "light",
        mt: "-40px",
        onlyForm: onlyForm,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: desc
            }),
            !isAuth ? isReset ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetForm, {
                setMode: setMode,
                accountActions: accountActions,
                mail: content === null || content === void 0 ? void 0 : content.mail
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyResetForm, {
                activateAuth: activateAuth,
                mode: mode,
                setMode: setMode,
                resetCode: resetCode,
                redirect: redirect
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                href: redirect,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    size: "large",
                    m: "0 auto",
                    children: "Dashboard"
                })
            })
        ]
    });
};
/* harmony default export */ var auth_Reset = (Reset);


/***/ }),

/***/ 43049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67324);
/* harmony import */ var _mosanic_styles_card_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2483);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);









var SmallLogo = function(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 66 66",
        style: {
            margin: "-2.5px 2.5px 0 -10px"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "Group_1",
            "data-name": "Group 1",
            transform: "translate(-88 -100)",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    id: "Rectangle_1",
                    "data-name": "Rectangle 1",
                    width: "28",
                    height: "28",
                    rx: "5",
                    transform: "translate(88 100)",
                    fill: "#1082e9"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    id: "Rectangle_2",
                    "data-name": "Rectangle 2",
                    width: "28",
                    height: "28",
                    rx: "5",
                    transform: "translate(126 100)",
                    fill: "#1082e9"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    id: "Rectangle_3",
                    "data-name": "Rectangle 3",
                    width: "28",
                    height: "28",
                    rx: "5",
                    transform: "translate(88 138)",
                    fill: "#1082e9"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    id: "Rectangle_4",
                    "data-name": "Rectangle 4",
                    width: "28",
                    height: "28",
                    rx: "5",
                    transform: "translate(126 138)",
                    fill: "#1082e9"
                })
            ]
        })
    });
};
// style={{marginTop: '-8%', opacity: 0.1}}
var LargeLogo = function(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20%",
        height: "20%",
        viewBox: "0 0 66 66",
        children: /*#__PURE__*/ _jsxs("g", {
            id: "Group_1",
            "data-name": "Group 1",
            transform: "translate(-88 -100)",
            children: [
                /*#__PURE__*/ _jsx("rect", {
                    id: "Rectangle_1",
                    "data-name": "Rectangle 1",
                    width: "28",
                    height: "28",
                    rx: "5",
                    transform: "translate(88 100)",
                    fill: "#fff"
                }),
                /*#__PURE__*/ _jsx("rect", {
                    id: "Rectangle_2",
                    "data-name": "Rectangle 2",
                    width: "28",
                    height: "28",
                    rx: "5",
                    transform: "translate(126 100)",
                    fill: "#fff"
                }),
                /*#__PURE__*/ _jsx("rect", {
                    id: "Rectangle_3",
                    "data-name": "Rectangle 3",
                    width: "28",
                    height: "28",
                    rx: "5",
                    transform: "translate(88 138)",
                    fill: "#fff"
                }),
                /*#__PURE__*/ _jsx("rect", {
                    id: "Rectangle_4",
                    "data-name": "Rectangle 4",
                    width: "28",
                    height: "28",
                    rx: "5",
                    transform: "translate(126 138)",
                    fill: "#fff"
                })
            ]
        })
    });
};
var AuthWrapper = function(_param) {
    var children = _param.children, _colorSchema = _param.colorSchema, colorSchema = _colorSchema === void 0 ? "light" : _colorSchema, _onlyForm = _param.onlyForm, onlyForm = _onlyForm === void 0 ? false : _onlyForm, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "colorSchema",
        "onlyForm"
    ]);
    return onlyForm ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* .Wrap */ .Eq, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        height: onlyForm ? "auto" : "100vh"
    }, other), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                bg: colorSchema === "light" ? "primary" : "#212121",
                center: true,
                width: [
                    1,
                    "40%",
                    "40%",
                    1 / 2
                ],
                height: [
                    10,
                    "100%"
                ],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: "https://mosanic-cdn.ams3.digitaloceanspaces.com/62e7a50082b1bd8d84a13845/mosanic_mark_large.svg",
                    height: "150px",
                    width: "150px",
                    alt: "Mosanic mark",
                    priority: true,
                    style: {
                        opacity: 0.1
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .JX, {
                center: true,
                bg: "white",
                width: onlyForm ? 1 : [
                    1,
                    "60%",
                    "60%",
                    1 / 2
                ],
                height: "100%",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_styles_card_styles__WEBPACK_IMPORTED_MODULE_7__/* .Card */ .Zb, {
                    trans: true,
                    textAlign: "center",
                    width: [
                        "85vw",
                        "80%",
                        "70%",
                        "60%"
                    ],
                    m: "auto",
                    pb: "10vh",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SmallLogo, {}),
                                "Mosanic ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                            ]
                        }),
                        children
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AuthWrapper);


/***/ }),

/***/ 49896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useLogout; }
/* harmony export */ });
/* harmony import */ var _redux_auth_action__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13213);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64157);


var useLogout = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    return function() {
        return dispatch((0,_redux_auth_action__WEBPACK_IMPORTED_MODULE_1__/* .removeAuthAction */ .Mc)({
            redirect: "/login"
        }, "Logout"));
    };
    ;
};


/***/ }),

/***/ 65139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useDataReceiver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66383);
/* harmony import */ var _mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49272);
/* harmony import */ var _mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42622);
/* harmony import */ var _mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43970);
/* harmony import */ var _mosanic_utils_value__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11039);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62357);
/* harmony import */ var _mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43551);
/* harmony import */ var _mosanic_cms_Query_useDataQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49974);
// source string: repeater
// entry string: 6390cf218598d23fb16ec7b6
// collection string: 63359058737d68d97014da2d
// fieldPath Array:
// [
// type string:
// text
// name string:
// short_room_name
// help string:
// default string:
// localized boolean:
// ]













var useCollection = function(param) {
    var collectionId = param.collectionId, getCollection = param.getCollection;
    var _id = Boolean(collectionId && getCollection) ? collectionId : null;
    // let [handler, [collection, loading, error]]  = useHandler(({_id}, true));
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_2__/* .useGetCollection */ .YD)({
        _id: _id,
        silent: true
    }), 1), collection = ref[0];
    //Get linked entries
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_3__/* .useGetEntries */ .e1)({
        filter: {
            collectionId: _id
        },
        silent: true
    }), 2), entries = ref1[0], loading = ref1[1];
    collection = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, collection), {
        entries: Array.isArray(entries) && (entries === null || entries === void 0 ? void 0 : entries.length) >= 1 ? entries.map(function(e) {
            return (0,_mosanic_cms_Query_useDataQuery__WEBPACK_IMPORTED_MODULE_6__/* .convertEntry */ .ec)(e);
        }) : collection === null || collection === void 0 ? void 0 : collection.entries
    });
    // const entry = useRetrieveEntry((
    //     getEntries && (singleEntry || entryId)
    // ) && (
    //     entryId || collection?.entries?.[0]
    // ))
    return [
        collection,
        loading
    ];
};
var useDataReceiver = function(param) {
    var source = param.source, entry = param.entry, clone = param.clone, _map = param.map, map = _map === void 0 ? false : _map;
    var data = null, schema = null, baseRoute = null, receiveData = false;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(useCollection({
        getCollection: (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__/* .isSource */ .Tx)(source),
        collectionId: entry === null || entry === void 0 ? void 0 : entry.collection
    }), 2), collection = ref[0], loading = ref[1];
    var relation = (0,_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_8__/* .useRelationProvider */ .UH)();
    var provider = (0,_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_8__/* .useDataProvider */ .x5)();
    var repeater = (0,_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_8__/* .useRepeatProvider */ .RS)();
    var page = (0,_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_9__/* .usePageContext */ .lO)();
    if ((0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__/* .isRepeaterSource */ .Cf)(source) || (0,_mosanic_utils_value__WEBPACK_IMPORTED_MODULE_10__/* .isClone */ .vu)(clone)) {
        var ref1;
        // if(!repeater?.entries) console.log({message: 'No repeater wrapper entries found.', entry})
        data = repeater === null || repeater === void 0 ? void 0 : (ref1 = repeater.entries) === null || ref1 === void 0 ? void 0 : ref1[clone];
        schema = repeater === null || repeater === void 0 ? void 0 : repeater.schema;
        baseRoute = repeater === null || repeater === void 0 ? void 0 : repeater.baseRoute;
    // console.log({repeater, data, entry, clone})
    // console.log('Repeater source')
    } else if ((0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__/* .isProviderSource */ .CB)(source)) {
        //No data provider context
        if (!provider) console.log({
            message: "Wrap with data provider.",
            entry: entry
        });
        // 
        //Get selected provider;
        var providedData = provider === null || provider === void 0 ? void 0 : provider[entry === null || entry === void 0 ? void 0 : entry.provider];
        //Parse provider;
        data = providedData === null || providedData === void 0 ? void 0 : providedData.data;
        var providedEntry = providedData === null || providedData === void 0 ? void 0 : providedData.entry;
        //Validate provided entry
        if (!data || !(providedEntry === null || providedEntry === void 0 ? void 0 : providedEntry.fieldPath)) {
            data = providedData;
        }
        if (Array.isArray(data)) {
            data = (0,_mosanic_utils_value__WEBPACK_IMPORTED_MODULE_10__/* .isClone */ .vu)(clone) ? data[clone] : data[0];
        }
    } else if (source === "relation" && (relation === null || relation === void 0 ? void 0 : relation.entry)) {
        var ref2;
        data = relation === null || relation === void 0 ? void 0 : relation.entry;
        schema = relation === null || relation === void 0 ? void 0 : (ref2 = relation.collection) === null || ref2 === void 0 ? void 0 : ref2.schema;
        baseRoute = relation === null || relation === void 0 ? void 0 : relation.baseRoute;
    } else if ((0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__/* .isPageSource */ .uS)(source)) {
        // if(!page) console.log({message: 'No page provider found.', entry})
        data = page === null || page === void 0 ? void 0 : page.entry;
        schema = page === null || page === void 0 ? void 0 : page.schema;
        baseRoute = page === null || page === void 0 ? void 0 : page.baseRoute;
    }
    if ((0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__/* .isSource */ .Tx)(source)) {
        var ref3;
        data = collection === null || collection === void 0 ? void 0 : collection.entries;
        schema = collection === null || collection === void 0 ? void 0 : collection.schema;
        baseRoute = collection === null || collection === void 0 ? void 0 : collection.baseRoute;
        // console.log(collection)
        if (entry === null || entry === void 0 ? void 0 : entry.entry) data = (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getEntry */ .e9)(collection, entry.entry);
        if (entry === null || entry === void 0 ? void 0 : entry.fieldPath) schema = (ref3 = (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getSchema */ .J1)(entry.fieldPath, schema)) === null || ref3 === void 0 ? void 0 : ref3.schema;
    // if(!entry?.collection) console.log({message: 'No provider collection selected.', entry})
    }
    // // todo !check fix
    // if(schema?.schema) schema = schema?.schema;
    schema = (entry === null || entry === void 0 ? void 0 : entry.fieldPath) ? (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getSchema */ .J1)(entry.fieldPath, schema) : schema;
    data = (entry === null || entry === void 0 ? void 0 : entry.fieldPath) ? (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getFieldValue */ .oe)(entry.fieldPath, data, schema) : data;
    return [
        data,
        schema,
        baseRoute,
        collection
    ];
};


/***/ }),

/***/ 53048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ findCenter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26021);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _MapThemes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21743);
/* harmony import */ var _googlemaps_js_api_loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28223);
/* harmony import */ var _googlemaps_markerclusterer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19249);
/* harmony import */ var _util_Num__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3121);
/* harmony import */ var _mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73987);
// import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n   width: 100%;\n   height: 100%;\n   text-align: center;\n   font-size: 12px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var themes = {
    dark: _MapThemes__WEBPACK_IMPORTED_MODULE_6__/* .dark_map */ .k9,
    light: _MapThemes__WEBPACK_IMPORTED_MODULE_6__/* .light_map */ .fo,
    minimal: _MapThemes__WEBPACK_IMPORTED_MODULE_6__/* .minimal_map */ .E,
    default: null
};
var getTheme = function(theme) {
    return themes[theme];
};
function findCenter(markers) {
    var _Math, _Math1, _Math2, _Math3;
    if ((markers === null || markers === void 0 ? void 0 : markers.length) <= 0 || !markers || !Array.isArray(markers)) return {
        lat: undefined,
        lng: undefined
    };
    var lats = markers.map(function(m) {
        return m.lat;
    });
    var lngs = markers.map(function(m) {
        return m.lng;
    });
    return {
        lat: ((_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(lats)) + (_Math1 = Math).max.apply(_Math1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(lats))) / 2,
        lng: ((_Math2 = Math).min.apply(_Math2, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(lngs)) + (_Math3 = Math).max.apply(_Math3, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(lngs))) / 2
    };
}
var Reload = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-8c3784c4-0"
})(_templateObject());
var points = [
    {
        lat: 42.02,
        lng: -77.01
    },
    {
        lat: 42.03,
        lng: -77.02
    },
    {
        lat: 41.03,
        lng: -77.04
    },
    {
        lat: 42.05,
        lng: -77.02
    }
];
var GoogleMap = function(param) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active;
    var ref1;
    var apiKey = editor === null || editor === void 0 ? void 0 : (ref1 = editor.source) === null || ref1 === void 0 ? void 0 : ref1.apiKey;
    if (!apiKey) apiKey = "AIzaSyAma8GPPHZNC5Gg1bXp7V5GMbfYH1gIGbk";
    // return JSON.stringify(editor)
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RenderMap, {
        editor: editor,
        apiKey: apiKey
    });
};
var validate = function(val) {
    return (0,_util_Num__WEBPACK_IMPORTED_MODULE_9__/* .isNumber */ .hj)(parseFloat(val));
};
var RenderMap = function(param) {
    var editor = param.editor, apiKey = param.apiKey, _libraries = param.libraries, libraries = _libraries === void 0 ? [
        "places"
    ] : _libraries;
    var ref = editor || {
        source: source
    }, source = ref.source, handler = ref.handler;
    var ref1 = source || {
        lat: 52.377956,
        lng: 4.897070,
        zoom: 8,
        markers: [],
        theme: "default"
    }, lat = ref1.lat, lng = ref1.lng, zoom = ref1.zoom, theme = ref1.theme, markers = ref1.markers, icon = ref1.icon;
    // if(!apiKey) apiKey = 'AIzaSyCdwFEEctdkfVlQMzV5attE6IqM8TrmtuA';
    zoom = validate(zoom) ? parseFloat(zoom) : 10;
    lat = validate(lat) ? parseFloat(lat) : 52.377956;
    lng = validate(lng) ? parseFloat(lng) : 4.897070;
    var googleMap = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), reload = ref2[0], setReload = ref2[1];
    // const icon = parseImageSrc(marker, true)?.thumb
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!apiKey) return;
        var loader = new _googlemaps_js_api_loader__WEBPACK_IMPORTED_MODULE_4__/* .Loader */ .aN({
            apiKey: apiKey,
            language: "en",
            // version: 'weekly',
            libraries: libraries
        });
        var map, marker;
        loader.load().then(function() {
            var ref;
            map = new google.maps.Map(googleMap.current, {
                center: {
                    lat: lat,
                    lng: lng
                },
                zoom: zoom,
                disableDefaultUI: true,
                mapTypeControl: true,
                scaleControl: true,
                zoomControl: true,
                styles: getTheme(theme),
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL
                }
            });
            var markerIcon = {
                url: (ref = (0,_mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_10__/* .parseImageSrc */ .yO)(icon, true)) === null || ref === void 0 ? void 0 : ref.thumb,
                // This marker is 20 pixels wide by 32 pixels high.
                size: new google.maps.Size(30, 30),
                // The origin for this image is (0, 0).
                // origin: new google.maps.Point(0, 0),
                // // The anchor for this image is the base of the flagpole at (0, 32).
                anchor: new google.maps.Point(0, 32)
            };
            // let markers_search = [];
            var infoWindow = new google.maps.InfoWindow();
            if ((markers === null || markers === void 0 ? void 0 : markers.length) >= 1) {
                var points = markers.map(function(marker) {
                    var ref;
                    var content = marker;
                    marker = new google.maps.Marker({
                        position: {
                            lat: marker === null || marker === void 0 ? void 0 : marker.lat,
                            lng: marker === null || marker === void 0 ? void 0 : marker.lng
                        },
                        title: marker === null || marker === void 0 ? void 0 : marker.title,
                        icon: (ref = (0,_mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_10__/* .parseImageSrc */ .yO)(icon, true)) === null || ref === void 0 ? void 0 : ref.full,
                        map: map
                    });
                    marker.addListener("click", function() {
                        console.log({
                            marker: marker,
                            title: marker.getTitle(),
                            content: content
                        });
                        infoWindow.close();
                        infoWindow.setContent(marker.getTitle());
                        infoWindow.open(marker.getMap(), marker);
                    });
                    return marker;
                });
                var mc = new _googlemaps_markerclusterer__WEBPACK_IMPORTED_MODULE_5__/* .MarkerClusterer */ .XL({
                    markers: points,
                    map: map
                });
            } else {
                var ref1;
                marker = new google.maps.Marker({
                    position: {
                        lat: lat,
                        lng: lng
                    },
                    icon: (ref1 = (0,_mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_10__/* .parseImageSrc */ .yO)(icon, true)) === null || ref1 === void 0 ? void 0 : ref1.full,
                    map: map
                });
            }
        });
    }, [
        theme,
        lat,
        lng,
        apiKey,
        markers
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            id: "map",
            style: {
                height: "100%",
                width: "100%"
            },
            ref: googleMap,
            children: apiKey ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Reload, {
                onClick: function() {
                    return setReload(reload++);
                },
                children: "Reload map"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Reload, {
                children: "Provide a valid key."
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GoogleMap);


/***/ }),

/***/ 21743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ minimal_map; },
/* harmony export */   "fo": function() { return /* binding */ light_map; },
/* harmony export */   "k9": function() { return /* binding */ dark_map; }
/* harmony export */ });
var dark_map = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#212121"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#212121"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#bdbdbd"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#181818"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#1b1b1b"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#2c2c2c"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#8a8a8a"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#373737"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#3c3c3c"
            }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#4e4e4e"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#3d3d3d"
            }
        ]
    }
];
var light_map = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#bdbdbd"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dadada"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#c9c9c9"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    }
];
var minimal_map = [
    {
        "featureType": "administrative.land_parcel",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    }
];


/***/ }),

/***/ 23045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53048);

/* harmony default export */ __webpack_exports__["Z"] = (_Map__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 10766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ RenderDialog; },
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66383);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _JSX__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96344);
/* harmony import */ var _mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43551);
/* harmony import */ var _mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8927);
/* harmony import */ var _mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42622);
/* harmony import */ var _mosanic_utils_value__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11039);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68311);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);










// import ControlDialog  from "@mosanic/items/ControlModal";
var ControlDialog = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6460).then(__webpack_require__.bind(__webpack_require__, 66460));
}, {
    ssr: false
});






var RenderDialog = function(_param) /*#__PURE__*/ {
    var page = _param.page, size = _param.size, title = _param.title, data = _param.data, children = _param.children, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "page",
        "size",
        "title",
        "data",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ControlDialog, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        size: size,
        title: null,
        trigger: children,
        wrapTrigger: true
    }, other), {
        padding: 0,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_7__/* .ConditionalWrapper */ .M, {
            when: data,
            wrapper: function(children) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_8__/* .RelationProvider */ .r$, {
                    data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
                        entry: data
                    }),
                    children: children
                });
            },
            children: page && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                blockSeo: true,
                mode: "prod",
                page: page
            })
        })
    }));
};
var Modal = function(param, children) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active, clone = param.clone;
    var ref1;
    var ref2 = editor || {
        source: {
            dialog: undefined
        },
        handler: undefined
    }, source = ref2.source, handler = ref2.handler;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_11__/* .useGetPages */ .m_)({
        filter: {
            _id: source === null || source === void 0 ? void 0 : source.dialog
        }
    }), 3), pages = ref3[0], loading = ref3[1], error = ref3[2];
    var page = pages === null || pages === void 0 ? void 0 : pages[0];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var isDev = (0,_util_Text__WEBPACK_IMPORTED_MODULE_12__/* .containsSubstr */ .xX)(router === null || router === void 0 ? void 0 : router.asPath, "/builder");
    //TODO --> use a universal 'data getter'
    // --> refactor, datalink type getter 
    // --> combine all methods
    // --> validate and check for 'clone'
    // --> check if entry is set
    // --> check if fallback 
    // --> page 
    // const data = useDataProvider();
    var repeat = (0,_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_8__/* .useRepeatProvider */ .RS)();
    // return (
    //     <div>
    //         {isValidElement(children) ? children :'test'}
    //     </div>
    // );
    var data = (0,_mosanic_utils_value__WEBPACK_IMPORTED_MODULE_13__/* .isClone */ .vu)(clone) ? repeat === null || repeat === void 0 ? void 0 : (ref1 = repeat.entries) === null || ref1 === void 0 ? void 0 : ref1[clone] : null;
    if (!children) children = null;
    return isDev || !ControlDialog ? children : !loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ControlDialog, {
        size: source === null || source === void 0 ? void 0 : source.size,
        title: null,
        trigger: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.isValidElement)(children) ? children : null,
        wrapTrigger: true,
        padding: 0,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_7__/* .ConditionalWrapper */ .M, {
            when: data,
            wrapper: function(children) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_8__/* .RelationProvider */ .r$, {
                    data: data,
                    children: children
                });
            },
            children: page && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                blockSeo: true,
                mode: "prod",
                page: page
            })
        })
    }) : null;
} // a[href^="http://maps.google.com/maps"]{display:none !important}
 // a[href^="https://maps.google.com/maps"]{display:none !important}
 // .gmnoprint[role=menubar], .gm-style-cc {
 //     display:none;
 // }
 // .gmnoprint div {
 //     transform: scale(0.9);
 //     trasnform-origin: left center;
 //     background:rgba(0,0,0,0.6) !important;
 // }
;


/***/ }),

/***/ 53342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ builder_registery; }
});

// UNUSED EXPORTS: registery

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/i18n/useLocale.js
var useLocale = __webpack_require__(38576);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
;// CONCATENATED MODULE: ./src/mosanic/builder/Button/Button.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    border: none;\n    padding: 0;\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    color: inherit;\n    width: inherit;\n    background: none;\n\n    &:focus {\n        outline: none;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-c485e6bc-0"
})(_templateObject());
var Button = function(param) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active;
    // const reference = useContextReference(true)
    var ref1 = editor || {
        source: {
            content: ""
        }
    }, source = ref1.source, handler = ref1.handler;
    var handleInput = function(e) {
        return handler({
            value: e.target.value,
            extend: "content"
        });
    };
    var content = source === null || source === void 0 ? void 0 : source.content;
    var translate = (0,useLocale/* useLocale */.bU)(JSON.stringify(content ? content : {}));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: active && source && (0,Text/* isString */.HD)(content) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
            onChange: handleInput,
            value: content,
            style: {
                width: "".concat((content === null || content === void 0 ? void 0 : content.length) ? content.length : 2, "ch")
            }
        }) : (0,Text/* isString */.HD)(content) ? content : (0,Text/* isString */.HD)(translate) ? translate : ""
    });
};
/* harmony default export */ var Button_Button = (Button);

;// CONCATENATED MODULE: ./src/mosanic/builder/Button/index.js

/* harmony default export */ var builder_Button = (Button_Button);

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/mosanic/builder/Code/Code.js
// import { default as CodeEditor } from '@mosanic/fields/Code';


var CodeEditor = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84019));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84019)
            ];
        }
    },
    ssr: false
});
var Code = function(param) {
    var editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active;
    var source = editor.source, handler = editor.handler;
    var handleInput = function(value) {
        if (value) {
            handler({
                value: value,
                extend: "content"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeEditor, {
            onChange: handleInput,
            language: (source === null || source === void 0 ? void 0 : source.language) ? source.language : "js",
            value: source === null || source === void 0 ? void 0 : source.content,
            active: active
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: source === null || source === void 0 ? void 0 : source.content
            }
        })
    });
};
/* harmony default export */ var Code_Code = (Code);

;// CONCATENATED MODULE: ./src/mosanic/builder/Code/index.js

/* harmony default export */ var builder_Code = (Code_Code);

// EXTERNAL MODULE: ./src/mosanic/utils/schema.js
var schema = __webpack_require__(32064);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/tiny-warning/dist/tiny-warning.esm.js
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ var tiny_warning_esm = (warning);

;// CONCATENATED MODULE: ../../node_modules/react-collapsed/dist/react-collapsed.esm.js
function a(){return a=Object.assign||function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var o in t)Object.prototype.hasOwnProperty.call(t,o)&&(n[o]=t[o])}return n},a.apply(this,arguments)}function u(n,e){if(null==n)return{};var t,o,r={},i=Object.keys(n);for(o=0;o<i.length;o++)e.indexOf(t=i[o])>=0||(r[t]=n[t]);return r}var c=function(){};function d(n){return null!=n&&n.current?n.current.scrollHeight:(tiny_warning_esm(!0,"useCollapse was not able to find a ref to the collapse element via `getCollapseProps`. Ensure that the element exposes its `ref` prop. If it exposes the ref prop under a different name (like `innerRef`), use the `refKey` property to change it. Example:\n\n{...getCollapseProps({refKey: 'innerRef'})}"),"auto")}var s=function(){var n=arguments;return function(){var e=arguments;return[].slice.call(n).forEach(function(n){return n&&n.apply(void 0,[].slice.call(e))})}};function f(n,e){if(null!=n)if("function"==typeof n)n(e);else try{n.current=e}catch(t){throw new Error('Cannot assign value "'+e+'" to ref "'+n+'"')}}var p="undefined"!=typeof window?react.useLayoutEffect:react.useEffect,h=!1,v=0,g=function(){return++v},m=["duration","easing","collapseStyles","expandStyles","onExpandStart","onExpandEnd","onCollapseStart","onCollapseEnd","isExpanded","defaultExpanded","hasDisabledAnimation"],x=["disabled","onClick"],y=["style","onTransitionEnd","refKey"];function E(r){var v,E,b=void 0===r?{}:r,C=b.duration,w=b.easing,S=void 0===w?"cubic-bezier(0.4, 0, 0.2, 1)":w,k=b.collapseStyles,A=void 0===k?{}:k,O=b.expandStyles,P=void 0===O?{}:O,T=b.onExpandStart,q=void 0===T?c:T,D=b.onExpandEnd,F=void 0===D?c:D,K=b.onCollapseStart,j=void 0===K?c:K,N=b.onCollapseEnd,z=void 0===N?c:N,H=b.isExpanded,I=b.defaultExpanded,M=void 0!==I&&I,R=b.hasDisabledAnimation,B=void 0!==R&&R,V=u(b,m),_=function(r,i){var a=(0,react.useState)(i||!1),u=a[0],c=a[1],d=(0,react.useRef)(null!=r),s=d.current?r:u,f=(0,react.useCallback)(function(n){d.current||c(n)},[]);return (0,react.useEffect)(function(){tiny_warning_esm(!(d.current&&null==r),"useCollapse is changing from controlled to uncontrolled. useCollapse should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled collapse for the lifetime of the component. Check the `isExpanded` prop."),tiny_warning_esm(!(!d.current&&null!=r),"useCollapse is changing from uncontrolled to controlled. useCollapse should not switch from uncontrolled to controlled (or vice versa). Decide between using a controlled or uncontrolled collapse for the lifetime of the component. Check the `isExpanded` prop.")},[r]),[s,f]}(H,M),G=_[0],J=_[1],L=function(e){var t=h?g():null,r=(0,react.useState)(t),i=r[0],l=r[1];return p(function(){null===i&&l(g())},[]),(0,react.useEffect)(function(){!1===h&&(h=!0)},[]),null!=i?String(i):void 0}(),Q=(0,react.useRef)(null);v=Q,E=function(n){}, false&&(0),(0,react.useEffect)(function(){E(v)},[v]);var U,W,X,Y=(V.collapsedHeight||0)+"px",Z={display:"0px"===Y?"none":"block",height:Y,overflow:"hidden"},$=(0,react.useState)(G?{}:Z),nn=$[0],en=$[1],tn=function(n){(0,react_dom.flushSync)(function(){en(n)})},on=function(n){tn(function(e){return a({},e,n)})};function rn(n){if(B)return{};var e=C||function(n){if(!n||"string"==typeof n)return 0;var e=n/36;return Math.round(10*(4+15*Math.pow(e,.25)+e/5))}(n);return{transition:"height "+e+"ms "+S}}U=function(){G?requestAnimationFrame(function(){q(),on(a({},P,{willChange:"height",display:"block",overflow:"hidden"})),requestAnimationFrame(function(){var n=d(Q);on(a({},rn(n),{height:n}))})}):requestAnimationFrame(function(){j();var n=d(Q);on(a({},A,rn(n),{willChange:"height",height:n})),requestAnimationFrame(function(){on({height:Y,overflow:"hidden"})})})},W=[G,Y],X=(0,react.useRef)(!0),(0,react.useEffect)(function(){if(!X.current)return U();X.current=!1},W);var ln=function(n){if(n.target===Q.current&&"height"===n.propertyName)if(G){var e=d(Q);e===nn.height?tn({}):on({height:e}),F()}else nn.height===Y&&(tn(Z),z())};return{getToggleProps:function(n){var e=void 0===n?{}:n,t=e.disabled,o=void 0!==t&&t,r=e.onClick,i=void 0===r?c:r,l=u(e,x);return a({type:"button",role:"button",id:"react-collapsed-toggle-"+L,"aria-controls":"react-collapsed-panel-"+L,"aria-expanded":G,tabIndex:0,disabled:o},l,{onClick:o?c:s(i,function(){return J(function(n){return!n})})})},getCollapseProps:function(n){var e,t=void 0===n?{}:n,o=t.style,r=void 0===o?{}:o,i=t.onTransitionEnd,l=void 0===i?c:i,d=t.refKey,p=void 0===d?"ref":d,h=u(t,y);return a({id:"react-collapsed-panel-"+L,"aria-hidden":!G},h,((e={})[p]=function(){var n=[].slice.call(arguments);return n.every(function(n){return null==n})?null:function(e){n.forEach(function(n){f(n,e)})}}(Q,h[p]),e.onTransitionEnd=s(ln,l),e.style=a({boxSizing:"border-box"},r,nn),e))},isExpanded:G,setExpanded:J}}
//# sourceMappingURL=react-collapsed.esm.js.map

;// CONCATENATED MODULE: ./src/mosanic/builder/Expanders/Expanders.js







var ExpanderContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var Accordion = function(param) {
    var children = param.children, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded, _trigger = param.trigger, trigger = _trigger === void 0 ? null : _trigger, _timeout = param.timeout, timeout = _timeout === void 0 ? 400 : _timeout, _direction = param.direction, direction = _direction === void 0 ? null : _direction, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    var ref = (0,react.useState)(expanded), isExpanded = ref[0], setExpanded = ref[1];
    var ref1 = E({
        isExpanded: isExpanded
    }), getCollapseProps = ref1.getCollapseProps, getToggleProps = ref1.getToggleProps;
    (0,react.useEffect)(function() {
        setExpanded(expanded);
    }, [
        expanded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            trigger ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: isExpanded ? "expanded" : "closed",
                style: {
                    width: fullWidth ? "100%" : "auto"
                }
            }, getToggleProps({
                onClick: function() {
                    return setExpanded(function(prevExpanded) {
                        return !prevExpanded;
                    });
                }
            })), {
                children: trigger
            })) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Expandable, {
                expanded: getCollapseProps,
                timeout: timeout,
                direction: direction,
                children: children
            })
        ]
    });
};
var Expandable = function(param) {
    var children = param.children, expanded = param.expanded, timeout = param.timeout, direction = param.direction;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, expanded()), {
        children: children
    }));
};
var Expanders = function(param, children) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpanderContext.Provider, {
        value: editor,
        children: children
    });
};
var ExpanderHeader = function(param, children) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active;
    var ref1;
    var source = editor.source, handler = editor.handler;
    var ctx = (0,react.useContext)(ExpanderContext);
    var isActive = (source === null || source === void 0 ? void 0 : source.identifier) === (ctx === null || ctx === void 0 ? void 0 : (ref1 = ctx.source) === null || ref1 === void 0 ? void 0 : ref1.active);
    var controlProps = {
        control: {
            active: active,
            notActive: !isActive
        },
        handler: function() {
            return ctx === null || ctx === void 0 ? void 0 : ctx.handler({
                value: !isActive ? source === null || source === void 0 ? void 0 : source.identifier : null,
                extend: "active"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: function() {
            ctx === null || ctx === void 0 ? void 0 : ctx.handler({
                value: !isActive ? source === null || source === void 0 ? void 0 : source.identifier : null,
                extend: "active"
            });
        },
        children: [
            source === null || source === void 0 ? void 0 : source.content,
            (0,schema/* passControlState */.Rn)({
                children: children,
                controlProps: controlProps
            })
        ]
    });
};
var Expander = function(param, children) {
    var fields = param.fields, editor = param.editor, ref = param.ref;
    var ref1;
    var ref2 = editor || {
        source: null,
        handler: null
    }, source = ref2.source, handler = ref2.handler;
    var ctx = (0,react.useContext)(ExpanderContext);
    var trigger = !ctx ? source === null || source === void 0 ? void 0 : source.content : null;
    var active = trigger || !ctx ? null : (source === null || source === void 0 ? void 0 : source.identifier) === (ctx === null || ctx === void 0 ? void 0 : (ref1 = ctx.source) === null || ref1 === void 0 ? void 0 : ref1.active);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
            expanded: active,
            trigger: trigger,
            children: (0,schema/* passControlState */.Rn)({
                children: children,
                controlProps: {
                    control: {
                        active: active,
                        notActive: !active
                    }
                }
            })
        })
    });
};
/* harmony default export */ var Expanders_Expanders = (Expanders);


;// CONCATENATED MODULE: ./src/mosanic/builder/Expanders/index.js

/* harmony default export */ var builder_Expanders = (Expanders_Expanders);


// EXTERNAL MODULE: ./src/mosanic/Icons/index.js
var Icons = __webpack_require__(42238);
;// CONCATENATED MODULE: ./src/mosanic/builder/Icn/Icon.js


var Icon = function(param) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active;
    var ref1, ref2;
    var ref3 = editor || {
        source: null,
        handler: null
    }, source = ref3.source, handler = ref3.handler;
    var icn = (0,Icons/* icon */.qv)(source === null || source === void 0 ? void 0 : (ref1 = source.icon) === null || ref1 === void 0 ? void 0 : ref1.set, source === null || source === void 0 ? void 0 : (ref2 = source.icon) === null || ref2 === void 0 ? void 0 : ref2.icon);
    return (source === null || source === void 0 ? void 0 : source.invert) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        style: {
            filter: "invert(1)"
        },
        children: icn
    }) : icn;
};
/* harmony default export */ var Icn_Icon = (Icon);

;// CONCATENATED MODULE: ./src/mosanic/builder/Icn/index.js

/* harmony default export */ var Icn = (Icn_Icon);

// EXTERNAL MODULE: ./src/adapters/host.js
var host = __webpack_require__(6539);
// EXTERNAL MODULE: ./src/mosanic/utils/Image.js
var utils_Image = __webpack_require__(73987);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/mosanic/builder/Image/Upload.js


var MediaUploader = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 51138));
});



var ImageContainer = function(param) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active;
    var ref1 = editor || {
        source: {
            imageUrl: null
        },
        handler: null
    }, source = ref1.source, handler = ref1.handler;
    var img = (0,utils_Image/* parseImageSrc */.yO)(source.imageUrl);
    return active || !(source === null || source === void 0 ? void 0 : source.imageUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaUploader, {
        imageUrl: img.full,
        showEditor: active,
        callback: handler,
        autoUpload: true,
        cover: true
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        layout: "fill",
        src: (0,host/* getImageUrl */.Jn)(img.full),
        alt: (source === null || source === void 0 ? void 0 : source.alt) ? source.alt : "Image",
        placeholder: (source === null || source === void 0 ? void 0 : source.placeholder) ? source === null || source === void 0 ? void 0 : source.placeholder : "blur",
        blurDataURL: (0,host/* getImageUrl */.Jn)(img.min),
        objectFit: "contain"
    });
};
/* harmony default export */ var Upload = (ImageContainer);

;// CONCATENATED MODULE: ./src/mosanic/builder/Image/index.js

var Image_Image = Upload;
/* harmony default export */ var builder_Image = (Image_Image);

// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/mosanic/builder/Script/Script.js





var Script = function(param) {
    var fields = param.fields, ref = param.ref, editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active;
    var source = editor.source, handler = editor.handler;
    return (0,Text/* containsSubstr */.xX)(source === null || source === void 0 ? void 0 : source.url, "fonts.googleapis") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://fonts.googleapis.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://fonts.gstatic.com",
                crossOrigin: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: source === null || source === void 0 ? void 0 : source.url,
                rel: "stylesheet"
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        src: (source === null || source === void 0 ? void 0 : source.url) ? source.url : undefined,
        dangerouslySetInnerHTML: {
            __html: source === null || source === void 0 ? void 0 : source.dangerCode
        },
        strategy: (source === null || source === void 0 ? void 0 : source.strategy) ? source.strategy : "afterInteractive",
        onLoad: (source === null || source === void 0 ? void 0 : source.onLoadCode) ? source.onLoadCode : undefined,
        onReady: (source === null || source === void 0 ? void 0 : source.onReadyCode) ? source.onReadyCode : undefined,
        onError: function(e) {
            return (source === null || source === void 0 ? void 0 : source.onErrorFunc) ? source.onErrorFunc(e) : undefined;
        }
    }, source === null || source === void 0 ? void 0 : source.dataAttrObject), {
        children: source === null || source === void 0 ? void 0 : source.inlineScriptCode
    }));
};
/* harmony default export */ var Script_Script = (Script);

;// CONCATENATED MODULE: ./src/mosanic/builder/Script/index.js

/* harmony default export */ var builder_Script = (Script_Script);

;// CONCATENATED MODULE: ./src/mosanic/builder/Tabs/Tabs.js



var TabContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var Tabs = function(param, children) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabContext.Provider, {
        value: editor,
        children: children
    });
};
var TabHeader = function(param, children) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active;
    var ref1, ref2;
    var source = editor.source, handler = editor.handler;
    var ctx = (0,react.useContext)(TabContext);
    var controlProps = {
        control: {
            active: (source === null || source === void 0 ? void 0 : source.identifier) === (ctx === null || ctx === void 0 ? void 0 : (ref1 = ctx.source) === null || ref1 === void 0 ? void 0 : ref1.active),
            notActive: (source === null || source === void 0 ? void 0 : source.identifier) != (ctx === null || ctx === void 0 ? void 0 : (ref2 = ctx.source) === null || ref2 === void 0 ? void 0 : ref2.active)
        },
        handler: function() {
            return ctx === null || ctx === void 0 ? void 0 : ctx.handler({
                value: source === null || source === void 0 ? void 0 : source.identifier,
                extend: "active"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: function() {
            return ctx === null || ctx === void 0 ? void 0 : ctx.handler({
                value: source === null || source === void 0 ? void 0 : source.identifier,
                extend: "active"
            });
        },
        children: [
            source === null || source === void 0 ? void 0 : source.content,
            (0,schema/* passControlState */.Rn)({
                children: children,
                controlProps: controlProps
            })
        ]
    });
};
var Tab = function(param, children) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active;
    var ref1;
    var ref2 = editor || {
        source: null,
        handler: null
    }, source = ref2.source, handler = ref2.handler;
    var ctx = (0,react.useContext)(TabContext);
    if (ctx && (ctx === null || ctx === void 0 ? void 0 : (ref1 = ctx.source) === null || ref1 === void 0 ? void 0 : ref1.active)) {
        if ((source === null || source === void 0 ? void 0 : source.identifier) != ctx.source.active) return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/* harmony default export */ var Tabs_Tabs = (Tabs);


;// CONCATENATED MODULE: ./src/mosanic/builder/Tabs/index.js

/* harmony default export */ var builder_Tabs = (Tabs_Tabs);


// EXTERNAL MODULE: ./src/mosanic/fields/Editor/Text.js
var Editor_Text = __webpack_require__(50703);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/mosanic/builder/Text/Text.js


var Editor = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 28970));
});



var Text_Text = function(param) {
    var editor = param.editor, active = param.active;
    var locale = (0,next_router.useRouter)().locale;
    var ref = editor || {
        source: {
            content: null
        }
    }, source = ref.source, handler = ref.handler;
    var content = source === null || source === void 0 ? void 0 : source.content;
    var localized = (0,Obj/* hasAttr */.B$)(content, locale);
    var handleInput = function(e) {
        return handler({
            value: e,
            extend: "content".concat(localized ? ".".concat(locale) : "")
        });
    };
    if (!content) return null;
    if (localized) content = content[locale];
    if (active) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
        content: content,
        setContent: handleInput,
        fullToolbar: false,
        ninja: true,
        autoFocus: false
    });
    return Array.isArray(content) && (0,Obj/* hasAttr */.B$)(content[0], "children") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor_Text/* default */.Z, {
        content: (0,Obj/* omitDeep */.Cd)(content)
    }) : null;
};
/* harmony default export */ var builder_Text_Text = (Text_Text);

;// CONCATENATED MODULE: ./src/mosanic/builder/Text/index.js

/* harmony default export */ var builder_Text = (builder_Text_Text);

// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/components/Media/MediaUploader.js + 4 modules
var Media_MediaUploader = __webpack_require__(51138);
;// CONCATENATED MODULE: ./src/mosanic/builder/Video/Upload.js

function Upload_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      content: '';\n      display: block;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left:0;\n      right:0;\n      background: rgba(0,0,0,0.5);\n      "
    ]);
    Upload_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n      filter: blur(5px);\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  object-fit: cover;\n  &::after {\n    ",
        "\n  }\n\n  video {\n    ",
        "\n    object-fit: cover;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var ReactPlayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 960).then(__webpack_require__.bind(__webpack_require__, 80960));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80960)
            ];
        }
    }
});

var Cover = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9919fbdd-0"
})(_templateObject2(), function(props) {
    return props.overlay && (0,styled_components_browser_esm/* css */.iv)(Upload_templateObject());
}, function(props) {
    return props.blur && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});
var bool = function(value) {
    return value === 1;
};
var VideoContainer = function(param) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active;
    var ref1 = editor || {
        source: null,
        handler: null
    }, source = ref1.source, handler = ref1.handler;
    var url = (0,utils_Image/* parseImageSrc */.yO)(source === null || source === void 0 ? void 0 : source.videoUrl, true);
    var ref2 = source || {
        controls: true,
        alt: "video",
        autoplay: true,
        loop: true,
        muted: true,
        cover: false,
        blur: false,
        overlay: false
    }, controls = ref2.controls, alt = ref2.alt, autoplay = ref2.autoplay, loop = ref2.loop, muted = ref2.muted, cover = ref2.cover, blur = ref2.blur, overlay = ref2.overlay;
    return active || !(source === null || source === void 0 ? void 0 : source.videoUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Media_MediaUploader["default"], {
        imageUrl: source === null || source === void 0 ? void 0 : source.videoUrl,
        type: "video",
        showEditor: active,
        callback: handler,
        autoUpload: true,
        cover: true
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: bool(cover),
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover, {
                blur: bool(blur),
                overlay: bool(overlay),
                children: children
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactPlayer, {
            url: (url === null || url === void 0 ? void 0 : url.full) ? url === null || url === void 0 ? void 0 : url.full : null,
            controls: bool(controls),
            autoPlay: bool(autoplay),
            loop: bool(loop),
            volume: bool(muted) ? 0 : 1,
            muted: bool(muted),
            playsinline: true,
            wrapper: "span",
            alt: alt,
            playing: bool(autoplay),
            width: "100%",
            height: "100%"
        })
    });
};
/* harmony default export */ var Video_Upload = (VideoContainer);

;// CONCATENATED MODULE: ./src/mosanic/builder/Video/index.js

var Video = Video_Upload;
/* harmony default export */ var builder_Video = (Video);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/mosanic/components/Media/Marked/MarkedImage.js
var MarkedImage = __webpack_require__(67683);
// EXTERNAL MODULE: ./src/mosanic/core/Page/Render.js
var Render = __webpack_require__(26381);
// EXTERNAL MODULE: ./src/mosanic/core/Provider/DataProviders.js
var DataProviders = __webpack_require__(42622);
// EXTERNAL MODULE: ./src/mosanic/core/Provider/PageProviders.js
var PageProviders = __webpack_require__(43970);
// EXTERNAL MODULE: ./src/mosanic/items/Link/index.js
var Link = __webpack_require__(8152);
// EXTERNAL MODULE: ./src/mosanic/items/Expander/index.js + 1 modules
var items_Expander = __webpack_require__(56957);
// EXTERNAL MODULE: ../../node_modules/slugify/slugify.js
var slugify = __webpack_require__(76854);
// EXTERNAL MODULE: ./src/mosanic/builder/Map/index.js
var Map = __webpack_require__(23045);
// EXTERNAL MODULE: ./src/mosanic/builder/DataLink/DataReceiver.js
var DataReceiver = __webpack_require__(65139);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/useCollection.js
var useCollection = __webpack_require__(11096);
// EXTERNAL MODULE: ./src/mosanic/items/Tooltip/index.js + 2 modules
var Tooltip = __webpack_require__(94233);
;// CONCATENATED MODULE: ./src/mosanic/builder/DataLink/DataRender.js


function DataRender_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        flex-wrap: nowrap;\n        max-width: 100%;\n        overflow: hidden;\n    "
    ]);
    DataRender_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DataRender_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: flex;\n    /* justify-content: space-between; */\n    flex-wrap: wrap;\n\n    ",
        "\n\n"
    ]);
    DataRender_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DataRender_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    font-size: 14px;\n"
    ]);
    DataRender_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        margin-right: 5px;\n        background: #fff;\n        height: 20px;\n        width: 20px;\n        border-radius: 50%;\n        padding: 2px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin: 0 10px 10px;\n    \n    ",
        "\n    img {\n        object-fit: cover!important;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var InlineStack = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f9c4ba9-0"
})(DataRender_templateObject1(), function(props) {
    return props.source === "repeater" && (0,styled_components_browser_esm/* css */.iv)(DataRender_templateObject());
});
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8f9c4ba9-1"
})(DataRender_templateObject2());
var Item = (0,styled_components_browser_esm/* default */.ZP)(Label).withConfig({
    componentId: "sc-8f9c4ba9-2"
})(_templateObject4(), function(props) {
    return props.source === "repeater" && (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
});
var room = "639303aac4f0348b9f479d24_dev";
var facility = "639306b5c4f0348b9f479ee2";
var acc_type = "639304afc4f0348b9f479d9e";
var hasRelationRender = function(collection) {
    return [
        room,
        facility,
        acc_type
    ].includes(collection);
};
var RelationRender = function(param) {
    var entry = param.entry, link = param.link, content = param.content;
    // const id = entry?.collection;
    // return JSON.stringify(entry)
    /// ---> if relation can render ==> pass as single option to zone
    // todo (let zones, select input type == multiple / single)
    if (room === link) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Rooms, {
        content: content
    });
    if (facility === link) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Facilities, {
        content: content,
        source: entry === null || entry === void 0 ? void 0 : entry.source
    });
    if (acc_type === link) return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccType, {
        content: content,
        source: entry === null || entry === void 0 ? void 0 : entry.source,
        entry: entry
    });
// return JSON.stringify(content)
};
var Rooms = function(param) {
    var content = param.content;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCollection/* useCollection */.K)({
        _id: room
    }), 2), handler = ref[0], ref1 = (0,_sliced_to_array/* default */.Z)(ref[1], 3), collection = ref1[0], loading = ref1[1], error = ref1[2];
    var getBed = function(value) {
        var ref;
        return collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.find(function(e) {
            return (e === null || e === void 0 ? void 0 : e.Value) === value || (e === null || e === void 0 ? void 0 : e._id) === value;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: content === null || content === void 0 ? void 0 : content.map(function(bed, i) {
            var ref, ref1, ref2;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Label, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: (ref1 = (0,utils_Image/* parseImageSrc */.yO)((ref = getBed((bed === null || bed === void 0 ? void 0 : bed.value) ? bed.value : bed)) === null || ref === void 0 ? void 0 : ref.Icon, true)) === null || ref1 === void 0 ? void 0 : ref1.full,
                        width: "35px",
                        height: "35px",
                        alt: "none"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: (bed === null || bed === void 0 ? void 0 : bed.label) ? bed.label : (ref2 = getBed((bed === null || bed === void 0 ? void 0 : bed.value) ? bed.value : bed)) === null || ref2 === void 0 ? void 0 : ref2.Label
                    })
                ]
            }, i);
        })
    });
};
var Facilities = function(param) {
    var content = param.content, source = param.source;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCollection/* useCollection */.K)({
        _id: facility
    }), 2), handler = ref[0], ref1 = (0,_sliced_to_array/* default */.Z)(ref[1], 3), collection = ref1[0], loading = ref1[1], error = ref1[2];
    var getFacility = function(value) {
        var ref;
        return collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.find(function(e) {
            return (e === null || e === void 0 ? void 0 : e.Label) === value || (e === null || e === void 0 ? void 0 : e._id) === value;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineStack, {
        source: source,
        children: Array.isArray(content) && (content === null || content === void 0 ? void 0 : content.map(function(point, i) {
            var ref, ref1, ref2;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                title: source === "repeater" && (point === null || point === void 0 ? void 0 : point.label),
                force: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    source: source,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (ref1 = (0,utils_Image/* parseImageSrc */.yO)((ref = getFacility((point === null || point === void 0 ? void 0 : point.label) ? point.label : point)) === null || ref === void 0 ? void 0 : ref.Icon, true)) === null || ref1 === void 0 ? void 0 : ref1.full,
                            width: "15px",
                            height: "15px",
                            alt: "none"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        source != "source" ? null : source != "repeater" && (point === null || point === void 0 ? void 0 : point.label) ? point.label : (ref2 = getFacility((point === null || point === void 0 ? void 0 : point.label) ? point.label : point)) === null || ref2 === void 0 ? void 0 : ref2.Label
                    ]
                })
            }, i);
        }))
    });
};
var AccType = function(param) {
    var content = param.content, source = param.source, entry = param.entry;
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useCollection/* useCollection */.K)({
        _id: acc_type
    }), 2), handler = ref2[0], ref3 = (0,_sliced_to_array/* default */.Z)(ref2[1], 3), collection = ref3[0], loading = ref3[1], error = ref3[2];
    var type = collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.find(function(e) {
        return (e === null || e === void 0 ? void 0 : e.sys_type) === content || e._id === content;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: (ref1 = (0,utils_Image/* parseImageSrc */.yO)(type === null || type === void 0 ? void 0 : type.Icon, true)) === null || ref1 === void 0 ? void 0 : ref1.full,
        width: "25px",
        height: "25px",
        alt: type === null || type === void 0 ? void 0 : type.Description
    });
};

// EXTERNAL MODULE: ./src/mosanic/utils/value.js + 1 modules
var value = __webpack_require__(11039);
// EXTERNAL MODULE: ./src/mosanic/fields/Source/helpers.js
var helpers = __webpack_require__(49272);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/index.js
var fields_Input = __webpack_require__(6928);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
;// CONCATENATED MODULE: ./src/mosanic/builder/DataLink/FormField.js









var FormField = function(param) {
    var entry = param.entry, schema = param.schema;
    var ref = (0,index_esm/* useFormContext */.Gc)(), handleSubmit = ref.handleSubmit, control = ref.control, watch = ref.watch, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors
    };
    var form = (0,DataProviders/* useFormProvider */.RC)();
    // TODO use same parser that is used in the input method
    // Render it over here
    var field = (0,helpers/* getLatestFieldFromFieldPath */.Ts)(entry === null || entry === void 0 ? void 0 : entry.fieldPath);
    return control ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fields_Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            label: (0,Text/* revertSnakeCase */.UY)(field === null || field === void 0 ? void 0 : field.name),
            type: field === null || field === void 0 ? void 0 : field.type
        }, field), {
            name: (0,Text/* combineString */.M7)(entry === null || entry === void 0 ? void 0 : entry.fieldPath.map(function(e) {
                return e.name;
            }), ".")
        }), inputProps), {
            props: field
        }))
    }) : "..";
};

// EXTERNAL MODULE: ./src/utils/Num.js
var Num = __webpack_require__(3121);
;// CONCATENATED MODULE: ./src/mosanic/builder/DataLink/DataLink.js























var getEntries = function(getData, repeater, collection) {
    return getData ? collection === null || collection === void 0 ? void 0 : collection.entries : (repeater === null || repeater === void 0 ? void 0 : repeater.entries) ? repeater === null || repeater === void 0 ? void 0 : repeater.entries : repeater === null || repeater === void 0 ? void 0 : repeater.entry;
};
var getEntry = function(entries, entry) {
    return (entry === null || entry === void 0 ? void 0 : entry.entry) ? entries === null || entries === void 0 ? void 0 : entries.find(function(e) {
        return (e === null || e === void 0 ? void 0 : e._id) === (entry === null || entry === void 0 ? void 0 : entry.entry);
    }) : entries;
};
var shouldReplaceCodeField = function(entry) {
    var ref, ref1;
    return (entry === null || entry === void 0 ? void 0 : (ref = entry.field) === null || ref === void 0 ? void 0 : ref.code) && (entry === null || entry === void 0 ? void 0 : (ref1 = entry.field) === null || ref1 === void 0 ? void 0 : ref1.field);
};
var RenderContent = function(html, content) {
    return html ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: content
        }
    }) : content;
};
// TODO --> add 'author' / userId selector --> for getting correct entries.
// TODO also in repeater.
var DataLink = function(param, children) {
    var fields = param.fields, ref = param.ref, editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active, clone = param.clone, isDev = param.isDev;
    var ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var source = editor.source;
    var entry = (source || {
        entry: null
    }).entry;
    var ref5 = source || {
        limit: null,
        end: null,
        excerpt: false,
        html: false
    }, limit = ref5.limit, end = ref5.end, excerpt = ref5.excerpt, html = ref5.html;
    var dataProvider = (0,DataProviders/* useDataProvider */.x5)();
    var form = (0,DataProviders/* useFormProvider */.RC)();
    var page = (0,PageProviders/* usePageContext */.lO)();
    var repeater = (0,DataProviders/* useRepeatProvider */.RS)();
    var getData = (entry === null || entry === void 0 ? void 0 : entry.source) != "provider" && (!(source === null || source === void 0 ? void 0 : source.dynamic) && !(source === null || source === void 0 ? void 0 : source.hasParentLink) && !(repeater === null || repeater === void 0 ? void 0 : repeater.entries) && !(repeater === null || repeater === void 0 ? void 0 : repeater.entry) || !(page === null || page === void 0 ? void 0 : page.entry));
    var entries = null, current = null;
    var lastField = (0,helpers/* getLatestFieldFromFieldPath */.Ts)(entry === null || entry === void 0 ? void 0 : entry.fieldPath);
    var fieldType = lastField === null || lastField === void 0 ? void 0 : lastField.type;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,DataReceiver/* useDataReceiver */.H)({
        source: (source === null || source === void 0 ? void 0 : source.dynamic) ? "page" : entry === null || entry === void 0 ? void 0 : entry.source,
        entry: entry,
        clone: clone
    }), 3), content = ref6[0], schema = ref6[1], baseRoute = ref6[2];
    if (shouldReplaceCodeField(entry)) {
        content = (0,value/* evalReplaceValue */.FG)(entry.field.code, content);
    }
    var locale = (0,useLocale/* useLocale */.bU)(JSON.stringify(content ? content : {}));
    var lowCaseField = (0,Text/* toLowCase */.Cc)(entry === null || entry === void 0 ? void 0 : entry.field);
    if ((0,Text/* containsSubstr */.xX)(lowCaseField, "slug") || lowCaseField === "slug" || (lastField === null || lastField === void 0 ? void 0 : lastField.name) === "slug" || (entry === null || entry === void 0 ? void 0 : (ref1 = entry.field) === null || ref1 === void 0 ? void 0 : ref1.code) && (0,Text/* containsSubstr */.xX)(content, "https")) {
        // const schemaIndex = schema?.[0]?.name;
        if (!(0,Text/* containsSubstr */.xX)(content, "https")) content = baseRoute ? "/".concat(baseRoute, "/").concat(content) : "/".concat(content);
        // if(schemaIndex && hasAttr(content, schemaIndex)) url += toLowCase(slugify(content[schemaIndex]))
        // if(entry?.collection === '63359058737d68d97014da2d') {
        //     url = '/listing/'
        //     if(schemaIndex && content?.accommodation_name) url += toLowCase(slugify(content?.accommodation_name))
        // } 
        if (source === null || source === void 0 ? void 0 : source.iframe) return /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            src: content,
            height: "100%",
            width: "100%"
        });
        if ((router === null || router === void 0 ? void 0 : router.pathname) === "/app/builder") return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            href: content,
            children: children ? children : "view"
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
            href: content,
            children: children ? children : "view"
        });
    }
    // if(fieldType === 'gallery') return JSON.stringify(content['image_gallery'])
    if (fieldType === "markedimage") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkedImage.MarkedImage, {
            value: content,
            displayOnly: true
        })
    });
    var imageSource = (0,utils_Image/* parseImageSrc */.yO)(content, true);
    if (fieldType === "image" || imageSource && ![
        "textarea",
        "text"
    ].includes(fieldType)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                position: "relative",
                width: "100%",
                height: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                blurDataURL: imageSource === null || imageSource === void 0 ? void 0 : imageSource.min,
                src: imageSource === null || imageSource === void 0 ? void 0 : imageSource.full,
                alt: (content === null || content === void 0 ? void 0 : content.alt) ? content.alt : "",
                objectFit: "contain",
                layout: "fill"
            })
        });
    }
    if (fieldType === "location") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Map/* default */.Z, {
            editor: {
                source: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, content), {
                    apiKey: "AIzaSyAma8GPPHZNC5Gg1bXp7V5GMbfYH1gIGbk"
                })
            }
        });
    }
    if (fieldType === "relation") {
        var ref7;
        // relationEnd --> rooms/ beds
        // relationRender --> page 
        // relation is type
        var linkData = entry === null || entry === void 0 ? void 0 : entry.fieldPath[(entry === null || entry === void 0 ? void 0 : (ref7 = entry.fieldPath) === null || ref7 === void 0 ? void 0 : ref7.length) - 1];
        // return JSON.stringify(linkData)
        if (hasRelationRender(linkData === null || linkData === void 0 ? void 0 : linkData.relation)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(RelationRender, {
            entry: entry,
            link: linkData === null || linkData === void 0 ? void 0 : linkData.relation,
            content: content
        });
        // if(hasRelationRender(linkData?.relationEnd)) return <RelationRender entry={entry} link={linkData?.relationEnd} content={content} />
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Render/* FullRelationRender */.Lf, {
                linkData: linkData,
                render: (linkData === null || linkData === void 0 ? void 0 : linkData.relationRender) ? linkData.relationRender : linkData === null || linkData === void 0 ? void 0 : linkData.render,
                relation: (linkData === null || linkData === void 0 ? void 0 : linkData.relationEnd) ? linkData.relationEnd : linkData === null || linkData === void 0 ? void 0 : linkData.relation,
                entries: (linkData === null || linkData === void 0 ? void 0 : linkData.entries) ? linkData.entries : content
            })
        });
    }
    var contentRender = content ? Array.isArray(content) && (content === null || content === void 0 ? void 0 : (ref2 = content[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.url) === null || ref3 === void 0 ? void 0 : ref3.url) || fieldType === "gallery" ? null : !(0,Text/* isString */.HD)(content) && Array.isArray(content) ? (0,Obj/* hasAttr */.B$)(content === null || content === void 0 ? void 0 : content[0], "children") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor_Text/* default */.Z, {
        content: (0,Obj/* omitDeep */.Cd)(content)
    }) : null : (0,Num/* isNumber */.hj)(content) ? content.toString() : (0,Text/* isString */.HD)(content) ? content : (0,Text/* isString */.HD)(locale) ? locale : Array.isArray(locale) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor_Text/* default */.Z, {
        content: (0,Obj/* omitDeep */.Cd)(locale)
    }) : null : null;
    // if(toLowCase(entry?.field) === 'gallery' ) console.log({content, contentRender})
    // if((Array.isArray(content) && content?.[0]?.url?.url) ) console.log("NOT RENDINGER?")
    var wrapperContent = !contentRender && content ? content : current ? current : entries ? entries : null;
    if ((0,Text/* isString */.HD)(contentRender) && excerpt) {
        var sourceContent = contentRender;
        contentRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(items_Expander/* default */.Z, {
            trigger: RenderContent(html, (0,Text/* excerptString */.dK)(sourceContent, parseFloat(limit), end)),
            children: RenderContent(html, sourceContent.substring(parseFloat(limit), 99999))
        });
    }
    // console.log({content, wrapperContent, content, entry: entry?.field} )
    // return JSON.stringify({wrapperContent, contentRender, content})
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataProviders/* DataProvider */.FW, {
        data: wrapperContent,
        children: [
            children && children,
            (form === null || form === void 0 ? void 0 : (ref4 = form.state) === null || ref4 === void 0 ? void 0 : ref4.editing) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField, {
                entry: entry,
                schema: schema
            }) : contentRender && ((0,Text/* isString */.HD)(contentRender) ? RenderContent(html, contentRender) : contentRender)
        ]
    });
//  return content ? (
//     <>
//     {contentRender}
//     </>
// ) : (
//     <DataProvider value={wrapperContent}>
//         {children}
//     </DataProvider>
// );
};
/* harmony default export */ var DataLink_DataLink = (DataLink);

;// CONCATENATED MODULE: ./src/mosanic/builder/DataLink/index.js

/* harmony default export */ var builder_DataLink = (DataLink_DataLink);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/adapters/queries/collections.js
var collections = __webpack_require__(94283);
// EXTERNAL MODULE: ./src/hooks/useApi.js + 3 modules
var useApi = __webpack_require__(70210);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
;// CONCATENATED MODULE: ./src/mosanic/builder/DataProvider/DataProvider.js













var DataProvider_getEntry = function(entries, entry) {
    return (entry === null || entry === void 0 ? void 0 : entry.entry) ? entries === null || entries === void 0 ? void 0 : entries.find(function(e) {
        return (e === null || e === void 0 ? void 0 : e._id) === (entry === null || entry === void 0 ? void 0 : entry.entry);
    }) : entries;
};
var DataProvider_useCollection = function(param) {
    var entry = param.entry;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useApi/* useLazyQuery */.td)("collectionById", collections/* COLLECTION */.du), 2), handler = ref[0], ref1 = (0,_sliced_to_array/* default */.Z)(ref[1], 3), collection = ref1[0], loading = ref1[1], error = ref1[2];
    (0,react.useEffect)(function() {
        if ((entry === null || entry === void 0 ? void 0 : entry.collection) && !(collection === null || collection === void 0 ? void 0 : collection.entries) && !error) handler({
            _id: entry.collection
        });
    }, [
        entry === null || entry === void 0 ? void 0 : entry.collection,
        collection === null || collection === void 0 ? void 0 : collection.entries,
        error
    ]);
    return [
        collection,
        loading
    ];
};
var DataProvider = function(param, children) {
    var fields = param.fields, ref = param.ref, editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active, clone = param.clone;
    var ref1, ref2, ref3;
    var source = (editor || {
        source: null
    }).source;
    var ref4 = source || {
        entry: null,
        filters: true
    }, entry = ref4.entry, filters = ref4.filters;
    var page = (0,PageProviders/* usePageContext */.lO)();
    var repeater = (0,DataProviders/* useRepeatProvider */.RS)();
    var providedData = (0,DataProviders/* useDataProvider */.x5)();
    var ref5 = (0,_sliced_to_array/* default */.Z)(DataProvider_useCollection({
        entry: entry
    }), 2), collection = ref5[0], loading = ref5[1];
    var entries = collection === null || collection === void 0 ? void 0 : collection.entries;
    var current = (source === null || source === void 0 ? void 0 : source.dynamic) && (page === null || page === void 0 ? void 0 : page.entry) ? page === null || page === void 0 ? void 0 : page.entry : (repeater === null || repeater === void 0 ? void 0 : repeater.entries) && (0,value/* isClone */.vu)(clone) ? entries === null || entries === void 0 ? void 0 : entries[clone] : DataProvider_getEntry(entries, entry);
    // const field = hasAttr(current, entry?.field) ? current[entry.field] : null;
    var field = (0,helpers/* getField */.rz)(collection, entry);
    var data = (0,helpers/* getFieldValue */.oe)(entry === null || entry === void 0 ? void 0 : entry.fieldPath, current);
    data = (0,value/* isClone */.vu)(clone) && (data === null || data === void 0 ? void 0 : data[clone]) ? data[clone] : data;
    var lastName = entry === null || entry === void 0 ? void 0 : (ref2 = entry.fieldPath) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[(entry === null || entry === void 0 ? void 0 : (ref1 = entry.fieldPath) === null || ref1 === void 0 ? void 0 : ref1.length) - 1]) === null || ref3 === void 0 ? void 0 : ref3.name;
    // if(toLowCase(entry?.field) === 'gallery' ) console.log({content, contentRender})
    // if((Array.isArray(content) && content?.[0]?.url?.url) ) console.log("NOT RENDINGER?")
    // const content = 
    //         field ? field : 
    //         current ? current : 
    //         entries ? entries :
    //         null
    // console.log({content, wrapperContent, content, entry: entry?.field} )
    // return JSON.stringify({wrapperContent, contentRender, content})
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataProviders/* DataProvider */.FW, {
        data: (0,_object_spread/* default */.Z)((0,_define_property/* default */.Z)({}, lastName, {
            data: data,
            entry: entry
        }), providedData),
        children: [
            filters && /*#__PURE__*/ (0,jsx_runtime.jsx)(items_Expander/* default */.Z, {
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    children: [
                        "Filters  ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* DropdownMenuIcon */.$Pd, {})
                    ]
                }),
                children: "Filter options"
            }),
            children
        ]
    });
// return content ? (
//     <>
//     {contentRender}
//     </>
// ) : (
//     <DataContext.Provider value={wrapperContent}>
//         {children}
//     </DataContext.Provider>
// );
};
/* harmony default export */ var DataProvider_DataProvider = (DataProvider);

;// CONCATENATED MODULE: ./src/mosanic/builder/DataProvider/index.js

/* harmony default export */ var builder_DataProvider = (DataProvider_DataProvider);

// EXTERNAL MODULE: ./src/mosanic/auth/AuthForm.js + 3 modules
var AuthForm = __webpack_require__(36086);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/Entry.js + 3 modules
var Entry = __webpack_require__(69491);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/mosanic/cms/Mutate/useDataMutate.js
var useDataMutate = __webpack_require__(39656);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/useDataQuery.js
var useDataQuery = __webpack_require__(49974);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/EntryMails.js
var EntryMails = __webpack_require__(3237);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/useEntries.js
var useEntries = __webpack_require__(60649);
// EXTERNAL MODULE: ./src/mosanic/fields/Code/PreviewCode.js
var PreviewCode = __webpack_require__(59389);
// EXTERNAL MODULE: ./src/mosanic/items/LoadingDots.tsx
var LoadingDots = __webpack_require__(4093);
// EXTERNAL MODULE: ./src/mosanic/utils/collection.js
var utils_collection = __webpack_require__(69735);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/utils/Boolean.js
var Boolean = __webpack_require__(13365);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/adapters/client.js + 4 modules
var client = __webpack_require__(64792);
// EXTERNAL MODULE: ./src/adapters/queries/users.js
var users = __webpack_require__(62641);
// EXTERNAL MODULE: ./src/mosanic/cms/Mutate/update.js
var update = __webpack_require__(80581);
// EXTERNAL MODULE: ./src/mosanic/components/Mail/useSendOne.js
var useSendOne = __webpack_require__(16956);
// EXTERNAL MODULE: ./src/mosanic/hooks/useNotify.js
var useNotify = __webpack_require__(33346);
;// CONCATENATED MODULE: ./src/mosanic/builder/Form/FormProvider.js







function FormProvider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    position: absolute;\n    width: 400px;\n    margin: 25px auto;\n    padding: 25px;\n    border: 1px solid red;\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 0 40px rgba(0,0,0,.3);\n"
    ]);
    FormProvider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FormProvider_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;   \n    bottom: 0;\n    background: rgba(0,0,0,.5);\n    backdrop-filter: blur(5px);\n"
    ]);
    FormProvider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FormProvider_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n"
    ]);
    FormProvider_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

























var FormProvider_Error = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5eb25a74-0"
})(FormProvider_templateObject());
var ErrorOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5eb25a74-1"
})(FormProvider_templateObject1());
var ErrorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5eb25a74-2"
})(FormProvider_templateObject2());
var tenSecondsInMs = 10000;
var UserError = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormProvider_Error, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: "⚠️ Updating stopped.."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                children: "Note: No actions were performed."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "We could not find or validate any users to update. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please sign out and sign in to try again. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "If the problem persists, please contact us. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "We are sorry for the inconvenience. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "The page will be reloaded in 10 seconds."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {})
                ]
            })
        ]
    });
};
var MailError = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormProvider_Error, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: "⚠️ Mail not send stopped.."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                children: "Note: No actions were performed."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "The previous action were successfully performed. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "However, we could not send the mail. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please contact us so we can send it manually. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "We are sorry for the inconvenience. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "The page will be reloaded in 10 seconds."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {})
                ]
            })
        ]
    });
};
var FormProvider = function(param) {
    var children = param.children, collection = param.collection, when = param.when;
    var ref;
    var ref1 = (0,react.useState)({
        editing: false,
        button: null
    }), state = ref1[0], setState = ref1[1];
    var toggleEditing = function() {
        return setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            editing: !(state === null || state === void 0 ? void 0 : state.editing)
        }));
    };
    var setSubmitButton = function(name) {
        return setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            button: name
        }));
    };
    // ? Utils
    var router = (0,next_router.useRouter)();
    var notify = (0,useNotify/* default */.Z)();
    var methods = (0,index_esm/* useForm */.cI)({
        mode: "all"
    });
    var handleSubmit = methods.handleSubmit, watch = methods.watch, reset = methods.reset, formState = methods.formState;
    var ref2 = (0,react.useState)(null), err = ref2[0], setErr = ref2[1];
    var ref3 = (0,react.useState)(false), submitting = ref3[0], setSubmitting = ref3[1];
    // ? Core handler
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useDataMutate/* useUpdate */.PQ)({}), 2), updateEntry = ref4[0], ref5 = (0,_sliced_to_array/* default */.Z)(ref4[1], 3), c_update_data = ref5[0], c_update_loading = ref5[1], c_update_error = ref5[2];
    // ? Handlers
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,update/* useUpdateUser */.Io)(true), 2), updateUser = ref6[0], ref7 = (0,_sliced_to_array/* default */.Z)(ref6[1], 3), d = ref7[0], loadingUpdateUser = ref7[1], errorUpdatingUser = ref7[2];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useSendOne/* useSendOne */.x)(), 4), sendMail = ref8[0], sendData = ref8[1], sendLoading = ref8[2], sendingError = ref8[3];
    // ? Selectors
    var page = (0,PageProviders/* usePageContext */.lO)();
    var userId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetUser */.pg)({
        _id: userId
    }), 1), user = ref9[0];
    // ? Mail handler
    var ref10 = (0,react.useState)({
        step: "null",
        data: null
    }), updateState = ref10[0], setUpdateState = ref10[1];
    var mails = (0,EntryMails/* useEntryMails */.$)({
        state: updateState,
        setState: setUpdateState,
        mail: updateState === null || updateState === void 0 ? void 0 : updateState.mail,
        collection: collection
    });
    (0,react.useEffect)(function() {
        var ref;
        if (page === null || page === void 0 ? void 0 : (ref = page.entry) === null || ref === void 0 ? void 0 : ref._id) reset((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, page === null || page === void 0 ? void 0 : page.entry), {
            retrieve: null
        }));
    }, [
        page === null || page === void 0 ? void 0 : (ref = page.entry) === null || ref === void 0 ? void 0 : ref._id
    ]);
    var validate = null;
    var _obj;
    var validation = (_obj = {
        hide: null,
        show: null,
        disable: null,
        enable: null
    }, (0,_define_property/* default */.Z)(_obj, "enable", null), (0,_define_property/* default */.Z)(_obj, "update", null), (0,_define_property/* default */.Z)(_obj, "noUpdate", null), (0,_define_property/* default */.Z)(_obj, "create", null), (0,_define_property/* default */.Z)(_obj, "noCreate", null), (0,_define_property/* default */.Z)(_obj, "error", null), (0,_define_property/* default */.Z)(_obj, "helper", null), _obj);
    if (when) {
        var ref11;
        validate = (0,helpers/* getSchema */.J1)(when === null || when === void 0 ? void 0 : when.fieldPath, collection === null || collection === void 0 ? void 0 : collection.schema);
        var shouldValidate = (validate === null || validate === void 0 ? void 0 : validate.validateActive) && (validate === null || validate === void 0 ? void 0 : (ref11 = validate.validation) === null || ref11 === void 0 ? void 0 : ref11.length) >= 1;
        if (shouldValidate) {
            var ctx = {
                entry: page === null || page === void 0 ? void 0 : page.entry,
                user: user
            };
            validate.validation.filter(function(rule) {
                var ref;
                return rule.code && ((ref = rule.actions) === null || ref === void 0 ? void 0 : ref.length) >= 1;
            }).map(function(rule, i) {
                var actions = rule.actions;
                var result = (0,PreviewCode/* parseCode */.zY)(rule.code, ctx, false);
                //Parse a action key
                var parseKey = function(key) {
                    //Get error || label validation
                    if ([
                        "error",
                        "helper"
                    ].includes(key)) return (rule === null || rule === void 0 ? void 0 : rule[key]) ? (0,PreviewCode/* parseCode */.zY)(rule === null || rule === void 0 ? void 0 : rule[key], ctx, false) : null;
                    //Return stringified result
                    return !(0,Boolean/* default */.Z)(result) ? result : result ? "true" : "false";
                };
                actions.map(function(key) {
                    validation[key] = parseKey(key);
                });
            });
            validation = Object.fromEntries(Object.entries(validation).filter(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], value = _param[1];
                return value != null;
            }));
            if ((0,Obj/* hasAttr */.B$)(validation, "hide") && (validation === null || validation === void 0 ? void 0 : validation.hide) === "true") return null;
            if ((0,Obj/* hasAttr */.B$)(validation, "show") && (validation === null || validation === void 0 ? void 0 : validation.show) === "false") return null;
            if ((validation === null || validation === void 0 ? void 0 : validation.show) === "true" && !(validation === null || validation === void 0 ? void 0 : validation.hide)) {
                if (!(state === null || state === void 0 ? void 0 : state.editing)) setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    editing: true
                }));
            }
        }
    }
    var schemaButtons = (0,utils_collection/* getFields */.V)(collection === null || collection === void 0 ? void 0 : collection.schema, "button");
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var ref, ref1, button, hasUserTriggers, hasMailTriggers, ctx, entry, userToTrigger;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setSubmitting(true);
                        if (data === null || data === void 0 ? void 0 : data._id) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        button = schemaButtons === null || schemaButtons === void 0 ? void 0 : schemaButtons.find(function(b) {
                            return (b === null || b === void 0 ? void 0 : b.name) === (state === null || state === void 0 ? void 0 : state.button);
                        });
                        hasUserTriggers = (button === null || button === void 0 ? void 0 : button.enableUser) && (button === null || button === void 0 ? void 0 : (ref = button.trigger) === null || ref === void 0 ? void 0 : (ref1 = ref.users) === null || ref1 === void 0 ? void 0 : ref1.length) >= 1;
                        hasMailTriggers = (button === null || button === void 0 ? void 0 : button.enableMail) && (button === null || button === void 0 ? void 0 : button.mailId) && (button === null || button === void 0 ? void 0 : button.mailTemplate);
                        if (button === null || button === void 0 ? void 0 : button.enableModify) {
                            ctx = {
                                entry: data
                            };
                            data = (0,PreviewCode/* parseCode */.zY)(button.modifyCode, ctx, false);
                        }
                        entry = data;
                        if (!(!hasUserTriggers && !hasMailTriggers)) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 11:
                        if (hasUserTriggers) {
                            userToTrigger = button.trigger.users.filter(function(t) {
                                return (t === null || t === void 0 ? void 0 : t.code) && (t === null || t === void 0 ? void 0 : t.userId);
                            }).map(function(trigger) {
                                return {
                                    userId: data === null || data === void 0 ? void 0 : data[trigger.userId],
                                    code: trigger.code
                                };
                            });
                            client/* default.query */.ZP.query({
                                query: users/* FILTER_USERS */.LW,
                                variables: {
                                    filter: {
                                        OR: Array.isArray(userToTrigger) ? userToTrigger === null || userToTrigger === void 0 ? void 0 : userToTrigger.map(function(t) {
                                            return {
                                                _id: t === null || t === void 0 ? void 0 : t.userId
                                            };
                                        }) : null
                                    }
                                }
                            }).then(function(param) {
                                var _$data = param.data;
                                if (!(_$data === null || _$data === void 0 ? void 0 : _$data.userMany)) notify({
                                    type: "error",
                                    content: "No users found"
                                });
                                var users = _$data === null || _$data === void 0 ? void 0 : _$data.userMany;
                                userToTrigger.map(function(trigger) {
                                    var user = users === null || users === void 0 ? void 0 : users.find(function(u) {
                                        return (u === null || u === void 0 ? void 0 : u._id) === (trigger === null || trigger === void 0 ? void 0 : trigger.userId);
                                    });
                                    if (!user) return;
                                    var ctx = {
                                        entry: entry,
                                        user: user
                                    };
                                    var result = (0,PreviewCode/* parseCode */.zY)(trigger === null || trigger === void 0 ? void 0 : trigger.code, ctx, false);
                                    updateUser({
                                        data: result
                                    });
                                    if (trigger.userId === userId) {
                                        notify('You wallet has been updated by your "'.concat((0,Text/* toLowCase */.Cc)(button === null || button === void 0 ? void 0 : button.name), '" response.'), "entry", "success");
                                    } else {
                                        setTimeout(function() {
                                            var ref;
                                            notify("We have updated ".concat(user === null || user === void 0 ? void 0 : (ref = user.author) === null || ref === void 0 ? void 0 : ref.firstName, "'s their wallet also."), "entry", "info");
                                        }, 500);
                                    }
                                });
                                console.log("userMany");
                            // console.log(userToTrigger)
                            }).catch(function(err) {
                                console.log(err);
                                notify("Updating stopped..", "entry", "error");
                                if ((entry === null || entry === void 0 ? void 0 : entry.collectionId) === "6401045f800fef330f4f4c04") {
                                    setErr("user");
                                }
                                setTimeout(function() {
                                    router.reload();
                                }, tenSecondsInMs);
                                return;
                            });
                        }
                        if (hasMailTriggers && button.mailId) {
                        // mailId: button.mailId,
                        //         template: button.mailTemplate,
                        //         entry: convertEntry(data, collection?.schema)
                        // Todo fix this
                        // ? We should implement the async await here
                        // ? Because we can be sure that the mail is send
                        // client.query({ 
                        //     query: MAIL,
                        //     variables: {
                        //         _id: button.mailId
                        //     }
                        // }).then(({data}) => {
                        //     const mail = data?.mailById;
                        //     if(!mail) return;
                        //     console.log('mailById', mail)
                        //     const template = mail?.templates?.find(t => t.template_id === mail?.template);
                        //     setParsingMailData({
                        //         baseRoute: collection?.routing?.baseRoute,
                        //         schema: collection?.schema, 
                        //         template, 
                        //         entry: convertEntry(entry, collection?.schema),
                        //         // ! temp fix to handle over here
                        //         base_mail: mail
                        //     })
                        // }).catch(err => {
                        //     console.log(err)
                        //     notify(`Mail could not be send..`, 'entry', 'error')
                        //     if(entry?.collectionId === '6401045f800fef330f4f4c04') {
                        //         setErr('mail')
                        //     }       
                        //     setTimeout(() => {
                        //         router.reload();
                        //     }, tenSecondsInMs );
                        //     return;
                        // });
                        }
                        setUpdateState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, updateState), {
                            data: data,
                            step: "loading",
                            mail: !hasMailTriggers ? null : {
                                mailId: button.mailId,
                                template: button.mailTemplate,
                                entry: (0,useEntries/* convertEntry */.ec)(data, collection === null || collection === void 0 ? void 0 : collection.schema)
                            }
                        }));
                        updateEntry({
                            data: {
                                _id: data === null || data === void 0 ? void 0 : data._id,
                                record: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,useDataQuery/* convertEntryBack */.Qb)(data, collection === null || collection === void 0 ? void 0 : collection.schema)), {
                                    updatedAt: new Date(),
                                    _id: undefined,
                                    retrieve: undefined
                                })
                            }
                        });
                        setTimeout(function() {
                            router.reload();
                        }, tenSecondsInMs / 2);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataProviders/* FormProvider */.RV, {
                data: {
                    data: methods.watch(),
                    collection: collection,
                    setState: setState,
                    state: state,
                    toggleEditing: toggleEditing,
                    setSubmitButton: setSubmitButton
                },
                children: [
                    children,
                    !submitting && (state === null || state === void 0 ? void 0 : state.button),
                    err || errorUpdatingUser || sendingError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOverlay, {}),
                            err === "mail" || sendingError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MailError, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UserError, {})
                        ]
                    }) : null,
                    c_update_error
                ]
            })
        }))
    });
};
/* harmony default export */ var Form_FormProvider = (FormProvider);

;// CONCATENATED MODULE: ./src/mosanic/builder/Form/Form.js










var Form_useCollection = function(param) {
    var form = param.form;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useApi/* useLazyQuery */.td)("collectionById", collections/* COLLECTION */.du), 2), handler = ref[0], ref1 = (0,_sliced_to_array/* default */.Z)(ref[1], 3), collection = ref1[0], loading = ref1[1], error = ref1[2];
    (0,react.useEffect)(function() {
        if ((form === null || form === void 0 ? void 0 : form.collection) && !error) handler({
            _id: form === null || form === void 0 ? void 0 : form.collection
        });
    }, [
        form === null || form === void 0 ? void 0 : form.collection
    ]);
    return [
        collection,
        loading
    ];
};
var Form = function(param, children) {
    var fields = param.fields, ref = param.ref, editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active, clone = param.clone;
    var ref1, ref2;
    var source = editor.source, handler = editor.handler;
    var ref3 = source || {
        form: null,
        advanced: false,
        login: false,
        verifyEmail: true,
        registerLink: null,
        forwardSlug: null
    }, form = ref3.form, when = ref3.when, advanced = ref3.advanced, login = ref3.login, verifyEmail = ref3.verifyEmail, registerLink = ref3.registerLink, forwardSlug = ref3.forwardSlug, isEditing = ref3.isEditing;
    var handleInput = function(e) {
        return handler({
            value: !isEditing,
            extend: "isEditing"
        });
    };
    var page = (0,PageProviders/* usePageContext */.lO)();
    var page_props = {
        author: page === null || page === void 0 ? void 0 : (ref1 = page.entry) === null || ref1 === void 0 ? void 0 : ref1.userId,
        entryId: page === null || page === void 0 ? void 0 : (ref2 = page.entry) === null || ref2 === void 0 ? void 0 : ref2._id
    };
    var ref4 = (0,_sliced_to_array/* default */.Z)(Form_useCollection({
        form: form
    }), 1), collection = ref4[0];
    return login ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthForm/* AuthForm */.B, {
        verify: verifyEmail
    }) : !advanced ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Entry/* Entry */.k, {
        cols: 1,
        collection: collection,
        type: "create",
        dataType: "form",
        submitTrigger: children,
        page_props: page_props,
        hideMeta: true,
        hideDisabled: true
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_FormProvider, {
        collection: collection,
        when: (when === null || when === void 0 ? void 0 : when.collection) === (form === null || form === void 0 ? void 0 : form.collection) ? when : null,
        children: children
    });
};
/* harmony default export */ var Form_Form = (Form);

;// CONCATENATED MODULE: ./src/mosanic/builder/Form/index.js

/* harmony default export */ var builder_Form = (Form_Form);

// EXTERNAL MODULE: ./src/mosanic/components/User/Profile.js + 2 modules
var Profile = __webpack_require__(29875);
// EXTERNAL MODULE: ./src/mosanic/core/Account/Account.js + 2 modules
var Account = __webpack_require__(89962);
// EXTERNAL MODULE: ./src/mosanic/core/Account/Preferences.js + 1 modules
var Preferences = __webpack_require__(45023);
// EXTERNAL MODULE: ./src/mosanic/core/Account/Security.js + 2 modules
var Security = __webpack_require__(23830);
// EXTERNAL MODULE: ./src/mosanic/items/Control/ControlButtons.js + 1 modules
var ControlButtons = __webpack_require__(11743);
;// CONCATENATED MODULE: ./src/mosanic/builder/Account/Account.js












var groupStyle = {
    margin: "30px 0",
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #eee"
};
var Account_Account = function(param, children) {
    var fields = param.fields, ref = param.ref, editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active, clone = param.clone;
    var ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var source = editor.source, handler = editor.handler;
    var ref5 = source || {
        screen: "account",
        tab: "account"
    }, screen = ref5.screen, tab = ref5.tab;
    var options = ((0,es/* useSelector */.v9)(reducer/* siteSelector */.ar) || {
        options: null
    }).options;
    var setTab = function(tab) {
        return handler({
            value: tab,
            extend: "tab"
        });
    };
    var _loggedInId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var viewingId = router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.slug) === null || ref2 === void 0 ? void 0 : ref2[1];
    var otherUser = viewingId != _loggedInId && viewingId;
    var login = options === null || options === void 0 ? void 0 : (ref3 = options.users) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.content) === null || ref4 === void 0 ? void 0 : ref4.login;
    var isAuth = (0,es/* useSelector */.v9)(reducer/* isAuthSelector */.Kj);
    return isAuth ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !screen && !otherUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlButtons/* ControlTabs */.i, {
                mb: 4,
                setActive: function(t) {
                    return setTab(t);
                },
                active: tab || "account",
                options: "profile|account|preferences|security"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Account_Render, {
                screen: otherUser ? "profile" : !screen || screen === "all" ? tab : screen,
                source: source,
                _id: viewingId
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, groupStyle), {
            textAlign: "center"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthForm/* AuthForm */.B, {
            verify: false,
            accountActions: true,
            content: {
                header: login
            }
        })
    });
//todo --> make 'collection' entries
// ? ----> linked to users
// ? - add option in collection schema
// ? - add correct user id to collection
// todo --> for 'user' management
// ? -> Select what user can create/ edit
// ! : view: wp user roles management
};
var Account_Render = function(param) {
    var screen = param.screen, source = param.source, _id = param._id;
    source = {
        overwrite: source
    };
    if (screen === "profile") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile/* UserProfile */.I, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, source), {
        _id: _id,
        groupStyle: groupStyle
    }));
    if (screen === "security") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Security/* UserSecurity */.U, (0,_object_spread/* default */.Z)({}, source));
    if (screen === "preferences") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Preferences/* UserPreferences */.i, (0,_object_spread/* default */.Z)({}, source));
    if (screen === "account") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Account/* UserAccount */.j, (0,_object_spread/* default */.Z)({}, source));
    return null;
};
/* harmony default export */ var builder_Account_Account = (Account_Account);

;// CONCATENATED MODULE: ./src/mosanic/builder/Account/index.js

/* harmony default export */ var builder_Account = (builder_Account_Account);

// EXTERNAL MODULE: ./src/jsx/Element.js
var Element = __webpack_require__(3679);
;// CONCATENATED MODULE: ./src/mosanic/builder/Heading/Heading.js


// import TextField from "@mosanic/fields/Fields";
var TextField = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 91639));
});

var Heading = function(param, children) {
    var editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active;
    var ref = editor || {
        source: {
            content: null
        },
        handler: null
    }, source = ref.source, handler = ref.handler;
    var handleInput = function(value) {
        if (value) {
            handler({
                value: value,
                extend: "content"
            });
        }
    };
    return active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField, {
        value: source.content,
        onChange: handleInput
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Element/* HeadingTag */.lb, {
        level: (source === null || source === void 0 ? void 0 : source.level) ? source.level : "2",
        children: (source === null || source === void 0 ? void 0 : source.content) ? source.content : !children ? "Heading" : children
    });
};
/* harmony default export */ var Heading_Heading = (Heading);

;// CONCATENATED MODULE: ./src/mosanic/builder/Heading/index.js

/* harmony default export */ var builder_Heading = (Heading_Heading);

// EXTERNAL MODULE: ./src/mosanic/core/Map/Child.js + 10 modules
var Child = __webpack_require__(50547);
// EXTERNAL MODULE: ./src/mosanic/core/Map/Render.js + 4 modules
var Map_Render = __webpack_require__(58829);
;// CONCATENATED MODULE: ./src/mosanic/builder/ImageSlider/Slider.js




var Slider = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3467).then(__webpack_require__.bind(__webpack_require__, 23467));
});
// import Slider from "react-slick";



var ImageSlider = function(param, children) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active, breakpoint = param.breakpoint;
    var ref1;
    var source = editor.source, handler = editor.handler;
    var slidesToShow = source.slidesToShow, slidesToScroll = source.slidesToScroll, devMode = source.devMode, speed = source.speed, dots = source.dots, infinite = source.infinite;
    var ref2 = source || {
        centerMode: false,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false
    }, centerMode = ref2.centerMode, autoplay = ref2.autoplay, autoplaySpeed = ref2.autoplaySpeed, arrows = ref2.arrows;
    var fade = (source === null || source === void 0 ? void 0 : source.fade) ? source.fade : false;
    var getValue = function(val) {
        var fb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        // (hasAttr(val, breakpoint) && !isNumber(val[breakpoint])) ? 
        //     val[breakpoint] : 
        return (val === null || val === void 0 ? void 0 : val.base) ? val.base : val ? val : fb;
    };
    var responsive = (slidesToShow === null || slidesToShow === void 0 ? void 0 : slidesToShow.xs) ? [
        {
            breakpoint: 480,
            settings: {
                slidesToShow: parseFloat(slidesToShow === null || slidesToShow === void 0 ? void 0 : slidesToShow.xs),
                slidesToScroll: parseFloat((slidesToScroll === null || slidesToScroll === void 0 ? void 0 : slidesToScroll.xs) ? slidesToScroll.xs : (slidesToScroll === null || slidesToScroll === void 0 ? void 0 : slidesToScroll.base) ? slidesToScroll.base : 1)
            }
        }
    ] : undefined;
    var settings = {
        dots: dots === 1 ? true : false,
        infinite: infinite === 1 ? true : false,
        autoplaySpeed: parseFloat(getValue(autoplaySpeed, 3500)),
        centerMode: centerMode === 1 ? true : false,
        arrows: arrows === 1 ? true : false,
        speed: speed,
        autoplay: autoplay === 1 ? true : false,
        slidesToShow: parseFloat(getValue(slidesToShow, 1)),
        responsive: responsive,
        slidesToScroll: parseFloat(getValue(slidesToScroll, 1)),
        fade: fade
    };
    var props = children === null || children === void 0 ? void 0 : children.props;
    //Remove slot components
    var slides = props === null || props === void 0 ? void 0 : (ref1 = props.child) === null || ref1 === void 0 ? void 0 : ref1.children.filter(function(child) {
        return !(child === null || child === void 0 ? void 0 : child.manage);
    });
    //Pass props
    var prod = {
        breakpoint: props === null || props === void 0 ? void 0 : props.breakpoint,
        mode: (props === null || props === void 0 ? void 0 : props.mode) ? props.mode : "prod",
        data: props === null || props === void 0 ? void 0 : props.data
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: active || devMode || !slides ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
            children: (slides === null || slides === void 0 ? void 0 : slides.length) >= 1 ? slides.map(function(child, index) {
                var ref;
                /*#__PURE__*/ return (0,react.createElement)(Child/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prod), {
                    key: child === null || child === void 0 ? void 0 : child._id,
                    child: child
                }), (child === null || child === void 0 ? void 0 : (ref = child.children) === null || ref === void 0 ? void 0 : ref.length) >= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Map_Render/* ProdRender */.O, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prod), {
                    child: child
                })) : null);
            }) : null
        }))
    });
};
/* harmony default export */ var ImageSlider_Slider = (ImageSlider);

;// CONCATENATED MODULE: ./src/mosanic/builder/ImageSlider/index.js

/* harmony default export */ var builder_ImageSlider = (ImageSlider_Slider);

// EXTERNAL MODULE: ./src/utils/Arr.js
var Arr = __webpack_require__(72393);
;// CONCATENATED MODULE: ./src/mosanic/builder/Repeater/Repeater.js









var AccommodationsLoader = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7823).then(__webpack_require__.bind(__webpack_require__, 87823));
});





var accommodations = "63359058737d68d97014da2d";
var Repeater = function(param, children) {
    var editor = param.editor;
    var ref;
    var source = editor.source;
    var collection = (source || {
        collection: null
    }).collection;
    var router = (0,next_router.useRouter)();
    var isAccommodations = (collection === null || collection === void 0 ? void 0 : collection.collection) === accommodations && (collection === null || collection === void 0 ? void 0 : collection.source) === "source";
    var _id = (collection === null || collection === void 0 ? void 0 : collection.source) != "provider" ? source === null || source === void 0 ? void 0 : (ref = source.collection) === null || ref === void 0 ? void 0 : ref.collection : null;
    // let [entries, schema, baseRoute] = useDataReceiver({
    //     source: (source?.dynamic) ? 'page' : 
    //         !collection?.source ? 'source' : 
    //         collection?.source, //Temp: transform old inputs.
    //     entry: !isAccommodations ? collection : null, 
    // })
    if (isAccommodations) return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccommodationsLoader, {
        source: source,
        children: children
    });
    else return /*#__PURE__*/ (0,jsx_runtime.jsx)(RepeaterRender, {
        source: source,
        children: children
    });
};
var RepeaterRender = function(param) {
    var data = param.data, source = param.source, children = param.children;
    var ref, ref1;
    var ref2 = (0,react.useState)([]), clones = ref2[0], setClones = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useCollection/* useCollection */.K)({
        _id: source === null || source === void 0 ? void 0 : (ref = source.collection) === null || ref === void 0 ? void 0 : ref.collection,
        singleEntry: false
    }, true), 2), handler = ref3[0], ref4 = (0,_sliced_to_array/* default */.Z)(ref3[1], 3), collection = ref4[0], loading = ref4[1], error = ref4[2];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,DataReceiver/* useDataReceiver */.H)({
        source: source === null || source === void 0 ? void 0 : (ref1 = source.collection) === null || ref1 === void 0 ? void 0 : ref1.source,
        // source: 'source',
        entry: source === null || source === void 0 ? void 0 : source.collection
    }), 4), entries = ref5[0], schema = ref5[1], baseRoute = ref5[2], add = ref5[3];
    // let [collection, loading, error] = useVarQuery('collectionById', COLLECTION, {_id: source?.collection?.collection}) 
    if (!schema) schema = collection === null || collection === void 0 ? void 0 : collection.schema;
    if (!entries || (0,Text/* isString */.HD)(entries === null || entries === void 0 ? void 0 : entries[0])) entries = collection === null || collection === void 0 ? void 0 : collection.entries;
    if (!baseRoute) baseRoute = collection === null || collection === void 0 ? void 0 : collection.baseRoute;
    var _id = schema === null || schema === void 0 ? void 0 : schema._id;
    var breakpoint = "base";
    var cloneCount = (0,Obj/* hasAttr */.B$)(source.clones, breakpoint) ? source.clones[breakpoint] : source.clones.base;
    (0,react.useEffect)(function() {
        var newClones = [];
        var i = 0;
        do {
            newClones.push(i);
            i = i + 1;
        }while (i < cloneCount);
        setClones(newClones);
    }, [
        cloneCount,
        children
    ]);
    var entryCount = entries === null || entries === void 0 ? void 0 : entries.length;
    var count = cloneCount <= entryCount ? cloneCount : entryCount;
    // alert(collection?._id)
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DataProviders/* RepeatProvider */.s4, {
        data: {
            entries: entries,
            schema: schema,
            baseRoute: baseRoute
        },
        children: (0,Arr/* loopFunc */.Jc)(count, function(index) {
            return children ? react.Children.map(children, function(child) {
                return child ? // <InView>
                /*#__PURE__*/ (0,react.cloneElement)(child, {
                    clone: index,
                    collection: _id
                }) : null;
            }) : index;
        })
    });
};
/* harmony default export */ var Repeater_Repeater = (Repeater);

;// CONCATENATED MODULE: ./src/mosanic/builder/Repeater/index.js

/* harmony default export */ var builder_Repeater = (Repeater_Repeater);

// EXTERNAL MODULE: ./src/mosanic/fields/TextArea/index.js + 6 modules
var TextArea = __webpack_require__(71645);
;// CONCATENATED MODULE: ./src/mosanic/builder/Textarea/Textarea.js


var Textarea = function(param) {
    var fields = param.fields, ref = param.ref, editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active;
    var source = editor.source, handler = editor.handler;
    var handleInput = function(value) {
        if (value) {
            handler({
                value: value,
                extend: "content"
            });
        }
    };
    return active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea["default"], {
        value: source === null || source === void 0 ? void 0 : source.content,
        onChange: handleInput
    }) : source === null || source === void 0 ? void 0 : source.content;
};
/* harmony default export */ var Textarea_Textarea = (Textarea);

;// CONCATENATED MODULE: ./src/mosanic/builder/Textarea/index.js

/* harmony default export */ var builder_Textarea = (Textarea_Textarea);

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/mosanic/builder/Menu/Menu.js

function Menu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    color: inherit!important;\n    li {\n        font-size: 13px;\n        display: inline-block;\n        padding: 7px 10px;\n        list-style-type: none;\n    }\n    li, \n    li a {\n        color: inherit!important;\n    }\n"
    ]);
    Menu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-7c9b562f-0"
})(Menu_templateObject());
var Menu = function(param) {
    var fields = param.fields, editor = param.editor, ref = param.ref, active = param.active;
    var ref1;
    var ref2 = editor || {
        source: null,
        handler: null
    }, source = ref2.source, handler = ref2.handler;
    var ctx = (0,PageProviders/* useHeaderContext */.Jv)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (ctx === null || ctx === void 0 ? void 0 : ctx.nav) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
            children: ctx === null || ctx === void 0 ? void 0 : (ref1 = ctx.nav) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/".concat(item.slug),
                        style: {
                            color: "inherit"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: (0,Text/* capitalizeFirst */.Ez)(item === null || item === void 0 ? void 0 : item.header)
                        })
                    })
                }, item === null || item === void 0 ? void 0 : item._id);
            })
        })
    });
};
/* harmony default export */ var Menu_Menu = (Menu);

;// CONCATENATED MODULE: ./src/mosanic/builder/Menu/index.js

/* harmony default export */ var builder_Menu = (Menu_Menu);

// EXTERNAL MODULE: ./src/mosanic/builder/Modal/Modal.js
var Modal = __webpack_require__(10766);
// EXTERNAL MODULE: ./src/mosanic/items/Spinner.js
var Spinner = __webpack_require__(36174);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(45460);
;// CONCATENATED MODULE: ./src/mosanic/builder/Gallery/Masonry.js
/* eslint-disable react/no-string-refs */ 






// Simple Masonry component for images
// Expects props:
//      imageUrls: array of image urls--this overrides any children passed in
//      children: an array of children to render as tiles
//      [required] numCols: number of columns
//      containerWidth: width of mansonry component, default 100%
//      animate: whether or not to animate components fading in, default true
var ImageMasonry = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ImageMasonry, _Component);
    var _super = (0,_create_super/* default */.Z)(ImageMasonry);
    function ImageMasonry(props) {
        (0,_class_call_check/* default */.Z)(this, ImageMasonry);
        var _this;
        _this = _super.call(this, props);
        var state = {};
        for(var i = 0; i < _this.props.numCols; i++){
            state["col-" + i] = [];
        }
        _this.state = state;
        _this.cancel = function() {
            console.log("Cancelation not set yet");
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(ImageMasonry, [
        {
            key: "render",
            value: function render() {
                // Create all of the columns
                var columns = [];
                for(var i = 0; i < this.props.numCols; i++){
                    columns.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: 100 / this.props.numCols + "%",
                            display: "flex",
                            flexDirection: "column",
                            float: "left",
                            cursor: "pointer"
                        },
                        className: "react-image-masonry-col",
                        children: Object.values(this.state["col-" + i])
                    }, "col-" + i));
                }
                var styles = "\n      .react-image-masonry-col * { width: 100%; box-sizing: border-box; }\n      @keyframes fadeIn { from { opacity:0; } to { opacity:1; } }\n    ";
                // Set the container width ( default to 100% )
                var containerWidth = this.props.hasOwnProperty("containerWidth") ? this.props.containerWidth : "100%";
                // Set the container height, if it is scrollable and no height was given, default to 500px
                var containerHeight = this.props.hasOwnProperty("containerHeight") ? this.props.containerHeight : this.props.scrollable ? "500px" : "auto";
                var overflowY = this.props.scrollable ? "scroll" : "hidden";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: "container",
                    style: {
                        width: containerWidth,
                        height: containerHeight,
                        overflowX: "hidden",
                        overflowY: overflowY,
                        margin: "auto"
                    },
                    className: this.props.className,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                            children: styles
                        }),
                        columns
                    ]
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Get tiles based on props
                var tiles = this.getTiles(this.props);
                // Add tiles to state
                this.addTiles(tiles);
            }
        },
        {
            // eslint-disable-next-line react/no-deprecated
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var _this = this;
                try {
                    // If any of these props changed, recalculate the tiles
                    if (nextProps.numCols !== this.props.numCols || !this.areArraysEqual(nextProps.imageUrls, this.props.imageUrls) || (nextProps.children || []).length !== (this.props.children || []).length || !(nextProps.children || []).every(function(child, i) {
                        return nextProps.children[i].key === _this.props.children[i].key;
                    })) {
                        // Reset the state
                        var newState = {};
                        for(var i = 0; i < nextProps.numCols; i++){
                            newState["col-" + i] = [];
                        }
                        this.setState(newState);
                        // Cancel any images that were loading
                        this.cancel();
                        // Get tiles based on props
                        var tiles = this.getTiles(nextProps);
                        // Add tiles to state
                        this.addTiles(tiles);
                    }
                } catch (error) {
                    console.warn(error.message);
                }
            }
        },
        {
            key: "areArraysEqual",
            value: function areArraysEqual(array1, array2) {
                // Note: This only works on scalar arrays
                return array1.length === array2.length && array1.sort().every(function(value, index) {
                    return value === array2.sort()[index];
                });
            }
        },
        {
            // Gets tiles based on the props passed in
            key: "getTiles",
            value: function getTiles(props) {
                var handle = this.props.hasOwnProperty("handle") ? this.props.handle : null;
                var tiles = [];
                if (props.imageUrls) {
                    // If imageUrls is defined, generate img tags
                    tiles = props.imageUrls.map(function(imageUrl, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            onClick: function() {
                                return handle(index);
                            },
                            src: imageUrl,
                            alt: imageUrl,
                            style: {
                                border: "2px solid transparent",
                                boxSizing: "border-box"
                            }
                        }, "img-" + index + Date.now());
                    });
                } else if (props.children) {
                    // Otherwise use the children components
                    tiles = props.children;
                } else {
                    // imageUrls or children must be passed in
                    console.warn("No images were passed into react-image-masonry");
                }
                return tiles;
            }
        },
        {
            // Expects react Element
            // Returns an array of all the image urls
            key: "getAllImageUrls",
            value: function getAllImageUrls(reactEl) {
                var _this = this;
                if (!reactEl) {
                    return [];
                }
                // If the element is an image, return the src
                if (reactEl.type === "img") {
                    return [
                        reactEl.props.src
                    ];
                }
                // Otherwise, if the element has children, get the imageUrls from them
                var children = reactEl.props ? reactEl.props.children : false;
                if (children) {
                    var imageUrls = [];
                    react.Children.forEach(children, function(child) {
                        imageUrls = imageUrls.concat(_this.getAllImageUrls(child));
                    });
                    return imageUrls;
                }
                // There were no images
                return [];
            }
        },
        {
            // Expects an array of imageUrls
            // Returns a promise that resolves when all of the images are loaded
            key: "loadImages",
            value: function loadImages(imageUrls) {
                var _this = this;
                var imagesLoaded = [];
                imageUrls.forEach(function(src) {
                    imagesLoaded.push(new Promise(function(resolve, reject) {
                        var image = new Image();
                        image.onload = resolve;
                        image.onerror = reject;
                        image.src = src;
                        _this.cancel = function() {
                            image.src = "";
                        };
                    }));
                });
                return Promise.all(imagesLoaded);
            }
        },
        {
            // Returns the index of the shortest column
            key: "getShortestCol",
            value: function getShortestCol(containerEl) {
                var cols = containerEl.querySelectorAll(".react-image-masonry-col");
                // Get the shortestColumn
                var shortestCol = 0;
                cols.forEach(function(column, index) {
                    if (column.offsetHeight < cols[shortestCol].offsetHeight) {
                        shortestCol = index;
                    }
                });
                return shortestCol;
            }
        },
        {
            // Adds the given tiles to the state
            key: "addTiles",
            value: function addTiles(tiles) {
                var _this = this;
                // For each tileComponent, get all of the images and load them
                tiles.forEach(function(tile, index) {
                    if (!tile) {
                        return;
                    }
                    var style = {};
                    // If animation is turned on add the style (on by default)
                    var animate = _this.props.hasOwnProperty("animate") ? _this.props.animate : true;
                    if (animate) {
                        style.animation = "fadeIn 1s ease-in";
                    }
                    // If forceOrder is turned on maintain the order of the tiles
                    if (_this.props.forceOrder) {
                        style.order = index;
                    }
                    // Copy over any styles that were set on the tile
                    if (tile && tile.props && tile.props.style) {
                        style = Object.assign({}, tile.props.style, style);
                    }
                    tile = /*#__PURE__*/ react.cloneElement(tile, {
                        style: style
                    });
                    // Once all of the images have been loaded, then add the tile to the shortest column
                    var imageUrls = _this.getAllImageUrls(tile);
                    _this.loadImages(imageUrls).then(function() {
                        var containerEl = _this.refs.container;
                        if (!containerEl) {
                            return;
                        }
                        var shortestCol = _this.getShortestCol(containerEl);
                        // Add the element to the column
                        _this.setState((0,_define_property/* default */.Z)({}, "col-" + shortestCol, _this.state["col-" + shortestCol].concat([
                            tile
                        ])));
                    }).catch(function(error) {
                        console.error(error);
                    });
                });
            }
        }
    ]);
    return ImageMasonry;
}(react.Component);
/* harmony default export */ var Masonry = (ImageMasonry);

;// CONCATENATED MODULE: ./src/mosanic/builder/Gallery/Gallery.js











var ImgsViewer = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 26689));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26689)
            ];
        }
    }
});
var buttonPosition = {
    position: "absolute",
    bototm: 5,
    right: 5,
    zIndex: 3
};
var metricCheck = function(val) {
    return (0,Text/* matchSubstrList */.OV)(val, "px|px|vh|vw|%".split("|")) ? val : val + "px";
};
var Gallery = function(param, children) {
    var editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active, breakpoint = param.breakpoint;
    var ref = editor || {
        source: {
            content: null
        },
        handler: null
    }, source = ref.source, handler = ref.handler;
    var parsed = true;
    var getValue = function(val) {
        var fb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return (0,Obj/* hasAttr */.B$)(val, breakpoint) ? val[breakpoint] : (val === null || val === void 0 ? void 0 : val.base) ? val.base : val ? val : fb;
    };
    var data = (0,DataProviders/* useDataProvider */.x5)();
    var imageSource = source === null || source === void 0 ? void 0 : source.images;
    var images = null, full_source = [], min_source = [];
    if (Array.isArray(data)) {
        imageSource = data;
        //Get from provider
        full_source = imageSource === null || imageSource === void 0 ? void 0 : imageSource.map(function(img) {
            return (0,utils_Image/* parseImageSrc */.yO)((0,utils_Image/* isExternalImageSrc */.vl)(img) ? img : img === null || img === void 0 ? void 0 : img.url, true);
        });
    } else {
        full_source = imageSource === null || imageSource === void 0 ? void 0 : imageSource.map(function(img) {
            return (0,utils_Image/* parseImageSrc */.yO)(img === null || img === void 0 ? void 0 : img.url, true);
        });
    }
    images = full_source === null || full_source === void 0 ? void 0 : full_source.map(function(img) {
        return {
            src: img === null || img === void 0 ? void 0 : img.full
        };
    });
    min_source = full_source === null || full_source === void 0 ? void 0 : full_source.map(function(img) {
        return (img === null || img === void 0 ? void 0 : img.min) ? img === null || img === void 0 ? void 0 : img.min : img === null || img === void 0 ? void 0 : img.full;
    });
    var ref1 = (0,react.useState)(), index = ref1[0], setIndex = ref1[1];
    if (!images) return null;
    // return JSON.stringify(imageSource)    
    // if(!source?.images) return null;
    var ref2 = source || {
        cols: 3,
        width: null,
        height: null,
        animate: false,
        scrollable: false
    }, cols = ref2.cols, width = ref2.width, height = ref2.height, animate = ref2.animate, scrollable = ref2.scrollable;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (images === null || images === void 0 ? void 0 : images.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgsViewer, {
                imgs: images,
                spinner: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {});
                },
                currImg: index,
                isOpen: (0,value/* isClone */.vu)(index),
                onClickPrev: function() {
                    return setIndex(index - 1);
                },
                onClickNext: function() {
                    return setIndex(index + 1);
                },
                onClose: function() {
                    return setIndex(null);
                },
                backdropCloseable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Masonry, {
                handle: function(i) {
                    return setIndex(i);
                },
                numCols: getValue(cols),
                animate: animate,
                scrollable: getValue(scrollable, true) === 1 ? true : false,
                containerWidth: width ? metricCheck(getValue(width)) : null,
                containerHeight: height ? metricCheck(getValue(height)) : null,
                imageUrls: min_source
            })
        ]
    });
};
/* harmony default export */ var Gallery_Gallery = (Gallery);

;// CONCATENATED MODULE: ./src/mosanic/builder/Gallery/index.js

/* harmony default export */ var builder_Gallery = (Gallery_Gallery);

;// CONCATENATED MODULE: ./src/mosanic/builder/SocialGrid/index.js


var InstagramFeed = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9759).then(__webpack_require__.bind(__webpack_require__, 79759));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79759)
            ];
        }
    },
    ssr: false
});
var defaultValue = {
    show: 6,
    tokenKey: "IGQVJVa2pjM3pCbU9seENnaUQ0XzJRWXp2c0FYZAXA3b1RlbWlyYmpqMmJia0VTSzJvMEdjWkJkeXNnSWNON2ZAhT2tDeUNhS2xrenNfVHJwRFhKdF9COWdmd1dGT0xpRkZAyejJ3R3ZAlU0x4NEI3eDM3MgZDZD"
};
var SocialGrid = function(param) {
    var editor = param.editor, active = param.active;
    var source = (editor || {
        source: defaultValue
    }).source;
    var token = (source === null || source === void 0 ? void 0 : source.tokenKey) || (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.tokenKey);
    return (token === null || token === void 0 ? void 0 : token.length) >= 9 && !active && (0,Text/* isString */.HD)(token) ? null : "";
};
{}/* harmony default export */ var builder_SocialGrid = (SocialGrid); // IGQVJXaWxyVFUxUnNBWFlMemNnQkFDRDVQMjdfc1hVdkVldFp4bjlPXzZAFR0xiZATNzWGo0WkZA6Si15S2JwLXNoMzFCMGhzV1B3TVRfY0plZAGVBYWZAiYTE1cFozdndBMW85bmpOTXNsM2tDT1M5ZAWk1QQZDZD

;// CONCATENATED MODULE: ./src/mosanic/builder/Form/Input.js
// const useCollection = ({form}) => {
//     let [handler, [collection, loading, error]]  = useLazyQuery(
//         'collectionById', 
//         COLLECTION
//     );
//     useEffect(() => {
//         if(form?.collection && !error) handler({_id: form?.collection})
//     },[form?.collection])
//     return [collection, loading]
// }

var Input_Input = function(param, children) {
    var fields = param.fields, ref = param.ref, editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active, clone = param.clone;
    // const {source} = editor;
    // const {form, advanced} = source || {form: null, advanced: false};
    // let [collection] = useCollection({form})
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            JSON.stringify({
                editor: editor
            }),
            "input"
        ]
    });
};
/* harmony default export */ var Form_Input = (Input_Input);

// EXTERNAL MODULE: ./src/utils/Funct.js
var Funct = __webpack_require__(3847);
// EXTERNAL MODULE: ./src/mosanic/auth/Register.js + 1 modules
var Register = __webpack_require__(64201);
// EXTERNAL MODULE: ./src/mosanic/auth/Reset.js + 2 modules
var Reset = __webpack_require__(90690);
;// CONCATENATED MODULE: ./src/mosanic/builder/Account/Auth.js








var Auth_groupStyle = {
    margin: "30px 0",
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #eee"
};
var AuthComponent = function(param, children) {
    var fields = param.fields, ref = param.ref, editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active, clone = param.clone;
    var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var router = (0,next_router.useRouter)();
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetSite */.iu)({
        _id: siteId
    }), 1), site = ref12[0];
    var source = editor.source, handler = editor.handler;
    var paths = "register|login|reset".split("|").includes(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.slug) === null || ref2 === void 0 ? void 0 : ref2[0]);
    var step = paths ? router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.slug[0] : source === null || source === void 0 ? void 0 : source.type;
    var siteConfig = site === null || site === void 0 ? void 0 : (ref4 = site.options) === null || ref4 === void 0 ? void 0 : ref4.users;
    var ref13 = (siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.content) || {
        platformName: "Mosanic",
        login: null,
        register: null
    }, platformName = ref13.platformName, register = ref13.register, login = ref13.login;
    var resetMail = site === null || site === void 0 ? void 0 : (ref5 = site.options) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.users) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.mails) === null || ref7 === void 0 ? void 0 : ref7.accountReset;
    var loginMail = site === null || site === void 0 ? void 0 : (ref8 = site.options) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.users) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.mails) === null || ref10 === void 0 ? void 0 : ref10.loginCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: step === "login" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthForm/* AuthForm */.B, {
            verify: false,
            accountActions: true,
            onlyForm: true,
            content: {
                platformName: platformName,
                header: login,
                mail: loginMail
            },
            redirect: "/account"
        }) : step === "register" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Register/* default */.Z, {
            accountActions: true,
            onlyForm: true,
            content: {
                platformName: platformName,
                header: register
            }
        }) : step === "reset" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Reset/* default */.Z, {
            accountActions: true,
            onlyForm: true,
            content: {
                mail: resetMail
            },
            resetCode: router === null || router === void 0 ? void 0 : (ref11 = router.query) === null || ref11 === void 0 ? void 0 : ref11.resetCode,
            redirect: "/account"
        }) : null
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./src/mosanic/components/Users/UserCard.js
var UserCard = __webpack_require__(69325);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Popper.js + 4 modules
var Popper = __webpack_require__(28932);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/items/List/List.js + 2 modules
var List = __webpack_require__(62035);
// EXTERNAL MODULE: ./src/features/auth/action.js
var action = __webpack_require__(13213);
;// CONCATENATED MODULE: ./src/mosanic/builder/Account/User.js











var User_groupStyle = {
    margin: "30px 0",
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #eee"
};
var UserComponent = function(param, children) {
    var fields = param.fields, ref = param.ref, editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active, clone = param.clone;
    var ref1, ref2;
    var router = (0,next_router.useRouter)();
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetSite */.iu)({
        _id: siteId
    }), 1), site = ref3[0];
    var userId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetUser */.pg)({
        _id: userId
    }), 1), user = ref4[0];
    var isAuth = (0,es/* useSelector */.v9)(reducer/* isAuthSelector */.Kj);
    var placement = undefined;
    var dispatch = (0,es/* useDispatch */.I0)();
    var removeAuth = function() {
        return dispatch((0,action/* removeAuthAction */.Mc)({
            redirect: "/login"
        }, "Component logout"));
    };
    // const paths = 'register|login|reset'.split('|').includes(router?.query?.slug?.[0])
    var loggedIn = [
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.ZP, {
            href: "/login",
            onClick: removeAuth,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    width: "22",
                    height: "22",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M22.829 9.172 18.95 5.293a1 1 0 0 0-1.414 1.414l3.879 3.879a2.057 2.057 0 0 1 .3.39c-.015 0-.027-.008-.042-.008L5.989 11a1 1 0 0 0 0 2l15.678-.032c.028 0 .051-.014.078-.016a2 2 0 0 1-.334.462l-3.879 3.879a1 1 0 1 0 1.414 1.414l3.879-3.879a4 4 0 0 0 0-5.656Z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M7 22H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h2a1 1 0 0 0 0-2H5a5.006 5.006 0 0 0-5 5v14a5.006 5.006 0 0 0 5 5h2a1 1 0 0 0 0-2Z"
                        })
                    ]
                }),
                "Logout"
            ]
        }, "logout"),
        {
            href: "/account",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                id: "Outline",
                viewBox: "0 0 24 24",
                width: "22",
                height: "22",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7,0H4A4,4,0,0,0,0,4V7a4,4,0,0,0,4,4H7a4,4,0,0,0,4-4V4A4,4,0,0,0,7,0ZM9,7A2,2,0,0,1,7,9H4A2,2,0,0,1,2,7V4A2,2,0,0,1,4,2H7A2,2,0,0,1,9,4Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20,0H17a4,4,0,0,0-4,4V7a4,4,0,0,0,4,4h3a4,4,0,0,0,4-4V4A4,4,0,0,0,20,0Zm2,7a2,2,0,0,1-2,2H17a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7,13H4a4,4,0,0,0-4,4v3a4,4,0,0,0,4,4H7a4,4,0,0,0,4-4V17A4,4,0,0,0,7,13Zm2,7a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2H7a2,2,0,0,1,2,2Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20,13H17a4,4,0,0,0-4,4v3a4,4,0,0,0,4,4h3a4,4,0,0,0,4-4V17A4,4,0,0,0,20,13Zm2,7a2,2,0,0,1-2,2H17a2,2,0,0,1-2-2V17a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
                    })
                ]
            }),
            label: "Dashboard"
        }
    ];
    var loggedOut = [
        {
            href: "/login",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                width: "22",
                height: "22",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M17 0H7a5.006 5.006 0 0 0-5 5v15a4 4 0 0 0 4 4h11a5.006 5.006 0 0 0 5-5V5a5.006 5.006 0 0 0-5-5Zm3 5v11H8V2h9a3 3 0 0 1 3 3ZM6 2.172V16a3.98 3.98 0 0 0-2 .537V5a3 3 0 0 1 2-2.828ZM17 22H6a2 2 0 0 1 0-4h14v1a3 3 0 0 1-3 3Z"
                })
            }),
            label: "Login"
        }
    ];
    var siteConfig = site === null || site === void 0 ? void 0 : (ref1 = site.options) === null || ref1 === void 0 ? void 0 : ref1.users;
    // const {
    //     platformName,
    //     register,
    //     login
    // } = siteConfig?.content || {
    //     platformName: 'Mosanic', 
    //     login: null, 
    //     register: null
    // };
    var accountItems = (0,_to_consumable_array/* default */.Z)(isAuth ? loggedIn : loggedOut);
    var ref5 = user || {
        firstName: "",
        lastName: ""
    }, firstName = ref5.firstName, lastName = ref5.lastName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popper/* default */.Z, {
            width: "175px",
            p: 2,
            placement: placement,
            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCard/* default */.Z, {
                width: "100%",
                height: "100%",
                mr: 0,
                user: !placement ? {
                    firstName: firstName,
                    lastName: lastName,
                    profilePicture: user === null || user === void 0 ? void 0 : (ref2 = user.author) === null || ref2 === void 0 ? void 0 : ref2.profilePicture
                } : {
                    firstName: firstName,
                    lastName: ""
                }
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                    as: "h3",
                    pl: 2,
                    span: true,
                    helpText: "We're working on amazing new features right now! Missing something? Submit a feature request.",
                    children: "Account actions"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* RenderList */.wp, {
                    items: accountItems,
                    size: "small"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/utils/api/helpers.ts
var api_helpers = __webpack_require__(62459);
// EXTERNAL MODULE: ./src/mosanic/styles/grid.styles.js
var grid_styles = __webpack_require__(67324);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
;// CONCATENATED MODULE: ./src/mosanic/builder/DataProvider/StripeProvider.js
/* provided dependency */ var process = __webpack_require__(93542);







function StripeProvider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    font-size: 33px;\n"
    ]);
    StripeProvider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StripeProvider_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin-bottom: 8px;\n    font-size: 16px;\n    font-weight: bold;\n    max-width: 120px;\n    word-wrap: normal;\n    max-height: 20px;\n    overflow: hidden;\n\n    span {\n        margin-left: 5px;\n        font-size: 14px;\n        font-weight: 300;\n    }\n"
    ]);
    StripeProvider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StripeProvider_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    text-align: center;\n"
    ]);
    StripeProvider_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function StripeProvider_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        transition: all ease-in-out 0.3s;\n        width: 150px;\n        background: linear-gradient( 90deg,rgba(62,167,247,1) 0%,rgba(9,132,225,1) 100% );\n        margin-top: 15px;\n        font-size: 14px!important;\n        padding: 10px 15px;\n        border-radius: 20px;\n        border:  none ;\n        color:  #fff ;\n\n        &:hover {\n            background: linear-gradient( 90deg, rgba(9,132,225,1) 0%,rgba(62,167,247,1) 100% );\n        }\n    "
    ]);
    StripeProvider_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function StripeProvider_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        /* background: #eee; */\n        padding: 20px 10px 15px;\n        border-left: 4px solid;\n        border-color: rgba(62,167,247,1);\n        box-shadow: 2px 2px 15px 0 rgba(0,0,0,0.2);\n    "
    ]);
    StripeProvider_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    transition: all ease-in-out 0.3s;\n    border-top: 1px solid #eee; \n    border-bottom: 1px solid transparent; \n    padding: 20px 5px 15px;\n    display: flex;\n    justify-content: space-between;\n    align-content: center;\n\n    ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

















var combineProductPrices = function(products, prices) {
    return products.data.map(function(product) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
            prices: prices.data.filter(function(price) {
                return price.product === product.id;
            })
        });
    });
};
var useData = function() {
    var stripe_key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : process.env.STRIPE_SECRET_KEY;
    var ref = (0,react.useState)([
        null,
        null
    ]), data = ref[0], setData = ref[1];
    var getProducts = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,api_helpers/* fetchPostJSON */.Gf)("/api/shop/products", {
                        key: stripe_key
                    }).then(function(val) {
                        var products = val.products, prices = val.prices;
                        var data = combineProductPrices(products, prices);
                        setData([
                            data,
                            prices,
                            products
                        ]);
                    }).catch(function(err) {
                        return setData([
                            err
                        ]);
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        stripe_key
    ]);
    (0,react.useEffect)(function() {
        if (stripe_key) getProducts();
    }, [
        getProducts,
        stripe_key
    ]);
    return data;
};
var StripeProvider = function(param, children) {
    var fields = param.fields, ref = param.ref, editor = param.editor, _active = param.active, active = _active === void 0 ? false : _active, clone = param.clone;
    var source = (editor || {
        source: null
    }).source;
    var ref1 = source || {
        entry: null,
        filters: true,
        stripe_key: "sk_live_wPlFpSrxi1qInTthQaSZa4m3"
    }, stripe_key = ref1.stripe_key, filters = ref1.filters;
    var ref2 = (0,react.useState)({
        prices: [],
        products: []
    }), cart = ref2[0], setCart = ref2[1];
    var addProduct = function(param) {
        var product = param.product, price = param.price;
        return setCart({
            prices: (0,_to_consumable_array/* default */.Z)(cart.prices).concat([
                price
            ]),
            products: (0,_to_consumable_array/* default */.Z)(cart === null || cart === void 0 ? void 0 : cart.products).concat([
                product
            ])
        });
    };
    var removeProduct = function(param) {
        var product = param.product, price = param.price;
        var ref, ref1;
        return setCart({
            prices: cart === null || cart === void 0 ? void 0 : (ref = cart.prices) === null || ref === void 0 ? void 0 : ref.filter(function(p) {
                return p != price;
            }),
            products: cart === null || cart === void 0 ? void 0 : (ref1 = cart.products) === null || ref1 === void 0 ? void 0 : ref1.filter(function(p) {
                return p != product;
            })
        });
    };
    var providedData = (0,DataProviders/* useDataProvider */.x5)();
    var ref3 = (0,_sliced_to_array/* default */.Z)(useData(stripe_key), 3), products = ref3[0], prices = ref3[1], data = ref3[2];
    // const field = hasAttr(current, entry?.field) ? current[entry.field] : null;
    // if(toLowCase(entry?.field) === 'gallery' ) console.log({content, contentRender})
    // if((Array.isArray(content) && content?.[0]?.url?.url) ) console.log("NOT RENDINGER?")
    // const content = 
    //         field ? field : 
    //         current ? current : 
    //         entries ? entries :
    //         null
    // console.log({content, wrapperContent, content, entry: entry?.field} )
    // return JSON.stringify({wrapperContent, contentRender, content})
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DataProviders/* DataProvider */.FW, {
        data: (0,_object_spread/* default */.Z)({
            stripe: {
                products: products,
                prices: prices,
                info: data
            }
        }, providedData),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataProviders/* CartProvider */.Zl, {
            data: {
                cart: cart,
                addProduct: addProduct,
                removeProduct: removeProduct,
                key: stripe_key ? stripe_key : null
            },
            children: [
                children,
                stripe_key === "sk_live_wPlFpSrxi1qInTthQaSZa4m3" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderProducts, {
                    products: products
                })
            ]
        })
    });
// return content ? (
//     <>
//     {contentRender}
//     </>
// ) : (
//     <DataContext.Provider value={wrapperContent}>
//         {children}
//     </DataContext.Provider>
// );
};
var getPrice = function(product) {
    if (!(product === null || product === void 0 ? void 0 : product.prices)) return null;
    if (!(product === null || product === void 0 ? void 0 : product.default_price)) {
        var ref;
        return product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref[0];
    } else {
        var ref1;
        return (ref1 = product.prices) === null || ref1 === void 0 ? void 0 : ref1.find(function(p) {
            return p.id === product.default_price;
        });
    }
};
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-f7b70d90-0"
})(StripeProvider_templateObject());
var Price = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-f7b70d90-1"
})(StripeProvider_templateObject1());
var Product = (0,styled_components_browser_esm/* default */.ZP)(grid_styles/* Col */.JX).withConfig({
    componentId: "sc-f7b70d90-2"
})(StripeProvider_templateObject2());
var getRecurringLabel = function(recurring) {
    if ((recurring === null || recurring === void 0 ? void 0 : recurring.interval) === "year") return "yearly";
    if ((recurring === null || recurring === void 0 ? void 0 : recurring.interval_count) === 3 && (recurring === null || recurring === void 0 ? void 0 : recurring.interval) === "month") return "quarterly";
    if ((recurring === null || recurring === void 0 ? void 0 : recurring.interval) === "month") return "monthly";
    return "";
};
var RenderProducts = function(param) {
    var products = param.products;
    var ref;
    var ref1 = (0,DataProviders/* useCartProvider */.yL)(), addProduct = ref1.addProduct, removeProduct = ref1.removeProduct, cart = ref1.cart, key = ref1.key;
    var router = (0,next_router.useRouter)();
    var notify = (0,useNotify/* default */.Z)();
    var userId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetUser */.pg)({
        _id: userId
    }), 1), user = ref2[0];
    var handleCheckout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var items, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (user === null || user === void 0 ? void 0 : user.email) {
                            _ctx.next = 4;
                            break;
                        }
                        console.log("no login found");
                        notify("Please login before checkout.", "checkout", "error");
                        return _ctx.abrupt("return", null);
                    case 4:
                        if (products) {
                            _ctx.next = 7;
                            break;
                        }
                        console.log(" no products found ");
                        return _ctx.abrupt("return");
                    case 7:
                        items = products === null || products === void 0 ? void 0 : products.filter(function(product) {
                            return cart.products.includes(product.id);
                        }).map(function(i) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, i), {
                                price_data: i.prices.find(function(p) {
                                    return cart.prices.includes(p.id);
                                })
                            });
                        });
                        if (items) {
                            _ctx.next = 12;
                            break;
                        }
                        console.log("no cart");
                        notify("No products in cart.", "checkout", "error");
                        return _ctx.abrupt("return", null);
                    case 12:
                        _ctx.next = 14;
                        return (0,api_helpers/* fetchPostJSON */.Gf)("/api/checkout/cart", {
                            items: items,
                            user: user,
                            inventory: products,
                            returnTo: router === null || router === void 0 ? void 0 : router.asPath,
                            key: key
                        });
                    case 14:
                        response = _ctx.sent;
                        if (!(response.statusCode > 399)) {
                            _ctx.next = 20;
                            break;
                        }
                        console.error(response.message);
                        return _ctx.abrupt("return");
                    case 20:
                        {
                            router.push(response.url);
                        // alert('push:'+response.url)
                        }
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCheckout(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var PrimaryButton = (0,styled_components_browser_esm/* default */.ZP)(Buttons.Button).withConfig({
        componentId: "sc-f7b70d90-3"
    })(StripeProvider_templateObject3());
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_styles/* Wrap */.Eq, {
        children: Array.isArray(products) && ((ref = [
            products === null || products === void 0 ? void 0 : products[0]
        ]) === null || ref === void 0 ? void 0 : ref.map(function(product) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                size: "md",
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Product, {
                    width: 1,
                    children: [
                        (product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref[0]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: product === null || product === void 0 ? void 0 : (ref1 = product.images) === null || ref1 === void 0 ? void 0 : ref1[0],
                            width: "100%",
                            height: "auto"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: product === null || product === void 0 ? void 0 : product.name
                        }),
                        (product === null || product === void 0 ? void 0 : product.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: product === null || product === void 0 ? void 0 : product.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                            children: [
                                (ref3 = product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : ref2.filter(function(price) {
                                    return price.active;
                                })) === null || ref3 === void 0 ? void 0 : ref3.length,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "plan options"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            label: "View options",
                            style: {
                                background: "linear-gradient( 90deg,rgba(62,167,247,1) 0%,rgba(9,132,225,1) 100% )",
                                fontSize: "14px!important",
                                padding: "8px 10px",
                                marginTop: 5,
                                borderRadius: 18,
                                border: "none",
                                width: "100%",
                                color: "#fff"
                            }
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid_styles/* Wrap */.Eq, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid_styles/* Col */.JX, {
                            width: [
                                1,
                                1 / 2
                            ],
                            pr: [
                                0,
                                4
                            ],
                            children: [
                                (product === null || product === void 0 ? void 0 : (ref4 = product.images) === null || ref4 === void 0 ? void 0 : ref4[0]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: product === null || product === void 0 ? void 0 : (ref5 = product.images) === null || ref5 === void 0 ? void 0 : ref5[0],
                                    width: "100%",
                                    height: "auto"
                                }),
                                (product === null || product === void 0 ? void 0 : product.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: product === null || product === void 0 ? void 0 : product.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid_styles/* Col */.JX, {
                            width: [
                                1,
                                1 / 2
                            ],
                            pl: [
                                0,
                                4
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: ((ref7 = product === null || product === void 0 ? void 0 : (ref6 = product.prices) === null || ref6 === void 0 ? void 0 : ref6.filter(function(price) {
                                        return price.active;
                                    })) === null || ref7 === void 0 ? void 0 : ref7.length) >= 2 ? "Price options" : "Pricing"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "All plans last at least one year, give full access to the platform and give 6 credits."
                                }),
                                (ref9 = product === null || product === void 0 ? void 0 : (ref8 = product.prices) === null || ref8 === void 0 ? void 0 : ref8.filter(function(price) {
                                    return price.active;
                                })) === null || ref9 === void 0 ? void 0 : ref9.map(function(price) {
                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(PriceOption, {
                                        active: cart === null || cart === void 0 ? void 0 : (ref = cart.prices) === null || ref === void 0 ? void 0 : ref.includes(price.id),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Price, {
                                                children: [
                                                    "€",
                                                    (price === null || price === void 0 ? void 0 : price.unit_amount) / 100,
                                                    (price === null || price === void 0 ? void 0 : price.recurring) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "/".concat((price === null || price === void 0 ? void 0 : (ref1 = price.recurring) === null || ref1 === void 0 ? void 0 : ref1.interval_count) >= 2 ? price === null || price === void 0 ? void 0 : (ref2 = price.recurring) === null || ref2 === void 0 ? void 0 : ref2.interval_count : "", " ").concat(price === null || price === void 0 ? void 0 : (ref3 = price.recurring) === null || ref3 === void 0 ? void 0 : ref3.interval).concat((price === null || price === void 0 ? void 0 : (ref4 = price.recurring) === null || ref4 === void 0 ? void 0 : ref4.interval_count) >= 2 ? "s" : "")
                                                    })
                                                ]
                                            }),
                                            !(cart === null || cart === void 0 ? void 0 : (ref5 = cart.products) === null || ref5 === void 0 ? void 0 : ref5.includes(product.id)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Button, {
                                                onClick: function() {
                                                    return addProduct({
                                                        product: product.id,
                                                        price: price.id
                                                    });
                                                },
                                                small: true,
                                                ml: "auto",
                                                style: {
                                                    width: "150px",
                                                    background: (price === null || price === void 0 ? void 0 : price.id) === (product === null || product === void 0 ? void 0 : product.default_price) ? "linear-gradient( 90deg,rgba(62,167,247,1) 0%,rgba(9,132,225,1) 100% )" : "transparent",
                                                    marginTop: "-5px",
                                                    fontSize: "14px!important",
                                                    padding: "8px 10px",
                                                    borderRadius: 18,
                                                    border: (price === null || price === void 0 ? void 0 : price.id) === (product === null || product === void 0 ? void 0 : product.default_price) ? "none" : "1px solid #212121",
                                                    color: (price === null || price === void 0 ? void 0 : price.id) === (product === null || product === void 0 ? void 0 : product.default_price) ? "#fff" : "#212121"
                                                },
                                                children: [
                                                    "Start ",
                                                    (price === null || price === void 0 ? void 0 : price.recurring) && getRecurringLabel(price === null || price === void 0 ? void 0 : price.recurring),
                                                    " plan ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                ]
                                            }, price.id),
                                            (cart === null || cart === void 0 ? void 0 : (ref6 = cart.prices) === null || ref6 === void 0 ? void 0 : ref6.includes(price.id)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TrashIcon */.XHJ, {}),
                                                ml: 0,
                                                onClick: function(e) {
                                                    return removeProduct({
                                                        product: product.id,
                                                        price: price.id
                                                    });
                                                }
                                            })
                                        ]
                                    });
                                }),
                                (cart === null || cart === void 0 ? void 0 : (ref10 = cart.products) === null || ref10 === void 0 ? void 0 : ref10.includes(product.id)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton, {
                                    // onClick={() => addProduct({product: product.id, price: price.id})}
                                    small: true,
                                    ml: "auto",
                                    onClick: function(e) {
                                        return handleCheckout(e);
                                    },
                                    children: "Checkout →"
                                })
                            ]
                        })
                    ]
                })
            }, product.id);
        }))
    });
};
var PriceOption = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f7b70d90-4"
})(_templateObject5(), function(props) {
    return props.active && (0,styled_components_browser_esm/* css */.iv)(StripeProvider_templateObject4());
});
/* harmony default export */ var DataProvider_StripeProvider = (StripeProvider);

;// CONCATENATED MODULE: ./src/mosanic/builder/registery.js
































// const DialogRender = Dialog;
//  341
// export const registery = {
//     menu: Menu,
//     tab: Tab,
//     gallery: Gallery,
//     dialog: Dialog,
//     expander: Expander,
//     expanders: Expanders,
//     expanderheader: ExpanderHeader,
//     dataprovider: DataProvider,
//     form: Form,
//     button: dynamic(() => import("./Button")),
//     icon: dynamic(() => import("./Icn")),
//     code: dynamic(() => import("./Code")),
//     script: dynamic(() => import("./Script")),
//     image: dynamic(() => import("./Image")),
//     text: dynamic(() => import("./Text")),
//     localizedtext: dynamic(() => import("./Text")),
//     video: dynamic(() => import("./Video")),
//     tabs: dynamic(() => import("./Tabs")),
//     tabheader: TabHeader,
//     datalink: dynamic(() => import("./DataLink")),
//     content: dynamic(() => import("./Textarea")),
//     heading: dynamic(() => import("./Heading")),
//     repeater: dynamic(() => import("./Repeater")),
//     imageslider: dynamic(() => import("./ImageSlider")),
// }
var base = {
    content: builder_Textarea,
    menu: builder_Menu,
    heading: builder_Heading,
    localizedtext: builder_Text,
    text: builder_Text,
    button: builder_Button,
    image: builder_Image,
    video: builder_Video,
    icon: Icn,
    code: builder_Code,
    script: builder_Script,
    tab: Tab,
    tabs: builder_Tabs,
    tabheader: TabHeader,
    gallery: builder_Gallery,
    dialog: function(_param, children) {
        var props = (0,_extends/* default */.Z)({}, _param);
        return (0,Modal/* Modal */.u)((0,_object_spread/* default */.Z)({}, props), children);
    }
};
var registery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
    expander: Expander,
    expanders: builder_Expanders,
    expanderheader: ExpanderHeader,
    repeater: builder_Repeater,
    datalink: builder_DataLink,
    dataprovider: builder_DataProvider,
    stripeprovider: DataProvider_StripeProvider,
    form: builder_Form,
    account: builder_Account,
    auth: AuthComponent,
    user: UserComponent,
    inputfield: Form_Input,
    googlemap: Map/* default */.Z,
    imageslider: builder_ImageSlider,
    socialgrid: builder_SocialGrid
});
var renderComponent = function(type) {
    type = (0,Text/* toLowCase */.Cc)(type);
    // const render = getItemSchema(type)?.render
    return (0,Obj/* hasAttr */.B$)(registery, type) ? registery[type] : null;
    return !render || !(0,Funct/* isFunc */.W)(render) ? null : render;
};
/* harmony default export */ var builder_registery = (renderComponent);


/***/ }),

/***/ 15121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ DataGrid_DataGrid; },
  "f": function() { return /* binding */ FilterContext; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/cms/Pagination/Pagination.js + 1 modules
var Pagination = __webpack_require__(40010);
// EXTERNAL MODULE: ./src/mosanic/i18n/useLocale.js
var useLocale = __webpack_require__(38576);
// EXTERNAL MODULE: ./src/mosanic/items/Spinner.js
var Spinner = __webpack_require__(36174);
// EXTERNAL MODULE: ./src/mosanic/styles/flex.styles.js
var flex_styles = __webpack_require__(5441);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
;// CONCATENATED MODULE: ../../node_modules/react-data-grid/lib/bundle.js




function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$f = ".c1wupbe700-beta15{background-color:inherit;border-block-end:1px solid var(--rdg-border-color);border-inline-end:1px solid var(--rdg-border-color);contain:size style;grid-row-start:var(--rdg-grid-row-start);outline:none;overflow:hidden;overflow:clip;padding-block:0;padding-inline:8px;position:relative;text-overflow:ellipsis;white-space:nowrap}.c1wupbe700-beta15[aria-selected=true]{outline:2px solid var(--rdg-selection-color);outline-offset:-2px}.cd0kgiy700-beta15 .c1wupbe700-beta15{contain:content}.c1730fa4700-beta15{position:sticky;z-index:1}.c9dpaye700-beta15{box-shadow:calc(2px*var(--rdg-sign)) 0 5px -2px hsla(0,0%,53%,.3)}";
styleInject(css_248z$f,{"insertAt":"top"});

const cell = "c1wupbe700-beta15";
const cellClassname = `rdg-cell ${cell}`;
const cellAutoResizeClassname = "cd0kgiy700-beta15";
const cellFrozen = "c1730fa4700-beta15";
const cellFrozenClassname = `rdg-cell-frozen ${cellFrozen}`;
const cellFrozenLast = "c9dpaye700-beta15";
const cellFrozenLastClassname = `rdg-cell-frozen-last ${cellFrozenLast}`;

var css_248z$e = ".r104f42s700-beta15{--rdg-color:#000;--rdg-border-color:#ddd;--rdg-summary-border-color:#aaa;--rdg-background-color:#fff;--rdg-header-background-color:#f9f9f9;--rdg-row-hover-background-color:#f5f5f5;--rdg-row-selected-background-color:#dbecfa;--row-selected-hover-background-color:#c9e3f8;--rdg-checkbox-color:#005194;--rdg-checkbox-focus-color:#61b8ff;--rdg-checkbox-disabled-border-color:#ccc;--rdg-checkbox-disabled-background-color:#ddd;--rdg-selection-color:#66afe9;--rdg-font-size:14px;background-color:var(--rdg-background-color);block-size:350px;border:1px solid var(--rdg-border-color);box-sizing:border-box;color:var(--rdg-color);color-scheme:var(--rdg-color-scheme,light dark);contain:strict;contain:size layout style paint;content-visibility:auto;display:grid;font-size:var(--rdg-font-size);overflow:auto;user-select:none}@supports not (contain:strict){.r104f42s700-beta15{position:relative;z-index:0}}.r104f42s700-beta15 *,.r104f42s700-beta15 :after,.r104f42s700-beta15 :before{box-sizing:inherit}.r104f42s700-beta15:before{content:\"\";grid-column:1/-1;grid-row:1/-1}.r104f42s700-beta15.rdg-dark{--rdg-color-scheme:dark;--rdg-color:#ddd;--rdg-border-color:#444;--rdg-summary-border-color:#555;--rdg-background-color:#212121;--rdg-header-background-color:#1b1b1b;--rdg-row-hover-background-color:#171717;--rdg-row-selected-background-color:#1a73bc;--row-selected-hover-background-color:#1768ab;--rdg-checkbox-color:#94cfff;--rdg-checkbox-focus-color:#c7e6ff;--rdg-checkbox-disabled-border-color:#000;--rdg-checkbox-disabled-background-color:#333}.r104f42s700-beta15.rdg-light{--rdg-color-scheme:light}@media (prefers-color-scheme:dark){.r104f42s700-beta15:not(.rdg-light){--rdg-color:#ddd;--rdg-border-color:#444;--rdg-summary-border-color:#555;--rdg-background-color:#212121;--rdg-header-background-color:#1b1b1b;--rdg-row-hover-background-color:#171717;--rdg-row-selected-background-color:#1a73bc;--row-selected-hover-background-color:#1768ab;--rdg-checkbox-color:#94cfff;--rdg-checkbox-focus-color:#c7e6ff;--rdg-checkbox-disabled-border-color:#000;--rdg-checkbox-disabled-background-color:#333}}.v7ly7s700-beta15.r1otpg64700-beta15{cursor:move}.fc4f4zb700-beta15{grid-column:1/-1;pointer-events:none;z-index:4}";
styleInject(css_248z$e,{"insertAt":"top"});

const root = "r104f42s700-beta15";
const rootClassname = `rdg ${root}`;
const viewportDragging = "v7ly7s700-beta15";
const viewportDraggingClassname = `rdg-viewport-dragging ${viewportDragging}`;
const focusSinkClassname = "fc4f4zb700-beta15";

var css_248z$d = ".r1otpg64700-beta15{background-color:var(--rdg-background-color);display:contents;line-height:var(--rdg-row-height)}.r1otpg64700-beta15:hover{background-color:var(--rdg-row-hover-background-color)}.r1otpg64700-beta15[aria-selected=true]{background-color:var(--rdg-row-selected-background-color)}.r1otpg64700-beta15[aria-selected=true]:hover{background-color:var(--row-selected-hover-background-color)}.rel5gk2700-beta15{outline:2px solid var(--rdg-selection-color);outline-offset:-2px}.r1qymf1z700-beta15:before{border-inline-start:2px solid var(--rdg-selection-color);content:\"\";display:inline-block;height:100%;inset-inline-start:0;position:sticky}";
styleInject(css_248z$d,{"insertAt":"top"});

const row = "r1otpg64700-beta15";
const rowClassname = `rdg-row ${row}`;
const rowSelected = "rel5gk2700-beta15";
const rowSelectedClassname = `rdg-row-selected`;
const rowSelectedWithFrozenCell = "r1qymf1z700-beta15";

var css_248z$c = ".c8rwwhf700-beta15{align-items:center;cursor:pointer;display:flex;inset:0;justify-content:center;margin-inline-end:1px;position:absolute}.c1rb4brs700-beta15{all:unset}.c1bvvwcc700-beta15{background-color:var(--rdg-background-color);block-size:20px;border:2px solid var(--rdg-border-color);content:\"\";inline-size:20px}.c1rb4brs700-beta15:checked+.c1bvvwcc700-beta15{background-color:var(--rdg-checkbox-color);outline:4px solid var(--rdg-background-color);outline-offset:-6px}.c1rb4brs700-beta15:focus+.c1bvvwcc700-beta15{border-color:var(--rdg-checkbox-focus-color)}.c1yg790j700-beta15{cursor:default}.c1yg790j700-beta15 .c1bvvwcc700-beta15{background-color:var(--rdg-checkbox-disabled-background-color);border-color:var(--rdg-checkbox-disabled-border-color)}";
styleInject(css_248z$c,{"insertAt":"top"});

const checkboxLabel = "c8rwwhf700-beta15";
const checkboxLabelClassname = `rdg-checkbox-label ${checkboxLabel}`;
const checkboxInput = "c1rb4brs700-beta15";
const checkboxInputClassname = `rdg-checkbox-input ${checkboxInput}`;
const bundle_checkbox = "c1bvvwcc700-beta15";
const checkboxClassname = `rdg-checkbox ${bundle_checkbox}`;
const checkboxLabelDisabled = "c1yg790j700-beta15";
const checkboxLabelDisabledClassname = `rdg-checkbox-label-disabled ${checkboxLabelDisabled}`;
function checkboxFormatter({
  onChange,
  ...props
}, ref) {
  function handleChange(e) {
    onChange(e.target.checked, e.nativeEvent.shiftKey);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
    className: (0,clsx_m["default"])(checkboxLabelClassname, props.disabled && checkboxLabelDisabledClassname),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      type: "checkbox",
      ref: ref,
      ...props,
      className: checkboxInputClassname,
      onChange: handleChange
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: checkboxClassname
    })]
  });
}

const useLayoutEffect = typeof window === 'undefined' ? react.useEffect : react.useLayoutEffect;

function useFocusRef(isSelected) {
  const ref = (0,react.useRef)(null);
  useLayoutEffect(() => {
    if (!isSelected) return;
    ref.current?.focus({
      preventScroll: true
    });
  }, [isSelected]);
  return {
    ref,
    tabIndex: isSelected ? 0 : -1
  };
}

const DataGridDefaultComponentsContext = /*#__PURE__*/(0,react.createContext)(undefined);
const DataGridDefaultComponentsProvider = DataGridDefaultComponentsContext.Provider;
function useDefaultComponents() {
  return (0,react.useContext)(DataGridDefaultComponentsContext);
}

function SelectCellFormatter({
  value,
  isCellSelected,
  disabled,
  onChange,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy
}) {
  const {
    ref,
    tabIndex
  } = useFocusRef(isCellSelected);
  const checkboxFormatter = useDefaultComponents().checkboxFormatter;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: checkboxFormatter({
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      tabIndex,
      disabled,
      checked: value,
      onChange
    }, ref)
  });
}

function valueFormatter(props) {
  try {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: props.row[props.column.key]
    });
  } catch {
    return null;
  }
}

var css_248z$b = ".gb8l2vs700-beta15{outline:none}.c1ggynjl700-beta15{stroke:currentColor;stroke-width:1.5px;fill:transparent;margin-inline-start:4px;vertical-align:middle}.c1ggynjl700-beta15>path{transition:d .1s}";
styleInject(css_248z$b,{"insertAt":"top"});

const groupCellContent = "gb8l2vs700-beta15";
const groupCellContentClassname = `rdg-group-cell-content ${groupCellContent}`;
const caret = "c1ggynjl700-beta15";
const caretClassname = `rdg-caret ${caret}`;
function toggleGroupFormatter(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ToggleGroup, { ...props
  });
}
function ToggleGroup({
  groupKey,
  isExpanded,
  isCellSelected,
  toggleGroup
}) {
  const {
    ref,
    tabIndex
  } = useFocusRef(isCellSelected);

  function handleKeyDown({
    key
  }) {
    if (key === 'Enter') {
      toggleGroup();
    }
  }

  const d = isExpanded ? 'M1 1 L 7 7 L 13 1' : 'M1 7 L 7 1 L 13 7';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    ref: ref,
    className: groupCellContentClassname,
    tabIndex: tabIndex,
    onKeyDown: handleKeyDown,
    children: [groupKey, /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
      viewBox: "0 0 14 8",
      width: "14",
      height: "8",
      className: caretClassname,
      "aria-hidden": true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: d
      })
    })]
  });
}

const RowSelectionContext = /*#__PURE__*/(0,react.createContext)(undefined);
const RowSelectionProvider = RowSelectionContext.Provider;
const RowSelectionChangeContext = /*#__PURE__*/(0,react.createContext)(undefined);
const RowSelectionChangeProvider = RowSelectionChangeContext.Provider;
function useRowSelection() {
  const rowSelectionContext = (0,react.useContext)(RowSelectionContext);
  const rowSelectionChangeContext = (0,react.useContext)(RowSelectionChangeContext);

  if (rowSelectionContext === undefined || rowSelectionChangeContext === undefined) {
    throw new Error('useRowSelection must be used within DataGrid cells');
  }

  return [rowSelectionContext, rowSelectionChangeContext];
}

const SELECT_COLUMN_KEY = 'select-row';

function SelectFormatter(props) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCellFormatter, {
    "aria-label": "Select",
    isCellSelected: props.isCellSelected,
    value: isRowSelected,
    onChange: (checked, isShiftClick) => {
      onRowSelectionChange({
        row: props.row,
        checked,
        isShiftClick
      });
    }
  });
}

function SelectGroupFormatter(props) {
  const [isRowSelected, onRowSelectionChange] = useRowSelection();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCellFormatter, {
    "aria-label": "Select Group",
    isCellSelected: props.isCellSelected,
    value: isRowSelected,
    onChange: checked => {
      onRowSelectionChange({
        row: props.row,
        checked,
        isShiftClick: false
      });
    }
  });
}

const SelectColumn = {
  key: SELECT_COLUMN_KEY,
  name: '',
  width: 35,
  minWidth: 35,
  maxWidth: 35,
  resizable: false,
  sortable: false,
  frozen: true,

  headerRenderer(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectCellFormatter, {
      "aria-label": "Select All",
      isCellSelected: props.isCellSelected,
      value: props.allRowsSelected,
      onChange: props.onAllRowsSelectionChange
    });
  },

  formatter(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectFormatter, { ...props
    });
  },

  groupFormatter(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectGroupFormatter, { ...props
    });
  }

};

function getColSpan(column, lastFrozenColumnIndex, args) {
  const colSpan = typeof column.colSpan === 'function' ? column.colSpan(args) : 1;

  if (Number.isInteger(colSpan) && colSpan > 1 && (!column.frozen || column.idx + colSpan - 1 <= lastFrozenColumnIndex)) {
    return colSpan;
  }

  return undefined;
}

function scrollIntoView(element) {
  element?.scrollIntoView({
    inline: 'nearest',
    block: 'nearest'
  });
}

const nonInputKeys = new Set(['Unidentified', 'Alt', 'AltGraph', 'CapsLock', 'Control', 'Fn', 'FnLock', 'Meta', 'NumLock', 'ScrollLock', 'Shift', 'Tab', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'End', 'Home', 'PageDown', 'PageUp', 'Insert', 'ContextMenu', 'Escape', 'Pause', 'Play', 'PrintScreen', 'F1', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12']);
function isCtrlKeyHeldDown(e) {
  return (e.ctrlKey || e.metaKey) && e.key !== 'Control';
}
function isDefaultCellInput(event) {
  return !nonInputKeys.has(event.key);
}
function onEditorNavigation({
  key,
  target
}) {
  if (key === 'Tab' && (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement)) {
    return target.matches('.rdg-editor-container > :only-child, .rdg-editor-container > label:only-child > :only-child');
  }

  return false;
}

function isSelectedCellEditable({
  selectedPosition,
  columns,
  rows,
  isGroupRow
}) {
  const column = columns[selectedPosition.idx];
  const row = rows[selectedPosition.rowIdx];
  return !isGroupRow(row) && isCellEditable(column, row);
}
function isCellEditable(column, row) {
  return column.editor != null && !column.rowGroup && (typeof column.editable === 'function' ? column.editable(row) : column.editable) !== false;
}
function getSelectedCellColSpan({
  rows,
  summaryRows,
  rowIdx,
  lastFrozenColumnIndex,
  column,
  isGroupRow
}) {
  if (rowIdx === -1) {
    return getColSpan(column, lastFrozenColumnIndex, {
      type: 'HEADER'
    });
  }

  if (rowIdx >= 0 && rowIdx < rows.length) {
    const row = rows[rowIdx];

    if (!isGroupRow(row)) {
      return getColSpan(column, lastFrozenColumnIndex, {
        type: 'ROW',
        row
      });
    }

    return undefined;
  }

  if (summaryRows) {
    return getColSpan(column, lastFrozenColumnIndex, {
      type: 'SUMMARY',
      row: summaryRows[rowIdx - rows.length]
    });
  }

  return undefined;
}
function getNextSelectedCellPosition({
  cellNavigationMode,
  columns,
  colSpanColumns,
  rows,
  summaryRows,
  minRowIdx,
  maxRowIdx,
  currentPosition: {
    idx: currentIdx
  },
  nextPosition,
  lastFrozenColumnIndex,
  isCellWithinBounds,
  isGroupRow
}) {
  let {
    idx: nextIdx,
    rowIdx: nextRowIdx
  } = nextPosition;

  const setColSpan = moveRight => {
    if (nextRowIdx >= 0 && nextRowIdx < rows.length) {
      const row = rows[nextRowIdx];
      if (isGroupRow(row)) return;
    }

    for (const column of colSpanColumns) {
      const colIdx = column.idx;
      if (colIdx > nextIdx) break;
      const colSpan = getSelectedCellColSpan({
        rows,
        summaryRows,
        rowIdx: nextRowIdx,
        lastFrozenColumnIndex,
        column,
        isGroupRow
      });

      if (colSpan && nextIdx > colIdx && nextIdx < colSpan + colIdx) {
        nextIdx = colIdx + (moveRight ? colSpan : 0);
        break;
      }
    }
  };

  if (isCellWithinBounds(nextPosition)) {
    setColSpan(nextIdx - currentIdx > 0);
  }

  if (cellNavigationMode !== 'NONE') {
    const columnsCount = columns.length;
    const isAfterLastColumn = nextIdx === columnsCount;
    const isBeforeFirstColumn = nextIdx === -1;

    if (isAfterLastColumn) {
      if (cellNavigationMode === 'CHANGE_ROW') {
        const isLastRow = nextRowIdx === maxRowIdx;

        if (!isLastRow) {
          nextIdx = 0;
          nextRowIdx += 1;
        }
      } else {
        nextIdx = 0;
      }
    } else if (isBeforeFirstColumn) {
      if (cellNavigationMode === 'CHANGE_ROW') {
        const isFirstRow = nextRowIdx === minRowIdx;

        if (!isFirstRow) {
          nextRowIdx -= 1;
          nextIdx = columnsCount - 1;
        }
      } else {
        nextIdx = columnsCount - 1;
      }

      setColSpan(false);
    }
  }

  return {
    idx: nextIdx,
    rowIdx: nextRowIdx
  };
}
function canExitGrid({
  cellNavigationMode,
  maxColIdx,
  minRowIdx,
  maxRowIdx,
  selectedPosition: {
    rowIdx,
    idx
  },
  shiftKey
}) {
  if (cellNavigationMode === 'NONE' || cellNavigationMode === 'CHANGE_ROW') {
    const atLastCellInRow = idx === maxColIdx;
    const atFirstCellInRow = idx === 0;
    const atLastRow = rowIdx === maxRowIdx;
    const atFirstRow = rowIdx === minRowIdx;
    return shiftKey ? atFirstCellInRow && atFirstRow : atLastCellInRow && atLastRow;
  }

  return false;
}

function getRowStyle(rowIdx, height) {
  if (height !== undefined) {
    return {
      '--rdg-grid-row-start': rowIdx,
      '--rdg-row-height': `${height}px`
    };
  }

  return {
    '--rdg-grid-row-start': rowIdx
  };
}
function getCellStyle(column, colSpan) {
  return {
    gridColumnStart: column.idx + 1,
    gridColumnEnd: colSpan !== undefined ? `span ${colSpan}` : undefined,
    insetInlineStart: column.frozen ? `var(--rdg-frozen-left-${column.idx})` : undefined
  };
}
function getCellClassname(column, ...extraClasses) {
  return (0,clsx_m["default"])(cellClassname, ...extraClasses, column.frozen && cellFrozenClassname, column.isLastFrozenColumn && cellFrozenLastClassname);
}

const {
  min,
  max,
  round,
  floor,
  sign,
  abs,
  ceil
} = Math;
function assertIsValidKeyGetter(keyGetter) {
  if (typeof keyGetter !== 'function') {
    throw new Error('Please specify the rowKeyGetter prop to use selection');
  }
}
function clampColumnWidth(width, {
  minWidth,
  maxWidth
}) {
  width = max(width, minWidth);

  if (typeof maxWidth === 'number' && maxWidth >= minWidth) {
    return min(width, maxWidth);
  }

  return width;
}

function useCalculatedColumns({
  rawColumns,
  columnWidths,
  viewportWidth,
  scrollLeft,
  defaultColumnOptions,
  rawGroupBy,
  enableVirtualization
}) {
  const defaultWidth = defaultColumnOptions?.width;
  const defaultMinWidth = defaultColumnOptions?.minWidth ?? 80;
  const defaultMaxWidth = defaultColumnOptions?.maxWidth;
  const defaultFormatter = defaultColumnOptions?.formatter ?? valueFormatter;
  const defaultSortable = defaultColumnOptions?.sortable ?? false;
  const defaultResizable = defaultColumnOptions?.resizable ?? false;
  const {
    columns,
    colSpanColumns,
    lastFrozenColumnIndex,
    groupBy
  } = (0,react.useMemo)(() => {
    const groupBy = [];
    let lastFrozenColumnIndex = -1;
    const columns = rawColumns.map(rawColumn => {
      const rowGroup = rawGroupBy?.includes(rawColumn.key) ?? false;
      const frozen = rowGroup || rawColumn.frozen || false;
      const column = { ...rawColumn,
        idx: 0,
        frozen,
        isLastFrozenColumn: false,
        rowGroup,
        width: rawColumn.width ?? defaultWidth,
        minWidth: rawColumn.minWidth ?? defaultMinWidth,
        maxWidth: rawColumn.maxWidth ?? defaultMaxWidth,
        sortable: rawColumn.sortable ?? defaultSortable,
        resizable: rawColumn.resizable ?? defaultResizable,
        formatter: rawColumn.formatter ?? defaultFormatter
      };

      if (rowGroup) {
        column.groupFormatter ?? (column.groupFormatter = toggleGroupFormatter);
      }

      if (frozen) {
        lastFrozenColumnIndex++;
      }

      return column;
    });
    columns.sort(({
      key: aKey,
      frozen: frozenA
    }, {
      key: bKey,
      frozen: frozenB
    }) => {
      if (aKey === SELECT_COLUMN_KEY) return -1;
      if (bKey === SELECT_COLUMN_KEY) return 1;

      if (rawGroupBy?.includes(aKey)) {
        if (rawGroupBy.includes(bKey)) {
          return rawGroupBy.indexOf(aKey) - rawGroupBy.indexOf(bKey);
        }

        return -1;
      }

      if (rawGroupBy?.includes(bKey)) return 1;

      if (frozenA) {
        if (frozenB) return 0;
        return -1;
      }

      if (frozenB) return 1;
      return 0;
    });
    const colSpanColumns = [];
    columns.forEach((column, idx) => {
      column.idx = idx;

      if (column.rowGroup) {
        groupBy.push(column.key);
      }

      if (column.colSpan != null) {
        colSpanColumns.push(column);
      }
    });

    if (lastFrozenColumnIndex !== -1) {
      columns[lastFrozenColumnIndex].isLastFrozenColumn = true;
    }

    return {
      columns,
      colSpanColumns,
      lastFrozenColumnIndex,
      groupBy
    };
  }, [rawColumns, defaultWidth, defaultMinWidth, defaultMaxWidth, defaultFormatter, defaultResizable, defaultSortable, rawGroupBy]);
  const {
    layoutCssVars,
    totalFrozenColumnWidth,
    columnMetrics
  } = (0,react.useMemo)(() => {
    const columnMetrics = new Map();
    let left = 0;
    let totalFrozenColumnWidth = 0;
    let templateColumns = '';
    let allocatedWidth = 0;
    let unassignedColumnsCount = 0;

    for (const column of columns) {
      let width = getSpecifiedWidth(column, columnWidths, viewportWidth);

      if (width === undefined) {
        unassignedColumnsCount++;
      } else {
        width = clampColumnWidth(width, column);
        allocatedWidth += width;
        columnMetrics.set(column, {
          width,
          left: 0
        });
      }
    }

    for (const column of columns) {
      let width;

      if (columnMetrics.has(column)) {
        const columnMetric = columnMetrics.get(column);
        columnMetric.left = left;
        ({
          width
        } = columnMetric);
      } else {
        const unallocatedWidth = viewportWidth - allocatedWidth;
        const unallocatedColumnWidth = round(unallocatedWidth / unassignedColumnsCount);
        width = clampColumnWidth(unallocatedColumnWidth, column);
        allocatedWidth += width;
        unassignedColumnsCount--;
        columnMetrics.set(column, {
          width,
          left
        });
      }

      left += width;
      templateColumns += `${width}px `;
    }

    if (lastFrozenColumnIndex !== -1) {
      const columnMetric = columnMetrics.get(columns[lastFrozenColumnIndex]);
      totalFrozenColumnWidth = columnMetric.left + columnMetric.width;
    }

    const layoutCssVars = {
      gridTemplateColumns: templateColumns
    };

    for (let i = 0; i <= lastFrozenColumnIndex; i++) {
      const column = columns[i];
      layoutCssVars[`--rdg-frozen-left-${column.idx}`] = `${columnMetrics.get(column).left}px`;
    }

    return {
      layoutCssVars,
      totalFrozenColumnWidth,
      columnMetrics
    };
  }, [columnWidths, columns, viewportWidth, lastFrozenColumnIndex]);
  const [colOverscanStartIdx, colOverscanEndIdx] = (0,react.useMemo)(() => {
    if (!enableVirtualization) {
      return [0, columns.length - 1];
    }

    const viewportLeft = scrollLeft + totalFrozenColumnWidth;
    const viewportRight = scrollLeft + viewportWidth;
    const lastColIdx = columns.length - 1;
    const firstUnfrozenColumnIdx = min(lastFrozenColumnIndex + 1, lastColIdx);

    if (viewportLeft >= viewportRight) {
      return [firstUnfrozenColumnIdx, firstUnfrozenColumnIdx];
    }

    let colVisibleStartIdx = firstUnfrozenColumnIdx;

    while (colVisibleStartIdx < lastColIdx) {
      const {
        left,
        width
      } = columnMetrics.get(columns[colVisibleStartIdx]);

      if (left + width > viewportLeft) {
        break;
      }

      colVisibleStartIdx++;
    }

    let colVisibleEndIdx = colVisibleStartIdx;

    while (colVisibleEndIdx < lastColIdx) {
      const {
        left,
        width
      } = columnMetrics.get(columns[colVisibleEndIdx]);

      if (left + width >= viewportRight) {
        break;
      }

      colVisibleEndIdx++;
    }

    const colOverscanStartIdx = max(firstUnfrozenColumnIdx, colVisibleStartIdx - 1);
    const colOverscanEndIdx = min(lastColIdx, colVisibleEndIdx + 1);
    return [colOverscanStartIdx, colOverscanEndIdx];
  }, [columnMetrics, columns, lastFrozenColumnIndex, scrollLeft, totalFrozenColumnWidth, viewportWidth, enableVirtualization]);
  return {
    columns,
    colSpanColumns,
    colOverscanStartIdx,
    colOverscanEndIdx,
    layoutCssVars,
    columnMetrics,
    lastFrozenColumnIndex,
    totalFrozenColumnWidth,
    groupBy
  };
}

function getSpecifiedWidth({
  key,
  width
}, columnWidths, viewportWidth) {
  if (columnWidths.has(key)) {
    return columnWidths.get(key);
  }

  if (typeof width === 'number') {
    return width;
  }

  if (typeof width === 'string' && /^\d+%$/.test(width)) {
    return floor(viewportWidth * parseInt(width, 10) / 100);
  }

  return undefined;
}

function useGridDimensions() {
  const gridRef = (0,react.useRef)(null);
  const [inlineSize, setInlineSize] = (0,react.useState)(1);
  const [blockSize, setBlockSize] = (0,react.useState)(1);
  useLayoutEffect(() => {
    const {
      ResizeObserver
    } = window;
    if (ResizeObserver == null) return;
    const {
      clientWidth,
      clientHeight,
      offsetWidth,
      offsetHeight
    } = gridRef.current;
    const {
      width,
      height
    } = gridRef.current.getBoundingClientRect();
    const initialWidth = width - offsetWidth + clientWidth;
    const initialHeight = height - offsetHeight + clientHeight;
    setInlineSize(handleDevicePixelRatio(initialWidth));
    setBlockSize(initialHeight);
    const resizeObserver = new ResizeObserver(entries => {
      const size = entries[0].contentBoxSize[0];
      setInlineSize(handleDevicePixelRatio(size.inlineSize));
      setBlockSize(size.blockSize);
    });
    resizeObserver.observe(gridRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  return [gridRef, inlineSize, blockSize];
}

function handleDevicePixelRatio(size) {
  return size - (devicePixelRatio === 1 ? 0 : ceil(devicePixelRatio));
}

function useLatestFunc(fn) {
  const ref = (0,react.useRef)(fn);
  (0,react.useEffect)(() => {
    ref.current = fn;
  });
  return (0,react.useCallback)((...args) => {
    ref.current(...args);
  }, []);
}

function useRovingCellRef(isSelected) {
  const [isChildFocused, setIsChildFocused] = (0,react.useState)(false);

  if (isChildFocused && !isSelected) {
    setIsChildFocused(false);
  }

  const ref = (0,react.useCallback)(cell => {
    if (cell === null) return;
    scrollIntoView(cell);
    if (cell.contains(document.activeElement)) return;
    cell.focus({
      preventScroll: true
    });
  }, []);

  function onFocus(event) {
    if (event.target !== event.currentTarget) {
      setIsChildFocused(true);
    }
  }

  const isFocused = isSelected && !isChildFocused;
  return {
    ref: isSelected ? ref : undefined,
    tabIndex: isFocused ? 0 : -1,
    onFocus: isSelected ? onFocus : undefined
  };
}

function useViewportColumns({
  columns,
  colSpanColumns,
  rows,
  summaryRows,
  colOverscanStartIdx,
  colOverscanEndIdx,
  lastFrozenColumnIndex,
  rowOverscanStartIdx,
  rowOverscanEndIdx,
  isGroupRow
}) {
  const startIdx = (0,react.useMemo)(() => {
    if (colOverscanStartIdx === 0) return 0;
    let startIdx = colOverscanStartIdx;

    const updateStartIdx = (colIdx, colSpan) => {
      if (colSpan !== undefined && colIdx + colSpan > colOverscanStartIdx) {
        startIdx = colIdx;
        return true;
      }

      return false;
    };

    for (const column of colSpanColumns) {
      const colIdx = column.idx;
      if (colIdx >= startIdx) break;

      if (updateStartIdx(colIdx, getColSpan(column, lastFrozenColumnIndex, {
        type: 'HEADER'
      }))) {
        break;
      }

      for (let rowIdx = rowOverscanStartIdx; rowIdx <= rowOverscanEndIdx; rowIdx++) {
        const row = rows[rowIdx];
        if (isGroupRow(row)) continue;

        if (updateStartIdx(colIdx, getColSpan(column, lastFrozenColumnIndex, {
          type: 'ROW',
          row
        }))) {
          break;
        }
      }

      if (summaryRows != null) {
        for (const row of summaryRows) {
          if (updateStartIdx(colIdx, getColSpan(column, lastFrozenColumnIndex, {
            type: 'SUMMARY',
            row
          }))) {
            break;
          }
        }
      }
    }

    return startIdx;
  }, [rowOverscanStartIdx, rowOverscanEndIdx, rows, summaryRows, colOverscanStartIdx, lastFrozenColumnIndex, colSpanColumns, isGroupRow]);
  return (0,react.useMemo)(() => {
    const viewportColumns = [];

    for (let colIdx = 0; colIdx <= colOverscanEndIdx; colIdx++) {
      const column = columns[colIdx];
      if (colIdx < startIdx && !column.frozen) continue;
      viewportColumns.push(column);
    }

    return viewportColumns;
  }, [startIdx, colOverscanEndIdx, columns]);
}

function isReadonlyArray(arr) {
  return Array.isArray(arr);
}

function useViewportRows({
  rawRows,
  rowHeight,
  clientHeight,
  scrollTop,
  groupBy,
  rowGrouper,
  expandedGroupIds,
  enableVirtualization
}) {
  const [groupedRows, rowsCount] = (0,react.useMemo)(() => {
    if (groupBy.length === 0 || rowGrouper == null) return [undefined, rawRows.length];

    const groupRows = (rows, [groupByKey, ...remainingGroupByKeys], startRowIndex) => {
      let groupRowsCount = 0;
      const groups = {};

      for (const [key, childRows] of Object.entries(rowGrouper(rows, groupByKey))) {
        const [childGroups, childRowsCount] = remainingGroupByKeys.length === 0 ? [childRows, childRows.length] : groupRows(childRows, remainingGroupByKeys, startRowIndex + groupRowsCount + 1);
        groups[key] = {
          childRows,
          childGroups,
          startRowIndex: startRowIndex + groupRowsCount
        };
        groupRowsCount += childRowsCount + 1;
      }

      return [groups, groupRowsCount];
    };

    return groupRows(rawRows, groupBy, 0);
  }, [groupBy, rowGrouper, rawRows]);
  const [rows, isGroupRow] = (0,react.useMemo)(() => {
    const allGroupRows = new Set();
    if (!groupedRows) return [rawRows, isGroupRow];
    const flattenedRows = [];

    const expandGroup = (rows, parentId, level) => {
      if (isReadonlyArray(rows)) {
        flattenedRows.push(...rows);
        return;
      }

      Object.keys(rows).forEach((groupKey, posInSet, keys) => {
        const id = parentId !== undefined ? `${parentId}__${groupKey}` : groupKey;
        const isExpanded = expandedGroupIds?.has(id) ?? false;
        const {
          childRows,
          childGroups,
          startRowIndex
        } = rows[groupKey];
        const groupRow = {
          id,
          parentId,
          groupKey,
          isExpanded,
          childRows,
          level,
          posInSet,
          startRowIndex,
          setSize: keys.length
        };
        flattenedRows.push(groupRow);
        allGroupRows.add(groupRow);

        if (isExpanded) {
          expandGroup(childGroups, id, level + 1);
        }
      });
    };

    expandGroup(groupedRows, undefined, 0);
    return [flattenedRows, isGroupRow];

    function isGroupRow(row) {
      return allGroupRows.has(row);
    }
  }, [expandedGroupIds, groupedRows, rawRows]);
  const {
    totalRowHeight,
    gridTemplateRows,
    getRowTop,
    getRowHeight,
    findRowIdx
  } = (0,react.useMemo)(() => {
    if (typeof rowHeight === 'number') {
      return {
        totalRowHeight: rowHeight * rows.length,
        gridTemplateRows: ` repeat(${rows.length}, ${rowHeight}px)`,
        getRowTop: rowIdx => rowIdx * rowHeight,
        getRowHeight: () => rowHeight,
        findRowIdx: offset => floor(offset / rowHeight)
      };
    }

    let totalRowHeight = 0;
    let gridTemplateRows = ' ';
    const rowPositions = rows.map(row => {
      const currentRowHeight = isGroupRow(row) ? rowHeight({
        type: 'GROUP',
        row
      }) : rowHeight({
        type: 'ROW',
        row
      });
      const position = {
        top: totalRowHeight,
        height: currentRowHeight
      };
      gridTemplateRows += `${currentRowHeight}px `;
      totalRowHeight += currentRowHeight;
      return position;
    });

    const validateRowIdx = rowIdx => {
      return max(0, min(rows.length - 1, rowIdx));
    };

    return {
      totalRowHeight,
      gridTemplateRows,
      getRowTop: rowIdx => rowPositions[validateRowIdx(rowIdx)].top,
      getRowHeight: rowIdx => rowPositions[validateRowIdx(rowIdx)].height,

      findRowIdx(offset) {
        let start = 0;
        let end = rowPositions.length - 1;

        while (start <= end) {
          const middle = start + floor((end - start) / 2);
          const currentOffset = rowPositions[middle].top;
          if (currentOffset === offset) return middle;

          if (currentOffset < offset) {
            start = middle + 1;
          } else if (currentOffset > offset) {
            end = middle - 1;
          }

          if (start > end) return end;
        }

        return 0;
      }

    };
  }, [isGroupRow, rowHeight, rows]);
  let rowOverscanStartIdx = 0;
  let rowOverscanEndIdx = rows.length - 1;

  if (enableVirtualization) {
    const overscanThreshold = 4;
    const rowVisibleStartIdx = findRowIdx(scrollTop);
    const rowVisibleEndIdx = findRowIdx(scrollTop + clientHeight);
    rowOverscanStartIdx = max(0, rowVisibleStartIdx - overscanThreshold);
    rowOverscanEndIdx = min(rows.length - 1, rowVisibleEndIdx + overscanThreshold);
  }

  return {
    rowOverscanStartIdx,
    rowOverscanEndIdx,
    rows,
    rowsCount,
    totalRowHeight,
    gridTemplateRows,
    isGroupRow,
    getRowTop,
    getRowHeight,
    findRowIdx
  };
}

var css_248z$a = ".h1e8ezgp700-beta15{cursor:pointer;display:flex}.h1e8ezgp700-beta15:focus{outline:none}.h1rrblhe700-beta15{flex-grow:1;overflow:hidden;overflow:clip;text-overflow:ellipsis}";
styleInject(css_248z$a,{"insertAt":"top"});

const headerSortCell = "h1e8ezgp700-beta15";
const headerSortCellClassname = `rdg-header-sort-cell ${headerSortCell}`;
const headerSortName = "h1rrblhe700-beta15";
const headerSortNameClassname = `rdg-header-sort-name ${headerSortName}`;
function headerRenderer({
  column,
  sortDirection,
  priority,
  onSort,
  isCellSelected
}) {
  if (!column.sortable) return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: column.name
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SortableHeaderCell, {
    onSort: onSort,
    sortDirection: sortDirection,
    priority: priority,
    isCellSelected: isCellSelected,
    children: column.name
  });
}

function SortableHeaderCell({
  onSort,
  sortDirection,
  priority,
  children,
  isCellSelected
}) {
  const sortIcon = useDefaultComponents().sortIcon;
  const {
    ref,
    tabIndex
  } = useFocusRef(isCellSelected);

  function handleKeyDown(event) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      onSort(event.ctrlKey || event.metaKey);
    }
  }

  function handleClick(event) {
    onSort(event.ctrlKey || event.metaKey);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    ref: ref,
    tabIndex: tabIndex,
    className: headerSortCellClassname,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: headerSortNameClassname,
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      children: [sortIcon({
        sortDirection
      }), priority]
    })]
  });
}

var css_248z$9 = ".celq7o9700-beta15{touch-action:none}.celq7o9700-beta15:after{content:\"\";cursor:col-resize;inline-size:10px;inset-block-end:0;inset-block-start:0;inset-inline-end:0;position:absolute}";
styleInject(css_248z$9,{"insertAt":"top"});

const cellResizable = "celq7o9700-beta15";
const cellResizableClassname = `rdg-cell-resizable ${cellResizable}`;
function HeaderCell({
  column,
  colSpan,
  isCellSelected,
  onColumnResize,
  allRowsSelected,
  onAllRowsSelectionChange,
  sortColumns,
  onSortColumnsChange,
  selectCell,
  shouldFocusGrid,
  direction
}) {
  const isRtl = direction === 'rtl';
  const {
    ref,
    tabIndex,
    onFocus
  } = useRovingCellRef(isCellSelected);
  const sortIndex = sortColumns?.findIndex(sort => sort.columnKey === column.key);
  const sortColumn = sortIndex !== undefined && sortIndex > -1 ? sortColumns[sortIndex] : undefined;
  const sortDirection = sortColumn?.direction;
  const priority = sortColumn !== undefined && sortColumns.length > 1 ? sortIndex + 1 : undefined;
  const ariaSort = sortDirection && !priority ? sortDirection === 'ASC' ? 'ascending' : 'descending' : undefined;
  const className = getCellClassname(column, column.headerCellClass, column.resizable && cellResizableClassname);
  const headerRenderer$1 = column.headerRenderer ?? headerRenderer;

  function onPointerDown(event) {
    if (event.pointerType === 'mouse' && event.buttons !== 1) {
      return;
    }

    const {
      currentTarget,
      pointerId
    } = event;
    const {
      right,
      left
    } = currentTarget.getBoundingClientRect();
    const offset = isRtl ? event.clientX - left : right - event.clientX;

    if (offset > 11) {
      return;
    }

    function onPointerMove(event) {
      const {
        right,
        left
      } = currentTarget.getBoundingClientRect();
      const width = isRtl ? right + offset - event.clientX : event.clientX + offset - left;

      if (width > 0) {
        onColumnResize(column, clampColumnWidth(width, column));
      }
    }

    function onLostPointerCapture() {
      currentTarget.removeEventListener('pointermove', onPointerMove);
      currentTarget.removeEventListener('lostpointercapture', onLostPointerCapture);
    }

    currentTarget.setPointerCapture(pointerId);
    currentTarget.addEventListener('pointermove', onPointerMove);
    currentTarget.addEventListener('lostpointercapture', onLostPointerCapture);
  }

  function onSort(ctrlClick) {
    if (onSortColumnsChange == null) return;
    const {
      sortDescendingFirst
    } = column;

    if (sortColumn === undefined) {
      const nextSort = {
        columnKey: column.key,
        direction: sortDescendingFirst ? 'DESC' : 'ASC'
      };
      onSortColumnsChange(sortColumns && ctrlClick ? [...sortColumns, nextSort] : [nextSort]);
    } else {
      let nextSortColumn;

      if (sortDescendingFirst && sortDirection === 'DESC' || !sortDescendingFirst && sortDirection === 'ASC') {
        nextSortColumn = {
          columnKey: column.key,
          direction: sortDirection === 'ASC' ? 'DESC' : 'ASC'
        };
      }

      if (ctrlClick) {
        const nextSortColumns = [...sortColumns];

        if (nextSortColumn) {
          nextSortColumns[sortIndex] = nextSortColumn;
        } else {
          nextSortColumns.splice(sortIndex, 1);
        }

        onSortColumnsChange(nextSortColumns);
      } else {
        onSortColumnsChange(nextSortColumn ? [nextSortColumn] : []);
      }
    }
  }

  function onClick() {
    selectCell(column.idx);
  }

  function onDoubleClick(event) {
    const {
      right,
      left
    } = event.currentTarget.getBoundingClientRect();
    const offset = isRtl ? event.clientX - left : right - event.clientX;

    if (offset > 11) {
      return;
    }

    onColumnResize(column, 'auto');
  }

  function handleFocus(event) {
    onFocus?.(event);

    if (shouldFocusGrid) {
      selectCell(0);
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "columnheader",
    "aria-colindex": column.idx + 1,
    "aria-selected": isCellSelected,
    "aria-sort": ariaSort,
    "aria-colspan": colSpan,
    ref: ref,
    tabIndex: shouldFocusGrid ? 0 : tabIndex,
    className: className,
    style: { ...getCellStyle(column, colSpan),
      minWidth: column.minWidth,
      maxWidth: column.maxWidth ?? undefined
    },
    onFocus: handleFocus,
    onClick: onClick,
    onDoubleClick: column.resizable ? onDoubleClick : undefined,
    onPointerDown: column.resizable ? onPointerDown : undefined,
    children: headerRenderer$1({
      column,
      sortDirection,
      priority,
      onSort,
      allRowsSelected,
      onAllRowsSelectionChange,
      isCellSelected
    })
  });
}

var css_248z$8 = ".h197vzie700-beta15{background-color:var(--rdg-header-background-color);display:contents;font-weight:700;line-height:var(--rdg-header-row-height)}.h197vzie700-beta15>.c1wupbe700-beta15{inset-block-start:0;position:sticky;z-index:2}.h197vzie700-beta15>.c1730fa4700-beta15{z-index:3}";
styleInject(css_248z$8,{"insertAt":"top"});

const headerRow = "h197vzie700-beta15";
const headerRowClassname = `rdg-header-row ${headerRow}`;

function HeaderRow({
  columns,
  allRowsSelected,
  onAllRowsSelectionChange,
  onColumnResize,
  sortColumns,
  onSortColumnsChange,
  lastFrozenColumnIndex,
  selectedCellIdx,
  selectCell,
  shouldFocusGrid,
  direction
}) {
  const cells = [];

  for (let index = 0; index < columns.length; index++) {
    const column = columns[index];
    const colSpan = getColSpan(column, lastFrozenColumnIndex, {
      type: 'HEADER'
    });

    if (colSpan !== undefined) {
      index += colSpan - 1;
    }

    cells.push( /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderCell, {
      column: column,
      colSpan: colSpan,
      isCellSelected: selectedCellIdx === column.idx,
      onColumnResize: onColumnResize,
      allRowsSelected: allRowsSelected,
      onAllRowsSelectionChange: onAllRowsSelectionChange,
      onSortColumnsChange: onSortColumnsChange,
      sortColumns: sortColumns,
      selectCell: selectCell,
      shouldFocusGrid: shouldFocusGrid && index === 0,
      direction: direction
    }, column.key));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "row",
    "aria-rowindex": 1,
    className: (0,clsx_m["default"])(headerRowClassname, selectedCellIdx === -1 && rowSelectedClassname),
    style: getRowStyle(1),
    children: cells
  });
}

const HeaderRow$1 = /*#__PURE__*/(0,react.memo)(HeaderRow);

var css_248z$7 = ".c1bmg16t700-beta15,.ccpfvsn700-beta15{background-color:#ccf}.c1bmg16t700-beta15.ccpfvsn700-beta15{background-color:#99f}";
styleInject(css_248z$7,{"insertAt":"top"});

const cellCopied = "ccpfvsn700-beta15";
const cellCopiedClassname = `rdg-cell-copied ${cellCopied}`;
const cellDraggedOver = "c1bmg16t700-beta15";
const cellDraggedOverClassname = `rdg-cell-dragged-over ${cellDraggedOver}`;

function Cell({
  column,
  colSpan,
  isCellSelected,
  isCopied,
  isDraggedOver,
  row,
  dragHandle,
  onRowClick,
  onRowDoubleClick,
  onRowChange,
  selectCell,
  ...props
}) {
  const {
    ref,
    tabIndex,
    onFocus
  } = useRovingCellRef(isCellSelected);
  const {
    cellClass
  } = column;
  const className = getCellClassname(column, typeof cellClass === 'function' ? cellClass(row) : cellClass, isCopied && cellCopiedClassname, isDraggedOver && cellDraggedOverClassname);

  function selectCellWrapper(openEditor) {
    selectCell(row, column, openEditor);
  }

  function handleClick() {
    selectCellWrapper(column.editorOptions?.editOnClick);
    onRowClick?.(row, column);
  }

  function handleContextMenu() {
    selectCellWrapper();
  }

  function handleDoubleClick() {
    selectCellWrapper(true);
    onRowDoubleClick?.(row, column);
  }

  function handleRowChange(newRow) {
    onRowChange(column, newRow);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "gridcell",
    "aria-colindex": column.idx + 1,
    "aria-selected": isCellSelected,
    "aria-colspan": colSpan,
    "aria-readonly": !isCellEditable(column, row) || undefined,
    ref: ref,
    tabIndex: tabIndex,
    className: className,
    style: getCellStyle(column, colSpan),
    onClick: handleClick,
    onDoubleClick: handleDoubleClick,
    onContextMenu: handleContextMenu,
    onFocus: onFocus,
    ...props,
    children: !column.rowGroup && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [column.formatter({
        column,
        row,
        isCellSelected,
        onRowChange: handleRowChange
      }), dragHandle]
    })
  });
}

const Cell$1 = /*#__PURE__*/(0,react.memo)(Cell);

function Row({
  className,
  rowIdx,
  gridRowStart,
  height,
  selectedCellIdx,
  isRowSelected,
  copiedCellIdx,
  draggedOverCellIdx,
  lastFrozenColumnIndex,
  row,
  viewportColumns,
  selectedCellEditor,
  selectedCellDragHandle,
  onRowClick,
  onRowDoubleClick,
  rowClass,
  setDraggedOverRowIdx,
  onMouseEnter,
  onRowChange,
  selectCell,
  ...props
}, ref) {
  const handleRowChange = useLatestFunc((column, newRow) => {
    onRowChange(column, rowIdx, newRow);
  });

  function handleDragEnter(event) {
    setDraggedOverRowIdx?.(rowIdx);
    onMouseEnter?.(event);
  }

  className = (0,clsx_m["default"])(rowClassname, `rdg-row-${rowIdx % 2 === 0 ? 'even' : 'odd'}`, rowClass?.(row), className, selectedCellIdx === -1 && rowSelectedClassname);
  const cells = [];

  for (let index = 0; index < viewportColumns.length; index++) {
    const column = viewportColumns[index];
    const {
      idx
    } = column;
    const colSpan = getColSpan(column, lastFrozenColumnIndex, {
      type: 'ROW',
      row
    });

    if (colSpan !== undefined) {
      index += colSpan - 1;
    }

    const isCellSelected = selectedCellIdx === idx;

    if (isCellSelected && selectedCellEditor) {
      cells.push(selectedCellEditor);
    } else {
      cells.push( /*#__PURE__*/(0,jsx_runtime.jsx)(Cell$1, {
        column: column,
        colSpan: colSpan,
        row: row,
        isCopied: copiedCellIdx === idx,
        isDraggedOver: draggedOverCellIdx === idx,
        isCellSelected: isCellSelected,
        dragHandle: isCellSelected ? selectedCellDragHandle : undefined,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowChange: handleRowChange,
        selectCell: selectCell
      }, column.key));
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(RowSelectionProvider, {
    value: isRowSelected,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      role: "row",
      ref: ref,
      className: className,
      onMouseEnter: handleDragEnter,
      style: getRowStyle(gridRowStart, height),
      ...props,
      children: cells
    })
  });
}

const RowComponent = /*#__PURE__*/(0,react.memo)( /*#__PURE__*/(0,react.forwardRef)(Row));
const RowComponent$1 = (/* unused pure expression or super */ null && (RowComponent));
function defaultRowRenderer(key, props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RowComponent, { ...props
  }, key);
}

function GroupCell({
  id,
  groupKey,
  childRows,
  isExpanded,
  isCellSelected,
  column,
  row,
  groupColumnIndex,
  toggleGroup: toggleGroupWrapper
}) {
  const {
    ref,
    tabIndex,
    onFocus
  } = useRovingCellRef(isCellSelected);

  function toggleGroup() {
    toggleGroupWrapper(id);
  }

  const isLevelMatching = column.rowGroup && groupColumnIndex === column.idx;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "gridcell",
    "aria-colindex": column.idx + 1,
    "aria-selected": isCellSelected,
    ref: ref,
    tabIndex: tabIndex,
    className: getCellClassname(column),
    style: { ...getCellStyle(column),
      cursor: isLevelMatching ? 'pointer' : 'default'
    },
    onClick: isLevelMatching ? toggleGroup : undefined,
    onFocus: onFocus,
    children: (!column.rowGroup || groupColumnIndex === column.idx) && column.groupFormatter?.({
      groupKey,
      childRows,
      column,
      row,
      isExpanded,
      isCellSelected,
      toggleGroup
    })
  }, column.key);
}

const GroupCell$1 = /*#__PURE__*/(0,react.memo)(GroupCell);

var css_248z$6 = ".gyxx7e9700-beta15:not([aria-selected=true]){background-color:var(--rdg-header-background-color)}.gyxx7e9700-beta15>.c1wupbe700-beta15:not(:last-child):not(.c9dpaye700-beta15){border-inline-end:none}";
styleInject(css_248z$6,{"insertAt":"top"});

const groupRow = "gyxx7e9700-beta15";
const groupRowClassname = `rdg-group-row ${groupRow}`;

function GroupedRow({
  id,
  groupKey,
  viewportColumns,
  childRows,
  rowIdx,
  row,
  gridRowStart,
  height,
  level,
  isExpanded,
  selectedCellIdx,
  isRowSelected,
  selectGroup,
  toggleGroup,
  ...props
}) {
  const idx = viewportColumns[0].key === SELECT_COLUMN_KEY ? level + 1 : level;

  function handleSelectGroup() {
    selectGroup(rowIdx);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(RowSelectionProvider, {
    value: isRowSelected,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      role: "row",
      "aria-level": level,
      "aria-expanded": isExpanded,
      className: (0,clsx_m["default"])(rowClassname, groupRowClassname, `rdg-row-${rowIdx % 2 === 0 ? 'even' : 'odd'}`, selectedCellIdx === -1 && rowSelectedClassname),
      onClick: handleSelectGroup,
      style: getRowStyle(gridRowStart, height),
      ...props,
      children: viewportColumns.map(column => /*#__PURE__*/(0,jsx_runtime.jsx)(GroupCell$1, {
        id: id,
        groupKey: groupKey,
        childRows: childRows,
        isExpanded: isExpanded,
        isCellSelected: selectedCellIdx === column.idx,
        column: column,
        row: row,
        groupColumnIndex: idx,
        toggleGroup: toggleGroup
      }, column.key))
    })
  });
}

const GroupRowRenderer = /*#__PURE__*/(0,react.memo)(GroupedRow);

var css_248z$5 = ".s1n3hxke700-beta15{inset-block-end:var(--rdg-summary-row-bottom);inset-block-start:var(--rdg-summary-row-top)}";
styleInject(css_248z$5,{"insertAt":"top"});

const summaryCellClassname = "s1n3hxke700-beta15";

function SummaryCell({
  column,
  colSpan,
  row,
  isCellSelected,
  selectCell
}) {
  const {
    ref,
    tabIndex,
    onFocus
  } = useRovingCellRef(isCellSelected);
  const {
    summaryCellClass
  } = column;
  const className = getCellClassname(column, summaryCellClassname, typeof summaryCellClass === 'function' ? summaryCellClass(row) : summaryCellClass);

  function onClick() {
    selectCell(row, column);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "gridcell",
    "aria-colindex": column.idx + 1,
    "aria-colspan": colSpan,
    "aria-selected": isCellSelected,
    ref: ref,
    tabIndex: tabIndex,
    className: className,
    style: getCellStyle(column, colSpan),
    onClick: onClick,
    onFocus: onFocus,
    children: column.summaryFormatter?.({
      column,
      row,
      isCellSelected
    })
  });
}

const SummaryCell$1 = /*#__PURE__*/(0,react.memo)(SummaryCell);

var css_248z$4 = ".snfqesz700-beta15.r1otpg64700-beta15{line-height:var(--rdg-summary-row-height)}.snfqesz700-beta15.r1otpg64700-beta15>.c1wupbe700-beta15{position:sticky}.s1jijrjz700-beta15>.c1wupbe700-beta15{border-block-start:2px solid var(--rdg-summary-border-color)}";
styleInject(css_248z$4,{"insertAt":"top"});

const summaryRow = "snfqesz700-beta15";
const summaryRowBorderClassname = "s1jijrjz700-beta15";
const summaryRowClassname = `rdg-summary-row ${summaryRow}`;

function SummaryRow({
  rowIdx,
  gridRowStart,
  row,
  viewportColumns,
  top,
  bottom,
  lastFrozenColumnIndex,
  selectedCellIdx,
  selectCell,
  'aria-rowindex': ariaRowIndex
}) {
  const cells = [];

  for (let index = 0; index < viewportColumns.length; index++) {
    const column = viewportColumns[index];
    const colSpan = getColSpan(column, lastFrozenColumnIndex, {
      type: 'SUMMARY',
      row
    });

    if (colSpan !== undefined) {
      index += colSpan - 1;
    }

    const isCellSelected = selectedCellIdx === column.idx;
    cells.push( /*#__PURE__*/(0,jsx_runtime.jsx)(SummaryCell$1, {
      column: column,
      colSpan: colSpan,
      row: row,
      isCellSelected: isCellSelected,
      selectCell: selectCell
    }, column.key));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "row",
    "aria-rowindex": ariaRowIndex,
    className: (0,clsx_m["default"])(rowClassname, `rdg-row-${rowIdx % 2 === 0 ? 'even' : 'odd'}`, summaryRowClassname, rowIdx === 0 && summaryRowBorderClassname, selectedCellIdx === -1 && rowSelectedClassname),
    style: { ...getRowStyle(gridRowStart),
      '--rdg-summary-row-top': top !== undefined ? `${top}px` : undefined,
      '--rdg-summary-row-bottom': bottom !== undefined ? `${bottom}px` : undefined
    },
    children: cells
  });
}

const SummaryRow$1 = /*#__PURE__*/(0,react.memo)(SummaryRow);

var css_248z$3 = ".c1tngyp1700-beta15.rdg-cell{padding:0}";
styleInject(css_248z$3,{"insertAt":"top"});

const cellEditing = "c1tngyp1700-beta15";
function EditCell({
  column,
  colSpan,
  row,
  onRowChange,
  closeEditor
}) {
  const frameRequestRef = (0,react.useRef)();
  const commitOnOutsideClick = column.editorOptions?.commitOnOutsideClick !== false;
  const commitOnOutsideMouseDown = useLatestFunc(() => {
    onClose(true);
  });
  (0,react.useEffect)(() => {
    if (!commitOnOutsideClick) return;

    function onWindowCaptureMouseDown() {
      frameRequestRef.current = requestAnimationFrame(commitOnOutsideMouseDown);
    }

    addEventListener('mousedown', onWindowCaptureMouseDown, {
      capture: true
    });
    return () => {
      removeEventListener('mousedown', onWindowCaptureMouseDown, {
        capture: true
      });
      cancelFrameRequest();
    };
  }, [commitOnOutsideClick, commitOnOutsideMouseDown]);

  function cancelFrameRequest() {
    cancelAnimationFrame(frameRequestRef.current);
  }

  function onKeyDown(event) {
    if (event.key === 'Escape') {
      event.stopPropagation();
      onClose();
    } else if (event.key === 'Enter') {
      event.stopPropagation();
      onClose(true);
    } else {
      const onNavigation = column.editorOptions?.onNavigation ?? onEditorNavigation;

      if (!onNavigation(event)) {
        event.stopPropagation();
      }
    }
  }

  function onClose(commitChanges) {
    if (commitChanges) {
      onRowChange(row, true);
    } else {
      closeEditor();
    }
  }

  const {
    cellClass
  } = column;
  const className = getCellClassname(column, 'rdg-editor-container', typeof cellClass === 'function' ? cellClass(row) : cellClass, !column.editorOptions?.renderFormatter && cellEditing);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    role: "gridcell",
    "aria-colindex": column.idx + 1,
    "aria-colspan": colSpan,
    "aria-selected": true,
    className: className,
    style: getCellStyle(column, colSpan),
    onKeyDown: onKeyDown,
    onMouseDownCapture: commitOnOutsideClick ? cancelFrameRequest : undefined,
    children: column.editor != null && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [column.editor({
        column,
        row,
        onRowChange,
        onClose
      }), column.editorOptions?.renderFormatter && column.formatter({
        column,
        row,
        isCellSelected: true,
        onRowChange
      })]
    })
  });
}

var css_248z$2 = ".cadd3bp700-beta15{background-color:var(--rdg-selection-color);block-size:8px;cursor:move;inline-size:8px;inset-block-end:0;inset-inline-end:0;position:absolute}.cadd3bp700-beta15:hover{background-color:var(--rdg-background-color);block-size:16px;border:2px solid var(--rdg-selection-color);inline-size:16px}";
styleInject(css_248z$2,{"insertAt":"top"});

const cellDragHandle = "cadd3bp700-beta15";
const cellDragHandleClassname = `rdg-cell-drag-handle ${cellDragHandle}`;
function DragHandle({
  rows,
  columns,
  selectedPosition,
  latestDraggedOverRowIdx,
  isCellEditable,
  onRowsChange,
  onFill,
  setDragging,
  setDraggedOverRowIdx
}) {
  function handleMouseDown(event) {
    if (event.buttons !== 1) return;
    setDragging(true);
    window.addEventListener('mouseover', onMouseOver);
    window.addEventListener('mouseup', onMouseUp);

    function onMouseOver(event) {
      if (event.buttons !== 1) onMouseUp();
    }

    function onMouseUp() {
      window.removeEventListener('mouseover', onMouseOver);
      window.removeEventListener('mouseup', onMouseUp);
      setDragging(false);
      handleDragEnd();
    }
  }

  function handleDragEnd() {
    const overRowIdx = latestDraggedOverRowIdx.current;
    if (overRowIdx === undefined) return;
    const {
      rowIdx
    } = selectedPosition;
    const startRowIndex = rowIdx < overRowIdx ? rowIdx + 1 : overRowIdx;
    const endRowIndex = rowIdx < overRowIdx ? overRowIdx + 1 : rowIdx;
    updateRows(startRowIndex, endRowIndex);
    setDraggedOverRowIdx(undefined);
  }

  function handleDoubleClick(event) {
    event.stopPropagation();
    updateRows(selectedPosition.rowIdx + 1, rows.length);
  }

  function updateRows(startRowIdx, endRowIdx) {
    const {
      idx,
      rowIdx
    } = selectedPosition;
    const column = columns[idx];
    const sourceRow = rows[rowIdx];
    const updatedRows = [...rows];
    const indexes = [];

    for (let i = startRowIdx; i < endRowIdx; i++) {
      if (isCellEditable({
        rowIdx: i,
        idx
      })) {
        const updatedRow = onFill({
          columnKey: column.key,
          sourceRow,
          targetRow: rows[i]
        });

        if (updatedRow !== rows[i]) {
          updatedRows[i] = updatedRow;
          indexes.push(i);
        }
      }
    }

    if (indexes.length > 0) {
      onRowsChange?.(updatedRows, {
        indexes,
        column
      });
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: cellDragHandleClassname,
    onMouseDown: handleMouseDown,
    onDoubleClick: handleDoubleClick
  });
}

var css_248z$1 = ".a1ekscoj700-beta15{fill:currentColor}.a1ekscoj700-beta15>path{transition:d .1s}";
styleInject(css_248z$1,{"insertAt":"top"});

const arrow = "a1ekscoj700-beta15";
const arrowClassname = `rdg-sort-arrow ${arrow}`;
function sortIcon({
  sortDirection
}) {
  if (sortDirection === undefined) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    viewBox: "0 0 12 8",
    width: "12",
    height: "8",
    className: arrowClassname,
    "aria-hidden": true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: sortDirection === 'ASC' ? 'M0 8 6 0 12 8' : 'M0 0 6 8 12 0'
    })
  });
}

const initialPosition = {
  idx: -1,
  rowIdx: -2,
  mode: 'SELECT'
};

function DataGrid({
  columns: rawColumns,
  rows: rawRows,
  summaryRows,
  rowKeyGetter,
  onRowsChange,
  rowHeight,
  headerRowHeight: rawHeaderRowHeight,
  summaryRowHeight: rawSummaryRowHeight,
  selectedRows,
  onSelectedRowsChange,
  sortColumns,
  onSortColumnsChange,
  defaultColumnOptions,
  groupBy: rawGroupBy,
  rowGrouper,
  expandedGroupIds,
  onExpandedGroupIdsChange,
  onRowClick,
  onRowDoubleClick,
  onScroll,
  onColumnResize,
  onFill,
  onCopy,
  onPaste,
  cellNavigationMode: rawCellNavigationMode,
  enableVirtualization,
  renderers,
  className,
  style,
  rowClass,
  direction,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  'aria-describedby': ariaDescribedBy,
  'data-testid': testId
}, ref) {
  const defaultComponents = useDefaultComponents();
  rowHeight ?? (rowHeight = 35);
  const headerRowHeight = rawHeaderRowHeight ?? (typeof rowHeight === 'number' ? rowHeight : 35);
  const summaryRowHeight = rawSummaryRowHeight ?? (typeof rowHeight === 'number' ? rowHeight : 35);
  const rowRenderer = renderers?.rowRenderer ?? defaultComponents?.rowRenderer ?? defaultRowRenderer;
  const sortIcon$1 = renderers?.sortIcon ?? defaultComponents?.sortIcon ?? sortIcon;
  const checkboxFormatter$1 = renderers?.checkboxFormatter ?? defaultComponents?.checkboxFormatter ?? checkboxFormatter;
  const noRowsFallback = renderers?.noRowsFallback ?? defaultComponents?.noRowsFallback;
  const cellNavigationMode = rawCellNavigationMode ?? 'NONE';
  enableVirtualization ?? (enableVirtualization = true);
  direction ?? (direction = 'ltr');
  const [scrollTop, setScrollTop] = (0,react.useState)(0);
  const [scrollLeft, setScrollLeft] = (0,react.useState)(0);
  const [columnWidths, setColumnWidths] = (0,react.useState)(() => new Map());
  const [selectedPosition, setSelectedPosition] = (0,react.useState)(initialPosition);
  const [copiedCell, setCopiedCell] = (0,react.useState)(null);
  const [isDragging, setDragging] = (0,react.useState)(false);
  const [draggedOverRowIdx, setOverRowIdx] = (0,react.useState)(undefined);
  const [autoResizeColumn, setAutoResizeColumn] = (0,react.useState)(null);
  const prevSelectedPosition = (0,react.useRef)(selectedPosition);
  const latestDraggedOverRowIdx = (0,react.useRef)(draggedOverRowIdx);
  const lastSelectedRowIdx = (0,react.useRef)(-1);
  const rowRef = (0,react.useRef)(null);
  const [gridRef, gridWidth, gridHeight] = useGridDimensions();
  const headerRowsCount = 1;
  const summaryRowsCount = summaryRows?.length ?? 0;
  const clientHeight = gridHeight - headerRowHeight - summaryRowsCount * summaryRowHeight;
  const isSelectable = selectedRows != null && onSelectedRowsChange != null;
  const isHeaderRowSelected = selectedPosition.rowIdx === -1;
  const isRtl = direction === 'rtl';
  const leftKey = isRtl ? 'ArrowRight' : 'ArrowLeft';
  const rightKey = isRtl ? 'ArrowLeft' : 'ArrowRight';
  const defaultGridComponents = (0,react.useMemo)(() => ({
    sortIcon: sortIcon$1,
    checkboxFormatter: checkboxFormatter$1
  }), [sortIcon$1, checkboxFormatter$1]);
  const allRowsSelected = (0,react.useMemo)(() => {
    const {
      length
    } = rawRows;
    return length !== 0 && selectedRows != null && rowKeyGetter != null && selectedRows.size >= length && rawRows.every(row => selectedRows.has(rowKeyGetter(row)));
  }, [rawRows, selectedRows, rowKeyGetter]);
  const {
    columns,
    colSpanColumns,
    colOverscanStartIdx,
    colOverscanEndIdx,
    layoutCssVars,
    columnMetrics,
    lastFrozenColumnIndex,
    totalFrozenColumnWidth,
    groupBy
  } = useCalculatedColumns({
    rawColumns,
    columnWidths,
    scrollLeft,
    viewportWidth: gridWidth,
    defaultColumnOptions,
    rawGroupBy: rowGrouper ? rawGroupBy : undefined,
    enableVirtualization
  });
  const {
    rowOverscanStartIdx,
    rowOverscanEndIdx,
    rows,
    rowsCount,
    totalRowHeight,
    gridTemplateRows,
    isGroupRow,
    getRowTop,
    getRowHeight,
    findRowIdx
  } = useViewportRows({
    rawRows,
    groupBy,
    rowGrouper,
    rowHeight,
    clientHeight,
    scrollTop,
    expandedGroupIds,
    enableVirtualization
  });
  const viewportColumns = useViewportColumns({
    columns,
    colSpanColumns,
    colOverscanStartIdx,
    colOverscanEndIdx,
    lastFrozenColumnIndex,
    rowOverscanStartIdx,
    rowOverscanEndIdx,
    rows,
    summaryRows,
    isGroupRow
  });
  const hasGroups = groupBy.length > 0 && typeof rowGrouper === 'function';
  const minColIdx = hasGroups ? -1 : 0;
  const maxColIdx = columns.length - 1;
  const minRowIdx = -1;
  const maxRowIdx = headerRowsCount + rows.length + summaryRowsCount - 2;
  const selectedCellIsWithinSelectionBounds = isCellWithinSelectionBounds(selectedPosition);
  const selectedCellIsWithinViewportBounds = isCellWithinViewportBounds(selectedPosition);
  const selectRowLatest = useLatestFunc(selectRow);
  const selectAllRowsLatest = useLatestFunc(selectAllRows);
  const handleFormatterRowChangeLatest = useLatestFunc(updateRow);
  const selectViewportCellLatest = useLatestFunc((row, column, enableEditor) => {
    const rowIdx = rows.indexOf(row);
    selectCell({
      rowIdx,
      idx: column.idx
    }, enableEditor);
  });
  const selectGroupLatest = useLatestFunc(rowIdx => {
    selectCell({
      rowIdx,
      idx: -1
    });
  });
  const selectHeaderCellLatest = useLatestFunc(idx => {
    selectCell({
      rowIdx: -1,
      idx
    });
  });
  const selectSummaryCellLatest = useLatestFunc((summaryRow, column) => {
    const rowIdx = summaryRows.indexOf(summaryRow) + headerRowsCount + rows.length - 1;
    selectCell({
      rowIdx,
      idx: column.idx
    });
  });
  const toggleGroupLatest = useLatestFunc(toggleGroup);
  useLayoutEffect(() => {
    if (!selectedCellIsWithinSelectionBounds || isSamePosition(selectedPosition, prevSelectedPosition.current)) {
      prevSelectedPosition.current = selectedPosition;
      return;
    }

    prevSelectedPosition.current = selectedPosition;

    if (selectedPosition.idx === -1) {
      rowRef.current.focus({
        preventScroll: true
      });
      scrollIntoView(rowRef.current);
    }
  });
  useLayoutEffect(() => {
    if (autoResizeColumn === null) return;
    const columnElement = gridRef.current.querySelector(`[aria-colindex="${autoResizeColumn.idx + 1}"]`);
    const {
      width
    } = columnElement.getBoundingClientRect();
    setColumnWidths(columnWidths => {
      const newColumnWidths = new Map(columnWidths);
      newColumnWidths.set(autoResizeColumn.key, width);
      return newColumnWidths;
    });
    setAutoResizeColumn(null);
    onColumnResize?.(autoResizeColumn.idx, width);
  }, [autoResizeColumn, gridRef, onColumnResize]);
  (0,react.useImperativeHandle)(ref, () => ({
    element: gridRef.current,
    scrollToColumn,

    scrollToRow(rowIdx) {
      const {
        current
      } = gridRef;
      if (!current) return;
      current.scrollTo({
        top: getRowTop(rowIdx),
        behavior: 'smooth'
      });
    },

    selectCell
  }));
  const handleColumnResize = (0,react.useCallback)((column, width) => {
    if (width === 'auto') {
      setAutoResizeColumn(column);
      return;
    }

    setColumnWidths(columnWidths => {
      const newColumnWidths = new Map(columnWidths);
      newColumnWidths.set(column.key, width);
      return newColumnWidths;
    });
    onColumnResize?.(column.idx, width);
  }, [onColumnResize]);
  const setDraggedOverRowIdx = (0,react.useCallback)(rowIdx => {
    setOverRowIdx(rowIdx);
    latestDraggedOverRowIdx.current = rowIdx;
  }, []);

  function selectRow({
    row,
    checked,
    isShiftClick
  }) {
    if (!onSelectedRowsChange) return;
    assertIsValidKeyGetter(rowKeyGetter);
    const newSelectedRows = new Set(selectedRows);

    if (isGroupRow(row)) {
      for (const childRow of row.childRows) {
        const rowKey = rowKeyGetter(childRow);

        if (checked) {
          newSelectedRows.add(rowKey);
        } else {
          newSelectedRows.delete(rowKey);
        }
      }

      onSelectedRowsChange(newSelectedRows);
      return;
    }

    const rowKey = rowKeyGetter(row);

    if (checked) {
      newSelectedRows.add(rowKey);
      const previousRowIdx = lastSelectedRowIdx.current;
      const rowIdx = rows.indexOf(row);
      lastSelectedRowIdx.current = rowIdx;

      if (isShiftClick && previousRowIdx !== -1 && previousRowIdx !== rowIdx) {
        const step = sign(rowIdx - previousRowIdx);

        for (let i = previousRowIdx + step; i !== rowIdx; i += step) {
          const row = rows[i];
          if (isGroupRow(row)) continue;
          newSelectedRows.add(rowKeyGetter(row));
        }
      }
    } else {
      newSelectedRows.delete(rowKey);
      lastSelectedRowIdx.current = -1;
    }

    onSelectedRowsChange(newSelectedRows);
  }

  function selectAllRows(checked) {
    if (!onSelectedRowsChange) return;
    assertIsValidKeyGetter(rowKeyGetter);
    const newSelectedRows = new Set(selectedRows);

    for (const row of rawRows) {
      const rowKey = rowKeyGetter(row);

      if (checked) {
        newSelectedRows.add(rowKey);
      } else {
        newSelectedRows.delete(rowKey);
      }
    }

    onSelectedRowsChange(newSelectedRows);
  }

  function toggleGroup(expandedGroupId) {
    if (!onExpandedGroupIdsChange) return;
    const newExpandedGroupIds = new Set(expandedGroupIds);

    if (newExpandedGroupIds.has(expandedGroupId)) {
      newExpandedGroupIds.delete(expandedGroupId);
    } else {
      newExpandedGroupIds.add(expandedGroupId);
    }

    onExpandedGroupIdsChange(newExpandedGroupIds);
  }

  function handleKeyDown(event) {
    if (!(event.target instanceof Element)) return;
    const isCellEvent = event.target.closest('.rdg-cell') !== null;
    const isRowEvent = hasGroups && event.target === rowRef.current;
    if (!isCellEvent && !isRowEvent) return;
    const {
      key,
      keyCode
    } = event;
    const {
      rowIdx
    } = selectedPosition;

    if (selectedCellIsWithinViewportBounds && (onPaste != null || onCopy != null) && isCtrlKeyHeldDown(event) && !isGroupRow(rows[rowIdx]) && selectedPosition.mode === 'SELECT') {
      const cKey = 67;
      const vKey = 86;

      if (keyCode === cKey) {
        handleCopy();
        return;
      }

      if (keyCode === vKey) {
        handlePaste();
        return;
      }
    }

    if (isRowIdxWithinViewportBounds(rowIdx)) {
      const row = rows[rowIdx];

      if (isGroupRow(row) && selectedPosition.idx === -1 && (key === leftKey && row.isExpanded || key === rightKey && !row.isExpanded)) {
        event.preventDefault();
        toggleGroup(row.id);
        return;
      }
    }

    switch (event.key) {
      case 'Escape':
        setCopiedCell(null);
        return;

      case 'ArrowUp':
      case 'ArrowDown':
      case 'ArrowLeft':
      case 'ArrowRight':
      case 'Tab':
      case 'Home':
      case 'End':
      case 'PageUp':
      case 'PageDown':
        navigate(event);
        break;

      default:
        handleCellInput(event);
        break;
    }
  }

  function handleScroll(event) {
    const {
      scrollTop,
      scrollLeft
    } = event.currentTarget;
    setScrollTop(scrollTop);
    setScrollLeft(abs(scrollLeft));
    onScroll?.(event);
  }

  function getRawRowIdx(rowIdx) {
    return hasGroups ? rawRows.indexOf(rows[rowIdx]) : rowIdx;
  }

  function updateRow(column, rowIdx, row) {
    if (typeof onRowsChange !== 'function') return;
    const rawRowIdx = getRawRowIdx(rowIdx);
    if (row === rawRows[rawRowIdx]) return;
    const updatedRows = [...rawRows];
    updatedRows[rawRowIdx] = row;
    onRowsChange(updatedRows, {
      indexes: [rawRowIdx],
      column
    });
  }

  function commitEditorChanges() {
    if (selectedPosition.mode !== 'EDIT') return;
    updateRow(columns[selectedPosition.idx], selectedPosition.rowIdx, selectedPosition.row);
  }

  function handleCopy() {
    const {
      idx,
      rowIdx
    } = selectedPosition;
    const sourceRow = rawRows[getRawRowIdx(rowIdx)];
    const sourceColumnKey = columns[idx].key;
    setCopiedCell({
      row: sourceRow,
      columnKey: sourceColumnKey
    });
    onCopy?.({
      sourceRow,
      sourceColumnKey
    });
  }

  function handlePaste() {
    if (!onPaste || !onRowsChange || copiedCell === null || !isCellEditable(selectedPosition)) {
      return;
    }

    const {
      idx,
      rowIdx
    } = selectedPosition;
    const targetColumn = columns[idx];
    const targetRow = rawRows[getRawRowIdx(rowIdx)];
    const updatedTargetRow = onPaste({
      sourceRow: copiedCell.row,
      sourceColumnKey: copiedCell.columnKey,
      targetRow,
      targetColumnKey: targetColumn.key
    });
    updateRow(targetColumn, rowIdx, updatedTargetRow);
  }

  function handleCellInput(event) {
    if (!selectedCellIsWithinViewportBounds) return;
    const row = rows[selectedPosition.rowIdx];
    if (isGroupRow(row)) return;
    const {
      key,
      shiftKey
    } = event;

    if (isSelectable && shiftKey && key === ' ') {
      assertIsValidKeyGetter(rowKeyGetter);
      const rowKey = rowKeyGetter(row);
      selectRow({
        row,
        checked: !selectedRows.has(rowKey),
        isShiftClick: false
      });
      event.preventDefault();
      return;
    }

    const column = columns[selectedPosition.idx];
    column.editorOptions?.onCellKeyDown?.(event);
    if (event.isDefaultPrevented()) return;

    if (isCellEditable(selectedPosition) && isDefaultCellInput(event)) {
      setSelectedPosition(({
        idx,
        rowIdx
      }) => ({
        idx,
        rowIdx,
        mode: 'EDIT',
        row,
        originalRow: row
      }));
    }
  }

  function isColIdxWithinSelectionBounds(idx) {
    return idx >= minColIdx && idx <= maxColIdx;
  }

  function isRowIdxWithinViewportBounds(rowIdx) {
    return rowIdx >= 0 && rowIdx < rows.length;
  }

  function isCellWithinSelectionBounds({
    idx,
    rowIdx
  }) {
    return rowIdx >= minRowIdx && rowIdx <= maxRowIdx && isColIdxWithinSelectionBounds(idx);
  }

  function isCellWithinViewportBounds({
    idx,
    rowIdx
  }) {
    return isRowIdxWithinViewportBounds(rowIdx) && isColIdxWithinSelectionBounds(idx);
  }

  function isCellEditable(position) {
    return isCellWithinViewportBounds(position) && isSelectedCellEditable({
      columns,
      rows,
      selectedPosition: position,
      isGroupRow
    });
  }

  function selectCell(position, enableEditor) {
    if (!isCellWithinSelectionBounds(position)) return;
    commitEditorChanges();

    if (enableEditor && isCellEditable(position)) {
      const row = rows[position.rowIdx];
      setSelectedPosition({ ...position,
        mode: 'EDIT',
        row,
        originalRow: row
      });
    } else if (isSamePosition(selectedPosition, position)) {
      scrollIntoView(gridRef.current?.querySelector('[tabindex="0"]'));
    } else {
      setSelectedPosition({ ...position,
        mode: 'SELECT'
      });
    }
  }

  function scrollToColumn(idx) {
    const {
      current
    } = gridRef;
    if (!current) return;

    if (idx > lastFrozenColumnIndex) {
      const {
        rowIdx
      } = selectedPosition;
      if (!isCellWithinSelectionBounds({
        rowIdx,
        idx
      })) return;
      const {
        clientWidth
      } = current;
      const column = columns[idx];
      const {
        left,
        width
      } = columnMetrics.get(column);
      let right = left + width;
      const colSpan = getSelectedCellColSpan({
        rows,
        summaryRows,
        rowIdx,
        lastFrozenColumnIndex,
        column,
        isGroupRow
      });

      if (colSpan !== undefined) {
        const {
          left,
          width
        } = columnMetrics.get(columns[column.idx + colSpan - 1]);
        right = left + width;
      }

      const isCellAtLeftBoundary = left < scrollLeft + totalFrozenColumnWidth;
      const isCellAtRightBoundary = right > clientWidth + scrollLeft;
      const sign = isRtl ? -1 : 1;

      if (isCellAtLeftBoundary) {
        current.scrollLeft = (left - totalFrozenColumnWidth) * sign;
      } else if (isCellAtRightBoundary) {
        current.scrollLeft = (right - clientWidth) * sign;
      }
    }
  }

  function getNextPosition(key, ctrlKey, shiftKey) {
    const {
      idx,
      rowIdx
    } = selectedPosition;
    const row = rows[rowIdx];
    const isRowSelected = selectedCellIsWithinSelectionBounds && idx === -1;

    if (key === leftKey && isRowSelected && isGroupRow(row) && !row.isExpanded && row.level !== 0) {
      let parentRowIdx = -1;

      for (let i = selectedPosition.rowIdx - 1; i >= 0; i--) {
        const parentRow = rows[i];

        if (isGroupRow(parentRow) && parentRow.id === row.parentId) {
          parentRowIdx = i;
          break;
        }
      }

      if (parentRowIdx !== -1) {
        return {
          idx,
          rowIdx: parentRowIdx
        };
      }
    }

    switch (key) {
      case 'ArrowUp':
        return {
          idx,
          rowIdx: rowIdx - 1
        };

      case 'ArrowDown':
        return {
          idx,
          rowIdx: rowIdx + 1
        };

      case leftKey:
        return {
          idx: idx - 1,
          rowIdx
        };

      case rightKey:
        return {
          idx: idx + 1,
          rowIdx
        };

      case 'Tab':
        return {
          idx: idx + (shiftKey ? -1 : 1),
          rowIdx
        };

      case 'Home':
        if (isRowSelected) return {
          idx,
          rowIdx: 0
        };
        return {
          idx: 0,
          rowIdx: ctrlKey ? minRowIdx : rowIdx
        };

      case 'End':
        if (isRowSelected) return {
          idx,
          rowIdx: rows.length - 1
        };
        return {
          idx: maxColIdx,
          rowIdx: ctrlKey ? maxRowIdx : rowIdx
        };

      case 'PageUp':
        {
          if (selectedPosition.rowIdx === minRowIdx) return selectedPosition;
          const nextRowY = getRowTop(rowIdx) + getRowHeight(rowIdx) - clientHeight;
          return {
            idx,
            rowIdx: nextRowY > 0 ? findRowIdx(nextRowY) : 0
          };
        }

      case 'PageDown':
        {
          if (selectedPosition.rowIdx >= rows.length) return selectedPosition;
          const nextRowY = getRowTop(rowIdx) + clientHeight;
          return {
            idx,
            rowIdx: nextRowY < totalRowHeight ? findRowIdx(nextRowY) : rows.length - 1
          };
        }

      default:
        return selectedPosition;
    }
  }

  function navigate(event) {
    const {
      key,
      shiftKey
    } = event;
    let mode = cellNavigationMode;

    if (key === 'Tab') {
      if (canExitGrid({
        shiftKey,
        cellNavigationMode,
        maxColIdx,
        minRowIdx,
        maxRowIdx,
        selectedPosition
      })) {
        commitEditorChanges();
        return;
      }

      mode = cellNavigationMode === 'NONE' ? 'CHANGE_ROW' : cellNavigationMode;
    }

    event.preventDefault();
    const ctrlKey = isCtrlKeyHeldDown(event);
    const nextPosition = getNextPosition(key, ctrlKey, shiftKey);
    if (isSamePosition(selectedPosition, nextPosition)) return;
    const nextSelectedCellPosition = getNextSelectedCellPosition({
      columns,
      colSpanColumns,
      rows,
      summaryRows,
      minRowIdx,
      maxRowIdx,
      lastFrozenColumnIndex,
      cellNavigationMode: mode,
      currentPosition: selectedPosition,
      nextPosition,
      isCellWithinBounds: isCellWithinSelectionBounds,
      isGroupRow
    });
    selectCell(nextSelectedCellPosition);
  }

  function getDraggedOverCellIdx(currentRowIdx) {
    if (draggedOverRowIdx === undefined) return;
    const {
      rowIdx
    } = selectedPosition;
    const isDraggedOver = rowIdx < draggedOverRowIdx ? rowIdx < currentRowIdx && currentRowIdx <= draggedOverRowIdx : rowIdx > currentRowIdx && currentRowIdx >= draggedOverRowIdx;
    return isDraggedOver ? selectedPosition.idx : undefined;
  }

  function getLayoutCssVars() {
    if (autoResizeColumn === null) return layoutCssVars;
    const {
      gridTemplateColumns
    } = layoutCssVars;
    const newSizes = gridTemplateColumns.split(' ');
    newSizes[autoResizeColumn.idx] = 'max-content';
    return { ...layoutCssVars,
      gridTemplateColumns: newSizes.join(' ')
    };
  }

  function getDragHandle(rowIdx) {
    if (selectedPosition.rowIdx !== rowIdx || selectedPosition.mode === 'EDIT' || hasGroups || onFill == null) {
      return;
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(DragHandle, {
      rows: rawRows,
      columns: columns,
      selectedPosition: selectedPosition,
      isCellEditable: isCellEditable,
      latestDraggedOverRowIdx: latestDraggedOverRowIdx,
      onRowsChange: onRowsChange,
      onFill: onFill,
      setDragging: setDragging,
      setDraggedOverRowIdx: setDraggedOverRowIdx
    });
  }

  function getCellEditor(rowIdx) {
    if (selectedPosition.rowIdx !== rowIdx || selectedPosition.mode === 'SELECT') return;
    const {
      idx,
      row
    } = selectedPosition;
    const column = columns[idx];
    const colSpan = getColSpan(column, lastFrozenColumnIndex, {
      type: 'ROW',
      row
    });

    const closeEditor = () => {
      setSelectedPosition(({
        idx,
        rowIdx
      }) => ({
        idx,
        rowIdx,
        mode: 'SELECT'
      }));
    };

    const onRowChange = (row, commitChanges) => {
      if (commitChanges) {
        updateRow(column, selectedPosition.rowIdx, row);
        closeEditor();
      } else {
        setSelectedPosition(position => ({ ...position,
          row
        }));
      }
    };

    if (rows[selectedPosition.rowIdx] !== selectedPosition.originalRow) {
      closeEditor();
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(EditCell, {
      column: column,
      colSpan: colSpan,
      row: row,
      onRowChange: onRowChange,
      closeEditor: closeEditor
    }, column.key);
  }

  function getRowViewportColumns(rowIdx) {
    const selectedColumn = columns[selectedPosition.idx];

    if (selectedColumn !== undefined && selectedPosition.rowIdx === rowIdx && !viewportColumns.includes(selectedColumn)) {
      return selectedPosition.idx > colOverscanEndIdx ? [...viewportColumns, selectedColumn] : [...viewportColumns.slice(0, lastFrozenColumnIndex + 1), selectedColumn, ...viewportColumns.slice(lastFrozenColumnIndex + 1)];
    }

    return viewportColumns;
  }

  function getViewportRows() {
    const rowElements = [];
    let startRowIndex = 0;
    const {
      idx: selectedIdx,
      rowIdx: selectedRowIdx
    } = selectedPosition;
    const startRowIdx = selectedCellIsWithinViewportBounds && selectedRowIdx < rowOverscanStartIdx ? rowOverscanStartIdx - 1 : rowOverscanStartIdx;
    const endRowIdx = selectedCellIsWithinViewportBounds && selectedRowIdx > rowOverscanEndIdx ? rowOverscanEndIdx + 1 : rowOverscanEndIdx;

    for (let viewportRowIdx = startRowIdx; viewportRowIdx <= endRowIdx; viewportRowIdx++) {
      const isRowOutsideViewport = viewportRowIdx === rowOverscanStartIdx - 1 || viewportRowIdx === rowOverscanEndIdx + 1;
      const rowIdx = isRowOutsideViewport ? selectedRowIdx : viewportRowIdx;
      let rowColumns = viewportColumns;
      const selectedColumn = columns[selectedIdx];

      if (selectedColumn !== undefined) {
        if (isRowOutsideViewport) {
          rowColumns = [selectedColumn];
        } else {
          rowColumns = getRowViewportColumns(rowIdx);
        }
      }

      const row = rows[rowIdx];
      const gridRowStart = headerRowsCount + rowIdx + 1;

      if (isGroupRow(row)) {
        ({
          startRowIndex
        } = row);
        const isGroupRowSelected = isSelectable && row.childRows.every(cr => selectedRows.has(rowKeyGetter(cr)));
        rowElements.push( /*#__PURE__*/(0,jsx_runtime.jsx)(GroupRowRenderer, {
          "aria-level": row.level + 1,
          "aria-setsize": row.setSize,
          "aria-posinset": row.posInSet + 1,
          "aria-rowindex": headerRowsCount + startRowIndex + 1,
          "aria-selected": isSelectable ? isGroupRowSelected : undefined,
          id: row.id,
          groupKey: row.groupKey,
          viewportColumns: rowColumns,
          childRows: row.childRows,
          rowIdx: rowIdx,
          row: row,
          gridRowStart: gridRowStart,
          height: getRowHeight(rowIdx),
          level: row.level,
          isExpanded: row.isExpanded,
          selectedCellIdx: selectedRowIdx === rowIdx ? selectedIdx : undefined,
          isRowSelected: isGroupRowSelected,
          selectGroup: selectGroupLatest,
          toggleGroup: toggleGroupLatest
        }, row.id));
        continue;
      }

      startRowIndex++;
      let key;
      let isRowSelected = false;

      if (typeof rowKeyGetter === 'function') {
        key = rowKeyGetter(row);
        isRowSelected = selectedRows?.has(key) ?? false;
      } else {
        key = hasGroups ? startRowIndex : rowIdx;
      }

      rowElements.push(rowRenderer(key, {
        'aria-rowindex': headerRowsCount + (hasGroups ? startRowIndex : rowIdx) + 1,
        'aria-selected': isSelectable ? isRowSelected : undefined,
        rowIdx,
        row,
        viewportColumns: rowColumns,
        isRowSelected,
        onRowClick,
        onRowDoubleClick,
        rowClass,
        gridRowStart,
        height: getRowHeight(rowIdx),
        copiedCellIdx: copiedCell !== null && copiedCell.row === row ? columns.findIndex(c => c.key === copiedCell.columnKey) : undefined,
        selectedCellIdx: selectedRowIdx === rowIdx ? selectedIdx : undefined,
        draggedOverCellIdx: getDraggedOverCellIdx(rowIdx),
        setDraggedOverRowIdx: isDragging ? setDraggedOverRowIdx : undefined,
        lastFrozenColumnIndex,
        onRowChange: handleFormatterRowChangeLatest,
        selectCell: selectViewportCellLatest,
        selectedCellDragHandle: getDragHandle(rowIdx),
        selectedCellEditor: getCellEditor(rowIdx)
      }));
    }

    return rowElements;
  }

  if (selectedPosition.idx > maxColIdx || selectedPosition.rowIdx > maxRowIdx) {
    setSelectedPosition(initialPosition);
    setDraggedOverRowIdx(undefined);
  }

  let templateRows = `${headerRowHeight}px`;

  if (rows.length > 0) {
    templateRows += gridTemplateRows;
  }

  if (summaryRowsCount > 0) {
    templateRows += ` repeat(${summaryRowsCount}, ${summaryRowHeight}px)`;
  }

  const isGroupRowFocused = selectedPosition.idx === -1 && selectedPosition.rowIdx !== -2;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    role: hasGroups ? 'treegrid' : 'grid',
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": ariaDescribedBy,
    "aria-multiselectable": isSelectable ? true : undefined,
    "aria-colcount": columns.length,
    "aria-rowcount": headerRowsCount + rowsCount + summaryRowsCount,
    className: (0,clsx_m["default"])(rootClassname, className, isDragging && viewportDraggingClassname, autoResizeColumn !== null && cellAutoResizeClassname),
    style: { ...style,
      scrollPaddingInlineStart: selectedPosition.idx > lastFrozenColumnIndex ? `${totalFrozenColumnWidth}px` : undefined,
      scrollPaddingBlock: selectedPosition.rowIdx >= 0 && selectedPosition.rowIdx < rows.length ? `${headerRowHeight}px ${summaryRowsCount * summaryRowHeight}px` : undefined,
      gridTemplateRows: templateRows,
      '--rdg-header-row-height': `${headerRowHeight}px`,
      '--rdg-summary-row-height': `${summaryRowHeight}px`,
      '--rdg-sign': isRtl ? -1 : 1,
      ...getLayoutCssVars()
    },
    dir: direction,
    ref: gridRef,
    onScroll: handleScroll,
    onKeyDown: handleKeyDown,
    "data-testid": testId,
    children: [hasGroups && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: rowRef,
      tabIndex: isGroupRowFocused ? 0 : -1,
      className: (0,clsx_m["default"])(focusSinkClassname, isGroupRowFocused && [rowSelected, lastFrozenColumnIndex !== -1 && rowSelectedWithFrozenCell]),
      style: {
        gridRowStart: selectedPosition.rowIdx + 2
      },
      onKeyDown: handleKeyDown
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DataGridDefaultComponentsProvider, {
      value: defaultGridComponents,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeaderRow$1, {
        columns: getRowViewportColumns(-1),
        onColumnResize: handleColumnResize,
        allRowsSelected: allRowsSelected,
        onAllRowsSelectionChange: selectAllRowsLatest,
        sortColumns: sortColumns,
        onSortColumnsChange: onSortColumnsChange,
        lastFrozenColumnIndex: lastFrozenColumnIndex,
        selectedCellIdx: isHeaderRowSelected ? selectedPosition.idx : undefined,
        selectCell: selectHeaderCellLatest,
        shouldFocusGrid: !selectedCellIsWithinSelectionBounds,
        direction: direction
      }), rows.length === 0 && noRowsFallback ? noRowsFallback : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RowSelectionChangeProvider, {
          value: selectRowLatest,
          children: getViewportRows()
        }), summaryRows?.map((row, rowIdx) => {
          const gridRowStart = headerRowsCount + rows.length + rowIdx + 1;
          const summaryRowIdx = headerRowsCount + rows.length + rowIdx - 1;
          const isSummaryRowSelected = selectedPosition.rowIdx === summaryRowIdx;
          const top = clientHeight > totalRowHeight ? gridHeight - summaryRowHeight * (summaryRows.length - rowIdx) : undefined;
          const bottom = top === undefined ? summaryRowHeight * (summaryRows.length - 1 - rowIdx) : undefined;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SummaryRow$1, {
            "aria-rowindex": headerRowsCount + rowsCount + rowIdx + 1,
            rowIdx: rowIdx,
            gridRowStart: gridRowStart,
            row: row,
            top: top,
            bottom: bottom,
            viewportColumns: getRowViewportColumns(summaryRowIdx),
            lastFrozenColumnIndex: lastFrozenColumnIndex,
            selectedCellIdx: isSummaryRowSelected ? selectedPosition.idx : undefined,
            selectCell: selectSummaryCellLatest
          }, rowIdx);
        })]
      })]
    })]
  });
}

function isSamePosition(p1, p2) {
  return p1.idx === p2.idx && p1.rowIdx === p2.rowIdx;
}

const DataGrid$1 = /*#__PURE__*/(0,react.forwardRef)(DataGrid);

var css_248z = ".tlmcuo0700-beta15{appearance:none;background-color:var(--rdg-background-color);block-size:100%;border:2px solid #ccc;box-sizing:border-box;color:var(--rdg-color);font-family:inherit;font-size:var(--rdg-font-size);inline-size:100%;padding-block:0;padding-inline:6px;vertical-align:top}.tlmcuo0700-beta15:focus{border-color:var(--rdg-selection-color);outline:none}.tlmcuo0700-beta15::placeholder{color:#999;opacity:1}";
styleInject(css_248z,{"insertAt":"top"});

const textEditorInternalClassname = "tlmcuo0700-beta15";
const textEditorClassname = `rdg-text-editor ${textEditorInternalClassname}`;

function autoFocusAndSelect(input) {
  input?.focus();
  input?.select();
}

function textEditor({
  row,
  column,
  onRowChange,
  onClose
}) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
    className: textEditorClassname,
    ref: autoFocusAndSelect,
    value: row[column.key],
    onChange: event => onRowChange({ ...row,
      [column.key]: event.target.value
    }),
    onBlur: () => onClose(true)
  });
}


//# sourceMappingURL=bundle.js.map

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
;// CONCATENATED MODULE: ./src/mosanic/components/Empty/EmptyRows.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    width: 100%;\n    height: 100%;\n    min-height: 300px;\n    background: #fff;\n    ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    text-align: center;\n    \n    button {\n        margin: 0 auto;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43b1c697-0"
})(_templateObject(), flex_styles/* CenterCenter */.IV);
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43b1c697-1"
})(_templateObject1());
var EmptyRows = function(param) {
    var title = param.title, label = param.label, _plural = param.plural, plural = _plural === void 0 ? "entries" : _plural, _singular = param.singular, singular = _singular === void 0 ? "entry" : _singular, _createCallback = param.createCallback, createCallback = _createCallback === void 0 ? null : _createCallback;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        style: {
            textAlign: "center",
            gridColumn: "1/-1"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: title ? title : "No ".concat(plural, " found.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: label ? label : "Let's start with creating your first ".concat(singular, ".")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    onClick: function() {
                        return createCallback();
                    },
                    label: "Create",
                    size: "large"
                })
            ]
        })
    });
};
/* harmony default export */ var Empty_EmptyRows = (EmptyRows);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/core/Items/useItems.js
var useItems = __webpack_require__(5628);
// EXTERNAL MODULE: ./src/mosanic/fields/Editor/Text.js
var Text = __webpack_require__(50703);
// EXTERNAL MODULE: ./src/mosanic/fields/TextField/Fields.js
var Fields = __webpack_require__(91639);
// EXTERNAL MODULE: ./src/mosanic/fields/Checkbox/index.js
var Checkbox = __webpack_require__(51840);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/items/Link/index.js
var Link = __webpack_require__(8152);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Popper.js + 4 modules
var Popper = __webpack_require__(28932);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/HelpPopper.tsx
var HelpPopper = __webpack_require__(77586);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/mosanic/utils/Image.js
var Image = __webpack_require__(73987);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ./src/utils/Date.js
var utils_Date = __webpack_require__(99787);
// EXTERNAL MODULE: ./src/utils/Empty.js
var Empty = __webpack_require__(75276);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ./src/utils/Text.js
var utils_Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/mosanic/components/Media/MediaMultiUploader.js
var MediaMultiUploader = __webpack_require__(38812);
;// CONCATENATED MODULE: ./src/mosanic/cms/DataGrid/FilterHeader.js


var FilterHeader_useLayoutEffect =  false ? 0 : react.useLayoutEffect;
function FilterHeader_useFocusRef(isSelected) {
    var ref = (0,react.useRef)(null);
    FilterHeader_useLayoutEffect(function() {
        var ref1;
        if (!isSelected) return;
        (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.focus({
            preventScroll: true
        });
    }, [
        isSelected
    ]);
    return {
        ref: ref,
        tabIndex: isSelected ? 0 : -1
    };
}
function FilterRenderer(param) {
    var isCellSelected = param.isCellSelected, column = param.column, children = param.children;
    var filters = (0,react.useContext)(FilterContext);
    var ref = FilterHeader_useFocusRef(isCellSelected), ref1 = ref.ref, tabIndex = ref.tabIndex;
    return (filters === null || filters === void 0 ? void 0 : filters.enabled) ? children({
        ref: ref1,
        tabIndex: tabIndex,
        filters: filters
    }) : column.name;
}

;// CONCATENATED MODULE: ./src/mosanic/cms/DataGrid/Columns.js






function Columns_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    opacity: 0.4;\n    &:hover {\n        opacity: 1;\n    }\n    font-size: 12px!important;\n\n"
    ]);
    Columns_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




















var Unfocus = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-efa4129c-0"
})(Columns_templateObject());
var StatusOptions = (/* unused pure expression or super */ null && ([
    "PLANNED",
    "PUBLISHED",
    "PENDING",
    "DRAFT",
    "DISABLED",
    "EDITING",
    "HIDDEN",
    "LOCKED",
    "TRASHED", 
]));
var hasLocale = function(props, key, locale) {
    var ref, ref1, ref2;
    return (0,Obj/* isObject */.Kn)((ref = props.row) === null || ref === void 0 ? void 0 : ref[key]) && ((ref1 = props.row) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[key]) === null || ref2 === void 0 ? void 0 : ref2[locale]);
};
function inputStopPropagation(event) {
    if ([
        "ArrowLeft",
        "ArrowRight"
    ].includes(event.key)) {
        event.stopPropagation();
    }
}
function selectStopPropagation(event) {
    if ([
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown"
    ].includes(event.key)) {
        event.stopPropagation();
    }
}
var getLink = function(param) {
    var _basePath = param.basePath, basePath = _basePath === void 0 ? "collection" : _basePath, parent = param.parent, rowId = param.rowId;
    return parent ? "/".concat(basePath, "/").concat(parent, "/").concat(rowId, "?action=view") : "/".concat(basePath, "/").concat(rowId, "?action=view");
};
var getUrl = function(host, baseRoute, slug) {
    return (0,utils_Text/* combineString */.M7)([
        baseRoute && host,
        baseRoute,
        slug
    ], [
        "/"
    ]);
};
var bookingFields = function(param) {
    var collection = param.collection, host = param.host, handles = param.handles, routing = param.routing;
    return [
        {
            width: 40,
            minWidth: 100,
            resizable: false,
            frozen: true,
            name: "Status",
            formatter: function(props) {
                var ref, ref1, ref2, ref3;
                var status = props === null || props === void 0 ? void 0 : (ref = props.row) === null || ref === void 0 ? void 0 : (ref1 = ref.booking) === null || ref1 === void 0 ? void 0 : ref1.status;
                var color = status === "pending" ? "orange" : status === "accepted" ? "green" : status === "cancelled" ? "red" : status === "rejected" ? "red" : "gray";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                    bg: color,
                    fontWeight: 500,
                    as: "span",
                    style: {
                        textTransform: "uppercase",
                        fontSize: 12,
                        padding: "2px 6px",
                        borderRadius: 4,
                        color: "#fff",
                        backgroundColor: colors/* default */.ZP === null || colors/* default */.ZP === void 0 ? void 0 : (ref2 = colors/* default.util */.ZP.util) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[color]) === null || ref3 === void 0 ? void 0 : ref3.base
                    },
                    children: status
                });
            }
        }
    ];
};
var baseFields = function(param) {
    var collection = param.collection, host = param.host, handles = param.handles, routing = param.routing;
    return [
        {
            width: (handles === null || handles === void 0 ? void 0 : handles.viewOnly) ? 20 : 40,
            minWidth: (handles === null || handles === void 0 ? void 0 : handles.viewOnly) ? 20 : 65,
            resizable: false,
            frozen: true,
            formatter: function(props) {
                var ref;
                var link = getLink({
                    parent: (collection === null || collection === void 0 ? void 0 : collection._id) ? collection._id : routing === null || routing === void 0 ? void 0 : routing.singlePath,
                    rowId: props === null || props === void 0 ? void 0 : (ref = props.row) === null || ref === void 0 ? void 0 : ref._id,
                    basePath: routing === null || routing === void 0 ? void 0 : routing.basePath
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Buttons, {
                    mx: "-16px",
                    style: {
                        transform: "scale(0.9)",
                        transformOrigin: "top",
                        background: "#fff"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            tooltip: "Open collection",
                            href: (handles === null || handles === void 0 ? void 0 : handles.viewOnly) ? getUrl(host, collection === null || collection === void 0 ? void 0 : collection.baseRoute, props.row.slug) : link,
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowRightIcon */.LZ3, {}),
                            ghost: true,
                            width: 30,
                            p: 0
                        }),
                        (handles === null || handles === void 0 ? void 0 : handles.viewOnly) ? // <Button tooltip="Modal editor" icon={<SizeIcon/>} onClick={() => handles.edit(props?.row)} ghost/>
                        null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                            p: 0,
                            m: 0,
                            width: 40,
                            placement: "right",
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* DotsVerticalIcon */.AjK, {}),
                                width: 30,
                                p: 0,
                                ghost: true
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Buttons, {
                                children: [
                                    link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                        tooltip: "Open collection in new tab",
                                        href: link,
                                        target: "_blank",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ExternalLinkIcon */.h0n, {}),
                                        ghost: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                        tooltip: "Modal editor",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* Pencil1Icon */.JtS, {}),
                                        onClick: function() {
                                            return handles.edit(props === null || props === void 0 ? void 0 : props.row);
                                        },
                                        ghost: true
                                    }),
                                    (handles === null || handles === void 0 ? void 0 : handles.delete) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                        tooltip: "Delete",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TrashIcon */.XHJ, {}),
                                        ghost: true,
                                        onClick: function() {
                                            return handles === null || handles === void 0 ? void 0 : handles.delete({
                                                _id: props.row._id
                                            });
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        }
    ];
};
var infoFields = function(collection, host, handles, userNames, filters) {
    var base = [];
    var hasField = function(atr) {
        var ref, ref1;
        return ((ref1 = collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.filter(function(e) {
            return e === null || e === void 0 ? void 0 : e[atr];
        })) === null || ref1 === void 0 ? void 0 : ref1.length) >= 1;
    };
    if (hasField("slug") && !(handles === null || handles === void 0 ? void 0 : handles.viewOnly)) base = (0,_to_consumable_array/* default */.Z)(base).concat([
        {
            width: 40,
            minWidth: 90,
            resizable: false,
            name: "Slug",
            formatter: function(props) {
                var ref, ref1;
                return props.row.slug ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                    target: "_blank",
                    href: getUrl(host, (collection === null || collection === void 0 ? void 0 : (ref = collection.routing) === null || ref === void 0 ? void 0 : ref.baseRoute) ? collection === null || collection === void 0 ? void 0 : (ref1 = collection.routing) === null || ref1 === void 0 ? void 0 : ref1.baseRoute : collection === null || collection === void 0 ? void 0 : collection.baseRoute, props.row.slug),
                    children: props.row.slug
                }) : "";
            }
        }
    ]);
    // if(hasField('status')) base = [...base, {
    // width: 40,
    // minWidth: 70,
    //     resizable: false,
    //     name: 'Status',
    //     // frozen: true,
    //     formatter: (props) => (
    //         <ControlPopper trigger={<span style={{color: lighten(0.3, getPageStatusColor(props.row.status))}}>{props.row?.status}</span>} overflow p={0}>
    //             <Select options={StatusOptions} value={props.row?.status} label="Status" clearable={false}/>
    //         </ControlPopper>
    //     )
    // }]
    // if(hasField('userId')) base = [...base, {
    //     width: 40,
    //     minWidth: 70,
    //     resizable: true,
    //     name: 'Author',
    //     // frozen: true,
    //     formatter: (props) => (
    //         // <ControlPopper trigger={<span style={{color: lighten(0.3, getPageStatusColor(props.row.status))}}>{props.row?.status}</span>} overflow p={0}>
    //         <Link target="_blank" href={`/user/${props.row?.userId}`}>
    //             {userNames ? userNames?.find(user => user?.value === props.row?.userId)?.label : ''}
    //         </Link>
    //         // </ControlPopper>
    //     )
    // }]
    return (0,_to_consumable_array/* default */.Z)(base).concat([
        {
            width: 50,
            minWidth: 110,
            resizable: false,
            name: "Date",
            headerRenderer: function(p) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(FilterRenderer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                    children: function(_param) {
                        var filters = _param.filters, rest = (0,_object_without_properties/* default */.Z)(_param, [
                            "filters"
                        ]);
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Buttons.ToggleButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            ghost: true
                        }, rest), {
                            small: true,
                            label: "Date",
                            m: 0,
                            p: 0,
                            altLabel: "Date",
                            icon: !(0,Empty/* default */.Z)(filters === null || filters === void 0 ? void 0 : filters.date) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowDownIcon */.veu, {}) : null,
                            altIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowUpIcon */.Hf3, {}),
                            checked: filters === null || filters === void 0 ? void 0 : filters.date,
                            onClick: function() {
                                return handles === null || handles === void 0 ? void 0 : handles.setFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), {
                                    "date": !(filters === null || filters === void 0 ? void 0 : filters.date)
                                }));
                            }
                        }));
                    }
                }));
            },
            formatter: function(props) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(HelpPopper/* HelpPopper */.q, {
                    span: true,
                    trigger: ((ref = props.row) === null || ref === void 0 ? void 0 : ref.lastLogin) != props.row.date && (props === null || props === void 0 ? void 0 : (ref1 = props.row) === null || ref1 === void 0 ? void 0 : ref1.lastLogin) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* LockOpen1Icon */.Jot, {}),
                            "\xa0",
                            (0,utils_Date/* getDate */._3)(props.row.lastLogin)
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* CalendarIcon */.Que, {}),
                            "\xa0",
                            (0,utils_Date/* getDate */._3)(props.row.date)
                        ]
                    }),
                    helpText: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            ((ref2 = props.row) === null || ref2 === void 0 ? void 0 : ref2.registrationDate) != ((ref3 = props.row) === null || ref3 === void 0 ? void 0 : ref3.date) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* CalendarIcon */.Que, {}),
                                    "\xa0Published ",
                                    (0,utils_Date/* getDate */._3)(props.row.date)
                                ]
                            }),
                            ((ref4 = props.row) === null || ref4 === void 0 ? void 0 : ref4.updatedAt) != ((ref5 = props.row) === null || ref5 === void 0 ? void 0 : ref5.date) && ((ref6 = props.row) === null || ref6 === void 0 ? void 0 : ref6.updatedAt) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* CalendarIcon */.Que, {}),
                                    "\xa0Updated at: ",
                                    (0,utils_Date/* getDate */._3)(props.row.updatedAt)
                                ]
                            }),
                            ((ref7 = props.row) === null || ref7 === void 0 ? void 0 : ref7.registrationDate) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* CalendarIcon */.Que, {}),
                                    "\xa0Registered at: ",
                                    (0,utils_Date/* getDate */._3)(props.row.registrationDate)
                                ]
                            }),
                            ((ref8 = props.row) === null || ref8 === void 0 ? void 0 : ref8.lastLogin) != ((ref9 = props.row) === null || ref9 === void 0 ? void 0 : ref9.date) && ((ref10 = props.row) === null || ref10 === void 0 ? void 0 : ref10.lastLogin) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* LockOpen1Icon */.Jot, {}),
                                    "\xa0Last login: ",
                                    (0,utils_Date/* getDate */._3)(props.row.lastLogin)
                                ]
                            })
                        ]
                    })
                });
            }
        }
    ]);
};
var renderText = function(hasTranslation, value) {
    if (!value) return "";
    value = hasTranslation ? value.en : value;
    if (Array.isArray(value)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        content: value
    });
    if ((0,utils_Text/* isString */.HD)(value)) return value;
};
var isInThePast = function(date) {
    var now = new Date();
    var dateObj = new Date(date);
    return dateObj < now;
};
var baseFormatter = function(props, key, locale) {
    var ref, ref1, ref2, ref3;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: hasLocale(props, key, locale),
        wrapper: function(children) {
            var ref, ref1, ref2;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Popper/* default */.Z, {
                trigger: (ref = props.row) === null || ref === void 0 ? void 0 : (ref1 = ref[key]) === null || ref1 === void 0 ? void 0 : ref1[locale],
                title: "Languages",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                        label: (0,utils_Text/* capitalizeFirst */.Ez)("".concat(locale, " entry")),
                        as: "h4"
                    }),
                    children,
                    Object.keys((ref2 = props.row) === null || ref2 === void 0 ? void 0 : ref2[key]).filter(function(lang) {
                        return lang != locale;
                    }).map(function(lang) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                    label: (0,utils_Text/* capitalizeFirst */.Ez)("".concat(lang, " entry")),
                                    as: "h4"
                                }),
                                (ref = props.row) === null || ref === void 0 ? void 0 : (ref1 = ref[key]) === null || ref1 === void 0 ? void 0 : ref1[lang]
                            ]
                        }, lang);
                    })
                ]
            });
        },
        children: hasLocale(props, key, locale) ? (ref = props.row) === null || ref === void 0 ? void 0 : ref[key][locale] : Array.isArray((ref1 = props.row) === null || ref1 === void 0 ? void 0 : ref1[key]) ? "Array" : (0,utils_Text/* isString */.HD)((ref2 = props.row) === null || ref2 === void 0 ? void 0 : ref2[key]) ? (ref3 = props.row) === null || ref3 === void 0 ? void 0 : ref3[key] : "No data"
    });
};
var formatField = function(param) {
    var field = param.field, handles = param.handles, locale = param.locale, userNames = param.userNames, siteNames = param.siteNames, filters = param.filters, schema = param.schema;
    var key = (field === null || field === void 0 ? void 0 : field.slug) ? field.slug : field === null || field === void 0 ? void 0 : field.name;
    var value = function(props) {
        var ref;
        return (0,utils_Text/* containsSubstr */.xX)(key, ".") ? (0,Obj/* get */.U2)(props.row, key) : (ref = props.row) === null || ref === void 0 ? void 0 : ref[key];
    };
    var hasTranslation = function(props) {
        return (0,Obj/* hasAttr */.B$)(value(props), "en");
    };
    var base = {
        key: key,
        field: key,
        _id: field === null || field === void 0 ? void 0 : field.name,
        name: (field === null || field === void 0 ? void 0 : field.label) ? field.label : (0,utils_Text/* revertDevCases */.Uw)(field === null || field === void 0 ? void 0 : field.name),
        resizable: true,
        formatter: function(props) {
            return baseFormatter(props, key, locale);
        }
    };
    if ((base === null || base === void 0 ? void 0 : base.name) === "Global") {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
            editor: textEditor,
            formatter: function(props) {
                var ref, ref1;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("span", {
                    children: [
                        (ref = siteNames === null || siteNames === void 0 ? void 0 : siteNames.find(function(site) {
                            var ref;
                            return (site === null || site === void 0 ? void 0 : site._id) === ((ref = props.row) === null || ref === void 0 ? void 0 : ref[key]);
                        })) === null || ref === void 0 ? void 0 : ref.name,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                            style: {
                                fontSize: "12px",
                                opacity: 0.2
                            },
                            children: (ref1 = props.row) === null || ref1 === void 0 ? void 0 : ref1[key]
                        })
                    ]
                });
            }
        });
    }
    switch(field === null || field === void 0 ? void 0 : field.type){
        case "custom":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                formatter: function(props) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                        trigger: renderText(hasTranslation(props), value(props)),
                        children: (ref = value(props)) === null || ref === void 0 ? void 0 : ref.render
                    });
                }
            });
        case "group":
            var ref;
            var groupField = schema === null || schema === void 0 ? void 0 : schema.find(function(s) {
                return (s === null || s === void 0 ? void 0 : s.name) === (base === null || base === void 0 ? void 0 : base._id);
            });
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                width: groupField === null || groupField === void 0 ? void 0 : (ref = groupField.name) === null || ref === void 0 ? void 0 : ref.length,
                formatter: function(props) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                        width: "600px",
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            label: "expand",
                            ghost: true,
                            m: 0,
                            p: 0,
                            style: {
                                width: "100%",
                                color: "#888",
                                background: "none"
                            }
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InlineGroup */.a_, {
                            justify: "space-between",
                            children: (ref1 = groupField === null || groupField === void 0 ? void 0 : (ref = groupField.schema) === null || ref === void 0 ? void 0 : ref.filter(function(f) {
                                return f === null || f === void 0 ? void 0 : f.inColumns;
                            })) === null || ref1 === void 0 ? void 0 : ref1.map(function(field) {
                                var ref, ref1;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                                    as: "h4",
                                    label: (field === null || field === void 0 ? void 0 : field.label) ? field.label : (0,utils_Text/* revertDevCases */.Uw)(field === null || field === void 0 ? void 0 : field.name),
                                    value: (field === null || field === void 0 ? void 0 : field.type) === "date" ? (0,utils_Date/* getDate */._3)((ref = value(props)) === null || ref === void 0 ? void 0 : ref[field.name]) : (ref1 = value(props)) === null || ref1 === void 0 ? void 0 : ref1[field.name]
                                }, field === null || field === void 0 ? void 0 : field.name);
                            })
                        })
                    });
                }
            });
        case "text":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                editor: textEditor,
                formatter: function(props) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: (0,useItems/* getSearchMarkTitle */.RW)(hasTranslation(props) ? value(props).en : value(props), (filters === null || filters === void 0 ? void 0 : (ref = filters[key]) === null || ref === void 0 ? void 0 : ref.en) ? filters === null || filters === void 0 ? void 0 : (ref1 = filters[key]) === null || ref1 === void 0 ? void 0 : ref1.en : filters === null || filters === void 0 ? void 0 : filters[key])
                        }
                    });
                },
                headerRenderer: function(p) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(FilterRenderer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                        children: function(_param) {
                            var filters = _param.filters, rest = (0,_object_without_properties/* default */.Z)(_param, [
                                "filters"
                            ]);
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Fields.TextField, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                                small: true,
                                label: (0,utils_Text/* capitalizeFirst */.Ez)(key),
                                value: filters === null || filters === void 0 ? void 0 : filters[key],
                                onChange: function(e) {
                                    return handles === null || handles === void 0 ? void 0 : handles.setFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), (0,_define_property/* default */.Z)({}, key, e.target.value)));
                                },
                                onKeyDown: inputStopPropagation
                            }));
                        }
                    }));
                }
            });
        case "textarea":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                editor: textEditor,
                formatter: function(props) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: (0,useItems/* getSearchMarkTitle */.RW)(hasTranslation(props) ? value(props).en : value(props), (filters === null || filters === void 0 ? void 0 : (ref = filters[key]) === null || ref === void 0 ? void 0 : ref.en) ? filters === null || filters === void 0 ? void 0 : (ref1 = filters[key]) === null || ref1 === void 0 ? void 0 : ref1.en : filters === null || filters === void 0 ? void 0 : filters[key])
                        }
                    });
                },
                headerRenderer: function(p) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(FilterRenderer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                        children: function(_param) {
                            var filters = _param.filters, rest = (0,_object_without_properties/* default */.Z)(_param, [
                                "filters"
                            ]);
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Fields.TextField, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                                small: true,
                                label: (0,utils_Text/* capitalizeFirst */.Ez)(key),
                                value: filters === null || filters === void 0 ? void 0 : filters[key],
                                onChange: function(e) {
                                    return handles === null || handles === void 0 ? void 0 : handles.setFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), (0,_define_property/* default */.Z)({}, key, e.target.value)));
                                },
                                onKeyDown: inputStopPropagation
                            }));
                        }
                    }));
                }
            });
        case "visual":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                formatter: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                        trigger: renderText(hasTranslation(props), value(props)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                label: "Content preview",
                                mb: 5,
                                as: "h4"
                            }),
                            renderText(hasTranslation(props), value(props))
                        ]
                    });
                }
            });
        case "number":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                headerRenderer: function(p) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(FilterRenderer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                        children: function(_param) {
                            var filters = _param.filters, rest = (0,_object_without_properties/* default */.Z)(_param, [
                                "filters"
                            ]);
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                                    label: "Value",
                                    type: "checkbox",
                                    // className={filterClassname}
                                    value: filters === null || filters === void 0 ? void 0 : filters[field === null || field === void 0 ? void 0 : field.name],
                                    onChange: function(e) {
                                        return handles === null || handles === void 0 ? void 0 : handles.setFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), (0,_define_property/* default */.Z)({}, field === null || field === void 0 ? void 0 : field.name, !(filters === null || filters === void 0 ? void 0 : filters[field === null || field === void 0 ? void 0 : field.name]))));
                                    }
                                }))
                            });
                        }
                    }));
                },
                formatter: function(props) {
                    return value(props);
                }
            });
        case "date":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                formatter: function(props) {
                    return (0,utils_Date/* getDate */._3)(value(props)) ? isInThePast(value(props)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Unfocus, {
                        children: (0,utils_Date/* getDate */._3)(value(props))
                    }) : (0,utils_Date/* getDate */._3)(value(props)) : "unknown";
                }
            });
        case "repeater":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                formatter: function(props) {
                    var ref;
                    return "".concat(((ref = value(props)) === null || ref === void 0 ? void 0 : ref.length) ? value(props).length : 0, " entries");
                }
            });
        case "image":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                width: 40,
                headerRenderer: function(p) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(FilterRenderer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                        children: function(_param) {
                            var filters = _param.filters, rest = (0,_object_without_properties/* default */.Z)(_param, [
                                "filters"
                            ]);
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                                    type: "checkbox",
                                    // className={filterClassname}
                                    value: filters === null || filters === void 0 ? void 0 : filters[field === null || field === void 0 ? void 0 : field.name],
                                    onChange: function(e) {
                                        return handles === null || handles === void 0 ? void 0 : handles.setFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), (0,_define_property/* default */.Z)({}, field === null || field === void 0 ? void 0 : field.name, !(filters === null || filters === void 0 ? void 0 : filters[field === null || field === void 0 ? void 0 : field.name]))));
                                    }
                                }))
                            });
                        }
                    }));
                },
                formatter: function(props) {
                    return value(props) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            textAlign: "center",
                            cursor: "pointer"
                        },
                        onClick: function() {
                            var ref;
                            return handles.setImage({
                                src: (ref = (0,Image/* parseImageSrc */.yO)(value(props), true)) === null || ref === void 0 ? void 0 : ref.full
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            height: "35px",
                            width: "35px",
                            alt: "thumb",
                            src: (0,Image/* parseImageSrc */.yO)(value(props), true).thumb
                        })
                    }) : "No image set";
                }
            });
        case "gallery":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                width: 40,
                formatter: function(props) {
                    return value(props) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaMultiUploader["default"], {
                        imageUrls: value(props),
                        type: "image",
                        callback: null,
                        label: "Gallery preview"
                    }) : "0 uploaded";
                }
            });
        case "user":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                // width: 80,
                formatter: function(props) {
                    var user = userNames === null || userNames === void 0 ? void 0 : userNames.find(function(user) {
                        return (user === null || user === void 0 ? void 0 : user.value) === value(props);
                    });
                    return (user === null || user === void 0 ? void 0 : user.current) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                        href: "/account",
                        style: {
                            opacity: 0.2
                        },
                        children: " you "
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                        target: "_blank",
                        href: "/account/".concat(value(props)),
                        children: userNames ? user === null || user === void 0 ? void 0 : user.label : ""
                    });
                }
            });
        case "email":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                formatter: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                        href: "mailto:".concat(value(props)),
                        children: value(props)
                    });
                }
            });
        default:
            return (0,_object_spread/* default */.Z)({}, base);
            break;
    }
};
var initColumns = function(param) {
    var collection = param.collection, handles = param.handles, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale, siteNames = param.siteNames, userNames = param.userNames, filters = param.filters, _host = param.host, host = _host === void 0 ? null : _host, props = param.props;
    var ref;
    if (!(collection === null || collection === void 0 ? void 0 : (ref = collection.schema) === null || ref === void 0 ? void 0 : ref.length) || !Array.isArray(collection === null || collection === void 0 ? void 0 : collection.entries)) return [];
    // todo --> make these able to render later
    var display = function(f) {
        return !"repeat|relation|location|label".split("|").includes(f === null || f === void 0 ? void 0 : f.type);
    };
    var isBooking = (collection === null || collection === void 0 ? void 0 : collection._id) === "6401045f800fef330f4f4c04";
    // const hasField = atr =>  true
    var hasField = function(atr) {
        var ref, ref1;
        return ((ref1 = collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.filter(function(e) {
            return (0,utils_Text/* containsSubstr */.xX)(atr, ".") ? (0,Obj/* get */.U2)(e, atr, null) : e === null || e === void 0 ? void 0 : e[atr];
        })) === null || ref1 === void 0 ? void 0 : ref1.length) >= 1;
    };
    var fields = collection.schema.filter(function(f) {
        return display(f);
    }).filter(function(f) {
        return (f === null || f === void 0 ? void 0 : f.name) != "booking";
    }).filter(function(f) {
        var ref;
        return (collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.length) >= 1 ? hasField((f === null || f === void 0 ? void 0 : f.slug) ? f.slug : f === null || f === void 0 ? void 0 : f.name) : f;
    });
    //  .filter //todo --> add 'schema' column 'fields' selector/ hider
    if (isBooking) {
        var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        fields = (0,_to_consumable_array/* default */.Z)(fields).concat((0,_to_consumable_array/* default */.Z)((ref4 = (ref2 = collection === null || collection === void 0 ? void 0 : (ref1 = collection.schema) === null || ref1 === void 0 ? void 0 : ref1.find(function(f) {
            return (f === null || f === void 0 ? void 0 : f.name) === "booking";
        })) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.schema) === null || ref3 === void 0 ? void 0 : ref3.filter(function(f) {
            return [
                "days",
                "persons",
                "rooms",
                "amount"
            ].includes(f === null || f === void 0 ? void 0 : f.name);
        })) === null || ref4 === void 0 ? void 0 : ref4.map(function(f) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), {
                slug: "booking.".concat(f === null || f === void 0 ? void 0 : f.name)
            });
        })), (0,_to_consumable_array/* default */.Z)((ref8 = (ref6 = collection === null || collection === void 0 ? void 0 : (ref5 = collection.schema) === null || ref5 === void 0 ? void 0 : ref5.find(function(f) {
            return (f === null || f === void 0 ? void 0 : f.name) === "booking";
        })) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.schema) === null || ref7 === void 0 ? void 0 : ref7.filter(function(f) {
            return [
                "arrival_date",
                "departure_date"
            ].includes(f === null || f === void 0 ? void 0 : f.name);
        })) === null || ref8 === void 0 ? void 0 : ref8.map(function(f) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), {
                slug: "booking.".concat(f === null || f === void 0 ? void 0 : f.name)
            });
        })));
        console.log();
    }
    var columns = // SelectColumn,
    (0,_to_consumable_array/* default */.Z)(baseFields({
        collection: collection,
        host: host,
        handles: handles,
        routing: props === null || props === void 0 ? void 0 : props.routing
    })).concat((0,_to_consumable_array/* default */.Z)(fields.map(function(field) {
        return formatField({
            field: field,
            handles: handles,
            locale: locale,
            siteNames: siteNames,
            userNames: userNames,
            filters: filters,
            schema: collection === null || collection === void 0 ? void 0 : collection.schema
        });
    })), (0,_to_consumable_array/* default */.Z)(infoFields(collection, host, handles, userNames, filters)));
    // ? temp add bookings status to columns
    return isBooking ? [
        columns[0], 
    ].concat((0,_to_consumable_array/* default */.Z)(bookingFields({
        collection: collection,
        host: host,
        handles: handles,
        routing: props === null || props === void 0 ? void 0 : props.routing
    })), (0,_to_consumable_array/* default */.Z)(columns.slice(2, columns.length - 1))) : columns;
};

// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/mosanic/core/Provider/DataProviders.js
var DataProviders = __webpack_require__(42622);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
// EXTERNAL MODULE: ./src/mosanic/utils/Site.js
var Site = __webpack_require__(95048);
;// CONCATENATED MODULE: ./src/mosanic/cms/DataGrid/DataGrid.js




function DataGrid_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    height: 100%;\n    min-height: 100px;\n    position: relative;\n"
    ]);
    DataGrid_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DataGrid_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    position: absolute;\n    top: 0;\n    bottom: 30px;\n    left: 0;\n    right: 0;\n    z-index: 3;\n    background: rgba(255,255,255, 0.2);\n    backdrop-filter: blur(2px);\n    ",
        "\n"
    ]);
    DataGrid_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






















var ImgsViewer = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 26689));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26689)
            ];
        }
    }
});
var DataGridWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e2114dd-0"
})(DataGrid_templateObject());
var FilterContext = /*#__PURE__*/ (0,react.createContext)(undefined);
function rowKeyGetter(row) {
    return row === null || row === void 0 ? void 0 : row._id;
}
var Center = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e2114dd-1"
})(DataGrid_templateObject1(), flex_styles/* CenterCenter */.IV);
var DataGrid_DataGrid = function(param) {
    var collection = param.collection, handles = param.handles, state = param.state, deleteResponse = param.deleteResponse, _pagination = param.pagination, pagination = _pagination === void 0 ? null : _pagination, _loading = param.loading, loading = _loading === void 0 ? null : _loading, _props = param.props, props = _props === void 0 ? null : _props, _domain = param.domain, domain = _domain === void 0 ? null : _domain;
    var ref;
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    var userId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetSite */.iu)({
        _id: siteId
    }), 1), site = ref1[0];
    // const customDomain = site?.customDomain
    var customDomain = (0,Site/* getSiteUrl */.$2)(site);
    var locale = (0,useLocale/* useCurrentLocale */.eV)();
    var siteNames = [] //useSiteNames()
    ;
    var users = (0,DataProviders/* useDataProvider */.x5)().users;
    var userNames = (0,react.useMemo)(function() {
        return users === null || users === void 0 ? void 0 : users.map(function(u) {
            return (u === null || u === void 0 ? void 0 : u.value) === userId ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, u), {
                current: true
            }) : u;
        });
    }, [
        userId,
        users
    ]) // useListUsers({siteId})
    ;
    // const [filters, setFilters] = useState({
    //     task: '',
    //     priority: 'Critical',
    //     issueType: 'All',
    //     developer: '',
    //     complete: undefined,
    //     enabled: false
    // });
    // const setFilter = (filter) => setFilters({...filters, ...filter})
    var ref2 = (0,react.useState)(null), img = ref2[0], setImage = ref2[1];
    var initializeColumns = function() {
        return initColumns({
            userNames: userNames,
            collection: collection,
            handles: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, handles), {
                setImage: setImage
            }),
            filters: state === null || state === void 0 ? void 0 : state.filters,
            locale: locale,
            siteNames: siteNames,
            host: domain ? domain : customDomain ? "https://".concat(customDomain) : "",
            props: props
        });
    };
    var ref3 = (0,react.useState)(Array.isArray(collection === null || collection === void 0 ? void 0 : collection.entries) ? collection === null || collection === void 0 ? void 0 : collection.entries : []), rows = ref3[0], setRows = ref3[1];
    var ref4 = (0,react.useState)(initializeColumns()), columns = ref4[0], setColumns = ref4[1];
    var ref5 = (0,react.useState)(function() {
        return new Set();
    }), selectedRows = ref5[0], setSelectedRows = ref5[1];
    var filteredRows = (0,react.useMemo)(function() {
        return rows;
    // if(!state?.filters?.enabled || !rows) return rows;
    // const filters = {...state?.filters, enabled: undefined};
    // let filtered = rows;
    // Object.entries(filters).map(([key, value]) => {
    //     if(isBoolean(value) && value) filtered = filtered.filter(r => !isEmpty(r?.[key]))
    //     if(isString(value) && value?.length >= 1) filtered = filtered.filter(r => substrSearch(r?.[key], value))
    //     if(key === 'date') filtered = filtered.filter(r => substrSearch(r?.[key], value))
    // })
    // return filtered;
    }, [
        rows,
        state === null || state === void 0 ? void 0 : state.filters,
        state === null || state === void 0 ? void 0 : state.order
    ]);
    // filteredRows = Array.isArray(filteredRows) && filteredRows?.length >= 2 ? filteredRows?.sort((a,b) => state?.order === 'desc'? 
    //     new Date(b?.date) - new Date(a?.date) : 
    //     new Date(a?.date) - new Date(b?.date)
    // ) : filteredRows;
    (0,react.useEffect)(function() {
        if (collection) {
            setColumns(initializeColumns());
            setTimeout(function() {
                setRows(Array.isArray(collection === null || collection === void 0 ? void 0 : collection.entries) ? collection === null || collection === void 0 ? void 0 : collection.entries : []);
            }, 100);
        }
    }, [
        collection,
        handles,
        locale,
        userNames,
        customDomain,
        domain
    ]);
    //Handle remove deleted
    (0,react.useEffect)(function() {
        if (deleteResponse === null || deleteResponse === void 0 ? void 0 : deleteResponse.recordId) setRows(function(r) {
            return r.filter(function(x) {
                return x._id != (deleteResponse === null || deleteResponse === void 0 ? void 0 : deleteResponse.recordId);
            });
        });
    }, [
        deleteResponse === null || deleteResponse === void 0 ? void 0 : deleteResponse.recordId
    ]);
    return rows ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataGridWrapper, {
        children: [
            img && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgsViewer, {
                imgs: [
                    img
                ],
                spinner: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {});
                },
                currImg: 0,
                isOpen: img,
                // onClickPrev={() => setIndex(index - 1)}
                // onClickNext={() => setIndex(index + 1)}
                onClose: function() {
                    return setImage(null);
                },
                backdropCloseable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterContext.Provider, {
                value: state === null || state === void 0 ? void 0 : state.filters,
                children: [
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Center, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataGrid$1, {
                        className: "rdg-light ".concat((state === null || state === void 0 ? void 0 : (ref = state.filters) === null || ref === void 0 ? void 0 : ref.enabled) ? "-filters" : ""),
                        components: {
                            noRowsFallback: function() {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    children: "no rows"
                                });
                            }
                        },
                        rowKeyGetter: rowKeyGetter,
                        selectedRows: selectedRows,
                        onSelectedRowsChange: setSelectedRows,
                        columns: columns,
                        rows: filteredRows,
                        // headerRowHeight={state?.filters.enabled ? 70 : undefined}
                        // rows={rows} 
                        rowGetter: function(i) {
                            return filteredRows[i];
                        },
                        onRowsChange: setRows,
                        style: {
                            background: "transparent",
                            border: "none",
                            height: "100%"
                        }
                    }),
                    !loading && (filteredRows === null || filteredRows === void 0 ? void 0 : filteredRows.length) <= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Empty_EmptyRows, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        plural: (collection === null || collection === void 0 ? void 0 : collection.title) ? collection.title : "entries",
                        singular: (collection === null || collection === void 0 ? void 0 : collection.singular) ? collection.singular : "entry"
                    }, props), {
                        createCallback: handles === null || handles === void 0 ? void 0 : handles.open
                    })),
                    pagination && (filteredRows === null || filteredRows === void 0 ? void 0 : filteredRows.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, (0,_object_spread/* default */.Z)({
                        type: "table"
                    }, pagination))
                ]
            })
        ]
    }) : null;
};


/***/ }),

/***/ 97949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LJ": function() { return /* binding */ useCollectionsDataGrid; },
/* harmony export */   "PQ": function() { return /* binding */ useMailsDataGrid; },
/* harmony export */   "Rb": function() { return /* binding */ useCollectionDataGrid; },
/* harmony export */   "og": function() { return /* binding */ useUsersDataGrid; },
/* harmony export */   "pk": function() { return /* binding */ useCollectionUserDataGrid; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26297);
/* harmony import */ var _api_schemas__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81841);
/* harmony import */ var _Query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43551);
/* harmony import */ var _Query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62357);
/* harmony import */ var _useMosanicData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62336);
/* harmony import */ var _Query_useDataQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49974);
/* harmony import */ var _Mutate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39761);
/* harmony import */ var _Query_pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59832);
/* harmony import */ var _Query_count__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88574);












var useUsersDataGrid = function(param) {
    var _defaultType = param.defaultType, defaultType = _defaultType === void 0 ? "all" : _defaultType, _all = param.all, all = _all === void 0 ? false : _all, props = param.props, columns = param.columns, formatter = param.formatter;
    return (0,_useMosanicData__WEBPACK_IMPORTED_MODULE_0__/* .useDirectDataGrid */ .VJ)({
        hookResponse: (0,_Query__WEBPACK_IMPORTED_MODULE_1__/* .useGetUsers */ .w4)({
            current: true
        }),
        defaultType: defaultType,
        dataHookMethods: _Mutate__WEBPACK_IMPORTED_MODULE_2__/* .userHooks */ .iv,
        entryTypePath: "role",
        headerSchema: columns,
        entryFormatter: formatter,
        props: props,
        title: "users",
        singular: "site's user",
        config: {
            dialog: "xs"
        }
    });
};
var useCollectionDataGrid = function(param) {
    var _id = param._id;
    return (0,_useMosanicData__WEBPACK_IMPORTED_MODULE_0__/* .useLinkedDataGrid */ .$R)({
        hookResponse: (0,_Query__WEBPACK_IMPORTED_MODULE_3__/* .useGetCollection */ .YD)({
            _id: _id
        }),
        dataHookMethods: _Mutate__WEBPACK_IMPORTED_MODULE_2__/* .collectionHooks */ .Bg,
        filtering: false,
        entriesPointer: "entries",
        entriesReceiverParams: {
            filter: {
                collectionId: _id
            },
            sort: "_ID_DESC"
        },
        useEntriesReceiver: _Query_pagination__WEBPACK_IMPORTED_MODULE_4__/* .useGetEntriesPage */ .$,
        entryHookMethods: _Mutate__WEBPACK_IMPORTED_MODULE_2__/* .entryHooks */ .tf,
        entryCount: (0,_Query_count__WEBPACK_IMPORTED_MODULE_5__/* .useGetEntryCount */ .p)({
            _id: _id
        }),
        // useGetEntriesPage,
        // useEntryUpdater: params => use
        entryFormatter: function(e) {
            return (0,_Query_useDataQuery__WEBPACK_IMPORTED_MODULE_6__/* .convertEntry */ .ec)(e);
        }
    });
};
var useCollectionUserDataGrid = function(_param) {
    var _id = _param._id, userId = _param.userId, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "_id",
        "userId"
    ]);
    return (0,_useMosanicData__WEBPACK_IMPORTED_MODULE_0__/* .useLinkedDataGrid */ .$R)({
        hookResponse: (0,_Query__WEBPACK_IMPORTED_MODULE_3__/* .useGetCollection */ .YD)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            _id: _id,
            silent: true
        }, other)),
        dataHookMethods: _Mutate__WEBPACK_IMPORTED_MODULE_2__/* .collectionHooks */ .Bg,
        filtering: false,
        entriesPointer: "entries",
        entriesReceiverParams: {
            filter: {
                OR: [
                    {
                        collectionId: _id,
                        userId: userId
                    },
                    {
                        collectionId: _id,
                        queryId: userId
                    }, 
                ]
            },
            sort: "_ID_DESC"
        },
        useEntriesReceiver: _Query_pagination__WEBPACK_IMPORTED_MODULE_4__/* .useGetEntriesPage */ .$,
        entryHookMethods: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, _Mutate__WEBPACK_IMPORTED_MODULE_2__/* .entryHooks */ .tf), {
            silent: true,
            update: undefined
        }),
        entryCount: (0,_Query_count__WEBPACK_IMPORTED_MODULE_5__/* .useGetEntryCount */ .p)({
            collectionId: _id,
            filter: {
                userId: userId
            }
        }),
        // useGetEntriesPage,
        // useEntryUpdater: params => use
        entryFormatter: function(e) {
            return (0,_Query_useDataQuery__WEBPACK_IMPORTED_MODULE_6__/* .convertEntry */ .ec)(e);
        }
    });
};
var useCollectionsDataGrid = function(param) {
    var _defaultType = param.defaultType, defaultType = _defaultType === void 0 ? "all" : _defaultType, props = param.props, columns = param.columns, formatter = param.formatter;
    return (0,_useMosanicData__WEBPACK_IMPORTED_MODULE_0__/* .useDirectDataGrid */ .VJ)({
        hookResponse: (0,_Query__WEBPACK_IMPORTED_MODULE_1__/* .useGetCollections */ .t8)({
            current: true
        }),
        dataHookMethods: _Mutate__WEBPACK_IMPORTED_MODULE_2__/* .collectionHooks */ .Bg,
        defaultType: defaultType,
        entryHookMethods: _Mutate__WEBPACK_IMPORTED_MODULE_2__/* .entryHooks */ .tf,
        headerSchema: columns,
        entryFormatter: formatter
    });
};
var useMailsDataGrid = function(param) {
    var _defaultType = param.defaultType, defaultType = _defaultType === void 0 ? "all" : _defaultType;
    return (0,_useMosanicData__WEBPACK_IMPORTED_MODULE_0__/* .useDirectDataGrid */ .VJ)({
        hookResponse: (0,_Query__WEBPACK_IMPORTED_MODULE_1__/* .useGetMails */ .fY)({
            current: true
        }),
        dataHookMethods: _Mutate__WEBPACK_IMPORTED_MODULE_2__/* .mailHooks */ .c4,
        defaultType: defaultType,
        headerSchema: _api_schemas__WEBPACK_IMPORTED_MODULE_10__/* .mailColumns */ .D,
        entryFormatter: function(c) {
            var ref, ref1, ref2, ref3, ref4;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, c), {
                Fields: c === null || c === void 0 ? void 0 : (ref = c.schema) === null || ref === void 0 ? void 0 : (ref1 = ref.length) === null || ref1 === void 0 ? void 0 : ref1.toString(),
                Entries: (c === null || c === void 0 ? void 0 : (ref2 = c.entries) === null || ref2 === void 0 ? void 0 : ref2.length) ? c === null || c === void 0 ? void 0 : (ref3 = c.entries) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.length) === null || ref4 === void 0 ? void 0 : ref4.toString() : "0"
            });
        }
    });
};


/***/ }),

/***/ 62336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VJ": function() { return /* binding */ useDirectDataGrid; },
  "$R": function() { return /* binding */ useLinkedDataGrid; },
  "af": function() { return /* binding */ usePaginateDataGrid; }
});

// UNUSED EXPORTS: useMosanicDataGrid

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(68875);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/fields/Select/Select.js + 3 modules
var Select = __webpack_require__(26074);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/utils/Funct.js
var Funct = __webpack_require__(3847);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/mosanic/cms/Pagination/usePagination.js
var usePagination = __webpack_require__(21067);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
;// CONCATENATED MODULE: ./src/mosanic/cms/DataGrid/useDataGrid.js








var defaultInfo = {
    singular: "collection",
    plural: "collection"
};
var useDataGridState = function(param) {
    var info = param.info;
    var ref = (0,react.useState)({
        deleteItem: null,
        item: null,
        modal: false,
        sidebar: false,
        filters: {
            enabled: false
        },
        order: "desc",
        info: info
    }), data = ref[0], setState = ref[1];
    //Append dialog state
    var state = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        action: (data === null || data === void 0 ? void 0 : data.item) ? "update" : "create"
    });
    return {
        state: state,
        setState: setState
    };
};
var useDataGridActions = function(param) {
    var state = param.state, setState = param.setState, refresh = param.refresh;
    var setFilters = function(filters) {
        return setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            filters: (0,_object_spread/* default */.Z)({}, state.filters, filters)
        }));
    };
    var actions = {
        close: function() {
            var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "modal";
            var _obj;
            return setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (_obj = {}, (0,_define_property/* default */.Z)(_obj, type, false), (0,_define_property/* default */.Z)(_obj, "item", null), _obj)));
        },
        open: function() {
            var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "modal";
            var _obj;
            return setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (_obj = {}, (0,_define_property/* default */.Z)(_obj, type, true), (0,_define_property/* default */.Z)(_obj, "item", null), _obj)));
        },
        edit: function(item) {
            var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "modal";
            return setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({
                item: item
            }, type, true)));
        },
        delete: function(deleteItem) {
            return setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                deleteItem: deleteItem
            }));
        },
        toggleFilters: function() {
            var ref;
            return setFilters({
                enabled: !(state === null || state === void 0 ? void 0 : (ref = state.filters) === null || ref === void 0 ? void 0 : ref.enabled)
            });
        },
        setFilters: setFilters,
        setState: setState,
        refresh: refresh
    };
    return actions;
};
var DataDialog = function(_param) {
    var state = _param.state, actions = _param.actions, children = _param.children, _level = _param.level, level = _level === void 0 ? 2 : _level, other = (0,_object_without_properties/* default */.Z)(_param, [
        "state",
        "actions",
        "children",
        "level"
    ]);
    return children ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        titleSize: level,
        state: (state === null || state === void 0 ? void 0 : state.modal) || (state === null || state === void 0 ? void 0 : state.item),
        close: function() {
            return actions.close();
        },
        children: children
    })) : null;
};
var useDataGrid = function(param) {
    var items = param.items, _info = param.info, info = _info === void 0 ? defaultInfo : _info, _refresh = param.refresh, refresh = _refresh === void 0 ? function() {
        return null;
    } : _refresh, _count = param.count, count = _count === void 0 ? null : _count, _level = param.level, level = _level === void 0 ? 2 : _level;
    var ref;
    var ref1 = useDataGridState({
        info: info
    }), state = ref1.state, setState = ref1.setState;
    var actions = useDataGridActions({
        state: state,
        setState: setState,
        refresh: refresh
    });
    var ref2 = (0,react.useState)((items === null || items === void 0 ? void 0 : items.length) > 10 || !items ? "10" : items === null || items === void 0 ? void 0 : (ref = items.length) === null || ref === void 0 ? void 0 : ref.toString()), limit = ref2[0], setLimit = ref2[1];
    var pagination = (0,usePagination/* usePagination */.h0)({
        data: items,
        limit: parseFloat(limit),
        count: count
    });
    var Dialog = function(param) {
        var props = param.props, children = param.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DataDialog, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            state: state,
            actions: actions,
            level: level
        }, props), {
            children: children
        }));
    };
    var data = {
        items: pagination.items,
        limiter: {
            limit: limit,
            setLimit: setLimit,
            count: count ? count : items === null || items === void 0 ? void 0 : items.length
        },
        pagination: pagination,
        actions: actions,
        state: state,
        Dialog: Dialog
    };
    return data;
};

// EXTERNAL MODULE: ./src/utils/Num.js
var Num = __webpack_require__(3121);
// EXTERNAL MODULE: ./src/mosanic/components/Team/roles.js
var roles = __webpack_require__(36563);
;// CONCATENATED MODULE: ./src/mosanic/cms/DataGrid/useMosanicData.js















var useTypeFilter = function(param) {
    var data = param.data, entryTypePath = param.entryTypePath, defaultType = param.defaultType, filtering = param.filtering;
    var ref = (0,react.useState)(defaultType), filter = ref[0], setFilter = ref[1];
    if (!Array.isArray(data) || !filtering) return [];
    //Flat map of possible types
    var options = [
        "all"
    ].concat((0,_to_consumable_array/* default */.Z)(new Set(data === null || data === void 0 ? void 0 : data.map(function(entry) {
        return (0,Obj/* get */.U2)(entry, entryTypePath, undefined);
    }))));
    var shouldFilter = Boolean(Array.isArray(options) && (options === null || options === void 0 ? void 0 : options.length) > 2 && filtering);
    var set = function(o, cb) {
        setFilter(o);
        if ((0,Funct/* isFunc */.W)(cb)) cb();
    };
    if ((options === null || options === void 0 ? void 0 : options.length) >= 1) options = options.map(function(value) {
        var ref;
        return {
            value: value,
            label: ((ref = (0,roles/* getRole */.cY)(value)) === null || ref === void 0 ? void 0 : ref.label) ? (0,roles/* getRole */.cY)(value).label : (0,Text/* capitalizeFirst */.Ez)(value)
        };
    });
    var Selector = function(param) {
        var cb = param.cb;
        return !shouldFilter ? function(_$param) {
            var _$param = _$param !== null ? _$param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
            return null;
        } : (options === null || options === void 0 ? void 0 : options.length) > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Select.Select, {
            container: {
                border: "none"
            },
            clearable: false,
            minWidth: "100px",
            label: "Type",
            options: options,
            value: filter,
            onChange: function(o) {
                return set(o, cb);
            }
        }) : options.map(function(o) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                active: filter === o.value,
                onClick: function() {
                    return set(o.value, cb);
                },
                label: o.label
            }, o.value);
        });
    };
    return [
        filter,
        Selector,
        options
    ];
};
/**
 * #### Data receiver 
 * @param {array} hookResponse [data, loading, error, cb] > full response from query hook
 * 
 * @param {string|boolean} entriesPointer path to entries, defaults to false, since a array of entries can be received
 * 
 * #### Formatting
 * @param {array} headerSchema [{name, slug, type}] > for data grid header rendering
 * @param {function} entryFormatter receives entry to parse into header schema slug setup.
 * 
 * #### Filtering
 * @param {boolean} filtering filtering enabled > default = true
 * @param {string} entryTypePath path.to.type > pointer to string_value within a entry for filtering
 * @param {string} defaultType defaultType > default filter + 'all' listing
 */ var useMosanicDataGrid = function(_param) {
    var hookResponse = _param.hookResponse, _dataHookMethods = _param.dataHookMethods, dataHookMethods = _dataHookMethods === void 0 ? null : _dataHookMethods, _countResponse = _param.countResponse, countResponse = _countResponse === void 0 ? undefined : _countResponse, props = _param.props, _entriesPointer = _param.entriesPointer, entriesPointer = _entriesPointer === void 0 ? false : _entriesPointer, _entryHookMethods = _param.entryHookMethods, entryHookMethods = _entryHookMethods === void 0 ? null : _entryHookMethods, _useEntriesReceiver = _param.useEntriesReceiver, useEntriesReceiver = _useEntriesReceiver === void 0 ? function(param) {
        var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
        return [];
    } : _useEntriesReceiver, _entriesReceiverParams = _param.// useGetEntriesPage =  ({}) => [],
    entriesReceiverParams, entriesReceiverParams = _entriesReceiverParams === void 0 ? null : _entriesReceiverParams, _entryCount = _param.entryCount, entryCount = _entryCount === void 0 ? [
        null,
        false,
        null,
        function() {
            return null;
        }
    ] : _entryCount, _headerSchema = _param.headerSchema, headerSchema = _headerSchema === void 0 ? null : _headerSchema, _entryFormatter = _param.entryFormatter, entryFormatter = _entryFormatter === void 0 ? function(e) {
        return e;
    } : _entryFormatter, _entryTypePath = _param.entryTypePath, entryTypePath = _entryTypePath === void 0 ? "type" : _entryTypePath, _defaultType = _param.defaultType, defaultType = _defaultType === void 0 ? "all" : _defaultType, _filtering = _param.filtering, filtering = _filtering === void 0 ? true : _filtering, _config = _param.config, config = _config === void 0 ? {} : _config, _level = _param.level, level = _level === void 0 ? 2 : _level, other = (0,_object_without_properties/* default */.Z)(_param, [
        "hookResponse",
        "dataHookMethods",
        "countResponse",
        "props",
        "entriesPointer",
        "entryHookMethods",
        "useEntriesReceiver",
        "entriesReceiverParams",
        "entryCount",
        "headerSchema",
        "entryFormatter",
        "entryTypePath",
        "defaultType",
        "filtering",
        "config",
        "level"
    ]);
    var ref;
    //Split hook response
    var ref1 = (0,_sliced_to_array/* default */.Z)(hookResponse || countResponse, 4), data = ref1[0], loading = ref1[1], error = ref1[2], refreshData = ref1[3];
    var ref2 = (0,_sliced_to_array/* default */.Z)(entryCount || countResponse, 4), dataCount = ref2[0], loadingC = ref2[1], errorC = ref2[2], refreshDataC = ref2[3];
    var count = (0,Num/* isNumber */.hj)(dataCount) ? dataCount : (0,Num/* isNumber */.hj)(data) ? data : null;
    var hasCountPointer = ((0,Num/* isNumber */.hj)(data) || (0,Num/* isNumber */.hj)(dataCount)) && count >= 1;
    //Check if response data has schema in it (for direct data grids)
    var schema = !headerSchema && !Array.isArray(data) && (data === null || data === void 0 ? void 0 : data.schema) ? data.schema : headerSchema;
    //Get type and filter selector options
    var ref3 = (0,_sliced_to_array/* default */.Z)(useTypeFilter({
        data: data,
        entryTypePath: entryTypePath,
        defaultType: defaultType,
        filtering: filtering
    }), 3), type = ref3[0], Selector = ref3[1], options = ref3[2];
    //Pre define filter function
    var canFilterItems = type != "all" && filtering && Array.isArray(data);
    var filterData = function(dataArray) {
        return dataArray === null || dataArray === void 0 ? void 0 : dataArray.filter(function(entry) {
            return (0,Obj/* get */.U2)(entry, entryTypePath, null) === type || !(0,Obj/* get */.U2)(entry, entryTypePath);
        });
    };
    //Retrieve pointed entries if defined else filter if data is received as an array 
    var filteredItems = hasCountPointer ? undefined : entriesPointer ? (0,Obj/* get */.U2)(data, entriesPointer) : canFilterItems ? filterData(data) : data;
    //Create the data grid
    var ref4 = useDataGrid({
        refresh: function() {
            return refreshData();
        },
        items: filteredItems,
        count: count,
        level: level
    }), items = ref4.items, limiter = ref4.limiter, pagination = ref4.pagination, actions = ref4.actions, state = ref4.state, Dialog = ref4.Dialog;
    var hasItems = (items === null || items === void 0 ? void 0 : items.length) >= 1;
    var shouldRetrieveEntries = Boolean(entriesPointer && (0,Text/* isString */.HD)(items === null || items === void 0 ? void 0 : items[0]) && (0,Funct/* isFunc */.W)(useEntriesReceiver)) || !(data === null || data === void 0 ? void 0 : (ref = data.config) === null || ref === void 0 ? void 0 : ref.notLinked) && !hasItems;
    // console.log({
    //     boolean: (entriesPointer &&
    //     isString(items?.[0]) &&
    //     isFunc(useEntriesReceiver)
    //     ) || (!data?.config?.notLinked && !hasItems),
    //         entriesPointer,
    //         config: data?.config ,
    //         hasItems ,
    //         items
    // })
    //Convert entries receiver to pagination props
    if (hasCountPointer) {
        var ref5;
        entriesReceiverParams = (0,_object_spread/* default */.Z)({
            perPage: (limiter === null || limiter === void 0 ? void 0 : limiter.limit) ? parseFloat(limiter === null || limiter === void 0 ? void 0 : limiter.limit) : 10,
            page: parseFloat(pagination === null || pagination === void 0 ? void 0 : (ref5 = pagination.validate) === null || ref5 === void 0 ? void 0 : ref5.currentPage)
        }, entriesReceiverParams);
    }
    // todo ---> change all of these to 'pagination' 
    var ref6 = (0,_sliced_to_array/* default */.Z)(useEntriesReceiver((0,_object_spread/* default */.Z)({
        _ids: hasCountPointer ? undefined : shouldRetrieveEntries && hasItems ? items === null || items === void 0 ? void 0 : items.map(function(_id) {
            return {
                _id: _id
            };
        }) : undefined
    }, !items && (data === null || data === void 0 ? void 0 : data._id) && !hasItems && !hasCountPointer ? {
        collectionId: data._id
    } : {}, entriesReceiverParams)), 3), _entries = ref6[0], _loading = ref6[1], _error = ref6[2];
    var entries = shouldRetrieveEntries || hasCountPointer ? _entries : items;
    return {
        limiter: limiter,
        pagination: pagination,
        actions: actions,
        state: state,
        dataHookMethods: dataHookMethods,
        entryHookMethods: entryHookMethods,
        data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, entriesPointer ? data : {}, other), {
            schema: schema,
            linked: shouldRetrieveEntries || hasCountPointer,
            entries: Array.isArray(entries) ? entries === null || entries === void 0 ? void 0 : entries.map(function(entry) {
                return entryFormatter(entry);
            }) : (data === null || data === void 0 ? void 0 : data.entries) ? data.entries : []
        }),
        collection: entriesPointer ? data : null,
        status: {
            collection: {
                loading: loading,
                error: error
            },
            entries: {
                loading: _loading,
                error: _error
            },
            loading: loading || _loading || null,
            error: error || _error || null,
            hasCountPointer: hasCountPointer
        },
        loading: loading,
        error: error,
        Selector: Selector,
        type: type,
        options: options,
        Dialog: Dialog
    };
};
var useLinkedDataGrid = function(_param) {
    var hookResponse = _param.hookResponse, _dataHookMethods = _param.dataHookMethods, dataHookMethods = _dataHookMethods === void 0 ? null : _dataHookMethods, _filtering = _param.filtering, filtering = _filtering === void 0 ? false : _filtering, _entriesPointer = _param.entriesPointer, entriesPointer = _entriesPointer === void 0 ? "entries" : _entriesPointer, _entryHookMethods = _param.entryHookMethods, entryHookMethods = _entryHookMethods === void 0 ? null : _entryHookMethods, entriesReceiverParams = _param.entriesReceiverParams, useEntriesReceiver = _param.useEntriesReceiver, _entryFormatter = _param.entryFormatter, entryFormatter = _entryFormatter === void 0 ? function(e) {
        return e;
    } : _entryFormatter, other = (0,_object_without_properties/* default */.Z)(_param, [
        "hookResponse",
        "dataHookMethods",
        "filtering",
        "entriesPointer",
        "entryHookMethods",
        "entriesReceiverParams",
        "useEntriesReceiver",
        "entryFormatter"
    ]);
    return useMosanicDataGrid((0,_object_spread/* default */.Z)({
        hookResponse: hookResponse,
        dataHookMethods: dataHookMethods,
        filtering: filtering,
        entriesPointer: entriesPointer,
        entryHookMethods: entryHookMethods,
        entriesReceiverParams: entriesReceiverParams,
        useEntriesReceiver: useEntriesReceiver,
        entryFormatter: entryFormatter
    }, other));
};
var useDirectDataGrid = function(_param) {
    var hookResponse = _param.hookResponse, _filtering = _param.filtering, filtering = _filtering === void 0 ? true : _filtering, entryTypePath = _param.entryTypePath, defaultType = _param.defaultType, headerSchema = _param.headerSchema, _entryFormatter = _param.entryFormatter, entryFormatter = _entryFormatter === void 0 ? function(e) {
        return e;
    } : _entryFormatter, props = (0,_object_without_properties/* default */.Z)(_param, [
        "hookResponse",
        "filtering",
        "entryTypePath",
        "defaultType",
        "headerSchema",
        "entryFormatter"
    ]);
    return useMosanicDataGrid((0,_object_spread/* default */.Z)({
        hookResponse: hookResponse,
        filtering: filtering,
        entryTypePath: entryTypePath,
        defaultType: defaultType,
        headerSchema: headerSchema,
        entryFormatter: entryFormatter
    }, props));
};
var usePaginateDataGrid = function(param) {
    var countResponse = param.countResponse, entriesReceiverParams = param.entriesReceiverParams, useEntriesReceiver = param.useEntriesReceiver, _filtering = param.filtering, filtering = _filtering === void 0 ? true : _filtering, entryTypePath = param.entryTypePath, defaultType = param.defaultType, headerSchema = param.headerSchema, _entryFormatter = param.entryFormatter, entryFormatter = _entryFormatter === void 0 ? function(e) {
        return e;
    } : _entryFormatter;
    return useMosanicDataGrid({
        countResponse: countResponse,
        entriesReceiverParams: entriesReceiverParams,
        useEntriesReceiver: useEntriesReceiver,
        filtering: filtering,
        entryTypePath: entryTypePath,
        defaultType: defaultType,
        headerSchema: headerSchema,
        entryFormatter: entryFormatter
    });
};


/***/ }),

/***/ 91189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ DataTable; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(68875);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/jsx/Element.js
var Element = __webpack_require__(3679);
// EXTERNAL MODULE: ./src/adapters/schemas/helpers.js
var helpers = __webpack_require__(80309);
// EXTERNAL MODULE: ./src/adapters/schemas/collections.js
var collections = __webpack_require__(18692);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/Entry.js + 3 modules
var Entry = __webpack_require__(69491);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/DataGrid.js
var DataGrid = __webpack_require__(90131);
// EXTERNAL MODULE: ./src/mosanic/core/Items/useItems.js
var useItems = __webpack_require__(5628);
// EXTERNAL MODULE: ./src/mosanic/core/Provider/DataProviders.js
var DataProviders = __webpack_require__(42622);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(87567);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/items/Page/Page.js
var Page = __webpack_require__(81099);
// EXTERNAL MODULE: ./src/mosanic/items/Block.js
var Block = __webpack_require__(57389);
// EXTERNAL MODULE: ./src/mosanic/items/Expander/index.js + 1 modules
var Expander = __webpack_require__(56957);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/items/Page/MetaHead.js
var MetaHead = __webpack_require__(3155);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/utils/Funct.js
var Funct = __webpack_require__(3847);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/mosanic/cms/DataGrid/DataGrid.js + 4 modules
var DataGrid_DataGrid = __webpack_require__(15121);
// EXTERNAL MODULE: ./src/mosanic/cms/Editor/EditorProvider.js + 5 modules
var EditorProvider = __webpack_require__(30614);
// EXTERNAL MODULE: ./src/mosanic/cms/Pagination/Pagination.js + 1 modules
var Pagination = __webpack_require__(40010);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
// EXTERNAL MODULE: ./src/adapters/queries/users.js
var queries_users = __webpack_require__(62641);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/many.js + 1 modules
var many = __webpack_require__(43551);
;// CONCATENATED MODULE: ./src/mosanic/cms/Query/list.js







var useListUsers = function(_param) {
    var filter = _param.filter, _siteId = _param.siteId, siteId = _siteId === void 0 ? undefined : _siteId, other = (0,_object_without_properties/* default */.Z)(_param, [
        "filter",
        "siteId"
    ]);
    var getLabel = function(user) {
        var ref, ref1;
        return (0,Text/* combineString */.M7)([
            user === null || user === void 0 ? void 0 : (ref = user.author) === null || ref === void 0 ? void 0 : ref.firstName,
            user === null || user === void 0 ? void 0 : (ref1 = user.author) === null || ref1 === void 0 ? void 0 : ref1.lastName
        ], " ");
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,many/* useGetUsers */.w4)((0,_object_spread/* default */.Z)({
        filter: filter,
        siteId: siteId,
        query: queries_users/* FILTER_USERS */.LW
    }, other)), 3), users = ref[0], loading = ref[1], error = ref[2];
    return [
        (0,react.useMemo)(function() {
            return (users === null || users === void 0 ? void 0 : users.length) >= 1 ? users.map(function(user) {
                return {
                    value: user === null || user === void 0 ? void 0 : user._id,
                    label: getLabel(user)
                };
            }) : [
                "No users found"
            ];
        }, [
            users === null || users === void 0 ? void 0 : users.length
        ]),
        loading,
        error
    ];
};

// EXTERNAL MODULE: ./src/mosanic/auth/AuthForm.js + 3 modules
var AuthForm = __webpack_require__(36086);
;// CONCATENATED MODULE: ./src/mosanic/cms/DataTable/DataTable.js

































var emptyResponse = null;
var DataTable = function(_param) {
    var _schema = _param.schema, schema = _schema === void 0 ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collections/* collectionsSchema */.V_), {
        props: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collections/* collectionsSchema.props */.V_.props), {
            info: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collections/* collectionsSchema.props.info */.V_.props.info), {
                slug: null
            })
        })
    }) : _schema, _config = _param.config, config = _config === void 0 ? {
        onlyEditorSchema: false,
        isIndexPage: false,
        defaultType: "user",
        defaultTypes: null,
        controlRouter: "/site"
    } : _config, _controls = _param.controls, controls = _controls === void 0 ? {
        add: true,
        ordering: true,
        limiter: true,
        filters: true,
        edit: true,
        delete: true,
        search: true,
        admin: true
    } : _controls, useDataGrid = _param.useDataGrid, _useEntryDataGrid = _param.useEntryDataGrid, useEntryDataGrid = _useEntryDataGrid === void 0 ? null : _useEntryDataGrid, _hookProps = _param.hookProps, hookProps = _hookProps === void 0 ? {} : _hookProps, _settings = _param.settings, settings = _settings === void 0 ? null : _settings, _render = _param.render, render = _render === void 0 ? true : _render, _wrap = _param.wrap, wrap = _wrap === void 0 ? true : _wrap, _domain = _param.domain, domain = _domain === void 0 ? null : _domain, other = (0,_object_without_properties/* default */.Z)(_param, [
        "schema",
        "config",
        "controls",
        "useDataGrid",
        "useEntryDataGrid",
        "hookProps",
        "settings",
        "render",
        "wrap",
        "domain"
    ]);
    var ref, ref1, ref2, ref3;
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetSite */.iu)({
        _id: siteId
    }), 1), site = ref4[0];
    var userId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetUser */.pg)({
        _id: userId
    }), 1), user = ref5[0];
    var router = (0,next_router.useRouter)();
    var site_schema = (schema === null || schema === void 0 ? void 0 : (ref = schema.site) === null || ref === void 0 ? void 0 : ref.schema) && site ? schema.site.schema(site) : null;
    var ref6 = (0,_sliced_to_array/* default */.Z)(useListUsers({}), 1), users = ref6[0];
    var controlCount = (ref1 = Object.values(controls).filter(function(c) {
        return c;
    })) === null || ref1 === void 0 ? void 0 : ref1.length;
    var ref7 = (0,react.useState)(false), allSites = ref7[0], setAllSites = ref7[1];
    var ref8 = useDataGrid((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hookProps), {
        //Schema props for rendering the entry columns
        props: schema === null || schema === void 0 ? void 0 : schema.props,
        columns: Array.isArray(site_schema) ? (0,_to_consumable_array/* default */.Z)(schema === null || schema === void 0 ? void 0 : schema.columns).concat((0,_to_consumable_array/* default */.Z)(site_schema)) : schema === null || schema === void 0 ? void 0 : schema.columns,
        //Formatting of entries for datagrid columns
        formatter: schema === null || schema === void 0 ? void 0 : (ref2 = schema.formatting) === null || ref2 === void 0 ? void 0 : ref2.columns
    })), data = ref8.data, limiter = ref8.limiter, pagination = ref8.pagination, actions = ref8.actions, state = ref8.state, type = ref8.type, loading = ref8.loading, error = ref8.error, options = ref8.options, status = ref8.status, Dialog = ref8.Dialog, Selector = ref8.Selector, dataHookMethods = ref8.dataHookMethods, entryHookMethods = ref8.entryHookMethods, collection = ref8.collection;
    var baseSchema = (0,helpers/* combineIntoDataTableSchema */.Ae)({
        dataTableSchema: schema,
        config: config,
        data: data
    });
    var dataTable = baseSchema.dataTable, props = baseSchema.props, info = baseSchema.info, singular = baseSchema.singular;
    (0,react.useEffect)(function() {
        if (data && (data === null || data === void 0 ? void 0 : data.siteId) && config.controlRouter && siteId != (data === null || data === void 0 ? void 0 : data.siteId)) {
            router.push(config.controlRouter);
        }
    }, [
        siteId,
        data === null || data === void 0 ? void 0 : data.siteId,
        data,
        router,
        config.controlRouter
    ]);
    var ref9 = (0,react.useState)("index"), tab = ref9[0], setTab = ref9[1];
    // const currentType = type === 'all' ? config?.defaultType : type ? type : data?.singular
    var Controls = function() {
        var ref, ref1, ref2;
        return (config === null || config === void 0 ? void 0 : config.viewOnly) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InlineGroup */.a_, {
            mb: 2
        }) : tab === "index" && (controlCount >= 1 || (controls === null || controls === void 0 ? void 0 : controls.search)) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InlineGroup */.a_, {
            mb: 4,
            children: [
                controlCount >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* ButtonGroup */.h, {
                    my: 0,
                    width: "".concat(controlCount * 120, "px"),
                    maxWidth: "100%",
                    minWidth: "300px",
                    mr: 2,
                    children: [
                        (props === null || props === void 0 ? void 0 : (ref = props.routing) === null || ref === void 0 ? void 0 : ref.indexPath) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            href: props === null || props === void 0 ? void 0 : (ref1 = props.routing) === null || ref1 === void 0 ? void 0 : ref1.indexPath,
                            label: "Return",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowLeftIcon */.Y4O, {})
                        }),
                        Selector && /*#__PURE__*/ (0,jsx_runtime.jsx)(Selector, {
                            cb: function() {
                                return setTab("index");
                            }
                        }),
                        controls.edit && !(status === null || status === void 0 ? void 0 : status.loading) && !config.isIndexPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            active: tab === "update",
                            label: "Edit schema",
                            onClick: function() {
                                return setTab(tab === "update" ? "index" : "update");
                            }
                        }),
                        settings && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* MixerVerticalIcon */.c1q, {}),
                            active: tab === "settings",
                            label: "Settings",
                            onClick: function() {
                                return setTab(tab === "settings" ? "index" : "settings");
                            }
                        }),
                        controls.add && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* PlusCircledIcon */.SPS, {}),
                            label: " Add ".concat((0,Text/* excerptString */.dK)(singular, 4)),
                            handler: function() {
                                return actions.open("modal");
                            }
                        }),
                        controls.filters && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.ToggleButton, {
                            label: " Filters",
                            altLabel: " Filtering",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* MixerHorizontalIcon */.hsZ, {}),
                            altIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* MixerVerticalIcon */.c1q, {}),
                            checked: state === null || state === void 0 ? void 0 : (ref2 = state.filters) === null || ref2 === void 0 ? void 0 : ref2.enabled,
                            onClick: actions === null || actions === void 0 ? void 0 : actions.toggleFilters
                        }, "filter"),
                        controls.ordering && /*#__PURE__*/ (0,jsx_runtime.jsx)(DataGrid/* GridOrderButton */.Z1, {
                            state: state,
                            setState: actions === null || actions === void 0 ? void 0 : actions.setState
                        }),
                        controls.delete && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TrashIcon */.XHJ, {}),
                            ghost: true,
                            label: " Delete"
                        }),
                        (user === null || user === void 0 ? void 0 : user.isAdmin) && controls.admin && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.ToggleButton, {
                            onClick: function() {
                                return setAllSites(!allSites);
                            },
                            checked: allSites,
                            altLabel: "Current site",
                            label: "[admin]"
                        }),
                        controls.limiter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* PaginationLimit */.S, (0,_object_spread/* default */.Z)({}, limiter))
                    ]
                }),
                controls.search && false && /*#__PURE__*/ 0
            ]
        }) : null;
    };
    var title = (0,Text/* capitalizeFirst */.Ez)(info.title);
    var label = /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
        label: info.label,
        helpText: info.help,
        as: "p"
    });
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useItems/* useSearchItems */.P4)({
        components: data === null || data === void 0 ? void 0 : data.entries,
        validate: function(c, input) {
            var ref, ref1, ref2;
            return (0,useItems/* substrSearch */.Gk)(c === null || c === void 0 ? void 0 : c.title, input) || ((ref1 = data === null || data === void 0 ? void 0 : (ref = data.schema) === null || ref === void 0 ? void 0 : ref.filter(function(f) {
                return (f === null || f === void 0 ? void 0 : f.type) === "text" ? (0,useItems/* substrSearch */.Gk)(c === null || c === void 0 ? void 0 : c[f === null || f === void 0 ? void 0 : f.name], input) : false;
            })) === null || ref1 === void 0 ? void 0 : ref1.length) >= 1 || (0,useItems/* substrSearch */.Gk)(c === null || c === void 0 ? void 0 : c.title, input) || (0,useItems/* substrSearch */.Gk)(c === null || c === void 0 ? void 0 : c.accommodation_desc, input) || (0,useItems/* substrSearch */.Gk)(c === null || c === void 0 ? void 0 : (ref2 = c.sys_location) === null || ref2 === void 0 ? void 0 : ref2.location_desc, input);
        }
    }), 3), input = ref10[0], setInput = ref10[1], filtered = ref10[2];
    var Entries = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(DataGrid_DataGrid/* DataGrid */._, {
            loading: status.loading,
            props: props,
            collection: data ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                entries: filtered
            }) : data,
            pagination: pagination,
            handles: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, actions), {
                delete: !(config === null || config === void 0 ? void 0 : config.disabled) ? actions.delete : null,
                viewOnly: config === null || config === void 0 ? void 0 : config.viewOnly
            }),
            state: state,
            domain: domain
        });
    };
    var Editor = function() {
        return tab === "update" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorProvider/* default */.Z, {
                initial: collection,
                dataHookMethods: dataHookMethods,
                entryHookMethods: entryHookMethods,
                formType: "update",
                stopEditing: function() {
                    return setTab("index");
                },
                baseSchema: baseSchema,
                type: type || config.defaultType,
                types: config.defaultTypes || options,
                singular: singular
            })
        }) : tab === "settings" ? settings({
            stopEditing: function() {
                return setTab("index");
            }
        }) : null;
    };
    // console.log(site_schema)
    var isUpdate = state.action != "create";
    var EditorRender = function(param) {
        var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
        var ref;
        var isUpdate = state.action != "create";
        // console.log(dataHookMethods, entryHookMethods
        var handler = isUpdate ? dataHookMethods === null || dataHookMethods === void 0 ? void 0 : dataHookMethods.update : dataHookMethods === null || dataHookMethods === void 0 ? void 0 : dataHookMethods.create;
        handler = (0,Funct/* isFunc */.W)(handler) ? handler : function() {
            return [
                function() {
                    return null;
                },
                [
                    null,
                    false,
                    null
                ]
            ];
        };
        //Return editor for updating schema's 
        // * Update Collection from /collections
        if (props.editor.entry === "data_table" && isUpdate && useEntryDataGrid) {
            var ref1;
            console.log(useEntryDataGrid);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DataTable, {
                    // handler={dataHookMethods}
                    // entryHandler={entryHookMethods}
                    schema: dataTable,
                    useDataGrid: useEntryDataGrid,
                    hookProps: {
                        _id: state === null || state === void 0 ? void 0 : (ref1 = state.item) === null || ref1 === void 0 ? void 0 : ref1._id
                    },
                    config: {
                        dialog: "lg",
                        onlyEditorSchema: false
                    },
                    wrap: false
                })
            });
        }
        //Return provided editor for index pages
        // * Create Collection from /collections
        // if(config.isIndexPage) return 'EditorProvider'
        if (config.isIndexPage) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorProvider/* default */.Z, {
                dataHookMethods: dataHookMethods,
                handler: handler,
                formType: state === null || state === void 0 ? void 0 : state.action,
                initial: state === null || state === void 0 ? void 0 : state.item,
                stopEditing: function() {
                    return setTab("index");
                },
                baseSchema: !site_schema ? baseSchema : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, baseSchema), {
                    base: (0,_to_consumable_array/* default */.Z)(baseSchema === null || baseSchema === void 0 ? void 0 : baseSchema.base).concat((0,_to_consumable_array/* default */.Z)(site_schema ? site_schema : []))
                }),
                type: type != "all" ? type :  false || config.defaultType,
                types: config.defaultTypes || options,
                singular: singular
            })
        });
        handler = entryHookMethods || (data === null || data === void 0 ? void 0 : (ref = data.config) === null || ref === void 0 ? void 0 : ref.notLinked) && entryHookMethods ? isUpdate ? entryHookMethods === null || entryHookMethods === void 0 ? void 0 : entryHookMethods.update : entryHookMethods === null || entryHookMethods === void 0 ? void 0 : entryHookMethods.create : handler;
        handler = (0,Funct/* isFunc */.W)(handler) ? handler : function() {
            return [
                function() {
                    return null;
                },
                [
                    null,
                    false,
                    null
                ]
            ];
        };
        // if(props.editor.entry != 'entry') return JSON.stringify(props?.editor)
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Entry/* Entry */.k, {
            handler: handler,
            cols: (data === null || data === void 0 ? void 0 : data._id) ? 1 : 2,
            dataType: type,
            initial: state === null || state === void 0 ? void 0 : state.item,
            type: state === null || state === void 0 ? void 0 : state.action,
            disabled: config === null || config === void 0 ? void 0 : config.disabled,
            collection: config.onlyEditorSchema ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                schema: (baseSchema === null || baseSchema === void 0 ? void 0 : baseSchema.base) ? baseSchema === null || baseSchema === void 0 ? void 0 : baseSchema.base : data === null || data === void 0 ? void 0 : data.schema
            }) : data
        });
    };
    var editorDialogTitle = config.onlyEditorSchema && isUpdate ? null : (0,Text/* capitalizeFirst */.Ez)("".concat(state.action, " ").concat(singular ? singular : ""));
    var editorDialogSize = state.action === "create" || config.isIndexPage ? props.level === 1 ? "xl" : props.level === 2 ? "lg" : props.level === 3 ? "md" : "sm" : config === null || config === void 0 ? void 0 : config.dialog;
    var EditorDialog = function(param) {
        var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog, {
            props: {
                size: editorDialogSize,
                title: editorDialogTitle,
                level: props.level + 1
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorRender, {})
        });
    };
    if (!data) return render ? null : emptyResponse;
    return render ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: ((ref3 = info.slug) === null || ref3 === void 0 ? void 0 : ref3.length) >= 1,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* Page */.T, {
                slug: (0,_to_consumable_array/* default */.Z)(info.slug).concat([
                    {
                        label: title
                    }
                ]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaHead/* default */.Z, {
                        title: title,
                        description: label
                    }),
                    children
                ]
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
            when: wrap,
            wrapper: function(children) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* Block */.gO, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    p: [
                        4,
                        8,
                        10
                    ]
                }, other), {
                    children: children
                }));
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DataProviders/* DataProvider */.FW, {
                data: {
                    users: users
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Element/* HeadingTag */.lb, {
                        level: props.level,
                        children: title
                    }),
                    label,
                    !userId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthForm/* AuthForm */.B, {
                        verify: false
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Controls, {}),
                            error,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                                expanded: tab != "index",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                                expanded: tab === "index",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Entries, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorDialog, {})
                        ]
                    })
                ]
            })
        })
    }) : {
        title: title,
        label: label,
        Error: Error,
        Controls: Controls,
        Entries: Entries,
        Dialog: Dialog,
        Editor: Editor,
        loading: loading,
        EditorDialog: EditorDialog,
        schema: data === null || data === void 0 ? void 0 : data.schema,
        state: state
    };
};


/***/ }),

/***/ 30614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Editor_EditorProvider; }
});

// UNUSED EXPORTS: EditorProvider

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/items/LoadingDots.tsx
var LoadingDots = __webpack_require__(4093);
// EXTERNAL MODULE: ./src/mosanic/items/Control/ControlButtons.js + 1 modules
var ControlButtons = __webpack_require__(11743);
// EXTERNAL MODULE: ./src/mosanic/styles/grid.styles.js
var grid_styles = __webpack_require__(67324);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ./src/mosanic/components/Pages/Resolvers/usePages.js
var usePages = __webpack_require__(67431);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/index.js
var Input = __webpack_require__(6928);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/many.js + 1 modules
var many = __webpack_require__(43551);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/count.js
var Query_count = __webpack_require__(88574);
// EXTERNAL MODULE: ./src/utils/Num.js
var Num = __webpack_require__(3121);
;// CONCATENATED MODULE: ./src/mosanic/cms/Editor/EditorBase.js
















var EditorBase = function(param) {
    var _type = param.type, type = _type === void 0 ? "collection" : _type, types = param.types, _singular = param.singular, singular = _singular === void 0 ? "collection" : _singular, hasField = param.hasField, getField = param.getField, fields = param.fields;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,index_esm/* useFormContext */.Gc)(), handleSubmit = ref8.handleSubmit, control = ref8.control, watch = ref8.watch, reset = ref8.reset, _formState = ref8.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors,
        wrap: true
    };
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    // todo --> pass these fields inside a 'data provider' 
    var pages = (ref = (0,usePages/* usePages */.Q)({
        siteId: siteId,
        pagesOnly: true
    })) === null || ref === void 0 ? void 0 : ref.map(function(p) {
        return {
            label: p.title,
            value: p._id
        };
    });
    var collections = (ref1 = (0,many/* useGetCollections */.t8)({
        siteId: siteId
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.map(function(p) {
        return {
            label: p === null || p === void 0 ? void 0 : p.title,
            value: p._id
        };
    });
    var example = type === "collection" ? "User cards are shown in the contact page" : "Main footer contact form";
    type = ((ref3 = watch()) === null || ref3 === void 0 ? void 0 : ref3.type) || type;
    types = types === null || types === void 0 ? void 0 : types.filter(function(t) {
        return t != "all";
    });
    (0,react.useEffect)(function() {
        var ref;
        if (!((ref = watch()) === null || ref === void 0 ? void 0 : ref.type) && (types === null || types === void 0 ? void 0 : types.length) >= 1) reset((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, watch()), {
            type: types[0]
        }));
    }, [
        watch,
        types,
        reset
    ]);
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,Query_count/* useGetEntryCount */.p)({
        _id: (ref4 = watch()) === null || ref4 === void 0 ? void 0 : ref4._id
    }), 1), count = ref9[0];
    var setCount = function() {
        return reset((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, watch()), {
            entries: count
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                cols: 2,
                border: true,
                label: "".concat((0,Text/* capitalizeFirst */.Ez)(singular), " info"),
                mt: 0,
                children: [
                    hasField("title") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        name: "title",
                        label: "".concat(singular, " name"),
                        type: "text"
                    }, inputProps), {
                        required: true,
                        rules: {
                            required: "Shorthand name that defines this ".concat(singular)
                        }
                    })),
                    hasField("description") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        fullWidth: true,
                        name: "description",
                        label: "Description",
                        type: "textarea"
                    }, inputProps), {
                        required: true,
                        rules: {
                            required: "Explain the purpose of this ".concat(singular, " and give some context. For example, ").concat(example)
                        }
                    })),
                    fields === null || fields === void 0 ? void 0 : fields.filter(function(f) {
                        return (!(f === null || f === void 0 ? void 0 : f.when) || (f === null || f === void 0 ? void 0 : f.when(watch()))) && (f === null || f === void 0 ? void 0 : f.base);
                    }).map(function(f) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputProps, f), {
                            name: (f === null || f === void 0 ? void 0 : f.path) ? f.path : f.name,
                            label: f === null || f === void 0 ? void 0 : f.label,
                            type: [
                                "page",
                                "collections"
                            ].includes(f === null || f === void 0 ? void 0 : f.type) ? "select" : f.type,
                            fullWidth: f === null || f === void 0 ? void 0 : f.fullWidth,
                            options: (f === null || f === void 0 ? void 0 : f.type) === "page" ? pages : (f === null || f === void 0 ? void 0 : f.type) === "collections" ? collections : f === null || f === void 0 ? void 0 : f.options
                        }));
                    }),
                    hasField("singular") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        name: "singular",
                        label: "Singular entry name",
                        type: "text"
                    }, inputProps), {
                        required: true,
                        rules: {
                            required: 'How should we call a single entry. For exmaple, articles collection => "Article"'
                        }
                    })),
                    hasField("status") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                        name: "status",
                        label: "Status",
                        type: "select",
                        options: (ref5 = getField("status")) === null || ref5 === void 0 ? void 0 : ref5.options
                    }, inputProps))
                ]
            }),
            (ref6 = fields === null || fields === void 0 ? void 0 : fields.filter(function(f) {
                return f === null || f === void 0 ? void 0 : f.schema;
            })) === null || ref6 === void 0 ? void 0 : ref6.map(function(g) {
                return (!(g === null || g === void 0 ? void 0 : g.when) || (g === null || g === void 0 ? void 0 : g.when(watch()))) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
                    label: g === null || g === void 0 ? void 0 : g.label,
                    cols: (g === null || g === void 0 ? void 0 : g.cols) ? g.cols : 2,
                    border: true,
                    children: g.schema.map(function(f) {
                        return (!(f === null || f === void 0 ? void 0 : f.when) || (f === null || f === void 0 ? void 0 : f.when(watch()))) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputProps, f), {
                            name: (f === null || f === void 0 ? void 0 : f.path) ? f.path : "".concat(g.name, ".").concat(f.name),
                            label: f === null || f === void 0 ? void 0 : f.label,
                            type: (f === null || f === void 0 ? void 0 : f.type) === "page" ? "select" : f.type,
                            fullWidth: f === null || f === void 0 ? void 0 : f.fullWidth,
                            options: (f === null || f === void 0 ? void 0 : f.type) === "page" ? pages : f === null || f === void 0 ? void 0 : f.options
                        }));
                    })
                }, g.name);
            }),
            (types === null || types === void 0 ? void 0 : types.length) >= 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                name: "type",
                label: "".concat(singular, " type"),
                type: "buttonGroup",
                options: types
            }, inputProps)),
            (0,Num/* isNumber */.hj)(count) && count >= 1 && ((ref7 = watch()) === null || ref7 === void 0 ? void 0 : ref7.entries) != count && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                label: "Set entry count: ".concat(count),
                ghost: true,
                style: {
                    width: "100%"
                },
                onClick: function() {
                    return setCount();
                }
            }),
            hasField("limit") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                name: "limit",
                label: type === "collection" ? "Limit entries" : "Limit is defined by membership package",
                type: "number",
                disabled: type != "collection"
            }, inputProps))
        ]
    });
};

// EXTERNAL MODULE: ./src/mosanic/core/Collections/Entry.js + 3 modules
var Entry = __webpack_require__(69491);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/FieldsCollection.js + 10 modules
var FieldsCollection = __webpack_require__(61101);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/useCreateCollection.js
var useCreateCollection = __webpack_require__(30611);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/useUpdateCollection.js
var useUpdateCollection = __webpack_require__(36414);
// EXTERNAL MODULE: ./src/mosanic/cms/DataGrid/DataGrid.js + 4 modules
var DataGrid = __webpack_require__(15121);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/mosanic/items/Expander/index.js + 1 modules
var Expander = __webpack_require__(56957);
// EXTERNAL MODULE: ./src/mosanic/items/List/List.js + 2 modules
var List = __webpack_require__(62035);
// EXTERNAL MODULE: ./src/mosanic/utils/Image.js
var Image = __webpack_require__(73987);
// EXTERNAL MODULE: ./src/mosanic/cms/Mutate/create.js
var create = __webpack_require__(33714);
// EXTERNAL MODULE: ./src/mosanic/items/Page/Columns.js
var Columns = __webpack_require__(60630);
;// CONCATENATED MODULE: ./src/mosanic/cms/Editor/EditorTransform.js

















var ReactJson = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8047).then(__webpack_require__.t.bind(__webpack_require__, 48047, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48047)
            ];
        }
    },
    ssr: false
});
var EditorTransform = function(param) {
    var schema = param.schema, callback = param.callback, formData = param.formData, handler = param.handler;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(handler ? handler({
        callback: callback,
        collection: formData
    }) : [
        function() {
            return null;
        },
        [
            null,
            false,
            null
        ]
    ], 2), action = ref1[0], ref2 = (0,_sliced_to_array/* default */.Z)(ref1[1], 3), data = ref2[0], loading = ref2[1], error = ref2[2];
    var entries = formData === null || formData === void 0 ? void 0 : formData.entries;
    var ref3 = (0,react.useState)({
        progress: "",
        loading: false,
        ids: [],
        log: []
    }), state = ref3[0], setState = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,create/* useCreateEntry */.l2)({
        callback: function(id) {
            return setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    progress: "Converting: ".concat(id),
                    ids: (0,_to_consumable_array/* default */.Z)(state.ids).concat([
                        id
                    ]),
                    log: (0,_to_consumable_array/* default */.Z)(state.log).concat([
                        "Converting: ".concat(id)
                    ])
                });
            });
        },
        collection: formData
    }), 2), addEntry = ref4[0], ref5 = (0,_sliced_to_array/* default */.Z)(ref4[1], 3), addData = ref5[0], loadingAdd = ref5[1], errorAdd = ref5[2];
    var transformData = function() {
        var ref;
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            preview: null,
            loading: true,
            ids: [],
            progress: "Starting transformation.",
            log: [
                "Starting transformation."
            ]
        }));
        formData === null || formData === void 0 ? void 0 : (ref = formData.entries) === null || ref === void 0 ? void 0 : ref.map(function(entry, i) {
            return setTimeout(function() {
                addEntry({
                    data: entry
                });
            }, i * 150);
        });
        setTimeout(function() {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    progress: "Updating collection.",
                    log: (0,_to_consumable_array/* default */.Z)(state.log).concat([
                        "Updating collection."
                    ])
                });
            });
            action({
                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                    entries: [
                        state.ids
                    ],
                    linked: undefined
                })
            });
            setTimeout(function() {
                return setState(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        preview: null,
                        loading: false,
                        progress: "Finished.",
                        log: (0,_to_consumable_array/* default */.Z)(state.log).concat([
                            "Finished."
                        ])
                    });
                });
            }, 750);
        }, 750);
    };
    var convertedEntries = entries === null || entries === void 0 ? void 0 : entries.map(function(entry) {
        return (0,create/* createEntryFormatter */.Sb)(entry, formData);
    });
    var isLoading = loading || state.loading || loadingAdd;
    //     Converting: 640b562df6eb9a91e2ca8ba7
    // Converting: 640b562df6eb9a91e2ca8ba9
    // Converting: 640b562df6eb9a91e2ca8bab
    // Converting: 640b562df6eb9a91e2ca8bad
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
        cols: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* TwoColumns */.VZ, {
                first: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.aV, {
                    my: 4,
                    children: convertedEntries === null || convertedEntries === void 0 ? void 0 : convertedEntries.map(function(entry) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(List/* ListItem */.HC, {
                            style: {
                                display: "flex"
                            },
                            onClick: function() {
                                return setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                    preview: entry
                                }));
                            },
                            children: [
                                (entry === null || entry === void 0 ? void 0 : entry.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: (ref = (0,Image/* parseImageSrc */.yO)(entry === null || entry === void 0 ? void 0 : entry.image, true)) === null || ref === void 0 ? void 0 : ref.full,
                                    width: "35px",
                                    height: "20px",
                                    objectFit: "contain",
                                    alt: "preview"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        paddingLeft: "10px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: entry.title
                                        }),
                                        (entry === null || entry === void 0 ? void 0 : entry.slug) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            style: {
                                                opacity: 0.4
                                            },
                                            children: [
                                                "\xa0/",
                                                entry.slug
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        (entry === null || entry === void 0 ? void 0 : entry.description) != "..." && (entry === null || entry === void 0 ? void 0 : entry.description)
                                    ]
                                })
                            ]
                        }, entry === null || entry === void 0 ? void 0 : entry.title);
                    })
                }),
                second: [
                    (state === null || state === void 0 ? void 0 : state.preview) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                        ghost: true,
                        onClick: function() {
                            return setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                preview: null
                            }));
                        },
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowLeftIcon */.Y4O, {}),
                        label: "View all conversions"
                    }, "clear"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactJson, {
                        collapsed: !(state === null || state === void 0 ? void 0 : state.preview),
                        name: (state === null || state === void 0 ? void 0 : (ref = state.preview) === null || ref === void 0 ? void 0 : ref.title) || "Conversion",
                        src: (state === null || state === void 0 ? void 0 : state.preview) || convertedEntries
                    }, "json")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                label: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : "Yes, transform",
                theme: "primary",
                size: "large",
                formType: "submit",
                disabled: isLoading,
                onClick: transformData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                    label: state.progress,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowDownIcon */.veu, {})
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.aV, {
                    p: 4,
                    children: state.log.map(function(log, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItem */.HC, {
                            children: log
                        }, index);
                    })
                })
            }),
            error || errorAdd
        ]
    });
};

// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
;// CONCATENATED MODULE: ./src/mosanic/cms/Editor/EditorBaseFields.js


















var EditorBaseFields_ReactJson = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8047).then(__webpack_require__.t.bind(__webpack_require__, 48047, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48047)
            ];
        }
    },
    ssr: false
});
var EditorBaseFields = function(param) {
    var schema = param.schema, callback = param.callback, formData = param.formData, handler = param.handler;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(handler ? handler({
        callback: callback,
        collection: formData
    }) : [
        function() {
            return null;
        },
        [
            null,
            false,
            null
        ]
    ], 2), action = ref1[0], ref2 = (0,_sliced_to_array/* default */.Z)(ref1[1], 3), data = ref2[0], loading = ref2[1], error = ref2[2];
    // const entries = formData?.entries;
    var ref3 = (0,react.useState)({
        progress: "",
        loading: false,
        ids: [],
        log: []
    }), state = ref3[0], setState = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,many/* useGetEntries */.e1)({
        collectionId: formData._id,
        silent: true
    }), 1), entries = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetCollection */.YD)({
        _id: formData._id,
        silent: true
    }), 1), collection = ref5[0];
    // const [addEntry, [addData, loadingAdd, errorAdd]] = useCreateEntry({
    // 	callback: id => setState(state => ({
    //         ...state, 
    //         progress: `Converting: ${id}`,
    //         ids: [...state.ids, id],
    //         log: [...state.log, `Converting: ${id}`]
    //     })),
    //     collection: formData
    // })
    var linkEntries = function() {
        action({
            data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collection), {
                entries: entries === null || entries === void 0 ? void 0 : entries.map(function(e) {
                    return e._id;
                }),
                linked: undefined
            })
        });
    };
    var isLoading = loading || state.loading;
    //     Converting: 640b562df6eb9a91e2ca8ba7
    // Converting: 640b562df6eb9a91e2ca8ba9
    // Converting: 640b562df6eb9a91e2ca8bab
    // Converting: 640b562df6eb9a91e2ca8bad
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
        cols: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid_styles/* Wrap */.Eq, {
                children: [
                    (collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.length) < (entries === null || entries === void 0 ? void 0 : entries.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid_styles/* Col */.JX, {
                        width: [
                            1,
                            1 / 2
                        ],
                        px: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                as: "h4",
                                label: "Relink entries",
                                span: true
                            }),
                            entries === null || entries === void 0 ? void 0 : entries.map(function(entry) {
                                var ref, ref1;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(List/* ListItem */.HC, {
                                    style: {
                                        display: "flex"
                                    },
                                    children: [
                                        (entry === null || entry === void 0 ? void 0 : entry.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref = (0,Image/* parseImageSrc */.yO)(entry === null || entry === void 0 ? void 0 : entry.image, true)) === null || ref === void 0 ? void 0 : ref.full,
                                            width: "35px",
                                            height: "20px",
                                            objectFit: "contain",
                                            alt: "preview"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                paddingLeft: "10px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: entry.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                                    label: (collection === null || collection === void 0 ? void 0 : (ref1 = collection.entries) === null || ref1 === void 0 ? void 0 : ref1.includes(entry === null || entry === void 0 ? void 0 : entry._id)) ? "Included" : "Not linked"
                                                })
                                            ]
                                        })
                                    ]
                                }, entry === null || entry === void 0 ? void 0 : entry.title);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                label: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : "Link entries",
                                theme: "primary",
                                size: "small",
                                disabled: isLoading,
                                onClick: linkEntries
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid_styles/* Col */.JX, {
                        width: [
                            1,
                            1 / 2
                        ],
                        px: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                as: "h4",
                                label: "Change base fields",
                                span: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                mb: 4,
                                children: "Select the base fields of this formData"
                            })
                        ]
                    })
                ]
            }),
            error
        ]
    });
};

// EXTERNAL MODULE: ./src/mosanic/fields/Button/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(87567);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Popper.js + 4 modules
var Popper = __webpack_require__(28932);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/Select/SelectField.js
var SelectField = __webpack_require__(3849);
// EXTERNAL MODULE: ./src/mosanic/fields/Source/index.js + 10 modules
var Source = __webpack_require__(4625);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/useDataQuery.js
var useDataQuery = __webpack_require__(49974);
// EXTERNAL MODULE: ./src/mosanic/fields/Source/helpers.js
var helpers = __webpack_require__(49272);
// EXTERNAL MODULE: ./src/mosanic/hooks/useNotify.js
var useNotify = __webpack_require__(33346);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
;// CONCATENATED MODULE: ./src/mosanic/cms/Editor/EditorVariables.js


















var EditorVariables = function(param) {
    var collectionId = param.collectionId, _trigger = param.trigger, trigger = _trigger === void 0 ? false : _trigger;
    var ref = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetCollection */.YD)({
        _id: collectionId,
        silent: true
    }), 1), collection = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,Query_count/* useGetEntryCount */.p)({
        collectionId: collectionId
    }), 1), count = ref1[0];
    var ref2 = (0,react.useState)(0), skip = ref2[0], setSkip = ref2[1];
    var ref3 = (0,react.useState)(0), state = ref3[0], setState = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,many/* useGetEntries */.e1)({
        filter: {
            collectionId: collectionId
        },
        limit: 1,
        skip: skip
    }), 1), entries = ref4[0];
    var notify = (0,useNotify/* default */.Z)();
    var path = (state === null || state === void 0 ? void 0 : state.fieldPath) ? "{".concat((0,helpers/* getMinimalFieldPath */.HU)(state === null || state === void 0 ? void 0 : state.fieldPath), "}") : null;
    var copyPath = (0,react.useCallback)(function() {
        var silent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (!(state === null || state === void 0 ? void 0 : state.fieldPath)) return;
        if ("clipboard" in navigator) {
            navigator.clipboard.writeText(path);
        } else {
            document.execCommand("copy", true, path);
        }
        if (!silent) notify("Copied: ".concat(path), "app", "info");
    }, [
        notify,
        path,
        state === null || state === void 0 ? void 0 : state.fieldPath
    ]);
    (0,react.useEffect)(function() {
        if (!trigger || !(state === null || state === void 0 ? void 0 : state.fieldPath)) return;
        copyPath(true);
    }, [
        trigger,
        state.fieldPath,
        copyPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: trigger,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                trigger: trigger,
                width: 550,
                height: 450,
                scroll: true,
                p: 0,
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: path
                }),
                children: children
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* ButtonGroup */.h, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            disabled: skip <= 0,
                            tooltip: "Previous entry",
                            label: "Previous entry",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowLeftIcon */.Y4O, {}),
                            onClick: function() {
                                return setSkip(skip - 1);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            disabled: skip >= count,
                            tooltip: "Next entry",
                            label: "Next entry",
                            iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowRightIcon */.LZ3, {}),
                            onClick: function() {
                                return setSkip(skip + 1);
                            }
                        })
                    ]
                }),
                path && !trigger && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    size: "large",
                    label: "Click to copy: ".concat(path),
                    onClick: function() {
                        return copyPath();
                    },
                    style: {
                        cursor: "copy",
                        border: "none",
                        minWidth: "100%"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Source.Columns, {
                    style: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectField/* default */.ZP, {
                        state: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            schema: collection === null || collection === void 0 ? void 0 : collection.schema
                        }),
                        setState: setState,
                        collection: collection,
                        activeEntry: (0,useDataQuery/* convertEntry */.ec)(entries === null || entries === void 0 ? void 0 : entries[0]),
                        canSelectField: function() {
                            return true;
                        }
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/Input.js + 4 modules
var Input_Input = __webpack_require__(84430);
// EXTERNAL MODULE: ./src/mosanic/i18n/SelectLocales.js
var SelectLocales = __webpack_require__(36072);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/utils/mail.js + 1 modules
var utils_mail = __webpack_require__(96346);
;// CONCATENATED MODULE: ./src/mosanic/cms/Editor/EditorTemplates.js




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \nwidth: 100%;\ndisplay: block;\ntext-align: center;\npadding: 10px 0 25px;\nfont-size: 110%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    font-size: 80%;\n    padding: 20px 10px 5px;\n    cursor: pointer;\n    transition: all ease-in-out .3s;\n    &:hover {\n        transform: scale(1.02)\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    font-size: 12px;\n    opacity: 0.5;\n    margin-bottom: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin-top: 10px;\n    border: 1px solid #eee;\n    padding: 15px 10px;\n    font-size: 80%;\n    border-radius: 10px;\n    \n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









// import { Entry } from "@mosanic/core/Collections"










var EditorTemplates = function(param) {
    var collectionId = param.collectionId, _trigger = param.trigger, trigger = _trigger === void 0 ? false : _trigger, _schema = param.schema, schema = _schema === void 0 ? [] : _schema, _templates = param.templates, templates = _templates === void 0 ? [] : _templates;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var id = "templates";
    var ref7 = (0,index_esm/* useFormContext */.Gc)(), control = ref7.control, errors = ref7.errors, setValue = ref7.setValue, watch1 = ref7.watch, isValid = ref7.formState.isValid;
    var ref8 = (0,index_esm/* useFieldArray */.Dq)({
        name: id,
        control: control
    }), fields = ref8.fields, append = ref8.append, prepend = ref8.prepend, remove = ref8.remove, swap = ref8.swap, move = ref8.move, insert = ref8.insert;
    var router = (0,next_router.useRouter)();
    var locales = router.locales, locale = router.locale, path = router.asPath;
    var ref9 = (0,react.useState)(locale), activeLang = ref9[0], setActiveLan = ref9[1];
    var setLang = function(lang, replaceRouter) {
        setActiveLan(lang);
        if (replaceRouter) router.push(path, path, {
            locale: lang,
            shallow: true
        });
    };
    var hasLocalizedFields = (ref = watch1()) === null || ref === void 0 ? void 0 : (ref1 = ref.schema) === null || ref1 === void 0 ? void 0 : ref1.find(function(s) {
        return s === null || s === void 0 ? void 0 : s.localized;
    });
    var primaryField = (ref2 = watch1()) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.schema) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.name;
    var inputProps = {
        control: control,
        errors: errors,
        fullWidth: true
    };
    var ref10 = (0,react.useState)(null), tab = ref10[0], setTab = ref10[1];
    var getLabel = function(i) {
        var ref, ref1, ref2;
        return (0,helpers/* getEntryLabel */.ax)((ref = watch1()) === null || ref === void 0 ? void 0 : (ref1 = ref[id]) === null || ref1 === void 0 ? void 0 : ref1[i], (ref2 = watch1()) === null || ref2 === void 0 ? void 0 : ref2.schema);
    };
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,many/* useGetEntries */.e1)({
        filter: {
            collectionId: collectionId
        },
        limit: 1,
        skip: 0
    }), 1), entries = ref11[0];
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetCollection */.YD)({
        _id: collectionId,
        silent: true
    }), 1), coll = ref12[0];
    var entry = (0,useDataQuery/* convertEntry */.ec)(entries === null || entries === void 0 ? void 0 : entries[0]);
    var mail = (0,utils_mail/* useEntryMailConversion */.y)({
        entry: entry,
        template: (ref5 = watch1()) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[id]) === null || ref6 === void 0 ? void 0 : ref6[tab],
        baseRoute: coll === null || coll === void 0 ? void 0 : coll.baseRoute,
        schema: coll === null || coll === void 0 ? void 0 : coll.schema
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ControlButtons/* default */.Z, {
                options: fields === null || fields === void 0 ? void 0 : fields.map(function(_, index) {
                    return {
                        label: getLabel(index),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* FileIcon */.aAW, {}),
                        value: "".concat(index)
                    };
                }),
                setActive: setTab,
                active: tab,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorVariables, {
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            style: {
                                border: "".concat(colors/* default.util.orange.lighter */.ZP.util.orange.lighter, " 1px solid"),
                                color: colors/* default.util.orange.dark */.ZP.util.orange.dark
                            },
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TokensIcon */.Nn4, {}),
                            m: 0,
                            ml: 2,
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "Variables"
                            }),
                            minWidth: "100px"
                        }),
                        collectionId: collectionId
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                        onClick: function() {
                            return append({});
                        },
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* PlusCircledIcon */.SPS, {}),
                        label: "Add template"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectLocales/* SelectLocales */.I, {
                locales: hasLocalizedFields ? locales : null,
                active: activeLang,
                setActive: setLang
            }),
            fields === null || fields === void 0 ? void 0 : fields.map(function(template, index) {
                var ref;
                return "".concat(index) === tab ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorTemplates_Entry, {
                    mail: mail,
                    id: id,
                    index: index,
                    inputProps: inputProps,
                    schema: (ref = watch1()) === null || ref === void 0 ? void 0 : ref.schema,
                    locales: {
                        locales: locales,
                        locale: locale,
                        activeLang: activeLang
                    },
                    label: "Template: ".concat(index + 1),
                    remove: function() {
                        var ref;
                        setTab(fields === null || fields === void 0 ? void 0 : (ref = fields[0]) === null || ref === void 0 ? void 0 : ref.id);
                        remove(index);
                    }
                }) : null;
            })
        ]
    });
};
var EditorTemplates_Entry = function(param) {
    var schema = param.schema, locales = param.locales, _label = param.label, label = _label === void 0 ? null : _label, _cols = param.cols, cols = _cols === void 0 ? 1 : _cols, id = param.id, index = param.index, remove = param.remove, mail = param.mail;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* TwoColumns */.VZ, {
        first: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
            fullWidth: true,
            cols: cols,
            style: {
                width: "100%"
            },
            border: true,
            label: label,
            children: [
                schema === null || schema === void 0 ? void 0 : schema.map(function(field) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Input_Input/* LocalizedInput */.TY, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, locales), {
                        type: field === null || field === void 0 ? void 0 : field.type,
                        // value={field?.default} 
                        field: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                            name: "".concat(id, ".").concat(index, ".").concat(field === null || field === void 0 ? void 0 : field.name),
                            label: (0,Text/* revertDevCases */.Uw)((0,Text/* isString */.HD)(field === null || field === void 0 ? void 0 : field.label) ? field.label : field === null || field === void 0 ? void 0 : field.name)
                        }),
                        help: field === null || field === void 0 ? void 0 : field.help,
                        options: (0,helpers/* getFieldOptions */._K)(field),
                        relation: (0,helpers/* getFieldRelation */.nj)(field),
                        schema: (0,helpers/* shouldPassSchema */.Eu)(field) ? collection.schema : null,
                        data: (0,helpers/* shouldPassData */.wg)(field) ? watch() : null,
                        // {...inputProps}
                        fullWidth: (field === null || field === void 0 ? void 0 : field.fullWidth) ? field.fullWidth : false
                    }));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    mt: 4,
                    ml: 0,
                    onClick: function() {
                        return remove();
                    },
                    label: "Remove template"
                })
            ]
        }),
        second: /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
            trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Preview, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: mail === null || mail === void 0 ? void 0 : mail.subject
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreHeader, {
                        children: mail === null || mail === void 0 ? void 0 : mail.preHeader
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:".concat(mail === null || mail === void 0 ? void 0 : mail.to),
                        children: mail === null || mail === void 0 ? void 0 : mail.to
                    })
                ]
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Mail, {
                border: true,
                children: [
                    (mail === null || mail === void 0 ? void 0 : mail.subHeader) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: mail.subHeader
                    }),
                    (mail === null || mail === void 0 ? void 0 : mail.mainHeader) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: mail.mainHeader
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: mail === null || mail === void 0 ? void 0 : mail.content
                        }
                    }),
                    (mail === null || mail === void 0 ? void 0 : mail.mainHeader) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterLink, {
                        href: "/",
                        children: "email dynamic code"
                    }),
                    (mail === null || mail === void 0 ? void 0 : mail.sectionFooterHeader) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: mail.sectionFooterHeader
                    }),
                    (mail === null || mail === void 0 ? void 0 : mail.sectionFooterText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: mail === null || mail === void 0 ? void 0 : mail.sectionFooterText
                        }
                    })
                ]
            })
        })
    });
};
var CenterLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-d168fd43-0"
})(_templateObject());
var Preview = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d168fd43-1"
})(_templateObject1());
var PreHeader = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-d168fd43-2"
})(_templateObject2());
var Mail = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-d168fd43-3"
})(_templateObject3());

// EXTERNAL MODULE: ./src/adapters/schemas/users.js
var users = __webpack_require__(75211);
;// CONCATENATED MODULE: ./src/mosanic/cms/Editor/EditorProvider.js

































var EditorProvider_ReactJson = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8047).then(__webpack_require__.t.bind(__webpack_require__, 48047, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48047)
            ];
        }
    },
    ssr: false
});
var Item = function(param) {
    var item = param.item;
    /*#__PURE__*/ return _jsxs("div", {
        children: [
            item === null || item === void 0 ? void 0 : item.id,
            " x"
        ]
    });
};
var EditorProvider = function(param) {
    var _initial = param.initial, initial = _initial === void 0 ? null : _initial, _formType = param.formType, formType = _formType === void 0 ? "create" : _formType, _redirect = param.redirect, redirect = _redirect === void 0 ? true : _redirect, _callback = param.callback, callback = _callback === void 0 ? null : _callback, _stopEditing = param.stopEditing, stopEditing = _stopEditing === void 0 ? function() {
        return null;
    } : _stopEditing, _dataHookMethods = param.dataHookMethods, dataHookMethods = _dataHookMethods === void 0 ? null : _dataHookMethods, _entryHookMethods = param.entryHookMethods, entryHookMethods = _entryHookMethods === void 0 ? null : _entryHookMethods, _type = param.type, type = _type === void 0 ? "collection" : _type, _types = param.types, types = _types === void 0 ? [
        "collection",
        "form"
    ] : _types, singular = param.singular, _baseSchema = param.baseSchema, baseSchema = _baseSchema === void 0 ? users/* userSchema */.IK : _baseSchema;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    singular = singular || type;
    var methods = (0,index_esm/* useForm */.cI)({
        mode: "all",
        defaultValues: initial
    });
    var formData = methods.watch();
    var schema = formData === null || formData === void 0 ? void 0 : formData.schema;
    // const schema = formData?.schema
    var ref9 = (0,_sliced_to_array/* default */.Z)((dataHookMethods === null || dataHookMethods === void 0 ? void 0 : dataHookMethods[formType]) ? dataHookMethods === null || dataHookMethods === void 0 ? void 0 : dataHookMethods[formType]({
        callback: callback,
        formData: formData
    }) : [
        function() {
            return null;
        },
        [
            null,
            false,
            null
        ]
    ], 2), action = ref9[0], ref10 = (0,_sliced_to_array/* default */.Z)(ref9[1], 3), data = ref10[0], loading = ref10[1], error = ref10[2];
    var isValid = methods.formState.isValid;
    var ref11 = (0,react.useState)(false), disabled = ref11[0], setDisabled = ref11[1];
    var ref12 = (0,react.useState)(false), init = ref12[0], setInit = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useCreateCollection/* useCreateCollection */.$)({
        redirect: redirect,
        type: type
    }), 2), addCollection = ref13[0], ref14 = (0,_sliced_to_array/* default */.Z)(ref13[1], 3), dataAdd = ref14[0], loadingAdd = ref14[1], errorAdd = ref14[2];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useUpdateCollection/* useUpdateCollection */.v)({
        callback: callback
    }), 2), update = ref15[0], ref16 = (0,_sliced_to_array/* default */.Z)(ref15[1], 3), dataUpdate = ref16[0], loadingUpdate = ref16[1], errorUpdate = ref16[2];
    var ref17 = (0,react.useState)(false), saving = ref17[0], setSaving = ref17[1];
    var ref18 = (0,react.useState)(null), progress = ref18[0], setProgress = ref18[1];
    // const [ids, setIds] = useState([null])
    var onSubmit = function(data) {
        if ((0,Obj/* hasAttr */.B$)(data, "preventDefault")) data === null || data === void 0 ? void 0 : data.preventDefault();
        console.log(data);
        // if(mode === 'transform') return;
        // if(!saving) return
        // setDisabled(true)
        // if(formType === 'create') {
        // 	addCollection({formData: data})
        // } else {
        // 	update({formData: {...data, linked: undefined, baseFields: convert}})
        // }
        console.log(dataHookMethods);
        // 	action({data: {
        // 		...data?.linked ? ({
        // 			...data,
        // 			entries: [...new Set(data?.entries?.map(e => e?._id || e))]
        // 		}) : data,
        // 		linked: undefined
        // 	}
        // })
        action({
            data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                linked: undefined
            })
        });
        // action({data: {
        // 	...data,
        // }})
        setDisabled(false);
        setSaving(false);
    };
    var triggerSave = function() {
        setSaving(true);
    };
    (0,react.useEffect)(function() {
        if (initial || init || formType != "create") {
            methods.reset(initial);
            return;
        } else if (baseSchema.schema) {
            methods.reset({
                schema: baseSchema.schema
            });
        }
        // methods.reset({
        // 	schema:[{
        // 		formType:"text",
        // 		id: ObjectID(),
        // 		name:"",
        // 		help:"",
        // 		default:"",
        // 		required:true
        // 	}]	
        // })
        setInit(true);
    }, [
        init,
        methods,
        initial,
        formType,
        baseSchema.schema
    ]);
    var ref19 = (0,react.useState)("base"), mode = ref19[0], setModeTab = ref19[1];
    var setMode = function(t) {
        return t === "return" ? stopEditing() : setModeTab(t);
    };
    var tabOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Return"
            }),
            value: "return",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowLeftIcon */.Y4O, {})
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Schema"
            }),
            value: "base",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* Component1Icon */.JMc, {})
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Templates"
            }),
            value: "templates",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* FileIcon */.aAW, {})
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Edit fields styling"
            }),
            value: "styling",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* BlendingModeIcon */.EGi, {})
        }, 
    ];
    if (baseSchema === null || baseSchema === void 0 ? void 0 : baseSchema.groups) tabOptions = tabOptions === null || tabOptions === void 0 ? void 0 : tabOptions.filter(function(tab) {
        var ref;
        return (baseSchema === null || baseSchema === void 0 ? void 0 : (ref = baseSchema.groups) === null || ref === void 0 ? void 0 : ref.includes(tab === null || tab === void 0 ? void 0 : tab.value)) || (tab === null || tab === void 0 ? void 0 : tab.value) === "return";
    });
    if ((formData === null || formData === void 0 ? void 0 : (ref = formData.schema) === null || ref === void 0 ? void 0 : ref.length) >= 1 && ((ref2 = formData === null || formData === void 0 ? void 0 : (ref1 = formData.schema) === null || ref1 === void 0 ? void 0 : ref1.filter(function(f) {
        return !(f === null || f === void 0 ? void 0 : f.name);
    })) === null || ref2 === void 0 ? void 0 : ref2.length) === 0) tabOptions = (0,_to_consumable_array/* default */.Z)(tabOptions).concat([
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Preview"
            }),
            value: "preview",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* EyeOpenIcon */.hsE, {})
        }
    ]);
    if (formData === null || formData === void 0 ? void 0 : formData.collectionId) tabOptions = (0,_to_consumable_array/* default */.Z)(tabOptions).concat([
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Variables"
            }),
            value: "variables",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TokensIcon */.Nn4, {})
        }
    ]);
    if (formData === null || formData === void 0 ? void 0 : formData.linked) tabOptions = (0,_to_consumable_array/* default */.Z)(tabOptions).concat([
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Base fields"
            }),
            value: "entry",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* InputIcon */.SQj, {})
        }
    ]);
    if (!(0,Text/* isString */.HD)(formData === null || formData === void 0 ? void 0 : (ref3 = formData.entries) === null || ref3 === void 0 ? void 0 : ref3[0]) && !(formData === null || formData === void 0 ? void 0 : formData.linked) && (formData === null || formData === void 0 ? void 0 : (ref4 = formData.entries) === null || ref4 === void 0 ? void 0 : ref4[0])) tabOptions = (0,_to_consumable_array/* default */.Z)(tabOptions).concat([
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Transform"
            }),
            value: "transform",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* RocketIcon */.WCv, {})
        }
    ]);
    if ((initial === null || initial === void 0 ? void 0 : initial.entries) && (initial === null || initial === void 0 ? void 0 : initial.schema)) tabOptions = (0,_to_consumable_array/* default */.Z)(tabOptions).concat([
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Entries"
            }),
            value: "entries",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ListBulletIcon */.jVc, {})
        }
    ]);
    if ((baseSchema === null || baseSchema === void 0 ? void 0 : (ref5 = baseSchema.groups) === null || ref5 === void 0 ? void 0 : ref5.includes("log")) && (initial === null || initial === void 0 ? void 0 : initial.schema)) tabOptions = (0,_to_consumable_array/* default */.Z)(tabOptions).concat([
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Log"
            }),
            value: "entries",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ListBulletIcon */.jVc, {})
        }
    ]);
    //form-row mb-3
    var hasField = function(name) {
        var attr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "base";
        var ref, ref1;
        return ((ref1 = (ref = baseSchema[attr]) === null || ref === void 0 ? void 0 : ref.filter(function(f) {
            return (f === null || f === void 0 ? void 0 : f.name) === name || (f === null || f === void 0 ? void 0 : f.slug) === name;
        })) === null || ref1 === void 0 ? void 0 : ref1.length) >= 1;
    };
    var getField = function(name) {
        var attr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "base";
        var ref;
        return (ref = baseSchema[attr]) === null || ref === void 0 ? void 0 : ref.find(function(f) {
            return (f === null || f === void 0 ? void 0 : f.name) === name || (f === null || f === void 0 ? void 0 : f.slug) === name;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlButtons/* ControlTabs */.i, {
                active: mode,
                setActive: setMode,
                lines: 2,
                mx: 3,
                mb: 4,
                options: tabOptions
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                disabled: disabled || formType === "preview",
                onSubmit: methods.handleSubmit(onSubmit),
                children: [
                    mode === "transform" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorTransform, {
                        schema: schema,
                        formData: formData,
                        callback: callback,
                        handler: dataHookMethods === null || dataHookMethods === void 0 ? void 0 : dataHookMethods[formType]
                    }) : mode === "entry" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorBaseFields, {
                        schema: schema,
                        formData: formData,
                        callback: callback,
                        handler: dataHookMethods === null || dataHookMethods === void 0 ? void 0 : dataHookMethods[formType]
                    }) : [
                        "variables"
                    ].includes(mode) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorVariables, {
                        collectionId: formData === null || formData === void 0 ? void 0 : formData.collectionId
                    }) : mode === "templates" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorTemplates, {
                        collectionId: formData === null || formData === void 0 ? void 0 : formData.collectionId,
                        schema: formData === null || formData === void 0 ? void 0 : formData.schema,
                        templates: formData === null || formData === void 0 ? void 0 : formData.templates
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid_styles/* Wrap */.Eq, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_styles/* Col */.JX, {
                                width: [
                                    1,
                                    1,
                                    1 / 2
                                ],
                                px: 2,
                                children: mode === "entries" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DataGrid/* DataGrid */._, {
                                            formData: methods.watch()
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorProvider_ReactJson, {
                                            collapsed: true,
                                            name: "data",
                                            src: {
                                                baseSchema: baseSchema,
                                                formData: formData
                                            }
                                        })
                                    ]
                                }) : mode === "base" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorBase, {
                                        type: type,
                                        types: types,
                                        hasField: hasField,
                                        getField: getField,
                                        singular: singular,
                                        fields: baseSchema === null || baseSchema === void 0 ? void 0 : baseSchema.base
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Entry/* Entry */.k, {
                                    cols: 1,
                                    initial: formData === null || formData === void 0 ? void 0 : (ref6 = formData.entries) === null || ref6 === void 0 ? void 0 : ref6[0],
                                    collection: {
                                        schema: formData === null || formData === void 0 ? void 0 : formData.schema
                                    },
                                    formType: "preview",
                                    preview: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_styles/* Col */.JX, {
                                width: [
                                    1,
                                    1,
                                    1 / 2
                                ],
                                px: 2,
                                children: mode === "styling" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                            as: "h4",
                                            label: "Coming soon"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedLabel/* AdvancedLabel */.qv, {
                                            width: "70%",
                                            children: [
                                                "We're currently working on two ways to style your fields. ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "The first version will be released inside this module, where you will be able to setup general field styling. We will expand this in the near future and integrate it fully inside the builder, where you can drag an drop your input fields. ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "Stay tuned! ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "-The Mosanic Team"
                                            ]
                                        })
                                    ]
                                }) : (baseSchema === null || baseSchema === void 0 ? void 0 : (ref7 = baseSchema.groups) === null || ref7 === void 0 ? void 0 : ref7.includes("schema")) ? // <div style={{marginTop: '-50px'}}>
                                // <FieldHeaderLabels/>
                                // <div style={{maxHeight: '67vh', overflow: 'scroll'}}>
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldsCollection/* FieldsCollection */.X, {
                                    ctx: {
                                        entry: formData === null || formData === void 0 ? void 0 : (ref8 = formData.entries) === null || ref8 === void 0 ? void 0 : ref8[0]
                                    }
                                }) : null
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                label: loading || loadingUpdate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : mode === "transform" ? "Yes, transform" : formType === "create" ? "Create ".concat(singular) : "Update ".concat(singular),
                                theme: "primary",
                                size: "large",
                                type: "submit",
                                disabled: Boolean(disabled || !isValid) && !error && formType != "preview",
                                onClick: triggerSave
                            })
                        ]
                    }),
                    error,
                    " ",
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {})
                ]
            })
        ]
    }));
};
/* harmony default export */ var Editor_EditorProvider = (EditorProvider);


/***/ }),

/***/ 33714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$J": function() { return /* binding */ useCreateCollection; },
/* harmony export */   "Fn": function() { return /* binding */ useCreateMail; },
/* harmony export */   "Sb": function() { return /* binding */ createEntryFormatter; },
/* harmony export */   "l$": function() { return /* binding */ useCreateChat; },
/* harmony export */   "l2": function() { return /* binding */ useCreateEntry; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66383);
/* harmony import */ var _api_mutations_collections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73755);
/* harmony import */ var _useDataMutate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39656);
/* harmony import */ var _api_mutations_entry__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54335);
/* harmony import */ var _mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49272);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68311);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62570);
/* harmony import */ var _api_mutations_mail__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15566);
/* harmony import */ var _api_mutations_chats__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81970);












var useCreateItem = function(_param) {
    var formatter = _param.formatter, mutation = _param.mutation, type = _param.type, _siteCheck = _param.siteCheck, siteCheck = _siteCheck === void 0 ? true : _siteCheck, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "formatter",
        "mutation",
        "type",
        "siteCheck"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_useDataMutate__WEBPACK_IMPORTED_MODULE_2__/* .useCreate */ .RO)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        formatter: formatter,
        mutation: mutation,
        type: type,
        silent: true,
        siteCheck: siteCheck
    }, other)), 2), update = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    return [
        update,
        [
            data,
            loading,
            error
        ]
    ];
};
var useCreateCollection = function() {
    return useCreateItem({
        mutation: _api_mutations_collections__WEBPACK_IMPORTED_MODULE_4__/* .ADD_COLLECTION */ .nU,
        type: "collection",
        formatter: function(data) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
                date: new Date(),
                _id: undefined
            });
        }
    });
};
var getInfoFields = function(data, schema) {
    return {
        title: (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getEntryLabel */ .ax)(data, schema),
        description: (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getEntryDescription */ .$n)(data, schema)
    };
};
var createEntryFormatter = function(data, collection) {
    var ref;
    var _id = collection._id, schema = collection.schema;
    var hasSeo = collection === null || collection === void 0 ? void 0 : (ref = collection.routing) === null || ref === void 0 ? void 0 : ref.catchRoutes;
    return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_7__/* .removeUndefined */ .o2)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
            date: undefined,
            updatedAt: undefined,
            userId: undefined,
            _id: undefined,
            siteId: undefined
        })
    }, getInfoFields(data, schema)), {
        image: (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getEntryImage */ .Oh)(data, schema),
        seo: hasSeo ? getInfoFields(data, schema) : undefined,
        slug: hasSeo ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_8__/* .slugify */ .lV)((0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getEntryLabel */ .ax)(data, schema)) : undefined,
        collectionId: _id,
        userId: (data === null || data === void 0 ? void 0 : data.userId) ? data.userId : undefined,
        date: (data === null || data === void 0 ? void 0 : data.date) ? data.date : new Date(),
        updatedAt: new Date(),
        siteId: data === null || data === void 0 ? void 0 : data.siteId,
        _id: undefined
    }));
};
var useCreateEntry = function(_param) {
    var collection = _param.collection, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "collection"
    ]);
    var formatter = function(data) {
        return createEntryFormatter(data, collection);
    };
    return useCreateItem((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        mutation: _api_mutations_entry__WEBPACK_IMPORTED_MODULE_9__/* .ADD_ENTRY */ .tr,
        loggedInCheck: "direct",
        siteCheck: "direct",
        type: "entry",
        formatter: formatter
    }, other));
};
var useCreateMail = function() {
    return useCreateItem({
        mutation: _api_mutations_mail__WEBPACK_IMPORTED_MODULE_10__/* .ADD_MAIL */ .a,
        type: "mail",
        formatter: function(data) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
                date: new Date(),
                _id: undefined
            });
        }
    });
};
var useCreateChat = function() {
    return useCreateItem({
        mutation: _api_mutations_chats__WEBPACK_IMPORTED_MODULE_11__/* .ADD_CHAT */ .i,
        type: "chat",
        siteCheck: false,
        formatter: function(data) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
                date: new Date(),
                isActive: true,
                _id: undefined
            });
        }
    });
};


/***/ }),

/***/ 39761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Bg": function() { return /* binding */ collectionHooks; },
  "tf": function() { return /* binding */ entryHooks; },
  "c4": function() { return /* binding */ mailHooks; },
  "iv": function() { return /* binding */ userHooks; }
});

// UNUSED EXPORTS: useCreateCollection, useCreateEntry, useRemoveCollection, useRemoveEntry, useUpdateCollection, useUpdateEntry

// EXTERNAL MODULE: ./src/mosanic/cms/Mutate/create.js
var create = __webpack_require__(33714);
// EXTERNAL MODULE: ./src/mosanic/cms/Mutate/update.js
var update = __webpack_require__(80581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/adapters/mutations/collections.js
var collections = __webpack_require__(73755);
// EXTERNAL MODULE: ./src/mosanic/cms/Mutate/useDataMutate.js
var useDataMutate = __webpack_require__(39656);
// EXTERNAL MODULE: ./src/adapters/mutations/entry.js
var entry = __webpack_require__(54335);
;// CONCATENATED MODULE: ./src/mosanic/cms/Mutate/remove.js







var useRemoveItem = function(_param) {
    var mutation = _param.mutation, type = _param.type, _siteCheck = _param.siteCheck, siteCheck = _siteCheck === void 0 ? true : _siteCheck, other = (0,_object_without_properties/* default */.Z)(_param, [
        "mutation",
        "type",
        "siteCheck"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useDataMutate/* useRemove */.mt)((0,_object_spread/* default */.Z)({
        mutation: mutation,
        type: type,
        silent: true,
        siteCheck: siteCheck
    }, other)), 2), update = ref[0], ref1 = (0,_sliced_to_array/* default */.Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    return [
        update,
        [
            data,
            loading,
            error
        ]
    ];
};
var useRemoveCollection = function(_param) {
    var other = (0,_extends/* default */.Z)({}, _param);
    return useRemoveItem((0,_object_spread/* default */.Z)({
        mutation: collections/* REMOVE_COLLECTION */.of,
        type: "collection"
    }, other));
};
var useRemoveEntry = function(_param) {
    var other = (0,_extends/* default */.Z)({}, _param);
    return useRemoveItem((0,_object_spread/* default */.Z)({
        mutation: entry/* REMOVE_ENTRY */.oT,
        type: "entry"
    }, other));
};

;// CONCATENATED MODULE: ./src/mosanic/cms/Mutate/index.js




var collectionHooks = {
    create: create/* useCreateCollection */.$J,
    update: update/* useUpdateCollection */.vU,
    remove: useRemoveCollection
};
var entryHooks = {
    create: create/* useCreateEntry */.l2,
    update: update/* useUpdateEntry */.Hk,
    remove: useRemoveEntry
};
var userHooks = {
    create: null,
    update: update/* useUpdateUser */.Io,
    remove: null
};
var mailHooks = {
    create: create/* useCreateMail */.Fn,
    update: update/* useUpdateMail */.si,
    remove: null
};


/***/ }),

/***/ 80581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hk": function() { return /* binding */ useUpdateEntry; },
/* harmony export */   "Io": function() { return /* binding */ useUpdateUser; },
/* harmony export */   "RF": function() { return /* binding */ useUpdateChat; },
/* harmony export */   "Z0": function() { return /* binding */ useUpdateTeam; },
/* harmony export */   "si": function() { return /* binding */ useUpdateMail; },
/* harmony export */   "vU": function() { return /* binding */ useUpdateCollection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66383);
/* harmony import */ var _api_mutations_collections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73755);
/* harmony import */ var _useDataMutate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39656);
/* harmony import */ var _api_mutations_entry__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54335);
/* harmony import */ var _Query_useDataQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49974);
/* harmony import */ var _api_mutations_users__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38374);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68311);
/* harmony import */ var _mosanic_components_Team_Handlers_useEditTeam__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32131);
/* harmony import */ var _api_mutations_mail__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15566);
/* harmony import */ var _api_mutations_chats__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81970);















var useUpdateItem = function(_param) {
    var formatter = _param.formatter, mutation = _param.mutation, type = _param.type, _siteCheck = _param.siteCheck, siteCheck = _siteCheck === void 0 ? true : _siteCheck, _silent = _param.silent, silent = _silent === void 0 ? false : _silent, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "formatter",
        "mutation",
        "type",
        "siteCheck",
        "silent"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_useDataMutate__WEBPACK_IMPORTED_MODULE_2__/* .useUpdate */ .PQ)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        formatter: formatter,
        mutation: mutation,
        type: type,
        silent: silent,
        siteCheck: siteCheck
    }, other)), 2), update = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    return [
        update,
        [
            data,
            loading,
            error
        ]
    ];
};
var useUpdateCollection = function() {
    return useUpdateItem({
        mutation: _api_mutations_collections__WEBPACK_IMPORTED_MODULE_4__/* .UPDATE_COLLECTION */ .Oy,
        type: "collection",
        formatter: function(data) {
            return {
                _id: data === null || data === void 0 ? void 0 : data._id,
                record: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
                    updatedAt: new Date(),
                    _id: undefined
                })
            };
        }
    });
};
var useUpdateEntry = function(_param) {
    var collection = _param.collection, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "collection"
    ]);
    var ref = collection || {
        _id: null,
        schema: []
    }, _id = ref._id, schema = ref.schema;
    var formatter = function(data) {
        return {
            record: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,_Query_useDataQuery__WEBPACK_IMPORTED_MODULE_6__/* .convertEntryBack */ .Qb)(data, schema)), {
                collectionId: _id,
                _id: undefined
            }),
            _id: data === null || data === void 0 ? void 0 : data._id
        };
    };
    return useUpdateItem((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        mutation: _api_mutations_entry__WEBPACK_IMPORTED_MODULE_7__/* .UPDATE_ENTRY */ .yN,
        type: "entry",
        formatter: formatter
    }, other));
};
var useUpdateUser = function() {
    var silent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var formatter = function(data) {
        var _obj;
        return {
            record: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), (_obj = {
                updatedAt: new Date(),
                firstName: undefined,
                lastName: undefined,
                status: (0,_util_Text__WEBPACK_IMPORTED_MODULE_8__/* .capitalizeFirst */ .Ez)(data === null || data === void 0 ? void 0 : data.status)
            }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "status", undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "slug", undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "date", undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "type", undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "updatedAt", undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "_id", undefined), _obj)),
            _id: data === null || data === void 0 ? void 0 : data._id
        };
    };
    return useUpdateItem({
        mutation: _api_mutations_users__WEBPACK_IMPORTED_MODULE_10__/* .UPDATE_USER */ .AX,
        type: "user",
        siteCheck: false,
        loggedInCheck: false,
        formatter: formatter,
        silent: silent
    });
};
var useUpdateTeam = function(param) {
    var callback = param.callback;
    return (0,_mosanic_components_Team_Handlers_useEditTeam__WEBPACK_IMPORTED_MODULE_11__/* .useEditTeam */ .t)({
        callback: callback
    });
};
var useUpdateMail = function() {
    return useUpdateItem({
        mutation: _api_mutations_mail__WEBPACK_IMPORTED_MODULE_12__/* .UPDATE_MAIL */ .P,
        type: "mail",
        formatter: function(data) {
            return {
                _id: data === null || data === void 0 ? void 0 : data._id,
                record: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
                    updatedAt: new Date(),
                    Fields: undefined,
                    Entries: undefined,
                    _id: undefined
                })
            };
        }
    });
};
var useUpdateChat = function() {
    return useUpdateItem({
        mutation: _api_mutations_chats__WEBPACK_IMPORTED_MODULE_13__/* .UPDATE_CHAT */ .c,
        type: "chat",
        siteCheck: false,
        silent: false,
        formatter: function(data) {
            return {
                _id: data === null || data === void 0 ? void 0 : data._id,
                record: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
                    updatedAt: new Date(),
                    _id: undefined
                })
            };
        }
    });
};


/***/ }),

/***/ 39656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PQ": function() { return /* binding */ useUpdate; },
/* harmony export */   "RO": function() { return /* binding */ useCreate; },
/* harmony export */   "mt": function() { return /* binding */ useRemove; }
/* harmony export */ });
/* unused harmony export useRemoveMany */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66383);
/* harmony import */ var _api_mutations_entry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54335);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70210);
/* harmony import */ var _mosanic_hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33346);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68311);
/* harmony import */ var _api_token__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94645);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25157);
/* harmony import */ var _util_Funct__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3847);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);












var createEntry = function(data) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
        date: (data === null || data === void 0 ? void 0 : data.date) ? data === null || data === void 0 ? void 0 : data.date : new Date(),
        updatedAt: (data === null || data === void 0 ? void 0 : data.updatedAt) ? data === null || data === void 0 ? void 0 : data.updatedAt : new Date()
    });
};
var useDataMutate = function(param) {
    var _callback = param.callback, callback = _callback === void 0 ? null : _callback, _redirect = param.redirect, redirect = _redirect === void 0 ? null : _redirect, _type = param.type, type = _type === void 0 ? "entry" : _type, _silent = param.silent, silent = _silent === void 0 ? false : _silent, _action = param.action, action = _action === void 0 ? "create" : _action, _method = param.method, method = _method === void 0 ? "CreateOne" : _method, _mutation = param.mutation, mutation = _mutation === void 0 ? _api_mutations_entry__WEBPACK_IMPORTED_MODULE_4__/* .ADD_ENTRY */ .tr : _mutation, _formatter = param.formatter, formatter = _formatter === void 0 ? function(data) {
        return createEntry(data);
    } : _formatter, _loggedInCheck = param.loggedInCheck, loggedInCheck = _loggedInCheck === void 0 ? true : _loggedInCheck, _siteCheck = param.siteCheck, siteCheck = _siteCheck === void 0 ? true : _siteCheck;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var shouldRedirect = Boolean(redirect && (0,_util_Text__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(redirect));
    var isAuth = (0,_api_token__WEBPACK_IMPORTED_MODULE_6__/* .isAuthenticated */ .$8)();
    var userId = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_7__/* .userIdSelector */ .dY);
    var siteId = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_7__/* .siteIdSelector */ .uL);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_9__/* .useMutate */ .Tu)("".concat(type).concat(method), mutation), 2), dispatch = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var handler = function(param) {
        var data = param.data;
        // if(!isAuth && !loggedInCheck) {notify(`You are not authenticated to ${action} a ${type}.`);return;}
        // if(!siteId && siteCheck) {notify('No active site selected.');return;}
        data = (0,_util_Funct__WEBPACK_IMPORTED_MODULE_11__/* .isFunc */ .W)(formatter) ? formatter(data) : data;
        var record = data;
        // console.log(data)
        if (method === "CreateOne" && (!(data === null || data === void 0 ? void 0 : data.userId) || !(data === null || data === void 0 ? void 0 : data.siteId))) {
            record = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
                siteId: siteId
            });
        }
        //For update by id, the _id is also passed
        var variables = (record === null || record === void 0 ? void 0 : record.record) ? record : {
            record: record
        };
        dispatch(variables).then(function(res) {
            var data = res.data, error = res.error;
            if (data === null || data === void 0 ? void 0 : data["".concat(type).concat(method)]) data = data["".concat(type).concat(method)];
            if (!error && (data === null || data === void 0 ? void 0 : data.recordId)) {
                if (!silent) notify("Success: ".concat(action, " ").concat(type, "."), "app", "success");
                if (callback) callback(data === null || data === void 0 ? void 0 : data.recordId);
                if (shouldRedirect) router.push((data === null || data === void 0 ? void 0 : data.recordId) ? "".concat(redirect, "/").concat(data.recordId) : redirect);
            } else if (error) {
                notify("An error occurred during the ".concat(type, " ").concat(action, "."));
            // console.log({error, record});
            } else {
                notify("Unknown: ".concat(action, " ").concat(type, "."), "app", "info");
                console.log(res);
            }
        });
    };
    return [
        handler,
        [
            data,
            loading,
            error
        ]
    ];
};
var useCreate = function(param) {
    var _callback = param.callback, callback = _callback === void 0 ? null : _callback, _redirect = param.redirect, redirect = _redirect === void 0 ? null : _redirect, _type = param.type, type = _type === void 0 ? "entry" : _type, _mutation = param.mutation, mutation = _mutation === void 0 ? _api_mutations_entry__WEBPACK_IMPORTED_MODULE_4__/* .ADD_ENTRY */ .tr : _mutation, _loggedInCheck = param.loggedInCheck, loggedInCheck = _loggedInCheck === void 0 ? true : _loggedInCheck, _siteCheck = param.siteCheck, siteCheck = _siteCheck === void 0 ? true : _siteCheck, _formatter = param.formatter, formatter = _formatter === void 0 ? null : _formatter;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(useDataMutate({
        callback: callback,
        redirect: redirect,
        type: type,
        mutation: mutation,
        loggedInCheck: loggedInCheck,
        siteCheck: siteCheck,
        formatter: formatter,
        action: "create"
    }), 2), handler = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    return [
        handler,
        [
            data,
            loading,
            error
        ]
    ];
};
var useUpdate = function(param) {
    var _callback = param.callback, callback = _callback === void 0 ? null : _callback, _redirect = param.redirect, redirect = _redirect === void 0 ? null : _redirect, _type = param.type, type = _type === void 0 ? "entry" : _type, _mutation = param.mutation, mutation = _mutation === void 0 ? _api_mutations_entry__WEBPACK_IMPORTED_MODULE_4__/* .UPDATE_ENTRY */ .yN : _mutation, _formatter = param.formatter, formatter = _formatter === void 0 ? false : _formatter, _silent = param.silent, silent = _silent === void 0 ? false : _silent, _loggedInCheck = param.loggedInCheck, loggedInCheck = _loggedInCheck === void 0 ? true : _loggedInCheck, _siteCheck = param.siteCheck, siteCheck = _siteCheck === void 0 ? true : _siteCheck, _method = param.method, method = _method === void 0 ? "UpdateById" : _method;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(useDataMutate({
        callback: callback,
        redirect: redirect,
        type: type,
        silent: silent,
        mutation: mutation,
        loggedInCheck: loggedInCheck,
        siteCheck: siteCheck,
        formatter: formatter,
        action: "update",
        method: method
    }), 2), handler = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    return [
        handler,
        [
            data,
            loading,
            error
        ]
    ];
};
var useRemove = function(param) {
    var _callback = param.callback, callback = _callback === void 0 ? null : _callback, _redirect = param.redirect, redirect = _redirect === void 0 ? null : _redirect, _type = param.type, type = _type === void 0 ? "entry" : _type, _method = param.method, method = _method === void 0 ? "RemoveById" : _method, _mutation = param.mutation, mutation = _mutation === void 0 ? _api_mutations_entry__WEBPACK_IMPORTED_MODULE_4__/* .REMOVE_ENTRY */ .oT : _mutation, _loggedInCheck = param.loggedInCheck, loggedInCheck = _loggedInCheck === void 0 ? true : _loggedInCheck, _siteCheck = param.siteCheck, siteCheck = _siteCheck === void 0 ? true : _siteCheck;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(useDataMutate({
        callback: callback,
        redirect: redirect,
        method: method,
        type: type,
        mutation: mutation,
        loggedInCheck: loggedInCheck,
        siteCheck: siteCheck,
        action: "delete"
    }), 2), handler = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    return [
        handler,
        [
            data,
            loading,
            error
        ]
    ];
};
var useRemoveMany = function(param) {
    var _callback = param.callback, callback = _callback === void 0 ? null : _callback, _redirect = param.redirect, redirect = _redirect === void 0 ? null : _redirect, _type = param.type, type = _type === void 0 ? "entry" : _type, _method = param.method, method = _method === void 0 ? "RemoveMany" : _method, _mutation = param.mutation, mutation = _mutation === void 0 ? REMOVE_ENTRIES : _mutation, _loggedInCheck = param.loggedInCheck, loggedInCheck = _loggedInCheck === void 0 ? true : _loggedInCheck, _siteCheck = param.siteCheck, siteCheck = _siteCheck === void 0 ? true : _siteCheck;
    var ref = _sliced_to_array(useDataMutate({
        callback: callback,
        redirect: redirect,
        method: method,
        type: type,
        mutation: mutation,
        loggedInCheck: loggedInCheck,
        siteCheck: siteCheck,
        action: "delete"
    }), 2), handler = ref[0], ref1 = _sliced_to_array(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    return [
        handler,
        [
            data,
            loading,
            error
        ]
    ];
};


/***/ }),

/***/ 40010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ PaginationLimit; },
  "Z": function() { return /* binding */ cms_Pagination_Pagination; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/fields/Select/Select.js + 3 modules
var Select = __webpack_require__(26074);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/mosanic/styles/flex.styles.js
var flex_styles = __webpack_require__(5441);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
;// CONCATENATED MODULE: ./src/mosanic/cms/Pagination/Pagination.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        justify-content: center;\n        width: 100%;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: flex;\n    list-style-type: none;\n\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n      background-color:  ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        pointer-events: none;\n\n        .arrow::before {\n            border-right: 0.12em solid rgba(0, 0, 0, 0.43);\n            border-top: 0.12em solid rgba(0, 0, 0, 0.43);\n        }\n\n        &:hover {\n            background-color: transparent;\n            cursor: default;\n        }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n     padding: 0 12px;\n    height: 32px;\n    text-align: center;\n    margin: auto 4px;\n    color: rgba(0, 0, 0, 0.87);\n    transition: all ease-in-out 0.2s;\n\n    letter-spacing: 0.01071em;\n    border-radius: 16px;\n    line-height: 1.43;\n    font-size: 13px;\n    width: 32px;\n    overflow: hidden;\n    ",
        "\n\n    &.dots:hover {\n      background-color: transparent;\n      cursor: default;\n    }\n    &:hover {\n      background-color: ",
        ";\n      cursor: pointer;\n    }\n\n    ",
        "\n\n    .arrow {\n      &::before {\n        position: relative;\n        /* top: 3pt; Uncomment this to lower the icons as requested in comments*/\n        content: '';\n        /* By using an em scale, the arrows will size with the font */\n        display: inline-block;\n        width: 0.4em;\n        height: 0.4em;\n        border-right: 0.12em solid rgba(0, 0, 0, 0.87);\n        border-top: 0.12em solid rgba(0, 0, 0, 0.87);\n      }\n\n      &.left {\n        transform: rotate(-135deg) translate(-50%);\n      }\n\n      &.right {\n        transform: rotate(45deg);\n      }\n    }\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var getType = function(type) {
    if (type === "table") return (0,styled_components_browser_esm/* css */.iv)(_templateObject());
};
var Pagination = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-7c4799a4-0"
})(_templateObject1(), function(props) {
    return getType(props.type);
});
var Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-7c4799a4-1"
})(_templateObject4(), flex_styles/* CenterCenter */.IV, colors/* default.util.gray.lighter */.ZP.util.gray.lighter, function(props) {
    return props.selected && (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), colors/* default.util.gray.light */.ZP.util.gray.light);
}, function(props) {
    return props.disabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
});
var styles = {
    Pagination: Pagination,
    Item: Item
};
/* harmony default export */ var Pagination_styles = (styles);

// EXTERNAL MODULE: ./src/mosanic/cms/Pagination/usePagination.js
var usePagination = __webpack_require__(21067);
;// CONCATENATED MODULE: ./src/mosanic/cms/Pagination/Pagination.js






var PaginationLimit = function(param) {
    var count = param.count, limit = param.limit, setLimit = param.setLimit;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select.Select, {
        options: count <= 100 ? (0,_to_consumable_array/* default */.Z)([
            "5",
            "10",
            "25",
            "50",
            "100"
        ].filter(function(value) {
            return parseFloat(value) < count;
        })).concat([
            "".concat(count)
        ]) : (0,_to_consumable_array/* default */.Z)([
            "5",
            "10",
            "25",
            "50",
            "100"
        ].filter(function(value) {
            return parseFloat(value) < count;
        })),
        onChange: function(value) {
            return setLimit(value);
        },
        label: "Limit",
        value: limit,
        minWidth: "55px",
        indicator: "none",
        container: {
            border: "none"
        },
        clearable: false
    });
};
var Pagination_Pagination = function(param) {
    var methods = param.methods, validate = param.validate, _type = param.type, type = _type === void 0 ? "default" : _type;
    var paginationRange = (0,usePagination/* usePaginationRange */.m)(validate);
    var canPrev = validate.canPrev, canNext = validate.canNext, currentPage = validate.currentPage;
    var _methods = (0,_sliced_to_array/* default */.Z)(methods, 3), nextPage = _methods[0], prevPage = _methods[1], setPage = _methods[2];
    // If there are less than 2 times in pagination range we shall not render the component
    if ((paginationRange === null || paginationRange === void 0 ? void 0 : paginationRange.length) < 2) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Pagination_styles.Pagination, {
        type: type,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination_styles.Item, {
                disabled: !canPrev,
                onClick: function() {
                    return prevPage();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "arrow left"
                })
            }),
            paginationRange && (paginationRange === null || paginationRange === void 0 ? void 0 : paginationRange.map(function(pageNumber) {
                // If the pageItem is a DOT, render the DOTS unicode character
                if (pageNumber === usePagination/* DOTS */.Ag) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination_styles.Item, {
                    className: "pagination-item dots",
                    children: "…"
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination_styles.Item, {
                    selected: pageNumber === currentPage,
                    onClick: function() {
                        return setPage(pageNumber);
                    },
                    children: pageNumber
                });
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination_styles.Item, {
                disabled: !canNext,
                onClick: function() {
                    return nextPage();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "arrow right"
                })
            })
        ]
    });
};
/* harmony default export */ var cms_Pagination_Pagination = (Pagination_Pagination);


/***/ }),

/***/ 21067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ag": function() { return /* binding */ DOTS; },
/* harmony export */   "h0": function() { return /* binding */ usePagination; },
/* harmony export */   "m": function() { return /* binding */ usePaginationRange; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50930);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);





var DOTS = "...";
var usePagination = function(param) {
    var data = param.data, _limit = param.limit, limit = _limit === void 0 ? 10 : _limit, _skip = param.skip, skip = _skip === void 0 ? 0 : _skip, _currentPage = param.currentPage, currentPage = _currentPage === void 0 ? 1 : _currentPage, _siblings = param.siblings, siblings = _siblings === void 0 ? 1 : _siblings, _count = param.count, count = _count === void 0 ? null : _count;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        limit: limit,
        skip: skip,
        currentPage: currentPage
    }), controls = ref[0], setControls = ref[1];
    var endRange = (controls === null || controls === void 0 ? void 0 : controls.skip) + (controls === null || controls === void 0 ? void 0 : controls.limit);
    var pageCount = Math.ceil((count ? count : data === null || data === void 0 ? void 0 : data.length) / (controls === null || controls === void 0 ? void 0 : controls.limit));
    var items = Array.isArray(data) ? data === null || data === void 0 ? void 0 : data.slice(controls === null || controls === void 0 ? void 0 : controls.skip, endRange) : data;
    var canNext = controls.currentPage < pageCount;
    var canPrev = controls.currentPage > 1;
    var nextPage = function() {
        return canNext && setControls((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, controls), {
            currentPage: controls.currentPage + 1,
            skip: controls.skip + controls.limit
        }));
    };
    var prevPage = function() {
        return canPrev && setControls((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, controls), {
            currentPage: controls.currentPage - 1,
            skip: controls.skip - controls.limit
        }));
    };
    var setPage = function(index) {
        return setControls((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, controls), {
            skip: index === 0 ? limit : limit * (index - 1),
            currentPage: index === 0 ? 1 : index
        }));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setControls({
            limit: limit,
            skip: skip,
            currentPage: currentPage
        });
    }, [
        limit,
        skip,
        currentPage,
        count
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((controls === null || controls === void 0 ? void 0 : controls.currentPage) > pageCount) setControls((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, controls), {
            currentPage: pageCount
        }));
    }, [
        controls,
        pageCount
    ]);
    var methods = [
        nextPage,
        prevPage,
        setPage
    ];
    var validate = {
        pageCount: pageCount,
        canNext: canNext,
        canPrev: canPrev
    };
    return {
        items: items,
        methods: methods,
        validate: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, controls, validate), {
            totalCount: count ? count : data === null || data === void 0 ? void 0 : data.length,
            siblings: siblings
        })
    };
};
var range = function(start, end) {
    var length = end - start + 1;
    /*
        Create an array of certain length and set the elements within it from
      start value to end value.
    */ return Array.from({
        length: length
    }, function(_, idx) {
        return idx + start;
    });
};
var usePaginationRange = function(validate) {
    var limit = validate.limit, currentPage = validate.currentPage, totalCount = validate.totalCount, siblings = validate.siblings;
    var paginationRange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var totalPageCount = Math.ceil(totalCount / limit);
        // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
        var totalPageNumbers = siblings + 5;
        /*
          Case 1:
          If the number of pages is less than the page numbers we want to show in our
          paginationComponent, we return the range [1..totalPageCount]
        */ if (totalPageNumbers >= totalPageCount) {
            return range(1, totalPageCount);
        }
        /*
            Calculate left and right sibling index and make sure they are within range 1 and totalPageCount
        */ var leftSiblingIndex = Math.max(currentPage - siblings, 1);
        var rightSiblingIndex = Math.min(currentPage + siblings, totalPageCount);
        /*
          We do not show dots just when there is just one page number to be inserted between the extremes of sibling and the page limits i.e 1 and totalPageCount. Hence we are using leftSiblingIndex > 2 and rightSiblingIndex < totalPageCount - 2
        */ var shouldShowLeftDots = leftSiblingIndex > 2;
        var shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
        var firstPageIndex = 0;
        var lastPageIndex = totalPageCount;
        /*
            Case 2: No left dots to show, but rights dots to be shown
        */ if (!shouldShowLeftDots && shouldShowRightDots) {
            var leftItemCount = 3 + 2 * siblings;
            var leftRange = range(1, leftItemCount);
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(leftRange).concat([
                DOTS,
                totalPageCount
            ]);
        }
        /*
            Case 3: No right dots to show, but left dots to be shown
        */ if (shouldShowLeftDots && !shouldShowRightDots) {
            var rightItemCount = 3 + 2 * siblings;
            var rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
            return [
                firstPageIndex,
                DOTS
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(rightRange));
        }
        /*
            Case 4: Both left and right dots to be shown
        */ if (shouldShowLeftDots && shouldShowRightDots) {
            var middleRange = range(leftSiblingIndex, rightSiblingIndex);
            return [
                firstPageIndex,
                DOTS
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(middleRange), [
                DOTS,
                lastPageIndex
            ]);
        }
    }, [
        totalCount,
        limit,
        siblings,
        currentPage
    ]);
    return paginationRange;
};


/***/ }),

/***/ 62357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useGetCollection; },
/* harmony export */   "bC": function() { return /* binding */ useGetMail; },
/* harmony export */   "iu": function() { return /* binding */ useGetSite; },
/* harmony export */   "l8": function() { return /* binding */ useGetTeam; },
/* harmony export */   "pg": function() { return /* binding */ useGetUser; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66383);
/* harmony import */ var _api_queries_sites__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71204);
/* harmony import */ var _useDataQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49974);
/* harmony import */ var _api_queries_collections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94283);
/* harmony import */ var _api_queries_teams__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17302);
/* harmony import */ var _api_queries_mails__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2782);
/* harmony import */ var _api_queries_users__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62641);









var useGetItem = function(_param) {
    var params = _param.params, query = _param.query, type = _param.type, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "params",
        "query",
        "type"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_useDataQuery__WEBPACK_IMPORTED_MODULE_2__/* .useGet */ .XD)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        params: params,
        method: "ById",
        query: query,
        type: type
    }, other)), 2), get = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    return [
        data,
        loading,
        error,
        get
    ];
};
var useGetCollection = function(_param) {
    var _id = _param._id, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "_id"
    ]);
    return useGetItem((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        params: {
            _id: _id
        },
        query: _api_queries_collections__WEBPACK_IMPORTED_MODULE_4__/* .COLLECTION */ .du,
        type: "collection"
    }, other));
};
var useGetSite = function(_param) {
    var _id = _param._id, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "_id"
    ]);
    return useGetItem((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        params: {
            _id: _id
        },
        query: _api_queries_sites__WEBPACK_IMPORTED_MODULE_5__/* .SITE */ .Ey,
        type: "site",
        silent: true
    }, other));
};
var useGetTeam = function(param) {
    var _id = param._id;
    return useGetItem({
        query: _api_queries_teams__WEBPACK_IMPORTED_MODULE_6__/* .TEAM */ .FV,
        type: "team",
        params: {
            _id: _id
        },
        silent: true
    });
};
var useGetMail = function(_param) {
    var _id = _param._id, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "_id"
    ]);
    return useGetItem((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        params: {
            _id: _id
        },
        query: _api_queries_mails__WEBPACK_IMPORTED_MODULE_7__/* .MAIL */ .cy,
        type: "mail"
    }, other));
};
var useGetUser = function(_param) {
    var _id = _param._id, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "_id"
    ]);
    return useGetItem((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        params: {
            _id: _id
        },
        query: _api_queries_users__WEBPACK_IMPORTED_MODULE_8__/* .USER */ .xR,
        type: "user",
        silent: true
    }, other)) // export const useGetMediaItem = ({_id}) => useGetItem({
     //     query: PAGINATION_MEDIA,
     //     params: siteId ? {filter: {siteId}, page, perPage} : null,
     //     method: 'Pagination',
     //     type: 'media',
     // })
    ;
};


/***/ }),

/***/ 88574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useGetMediaCount; },
/* harmony export */   "p": function() { return /* binding */ useGetEntryCount; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _api_queries_media__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64487);
/* harmony import */ var _useDataQuery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49974);
/* harmony import */ var _api_queries_entries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78721);





var useGetMediaCount = function(param) {
    var params = param.params;
    return (0,_useDataQuery__WEBPACK_IMPORTED_MODULE_0__/* .useGetCount */ .RF)({
        type: "media",
        query: _api_queries_media__WEBPACK_IMPORTED_MODULE_1__/* .MEDIA_COUNT */ .dP
    });
};
var useGetEntryCount = function(param) {
    var _id = param._id, collectionId = param.collectionId, filter = param.filter;
    return (0,_useDataQuery__WEBPACK_IMPORTED_MODULE_0__/* .useGetCount */ .RF)({
        type: "entry",
        params: _id ? {
            filter: {
                collectionId: _id
            }
        } : collectionId && filter ? {
            filter: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, filter), {
                collectionId: collectionId
            })
        } : filter ? {
            filter: filter
        } : null,
        query: _api_queries_entries__WEBPACK_IMPORTED_MODULE_4__/* .ENTRY_COUNT */ .Vz
    });
};


/***/ }),

/***/ 18780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "CG": function() { return /* binding */ useSiteId; },
/* harmony export */   "Qf": function() { return /* binding */ getParams; }
/* harmony export */ });
/* unused harmony export compareAttrs */
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62570);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64157);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25157);







//Helpers
var useSiteId = function() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_1__/* .siteIdSelector */ .uL);
};
var getParams = function(param) {
    var filter = param.filter, siteId = param.siteId;
    return filter ? {
        filter: filter
    } : siteId ? {
        filter: {
            siteId: siteId
        }
    } : {};
};
var compareAttrs = function(obj, other, attr) {
    return !(0,_util_Obj__WEBPACK_IMPORTED_MODULE_2__/* .hasAttr */ .B$)(obj, attr) && (0,_util_Obj__WEBPACK_IMPORTED_MODULE_2__/* .hasAttr */ .B$)(other, attr);
};
var combine = function(params, other, attr) {
    return compareAttrs(params, other, attr) ? (0,_util_Obj__WEBPACK_IMPORTED_MODULE_2__/* .combineAttr */ .$0)(params, other, attr) : params;
};



/***/ }),

/***/ 43551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pX": function() { return /* binding */ useGetChats; },
  "Vk": function() { return /* binding */ useGetCollectionIndexes; },
  "t8": function() { return /* binding */ useGetCollections; },
  "e1": function() { return /* binding */ useGetEntries; },
  "fY": function() { return /* binding */ useGetMails; },
  "m_": function() { return /* binding */ useGetPages; },
  "ck": function() { return /* binding */ useGetTeams; },
  "w4": function() { return /* binding */ useGetUsers; }
});

// UNUSED EXPORTS: useGetMedia

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/utils/Arr.js
var Arr = __webpack_require__(72393);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/useDataQuery.js
var useDataQuery = __webpack_require__(49974);
// EXTERNAL MODULE: ./src/adapters/queries/collections.js
var collections = __webpack_require__(94283);
// EXTERNAL MODULE: ./src/adapters/queries/entries.js
var entries = __webpack_require__(78721);
// EXTERNAL MODULE: ./src/adapters/queries/mails.js
var mails = __webpack_require__(2782);
// EXTERNAL MODULE: ./src/adapters/queries/users.js
var users = __webpack_require__(62641);
// EXTERNAL MODULE: ./src/adapters/queries/pages.js
var pages = __webpack_require__(81913);
// EXTERNAL MODULE: ./src/adapters/queries/teams.js
var teams = __webpack_require__(17302);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/index.js
var Query = __webpack_require__(18780);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(60138);
;// CONCATENATED MODULE: ./src/adapters/queries/chats.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \nquery chatCount($filter:FilterCountChatInput) {\n  chatCount(filter:$filter) \n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nquery chatMany($filter: FilterFindManyChatInput, $limit: Int, $skip: Int) {\n	chatMany(filter: $filter, limit: $limit, skip: $skip){\n		_id\n		name\n		isActive\n		status\n		subscription\n		updatedAt\n		date\n		siteId\n		userId\n		unreadFor\n		queryId\n		teamId\n		receivers {\n			teams \n			users\n		}\n		latestMessage\n		priority\n		messages\n		history\n		assets\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var CHAT_COUNT = (0,lib/* gql */.Ps)(_templateObject());
var FILTER_CHATS = (0,lib/* gql */.Ps)(_templateObject1());

;// CONCATENATED MODULE: ./src/mosanic/cms/Query/many.js















//Main call
var useGetMany = function(_param) {
    var params = _param.params, query = _param.query, type = _param.type, _sort = _param.sort, sort = _sort === void 0 ? null : _sort, _shouldHaveParams = _param.shouldHaveParams, shouldHaveParams = _shouldHaveParams === void 0 ? true : _shouldHaveParams, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "params",
        "query",
        "type",
        "sort",
        "shouldHaveParams"
    ]);
    var ref;
    var siteId = (0,Query/* useSiteId */.CG)();
    params = (0,Query/* combine */.$e)(params, other, "limit");
    params = (0,Query/* combine */.$e)(params, other, "skip");
    if (other === null || other === void 0 ? void 0 : other.current) params = {
        filter: {
            siteId: siteId
        }
    };
    if (sort) params = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, params), {
        sort: sort
    });
    if (!params || ((ref = Object.keys(params)) === null || ref === void 0 ? void 0 : ref.length) <= 0) params = null;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useDataQuery/* useGet */.XD)({
        method: "Many",
        params: params,
        query: query,
        type: type,
        silent: true,
        shouldHaveParams: shouldHaveParams
    }), 2), get = ref1[0], ref2 = (0,_sliced_to_array/* default */.Z)(ref1[1], 3), data = ref2[0], loading = ref2[1], error = ref2[2];
    return [
        data,
        loading,
        error,
        get
    ];
};
// # Call Hooks
var useGetEntries = function(_param) {
    var filter = _param.filter, _ids = _param._ids, collectionId = _param.collectionId, _sort = _param.sort, sort = _sort === void 0 ? "_ID_DESC" : _sort, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "filter",
        "_ids",
        "collectionId",
        "sort"
    ]);
    return useGetMany((0,src_object_spread/* default */.Z)({
        params: filter ? {
            filter: filter
        } : (0,Arr/* canMap */.is)(_ids) && collectionId ? {
            filter: {
                collectionId: collectionId,
                AND: {
                    OR: _ids
                }
            }
        } : collectionId ? {
            filter: {
                collectionId: collectionId
            }
        } : null,
        query: entries/* FILTER_ENTRIES */.r8,
        type: "entry",
        sort: sort
    }, other));
};
var useGetMedia = function(_param) {
    var filter = _param.filter, siteId = _param.siteId, other = _object_without_properties(_param, [
        "filter",
        "siteId"
    ]);
    return useGetMany(_object_spread({
        params: getParams({
            filter: filter,
            siteId: siteId
        }),
        query: FILTER_MEDIA,
        type: "media"
    }, other));
};
var useGetUsers = function(_param) {
    var filter = _param.filter, _siteId = _param.siteId, siteId = _siteId === void 0 ? undefined : _siteId, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "filter",
        "siteId"
    ]);
    return useGetMany((0,src_object_spread/* default */.Z)({
        params: (0,Query/* getParams */.Qf)({
            filter: filter,
            siteId: siteId
        }),
        query: users/* FILTER_USERS */.LW,
        type: "user"
    }, other));
};
var useGetMails = function(_param) {
    var filter = _param.filter, siteId = _param.siteId, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "filter",
        "siteId"
    ]);
    return useGetMany((0,src_object_spread/* default */.Z)({
        params: (0,Query/* getParams */.Qf)({
            filter: filter,
            siteId: siteId
        }),
        query: mails/* FILTER_MAILS */.lS,
        type: "mail"
    }, other));
};
var useGetCollections = function(_param) {
    var filter = _param.filter, siteId = _param.siteId, _sort = _param.sort, sort = _sort === void 0 ? "_ID_DESC" : _sort, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "filter",
        "siteId",
        "sort"
    ]);
    return useGetMany((0,src_object_spread/* default */.Z)({
        params: (0,Query/* getParams */.Qf)({
            filter: filter,
            siteId: siteId
        }),
        query: collections/* FILTER_COLLECTIONS */.YN,
        type: "collection",
        sort: sort
    }, other));
};
var useGetCollectionIndexes = function(_param) {
    var filter = _param.filter, siteId = _param.siteId, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "filter",
        "siteId"
    ]);
    return useGetMany((0,src_object_spread/* default */.Z)({
        query: collections/* FILTER_COLLECTIONS_INDEX */.WN,
        params: (0,Query/* getParams */.Qf)({
            filter: filter,
            siteId: siteId
        }),
        type: "collection"
    }, other));
};
var useGetPages = function(_param) {
    var filter = _param.filter, siteId = _param.siteId, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "filter",
        "siteId"
    ]);
    return useGetMany((0,src_object_spread/* default */.Z)({
        params: (0,Query/* getParams */.Qf)({
            filter: filter,
            siteId: siteId
        }),
        query: pages/* FILTER_PAGES */.mS,
        type: "page"
    }, other));
};
var useGetTeams = function(_param) {
    var __ids = _param._ids, _ids = __ids === void 0 ? undefined : __ids, _userId = _param.userId, userId = _userId === void 0 ? undefined : _userId, _filter = _param.filter, filter = _filter === void 0 ? undefined : _filter, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "_ids",
        "userId",
        "filter"
    ]);
    return useGetMany((0,src_object_spread/* default */.Z)({
        params: filter ? {
            filter: filter
        } : (0,Arr/* canMap */.is)(_ids) ? {
            filter: {
                OR: _ids
            }
        } : userId ? {
            filter: {
                superAdmin: userId
            }
        } : null,
        query: teams/* LIST_ALL_TEAMS */.w1,
        type: "team"
    }, other));
};
var useGetChats = function(_param) {
    var filter = _param.filter, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "filter"
    ]);
    return useGetMany((0,src_object_spread/* default */.Z)({
        params: {
            filter: filter
        },
        query: FILTER_CHATS,
        type: "chat"
    }, other));
};


/***/ }),

/***/ 59832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useGetEntriesPage; },
/* harmony export */   "o": function() { return /* binding */ useGetMediaPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66383);
/* harmony import */ var _api_queries_entries__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78721);
/* harmony import */ var _useDataQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49974);
/* harmony import */ var _api_queries_media__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64487);
/* harmony import */ var _util_Arr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72393);







var useGetPage = function(param) {
    var params = param.params, query = param.query, type = param.type;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_useDataQuery__WEBPACK_IMPORTED_MODULE_1__/* .useGet */ .XD)({
        method: "Pagination",
        params: !(params === null || params === void 0 ? void 0 : params.filter) ? null : params,
        query: query,
        type: type,
        silent: true
    }), 2), get = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    return [
        data === null || data === void 0 ? void 0 : data.items,
        loading,
        error,
        get
    ];
};
var useGetMediaPage = function(param) {
    var perPage = param.perPage, page = param.page, siteId = param.siteId;
    return useGetPage({
        query: _api_queries_media__WEBPACK_IMPORTED_MODULE_2__/* .PAGINATION_MEDIA */ .pm,
        params: siteId ? {
            filter: {
                siteId: siteId
            },
            page: page,
            perPage: perPage
        } : null,
        type: "media"
    });
};
var useGetEntriesPage = function(_param) {
    var filter = _param.filter, _ids = _param._ids, collectionId = _param.collectionId, _userId = _param.userId, userId = _userId === void 0 ? undefined : _userId, _sort = _param.sort, sort = _sort === void 0 ? "_ID_DESC" : _sort, perPage = _param.perPage, page = _param.page, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "filter",
        "_ids",
        "collectionId",
        "userId",
        "sort",
        "perPage",
        "page"
    ]);
    return useGetPage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        params: filter ? {
            filter: filter,
            perPage: perPage,
            page: page,
            sort: sort
        } : (0,_util_Arr__WEBPACK_IMPORTED_MODULE_5__/* .canMap */ .is)(_ids) && collectionId ? {
            filter: {
                collectionId: collectionId,
                AND: {
                    OR: _ids
                },
                userId: userId,
                perPage: perPage,
                page: page
            }
        } : collectionId ? {
            filter: {
                collectionId: collectionId,
                userId: userId
            },
            perPage: perPage,
            page: page
        } : null,
        query: _api_queries_entries__WEBPACK_IMPORTED_MODULE_6__/* .PAGINATION_ENTRIES */ .cH,
        type: "entry"
    }, other));
};


/***/ }),

/***/ 74063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useGetUsersPublic; },
/* harmony export */   "q": function() { return /* binding */ useGetSitesPublic; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66383);
/* harmony import */ var _api_queries_sites__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71204);
/* harmony import */ var _api_queries_users__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62641);
/* harmony import */ var _util_Funct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3847);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68311);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18780);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49974);










var useGetManyPublic = function(_param) {
    var params = _param.params, query = _param.query, type = _param.type, _formatter = _param.formatter, formatter = _formatter === void 0 ? null : _formatter, _method = _param.method, method = _method === void 0 ? "Many" : _method, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "params",
        "query",
        "type",
        "formatter",
        "method"
    ]);
    var siteId = (0,___WEBPACK_IMPORTED_MODULE_1__/* .useSiteId */ .CG)();
    params = (0,___WEBPACK_IMPORTED_MODULE_1__/* .combine */ .$e)(params, other, "limit");
    params = (0,___WEBPACK_IMPORTED_MODULE_1__/* .combine */ .$e)(params, other, "skip");
    if (other === null || other === void 0 ? void 0 : other.current) params = {
        filter: {
            siteId: siteId
        }
    };
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,___WEBPACK_IMPORTED_MODULE_3__/* .useGet */ .XD)({
        method: method,
        params: params,
        query: query,
        type: type,
        silent: true
    }), 2), get = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    return (0,_util_Funct__WEBPACK_IMPORTED_MODULE_4__/* .isFunc */ .W)(formatter) ? [
        Array.isArray(data) ? data === null || data === void 0 ? void 0 : data.map(function(e) {
            return formatter(e);
        }) : data,
        loading,
        error,
        get
    ] : [
        data,
        loading,
        error,
        get
    ];
};
var useGetUsersPublic = function(_param) {
    var filter = _param.filter, _siteId = _param.siteId, siteId = _siteId === void 0 ? undefined : _siteId, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "filter",
        "siteId"
    ]);
    return useGetManyPublic((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        params: (0,___WEBPACK_IMPORTED_MODULE_1__/* .getParams */ .Qf)({
            filter: filter,
            siteId: siteId
        }),
        query: _api_queries_users__WEBPACK_IMPORTED_MODULE_6__/* .PUBLIC_USERS */ .Fi,
        type: "user",
        formatter: function(u) {
            var ref, ref1;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, u), {
                fullName: (0,_util_Text__WEBPACK_IMPORTED_MODULE_8__/* .combineString */ .M7)([
                    u === null || u === void 0 ? void 0 : (ref = u.author) === null || ref === void 0 ? void 0 : ref.firstName,
                    u === null || u === void 0 ? void 0 : (ref1 = u.author) === null || ref1 === void 0 ? void 0 : ref1.lastName
                ])
            });
        }
    }, other));
};
var useGetSitesPublic = function(_param) {
    var filter = _param.filter, _siteId = _param.siteId, siteId = _siteId === void 0 ? undefined : _siteId, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "filter",
        "siteId"
    ]);
    return useGetManyPublic((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        params: filter ? filter : {
            _id: siteId
        },
        query: siteId ? _api_queries_sites__WEBPACK_IMPORTED_MODULE_9__/* .PUBLIC_SITE */ .I7 : _api_queries_sites__WEBPACK_IMPORTED_MODULE_9__/* .PUBLIC_SITES */ .Cz,
        method: siteId ? "ById" : undefined,
        type: "site"
    }, other));
};


/***/ }),

/***/ 49974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qb": function() { return /* binding */ convertEntryBack; },
/* harmony export */   "RF": function() { return /* binding */ useGetCount; },
/* harmony export */   "XD": function() { return /* binding */ useGet; },
/* harmony export */   "ec": function() { return /* binding */ convertEntry; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50930);
/* harmony import */ var _api_queries_collections__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(94283);
/* harmony import */ var _api_queries_entries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78721);
/* harmony import */ var _api_token__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94645);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70210);
/* harmony import */ var _mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49272);
/* harmony import */ var _mosanic_hooks__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(33346);
/* harmony import */ var _mosanic_utils_value__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11039);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25157);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64157);


















var convertEntry = function(entry) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry, entry === null || entry === void 0 ? void 0 : entry.data, entry === null || entry === void 0 ? void 0 : entry.map, entry === null || entry === void 0 ? void 0 : entry.filters, entry === null || entry === void 0 ? void 0 : entry.props), {
        map: undefined,
        data: undefined,
        filters: undefined,
        props: undefined
    });
};
var getFields = function(schema) {
    var validate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(field) {
        return field.inMap;
    };
    var ref, ref1;
    return [
        schema === null || schema === void 0 ? void 0 : (ref = schema[0]) === null || ref === void 0 ? void 0 : ref.name
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((ref1 = schema === null || schema === void 0 ? void 0 : schema.filter(function(f) {
        return validate(f);
    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(f) {
        return f === null || f === void 0 ? void 0 : f.name;
    })));
};
var moveFields = function(param) {
    var entry = param.entry, fields = param.fields, property = param.property, _remove = param.remove, remove = _remove === void 0 ? false : _remove;
    fields.map(function(field) {
        var _obj;
        entry = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, property, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry === null || entry === void 0 ? void 0 : entry[property]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, field, entry[field]))), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, field, remove ? undefined : entry[field]), _obj));
    });
    return entry;
};
var removeFields = function(param) {
    var entry = param.entry, fields = param.fields;
    fields.map(function(field) {
        entry = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, field, undefined));
    });
    return entry;
};
var convertEntryBack = function(data, schema) {
    var entry = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, data), {
        map: {}
    });
    entry = moveFields({
        entry: entry,
        fields: [
            "author",
            "id",
            "location_id",
            "sys_group",
            "accommodation_type_category"
        ],
        property: "props",
        remove: true
    });
    var imageFields = schema === null || schema === void 0 ? void 0 : schema.filter(function(f) {
        return (f === null || f === void 0 ? void 0 : f.type) === "image";
    });
    if ((imageFields === null || imageFields === void 0 ? void 0 : imageFields.length) >= 1) {
        var ref;
        entry = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry), {
            image: data[(ref = imageFields[0]) === null || ref === void 0 ? void 0 : ref.name]
        });
    }
    entry = moveFields({
        entry: entry,
        fields: getFields(schema, function(f) {
            return f === null || f === void 0 ? void 0 : f.filterable;
        }),
        property: "filters"
    });
    entry = moveFields({
        entry: entry,
        fields: getFields(schema, function(f) {
            return !(f === null || f === void 0 ? void 0 : f.inMap);
        }),
        property: "data"
    });
    entry = moveFields({
        entry: entry,
        fields: getFields(schema, function(f) {
            return f === null || f === void 0 ? void 0 : f.inMap;
        }),
        property: "data"
    });
    entry = moveFields({
        entry: entry,
        fields: getFields(schema, function(f) {
            return f === null || f === void 0 ? void 0 : f.inMap;
        }),
        property: "map"
    });
    entry = removeFields({
        entry: entry,
        fields: getFields(schema, function(f) {
            return f;
        })
    });
    entry = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry), {
        title: (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getEntryLabel */ .ax)(data, schema),
        description: (0,_util_Text__WEBPACK_IMPORTED_MODULE_8__/* .isString */ .HD)((0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getEntryDescription */ .$n)(data, schema)) ? (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_7__/* .getEntryDescription */ .$n)(data, schema) : "...",
        queryId: data === null || data === void 0 ? void 0 : data.queryId,
        userId: data === null || data === void 0 ? void 0 : data.userId,
        updatedAt: new Date(),
        image_title: undefined,
        image_desc: undefined,
        image_link: undefined,
        accommodation_status: undefined
    });
    entry = removeFields({
        entry: entry,
        fields: [
            "short_description",
            "align_main_image",
            "sys_type_bb",
            "sys_type_bb_plus",
            "sys_type_glamping"
        ]
    });
    //TODO --> Ûnder de Wol --> no host && accommodation _id
    // Boutique Yurt Puck --> images
    // Slapen bij Hein -> images 
    // Boutique B&B Locanda Toscanini --> no host
    // Bed & Broodje Ouddorp --> no host
    // Tiny House Damhert --> no host
    // Villa Sabandari --> no host
    Object.keys(entry).forEach(function(key) {
        return entry[key] === undefined && delete entry[key];
    });
    // ! dep
    // ! entry = moveFields(entry, getFields(schema, f => f?.name === 'sys_activities'), 'data')
    return entry;
};
var useDataQuery = function(param) {
    var _callback = param.callback, callback = _callback === void 0 ? null : _callback, _redirect = param.redirect, redirect = _redirect === void 0 ? null : _redirect, _type = param.type, type = _type === void 0 ? "entry" : _type, _action = param.action, action = _action === void 0 ? "get" : _action, _method = param.method, method = _method === void 0 ? "ById" : _method, _query = param.query, query = _query === void 0 ? _api_queries_entries__WEBPACK_IMPORTED_MODULE_9__/* .ENTRY */ .hZ : _query, _formatter = param.formatter, formatter = _formatter === void 0 ? function(data) {
        return convertEntry(data);
    } : _formatter, _loggedInCheck = param.loggedInCheck, loggedInCheck = _loggedInCheck === void 0 ? false : _loggedInCheck, _siteCheck = param.siteCheck, siteCheck = _siteCheck === void 0 ? false : _siteCheck, _silent = param.silent, silent = _silent === void 0 ? false : _silent;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var shouldRedirect = Boolean(redirect && (0,_util_Text__WEBPACK_IMPORTED_MODULE_8__/* .isString */ .HD)(redirect));
    var siteId = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_10__/* .siteIdSelector */ .uL);
    var isAuth = (0,_api_token__WEBPACK_IMPORTED_MODULE_11__/* .isAuthenticated */ .$8)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_13__/* .useLazyQuery */ .td)("".concat(type).concat(method), query), 2), dispatch = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();
    var handler = function(params) {
        if (!isAuth && loggedInCheck && false) {}
        if (!siteId && siteCheck && false) {}
        // if(method === 'ById' && (!params?._id)) console.log('no params!')
        dispatch(params).then(function(res) {
            var data = res.data, error = res.error;
            if (!error && data) {
                if (!silent) notify("Success: ".concat((0,_util_Text__WEBPACK_IMPORTED_MODULE_8__/* .toLowCase */ .Cc)("".concat(action, " ").concat(type, " ").concat(method)), "."), "app", "success");
                if (callback) callback(data);
                if (shouldRedirect) router.push((data === null || data === void 0 ? void 0 : data.recordId) ? "".concat(redirect, "/").concat(data.recordId) : redirect);
                if (((0,_mosanic_utils_value__WEBPACK_IMPORTED_MODULE_15__/* .isClone */ .vu)(data === null || data === void 0 ? void 0 : data.data) || (data === null || data === void 0 ? void 0 : data.data)) && formatter) data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, formatter(data));
            } else if (error) {
                if (!silent) notify("An error occurred during the ".concat(type, " ").concat(action, "."));
                console.log({
                    error: error,
                    params: params,
                    method: method,
                    type: type,
                    action: action
                });
            }
        });
    };
    return [
        handler,
        [
            data,
            loading,
            error
        ]
    ];
};
var useGet = function(param) {
    var _callback = param.callback, callback = _callback === void 0 ? null : _callback, _redirect = param.redirect, redirect = _redirect === void 0 ? null : _redirect, _type = param.type, type = _type === void 0 ? "entry" : _type, _method = param.method, method = _method === void 0 ? "ById" : _method, _query = param.query, query = _query === void 0 ? _api_queries_entries__WEBPACK_IMPORTED_MODULE_9__/* .ENTRY */ .hZ : _query, _loggedInCheck = param.loggedInCheck, loggedInCheck = _loggedInCheck === void 0 ? true : _loggedInCheck, _siteCheck = param.siteCheck, siteCheck = _siteCheck === void 0 ? true : _siteCheck, _alert = param.alert, alert = _alert === void 0 ? false : _alert, _params = param.params, params = _params === void 0 ? null : _params, _silent = param.silent, silent = _silent === void 0 ? false : _silent, _shouldHaveParams = param.shouldHaveParams, shouldHaveParams = _shouldHaveParams === void 0 ? true : _shouldHaveParams;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), calledParams = ref[0], setCalledParams = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(useDataQuery({
        callback: callback,
        redirect: redirect,
        method: method,
        type: type,
        query: query,
        loggedInCheck: loggedInCheck,
        siteCheck: siteCheck,
        alert: alert,
        action: "get",
        silent: silent
    }), 2), handler = ref1[0], ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(ref1[1], 3), data = ref2[0], loading = ref2[1], error = ref2[2];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (JSON.stringify(params) === JSON.stringify(calledParams) || method === "ById" && !(params === null || params === void 0 ? void 0 : params._id) || method === "Pagination" && !(params === null || params === void 0 ? void 0 : params.filter)) {
            return;
        }
        if (params || !calledParams) {
            handler(params);
        }
        setCalledParams(params);
    }, [
        params,
        calledParams,
        shouldHaveParams,
        method,
        handler
    ]);
    return [
        handler,
        [
            data,
            loading,
            error
        ]
    ];
};
var useGetCount = function(param) {
    var _type = param.type, type = _type === void 0 ? "collection" : _type, _query = param.query, query = _query === void 0 ? _api_queries_collections__WEBPACK_IMPORTED_MODULE_16__/* .COLLECTIONS_COUNT */ .SC : _query, _params = param.params, params = _params === void 0 ? null : _params, site_id = param.site_id;
    var siteId = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_10__/* .siteIdSelector */ .uL);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(useGet({
        query: query,
        type: type,
        action: "",
        method: "Count",
        params: params ? params : siteId ? {
            filter: {
                siteId: site_id ? site_id : siteId
            }
        } : null,
        silent: true
    }), 2), getCount = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(ref[1], 3), count = ref1[0], loadingCount = ref1[1], errorCount = ref1[2];
    return [
        count,
        loadingCount,
        errorCount,
        getCount
    ];
};


/***/ }),

/***/ 16956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useSendOne; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66383);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _api_queries_mails__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2782);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70210);
/* harmony import */ var _mosanic_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33346);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);









var defaultTemplate = "d-f00fa9adf0ad46f389bb8289412447a5";
var useSendOne = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_3__/* .useLazyQuery */ .td)("mailSendOne", _api_queries_mails__WEBPACK_IMPORTED_MODULE_4__/* .SEND_MAIL */ .UU), 2), sendMail = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var sendSimpleMail = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var address, subject, message, res, error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        address = param.address, subject = param.subject, message = param.message;
                        _ctx.next = 3;
                        return fetch("/api/mail", {
                            body: JSON.stringify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, address), {
                                subject: subject,
                                name: "Mosanic.io",
                                message: message
                            })),
                            headers: {
                                "Content-Type": "application/json"
                            },
                            method: "POST"
                        });
                    case 3:
                        res = _ctx.sent;
                        _ctx.next = 6;
                        return res.json();
                    case 6:
                        error = _ctx.sent.error;
                        if (!error) {
                            _ctx.next = 12;
                            break;
                        }
                        notify(error);
                        return _ctx.abrupt("return", {
                            error: error
                        });
                    case 12:
                        notify("Successfully send simple mail.", "app", "success");
                        return _ctx.abrupt("return", {
                            message: "Mail send successful."
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        notify
    ]);
    var sendTemplateMail = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var address, mailData, templateId;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        address = param.address, mailData = param.mailData, templateId = param.templateId;
                        sendMail((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, address), {
                            mailData: mailData,
                            templateId: templateId
                        })).then(function(res) {
                            var data = res.data, error = res.error;
                            if (!error) {
                                notify("Successfully send template mail.", "app", "success");
                            } else {
                                notify("Could not send template mail.");
                            }
                            return {
                                data: data
                            } || {
                                error: error
                            };
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        notify,
        sendMail
    ]);
    var handler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(param) {
        var subject = param.subject, to = param.to, preHeader = param.preHeader, subHeader = param.subHeader, mainHeader = param.mainHeader, mainText = param.mainText, _simple = param.simple, simple = _simple === void 0 ? false : _simple, _templateId = param.templateId, templateId = _templateId === void 0 ? defaultTemplate : _templateId, _from = param.from, from = _from === void 0 ? "info@mosanic.io" : _from;
        if (!subject) {
            notify("No mail subject provided.");
            return;
        }
        if (!to) {
            notify("No receiving mail address provided.");
            return;
        }
        if (!preHeader || !subHeader || !mainHeader || !mainText) {
            notify("Mail data is not valid.");
            return;
        }
        var address = {
            to: to,
            from: from
        };
        var result = simple ? sendSimpleMail({
            address: address,
            subject: subject,
            message: mainText
        }) : sendTemplateMail({
            address: address,
            templateId: templateId,
            mailData: {
                subject: subject,
                preHeader: preHeader,
                subHeader: subHeader,
                mainHeader: mainHeader,
                mainText: mainText
            }
        });
        return result;
    }, [
        sendSimpleMail,
        sendTemplateMail,
        notify
    ]);
    return [
        handler,
        data,
        loading,
        error, 
    ];
};


/***/ }),

/***/ 2531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ useUploadFactory; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/utils/Arr.js
var Arr = __webpack_require__(72393);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/Handlers/useMetaFields.js




var convertFileName = function(name) {
    return !name ? name : (0,Text/* replacePart */.bA)((0,Text/* replacePart */.bA)(name.substr(0, name.lastIndexOf(".")), "-", " "), "_", " ");
};
var useMetaFields = function(param) {
    var images = param.images;
    return useArrayFields({
        array: images,
        dataFunc: function(img, index) {
            var ref, ref1;
            return {
                title: convertFileName((ref = img.file) === null || ref === void 0 ? void 0 : ref.name),
                alt: convertFileName((ref1 = img.file) === null || ref1 === void 0 ? void 0 : ref1.name),
                folder: ""
            };
        }
    });
};
var useArrayFields = function(param) {
    var array = param.array, _count = param.count, count = _count === void 0 ? null : _count, dataFunc = param.dataFunc;
    var ref = (0,react.useState)([]), arr = ref[0], setArr = ref[1];
    (0,react.useEffect)(function() {
        if (count) {
            if (count > (arr === null || arr === void 0 ? void 0 : arr.length)) setArr((0,_to_consumable_array/* default */.Z)(arr).concat([
                dataFunc(arr === null || arr === void 0 ? void 0 : arr.length)
            ]));
            else if (count < (arr === null || arr === void 0 ? void 0 : arr.length)) setArr(arr.slice(0, -1));
        } else {
            if ((array === null || array === void 0 ? void 0 : array.length) > (arr === null || arr === void 0 ? void 0 : arr.length)) setArr(array === null || array === void 0 ? void 0 : array.map(function(item, index) {
                return dataFunc(item, index);
            }));
            else if ((array === null || array === void 0 ? void 0 : array.length) < (arr === null || arr === void 0 ? void 0 : arr.length)) setArr(arr.slice(0, -1));
        }
    }, [
        array,
        count,
        arr,
        dataFunc
    ]);
    var updateItem = function(index, newData) {
        return setArr((0,Arr/* updateItem */.$G)(arr, index, newData));
    };
    var removeItem = function(index) {
        return setArr((0,_to_consumable_array/* default */.Z)((0,Arr/* remove */.Od)(arr, index)));
    };
    var addItem = function(item) {
        return setArr((0,_to_consumable_array/* default */.Z)(arr).concat([
            item
        ]));
    };
    return [
        arr,
        updateItem,
        removeItem,
        addItem
    ];
};

// EXTERNAL MODULE: ./src/adapters/mutations/media.js
var media = __webpack_require__(96362);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(33379);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/features/notification/action.js
var action = __webpack_require__(64725);
// EXTERNAL MODULE: ./src/utils/Num.js
var Num = __webpack_require__(3121);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/Handlers/useUploadFile.js









var ERROR_DURATION = 10000;
var STATUS_DURATION = 4000;
var uploadSuccess = function(fileName) {
    return {
        message: "Successfully uploaded: ".concat(fileName),
        feature: "ImageContainer",
        meta: {
            duration: STATUS_DURATION
        }
    };
};
var uploadError = function() {
    return {
        message: "Error during file upload",
        feature: "ImageContainer",
        meta: {
            duration: ERROR_DURATION
        }
    };
};
var noActiveSiteError = function() {
    return {
        message: "Media could not be saved. No active site selected.",
        feature: "ImageContainer",
        meta: {
            duration: ERROR_DURATION
        }
    };
};
var useUploadFile = function(param) {
    var storeMediaCallback = param.storeMediaCallback;
    var dispatch = (0,es/* useDispatch */.I0)();
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    var ref = (0,react.useState)(0), progress = ref[0], setProgress = ref[1];
    var ref1 = (0,react.useState)(null), abort = ref1[0], setAbort = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(media/* SINGLE_UPLOAD */.b$), 2), handleUpload = ref2[0], ref3 = ref2[1], loading = ref3.loading, error = ref3.error, data = ref3.data;
    // const [ handleUpload, [data, loading, error] ] = useMutate('uploadFile', SINGLE_UPLOAD);
    var notify = (0,react.useCallback)(function(notification) {
        return dispatch((0,action/* setNotification */.sc)(notification));
    }, [
        dispatch
    ]);
    //Abort controller
    (0,react.useEffect)(function() {
        return function() {
            return abort ? abort() : null;
        };
    }, [
        abort
    ]);
    var handler = (0,react.useCallback)(function(image, meta) {
        setProgress(0);
        if (!(image === null || image === void 0 ? void 0 : image.file)) return;
        if (!siteId) {
            notify(noActiveSiteError());
            return;
        }
        var path = (meta === null || meta === void 0 ? void 0 : meta.folder) ? "".concat(siteId, "/").concat((0,Text/* slugify */.lV)(meta === null || meta === void 0 ? void 0 : meta.folder), "/") : "".concat(siteId, "/");
        var variables = {
            file: image.file,
            path: path
        };
        console.log(variables);
        handleUpload({
            variables: variables,
            context: {
                fetchOptions: {
                    onUploadProgress: function(ev) {
                        setProgress(ev.loaded / ev.total);
                    }
                }
            }
        }).then(function(res) {
            var data = res.data, error = res.error;
            if (data === null || data === void 0 ? void 0 : data.uploadFile) data = data.uploadFile;
            var fileName = data === null || data === void 0 ? void 0 : data.filename;
            if (!error) {
                notify(uploadSuccess((meta === null || meta === void 0 ? void 0 : meta.title) ? meta.title : fileName));
                storeMediaCallback({
                    size: (0,Num/* biteSizeToMb */.vS)(image.file.size),
                    uploadedImage: data,
                    meta: meta
                });
            }
            if (error) notify(uploadError());
        });
    }, [
        siteId,
        handleUpload,
        notify,
        storeMediaCallback,
        abort
    ]);
    return [
        handler,
        progress,
        loading,
        error,
        data, 
    ];
};

// EXTERNAL MODULE: ./src/hooks/useApi.js + 3 modules
var useApi = __webpack_require__(70210);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/Handlers/useStoreMedia.js








var useStoreMedia_ERROR_DURATION = 10000;
var useStoreMedia_STATUS_DURATION = 4000;
var dataReceivedNotValid = function(url, filename) {
    return {
        message: "Media could not be saved. ".concat(!url && "File url not received.", " ").concat(!filename && "Filename not received."),
        feature: "ImageContainer",
        meta: {
            duration: useStoreMedia_ERROR_DURATION
        }
    };
};
var useStoreMedia_noActiveSiteError = function() {
    return {
        message: "Media could not be saved. No active site selected.",
        feature: "ImageContainer",
        meta: {
            duration: useStoreMedia_ERROR_DURATION
        }
    };
};
var useStoreMedia_uploadSuccess = function() {
    return {
        message: "New media saved and url & properties stored.",
        feature: "ImageContainer",
        meta: {
            duration: useStoreMedia_STATUS_DURATION,
            delay: 1000
        }
    };
};
var useStoreMedia_uploadError = function() {
    return {
        message: "Media could not be saved. Please try again.",
        feature: "ImageContainer",
        meta: {
            duration: useStoreMedia_ERROR_DURATION
        }
    };
};
var useStoreMedia = function(param) {
    var useUrlCallback = param.useUrlCallback;
    var dispatch = (0,es/* useDispatch */.I0)();
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    var cb = useUrlCallback;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useApi/* useMutate */.Tu)("mediaCreateOne", media/* ADD_MEDIA */.xM), 2), addMedia = ref[0], ref1 = (0,_sliced_to_array/* default */.Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    var notify = (0,react.useCallback)(function(notification) {
        dispatch((0,action/* setNotification */.sc)(notification));
    }, [
        dispatch
    ]);
    var handler = (0,react.useCallback)(function(param) {
        var uploadedImage = param.uploadedImage, _size = param.size, size = _size === void 0 ? 0 : _size, meta = param.meta;
        var url = uploadedImage.url, urlMin = uploadedImage.urlMin, urlThumb = uploadedImage.urlThumb, filename = uploadedImage.filename, encoding = uploadedImage.encoding, mimetype = uploadedImage.mimetype;
        var ref = meta || {
            title: (0,Text/* getSensitizedString */.W_)(filename),
            alt: "",
            folder: ""
        }, title = ref.title, alt = ref.alt, folder = ref.folder;
        if (!url || !filename) {
            notify(dataReceivedNotValid(url, filename));
            return;
        }
        if (!siteId) {
            notify(useStoreMedia_noActiveSiteError());
            return;
        }
        var variables = {
            record: {
                title: title,
                filename: filename,
                mimetype: mimetype,
                encoding: encoding,
                folder: folder ? (0,Text/* slugify */.lV)(folder) : "",
                alt: alt,
                url: url,
                urlMin: urlMin,
                urlThumb: urlThumb,
                size: size,
                siteId: siteId
            }
        };
        addMedia(variables).then(function(res) {
            var data = res.data, error = res.error;
            if (!error) {
                notify(useStoreMedia_uploadSuccess());
                cb({
                    url: url,
                    urlMin: urlMin,
                    urlThumb: urlThumb,
                    seo: meta
                });
            }
            if (error) {
                notify(useStoreMedia_uploadError());
            //Todo remove uploaded file
            }
        });
    }, [
        addMedia,
        notify,
        siteId,
        cb
    ]);
    return [
        handler,
        data,
        loading,
        error, 
    ];
};

;// CONCATENATED MODULE: ./src/mosanic/components/Media/Handlers/useUploadFactory.js




var useUploadFactory = function(param) {
    var url = param.url, _urls = param.urls, urls = _urls === void 0 ? null : _urls, _callback = param.callback, callback = _callback === void 0 ? null : _callback;
    var ref = (0,react.useState)(url ? [
        {
            url: url
        }
    ] : null), images = ref[0], setImages = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(useMetaFields({
        images: images
    }), 3), meta = ref1[0], updateMeta = ref1[1], removeMeta = ref1[2];
    var ref2 = (0,react.useState)(false), load = ref2[0], setLoading = ref2[1];
    (0,react.useEffect)(function() {
        if (url) setImages([
            {
                url: url
            }
        ]);
    }, [
        url
    ]);
    (0,react.useEffect)(function() {
        if (urls) setImages(urls);
    }, [
        urls
    ]);
    //Upload handler
    var ref3 = (0,_sliced_to_array/* default */.Z)(useUploadFile({
        storeMediaCallback: function(data) {
            return storeMediaFile(data);
        }
    }), 5), uploadFiles = ref3[0], progress = ref3[1], loadingUpload = ref3[2], errorUpload = ref3[3], dataUpload = ref3[4];
    //Media upload handler
    var ref4 = (0,_sliced_to_array/* default */.Z)(useStoreMedia({
        useUrlCallback: function(e) {
            if (callback) callback(e);
            setLoading(false);
        }
    }), 4), storeMediaFile = ref4[0], dataMedia = ref4[1], loadingMedia = ref4[2], errorMedia = ref4[3];
    var handleRemove = function(index) {
        setImages((0,Arr/* remove */.Od)(images, index));
        removeMeta(index);
        if (callback) callback(images);
    };
    var uploadOne = function(i) {
        setLoading(true);
        uploadFiles(images[i], meta[i]);
        handleRemove(i);
    };
    var uploadFile = function(file, folder) {
        setLoading(true);
        console.log(file);
        uploadFiles({
            file: file
        }, {
            folder: folder
        });
    };
    var uploadAll = function() {
        return images.map(function(img, index) {
            uploadFiles(img, meta[index]);
            handleRemove(index);
        });
    };
    (0,react.useEffect)(function() {
        if (errorMedia || errorUpload) setLoading(false);
    }, [
        errorMedia,
        errorUpload
    ]);
    var loading = load || loadingUpload || loadingMedia || null;
    var error = errorUpload || errorMedia || null;
    var handlers = {
        updateMeta: updateMeta,
        setImages: setImages,
        uploadOne: uploadOne,
        uploadAll: uploadAll,
        uploadFile: uploadFile,
        handleRemove: handleRemove
    };
    return [
        images,
        meta,
        progress,
        handlers,
        loading,
        error
    ];
};


/***/ }),

/***/ 65475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ ListOfMedia; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/adapters/host.js
var host = __webpack_require__(6539);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/items/Spinner.js
var Spinner = __webpack_require__(36174);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/mosanic/styles/flex.styles.js
var flex_styles = __webpack_require__(5441);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/Media.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n\n    video {\n        width: 100%;\n        height: 100%;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        min-height: 0;\n        border-left: 0;\n        padding: 0;\n        width: 100%;\n        padding: 0;\n\n        ",
        " {\n            ",
        "\n            width: 50%;\n            height: 100%;\n            float: left;\n        }\n        ",
        " {\n            padding-left: 25px;\n            width: 50%;\n            float: left;\n        }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    padding: 0 10px;\n    top:0;\n    /* position:absolute; */\n    right: 0;\n    height: 100%;\n    min-height: 70vh;\n    border-left: 1px solid ",
        ";\n    width: 30%;\n    float: left;\n    max-height: none;\n\n    ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        height: 90px;\n        width: 90px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        border: 1.5px solid ",
        ";\n        transform: scale(1.02);\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        &, &:hover {\n            border: 1.5px solid transparent;\n            cursor: default;\n        }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    transition: all ease-in-out 0.4s;\n    background-color: ",
        ";\n    /* display: inline-block; */\n    vertical-align: top;\n    max-width: 48%;\n    height: auto;\n    \n    height: 200px;\n    width: 200px;\n\n    @media (min-width: 1000px) {\n        height: 200px;\n        width: 23%;\n        height: 170px;\n    }\n    @media (min-width: 1400px) {\n        height: 200px;\n        width: 18%;\n        height: 190px;\n    }\n\n    ",
        "\n    background-position: center center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    margin: 0 1% 10px;\n    cursor: pointer;\n    border: 1.5px solid ",
        ";\n    position: relative;\n\n    &:hover {\n      border: 1.5px solid ",
        ";\n    }\n    ",
        "\n\n    ",
        "\n    video {\n        pointer-events: none;\n        width: 100%;\n        height: 100%;\n    }\n\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    width: 70%;\n    /* padding: 25px 10px; */\n    float: left;\n    height: auto;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        min-height: 100px;\n\n        ",
        " {\n            width: 100%;\n            padding: 0;\n\n            ",
        " {\n                min-height: 100px;\n            }\n        }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    min-height: 70vh;\n    height: auto;\n    display: block;\n    ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    clear: both;\n    display: block;\n    content: '';\n    position: relative;\n    min-height: 2vh;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var MediaContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef5b2f99-0"
})(_templateObject());
var SideBarImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef5b2f99-1"
})(_templateObject1());
var MediaSideBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef5b2f99-2"
})(_templateObject3(), colors/* default.util.gray.light */.ZP.util.gray.light, function(props) {
    return props.dialog && (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), SideBarImage, flex_styles/* CenterCenter */.IV, MediaContent);
});
var MediaItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef5b2f99-3"
})(_templateObject7(), colors/* default.util.gray.lightest */.ZP.util.gray.lightest, function(props) {
    return props.size === "small" && (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
}, colors/* default.util.gray.light */.ZP.util.gray.light, colors/* default.util.primary.base */.ZP.util.primary.base, function(props) {
    return props.active && (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), colors/* default.util.primary.base */.ZP.util.primary.base);
}, function(props) {
    return props.isLoading && (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
});
var MediaItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef5b2f99-4"
})(_templateObject8());
/* background: ${props => props.theme.colors.light}; */ var Media = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef5b2f99-5"
})(_templateObject10(), function(props) {
    return props.dialog && (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), MediaItems, MediaItem);
});
var Clear = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef5b2f99-6"
})(_templateObject11());
var MediaStyles = {
    Clear: Clear,
    Media: Media,
    MediaItems: MediaItems,
    MediaSideBar: MediaSideBar,
    SideBarImage: SideBarImage,
    MediaContent: MediaContent,
    MediaItem: MediaItem
};
/* harmony default export */ var Media_styles = (MediaStyles);

// EXTERNAL MODULE: ./src/mosanic/components/Media/MediaUploader.js + 4 modules
var MediaUploader = __webpack_require__(51138);
// EXTERNAL MODULE: ./src/mosanic/utils/Image.js
var Image = __webpack_require__(73987);
// EXTERNAL MODULE: ../../node_modules/react-images-viewer/lib/ImgsViewer.js
var ImgsViewer = __webpack_require__(26689);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ./src/mosanic/items/Skeletons/Skeletons.js + 1 modules
var Skeletons = __webpack_require__(86443);
// EXTERNAL MODULE: ./src/utils/Arr.js
var Arr = __webpack_require__(72393);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/MediaItem.js








var MediaItem_MediaItem = function(param) {
    var size = param.size, setPreview = param.setPreview, image = param.image, isActive = param.isActive;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Media_styles.MediaItem, {
        size: size,
        active: isActive,
        className: "MediaGallery__item",
        style: {
            backgroundImage: "url('".concat((0,host/* getImageUrl */.Jn)(!(0,Text/* containsSubstr */.xX)(image === null || image === void 0 ? void 0 : image.urlThumb, ".svg") && (image === null || image === void 0 ? void 0 : image.urlThumb) ? image.urlThumb : image.url), "')")
        },
        onClick: function() {
            return setPreview(image);
        },
        children: !(0,Image/* isImage */.Or)((image === null || image === void 0 ? void 0 : image.urlThumb) ? image.urlThumb : image.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
            src: (0,host/* getImageUrl */.Jn)(image === null || image === void 0 ? void 0 : image.url),
            alt: "Video",
            loop: true,
            controls: true,
            muted: true,
            autoPlay: true
        })
    });
};
var NoMediaItems = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,Arr/* loop */.VX)(3, /*#__PURE__*/ (0,jsx_runtime.jsx)(Media_styles.MediaItem, {
                size: size,
                isLoading: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeletons/* Skeleton */.Od, {})
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                ml: 2,
                children: "No assets found."
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/items/Expander/index.js + 1 modules
var Expander = __webpack_require__(56957);
// EXTERNAL MODULE: ./src/mosanic/items/Link/index.js
var Link = __webpack_require__(8152);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ./src/utils/Round.js
var Round = __webpack_require__(82261);
// EXTERNAL MODULE: ./src/adapters/mutations/media.js
var media = __webpack_require__(96362);
// EXTERNAL MODULE: ./src/hooks/useApi.js + 3 modules
var useApi = __webpack_require__(70210);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/features/notification/action.js
var action = __webpack_require__(64725);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/Handlers/useDeleteAsset.js







var ERROR_DURATION = 10000;
var STATUS_DURATION = 4000;
var errorField = function(field) {
    return {
        message: "Asset could not be deleted. ".concat(field, " not received."),
        feature: "ImageContainer",
        meta: {
            duration: ERROR_DURATION
        }
    };
};
var errorAction = function(action) {
    return {
        message: "".concat(action, " error."),
        feature: "ImageContainer",
        meta: {
            duration: ERROR_DURATION
        }
    };
};
var successAction = function(action) {
    return {
        message: "".concat(action, " success."),
        feature: "ImageContainer",
        meta: {
            duration: STATUS_DURATION
        }
    };
};
var useDeleteAsset = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    var notify = function(notification) {
        return dispatch((0,action/* setNotification */.sc)(notification));
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,useApi/* useMutate */.Tu)("deleteFile", media/* DELETE_UPLOAD */.DC), 2), deleteFile = ref[0], ref1 = (0,_sliced_to_array/* default */.Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useApi/* useMutate */.Tu)("mediaRemoveById", media/* DELETE_MEDIA */.CI), 2), deleteMedia = ref2[0], ref3 = (0,_sliced_to_array/* default */.Z)(ref2[1], 3), dataMedia = ref3[0], loadingMedia = ref3[1], errorMedia = ref3[2];
    var handleDelete = function(asset) {
        var _id = asset._id, filename = asset.filename, url = asset.url;
        var next = true;
        if ((url === null || url === void 0 ? void 0 : url.charAt(0)) === "/") url = (0,Text/* removeFirstChar */.eQ)(url);
        if (!_id) {
            notify(errorField("_id"));
            next = false;
            return;
        }
        if (!filename) {
            notify(errorField("filename"));
            next = false;
            return;
        }
        if (!url) {
            notify(errorField("url"));
            next = false;
            return;
        }
        if (asset.siteId != siteId) {
            notify(errorAction("Current editing site is not as asset."));
            next = false;
            return;
        }
        deleteMedia({
            _id: _id
        }).then(function(param) {
            var data = param.data;
            if (data === null || data === void 0 ? void 0 : data.mediaRemoveById) data = data.mediaRemoveById;
            var error = data.error, recordId = data.recordId;
            if (!error) {
                notify(successAction("Deleted asset reference: ".concat(recordId)));
            } else {
                notify(errorAction("Asset reference not deleted."));
                next = false;
            }
        }).catch(function(e) {
            notify(errorAction("Asset reference not deleted. Catch error."));
            console.error(e);
            next = false;
        });
        if (next) {
            var file = {
                filename: filename,
                url: url
            };
            deleteFile(file).then(function(response) {
                notify(successAction("Deleted asset"));
                console.log(response);
            }).catch(function(e) {
                notify(errorAction("Asset not deleted. Catch error."));
                console.log(e);
            });
        }
    };
    return [
        handleDelete,
        dataMedia || data,
        loading || loadingMedia,
        error || errorMedia
    ];
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/index.js
var Input = __webpack_require__(6928);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ./src/components/Core/Utils/SuccessAlert.js
var SuccessAlert = __webpack_require__(17980);
// EXTERNAL MODULE: ./src/mosanic/fields/Form/FormGroup.js
var FormGroup = __webpack_require__(35345);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/MetaFields.js












var MetaFields = function(param) {
    var meta = param.meta, handler = param.handler, trigger = param.trigger, _dialog = param.dialog, dialog = _dialog === void 0 ? true : _dialog;
    var ref = (0,index_esm/* useForm */.cI)({
        mode: "all"
    }), handleSubmit = ref.handleSubmit, control = ref.control, watch = ref.watch, reset = ref.reset, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid;
    (0,react.useEffect)(function() {
        reset(meta);
    }, [
        meta,
        reset
    ]);
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors
    };
    var ref1 = (0,react.useState)(false), modalStateManager = ref1[0], setModalStateManager = ref1[1];
    var ref2 = (0,react.useState)(false), updated = ref2[0], setUpdated = ref2[1];
    var open = function() {
        setModalStateManager(true);
        setUpdated(false);
    };
    var onSubmit = function(data) {
        handler(data);
        setUpdated(true);
        setTimeout(function() {
            setModalStateManager(false);
        }, 1000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalWrapper/* ConditionalWrapper */.M, {
            when: dialog,
            wrapper: function(children) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: open,
                            children: trigger
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                            state: modalStateManager,
                            close: function() {
                                return setModalStateManager(false);
                            },
                            size: "xs",
                            fullWidth: true,
                            portal: false,
                            children: children
                        })
                    ]
                });
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                    span: true,
                    helpText: "From here you can edit the meta data of your assets and pages.",
                    children: "Edit SEO fields."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, {
                    disabled: !updated,
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            name: "title",
                            label: "Title",
                            type: "text"
                        }, inputProps), {
                            rules: {
                                required: "You should enter the title for seo purposes."
                            }
                        })),
                        dialog ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    name: "alt",
                                    label: "Alt text",
                                    type: "textarea"
                                }, inputProps), {
                                    rules: {
                                        required: "Give a description about your asset."
                                    }
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                                    name: "folder",
                                    label: "Folder",
                                    type: "text"
                                }, inputProps))
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                                    name: "description",
                                    label: "Description",
                                    type: "textarea"
                                }, inputProps)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    name: "keywords",
                                    label: "Keywords",
                                    type: "text"
                                }, inputProps), {
                                    rules: {
                                        required: "Comma seperated and required."
                                    }
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                                    name: "language",
                                    label: "Language",
                                    type: "text"
                                }, inputProps)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                                    name: "robots",
                                    label: "Robots indexing",
                                    type: "switch"
                                }, inputProps))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            wrap: true,
                            fullWidth: true,
                            label: dialog ? "Store meta" : "Update",
                            theme: "primary",
                            size: "large",
                            type: "submit",
                            disabled: Boolean(!isValid)
                        })
                    ]
                }),
                updated && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessAlert/* SuccessAlert */.I, {
                    successMessage: "Updated meta"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/mosanic/components/Media/MediaPreview.js
















var MediaPreview = function(param) {
    var previewImage = param.previewImage, close = param.close, initiate = param.initiate, initiateImage = param.initiateImage, dialog = param.dialog, callbackDelete = param.callbackDelete, _hasImages = param.hasImages, hasImages = _hasImages === void 0 ? false : _hasImages;
    var ref = (0,_sliced_to_array/* default */.Z)(useDeleteAsset(), 4), handleDelete = ref[0], dataDelete = ref[1], loadingDelete = ref[2], errorDelete = ref[3];
    // useEffect(() => {
    // 	if(dataDelete?.recordId && callbackDelete) 
    // 		callbackDelete(dataDelete?.recordId)
    // }, [dataDelete?.recordId, callbackDelete])
    var metaFields = [
        {
            label: "Asset Title",
            value: previewImage === null || previewImage === void 0 ? void 0 : previewImage.title
        },
        {
            label: "Alt Text",
            value: previewImage === null || previewImage === void 0 ? void 0 : previewImage.alt
        },
        {
            label: "Filename",
            value: previewImage === null || previewImage === void 0 ? void 0 : previewImage.filename
        },
        {
            label: "Folder",
            value: (previewImage === null || previewImage === void 0 ? void 0 : previewImage.folder) ? previewImage === null || previewImage === void 0 ? void 0 : previewImage.folder : "/"
        },
        {
            label: "Size",
            value: !(previewImage === null || previewImage === void 0 ? void 0 : previewImage.size) ? "unknown" : (0,Round/* roundPrecise */.FK)(previewImage === null || previewImage === void 0 ? void 0 : previewImage.size, 2) + " mb"
        },
        {
            label: "SiteId",
            value: previewImage === null || previewImage === void 0 ? void 0 : previewImage.siteId
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: dialog,
        wrapper: function(children) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                size: "large",
                state: previewImage === null || previewImage === void 0 ? void 0 : previewImage.url,
                close: close,
                children: children
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Media_styles.MediaSideBar, {
            className: "CoreSidebar MediaGallery__sidebar",
            dialog: dialog,
            children: (previewImage === null || previewImage === void 0 ? void 0 : previewImage.url) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "MediaGallery__itemPreview mt-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Media_styles.SideBarImage, {
                        children: !(0,Image/* isImage */.Or)(previewImage === null || previewImage === void 0 ? void 0 : previewImage.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            src: (0,host/* getImageUrl */.Jn)(previewImage === null || previewImage === void 0 ? void 0 : previewImage.url),
                            alt: "Video",
                            controls: true
                        }) : // eslint-disable-next-line @next/next/no-img-element
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,host/* getImageUrl */.Jn)(!(0,Text/* containsSubstr */.xX)(previewImage === null || previewImage === void 0 ? void 0 : previewImage.urlMin, ".svg") && (previewImage === null || previewImage === void 0 ? void 0 : previewImage.urlMin) ? previewImage === null || previewImage === void 0 ? void 0 : previewImage.urlMin : previewImage === null || previewImage === void 0 ? void 0 : previewImage.url),
                            alt: "",
                            width: "100%"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media_styles.MediaContent, {
                        children: [
                            loadingDelete,
                            errorDelete,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    children: [
                                        "Title: ",
                                        (0,Text/* excerptString */.dK)(previewImage === null || previewImage === void 0 ? void 0 : previewImage.title, 22, "...")
                                    ]
                                }),
                                children: metaFields === null || metaFields === void 0 ? void 0 : metaFields.map(function(field) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                                        mt: 2,
                                        label: field === null || field === void 0 ? void 0 : field.label,
                                        value: field === null || field === void 0 ? void 0 : field.value
                                    }, field.label);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                                mt: 2,
                                label: "Minimized version",
                                value: (previewImage === null || previewImage === void 0 ? void 0 : previewImage.urlMin) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.ZP, {
                                    href: (0,host/* getImageUrl */.Jn)(previewImage === null || previewImage === void 0 ? void 0 : previewImage.urlMin),
                                    target: "_blank",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowRightIcon */.LZ3, {}),
                                        " ",
                                        (0,Round/* roundPrecise */.FK)((previewImage === null || previewImage === void 0 ? void 0 : previewImage.size) * 0.3, 2),
                                        " mb"
                                    ]
                                }) : "No"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                                mt: 2,
                                label: "Public Url",
                                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                    href: (0,host/* getImageUrl */.Jn)(previewImage === null || previewImage === void 0 ? void 0 : previewImage.url),
                                    target: "_blank",
                                    children: (0,Text/* replacePart */.bA)(previewImage === null || previewImage === void 0 ? void 0 : previewImage.url, "".concat(previewImage === null || previewImage === void 0 ? void 0 : previewImage.siteId, "/"), "")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Buttons, {
                                mt: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                        onClick: initiateImage,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* SizeIcon */.el1, {}),
                                        label: initiate ? " Select" : " Preview"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaFields, {
                                        meta: (0,_object_spread/* default */.Z)({}, previewImage),
                                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* Pencil1Icon */.JtS, {}),
                                            label: " SEO"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                        onClick: function() {
                                            return handleDelete(previewImage);
                                        },
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TrashIcon */.XHJ, {}),
                                        label: " Delete"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "empty__state",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "label",
                    children: hasImages && "Click an image to see and edit its properties here."
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./src/mosanic/hooks/useScrollTop.js
var useScrollTop = __webpack_require__(86314);
// EXTERNAL MODULE: ./src/mosanic/cms/Pagination/Pagination.js + 1 modules
var Pagination = __webpack_require__(40010);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/ListOfMedia.js














var ListOfMedia = function(param) {
    var media = param.media, _header = param.header, header = _header === void 0 ? true : _header, _initiate = param.initiate, initiate = _initiate === void 0 ? false : _initiate, _callback = param.callback, callback = _callback === void 0 ? null : _callback, _dialog = param.dialog, dialog = _dialog === void 0 ? false : _dialog, _upload = param.upload, upload = _upload === void 0 ? false : _upload, _type = param.type, type = _type === void 0 ? "image" : _type, _size = param.size, size = _size === void 0 ? null : _size, _pagination = param.pagination, pagination = _pagination === void 0 ? null : _pagination;
    var ref = (0,react.useState)(), previewImage = ref[0], initiatePreview = ref[1];
    var ref1 = (0,react.useState)(false), preview = ref1[0], setFullPreview = ref1[1];
    var setPreview = function(img) {
        initiatePreview(img);
        if (!dialog) (0,useScrollTop/* scrollTop */.S)();
    };
    var initiateImage = function() {
        if (initiate) {
            initiate((previewImage === null || previewImage === void 0 ? void 0 : previewImage.urlMin) ? {
                urlThumb: previewImage === null || previewImage === void 0 ? void 0 : previewImage.urlThumb,
                urlMin: previewImage.urlMin,
                url: previewImage === null || previewImage === void 0 ? void 0 : previewImage.url,
                seo: {
                    title: previewImage === null || previewImage === void 0 ? void 0 : previewImage.title,
                    alt: previewImage === null || previewImage === void 0 ? void 0 : previewImage.alt
                }
            } : previewImage === null || previewImage === void 0 ? void 0 : previewImage.url);
            if (dialog) setPreview(null);
        } else {
            setFullPreview(true);
        }
    };
    var callbackDelete = function(recordId) {
        callback(recordId);
        setPreview(null);
    };
    var shouldShow = function(img) {
        return type === "video" && !(0,Image/* isImage */.Or)((img === null || img === void 0 ? void 0 : img.urlThumb) ? img === null || img === void 0 ? void 0 : img.urlThumb : img === null || img === void 0 ? void 0 : img.url) || type != "video";
    };
    var ref2 = (0,react.useState)(false), modalStateManager = ref2[0], setModalStateManager = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media_styles.Media, {
        className: "MediaGallery",
        dialog: dialog,
        children: [
            header && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: "Media"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                        onClick: function() {
                            return setModalStateManager(true);
                        },
                        children: "Upload media"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media_styles.MediaItems, {
                className: "MediaGallery__items",
                children: [
                    (media === null || media === void 0 ? void 0 : media.length) >= 1 ? media.map(function(image, index) {
                        return shouldShow(image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaItem_MediaItem, {
                            setPreview: setPreview,
                            image: image,
                            isActive: (previewImage === null || previewImage === void 0 ? void 0 : previewImage.url) === image.url,
                            size: size
                        }, image === null || image === void 0 ? void 0 : image._id);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoMediaItems, {
                        size: size
                    }),
                    pagination && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, (0,_object_spread/* default */.Z)({
                        type: "table"
                    }, pagination))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaPreview, {
                previewImage: previewImage,
                close: function() {
                    return setPreview(null);
                },
                initiate: initiate,
                initiateImage: initiateImage,
                callbackDelete: callbackDelete,
                hasImages: (media === null || media === void 0 ? void 0 : media.length) >= 1,
                dialog: dialog
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Media_styles.Clear, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "clearfix clear-both"
            }),
            upload && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                onClick: function() {
                    return setModalStateManager(true);
                },
                label: "Upload media"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                state: modalStateManager,
                close: function() {
                    return setModalStateManager(false);
                },
                size: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                        helpText: "From here you can view, load and open your pages.",
                        children: "Upload item"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaUploader["default"], {
                        showEditor: true,
                        maxNumber: 3
                    })
                ]
            }),
            (previewImage === null || previewImage === void 0 ? void 0 : previewImage.url) >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgsViewer["default"], {
                imgs: [
                    {
                        src: (0,host/* getImageUrl */.Jn)(previewImage === null || previewImage === void 0 ? void 0 : previewImage.url)
                    }
                ],
                spinner: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {});
                },
                // currImg={previewImage}
                isOpen: preview,
                // onClickPrev={this.gotoPrevious}
                // onClickNext={this.gotoNext}
                onClose: function() {
                    return setFullPreview(false);
                }
            })
        ]
    });
}; // ListOfArticles.propTypes = {
 // 	articles: PropTypes.arrayOf(
 // 		PropTypes.shape({
 // 			title: PropTypes.string.isRequired,
 // 			_id: PropTypes.string.isRequired,
 // 			published: PropTypes.bool.isRequired,
 // 			description: PropTypes.string.isRequired,
 // 		})
 // 	),
 // 	startPolling: PropTypes.func.isRequired,
 // 	stopPolling: PropTypes.func.isRequired
 // };


/***/ }),

/***/ 67683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MarkedImage": function() { return /* binding */ MarkedImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_builder_Modal_Modal__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(10766);
/* harmony import */ var _mosanic_components_Media_Handlers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2531);
/* harmony import */ var _mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(64957);
/* harmony import */ var _mosanic_core_Collections__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11096);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26074);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(47914);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(91639);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(71645);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(39381);
/* harmony import */ var _mosanic_fields_File__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(60772);
/* harmony import */ var _mosanic_hooks__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(42974);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(41145);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(99057);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(56957);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5441);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2921);
/* harmony import */ var _mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73987);
/* harmony import */ var _mosanic_utils_value__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(11039);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77298);
/* harmony import */ var _util_Arr__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(72393);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68311);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var react_image_marker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36732);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26021);
// import { RenderDialog } from '@mosanic/builder/Modal';






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        border-radius: 50%;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        transform: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n            transform: ",
        ";\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    transition: all ease-in-out 0.3s;\n    width: 25px;\n    height: 25px;\n    \n    background: ",
        ";\n    border: 2px solid ",
        ";\n    color: ",
        ";\n    box-shadow: rgba(0,0,0,0.35) 5px 5px 10px 5px;\n    font-size: 12px;\n    ",
        "\n\n    ",
        "\n    ",
        "\n    :hover {\n        cursor: pointer;\n        ",
        "  \n        &[title]::after {\n            background: inherit;\n            padding: 5px 10px;\n            content: attr(title);\n            position: absolute;\n            top: calc(-100% - 15px);\n            left: calc(-50% - 10px);\n            box-shadow: rgba(0,0,0,0.4) 5px 5px 25px 5px;\n        }\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    display: flex;\n    align-items: center; \n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    margin-top: 8px;\n    border: 1px dashed ",
        ";\n    padding: 2px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



















var getType = function(type) {
    if (type === "dot") return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject());
    return "";
};
var MarkerDot = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a3ec2738-0"
})(_templateObject3(), function(props) {
    var ref;
    return (ref = props.styleProps) === null || ref === void 0 ? void 0 : ref.bg;
}, function(props) {
    var ref;
    return (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .darken */ ._j)(0.1, (ref = props.styleProps) === null || ref === void 0 ? void 0 : ref.bg);
}, function(props) {
    var ref;
    return (ref = props.styleProps) === null || ref === void 0 ? void 0 : ref.color;
}, _mosanic_styles__WEBPACK_IMPORTED_MODULE_7__/* .CenterCenter */ .IV, function(props) {
    return getType(props.type);
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1(), "scale(".concat(props.size === "large" ? 1.4 : props.size === "small" ? 1 : props.size === "xs" ? 0.5 : 1, ")"));
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), "scale(".concat(props.size === "large" ? 1.6 : props.size === "small" ? 1.2 : props.size === "xs" ? 0.75 : 1.2, ")"));
});
var Inline = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a3ec2738-1"
})(_templateObject4());
var Border = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a3ec2738-2"
})(_templateObject5(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_8__/* ["default"].util.gray.light */ .ZP.util.gray.light);
var typeLabel = function(type, styleProps, size) {
    var title = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Inline, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MarkerDot, {
                styleProps: styleProps,
                type: type,
                size: size,
                children: "1"
            }),
            "\xa0",
            (styleProps === null || styleProps === void 0 ? void 0 : styleProps.title) && title ? styleProps.title : "".concat((0,_util_Text__WEBPACK_IMPORTED_MODULE_9__/* .capitalizeFirst */ .Ez)(type), " ").concat(size ? size : "")
        ]
    });
};
var defaultDot = function(i) {
    return {
        color: "#000",
        bg: "#fff",
        type: "dot",
        title: "Dot ".concat(i)
    };
};
var MarkedImageUploader = function(param) {
    var value = param.value, _type = param.type, type = _type === void 0 ? "image" : _type, _onChange = param.onChange, onChange = _onChange === void 0 ? null : _onChange, _label = param.label, label = _label === void 0 ? null : _label, _setup = param.setup, setup = _setup === void 0 ? true : _setup, _relation = param.relation, relation = _relation === void 0 ? null : _relation, _display = param.display, display = _display === void 0 ? null : _display, _displayOnly = param.displayOnly, displayOnly = _displayOnly === void 0 ? false : _displayOnly;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var source = (0,_mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_10__/* .parseImageSrc */ .yO)((value === null || value === void 0 ? void 0 : (ref = value.img) === null || ref === void 0 ? void 0 : ref.url) ? value === null || value === void 0 ? void 0 : (ref1 = value.img) === null || ref1 === void 0 ? void 0 : ref1.url : value === null || value === void 0 ? void 0 : value.img, true);
    var ref11 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_mosanic_core_Collections__WEBPACK_IMPORTED_MODULE_12__/* .useCollection */ .K)({
        _id: relation
    }), 2), handler = ref11[0], ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(ref11[1], 1), collection = ref12[0];
    var hasRelation = Boolean(collection && relation);
    //Data
    var ref13 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_mosanic_components_Media_Handlers__WEBPACK_IMPORTED_MODULE_13__/* .useUploadFactory */ .V)({
        callback: function(img) {
            return onChange((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, value), {
                img: img
            }));
        },
        url: value === null || value === void 0 ? void 0 : value.img
    }), 6), images = ref13[0], meta = ref13[1], progress = ref13[2], handlers = ref13[3], loading = ref13[4], error = ref13[5];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), trigger = ref14[0], setTrigger = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)((value === null || value === void 0 ? void 0 : value.styles) ? value === null || value === void 0 ? void 0 : value.styles : []), styles = ref15[0], setStyles = ref15[1];
    var updateStyle = function(index, newData) {
        return setStyles((0,_util_Arr__WEBPACK_IMPORTED_MODULE_16__/* .updateItem */ .$G)(styles, index, newData));
    };
    var removeStyle = function(index) {
        return setStyles((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_util_Arr__WEBPACK_IMPORTED_MODULE_16__/* .remove */ .Od)(styles, index)));
    };
    var addStyle = function() {
        return setStyles((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(styles).concat([
            defaultDot(styles === null || styles === void 0 ? void 0 : styles.length)
        ]));
    };
    //Data handling
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)((value === null || value === void 0 ? void 0 : value.markers) ? value === null || value === void 0 ? void 0 : value.markers : []), arr = ref16[0], setArr = ref16[1];
    var updateItem = function(index, newData) {
        return setArr((0,_util_Arr__WEBPACK_IMPORTED_MODULE_16__/* .updateItem */ .$G)(arr, index, newData));
    };
    var removeItem = function(index) {
        return setArr((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_util_Arr__WEBPACK_IMPORTED_MODULE_16__/* .remove */ .Od)(arr, index)));
    };
    var addItem = function(item) {
        return setArr((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(arr).concat([
            item
        ]));
    };
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), relationType = ref17[0], setRelationType = ref17[1];
    var removeMarker = function(index) {
        return removeItem(index);
    };
    // useEffect(() => {
    //     if(display && !value?.display) onChange({...value, display})
    //     if(relation && !value?.relation) onChange({...value, relation})
    //      if(value?.markers) setArr(value?.markers)
    // },[display, value?.markers, relation, value])
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var timer;
        timer = setTimeout(function() {
            if ((arr === null || arr === void 0 ? void 0 : arr.length) >= 1) onChange((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, value), {
                markers: arr
            }));
        }, 400);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        arr,
        value === null || value === void 0 ? void 0 : (ref2 = value.markers) === null || ref2 === void 0 ? void 0 : ref2.length,
        value === null || value === void 0 ? void 0 : value.markers
    ]);
    // useEffect(() => {
    //     let timer;
    //     timer = setTimeout(() => {
    //         if(styles?.length >= 1) onChange({...value, styles})
    //     }, 400);
    //     return ()=> clearTimeout(timer)
    // },[styles?.length, styles, setup])
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), activeMarkerIndex = ref18[0], setActiveMarkerIndex = ref18[1];
    var Marker = function(props) {
        var ref, ref1, ref2, ref3;
        var markerDot = arr[props.itemNumber];
        var markerStyle = styles === null || styles === void 0 ? void 0 : styles.find(function(s) {
            return (s === null || s === void 0 ? void 0 : s.title) === (markerDot === null || markerDot === void 0 ? void 0 : markerDot.type);
        });
        markerStyle = markerStyle ? markerStyle : styles[0];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MarkerDot, {
            onClick: function() {
                return setActiveMarkerIndex(props.itemNumber);
            },
            style: {
                opacity: hasRelation && (markerDot === null || markerDot === void 0 ? void 0 : markerDot.relation) != relationType ? 0.4 : 1
            },
            data: markerStyle === null || markerStyle === void 0 ? void 0 : markerStyle.title,
            attr: markerDot === null || markerDot === void 0 ? void 0 : markerDot.attr,
            size: (ref1 = markerStyle === null || markerStyle === void 0 ? void 0 : (ref = markerStyle.type) === null || ref === void 0 ? void 0 : ref.split("-")) === null || ref1 === void 0 ? void 0 : ref1[1],
            type: (ref3 = markerStyle === null || markerStyle === void 0 ? void 0 : (ref2 = markerStyle.type) === null || ref2 === void 0 ? void 0 : ref2.split("-")) === null || ref3 === void 0 ? void 0 : ref3[0],
            styleProps: markerStyle,
            children: (0,_util_Text__WEBPACK_IMPORTED_MODULE_9__/* .replacePart */ .bA)(markerDot === null || markerDot === void 0 ? void 0 : markerDot.title, "Marker", "")
        });
    };
    var ref19 = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_18__/* .useTabs */ .Y)({
        tabs: (setup ? "markers|image|style" : "markers|image").split("|"),
        tab: "image"
    }), setOptions = ref19.setOptions, current = ref19.current, Tabs = ref19.Tabs;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        setOptions((setup ? "styles|trigger|markers" : "markers|image").split("|"));
    }, [
        setup
    ]);
    var RelationSelect = function(_param) {
        var onChange = _param.onChange, value = _param.value, _unsetLabel = _param.unsetLabel, unsetLabel = _unsetLabel === void 0 ? "Unset" : _unsetLabel, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_param, [
            "onChange",
            "value",
            "unsetLabel"
        ]);
        var ref;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_20__.Select, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
            wrap: true,
            fullWidth: true,
            label: "Relation",
            options: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.map(function(c) {
                var ref, ref1;
                return {
                    value: c === null || c === void 0 ? void 0 : c._id,
                    label: c === null || c === void 0 ? void 0 : c[collection === null || collection === void 0 ? void 0 : (ref = collection.schema) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name]
                };
            })).concat([
                {
                    label: unsetLabel,
                    value: null
                }
            ]),
            onChange: onChange,
            value: value
        }, other));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                state: (0,_mosanic_utils_value__WEBPACK_IMPORTED_MODULE_22__/* .isClone */ .vu)(activeMarkerIndex),
                close: function() {
                    return setActiveMarkerIndex(null);
                },
                overflow: true,
                title: "Marker: ".concat(((ref3 = arr[activeMarkerIndex]) === null || ref3 === void 0 ? void 0 : ref3.title) ? (ref4 = arr[activeMarkerIndex]) === null || ref4 === void 0 ? void 0 : ref4.title : activeMarkerIndex),
                children: (!relationType || relationType === ((ref5 = arr[activeMarkerIndex]) === null || ref5 === void 0 ? void 0 : ref5.relation)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_23__/* .InputGroupItem */ .oV, {
                    fullWidth: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_24__.Button, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .TrashIcon */ .XHJ, {}),
                            ghost: true,
                            onClick: function() {
                                return removeMarker(activeMarkerIndex);
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_25__.TextField, {
                            label: "Title",
                            value: (ref6 = arr[activeMarkerIndex]) === null || ref6 === void 0 ? void 0 : ref6.title,
                            onChange: function(e) {
                                var ref;
                                return updateItem(activeMarkerIndex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, arr[activeMarkerIndex]), {
                                    title: e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value
                                }));
                            }
                        }),
                        (styles === null || styles === void 0 ? void 0 : styles.length) >= 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_20__.Select, {
                            wrap: true,
                            fullWidth: true,
                            label: "Marker style",
                            options: styles === null || styles === void 0 ? void 0 : styles.map(function(style, index) {
                                var ref, ref1, ref2;
                                return {
                                    value: style === null || style === void 0 ? void 0 : style.title,
                                    label: typeLabel(style === null || style === void 0 ? void 0 : (ref = style.type) === null || ref === void 0 ? void 0 : ref.split("-")[0], style, (ref2 = style === null || style === void 0 ? void 0 : (ref1 = style.type) === null || ref1 === void 0 ? void 0 : ref1.split("-")) === null || ref2 === void 0 ? void 0 : ref2[1])
                                };
                            }),
                            value: (ref7 = arr[activeMarkerIndex]) === null || ref7 === void 0 ? void 0 : ref7.type,
                            onChange: function(type) {
                                return updateItem(activeMarkerIndex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, arr[activeMarkerIndex]), {
                                    type: type
                                }));
                            }
                        }),
                        hasRelation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RelationSelect, {
                            value: (ref8 = arr[activeMarkerIndex]) === null || ref8 === void 0 ? void 0 : ref8.relation,
                            onChange: function(relation) {
                                return updateItem(activeMarkerIndex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, arr[activeMarkerIndex]), {
                                    relation: relation
                                }));
                            }
                        }),
                        ((ref9 = trigger === null || trigger === void 0 ? void 0 : trigger.split("\n")) === null || ref9 === void 0 ? void 0 : ref9.length) >= 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_20__.Select, {
                            wrap: true,
                            fullWidth: true,
                            label: "Trigger",
                            options: trigger === null || trigger === void 0 ? void 0 : trigger.split("\n"),
                            value: (ref10 = arr[activeMarkerIndex]) === null || ref10 === void 0 ? void 0 : ref10.trigger,
                            onChange: function(trigger) {
                                return updateItem(activeMarkerIndex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, arr[activeMarkerIndex]), {
                                    trigger: trigger
                                }));
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Tabs, {}),
            current === "image" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields_File__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                label: label,
                onChange: function(e) {
                    return handlers.uploadFile(e.target.files[0], "");
                },
                initiate: function(url) {
                    handlers === null || handlers === void 0 ? void 0 : handlers.setImages([
                        {
                            url: url
                        }
                    ]);
                    onChange((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, value), {
                        img: url
                    }));
                },
                value: images === null || images === void 0 ? void 0 : images[0],
                loading: loading,
                type: type
            }),
            current === "styles" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    styles === null || styles === void 0 ? void 0 : styles.map(function(itemStyle, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MarkerStyling, {
                            item: itemStyle,
                            update: function(item) {
                                return updateStyle(index, item);
                            }
                        });
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_24__.Buttons, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_24__.Button, {
                                label: "Remove type",
                                onClick: function() {
                                    return removeStyle((styles === null || styles === void 0 ? void 0 : styles.length) - 1);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_24__.Button, {
                                label: "Add type",
                                onClick: addStyle
                            })
                        ]
                    })
                ]
            }),
            current === "trigger" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_23__/* .InputGroup */ .BZ, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_27__["default"], {
                    label: "Triggers",
                    onChange: function(e) {
                        return setTrigger(e);
                    },
                    value: trigger
                })
            }),
            current === "markers" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_23__/* .InputGroup */ .BZ, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Border, {
                        children: (source === null || source === void 0 ? void 0 : source.full) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_image_marker__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            src: source === null || source === void 0 ? void 0 : source.full,
                            markers: arr ? arr : (value === null || value === void 0 ? void 0 : value.markers) ? value.markers : [],
                            onAddMarker: function(marker) {
                                return !displayOnly ? addItem(marker) : null;
                            },
                            markerComponent: Marker
                        })
                    }),
                    hasRelation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RelationSelect, {
                        unsetLabel: "View all",
                        onChange: setRelationType,
                        value: relationType,
                        label: "Filter relation"
                    }),
                    arr === null || arr === void 0 ? void 0 : arr.map(function(marker, index) {
                        var ref;
                        return (!relationType || relationType === (marker === null || marker === void 0 ? void 0 : marker.relation)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_23__/* .InputGroupItem */ .oV, {
                            fullWidth: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_24__.Button, {
                                    label: (marker === null || marker === void 0 ? void 0 : marker.title) ? marker === null || marker === void 0 ? void 0 : marker.title : index,
                                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .ChevronDownIcon */ .v4q, {}),
                                    ghost: true
                                }),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_24__.Button, {
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .TrashIcon */ .XHJ, {}),
                                        ghost: true,
                                        onClick: function() {
                                            return removeMarker(index);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_25__.TextField, {
                                        label: "Title",
                                        value: marker === null || marker === void 0 ? void 0 : marker.title,
                                        onChange: function(e) {
                                            var ref;
                                            return updateItem(index, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, marker), {
                                                title: e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value
                                            }));
                                        }
                                    }),
                                    (styles === null || styles === void 0 ? void 0 : styles.length) >= 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_20__.Select, {
                                        wrap: true,
                                        fullWidth: true,
                                        label: "Marker style",
                                        options: styles === null || styles === void 0 ? void 0 : styles.map(function(style, index) {
                                            var ref, ref1, ref2;
                                            return {
                                                value: style === null || style === void 0 ? void 0 : style.title,
                                                label: typeLabel(style === null || style === void 0 ? void 0 : (ref = style.type) === null || ref === void 0 ? void 0 : ref.split("-")[0], style, (ref2 = style === null || style === void 0 ? void 0 : (ref1 = style.type) === null || ref1 === void 0 ? void 0 : ref1.split("-")) === null || ref2 === void 0 ? void 0 : ref2[1])
                                            };
                                        }),
                                        value: marker === null || marker === void 0 ? void 0 : marker.type,
                                        onChange: function(type) {
                                            return updateItem(index, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, marker), {
                                                type: type
                                            }));
                                        }
                                    }),
                                    hasRelation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RelationSelect, {
                                        value: marker === null || marker === void 0 ? void 0 : marker.relation,
                                        onChange: function(relation) {
                                            return updateItem(index, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, marker), {
                                                relation: relation
                                            }));
                                        }
                                    }),
                                    ((ref = trigger === null || trigger === void 0 ? void 0 : trigger.split("\n")) === null || ref === void 0 ? void 0 : ref.length) >= 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_20__.Select, {
                                        wrap: true,
                                        fullWidth: true,
                                        label: "Trigger",
                                        options: trigger === null || trigger === void 0 ? void 0 : trigger.split("\n"),
                                        value: marker === null || marker === void 0 ? void 0 : marker.trigger,
                                        onChange: function(trigger) {
                                            return updateItem(index, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, marker), {
                                                trigger: trigger
                                            }));
                                        }
                                    })
                                ]
                            })
                        }, index);
                    })
                ]
            })
        ]
    });
};
var MarkerStyling = function(param) {
    var item = param.item, update = param.update;
    var markerStyles = "dot|square".split("|").map(function(type) {
        return {
            value: type,
            label: typeLabel(type, item, null, false)
        };
    });
    var addSize = function(markers, size) {
        return markers.map(function(m) {
            return {
                value: "".concat(m === null || m === void 0 ? void 0 : m.value, "-").concat(size),
                label: typeLabel(m.value, item, size, false)
            };
        });
    };
    markerStyles = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(addSize(markerStyles, "xs")).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(addSize(markerStyles, "small")), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(markerStyles), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(addSize(markerStyles, "large")));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_23__/* .InputGroup */ .BZ, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_25__.TextField, {
                label: "Title",
                value: item === null || item === void 0 ? void 0 : item.title,
                onChange: function(e) {
                    var ref;
                    return update((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, item), {
                        title: e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value
                    }));
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_20__.Select, {
                wrap: true,
                fullWidth: true,
                label: "Marker style",
                options: markerStyles,
                value: item === null || item === void 0 ? void 0 : item.type,
                onChange: function(type) {
                    return update((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, item), {
                        type: type
                    }));
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                wrap: true,
                fullWidth: true,
                label: "Background",
                value: item === null || item === void 0 ? void 0 : item.bg,
                onChange: function(bg) {
                    return update((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, item), {
                        bg: bg === null || bg === void 0 ? void 0 : bg.hex
                    }));
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                wrap: true,
                fullWidth: true,
                label: "Color",
                value: item === null || item === void 0 ? void 0 : item.color,
                onChange: function(color) {
                    return update((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, item), {
                        color: color === null || color === void 0 ? void 0 : color.hex
                    }));
                }
            })
        ]
    });
};
var MarkedImage = function(param) {
    var value = param.value;
    var ref, ref1, ref2;
    var styles = value === null || value === void 0 ? void 0 : value.styles;
    var arr = value === null || value === void 0 ? void 0 : value.markers;
    var source = (0,_mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_10__/* .parseImageSrc */ .yO)(value === null || value === void 0 ? void 0 : (ref = value.img) === null || ref === void 0 ? void 0 : ref.url, true);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), mark = ref3[0], setMark = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_mosanic_core_Collections__WEBPACK_IMPORTED_MODULE_12__/* .useCollection */ .K)({
        _id: value === null || value === void 0 ? void 0 : value.relation
    }), 2), getColl = ref4[0], ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(ref4[1], 1), collection = ref5[0];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_30__/* .usePage */ .q)({
        _id: value === null || value === void 0 ? void 0 : value.display
    }), 2), getPage = ref6[0], ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(ref6[1], 1), page = ref7[0];
    var Marker = function(props) {
        var ref, ref1, ref2, ref3;
        var mark = arr === null || arr === void 0 ? void 0 : arr[props.itemNumber];
        var markerStyle = styles === null || styles === void 0 ? void 0 : styles.find(function(s) {
            return (s === null || s === void 0 ? void 0 : s.title) === (mark === null || mark === void 0 ? void 0 : mark.type);
        });
        markerStyle = markerStyle ? markerStyle : styles[0];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MarkerDot, {
            onClick: function() {
                return setMark(mark);
            },
            data: markerStyle === null || markerStyle === void 0 ? void 0 : markerStyle.title,
            attr: mark === null || mark === void 0 ? void 0 : mark.attr,
            size: (ref1 = markerStyle === null || markerStyle === void 0 ? void 0 : (ref = markerStyle.type) === null || ref === void 0 ? void 0 : ref.split("-")) === null || ref1 === void 0 ? void 0 : ref1[1],
            type: (ref3 = markerStyle === null || markerStyle === void 0 ? void 0 : (ref2 = markerStyle.type) === null || ref2 === void 0 ? void 0 : ref2.split("-")) === null || ref3 === void 0 ? void 0 : ref3[0],
            styleProps: markerStyle,
            title: mark === null || mark === void 0 ? void 0 : mark.type,
            children: (0,_util_Text__WEBPACK_IMPORTED_MODULE_9__/* .replacePart */ .bA)(mark === null || mark === void 0 ? void 0 : mark.title, "Marker", "")
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            page && collection && mark && (mark === null || mark === void 0 ? void 0 : mark.relation) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_builder_Modal_Modal__WEBPACK_IMPORTED_MODULE_31__/* .RenderDialog */ .D, {
                page: page,
                data: collection === null || collection === void 0 ? void 0 : (ref1 = collection.entries) === null || ref1 === void 0 ? void 0 : ref1.find(function(e) {
                    return e._id === (mark === null || mark === void 0 ? void 0 : mark.relation);
                }),
                size: "xl",
                title: collection === null || collection === void 0 ? void 0 : collection.singular,
                state: mark === null || mark === void 0 ? void 0 : mark.relation,
                close: function() {
                    return setMark(null);
                }
            }),
            (value === null || value === void 0 ? void 0 : (ref2 = value.img) === null || ref2 === void 0 ? void 0 : ref2.url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_image_marker__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                src: source === null || source === void 0 ? void 0 : source.full,
                markers: Array.isArray(arr) ? arr : [],
                markerComponent: Marker
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MarkedImageUploader);


/***/ }),

/***/ 38812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_components_Media_Handlers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2531);
/* harmony import */ var _mosanic_fields_File__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(60772);
/* harmony import */ var _mosanic_Icons_ElementIcons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99559);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36174);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41145);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26021);
/* harmony import */ var _mosanic_core_Collections_FieldControls__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87818);
/* harmony import */ var _util_Arr__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72393);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73987);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mosanic_utils_value__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11039);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    position: absolute;\n    width: 150px;\n    height: 40px;\n    background: #fff;\n    opacity: 0;\n    span:not(:first-child) {\n        transform: rotate(-90deg)!important;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    display: inline-block;\n    position: relative;\n    margin: 5px;\n\n    &:hover{\n        ",
        " {\n            opacity: 1;\n        }\n    }\n    img {\n        width: 100px;\n        height: 100px;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var ImgsViewer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 26689));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26689)
            ];
        }
    }
});
var Controls = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-22b7db84-0"
})(_templateObject());
var Thumb = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-22b7db84-1"
})(_templateObject1(), Controls);
var MediaMultiUploader = function(param) {
    var imageUrls = param.imageUrls, _type = param.type, type = _type === void 0 ? "image" : _type, _callback = param.callback, callback = _callback === void 0 ? null : _callback, _label = param.label, label = _label === void 0 ? null : _label;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_mosanic_components_Media_Handlers__WEBPACK_IMPORTED_MODULE_6__/* .useUploadFactory */ .V)({
        callback: callback,
        urls: imageUrls
    }), 6), images = ref[0], meta = ref[1], progress = ref[2], handlers = ref[3], loading = ref[4], error = ref[5];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), index = ref1[0], setIndex = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var timer = null;
        timer = setTimeout(function() {
            if (images && callback) callback(images);
        }, 1500);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        images === null || images === void 0 ? void 0 : images.length
    ]);
    var ImagesGallery = function() {
        return (images === null || images === void 0 ? void 0 : images.length) >= 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImgsViewer, {
            imgs: images === null || images === void 0 ? void 0 : images.map(function(img) {
                var ref;
                return {
                    src: (ref = (0,_mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_7__/* .parseImageSrc */ .yO)(img, true)) === null || ref === void 0 ? void 0 : ref.full
                };
            }),
            spinner: function() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_8__/* .Spinner */ .$, {});
            },
            currImg: index,
            isOpen: (0,_mosanic_utils_value__WEBPACK_IMPORTED_MODULE_9__/* .isClone */ .vu)(index),
            onClickPrev: function() {
                return setIndex(index - 1);
            },
            onClickNext: function() {
                return setIndex(index + 1);
            },
            onClose: function() {
                return setIndex(null);
            }
        }) : null;
    };
    var Preview = function(param) {
        var trigger = param.trigger;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            title: "Gallery setup",
            trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                children: trigger
            }),
            children: Array.isArray(images) && (images === null || images === void 0 ? void 0 : images.map(function(i, index) {
                var ref;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Thumb, {
                    children: [
                        callback && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Controls, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_core_Collections_FieldControls__WEBPACK_IMPORTED_MODULE_11__/* .FieldControls */ .g, {
                                wrap: false,
                                move: function(currIndex, newIndex) {
                                    var imgs = (0,_util_Arr__WEBPACK_IMPORTED_MODULE_12__/* .reorder */ .HP)(images, currIndex, newIndex);
                                    handlers === null || handlers === void 0 ? void 0 : handlers.setImages(imgs);
                                    callback(imgs);
                                },
                                remove: function() {
                                    return handlers === null || handlers === void 0 ? void 0 : handlers.handleRemove(index);
                                },
                                index: index,
                                count: images === null || images === void 0 ? void 0 : images.length
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            onClick: function() {
                                return setIndex(index);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: (ref = (0,_mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_7__/* .parseImageSrc */ .yO)((i === null || i === void 0 ? void 0 : i.sizes) ? i : i === null || i === void 0 ? void 0 : i.url, true)) === null || ref === void 0 ? void 0 : ref.thumb
                            })
                        })
                    ]
                });
            }))
        });
    };
    return callback ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImagesGallery, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields_File__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                label: label,
                onChange: function(e) {
                    return handlers.uploadFile(e.target.files[0], "");
                },
                initiate: function(url) {
                    handlers === null || handlers === void 0 ? void 0 : handlers.setImages([
                        {
                            url: url
                        }
                    ]);
                    callback(images ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(images).concat([
                        {
                            url: url
                        }
                    ]) : [
                        {
                            url: url
                        }
                    ]);
                },
                value: (images === null || images === void 0 ? void 0 : images.length) ? "".concat(images === null || images === void 0 ? void 0 : images.length, " images") : null,
                loading: loading,
                thumb: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Preview, {
                    trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_Icons_ElementIcons__WEBPACK_IMPORTED_MODULE_15__/* .GalleryIcon */ .zB, {})
                }),
                type: type
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImagesGallery, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Preview, {
                trigger: (images === null || images === void 0 ? void 0 : images.length) ? "".concat(images === null || images === void 0 ? void 0 : images.length, " images") : "No images"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MediaMultiUploader);


/***/ }),

/***/ 99931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66383);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_components_Media_Handlers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2531);
/* harmony import */ var _mosanic_fields_File__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60772);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99057);







var MediaSingleUploader = function(_param) {
    var imageUrl = _param.imageUrl, _type = _param.type, type = _type === void 0 ? "image" : _type, _stopServerUpload = _param.stopServerUpload, stopServerUpload = _stopServerUpload === void 0 ? false : _stopServerUpload, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _callback = _param.callback, callback = _callback === void 0 ? null : _callback, _label = _param.label, label = _label === void 0 ? null : _label, _wrap = _param.wrap, wrap = _wrap === void 0 ? null : _wrap, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _value = _param.value, value = _value === void 0 ? null : _value, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "imageUrl",
        "type",
        "stopServerUpload",
        "onChange",
        "callback",
        "label",
        "wrap",
        "fullWidth",
        "value"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_mosanic_components_Media_Handlers__WEBPACK_IMPORTED_MODULE_3__/* .useUploadFactory */ .V)({
        url: imageUrl,
        callback: callback
    }), 6), images = ref[0], meta = ref[1], progress = ref[2], handlers = ref[3], loading = ref[4], error = ref[5];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_4__/* .WrapInput */ .Vw, {
        wrap: wrap ? wrap : false,
        fullWidth: fullWidth,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields_File__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            label: label,
            onChange: function(e) {
                if (onChange) onChange(e);
                if (!stopServerUpload) handlers.uploadFile(e.target.files[0], "");
            },
            initiate: function(url) {
                handlers === null || handlers === void 0 ? void 0 : handlers.setImages([
                    {
                        url: url
                    }
                ]);
                callback(url);
            },
            value: stopServerUpload ? value : images === null || images === void 0 ? void 0 : images[0],
            loading: loading,
            type: type
        }, other))
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MediaSingleUploader);


/***/ }),

/***/ 51138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Media_MediaUploader; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/adapters/host.js
var host = __webpack_require__(6539);
// EXTERNAL MODULE: ./src/context/CoreContext.js
var CoreContext = __webpack_require__(64178);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
;// CONCATENATED MODULE: ./src/mosanic/builder/Image/Image.style.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n   position: relative;\n  /*display: block; */\n  overflow: hidden;\n  width: 100%;\n  height: auto; \n  min-height: ",
        ";\n  ",
        "\n  \n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    height: inherit;\n    width: inherit;\n    min-width: inherit;\n    min-height: inherit;\n    max-width: inherit;\n    max-height: inherit;\n    min-height: 25px;\n    min-width: 50px;\n    /* min-height: 100px; */\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0%  {transform: scale(1.1); }\n  50% {transform: scale(1); }\n  75% {transform: scale(1); }\n  100%{transform: scale(1.1); }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  transition: all cubic-bezier(0.19, 1, 0.22, 1) 0.3s;\n  animation: ease-in-out ",
        " 2s infinite;\n  fill: ",
        ";\n  margin: 0 auto;\n  width: 35px;\n  height: 35px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: relative;\n    height: 50px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    height: 25px;\n    min-height: 45px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  transition: all ease-in-out 0.3s;\n  ",
        ", svg {\n    transition: all ease-in-out 0.3s;\n  }\n  width: 100%;\n  min-height: 120px;\n  height: 100%;\n  max-height: none;\n  border: 2px dashed ",
        ";\n  background: ",
        " ;\n  margin: 0 auto;\n  color: ",
        ";\n\n  &:hover {\n    background: ",
        " ;\n    border-color: ",
        ";\n    ",
        " {\n      animation-duration: 10s;\n      svg {\n        transform-origin: bottom center;\n        transform: scale(1.1);\n      }\n    }\n  }\n  ",
        "\n  /* ",
        " */\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  padding: 0;\n  width: 100%;\n\n  ",
        "{\n    border-bottom: 1px solid ",
        ";\n    \n    &:last-child {\n      border-bottom: none;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  transition: all ease-in-out 0.2s;\n  position: relative;\n  height: 75px;\n  width: 75px;\n  transform: scale(0.85);\n  transform-origin: left center;\n  video {\n    width: 100%;\n    height: 100%;\n  }\n  &:hover {\n    transform: scale(0.9);\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  /* position: ",
        "; */\n  display: inline-block;\n  z-index: 3;\n  /* position: absolute; */\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  margin-right: auto;\n  margin-left: 5px;\n  margin-top: 0px;\n  min-width: 50%;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cefe10ab-0"
})(_templateObject(), function(props) {
    return props.type === "background" ? "250px" : props.type === "uploader" ? "50px" : "50px";
}, function(props) {
    return props.type === "uploader" ? "height: 75px;" : "";
});
var DisplayImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cefe10ab-1"
})(_templateObject1());
var Pulse = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject2());
var Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cefe10ab-2"
})(_templateObject3(), Pulse, colors/* default.util.primary.base */.ZP.util.primary.base);
var DropTarget = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-cefe10ab-3"
})(_templateObject6(), Icon, colors/* default.util.gray.light */.ZP.util.gray.light, colors/* default.util.gray.lightest */.ZP.util.gray.lightest, colors/* default.util.gray.dark */.ZP.util.gray.dark, colors/* default.util.gray.lighter */.ZP.util.gray.lighter, colors/* default.util.primary.lighter */.ZP.util.primary.lighter, Icon, function(props) {
    return props.count >= 1 && (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
}, function(props) {
    return props.type === "input" && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
});
var DropTargetWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cefe10ab-4"
})(_templateObject7());
var UploadedListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-cefe10ab-5"
})(_templateObject8());
var UploadedList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-cefe10ab-6"
})(_templateObject9(), UploadedListItem, colors/* default.util.gray.light */.ZP.util.gray.light);
var UploadedImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cefe10ab-7"
})(_templateObject10());
var Controllers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cefe10ab-8"
})(_templateObject11(), function(props) {
    return props.editor && !props.minSize ? "absolute" : "relative";
});
var Meta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cefe10ab-9"
})(_templateObject12());
var ImageStyles = {
    Container: Container,
    DisplayImage: DisplayImage,
    Icon: Icon,
    DropTargetWrapper: DropTargetWrapper,
    DropTarget: DropTarget,
    Controllers: Controllers,
    UploadedImage: UploadedImage,
    UploadedList: UploadedList,
    UploadedListItem: UploadedListItem,
    Meta: Meta
};
/* harmony default export */ var Image_style = (ImageStyles);

// EXTERNAL MODULE: ./src/mosanic/components/Media/Handlers/useUploadFactory.js + 3 modules
var useUploadFactory = __webpack_require__(2531);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/fields/Video/index.js + 1 modules
var Video = __webpack_require__(26518);
// EXTERNAL MODULE: ./src/mosanic/hooks/useNotify.js
var useNotify = __webpack_require__(33346);
// EXTERNAL MODULE: ./src/mosanic/Icons/ElementIcons.js
var ElementIcons = __webpack_require__(99559);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/items/LoadingDots.tsx
var LoadingDots = __webpack_require__(4093);
// EXTERNAL MODULE: ./src/mosanic/utils/Image.js
var Image = __webpack_require__(73987);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-images-uploading/dist/index.js
var dist = __webpack_require__(97802);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/jsx/ControlStatements.js
var ControlStatements = __webpack_require__(706);
// EXTERNAL MODULE: ./src/mosanic/Icons/EditIcons.js
var EditIcons = __webpack_require__(75679);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/MediaDropTarget.js




var MediaDropTarget = function(param) {
    var onImageUpload = param.onImageUpload, images = param.images, dragProps = param.dragProps, type = param.type;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Image_style.DropTarget, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        size: "small",
        onClick: onImageUpload,
        count: images === null || images === void 0 ? void 0 : images.length,
        type: type
    }, dragProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_style.Icon, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        "data-name": "Layer 2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            "data-name": "cloud-upload",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: "8",
                                    height: "8",
                                    opacity: "0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M12.71 11.29a1 1 0 0 0-1.4 0l-3 2.9a1 1 0 1 0 1.38 1.44L11 14.36V20a1 1 0 0 0 2 0v-5.59l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M17.67 7A6 6 0 0 0 6.33 7a5 5 0 0 0-3.08 8.27A1 1 0 1 0 4.75 14 3 3 0 0 1 7 9h.1a1 1 0 0 0 1-.8 4 4 0 0 1 7.84 0 1 1 0 0 0 1 .8H17a3 3 0 0 1 2.25 5 1 1 0 0 0 .09 1.42 1 1 0 0 0 .66.25 1 1 0 0 0 .75-.34A5 5 0 0 0 17.67 7z"
                                })
                            ]
                        })
                    })
                })
            }),
            (images === null || images === void 0 ? void 0 : images.length) >= 1 ? "Drop or click to upload more" : "Drop or click"
        ]
    }));
};

;// CONCATENATED MODULE: ./src/mosanic/components/Media/MediaController.js






// {
//         imageList,
//         onImageUpload,
//         onImageRemoveAll,
//         onImageUpdate,
//         onImageRemove,
//         isDragging,
//         dragProps,
//       }
var MediaController = function(param) {
    var actions = param.actions, canUpload = param.canUpload, showEditor = param.showEditor, images = param.images, _type = param.type, type = _type === void 0 ? "large" : _type;
    return showEditor || (images === null || images === void 0 ? void 0 : images.length) <= 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Image_style.DropTargetWrapper, {
        // minSize={(!images) || images?.length >= 2} 
        minSize: true,
        editor: showEditor,
        className: "controls",
        canUpload: canUpload,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlStatements.If, {
                condition: canUpload,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaDropTarget, {
                    type: type,
                    onImageUpload: actions === null || actions === void 0 ? void 0 : actions.onImageUpload,
                    dragProps: actions === null || actions === void 0 ? void 0 : actions.dragProps,
                    images: images
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlStatements.If, {
                condition: !canUpload,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        position: "absolute",
                        right: 0,
                        top: -8,
                        zIndex: 3
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Buttons, {
                        size: "small",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                handler: actions.onImageUpload,
                                size: "small",
                                label: "Update",
                                ghost: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Button, {
                                variant: "text",
                                size: "small",
                                ghost: true,
                                handler: actions.handleRemoveAll,
                                children: [
                                    EditIcons/* trash */._I,
                                    " Remove all"
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    }) : null;
};

// EXTERNAL MODULE: ./src/mosanic/fields/TextField/Fields.js
var Fields = __webpack_require__(91639);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(87567);
// EXTERNAL MODULE: ./src/mosanic/fields/TextArea/index.js + 6 modules
var TextArea = __webpack_require__(71645);
// EXTERNAL MODULE: ./src/mosanic/Icons/SidebarIcons.js
var SidebarIcons = __webpack_require__(26703);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Popper.js + 4 modules
var Popper = __webpack_require__(28932);
// EXTERNAL MODULE: ./src/mosanic/items/Spinner.js
var Spinner = __webpack_require__(36174);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/MediaListImage.js













var ImgsViewer = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 26689));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26689)
            ];
        }
    },
    ssr: false
});
var MediaListImage = function(param) {
    var actions = param.actions, image = param.image, meta = param.meta, index = param.index, showEditor = param.showEditor, _type = param.type, type = _type === void 0 ? "image" : _type;
    var source = (0,Image/* parseImageSrc */.yO)(image.url, true);
    var ref = (0,react.useState)(false), preview = ref[0], setPreview = ref[1];
    var togglePreview = function() {
        return setPreview(function(prev) {
            return !prev;
        });
    };
    var updateName = function(e) {
        return actions.updateMeta(index, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, meta), {
            title: e.target.value
        }));
    };
    var updateAlt = function(e) {
        return actions.updateMeta(index, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, meta), {
            alt: e
        }));
    };
    var updateFold = function(e) {
        return actions.updateMeta(index, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, meta), {
            folder: e.target.value
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Image_style.UploadedListItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_style.UploadedImage, {
                onClick: togglePreview,
                children: type === "video" && (0,Text/* matchSubstrList */.OV)(image["url"], [
                    "mp4",
                    "mov"
                ]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    src: source === null || source === void 0 ? void 0 : source.thumb,
                    alt: "Video",
                    controls: true
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: source === null || source === void 0 ? void 0 : source.thumb,
                    alt: image === null || image === void 0 ? void 0 : image.title,
                    width: "75px",
                    height: "75px"
                })
            }),
            showEditor && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_style.Meta, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                    fullWidth: true,
                    label: "Asset Name",
                    value: meta === null || meta === void 0 ? void 0 : meta.title,
                    onChange: updateName
                })
            }),
            showEditor && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_style.Controllers, {
                editor: showEditor,
                className: "controls",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* ButtonGroup */.h, {
                    size: "small",
                    mt: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popper/* default */.Z, {
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                icon: EditIcons/* editPencil */.j7
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                    as: "h4",
                                    label: "Asset seo"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                                    fullWidth: true,
                                    wrap: true,
                                    label: "Asset Name",
                                    value: meta === null || meta === void 0 ? void 0 : meta.title,
                                    onChange: updateName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea["default"], {
                                    minRows: 1,
                                    wrap: true,
                                    fullWidth: true,
                                    label: "Alt description",
                                    value: meta === null || meta === void 0 ? void 0 : meta.alt,
                                    onChange: updateAlt
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                                    fullWidth: true,
                                    wrap: true,
                                    label: "Folder",
                                    value: meta === null || meta === void 0 ? void 0 : meta.folder,
                                    onChange: updateFold
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Button, {
                                    mt: 2,
                                    ml: 0,
                                    ghost: true,
                                    handler: function() {
                                        return actions.onImageUpdate(index);
                                    },
                                    size: "small",
                                    children: [
                                        SidebarIcons/* imageIcon */.yy,
                                        " \xa0 Replace asset"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            size: "small",
                            handler: function() {
                                return actions.handleRemove(index);
                            },
                            icon: EditIcons/* trash */._I
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            disabled: !(meta === null || meta === void 0 ? void 0 : meta.title) || !(meta === null || meta === void 0 ? void 0 : meta.alt),
                            handler: function() {
                                return actions.uploadOne(index);
                            },
                            size: "small",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                version: "1.1",
                                width: "15px",
                                height: "15px",
                                viewBox: "0 0 15 15",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M7.81825,1.18188c-0.17574,-0.17573 -0.46066,-0.17573 -0.6364,0l-3,3c-0.17574,0.17574 -0.17574,0.46066 0,0.6364c0.17574,0.17573 0.46066,0.17573 0.6364,0l2.2318,-2.2318v6.91348c0,0.24853 0.20147,0.45 0.45,0.45c0.24853,0 0.45,-0.20147 0.45,-0.45v-6.91348l2.23185,2.2318c0.1757,0.17573 0.4606,0.17573 0.6363,0c0.1758,-0.17574 0.1758,-0.46066 0,-0.6364l-2.99995,-3Zm-5.31825,8.81809c0.27614,0 0.5,0.22383 0.5,0.50003v1.5c0,0.5538 0.44565,1 0.99635,1h7.00485c0.5517,0 0.9988,-0.4472 0.9988,-1v-1.5c0,-0.2762 0.2239,-0.50003 0.5,-0.50003c0.2761,0 0.5,0.22383 0.5,0.50003v1.5c0,1.104 -0.8938,2 -1.9988,2h-7.00485c-1.10616,0 -1.99635,-0.897 -1.99635,-2v-1.5c0,-0.2762 0.22386,-0.50003 0.5,-0.50003Z",
                                    fill: "#000",
                                    fillRule: "evenodd"
                                })
                            })
                        })
                    ]
                })
            }),
            (source === null || source === void 0 ? void 0 : source.full) >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgsViewer, {
                imgs: [
                    {
                        src: source === null || source === void 0 ? void 0 : source.full
                    }
                ],
                spinner: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {});
                },
                isOpen: preview && (source === null || source === void 0 ? void 0 : source.full),
                onClose: togglePreview
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/mosanic/components/Media/Resolvers/GetListOfMedia.js
var GetListOfMedia = __webpack_require__(36520);
// EXTERNAL MODULE: ./src/mosanic/items/Progress/Progress.js + 1 modules
var Progress = __webpack_require__(85774);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/MediaUploader.js





















var MediaUploader = function(param) {
    var imageUrl = param.imageUrl, _type = param.type, type = _type === void 0 ? "image" : _type, _maxNumber = param.maxNumber, maxNumber = _maxNumber === void 0 ? 1 : _maxNumber, _autoUpload = param.autoUpload, autoUpload = _autoUpload === void 0 ? false : _autoUpload, _callback = param.callback, callback = _callback === void 0 ? null : _callback, _selector = param.selector, selector = _selector === void 0 ? false : _selector, _inlineSelect = param.inlineSelect, inlineSelect = _inlineSelect === void 0 ? false : _inlineSelect, _showEditor = param.showEditor, showEditor = _showEditor === void 0 ? false : _showEditor, _cover = param.cover, cover = _cover === void 0 ? true : _cover, _activeFolder = param.activeFolder, activeFolder = _activeFolder === void 0 ? "" : _activeFolder, _isRemote = param.isRemote, isRemote = _isRemote === void 0 ? true : _isRemote, _onChange = param.onChange, onChange = _onChange === void 0 ? null : _onChange, _shouldUploadAll = param.shouldUploadAll, shouldUploadAll = _shouldUploadAll === void 0 ? false : _shouldUploadAll, _toggleUploadAll = param.toggleUploadAll, toggleUploadAll = _toggleUploadAll === void 0 ? null : _toggleUploadAll;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useUploadFactory/* useUploadFactory */.V)({
        url: imageUrl,
        callback: callback
    }), 6), images = ref1[0], meta = ref1[1], progress = ref1[2], handlers = ref1[3], loading = ref1[4], error = ref1[5];
    var notify = (0,useNotify/* default */.Z)();
    var canUploadImage = Boolean((images === null || images === void 0 ? void 0 : images.length) < maxNumber || !images);
    //Store in local array
    var handleUpload = function(imageList, addUpdateIndex) {
        if (!addUpdateIndex) {
            notify("No update index found");
            return;
        }
        if (!imageList[0]) {
            notify("No file found");
            return;
        }
        autoUpload ? handlers.uploadFile(imageList[0], activeFolder) : handlers.setImages(imageList);
    };
    // const {uploadAll} = handlers;
    var cContext = (0,react.useContext)(CoreContext/* default */.Z);
    var ref2 = (0,react.useState)(false), mediaLib = ref2[0], setMediaLib = ref2[1];
    if (!showEditor) {
        if (loading) return loading;
        if (error) return error;
    }
    var url = isRemote ? (0,host/* getImageUrl */.Jn)((imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) ? imageUrl.url : imageUrl) : (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) ? imageUrl.url : imageUrl;
    var inlineCallback = function(e) {
        console.log(e);
        handlers.setImages([
            {
                url: e
            }
        ]);
        callback(e);
    };
    var Library = function() {
        return selector ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Button, {
            ghost: true,
            handler: function() {
                return inlineSelect ? setMediaLib(true) : cContext.setMediaModal(true);
            },
            style: {
                top: "5px",
                zIndex: 4,
                position: "absolute"
            },
            children: [
                (0,ElementIcons/* elementIcon */.$N)("archive"),
                " \xa0 Library"
            ]
        }) : null;
    };
    var source = (ref = (0,Image/* parseImageSrc */.yO)(imageUrl, true)) === null || ref === void 0 ? void 0 : ref.min;
    // if(loading) return <LoadingDots />
    return (showEditor || !images) && !source ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            inlineSelect && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                state: mediaLib,
                close: function() {
                    return setMediaLib(false);
                },
                size: "md",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GetListOfMedia/* GetListOfMedia */.h, {
                        header: true,
                        dialog: true,
                        initiate: inlineCallback,
                        direct: true,
                        upload: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                        onClick: function() {
                            return cContext.setMediaModal(false);
                        },
                        size: "small",
                        label: "Close"
                    })
                ]
            }),
            type === "video" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Library, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Video/* default */.ZP, {
                        onChange: function(e) {
                            return handlers.uploadFile(e.target.files[0], activeFolder);
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Library, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                        type: "button",
                        multiple: true,
                        value: images,
                        onChange: handleUpload,
                        maxNumber: maxNumber,
                        dataURLKey: "url",
                        children: function(actions) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Image_style.Container, {
                                type: type,
                                className: "input_field",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaController, {
                                        type: inlineSelect ? "input" : null,
                                        canUpload: canUploadImage,
                                        showEditor: showEditor,
                                        images: images,
                                        actions: actions
                                    }),
                                    (images === null || images === void 0 ? void 0 : images.length) >= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_style.UploadedList, {
                                        children: images === null || images === void 0 ? void 0 : images.map(function(image, index) {
                                            return image["url"] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaListImage, {
                                                type: type,
                                                remote: (0,Text/* containsSubstr */.xX)(image.url, "data:/image"),
                                                index: index,
                                                image: image,
                                                meta: meta && (meta === null || meta === void 0 ? void 0 : meta.length) - 1 >= index && meta[index],
                                                actions: (0,_object_spread/* default */.Z)({}, handlers, actions),
                                                showEditor: showEditor
                                            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Image_style.UploadedListItem, {
                                                children: [
                                                    "Image does not have a valid url. ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "Refresh page to reload."
                                                ]
                                            });
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                        children: "No images in upload queue."
                                    })
                                ]
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* Progress */.E, {
                value: progress * 100
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {})
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_style.DisplayImage, {
        type: type,
        children: source ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: type === "video" && (0,Text/* matchSubstrList */.OV)(source, [
                "mp4",
                "mov"
            ]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                src: source,
                alt: "Video",
                controls: true
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                layout: "fill",
                src: source,
                alt: "test",
                objectFit: cover ? "cover" : "contain"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
            label: "No url received."
        })
    });
};
/* harmony default export */ var Media_MediaUploader = (MediaUploader);


/***/ }),

/***/ 36520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ GetListOfMedia; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_cms_Pagination_Pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40010);
/* harmony import */ var _ListOfMedia__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65475);
/* harmony import */ var _mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88574);
/* harmony import */ var _mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59832);
/* harmony import */ var _mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18780);
/* harmony import */ var _mosanic_cms_DataGrid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62336);







var GetListOfMedia = function(param) {
    var _header = param.header, header = _header === void 0 ? true : _header, _dialog = param.dialog, dialog = _dialog === void 0 ? false : _dialog, _upload = param.upload, upload = _upload === void 0 ? true : _upload, _initiate = param.initiate, initiate = _initiate === void 0 ? null : _initiate, _type = param.type, type = _type === void 0 ? "image" : _type, _size = param.size, size = _size === void 0 ? null : _size;
    var mediaCountReceiver = (0,_mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_1__/* .useGetMediaCount */ .T)({});
    var ref = (0,_mosanic_cms_DataGrid__WEBPACK_IMPORTED_MODULE_2__/* .usePaginateDataGrid */ .af)({
        countResponse: mediaCountReceiver,
        useEntriesReceiver: _mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_3__/* .useGetMediaPage */ .o,
        entriesReceiverParams: {
            siteId: (0,_mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_4__/* .useSiteId */ .CG)()
        },
        filtering: false
    }), limiter = ref.limiter, pagination = ref.pagination, actions = ref.actions, state = ref.state, data = ref.data, status = ref.status, loading = ref.loading, error = ref.error, Selector = ref.Selector;
    // return 'test';
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_cms_Pagination_Pagination__WEBPACK_IMPORTED_MODULE_5__/* .PaginationLimit */ .S, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, limiter)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ListOfMedia__WEBPACK_IMPORTED_MODULE_7__/* .ListOfMedia */ .L, {
                media: data === null || data === void 0 ? void 0 : data.entries,
                initiate: initiate,
                header: header,
                dialog: dialog,
                upload: upload,
                type: type,
                size: size
            }),
            pagination && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_cms_Pagination_Pagination__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                type: "table"
            }, pagination))
        ]
    });
};


/***/ }),

/***/ 63730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "il": function() { return /* binding */ formatProduct; },
  "ND": function() { return /* binding */ parseAddons; },
  "Mu": function() { return /* binding */ parseMemberships; }
});

// UNUSED EXPORTS: parseProducts

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ./src/mosanic/content/addons.js

var addonsMap = [
    {
        title: "Custom Domain Slot",
        id: "prod_MOVaBXHbflxhis",
        category: "addon",
        currency: "EUR",
        price: 350,
        priceNotice: "per additional slot/month",
        value: "domain",
        limit: {
            starter: 0,
            basic: 0,
            advanced: 0,
            pro: 3,
            enterprise: 99
        },
        label: "Connect additional custom domains to your Mosanic account.",
        points: [
            "Pro Plan and above only", 
        ]
    },
    {
        title: "Page views",
        id: "prod_MOVeliWIc6kXTv",
        category: "addon",
        currency: "EUR",
        price: 600,
        priceNotice: "per 10K visitors/month",
        metric: {
            amount: 10,
            metric: "K",
            category: "visitors"
        },
        value: "views",
        limit: {
            starter: 0,
            basic: 1,
            advanced: 2,
            pro: 99,
            enterprise: 99
        },
        label: "Mosanic handles your hosting and delivers your sites pages fast. To ensure fair use we do this with a generous packages and offer extension.",
        points: [
            "Basic Plan and above", 
        ]
    },
    {
        title: "Bulk page views",
        id: "prod_MOVflYtUNFR30O",
        category: "addon",
        currency: "EUR",
        price: 1250,
        priceNotice: "per 25K visitors/month",
        metric: {
            amount: 25,
            metric: "K",
            category: "visitors"
        },
        value: "bulk-views",
        limit: {
            starter: 0,
            basic: 0,
            advanced: 1,
            pro: 99,
            enterprise: 99
        },
        label: "Discounted page views for users who really need them. ",
        points: [
            "Advanced Plan and above only", 
        ]
    },
    {
        title: "Basic CMS Entries",
        id: "prod_MOVfzHXK4yhNx1",
        currency: "EUR",
        category: "addon",
        price: 450,
        "price_data": {
            recurring: {
                interval: "month",
                "interval_count": 1
            },
            // "tax_code": "txcd_10102000",
            "tax_behavior": "exclusive"
        },
        priceNotice: "1 * 250 Entries/month",
        value: "basic-entries",
        metric: {
            amount: 250,
            metric: "",
            category: "entries"
        },
        limit: {
            starter: 0,
            basic: 1,
            advanced: 0,
            pro: 0,
            enterprise: 0
        },
        color: "green",
        label: "To get started with collections we offer a basic package.",
        points: [
            "Basic Plan only. Max 1 CMS Entry set.", 
        ]
    },
    {
        title: "Advanced CMS Entries",
        id: "prod_MOVgqswetw6Knm",
        category: "addon",
        currency: "EUR",
        price: 550,
        priceNotice: "per 500 Entries/month",
        value: "advanced-entries",
        metric: {
            amount: 500,
            metric: "",
            category: "entries"
        },
        limit: {
            starter: 0,
            basic: 0,
            advanced: 10,
            pro: 0,
            enterprise: 0
        },
        color: "orange",
        label: "Combined with the 1500 entries included in the advanced membership you won't be running out of them any time soon.",
        points: [
            "Advanced Plan only. Max 10 CMS Entry sets.", 
        ]
    },
    {
        title: "Pro CMS Entries",
        id: "prod_MOVh3np7DCeZLc",
        category: "addon",
        currency: "EUR",
        price: 750,
        priceNotice: "per 1K Entries/month",
        value: "pro-entries",
        metric: {
            amount: 1,
            metric: "K",
            category: "entries"
        },
        limit: {
            starter: 0,
            basic: 0,
            advanced: 0,
            pro: 25,
            enterprise: 99
        },
        color: "primary",
        label: "Expand and transform all of your data to collections. Starting from the 2500 included entries of the Pro membership.",
        points: [
            "Pro Plan only. Unlimited CMS Entry sets.", 
        ]
    },
    {
        title: "Storage",
        id: "prod_MOVhuTXgyHg3eu",
        category: "addon",
        currency: "EUR",
        price: 1000,
        priceNotice: "per 25GB/month",
        value: "storage",
        metric: {
            amount: 25,
            metric: "GB",
            category: "storage"
        },
        limit: {
            starter: 0
        },
        label: "All memberships have a generous amount of storage included in them. If this ain't enough you can upgrade without a limit.",
        points: [
            "All plans", 
        ]
    },
    {
        title: "Bandwidth",
        id: "prod_MOVi8ludoo4tUY",
        category: "addon",
        currency: "EUR",
        price: 2000,
        priceNotice: "per 50GB bandwidth/month",
        value: "bandwidth",
        metric: {
            amount: 25,
            metric: "GB",
            category: "bandwidth"
        },
        limit: {
            starter: 0
        },
        label: "Data is always delivered by super fast CDN providers and scales as your needs might exceed your membership starting data. ",
        points: [
            "All plans", 
        ]
    },
    {
        title: "Additional User",
        id: "SKU-MSN22-CRO-ADD015",
        currency: "EUR",
        category: "user",
        priceNotice: "per 1 extra user/month",
        value: "users",
        limit: {
            starter: 0,
            basic: 7,
            advanced: 7,
            pro: 7,
            enterprise: 99
        },
        label: "Add users to your membership, all access to your team's data with limits defined and manged from your team panel.",
        points: [
            "Price based on membership plan", 
        ]
    },
    {
        title: "Custom roles",
        id: "SKU-MSN22-CRO-ADD014",
        currency: "EUR",
        category: "addon",
        price: 750,
        priceNotice: "per 2 extra roles/month",
        value: "roles",
        limit: {
            starter: 0,
            basic: 7,
            advanced: 7,
            pro: 10,
            enterprise: 99
        },
        label: "Extend the possibilities of user roles by adding your own. You can even add restrictions inside our CMS, your Builder Canvas and Artboards, Settings and Variables.",
        cta: "Request addon",
        points: [
            "Pro and Enterprise Plan only", 
        ]
    },
    {
        title: "Localization",
        id: "SKU-MSN22-LOC-ADD015",
        category: "addon",
        currency: "EUR",
        priceNotice: "on request",
        value: "localization",
        limit: {
            starter: 0,
            basic: 0,
            advanced: 0,
            pro: 0,
            enterprise: 99
        },
        color: "gray",
        cta: "Request addon",
        label: "White label mosanic completely, you only have to deliver a custom domain, we take care of the hosting & setup.",
        points: [
            "Enterprise Plan only", 
        ]
    },
    {
        title: "Private connections (API)",
        id: "SKU-MSN22-API-ADD016",
        category: "addon",
        currency: "EUR",
        priceNotice: "on request",
        value: "white-label",
        limit: {
            starter: 0,
            basic: 0,
            advanced: 0,
            pro: 0,
            enterprise: 1
        },
        color: "gray",
        cta: "Request addon",
        label: "White label mosanic completely, you only have to deliver a custom domain, we take care of the hosting & setup.",
        points: [
            "Enterprise Plan only", 
        ]
    },
    {
        title: "White label Mosanic",
        id: "SKU-MSN22-WLB-ADD017",
        category: "addon",
        currency: "EUR",
        priceNotice: "on request",
        value: "white-label",
        limit: {
            starter: 0,
            basic: 0,
            advanced: 0,
            pro: 0,
            enterprise: 1
        },
        color: "gray",
        cta: "Request addon",
        label: "White label mosanic completely, you only have to deliver a custom domain, we take care of the hosting & setup.",
        points: [
            "Enterprise Plan only", 
        ]
    },
    {
        title: "Spaces",
        id: "SKU-MSN22-SPA-ADD018",
        category: "addon",
        currency: "EUR",
        priceNotice: "on request",
        value: "spaces",
        limit: {
            starter: 0,
            basic: 0,
            advanced: 0,
            pro: 0,
            enterprise: 99
        },
        color: "gray",
        cta: "Request addon",
        label: "White label mosanic completely, you only have to deliver a custom domain, we take care of the hosting & setup.",
        points: [
            "Enterprise Plan only", 
        ]
    }
];
var getAddon = function(key) {
    return isNumber(key) ? addonsMap[key - 1] : addonsMap.filter(function(addon) {
        return addon.value === key;
    })[0];
};

// EXTERNAL MODULE: ./src/mosanic/content/membership.js
var membership = __webpack_require__(18453);
// EXTERNAL MODULE: ./src/mosanic/utils/products.js
var products = __webpack_require__(25220);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
;// CONCATENATED MODULE: ./src/mosanic/components/Membership/CombineData.js






var addProductPrice = function(product, price) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
        priceId: price === null || price === void 0 ? void 0 : price.id,
        "price_data": {
            tax_behavior: price === null || price === void 0 ? void 0 : price.tax_behavior,
            recurring: {
                interval: price === null || price === void 0 ? void 0 : price.recurring.interval,
                interval_count: price === null || price === void 0 ? void 0 : price.recurring.interval_count
            }
        },
        price: price === null || price === void 0 ? void 0 : price.unit_amount,
        currency: (0,Text/* upperCase */.Lw)(price === null || price === void 0 ? void 0 : price.currency)
    });
};
var formatProduct = function(product) {
    var ref;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
        prices: product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref.map(function(p) {
            return {
                id: p.id,
                interval: p.recurring.interval,
                price: p.unit_amount
            };
        }),
        default_price: undefined,
        package_dimensions: undefined,
        tax_code: undefined
    });
};
var parseProduct = function(product, annual) {
    return formatProduct(addProductPrice(product, (0,products/* getPrice */.aS)(product.prices, annual)));
};
var parseProducts = function(products, annual, source) {
    return source.map(function(product) {
        return parseProduct((0,_object_spread/* default */.Z)({}, product, products.find(function(p) {
            return p.id === product.id;
        })), annual);
    });
};
var parseMemberships = function(products, annual) {
    return parseProducts(products, annual, membership/* subscriptionPlans */.BV);
};
var parseAddons = function(products, annual) {
    return parseProducts(products, annual, addonsMap);
};


/***/ }),

/***/ 82223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ redirectToPortal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _util_api_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62459);



var redirectToPortal = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(user) {
        var ref, url, _$error;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,_util_api_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fetchPostJSON */ .Gf)("/api/user/portal", {
                        user: user
                    });
                case 3:
                    ref = _ctx.sent;
                    url = ref.url;
                    _$error = ref.error;
                    window.open(url, "_ blank");
                    _ctx.next = 13;
                    break;
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    if (!_ctx.t0) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", console.log(_ctx.t0.message));
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function redirectToPortal(user) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 79721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Navigation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _api_host__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6539);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47914);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8152);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68311);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26021);
// import Coming from "@mosanic/Coming";

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  z-index:",
        ";\n  width: 100%;\n  position: ",
        ";\n  top: 0;\n  left:0;\n  right:0; \n  height: 40px;\n  background: #fff;\n\n  ul {\n    margin-left: 10px;\n    padding-left: 10px;\n    vertical-align: top;\n    display: inline-block;\n    a {\n      li {\n        font-size: 13px;\n        display: inline-block;\n        padding: 7px 10px;\n\n          color: #000 !important;\n      }\n    }\n  }\n  button {\n    display: inline-block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    display: inline-block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var Nav = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d8cbb90a-0"
})(_templateObject(), function(props) {
    return props.top ? 2 : 99;
}, function(props) {
    return props.top ? "absolute" : "fixed";
});
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d8cbb90a-1"
})(_templateObject1());
var Navigation = function(param) {
    var nav = param.nav, url = param.url, top = param.top, translated = param.translated;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var isEnglish = (router === null || router === void 0 ? void 0 : router.locale) === "en";
    return (nav === null || nav === void 0 ? void 0 : nav.length) >= 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Nav, {
        top: top,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                href: "/",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Logo, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        width: "100px",
                        height: "40px",
                        alt: "site logo",
                        src: (0,_api_host__WEBPACK_IMPORTED_MODULE_7__/* .getImageUrl */ .Jn)(url)
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                children: nav === null || nav === void 0 ? void 0 : nav.map(function(item) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                        href: "/".concat(item.slug),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                            children: (0,_util_Text__WEBPACK_IMPORTED_MODULE_8__/* .capitalizeFirst */ .Ez)(item === null || item === void 0 ? void 0 : item.header)
                        })
                    }, item === null || item === void 0 ? void 0 : item._id);
                })
            }),
            translated && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_9__.Button, {
                float: true,
                right: true,
                ghost: true,
                size: "large",
                onClick: function() {
                    return router.replace(router.asPath, null, {
                        locale: isEnglish ? "nl" : "en"
                    });
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16px",
                        height: "16px",
                        viewBox: "0 0 24 24",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                d: "M0 0h24v24H0z",
                                fill: "none"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                d: "M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
                            })
                        ]
                    }),
                    "\xa0 ",
                    isEnglish ? "Dutch" : "English"
                ]
            })
        ]
    }) : null;
};


/***/ }),

/***/ 64957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ usePageVersions; },
/* harmony export */   "q": function() { return /* binding */ usePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66383);
/* harmony import */ var _api_queries_pages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81913);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70210);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);




var usePage = function(param) {
    var _id = param._id;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_2__/* .useLazyQuery */ .td)("pageById", _api_queries_pages__WEBPACK_IMPORTED_MODULE_3__/* .PAGE */ .qX, {
        _id: _id
    }), 2), handler = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref[1], 3), page = ref1[0], loading = ref1[1], error = ref1[2];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (_id) handler({
            _id: _id
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        _id
    ]);
    return [
        handler,
        [
            page,
            loading,
            error
        ]
    ];
};
var usePageVersions = function(param) {
    var _id = param._id;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_2__/* .useLazyQuery */ .td)("pageById", _api_queries_pages__WEBPACK_IMPORTED_MODULE_3__/* .PAGE_VERSIONS */ .Cw, {
        _id: _id
    }), 2), handler = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref[1], 3), page = ref1[0], loading = ref1[1], error = ref1[2];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (_id) handler({
            _id: _id
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        _id
    ]);
    return [
        handler,
        [
            page,
            loading,
            error
        ]
    ];
};


/***/ }),

/***/ 67431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ usePages; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66383);
/* harmony import */ var _api_queries_pages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81913);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70210);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* eslint-disable no-nested-ternary */ 



var usePages = function(param) {
    var siteId = param.siteId, _getData = param.getData, getData = _getData === void 0 ? false : _getData, _admin = param.admin, admin = _admin === void 0 ? false : _admin, _countOnly = param.countOnly, countOnly = _countOnly === void 0 ? false : _countOnly, _pagesOnly = param.pagesOnly, pagesOnly = _pagesOnly === void 0 ? false : _pagesOnly;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_2__/* .useLazyQuery */ .td)("pageMany", _api_queries_pages__WEBPACK_IMPORTED_MODULE_3__/* .PAGES */ .q5, siteId === "admin" ? undefined : {
        siteId: siteId
    }), 2), getPages = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref[1], 3), pages = ref1[0], loading = ref1[1], error = ref1[2];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (siteId) getPages({
            filter: {
                siteId: siteId
            } ? {
                siteId: siteId
            } : !admin ? {
                siteId: "msncc0re"
            } : undefined
        });
    }, [
        siteId
    ]);
    if (pagesOnly) return pages;
    if (countOnly) return (pages === null || pages === void 0 ? void 0 : pages.length) ? pages === null || pages === void 0 ? void 0 : pages.length : 0;
    if (getData) return [
        getPages,
        [
            pages,
            loading,
            error
        ]
    ];
    if (loading) return loading;
    if (error) return error;
    return pages ? "list" : null;
};


/***/ }),

/***/ 8927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Pages; }
});

// UNUSED EXPORTS: IndexingCard, Navigation, PageMeta, RenderPage, UpdatePageDialog, useCreatePage, useIndexingSetup, usePage, usePageInit

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/core/Map/index.js
var Map = __webpack_require__(65902);
// EXTERNAL MODULE: ./src/mosanic/hooks/Breakpoint.js
var Breakpoint = __webpack_require__(56542);
// EXTERNAL MODULE: ./src/mosanic/items/Page/MetaHead.js
var MetaHead = __webpack_require__(3155);
;// CONCATENATED MODULE: ./src/mosanic/components/Pages/Resolvers/Page.js







var Page = function(param) {
    var page = param.page, _mode = param.mode, mode = _mode === void 0 ? "prod" : _mode, _locale = param.locale, locale = _locale === void 0 ? null : _locale, _seo = param.seo, seo = _seo === void 0 ? null : _seo, _blockSeo = param.blockSeo, blockSeo = _blockSeo === void 0 ? false : _blockSeo, _noWrap = param.noWrap, noWrap = _noWrap === void 0 ? false : _noWrap, _bp = param.bp, bp = _bp === void 0 ? "auto" : _bp;
    var breakpoint = (0,Breakpoint/* useBreakpoint */.G)({
        overwrite: bp
    });
    var pageProps = {
        data: page === null || page === void 0 ? void 0 : page.data,
        breakpoint: bp === "auto" ? breakpoint : bp,
        child: page === null || page === void 0 ? void 0 : page.map,
        level: 0
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !blockSeo && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaHead/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, seo), {
                locale: locale
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
                when: !noWrap,
                wrapper: function(children) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mosanic_site",
                        children: children
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Map/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                    mode: mode
                }))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/mosanic/components/Pages/index.js








/* harmony default export */ var Pages = (Page);


/***/ }),

/***/ 17248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ usePageInit; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _redux_map_data_action__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78364);
/* harmony import */ var _redux_map_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64234);
/* harmony import */ var _redux_screens_action__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21398);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);
/* harmony import */ var _redux_pages_action__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80936);








var usePageInit = function(param) {
    var _page = param.page, page = _page === void 0 ? null : _page;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var update = function(data) {
        var meta = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
            map: undefined,
            data: undefined,
            author: undefined,
            updates: undefined
        });
        dispatch((0,_redux_pages_action__WEBPACK_IMPORTED_MODULE_4__/* .setPageAction */ .m8)(meta));
        dispatch((0,_redux_screens_action__WEBPACK_IMPORTED_MODULE_5__/* .handlePageAdd */ .gd)({
            name: data === null || data === void 0 ? void 0 : data.title,
            _id: data === null || data === void 0 ? void 0 : data._id
        }));
        dispatch((0,_redux_screens_action__WEBPACK_IMPORTED_MODULE_5__/* .setCurrentPage */ .D4)({
            _id: data === null || data === void 0 ? void 0 : data._id
        }));
        dispatch((0,_redux_map_data_action__WEBPACK_IMPORTED_MODULE_6__/* .setDataAction */ .aL)({
            data: (data === null || data === void 0 ? void 0 : data.data) ? data.data : {}
        }));
        dispatch((0,_redux_map_action__WEBPACK_IMPORTED_MODULE_7__/* .selectMapAction */ .DB)({
            name: data === null || data === void 0 ? void 0 : data._id
        }));
        dispatch((0,_redux_map_action__WEBPACK_IMPORTED_MODULE_7__/* .updateMapAction */ .aZ)({
            map: (data === null || data === void 0 ? void 0 : data.map) ? data === null || data === void 0 ? void 0 : data.map : []
        }));
    };
    var initiate = function() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        update((page === null || page === void 0 ? void 0 : page.title) ? page : data);
        router.push("/builder");
    };
    return initiate;
};


/***/ }),

/***/ 18606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Td": function() { return /* binding */ Td; },
/* harmony export */   "Th": function() { return /* binding */ Th; },
/* harmony export */   "Tr": function() { return /* binding */ Tr; },
/* harmony export */   "i": function() { return /* binding */ Table; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26021);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        background: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    text-transform: capitalize;\n    text-align: center;\n    font-size: 12px;\n\n    ",
        "\n    overflow: hidden;\n    padding: 5px 2.5px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        background: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    padding: 5px 2.5px;\n    text-align: center;\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ",
        " {\n            width: ",
        "%;\n        }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ",
        ", ",
        " {\n            text-align: ",
        ";\n        }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ",
        ", ",
        " {\n            font-size: ",
        ";\n        }\n        ",
        " {\n            font-weight: 600;\n        }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    width: 100%;\n    ",
        "\n    ",
        "\n    ",
        "\n    tr:last-child {\n        padding-bottom: 15px;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var Th = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].th.withConfig */ .ZP.th.withConfig({
    componentId: "sc-efbcffa0-0"
})(_templateObject1(), function(props) {
    return props.bg && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject(), props.bg);
});
var Tr = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].tr.withConfig */ .ZP.tr.withConfig({
    componentId: "sc-efbcffa0-1"
})(_templateObject2());
var Td = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].td.withConfig */ .ZP.td.withConfig({
    componentId: "sc-efbcffa0-2"
})(_templateObject4(), function(props) {
    return props.bg && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3(), props.bg);
});
var Table = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    componentId: "sc-efbcffa0-3"
})(_templateObject8(), function(props) {
    return props.cells && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject5(), Th, 100 / props.cells);
}, function(props) {
    return props.align && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject6(), Th, Td, props.align);
}, function(props) {
    return props.fontSize && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject7(), Th, Td, props.fontSize, Th);
});
var table = {
    Th: Th,
    Tr: Tr,
    Table: Table,
    Td: Td
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (table)));



/***/ }),

/***/ 32131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useEditTeam; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66383);
/* harmony import */ var _api_mutations_teams__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17074);
/* harmony import */ var _api_token__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94645);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70210);
/* harmony import */ var _mosanic_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33346);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25157);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64157);









var useEditTeam = function(param) {
    var _callback = param.callback, callback = _callback === void 0 ? null : _callback;
    var userId = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_1__/* .userIdSelector */ .dY);
    var isAuth = (0,_api_token__WEBPACK_IMPORTED_MODULE_2__/* .isAuthenticated */ .$8)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_4__/* .useMutate */ .Tu)("teamUpdateById", _api_mutations_teams__WEBPACK_IMPORTED_MODULE_5__/* .UPDATE_TEAM */ .x), 2), updateTeam = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var handler = function(param) {
        var team = param.team;
        var ref, ref1;
        var _id = team === null || team === void 0 ? void 0 : team._id;
        if (!_id) {
            notify("No team id received.");
            return;
        }
        if (!isAuth) {
            notify("You are not authenticated.");
            return;
        }
        if (!(team === null || team === void 0 ? void 0 : team.unsubscribe) && (team === null || team === void 0 ? void 0 : team.superAdmin) != userId && ((ref1 = team === null || team === void 0 ? void 0 : (ref = team.users) === null || ref === void 0 ? void 0 : ref.find(function(u) {
            return (u === null || u === void 0 ? void 0 : u._id) === userId;
        })) === null || ref1 === void 0 ? void 0 : ref1.role) != "admin") {
            notify("Only admins can update a team.");
            return;
        }
        var record = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, team), {
            unsubscribe: undefined,
            _id: undefined
        });
        updateTeam({
            _id: _id,
            record: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, record)
        }).then(function(res) {
            var data = res.data, error = res.error;
            if (data === null || data === void 0 ? void 0 : data.teamUpdateById) data = data.teamUpdateById;
            if (!error && data) {
                notify("Successfully updated team.", "app", "success");
                if (callback) callback();
            } else if (error) {
                notify("An error occurred during the team update.");
            }
        });
    };
    return [
        handler,
        [
            data,
            loading,
            error
        ]
    ];
};


/***/ }),

/***/ 36563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cT": function() { return /* binding */ list_roles; },
/* harmony export */   "cY": function() { return /* binding */ getRole; },
/* harmony export */   "ge": function() { return /* binding */ platform_roles; },
/* harmony export */   "uJ": function() { return /* binding */ roles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50930);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2921);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68311);






var roles = "admin|designer|builder|editor|viewer|all".split("|");
var platform_roles = {
    member_active: "active",
    member_pr: "pending registration",
    member_r: "registered",
    member_d: "disabled",
    member_o: "overdue",
    administrator: "admin [wp]"
};
var list_roles = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(roles.map(function(value) {
    return {
        label: (0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .capitalizeFirst */ .Ez)(value),
        value: value
    };
})).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Object.entries(platform_roles).map(function(param) {
    var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), value = _param[0], label = _param[1];
    return {
        label: (0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .capitalizeFirst */ .Ez)(label),
        value: value
    };
})), [
    {
        value: "all",
        label: "Undefined"
    }
]);
var status_colors = {
    member_active: _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.green.base */ .ZP.util.green.base,
    member_pr: _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.green.light */ .ZP.util.green.light,
    member_r: _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.light */ .ZP.util.gray.light,
    member_d: _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.red.dark */ .ZP.util.red.dark,
    member_o: _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.red.base */ .ZP.util.red.base
};
var getRole = function(role) {
    role = list_roles === null || list_roles === void 0 ? void 0 : list_roles.find(function(r) {
        return r.value === role;
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, role), {
        color: (status_colors === null || status_colors === void 0 ? void 0 : status_colors[role === null || role === void 0 ? void 0 : role.value]) ? status_colors[role.value] : _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.primary.base */ .ZP.util.primary.base
    });
};


/***/ }),

/***/ 86466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useDeleteUser; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66383);
/* harmony import */ var _api_mutations_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37029);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70210);
/* harmony import */ var _mosanic_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49896);
/* harmony import */ var _mosanic_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33346);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mosanic_components_Mail__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16956);
/* harmony import */ var _api_token__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94645);









var useDeleteUser = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var logout = (0,_mosanic_auth__WEBPACK_IMPORTED_MODULE_2__/* .useLogout */ .a)(false);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_4__/* .useMutate */ .Tu)("deleteMyUserAccount", _api_mutations_auth__WEBPACK_IMPORTED_MODULE_5__/* .DELETE_ACCOUNT */ .IR), 2), dispatchDelete = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], errorDelete = ref1[2];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_mosanic_components_Mail__WEBPACK_IMPORTED_MODULE_6__/* .useSendOne */ .x)(), 1), sendMail = ref2[0];
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var isAuth = (0,_api_token__WEBPACK_IMPORTED_MODULE_8__/* .isAuthenticated */ .$8)();
    var handler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(param) {
        var _id = param._id, user = param.user;
        var email = user.email, firstName = user.firstName, lastName = user.lastName;
        if (!_id) {
            notify("No user _id received.");
            return;
        }
        if (!email || !firstName) {
            notify("No user data found.");
            return;
        }
        if (!isAuth) {
            notify("Current user not authenticated.");
            // router.push('/login');
            return;
        }
        dispatchDelete().then(function(res) {
            var data = res.data, error = res.error;
            if (!error && !errorDelete) {
                sendMail({
                    subject: "".concat(firstName, ", we're sad to see you leave."),
                    to: email,
                    preHeader: "You're account on Mosanic will be terminated within 31 days...",
                    subHeader: "\uD83D\uDE22 Oh no..",
                    mainHeader: "".concat(firstName, " ").concat(lastName, ", we're sad to see you leave."),
                    mainText: "We value your opinion very much and would massively appreciate it if you would like to tell us why. \n So we can keep improving and maybe get you back in the future. \n If you wouldn't mind, send us a short reply on this email. \n \n Kind Regards, \n The Mosanic Team"
                });
                notify("Successfully deleted account.", "app", "success");
                console.log(data);
                setTimeout(function() {
                    logout();
                    router.push({
                        pathname: "/ticket",
                        query: {
                            type: "terminate-account"
                        }
                    });
                }, 1000);
            }
            if (error) {
                console.log(error);
                notify("Could not delete account.");
            }
        });
    }, [
        dispatchDelete,
        notify,
        errorDelete,
        sendMail,
        logout,
        router
    ]);
    return [
        handler,
        data,
        loading,
        errorDelete, 
    ];
};


/***/ }),

/***/ 29134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ usePasswordValidation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _util_Boolean__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13365);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68311);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51085);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2921);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77298);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26021);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        text-align: center;\n        position: relative;\n        margin: 0;\n        right: 0;\n        width: 100%;\n\n        ul li {\n            text-align: center;\n            justify-content: center;\n            margin: 0;\n\n            div {\n                margin: 0;\n            }\n        }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    background: #ffffff;\n    position: absolute;\n    right: -250px;\n    margin-top: -50px;\n    width: 250px;\n    padding: 10px;\n    ",
        "\n    ul {\n        list-style: none;\n        padding: 0;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        color: #999;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    padding: 5px;\n    font-size: 14px;\n    display: flex;\n    ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    background: ",
        ";\n    border-radius: 4px;\n    color: #fff;\n    padding: 2px 4px;\n    margin-left: 4px;\n\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    max-height: 20px;\n    max-width: 20px;    \n    min-height: 20px;\n    min-width: 20px; \n    display: inline-block;\n    margin-right: 10px;\n    padding: 0 2.5px;\n    overflow: hidden;\n    border-radius: 15px;\n    background: ",
        ";\n    svg {\n        margin-top: -4px;\n        path {\n            fill: #fff;\n        }\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var CheckList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f3653bdd-0"
})(_templateObject1(), function(props) {
    return props.center && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject());
});
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-f3653bdd-1"
})(_templateObject3(), function(props) {
    return props.valid && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2());
});
var Label = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-f3653bdd-2"
})(_templateObject4(), function(props) {
    var ref;
    return (ref = _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].util.bright */ .ZP.util.bright) === null || ref === void 0 ? void 0 : ref[props.color];
});
var Status = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f3653bdd-3"
})(_templateObject5(), function(props) {
    return props.valid ? _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].util.bright.green */ .ZP.util.bright.green : _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].util.bright.red */ .ZP.util.bright.red;
});
var list = function(txt) {
    return {
        match: "Passwords match",
        length: "At least 8 characters (".concat(txt === null || txt === void 0 ? void 0 : txt.length, ")"),
        lower: "Lower case letters (a-z)",
        higher: "Upper case letters (A-Z)",
        number: "Contains a number (0-9)",
        special: "A special character (!@#$%&*)"
    };
};
var usePasswordValidation = function(param) {
    var _password = param.password, password = _password === void 0 ? "" : _password, _repeat_password = param.repeat_password, repeat_password = _repeat_password === void 0 ? "" : _repeat_password, _firstOnly = param.firstOnly, firstOnly = _firstOnly === void 0 ? false : _firstOnly;
    var ref, ref1, ref2;
    var numbers = (ref = (0,_util_Text__WEBPACK_IMPORTED_MODULE_5__/* .getNumberPartOfString */ .kr)(password)) === null || ref === void 0 ? void 0 : ref.length;
    var specials = (password === null || password === void 0 ? void 0 : password.length) - ((ref1 = password === null || password === void 0 ? void 0 : password.replace(/[^a-zA-Z\']/g, "")) === null || ref1 === void 0 ? void 0 : ref1.length);
    var validations = {
        match: password != repeat_password ? "Passwords do not match." : true,
        length: (password === null || password === void 0 ? void 0 : password.length) < 8 ? "Password must be longer than 8 characters." : true,
        lower: !new RegExp("[a-z]").test(password) ? "Password should contain one lower case letter" : true,
        higher: !new RegExp("[A-Z]").test(password) ? "Password should contain one upper case letter" : true,
        number: !numbers || (numbers === null || numbers === void 0 ? void 0 : numbers.length) < 1 ? "Password should contain a number." : true,
        special: !new RegExp("[!@#$%--&*]").test(password) ? "Password should contain a special character." : true
    };
    var errorMessage = !repeat_password && !password ? null : (ref2 = Object.values(validations)) === null || ref2 === void 0 ? void 0 : ref2.find(function(val) {
        return !(0,_util_Boolean__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(val) && val;
    });
    var color = {
        "Not good enough": "red",
        "Good +": "green",
        "Strong": "green",
        "Good": "green",
        "Medium": "orange"
    };
    var strength = function() {
        if (errorMessage) return "Not good enough";
        if ((password === null || password === void 0 ? void 0 : password.length) >= 14) {
            if (numbers >= 3 || specials >= 3) return "Good +";
            return numbers >= 2 || specials >= 2 ? "Strong" : "Good";
        }
        if (numbers >= 4 && specials >= 4) return "Insane";
        if (numbers >= 3 || specials >= 3) return "Strong";
        if (numbers >= 2 || specials >= 2) return "Good";
        return "Medium";
    };
    var filteredValidations = Object.entries(validations).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), _ = _param[0], val = _param[1];
        return !firstOnly || !(0,_util_Boolean__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(val);
    }).filter(function(e, index) {
        return !firstOnly || index === 0;
    });
    var Validations = function(param) {
        var center = param.center;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CheckList, {
            center: center,
            children: [
                !firstOnly && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                    children: "Password Validation:"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                    children: [
                        filteredValidations.map(function(param) {
                            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListItem, {
                                valid: (0,_util_Boolean__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(value),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Status, {
                                        valid: (0,_util_Boolean__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(value),
                                        children: (0,_util_Boolean__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(value) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .CheckIcon */ .nQG, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .Cross2Icon */ .Pxu, {})
                                    }),
                                    list(password)[key]
                                ]
                            }, key);
                        }),
                        ((filteredValidations === null || filteredValidations === void 0 ? void 0 : filteredValidations.length) === 0 || !firstOnly) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_8__/* .AdvancedLabel */ .qv, {
                            children: [
                                "Strength:",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                                    color: color[strength()],
                                    children: strength()
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return [
        errorMessage,
        Validations,
        strength(), 
    ];
};


/***/ }),

/***/ 93548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useUpdateUser; },
/* harmony export */   "U": function() { return /* binding */ useUpdatePassword; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66383);
/* harmony import */ var _api_mutations_users__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38374);
/* harmony import */ var _api_token__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94645);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70210);
/* harmony import */ var _mosanic_cms_Query_byId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62357);
/* harmony import */ var _mosanic_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33346);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25157);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);











var useUpdateUser = function() {
    var userId = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_2__/* .userIdSelector */ .dY);
    var isAuth = (0,_api_token__WEBPACK_IMPORTED_MODULE_3__/* .isAuthenticated */ .$8)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_mosanic_cms_Query_byId__WEBPACK_IMPORTED_MODULE_5__/* .useGetUser */ .pg)({
        _id: userId
    }), 1), user = ref[0];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_6__/* .useMutate */ .Tu)("userUpdateById", _api_mutations_users__WEBPACK_IMPORTED_MODULE_7__/* .UPDATE_USER */ .AX), 2), update = ref1[0], ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ref1[1], 3), data = ref2[0], loading = ref2[1], errorUpdate = ref2[2];
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var handler = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var _id = param._id, user = param.user;
        var diffUser = userId != _id;
        if (!_id) {
            notify("No user _id received.");
            return;
        }
        if (!isAuth) {
            notify("Current user not authenticated.");
            return;
        }
        if (diffUser && !(user === null || user === void 0 ? void 0 : user.isAdmin)) {
            notify("You can not update another user.");
            return;
        }
        var record = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, user), {
            firstName: undefined,
            lastName: undefined,
            _id: undefined
        });
        update({
            _id: _id,
            record: record
        }, diffUser).then(function(res) {
            var error = res.error, data = res.data;
            if (data === null || data === void 0 ? void 0 : data.userUpdateById) data = data.userUpdateById;
            var recordId = (data || {
                recordId: null
            }).recordId;
            if (!error && !errorUpdate && recordId) {
                notify("Successfully updated user.", "app", "success");
            }
            if (error) {
                console.log(error);
                notify("Could not update user.");
            }
        });
    }, [
        userId,
        user === null || user === void 0 ? void 0 : user.isAdmin,
        isAuth,
        update,
        notify,
        errorUpdate
    ]);
    return [
        handler,
        data,
        loading,
        errorUpdate, 
    ];
};
var useUpdatePassword = function() {
    var isAuth = (0,_api_token__WEBPACK_IMPORTED_MODULE_3__/* .isAuthenticated */ .$8)();
    var userId = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_2__/* .userIdSelector */ .dY);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_mosanic_cms_Query_byId__WEBPACK_IMPORTED_MODULE_5__/* .useGetUser */ .pg)({
        _id: userId
    }), 1), user = ref[0];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_6__/* .useMutate */ .Tu)("editUserPassword", _api_mutations_users__WEBPACK_IMPORTED_MODULE_7__/* .EDIT_PASSWORD */ .A1), 2), update = ref1[0], ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ref1[1], 3), data = ref2[0], loading = ref2[1], errorUpdate = ref2[2];
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var handler = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var _id = param._id, password = param.password, oldPassword = param.oldPassword;
        var diffUser = userId != _id;
        if (!_id) {
            notify("No user _id received.");
            return;
        }
        if (!isAuth) {
            notify("Current user not authenticated.");
            return;
        }
        if (diffUser && !(user === null || user === void 0 ? void 0 : user.isAdmin)) {
            notify("You can not update another user.");
            return;
        }
        if (!password || !oldPassword) {
            notify("Did not receive credentials.");
            return;
        }
        var variables = {
            _id: _id,
            password: password,
            oldPassword: oldPassword
        };
        update(variables).then(function(res) {
            var error = res.error, data = res.data;
            if (!error && !errorUpdate && data) {
                notify("Successfully updated password.", "app", "success");
            }
            if (error) {
                console.log(error);
                notify("Could not update password.");
            }
        });
    }, [
        userId,
        user === null || user === void 0 ? void 0 : user.isAdmin,
        isAuth,
        update,
        notify,
        errorUpdate
    ]);
    return [
        handler,
        data,
        loading,
        errorUpdate, 
    ];
};


/***/ }),

/***/ 29875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ UserProfile; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/adapters/queries/sites.js
var sites = __webpack_require__(71204);
// EXTERNAL MODULE: ./src/adapters/queries/teams.js
var teams = __webpack_require__(17302);
// EXTERNAL MODULE: ./src/adapters/schemas/collections.js
var schemas_collections = __webpack_require__(18692);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/useDataQuery.js
var useDataQuery = __webpack_require__(49974);
// EXTERNAL MODULE: ./src/mosanic/cms/DataTable/DataTable.js + 1 modules
var DataTable = __webpack_require__(91189);
// EXTERNAL MODULE: ./src/mosanic/cms/DataGrid/retrievers.js
var retrievers = __webpack_require__(97949);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ./src/mosanic/components/Table/index.js
var Table = __webpack_require__(18606);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/HelpPopper.tsx
var HelpPopper = __webpack_require__(77586);
;// CONCATENATED MODULE: ./src/mosanic/components/Credits/CreditStatus.js










var colorIndex = {
    gained: (0,polished_esm/* lighten */.$n)(0.3, colors/* default.util.green.base */.ZP.util.green.base),
    gained_pending: (0,polished_esm/* lighten */.$n)(0.4, colors/* default.util.green.base */.ZP.util.green.base),
    spend: (0,polished_esm/* lighten */.$n)(0.3, colors/* default.util.red.light */.ZP.util.red.light),
    spend_pending: (0,polished_esm/* lighten */.$n)(0.1, colors/* default.util.red.trans */.ZP.util.red.trans),
    credits: colors/* default.util.gray.lighter */.ZP.util.gray.lighter
};
var getStatusProps = function(field) {
    return {
        bg: colorIndex === null || colorIndex === void 0 ? void 0 : colorIndex[field]
    };
};
var CreditStatus = function(param) {
    var data = param.data, properties = param.properties;
    if (!(0,Obj/* hasAttr */.B$)(data, "gained")) return null;
    var fields = properties ? properties : "start|gained|gained_pending|spend|spend_pending|credits".split("|").filter(function(field) {
        return (0,Obj/* hasAttr */.B$)(data, field);
    });
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
            children: [
                "Credits \xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpPopper/* HelpPopper */.q, {
                    helpText: "Note that the spend pending credits are subtracted from your current credit count."
                })
            ]
        }, "heading"),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* Table */.i, {
            cells: fields === null || fields === void 0 ? void 0 : fields.length,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table.Tr, {
                children: fields === null || fields === void 0 ? void 0 : fields.map(function(field) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Table.Td, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getStatusProps(field)), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                            label: (0,Text/* capitalizeFirst */.Ez)((0,Text/* revertSnakeCase */.UY)(field)),
                            value: data === null || data === void 0 ? void 0 : data[field]
                        })
                    }));
                })
            })
        }, "data")
    ];
};

// EXTERNAL MODULE: ./src/mosanic/components/User/useUser.js
var useUser = __webpack_require__(12107);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/utils/Date.js
var utils_Date = __webpack_require__(99787);
// EXTERNAL MODULE: ./src/mosanic/components/Team/roles.js
var roles = __webpack_require__(36563);
;// CONCATENATED MODULE: ./src/mosanic/components/User/Status.js













var Status = function(_param) {
    var user = _param.user, other = (0,_object_without_properties/* default */.Z)(_param, [
        "user"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var data = {
        registration: (0,utils_Date/* getDate */._3)(user === null || user === void 0 ? void 0 : user.registrationDate),
        status: (0,Obj/* hasAttr */.B$)(roles/* platform_roles */.ge, user === null || user === void 0 ? void 0 : user.role) ? roles/* platform_roles */.ge[user.role] : user === null || user === void 0 ? void 0 : user.role,
        active: Boolean((user === null || user === void 0 ? void 0 : user.isActive) && !((ref1 = (ref = "member_o|member_d") === null || ref === void 0 ? void 0 : ref.split("|")) === null || ref1 === void 0 ? void 0 : ref1.includes(user === null || user === void 0 ? void 0 : user.role))) ? "yes" : "no",
        membership_started: (0,utils_Date/* getDate */._3)(user === null || user === void 0 ? void 0 : (ref2 = user.subscription) === null || ref2 === void 0 ? void 0 : ref2.started),
        membership_ending: (0,utils_Date/* getDate */._3)(user === null || user === void 0 ? void 0 : (ref3 = user.subscription) === null || ref3 === void 0 ? void 0 : ref3.ending)
    };
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
            children: [
                "Status \xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpPopper/* HelpPopper */.q, {
                    helpText: "If you have any question regarding the status of your account, feel free to contact the admins."
                })
            ]
        }, "heading"),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
        /*#__PURE__*/ (0,react.createElement)(Table/* Table */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            entries: (ref5 = (ref4 = Object === null || Object === void 0 ? void 0 : Object.values(data)) === null || ref4 === void 0 ? void 0 : ref4.filter(function(d) {
                return d;
            })) === null || ref5 === void 0 ? void 0 : ref5.length
        }, other), {
            key: "data"
        }), /*#__PURE__*/ (0,jsx_runtime.jsx)(Table.Tr, {
            children: (ref6 = Object.entries(data)) === null || ref6 === void 0 ? void 0 : ref6.map(function(param) {
                var _$_param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _$_param[0], value = _$_param[1];
                return value ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Table.Td, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                        label: (0,Text/* capitalizeFirst */.Ez)((0,Text/* revertSnakeCase */.UY)(key)),
                        value: value
                    })
                }) : null;
            })
        }))
    ];
};

// EXTERNAL MODULE: ./src/mosanic/components/Users/Users.styles.js
var Users_styles = __webpack_require__(21924);
// EXTERNAL MODULE: ./src/mosanic/items/Link/index.js
var Link = __webpack_require__(8152);
// EXTERNAL MODULE: ./src/mosanic/items/Block.js
var Block = __webpack_require__(57389);
// EXTERNAL MODULE: ./src/mosanic/items/Skeletons/Skeletons.js + 1 modules
var Skeletons = __webpack_require__(86443);
// EXTERNAL MODULE: ./src/mosanic/utils/Image.js
var Image = __webpack_require__(73987);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/adapters/schemas/helpers.js
var helpers = __webpack_require__(80309);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/auth/useAuth.js
var useAuth = __webpack_require__(49896);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/utils/Site.js
var Site = __webpack_require__(95048);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
;// CONCATENATED MODULE: ./src/mosanic/components/User/Profile.js































var UserProfile = function(param) {
    var _id = param._id, _overwrite = param.overwrite, overwrite = _overwrite === void 0 ? {
        collections: ""
    } : _overwrite, _groupStyle = param.groupStyle, groupStyle = _groupStyle === void 0 ? null : _groupStyle;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var _loggedInId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref9 = (0,react.useState)(_id), userId = ref9[0], setUserId = ref9[1];
    var collections = (Array === null || Array === void 0 ? void 0 : Array.isArray(overwrite === null || overwrite === void 0 ? void 0 : overwrite.collections)) ? overwrite === null || overwrite === void 0 ? void 0 : overwrite.collections : overwrite === null || overwrite === void 0 ? void 0 : (ref = overwrite.collections) === null || ref === void 0 ? void 0 : ref.split("\n");
    (0,react.useEffect)(function() {
        if (!_id && _loggedInId) setUserId(_loggedInId);
        if (_id) setUserId(_id);
    }, [
        _id,
        _loggedInId
    ]);
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useUser/* useUser */.a)({
        _id: userId
    }), 2), user = ref10[0], loading = ref10[1];
    var img = (ref2 = (0,Image/* parseImageSrc */.yO)(user === null || user === void 0 ? void 0 : (ref1 = user.author) === null || ref1 === void 0 ? void 0 : ref1.profilePicture, true)) === null || ref2 === void 0 ? void 0 : ref2.full;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useDataQuery/* useGet */.XD)({
        params: (user === null || user === void 0 ? void 0 : user.siteId) ? {
            _id: user === null || user === void 0 ? void 0 : user.siteId
        } : undefined,
        type: "site",
        query: sites/* SITE_TEAM */.nX,
        silent: true,
        siteCheck: false
    }), 2), getSite = ref11[0], ref12 = (0,_sliced_to_array/* default */.Z)(ref11[1], 2), site = ref12[0], loadingSite = ref12[1];
    var customDomain = (0,Site/* getSiteUrl */.$2)(site);
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useDataQuery/* useGet */.XD)({
        params: (site === null || site === void 0 ? void 0 : site.team) ? {
            _id: site === null || site === void 0 ? void 0 : site.team
        } : undefined,
        type: "team",
        query: teams/* TEAM */.FV,
        silent: true,
        siteCheck: false
    }), 2), getTeam = ref13[0], ref14 = (0,_sliced_to_array/* default */.Z)(ref13[1], 2), team = ref14[0], loadingTeam = ref14[1];
    var isSuperiorRole = Boolean((team === null || team === void 0 ? void 0 : team.superAdmin) === _loggedInId || ((ref4 = team === null || team === void 0 ? void 0 : (ref3 = team.users) === null || ref3 === void 0 ? void 0 : ref3.filter(function(user) {
        return (user === null || user === void 0 ? void 0 : user.userId) === _loggedInId;
    })) === null || ref4 === void 0 ? void 0 : ref4.length) >= 1);
    var isOwnProfile = Boolean(_id === _loggedInId || !_id && _loggedInId);
    var loadingExtra = loadingTeam || loadingSite;
    var checkPref = function(attr) {
        var ref, ref1, ref2;
        return !(0,Obj/* hasAttr */.B$)(user === null || user === void 0 ? void 0 : (ref = user.pref) === null || ref === void 0 ? void 0 : ref.privacy, attr) || (user === null || user === void 0 ? void 0 : (ref1 = user.pref) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.privacy) === null || ref2 === void 0 ? void 0 : ref2[attr]);
    };
    var role = (0,roles/* getRole */.cY)(user === null || user === void 0 ? void 0 : user.role);
    var logout = (0,useAuth/* useLogout */.a)();
    return checkPref("public") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Users_styles/* default.Avatar */.Z.Avatar, {
                        src: img,
                        width: "25px",
                        height: "25px"
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeletons/* SkeletonLine */.AU, {}) : (user === null || user === void 0 ? void 0 : user.firstName) ? "".concat(user === null || user === void 0 ? void 0 : user.firstName, " ").concat((0,Text/* isString */.HD)(user === null || user === void 0 ? void 0 : user.lastName) ? user.lastName : "") : "No user found",
                    isOwnProfile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                        float: true,
                        theme: "primary",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* PersonIcon */.Tk0, {}),
                        label: "logout",
                        size: "large",
                        right: true,
                        style: {
                            marginTop: -35,
                            fontWeight: "bold"
                        },
                        onClick: function() {
                            return logout();
                        }
                    }),
                    isSuperiorRole && /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* Tag */.Vp, {
                        mb: 1,
                        children: "Viewing user as a superior role"
                    }),
                    role && (isSuperiorRole || isOwnProfile) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* Tag */.Vp, {
                        bg: role.color,
                        children: [
                            role === null || role === void 0 ? void 0 : role.label,
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    margin: "25px 0"
                },
                children: (user === null || user === void 0 ? void 0 : (ref5 = user.author) === null || ref5 === void 0 ? void 0 : ref5.biography) ? user === null || user === void 0 ? void 0 : (ref6 = user.author) === null || ref6 === void 0 ? void 0 : ref6.biography : user === null || user === void 0 ? void 0 : (ref7 = user.author) === null || ref7 === void 0 ? void 0 : ref7.bio
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InlineGroup */.a_, {
                style: (0,_object_spread/* default */.Z)({
                    justifyContent: "space-between"
                }, groupStyle),
                children: [
                    checkPref("email") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            margin: "15px 0"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "mailto:".concat(user.email),
                                children: user === null || user === void 0 ? void 0 : user.email
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            checkPref("messages") && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "You can soon send direct messages."
                            })
                        ]
                    }),
                    checkPref("length") && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                        label: "Joined on:",
                        style: {
                            fontSize: "12px",
                            marginTop: 15
                        },
                        value: (0,utils_Date/* getDate */._3)(user === null || user === void 0 ? void 0 : user.registrationDate)
                    }),
                    checkPref("lastLogin") && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                        label: "Last login:",
                        style: {
                            fontSize: "12px",
                            marginTop: 15
                        },
                        value: (0,utils_Date/* getDate */._3)(user === null || user === void 0 ? void 0 : user.lastLogin)
                    })
                ]
            }),
            loadingExtra ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeletons/* SkeletonCard */.As, {
                height: "400px"
            }) : isSuperiorRole || isOwnProfile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: groupStyle,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Status, {
                                user: user,
                                style: {
                                    marginBottom: "20px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Button, {
                                ghost: true,
                                style: {
                                    width: "100%"
                                },
                                size: "large",
                                href: "https://www.swopyourstay.com/membership",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowRightIcon */.LZ3, {}),
                                    " Renew membership"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: groupStyle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditStatus, {
                            data: user === null || user === void 0 ? void 0 : (ref8 = user.subscription) === null || ref8 === void 0 ? void 0 : ref8.data
                        }, "credit")
                    })
                ]
            }) : null,
            (isSuperiorRole || isOwnProfile) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadCollections, {
                customDomain: customDomain,
                groupStyle: groupStyle,
                collections: collections,
                userId: _id || _loggedInId
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
            children: "This user has their profile set to private."
        })
    });
};
var LoadCollections = function(param) {
    var collections = param.collections, userId = param.userId, _groupStyle = param.groupStyle, groupStyle = _groupStyle === void 0 ? null : _groupStyle, customDomain = param.customDomain;
    // console.log(useCollectionDataGrid({_id: collections[0]}))
    // const [data, loading, error] = useGetCollection({_id: collections[0], siteCheck: false})
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            collections === null || collections === void 0 ? void 0 : collections.map(function(collectionId) {
                return collectionId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, groupStyle), {
                        paddingTop: 5
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DataTable/* DataTable */.w, {
                        config: {
                            defaultType: "collection",
                            viewOnly: true,
                            disabled: true,
                            frontEnd: true
                        },
                        schema: (0,helpers/* removeSchemaInfo */.xl)(schemas_collections/* collectionSchema */.jm),
                        controls: {
                            filters: true,
                            limiter: true,
                            search: true
                        },
                        // domain={customDomain ? `https://${customDomain}` : null}
                        // todo --> remove and fix this
                        domain: "https://www.swopyourstay.com",
                        useDataGrid: retrievers/* useCollectionUserDataGrid */.pk,
                        hookProps: {
                            _id: collectionId,
                            userId: userId
                        },
                        p: 0,
                        pt: [
                            4,
                            8,
                            25
                        ]
                    })
                }, collectionId) : null;
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: groupStyle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: "Hi Swopper!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Do you still miss certain bookings or can't you see your accommodation?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "U can give the SwopYourStay admins a notice on:",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "mailto:info@swopyourstay.com",
                                children: "info@swopyourstay.com"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Is your wallet incorrect or the booking form not available? ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Contact the developers directly: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                href: "mailto:info@mosanic.io",
                                children: "info@mosanic.io"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 12107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useUser; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66383);
/* harmony import */ var _api_queries_users__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62641);
/* harmony import */ var _mosanic_cms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49974);






var useUser = function(param) {
    var _id = param._id;
    // const [user, loading, error] = useVarQuery('userById', USER, {_id}, Boolean(_id))
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_mosanic_cms__WEBPACK_IMPORTED_MODULE_1__/* .useGet */ .XD)({
        params: {
            _id: _id
        },
        type: "user",
        query: _api_queries_users__WEBPACK_IMPORTED_MODULE_2__/* .USER */ .xR,
        silent: true,
        siteCheck: false
    }), 2), getUser = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ref[1], 3), user = ref1[0], loading = ref1[1], error = ref1[2];
    var ref2 = (user === null || user === void 0 ? void 0 : user.author) || {
        firstName: undefined,
        lastName: undefined
    }, firstName = ref2.firstName, lastName = ref2.lastName;
    return [
        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, user), {
            firstName: firstName,
            lastName: lastName
        }),
        loading,
        error,
        getUser
    ];
};


/***/ }),

/***/ 69325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73987);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77298);
/* harmony import */ var _Users_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21924);








var getImg = function(user) {
    var ref;
    return (ref = (0,_mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_2__/* .parseImageSrc */ .yO)(user.profilePicture, true)) === null || ref === void 0 ? void 0 : ref.thumb;
};
var UserCard = function(_param) {
    var user = _param.user, _width = _param.width, width = _width === void 0 ? 20 : _width, _height = _param.height, height = _height === void 0 ? 20 : _height, _mr = _param.mr, mr = _mr === void 0 ? 2 : _mr, _fallback = _param.fallback, fallback = _fallback === void 0 ? "https://mosanic-cdn.ams3.digitaloceanspaces.com/62e7a50082b1bd8d84a13845/thumb_mosanic.jpg" : _fallback, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "user",
        "width",
        "height",
        "mr",
        "fallback"
    ]);
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Users_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Card */ .Z.Card, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, other), {
        mr: mr,
        children: getImg(user) || (user === null || user === void 0 ? void 0 : user.img) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Users_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Avatar */ .Z.Avatar, {
            alt: "user icon",
            width: width,
            height: height,
            src: getImg(user) || user.img
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .PersonIcon */ .Tk0, {})
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (UserCard);


/***/ }),

/***/ 21924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2921);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26021);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78545);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    cursor: pointer;\n    font-size: 14px;\n    margin-top: -2.5px;\n    span {\n        vertical-align: middle;\n        padding: 4px;\n    }\n\n    img {\n        display: inline-block;\n        margin: 0 5px;\n    }\n\n    @media (max-width: 700px) {\n        span {\n            display: none;\n        }\n    }\n\n    &:hover {\n        color: ",
        ";\n    }\n\n    ",
        " \n    ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    border-radius: 50%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Card = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bd1ef08b-0"
})(_templateObject(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].util.primary.base */ .ZP.util.primary.base, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh);
var Avatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((next_image__WEBPACK_IMPORTED_MODULE_1___default())).withConfig({
    componentId: "sc-bd1ef08b-1"
})(_templateObject1());
var UserStyles = {
    Card: Card,
    Avatar: Avatar
};
/* harmony default export */ __webpack_exports__["Z"] = (UserStyles);


/***/ }),

/***/ 87269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ COLOR_SHADES; },
/* harmony export */   "W": function() { return /* binding */ MAIN_SHADE; }
/* harmony export */ });
var MAIN_SHADE = 3;
var COLOR_SHADES = [
    {
        name: "Main shades",
        type: "shades",
        colors: [
            {
                type: "10",
                name: "snow",
                value: "#F4F7FA"
            },
            {
                type: "20",
                name: "mist",
                value: "#E7E9ED"
            },
            {
                type: "30",
                name: "storm",
                value: "#D5D7DD"
            },
            {
                type: "40",
                inPalette: true,
                name: "stone",
                value: "#7D818D"
            },
            {
                type: "50",
                name: "night",
                value: "#5A5E68"
            },
            {
                type: "60",
                name: "gone",
                value: "#1E1E20"
            }, 
        ]
    },
    {
        name: "Primary",
        type: "main",
        colors: [
            {
                type: "10",
                name: "soft",
                value: "#D7EFFE"
            },
            {
                type: "20",
                name: "sky",
                value: "#A5DBFD"
            },
            {
                type: "30",
                name: "soft",
                value: "#8ED1FC"
            },
            {
                type: "40",
                inPalette: true,
                name: "bright",
                value: "#0693E3"
            },
            {
                type: "50",
                name: "ocean",
                value: "#046095"
            },
            {
                type: "60",
                name: "sea",
                value: "#023350"
            }, 
        ]
    },
    {
        name: "Secondary",
        type: "secondary",
        colors: [
            {
                type: "10",
                name: "Color",
                value: "#eef1f3"
            },
            {
                type: "20",
                name: "Color",
                value: "#d5dce1"
            },
            {
                type: "30",
                name: "Color",
                value: "#b3bfc9"
            },
            {
                type: "40",
                inPalette: true,
                name: "Color",
                value: "#9aa6b0"
            },
            {
                type: "50",
                name: "Color",
                value: "#565c62"
            },
            {
                type: "60",
                name: "Color",
                value: "#222527"
            }, 
        ]
    },
    {
        name: "Error",
        type: "error",
        colors: [
            {
                type: "10",
                name: "Color",
                value: "#fbd0db"
            },
            {
                type: "20",
                name: "Color",
                value: "#f37294"
            },
            {
                type: "30",
                name: "Color",
                value: "#ef4370"
            },
            {
                type: "40",
                inPalette: true,
                name: "Color",
                value: "#EB144C"
            },
            {
                type: "50",
                name: "Color",
                value: "#bc103d"
            },
            {
                type: "60",
                name: "Color",
                value: "#8d0c2e"
            }, 
        ]
    },
    {
        name: "Warning",
        type: "warning",
        colors: [
            {
                type: "10",
                name: "Color",
                value: "#fef1cc"
            },
            {
                type: "20",
                name: "Color",
                value: "#fedc80"
            },
            {
                type: "30",
                name: "Color",
                value: "#fdce4d"
            },
            {
                type: "40",
                inPalette: true,
                name: "Color",
                value: "#FCB900"
            },
            {
                type: "50",
                name: "Color",
                value: "#ca9400"
            },
            {
                type: "60",
                name: "Color",
                value: "#654a00"
            }, 
        ]
    },
    {
        name: "Success",
        type: "success",
        colors: [
            {
                type: "10",
                name: "Color",
                value: "#ccf6e6"
            },
            {
                type: "20",
                name: "Color",
                value: "#99ecce"
            },
            {
                type: "30",
                name: "Color",
                value: "#4ddea9"
            },
            {
                type: "40",
                inPalette: true,
                name: "Color",
                value: "#00D084"
            },
            {
                type: "50",
                name: "Color",
                value: "#00a66a"
            },
            {
                type: "60",
                name: "Color",
                value: "#005335"
            }, 
        ]
    },
    {
        name: "Utility colors",
        type: "util",
        colors: [
            {
                type: "10",
                name: "Color",
                value: "#fbcfec"
            },
            {
                type: "20",
                name: "Color",
                value: "#f79fd9"
            },
            {
                type: "30",
                name: "Color",
                value: "#f056bd"
            },
            {
                type: "40",
                inPalette: true,
                name: "Color",
                value: "#EA0EA0"
            },
            {
                type: "50",
                name: "Color",
                value: "#bb0b80"
            },
            {
                type: "60",
                name: "Color",
                value: "#750750"
            }, 
        ]
    }, 
];


/***/ }),

/***/ 46993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BT": function() { return /* binding */ getInitialComponent; },
/* harmony export */   "fu": function() { return /* binding */ ADD_ITEMS; },
/* harmony export */   "uA": function() { return /* binding */ getAddItem; }
/* harmony export */ });
/* unused harmony export INITIAL_COMPONENTS */
/* harmony import */ var _items__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66625);

var INITIAL_COMPONENTS = [
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: false,
        component: {
            name: "Layout tools",
            type: "layout-tools",
            icon: null,
            content: "Build up the foundation of this page.",
            isFocus: false,
            editor: {
                desc: "Testing desc"
            }
        },
        elements: [
            "boxes",
            "layouts",
            "grids",
            "repeaters",
            "modals"
        ]
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "text",
            title: "Visual text",
            icon: "visual"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            icon: "translated",
            type: "localizedtext",
            title: "Localized text"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            icon: "text",
            type: "content",
            title: "Text area"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "heading"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "button"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "icon"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "dataprovider",
            template: "height",
            title: "Data Provider",
            icon: "collection",
            desc: "Provide data to children"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "repeater",
            desc: "Loop dynamic with data links"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "datalink",
            template: "height",
            title: "Data link",
            icon: "link",
            desc: "Connect to a entry"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "link",
            icon: "external"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "stripeprovider",
            template: "height",
            title: "stripe Provider",
            icon: "product",
            desc: "Retreive stripe products"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "image"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "video"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            icon: "imageslider",
            type: "imageslider",
            title: "Content slider"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "gallery",
            desc: "Image masonary gallery"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "dialog"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "container",
            template: "container",
            desc: "Base container"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "stack",
            template: "vertical",
            title: "Vertical stack",
            icon: "verticalstack"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "stack",
            template: "horizontal",
            title: "Horizon stack",
            icon: "horizontalstack"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "columns",
            desc: "Easy responsive sizing"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "column",
            desc: "Only as child of columns"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "table",
            future: true
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "tabs",
            desc: "Must wrap tabs"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            title: "Tab header",
            type: "tabheader",
            desc: "Control current tab"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "tab",
            desc: "Tab content"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            title: "Accordions",
            type: "expanders",
            desc: "To control multi expanders"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            title: "Accordion H",
            icon: "accordion",
            type: "expanderheader",
            desc: "Control current expander"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            title: "Accordion",
            type: "expander",
            desc: "Expander Accordion"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "layout",
            coming: true
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "grid",
            coming: true
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "code",
            desc: "Custom code"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "script",
            desc: "Insert code links"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "panel",
            desc: "Information panel",
            coming: true
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        limit: "header",
        component: {
            type: "menu",
            desc: "Insert custom navs"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            title: "Count down",
            type: "timer",
            coming: true
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "form",
            desc: "Link custom forms direct"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        group: "form",
        addQuick: true,
        component: {
            type: "inputfield",
            title: "Input",
            desc: "Field input"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        group: "form",
        addQuick: true,
        component: {
            type: "checkbox",
            future: true
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        group: "form",
        addQuick: true,
        component: {
            type: "switch",
            future: true
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        group: "form",
        addQuick: true,
        component: {
            type: "radio",
            future: true
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        group: "form",
        addQuick: true,
        component: {
            type: "slider",
            future: true
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "chart",
            planned: true
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "pie",
            future: true
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            type: "calendar",
            future: true
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            title: "Social grid",
            type: "socialgrid"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            title: "Google map",
            type: "googlemap"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            title: "Account",
            type: "account",
            desc: "[addon] User accounts"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            title: "Auth forms",
            type: "auth",
            desc: "[addon] User accounts"
        }
    },
    {
        type: _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8,
        addQuick: true,
        component: {
            title: "User",
            type: "user",
            desc: "[addon] User accounts"
        }
    }
];
var getQuickAddItems = function() {
    var items = [];
    Object.values(INITIAL_COMPONENTS).map(function(item, index) {
        if (item.addQuick) {
            if (item.type === _items__WEBPACK_IMPORTED_MODULE_0__/* .SIDEBAR_ITEM */ .d8) item.type = _items__WEBPACK_IMPORTED_MODULE_0__/* .ADD_ITEM */ .mj;
            items.push(item);
        }
    });
    return items;
};
var ADD_ITEMS = getQuickAddItems();
var getAddItem = function(type) {
    var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return ADD_ITEMS.filter(function(item) {
        return item.component.type === type;
    })[index];
};
var getInitialComponent = function(type) {
    return INITIAL_COMPONENTS.filter(function(item) {
        return item.component.type === type;
    })[0];
};


/***/ }),

/***/ 21871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ isRenderField; }
/* harmony export */ });
/* unused harmony export FieldTypes */
var FieldTypes = [
    "metricInput",
    "incrementInput",
    "transform",
    "bezier",
    "font",
    "imageUrls",
    // 'gallery',
    "imageUrl",
    // 'image',
    // 'markedimage',
    "videoUrl",
    // 'video',
    "focal",
    "icon",
    "choice",
    // 'checkbox',
    // 'radio',
    "select",
    "toggle",
    // 'switch',
    "btn",
    // 'image',
    "number",
    "string",
    // 'text',
    // 'textarea',
    "content",
    "code",
    "slider",
    "link",
    "colorPlus",
    "editor",
    "color",
    "gradient",
    //Data links
    "entry",
    "collection",
    // 'relation',
    "form",
    "inputfield",
    "dialogSelector",
    // 'date',
    // 'date-time',
    // 'time',
    //Inline
    "slot",
    "render",
    "label"
];
var isRenderField = function(type) {
    return FieldTypes.includes(type);
};


/***/ }),

/***/ 66625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DT": function() { return /* binding */ STACK; },
/* harmony export */   "GK": function() { return /* binding */ REPEATER; },
/* harmony export */   "Ls": function() { return /* binding */ SIDEBAR_REPEATER; },
/* harmony export */   "NV": function() { return /* binding */ COMPONENT; },
/* harmony export */   "Nz": function() { return /* binding */ SIDEBAR_PANEL; },
/* harmony export */   "aC": function() { return /* binding */ COLUMN; },
/* harmony export */   "d8": function() { return /* binding */ SIDEBAR_ITEM; },
/* harmony export */   "dA": function() { return /* binding */ SIDEBAR_STACK; },
/* harmony export */   "mj": function() { return /* binding */ ADD_ITEM; },
/* harmony export */   "rZ": function() { return /* binding */ CONTAINER; },
/* harmony export */   "rn": function() { return /* binding */ ROW; },
/* harmony export */   "vo": function() { return /* binding */ SIDEBAR_LAYOUT; }
/* harmony export */ });
//New items
var SIDEBAR_ITEM = "sidebarItem";
var SIDEBAR_STACK = "sidebarContainer";
var SIDEBAR_REPEATER = "sidebarRepeater";
var SIDEBAR_LAYOUT = "layoutItem";
var SIDEBAR_PANEL = "sidebarPanel";
//Dynamic
var ADD_ITEM = "addItem";
//Map items
var ROW = "ROW";
var COLUMN = "COLUMN";
var STACK = "STACK";
var COMPONENT = "COMPONENT";
var CONTAINER = "CONTAINER";
var REPEATER = "REPEATER";
var Items = {
    SIDEBAR_ITEM: SIDEBAR_ITEM,
    SIDEBAR_STACK: SIDEBAR_STACK,
    SIDEBAR_REPEATER: SIDEBAR_REPEATER,
    SIDEBAR_LAYOUT: SIDEBAR_LAYOUT,
    SIDEBAR_PANEL: SIDEBAR_PANEL,
    ADD_ITEM: ADD_ITEM,
    ROW: ROW,
    COLUMN: COLUMN,
    STACK: STACK,
    COMPONENT: COMPONENT,
    REPEATER: REPEATER,
    CONTAINER: CONTAINER
};
/* harmony default export */ __webpack_exports__["ZP"] = (Items);


/***/ }),

/***/ 29667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ft": function() { return /* binding */ BuilderSubNav; }
/* harmony export */ });
/* unused harmony exports SIDEBAR_ITEM, SIDEBAR_STACK, SIDEBAR_REPEATER, SIDEBAR_PANEL */
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);


var SIDEBAR_ITEM = "sidebarItem";
var SIDEBAR_STACK = "sidebarContainer";
var SIDEBAR_REPEATER = "sidebarRepeater";
var SIDEBAR_PANEL = "sidebarPanel";
var BuilderSubNav = [
    {
        _id: "elements",
        type: SIDEBAR_PANEL,
        value: "elements",
        tooltip: "Add Elements",
        icon: "elements"
    },
    {
        _id: "layers",
        type: SIDEBAR_PANEL,
        value: "layers",
        tooltip: "Layers",
        icon: "layers"
    },
    {
        _id: "pages",
        type: SIDEBAR_PANEL,
        value: "pages",
        tooltip: "Structures",
        icon: "global"
    },
    {
        _id: "styles",
        type: SIDEBAR_PANEL,
        value: "styles",
        tooltip: "Global Styles",
        icon: "styles"
    },
    {
        _id: "content",
        type: SIDEBAR_PANEL,
        value: "content",
        tooltip: "Content Manager",
        icon: "content"
    },
    {
        _id: "options",
        type: SIDEBAR_PANEL,
        value: "options",
        tooltip: "Options",
        icon: "gear"
    },
    {
        _id: "dev",
        type: SIDEBAR_PANEL,
        value: "dev",
        tooltip: "Dev Console",
        icon: "code"
    }, 
];


/***/ }),

/***/ 73151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ELEMENTS_SIDEBAR; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77298);


var ELEMENTS_SIDEBAR = [
    {
        label: "Quick add",
        value: "quick-add",
        help: "Quick add element's are the building blocks of your page. You can drag & drop them into the layout.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .PlusCircledIcon */ .SPS, {})
    },
    {
        key: "subAssets",
        value: "divider"
    },
    {
        label: "Layouts",
        value: "layouts",
        help: "Layouts are preset sections without much template content and styling.",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ViewGridIcon */ .XOb, {})
    },
    {
        label: "Structures",
        value: "layouts-structures",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .DashboardIcon */ .QGC, {})
    },
    {
        key: "subMain",
        value: "divider"
    },
    {
        label: "Navigation",
        value: "layouts-navigation",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .BorderTopIcon */ .qKs, {})
    },
    {
        label: "Header",
        value: "layouts-headers",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .BorderTopIcon */ .qKs, {})
    },
    {
        label: "Footer",
        value: "layouts-footers",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .BorderBottomIcon */ .PQg, {})
    },
    {
        key: "subCore",
        value: "divider"
    },
    {
        label: "About",
        value: "layouts-about",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .TextIcon */ .VL1, {})
    },
    {
        label: "Benefits",
        value: "layouts-benefits",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ListBulletIcon */ .jVc, {})
    },
    {
        label: "Call to action",
        value: "layouts-cta",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .StarIcon */ .r7p, {})
    },
    {
        label: "Gallery",
        value: "layouts-images",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ImageIcon */ .XBm, {})
    },
    {
        label: "Video",
        value: "layouts-video",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .VideoIcon */ .Odl, {})
    },
    {
        value: "divider",
        key: "subContents"
    },
    {
        label: "News",
        value: "layouts-news",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .TextAlignLeftIcon */ .rrd, {})
    },
    {
        label: "Article",
        value: "layouts-article",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .TextAlignJustifyIcon */ .ux3, {})
    },
    {
        value: "divider",
        key: "subNews"
    },
    {
        label: "Products",
        value: "layouts-products",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "15px",
            height: "15px",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    "data-name": "shopping-cart",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "24",
                            height: "24",
                            opacity: "0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M21.08 7a2 2 0 0 0-1.7-1H6.58L6 3.74A1 1 0 0 0 5 3H3a1 1 0 0 0 0 2h1.24L7 15.26A1 1 0 0 0 8 16h9a1 1 0 0 0 .89-.55l3.28-6.56A2 2 0 0 0 21.08 7zm-4.7 7H8.76L7.13 8h12.25z"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "7.5",
                            cy: "19.5",
                            r: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "17.5",
                            cy: "19.5",
                            r: "1.5"
                        })
                    ]
                })
            })
        })
    },
    {
        label: "Product",
        value: "layouts-pricing",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .SketchLogoIcon */ .VFo, {})
    },
    {
        label: "Projects",
        value: "layouts-projects",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .MixIcon */ .$bm, {})
    },
    {
        label: "Events",
        value: "layouts-events",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .CalendarIcon */ .Que, {})
    },
    {
        label: "Forms",
        value: "layouts-from",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .InputIcon */ .SQj, {})
    },
    {
        //     value: 'divider',
        //     key: 'subCta',
        // },{
        //     label: 'Menu',
        //     value: 'layouts-menu',
        //     icon: <TextAlignCenterIcon />
        // },{
        value: "divider",
        key: "subSpecific"
    },
    {
        //     label: 'Location',
        //     value: 'layouts-location',
        //     icon: <SewingPinIcon />
        // },{
        label: "Business",
        value: "layouts-opening-hours",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ClockIcon */ .T39, {})
    },
    {
        label: "Reviews",
        value: "layouts-reviews",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ChatBubbleIcon */ .mTE, {})
    },
    {
        label: "Team",
        value: "layouts-team",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .PersonIcon */ .Tk0, {})
    },
    {
        //     label: 'Calendar',
        //     value: 'layouts-calendar',
        //     icon: <CalendarIcon />
        // },{
        //     label: 'Info Graphics',
        //     value: 'layouts-info-graphics',
        //     icon: <PieChartIcon />
        // },{
        label: "Charts",
        value: "layouts-charts",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .BarChartIcon */ .eJP, {})
    },
    {
        label: "FAQs",
        value: "faqs",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .QuestionMarkCircledIcon */ .pjG, {})
    },
    {
        label: "Dialogs",
        value: "layouts-dialogs",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .SizeIcon */ .el1, {})
    },
    {
        //     label: 'Partners',
        //     value: 'layouts-partners',
        //     icon: <StarIcon />
        // },{
        label: "Misc",
        value: "layouts-misc",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .PersonIcon */ .Tk0, {})
    }
];


/***/ }),

/***/ 91051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ variantGroupTypes; },
/* harmony export */   "kG": function() { return /* binding */ interactionStates; },
/* harmony export */   "tr": function() { return /* binding */ Variants; }
/* harmony export */ });
/* unused harmony exports BASE, ALL, HOVER, NOT_HOVER, FOCUS, NOT_FOCUS, PRESSED, NOT_PRESSED, States */
//Base variants
var BASE = "base";
var ALL = "all";
var HOVER = ":hover";
var NOT_HOVER = ":not(:hover)";
var FOCUS = ":focus";
var NOT_FOCUS = ":not(:focus)";
var PRESSED = ":active";
var NOT_PRESSED = ":not(:active)";
var States = {
    HOVER: HOVER,
    NOT_HOVER: NOT_HOVER,
    FOCUS: FOCUS,
    NOT_FOCUS: NOT_FOCUS,
    PRESSED: PRESSED,
    NOT_PRESSED: NOT_PRESSED
};
var interactionStates = [
    {
        label: "Hover",
        value: HOVER
    },
    {
        label: "Not Hover",
        value: NOT_HOVER
    },
    {
        label: "Pressed",
        value: PRESSED
    },
    {
        label: "Not Pressed",
        value: NOT_PRESSED
    },
    {
        label: "Focussed",
        value: FOCUS
    },
    {
        label: "Not Focussed",
        value: NOT_FOCUS
    }
];
var variantGroupTypes = [
    {
        label: "Toggle variant",
        type: "toggle",
        helpText: "This variant can be switched on and off by a single toggle."
    },
    {
        label: "Single select variant",
        type: "single",
        helpText: "This variant group contains multiple options where only one can be selected."
    },
    {
        label: "Multi select variant",
        type: "multi",
        helpText: "This variant group contains multiple options where multiple can be selected."
    }
];
var Variants = {
    BASE: BASE,
    ALL: ALL
};


/***/ }),

/***/ 18453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BV": function() { return /* binding */ subscriptionPlans; },
/* harmony export */   "Ov": function() { return /* binding */ getPlanById; },
/* harmony export */   "UN": function() { return /* binding */ getSubScriptionPlan; },
/* harmony export */   "vf": function() { return /* binding */ enterprisePlan; },
/* harmony export */   "z5": function() { return /* binding */ plans; }
/* harmony export */ });
/* unused harmony export plan */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_items_ControlPanel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77586);
/* harmony import */ var _util_Num__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3121);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68311);






var plans = {
    "starter": 1,
    "basic": 2,
    "advanced": 3,
    "pro": 4,
    "custom": 5
};
var plan = function(lvl) {
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .capitalizeFirst */ .Ez)(Object.keys(plans)[lvl]);
};
var subscriptionPlans = [
    {
        tooltip: "Start creating for free.",
        name: "Starter Plan",
        id: "prod_MJK678l0B5kMJL",
        category: "plan",
        priceNotice: "per team/month",
        notice: "Includes 30 days Pro trial",
        subNotice: "*With sub domain and 1 user only",
        value: "starter",
        label: "Start building, learn Mosanic and publish for free to Mosanic.io ",
        helpLower: "Lower than your current plan with less features, less band-width and less possibilities to make your website go fire.",
        helpHigher: "A great starting point, enjoy the benefits of exploring Mosanic and make something beautiful.",
        points: [
            {
                label: "Free mosanic.io hosting",
                help: "Your website is hosted for free on your chosen custom sub domain name!",
                key: "slots",
                amount: 1,
                metric: " slot"
            },
            {
                label: "Unlimited collections",
                help: "A collection contains data you can load in dynamically. These can contain anything, ex; projects, articles, pages.",
                key: "all",
                amount: "unlimited"
            },
            {
                label: "7-days version history",
                key: "version-history",
                amount: 7,
                metric: " days"
            },
            {
                label: "1K Monthly page views",
                help: "All delivered by our blazingly fast CDN. We will let you know if you go over.",
                key: "views",
                amount: 1,
                metric: "K"
            },
            {
                label: "Unlimited publishes",
                help: "Made some edits? No problem, you can publish them without any restrictions.",
                key: "all"
            },
            {
                label: "50 CMS entries",
                help: "The number of items you can store in the CMS for free. Example: 25 articles, 15 pages and 10 portfolio items.",
                key: "cms-entries",
                amount: 50,
                metric: " entries"
            },
            {
                key: "storage",
                amount: 10,
                metric: "GB"
            },
            {
                label: "15GB bandwidth",
                help: "Data transfer from our CDN. Included with 10GB file and image storage for free.",
                key: "bandwidth",
                amount: 15,
                metric: "GB"
            },
            {
                label: "3 Un-hosted sites",
                key: "unhosted",
                amount: 3
            },
            {
                label: "Image optimization",
                key: "all"
            },
            {
                label: "Template library",
                key: "all"
            },
            {
                label: "Visual editor",
                key: "all"
            },
            {
                key: "users",
                amount: 1,
                metric: " user"
            }
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("features-req|contact-plus|whatsapp|domain|chat|support|editors|roles|canvas|addons|transfer|team|cms-addons|schedule|basic-add|ab-add|analytics-add|comm-add|api-add|local-add|shop-add".split("|").map(function(key) {
            return {
                key: key,
                amount: "none"
            };
        })))
    },
    {
        tooltip: "Build a basic mosaic in Mosanic.",
        id: "prod_MJKGUjWbUVHslM",
        // "price_data": {
        //   recurring: {
        //     interval: 'month',
        //     "interval_count": 1
        //   },
        //   // "tax_code": "txcd_10102000",
        //   "tax_behavior": "exclusive",
        // },
        // "tax_rates": [],
        category: "plan",
        priceNotice: "per team/month",
        notice: "Includes 3 users",
        subNotice: "Add more for €[value]/user",
        subNoticeValue: 1000,
        value: "basic",
        addons: {
            slots: 3,
            users: 7
        },
        color: "green",
        label: "For small teams, ready to test layouts, scale and converse visitors to customers.",
        helpLower: "Lower than your current plan with less features, less band-width and less possibilities to make your website go fire.",
        helpHigher: "5K visitors is a lot, 50GB of bandwidth as well. But if you really want to get more out of you're current plan, you can add up to 3 addons.",
        points: [
            {
                label: "All ".concat(plan(0), " points!"),
                bolder: true
            },
            {
                label: "1 Custom domain slot",
                help: "You can bring your own domain name and host multiple mosanic.io slots.",
                key: "domain",
                amount: 1
            },
            {
                label: "4 mosanic.io slots",
                help: "Convert your un-hosted projects to live demo's. Share them easily with your stake holders.",
                key: "slots",
                amount: 4,
                metric: " slots"
            },
            {
                label: "14-days version history",
                key: "version-history",
                amount: 14,
                metric: " days"
            },
            {
                label: "5K Monthly page views",
                help: "All delivered by our fast CDN. We will let you know if you go over.",
                key: "views",
                amount: 5,
                metric: "K"
            },
            {
                label: "Up to 10 users per team",
                help: "By default, there are 3 users included in the ".concat(plan(1), " plan. You can add 7 additional, for a total of 10 users."),
                key: "users",
                amount: 3,
                metric: "+ users"
            },
            {
                label: "0 CMS entries",
                help: "CMS entries are not included in the ".concat(plan(1), " plan, you can add up to 250 under CMS the addons. Not enough entries? Check out the ").concat(plan(2), " Plan with 1500 CMS entries."),
                key: "cms-entries",
                amount: "0 - 250",
                metric: " entries"
            },
            {
                key: "storage",
                amount: 25,
                metric: "GB +"
            },
            {
                label: "50GB bandwidth",
                help: "Data transfer from our CDN. Included with 25GB file and image storage.",
                key: "bandwidth",
                amount: 50,
                metric: "GB +"
            },
            {
                label: "10 Un-hosted sites",
                help: "Get fancy and experiment with designs, you can create up to 10 un-hosted sites in de builder. Note that sites configured in an domain slot do not count towards this limit.",
                key: "unhosted",
                amount: 10
            },
            {
                label: "Editor +",
                // help: "We've included the Editor + canvas for Basic Mosaic members as well !",
                amount: "Editor +",
                key: "canvas"
            },
            {
                key: "roles",
                amount: 3,
                metric: " roles"
            },
            {
                key: "addons",
                amount: "Basic"
            }
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("features-req|cms-addons|whatsapp|editors|chat|schedule|ab-add|analytics-add|comm-add|api-add|local-add|shop-add".split("|").map(function(key) {
            return {
                key: key,
                amount: "none"
            };
        })))
    },
    {
        tooltip: "Data that compliments your UI.",
        id: "prod_MJKJjn5qGjSOYI",
        category: "plan",
        priceNotice: "per team/month",
        notice: "Includes 4 users + 2 editors",
        subNotice: "Add more for €[value]/user",
        subNoticeValue: 2000,
        value: "advanced",
        addons: {
            slots: 10,
            users: 7
        },
        color: "orange",
        label: "Businesses that want to go to the next level. You understand the benefit of a great site, we've got the tools.",
        helpLower: "Lower than your current plan with less features, less band-width and less possibilities to make your website go fire.",
        helpHigher: "Go grazy, convert al your data fields to CMS entries, hire an content writer, analyze your users and make your designs pop with the Advanced Editor features.",
        points: [
            {
                label: "All ".concat(plan(1), " points!"),
                bolder: true
            },
            {
                label: "30-days version history",
                key: "version-history",
                amount: 30,
                metric: " days"
            },
            {
                label: "25K Monthly page views",
                help: "All delivered by our fast CDN. We will let you know if you go over.",
                key: "views",
                amount: 25,
                metric: "K"
            },
            {
                label: "1500 CMS entries",
                help: "Not enough entries? You can keep adding up to 10 sets of 500 more under CMS addons.",
                key: "cms-entries",
                amount: 1.5,
                metric: "K+ entries"
            },
            {
                label: "100GB bandwidth",
                help: "Data transfer from our CDN. Included with 50GB file and image storage. Data addons are available",
                key: "bandwidth",
                amount: 100,
                metric: "GB"
            },
            {
                key: "storage",
                amount: 50,
                metric: "GB"
            },
            {
                label: "2 Editor accounts",
                help: "The same user limit and upgrade possibilities as the ".concat(plan(1), " plan with the addition of 1 extra user and 2 content editor accounts."),
                key: "editors",
                amount: 2,
                metric: " editors"
            },
            {
                key: "users",
                amount: 4,
                metric: "+ users"
            },
            {
                label: "6 user roles",
                help: "Setup your included and added users with different roles; Admin, Developer, Designer, Viewer, Analyst and Editor. Heads-up: the 2 guest content editors cannot be changed.",
                amount: 6,
                metric: " roles",
                key: "roles"
            },
            {
                label: "A/B and Analytics*",
                help: "Coming soon! Test, track and improve the conversion by sending a percentage of you users to a different variant of an page.",
                key: "addons",
                amount: "A/B testing"
            },
            {
                key: "addons",
                amount: "Analytics"
            },
            {
                label: "Advanced editor",
                help: "Edit your components live from the canvas. Auto Round-ups, Themes and many more features. So you work even faster in the Mosanic builder.",
                amount: "Advanced",
                key: "canvas"
            },
            {
                key: "slots",
                amount: 7,
                metric: " slots"
            },
            {
                key: "domain",
                amount: "1 - 3"
            },
            {
                key: "unhosted",
                amount: 15
            }
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("basic-add|whatsapp|chat|schedule|comm-add|api-add|local-add|shop-add".split("|").map(function(key) {
            return {
                key: key,
                amount: "none"
            };
        })))
    },
    {
        tooltip: "Features that bring you to the moon.",
        id: "prod_MJKJ22GOKWPgtU",
        category: "plan",
        // "price_data": {
        //   recurring: {
        //     interval: 'month',
        //     "interval_count": 1
        //   },
        //   // "tax_code": "txcd_10102000",
        //   "tax_behavior": "exclusive",
        // },
        priceNotice: "per team/month",
        notice: "Includes 10 users",
        subNotice: "Add more for €[value]/user",
        subNoticeValue: 3000,
        value: "pro",
        addons: {
            slots: 25,
            users: 25
        },
        color: "primary",
        label: "You're there...",
        helpLower: "Lower than your current plan with less features, less band-width and less possibilities to make your website go fire.",
        helpHigher: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                "Page views aren't one of your problems, you scale, you grow. You can offer your content in multiple languages, connect to data externally and make your design 100% consistent with the pro editor tools. ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "Ain't enough? Discuss your needs, let us work together. Check out the ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_ControlPanel__WEBPACK_IMPORTED_MODULE_3__/* .HelpPopper */ .q, {
                    trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        children: "enterprise"
                    }),
                    hover: true,
                    span: true,
                    helpText: "Don't let te name scare you. Just like you, we value our time. But we're here to help."
                }),
                " plan."
            ]
        }),
        points: [
            {
                label: "All ".concat(plan(2), " points!"),
                bolder: true
            },
            {
                label: "75K Monthly page views",
                help: "All delivered by our blazingly fast CDN. We will let you know if you go over, additional visits are possible on Pro plans.",
                key: "views",
                amount: 75,
                metric: "K +"
            },
            {
                label: "2500 CMS entries",
                help: "Not enough entries? You can add more under CMS addons.",
                key: "cms-entries",
                amount: 2.5,
                metric: "K+ entries"
            },
            {
                label: "90-days version history",
                key: "version-history",
                amount: 90,
                metric: " days +"
            },
            {
                key: "users",
                amount: 10,
                metric: "+ users"
            },
            {
                amount: 6,
                metric: "+ roles",
                key: "roles"
            },
            {
                amount: "custom",
                key: "editors"
            },
            {
                label: "Private connections (API)",
                help: "Coming soon! Built out api connectors to any homegrown or third party software systems to link your collections and data sources.",
                key: "addons"
            },
            {
                label: "Localization",
                help: "You will be able to add the localization Addon to translate your Site/ platform to as many languages as you want.",
                key: "addons"
            },
            {
                label: "Support +",
                help: "You will be abble to submit tickets with a priority status and have a private chat channel with our team."
            },
            {
                label: "Pro editor",
                help: "Create artboards, Tokens, Mixins and stacked Variants. Feel like a absolute god and keep everything consistent. And uh.. Before we forget, you can even add your own code!",
                key: "canvas"
            },
            {
                key: "domain",
                amount: "1 - 6"
            },
            {
                key: "slots",
                amount: 10,
                metric: "+ slots"
            },
            {
                key: "bandwidth",
                amount: 150,
                metric: "GB +"
            },
            {
                key: "storage",
                amount: 75,
                metric: "GB +"
            },
            {
                key: "unhosted",
                amount: 20
            },
            {
                key: "addons",
                amount: "Ecommerce"
            }
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("basic-add|whatsapp|comm-add|shop-add".split("|").map(function(key) {
            return {
                key: key,
                amount: "none"
            };
        })))
    }
];
var enterprisePlan = {
    title: "\uD83D\uDCC8 Enterprise",
    name: "\uD83D\uDCC8 Enterprise",
    fullPrice: "custom",
    category: "plan",
    priceAdd: "+",
    currency: "EUR",
    id: "SKU-MSN22-ENT-PLN005",
    priceNotice: "Annual billing only",
    notice: "Includes 20+ Users",
    subNotice: "These points are the base indications",
    value: "enterprise",
    addons: {
        slots: 99,
        users: 99
    },
    color: "gray",
    cta: [
        {
            label: "Schedule meeting",
            href: "/meeting"
        },
        {
            label: "Contact us",
            href: "mailto:enterprise@mosanic.io"
        }
    ],
    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            "All our members get attention. With the enterprise package you will get a",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_ControlPanel__WEBPACK_IMPORTED_MODULE_3__/* .HelpPopper */ .q, {
                trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                    children: '"little" bit more'
                }),
                hover: true,
                span: true,
                helpText: "Monthly onboarding, priority support, queue skipping tickets, contact addons and our focus. ❤️"
            }),
            "."
        ]
    }),
    points: [
        {
            label: "All ".concat(plan(3), " points!"),
            bolder: true
        },
        {
            label: "500K+ Monthly page views",
            help: "The sky is the limit, we can scale with your needs. We will setup a custom plan for your company alone and give full transparency about the costs and usage."
        },
        {
            label: "10.000+ CMS entries",
            help: "Not enough entries? You can keep adding more without a limit under CMS addons."
        },
        {
            label: "180-days+ version history",
            help: "With the possibility to discuss a 360 or more days history."
        },
        {
            label: "Custom feature priority",
            help: "Just like all premium plans you can submit feature requests. These get priority and we will work close together to fulfill your needs."
        },
        {
            label: "Monthly onboarding",
            help: "We will schedule once a month a digital onboarding to discuss your success, points of attention, needs and feature requests."
        },
        {
            label: "Analytics +",
            help: "A fully custom dashboard based on your needs, also the possibility to use Google Analytics without the 'G.A.' Addon."
        },
        {
            label: "Priority Support",
            help: "Tickets will go in front of the queue and you will be able to add the 'Whatsapp' or 'Private slack channel' Addons."
        },
        {
            label: "2+ Spaces",
            help: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "A Space is the container for your hosted and un-hosted sites, with shared data, components and designs assets like tokens. ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "With multiple spaces you can separate these, just like if you create a second account on Mosanic but with a lot of Additional features and control. ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "For agencies we would like to utilize this functionally we have additional discounts and automatic space creation."
                ]
            })
        },
        {
            label: "White labeling",
            help: "Make it your own and receive advanced client control by adding the 'White label Mosanic' addon for Agencies."
        },
        {
            label: "Custom roles",
            help: "Extend the possibilities of user roles by adding your own. Available with the 'Custom roles' addon."
        },
        {
            label: "spaces +",
            key: "team"
        }
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("cms-entries|cdnd|slots|domain|unhosted|version-history|views|storage|bandwidth|transfer|roles|users|editors".split("|").map(function(key) {
        return {
            key: key,
            amount: "custom"
        };
    })))
};
var getSubScriptionPlan = function(key) {
    return (0,_util_Num__WEBPACK_IMPORTED_MODULE_4__/* .isNumber */ .hj)(key) ? subscriptionPlans[key - 1] : subscriptionPlans.filter(function(plan) {
        return plan.value === key;
    })[0];
};
var getPlanById = function(id) {
    return subscriptionPlans.find(function(p) {
        return p.id === id;
    });
};


/***/ }),

/***/ 89962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ UserAccount; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/adapters/token.js + 1 modules
var token = __webpack_require__(94645);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
// EXTERNAL MODULE: ./src/mosanic/components/Membership/redirectToPortal.js
var redirectToPortal = __webpack_require__(82223);
// EXTERNAL MODULE: ./src/mosanic/components/User/useUser.js
var useUser = __webpack_require__(12107);
// EXTERNAL MODULE: ./src/mosanic/components/User/Handlers/useUpdateUser.js
var useUpdateUser = __webpack_require__(93548);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(68875);
// EXTERNAL MODULE: ./src/mosanic/fields/Form/FormItems.js
var FormItems = __webpack_require__(56185);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
;// CONCATENATED MODULE: ./src/mosanic/components/User/EditUser.js






var EditUser = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,index_esm/* useFormContext */.Gc)(), handleSubmit = ref.handleSubmit, control = ref.control, watch = ref.watch, reset = ref.reset, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        errors: errors
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItems/* FormItems */.G, {
            controls: inputProps,
            fields: [
                {
                    name: "author.profilePicture",
                    label: "Profile image",
                    type: "image",
                    fullWidth: true
                },
                {
                    //     name: 'author.banner',
                    //     label: 'Banner color',
                    //     type: 'color',
                    // },{
                    name: "author.firstName",
                    label: "First name",
                    rules: {
                        required: "You can't clear your first name."
                    }
                },
                {
                    name: "author.lastName",
                    label: "Last name",
                    rules: {
                        required: "You can't clear your last name."
                    }
                },
                {
                    name: "email",
                    label: "E-mail",
                    rules: {
                        required: "You'r email can not be changed."
                    },
                    disabled: true,
                    fullWidth: true
                }
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/mosanic/components/User/EditProfile.js





var EditProfile = function(param) {
    var handler = param.handler, _updating = param.updating, updating = _updating === void 0 ? false : _updating, author = param.author;
    var ref = (0,index_esm/* useFormContext */.Gc)(), handleSubmit = ref.handleSubmit, control = ref.control, watch = ref.watch, reset = ref.reset, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItems/* FormItems */.G, {
            controls: inputProps,
            fields: [
                {
                    name: "author.displayName",
                    label: "Displayed name",
                    fullWidth: true
                },
                {
                    name: "author.bio",
                    label: "Short bio"
                },
                {
                    name: "author.biography",
                    label: "Biography",
                    type: "textarea"
                }
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/mosanic/components/User/Handlers/useDeleteUser.js
var useDeleteUser = __webpack_require__(86466);
// EXTERNAL MODULE: ./src/mosanic/core/Notifications/DeleteConfirm.js
var DeleteConfirm = __webpack_require__(37676);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(87567);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/items/LoadingDots.tsx
var LoadingDots = __webpack_require__(4093);
// EXTERNAL MODULE: ./src/mosanic/items/Page/DashCard.js
var DashCard = __webpack_require__(69756);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/utils/Date.js
var utils_Date = __webpack_require__(99787);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
;// CONCATENATED MODULE: ./src/mosanic/core/Account/Account.js



















var UserAccount = function(param) {
    var _teamsAvailable = param.teamsAvailable, teamsAvailable = _teamsAvailable === void 0 ? true : _teamsAvailable, _overwrite = param.overwrite, overwrite = _overwrite === void 0 ? {
        settings: "Your personal details and information.",
        author: "This information is displayed under the articles created by you."
    } : _overwrite;
    var ref;
    var methods = (0,index_esm/* useForm */.cI)({
        mode: "all"
    });
    var isAuth = (0,token/* isAuthenticated */.$8)();
    var userId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetUser */.pg)({
        _id: userId
    }), 1), storedUser = ref1[0];
    var _id = (storedUser || {
        _id: null
    })._id;
    var isVisit = false;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useUser/* useUser */.a)({
        _id: _id
    }), 3), user = ref2[0], loading = ref2[1], error = ref2[2];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useDeleteUser/* useDeleteUser */.F)(), 4), deleteAccount = ref3[0], dataDelete = ref3[1], loadingDelete = ref3[2], errorDelete = ref3[3];
    var firstName = user.firstName, lastName = user.lastName, subscription = user.subscription;
    var plan = (subscription === null || subscription === void 0 ? void 0 : subscription.active) ? subscription.active : "starter";
    var ref4 = (0,react.useState)(false), viewPlan = ref4[0], setViewPlan = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useUpdateUser/* useUpdateUser */.I)(), 4), update = ref5[0], dataUpdate = ref5[1], loadingUpdate = ref5[2], errorUpdate = ref5[3];
    var updateAccount = function(updatedUser) {
        return update({
            _id: _id,
            user: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user, updatedUser), {
                registrationDate: undefined,
                lastLogin: undefined,
                _id: undefined,
                email: undefined
            })
        });
    };
    var ref6 = (0,react.useState)(false), accountDeleteModal = ref6[0], setAccountDeleteModal = ref6[1];
    var dispatchDeleteAction = function() {
        deleteAccount({
            _id: _id,
            user: user
        });
    };
    var ref7 = (0,react.useState)(), data = ref7[0], setData = ref7[1];
    var ref8 = (0,react.useState)(), sites = ref8[0], setSites = ref8[1];
    (0,react.useEffect)(function() {
        var ref;
        if ((user === null || user === void 0 ? void 0 : user._id) != ((ref = methods === null || methods === void 0 ? void 0 : methods.watch()) === null || ref === void 0 ? void 0 : ref._id)) {
            methods.reset((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
                registrationDate: (0,utils_Date/* getFullTimeStamp */.tZ)(user === null || user === void 0 ? void 0 : user.registrationDate),
                lastLogin: (0,utils_Date/* getFullTimeStamp */.tZ)(user === null || user === void 0 ? void 0 : user.lastLogin)
            }));
        }
    }, [
        methods,
        user
    ]);
    (0,react.useEffect)(function() {
        if (data) {
            setSites(data === null || data === void 0 ? void 0 : data.sites);
        }
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: !(user === null || user === void 0 ? void 0 : user.errors) ? isVisit ? "".concat(firstName, " ").concat(lastName) : "Account" : "No account found."
            }),
            !isVisit ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* ButtonGroup */.h, {
                mt: 2,
                children: [
                    plan != "starter" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                        label: "View current plan",
                        onClick: function() {
                            return setViewPlan(true);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                        onClick: function() {
                            return (0,redirectToPortal/* redirectToPortal */.g)(user);
                        },
                        children: "Open customer portal"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Buttons, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    href: "mailto:".concat(user === null || user === void 0 ? void 0 : user.email),
                    label: user === null || user === void 0 ? void 0 : user.email,
                    ghost: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            loading,
            error,
            isAuth && !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DashCard/* default */.Z, {
                        header: "Settings",
                        label: overwrite.settings,
                        help: "You can change this information any time, just make sure to save it once you're done.",
                        render: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditUser, {})
                    }, "Settings"),
                    (user === null || user === void 0 ? void 0 : (ref = user.teams) === null || ref === void 0 ? void 0 : ref.length) <= 0 && teamsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(DashCard/* default */.Z, {
                        header: "Team",
                        label: "Join a team or set one up.",
                        helpText: "Note that we combine this information with the fields you filled in under /users.",
                        render: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Buttons, {
                            mb: 10,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                    label: "Create team",
                                    href: "/team/setup"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                    label: "Join team",
                                    href: "/teams"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DashCard/* default */.Z, {
                        header: "Author profile",
                        label: overwrite.author,
                        helpText: "Note that we combine this information with the fields you filled in under /users.",
                        render: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditProfile, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                label: "This account was created on ".concat((0,utils_Date/* getFullTimeStamp */.tZ)(user === null || user === void 0 ? void 0 : user.registrationDate), " "),
                helpText: "The last login on Mosanic was at: ".concat((0,utils_Date/* getFullTimeStamp */.tZ)(user === null || user === void 0 ? void 0 : user.lastLogin), " "),
                span: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Buttons, {
                style: {
                    float: "right",
                    marginRight: "5%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                        label: "Cancel",
                        type: "submit"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                        mr: 0,
                        theme: "primary",
                        label: loadingUpdate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : "Save changes",
                        onClick: function() {
                            return updateAccount(methods.watch());
                        }
                    })
                ]
            }),
            errorUpdate,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteConfirm/* DeleteConfirm */.y, {
                action: dispatchDeleteAction,
                actionState: loadingDelete || dataDelete,
                validateLabel: "email",
                validateValue: user === null || user === void 0 ? void 0 : user.email,
                header: "About to delete your account.",
                message: "We're sad to see your go. Continue below if you really want to delete your Mosanic account. Note that it will take up-to 31 days to fully remove all of your data. ",
                state: accountDeleteModal,
                close: function() {
                    return setAccountDeleteModal(false);
                }
            })
        ]
    }));
};


/***/ }),

/***/ 45023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ UserPreferences; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/components/User/useUser.js
var useUser = __webpack_require__(12107);
// EXTERNAL MODULE: ./src/mosanic/components/User/Handlers/useUpdateUser.js
var useUpdateUser = __webpack_require__(93548);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./src/mosanic/core/Forms/AppearanceForm.js
var AppearanceForm = __webpack_require__(18918);
// EXTERNAL MODULE: ./src/mosanic/core/Forms/PreferencesForm.js
var Forms_PreferencesForm = __webpack_require__(30670);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/items/Page/Columns.js
var Columns = __webpack_require__(60630);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/mosanic/components/User/Settings.js










var OFFSET = 15;
var InfoTrigger = function(param) {
    var label = param.label;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ArrowRightIcon, {}),
            " ",
            label
        ]
    });
};
var Header = function(param) {
    var title = param.title, label = param.label, help = param.help;
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
            children: title
        }, "title"),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
            width: "400px",
            maxWidth: "100%",
            mb: 4,
            span: true,
            children: label
        }, "label"),
        help
    ];
};
var uiImage = {
    "System": "/assets/system-ui/system-pref.svg",
    "Light": "/assets/system-ui/light.svg",
    "Dark": "/assets/system-ui/dark.svg",
    "Single": "/assets/system-ui/single.svg",
    "Duo": "/assets/system-ui/duo.svg",
    "Free": "/assets/system-ui/free.svg"
};
var GeneralPreferences = function(param) {
    var site = param.site, loading = param.loading, update = param.update, name = param.name, _compact = param.compact, compact = _compact === void 0 ? false : _compact, _ui = param.ui, ui = _ui === void 0 ? true : _ui, _help = param.help, help = _help === void 0 ? true : _help;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !ui ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* TwoColumns */.VZ, {
                first: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                    title: "Interface",
                    label: "\n                Change how the user interface of ".concat(name, " looks and feels. These options will be expanded in the future.\n            ")
                }),
                second: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppearanceForm/* AppearanceForm */.O, {
                    fields: [
                        {
                            name: "pref.theme",
                            type: "buttonGroup",
                            height: "140px",
                            maxHeight: "140px!important",
                            options: [
                                {
                                    value: null,
                                    label: "System"
                                }
                            ].concat((0,_to_consumable_array/* default */.Z)("light|dark".split("|").map(function(value) {
                                return {
                                    label: (0,Text/* capitalizeFirst */.Ez)(value),
                                    value: value
                                };
                            }))).map(function(o) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                height: "100",
                                                width: "125",
                                                src: uiImage[o === null || o === void 0 ? void 0 : o.label],
                                                alt: "ui-pref"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            o.label
                                        ]
                                    })
                                });
                            })
                        },
                        {
                            name: "pref.sidebar.right",
                            label: "Right sidebar",
                            options: (0,_to_consumable_array/* default */.Z)("activity|messages|updates|pages|sites".split("|")).concat([
                                {
                                    value: null,
                                    label: "Automatic"
                                }
                            ]),
                            type: "select"
                        },
                        {
                            name: "pref.sidebar.transparent",
                            label: "Transparent sidebar",
                            desc: "Make the sidebars that float over the UI transparent.",
                            type: "switch"
                        },
                        {
                            name: "pref.sidebar.help",
                            label: "Sidebar labels",
                            desc: "Show helper labels within the sidebar.",
                            type: "switch"
                        }
                    ]
                })
            }),
            !help ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* TwoColumns */.VZ, {
                mt: compact ? 0 : OFFSET,
                first: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                    title: "Help",
                    label: "Get help and more information within ".concat(name, ", you can turn these options off once you've got a clear idea of all the features within mosanic.")
                }),
                second: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms_PreferencesForm/* PreferencesForm */.w, {
                    fields: [
                        {
                            label: "Tooltips",
                            name: "pref.helpers.tooltips",
                            desc: "Show helper tooltips across ".concat(name, ".")
                        },
                        {
                            label: "Tips and tours",
                            name: "pref.helpers.intro",
                            desc: "Show small tips and tours on new features."
                        },
                        {
                            label: "Header help",
                            name: "pref.helpers.headers",
                            desc: "Display extra info above sidebar sections."
                        }
                    ]
                })
            })
        ]
    });
};
var PrivacyPreferences = function(param) {
    var site = param.site, loading = param.loading, update = param.update, name = param.name, _compact = param.compact, compact = _compact === void 0 ? false : _compact;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* TwoColumns */.VZ, {
        first: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
            title: "Profile Privacy",
            label: "Control how and by who, your profile will be displayed within the ".concat(name, " admin area.")
        }),
        second: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms_PreferencesForm/* PreferencesForm */.w, {
            fields: [
                {
                    name: "pref.privacy.public",
                    label: "List Profile Public",
                    desc: "Your profile will be searchable within the /users page for ".concat(name, " Members."),
                    type: "switch"
                },
                {
                    name: "pref.privacy.length",
                    label: "Show your starting date",
                    desc: "Display how long you have been a ".concat(name, " user."),
                    type: "switch"
                },
                {
                    name: "pref.privacy.lastLogin",
                    label: "Show your last login date",
                    desc: "Display the last time you've logged in into ".concat(name, "."),
                    type: "switch"
                },
                {
                    name: "pref.privacy.messages",
                    label: "Allow messages",
                    desc: "Allow other users to send messages trough your profile page.",
                    type: "switch"
                },
                {
                    name: "pref.privacy.status",
                    label: "Show your online status",
                    desc: "Allow other users to view if you are online or not.",
                    type: "switch"
                },
                {
                    name: "pref.privacy.email",
                    label: "Display your email",
                    desc: "So ".concat(name, " members can email you directly."),
                    type: "switch"
                }
            ]
        })
    });
};
var EmailPreferences = function(param) {
    var site = param.site, loading = param.loading, name = param.name, update = param.update, _compact = param.compact, compact = _compact === void 0 ? false : _compact;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* TwoColumns */.VZ, {
                first: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                    title: "".concat(name, " notifications"),
                    label: " \n                Get emails to find out what's going on around ".concat(name, " and its features. You can turn these off if you want.\n            ")
                }),
                second: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms_PreferencesForm/* PreferencesForm */.w, {
                    fields: [
                        {
                            label: "News and update",
                            name: "pref.email.news-update",
                            desc: "News about ".concat(name, " and feature updates.")
                        },
                        {
                            label: "Tips and tutorials",
                            name: "pref.email.tips-tutorial",
                            desc: "Tips on getting more out of ".concat(name, ".")
                        },
                        {
                            label: "User research",
                            name: "pref.email.beta",
                            desc: "Get involved in our beta testing program and contribute to our product user research."
                        },
                        {
                            label: "Reminders",
                            name: "pref.email.reminders",
                            desc: "Get email notifications about updates."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* TwoColumns */.VZ, {
                mt: compact ? 0 : OFFSET,
                first: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                    title: "Account notifications",
                    label: " \n                Emails to find out what's going on in your ".concat(name, " account when you're not online. We don't recommend turning these off.\n            ")
                }),
                second: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms_PreferencesForm/* PreferencesForm */.w, {
                    fields: [
                        {
                            label: "Direct Messages",
                            name: "pref.email.direct",
                            desc: "Be notified when a ".concat(name, " user sends you a direct message trough your profile.")
                        },
                        {
                            label: "Comments",
                            name: "pref.email.comments",
                            desc: "Get an email when someone comments on a page or post publicly posted by you."
                        }
                    ]
                })
            })
        ]
    });
};
var canvasOptions = (0,_to_consumable_array/* default */.Z)("single|duo|free".split("|").map(function(value) {
    return {
        label: (0,Text/* capitalizeFirst */.Ez)(value),
        value: value
    };
})).map(function(o) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    height: "150",
                    width: "275",
                    src: uiImage[o === null || o === void 0 ? void 0 : o.label],
                    alt: "ui-pref"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                o.label
            ]
        })
    });
});
var builder = [
    {
        title: "Canvas",
        label: "Choose your default preferred canvas setup. Note that you can change these options on the fly within the view options in the navigation bar.",
        options: [
            {
                label: "Canvas mode",
                name: "pref.canvas.mode",
                type: "buttonGroup",
                height: "140px",
                maxHeight: "140px!important",
                plan: "pro",
                options: canvasOptions
            },
            {
                label: "Dynamic movements",
                name: "pref.canvas.pinchZoom",
                plan: "pro",
                desc: "Zoom, Scroll and Pinch to move the canvas around."
            },
            {
                label: "Shift scroll x-axis",
                name: "pref.canvas.shiftScroll",
                plan: "pro",
                desc: "When the shift button is pressed you can scroll from left to right with the mousewheel."
            },
            {
                label: "SpaceBar drag",
                name: "pref.canvas.spaceBarDrag",
                plan: "pro",
                desc: "Press the space bar to drag the canvas around."
            }
        ]
    },
    {
        title: "Inspector",
        label: "Change how the Builder Inspector on the right side reacts to your actions.",
        options: [
            {
                label: "Auto open inspector",
                name: "pref.inspector.autoOpenInspect",
                desc: "Open builder inspector sidebar on click."
            },
            {
                label: "Smart accordion",
                name: "pref.inspector.autoCloseAccordion",
                desc: "Auto close the other accordion field groups."
            }
        ]
    },
    {
        title: "Inputs",
        label: "Let the builder perform automatic adjustments based on your inputs.",
        options: [
            {
                label: "Round up values",
                name: "pref.values.roundUp",
                desc: "Automatic round up pixel based values to the nearest half (.5) value."
            },
            {
                label: "Auto switch screen state",
                name: "pref.values.bpSwitch",
                desc: "When clicking on an element inside a different breakpoint screen, set the variant to that breakpoint."
            }
        ]
    },
    {
        title: "Layers",
        label: "The builder layers display your current design components in parent-child relations. It can be found in the second tab of the sub navbar.",
        options: [
            {
                label: "Auto open layers",
                name: "pref.layers.autoOpenLayers",
                desc: "Layers expand automatic."
            },
            {
                label: "Show component icons",
                name: "pref.layers.showIcons",
                desc: "Display the component icons of each layer."
            },
            {
                label: "Unfocus non-selected",
                name: "pref.layers.unfocus",
                desc: "Make the components that are not hovered or related to the inspected component less visible."
            },
            {
                label: "Highlight inspected group",
                name: "pref.layers.highlightGroup",
                desc: "Highlight the container of the inspected component."
            }
        ]
    }
];
var BuilderPreferences = function(param) {
    var site = param.site, loading = param.loading, update = param.update, _compact = param.compact, compact = _compact === void 0 ? false : _compact;
    return builder.map(function(group) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Columns/* TwoColumns */.VZ, {
            mt: compact ? 0 : OFFSET,
            first: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                title: group === null || group === void 0 ? void 0 : group.title,
                label: group === null || group === void 0 ? void 0 : group.label
            }),
            second: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms_PreferencesForm/* PreferencesForm */.w, {
                fields: group === null || group === void 0 ? void 0 : group.options
            })
        }, group === null || group === void 0 ? void 0 : group.title);
    });
};
var DashboardPreferences = function(param) {
    var site = param.site, loading = param.loading, update = param.update, _compact = param.compact, compact = _compact === void 0 ? false : _compact;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* TwoColumns */.VZ, {
            first: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                title: "Mosanic UI"
            }),
            second: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms_PreferencesForm/* PreferencesForm */.w, {
                fields: [
                    {
                        label: "Disable dashboard",
                        name: "pref.dashboard.disable",
                        desc: "When disabled, you will auto redirect to one of your sites ."
                    }
                ]
            })
        })
    });
};
var CollectionsPreferences = function(param) {
    var site = param.site, loading = param.loading, update = param.update, _compact = param.compact, compact = _compact === void 0 ? false : _compact;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(TwoColumns, {
            first: /*#__PURE__*/ _jsx(Header, {
                title: "Collections",
                label: " Get emails to find out what's going on around Mosanic and its features. You can turn these off if you want. "
            }),
            second: /*#__PURE__*/ _jsx(PreferencesForm, {
                fields: [
                    {
                        label: "Auto save",
                        name: "pref.helpers.autoCloseAccordion",
                        desc: "Auto close the inspector accordion field groups."
                    },
                    {
                        label: "Tips and tours",
                        desc: "Show small tips and tours on new features."
                    }
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/items/Block.js
var Block = __webpack_require__(57389);
// EXTERNAL MODULE: ./src/mosanic/items/LoadingDots.tsx
var LoadingDots = __webpack_require__(4093);
// EXTERNAL MODULE: ./src/mosanic/items/Control/ControlButtons.js + 1 modules
var ControlButtons = __webpack_require__(11743);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
;// CONCATENATED MODULE: ./src/mosanic/core/Account/Preferences.js



















var defaultPref = {
    "theme": null,
    "sidebar": {
        "transparent": false,
        "compact": false
    },
    "helpers": {
        "tooltips": true,
        "intro": true,
        "headers": true,
        "autoCloseAccordion": true,
        "autoOpenLayers": true,
        "autoOpenInspect": true
    },
    "email": {
        "news-update": true,
        "tips-tutorial": true,
        "beta": true,
        "reminders": true,
        "direct": true,
        "comments": true
    },
    "privacy": {
        "public": true,
        "length": true,
        "messages": true,
        "email": true,
        "lastLogin": true,
        "status": true
    }
};
var UserPreferences = function(param) {
    var _overwrite = param.overwrite, overwrite = _overwrite === void 0 ? {
        interface: true,
        help: true,
        privacy: true,
        builder: true,
        dashboard: true,
        mail: true,
        platformName: "Mosanic"
    } : _overwrite;
    var ref;
    var o = overwrite;
    var name = o.platformName || "Mosanic";
    var router = (0,next_router.useRouter)();
    var hasGeneral = o.interface || o.help;
    var ref1 = (0,react.useState)(hasGeneral ? "general" : "privacy"), main = ref1[0], setMain = ref1[1];
    var ref2 = (0,react.useState)(null), init = ref2[0], setInit = ref2[1];
    var _id = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useUser/* useUser */.a)({
        _id: _id
    }), 3), user = ref3[0], loading = ref3[1], error = ref3[2];
    var methods = (0,index_esm/* useForm */.cI)({
        mode: "all",
        defaultValues: user
    });
    var firstName = user.firstName, lastName = user.lastName, subscription = user.subscription;
    var defaultState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods.watch()), {
        pref: defaultPref
    });
    var resetToDefault = function() {
        return methods.reset(defaultState);
    };
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useUpdateUser/* useUpdateUser */.I)(), 4), update = ref4[0], dataUpdate = ref4[1], loadingUpdate = ref4[2], errorUpdate = ref4[3];
    var updateAccount = function(updatedUser) {
        return update({
            _id: _id,
            user: updatedUser
        });
    };
    (0,react.useEffect)(function() {
        if ((user === null || user === void 0 ? void 0 : user.pref) && init != _id) {
            methods.reset(user);
            setInit(_id);
            if (!(0,Obj/* hasAttr */.B$)(user, "pref", "lastLogin") && (user === null || user === void 0 ? void 0 : user._id)) {
                resetToDefault();
                updateAccount(defaultState);
            }
        }
    }, [
        user,
        _id,
        init
    ]);
    var tabs = (ref = [
        {
            value: "general",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* Component1Icon */.JMc, {}),
            render: hasGeneral && /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneralPreferences, {
                ui: o.interface,
                help: o.help,
                name: name
            })
        },
        {
            value: "privacy",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* LockClosedIcon */.khe, {}),
            render: o.privacy && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPreferences, {
                name: name
            })
        },
        {
            value: "builder",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* DashboardIcon */.QGC, {}),
            render: o.builder && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderPreferences, {
                name: name
            })
        },
        {
            value: "dashboard",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* BarChartIcon */.eJP, {}),
            render: o.dashboard && /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardPreferences, {
                name: name
            })
        },
        {
            value: "mail",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* EnvelopeOpenIcon */.a4p, {}),
            render: o.mail && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailPreferences, {
                name: name
            })
        },
        {
            value: "all",
            label: "View all",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* EyeOpenIcon */.hsE, {})
        }
    ]) === null || ref === void 0 ? void 0 : ref.filter(function(t) {
        return t === null || t === void 0 ? void 0 : t.render;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlButtons/* ControlTabs */.i, {
                active: main,
                setActive: setMain,
                size: "large",
                my: 4,
                options: tabs.map(function(t) {
                    return (0,_object_spread/* default */.Z)({
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: (0,Text/* capitalizeFirst */.Ez)(t.value)
                        })
                    }, t);
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    mt: "1",
                    ghost: true,
                    small: true,
                    force: true,
                    tooltip: {
                        title: "Reset preferences",
                        wrap: true
                    },
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ResetIcon */.X5P, {}),
                    onClick: function() {
                        return resetToDefault();
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* Block */.gO, {
                py: 4,
                children: [
                    loading,
                    error,
                    tabs.map(function(t) {
                        return (main === "all" || main === t.value) && (t === null || t === void 0 ? void 0 : t.render);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Buttons, {
                        style: {
                            float: "right",
                            marginRight: "5%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                label: "Cancel",
                                type: "submit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                mr: 0,
                                theme: "primary",
                                label: loadingUpdate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : "Save changes",
                                onClick: function() {
                                    return updateAccount(methods.watch());
                                }
                            })
                        ]
                    })
                ]
            }),
            errorUpdate
        ]
    }));
};


/***/ }),

/***/ 23830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ UserSecurity; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/adapters/token.js + 1 modules
var token = __webpack_require__(94645);
// EXTERNAL MODULE: ./src/mosanic/components/User/useUser.js
var useUser = __webpack_require__(12107);
// EXTERNAL MODULE: ./src/mosanic/components/User/Handlers/useUpdateUser.js
var useUpdateUser = __webpack_require__(93548);
// EXTERNAL MODULE: ./src/mosanic/components/User/Handlers/useDeleteUser.js
var useDeleteUser = __webpack_require__(86466);
// EXTERNAL MODULE: ./src/mosanic/components/User/Handlers/usePasswordValidation.js
var usePasswordValidation = __webpack_require__(29134);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/fields/Form/FormItems.js
var FormItems = __webpack_require__(56185);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/items/ErrorAlert.js
var ErrorAlert = __webpack_require__(83482);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ../../node_modules/axios/index.js
var axios = __webpack_require__(89644);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/items/Expander/index.js + 1 modules
var Expander = __webpack_require__(56957);
// EXTERNAL MODULE: ./src/mosanic/items/Page/Columns.js
var Columns = __webpack_require__(60630);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
;// CONCATENATED MODULE: ./src/mosanic/components/User/SecurityUser.js




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        color: #999;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    padding: 5px;\n    font-size: 14px;\n    display: flex;\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    max-height: 20px;\n    max-width: 20px;    \n    min-height: 20px;\n    min-width: 20px; \n    display: inline-block;\n    margin-right: 10px;\n    padding: 0 2.5px;\n    overflow: hidden;\n    border-radius: 15px;\n    background: ",
        ";\n    svg {\n        margin-top: -4px;\n        path {\n            fill: #fff;\n        }\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var ListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-5e3f7e09-0"
})(_templateObject1(), function(props) {
    return props.valid && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Status = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e3f7e09-1"
})(_templateObject2(), function(props) {
    return props.valid ? colors/* default.util.bright.green */.ZP.util.bright.green : colors/* default.util.bright.red */.ZP.util.bright.red;
});
var list = function(txt) {
    return {
        match: "Passwords match",
        length: "At least 8 characters (".concat(txt === null || txt === void 0 ? void 0 : txt.length, ")"),
        lower: "Lower case letters (a-z)",
        higher: "Upper case letters (A-Z)",
        number: "Contains a number (0-9)",
        special: "A special character (!@#$%&*)"
    };
};
var SecurityUser = function(param) {
    var user = param.user, Validations = param.Validations, errorMessage = param.errorMessage;
    var ref = (0,index_esm/* useFormContext */.Gc)({
        mode: "all",
        defaultValues: user
    }), handleSubmit = ref.handleSubmit, control = ref.control, watch = ref.watch, reset = ref.reset, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        errors: errors
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItems/* FormItems */.G, {
                controls: inputProps,
                fields: [
                    {
                        name: "password",
                        label: "New password",
                        type: "password",
                        disabled: true,
                        fullWidth: true
                    },
                    {
                        name: "repeat_password",
                        label: "Repeat password",
                        disabled: true,
                        type: "password",
                        fullWidth: true
                    }
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroupItem */.oV, {
                fullWidth: true,
                children: errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert/* ErrorAlert */.h, {
                    errorMessage: errorMessage
                })
            })
        ]
    });
};
var useClientNetwork = function() {
    var ref = (0,react.useState)({}), info = ref[0], setInfo = ref[1];
    var getData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return axios_default().get("https://geolocation-db.com/json/");
                    case 2:
                        res = _ctx.sent;
                        console.log(res.data);
                        setInfo(res.data);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        //passing getData method to the lifecycle method
        getData();
    }, []);
    return info;
};
var useClientInfo = function() {
    var ref = (0,react.useState)({}), info = ref[0], setInfo = ref[1];
    var update = function(data) {
        return setInfo((0,_object_spread/* default */.Z)({}, info, data));
    };
    (0,react.useEffect)(function() {
        var ref;
        if (typeof navigator === "undefined") return null;
        var base = {
            nVer: navigator === null || navigator === void 0 ? void 0 : navigator.appVersion,
            appName: navigator.appName,
            nAgt: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
            userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
            browserName: navigator === null || navigator === void 0 ? void 0 : navigator.appName,
            fullVersion: "" + parseFloat(navigator === null || navigator === void 0 ? void 0 : navigator.appVersion),
            majorVersion: parseInt(navigator === null || navigator === void 0 ? void 0 : navigator.appVersion, 10),
            platform: (navigator === null || navigator === void 0 ? void 0 : (ref = navigator.userAgentData) === null || ref === void 0 ? void 0 : ref.platform) || "Windows"
        };
        var nameOffset, verOffset, ix;
        // In Opera, the true version is after "OPR" or after "Version"
        if ((verOffset = base.nAgt.indexOf("OPR")) != -1) {
            base.browserName = "Opera";
            base.fullVersion = base.nAgt.substring(verOffset + 4);
            if ((verOffset = base.nAgt.indexOf("Version")) != -1) base.fullVersion = base.nAgt.substring(verOffset + 8);
        } else if ((verOffset = base.nAgt.indexOf("Edg")) != -1) {
            base.browserName = "Microsoft Edge";
            base.fullVersion = base.nAgt.substring(verOffset + 4);
        } else if ((verOffset = base.nAgt.indexOf("MSIE")) != -1) {
            browserName = "Microsoft Internet Explorer";
            fullVersion = base.nAgt.substring(verOffset + 5);
        } else if ((verOffset = base.nAgt.indexOf("Chrome")) != -1) {
            base.browserName = "Chrome";
            base.fullVersion = base.nAgt.substring(verOffset + 7);
        } else if ((verOffset = base.nAgt.indexOf("Safari")) != -1) {
            base.browserName = "Safari";
            base.fullVersion = base.nAgt.substring(verOffset + 7);
            if ((verOffset = base.nAgt.indexOf("Version")) != -1) base.fullVersion = base.nAgt.substring(verOffset + 8);
        } else if ((verOffset = base.nAgt.indexOf("Firefox")) != -1) {
            base.browserName = "Firefox";
            base.fullVersion = base.nAgt.substring(verOffset + 8);
        } else if ((nameOffset = base.nAgt.lastIndexOf(" ") + 1) < (verOffset = base.nAgt.lastIndexOf("/"))) {
            base.browserName = base.nAgt.substring(nameOffset, verOffset);
            base.fullVersion = base.nAgt.substring(verOffset + 1);
            if (browserName.toLowerCase() == browserName.toUpperCase()) {
                base.browserName = navigator.appName;
            }
        }
        // trim the fullVersion string at semicolon/space if present
        if ((ix = base.fullVersion.indexOf(";")) != -1) base.fullVersion = base.fullVersion.substring(0, ix);
        if ((ix = base.fullVersion.indexOf(" ")) != -1) base.fullVersion = base.fullVersion.substring(0, ix);
        base.majorVersion = parseInt("" + base.fullVersion, 10);
        if (isNaN(base.majorVersion)) {
            base.fullVersion = "" + parseFloat(navigator.appVersion);
            base.majorVersion = parseInt(navigator.appVersion, 10);
        }
        update(base);
    }, []);
    return info;
};
var RenderClientInfo = function() {
    var ref = useClientInfo(), browserName1 = ref.browserName, fullVersion1 = ref.fullVersion, appName = ref.appName, platform = ref.platform, userAgent = ref.userAgent;
    var ref1 = useClientNetwork(), IPv4 = ref1.IPv4, city = ref1.city, country_name = ref1.country_name, state = ref1.state;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Expander/* default */.Z, {
        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
            m: 0,
            ghost: true,
            label: " Client info",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* DesktopIcon */.ugZ, {})
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                my: 2,
                label: "To maintain the reliability and security of Mosanic we track the incoming connections to the platform."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* TwoColumns */.VZ, {
                first: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                            label: "Browser name",
                            value: browserName1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                            label: "Version",
                            value: fullVersion1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                            label: "App name",
                            value: appName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                            label: "User IP",
                            value: IPv4
                        })
                    ]
                }),
                second: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                            label: "User os",
                            value: platform || "Windows"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                            label: "Location",
                            value: "".concat(country_name, " - ").concat(city)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                            label: "User agent",
                            value: userAgent
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    });
};

// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
;// CONCATENATED MODULE: ./src/mosanic/components/User/TwoFactorAuth.js





var formatInterval = function(v) {
    var interval = parseFloat((0,Text/* getNumberPartOfString */.kr)(v));
    if ((0,Text/* containsSubstr */.xX)(v, "d")) return "".concat(interval, " day").concat(interval != 1 ? "s" : "");
    if ((0,Text/* containsSubstr */.xX)(v, "m")) return "".concat(interval, " month").concat(interval != 1 ? "s" : "");
    if ((0,Text/* containsSubstr */.xX)(v, "y")) return "".concat(interval, " year").concat(interval != 1 ? "s" : "");
    return v;
};
var TwoFactorAuth = function(param) {
    var handler = param.handler, _updating = param.updating, updating = _updating === void 0 ? false : _updating, user = param.user;
    var ref = (0,index_esm/* useFormContext */.Gc)({
        mode: "all",
        defaultValues: user
    }), handleSubmit = ref.handleSubmit, control = ref.control, watch = ref.watch, reset = ref.reset, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        errors: errors
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItems/* FormItems */.G, {
            controls: inputProps,
            fields: [
                {
                    name: "security.two-factor",
                    label: "Two factor enabled",
                    desc: "Verify your login with your email.",
                    type: "switch",
                    value: true,
                    disabled: true
                },
                {
                    name: "security.interval",
                    label: "Verify interval",
                    desc: "Change the interval of your two-factor authentication verification.",
                    type: "select",
                    options: "instant|1d|2d|7d|14d|1m|3m|6m|1y".split("|").map(function(value) {
                        return {
                            value: value,
                            label: formatInterval(value)
                        };
                    })
                }
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/mosanic/core/Notifications/DeleteConfirm.js
var DeleteConfirm = __webpack_require__(37676);
// EXTERNAL MODULE: ./src/mosanic/fields/TextField/Fields.js
var Fields = __webpack_require__(91639);
// EXTERNAL MODULE: ./src/mosanic/items/LoadingDots.tsx
var LoadingDots = __webpack_require__(4093);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/mosanic/items/Page/DashCard.js
var DashCard = __webpack_require__(69756);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
;// CONCATENATED MODULE: ./src/mosanic/core/Account/Security.js





















var UserSecurity = function(param) {
    var _overwrite = param.overwrite, overwrite = _overwrite === void 0 ? {
        twoStepsVerification: true,
        passwordText: "Your password and login to your account and manage your sites."
    } : _overwrite;
    var ref, ref1;
    var methods = (0,index_esm/* useForm */.cI)({
        mode: "all"
    });
    var isAuth = (0,token/* isAuthenticated */.$8)();
    var _id = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useUser/* useUser */.a)({
        _id: _id
    }), 3), user = ref2[0], loading = ref2[1], error = ref2[2];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useDeleteUser/* useDeleteUser */.F)(), 4), deleteAccount = ref3[0], dataDelete = ref3[1], loadingDelete = ref3[2], errorDelete = ref3[3];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useUpdateUser/* useUpdateUser */.I)(), 4), update = ref4[0], dataUpdate = ref4[1], loadingUpdate = ref4[2], errorUpdate = ref4[3];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useUpdateUser/* useUpdatePassword */.U)(), 4), updatePassword = ref5[0], dataPass = ref5[1], loadingPass = ref5[2], errorPass = ref5[3];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,usePasswordValidation/* usePasswordValidation */.g)({
        password: (ref = methods.watch()) === null || ref === void 0 ? void 0 : ref.password,
        repeat_password: (ref1 = methods.watch()) === null || ref1 === void 0 ? void 0 : ref1.repeat_password
    }), 3), errorMessage = ref6[0], Validations = ref6[1], strength = ref6[2];
    var ref7 = (0,react.useState)(null), confirm = ref7[0], setConfirm = ref7[1];
    var ref8 = (0,react.useState)(null), prevPassword = ref8[0], setPrevPassword = ref8[1];
    var cancelConfirm = function() {
        return setConfirm(false);
    };
    var handleSubmit = function(prev) {
        if (methods.watch().repeat_password && !errorMessage) {
            if (!prev) setConfirm(true);
            else {
                var ref;
                updatePassword({
                    _id: user === null || user === void 0 ? void 0 : user._id,
                    password: (ref = methods.watch()) === null || ref === void 0 ? void 0 : ref.password,
                    oldPassword: prevPassword
                });
                update({
                    _id: user === null || user === void 0 ? void 0 : user._id,
                    user: (0,_object_spread/* default */.Z)({}, user, methods.watch())
                });
                setConfirm(false);
            }
        } else {
            update({
                _id: user === null || user === void 0 ? void 0 : user._id,
                user: (0,_object_spread/* default */.Z)({}, user, methods.watch())
            });
        }
    };
    var ref9 = (0,react.useState)(false), accountDeleteModal = ref9[0], setAccountDeleteModal = ref9[1];
    var dispatchDeleteAction = function() {
        deleteAccount({
            _id: _id,
            user: user
        });
    };
    (0,react.useEffect)(function() {
        var ref;
        if ((user === null || user === void 0 ? void 0 : user._id) != ((ref = methods === null || methods === void 0 ? void 0 : methods.watch()) === null || ref === void 0 ? void 0 : ref._id)) {
            methods.reset((0,_object_spread/* default */.Z)({}, user));
        }
    }, [
        methods,
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
            children: [
                loading,
                error,
                isAuth && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DashCard/* default */.Z, {
                            header: "Password",
                            label: overwrite.passwordText,
                            help: "Note that once you save these changes an confirm with your old account password will be asked.",
                            render: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityUser, {
                                user: user,
                                errorMessage: errorMessage,
                                Validations: Validations
                            })
                        }),
                        (overwrite === null || overwrite === void 0 ? void 0 : overwrite.twoStepsVerification) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DashCard/* default */.Z, {
                            mt: 5,
                            header: "2-step verification",
                            label: "Protect your Mosanic account by enabling an extra layer of security when you log in with an email and password.",
                            help: "This security is enabled by default, you can turn it only off if your password is longer than 10 characters.",
                            render: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoFactorAuth, {
                                user: user
                            })
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DashCard/* default */.Z, {
                            mt: 10,
                            header: "Terminate your account",
                            label: "This action is irreversible, all of your data will be deleted.",
                            help: "⚠️ Your data will be deleted within 31 days, just make sure to check the consequences. Got a question? Contact us.",
                            render: /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                    label: "Yes, continue.",
                                    small: true,
                                    ghost: true
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Button, {
                                    ghost: true,
                                    onClick: function() {
                                        return setAccountDeleteModal(true);
                                    },
                                    ml: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TrashIcon */.XHJ, {}),
                                        " Delete account"
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderClientInfo, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Buttons, {
                            style: {
                                float: "right",
                                marginRight: "5%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                    label: "Cancel",
                                    type: "submit"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                    disabled: errorMessage,
                                    mr: 0,
                                    theme: "primary",
                                    label: loadingPass || loadingUpdate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : "Save changes",
                                    onClick: handleSubmit
                                })
                            ]
                        }),
                        errorUpdate || errorPass,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                            state: confirm,
                            close: cancelConfirm,
                            size: "xs",
                            title: "Confirm password",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                    helpText: "Can't remember your previous password? Please contact support@mosanic.io",
                                    span: true,
                                    children: "Confirm your password change by entering your previous password. Note that this action will be applied instantly if you've entered your previous password correct."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                                    wrap: true,
                                    fullWidth: true,
                                    label: "Previous password",
                                    type: "password",
                                    size: "large",
                                    onChange: function(e) {
                                        return setPrevPassword(e.target.value);
                                    },
                                    value: prevPassword
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Buttons, {
                                    mt: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                            ghost: true,
                                            label: "Cancel",
                                            onClick: function() {
                                                return cancelConfirm;
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                            ghost: true,
                                            label: "Confirm",
                                            disabled: !prevPassword || (prevPassword === null || prevPassword === void 0 ? void 0 : prevPassword.length) <= 6,
                                            theme: "primary",
                                            onClick: function() {
                                                return handleSubmit(prevPassword);
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteConfirm/* DeleteConfirm */.y, {
                            action: dispatchDeleteAction,
                            actionState: loadingDelete || dataDelete,
                            validateLabel: "email",
                            validateValue: user === null || user === void 0 ? void 0 : user.email,
                            header: "About to delete your account.",
                            message: "We're sad to see your go. Continue below if you really want to delete your Mosanic account. Note that it will take up-to 31 days to fully remove all of your data. ",
                            state: accountDeleteModal,
                            close: function() {
                                return setAccountDeleteModal(false);
                            }
                        })
                    ]
                })
            ]
        }))
    });
};


/***/ }),

/***/ 61641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pS": function() { return /* binding */ BreakpointsList; },
/* harmony export */   "sr": function() { return /* binding */ ItemList; }
/* harmony export */ });
/* unused harmony exports useBreakpoints, ControlBreakpoints */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_items_List__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62035);
/* harmony import */ var _redux_breakpoints_reducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95746);
/* harmony import */ var _redux_screens_action__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21398);
/* harmony import */ var _redux_screens_reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45260);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);
/* harmony import */ var src_components_Builder_Util_getBreakpointIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31879);











var useBreakpoints = function() {
    var ref, ref1;
    var breakpoint = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_screens_reducer__WEBPACK_IMPORTED_MODULE_2__/* .currentBpSelector */ .Xr);
    var activeBreakpoints = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_breakpoints_reducer__WEBPACK_IMPORTED_MODULE_3__/* .getBreakpointsSelector */ .Pg);
    var breakpoints = (ref1 = (ref = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(activeBreakpoints)) === null || ref === void 0 ? void 0 : ref.reverse()) === null || ref1 === void 0 ? void 0 : ref1.filter(function(bp) {
        return (bp === null || bp === void 0 ? void 0 : bp._id) != "base";
    });
    return [
        breakpoints,
        breakpoint
    ];
};
var BreakpointsList = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var setBp = function(bp) {
        return dispatch((0,_redux_screens_action__WEBPACK_IMPORTED_MODULE_5__/* .setScreenBpAction */ .L4)({
            bp: bp
        }));
    };
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(useBreakpoints(), 2), breakpoints = ref[0], breakpoint = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_7__/* .List */ .aV, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ItemList, {
            items: breakpoints,
            active: breakpoint,
            handle: function(bp) {
                return setBp(bp === null || bp === void 0 ? void 0 : bp._id);
            },
            label: function(bp) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_7__/* .ListItemIcon */ .Q$, {
                            style: {
                                width: "20px",
                                display: "inline-block"
                            },
                            children: (0,src_components_Builder_Util_getBreakpointIcon__WEBPACK_IMPORTED_MODULE_8__/* .getBreakpointIcon */ .N)(bp === null || bp === void 0 ? void 0 : bp._id, false)
                        }),
                        bp === null || bp === void 0 ? void 0 : bp.name
                    ]
                });
            }
        })
    });
};
var ControlBreakpoints = function(param) {
    var trigger = param.trigger;
    return /*#__PURE__*/ _jsx(ControlPopper, {
        trigger: trigger,
        children: /*#__PURE__*/ _jsx(BreakpointsList, {})
    });
};
var ItemList = function(param) {
    var items = param.items, active = param.active, label = param.label, handle = param.handle;
    return items ? items.map(function(item) {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_7__/* .ListItem */ .HC, {
            active: (item === null || item === void 0 ? void 0 : item._id) === active,
            onClick: function() {
                return handle(item);
            },
            children: label(item)
        }, item === null || item === void 0 ? void 0 : item._id);
    }) : null;
};


/***/ }),

/***/ 35702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ih": function() { return /* binding */ ControlDevices; },
  "KT": function() { return /* binding */ getDeviceSize; }
});

// UNUSED EXPORTS: DevicesList, devices

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ./src/mosanic/constants/devices.js
var desktops = {
    'iMac 24"': "1800 x 1152",
    "iMac": "1280 x 720",
    'MacBook Pro 16"': "1536 x 960",
    "MacBook Pro": "1440 x 900",
    "MacBook": "1152 x 700",
    "Surface Book": "1500 x 1000",
    "Desktop": "1440 x 1024"
};
var phones = {
    "iPhone 14 Pro Max": "428 x 928",
    "iPhone 14 Pro": "393 x 852",
    // 'iPhone 14': '390 x 844',
    // 'iPhone 12 Pro Max': '428 x 926',
    // 'iPhone 12 Pro': '390 x 844',
    // 'iPhone 11 Pro Max': '414 x 896',
    // 'iPhone 11 Pro / X': '375 x 812',
    "iPhone 8 Plus": "414 x 736",
    "iPhone 8": "375 x 667",
    "iPhone SE": "320 x 568",
    "Galaxy Note 5": "480 x 853",
    "Google Pixel 3": "412 x 824",
    "Android": "304 x 555"
};
var tablets = {
    "iPad Pro 12.9": "1024 x 1366",
    "iPad Pro": "834 x 1194",
    "iPad mini": "768 x 1024",
    "Surface Pro 4": "1368 x 912",
    "Surface Pro 3": "1440 x 990"
};

// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Popper.js + 4 modules
var Popper = __webpack_require__(28932);
// EXTERNAL MODULE: ./src/mosanic/items/List/List.js + 2 modules
var List = __webpack_require__(62035);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(87567);
// EXTERNAL MODULE: ./src/features/screens/action.js
var action = __webpack_require__(21398);
// EXTERNAL MODULE: ./src/features/screens/reducer.js
var reducer = __webpack_require__(45260);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/mosanic/core/Breakpoints/useBreakpoints.js
var useBreakpoints = __webpack_require__(61641);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
;// CONCATENATED MODULE: ./src/mosanic/core/Breakpoints/useDevices.js


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: flex;\n    justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var Space = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98974197-0"
})(_templateObject());
var devices = {
    desktop: desktops,
    tablet: tablets,
    phone: phones
};
var getDeviceSize = function(device) {
    var ref;
    var size = devices === null || devices === void 0 ? void 0 : (ref = devices[device === null || device === void 0 ? void 0 : device.type]) === null || ref === void 0 ? void 0 : ref[device === null || device === void 0 ? void 0 : device.device];
    if (!size) return null;
    size = size === null || size === void 0 ? void 0 : size.split("x");
    return {
        maxWidth: parseFloat(size[0]),
        maxHeight: parseFloat(size[1])
    };
};
var DevicesList = function(param) {
    var devices = param.devices, device = param.device, type = param.type;
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var setDevice = function(device) {
        return dispatch((0,action/* setScreenDeviceAction */.Yk)({
            device: {
                type: type,
                device: device
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.aV, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useBreakpoints/* ItemList */.sr, {
            items: (ref = Object.entries(devices)) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _id = _param[0], size = _param[1];
                return {
                    size: size,
                    _id: _id
                };
            }),
            active: device,
            handle: function(device) {
                return setDevice(device === null || device === void 0 ? void 0 : device._id);
            },
            label: function(device) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Space, {
                    children: [
                        device === null || device === void 0 ? void 0 : device._id,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                device === null || device === void 0 ? void 0 : device.size,
                                " "
                            ]
                        })
                    ]
                });
            }
        })
    });
};
var ControlDevices = function(param) {
    var _trigger = param.trigger, trigger = _trigger === void 0 ? null : _trigger;
    var device = (0,es/* useSelector */.v9)(reducer/* currentDeviceSelector */.vk);
    var ref = (0,react.useState)(device === null || device === void 0 ? void 0 : device.type), type = ref[0], setType = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: trigger,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                trigger: trigger,
                width: 250,
                children: children
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* ButtonGroup */.h, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* ButtonGroup.Choices */.h.Choices, {
                    options: Object.keys(devices).map(function(value) {
                        return {
                            label: value === (device === null || device === void 0 ? void 0 : device.type) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: (0,Text/* capitalizeFirst */.Ez)(value)
                            }) : (0,Text/* capitalizeFirst */.Ez)(value),
                            value: value
                        };
                    }),
                    value: type,
                    handler: function(t) {
                        return setType(t);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DevicesList, {
                devices: devices[type],
                device: device === null || device === void 0 ? void 0 : device.device,
                type: type
            })
        ]
    });
};


/***/ }),

/***/ 44032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ AddCollection; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/mosanic/cms/Mutate/useDataMutate.js
var useDataMutate = __webpack_require__(39656);
// EXTERNAL MODULE: ./src/mosanic/fields/Select/Select.js + 3 modules
var Select = __webpack_require__(26074);
// EXTERNAL MODULE: ./src/mosanic/fields/Switch/index.js + 2 modules
var Switch = __webpack_require__(9441);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/items/LoadingDots.tsx
var LoadingDots = __webpack_require__(4093);
// EXTERNAL MODULE: ./src/mosanic/items/Control/ControlButtons.js + 1 modules
var ControlButtons = __webpack_require__(11743);
// EXTERNAL MODULE: ./src/mosanic/items/List/List.js + 2 modules
var List = __webpack_require__(62035);
// EXTERNAL MODULE: ./src/mosanic/styles/grid.styles.js
var grid_styles = __webpack_require__(67324);
// EXTERNAL MODULE: ./src/mosanic/utils/ObjectID.js
var ObjectID = __webpack_require__(56831);
// EXTERNAL MODULE: ./src/mosanic/utils/collections.js
var collections = __webpack_require__(12778);
// EXTERNAL MODULE: ./src/mosanic/utils/Image.js
var Image = __webpack_require__(73987);
// EXTERNAL MODULE: ./src/mosanic/_Fieldsets.js
var _Fieldsets = __webpack_require__(28585);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/index.js
var Input = __webpack_require__(6928);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/mosanic/components/Pages/Resolvers/usePages.js
var usePages = __webpack_require__(67431);
;// CONCATENATED MODULE: ./src/mosanic/core/Collections/BaseCollection.js











var BaseCollection = function(param) {
    var _dataType = param.dataType, dataType = _dataType === void 0 ? "collection" : _dataType;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,index_esm/* useFormContext */.Gc)(), handleSubmit = ref4.handleSubmit, control = ref4.control, watch = ref4.watch, _formState = ref4.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors,
        wrap: true
    };
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    var pages = (0,usePages/* usePages */.Q)({
        siteId: siteId,
        pagesOnly: true
    });
    var example = dataType === "collection" ? "User cards are shown in the contact page" : "Main footer contact form";
    dataType = ((ref = watch()) === null || ref === void 0 ? void 0 : ref.type) || dataType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                cols: 2,
                border: true,
                label: "".concat((0,Text/* capitalizeFirst */.Ez)(dataType), " info"),
                mt: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        name: "title",
                        label: "".concat(dataType, " name"),
                        type: "text"
                    }, inputProps), {
                        required: true,
                        rules: {
                            required: "Shorthand name that defines this ".concat(dataType)
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        name: "description",
                        label: "Description",
                        type: "textarea"
                    }, inputProps), {
                        required: true,
                        rules: {
                            required: "Explain the purpose of this ".concat(dataType, " and give some context. For example, ").concat(example)
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        name: "singular",
                        label: "Singular entry name",
                        type: "text"
                    }, inputProps), {
                        required: true,
                        rules: {
                            required: 'How should we call a single entry. For example, articles collection => "Article"'
                        }
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                name: "type",
                label: "Collection type",
                type: "buttonGroup",
                options: "collection|form".split("|")
            }, inputProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                cols: 2,
                border: true,
                label: dataType === "form" ? "Form options" : "Routing",
                style: {
                    paddingTop: 5,
                    marginTop: 25
                },
                children: [
                    dataType === "collection" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "catchRoutes",
                                label: "Catch routes",
                                type: "switch"
                            }, inputProps), {
                                fullWidth: false
                            }), "catchRoutes"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "frontEnd",
                                label: "Front end",
                                type: "switch"
                            }, inputProps), {
                                disabled: !((ref1 = watch()) === null || ref1 === void 0 ? void 0 : ref1.catchRoutes),
                                fullWidth: false
                            }), "frontEnd")
                        ]
                    }),
                    "here",
                    ((ref2 = watch()) === null || ref2 === void 0 ? void 0 : ref2.catchRoutes) && dataType === "collection" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "sss",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "baseRoute",
                                label: "Base route"
                            }, inputProps), {
                                type: "text",
                                fullWidth: false
                            }), "baseRoute"),
                            "ss",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "dynamicPage",
                                label: "Dynamic page",
                                type: "select"
                            }, inputProps), {
                                options: (pages === null || pages === void 0 ? void 0 : pages.length) >= 1 ? pages.map(function(p) {
                                    return {
                                        label: p.title,
                                        value: p._id
                                    };
                                }) : [
                                    "No pages setup"
                                ],
                                fullWidth: false
                            }), "dynamicPage"),
                            ((ref3 = watch()) === null || ref3 === void 0 ? void 0 : ref3.frontEnd) && dataType === "collection" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        name: "editRoute",
                                        label: "Edit route",
                                        type: "text"
                                    }, inputProps), {
                                        fullWidth: false
                                    }), "editRoute"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        name: "editPage",
                                        label: "Edit page",
                                        type: "select"
                                    }, inputProps), {
                                        options: (pages === null || pages === void 0 ? void 0 : pages.length) >= 1 ? pages.map(function(p) {
                                            return {
                                                label: p.title,
                                                value: p._id
                                            };
                                        }) : [
                                            "No pages setup"
                                        ],
                                        fullWidth: false
                                    }), "editPage")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "groupPage",
                                label: "Index page",
                                type: "select"
                            }, inputProps), {
                                options: (pages === null || pages === void 0 ? void 0 : pages.length) >= 1 ? pages.map(function(p) {
                                    return {
                                        label: p.title,
                                        value: p._id
                                    };
                                }) : [
                                    "No pages setup"
                                ],
                                fullWidth: false
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "notFoundPage",
                                label: "404 page",
                                type: "select"
                            }, inputProps), {
                                options: (pages === null || pages === void 0 ? void 0 : pages.length) >= 1 ? pages.map(function(p) {
                                    return {
                                        label: p.title,
                                        value: p._id
                                    };
                                }) : [
                                    "No pages setup"
                                ],
                                fullWidth: false
                            }))
                        ]
                    }),
                    dataType === "form" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "stepType",
                                label: "Stepper flow",
                                helpText: "Each field is displayed in a separate step. To combine fields in a step, use a group field.",
                                type: "switch"
                            }, inputProps), {
                                fullWidth: false
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                name: "form.data",
                                label: "Auto delete",
                                type: "select",
                                options: "7 days|14 days|1 month|3 months|6 months|fill-up".split("|")
                            }, inputProps), {
                                fullWidth: false
                            }))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                name: "limit",
                label: dataType === "collection" ? "Limit entries" : "Limit is defined by membership package",
                type: "number",
                disabled: dataType != "collection"
            }, inputProps))
        ]
    });
};

// EXTERNAL MODULE: ./src/mosanic/core/Collections/Entry.js + 3 modules
var Entry = __webpack_require__(69491);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/FieldsCollection.js + 10 modules
var FieldsCollection = __webpack_require__(61101);
// EXTERNAL MODULE: ./src/mosanic/fields/Source/helpers.js
var helpers = __webpack_require__(49272);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/useCreateCollection.js
var useCreateCollection = __webpack_require__(30611);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/useUpdateCollection.js
var useUpdateCollection = __webpack_require__(36414);
;// CONCATENATED MODULE: ./src/mosanic/core/Collections/AddCollection.js




























var Item = function(param) {
    var item = param.item;
    /*#__PURE__*/ return _jsxs("div", {
        children: [
            item === null || item === void 0 ? void 0 : item.id,
            " x"
        ]
    });
};
var AddCollection = function(param) {
    var _initial = param.initial, initial = _initial === void 0 ? null : _initial, _type = param.type, type = _type === void 0 ? "create" : _type, _redirect = param.redirect, redirect = _redirect === void 0 ? true : _redirect, _callback = param.callback, callback = _callback === void 0 ? null : _callback, _dataType = param.dataType, dataType = _dataType === void 0 ? "collection" : _dataType;
    var ref, ref1, ref2, ref3;
    var methods = (0,index_esm/* useForm */.cI)({
        mode: "all",
        defaultValues: initial
    });
    var collection = methods.watch();
    var schema = collection === null || collection === void 0 ? void 0 : collection.schema;
    var convertFields = function() {
        var select = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            "name",
            "text",
            "textarea"
        ];
        var ref, ref1;
        return (0,_Fieldsets/* addUnset */.fN)((ref1 = collection === null || collection === void 0 ? void 0 : (ref = collection.schema) === null || ref === void 0 ? void 0 : ref.filter(function(f) {
            return select.includes(f === null || f === void 0 ? void 0 : f.type);
        })) === null || ref1 === void 0 ? void 0 : ref1.map(function(f) {
            return {
                value: f === null || f === void 0 ? void 0 : f.name,
                label: "".concat(f.name, " [").concat(f.type, "]")
            };
        }));
    };
    var ref4 = (0,react.useState)({
        title: schema === null || schema === void 0 ? void 0 : (ref = schema[0]) === null || ref === void 0 ? void 0 : ref.name,
        description: schema === null || schema === void 0 ? void 0 : (ref1 = schema[0]) === null || ref1 === void 0 ? void 0 : ref1.name,
        image: null,
        slug: true
    }), convert = ref4[0], setConvert = ref4[1];
    var isValid = methods.formState.isValid;
    var ref5 = (0,react.useState)(false), disabled = ref5[0], setDisabled = ref5[1];
    var ref6 = (0,react.useState)(false), init = ref6[0], setInit = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useCreateCollection/* useCreateCollection */.$)({
        redirect: redirect,
        dataType: dataType
    }), 2), addCollection = ref7[0], ref8 = (0,_sliced_to_array/* default */.Z)(ref7[1], 3), data = ref8[0], loading = ref8[1], error = ref8[2];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useUpdateCollection/* useUpdateCollection */.v)({
        callback: callback
    }), 2), update = ref9[0], ref10 = (0,_sliced_to_array/* default */.Z)(ref9[1], 3), dataUpdate = ref10[0], loadingUpdate = ref10[1], errorUpdate = ref10[2];
    var ref11 = (0,react.useState)(false), saving = ref11[0], setSaving = ref11[1];
    var ref12 = (0,react.useState)(null), progress = ref12[0], setProgress = ref12[1];
    var ref13 = (0,react.useState)([
        null
    ]), ids = ref13[0], setIds = ref13[1];
    //Converting method
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useDataMutate/* useCreate */.RO)({
        callback: function(id) {
            setProgress("Converting: ".concat(id));
            setIds(function(ids) {
                return (0,_to_consumable_array/* default */.Z)(ids).concat([
                    id
                ]);
            });
        }
    }), 2), addEntry = ref14[0], addEntryMethods = ref14[1];
    var onSubmit = function(data) {
        if ((0,Obj/* hasAttr */.B$)(data, "preventDefault")) data === null || data === void 0 ? void 0 : data.preventDefault();
        if (mode === "transform") return;
        if (!saving) return;
        setDisabled(true);
        if (type === "create") {
            addCollection({
                collection: data
            });
        } else {
            update({
                collection: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                    linked: undefined,
                    baseFields: convert
                })
            });
        }
        setDisabled(false);
        setSaving(false);
    };
    var triggerSave = function() {
        setSaving(true);
        if (mode === "transform") {
            var ref;
            setProgress("Starting transformation.");
            setIds([]);
            collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.forEach(function(entry, i) {
                addEntry({
                    data: (0,collections/* createUpdateEntry */.XW)({
                        title: (0,helpers/* getEntryLabel */.ax)(entry, schema),
                        description: entry === null || entry === void 0 ? void 0 : entry[convert === null || convert === void 0 ? void 0 : convert.description],
                        slug: (convert === null || convert === void 0 ? void 0 : convert.slug) && (0,Text/* slugify */.lV)((0,helpers/* getEntryLabel */.ax)(entry, [
                            {
                                name: convert === null || convert === void 0 ? void 0 : convert.title
                            }
                        ])),
                        image: (convert === null || convert === void 0 ? void 0 : convert.image) && (entry === null || entry === void 0 ? void 0 : entry[convert === null || convert === void 0 ? void 0 : convert.image]),
                        seo: (convert === null || convert === void 0 ? void 0 : convert.slug) && {
                            title: (0,helpers/* getEntryLabel */.ax)(entry, schema),
                            description: entry === null || entry === void 0 ? void 0 : entry[convert === null || convert === void 0 ? void 0 : convert.description]
                        },
                        date: entry === null || entry === void 0 ? void 0 : entry.date,
                        data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, entry), {
                            date: undefined,
                            updatedAt: undefined,
                            _id: undefined
                        }),
                        siteId: collection === null || collection === void 0 ? void 0 : collection.siteId,
                        collectionId: collection === null || collection === void 0 ? void 0 : collection._id
                    })
                });
            });
            setTimeout(function() {
                setProgress("Updating collection.");
                update({
                    collection: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collection), {
                        entries: ids
                    })
                });
                setTimeout(function() {
                    return setProgress("Finished.");
                }, 750);
            }, 750);
        } else {
            methods.handleSubmit(onSubmit);
        }
    };
    (0,react.useEffect)(function() {
        if (initial || init || type != "create") {
            methods === null || methods === void 0 ? void 0 : methods.reset(initial);
            return;
        }
        ;
        methods.reset({
            schema: [
                {
                    type: "text",
                    id: (0,ObjectID/* ObjectID */.t)(),
                    name: "",
                    help: "",
                    default: "",
                    required: true
                }
            ]
        });
        setInit(true);
    }, [
        init,
        methods,
        initial,
        type
    ]);
    var ref15 = (0,react.useState)("base"), mode = ref15[0], setMode = ref15[1];
    //form-row mb-3
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlButtons/* ControlTabs */.i, {
                active: mode,
                setActive: setMode,
                lines: 2,
                mx: 3,
                mb: 4,
                options: [
                    {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Collection base information"
                        }),
                        value: "base",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* Component1Icon */.JMc, {})
                    },
                    {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                "Preview ",
                                dataType,
                                " fields"
                            ]
                        }),
                        value: "preview",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* EyeOpenIcon */.hsE, {})
                    },
                    {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Edit fields styling"
                        }),
                        value: "styling",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* BlendingModeIcon */.EGi, {})
                    },
                    (collection === null || collection === void 0 ? void 0 : collection.linked) && {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Base fields"
                        }),
                        value: "entry",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* InputIcon */.SQj, {})
                    },
                    !(0,Text/* isString */.HD)(collection === null || collection === void 0 ? void 0 : (ref2 = collection.entries) === null || ref2 === void 0 ? void 0 : ref2[0]) && !(collection === null || collection === void 0 ? void 0 : collection.linked) && {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Transform"
                        }),
                        value: "transform",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* RocketIcon */.WCv, {})
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                disabled: disabled || type === "preview",
                onSubmit: methods.handleSubmit(onSubmit),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid_styles/* Wrap */.Eq, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid_styles/* Col */.JX, {
                            width: [
                                1,
                                1 / 2
                            ],
                            px: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
                                    children: mode === "transform" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                                as: "h4",
                                                label: "Transform collection ",
                                                span: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedLabel/* AdvancedLabel */.qv, {
                                                mb: 4,
                                                children: [
                                                    "Once submitted all the entries will be converted to separate files. ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "This way more data can be saved inside of them. ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " Note that this action is irreversible."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                                as: "h5",
                                                label: "Setup the entry data",
                                                span: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                                                children: [
                                                    [
                                                        "title",
                                                        "description"
                                                    ].map(function(field) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Select.Select, {
                                                            wrap: true,
                                                            options: convertFields(),
                                                            label: field,
                                                            value: convert === null || convert === void 0 ? void 0 : convert[field],
                                                            onChange: function(val) {
                                                                return setConvert((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, convert), (0,_define_property/* default */.Z)({}, field, val)));
                                                            }
                                                        });
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select.Select, {
                                                        wrap: true,
                                                        options: convertFields([
                                                            "image"
                                                        ]),
                                                        label: "image",
                                                        value: convert === null || convert === void 0 ? void 0 : convert.image,
                                                        onChange: function(val) {
                                                            return setConvert((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, convert), {
                                                                "image": val
                                                            }));
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                                                        wrap: true,
                                                        label: "Slugify",
                                                        checked: convert === null || convert === void 0 ? void 0 : convert.slug,
                                                        onChange: function() {
                                                            return setConvert((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, convert), {
                                                                slug: !(convert === null || convert === void 0 ? void 0 : convert.slug)
                                                            }));
                                                        }
                                                    })
                                                ]
                                            }),
                                            addEntryMethods === null || addEntryMethods === void 0 ? void 0 : addEntryMethods[2],
                                            progress
                                        ]
                                    }) : mode === "entry" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                                as: "h4",
                                                label: "Change base fields",
                                                span: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                                mb: 4,
                                                children: "Select the base fields of this collection"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                                                children: [
                                                    [
                                                        "title",
                                                        "description"
                                                    ].map(function(field) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Select.Select, {
                                                            wrap: true,
                                                            options: convertFields(),
                                                            label: field,
                                                            value: convert === null || convert === void 0 ? void 0 : convert[field],
                                                            onChange: function(val) {
                                                                return setConvert((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, convert), (0,_define_property/* default */.Z)({}, field, val)));
                                                            }
                                                        });
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select.Select, {
                                                        wrap: true,
                                                        options: convertFields([
                                                            "image"
                                                        ]),
                                                        label: "image",
                                                        value: convert === null || convert === void 0 ? void 0 : convert.image,
                                                        onChange: function(val) {
                                                            return setConvert((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, convert), {
                                                                "image": val
                                                            }));
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                                                        wrap: true,
                                                        label: "Slugify",
                                                        checked: convert === null || convert === void 0 ? void 0 : convert.slug,
                                                        onChange: function() {
                                                            return setConvert((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, convert), {
                                                                slug: !(convert === null || convert === void 0 ? void 0 : convert.slug)
                                                            }));
                                                        }
                                                    })
                                                ]
                                            }),
                                            addEntryMethods === null || addEntryMethods === void 0 ? void 0 : addEntryMethods[2],
                                            progress
                                        ]
                                    }) : mode === "base" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseCollection, {
                                        dataType: dataType
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Entry/* Entry */.k, {
                                        collection: collection,
                                        initial: null,
                                        type: "preview"
                                    })
                                }),
                                error,
                                errorUpdate
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_styles/* Col */.JX, {
                            width: [
                                1,
                                1 / 2
                            ],
                            px: 2,
                            children: mode === "transform" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                        as: "h4",
                                        label: " Entries"
                                    }),
                                    JSON.stringify(ids),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.aV, {
                                        children: collection === null || collection === void 0 ? void 0 : (ref3 = collection.entries) === null || ref3 === void 0 ? void 0 : ref3.map(function(entry, index) {
                                            var ref;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(List/* ListItem */.HC, {
                                                style: {
                                                    display: "flex"
                                                },
                                                children: [
                                                    (convert === null || convert === void 0 ? void 0 : convert.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: (ref = (0,Image/* parseImageSrc */.yO)(entry === null || entry === void 0 ? void 0 : entry[convert === null || convert === void 0 ? void 0 : convert.image], true)) === null || ref === void 0 ? void 0 : ref.full,
                                                        width: "35px",
                                                        height: "20px",
                                                        alt: "preview"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            paddingLeft: "5px"
                                                        },
                                                        children: [
                                                            (0,helpers/* getEntryLabel */.ax)(entry, schema),
                                                            (convert === null || convert === void 0 ? void 0 : convert.slug) && " > ".concat((0,Text/* slugify */.lV)((0,helpers/* getEntryLabel */.ax)(entry, [
                                                                {
                                                                    name: convert === null || convert === void 0 ? void 0 : convert.title
                                                                }
                                                            ]))),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            (convert === null || convert === void 0 ? void 0 : convert.description) != (convert === null || convert === void 0 ? void 0 : convert.title) && (entry === null || entry === void 0 ? void 0 : entry[convert === null || convert === void 0 ? void 0 : convert.description])
                                                        ]
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }) : mode === "styling" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                        as: "h4",
                                        label: "Coming soon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedLabel/* AdvancedLabel */.qv, {
                                        width: "70%",
                                        children: [
                                            "We're currently working on two ways to style your fields. ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "The first version will be released inside this module, where you will be able to setup general field styling. We will expand this in the near future and integrate it fully inside the builder, where you can drag an drop your input fields. ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "Stay tuned! ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "-The Mosanic Team"
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldsCollection/* FieldsCollection */.X, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                            label: loading || loadingUpdate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : mode === "transform" ? "Yes, transform" : type === "create" ? "Create ".concat(dataType) : "Update ".concat(dataType),
                            theme: "primary",
                            size: "large",
                            type: "submit",
                            disabled: Boolean(disabled || !isValid) && !error && type != "preview",
                            onClick: triggerSave
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var Collections_AddCollection = ((/* unused pure expression or super */ null && (AddCollection)));


/***/ }),

/***/ 35712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2921);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5441);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26021);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78545);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        opacity: 0.3;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    padding: 10px;\n    font-size: 12px;\n    transition: all ease-in-out 0.3s;\n    &:hover {\n        background: ",
        ";\n        cursor: pointer;\n    }\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    min-width: 100px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    text-align: right;\n    font-size: 10px;\n    min-width: 70px;\n    text-transform: upperCase;\n    padding: 0 5px;\n    opacity: 0.4;\n    cursor: s-resize;\n\n    svg {\n        transform: scale(0.9);\n        transform-origin: top left;\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    right: 0;\n    top: 15px;\n    min-width: 120px;\n    /* z-index: 2; */\n\n    button {\n        z-index: 2;\n        display: inline-block;\n    }\n\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        opacity: 0.2;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    /* padding: 15px 15px 20px 15px; */\n    display: inline-block;\n    cursor: ",
        "!important;\n    /* position: absolute;\n    text-align: right;\n    top: 0;\n    right:0;\n    bottom: 0; */\n    z-index: 0;\n    width: 40px;\n\n    &, svg, svg path {\n        transition: all ease-in-out 0.3s;\n    }\n    &:hover {\n        svg path {\n            transform: scale(1.5);\n            transform-origin: center center;\n        }\n    }\n    ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        background: ",
        ";\n\n        ",
        " svg {\n            transform: rotate(-180deg);\n        }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        background: ",
        ";\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        min-width: 90%;\n        padding: 0 0 0 10px;\n        margin-left: -10px;\n        background: ",
        ";\n        /* ",
        " {\n            position: absolute;\n            top: 0;\n        } */\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    position: relative;\n    transition: all ease-in-out 0.3s;\n    min-width: 100%;\n    padding: 0 0 0 10px;\n    height: 60px;\n    border-bottom: 1px solid ",
        ";\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n\n    ",
        "\n    &:hover {\n        background: ",
        ";\n    }\n\n    input {\n        /* z-index: 2; */\n    }\n\n    ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    position: relative;\n    \n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    padding: 0 0 20px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    color: ",
        ";\n    padding: 0 5px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    display: flex;\n    flex-wrap: wrap;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    opacity: 0.5;\n    overflow: hidden;\n    min-width: 120px;\n    text-align: left;\n    font-size: 12px;\n    cursor: pointer;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        border: 2px solid ",
        ";\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    position: relative;\n    width: 23%;\n    padding: 10px 10px;\n    text-align: center;\n    font-size: 12px;\n    ",
        "\n    margin: 10px 1%;\n    background: ",
        ";\n    border: ",
        ";\n    transition: all ease-in-out 0.3s;\n    border-radius: 5px;\n    flex-wrap: wrap;\n\n    ",
        "\n    :hover {\n        background: ",
        ";\n        transform: ",
        ";\n        cursor: pointer;\n    }\n    :active {\n        transform: scale(1);\n    }\n    div {\n        width: 100%;\n    }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}



var Button = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-e658c590-0"
})(_templateObject1(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.light */ .ZP.util.gray.light, function(props) {
    return props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
});
var HeaderField = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e658c590-1"
})(_templateObject2());
var HeaderType = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e658c590-2"
})(_templateObject3());
var FieldControls = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e658c590-3"
})(_templateObject4(), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
var HeaderToggle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(Button).withConfig({
    componentId: "sc-e658c590-4"
})(_templateObject6(), function(props) {
    return !props.expanded ? "s-resize" : "n-resize";
}, function(props) {
    return props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5());
});
var FieldHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e658c590-5"
})(_templateObject10(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.light */ .ZP.util.gray.light, function(props) {
    return props.expanded ? (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.lighter */ .ZP.util.gray.lighter, HeaderToggle) : (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.trans */ .ZP.util.gray.trans);
}, _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.lighter */ .ZP.util.gray.lighter, function(props) {
    return props.level && props.level >= 1 && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject9(), function(props) {
        return props.expanded ? _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.lighter */ .ZP.util.gray.lighter : "transparent";
    }, HeaderField);
});
var FieldEntry = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e658c590-6"
})(_templateObject11());
var FieldEntryFields = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e658c590-7"
})(_templateObject12());
//Field specific
var RelationLabel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-e658c590-8"
})(_templateObject13(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.primary.base */ .ZP.util.primary.base);
var FieldTypes = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e658c590-9"
})(_templateObject14());
var HeaderLabel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e658c590-10"
})(_templateObject15());
var FieldType = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e658c590-11"
})(_templateObject17(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* .CenterCenter */ .IV, function(props) {
    return props.coming ? _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.lightest */ .ZP.util.gray.lightest : "transparent";
}, function(props) {
    return props.coming ? "1px dashed ".concat(_mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.light */ .ZP.util.gray.light) : "none";
}, function(props) {
    return props.active && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject16(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.base */ .ZP.util.gray.base);
}, function(props) {
    return props.coming ? _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.trans */ .ZP.util.gray.trans : _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.lighter */ .ZP.util.gray.lighter;
}, function(props) {
    return props.coming ? "scale(0.9)" : "scale(1.1)";
});
var CollectionStyles = {
    Button: Button,
    FieldHeader: FieldHeader,
    HeaderField: HeaderField,
    HeaderType: HeaderType,
    HeaderLabel: HeaderLabel,
    HeaderToggle: HeaderToggle,
    FieldControls: FieldControls,
    FieldEntry: FieldEntry,
    FieldEntryFields: FieldEntryFields,
    RelationLabel: RelationLabel,
    FieldType: FieldType,
    FieldTypes: FieldTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionStyles);


/***/ }),

/***/ 90131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mq": function() { return /* binding */ useDataGridHandles; },
/* harmony export */   "Xy": function() { return /* binding */ DataGridModals; },
/* harmony export */   "Z1": function() { return /* binding */ GridOrderButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66383);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41145);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mosanic_core_Collections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36414);
/* harmony import */ var _mosanic_core_Collections__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69491);
/* harmony import */ var _mosanic_core_Notifications__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(37676);
/* harmony import */ var _fields_Source_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49272);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47914);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77298);













var useDataGridHandles = function(param) {
    var refreshData = param.refreshData;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_mosanic_core_Collections__WEBPACK_IMPORTED_MODULE_4__/* .useDeleteEntry */ .e)({
        refreshData: refreshData
    }), 1), handleDelete = ref[0];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        entry: null,
        deleteEntry: null,
        modal: false,
        sidebar: false,
        filters: {
            enabled: false
        },
        order: "desc"
    }), state = ref1[0], setState = ref1[1];
    var setFilters = function(filters) {
        return setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
            filters: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state.filters, filters)
        }));
    };
    var gridHandles = {
        open: function() {
            var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "modal";
            var _obj;
            return setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, type, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, "entry", null), _obj)));
        },
        edit: function(entry) {
            var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "modal";
            return setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                entry: entry
            }, type, true)));
        },
        delete: function(deleteEntry) {
            return setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                deleteEntry: deleteEntry
            }));
        },
        setFilters: setFilters
    };
    return {
        gridHandles: gridHandles,
        handles: {
            setState: setState,
            refreshData: refreshData,
            handleDelete: handleDelete,
            setFilters: setFilters,
            toggleFilters: function() {
                var ref;
                return setFilters({
                    enabled: !(state === null || state === void 0 ? void 0 : (ref = state.filters) === null || ref === void 0 ? void 0 : ref.enabled)
                });
            }
        },
        state: state
    };
};
var GridOrderButton = function(param) {
    var state = param.state, setState = param.setState;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_8__.Button, {
        label: " Order",
        icon: (state === null || state === void 0 ? void 0 : state.order) === "desc" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .ArrowDownIcon */ .veu, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .ArrowUpIcon */ .Hf3, {}),
        onClick: function() {
            return setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                order: (state === null || state === void 0 ? void 0 : state.order) === "desc" ? "asc" : "desc"
            }));
        }
    });
};
var getModalStates = function(param) {
    var collection = param.collection, state = param.state, handles = param.handles;
    var modal = state.modal, sidebar = state.sidebar, item = state.item, deleteEntry = state.deleteEntry;
    var setState = handles.setState, handleDelete = handles.handleDelete, refreshData = handles.refreshData;
    var editCreateState = {
        modal: modal,
        sidebar: sidebar,
        close: function() {
            return setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                sidebar: false,
                modal: false,
                item: null
            }));
        },
        switch: function() {
            return setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                sidebar: !(state === null || state === void 0 ? void 0 : state.sidebar),
                modal: !(state === null || state === void 0 ? void 0 : state.modal)
            }));
        },
        title: "".concat(!item ? "Create ".concat(collection === null || collection === void 0 ? void 0 : collection.singular) : "Update ".concat(collection === null || collection === void 0 ? void 0 : collection.singular, ": ").concat((0,_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_9__/* .getEntryLabel */ .ax)(item, collection === null || collection === void 0 ? void 0 : collection.schema)))
    };
    var deleteModalState = {
        header: "Delete ".concat(collection === null || collection === void 0 ? void 0 : collection.title, " entry"),
        message: "This action is irreversible.",
        state: deleteEntry,
        validateLabel: "",
        validateValue: (0,_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_9__/* .getEntryLabel */ .ax)(deleteEntry, collection === null || collection === void 0 ? void 0 : collection.schema),
        action: function() {
            handleDelete({
                collection: collection,
                entry: deleteEntry
            });
            setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                deleteEntry: null
            }));
            setTimeout(function() {
                refreshData();
            }, 1000);
        },
        close: function() {
            return setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                deleteEntry: null
            }));
        }
    };
    return [
        editCreateState,
        deleteModalState
    ];
};
var DataGridModals = function(param) {
    var collection = param.collection, state = param.state, handles = param.handles;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(getModalStates({
        collection: collection,
        state: state,
        handles: handles
    }), 2), editCreateState = ref[0], deleteModalState = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, editCreateState), {
                state: editCreateState === null || editCreateState === void 0 ? void 0 : editCreateState.modal,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_core_Collections__WEBPACK_IMPORTED_MODULE_11__/* .Entry */ .k, {
                    callback: handles.refreshData,
                    collection: collection,
                    initial: state === null || state === void 0 ? void 0 : state.item,
                    type: !(state === null || state === void 0 ? void 0 : state.item) ? "create" : "update"
                })
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_core_Notifications__WEBPACK_IMPORTED_MODULE_12__/* .DeleteConfirm */ .y, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, deleteModalState))
        ]
    });
};


/***/ }),

/***/ 69491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ Entry; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/mosanic/utils/collections.js
var collections = __webpack_require__(12778);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/mosanic/cms/Mutate/useDataMutate.js
var useDataMutate = __webpack_require__(39656);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/index.js
var Query = __webpack_require__(18780);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/useDataQuery.js
var useDataQuery = __webpack_require__(49974);
// EXTERNAL MODULE: ./src/mosanic/items/Spinner.js
var Spinner = __webpack_require__(36174);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/utils/collection.js
var utils_collection = __webpack_require__(69735);
// EXTERNAL MODULE: ./src/mosanic/utils/entry.js
var utils_entry = __webpack_require__(24730);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/i18n/SelectLocales.js
var SelectLocales = __webpack_require__(36072);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/items/LoadingDots.tsx
var LoadingDots = __webpack_require__(4093);
// EXTERNAL MODULE: ./src/mosanic/items/Expander/index.js + 1 modules
var Expander = __webpack_require__(56957);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/Input.js + 4 modules
var Input = __webpack_require__(84430);
// EXTERNAL MODULE: ./src/mosanic/utils/clone.js
var clone = __webpack_require__(32428);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ./src/mosanic/fields/Source/helpers.js
var helpers = __webpack_require__(49272);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/core/Page/PreviewDynamic.js
var PreviewDynamic = __webpack_require__(2562);
// EXTERNAL MODULE: ./src/mosanic/styles/grid.styles.js
var grid_styles = __webpack_require__(67324);
;// CONCATENATED MODULE: ./src/mosanic/core/Collections/PreviewEntry.js




var PreviewDynamicEntry = function(param) {
    var collection = param.collection, entry = param.entry, _preview = param.preview, preview = _preview === void 0 ? false : _preview, children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: preview && (collection === null || collection === void 0 ? void 0 : collection.baseRoute) && (collection === null || collection === void 0 ? void 0 : collection.dynamicPage),
        wrapper: function(children) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(grid_styles/* Wrap */.Eq, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_styles/* Col */.JX, {
                        width: [
                            1,
                            1 / 2
                        ],
                        pr: 4,
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_styles/* Col */.JX, {
                        width: [
                            1,
                            1 / 2
                        ],
                        pl: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewDynamic/* PreviewDynamicPage */.I, {
                            pageId: collection === null || collection === void 0 ? void 0 : collection.dynamicPage,
                            baseRoute: collection === null || collection === void 0 ? void 0 : collection.baseRoute,
                            entry: entry
                        })
                    })
                ]
            });
        },
        children: children
    });
};

// EXTERNAL MODULE: ./src/features/options/reducer.js + 1 modules
var options_reducer = __webpack_require__(51331);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
;// CONCATENATED MODULE: ./src/mosanic/core/Collections/EntryFields.js




















var EntryFields = function(param) {
    var collection = param.collection, schema = param.schema, initial = param.initial, onSubmit = param.onSubmit, type = param.type, dataType = param.dataType, loading = param.loading, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _formDisabled = param.formDisabled, formDisabled = _formDisabled === void 0 ? false : _formDisabled, _hideDisabled = param.hideDisabled, hideDisabled = _hideDisabled === void 0 ? false : _hideDisabled, _inputGroup = param.inputGroup, inputGroup = _inputGroup === void 0 ? {
        border: false,
        label: null,
        cols: 1
    } : _inputGroup, _preview = param.preview, preview = _preview === void 0 ? false : _preview, _hideMeta = param.hideMeta, hideMeta = _hideMeta === void 0 ? true : _hideMeta, _submitTrigger = param.submitTrigger, submitTrigger = _submitTrigger === void 0 ? null : _submitTrigger, _smallSubmit = param.smallSubmit, smallSubmit = _smallSubmit === void 0 ? false : _smallSubmit, _schemaButtons = param.schemaButtons, schemaButtons = _schemaButtons === void 0 ? null : _schemaButtons, _replaceRouter = param.replaceRouter, replaceRouter = _replaceRouter === void 0 ? false : _replaceRouter;
    var ref, ref1, ref2;
    var primaryField = schema === null || schema === void 0 ? void 0 : (ref = schema[0]) === null || ref === void 0 ? void 0 : ref.name;
    var hasLocalizedFields = schema === null || schema === void 0 ? void 0 : schema.find(function(s) {
        return s === null || s === void 0 ? void 0 : s.localized;
    });
    //Language support
    var router = (0,next_router.useRouter)();
    var locales = router.locales, locale = router.locale, path = router.asPath;
    var ref3 = (0,react.useState)(locale), activeLang = ref3[0], setActiveLan = ref3[1];
    var setLang = function(lang, replaceRouter) {
        setActiveLan(lang);
        if (replaceRouter) router.push(path, path, {
            locale: lang,
            shallow: true
        });
    };
    var ref4 = (0,index_esm/* useForm */.cI)({
        mode: "all"
    }), handleSubmit = ref4.handleSubmit, control = ref4.control, watch = ref4.watch, reset = ref4.reset, _formState = ref4.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        errors: errors,
        fullWidth: true,
        preview: preview
    };
    //Reset handling
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (initial && (((ref = watch()) === null || ref === void 0 ? void 0 : ref[primaryField]) != (initial === null || initial === void 0 ? void 0 : initial[primaryField]) || (initial === null || initial === void 0 ? void 0 : initial._id) != ((ref1 = watch()) === null || ref1 === void 0 ? void 0 : ref1._id))) {
            reset((0,_object_spread/* default */.Z)({}, initial));
        }
    }, [
        initial,
        primaryField,
        watch
    ]);
    var userId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetUser */.pg)({
        _id: userId
    }), 1), user = ref5[0];
    var devMode = (0,es/* useSelector */.v9)(options_reducer/* getDevModePrefSelector */.Lj);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewDynamicEntry, {
        collection: collection,
        preview: preview,
        entry: watch(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            disabled: formDisabled,
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectLocales/* SelectLocales */.I, {
                    locales: hasLocalizedFields ? locales : null,
                    active: activeLang,
                    setActive: setLang
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    fullWidth: true,
                    style: {
                        width: "100%"
                    }
                }, inputGroup), {
                    children: collection === null || collection === void 0 ? void 0 : (ref1 = collection.schema) === null || ref1 === void 0 ? void 0 : ref1.map(function(field, index) {
                        return !(field === null || field === void 0 ? void 0 : field.name) ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* LocalizedInput */.TY, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            disabled: disabled,
                            locales: locales,
                            locale: locale,
                            activeLang: activeLang,
                            hideDisabled: hideDisabled,
                            name: field === null || field === void 0 ? void 0 : field.name,
                            label: (0,Text/* revertDevCases */.Uw)((0,Text/* isString */.HD)(field === null || field === void 0 ? void 0 : field.label) ? field.label : field === null || field === void 0 ? void 0 : field.name),
                            type: field === null || field === void 0 ? void 0 : field.type,
                            // value={field?.default} 
                            field: field,
                            help: field === null || field === void 0 ? void 0 : field.help,
                            options: (0,helpers/* getFieldOptions */._K)(field),
                            multiple: field === null || field === void 0 ? void 0 : field.multiple,
                            relation: (0,helpers/* getFieldRelation */.nj)(field),
                            schema: (0,helpers/* shouldPassSchema */.Eu)(field) ? collection.schema : null,
                            data: (0,helpers/* shouldPassData */.wg)(field) ? watch() : null,
                            preview: preview
                        }, inputProps), {
                            fullWidth: (field === null || field === void 0 ? void 0 : field.fullWidth) ? field.fullWidth : false
                        }));
                    })
                })),
                Boolean((((ref2 = schemaButtons === null || schemaButtons === void 0 ? void 0 : schemaButtons.filter(function(b) {
                    return (b === null || b === void 0 ? void 0 : b.action) === type;
                })) === null || ref2 === void 0 ? void 0 : ref2.length) >= 1 || type === "preview") && !submitTrigger) ? null : submitTrigger ? (0,clone/* extendClone */.j)({
                    type: "submit"
                }, submitTrigger) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    width: smallSubmit ? null : [
                        1,
                        "100%"
                    ],
                    style: {
                        margin: "20px 0 0 0"
                    },
                    label: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : dataType === "global" ? "Update" : type === "create" ? "Add entry" : "Update entry",
                    theme: "primary",
                    size: smallSubmit ? "small" : "large",
                    type: "submit",
                    disabled: loading || !isValid || type === "preview"
                }),
                (user === null || user === void 0 ? void 0 : user.isAdmin) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                        label: "Admin controls",
                        ghost: true,
                        style: {
                            minWidth: "100%"
                        },
                        m: 0
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                        border: true,
                        label: "Admin controls",
                        mb: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.II, (0,_object_spread/* default */.Z)({
                                type: "user",
                                name: "userId"
                            }, inputProps)),
                            !hideMeta && type != "create" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
                                border: true,
                                label: "Admin controls",
                                mb: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                        label: "Entry meta",
                                        ghost: true,
                                        fullWidth: true,
                                        width: smallSubmit ? null : [
                                            1,
                                            "100%"
                                        ],
                                        style: {
                                            margin: "0 0 10px 0"
                                        }
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InlineGroup */.a_, {
                                        style: {
                                            flexWrap: "wrap"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                                                label: "Entry id",
                                                value: initial === null || initial === void 0 ? void 0 : initial._id
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                                                label: "Entry author",
                                                value: initial === null || initial === void 0 ? void 0 : initial.userId
                                            }),
                                            (initial === null || initial === void 0 ? void 0 : initial.collectionId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* Label */.__, {
                                                label: "Collection ID",
                                                value: initial === null || initial === void 0 ? void 0 : initial.collectionId
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/mosanic/core/Collections/EntryMails.js
var EntryMails = __webpack_require__(3237);
// EXTERNAL MODULE: ./src/mosanic/cms/Mutate/update.js
var Mutate_update = __webpack_require__(80581);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/many.js + 1 modules
var many = __webpack_require__(43551);
// EXTERNAL MODULE: ./src/mosanic/fields/Code/PreviewCode.js
var PreviewCode = __webpack_require__(59389);
;// CONCATENATED MODULE: ./src/mosanic/core/Collections/EntryTriggers.js







var useEntryTriggers = function(param) {
    var state = param.state, setState = param.setState, entry = param.entry, trigger = param.trigger;
    var ref = (0,_sliced_to_array/* default */.Z)((0,Mutate_update/* useUpdateUser */.Io)(), 2), update = ref[0], ref1 = (0,_sliced_to_array/* default */.Z)(ref[1], 2), d = ref1[0], loading = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,many/* useGetUsers */.w4)({
        filter: {
            OR: Array.isArray(trigger) ? trigger === null || trigger === void 0 ? void 0 : trigger.map(function(t) {
                return {
                    _id: t === null || t === void 0 ? void 0 : t.userId
                };
            }) : null
        }
    }), 2), users = ref2[0], load = ref2[1];
    var getParsed = (0,react.useCallback)(function() {
        return Array.isArray(trigger) ? trigger === null || trigger === void 0 ? void 0 : trigger.map(function(t) {
            var user = Array.isArray(users) ? users === null || users === void 0 ? void 0 : users.find(function(u) {
                return u._id === (t === null || t === void 0 ? void 0 : t.userId);
            }) : null;
            return (0,PreviewCode/* parseCode */.zY)(t === null || t === void 0 ? void 0 : t.code, {
                user: user,
                entry: entry
            }, false);
        }) : [];
    }, [
        entry,
        trigger,
        users
    ]);
    (0,react.useEffect)(function() {
        if ((users === null || users === void 0 ? void 0 : users.length) >= 1 && !load && !(state === null || state === void 0 ? void 0 : state.updated) && trigger && Array.isArray(trigger)) {
            var ref;
            var parsed = getParsed();
            if (parsed && (parsed === null || parsed === void 0 ? void 0 : parsed.length) >= 1 && ((ref = parsed === null || parsed === void 0 ? void 0 : parsed.filter(function(i) {
                return i;
            })) === null || ref === void 0 ? void 0 : ref.length) >= 1) {
                parsed === null || parsed === void 0 ? void 0 : parsed.map(function(user) {
                    update({
                        data: user
                    });
                });
                setState(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        updated: "users"
                    });
                });
            }
        }
    }, [
        entry,
        getParsed,
        load,
        setState,
        state,
        trigger,
        update,
        users
    ]);
    return loading ? loading ? load : load : "Updated users";
};

;// CONCATENATED MODULE: ./src/mosanic/core/Collections/Entry.js



















var Entry = function(param) {
    var collection = param.collection, _initial = param.initial, initial = _initial === void 0 ? null : _initial, _type = param.type, type = _type === void 0 ? "create" : _type, _hideDisabled = param.hideDisabled, hideDisabled = _hideDisabled === void 0 ? false : _hideDisabled, _callback = param.callback, callback = _callback === void 0 ? null : _callback, _hideMeta = param.hideMeta, hideMeta = _hideMeta === void 0 ? false : _hideMeta, _preview = param.preview, preview = _preview === void 0 ? false : _preview, _dataType = param.dataType, dataType = _dataType === void 0 ? "collection" : _dataType, _submitTrigger = param.submitTrigger, submitTrigger = _submitTrigger === void 0 ? null : _submitTrigger, _cols = param.cols, cols = _cols === void 0 ? 2 : _cols, _label = param.label, label = _label === void 0 ? null : _label, _border = param.border, border = _border === void 0 ? false : _border, handler = param.handler, _replaceRouter = param.replaceRouter, replaceRouter = _replaceRouter === void 0 ? false : _replaceRouter, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _page_props = param.page_props, page_props = _page_props === void 0 ? null : _page_props;
    var ref;
    var ref1 = (0,react.useState)({
        step: type,
        data: null
    }), state = ref1[0], setState = ref1[1];
    var userId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var isCreate = Boolean(type === "create");
    //Schema fields
    var schema = collection === null || collection === void 0 ? void 0 : collection.schema;
    var schemaButtons = (0,utils_collection/* getFields */.V)(schema, "button");
    var schemaUsers = (0,utils_collection/* getFields */.V)(schema, "user");
    var loggedInCreation = schemaUsers === null || schemaUsers === void 0 ? void 0 : schemaUsers.filter(function(u) {
        return (u === null || u === void 0 ? void 0 : u.userId) || (u === null || u === void 0 ? void 0 : u.isAuthor);
    });
    //Update handling
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useDataMutate/* useCreate */.RO)({
        callback: callback
    }), 2), createEntry = ref2[0], ref3 = (0,_sliced_to_array/* default */.Z)(ref2[1], 3), c_data = ref3[0], c_loading = ref3[1], c_error = ref3[2];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useDataMutate/* useUpdate */.PQ)({
        callback: callback
    }), 2), updateEntry = ref4[0], ref5 = (0,_sliced_to_array/* default */.Z)(ref4[1], 3), c_update_data = ref5[0], c_update_loading = ref5[1], c_update_error = ref5[2];
    var ref6 = (0,_sliced_to_array/* default */.Z)(handler ? handler({
        callback: callback,
        collection: collection
    }) : [
        function() {
            return null;
        },
        [
            null,
            false,
            null
        ]
    ], 2), action = ref6[0], ref7 = (0,_sliced_to_array/* default */.Z)(ref6[1], 3), data = ref7[0], loading = ref7[1], error = ref7[2];
    var siteId = (0,Query/* useSiteId */.CG)();
    (0,react.useEffect)(function() {
        if (c_data === null || c_data === void 0 ? void 0 : c_data.recordId) {
            setState(function(state) {
                var ref, ref1, ref2, ref3, ref4;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    step: "continue",
                    mail: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.mail), {
                        entry: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state === null || state === void 0 ? void 0 : (ref = state.mail) === null || ref === void 0 ? void 0 : ref.entry), {
                            slug: (state === null || state === void 0 ? void 0 : (ref1 = state.mail) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.entry) === null || ref2 === void 0 ? void 0 : ref2.slug) ? state === null || state === void 0 ? void 0 : (ref3 = state.mail) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.entry) === null || ref4 === void 0 ? void 0 : ref4.slug : c_data === null || c_data === void 0 ? void 0 : c_data.recordId,
                            _id: c_data === null || c_data === void 0 ? void 0 : c_data.recordId
                        })
                    })
                });
            });
        } else {}
    }, [
        c_data
    ]);
    var onSubmit = function(data) {
        if (handler) {
            action({
                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                    userId: (data === null || data === void 0 ? void 0 : data.userId) ? data.userId : userId,
                    siteId: siteId,
                    short_description: undefined
                })
            });
        } else if (type === "create") {
            var ref, ref1;
            schemaUsers === null || schemaUsers === void 0 ? void 0 : schemaUsers.map(function(u) {
                if ((u === null || u === void 0 ? void 0 : u.userId) || (u === null || u === void 0 ? void 0 : u.isAuthor)) {
                    data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), (0,_define_property/* default */.Z)({}, u.name, userId));
                }
            });
            //Convert data
            data = (0,utils_entry/* replaceEntryPageProps */.NH)({
                entry: data,
                schema: schema,
                pageProps: page_props
            });
            data = (0,utils_entry/* setDefaultEntryValues */.Sq)({
                entry: data,
                schema: schema
            });
            //Validate triggers
            var creation = schemaButtons === null || schemaButtons === void 0 ? void 0 : schemaButtons.find(function(b) {
                return b.action === "create";
            });
            var hasUserTriggers = (creation === null || creation === void 0 ? void 0 : creation.enableUser) && (creation === null || creation === void 0 ? void 0 : (ref = creation.trigger) === null || ref === void 0 ? void 0 : (ref1 = ref.users) === null || ref1 === void 0 ? void 0 : ref1.length) >= 1;
            var hasMailTriggers = (creation === null || creation === void 0 ? void 0 : creation.enableMail) && (creation === null || creation === void 0 ? void 0 : creation.mailId) && (creation === null || creation === void 0 ? void 0 : creation.mailTemplate);
            createEntry({
                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,useDataQuery/* convertEntryBack */.Qb)(data, schema)), {
                    date: new Date(),
                    collectionId: collection === null || collection === void 0 ? void 0 : collection._id,
                    siteId: (collection === null || collection === void 0 ? void 0 : collection.siteId) ? collection === null || collection === void 0 ? void 0 : collection.siteId : siteId,
                    userId: userId ? userId : "999"
                })
            });
            setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                data: data,
                hasUserTriggers: hasUserTriggers,
                hasMailTriggers: hasMailTriggers,
                step: "loading",
                trigger: !hasUserTriggers ? null : creation.trigger.users.filter(function(t) {
                    return (t === null || t === void 0 ? void 0 : t.code) && (t === null || t === void 0 ? void 0 : t.userId);
                }).map(function(trigger) {
                    return {
                        userId: data === null || data === void 0 ? void 0 : data[trigger.userId],
                        code: trigger.code
                    };
                }),
                mail: !hasMailTriggers ? null : {
                    mailId: creation.mailId,
                    template: creation.mailTemplate,
                    entry: (0,useDataQuery/* convertEntryBack */.Qb)(data, schema)
                }
            }));
        }
        if ((collection === null || collection === void 0 ? void 0 : collection.linked) && false) {}
        return;
        if (isCreate) {
            entry = (0,collections/* createNewEntry */.oz)(entry, userId);
            data = (0,collections/* addEntry */.px)(collection, entry);
        } else {
            entry = (0,collections/* createUpdateEntry */.XW)(entry);
            data = updateEntry(collection, entry);
        }
    };
    var canRenderEntry = Boolean((loggedInCreation === null || loggedInCreation === void 0 ? void 0 : loggedInCreation.length) === 0 || (loggedInCreation === null || loggedInCreation === void 0 ? void 0 : loggedInCreation.length) >= 1 && userId || disabled);
    var triggers = useEntryTriggers({
        state: state,
        setState: setState,
        trigger: state === null || state === void 0 ? void 0 : state.trigger,
        collection: collection,
        entry: state === null || state === void 0 ? void 0 : state.data
    });
    var mails = (0,EntryMails/* useEntryMails */.$)({
        state: state,
        setState: setState,
        mail: state === null || state === void 0 ? void 0 : state.mail,
        collection: collection
    });
    (0,react.useEffect)(function() {
        if (triggers && mails) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    checks: [
                        triggers,
                        mails
                    ]
                });
            });
        }
    }, [
        mails,
        triggers
    ]);
    // 		{JSON.stringify(parsedMail)}
    // <br/><br/><br/><br/>
    // <pre>
    // 		{JSON.stringify(parsed, undefined, 4)}
    return canRenderEntry ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            c_loading,
            c_error,
            loading,
            error,
            [
                "create",
                "update"
            ].includes(state.step) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryFields, {
                collection: collection,
                initial: initial,
                onSubmit: onSubmit,
                schema: schema,
                loading: loading,
                disabled: disabled,
                formDisabled: loading || type === "preview",
                hideDisabled: hideDisabled,
                inputGroup: {
                    label: label,
                    border: border,
                    cols: cols
                },
                preview: preview,
                schemaButtons: schemaButtons,
                replaceRouter: replaceRouter,
                smallSubmit: dataType === "global" || type === "preview",
                submitTrigger: submitTrigger,
                hideMeta: hideMeta,
                type: type,
                dataType: dataType
            }) : ((state === null || state === void 0 ? void 0 : state.trigger) && !(state === null || state === void 0 ? void 0 : state.updated) || (state === null || state === void 0 ? void 0 : state.mail) && !(state === null || state === void 0 ? void 0 : state.send)) && ((state === null || state === void 0 ? void 0 : state.hasMailTriggers) || (state === null || state === void 0 ? void 0 : state.hasUserTriggers)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    textAlign: "center",
                    width: "100%"
                },
                children: [
                    submitTrigger ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                        mt: 4,
                        as: "h6",
                        label: "Submission is successfully send"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                        as: "h4",
                        label: "".concat(type === "create" ? "Created" : "Updated", " ").concat(collection === null || collection === void 0 ? void 0 : collection.singular)
                    }),
                    ((state === null || state === void 0 ? void 0 : state.hasMailTriggers) || (state === null || state === void 0 ? void 0 : state.hasUserTriggers)) && (state === null || state === void 0 ? void 0 : (ref = state.checks) === null || ref === void 0 ? void 0 : ref.map(function(point) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                            as: "p",
                            style: {
                                position: "relative"
                            },
                            children: point
                        });
                    }))
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};


/***/ }),

/***/ 3237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useEntryMails; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _mosanic_cms_Query_byId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62357);
/* harmony import */ var _mosanic_components_Mail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16956);
/* harmony import */ var _mosanic_utils_mail__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96346);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68311);








var useEntryMails = function(param) {
    var mail = param.mail, collection = param.collection, state = param.state, setState = param.setState;
    var ref, ref1;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_mosanic_components_Mail__WEBPACK_IMPORTED_MODULE_2__/* .useSendOne */ .x)(), 3), sendMail = ref2[0], sendData = ref2[1], sendLoading = ref2[2];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_mosanic_cms_Query_byId__WEBPACK_IMPORTED_MODULE_3__/* .useGetMail */ .bC)({
        _id: mail === null || mail === void 0 ? void 0 : mail.mailId,
        silent: true
    }), 2), mail_data = ref3[0], loading = ref3[1];
    var template = mail_data === null || mail_data === void 0 ? void 0 : (ref = mail_data.templates) === null || ref === void 0 ? void 0 : ref.find(function(t) {
        return t.template_id === (mail === null || mail === void 0 ? void 0 : mail.template);
    });
    var parsedMail = (0,_mosanic_utils_mail__WEBPACK_IMPORTED_MODULE_4__/* .useEntryMailConversion */ .y)({
        baseRoute: collection === null || collection === void 0 ? void 0 : (ref1 = collection.routing) === null || ref1 === void 0 ? void 0 : ref1.baseRoute,
        schema: collection === null || collection === void 0 ? void 0 : collection.schema,
        template: template,
        entry: mail === null || mail === void 0 ? void 0 : mail.entry
    });
    // d-aafe89c6f02644e6be7c8362642570af 
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref;
        if ((parsedMail === null || parsedMail === void 0 ? void 0 : parsedMail.to) && template && !loading && mail && (mail === null || mail === void 0 ? void 0 : (ref = mail.entry) === null || ref === void 0 ? void 0 : ref.slug) && (mail_data === null || mail_data === void 0 ? void 0 : mail_data._id) && !(state === null || state === void 0 ? void 0 : state.send) && (mail === null || mail === void 0 ? void 0 : mail.mailId)) {
            var ref1, ref2;
            sendMail({
                templateId: (0,_util_Text__WEBPACK_IMPORTED_MODULE_5__/* .removeSpaces */ .I8)(mail_data === null || mail_data === void 0 ? void 0 : (ref1 = mail_data.data) === null || ref1 === void 0 ? void 0 : ref1.templateId),
                from: (0,_util_Text__WEBPACK_IMPORTED_MODULE_5__/* .toLowCase */ .Cc)(mail_data === null || mail_data === void 0 ? void 0 : (ref2 = mail_data.data) === null || ref2 === void 0 ? void 0 : ref2.defaultSender),
                subject: parsedMail.subject,
                to: parsedMail === null || parsedMail === void 0 ? void 0 : parsedMail.to,
                // to: 'thijs.zijdel@gmail.com', 
                preHeader: parsedMail.preHeader,
                subHeader: "dep.",
                mainHeader: "dep.",
                mainText: parsedMail === null || parsedMail === void 0 ? void 0 : parsedMail.content
            });
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                    send: "mail"
                });
            });
        }
    }, [
        mail_data,
        mail,
        loading,
        parsedMail,
        template,
        setState,
        state
    ]);
    return loading ? loading : sendLoading ? sendLoading : "Send mail";
};


/***/ }),

/***/ 26168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ FieldType; },
  "N": function() { return /* binding */ inputFields; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/index.js
var Input = __webpack_require__(6928);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/mosanic/fields/TextField/Fields.js
var Fields = __webpack_require__(91639);
// EXTERNAL MODULE: ./src/mosanic/items/Tooltip/index.js + 2 modules
var Tooltip = __webpack_require__(94233);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/Collection.styles.js
var Collection_styles = __webpack_require__(35712);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/Icons/ElementIcons.js
var ElementIcons = __webpack_require__(99559);
// EXTERNAL MODULE: ./src/mosanic/items/Control/ControlButtons.js + 1 modules
var ControlButtons = __webpack_require__(11743);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
;// CONCATENATED MODULE: ./src/mosanic/core/Collections/Field/FieldTypes.js












var useSearchItems = function(param) {
    var components = param.components;
    var ref = (0,react.useState)(""), input = ref[0], setInput = ref[1];
    var isSubstr = function(val) {
        return !val ? false : (0,Text/* lowCaseContainsSubstr */.dW)(val, input);
    };
    var isMatch = function(c) {
        return isSubstr(c.value);
    };
    var filteredComponents = (input === null || input === void 0 ? void 0 : input.length) >= 1 ? components.filter(function(c) {
        return isMatch(c);
    }) : components;
    return [
        input,
        setInput,
        filteredComponents
    ];
};
var FieldTypes = function(param) {
    var types = param.types, fieldType = param.fieldType, fieldId = param.fieldId, setValue = param.setValue;
    var ref = (0,react.useState)("all"), tab = ref[0], setTab = ref[1];
    var filteredFieldTypes = tab === "all" ? types : types === null || types === void 0 ? void 0 : types.filter(function(t) {
        return t.type === tab;
    });
    var ref1 = (0,_sliced_to_array/* default */.Z)(useSearchItems({
        components: types
    }), 3), input = ref1[0], setInput = ref1[1], searchedItems = ref1[2];
    var filteredItems = input ? searchedItems : filteredFieldTypes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                autoFocus: true,
                label: "Search field type",
                value: input,
                style: {
                    width: "100%",
                    border: "2.5px solid #eee",
                    marginBottom: 5
                },
                onChange: function(e) {
                    return setInput(e.target.value);
                },
                endAdornment: input ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    ghost: true,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* CrossCircledIcon */.xrR, {}),
                    onClick: function() {
                        return setInput("");
                    }
                }) : null
            }),
            !input && /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlButtons/* default */.Z, {
                mt: 2,
                setActive: setTab,
                active: tab,
                options: "all|input|advanced|visual"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styles/* default.FieldTypes */.Z.FieldTypes, {
                children: filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.map(function(type) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
                        when: type === null || type === void 0 ? void 0 : type.coming,
                        wrapper: function(children) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                force: true,
                                title: "Coming soon",
                                children: children
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collection_styles/* default.FieldType */.Z.FieldType, {
                            active: (type === null || type === void 0 ? void 0 : type.value) === fieldType,
                            coming: type === null || type === void 0 ? void 0 : type.coming,
                            onClick: function() {
                                return (type === null || type === void 0 ? void 0 : type.coming) ? null : setValue("".concat(fieldId, ".type"), type === null || type === void 0 ? void 0 : type.value);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: (0,ElementIcons/* elementIcon */.$N)(type.value)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    style: {
                                        margin: "5px 0 0"
                                    },
                                    dangerouslySetInnerHTML: {
                                        __html: type.value.replace(new RegExp(input, "gi"), function(match) {
                                            return '<mark style="background: '.concat(colors/* default.util.orange.mark */.ZP.util.orange.mark, '">').concat(match, "</mark>");
                                        })
                                    }
                                })
                            ]
                        })
                    }, type.value);
                })
            })
        ]
    });
};
/* harmony default export */ var Field_FieldTypes = (FieldTypes);

;// CONCATENATED MODULE: ./src/mosanic/core/Collections/Field/FieldType.js


var ref;













var types = [
    {
        value: "text",
        type: "input"
    },
    {
        value: "textarea",
        type: "input"
    },
    {
        value: "email",
        type: "input"
    },
    {
        value: "code",
        type: "advanced"
    },
    {
        value: "visual",
        type: "input"
    },
    {
        value: "link",
        type: "input"
    },
    {
        value: "number",
        type: "input"
    },
    {
        value: "select",
        type: "input"
    },
    {
        value: "switch",
        type: "input"
    },
    {
        value: "radio",
        type: "input"
    },
    {
        value: "slider",
        type: "input"
    },
    {
        value: "checkbox",
        type: "input"
    },
    {
        value: "buttonGroup",
        type: "input"
    },
    {
        value: "button",
        type: "input"
    },
    {
        value: "date-time",
        type: "input"
    },
    {
        value: "date",
        type: "input"
    },
    {
        value: "time",
        type: "input"
    },
    {
        value: "color",
        type: "input"
    },
    {
        value: "image",
        type: "input"
    },
    {
        value: "markedimage",
        type: "advanced"
    },
    {
        value: "gallery",
        type: "input"
    },
    {
        value: "location",
        type: "input"
    },
    {
        value: "file",
        type: "input",
        coming: true
    },
    {
        value: "video",
        type: "input",
        coming: true
    },
    {
        value: "relation",
        type: "advanced"
    },
    {
        value: "user",
        type: "advanced"
    },
    {
        value: "repeater",
        type: "advanced"
    },
    {
        value: "label",
        type: "visual"
    },
    {
        value: "help",
        type: "visual"
    },
    {
        value: "accordion",
        type: "visual"
    },
    {
        value: "tabs",
        type: "visual"
    },
    {
        value: "group",
        type: "visual"
    },
    {
        value: "row",
        type: "visual",
        coming: true
    },
    {
        value: "column",
        type: "visual",
        coming: true
    },
    {
        value: "steps",
        type: "visual"
    },
    {
        value: "dialog",
        type: "visual",
        coming: true
    },
    {
        value: "component",
        type: "advanced",
        coming: true
    },
    {
        value: "id",
        type: "advanced"
    }, 
];
var inputFields = (ref = types === null || types === void 0 ? void 0 : types.filter(function(t) {
    return !(t === null || t === void 0 ? void 0 : t.coming);
})) === null || ref === void 0 ? void 0 : ref.map(function(t) {
    return t.value;
});
var FieldType = function(param) {
    var isFirstField = param.isFirstField, inputProps = param.inputProps, fieldId = param.fieldId, fieldType = param.fieldType, setValue = param.setValue;
    var fieldTypes = isFirstField ? [
        "text"
    ] : inputFields;
    var ref = (0,react.useState)(false), state = ref[0], setState = ref[1];
    var close = function() {
        return setState(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                style: {
                    fontSize: "10px",
                    fontWeight: "100"
                },
                ghost: true,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* SizeIcon */.el1, {}),
                onClick: function() {
                    return setState(true);
                },
                disabled: isFirstField,
                label: isFirstField ? "Can't change the identifier field" : "Expand field types"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                name: "".concat(fieldId, ".type"),
                label: "Field type",
                type: "select"
            }, inputProps), {
                required: true,
                options: fieldTypes,
                searchable: true,
                disabled: isFirstField,
                rules: {
                    required: "Field type is required, otherwise you can't input data."
                },
                maxMenuHeight: 140
            })),
            !isFirstField && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                title: "Select field type",
                titleSize: 4,
                size: "sm",
                state: state,
                close: close,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field_FieldTypes, {
                    state: state,
                    close: close,
                    types: types,
                    fieldId: fieldId,
                    fieldType: fieldType,
                    setValue: setValue
                })
            })
        ]
    });
};


/***/ }),

/***/ 87818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ FieldControls; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _JSX__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96344);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47914);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28932);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77298);
/* harmony import */ var _Collection_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35712);









var Button = function(_param) /*#__PURE__*/ {
    var icon = _param.icon, label = _param.label, disabled = _param.disabled, onClick = _param.onClick, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "icon",
        "label",
        "disabled",
        "onClick"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Collection_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Button */ .Z.Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, other), {
        disabled: disabled,
        onClick: function() {
            return !disabled && onClick && onClick();
        },
        children: [
            icon,
            label
        ]
    }));
};
var FieldControls = function(_param) /*#__PURE__*/ {
    var remove = _param.remove, move = _param.move, index = _param.index, count = _param.count, _dragHandle = _param.dragHandle, dragHandle = _dragHandle === void 0 ? null : _dragHandle, _wrap = _param.wrap, wrap = _wrap === void 0 ? true : _wrap, _extra = _param.extra, extra = _extra === void 0 ? null : _extra, _trigger = _param.trigger, trigger = _trigger === void 0 ? null : _trigger, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "remove",
        "move",
        "index",
        "count",
        "dragHandle",
        "wrap",
        "extra",
        "trigger"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_JSX__WEBPACK_IMPORTED_MODULE_6__/* .ConditionalWrapper */ .M, {
        when: wrap,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Collection_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].FieldControls */ .Z.FieldControls, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, other), {
                children: children
            }));
        },
        children: [
            extra,
            dragHandle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                ghost: true,
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .DragHandleDots1Icon */ .Gtn, {})
            }, dragHandle), {
                style: {
                    cursor: "grab"
                }
            })),
            (move || remove) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                trigger: trigger ? trigger : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .DotsVerticalIcon */ .AjK, {})
                }),
                p: 0,
                width: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_8__.Buttons, {
                    children: [
                        move && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                            ghost: true,
                            type: "button",
                            disabled: 0 === index,
                            onClick: function() {
                                return move(index, index - 1);
                            },
                            label: "↑"
                        }),
                        move && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                            ghost: true,
                            type: "button",
                            disabled: count === index + 1,
                            onClick: function() {
                                return move(index, index + 1);
                            },
                            label: "↓"
                        }),
                        remove && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                            ghost: true,
                            type: "button",
                            onClick: function() {
                                return remove(index);
                            },
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .TrashIcon */ .XHJ, {})
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 61101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ FieldsCollection; },
  "_": function() { return /* binding */ StepsCollection; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ./src/adapters/queries/pages.js
var pages = __webpack_require__(81913);
// EXTERNAL MODULE: ./src/mosanic/Icons/EditIcons.js
var EditIcons = __webpack_require__(75679);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/useDataQuery.js
var useDataQuery = __webpack_require__(49974);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/mosanic/utils/ObjectID.js
var ObjectID = __webpack_require__(56831);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ./src/mosanic/core/Provider/DataProviders.js
var DataProviders = __webpack_require__(42622);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./src/mosanic/Icons/HelpIcons.js
var HelpIcons = __webpack_require__(87308);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/index.js
var Input = __webpack_require__(6928);
// EXTERNAL MODULE: ./src/mosanic/items/Expander/index.js + 1 modules
var Expander = __webpack_require__(56957);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/mosanic/core/Items/InView.tsx + 1 modules
var InView = __webpack_require__(34395);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/Collection.styles.js
var Collection_styles = __webpack_require__(35712);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/FieldControls.js
var FieldControls = __webpack_require__(87818);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/mosanic/items/Link/index.js
var Link = __webpack_require__(8152);
// EXTERNAL MODULE: ./src/mosanic/Icons/ElementIcons.js
var ElementIcons = __webpack_require__(99559);
// EXTERNAL MODULE: ./src/mosanic/fields/TextField/Fields.js
var Fields = __webpack_require__(91639);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(87567);
// EXTERNAL MODULE: ./src/mosanic/components/Team/roles.js
var roles = __webpack_require__(36563);
// EXTERNAL MODULE: ./src/mosanic/fields/Source/Relation.js
var Relation = __webpack_require__(23494);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/mosanic/styles/grid.styles.js
var grid_styles = __webpack_require__(67324);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/many.js + 1 modules
var many = __webpack_require__(43551);
// EXTERNAL MODULE: ./src/mosanic/fields/Code/PreviewCode.js
var PreviewCode = __webpack_require__(59389);
// EXTERNAL MODULE: ./src/mosanic/fields/Source/helpers.js
var helpers = __webpack_require__(49272);
// EXTERNAL MODULE: ./src/mosanic/items/Control/ControlButtons.js + 1 modules
var ControlButtons = __webpack_require__(11743);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Popper.js + 4 modules
var Popper = __webpack_require__(28932);
// EXTERNAL MODULE: ./src/mosanic/utils/value.js + 1 modules
var value = __webpack_require__(11039);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/features/options/reducer.js + 1 modules
var options_reducer = __webpack_require__(51331);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
;// CONCATENATED MODULE: ./src/mosanic/core/Collections/Field/FieldGroups.js






function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    font-size: 12px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    ",
        "\n    font-family: courier;\n    font-size: 12px;\n    background: ",
        ";\n    padding: 2.5px 5px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin: 2.5px 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: block;\n    margin-top: 5px;\n    &:hover {\n        background: ",
        ";\n        cursor: pointer;\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





























//Generic groups
var FieldMeta = function(param) {
    var control = param.control, fieldId = param.fieldId, getField = param.getField, fieldType = param.fieldType, disabled = param.disabled;
    return !disabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
        cols: 3,
        border: true,
        label: "Meta controls",
        force: true,
        children: [
            !getField("populateActive") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".required"),
                        label: "Required",
                        type: "switch",
                        control: control
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".unique"),
                        label: "Unique",
                        type: "switch",
                        control: control
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".localized"),
                        label: "Localized",
                        type: "switch",
                        control: control
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".props"),
                label: "Prop",
                type: "switch",
                control: control
            }),
            [
                "textarea",
                "text"
            ].includes(fieldType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".description"),
                label: "Description",
                type: "switch",
                control: control
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".inMap"),
                label: "In map",
                type: "switch",
                control: control
            }),
            getField("inMap") && [
                "textarea",
                "text",
                "visual"
            ].includes(fieldType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".searchable"),
                label: "Searchable",
                type: "switch",
                control: control
            }),
            getField("inMap") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".filterable"),
                label: "Filterable",
                type: "switch",
                control: control
            }),
            !getField("populateActive") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".pageProp"),
                label: "Received from page",
                type: "switch",
                control: control
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".variable"),
                label: "Mail variable",
                type: "switch",
                control: control
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".restrict"),
                label: "Restrict field",
                type: "select",
                control: control,
                options: roles/* list_roles */.cT,
                searchable: true,
                multiple: true,
                fullWidth: true,
                wrap: true
            })
        ]
    }) : null;
};
var FieldVisibility = function(param) {
    var control = param.control, fieldId = param.fieldId, getField = param.getField, fieldType = param.fieldType, disabled = param.disabled;
    return !disabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
        cols: 3,
        border: true,
        label: "Visibility",
        force: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".hidden"),
                label: "Hidden",
                type: "switch",
                control: control
            }),
            !getField("populateActive") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".fixed"),
                label: "Not editable",
                type: "switch",
                control: control
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".fullWidth"),
                label: "Full width",
                type: "switch",
                control: control
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".inColumns"),
                label: "In Columns",
                type: "switch",
                control: control
            }),
            "label" === fieldType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".headingSize"),
                        fullWidth: true,
                        label: "Label size",
                        type: "select",
                        control: control,
                        options: (0,_to_consumable_array/* default */.Z)("h1|h2|h3|h4|h5|h6|bold|small".split("|").map(function(value) {
                            return {
                                value: value,
                                label: value
                            };
                        })).concat([
                            {
                                value: null,
                                label: "default"
                            }
                        ])
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".separator"),
                        fullWidth: true,
                        label: "Separator",
                        type: "select",
                        control: control,
                        options: (0,_to_consumable_array/* default */.Z)("top|bottom".split("|").map(function(value) {
                            return {
                                value: value,
                                label: value
                            };
                        })).concat([
                            {
                                value: null,
                                label: "none"
                            }
                        ])
                    })
                ]
            }),
            "visual" === fieldType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".removeBorders"),
                        label: "Remove borders",
                        type: "switch",
                        control: control
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".hideToolbar"),
                        label: "Hide toolbar",
                        type: "switch",
                        control: control
                    })
                ]
            })
        ]
    }) : null;
};
var RegexValidation = function(param) {
    var fieldId = param.fieldId, control = param.control, getField = param.getField;
    // Some regular expression you could try
    // const email = /[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+/;
    // const phone = /(\\+\\d{1,3} )?\\(\\d{3}\\)-\\d{3}-\\d{4}( Ext: \\d+)?/;
    // const color = /Red|Gr(een|ay)|Blue|Yellow|O(range|live)/;
    // A rather complex regular expression (please feel free to user your own)
    var ref = (0,react.useState)(""), text = ref[0], setText = ref[1];
    var regex = getField("regex");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".regex"),
                label: "Regex value",
                fullWidth: true,
                type: "text",
                control: control
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                        label: "Test text",
                        value: text,
                        onChange: function(e) {
                            return setText(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                        label: "Validation",
                        value: JSON.stringify(regex && text && regex.test(text)),
                        disabled: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                mt: 3,
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                    href: "https://www.regextester.com/",
                    children: "More information "
                })
            })
        ]
    });
};
var HelpContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3921737-0"
})(_templateObject());
var Value = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-f3921737-1"
})(_templateObject1(), function(props) {
    return props.clickable && "cursor: pointer;";
}, colors/* default.util.gray.lighter */.ZP.util.gray.lighter);
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3921737-2"
})(_templateObject2());
var Bold = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
    componentId: "sc-f3921737-3"
})(_templateObject3(), colors/* default.util.gray.lighter */.ZP.util.gray.lighter);
var _obj;
var operations = (_obj = {}, (0,_define_property/* default */.Z)(_obj, "+", "Add / Unary Plus"), (0,_define_property/* default */.Z)(_obj, "-", "Subtract / Unary Minus"), (0,_define_property/* default */.Z)(_obj, "*", "Multiply"), (0,_define_property/* default */.Z)(_obj, "/", "Divide"), (0,_define_property/* default */.Z)(_obj, "^", "Power"), (0,_define_property/* default */.Z)(_obj, "%", "Modulo"), (0,_define_property/* default */.Z)(_obj, "(", "Begin Group"), (0,_define_property/* default */.Z)(_obj, ")", "End Group"), (0,_define_property/* default */.Z)(_obj, ",", "Separate Argument"), _obj);
var _obj1;
var functions = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, "ABS(x)", "Returns the absolute value of a number."), (0,_define_property/* default */.Z)(_obj1, "CEIL(x)", "Returns the smallest integer greater than or equal to a number."), (0,_define_property/* default */.Z)(_obj1, "FLOOR(x)", "Returns the largest integer less than or equal to a number."), (0,_define_property/* default */.Z)(_obj1, "SUM(x[, y[, ...]])", "Returns the sum of one or more numbers."), _obj1);
var PopulationGroup = function(param) {
    var control = param.control, fieldId = param.fieldId, getField = param.getField, fieldType = param.fieldType;
    // const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    // 	name: `${fieldId}.populate`, 
    // 	control
    // }); 
    var ctx = (0,DataProviders/* useDataProvider */.x5)().ctx;
    var isDev = (0,es/* useSelector */.v9)(options_reducer/* getDevModePrefSelector */.Lj);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
        fullWidth: true,
        border: true,
        label: "Population config",
        cols: 1,
        force: true,
        children: [
            getField("dangerousPopulation") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedLabel/* AdvancedLabel */.qv, {
                        children: [
                            "Access ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                children: "$ctx.entry"
                            }),
                            " to perform all data manipulations"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".code"),
                        label: "Code",
                        type: "code",
                        control: control,
                        ctx: ctx,
                        showPreview: true
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedLabel/* AdvancedLabel */.qv, {
                            children: [
                                "Insert ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                    children: "{group_name.field_name}"
                                }),
                                " and perform math evaluations ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* QuestionMarkCircledIcon */.pjG, {})
                            ]
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HelpContent, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                                        children: "Math operations"
                                    }),
                                    children: Object.entries(operations).map(function(param) {
                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), o = _param[0], label = _param[1];
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                                    children: o
                                                }),
                                                " ",
                                                label
                                            ]
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                                        children: "Math functions"
                                    }),
                                    children: Object.entries(functions).map(function(param) {
                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), o = _param[0], label = _param[1];
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                                    clickable: true,
                                                    children: o
                                                }),
                                                children: label
                                            })
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Expander/* default */.Z, {
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bold, {
                                        children: "Dates"
                                    }),
                                    children: [
                                        "If a pointer is to a date field, only a - operator can be used. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Get days between:",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Value, {
                                            children: [
                                                "{dateA}",
                                                " - ",
                                                "{dateB}"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".populateCode"),
                        label: "Population",
                        type: "text",
                        control: control
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                        value: JSON.stringify((0,value/* replaceWithSource */.yL)(getField("populateCode"), ctx === null || ctx === void 0 ? void 0 : ctx.entry, true)),
                        fullWidth: true,
                        wrap: true,
                        label: "Preview population",
                        disabled: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".dangerousPopulation"),
                label: "Dangerous",
                type: "switch",
                control: control,
                disabled: !isDev
            })
        ]
    });
};
var validateOptions = "hide|Hide field\nshow|Show field\ndisable|Disable field\nenable|Enable field\ncreate|Can create\nnoCreate|Can't create\nupdate|Can update\nnoUpdate|Can't update\nhelper|Display Helper\nerror|Display Error".split("\n").map(function(f) {
    var o = f.split("|");
    return {
        value: o[0],
        label: o[1]
    };
});
var _obj2;
var crossValidate = (_obj2 = {
    hide: "show",
    show: "hide",
    disable: "enable",
    enable: "disable"
}, (0,_define_property/* default */.Z)(_obj2, "enable", "disable"), (0,_define_property/* default */.Z)(_obj2, "update", "noUpdate"), (0,_define_property/* default */.Z)(_obj2, "noUpdate", "update"), (0,_define_property/* default */.Z)(_obj2, "create", "noCreate"), (0,_define_property/* default */.Z)(_obj2, "noCreate", "create"), _obj2);
var ValidateGroup = function(param) {
    var control = param.control, fieldId = param.fieldId, getField = param.getField, fieldType = param.fieldType;
    var ref;
    var ref1 = (0,index_esm/* useFieldArray */.Dq)({
        name: "".concat(fieldId, ".validation"),
        control: control
    }), fields = ref1.fields, append = ref1.append, prepend = ref1.prepend, remove = ref1.remove, swap = ref1.swap, move = ref1.move, insert = ref1.insert;
    var option = function(index) {
        var ref;
        return (ref = getField("validation")) === null || ref === void 0 ? void 0 : ref[index];
    };
    var helpers = function(index) {
        var ref, ref1;
        return (ref = option(index)) === null || ref === void 0 ? void 0 : (ref1 = ref.actions) === null || ref1 === void 0 ? void 0 : ref1.filter(function(o) {
            return [
                "error",
                "helper"
            ].includes(o);
        });
    };
    var data = (0,DataProviders/* useDataProvider */.x5)();
    var ctx = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.ctx), {
        user: data === null || data === void 0 ? void 0 : data.user,
        validation: fields === null || fields === void 0 ? void 0 : fields.map(function(f, i) {
            var ref;
            return (0,PreviewCode/* parseCode */.zY)((ref = option(i)) === null || ref === void 0 ? void 0 : ref.code, data.ctx);
        })
    });
    var isDev = (0,es/* useSelector */.v9)(options_reducer/* getDevModePrefSelector */.Lj);
    // validateActive
    var validate = (ref = getField("validate")) === null || ref === void 0 ? void 0 : ref.field;
    var ref2 = (0,react.useState)(null), expanded = ref2[0], setExpanded = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
        fullWidth: true,
        border: true,
        label: "Validation config",
        cols: 1,
        force: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedLabel/* AdvancedLabel */.qv, {
                my: 3,
                children: [
                    "Access ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                        children: "$ctx.entry"
                    }),
                    " to perform all data validation. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ExclamationTriangleIcon */.LPM, {}),
                    " Return a wrapped ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Value, {
                        children: [
                            "Boolean",
                            "(...)"
                        ]
                    }),
                    " else if the value is'nt empty the validation is ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                        children: "true"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlButtons/* default */.Z, {
                setActive: setExpanded,
                active: expanded,
                options: fields.map(function(f, i) {
                    var ref;
                    return {
                        value: "".concat(i),
                        label: "".concat((0,Text/* combineString */.M7)((ref = option(i)) === null || ref === void 0 ? void 0 : ref.actions, ", "), " ")
                    };
                })
            }),
            fields === null || fields === void 0 ? void 0 : fields.map(function(f, index) {
                var ref, ref1, ref2, ref3, ref4, ref5;
                return expanded === "".concat(index) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                    border: true,
                    label: ((ref = option(index)) === null || ref === void 0 ? void 0 : (ref1 = ref.actions) === null || ref1 === void 0 ? void 0 : ref1.length) >= 1 ? "Validation for: [".concat((0,Text/* combineString */.M7)((ref2 = option(index)) === null || ref2 === void 0 ? void 0 : ref2.actions, ", "), "]") : "Validation",
                    cols: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldControls/* FieldControls */.g, {
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* DotsHorizontalIcon */.nWS, {}),
                                ghost: true
                            }),
                            count: fields === null || fields === void 0 ? void 0 : fields.length,
                            style: {
                                position: "absolute",
                                right: 0,
                                top: 0,
                                minWidth: 5
                            },
                            remove: remove,
                            move: move,
                            index: index
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                            name: "".concat(fieldId, ".validation.").concat(index, ".code"),
                            label: "Code",
                            type: "code",
                            control: control,
                            ctx: ctx,
                            showPreview: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                            name: "".concat(fieldId, ".validation.").concat(index, ".actions"),
                            label: "If validation is true",
                            type: "select",
                            control: control,
                            options: validateOptions.map(function(o) {
                                var ref;
                                //skip update and crate
                                if (!(0,Obj/* hasAttr */.B$)(crossValidate, o.value)) return o;
                                var active = (ref = option(0)) === null || ref === void 0 ? void 0 : ref.actions;
                                if (!(active === null || active === void 0 ? void 0 : active.includes(crossValidate[o.value]))) return o;
                                return null;
                            // return active.filter(a => crossValidate[a.value]?.includes(o.value))
                            }).filter(function(o) {
                                return o === null || o === void 0 ? void 0 : o.value;
                            }),
                            multiple: true,
                            fullWidth: true
                        }),
                        ((ref3 = helpers(index)) === null || ref3 === void 0 ? void 0 : ref3.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                            label: "Labels",
                            border: true,
                            cols: 1,
                            children: [
                                ((ref4 = helpers(index)) === null || ref4 === void 0 ? void 0 : ref4.includes("error")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                                    name: "".concat(fieldId, ".validation.").concat(index, ".error"),
                                    label: "Error if false",
                                    type: "code",
                                    control: control,
                                    ctx: ctx,
                                    showPreview: true
                                }),
                                ((ref5 = helpers(index)) === null || ref5 === void 0 ? void 0 : ref5.includes("helper")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                                    name: "".concat(fieldId, ".validation.").concat(index, ".helper"),
                                    label: "Helper if true",
                                    type: "code",
                                    control: control,
                                    ctx: ctx,
                                    showPreview: true
                                })
                            ]
                        })
                    ]
                }, f.id) : null;
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                onClick: function() {
                    return append({
                        code: "$ctx.entry",
                        actions: []
                    });
                },
                label: "Add validation",
                style: {
                    width: "100%"
                },
                m: 0,
                ghost: true
            })
        ]
    });
};
var FieldValidation = function(param) {
    var control = param.control, fieldId = param.fieldId, getField = param.getField, fieldType = param.fieldType, disabled = param.disabled;
    return !disabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                cols: 3,
                border: true,
                label: "Validation",
                force: true,
                children: [
                    [
                        "textarea",
                        "text",
                        "visual",
                        "number"
                    ].includes(fieldType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".regexActive"),
                        label: "Regex validation",
                        type: "switch",
                        control: control
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".populateActive"),
                        label: "Dynamic populate",
                        type: "switch",
                        control: control
                    }),
                    "date" === fieldType && [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                            name: "".concat(fieldId, ".range"),
                            type: "switch",
                            label: "Range",
                            control: control
                        })
                    ],
                    [
                        "textarea",
                        "text",
                        "visual",
                        "number"
                    ].includes(fieldType) && !getField("populateActive") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".limit"),
                        label: "Limit",
                        type: "switch",
                        control: control
                    }),
                    getField("regexActive") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
                        fullWidth: true,
                        border: true,
                        label: "Regex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegexValidation, {
                            control: control,
                            fieldId: fieldId,
                            getField: getField
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".validateActive"),
                        label: "Advanced validation",
                        type: "switch",
                        control: control
                    }),
                    [
                        "textarea",
                        "text",
                        "visual",
                        "number"
                    ].includes(fieldType) && getField("limit") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                        fullWidth: true,
                        border: true,
                        label: "Limit",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                                name: "".concat(fieldId, ".min"),
                                label: fieldType === "number" ? "Minimum value" : "Minimum chars",
                                type: "number",
                                control: control
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                                name: "".concat(fieldId, ".max"),
                                label: fieldType === "number" ? "Maximum value" : "Maximum chars",
                                type: "number",
                                control: control
                            })
                        ]
                    }),
                    "repeater" === fieldType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                        fullWidth: true,
                        border: true,
                        label: "Repeater config",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                                name: "".concat(fieldId, ".limitChildren"),
                                label: "Limit repeats",
                                type: "number",
                                control: control
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                                name: "".concat(fieldId, ".singular"),
                                label: "Singular name",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                                name: "".concat(fieldId, ".displayChildren"),
                                label: "Editor view",
                                type: "select",
                                control: control,
                                options: "list|tabs|select|accordion|row".split("|").map(function(value) {
                                    return {
                                        value: value,
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                (0,ElementIcons/* elementIcon */.$N)(value),
                                                " ",
                                                ![
                                                    "s",
                                                    "t"
                                                ].includes(value.charAt(value.length - 1)) ? value + "s" : value
                                            ]
                                        })
                                    };
                                })
                            })
                        ]
                    })
                ]
            }),
            getField("populateActive") && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopulationGroup, {
                control: control,
                fieldId: fieldId,
                getField: getField,
                fieldType: fieldType
            }),
            getField("validateActive") && /*#__PURE__*/ (0,jsx_runtime.jsx)(ValidateGroup, {
                control: control,
                fieldId: fieldId,
                getField: getField,
                fieldType: fieldType
            })
        ]
    }) : null;
};
//Group collections
var ChoiceType = function(param) {
    var control = param.control, fieldId = param.fieldId, fieldType = param.fieldType, show = param.show;
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
        cols: 2,
        force: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".options"),
                label: "Values",
                placeHolder: "Example: \nmain|sub-text \nsub|sub-text \nthird|sub-text",
                type: "textarea",
                control: control
            }),
            fieldType != "buttonGroup" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".direction"),
                label: "Direction",
                options: [
                    "horizontal",
                    "vertical"
                ],
                type: "buttonGroup",
                control: control
            })
        ]
    }) : null;
};
var FieldUser = function(param) {
    var control = param.control, fieldId = param.fieldId, getField = param.getField, show = param.show;
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
        cols: 2,
        border: true,
        label: "User",
        force: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".isAuthor"),
                label: "Is Author",
                type: "switch",
                control: control
            }),
            !getField("isAuthor") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".canView"),
                label: "Can view",
                type: "switch",
                control: control
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".userId"),
                label: "Active user id",
                type: "switch",
                control: control,
                disabled: getField("pageProp")
            })
        ]
    }) : null;
};
//Specific groups
var FieldMarkedImage = function(param) {
    var control = param.control, fieldId = param.fieldId, getField = param.getField, collections = param.collections, show = param.show;
    return show ? [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
            clearable: false,
            name: "".concat(fieldId, ".markerRelation"),
            label: "Marker relation",
            type: "select",
            control: control,
            options: (0,_to_consumable_array/* default */.Z)(collections === null || collections === void 0 ? void 0 : collections.options).concat([
                {
                    value: null,
                    label: "Unset"
                }
            ]),
            fullWidth: true
        }),
        getField("markerRelation") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
            name: "".concat(fieldId, ".markerDisplay"),
            label: "Marker display",
            type: "select",
            control: control,
            options:  false ? 0 : [
                {
                    value: null,
                    label: "Create an dialog or zone first."
                }
            ],
            fullWidth: true
        })
    ] : null;
};
var FieldRelation = function(param) {
    var control = param.control, fieldId = param.fieldId, getField = param.getField, collections = param.collections, zones = param.zones, setValue = param.setValue, show = param.show;
    var ref;
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
        border: true,
        label: "Relation setup",
        style: {
            paddingTop: "25px"
        },
        force: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".relation"),
                type: "string",
                control: control
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* ButtonGroup */.h, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* ButtonGroup.Choices */.h.Choices, {
                    value: getField("relation"),
                    handler: function(value) {
                        return setValue("".concat(fieldId, ".relation"), value);
                    },
                    options: Relation.relations
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid_styles/* Wrap */.Eq, {
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_styles/* Col */.JX, {
                        width: [
                            1 / 4
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                            label: "Entry",
                            value: getField("name"),
                            wrap: true,
                            fullWidth: true,
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_styles/* Col */.JX, {
                        width: [
                            1 / 2
                        ],
                        style: {
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedLabel/* AdvancedLabel */.qv, {
                            pt: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: getField("name")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styles/* default.RelationLabel */.Z.RelationLabel, {
                                    children: (ref = Relation.relations === null || Relation.relations === void 0 ? void 0 : Relation.relations.find(function(r) {
                                        return r.value === getField("relation");
                                    })) === null || ref === void 0 ? void 0 : ref.tooltip
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "field"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_styles/* Col */.JX, {
                        width: [
                            1 / 4
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                            clearable: false,
                            name: "".concat(fieldId, ".relationEnd"),
                            label: "To",
                            type: "select",
                            control: control,
                            options: collections === null || collections === void 0 ? void 0 : collections.options,
                            fullWidth: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(fieldId, ".relationRender"),
                label: "Render component",
                type: "select",
                control: control,
                options: (zones === null || zones === void 0 ? void 0 : zones.length) >= 1 ? zones.map(function(p) {
                    return {
                        value: p._id,
                        label: "".concat(p === null || p === void 0 ? void 0 : p.title, " [").concat(p === null || p === void 0 ? void 0 : p.type, "]")
                    };
                }) : [
                    {
                        value: null,
                        label: "Create an dialog or zone first."
                    }
                ],
                fullWidth: true
            })
        ]
    }) : null;
};
var FieldGroup = function(param) {
    var fieldId = param.fieldId, level = param.level, show = param.show;
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
        border: true,
        label: "Fields",
        cols: 1,
        force: true,
        style: {
            borderLeft: "2px solid ".concat(colors/* default.util.gray.light */.ZP.util.gray.light),
            paddingLeft: "10px",
            marginTop: "25px",
            display: "block"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldsCollection, {
            id: "".concat(fieldId, ".schema"),
            level: level + 1,
            skipFirstField: true
        })
    }) : null;
};
var FieldSteps = function(param) {
    var fieldId = param.fieldId, level = param.level, label = param.label, show = param.show;
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
        force: true,
        style: {
            borderLeft: "2px solid ".concat(colors/* default.util.gray.light */.ZP.util.gray.light),
            paddingLeft: "10px"
        },
        label: label,
        cols: 1,
        border: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsCollection, {
            id: "".concat(fieldId, ".schema"),
            level: level + 1,
            type: "step"
        })
    }) : null;
};
var FieldRepeat = function(param) {
    var fieldId = param.fieldId, level = param.level, label = param.label, show = param.show;
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
        force: true,
        style: {
            borderLeft: "2px solid ".concat(colors/* default.util.gray.light */.ZP.util.gray.light),
            paddingLeft: "10px",
            display: "block"
        },
        label: label,
        cols: 1,
        border: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldsCollection, {
            id: "".concat(fieldId, ".schema"),
            level: level + 1
        })
    }) : null;
};
var userSelectCode = "({\n    ...$ctx.user, \n    updatedAt: new Date()\n})";
var FieldButton = function(param) {
    var fieldId = param.fieldId, level = param.level, schema = param.schema, getField = param.getField, show = param.show, control = param.control, collectionId = param.collectionId, trigger = param.trigger;
    var ref;
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,many/* useGetMails */.fY)({
        filter: {
            siteId: siteId,
            collectionId: collectionId
        }
    }), 1), mails = ref1[0];
    var mail = mails === null || mails === void 0 ? void 0 : mails.find(function(m) {
        return m._id === getField("mailId");
    });
    var templates = mail === null || mail === void 0 ? void 0 : mail.templates;
    var userFieldsName = "".concat(fieldId, ".trigger.users");
    var userFields = [
        {
            value: "userId",
            label: "Author"
        }
    ].concat((0,_to_consumable_array/* default */.Z)((ref = schema === null || schema === void 0 ? void 0 : schema.filter(function(f) {
        return (f === null || f === void 0 ? void 0 : f.type) === "user";
    })) === null || ref === void 0 ? void 0 : ref.map(function(f) {
        return {
            label: (0,Text/* revertDevCases */.Uw)((f === null || f === void 0 ? void 0 : f.label) ? f.label : f.name),
            value: f.name
        };
    })));
    var ref2 = (0,index_esm/* useFieldArray */.Dq)({
        name: userFieldsName,
        control: control
    }), fields = ref2.fields, append = ref2.append, prepend = ref2.prepend, remove = ref2.remove, swap = ref2.swap, move = ref2.move, insert = ref2.insert;
    var ref3 = (0,react.useState)(null), expanded = ref3[0], setExpanded = ref3[1];
    var toggle = function(i) {
        return setExpanded((0,_define_property/* default */.Z)({}, i, !expanded[i]));
    };
    var data = (0,DataProviders/* useDataProvider */.x5)();
    return show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                label: "Trigger",
                cols: 3,
                border: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".action"),
                        label: "Action",
                        type: "select",
                        options: "create|update|delete|send".split("|"),
                        control: control,
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".enableMail"),
                        label: "Mail trigger",
                        type: "switch",
                        control: control
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".enableUser"),
                        label: "User trigger",
                        type: "switch",
                        control: control
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".enableModify"),
                        label: "Modify trigger",
                        type: "switch",
                        control: control
                    })
                ]
            }),
            getField("enableMail") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                border: true,
                label: "Mail",
                cols: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".mailId"),
                        label: "Mail trigger",
                        type: "select",
                        control: control,
                        options: mails === null || mails === void 0 ? void 0 : mails.map(function(mail) {
                            return {
                                value: mail._id,
                                label: mail.title
                            };
                        }),
                        fullWidth: true
                    }),
                    getField("mailId") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".mailTemplate"),
                        label: "On submit",
                        type: "select",
                        control: control,
                        options: templates === null || templates === void 0 ? void 0 : templates.map(function(template) {
                            return (0,helpers/* getEntryLabel */.ax)(template, mail === null || mail === void 0 ? void 0 : mail.schema);
                        })
                    })
                ]
            }),
            getField("enableUser") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                label: "Users",
                border: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedLabel/* AdvancedLabel */.qv, {
                        my: 3,
                        children: [
                            "Access ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                children: "$ctx.user"
                            }),
                            " to perform all user manipulations on the selected userId. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ExclamationTriangleIcon */.LPM, {}),
                            " Return a changed ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                children: "({ ...$ctx.user })"
                            }),
                            " object."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlButtons/* default */.Z, {
                        setActive: setExpanded,
                        active: expanded,
                        options: fields.map(function(f, i) {
                            var ref, ref1, ref2;
                            return {
                                value: "".concat(i),
                                label: (ref = getField("trigger")) === null || ref === void 0 ? void 0 : (ref1 = ref.users) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[i]) === null || ref2 === void 0 ? void 0 : ref2.userId
                            };
                        })
                    }),
                    fields === null || fields === void 0 ? void 0 : fields.map(function(f, index) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(UserTrigger, {
                            userFields: userFields,
                            controls: {
                                count: fields === null || fields === void 0 ? void 0 : fields.length,
                                remove: remove
                            },
                            name: "".concat(userFieldsName, ".").concat(index),
                            index: index,
                            control: control,
                            field: (ref = getField("trigger")) === null || ref === void 0 ? void 0 : (ref1 = ref.users) === null || ref1 === void 0 ? void 0 : ref1[index],
                            expanded: expanded === "".concat(index),
                            toggle: toggle
                        });
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                        onClick: function() {
                            return append({
                                code: userSelectCode,
                                userId: "userId"
                            });
                        },
                        label: "Add user trigger",
                        style: {
                            width: "100%"
                        },
                        m: 0,
                        ghost: true
                    })
                ]
            }),
            getField("enableModify") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                label: "Users",
                border: true,
                cols: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedLabel/* AdvancedLabel */.qv, {
                        children: [
                            "You must return a ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                children: "$ctx.entry"
                            }),
                            ". You can perform changes and return it like this: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                children: "({...$ctx.entry, newField: true})"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                        name: "".concat(fieldId, ".modifyCode"),
                        label: "Modification Code",
                        type: "code",
                        control: control,
                        ctx: data.ctx,
                        showPreview: true
                    })
                ]
            })
        ]
    }) : null;
};
var UserTrigger = function(param) {
    var index = param.index, field = param.field, name = param.name, controls = param.controls, control = param.control, userFields = param.userFields, expanded = param.expanded, toggle = param.toggle;
    var ref, ref1;
    var data = (0,DataProviders/* useDataProvider */.x5)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetUser */.pg)({
        _id: data === null || data === void 0 ? void 0 : (ref = data.ctx) === null || ref === void 0 ? void 0 : (ref1 = ref.entry) === null || ref1 === void 0 ? void 0 : ref1[field === null || field === void 0 ? void 0 : field.userId],
        silent: true
    }), 1), user = ref2[0];
    var ctx = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.ctx), {
        user: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
            firstName: undefined,
            lastName: undefined,
            author: undefined
        })
    });
    return expanded ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
        label: (0,Text/* capitalizeFirst */.Ez)(field === null || field === void 0 ? void 0 : field.userId),
        border: true,
        cols: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldControls/* FieldControls */.g, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* DotsHorizontalIcon */.nWS, {}),
                    ghost: true
                })
            }, controls), {
                style: {
                    position: "absolute",
                    right: 0,
                    top: 0,
                    minWidth: 5
                },
                index: index
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(name, ".userId"),
                label: "User Id",
                type: "select",
                control: control,
                options: userFields
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                name: "".concat(name, ".code"),
                label: "Code",
                type: "code",
                control: control,
                ctx: ctx,
                showPreview: true
            })
        ]
    }, index) : null;
};

// EXTERNAL MODULE: ./src/mosanic/core/Collections/Field/FieldType.js + 1 modules
var FieldType = __webpack_require__(26168);
// EXTERNAL MODULE: ./src/mosanic/Icons/StateIcons.js
var StateIcons = __webpack_require__(46669);
;// CONCATENATED MODULE: ./src/mosanic/core/Collections/Field/Header.js








var FieldHeaderLabels = function(param) {
    var _level = param.level, level = _level === void 0 ? 0 : _level, _info = param.info, info = _info === void 0 ? {
        field_name: "Field name",
        field_label: "Display Label",
        field_type: "field type",
        field_controls: "Controls"
    } : _info;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collection_styles/* default.FieldHeader */.Z.FieldHeader, {
        expanded: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styles/* default.HeaderField */.Z.HeaderField, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collection_styles/* default.HeaderLabel */.Z.HeaderLabel, {
                    children: [
                        level ? "".concat(level, ".") : "",
                        info.field_name
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styles/* default.HeaderLabel */.Z.HeaderLabel, {
                children: info.field_label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styles/* default.HeaderType */.Z.HeaderType, {
                children: info.field_type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: "100px",
                    paddingLeft: "20px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styles/* default.HeaderLabel */.Z.HeaderLabel, {
                    children: info.field_controls
                })
            })
        ]
    });
};
var FieldHeader = function(param) {
    var _displayName = param.displayName, displayName = _displayName === void 0 ? false : _displayName, _isFirstField = param.isFirstField, isFirstField = _isFirstField === void 0 ? false : _isFirstField, controls = param.controls, inputProps = param.inputProps, restricted = param.restricted, duplicate = param.duplicate, expanded = param.expanded, toggle = param.toggle, level = param.level, fieldId = param.fieldId, index = param.index, getField = param.getField, getType = param.getType;
    var ref;
    var name = getField("name");
    var alert = (ref = (0,_to_consumable_array/* default */.Z)(restricted).concat((0,_to_consumable_array/* default */.Z)(duplicate))) === null || ref === void 0 ? void 0 : ref.includes(name);
    var notAllowed = restricted === null || restricted === void 0 ? void 0 : restricted.includes(name);
    var repeated = duplicate === null || duplicate === void 0 ? void 0 : duplicate.includes(name);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collection_styles/* default.FieldHeader */.Z.FieldHeader, {
        expanded: expanded === null || expanded === void 0 ? void 0 : expanded[index],
        level: level,
        style: {
            border: "1px solid ".concat(alert ? "red" : "white")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styles/* default.HeaderField */.Z.HeaderField, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    wrap: false,
                    name: "".concat(fieldId, ".name"),
                    label: (0,Text/* combineString */.M7)([
                        "Field name",
                        notAllowed && "[restricted]",
                        repeated && "[repeated]"
                    ], " "),
                    type: "text"
                }, inputProps), {
                    ninja: !alert && name,
                    rules: {
                        required: true
                    }
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styles/* default.HeaderLabel */.Z.HeaderLabel, {
                onClick: function() {
                    return name ? toggle(index) : null;
                },
                children: !isFirstField ? getField("label") ? getField("label") : (0,Text/* revertDevCases */.Uw)(name) : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styles/* default.HeaderType */.Z.HeaderType, {
                onClick: function() {
                    return name ? toggle(index) : null;
                },
                children: isFirstField ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        StateIcons/* uniqueIcon */.Jl,
                        " Entry ID"
                    ]
                }) : getType(index)
            }),
            controls
        ]
    });
};

;// CONCATENATED MODULE: ./src/mosanic/core/Collections/Field/CollectionField.js



















var CollectionField = function(param) {
    var id = param.id, fieldId = param.fieldId, expanded = param.expanded, toggle = param.toggle, index = param.index, dragHandle = param.dragHandle, move = param.move, remove = param.remove, fieldCount = param.fieldCount, _level = param.level, level = _level === void 0 ? 0 : _level, _skipFirstField = param.skipFirstField, skipFirstField = _skipFirstField === void 0 ? false : _skipFirstField;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,DataProviders/* useDataProvider */.x5)(), collections = ref7.collections, zones = ref7.zones, filters = ref7.filters;
    var ref8 = (0,router.useRouter)(), locales = ref8.locales, locale = ref8.locale;
    var ref9 = (0,index_esm/* useFormContext */.Gc)(), control = ref9.control, setValue = ref9.setValue, watch = ref9.watch, isValid = ref9.formState.isValid;
    var source = (0,value/* getValue */.NA)(watch(), id, false);
    var inputProps = {
        control: control,
        fullWidth: true,
        size: "small"
    };
    //Reduce does separated fieldId path to object and get certain key.
    var getField = function(key) {
        var ref;
        return (ref = (0,value/* getValue */.NA)(watch(), fieldId, false)) === null || ref === void 0 ? void 0 : ref[key];
    };
    var getType = function(i) {
        return getField("type");
    };
    var fieldType = getField("type");
    var isFirstField = Boolean(index === 0) && !skipFirstField;
    var isInList = function(list) {
        return list.split("|").includes(fieldType);
    };
    var isField = function(field) {
        return field === fieldType;
    };
    var restrict = {
        meta: isInList("label|label|group") || isFirstField,
        default: isInList("repeater|relation|label|group") || isFirstField,
        localize: !getField("localized") || (locales === null || locales === void 0 ? void 0 : locales.length) < 2,
        validation: !isInList("text|textarea|email|number|link|visual|code|repeater|button|relation|select"),
        visibility: isInList("label|label|group")
    };
    var groupProps = {
        control: control,
        fieldId: fieldId,
        fieldType: fieldType,
        getField: function(f) {
            return getField(f);
        }
    };
    var options = (ref = getField("values")) === null || ref === void 0 ? void 0 : ref.split("\n");
    if ((0,Text/* containsSubstr */.xX)(options === null || options === void 0 ? void 0 : options[0], ":")) options = options.map(function(o) {
        var ref;
        return {
            value: (0,Text/* removeSpaces */.I8)(o.split(":")[0]),
            label: ((ref = o.split(":")) === null || ref === void 0 ? void 0 : ref[1]) ? o.split(":")[1] : o.split(":")[0]
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collection_styles/* default.FieldEntry */.Z.FieldEntry, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldHeader, {
                isFirstField: isFirstField,
                displayName: filters === null || filters === void 0 ? void 0 : filters.displayName,
                duplicate: (0,_to_consumable_array/* default */.Z)(source === null || source === void 0 ? void 0 : source.map(function(f, i) {
                    return i != index && (f === null || f === void 0 ? void 0 : f.name);
                })),
                restricted: "_id".split("|"),
                inputProps: inputProps,
                expanded: expanded,
                level: level,
                fieldId: fieldId,
                index: index,
                getField: getField,
                getType: getType,
                toggle: toggle,
                controls: !isFirstField ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldControls/* FieldControls */.g, {
                    dragHandle: dragHandle,
                    remove: remove,
                    move: move,
                    index: index,
                    count: fieldCount,
                    extra: !isFirstField && /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styles/* default.HeaderToggle */.Z.HeaderToggle, {
                        tabindex: "1",
                        expanded: expanded === null || expanded === void 0 ? void 0 : expanded[index],
                        disabled: !getField("name"),
                        onClick: function() {
                            return getField("name") ? toggle(index) : null;
                        },
                        children: HelpIcons/* arrowDownIcon */.MW
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        width: "100px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                expanded: expanded === null || expanded === void 0 ? void 0 : expanded[index],
                fullWidth: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InView/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collection_styles/* default.FieldEntryFields */.Z.FieldEntryFields, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldType/* FieldType */.f, {
                                isFirstField: isFirstField,
                                inputProps: inputProps,
                                fieldId: fieldId,
                                setValue: setValue,
                                fieldType: fieldType
                            }),
                            "code" === fieldType && /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                                    name: "".concat(fieldId, ".codeLang"),
                                    label: "Code language",
                                    type: "select",
                                    options: "js|html|css|json".split("|"),
                                    control: control
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                                name: "".concat(fieldId, ".label"),
                                label: "Label"
                            }, inputProps)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                                name: "".concat(fieldId, ".help"),
                                label: "Help text",
                                type: "textarea"
                            }, inputProps)),
                            !restrict.default && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                                field: (ref1 = watch()) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[id]) === null || ref2 === void 0 ? void 0 : ref2[index],
                                name: "".concat(fieldId, ".default"),
                                setup: true,
                                direction: getField("direction"),
                                label: "Default value",
                                type: fieldType,
                                options: getField("options") ? (ref3 = getField("options")) === null || ref3 === void 0 ? void 0 : ref3.split("\n") : fieldType === "select" ? options : null,
                                noCase: getField("localized") && (locales === null || locales === void 0 ? void 0 : locales.length) >= 2,
                                language: fieldType === "code" ? (0,Text/* toLowCase */.Cc)(getField("codeLang")) : undefined
                            }, inputProps)),
                            !restrict.localize && locales.filter(function(l) {
                                return l != locale;
                            }).map(function(lang) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, (0,_object_spread/* default */.Z)({
                                    name: "".concat(fieldId, ".default_").concat(lang),
                                    label: "Default value ".concat(lang),
                                    type: fieldType,
                                    noCase: true,
                                    language: fieldType === "code" ? (0,Text/* toLowCase */.Cc)(getField("codeLang")) : undefined
                                }, inputProps), fieldId + "" + lang);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldMeta, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, groupProps), {
                                fieldId: fieldId,
                                disabled: restrict.meta
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldVisibility, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, groupProps), {
                                fieldId: fieldId,
                                disabled: restrict.visibility
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldValidation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, groupProps), {
                                fieldId: fieldId,
                                disabled: restrict.validation
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldMarkedImage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, groupProps), {
                                collections: collections,
                                show: isField("markedimage")
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldRelation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, groupProps), {
                                collections: collections,
                                zones: zones,
                                setValue: setValue,
                                show: isField("relation")
                            })),
                            "select" === fieldType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                                border: true,
                                cols: 2,
                                label: "Select settings",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                                        name: "".concat(fieldId, ".multiple"),
                                        label: "Multiple values",
                                        type: "switch",
                                        control: control
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                                        name: "".concat(fieldId, ".searchable"),
                                        label: "Searchable",
                                        type: "switch",
                                        control: control
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                                        name: "".concat(fieldId, ".values"),
                                        fullWidth: true,
                                        label: "Selectable Values",
                                        placeHolder: "Example: \nmain \nsub \nthird",
                                        type: "textarea",
                                        control: control
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChoiceType, {
                                fieldId: fieldId,
                                fieldType: fieldType,
                                control: control,
                                show: isInList("radio|checkbox|buttonGroup")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldUser, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, groupProps), {
                                show: isField("user")
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldGroup, {
                                fieldId: fieldId,
                                level: level,
                                show: isInList("group|column")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldRepeat, {
                                fieldId: fieldId,
                                level: level,
                                show: isField("repeater"),
                                label: "".concat((0,Text/* capitalizeFirst */.Ez)(fieldType), " fields")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldSteps, {
                                fieldId: fieldId,
                                level: level,
                                show: isField("steps"),
                                label: "".concat((0,Text/* capitalizeFirst */.Ez)(fieldType), " fields")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, groupProps), {
                                show: isField("button"),
                                getField: getField,
                                schema: (ref4 = watch()) === null || ref4 === void 0 ? void 0 : ref4.schema,
                                collectionId: (ref5 = watch()) === null || ref5 === void 0 ? void 0 : ref5._id,
                                trigger: (ref6 = watch()) === null || ref6 === void 0 ? void 0 : ref6.trigger
                            }))
                        ]
                    })
                })
            })
        ]
    }, fieldId);
};

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/redux/es/redux.js
var redux = __webpack_require__(18717);
;// CONCATENATED MODULE: ../../node_modules/use-memo-one/dist/use-memo-one.esm.js


function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne(getResult, inputs) {
  var initial = (0,react.useState)(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var isFirstRun = (0,react.useRef)(true);
  var committed = (0,react.useRef)(initial);
  var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
  var cache = useCache ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  (0,react.useEffect)(function () {
    isFirstRun.current = false;
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function useCallbackOne(callback, inputs) {
  return useMemoOne(function () {
    return callback;
  }, inputs);
}
var useMemo = useMemoOne;
var useCallback = useCallbackOne;



;// CONCATENATED MODULE: ../../node_modules/tiny-invariant/dist/tiny-invariant.esm.js
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix + ": " + provided : prefix;
    throw new Error(value);
}



;// CONCATENATED MODULE: ../../node_modules/css-box-model/dist/css-box-model.esm.js


var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};
var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ?  false ? 0 : invariant(false) : void 0;
  return result;
};

var getWindowScroll = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};
var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll();
  }

  return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse(styles.marginTop),
    right: parse(styles.marginRight),
    bottom: parse(styles.marginBottom),
    left: parse(styles.marginLeft)
  };
  var padding = {
    top: parse(styles.paddingTop),
    right: parse(styles.paddingRight),
    bottom: parse(styles.paddingBottom),
    left: parse(styles.paddingLeft)
  };
  var border = {
    top: parse(styles.borderTopWidth),
    right: parse(styles.borderRightWidth),
    bottom: parse(styles.borderBottomWidth),
    left: parse(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};
var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};



// EXTERNAL MODULE: ../../node_modules/memoize-one/dist/memoize-one.esm.js
var memoize_one_esm = __webpack_require__(36631);
;// CONCATENATED MODULE: ../../node_modules/raf-schd/dist/raf-schd.esm.js
var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
};

/* harmony default export */ var raf_schd_esm = (rafSchd);

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/react-beautiful-dnd/dist/react-beautiful-dnd.esm.js











var react_beautiful_dnd_esm_isProduction = "production" === 'production';
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;

var clean = function clean(value) {
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
};

var getDevMessage = function getDevMessage(message) {
  return clean("\n  %creact-beautiful-dnd\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};

var getFormattedMessage = function getFormattedMessage(message) {
  return [getDevMessage(message), 'color: #00C584; font-size: 1.2em; font-weight: bold;', 'line-height: 1.5', 'color: #723874;'];
};
var isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function log(type, message) {
  var _console;

  if (react_beautiful_dnd_esm_isProduction) {
    return;
  }

  if (typeof window !== 'undefined' && window[isDisabledFlag]) {
    return;
  }

  (_console = console)[type].apply(_console, getFormattedMessage(message));
}
var warning = log.bind(null, 'warn');
var error = log.bind(null, 'error');

function noop() {}

function getOptions(shared, fromBinding) {
  return (0,esm_extends/* default */.Z)({}, shared, {}, fromBinding);
}

function bindEvents(el, bindings, sharedOptions) {
  var unbindings = bindings.map(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
    return function unbind() {
      el.removeEventListener(binding.eventName, binding.fn, options);
    };
  });
  return function unbindAll() {
    unbindings.forEach(function (unbind) {
      unbind();
    });
  };
}

var isProduction$1 = "production" === 'production';
var react_beautiful_dnd_esm_prefix = 'Invariant failed';
function RbdInvariant(message) {
  this.message = message;
}

RbdInvariant.prototype.toString = function toString() {
  return this.message;
};

function react_beautiful_dnd_esm_invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction$1) {
    throw new RbdInvariant(react_beautiful_dnd_esm_prefix);
  } else {
    throw new RbdInvariant(react_beautiful_dnd_esm_prefix + ": " + (message || ''));
  }
}

var ErrorBoundary = function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.callbacks = null;
    _this.unbind = noop;

    _this.onWindowError = function (event) {
      var callbacks = _this.getCallbacks();

      if (callbacks.isDragging()) {
        callbacks.tryAbort();
         false ? 0 : void 0;
      }

      var err = event.error;

      if (err instanceof RbdInvariant) {
        event.preventDefault();

        if (false) {}
      }
    };

    _this.getCallbacks = function () {
      if (!_this.callbacks) {
        throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
      }

      return _this.callbacks;
    };

    _this.setCallbacks = function (callbacks) {
      _this.callbacks = callbacks;
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.unbind = bindEvents(window, [{
      eventName: 'error',
      fn: this.onWindowError
    }]);
  };

  _proto.componentDidCatch = function componentDidCatch(err) {
    if (err instanceof RbdInvariant) {
      if (false) {}

      this.setState({});
      return;
    }

    throw err;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unbind();
  };

  _proto.render = function render() {
    return this.props.children(this.setCallbacks);
  };

  return ErrorBoundary;
}(react.Component);

var dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";

var position = function position(index) {
  return index + 1;
};

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + position(start.source.index) + "\n";
};

var withLocation = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position(source.index);
  var endPosition = position(destination.index);

  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }

  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};

var withCombine = function withCombine(id, source, combine) {
  var inHomeList = source.droppableId === combine.droppableId;

  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
  }

  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};

var onDragUpdate = function onDragUpdate(update) {
  var location = update.destination;

  if (location) {
    return withLocation(update.source, location);
  }

  var combine = update.combine;

  if (combine) {
    return withCombine(update.draggableId, update.source, combine);
  }

  return 'You are over an area that cannot be dropped on';
};

var returnedToStart = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
  }

  var location = result.destination;
  var combine = result.combine;

  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
  }

  if (combine) {
    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
  }

  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};

var preset = {
  dragHandleUsageInstructions: dragHandleUsageInstructions,
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};

var origin = {
  x: 0,
  y: 0
};
var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};
var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};
var apply = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var executeClip = (function (frame, subject) {
  var result = getRect({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
});

var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};
var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};
var react_beautiful_dnd_esm_noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var react_beautiful_dnd_esm_scroll = function scroll(target, frame) {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

var increase = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;

    return (0,esm_extends/* default */.Z)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }

  return target;
};

var clip = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }

  return getRect(target);
};

var getSubject = (function (_ref) {
  var page = _ref.page,
      withPlaceholder = _ref.withPlaceholder,
      axis = _ref.axis,
      frame = _ref.frame;
  var scrolled = react_beautiful_dnd_esm_scroll(page.marginBox, frame);
  var increased = increase(scrolled, axis, withPlaceholder);
  var clipped = clip(increased, frame);
  return {
    page: page,
    withPlaceholder: withPlaceholder,
    active: clipped
  };
});

var scrollDroppable = (function (droppable, newScroll) {
  !droppable.frame ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var scrollable = droppable.frame;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);

  var frame = (0,esm_extends/* default */.Z)({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });

  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame: frame
  });

  var result = (0,esm_extends/* default */.Z)({}, droppable, {
    frame: frame,
    subject: subject
  });

  return result;
});

function isInteger(value) {
  if (Number.isInteger) {
    return Number.isInteger(value);
  }

  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function values(map) {
  if (Object.values) {
    return Object.values(map);
  }

  return Object.keys(map).map(function (key) {
    return map[key];
  });
}
function findIndex(list, predicate) {
  if (list.findIndex) {
    return list.findIndex(predicate);
  }

  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return i;
    }
  }

  return -1;
}
function find(list, predicate) {
  if (list.find) {
    return list.find(predicate);
  }

  var index = findIndex(list, predicate);

  if (index !== -1) {
    return list[index];
  }

  return undefined;
}
function toArray(list) {
  return Array.prototype.slice.call(list);
}

var toDroppableMap = (0,memoize_one_esm["default"])(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = (0,memoize_one_esm["default"])(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = (0,memoize_one_esm["default"])(function (droppables) {
  return values(droppables);
});
var toDraggableList = (0,memoize_one_esm["default"])(function (draggables) {
  return values(draggables);
});

var getDraggablesInsideDroppable = (0,memoize_one_esm["default"])(function (droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function (draggable) {
    return droppableId === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
  return result;
});

function tryGetDestination(impact) {
  if (impact.at && impact.at.type === 'REORDER') {
    return impact.at.destination;
  }

  return null;
}
function tryGetCombine(impact) {
  if (impact.at && impact.at.type === 'COMBINE') {
    return impact.at.combine;
  }

  return null;
}

var removeDraggableFromList = (0,memoize_one_esm["default"])(function (remove, list) {
  return list.filter(function (item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});

var moveToNextCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var location = tryGetDestination(previousImpact);

  if (!location) {
    return null;
  }

  function getImpact(target) {
    var at = {
      type: 'COMBINE',
      combine: {
        draggableId: target,
        droppableId: destination.descriptor.id
      }
    };
    return (0,esm_extends/* default */.Z)({}, previousImpact, {
      at: at
    });
  }

  var all = previousImpact.displaced.all;
  var closestId = all.length ? all[0] : null;

  if (isMovingForward) {
    return closestId ? getImpact(closestId) : null;
  }

  var withoutDraggable = removeDraggableFromList(draggable, insideDestination);

  if (!closestId) {
    if (!withoutDraggable.length) {
      return null;
    }

    var last = withoutDraggable[withoutDraggable.length - 1];
    return getImpact(last.descriptor.id);
  }

  var indexOfClosest = findIndex(withoutDraggable, function (d) {
    return d.descriptor.id === closestId;
  });
  !(indexOfClosest !== -1) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var proposedIndex = indexOfClosest - 1;

  if (proposedIndex < 0) {
    return null;
  }

  var before = withoutDraggable[proposedIndex];
  return getImpact(before.descriptor.id);
});

var isHomeOf = (function (draggable, destination) {
  return draggable.descriptor.droppableId === destination.descriptor.id;
});

var noDisplacedBy = {
  point: origin,
  value: 0
};
var emptyGroups = {
  invisible: {},
  visible: {},
  all: []
};
var noImpact = {
  displaced: emptyGroups,
  displacedBy: noDisplacedBy,
  at: null
};

var isWithin = (function (lowerBound, upperBound) {
  return function (value) {
    return lowerBound <= value && value <= upperBound;
  };
});

var isPartiallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
});

var isTotallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
});

var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var isTotallyVisibleThroughFrameOnAxis = (function (axis) {
  return function (frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function (subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }

      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
});

var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition(target, displacement);
};

var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }

  return isVisibleThroughFrameFn(destination.subject.active)(target);
};

var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};

var isVisible = function isVisible(_ref) {
  var toBeDisplaced = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};

var isPartiallyVisible = function isPartiallyVisible(args) {
  return isVisible((0,esm_extends/* default */.Z)({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};
var isTotallyVisible = function isTotallyVisible(args) {
  return isVisible((0,esm_extends/* default */.Z)({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};
var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
  return isVisible((0,esm_extends/* default */.Z)({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};

var getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
  if (typeof forceShouldAnimate === 'boolean') {
    return forceShouldAnimate;
  }

  if (!last) {
    return true;
  }

  var invisible = last.invisible,
      visible = last.visible;

  if (invisible[id]) {
    return false;
  }

  var previous = visible[id];
  return previous ? previous.shouldAnimate : true;
};

function getTarget(draggable, displacedBy) {
  var marginBox = draggable.page.marginBox;
  var expandBy = {
    top: displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: displacedBy.point.x
  };
  return getRect(expand(marginBox, expandBy));
}

function getDisplacementGroups(_ref) {
  var afterDragging = _ref.afterDragging,
      destination = _ref.destination,
      displacedBy = _ref.displacedBy,
      viewport = _ref.viewport,
      forceShouldAnimate = _ref.forceShouldAnimate,
      last = _ref.last;
  return afterDragging.reduce(function process(groups, draggable) {
    var target = getTarget(draggable, displacedBy);
    var id = draggable.descriptor.id;
    groups.all.push(id);
    var isVisible = isPartiallyVisible({
      target: target,
      destination: destination,
      viewport: viewport,
      withDroppableDisplacement: true
    });

    if (!isVisible) {
      groups.invisible[draggable.descriptor.id] = true;
      return groups;
    }

    var shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
    var displacement = {
      draggableId: id,
      shouldAnimate: shouldAnimate
    };
    groups.visible[id] = displacement;
    return groups;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}

function getIndexOfLastItem(draggables, options) {
  if (!draggables.length) {
    return 0;
  }

  var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
  return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}

function goAtEnd(_ref) {
  var insideDestination = _ref.insideDestination,
      inHomeList = _ref.inHomeList,
      displacedBy = _ref.displacedBy,
      destination = _ref.destination;
  var newIndex = getIndexOfLastItem(insideDestination, {
    inHomeList: inHomeList
  });
  return {
    displaced: emptyGroups,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: newIndex
      }
    }
  };
}

function calculateReorderImpact(_ref2) {
  var draggable = _ref2.draggable,
      insideDestination = _ref2.insideDestination,
      destination = _ref2.destination,
      viewport = _ref2.viewport,
      displacedBy = _ref2.displacedBy,
      last = _ref2.last,
      index = _ref2.index,
      forceShouldAnimate = _ref2.forceShouldAnimate;
  var inHomeList = isHomeOf(draggable, destination);

  if (index == null) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var match = find(insideDestination, function (item) {
    return item.descriptor.index === index;
  });

  if (!match) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var sliceFrom = insideDestination.indexOf(match);
  var impacted = withoutDragging.slice(sliceFrom);
  var displaced = getDisplacementGroups({
    afterDragging: impacted,
    destination: destination,
    displacedBy: displacedBy,
    last: last,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate
  });
  return {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: index
      }
    }
  };
}

function didStartAfterCritical(draggableId, afterCritical) {
  return Boolean(afterCritical.effected[draggableId]);
}

var fromCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      destination = _ref.destination,
      draggables = _ref.draggables,
      combine = _ref.combine,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var combineId = combine.draggableId;
  var combineWith = draggables[combineId];
  var combineWithIndex = combineWith.descriptor.index;
  var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);

  if (didCombineWithStartAfterCritical) {
    if (isMovingForward) {
      return combineWithIndex;
    }

    return combineWithIndex - 1;
  }

  if (isMovingForward) {
    return combineWithIndex + 1;
  }

  return combineWithIndex;
});

var fromReorder = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      insideDestination = _ref.insideDestination,
      location = _ref.location;

  if (!insideDestination.length) {
    return null;
  }

  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  var firstIndex = insideDestination[0].descriptor.index;
  var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
  var upperBound = isInHomeList ? lastIndex : lastIndex + 1;

  if (proposedIndex < firstIndex) {
    return null;
  }

  if (proposedIndex > upperBound) {
    return null;
  }

  return proposedIndex;
});

var moveToNextIndex = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var wasAt = previousImpact.at;
  !wasAt ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

  if (wasAt.type === 'REORDER') {
    var _newIndex = fromReorder({
      isMovingForward: isMovingForward,
      isInHomeList: isInHomeList,
      location: wasAt.destination,
      insideDestination: insideDestination
    });

    if (_newIndex == null) {
      return null;
    }

    return calculateReorderImpact({
      draggable: draggable,
      insideDestination: insideDestination,
      destination: destination,
      viewport: viewport,
      last: previousImpact.displaced,
      displacedBy: previousImpact.displacedBy,
      index: _newIndex
    });
  }

  var newIndex = fromCombine({
    isMovingForward: isMovingForward,
    destination: destination,
    displaced: previousImpact.displaced,
    draggables: draggables,
    combine: wasAt.combine,
    afterCritical: afterCritical
  });

  if (newIndex == null) {
    return null;
  }

  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: previousImpact.displaced,
    displacedBy: previousImpact.displacedBy,
    index: newIndex
  });
});

var getCombinedItemDisplacement = (function (_ref) {
  var displaced = _ref.displaced,
      afterCritical = _ref.afterCritical,
      combineWith = _ref.combineWith,
      displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);

  if (didStartAfterCritical(combineWith, afterCritical)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
});

var whenCombining = (function (_ref) {
  var afterCritical = _ref.afterCritical,
      impact = _ref.impact,
      draggables = _ref.draggables;
  var combine = tryGetCombine(impact);
  !combine ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var combineWith = combine.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: impact.displaced,
    afterCritical: afterCritical,
    combineWith: combineWith,
    displacedBy: impact.displacedBy
  });
  return add(center, displaceBy);
});

var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};

var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};

var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};

var goAfter = function goAfter(_ref) {
  var axis = _ref.axis,
      moveRelativeTo = _ref.moveRelativeTo,
      isMoving = _ref.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore = function goBefore(_ref2) {
  var axis = _ref2.axis,
      moveRelativeTo = _ref2.moveRelativeTo,
      isMoving = _ref2.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart = function goIntoStart(_ref3) {
  var axis = _ref3.axis,
      moveInto = _ref3.moveInto,
      isMoving = _ref3.isMoving;
  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};

var whenReordering = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      afterCritical = _ref.afterCritical;
  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var draggablePage = draggable.page;
  var axis = droppable.axis;

  if (!insideDestination.length) {
    return goIntoStart({
      axis: axis,
      moveInto: droppable.page,
      isMoving: draggablePage
    });
  }

  var displaced = impact.displaced,
      displacedBy = impact.displacedBy;
  var closestAfter = displaced.all[0];

  if (closestAfter) {
    var closest = draggables[closestAfter];

    if (didStartAfterCritical(closestAfter, afterCritical)) {
      return goBefore({
        axis: axis,
        moveRelativeTo: closest.page,
        isMoving: draggablePage
      });
    }

    var withDisplacement = offset(closest.page, displacedBy.point);
    return goBefore({
      axis: axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }

  var last = insideDestination[insideDestination.length - 1];

  if (last.descriptor.id === draggable.descriptor.id) {
    return draggablePage.borderBox.center;
  }

  if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
    var page = offset(last.page, negate(afterCritical.displacedBy.point));
    return goAfter({
      axis: axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }

  return goAfter({
    axis: axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
});

var withDroppableDisplacement = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
});

var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      afterCritical = _ref.afterCritical;
  var original = draggable.page.borderBox.center;
  var at = impact.at;

  if (!droppable) {
    return original;
  }

  if (!at) {
    return original;
  }

  if (at.type === 'REORDER') {
    return whenReordering({
      impact: impact,
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      afterCritical: afterCritical
    });
  }

  return whenCombining({
    impact: impact,
    draggables: draggables,
    afterCritical: afterCritical
  });
};

var getPageBorderBoxCenterFromImpact = (function (args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
  var droppable = args.droppable;
  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
});

var scrollViewport = (function (viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = getRect({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
});

function getDraggables(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

function tryGetVisible(id, groups) {
  for (var i = 0; i < groups.length; i++) {
    var displacement = groups[i].visible[id];

    if (displacement) {
      return displacement;
    }
  }

  return null;
}

var speculativelyIncrease = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      maxScrollChange = _ref.maxScrollChange;
  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
  var last = impact.displaced;
  var withViewportScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: scrolledViewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var withDroppableScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: scrolledDroppable,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var invisible = {};
  var visible = {};
  var groups = [last, withViewportScroll, withDroppableScroll];
  last.all.forEach(function (id) {
    var displacement = tryGetVisible(id, groups);

    if (displacement) {
      visible[id] = displacement;
      return;
    }

    invisible[id] = true;
  });

  var newImpact = (0,esm_extends/* default */.Z)({}, impact, {
    displaced: {
      all: last.all,
      invisible: invisible,
      visible: visible
    }
  });

  return newImpact;
});

var withViewportDisplacement = (function (viewport, point) {
  return add(viewport.scroll.diff.displacement, point);
});

var getClientFromPageBorderBoxCenter = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
  return add(draggable.client.borderBox.center, offset);
});

var isTotallyVisibleInNewLocation = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination: destination,
    withDroppableDisplacement: withDroppableDisplacement,
    viewport: viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
});

var moveToNextPlace = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      draggables = _ref.draggables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousClientSelection = _ref.previousClientSelection,
      afterCritical = _ref.afterCritical;

  if (!destination.isEnabled) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable, destination);
  var impact = moveToNextCombine({
    isMovingForward: isMovingForward,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact
  }) || moveToNextIndex({
    isMovingForward: isMovingForward,
    isInHomeList: isInHomeList,
    draggable: draggable,
    draggables: draggables,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });

  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      viewport: viewport
    });
    return {
      clientSelection: clientSelection,
      impact: impact,
      scrollJumpRequest: null
    };
  }

  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact: impact,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    maxScrollChange: distance
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance
  };
});

var getKnownActive = function getKnownActive(droppable) {
  var rect = droppable.subject.active;
  !rect ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var active = source.subject.active;

  if (!active) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    return Boolean(droppable.subject.active);
  }).filter(function (droppable) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);

    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }

    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function (a, b) {
    var first = getKnownActive(a)[axis.crossAxisStart];
    var second = getKnownActive(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
    var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));

    if (first !== second) {
      return first - second;
    }

    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
  })[0];
});

var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
  var original = draggable.page.borderBox.center;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
};
var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
  var original = draggable.page.borderBox;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
};

var getClosestDraggable = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      viewport = _ref.viewport,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;
  var sorted = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: getCurrentPageBorderBox(draggable, afterCritical),
      destination: destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.descriptor.index - b.descriptor.index;
  });
  return sorted[0] || null;
});

var getDisplacedBy = (0,memoize_one_esm["default"])(function getDisplacedBy(axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement)
  };
});

var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
  var axis = droppable.axis;

  if (droppable.descriptor.mode === 'virtual') {
    return patch(axis.line, placeholderSize[axis.line]);
  }

  var availableSpace = droppable.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;

  if (needsToGrowBy <= 0) {
    return null;
  }

  return patch(axis.line, needsToGrowBy);
};

var withMaxScroll = function withMaxScroll(frame, max) {
  return (0,esm_extends/* default */.Z)({}, frame, {
    scroll: (0,esm_extends/* default */.Z)({}, frame.scroll, {
      max: max
    })
  });
};

var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
  var frame = droppable.frame;
  !!isHomeOf(draggable, droppable) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  !!droppable.subject.withPlaceholder ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
  var added = {
    placeholderSize: placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
  };

  if (!frame) {
    var _subject = getSubject({
      page: droppable.subject.page,
      withPlaceholder: added,
      axis: droppable.axis,
      frame: droppable.frame
    });

    return (0,esm_extends/* default */.Z)({}, droppable, {
      subject: _subject
    });
  }

  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll(frame, maxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: added,
    axis: droppable.axis,
    frame: newFrame
  });
  return (0,esm_extends/* default */.Z)({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};
var removePlaceholder = function removePlaceholder(droppable) {
  var added = droppable.subject.withPlaceholder;
  !added ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var frame = droppable.frame;

  if (!frame) {
    var _subject2 = getSubject({
      page: droppable.subject.page,
      axis: droppable.axis,
      frame: null,
      withPlaceholder: null
    });

    return (0,esm_extends/* default */.Z)({}, droppable, {
      subject: _subject2
    });
  }

  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var newFrame = withMaxScroll(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    axis: droppable.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return (0,esm_extends/* default */.Z)({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var moveToNewDroppable = (function (_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      moveRelativeTo = _ref.moveRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;

  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }

    var proposed = {
      displaced: emptyGroups,
      displacedBy: noDisplacedBy,
      at: {
        type: 'REORDER',
        destination: {
          droppableId: destination.descriptor.id,
          index: 0
        }
      }
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable,
      droppable: destination,
      draggables: draggables,
      afterCritical: afterCritical
    });
    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }

  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);

  var proposedIndex = function () {
    var relativeTo = moveRelativeTo.descriptor.index;

    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
      return relativeTo;
    }

    if (isGoingBeforeTarget) {
      return relativeTo;
    }

    return relativeTo + 1;
  }();

  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    displacedBy: displacedBy,
    last: emptyGroups,
    index: proposedIndex
  });
});

var moveCrossAxis = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      draggable = _ref.draggable,
      isOver = _ref.isOver,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport: viewport,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    draggables: draggables,
    moveRelativeTo: moveRelativeTo,
    insideDestination: insideDestination,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
  return {
    clientSelection: clientSelection,
    impact: impact,
    scrollJumpRequest: null
  };
});

var whatIsDraggedOver = (function (impact) {
  var at = impact.at;

  if (!at) {
    return null;
  }

  if (at.type === 'REORDER') {
    return at.destination.droppableId;
  }

  return at.combine.droppableId;
});

var getDroppableOver = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};

var moveInDirection = (function (_ref) {
  var state = _ref.state,
      type = _ref.type;
  var isActuallyOver = getDroppableOver(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions,
      draggables = _state$dimensions.draggables,
      droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    destination: isOver,
    draggables: draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    afterCritical: state.afterCritical
  }) : moveCrossAxis({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    isOver: isOver,
    draggables: draggables,
    droppables: droppables,
    viewport: state.viewport,
    afterCritical: state.afterCritical
  });
});

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

function isPositionInFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function run(point) {
    return isWithinVertical(point.y) && isWithinHorizontal(point.x);
  };
}

function getHasOverlap(first, second) {
  return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}

function getFurthestAway(_ref) {
  var pageBorderBox = _ref.pageBorderBox,
      draggable = _ref.draggable,
      candidates = _ref.candidates;
  var startCenter = draggable.page.borderBox.center;
  var sorted = candidates.map(function (candidate) {
    var axis = candidate.axis;
    var target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
    return {
      id: candidate.descriptor.id,
      distance: distance(startCenter, target)
    };
  }).sort(function (a, b) {
    return b.distance - a.distance;
  });
  return sorted[0] ? sorted[0].id : null;
}

function getDroppableOver$1(_ref2) {
  var pageBorderBox = _ref2.pageBorderBox,
      draggable = _ref2.draggable,
      droppables = _ref2.droppables;
  var candidates = toDroppableList(droppables).filter(function (item) {
    if (!item.isEnabled) {
      return false;
    }

    var active = item.subject.active;

    if (!active) {
      return false;
    }

    if (!getHasOverlap(pageBorderBox, active)) {
      return false;
    }

    if (isPositionInFrame(active)(pageBorderBox.center)) {
      return true;
    }

    var axis = item.axis;
    var childCenter = active.center[axis.crossAxisLine];
    var crossAxisStart = pageBorderBox[axis.crossAxisStart];
    var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
    var isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
    var isStartContained = isContained(crossAxisStart);
    var isEndContained = isContained(crossAxisEnd);

    if (!isStartContained && !isEndContained) {
      return true;
    }

    if (isStartContained) {
      return crossAxisStart < childCenter;
    }

    return crossAxisEnd > childCenter;
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0].descriptor.id;
  }

  return getFurthestAway({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    candidates: candidates
  });
}

var offsetRectByPosition = function offsetRectByPosition(rect, point) {
  return getRect(offsetByPosition(rect, point));
};

var withDroppableScroll = (function (droppable, area) {
  var frame = droppable.frame;

  if (!frame) {
    return area;
  }

  return offsetRectByPosition(area, frame.scroll.diff.value);
});

function getIsDisplaced(_ref) {
  var displaced = _ref.displaced,
      id = _ref.id;
  return Boolean(displaced.visible[id] || displaced.invisible[id]);
}

function atIndex(_ref) {
  var draggable = _ref.draggable,
      closest = _ref.closest,
      inHomeList = _ref.inHomeList;

  if (!closest) {
    return null;
  }

  if (!inHomeList) {
    return closest.descriptor.index;
  }

  if (closest.descriptor.index > draggable.descriptor.index) {
    return closest.descriptor.index - 1;
  }

  return closest.descriptor.index;
}

var getReorderImpact = (function (_ref2) {
  var targetRect = _ref2.pageBorderBoxWithDroppableScroll,
      draggable = _ref2.draggable,
      destination = _ref2.destination,
      insideDestination = _ref2.insideDestination,
      last = _ref2.last,
      viewport = _ref2.viewport,
      afterCritical = _ref2.afterCritical;
  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var closest = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childCenter = child.page.borderBox.center[axis.line];
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: last,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd <= childCenter;
      }

      return targetStart < childCenter - displacement;
    }

    if (isDisplaced) {
      return targetEnd <= childCenter + displacement;
    }

    return targetStart < childCenter;
  });
  var newIndex = atIndex({
    draggable: draggable,
    closest: closest,
    inHomeList: isHomeOf(draggable, destination)
  });
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: last,
    displacedBy: displacedBy,
    index: newIndex
  });
});

var combineThresholdDivisor = 4;
var getCombineImpact = (function (_ref) {
  var draggable = _ref.draggable,
      targetRect = _ref.pageBorderBoxWithDroppableScroll,
      previousImpact = _ref.previousImpact,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var combineWith = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childRect = child.page.borderBox;
    var childSize = childRect[axis.size];
    var threshold = childSize / combineThresholdDivisor;
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: previousImpact.displaced,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
      }

      return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
    }

    if (isDisplaced) {
      return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
    }

    return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
  });

  if (!combineWith) {
    return null;
  }

  var impact = {
    displacedBy: displacedBy,
    displaced: previousImpact.displaced,
    at: {
      type: 'COMBINE',
      combine: {
        draggableId: combineWith.descriptor.id,
        droppableId: destination.descriptor.id
      }
    }
  };
  return impact;
});

var getDragImpact = (function (_ref) {
  var pageOffset = _ref.pageOffset,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
  var destinationId = getDroppableOver$1({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    droppables: droppables
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
  return getCombineImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    previousImpact: previousImpact,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  }) || getReorderImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    last: previousImpact.displaced,
    viewport: viewport,
    afterCritical: afterCritical
  });
});

var patchDroppableMap = (function (droppables, updated) {
  var _extends2;

  return (0,esm_extends/* default */.Z)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
});

var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact,
      impact = _ref.impact,
      droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now = whatIsDraggedOver(impact);

  if (!last) {
    return droppables;
  }

  if (last === now) {
    return droppables;
  }

  var lastDroppable = droppables[last];

  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }

  var updated = removePlaceholder(lastDroppable);
  return patchDroppableMap(droppables, updated);
};

var recomputePlaceholders = (function (_ref2) {
  var draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousImpact = _ref2.previousImpact,
      impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder({
    previousImpact: previousImpact,
    impact: impact,
    droppables: droppables
  });
  var isOver = whatIsDraggedOver(impact);

  if (!isOver) {
    return cleaned;
  }

  var droppable = droppables[isOver];

  if (isHomeOf(draggable, droppable)) {
    return cleaned;
  }

  if (droppable.subject.withPlaceholder) {
    return cleaned;
  }

  var patched = addPlaceholder(droppable, draggable, draggables);
  return patchDroppableMap(cleaned, patched);
});

var update = (function (_ref) {
  var state = _ref.state,
      forcedClientSelection = _ref.clientSelection,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport,
      forcedImpact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset = subtract(clientSelection, state.initial.client.selection);
  var client = {
    offset: offset,
    selection: clientSelection,
    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
  };
  var page = {
    selection: add(client.selection, viewport.scroll.current),
    borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
    offset: add(client.offset, viewport.scroll.diff.value)
  };
  var current = {
    client: client,
    page: page
  };

  if (state.phase === 'COLLECTING') {
    return (0,esm_extends/* default */.Z)({
      phase: 'COLLECTING'
    }, state, {
      dimensions: dimensions,
      viewport: viewport,
      current: current
    });
  }

  var draggable = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageOffset: page.offset,
    draggable: draggable,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });

  var result = (0,esm_extends/* default */.Z)({}, state, {
    current: current,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport: viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });

  return result;
});

function getDraggables$1(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

var recompute = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      draggables = _ref.draggables,
      destination = _ref.destination,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var last = impact.displaced;
  var afterDragging = getDraggables$1(last.all, draggables);
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate,
    last: last
  });
  return (0,esm_extends/* default */.Z)({}, impact, {
    displaced: displaced
  });
});

var getClientBorderBoxCenter = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    droppable: droppable,
    afterCritical: afterCritical
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
});

var refreshSnap = (function (_ref) {
  var state = _ref.state,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport;
  !(state.movementMode === 'SNAP') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var draggable = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport: viewport,
    destination: destination,
    draggables: draggables
  });
  var clientSelection = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  return update({
    impact: impact,
    clientSelection: clientSelection,
    state: state,
    dimensions: dimensions,
    viewport: viewport
  });
});

var getHomeLocation = (function (descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
});

var getLiftEffect = (function (_ref) {
  var draggable = _ref.draggable,
      home = _ref.home,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
  var rawIndex = insideHome.indexOf(draggable);
  !(rawIndex !== -1) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var afterDragging = insideHome.slice(rawIndex + 1);
  var effected = afterDragging.reduce(function (previous, item) {
    previous[item.descriptor.id] = true;
    return previous;
  }, {});
  var afterCritical = {
    inVirtualList: home.descriptor.mode === 'virtual',
    displacedBy: displacedBy,
    effected: effected
  };
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: home,
    displacedBy: displacedBy,
    last: null,
    viewport: viewport.frame,
    forceShouldAnimate: false
  });
  var impact = {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: getHomeLocation(draggable.descriptor)
    }
  };
  return {
    impact: impact,
    afterCritical: afterCritical
  };
});

var patchDimensionMap = (function (dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
});

var start = function start(key) {
  if (false) {}
};
var finish = function finish(key) {
  if (false) {}
};

var offsetDraggable = (function (_ref) {
  var draggable = _ref.draggable,
      offset$1 = _ref.offset,
      initialWindowScroll = _ref.initialWindowScroll;
  var client = offset(draggable.client, offset$1);
  var page = withScroll(client, initialWindowScroll);

  var moved = (0,esm_extends/* default */.Z)({}, draggable, {
    placeholder: (0,esm_extends/* default */.Z)({}, draggable.placeholder, {
      client: client
    }),
    client: client,
    page: page
  });

  return moved;
});

var getFrame = (function (droppable) {
  var frame = droppable.frame;
  !frame ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return frame;
});

var adjustAdditionsForScrollChanges = (function (_ref) {
  var additions = _ref.additions,
      updatedDroppables = _ref.updatedDroppables,
      viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function (draggable) {
    var droppableId = draggable.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = getFrame(modified);
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
});

var publishWhileDraggingInVirtual = (function (_ref) {
  var state = _ref.state,
      published = _ref.published;
  start();
  var withScrollChange = published.modified.map(function (update) {
    var existing = state.dimensions.droppables[update.droppableId];
    var scrolled = scrollDroppable(existing, update.scroll);
    return scrolled;
  });

  var droppables = (0,esm_extends/* default */.Z)({}, state.dimensions.droppables, {}, toDroppableMap(withScrollChange));

  var updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
    additions: published.additions,
    updatedDroppables: droppables,
    viewport: state.viewport
  }));

  var draggables = (0,esm_extends/* default */.Z)({}, state.dimensions.draggables, {}, updatedAdditions);

  published.removals.forEach(function (id) {
    delete draggables[id];
  });
  var dimensions = {
    droppables: droppables,
    draggables: draggables
  };
  var wasOverId = whatIsDraggedOver(state.impact);
  var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
  var draggable = dimensions.draggables[state.critical.draggable.id];
  var home = dimensions.droppables[state.critical.droppable.id];

  var _getLiftEffect = getLiftEffect({
    draggable: draggable,
    home: home,
    draggables: draggables,
    viewport: state.viewport
  }),
      onLiftImpact = _getLiftEffect.impact,
      afterCritical = _getLiftEffect.afterCritical;

  var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
  var impact = getDragImpact({
    pageOffset: state.current.page.offset,
    draggable: dimensions.draggables[state.critical.draggable.id],
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: previousImpact,
    viewport: state.viewport,
    afterCritical: afterCritical
  });
  finish();

  var draggingState = (0,esm_extends/* default */.Z)({
    phase: 'DRAGGING'
  }, state, {
    phase: 'DRAGGING',
    impact: impact,
    onLiftImpact: onLiftImpact,
    dimensions: dimensions,
    afterCritical: afterCritical,
    forceShouldAnimate: false
  });

  if (state.phase === 'COLLECTING') {
    return draggingState;
  }

  var dropPending = (0,esm_extends/* default */.Z)({
    phase: 'DROP_PENDING'
  }, draggingState, {
    phase: 'DROP_PENDING',
    reason: state.reason,
    isWaiting: false
  });

  return dropPending;
});

var isSnapping = function isSnapping(state) {
  return state.movementMode === 'SNAP';
};

var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);

  if (!isSnapping(state) || isEnabledChanging) {
    return update({
      state: state,
      dimensions: dimensions
    });
  }

  return refreshSnap({
    state: state,
    dimensions: dimensions
  });
};

function removeScrollJumpRequest(state) {
  if (state.isDragging && state.movementMode === 'SNAP') {
    return (0,esm_extends/* default */.Z)({
      phase: 'DRAGGING'
    }, state, {
      scrollJumpRequest: null
    });
  }

  return state;
}

var idle = {
  phase: 'IDLE',
  completed: null,
  shouldFlush: false
};
var react_beautiful_dnd_esm_reducer = (function (state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'FLUSH') {
    return (0,esm_extends/* default */.Z)({}, idle, {
      shouldFlush: true
    });
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        clientSelection = _action$payload.clientSelection,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        movementMode = _action$payload.movementMode;
    var draggable = dimensions.draggables[critical.draggable.id];
    var home = dimensions.droppables[critical.droppable.id];
    var client = {
      selection: clientSelection,
      borderBoxCenter: draggable.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial),
        offset: add(client.selection, viewport.scroll.diff.value)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
      return !item.isFixedOnPage;
    });

    var _getLiftEffect = getLiftEffect({
      draggable: draggable,
      home: home,
      draggables: dimensions.draggables,
      viewport: viewport
    }),
        impact = _getLiftEffect.impact,
        afterCritical = _getLiftEffect.afterCritical;

    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      movementMode: movementMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      isWindowScrollAllowed: isWindowScrollAllowed,
      impact: impact,
      afterCritical: afterCritical,
      onLiftImpact: impact,
      viewport: viewport,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var _result = (0,esm_extends/* default */.Z)({
      phase: 'COLLECTING'
    }, state, {
      phase: 'COLLECTING'
    });

    return _result;
  }

  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return publishWhileDraggingInVirtual({
      state: state,
      published: action.payload
    });
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _clientSelection = action.payload.client;

    if (isEqual(_clientSelection, state.current.client.selection)) {
      return state;
    }

    return update({
      state: state,
      clientSelection: _clientSelection,
      impact: isSnapping(state) ? state.impact : null
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    if (state.phase === 'DROP_PENDING') {
      return removeScrollJumpRequest(state);
    }

    if (state.phase === 'COLLECTING') {
      return removeScrollJumpRequest(state);
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _action$payload2 = action.payload,
        id = _action$payload2.id,
        newScroll = _action$payload2.newScroll;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var scrolled = scrollDroppable(target, newScroll);
    return postDroppableChange(state, scrolled, false);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _action$payload3 = action.payload,
        _id = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !(_target.isEnabled !== isEnabled) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var updated = (0,esm_extends/* default */.Z)({}, _target, {
      isEnabled: isEnabled
    });

    return postDroppableChange(state, updated, true);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _action$payload4 = action.payload,
        _id2 = _action$payload4.id,
        isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var _updated = (0,esm_extends/* default */.Z)({}, _target2, {
      isCombineEnabled: isCombineEnabled
    });

    return postDroppableChange(state, _updated, true);
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !state.isWindowScrollAllowed ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _newScroll = action.payload.newScroll;

    if (isEqual(state.viewport.scroll.current, _newScroll)) {
      return removeScrollJumpRequest(state);
    }

    var _viewport = scrollViewport(state.viewport, _newScroll);

    if (isSnapping(state)) {
      return refreshSnap({
        state: state,
        viewport: _viewport
      });
    }

    return update({
      state: state,
      viewport: _viewport
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    if (!isMovementAllowed(state)) {
      return state;
    }

    var maxScroll = action.payload.maxScroll;

    if (isEqual(maxScroll, state.viewport.scroll.max)) {
      return state;
    }

    var withMaxScroll = (0,esm_extends/* default */.Z)({}, state.viewport, {
      scroll: (0,esm_extends/* default */.Z)({}, state.viewport.scroll, {
        max: maxScroll
      })
    });

    return (0,esm_extends/* default */.Z)({
      phase: 'DRAGGING'
    }, state, {
      viewport: withMaxScroll
    });
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return update({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var newState = (0,esm_extends/* default */.Z)({
      phase: 'DROP_PENDING'
    }, state, {
      phase: 'DROP_PENDING',
      isWaiting: true,
      reason: reason
    });

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        completed = _action$payload5.completed,
        dropDuration = _action$payload5.dropDuration,
        newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      completed: completed,
      dropDuration: dropDuration,
      newHomeClientOffset: newHomeClientOffset,
      dimensions: state.dimensions
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    var _completed = action.payload.completed;
    return {
      phase: 'IDLE',
      completed: _completed,
      shouldFlush: false
    };
  }

  return state;
});

var beforeInitialCapture = function beforeInitialCapture(args) {
  return {
    type: 'BEFORE_INITIAL_CAPTURE',
    payload: args
  };
};
var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};
var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};
var publishWhileDragging = function publishWhileDragging(args) {
  return {
    type: 'PUBLISH_WHILE_DRAGGING',
    payload: args
  };
};
var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};
var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};
var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};
var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
    payload: args
  };
};
var move = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};
var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};
var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: args
  };
};
var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};
var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};
var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};
var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};
var flush = function flush() {
  return {
    type: 'FLUSH',
    payload: null
  };
};
var animateDrop = function animateDrop(args) {
  return {
    type: 'DROP_ANIMATE',
    payload: args
  };
};
var completeDrop = function completeDrop(args) {
  return {
    type: 'DROP_COMPLETE',
    payload: args
  };
};
var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};
var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};
var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

function checkIndexes(insideDestination) {
  if (insideDestination.length <= 1) {
    return;
  }

  var indexes = insideDestination.map(function (d) {
    return d.descriptor.index;
  });
  var errors = {};

  for (var i = 1; i < indexes.length; i++) {
    var current = indexes[i];
    var previous = indexes[i - 1];

    if (current !== previous + 1) {
      errors[current] = true;
    }
  }

  if (!Object.keys(errors).length) {
    return;
  }

  var formatted = indexes.map(function (index) {
    var hasError = Boolean(errors[index]);
    return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
  }).join(', ');
   false ? 0 : void 0;
}

function validateDimensions(critical, dimensions) {
  if (false) { var insideDestination; }
}

var lift$1 = (function (marshal) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        var _action$payload = action.payload,
            id = _action$payload.id,
            clientSelection = _action$payload.clientSelection,
            movementMode = _action$payload.movementMode;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop({
            completed: initial.completed
          }));
        }

        !(getState().phase === 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
        dispatch(flush());
        dispatch(beforeInitialCapture({
          draggableId: id,
          movementMode: movementMode
        }));
        var scrollOptions = {
          shouldPublishImmediately: movementMode === 'SNAP'
        };
        var request = {
          draggableId: id,
          scrollOptions: scrollOptions
        };

        var _marshal$startPublish = marshal.startPublishing(request),
            critical = _marshal$startPublish.critical,
            dimensions = _marshal$startPublish.dimensions,
            viewport = _marshal$startPublish.viewport;

        validateDimensions(critical, dimensions);
        dispatch(initialPublish({
          critical: critical,
          dimensions: dimensions,
          clientSelection: clientSelection,
          movementMode: movementMode,
          viewport: viewport
        }));
      };
    };
  };
});

var style = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.completed.result.reason);
        }

        if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
});

var curves = {
  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
  drop: 'cubic-bezier(.2,1,.1,1)'
};
var combine = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};

var moveTo = function moveTo(offset) {
  return isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};

var transforms = {
  moveTo: moveTo,
  drop: function drop(offset, isCombining) {
    var translate = moveTo(offset);

    if (!translate) {
      return null;
    }

    if (!isCombining) {
      return translate;
    }

    return translate + " scale(" + combine.scale.drop + ")";
  }
};

var minDropTime = timings.minDropTime,
    maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = (function (_ref) {
  var current = _ref.current,
      destination = _ref.destination,
      reason = _ref.reason;
  var distance$1 = distance(current, destination);

  if (distance$1 <= 0) {
    return minDropTime;
  }

  if (distance$1 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }

  var percentage = distance$1 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
});

var getNewHomeClientOffset = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      dimensions = _ref.dimensions,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home = droppables[draggable.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    afterCritical: afterCritical,
    droppable: destination || home,
    viewport: viewport
  });
  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
  return offset;
});

var getDropImpact = (function (_ref) {
  var draggables = _ref.draggables,
      reason = _ref.reason,
      lastImpact = _ref.lastImpact,
      home = _ref.home,
      viewport = _ref.viewport,
      onLiftImpact = _ref.onLiftImpact;

  if (!lastImpact.at || reason !== 'DROP') {
    var recomputedHomeImpact = recompute({
      draggables: draggables,
      impact: onLiftImpact,
      destination: home,
      viewport: viewport,
      forceShouldAnimate: true
    });
    return {
      impact: recomputedHomeImpact,
      didDropInsideDroppable: false
    };
  }

  if (lastImpact.at.type === 'REORDER') {
    return {
      impact: lastImpact,
      didDropInsideDroppable: true
    };
  }

  var withoutMovement = (0,esm_extends/* default */.Z)({}, lastImpact, {
    displaced: emptyGroups
  });

  return {
    impact: withoutMovement,
    didDropInsideDroppable: true
  };
});

var drop$1 = (function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;
      var draggable = dimensions.draggables[state.critical.draggable.id];

      var _getDropImpact = getDropImpact({
        reason: reason,
        lastImpact: state.impact,
        afterCritical: state.afterCritical,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }),
          impact = _getDropImpact.impact,
          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;

      var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
      var combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable.descriptor.id,
        type: draggable.descriptor.type,
        source: source,
        reason: reason,
        mode: state.movementMode,
        destination: destination,
        combine: combine
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact: impact,
        draggable: draggable,
        dimensions: dimensions,
        viewport: state.viewport,
        afterCritical: state.afterCritical
      });
      var completed = {
        critical: state.critical,
        afterCritical: state.afterCritical,
        result: result,
        impact: impact
      };
      var isAnimationRequired = !isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);

      if (!isAnimationRequired) {
        dispatch(completeDrop({
          completed: completed
        }));
        return;
      }

      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason: reason
      });
      var args = {
        newHomeClientOffset: newHomeClientOffset,
        dropDuration: dropDuration,
        completed: completed
      };
      dispatch(animateDrop(args));
    };
  };
});

var react_beautiful_dnd_esm_getWindowScroll = (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});

function getWindowScrollBinding(update) {
  return {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn(event) {
      if (event.target !== window && event.target !== window.document) {
        return;
      }

      update();
    }
  };
}

function getScrollListener(_ref) {
  var onWindowScroll = _ref.onWindowScroll;

  function updateScroll() {
    onWindowScroll(react_beautiful_dnd_esm_getWindowScroll());
  }

  var scheduled = raf_schd_esm(updateScroll);
  var binding = getWindowScrollBinding(scheduled);
  var unbind = noop;

  function isActive() {
    return unbind !== noop;
  }

  function start() {
    !!isActive() ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    unbind = bindEvents(window, [binding]);
  }

  function stop() {
    !isActive() ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    scheduled.cancel();
    unbind();
    unbind = noop;
  }

  return {
    start: start,
    stop: stop,
    isActive: isActive
  };
}

var shouldEnd = function shouldEnd(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var scrollListener = (function (store) {
  var listener = getScrollListener({
    onWindowScroll: function onWindowScroll(newScroll) {
      store.dispatch(moveByWindowScroll({
        newScroll: newScroll
      }));
    }
  });
  return function (next) {
    return function (action) {
      if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') {
        listener.start();
      }

      if (listener.isActive() && shouldEnd(action)) {
        listener.stop();
      }

      next(action);
    };
  };
});

var getExpiringAnnounce = (function (announce) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
       false ? 0 : void 0;
      return;
    }

    if (isExpired) {
       false ? 0 : void 0;
      return;
    }

    wasCalled = true;
    announce(message);
    clearTimeout(timeoutId);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
});

var getAsyncMarshal = (function () {
  var entries = [];

  var execute = function execute(timerId) {
    var index = findIndex(entries, function (item) {
      return item.timerId === timerId;
    });
    !(index !== -1) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var _entries$splice = entries.splice(index, 1),
        entry = _entries$splice[0];

    entry.callback();
  };

  var add = function add(fn) {
    var timerId = setTimeout(function () {
      return execute(timerId);
    });
    var entry = {
      timerId: timerId,
      callback: fn
    };
    entries.push(entry);
  };

  var flush = function flush() {
    if (!entries.length) {
      return;
    }

    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function (entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };

  return {
    add: add,
    flush: flush
  };
});

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};
var isCombineEqual = function isCombineEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var withTimings = function withTimings(key, fn) {
  start();
  fn();
  finish();
};

var getDragStart = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode: mode
  };
};

var execute = function execute(responder, data, announce, getDefaultMessage) {
  if (!responder) {
    announce(getDefaultMessage(data));
    return;
  }

  var willExpire = getExpiringAnnounce(announce);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);

  if (!willExpire.wasCalled()) {
    announce(getDefaultMessage(data));
  }
};

var getPublisher = (function (getResponders, announce) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;

  var beforeCapture = function beforeCapture(draggableId, mode) {
    !!dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    withTimings('onBeforeCapture', function () {
      var fn = getResponders().onBeforeCapture;

      if (fn) {
        var before = {
          draggableId: draggableId,
          mode: mode
        };
        fn(before);
      }
    });
  };

  var beforeStart = function beforeStart(critical, mode) {
    !!dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    withTimings('onBeforeDragStart', function () {
      var fn = getResponders().onBeforeDragStart;

      if (fn) {
        fn(getDragStart(critical, mode));
      }
    });
  };

  var start = function start(critical, mode) {
    !!dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var data = getDragStart(critical, mode);
    dragging = {
      mode: mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function () {
      withTimings('onDragStart', function () {
        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
      });
    });
  };

  var update = function update(critical, impact) {
    var location = tryGetDestination(impact);
    var combine = tryGetCombine(impact);
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);

    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }

    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);

    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }

    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);

    if (hasGroupingChanged) {
      dragging.lastCombine = combine;
    }

    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }

    var data = (0,esm_extends/* default */.Z)({}, getDragStart(critical, dragging.mode), {
      combine: combine,
      destination: location
    });

    asyncMarshal.add(function () {
      withTimings('onDragUpdate', function () {
        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
      });
    });
  };

  var flush = function flush() {
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    asyncMarshal.flush();
  };

  var drop = function drop(result) {
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    dragging = null;
    withTimings('onDragEnd', function () {
      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
    });
  };

  var abort = function abort() {
    if (!dragging) {
      return;
    }

    var result = (0,esm_extends/* default */.Z)({}, getDragStart(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: 'CANCEL'
    });

    drop(result);
  };

  return {
    beforeCapture: beforeCapture,
    beforeStart: beforeStart,
    start: start,
    update: update,
    flush: flush,
    drop: drop,
    abort: abort
  };
});

var responders = (function (getResponders, announce) {
  var publisher = getPublisher(getResponders, announce);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'BEFORE_INITIAL_CAPTURE') {
          publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload.completed.result;
          publisher.flush();
          next(action);
          publisher.drop(result);
          return;
        }

        next(action);

        if (action.type === 'FLUSH') {
          publisher.abort();
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
});

var dropAnimationFinish = (function (store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      store.dispatch(completeDrop({
        completed: state.completed
      }));
    };
  };
});

var dropAnimationFlushOnScroll = (function (store) {
  var unbind = null;
  var frameId = null;

  function clear() {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }

    if (unbind) {
      unbind();
      unbind = null;
    }
  }

  return function (next) {
    return function (action) {
      if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') {
        clear();
      }

      next(action);

      if (action.type !== 'DROP_ANIMATE') {
        return;
      }

      var binding = {
        eventName: 'scroll',
        options: {
          capture: true,
          passive: false,
          once: true
        },
        fn: function flushDropAnimation() {
          var state = store.getState();

          if (state.phase === 'DROP_ANIMATING') {
            store.dispatch(dropAnimationFinished());
          }
        }
      };
      frameId = requestAnimationFrame(function () {
        frameId = null;
        unbind = bindEvents(window, [binding]);
      });
    };
  };
});

var dimensionMarshalStopper = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') {
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
});

var react_beautiful_dnd_esm_focus = (function (marshal) {
  var isWatching = false;
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          isWatching = true;
          marshal.tryRecordFocus(action.payload.critical.draggable.id);
          next(action);
          marshal.tryRestoreFocusRecorded();
          return;
        }

        next(action);

        if (!isWatching) {
          return;
        }

        if (action.type === 'FLUSH') {
          isWatching = false;
          marshal.tryRestoreFocusRecorded();
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          isWatching = false;
          var result = action.payload.completed.result;

          if (result.combine) {
            marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
          }

          marshal.tryRestoreFocusRecorded();
        }
      };
    };
  };
});

var shouldStop = function shouldStop(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var autoScroll = (function (autoScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldStop(action)) {
          autoScroller.stop();
          next(action);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          next(action);
          var state = store.getState();
          !(state.phase === 'DRAGGING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
          autoScroller.start(state);
          return;
        }

        next(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
});

var pendingDrop = (function (store) {
  return function (next) {
    return function (action) {
      next(action);

      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
        return;
      }

      var postActionState = store.getState();

      if (postActionState.phase !== 'DROP_PENDING') {
        return;
      }

      if (postActionState.isWaiting) {
        return;
      }

      store.dispatch(drop({
        reason: postActionState.reason
      }));
    };
  };
});

var composeEnhancers =  false ? 0 : redux.compose;
var createStore = (function (_ref) {
  var dimensionMarshal = _ref.dimensionMarshal,
      focusMarshal = _ref.focusMarshal,
      styleMarshal = _ref.styleMarshal,
      getResponders = _ref.getResponders,
      announce = _ref.announce,
      autoScroller = _ref.autoScroller;
  return (0,redux.createStore)(react_beautiful_dnd_esm_reducer, composeEnhancers((0,redux.applyMiddleware)(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, dropAnimationFlushOnScroll, pendingDrop, autoScroll(autoScroller), scrollListener, react_beautiful_dnd_esm_focus(focusMarshal), responders(getResponders, announce))));
});

var clean$1 = function clean() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function createPublisher(_ref) {
  var registry = _ref.registry,
      callbacks = _ref.callbacks;
  var staging = clean$1();
  var frameId = null;

  var collect = function collect() {
    if (frameId) {
      return;
    }

    callbacks.collectionStarting();
    frameId = requestAnimationFrame(function () {
      frameId = null;
      start();
      var _staging = staging,
          additions = _staging.additions,
          removals = _staging.removals,
          modified = _staging.modified;
      var added = Object.keys(additions).map(function (id) {
        return registry.draggable.getById(id).getDimension(origin);
      }).sort(function (a, b) {
        return a.descriptor.index - b.descriptor.index;
      });
      var updated = Object.keys(modified).map(function (id) {
        var entry = registry.droppable.getById(id);
        var scroll = entry.callbacks.getScrollWhileDragging();
        return {
          droppableId: id,
          scroll: scroll
        };
      });
      var result = {
        additions: added,
        removals: Object.keys(removals),
        modified: updated
      };
      staging = clean$1();
      finish();
      callbacks.publish(result);
    });
  };

  var add = function add(entry) {
    var id = entry.descriptor.id;
    staging.additions[id] = entry;
    staging.modified[entry.descriptor.droppableId] = true;

    if (staging.removals[id]) {
      delete staging.removals[id];
    }

    collect();
  };

  var remove = function remove(entry) {
    var descriptor = entry.descriptor;
    staging.removals[descriptor.id] = true;
    staging.modified[descriptor.droppableId] = true;

    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$1();
  };

  return {
    add: add,
    remove: remove,
    stop: stop
  };
}

var getMaxScroll = (function (_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
});

var getDocumentElement = (function () {
  var doc = document.documentElement;
  !doc ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return doc;
});

var getMaxWindowScroll = (function () {
  var doc = getDocumentElement();
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
});

var getViewport = (function () {
  var scroll = react_beautiful_dnd_esm_getWindowScroll();
  var maxScroll = getMaxWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = getDocumentElement();
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = getRect({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
});

var getInitialPublish = (function (_ref) {
  var critical = _ref.critical,
      scrollOptions = _ref.scrollOptions,
      registry = _ref.registry;
  start();
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home = critical.droppable;
  var droppables = registry.droppable.getAllByType(home.type).map(function (entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function (entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  finish();
  var result = {
    dimensions: dimensions,
    critical: critical,
    viewport: viewport
  };
  return result;
});

function shouldPublishUpdate(registry, dragging, entry) {
  if (entry.descriptor.id === dragging.id) {
    return false;
  }

  if (entry.descriptor.type !== dragging.type) {
    return false;
  }

  var home = registry.droppable.getById(entry.descriptor.droppableId);

  if (home.descriptor.mode !== 'virtual') {
     false ? 0 : void 0;
    return false;
  }

  return true;
}

var createDimensionMarshal = (function (registry, callbacks) {
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting
    },
    registry: registry
  });

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !registry.droppable.exists(id) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    callbacks.updateDroppableIsCombineEnabled({
      id: id,
      isCombineEnabled: isCombineEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    callbacks.updateDroppableScroll({
      id: id,
      newScroll: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    if (!collection) {
      return;
    }

    registry.droppable.getById(id).callbacks.scroll(change);
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;
    registry.droppable.getAllByType(home.type).forEach(function (entry) {
      return entry.callbacks.dragStopped();
    });
    collection.unsubscribe();
    collection = null;
  };

  var subscriber = function subscriber(event) {
    !collection ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var dragging = collection.critical.draggable;

    if (event.type === 'ADDITION') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.add(event.value);
      }
    }

    if (event.type === 'REMOVAL') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.remove(event.value);
      }
    }
  };

  var startPublishing = function startPublishing(request) {
    !!collection ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var entry = registry.draggable.getById(request.draggableId);
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    var unsubscribe = registry.subscribe(subscriber);
    collection = {
      critical: critical,
      unsubscribe: unsubscribe
    };
    return getInitialPublish({
      critical: critical,
      registry: registry,
      scrollOptions: request.scrollOptions
    });
  };

  var marshal = {
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
});

var canStartDrag = (function (state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.completed.result.draggableId === id) {
    return false;
  }

  return state.completed.result.reason === 'DROP';
});

var scrollWindow = (function (change) {
  window.scrollBy(change.x, change.y);
});

var getScrollableDroppables = (0,memoize_one_esm["default"])(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.frame) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
    !droppable.frame ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = (function (_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination];

    if (!_dimension.frame) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
});

var config = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};

var getDistanceThresholds = (function (container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
});

var getPercentage = (function (_ref) {
  var startOfRange = _ref.startOfRange,
      endOfRange = _ref.endOfRange,
      current = _ref.current;
  var range = endOfRange - startOfRange;

  if (range === 0) {
     false ? 0 : void 0;
    return 0;
  }

  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
});

var minScroll = 1;

var getValueFromDistance = (function (distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }

  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config.maxPixelScroll;
  }

  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }

  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll);
});

var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;
var dampenValueByTime = (function (proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;
  var now = Date.now();
  var runTime = now - startOfRange;

  if (runTime >= stopAt) {
    return proposedScroll;
  }

  if (runTime < accelerateAt) {
    return minScroll;
  }

  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange: endOfRange,
    current: runTime
  });
  var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll);
});

var getValue = (function (_ref) {
  var distanceToEdge = _ref.distanceToEdge,
      thresholds = _ref.thresholds,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getValueFromDistance(distanceToEdge, thresholds);

  if (scroll === 0) {
    return 0;
  }

  if (!shouldUseTimeDampening) {
    return scroll;
  }

  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
});

var getScrollOnAxis = (function (_ref) {
  var container = _ref.container,
      distanceToEdges = _ref.distanceToEdges,
      dragStartTime = _ref.dragStartTime,
      axis = _ref.axis,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];

  if (isCloserToEnd) {
    return getValue({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  }

  return -1 * getValue({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds,
    dragStartTime: dragStartTime,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
});

var adjustForSizeLimits = (function (_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
});

var clean$2 = apply(function (value) {
  return value === 0 ? 0 : value;
});
var getScroll = (function (_ref) {
  var dragStartTime = _ref.dragStartTime,
      container = _ref.container,
      subject = _ref.subject,
      center = _ref.center,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: vertical,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var required = clean$2({
    x: x,
    y: y
  });

  if (isEqual(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return isEqual(limited, origin) ? null : limited;
});

var smallestSigned = apply(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});
var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (isEqual(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();
var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};
var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};
var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};
var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return false;
  }

  return canPartiallyScroll({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};
var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getWindowScrollChange = (function (_ref) {
  var viewport = _ref.viewport,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: viewport.frame,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
});

var getDroppableScrollChange = (function (_ref) {
  var droppable = _ref.droppable,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: frame.pageMarginBox,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
});

var scroll$1 = (function (_ref) {
  var state = _ref.state,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
      scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable.page.marginBox;

  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;

    var _change = getWindowScrollChange({
      dragStartTime: dragStartTime,
      viewport: viewport,
      subject: subject,
      center: center,
      shouldUseTimeDampening: shouldUseTimeDampening
    });

    if (_change) {
      scrollWindow(_change);
      return;
    }
  }

  var droppable = getBestScrollableDroppable({
    center: center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });

  if (!droppable) {
    return;
  }

  var change = getDroppableScrollChange({
    dragStartTime: dragStartTime,
    droppable: droppable,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });

  if (change) {
    scrollDroppable(droppable.descriptor.id, change);
  }
});

var createFluidScroller = (function (_ref) {
  var scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var scheduleWindowScroll = raf_schd_esm(scrollWindow);
  var scheduleDroppableScroll = raf_schd_esm(scrollDroppable);
  var dragging = null;

  var tryScroll = function tryScroll(state) {
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _dragging = dragging,
        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
        dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state: state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  };

  var start$1 = function start$1(state) {
    start();
    !!dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var dragStartTime = Date.now();
    var wasScrollNeeded = false;

    var fakeScrollCallback = function fakeScrollCallback() {
      wasScrollNeeded = true;
    };

    scroll$1({
      state: state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish();

    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };

  var stop = function stop() {
    if (!dragging) {
      return;
    }

    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
    dragging = null;
  };

  return {
    start: start$1,
    stop: stop,
    scroll: tryScroll
  };
});

var createJumpScroller = (function (_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = whatIsDraggedOver(state.impact);
    !destination ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
});

var createAutoScroller = (function (_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var scroll = function scroll(state) {
    if (state.phase !== 'DRAGGING') {
      return;
    }

    if (state.movementMode === 'FLUID') {
      fluidScroller.scroll(state);
      return;
    }

    if (!state.scrollJumpRequest) {
      return;
    }

    jumpScroll(state);
  };

  var scroller = {
    scroll: scroll,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
});

var prefix$1 = 'data-rbd';
var dragHandle = function () {
  var base = prefix$1 + "-drag-handle";
  return {
    base: base,
    draggableId: base + "-draggable-id",
    contextId: base + "-context-id"
  };
}();
var draggable = function () {
  var base = prefix$1 + "-draggable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var droppable = function () {
  var base = prefix$1 + "-droppable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var scrollContainer = {
  contextId: prefix$1 + "-scroll-container-context-id"
};

var makeGetSelector = function makeGetSelector(context) {
  return function (attribute) {
    return "[" + attribute + "=\"" + context + "\"]";
  };
};

var getStyles = function getStyles(rules, property) {
  return rules.map(function (rule) {
    var value = rule.styles[property];

    if (!value) {
      return '';
    }

    return rule.selector + " { " + value + " }";
  }).join(' ');
};

var noPointerEvents = 'pointer-events: none;';
var getStyles$1 = (function (contextId) {
  var getSelector = makeGetSelector(contextId);

  var dragHandle$1 = function () {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector(dragHandle.contextId),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();

  var draggable$1 = function () {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector(draggable.contextId),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();

  var droppable$1 = {
    selector: getSelector(droppable.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: 'body',
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1, dragHandle$1, droppable$1, body];
  return {
    always: getStyles(rules, 'always'),
    resting: getStyles(rules, 'resting'),
    dragging: getStyles(rules, 'dragging'),
    dropAnimating: getStyles(rules, 'dropAnimating'),
    userCancel: getStyles(rules, 'userCancel')
  };
});

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return head;
};

var createStyleEl = function createStyleEl(nonce) {
  var el = document.createElement('style');

  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  el.type = 'text/css';
  return el;
};

function useStyleMarshal(contextId, nonce) {
  var styles = useMemo(function () {
    return getStyles$1(contextId);
  }, [contextId]);
  var alwaysRef = (0,react.useRef)(null);
  var dynamicRef = (0,react.useRef)(null);
  var setDynamicStyle = useCallback((0,memoize_one_esm["default"])(function (proposed) {
    var el = dynamicRef.current;
    !el ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = useCallback(function (proposed) {
    var el = alwaysRef.current;
    !el ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    el.textContent = proposed;
  }, []);
  useIsomorphicLayoutEffect(function () {
    !(!alwaysRef.current && !dynamicRef.current) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var always = createStyleEl(nonce);
    var dynamic = createStyleEl(nonce);
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix$1 + "-always", contextId);
    dynamic.setAttribute(prefix$1 + "-dynamic", contextId);
    getHead().appendChild(always);
    getHead().appendChild(dynamic);
    setAlwaysStyle(styles.always);
    setDynamicStyle(styles.resting);
    return function () {
      var remove = function remove(ref) {
        var current = ref.current;
        !current ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
        getHead().removeChild(current);
        ref.current = null;
      };

      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [nonce, setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, contextId]);
  var dragging = useCallback(function () {
    return setDynamicStyle(styles.dragging);
  }, [setDynamicStyle, styles.dragging]);
  var dropping = useCallback(function (reason) {
    if (reason === 'DROP') {
      setDynamicStyle(styles.dropAnimating);
      return;
    }

    setDynamicStyle(styles.userCancel);
  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
  var resting = useCallback(function () {
    if (!dynamicRef.current) {
      return;
    }

    setDynamicStyle(styles.resting);
  }, [setDynamicStyle, styles.resting]);
  var marshal = useMemo(function () {
    return {
      dragging: dragging,
      dropping: dropping,
      resting: resting
    };
  }, [dragging, dropping, resting]);
  return marshal;
}

var getWindowFromEl = (function (el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
});

function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}

function findDragHandle(contextId, draggableId) {
  var selector = "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));

  if (!possible.length) {
     false ? 0 : void 0;
    return null;
  }

  var handle = find(possible, function (el) {
    return el.getAttribute(dragHandle.draggableId) === draggableId;
  });

  if (!handle) {
     false ? 0 : void 0;
    return null;
  }

  if (!isHtmlElement(handle)) {
     false ? 0 : void 0;
    return null;
  }

  return handle;
}

function useFocusMarshal(contextId) {
  var entriesRef = (0,react.useRef)({});
  var recordRef = (0,react.useRef)(null);
  var restoreFocusFrameRef = (0,react.useRef)(null);
  var isMountedRef = (0,react.useRef)(false);
  var register = useCallback(function register(id, focus) {
    var entry = {
      id: id,
      focus: focus
    };
    entriesRef.current[id] = entry;
    return function unregister() {
      var entries = entriesRef.current;
      var current = entries[id];

      if (current !== entry) {
        delete entries[id];
      }
    };
  }, []);
  var tryGiveFocus = useCallback(function tryGiveFocus(tryGiveFocusTo) {
    var handle = findDragHandle(contextId, tryGiveFocusTo);

    if (handle && handle !== document.activeElement) {
      handle.focus();
    }
  }, [contextId]);
  var tryShiftRecord = useCallback(function tryShiftRecord(previous, redirectTo) {
    if (recordRef.current === previous) {
      recordRef.current = redirectTo;
    }
  }, []);
  var tryRestoreFocusRecorded = useCallback(function tryRestoreFocusRecorded() {
    if (restoreFocusFrameRef.current) {
      return;
    }

    if (!isMountedRef.current) {
      return;
    }

    restoreFocusFrameRef.current = requestAnimationFrame(function () {
      restoreFocusFrameRef.current = null;
      var record = recordRef.current;

      if (record) {
        tryGiveFocus(record);
      }
    });
  }, [tryGiveFocus]);
  var tryRecordFocus = useCallback(function tryRecordFocus(id) {
    recordRef.current = null;
    var focused = document.activeElement;

    if (!focused) {
      return;
    }

    if (focused.getAttribute(dragHandle.draggableId) !== id) {
      return;
    }

    recordRef.current = id;
  }, []);
  useIsomorphicLayoutEffect(function () {
    isMountedRef.current = true;
    return function clearFrameOnUnmount() {
      isMountedRef.current = false;
      var frameId = restoreFocusFrameRef.current;

      if (frameId) {
        cancelAnimationFrame(frameId);
      }
    };
  }, []);
  var marshal = useMemo(function () {
    return {
      register: register,
      tryRecordFocus: tryRecordFocus,
      tryRestoreFocusRecorded: tryRestoreFocusRecorded,
      tryShiftRecord: tryShiftRecord
    };
  }, [register, tryRecordFocus, tryRestoreFocusRecorded, tryShiftRecord]);
  return marshal;
}

function createRegistry() {
  var entries = {
    draggables: {},
    droppables: {}
  };
  var subscribers = [];

  function subscribe(cb) {
    subscribers.push(cb);
    return function unsubscribe() {
      var index = subscribers.indexOf(cb);

      if (index === -1) {
        return;
      }

      subscribers.splice(index, 1);
    };
  }

  function notify(event) {
    if (subscribers.length) {
      subscribers.forEach(function (cb) {
        return cb(event);
      });
    }
  }

  function findDraggableById(id) {
    return entries.draggables[id] || null;
  }

  function getDraggableById(id) {
    var entry = findDraggableById(id);
    !entry ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return entry;
  }

  var draggableAPI = {
    register: function register(entry) {
      entries.draggables[entry.descriptor.id] = entry;
      notify({
        type: 'ADDITION',
        value: entry
      });
    },
    update: function update(entry, last) {
      var current = entries.draggables[last.descriptor.id];

      if (!current) {
        return;
      }

      if (current.uniqueId !== entry.uniqueId) {
        return;
      }

      delete entries.draggables[last.descriptor.id];
      entries.draggables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var draggableId = entry.descriptor.id;
      var current = findDraggableById(draggableId);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.draggables[draggableId];
      notify({
        type: 'REMOVAL',
        value: entry
      });
    },
    getById: getDraggableById,
    findById: findDraggableById,
    exists: function exists(id) {
      return Boolean(findDraggableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.draggables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function findDroppableById(id) {
    return entries.droppables[id] || null;
  }

  function getDroppableById(id) {
    var entry = findDroppableById(id);
    !entry ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return entry;
  }

  var droppableAPI = {
    register: function register(entry) {
      entries.droppables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var current = findDroppableById(entry.descriptor.id);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.droppables[entry.descriptor.id];
    },
    getById: getDroppableById,
    findById: findDroppableById,
    exists: function exists(id) {
      return Boolean(findDroppableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.droppables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function clean() {
    entries.draggables = {};
    entries.droppables = {};
    subscribers.length = 0;
  }

  return {
    draggable: draggableAPI,
    droppable: droppableAPI,
    subscribe: subscribe,
    clean: clean
  };
}

function useRegistry() {
  var registry = useMemo(createRegistry, []);
  (0,react.useEffect)(function () {
    return function unmount() {
      requestAnimationFrame(registry.clean);
    };
  }, [registry]);
  return registry;
}

var StoreContext = react.createContext(null);

var getBodyElement = (function () {
  var body = document.body;
  !body ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return body;
});

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};

var getId = function getId(contextId) {
  return "rbd-announcement-" + contextId;
};
function useAnnouncer(contextId) {
  var id = useMemo(function () {
    return getId(contextId);
  }, [contextId]);
  var ref = (0,react.useRef)(null);
  (0,react.useEffect)(function setup() {
    var el = document.createElement('div');
    ref.current = el;
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('aria-atomic', 'true');

    (0,esm_extends/* default */.Z)(el.style, visuallyHidden);

    getBodyElement().appendChild(el);
    return function cleanup() {
      setTimeout(function remove() {
        var body = getBodyElement();

        if (body.contains(el)) {
          body.removeChild(el);
        }

        if (el === ref.current) {
          ref.current = null;
        }
      });
    };
  }, [id]);
  var announce = useCallback(function (message) {
    var el = ref.current;

    if (el) {
      el.textContent = message;
      return;
    }

     false ? 0 : void 0;
  }, []);
  return announce;
}

var count = 0;
var defaults = {
  separator: '::'
};
function react_beautiful_dnd_esm_reset() {
  count = 0;
}
function useUniqueId(prefix, options) {
  if (options === void 0) {
    options = defaults;
  }

  return useMemo(function () {
    return "" + prefix + options.separator + count++;
  }, [options.separator, prefix]);
}

function getElementId(_ref) {
  var contextId = _ref.contextId,
      uniqueId = _ref.uniqueId;
  return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function useHiddenTextElement(_ref2) {
  var contextId = _ref2.contextId,
      text = _ref2.text;
  var uniqueId = useUniqueId('hidden-text', {
    separator: '-'
  });
  var id = useMemo(function () {
    return getElementId({
      contextId: contextId,
      uniqueId: uniqueId
    });
  }, [uniqueId, contextId]);
  (0,react.useEffect)(function mount() {
    var el = document.createElement('div');
    el.id = id;
    el.textContent = text;
    el.style.display = 'none';
    getBodyElement().appendChild(el);
    return function unmount() {
      var body = getBodyElement();

      if (body.contains(el)) {
        body.removeChild(el);
      }
    };
  }, [id, text]);
  return id;
}

var AppContext = react.createContext(null);

var peerDependencies = {
	react: "^16.8.5 || ^17.0.0 || ^18.0.0",
	"react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};

var semver = /(\d+)\.(\d+)\.(\d+)/;

var getVersion = function getVersion(value) {
  var result = semver.exec(value);
  !(result != null) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch = Number(result[3]);
  return {
    major: major,
    minor: minor,
    patch: patch,
    raw: value
  };
};

var isSatisfied = function isSatisfied(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }

  if (actual.major < expected.major) {
    return false;
  }

  if (actual.minor > expected.minor) {
    return true;
  }

  if (actual.minor < expected.minor) {
    return false;
  }

  return actual.patch >= expected.patch;
};

var checkReactVersion = (function (peerDepValue, actualValue) {
  var peerDep = getVersion(peerDepValue);
  var actual = getVersion(actualValue);

  if (isSatisfied(peerDep, actual)) {
    return;
  }

   false ? 0 : void 0;
});

var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype = (function (doc) {
  var doctype = doc.doctype;

  if (!doctype) {
     false ? 0 : void 0;
    return;
  }

  if (doctype.name.toLowerCase() !== 'html') {
     false ? 0 : void 0;
  }

  if (doctype.publicId !== '') {
     false ? 0 : void 0;
  }
});

function useDev(useHook) {
  if (false) {}
}

function useDevSetupWarning(fn, inputs) {
  useDev(function () {
    (0,react.useEffect)(function () {
      try {
        fn();
      } catch (e) {
        error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
      }
    }, inputs);
  });
}

function useStartupValidation() {
  useDevSetupWarning(function () {
    checkReactVersion(peerDependencies.react, react.version);
    checkDoctype(document);
  }, []);
}

function usePrevious(current) {
  var ref = (0,react.useRef)(current);
  (0,react.useEffect)(function () {
    ref.current = current;
  });
  return ref;
}

function create() {
  var lock = null;

  function isClaimed() {
    return Boolean(lock);
  }

  function isActive(value) {
    return value === lock;
  }

  function claim(abandon) {
    !!lock ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var newLock = {
      abandon: abandon
    };
    lock = newLock;
    return newLock;
  }

  function release() {
    !lock ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    lock = null;
  }

  function tryAbandon() {
    if (lock) {
      lock.abandon();
      release();
    }
  }

  return {
    isClaimed: isClaimed,
    isActive: isActive,
    claim: claim,
    release: release,
    tryAbandon: tryAbandon
  };
}

var tab = 9;
var enter = 13;
var react_beautiful_dnd_esm_escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
var preventStandardKeyEvents = (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = find(candidates, function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var primaryButton = 0;
var sloppyClickThreshold = 5;

function isSloppyClickThresholdExceeded(original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
}

var idle$1 = {
  type: 'IDLE'
};

function getCaptureBindings(_ref) {
  var cancel = _ref.cancel,
      completed = _ref.completed,
      getPhase = _ref.getPhase,
      setPhase = _ref.setPhase;
  return [{
    eventName: 'mousemove',
    fn: function fn(event) {
      var button = event.button,
          clientX = event.clientX,
          clientY = event.clientY;

      if (button !== primaryButton) {
        return;
      }

      var point = {
        x: clientX,
        y: clientY
      };
      var phase = getPhase();

      if (phase.type === 'DRAGGING') {
        event.preventDefault();
        phase.actions.move(point);
        return;
      }

      !(phase.type === 'PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      var pending = phase.point;

      if (!isSloppyClickThresholdExceeded(pending, point)) {
        return;
      }

      event.preventDefault();
      var actions = phase.actions.fluidLift(point);
      setPhase({
        type: 'DRAGGING',
        actions: actions
      });
    }
  }, {
    eventName: 'mouseup',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'mousedown',
    fn: function fn(event) {
      if (getPhase().type === 'DRAGGING') {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        cancel();
        return;
      }

      if (event.keyCode === react_beautiful_dnd_esm_escape) {
        event.preventDefault();
        cancel();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn() {
      if (getPhase().type === 'PENDING') {
        cancel();
      }
    }
  }, {
    eventName: 'webkitmouseforcedown',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

      if (phase.actions.shouldRespectForcePress()) {
        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useMouseSensor(api) {
  var phaseRef = (0,react.useRef)(idle$1);
  var unbindEventsRef = (0,react.useRef)(noop);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'mousedown',
      fn: function onMouseDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.button !== primaryButton) {
          return;
        }

        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        event.preventDefault();
        var point = {
          x: event.clientX,
          y: event.clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var preventForcePressBinding = useMemo(function () {
    return {
      eventName: 'webkitmouseforcewillbegin',
      fn: function fn(event) {
        if (event.defaultPrevented) {
          return;
        }

        var id = api.findClosestDraggableId(event);

        if (!id) {
          return;
        }

        var options = api.findOptionsForDraggable(id);

        if (!options) {
          return;
        }

        if (options.shouldRespectForcePress) {
          return;
        }

        if (!api.canGetLock(id)) {
          return;
        }

        event.preventDefault();
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [preventForcePressBinding, startCaptureBinding], options);
  }, [preventForcePressBinding, startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    phaseRef.current = idle$1;
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var bindings = getCaptureBindings({
      cancel: cancel,
      completed: stop,
      getPhase: function getPhase() {
        return phaseRef.current;
      },
      setPhase: function setPhase(phase) {
        phaseRef.current = phase;
      }
    });
    unbindEventsRef.current = bindEvents(window, bindings, options);
  }, [cancel, stop]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(phaseRef.current.type === 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    phaseRef.current = {
      type: 'PENDING',
      point: point,
      actions: actions
    };
    bindCapturingEvents();
  }, [bindCapturingEvents]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var _scrollJumpKeys;

function noop$1() {}

var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);

function getDraggingBindings(actions, stop) {
  function cancel() {
    stop();
    actions.cancel();
  }

  function drop() {
    stop();
    actions.drop();
  }

  return [{
    eventName: 'keydown',
    fn: function fn(event) {
      if (event.keyCode === react_beautiful_dnd_esm_escape) {
        event.preventDefault();
        cancel();
        return;
      }

      if (event.keyCode === space) {
        event.preventDefault();
        drop();
        return;
      }

      if (event.keyCode === arrowDown) {
        event.preventDefault();
        actions.moveDown();
        return;
      }

      if (event.keyCode === arrowUp) {
        event.preventDefault();
        actions.moveUp();
        return;
      }

      if (event.keyCode === arrowRight) {
        event.preventDefault();
        actions.moveRight();
        return;
      }

      if (event.keyCode === arrowLeft) {
        event.preventDefault();
        actions.moveLeft();
        return;
      }

      if (scrollJumpKeys[event.keyCode]) {
        event.preventDefault();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'mousedown',
    fn: cancel
  }, {
    eventName: 'mouseup',
    fn: cancel
  }, {
    eventName: 'click',
    fn: cancel
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'wheel',
    fn: cancel,
    options: {
      passive: true
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useKeyboardSensor(api) {
  var unbindEventsRef = (0,react.useRef)(noop$1);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'keydown',
      fn: function onKeyDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.keyCode !== space) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var preDrag = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!preDrag) {
          return;
        }

        event.preventDefault();
        var isCapturing = true;
        var actions = preDrag.snapLift();
        unbindEventsRef.current();

        function stop() {
          !isCapturing ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
          isCapturing = false;
          unbindEventsRef.current();
          listenForCapture();
        }

        unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
          capture: true,
          passive: false
        });
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function tryStartCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var idle$2 = {
  type: 'IDLE'
};
var timeForLongPress = 120;
var forcePressThreshold = 0.15;

function getWindowBindings(_ref) {
  var cancel = _ref.cancel,
      getPhase = _ref.getPhase;
  return [{
    eventName: 'orientationchange',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'contextmenu',
    fn: function fn(event) {
      event.preventDefault();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      if (event.keyCode === react_beautiful_dnd_esm_escape) {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function getHandleBindings(_ref2) {
  var cancel = _ref2.cancel,
      completed = _ref2.completed,
      getPhase = _ref2.getPhase;
  return [{
    eventName: 'touchmove',
    options: {
      capture: false
    },
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      phase.hasMoved = true;
      var _event$touches$ = event.touches[0],
          clientX = _event$touches$.clientX,
          clientY = _event$touches$.clientY;
      var point = {
        x: clientX,
        y: clientY
      };
      event.preventDefault();
      phase.actions.move(point);
    }
  }, {
    eventName: 'touchend',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'touchcancel',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      cancel();
    }
  }, {
    eventName: 'touchforcechange',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      var touch = event.touches[0];

      if (!touch) {
        return;
      }

      var isForcePress = touch.force >= forcePressThreshold;

      if (!isForcePress) {
        return;
      }

      var shouldRespect = phase.actions.shouldRespectForcePress();

      if (phase.type === 'PENDING') {
        if (shouldRespect) {
          cancel();
        }

        return;
      }

      if (shouldRespect) {
        if (phase.hasMoved) {
          event.preventDefault();
          return;
        }

        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useTouchSensor(api) {
  var phaseRef = (0,react.useRef)(idle$2);
  var unbindEventsRef = (0,react.useRef)(noop);
  var getPhase = useCallback(function getPhase() {
    return phaseRef.current;
  }, []);
  var setPhase = useCallback(function setPhase(phase) {
    phaseRef.current = phase;
  }, []);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'touchstart',
      fn: function onTouchStart(event) {
        if (event.defaultPrevented) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        var touch = event.touches[0];
        var clientX = touch.clientX,
            clientY = touch.clientY;
        var point = {
          x: clientX,
          y: clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      capture: true,
      passive: false
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    if (current.type === 'PENDING') {
      clearTimeout(current.longPressTimerId);
    }

    setPhase(idle$2);
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture, setPhase]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var args = {
      cancel: cancel,
      completed: stop,
      getPhase: getPhase
    };
    var unbindTarget = bindEvents(window, getHandleBindings(args), options);
    var unbindWindow = bindEvents(window, getWindowBindings(args), options);

    unbindEventsRef.current = function unbindAll() {
      unbindTarget();
      unbindWindow();
    };
  }, [cancel, getPhase, stop]);
  var startDragging = useCallback(function startDragging() {
    var phase = getPhase();
    !(phase.type === 'PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var actions = phase.actions.fluidLift(phase.point);
    setPhase({
      type: 'DRAGGING',
      actions: actions,
      hasMoved: false
    });
  }, [getPhase, setPhase]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(getPhase().type === 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    setPhase({
      type: 'PENDING',
      point: point,
      actions: actions,
      longPressTimerId: longPressTimerId
    });
    bindCapturingEvents();
  }, [bindCapturingEvents, getPhase, setPhase, startDragging]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        clearTimeout(phase.longPressTimerId);
        setPhase(idle$2);
      }
    };
  }, [getPhase, listenForCapture, setPhase]);
  useIsomorphicLayoutEffect(function webkitHack() {
    var unbind = bindEvents(window, [{
      eventName: 'touchmove',
      fn: function fn() {},
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
}

function useValidateSensorHooks(sensorHooks) {
  useDev(function () {
    var previousRef = usePrevious(sensorHooks);
    useDevSetupWarning(function () {
      !(previousRef.current.length === sensorHooks.length) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    });
  });
}

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
}

function isEventInInteractiveElement(draggable, event) {
  var target = event.target;

  if (!isHtmlElement(target)) {
    return false;
  }

  return isAnInteractiveElement(draggable, target);
}

var getBorderBoxCenterPosition = (function (el) {
  return getRect(el.getBoundingClientRect()).center;
});

function isElement(el) {
  return el instanceof getWindowFromEl(el).Element;
}

var supportedMatchesName = function () {
  var base = 'matches';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, 'msMatchesSelector', 'webkitMatchesSelector'];
  var value = find(candidates, function (name) {
    return name in Element.prototype;
  });
  return value || base;
}();

function closestPonyfill(el, selector) {
  if (el == null) {
    return null;
  }

  if (el[supportedMatchesName](selector)) {
    return el;
  }

  return closestPonyfill(el.parentElement, selector);
}

function closest$1(el, selector) {
  if (el.closest) {
    return el.closest(selector);
  }

  return closestPonyfill(el, selector);
}

function getSelector(contextId) {
  return "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
}

function findClosestDragHandleFromEvent(contextId, event) {
  var target = event.target;

  if (!isElement(target)) {
     false ? 0 : void 0;
    return null;
  }

  var selector = getSelector(contextId);
  var handle = closest$1(target, selector);

  if (!handle) {
    return null;
  }

  if (!isHtmlElement(handle)) {
     false ? 0 : void 0;
    return null;
  }

  return handle;
}

function tryGetClosestDraggableIdFromEvent(contextId, event) {
  var handle = findClosestDragHandleFromEvent(contextId, event);

  if (!handle) {
    return null;
  }

  return handle.getAttribute(dragHandle.draggableId);
}

function findDraggable(contextId, draggableId) {
  var selector = "[" + draggable.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));
  var draggable$1 = find(possible, function (el) {
    return el.getAttribute(draggable.id) === draggableId;
  });

  if (!draggable$1) {
    return null;
  }

  if (!isHtmlElement(draggable$1)) {
     false ? 0 : void 0;
    return null;
  }

  return draggable$1;
}

function preventDefault(event) {
  event.preventDefault();
}

function _isActive(_ref) {
  var expected = _ref.expected,
      phase = _ref.phase,
      isLockActive = _ref.isLockActive,
      shouldWarn = _ref.shouldWarn;

  if (!isLockActive()) {
    if (shouldWarn) {
       false ? 0 : void 0;
    }

    return false;
  }

  if (expected !== phase) {
    if (shouldWarn) {
       false ? 0 : void 0;
    }

    return false;
  }

  return true;
}

function canStart(_ref2) {
  var lockAPI = _ref2.lockAPI,
      store = _ref2.store,
      registry = _ref2.registry,
      draggableId = _ref2.draggableId;

  if (lockAPI.isClaimed()) {
    return false;
  }

  var entry = registry.draggable.findById(draggableId);

  if (!entry) {
     false ? 0 : void 0;
    return false;
  }

  if (!entry.options.isEnabled) {
    return false;
  }

  if (!canStartDrag(store.getState(), draggableId)) {
    return false;
  }

  return true;
}

function tryStart(_ref3) {
  var lockAPI = _ref3.lockAPI,
      contextId = _ref3.contextId,
      store = _ref3.store,
      registry = _ref3.registry,
      draggableId = _ref3.draggableId,
      forceSensorStop = _ref3.forceSensorStop,
      sourceEvent = _ref3.sourceEvent;
  var shouldStart = canStart({
    lockAPI: lockAPI,
    store: store,
    registry: registry,
    draggableId: draggableId
  });

  if (!shouldStart) {
    return null;
  }

  var entry = registry.draggable.getById(draggableId);
  var el = findDraggable(contextId, entry.descriptor.id);

  if (!el) {
     false ? 0 : void 0;
    return null;
  }

  if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) {
    return null;
  }

  var lock = lockAPI.claim(forceSensorStop || noop);
  var phase = 'PRE_DRAG';

  function getShouldRespectForcePress() {
    return entry.options.shouldRespectForcePress;
  }

  function isLockActive() {
    return lockAPI.isActive(lock);
  }

  function tryDispatch(expected, getAction) {
    if (_isActive({
      expected: expected,
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    })) {
      store.dispatch(getAction());
    }
  }

  var tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');

  function lift$1(args) {
    function completed() {
      lockAPI.release();
      phase = 'COMPLETED';
    }

    if (phase !== 'PRE_DRAG') {
      completed();
      !(phase === 'PRE_DRAG') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    }

    store.dispatch(lift(args.liftActionArgs));
    phase = 'DRAGGING';

    function finish(reason, options) {
      if (options === void 0) {
        options = {
          shouldBlockNextClick: false
        };
      }

      args.cleanup();

      if (options.shouldBlockNextClick) {
        var unbind = bindEvents(window, [{
          eventName: 'click',
          fn: preventDefault,
          options: {
            once: true,
            passive: false,
            capture: true
          }
        }]);
        setTimeout(unbind);
      }

      completed();
      store.dispatch(drop({
        reason: reason
      }));
    }

    return (0,esm_extends/* default */.Z)({
      isActive: function isActive() {
        return _isActive({
          expected: 'DRAGGING',
          phase: phase,
          isLockActive: isLockActive,
          shouldWarn: false
        });
      },
      shouldRespectForcePress: getShouldRespectForcePress,
      drop: function drop(options) {
        return finish('DROP', options);
      },
      cancel: function cancel(options) {
        return finish('CANCEL', options);
      }
    }, args.actions);
  }

  function fluidLift(clientSelection) {
    var move$1 = raf_schd_esm(function (client) {
      tryDispatchWhenDragging(function () {
        return move({
          client: client
        });
      });
    });
    var api = lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: clientSelection,
        movementMode: 'FLUID'
      },
      cleanup: function cleanup() {
        return move$1.cancel();
      },
      actions: {
        move: move$1
      }
    });
    return (0,esm_extends/* default */.Z)({}, api, {
      move: move$1
    });
  }

  function snapLift() {
    var actions = {
      moveUp: function moveUp$1() {
        return tryDispatchWhenDragging(moveUp);
      },
      moveRight: function moveRight$1() {
        return tryDispatchWhenDragging(moveRight);
      },
      moveDown: function moveDown$1() {
        return tryDispatchWhenDragging(moveDown);
      },
      moveLeft: function moveLeft$1() {
        return tryDispatchWhenDragging(moveLeft);
      }
    };
    return lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: getBorderBoxCenterPosition(el),
        movementMode: 'SNAP'
      },
      cleanup: noop,
      actions: actions
    });
  }

  function abortPreDrag() {
    var shouldRelease = _isActive({
      expected: 'PRE_DRAG',
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    });

    if (shouldRelease) {
      lockAPI.release();
    }
  }

  var preDrag = {
    isActive: function isActive() {
      return _isActive({
        expected: 'PRE_DRAG',
        phase: phase,
        isLockActive: isLockActive,
        shouldWarn: false
      });
    },
    shouldRespectForcePress: getShouldRespectForcePress,
    fluidLift: fluidLift,
    snapLift: snapLift,
    abort: abortPreDrag
  };
  return preDrag;
}

var defaultSensors = [useMouseSensor, useKeyboardSensor, useTouchSensor];
function useSensorMarshal(_ref4) {
  var contextId = _ref4.contextId,
      store = _ref4.store,
      registry = _ref4.registry,
      customSensors = _ref4.customSensors,
      enableDefaultSensors = _ref4.enableDefaultSensors;
  var useSensors = [].concat(enableDefaultSensors ? defaultSensors : [], customSensors || []);
  var lockAPI = (0,react.useState)(function () {
    return create();
  })[0];
  var tryAbandonLock = useCallback(function tryAbandonLock(previous, current) {
    if (previous.isDragging && !current.isDragging) {
      lockAPI.tryAbandon();
    }
  }, [lockAPI]);
  useIsomorphicLayoutEffect(function listenToStore() {
    var previous = store.getState();
    var unsubscribe = store.subscribe(function () {
      var current = store.getState();
      tryAbandonLock(previous, current);
      previous = current;
    });
    return unsubscribe;
  }, [lockAPI, store, tryAbandonLock]);
  useIsomorphicLayoutEffect(function () {
    return lockAPI.tryAbandon;
  }, [lockAPI.tryAbandon]);
  var canGetLock = useCallback(function (draggableId) {
    return canStart({
      lockAPI: lockAPI,
      registry: registry,
      store: store,
      draggableId: draggableId
    });
  }, [lockAPI, registry, store]);
  var tryGetLock = useCallback(function (draggableId, forceStop, options) {
    return tryStart({
      lockAPI: lockAPI,
      registry: registry,
      contextId: contextId,
      store: store,
      draggableId: draggableId,
      forceSensorStop: forceStop,
      sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
    });
  }, [contextId, lockAPI, registry, store]);
  var findClosestDraggableId = useCallback(function (event) {
    return tryGetClosestDraggableIdFromEvent(contextId, event);
  }, [contextId]);
  var findOptionsForDraggable = useCallback(function (id) {
    var entry = registry.draggable.findById(id);
    return entry ? entry.options : null;
  }, [registry.draggable]);
  var tryReleaseLock = useCallback(function tryReleaseLock() {
    if (!lockAPI.isClaimed()) {
      return;
    }

    lockAPI.tryAbandon();

    if (store.getState().phase !== 'IDLE') {
      store.dispatch(flush());
    }
  }, [lockAPI, store]);
  var isLockClaimed = useCallback(lockAPI.isClaimed, [lockAPI]);
  var api = useMemo(function () {
    return {
      canGetLock: canGetLock,
      tryGetLock: tryGetLock,
      findClosestDraggableId: findClosestDraggableId,
      findOptionsForDraggable: findOptionsForDraggable,
      tryReleaseLock: tryReleaseLock,
      isLockClaimed: isLockClaimed
    };
  }, [canGetLock, tryGetLock, findClosestDraggableId, findOptionsForDraggable, tryReleaseLock, isLockClaimed]);
  useValidateSensorHooks(useSensors);

  for (var i = 0; i < useSensors.length; i++) {
    useSensors[i](api);
  }
}

var createResponders = function createResponders(props) {
  return {
    onBeforeCapture: props.onBeforeCapture,
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};

function getStore(lazyRef) {
  !lazyRef.current ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return lazyRef.current;
}

function App(props) {
  var contextId = props.contextId,
      setCallbacks = props.setCallbacks,
      sensors = props.sensors,
      nonce = props.nonce,
      dragHandleUsageInstructions = props.dragHandleUsageInstructions;
  var lazyStoreRef = (0,react.useRef)(null);
  useStartupValidation();
  var lastPropsRef = usePrevious(props);
  var getResponders = useCallback(function () {
    return createResponders(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce = useAnnouncer(contextId);
  var dragHandleUsageInstructionsId = useHiddenTextElement({
    contextId: contextId,
    text: dragHandleUsageInstructions
  });
  var styleMarshal = useStyleMarshal(contextId, nonce);
  var lazyDispatch = useCallback(function (action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var marshalCallbacks = useMemo(function () {
    return (0,redux.bindActionCreators)({
      publishWhileDragging: publishWhileDragging,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
      collectionStarting: collectionStarting
    }, lazyDispatch);
  }, [lazyDispatch]);
  var registry = useRegistry();
  var dimensionMarshal = useMemo(function () {
    return createDimensionMarshal(registry, marshalCallbacks);
  }, [registry, marshalCallbacks]);
  var autoScroller = useMemo(function () {
    return createAutoScroller((0,esm_extends/* default */.Z)({
      scrollWindow: scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, (0,redux.bindActionCreators)({
      move: move
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var focusMarshal = useFocusMarshal(contextId);
  var store = useMemo(function () {
    return createStore({
      announce: announce,
      autoScroller: autoScroller,
      dimensionMarshal: dimensionMarshal,
      focusMarshal: focusMarshal,
      getResponders: getResponders,
      styleMarshal: styleMarshal
    });
  }, [announce, autoScroller, dimensionMarshal, focusMarshal, getResponders, styleMarshal]);

  if (false) {}

  lazyStoreRef.current = store;
  var tryResetStore = useCallback(function () {
    var current = getStore(lazyStoreRef);
    var state = current.getState();

    if (state.phase !== 'IDLE') {
      current.dispatch(flush());
    }
  }, []);
  var isDragging = useCallback(function () {
    var state = getStore(lazyStoreRef).getState();
    return state.isDragging || state.phase === 'DROP_ANIMATING';
  }, []);
  var appCallbacks = useMemo(function () {
    return {
      isDragging: isDragging,
      tryAbort: tryResetStore
    };
  }, [isDragging, tryResetStore]);
  setCallbacks(appCallbacks);
  var getCanLift = useCallback(function (id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = useCallback(function () {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = useMemo(function () {
    return {
      marshal: dimensionMarshal,
      focus: focusMarshal,
      contextId: contextId,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed,
      dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
      registry: registry
    };
  }, [contextId, dimensionMarshal, dragHandleUsageInstructionsId, focusMarshal, getCanLift, getIsMovementAllowed, registry]);
  useSensorMarshal({
    contextId: contextId,
    store: store,
    registry: registry,
    customSensors: sensors,
    enableDefaultSensors: props.enableDefaultSensors !== false
  });
  (0,react.useEffect)(function () {
    return tryResetStore;
  }, [tryResetStore]);
  return react.createElement(AppContext.Provider, {
    value: appContext
  }, react.createElement(es/* Provider */.zt, {
    context: StoreContext,
    store: store
  }, props.children));
}

var count$1 = 0;
function reset$1() {
  count$1 = 0;
}
function useInstanceCount() {
  return useMemo(function () {
    return "" + count$1++;
  }, []);
}

function resetServerContext() {
  reset$1();
  react_beautiful_dnd_esm_reset();
}
function DragDropContext(props) {
  var contextId = useInstanceCount();
  var dragHandleUsageInstructions = props.dragHandleUsageInstructions || preset.dragHandleUsageInstructions;
  return react.createElement(ErrorBoundary, null, function (setCallbacks) {
    return react.createElement(App, {
      nonce: props.nonce,
      contextId: contextId,
      setCallbacks: setCallbacks,
      dragHandleUsageInstructions: dragHandleUsageInstructions,
      enableDefaultSensors: props.enableDefaultSensors,
      sensors: props.sensors,
      onBeforeCapture: props.onBeforeCapture,
      onBeforeDragStart: props.onBeforeDragStart,
      onDragStart: props.onDragStart,
      onDragUpdate: props.onDragUpdate,
      onDragEnd: props.onDragEnd
    }, props.children);
  });
}

var isEqual$1 = function isEqual(base) {
  return function (value) {
    return base === value;
  };
};

var isScroll = isEqual$1('scroll');
var isAuto = isEqual$1('auto');
var isVisible$1 = isEqual$1('visible');

var isEither = function isEither(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};

var isBoth = function isBoth(overflow, fn) {
  return fn(overflow.overflowX) && fn(overflow.overflowY);
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  var overflow = {
    overflowX: style.overflowX,
    overflowY: style.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

var isBodyScrollable = function isBodyScrollable() {
  if (true) {
    return false;
  }

  var body = getBodyElement();
  var html = document.documentElement;
  !html ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

  if (!isElementScrollable(body)) {
    return false;
  }

  var htmlStyle = window.getComputedStyle(html);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };

  if (isBoth(htmlOverflow, isVisible$1)) {
    return false;
  }

   false ? 0 : void 0;
  return false;
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (el === document.body) {
    return isBodyScrollable() ? el : null;
  }

  if (el === document.documentElement) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var checkForNestedScrollContainers = (function (scrollable) {
  if (!scrollable) {
    return;
  }

  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);

  if (!anotherScrollParent) {
    return;
  }

   false ? 0 : void 0;
});

var getScroll$1 = (function (el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
});

var getIsFixed = function getIsFixed(el) {
  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);

  if (style.position === 'fixed') {
    return true;
  }

  return getIsFixed(el.parentElement);
};

var getEnv = (function (start) {
  var closestScrollable = getClosestScrollable(start);
  var isFixedOnPage = getIsFixed(start);
  return {
    closestScrollable: closestScrollable,
    isFixedOnPage: isFixedOnPage
  };
});

var getDroppableDimension = (function (_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      isCombineEnabled = _ref.isCombineEnabled,
      isFixedOnPage = _ref.isFixedOnPage,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest = _ref.closest;

  var frame = function () {
    if (!closest) {
      return null;
    }

    var scrollSize = closest.scrollSize,
        frameClient = closest.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest.page.marginBox,
      frameClient: frameClient,
      scrollSize: scrollSize,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,
        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var axis = direction === 'vertical' ? vertical : horizontal;
  var subject = getSubject({
    page: page,
    withPlaceholder: null,
    axis: axis,
    frame: frame
  });
  var dimension = {
    descriptor: descriptor,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: isFixedOnPage,
    axis: axis,
    isEnabled: isEnabled,
    client: client,
    page: page,
    frame: frame,
    subject: subject
  };
  return dimension;
});

var getClient = function getClient(targetRef, closestScrollable) {
  var base = getBox(targetRef);

  if (!closestScrollable) {
    return base;
  }

  if (targetRef !== closestScrollable) {
    return base;
  }

  var top = base.paddingBox.top - closestScrollable.scrollTop;
  var left = base.paddingBox.left - closestScrollable.scrollLeft;
  var bottom = top + closestScrollable.scrollHeight;
  var right = left + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  var borderBox = expand(paddingBox, base.border);
  var client = createBox({
    borderBox: borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding
  });
  return client;
};

var getDimension = (function (_ref) {
  var ref = _ref.ref,
      descriptor = _ref.descriptor,
      env = _ref.env,
      windowScroll = _ref.windowScroll,
      direction = _ref.direction,
      isDropDisabled = _ref.isDropDisabled,
      isCombineEnabled = _ref.isCombineEnabled,
      shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env.closestScrollable;
  var client = getClient(ref, closestScrollable);
  var page = withScroll(client, windowScroll);

  var closest = function () {
    if (!closestScrollable) {
      return null;
    }

    var frameClient = getBox(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: withScroll(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize: scrollSize,
      shouldClipSubject: shouldClipSubject
    };
  }();

  var dimension = getDroppableDimension({
    descriptor: descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction: direction,
    client: client,
    page: page,
    closest: closest
  });
  return dimension;
});

var immediate = {
  passive: false
};
var delayed = {
  passive: true
};
var getListenerOptions = (function (options) {
  return options.shouldPublishImmediately ? immediate : delayed;
});

function useRequiredContext(Context) {
  var result = (0,react.useContext)(Context);
  !result ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return result;
}

var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};

function useDroppablePublisher(args) {
  var whileDraggingRef = (0,react.useRef)(null);
  var appContext = useRequiredContext(AppContext);
  var uniqueId = useUniqueId('droppable');
  var registry = appContext.registry,
      marshal = appContext.marshal;
  var previousRef = usePrevious(args);
  var descriptor = useMemo(function () {
    return {
      id: args.droppableId,
      type: args.type,
      mode: args.mode
    };
  }, [args.droppableId, args.mode, args.type]);
  var publishedDescriptorRef = (0,react.useRef)(descriptor);
  var memoizedUpdateScroll = useMemo(function () {
    return (0,memoize_one_esm["default"])(function (x, y) {
      !whileDraggingRef.current ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      var scroll = {
        x: x,
        y: y
      };
      marshal.updateDroppableScroll(descriptor.id, scroll);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;

    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }

    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = useCallback(function () {
    var scroll = getClosestScroll();
    memoizedUpdateScroll(scroll.x, scroll.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = useMemo(function () {
    return raf_schd_esm(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var options = dragging.scrollOptions;

    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }

    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = useCallback(function (windowScroll, options) {
    !!whileDraggingRef.current ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var previous = previousRef.current;
    var ref = previous.getDroppableRef();
    !ref ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var env = getEnv(ref);
    var dragging = {
      ref: ref,
      descriptor: descriptor,
      env: env,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref,
      descriptor: descriptor,
      env: env,
      windowScroll: windowScroll,
      direction: previous.direction,
      isDropDisabled: previous.isDropDisabled,
      isCombineEnabled: previous.isCombineEnabled,
      shouldClipSubject: !previous.ignoreContainerClipping
    });
    var scrollable = env.closestScrollable;

    if (scrollable) {
      scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
      scrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));

      if (false) {}
    }

    return dimension;
  }, [appContext.contextId, descriptor, onClosestScroll, previousRef]);
  var getScrollWhileDragging = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return getScroll$1(closest);
  }, []);
  var dragStopped = useCallback(function () {
    var dragging = whileDraggingRef.current;
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    whileDraggingRef.current = null;

    if (!closest) {
      return;
    }

    scheduleScrollUpdate.cancel();
    closest.removeAttribute(scrollContainer.contextId);
    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll = useCallback(function (change) {
    var dragging = whileDraggingRef.current;
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    !closest ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    closest.scrollTop += change.y;
    closest.scrollLeft += change.x;
  }, []);
  var callbacks = useMemo(function () {
    return {
      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
      getScrollWhileDragging: getScrollWhileDragging,
      dragStopped: dragStopped,
      scroll: scroll
    };
  }, [dragStopped, getDimensionAndWatchScroll, getScrollWhileDragging, scroll]);
  var entry = useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      callbacks: callbacks
    };
  }, [callbacks, descriptor, uniqueId]);
  useIsomorphicLayoutEffect(function () {
    publishedDescriptorRef.current = entry.descriptor;
    registry.droppable.register(entry);
    return function () {
      if (whileDraggingRef.current) {
         false ? 0 : void 0;
        dragStopped();
      }

      registry.droppable.unregister(entry);
    };
  }, [callbacks, descriptor, dragStopped, entry, marshal, registry.droppable]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}

function noop$2() {}

var empty = {
  width: 0,
  height: 0,
  margin: react_beautiful_dnd_esm_noSpacing
};

var getSize = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
      placeholder = _ref.placeholder,
      animate = _ref.animate;

  if (isAnimatingOpenOnMount) {
    return empty;
  }

  if (animate === 'close') {
    return empty;
  }

  return {
    height: placeholder.client.borderBox.height,
    width: placeholder.client.borderBox.width,
    margin: placeholder.client.margin
  };
};

var getStyle = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
      placeholder = _ref2.placeholder,
      animate = _ref2.animate;
  var size = getSize({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    placeholder: placeholder,
    animate: animate
  });
  return {
    display: placeholder.display,
    boxSizing: 'border-box',
    width: size.width,
    height: size.height,
    marginTop: size.margin.top,
    marginRight: size.margin.right,
    marginBottom: size.margin.bottom,
    marginLeft: size.margin.left,
    flexShrink: '0',
    flexGrow: '0',
    pointerEvents: 'none',
    transition: animate !== 'none' ? transitions.placeholder : null
  };
};

function Placeholder(props) {
  var animateOpenTimerRef = (0,react.useRef)(null);
  var tryClearAnimateOpenTimer = useCallback(function () {
    if (!animateOpenTimerRef.current) {
      return;
    }

    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate,
      onTransitionEnd = props.onTransitionEnd,
      onClose = props.onClose,
      contextId = props.contextId;

  var _useState = (0,react.useState)(props.animate === 'open'),
      isAnimatingOpenOnMount = _useState[0],
      setIsAnimatingOpenOnMount = _useState[1];

  (0,react.useEffect)(function () {
    if (!isAnimatingOpenOnMount) {
      return noop$2;
    }

    if (animate !== 'open') {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop$2;
    }

    if (animateOpenTimerRef.current) {
      return noop$2;
    }

    animateOpenTimerRef.current = setTimeout(function () {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = useCallback(function (event) {
    if (event.propertyName !== 'height') {
      return;
    }

    onTransitionEnd();

    if (animate === 'close') {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style = getStyle({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return react.createElement(props.placeholder.tagName, {
    style: style,
    'data-rbd-placeholder-context-id': contextId,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}

var Placeholder$1 = react.memo(Placeholder);

var DroppableContext = react.createContext(null);

function checkIsValidInnerRef(el) {
  !(el && isHtmlElement(el)) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}

function isBoolean(value) {
  return typeof value === 'boolean';
}

function runChecks(args, checks) {
  checks.forEach(function (check) {
    return check(args);
  });
}

var shared = [function required(_ref) {
  var props = _ref.props;
  !props.droppableId ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  !(typeof props.droppableId === 'string') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}, function _boolean(_ref2) {
  var props = _ref2.props;
  !isBoolean(props.isDropDisabled) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  !isBoolean(props.isCombineEnabled) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  !isBoolean(props.ignoreContainerClipping) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}, function ref(_ref3) {
  var getDroppableRef = _ref3.getDroppableRef;
  checkIsValidInnerRef(getDroppableRef());
}];
var standard = [function placeholder(_ref4) {
  var props = _ref4.props,
      getPlaceholderRef = _ref4.getPlaceholderRef;

  if (!props.placeholder) {
    return;
  }

  var ref = getPlaceholderRef();

  if (ref) {
    return;
  }

   false ? 0 : void 0;
}];
var virtual = [function hasClone(_ref5) {
  var props = _ref5.props;
  !props.renderClone ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}, function hasNoPlaceholder(_ref6) {
  var getPlaceholderRef = _ref6.getPlaceholderRef;
  !!getPlaceholderRef() ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}];
function useValidation(args) {
  useDevSetupWarning(function () {
    runChecks(args, shared);

    if (args.props.mode === 'standard') {
      runChecks(args, standard);
    }

    if (args.props.mode === 'virtual') {
      runChecks(args, virtual);
    }
  });
}

var AnimateInOut = function (_React$PureComponent) {
  (0,inheritsLoose/* default */.Z)(AnimateInOut, _React$PureComponent);

  function AnimateInOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
    };

    _this.onClose = function () {
      if (_this.state.animate !== 'close') {
        return;
      }

      _this.setState({
        isVisible: false
      });
    };

    return _this;
  }

  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: 'none'
      };
    }

    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: 'open'
      };
    }

    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: 'close'
      };
    }

    return {
      isVisible: false,
      animate: 'close',
      data: null
    };
  };

  var _proto = AnimateInOut.prototype;

  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }

    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };

  return AnimateInOut;
}(react.PureComponent);

var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }

  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }

  return transitions.fluid;
};

var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }

  return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};

var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }

  return dragging.mode === 'SNAP';
};

function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset = dragging.offset,
      combineWith = dragging.combineWith,
      dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
  var style = {
    position: 'fixed',
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: 'border-box',
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition(shouldAnimate, dropping),
    transform: transform,
    opacity: getDraggingOpacity(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: 'none'
  };
  return style;
}

function getSecondaryStyle(secondary) {
  return {
    transform: transforms.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : 'none'
  };
}

function getStyle$1(mapped) {
  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}

function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }

  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client = calculateBox(borderBox, computedStyles);
  var page = withScroll(client, windowScroll);
  var placeholder = {
    client: client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client.marginBox.width,
    y: client.marginBox.height
  };
  var dimension = {
    descriptor: descriptor,
    placeholder: placeholder,
    displaceBy: displaceBy,
    client: client,
    page: page
  };
  return dimension;
}

function useDraggablePublisher(args) {
  var uniqueId = useUniqueId('draggable');
  var descriptor = args.descriptor,
      registry = args.registry,
      getDraggableRef = args.getDraggableRef,
      canDragInteractiveElements = args.canDragInteractiveElements,
      shouldRespectForcePress = args.shouldRespectForcePress,
      isEnabled = args.isEnabled;
  var options = useMemo(function () {
    return {
      canDragInteractiveElements: canDragInteractiveElements,
      shouldRespectForcePress: shouldRespectForcePress,
      isEnabled: isEnabled
    };
  }, [canDragInteractiveElements, isEnabled, shouldRespectForcePress]);
  var getDimension = useCallback(function (windowScroll) {
    var el = getDraggableRef();
    !el ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return getDimension$1(descriptor, el, windowScroll);
  }, [descriptor, getDraggableRef]);
  var entry = useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      options: options,
      getDimension: getDimension
    };
  }, [descriptor, getDimension, options, uniqueId]);
  var publishedRef = (0,react.useRef)(entry);
  var isFirstPublishRef = (0,react.useRef)(true);
  useIsomorphicLayoutEffect(function () {
    registry.draggable.register(publishedRef.current);
    return function () {
      return registry.draggable.unregister(publishedRef.current);
    };
  }, [registry.draggable]);
  useIsomorphicLayoutEffect(function () {
    if (isFirstPublishRef.current) {
      isFirstPublishRef.current = false;
      return;
    }

    var last = publishedRef.current;
    publishedRef.current = entry;
    registry.draggable.update(entry, last);
  }, [entry, registry.draggable]);
}

function useValidation$1(props, contextId, getRef) {
  useDevSetupWarning(function () {
    function prefix(id) {
      return "Draggable[id: " + id + "]: ";
    }

    var id = props.draggableId;
    !id ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !(typeof id === 'string') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !isInteger(props.index) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    if (props.mapped.type === 'DRAGGING') {
      return;
    }

    checkIsValidInnerRef(getRef());

    if (props.isEnabled) {
      !findDragHandle(contextId, id) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    }
  });
}
function useClonePropValidation(isClone) {
  useDev(function () {
    var initialRef = (0,react.useRef)(isClone);
    useDevSetupWarning(function () {
      !(isClone === initialRef.current) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    }, [isClone]);
  });
}

function preventHtml5Dnd(event) {
  event.preventDefault();
}

function Draggable(props) {
  var ref = (0,react.useRef)(null);
  var setRef = useCallback(function (el) {
    ref.current = el;
  }, []);
  var getRef = useCallback(function () {
    return ref.current;
  }, []);

  var _useRequiredContext = useRequiredContext(AppContext),
      contextId = _useRequiredContext.contextId,
      dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId,
      registry = _useRequiredContext.registry;

  var _useRequiredContext2 = useRequiredContext(DroppableContext),
      type = _useRequiredContext2.type,
      droppableId = _useRequiredContext2.droppableId;

  var descriptor = useMemo(function () {
    return {
      id: props.draggableId,
      index: props.index,
      type: type,
      droppableId: droppableId
    };
  }, [props.draggableId, props.index, type, droppableId]);
  var children = props.children,
      draggableId = props.draggableId,
      isEnabled = props.isEnabled,
      shouldRespectForcePress = props.shouldRespectForcePress,
      canDragInteractiveElements = props.canDragInteractiveElements,
      isClone = props.isClone,
      mapped = props.mapped,
      dropAnimationFinishedAction = props.dropAnimationFinished;
  useValidation$1(props, contextId, getRef);
  useClonePropValidation(isClone);

  if (!isClone) {
    var forPublisher = useMemo(function () {
      return {
        descriptor: descriptor,
        registry: registry,
        getDraggableRef: getRef,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress,
        isEnabled: isEnabled
      };
    }, [descriptor, registry, getRef, canDragInteractiveElements, shouldRespectForcePress, isEnabled]);
    useDraggablePublisher(forPublisher);
  }

  var dragHandleProps = useMemo(function () {
    return isEnabled ? {
      tabIndex: 0,
      role: 'button',
      'aria-describedby': dragHandleUsageInstructionsId,
      'data-rbd-drag-handle-draggable-id': draggableId,
      'data-rbd-drag-handle-context-id': contextId,
      draggable: false,
      onDragStart: preventHtml5Dnd
    } : null;
  }, [contextId, dragHandleUsageInstructionsId, draggableId, isEnabled]);
  var onMoveEnd = useCallback(function (event) {
    if (mapped.type !== 'DRAGGING') {
      return;
    }

    if (!mapped.dropping) {
      return;
    }

    if (event.propertyName !== 'transform') {
      return;
    }

    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = useMemo(function () {
    var style = getStyle$1(mapped);
    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        'data-rbd-draggable-context-id': contextId,
        'data-rbd-draggable-id': draggableId,
        style: style,
        onTransitionEnd: onTransitionEnd
      },
      dragHandleProps: dragHandleProps
    };
    return result;
  }, [contextId, dragHandleProps, draggableId, mapped, onMoveEnd, setRef]);
  var rubric = useMemo(function () {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  }, [descriptor.droppableId, descriptor.id, descriptor.index, descriptor.type]);
  return children(provided, mapped.snapshot, rubric);
}

var isStrictEqual = (function (a, b) {
  return a === b;
});

var whatIsDraggedOverFromResult = (function (result) {
  var combine = result.combine,
      destination = result.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
});

var getCombineWithFromResult = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};

var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
  return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};

function getDraggableSelector() {
  var memoizedOffset = (0,memoize_one_esm["default"])(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = (0,memoize_one_esm["default"])(function (mode, isClone, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isClone: isClone,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode: mode,
      draggingOver: draggingOver,
      combineWith: combineWith,
      combineTargetFor: null
    };
  });
  var getMemoizedProps = (0,memoize_one_esm["default"])(function (offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: 'DRAGGING',
        dropping: null,
        draggingOver: draggingOver,
        combineWith: combineWith,
        mode: mode,
        offset: offset,
        dimension: dimension,
        forceShouldAnimate: forceShouldAnimate,
        snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
      }
    };
  });

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var isClone = ownProps.isClone;
      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var mode = result.mode;

      var _draggingOver = whatIsDraggedOverFromResult(result);

      var _combineWith = getCombineWithFromResult(result);

      var duration = state.dropDuration;
      var dropping = {
        duration: duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine.opacity.drop : null,
        scale: _combineWith ? combine.scale.drop : null
      };
      return {
        mapped: {
          type: 'DRAGGING',
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping: dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: mode,
          forceShouldAnimate: null,
          snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
        }
      };
    }

    return null;
  };

  return selector;
}

function getSecondarySnapshot(combineTargetFor) {
  return {
    isDragging: false,
    isDropAnimating: false,
    isClone: false,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: combineTargetFor,
    combineWith: null
  };
}

var atRest = {
  mapped: {
    type: 'SECONDARY',
    offset: origin,
    combineTargetFor: null,
    shouldAnimateDisplacement: true,
    snapshot: getSecondarySnapshot(null)
  }
};

function getSecondarySelector() {
  var memoizedOffset = (0,memoize_one_esm["default"])(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = (0,memoize_one_esm["default"])(getSecondarySnapshot);
  var getMemoizedProps = (0,memoize_one_esm["default"])(function (offset, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }

    return {
      mapped: {
        type: 'SECONDARY',
        offset: offset,
        combineTargetFor: combineTargetFor,
        shouldAnimateDisplacement: shouldAnimateDisplacement,
        snapshot: getMemoizedSnapshot(combineTargetFor)
      }
    };
  });

  var getFallback = function getFallback(combineTargetFor) {
    return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
  };

  var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
    var visualDisplacement = impact.displaced.visible[ownId];
    var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
    var combine = tryGetCombine(impact);
    var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;

    if (!visualDisplacement) {
      if (!isAfterCriticalInVirtualList) {
        return getFallback(combineTargetFor);
      }

      if (impact.displaced.invisible[ownId]) {
        return null;
      }

      var change = negate(afterCritical.displacedBy.point);

      var _offset = memoizedOffset(change.x, change.y);

      return getMemoizedProps(_offset, combineTargetFor, true);
    }

    if (isAfterCriticalInVirtualList) {
      return getFallback(combineTargetFor);
    }

    var displaceBy = impact.displacedBy.point;
    var offset = memoizedOffset(displaceBy.x, displaceBy.y);
    return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
  };

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
    }

    return null;
  };

  return selector;
}

var makeMapStateToProps = function makeMapStateToProps() {
  var draggingSelector = getDraggableSelector();
  var secondarySelector = getSecondarySelector();

  var selector = function selector(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
  };

  return selector;
};
var mapDispatchToProps = {
  dropAnimationFinished: dropAnimationFinished
};
var ConnectedDraggable = (0,es/* connect */.$j)(makeMapStateToProps, mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);

function PrivateDraggable(props) {
  var droppableContext = useRequiredContext(DroppableContext);
  var isUsingCloneFor = droppableContext.isUsingCloneFor;

  if (isUsingCloneFor === props.draggableId && !props.isClone) {
    return null;
  }

  return react.createElement(ConnectedDraggable, props);
}
function PublicDraggable(props) {
  var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
  var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
  var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
  return react.createElement(PrivateDraggable, (0,esm_extends/* default */.Z)({}, props, {
    isClone: false,
    isEnabled: isEnabled,
    canDragInteractiveElements: canDragInteractiveElements,
    shouldRespectForcePress: shouldRespectForcePress
  }));
}

function Droppable(props) {
  var appContext = (0,react.useContext)(AppContext);
  !appContext ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var contextId = appContext.contextId,
      isMovementAllowed = appContext.isMovementAllowed;
  var droppableRef = (0,react.useRef)(null);
  var placeholderRef = (0,react.useRef)(null);
  var children = props.children,
      droppableId = props.droppableId,
      type = props.type,
      mode = props.mode,
      direction = props.direction,
      ignoreContainerClipping = props.ignoreContainerClipping,
      isDropDisabled = props.isDropDisabled,
      isCombineEnabled = props.isCombineEnabled,
      snapshot = props.snapshot,
      useClone = props.useClone,
      updateViewportMaxScroll = props.updateViewportMaxScroll,
      getContainerForClone = props.getContainerForClone;
  var getDroppableRef = useCallback(function () {
    return droppableRef.current;
  }, []);
  var setDroppableRef = useCallback(function (value) {
    droppableRef.current = value;
  }, []);
  var getPlaceholderRef = useCallback(function () {
    return placeholderRef.current;
  }, []);
  var setPlaceholderRef = useCallback(function (value) {
    placeholderRef.current = value;
  }, []);
  useValidation({
    props: props,
    getDroppableRef: getDroppableRef,
    getPlaceholderRef: getPlaceholderRef
  });
  var onPlaceholderTransitionEnd = useCallback(function () {
    if (isMovementAllowed()) {
      updateViewportMaxScroll({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed, updateViewportMaxScroll]);
  useDroppablePublisher({
    droppableId: droppableId,
    type: type,
    mode: mode,
    direction: direction,
    isDropDisabled: isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    ignoreContainerClipping: ignoreContainerClipping,
    getDroppableRef: getDroppableRef
  });
  var placeholder = react.createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function (_ref) {
    var onClose = _ref.onClose,
        data = _ref.data,
        animate = _ref.animate;
    return react.createElement(Placeholder$1, {
      placeholder: data,
      onClose: onClose,
      innerRef: setPlaceholderRef,
      animate: animate,
      contextId: contextId,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = useMemo(function () {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder,
      droppableProps: {
        'data-rbd-droppable-id': droppableId,
        'data-rbd-droppable-context-id': contextId
      }
    };
  }, [contextId, droppableId, placeholder, setDroppableRef]);
  var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
  var droppableContext = useMemo(function () {
    return {
      droppableId: droppableId,
      type: type,
      isUsingCloneFor: isUsingCloneFor
    };
  }, [droppableId, isUsingCloneFor, type]);

  function getClone() {
    if (!useClone) {
      return null;
    }

    var dragging = useClone.dragging,
        render = useClone.render;
    var node = react.createElement(PrivateDraggable, {
      draggableId: dragging.draggableId,
      index: dragging.source.index,
      isClone: true,
      isEnabled: true,
      shouldRespectForcePress: false,
      canDragInteractiveElements: true
    }, function (draggableProvided, draggableSnapshot) {
      return render(draggableProvided, draggableSnapshot, dragging);
    });
    return react_dom.createPortal(node, getContainerForClone());
  }

  return react.createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot), getClone());
}

var isMatchingType = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};

var getDraggable = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};

var makeMapStateToProps$1 = function makeMapStateToProps() {
  var idleWithAnimation = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: false
    },
    useClone: null
  };

  var idleWithoutAnimation = (0,esm_extends/* default */.Z)({}, idleWithAnimation, {
    shouldAnimatePlaceholder: false
  });

  var getDraggableRubric = (0,memoize_one_esm["default"])(function (descriptor) {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  });
  var getMapProps = (0,memoize_one_esm["default"])(function (id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;

    if (isHome) {
      var useClone = renderClone ? {
        render: renderClone,
        dragging: getDraggableRubric(dragging.descriptor)
      } : null;
      var _snapshot = {
        isDraggingOver: isDraggingOverForConsumer,
        draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
        draggingFromThisWith: draggableId,
        isUsingPlaceholder: true
      };
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: _snapshot,
        useClone: useClone
      };
    }

    if (!isEnabled) {
      return idleWithoutAnimation;
    }

    if (!isDraggingOverForImpact) {
      return idleWithAnimation;
    }

    var snapshot = {
      isDraggingOver: isDraggingOverForConsumer,
      draggingOverWith: draggableId,
      draggingFromThisWith: null,
      isUsingPlaceholder: true
    };
    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot: snapshot,
      useClone: null
    };
  });

  var selector = function selector(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;
    var isEnabled = !ownProps.isDropDisabled;
    var renderClone = ownProps.renderClone;

    if (state.isDragging) {
      var critical = state.critical;

      if (!isMatchingType(type, critical)) {
        return idleWithoutAnimation;
      }

      var dragging = getDraggable(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (!isMatchingType(type, completed.critical)) {
        return idleWithoutAnimation;
      }

      var _dragging = getDraggable(completed.critical, state.dimensions);

      return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
    }

    if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
      var _completed = state.completed;

      if (!isMatchingType(type, _completed.critical)) {
        return idleWithoutAnimation;
      }

      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
      var isHome = _completed.critical.droppable.id === id;

      if (wasOver) {
        return wasCombining ? idleWithAnimation : idleWithoutAnimation;
      }

      if (isHome) {
        return idleWithAnimation;
      }

      return idleWithoutAnimation;
    }

    return idleWithoutAnimation;
  };

  return selector;
};
var mapDispatchToProps$1 = {
  updateViewportMaxScroll: updateViewportMaxScroll
};

function getBody() {
  !document.body ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return document.body;
}

var defaultProps = {
  mode: 'standard',
  type: 'DEFAULT',
  direction: 'vertical',
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false,
  renderClone: null,
  getContainerForClone: getBody
};
var ConnectedDroppable = (0,es/* connect */.$j)(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps;



;// CONCATENATED MODULE: ./src/mosanic/core/Collections/FieldsDragWrapper.js




var FieldsDragContext = function(param) {
    var id = param.id, move = param.move, children = param.children;
    var handleDrag = function(param) {
        var source = param.source, destination = param.destination;
        if (destination) {
            move(source.index, destination.index);
        // alert(`${source.index} > ${destination.index}`)
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DragDropContext, {
        onDragEnd: handleDrag,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectedDroppable, {
            droppableId: id,
            children: function(provided, snapshot) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided.droppableProps), {
                    ref: provided.innerRef,
                    children: [
                        children,
                        provided.placeholder
                    ]
                }));
            }
        })
    });
};
var FieldDragItem = function(param) {
    var index = param.index, id = param.id, render = param.render;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicDraggable, {
        draggableId: "item-".concat(index),
        index: index,
        children: function(provided, snapshot) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: provided.innerRef
            }, provided.draggableProps), {
                children: render(provided.dragHandleProps)
            }), id);
        }
    }, "drag[".concat(index, "]"));
};

;// CONCATENATED MODULE: ./src/mosanic/core/Collections/FieldsFilters.js










var useFieldFilters = function(param) {
    var watch = param.watch;
    var ref = (0,react.useState)({
        meta: null,
        type: null,
        displayName: false
    }), filters = ref[0], setFieldFilters = ref[1];
    var shouldFilter = function(group) {
        var ref;
        return Array.isArray(filters === null || filters === void 0 ? void 0 : filters[group]) && (filters === null || filters === void 0 ? void 0 : (ref = filters[group]) === null || ref === void 0 ? void 0 : ref.length) >= 1;
    };
    var getFilter = function(group) {
        var ref;
        return filters === null || filters === void 0 ? void 0 : (ref = filters[group]) === null || ref === void 0 ? void 0 : ref.map(function(f) {
            return f.value;
        });
    };
    var setFilter = function(val, group) {
        return setFieldFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), (0,_define_property/* default */.Z)({}, group, val)));
    };
    var inFilters = function(field) {
        var ref;
        if (!filters.meta && !filters.inMap && !filters.type) return field;
        var pass = true;
        if (shouldFilter("type") && !((ref = getFilter("type")) === null || ref === void 0 ? void 0 : ref.includes(field.type))) return;
        if (shouldFilter("meta")) {
            getFilter("meta").map(function(filter) {
                if (!(0,Obj/* hasAttr */.B$)(field, filter) || !(field === null || field === void 0 ? void 0 : field[filter])) pass = false;
            });
        }
        return pass ? field : null;
    };
    var getOptions = function(options, validate) {
        return options.map(function(o) {
            var ref, ref1, ref2;
            return {
                value: o,
                count: (ref2 = (ref = watch()) === null || ref === void 0 ? void 0 : (ref1 = ref.schema) === null || ref1 === void 0 ? void 0 : ref1.filter(function(f) {
                    return validate(f, o);
                })) === null || ref2 === void 0 ? void 0 : ref2.length
            };
        }).filter(function(o) {
            return o.count >= 1;
        }).map(function(o) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, o), {
                label: (0,Text/* capitalizeFirst */.Ez)("".concat((0,Text/* replacePart */.bA)(o.value, "Active", ""), " (").concat(o.count, ")"))
            });
        });
    };
    var filterGroups = [
        {
            label: "Field type",
            options: getOptions(FieldType/* inputFields */.N, function(f, o) {
                return f.type === o;
            }),
            type: "type"
        },
        {
            label: "Validation",
            options: getOptions("none|regexActive|populateActive|limit".split("|"), function(f, o) {
                return f === null || f === void 0 ? void 0 : f[o];
            }),
            type: "validate"
        },
        {
            label: "Field meta",
            options: getOptions("all|inMap|localized|props|variable|required|searchable|filterable".split("|"), function(f, o) {
                return f === null || f === void 0 ? void 0 : f[o];
            }),
            type: "meta"
        }
    ];
    return [
        filterGroups,
        filters,
        inFilters,
        setFilter
    ];
};
var FieldFilters = function(param) {
    var filterGroups = param.filterGroups, setFilter = param.setFilter, filters = param.filters;
    /*#__PURE__*/ return _jsx(InlineGroup, {
        justify: "space-between",
        children: filterGroups.filter(function(g) {
            var ref;
            return ((ref = g.options) === null || ref === void 0 ? void 0 : ref.length) >= 1;
        }).map(function(g) {
            /*#__PURE__*/ return _jsx(Select, {
                wrap: true,
                multiple: true,
                searchable: true,
                label: g.label,
                value: filters === null || filters === void 0 ? void 0 : filters[g.type],
                onChange: function(val) {
                    return setFilter(val, g.type);
                },
                options: g.options.sort(function(a, b) {
                    return b.count - a.count;
                })
            }, g.type);
        })
    });
};

// EXTERNAL MODULE: ./src/mosanic/core/Collections/useCollections.js
var useCollections = __webpack_require__(52610);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/mosanic/core/Collections/FieldsCollection.js


























var ReactJson = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8047).then(__webpack_require__.t.bind(__webpack_require__, 48047, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48047)
            ];
        }
    },
    ssr: false
});
var FieldsCollection = function(param) {
    var ctx = param.ctx, _id = param.id, id = _id === void 0 ? "schema" : _id, _level = param.level, level = _level === void 0 ? 0 : _level, _type = param.type, type = _type === void 0 ? "field" : _type, _skipFirstField = param.skipFirstField, skipFirstField = _skipFirstField === void 0 ? false : _skipFirstField;
    // const PRO = useDataProvider()
    var collections = (0,useCollections/* useCollectionSelector */.Zl)();
    var users = ((0,DataProviders/* useDataProvider */.x5)() || {
        users: null
    }).users;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useDataQuery/* useGet */.XD)({
        query: pages/* PAGES */.q5,
        type: "page",
        method: "Many",
        silent: true,
        params: {
            filter: {
                type: "zone"
            }
        }
    }), 2), getP = ref[0], ref1 = (0,_sliced_to_array/* default */.Z)(ref[1], 1), zones = ref1[0];
    var ref2 = (0,index_esm/* useFormContext */.Gc)(), control = ref2.control, setValue = ref2.setValue, watch = ref2.watch, isValid = ref2.formState.isValid;
    var ref3 = (0,index_esm/* useFieldArray */.Dq)({
        name: id
    }), fields = ref3.fields, append = ref3.append, prepend = ref3.prepend, remove = ref3.remove, swap = ref3.swap, move = ref3.move, insert = ref3.insert;
    var ref4 = (0,react.useState)({}), expanded = ref4[0], setExpanded = ref4[1];
    var toggle = function(i) {
        return setExpanded(// ...expanded,
        (0,_define_property/* default */.Z)({}, i, (0,Obj/* hasAttr */.B$)(expanded, i) ? !(expanded === null || expanded === void 0 ? void 0 : expanded[i]) : true));
    };
    var addItem = function() {
        return append({
            id: (0,ObjectID/* ObjectID */.t)(),
            type: "text",
            maxDepth: 0
        });
    };
    var ref5 = (0,_sliced_to_array/* default */.Z)(useFieldFilters({
        watch: watch
    }), 4), filterGroups = ref5[0], filters = ref5[1], inFilters = ref5[2], setFilter = ref5[3];
    var userId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetUser */.pg)({
        _id: userId
    }), 1), user_data = ref6[0];
    var user = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user_data), {
        pref: undefined,
        sites: undefined,
        teams: undefined,
        notifications: undefined,
        security: undefined
    });
    var parent = (0,DataProviders/* useDataProvider */.x5)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: level === 0,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DataProviders/* DataProvider */.FW, {
                data: {
                    collections: collections,
                    zones: zones,
                    filters: filters,
                    users: users,
                    ctx: ctx,
                    user: user
                },
                children: children
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldHeaderLabels, {
                level: level != 0 ? "Sub" : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldsDragContext, {
                id: id,
                move: move,
                children: fields.map(function(field, index) {
                    return inFilters(field) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldDragItem, {
                        index: index,
                        id: (field === null || field === void 0 ? void 0 : field.id) ? field.id : index,
                        render: function(dragHandle) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(CollectionField, {
                                skipFirstField: skipFirstField,
                                dragHandle: dragHandle,
                                id: id,
                                fieldId: "".concat(id, ".").concat(index),
                                expanded: expanded,
                                toggle: toggle,
                                index: index,
                                move: move,
                                remove: remove,
                                fieldCount: fields === null || fields === void 0 ? void 0 : fields.length,
                                level: level
                            });
                        }
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Button, {
                mt: 4,
                type: "button",
                onClick: addItem,
                children: [
                    EditIcons/* circlePlus */.Tw,
                    " \xa0 ",
                    (fields === null || fields === void 0 ? void 0 : fields.length) >= 1 ? "Append ".concat(type) : "Add first ".concat(type)
                ]
            })
        ]
    });
};
var StepsCollection = function(param) {
    var _id = param.id, id = _id === void 0 ? "schema" : _id, _level = param.level, level = _level === void 0 ? 0 : _level, _type = param.type, type = _type === void 0 ? "field" : _type;
    var ref = (0,index_esm/* useFieldArray */.Dq)({
        name: id
    }), fields = ref.fields, append = ref.append, prepend = ref.prepend, remove = ref.remove, swap = ref.swap, move = ref.move, insert = ref.insert;
    var steps = fields;
    var ref1 = (0,react.useState)({}), expanded = ref1[0], setExpanded = ref1[1];
    var toggle = function(i) {
        return setExpanded(// ...expanded,
        (0,_define_property/* default */.Z)({}, i, (0,Obj/* hasAttr */.B$)(expanded, i) ? !(expanded === null || expanded === void 0 ? void 0 : expanded[i]) : true));
    };
    var control = (0,index_esm/* useFormContext */.Gc)().control;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            steps.map(function(field, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                position: "relative",
                                height: "50px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                                    label: "step ".concat(index + 1)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldControls/* FieldControls */.g, {
                                    remove: remove,
                                    move: move,
                                    index: index,
                                    count: null
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldsCollection, {
                            id: "".concat(id, ".").concat(index),
                            level: level + 1
                        })
                    ]
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Button, {
                mt: 4,
                type: "button",
                onClick: function() {
                    return append({
                        type: "text",
                        name: "identifier",
                        help: "",
                        value: (0,ObjectID/* ObjectID */.t)()
                    });
                },
                children: [
                    EditIcons/* circlePlus */.Tw,
                    " \xa0 ",
                    (fields === null || fields === void 0 ? void 0 : fields.length) >= 1 ? "Append ".concat(type) : "Add first ".concat(type)
                ]
            })
        ]
    });
};


/***/ }),

/***/ 16990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y3": function() { return /* binding */ CollectionEntries; },
/* harmony export */   "lk": function() { return /* binding */ CollectionEditing; }
/* harmony export */ });
/* unused harmony exports CollectionHeaderColsInfo, CollectionHeader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mosanic_core_Collections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44032);
/* harmony import */ var _DataGrid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90131);
/* harmony import */ var _mosanic_cms_DataGrid_DataGrid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15121);









var CollectionHeaderColsInfo = function(param) {
    var collection = param.collection;
    var ref, ref1, ref2, ref3;
    /*#__PURE__*/ return _jsx(Columns, {
        equal: true,
        columns: [
            /*#__PURE__*/ _jsx(Label, {
                label: "Entry count",
                value: "".concat((collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.length) ? collection === null || collection === void 0 ? void 0 : (ref1 = collection.entries) === null || ref1 === void 0 ? void 0 : ref1.length : 0, " entries")
            }, "entries"),
            /*#__PURE__*/ _jsx(Label, {
                label: "Field count",
                value: "".concat((collection === null || collection === void 0 ? void 0 : (ref2 = collection.schema) === null || ref2 === void 0 ? void 0 : ref2.length) ? collection === null || collection === void 0 ? void 0 : (ref3 = collection.schema) === null || ref3 === void 0 ? void 0 : ref3.length : 0, " fields")
            }, "fields"),
            /*#__PURE__*/ _jsx(Label, {
                label: "Published",
                value: "".concat(getDate(collection === null || collection === void 0 ? void 0 : collection.date))
            }, "publish"),
            /*#__PURE__*/ _jsx(Label, {
                label: "Updated",
                value: "".concat(getFullTimeStamp(collection === null || collection === void 0 ? void 0 : collection.updatedAt))
            }, "updated"), 
        ]
    });
};
var CollectionHeader = function(param) {
    var collection = param.collection;
    /*#__PURE__*/ return _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h4", {
                children: (collection === null || collection === void 0 ? void 0 : collection.catchRoutes) && /*#__PURE__*/ _jsx(Tag, {
                    float: true,
                    right: true,
                    children: "Catch routes"
                })
            }),
            /*#__PURE__*/ _jsx(CollectionHeaderColsInfo, {
                collection: collection
            })
        ]
    });
};
var CollectionEditing = function(param) {
    var collection = param.collection, refreshData = param.refreshData;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_core_Collections__WEBPACK_IMPORTED_MODULE_2__/* .AddCollection */ .b, {
        initial: collection,
        dataType: collection === null || collection === void 0 ? void 0 : collection.type,
        type: "update",
        callback: refreshData
    });
};
var CollectionEntries = function(param) {
    var collection = param.collection, gridHandles = param.gridHandles, handles = param.handles, state = param.state, _pagination = param.pagination, pagination = _pagination === void 0 ? null : _pagination, _loading = param.loading, loading = _loading === void 0 ? null : _loading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_cms_DataGrid_DataGrid__WEBPACK_IMPORTED_MODULE_3__/* .DataGrid */ ._, {
                collection: collection,
                state: state,
                handles: gridHandles,
                pagination: pagination,
                loading: loading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DataGrid__WEBPACK_IMPORTED_MODULE_4__/* .DataGridModals */ .Xy, {
                collection: collection,
                handles: handles,
                state: state
            })
        ]
    });
};


/***/ }),

/***/ 63222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "an": function() { return /* binding */ CollectionSelectorImbed; }
/* harmony export */ });
/* unused harmony exports SwitchCollection, CollectionSelector */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66383);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26074);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25157);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);
/* harmony import */ var _mosanic_items_List__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62035);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77298);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var _mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43551);

















var collectionLabel = function(collection) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                children: collection === null || collection === void 0 ? void 0 : collection.title
            }),
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
            (collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.length) ? collection.entries.length : (collection === null || collection === void 0 ? void 0 : collection.count) ? collection.count : 0,
            " entries ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
        ]
    });
};
var getCollectionOptions = function(collections, full) {
    return (collections === null || collections === void 0 ? void 0 : collections.length) >= 1 ? collections.map(function(collection) {
        return {
            label: collectionLabel(collection),
            value: full ? collection : collection === null || collection === void 0 ? void 0 : collection._id
        };
    }) : [
        "No collections found."
    ];
};
var getSourceType = function(state, type) {
    return type != "collection" ? type : (state === null || state === void 0 ? void 0 : state.modus) === "page" ? "Page collection" : "Collection";
};
var SelectCollection = function(_param) {
    var _state = _param.state, state = _state === void 0 ? null : _state, _setState = _param.setState, setState = _setState === void 0 ? null : _setState, collections = _param.collections, _full = _param.full, full = _full === void 0 ? false : _full, _sourceSelector = _param.sourceSelector, sourceSelector = _sourceSelector === void 0 ? true : _sourceSelector, _type = _param.type, type = _type === void 0 ? "collection" : _type, _as = _param.as, as = _as === void 0 ? "select" : _as, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "state",
        "setState",
        "collections",
        "full",
        "sourceSelector",
        "type",
        "as"
    ]);
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CollectionSelector, {
        label: "".concat((state === null || state === void 0 ? void 0 : state.collection) ? "Active" : "Select", " ").concat(getSourceType(state, type)),
        collections: collections,
        value: state.collection,
        onChange: function(collection) {
            return setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                collection: collection
            }));
        },
        as: as
    });
};
var SwitchCollection = function(param) {
    var active = param.active;
    var router = useRouter();
    var ref = _sliced_to_array(useGetCollections({
        current: true
    }), 2), collections = ref[0], loading = ref[1];
    var ref1 = useState(false), dialog = ref1[0], setDialog = ref1[1];
    var switchPage = function(pageId) {
        setDialog("Switching collection...");
        setTimeout(function() {
            router.push("/collection/".concat(pageId));
            setDialog(false);
        }, 750);
    };
    return loading ? null : [
        /*#__PURE__*/ _jsx(Button, {
            icon: /*#__PURE__*/ _jsx(ExternalLinkIcon, {}),
            label: " Switch",
            onClick: function() {
                return setDialog(true);
            }
        }, "trigger"),
        /*#__PURE__*/ _jsx(ControlDialog, {
            state: dialog,
            close: function() {
                return setDialog(false);
            },
            children: isString(dialog) ? /*#__PURE__*/ _jsx(AdvancedLabel, {
                label: dialog
            }) : /*#__PURE__*/ _jsx(SelectCollection, {
                as: "list",
                setState: function(state) {
                    return switchPage(state === null || state === void 0 ? void 0 : state.collection);
                },
                state: {
                    collection: active
                },
                collections: collections,
                full: false,
                clearable: false,
                sourceSelector: false
            })
        }, "dialog")
    ];
};
var CollectionSelectorImbed = function(_param) {
    var onChange = _param.onChange, value = _param.value, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "onChange",
        "value"
    ]);
    var siteId = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_8__/* .siteIdSelector */ .uL);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_10__/* .useGetCollections */ .t8)({
        siteId: siteId
    }), 3), collections = ref[0], loading = ref[1], error = ref[2];
    return loading ? loading : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CollectionSelector, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        collections: collections,
        onChange: function(o) {
            console.log(o);
            onChange(o);
        },
        value: value
    }, other));
};
var CollectionSelector = function(_param) {
    var collections = _param.collections, onChange = _param.onChange, value = _param.value, label = _param.label, __idOnly = _param._idOnly, _idOnly = __idOnly === void 0 ? true : __idOnly, _as = _param.as, as = _as === void 0 ? "select" : _as, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "collections",
        "onChange",
        "value",
        "label",
        "_idOnly",
        "as"
    ]);
    var ref;
    return as === "select" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_11__.Select, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        // getOptionValue={o => o?.value}
        clearable: false,
        getValue: function(e) {
            return e.value;
        },
        options: getCollectionOptions(collections, !_idOnly),
        label: label ? label : "Select collection",
        value: value,
        onChange: onChange
    }, other)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_12__/* .List */ .aV, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_12__/* .ListItem */ .HC, {
                disabled: true,
                children: "All collections"
            }),
            (ref = getCollectionOptions(collections, !_idOnly)) === null || ref === void 0 ? void 0 : ref.map(function(o) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_12__/* .ListItem */ .HC, {
                    chevron: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .ChevronRightIcon */ .XCv, {}),
                    active: value === (o === null || o === void 0 ? void 0 : o.value),
                    onClick: function() {
                        return onChange(o.value);
                    },
                    children: o.label
                }, o.value);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (SelectCollection);


/***/ }),

/***/ 3849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qo": function() { return /* binding */ fieldSchemas; },
/* harmony export */   "x9": function() { return /* binding */ CodeFieldValue; }
/* harmony export */ });
/* unused harmony exports relationSchema, userSchema, seoSchema */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(71645);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(47914);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(84019);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(51085);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(57389);
/* harmony import */ var _mosanic_items_ControlPanel__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28932);
/* harmony import */ var _mosanic_items_ControlPanel__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77586);
/* harmony import */ var _mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(62035);
/* harmony import */ var _mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73987);
/* harmony import */ var _mosanic_utils_value__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(11039);
/* harmony import */ var _util_Date__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99787);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68311);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76854);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(49272);
/* harmony import */ var _mosanic_fields_Location_Location__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(43643);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77298);
/* harmony import */ var _redux_options_reducer__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(51331);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64157);
/* harmony import */ var _JSX__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96344);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(62570);















// import { getFieldValue, getLatestFieldFromFieldPath } from "../../../fields/Source/helpers";









var ReactJson = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 8047).then(__webpack_require__.t.bind(__webpack_require__, 48047, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48047)
            ];
        }
    },
    ssr: false
});
var CalculatorIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 480 512",
        width: "18px",
        height: "18px",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M72 160h112c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm5.09 247.6l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0L128 390.63l28.29 28.29c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31L150.63 368l28.29-28.29c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0L128 345.37l-28.29-28.29c-3.12-3.12-8.19-3.12-11.31 0L77.09 328.4c-3.12 3.12-3.12 8.19 0 11.31L105.37 368l-28.29 28.28a8.006 8.006 0 0 0 .01 11.32zM448 16H32C14.33 16 0 30.33 0 48v416c0 17.67 14.33 32 32 32h416c17.67 0 32-14.33 32-32V48c0-17.67-14.33-32-32-32zM224 464H32V272h192v192zm0-224H32V48h192v192zm224 224H256V272h192v192zm0-224H256V48h192v192zm-152-80h40v40c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-40h40c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-40V88c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v40h-40c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm0 256h112c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H296c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm0-64h112c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H296c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
        })
    });
};
var renderFieldData = function(field, data) {
    var ref;
    var img = (ref = (0,_mosanic_utils_Image__WEBPACK_IMPORTED_MODULE_6__/* .parseImageSrc */ .yO)(data, true)) === null || ref === void 0 ? void 0 : ref.thumb;
    if (img) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: img,
        width: "20px",
        height: "20px"
    });
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .isString */ .HD)(data) ? data.length >= 200 ? "[text] with ".concat(data.length, " chars") : (0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .excerptString */ .dK)(data, 18, "...") : data ? "[".concat(field === null || field === void 0 ? void 0 : field.type, "] with value") : data ? JSON.stringify(data) : "[".concat(field === null || field === void 0 ? void 0 : field.type, "]");
};
var getFieldLabel = function(field, activeEntry, devMode) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_8__/* .ConditionalWrapper */ .M, {
        when: devMode,
        wrapper: function(children) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items_ControlPanel__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                contextOnly: true,
                trigger: children,
                width: "400px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReactJson, {
                        name: "field",
                        src: field,
                        collapsed: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReactJson, {
                        name: "value",
                        src: {
                            data: activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry[field === null || field === void 0 ? void 0 : field.name]
                        }
                    })
                ]
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                    children: (0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .capitalizeFirst */ .Ez)(field === null || field === void 0 ? void 0 : field.name)
                }),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                activeEntry ? renderFieldData(field, activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry[field === null || field === void 0 ? void 0 : field.name]) : ""
            ]
        })
    });
};
var getFieldsSchema = function(schema, activeEntry, devMode) {
    return Array.isArray(schema) ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(schema === null || schema === void 0 ? void 0 : schema.map(function(field) {
        return {
            label: getFieldLabel(field, activeEntry, devMode),
            // value: field?.name,
            value: field,
            schema: field === null || field === void 0 ? void 0 : field.schema
        };
    })) : [
        "No fields available"
    ];
};
var getFieldSlug = function(schema, activeEntry) {
    var baseRoute = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var ref;
    return [
        {
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "Entry link"
                    }),
                    " ",
                    !baseRoute && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_ControlPanel__WEBPACK_IMPORTED_MODULE_11__/* .HelpPopper */ .q, {
                        span: true,
                        helpText: "Prefix url with code"
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    ">",
                    " ",
                    baseRoute,
                    "/",
                    (0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .excerptString */ .dK)(slugify__WEBPACK_IMPORTED_MODULE_2___default()((0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .toLowCase */ .Cc)(activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry[schema === null || schema === void 0 ? void 0 : (ref = schema[0]) === null || ref === void 0 ? void 0 : ref.name])), 7)
                ]
            }),
            value: {
                name: "slug",
                type: "slug"
            }
        }
    ];
};
var dateField = function(label, preview, value) {
    return {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                    children: label
                }),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                preview
            ]
        }),
        value: {
            name: value
        }
    };
};
var getFieldDates = function(activeEntry) {
    var baseRoute = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return [
        dateField("Created at", (0,_util_Date__WEBPACK_IMPORTED_MODULE_12__/* .getFullTimeStamp */ .tZ)(activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry.date), "date"),
        dateField("Updated at", (0,_util_Date__WEBPACK_IMPORTED_MODULE_12__/* .getFullTimeStamp */ .tZ)(activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry.updatedAt), "updatedAt")
    ];
};
var getFieldUsers = function(schema, activeEntry) {
    return (activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry.userId) ? [
        {
            value: {
                name: "userId"
            },
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "User id"
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry.userId
                ]
            })
        }
    ] : [];
};
var getFieldOptions = function(schema, activeEntry, baseRoute, devMode) {
    var base = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(getFieldsSchema(schema, activeEntry, devMode)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(getFieldSlug(schema, activeEntry, baseRoute)), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(getFieldDates(activeEntry, baseRoute)), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(getFieldUsers(schema, activeEntry)));
    return (base === null || base === void 0 ? void 0 : base.length) >= 3 ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(base).concat([
        {
            value: null,
            label: "Unset"
        }
    ]) : base;
};
var getFieldName = function(o) {
    var ref;
    return o === null || o === void 0 ? void 0 : (ref = o.value) === null || ref === void 0 ? void 0 : ref.name;
};
var SelectField = function(_param) {
    var _state = _param.state, state = _state === void 0 ? null : _state, _setState = _param.setState, setState = _setState === void 0 ? null : _setState, _collection = _param.collection, collection = _collection === void 0 ? null : _collection, _activeEntry = _param.activeEntry, activeEntry = _activeEntry === void 0 ? null : _activeEntry, _baseRoute = _param.baseRoute, baseRoute = _baseRoute === void 0 ? null : _baseRoute, _canSelectField = _param.canSelectField, canSelectField = _canSelectField === void 0 ? null : _canSelectField, _dataProvider = _param.dataProvider, dataProvider = _dataProvider === void 0 ? null : _dataProvider, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_param, [
        "state",
        "setState",
        "collection",
        "activeEntry",
        "baseRoute",
        "canSelectField",
        "dataProvider"
    ]);
    var ref, ref1, ref2, ref3;
    var getFieldPath = function(field, index) {
        var ref;
        if (index === 0) return [
            field
        ];
        var copy = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(state === null || state === void 0 ? void 0 : state.fieldPath);
        var pathLength = state === null || state === void 0 ? void 0 : (ref = state.fieldPath) === null || ref === void 0 ? void 0 : ref.length;
        // console.log(pathLength, index)
        if (pathLength > index) {
            copy.length = index;
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(copy).concat([
                field
            ]);
        }
        // console.log({field, newPath: [...state?.fieldPath, field]})
        // console.log([...state?.fieldPath, field])
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(state === null || state === void 0 ? void 0 : state.fieldPath).concat([
            field
        ]);
    };
    var setField = function(field, index) {
        var ref;
        var fieldName = field === null || field === void 0 ? void 0 : field.name;
        var fieldPath = getFieldPath(field, index);
        setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, state), {
            field: ((ref = state.modus) === null || ref === void 0 ? void 0 : ref.field) != "picker" ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, state.field), {
                field: fieldName
            }) : fieldName,
            fieldPath: fieldPath
        }));
    };
    var canLoopSubFields = Boolean((state === null || state === void 0 ? void 0 : state.fieldPath) && (state === null || state === void 0 ? void 0 : (ref = state.fieldPath) === null || ref === void 0 ? void 0 : ref.length) >= 1);
    var devMode = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_redux_options_reducer__WEBPACK_IMPORTED_MODULE_16__/* .getDevModePrefSelector */ .Lj);
    var getOptions = function(fieldSchema, entry) {
        var baseFields = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var options = getFieldOptions(fieldSchema, entry, baseRoute, devMode);
        return baseFields ? options : options.filter(function(o) {
            var ref;
            return ![
                "date",
                "updatedAt",
                "slug",
                "userId"
            ].includes(o === null || o === void 0 ? void 0 : (ref = o.value) === null || ref === void 0 ? void 0 : ref.name);
        });
    };
    // console.log(state?.schema, activeEntry)
    var isDisabledIndex = function(index) {
        var ref;
        return (dataProvider === null || dataProvider === void 0 ? void 0 : dataProvider.fieldPath) ? (dataProvider === null || dataProvider === void 0 ? void 0 : (ref = dataProvider.fieldPath) === null || ref === void 0 ? void 0 : ref.length) - 1 >= index : false;
    };
    var getFieldPathName = function(index) {
        var ref, ref1;
        return state === null || state === void 0 ? void 0 : (ref = state.fieldPath) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1.name;
    };
    var isActiveField = function(o, index) {
        return getFieldPathName(index) === getFieldName(o);
    };
    // console.log(getOptions(state?.schema, activeEntry))
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .List */ .aV, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                        disabled: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_18__/* .AdvancedLabel */ .qv, {
                            label: activeEntry ? "Entry fields " : "Schema fields ",
                            span: true,
                            helpText: "If you've selected an entry or are using the page source, the schema fields will be populated with the correct data."
                        })
                    }),
                    (ref1 = getOptions(state === null || state === void 0 ? void 0 : state.schema, activeEntry)) === null || ref1 === void 0 ? void 0 : ref1.map(function(o, itemIndex) {
                        var ref;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                            chevron: (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_19__/* .hasPotentialSubFields */ .i7)(o === null || o === void 0 ? void 0 : o.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_3__/* .ChevronRightIcon */ .XCv, {}),
                            disabled: !canSelectField(o === null || o === void 0 ? void 0 : (ref = o.value) === null || ref === void 0 ? void 0 : ref.type) || isDisabledIndex(0),
                            active: isActiveField(o, 0),
                            onClick: function() {
                                return isDisabledIndex(0) ? null : setField(o.value, 0);
                            },
                            children: (0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .isString */ .HD)(o) ? o : o === null || o === void 0 ? void 0 : o.label
                        }, itemIndex);
                    })
                ]
            }),
            canLoopSubFields && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubFields, {
                path: state === null || state === void 0 ? void 0 : state.fieldPath,
                getOptions: getOptions,
                isActiveField: isActiveField,
                canSelectField: canSelectField,
                setField: setField,
                activeEntry: activeEntry === null || activeEntry === void 0 ? void 0 : (ref3 = activeEntry.data) === null || ref3 === void 0 ? void 0 : ref3[(ref2 = state === null || state === void 0 ? void 0 : state.fieldPath[0]) === null || ref2 === void 0 ? void 0 : ref2.name]
            })
        ]
    });
};
var SubFields = function(param) {
    var path = param.path, setField = param.setField, getOptions = param.getOptions, isActiveField = param.isActiveField, canSelectField = param.canSelectField, activeEntry = param.activeEntry;
    // let tempActive = activeEntry
    var copy = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(path);
    return path ? path === null || path === void 0 ? void 0 : path.map(function(field, index) {
        copy.length = index + 1;
        //  tempActive = field?.type === 'repeater' ? tempActive?.[field?.name] : tempActive
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubField, {
                field: field,
                getOptions: function(schema, entry) {
                    return getOptions(schema, entry, false);
                },
                isActiveField: function(o) {
                    return isActiveField(o, index + 1);
                },
                canSelectField: canSelectField,
                setField: function(field) {
                    return setField(field, index + 1);
                },
                // activeEntry={getFieldValue([...copy], activeEntry)}
                activeEntry: (activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry[field === null || field === void 0 ? void 0 : field.name]) ? activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry[field === null || field === void 0 ? void 0 : field.name] : activeEntry
            }, index)
        });
    }) : null;
};
var SubField = function(param) {
    var field = param.field, setField = param.setField, getOptions = param.getOptions, isActiveField = param.isActiveField, canSelectField = param.canSelectField, activeEntry = param.activeEntry;
    var ref, ref1;
    // activeEntry = field?.type === 'repeater' ? activeEntry?.[0] : activeEntry
    var type = (0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .revertDevCases */ .Uw)((field === null || field === void 0 ? void 0 : field.singular) ? field.singular : (field === null || field === void 0 ? void 0 : field.label) ? field.label : field === null || field === void 0 ? void 0 : field.name);
    var dupe = "";
    if (field.type === "repeater") dupe = Array.from(new Set(activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry.map(function(o) {
        var ref, ref1;
        return o === null || o === void 0 ? void 0 : o[field === null || field === void 0 ? void 0 : (ref = field.schema) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name];
    }))).toString();
    return [
        "repeater",
        "group"
    ].includes(field === null || field === void 0 ? void 0 : field.type) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            field.type === "repeater" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .List */ .aV, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                        disabled: true,
                        children: [
                            activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry.length,
                            "  ",
                            type,
                            " entries"
                        ]
                    }),
                    (activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry.length) >= 1 && (activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry.map(function(o, itemIndex) {
                        var ref, ref1, ref2, ref3;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                            chevron: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_3__/* .ChevronRightIcon */ .XCv, {}),
                            onClick: function() {
                                return setField({
                                    type: "index",
                                    value: "[".concat(itemIndex, "]")
                                });
                            },
                            children: (o === null || o === void 0 ? void 0 : o[field === null || field === void 0 ? void 0 : (ref = field.schema) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name]) ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .replacePart */ .bA)(o === null || o === void 0 ? void 0 : o[field === null || field === void 0 ? void 0 : (ref2 = field.schema) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name], dupe, "...") : "".concat(type, " [").concat(itemIndex, "]")
                        }, itemIndex);
                    }))
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .List */ .aV, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                        disabled: true,
                        children: [
                            field === null || field === void 0 ? void 0 : field.singular,
                            " fields"
                        ]
                    }),
                    (ref = getOptions(field === null || field === void 0 ? void 0 : field.schema, Array.isArray(activeEntry) ? activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry[0] : activeEntry)) === null || ref === void 0 ? void 0 : ref.map(function(o, itemIndex) {
                        var ref;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                            active: isActiveField(o),
                            disabled: !canSelectField(o === null || o === void 0 ? void 0 : (ref = o.value) === null || ref === void 0 ? void 0 : ref.type),
                            onClick: function() {
                                return setField(o === null || o === void 0 ? void 0 : o.value);
                            },
                            children: o === null || o === void 0 ? void 0 : o.label
                        }, itemIndex);
                    })
                ]
            })
        ]
    }) : (field === null || field === void 0 ? void 0 : field.type) === "relation" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .List */ .aV, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                    disabled: true,
                    children: "Relation sub fields"
                }),
                relationSchema === null || relationSchema === void 0 ? void 0 : relationSchema.map(function(o, itemIndex) {
                    var ref;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                        active: isActiveField(o),
                        disabled: !canSelectField(o === null || o === void 0 ? void 0 : (ref = o.value) === null || ref === void 0 ? void 0 : ref.type),
                        onClick: function() {
                            return setField(o === null || o === void 0 ? void 0 : o.value);
                        },
                        children: o === null || o === void 0 ? void 0 : o.label
                    }, itemIndex);
                }),
                JSON.stringify(activeEntry)
            ]
        })
    }) : (field === null || field === void 0 ? void 0 : field.type) === "location" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .List */ .aV, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                    disabled: true,
                    children: "location map fields"
                }),
                _mosanic_fields_Location_Location__WEBPACK_IMPORTED_MODULE_20__/* .locationFields */ .Xm === null || _mosanic_fields_Location_Location__WEBPACK_IMPORTED_MODULE_20__/* .locationFields */ .Xm === void 0 ? void 0 : _mosanic_fields_Location_Location__WEBPACK_IMPORTED_MODULE_20__/* .locationFields.map */ .Xm.map(function(o, itemIndex) {
                    var ref;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                        active: isActiveField(o),
                        disabled: !canSelectField(o === null || o === void 0 ? void 0 : (ref = o.value) === null || ref === void 0 ? void 0 : ref.type),
                        onClick: function() {
                            return setField(o === null || o === void 0 ? void 0 : o.value);
                        },
                        children: o === null || o === void 0 ? void 0 : o.label
                    }, itemIndex);
                })
            ]
        })
    }) : (field === null || field === void 0 ? void 0 : field.type) === "user" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .List */ .aV, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                    disabled: true,
                    children: "User fields"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "Load user"
                    })
                }),
                userSchema === null || userSchema === void 0 ? void 0 : userSchema.map(function(o, itemIndex) {
                    var ref;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                        active: isActiveField(o),
                        disabled: !canSelectField(o === null || o === void 0 ? void 0 : (ref = o.value) === null || ref === void 0 ? void 0 : ref.type),
                        onClick: function() {
                            return setField(o === null || o === void 0 ? void 0 : o.value);
                        },
                        children: o === null || o === void 0 ? void 0 : o.label
                    }, itemIndex);
                })
            ]
        })
    }) : (field === null || field === void 0 ? void 0 : field.type) === "image" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .List */ .aV, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                    disabled: true,
                    children: "Image fields"
                }),
                (ref1 = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(seoSchema).concat([
                    {
                        label: "File type",
                        value: {
                            type: "text",
                            name: "fileType"
                        }
                    }
                ])) === null || ref1 === void 0 ? void 0 : ref1.map(function(o, itemIndex) {
                    var ref;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_List__WEBPACK_IMPORTED_MODULE_17__/* .ListItem */ .HC, {
                        active: isActiveField(o),
                        disabled: !canSelectField(o === null || o === void 0 ? void 0 : (ref = o.value) === null || ref === void 0 ? void 0 : ref.type),
                        onClick: function() {
                            return setField(o === null || o === void 0 ? void 0 : o.value);
                        },
                        children: o === null || o === void 0 ? void 0 : o.label
                    }, itemIndex);
                })
            ]
        })
    }) : null;
};
var relationSchema = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("relation|relationEnd|relationRender".split("|").map(function(name) {
    return {
        label: name,
        value: {
            type: "text",
            name: name
        }
    };
}));
var userSchema = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("author.firstName|author.lastName|author.displayName|author.bio|author.biography|author.profilePicture|email|role|siteId|_id".split("|").map(function(name) {
    return {
        label: name,
        value: {
            type: "text",
            name: name
        }
    };
}));
var seoSchema = [
    {
        label: "Title",
        value: {
            type: "text",
            name: "seo.title"
        }
    },
    {
        label: "Description",
        value: {
            type: "text",
            name: "seo.description"
        }
    },
    {
        label: "Size Small",
        value: {
            type: "text",
            name: "sizes.small"
        }
    },
    {
        label: "Size Thumb",
        value: {
            type: "text",
            name: "sizes.thumb"
        }
    }
];
var convert = function(schema, value) {
    return(// ...createSchema(value?.data),
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(schema.map(function(f) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, f), {
            title: ((ref1 = f === null || f === void 0 ? void 0 : (ref = f.label) === null || ref === void 0 ? void 0 : ref.split(".")) === null || ref1 === void 0 ? void 0 : ref1.length) >= 2 ? f === null || f === void 0 ? void 0 : (ref2 = f.label) === null || ref2 === void 0 ? void 0 : ref2.split(".")[1] : f === null || f === void 0 ? void 0 : f.label,
            // value: null, 
            value: undefined,
            name: f === null || f === void 0 ? void 0 : (ref3 = f.value) === null || ref3 === void 0 ? void 0 : ref3.name,
            label: (0,_util_Obj__WEBPACK_IMPORTED_MODULE_21__/* .get */ .U2)(value, f === null || f === void 0 ? void 0 : (ref4 = f.value) === null || ref4 === void 0 ? void 0 : ref4.name, f === null || f === void 0 ? void 0 : (ref5 = f.value) === null || ref5 === void 0 ? void 0 : ref5.name)
        });
    })));
};
var fieldSchemas = function(value) {
    return {
        relation: convert(relationSchema, value),
        location: convert(_mosanic_fields_Location_Location__WEBPACK_IMPORTED_MODULE_20__/* .locationFields */ .Xm, value),
        user: convert(userSchema, value),
        // user: createSchema(value),
        image: convert(seoSchema, value)
    };
};
// relationSchema,
// locationFields,
// userSchema,
// seoSchema,
// gallerySchema
var CodeFieldValue = function(param) {
    var setState = param.setState, state = param.state, activeEntry = param.activeEntry;
    var ref, ref1, ref2;
    // const value = state?.field?.field ? state.field.field : state.field
    var value = (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_19__/* .getFieldValue */ .oe)(state.fieldPath, activeEntry, state === null || state === void 0 ? void 0 : state.schema);
    var field = (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_19__/* .getLatestFieldFromFieldPath */ .Ts)(state.fieldPath);
    var handleCode = function(code) {
        return setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, state), {
            field: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, state.field), {
                code: code
            })
        }));
    };
    if (!(0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .containsSubstr */ .xX)(state === null || state === void 0 ? void 0 : (ref = state.field) === null || ref === void 0 ? void 0 : ref.code, "{value}") && (field === null || field === void 0 ? void 0 : field.type) === "text") handleCode("{value}");
    var toggle = function() {
        return setCalculate(!calculate);
    };
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), calculate = ref3[0], setCalculate = ref3[1];
    var retrieved = value // === 'slug' ? '/entry-slug' : activeEntry?.[value]
    ;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_22__/* .Block */ .gO, {
        p: 3,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_18__/* .AdvancedLabel */ .qv, {
                as: "h4",
                label: "Append / prepend field with code"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_18__/* .AdvancedLabel */ .qv, {
                mb: 4,
                span: true,
                helpText: "We hope to extend this in the near future with more complex calculations. Example shows: This product is on sale for €15",
                children: [
                    "You can calculate a part of the string by adding a separator: | ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "For example: 'This product is on sale for €|",
                    "{value}",
                    " * 0.8 \xa0"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_23__["default"], {
                label: "Code",
                onChange: handleCode,
                value: state === null || state === void 0 ? void 0 : (ref1 = state.field) === null || ref1 === void 0 ? void 0 : ref1.code,
                minRows: 1,
                endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_24__.Button, {
                    mt: 2,
                    mr: "-4px",
                    ghost: true,
                    tooltip: {
                        title: "Calculate value",
                        wrap: true
                    },
                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CalculatorIcon, {}),
                    active: calculate,
                    onClick: toggle
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_25__.Code, {
                label: "Code"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_18__/* .Label */ .__, {
                mt: 2,
                ml: 2,
                label: "Output",
                value: (0,_mosanic_utils_value__WEBPACK_IMPORTED_MODULE_26__/* .evalReplaceValue */ .FG)(state === null || state === void 0 ? void 0 : (ref2 = state.field) === null || ref2 === void 0 ? void 0 : ref2.code, value, calculate)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (SelectField);


/***/ }),

/***/ 11096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useCollection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _useEntries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60649);
/* harmony import */ var _mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62357);
/* harmony import */ var _mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43551);









var convert = _useEntries__WEBPACK_IMPORTED_MODULE_1__/* .convertEntry */ .ec;
var useRetrieveEntries = function() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var ref = _sliced_to_array(useGetEntries(_object_spread({}, params)), 3), entries = ref[0], loading = ref[1], error = ref[2];
    return Array.isArray(entries) ? entries.map(function(entry) {
        return convert(entry);
    }) : [];
};
var useRetrieveEntry = function() {
    var _id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_useEntries__WEBPACK_IMPORTED_MODULE_1__/* .useEntry */ .DV)({
        _id: _id
    }), 2), handleEntry = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ref[1], 3), entry = ref1[0], loadingEntry = ref1[1], errorEntry = ref1[2];
    return entry ? [
        convert(entry)
    ] : [];
};
var useCollection = function(param) {
    var _id = param._id, _singleEntry = param.singleEntry, singleEntry = _singleEntry === void 0 ? false : _singleEntry, _entryId = param.entryId, entryId = _entryId === void 0 ? null : _entryId, retrieveEntries = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_3__/* .useGetCollection */ .YD)({
        _id: _id,
        silent: true
    }), 3), collection = ref2[0], loading = ref2[1], error = ref2[2];
    var setEntries = function(data) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, collection), {
            entries: data
        });
    };
    //Validate external api call
    var linkedEntries = !Array.isArray(collection === null || collection === void 0 ? void 0 : collection.entries);
    var getEntries = Boolean(retrieveEntries && linkedEntries);
    //Get linked entries
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_6__/* .useGetEntries */ .e1)({
        collectionId: _id
    }), 3), entries = ref3[0], loadingEnt = ref3[1], errorEnt = ref3[2];
    var entry = useRetrieveEntry(getEntries && (singleEntry || entryId) && (entryId || (collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref[0])));
    //Format entries return
    if (getEntries && !loading) collection = setEntries(entries);
    if (singleEntry && !loading) collection = setEntries([
        collection === null || collection === void 0 ? void 0 : (ref1 = collection.entries) === null || ref1 === void 0 ? void 0 : ref1[0]
    ]);
    return [
        function() {
            return null;
        },
        [
            collection,
            loading,
            error
        ]
    ];
};


/***/ }),

/***/ 52610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zl": function() { return /* binding */ useCollectionSelector; },
/* harmony export */   "bX": function() { return /* binding */ useCollections; },
/* harmony export */   "mt": function() { return /* binding */ useCollectionStats; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66383);
/* harmony import */ var _api_queries_collections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94283);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70210);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25157);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);









var useCollections = function(param) {
    var filter = param.filter, _type = param.type, type = _type === void 0 ? null : _type, _indexOnly = param.indexOnly, indexOnly = _indexOnly === void 0 ? false : _indexOnly;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_3__/* .useLazyQuery */ .td)("collectionMany", _api_queries_collections__WEBPACK_IMPORTED_MODULE_4__/* .FILTER_COLLECTIONS */ .YN), 2), callback = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((filter === null || filter === void 0 ? void 0 : filter.siteId) && !type) callback({
            filter: filter
        });
        else {
            callback({
                filter: {
                    AND: [
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, filter),
                        {
                            type: type
                        }
                    ]
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filter === null || filter === void 0 ? void 0 : filter.siteId,
        type
    ]);
    var collections = indexOnly && Array.isArray(data) ? data === null || data === void 0 ? void 0 : data.map(function(c) {
        var ref;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, c), {
            entries: undefined,
            count: c === null || c === void 0 ? void 0 : (ref = c.entries) === null || ref === void 0 ? void 0 : ref.length
        });
    }) : data;
    return [
        collections,
        loading,
        error,
        callback
    ];
};
var useCollectionStats = function(param) {
    var siteId = param.siteId;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(useCollections({
        filter: {
            siteId: siteId
        }
    }), 3), collections = ref[0], loading = ref[1], error = ref[2];
    if (!collections) return {
        schemas: 0,
        entries: 0
    };
    var entries = 0;
    if ((collections === null || collections === void 0 ? void 0 : collections.length) >= 1) {
        collections.map(function(c) {
            var ref;
            if (((ref = c.entries) === null || ref === void 0 ? void 0 : ref.length) >= 1) entries += c.entries.length;
        });
    }
    return {
        schemas: collections === null || collections === void 0 ? void 0 : collections.length,
        entries: entries
    };
};
var useCollectionSelector = function(val) {
    var siteId = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_7__/* .siteIdSelector */ .uL);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(useCollections({
        filter: {
            siteId: siteId
        },
        indexOnly: true
    }), 1), collections = ref[0];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(val), value = ref1[0], onChange = ref1[1];
    var options = (collections === null || collections === void 0 ? void 0 : collections.length) >= 1 ? collections.map(function(c) {
        return {
            value: c._id,
            label: "".concat(c === null || c === void 0 ? void 0 : c.title) //[${c?.entries?.length ? c?.entries?.length : 0} entries]
        };
    }) : [
        {
            value: null,
            label: "Create other collections first"
        }
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        onChange({
            value: val
        });
    }, [
        val
    ]);
    return {
        options: options,
        value: value,
        onChange: onChange
    };
};


/***/ }),

/***/ 30611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useCreateCollection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66383);
/* harmony import */ var _api_mutations_collections__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73755);
/* harmony import */ var _api_token__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94645);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70210);
/* harmony import */ var _mosanic_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33346);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25157);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);










var useCreateCollection = function(param) {
    var _callback = param.callback, callback = _callback === void 0 ? null : _callback, _redirect = param.redirect, redirect = _redirect === void 0 ? true : _redirect, _dataType = param.dataType, dataType = _dataType === void 0 ? "collection" : _dataType;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var isAuth = (0,_api_token__WEBPACK_IMPORTED_MODULE_2__/* .isAuthenticated */ .$8)();
    var userId = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_3__/* .userIdSelector */ .dY);
    var siteId = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_3__/* .siteIdSelector */ .uL);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_5__/* .useMutate */ .Tu)("collectionCreateOne", _api_mutations_collections__WEBPACK_IMPORTED_MODULE_6__/* .ADD_COLLECTION */ .nU), 2), addCollection = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var handler = function(param) {
        var collection = param.collection;
        if (!isAuth) {
            notify("You are not authenticated.");
            return;
        }
        if (!siteId) {
            notify("No active site selected.");
            return;
        }
        var record = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, collection), {
            date: new Date(),
            updatedAt: new Date()
        });
        addCollection({
            record: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                siteId: siteId,
                userId: userId,
                type: dataType
            }, record)
        }).then(function(res) {
            var data = res.data, error = res.error;
            if (data === null || data === void 0 ? void 0 : data.collectionCreateOne) data = data.collectionCreateOne;
            if (!error && (data === null || data === void 0 ? void 0 : data.recordId)) {
                notify("Successfully created collection.", "app", "success");
                if (callback) callback();
                if (redirect) router.push("/collection/".concat(data.recordId));
            } else if (error) {
                notify("An error occurred during the collection creation.");
            }
        });
    };
    return [
        handler,
        [
            data,
            loading,
            error
        ]
    ];
};


/***/ }),

/***/ 60649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ useEntry; },
/* harmony export */   "Di": function() { return /* binding */ useEntries; },
/* harmony export */   "ec": function() { return /* binding */ convertEntry; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66383);
/* harmony import */ var _api_queries_entries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78721);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70210);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);






var convertEntry = function(entry) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, entry, entry === null || entry === void 0 ? void 0 : entry.data, entry === null || entry === void 0 ? void 0 : entry.map), {
        map: undefined,
        data: undefined
    });
};
var useEntry = function(param) {
    var _id = param._id;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_4__/* .useLazyQuery */ .td)("entryById", _api_queries_entries__WEBPACK_IMPORTED_MODULE_5__/* .ENTRY */ .hZ, {
        _id: _id
    }), 2), handler = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref[1], 3), entry = ref1[0], loading = ref1[1], error = ref1[2];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (_id) handler({
            _id: _id
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        _id
    ]);
    return [
        handler,
        [
            entry,
            loading,
            error
        ]
    ];
};
var useEntries = function(param) {
    var _collectionId = param.collectionId, collectionId = _collectionId === void 0 ? null : _collectionId, _filter = param.filter, filter = _filter === void 0 ? undefined : _filter, _limit = param.limit, limit = _limit === void 0 ? undefined : _limit, _skip = param.skip, skip = _skip === void 0 ? null : _skip, _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_4__/* .useLazyQuery */ .td)("entryMany", minimize ? _api_queries_entries__WEBPACK_IMPORTED_MODULE_5__/* .ENTRIES_MAP */ .ji : _api_queries_entries__WEBPACK_IMPORTED_MODULE_5__/* .FILTER_ENTRIES */ .r8), 2), callback = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref[1], 3), entries = ref1[0], loading = ref1[1], error = ref1[2];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (collectionId) callback({
            filter: {
                collectionId: collectionId
            },
            limit: limit,
            skip: skip
        });
        else if (filter) {
            callback({
                filter: filter,
                limit: limit,
                skip: skip
            });
        }
    //todo limit: 5
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collectionId,
        filter
    ]);
    return [
        callback,
        [
            entries,
            loading,
            error
        ]
    ];
};


/***/ }),

/***/ 36414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useDeleteEntry; },
/* harmony export */   "v": function() { return /* binding */ useUpdateCollection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66383);
/* harmony import */ var _api_mutations_collections__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73755);
/* harmony import */ var _api_token__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94645);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70210);
/* harmony import */ var _mosanic_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33346);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25157);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64157);









var success = function(dataType) {
    if (dataType === "global") return "Successfully updated data.";
    if (dataType === "form") return "Successfully submitted form.";
    return "Successfully updated collection.";
};
var err = function(dataType) {
    if (dataType === "global") return "An error occurred during the data update.";
    if (dataType === "form") return "Could not submit the form.";
    return "An error occurred during the collection update.";
};
var useUpdateCollection = function(param) {
    var _callback = param.callback, callback = _callback === void 0 ? null : _callback, _dataType = param.dataType, dataType = _dataType === void 0 ? "collection" : _dataType;
    var site = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_1__/* .siteIdSelector */ .uL);
    var isAuth = (0,_api_token__WEBPACK_IMPORTED_MODULE_2__/* .isAuthenticated */ .$8)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_4__/* .useMutate */ .Tu)("collectionUpdateById", _api_mutations_collections__WEBPACK_IMPORTED_MODULE_5__/* .UPDATE_COLLECTION */ .Oy), 2), update = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var handler = function(param) {
        var collection = param.collection;
        var _id = collection._id, siteId = collection.siteId;
        if (!_id) {
            notify("No collection _id received.");
            return;
        }
        if (!isAuth) {
            notify("You are not authenticated.");
            return;
        }
        if (!site) {
            notify("No active site selected.");
            return;
        }
        if (siteId != site && dataType === "collection") {
            notify("Collection is linked to a different site.");
            return;
        }
        update({
            _id: _id,
            record: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, collection), {
                updatedAt: new Date(),
                _id: undefined
            })
        }).then(function(res) {
            var data = res.data, error = res.error;
            if (data === null || data === void 0 ? void 0 : data.collectionUpdateById) data = data.collectionUpdateById;
            if (data) {
                notify(success(dataType), "app", "success");
                if (callback) callback();
            } else notify(err(dataType));
            console.log(res);
        });
    };
    return [
        handler,
        [
            data,
            loading,
            error
        ]
    ];
};
var useDeleteEntry = function(param) {
    var _callback = param.callback, callback = _callback === void 0 ? null : _callback;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(useUpdateCollection({
        callback: callback
    }), 2), handler = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref[1], 3), data = ref1[0], loading = ref1[1], error = ref1[2];
    var deleteEntry = function(param) {
        var collection = param.collection, entry = param.entry;
        var ref;
        collection = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, collection), {
            entries: collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.filter(function(e) {
                return (e === null || e === void 0 ? void 0 : e._id) != (entry === null || entry === void 0 ? void 0 : entry._id);
            })
        });
        handler({
            collection: collection
        });
    };
    return [
        deleteEntry,
        [
            data,
            loading,
            error
        ]
    ];
};


/***/ }),

/***/ 26675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ DropZone; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2921);
/* harmony import */ var _mosanic_styles_flex_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5441);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26021);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    margin: 0;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 100%;\n    min-height: 25px;\n    position: absolute;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    /* position: absolute; */\n    margin: 0 -1.05%;\n    width: 2%;\n    height: auto;\n    max-height: none;\n    min-height: auto;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    border: 1px solid ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        " {\n      \n        height: 10px;\n        background: ",
        "!important;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    background: none !important;\n    border-color: transparent !important;\n    flex-shrink: 0;\n    ",
        "\n\n    ",
        " {\n      position: absolute;\n      width: 100%;\n      height: 5px;\n      border: 2px solid ",
        ";\n      background: ",
        "!important;\n    }\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n      /* margin: -10px ; */\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ",
        " {\n          height: 10px;\n          background: ",
        "!important;\n        }\n      "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    &:hover {\n      opacity: 0.7!important;\n      border: 1px solid ",
        ";\n      background-color:  ",
        ";\n\n      cursor: pointer; \n\n      ",
        "\n\n    }\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    /* positio */\n    transform: scale(0.95);\n    position: relative;\n    /* margin: -12.5px 0; */\n    /* margin-top: ",
        "; */\n    /* margin-left: ",
        "; */\n      /* margin: 5px 0; */\n      /* margin-bottom: -2.5px; */\n      /* border: 1px solid red!important; */\n      /* opacity: 1; */\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  position: absolute;\n  transform: translateZ(0);\n  transition: \n    background-color 0.2s ease-in-out,\n    transform 0.3s ease-out,\n    opacity 0.3s ease-in-out  \n  ;\n  pointer-events: ",
        ";\n  z-index: 99;\n  border: 1px solid ",
        ";\n  background-color:  ",
        ";\n  transform:  ",
        ";\n  opacity: ",
        ";\n  /* position: relative; */\n  border-radius: 2px;\n  flex: 0 0 auto;\n  margin: -12.5px 0;\n  width: 100%;\n  height: 25px;\n  max-height: 25px;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n  ",
        " \n  ",
        "\n\n  ",
        "\n  /* background-color: red; */\n  /* opacity: 0.2; */\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var isEmptyCol = function(props) {
    return props.empty && props.isLast && props.canExpand;
};
var isActive = function(props) {
    return props.canDrop && props.isOver;
};
var getBackground = function(level) {
    switch(level){
        case 0:
            return "rgba(16, 132, 233, 0.049)";
        case 1:
            return "rgba(16, 132, 233, 0.109)";
        case 2:
            return "rgba(16, 132, 233, 0.149)";
        case 3:
            return "rgba(16, 132, 233, 0.209)";
        case 4:
            return "rgba(16, 132, 233, 0.249)";
        case 5:
            return "rgba(16, 132, 233, 0.309)";
        case 6:
            return "rgba(16, 132, 233, 0.449)";
        case "full":
            return "rgba(16, 132, 233, 0.549)";
        default:
            return "rgba(16, 132, 233, 0.049)";
    }
};
var getOpacity = function(props) {
    if (props.canDrop) {
        if (props.isOver) return 0.7;
        if (isEmptyCol(props)) return 0.05;
        return 0.3;
    }
    return 0;
};
var Inside = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c5ca0c95-0"
})(_templateObject());
var DropZone = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c5ca0c95-1"
})(_templateObject10(), function(props) {
    return props.canDrop ? "all" : "none";
}, _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.primary.lighter */ .ZP.util.primary.lighter, function(props) {
    return isActive(props) ? getBackground(props.level + 2) : getBackground(props.level);
}, function(props) {
    return isActive(props) ? "scale(0.9)" : "scale(0.85)";
}, function(props) {
    return getOpacity(props);
}, function(props) {
    return isEmptyCol(props) && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return props.isHorizontal && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2());
}, function(props) {
    return props.isOver && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.primary.light */ .ZP.util.primary.light);
}, function(props) {
    return (props.slot || props.layers) && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject5(), _mosanic_styles_flex_styles__WEBPACK_IMPORTED_MODULE_3__/* .CenterCenter */ .IV, Inside, _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.primary.base */ .ZP.util.primary.base, getBackground(4), props.isOver && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject4(), Inside, getBackground("full")));
}, function(props) {
    return props.layers && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject6());
}, function(props) {
    return props.canDrop && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject8(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.primary.light */ .ZP.util.primary.light, function(props) {
        return getBackground(props.level + 2);
    }, (props.slot || props.layers) && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject7(), Inside, getBackground("full")));
}, function(props) {
    return props.layers && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject9(), function(props) {
        return (props.level - 1) * 10 + "px!important";
    }, function(props) {
        return (props.level - 1) * 10 + "px!important";
    });
});
var DropZoneStyles = {
    DropZone: DropZone,
    Inside: Inside
};
/* harmony default export */ __webpack_exports__["Z"] = (DropZoneStyles); // import { colors } from "@mosanic/styles";
 // import { CenterCenter } from "@mosanic/styles/flex.styles";
 // import styled, { css } from "styled-components";
 // const isEmptyCol = (props) => props.empty && props.isLast && props.canExpand
 // const isActive = (props) => props.canDrop && props.isOver
 // const getBackground = (level) => {
 //   switch (level) {
 //     case 0: return `rgba(16, 132, 233, 0.049)`
 //     case 1: return `rgba(16, 132, 233, 0.109)`
 //     case 2: return `rgba(16, 132, 233, 0.149)`
 //     case 3: return `rgba(16, 132, 233, 0.209)`
 //     case 4: return `rgba(16, 132, 233, 0.249)`
 //     case 5: return `rgba(16, 132, 233, 0.309)`
 //     case 6: return `rgba(16, 132, 233, 0.449)`
 //     case 'full': return `rgba(16, 132, 233, 0.549)`
 //     default: return `rgba(16, 132, 233, 0.049)`
 //   }
 // }
 // const getOpacity = (props) => {
 //   if(props.canDrop){
 //     if(props.isOver) return 0.7;
 //     if(isEmptyCol(props)) return 0.05;
 //     return 0.3;
 //   }
 //   return 0;
 // }
 // const Inside = styled.div` 
 // `;
 // export const DropZone = styled.div` 
 //   position: absolute;
 //   transform: translateZ(0);
 //   transition: 
 //     background-color 0.2s ease-in-out,
 //     transform 0.3s ease-out,
 //     opacity 0.3s ease-in-out  
 //   ;
 //   pointer-events: ${props => props.canDrop ? 'all' : 'none'};
 //   z-index: 99;
 //   border: 1px solid ${colors.util.primary.lighter};
 //   background-color:  ${props => isActive(props) ? 
 //     getBackground(props.level + 2) : 
 //     getBackground(props.level)
 //   };
 //   transform:  ${props => isActive(props) ? 
 //     `scale(0.9)` : 
 //     `scale(0.85)`
 //   };
 //   opacity: ${props => getOpacity(props)};
 //   /* position: relative; */
 //   border-radius: 2px;
 //   flex: 0 0 auto;
 //   margin: -2.5px 0;
 //   width: 100%;
 //   height: 5px;
 //   max-height: 5px;
 //   ${props => isEmptyCol(props) && css` 
 //     margin: 0;
 //     top: 0;
 //     left: 0;
 //     right: 0;
 //     height: 100%;
 //     min-height: 25px;
 //     position: absolute;
 //   `}
 //   ${props => props.isHorizontal && css` 
 //     /* position: absolute; */
 //     margin: 0 -1.05%;
 //     width: 2%;
 //     height: auto;
 //     max-height: none;
 //     min-height: auto;
 //   `}
 //   ${props =>props.isOver && css` 
 //     opacity: 0.7!important;
 //     border: 1px solid ${colors.util.primary.light};
 //   `}
 //   ${props => (props.slot || props.layers) && css` 
 //     background: none !important;
 //     border-color: transparent !important;
 //     flex-shrink: 0;
 //     ${CenterCenter}
 //     ${Inside} {
 //       position: absolute;
 //       width: 100%;
 //       height: 5px;
 //       border: 2px solid ${colors.util.primary.base};
 //       background: ${getBackground(4)}!important;
 //     }
 //     ${props.isOver && css`
 //       ${Inside} {
 //         height: 5px;
 //         background: ${getBackground('full')}!important;
 //       }
 //     `}
 //   `} 
 //   ${props => props.canDrop && css` 
 //     opacity: 0;
 //     &:hover {
 //       opacity: 0.7;
 //       border: 1px solid ${colors.util.primary.light};
 //       background-color:  ${props => getBackground(props.level + 2)};
 //       cursor: pointer; 
 //       ${(props.slot || props.layers) && css` 
 //         ${Inside} {
 //           height: 5px;
 //           background: ${getBackground('full')}!important;
 //         }
 //       `}
 //     }
 //   `}
 //   /* background-color: red; */
 //   /* opacity: 0.2; */
 // `;
 // const DropZoneStyles = {
 //   DropZone,
 //   Inside
 // }
 // export default DropZoneStyles;


/***/ }),

/***/ 18918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ AppearanceForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_fields_Form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35345);
/* harmony import */ var _mosanic_fields_Form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56185);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63955);




var AppearanceForm = function(param) {
    var _fields = param.fields, fields = _fields === void 0 ? [] : _fields;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .useFormContext */ .Gc)(), handleSubmit = ref.handleSubmit, control = ref.control, watch = ref.watch, reset = ref.reset, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields_Form__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        onSubmit: null,
        disabled: !isValid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields_Form__WEBPACK_IMPORTED_MODULE_3__/* .FormItems */ .G, {
            controls: inputProps,
            fields: fields
        })
    });
};


/***/ }),

/***/ 30670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ PreferencesForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_fields_Form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35345);
/* harmony import */ var _mosanic_fields_Form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56185);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68311);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63955);





var PreferencesForm = function(param) {
    var _fields = param.fields, fields = _fields === void 0 ? [] : _fields;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .useFormContext */ .Gc)(), handleSubmit = ref.handleSubmit, control = ref.control, watch = ref.watch, reset = ref.reset, _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        fullWidth: true,
        errors: errors
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields_Form__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        onSubmit: null,
        disabled: !isValid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields_Form__WEBPACK_IMPORTED_MODULE_3__/* .FormItems */ .G, {
            controls: inputProps,
            fields: fields === null || fields === void 0 ? void 0 : fields.map(function(f) {
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    type: "switch",
                    name: "pref.".concat((0,_util_Text__WEBPACK_IMPORTED_MODULE_5__/* .slugify */ .lV)(f === null || f === void 0 ? void 0 : f.label))
                }, f);
            })
        })
    });
};


/***/ }),

/***/ 34395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InView_InView; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.modern.mjs


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = (/* unused pure expression or super */ null && (["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"]));

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends react.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return React.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  }

}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _state$entry;

  const [ref, setRef] = react.useState(null);
  const callback = react.useRef();
  const [state, setState] = react.useState({
    inView: !!initialInView,
    entry: undefined
  }); // Store the onChange callback in a `ref`, so we can access the latest instance
  // inside the `useEffect`, but without triggering a rerender.

  callback.current = onChange;
  react.useEffect(() => {
    // Ensure we have node ref, and that we shouldn't skip observing
    if (skip || !ref) return;
    let unobserve = observe(ref, (inView, entry) => {
      setState({
        inView,
        entry
      });
      if (callback.current) callback.current(inView, entry);

      if (entry.isIntersecting && triggerOnce && unobserve) {
        // If it should only trigger once, unobserve the element after it's inView
        unobserve();
        unobserve = undefined;
      }
    }, {
      root,
      rootMargin,
      threshold,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
    return () => {
      if (unobserve) {
        unobserve();
      }
    };
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string, so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  const entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
  react.useEffect(() => {
    if (!ref && entryTarget && !triggerOnce && !skip) {
      // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView,
        entry: undefined
      });
    }
  }, [ref, entryTarget, triggerOnce, skip, initialInView]);
  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.modern.mjs.map

;// CONCATENATED MODULE: ./src/mosanic/core/Items/InView.tsx



function InView_InView(param) {
    var children = param.children, height = param.height;
    var ref = (0,_sliced_to_array/* default */.Z)(useInView({
        threshold: 0,
        triggerOnce: true
    }), 2), ref1 = ref[0], inView = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref1,
        style: {
            height: "100%",
            width: "100%"
        },
        children: inView && children
    });
};


/***/ }),

/***/ 5628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ce": function() { return /* binding */ useItems; },
/* harmony export */   "Gk": function() { return /* binding */ substrSearch; },
/* harmony export */   "P4": function() { return /* binding */ useSearchItems; },
/* harmony export */   "RW": function() { return /* binding */ getSearchMarkTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var _api_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87860);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70210);
/* harmony import */ var _mosanic_constants_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46993);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2921);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68311);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);








var useItems = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .aM)("builderItemMany", _api_queries__WEBPACK_IMPORTED_MODULE_3__/* .BUILDER_ITEMS */ .$), 3), serverItems = ref[0], loading = ref[1], error = ref[2];
    return Boolean(serverItems) ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(serverItems).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mosanic_constants_components__WEBPACK_IMPORTED_MODULE_5__/* .ADD_ITEMS */ .fu)) : _mosanic_constants_components__WEBPACK_IMPORTED_MODULE_5__/* .ADD_ITEMS */ .fu;
};
var isSubstr = function(val, input) {
    return !val ? false : (0,_util_Text__WEBPACK_IMPORTED_MODULE_6__/* .lowCaseContainsSubstr */ .dW)(val, input);
};
var substrSearch = isSubstr;
var componentValidate = function(c, input) {
    var ref, ref1, ref2, ref3;
    return isSubstr((ref = c.component) === null || ref === void 0 ? void 0 : ref.type, input) || isSubstr(c === null || c === void 0 ? void 0 : (ref1 = c.component) === null || ref1 === void 0 ? void 0 : ref1.desc, input) || isSubstr(c === null || c === void 0 ? void 0 : (ref2 = c.component) === null || ref2 === void 0 ? void 0 : ref2.title, input) || isSubstr(c === null || c === void 0 ? void 0 : (ref3 = c.component) === null || ref3 === void 0 ? void 0 : ref3.icon, input);
};
var useSearchItems = function(param) {
    var components = param.components, _validate = param.validate, validate = _validate === void 0 ? componentValidate : _validate;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), input = ref[0], set = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), delayed = ref1[0], setDelay = ref1[1];
    var setInput = function(e) {
        return setDelay(e);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timer = setTimeout(function() {
            set(delayed);
        }, 400);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        delayed
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var isMatch = function(c) {
        return validate(c, input);
    };
    var filteredComponents = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (input === null || input === void 0 ? void 0 : input.length) >= 1 ? components.filter(function(c) {
            return isMatch(c);
        }) : components;
    }, [
        input === null || input === void 0 ? void 0 : input.length,
        components,
        isMatch
    ]);
    return [
        delayed,
        setInput,
        filteredComponents
    ];
};
var getSearchMarkTitle = function(title, input) {
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_6__/* .isString */ .HD)(title) ? title.replace(new RegExp(input, "gi"), function(match) {
        return '<mark style="background: '.concat(_mosanic_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"].util.orange.mark */ .ZP.util.orange.mark, '">').concat(match, "</mark>");
    }) : title;
};


/***/ }),

/***/ 97002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout_ThemeWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ./src/utils/Device.js
var Device = __webpack_require__(17629);
;// CONCATENATED MODULE: ./src/utils/theme.js


// import { colors } from "@mosanic/styles";
// todo Use polished in shades
var defaultColors = {
    primary: "#1082e9",
    primaryHover: "#1082e9",
    secondary: "#f64b4b",
    light: "#fff",
    light10: "#FCFCFD",
    lightGray: "#e7e9ed",
    dark: "#313131",
    dark10: "#222222",
    yellow: "#fedc5a",
    ash: "#413e65",
    green: "#68d585 ",
    info: "#0e567c"
};
var colorTemplates = {
    light: {
        primary: defaultColors.primary,
        primaryHover: (0,polished_esm/* darken */._j)(10, defaultColors.primaryHover),
        secondary: defaultColors.secondary,
        text: "#212121",
        light: defaultColors.light,
        light10: defaultColors.light10,
        lightGray: defaultColors.lightGray,
        lightShade: (0,polished_esm/* rgba */.m4)(defaultColors.light, 0.7),
        dark: defaultColors.dark,
        dark10: defaultColors.dark10,
        darkShade: (0,polished_esm/* rgba */.m4)(defaultColors.dark, 0.7),
        ash: defaultColors.ash,
        white: "#FFFFFF",
        bg: "#f2f2f2",
        bg2: "#f4f7fa",
        bg3: "#f8f8f8",
        bg4: "#fdfdff",
        bg5: "#ecf2f7",
        bg6: "#fff",
        bg7: "#EDF9F2",
        border: "#e7e9ed",
        shadow: (0,polished_esm/* rgba */.m4)(defaultColors.dark, 0.15),
        heading: defaultColors.dark,
        // text: rgba(defaultColors.dark, 0.7),
        warning: defaultColors.yellow,
        success: defaultColors.green,
        info: defaultColors.info
    },
    dark: {
        primary: defaultColors.primary,
        primaryHover: defaultColors.primaryHover,
        secondary: defaultColors.secondary,
        text: "#FEFEFE",
        light: defaultColors.dark,
        light10: defaultColors.dark10,
        lightGray: "#111",
        lightShade: (0,polished_esm/* rgba */.m4)(defaultColors.dark, 0.7),
        dark: defaultColors.light,
        dark10: defaultColors.light10,
        darkShade: (0,polished_esm/* rgba */.m4)(defaultColors.light, 0.7),
        ash: defaultColors.ash,
        white: "#222",
        bg: "#323232",
        bg2: "#f4f7fa",
        bg3: "#f8f8f8",
        bg4: "#fdfdff",
        bg5: "#ecf2f7",
        bg6: "#fff",
        bg7: "#EDF9F2",
        border: "#e7e9ed",
        shadow: (0,polished_esm/* rgba */.m4)(defaultColors.dark, 0.15),
        heading: defaultColors.dark,
        // text: rgba(defaultColors.dark, 0.7),
        warning: defaultColors.yellow,
        success: defaultColors.green,
        info: defaultColors.info
    }
};
var modes = colorTemplates;
var colors = {
    primary: defaultColors.primary,
    primaryHover: (0,polished_esm/* darken */._j)(10, defaultColors.primaryHover),
    secondary: defaultColors.secondary,
    light: defaultColors.light,
    light10: defaultColors.light10,
    lightShade: (0,polished_esm/* rgba */.m4)(defaultColors.light, 0.7),
    dark: defaultColors.dark,
    dark10: defaultColors.dark10,
    darkShade: (0,polished_esm/* rgba */.m4)(defaultColors.dark, 0.7),
    ash: defaultColors.ash,
    bg: defaultColors.light,
    bg2: "#f4f7fa",
    bg3: "#f8f8f8",
    bg4: "#fdfdff",
    bg5: "#ecf2f7",
    bg6: "#fff",
    bg7: "#EDF9F2",
    border: "#e7e9ed",
    shadow: (0,polished_esm/* rgba */.m4)(defaultColors.dark, 0.15),
    heading: defaultColors.dark,
    text: (0,polished_esm/* rgba */.m4)(defaultColors.dark, 0.7),
    warning: defaultColors.yellow,
    success: defaultColors.green,
    info: defaultColors.info,
    gray: {
        darkest: "#2c2d30",
        darker: "#45464a",
        dark: "#5d5f64",
        base: "#7d818d",
        light: "#e7e9ed",
        lighter: "#f4f7fa",
        lightest: "#f8fafc",
        trans: "#fcfdfe"
    },
    modes: modes
};
var theme = {
    initialColorModeName: "light",
    colors: colors,
    space: [
        0,
        4,
        8,
        12,
        16,
        20,
        24,
        28,
        32,
        36,
        40,
        48,
        52,
        56,
        60,
        64,
        72,
        84,
        100,
        120,
        140, 
    ],
    breakpoints: [
        "".concat(Device/* breakpoints.sm */.AV.sm, "px"),
        "".concat(Device/* breakpoints.md */.AV.md, "px"),
        "".concat(Device/* breakpoints.lg */.AV.lg, "px"),
        "".concat(Device/* breakpoints.xl */.AV.xl, "px"), 
    ]
};
/* harmony default export */ var utils_theme = (theme);

// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/features/ui/uiReducer.js
var uiReducer = __webpack_require__(39336);
;// CONCATENATED MODULE: ./src/mosanic/core/Layout/ThemeWrapper.js










var getTheme = function(mode) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, utils_theme), {
        mode: mode,
        alt: mode === "dark" ? "light" : "dark",
        colors: colorTemplates === null || colorTemplates === void 0 ? void 0 : colorTemplates[mode]
    });
};
var ThemeWrapper = function(param) {
    var children = param.children;
    var savedAutomatic = !(0,Device/* isServer */.sk)() ? localStorage.getItem("automaticColorScheme") : null;
    var savedPreferred = !(0,Device/* isServer */.sk)() ? localStorage.getItem("preferredColorScheme") : null;
    var pref = savedPreferred || savedAutomatic;
    var mode = (0,es/* useSelector */.v9)(uiReducer/* themeModeSelector */.Eq);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
        theme: pref === "dark" ? getTheme("light") : getTheme("light"),
        children: children
    });
};
/* harmony default export */ var Layout_ThemeWrapper = (ThemeWrapper);


/***/ }),

/***/ 50547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Map_Child; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/features/map/data/selector.js
var selector = __webpack_require__(52478);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/features/options/reducer.js + 1 modules
var reducer = __webpack_require__(51331);
// EXTERNAL MODULE: ./src/features/ui/uiAction.js
var uiAction = __webpack_require__(19957);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrag/useDrag.js + 9 modules
var useDrag = __webpack_require__(39717);
;// CONCATENATED MODULE: ./src/mosanic/hooks/useItemDrag.js







var useItemDrag = function(param) {
    var map = param.map, _isClone = param.isClone, isClone = _isClone === void 0 ? false : _isClone;
    var dispatch = (0,es/* useDispatch */.I0)();
    var canDragDrop = (0,es/* useSelector */.v9)(reducer/* canDragDropSelector */.QE);
    //Ref initialization to pass down
    var ref = (0,react.useRef)();
    var ref1 = (0,react.useState)(false), isDrag = ref1[0], setIsDrag = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useDrag/* useDrag */.c)({
        type: (map === null || map === void 0 ? void 0 : map.itemType) ? map === null || map === void 0 ? void 0 : map.itemType : "none",
        canDrag: canDragDrop,
        item: map,
        collect: function(monitor) {
            return {
                isDragging: monitor.isDragging()
            };
        }
    }), 2), isDragging = ref2[0].isDragging, drag = ref2[1];
    (0,react.useEffect)(function() {
        dispatch((0,uiAction/* setDragging */.q6)(isDragging));
        setIsDrag(isDragging);
    }, [
        dispatch,
        isDragging
    ]);
    if (!isClone) drag(ref);
    return {
        ref: ref,
        isDragging: isDrag
    };
};
/* harmony default export */ var hooks_useItemDrag = (useItemDrag);

// EXTERNAL MODULE: ./src/features/bounds/action.js
var action = __webpack_require__(42159);
// EXTERNAL MODULE: ../../node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(5994);
// EXTERNAL MODULE: ./src/features/bounds/reducer.js
var bounds_reducer = __webpack_require__(40394);
;// CONCATENATED MODULE: ./src/features/bounds/selectors.js




var parameters = function(state, obj) {
    return obj;
};
var validateParameters = function(state, obj) {
    return _object_spread_props(_object_spread({}, obj), {
        isInspected: true //isItemInspected(state, obj)
    });
};
// const hoverIdSelector = state => hoverSelector(state).map?._id
// const inspectedIdSelector = state => inspectedSelector(state).map?._id
// const parameterId = (state, id) => id;
var isItemHovered = (0,reselect_es/* createSelector */.P1)([
    bounds_reducer/* hoverSelector */.Js,
    parameters
], function(hover, obj) {
    var ref, ref1;
    return obj.validateScreen ? ((ref = hover.map) === null || ref === void 0 ? void 0 : ref._id) === obj.id && hover.screen === obj.screen : ((ref1 = hover.map) === null || ref1 === void 0 ? void 0 : ref1._id) === obj.id;
});
var isItemInspected = (0,reselect_es/* createSelector */.P1)([
    bounds_reducer/* inspectHoverSelector */.uG,
    parameters
], function(inspected, obj) {
    return obj.validateScreen ? (inspected === null || inspected === void 0 ? void 0 : inspected._id) === obj.id && inspected.screen === obj.screen : (inspected === null || inspected === void 0 ? void 0 : inspected._id) === obj.id;
});

// EXTERNAL MODULE: ./src/features/canvas/reducer.js
var canvas_reducer = __webpack_require__(64386);
;// CONCATENATED MODULE: ./src/utils/Node.js
var getNodeScale = function(param) {
    var className = param.className;
    var target = document.getElementsByClassName(className)[0];
    if (!target) return null;
    var scale = target.getBoundingClientRect().width / target.offsetWidth;
    // console.log(target.style)
    // var style = getComputedStyle(target, null);
    // var style = getComputedStyle(target, null);
    // console.log(style.getPropertyValue('transform'));
    // console.log(style.getPropertyValue('translate'));
    // console.log(style.getPropertyValue('scale'));
    // console.log('======');
    // console.log(window.screen.width)
    return scale;
};
var getParentNode = function(param) {
    var parent = param.parent, findClass = param.findClass, _stopCount = param.stopCount, stopCount = _stopCount === void 0 ? 25 : _stopCount, _count = param.count, count = _count === void 0 ? 0 : _count;
    var ref;
    if (parent === null || parent === void 0 ? void 0 : (ref = parent.classList) === null || ref === void 0 ? void 0 : ref.contains(findClass)) return parent;
    if (count >= stopCount) return null;
    if (!(parent === null || parent === void 0 ? void 0 : parent.parentNode)) return null;
    return getParentNode({
        parent: parent === null || parent === void 0 ? void 0 : parent.parentNode,
        findClass: findClass,
        stopCount: stopCount,
        count: count + 1
    });
};
var Node = {
    getScale: getNodeScale,
    getParent: getParentNode
};

/* harmony default export */ var utils_Node = ((/* unused pure expression or super */ null && (Node)));

// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
;// CONCATENATED MODULE: ./src/utils/Scale.js


var getScaledPosition = function(item, parent, scale) {
    return item && parent && scale ? {
        x: item.getBoundingClientRect().x / scale - parent.getBoundingClientRect().x / scale,
        y: item.getBoundingClientRect().y / scale - parent.getBoundingClientRect().y / scale,
        height: item.offsetHeight,
        width: item.offsetWidth
    } : null;
};
var getScaledPositionByParent = function(ref, parentClass, scaleClass) {
    var current = ref === null || ref === void 0 ? void 0 : ref.current;
    if (!current) return;
    var parentRef = getParentNode({
        parent: current === null || current === void 0 ? void 0 : current.parentNode,
        findClass: parentClass
    });
    if (!parentRef) return;
    var scale = (0,Text/* isString */.HD)(scaleClass) ? getNodeScale(scaleClass) : scaleClass;
    if (!scale) return;
    return getScaledPosition(current, parentRef, scale);
};


;// CONCATENATED MODULE: ./src/mosanic/hooks/useItemHover.js









var useItemHover = function(param) {
    var item = param.item, map = param.map, ref = param.ref, _breakpoint = param.breakpoint, breakpoint = _breakpoint === void 0 ? null : _breakpoint, _clone = param.clone, clone = _clone === void 0 ? null : _clone;
    var dispatch = (0,es/* useDispatch */.I0)();
    // const hoverLayers = useSelector(hoveringLayersSelector);
    var isHovered = (0,es/* useSelector */.v9)(function(state) {
        return isItemHovered(state, {
            id: item === null || item === void 0 ? void 0 : item._id
        });
    });
    var pageScale = (0,es/* useSelector */.v9)(canvas_reducer/* getPageScale */.ZK);
    var setHoverState = function(state) {
        var bounds = breakpoint === "layers" ? null : getScaledPositionByParent(ref, "inspectRef", pageScale);
        dispatch((0,action/* setHoverAction */.Te)({
            item: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                clone: clone
            }),
            state: state,
            map: map,
            bounds: bounds,
            screen: breakpoint
        }));
    };
    // ,[dispatch, item, map, ref, breakpoint, pageScale, clone]);
    // useEffect(() => {
    //     if(hoverLayers && isHovered && breakpoint != 'layers')
    //       setHoverState(true)
    // },[isHovered, setHoverState, breakpoint, hoverLayers])
    return {
        hoverState: breakpoint === "layers" ? isHovered : false,
        onMouseEnter: function() {
            return setHoverState(true);
        },
        onMouseLeave: function() {
            return setHoverState(false);
        }
    };
};
/* harmony default export */ var hooks_useItemHover = (useItemHover);

;// CONCATENATED MODULE: ./src/hooks/events/mousePositionClick.js
var mousePositionClick = function(event, contextMenu, setContextMenu) {
    var clear = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    setContextMenu(contextMenu === null || !clear ? {
        x: event.clientX - 2,
        y: event.clientY - 4
    } : null);
};

// EXTERNAL MODULE: ./src/mosanic/utils/map/paths.js
var paths = __webpack_require__(21634);
// EXTERNAL MODULE: ./src/mosanic/utils/map/slots.js
var slots = __webpack_require__(67692);
// EXTERNAL MODULE: ./src/features/inspect/action.js
var inspect_action = __webpack_require__(67319);
// EXTERNAL MODULE: ./src/features/inspect/reducer.js
var inspect_reducer = __webpack_require__(57522);
// EXTERNAL MODULE: ./src/utils/Event.js
var Event = __webpack_require__(33434);
;// CONCATENATED MODULE: ./src/mosanic/hooks/useItemInspect.js














var useInspectState = function() {
    var inspectScreen = (0,es/* useSelector */.v9)(inspect_reducer/* selectInspectItemScreen */.ns);
    var inspectPath = (0,es/* useSelector */.v9)(inspect_reducer/* selectInspectItemPath */.fP);
    var inspectId = (0,es/* useSelector */.v9)(inspect_reducer/* selectInspectItemId */.SM);
    var splitPath = inspectPath ? (0,paths/* splitPath */.uo)(inspectPath) : null;
    return [
        splitPath,
        inspectScreen,
        inspectId
    ];
};
var validateIsInspected = function(param) {
    var inspectScreen = param.inspectScreen, inspectId = param.inspectId, itemScreen = param.itemScreen, itemId = param.itemId;
    if (itemScreen === "layers") return inspectScreen === inspectId;
    return inspectScreen === itemScreen && inspectId === itemId;
};
var interval = 150;
var useItemInspect = function(param) {
    var item = param.item, ref = param.ref, breakpoint = param.breakpoint, map = param.map, mode = param.mode, _data = param.data, data = _data === void 0 ? null : _data;
    var path = map.path, children = map.children;
    var className = (data === null || data === void 0 ? void 0 : data.clone) ? "".concat(item === null || item === void 0 ? void 0 : item.className).concat(data === null || data === void 0 ? void 0 : data.clone) : item === null || item === void 0 ? void 0 : item.className;
    var isEnd = (0,slots/* hasSlots */.kq)(children) || !children;
    var itemPath = (0,paths/* splitPath */.uo)(path);
    var itemId = item === null || item === void 0 ? void 0 : item._id;
    // const isInspected = useInspectState(item?._id, mode === 'layers' ? 'any' : breakpoint, true, data?.clone)
    var ref1 = (0,_sliced_to_array/* default */.Z)(useInspectState(), 3), splittedInspect = ref1[0], inspectScreen = ref1[1], inspectId = ref1[2];
    var itemScreen = mode === "layers" ? "layers" : breakpoint;
    var isInspected = validateIsInspected({
        inspectScreen: inspectScreen,
        inspectId: inspectId,
        itemId: itemId,
        itemScreen: itemScreen
    });
    var shouldValidate = Boolean(splittedInspect && breakpoint != "layers");
    var validateChild = Boolean((splittedInspect === null || splittedInspect === void 0 ? void 0 : splittedInspect.length) < (itemPath === null || itemPath === void 0 ? void 0 : itemPath.length));
    var passRowAndScreen = Boolean((0,paths/* isDiffRow */.aU)(splittedInspect, itemPath) || inspectScreen != itemScreen);
    var ref2 = (0,react.useState)(null), contextMenu = ref2[0], setContextMenu = ref2[1];
    var pageScale = (0,es/* useSelector */.v9)(canvas_reducer/* getPageScale */.ZK);
    var dispatch = (0,es/* useDispatch */.I0)();
    var setInspector = function(e) {
        var isLayer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (isLayer) handleInspector(e);
        else if (isEnd || Event/* default.isCurrentTarget */.ZP.isCurrentTarget(e, className)) {
            if ((e === null || e === void 0 ? void 0 : e.type) === "contextmenu") {
                Event/* default.prevent */.ZP.prevent(e);
                mousePositionClick(e, contextMenu, setContextMenu, false);
            }
            if (!isInspected) handleInspector(e);
        }
    };
    var handleInspector = function(e) {
        var bounds = getScaledPositionByParent(ref, "inspectRef", pageScale);
        if (shouldValidate && !Event/* default.isCurrentTarget */.ZP.isCurrentTarget(e, className)) {
            if (passRowAndScreen) {
            // All good.
            } else if (validateChild) {
                if (!(0,paths/* isDiffRow */.aU)(splittedInspect, itemPath) && !(0,paths/* isDiffCol */.Ad)(splittedInspect, itemPath) && !getParentNode({
                    parent: e.target,
                    findClass: className
                })) return false;
            } else if ((0,paths/* isSameLevel */.Rp)(splittedInspect, itemPath) && (0,paths/* isDiffParent */.GK)(splittedInspect, itemPath)) {
            //Other child
            } else {
                return false;
            }
        }
        // todo --> handle screen
        // if not xl screen is available 
        // fallback to the screen with the most items
        dispatch((0,inspect_action/* initInspectAction */.Vx)({
            component: (0,src_object_spread/* default */.Z)({
                _id: item._id,
                type: item === null || item === void 0 ? void 0 : item.type,
                group: item === null || item === void 0 ? void 0 : item.group,
                itemType: item === null || item === void 0 ? void 0 : item.itemType,
                state: item === null || item === void 0 ? void 0 : item.state
            }, data),
            screen: itemScreen != "layers" ? itemScreen : "xl",
            bounds: bounds,
            path: path
        }));
        //Convert on artboards item state to correct overwrite value
        if ((0,Text/* containsSubstr */.xX)(itemScreen, "ab-")) {
            var variant = Object.entries(item === null || item === void 0 ? void 0 : item.state).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), type = _param[0], value = _param[1];
                return {
                    type: type,
                    value: value,
                    label: (0,Text/* capitalizeFirst */.Ez)((0,Text/* replacePart */.bA)(value, "".concat(type, "-"), ""))
                };
            });
            dispatch((0,inspect_action/* setOverwriteAction */.lN)(variant[0], "variant"));
        }
    };
    var ref3 = (0,react.useState)(null), size = ref3[0], setSize = ref3[1];
    (0,react.useEffect)(function() {
        var timer;
        if (isInspected) {
            timer = setInterval(function() {
                var ref1;
                var clientRect = ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect();
                if (JSON.stringify(size) != JSON.stringify(clientRect)) {
                    setSize(clientRect);
                    dispatch((0,action/* updateInspectBounds */.Qe)(path, getScaledPositionByParent(ref, "inspectRef", pageScale), breakpoint));
                }
            }, 250);
        }
        return function() {
            return clearTimeout(timer);
        };
    }, [
        breakpoint,
        dispatch,
        isInspected,
        pageScale,
        path,
        ref,
        size
    ]);
    return {
        onClick: setInspector,
        contextMenu: contextMenu,
        setContextMenu: setContextMenu,
        isInspected: isInspected
    };
};
/* harmony default export */ var hooks_useItemInspect = (useItemInspect);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./src/mosanic/utils/controlContext.js





var controlVariant = function(controlProps) {
    var ref;
    return {
        value: "control",
        label: "Controlled item",
        type: "single",
        options: (ref = Object.keys(controlProps.control)) === null || ref === void 0 ? void 0 : ref.map(function(variant) {
            return {
                value: "control-".concat((0,Text/* toLowCase */.Cc)(variant)),
                label: (0,Text/* capitalizeFirst */.Ez)(variant)
            };
        })
    };
};
var getActiveControl = function(controlProps) {
    var ref;
    var active = (ref = Object.entries(controlProps.control)) === null || ref === void 0 ? void 0 : ref.find(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], state = _param[1];
        return key === "active" && state;
    });
    return active ? "control-true" : "control-false";
};
var appendControlProps = function(item, controlProps) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
        variants: (item === null || item === void 0 ? void 0 : item.variants) ? (0,_to_consumable_array/* default */.Z)(item.variants).concat([
            controlVariant(controlProps)
        ]) : [
            controlVariant(controlProps)
        ],
        state: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item === null || item === void 0 ? void 0 : item.state), {
            control: getActiveControl(controlProps)
        })
    });
};
var appendLocaleProp = function(item, locale) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
        state: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item === null || item === void 0 ? void 0 : item.state), {
            locale: "local-".concat(locale)
        })
    });
};
var appendControl = function(item, controlProps, locale) {
    if (controlProps === null || controlProps === void 0 ? void 0 : controlProps.control) item = appendControlProps(item, controlProps);
    if (locale) item = appendLocaleProp(item, locale);
    return item;
};

// EXTERNAL MODULE: ./src/mosanic/utils/map/mode.js
var map_mode = __webpack_require__(30415);
// EXTERNAL MODULE: ./src/mosanic/core/Provider/DataProviders.js
var DataProviders = __webpack_require__(42622);
// EXTERNAL MODULE: ./src/mosanic/core/Provider/PageProviders.js
var PageProviders = __webpack_require__(43970);
// EXTERNAL MODULE: ./src/mosanic/core/Map/ChildItem.js + 1 modules
var ChildItem = __webpack_require__(35798);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/Icons/ElementIcons.js
var ElementIcons = __webpack_require__(99559);
// EXTERNAL MODULE: ./src/mosanic/builder/registery.js + 49 modules
var registery = __webpack_require__(53342);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ./src/mosanic/core/Map/Styles/Layer.styles.js
var Layer_styles = __webpack_require__(60354);
;// CONCATENATED MODULE: ./src/mosanic/core/Map/ChildLayer.js

















var isHigher = function(activeInspect, itemPath) {
    return (activeInspect === null || activeInspect === void 0 ? void 0 : activeInspect.length) >= (itemPath === null || itemPath === void 0 ? void 0 : itemPath.length) + 1;
};
var validatePaths = function(activePath, itemPath) {
    var toValidate = (0,_to_consumable_array/* default */.Z)(activePath);
    toValidate.length = itemPath === null || itemPath === void 0 ? void 0 : itemPath.length;
    var isClosed = activePath[0] != itemPath[0] || toValidate.toString() != itemPath.toString();
    var isActive = activePath.toString() === itemPath.toString();
    var isOpen = (open || isActive || isHigher(activePath, itemPath)) && !isClosed;
    return [
        isActive,
        isOpen
    ];
};
var Layer = function(param) {
    var props = param.props;
    var item = props.item, child = props.child, path = props.path, level = props.level, breakpoint = props.breakpoint, hover = props.hover, inspect = props.inspect, ref = props.ref;
    var autoOpen = (0,es/* useSelector */.v9)(reducer/* getAutoOpenLayers */.yp);
    var onClick = inspect.onClick, contextMenu = inspect.contextMenu, setContextMenu = inspect.setContextMenu, isInspected = inspect.isInspected;
    var Render = (0,registery/* default */.Z)(item === null || item === void 0 ? void 0 : item.type);
    var inspectedPath = (0,es/* useSelector */.v9)(inspect_reducer/* selectInspectItemPath */.fP);
    var toggleOpen = function(e) {
        return onClick(e, true);
    };
    var map = (0,es/* useSelector */.v9)(bounds_reducer/* hoverBoundsSelector */.q0).map;
    var activePath = (0,paths/* splitPath */.uo)(map === null || map === void 0 ? void 0 : map.path) ? (0,paths/* splitPath */.uo)(map === null || map === void 0 ? void 0 : map.path) : [];
    var activeInspect = inspectedPath ? (0,paths/* splitPath */.uo)(inspectedPath) : [];
    var itemPath = (0,paths/* splitPath */.uo)(path);
    var ref1 = (0,_sliced_to_array/* default */.Z)(validatePaths(activeInspect, itemPath), 2), isActive = ref1[0], isOpenInspect = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(validatePaths(activePath, itemPath), 2), isHovered = ref2[0], isOpenHover = ref2[1];
    var isOpen = isOpenInspect || isOpenHover;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layer_styles/* default.Layer */.Z.Layer, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        level: level,
        ref: ref
    }, hover), {
        open: isOpen,
        hasChildren: props === null || props === void 0 ? void 0 : props.children,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layer_styles/* default.Label */.Z.Label, {
                isOpen: isOpen,
                onClick: toggleOpen,
                active: isActive,
                hovered: hover.hoverState,
                hasChildren: props === null || props === void 0 ? void 0 : props.children,
                children: [
                    !props.children ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* DotIcon */.ZNd, {}) : isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronDownIcon */.v4q, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronRightIcon */.XCv, {}),
                    (0,ElementIcons/* elementIcon */.$N)(item === null || item === void 0 ? void 0 : item.type),
                    (item === null || item === void 0 ? void 0 : item.title) ? item.title : (0,Text/* capitalizeFirst */.Ez)(item === null || item === void 0 ? void 0 : item.type)
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
                when: Render,
                wrapper: function(children) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layer_styles/* default.Render */.Z.Render, {
                        level: level + 1,
                        children: children
                    });
                },
                children: props === null || props === void 0 ? void 0 : props.children
            })
        ]
    }));
};
/* harmony default export */ var ChildLayer = (Layer);

// EXTERNAL MODULE: ./src/mosanic/core/Map/ChildProd.js
var ChildProd = __webpack_require__(56619);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/mosanic/constants/items.js
var items = __webpack_require__(66625);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
// EXTERNAL MODULE: ./src/utils/Tag.js
var Tag = __webpack_require__(38618);
// EXTERNAL MODULE: ./src/mosanic/utils/schema.js
var schema = __webpack_require__(32064);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/mosanic/core/Map/ItemRow.js + 1 modules
var ItemRow = __webpack_require__(94887);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
;// CONCATENATED MODULE: ./src/mosanic/core/Map/ChildSeo.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



// const canRenderSchema = dynamic(() => import("@mosanic/_Schemas"));











var Wrapper = function(param) {
    var props = param.props, children = param.children;
    var ref;
    if ((props === null || props === void 0 ? void 0 : (ref = props.child) === null || ref === void 0 ? void 0 : ref.itemType) === items/* default.ROW */.ZP.ROW) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemRow/* default */.Z, {
        props: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            children: children
        }),
        menu: {
            render: "Column"
        },
        production: true
    });
    return children;
};
var ProdFieldsContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var Component = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8821b25-0"
})(_templateObject());
var Seo = function(param) {
    var props = param.props, item = param.item;
    var ref, ref1;
    var child = props.child;
    var Render = (0,registery/* default */.Z)(item === null || item === void 0 ? void 0 : item.type);
    var reference = (0,schema/* useProductionFieldsRef */.Lv)({
        active: false,
        item: item,
        production: true
    });
    var linkHref = (0,Obj/* hasAttr */.B$)(reference === null || reference === void 0 ? void 0 : reference.fields, "href") ? {
        href: reference === null || reference === void 0 ? void 0 : (ref = reference.fields) === null || ref === void 0 ? void 0 : ref.href,
        target: reference === null || reference === void 0 ? void 0 : (ref1 = reference.fields) === null || ref1 === void 0 ? void 0 : ref1.target
    } : null;
    var slotComponent = (0,slots/* hasSlots */.kq)(child === null || child === void 0 ? void 0 : child.children);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: linkHref === null || linkHref === void 0 ? void 0 : linkHref.href,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: linkHref.href,
                target: linkHref.target,
                children: children
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
            as: (0,Tag/* getTag */.h1)(item === null || item === void 0 ? void 0 : item.type),
            type: item === null || item === void 0 ? void 0 : item.type,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                props: props,
                children: slotComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdFieldsContext.Provider, {
                    value: reference,
                    children: props.children
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        Render && Render(reference),
                        props.children
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var ChildSeo = (Seo);

;// CONCATENATED MODULE: ./src/mosanic/core/Map/Child.js


















var Child = function(_param) {
    var children = _param.children, child = _param.child, path = _param.path, level = _param.level, breakpoint = _param.breakpoint, data = _param.data, mode = _param.mode, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "child",
        "path",
        "level",
        "breakpoint",
        "data",
        "mode"
    ]);
    var ref, ref1;
    var props = {
        children: children,
        child: child,
        path: path,
        level: level,
        data: data,
        breakpoint: breakpoint
    };
    var router = (0,next_router.useRouter)();
    var ctxLocale = (0,es/* useSelector */.v9)(reducer/* canVariantLocaleSelector */.WT);
    if ((0,map_mode/* isDevMode */.X6)(mode)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(DevChild, (0,src_object_spread/* default */.Z)({
        mode: mode,
        props: props
    }, other));
    var item = data === null || data === void 0 ? void 0 : (ref = data[child === null || child === void 0 ? void 0 : child.group]) === null || ref === void 0 ? void 0 : ref[child === null || child === void 0 ? void 0 : child._id];
    var fieldAction = item === null || item === void 0 ? void 0 : (ref1 = item.fields) === null || ref1 === void 0 ? void 0 : ref1.action;
    var showLocale = Boolean(fieldAction === "locale" || ctxLocale);
    item = appendControl(item, other === null || other === void 0 ? void 0 : other.controlProps, showLocale ? router === null || router === void 0 ? void 0 : router.locale : null);
    // if(other?.controlProps) console.log(other?.controlProps)
    //Render with base props
    if ((0,map_mode/* isProdMode */.Br)(mode)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildProd/* default */.Z, (0,src_object_spread/* default */.Z)({
        props: props,
        item: item
    }, other));
    if ((0,map_mode/* isSeoMode */.DH)(mode)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildSeo, {
        props: props,
        item: item
    });
};
var DevChild = function(_param) {
    var mode = _param.mode, props = _param.props, other = (0,_object_without_properties/* default */.Z)(_param, [
        "mode",
        "props"
    ]);
    var ref;
    var router = (0,next_router.useRouter)();
    var breakpoint = props.breakpoint, path = props.path, child = props.child, data = props.data;
    var map = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, child), {
        path: path
    });
    //Get item from store
    var item = (0,es/* useSelector */.v9)(function(state) {
        return (0,selector/* itemSelector */.O1)(state, props.child);
    });
    var fieldAction = item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : ref.action;
    if (!item || data && (data === null || data === void 0 ? void 0 : data[child === null || child === void 0 ? void 0 : child._id])) {
        item = data === null || data === void 0 ? void 0 : data[child === null || child === void 0 ? void 0 : child._id];
    }
    if (item && (data === null || data === void 0 ? void 0 : data.extend)) {
        item = (0,src_object_spread/* default */.Z)({}, item, data.extend);
    }
    var ctxLocale = (0,es/* useSelector */.v9)(reducer/* canVariantLocaleSelector */.WT);
    var showLocale = Boolean(fieldAction === "locale" || ctxLocale);
    //Add other control options to item 'states'
    item = appendControl(item, other === null || other === void 0 ? void 0 : other.controlProps, showLocale ? router === null || router === void 0 ? void 0 : router.locale : null);
    var dataProvider = (0,DataProviders/* useDataProvider */.x5)();
    var repeatProvider = (0,DataProviders/* useRepeatProvider */.RS)();
    var pageProvider = (0,PageProviders/* usePageContext */.lO)();
    var relationProvider = (0,DataProviders/* useRelationProvider */.UH)();
    // console.log(dataProvider)
    var ref1 = hooks_useItemDrag({
        map: map
    }), ref2 = ref1.ref, isDrag = ref1.isDrag;
    var inspect = hooks_useItemInspect({
        item: item,
        ref: ref2,
        breakpoint: breakpoint,
        map: map,
        mode: mode,
        data: {
            clone: other === null || other === void 0 ? void 0 : other.clone,
            repeat: {
                collection: other === null || other === void 0 ? void 0 : other.collection
            },
            context: {
                dataProvider: dataProvider,
                repeatProvider: repeatProvider,
                relationProvider: relationProvider,
                pageProvider: pageProvider
            }
        }
    });
    var hover = hooks_useItemHover({
        item: item,
        ref: ref2,
        breakpoint: breakpoint,
        map: map,
        clone: other === null || other === void 0 ? void 0 : other.clone
    });
    var extendedProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        item: item,
        inspect: inspect,
        hover: hover,
        ref: ref2,
        isDrag: isDrag
    });
    //Render interactive dev layer
    if (mode === "layers") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildLayer, (0,src_object_spread/* default */.Z)({
        props: extendedProps
    }, other));
    //Render dev item container
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildItem/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        props: extendedProps
    }, other), {
        children: props.children
    })) : (props === null || props === void 0 ? void 0 : props.children) ? props.children : null;
};
/* harmony default export */ var Map_Child = (Child);


/***/ }),

/***/ 35798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ FieldsContext; },
  "Z": function() { return /* binding */ ChildItem; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/builder/registery.js + 49 modules
var registery = __webpack_require__(53342);
// EXTERNAL MODULE: ./src/mosanic/constants/items.js
var items = __webpack_require__(66625);
// EXTERNAL MODULE: ./src/mosanic/hooks/useEditorMenu.js
var useEditorMenu = __webpack_require__(52926);
// EXTERNAL MODULE: ./src/mosanic/utils/map/slots.js
var slots = __webpack_require__(67692);
// EXTERNAL MODULE: ./src/mosanic/utils/schema.js
var schema = __webpack_require__(32064);
// EXTERNAL MODULE: ./src/utils/Funct.js
var Funct = __webpack_require__(3847);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ./src/utils/Tag.js
var Tag = __webpack_require__(38618);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/mosanic/hooks/useValidate.js
var useValidate = __webpack_require__(15901);
// EXTERNAL MODULE: ./src/mosanic/items/ControlMenu/Menu.tsx + 31 modules
var Menu = __webpack_require__(41100);
// EXTERNAL MODULE: ./src/components/Builder/Layout/Component/Controls.js + 3 modules
var Controls = __webpack_require__(49873);
;// CONCATENATED MODULE: ./src/mosanic/core/Map/ItemControls.js



var ItemControls = function(param) {
    var menu = param.menu;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Menu/* default */.Z, {
        position: {
            x: menu === null || menu === void 0 ? void 0 : menu.x,
            y: menu === null || menu === void 0 ? void 0 : menu.y
        },
        close: function() {
            return menu === null || menu === void 0 ? void 0 : menu.setMenu(null);
        },
        children: (menu === null || menu === void 0 ? void 0 : menu.render) ? menu.render : /*#__PURE__*/ (0,jsx_runtime.jsx)(Controls/* default */.Z, {
            component: menu === null || menu === void 0 ? void 0 : menu.data,
            listOnly: true
        })
    });
};
/* harmony default export */ var Map_ItemControls = (ItemControls);

// EXTERNAL MODULE: ./src/mosanic/core/Map/ItemRow.js + 1 modules
var ItemRow = __webpack_require__(94887);
// EXTERNAL MODULE: ./src/mosanic/core/Map/Styles/Item.styles.js + 3 modules
var Item_styles = __webpack_require__(51490);
;// CONCATENATED MODULE: ./src/mosanic/core/Map/ChildItem.js























var Wrapper = function(param) {
    var props = param.props, children = param.children;
    var ref;
    if ((props === null || props === void 0 ? void 0 : (ref = props.child) === null || ref === void 0 ? void 0 : ref.itemType) === items/* default.ROW */.ZP.ROW) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemRow/* default */.Z, {
        props: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: children
        }),
        menu: {
            render: "Column"
        }
    });
    return children;
};
var controls = {
    column: {
        render: "Column"
    },
    stack: {
        render: "Stack"
    },
    repeater: {
        render: "Repeater"
    }
};
var FieldsContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var ChildRender = function(param) {
    var child = param.child, reference = param.reference, children = param.children;
    var Render = (0,registery/* default */.Z)(child.type);
    var slotComponent = (0,slots/* hasSlots */.kq)(child === null || child === void 0 ? void 0 : child.children);
    var manageComponent = (0,slots/* manageSlots */.zZ)(child === null || child === void 0 ? void 0 : child.children);
    return slotComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldsContext.Provider, {
        value: reference,
        children: (0,Funct/* isFunc */.W)(Render) && manageComponent ? Render(reference, children) : children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,Funct/* isFunc */.W)(Render) && Render(reference),
            children
        ]
    });
};
var Item = function(_param) {
    var children = _param.children, props = _param.props, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "props"
    ]);
    var ref, ref1, ref2, ref3, ref4;
    var item = props.item, child = props.child, path = props.path, level = props.level, breakpoint = props.breakpoint, hover = props.hover, inspect = props.inspect, ref5 = props.ref;
    var onClick = inspect.onClick, isInspected = inspect.isInspected, contextMenu = inspect.contextMenu, setContextMenu = inspect.setContextMenu;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useEditorMenu/* useEditorMenu */.i)(screen), 2), showEditor = ref6[0], toggleEditor = ref6[1];
    var validate = (0,useValidate/* useValidate */._)(item === null || item === void 0 ? void 0 : item.state, breakpoint, false);
    var reference = (0,schema/* useSchemaFieldsRef */.Kq)({
        active: Boolean(showEditor && isInspected),
        item: item,
        clone: other === null || other === void 0 ? void 0 : other.clone,
        breakpoint: breakpoint
    });
    var linkHref = (0,Obj/* hasAttr */.B$)(reference === null || reference === void 0 ? void 0 : reference.fields, "href") ? {
        href: reference === null || reference === void 0 ? void 0 : (ref = reference.fields) === null || ref === void 0 ? void 0 : ref.href,
        target: reference === null || reference === void 0 ? void 0 : (ref1 = reference.fields) === null || ref1 === void 0 ? void 0 : ref1.target
    } : null;
    var className = (other === null || other === void 0 ? void 0 : other.clone) ? "".concat(item === null || item === void 0 ? void 0 : item.className).concat(other === null || other === void 0 ? void 0 : other.clone) : item === null || item === void 0 ? void 0 : item.className;
    var actionsStyle = (item === null || item === void 0 ? void 0 : item.isCut) ? {
        opacity: 0.2
    } : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: (linkHref === null || linkHref === void 0 ? void 0 : linkHref.href) && false,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: linkHref.href,
                target: linkHref.target,
                children: children
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item_styles/* Component */.w, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            style: actionsStyle,
            as: (0,Text/* isString */.HD)(item === null || item === void 0 ? void 0 : (ref2 = item.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.tags) === null || ref3 === void 0 ? void 0 : ref3.tag) ? item.data.tags.tag : (0,Tag/* getTag */.h1)(item === null || item === void 0 ? void 0 : item.type),
            type: (item === null || item === void 0 ? void 0 : item.type) != "textarea" ? item === null || item === void 0 ? void 0 : item.type : "div",
            onContextMenu: onClick,
            onClick: onClick,
            ref: ref5,
            className: className,
            childs: child === null || child === void 0 ? void 0 : (ref4 = child.children) === null || ref4 === void 0 ? void 0 : ref4.length,
            validate: validate,
            data: item === null || item === void 0 ? void 0 : item.data
        }, hover), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                props: props,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Map_ItemControls, {
                        menu: (0,_object_spread/* default */.Z)({
                            setMenu: setContextMenu,
                            data: item
                        }, controls[item.type], contextMenu)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildRender, {
                        child: child,
                        reference: reference,
                        children: children
                    })
                ]
            })
        }))
    });
};
var memoizedChildItem = /*#__PURE__*/ (0,react.memo)(Item);
memoizedChildItem.displayName = "memoizedChildItem";
/* harmony default export */ var ChildItem = (memoizedChildItem);


/***/ }),

/***/ 56619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ ProdFieldsContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _JSX__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96344);
/* harmony import */ var _mosanic_builder_registery__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53342);
/* harmony import */ var _mosanic_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66625);
/* harmony import */ var _mosanic_utils_map_slots__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67692);
/* harmony import */ var _mosanic_utils_schema__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32064);
/* harmony import */ var _util_Funct__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(3847);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(62570);
/* harmony import */ var _util_Tag__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(38618);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68311);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var _hooks_useValidate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15901);
/* harmony import */ var _ItemRow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94887);
/* harmony import */ var _Styles_Item_styles__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(51490);
/* harmony import */ var _Provider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42622);




















var Wrapper = function(param) {
    var props = param.props, children = param.children;
    var ref;
    if ((props === null || props === void 0 ? void 0 : (ref = props.child) === null || ref === void 0 ? void 0 : ref.itemType) === _mosanic_constants__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ROW */ .ZP.ROW) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ItemRow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        props: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
            children: children
        }),
        menu: {
            render: "Column"
        },
        production: true
    });
    return children;
};
var ProdFieldsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createContext)(undefined);
//View item with passed data
var Prod = function(_param) {
    var props = _param.props, item = _param.item, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "props",
        "item"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var child = props.child, path = props.path, level = props.level, breakpoint = props.breakpoint;
    var validate = (0,_hooks_useValidate__WEBPACK_IMPORTED_MODULE_9__/* .useValidate */ ._)(item === null || item === void 0 ? void 0 : item.state, breakpoint);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var isEnglish = (router === null || router === void 0 ? void 0 : router.locale) === "en";
    var fieldAction = item === null || item === void 0 ? void 0 : (ref = item.fields) === null || ref === void 0 ? void 0 : ref.action;
    var isLink = !fieldAction || ![
        "trigger",
        "locale"
    ].includes(fieldAction);
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), hoverState = ref8[0], setHoverState = ref8[1];
    var hover = {
        hoverState: hoverState,
        onMouseEnter: function() {
            return setHoverState(true);
        },
        onMouseLeave: function() {
            return setHoverState(false);
        }
    };
    var Render = (0,_mosanic_builder_registery__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(item === null || item === void 0 ? void 0 : item.type);
    var reference = (0,_mosanic_utils_schema__WEBPACK_IMPORTED_MODULE_11__/* .useProductionFieldsRef */ .Lv)({
        item: item,
        active: false,
        clone: other === null || other === void 0 ? void 0 : other.clone,
        breakpoint: breakpoint
    });
    var form = (0,_Provider__WEBPACK_IMPORTED_MODULE_12__/* .useFormProvider */ .RC)();
    var triggerLocale = fieldAction === "locale" || fieldAction === "trigger" && (item === null || item === void 0 ? void 0 : (ref1 = item.fields) === null || ref1 === void 0 ? void 0 : ref1.type) === "locale" ? function() {
        return router.replace(router.asPath, null, {
            locale: isEnglish ? "nl" : "en"
        });
    } : null;
    var triggerForm = fieldAction === "trigger" && (item === null || item === void 0 ? void 0 : (ref2 = item.fields) === null || ref2 === void 0 ? void 0 : ref2.type) === "form toggle" ? function() {
        return form === null || form === void 0 ? void 0 : form.toggleEditing();
    } : null;
    var linkHref = (0,_util_Obj__WEBPACK_IMPORTED_MODULE_13__/* .hasAttr */ .B$)(reference === null || reference === void 0 ? void 0 : reference.fields, "href") && isLink ? {
        href: reference === null || reference === void 0 ? void 0 : (ref3 = reference.fields) === null || ref3 === void 0 ? void 0 : ref3.href,
        target: reference === null || reference === void 0 ? void 0 : (ref4 = reference.fields) === null || ref4 === void 0 ? void 0 : ref4.target
    } : null;
    var slotComponent = (0,_mosanic_utils_map_slots__WEBPACK_IMPORTED_MODULE_14__/* .hasSlots */ .kq)(child === null || child === void 0 ? void 0 : child.children);
    var manageComponent = (0,_mosanic_utils_map_slots__WEBPACK_IMPORTED_MODULE_14__/* .manageSlots */ .zZ)(child === null || child === void 0 ? void 0 : child.children);
    var noSlots = slotComponent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_15__/* .ConditionalWrapper */ .M, {
        when: linkHref === null || linkHref === void 0 ? void 0 : linkHref.href,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: linkHref.href,
                target: linkHref.target,
                children: children
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Styles_Item_styles__WEBPACK_IMPORTED_MODULE_16__/* .Component */ .w, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            as: (0,_util_Text__WEBPACK_IMPORTED_MODULE_17__/* .isString */ .HD)(item === null || item === void 0 ? void 0 : (ref5 = item.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.tags) === null || ref6 === void 0 ? void 0 : ref6.tag) ? item.data.tags.tag : (0,_util_Tag__WEBPACK_IMPORTED_MODULE_18__/* .getTag */ .h1)(item === null || item === void 0 ? void 0 : item.type),
            type: (item === null || item === void 0 ? void 0 : item.type) != "button" ? item === null || item === void 0 ? void 0 : item.type : "submit",
            className: item === null || item === void 0 ? void 0 : item.className,
            childs: child === null || child === void 0 ? void 0 : (ref7 = child.children) === null || ref7 === void 0 ? void 0 : ref7.length,
            validate: validate,
            data: item === null || item === void 0 ? void 0 : item.data,
            onClick: function(e) {
                var ref;
                if (other === null || other === void 0 ? void 0 : (ref = other.controlProps) === null || ref === void 0 ? void 0 : ref.handler) other.controlProps.handler(e);
                if (triggerLocale) triggerLocale();
                if (triggerForm) triggerForm();
            }
        }, hover), {
            production: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
                props: props,
                children: slotComponent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProdFieldsContext.Provider, {
                    value: reference,
                    children: (0,_util_Funct__WEBPACK_IMPORTED_MODULE_19__/* .isFunc */ .W)(Render) && manageComponent ? Render(reference, props === null || props === void 0 ? void 0 : props.children) : props === null || props === void 0 ? void 0 : props.children
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        Render && (0,_util_Funct__WEBPACK_IMPORTED_MODULE_19__/* .isFunc */ .W)(Render) && Render(reference),
                        props === null || props === void 0 ? void 0 : props.children
                    ]
                })
            })
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Prod);


/***/ }),

/***/ 94887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ItemRow; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/items/ControlMenu/Menu.tsx + 31 modules
var Menu = __webpack_require__(41100);
// EXTERNAL MODULE: ./src/features/canvas/reducer.js
var reducer = __webpack_require__(64386);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/Builder/Items/SaveLayout.js + 1 modules
var SaveLayout = __webpack_require__(75406);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/hooks/useControlPopper.js
var useControlPopper = __webpack_require__(39284);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Popper.js + 4 modules
var Popper = __webpack_require__(28932);
// EXTERNAL MODULE: ./src/mosanic/items/Tooltip/index.js + 2 modules
var Tooltip = __webpack_require__(94233);
// EXTERNAL MODULE: ./src/features/options/reducer.js + 1 modules
var options_reducer = __webpack_require__(51331);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/components/Builder/Adapters/constants.js
var constants = __webpack_require__(74079);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/mosanic/Icons/EditIcons.js
var EditIcons = __webpack_require__(75679);
;// CONCATENATED MODULE: ./src/components/Builder/Layout/Row/AddNew.js












var SelectLayout = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9589));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9589)
            ];
        }
    }
});
function RowAddSection(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), grid = ref[0], setGrid = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var tooltips = (0,es/* useSelector */.v9)(options_reducer/* getTooltips */.Sm);
    var addNewRow = function() {
        setOpen(false); //close
        var newComponent = {
        };
        var newItem = {
            _id: newComponent._id,
            type: constants/* SIDEBAR_ITEM */.d8,
            component: newComponent
        };
    };
    var ref1 = (0,useControlPopper/* useControlPopper */.Z)(), anchor = ref1.anchor, open = ref1.open, close = ref1.close, isOpen = ref1.isOpen;
    var handleClick = function(event) {
        open(event);
        setGrid(false);
        props.passRowState(true);
    };
    var handleClose = function(event) {
        close(event);
        setGrid(false);
        props.passRowState(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popper/* default */.Z, {
                anchor: anchor,
                close: handleClose,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Choose a section layout"
                    }),
                    !grid ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "controlThumbnails -list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item thumbnail-wrapper",
                                onClick: addNewRow,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    title: !tooltips ? "" : "Blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "32",
                                        height: "32",
                                        viewBox: "0 0 32 32",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M8 21v3h3v2H8c-1.103 0-2-.897-2-2v-3h2zm10 3v2h-4v-2h4zm8-3v3c0 1.103-.897 2-2 2h-3v-2h3v-3h2zM8 14v4H6v-4h2zm18 0v4h-2v-4h2zm-2-8c1.103 0 2 .897 2 2v3h-2V8h-3V6zM11 6v2H8v3H6V8c0-1.103.897-2 2-2h3zm7 0v2h-4V6h4z"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item thumbnail-wrapper",
                                onClick: function() {
                                    return setGrid(!grid);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    title: !tooltips ? "" : "Grid",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "32",
                                        height: "32",
                                        viewBox: "0 0 32 32",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M17 15V8h7l.001 7H17zm7.002 9H17v-7h7.001l.001 7zM8 24h7v-7H8v7zm0-9h7V8H8v7zm16-9H8c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2z"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "item thumbnail-wrapper",
                                onClick: addNewRow,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    title: !tooltips ? "" : "Layout",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "32",
                                        height: "32",
                                        viewBox: "0 0 32 32",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M20 24v-4h4.001l.001 4H20zM8 24h10v-4H8v4zm0-12h4V8H8v4zm0 6h16.001v-4H8v4zm6-6h10V8H14v4zm10-6H8c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2z"
                                        })
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectLayout, {
                        rowData: null
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                variant: "text",
                id: "row-controls-btn",
                "aria-controls": "row-controls",
                className: "trigger",
                onClick: handleClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "add",
                    children: Boolean(anchor) ? EditIcons/* trash */._I : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        title: !tooltips ? "" : "Add section",
                        children: EditIcons/* circlePlus */.Tw
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Builder/Util/SelectLayout.js + 1 modules
var Util_SelectLayout = __webpack_require__(9589);
// EXTERNAL MODULE: ./src/mosanic/core/Map/Styles/Item.wrapper.styles.js
var Item_wrapper_styles = __webpack_require__(71367);
// EXTERNAL MODULE: ./src/mosanic/core/Map/Styles/Item.styles.js + 3 modules
var Item_styles = __webpack_require__(51490);
;// CONCATENATED MODULE: ./src/mosanic/core/Map/ItemRow.js







// import SaveLayout from '../Items/SaveLayout';
// const SelectLayout = dynamic(() => import("../Util/SelectLayout"))
// import RowAddSection from "./Row/AddNew";


// const mediaQuery = (minWidth, maxWidth) => {
//   return `@media(min-width: ${minWidth}px) {
//     max-width: ${maxWidth}px;
//     margin-right: auto;
//     margin-left: auto;
//   }`;
// };
/** 
 * Row 
 * @param {*} param0 
 * @returns 
 */ var Row = function(param) {
    var props = param.props, menu = param.menu, _production = param.production, production = _production === void 0 ? false : _production;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var item = props.item, child = props.child, path = props.path, level = props.level, breakpoint = props.breakpoint, hover = props.hover, inspect = props.inspect, ref6 = props.ref;
    var ref7 = (0,react.useState)(false), rowAdd = ref7[0], toggleRowAdd = ref7[1];
    var hasContainer = (item === null || item === void 0 ? void 0 : (ref = item.data) === null || ref === void 0 ? void 0 : ref.container) && (item === null || item === void 0 ? void 0 : (ref1 = item.data) === null || ref1 === void 0 ? void 0 : ref1.container[breakpoint]) || (item === null || item === void 0 ? void 0 : (ref2 = item.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.container) === null || ref3 === void 0 ? void 0 : ref3.all);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !production && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                        position: {
                            x: menu === null || menu === void 0 ? void 0 : (ref4 = menu.position) === null || ref4 === void 0 ? void 0 : ref4.x,
                            y: menu === null || menu === void 0 ? void 0 : (ref5 = menu.position) === null || ref5 === void 0 ? void 0 : ref5.y
                        },
                        close: menu === null || menu === void 0 ? void 0 : menu.closeMenu,
                        children: [
                            "Adjust section layout",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Util_SelectLayout["default"], {
                                rowData: child,
                                passHandleClose: menu === null || menu === void 0 ? void 0 : menu.closeMenu,
                                hideOthers: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveLayout/* default */.Z, {
                                row: item,
                                rowData: child
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item_wrapper_styles/* default.RowAdd */.Z.RowAdd, {
                        className: "row__add",
                        style: rowAdd ? {
                            opacity: 1
                        } : {},
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RowAddSection, {
                            passRowState: toggleRowAdd,
                            rowId: path
                        })
                    })
                ]
            }),
            hasContainer || true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Item_styles/* default.ColWrapper */.Z.ColWrapper, {
                className: "row_col_wrapper",
                offset: (0,reducer/* getContainerOffset */.Wv)(breakpoint),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item_styles/* default.Columns */.Z.Columns, {
                    className: "row_col_container",
                    children: props.children
                })
            }) : /*#__PURE__*/ 0
        ]
    });
};
/* harmony default export */ var ItemRow = (Row); // export default memo(Row, (prevProps, nextProps) => {
 //   return (
 //     prevProps.isActive === nextProps.isActive && 
 //     prevProps.element === nextProps.element)
 // });


/***/ }),

/***/ 58829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ ProdRender; },
  "Z": function() { return /* binding */ Map_Render; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/utils/map/path.js
var map_path = __webpack_require__(49578);
// EXTERNAL MODULE: ./src/mosanic/utils/map/type.js
var type = __webpack_require__(9528);
;// CONCATENATED MODULE: ./src/mosanic/utils/map/dropZone.js


var getLastDropzonePath = function(path, childCount) {
    return path ? "".concat(path, "-").concat(childCount) : "".concat(childCount);
};
var isHorizontalDropzone = function(componentType) {
    return (0,type/* isColumns */.Uw)(componentType) || (0,type/* isRow */.jC)(componentType);
};
var getDropzoneClass = function(type) {
    switch(type){
        case "repeater":
            return type + "__dropZone";
        case "row":
            return type + "__dropZone horizontalDrag";
        case "columns":
            return "row__dropZone horizontalDrag";
        case "column":
            return type + "__dropZone";
        case "component":
            return type + "__dropZone";
        case "stack":
            return type + "__dropZone";
        default:
            return "page__dropZone";
    }
};
var getDropzoneData = function(path, index, children) {
    return {
        path: (0,map_path/* getCurrentPath */.J)(path, index),
        childrenCount: children === null || children === void 0 ? void 0 : children.length
    };
};

// EXTERNAL MODULE: ./src/mosanic/utils/map/mode.js
var map_mode = __webpack_require__(30415);
// EXTERNAL MODULE: ./src/mosanic/utils/map/slots.js
var slots = __webpack_require__(67692);
// EXTERNAL MODULE: ./src/mosanic/utils/validate.js
var validate = __webpack_require__(32646);
// EXTERNAL MODULE: ./src/utils/Device.js
var Device = __webpack_require__(17629);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/mosanic/constants/items.js
var items = __webpack_require__(66625);
// EXTERNAL MODULE: ./src/mosanic/utils/map/paths.js
var paths = __webpack_require__(21634);
// EXTERNAL MODULE: ./src/features/map/drop/reducer.js
var reducer = __webpack_require__(93819);
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrop/useDrop.js + 9 modules
var useDrop = __webpack_require__(40940);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/mosanic/core/DropZone/DropZone.style.js
var DropZone_style = __webpack_require__(26675);
;// CONCATENATED MODULE: ./src/mosanic/core/DropZone/DropZone.js











var ACCEPTS = [
    items/* ADD_ITEM */.mj,
    items/* SIDEBAR_LAYOUT */.vo,
    items/* SIDEBAR_ITEM */.d8,
    items/* SIDEBAR_STACK */.dA,
    items/* SIDEBAR_REPEATER */.Ls,
    items/* COMPONENT */.NV,
    items/* ROW */.rn,
    items/* COLUMN */.aC,
    items/* STACK */.DT,
    items/* REPEATER */.GK,
    items/* CONTAINER */.rZ
];
var canDropItem = function(item, data, allowed) {
    var ref;
    var itemType = item === null || item === void 0 ? void 0 : item.itemType;
    var itemPath = item === null || item === void 0 ? void 0 : item.path;
    var dropZonePath = data === null || data === void 0 ? void 0 : data.path;
    var splitItemPath = (0,paths/* splitPath */.uo)(itemPath);
    var splitDropZonePath = (0,paths/* splitPath */.uo)(dropZonePath);
    if (!item) return false;
    if (!dropZonePath) return false; //No dropZone path
    if (itemPath === dropZonePath) return false; //Same location
    // if(itemType === Items.ROW && splitDropZonePath?.length != 1) return false; //rows only at base      
    if ((item === null || item === void 0 ? void 0 : (ref = item.component) === null || ref === void 0 ? void 0 : ref.type) === "columns" && (splitDropZonePath === null || splitDropZonePath === void 0 ? void 0 : splitDropZonePath.length) != 1) return false; //New columns wrapper only at base
    if (Array.isArray(allowed)) {
        var ref1;
        var checkType = (item === null || item === void 0 ? void 0 : (ref1 = item.component) === null || ref1 === void 0 ? void 0 : ref1.type) ? item.component.type : item.type;
        return allowed.includes(checkType);
    }
    if (!itemPath) return true; //New item
    // * custom limits
    // switch (item.type) {
    //   case SIDEBAR_LAYOUT: return splitDropZonePath.length === 1
    //   case REPEATER: if(splitDropZonePath.length <= 3) return false;
    //   case SIDEBAR_REPEATER:return (splitDropZonePath.length <= 3)
    //   default: break;
    // }
    var dropZonePathRowIndex = splitDropZonePath[0];
    var itemPathRowIndex = splitItemPath[0];
    var diffRow = dropZonePathRowIndex !== itemPathRowIndex;
    if (!diffRow && splitDropZonePath.length === 2 && data.childrenCount >= 12) return false; //Limit columns
    //Prevent row drop inside child
    var parentDropInChild = splitItemPath.length < splitDropZonePath.length;
    // if(parentDropInChild && isContainer(itemType)) return false;
    // Current area
    if (splitItemPath.length === splitDropZonePath.length) {
        var pathToItem = (0,paths/* pathToItem */.pN)(splitItemPath);
        var currentItemIndex = (0,paths/* getItemIndex */.iS)(splitItemPath);
        var pathToDropZone = (0,paths/* pathToItem */.pN)(splitDropZonePath);
        var currentDropZoneIndex = (0,paths/* getItemIndex */.iS)(splitDropZonePath);
        if (pathToItem === pathToDropZone) {
            var nextDropZoneIndex = currentItemIndex + 1;
            if (nextDropZoneIndex === currentDropZoneIndex) return false;
        }
    }
    return true;
};
var DropZone = function(_param) {
    var data = _param.data, onDrop = _param.onDrop, isLast = _param.isLast, _isHorizontal = _param.isHorizontal, isHorizontal = _isHorizontal === void 0 ? false : _isHorizontal, _allowed = _param.allowed, allowed = _allowed === void 0 ? true : _allowed, _canExpand = _param.canExpand, canExpand = _canExpand === void 0 ? false : _canExpand, _empty = _param.empty, empty = _empty === void 0 ? false : _empty, _slot = _param.slot, slot = _slot === void 0 ? false : _slot, _level = _param.level, level = _level === void 0 ? 0 : _level, _breakpoint = _param.breakpoint, breakpoint = _breakpoint === void 0 ? null : _breakpoint, other = (0,_object_without_properties/* default */.Z)(_param, [
        "data",
        "onDrop",
        "isLast",
        "isHorizontal",
        "allowed",
        "canExpand",
        "empty",
        "slot",
        "level",
        "breakpoint"
    ]);
    var preStoreDrop = (0,es/* useSelector */.v9)(reducer/* preDropStoreSelector */.U);
    var canDropPreStore = canDropItem(preStoreDrop, data, allowed);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useDrop/* useDrop */.L)({
        accept: ACCEPTS,
        drop: function(item, monitor) {
            onDrop((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                slot: slot
            }), item);
        },
        canDrop: function(item, monitor) {
            return canDropItem(item, data, allowed);
        },
        collect: function(monitor, item) {
            return {
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop()
            };
        }
    }), 2), ref1 = ref[0], isOver = ref1.isOver, canDrop = ref1.canDrop, drop = ref[1];
    var state = {
        level: level,
        empty: empty,
        canExpand: canExpand,
        canDrop: canDrop || canDropPreStore,
        isOver: isOver,
        isLast: isLast,
        isHorizontal: isHorizontal
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropZone_style/* default.DropZone */.Z.DropZone, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        ref: drop,
        slot: slot || breakpoint === "layers" || true,
        type: "dropZone",
        layers: breakpoint === "layers",
        onClick: function() {
            return canDropPreStore ? onDrop((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                slot: slot
            }), preStoreDrop) : null;
        }
    }), other), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropZone_style/* default.Inside */.Z.Inside, {})
    }));
};
/* harmony default export */ var DropZone_DropZone = (DropZone);

// EXTERNAL MODULE: ./src/utils/Arr.js
var Arr = __webpack_require__(72393);
// EXTERNAL MODULE: ./src/mosanic/core/Map/Child.js + 10 modules
var Child = __webpack_require__(50547);
;// CONCATENATED MODULE: ./src/mosanic/core/Map/Children.js














var Children = function(_param) {
    var render = _param.render, dropZoneState = _param.dropZoneState, path = _param.path, handleDrop = _param.handleDrop, breakpoint = _param.breakpoint, data = _param.data, mode = _param.mode, other = (0,_object_without_properties/* default */.Z)(_param, [
        "render",
        "dropZoneState",
        "path",
        "handleDrop",
        "breakpoint",
        "data",
        "mode"
    ]);
    return (0,Arr/* canMap */.is)(render) && render.map(function(child, index) {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                (0,map_mode/* isDevMode */.X6)(mode) && !(0,Device/* isServer */.sk)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropZone_DropZone, (0,_object_spread/* default */.Z)({
                    data: getDropzoneData(path, index, render),
                    onDrop: handleDrop
                }, dropZoneState)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Child/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    data: data,
                    child: child,
                    path: (0,map_path/* getCurrentPath */.J)(path, index),
                    level: dropZoneState.level + 1,
                    breakpoint: breakpoint,
                    mode: mode
                }, other), {
                    children: (child === null || child === void 0 ? void 0 : child.children) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Map_Render, (0,_object_spread/* default */.Z)({
                        data: data,
                        child: child,
                        handleDrop: handleDrop,
                        path: (0,map_path/* getCurrentPath */.J)(path, index),
                        breakpoint: breakpoint,
                        level: dropZoneState.level + 1,
                        mode: mode
                    }, other))
                }))
            ]
        }, child === null || child === void 0 ? void 0 : child._id);
    });
};
/* harmony default export */ var Map_Children = (Children);

// EXTERNAL MODULE: ./src/mosanic/constants/fieldTypes.js
var fieldTypes = __webpack_require__(21871);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ./src/mosanic/core/Map/RenderComp.js + 1 modules
var RenderComp = __webpack_require__(73650);
// EXTERNAL MODULE: ./src/mosanic/core/Map/Styles/Layer.styles.js
var Layer_styles = __webpack_require__(60354);
;// CONCATENATED MODULE: ./src/mosanic/core/Map/Slots.js
















var Slots = function(_param) {
    var render = _param.render, path = _param.path, dropZoneState = _param.dropZoneState, handleDrop = _param.handleDrop, breakpoint = _param.breakpoint, mode = _param.mode, data = _param.data, other = (0,_object_without_properties/* default */.Z)(_param, [
        "render",
        "path",
        "dropZoneState",
        "handleDrop",
        "breakpoint",
        "mode",
        "data"
    ]);
    return (render === null || render === void 0 ? void 0 : render.length) > 0 && render.map(function(slot, index) {
        /*#__PURE__*/ return (0,react.createElement)(Slot, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            slot: slot,
            index: index,
            path: path,
            dropZoneState: dropZoneState,
            handleDrop: handleDrop,
            breakpoint: breakpoint,
            mode: mode,
            data: data,
            render: render
        }, other), {
            key: (slot === null || slot === void 0 ? void 0 : slot.type) + index
        }));
    });
};
var Slot = function(_param) {
    var slot = _param.slot, index = _param.index, path = _param.path, dropZoneState = _param.dropZoneState, handleDrop = _param.handleDrop, breakpoint = _param.breakpoint, mode = _param.mode, data = _param.data, render = _param.render, other = (0,_object_without_properties/* default */.Z)(_param, [
        "slot",
        "index",
        "path",
        "dropZoneState",
        "handleDrop",
        "breakpoint",
        "mode",
        "data",
        "render"
    ]);
    //Render slot dropzones
    // if(
    // isSlot(slot) 
    // && slot?.max &&
    // !isValidSlot(slot, getSlotChildCount(render, index))
    // ) return getSlotChildCount(render, index)+','+slot.max+','+index;
    if ((0,slots/* isSlot */.im)(slot) && (mode === "dev" || mode === "layers")) {
        return (0,Device/* isServer */.sk)() ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(DropZone_DropZone, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            allowed: (slot === null || slot === void 0 ? void 0 : slot.allowed) ? slot.allowed : true,
            data: getDropzoneData(path, index, render),
            onDrop: handleDrop
        }, dropZoneState), {
            slot: true
        }), index);
    }
    //Render fields like: inputs, editors
    //These must be defined as: props.fields.['content']
    //Note: these don't contain any styling possibilities
    if ((0,fieldTypes/* isRenderField */.x)(slot.type) && (slot === null || slot === void 0 ? void 0 : slot.type) != "icon") {
        return breakpoint === "layers" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layer_styles/* LayerLabel */.g, {
            center: true,
            level: other === null || other === void 0 ? void 0 : other.level,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowRightIcon */.LZ3, {}),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* InputIcon */.SQj, {}),
                " Field"
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderComp/* default */.Z, {
                fieldType: slot.type,
                path: (0,map_path/* getCurrentPath */.J)(path, index),
                fieldData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, slot), {
                    screen: breakpoint,
                    inline: true
                }),
                isDev: mode === "dev" || mode === "layers"
            }, (slot === null || slot === void 0 ? void 0 : slot.type) + index)
        });
    }
    //New render loop if slot has childs
    //Example: 'tabber' has slot allowing: containers.
    //Render here the 'container' with its children.
    if (slot === null || slot === void 0 ? void 0 : slot.children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Child/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                data: data,
                child: slot,
                path: (0,map_path/* getCurrentPath */.J)(path, index),
                level: dropZoneState.level + 1,
                breakpoint: breakpoint,
                mode: mode
            }, other), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Map_Render, (0,_object_spread/* default */.Z)({
                    data: data,
                    child: slot,
                    handleDrop: handleDrop,
                    path: (0,map_path/* getCurrentPath */.J)(path, index),
                    breakpoint: breakpoint,
                    level: dropZoneState.level + 1,
                    mode: mode
                }, other))
            }))
        });
    }
    //Render child component
    //Note: these don't contain any children itself
    //For example: Image component, Icon Component.
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Child/* default */.Z, (0,_object_spread/* default */.Z)({
        child: slot,
        data: data,
        path: (0,map_path/* getCurrentPath */.J)(path, index),
        level: dropZoneState.level + 1,
        breakpoint: breakpoint,
        mode: mode
    }, other), slot);
};
/* harmony default export */ var Map_Slots = (Slots);

;// CONCATENATED MODULE: ./src/mosanic/core/Map/Render.js















var ProdRender = function(param) {
    var child = param.child, data = param.data, breakpoint = param.breakpoint;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Render, {
        child: child,
        data: data,
        breakpoint: breakpoint,
        handleDrop: null,
        mode: "prod",
        path: ""
    });
};
var Render = function(_param) {
    var child = _param.child, data = _param.data, handleDrop = _param.handleDrop, path = _param.path, breakpoint = _param.breakpoint, _level = _param.level, level = _level === void 0 ? 0 : _level, _mode = _param.mode, mode = _mode === void 0 ? "dev" : _mode, other = (0,_object_without_properties/* default */.Z)(_param, [
        "child",
        "data",
        "handleDrop",
        "path",
        "breakpoint",
        "level",
        "mode"
    ]);
    var children = (child === null || child === void 0 ? void 0 : child.children) ? child.children : child;
    var type = child === null || child === void 0 ? void 0 : child.type;
    var dropZoneState = {
        level: level,
        breakpoint: breakpoint,
        canExpand: (0,validate/* isCol */.B1)(child === null || child === void 0 ? void 0 : child.itemType),
        empty: !children || children.length === 0,
        isHorizontal: isHorizontalDropzone(type),
        slot: false
    };
    var childrenProps = (0,_object_spread/* default */.Z)({
        render: children,
        dropZoneState: dropZoneState,
        path: path,
        handleDrop: handleDrop,
        breakpoint: breakpoint,
        mode: mode,
        data: data
    }, other);
    if ((0,slots/* hasSlots */.kq)(children)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Map_Slots, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, childrenProps), {
                level: level
            }))
        });
    }
    return (0,map_mode/* isDevMode */.X6)(mode) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: level === 0,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: children
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Map_Children, (0,_object_spread/* default */.Z)({}, childrenProps)),
            (0,Device/* isServer */.sk)() ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(DropZone_DropZone, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dropZoneState), {
                data: {
                    path: getLastDropzonePath(path, children === null || children === void 0 ? void 0 : children.length),
                    childrenCount: children === null || children === void 0 ? void 0 : children.length
                },
                onDrop: handleDrop,
                isLast: true
            }))
        ]
    }) : // <Condition
    //   wrap={ isSeoMode(mode) }
    //   wrapper={children => <div className="preRenderSeo">{!rendered ? children : null}</div>}
    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Map_Children, (0,_object_spread/* default */.Z)({}, childrenProps))
    });
};
var MemoizedRender = /*#__PURE__*/ (0,react.memo)(Render);
/* harmony default export */ var Map_Render = (MemoizedRender);


/***/ }),

/***/ 73650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Map_RenderComp; }
});

// UNUSED EXPORTS: RenderComp

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
// EXTERNAL MODULE: ./src/mosanic/builder/registery.js + 49 modules
var registery = __webpack_require__(53342);
// EXTERNAL MODULE: ./src/utils/Funct.js
var Funct = __webpack_require__(3847);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/mosanic/core/Map/ChildItem.js + 1 modules
var ChildItem = __webpack_require__(35798);
// EXTERNAL MODULE: ./src/mosanic/core/Map/ChildProd.js
var ChildProd = __webpack_require__(56619);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/mosanic/core/Map/Context.js





var useContextReference = function(isDev) {
    var devReference = (0,react.useContext)(ChildItem/* FieldsContext */.L);
    var prodReference = (0,react.useContext)(ChildProd/* ProdFieldsContext */.t);
    var reference = isDev ? devReference : prodReference;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reference), {
        isDev: isDev
    });
};

;// CONCATENATED MODULE: ./src/mosanic/core/Map/RenderComp.js


// const canRenderSchema = dynamic(() => import("@mosanic/_Schemas"));



// import { InlineEditor } from "../Editor";
// const InlineEditor = dynamic(() => import('@mosanic/fields/Editor/Inline'))
// import { RenderField } from "./Render";
// const RenderField = dynamic(() => import("./Render"))
// const InlineEditor = dynamic(
//     import("../Editor/Inline"),{
//         loading: () => (<span>...</span>),
//         ssr: false
//     }
// )
// const compMap = {
// 'Button':  dynamic(() => import("@mosanic/builder/Button")),
// 'Icon':  dynamic(() => import("@mosanic/builder/Icn")),
// 'Code':  dynamic(() => import("@mosanic/builder/Code")),
// 'Script':  dynamic(() => import("@mosanic/builder/Script")),
// 'Image':  dynamic(() => import("@mosanic/builder/Image")),
// 'Text':  dynamic(() => import("@mosanic/builder/Text")),
// 'Video':  dynamic(() => import("@mosanic/builder/Video")),
// 'Tabs':  dynamic(() => import("@mosanic/builder/Tabs")),
// 'TabHeader':  dynamic(() => import("@mosanic/builder/Tabs/TabHeader")),
// 'Container':  dynamic(() => import("@mosanic/builder/Container")),
// 'DataLink':  dynamic(() => import("@mosanic/builder/DataLink")),
// 'Textarea':  dynamic(() => import("@mosanic/builder/Textarea")),
// 'Heading':  dynamic(() => import("@mosanic/builder/Heading")),
// 'Repeater':  dynamic(() => import("@mosanic/builder/Repeater")),
// 'ImageSlider':  dynamic(() => import("@mosanic/builder/ImageSlider")),
// }
var RenderComp = function(param) {
    var fieldType = param.fieldType, fieldData = param.fieldData, _isDev = param.isDev, isDev = _isDev === void 0 ? true : _isDev;
    var reference = useContextReference(isDev);
    // console.log(reference)
    if (fieldType === "render" && reference) {
        var Render = (0,registery/* default */.Z)(reference.ref.type);
        if (!Render || !(0,Funct/* isFunc */.W)(Render)) {
            console.warn("Could not find a valid render method for: ".concat(JSON.stringify(reference.ref)));
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: Render(reference)
        });
    }
    return null;
};
/* harmony default export */ var Map_RenderComp = (RenderComp);


/***/ }),

/***/ 51490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ Component; },
  "Z": function() { return /* binding */ Item_styles; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/adapters/host.js
var host = __webpack_require__(6539);
// EXTERNAL MODULE: ./src/mosanic/styles/flex.styles.js
var flex_styles = __webpack_require__(5441);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/core/DropZone/DropZone.style.js
var DropZone_style = __webpack_require__(26675);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
;// CONCATENATED MODULE: ./src/mosanic/core/Map/Styles/Column.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: rgba(255,255,255,0.5);\n  position: relative;\n  min-height: 35px;\n  text-align: center;\n\n  &::before {\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    content: '';\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    border: 0.5px dashed ",
        ";\n  }\n\n  &::after {\n    font-size: 12px;\n    content: 'Column';\n    height: 100%; \n    ",
        "\n  }\n\n    ",
        " {\n      height: 100%;\n      max-height: 100%;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    pointer-events: all;\n    z-index: 0;\n    min-width: calc(100% / 12);\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var EmptyColumn = (0,styled_components_browser_esm/* css */.iv)(_templateObject(), colors/* default.util.gray.base */.ZP.util.gray.base, flex_styles/* CenterCenter */.IV, DropZone_style/* DropZone */.r);
var ItemColumn = (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), function(props) {
    return props.childs === 0 && !(props === null || props === void 0 ? void 0 : props.production) ? EmptyColumn : "";
});


// EXTERNAL MODULE: ./src/mosanic/core/Map/Styles/Item.wrapper.styles.js
var Item_wrapper_styles = __webpack_require__(71367);
;// CONCATENATED MODULE: ./src/mosanic/core/Map/Styles/Columns.styles.js

function Columns_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin-left: 0;\n    margin-right: 0;\n    width: 100%;\n    cursor: initial;\n    pointer-events: all;\n    \n    &:hover {\n        /* cursor: pointer; */\n\n        ",
        " {\n            opacity: 0.2;\n\n            &:hover {\n                margin-top: -20px;\n                transform: scale(1);\n                opacity: 1;\n            }\n        }\n    }    \n"
    ]);
    Columns_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ItemColumns = (0,styled_components_browser_esm/* css */.iv)(Columns_styles_templateObject(), Item_wrapper_styles/* default.RowAdd */.Z.RowAdd);


// EXTERNAL MODULE: ./src/mosanic/core/Map/Styles/parseAttr.js
var parseAttr = __webpack_require__(59986);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/mosanic/core/Map/Styles/styleUtils.js
var styleUtils = __webpack_require__(11358);
// EXTERNAL MODULE: ./src/mosanic/core/Map/Styles/selectors.js
var selectors = __webpack_require__(29613);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
;// CONCATENATED MODULE: ./src/mosanic/core/Map/Styles/parseDisplayAttr.js







var flexBoxAttr = {
    direction: "flex-direction",
    align: "align-items",
    justify: "justify-content",
    wrap: "flex-wrap",
    reverse: "reverse"
};
var getFlexAttr = function(attr, value) {
    var direction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "column";
    if (attr === "direction") {
        value = value === "vertical" ? "column" : "row";
    }
    if (attr === "align" && ![
        "stretch",
        "baseline",
        "center"
    ].includes(value)) {
        value = "flex-".concat(value);
    }
    if (attr === "justify") {
        if ([
            "around",
            "between"
        ].includes(value)) {
            value = "space-".concat(value);
        } else if (value === "center") {} else {
            value = "flex-".concat(value);
        }
    }
    if (attr === "reverse") {
        if (!value) return;
        attr = "direction";
        value = "".concat(direction, "-reverse");
    }
    // console.log(attr)
    if (attr === "wrap") {
        if (!value || value === 0) return;
        value = "wrap";
    }
    return (0,selectors/* getAttr */.UK)(flexBoxAttr[attr], value);
};
var parseDisplayAttr = function(data, validate) {
    var base = "\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        flex-wrap: nowrap;\n\n    ";
    //Stored direction for applying reverse
    var storeDir = "column", direction = "";
    //Loop trough attributes 
    //Display: --> Attribute = FlexDirection: Variants
    if ((0,Obj/* hasAttr */.B$)(data, "wrap")) {
        if ((data === null || data === void 0 ? void 0 : data.wrap) === 1) base += "flex-wrap: wrap;";
    // data = {...data, wrap: undefined}
    // console.log(data)
    }
    Object.entries(data).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), attribute = _param[0], variants = _param[1];
        var attr = function(value) {
            return getFlexAttr(attribute, value, storeDir);
        };
        var handleValue = function(variant, value) {
            var received = (0,styleUtils/* default */.ZP)({
                variant: variant,
                value: value,
                attr: attr,
                validate: validate
            });
            if (attribute === "direction") {
                direction = value;
                storeDir = (0,Text/* replacePart */.bA)((0,Text/* removeLastChar */.Nn)(received), "flex-direction: ", "");
            }
            return received;
        };
        base += (0,parseAttr/* default */.ZP)({
            data: variants,
            attrName: null,
            validate: validate,
            type: null,
            custom: handleValue
        });
    // Object.entries(variants).map(([variant, value]) => {
    //     if(value && variant){
    //         const received = getValues({
    //             variant, 
    //             value, 
    //             attr, 
    //             validate
    //         });
    //         base += received;
    //     }
    // })
    });
    if (data) {
        if (direction === "horizontal") {
            base += "& > ".concat(DropZone_style/* DropZone */.r, " { \n                max-width: 2%;\n                min-height: 25px;\n                top: 0;\n                bottom: 0;\n                height: 100%;\n                min-height: 100%;\n                margin: 0 -1%;\n                // position: absolute;\n            }");
        } else {
            base += "& > ".concat(DropZone_style/* DropZone */.r, " { \n                width: 100%;\n                left: 0;\n                right: 0;\n                min-height: 25px;\n                height: 25px;\n                min-width: 100%;\n\n                margin: -12.5px 0;\n                // position: absolute;\n            }");
        }
    }
    return base;
};
/* harmony default export */ var Styles_parseDisplayAttr = (parseDisplayAttr);

;// CONCATENATED MODULE: ./src/mosanic/core/Map/Styles/Item.styles.js

function Item_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " display: none; "
    ]);
    Item_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Item_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n            ",
        "\n        "
    ]);
    Item_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "position:relative;"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        background-image: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        background-size: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        ",
        "\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        background-repeat: ",
        ";\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        ",
        " \n        * {\n            ",
        " \n        }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " display: none; "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n\n\n    ",
        "\n    ",
        "\n    ",
        "\n \n    ",
        "\n    \n\n    ",
        "\n    ",
        "\n\n    \n    ",
        "\n\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n    ",
        "\n    ",
        "\n\n\n    ",
        "\n\n    ",
        " \n    \n     ",
        "\n    \n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n \n    ",
        "\n    \n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        max-width: ",
        ";\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    ",
        "\n    margin: 0 auto;\n    overflow: hidden;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  ",
        "\n  pointer-events: auto;\n  position: relative;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}









// const getTextAlign = (variant, value) => css`text-align: ${value}; * { text-align: ${value}; }`
var getTextColor = function(variant, value, validate) {
    var ref, ref1;
    var styles = "";
    if (value === null || value === void 0 ? void 0 : value.color) {
        var color = (0,styleUtils/* getParsedValue */.Pi)({
            value: value.color,
            type: "color"
        }, validate);
        styles += "color: ".concat(color, "; svg path { fill: ").concat(color, "; }");
    }
    /* color: ${value.gradient?.colors[0]?.color}; */ if (value === null || value === void 0 ? void 0 : value.gradient) styles += "\n        background: ".concat(value === null || value === void 0 ? void 0 : (ref = value.gradient) === null || ref === void 0 ? void 0 : ref.value, ";\n        background-clip: text;\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n    ; * {\n        background: ").concat(value === null || value === void 0 ? void 0 : (ref1 = value.gradient) === null || ref1 === void 0 ? void 0 : ref1.value, ";\n        background-clip: text;\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n    \n    }");
    return (0,Text/* oneLineString */.r6)(styles);
};
var getVisibility = function(variant, validate) {
    return validate.breakpoint === variant ? (0,styled_components_browser_esm/* css */.iv)(Item_styles_templateObject()) : "";
};
var getObjectFit = function(variant, value) {
    return "object-fit: ".concat(value, "!important;}");
};
var getBackgroundImg = function(image) {
    if ((image === null || image === void 0 ? void 0 : image.urlMin) && (image === null || image === void 0 ? void 0 : image.url)) {
        return 'image-set(\n            url("'.concat((0,host/* getImageUrl */.Jn)(image === null || image === void 0 ? void 0 : image.urlMin), '") 1x,\n            url("').concat((0,host/* getImageUrl */.Jn)(image === null || image === void 0 ? void 0 : image.url), '") 2x\n        )');
    }
    return "url(".concat((0,host/* getImageUrl */.Jn)(image), ")");
};
var getBackgroundSize = function(bg) {
    if ((bg === null || bg === void 0 ? void 0 : bg.size) === "percentage") return (bg === null || bg === void 0 ? void 0 : bg.sizeValue) ? bg.sizeValue : "1250%";
    return (bg === null || bg === void 0 ? void 0 : bg.size) ? bg.size : "cover";
};
var getTransition = function(transition) {
    var property = (transition === null || transition === void 0 ? void 0 : transition.target) ? transition.target : "all";
    var timing = (transition === null || transition === void 0 ? void 0 : transition.curve) === "custom" ? "cubic-bezier(".concat((0,Text/* combineString */.M7)(transition === null || transition === void 0 ? void 0 : transition.bezier, ","), ")") : (transition === null || transition === void 0 ? void 0 : transition.curve) ? transition.curve : "ease-in-out";
    var duration = (transition === null || transition === void 0 ? void 0 : transition.duration) ? transition.duration : "0.3s";
    var base = "transition: ".concat(duration, " ").concat(property, ";");
    base += "transition-timing: ".concat(timing, ";");
    if (transition === null || transition === void 0 ? void 0 : transition.delay) {
        base += "transition-delay: ".concat(transition.delay, ";");
    }
    return base;
};
var ItemStyle = function(type) {
    var production = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    switch(type){
        case "columns":
            return ItemColumns;
        case "column":
            return (0,styled_components_browser_esm/* css */.iv)(Item_styles_templateObject1(), ItemColumn);
        case "image":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
    }
};
var ParseStyle = function(data, validate) {
    var production = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref, ref1, ref2, ref3, ref4, ref5;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), !production && "cursor: pointer;", (data === null || data === void 0 ? void 0 : data.sizing) && (0,parseAttr/* parseAttrGroup */.yv)({
        data: data.sizing,
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.padding) && (0,parseAttr/* parseAttrGroup */.yv)({
        data: data.padding,
        before: "padding",
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.margin) && (0,parseAttr/* parseAttrGroup */.yv)({
        data: data.margin,
        before: "margin",
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.docking) && (0,parseAttr/* parseAttrGroup */.yv)({
        data: data.docking,
        log: true,
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.corner) && (0,parseAttr/* parseAttrGroup */.yv)({
        data: data.corner,
        before: "border",
        extend: "radius",
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.cursor) && (0,parseAttr/* default */.ZP)({
        data: data.cursor,
        attrName: (0,styleUtils/* getAttrSelector */.Q1)("cursor"),
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.zIndex) && (0,parseAttr/* default */.ZP)({
        data: data.zIndex,
        attrName: (0,styleUtils/* getAttrSelector */.Q1)("z-index"),
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.position) && (0,parseAttr/* default */.ZP)({
        data: data.position,
        attrName: (0,styleUtils/* getAttrSelector */.Q1)("position"),
        type: "position",
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.gradient) && (0,parseAttr/* default */.ZP)({
        data: data.gradient,
        attrName: "background",
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.display) && Styles_parseDisplayAttr(data.display, validate), (data === null || data === void 0 ? void 0 : data.grid) && (0,parseAttr/* parseGridAttr */.jA)(data.grid, validate), (data === null || data === void 0 ? void 0 : data.background) && (0,parseAttr/* default */.ZP)({
        data: data.background,
        attrName: "background",
        type: "color",
        validate: validate
    }), (data === null || data === void 0 ? void 0 : (ref = data.bg) === null || ref === void 0 ? void 0 : ref.position) && (0,parseAttr/* default */.ZP)({
        data: data.bg.position,
        attrName: "background-position",
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.image) && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), getBackgroundImg(data === null || data === void 0 ? void 0 : data.image)), ((data === null || data === void 0 ? void 0 : (ref1 = data.bg) === null || ref1 === void 0 ? void 0 : ref1.size) || (data === null || data === void 0 ? void 0 : (ref2 = data.bg) === null || ref2 === void 0 ? void 0 : ref2.sizeValue)) && (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), getBackgroundSize(data === null || data === void 0 ? void 0 : data.bg)), (data === null || data === void 0 ? void 0 : data.transition) && (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), getTransition(data.transition)), (data === null || data === void 0 ? void 0 : (ref3 = data.bg) === null || ref3 === void 0 ? void 0 : ref3.repeat) && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), data === null || data === void 0 ? void 0 : (ref4 = data.bg) === null || ref4 === void 0 ? void 0 : ref4.repeat), (data === null || data === void 0 ? void 0 : data.textColor) && (0,parseAttr/* default */.ZP)({
        data: data.textColor,
        attrName: "color",
        type: "color",
        validate: validate,
        custom: function(variant, value) {
            return getTextColor(variant, value, validate);
        }
    }), (data === null || data === void 0 ? void 0 : data.hidden) && (0,parseAttr/* default */.ZP)({
        data: data.hidden,
        attrName: (0,styleUtils/* getAttrSelector */.Q1)("display"),
        custom: function(variant) {
            return getVisibility(variant, validate);
        },
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.objectFit) && (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), (0,parseAttr/* default */.ZP)({
        data: data.objectFit,
        attrName: (0,styleUtils/* getAttrSelector */.Q1)("object-fit"),
        // custom: (variant, value) => getObjectFit(variant, value),
        validate: validate
    }), (0,parseAttr/* default */.ZP)({
        data: data.objectFit,
        attrName: (0,styleUtils/* getAttrSelector */.Q1)("object-fit"),
        custom: function(variant, value) {
            return getObjectFit(variant, value);
        },
        validate: validate
    })), (data === null || data === void 0 ? void 0 : (ref5 = data.hidden) === null || ref5 === void 0 ? void 0 : ref5.all) && (0,styled_components_browser_esm/* css */.iv)(_templateObject8()), (data === null || data === void 0 ? void 0 : data.font) && (0,parseAttr/* parseLetterAttrGroup */.cV)({
        data: data.font,
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.border) && (0,parseAttr/* parseBorderAttrGroup */.pI)({
        data: data.border,
        validate: validate
    }), (data === null || data === void 0 ? void 0 : data.transform) && (0,parseAttr/* parseTransformAttrGroup */.Kn)({
        data: data.transform,
        type: "transform",
        validate: validate
    }));
};
var Component = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f000f68e-0"
})(_templateObject11(), function(props) {
    return ItemStyle(props.type, props === null || props === void 0 ? void 0 : props.production);
}, function(props) {
    return ParseStyle(props.data, props.validate, props === null || props === void 0 ? void 0 : props.production);
}, function(props) {
    var ref;
    return (props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.css) && (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), props.data.css);
});
/**
 * ! Wrappers
 */ var ColWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f000f68e-1"
})(_templateObject13(), function(props) {
    return props.offset && (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), "calc(100% - ".concat(props.offset * 3, "px)"));
});
var Columns = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f000f68e-2"
})(_templateObject14(), flex_styles/* RowWrap */.xv);
var ItemStyles = {
    ColWrapper: ColWrapper,
    Columns: Columns
};
/* harmony default export */ var Item_styles = (ItemStyles);


/***/ }),

/***/ 71367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RowAdd */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2921);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26021);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    z-index: 9;\n    transform: scale(0.6);\n    transform-origin: center bottom;\n    position: absolute;\n    margin-top: -10px;\n    left: calc(50% - 30px);\n    transition: all ease-in-out 0.3s;\n    opacity: 0;\n    text-align:center;\n    width: 60px;\n    background: none;\n    height: 0px;\n    border: none!important;\n    .trigger {\n        border: none;\n        background: none!important;\n    }\n    span.add {\n        transition: all ease-in-out 0.3s;\n        background: ",
        ";\n        color: #fff;\n        height: 35px;\n        width: 35px;\n        line-height: 10px;\n        border-radius: 50%;\n        padding: 6px 8px;\n        font-weight: bold;\n        font-size: 14px;\n\n        &:hover {\n            background: ",
        ";\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var RowAdd = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-5d3c1876-0"
})(_templateObject(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light.primary */ .ZP.light.primary, _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.primary.dark */ .ZP.util.primary.dark);
var ItemWrapperStyles = {
    RowAdd: RowAdd
};
/* harmony default export */ __webpack_exports__["Z"] = (ItemWrapperStyles);


/***/ }),

/***/ 60354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ LayerLabel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2921);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8782);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26021);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  color: ",
        ";\n  border: 1px solid ",
        ";\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  color: #000;\n  border: 1px dashed ",
        ";\n  border-left-style: solid;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n       ",
        "\n       svg {\n        opacity: 0.7;\n        path {\n          color: #000;\n        }\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n      svg {\n        opacity: 1;\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n\n    /* color: ",
        "; */\n    opacity: ",
        ";\n    transition: all ease-in-out 0.15s;\n    cursor: pointer;\n    text-transform: capitalize;\n    font-size: 12px;\n    -webkit-font-smoothing: antialiased;\n    padding: 2.5px 0 5px 5px;\n    border: 1px solid rgba(0,0,0,0);\n    /* border: 1px solid red; */\n    margin-bottom: 2.5px;\n\n    svg {\n      margin: 0 5px 2.5px 0;\n      opacity: 0.2;\n    }\n    :hover {\n      ",
        "\n    }\n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    height: 5px;\n    max-height: 5px;\n    left: 0!important;\n    right: 0;\n    position: absolute!important;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    border-left: 1px solid rgba(0,0,0,0.4);\n    /* border-top: 1px solid rgba(0,0,0,0.4); */\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  position: relative;\n  margin-left: ",
        ";\n  /* border-left: 1px solid rgba(0,0,0,0.2); */\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    /* border: 1px solid; */\n    /* border-top: none; */\n    /* border-right: none; */\n    /* border-color: ",
        "; */\n    padding-right: ",
        ";\n    margin-left: ",
        ";\n    /* margin-bottom: 10px; */\n    \n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var inspectedStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.primary.dark */ .ZP.util.primary.dark, _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.primary.dark */ .ZP.util.primary.dark, _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.primary.lightest */ .ZP.util.primary.lightest);
var hoverStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.primary.base */ .ZP.util.primary.base);
var Label = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3a61ca05-0"
})(_templateObject4(), function(props) {
    return props.isOpen ? "#111" : "#999";
}, function(props) {
    return props.isOpen ? "1" : "0.6";
}, hoverStyle, function(props) {
    return props.hovered && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), hoverStyle);
}, function(props) {
    return props.active && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), inspectedStyle);
});
var DropZone = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3a61ca05-1"
})(_templateObject5());
var Layer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3a61ca05-2"
})(_templateObject7(), function(props) {
    return (props.level - 1) * 10 + "px";
}, function(props) {
    return props.hasChildren && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6());
});
var Render = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3a61ca05-3"
})(_templateObject8(), function(props) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_4__/* .darken */ ._j)(props.level / 20, "#eee");
}, function(props) {
    return props.level * 5 + "px";
}, function(props) {
    return props.level * 5 + "px";
});
var LayerLabel = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Layer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, other), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
            children: children
        })
    }));
};
var LayerStyles = {
    Label: Label,
    Layer: Layer,
    Render: Render,
    DropZone: DropZone
};
/* harmony default export */ __webpack_exports__["Z"] = (LayerStyles);


/***/ }),

/***/ 59986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kn": function() { return /* binding */ parseTransformAttrGroup; },
/* harmony export */   "cV": function() { return /* binding */ parseLetterAttrGroup; },
/* harmony export */   "jA": function() { return /* binding */ parseGridAttr; },
/* harmony export */   "np": function() { return /* binding */ getAttrGroup; },
/* harmony export */   "pI": function() { return /* binding */ parseBorderAttrGroup; },
/* harmony export */   "yv": function() { return /* binding */ parseAttrGroup; }
/* harmony export */ });
/* unused harmony export getInspectAttr */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66383);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68311);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29613);
/* harmony import */ var _styleUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11358);








// ? Inspector data
//Get attr group data for inspectors
var getAttrGroup = function(data, validate) {
    if (!data) return null;
    var base = {};
    data = (0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .removeSmallerBpsFromData */ .V3)(data, validate);
    Object.entries(data).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), attribute = _param[0], variants = _param[1];
        base = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, base), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, attribute, getInspectAttr(variants, validate, attribute)));
    });
    return base;
};
//Get current breakpoint (if exists) from data
var getInspectAttr = function(data, validate) {
    return (0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .containsValue */ .an)(data, validate.breakpoint) ? data[validate.breakpoint] : data.base;
};
// ? Styling data
/** 
 * * Parse attribute group
* @param data object: { attr: data, attr2: data, ...}
* @param validate useValidate object
*
* @param before? string prepend css selector
* @param extend? string append css selector
*/ var parseAttrGroup = function(param) {
    var data = param.data, validate = param.validate, _before = param.before, before = _before === void 0 ? null : _before, _extend = param.extend, extend = _extend === void 0 ? null : _extend, _type = param.type, type = _type === void 0 ? "metric" : _type, _log = param.log, log = _log === void 0 ? false : _log;
    var base = "";
    Object.entries(data).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), attribute = _param[0], variants = _param[1];
        base += parseAttr({
            data: variants,
            attrName: (0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .getAttrSelector */ .Q1)(attribute, before, extend),
            validate: validate,
            type: type
        });
    });
    return base;
};
var getTextAlign = function(variant, value) {
    return "text-align: ".concat(value, "; * { text-align: ").concat(value, "; }");
};
var getLineHeight = function(value) {
    return "line-height: ".concat((0,_util_Text__WEBPACK_IMPORTED_MODULE_5__/* .hasOnlyNumbers */ .io)(value) ? "".concat(value, "px") : value, ";");
};
var getLetterSpacing = function(value) {
    return "letter-spacing: ".concat((0,_util_Text__WEBPACK_IMPORTED_MODULE_5__/* .hasOnlyNumbers */ .io)(value) ? "".concat(value, "px") : value, ";");
};
var getFontStyle = function(value) {
    return "font-style:".concat(value, "!important;");
};
var getFontTransform = function(value) {
    return "text-transform:".concat(value, "!important;");
};
var getFontSize = function(value) {
    return "font-size:".concat(value, "px!important;");
};
var parseLetterAttrGroup = function(param) {
    var data = param.data, validate = param.validate;
    var base = "";
    // Object.entries(data).map(([attribute, variants]) => {
    //     base += parseAttr({
    //         data: variants, 
    //         attrName: getAttrSelector(attribute, before, extend), 
    //         custom: (variant, value) => getTextAlign(variant, value),
    //         validate,
    //     });
    // });
    if (data === null || data === void 0 ? void 0 : data.textAlign) base += parseAttr({
        data: data.textAlign,
        attrName: "text-align",
        custom: function(variant, value) {
            return getTextAlign(variant, value);
        },
        validate: validate
    });
    if (data === null || data === void 0 ? void 0 : data.lineHeight) base += parseAttr({
        data: data.lineHeight,
        attrName: "line-height",
        custom: function(variant, value) {
            return getLineHeight(value);
        },
        validate: validate
    });
    if (data === null || data === void 0 ? void 0 : data.letterSpacing) base += parseAttr({
        data: data.letterSpacing,
        attrName: "letter-spacing",
        custom: function(variant, value) {
            return getLetterSpacing(value);
        },
        validate: validate
    });
    if (data === null || data === void 0 ? void 0 : data.style) base += parseAttr({
        data: data.style,
        attrName: "font-style",
        custom: function(variant, value) {
            return getFontStyle(value);
        },
        validate: validate
    });
    if (data === null || data === void 0 ? void 0 : data.size) base += parseAttr({
        data: data.size,
        attrName: "font-size",
        custom: function(variant, value) {
            return getFontSize(value);
        },
        validate: validate
    });
    if (data === null || data === void 0 ? void 0 : data.transform) base += parseAttr({
        data: data.transform,
        attrName: "text-transform",
        custom: function(variant, value) {
            return getFontTransform(value);
        },
        validate: validate
    });
    return base;
};
var parseBorderAttrGroup = function(param) {
    var data = param.data, validate = param.validate;
    var base = "";
    Object.entries(data).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), attribute = _param[0], variants = _param[1];
        // const meta = getBorderMeta(attribute);
        base += parseAttr({
            data: variants,
            attrName: (0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .getAttrSelector */ .Q1)("border", null, attribute),
            validate: validate,
            type: attribute
        });
    });
    return base;
};
var parseTransformAttrGroup = function(param) {
    var data = param.data, validate = param.validate;
    var base = "";
    Object.entries(data).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), attribute = _param[0], variants = _param[1];
        // const meta = getBorderMeta(attribute);
        base += parseAttr({
            data: variants,
            attrName: "transform",
            validate: validate,
            type: "transform"
        });
    });
    return base;
};
//Parse pre-defined and validated attributes
var parseControlledAttr = function(param) {
    var map = param.map, base = param.base, data = param.data, append = param.append;
    if (!(map === null || map === void 0 ? void 0 : map.length)) return [
        data,
        base
    ];
    map === null || map === void 0 ? void 0 : map.map(function(variant) {
        if (!(0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .containsValue */ .an)(data, variant)) return;
        //Add data
        base += append(variant, data[variant]);
        //Rmv handled breakpoint
        data = (0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .removeVariantFromData */ .Uw)(data, variant);
    });
    return [
        data,
        base
    ];
};
/** 
 * * Parse single attribute
 * @param data object: { xs: data model, md: data model, ...}
 * @param attrName string
 * @param validate useValidate object
 * @param type string getValue type
 */ var parseAttr = function(param) {
    var data = param.data, attrName = param.attrName, validate = param.validate, _type = param.type, type = _type === void 0 ? null : _type, _custom = param.custom, custom = _custom === void 0 ? null : _custom;
    var base = "";
    var append = function(variant, value) {
        return custom ? custom(variant, value) : (0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
            variant: variant,
            value: (0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .getParsedValue */ .Pi)({
                value: value,
                type: type
            }, validate),
            attr: function(value) {
                return (0,_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getAttr */ .UK)(attrName, value);
            },
            validate: validate
        });
    };
    //Handle base first
    if ((0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .containsValue */ .an)(data, "base")) {
        base = append("base", data.base);
        data = (0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .removeVariantFromData */ .Uw)(data, "base");
    }
    //Remove non rendered breakpoints for dev
    if (!(validate === null || validate === void 0 ? void 0 : validate.prod)) {
        data = (0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .removeSmallerBpsFromData */ .V3)(data, validate);
    }
    var ref;
    ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(parseControlledAttr({
        map: validate === null || validate === void 0 ? void 0 : validate.ids,
        base: base,
        data: data,
        append: append
    }), 2), data = ref[0], base = ref[1], ref;
    var ref1;
    ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(parseControlledAttr({
        map: validate === null || validate === void 0 ? void 0 : validate.interactions,
        base: base,
        data: data,
        append: append
    }), 2), data = ref1[0], base = ref1[1], ref1;
    //Parse other data attributes
    Object.entries(data).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), variant = _param[0], value = _param[1];
        if (!value || !variant) return;
        base += append(variant, value);
    });
    return base;
};
// parse column grid 
var parseGridAttr = function(data, validate) {
    var base = (0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .getParsedValue */ .Pi)({
        value: "base",
        type: "grid"
    });
    validate.ids.map(function(id) {
        if ((0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .containsValue */ .an)(data, id)) base += (0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
            variant: id,
            value: data[id],
            attr: function(value) {
                return (0,_styleUtils__WEBPACK_IMPORTED_MODULE_0__/* .getParsedValue */ .Pi)({
                    value: value,
                    type: "grid"
                });
            },
            validate: validate
        });
    });
    return base;
};

/* harmony default export */ __webpack_exports__["ZP"] = (parseAttr);


/***/ }),

/***/ 29613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BC": function() { return /* binding */ media; },
/* harmony export */   "EW": function() { return /* binding */ interact; },
/* harmony export */   "UK": function() { return /* binding */ getAttr; }
/* harmony export */ });
var interact = function(variant) {
    return ":".concat(variant);
};
var media = function(variant, bps) {
    var ref;
    return "@media ".concat((ref = bps[variant]) === null || ref === void 0 ? void 0 : ref.selector);
};
var attr = function(attr, value) {
    return "".concat(attr, ": ").concat(value, ";");
};
var getAttr = attr;



/***/ }),

/***/ 11358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G$": function() { return /* binding */ parseTransform; },
/* harmony export */   "Pi": function() { return /* binding */ getParsedValue; },
/* harmony export */   "Q1": function() { return /* binding */ getAttrSelector; },
/* harmony export */   "Uw": function() { return /* binding */ removeVariantFromData; },
/* harmony export */   "V3": function() { return /* binding */ removeSmallerBpsFromData; },
/* harmony export */   "an": function() { return /* binding */ containsValue; }
/* harmony export */ });
/* unused harmony export getInspectValues */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62570);
/* harmony import */ var _util_Round__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82261);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68311);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29613);







var COL_WIDTH = 100 / 12;
// ? Validation 
//Validate if property exists and has value
var containsValue = function(data, variant) {
    return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_0__/* .hasAttr */ .B$)(data, variant) && (data === null || data === void 0 ? void 0 : data[variant]);
};
// ? Helpers
var splitVariant = function(variant) {
    return variant.split(/(<![:(]):/);
}; //variant.split(/(?<![:(]):/);
//Get css selector for attr 
var getAttrSelector = function(attr, before, extend) {
    var parsed = (0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .cssSelector */ .Yg)(attr);
    if (before) parsed = "".concat(before, "-").concat(parsed);
    if (extend) parsed = "".concat(parsed, "-").concat(extend);
    return parsed;
};
//Transform parser
var value = function(val) {
    var fb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, metric = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "px", times = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 100;
    return "".concat((val ? val : fb) * times).concat(metric);
};
var skewValue = function(val) {
    return value(val, 0, "deg", 90);
};
var translate = function(move) {
    return (move === null || move === void 0 ? void 0 : move.x) || (move === null || move === void 0 ? void 0 : move.y) ? "translate(".concat(value(move === null || move === void 0 ? void 0 : move.x), ", ").concat(value(move === null || move === void 0 ? void 0 : move.y), ")") : "";
};
var skew = function(skew) {
    return (skew === null || skew === void 0 ? void 0 : skew.x) || (skew === null || skew === void 0 ? void 0 : skew.y) ? "skew(".concat(skewValue(skew === null || skew === void 0 ? void 0 : skew.x), ", ").concat(skewValue(skew === null || skew === void 0 ? void 0 : skew.y), ")") : "";
};
var rotate = function(rotate) {
    return (rotate === null || rotate === void 0 ? void 0 : rotate.deg) ? "rotate(".concat(rotate.deg * 180, "deg)") : "";
};
var scale = function(scale) {
    return (scale === null || scale === void 0 ? void 0 : scale.percent) ? "scale(".concat(scale.percent >= 0 ? scale.percent + 1 : 1 - Math.abs(scale.percent), ")") : "";
};
var parseTransform = function(props) {
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .oneLineString */ .r6)("\n    ".concat(translate(props === null || props === void 0 ? void 0 : props.move), " \n    ").concat(rotate(props === null || props === void 0 ? void 0 : props.rotate), "\n    ").concat(scale(props === null || props === void 0 ? void 0 : props.scale), " \n    ").concat(skew(props === null || props === void 0 ? void 0 : props.skew), " \n"));
};
//Parse and get potential metric values     //! change to validate CmpCntnr34459cb8a1f
var getParsedValue = function(param, validate) {
    var value = param.value, type = param.type;
    if (type === "metric") {
        if ((0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .containsSubstr */ .xX)(value, "vw")) return validate.vw(value);
        if ((0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .containsSubstr */ .xX)(value, "vh")) return validate.vh(value);
        if (value === "contain") return "fit-content";
        if (value === "stretch") return "100%";
        if ((0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .isStartSubString */ .ze)(value, "--")) return "var(--".concat(value, ")");
    }
    if (type === "object-fit") {
        return "object-fit: ".concat(value, "; ");
    }
    if (type === "grid") {
        if (value === "base") return "min-width: ".concat((0,_util_Round__WEBPACK_IMPORTED_MODULE_2__/* .roundPrecise */ .FK)(COL_WIDTH, 3), "%;");
        var roundedWidth = (0,_util_Round__WEBPACK_IMPORTED_MODULE_2__/* .roundPrecise */ .FK)(value * COL_WIDTH, 3);
        return "width: ".concat(roundedWidth, "%; \n max-width:").concat(roundedWidth, "%;");
    }
    if (type === "color" && (validate === null || validate === void 0 ? void 0 : validate.color)) {
        return (value === null || value === void 0 ? void 0 : value.hue) && (value === null || value === void 0 ? void 0 : value.shade) ? validate.color(value.hue, value.shade) : (value === null || value === void 0 ? void 0 : value.rgb) ? "rgba(".concat((0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .combineString */ .M7)(Object.values(value.rgb), ","), ")") : (value === null || value === void 0 ? void 0 : value.hex) ? value.hex : value;
    }
    if (type === "position") {
        return value === "fixed" && !(validate === null || validate === void 0 ? void 0 : validate.prod) ? "sticky" : value;
    }
    if (type === "width") {
        return "".concat(value, "px");
    }
    if (type === "transform") {
        return parseTransform(value);
    }
    return (value === null || value === void 0 ? void 0 : value.value) ? value.value : value;
};
//Get correct values of passed variant
var getValues = function(param) {
    var variant = param.variant, value = param.value, attr = param.attr, validate = param.validate;
    var base = "";
    //Initial styling
    if (variant === "base") {
        base += attr(value);
    } else if ((validate === null || validate === void 0 ? void 0 : validate.media(variant)) || (validate === null || validate === void 0 ? void 0 : validate.overwrite(variant, "breakpoint"))) {
        if (validate.prod) base += "".concat((0,_selectors__WEBPACK_IMPORTED_MODULE_3__/* .media */ .BC)(variant, validate === null || validate === void 0 ? void 0 : validate.bps), "{");
        base += "".concat(attr(value, variant === (validate === null || validate === void 0 ? void 0 : validate.breakpoint)));
        if (validate.prod) base += "}";
    // if(isPreviewMedia(variant, preview)){
    //     base += attr( `${value}!important` );
    // }
    } else if ((validate === null || validate === void 0 ? void 0 : validate.variant(variant)) || (validate === null || validate === void 0 ? void 0 : validate.overwrite(variant, "variant"))) {
        base += attr(value + "!important");
    // if(isPreviewVariant(variant, preview)){
    //     base += attr( `${value}!important` );
    // }
    } else if ((validate === null || validate === void 0 ? void 0 : validate.interact(variant)) || (validate === null || validate === void 0 ? void 0 : validate.overwrite(variant, "state"))) {
        base += "".concat((0,_selectors__WEBPACK_IMPORTED_MODULE_3__/* .interact */ .EW)(variant), "{ ").concat(attr(value), " }");
    // if(isPreviewInteract(variant, preview)) {
    //     base += attr(value);
    // }
    } else {
        //TODO --> fix combined
        // console.log(variant)
        //
        var split = splitVariant(variant);
        // console.log(validate.ids, validate.ids.includes(split[0]), split[0])
        if ((validate === null || validate === void 0 ? void 0 : validate.media(split[0])) && validate.ids.includes(split[0])) {
            if (validate.prod) base += "".concat((0,_selectors__WEBPACK_IMPORTED_MODULE_3__/* .media */ .BC)(split[0], validate === null || validate === void 0 ? void 0 : validate.bps), "{");
            base += getValues({
                variant: split[1],
                value: value,
                attr: attr,
                validate: validate
            });
            if (validate.prod) base += "}";
        }
    // // console.log(combined)
    // console.log(base)
    // let combinedValue = ``;
    // let cState = {
    //     media: false,
    //     variant: false,
    //     interact: false,
    // };
    // combined.map(part => {
    //     if(isMedia(part, preview, bps)) cState = {...cState, media: part}
    //     if(isVariant(part, preview, state)) cState = {...cState, variant: part}
    //     if(isInteract(part, preview)) cState = {...cState, interact: part}
    // })
    // // console.log(base)
    // //open parts
    // if(cState.media) base+= `${media(cState.media, bps)}{`
    // if(cState.interact) base += `${interact(cState.interact)}{`
    // base += attr(value)
    // if(cState.interact) base += `}`;
    // if(cState.media) base += `}`;
    // console.log(base)
    // base += 
    // console.log(cState)
    // console.log(state)
    }
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .oneLineString */ .r6)(base);
};
var getInspectValues = function(variant, value, validate) {
    var base;
    //Initial styling
    if (variant === "base") {
        base = value;
    } else if (validate.overwrite(variant, "breakpoint")) {
        // base += `${media(variant, validate?.bps)}{ 
        //     ${attr(value, variant === validate?.breakpoint)}
        // }`;
        base = value;
    } else if (validate.overwrite(variant, "variant")) {
        // base += attr( value+'!important' );
        base = value;
    } else if (validate.overwrite(variant, "state")) {
        // base += `${interact(variant)}{ ${attr(value)} }`;
        base = value;
    } else {
    //TODO --> fix combined
    }
    return base;
};
// ? Removers
var removeVariantFromData = function(data, variant) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, variant, undefined));
};
var removeSmallerBpsFromData = function(data, validate) {
    var ref;
    if (!(validate === null || validate === void 0 ? void 0 : (ref = validate.rmv) === null || ref === void 0 ? void 0 : ref.length)) return data;
    validate.rmv.map(function(bp) {
        data = removeVariantFromData(data, bp);
    });
    return data;
};

/* harmony default export */ __webpack_exports__["ZP"] = (getValues);


/***/ }),

/***/ 65902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Render__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58829);

/* harmony default export */ __webpack_exports__["Z"] = (_Render__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 37676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ DeleteConfirm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92228);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41145);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94233);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99057);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4093);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91639);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47914);
/* harmony import */ var _mosanic_Icons_EditIcons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75679);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26021);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        "\n    user-select: none;\n    font-family: 'Courier New', Courier, monospace;\n    font-weight: bolder;\n    font-size: 12px;\n    vertical-align: middle;\n    padding: 0 4px;\n    position: relative;\n    display: inline-block;\n\n    &::after{\n        content: '';\n        position: absolute;\n        display: inline-block;\n        top: 0;\n        left: 2px;\n        right: 2px;\n        bottom: 0;\n        user-select: none;\n        background: rgba(0,0,0,0.05);\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Value = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].b.withConfig */ .ZP.b.withConfig({
    componentId: "sc-f6ea7c87-0"
})(_templateObject());
var DeleteConfirm = function(param) {
    var action = param.action, _actionState = param.actionState, actionState = _actionState === void 0 ? false : _actionState, _validateLabel = param.validateLabel, validateLabel = _validateLabel === void 0 ? "Site name" : _validateLabel, _validateValue = param.validateValue, validateValue = _validateValue === void 0 ? null : _validateValue, _header = param.header, header = _header === void 0 ? "About to perform a irreversible action." : _header, _message = param.message, message = _message === void 0 ? "" : _message, state = param.state, close = param.close;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), value = ref[0], setValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        setValue("");
    }, [
        state
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        state: state,
        close: close,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("form", {
            style: {
                textAlign: "center"
            },
            onSubmit: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
                    return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                event.preventDefault();
                                action();
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                // await deleteSite(siteId);
                }));
                return function(event) {
                    return _ref.apply(this, arguments);
                };
            }(),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("h2", {
                    children: [
                        "⚠️ ",
                        header
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("p", {
                    style: {
                        maxWidth: "80%",
                        margin: "0 auto 10px"
                    },
                    children: [
                        message,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("br", {}),
                        validateValue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                            children: [
                                "Re-enter ",
                                validateLabel,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    title: "You can't copy this value.",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Value, {
                                        children: validateValue
                                    })
                                }),
                                "to confirm."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_8__/* .InputGroup */ .BZ, {
                    style: {
                        maxWidth: "50%",
                        margin: "0 auto 10px"
                    },
                    children: validateValue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_9__.TextField, {
                        onChange: function(e) {
                            var ref;
                            return setValue((ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                        },
                        value: value,
                        wrap: true,
                        fullWidth: true,
                        type: "text",
                        label: validateLabel,
                        placeholder: validateValue !== null && validateValue !== void 0 ? validateValue : "",
                        pattern: validateValue !== null && validateValue !== void 0 ? validateValue : validateLabel
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_10__.Buttons, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_10__.Button, {
                            type: "button",
                            onClick: close,
                            size: "large",
                            label: "No, Cancel"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_10__.Button, {
                            type: "submit",
                            disabled: validateValue && (actionState || value != validateValue),
                            theme: "orange",
                            children: [
                                _mosanic_Icons_EditIcons__WEBPACK_IMPORTED_MODULE_11__/* .trash */ ._I,
                                " ",
                                actionState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_12__/* .LoadingDots */ .x, {}) : "Yes, Delete"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 2562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ PreviewDynamicPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66383);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64957);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47914);
/* harmony import */ var _mosanic_items_Frames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98900);
/* harmony import */ var _mosanic_utils_Site__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(95048);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25157);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64157);
/* harmony import */ var _Render__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26381);
/* harmony import */ var _mosanic_cms_Query_byId__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62357);












var PreviewDynamicPage = function(param) {
    var pageId = param.pageId, entry = param.entry, baseRoute = param.baseRoute, _links = param.links, links = _links === void 0 ? false : _links;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_5__/* .usePage */ .q)({
        _id: pageId
    }), 2), refreshPage = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ref[1], 3), page = ref1[0], loadingPage = ref1[1], errorPage = ref1[2];
    var siteId = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_6__/* .siteIdSelector */ .uL);
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_mosanic_cms_Query_byId__WEBPACK_IMPORTED_MODULE_7__/* .useGetSite */ .iu)({
        _id: siteId
    }), 1), site = ref2[0];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (pageId) refreshPage({
            _id: pageId
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            errorPage,
            loadingPage ? loadingPage : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items_Frames__WEBPACK_IMPORTED_MODULE_8__/* .ScaledFrame */ .n, {
                border: true,
                float: true,
                children: page && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Render__WEBPACK_IMPORTED_MODULE_9__/* .RenderHeaderFooter */ .VD, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Render__WEBPACK_IMPORTED_MODULE_9__/* .SwitchPageRender */ .dr, {
                        page: page,
                        site: site,
                        entry: entry
                    })
                })
            }),
            links && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_10__.Buttons, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_10__.Button, {
                        ghost: true,
                        label: "Open page",
                        href: (0,_mosanic_utils_Site__WEBPACK_IMPORTED_MODULE_11__/* .siteSlugUrl */ .jY)("page/".concat(page === null || page === void 0 ? void 0 : page._id))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "https://".concat((0,_mosanic_utils_Site__WEBPACK_IMPORTED_MODULE_11__/* .getSiteUrl */ .$2)(site), "/").concat(baseRoute),
                        target: "_blank",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_10__.Button, {
                            ghost: true,
                            label: "View page"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 26381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lf": function() { return /* binding */ FullRelationRender; },
/* harmony export */   "VD": function() { return /* binding */ RenderHeaderFooter; },
/* harmony export */   "XP": function() { return /* binding */ PageRender; },
/* harmony export */   "dr": function() { return /* binding */ SwitchPageRender; }
/* harmony export */ });
/* unused harmony exports useDynamicPage, ClientPageRender */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64957);
/* harmony import */ var _mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8927);
/* harmony import */ var _mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79721);
/* harmony import */ var _mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(17248);
/* harmony import */ var _mosanic_utils_slug__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(38380);
/* harmony import */ var _mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42622);
/* harmony import */ var _mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43970);
/* harmony import */ var _mosanic_cms_Query_byId__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(62357);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(25157);
/* harmony import */ var _redux_pages_reducer__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(80762);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64157);
/* harmony import */ var _Collections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11096);
/* harmony import */ var _Theme__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(77973);
/* harmony import */ var _JSX__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96344);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26021);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5441);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2921);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    border:  1px solid transparent;\n    transition: all ease-in-out 0.3s;\n    > ::after {\n        background: rgba(255,255,255, 0.5);\n        backdrop-filter: blur(2px);\n        ",
        "\n        position: absolute;\n        top: 0;\n        right:0;\n        left: 0;\n        bottom: 0;\n        content: ",
        ";\n        height: 100%;\n        width: 100%;\n        z-index: 9999;\n        transition: all ease-in-out 0.3s;\n        opacity: 0;\n        font-size: 12px;\n    }\n    &:hover {\n        border-color: ",
        ";\n        cursor: pointer;\n        > ::after {\n            opacity: 1;\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var FullRelationRender = function(param) {
    var render = param.render, relation = param.relation, entries = param.entries, _bp = param.bp, bp = _bp === void 0 ? "auto" : _bp;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_Collections__WEBPACK_IMPORTED_MODULE_4__/* .useCollection */ .K)({
        _id: relation
    }, true), 2), getCol = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref[1], 1), collection = ref1[0];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_5__/* .usePage */ .q)({
        _id: render
    }), 2), getPages = ref2[0], ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref2[1], 1), page = ref3[0];
    var getEntry = function(id) {
        var ref;
        return collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.find(function(e) {
            return (e === null || e === void 0 ? void 0 : e._id) === id;
        });
    };
    // relationEnd --> rooms/ beds
    // relationRender --> page 
    // relation is type
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: !Array.isArray(entries) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RelationRender, {
            page: page,
            entry: getEntry(entries === null || entries === void 0 ? void 0 : entries.value),
            bp: bp
        }) : entries === null || entries === void 0 ? void 0 : entries.map(function(r) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RelationRender, {
                page: page,
                entry: getEntry((r === null || r === void 0 ? void 0 : r.value) ? r === null || r === void 0 ? void 0 : r.value : r),
                bp: bp
            });
        })
    });
};
var RelationRender = function(param) {
    var page = param.page, entry = param.entry, bp = param.bp;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_6__/* .RelationProvider */ .r$, {
            data: {
                entry: entry,
                entries: [
                    entry
                ]
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                page: page ? page : null,
                production: true,
                noWrap: true,
                blockSeo: true,
                bp: bp
            })
        })
    });
};
var MainRender = function(param) {
    var page = param.page, entry = param.entry, _bp = param.bp, bp = _bp === void 0 ? "auto" : _bp;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_8__/* .PageProvider */ .Ti, {
        entry: entry,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            page: page ? page : null,
            production: true,
            blockSeo: true,
            bp: bp
        })
    });
};
var InitiateBlock = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7a41710f-0"
})(_templateObject(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_10__/* .CenterCenter */ .IV, function(props) {
    return "'".concat(props.tooltip, "'");
}, _mosanic_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"].util.primary.base */ .ZP.util.primary.base);
var HeaderRender = function(param) {
    var header = param.header, site = param.site, _locale = param.locale, locale = _locale === void 0 ? null : _locale, _seo = param.seo, seo = _seo === void 0 ? null : _seo, _bp = param.bp, bp = _bp === void 0 ? "auto" : _bp, initiate = param.initiate;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_8__/* .HeaderProvider */ .I7, {
        nav: site === null || site === void 0 ? void 0 : site.nav,
        locales: site === null || site === void 0 ? void 0 : site.locales,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_12__/* .ConditionalWrapper */ .M, {
            when: initiate,
            wrapper: function(children) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InitiateBlock, {
                    onClick: function() {
                        return initiate();
                    },
                    tooltip: "Edit header",
                    children: children
                });
            },
            children: header ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                page: header,
                production: true,
                locale: locale,
                seo: seo,
                bp: bp
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_13__/* .Navigation */ .W, {
                nav: site === null || site === void 0 ? void 0 : site.nav,
                url: "/logo/".concat(site === null || site === void 0 ? void 0 : site._id, ".svg"),
                translated: site === null || site === void 0 ? void 0 : site.locales
            })
        })
    });
};
var FooterRender = function(param) {
    var footer = param.footer, site = param.site, _bp = param.bp, bp = _bp === void 0 ? "auto" : _bp, initiate = param.initiate;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_8__/* .FooterProvider */ .FD, {
        nav: site === null || site === void 0 ? void 0 : site.nav,
        locales: site === null || site === void 0 ? void 0 : site.locales,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_12__/* .ConditionalWrapper */ .M, {
                when: initiate,
                wrapper: function(children) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InitiateBlock, {
                        onClick: function() {
                            return initiate();
                        },
                        tooltip: "Edit footer",
                        children: children
                    });
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    page: footer,
                    production: true,
                    blockSeo: true,
                    bp: bp
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Theme__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                themeId: site === null || site === void 0 ? void 0 : site.themeId
            })
        ]
    });
};
var SwitchPageRender = function(param) {
    var page = param.page, site = param.site, _entry = param.entry, entry = _entry === void 0 ? null : _entry;
    return (page === null || page === void 0 ? void 0 : page.type) === "header" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HeaderRender, {
        header: page,
        site: site,
        seo: null
    }) : (page === null || page === void 0 ? void 0 : page.type) === "footer" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterRender, {
        footer: page,
        site: site
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MainRender, {
        page: page,
        entry: entry
    });
};
var useDynamicPage = function(param) {
    var site = param.site;
    var ref = site || {
        header: null,
        footer: null
    }, header = ref.header, footer = ref.footer;
    var home = (0,_mosanic_utils_slug__WEBPACK_IMPORTED_MODULE_15__/* .getIndexPageId */ .Qs)(site, "home");
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_5__/* .usePage */ .q)({
        _id: header
    }), 2), getHeader = ref1[0], ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref1[1], 1), headerPage = ref2[0];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_5__/* .usePage */ .q)({
        _id: footer
    }), 2), getFooter = ref3[0], ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref3[1], 1), footerPage = ref4[0];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_5__/* .usePage */ .q)({
        _id: home
    }), 2), getHome = ref5[0], ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref5[1], 1), homePage = ref6[0];
    var pages = {
        headerPage: headerPage,
        footerPage: footerPage,
        homePage: homePage
    };
    return pages;
};
//Just pass the page or get the home page
var ClientPageRender = function(param) {
    var site = param.site, _page = param.page, page = _page === void 0 ? null : _page, _bp = param.bp, bp = _bp === void 0 ? "auto" : _bp;
    var pages = useDynamicPage({
        site: site
    });
    return /*#__PURE__*/ _jsx(PageRender, {
        bp: bp,
        page: page ? page : pages === null || pages === void 0 ? void 0 : pages.homePage,
        site: site,
        headerPage: pages === null || pages === void 0 ? void 0 : pages.headerPage,
        footerPage: pages === null || pages === void 0 ? void 0 : pages.footerPage
    });
};
var RenderHeaderFooter = function(param) {
    var children = param.children, bp = param.bp, _isDev = param.isDev, isDev = _isDev === void 0 ? false : _isDev;
    var siteId = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_16__/* .siteIdSelector */ .uL);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_mosanic_cms_Query_byId__WEBPACK_IMPORTED_MODULE_17__/* .useGetSite */ .iu)({
        _id: siteId
    }), 1), site = ref[0];
    var type = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_redux_pages_reducer__WEBPACK_IMPORTED_MODULE_18__/* .pageMetaAttrSelector */ .vz)(state, "type");
    });
    var initiate = (0,_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_19__/* .usePageInit */ .a)({});
    var pages = useDynamicPage({
        site: site
    });
    if (type != "page") return children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_6__/* .ModeProvider */ .aJ, {
        data: {
            isDev: isDev
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageRender, {
            bp: bp,
            page: null,
            site: site,
            headerPage: pages === null || pages === void 0 ? void 0 : pages.headerPage,
            footerPage: pages === null || pages === void 0 ? void 0 : pages.footerPage,
            initiate: function(page) {
                return initiate(page);
            },
            children: children
        })
    });
};
//Full custom page render
var PageRender = function(param) {
    var page = param.page, site = param.site, headerPage = param.headerPage, footerPage = param.footerPage, _entry = param.entry, entry = _entry === void 0 ? null : _entry, _locale = param.locale, locale = _locale === void 0 ? null : _locale, _seo = param.seo, seo = _seo === void 0 ? null : _seo, _bp = param.bp, bp = _bp === void 0 ? "auto" : _bp, initiate = param.initiate, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HeaderRender, {
                bp: bp,
                header: headerPage,
                site: site,
                seo: seo,
                locale: locale,
                initiate: initiate ? function() {
                    return initiate(headerPage);
                } : null
            }),
            children ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MainRender, {
                bp: bp,
                page: page,
                entry: entry
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FooterRender, {
                bp: bp,
                footer: footerPage,
                site: site,
                initiate: initiate ? function() {
                    return initiate(footerPage);
                } : null
            })
        ]
    });
};


/***/ }),

/***/ 42622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FW": function() { return /* binding */ DataProvider; },
/* harmony export */   "RC": function() { return /* binding */ useFormProvider; },
/* harmony export */   "RS": function() { return /* binding */ useRepeatProvider; },
/* harmony export */   "RV": function() { return /* binding */ FormProvider; },
/* harmony export */   "UH": function() { return /* binding */ useRelationProvider; },
/* harmony export */   "Zl": function() { return /* binding */ CartProvider; },
/* harmony export */   "aJ": function() { return /* binding */ ModeProvider; },
/* harmony export */   "r$": function() { return /* binding */ RelationProvider; },
/* harmony export */   "s4": function() { return /* binding */ RepeatProvider; },
/* harmony export */   "uk": function() { return /* binding */ useModeProvider; },
/* harmony export */   "x5": function() { return /* binding */ useDataProvider; },
/* harmony export */   "yL": function() { return /* binding */ useCartProvider; }
/* harmony export */ });
/* unused harmony export useCloneProvider */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43505);



var ModeContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var DataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var CartContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var RepeatContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var CloneContext = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext(undefined)));
var RelationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var FormContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var ModeProvider = function(param) {
    var data = param.data, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModeContext.Provider, {
        value: data,
        children: children
    });
};
var DataProvider = function(param) {
    var data = param.data, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DataContext.Provider, {
        value: data,
        children: children
    });
};
var CartProvider = function(param) {
    var data = param.data, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CartContext.Provider, {
        value: data,
        children: children
    });
};
var RepeatProvider = function(param) {
    var data = param.data, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RepeatContext.Provider, {
        value: data,
        children: children
    });
};
var RelationProvider = function(param) {
    var data = param.data, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RelationContext.Provider, {
        value: data,
        children: children
    });
};
var FormProvider = function(param) {
    var data = param.data, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormContext.Provider, {
        value: data,
        children: children
    });
};
var useModeProvider = function() {
    var validate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return (0,_Helpers__WEBPACK_IMPORTED_MODULE_2__/* .useContextHandler */ .k)(ModeContext, "ModeContext", validate);
};
var useDataProvider = function() {
    var validate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return (0,_Helpers__WEBPACK_IMPORTED_MODULE_2__/* .useContextHandler */ .k)(DataContext, "DataContext", validate);
};
var useCartProvider = function() {
    var validate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return (0,_Helpers__WEBPACK_IMPORTED_MODULE_2__/* .useContextHandler */ .k)(CartContext, "DataContext", validate);
};
var useRepeatProvider = function() {
    var validate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return (0,_Helpers__WEBPACK_IMPORTED_MODULE_2__/* .useContextHandler */ .k)(RepeatContext, "RepeatContext", validate);
};
var useCloneProvider = function() {
    var validate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return useContextHandler(CloneContext, "CloneContext", validate);
};
var useRelationProvider = function() {
    var validate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return (0,_Helpers__WEBPACK_IMPORTED_MODULE_2__/* .useContextHandler */ .k)(RelationContext, "RelationContext", validate);
};
var useFormProvider = function() {
    var validate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return (0,_Helpers__WEBPACK_IMPORTED_MODULE_2__/* .useContextHandler */ .k)(FormContext, "FormContext", validate);
};


/***/ }),

/***/ 43505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useContextHandler; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useContextHandler = function(ContextProvider, name) {
    var validate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ContextProvider);
    if (context === undefined && validate) {
        console.warn("".concat(name, " must be used within a ").concat(name, ".Provider"));
    }
    return context;
};


/***/ }),

/***/ 43970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ FooterProvider; },
/* harmony export */   "I7": function() { return /* binding */ HeaderProvider; },
/* harmony export */   "Jv": function() { return /* binding */ useHeaderContext; },
/* harmony export */   "Ti": function() { return /* binding */ PageProvider; },
/* harmony export */   "lO": function() { return /* binding */ usePageContext; }
/* harmony export */ });
/* unused harmony export useFooterContext */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43505);




var PageContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var HeaderContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var FooterContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var PageProvider = function(param) {
    var entry = param.entry, pageData = param.pageData, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageContext.Provider, {
        value: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            entry: entry
        }, pageData),
        children: children
    });
};
var HeaderProvider = function(param) {
    var nav = param.nav, locales = param.locales, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderContext.Provider, {
        value: {
            nav: nav,
            locales: locales
        },
        children: children
    });
};
var FooterProvider = function(param) {
    var nav = param.nav, locales = param.locales, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterContext.Provider, {
        value: {
            nav: nav,
            locales: locales
        },
        children: children
    });
};
var usePageContext = function() {
    return (0,_Helpers__WEBPACK_IMPORTED_MODULE_3__/* .useContextHandler */ .k)(PageContext, "PageContext");
};
var useHeaderContext = function() {
    return (0,_Helpers__WEBPACK_IMPORTED_MODULE_3__/* .useContextHandler */ .k)(HeaderContext, "HeaderContext");
};
var useFooterContext = function() {
    return useContextHandler(FooterContext, "FooterContext");
};


/***/ }),

/***/ 77973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Theme; }
});

// UNUSED EXPORTS: StoreTheme, useCreateTheme, useDispatchActiveTheme, useTheme, useThemeDispatch, useThemes, useUpdateTheme

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/mosanic/core/Theme/useTheme.js + 1 modules
var useTheme = __webpack_require__(1465);
// EXTERNAL MODULE: ./src/mosanic/core/Typography/RenderFontSources.js
var RenderFontSources = __webpack_require__(13404);
// EXTERNAL MODULE: ./src/mosanic/core/Theme/useThemeDispatch.js
var useThemeDispatch = __webpack_require__(57800);
;// CONCATENATED MODULE: ./src/mosanic/core/Theme/RenderTheme.js







var RenderTheme = function(param) {
    var themeId = param.themeId;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTheme/* useTheme */.F)({
        _id: undefined
    }), 2), handler = ref[0], ref1 = (0,_sliced_to_array/* default */.Z)(ref[1], 3), theme = ref1[0], loading = ref1[1], error = ref1[2];
    (0,react.useEffect)(function() {
        if (themeId) handler({
            _id: themeId
        });
    }, [
        themeId
    ]);
    var typography = (theme || {
        typography: null
    }).typography;
    (0,useThemeDispatch/* useDispatchActiveTheme */.O)(themeId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderFontSources/* RenderFonts */.gz, {
            baseSize: (typography === null || typography === void 0 ? void 0 : typography.baseSize) + "px",
            fonts: typography === null || typography === void 0 ? void 0 : typography.fonts,
            sources: typography === null || typography === void 0 ? void 0 : typography.sources
        })
    });
};
/* harmony default export */ var Theme_RenderTheme = (RenderTheme);

;// CONCATENATED MODULE: ./src/mosanic/core/Theme/index.js






/* harmony default export */ var Theme = (Theme_RenderTheme);


/***/ }),

/***/ 1465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ useTheme; },
  "S": function() { return /* binding */ useThemes; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(60138);
;// CONCATENATED MODULE: ./src/adapters/queries/themes.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nquery themeMany($filter: FilterFindManyThemeInput) {\n	themeMany(filter: $filter){\n		",
        "\n	}\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nquery themeById($_id: MongoID!) {\n	themeById(_id: $_id){\n		",
        "\n	}\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

;
var THEME_FIELDS = " \n	type\n	title \n	description \n	isUserGenerated\n	isBookmarked\n	colors \n	typography \n	_id\n";
var THEMES = (0,lib/* gql */.Ps)(_templateObject(), THEME_FIELDS);
var THEME = (0,lib/* gql */.Ps)(_templateObject1(), THEME_FIELDS);

// EXTERNAL MODULE: ./src/hooks/useApi.js + 3 modules
var useApi = __webpack_require__(70210);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/mosanic/core/Theme/useTheme.js
/* eslint-disable react-hooks/exhaustive-deps */ 




var useTheme = function(param) {
    var _id = param._id;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useApi/* useLazyQuery */.td)("themeById", THEME, {
        _id: _id
    }), 2), handler = ref[0], ref1 = (0,_sliced_to_array/* default */.Z)(ref[1], 3), theme = ref1[0], loading = ref1[1], error = ref1[2];
    (0,react.useEffect)(function() {
        if (_id) handler({
            _id: _id
        });
    }, [
        _id
    ]);
    return [
        handler,
        [
            theme,
            loading,
            error
        ]
    ];
};
var useThemes = function(param) {
    var _ids = param._ids, _onlyUser = param.onlyUser, onlyUser = _onlyUser === void 0 ? false : _onlyUser;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useApi/* useLazyQuery */.td)("themeMany", THEMES), 2), handler = ref[0], ref1 = (0,_sliced_to_array/* default */.Z)(ref[1], 3), themes = ref1[0], loading = ref1[1], error = ref1[2];
    (0,react.useEffect)(function() {
        if (Array.isArray(_ids) && (_ids === null || _ids === void 0 ? void 0 : _ids.length) >= 1) {
            handler({
                filter: {
                    OR: (0,_to_consumable_array/* default */.Z)(_ids === null || _ids === void 0 ? void 0 : _ids.map(function(_id) {
                        return {
                            _id: _id
                        };
                    })).concat([
                        {
                            isUserGenerated: onlyUser
                        }
                    ])
                }
            });
        } else if (!onlyUser) {
            handler({
                filter: {
                    isUserGenerated: false
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        _ids
    ]);
    return [
        themes,
        loading,
        error
    ];
};


/***/ }),

/***/ 57800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useDispatchActiveTheme; },
/* harmony export */   "l": function() { return /* binding */ useThemeDispatch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66383);
/* harmony import */ var _redux_colors_action__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32360);
/* harmony import */ var _redux_theme_action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55403);
/* harmony import */ var _redux_typography_action__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94860);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);
/* harmony import */ var _useTheme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1465);









var useThemeDispatch = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    return {
        setTheme: function(theme) {
            dispatch((0,_redux_theme_action__WEBPACK_IMPORTED_MODULE_2__/* .setThemeAction */ .jU)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, theme), {
                colors: undefined,
                typography: undefined
            })));
            dispatch((0,_redux_colors_action__WEBPACK_IMPORTED_MODULE_5__/* .setColorsAction */ .Dz)(theme.colors));
            dispatch((0,_redux_typography_action__WEBPACK_IMPORTED_MODULE_6__/* .setTypesAction */ .P6)(theme.typography));
        },
        resetTheme: function() {
            dispatch((0,_redux_theme_action__WEBPACK_IMPORTED_MODULE_2__/* .setThemeAction */ .jU)({}));
            dispatch((0,_redux_colors_action__WEBPACK_IMPORTED_MODULE_5__/* .resetColorsAction */ .Zx)());
            dispatch((0,_redux_typography_action__WEBPACK_IMPORTED_MODULE_6__/* .resetTypesAction */ .TK)());
        }
    };
};
var useDispatchActiveTheme = function(themeId) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_useTheme__WEBPACK_IMPORTED_MODULE_8__/* .useTheme */ .F)({
        _id: themeId ? themeId : undefined
    }), 2), handler = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(ref[1], 3), theme = ref1[0], loading = ref1[1], error = ref1[2];
    var dispatch = useThemeDispatch();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((theme === null || theme === void 0 ? void 0 : theme.typography) && themeId) dispatch.setTheme(theme);
    }, [
        themeId,
        theme,
        dispatch
    ]);
    return [
        theme,
        loading,
        error
    ];
};


/***/ }),

/***/ 13404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ FontSources; },
/* harmony export */   "M$": function() { return /* binding */ FontFace; },
/* harmony export */   "gz": function() { return /* binding */ RenderFonts; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66383);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mosanic_cms_Query_byId__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62357);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25157);
/* harmony import */ var _redux_colors_reducer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74329);
/* harmony import */ var _redux_typography_reducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96117);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68311);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64157);











// import { useFontSources } from "./useFontSources";
var selectors = ":is(.mosanic_preview, .mosanic_site)";
var children = ":is(span, b, u, strong, i, a, ul, li)";
var getType = function(type) {
    var base = "".concat(selectors, " ").concat(type);
    if ("h1|h2|h3|h4|h5|h6".split("|").includes(type)) {
        return "".concat(base, " > ").concat(children, ", ").concat(base);
    }
    if (type === "p") {
        return "".concat(selectors, " div > ").concat(children, ", ").concat(base, " > ").concat(children, ", ").concat(base);
    }
    return "".concat(selectors, " ").concat(type, ", ").concat(selectors, " ").concat(type, " > span");
// if(type != button) 
};
var FontTypes = function(fonts, primary) {
    return (fonts === null || fonts === void 0 ? void 0 : fonts.length) >= 1 ? fonts.map(function(item) {
        return (0,_util_Text__WEBPACK_IMPORTED_MODULE_3__/* .oneLineString */ .r6)(" \n    /** ".concat(item.type, " **/    \n    ").concat(selectors, " ").concat(item.type, " {\n        font-weight: ").concat((item === null || item === void 0 ? void 0 : item.bold) && !(item === null || item === void 0 ? void 0 : item.weight) ? "bold" : (item === null || item === void 0 ? void 0 : item.style) === "regular" ? 400 : item === null || item === void 0 ? void 0 : item.weight, ";\n    }\n    ").concat(getType(item.type), ' {\n        -moz-osx-font-smoothing: grayscale;\n        -webkit-font-smoothing: antialiased;\n        font-family: "').concat(item.font, '";\n        font-size: ').concat(item.size + "" + item.metric, ";\n        font-weight: ").concat((item === null || item === void 0 ? void 0 : item.bold) && !(item === null || item === void 0 ? void 0 : item.weight) ? "bold" : (item === null || item === void 0 ? void 0 : item.style) === "regular" ? 400 : item === null || item === void 0 ? void 0 : item.weight, ";\n        font-style: ").concat(item.italic ? "italic" : "normal", ";\n        ").concat(item.underline ? "text-decoration: underline" : "", ";\n        ").concat(item.type === "a" && (primary === null || primary === void 0 ? void 0 : primary.value) && "color: ".concat(primary === null || primary === void 0 ? void 0 : primary.value, ";"), "\n    }\n"));
    }) : null;
};
var FontFace = function(param) {
    var family = param.family, weight = param.weight, style = param.style, src = param.src;
    return '\n    @font-face {\n        font-family: "'.concat(family, "\";\n        src: url('").concat((0,_util_Text__WEBPACK_IMPORTED_MODULE_3__/* .replacePart */ .bA)(src, "http", "https"), "') format('truetype');\n        font-weight: ").concat(style === "regular" ? 400 : weight, ";\n        font-style: ").concat(style, ";\n    }\n");
};
var FontSources = function(param) {
    var _dynamic = param.dynamic, dynamic = _dynamic === void 0 ? false : _dynamic;
    // const site.themeId 
    var siteId = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_4__/* .siteIdSelector */ .uL);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_mosanic_cms_Query_byId__WEBPACK_IMPORTED_MODULE_6__/* .useGetSite */ .iu)({
        _id: siteId
    }), 1), site = ref[0];
    var sources = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_typography_reducer__WEBPACK_IMPORTED_MODULE_7__/* .fontSourcesSelector */ .mX);
    var fonts = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_typography_reducer__WEBPACK_IMPORTED_MODULE_7__/* .fontsSelector */ .Ai);
    var primary = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_redux_colors_reducer__WEBPACK_IMPORTED_MODULE_8__/* .colorSelector */ .cq)(state, "main", "40");
    });
    var baseSize = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_typography_reducer__WEBPACK_IMPORTED_MODULE_7__/* .baseFontSizeSelector */ .VA);
    var data = {
        fonts: fonts,
        sources: sources,
        baseSize: baseSize,
        primary: primary
    };
    // useEffect(() => {
    //     let timer = null;
    //     if(dynamic && theme) timer = setTimeout(() => handles.setTheme(theme), 500)
    //     return () => clearTimeout(timer)
    // },[dynamic, theme, handles])
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RenderFonts, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, data));
};
var RenderFonts = function(param) {
    var fonts = param.fonts, _baseSize = param.baseSize, baseSize = _baseSize === void 0 ? "16px" : _baseSize, primary = param.primary, sources = param.sources;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("style", {
        type: "text/css",
        children: [
            "\nhtml ".concat(selectors, " {\n    font-size: ").concat(baseSize).concat((0,_util_Text__WEBPACK_IMPORTED_MODULE_3__/* .containsSubstr */ .xX)(baseSize, "px") ? "" : "px", ";\n    line-height: ").concat(parseFloat(baseSize) / 10 - 0.1, ";\n}\n"),
            (sources === null || sources === void 0 ? void 0 : sources.length) >= 1 ? sources.map(function(source, index) {
                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(FontFace, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, source), {
                    key: index
                }));
            }) : null,
            FontTypes(fonts, primary)
        ]
    });
};


/***/ }),

/***/ 87567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ButtonGroup_ButtonGroup; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/mosanic/Icons/EditorIcons.js
var EditorIcons = __webpack_require__(59688);
;// CONCATENATED MODULE: ./src/mosanic/Icons/FieldIcons.js


//Flex
var align = {
    start: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 47 45",
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            transform: "translate(1)",
            fill: "#1082E9",
            stroke: "#1082E9",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M45 1v3H0V1z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "10",
                    y: "8",
                    width: "9",
                    height: "21",
                    rx: "2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "24",
                    y: "8",
                    width: "9",
                    height: "15",
                    rx: "2"
                })
            ]
        })
    }),
    center: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 47 45",
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            transform: "matrix(1 0 0 -1 1 45)",
            fill: "#1082E9",
            stroke: "#1082E9",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M45 20v3H0v-3z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "10",
                    y: "13",
                    width: "9",
                    height: "21",
                    rx: "2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "25",
                    y: "15",
                    width: "9",
                    height: "15",
                    rx: "2"
                })
            ]
        })
    }),
    end: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 47 46",
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            transform: "matrix(1 0 0 -1 1 45)",
            fill: "#1082E9",
            stroke: "#1082E9",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M45 0v3H0V0z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "10",
                    y: "7",
                    width: "9",
                    height: "21",
                    rx: "2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "24",
                    y: "7",
                    width: "9",
                    height: "15",
                    rx: "2"
                })
            ]
        })
    }),
    stretch: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 47 46",
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            transform: "matrix(1 0 0 -1 1 45)",
            fill: "#1082E9",
            stroke: "#1082E9",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M45 0v3H0V0zM45 41v3H0v-3z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "10",
                    y: "7",
                    width: "9",
                    height: "30",
                    rx: "2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "24",
                    y: "7",
                    width: "9",
                    height: "30",
                    rx: "2"
                })
            ]
        })
    }),
    baseline: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 47 45",
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "#1082E9",
            stroke: "#1082E9",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M46 25v-3H1v3z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18 32a2 2 0 0 0 2-2V13a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v17a2 2 0 0 0 2 2h5zm0-11h-5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1zM33 30a2 2 0 0 0 2-2V17a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h5zm0-9h-5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1z"
                })
            ]
        })
    })
};
var justify = {
    start: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 45 47",
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            transform: "rotate(-90 23 23)",
            fill: "#1082E9",
            stroke: "#1082E9",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M45 1v3H0V1z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    transform: "rotate(90 22.5 13.5)",
                    x: "18",
                    y: "3",
                    width: "9",
                    height: "21",
                    rx: "2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    transform: "rotate(90 22.5 27.5)",
                    x: "18",
                    y: "17",
                    width: "9",
                    height: "21",
                    rx: "2"
                })
            ]
        })
    }),
    center: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 45 47",
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            transform: "rotate(-90 23 23)",
            fill: "#1082E9",
            stroke: "#1082E9",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M45 21v3H0v-3z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    transform: "rotate(90 22.5 33.5)",
                    x: "18",
                    y: "23",
                    width: "9",
                    height: "21",
                    rx: "2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    transform: "rotate(90 22.5 11.5)",
                    x: "18",
                    y: "1",
                    width: "9",
                    height: "21",
                    rx: "2"
                })
            ]
        })
    }),
    end: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 45 47",
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            transform: "rotate(90 22 23)",
            fill: "#1082E9",
            stroke: "#1082E9",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M45 1v3H0V1z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    transform: "rotate(90 22.5 13.5)",
                    x: "18",
                    y: "3",
                    width: "9",
                    height: "21",
                    rx: "2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    transform: "rotate(90 22.5 27.5)",
                    x: "18",
                    y: "17",
                    width: "9",
                    height: "21",
                    rx: "2"
                })
            ]
        })
    }),
    between: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 47 47",
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            transform: "rotate(90 22.5 23.5)",
            fill: "#1082E9",
            stroke: "#1082E9",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M45 0v3H0V0zM45 42v3H0v-3z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    transform: "rotate(90 22.5 11.5)",
                    x: "18",
                    y: "1",
                    width: "9",
                    height: "21",
                    rx: "2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    transform: "rotate(90 22.5 33.5)",
                    x: "18",
                    y: "23",
                    width: "9",
                    height: "21",
                    rx: "2"
                })
            ]
        })
    }),
    around: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 47 47",
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            transform: "rotate(90 22.5 23.5)",
            fill: "#1082E9",
            stroke: "#1082E9",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M45 0v3H0V0zM45 42v3H0v-3z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    transform: "rotate(90 22.5 14.5)",
                    x: "18",
                    y: "4",
                    width: "9",
                    height: "21",
                    rx: "2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    transform: "rotate(90 22.5 30.5)",
                    x: "18",
                    y: "20",
                    width: "9",
                    height: "21",
                    rx: "2"
                })
            ]
        })
    })
};
var grid = {
    grid: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.81812 4.68161C4.99386 4.85734 4.99386 5.14227 4.81812 5.318L3.08632 7.0498H11.9135L10.1817 5.318C10.006 5.14227 10.006 4.85734 10.1817 4.68161C10.3575 4.50587 10.6424 4.50587 10.8181 4.68161L13.3181 7.18161C13.4939 7.35734 13.4939 7.64227 13.3181 7.818L10.8181 10.318C10.6424 10.4937 10.3575 10.4937 10.1817 10.318C10.006 10.1423 10.006 9.85734 10.1817 9.68161L11.9135 7.9498H3.08632L4.81812 9.68161C4.99386 9.85734 4.99386 10.1423 4.81812 10.318C4.64239 10.4937 4.35746 10.4937 4.18173 10.318L1.68173 7.818C1.50599 7.64227 1.50599 7.35734 1.68173 7.18161L4.18173 4.68161C4.35746 4.50587 4.64239 4.50587 4.81812 4.68161Z",
            fill: "black"
        })
    }),
    order: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
            fill: "black"
        })
    }),
    offset: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.05005 13.5C2.05005 13.7485 2.25152 13.95 2.50005 13.95C2.74858 13.95 2.95005 13.7485 2.95005 13.5L2.95005 1.49995C2.95005 1.25142 2.74858 1.04995 2.50005 1.04995C2.25152 1.04995 2.05005 1.25142 2.05005 1.49995L2.05005 13.5ZM8.4317 11.0681C8.60743 11.2439 8.89236 11.2439 9.06809 11.0681C9.24383 10.8924 9.24383 10.6075 9.06809 10.4317L6.58629 7.94993L14.5 7.94993C14.7485 7.94993 14.95 7.74846 14.95 7.49993C14.95 7.2514 14.7485 7.04993 14.5 7.04993L6.58629 7.04993L9.06809 4.56813C9.24383 4.39239 9.24383 4.10746 9.06809 3.93173C8.89236 3.75599 8.60743 3.75599 8.4317 3.93173L5.1817 7.18173C5.00596 7.35746 5.00596 7.64239 5.1817 7.81812L8.4317 11.0681Z",
            fill: "black"
        })
    }),
    elements: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.87935 1H3.9H11.1H11.1207C11.5231 0.999994 11.8553 0.999989 12.1259 1.0221C12.407 1.04506 12.6653 1.09434 12.908 1.21799C13.2843 1.40973 13.5903 1.7157 13.782 2.09202C13.9057 2.33469 13.9549 2.59304 13.9779 2.87409C14 3.14468 14 3.47686 14 3.87934V3.9V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H3.9H3.87934C3.47686 14 3.14468 14 2.87409 13.9779C2.59304 13.9549 2.33469 13.9057 2.09202 13.782C1.7157 13.5903 1.40973 13.2843 1.21799 12.908C1.09434 12.6653 1.04506 12.407 1.0221 12.1259C0.999989 11.8553 0.999994 11.5231 1 11.1207V11.1207V11.1V3.9V3.87935V3.87934C0.999994 3.47686 0.999989 3.14468 1.0221 2.87409C1.04506 2.59304 1.09434 2.33469 1.21799 2.09202C1.40973 1.7157 1.7157 1.40973 2.09202 1.21799C2.33469 1.09434 2.59304 1.04506 2.87409 1.0221C3.14469 0.999989 3.47687 0.999994 3.87935 1ZM2.95552 2.01878C2.73631 2.03669 2.62421 2.06915 2.54601 2.10899C2.35785 2.20487 2.20487 2.35785 2.10899 2.54601C2.06915 2.62421 2.03669 2.73631 2.01878 2.95552C2.00039 3.18056 2 3.47171 2 3.9V7H7V2H3.9C3.47171 2 3.18056 2.00039 2.95552 2.01878ZM7 8H2V11.1C2 11.5283 2.00039 11.8194 2.01878 12.0445C2.03669 12.2637 2.06915 12.3758 2.10899 12.454C2.20487 12.6422 2.35785 12.7951 2.54601 12.891C2.62421 12.9309 2.73631 12.9633 2.95552 12.9812C3.18056 12.9996 3.47171 13 3.9 13H7V8ZM8 8H13V11.1C13 11.5283 12.9996 11.8194 12.9812 12.0445C12.9633 12.2637 12.9309 12.3758 12.891 12.454C12.7951 12.6422 12.6422 12.7951 12.454 12.891C12.3758 12.9309 12.2637 12.9633 12.0445 12.9812C11.8194 12.9996 11.5283 13 11.1 13H8V8ZM13 7H8V2H11.1C11.5283 2 11.8194 2.00039 12.0445 2.01878C12.2637 2.03669 12.3758 2.06915 12.454 2.10899C12.6422 2.20487 12.7951 2.35785 12.891 2.54601C12.9309 2.62421 12.9633 2.73631 12.9812 2.95552C12.9996 3.18056 13 3.47171 13 3.9V7Z",
            fill: "black"
        })
    }),
    hide: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z",
            fill: "black"
        })
    })
};
var textAlign = {
    left: EditorIcons/* format_align_left */.ih,
    center: EditorIcons/* format_align_center */.pZ,
    right: EditorIcons/* format_align_right */.ZI,
    justify: EditorIcons/* format_align_justify */.UG,
    hide: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z",
            fill: "black"
        })
    })
};
var FieldIcons = {
    textAlign: textAlign,
    align: align,
    justify: justify,
    grid: grid
};
/* harmony default export */ var Icons_FieldIcons = (FieldIcons);

// EXTERNAL MODULE: ./src/mosanic/_Fieldsets.js
var _Fieldsets = __webpack_require__(28585);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/styles/button.styles.js + 1 modules
var button_styles = __webpack_require__(6554);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(78545);
;// CONCATENATED MODULE: ./src/mosanic/styles/buttonGroup.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            margin: 0 0 10px;\n            \n            ",
        " {\n                padding: 10px;\n                max-height: 40px;\n                min-height: 40px;\n                min-width: 48px;\n                max-width: 48px;\n            }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            margin: 0 0 5px;\n            \n            ",
        " {\n                padding: 2.5px;\n                max-height: 28px;\n                min-height: 28px;\n                min-width: 38px;\n                max-width: 48px;\n            }\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            margin: 0 0 8px;\n\n            ",
        " {\n                padding: 5px;\n                max-height: 32px;\n                min-height: 32px;\n                 min-width: 48px;\n                max-width: 48px;\n                /* min-width: 38px; */\n                /* max-width: 38px; */\n            }\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        width: 100%;\n        align-items: stretch;\n        ",
        " {\n            max-width: none;\n            width: 100%;\n        }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-color: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        margin-top: -5px;\n        float: right;\n        margin-left: auto;\n        width: fit-content;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        transform: scale(0.8);\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    ",
        "\n    border: 1px solid ",
        ";\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    padding: 0;\n    border-radius: ",
        ";\n    width: fit-content;\n\n    ",
        "\n    ",
        ",\n    span,\n    a {\n        margin: 0;\n        border: none;\n    }\n    span, a {\n        width: 100%;\n    }\n\n    ",
        "\n\n    svg {\n        transition: all ease-in-out 0.3s;\n    }\n    \n    &.-rotate {\n        svg {\n            transform: rotate(-90deg);\n        }\n    }\n\n    ",
        "\n    ",
        "\n\n\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var getSize = function(size) {
    switch(size){
        case "large":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), button_styles/* default.Button */.ZP.Button);
        case "xs":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), button_styles/* default.Button */.ZP.Button);
        //Small
        default:
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), button_styles/* default.Button */.ZP.Button);
    }
};
var Radius = "4px";
var ButtonGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0b46330-0"
})(_templateObject7(), function(props) {
    return getSize(props === null || props === void 0 ? void 0 : props.size);
}, colors/* default.util.gray.light */.ZP.util.gray.light, Radius, function(props) {
    return props.isText && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), button_styles/* default.Button */.ZP.Button);
}, button_styles/* default.Button */.ZP.Button, function(props) {
    return props.active && (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), colors/* default.util.primary.base */.ZP.util.primary.base);
}, function(props) {
    return props.right && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
}, function(props) {
    return props.small && (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
}, index_esm/* layout */.bK, index_esm/* space */.Dh);
var ButtonGroupStyles = {
    ButtonGroup: ButtonGroup
};
/* harmony default export */ var buttonGroup_styles = (ButtonGroupStyles);

// EXTERNAL MODULE: ./src/mosanic/items/Tooltip/index.js + 2 modules
var Tooltip = __webpack_require__(94233);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/Input.styles.js
var Input_styles = __webpack_require__(55217);
;// CONCATENATED MODULE: ./src/mosanic/fields/Button/ButtonGroup.js
// const FieldIcons = dynamic(() => import("@mosanic/Icons/FieldIcons"))
















var ButtonGroup_ButtonGroup = function(_param) /*#__PURE__*/ {
    var children = _param.children, _theme = _param.theme, theme = _theme === void 0 ? "" : _theme, _size = _param.size, size = _size === void 0 ? "small" : _size, _variant = _param.variant, variant = _variant === void 0 ? "outlined" : _variant, _noBorder = _param.noBorder, noBorder = _noBorder === void 0 ? true : _noBorder, _extraClass = _param.extraClass, extraClass = _extraClass === void 0 ? "" : _extraClass, _active = _param.active, active = _active === void 0 ? false : _active, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _wrap = _param.wrap, wrap = _wrap === void 0 ? false : _wrap, _tooltip = _param.tooltip, tooltip = _tooltip === void 0 ? null : _tooltip, _isText = _param.isText, isText = _isText === void 0 ? true : _isText, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _label = _param.label, label = _label === void 0 ? null : _label, _name = _param.name, name = _name === void 0 ? null : _name, _required = _param.required, required = _required === void 0 ? false : _required, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "theme",
        "size",
        "variant",
        "noBorder",
        "extraClass",
        "active",
        "disabled",
        "wrap",
        "tooltip",
        "isText",
        "fullWidth",
        "label",
        "name",
        "required"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        title: tooltip,
        placement: "left",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* WrapInput */.Vw, {
            wrap: wrap ? 1 : 0,
            fullWidth: fullWidth,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Input_styles/* InputLabel */.AZ, {
                    shrink: true,
                    children: [
                        label ? label : name ? name : "",
                        required && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_styles/* InputRequired */.Bm, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(buttonGroup_styles.ButtonGroup, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    size: size,
                    theme: theme,
                    variant: variant,
                    active: active,
                    disabled: disabled,
                    isText: isText,
                    className: " ".concat(noBorder ? "-noBorder" : "", " ").concat(extraClass)
                }, other), {
                    children: children
                }))
            ]
        })
    });
};
var isActive = function(value, optionValue) {
    return !Array.isArray(value) ? value == optionValue : value.reverse().filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], keyValue = _param[1];
        if (key === "all" && keyValue) return true // all
        ;
        if (key === optionValue) return keyValue;
    })[0];
};
var getValue = function(option) {
    return (option === null || option === void 0 ? void 0 : option.label) ? option.value : option;
};
var getLabelValue = function(option) {
    return (option === null || option === void 0 ? void 0 : option.value) ? option.value : option;
};
var Label = function(param) {
    var labelFormat = param.labelFormat, iconGroup = param.iconGroup, option = param.option;
    return (0,_Fieldsets/* parseIcon */.GF)(labelFormat) && (0,Obj/* hasAttr */.B$)(Icons_FieldIcons, iconGroup, getLabelValue(option)) ? Icons_FieldIcons[iconGroup][getLabelValue(option)] : (option === null || option === void 0 ? void 0 : option.label) ? option === null || option === void 0 ? void 0 : option.label : (0,Text/* isString */.HD)(option) ? (0,Text/* capitalizeFirst */.Ez)(option) : "";
};
var _tmp;
_tmp = function(_param) {
    var _options = _param.options, options = _options === void 0 ? [] : _options, _value = _param.value, value = _value === void 0 ? null : _value, _handler = _param.handler, handler = _handler === void 0 ? null : _handler, _labelFormat = _param.labelFormat, labelFormat = _labelFormat === void 0 ? "text" : _labelFormat, _iconGroup = _param.iconGroup, iconGroup = _iconGroup === void 0 ? null : _iconGroup, other = (0,_object_without_properties/* default */.Z)(_param, [
        "options",
        "value",
        "handler",
        "labelFormat",
        "iconGroup"
    ]);
    return Array.isArray(options) ? options.map(function(option) {
        /*#__PURE__*/ return (0,react.createElement)(ChoiceButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
            type: "button",
            active: isActive(value, getValue(option)),
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                labelFormat: labelFormat,
                iconGroup: iconGroup,
                option: option
            }),
            handler: function() {
                return handler(getValue(option));
            },
            tooltip: option === null || option === void 0 ? void 0 : option.tooltip,
            key: (option === null || option === void 0 ? void 0 : option.label) ? option.label : option
        }));
    }) : null;
}, ButtonGroup_ButtonGroup.Choices = _tmp, _tmp;
var ChoiceButton = function(_param) /*#__PURE__*/ {
    var active = _param.active, label = _param.label, _tooltip = _param.tooltip, tooltip = _tooltip === void 0 ? null : _tooltip, handler = _param.handler, other = (0,_object_without_properties/* default */.Z)(_param, [
        "active",
        "label",
        "tooltip",
        "handler"
    ]);
    return (0,jsx_runtime.jsx)(Buttons.Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        active: active,
        handler: handler,
        tooltip: tooltip,
        children: label
    }));
};


/***/ }),

/***/ 47914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Button": function() { return /* binding */ Button; },
  "Buttons": function() { return /* binding */ Buttons; },
  "ToggleButton": function() { return /* binding */ ToggleButton; },
  "default": function() { return /* binding */ Button_Buttons; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/items/Tooltip/index.js + 2 modules
var Tooltip = __webpack_require__(94233);
// EXTERNAL MODULE: ./src/mosanic/items/Link/index.js
var Link = __webpack_require__(8152);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
;// CONCATENATED MODULE: ./src/utils/Class.js

var oneLineClass = function(classNames) {
    return {
        className: (0,Text/* oneLineString */.r6)(classNames)
    };
};

// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/styles/button.styles.js + 1 modules
var button_styles = __webpack_require__(6554);
;// CONCATENATED MODULE: ./src/mosanic/fields/Button/Buttons.js









var Buttons = function(_param) /*#__PURE__*/ {
    var children = _param.children, _size = _param.size, size = _size === void 0 ? "small" : _size, _noBorder = _param.noBorder, noBorder = _noBorder === void 0 ? true : _noBorder, _extraClass = _param.extraClass, extraClass = _extraClass === void 0 ? "text" : _extraClass, _wrap = _param.wrap, wrap = _wrap === void 0 ? false : _wrap, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "size",
        "noBorder",
        "extraClass",
        "wrap"
    ]);
    return (0,jsx_runtime.jsx)(Inputs/* WrapInput */.Vw, {
        wrap: wrap ? wrap : false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_styles/* default.Buttons */.ZP.Buttons, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, oneLineClass("\n        coreButtons \n        ".concat(noBorder ? "-noBorder" : "", " \n        -").concat(extraClass, "\n        -").concat(size, " \n        -text")), other), {
            children: children
        }))
    });
};
var ToggleButton = function(_param) {
    var _altLabel = _param.altLabel, altLabel = _altLabel === void 0 ? null : _altLabel, _altIcon = _param.altIcon, altIcon = _altIcon === void 0 ? null : _altIcon, _checked = _param.checked, checked = _checked === void 0 ? false : _checked, other = (0,_object_without_properties/* default */.Z)(_param, [
        "altLabel",
        "altIcon",
        "checked"
    ]);
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        label: checked ? altLabel : other === null || other === void 0 ? void 0 : other.label,
        icon: checked ? altIcon : other === null || other === void 0 ? void 0 : other.icon
    }));
};
var Button = function(_param) {
    var children = _param.children, handler = _param.handler, _onClick = _param.onClick, onClick = _onClick === void 0 ? null : _onClick, _label = _param.label, label = _label === void 0 ? null : _label, _size = _param.size, size = _size === void 0 ? "small" : _size, _theme = _param.theme, theme = _theme === void 0 ? "" : _theme, _variant = _param.variant, variant = _variant === void 0 ? "outlined" : _variant, _customClass = _param.customClass, customClass = _customClass === void 0 ? "" : _customClass, _icon = _param.icon, icon = _icon === void 0 ? false : _icon, _iconRight = _param.iconRight, iconRight = _iconRight === void 0 ? false : _iconRight, _double = _param.double, double = _double === void 0 ? false : _double, _scale = _param.scale, scale = _scale === void 0 ? false : _scale, _maxW = _param.maxW, maxW = _maxW === void 0 ? false : _maxW, _active = _param.active, active = _active === void 0 ? false : _active, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _noVal = _param.noVal, noVal = _noVal === void 0 ? false : _noVal, _cell = _param.cell, cell = _cell === void 0 ? false : _cell, _style = _param.style, style = _style === void 0 ? null : _style, _bold = _param.bold, bold = _bold === void 0 ? false : _bold, _tooltip = _param.tooltip, tooltip = _tooltip === void 0 ? null : _tooltip, _wrap = _param.wrap, wrap = _wrap === void 0 ? false : _wrap, _href = _param.href, href = _href === void 0 ? null : _href, _target = _param.target, target = _target === void 0 ? null : _target, _type = _param.type, type = _type === void 0 ? "button" : _type, _lines = _param.lines, lines = _lines === void 0 ? 1 : _lines, _ui = _param.ui, ui = _ui === void 0 ? false : _ui, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "handler",
        "onClick",
        "label",
        "size",
        "theme",
        "variant",
        "customClass",
        "icon",
        "iconRight",
        "double",
        "scale",
        "maxW",
        "active",
        "disabled",
        "noVal",
        "cell",
        "style",
        "bold",
        "tooltip",
        "wrap",
        "href",
        "target",
        "type",
        "lines",
        "ui"
    ]);
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Inputs/* WrapInput */.Vw, {
        wrap: wrap ? wrap : false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
            when: tooltip,
            wrapper: function(children) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    title: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.title) ? tooltip.title : tooltip,
                    wrap: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.wrap) ? tooltip.wrap : false,
                    placement: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.placement) ? tooltip.placement : null,
                    children: children
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
                when: href,
                wrapper: function(children) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                        href: href,
                        target: target,
                        children: children
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_styles/* default.Button */.ZP.Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    uiButton: ui,
                    onClick: handler ? handler : onClick,
                    className: "coreButton ".concat(customClass),
                    sz: size,
                    theme: theme,
                    variant: variant,
                    icon: icon || iconRight,
                    // scale={scale}
                    maxW: maxW,
                    active: active,
                    disabled: disabled,
                    noVal: noVal,
                    cell: cell,
                    bold: bold,
                    style: style,
                    type: type,
                    double: double,
                    lines: lines
                }, other), {
                    children: [
                        icon ? icon : "",
                        (double || lines >= 2) && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        label ? double ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: label
                        }) : label : "",
                        !icon && !label && children,
                        iconRight ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                margin: "0 0 0 2px"
                            },
                            children: iconRight
                        }) : ""
                    ]
                }))
            })
        })
    });
};
/* harmony default export */ var Button_Buttons = (Button);


/***/ }),

/***/ 26173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/mosanic/styles/flex.styles.js
var flex_styles = __webpack_require__(5441);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
;// CONCATENATED MODULE: ./src/mosanic/fields/Checkbox/Checkbox.style.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin-left: 8px;\n    padding-bottom: 4px;\n    font-size: 14px;\n    align-items: top;\n    &:hover {\n        cursor: pointer;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    ",
        "\n    overflow: hidden;\n    border-radius: 50%;\n    width: 18px;\n    height: 18px;\n    background: ",
        ";\n    color: #fff;\n    font-size: 11px;\n    position: absolute;\n    top: 2.5px;\n    right: 2.5px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n            border-color: ",
        ";\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        transition: all ease-in-out 0.3s;\n        border: 1px solid ",
        ";\n        border-radius: 7.5px;\n        padding: 2.5px;\n        margin: 5px;\n        ",
        " {\n            margin: 5px 5px 0;\n            transform: scale(1.1);\n            transform-origin: left top;\n        }\n        &:hover{\n            cursor: pointer;\n            background: ",
        ";\n            transform: scale(1.05);\n        }\n\n        ",
        "\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        opacity: 0.7;\n        transform: scale(0.9);\n        &:hover{\n            transform: scale(0.9)\n        }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        ",
        " {\n            display: block;\n            width: 100%;\n            font-size: 12px;\n            margin: 5px;\n            max-height: 16px;\n            overflow: hidden;\n        }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    position: relative;\n    ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-block;\n    vertical-align: middle;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: -14px;\n    fill: none;\n    stroke: white;\n    stroke-width: 3px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 0;\n    clip: rect(0 0 0 0);\n    clip-path: inset(50%);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transition: ease-in-out 0.2s all;\n    padding: 2px;\n    cursor: pointer;\n    display: inline-block;\n    margin-top: 10px;\n    width: 16px;\n    height: 16px;\n    border: ",
        ";\n    background: ",
        ";\n    border-radius: 3px;\n    transition: all 150ms;\n\n    ",
        ":focus + & {\n        box-shadow: 0 0 0 3px ",
        ";\n    }\n    &:hover {\n        background: ",
        ";\n        box-shadow: 0 0 0 3px ",
        ";\n    }\n\n    ",
        " {\n        visibility: ",
        ";\n    }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var CheckBoxLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ca8a3522-0"
})(_templateObject());
var CheckBoxCount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca8a3522-1"
})(_templateObject1(), flex_styles/* CenterCenter */.IV, colors/* default.util.primary.light */.ZP.util.primary.light);
var CheckBoxImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca8a3522-2"
})(_templateObject2());
var CheckBoxWrapper = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-ca8a3522-3"
})(_templateObject7(), function(props) {
    return props.hasBorder && (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), colors/* default.util.gray.light */.ZP.util.gray.light, CheckBoxImage, colors/* default.util.gray.lighter */.ZP.util.gray.lighter, props.checked && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), colors/* default.util.primary.base */.ZP.util.primary.base));
}, function(props) {
    return props.disabled || props.unfocus && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
}, function(props) {
    return props.size === "full" && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), CheckBoxLabel);
});
var CheckboxContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca8a3522-4"
})(_templateObject8());
var Icon = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-ca8a3522-5"
})(_templateObject9());
var HiddenCheckbox = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs({
    type: "checkbox"
}).withConfig({
    componentId: "sc-ca8a3522-6"
})(_templateObject10());
var StyledCheckbox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca8a3522-7"
})(_templateObject11(), function(props) {
    return props.checked ? "none" : "1px solid ".concat(colors/* default.util.gray.base */.ZP.util.gray.base);
}, function(props) {
    return props.checked ? colors/* default.util.primary.base */.ZP.util.primary.base : colors/* default.util.gray.lighter */.ZP.util.gray.lighter;
}, HiddenCheckbox, colors/* default.util.primary.underlay */.ZP.util.primary.underlay, function(props) {
    return props.checked ? colors/* default.util.primary.light */.ZP.util.primary.light : colors/* default.util.gray.light */.ZP.util.gray.light;
}, colors/* default.util.primary.underlay */.ZP.util.primary.underlay, Icon, function(props) {
    return props.checked ? "visible" : "hidden";
});
var CheckBoxStyle = {
    CheckBoxWrapper: CheckBoxWrapper,
    CheckBoxLabel: CheckBoxLabel,
    CheckBoxImage: CheckBoxImage,
    CheckBoxCount: CheckBoxCount,
    CheckboxContainer: CheckboxContainer,
    Icon: Icon,
    HiddenCheckbox: HiddenCheckbox,
    StyledCheckbox: StyledCheckbox
};
/* harmony default export */ var Checkbox_style = (CheckBoxStyle);

// EXTERNAL MODULE: ./src/mosanic/fields/Checkbox/Checkboxes.js
var Checkboxes = __webpack_require__(99182);
;// CONCATENATED MODULE: ./src/mosanic/fields/Checkbox/Checkbox.js









var Checkbox = function(_param) {
    var className = _param.className, label = _param.label, checked = _param.checked, _value = _param.value, value = _value === void 0 ? null : _value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _size = _param.size, size = _size === void 0 ? "small" : _size, _options = _param.options, options = _options === void 0 ? null : _options, _img = _param.img, img = _img === void 0 ? null : _img, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _unfocus = _param.unfocus, unfocus = _unfocus === void 0 ? false : _unfocus, _count = _param.count, count = _count === void 0 ? null : _count, other = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "label",
        "checked",
        "value",
        "onChange",
        "size",
        "options",
        "img",
        "disabled",
        "unfocus",
        "count"
    ]);
    var ref = (0,react.useState)(false), localState = ref[0], setLocal = ref[1];
    var toggleLocal = function() {
        return setLocal(function(prev) {
            return !prev;
        });
    };
    if (Array.isArray(value)) {
        var temp = {};
        value.map(function(v) {
            temp = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, temp), (0,_define_property/* default */.Z)({}, v === null || v === void 0 ? void 0 : v.label, true));
        });
        onChange(temp);
    }
    if (Array.isArray(options)) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            JSON.stringify(size),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkboxes/* default */.Z, (0,_object_spread/* default */.Z)({
                options: options,
                value: value,
                onChange: onChange
            }, other))
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Checkbox_style.CheckBoxWrapper, {
        size: size,
        disabled: disabled,
        unfocus: unfocus,
        checked: checked,
        hasBorder: img,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Checkbox_style.CheckboxContainer, {
                className: className,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_style.HiddenCheckbox, {
                        checked: checked ? checked : value ? value : localState,
                        onChange: Boolean(disabled) ? null : onChange ? onChange : toggleLocal
                    }),
                    count && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_style.CheckBoxCount, {
                        children: count
                    }),
                    img ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_style.CheckBoxImage, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: img,
                            alt: label,
                            width: "20px",
                            height: "20px"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_style.StyledCheckbox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        id: label
                    }, other), {
                        type: "checkbox",
                        checked: checked ? checked : value ? value : localState,
                        disabled: disabled,
                        onChange: function() {
                            return Boolean(disabled) ? null : onChange ? onChange : toggleLocal;
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_style.Icon, {
                            viewBox: "0 0 24 24",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                points: "20 6 9 17 4 12"
                            })
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_style.CheckBoxLabel, {
                children: label
            })
        ]
    });
};
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);


/***/ }),

/***/ 99182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68311);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26021);
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26173);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    display: inline-block;\n    vertical-align: top;\n    margin-top: 5px;\n    margin-right: 5px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        flex-wrap: wrap;\n        label {\n            width: 100%;\n        }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        flex-wrap: nowrap;\n        label {\n            width: 100%;\n        }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        justify-content: space-between;\n        flex-wrap: wrap;\n        label {width: auto;}\n        max-width: 100%;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    display: flex;\n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var Label = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5293a1ff-0"
})(_templateObject());
var Direction = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5293a1ff-1"
})(_templateObject4(), function(props) {
    return props.direction === "vertical" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2());
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.behavior) === "justify" && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3());
});
var Checkboxes = function(_param) {
    var className = _param.className, options = _param.options, value = _param.value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _size = _param.size, size = _size === void 0 ? "small" : _size, _direction = _param.direction, direction = _direction === void 0 ? "horizontal" : _direction, _style = _param.style, style = _style === void 0 ? null : _style, _behavior = _param.behavior, behavior = _behavior === void 0 ? null : _behavior, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "options",
        "value",
        "onChange",
        "disabled",
        "size",
        "direction",
        "style",
        "behavior"
    ]);
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Direction, {
        direction: direction,
        behavior: behavior,
        children: options === null || options === void 0 ? void 0 : options.map(function(option) {
            return renderOption((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                option: option,
                value: value,
                onChange: onChange,
                size: size,
                style: style
            }, other));
        })
    });
};
var renderOption = function(_param) {
    var option = _param.option, value = _param.value, onChange = _param.onChange, size = _param.size, style = _param.style, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "option",
        "value",
        "onChange",
        "size",
        "style"
    ]);
    var ref;
    var label = (0,_util_Text__WEBPACK_IMPORTED_MODULE_6__/* .isString */ .HD)(option === null || option === void 0 ? void 0 : option.label) ? option.label : option;
    var canSplit = (0,_util_Text__WEBPACK_IMPORTED_MODULE_6__/* .containsSubstr */ .xX)(label, "|");
    var val = (option === null || option === void 0 ? void 0 : option.value) ? option.value : canSplit ? (ref = label.split("|")) === null || ref === void 0 ? void 0 : ref[0] : label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        size: size
    }, other), {
        disabled: option === null || option === void 0 ? void 0 : option.disabled,
        unfocus: option === null || option === void 0 ? void 0 : option.unfocus,
        img: option === null || option === void 0 ? void 0 : option.img,
        count: option === null || option === void 0 ? void 0 : option.count,
        label: canSplit ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Label, {
            style: style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("b", {
                    children: label === null || label === void 0 ? void 0 : label.split("|")[0]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                label === null || label === void 0 ? void 0 : label.split("|")[1]
            ]
        }) : label,
        checked: value === null || value === void 0 ? void 0 : value[val],
        onChange: function(state) {
            return onChange((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, value), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, val, !(value === null || value === void 0 ? void 0 : value[val]))));
        }
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkboxes);


/***/ }),

/***/ 51840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Checkboxes": function() { return /* reexport safe */ _Checkboxes__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26173);
/* harmony import */ var _Checkboxes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99182);


/* harmony default export */ __webpack_exports__["default"] = (_Checkbox__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);



/***/ }),

/***/ 84019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Code": function() { return /* binding */ Code; },
/* harmony export */   "CodeEditor": function() { return /* binding */ CodeEditor; },
/* harmony export */   "highlighter": function() { return /* binding */ highlighter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var prismjs_components_prism_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53712);
/* harmony import */ var prismjs_components_prism_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prismjs_components_prism_core__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var react_simple_code_editor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4883);
/* harmony import */ var react_simple_code_editor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_simple_code_editor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26021);
/* harmony import */ var _Input_Input_styles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55217);
/* harmony import */ var prismjs_prism__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18476);
/* harmony import */ var prismjs_prism__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prismjs_prism__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var prismjs_components_prism_json__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62363);
/* harmony import */ var prismjs_components_prism_json__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prismjs_components_prism_json__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var prismjs_components_prism_clike__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18267);
/* harmony import */ var prismjs_components_prism_clike__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prismjs_components_prism_clike__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var prismjs_components_prism_javascript__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64883);
/* harmony import */ var prismjs_components_prism_javascript__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prismjs_components_prism_javascript__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var prismjs_themes_prism_coy_min_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var prismjs_themes_prism_coy_min_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prismjs_themes_prism_coy_min_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68311);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    border: none;\n    * {\n        border: none;\n        outline: none;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







 // need this




var CodeEditor = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)((react_simple_code_editor__WEBPACK_IMPORTED_MODULE_4___default())).withConfig({
    componentId: "sc-293dbb29-0"
})(_templateObject(), _Input_Input_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"].BaseField */ .ZP.BaseField);
var highlighter = function(code) {
    var lang = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "jsx";
    return prismjs_prism__WEBPACK_IMPORTED_MODULE_5___default().highlight(code, (prismjs_prism__WEBPACK_IMPORTED_MODULE_5___default().languages)[lang], lang);
};
var Code = function(_param) {
    var _name = _param.//Essential
    name, name = _name === void 0 ? "" : _name, _type = _param.type, type = _type === void 0 ? "text" : _type, _value = _param.value, value = _value === void 0 ? null : _value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _label = _param.//Overwrite
    label, label = _label === void 0 ? null : _label, _language = _param.language, language = _language === void 0 ? "html" : _language, _fullWidth = _param.//Styling
    fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _small = _param.small, small = _small === void 0 ? null : _small, _size = _param.size, size = _size === void 0 ? null : _size, _ninja = _param.ninja, ninja = _ninja === void 0 ? false : _ninja, _wrap = _param.wrap, wrap = _wrap === void 0 ? false : _wrap, _endAdornment = _param.//Specific
    endAdornment, endAdornment = _endAdornment === void 0 ? null : _endAdornment, _endSource = _param.endSource, endSource = _endSource === void 0 ? null : _endSource, _valid = _param.//Validation
    valid, valid = _valid === void 0 ? null : _valid, _empty = _param.empty, empty = _empty === void 0 ? false : _empty, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _required = _param.required, required = _required === void 0 ? false : _required, _innerRef = _param.innerRef, innerRef = _innerRef === void 0 ? null : _innerRef, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_param, [
        "name",
        "type",
        "value",
        "onChange",
        "label",
        "language",
        "fullWidth",
        "small",
        "size",
        "ninja",
        "wrap",
        "endAdornment",
        "endSource",
        "valid",
        "empty",
        "disabled",
        "required",
        "innerRef"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), focussed = ref[0], setFocused = ref[1];
    var onFocus = function() {
        return setFocused(true);
    };
    var onBlur = function() {
        return setFocused(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Input_Input_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Container */ .ZP.Container, {
        className: "input_field",
        focussed: focussed,
        disabled: disabled,
        valid: valid,
        empty: empty,
        ninja: ninja,
        size: size,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Input_Input_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Label */ .ZP.Label, {
                shrink: Boolean((innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) || value || focussed),
                children: [
                    ninja ? "" : label ? label : name ? name : "",
                    required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input_Input_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Required */ .ZP.Required, {})
                ]
            }),
            ((0,_util_Text__WEBPACK_IMPORTED_MODULE_13__/* .isString */ .HD)(value) || !value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CodeEditor, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                ref: innerRef,
                disabled: disabled,
                value: value || (other === null || other === void 0 ? void 0 : other.defaultValue) || ""
            }, other), {
                onChange: undefined,
                onValueChange: function(code) {
                    return onChange(code);
                },
                highlight: function(code) {
                    return highlighter(code, (0,_util_Text__WEBPACK_IMPORTED_MODULE_13__/* .isEmptyString */ .ke)(language) ? "html" : language);
                },
                padding: 10,
                style: {
                    fontFamily: '"Fira code", "Fira Mono", monospace',
                    fontSize: 12
                },
                onFocus: function(e) {
                    if (other === null || other === void 0 ? void 0 : other.onFocus) other.onFocus(e);
                    onFocus();
                },
                onBlur: function(e) {
                    if (other === null || other === void 0 ? void 0 : other.onBlur) other.onBlur(e);
                    onBlur();
                }
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Input_Input_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"].End */ .ZP.End, {
                children: [
                    endAdornment,
                    endSource
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Code);


/***/ }),

/***/ 22549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ FullCodeEditor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _monaco_editor_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27911);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26021);
/* harmony import */ var _Input_Input_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55217);
/* harmony import */ var prismjs_themes_prism_coy_min_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var prismjs_themes_prism_coy_min_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prismjs_themes_prism_coy_min_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _JSX__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96344);
/* harmony import */ var _PreviewCode__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59389);
/* harmony import */ var _mosanic_items_Inputs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99057);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68311);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    border: none;\n    * {\n        border: none;\n        outline: none;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var CodeEditor = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_monaco_editor_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-6a823e9a-0"
})(_templateObject(), _Input_Input_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"].BaseField */ .ZP.BaseField);
var editorOptions = {
    lineNumbers: "off",
    lineNumbersMinChars: 0,
    lineDecorationsWidth: 0,
    folding: false,
    glyphMargin: false,
    renderLineHighlight: "none",
    scrollBeyondLastLine: false,
    smoothScrolling: true,
    wordWrap: "on",
    minimap: {
        showSlider: false,
        enabled: false
    },
    overviewRulerLanes: 0,
    scrollbar: {
        vertical: "hidden",
        horizontal: "hidden"
    }
};
var FullCodeEditor = function(_param) {
    var handleEditorDidMount = function handleEditorDidMount(editor, monaco) {
        monaco.languages.typescript.javascriptDefaults.addExtraLib('\n            declare const $mos : () => mosanic state", "mosanic.d.ts\n            declare const $ctx : () => context", "mosanic.d.ts\n        ');
        // monaco.editor.defineTheme('mosanic', {
        //     base: 'vs',
        //     inherit: true,
        //     rules: [],
        //     colors: {
        //         'editor.background': '#333333',
        //     },
        // });
        editorRef.current = editor;
    };
    var _name = _param.//Essential
    name, name = _name === void 0 ? "" : _name, _type = _param.type, type = _type === void 0 ? "text" : _type, _value = _param.value, value = _value === void 0 ? null : _value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _label = _param.//Overwrite
    label, label = _label === void 0 ? null : _label, _language = _param.language, language = _language === void 0 ? "javascript" : _language, _fullWidth = _param.//Styling
    fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _small = _param.small, small = _small === void 0 ? null : _small, _size = _param.size, size = _size === void 0 ? null : _size, _wrap = _param.wrap, wrap = _wrap === void 0 ? false : _wrap, _noBorder = _param.noBorder, noBorder = _noBorder === void 0 ? false : _noBorder, _valid = _param.//Validation
    valid, valid = _valid === void 0 ? null : _valid, _empty = _param.empty, empty = _empty === void 0 ? false : _empty, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _required = _param.required, required = _required === void 0 ? false : _required, _loading = _param.loading, loading = _loading === void 0 ? false : _loading, _ctx = _param.ctx, ctx = _ctx === void 0 ? null : _ctx, _showPreview = _param.showPreview, showPreview = _showPreview === void 0 ? false : _showPreview, _container = _param.container, container = _container === void 0 ? null : _container, _height = _param.height, height = _height === void 0 ? "200px" : _height, _maxHeight = _param.maxHeight, maxHeight = _maxHeight === void 0 ? "200px" : _maxHeight, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "name",
        "type",
        "value",
        "onChange",
        "label",
        "language",
        "fullWidth",
        "small",
        "size",
        "wrap",
        "noBorder",
        "valid",
        "empty",
        "disabled",
        "required",
        "loading",
        "ctx",
        "showPreview",
        "container",
        "height",
        "maxHeight"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(language || "javascript"), lang = ref[0], setLanguage = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(value), state = ref1[0], setState = ref1[1];
    var editorRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), focussed = ref2[0], setFocused = ref2[1];
    var onFocus = function() {
        return setFocused(true);
    };
    var onBlur = function() {
        return setFocused(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Input_Input_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .ZP.Container, {
        noBorder: noBorder,
        className: "input_field",
        focussed: focussed,
        disabled: disabled,
        size: size,
        style: {
            maxHeight: height >= maxHeight ? height : maxHeight,
            height: height
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Input_Input_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Label */ .ZP.Label, {
                shrink: Boolean(value || focussed),
                children: [
                    label ? label : name ? name : "",
                    required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input_Input_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Required */ .ZP.Required, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_8__/* .ConditionalWrapper */ .M, {
                when: showPreview,
                wrapper: function(children) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_items_Inputs__WEBPACK_IMPORTED_MODULE_9__/* .InlineGroup */ .a_, {
                        m: 0,
                        p: 0,
                        style: {
                            overflow: "hidden",
                            maxHeight: "100%",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                style: {
                                    overflow: "auto",
                                    width: "50%",
                                    height: "100%"
                                },
                                children: children
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PreviewCode__WEBPACK_IMPORTED_MODULE_10__/* .PreviewCode */ .r_, {
                                ctx: ctx,
                                value: onChange ? value : state
                            })
                        ]
                    });
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CodeEditor, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, other), {
                    loading: loading,
                    height: height,
                    width: "100%",
                    // theme="vs-dark"
                    defaultLanguage: lang,
                    onChange: function(val) {
                        return onChange ? onChange(val) : setState(val);
                    },
                    value: onChange ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_13__/* .isString */ .HD)(value) ? value : JSON.stringify(value) : state,
                    onMount: handleEditorDidMount,
                    options: editorOptions,
                    onFocus: function(e) {
                        if (other === null || other === void 0 ? void 0 : other.onFocus) other.onFocus(e);
                        onFocus();
                    },
                    onBlur: function(e) {
                        if (other === null || other === void 0 ? void 0 : other.onBlur) other.onBlur(e);
                        onBlur();
                    }
                }))
            })
        ]
    });
};


/***/ }),

/***/ 59389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r_": function() { return /* binding */ PreviewCode; },
/* harmony export */   "zY": function() { return /* binding */ parseCode; }
/* harmony export */ });
/* unused harmony export useParseCode */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2921);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68311);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Button_Buttons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47914);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77298);







var demo = {
    text: "info",
    arr: [
        20220,
        1,
        22,
        25,
        {
            test: "value",
            arr: [
                "a",
                "b",
                "c"
            ]
        }
    ],
    nested: {
        extra: "text",
        sub: "text",
        num: 89
    },
    dateTest: new Date()
};
// todo add : https://www.npmjs.com/package/sandbox on server
var restricted = [
    "eval",
    "innerHTML",
    "version",
    "process.env",
    "process",
    "env",
    "password",
    "secret",
    "restricted",
    "restrict",
    "require",
    "function",
    "console",
    "yaml",
    "execute"
];
// const (?:^|\W)single_word(?:$|\W)
var parseCode = function(code, ctx) {
    var returnCtx = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var mosanic_context = ctx;
    code = code ? code.replace(RegExp("[\\u{0080}-\\u{FFFF}]", "gu"), "") : "wrong chars";
    if ((0,_util_Text__WEBPACK_IMPORTED_MODULE_3__/* .matchSubstrList */ .OV)((0,_util_Text__WEBPACK_IMPORTED_MODULE_3__/* .toLowCase */ .Cc)(code), restricted)) return "restricted ";
    try {
        return eval((0,_util_Text__WEBPACK_IMPORTED_MODULE_3__/* .replaceParts */ .oE)(code, "$ctx", "mosanic_context"));
    } catch (e) {
        return returnCtx ? mosanic_context : null;
    }
};
var useParseCode = function(param) {
    var value = param.value, ctx = param.ctx;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), parsed = ref[0], setParsed = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timer;
        timer = setTimeout(function() {
            var code = parseCode(value, ctx) || null;
            setParsed(code);
        }, 1000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        ctx,
        value
    ]);
    return parsed;
};
var PreviewCode = function(param) {
    var value = param.value, ctx = param.ctx;
    var result = useParseCode({
        value: value,
        ctx: ctx
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("parsed"), view = ref[0], setView = ref[1];
    var toggle = function() {
        return setView(view === "parsed" ? "ctx" : "parsed");
    };
    var data = view === "parsed" ? {
        result: result
    } : ctx;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            width: "50%",
            fontSize: "12px",
            fontFamily: 'Menlo, Monaco, "Courier New", monospace',
            overflow: "auto",
            borderLeft: "2px solid ".concat(_mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].util.gray.light */ .ZP.util.gray.light),
            paddingLeft: "10px"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Buttons__WEBPACK_IMPORTED_MODULE_5__["default"], {
                onClick: function() {
                    return toggle();
                },
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .FileIcon */ .aAW, {}),
                right: true,
                ghost: true,
                float: true,
                style: {
                    right: 2
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", {
                children: JSON.stringify(data, undefined, 2)
            })
        ]
    });
};


/***/ }),

/***/ 39381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Color_ColorPicker; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/Icons/EditIcons.js
var EditIcons = __webpack_require__(75679);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Popper.js + 4 modules
var Popper = __webpack_require__(28932);
// EXTERNAL MODULE: ./src/features/colors/reducer.js
var reducer = __webpack_require__(74329);
// EXTERNAL MODULE: ./src/utils/color/Color.js
var Color = __webpack_require__(50606);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-color/es/index.js + 217 modules
var es = __webpack_require__(88233);
// EXTERNAL MODULE: ../../node_modules/react-color/lib/components/common/index.js
var common = __webpack_require__(92375);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var react_redux_es = __webpack_require__(64157);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(87567);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/Base.js
var Base = __webpack_require__(57348);
;// CONCATENATED MODULE: ./src/mosanic/fields/Color/ColorPicker.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: flex;\n    flex-wrap: wrap;\n    max-width: 320px;\n    min-width: 150px;\n    min-height: 30px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        transform: scale(1.01);\n        border: 1.5px solid rgba(3, 3, 3, 0.496);\n        box-shadow: 1px 1px 10px rgba(0,0,0,0.3);\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    width: 28px;\n    cursor: pointer!important;\n    height: 28px;\n    cursor: pointer;\n    position: relative;\n    outline: none!important;\n    border-radius: 4px;\n    margin: 2px;\n    transform: scale(0.9);\n    transition: all ease-in-out 0.3s;\n\n    &:hover {\n        transform: scale(1.01);\n    }\n\n    ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    width: 90px;\n    appearance: none;\n    border: 1px solid;\n    border-color: ",
        ";\n    color: ",
        ";\n    background: ",
        ";\n    box-shadow: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var ColorBoxes = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a132f36-0"
})(_templateObject());
var ColorBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a132f36-1"
})(_templateObject2(), function(props) {
    return props.active && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});
var ColorInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-4a132f36-2"
})(_templateObject3(), function(props) {
    return props.color;
}, function(props) {
    return (0,Color/* invertColor */.qd)(props, color, true);
}, function(props) {
    return props.color;
}, function(props) {
    return "1px 1px 7.5px ".concat((0,Color/* getRGB */.WJ)(props.hex, "0.7"));
});
var ColorPickerStyles = {
    ColorBoxes: ColorBoxes,
    ColorBox: ColorBox,
    ColorInput: ColorInput
};
/* harmony default export */ var ColorPicker_styles = (ColorPickerStyles);

;// CONCATENATED MODULE: ./src/mosanic/fields/Color/ColorPicker.js





function ColorPicker_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    flex-wrap: wrap;\n"
    ]);
    ColorPicker_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var defaultValue = "#FFFFFF";
var wheel = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    version: "1.1",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15px",
    height: "15px",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M0.877075,7.49985c0,-3.65769 2.96515,-6.62284 6.62284,-6.62284c3.65769,0 6.62279,2.96515 6.62279,6.62284c0,3.65765 -2.9651,6.62285 -6.62279,6.62285c-3.65769,0 -6.62284,-2.9652 -6.62284,-6.62285Zm2.90428,-4.2842c0.90163,-0.78326 2.05294,-1.28661 3.31863,-1.37476v4.6934l-3.31863,-3.31864Zm-0.56568,0.56569c-0.78325,0.90164 -1.28658,2.05294 -1.37472,3.31863h4.69335l-3.31863,-3.31863Zm3.31863,4.11863h-4.69333c0.08819,1.26565 0.59156,2.41693 1.37482,3.31853l3.31851,-3.31853Zm-2.75281,3.88423c0.90161,0.7831 2.05286,1.2865 3.31849,1.3746v-4.69314l-3.31849,3.31854Zm4.11849,-3.31854v4.69314c1.26561,-0.0882 2.41682,-0.5915 3.31842,-1.3747l-3.31842,-3.31844Zm3.88412,2.75274c0.7832,-0.9016 1.2866,-2.05282 1.3747,-3.31843h-4.69313l3.31843,3.31843Zm-3.31843,-4.11843h4.69323c-0.0882,-1.26565 -0.5915,-2.41692 -1.3747,-3.31854l-3.31853,3.31854Zm2.75283,-3.88424c-0.9016,-0.78327 -2.05285,-1.28664 -3.31852,-1.37483v4.69339l3.31852,-3.31856Z",
        fill: "#000",
        fillRule: "evenodd"
    })
});
var Container = (0,styled_components_browser_esm/* default */.ZP)(Base/* default */.ZP).withConfig({
    componentId: "sc-b75351fb-0"
})(ColorPicker_templateObject());
var ColorPicker = function(_param) {
    var _value = _param.value, value = _value === void 0 ? {
        hex: defaultValue
    } : _value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _advanced = _param.advanced, advanced = _advanced === void 0 ? true : _advanced, _label = _param.label, label = _label === void 0 ? "Color" : _label, _boxes = _param.boxes, boxes = _boxes === void 0 ? false : _boxes, other = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange",
        "advanced",
        "label",
        "boxes"
    ]);
    var paletteColors = (0,react_redux_es/* useSelector */.v9)(reducer/* paletteColorsSelector */.NR);
    var simplePalette = (0,react_redux_es/* useSelector */.v9)(reducer/* simplePaletteSelector */.xj);
    var colors = (0,react_redux_es/* useSelector */.v9)(reducer/* colorsSelector */.qQ);
    var ref = (0,react.useState)(value), local = ref[0], setLocal = ref[1];
    var ref1 = (0,react.useState)(false), manual = ref1[0], setManual = ref1[1];
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            if ((local === null || local === void 0 ? void 0 : local.hex) != defaultValue && manual && onChange) {
                console.log(local);
                setManual(false);
            }
        }, 500);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        onChange,
        local,
        manual
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (local === null || local === void 0 ? void 0 : (ref = local.hex) === null || ref === void 0 ? void 0 : ref.hex) setLocal(local.hex.hex);
    }, [
        local
    ]);
    var handleChange = function(color) {
        var direct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref;
        var _$hex = (color === null || color === void 0 ? void 0 : color.hex) ? color.hex : color;
        var colorValue = (0,_object_spread/* default */.Z)({
            hex: _$hex,
            rgb: (color === null || color === void 0 ? void 0 : (ref = color.rgb) === null || ref === void 0 ? void 0 : ref.a) != 1 ? color.rgb : undefined
        }, (0,reducer/* colorByHexSelector */.wt)(colors, _$hex));
        setManual(true);
        if (direct) onChange(colorValue);
        setLocal(colorValue);
    };
    var styles = {
        input: {
            border: (value === null || value === void 0 ? void 0 : value.hex) ? "1px solid ".concat(value === null || value === void 0 ? void 0 : value.hex) : "none",
            width: "90px",
            borderRadius: "6px",
            outline: "none",
            transform: "scale(0.9)",
            transformOrigin: "top",
            appearance: "none",
            marginTop: boxes ? 0 : "4px",
            boxShadow: boxes ? "1px 1px 7.5px " + (0,Color/* getRGB */.WJ)(value === null || value === void 0 ? void 0 : value.hex, "0.4") : null,
            background: value === null || value === void 0 ? void 0 : value.hex,
            fontSize: "12px",
            color: (0,Color/* invertColor */.qd)(value === null || value === void 0 ? void 0 : value.hex, true)
        }
    };
    var getActiveState = function(colorCheck) {
        return colorCheck && colorCheck.toString() === (value === null || value === void 0 ? void 0 : value.hex) ? {
            boxShadow: "1px 1px 7.5px " + (0,Color/* getRGB */.WJ)(colorCheck, "0.4")
        } : null;
    };
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,Base/* useBaseField */.z)((0,_object_spread/* default */.Z)({}, other)), 3), focussed = ref2[0], onFocus = ref2[1], onBlur = ref2[2];
    var props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        focussed: focussed,
        label: label,
        value: true,
        onFocus: onFocus,
        onBlur: onBlur
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: "customPicker",
        style: {
            justifyContent: "space-between"
        },
        children: [
            boxes && /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker_styles.ColorBoxes, {
                children: paletteColors && paletteColors.map(function(colorOption) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker_styles.ColorBox, {
                        active: (0,Text/* toLowCase */.Cc)(colorOption === null || colorOption === void 0 ? void 0 : colorOption.value) === (0,Text/* toLowCase */.Cc)(local === null || local === void 0 ? void 0 : local.hex),
                        "data-title": colorOption.value,
                        style: (0,_object_spread/* default */.Z)({
                            background: colorOption.value
                        }, getActiveState(colorOption === null || colorOption === void 0 ? void 0 : colorOption.value)),
                        onClick: function() {
                            return handleChange(colorOption.value, true);
                        }
                    }, colorOption.value);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "-inline",
                children: advanced ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* EditableInput */.Vm, {
                    style: {
                        input: styles.input
                    },
                    className: "colorInput",
                    value: (value === null || value === void 0 ? void 0 : value.hex) ? value.hex : defaultValue,
                    onChange: handleChange,
                    disabled: !advanced
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker_styles.ColorInput, {
                    color: local === null || local === void 0 ? void 0 : local.hex,
                    hex: hex,
                    className: "colorInput",
                    value: (value === null || value === void 0 ? void 0 : value.hex) ? value.hex : defaultValue,
                    type: "text",
                    disabled: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* ButtonGroup */.h, {
                width: 60,
                my: 0,
                style: {
                    border: "none"
                },
                children: [
                    advanced && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                        customClass: "-large -scaleDown",
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons["default"], {
                            ghost: true,
                            style: {
                                width: "30px",
                                minWidth: "30px"
                            },
                            tooltip: "Select a custom color",
                            icon: wheel
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SketchPicker */.xS, {
                            className: "backgroundPicker",
                            triangle: "hide",
                            color: (local === null || local === void 0 ? void 0 : local.rgb) ? local.rgb : (local === null || local === void 0 ? void 0 : local.hex) ? local.hex : local,
                            presetColors: !boxes ? simplePalette : [],
                            // onChangeComplete={ handleChangeComplete } 
                            onChange: handleChange
                        })
                    }),
                    local && /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons["default"], {
                        ghost: true,
                        style: {
                            width: "30px",
                            minWidth: "30px"
                        },
                        disabled: (local === null || local === void 0 ? void 0 : local.hex) === defaultValue,
                        onClick: function() {
                            setLocal("");
                            onChange(null);
                        },
                        tooltip: "Clear color",
                        icon: EditIcons/* trash */._I
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Color_ColorPicker = (ColorPicker);


/***/ }),

/***/ 21117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _items_Inputs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99057);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37726);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_datepicker__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79192);
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55217);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2921);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68311);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62570);





// import { Select as Selector } from "./External";








var Field = (react_datepicker__WEBPACK_IMPORTED_MODULE_3___default());
/* ${BaseField} */ var DatePicker = function(_param) {
    var _name = _param.//Essential
    name, name = _name === void 0 ? "" : _name, _value = _param.value, value = _value === void 0 ? null : _value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _label = _param.//Overwrite
    label, label = _label === void 0 ? null : _label, _fullWidth = _param.//Styling
    fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _small = _param.small, small = _small === void 0 ? null : _small, _size = _param.size, size = _size === void 0 ? null : _size, _wrap = _param.wrap, wrap = _wrap === void 0 ? false : _wrap, _center = _param.center, center = _center === void 0 ? false : _center, _defaultValue = _param.//Specific
    defaultValue, defaultValue = _defaultValue === void 0 ? null : _defaultValue, _valid = _param.//Validation
    valid, valid = _valid === void 0 ? null : _valid, _empty = _param.empty, empty = _empty === void 0 ? false : _empty, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _required = _param.required, required = _required === void 0 ? false : _required, _innerRef = _param.innerRef, innerRef = _innerRef === void 0 ? null : _innerRef, _noCase = _param.noCase, noCase = _noCase === void 0 ? false : _noCase, _timeOnly = _param.timeOnly, timeOnly = _timeOnly === void 0 ? false : _timeOnly, _range = _param.range, range = _range === void 0 ? false : _range, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "name",
        "value",
        "onChange",
        "label",
        "fullWidth",
        "small",
        "size",
        "wrap",
        "center",
        "defaultValue",
        "valid",
        "empty",
        "disabled",
        "required",
        "innerRef",
        "noCase",
        "timeOnly",
        "range"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), focussed = ref[0], setFocused = ref[1];
    var onFocus = function() {
        return setFocused(true);
    };
    var onBlur = function() {
        return setFocused(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_items_Inputs__WEBPACK_IMPORTED_MODULE_5__/* .WrapInput */ .Vw, {
        wrap: wrap ? wrap : false,
        fullWidth: fullWidth,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .ZP.Container, {
            className: "input_field",
            focussed: focussed,
            disabled: disabled,
            valid: valid,
            empty: empty,
            size: size,
            center: center,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Label */ .ZP.Label, {
                    shrink: Boolean((innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) || value || focussed),
                    noCase: noCase,
                    children: [
                        label ? label : name ? name : "",
                        required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Required */ .ZP.Required, {})
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Field, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                    className: "noborder",
                    style: {
                        border: "none"
                    },
                    ref: innerRef,
                    fullWidth: fullWidth,
                    size: small ? "small" : size ? size : null
                }, other), {
                    disabled: disabled,
                    minDate: new Date(),
                    selected: range ? Array.isArray(range) ? (value === null || value === void 0 ? void 0 : value[0]) || null : null : (0,_util_Text__WEBPACK_IMPORTED_MODULE_9__/* .containsSubstr */ .xX)(value, "T") ? new Date(value.split("T")[0]) : value || null,
                    onChange: function(val) {
                        return range ? onChange(val) : onChange((0,_util_Obj__WEBPACK_IMPORTED_MODULE_10__/* .removeUndefined */ .o2)(val));
                    },
                    onFocus: function(e) {
                        if (other === null || other === void 0 ? void 0 : other.onFocus) other.onFocus(e);
                        onFocus();
                    },
                    onBlur: function(e) {
                        if (other === null || other === void 0 ? void 0 : other.onBlur) other.onBlur(e);
                        onBlur();
                    },
                    selectsRange: range,
                    startDate: range ? Array.isArray(value) ? (value === null || value === void 0 ? void 0 : value[0]) || new Date() : new Date() : null,
                    endDate: range ? Array.isArray(value) ? (value === null || value === void 0 ? void 0 : value[1]) || new Date() : new Date() : null,
                    // onBlur={(e) => {
                    //     if(other?.onBlur) other.onBlur(e)
                    //     onBlur();
                    // }}
                    calendarClassName: "small-calendar ".concat(timeOnly ? "timeOnly" : "")
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                    children: "\n                    .small-calendar.timeOnly .react-datepicker__month-container {display: none;}\n                    .noborder {width: 100%; border: none !important;font-size: 12px; background: transparent;}.noborder:focus {outline: none !important;}\n                    .small-calendar {transform: scale(0.9); transform-origin: bottom center; padding: 10px; border: 1px solid  ".concat(_mosanic_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"].util.gray.base */ .ZP.util.gray.base, ";}\n                    .small-calendar .react-datepicker__day--outside-month {opacity: 0.4;}\n                    .small-calendar .react-datepicker__day--outside-month:hover {opacity: 0.9;}\n                    .small-calendar .react-datepicker__day--selected,\n                    .small-calendar .react-datepicker__time-list-item--selected {background-color: ").concat(_mosanic_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"].util.primary.dark */ .ZP.util.primary.dark, "!important; font-weight: bold; }\n                    .small-calendar .react-datepicker__time-list-item--selected {border-radius: 5px; transform: scale(0.9);font-size: 14px; line-height: 18px;width: 90%;margin-left: 5%;}\n                    .small-calendar .react-datepicker__header {background: none; border: none; }\n                    .small-calendar .react-datepicker__navigation {margin: 15px 0;transform-origin: center center; transform: scale(0.8);}\n                    .small-calendar .react-datepicker__time-container {border: none; margin-left: 5px;}\n                    .small-calendar .react-datepicker__triangle {display: none;}\n                ")
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DatePicker);


/***/ }),

/***/ 35134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ InlineChromiumBugfix; },
/* harmony export */   "a": function() { return /* binding */ EditableButtonComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26021);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  margin: 0 0.1em;\n  background-color: #efefef;\n  padding: 2px 6px;\n  border: 1px solid #767676;\n  border-radius: 2px;\n  font-size: 0.9em;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Span = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-10268493-0"
})(_templateObject(), function(props) {
    return props.render;
});
// Chromium bug:
// https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
var InlineChromiumBugfix = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
        contentEditable: false,
        className: "hiddenFont",
        style: {
            fontSize: "0 !important;"
        },
        children: [
            "$",
            String.fromCodePoint(160)
        ]
    });
};
var EditableButtonComponent = function(param) {
    var style = param.style, attributes = param.attributes, children = param.children;
    return(/*
      Note that this is not a true button, but a span with button-like CSS.
    */ /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Span, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, attributes), {
        onClick: function(ev) {
            return ev.preventDefault();
        },
        // Margin is necessary to clearly show the cursor adjacent to the button
        render: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InlineChromiumBugfix, {}),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InlineChromiumBugfix, {})
        ]
    })));
};



/***/ }),

/***/ 12288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ Elements; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/jsx/Element.js
var Element = __webpack_require__(3679);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/mosanic/fields/Editor/Element.js
var Editor_Element = __webpack_require__(35134);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ../../node_modules/slate/dist/index.es.js
var index_es = __webpack_require__(203);
// EXTERNAL MODULE: ../../node_modules/slate-react/dist/index.es.js + 3 modules
var dist_index_es = __webpack_require__(67895);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/ImageElement.js







var SlateImage = function(param) {
    var attributes = param.attributes, children = param.children, element = param.element;
    var editor = (0,dist_index_es/* useSlateStatic */._7)();
    var path = dist_index_es/* ReactEditor.findPath */.F3.findPath(editor, element);
    var selected = (0,dist_index_es/* useSelected */.vt)();
    var focused = (0,dist_index_es/* useFocused */.UE)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    position: "relative"
                },
                contentEditable: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: element.url,
                        style: {
                            maxHeight: "20em",
                            width: "auto"
                        }
                    }),
                    selected && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Buttons, {
                        style: {
                            position: "absolute",
                            top: 5,
                            left: 0,
                            zIndex: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons["default"], {
                                active: true,
                                ghost: true,
                                onClick: function() {
                                    return index_es/* Transforms.removeNodes */.YR.removeNodes(editor, {
                                        at: path
                                    });
                                },
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TrashIcon */.XHJ, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons["default"], {
                                active: true,
                                ghost: true,
                                onClick: function() {
                                    return index_es/* Transforms.removeNodes */.YR.removeNodes(editor, {
                                        at: path
                                    });
                                },
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* Pencil1Icon */.JtS, {})
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var ImageElement = (SlateImage);

;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Elements.js








var LinkComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5555).then(__webpack_require__.bind(__webpack_require__, 95555));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95555)
            ];
        }
    }
});
var LinkProd = function(param) {
    var style = param.style, attributes = param.attributes, url = param.url, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
        href: url,
        style: style,
        children: children
    }));
};
var Elements = function(param) {
    var attributes = param.attributes, children = param.children, element = param.element, _prod = param.prod, prod = _prod === void 0 ? false : _prod;
    var style = {
        textAlign: element === null || element === void 0 ? void 0 : element.align
    };
    if ((0,Text/* containsSubstr */.xX)(element.type, "heading")) {
        var heading = {
            level: (0,Text/* startSubString */.J$)(element.type, "heading-"),
            other: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                style: style
            })
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element/* HeadingTag */.lb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heading), {
            children: children
        }));
    }
    switch(element.type){
        case "image":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageElement, {
                attributes: attributes,
                element: element,
                children: children
            });
        case "block-quote":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: style
            }, attributes), {
                children: children
            }));
        case "bulleted-list":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: style
            }, attributes), {
                children: children
            }));
        case "list-item":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: style
            }, attributes), {
                children: children
            }));
        case "numbered-list":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: style
            }, attributes), {
                children: children
            }));
        case "link":
            var url = (0,Text/* containsSubstr */.xX)(element === null || element === void 0 ? void 0 : element.url, "//") ? "/" : element === null || element === void 0 ? void 0 : element.url;
            return prod ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkProd, {
                style: style,
                attributes: attributes,
                url: url,
                children: children
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComponent, {
                style: style,
                attributes: attributes,
                url: url,
                prod: prod,
                children: children
            });
        case "button":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor_Element/* EditableButtonComponent */.a, {
                style: style,
                attributes: attributes,
                children: children
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: style
            }, attributes), {
                children: children
            }));
    }
};



/***/ }),

/***/ 32801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getInitialContent; }
/* harmony export */ });
var getInitialContent = function() {
    var content = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", wrapper = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
    if (!Array.isArray(content)) {
        content = [
            {
                type: wrapper,
                children: [
                    {
                        text: content ? content === null || content === void 0 ? void 0 : content.toString() : ""
                    }
                ]
            }
        ];
    }
    ;
    return content;
};


/***/ }),

/***/ 15043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Leaf; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);



var Leaf = function(param) {
    var attributes = param.attributes, children = param.children, leaf = param.leaf, _prod = param.prod, prod = _prod === void 0 ? false : _prod;
    if (leaf.bold) {
        children = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
            children: children
        });
    }
    if (leaf.italic) {
        children = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
            children: children
        });
    }
    if (leaf.underline) {
        children = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
            children: children
        });
    }
    if (leaf.code) {
        children = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("code", {
            children: children
        });
    }
    // // For inline at the end of a block, put the cursor inside the final {text: ''} node
    // if (leaf.link || leaf.button) {
    //   children = 
    //     <span className={css` padding-left: 0.1px; `}>
    //       {children}
    //     </span>
    // }
    if (prod) return children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        // The following is a workaround for a Chromium bug where,
        // if you have an inline at the end of a block,
        // clicking the end of a block puts the cursor inside the inline
        // instead of inside the final {text: ''} node
        // https://github.com/ianstormtaylor/slate/issues/4704#issuecomment-1006696364
        style: {
            paddingLeft: leaf.text === "" ? "0.1px;" : null
        }
    }, attributes), {
        children: children
    }));
// return <span {...attributes}>{children}</span>
};


/***/ }),

/***/ 50703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12288);
/* harmony import */ var _Leaf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15043);
// import { useCallback, useMemo } from 'react'
// import { createEditor } from 'slate'
// import { withHistory } from 'slate-history'
// import { Editable, Slate, withReact } from 'slate-react'






var RenderContent = function(content) {
    return Array.isArray(content) ? content.map(function(element, topI) {
        var ref;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Elements__WEBPACK_IMPORTED_MODULE_2__/* .Elements */ .e, {
            element: element,
            prod: true,
            children: element === null || element === void 0 ? void 0 : (ref = element.children) === null || ref === void 0 ? void 0 : ref.map(function(child, childI) {
                /*#__PURE__*/ return (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_Leaf__WEBPACK_IMPORTED_MODULE_3__/* .Leaf */ .B, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, child), {
                    leaf: child,
                    prod: true,
                    key: childI
                }), (child === null || child === void 0 ? void 0 : child.type) ? RenderContent([
                    child
                ]) : child === null || child === void 0 ? void 0 : child.text);
            })
        }, topI);
    }) : [];
};
var Text = function(param) {
    var content = param.content, children = param.children;
    // const editor = useMemo(() => withReact(withHistory(createEditor())), [])
    // const renderElement = useCallback(props => <Elements {...props} />, [])
    // const renderLeaf = useCallback(props => <Leaf {...props}/>, [])
    content = content ? content : children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: RenderContent(content)
    });
// return (
//   <Slate editor={editor} value={content ? content : children}>
//     <Editable 
//       renderLeaf={renderLeaf}
//       renderElement={renderElement}
//       readOnly
//     />
//   </Slate>
// )
};
/* harmony default export */ __webpack_exports__["Z"] = (Text);


/***/ }),

/***/ 77469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h_": function() { return /* binding */ Portal; },
/* harmony export */   "o8": function() { return /* binding */ Toolbar; },
/* harmony export */   "v2": function() { return /* binding */ Menu; },
/* harmony export */   "xv": function() { return /* binding */ Text; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony exports EditorValue, Icon, Instruction */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28316);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26021);
/* eslint-disable react/display-name */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  cursor: pointer;\n  color: ",
        ";\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    font-size: 14px;\n    padding: 5px 20px;\n    color: #404040;\n    border-top: 2px solid #eeeeee;\n    background: #f8f8f8;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  color: #404040;\n  font: 12px monospace;\n  white-space: pre-wrap;\n  padding: 10px 20px;\n  div {\n    margin: 0 0 0.5em;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  text-transform: uppercase;\n  font-size: 14px !important;\n  vertical-align: text-bottom;\n  padding: 0 5px;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  white-space: pre-wrap;\n    margin: 0 -20px 10px;\n    padding: 10px 20px;\n    font-size: 14px;\n    background: #f8f8e8;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  & > * {\n    display: inline-block;\n  }\n\n  & > * + * {\n    margin-left: 15px;\n  }\n\n    position: relative;\n    margin: 0;\n    ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var Btn = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-2cfd95a8-0"
})(_templateObject(), function(props) {
    return props.reversed ? props.active ? "#fff" : "#aaa" : props.active ? "#1082e9" : "#a5a5a5";
}, function(props) {
    return props.reversed ? props.active ? "#d0d0d0" : "#939393" : props.active ? "#0b5aa2" : "#6f6f6f";
});
var ValAsTxt = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2cfd95a8-1"
})(_templateObject1());
var TxtLines = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2cfd95a8-2"
})(_templateObject2());
var TxtBtn = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-2cfd95a8-3"
})(_templateObject3());
var TextInstr = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2cfd95a8-4"
})(_templateObject4());
var Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, active = _param.active, reversed = _param.reversed, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className",
        "active",
        "reversed"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Btn, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        ref: ref,
        className: className,
        reversed: reversed,
        active: active
    }));
});
var Mnu = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2cfd95a8-5"
})(_templateObject5(), function(props) {
    return props.auto ? "\n      padding: 1px 18px 5px;\n      border-bottom: 2px solid #eee;\n      margin-bottom: 20px;\n    " : "\n    margin-top: -px;\n    > span {\n      margin: 2px 6px;\n    }\n    ";
});
var EditorValue = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(_param, ref) {
    var className = _param.className, value = _param.value, props = _object_without_properties(_param, [
        "className",
        "value"
    ]);
    var textLines = value.document.nodes.map(function(node) {
        return node.text;
    }).toArray().join("\n");
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        ref: ref
    }, props), {
        className: className,
        style: {
            margin: "30px -20px 0"
        },
        children: [
            /*#__PURE__*/ _jsx(ValAsTxt, {
                children: "Value as text"
            }),
            /*#__PURE__*/ _jsx(TxtLines, {
                children: textLines
            })
        ]
    }));
})));
var Icon = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    return _jsx("span", _object_spread_props(_object_spread({}, props), {
        ref: ref,
        className: "mosanic-icon " + className,
        style: {
            fontSize: "18px",
            verticalAlign: "text-bottom"
        },
        children: /*#__PURE__*/ _jsx(EditorIcon, {
            icon: props.children
        })
    }));
})));
var Text = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TxtBtn, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        ref: ref,
        className: "mosanic-text " + className,
        children: props.children
    }));
});
var Instruction = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    return _jsx(TextInstr, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        className: className
    }));
})));
var Menu = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, _auto = _param.auto, auto = _auto === void 0 ? true : _auto, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className",
        "auto"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Mnu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        ref: ref,
        auto: auto,
        className: className
    }));
});
var Portal = function(param) {
    var children = param.children;
    return typeof document === "object" ? /*#__PURE__*/ react_dom__WEBPACK_IMPORTED_MODULE_3__.createPortal(children, document.body) : null;
};
var Toolbar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, minified = _param.minified, _location = _param.location, location = _location === void 0 ? "auto" : _location, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className",
        "minified",
        "location"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Menu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        ref: ref,
        auto: !minified && location === "auto",
        className: className
    }));
});



/***/ }),

/***/ 28970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "InlineEditor": function() { return /* reexport */ InlineEditor; },
  "Serialize": function() { return /* reexport */ serialize; },
  "Text": function() { return /* reexport */ Text/* default */.Z; },
  "default": function() { return /* binding */ fields_Editor; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/slate/dist/index.es.js
var index_es = __webpack_require__(203);
// EXTERNAL MODULE: ../../node_modules/slate-react/dist/index.es.js + 3 modules
var dist_index_es = __webpack_require__(67895);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/Input.styles.js
var Input_styles = __webpack_require__(55217);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(78545);
;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Editor.style.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n    display: block;\n\n    [role="textbox"] {\n        ',
        "\n    }\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Container = Input_styles/* default.Container */.ZP.Container;
var EditorContainer = (0,styled_components_browser_esm/* default */.ZP)(Container).withConfig({
    componentId: "sc-a2979e3-0"
})(_templateObject(), Input_styles/* default.BaseField */.ZP.BaseField, index_esm/* layout */.bK, index_esm/* space */.Dh);
var EditorLabel = Input_styles/* default.Label */.ZP.Label;

// EXTERNAL MODULE: ./src/mosanic/fields/Editor/Elements.js + 1 modules
var Elements = __webpack_require__(12288);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Constants.js
var LIST_TYPES = [
    "numbered-list",
    "bulleted-list"
];
var TEXT_ALIGN_TYPES = [
    "left",
    "center",
    "right",
    "justify"
];
var HEADING_TYPES = [
    "heading-1",
    "heading-2",
    "heading-3",
    "heading-4",
    "heading-5",
    "heading-6"
];


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Validate.js



var isBlockActive = function(editor, format) {
    var blockType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "type";
    var selection = editor.selection;
    if (!selection) return false;
    var ref = (0,_sliced_to_array/* default */.Z)(Array.from(index_es/* Editor.nodes */.ML.nodes(editor, {
        at: index_es/* Editor.unhangRange */.ML.unhangRange(editor, selection),
        match: function(n) {
            return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && (n[blockType] === format || "headings" === format && HEADING_TYPES.includes(n[blockType]));
        }
    })), 1), match = ref[0];
    return !!match;
};
var isFormatActive = function(editor, format) {
    var ref;
    if (!((ref = index_es/* Editor.nodes */.ML.nodes(editor)) === null || ref === void 0 ? void 0 : ref[0])) return;
    var ref1 = (0,_sliced_to_array/* default */.Z)(index_es/* Editor.nodes */.ML.nodes(editor, {
        match: function(n) {
            return (n === null || n === void 0 ? void 0 : n[format]) === true;
        },
        mode: "all"
    }), 1), match = ref1[0];
    return !!match;
};
var isMarkActive = function(editor, format) {
    var marks = index_es/* Editor.marks */.ML.marks(editor);
    return marks ? marks[format] === true : false;
};
var isLinkActive = function(editor) {
    var ref = (0,_sliced_to_array/* default */.Z)(index_es/* Editor.nodes */.ML.nodes(editor, {
        match: function(n) {
            return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && n.type === "link";
        }
    }), 1), link = ref[0];
    return !!link;
};
var isButtonActive = function(editor) {
    var ref = (0,_sliced_to_array/* default */.Z)(index_es/* Editor.nodes */.ML.nodes(editor, {
        match: function(n) {
            return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && n.type === "button";
        }
    }), 1), button = ref[0];
    return !!button;
};
var Validate = {
    isBlockActive: isBlockActive,
    isFormatActive: isFormatActive,
    isMarkActive: isMarkActive,
    //Inline elements
    isLinkActive: isLinkActive,
    isButtonActive: isButtonActive
};
/* harmony default export */ var Editor_Validate = (Validate);

;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Handler/Toggle.js




var toggleBlock = function(editor, format) {
    var isActive = Editor_Validate.isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? "align" : "type");
    var isList = LIST_TYPES.includes(format);
    index_es/* Transforms.unwrapNodes */.YR.unwrapNodes(editor, {
        match: function(n) {
            return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && LIST_TYPES.includes(n.type) && !TEXT_ALIGN_TYPES.includes(format);
        },
        split: true
    });
    var newProperties;
    if (TEXT_ALIGN_TYPES.includes(format)) {
        newProperties = {
            align: isActive ? undefined : format
        };
    } else {
        newProperties = {
            type: isActive ? "paragraph" : isList ? "list-item" : format
        };
    }
    index_es/* Transforms.setNodes */.YR.setNodes(editor, newProperties);
    if (!isActive && isList) {
        var block = {
            type: format,
            children: []
        };
        index_es/* Transforms.wrapNodes */.YR.wrapNodes(editor, block);
    }
};
var Toggle_toggleFormat = function(editor, format) {
    var isActive = Editor_Validate.isFormatActive(editor, format);
    index_es/* Transforms.setNodes */.YR.setNodes(editor, (0,_define_property/* default */.Z)({}, format, isActive ? null : true), {
        match: index_es/* Text.isText */.xv.isText,
        split: true
    });
};
var toggleMark = function(editor, format) {
    var isActive = Editor_Validate.isMarkActive(editor, format);
    if (isActive) {
        index_es/* Editor.removeMark */.ML.removeMark(editor, format);
    } else {
        index_es/* Editor.addMark */.ML.addMark(editor, format, true);
    }
};
var Toggle = {
    toggleBlock: toggleBlock,
    toggleFormat: Toggle_toggleFormat,
    toggleMark: toggleMark
};
/* harmony default export */ var Handler_Toggle = (Toggle);

;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Handler/BeforeInput.js

var BeforeInput = function(event) {
    event.preventDefault();
    switch(event.inputType){
        case "formatBold":
            return Handler_Toggle.toggleFormat(editor, "bold");
        case "formatItalic":
            return Handler_Toggle.toggleFormat(editor, "italic");
        case "formatUnderline":
            return Handler_Toggle, toggleFormat(editor, "underlined");
    }
};
/* harmony default export */ var Handler_BeforeInput = (BeforeInput);

// EXTERNAL MODULE: ../../node_modules/is-hotkey/lib/index.js
var lib = __webpack_require__(87202);
;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Handler/KeyDown.js


var KeyDown = function(event, editor) {
    var selection = editor.selection;
    // Default left/right behavior is unit:'character'.
    // This fails to distinguish between two cursor positions, such as
    // <inline>foo<cursor/></inline> vs <inline>foo</inline><cursor/>.
    // Here we modify the behavior to unit:'offset'.
    // This lets the user step into and out of the inline without stepping over characters.
    // You may wish to customize this further to only use unit:'offset' in specific cases.
    if (selection && index_es/* Range.isCollapsed */.e6.isCollapsed(selection)) {
        var nativeEvent = event.nativeEvent;
        if ((0,lib/* isKeyHotkey */.TB)("left", nativeEvent)) {
            event.preventDefault();
            index_es/* Transforms.move */.YR.move(editor, {
                unit: "offset",
                reverse: true
            });
            return;
        }
        if ((0,lib/* isKeyHotkey */.TB)("right", nativeEvent)) {
            event.preventDefault();
            index_es/* Transforms.move */.YR.move(editor, {
                unit: "offset"
            });
            return;
        }
        if (event.key === "enter") {
            return;
        }
    }
};
/* harmony default export */ var Handler_KeyDown = (KeyDown);

// EXTERNAL MODULE: ./src/mosanic/fields/Editor/Handler/Content.js
var Content = __webpack_require__(32801);
// EXTERNAL MODULE: ./src/mosanic/fields/Editor/Leaf.js
var Leaf = __webpack_require__(15043);
;// CONCATENATED MODULE: ./src/utils/Compose.js
var arg = function(x) {
    return x;
};
var compose = function(next, func) {
    return function(inputArg) {
        return next(func(inputArg));
    };
};
var composeFunctions = function() {
    for(var _len = arguments.length, all = new Array(_len), _key = 0; _key < _len; _key++){
        all[_key] = arguments[_key];
    }
    return all.reduce(compose, arg);
};

// EXTERNAL MODULE: ../../node_modules/is-plain-object/dist/is-plain-object.mjs
var is_plain_object = __webpack_require__(66439);
;// CONCATENATED MODULE: ../../node_modules/slate-history/dist/index.es.js



var History = {
  /**
   * Check if a value is a `History` object.
   */
  isHistory(value) {
    return (0,is_plain_object/* isPlainObject */.P)(value) && Array.isArray(value.redos) && Array.isArray(value.undos) && (value.redos.length === 0 || index_es/* Operation.isOperationList */.OX.isOperationList(value.redos[0])) && (value.undos.length === 0 || index_es/* Operation.isOperationList */.OX.isOperationList(value.undos[0]));
  }

};

/**
 * Weakmaps for attaching state to the editor.
 */

var HISTORY = new WeakMap();
var SAVING = new WeakMap();
var MERGING = new WeakMap();
var HistoryEditor = {
  /**
   * Check if a value is a `HistoryEditor` object.
   */
  isHistoryEditor(value) {
    return History.isHistory(value.history) && index_es/* Editor.isEditor */.ML.isEditor(value);
  },

  /**
   * Get the merge flag's current value.
   */
  isMerging(editor) {
    return MERGING.get(editor);
  },

  /**
   * Get the saving flag's current value.
   */
  isSaving(editor) {
    return SAVING.get(editor);
  },

  /**
   * Redo to the previous saved state.
   */
  redo(editor) {
    editor.redo();
  },

  /**
   * Undo to the previous saved state.
   */
  undo(editor) {
    editor.undo();
  },

  /**
   * Apply a series of changes inside a synchronous `fn`, without merging any of
   * the new operations into previous save point in the history.
   */
  withoutMerging(editor, fn) {
    var prev = HistoryEditor.isMerging(editor);
    MERGING.set(editor, false);
    fn();
    MERGING.set(editor, prev);
  },

  /**
   * Apply a series of changes inside a synchronous `fn`, without saving any of
   * their operations into the history.
   */
  withoutSaving(editor, fn) {
    var prev = HistoryEditor.isSaving(editor);
    SAVING.set(editor, false);
    fn();
    SAVING.set(editor, prev);
  }

};

/**
 * The `withHistory` plugin keeps track of the operation history of a Slate
 * editor as operations are applied to it, using undo and redo stacks.
 *
 * If you are using TypeScript, you must extend Slate's CustomTypes to use
 * this plugin.
 *
 * See https://docs.slatejs.org/concepts/11-typescript to learn how.
 */

var withHistory = editor => {
  var e = editor;
  var {
    apply
  } = e;
  e.history = {
    undos: [],
    redos: []
  };

  e.redo = () => {
    var {
      history
    } = e;
    var {
      redos
    } = history;

    if (redos.length > 0) {
      var batch = redos[redos.length - 1];
      HistoryEditor.withoutSaving(e, () => {
        index_es/* Editor.withoutNormalizing */.ML.withoutNormalizing(e, () => {
          for (var op of batch) {
            e.apply(op);
          }
        });
      });
      history.redos.pop();
      history.undos.push(batch);
    }
  };

  e.undo = () => {
    var {
      history
    } = e;
    var {
      undos
    } = history;

    if (undos.length > 0) {
      var batch = undos[undos.length - 1];
      HistoryEditor.withoutSaving(e, () => {
        index_es/* Editor.withoutNormalizing */.ML.withoutNormalizing(e, () => {
          var inverseOps = batch.map(index_es/* Operation.inverse */.OX.inverse).reverse();

          for (var op of inverseOps) {
            e.apply(op);
          }
        });
      });
      history.redos.push(batch);
      history.undos.pop();
    }
  };

  e.apply = op => {
    var {
      operations,
      history
    } = e;
    var {
      undos
    } = history;
    var lastBatch = undos[undos.length - 1];
    var lastOp = lastBatch && lastBatch[lastBatch.length - 1];
    var overwrite = shouldOverwrite(op, lastOp);
    var save = HistoryEditor.isSaving(e);
    var merge = HistoryEditor.isMerging(e);

    if (save == null) {
      save = shouldSave(op);
    }

    if (save) {
      if (merge == null) {
        if (lastBatch == null) {
          merge = false;
        } else if (operations.length !== 0) {
          merge = true;
        } else {
          merge = shouldMerge(op, lastOp) || overwrite;
        }
      }

      if (lastBatch && merge) {
        if (overwrite) {
          lastBatch.pop();
        }

        lastBatch.push(op);
      } else {
        var batch = [op];
        undos.push(batch);
      }

      while (undos.length > 100) {
        undos.shift();
      }

      if (shouldClear(op)) {
        history.redos = [];
      }
    }

    apply(op);
  };

  return e;
};
/**
 * Check whether to merge an operation into the previous operation.
 */

var shouldMerge = (op, prev) => {
  if (op.type === 'set_selection') {
    return true;
  }

  if (prev && op.type === 'insert_text' && prev.type === 'insert_text' && op.offset === prev.offset + prev.text.length && index_es/* Path.equals */.y$.equals(op.path, prev.path)) {
    return true;
  }

  if (prev && op.type === 'remove_text' && prev.type === 'remove_text' && op.offset + op.text.length === prev.offset && index_es/* Path.equals */.y$.equals(op.path, prev.path)) {
    return true;
  }

  return false;
};
/**
 * Check whether an operation needs to be saved to the history.
 */


var shouldSave = (op, prev) => {
  if (op.type === 'set_selection' && (op.properties == null || op.newProperties == null)) {
    return false;
  }

  return true;
};
/**
 * Check whether an operation should overwrite the previous one.
 */


var shouldOverwrite = (op, prev) => {
  if (prev && op.type === 'set_selection' && prev.type === 'set_selection') {
    return true;
  }

  return false;
};
/**
 * Check whether an operation should clear the redos stack.
 */


var shouldClear = op => {
  if (op.type === 'set_selection') {
    return false;
  }

  return true;
};


//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Plugins/AutoReplace.js



var SHORTCUTS = {
    "*": "list-item",
    ">": "block-quote",
    "#": "heading-1",
    "##": "heading-2",
    "###": "heading-3",
    "####": "heading-4",
    "#####": "heading-5",
    "######": "heading-6"
};
var withShortCuts = function(editor) {
    var deleteBackward = editor.deleteBackward, insertText = editor.insertText;
    editor.insertText = function(text) {
        var selection = editor.selection;
        if (text === " " && selection && index_es/* Range.isCollapsed */.e6.isCollapsed(selection)) {
            var anchor = selection.anchor;
            var block = index_es/* Editor.above */.ML.above(editor, {
                match: function(n) {
                    return index_es/* Editor.isBlock */.ML.isBlock(editor, n);
                }
            });
            var path = block ? block[1] : [];
            var start = index_es/* Editor.start */.ML.start(editor, path);
            var range = {
                anchor: anchor,
                focus: start
            };
            var beforeText = index_es/* Editor.string */.ML.string(editor, range);
            var type = SHORTCUTS[beforeText];
            if (type) {
                // Transforms.select(editor, range)
                index_es/* Transforms.delete */.YR["delete"](editor);
                var newProperties = {
                    type: type
                };
                index_es/* Transforms.setNodes */.YR.setNodes(editor, newProperties, {
                    match: function(n) {
                        return index_es/* Editor.isBlock */.ML.isBlock(editor, n);
                    }
                });
                if (type === "list-item") {
                    var list = {
                        type: "bulleted-list",
                        children: []
                    };
                    index_es/* Transforms.wrapNodes */.YR.wrapNodes(editor, list, {
                        match: function(n) {
                            return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && n.type === "list-item";
                        }
                    });
                }
                return;
            }
        }
        insertText(text);
    };
    editor.deleteBackward = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var selection = editor.selection;
        if (selection && index_es/* Range.isCollapsed */.e6.isCollapsed(selection)) {
            var match = index_es/* Editor.above */.ML.above(editor, {
                match: function(n) {
                    return index_es/* Editor.isBlock */.ML.isBlock(editor, n);
                }
            });
            if (match) {
                var _match = (0,_sliced_to_array/* default */.Z)(match, 2), block = _match[0], path = _match[1];
                var start = index_es/* Editor.start */.ML.start(editor, path);
                if (!index_es/* Editor.isEditor */.ML.isEditor(block) && index_es/* Element.isElement */.W_.isElement(block) && block.type !== "paragraph" && index_es/* Point.equals */.E9.equals(selection.anchor, start)) {
                    var newProperties = {
                        type: "paragraph"
                    };
                    index_es/* Transforms.setNodes */.YR.setNodes(editor, newProperties);
                    if (block.type === "list-item") {
                        index_es/* Transforms.unwrapNodes */.YR.unwrapNodes(editor, {
                            match: function(n) {
                                return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && n.type === "bulleted-list";
                            },
                            split: true
                        });
                    }
                    return;
                }
            }
            deleteBackward.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
        }
    };
    return editor;
};

var withAutoReplace = function(editor) {
    return withShortCuts(editor);
};
/* harmony default export */ var AutoReplace = (withAutoReplace);

// EXTERNAL MODULE: ./src/utils/Url.js + 1 modules
var Url = __webpack_require__(98022);
;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Handler/Wrap.js


var wrapLink = function(editor, url) {
    if (Editor_Validate.isLinkActive(editor)) {
        unwrapLink(editor);
    }
    var selection = editor.selection;
    var isCollapsed = selection && index_es/* Range.isCollapsed */.e6.isCollapsed(selection);
    var link = {
        type: "link",
        url: url,
        children: isCollapsed ? [
            {
                text: url
            }
        ] : []
    };
    if (isCollapsed) {
        index_es/* Transforms.insertNodes */.YR.insertNodes(editor, link);
    } else {
        index_es/* Transforms.wrapNodes */.YR.wrapNodes(editor, link, {
            split: true
        });
        index_es/* Transforms.collapse */.YR.collapse(editor, {
            edge: "end"
        });
    }
};
var wrapButton = function(editor) {
    if (Editor_Validate.isButtonActive(editor)) {
        unwrapButton(editor);
    }
    var selection = editor.selection;
    var isCollapsed = selection && index_es/* Range.isCollapsed */.e6.isCollapsed(selection);
    var button = {
        type: "button",
        children: isCollapsed ? [
            {
                text: "Edit me!"
            }
        ] : []
    };
    if (isCollapsed) {
        index_es/* Transforms.insertNodes */.YR.insertNodes(editor, button);
    } else {
        index_es/* Transforms.wrapNodes */.YR.wrapNodes(editor, button, {
            split: true
        });
        index_es/* Transforms.collapse */.YR.collapse(editor, {
            edge: "end"
        });
    }
};
var unwrapLink = function(editor) {
    index_es/* Transforms.unwrapNodes */.YR.unwrapNodes(editor, {
        match: function(n) {
            return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && n.type === "link";
        }
    });
};
var unwrapButton = function(editor) {
    index_es/* Transforms.unwrapNodes */.YR.unwrapNodes(editor, {
        match: function(n) {
            return !index_es/* Editor.isEditor */.ML.isEditor(n) && index_es/* Element.isElement */.W_.isElement(n) && n.type === "button";
        }
    });
};
var Wrap = {
    wrapLink: wrapLink,
    wrapButton: wrapButton,
    unwrapLink: unwrapLink,
    unwrapButton: unwrapButton
};
/* harmony default export */ var Handler_Wrap = (Wrap);

;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Plugins/InlineElements.js


var withInlineElements = function(editor) {
    var insertData = editor.insertData, insertText = editor.insertText, isInline = editor.isInline;
    editor.isInline = function(element) {
        return [
            "link",
            "button"
        ].includes(element.type) || isInline(element);
    };
    editor.insertText = function(text) {
        if (text && (0,Url/* isUrl */.C)(text)) {
            Handler_Wrap.wrapLink(editor, text);
        } else {
            insertText(text);
        }
    };
    editor.insertData = function(data) {
        var text = data.getData("text/plain");
        if (text && (0,Url/* isUrl */.C)(text)) {
            Handler_Wrap.wrapLink(editor, text);
        } else {
            insertData(data);
        }
    };
    return editor;
};
/* harmony default export */ var InlineElements = (withInlineElements);

;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Handler/Insert.js


var insertLink = function(editor, url) {
    if (editor.selection) {
        Handler_Wrap.wrapLink(editor, url);
    }
};
var insertImage = function(editor, url) {
    var text = {
        text: ""
    };
    var image = {
        type: "image",
        url: url,
        children: [
            text
        ]
    };
    index_es/* Transforms.insertNodes */.YR.insertNodes(editor, image);
};
var insertButton = function(editor) {
    if (editor.selection) {
        Handler_Wrap.wrapButton(editor);
    }
};
var Insert = {
    insertLink: insertLink,
    insertImage: insertImage,
    insertButton: insertButton
};
/* harmony default export */ var Handler_Insert = (Insert);

;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Plugins/withImages.js



var withImages = function(editor) {
    var insertData = editor.insertData, isVoid = editor.isVoid;
    editor.isVoid = function(element) {
        return element.type === "image" ? true : isVoid(element);
    };
    editor.insertData = function(data) {
        var text = data.getData("text/plain");
        var files = data.files;
        if (files && files.length > 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var file = _step.value;
                    var reader = new FileReader();
                    var ref = (0,_sliced_to_array/* default */.Z)(file.type.split("/"), 1), mime = ref[0];
                    if (mime === "image") {
                        reader.addEventListener("load", function() {
                            var url = reader.result;
                            Handler_Insert.insertImage(editor, url);
                        });
                        reader.readAsDataURL(file);
                    }
                };
                for(var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else if ((0,Url/* isImageUrl */.h)(text)) {
            Handler_Insert.insertImage(editor, text);
        } else {
            insertData(data);
        }
    };
    return editor;
};
/* harmony default export */ var Plugins_withImages = (withImages);

;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Plugins/index.js






var withPlugins = composeFunctions(dist_index_es/* withReact */.BU, withHistory, AutoReplace, Plugins_withImages, InlineElements);

/* harmony default export */ var Plugins = (withPlugins);

;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Plugins/SingleLine.js


function withSingleLine(editor) {
    var normalizeNode = editor.normalizeNode;
    editor.normalizeNode = function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), node = _param[0], path = _param[1];
        if (path.length === 0) {
            if (editor.children.length > 1) {
                index_es/* Transforms.mergeNodes */.YR.mergeNodes(editor);
            }
        }
        return normalizeNode([
            node,
            path
        ]);
    };
    return editor;
}
/* harmony default export */ var SingleLine = (withSingleLine);

// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Popper.js + 4 modules
var Popper = __webpack_require__(28932);
// EXTERNAL MODULE: ./src/mosanic/styles/panels.js
var panels = __webpack_require__(42895);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(68875);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/mosanic/fields/Editor/Wrappers.js
var Wrappers = __webpack_require__(77469);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/mosanic/fields/TextField/Fields.js
var Fields = __webpack_require__(91639);
;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Components.js
/* eslint-disable react/display-name */ 


// import { AdvancedPicker } from '../Color';

var AdvancedPicker = dynamic_default()(function() {
    return Promise.all(/* import() | Advanced picker from Editor */[__webpack_require__.e(5092), __webpack_require__.e(9317)]).then(__webpack_require__.bind(__webpack_require__, 70006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70006)
            ];
        }
    }
});









var ButtonContent = function(param) {
    var icon = param.icon, text = param.text;
    return !text ? icon : /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers/* Text */.xv, {
        children: text
    });
};
var FormatButton = function(param) {
    var format = param.format, icon = param.icon, _text = param.text, text = _text === void 0 ? null : _text;
    var editor = (0,dist_index_es/* useSlate */.ui)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers/* Button */.zx, {
        reversed: true,
        active: Editor_Validate.isFormatActive(editor, format),
        onClick: function() {
            return Handler_Toggle.toggleFormat(editor, format);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContent, {
            icon: icon,
            text: text
        })
    });
};
var MarkButton = function(param) {
    var format = param.format, icon = param.icon;
    var editor = (0,dist_index_es/* useSlate */.ui)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers/* Button */.zx, {
        active: Editor_Validate.isMarkActive(editor, format),
        onMouseDown: function(event) {
            event.preventDefault();
            Handler_Toggle.toggleMark(editor, format);
        },
        children: icon
    });
};
var BlockButton = function(param) {
    var format = param.format, icon = param.icon, _formatGroup = param.formatGroup, formatGroup = _formatGroup === void 0 ? null : _formatGroup, _text = param.text, text = _text === void 0 ? null : _text;
    var editor = (0,dist_index_es/* useSlate */.ui)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers/* Button */.zx, {
        active: Editor_Validate.isBlockActive(editor, formatGroup ? formatGroup : format, TEXT_ALIGN_TYPES.includes(format) ? "align" : "type"),
        onMouseDown: function(event) {
            event.preventDefault();
            if (!format) return;
            Handler_Toggle.toggleBlock(editor, format);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContent, {
            icon: icon,
            text: text
        })
    });
};
var ColorButton = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers/* Button */.zx, {
        className: "mosanic-icon -small",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedPicker, {})
    });
};
var SourceButton = function(param) {
    var endSource = param.endSource;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers/* Button */.zx, {
        className: "mosanic-icon -small",
        children: endSource
    });
};
/** InlineElements */ var ToggleLinkButton = function() {
    var editor = (0,dist_index_es/* useSlate */.ui)();
    var ref = (0,react.useState)(false), modal = ref[0], setModal = ref[1];
    var handleLink = function(event) {
        if (Editor_Validate.isLinkActive(editor)) {
            Handler_Wrap.unwrapLink(editor);
        } else {
            event.preventDefault();
            var url = window.prompt("Enter the URL of the link:");
            // setModal(true);
            if (!url) return;
            Handler_Insert.insertLink(editor, url);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                title: "Link",
                size: "xxs",
                state: modal,
                close: function() {
                    return setModal(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields["default"], {
                    label: "url"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers/* Button */.zx, {
                active: Editor_Validate.isLinkActive(editor),
                onMouseDown: function(event) {
                    if (Editor_Validate.isLinkActive(editor)) {
                        Handler_Wrap.unwrapLink(editor);
                    } else {
                        event.preventDefault();
                        var url = window.prompt("Enter the URL of the link:");
                        if (!url) return;
                        Handler_Insert.insertLink(editor, url);
                    }
                },
                children: Editor_Validate.isLinkActive(editor) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* LinkBreak1Icon */.BxK, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* Link1Icon */.DrZ, {})
            })
        ]
    });
};
var ImageButton = function() {
    var editor = (0,dist_index_es/* useSlateStatic */._7)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers/* Button */.zx, {
        onMouseDown: function(event) {
            event.preventDefault();
            var url = window.prompt("Enter the URL of the image:");
            if (url && !(0,Url/* isImageUrl */.h)(url)) {
                alert("URL is not an image");
                return;
            }
            url && Handler_Insert.insertImage(editor, url);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ImageIcon */.XBm, {})
    });
};
var ToggleEditableButton = function() {
    var editor = (0,dist_index_es/* useSlate */.ui)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers/* Button */.zx, {
        active: Editor_Validate.isButtonActive(editor),
        onMouseDown: function(event) {
            event.preventDefault();
            Editor_Validate.isButtonActive(editor) ? Handler_Wrap.unwrapButton(editor) : Handler_Insert.insertButton(editor);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ButtonIcon */.Eik, {})
    });
};
var InlineButtons = {
    Link: ToggleLinkButton,
    Button: ToggleEditableButton,
    Image: ImageButton
};


;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Toolbars/ToolbarHover.js

function ToolbarHover_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  padding: 0px 10px 2px;\n  position: absolute;\n  z-index: 9;\n  top: -10000px;\n  left: -10000px;\n  margin-top: -6px;\n  opacity: 0;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  transition: opacity 0.25s;\n\n"
    ]);
    ToolbarHover_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var Mnu = (0,styled_components_browser_esm/* default */.ZP)(Wrappers/* Menu */.v2).withConfig({
    componentId: "sc-20837589-0"
})(ToolbarHover_templateObject(), panels/* default.dark */.Z.dark, panels/* default.borderRadius */.Z.borderRadius);
var HoveringToolbar = function(param) {
    var _extra = param.extra, extra = _extra === void 0 ? null : _extra;
    var ref = (0,react.useRef)();
    var editor = (0,dist_index_es/* useSlate */.ui)();
    var inFocus = (0,dist_index_es/* useFocused */.UE)();
    (0,react.useEffect)(function() {
        var el = ref.current;
        var selection = editor.selection;
        if (!el) return;
        if (!selection || !inFocus || index_es/* Range.isCollapsed */.e6.isCollapsed(selection) || index_es/* Editor.string */.ML.string(editor, selection) === "") {
            el.removeAttribute("style");
            return;
        }
        var domSelection = window === null || window === void 0 ? void 0 : window.getSelection();
        var domRange = domSelection.getRangeAt(0);
        var rect = domRange.getBoundingClientRect();
        el.style.opacity = "1";
        el.style.top = "".concat(rect.top + (window === null || window === void 0 ? void 0 : window.pageYOffset) - el.offsetHeight, "px");
        el.style.left = "".concat(rect.left + (window === null || window === void 0 ? void 0 : window.pageXOffset) - el.offsetWidth / 2 + rect.width / 2, "px");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers/* Portal */.h_, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Mnu, {
            ref: ref,
            onMouseDown: function(e) {
                // prevent toolbar from taking focus away from editor
                e.preventDefault();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatButton, {
                    format: "bold",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* FontBoldIcon */.X20, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatButton, {
                    format: "italic",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* FontItalicIcon */.MzY, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatButton, {
                    format: "underline",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* UnderlineIcon */.Adg, {})
                }),
                extra ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                    reversed: true,
                    placement: "top",
                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatButton, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* PlusCircledIcon */.SPS, {})
                    }),
                    children: extra
                }) : null
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Toolbars/ControlGroup.js





var ControlGroup = function(param) {
    var triggerProps = param.triggerProps, group = param.group, _reversed = param.reversed, reversed = _reversed === void 0 ? false : _reversed, _placement = param.placement, placement = _placement === void 0 ? "top" : _placement;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
        style: {
            justifyContent: "space-around",
            display: "flex"
        },
        reversed: reversed,
        placement: placement,
        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, (0,_object_spread/* default */.Z)({}, triggerProps)),
        children: group
    });
};


// EXTERNAL MODULE: ./src/mosanic/Icons/ElementIcons.js
var ElementIcons = __webpack_require__(99559);
;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Toolbars/Groups.js




var GroupStyle = function(param) {
    var _code = param.code, code = _code === void 0 ? false : _code;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkButton, {
                format: "bold",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* FontBoldIcon */.X20, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkButton, {
                format: "italic",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* FontItalicIcon */.MzY, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkButton, {
                format: "underline",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* UnderlineIcon */.Adg, {})
            }),
            code ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkButton, {
                format: "code",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* CodeIcon */.dNJ, {})
            }) : null
        ]
    });
};
var GroupAlign = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "left",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TextAlignLeftIcon */.rrd, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "center",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TextAlignCenterIcon */.o3f, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "right",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TextAlignRightIcon */.oTK, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "justify",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TextAlignJustifyIcon */.ux3, {})
            })
        ]
    });
};
var GroupHeadings = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "heading-1",
                text: "h1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "heading-2",
                text: "h2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "heading-3",
                text: "h3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "heading-4",
                text: "h4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "heading-5",
                text: "h5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "heading-6",
                text: "h6"
            })
        ]
    });
};
var GroupInsertBlocks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "block-quote",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* QuoteIcon */.PEf, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "numbered-list",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ElementIcons/* NumList */.Xt, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockButton, {
                format: "bulleted-list",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ListBulletIcon */.jVc, {})
            })
        ]
    });
};
var GroupInlineElements = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineButtons.Link, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineButtons.Image, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineButtons.Button, {})
        ]
    });
};


;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Toolbars/ToolbarFull.js








var TopToolbar = function(param) {
    var _reversed = param.reversed, reversed = _reversed === void 0 ? false : _reversed, _minified = param.minified, minified = _minified === void 0 ? false : _minified, _location = param.location, location = _location === void 0 ? "auto" : _location, _endSource = param.endSource, endSource = _endSource === void 0 ? null : _endSource;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrappers/* Toolbar */.o8, {
        minified: minified,
        location: location,
        children: [
            !minified ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupStyle, {
                code: true
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlGroup, {
                triggerProps: {
                    formatGroup: "headings",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* HeadingIcon */.bHp, {})
                },
                group: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupHeadings, {}),
                reversed: reversed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupInsertBlocks, {}),
            minified ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlGroup, {
                triggerProps: {
                    formatGroup: "link",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* MixIcon */.$bm, {})
                },
                group: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupInlineElements, {}),
                reversed: reversed
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupInlineElements, {}),
            minified || true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlGroup, {
                triggerProps: {
                    formatGroup: "align",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TextAlignLeftIcon */.rrd, {})
                },
                group: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupAlign, {}),
                reversed: reversed
            }) : /*#__PURE__*/ 0,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlGroup, {
                triggerProps: {
                    formatGroup: "translate",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ElementIcons/* LocalizedTextIcon */.t4, {})
                },
                group: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                        label: "Translate content"
                    })
                }),
                reversed: reversed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorButton, {}),
            endSource && /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceButton, {
                endSource: endSource
            })
        ]
    });
};
// const MinifiedAlign = ({reversed = false}) => (
// )


;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Toolbars/index.js



var Toolbars = function(param) {
    var _full = param.full, full = _full === void 0 ? true : _full, _location = param.location, location = _location === void 0 ? "location" : _location, _endSource = param.endSource, endSource = _endSource === void 0 ? null : _endSource;
    return full ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TopToolbar, {
        location: location,
        endSource: endSource
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HoveringToolbar, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopToolbar, {
            reversed: true,
            minified: true
        })
    });
};

/* harmony default export */ var Editor_Toolbars = (Toolbars);

;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Editor.js














var isMobileDevice = function(e) {
    if (false) {}
    return typeof window.orientation !== "undefined" || navigator.userAgent.indexOf("IEMobile") !== -1;
};
var Editor = function(param) {
    var content = param.content, setContent = param.setContent, _fullToolbar = param.fullToolbar, fullToolbar = _fullToolbar === void 0 ? true : _fullToolbar, _readOnly = param.readOnly, readOnly = _readOnly === void 0 ? false : _readOnly, _ninja = param.ninja, ninja = _ninja === void 0 ? false : _ninja, _autoFocus = param.autoFocus, autoFocus = _autoFocus === void 0 ? true : _autoFocus, _singleLine = param.singleLine, singleLine = _singleLine === void 0 ? false : _singleLine, _location = param.location, location = _location === void 0 ? "auto" : _location, _endSource = param.endSource, endSource = _endSource === void 0 ? null : _endSource, _translate = param.translate, translate = _translate === void 0 ? false : _translate, _label = param.label, label = _label === void 0 ? null : _label, _fieldName = param.fieldName, fieldName = _fieldName === void 0 ? null : _fieldName, _name = param.name, name = _name === void 0 ? null : _name, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    //  const editor = useMemo(() => singleLine ? 
    //     withSingleLine(withPlugins(createEditor())) : 
    //     withPlugins(createEditor())
    // , [singleLine])
    var editorRef = (0,react.useRef)();
    if (!editorRef.current) editorRef.current = singleLine ? SingleLine(Plugins((0,index_es/* createEditor */.Jh)())) : Plugins((0,index_es/* createEditor */.Jh)());
    var editor = editorRef.current;
    // useEffect(() => {
    //   editorRef.current = singleLine ? 
    //     withSingleLine(withPlugins(createEditor())) : 
    //     withPlugins(createEditor())
    // },[singleLine])
    // const [editor, setEditor] = useState()
    // useEffect(() => {
    //   setEditor(singleLine ? 
    //     withSingleLine(withPlugins(createEditor())) : 
    //     withPlugins(createEditor())
    //   );
    // }, [singleLine, setContent])
    if (!content) setContent((0,Content/* getInitialContent */.M)("Text", "p"));
    var handleBeforeInput = function(e) {
        return Handler_BeforeInput(e);
    };
    var handleKeyDown = function(e) {
        return disabled ? null : Handler_KeyDown(e, editor);
    };
    var renderElement = (0,react.useCallback)(function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Elements */.e, (0,_object_spread/* default */.Z)({}, props));
    }, []);
    var renderLeaf = (0,react.useCallback)(function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Leaf/* Leaf */.B, (0,_object_spread/* default */.Z)({}, props));
    }, []);
    if (!editor) return "...";
    return editor ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: !ninja && !singleLine,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EditorContainer, {
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorLabel, {
                        shrink: true,
                        children: label ? label : fieldName ? fieldName : name ? name : ""
                    }),
                    !fullToolbar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            height: "5px"
                        }
                    }),
                    children
                ]
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_es/* Slate */.mH, {
            editor: editor,
            value: content,
            onChange: disabled ? function() {
                return null;
            } : setContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor_Toolbars, {
                    full: fullToolbar,
                    location: location,
                    endSource: endSource
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* Editable */.CX, {
                    className: ninja ? "-ninja" : "",
                    renderElement: renderElement,
                    renderLeaf: renderLeaf,
                    placeholder: "Enter text...",
                    onDOMBeforeInput: isMobileDevice() ? null : handleBeforeInput,
                    onKeyDown: handleKeyDown,
                    readOnly: readOnly || disabled,
                    autoFocus: !readOnly && autoFocus,
                    spellCheck: true
                })
            ]
        })
    }) : null;
};
var renderEditor = function(props) {
    var children = props.children, editor = props.editor;
    var wordCount = 2;
    // const wordCount = countWords(editor.value.text)
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            children,
            /*#__PURE__*/ _jsx("span", {
                className: "word-count",
                children: wordCount
            })
        ]
    });
};
/* harmony default export */ var Editor_Editor = (Editor);

// EXTERNAL MODULE: ./src/mosanic/fields/Editor/Text.js
var Text = __webpack_require__(50703);
;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Serialize.js
var serialize = function(param) {
    var content = param.content;
    if (!content) return null;
    return content === null || content === void 0 ? void 0 : content.map(function(b) {
        var ref;
        return b === null || b === void 0 ? void 0 : (ref = b.children) === null || ref === void 0 ? void 0 : ref.map(function(n) {
            return "".concat(n === null || n === void 0 ? void 0 : n.text, " \n");
        });
    });
} // import escapeHtml from 'escape-html'
 // import { Text } from 'slate'
 // const serialize = node => {
 //   if (Text.isText(node)) {
 //     let string = escapeHtml(node.text)
 //     if (node.bold) {
 //       string = `<strong>${string}</strong>`
 //     }
 //     return string
 //   }
 //   const children = node.children.map(n => serialize(n)).join('')
 //   switch (node.type) {
 //     case 'quote':
 //       return `<blockquote><p>${children}</p></blockquote>`
 //     case 'paragraph':
 //       return `<p>${children}</p>`
 //     case 'link':
 //       return `<a href="${escapeHtml(node.url)}">${children}</a>`
 //     default:
 //       return children
 //   }
 // }
 // import { Node } from 'slate'
 // const serialize = nodes => {
 //   return nodes.map(n => Node.string(n)).join('\n')
 // }
;

// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ./src/utils/isEqual.js
var isEqual = __webpack_require__(89450);
;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/Inline.js


var Inline_Editor = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 28970));
});







var interval = 2500;
var InlineEditor = function(param) {
    var _content = param.content, content = _content === void 0 ? "" : _content, _handler = param.handler, handler = _handler === void 0 ? null : _handler, _ninja = param.ninja, ninja = _ninja === void 0 ? false : _ninja, _oneLine = param.oneLine, oneLine = _oneLine === void 0 ? true : _oneLine, _fullToolbar = param.fullToolbar, fullToolbar = _fullToolbar === void 0 ? false : _fullToolbar, _active = param.active, active = _active === void 0 ? false : _active;
    if (!content) content = (0,Content/* getInitialContent */.M)(content, "span");
    // const [enabled, toggleEditor] = useEditorMenu(screen);
    var ref = (0,react.useState)(active), enabled = ref[0], setEnabled = ref[1];
    //Store
    // const [editorState, setEditorState] = useState(showEditor)
    var ref1 = (0,react.useState)(content), data = ref1[0], setData = ref1[1];
    var ref2 = (0,react.useState)(content), localData = ref2[0], setLocalData = ref2[1];
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        if ((localData === null || localData === void 0 ? void 0 : localData.length) === 1 && ((ref = localData[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.children) === null || ref1 === void 0 ? void 0 : ref1.length) === 1 && ((ref3 = (ref2 = localData[0]) === null || ref2 === void 0 ? void 0 : ref2.children[0]) === null || ref3 === void 0 ? void 0 : ref3.text) === "") {
        // setLocalData(getInitialContent('...', 'span'))
        }
    }, [
        content,
        localData
    ]);
    (0,react.useEffect)(function() {
        if (!(0,isEqual/* default */.Z)(content, data) && !active) {
            setData(content);
            setLocalData(content);
        }
    }, [
        content,
        data,
        active
    ]);
    //Handle
    var setContent = function(value) {
        setData(value);
        setLocalData(value);
    };
    //Handle input timing
    (0,react.useEffect)(function() {
        var timer;
        if (active) {
            if (enabled != active) setEnabled(active);
            timer = setInterval(function() {
                if (!(0,isEqual/* default */.Z)(localData, content) && active) {
                    dispatchData(localData);
                }
            }, interval);
        } else {
            //exit
            if (enabled) {
                setEnabled(false);
                dispatchData(localData);
            }
        // dispatchData(localData)
        }
        return function() {
            return clearInterval(timer);
        };
    }, [
        dispatchData,
        localData,
        enabled,
        active,
        content
    ]);
    //Update to redux
    var dispatchData = (0,react.useCallback)(function(newData) {
        handler(newData);
    }, [
        handler
    ]);
    var ref3 = (0,react.useState)(false), state = ref3[0], setActive = ref3[1];
    // useEffect(() => {
    //   setTimeout(() => {
    //     if(state != (enabled && current))
    //     setActive(enabled && current)
    //   }, 200);
    // }, [enabled, current, state]) 
    return Boolean(active) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline_Editor, {
        content: data,
        setContent: setContent,
        fullToolbar: fullToolbar,
        ninja: ninja,
        singleLine: oneLine
    }, "slate") : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: ninja && oneLine ? /*#__PURE__*/ (0,jsx_runtime.jsx)(serialize, {
            content: data
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            content: (0,Obj/* omitDeep */.Cd)(content)
        })
    });
};
/* harmony default export */ var Inline = ((/* unused pure expression or super */ null && (InlineEditor)));

;// CONCATENATED MODULE: ./src/mosanic/fields/Editor/index.js





/* harmony default export */ var fields_Editor = (Editor_Editor);


/***/ }),

/***/ 60772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ File; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/Base.js
var Base = __webpack_require__(57348);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/Input.styles.js
var Input_styles = __webpack_require__(55217);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/Icons/ElementIcons.js
var ElementIcons = __webpack_require__(99559);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/mosanic/components/Media/Resolvers/GetListOfMedia.js
var GetListOfMedia = __webpack_require__(36520);
;// CONCATENATED MODULE: ./src/mosanic/components/Media/MediaDialog.js








var MediaDialog = function(_param) /*#__PURE__*/ {
    var callback = _param.callback, _type = _param.type, type = _type === void 0 ? "image" : _type, other = (0,_object_without_properties/* default */.Z)(_param, [
        "callback",
        "type"
    ]);
    return (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ghost: true
        }, other), {
            children: (0,ElementIcons/* elementIcon */.$N)("archive")
        })),
        size: "xl",
        fullWidth: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetListOfMedia/* GetListOfMedia */.h, {
            header: true,
            dialog: true,
            initiate: callback,
            direct: true,
            type: type,
            upload: false
        })
    });
};

// EXTERNAL MODULE: ./src/mosanic/items/LoadingDots.tsx
var LoadingDots = __webpack_require__(4093);
// EXTERNAL MODULE: ./src/mosanic/items/Spinner.js
var Spinner = __webpack_require__(36174);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/mosanic/utils/Image.js
var Image = __webpack_require__(73987);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ./src/mosanic/fields/Video/index.js + 1 modules
var Video = __webpack_require__(26518);
;// CONCATENATED MODULE: ./src/mosanic/fields/File/FileUploader.js





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    font-size: 12px !important;\n    display: inline-block;\n    transform-origin: bottom;\n    pointer-events: none;\n    margin-right: 5px;\n    svg {\n        transition: all ease-in-out 0.3s;\n        transform-origin: center center;\n        transform: scale(0.9);\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    display: flex;\n    margin: 0;\n    padding-top: 2px;\n    font-size: 12px;\n    vertical-align: center;\n   \n    &:hover svg {\n        transform: scale(1.1)\n    }\n\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    transition: all ease-in-out 0.3s;\n    padding: 0 5px !important;\n    z-index: 2;\n    cursor: pointer;\n    &:hover {\n        transform: scale(1.1);\n    }\n    video, img {\n        margin: 2.5px 0 -2.5px !important;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: inline-block;\n    display: none;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var ImgsViewer = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 26689));
}, {
    ssr: false
});




var UploadButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f4441f8b-0"
})(_templateObject());
var InputLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-f4441f8b-1"
})(_templateObject1(), Input_styles/* BaseFieldStyles */.Zz);
var PreviewImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f4441f8b-2"
})(_templateObject2());
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-f4441f8b-3"
})(_templateObject3());
var getTitle = function(other) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return (other === null || other === void 0 ? void 0 : (ref = other.value) === null || ref === void 0 ? void 0 : (ref1 = ref.url) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.seo) === null || ref2 === void 0 ? void 0 : ref2.title) ? other.value.url.seo.title : (other === null || other === void 0 ? void 0 : (ref3 = other.value) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.url) === null || ref4 === void 0 ? void 0 : ref4.url) ? other.value.url.url : (other === null || other === void 0 ? void 0 : (ref5 = other.value) === null || ref5 === void 0 ? void 0 : ref5.url) ? other.value.url : (other === null || other === void 0 ? void 0 : other.value) ? other.value : (other === null || other === void 0 ? void 0 : other.label) ? other === null || other === void 0 ? void 0 : other.label : "".concat((0,Text/* capitalizeFirst */.Ez)(other === null || other === void 0 ? void 0 : other.type), " upload");
};
var FileField = function(_param) {
    var _mediaLib = _param.mediaLib, mediaLib = _mediaLib === void 0 ? true : _mediaLib, other = (0,_object_without_properties/* default */.Z)(_param, [
        "mediaLib"
    ]);
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,Base/* useBaseField */.z)((0,_object_spread/* default */.Z)({}, other)), 3), focussed = ref2[0], onFocus = ref2[1], onBlur = ref2[2];
    var ref3 = (0,react.useState)(false), preview = ref3[0], setPreview = ref3[1];
    var togglePreview = function() {
        return setPreview(function(prev) {
            return !prev;
        });
    };
    var source = (0,Image/* parseImageSrc */.yO)((other === null || other === void 0 ? void 0 : (ref = other.value) === null || ref === void 0 ? void 0 : ref.url) ? other === null || other === void 0 ? void 0 : (ref1 = other.value) === null || ref1 === void 0 ? void 0 : ref1.url : other === null || other === void 0 ? void 0 : other.value, true);
    var title = getTitle(other);
    var props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        label: (source === null || source === void 0 ? void 0 : source.thumb) ? (other === null || other === void 0 ? void 0 : other.label) ? other.label : (0,Text/* capitalizeFirst */.Ez)(other === null || other === void 0 ? void 0 : other.type) : null,
        type: "file",
        focussed: focussed,
        onFocus: onFocus,
        onBlur: onBlur
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Base/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                endSource: !mediaLib ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaDialog, {
                    callback: other === null || other === void 0 ? void 0 : other.initiate,
                    style: {
                        margin: "5px 0"
                    },
                    type: other === null || other === void 0 ? void 0 : other.type
                }),
                children: [
                    (other === null || other === void 0 ? void 0 : other.thumb) ? other === null || other === void 0 ? void 0 : other.thumb : (source === null || source === void 0 ? void 0 : source.thumb) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewImg, {
                        children: !(0,Video/* isVideo */.Wv)(source === null || source === void 0 ? void 0 : source.full) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: source === null || source === void 0 ? void 0 : source.thumb,
                            height: "20px",
                            width: "20px",
                            alt: "uploaded",
                            onClick: togglePreview
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Video/* Video */.nk, {
                            url: source === null || source === void 0 ? void 0 : source.full,
                            height: "20px",
                            width: "20px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputLabel, {
                        children: [
                            !(source === null || source === void 0 ? void 0 : source.thumb) && /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadButton, {
                                ghost: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    width: "15px",
                                    height: "15px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                        "data-name": "Layer 2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                            "data-name": "cloud-upload",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                    width: "8",
                                                    height: "8",
                                                    opacity: "0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12.71 11.29a1 1 0 0 0-1.4 0l-3 2.9a1 1 0 1 0 1.38 1.44L11 14.36V20a1 1 0 0 0 2 0v-5.59l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M17.67 7A6 6 0 0 0 6.33 7a5 5 0 0 0-3.08 8.27A1 1 0 1 0 4.75 14 3 3 0 0 1 7 9h.1a1 1 0 0 0 1-.8 4 4 0 0 1 7.84 0 1 1 0 0 0 1 .8H17a3 3 0 0 1 2.25 5 1 1 0 0 0 .09 1.42 1 1 0 0 0 .66.25 1 1 0 0 0 .75-.34A5 5 0 0 0 17.67 7z"
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
                                value: "",
                                type: "file"
                            })),
                            (other === null || other === void 0 ? void 0 : other.loading) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingDots/* LoadingDots */.x, {}) : (0,Text/* subStringFromLast */.zw)(title, "/")
                        ]
                    })
                ]
            })),
            (source === null || source === void 0 ? void 0 : source.full) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgsViewer, {
                imgs: [
                    {
                        src: source === null || source === void 0 ? void 0 : source.full
                    }
                ],
                spinner: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {});
                },
                isOpen: preview && (source === null || source === void 0 ? void 0 : source.full),
                onClose: togglePreview
            })
        ]
    });
};
// <BaseField 
//     {...other}
//     noFocus
//     label={''}
//     type='file' 
//     field={(props) => (
//     )}
// />
// );
/* harmony default export */ var FileUploader = (FileField);

;// CONCATENATED MODULE: ./src/mosanic/fields/File/index.js

/* harmony default export */ var File = (FileUploader);


/***/ }),

/***/ 35345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99057);





var FormGroup = function(_param) /*#__PURE__*/ {
    var onSubmit = _param.onSubmit, disabled = _param.disabled, children = _param.children, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "onSubmit",
        "disabled",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        disabled: disabled,
        onSubmit: onSubmit,
        style: {
            maxWidth: "100%"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_2__/* .InputGroup */ .BZ, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, other), {
            cols: 1,
            fullWidth: true,
            children: children
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormGroup);


/***/ }),

/***/ 56185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ FormItems; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6928);




var FormItems = function(param) {
    var fields = param.fields, controls = param.controls;
    return (fields === null || fields === void 0 ? void 0 : fields.length) >= 1 ? fields.map(function(field, index) {
        /*#__PURE__*/ return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_Input__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, field, controls), {
            key: (field === null || field === void 0 ? void 0 : field.name) ? field.name : index,
            field: field
        }));
    }) : null;
};


/***/ }),

/***/ 57348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useBaseField; }
/* harmony export */ });
/* unused harmony export sanitizeValue */
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58013);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99057);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Input_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55217);








var sanitizeValue = function(sanitize, e) {
    var ref, ref1;
    return !((ref = e.target) === null || ref === void 0 ? void 0 : ref.value) ? (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value : sanitize === "extreme" ? getSensitizedString(removeSpaces(toLowCase(e.target.value))) : sanitize ? getSensitizedString(e.target.value) : event.target.value;
};
var useBaseField = function(_param) {
    var other = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), focussed = ref[0], setFocused = ref[1];
    var onFocus = function(e) {
        if (other === null || other === void 0 ? void 0 : other.noFocus) return;
        if (other === null || other === void 0 ? void 0 : other.onFocus) other.onFocus(e);
        setFocused(true);
    };
    var onBlur = function(e) {
        if (other === null || other === void 0 ? void 0 : other.noFocus) return;
        if (other === null || other === void 0 ? void 0 : other.onBlur) other.onBlur(e);
        setFocused(false);
    };
    return [
        focussed,
        onFocus,
        onBlur
    ];
};
var Label = function(_param) {
    var innerRef = _param.innerRef, value = _param.value, label = _param.label, name = _param.name, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "innerRef",
        "value",
        "label",
        "name"
    ]);
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Label */ .ZP.Label, {
        shrink: Boolean((innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) || value || (other === null || other === void 0 ? void 0 : other.focussed) || (other === null || other === void 0 ? void 0 : other.placeholder)),
        children: [
            (other === null || other === void 0 ? void 0 : other.ninja) ? "" : label ? label : name ? name : "",
            (other === null || other === void 0 ? void 0 : other.required) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Required */ .ZP.Required, {})
        ]
    });
};
var EndSource = function(_param) {
    var other = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    return (other === null || other === void 0 ? void 0 : other.endAdornment) || (other === null || other === void 0 ? void 0 : other.endSource) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].End */ .ZP.End, {
        children: [
            other === null || other === void 0 ? void 0 : other.endAdornment,
            other === null || other === void 0 ? void 0 : other.endSource
        ]
    }) : null;
};
var BaseField = function(_param) {
    var _name = _param.name, name = _name === void 0 ? "" : _name, _label = _param.label, label = _label === void 0 ? null : _label, _value = _param.value, value = _value === void 0 ? null : _value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _type = _param.type, type = _type === void 0 ? "text" : _type, _innerRef = _param.innerRef, innerRef = _innerRef === void 0 ? null : _innerRef, _field = _param.field, field = _field === void 0 ? null : _field, children = _param.children, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "name",
        "label",
        "value",
        "onChange",
        "type",
        "innerRef",
        "field",
        "children"
    ]);
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_5__/* .WrapInput */ .Vw, {
        wrap: (other === null || other === void 0 ? void 0 : other.wrap) ? other.wrap : false,
        fullWidth: (other === null || other === void 0 ? void 0 : other.fullWidth) ? other === null || other === void 0 ? void 0 : other.fullWidth : false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Container */ .ZP.Container, {
            onClick: other === null || other === void 0 ? void 0 : other.onClick,
            focussed: other === null || other === void 0 ? void 0 : other.focussed,
            disabled: other === null || other === void 0 ? void 0 : other.disabled,
            valid: other === null || other === void 0 ? void 0 : other.valid,
            empty: other === null || other === void 0 ? void 0 : other.empty,
            ninja: other === null || other === void 0 ? void 0 : other.ninja,
            size: other === null || other === void 0 ? void 0 : other.size,
            className: (other === null || other === void 0 ? void 0 : other.className) + " input_field",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    innerRef: innerRef,
                    value: value,
                    label: label,
                    name: name
                }, other)),
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EndSource, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, other))
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (BaseField);



/***/ }),

/***/ 84430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "II": function() { return /* binding */ Input; },
  "TY": function() { return /* binding */ LocalizedInput; },
  "sw": function() { return /* binding */ SwitchRenderField; },
  "EU": function() { return /* binding */ localFlag; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/components/Media/Marked/MarkedImage.js
var MarkedImage = __webpack_require__(67683);
// EXTERNAL MODULE: ./src/mosanic/components/Media/MediaMultiUploader.js
var MediaMultiUploader = __webpack_require__(38812);
// EXTERNAL MODULE: ./src/mosanic/components/Media/MediaSingleUploader.js
var MediaSingleUploader = __webpack_require__(99931);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/FieldControls.js
var FieldControls = __webpack_require__(87818);
// EXTERNAL MODULE: ./src/mosanic/fields/Select/Select.js + 3 modules
var Select = __webpack_require__(26074);
// EXTERNAL MODULE: ./src/mosanic/fields/Editor/index.js + 24 modules
var Editor = __webpack_require__(28970);
// EXTERNAL MODULE: ./src/mosanic/fields/TextField/Fields.js
var Fields = __webpack_require__(91639);
// EXTERNAL MODULE: ./src/mosanic/fields/TextArea/index.js + 6 modules
var TextArea = __webpack_require__(71645);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/fields/Color/ColorPicker.js + 1 modules
var ColorPicker = __webpack_require__(39381);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(87567);
// EXTERNAL MODULE: ./src/mosanic/fields/Date/DatePicker.js
var DatePicker = __webpack_require__(21117);
// EXTERNAL MODULE: ./src/mosanic/fields/Switch/index.js + 2 modules
var Switch = __webpack_require__(9441);
// EXTERNAL MODULE: ./src/mosanic/fields/Checkbox/index.js
var Checkbox = __webpack_require__(51840);
// EXTERNAL MODULE: ./src/mosanic/fields/Source/helpers.js
var helpers = __webpack_require__(49272);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ./src/utils/Arr.js
var Arr = __webpack_require__(72393);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ./src/mosanic/fields/Editor/Handler/Content.js
var Content = __webpack_require__(32801);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
;// CONCATENATED MODULE: ../../node_modules/@hookform/error-message/dist/index.esm.js
var s=function(s){var t=s.as,a=s.errors,m=s.name,o=s.message,i=s.render,l=function(e,r){if(null==e)return{};var n,s,t={},a=Object.keys(e);for(s=0;s<a.length;s++)r.indexOf(n=a[s])>=0||(t[n]=e[n]);return t}(s,["as","errors","name","message","render"]),f=(0,index_esm/* useFormContext */.Gc)(),c=(0,index_esm/* get */.U2)(a||f.formState.errors,m);if(!c)return null;var g=c.message,u=c.types,d=Object.assign({},l,{children:g||o});return react.isValidElement(t)?react.cloneElement(t,d):i?i({message:g||o,messages:u}):react.createElement(t||react.Fragment,d)};
//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
;// CONCATENATED MODULE: ./src/mosanic/fields/Errors/index.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    color: ",
        ";\n    width: 100%;\n    font-size: 12px;\n    margin-bottom: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Message = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-a2c6d951-0"
})(_templateObject(), colors/* default.util.gray.base */.ZP.util.gray.base);
var ErrorMessage = function(param) {
    var errors = param.errors, name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(s, {
        errors: errors,
        name: name,
        render: function(param) {
            var message = param.message;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                children: message
            });
        }
    });
};
/* harmony default export */ var Errors = (ErrorMessage);

// EXTERNAL MODULE: ./src/mosanic/fields/Radio/index.js + 3 modules
var Radio = __webpack_require__(55953);
// EXTERNAL MODULE: ./src/mosanic/fields/Source/index.js + 10 modules
var Source = __webpack_require__(4625);
// EXTERNAL MODULE: ./src/mosanic/fields/Source/Relation.js
var Relation = __webpack_require__(23494);
// EXTERNAL MODULE: ./src/adapters/queries/users.js
var queries_users = __webpack_require__(62641);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/useDataQuery.js
var useDataQuery = __webpack_require__(49974);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/mosanic/hooks/useNotify.js
var useNotify = __webpack_require__(33346);
// EXTERNAL MODULE: ./src/mosanic/fields/Source/Convert.js
var Convert = __webpack_require__(85938);
// EXTERNAL MODULE: ./src/features/options/reducer.js + 1 modules
var options_reducer = __webpack_require__(51331);
;// CONCATENATED MODULE: ./src/mosanic/fields/Source/User.js













var UserSelector = function(param) {
    var _value = param.value, value = _value === void 0 ? null : _value, _relation = param.relation, relation = _relation === void 0 ? null : _relation, _onChange = param.onChange, onChange = _onChange === void 0 ? null : _onChange, _label = param.label, label = _label === void 0 ? null : _label, _name = param.name, name = _name === void 0 ? null : _name, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _pointer = param.pointer, pointer = _pointer === void 0 ? "data.id" : _pointer;
    var ref;
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    var devMode = (0,es/* useSelector */.v9)(options_reducer/* getDevModePrefSelector */.Lj);
    // const {users} = useDataProvider()
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useDataQuery/* useGet */.XD)({
        params: {
            filter: {
                siteId: siteId
            }
        },
        type: "user",
        method: "Many",
        query: queries_users/* LIST_ALL_USERS */.yN,
        silent: true,
        siteCheck: false
    }), 2), getUsers = ref1[0], ref2 = (0,_sliced_to_array/* default */.Z)(ref1[1], 2), users = ref2[0], loadingUsers = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useDataQuery/* useGetCount */.RF)({
        type: "user",
        query: queries_users/* USER_COUNT */.c4,
        site_id: siteId
    }), 1), userCount = ref3[0];
    var notify = (0,useNotify/* default */.Z)();
    if ((users === null || users === void 0 ? void 0 : users.length) >= 101) notify("Default limit reached. Contact info@mosanic.io for user expansion.");
    var getLabel = function(user) {
        var ref, ref1, ref2;
        return "".concat(user === null || user === void 0 ? void 0 : (ref = user.author) === null || ref === void 0 ? void 0 : ref.firstName, " ").concat((user === null || user === void 0 ? void 0 : (ref1 = user.author) === null || ref1 === void 0 ? void 0 : ref1.lastName) ? user === null || user === void 0 ? void 0 : (ref2 = user.author) === null || ref2 === void 0 ? void 0 : ref2.lastName : "");
    };
    var options = (users === null || users === void 0 ? void 0 : users.length) >= 1 && siteId ? users.map(function(user) {
        return {
            value: user === null || user === void 0 ? void 0 : user._id,
            label: getLabel(user)
        };
    }) : [
        "No users found"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select["default"], {
                searchable: true,
                disabled: disabled,
                label: label,
                name: name,
                options: options,
                onChange: onChange,
                value: value,
                loading: loadingUsers
            }),
            devMode && !((ref = options === null || options === void 0 ? void 0 : options.map(function(o) {
                return o.value;
            })) === null || ref === void 0 ? void 0 : ref.includes(value)) && Array.isArray(options) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Convert/* PreviewDataTable */.A, {
                value: value,
                data: users,
                options: options,
                onChange: onChange,
                label: "User",
                getLabel: getLabel
            })
        ]
    });
};
/* harmony default export */ var User = (UserSelector);

// EXTERNAL MODULE: ./src/mosanic/core/Collections/Select/SelectCollection.js
var SelectCollection = __webpack_require__(63222);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/many.js + 1 modules
var many = __webpack_require__(43551);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
// EXTERNAL MODULE: ./src/mosanic/core/Provider/DataProviders.js
var DataProviders = __webpack_require__(42622);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/utils/Boolean.js
var Boolean = __webpack_require__(13365);
// EXTERNAL MODULE: ./src/mosanic/utils/value.js + 1 modules
var utils_value = __webpack_require__(11039);
// EXTERNAL MODULE: ./src/mosanic/fields/Code/PreviewCode.js
var PreviewCode = __webpack_require__(59389);
;// CONCATENATED MODULE: ./src/mosanic/utils/field.js








var canPopulateValue = function(field) {
    return (field === null || field === void 0 ? void 0 : field.populateActive) && ((field === null || field === void 0 ? void 0 : field.populateCode) || (field === null || field === void 0 ? void 0 : field.code));
};
var populateFieldValue = function(param) {
    var field = param.field, entry = param.entry, onChange = param.onChange, value = param.value;
    if (!canPopulateValue(field) || !entry || !onChange) return false;
    var populatedValue = !(field === null || field === void 0 ? void 0 : field.dangerousPopulation) ? (0,utils_value/* replaceWithSource */.yL)(field.populateCode, entry) : (0,PreviewCode/* parseCode */.zY)(field.code, {
        entry: entry
    }, false);
    if ((!value || value != populatedValue) && populatedValue) onChange(populatedValue);
    return true;
};
var canValidateField = function(field) {
    var ref;
    return (field === null || field === void 0 ? void 0 : field.validateActive) && (field === null || field === void 0 ? void 0 : (ref = field.validation) === null || ref === void 0 ? void 0 : ref.length) >= 1;
};
var getValidationRules = function(field) {
    return field.validation.filter(function(rule) {
        var ref;
        return rule.code && ((ref = rule.actions) === null || ref === void 0 ? void 0 : ref.length) >= 1;
    });
};
var validationRefArray = "hide|show|disable|enable|update|noUpdate|create|noCreate|error|helper".split("|");
var validationRefObj = validationRefArray.reduce(function(obj, v) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, obj), (0,_define_property/* default */.Z)({}, v, null));
}, {});
var validateFieldRules = function(param) {
    var field = param.field, user = param.user, entry = param.entry;
    if (!canValidateField(field) || !user || !entry) return false;
    var validation = (0,_object_spread/* default */.Z)({}, validationRefObj);
    var ctx = {
        entry: entry,
        user: user
    };
    // console.log({rules: getValidationRules(field), ctx})
    getValidationRules(field).map(function(rule, i) {
        var actions = rule.actions;
        var result = (0,PreviewCode/* parseCode */.zY)(rule.code, ctx, false);
        //Parse a action key
        var parseKey = function(key) {
            //Get error || label validation
            if ([
                "error",
                "helper"
            ].includes(key)) return (rule === null || rule === void 0 ? void 0 : rule[key]) ? (0,PreviewCode/* parseCode */.zY)(rule === null || rule === void 0 ? void 0 : rule[key], ctx, false) : null;
            //Return stringified result
            return !(0,Boolean/* default */.Z)(result) ? result : result ? "true" : "false";
        };
        actions.map(function(key) {
            validation[key] = parseKey(key);
        });
    });
    return Object.fromEntries(Object.entries(validation).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], value = _param[1];
        return value != null;
    }));
};

// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/mosanic/fields/Code/FullEditor.js
var FullEditor = __webpack_require__(22549);
// EXTERNAL MODULE: ./src/mosanic/fields/Location/Location.js + 1 modules
var Location = __webpack_require__(43643);
;// CONCATENATED MODULE: ./src/mosanic/fields/Input/Input.js




























var ReactJson = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8047).then(__webpack_require__.t.bind(__webpack_require__, 48047, 23));
}, {
    ssr: false
});













var PageSelectorImbed = function(_param) {
    var value = _param.value, onChange = _param.onChange, other = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,many/* useGetPages */.m_)({
        current: true
    }), 3), pages = ref[0], loading = ref[1], error = ref[2];
    return loading ? loading : /*#__PURE__*/ (0,jsx_runtime.jsx)(Select.Select, (0,_object_spread/* default */.Z)({
        getOptionValue: function(o) {
            return o === null || o === void 0 ? void 0 : o.value;
        },
        options: pages === null || pages === void 0 ? void 0 : pages.map(function(p) {
            return {
                value: p._id,
                label: p.title
            };
        }),
        onChange: onChange,
        value: value
    }, other));
};
var MailSelectorImbed = function(_param) {
    var value = _param.value, onChange = _param.onChange, _templateSelect = _param.templateSelect, templateSelect = _templateSelect === void 0 ? true : _templateSelect, other = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange",
        "templateSelect"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,many/* useGetMails */.fY)({
        current: true
    }), 3), mails = ref[0], loading = ref[1], error = ref[2];
    mails = mails === null || mails === void 0 ? void 0 : mails.map(function(p) {
        var ref;
        return {
            value: p._id,
            label: p.title,
            templates: (ref = p.templates) === null || ref === void 0 ? void 0 : ref.map(function(p) {
                return p === null || p === void 0 ? void 0 : p.template_id;
            })
        };
    });
    var options = templateSelect ? mails === null || mails === void 0 ? void 0 : mails.flatMap(function(item) {
        return(// {...item, templates: undefined},
        (0,_to_consumable_array/* default */.Z)(item.templates.map(function(t) {
            return {
                value: "".concat(item.value, "|").concat(t),
                label: "".concat(item.label, ": ").concat(t)
            };
        })));
    }) : mails;
    return loading ? loading : /*#__PURE__*/ (0,jsx_runtime.jsx)(Select.Select, (0,_object_spread/* default */.Z)({
        getOptionValue: function(o) {
            return o === null || o === void 0 ? void 0 : o.value;
        },
        options: options,
        onChange: onChange,
        value: value
    }, other));
};
var Visual = function(_param) {
    var onChange = _param.onChange, value = _param.value, _name = _param.name, name = _name === void 0 ? null : _name, _label = _param.label, label = _label === void 0 ? "" : _label, _hideToolbar = _param.hideToolbar, hideToolbar = _hideToolbar === void 0 ? false : _hideToolbar, main = _param.main, other = (0,_object_without_properties/* default */.Z)(_param, [
        "onChange",
        "value",
        "name",
        "label",
        "hideToolbar",
        "main"
    ]);
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor["default"], (0,_object_spread/* default */.Z)({
            fullToolbar: !(main === null || main === void 0 ? void 0 : main.hideToolbar),
            ninja: main === null || main === void 0 ? void 0 : main.removeBorders,
            label: label ? label : name ? name : null,
            content: !Array.isArray(value) ? (0,Content/* getInitialContent */.M)(value, "p") : value,
            setContent: function(data) {
                return onChange(data);
            },
            autoFocus: false
        }, other))
    });
};
var localFlag = function(locale) {
    if (locale === "en") locale = "gb";
    return "http://purecatamphetamine.github.io/country-flag-icons/3x2/".concat((0,Text/* upperCase */.Lw)(locale), ".svg");
};
var LocalizedInput = function(_param) {
    var field = _param.field, locales = _param.locales, locale = _param.locale, activeLang = _param.activeLang, _renderAll = _param.renderAll, renderAll = _renderAll === void 0 ? true : _renderAll, other = (0,_object_without_properties/* default */.Z)(_param, [
        "field",
        "locales",
        "locale",
        "activeLang",
        "renderAll"
    ]);
    return (field === null || field === void 0 ? void 0 : field.localized) && (locales === null || locales === void 0 ? void 0 : locales.length) >= 2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            locale === activeLang && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
                field: field,
                name: "".concat(field === null || field === void 0 ? void 0 : field.name, ".").concat(locale),
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        (0,Text/* revertDevCases */.Uw)((0,Text/* isString */.HD)(field === null || field === void 0 ? void 0 : field.label) ? field.label : field === null || field === void 0 ? void 0 : field.name),
                        " \xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: "".concat(locale, " flag"),
                            src: localFlag(locale),
                            width: "10px",
                            height: "6px"
                        })
                    ]
                }),
                type: field === null || field === void 0 ? void 0 : field.type
            })),
            renderAll && locales.filter(function(l) {
                return l != locale;
            }).map(function(lang) {
                return lang === activeLang && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
                    field: field,
                    name: "".concat(field === null || field === void 0 ? void 0 : field.name, ".").concat(lang),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            (0,Text/* revertDevCases */.Uw)((0,Text/* isString */.HD)(field === null || field === void 0 ? void 0 : field.label) ? field.label : field === null || field === void 0 ? void 0 : field.name),
                            " \xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "".concat(lang, " flag"),
                                src: localFlag(lang),
                                width: "10px",
                                height: "6px"
                            })
                        ]
                    }),
                    type: field === null || field === void 0 ? void 0 : field.type,
                    noCase: true
                }));
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        field: field,
        name: field === null || field === void 0 ? void 0 : field.name,
        label: (0,Text/* revertDevCases */.Uw)((0,Text/* isString */.HD)(field === null || field === void 0 ? void 0 : field.label) ? field.label : field === null || field === void 0 ? void 0 : field.name),
        type: field === null || field === void 0 ? void 0 : field.type
    }));
};
var Input = function(_param) {
    var register = _param.register, name = _param.name, control = _param.control, _hideDisabled = _param.hideDisabled, hideDisabled = _hideDisabled === void 0 ? false : _hideDisabled, _rules = _param.rules, rules = _rules === void 0 ? null : _rules, _type = _param.type, type = _type === void 0 ? "text" : _type, _wrap = _param.wrap, wrap = _wrap === void 0 ? true : _wrap, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _errors = _param.errors, errors = _errors === void 0 ? null : _errors, _field = _param.field, field = _field === void 0 ? null : _field, other = (0,_object_without_properties/* default */.Z)(_param, [
        "register",
        "name",
        "control",
        "hideDisabled",
        "rules",
        "type",
        "wrap",
        "fullWidth",
        "errors",
        "field"
    ]);
    var ref, ref1;
    return type === "repeater" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Repeater, (0,_object_spread/* default */.Z)({
            main: field,
            errors: errors,
            fullWidth: fullWidth,
            control: control,
            name: name
        }, other))
    }) : type === "group" ? (field === null || field === void 0 ? void 0 : (ref = field.schema) === null || ref === void 0 ? void 0 : ref.length) >= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroup */.BZ, {
        p: 2,
        cols: 1,
        border: true,
        fullWidth: true,
        label: (0,Text/* revertDevCases */.Uw)((field === null || field === void 0 ? void 0 : field.label) ? field.label : field === null || field === void 0 ? void 0 : field.name),
        children: field === null || field === void 0 ? void 0 : (ref1 = field.schema) === null || ref1 === void 0 ? void 0 : ref1.map(function(sub, index) {
            /*#__PURE__*/ return (0,react.createElement)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
                key: sub.name + "" + index,
                label: (sub === null || sub === void 0 ? void 0 : sub.label) ? sub === null || sub === void 0 ? void 0 : sub.label : sub === null || sub === void 0 ? void 0 : sub.name,
                name: "".concat(name, ".").concat(sub.name),
                type: sub === null || sub === void 0 ? void 0 : sub.type,
                field: sub,
                hideDisabled: hideDisabled,
                options: (0,helpers/* getFieldOptions */._K)(sub),
                help: sub === null || sub === void 0 ? void 0 : sub.help,
                multiple: sub === null || sub === void 0 ? void 0 : sub.multiple,
                // relation={getFieldRelation(sub)}
                // schema={shouldPassSchema(sub) ? collection.schema : null}
                // data={shouldPassData(sub) ? watch() : null}
                // preview={other?.preview}
                // options={sub?.type === 'select' ? sub?.values?.split('\n') : null}
                // relation={sub?.type === 'relation' ? sub : null}
                // schema={sub?.type === 'repeater' ? other?.schema : null}
                noCase: true,
                control: control,
                errors: errors,
                fullWidth: fullWidth
            }));
        })
    }) : null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: wrap && !(field === null || field === void 0 ? void 0 : field.fixed) && !(field === null || field === void 0 ? void 0 : field.hidden),
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroupItem */.oV, {
                fullWidth: fullWidth,
                children: children
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderInput, (0,_object_spread/* default */.Z)({
                hideDisabled: hideDisabled,
                register: register,
                name: name,
                control: control,
                rules: rules,
                type: type,
                wrap: wrap,
                main: field
            }, other)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Errors, {
                errors: errors,
                name: name,
                render: function(param) {
                    var message = param.message;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: message
                    });
                }
            })
        ]
    });
};
var RenderInput = function(_param) /*#__PURE__*/ {
    var _register = _param.register, register = _register === void 0 ? null : _register, name = _param.name, control = _param.control, rules = _param.rules, type = _param.type, wrap = _param.wrap, other = (0,_object_without_properties/* default */.Z)(_param, [
        "register",
        "name",
        "control",
        "rules",
        "type",
        "wrap"
    ]);
    return (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: control,
        name: name,
        rules: rules,
        render: function(param) {
            var field = param.field, fieldState = param.fieldState;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderField, (0,_object_spread/* default */.Z)({
                register: register,
                name: name,
                fieldState: fieldState,
                field: field,
                type: type
            }, other));
        }
    });
};
// return register ? <input {...register(name)} {...other} /> : null;
var SwitchRenderField = function(_param) /*#__PURE__*/ {
    var props = (0,_extends/* default */.Z)({}, _param);
    return (0,jsx_runtime.jsx)(RenderField, (0,_object_spread/* default */.Z)({}, props));
};
var RenderField = function(_param) {
    var register = _param.register, name = _param.name, fieldState = _param.fieldState, field = _param.field, type = _param.type, relation = _param.relation, main = _param.main, other = (0,_object_without_properties/* default */.Z)(_param, [
        "register",
        "name",
        "fieldState",
        "field",
        "type",
        "relation",
        "main"
    ]);
    var userId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetUser */.pg)({
        _id: userId
    }), 1), user = ref[0];
    var isDev = (0,es/* useSelector */.v9)(options_reducer/* getDevModePrefSelector */.Lj);
    var fieldType = [
        "text",
        "password",
        "number"
    ].includes(type) ? "text" : type;
    var props = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: type,
        name: name
    }, main, field, fieldState), {
        ref: undefined,
        innerRef: field === null || field === void 0 ? void 0 : field.ref,
        relation: relation
    }), other);
    var shouldValidate = canValidateField(props);
    var disabled = (props === null || props === void 0 ? void 0 : props.fixed) || (props === null || props === void 0 ? void 0 : props.hidden);
    var form = (0,DataProviders/* useFormProvider */.RC)();
    var canPopulate = populateFieldValue({
        onChange: props === null || props === void 0 ? void 0 : props.onChange,
        entry: props === null || props === void 0 ? void 0 : props.data,
        value: props === null || props === void 0 ? void 0 : props.value,
        field: props
    });
    if ((props === null || props === void 0 ? void 0 : props.hideDisabled) && ((props === null || props === void 0 ? void 0 : props.fixed) || (props === null || props === void 0 ? void 0 : props.hidden))) return null;
    var validation = validateFieldRules({
        entry: props === null || props === void 0 ? void 0 : props.data,
        field: props,
        user: user
    });
    if (shouldValidate && ((validation === null || validation === void 0 ? void 0 : validation.disable) === "true" || (validation === null || validation === void 0 ? void 0 : validation.enable) === "false")) disabled = true;
    if ((0,Obj/* hasAttr */.B$)(validation, "hide") && (validation === null || validation === void 0 ? void 0 : validation.hide) === "true") return null;
    if ((0,Obj/* hasAttr */.B$)(validation, "show") && (validation === null || validation === void 0 ? void 0 : validation.show) === "false") return null;
    // if(validation) return (
    //     <pre>
    //         {JSON.stringify({canPopulate, validation, props}, null, 4)}
    //     </pre>
    // )
    props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        disabled: disabled || props.disabled || (main === null || main === void 0 ? void 0 : main.disabled) || canPopulate
    });
    // if(props.disabled) {
    //     <pre>
    //         DISABLED
    //         {JSON.stringify({props}, null, 4)}
    //     </pre>
    // }
    // if(!props?.onChange && props?.value) props = {...props, onChange: undefined, defaultValue: props.value, value: undefined}
    switch(fieldType){
        case "text":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, (0,_object_spread/* default */.Z)({}, props));
        case "email":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                type: "email"
            }));
        case "textarea":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                innerRef: undefined,
                maxRows: 20
            }));
        // case 'code': return <Code {...props} />;
        case "code":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullEditor/* FullCodeEditor */.X, (0,_object_spread/* default */.Z)({}, props));
        case "button":
            var passFieldName = function() {
                return (form === null || form === void 0 ? void 0 : form.setSubmitButton) ? form.setSubmitButton(props.name) : null;
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        style: {
                            width: "100%"
                        },
                        m: 0,
                        type: "submit",
                        customClass: (0,Text/* slugify */.lV)(props === null || props === void 0 ? void 0 : props.name),
                        onClick: function() {
                            return passFieldName();
                        }
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                        label: (0,Text/* isString */.HD)(validation === null || validation === void 0 ? void 0 : validation.error) ? validation.error : !disabled && (0,Text/* isString */.HD)(validation === null || validation === void 0 ? void 0 : validation.helper) ? validation.helper : null
                    })
                ]
            });
        case "visual":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Visual, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                main: main
            }));
        case "collections":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectCollection/* CollectionSelectorImbed */.an, (0,_object_spread/* default */.Z)({}, props));
        case "mail":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MailSelectorImbed, (0,_object_spread/* default */.Z)({}, props));
        case "pages":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSelectorImbed, (0,_object_spread/* default */.Z)({}, props));
        case "select":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select.Select, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                searchable: true
            }, props), {
                options: (props === null || props === void 0 ? void 0 : props.options) ? props.options : (props === null || props === void 0 ? void 0 : props.values) ? props.values.split("\n") : []
            }));
        case "color":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
        case "collection":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Source["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                activate: {
                    collection: true
                }
            }));
        case "buttonGroup":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* ButtonGroup */.h, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* ButtonGroup.Choices */.h.Choices, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    handler: props.onChange
                }))
            }));
        case "gallery":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaMultiUploader["default"], {
                imageUrls: props.value,
                type: "image",
                callback: props.onChange,
                label: "Gallery uploader"
            });
        case "relation":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Relation["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                relation: relation,
                inline: true,
                type: "collection"
            }));
        case "markedimage":
            var ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkedImage["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                type: "image",
                callback: props.onChange,
                relation: main === null || main === void 0 ? void 0 : main.markerRelation,
                display: main === null || main === void 0 ? void 0 : main.markerDisplay,
                value: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props === null || props === void 0 ? void 0 : props.value), {
                    styles: main === null || main === void 0 ? void 0 : (ref1 = main.default) === null || ref1 === void 0 ? void 0 : ref1.styles
                })
            }));
        case "date":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker["default"], (0,_object_spread/* default */.Z)({}, props, main))
            });
        case "time":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                timeOnly: true
            }));
        case "date-time":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                timeFormat: "HH:mm",
                showTimeSelect: true
            }));
        case "image":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaSingleUploader["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                imageUrl: props.value,
                type: "image",
                callback: props.onChange
            }));
        case "video":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaSingleUploader["default"], {
                imageUrl: props.value,
                type: "video",
                callback: props.onChange
            });
        case "switch":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                checked: field === null || field === void 0 ? void 0 : field.value
            }));
        case "checkbox":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox["default"], (0,_object_spread/* default */.Z)({}, props));
        case "radio":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio["default"], (0,_object_spread/* default */.Z)({}, props));
        case "submit":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                label: "Submit"
            });
        case "label":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other, main), {
                    label: (field === null || field === void 0 ? void 0 : field.label) ? field.label : name,
                    span: true,
                    as: main === null || main === void 0 ? void 0 : main.headingSize
                }), other === null || other === void 0 ? void 0 : other.fieldProps))
            });
        case "location":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Location/* default */.ZP, (0,_object_spread/* default */.Z)({}, props));
        case "user":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(User, (0,_object_spread/* default */.Z)({}, props));
        default:
            return register ? /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({}, register(name), other)) : null;
    }
};
var getLevelType = function(lvl) {
    if (lvl + 3 < 6) return "h".concat(lvl + 3);
    return "bold";
};
var Repeater = function(_param) {
    var main = _param.main, name = _param.name, errors = _param.errors, fullWidth = _param.fullWidth, fieldState = _param.fieldState, control = _param.control, other = (0,_object_without_properties/* default */.Z)(_param, [
        "main",
        "name",
        "errors",
        "fullWidth",
        "fieldState",
        "control"
    ]);
    var ref = (0,index_esm/* useFieldArray */.Dq)({
        control: control,
        name: name
    }), fields = ref.fields, append = ref.append, prepend = ref.prepend, remove = ref.remove, swap = ref.swap, move = ref.move, insert = ref.insert;
    var entries = fields;
    var ref1 = (0,react.useState)(0), activeTab = ref1[0], setTab = ref1[1];
    var hasTabs = (main === null || main === void 0 ? void 0 : main.displayChildren) === "tabs" || !(main === null || main === void 0 ? void 0 : main.displayChildren);
    var singular = (main === null || main === void 0 ? void 0 : main.singular) ? main.singular : "entry";
    var inputProps = {
        control: control,
        errors: errors,
        fullWidth: fullWidth
    };
    var activeLevel = (main === null || main === void 0 ? void 0 : main.level) ? main === null || main === void 0 ? void 0 : main.level : 0;
    var schema = main === null || main === void 0 ? void 0 : main.schema;
    var ref2 = (0,react.useState)(true), show = ref2[0], setShow = ref2[1];
    var devMode = (0,es/* useSelector */.v9)(options_reducer/* getDevModePrefSelector */.Lj);
    // useEffect(() => {
    //     setShow(false)
    //     setTimeout(() => {
    //         setShow(true)
    //     }, 50);
    //     setTab(0);
    // }, [entries])
    // if(other?.control) return;
    // main?.displayChildren
    var getNameValue = function(i) {
        return (0,helpers/* getEntryLabel */.ax)(entries === null || entries === void 0 ? void 0 : entries[i], schema, "".concat(singular, " ").concat(i));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
        border: true,
        py: 4,
        style: {
            marginTop: "20px !important;"
        },
        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
            as: getLevelType(activeLevel),
            label: "".concat((0,Arr/* loop */.VX)(activeLevel, ">"), " ").concat((0,Text/* revertDevCases */.Uw)((main === null || main === void 0 ? void 0 : main.name) ? main.name : name)),
            helpText: main === null || main === void 0 ? void 0 : main.help
        }),
        children: [
            hasTabs && (entries === null || entries === void 0 ? void 0 : entries.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* ButtonGroup */.h, {
                size: "small",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* ButtonGroup.Choices */.h.Choices, {
                    max: 10,
                    value: activeTab,
                    handler: setTab,
                    options: fields === null || fields === void 0 ? void 0 : fields.map(function(f, i) {
                        var ref;
                        return {
                            label: ((ref = getNameValue(i)) === null || ref === void 0 ? void 0 : ref.length) >= 8 ? "".concat(main === null || main === void 0 ? void 0 : main.singular, " ").concat(i + 1) : getNameValue(i),
                            value: i
                        };
                    })
                })
            }),
            show && (entries === null || entries === void 0 ? void 0 : entries.map(function(field, index) {
                return hasTabs && index === activeTab || !hasTabs ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                    border: true,
                    label: getNameValue(activeTab),
                    cols: 1,
                    children: [
                        !hasTabs && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                            label: "".concat(singular, " ").concat(index + 1)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldControls/* FieldControls */.g, {
                            style: {
                                top: 0
                            },
                            m: 0,
                            remove: remove,
                            move: move,
                            index: index,
                            count: fields === null || fields === void 0 ? void 0 : fields.length,
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* DotsHorizontalIcon */.nWS, {}),
                                ghost: true,
                                mb: 2
                            })
                        }),
                        schema === null || schema === void 0 ? void 0 : schema.map(function(sub) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Input, (0,_object_spread/* default */.Z)({
                                label: sub === null || sub === void 0 ? void 0 : sub.name,
                                name: "".concat(name, ".").concat(index, ".").concat(sub.name),
                                type: sub === null || sub === void 0 ? void 0 : sub.type,
                                field: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sub), {
                                    level: activeLevel + 1
                                }),
                                options: (sub === null || sub === void 0 ? void 0 : sub.type) === "select" ? sub === null || sub === void 0 ? void 0 : (ref = sub.values) === null || ref === void 0 ? void 0 : ref.split("\n") : null,
                                relation: (sub === null || sub === void 0 ? void 0 : sub.type) === "relation" ? sub : null,
                                schema: (sub === null || sub === void 0 ? void 0 : sub.type) === "repeater" ? other === null || other === void 0 ? void 0 : other.schema : null,
                                noCase: true
                            }, inputProps), sub.name + "" + index);
                        })
                    ]
                }, field === null || field === void 0 ? void 0 : field.id) : null;
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Button, {
                type: "button",
                style: {
                    width: "100%"
                },
                onClick: function() {
                    return append({});
                },
                children: [
                    "\xa0",
                    (entries === null || entries === void 0 ? void 0 : entries.length) >= 1 ? "Append ".concat(singular) : "Add first ".concat(singular)
                ]
            })
        ]
    });
};


/***/ }),

/***/ 55217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AZ": function() { return /* binding */ InputLabel; },
/* harmony export */   "Bm": function() { return /* binding */ InputRequired; },
/* harmony export */   "Zz": function() { return /* binding */ BaseFieldStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2921);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26021);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ' \n    \n    &:after {\n        content: "*";\n        display: inline-block;\n        color: ',
        ";\n        padding-left: 1.5px;\n        position: absolute;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 12px;\n    position: absolute;\n\n    right: 4px;\n    top: 0;\n    bottom: 0;\n    min-width: 8px;\n    display: flex;\n    align-items: center; \n\n    svg {\n        transform: scale(0.7);\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        text-transform: capitalize;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        left: 6px;\n        top: -8px;\n        font-size: 9px;\n        padding: 0 2px;\n        /* background: #fff; */\n        color: inherit;\n        display: inline-block;\n        z-index: 0;\n        &::before {\n            z-index: -1;\n            content: '';\n            display: block;\n            background:inherit;\n            height: 4px;\n            width: 110%;\n            bottom: calc(50% - 2px);\n            margin: 0 -5px;\n            position: absolute;\n        }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    transition: all ease-in-out 0.1s;\n    font-size: 12px;\n    position: absolute;\n    pointer-events: none;\n    left: 5px;\n    top: 5px;\n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    flex: 1 0;\n    min-width: 50px;\n    min-height: 25px;\n    font-size: inherit;\n    background-color: transparent;\n    padding-left: 5px;\n    border: 0;\n    font-size: 12px;\n    &:focus {\n        outline: none;\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n\n    ",
        "\n    \n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        " {\n        font-size: 11px;\n        line-height: 16px;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n     ",
        " {\n        font-size: 16px;\n        line-height: 18px;\n    }\n    ",
        "  {\n        margin: 2px 0;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        " {\n        font-size: 22px;\n        line-height: 24px;\n    }\n    ",
        "  {\n        margin: 3px 0;\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n            padding: 6px 4px;\n            ",
        " {\n                font-size: 14px;\n                line-height: 16px;\n            }\n            ",
        " {\n                margin: 2px 0;\n            }\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        width: 100%;\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        margin-left: auto;\n        margin-right: auto;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        fieldset {\n            border-color: ",
        ";\n        }\n        border-color: ",
        ";\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        fieldset {\n            border-color: ",
        ";\n        }\n        border-color: ",
        "!important;\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        border: 1px solid ",
        ";\n        opacity: 1;\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        opacity: 0.8;\n        color: ",
        ";\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ",
        " {\n            opacity: 0.5;\n        }\n        textarea {\n            opacity: 0.5;\n        }\n\n        &:hover {\n            opacity: 0.8;\n            border-color: ",
        ";\n            ",
        " {\n                transform: scale(1.05);\n            }\n            *:hover{\n                cursor: not-allowed!important;\n            }\n        }\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        border-color: transparent;\n        font-size: inherit;\n        font-weight: inherit;\n        ",
        " {\n            font-size: ",
        ";\n            font-weight: ",
        ";\n            color: var(--color-texts-opacity)!important;\n            font-family: inherit!important;\n            background: inherit !important;\n            color: inherit !important;\n            padding: 0 !important;\n            margin: 0 !important;   \n        }  \n        &:hover {\n            border-color: transparent;\n        }\n        \n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: relative;\n    transition: border ease-in-out 0.1s;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 2px;\n    border: 1px solid ",
        ";\n    border-radius: 5px;\n    /* max-width: 350px; */\n    \n    ",
        "\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n    &:hover {\n        border: 1px solid ",
        ";\n        &:hover {\n            opacity: 1;\n        }\n    }\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n    ",
        "\n    \n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}


var Required = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-6f42cb86-0"
})(_templateObject(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.gray.base */ .ZP.util.gray.base);
var InputRequired = Required;
var End = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-6f42cb86-1"
})(_templateObject1());
var Label = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-6f42cb86-2"
})(_templateObject4(), function(props) {
    return !props.noCase && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2());
}, function(props) {
    return props.shrink && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3());
});
var InputLabel = Label;
var BaseField = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject5());
var BaseFieldStyles = BaseField;
var Field = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-6f42cb86-3"
})(_templateObject6(), BaseField);
var SmallSize = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject7(), Field);
var LargeSize = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject8(), Field, Label);
var ExtraLargeSize = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject9(), Field, Label);
var getSize = function(size) {
    switch(size){
        case "small":
            return SmallSize;
        case "sm":
            return SmallSize;
        case "md":
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject10(), Field, Label);
        case "large":
            return LargeSize;
        case "lg":
            return LargeSize;
        case "extra-large":
            return ExtraLargeSize;
        case "xl":
            return ExtraLargeSize;
        default:
            return SmallSize;
    }
};
var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6f42cb86-4"
})(_templateObject20(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.gray.light */ .ZP.util.gray.light, function(props) {
    return props.fullWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject11());
}, function(props) {
    return props.center && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject12());
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.valid) === "true" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject13(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.bright.green */ .ZP.util.bright.green, _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.bright.green */ .ZP.util.bright.green) : (props === null || props === void 0 ? void 0 : props.valid) === "false" ? (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject14(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.red.lighter */ .ZP.util.red.lighter, _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.red.lighter */ .ZP.util.red.lighter) : "";
}, function(props) {
    return props.focussed ? (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject15(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.gray.base */ .ZP.util.gray.base) : (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject16());
}, function(props) {
    return (props.empty || props.disabled) && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject17(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.gray.base */ .ZP.util.gray.base);
}, _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.gray.base */ .ZP.util.gray.base, function(props) {
    return props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject18(), Label, _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.gray.light */ .ZP.util.gray.light, End);
}, function(props) {
    return props.noBorder ? "border: none!important;" : "";
}, function(props) {
    return props.ninja && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject19(), Field, props.ninja.size ? props.ninja.size + "px" : "inherit", props.ninja.weight ? props.ninja.weight : "inherit");
}, function(props) {
    return getSize(props.size);
});
var InputStyles = {
    Container: Container,
    BaseField: BaseField,
    Field: Field,
    Label: Label,
    End: End,
    Required: Required
};
/* harmony default export */ __webpack_exports__["ZP"] = (InputStyles);


/***/ }),

/***/ 6928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84430);



/* harmony default export */ __webpack_exports__["ZP"] = (_Input__WEBPACK_IMPORTED_MODULE_0__/* .Input */ .II);



/***/ }),

/***/ 43643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Location_Location; },
  "Xm": function() { return /* binding */ locationFields; }
});

// UNUSED EXPORTS: Location

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ./src/mosanic/items/Expander/index.js + 1 modules
var Expander = __webpack_require__(56957);
// EXTERNAL MODULE: ./src/mosanic/builder/Map/index.js
var Map = __webpack_require__(23045);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/Input.js + 4 modules
var Input = __webpack_require__(84430);
// EXTERNAL MODULE: ./src/mosanic/fields/Select/Select.js + 3 modules
var Select = __webpack_require__(26074);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(87567);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/fields/TextField/Fields.js
var Fields = __webpack_require__(91639);
// EXTERNAL MODULE: ./src/mosanic/components/Media/MediaSingleUploader.js
var MediaSingleUploader = __webpack_require__(99931);
// EXTERNAL MODULE: ../../node_modules/@googlemaps/js-api-loader/dist/index.esm.js
var index_esm = __webpack_require__(28223);
// EXTERNAL MODULE: ../../node_modules/@googlemaps/markerclusterer/dist/index.esm.js + 5 modules
var dist_index_esm = __webpack_require__(19249);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/mosanic/builder/Map/MapThemes.js
var MapThemes = __webpack_require__(21743);
// EXTERNAL MODULE: ./src/mosanic/utils/Image.js
var Image = __webpack_require__(73987);
// EXTERNAL MODULE: ./src/utils/Num.js
var Num = __webpack_require__(3121);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
;// CONCATENATED MODULE: ./src/mosanic/fields/Location/ClickMap.js












var themes = {
    dark: MapThemes/* dark_map */.k9,
    light: MapThemes/* light_map */.fo,
    minimal: MapThemes/* minimal_map */.E,
    default: null
};
var getTheme = function(theme) {
    return themes[theme];
};
var validate = function(val) {
    return (0,Num/* isNumber */.hj)(parseFloat(val));
};
function findCenter(markers) {
    var _Math, _Math1, _Math2, _Math3;
    var lats = markers.map(function(m) {
        return m.lat;
    });
    var lngs = markers.map(function(m) {
        return m.lng;
    });
    return {
        lat: ((_Math = Math).min.apply(_Math, _to_consumable_array(lats)) + (_Math1 = Math).max.apply(_Math1, _to_consumable_array(lats))) / 2,
        lng: ((_Math2 = Math).min.apply(_Math2, _to_consumable_array(lngs)) + (_Math3 = Math).max.apply(_Math3, _to_consumable_array(lngs))) / 2
    };
}
var ClickMap = function(param) {
    var value = param.value, onChange = param.onChange, control = param.control, search = param.search;
    var apiKey = value === null || value === void 0 ? void 0 : value.apiKey;
    if (!apiKey) apiKey = "AIzaSyAma8GPPHZNC5Gg1bXp7V5GMbfYH1gIGbk";
    // return JSON.stringify(editor)
    var updateProp = (0,react.useCallback)(function(param) {
        var prop = param.prop, val = param.val;
        return onChange(prop ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), (0,_define_property/* default */.Z)({}, prop, val)) : (0,_object_spread/* default */.Z)({}, value, val));
    }, [
        value,
        onChange
    ]);
    var ref = value || {
        lat: 52.377956,
        lng: 4.897070,
        zoom: 8,
        markers: [],
        theme: "default"
    }, lat = ref.lat, lng = ref.lng, zoom = ref.zoom, theme = ref.theme, markers = ref.markers, icon = ref.icon;
    // if(!apiKey) apiKey = 'AIzaSyCdwFEEctdkfVlQMzV5attE6IqM8TrmtuA';
    zoom = validate(zoom) ? parseFloat(zoom) : 10;
    lat = validate(lat) ? parseFloat(lat) : 52.377956;
    lng = validate(lng) ? parseFloat(lng) : 4.897070;
    var googleMap = (0,react.useRef)();
    var ref1 = (0,react.useState)(0), reload = ref1[0], setReload = ref1[1];
    var ref2 = (0,react.useState)(false), loaded = ref2[0], setLoaded = ref2[1];
    var input = (0,react.useRef)();
    // const icon = parseImageSrc(marker, true)?.thumb
    (0,react.useEffect)(function() {
        var isIconMouseEvent = function isIconMouseEvent(e) {
            return "placeId" in e;
        };
        if (!apiKey || !loaded) return;
        var loader = new index_esm/* Loader */.aN({
            apiKey: apiKey,
            language: "en",
            // version: 'weekly',
            libraries: [
                "places"
            ]
        });
        var map, marker, placesService, autocomplete;
        loader.load().then(function() {
            var ref, ref1;
            // const input = document.getElementById("pac-input");
            var address = {
                city: null,
                street_number: null,
                route: null,
                state: null,
                state_short: null,
                postal_code: null,
                country: null,
                country_short: null
            };
            map = new google.maps.Map(googleMap.current, {
                center: {
                    lat: lat,
                    lng: lng
                },
                zoom: zoom,
                disableDefaultUI: true,
                mapTypeControl: true,
                scaleControl: true,
                zoomControl: true,
                styles: getTheme(theme),
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL
                }
            });
            placesService = new google.maps.places.PlacesService(map);
            // autocomplete = new google.maps.places.Autocomplete(input, options);
            var setPlace = function(place) {
                var data = place === null || place === void 0 ? void 0 : place.address_components;
                if (Array.isArray(data)) data.map(function(info) {
                    info.types.map(function(type) {
                        if ([
                            "country"
                        ].includes(type)) {
                            address = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, address), {
                                country_short: info.short_name,
                                country: info.long_name
                            });
                        } else if ([
                            "administrative_area_level_1"
                        ].includes(type)) {
                            address = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, address), {
                                state_short: info.short_name,
                                state: info.long_name
                            });
                        } else if ([
                            "locality"
                        ].includes(type)) {
                            address = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, address), {
                                city: info.long_name
                            });
                        } else if ((0,Obj/* hasAttr */.B$)(address, type)) {
                            address = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, address), (0,_define_property/* default */.Z)({}, type, info.long_name));
                        }
                    });
                });
                address = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, address), {
                    street_name: address.route,
                    route: undefined,
                    post_code: address.postal_code,
                    postal_code: undefined
                });
                updateProp({
                    val: (0,_object_spread/* default */.Z)({
                        "place-id": place.place_id,
                        "address": place.formatted_address,
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng()
                    }, address)
                });
            };
            var markerIcon = {
                url: (ref = (0,Image/* parseImageSrc */.yO)(icon, true)) === null || ref === void 0 ? void 0 : ref.thumb,
                // This marker is 20 pixels wide by 32 pixels high.
                size: new google.maps.Size(30, 30),
                // The origin for this image is (0, 0).
                // origin: new google.maps.Point(0, 0),
                // // The anchor for this image is the base of the flagpole at (0, 32).
                anchor: new google.maps.Point(0, 32)
            };
            // let markers_search = [];
            if (control === "zoom") {
                map.addListener("zoom_changed", function() {
                    updateProp({
                        prop: "zoom",
                        val: map.getZoom()
                    });
                });
            } else if (control === "marker") {
                map.addListener("click", function(event) {
                    if (isIconMouseEvent(event)) {
                        event.stop(); // prevent place to show
                        if (event.placeId) {
                            placesService.getDetails({
                                placeId: event.placeId
                            }, function(place, status) {
                                if (status === "OK" && place && place.geometry && place.geometry.location) {
                                    setPlace(place);
                                }
                            });
                        }
                    } else {
                        console.log(event);
                        updateProp({
                            val: event.latLng.toJSON()
                        });
                    }
                });
            }
            if (search) {
                var request = {
                    query: search,
                    fields: [
                        "name",
                        "geometry"
                    ]
                };
                placesService.findPlaceFromQuery(request, function(results, status) {
                    if (status === google.maps.places.PlacesServiceStatus.OK && results) {
                        // for (let i = 0; i < results.length; i++) {
                        //     createMarker(results[i]);
                        // }
                        map.setCenter(results[0].geometry.location);
                        map.setZoom(18);
                    }
                });
            }
            marker = new google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                },
                icon: (ref1 = (0,Image/* parseImageSrc */.yO)(icon, true)) === null || ref1 === void 0 ? void 0 : ref1.full,
                map: map
            });
        });
    }, [
        apiKey,
        icon,
        lat,
        search,
        lng,
        loaded,
        theme,
        updateProp,
        zoom,
        control
    ]);
    (0,react.useEffect)(function() {
        setLoaded(true);
        return function() {
            return setLoaded(false);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "map",
            style: {
                height: "100%",
                width: "100%"
            },
            ref: googleMap
        })
    });
};
/* harmony default export */ var Location_ClickMap = (ClickMap);

;// CONCATENATED MODULE: ./src/mosanic/fields/Location/Location.js














var locationFields = (0,src_to_consumable_array/* default */.Z)("address|city|street_name|street_number|state|state_short|post_code|country|country_short".split("|").map(function(name) {
    return {
        label: name,
        value: {
            type: "text",
            name: name
        }
    };
})).concat([
    {
        label: "Latitude",
        value: {
            name: "lat",
            type: "number"
        }
    },
    {
        label: "Longitude",
        value: {
            name: "lng",
            type: "number"
        }
    }
]);
var Location = function(_param) {
    var _name = _param.//Essential
    name, name = _name === void 0 ? "" : _name, _value = _param.value, value = _value === void 0 ? null : _value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _label = _param.//Overwrite
    label, label = _label === void 0 ? null : _label, _disabled = _param.//Validation
    disabled, disabled = _disabled === void 0 ? false : _disabled, _required = _param.required, required = _required === void 0 ? false : _required, other = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "value",
        "onChange",
        "label",
        "disabled",
        "required"
    ]);
    var ref = (0,react.useState)("preview"), map = ref[0], setTab = ref[1];
    var ref1 = (0,react.useState)(""), search = ref1[0], setSearch = ref1[1];
    var ref2 = (0,react.useState)(""), input = ref2[0], setInput = ref2[1];
    var setMap = function(tab) {
        setTab(tab);
        setInput("");
        setSearch("");
    };
    var setSearchInput = function(value) {
        return setInput(value);
    };
    (0,react.useEffect)(function() {
        var timer;
        timer = setTimeout(function() {
            return setSearch(input);
        }, 1000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        input
    ]);
    var update = function(prop, val) {
        return onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), (0,_define_property/* default */.Z)({}, prop, val)));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                border: true,
                label: "Location",
                cols: 4,
                style: {
                    padding: "8px 4px"
                },
                children: [
                    locationFields === null || locationFields === void 0 ? void 0 : locationFields.map(function(field, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Input/* SwitchRenderField */.sw, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            wrap: true,
                            fullWidth: index === 0
                        }, other), {
                            label: field.label,
                            type: field.value.type,
                            name: field.value.name,
                            onChange: function(e) {
                                return update(field.value.name, e.target.value);
                            },
                            value: value === null || value === void 0 ? void 0 : value[field.value.name]
                        }));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select.Select, {
                        wrap: true,
                        label: "Theme",
                        onChange: function(e) {
                            return update("theme", e);
                        },
                        value: value === null || value === void 0 ? void 0 : value.theme,
                        options: "default,minimal,light,dark".split(",")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                border: true,
                label: "Map",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* ButtonGroup */.h, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                label: "Preview",
                                onClick: function() {
                                    return setMap("preview");
                                },
                                active: map === "preview"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                label: "Set marker",
                                onClick: function() {
                                    return setMap("marker");
                                },
                                active: map === "marker"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                label: "Set zoom",
                                onClick: function() {
                                    return setMap("zoom");
                                },
                                active: map === "zoom"
                            })
                        ]
                    }),
                    map === "marker" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* InputGroupItem */.oV, {
                        style: {
                            margin: "0 0 10px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                            label: "Go to area to click the desired place.",
                            onChange: function(e) {
                                return setSearchInput(e.target.value);
                            },
                            value: input
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: "100%",
                            height: map === "preview" ? "150px" : "300px"
                        },
                        children: map === "preview" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Map/* default */.Z, {
                            editor: {
                                source: (0,_object_spread/* default */.Z)({}, value)
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Location_ClickMap, {
                            value: value,
                            onChange: onChange,
                            control: map,
                            search: search
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    fullWidth: true,
                    ghost: true,
                    label: "More fields",
                    style: {
                        width: "100%"
                    }
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InputGroup */.BZ, {
                    fullWidth: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                            wrap: true,
                            label: "apiKey",
                            onChange: function(e) {
                                return update("apiKey", e.target.value);
                            },
                            value: value === null || value === void 0 ? void 0 : value.apiKey
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields.TextField, {
                            wrap: true,
                            label: "zoom",
                            onChange: function(e) {
                                return update("zoom", e.target.value);
                            },
                            value: value === null || value === void 0 ? void 0 : value.zoom
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaSingleUploader["default"], {
                            wrap: true,
                            imageUrl: value === null || value === void 0 ? void 0 : value.marker,
                            type: "image",
                            label: "marker",
                            callback: function(e) {
                                return update("marker", e);
                            },
                            value: value === null || value === void 0 ? void 0 : value.marker
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Location_Location = (Location); // MosanicSwopYourStay2023


/***/ }),

/***/ 55953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ fields_Radio; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
;// CONCATENATED MODULE: ./src/mosanic/fields/Radio/Radio.style.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        margin-left: 10px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin-left: 8px;\n    padding-bottom: 4px;\n    font-size: 14px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-block;\n    vertical-align: middle;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: -14px;\n    fill: none;\n    stroke: white;\n    stroke-width: 3px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 0;\n    clip: rect(0 0 0 0);\n    clip-path: inset(50%);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n            background: ",
        ";\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n                background: ",
        ";\n                transform: scale(1);\n            "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transition: ease-in-out 0.2s all;\n    padding: 2px;\n    cursor: pointer;\n    display: inline-block;\n    margin-top: 5px;\n    width: 17px;\n    height: 17px;\n    border: ",
        ";\n    /* background: ",
        "; */\n    border-radius: 9px;\n    transition: all 150ms;\n\n    ",
        ":focus + & {\n        box-shadow: 0 0 0 3px ",
        ";\n    }\n\n    ::after {\n        transition: all ease-in-out 0.3s;\n        content: '';\n        display: block;\n        margin: 0px;\n        border-radius: 9px;\n        width: 10px;\n        height: 10px;\n        ",
        "\n    }\n    &:hover {\n        background: ",
        ";\n        box-shadow: 0 0 0 3px ",
        ";\n        ::after {\n            background: ",
        ";\n            ",
        "\n        }\n    }\n\n    /* ",
        " {\n        visibility: ",
        ";\n    } */\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        border-color: ",
        ";\n        background: ",
        ";\n\n        &:hover {\n            border-color: ",
        ";\n        }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    border: 2px solid ",
        ";\n    transition: all ease-in-out 0.3s;\n    border-radius: 5px;\n    wrap: nowrap;\n    display: flex;\n    align-items: center\n\n    border-radius: 5px;\n    text-align: left;\n    padding: 10px 25px;\n    min-width: 100%;\n\n    h3, h4, h5 {\n        margin-bottom: 0!important;\n    }\n\n    &:hover {\n        border-color: ",
        ";\n        cursor: pointer;\n\n        span {\n            transform: scale(1.05);\n        }\n    }\n\n\n    ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var CheckBoxWrapper = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-b6e3a0a7-0"
})(_templateObject1(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.index) >= 1 && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var CheckBoxLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b6e3a0a7-1"
})(_templateObject2());
var CheckboxContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6e3a0a7-2"
})(_templateObject3());
var Icon = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-b6e3a0a7-3"
})(_templateObject4());
var HiddenCheckbox = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs({
    type: "checkbox"
}).withConfig({
    componentId: "sc-b6e3a0a7-4"
})(_templateObject5());
var StyledCheckbox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6e3a0a7-5"
})(_templateObject8(), function(props) {
    return props.checked ? "1.5px solid ".concat(colors/* default.util.primary.base */.ZP.util.primary.base) : "1.5px solid ".concat(colors/* default.util.gray.base */.ZP.util.gray.base);
}, function(props) {
    return props.checked ? colors/* default.util.primary.base */.ZP.util.primary.base : colors/* default.util.gray.lighter */.ZP.util.gray.lighter;
}, HiddenCheckbox, colors/* default.util.primary.underlay */.ZP.util.primary.underlay, function(props) {
    return props.checked && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), colors/* default.util.primary.base */.ZP.util.primary.base);
}, function(props) {
    return props.checked ? colors/* default.util.gray.light */.ZP.util.gray.light : colors/* default.util.primary.lighter */.ZP.util.primary.lighter;
}, colors/* default.util.primary.underlay */.ZP.util.primary.underlay, colors/* default.util.gray.base */.ZP.util.gray.base, function(props) {
    return props.checked && (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), colors/* default.util.primary.dark */.ZP.util.primary.dark);
}, Icon, function(props) {
    return props.checked ? "visible" : "hidden";
});
var RadioButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6e3a0a7-6"
})(_templateObject10(), colors/* default.util.gray.light */.ZP.util.gray.light, colors/* default.util.primary.base */.ZP.util.primary.base, function(props) {
    return props.checked && (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), colors/* default.util.primary.base */.ZP.util.primary.base, colors/* default.util.gray.lightest */.ZP.util.gray.lightest, colors/* default.util.primary.dark */.ZP.util.primary.dark);
});
var RadioStyles = {
    CheckBoxWrapper: CheckBoxWrapper,
    CheckBoxLabel: CheckBoxLabel,
    CheckboxContainer: CheckboxContainer,
    Icon: Icon,
    HiddenCheckbox: HiddenCheckbox,
    StyledCheckbox: StyledCheckbox,
    RadioButton: RadioButton
};
/* harmony default export */ var Radio_style = (RadioStyles);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
;// CONCATENATED MODULE: ./src/mosanic/fields/Radio/Radios.js





function Radios_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: inline-block;\n    vertical-align: top;\n    margin-top: 0px;\n    margin-right: 5px;\n"
    ]);
    Radios_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Radios_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        flex-wrap: wrap;\n        label {\n            width: 100%;\n        }\n    "
    ]);
    Radios_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Radios_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        flex-wrap: nowrap;\n    "
    ]);
    Radios_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Radios_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: flex;\n    ",
        "\n"
    ]);
    Radios_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4286bdb0-0"
})(Radios_templateObject());
var Direction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4286bdb0-1"
})(Radios_templateObject3(), function(props) {
    return props.direction === "vertical" ? (0,styled_components_browser_esm/* css */.iv)(Radios_templateObject1()) : (0,styled_components_browser_esm/* css */.iv)(Radios_templateObject2());
});
var Radios = function(_param) {
    var className = _param.className, options = _param.options, value = _param.value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _size = _param.size, size = _size === void 0 ? "small" : _size, _direction = _param.direction, direction = _direction === void 0 ? "horizontal" : _direction, _renderOption = _param.renderOption, renderOption = _renderOption === void 0 ? null : _renderOption, other = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "options",
        "value",
        "onChange",
        "disabled",
        "size",
        "direction",
        "renderOption"
    ]);
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Direction, {
        direction: direction,
        children: options === null || options === void 0 ? void 0 : options.map(function(option, index) {
            var lbl = (option === null || option === void 0 ? void 0 : option.label) ? option.label : option;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radio, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                index: index
            }, other), {
                renderOption: renderOption,
                label: (0,Text/* containsSubstr */.xX)(lbl, "|") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: lbl === null || lbl === void 0 ? void 0 : lbl.split("|")[0]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        lbl === null || lbl === void 0 ? void 0 : lbl.split("|")[1]
                    ]
                }) : option,
                value: value === null || value === void 0 ? void 0 : value[lbl],
                onChange: function(state) {
                    return onChange((0,_define_property/* default */.Z)({}, lbl, (value === null || value === void 0 ? void 0 : value[lbl]) ? false : true));
                }
            }), index);
        })
    });
};
/* harmony default export */ var Radio_Radios = (Radios);

;// CONCATENATED MODULE: ./src/mosanic/fields/Radio/Radio.js







var Radio = function(_param) {
    var className = _param.className, label = _param.label, checked = _param.checked, _value = _param.value, value = _value === void 0 ? null : _value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _size = _param.size, size = _size === void 0 ? "small" : _size, _options = _param.options, options = _options === void 0 ? null : _options, _index = _param.index, index = _index === void 0 ? 0 : _index, _renderOption = _param.renderOption, renderOption = _renderOption === void 0 ? null : _renderOption, other = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "label",
        "checked",
        "value",
        "onChange",
        "disabled",
        "size",
        "options",
        "index",
        "renderOption"
    ]);
    var ref = (0,react.useState)(false), localState = ref[0], setLocal = ref[1];
    var toggleLocal = function() {
        return setLocal(function(prev) {
            return !prev;
        });
    };
    if (Array.isArray(options)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_Radios, (0,_object_spread/* default */.Z)({
        options: options,
        value: value,
        onChange: onChange,
        renderOption: renderOption
    }, other));
    var isChecked = checked ? checked : value ? value : localState;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_style.CheckBoxWrapper, {
        size: size,
        disabled: disabled,
        index: index,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Radio_style.CheckboxContainer, {
            className: className,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_style.HiddenCheckbox, {
                    checked: checked ? checked : value ? value : localState,
                    onChange: Boolean(disabled) ? null : onChange ? onChange : toggleLocal
                }),
                !renderOption && /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_style.StyledCheckbox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    id: label
                }, other), {
                    type: "checkbox",
                    checked: isChecked,
                    disabled: disabled,
                    onChange: function() {
                        return Boolean(disabled) ? null : onChange ? onChange : toggleLocal;
                    }
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio_style.CheckBoxLabel, {
                    children: renderOption ? renderOption(label, isChecked) : label
                })
            ]
        })
    });
};
/* harmony default export */ var Radio_Radio = (Radio);

;// CONCATENATED MODULE: ./src/mosanic/fields/Radio/index.js

/* harmony default export */ var fields_Radio = (Radio_Radio);


/***/ }),

/***/ 26074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Select": function() { return /* binding */ Select; },
  "default": function() { return /* binding */ Select_Select; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/index-a7690a33.esm.js + 1 modules
var index_a7690a33_esm = __webpack_require__(33672);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/memoize-one/dist/memoize-one.esm.js
var memoize_one_esm = __webpack_require__(36631);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(9249);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(87371);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(45754);
// EXTERNAL MODULE: ../../node_modules/react-transition-group/esm/Transition.js + 2 modules
var Transition = __webpack_require__(41759);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(80753);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
// EXTERNAL MODULE: ../../node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(77008);
;// CONCATENATED MODULE: ../../node_modules/react-transition-group/esm/utils/ChildMapping.js

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0,react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0,react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0,react.isValidElement)(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = (0,react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0,react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0,react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
;// CONCATENATED MODULE: ../../node_modules/react-transition-group/esm/TransitionGroup.js









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind((0,assertThisInitialized/* default */.Z)(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = (0,esm_extends/* default */.Z)({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
      value: contextValue
    }, /*#__PURE__*/react.createElement(Component, props, children));
  };

  return TransitionGroup;
}(react.Component);

TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ var esm_TransitionGroup = (TransitionGroup);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(12215);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/react-select/animated/dist/react-select.esm.js

















var _excluded$4 = ["in", "onExited", "appear", "enter", "exit"];

// strip transition props off before spreading onto select component
var AnimatedInput = function AnimatedInput(WrappedComponent) {
  return function (_ref) {
    _ref.in;
        _ref.onExited;
        _ref.appear;
        _ref.enter;
        _ref.exit;
        var props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded$4);

    return /*#__PURE__*/react.createElement(WrappedComponent, props);
  };
};

var _excluded$3 = ["component", "duration", "in", "onExited"];
var Fade = function Fade(_ref) {
  var Tag = _ref.component,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1 : _ref$duration,
      inProp = _ref.in;
      _ref.onExited;
      var props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded$3);

  var nodeRef = (0,react.useRef)(null);
  var transition = {
    entering: {
      opacity: 0
    },
    entered: {
      opacity: 1,
      transition: "opacity ".concat(duration, "ms")
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  };
  return /*#__PURE__*/react.createElement(Transition/* default */.ZP, {
    mountOnEnter: true,
    unmountOnExit: true,
    in: inProp,
    timeout: duration,
    nodeRef: nodeRef
  }, function (state) {
    var innerProps = {
      style: (0,index_a7690a33_esm.a)({}, transition[state]),
      ref: nodeRef
    };
    return /*#__PURE__*/react.createElement(Tag, (0,esm_extends/* default */.Z)({
      innerProps: innerProps
    }, props));
  });
}; // ==============================
// Collapse Transition
// ==============================

var collapseDuration = 260;
// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var Collapse = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Collapse, _Component);

  var _super = (0,index_a7690a33_esm._)(Collapse);

  function Collapse() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.duration = collapseDuration;
    _this.rafID = void 0;
    _this.state = {
      width: 'auto'
    };
    _this.transition = {
      exiting: {
        width: 0,
        transition: "width ".concat(_this.duration, "ms ease-out")
      },
      exited: {
        width: 0
      }
    };
    _this.nodeRef = /*#__PURE__*/(0,react.createRef)();

    _this.getStyle = function (width) {
      return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: width
      };
    };

    _this.getTransition = function (state) {
      return _this.transition[state];
    };

    return _this;
  }

  (0,createClass/* default */.Z)(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var ref = this.nodeRef.current;
      /*
        A check on existence of ref should not be necessary at this point,
        but TypeScript demands it.
      */

      if (ref) {
        /*
          Here we're invoking requestAnimationFrame with a callback invoking our
          call to getBoundingClientRect and setState in order to resolve an edge case
          around portalling. Certain portalling solutions briefly remove children from the DOM
          before appending them to the target node. This is to avoid us trying to call getBoundingClientrect
          while the Select component is in this state.
        */
        // cannot use `offsetWidth` because it is rounded
        this.rafID = window.requestAnimationFrame(function () {
          var _ref$getBoundingClien = ref.getBoundingClientRect(),
              width = _ref$getBoundingClien.width;

          _this2.setState({
            width: width
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.rafID) {
        window.cancelAnimationFrame(this.rafID);
      }
    } // get base styles

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          inProp = _this$props.in,
          onExited = _this$props.onExited;

      var exitedProp = function exitedProp() {
        if (_this3.nodeRef.current && onExited) {
          onExited(_this3.nodeRef.current);
        }
      };

      var width = this.state.width;
      return /*#__PURE__*/react.createElement(Transition/* default */.ZP, {
        enter: false,
        mountOnEnter: true,
        unmountOnExit: true,
        in: inProp,
        onExited: exitedProp,
        timeout: this.duration,
        nodeRef: this.nodeRef
      }, function (state) {
        var style = (0,index_a7690a33_esm.a)((0,index_a7690a33_esm.a)({}, _this3.getStyle(width)), _this3.getTransition(state));

        return /*#__PURE__*/react.createElement("div", {
          ref: _this3.nodeRef,
          style: style
        }, children);
      });
    }
  }]);

  return Collapse;
}(react.Component);

var _excluded$2 = ["in", "onExited"];

// strip transition props off before spreading onto actual component
var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded$2);

    return /*#__PURE__*/react.createElement(Collapse, {
      in: inProp,
      onExited: onExited
    }, /*#__PURE__*/react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({
      cropWithEllipsis: inProp
    }, props)));
  };
};

// fade in when last multi-value removed, otherwise instant
var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/react.createElement(Fade, (0,esm_extends/* default */.Z)({
      component: WrappedComponent,
      duration: props.isMulti ? collapseDuration : 1
    }, props));
  };
};

// instant fade; all transition-group children must be transitions
var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/react.createElement(Fade, (0,esm_extends/* default */.Z)({
      component: WrappedComponent
    }, props));
  };
};

var _excluded$1 = ["component"],
    _excluded2 = ["children"];

// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
  return function (props) {
    return props.isMulti ? /*#__PURE__*/react.createElement(IsMultiValueContainer, (0,esm_extends/* default */.Z)({
      component: WrappedComponent
    }, props)) : /*#__PURE__*/react.createElement(esm_TransitionGroup, (0,esm_extends/* default */.Z)({
      component: WrappedComponent
    }, props));
  };
};

var IsMultiValueContainer = function IsMultiValueContainer(_ref) {
  var component = _ref.component,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded$1);

  var multiProps = useIsMultiValueContainer(restProps);
  return /*#__PURE__*/react.createElement(esm_TransitionGroup, (0,esm_extends/* default */.Z)({
    component: component
  }, multiProps));
};

var useIsMultiValueContainer = function useIsMultiValueContainer(_ref2) {
  var children = _ref2.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);

  var isMulti = props.isMulti,
      hasValue = props.hasValue,
      innerProps = props.innerProps,
      _props$selectProps = props.selectProps,
      components = _props$selectProps.components,
      controlShouldRenderValue = _props$selectProps.controlShouldRenderValue;

  var _useState = (0,react.useState)(isMulti && controlShouldRenderValue && hasValue),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      cssDisplayFlex = _useState2[0],
      setCssDisplayFlex = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      removingValue = _useState4[0],
      setRemovingValue = _useState4[1];

  (0,react.useEffect)(function () {
    if (hasValue && !cssDisplayFlex) {
      setCssDisplayFlex(true);
    }
  }, [hasValue, cssDisplayFlex]);
  (0,react.useEffect)(function () {
    if (removingValue && !hasValue && cssDisplayFlex) {
      setCssDisplayFlex(false);
    }

    setRemovingValue(false);
  }, [removingValue, hasValue, cssDisplayFlex]);

  var onExited = function onExited() {
    return setRemovingValue(true);
  };

  var childMapper = function childMapper(child) {
    if (isMulti && /*#__PURE__*/react.isValidElement(child)) {
      // Add onExited callback to MultiValues
      if (child.type === components.MultiValue) {
        return /*#__PURE__*/react.cloneElement(child, {
          onExited: onExited
        });
      } // While container flexed, Input cursor is shown after Placeholder text,
      // so remove Placeholder until display is set back to grid


      if (child.type === components.Placeholder && cssDisplayFlex) {
        return null;
      }
    }

    return child;
  };

  var newInnerProps = (0,index_a7690a33_esm.a)((0,index_a7690a33_esm.a)({}, innerProps), {}, {
    style: (0,index_a7690a33_esm.a)((0,index_a7690a33_esm.a)({}, innerProps === null || innerProps === void 0 ? void 0 : innerProps.style), {}, {
      display: cssDisplayFlex ? 'flex' : 'grid'
    })
  });

  var newProps = (0,index_a7690a33_esm.a)((0,index_a7690a33_esm.a)({}, props), {}, {
    innerProps: newInnerProps,
    children: react.Children.toArray(children).map(childMapper)
  });

  return newProps;
};

var _excluded = ["Input", "MultiValue", "Placeholder", "SingleValue", "ValueContainer"];

var makeAnimated = function makeAnimated() {
  var externalComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var components = (0,index_a7690a33_esm.G)({
    components: externalComponents
  });

  var Input = components.Input,
      MultiValue = components.MultiValue,
      Placeholder = components.Placeholder,
      SingleValue = components.SingleValue,
      ValueContainer = components.ValueContainer,
      rest = (0,objectWithoutProperties/* default */.Z)(components, _excluded);

  return (0,index_a7690a33_esm.a)({
    Input: AnimatedInput(Input),
    MultiValue: AnimatedMultiValue(MultiValue),
    Placeholder: AnimatedPlaceholder(Placeholder),
    SingleValue: AnimatedSingleValue(SingleValue),
    ValueContainer: AnimatedValueContainer(ValueContainer)
  }, rest);
};

var AnimatedComponents = makeAnimated();
var Input = AnimatedComponents.Input;
var MultiValue = AnimatedComponents.MultiValue;
var Placeholder = AnimatedComponents.Placeholder;
var SingleValue = AnimatedComponents.SingleValue;
var ValueContainer = AnimatedComponents.ValueContainer;
var index = (0,memoize_one_esm["default"])(makeAnimated);

/* harmony default export */ var react_select_esm = (index);


// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/Input.styles.js
var Input_styles = __webpack_require__(55217);
;// CONCATENATED MODULE: ./src/mosanic/fields/Select/Select.js








// import { Select as Selector } from "./External";
var Selector = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2233), __webpack_require__.e(8331)]).then(__webpack_require__.bind(__webpack_require__, 98331));
});




var animatedSelect = react_select_esm();
var selectStyles = function() {
    var labelSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "12px", minWidth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, indicator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "block";
    return {
        control: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                // border: `0.5px solid ${colors.util.gray.lightest}`,
                minHeight: "27px",
                border: "none",
                boxShadow: "none",
                background: "none"
            });
        },
        valueContainer: function(provided, state) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                fontSize: "12px",
                // padding: '2px 5px',
                padding: 0,
                minHeight: "20px",
                opacity: (state === null || state === void 0 ? void 0 : (ref = state.selectProps) === null || ref === void 0 ? void 0 : ref.focussed) || (state === null || state === void 0 ? void 0 : state.hasValue) ? 1 : 0
            });
        },
        option: function(provided, state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                zIndex: 5,
                fontSize: labelSize,
                color: state.isSelected ? colors/* default.util.primary.base */.ZP.util.primary.base : "initial",
                background: state.isSelected ? colors/* default.util.gray.lighter */.ZP.util.gray.lighter : "transparent",
                padding: "5px 10px",
                width: "auto",
                "&:hover": {
                    background: colors/* default.util.gray.lighter */.ZP.util.gray.lighter,
                    cursor: "pointer"
                }
            });
        },
        multiValue: function(provided, state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                background: colors/* default.util.gray.lighter */.ZP.util.gray.lighter,
                // fontSize: '12px',
                width: "fit-content"
            });
        },
        noOptionsMessage: function(provided, state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                fontSize: "12px"
            });
        },
        container: function(provided, state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                width: "100%",
                padding: 0,
                minWidth: minWidth,
                // border: `1px solid ${colors.util.gray.lightest}`,
                border: "none",
                "&:hover": {
                    border: "none"
                }
            });
        },
        menuPortal: function(base) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                zIndex: 99
            });
        },
        input: function(provided, state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                margin: "0px"
            });
        },
        indicatorSeparator: function(state) {
            return {
                display: "none"
            };
        },
        indicatorsContainer: function(provided, state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                height: "27px",
                display: "flex",
                "& svg": {
                    transform: "scale(0.7)"
                }
            });
        },
        singleValue: function(provided, state) {
            var opacity = state.isDisabled ? 0.5 : 1;
            var transition = "opacity 300ms";
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
                opacity: opacity,
                transition: transition
            });
        }
    };
};
var Select = function(_param) {
    var _fieldName = _param.fieldName, fieldName = _fieldName === void 0 ? null : _fieldName, _label = _param.label, label = _label === void 0 ? null : _label, _name = _param.name, name = _name === void 0 ? null : _name, _tooltip = _param.tooltip, tooltip = _tooltip === void 0 ? null : _tooltip, _options = _param.options, options = _options === void 0 ? [] : _options, _wrap = _param.wrap, wrap = _wrap === void 0 ? false : _wrap, _value = _param.value, value = _value === void 0 ? null : _value, _defaultValue = _param.defaultValue, defaultValue = _defaultValue === void 0 ? null : _defaultValue, _multiple = _param.multiple, multiple = _multiple === void 0 ? false : _multiple, _searchable = _param.searchable, searchable = _searchable === void 0 ? false : _searchable, _clearable = _param.clearable, clearable = _clearable === void 0 ? true : _clearable, _autoClose = _param.autoClose, autoClose = _autoClose === void 0 ? false : _autoClose, _animated = _param.animated, animated = _animated === void 0 ? true : _animated, _wrapperClass = _param.wrapperClass, wrapperClass = _wrapperClass === void 0 ? null : _wrapperClass, _handler = _param.handler, handler = _handler === void 0 ? function() {
        return null;
    } : _handler, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _required = _param.required, required = _required === void 0 ? false : _required, _labelSize = _param.labelSize, labelSize = _labelSize === void 0 ? "12px" : _labelSize, _menuIsOpen = _param.menuIsOpen, menuIsOpen = _menuIsOpen === void 0 ? undefined : _menuIsOpen, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _loading = _param.loading, loading = _loading === void 0 ? false : _loading, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _getValue = _param.getValue, getValue = _getValue === void 0 ? function(e) {
        return e;
    } : _getValue, _getOptionValue = _param.getOptionValue, getOptionValue = _getOptionValue === void 0 ? function(e) {
        return e === null || e === void 0 ? void 0 : e.value;
    } : _getOptionValue, _getOptionLabel = _param.getOptionLabel, getOptionLabel = _getOptionLabel === void 0 ? function(e) {
        return (e === null || e === void 0 ? void 0 : e.label) ? e.label : e;
    } : _getOptionLabel, other = (0,_object_without_properties/* default */.Z)(_param, [
        "fieldName",
        "label",
        "name",
        "tooltip",
        "options",
        "wrap",
        "value",
        "defaultValue",
        "multiple",
        "searchable",
        "clearable",
        "autoClose",
        "animated",
        "wrapperClass",
        "handler",
        "onChange",
        "required",
        "labelSize",
        "menuIsOpen",
        "fullWidth",
        "loading",
        "disabled",
        "getValue",
        "getOptionValue",
        "getOptionLabel"
    ]);
    var ref;
    var ref1 = (0,react.useState)(false), focussed = ref1[0], setFocused = ref1[1];
    var onFocus = function() {
        return setFocused(true);
    };
    var onBlur = function() {
        return setFocused(false);
    };
    var shrink = Boolean(focussed || value || !value && (options === null || options === void 0 ? void 0 : options.filter(function(o) {
        return !(o === null || o === void 0 ? void 0 : o.value);
    }) //Has unset value
    ));
    if (!((ref = options[0]) === null || ref === void 0 ? void 0 : ref.label)) {
        options = options.map(function(option) {
            return !(option === null || option === void 0 ? void 0 : option.label) ? {
                value: option,
                label: (0,Text/* capitalizeFirst */.Ez)(option)
            } : option;
        });
    }
    var handleSelect = function(val) {
        if (disabled) return;
        if (!onChange && handler) onChange = handler;
        //Get only the value field
        if (multiple) {
            onChange(val.map(function(o) {
                return getOptionValue(o);
            }));
        } else {
            onChange(getOptionValue(val));
        }
    };
    //Get option from received value [option]
    var getOption = function(option) {
        //Check if option is correctly passed
        if (getOptionValue(option)) option = getOptionValue(option);
        //Get multiple single option
        if (Array.isArray(options)) return options === null || options === void 0 ? void 0 : options.find(function(o) {
            return getOptionValue(o) === option;
        });
        //Fallback
        return option;
    };
    var renderValue = function() {
        if (multiple && value) return Array.isArray(value) ? value.map(function(option) {
            return getOption(option);
        }) : [
            getOption(value)
        ];
        return value ? getOption(value) : value;
    };
    //       value={Array.isArray(value) && !value?.[0]?.label ? (
    //     value?.map(v => getCollectionOptions(collections, !_idOnly)?.find(o => o.value === v))
    // ) : value}
    // onChange={o => other?.multiple ? onChange([...o?.map(o => o?.value)]) : onChange(o.value)}
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* WrapInput */.Vw, {
        wrap: wrap ? wrap : false,
        fullWidth: fullWidth,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Input_styles/* default.Container */.ZP.Container, {
            className: "input_field",
            focussed: focussed,
            style: other === null || other === void 0 ? void 0 : other.container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Input_styles/* default.Label */.ZP.Label, {
                    shrink: shrink,
                    children: [
                        label ? label : fieldName ? fieldName : name ? name : "",
                        required && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_styles/* default.Required */.ZP.Required, {})
                    ]
                }),
                (options === null || options === void 0 ? void 0 : options.length) >= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Selector, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    // getOptionLabel={getOptionLabel}
                    disabled: disabled,
                    isDisabled: disabled,
                    focussed: focussed,
                    options: options,
                    value: renderValue(),
                    isLoading: loading,
                    defaultValue: value,
                    onChange: handleSelect,
                    menuIsOpen: menuIsOpen,
                    closeMenuOnSelect: autoClose,
                    isClearable: clearable,
                    isSearchable: searchable,
                    isMulti: multiple,
                    minWidth: "400px",
                    styles: selectStyles(labelSize, other === null || other === void 0 ? void 0 : other.minWidth, other === null || other === void 0 ? void 0 : other.indicator),
                    components: animated ? animatedSelect : null,
                    className: wrapperClass
                }, other), {
                    onFocus: function(e) {
                        if (other === null || other === void 0 ? void 0 : other.onFocus) other.onFocus(e);
                        onFocus();
                    },
                    onBlur: function(e) {
                        if (other === null || other === void 0 ? void 0 : other.onBlur) other.onBlur(e);
                        onBlur();
                    }
                })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_styles/* default.Field */.ZP.Field, {
                    value: (0,Text/* isString */.HD)(value) ? value : "".concat((value === null || value === void 0 ? void 0 : value.length) ? value.length : "0", " entries"),
                    disabled: disabled
                })
            ]
        })
    });
};
/* harmony default export */ var Select_Select = (Select);


/***/ }),

/***/ 85938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ PreviewDataTable; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28932);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(51085);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26021);
/* harmony import */ var _Button_Buttons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47914);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77298);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2921);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8782);
/* harmony import */ var _Select_Select__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26074);
/* harmony import */ var _TextField_Fields__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(91639);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(62570);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _util_Arr__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(72393);
/* harmony import */ var _mosanic_Fieldsets__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(28585);
/* harmony import */ var _mosanic_items_Control_ControlButtons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11743);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    margin: 5px 0 15px;\n    width: 100%;\n\n    th, td { \n        font-size: 12px;\n        border: 1px solid #eee;\n        padding: 5px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        background: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
















var ReactJson = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 8047).then(__webpack_require__.t.bind(__webpack_require__, 48047, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48047)
            ];
        }
    },
    ssr: false
});
var Table = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    componentId: "sc-8fe001a8-0"
})(_templateObject());
var Tr = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tr.withConfig */ .ZP.tr.withConfig({
    componentId: "sc-8fe001a8-1"
})(_templateObject2(), function(props) {
    return props.warning && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1(), (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .lighten */ .$n)(0.1, _mosanic_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"].util.orange.lighter */ .ZP.util.orange.lighter));
});
var TableHeader = function(param) {
    var _hasPointer = param.hasPointer, hasPointer = _hasPointer === void 0 ? false : _hasPointer;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                children: "Current"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                children: "Option"
            }),
            hasPointer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                children: "Found"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                style: {
                    width: "100px"
                },
                children: "Convert"
            })
        ]
    });
};
var TableFooter = function(param) {
    var converted = param.converted, value = param.value, conversion = param.conversion, update = param.update, disabled = param.disabled, options = param.options;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("conversion"), tab = ref[0], setTab = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                colSpan: 2,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Button_Buttons__WEBPACK_IMPORTED_MODULE_8__.Buttons, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Buttons__WEBPACK_IMPORTED_MODULE_8__["default"], {
                                label: "View conversion",
                                ghost: true
                            }),
                            width: "100%",
                            maxWidth: "70vw",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items_Control_ControlButtons__WEBPACK_IMPORTED_MODULE_10__/* .ControlTabs */ .i, {
                                    mb: 2,
                                    active: tab,
                                    setActive: setTab,
                                    options: "conversion|start data|parsed data"
                                }),
                                tab === "conversion" ? Array.isArray(converted) ? converted === null || converted === void 0 ? void 0 : converted.map(function(o) {
                                    var ref;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                        children: [
                                            o === null || o === void 0 ? void 0 : o.index,
                                            " ",
                                            JSON.stringify(o.origin),
                                            " ",
                                            ">",
                                            " ",
                                            JSON.stringify((o === null || o === void 0 ? void 0 : (ref = o.overwrite) === null || ref === void 0 ? void 0 : ref.value) ? o.overwrite : o.convert),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {})
                                        ]
                                    });
                                }) : JSON.stringify(converted) : tab === "start data" ? JSON.stringify(value) : Array.isArray(conversion) ? [
                                    "["
                                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(conversion.map(function(c) {
                                    return " ".concat(c, " , ");
                                })), [
                                    "]"
                                ]).map(function(id) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                        children: [
                                            id,
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {})
                                        ]
                                    }, id);
                                }) : JSON.stringify(conversion)
                            ]
                        }),
                        options && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Buttons__WEBPACK_IMPORTED_MODULE_8__["default"], {
                                label: "View pointer options",
                                ghost: true
                            }),
                            width: "100%",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReactJson, {
                                name: "source",
                                src: options,
                                collapsed: true
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Buttons__WEBPACK_IMPORTED_MODULE_8__["default"], {
                    mt: 1,
                    theme: "primary",
                    label: "Convert",
                    onClick: update,
                    ghost: true,
                    disabled: disabled
                })
            })
        ]
    });
};
var PreviewDataTable = function(param) {
    var value = param.value, options = param.options, _label = param.label, label = _label === void 0 ? null : _label, _data = param.data, data = _data === void 0 ? null : _data, _getLabel = param.getLabel, getLabel = _getLabel === void 0 ? null : _getLabel, onChange = param.onChange;
    var findOption = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(o) {
        return options === null || options === void 0 ? void 0 : options.find(function(option) {
            return (option === null || option === void 0 ? void 0 : option.label) === (o === null || o === void 0 ? void 0 : o.value) || (option === null || option === void 0 ? void 0 : option.label) === (o === null || o === void 0 ? void 0 : o.label);
        });
    }, [
        options
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), pointer = ref[0], setPointer = ref[1];
    var props = {
        value: value,
        options: options,
        findOption: findOption,
        label: label,
        data: data,
        getLabel: getLabel,
        onChange: onChange,
        setPointer: setPointer,
        pointer: pointer
    };
    if (Array.isArray(value)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArrayDataTable, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SingleDataTable, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props));
};
var SingleDataTable = function(param) {
    var value = param.value, options = param.options, findOption = param.findOption, label = param.label, data = param.data, getLabel = param.getLabel, onChange = param.onChange, setPointer = param.setPointer, pointer = param.pointer;
    var ref;
    var o = findOption({
        value: (value === null || value === void 0 ? void 0 : value.value) ? value.value : value,
        label: (value === null || value === void 0 ? void 0 : value.value) ? value.value : value
    });
    var option = data === null || data === void 0 ? void 0 : data.find(function(option) {
        return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_13__/* .get */ .U2)(option, pointer) === value;
    });
    var converted = [
        {
            origin: value,
            option: option,
            convert: {
                label: getLabel ? getLabel(option) : (option === null || option === void 0 ? void 0 : option.label) ? option.label : option,
                value: (option === null || option === void 0 ? void 0 : option._id) ? option._id : (option === null || option === void 0 ? void 0 : option.value) ? option.value : option
            }
        }
    ], conversion = (option === null || option === void 0 ? void 0 : option._id) ? option._id : (option === null || option === void 0 ? void 0 : option.value) ? option.value : option;
    var update = function() {
        return onChange(conversion);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Table, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TableHeader, {
                hasPointer: pointer
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DataRow, {
                origin: {
                    label: label,
                    value: value
                },
                option: option,
                getLabel: getLabel,
                setPointer: setPointer,
                pointer: pointer,
                options: (0,_mosanic_Fieldsets__WEBPACK_IMPORTED_MODULE_14__/* .addUnset */ .fN)(options),
                update: function(val) {
                    return update(val, index);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TableFooter, {
                converted: converted,
                conversion: conversion,
                value: value,
                options: data,
                disabled: ((ref = converted === null || converted === void 0 ? void 0 : converted.filter(function(o) {
                    return !(o === null || o === void 0 ? void 0 : o.option);
                })) === null || ref === void 0 ? void 0 : ref.length) >= 1,
                update: update
            })
        ]
    });
};
var ArrayDataTable = function(param) {
    var value = param.value, options = param.options, findOption = param.findOption, label = param.label, data = param.data, getLabel = param.getLabel, onChange = param.onChange, setPointer = param.setPointer, pointer = param.pointer;
    var ref;
    var formatOption = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(option) {
        return !getLabel ? option : (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, option), {
            label: getLabel(option)
        });
    }, [
        getLabel
    ]);
    //Covert 
    var convertValue = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(o, index1) {
        var option = findOption(o) || (data === null || data === void 0 ? void 0 : data.find(function(option) {
            return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_13__/* .get */ .U2)(option, pointer) === value;
        }));
        return {
            index: index1,
            origin: o,
            option: option,
            convert: formatOption(option),
            overwrite: null
        };
    }, [
        data,
        findOption,
        formatOption,
        pointer,
        value
    ]);
    var convertData = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        return value === null || value === void 0 ? void 0 : value.map(function(val, index1) {
            return convertValue(val, index1);
        });
    }, [
        convertValue,
        value
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(convertData()), converted = ref1[0], setConverted = ref1[1];
    var update = function(val, index1) {
        return setConverted((0,_util_Arr__WEBPACK_IMPORTED_MODULE_16__/* .updateItem */ .$G)(converted, index1, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, converted[index1]), {
            overwrite: formatOption(options === null || options === void 0 ? void 0 : options.find(function(o) {
                return (o === null || o === void 0 ? void 0 : o.value) === val;
            }))
        })));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var timer = null;
        timer = setTimeout(function() {
            setConverted(convertData());
        }, 500);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        convertData,
        pointer
    ]);
    var conversion = converted === null || converted === void 0 ? void 0 : converted.map(function(o) {
        var ref, ref1, ref2;
        return (o === null || o === void 0 ? void 0 : (ref = o.overwrite) === null || ref === void 0 ? void 0 : ref.value) ? o === null || o === void 0 ? void 0 : o.overwrite.value : (o === null || o === void 0 ? void 0 : (ref1 = o.option) === null || ref1 === void 0 ? void 0 : ref1.value) ? o === null || o === void 0 ? void 0 : o.option.value : (o === null || o === void 0 ? void 0 : (ref2 = o.origin) === null || ref2 === void 0 ? void 0 : ref2.value) ? o.origin.value : o.origin;
    });
    var updateAll = function() {
        onChange(conversion);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Table, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TableHeader, {
                hasPointer: pointer
            }),
            converted === null || converted === void 0 ? void 0 : converted.map(function(o, index1) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DataRow, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, o), {
                    getLabel: getLabel,
                    setPointer: setPointer,
                    pointer: pointer,
                    options: (0,_mosanic_Fieldsets__WEBPACK_IMPORTED_MODULE_14__/* .addUnset */ .fN)(options),
                    update: function(val) {
                        return update(val, index1);
                    }
                }));
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TableFooter, {
                converted: converted,
                conversion: conversion,
                value: value,
                options: options,
                disabled: ((ref = converted === null || converted === void 0 ? void 0 : converted.filter(function(o) {
                    var ref;
                    return !(o === null || o === void 0 ? void 0 : o.option) && !(o === null || o === void 0 ? void 0 : (ref = o.overwrite) === null || ref === void 0 ? void 0 : ref.value);
                })) === null || ref === void 0 ? void 0 : ref.length) >= 1,
                update: updateAll
            })
        ]
    });
};
var RenderOption = function(_param) {
    var option = _param.option, _label = _param.label, label = _label === void 0 ? "Matched to:" : _label, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_param, [
        "option",
        "label"
    ]);
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_18__/* .AdvancedLabel */ .qv, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        span: true,
        label: (option === null || option === void 0 ? void 0 : option.label) + " ",
        helpText: "".concat(label, " ").concat(option === null || option === void 0 ? void 0 : option.value)
    }, other));
};
var DataRow = function(param) {
    var option = param.option, origin = param.origin, options = param.options, overwrite = param.overwrite, pointer = param.pointer, setPointer = param.setPointer, getLabel = param.getLabel, update = param.update;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Tr, {
        warning: !option,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_18__/* .Label */ .__, {
                    label: "".concat(origin === null || origin === void 0 ? void 0 : origin.label, ":"),
                    value: origin === null || origin === void 0 ? void 0 : origin.value
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                children: (overwrite || option) && !pointer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RenderOption, {
                            option: option,
                            style: {
                                opacity: (overwrite === null || overwrite === void 0 ? void 0 : overwrite.value) ? 0.2 : 1
                            }
                        }),
                        (overwrite === null || overwrite === void 0 ? void 0 : overwrite.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RenderOption, {
                            option: overwrite,
                            label: "Overwrite set to:"
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_TextField_Fields__WEBPACK_IMPORTED_MODULE_19__["default"], {
                    label: "Set manual pointer",
                    value: pointer,
                    onChange: function(e) {
                        return setPointer(e.target.value);
                    }
                })
            }),
            pointer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_18__/* .AdvancedLabel */ .qv, {
                    span: true,
                    label: getLabel(option)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Buttons__WEBPACK_IMPORTED_MODULE_8__.Buttons, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        overflow: true,
                        p: 0,
                        trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button_Buttons__WEBPACK_IMPORTED_MODULE_8__["default"], {
                            theme: !option && "warning",
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_2__/* .DropdownMenuIcon */ .$Pd, {}),
                            ghost: true
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select_Select__WEBPACK_IMPORTED_MODULE_20__["default"], {
                            searchable: true,
                            label: "Link",
                            options: options,
                            value: overwrite === null || overwrite === void 0 ? void 0 : overwrite.value,
                            onChange: update
                        })
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 23494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "relations": function() { return /* binding */ relations; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66383);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_core_Collections__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11096);
/* harmony import */ var _mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49272);
/* harmony import */ var _redux_auth_reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25157);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);
/* harmony import */ var _Select_Select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26074);
/* harmony import */ var _Convert__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85938);
/* harmony import */ var _redux_options_reducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51331);












var isMultiple = function(type) {};
var relations = [
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "1em",
            height: "1em",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.128 12.321a3.601 3.601 0 110-1.44H18.72v-2.4L24 11.6l-5.28 3.12v-2.4H7.128zM6 11.6a2.4 2.4 0 11-4.8 0 2.4 2.4 0 014.8 0z",
                fill: "#212121"
            })
        }),
        value: "has-one",
        tooltip: "has one",
        multiple: false
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "1em",
            height: "1em",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.6 14a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM20.4 14a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2z",
                    fill: "#212121"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6.24 10.881H18v1.44H6.24v-1.44z",
                    fill: "#212121"
                })
            ]
        }),
        value: "has-belongs-one",
        tooltip: "has and belongs to one",
        multiple: false
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "1em",
            height: "1em",
            viewBox: "0 0 24 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6.24 11.28H18v1.44H6.24v-1.44z",
                    fill: "#212134"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5.871 10.699l8.347-6.176.86 1.162-8.347 6.177-.86-1.163zM5.899 13.354l8.346 6.176.864-1.167-8.347-6.176-.863 1.167z",
                    fill: "#212134"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.6 14.399a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM20.4 14.399a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM16.8 22.8a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM16.8 6a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2z",
                    fill: "#212121"
                })
            ]
        }),
        value: "has-belongs-many",
        tooltip: "belongs to many",
        multiple: true
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "1em",
            height: "1em",
            viewBox: "0 0 24 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17.76 11.28H6v1.44h11.76v-1.44z",
                    fill: "#212134"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M18.129 10.699L9.782 4.523l-.86 1.162 8.347 6.177.86-1.163zM18.101 13.354L9.755 19.53l-.864-1.167 8.347-6.176.863 1.167z",
                    fill: "#212134"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.4 14.399a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0 1.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2zM3.6 14.399a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0 1.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2zM7.2 22.8a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0 1.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2zM7.2 6a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0 1.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2z",
                    fill: "#212134"
                })
            ]
        }),
        value: "other-has-many",
        tooltip: "has may",
        flip: true,
        multiple: true
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "1em",
            height: "1em",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.4 14.4a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM3.6 14.4a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM20.4 22.8a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM20.4 6a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2z",
                    fill: "#212134"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6.24 11.28H18v1.44H6.24v-1.44z",
                    fill: "#212134"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.6 22.8a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0 1.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2zM3.6 6a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0 1.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2z",
                    fill: "#212134"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M18.328 13.863L6.49 19.765l-.652-1.307 11.838-5.902.652 1.307zM18.358 10.078L6.398 4.115l-.646 1.294 11.961 5.963.645-1.294z",
                    fill: "#212134"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M18.323 18.83L6.252 12.813l-.643 1.29 12.071 6.019.643-1.29zM18.136 5.228L6.207 11.176l-.653-1.311 11.928-5.948.654 1.311z",
                    fill: "#212134"
                })
            ]
        }),
        value: "many-has-belongs-many",
        tooltip: "has and belongs to many",
        multiple: true
    },
    {
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "1em",
            height: "1em",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.6 14.132a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2z",
                    fill: "#212134"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6.24 11.011h13.44v1.44H6.24v-1.44z",
                    fill: "#212134"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5.872 10.43l8.347-6.176.86 1.163-8.347 6.176-.86-1.162zM5.9 13.087l8.346 6.177.864-1.168-8.347-6.176-.864 1.167zM18.72 8.613l5.28 3.12-5.28 3.12v-6.24z",
                    fill: "#212134"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12.72 2.633L18.82 2 16.43 7.649 12.72 2.633zM12.72 21.307l6.1.633-2.389-5.649-3.711 5.016z",
                    fill: "#212134"
                })
            ]
        }),
        value: "has-many",
        tooltip: "has many",
        flip: true,
        multiple: true
    }
];
var RelationSelector = function(param) {
    var _value = param.value, value = _value === void 0 ? null : _value, _label = param.label, label = _label === void 0 ? null : _label, _name = param.name, name = _name === void 0 ? null : _name, _relation = param.relation, relation = _relation === void 0 ? null : _relation, _onChange = param.onChange, onChange = _onChange === void 0 ? null : _onChange;
    var ref, ref1, ref2, ref3, ref4;
    var siteId = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_auth_reducer__WEBPACK_IMPORTED_MODULE_2__/* .siteIdSelector */ .uL);
    var devMode = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_options_reducer__WEBPACK_IMPORTED_MODULE_3__/* .getDevModePrefSelector */ .Lj);
    // _id, singleEntry = false, entryId = null}, retrieveEntries = false
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_mosanic_core_Collections__WEBPACK_IMPORTED_MODULE_5__/* .useCollection */ .K)({
        _id: relation === null || relation === void 0 ? void 0 : relation.relationEnd
    }, true), 2), get = ref5[0], ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ref5[1], 3), collection = ref6[0], loading = ref6[1], error = ref6[2];
    // const collection = getCollection(collections, relation?.relationEnd)
    var options = Array.isArray(collection === null || collection === void 0 ? void 0 : collection.entries) ? collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.map(function(e) {
        return {
            value: e === null || e === void 0 ? void 0 : e._id,
            label: (0,_mosanic_fields_Source_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getEntryLabel */ .ax)(e, collection === null || collection === void 0 ? void 0 : collection.schema)
        };
    }) : [];
    var type = relations === null || relations === void 0 ? void 0 : relations.find(function(r) {
        return r.value === (relation === null || relation === void 0 ? void 0 : relation.relation);
    });
    var linkedTitle = (type === null || type === void 0 ? void 0 : type.multiple) ? collection === null || collection === void 0 ? void 0 : collection.title : collection === null || collection === void 0 ? void 0 : collection.singular;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_Select__WEBPACK_IMPORTED_MODULE_7__["default"], {
                searchable: true,
                label: label ? label : linkedTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        type === null || type === void 0 ? void 0 : type.tooltip,
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            children: linkedTitle
                        }),
                        " ",
                        type === null || type === void 0 ? void 0 : type.label
                    ]
                }) : name || label,
                options: options,
                onChange: onChange,
                value: (type === null || type === void 0 ? void 0 : type.multiple) && (value === null || value === void 0 ? void 0 : value.length) >= 1 && !(value === null || value === void 0 ? void 0 : (ref1 = value[0]) === null || ref1 === void 0 ? void 0 : ref1.label) ? value === null || value === void 0 ? void 0 : value.map(function(value) {
                    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        value: value
                    }, options === null || options === void 0 ? void 0 : options.find(function(o) {
                        return o.value === value;
                    }));
                }) : value,
                multiple: type === null || type === void 0 ? void 0 : type.multiple
            }),
            value && devMode && (value === null || value === void 0 ? void 0 : (ref2 = value[0]) === null || ref2 === void 0 ? void 0 : ref2.value) && !((ref3 = options === null || options === void 0 ? void 0 : options.map(function(o) {
                return o.value;
            })) === null || ref3 === void 0 ? void 0 : ref3.includes(value === null || value === void 0 ? void 0 : (ref4 = value[0]) === null || ref4 === void 0 ? void 0 : ref4.value)) && Array.isArray(options) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Convert__WEBPACK_IMPORTED_MODULE_9__/* .PreviewDataTable */ .A, {
                value: value,
                options: options,
                onChange: onChange
            }) : devMode && !(type === null || type === void 0 ? void 0 : type.multiple) && !Array.isArray(value) ? JSON.stringify(value) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (RelationSelector);


/***/ }),

/***/ 49272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* binding */ getEntryDescription; },
/* harmony export */   "$w": function() { return /* binding */ getExtendedFieldPath; },
/* harmony export */   "BG": function() { return /* binding */ isProvider; },
/* harmony export */   "CB": function() { return /* binding */ isProviderSource; },
/* harmony export */   "Cf": function() { return /* binding */ isRepeaterSource; },
/* harmony export */   "Eu": function() { return /* binding */ shouldPassSchema; },
/* harmony export */   "HU": function() { return /* binding */ getMinimalFieldPath; },
/* harmony export */   "J1": function() { return /* binding */ getSchema; },
/* harmony export */   "KE": function() { return /* binding */ isDataLink; },
/* harmony export */   "Kw": function() { return /* binding */ getSourceEntry; },
/* harmony export */   "Oh": function() { return /* binding */ getEntryImage; },
/* harmony export */   "Ts": function() { return /* binding */ getLatestFieldFromFieldPath; },
/* harmony export */   "Tx": function() { return /* binding */ isSource; },
/* harmony export */   "V0": function() { return /* binding */ getEntryDate; },
/* harmony export */   "_K": function() { return /* binding */ getFieldOptions; },
/* harmony export */   "ax": function() { return /* binding */ getEntryLabel; },
/* harmony export */   "c8": function() { return /* binding */ mappableSubFields; },
/* harmony export */   "dg": function() { return /* binding */ canValueReplaceWithCode; },
/* harmony export */   "e9": function() { return /* binding */ getEntry; },
/* harmony export */   "i7": function() { return /* binding */ hasPotentialSubFields; },
/* harmony export */   "nj": function() { return /* binding */ getFieldRelation; },
/* harmony export */   "oe": function() { return /* binding */ getFieldValue; },
/* harmony export */   "rz": function() { return /* binding */ getField; },
/* harmony export */   "uS": function() { return /* binding */ isPageSource; },
/* harmony export */   "wg": function() { return /* binding */ shouldPassData; }
/* harmony export */ });
/* unused harmony exports setBaseState, getCollection, canSelectField */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50930);
/* harmony import */ var _mosanic_utils_value__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11039);
/* harmony import */ var _util_Boolean__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13365);
/* harmony import */ var _util_Date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99787);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62570);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68311);






var setBaseState = function(value, onChange) {};
//Core retreivers
var getCollection = function(collections, collectionId) {
    return (collections === null || collections === void 0 ? void 0 : collections.length) >= 1 ? collectionId ? collections === null || collections === void 0 ? void 0 : collections.find(function(c) {
        return c._id === collectionId;
    }) : {
        entries: collections
    } : collections;
};
var getEntry = function(collection, _id, clone) {
    var ref, ref1;
    return (0,_mosanic_utils_value__WEBPACK_IMPORTED_MODULE_0__/* .isClone */ .vu)(clone) && !_id ? collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref[clone] : Array.isArray(collection === null || collection === void 0 ? void 0 : collection.entries) ? collection === null || collection === void 0 ? void 0 : (ref1 = collection.entries) === null || ref1 === void 0 ? void 0 : ref1.find(function(e) {
        return e._id === _id;
    }) : null;
};
var getEntryLabel = function(entry, schema) {
    var fallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Entry";
    var ref;
    var selector = schema === null || schema === void 0 ? void 0 : (ref = schema[0]) === null || ref === void 0 ? void 0 : ref.name;
    var label = getEntryField(entry, selector, fallback);
    return label != fallback ? label : (entry === null || entry === void 0 ? void 0 : entry.label) ? entry.label : (entry === null || entry === void 0 ? void 0 : entry.name) ? entry.name : (entry === null || entry === void 0 ? void 0 : entry.value) ? entry.value : fallback;
};
var getEntryDate = function(entry) {
    var date = (entry === null || entry === void 0 ? void 0 : entry.updatedAt) ? entry.updatedAt : (entry === null || entry === void 0 ? void 0 : entry.date) ? entry.date : (entry === null || entry === void 0 ? void 0 : entry.lastLogin) ? entry.lastLogin : null;
    return date ? (0,_util_Date__WEBPACK_IMPORTED_MODULE_1__/* .getDate */ ._3)(new Date(date)) : null;
};
var getEntryDescription = function(entry, schema) {
    var fallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "...";
    var ref, ref1;
    if ((0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(entry === null || entry === void 0 ? void 0 : entry.description)) return entry;
    var temp = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(schema);
    var rmvFirst = temp.shift();
    var selector = (ref = temp === null || temp === void 0 ? void 0 : temp.filter(function(f) {
        return [
            "text",
            "textarea"
        ].includes(f === null || f === void 0 ? void 0 : f.type);
    })) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name;
    return getEntryField(entry, selector, fallback);
};
var getEntryImage = function(entry, schema) {
    var fallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var ref, ref1;
    var selector = (ref = schema === null || schema === void 0 ? void 0 : schema.filter(function(f) {
        return [
            "image"
        ].includes(f === null || f === void 0 ? void 0 : f.type);
    })) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name;
    return (entry === null || entry === void 0 ? void 0 : entry[selector]) ? entry[selector] : fallback;
};
var getEntryField = function(entry, selector, fb) {
    var value = (0,_util_Obj__WEBPACK_IMPORTED_MODULE_4__/* .hasAttr */ .B$)(entry, selector) ? entry[selector] : entry === null || entry === void 0 ? void 0 : entry.title;
    if (value || (value === null || value === void 0 ? void 0 : value.en)) {
        return (0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)(value) ? value : value === null || value === void 0 ? void 0 : value.en;
    }
    return fb;
};
var hasPotentialSubFields = function(field) {
    return [
        "repeater",
        "group",
        "user",
        "location",
        "image",
        "relation"
    ].includes(field === null || field === void 0 ? void 0 : field.type);
};
//Render helpers
var getFieldOptions = function(field) {
    var options = (field === null || field === void 0 ? void 0 : field.values) || (field === null || field === void 0 ? void 0 : field.options);
    if (!options) return options;
    if (!Array.isArray(options)) options = options.split("\n");
    if ((0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .containsSubstr */ .xX)(options === null || options === void 0 ? void 0 : options[0], ":")) options = options.map(function(o) {
        var ref;
        return {
            value: (0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .removeSpaces */ .I8)(o.split(":")[0]),
            label: ((ref = o.split(":")) === null || ref === void 0 ? void 0 : ref[1]) ? o.split(":")[1] : o.split(":")[0]
        };
    });
    return options;
};
var getFieldRelation = function(field) {
    return (field === null || field === void 0 ? void 0 : field.type) === "relation" ? {
        relation: field.relation,
        relationEnd: field === null || field === void 0 ? void 0 : field.relationEnd
    } : null;
};
var shouldPassSchema = function(field) {
    if ([
        "repeater",
        "markedimage",
        "group",
        "column",
        "select"
    ].includes(field === null || field === void 0 ? void 0 : field.type)) return true;
    return false;
};
var shouldPassData = function(field) {
    var ref;
    if ((field === null || field === void 0 ? void 0 : field.populateActive) && (field === null || field === void 0 ? void 0 : field.populateCode)) return true;
    if ((field === null || field === void 0 ? void 0 : field.populateActive) && (field === null || field === void 0 ? void 0 : field.dangerousPopulation) && (field === null || field === void 0 ? void 0 : field.code)) return true;
    if ((field === null || field === void 0 ? void 0 : field.validateActive) && (field === null || field === void 0 ? void 0 : (ref = field.validation) === null || ref === void 0 ? void 0 : ref.length) >= 1) return true;
    if (shouldPassSchema(field)) {
        var ref1, ref2;
        return ((ref2 = field === null || field === void 0 ? void 0 : (ref1 = field.schema) === null || ref1 === void 0 ? void 0 : ref1.filter(function(f) {
            return shouldPassData(f);
        })) === null || ref2 === void 0 ? void 0 : ref2.length) >= 1;
    }
    return false;
};
//Data Item source selector
var isProvider = function(itemType) {
    return itemType === "dataprovider";
};
var isDataLink = function(itemType) {
    return itemType === "datalink";
};
var isSource = function(state) {
    return (state === null || state === void 0 ? void 0 : state.source) === "source" || state === "source";
};
var isProviderSource = function(state) {
    return (state === null || state === void 0 ? void 0 : state.source) === "provider" || state === "provider";
};
var isRepeaterSource = function(state) {
    return (state === null || state === void 0 ? void 0 : state.source) === "repeater" || state === "repeater";
};
var isPageSource = function(state) {
    return (state === null || state === void 0 ? void 0 : state.source) === "page" || state === "page";
};
var mappableSubFields = [
    "repeater",
    "group",
    "relation",
    "location",
    "user",
    "gallery",
    "image"
];
var canValueReplaceWithCode = function(fieldType) {
    return [
        "textarea",
        "text",
        "number",
        "slug",
        "code",
        "switch"
    ].includes(fieldType);
};
var canSelectField = function(fieldType, itemType) {
    if (isProvider(itemType)) return "repeater|relation".split("|").includes(fieldType);
    if (isDataLink(itemType)) return !"repeater|relation".split("|").includes(fieldType);
    return true;
};
var findField = function(schema, fieldName) {
    return Array.isArray(schema) ? schema === null || schema === void 0 ? void 0 : schema.find(function(f) {
        return (f === null || f === void 0 ? void 0 : f.name) === fieldName;
    }) : null;
};
//Parse field path
var getField = function(collection, entry) {
    var ref;
    if (!(collection === null || collection === void 0 ? void 0 : collection.schema) || !(entry === null || entry === void 0 ? void 0 : entry.fieldPath)) return null;
    var fullFieldPath = [];
    var tempSchema = collection === null || collection === void 0 ? void 0 : collection.schema;
    entry === null || entry === void 0 ? void 0 : (ref = entry.fieldPath) === null || ref === void 0 ? void 0 : ref.map(function(path) {
        var field = findField(tempSchema, path === null || path === void 0 ? void 0 : path.name);
        if (field) {
            fullFieldPath = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(fullFieldPath).concat([
                field
            ]);
            tempSchema = field === null || field === void 0 ? void 0 : field.schema;
        } else {
            console.warn("no field");
            console.warn({
                fullFieldPath: fullFieldPath,
                field: field,
                tempSchema: tempSchema
            });
        }
    });
    return fullFieldPath;
};
var getExtendedFieldPath = function(fullPath, prevPath) {
    return fullPath === null || fullPath === void 0 ? void 0 : fullPath.filter(function(field) {
        return !(prevPath === null || prevPath === void 0 ? void 0 : prevPath.find(function(rmv) {
            return (rmv === null || rmv === void 0 ? void 0 : rmv.name) === (field === null || field === void 0 ? void 0 : field.name);
        }));
    });
};
var getLatestFieldFromFieldPath = function(fieldPath) {
    return fieldPath === null || fieldPath === void 0 ? void 0 : fieldPath[(fieldPath === null || fieldPath === void 0 ? void 0 : fieldPath.length) - 1];
};
var getMinimalFieldPath = function(fieldPath) {
    return Array.isArray(fieldPath) ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .combineString */ .M7)(fieldPath.map(function(field) {
        return field === null || field === void 0 ? void 0 : field.name;
    }), ".") : "";
};
var getFieldValue = function(fieldPath, entry) {
    var schema = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var tempValue = entry;
    // todo !check fix
    if (schema === null || schema === void 0 ? void 0 : schema.schema) schema = schema === null || schema === void 0 ? void 0 : schema.schema;
    fieldPath === null || fieldPath === void 0 ? void 0 : fieldPath.map(function(path) {
        var value = (0,_util_Obj__WEBPACK_IMPORTED_MODULE_4__/* .hasAttr */ .B$)(tempValue, path === null || path === void 0 ? void 0 : path.name) ? tempValue[path === null || path === void 0 ? void 0 : path.name] : null;
        // console.log({path, entry, value})
        if ((0,_util_Boolean__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(value)) {
            tempValue = value;
        } else if ((path === null || path === void 0 ? void 0 : path.name) === "slug" && !value) {
            var ref;
            //Retrieve full entry for slug data.
            tempValue = schema ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .slugify */ .lV)(entry === null || entry === void 0 ? void 0 : entry[schema === null || schema === void 0 ? void 0 : (ref = schema[0]) === null || ref === void 0 ? void 0 : ref.name]) : entry;
        // console.log({ slug: slugify(entry?.[schema?.[0]?.name]), name: entry?.[schema?.[0]?.name], attr: schema?.[0]?.name, schema, entry})
        } else if (value) {
            tempValue = value;
        } else {
            tempValue = null;
        // console.warn('no value')
        // console.warn({tempValue, value, fieldPath})
        }
    });
    return tempValue;
};
var getSchema = function(fieldPath, schema) {
    var tempSchema = schema;
    if (!Array.isArray(tempSchema) || !fieldPath) return tempSchema;
    fieldPath === null || fieldPath === void 0 ? void 0 : fieldPath.map(function(path) {
        var ref;
        var value = (tempSchema === null || tempSchema === void 0 ? void 0 : tempSchema.schema) ? (ref = tempSchema.schema) === null || ref === void 0 ? void 0 : ref.find(function(s) {
            return (s === null || s === void 0 ? void 0 : s.name) === (path === null || path === void 0 ? void 0 : path.name);
        }) : Array.isArray(tempSchema) ? tempSchema === null || tempSchema === void 0 ? void 0 : tempSchema.find(function(s) {
            return (s === null || s === void 0 ? void 0 : s.name) === (path === null || path === void 0 ? void 0 : path.name);
        }) : tempSchema;
        if ((path === null || path === void 0 ? void 0 : path.name) === "slug") value = {
            schema: schema
        };
        if (value) {
            tempSchema = value;
        } else {
        // console.warn('no tempSchema')
        // console.warn({tempSchema, value, fieldPath})
        }
    });
    return tempSchema;
};
var getSourceEntry = function(param) {
    var value = param.value, collections = param.collections, context = param.context;
    if (isPageSource(value)) {
        var dataProvider = context === null || context === void 0 ? void 0 : context.pageProvider;
        return [
            dataProvider === null || dataProvider === void 0 ? void 0 : dataProvider.schema,
            dataProvider === null || dataProvider === void 0 ? void 0 : dataProvider.schema,
            dataProvider === null || dataProvider === void 0 ? void 0 : dataProvider.baseRoute,
            dataProvider === null || dataProvider === void 0 ? void 0 : dataProvider.entries,
            null
        ];
    // return retreivePageContext(value, collections, context.pageProvider.entry)
    }
    if (isProviderSource(value)) {
        var ref, ref1, ref2;
        var dataProvider1 = context === null || context === void 0 ? void 0 : (ref = context.dataProvider) === null || ref === void 0 ? void 0 : (ref1 = ref[value === null || value === void 0 ? void 0 : value.provider]) === null || ref1 === void 0 ? void 0 : ref1.entry;
        var hasReceivedSource = Boolean((dataProvider1 === null || dataProvider1 === void 0 ? void 0 : dataProvider1.source) === "provider");
        var receivedSource = context === null || context === void 0 ? void 0 : (ref2 = context.dataProvider) === null || ref2 === void 0 ? void 0 : ref2[dataProvider1 === null || dataProvider1 === void 0 ? void 0 : dataProvider1.provider];
        return revertEntryPath(hasReceivedSource ? receivedSource : collections, hasReceivedSource ? receivedSource === null || receivedSource === void 0 ? void 0 : receivedSource.entry : dataProvider1, value === null || value === void 0 ? void 0 : value.clone);
    }
    if (isRepeaterSource(value)) {
        var dataProvider2 = context === null || context === void 0 ? void 0 : context.repeatProvider;
        return [
            dataProvider2 === null || dataProvider2 === void 0 ? void 0 : dataProvider2.schema,
            dataProvider2 === null || dataProvider2 === void 0 ? void 0 : dataProvider2.schema,
            dataProvider2 === null || dataProvider2 === void 0 ? void 0 : dataProvider2.baseRoute,
            [
                dataProvider2 === null || dataProvider2 === void 0 ? void 0 : dataProvider2.entries
            ],
            null
        ];
    }
    // [
    //     collection,
    //     item,
    //     value.fieldPath
    // ]
    return revertEntryPath(collections, value, value === null || value === void 0 ? void 0 : value.clone);
};
// const retreivePageContext = (value, collections, dataEntry) => {
//     if(!dataEntry?.collectionId) return [null, 'Did not receive collection id', null]
//     const collection = getCollection(collections, dataEntry?.collectionId);
//     const item = dataEntry;
//     return [
//         collection,
//         collection?.schema,
//         collection?.baseRoute,
//         item,
//         value.fieldPath
//     ]
// }
var revertEntryPath = function(collections, entry) {
    var clone = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var collection = getCollection(collections, entry === null || entry === void 0 ? void 0 : entry.collection);
    var item = getEntry(collection, entry === null || entry === void 0 ? void 0 : entry.entry, clone);
    var fieldPath = getField(collection, entry);
    return [
        collection,
        collection === null || collection === void 0 ? void 0 : collection.schema,
        collection === null || collection === void 0 ? void 0 : collection.baseRoute,
        item,
        fieldPath
    ];
};


/***/ }),

/***/ 4625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Columns": function() { return /* binding */ Columns; },
  "default": function() { return /* binding */ Source; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Popper.js + 4 modules
var Popper = __webpack_require__(28932);
// EXTERNAL MODULE: ./src/mosanic/items/ControlModal/Dialog.js
var Dialog = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/mosanic/items/ErrorAlert.js
var ErrorAlert = __webpack_require__(83482);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/useCollections.js
var useCollections = __webpack_require__(52610);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/useCollection.js
var useCollection = __webpack_require__(11096);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/fields/Source/helpers.js
var helpers = __webpack_require__(49272);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/mosanic/styles/util.js
var util = __webpack_require__(5070);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/features/inspect/reducer.js
var inspect_reducer = __webpack_require__(57522);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/fields/TextField/Fields.js
var Fields = __webpack_require__(91639);
// EXTERNAL MODULE: ./src/mosanic/builder/DataLink/DataReceiver.js
var DataReceiver = __webpack_require__(65139);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(87567);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var items_AdvancedLabel = __webpack_require__(51085);
// EXTERNAL MODULE: ./src/utils/Empty.js
var Empty = __webpack_require__(75276);
;// CONCATENATED MODULE: ./src/mosanic/fields/Source/Header/useSourceTabs.js





var validateContextProviders = function(options, context) {
    var ref;
    if (!(0,Empty/* default */.Z)(context === null || context === void 0 ? void 0 : context.dataProvider)) options.push({
        value: "provider",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* OpenInNewWindowIcon */.kDh, {})
    });
    if (!(0,Empty/* default */.Z)(context === null || context === void 0 ? void 0 : context.relationProvider)) options.push({
        value: "relation",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* OpenInNewWindowIcon */.kDh, {})
    });
    if (!(0,Empty/* default */.Z)(context === null || context === void 0 ? void 0 : context.repeatProvider)) options.push({
        value: "repeater",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* LoopIcon */.DjT, {})
    });
    if (!(0,Empty/* default */.Z)(context === null || context === void 0 ? void 0 : (ref = context.pageProvider) === null || ref === void 0 ? void 0 : ref.entry)) options.push({
        value: "page",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* FileTextIcon */.zPP, {})
    });
    return options;
};
var getSourceTabOptions = function(context) {
    var options = [
        {
            value: "source"
        }
    ];
    return validateContextProviders(options, context);
};
var useSourceTabs = function(param) {
    var value = param.value, handler = param.handler, _context = param.context, context = _context === void 0 ? null : _context;
    var source = (value || {
        source: "source"
    }).source;
    var setSourceTab = function(source) {
        return handler((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            collection: undefined,
            entry: undefined,
            column: "field",
            source: source
        }));
    };
    if (!(value === null || value === void 0 ? void 0 : value.source)) setSourceTab("source");
    return {
        value: source,
        options: getSourceTabOptions(context),
        handler: setSourceTab,
        key: "source"
    };
};

// EXTERNAL MODULE: ./src/mosanic/utils/value.js + 1 modules
var utils_value = __webpack_require__(11039);
;// CONCATENATED MODULE: ./src/mosanic/fields/Source/Header/useEntryTabs.js






var getEntryOptions = function(value, isProvider) {
    if (isProvider) return [
        {
            value: "entry"
        }
    ];
    return (0,utils_value/* isClone */.vu)(value === null || value === void 0 ? void 0 : value.clone) ? [
        {
            value: "entry",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* Component2Icon */.GwC, {})
        },
        {
            value: "dynamic",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* TargetIcon */.cK5, {})
        }
    ] : [
        {
            value: "entry"
        }
    ];
};
var useEntryTabs = function(param) {
    var value = param.value, handler = param.handler, itemType = param.itemType;
    var tab = (value || {
        tab: {
            entry: "entry"
        }
    }).tab;
    var setEntryTab = function(entry) {
        return handler((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            tab: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tab), {
                entry: entry
            })
        }));
    };
    var options = getEntryOptions(value, (0,helpers/* isProvider */.BG)(itemType));
    return {
        value: tab === null || tab === void 0 ? void 0 : tab.entry,
        handler: setEntryTab,
        options: options,
        key: "entry"
    };
};

;// CONCATENATED MODULE: ./src/mosanic/fields/Source/Header/useColumnTabs.js






var getColumnTabOptions = function(param) {
    var canReplaceValue = param.canReplaceValue, isProvider = param.isProvider;
    var base = [
        {
            value: "field",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* InputIcon */.SQj, {})
        },
        {
            value: "editor",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* CodeIcon */.dNJ, {})
        }, 
    ];
    if (isProvider || !canReplaceValue) return base;
    return [
        {
            value: "code",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* CodeIcon */.dNJ, {})
        }
    ].concat((0,_to_consumable_array/* default */.Z)(base));
};
/**
 * Source selector column options
 * @returns data + handling for selector
 */ var useColumnTabs = function(param) {
    var value = param.value, handler = param.handler, itemType = param.itemType;
    var ref;
    var column = (value || {
        column: "field"
    }).column;
    var setColumn = function(col) {
        return handler((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            column: col
        }));
    };
    var options = getColumnTabOptions({
        canReplaceValue: (0,helpers/* canValueReplaceWithCode */.dg)((ref = (0,helpers/* getLatestFieldFromFieldPath */.Ts)(value === null || value === void 0 ? void 0 : value.fieldPath)) === null || ref === void 0 ? void 0 : ref.type),
        isProvider: (0,helpers/* isProvider */.BG)(itemType)
    });
    return {
        value: column,
        handler: setColumn,
        options: options,
        key: "column"
    };
};

// EXTERNAL MODULE: ./src/features/options/reducer.js + 1 modules
var options_reducer = __webpack_require__(51331);
;// CONCATENATED MODULE: ./src/mosanic/fields/Source/Header/useDevTabs.js






var useDevTabs = function(param) {
    var value = param.value, handler = param.handler;
    var dev = (value || {
        dev: undefined
    }).dev;
    var isDevMode = (0,es/* useSelector */.v9)(options_reducer/* getDevModePrefSelector */.Lj);
    var options = [
        {
            value: "add",
            icons: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ResetIcon */.X5P, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* PlusCircledIcon */.SPS, {})
            ]
        },
        {
            value: "data",
            icons: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ResetIcon */.X5P, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* FileIcon */.aAW, {})
            ]
        },
        {
            value: "get",
            icons: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ResetIcon */.X5P, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowDownIcon */.veu, {})
            ]
        }, 
    ];
    var setDevColumn = function(mode) {
        return handler((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            dev: dev === mode ? undefined : mode
        }));
    };
    return {
        options: isDevMode ? options : [],
        handler: setDevColumn,
        value: dev,
        key: "dev"
    };
};

;// CONCATENATED MODULE: ./src/mosanic/fields/Source/Header/Header.js




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    \n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dfe1d869-0"
})(_templateObject());
var isValue = function(option, value) {
    return value && option.value === value;
};
var Group = function(_param) {
    var options = _param.options, handler = _param.handler, value = _param.value, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "options",
        "handler",
        "value",
        "children"
    ]);
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ButtonGroup/* ButtonGroup */.h, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        small: true,
        right: true
    }, other), {
        children: options === null || options === void 0 ? void 0 : options.map(function(option) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Buttons["default"], (0,_object_spread/* default */.Z)({
                label: isValue(option, value) && (option === null || option === void 0 ? void 0 : option.icons) ? "" : option.value,
                onClick: function() {
                    return handler(option.value);
                },
                icon: (option === null || option === void 0 ? void 0 : option.icons) ? isValue(option, value) ? option.icons[0] : option.icons[1] : option.icon,
                active: isValue(option, value),
                disabled: other === null || other === void 0 ? void 0 : other.disabled
            }, option), option.value);
        })
    }));
};
var HeaderWrapper = function(param) {
    var title = param.title, helpText = param.helpText, dialog = param.dialog, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(items_AdvancedLabel/* AdvancedLabel */.qv, {
                as: "h4",
                style: {
                    marginTop: dialog.expand ? "15px" : 0
                },
                span: true,
                helpText: helpText,
                children: [
                    title,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons["default"], {
                        ghost: true,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* SizeIcon */.el1, {}),
                        mt: "-2px",
                        style: {
                            display: "inline-block"
                        },
                        onClick: dialog.handleExpand
                    })
                ]
            }),
            children
        ]
    });
};
var Header = function(param) {
    var dialog = param.dialog, title = param.title, helpText = param.helpText, value = param.value, handler = param.handler, itemType = param.itemType, context = param.context;
    title = !(value === null || value === void 0 ? void 0 : value.dev) ? title : (0,Text/* capitalizeFirst */.Ez)(value.dev);
    var groups = [
        useSourceTabs({
            value: value,
            handler: handler,
            context: context
        }),
        useEntryTabs({
            value: value,
            handler: handler,
            itemType: itemType
        }),
        useColumnTabs({
            value: value,
            handler: handler,
            itemType: itemType
        }),
        useDevTabs({
            value: value,
            handler: handler
        }), 
    ].filter(function(g) {
        return g.options.length > 1;
    }).filter(function(g) {
        return !(value === null || value === void 0 ? void 0 : value.dev) || g.key === "dev";
    }).map(function(g) {
        var ref;
        return !(value === null || value === void 0 ? void 0 : value.dev) ? g : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, g), {
            options: (ref = g.options) === null || ref === void 0 ? void 0 : ref.filter(function(o) {
                return o.value === value.dev;
            })
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWrapper, {
        title: title,
        helpText: helpText,
        dialog: dialog,
        children: groups.map(function(group) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Group, (0,_object_spread/* default */.Z)({}, group), group === null || group === void 0 ? void 0 : group.key);
        })
    });
};

;// CONCATENATED MODULE: ./src/mosanic/fields/Source/Header/index.js

/* harmony default export */ var Source_Header = (Header);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/mosanic/items/Expander/index.js + 1 modules
var Expander = __webpack_require__(56957);
// EXTERNAL MODULE: ./src/mosanic/items/Tooltip/index.js + 2 modules
var Tooltip = __webpack_require__(94233);
// EXTERNAL MODULE: ./src/mosanic/items/List/List.js + 2 modules
var List = __webpack_require__(62035);
// EXTERNAL MODULE: ./src/utils/Arr.js
var Arr = __webpack_require__(72393);
// EXTERNAL MODULE: ./src/mosanic/items/Skeletons/Skeletons.js + 1 modules
var Skeletons = __webpack_require__(86443);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/mosanic/utils/Image.js
var Image = __webpack_require__(73987);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/Funct.js
var Funct = __webpack_require__(3847);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(1899);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/many.js + 1 modules
var many = __webpack_require__(43551);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/count.js
var Query_count = __webpack_require__(88574);
// EXTERNAL MODULE: ./src/utils/Num.js
var Num = __webpack_require__(3121);
// EXTERNAL MODULE: ./src/utils/Boolean.js
var Boolean = __webpack_require__(13365);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/useDataQuery.js
var useDataQuery = __webpack_require__(49974);
;// CONCATENATED MODULE: ./src/mosanic/fields/Source/useSources.js
















var getContext = function(param) {
    var type = param.type, context = param.context;
    switch(type){
        case "page":
            return context === null || context === void 0 ? void 0 : context.pageProvider;
        case "provider":
            return context === null || context === void 0 ? void 0 : context.dataProvider;
        case "repeater":
            return context === null || context === void 0 ? void 0 : context.repeatProvider;
        default:
            return null;
    }
};
var getProviderCollections = function(param) {
    var type = param.type, context = param.context, collections = param.collections;
    switch(type){
        case "page":
            return context;
        case "provider":
            return [
                (0,_object_spread/* default */.Z)({
                    title: "Page context",
                    label: "entry",
                    _id: "page"
                }, context)
            ];
        case "repeater":
            return context;
        default:
            return collections === null || collections === void 0 ? void 0 : collections.map(function(c) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, c), {
                    label: (0,Num/* isNumber */.hj)(c === null || c === void 0 ? void 0 : c.entries) ? "".concat(c === null || c === void 0 ? void 0 : c.entries, " entries") : "",
                    count: (0,Num/* isNumber */.hj)(c === null || c === void 0 ? void 0 : c.entries) ? c.entries : ""
                });
            });
    }
};
var getProviderEntries = function(param) {
    var type = param.type, provider = param.provider, entries = param.entries;
    switch(type){
        // case 'page': return Object.entries(providers).map(([title, value]) => ({
        //     title, label: getProviderCollectionLabel({value}), value, _id: title
        // }));
        // case 'provider': return [{title: 'Page context', label: 'entry', _id: 'page', ...context}]
        // case 'repeater': return [{title: 'Repeater context', label: 'entries', _id: 'repeater', ...context}];
        default:
            return Array.isArray(provider === null || provider === void 0 ? void 0 : provider.entries) ? provider === null || provider === void 0 ? void 0 : provider.entries : entries;
    }
};
var getFieldSchema = function(param) {
    var type = param.type, provider = param.provider, entry = param.entry, value = param.value;
    var schema;
    switch(type){
        // case 'page': return Object.entries(providers).map(([title, value]) => ({
        //     title, label: getProviderCollectionLabel({value}), value, _id: title
        // }));
        // case 'provider': return [{title: 'Page context', label: 'entry', _id: 'page', ...context}]
        case "repeater":
            schema = provider === null || provider === void 0 ? void 0 : provider.schema;
            break;
        default:
            schema = provider === null || provider === void 0 ? void 0 : provider.schema;
            break;
    }
    if (!schema && entry) schema = createSchema(entry);
    if ((value === null || value === void 0 ? void 0 : value.entry) === "provider" && provider) schema = createSchema(provider);
    return schema;
};
var BASE_CONTROLS = {
    limit: 8,
    skip: 0
};
var useSources = function(param) {
    var value = param.value;
    var ref = (0,react.useState)(BASE_CONTROLS), controller = ref[0], setController = ref[1];
    var type = value === null || value === void 0 ? void 0 : value.source;
    //Sources
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,many/* useGetCollectionIndexes */.Vk)({
        current: true
    }), 2), collections = ref1[0], loading = ref1[1];
    var collectionId = type === "source" ? value === null || value === void 0 ? void 0 : value.collection : undefined;
    (0,react.useEffect)(function() {
        if (collectionId) {
            setController(BASE_CONTROLS);
        }
    }, [
        collectionId
    ]);
    var inspectedContext = (0,es/* useSelector */.v9)(inspect_reducer/* selectInspectContext */.P);
    //Entries
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,many/* useGetEntries */.e1)((0,_object_spread/* default */.Z)({
        filter: {
            collectionId: collectionId
        }
    }, controller)), 2), data_entries = ref2[0], loading_entries = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,Query_count/* useGetEntryCount */.p)({
        _id: collectionId
    }), 1), count = ref3[0];
    var context = getContext({
        type: type,
        context: inspectedContext
    });
    var providers = getProviderCollections({
        type: type,
        context: context,
        collections: collections
    });
    var provider = (value === null || value === void 0 ? void 0 : value.collection) && Array.isArray(providers) ? providers === null || providers === void 0 ? void 0 : providers.find(function(p) {
        return (p === null || p === void 0 ? void 0 : p._id) === (value === null || value === void 0 ? void 0 : value.collection);
    }) : context;
    var entries = getProviderEntries({
        type: type,
        provider: provider,
        entries: data_entries
    });
    var entry = entries === null || entries === void 0 ? void 0 : entries.find(function(e) {
        return (e === null || e === void 0 ? void 0 : e._id) === (value === null || value === void 0 ? void 0 : value.entry);
    });
    if (entry) entry = (0,useDataQuery/* convertEntry */.ec)(entry);
    var schema = getFieldSchema({
        type: type,
        provider: provider,
        entry: entry,
        value: value
    });
    console.log({
        context: context,
        type: type,
        provider: provider,
        entries: entries
    });
    var controls = {
        next: function() {
            var newSkip = controller.skip + controller.limit;
            if (!count || newSkip > count) return null;
            return function() {
                return setController((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, controller), {
                    skip: newSkip
                }));
            };
        },
        prev: function() {
            var newSkip = controller.skip - controller.limit;
            if (!count || newSkip < 0) return null;
            return function() {
                return setController((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, controller), {
                    skip: newSkip
                }));
            };
        },
        skip: controller === null || controller === void 0 ? void 0 : controller.skip,
        limit: controller === null || controller === void 0 ? void 0 : controller.limit,
        count: count
    };
    return [
        providers,
        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provider), {
            entries: entries
        }),
        entry,
        schema,
        [
            loading,
            loading_entries
        ],
        controls
    ];
};
//Creation 
var createProviderCollectionLabel = function(param) {
    var value = param.value;
    var ref;
    if (Array.isArray(value)) return "List of ".concat(value.length, " entries");
    return "".concat((ref = Object.keys(value)) === null || ref === void 0 ? void 0 : ref.length, " sub groups");
};
var getField = function(key, value) {
    var ref;
    var field = {
        label: key,
        type: (0,Text/* isString */.HD)(value) ? "text" : Array.isArray(value) ? "repeater" : (0,Obj/* isObject */.Kn)(value) ? "group" : (0,Boolean/* default */.Z)(value) ? "switch" : ((ref = new Date(value)) === null || ref === void 0 ? void 0 : ref.getMonth()) ? "date" : typeof value === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(value),
        name: key,
        schema: null,
        value: value
    };
    if ([
        "updated",
        "created"
    ].includes(field === null || field === void 0 ? void 0 : field.name) && (field === null || field === void 0 ? void 0 : field.type) === "number") field = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
        type: "date",
        value: new Date(value * 1000)
    });
    return "group" === (field === null || field === void 0 ? void 0 : field.type) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
        schema: createSchema(value)
    }) : "repeater" === (field === null || field === void 0 ? void 0 : field.type) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
        schema: !(0,Text/* isString */.HD)(value === null || value === void 0 ? void 0 : value[0]) ? createSchema(value[0]) : null
    }) : field;
};
var createSchema = function(obj) {
    return !obj ? [] : Object.entries(obj).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], value = _param[1];
        return !(0,Empty/* default */.Z)(value);
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return getField(key, value);
    });
};

// EXTERNAL MODULE: ./src/mosanic/core/Collections/Select/SelectField.js
var SelectField = __webpack_require__(3849);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
;// CONCATENATED MODULE: ./src/mosanic/fields/Source/Select/Provider.js






function Provider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    opacity: 0.3;\n"
    ]);
    Provider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





























var ReactJson = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8047).then(__webpack_require__.t.bind(__webpack_require__, 48047, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48047)
            ];
        }
    },
    ssr: false
});
//Data provider
var getProviderEntryLabel = function(value) {
    var ref;
    if (Array.isArray(value)) return "List of ".concat(value.length, " entries");
    return "".concat((ref = Object.keys(value)) === null || ref === void 0 ? void 0 : ref.length, " sub groups");
};
var removePath = function(title) {
    var ref;
    return ((ref = title === null || title === void 0 ? void 0 : title.split(".")) === null || ref === void 0 ? void 0 : ref.length) >= 2 ? title === null || title === void 0 ? void 0 : title.split(".")[1] : title;
};
var getTitle = function(title) {
    return (0,Text/* excerptString */.dK)((0,Text/* revertDevCases */.Uw)((0,Text/* replaceParts */.oE)(title, "&amp;", "&")), 14, "...");
};
var renderFieldData = function(field, data) {
    var ref;
    var img = (ref = (0,Image/* parseImageSrc */.yO)(data, true)) === null || ref === void 0 ? void 0 : ref.thumb;
    if (img) return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: img,
        width: "20px",
        height: "20px",
        alt: ""
    });
    return (0,Text/* isString */.HD)(data) && data ? data.length >= 200 ? "[text] with ".concat(data.length, " chars") : (0,Text/* excerptString */.dK)(data, 14, "...") : data ? "[".concat(field === null || field === void 0 ? void 0 : field.type, "] with value") : data ? JSON.stringify(data) : "[".concat(field === null || field === void 0 ? void 0 : field.type, "]");
};
var loader = function() {
    var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3;
    return (0,Arr/* loopFunc */.Jc)(count <= 10 ? count : 10, function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItem */.HC, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeletons/* SkeletonLine */.AU, {})
        });
    });
};
var Item = function(param) {
    var actions = param.actions, trigger = param.trigger, title = param.title;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Popper/* default */.Z, {
        contextOnly: true,
        p: 0,
        m: 0,
        ml: 10,
        width: "120px",
        trigger: trigger,
        bigShadow: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* List */.aV, {
            compact: true,
            m: 0,
            p: 0,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItem */.HC, {
                    title: true,
                    children: title
                }),
                actions === null || actions === void 0 ? void 0 : actions.map(function(action) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(List/* ListItem */.HC, {
                        disabled: action === null || action === void 0 ? void 0 : action.disabled,
                        onClick: action === null || action === void 0 ? void 0 : action.onClick,
                        children: action === null || action === void 0 ? void 0 : action.label
                    });
                })
            ]
        })
    });
};
var ProviderSelector = function(param) {
    var type = param.type, providers = param.providers, onChange = param.onChange, value = param.value;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(List/* List */.aV, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* ListItem */.HC, {
                title: true,
                disabled: true,
                children: [
                    (0,Text/* capitalizeFirst */.Ez)(type),
                    " providers"
                ]
            }),
            providers === null || providers === void 0 ? void 0 : providers.map(function(provider) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Item, {
                    title: getTitle(provider === null || provider === void 0 ? void 0 : provider.title),
                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* ListItem */.HC, {
                        chevron: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronRightIcon */.XCv, {}),
                        active: value === provider._id,
                        onClick: function() {
                            return onChange(provider._id);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: getTitle(provider === null || provider === void 0 ? void 0 : provider.title)
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            (provider === null || provider === void 0 ? void 0 : provider.label) ? provider === null || provider === void 0 ? void 0 : provider.label : provider === null || provider === void 0 ? void 0 : provider.count
                        ]
                    }, provider._id),
                    actions: [
                        {
                            label: "Open in editor",
                            action: function() {
                                return null;
                            },
                            disabled: true
                        },
                        {
                            label: "Load Data",
                            action: function() {
                                return onChange === null || onChange === void 0 ? void 0 : onChange.load(provider === null || provider === void 0 ? void 0 : provider._id);
                            }
                        },
                        {
                            label: "Set Preview",
                            action: function() {
                                return onChange === null || onChange === void 0 ? void 0 : onChange.preview(provider === null || provider === void 0 ? void 0 : provider._id);
                            },
                            disabled: (value === null || value === void 0 ? void 0 : value.preview) === (provider === null || provider === void 0 ? void 0 : provider._id)
                        },
                        {
                            label: "Unset",
                            action: function() {
                                return onChange === null || onChange === void 0 ? void 0 : onChange.unset();
                            },
                            disabled: (value === null || value === void 0 ? void 0 : value.preview) != (provider === null || provider === void 0 ? void 0 : provider._id)
                        }, 
                    ]
                });
            })
        ]
    });
};
var EntrySelector = function(param) {
    var provider = param.provider, controls = param.controls, onChange = param.onChange, value = param.value, loading = param.loading;
    if (!Array.isArray(provider === null || provider === void 0 ? void 0 : provider.entries) && !loading) return "SELECT GROUPS";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupSelector, {
        controls: controls,
        loading: loading && loader(provider === null || provider === void 0 ? void 0 : provider.count),
        provider: provider,
        actions: (0,_define_property/* default */.Z)({
            set: function(entry) {
                return onChange({
                    entry: entry === null || entry === void 0 ? void 0 : entry._id
                });
            }
        }, "set", function(entry) {
            return onChange({
                entry: entry === null || entry === void 0 ? void 0 : entry._id
            });
        }),
        value: {
            active: value === null || value === void 0 ? void 0 : value.entry,
            preview: value === null || value === void 0 ? void 0 : value.preview
        }
    });
};
var GroupSelector = function(param) {
    var provider = param.provider, actions = param.actions, value = param.value, loading = param.loading, controls = param.controls;
    var ref, ref1;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(List/* List */.aV, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* ListItem */.HC, {
                title: true,
                disabled: true,
                children: [
                    (0,Text/* excerptString */.dK)(provider === null || provider === void 0 ? void 0 : provider.title, 10, "..."),
                    " fields"
                ]
            }),
            (provider === null || provider === void 0 ? void 0 : provider.schema) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* ListItem */.HC, {
                active: (value === null || value === void 0 ? void 0 : value.active) === "schema",
                chevron: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronRightIcon */.XCv, {}),
                onClick: function() {
                    return actions.set({
                        _id: "schema"
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "Schema"
                    }),
                    " ",
                    provider === null || provider === void 0 ? void 0 : provider.schema.length,
                    " fields"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* ListItem */.HC, {
                active: (value === null || value === void 0 ? void 0 : value.active) === "provider",
                chevron: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronRightIcon */.XCv, {}),
                onClick: function() {
                    return actions.set({
                        _id: "provider"
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "Provider"
                    }),
                    " ",
                    (ref = Object.keys(provider)) === null || ref === void 0 ? void 0 : ref.length,
                    " fields"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsList, {
                options: provider === null || provider === void 0 ? void 0 : (ref1 = provider.entries) === null || ref1 === void 0 ? void 0 : ref1.map(function(e) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, e), {
                        title: (0,helpers/* getEntryLabel */.ax)(e, provider === null || provider === void 0 ? void 0 : provider.schema),
                        label: (0,helpers/* getEntryDate */.V0)(e)
                    });
                }),
                actions: actions,
                provider: provider,
                controls: controls,
                value: value,
                loading: loading
            })
        ]
    });
};
var skipFields = [
    "__typename",
    "entries",
    "schema"
];
var skipEntrySchemaFields = [
    "__typename",
    "singular",
    "count",
    "entries",
    "catchRoutes",
    "frontEnd",
    "dynamicPage",
    "description",
    "schema"
];
var FieldSelector = function(param) {
    var provider = param.provider, schema = param.schema, entry = param.entry, value = param.value, onChange = param.onChange;
    var ref;
    var devMode = (0,es/* useSelector */.v9)(options_reducer/* getDevModePrefSelector */.Lj);
    var getFieldPath = function(field, index) {
        var ref;
        if (index === 0) return [
            field
        ];
        var copy = (0,_to_consumable_array/* default */.Z)(value === null || value === void 0 ? void 0 : value.fieldPath);
        var pathLength = value === null || value === void 0 ? void 0 : (ref = value.fieldPath) === null || ref === void 0 ? void 0 : ref.length;
        if (pathLength > index) {
            copy.length = index;
            return (0,_to_consumable_array/* default */.Z)(copy).concat([
                field
            ]);
        }
        return (0,_to_consumable_array/* default */.Z)(value === null || value === void 0 ? void 0 : value.fieldPath).concat([
            field
        ]);
    };
    var setField = function(field, index) {
        var ref;
        var fieldName = field === null || field === void 0 ? void 0 : field.name;
        var fieldPath = getFieldPath(field, index);
        onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            field: ((ref = value.modus) === null || ref === void 0 ? void 0 : ref.field) != "picker" ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value.field), {
                field: fieldName
            }) : fieldName,
            fieldPath: fieldPath
        }));
    };
    var getFieldPathName = function(index) {
        var ref, ref1;
        return value === null || value === void 0 ? void 0 : (ref = value.fieldPath) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1.name;
    };
    var isActive = function(field, index) {
        var ref;
        return [
            field === null || field === void 0 ? void 0 : field.name,
            field === null || field === void 0 ? void 0 : (ref = field.value) === null || ref === void 0 ? void 0 : ref.name
        ].includes(getFieldPathName(index)) && getFieldPathName(index);
    };
    var isNotEntry = (value === null || value === void 0 ? void 0 : value.entry) === "schema" || (value === null || value === void 0 ? void 0 : value.entry) === "provider";
    var label = isNotEntry ? getTitle("".concat(value.entry, " fields")) : "Entry fields";
    var getFieldValue = function(field) {
        var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : entry;
        if (isNotEntry && (field === null || field === void 0 ? void 0 : field.value)) return field === null || field === void 0 ? void 0 : field.value;
        return (0,Obj/* get */.U2)(data, (0,Text/* isString */.HD)(field) ? field : field === null || field === void 0 ? void 0 : field.name, null);
    };
    var createOptions = function(schema) {
        var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : entry, type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        var ref, ref1, ref2;
        return schema ? (ref1 = (ref = schema === null || schema === void 0 ? void 0 : schema.filter(function(field) {
            return (field === null || field === void 0 ? void 0 : field.type) != "label";
        })) === null || ref === void 0 ? void 0 : ref.filter(function(f) {
            return !skipFields.includes(f.name);
        })) === null || ref1 === void 0 ? void 0 : ref1.map(function(field) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                title: (field === null || field === void 0 ? void 0 : field.label) ? field.label : removePath(field === null || field === void 0 ? void 0 : field.name),
                label: renderFieldData(field, getFieldValue(field, data))
            });
        }) : (helpers/* mappableSubFields */.c8 === null || helpers/* mappableSubFields */.c8 === void 0 ? void 0 : helpers/* mappableSubFields.includes */.c8.includes(type)) ? (ref2 = (0,SelectField/* fieldSchemas */.qo)((0,_object_spread/* default */.Z)({}, path, data))) === null || ref2 === void 0 ? void 0 : ref2[type] : null;
    };
    var options = createOptions(schema);
    var returnValue = getFieldValue(combineOptionPath(value === null || value === void 0 ? void 0 : value.fieldPath), isNotEntry ? provider : entry);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* List */.aV, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsList, {
                        label: label,
                        options: options,
                        value: {
                            active: isActive
                        },
                        actions: {
                            set: function(field, index) {
                                return setField(field, 0);
                            }
                        },
                        chevronValidation: true
                    }),
                    !isNotEntry && /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItem */.HC, {
                            title: true,
                            disabled: true,
                            chevron: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronDownIcon */.v4q, {}),
                            children: "Direct schema"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsList, {
                            chevronValidation: true,
                            label: null,
                            value: {
                                active: isActive
                            },
                            options: createOptions(createSchema(provider).filter(function(f) {
                                return !skipEntrySchemaFields.includes(f.name);
                            })),
                            actions: {
                                set: function(field) {
                                    return setField(field, 0);
                                }
                            }
                        })
                    })
                ]
            }),
            (value === null || value === void 0 ? void 0 : value.fieldPath) && (value === null || value === void 0 ? void 0 : (ref = value.fieldPath) === null || ref === void 0 ? void 0 : ref.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionPaths, {
                getFieldValue: getFieldValue,
                createOptions: createOptions,
                fieldPath: value.fieldPath,
                setField: setField,
                isActive: isActive
            })
        ]
    });
};
var combineOptionPath = function(path) {
    var till = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref;
    return (0,Text/* combineString */.M7)((ref = till ? (0,Arr/* remove */.Od)(path, till) : path) === null || ref === void 0 ? void 0 : ref.map(function(f) {
        return (f === null || f === void 0 ? void 0 : f.name) || (f === null || f === void 0 ? void 0 : f.value) || f;
    }), ".");
};
var OptionPaths = function(param) {
    var getFieldValue = param.getFieldValue, createOptions = param.createOptions, fieldPath = param.fieldPath, isActive = param.isActive, setField = param.setField;
    return fieldPath.map(function(path, index) {
        return helpers/* mappableSubFields.includes */.c8.includes(path === null || path === void 0 ? void 0 : path.type) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionPath, {
            getFieldValue: getFieldValue,
            entry: getFieldValue(path === null || path === void 0 ? void 0 : path.name),
            createOptions: createOptions,
            isActive: isActive,
            path: path,
            index: index,
            setField: setField,
            combinedPath: combineOptionPath(fieldPath, index + 2)
        }) : null;
    });
};
var OptionPath = function(param) {
    var path = param.path, index = param.index, entry = param.entry, createOptions = param.createOptions, getFieldValue = param.getFieldValue, setField = param.setField, isActive = param.isActive, combinedPath = param.combinedPath;
    var ref, ref1;
    var getLast = function() {
        var splitted = combinedPath.split(".");
        var last = splitted === null || splitted === void 0 ? void 0 : splitted[(splitted === null || splitted === void 0 ? void 0 : splitted.length) - 1];
        return {
            splitted: splitted,
            last: last
        };
    };
    var removeLast = function() {
        var ref = getLast(), splitted = ref.splitted, last = ref.last;
        return (0,Num/* isNumber */.hj)(parseFloat(last)) ? combineOptionPath(splitted, (splitted === null || splitted === void 0 ? void 0 : splitted.length) - 1) : combinedPath;
    };
    var newGet = null;
    if ((path === null || path === void 0 ? void 0 : path.type) === "user") {
        newGet = function(other) {
            var id = getFieldValue(other);
            return {
                id: id,
                author: {
                    firstName: "hi",
                    lastName: "zijdel"
                }
            };
        };
    }
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetUser */.pg)({
        _id: (path === null || path === void 0 ? void 0 : path.type) === "user" && entry
    }), 1), user = ref2[0];
    if (user) entry = (0,_object_spread/* default */.Z)({}, user);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (path.type === "repeater" || (path === null || path === void 0 ? void 0 : path.type) === "relationEnd") && /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.aV, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsList, {
                    chevronValidation: true,
                    label: getTitle((path === null || path === void 0 ? void 0 : path.title) ? path.title : path === null || path === void 0 ? void 0 : path.name),
                    value: {
                        active: (ref = getLast()) === null || ref === void 0 ? void 0 : ref.last
                    },
                    options: (ref1 = getFieldValue(removeLast())) === null || ref1 === void 0 ? void 0 : ref1.map(function(e, itemIndex) {
                        var ref, ref1;
                        return {
                            title: e === null || e === void 0 ? void 0 : e[path === null || path === void 0 ? void 0 : (ref = path.schema) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name],
                            _id: "".concat(itemIndex),
                            name: "".concat(itemIndex),
                            type: "index"
                        };
                    }),
                    actions: {
                        set: function(field) {
                            return setField(field, index + 1);
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.aV, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsList, {
                    label: "".concat(getTitle((path === null || path === void 0 ? void 0 : path.singular) ? path.singular : (path === null || path === void 0 ? void 0 : path.title) ? path.title : path === null || path === void 0 ? void 0 : path.name), " fields"),
                    // path={value.fieldPath}
                    // getOptions={getOptions}
                    // isActiveField={isActiveField}
                    // canSelectField={canSelectField}
                    // setField={setField}
                    options: createOptions(path === null || path === void 0 ? void 0 : path.schema, entry ? entry : getFieldValue(combinedPath), path === null || path === void 0 ? void 0 : path.type, path),
                    actions: {
                        set: function(field) {
                            return setField(field, index + ((path === null || path === void 0 ? void 0 : path.type) === "repeater" ? 2 : 1));
                        }
                    },
                    value: {
                        active: function(field) {
                            return isActive(field, index + ((path === null || path === void 0 ? void 0 : path.type) === "repeater" ? 2 : 1));
                        }
                    },
                    chevronValidation: true
                })
            })
        ]
    });
};
var OptionLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8c42e59f-0"
})(Provider_templateObject());
//Render the options
var OptionsList = function(param) {
    var options = param.options, value = param.value, controls = param.controls, actions = param.actions, provider = param.provider, loading = param.loading, _label = param.label, label = _label === void 0 ? "Entries" : _label, _chevronValidation = param.chevronValidation, chevronValidation = _chevronValidation === void 0 ? false : _chevronValidation;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItem */.HC, {
                disabled: true,
                title: true,
                chevron: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
                    m: 0,
                    overflow: true,
                    p: 0,
                    width: "150px",
                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* MagnifyingGlassIcon */._Ve, {}),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields["default"], {
                        ghost: true,
                        label: "Search"
                    })
                }),
                children: label
            }),
            loading ? loading : Array.isArray(options) ? options === null || options === void 0 ? void 0 : options.map(function(entry, index) {
                var ref, ref1;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Item, {
                    title: getTitle(provider === null || provider === void 0 ? void 0 : provider.singular),
                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* ListItem */.HC, {
                        chevron: chevronValidation && helpers/* mappableSubFields.includes */.c8.includes(entry === null || entry === void 0 ? void 0 : entry.type) || !chevronValidation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronRightIcon */.XCv, {}) : null,
                        active: (0,Funct/* isFunc */.W)(value === null || value === void 0 ? void 0 : value.active) && (value === null || value === void 0 ? void 0 : value.active(entry, 0)) || (entry === null || entry === void 0 ? void 0 : entry._id) === (value === null || value === void 0 ? void 0 : value.active),
                        onClick: function() {
                            return (entry === null || entry === void 0 ? void 0 : entry.isEmpty) ? null : actions === null || actions === void 0 ? void 0 : actions.set(entry);
                        },
                        disabled: entry === null || entry === void 0 ? void 0 : entry.isEmpty,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tooltip/* default */.Z, {
                                placement: "left",
                                m: 2,
                                wrap: true,
                                title: (entry === null || entry === void 0 ? void 0 : (ref = entry.title) === null || ref === void 0 ? void 0 : ref.length) >= 17 ? entry.title : "",
                                force: (entry === null || entry === void 0 ? void 0 : (ref1 = entry.title) === null || ref1 === void 0 ? void 0 : ref1.length) >= 17,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: getTitle(entry === null || entry === void 0 ? void 0 : entry.title)
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionLabel, {
                                children: entry === null || entry === void 0 ? void 0 : entry.label
                            })
                        ]
                    }, entry === null || entry === void 0 ? void 0 : entry._id),
                    actions: [
                        {
                            label: "Edit entry",
                            action: function() {
                                return null;
                            },
                            disabled: true
                        },
                        {
                            label: "Set Preview",
                            action: function() {
                                return actions === null || actions === void 0 ? void 0 : actions.preview(provider === null || provider === void 0 ? void 0 : provider._id);
                            },
                            disabled: (value === null || value === void 0 ? void 0 : value.preview) === (provider === null || provider === void 0 ? void 0 : provider._id)
                        },
                        {
                            label: "Unset",
                            action: function() {
                                return actions === null || actions === void 0 ? void 0 : actions.unset();
                            },
                            disabled: (value === null || value === void 0 ? void 0 : value.preview) != (provider === null || provider === void 0 ? void 0 : provider._id)
                        }, 
                    ]
                });
            }) : null,
            (controls === null || controls === void 0 ? void 0 : controls.next()) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inputs/* InlineGroup */.a_, {
                justify: "space-between",
                align: "center",
                pt: 0,
                style: {
                    fontSize: 10
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons["default"], {
                        ghost: true,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowLeftIcon */.Y4O, {}),
                        m: 0,
                        onClick: controls === null || controls === void 0 ? void 0 : controls.prev()
                    }),
                    controls === null || controls === void 0 ? void 0 : controls.skip,
                    " - ",
                    (controls === null || controls === void 0 ? void 0 : controls.skip) + (controls === null || controls === void 0 ? void 0 : controls.limit),
                    " ",
                    "/",
                    " ",
                    provider === null || provider === void 0 ? void 0 : provider.count,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons["default"], {
                        ghost: true,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ArrowRightIcon */.LZ3, {}),
                        m: 0,
                        onClick: controls === null || controls === void 0 ? void 0 : controls.next()
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/mosanic/items/Spinner.js
var Spinner = __webpack_require__(36174);
// EXTERNAL MODULE: ./src/mosanic/fields/Code/FullEditor.js
var FullEditor = __webpack_require__(22549);
// EXTERNAL MODULE: ./src/mosanic/core/Collections/AddCollection.js + 1 modules
var AddCollection = __webpack_require__(44032);
;// CONCATENATED MODULE: ./src/mosanic/fields/Source/SourceColumns.js










var SourceColumns_ReactJson = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8047).then(__webpack_require__.t.bind(__webpack_require__, 48047, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48047)
            ];
        }
    },
    ssr: false
});
var SwitchColumns = function(_param) {
    var loading = _param.loading, column = _param.column, _children = _param.children, children = _children === void 0 ? null : _children, value = _param.value, props = (0,_object_without_properties/* default */.Z)(_param, [
        "loading",
        "column",
        "children",
        "value"
    ]);
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {});
    switch(column){
        case "editor":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceEditor, (0,_object_spread/* default */.Z)({}, props));
        case "code":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectField/* CodeFieldValue */.x9, (0,_object_spread/* default */.Z)({}, props === null || props === void 0 ? void 0 : props.codeFieldValue));
        case "add":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCollection/* AddCollection */.b, {
                ghost: true
            });
        case "data":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceColumns_ReactJson, {
                name: "Data",
                collapsed: true,
                src: props === null || props === void 0 ? void 0 : props.dev
            });
        case "get":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GetPreview, {
                value: value
            });
        default:
            return children;
    }
};
var GetPreview = function(param) {
    var value = param.value;
    var source = value.source, clone = value.clone;
    var ref = (0,_sliced_to_array/* default */.Z)((0,DataReceiver/* useDataReceiver */.H)({
        source: source,
        entry: value,
        clone: clone
    }), 3), content = ref[0], schema = ref[1], baseRoute = ref[2];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceColumns_ReactJson, {
        name: "Data receiver",
        collapsed: true,
        src: {
            params: value,
            content: content,
            schema: schema,
            baseRoute: baseRoute
        }
    });
};
var SourceEditor = function(param) {
    var fieldPath = param.fieldPath, ctx = param.ctx, onChange = param.onChange, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullEditor/* FullCodeEditor */.X, {
        noBorder: true,
        onChange: onChange,
        // value={state?.fieldPath ? `$ctx.entry.${combineString(state?.fieldPath?.map(f => f?.name), '.')}` : null}
        value: value,
        ctx: ctx,
        size: {
            width: "100%",
            height: "100%",
            minHeight: "300px"
        },
        height: "500px",
        maxHeight: "100%",
        showPreview: true
    });
};

// EXTERNAL MODULE: ./src/mosanic/core/Collections/Parts.js
var Parts = __webpack_require__(16990);
;// CONCATENATED MODULE: ./src/mosanic/fields/Source/SourceParts.js

function SourceParts_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    /* display: flex; */\n    /* flex-wrap: nowrap; */\n    margin-top: 4px;\n    white-space: nowrap;\n    max-width: 275px;\n    height: 35px;\n    /* overflow: scroll; */\n"
    ]);
    SourceParts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    \n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var Slug = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e1eea8b6-0"
})(SourceParts_templateObject());
var SourceParts_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e1eea8b6-1"
})(_templateObject1());
var SourceHeader = function(param) {
    var title = param.title, helpText = param.helpText, dialog = param.dialog, children = param.children;
    return /*#__PURE__*/ _jsxs(SourceParts_Wrapper, {
        children: [
            /*#__PURE__*/ _jsxs(AdvancedLabel, {
                as: "h4",
                style: {
                    marginTop: dialog.expand ? "15px" : 0
                },
                span: true,
                helpText: helpText,
                children: [
                    title,
                    /*#__PURE__*/ _jsx(Button, {
                        ghost: true,
                        icon: /*#__PURE__*/ _jsx(SizeIcon, {}),
                        mt: "-2px",
                        style: {
                            display: "inline-block"
                        },
                        onClick: dialog.handleExpand
                    })
                ]
            }),
            children
        ]
    });
};
var SourceFooter = function(param) {
    var collection = param.collection, state = param.state, activeEntry = param.activeEntry, save = param.save, canSave = param.canSave, type = param.type;
    var fieldPath = state === null || state === void 0 ? void 0 : state.fieldPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(items_AdvancedLabel/* AdvancedLabel */.qv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Slug, {
                    children: [
                        collection === null || collection === void 0 ? void 0 : collection.title,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronRightIcon */.XCv, {}),
                        (0,Text/* revertDevCases */.Uw)((0,helpers/* getEntryLabel */.ax)((0,useDataQuery/* convertEntry */.ec)(activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry.entry), collection === null || collection === void 0 ? void 0 : collection.schema)),
                        fieldPath && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronRightIcon */.XCv, {}),
                        fieldPath && (fieldPath === null || fieldPath === void 0 ? void 0 : fieldPath.map(function(f, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    (0,Text/* revertDevCases */.Uw)(f === null || f === void 0 ? void 0 : f.name),
                                    (fieldPath === null || fieldPath === void 0 ? void 0 : fieldPath.length) - 1 != index && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronRightIcon */.XCv, {})
                                ]
                            }, f === null || f === void 0 ? void 0 : f.name);
                        }))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons.Buttons, {
                size: "small",
                right: true,
                children: [
                    (state === null || state === void 0 ? void 0 : state.collection) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                        title: collection === null || collection === void 0 ? void 0 : collection.title,
                        size: "xl",
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons["default"], {
                            label: "View ".concat(type),
                            ghost: true,
                            target: "_blank"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Parts/* CollectionEditing */.lk, {
                            collection: collection
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons["default"], {
                        disabled: !canSave,
                        label: "Save",
                        theme: "primary",
                        onClick: save
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/mosanic/fields/Source/index.js





function Source_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: flex;\n    flex-wrap: nowrap;\n\n    ul {\n        min-width: 150px;\n        width: 150px;\n\n        border-right: ",
        " 1px solid;\n        margin: 0;\n        padding: 0 5px;\n        overflow-x: hidden;\n    }\n"
    ]);
    Source_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





















var getSourceType = function(state, type) {
    return type != "collection" ? type : (state === null || state === void 0 ? void 0 : state.modus) === "page" ? "Page collection" : "Collection";
};
var Columns = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-76886c51-0"
})(Source_templateObject(), colors/* default.util.gray.light */.ZP.util.gray.light);
var SourceSelector = function(param) {
    var _handler = param.handler, handler = _handler === void 0 ? null : _handler, _onChange = param.onChange, onChange = _onChange === void 0 ? null : _onChange, _inline = param.inline, inline = _inline === void 0 ? false : _inline, _value = param.value, value = _value === void 0 ? null : _value, _sourceSelector = param.sourceSelector, sourceSelector = _sourceSelector === void 0 ? false : _sourceSelector, _type = param.type, type = _type === void 0 ? "collection" : _type, _activate = param.activate, activate = _activate === void 0 ? null : _activate, _isEnd = param.isEnd, isEnd = _isEnd === void 0 ? false : _isEnd, _height = param.height, height = _height === void 0 ? null : _height, _width = param.width, width = _width === void 0 ? null : _width, collectionId = param.collectionId;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    if (handler && !onChange) onChange = handler;
    //If id is received, set as only option.
    if (collectionId && (state === null || state === void 0 ? void 0 : state.collection) != collectionId) {
        onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            collection: collectionId
        }));
    }
    //Set base entry tab
    if (!(value === null || value === void 0 ? void 0 : (ref = value.tab) === null || ref === void 0 ? void 0 : ref.entry) && onChange) {
        onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            tab: {
                entry: "entry",
                field: "field"
            }
        }));
    }
    if (!(value === null || value === void 0 ? void 0 : value.fieldPath) && onChange) {
        onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            fieldPath: []
        }));
    }
    var tab = (value || {
        tab: null
    }).tab;
    var state = value;
    var itemType = (0,es/* useSelector */.v9)(inspect_reducer/* selectInspectItemType */.mL);
    var clone = (0,es/* useSelector */.v9)(inspect_reducer/* selectInspectItemClone */.oW);
    var _id = (0,es/* useSelector */.v9)(inspect_reducer/* selectInspectItemId */.SM);
    var ref13 = (0,_sliced_to_array/* default */.Z)(useSources({
        value: value
    }), 6), providers = ref13[0], provider = ref13[1], entry = ref13[2], schema = ref13[3], loading = ref13[4], controls = ref13[5];
    var context = (0,es/* useSelector */.v9)(inspect_reducer/* selectInspectContext */.P);
    var dataProvider = context === null || context === void 0 ? void 0 : (ref1 = context.dataProvider) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[state === null || state === void 0 ? void 0 : state.provider]) === null || ref2 === void 0 ? void 0 : ref2.entry;
    //Use main retriever for schemas
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useCollections/* useCollections */.bX)({
        filter: {
            siteId: (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL),
            _id: collectionId || undefined
        },
        indexOnly: true
    }), 3), collections = ref14[0], loadings = ref14[1], error = ref14[2];
    //Use single collection retriever
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useCollection/* useCollection */.K)({
        _id: (state === null || state === void 0 ? void 0 : state.retrieveEntries) || collectionId
    }, true), 2), getColl = ref15[0], ref16 = (0,_sliced_to_array/* default */.Z)(ref15[1], 3), retrieved = ref16[0], loadingRet = ref16[1], errorRet = ref16[2];
    //Get entry by selected value's
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,helpers/* getSourceEntry */.Kw)({
        collections: collections === null || collections === void 0 ? void 0 : collections.map(function(c) {
            return (c === null || c === void 0 ? void 0 : c._id) === (retrieved === null || retrieved === void 0 ? void 0 : retrieved._id) ? retrieved : c;
        }),
        context: context,
        value: value
    }), 5), collection = ref17[0], schema_ = ref17[1], baseRoute = ref17[2], item = ref17[3], fieldPath = ref17[4];
    var path = (0,helpers/* isProviderSource */.CB)(state) && (fieldPath === null || fieldPath === void 0 ? void 0 : fieldPath.length) >= 1 ? (0,_to_consumable_array/* default */.Z)(fieldPath).concat([
        state === null || state === void 0 ? void 0 : state.fieldPath
    ]) : state === null || state === void 0 ? void 0 : state.fieldPath;
    var canSave = true;
    var activeStateFieldPath = state === null || state === void 0 ? void 0 : state.fieldPath;
    var newExtendedFieldPath = (0,helpers/* getExtendedFieldPath */.$w)(activeStateFieldPath, dataProvider === null || dataProvider === void 0 ? void 0 : dataProvider.fieldPath);
    var formatFieldPath = function() {
        var ref;
        return value === null || value === void 0 ? void 0 : (ref = value.fieldPath) === null || ref === void 0 ? void 0 : ref.map(function(f) {
            return (f === null || f === void 0 ? void 0 : f.type) === "relation" ? {
                type: f === null || f === void 0 ? void 0 : f.type,
                name: f === null || f === void 0 ? void 0 : f.name,
                relation: f === null || f === void 0 ? void 0 : f.relationEnd,
                render: f === null || f === void 0 ? void 0 : f.relationRender
            } : {
                type: f === null || f === void 0 ? void 0 : f.type,
                name: f === null || f === void 0 ? void 0 : f.name
            };
        });
    };
    var getSaveValue = function() {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            collection: inline ? (value === null || value === void 0 ? void 0 : value.repeaterSource) ? null : value === null || value === void 0 ? void 0 : value.collection : value === null || value === void 0 ? void 0 : value.collection,
            fieldPath: formatFieldPath(),
            // extend: 'entry',
            // newPath: undefined,
            schema: undefined
        });
    };
    var save = function() {
        onChange(getSaveValue());
    // console.log(getSaveValue())
    // console.log(newExtendedFieldPath)
    // console.log(activeStateFieldPath)
    };
    var title = collection ? type === "collection" ? (0,Text/* excerptString */.dK)((collection === null || collection === void 0 ? void 0 : collection.title) + " ", 9, "...") : collection === null || collection === void 0 ? void 0 : collection.title : (0,Text/* capitalizeFirst */.Ez)("".concat(type, " source"));
    //Expand dialog
    var ref18 = (0,react.useState)(false), expand = ref18[0], setExpand = ref18[1];
    var handleExpand = function() {
        return setExpand(!expand);
    };
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,DataReceiver/* useDataReceiver */.H)({
        source: value === null || value === void 0 ? void 0 : value.source,
        entry: value,
        clone: clone
    }), 1), content = ref19[0];
    var headerData = {
        title: title,
        dialog: {
            expand: expand,
            handleExpand: handleExpand
        },
        helpText: (0,helpers/* isProvider */.BG)(itemType) ? "The latest selected element will be provided to the children of this data provider" : (0,helpers/* isDataLink */.KE)(itemType) ? "Select a data provider source and a available field to render." : "",
        value: value,
        handler: onChange,
        itemType: itemType,
        context: context
    };
    var activeEntry = {
        entry: (state === null || state === void 0 ? void 0 : state.source) === "page" ? context === null || context === void 0 ? void 0 : (ref3 = context.pageProvider) === null || ref3 === void 0 ? void 0 : ref3.entry : (state === null || state === void 0 ? void 0 : state.provider) && Array.isArray((ref4 = context.dataProvider) === null || ref4 === void 0 ? void 0 : (ref6 = ref4[state.provider]) === null || ref6 === void 0 ? void 0 : ref6[state === null || state === void 0 ? void 0 : (ref5 = state.providerFieldPath) === null || ref5 === void 0 ? void 0 : ref5[0]]) ? (ref7 = context.dataProvider) === null || ref7 === void 0 ? void 0 : (ref9 = ref7[state.provider]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[state === null || state === void 0 ? void 0 : (ref8 = state.providerFieldPath) === null || ref8 === void 0 ? void 0 : ref8[0]]) === null || ref10 === void 0 ? void 0 : ref10.find(function(e) {
            return (e === null || e === void 0 ? void 0 : e.id) === (state === null || state === void 0 ? void 0 : state.entry);
        }) : (0,helpers/* getEntry */.e9)(collection, state === null || state === void 0 ? void 0 : state.entry, state === null || state === void 0 ? void 0 : state.clone),
        collection: collection
    };
    var displayValue = !(value === null || value === void 0 ? void 0 : value.fieldPath) ? title : "".concat(title ? title : "", " › ").concat((0,Text/* combineString */.M7)(value === null || value === void 0 ? void 0 : (ref11 = value.fieldPath) === null || ref11 === void 0 ? void 0 : ref11.map(function(f) {
        return f === null || f === void 0 ? void 0 : f.name;
    }), " › "));
    var isList = true;
    (0,react.useEffect)(function() {
        var ref;
        if ((value === null || value === void 0 ? void 0 : value.column) === "editor") (value === null || value === void 0 ? void 0 : (ref = value.fieldPath) === null || ref === void 0 ? void 0 : ref.length) >= 1 ? onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            editor: "$ctx.entry.".concat((0,Text/* combineString */.M7)(value === null || value === void 0 ? void 0 : value.fieldPath.map(function(f) {
                return f.name;
            }), "."))
        })) : onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            editor: "$ctx.collections"
        }));
    }, [
        value === null || value === void 0 ? void 0 : (ref12 = value.fieldPath) === null || ref12 === void 0 ? void 0 : ref12.length,
        value === null || value === void 0 ? void 0 : value.column
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper/* default */.Z, {
        noPadding: true,
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(Source_Header, (0,_object_spread/* default */.Z)({}, headerData)),
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceFooter, {
            collection: collection,
            state: state,
            activeEntry: activeEntry,
            canSave: canSave,
            save: save,
            type: type
        }),
        trigger: isEnd ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isEnd,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* Link1Icon */.DrZ, {})
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields["default"], {
            value: displayValue,
            disabled: true
        }),
        // width={450} 
        // height={300}
        width: width || 950,
        height: height || 600,
        scroll: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalWrapper/* ConditionalWrapper */.M, {
            when: expand,
            wrapper: function(children) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                    title: "Dynamic data",
                    state: expand,
                    close: handleExpand,
                    ghost: true,
                    children: children
                });
            },
            children: [
                (0,Text/* isString */.HD)(item) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorAlert/* ErrorAlert */.h, {
                    errorMessage: item
                }),
                error,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchColumns, {
                    loading: loading[0],
                    column: (value === null || value === void 0 ? void 0 : value.dev) || (value === null || value === void 0 ? void 0 : value.column),
                    value: value,
                    editor: {
                        onChange: function(code) {
                            return onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                editor: code
                            }));
                        },
                        value: value === null || value === void 0 ? void 0 : value.editor,
                        ctx: {
                            entry: (activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry.entry) ? activeEntry.entry : activeEntry,
                            collections: collections
                        }
                    },
                    dev: {
                        state: value,
                        context: context,
                        collection: collection,
                        collections: collections,
                        providers: providers
                    },
                    codeFieldValue: {
                        activeEntry: (activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry.entry) ? activeEntry.entry : activeEntry,
                        setState: onChange,
                        state: value
                    },
                    ctx: {
                        entry: (activeEntry === null || activeEntry === void 0 ? void 0 : activeEntry.entry) ? activeEntry.entry : activeEntry,
                        collections: collections,
                        output: content
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Columns, {
                        children: [
                            Array.isArray(providers) && (providers === null || providers === void 0 ? void 0 : providers.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderSelector, {
                                type: state === null || state === void 0 ? void 0 : state.source,
                                providers: providers,
                                value: value === null || value === void 0 ? void 0 : value.collection,
                                onChange: function(collection) {
                                    return onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                        path: [
                                            collection
                                        ],
                                        collection: collection,
                                        fieldPath: undefined,
                                        entry: undefined,
                                        tab: "entry"
                                    }));
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EntrySelector, {
                                controls: controls,
                                loading: loading === null || loading === void 0 ? void 0 : loading[1],
                                provider: provider,
                                value: value,
                                onChange: function(newState) {
                                    return onChange((0,_object_spread/* default */.Z)({}, value, newState));
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldSelector, {
                                onChange: onChange,
                                provider: provider,
                                schema: schema,
                                entry: entry,
                                value: value
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {})
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(util/* ClearBoth */.Z, {})
            ]
        })
    });
};
/* harmony default export */ var Source = (SourceSelector);


/***/ }),

/***/ 9441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ fields_Switch; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
;// CONCATENATED MODULE: ./src/mosanic/fields/Switch/Switch.style.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " width: 42px; height: 26px; "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " margin-top: 5px; width: 30px; height: 16px; "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " margin-top: 0px; width: 24px; height: 12px; "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " width: 18px; height: 18px; "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " width: 9px; height: 9px; "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " width: 6px; height: 6px; "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    font-size: 12px;\n    display: inline-block;\n    margin-top: -5px;\n    padding: 0 0 5px 10px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  max-width: 300px;\n  margin-left: 30px;\n  display: block;\n  opacity: 0.5;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: 3px;\n    left: 0;\n    ",
        '\n\n    border-radius: 15px;\n    background: #bebebe;\n    cursor: pointer;\n\n    &:hover {\n        &::after {\n            transform: scale(1.1);\n        }\n    }\n\n    &::after {\n        content: "";\n        display: block;\n        border-radius: 50%;\n        ',
        "\n        margin: 3px;\n        background: #ffffff;\n        box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);\n        transition: 0.2s;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 0;\n  z-index: 1;\n  border-radius: 15px;\n  ",
        "\n\n  &:checked + ",
        ' {\n    background: #4fbe79;\n    &::after {\n      content: "";\n      display: block;\n      border-radius: 50%;\n      ',
        "\n      margin-left: 16px;\n      transition: 0.2s;\n    }\n  }\n  background: red!important;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    ",
        " {\n        ",
        "\n        &::after { ",
        " }\n    }\n    ",
        " {\n        ",
        "\n        &:checked + ",
        ":after { \n            ",
        "\n            margin-left: 21px;\n        }\n    }\n    ",
        " { font-size: 16px; vertical-align: middle; }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    ",
        " {\n        ",
        "\n        &::after { ",
        " }\n    }\n    ",
        " {\n        ",
        "\n        &:checked + ",
        ":after { \n            ",
        "\n            margin-left: 15px;\n        }\n    }\n    ",
        " { font-size: 12px; }\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    ",
        " {\n        background: #eee;\n        transition: all ease-in-out 0.2s;\n        &:hover {\n            opacity: 0.8;\n        }\n    }\n  \n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}

var Large = (0,styled_components_browser_esm/* css */.iv)(_templateObject());
var Small = (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
var Xs = (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
var ControlCircleLarge = (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
var ControlCircleSmall = (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
var ControlCircleXs = (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
var DisplayLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b3377479-0"
})(_templateObject6());
var SubLabel = (0,styled_components_browser_esm/* default */.ZP)(DisplayLabel).withConfig({
    componentId: "sc-b3377479-1"
})(_templateObject7());
var CheckBoxLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-b3377479-2"
})(_templateObject8(), Small, ControlCircleSmall);
var CheckBox = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs({
    type: "checkbox"
}).withConfig({
    componentId: "sc-b3377479-3"
})(_templateObject9(), Small, CheckBoxLabel, ControlCircleSmall);
var CheckBoxWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b3377479-4"
})(_templateObject13(), function(props) {
    return props.size === "large" && (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), CheckBoxLabel, Large, ControlCircleLarge, CheckBox, Large, CheckBoxLabel, ControlCircleLarge, DisplayLabel);
}, function(props) {
    return props.size === "xs" && (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), CheckBoxLabel, Xs, ControlCircleXs, CheckBox, Xs, CheckBoxLabel, ControlCircleXs, DisplayLabel);
}, function(props) {
    return props.disabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), CheckBoxLabel);
});
var SwitchStyles = {
    CheckBoxWrapper: CheckBoxWrapper,
    CheckBoxLabel: CheckBoxLabel,
    CheckBox: CheckBox,
    DisplayLabel: DisplayLabel,
    SubLabel: SubLabel
};
/* harmony default export */ var Switch_style = (SwitchStyles);

;// CONCATENATED MODULE: ./src/mosanic/fields/Switch/Switch.js





var Switch = function(_param) {
    var label = _param.label, _checked = _param.checked, checked = _checked === void 0 ? null : _checked, _value = _param.value, value = _value === void 0 ? null : _value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _size = _param.size, size = _size === void 0 ? "small" : _size, _wrap = _param.wrap, wrap = _wrap === void 0 ? false : _wrap, _name = _param.name, name = _name === void 0 ? null : _name, _desc = _param.desc, desc = _desc === void 0 ? null : _desc, other = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "checked",
        "value",
        "onChange",
        "disabled",
        "size",
        "wrap",
        "name",
        "desc"
    ]);
    var ref = (0,react.useState)(false), localState = ref[0], setLocal = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* WrapInput */.Vw, {
        wrap: wrap ? wrap : false,
        fullWidth: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Switch_style.CheckBoxWrapper, {
            size: size,
            disabled: disabled,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch_style.CheckBox, {
                    id: label ? label : name,
                    type: "checkbox",
                    checked: checked ? checked : localState,
                    disabled: disabled,
                    onChange: Boolean(disabled) ? null : onChange ? onChange : setLocal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch_style.CheckBoxLabel, {
                    htmlFor: label ? label : name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch_style.DisplayLabel, {
                    children: label
                }),
                desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch_style.SubLabel, {
                    children: desc
                })
            ]
        })
    });
};
/* harmony default export */ var Switch_Switch = (Switch); //  <s.CheckBoxWrapper size={size} disabled={disabled}>
 //             <s.CheckBox
 //                 id={label} 
 //                 type="checkbox" 
 //                 checked={checked ? checked : localState} 
 //                 disabled={disabled}
 // onChange={Boolean(disabled) ? null : ( 
 //     onChange ? 
 //         onChange : 
 //         setLocal
 // )}
 //             />
 //             <s.CheckBoxLabel htmlFor={label} />
 //             <s.DisplayLabel>
 //                 {label}
 //             </s.DisplayLabel>
 //         </s.CheckBoxWrapper>

;// CONCATENATED MODULE: ./src/mosanic/fields/Switch/index.js

/* harmony default export */ var fields_Switch = (Switch_Switch);


/***/ }),

/***/ 71645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ fields_TextArea; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/items/Inputs.js + 1 modules
var Inputs = __webpack_require__(99057);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
;// CONCATENATED MODULE: ../../node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.js


var index =  react.useLayoutEffect ;

/* harmony default export */ var use_isomorphic_layout_effect_browser_esm = (index);

;// CONCATENATED MODULE: ../../node_modules/use-latest/dist/use-latest.esm.js



var useLatest = function useLatest(value) {
  var ref = react.useRef(value);
  use_isomorphic_layout_effect_browser_esm(function () {
    ref.current = value;
  });
  return ref;
};



;// CONCATENATED MODULE: ../../node_modules/use-composed-ref/dist/use-composed-ref.esm.js


var updateRef = function updateRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
    return;
  }
  ref.current = value;
};

var useComposedRef = function useComposedRef(libRef, userRef) {
  var prevUserRef = (0,react.useRef)();
  return (0,react.useCallback)(function (instance) {
    libRef.current = instance;

    if (prevUserRef.current) {
      updateRef(prevUserRef.current, null);
    }

    prevUserRef.current = userRef;

    if (!userRef) {
      return;
    }

    updateRef(userRef, instance);
  }, [userRef]);
};

/* harmony default export */ var use_composed_ref_esm = (useComposedRef);

;// CONCATENATED MODULE: ../../node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js






var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};

var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
};

//   export type CalculatedNodeHeights = [height: number, rowHeight: number];
// https://github.com/microsoft/TypeScript/issues/28259

var hiddenTextarea = null;

var getHeight = function getHeight(node, sizingData) {
  var height = node.scrollHeight;

  if (sizingData.sizingStyle.boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
  } // remove padding, since height = content


  return height - sizingData.paddingSize;
};

function calculateNodeHeight(sizingData, value, minRows, maxRows) {
  if (minRows === void 0) {
    minRows = 1;
  }

  if (maxRows === void 0) {
    maxRows = Infinity;
  }

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tabindex', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
    forceHiddenStyles(hiddenTextarea);
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  }

  var paddingSize = sizingData.paddingSize,
      borderSize = sizingData.borderSize,
      sizingStyle = sizingData.sizingStyle;
  var boxSizing = sizingStyle.boxSizing;
  Object.keys(sizingStyle).forEach(function (_key) {
    var key = _key;
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  forceHiddenStyles(hiddenTextarea);
  hiddenTextarea.value = value;
  var height = getHeight(hiddenTextarea, sizingData); // measure height of a textarea with a single row

  hiddenTextarea.value = 'x';
  var rowHeight = hiddenTextarea.scrollHeight - paddingSize;
  var minHeight = rowHeight * minRows;

  if (boxSizing === 'border-box') {
    minHeight = minHeight + paddingSize + borderSize;
  }

  height = Math.max(minHeight, height);
  var maxHeight = rowHeight * maxRows;

  if (boxSizing === 'border-box') {
    maxHeight = maxHeight + paddingSize + borderSize;
  }

  height = Math.min(maxHeight, height);
  return [height, rowHeight];
}

var noop = function noop() {};
var pick = function pick(props, obj) {
  return props.reduce(function (acc, prop) {
    acc[prop] = obj[prop];
    return acc;
  }, {});
};

var SIZING_STYLE = ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'boxSizing', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop', // non-standard
'tabSize', 'textIndent', // non-standard
'textRendering', 'textTransform', 'width', 'wordBreak'];
var isIE = !!document.documentElement.currentStyle ;

var getSizingData = function getSizingData(node) {
  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = pick(SIZING_STYLE, style);
  var boxSizing = sizingStyle.boxSizing; // probably node is detached from DOM, can't read computed dimensions

  if (boxSizing === '') {
    return null;
  } // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths


  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
  var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
  return {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize
  };
};

var useWindowResizeListener = function useWindowResizeListener(listener) {
  var latestListener = useLatest(listener);
  (0,react.useLayoutEffect)(function () {
    var handler = function handler(event) {
      latestListener.current(event);
    };

    window.addEventListener('resize', handler);
    return function () {
      window.removeEventListener('resize', handler);
    };
  }, []);
};

var TextareaAutosize = function TextareaAutosize(_ref, userRef) {
  var cacheMeasurements = _ref.cacheMeasurements,
      maxRows = _ref.maxRows,
      minRows = _ref.minRows,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$onHeightChange = _ref.onHeightChange,
      onHeightChange = _ref$onHeightChange === void 0 ? noop : _ref$onHeightChange,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]);

  if (false) {}

  var isControlled = props.value !== undefined;
  var libRef = (0,react.useRef)(null);
  var ref = use_composed_ref_esm(libRef, userRef);
  var heightRef = (0,react.useRef)(0);
  var measurementsCacheRef = (0,react.useRef)();

  var resizeTextarea = function resizeTextarea() {
    var node = libRef.current;
    var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : getSizingData(node);

    if (!nodeSizingData) {
      return;
    }

    measurementsCacheRef.current = nodeSizingData;

    var _calculateNodeHeight = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows),
        height = _calculateNodeHeight[0],
        rowHeight = _calculateNodeHeight[1];

    if (heightRef.current !== height) {
      heightRef.current = height;
      node.style.setProperty('height', height + "px", 'important');
      onHeightChange(height, {
        rowHeight: rowHeight
      });
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      resizeTextarea();
    }

    onChange(event);
  };

  {
    (0,react.useLayoutEffect)(resizeTextarea);
    useWindowResizeListener(resizeTextarea);
  }

  return /*#__PURE__*/(0,react.createElement)("textarea", (0,esm_extends/* default */.Z)({}, props, {
    onChange: handleChange,
    ref: ref
  }));
};

var react_textarea_autosize_browser_esm_index = /* #__PURE__ */(0,react.forwardRef)(TextareaAutosize);

/* harmony default export */ var react_textarea_autosize_browser_esm = (react_textarea_autosize_browser_esm_index);

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/fields/Input/Input.styles.js
var Input_styles = __webpack_require__(55217);
;// CONCATENATED MODULE: ./src/mosanic/fields/TextArea/TextArea.style.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var TextArea = (0,styled_components_browser_esm/* default */.ZP)(react_textarea_autosize_browser_esm).withConfig({
    componentId: "sc-f8d860f1-0"
})(_templateObject(), Input_styles/* BaseFieldStyles */.Zz);
var TextAreaStyles = {
    TextArea: TextArea
};
/* harmony default export */ var TextArea_style = (TextAreaStyles);

;// CONCATENATED MODULE: ./src/mosanic/fields/TextArea/TextArea.js








var TextArea_TextArea = function(_param) {
    var _name = _param.//Essential
    name, name = _name === void 0 ? "" : _name, _type = _param.type, type = _type === void 0 ? "text" : _type, _value = _param.value, value = _value === void 0 ? null : _value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? null : _placeholder, _label = _param.//Overwrite
    label, label = _label === void 0 ? null : _label, _fullWidth = _param.//Styling
    fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _small = _param.small, small = _small === void 0 ? null : _small, _size = _param.size, size = _size === void 0 ? null : _size, _ninja = _param.ninja, ninja = _ninja === void 0 ? false : _ninja, _wrap = _param.wrap, wrap = _wrap === void 0 ? false : _wrap, _minRows = _param.//Specific
    minRows, minRows = _minRows === void 0 ? 3 : _minRows, _maxRows = _param.maxRows, maxRows = _maxRows === void 0 ? 6 : _maxRows, _valid = _param.//Validation
    valid, valid = _valid === void 0 ? null : _valid, _empty = _param.empty, empty = _empty === void 0 ? false : _empty, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _required = _param.required, required = _required === void 0 ? false : _required, _endAdornment = _param.endAdornment, endAdornment = _endAdornment === void 0 ? null : _endAdornment, _endSource = _param.endSource, endSource = _endSource === void 0 ? null : _endSource, _ref = _param.ref, ref = _ref === void 0 ? null : _ref, _error = _param.//Dep
    error, error = _error === void 0 ? false : _error, _handler = _param.handler, handler = _handler === void 0 ? null : _handler, _inputProps = _param.inputProps, inputProps = _inputProps === void 0 ? null : _inputProps, _noCase = _param.noCase, noCase = _noCase === void 0 ? false : _noCase, other = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "type",
        "value",
        "onChange",
        "placeholder",
        "label",
        "fullWidth",
        "small",
        "size",
        "ninja",
        "wrap",
        "minRows",
        "maxRows",
        "valid",
        "empty",
        "disabled",
        "required",
        "endAdornment",
        "endSource",
        "ref",
        "error",
        "handler",
        "inputProps",
        "noCase"
    ]);
    var ref1 = (0,react.useState)(false), focussed = ref1[0], setFocused = ref1[1];
    var onFocus = function() {
        return setFocused(true);
    };
    var onBlur = function() {
        return setFocused(false);
    };
    var ref2 = (0,react.useState)(), local = ref2[0], setLocal = ref2[1];
    var handleInput = function(e) {
        var ref, ref1;
        return disabled ? null : onChange ? onChange(((ref = e.target) === null || ref === void 0 ? void 0 : ref.value) ? e.target.value : "") : setLocal(((ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value) ? e.target.value : "");
    };
    // console.warn('Please use other text area!')
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inputs/* WrapInput */.Vw, {
        wrap: wrap ? wrap : false,
        fullWidth: fullWidth,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Input_styles/* default.Container */.ZP.Container, {
            className: "input_field",
            focussed: focussed,
            disabled: disabled,
            valid: valid,
            empty: empty,
            ninja: ninja,
            size: size,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Input_styles/* default.Label */.ZP.Label, {
                    shrink: Boolean((ref === null || ref === void 0 ? void 0 : ref.current) || value || focussed || (other === null || other === void 0 ? void 0 : other.placeHolder)),
                    noCase: noCase,
                    children: [
                        ninja ? "" : label ? label : name ? name : "",
                        required && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_styles/* default.Required */.ZP.Required, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea_style.TextArea, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: ref,
                    placeholder: focussed ? placeholder : undefined,
                    size: small ? "small" : size ? size : null,
                    minRows: minRows,
                    maxRows: maxRows,
                    value: value ? value : local,
                    onChange: handleInput
                }, handler, other), {
                    // innerRef={undefined}
                    onFocus: function(e) {
                        if (other === null || other === void 0 ? void 0 : other.onFocus) other.onFocus(e);
                        onFocus();
                    },
                    onBlur: function(e) {
                        if (other === null || other === void 0 ? void 0 : other.onBlur) other.onBlur(e);
                        onBlur();
                    }
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Input_styles/* default.End */.ZP.End, {
                    children: [
                        endAdornment,
                        endSource
                    ]
                }),
                error && error
            ]
        })
    });
};
/* harmony default export */ var fields_TextArea_TextArea = (TextArea_TextArea);

;// CONCATENATED MODULE: ./src/mosanic/fields/TextArea/index.js

/* harmony default export */ var fields_TextArea = (fields_TextArea_TextArea);


/***/ }),

/***/ 91639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NumField": function() { return /* binding */ NumField; },
/* harmony export */   "TextArea": function() { return /* binding */ TextArea; },
/* harmony export */   "TextField": function() { return /* binding */ TextField; },
/* harmony export */   "useAutoTextField": function() { return /* binding */ useAutoTextField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _hooks_inputs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(91504);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77298);
/* harmony import */ var _util_Funct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3847);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68311);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76854);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _items_Inputs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99057);
/* harmony import */ var _Button_Buttons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47914);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55217);















var sanitizeValue = function(sanitize, e) {
    var ref, ref1;
    return !((ref = e.target) === null || ref === void 0 ? void 0 : ref.value) ? (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value : (0,_util_Funct__WEBPACK_IMPORTED_MODULE_4__/* .isFunc */ .W)(sanitize) ? sanitize(e.target.value) : sanitize === "extreme" ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_5__/* .getSensitizedString */ .W_)((0,_util_Text__WEBPACK_IMPORTED_MODULE_5__/* .removeSpaces */ .I8)((0,_util_Text__WEBPACK_IMPORTED_MODULE_5__/* .toLowCase */ .Cc)(e.target.value))) : sanitize === "slugify" ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_5__/* .toLowCase */ .Cc)(slugify__WEBPACK_IMPORTED_MODULE_3___default()(e.target.value)) : sanitize ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_5__/* .getSensitizedString */ .W_)(e.target.value) : e.target.value;
};
var TextField = function(_param) {
    var _name = _param.//Essential
    name, name = _name === void 0 ? "" : _name, _type = _param.type, type = _type === void 0 ? "text" : _type, _value = _param.value, value = _value === void 0 ? null : _value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? null : _placeholder, _label = _param.//Overwrite
    label, label = _label === void 0 ? null : _label, _fullWidth = _param.//Styling
    fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _small = _param.small, small = _small === void 0 ? null : _small, _size = _param.size, size = _size === void 0 ? null : _size, _ninja = _param.ninja, ninja = _ninja === void 0 ? false : _ninja, _wrap = _param.wrap, wrap = _wrap === void 0 ? false : _wrap, _center = _param.center, center = _center === void 0 ? false : _center, _endAdornment = _param.//Specific
    endAdornment, endAdornment = _endAdornment === void 0 ? null : _endAdornment, _endSource = _param.endSource, endSource = _endSource === void 0 ? null : _endSource, _defaultValue = _param.defaultValue, defaultValue = _defaultValue === void 0 ? null : _defaultValue, _valid = _param.//Validation
    valid, valid = _valid === void 0 ? null : _valid, _empty = _param.empty, empty = _empty === void 0 ? false : _empty, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _required = _param.required, required = _required === void 0 ? false : _required, _innerRef = _param.innerRef, innerRef = _innerRef === void 0 ? null : _innerRef, _inputProps = _param.//Dep
    inputProps, inputProps = _inputProps === void 0 ? null : _inputProps, _sanitize = _param.sanitize, sanitize = _sanitize === void 0 ? null : _sanitize, _noCase = _param.noCase, noCase = _noCase === void 0 ? false : _noCase, _style = _param.style, style = _style === void 0 ? null : _style, _inputStyle = _param.inputStyle, inputStyle = _inputStyle === void 0 ? null : _inputStyle, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "name",
        "type",
        "value",
        "onChange",
        "placeholder",
        "label",
        "fullWidth",
        "small",
        "size",
        "ninja",
        "wrap",
        "center",
        "endAdornment",
        "endSource",
        "defaultValue",
        "valid",
        "empty",
        "disabled",
        "required",
        "innerRef",
        "inputProps",
        "sanitize",
        "noCase",
        "style",
        "inputStyle"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), focussed = ref[0], setFocused = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(type), fieldType = ref1[0], setType = ref1[1];
    var updated = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(0);
    var onFocus = function() {
        return setFocused(true);
    };
    var onBlur = function() {
        return setFocused(false);
    };
    if (inputProps) {
        console.error("inputProps are deprecated: ".concat(label ? label : name));
    // console.log(inputProps)
    }
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (defaultValue && !value && (updated === null || updated === void 0 ? void 0 : updated.current) === 0) {
            onChange({
                target: {
                    value: defaultValue
                }
            });
            updated.current = 1;
        }
    }, [
        defaultValue,
        onChange,
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_items_Inputs__WEBPACK_IMPORTED_MODULE_7__/* .WrapInput */ .Vw, {
        wrap: wrap ? wrap : false,
        fullWidth: fullWidth,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Container */ .ZP.Container, {
            focussed: focussed,
            disabled: disabled,
            valid: valid,
            empty: empty,
            ninja: ninja,
            size: size,
            center: center,
            style: style,
            className: "input_field",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Label */ .ZP.Label, {
                    shrink: Boolean((innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) || value || focussed),
                    noCase: noCase,
                    children: [
                        ninja ? "" : label ? label : name ? name : "",
                        required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Required */ .ZP.Required, {})
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Field */ .ZP.Field, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    ref: innerRef,
                    type: fieldType ? fieldType : "text",
                    fullWidth: fullWidth,
                    placeholder: focussed ? placeholder : undefined,
                    size: small ? "small" : size ? size : null
                }, other), {
                    style: inputStyle,
                    disabled: disabled,
                    value: value || "",
                    onChange: function(e) {
                        if (sanitize) onChange(sanitizeValue(sanitize, e));
                        else onChange(e);
                    // todo -> check!
                    },
                    onFocus: function(e) {
                        if (other === null || other === void 0 ? void 0 : other.onFocus) other.onFocus(e);
                        onFocus();
                    },
                    onBlur: function(e) {
                        if (other === null || other === void 0 ? void 0 : other.onBlur) other.onBlur(e);
                        onBlur();
                    }
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"].End */ .ZP.End, {
                    children: [
                        type === "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Buttons__WEBPACK_IMPORTED_MODULE_11__["default"], {
                            ghost: true,
                            mt: 1,
                            icon: fieldType === "password" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .EyeOpenIcon */ .hsE, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .EyeClosedIcon */ .LAO, {}),
                            onClick: function() {
                                return setType(fieldType === "password" ? "text" : "password");
                            }
                        }),
                        endAdornment,
                        endSource
                    ]
                })
            ]
        })
    });
};
var TextArea = function(param) {
    var handler = param.handler, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? null : _placeholder, _ninja = param.ninja, ninja = _ninja === void 0 ? false : _ninja, _wrap = param.wrap, wrap = _wrap === void 0 ? false : _wrap, _inputProps = param.inputProps, inputProps = _inputProps === void 0 ? {} : _inputProps, _name = param.name, name = _name === void 0 ? "" : _name, _small = param.small, small = _small === void 0 ? null : _small;
    console.error("dep text area from fields");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_items_Inputs__WEBPACK_IMPORTED_MODULE_7__/* .WrapInput */ .Vw, {
        wrap: wrap,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Container */ .ZP.Container, {
            className: "input_field",
            ninja: ninja,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Label */ .ZP.Label, {
                    shrink: Boolean(handler === null || handler === void 0 ? void 0 : handler.value),
                    children: ninja ? "" : (handler === null || handler === void 0 ? void 0 : handler.label) ? handler.label : name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Field */ .ZP.Field, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    placeholder: placeholder ? placeholder : undefined,
                    size: small ? "small" : null
                }, handler), {
                    InputLabelProps: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        shrink: Boolean(handler === null || handler === void 0 ? void 0 : handler.value)
                    }, inputProps)
                }))
            ]
        })
    });
};
var NumField = function(_param) /*#__PURE__*/ {
    var handler = _param.handler, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? null : _placeholder, _ninja = _param.ninja, ninja = _ninja === void 0 ? false : _ninja, _wrap = _param.wrap, wrap = _wrap === void 0 ? false : _wrap, _name = _param.name, name = _name === void 0 ? "" : _name, _label = _param.label, label = _label === void 0 ? "" : _label, _small = _param.small, small = _small === void 0 ? null : _small, _size = _param.size, size = _size === void 0 ? null : _size, _value = _param.value, value = _value === void 0 ? null : _value, _onChange = _param.onChange, onChange = _onChange === void 0 ? null : _onChange, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "handler",
        "placeholder",
        "ninja",
        "wrap",
        "name",
        "label",
        "small",
        "size",
        "value",
        "onChange",
        "fullWidth"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextField, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        fullWidth: fullWidth,
        placeholder: placeholder,
        handler: handler,
        name: name,
        label: label,
        small: small,
        size: size,
        value: value,
        onChange: onChange,
        type: "number",
        ninja: ninja,
        wrap: wrap
    }, other));
};
/**
 * Use automatic handled text input field
 * 
 * @param {Value|Label|FullWidth} ConfigObject
 * @returns {field|handler} field|handler
 */ var useAutoTextField = function(param) {
    var _value = param.value, value = _value === void 0 ? "" : _value, _label = param.label, label = _label === void 0 ? "" : _label, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    var handler = (0,_hooks_inputs__WEBPACK_IMPORTED_MODULE_12__/* .useTextField */ .hR)(value, label);
    return {
        field: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextField, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, handler), {
            fullWidth: fullWidth
        })),
        handler: handler
    };
};

/* harmony default export */ __webpack_exports__["default"] = (TextField);


/***/ }),

/***/ 26518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nk": function() { return /* binding */ Video_Video; },
  "ZP": function() { return /* binding */ Video; },
  "Wv": function() { return /* binding */ isVideo; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/adapters/host.js
var host = __webpack_require__(6539);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ./src/mosanic/fields/File/index.js + 2 modules
var File = __webpack_require__(60772);
;// CONCATENATED MODULE: ./src/mosanic/fields/Video/VideoFile.js





var VideoField = function(_param) /*#__PURE__*/ {
    var other = (0,_extends/* default */.Z)({}, _param);
    return (0,jsx_runtime.jsx)(File/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        type: "video"
    }));
};
/* harmony default export */ var VideoFile = (VideoField);

;// CONCATENATED MODULE: ./src/mosanic/fields/Video/index.js







/* harmony default export */ var Video = (VideoFile);
var isVideo = function(url) {
    return !url ? false : (0,Text/* matchSubstrList */.OV)(url, [
        ".mp4",
        ".mov"
    ]);
};
var Video_Video = function(_param) {
    var url = _param.url, other = (0,_object_without_properties/* default */.Z)(_param, [
        "url"
    ]);
    return isVideo(url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        src: (0,host/* getImageUrl */.Jn)(url)
    }, other), {
        alt: "Video",
        autoPlay: true,
        muted: true,
        controls: true
    })) : JSON.stringify(url);
};


/***/ }),

/***/ 56542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useBreakpoint; },
/* harmony export */   "_": function() { return /* binding */ useCanvasScreenSize; }
/* harmony export */ });
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64485);
/* harmony import */ var _mosanic_core_Breakpoints_useDevices__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35702);
/* harmony import */ var _redux_breakpoints_reducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95746);
/* harmony import */ var _redux_options_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51331);
/* harmony import */ var _redux_screens_reducer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45260);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);



// import { getBreakPointByWidth } from '@redux/canvas/reducer';




var useBreakpoint = function(param) {
    var _overwrite = param.overwrite, overwrite = _overwrite === void 0 ? "auto" : _overwrite;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("xl"), breakpoint = ref1[0], setBreakpoint = ref1[1];
    var width = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_2__/* .useWindowSize */ .i)().width;
    var bp = (ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return (0,_redux_breakpoints_reducer__WEBPACK_IMPORTED_MODULE_3__/* .getBreakPointByWidth */ .Vj)(state, width);
    })) === null || ref === void 0 ? void 0 : ref._id;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (width && bp != breakpoint) {
            setBreakpoint(bp);
        }
    }, [
        bp,
        breakpoint,
        width
    ]);
    if (!breakpoint) setBreakpoint(bp);
    if (overwrite && overwrite != "auto") return overwrite;
    return breakpoint;
};
var useCanvasScreenSize = function() {
    var ref;
    //Active mode
    var breakpointMode = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_options_reducer__WEBPACK_IMPORTED_MODULE_4__/* .breakpointModeSelector */ .CT);
    var activeBp = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_screens_reducer__WEBPACK_IMPORTED_MODULE_5__/* .currentBpSelector */ .Xr);
    var full = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return (0,_redux_breakpoints_reducer__WEBPACK_IMPORTED_MODULE_3__/* .getBreakpointById */ .$g)(state, activeBp);
    });
    var device = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_screens_reducer__WEBPACK_IMPORTED_MODULE_5__/* .currentDeviceSelector */ .vk);
    var horizontalMode = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_options_reducer__WEBPACK_IMPORTED_MODULE_4__/* .horizontalModeSelector */ .J) && (device === null || device === void 0 ? void 0 : device.type) != "desktop";
    var size = (0,_mosanic_core_Breakpoints_useDevices__WEBPACK_IMPORTED_MODULE_6__/* .getDeviceSize */ .KT)(device);
    var width = breakpointMode ? (full === null || full === void 0 ? void 0 : full.minWidth) ? full.minWidth : 350 : !horizontalMode ? size === null || size === void 0 ? void 0 : size.maxWidth : size === null || size === void 0 ? void 0 : size.maxHeight;
    var breakpoint = (ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return (0,_redux_breakpoints_reducer__WEBPACK_IMPORTED_MODULE_3__/* .getBreakPointByWidth */ .Vj)(state, width);
    })) === null || ref === void 0 ? void 0 : ref._id;
    return {
        width: width,
        height: horizontalMode ? size === null || size === void 0 ? void 0 : size.maxWidth : size === null || size === void 0 ? void 0 : size.maxHeight,
        breakpoint: breakpoint,
        breakpointMode: breakpointMode
    };
};


/***/ }),

/***/ 39284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useControlPopper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function useControlPopper() {
    var closeSecondTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), anchor = ref[0], setAnchor = ref[1];
    var target = function(event) {
        return (event === null || event === void 0 ? void 0 : event.currentTarget) ? event.currentTarget : event;
    };
    var open = function(event) {
        return setAnchor(anchor ? closeSecondTime ? null : target(event) : target(event));
    };
    var close = function(event) {
        if (event && (anchor === null || anchor === void 0 ? void 0 : anchor.current) && (anchor === null || anchor === void 0 ? void 0 : anchor.current.contains(event.target))) return;
        if (event && !(event === null || event === void 0 ? void 0 : event.currentTarget) && anchor === event.target) return;
        setAnchor(null);
    };
    var isOpen = Boolean(anchor);
    return {
        anchor: anchor,
        open: open,
        close: close,
        isOpen: isOpen
    };
}


/***/ }),

/***/ 52926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useEditorMenu; }
/* harmony export */ });
/* harmony import */ var _redux_inspect_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67319);
/* harmony import */ var _redux_inspect_reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57522);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);




var useEditorMenu = function() {
    var screen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "undefined";
    var showEditor = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_inspect_reducer__WEBPACK_IMPORTED_MODULE_2__/* .isEditingSelector */ .m7);
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    //Handlers
    var toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(newState) {
        dispatch((0,_redux_inspect_action__WEBPACK_IMPORTED_MODULE_3__/* .setEditorAction */ .qo)({
            screen: screen,
            state: newState
        }));
    }, [
        dispatch,
        screen
    ]);
    var toggleEditor = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        toggle(!showEditor);
    }, [
        showEditor,
        toggle
    ]);
    return [
        showEditor,
        toggleEditor
    ];
};


/***/ }),

/***/ 294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useFieldHandler; }
/* harmony export */ });
/* unused harmony export useFieldsHandler */
/* harmony import */ var _mosanic_update__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2327);
/* harmony import */ var _redux_update_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94889);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68311);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);





//Single
var useFieldHandler = function(param) {
    var path = param.path, _state = param.state, state = _state === void 0 ? "base" : _state, _itemPath = param.itemPath, itemPath = _itemPath === void 0 ? null : _itemPath, canIncludeState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    //Dispatch handling
    var dispatchUpdate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(newValue) {
        var includeState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        // if(!newValue) return;
        var overwrite = (0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .isEmptyString */ .ke)(state) ? "base" : state;
        var updatePath = includeState && canIncludeState ? "".concat(path, ".").concat(overwrite) : path;
        var value = newValue;
        if ((newValue === null || newValue === void 0 ? void 0 : newValue.extend) || locale) {
            if (newValue.extend) updatePath += ".".concat(newValue.extend);
            if (locale) updatePath += ".".concat(locale);
            value = locale ? newValue : newValue.value;
        }
        if (locale && !value) return;
        dispatch(itemPath ? (0,_redux_update_action__WEBPACK_IMPORTED_MODULE_3__/* .updateItemField */ .Mx)((0,_mosanic_update__WEBPACK_IMPORTED_MODULE_4__/* .pathValue */ .X8)({
            path: updatePath,
            value: value
        }), itemPath) : (0,_redux_update_action__WEBPACK_IMPORTED_MODULE_3__/* .updateCurrentField */ .Wh)((0,_mosanic_update__WEBPACK_IMPORTED_MODULE_4__/* .pathValue */ .X8)({
            path: updatePath,
            value: value
        })));
    }, [
        state,
        canIncludeState,
        path,
        locale,
        dispatch,
        itemPath
    ]);
    return dispatchUpdate;
};
//Multiple
var useFieldsHandler = function(param) {
    var path = param.path, _itemPath = param.itemPath, itemPath = _itemPath === void 0 ? null : _itemPath;
    var dispatch = useDispatch();
    //Dispatch handling
    var dispatchUpdate = useCallback(function(object) {
        dispatch(itemPath ? updateItemFields(pathValue({
            path: path,
            object: object
        }), itemPath) : updateCurrentFields(pathValue({
            path: path,
            object: object
        })));
    }, [
        dispatch,
        itemPath,
        path
    ]);
    return dispatchUpdate;
};


/***/ }),

/***/ 68901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IZ": function() { return /* binding */ useMosanicInlineEditorFields; },
/* harmony export */   "k9": function() { return /* binding */ useFieldSource; }
/* harmony export */ });
/* unused harmony export useMosanicInlineEditorField */
/* harmony import */ var _mosanic_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(294);
/* harmony import */ var _redux_map_data_selector__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52478);
/* harmony import */ var _redux_inspect_selector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81903);
/* harmony import */ var _util_isEqual__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89450);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68311);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64157);
/* harmony import */ var _useOverwrite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19913);







var convertBasePath = function(basePath, path, fieldName) {
    var replace = (0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .isEmptyString */ .ke)(fieldName) ? ".[field]" : "[field]"; //prepare for switching with fieldname
    //Bade field group path
    if (basePath) path = (0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .replacePart */ .bA)(basePath, replace, fieldName);
    //Fallback if no path or basepath is set 
    if (!basePath && !path) path = "data.".concat(fieldName);
    return path;
};
/**
 * * Main field handler
 * 
 * A:   Convert to correct field path
 *      data.sizing.[field] => data.sizing.minWidth
 * 
 * B:   Get state overwrite
 *      primary:xl:hover       
 * 
 * C:   Get actual main field source 
 *      retruns full attr data structure
 * 
 * D:   Handler to update pass:
 *      @param value {full field value}
 *      @param boolean {optional prefix value with overwrite state}
 * 
 * @returns {
 *  source,
 *  handler
 * }
 */ var useFieldSource = function(param) {
    var _basePath = param.basePath, basePath = _basePath === void 0 ? null : _basePath, _path = param.path, path = _path === void 0 ? null : _path, _fieldName = param.fieldName, fieldName = _fieldName === void 0 ? "" : _fieldName, canIncludeState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    //A. Path to field
    path = convertBasePath(basePath, path, fieldName);
    //B. Get overwrite state selector
    var selector = (0,_useOverwrite__WEBPACK_IMPORTED_MODULE_2__/* .useOverwriteSelector */ .Rx)();
    //C. Get source to full field 
    var fullSource = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return (0,_redux_inspect_selector__WEBPACK_IMPORTED_MODULE_3__/* .inspectedDataSelector */ .Cu)(state, path, _util_isEqual__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    });
    var source = locale ? fullSource === null || fullSource === void 0 ? void 0 : fullSource[locale] : fullSource;
    //D. Handle with optional overwrite
    var handler = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useFieldHandler */ .T)({
        path: path,
        state: selector
    }, canIncludeState, locale);
    return {
        source: source,
        handler: handler
    };
};
var useMosanicInlineEditorField = function(param) {
    var field = param.field, ref = param.ref, includeOverwriteState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var path = "fields.".concat(field);
    //B. Get overwrite state selector
    var selector = useOverwriteSelector();
    //C. Get source to full field 
    var source = useSelector(function(state) {
        return itemDataSelector(state, {
            ref: ref,
            path: path
        }, isEqual);
    });
    //D. Handle with optional overwrite
    var handler = useFieldHandler({
        path: path,
        state: selector
    }, includeOverwriteState);
    return {
        source: source,
        handler: handler
    };
};
var useMosanicInlineEditorFields = function(param) {
    var ref = param.ref, includeOverwriteState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var path = "fields";
    //B. Get overwrite state selector
    var selector = (0,_useOverwrite__WEBPACK_IMPORTED_MODULE_2__/* .useOverwriteSelector */ .Rx)();
    //C. Get source to full field 
    var source = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return (0,_redux_map_data_selector__WEBPACK_IMPORTED_MODULE_6__/* .itemDataSelector */ .Lm)(state, {
            ref: ref,
            path: path
        }, _util_isEqual__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    });
    //D. Handle with optional overwrite
    var handler = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useFieldHandler */ .T)({
        path: path,
        state: selector
    }, includeOverwriteState);
    return {
        source: source,
        handler: handler
    };
};


/***/ }),

/***/ 74069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useInspectState; }
/* harmony export */ });
/* unused harmony export useInspectItemMap */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47842);
/* harmony import */ var _redux_inspect_selector__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81903);
/* harmony import */ var _util_isEqual__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89450);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64157);









//Validate from inspect store
var useInspectState = function(_id, screen) {
    var check = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, clone = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var state = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        id: (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
            return (0,_redux_inspect_selector__WEBPACK_IMPORTED_MODULE_2__/* .inspectAttrSelector */ .mj)(state, "_id");
        }, _util_isEqual__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z),
        screen: (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
            return (0,_redux_inspect_selector__WEBPACK_IMPORTED_MODULE_2__/* .inspectAttrSelector */ .mj)(state, "screen");
        }, _util_isEqual__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z),
        path: (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
            return (0,_redux_inspect_selector__WEBPACK_IMPORTED_MODULE_2__/* .inspectAttrSelector */ .mj)(state, "path");
        }, _util_isEqual__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z),
        clone: (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
            return (0,_redux_inspect_selector__WEBPACK_IMPORTED_MODULE_2__/* .inspectAttrSelector */ .mj)(state, "clone");
        }, _util_isEqual__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)
    }, "clone", (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return (0,_redux_inspect_selector__WEBPACK_IMPORTED_MODULE_2__/* .inspectAttrSelector */ .mj)(state, "clone");
    }, _util_isEqual__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z));
    if (!check) return state; //No check just state
    if (_id != state.id) return false; //Diff id
    if (screen === "any") return true; //Skip screen check
    if (!clone && screen === state.screen) return true; //No clone and current screen
    return clone && clone === state.clone //Validate clone index
    ;
};
var useInspectItemMap = function() {
    var path = useInspectState().path;
    var map = useSelector(mapSelector);
    var itemMap = getItemByPath({
        map: map,
        path: path
    });
    // console.log('ALERT:', path, itemMap)
    return _object_spread_props(_object_spread({}, itemMap), {
        path: path
    });
};


/***/ }),

/***/ 73360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ sortMediaQueries; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50930);
/* harmony import */ var _redux_breakpoints_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95746);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62570);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64157);







var getSelector = function(bp) {
    return (bp === null || bp === void 0 ? void 0 : bp.minWidth) && (bp === null || bp === void 0 ? void 0 : bp.maxWidth) ? "(min-width: ".concat(bp === null || bp === void 0 ? void 0 : bp.minWidth, "px) and (max-width: ").concat(bp === null || bp === void 0 ? void 0 : bp.maxWidth, "px)") : (bp === null || bp === void 0 ? void 0 : bp.minWidth) ? "(min-width: ".concat(bp === null || bp === void 0 ? void 0 : bp.minWidth, "px)") : (bp === null || bp === void 0 ? void 0 : bp.maxWidth) ? "(max-width: ".concat(bp === null || bp === void 0 ? void 0 : bp.maxWidth, "px)") : "(min-width: 0px)";
};
function compareIndex(a, b) {
    if (a.index < b.index) return -1;
    if (a.index > b.index) return 1;
    return 0;
}
var sortMediaQueries = function(mediaObj) {
    var desktopFirst = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var mediaArray = Object.entries(mediaObj).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), id = _param[0], value = _param[1];
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            id: id
        }, value);
    });
    var sortedArray = mediaArray.sort(compareIndex);
    var desktopFirstArray = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(sortedArray).reverse();
    return desktopFirst ? desktopFirstArray : sortedArray;
};
var useMediaQueries = function() {
    var bps = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_redux_breakpoints_reducer__WEBPACK_IMPORTED_MODULE_4__/* .getBreakpointsSelector */ .Pg);
    var mobileFirst = bps.map(function(bp, index) {
        return {
            id: bp._id,
            selector: getSelector(bp),
            index: index
        };
    });
    var media = mobileFirst //.reverse()
    ;
    return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_5__/* .toObject */ .ru)(media, "id");
};
/* harmony default export */ __webpack_exports__["Z"] = (useMediaQueries);


/***/ }),

/***/ 33346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _redux_notification_action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64725);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64157);



var ERROR_DURATION = 10000;
var STATUS_DURATION = 4000;
var DURATION = 2500;
var notifyError = function() {
    return {
        duration: ERROR_DURATION,
        variant: "error"
    };
};
var notifySuccess = function() {
    return {
        duration: STATUS_DURATION,
        variant: "success"
    };
};
var notify = function(variant) {
    return {
        duration: DURATION,
        variant: variant
    };
};
var getNotify = function(type) {
    if (type === "error") return notifyError();
    if (type === "success") return notifySuccess();
    return notify(type);
};
var getNotification = function(notification, feature, type) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        feature: feature
    }, (notification === null || notification === void 0 ? void 0 : notification.message) ? notification : {
        message: notification
    }, getNotify(type));
};
var useNotify = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    return function(notification) {
        var feature = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "app", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "error";
        return dispatch((0,_redux_notification_action__WEBPACK_IMPORTED_MODULE_2__/* .setNotification */ .sc)(getNotification(notification, feature, type)));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useNotify);


/***/ }),

/***/ 19913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rx": function() { return /* binding */ useOverwriteSelector; },
/* harmony export */   "d2": function() { return /* binding */ getOverwriteSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50930);
/* harmony import */ var _redux_inspect_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67319);
/* harmony import */ var _redux_inspect_reducer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57522);
/* harmony import */ var _util_Arr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72393);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62570);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68311);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);








var order = [
    "variant",
    "breakpoint",
    "state", 
];
var getOverwriteSelector = function(value, overwrites) {
    var attr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "value", skip = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    var selector = appendState(value, activeOverwrites(overwrites, attr, skip));
    if (!value) return (0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .removeFirstChar */ .eQ)(selector);
    return selector;
};
//Combine states
var appendState = function(value, state) {
    return state ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .combineString */ .M7)([
        value
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(state)), "") : value;
};
//Get overwrite labels
var activeOverwrites = function(overwrite) {
    var attr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "value", skip = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var active = [];
    order.map(function(selector) {
        if (skip.includes(selector)) return;
        active = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(active).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(getValues(overwrite, attr, selector)));
    });
    return active;
};
//Format active group labels for displaying combined
var getValues = function(overwrite) {
    var attr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "value", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "breakpoint";
    var ref;
    return (0,_util_Arr__WEBPACK_IMPORTED_MODULE_4__/* .canMap */ .is)(overwrite[type]) ? (ref = overwrite[type]) === null || ref === void 0 ? void 0 : ref.map(function(variant) {
        return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_5__/* .hasAttr */ .B$)(variant, attr) ? ":".concat((0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .removePart */ .ws)(variant[attr], ":")) : "";
    }) : "";
};
var useOverwrite = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var overwrite = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_inspect_reducer__WEBPACK_IMPORTED_MODULE_6__/* .inspectOverwriteSelector */ .b8);
    var setOverwrite = function(variant) {
        var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "state";
        dispatch((0,_redux_inspect_action__WEBPACK_IMPORTED_MODULE_7__/* .setOverwriteAction */ .lN)({
            value: variant === null || variant === void 0 ? void 0 : variant.value,
            label: variant === null || variant === void 0 ? void 0 : variant.label,
            type: variant === null || variant === void 0 ? void 0 : variant.type
        }, type));
    };
    return {
        overwrite: overwrite,
        setOverwrite: setOverwrite,
        prefixSelector: function(value) {
            return getOverwriteSelector(value, overwrite);
        },
        selector: getOverwriteSelector("", overwrite)
    };
};
var useOverwriteSelector = function() {
    var overwrite = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_inspect_reducer__WEBPACK_IMPORTED_MODULE_6__/* .inspectOverwriteSelector */ .b8);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return getOverwriteSelector("", overwrite);
    }, [
        overwrite
    ]);
};
/* harmony default export */ __webpack_exports__["ZP"] = (useOverwrite);


/***/ }),

/***/ 86314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ scrollTop; }
/* harmony export */ });
/* unused harmony export useShowScrollTop */
/* harmony import */ var _util_Device__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17629);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var scrollTop = function() {
    return (0,_util_Device__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk)() ? null : window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};
var useShowScrollTop = function() {
    var ref = useState(false), showScroll = ref[0], setShowScroll = ref[1];
    useEffect(function() {
        var checkScrollTop = function() {
            if (!showScroll && window.pageYOffset > 400) {
                setShowScroll(true);
            } else if (showScroll && window.pageYOffset <= 400) {
                setShowScroll(false);
            }
        };
        window.addEventListener("scroll", checkScrollTop);
        return function() {
            return window.removeEventListener("scroll", checkScrollTop);
        };
    }, [
        showScroll
    ]);
    return [
        showScroll,
        scrollTop
    ];
};


/***/ }),

/***/ 42974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useTabs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87567);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



// Todo --> if options.length is to long, switch to select.
var useTabs = function(param) {
    var _tabs = param.tabs, tabs = _tabs === void 0 ? [] : _tabs, _tab = param.tab, tab = _tab === void 0 ? null : _tab, _labelFormat = param.labelFormat, labelFormat = _labelFormat === void 0 ? "text" : _labelFormat, _iconGroup = param.iconGroup, iconGroup = _iconGroup === void 0 ? null : _iconGroup;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(tab), current = ref[0], setTab = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(tabs), options = ref1[0], setOptions = ref1[1];
    var Tabs = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroup */ .h, {
            size: "small",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_2__/* .ButtonGroup.Choices */ .h.Choices, {
                value: current,
                handler: setTab,
                options: options,
                labelFormat: labelFormat,
                iconGroup: iconGroup
            })
        });
    };
    return {
        setOptions: setOptions,
        current: current,
        Tabs: Tabs
    };
};


/***/ }),

/***/ 51925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useTooltips; }
/* harmony export */ });
/* harmony import */ var _redux_options_reducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51331);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64157);


var useTooltips = function() {
    var tooltips = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_redux_options_reducer__WEBPACK_IMPORTED_MODULE_1__/* .getTooltips */ .Sm);
    return tooltips;
};


/***/ }),

/***/ 15901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useValidate; }
/* harmony export */ });
/* harmony import */ var _mosanic_hooks_useMediaQueries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73360);
/* harmony import */ var _redux_inspect_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57522);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62570);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68311);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64157);
/* harmony import */ var _mosanic_constants_variants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91051);
/* harmony import */ var _redux_screens_reducer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45260);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _redux_colors_reducer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74329);
/* harmony import */ var _mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42622);
/* harmony import */ var _Breakpoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56542);















var parseMedia = function(media, breakpoint, width) {
    if (hasAttr(media, breakpoint)) {
        var index = media[breakpoint].index;
        var newMap = Object.entries(media).map(function(param) {
            var _param = _sliced_to_array(param, 2), id = _param[0], value = _param[1];
            if ((value === null || value === void 0 ? void 0 : value.index) < index || !(value === null || value === void 0 ? void 0 : value.index)) return _object_spread({
                id: id
            }, value);
            if ((value === null || value === void 0 ? void 0 : value.index) === index) return _object_spread_props(_object_spread({
                id: id
            }, value), {
                selector: "(min-width: ".concat(width - 50, "px) and (max-width: ").concat(width + 50, "px)")
            });
            return false; // skip
        });
        media = toObject(newMap, "id");
    }
    return media;
};
var useValidate = function(state, breakpoint) {
    var isProduction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var ref = (0,_Breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .useCanvasScreenSize */ ._)(), width = ref.width, height = ref.height, breakpointMode = ref.breakpointMode;
    var mode = (0,_mosanic_core_Provider__WEBPACK_IMPORTED_MODULE_3__/* .useModeProvider */ .uk)();
    var overwrite = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_redux_inspect_reducer__WEBPACK_IMPORTED_MODULE_4__/* .inspectOverwriteSelector */ .b8);
    var page = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_redux_screens_reducer__WEBPACK_IMPORTED_MODULE_5__/* .currentPageName */ .K);
    var colors = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(_redux_colors_reducer__WEBPACK_IMPORTED_MODULE_6__/* .colorsSelector */ .qQ);
    var getColor = function(hue, shade) {
        var ref;
        return (ref = (0,_redux_colors_reducer__WEBPACK_IMPORTED_MODULE_6__/* .colorByShadeSelector */ .dQ)(colors, hue, shade)) === null || ref === void 0 ? void 0 : ref.value;
    };
    var media = (0,_mosanic_hooks_useMediaQueries__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var sorted = (0,_mosanic_hooks_useMediaQueries__WEBPACK_IMPORTED_MODULE_7__/* .sortMediaQueries */ .P)(media, false);
    var current = sorted.find(function(s) {
        return s.id === breakpoint;
    });
    return {
        overwrite: function(variant, type) {
            var ref;
            return page != "artboards" && (0,_util_Obj__WEBPACK_IMPORTED_MODULE_8__/* .hasAttr */ .B$)(overwrite, type) ? ((ref = overwrite[type].filter(function(s) {
                return (s === null || s === void 0 ? void 0 : s.value) === variant;
            })) === null || ref === void 0 ? void 0 : ref.length) >= 1 : false;
        },
        interact: function(variant) {
            var ref;
            return ((ref = _mosanic_constants_variants__WEBPACK_IMPORTED_MODULE_9__/* .interactionStates.filter */ .kG.filter(function(s) {
                return (0,_util_Text__WEBPACK_IMPORTED_MODULE_10__/* .removeFirstChar */ .eQ)(s === null || s === void 0 ? void 0 : s.value) === variant;
            })) === null || ref === void 0 ? void 0 : ref.length) >= 1;
        },
        media: function(variant) {
            return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_8__/* .hasAttr */ .B$)(media, variant);
        },
        variant: function(variant) {
            var ref, ref1;
            return state ? ((ref1 = (ref = Object.values(state)) === null || ref === void 0 ? void 0 : ref.filter(function(s) {
                return Array.isArray(s) && (s === null || s === void 0 ? void 0 : s.includes(variant)) || !Array.isArray(s) && s === variant;
            })) === null || ref1 === void 0 ? void 0 : ref1.length) >= 1 : false;
        },
        vh: function(vh) {
            return !breakpointMode && (mode === null || mode === void 0 ? void 0 : mode.isDev) ? "".concat(parseFloat(vh) / 100 * height, "px") : vh;
        },
        vw: function(vw) {
            return !breakpointMode && (mode === null || mode === void 0 ? void 0 : mode.isDev) ? "".concat(parseFloat(vw) / 100 * width, "px") : vw;
        },
        interactions: _mosanic_constants_variants__WEBPACK_IMPORTED_MODULE_9__/* .interactionStates.map */ .kG.map(function(i) {
            return (0,_util_Text__WEBPACK_IMPORTED_MODULE_10__/* .removeFirstChar */ .eQ)(i === null || i === void 0 ? void 0 : i.value);
        }),
        bps: media,
        sorted: sorted,
        ids: sorted.filter(function(s) {
            return s.index <= (current === null || current === void 0 ? void 0 : current.index) || !s.index;
        }).map(function(s) {
            return s.id;
        }),
        rmv: isProduction ? [] : sorted.filter(function(s) {
            return s.index > (current === null || current === void 0 ? void 0 : current.index);
        }).map(function(s) {
            return s.id;
        }),
        breakpoint: breakpoint,
        bp: breakpoint,
        current: current,
        prod: (mode === null || mode === void 0 ? void 0 : mode.isDev) ? false : isProduction,
        color: function(hue, shade) {
            return getColor(hue, shade);
        }
    };
};


/***/ }),

/***/ 36072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ SelectLocales; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87567);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47914);
/* harmony import */ var _mosanic_fields_Input_Input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84430);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77298);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);





var mapped = {
    "en": "English",
    "nl": "Dutch"
};
var SelectLocales = function(param) {
    var locales = param.locales, active = param.active, setActive = param.setActive;
    return (locales === null || locales === void 0 ? void 0 : locales.length) >= 2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_3__/* .ButtonGroup */ .h, {
        fullWidth: true,
        children: locales.map(function(lang) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_4__.Button, {
                label: (mapped === null || mapped === void 0 ? void 0 : mapped[lang]) ? " ".concat(mapped[lang]) : lang,
                active: active === lang,
                icon: lang === "base" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .ComponentInstanceIcon */ .dgb, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    alt: "".concat(lang, " flag"),
                    src: (0,_mosanic_fields_Input_Input__WEBPACK_IMPORTED_MODULE_5__/* .localFlag */ .EU)(lang),
                    width: "20px",
                    height: "12px"
                }),
                onClick: function() {
                    return setActive(lang);
                },
                fullWidth: true
            }, lang);
        })
    }) : null;
};


/***/ }),

/***/ 38576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bU": function() { return /* binding */ useLocale; },
/* harmony export */   "eV": function() { return /* binding */ useCurrentLocale; },
/* harmony export */   "vN": function() { return /* binding */ Translate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62570);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);





var useCurrentLocale = function() {
    var _ref = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(), _locales = _ref.locales, locales = _locales === void 0 ? [] : _locales, defaultLocale = _ref.defaultLocale, nextRouter = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "locales",
        "defaultLocale"
    ]);
    var locale = locales.includes(nextRouter.locale || "") ? nextRouter.locale : defaultLocale;
    return locale;
};
var useLocale = function(obj) {
    var locale = useCurrentLocale();
    var defaultLocale = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().defaultLocale;
    var data = JSON.parse(obj);
    return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_3__/* .hasAttr */ .B$)(data, locale) ? data[locale] : (0,_util_Obj__WEBPACK_IMPORTED_MODULE_3__/* .hasAttr */ .B$)(data, defaultLocale) ? data[defaultLocale] : "";
};
var Translate = function(param) {
    var txt = param.txt;
    var text = useLocale(txt);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        style: {
            whiteSpace: "pre-line"
        },
        children: text
    });
};


/***/ }),

/***/ 51085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__": function() { return /* binding */ Label; },
/* harmony export */   "qv": function() { return /* binding */ AdvancedLabel; }
/* harmony export */ });
/* unused harmony exports Val, Lbl, LblIcon */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_Icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87308);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26021);
/* harmony import */ var _ControlPanel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77586);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78545);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    border-bottom: 2px solid #303031;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  display: block;\n  font-size: 14px;\n  padding: 3px 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-weight: 600!important;\n    color: rgba(0, 0, 0, 0.87);\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    font-size: 12px;  \n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n  svg {\n    transform: scale(0.9);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  padding: 2px;\n  margin: 0 4px 0 0;\n  svg {\n    transform: scale(0.9);\n    margin-top: -2.5px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var getTypeStyles = function(type) {
    if (type === "top") return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject());
};
var Val = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-68028a81-0"
})(_templateObject1());
var Lbl = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-68028a81-1"
})(_templateObject4(), styled_system__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_, function(props) {
    return props.bold && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2());
}, function(props) {
    return getTypeStyles(props.type);
}, function(props) {
    return !props.as && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3());
});
var LblIcon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-68028a81-2"
})(_templateObject5());
var TriggerIcon = function(param) {
    var largeIcon = param.largeIcon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
        className: "help__icon -sm",
        children: largeIcon ? _mosanic_Icons__WEBPACK_IMPORTED_MODULE_4__/* .largeCircle */ .Bn : _mosanic_Icons__WEBPACK_IMPORTED_MODULE_4__/* .helpCircle */ .pv
    });
};
var AdvancedLabel = function(_param) {
    var children = _param.children, _label = _param.label, label = _label === void 0 ? null : _label, helpText = _param.helpText, _help = _param.help, help = _help === void 0 ? null : _help, _className = _param.className, className = _className === void 0 ? "" : _className, _renderHelp = _param.renderHelp, renderHelp = _renderHelp === void 0 ? false : _renderHelp, _style = _param.//Styling
    style, style = _style === void 0 ? {
        display: "block"
    } : _style, _bold = _param.bold, bold = _bold === void 0 ? false : _bold, _header = _param.header, header = _header === void 0 ? false : _header, _title = _param.title, title = _title === void 0 ? false : _title, _type = _param.type, type = _type === void 0 ? null : _type, _icon = _param.icon, icon = _icon === void 0 ? null : _icon, _largeIcon = _param.largeIcon, largeIcon = _largeIcon === void 0 ? false : _largeIcon, _hover = _param.hover, hover = _hover === void 0 ? false : _hover, _span = _param.span, span = _span === void 0 ? false : _span, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "label",
        "helpText",
        "help",
        "className",
        "renderHelp",
        "style",
        "bold",
        "header",
        "title",
        "type",
        "icon",
        "largeIcon",
        "hover",
        "span"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Lbl, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: "label ".concat(className, " ").concat(header ? "-title" : ""),
        bold: bold,
        style: style,
        type: type,
        px: title ? 4 : 0
    }, other), {
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LblIcon, {
                children: icon
            }),
            label ? label : children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ControlPanel__WEBPACK_IMPORTED_MODULE_8__/* .HelpPopper */ .q, {
                helpText: helpText || help,
                trigger: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TriggerIcon, {
                    largeIcon: largeIcon
                }),
                hover: hover,
                renderHelp: renderHelp,
                span: span
            })
        ]
    }));
};
var Label = function(_param) {
    var children = _param.children, _label = _param.label, label = _label === void 0 ? null : _label, _className = _param.className, className = _className === void 0 ? "" : _className, _style = _param.//Styling
    style, style = _style === void 0 ? {
        display: "block"
    } : _style, _bold = _param.bold, bold = _bold === void 0 ? false : _bold, _header = _param.header, header = _header === void 0 ? false : _header, _title = _param.title, title = _title === void 0 ? false : _title, _type = _param.type, type = _type === void 0 ? null : _type, _icon = _param.icon, icon = _icon === void 0 ? null : _icon, _largeIcon = _param.largeIcon, largeIcon = _largeIcon === void 0 ? false : _largeIcon, _hover = _param.hover, hover = _hover === void 0 ? false : _hover, _span = _param.span, span = _span === void 0 ? false : _span, _value = _param.value, value = _value === void 0 ? null : _value, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "label",
        "className",
        "style",
        "bold",
        "header",
        "title",
        "type",
        "icon",
        "largeIcon",
        "hover",
        "span",
        "value"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Lbl, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: "label ".concat(className, " ").concat(header ? "-title" : ""),
        bold: bold,
        style: style,
        type: type,
        px: title ? 4 : 0
    }, other), {
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LblIcon, {
                children: icon
            }),
            label ? label : children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Val, {
                children: value
            })
        ]
    }));
};


/***/ }),

/***/ 57389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vp": function() { return /* binding */ Tag; },
/* harmony export */   "Zb": function() { return /* binding */ Card; },
/* harmony export */   "gO": function() { return /* binding */ Block; },
/* harmony export */   "it": function() { return /* binding */ MembershipCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_styles_card_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2483);





var Card = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_styles_card_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Card */ .ZP.Card, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, other), {
        children: children
    }));
};
var Block = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_styles_card_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Block */ .ZP.Block, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, other), {
        children: children
    }));
};
var MembershipCard = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_styles_card_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].MembershipCard */ .ZP.MembershipCard, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, other), {
        children: children
    }));
};
var Tag = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_styles_card_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Tag */ .ZP.Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, other), {
        children: children
    }));
};


/***/ }),

/***/ 11743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ ControlTabs; },
  "Z": function() { return /* binding */ Control_ControlButtons; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(87567);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/items/Tooltip/index.js + 2 modules
var Tooltip = __webpack_require__(94233);
// EXTERNAL MODULE: ./src/mosanic/items/Link/index.js
var Link = __webpack_require__(8152);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(78545);
;// CONCATENATED MODULE: ./src/mosanic/fields/Tab/Tab.js




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        &:hover {\n            border-bottom: 1px solid ",
        ";\n            background: ",
        ";\n        }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    border-top: none;\n    border-left: none;\n    border-right: none;\n    border-radius: none!important;\n    margin: 0;\n    transition: background-color ease-in-out 0.2s;\n    background: ",
        ";\n    border-color: ",
        ";\n    border-bottom: ",
        ";\n    font-size: 12px;\n    padding: 5px 15px;\n    svg {\n        margin: 5px;\n    }\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: flex;\n    width: auto;\n    border-bottom: 1px solid ",
        ";\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var StyledTab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77dcf207-0"
})(_templateObject1(), function(props) {
    return props.active ? colors/* default.util.gray.lighter */.ZP.util.gray.lighter : "transparent";
}, colors/* default.util.primary.light */.ZP.util.primary.light, function(props) {
    return props.active ? "1px solid ".concat(colors/* default.util.primary.base */.ZP.util.primary.base) : "none";
}, function(props) {
    return !props.active && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), colors/* default.util.primary.lighter */.ZP.util.primary.lighter, colors/* default.util.gray.lightest */.ZP.util.gray.lightest);
});
var StyledTabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-77dcf207-1"
})(_templateObject2(), colors/* default.util.gray.lighter */.ZP.util.gray.lighter, index_esm/* space */.Dh, index_esm/* layout */.bK);
var Tabs = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(StyledTabs, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};
var Tab = function(_param) {
    var children = _param.children, handler = _param.handler, _onClick = _param.onClick, onClick = _onClick === void 0 ? null : _onClick, _label = _param.label, label = _label === void 0 ? null : _label, _size = _param.size, size = _size === void 0 ? "small" : _size, _theme = _param.theme, theme = _theme === void 0 ? "" : _theme, _variant = _param.variant, variant = _variant === void 0 ? "outlined" : _variant, _customClass = _param.customClass, customClass = _customClass === void 0 ? "" : _customClass, _icon = _param.icon, icon = _icon === void 0 ? false : _icon, _scale = _param.scale, scale = _scale === void 0 ? false : _scale, _maxW = _param.maxW, maxW = _maxW === void 0 ? false : _maxW, _active = _param.active, active = _active === void 0 ? false : _active, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _noVal = _param.noVal, noVal = _noVal === void 0 ? false : _noVal, _cell = _param.cell, cell = _cell === void 0 ? false : _cell, _style = _param.style, style = _style === void 0 ? null : _style, _bold = _param.bold, bold = _bold === void 0 ? false : _bold, _tooltip = _param.tooltip, tooltip = _tooltip === void 0 ? null : _tooltip, _wrap = _param.wrap, wrap = _wrap === void 0 ? false : _wrap, _href = _param.href, href = _href === void 0 ? null : _href, _target = _param.target, target = _target === void 0 ? null : _target, _type = _param.type, type = _type === void 0 ? "button" : _type, _lines = _param.lines, lines = _lines === void 0 ? 1 : _lines, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "handler",
        "onClick",
        "label",
        "size",
        "theme",
        "variant",
        "customClass",
        "icon",
        "scale",
        "maxW",
        "active",
        "disabled",
        "noVal",
        "cell",
        "style",
        "bold",
        "tooltip",
        "wrap",
        "href",
        "target",
        "type",
        "lines"
    ]);
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: tooltip,
        wrapper: function(children) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                title: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.title) ? tooltip.title : tooltip,
                wrap: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.wrap) ? tooltip.wrap : false,
                placement: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.placement) ? tooltip.placement : null,
                children: children
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
            when: href,
            wrapper: function(children) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                    href: href,
                    target: target,
                    children: children
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTab, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onClick: handler ? handler : onClick,
                className: "coreButton ".concat(customClass),
                sz: size,
                theme: theme,
                variant: variant,
                icon: icon,
                // scale={scale}
                active: active,
                disabled: disabled,
                noVal: noVal,
                bold: bold,
                style: style,
                type: type,
                lines: lines
            }, other), {
                children: [
                    icon ? icon : "",
                    label ? label : "",
                    !icon && !label && children
                ]
            }))
        })
    });
};
/* harmony default export */ var Tab_Tab = (Tab);

// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
;// CONCATENATED MODULE: ./src/mosanic/items/Control/ControlButtons.js







var parseOptions = function(options) {
    return (0,Text/* isString */.HD)(options) ? options.split("|") : options;
};
var val = function(option) {
    return (option === null || option === void 0 ? void 0 : option.value) ? option.value : option;
};
var lbl = function(option) {
    return (option === null || option === void 0 ? void 0 : option.label) ? option.label : option;
};
var ControlButtons = function(_param) {
    var setActive = _param.setActive, active = _param.active, options = _param.options, size = _param.size, lines = _param.lines, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "setActive",
        "active",
        "options",
        "size",
        "lines",
        "children"
    ]);
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ButtonGroup/* ButtonGroup */.h, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: [
            parseOptions(options).map(function(option) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Buttons.Button, {
                    size: size,
                    lines: lines,
                    icon: option === null || option === void 0 ? void 0 : option.icon,
                    label: (0,Text/* isString */.HD)(lbl(option)) ? (0,Text/* capitalizeFirst */.Ez)(lbl(option)) : lbl(option),
                    onClick: function() {
                        return setActive(val(option));
                    },
                    active: val(option) === active,
                    className: val(option) === active ? "active" : ""
                }, val(option));
            }),
            children
        ]
    }));
};
var ControlTabs = function(_param) {
    var setActive = _param.setActive, active = _param.active, options = _param.options, size = _param.size, lines = _param.lines, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "setActive",
        "active",
        "options",
        "size",
        "lines",
        "children"
    ]);
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Tabs, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: [
            parseOptions(options).map(function(option) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Tab_Tab, {
                    size: size,
                    lines: lines,
                    icon: option === null || option === void 0 ? void 0 : option.icon,
                    label: (0,Text/* isString */.HD)(lbl(option)) ? (0,Text/* capitalizeFirst */.Ez)(lbl(option)) : lbl(option),
                    onClick: function() {
                        return setActive(val(option));
                    },
                    active: val(option) === active,
                    className: val(option) === active ? "active" : ""
                }, val(option));
            }),
            children
        ]
    }));
};

/* harmony default export */ var Control_ControlButtons = (ControlButtons);


/***/ }),

/***/ 41100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ControlMenu_Menu; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(48570);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(69075);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/ownerDocument.js
var ownerDocument = __webpack_require__(36855);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/utils/ownerDocument.js

/* harmony default export */ var utils_ownerDocument = (ownerDocument/* default */.Z);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js + 17 modules
var styled = __webpack_require__(60414);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useThemeProps.js + 3 modules
var useThemeProps = __webpack_require__(95285);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/List/ListContext.js

/**
 * @ignore - internal component.
 */

const ListContext = /*#__PURE__*/react.createContext({});

if (false) {}

/* harmony default export */ var List_ListContext = (ListContext);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js + 1 modules
var generateUtilityClass = __webpack_require__(61069);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(69222);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/List/listClasses.js

function getListUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiList', slot);
}
const listClasses = (0,generateUtilityClasses/* default */.Z)('MuiList', ['root', 'padding', 'dense', 'subheader']);
/* harmony default export */ var List_listClasses = ((/* unused pure expression or super */ null && (listClasses)));
;// CONCATENATED MODULE: ../../node_modules/@mui/material/List/List.js


const _excluded = ["children", "className", "component", "dense", "disablePadding", "subheader"];











const useUtilityClasses = ownerState => {
  const {
    classes,
    disablePadding,
    dense,
    subheader
  } = ownerState;
  const slots = {
    root: ['root', !disablePadding && 'padding', dense && 'dense', subheader && 'subheader']
  };
  return (0,composeClasses/* default */.Z)(slots, getListUtilityClass, classes);
};

const ListRoot = (0,styled/* default */.ZP)('ul', {
  name: 'MuiList',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disablePadding && styles.padding, ownerState.dense && styles.dense, ownerState.subheader && styles.subheader];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  position: 'relative'
}, !ownerState.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.subheader && {
  paddingTop: 0
}));
const List = /*#__PURE__*/react.forwardRef(function List(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiList'
  });

  const {
    children,
    className,
    component = 'ul',
    dense = false,
    disablePadding = false,
    subheader
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const context = react.useMemo(() => ({
    dense
  }), [dense]);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    dense,
    disablePadding
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(List_ListContext.Provider, {
    value: context,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ListRoot, (0,esm_extends/* default */.Z)({
      as: component,
      className: (0,clsx_m["default"])(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [subheader, children]
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var List_List = (List);
;// CONCATENATED MODULE: ../../node_modules/@mui/utils/esm/getScrollbarSize.js
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function getScrollbarSize(doc) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
  const documentWidth = doc.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}
;// CONCATENATED MODULE: ../../node_modules/@mui/material/utils/getScrollbarSize.js

/* harmony default export */ var utils_getScrollbarSize = (getScrollbarSize);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/useForkRef.js
var useForkRef = __webpack_require__(84501);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/utils/useForkRef.js

/* harmony default export */ var utils_useForkRef = (useForkRef/* default */.Z);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(21399);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/utils/useEnhancedEffect.js

/* harmony default export */ var utils_useEnhancedEffect = (useEnhancedEffect/* default */.Z);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/MenuList/MenuList.js


const MenuList_excluded = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];










function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return disableListWrap ? null : list.firstChild;
}

function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return disableListWrap ? null : list.lastChild;
}

function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }

  let text = nextFocus.innerText;

  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }

  text = text.trim().toLowerCase();

  if (text.length === 0) {
    return false;
  }

  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }

  return text.indexOf(textCriteria.keys.join('')) === 0;
}

function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  let wrappedOnce = false;
  let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return false;
      }

      wrappedOnce = true;
    } // Same logic as useAutocomplete.js


    const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return true;
    }
  }

  return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menubutton/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */


const MenuList = /*#__PURE__*/react.forwardRef(function MenuList(props, ref) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions,
    autoFocus = false,
    autoFocusItem = false,
    children,
    className,
    disabledItemsFocusable = false,
    disableListWrap = false,
    onKeyDown,
    variant = 'selectedMenu'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, MenuList_excluded);

  const listRef = react.useRef(null);
  const textCriteriaRef = react.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  utils_useEnhancedEffect(() => {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  react.useImperativeHandle(actions, () => ({
    adjustStyleForScrollbar: (containerElement, theme) => {
      // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.
      const noExplicitWidth = !listRef.current.style.width;

      if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
        const scrollbarSize = `${utils_getScrollbarSize(utils_ownerDocument(containerElement))}px`;
        listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
        listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
      }

      return listRef.current;
    }
  }), []);

  const handleKeyDown = event => {
    const list = listRef.current;
    const key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */

    const currentFocus = utils_ownerDocument(list).activeElement;

    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      const criteria = textCriteriaRef.current;
      const lowerKey = key.toLowerCase();
      const currTime = performance.now();

      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }

      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  const handleRef = utils_useForkRef(listRef, ref);
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */

  let activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  react.Children.forEach(children, (child, index) => {
    if (! /*#__PURE__*/react.isValidElement(child)) {
      return;
    }

    if (false) {}

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  const items = react.Children.map(children, (child, index) => {
    if (index === activeItemIndex) {
      const newChildProps = {};

      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }

      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }

      return /*#__PURE__*/react.cloneElement(child, newChildProps);
    }

    return child;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(List_List, (0,esm_extends/* default */.Z)({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other, {
    children: items
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var MenuList_MenuList = (MenuList);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(47591);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Paper/paperClasses.js

function getPaperUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiPaper', slot);
}
const paperClasses = (0,generateUtilityClasses/* default */.Z)('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);
/* harmony default export */ var Paper_paperClasses = ((/* unused pure expression or super */ null && (paperClasses)));
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Paper/Paper.js


const Paper_excluded = ["className", "component", "elevation", "square", "variant"];









 // Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61


const getOverlayAlpha = elevation => {
  let alphaValue;

  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }

  return (alphaValue / 100).toFixed(2);
};

const Paper_useUtilityClasses = ownerState => {
  const {
    square,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && `elevation${elevation}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getPaperUtilityClass, classes);
};

const PaperRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$overlays;

  return (0,esm_extends/* default */.Z)({
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create('box-shadow')
  }, !ownerState.square && {
    borderRadius: theme.shape.borderRadius
  }, ownerState.variant === 'outlined' && {
    border: `1px solid ${(theme.vars || theme).palette.divider}`
  }, ownerState.variant === 'elevation' && (0,esm_extends/* default */.Z)({
    boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
  }, !theme.vars && theme.palette.mode === 'dark' && {
    backgroundImage: `linear-gradient(${(0,colorManipulator/* alpha */.Fq)('#fff', getOverlayAlpha(ownerState.elevation))}, ${(0,colorManipulator/* alpha */.Fq)('#fff', getOverlayAlpha(ownerState.elevation))})`
  }, theme.vars && {
    backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
  }));
});
const Paper = /*#__PURE__*/react.forwardRef(function Paper(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPaper'
  });

  const {
    className,
    component = 'div',
    elevation = 1,
    square = false,
    variant = 'elevation'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Paper_excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    elevation,
    square,
    variant
  });

  const classes = Paper_useUtilityClasses(ownerState);

  if (false) {}

  return /*#__PURE__*/(0,jsx_runtime.jsx)(PaperRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx_m["default"])(classes.root, className),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Paper_Paper = (Paper);
;// CONCATENATED MODULE: ../../node_modules/@mui/utils/esm/debounce.js
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func, wait = 166) {
  let timeout;

  function debounced(...args) {
    const later = () => {
      func.apply(this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = () => {
    clearTimeout(timeout);
  };

  return debounced;
}
;// CONCATENATED MODULE: ../../node_modules/@mui/material/utils/debounce.js

/* harmony default export */ var utils_debounce = (debounce);
;// CONCATENATED MODULE: ../../node_modules/@mui/utils/esm/ownerWindow.js

function ownerWindow(node) {
  const doc = (0,ownerDocument/* default */.Z)(node);
  return doc.defaultView || window;
}
;// CONCATENATED MODULE: ../../node_modules/@mui/material/utils/ownerWindow.js

/* harmony default export */ var utils_ownerWindow = (ownerWindow);
// EXTERNAL MODULE: ../../node_modules/react-transition-group/esm/Transition.js + 2 modules
var Transition = __webpack_require__(41759);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/useTheme.js
var useTheme = __webpack_require__(16933);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/defaultTheme.js + 15 modules
var defaultTheme = __webpack_require__(9077);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/styles/useTheme.js



function useTheme_useTheme() {
  const theme = (0,useTheme/* default */.Z)(defaultTheme/* default */.Z);

  if (false) {}

  return theme;
}
;// CONCATENATED MODULE: ../../node_modules/@mui/material/transitions/utils.js
const reflow = node => node.scrollTop;
function getTransitionProps(props, options) {
  var _style$transitionDura, _style$transitionTimi;

  const {
    timeout,
    easing,
    style = {}
  } = props;
  return {
    duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
    delay: style.transitionDelay
  };
}
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Grow/Grow.js


const Grow_excluded = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];









function getScale(value) {
  return `scale(${value}, ${value ** 2})`;
}

const styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */

const isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Grow = /*#__PURE__*/react.forwardRef(function Grow(props, ref) {
  const {
    addEndListener,
    appear = true,
    children,
    easing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style,
    timeout = 'auto',
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition/* default */.ZP
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Grow_excluded);

  const timer = react.useRef();
  const autoTimeout = react.useRef();
  const theme = useTheme_useTheme();
  const nodeRef = react.useRef(null);
  const foreignRef = utils_useForkRef(children.ref, ref);
  const handleRef = utils_useForkRef(nodeRef, foreignRef);

  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.

      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };

  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    reflow(node); // So the animation always start from the start.

    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    let duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration,
      delay
    }), theme.transitions.create('transform', {
      duration: isWebKit154 ? duration : duration * 0.666,
      delay,
      easing: transitionTimingFunction
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    let duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration,
      delay
    }), theme.transitions.create('transform', {
      duration: isWebKit154 ? duration : duration * 0.666,
      delay: isWebKit154 ? delay : delay || duration * 0.333,
      easing: transitionTimingFunction
    })].join(',');
    node.style.opacity = 0;
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);

  const handleAddEndListener = next => {
    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }

    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };

  react.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react.cloneElement(children, (0,esm_extends/* default */.Z)({
        style: (0,esm_extends/* default */.Z)({
          opacity: 0,
          transform: getScale(0.75),
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
Grow.muiSupportAuto = true;
/* harmony default export */ var Grow_Grow = (Grow);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/useEventCallback.js
var useEventCallback = __webpack_require__(57817);
;// CONCATENATED MODULE: ../../node_modules/@mui/utils/esm/createChainedFunction.js
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }

    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {});
}
// EXTERNAL MODULE: ../../node_modules/@mui/base/Portal/Portal.js
var Portal = __webpack_require__(83820);
;// CONCATENATED MODULE: ../../node_modules/@mui/base/ModalUnstyled/ModalManager.js


// Is a vertical scrollbar displayed?
function isOverflowing(container) {
  const doc = (0,ownerDocument/* default */.Z)(container);

  if (doc.body === container) {
    return ownerWindow(container).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(element, show) {
  if (show) {
    element.setAttribute('aria-hidden', 'true');
  } else {
    element.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(element) {
  return parseInt(ownerWindow(element).getComputedStyle(element).paddingRight, 10) || 0;
}

function isAriaHiddenForbiddenOnElement(element) {
  // The forbidden HTML tags are the ones from ARIA specification that
  // can be children of body and can't have aria-hidden attribute.
  // cf. https://www.w3.org/TR/html-aria/#docconformance
  const forbiddenTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE', 'LINK', 'MAP', 'META', 'NOSCRIPT', 'PICTURE', 'COL', 'COLGROUP', 'PARAM', 'SLOT', 'SOURCE', 'TRACK'];
  const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
  const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
  return isForbiddenTagName || isInputHidden;
}

function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude = [], show) {
  const blacklist = [mountElement, currentElement, ...elementsToExclude];
  [].forEach.call(container.children, element => {
    const isNotExcludedElement = blacklist.indexOf(element) === -1;
    const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);

    if (isNotExcludedElement && isNotForbiddenElement) {
      ariaHidden(element, show);
    }
  });
}

function findIndexOf(items, callback) {
  let idx = -1;
  items.some((item, index) => {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  const restoreStyle = [];
  const container = containerInfo.container;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      const scrollbarSize = getScrollbarSize((0,ownerDocument/* default */.Z)(container));
      restoreStyle.push({
        value: container.style.paddingRight,
        property: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`; // .mui-fixed is a global helper.

      const fixedElements = (0,ownerDocument/* default */.Z)(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedElements, element => {
        restoreStyle.push({
          value: element.style.paddingRight,
          property: 'padding-right',
          el: element
        });
        element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
      });
    }

    let scrollContainer;

    if (container.parentNode instanceof DocumentFragment) {
      scrollContainer = (0,ownerDocument/* default */.Z)(container).body;
    } else {
      // Improve Gatsby support
      // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
      const parent = container.parentElement;
      const containerWindow = ownerWindow(container);
      scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
    } // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.


    restoreStyle.push({
      value: scrollContainer.style.overflow,
      property: 'overflow',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowX,
      property: 'overflow-x',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowY,
      property: 'overflow-y',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  const restore = () => {
    restoreStyle.forEach(({
      value,
      el,
      property
    }) => {
      if (value) {
        el.style.setProperty(property, value);
      } else {
        el.style.removeProperty(property);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  const hiddenSiblings = [];
  [].forEach.call(container.children, element => {
    if (element.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(element);
    }
  });
  return hiddenSiblings;
}

/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */
class ModalManager {
  constructor() {
    this.containers = void 0;
    this.modals = void 0;
    this.modals = [];
    this.containers = [];
  }

  add(modal, container) {
    let modalIndex = this.modals.indexOf(modal);

    if (modalIndex !== -1) {
      return modalIndex;
    }

    modalIndex = this.modals.length;
    this.modals.push(modal); // If the modal we are adding is already in the DOM.

    if (modal.modalRef) {
      ariaHidden(modal.modalRef, false);
    }

    const hiddenSiblings = getHiddenSiblings(container);
    ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
    const containerIndex = findIndexOf(this.containers, item => item.container === container);

    if (containerIndex !== -1) {
      this.containers[containerIndex].modals.push(modal);
      return modalIndex;
    }

    this.containers.push({
      modals: [modal],
      container,
      restore: null,
      hiddenSiblings
    });
    return modalIndex;
  }

  mount(modal, props) {
    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];

    if (!containerInfo.restore) {
      containerInfo.restore = handleContainer(containerInfo, props);
    }
  }

  remove(modal, ariaHiddenState = true) {
    const modalIndex = this.modals.indexOf(modal);

    if (modalIndex === -1) {
      return modalIndex;
    }

    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
    this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

    if (containerInfo.modals.length === 0) {
      // The modal might be closed before it had the chance to be mounted in the DOM.
      if (containerInfo.restore) {
        containerInfo.restore();
      }

      if (modal.modalRef) {
        // In case the modal wasn't in the DOM yet.
        ariaHidden(modal.modalRef, ariaHiddenState);
      }

      ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
      this.containers.splice(containerIndex, 1);
    } else {
      // Otherwise make sure the next top modal is visible to a screen reader.
      const nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
      // aria-hidden because the dom element doesn't exist either
      // when modal was unmounted before modalRef gets null

      if (nextTop.modalRef) {
        ariaHidden(nextTop.modalRef, false);
      }
    }

    return modalIndex;
  }

  isTopModal(modal) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
  }

}
;// CONCATENATED MODULE: ../../node_modules/@mui/base/TrapFocus/TrapFocus.js
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */


 // Inspired by https://github.com/focus-trap/tabbable



const candidatesSelector = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'].join(',');

function getTabIndex(node) {
  const tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

  if (!Number.isNaN(tabindexAttr)) {
    return tabindexAttr;
  } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.


  if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }

  return node.tabIndex;
}

function isNonTabbableRadio(node) {
  if (node.tagName !== 'INPUT' || node.type !== 'radio') {
    return false;
  }

  if (!node.name) {
    return false;
  }

  const getRadio = selector => node.ownerDocument.querySelector(`input[type="radio"]${selector}`);

  let roving = getRadio(`[name="${node.name}"]:checked`);

  if (!roving) {
    roving = getRadio(`[name="${node.name}"]`);
  }

  return roving !== node;
}

function isNodeMatchingSelectorFocusable(node) {
  if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) {
    return false;
  }

  return true;
}

function defaultGetTabbable(root) {
  const regularTabNodes = [];
  const orderedTabNodes = [];
  Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i) => {
    const nodeTabIndex = getTabIndex(node);

    if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) {
      return;
    }

    if (nodeTabIndex === 0) {
      regularTabNodes.push(node);
    } else {
      orderedTabNodes.push({
        documentOrder: i,
        tabIndex: nodeTabIndex,
        node
      });
    }
  });
  return orderedTabNodes.sort((a, b) => a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map(a => a.node).concat(regularTabNodes);
}

function defaultIsEnabled() {
  return true;
}
/**
 * Utility component that locks focus inside the component.
 */


function TrapFocus(props) {
  const {
    children,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableRestoreFocus = false,
    getTabbable = defaultGetTabbable,
    isEnabled = defaultIsEnabled,
    open
  } = props;
  const ignoreNextEnforceFocus = react.useRef();
  const sentinelStart = react.useRef(null);
  const sentinelEnd = react.useRef(null);
  const nodeToRestore = react.useRef(null);
  const reactFocusEventTarget = react.useRef(null); // This variable is useful when disableAutoFocus is true.
  // It waits for the active element to move into the component to activate.

  const activated = react.useRef(false);
  const rootRef = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(children.ref, rootRef);
  const lastKeydown = react.useRef(null);
  react.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }

    activated.current = !disableAutoFocus;
  }, [disableAutoFocus, open]);
  react.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }

    const doc = (0,ownerDocument/* default */.Z)(rootRef.current);

    if (!rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (false) {}

        rootRef.current.setAttribute('tabIndex', -1);
      }

      if (activated.current) {
        rootRef.current.focus();
      }
    }

    return () => {
      // restoreLastFocus()
      if (!disableRestoreFocus) {
        // In IE11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE11 have a focus method.
        // Once IE11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          ignoreNextEnforceFocus.current = true;
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    }; // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open TrapFocus
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  react.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }

    const doc = (0,ownerDocument/* default */.Z)(rootRef.current);

    const contain = nativeEvent => {
      const {
        current: rootElement
      } = rootRef; // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.

      if (rootElement === null) {
        return;
      }

      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (!rootElement.contains(doc.activeElement)) {
        // if the focus event is not coming from inside the children's react tree, reset the refs
        if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) {
          reactFocusEventTarget.current = null;
        } else if (reactFocusEventTarget.current !== null) {
          return;
        }

        if (!activated.current) {
          return;
        }

        let tabbable = [];

        if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) {
          tabbable = getTabbable(rootRef.current);
        }

        if (tabbable.length > 0) {
          var _lastKeydown$current, _lastKeydown$current2;

          const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
          const focusNext = tabbable[0];
          const focusPrevious = tabbable[tabbable.length - 1];

          if (isShiftTab) {
            focusPrevious.focus();
          } else {
            focusNext.focus();
          }
        } else {
          rootElement.focus();
        }
      }
    };

    const loopFocus = nativeEvent => {
      lastKeydown.current = nativeEvent;

      if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') {
        return;
      } // Make sure the next tab starts from the right place.
      // doc.activeElement referes to the origin.


      if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;
        sentinelEnd.current.focus();
      }
    };

    doc.addEventListener('focusin', contain);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    // Instead, we can look if the active element was restored on the BODY element.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    const interval = setInterval(() => {
      if (doc.activeElement.tagName === 'BODY') {
        contain();
      }
    }, 50);
    return () => {
      clearInterval(interval);
      doc.removeEventListener('focusin', contain);
      doc.removeEventListener('keydown', loopFocus, true);
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);

  const onFocus = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }

    activated.current = true;
    reactFocusEventTarget.current = event.target;
    const childrenPropsHandler = children.props.onFocus;

    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };

  const handleFocusSentinel = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }

    activated.current = true;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelStart,
      "data-testid": "sentinelStart"
    }), /*#__PURE__*/react.cloneElement(children, {
      ref: handleRef,
      onFocus
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelEnd,
      "data-testid": "sentinelEnd"
    })]
  });
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ var TrapFocus_TrapFocus = (TrapFocus);
;// CONCATENATED MODULE: ../../node_modules/@mui/base/ModalUnstyled/modalUnstyledClasses.js


function getModalUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiModal', slot);
}
const modalUnstyledClasses_modalUnstyledClasses = (0,generateUtilityClasses/* default */.Z)('MuiModal', ['root', 'hidden']);
/* harmony default export */ var ModalUnstyled_modalUnstyledClasses = ((/* unused pure expression or super */ null && (modalUnstyledClasses_modalUnstyledClasses)));
// EXTERNAL MODULE: ../../node_modules/@mui/base/utils/useSlotProps.js + 4 modules
var useSlotProps = __webpack_require__(70586);
;// CONCATENATED MODULE: ../../node_modules/@mui/base/ModalUnstyled/ModalUnstyled.js


const ModalUnstyled_excluded = ["children", "classes", "closeAfterTransition", "component", "components", "componentsProps", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onKeyDown", "open", "onTransitionEnter", "onTransitionExited"];












const ModalUnstyled_useUtilityClasses = ownerState => {
  const {
    open,
    exited,
    classes
  } = ownerState;
  const slots = {
    root: ['root', !open && exited && 'hidden']
  };
  return (0,composeClasses/* default */.Z)(slots, getModalUtilityClass, classes);
};

function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


const defaultManager = new ModalManager();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

const ModalUnstyled = /*#__PURE__*/react.forwardRef(function ModalUnstyled(props, ref) {
  var _props$ariaHidden;

  const {
    children,
    classes: classesProp,
    closeAfterTransition = false,
    component = 'div',
    components = {},
    componentsProps = {},
    container,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = false,
    disableRestoreFocus = false,
    disableScrollLock = false,
    hideBackdrop = false,
    keepMounted = false,
    // private
    // eslint-disable-next-line react/prop-types
    manager = defaultManager,
    onBackdropClick,
    onClose,
    onKeyDown,
    open,

    /* eslint-disable react/prop-types */
    onTransitionEnter,
    onTransitionExited
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ModalUnstyled_excluded);

  const [exited, setExited] = react.useState(true);
  const modal = react.useRef({});
  const mountNodeRef = react.useRef(null);
  const modalRef = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(modalRef, ref);
  const hasTransition = getHasTransition(props);
  const ariaHiddenProp = (_props$ariaHidden = props['aria-hidden']) != null ? _props$ariaHidden : true;

  const getDoc = () => (0,ownerDocument/* default */.Z)(mountNodeRef.current);

  const getModal = () => {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  const handleMounted = () => {
    manager.mount(getModal(), {
      disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  const handleOpen = (0,useEventCallback/* default */.Z)(() => {
    const resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  const isTopModal = react.useCallback(() => manager.isTopModal(getModal()), [manager]);
  const handlePortalRef = (0,useEventCallback/* default */.Z)(node => {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      ariaHidden(modalRef.current, ariaHiddenProp);
    }
  });
  const handleClose = react.useCallback(() => {
    manager.remove(getModal(), ariaHiddenProp);
  }, [manager, ariaHiddenProp]);
  react.useEffect(() => {
    return () => {
      handleClose();
    };
  }, [handleClose]);
  react.useEffect(() => {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    classes: classesProp,
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    exited,
    hideBackdrop,
    keepMounted
  });

  const classes = ModalUnstyled_useUtilityClasses(ownerState);

  const handleEnter = () => {
    setExited(false);

    if (onTransitionEnter) {
      onTransitionEnter();
    }
  };

  const handleExited = () => {
    setExited(true);

    if (onTransitionExited) {
      onTransitionExited();
    }

    if (closeAfterTransition) {
      handleClose();
    }
  };

  const handleBackdropClick = event => {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };

  const handleKeyDown = event => {
    if (onKeyDown) {
      onKeyDown(event);
    } // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.


    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  const childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = createChainedFunction(handleEnter, children.props.onEnter);
    childProps.onExited = createChainedFunction(handleExited, children.props.onExited);
  }

  const Root = components.Root || component;
  const rootProps = (0,useSlotProps/* default */.Z)({
    elementType: Root,
    externalSlotProps: componentsProps.root,
    externalForwardedProps: other,
    additionalProps: {
      ref: handleRef,
      role: 'presentation',
      onKeyDown: handleKeyDown
    },
    className: classes.root,
    ownerState
  });
  const BackdropComponent = components.Backdrop;
  const backdropProps = (0,useSlotProps/* default */.Z)({
    elementType: BackdropComponent,
    externalSlotProps: componentsProps.backdrop,
    additionalProps: {
      'aria-hidden': true,
      onClick: handleBackdropClick,
      open
    },
    ownerState
  });

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Portal/* default */.Z, {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Root, (0,esm_extends/* default */.Z)({}, rootProps, {
      children: [!hideBackdrop && BackdropComponent ? /*#__PURE__*/(0,jsx_runtime.jsx)(BackdropComponent, (0,esm_extends/* default */.Z)({}, backdropProps)) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(TrapFocus_TrapFocus, {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        isEnabled: isTopModal,
        open: open,
        children: /*#__PURE__*/react.cloneElement(children, childProps)
      })]
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var ModalUnstyled_ModalUnstyled = (ModalUnstyled);
// EXTERNAL MODULE: ../../node_modules/@mui/base/utils/resolveComponentProps.js
var resolveComponentProps = __webpack_require__(5584);
// EXTERNAL MODULE: ../../node_modules/@mui/base/utils/isHostComponent.js
var isHostComponent = __webpack_require__(65444);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Fade/Fade.js


const Fade_excluded = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];








const Fade_styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Fade = /*#__PURE__*/react.forwardRef(function Fade(props, ref) {
  const theme = useTheme_useTheme();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    addEndListener,
    appear = true,
    children,
    easing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style,
    timeout = defaultTimeout,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition/* default */.ZP
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Fade_excluded);

  const enableStrictModeCompat = true;
  const nodeRef = react.useRef(null);
  const foreignRef = utils_useForkRef(children.ref, ref);
  const handleRef = utils_useForkRef(nodeRef, foreignRef);

  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.

      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };

  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    reflow(node); // So the animation always start from the start.

    const transitionProps = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);

  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    appear: appear,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react.cloneElement(children, (0,esm_extends/* default */.Z)({
        style: (0,esm_extends/* default */.Z)({
          opacity: 0,
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, Fade_styles[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Fade_Fade = (Fade);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Backdrop/backdropClasses.js

function getBackdropUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiBackdrop', slot);
}
const backdropClasses = (0,generateUtilityClasses/* default */.Z)('MuiBackdrop', ['root', 'invisible']);
/* harmony default export */ var Backdrop_backdropClasses = ((/* unused pure expression or super */ null && (backdropClasses)));
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Backdrop/Backdrop.js


const Backdrop_excluded = ["children", "component", "components", "componentsProps", "className", "invisible", "open", "transitionDuration", "TransitionComponent"];










const Backdrop_useUtilityClasses = ownerState => {
  const {
    classes,
    invisible
  } = ownerState;
  const slots = {
    root: ['root', invisible && 'invisible']
  };
  return (0,composeClasses/* default */.Z)(slots, getBackdropUtilityClass, classes);
};

const BackdropRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiBackdrop',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.invisible && styles.invisible];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  WebkitTapHighlightColor: 'transparent'
}, ownerState.invisible && {
  backgroundColor: 'transparent'
}));
const Backdrop = /*#__PURE__*/react.forwardRef(function Backdrop(inProps, ref) {
  var _components$Root, _componentsProps$root;

  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiBackdrop'
  });

  const {
    children,
    component = 'div',
    components = {},
    componentsProps = {},
    className,
    invisible = false,
    open,
    transitionDuration,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Fade_Fade
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Backdrop_excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    invisible
  });

  const classes = Backdrop_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
    in: open,
    timeout: transitionDuration
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BackdropRoot, {
      "aria-hidden": true,
      as: (_components$Root = components.Root) != null ? _components$Root : component,
      className: (0,clsx_m["default"])(classes.root, className),
      ownerState: (0,esm_extends/* default */.Z)({}, ownerState, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState),
      classes: classes,
      ref: ref,
      children: children
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Backdrop_Backdrop = (Backdrop);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Modal/Modal.js


const Modal_excluded = ["BackdropComponent", "BackdropProps", "closeAfterTransition", "children", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "theme"];









const modalClasses = (/* unused pure expression or super */ null && (modalUnstyledClasses));

const extendUtilityClasses = ownerState => {
  return ownerState.classes;
};

const ModalRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiModal',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.open && ownerState.exited && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'fixed',
  zIndex: (theme.vars || theme).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !ownerState.open && ownerState.exited && {
  visibility: 'hidden'
}));
const ModalBackdrop = (0,styled/* default */.ZP)(Backdrop_Backdrop, {
  name: 'MuiModal',
  slot: 'Backdrop',
  overridesResolver: (props, styles) => {
    return styles.backdrop;
  }
})({
  zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

const Modal = /*#__PURE__*/react.forwardRef(function Modal(inProps, ref) {
  var _ref, _components$Root;

  const props = (0,useThemeProps/* default */.Z)({
    name: 'MuiModal',
    props: inProps
  });

  const {
    BackdropComponent = ModalBackdrop,
    BackdropProps,
    closeAfterTransition = false,
    children,
    component,
    components = {},
    componentsProps = {},
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = false,
    disableRestoreFocus = false,
    disableScrollLock = false,
    hideBackdrop = false,
    keepMounted = false,
    // eslint-disable-next-line react/prop-types
    theme
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Modal_excluded);

  const [exited, setExited] = react.useState(true);
  const commonProps = {
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted
  };

  const ownerState = (0,esm_extends/* default */.Z)({}, props, commonProps, {
    exited
  });

  const classes = extendUtilityClasses(ownerState);
  const Root = (_ref = (_components$Root = components.Root) != null ? _components$Root : component) != null ? _ref : ModalRoot;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalUnstyled_ModalUnstyled, (0,esm_extends/* default */.Z)({
    components: (0,esm_extends/* default */.Z)({
      Root,
      Backdrop: BackdropComponent
    }, components),
    componentsProps: {
      root: () => (0,esm_extends/* default */.Z)({}, (0,resolveComponentProps/* default */.Z)(componentsProps.root, ownerState), !(0,isHostComponent/* default */.Z)(Root) && {
        as: component,
        theme
      }),
      backdrop: () => (0,esm_extends/* default */.Z)({}, BackdropProps, (0,resolveComponentProps/* default */.Z)(componentsProps.backdrop, ownerState))
    },
    onTransitionEnter: () => setExited(false),
    onTransitionExited: () => setExited(true),
    ref: ref
  }, other, {
    classes: classes
  }, commonProps, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Modal_Modal = (Modal);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Popover/popoverClasses.js

function getPopoverUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiPopover', slot);
}
const popoverClasses = (0,generateUtilityClasses/* default */.Z)('MuiPopover', ['root', 'paper']);
/* harmony default export */ var Popover_popoverClasses = ((/* unused pure expression or super */ null && (popoverClasses)));
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Popover/Popover.js


const Popover_excluded = ["onEntering"],
      _excluded2 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"];
















function getOffsetTop(rect, vertical) {
  let offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
function getOffsetLeft(rect, horizontal) {
  let offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(n => typeof n === 'number' ? `${n}px` : n).join(' ');
}

function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

const Popover_useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper']
  };
  return (0,composeClasses/* default */.Z)(slots, getPopoverUtilityClass, classes);
};

const PopoverRoot = (0,styled/* default */.ZP)(Modal_Modal, {
  name: 'MuiPopover',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const PopoverPaper = (0,styled/* default */.ZP)(Paper_Paper, {
  name: 'MuiPopover',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})({
  position: 'absolute',
  overflowY: 'auto',
  overflowX: 'hidden',
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: 'calc(100% - 32px)',
  maxHeight: 'calc(100% - 32px)',
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Popover = /*#__PURE__*/react.forwardRef(function Popover(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPopover'
  });

  const {
    action,
    anchorEl,
    anchorOrigin = {
      vertical: 'top',
      horizontal: 'left'
    },
    anchorPosition,
    anchorReference = 'anchorEl',
    children,
    className,
    container: containerProp,
    elevation = 8,
    marginThreshold = 16,
    open,
    PaperProps = {},
    transformOrigin = {
      vertical: 'top',
      horizontal: 'left'
    },
    TransitionComponent = Grow_Grow,
    transitionDuration: transitionDurationProp = 'auto',
    TransitionProps: {
      onEntering
    } = {}
  } = props,
        TransitionProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.TransitionProps, Popover_excluded),
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

  const paperRef = react.useRef();
  const handlePaperRef = utils_useForkRef(paperRef, PaperProps.ref);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    anchorOrigin,
    anchorReference,
    elevation,
    marginThreshold,
    PaperProps,
    transformOrigin,
    TransitionComponent,
    transitionDuration: transitionDurationProp,
    TransitionProps
  });

  const classes = Popover_useUtilityClasses(ownerState); // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)

  const getAnchorOffset = react.useCallback(() => {
    if (anchorReference === 'anchorPosition') {
      if (false) {}

      return anchorPosition;
    }

    const resolvedAnchorEl = resolveAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

    const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : utils_ownerDocument(paperRef.current).body;
    const anchorRect = anchorElement.getBoundingClientRect();

    if (false) {}

    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the base transform origin using the element

  const getTransformOrigin = react.useCallback(elemRect => {
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical),
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  const getPositioningStyle = react.useCallback(element => {
    const elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    }; // Get the transform origin point on the element itself

    const elemTransformOrigin = getTransformOrigin(elemRect);

    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    } // Get the offset of the anchoring element


    const anchorOffset = getAnchorOffset(); // Calculate element positioning

    let top = anchorOffset.top - elemTransformOrigin.vertical;
    let left = anchorOffset.left - elemTransformOrigin.horizontal;
    const bottom = top + elemRect.height;
    const right = left + elemRect.width; // Use the parent window of the anchorEl if provided

    const containerWindow = utils_ownerWindow(resolveAnchorEl(anchorEl)); // Window thresholds taking required margin into account

    const heightThreshold = containerWindow.innerHeight - marginThreshold;
    const widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      const diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      const diff = bottom - heightThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    }

    if (false) {} // Check if the horizontal axis needs shifting


    if (left < marginThreshold) {
      const diff = left - marginThreshold;
      left -= diff;
      elemTransformOrigin.horizontal += diff;
    } else if (right > widthThreshold) {
      const diff = right - widthThreshold;
      left -= diff;
      elemTransformOrigin.horizontal += diff;
    }

    return {
      top: `${Math.round(top)}px`,
      left: `${Math.round(left)}px`,
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getTransformOrigin, marginThreshold]);
  const setPositioningStyles = react.useCallback(() => {
    const element = paperRef.current;

    if (!element) {
      return;
    }

    const positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  const handleEntering = (element, isAppearing) => {
    if (onEntering) {
      onEntering(element, isAppearing);
    }

    setPositioningStyles();
  };

  react.useEffect(() => {
    if (open) {
      setPositioningStyles();
    }
  });
  react.useImperativeHandle(action, () => open ? {
    updatePosition: () => {
      setPositioningStyles();
    }
  } : null, [open, setPositioningStyles]);
  react.useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleResize = utils_debounce(() => {
      setPositioningStyles();
    });
    const containerWindow = utils_ownerWindow(anchorEl);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [anchorEl, open, setPositioningStyles]);
  let transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  const container = containerProp || (anchorEl ? utils_ownerDocument(resolveAnchorEl(anchorEl)).body : undefined);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PopoverRoot, (0,esm_extends/* default */.Z)({
    BackdropProps: {
      invisible: true
    },
    className: (0,clsx_m["default"])(classes.root, className),
    container: container,
    open: open,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
      appear: true,
      in: open,
      onEntering: handleEntering,
      timeout: transitionDuration
    }, TransitionProps, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PopoverPaper, (0,esm_extends/* default */.Z)({
        elevation: elevation
      }, PaperProps, {
        ref: handlePaperRef,
        className: (0,clsx_m["default"])(classes.paper, PaperProps.className),
        children: children
      }))
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Popover_Popover = (Popover);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Menu/menuClasses.js

function getMenuUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiMenu', slot);
}
const menuClasses = (0,generateUtilityClasses/* default */.Z)('MuiMenu', ['root', 'paper', 'list']);
/* harmony default export */ var Menu_menuClasses = ((/* unused pure expression or super */ null && (menuClasses)));
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Menu/Menu.js


const Menu_excluded = ["onEntering"],
      Menu_excluded2 = ["autoFocus", "children", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"];














const RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
const LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};

const Menu_useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper'],
    list: ['list']
  };
  return (0,composeClasses/* default */.Z)(slots, getMenuUtilityClass, classes);
};

const MenuRoot = (0,styled/* default */.ZP)(Popover_Popover, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiMenu',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const MenuPaper = (0,styled/* default */.ZP)(Paper_Paper, {
  name: 'MuiMenu',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tapable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: 'calc(100% - 96px)',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch'
});
const MenuMenuList = (0,styled/* default */.ZP)(MenuList_MenuList, {
  name: 'MuiMenu',
  slot: 'List',
  overridesResolver: (props, styles) => styles.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Menu = /*#__PURE__*/react.forwardRef(function Menu(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiMenu'
  });

  const {
    autoFocus = true,
    children,
    disableAutoFocusItem = false,
    MenuListProps = {},
    onClose,
    open,
    PaperProps = {},
    PopoverClasses,
    transitionDuration = 'auto',
    TransitionProps: {
      onEntering
    } = {},
    variant = 'selectedMenu'
  } = props,
        TransitionProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.TransitionProps, Menu_excluded),
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Menu_excluded2);

  const theme = useTheme_useTheme();
  const isRtl = theme.direction === 'rtl';

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    autoFocus,
    disableAutoFocusItem,
    MenuListProps,
    onEntering,
    PaperProps,
    transitionDuration,
    TransitionProps,
    variant
  });

  const classes = Menu_useUtilityClasses(ownerState);
  const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  const menuListActionsRef = react.useRef(null);

  const handleEntering = (element, isAppearing) => {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }

    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };

  const handleListKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */


  let activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  react.Children.map(children, (child, index) => {
    if (! /*#__PURE__*/react.isValidElement(child)) {
      return;
    }

    if (false) {}

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MenuRoot, (0,esm_extends/* default */.Z)({
    classes: PopoverClasses,
    onClose: onClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: isRtl ? 'right' : 'left'
    },
    transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: (0,esm_extends/* default */.Z)({
      component: MenuPaper
    }, PaperProps, {
      classes: (0,esm_extends/* default */.Z)({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    className: classes.root,
    open: open,
    ref: ref,
    transitionDuration: transitionDuration,
    TransitionProps: (0,esm_extends/* default */.Z)({
      onEntering: handleEntering
    }, TransitionProps),
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MenuMenuList, (0,esm_extends/* default */.Z)({
      onKeyDown: handleListKeyDown,
      actions: menuListActionsRef,
      autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
      autoFocusItem: autoFocusItem,
      variant: variant
    }, MenuListProps, {
      className: (0,clsx_m["default"])(classes.list, MenuListProps.className),
      children: children
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Menu_Menu = (Menu);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Parts.js + 1 modules
var Parts = __webpack_require__(39171);
;// CONCATENATED MODULE: ./src/mosanic/items/ControlMenu/Menu.tsx




var milliseconds = 500;
var ControlMenu = function(param) {
    var _position = param.position, position = _position === void 0 ? null : _position, _close = param.close, close = _close === void 0 ? function() {
        return null;
    } : _close, _autoClose = param.autoClose, autoClose = _autoClose === void 0 ? true : _autoClose, _customClass = param.customClass, customClass = _customClass === void 0 ? "" : _customClass, _bigShadow = param.bigShadow, bigShadow = _bigShadow === void 0 ? false : _bigShadow, _reversed = param.reversed, reversed = _reversed === void 0 ? false : _reversed, _delay = param.delay, delay = _delay === void 0 ? 1 : _delay, children = param.children;
    var isOpen = Boolean((position === null || position === void 0 ? void 0 : position.x) && (position === null || position === void 0 ? void 0 : position.y));
    var ref = (0,react.useState)(false), hover = ref[0], setHover = ref[1];
    var onEnter = (0,react.useCallback)(function() {
        if (autoClose) setHover(true);
    }, [
        autoClose
    ]);
    var onLeave = (0,react.useCallback)(function() {
        if (autoClose) setHover(false);
    }, [
        autoClose
    ]);
    var hide = (0,react.useCallback)(function() {
        if (!hover) close();
    }, [
        close,
        hover
    ]);
    (0,react.useEffect)(function() {
        var timer;
        if (isOpen && autoClose) timer = setTimeout(function() {
            hide();
        }, delay * milliseconds);
        return function() {
            clearTimeout(timer);
        };
    }, [
        hover,
        isOpen,
        hide,
        autoClose,
        delay
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu, {
        style: {
            background: "transparent",
            boxShadow: "none",
            zIndex: 3
        },
        open: isOpen,
        onClose: function(e) {
            return close(e);
        },
        anchorReference: "anchorPosition",
        anchorPosition: position && isOpen ? {
            top: position.y,
            left: position.x
        } : undefined,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onMouseEnter: onEnter,
            onMouseLeave: onLeave,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Parts/* ControlPanel */.qG, {
                extraClass: customClass,
                bigShadow: bigShadow,
                reversed: reversed,
                children: children
            })
        })
    });
};
/* harmony default export */ var ControlMenu_Menu = (ControlMenu);


/***/ }),

/***/ 41145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _JSX__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3679);
/* harmony import */ var _mosanic_utils_clone__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32428);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77298);
/* harmony import */ var _util_Event__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33434);
/* harmony import */ var _util_Num__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3121);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var react_draggable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41327);
/* harmony import */ var react_draggable__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_draggable__WEBPACK_IMPORTED_MODULE_4__);









// import Dialog from 'rc-dialog';
var Dialog = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 1217).then(__webpack_require__.bind(__webpack_require__, 41217));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41217)
            ];
        }
    },
    ssr: false
});


var sizes = {
    xxs: "250px",
    xs: "400px",
    small: "600px",
    sm: "600px",
    md: "700px",
    large: "800px",
    xl: "1000px",
    xxl: "1150px"
};
var ControlDialog = function(_param) {
    var children = _param.children, _title = _param.title, title = _title === void 0 ? null : _title, _state = _param.state, state = _state === void 0 ? false : _state, _close = _param.close, close = _close === void 0 ? null : _close, _size = _param.size, size = _size === void 0 ? "sm" : _size, _sizing = _param.sizing, sizing = _sizing === void 0 ? null : _sizing, _ghost = _param.ghost, ghost = _ghost === void 0 ? false : _ghost, _titleSize = _param.titleSize, titleSize = _titleSize === void 0 ? 2 : _titleSize, _trigger = _param.trigger, trigger = _trigger === void 0 ? null : _trigger, _wrapTrigger = _param.wrapTrigger, wrapTrigger = _wrapTrigger === void 0 ? false : _wrapTrigger, _bodyProps = _param.bodyProps, bodyProps = _bodyProps === void 0 ? null : _bodyProps, _headingProps = _param.headingProps, headingProps = _headingProps === void 0 ? null : _headingProps, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "title",
        "state",
        "close",
        "size",
        "sizing",
        "ghost",
        "titleSize",
        "trigger",
        "wrapTrigger",
        "bodyProps",
        "headingProps"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), localState = ref[0], setLocalState = ref[1];
    var isOpen = Boolean(trigger) ? localState : state;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true), disabled = ref1[0], setDisabled = ref1[1];
    var onClose = function(event) {
        var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (_util_Event__WEBPACK_IMPORTED_MODULE_6__/* ["default"].isValidCurrentTarget */ .ZP.isValidCurrentTarget(event) || force) {
            trigger ? setLocalState(false) : close ? close() : null;
        }
    };
    // useEffect(() => {
    //   const escFunction = (event) => {
    //     if (event.key === "Escape") close(event, true)
    //   }
    //   document.addEventListener("keydown", escFunction, false);
    //   return () =>  document.removeEventListener("keydown", escFunction, false);
    // })
    var getSizeValue = function(value) {
        return (0,_util_Num__WEBPACK_IMPORTED_MODULE_7__/* .isNumber */ .hj)(value) ? "".concat(value, "px") : value;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            trigger && (wrapTrigger ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                onClick: function() {
                    return setLocalState(true);
                },
                children: trigger
            }) : (0,_mosanic_utils_clone__WEBPACK_IMPORTED_MODULE_8__/* .extendClone */ .j)({
                onClick: function() {
                    return setLocalState(true);
                }
            }, trigger)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Dialog, {
                visible: isOpen,
                onClose: onClose,
                animation: "fade",
                wrapStyle: {
                    pointerEvents: ghost ? "none" : "initial"
                },
                maskClosable: !ghost,
                mask: !ghost,
                maskAnimation: "fade",
                bodyProps: {
                    style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        alignSelf: "center",
                        marginTop: (other === null || other === void 0 ? void 0 : other.minimize) ? "-10px" : 0,
                        padding: ghost ? "0px 20px 20px" : "15px",
                        position: "relative",
                        height: (sizing === null || sizing === void 0 ? void 0 : sizing.height) ? getSizeValue(sizing === null || sizing === void 0 ? void 0 : sizing.height) : null,
                        maxHeight: "90vh",
                        overflowX: "hidden",
                        overflowY: (sizing === null || sizing === void 0 ? void 0 : sizing.height) ? "auto" : "auto"
                    }, bodyProps, other)
                },
                style: {
                    // pointerEvents: 'all',
                    width: (sizing === null || sizing === void 0 ? void 0 : sizing.width) ? getSizeValue(sizing.width) : size ? sizes[size] : 600,
                    // overflow: sizing ? 'scroll' : null,
                    maxWidth: "95vw",
                    zIndex: 0
                },
                title: title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_10__/* .HeadingTag */ .lb, {
                    level: titleSize,
                    style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        pointerEvents: "all",
                        width: "90%",
                        cursor: "pointer",
                        color: "#212121"
                    }, headingProps),
                    onMouseOver: function() {
                        return disabled ? setDisabled(false) : null;
                    },
                    onMouseOut: function() {
                        return setDisabled(true);
                    },
                    onFocus: function() {},
                    onBlur: function() {},
                    children: title
                }) : null,
                closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_1__/* .CrossCircledIcon */ .xrR, {
                    onClick: onClose
                }),
                modalRender: function(modal) {
                    return title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_draggable__WEBPACK_IMPORTED_MODULE_4___default()), {
                        disabled: disabled,
                        style: {
                            pointerEvents: "all"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                boxShadow: ghost ? "5px 5px 15px 0 rgba(0,0,0,0.1)" : "5px 0px 35px 0 rgba(0,0,0,0.2)",
                                pointerEvents: "all"
                            },
                            children: modal
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            boxShadow: ghost ? "5px 5px 15px 0 rgba(0,0,0,0.1)" : "5px 0px 35px 0 rgba(0,0,0,0.2)"
                        },
                        children: modal
                    });
                },
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ControlDialog);


/***/ }),

/***/ 77586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ HelpPopper; }
/* harmony export */ });
/* unused harmony export DefaultTrigger */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _JSX__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(706);
/* harmony import */ var _mosanic_Icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87308);
/* harmony import */ var _Popper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28932);




var DefaultTrigger = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "help__icon -sm",
        children: _mosanic_Icons__WEBPACK_IMPORTED_MODULE_1__/* .helpCircle */ .pv
    });
};
var HelpPopper = function(param) {
    var helpText = param.helpText, _trigger = param.trigger, trigger = _trigger === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultTrigger, {}) : _trigger, _renderHelp = param.renderHelp, renderHelp = _renderHelp === void 0 ? false : _renderHelp, _hover = param.hover, hover = _hover === void 0 ? false : _hover, _span = param.span, span = _span === void 0 ? false : _span;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_2__.If, {
        condition: helpText,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Popper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            trigger: trigger,
            customClass: "helpPopper",
            hover: hover,
            children: renderHelp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: helpText
                }
            }) : span ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                style: {
                    fontSize: "12px"
                },
                children: helpText
            }) : helpText
        })
    });
};


/***/ }),

/***/ 39171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NS": function() { return /* binding */ ControlHeader; },
  "qG": function() { return /* binding */ ControlPanel; },
  "V9": function() { return /* binding */ PanelHeader; },
  "s": function() { return /* binding */ PanelTrigger; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/Icons/EditIcons.js
var EditIcons = __webpack_require__(75679);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/styles/panels.js
var panels = __webpack_require__(42895);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(78545);
;// CONCATENATED MODULE: ./src/mosanic/items/ControlPanel/Parts.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        max-height: ",
        ";\n        overflow-y: scroll;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        padding: 16px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        overflow: visible;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        /* padding-top: 5px; */\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        padding-bottom: 0;\n        /* margin-bottom: -5px; */\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    background-color: ",
        ";\n    border-radius: ",
        ";\n    position: relative;\n    display: block;\n    overflow: hidden;\n    margin: 20px;\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n    ",
        "\n\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var Panel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bcf2f4ba-0"
})(_templateObject6(), function(props) {
    return props.reversed ? panels/* default.dark */.Z.dark : panels/* default.light */.Z.light;
}, panels/* default.borderRadius */.Z.borderRadius, function(props) {
    return (props === null || props === void 0 ? void 0 : props.scroll) && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), props.height ? "".concat(parseFloat(props.height - 100), "px") : "320px");
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.noPadding) ? (0,styled_components_browser_esm/* css */.iv)(_templateObject1()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.overflow) && (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.hasHeader) && (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.hasFooter) && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
}, index_esm/* layout */.bK, index_esm/* space */.Dh);
var PartStyles = {
    Panel: Panel
};
/* harmony default export */ var Parts_styles = (PartStyles);

;// CONCATENATED MODULE: ./src/mosanic/items/ControlPanel/Parts.js







var Part = Parts_styles;
var DEFAULT_TRIGGER_ICON = "editPencil";
var DEFAULT = "default";
var PanelIcon = function(param) {
    var icon = param.icon, _source = param.source, source = _source === void 0 ? EditIcons/* default */.ZP : _source;
    var iconKey = icon === DEFAULT ? DEFAULT_TRIGGER_ICON : !icon ? null : icon;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
            if (iconKey === key) return value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var ControlPanel = function(_param) /*#__PURE__*/ {
    var children = _param.children, _extraClass = _param.extraClass, extraClass = _extraClass === void 0 ? "" : _extraClass, _bigShadow = _param.bigShadow, bigShadow = _bigShadow === void 0 ? false : _bigShadow, _reversed = _param.reversed, reversed = _reversed === void 0 ? false : _reversed, _overflow = _param.overflow, overflow = _overflow === void 0 ? false : _overflow, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "extraClass",
        "bigShadow",
        "reversed",
        "overflow"
    ]);
    return (0,jsx_runtime.jsx)(Part.Panel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "control__panel ".concat(extraClass, " ").concat(bigShadow ? "-bigShadow" : ""),
        reversed: reversed,
        overflow: overflow
    }, other), {
        children: children
    }));
};
var ControlHeader = function(param) {
    var children = param.children, _title = param.title, title = _title === void 0 ? "" : _title, _extraClass = param.extraClass, extraClass = _extraClass === void 0 ? "" : _extraClass;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelHeader, {
        title: title,
        extraClass: extraClass,
        children: children
    });
};
var PanelHeader = function(param) {
    var children = param.children, _title = param.title, title = _title === void 0 ? "" : _title, _extraClass = param.extraClass, extraClass = _extraClass === void 0 ? "" : _extraClass;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "panel__header ".concat(extraClass),
        children: [
            title,
            children
        ]
    });
};
var PanelTrigger = function(param) {
    var children = param.children, _icon = param.icon, icon = _icon === void 0 ? DEFAULT : _icon, _extraClass = param.extraClass, extraClass = _extraClass === void 0 ? "" : _extraClass, _onClick = param.onClick, onClick = _onClick === void 0 ? null : _onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "panel__trigger ".concat(extraClass),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelIcon, {
                icon: icon
            }),
            children
        ]
    });
};


/***/ }),

/***/ 28932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ControlPanel_Popper; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/jsx/ControlStatements.js
var ControlStatements = __webpack_require__(706);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/mosanic/hooks/useControlPopper.js
var useControlPopper = __webpack_require__(39284);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/useForkRef.js
var useForkRef = __webpack_require__(84501);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/useEventCallback.js
var useEventCallback = __webpack_require__(57817);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/ownerDocument.js
var ownerDocument = __webpack_require__(36855);
;// CONCATENATED MODULE: ../../node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js


 // TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1



function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}

function clickedRootScrollbar(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}

/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click away listener](https://mui.com/base/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base/api/click-away-listener/)
 */
function ClickAwayListener(props) {
  const {
    children,
    disableReactTree = false,
    mouseEvent = 'onClick',
    onClickAway,
    touchEvent = 'onTouchEnd'
  } = props;
  const movedRef = react.useRef(false);
  const nodeRef = react.useRef(null);
  const activatedRef = react.useRef(false);
  const syntheticEventRef = react.useRef(false);
  react.useEffect(() => {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(() => {
      activatedRef.current = true;
    }, 0);
    return () => {
      activatedRef.current = false;
    };
  }, []);
  const handleRef = (0,useForkRef/* default */.Z)( // @ts-expect-error TODO upstream fix
  children.ref, nodeRef); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviors like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  const handleClickAway = (0,useEventCallback/* default */.Z)(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    const doc = (0,ownerDocument/* default */.Z)(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!activatedRef.current || !nodeRef.current || 'clientX' in event && clickedRootScrollbar(event, doc)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    let insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains( // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target) || nodeRef.current.contains( // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target);
    }

    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  const createHandleSynthetic = handlerName => event => {
    syntheticEventRef.current = true;
    const childrenPropsHandler = children.props[handlerName];

    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };

  const childrenProps = {
    ref: handleRef
  };

  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }

  react.useEffect(() => {
    if (touchEvent !== false) {
      const mappedTouchEvent = mapEventPropToEvent(touchEvent);
      const doc = (0,ownerDocument/* default */.Z)(nodeRef.current);

      const handleTouchMove = () => {
        movedRef.current = true;
      };

      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return () => {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, touchEvent]);

  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }

  react.useEffect(() => {
    if (mouseEvent !== false) {
      const mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      const doc = (0,ownerDocument/* default */.Z)(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return () => {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/react.cloneElement(children, childrenProps)
  });
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ var ClickAwayListener_ClickAwayListener = (ClickAwayListener);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(21399);
// EXTERNAL MODULE: ../../node_modules/@popperjs/core/lib/popper.js + 53 modules
var lib_popper = __webpack_require__(66208);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(69075);
// EXTERNAL MODULE: ../../node_modules/@mui/base/Portal/Portal.js
var Portal = __webpack_require__(83820);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js + 1 modules
var generateUtilityClass = __webpack_require__(61069);
// EXTERNAL MODULE: ../../node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(69222);
;// CONCATENATED MODULE: ../../node_modules/@mui/base/PopperUnstyled/popperUnstyledClasses.js


function getPopperUnstyledUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiPopperUnstyled', slot);
}
const popperUnstyledClasses = (0,generateUtilityClasses/* default */.Z)('MuiPopperUnstyled', ['root']);
/* harmony default export */ var PopperUnstyled_popperUnstyledClasses = ((/* unused pure expression or super */ null && (popperUnstyledClasses)));
// EXTERNAL MODULE: ../../node_modules/@mui/base/utils/useSlotProps.js + 4 modules
var useSlotProps = __webpack_require__(70586);
;// CONCATENATED MODULE: ../../node_modules/@mui/base/PopperUnstyled/PopperUnstyled.js


const _excluded = ["anchorEl", "children", "component", "components", "componentsProps", "direction", "disablePortal", "modifiers", "open", "ownerState", "placement", "popperOptions", "popperRef", "TransitionProps"],
      _excluded2 = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"];










function flipPlacement(placement, direction) {
  if (direction === 'ltr') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

const useUtilityClasses = () => {
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getPopperUnstyledUtilityClass, {});
};

const defaultPopperOptions = {};
/* eslint-disable react/prop-types */

const PopperTooltip = /*#__PURE__*/react.forwardRef(function PopperTooltip(props, ref) {
  var _ref;

  const {
    anchorEl,
    children,
    component,
    components = {},
    componentsProps = {},
    direction,
    disablePortal,
    modifiers,
    open,
    ownerState,
    placement: initialPlacement,
    popperOptions,
    popperRef: popperRefProp,
    TransitionProps
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const tooltipRef = react.useRef(null);
  const ownRef = (0,useForkRef/* default */.Z)(tooltipRef, ref);
  const popperRef = react.useRef(null);
  const handlePopperRef = (0,useForkRef/* default */.Z)(popperRef, popperRefProp);
  const handlePopperRefRef = react.useRef(handlePopperRef);
  (0,useEnhancedEffect/* default */.Z)(() => {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  react.useImperativeHandle(popperRefProp, () => popperRef.current, []);
  const rtlPlacement = flipPlacement(initialPlacement, direction);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */

  const [placement, setPlacement] = react.useState(rtlPlacement);
  react.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.forceUpdate();
    }
  });
  (0,useEnhancedEffect/* default */.Z)(() => {
    if (!anchorEl || !open) {
      return undefined;
    }

    const handlePopperUpdate = data => {
      setPlacement(data.placement);
    };

    const resolvedAnchorEl = resolveAnchorEl(anchorEl);

    if (false) {}

    let popperModifiers = [{
      name: 'preventOverflow',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'flip',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'onUpdate',
      enabled: true,
      phase: 'afterWrite',
      fn: ({
        state
      }) => {
        handlePopperUpdate(state);
      }
    }];

    if (modifiers != null) {
      popperModifiers = popperModifiers.concat(modifiers);
    }

    if (popperOptions && popperOptions.modifiers != null) {
      popperModifiers = popperModifiers.concat(popperOptions.modifiers);
    }

    const popper = (0,lib_popper/* createPopper */.fi)(resolveAnchorEl(anchorEl), tooltipRef.current, (0,esm_extends/* default */.Z)({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: popperModifiers
    }));
    handlePopperRefRef.current(popper);
    return () => {
      popper.destroy();
      handlePopperRefRef.current(null);
    };
  }, [anchorEl, disablePortal, modifiers, open, popperOptions, rtlPlacement]);
  const childProps = {
    placement
  };

  if (TransitionProps !== null) {
    childProps.TransitionProps = TransitionProps;
  }

  const classes = useUtilityClasses();
  const Root = (_ref = component != null ? component : components.Root) != null ? _ref : 'div';
  const rootProps = (0,useSlotProps/* default */.Z)({
    elementType: Root,
    externalSlotProps: componentsProps.root,
    externalForwardedProps: other,
    additionalProps: {
      role: 'tooltip',
      ref: ownRef
    },
    ownerState: (0,esm_extends/* default */.Z)({}, props, ownerState),
    className: classes.root
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Root, (0,esm_extends/* default */.Z)({}, rootProps, {
    children: typeof children === 'function' ? children(childProps) : children
  }));
});
/* eslint-enable react/prop-types */

/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 */

const PopperUnstyled = /*#__PURE__*/react.forwardRef(function PopperUnstyled(props, ref) {
  const {
    anchorEl,
    children,
    container: containerProp,
    direction = 'ltr',
    disablePortal = false,
    keepMounted = false,
    modifiers,
    open,
    placement = 'bottom',
    popperOptions = defaultPopperOptions,
    popperRef,
    style,
    transition = false
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

  const [exited, setExited] = react.useState(true);

  const handleEnter = () => {
    setExited(false);
  };

  const handleExited = () => {
    setExited(true);
  };

  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  const container = containerProp || (anchorEl ? (0,ownerDocument/* default */.Z)(resolveAnchorEl(anchorEl)).body : undefined);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Portal/* default */.Z, {
    disablePortal: disablePortal,
    container: container,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(PopperTooltip, (0,esm_extends/* default */.Z)({
      anchorEl: anchorEl,
      direction: direction,
      disablePortal: disablePortal,
      modifiers: modifiers,
      ref: ref,
      open: transition ? !exited : open,
      placement: placement,
      popperOptions: popperOptions,
      popperRef: popperRef
    }, other, {
      style: (0,esm_extends/* default */.Z)({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: 'fixed',
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: !open && keepMounted && (!transition || exited) ? 'none' : null
      }, style),
      TransitionProps: transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
      } : null,
      children: children
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var PopperUnstyled_PopperUnstyled = (PopperUnstyled);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/useThemeWithoutDefault.js + 2 modules
var useThemeWithoutDefault = __webpack_require__(10123);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js + 17 modules
var styled = __webpack_require__(60414);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useThemeProps.js + 3 modules
var useThemeProps = __webpack_require__(95285);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Popper/Popper.js








const PopperRoot = (0,styled/* default */.ZP)(PopperUnstyled_PopperUnstyled, {
  name: 'MuiPopper',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menus](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */

const Popper = /*#__PURE__*/react.forwardRef(function Popper(inProps, ref) {
  const theme = (0,useThemeWithoutDefault/* default */.Z)();
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiPopper'
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PopperRoot, (0,esm_extends/* default */.Z)({
    direction: theme == null ? void 0 : theme.direction
  }, props, {
    ref: ref
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Popper_Popper = (Popper);
// EXTERNAL MODULE: ./src/utils/Num.js
var Num = __webpack_require__(3121);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Parts.js + 1 modules
var Parts = __webpack_require__(39171);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/utils/Event.js
var Event = __webpack_require__(33434);
;// CONCATENATED MODULE: ./src/mosanic/items/ControlPanel/Popper.js




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  background: #ffffff;\n  padding: 5px;\n  right: 0;\n  left: 0px;\n  /* position: fixed; */\n  width: 100%;\n  margin-bottom: 0px;\n  height: 45px;\n  display: flex;\n  align-content: center;\n  justify-content: space-between;\n  :is(h1, h2, h3, h4, h5) {\n    margin-bottom: 0px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  border-bottom: 1px solid ",
        ";\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  border-top: 1px solid ",
        ";\n  ",
        "\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n  right: 25px;\n  padding-top: 10px;\n  position: relative;\n  /* bottom: -5px; */\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  height: ",
        ";\n  overflow: auto;\n  /* bottom: -5px; */\n  position: relative;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






// const ClickAwayListener = dynamic(() => import('@mui/material/ClickAwayListener') )
// const Popper = dynamic(() => import('@mui/material/Popper') )







var Trigger = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-d70e3b63-0"
})(_templateObject());
var PopperContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d70e3b63-1"
})(_templateObject1());
var Spacing = (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d70e3b63-2"
})(_templateObject3(), colors/* default.util.gray.light */.ZP.util.gray.light, Spacing);
var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d70e3b63-3"
})(_templateObject4(), colors/* default.util.gray.light */.ZP.util.gray.light, Spacing);
var ScrollContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d70e3b63-4"
})(_templateObject5(), function(props) {
    return props.height ? (props.hasHeaders ? parseFloat(props.height) - 100 : parseFloat(props.height)) + "px" : "200px";
});
var isSameTarget = function(anchor, event) {
    return (anchor === null || anchor === void 0 ? void 0 : anchor.current) && (anchor === null || anchor === void 0 ? void 0 : anchor.current.contains(event.target));
};
var getMaxIndex = function(maxIndex) {
    return (0,Num/* isNumber */.hj)(maxIndex) ? {
        zIndex: maxIndex
    } : !maxIndex ? {
        zIndex: 55
    } : {
        zIndex: 9999
    };
};
//Control automatic
var ControlPopper = function(_param) {
    var _anchor = _param.anchor, anchor = _anchor === void 0 ? null : _anchor, _close = _param.close, close = _close === void 0 ? function() {
        return null;
    } : _close, _customClass = _param.customClass, customClass = _customClass === void 0 ? "" : _customClass, _bigShadow = _param.bigShadow, bigShadow = _bigShadow === void 0 ? false : _bigShadow, _maxIndex = _param.maxIndex, maxIndex = _maxIndex === void 0 ? false : _maxIndex, _disablePortal = _param.disablePortal, disablePortal = _disablePortal === void 0 ? false : _disablePortal, _placement = _param.placement, placement = _placement === void 0 ? "bottom" : _placement, _trigger = _param.trigger, trigger = _trigger === void 0 ? null : _trigger, _reversed = _param.reversed, reversed = _reversed === void 0 ? false : _reversed, _hover = _param.hover, hover = _hover === void 0 ? false : _hover, _clickStick = _param.clickStick, clickStick = _clickStick === void 0 ? false : _clickStick, _header = _param.header, header = _header === void 0 ? null : _header, _footer = _param.footer, footer = _footer === void 0 ? null : _footer, _scroll = _param.scroll, scroll = _scroll === void 0 ? false : _scroll, _overflow = _param.overflow, overflow = _overflow === void 0 ? null : _overflow, _contextOnly = _param.contextOnly, contextOnly = _contextOnly === void 0 ? false : _contextOnly, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "anchor",
        "close",
        "customClass",
        "bigShadow",
        "maxIndex",
        "disablePortal",
        "placement",
        "trigger",
        "reversed",
        "hover",
        "clickStick",
        "header",
        "footer",
        "scroll",
        "overflow",
        "contextOnly",
        "children"
    ]);
    var handler = (0,useControlPopper/* useControlPopper */.Z)();
    var open = function(event) {
        return handler.open(event);
    };
    if (trigger) {
        anchor = handler.anchor;
        close = function(event) {
            return handler.close(event);
        };
    }
    var canBeOpenZoom = Boolean(anchor);
    var handleCloseZoom = (0,react.useCallback)(function(event) {
        if (isSameTarget(anchor, event)) return;
        if (close) close();
    }, [
        anchor,
        close
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlStatements.If, {
                condition: Boolean(trigger),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    onContextMenu: function(e) {
                        if (!contextOnly) return;
                        (0,Event/* prevent */.X$)(e);
                        open(e);
                    },
                    onMouseEnter: function(e) {
                        return hover ? open(e) : null;
                    },
                    onMouseLeave: function(e) {
                        return hover ? close(e) : null;
                    },
                    onClick: function(e) {
                        (0,Event/* prevent */.X$)(e);
                        if (contextOnly) return;
                        anchor ? close() : open(e);
                    },
                    style: {
                        cursor: "pointer"
                    },
                    className: "triggerPopper",
                    children: trigger
                }, "trigger")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popper_Popper, {
                open: canBeOpenZoom,
                id: "controlPopper",
                anchorEl: anchor,
                disablePortal: disablePortal,
                placement: placement,
                // transition 
                style: (0,_object_spread/* default */.Z)({}, getMaxIndex(maxIndex)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener_ClickAwayListener, {
                        onClickAway: handleCloseZoom,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Parts/* ControlPanel */.qG, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                extraClass: customClass,
                                bigShadow: bigShadow,
                                reversed: reversed,
                                h: true,
                                asHeader: header,
                                hasFooter: footer,
                                overflow: overflow
                            }, other), {
                                children: [
                                    header && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                        children: header
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
                                        when: scroll,
                                        wrapper: function(children) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ScrollContainer, {
                                                hasHeaders: header && footer,
                                                height: other === null || other === void 0 ? void 0 : other.height,
                                                children: children
                                            });
                                        },
                                        children: children
                                    }),
                                    header && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                                        children: footer
                                    })
                                ]
                            }))
                        })
                    })
                })
            }, "ControlPopper")
        ]
    });
};
/* harmony default export */ var ControlPanel_Popper = (ControlPopper);


/***/ }),

/***/ 83482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ErrorAlert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var ErrorAlert = function(param) {
    var errorMessage = param.errorMessage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: "soo-alert -error",
        role: "alert",
        children: errorMessage
    });
};


/***/ }),

/***/ 56957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ items_Expander; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-slidedown/lib/slidedown.js
var slidedown = __webpack_require__(76631);
;// CONCATENATED MODULE: ./src/mosanic/items/Expander/Expander.js





// import useCollapse from "react-collapsed";
// import {UnmountClosed, Collapse } from 'react-collapse';
// import Collapse from 'rc-collapse';

var Expander = function(_param) {
    var children = _param.children, _expanded = _param.expanded, expanded = _expanded === void 0 ? false : _expanded, _trigger = _param.trigger, trigger = _trigger === void 0 ? null : _trigger, _timeout = _param.timeout, timeout = _timeout === void 0 ? 400 : _timeout, _direction = _param.direction, direction = _direction === void 0 ? null : _direction, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "expanded",
        "trigger",
        "timeout",
        "direction",
        "fullWidth"
    ]);
    var ref = (0,react.useState)(expanded), isExpanded = ref[0], setExpanded = ref[1];
    // const { getCollapseProps, getToggleProps } = useCollapse({ 
    //     isExpanded
    // })
    (0,react.useEffect)(function() {
        setExpanded(expanded);
    }, [
        expanded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            trigger ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: isExpanded ? "expanded" : "closed",
                style: {
                    width: fullWidth ? "100%" : "auto"
                },
                onClick: function() {
                    return setExpanded(function(prevExpanded) {
                        return !prevExpanded;
                    });
                },
                children: trigger
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Expandable, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
                expanded: isExpanded,
                timeout: timeout,
                direction: direction,
                children: children
            }))
        ]
    });
};
var Expandable = function(_param) /*#__PURE__*/ {
    var children = _param.children, expanded = _param.expanded, timeout = _param.timeout, direction = _param.direction, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "expanded",
        "timeout",
        "direction"
    ]);
    return (0,jsx_runtime.jsx)(slidedown/* SlideDown */.sJ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "div",
        closed: !expanded,
        transitionOnAppear: true
    }, other), {
        children: children
    }));
};
/* harmony default export */ var Expander_Expander = (Expander);

;// CONCATENATED MODULE: ./src/mosanic/items/Expander/index.js

/* harmony default export */ var items_Expander = (Expander_Expander);


/***/ }),

/***/ 98900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ ScaledFrame; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2921);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26021);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        border: 1px solid ",
        ";\n        border-radius: 10px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        box-shadow: 4px 4px 25px 0 ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 143%;\n    /* width: 130% */\n    zoom: ",
        ";\n    transform: scale(",
        ");\n    transform-origin: 0 0;\n    margin-bottom: -100%; \n    /* -20% */\n\n    ",
        "\n    ",
        "\n    \n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ScaledFrame = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e019ea87-0"
})(_templateObject2(), function(props) {
    return props.scale ? props.scale : 0.7;
}, function(props) {
    return props.scale ? props.scale : 0.7;
}, function(props) {
    return props.border && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.gray.light */ .ZP.util.gray.light);
}, function(props) {
    return props.float && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.gray.light */ .ZP.util.gray.light);
});



/***/ }),

/***/ 47726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Separator */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2921);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26021);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78545);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    border-top: 1px solid ",
        ";\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledSeparator = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
    componentId: "sc-c269dee3-0"
})(_templateObject(), function(props) {
    return _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].util.gray */ .ZP.util.gray[props.tint];
}, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .layout */ .bK);
var Hr = function(_param) /*#__PURE__*/ {
    var _tint = _param.tint, tint = _tint === void 0 ? "light" : _tint, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "tint"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSeparator, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        tint: tint
    }, other));
};
var Separator = (/* unused pure expression or super */ null && (Hr));

/* harmony default export */ __webpack_exports__["C"] = (Hr);


/***/ }),

/***/ 99057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a_": function() { return /* binding */ Inputs_InlineGroup; },
  "BZ": function() { return /* binding */ InputGroup; },
  "Xv": function() { return /* binding */ InputGroupDivider; },
  "G7": function() { return /* binding */ InputGroupHeader; },
  "oV": function() { return /* binding */ InputGroupItem; },
  "zo": function() { return /* binding */ RenderInputGroup; },
  "Vw": function() { return /* binding */ WrapInput; }
});

// UNUSED EXPORTS: IconLabel

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/mosanic/styles/flex.styles.js
var flex_styles = __webpack_require__(5441);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(78545);
;// CONCATENATED MODULE: ./src/mosanic/items/Inputs.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        margin-top: 0;\n        padding-top: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: ",
        ";\n\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    ",
        "\n    font-size: 12px;\n    margin: 5px 0 10px;\n    font-weight: 600;\n\n    ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        width: 100%!important;\n\n        textarea {\n            width: 100%;\n        }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        border-bottom: 1px solid #e7e9ed;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin: ",
        " 0 0 0;\n    width: 50%;\n    ",
        "\n    ",
        "\n\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin: ",
        " 0 0px;\n    width: 100%;\n    border-top: 1px solid #e7e9ed;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    width: ",
        "!important;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        width: 100%;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        ",
        " {\n            width: 48% ;\n        }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        ",
        " {\n            margin: 0!important;\n            padding: ",
        " 5px 25px;\n        }\n\n        ",
        " {\n            margin: ",
        " 0 -25px;\n        }\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        .stateIndicator {\n            top: calc(25% - 2px);\n            left: -5px;\n            transform: scale(0.9)\n        }\n        ",
        " {\n            width: 22.5% ;\n            margin: 20px 2.5% 0 0;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n            label {\n                padding-top: 2px;\n                font-size: 10px;\n            }\n        }\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n\n        ",
        " {\n            width: 33.33% ;\n            margin: 20px 0 0 0;\n\n            &:last-child {\n                /* margin-bottom: 0; */\n                margin-right: auto;\n            }\n        }\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        /* display: block; */\n        ",
        " {\n            width: 100% ;\n            margin: 20px 0 0 0;\n\n            /* &:last-child {\n                margin-bottom: 0; */\n            }\n        }\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        > ",
        ":not(.-full) {\n            ",
        "\n        }\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        svg {\n           transform: rotate(-45deg) scale(1.2) !important;\n        }\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        display: flex; \n        flex-wrap: wrap;\n        align-items: center;\n        ",
        ", * {\n            margin-left: auto;\n            margin-right: auto;\n        }\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        border: 2px solid ",
        ";\n        margin-top: 25px;\n        border-radius: 5px;\n        padding: 10px 15px;\n        /* ",
        ":first-child {\n            margin-top: 0;\n        } */\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    \n    ",
        "\n    ",
        " {\n        width: 48%;\n    }\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n\n    ",
        "\n    ",
        "\n    ",
        "\n\n    ",
        "\n\n    .inputGroup {\n        margin: 10px 0;\n        width: 100%;\n        ",
        ":last-child {\n            margin-left: auto;\n            margin-right: 0;\n        }\n    }\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    position: absolute;\n    top: 5px;\n    right: -15%;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    font-size: 12px;\n    font-weight: bold;\n    position: absolute;\n    top: -10px;\n\n    /* &::after {\n        background: #F9FBFC;\n        display: block;\n        position: absolute;\n        z-index: -1;\n        left: 0;\n        right:0;\n        top: 0;\n        bottom: 0;\n        content: ' ';\n    } */\n\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: ",
        ";\n    align-items: ",
        ";\n\n\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}



var OFFSET_TOP = "15px";
var ActiveStyle = function(active) {
    var fixMargin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return active && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), colors/* default.util.gray.lightest */.ZP.util.gray.lightest, fixMargin && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), OFFSET_TOP));
};
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1aa8cd13-0"
})(_templateObject2(), flex_styles/* SpaceBetween */.i9, function(props) {
    return ActiveStyle(props.active);
});
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1aa8cd13-1"
})(_templateObject5(), OFFSET_TOP, function(props) {
    return ActiveStyle(props.active, true);
}, function(props) {
    return props.customStyle;
}, function(props) {
    return props.fullWidth && (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
}, function(props) {
    return props.divider && (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
}, index_esm/* space */.Dh, index_esm/* layout */.bK);
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1aa8cd13-2"
})(_templateObject6(), OFFSET_TOP);
var childWidth = {
    "4": "22.5%",
    "3": "32.3%",
    "2": "48%",
    "1": "100%"
};
var getChildWidth = function(props) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), function(props) {
        return childWidth === null || childWidth === void 0 ? void 0 : childWidth[props.cols];
    });
};
var Group = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1aa8cd13-3"
})(_templateObject18(), function(props) {
    return props.fullWidth && (0,styled_components_browser_esm/* css */.iv)(_templateObject8());
}, Item, function(props) {
    return (props.inline === "two" || props.cols === 2) && (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), Item);
}, function(props) {
    return props.breath && (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), Item, OFFSET_TOP, Divider, OFFSET_TOP);
}, function(props) {
    return (props.inline === "four" || props.cols === 4) && (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), Item);
}, function(props) {
    return (props.inline === "three" || props.cols === 3) && (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), Item);
}, function(props) {
    return (props.inline === "one" || props.cols === 1) && (0,styled_components_browser_esm/* css */.iv)(_templateObject13(), Item);
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.cols) && (0,styled_components_browser_esm/* css */.iv)(_templateObject14(), Item, getChildWidth(props));
}, function(props) {
    return props.extra === "corners" && (0,styled_components_browser_esm/* css */.iv)(_templateObject15());
}, function(props) {
    return props.center && (0,styled_components_browser_esm/* css */.iv)(_templateObject16(), Item);
}, function(props) {
    return props.border && (0,styled_components_browser_esm/* css */.iv)(_templateObject17(), colors/* default.util.gray.light */.ZP.util.gray.light, Item);
}, Item, index_esm/* layout */.bK, index_esm/* space */.Dh);
var End = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1aa8cd13-4"
})(_templateObject19());
var Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-1aa8cd13-5"
})(_templateObject20());
var InlineGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1aa8cd13-6"
})(_templateObject21(), function(props) {
    return props.justify;
}, function(props) {
    return props.align;
}, index_esm/* layout */.bK, index_esm/* space */.Dh);
var InputStyles = {
    InlineGroup: InlineGroup,
    Label: Label,
    Header: Header,
    Item: Item,
    Divider: Divider,
    Group: Group,
    End: End
};
/* harmony default export */ var Inputs_styles = (InputStyles);

;// CONCATENATED MODULE: ./src/mosanic/items/Inputs.js








var Input = Inputs_styles;
var InputGroupDivider = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input.Divider, {
        className: "inputGroup__divider"
    });
};
var Inputs_InlineGroup = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Input.InlineGroup, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};
var InputGroupHeader = function(param) {
    var children = param.children, _extraClass = param.extraClass, extraClass = _extraClass === void 0 ? "" : _extraClass, _active = param.active, active = _active === void 0 ? false : _active, _divider = param.divider, divider = _divider === void 0 ? false : _divider;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input.Header, {
        className: "inputGroup__header ".concat(extraClass),
        divider: divider,
        active: active,
        children: children
    });
};
var InputGroupItem = function(_param) /*#__PURE__*/ {
    var children = _param.children, _extraClass = _param.extraClass, extraClass = _extraClass === void 0 ? "" : _extraClass, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _active = _param.active, active = _active === void 0 ? false : _active, _customStyle = _param.customStyle, customStyle = _customStyle === void 0 ? null : _customStyle, _endAdornment = _param.endAdornment, endAdornment = _endAdornment === void 0 ? null : _endAdornment, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "extraClass",
        "fullWidth",
        "active",
        "customStyle",
        "endAdornment"
    ]);
    return (0,jsx_runtime.jsxs)(Input.Item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,Text/* oneLineString */.r6)("\n            inputGroup__item \n            ".concat(extraClass, "\n            ").concat(fullWidth ? "-full" : "", "\n        ")),
        active: active,
        customStyle: customStyle,
        fullWidth: fullWidth
    }, other), {
        children: [
            children,
            endAdornment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input.End, {
                children: endAdornment
            })
        ]
    }));
};
/** 
 * Wrapper for input groups
 */ var InputGroup = function(_param) /*#__PURE__*/ {
    var children = _param.children, _extraClass = _param.extraClass, extraClass = _extraClass === void 0 ? "" : _extraClass, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _inset = _param.inset, inset = _inset === void 0 ? false : _inset, _style = _param.style, style = _style === void 0 ? {} : _style, _cols = _param.cols, cols = _cols === void 0 ? 2 : _cols, _label = _param.label, label = _label === void 0 ? null : _label, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "extraClass",
        "fullWidth",
        "inset",
        "style",
        "cols",
        "label"
    ]);
    return (0,jsx_runtime.jsxs)(Input.Group, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        style: style
    }, other), {
        cols: cols,
        fullWidth: fullWidth,
        className: (0,Text/* oneLineString */.r6)("\n        inputGroup \n        ".concat(extraClass, " \n        ").concat(fullWidth ? "-full" : "", " \n        ").concat(inset ? "-inset" : "", "\n    ")),
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input.Label, {
                children: label
            }),
            children
        ]
    }));
};
var RenderInputGroup = function(param) {
    var items = param.items;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(InputGroup, {
        children: items.map(function(item) {
            /*#__PURE__*/ return (0,react.createElement)(InputGroupItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item === null || item === void 0 ? void 0 : item.wrapper), {
                key: item === null || item === void 0 ? void 0 : item.key
            }), item.render);
        })
    });
};
var WrapInput = function(param) {
    var children = param.children, _wrap = param.wrap, wrap = _wrap === void 0 ? false : _wrap, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: wrap,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroupItem, {
                fullWidth: fullWidth,
                children: children
            });
        },
        children: children
    });
};
var IconLabel = function(param) {
    var icon = param.icon, txt = param.txt;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            icon,
            " \xa0 ",
            txt
        ]
    });
};



/***/ }),

/***/ 44041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ Link; },
  "Z": function() { return /* binding */ Link_Link; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(78545);
;// CONCATENATED MODULE: ./src/mosanic/items/Link/Link.style.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    transition: color ease-in-out 0.1s;\n    cursor: pointer;\n    color: #212121;\n    height: fit-content;\n    text-decoration: none;\n    width: fit-content;\n    /* font-weight: 900; */\n\n    :visited,\n    :hover,\n    :active {\n        /* color: inherit; */\n        cursor: pointer;\n    }\n\n    &:hover {\n        color: ",
        ";\n\n        a {\n            color: #212121;\n\n            &:hover {\n                color: ",
        ";\n            }\n        }\n    }\n\n    > * {\n        /* color: inherit; */\n        &:hover {\n            color: ",
        ";\n        }\n    }\n    /* > :is(h1, h2, h3, h4, h5, h6) {\n        &:hover {\n            color: ",
        "!important;\n        }\n    } */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var a = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-ccb571c6-0"
})(_templateObject(), index_esm/* space */.Dh, index_esm/* layout */.bK, index_esm/* color */.$_, index_esm/* flexbox */.GQ, colors/* default.util.primary.base */.ZP.util.primary.base, colors/* default.util.primary.base */.ZP.util.primary.base, colors/* default.util.primary.base */.ZP.util.primary.base, colors/* default.util.primary.base */.ZP.util.primary.base);
var LinkStyles = {
    a: a
};
/* harmony default export */ var Link_style = (LinkStyles);

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/mosanic/items/Link/Link.tsx






var Link = function(_param) /*#__PURE__*/ {
    var href = _param.href, _passHref = _param.passHref, passHref = _passHref === void 0 ? true : _passHref, target = _param.target, children = _param.children, _action = _param.action, action = _action === void 0 ? null : _action, other = (0,_object_without_properties/* default */.Z)(_param, [
        "href",
        "passHref",
        "target",
        "children",
        "action"
    ]);
    return (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: passHref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_style.a, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            href: href,
            target: target,
            onClick: action
        }, other), {
            children: children
        }))
    });
};
/* harmony default export */ var Link_Link = (Link);


/***/ }),

/***/ 8152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44041);


/* harmony default export */ __webpack_exports__["ZP"] = (_Link__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);



/***/ }),

/***/ 62035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aV": function() { return /* binding */ List_List; },
  "Rx": function() { return /* binding */ List_ListDivider; },
  "HC": function() { return /* binding */ List_ListItem; },
  "no": function() { return /* binding */ ListItemChevron; },
  "Ek": function() { return /* binding */ List_ListItemContent; },
  "Q$": function() { return /* binding */ List_ListItemIcon; },
  "zK": function() { return /* binding */ List_ListItemRight; },
  "oZ": function() { return /* binding */ List_ListItemSub; },
  "F_": function() { return /* binding */ List_ListItemText; },
  "xL": function() { return /* binding */ ListItems; },
  "wp": function() { return /* binding */ RenderList; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/utils/Arr.js
var Arr = __webpack_require__(72393);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/items/Link/Link.tsx + 1 modules
var Link = __webpack_require__(44041);
;// CONCATENATED MODULE: ./src/mosanic/items/Link/RenderLink.js


var isLink = function(item) {
    return ((item === null || item === void 0 ? void 0 : item.label) || (item === null || item === void 0 ? void 0 : item.icon)) && (item === null || item === void 0 ? void 0 : item.href);
};
var RenderLink = function(param) {
    var item = param.item;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Link/* Link */.r, {
        href: item === null || item === void 0 ? void 0 : item.href,
        onClick: item === null || item === void 0 ? void 0 : item.handler,
        children: [
            item === null || item === void 0 ? void 0 : item.icon,
            item === null || item === void 0 ? void 0 : item.label
        ]
    });
};

// EXTERNAL MODULE: ./src/mosanic/items/Skeletons/Skeletons.js + 1 modules
var Skeletons = __webpack_require__(86443);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(78545);
;// CONCATENATED MODULE: ./src/mosanic/items/List/List.style.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        color: ",
        ";\n        background: ",
        ";\n\n        ",
        ", a {\n            color: ",
        ";\n        }\n        ",
        "{\n            font-weight: 600;\n        }\n\n        ul > li {\n            ",
        ", a {\n                color: #212121;\n            }\n            ",
        "{\n                font-weight: inherit;\n            }\n        }\n\n        svg path {\n            fill:  ",
        ";\n            transform: scale(1.1);\n            transform-origin: center center;\n        }\n        &:hover {\n            svg path {\n                transform: scale(0.9);\n            }\n        }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        border-left: 2px solid ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        opacity: 0.5!important;\n        background: none;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 100% !important;\n        min-width: 100px !important;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        * {\n            display: inline-block;\n        }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        width: 100%;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        padding: 0 7px;\n\n        svg {\n            transform: scale(0.5)!important;\n        }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        svg {\n            transform: scale(0.7)!important;\n            margin-right: 5px;\n        }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        font-size: 12px;\n        font-weight: 400;\n        background: ",
        ";\n        margin: 0 -5px;\n        width: calc(100% + 10px);\n        border-bottom: 2px solid ",
        " !important;\n        /* padding: 5px 0; */\n        &:hover {\n            background: ",
        ";\n        }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    list-style-type: none;\n    padding: 5px 10px;\n    transition: all ease-in-out 0.2s;\n    cursor: pointer;\n    font-size: 12px;\n\n    a {\n        color: #212121;\n        font-size: 13px;\n        line-height: 30px;\n        -webkit-font-smoothing: antialiased;\n\n        svg {\n            margin-top: -2px;\n            /* margin-right: 8px; */\n            transform: scale(0.8);\n            transition: all ease-in-out 0.2s;\n            path {\n                transition: all ease-in-out 0.3s;\n            }\n        }\n    }\n\n    &:hover {\n        background: ",
        ";\n\n        a {\n            color: ",
        ";\n\n            svg path {\n                fill:  ",
        ";\n            }\n        }\n        svg {\n            transform: scale(0.85);\n            transform-origin: center center;\n            \n            path {\n                fill:  ",
        ";\n            }\n        }\n    }\n    \n    ",
        "\n\n    ",
        "\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n    ",
        "\n    ",
        "\n    position: relative;\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    transition: all ease-in-out 0.2s;\n    position: absolute;\n    right: 5px;\n    top: calc(50% - 10px);\n    &:hover {\n        transform: scale(1.2);\n        svg path {\n            fill: ",
        ";\n        }\n    }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    border-bottom: #e7e9ed 1px solid;\n    padding: 0!important;\n    margin: 5px 0;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin-left: 28px;\n    padding-bottom: 5px;\n    font-size: 12px;\n    line-height: 18px;\n    color: ",
        " !important;\n    &:hover {\n        color: ",
        " !important;\n    }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin-left: 10px;\n    font-size: 12px;\n\n    color: #212121;\n    font-size: 13px;\n    line-height: 30px;\n    -webkit-font-smoothing: antialiased;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin: 2px 4px 0px 0;\n    width: 25px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    font-family: ",
        ";\n    color: ",
        ";\n    font-size: 12px;\n    float: right;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        \n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        padding: 0 5px 0 0;\n        ",
        " {\n            padding: 5px 4px;\n        }\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        display: block;\n        padding: 0 0 0 0;\n        ",
        " {\n            padding: 5px 2px;\n            font-size: 11px;\n            width: 100%;\n            min-width: 100%;\n            display: flex;\n\n            &::after {\n                clear: both;\n                display: block;\n                content: '';\n            }\n        }\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    padding: 0 15px 0 0;\n\n    ",
        "\n\n    ",
        "\n    ",
        "\n\n    ul > ",
        " {\n        /* margin-left: 15px!important; */\n        &:hover {\n            background: ",
        ";\n        }\n    }\n\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}




var ListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-935df2d7-0"
})(_templateObject9(), colors/* default.util.gray.lighter */.ZP.util.gray.lighter, colors/* default.util.primary.base */.ZP.util.primary.base, colors/* default.util.primary.base */.ZP.util.primary.base, colors/* default.util.gray.darker */.ZP.util.gray.darker, function(props) {
    return props.active && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), colors/* default.util.primary.base */.ZP.util.primary.base, colors/* default.util.gray.lighter */.ZP.util.gray.lighter, ListItemText, colors/* default.util.primary.base */.ZP.util.primary.base, ListItemText, ListItemText, ListItemText, colors/* default.util.primary.base */.ZP.util.primary.base);
}, function(props) {
    return props.borderLeft && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), colors/* default.util.primary.base */.ZP.util.primary.base);
}, function(props) {
    return props.disabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
}, function(props) {
    return props.fullWidth && (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
}, function(props) {
    return props.inline ? (0,styled_components_browser_esm/* css */.iv)(_templateObject4()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
}, function(props) {
    return props.size === "small" && (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
}, function(props) {
    return props.icons === "large" && (0,styled_components_browser_esm/* css */.iv)(_templateObject7());
}, function(props) {
    return props.title && (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), colors/* default.util.gray.light */.ZP.util.gray.light, colors/* default.util.gray.light */.ZP.util.gray.light, colors/* default.util.gray.light */.ZP.util.gray.light);
}, index_esm/* layout */.bK, index_esm/* space */.Dh);
var ListItemContent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-935df2d7-1"
})(_templateObject10());
var Chevron = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-935df2d7-2"
})(_templateObject11(), colors/* default.util.primary.base */.ZP.util.primary.base);
var ListDivider = (0,styled_components_browser_esm/* default */.ZP)(ListItem).withConfig({
    componentId: "sc-935df2d7-3"
})(_templateObject12());
var ListItemSub = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-935df2d7-4"
})(_templateObject13(), colors/* default.util.gray.base */.ZP.util.gray.base, colors/* default.util.gray.base */.ZP.util.gray.base);
var ListItemText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-935df2d7-5"
})(_templateObject14());
var ListItemIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-935df2d7-6"
})(_templateObject15());
var ListItemRight = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-935df2d7-7"
})(_templateObject16(), function(props) {
    return props.code && "'Courier New', monospace";
}, colors/* default.util.gray.base */.ZP.util.gray.base);
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-935df2d7-8"
})(_templateObject20(), function(props) {
    return props.sub && (0,styled_components_browser_esm/* css */.iv)(_templateObject17());
}, function(props) {
    return props.compact && (0,styled_components_browser_esm/* css */.iv)(_templateObject18(), ListItem);
}, function(props) {
    return props.min && (0,styled_components_browser_esm/* css */.iv)(_templateObject19(), ListItem);
}, ListItem, (0,polished_esm/* darken */._j)(0.02, colors/* default.util.gray.lighter */.ZP.util.gray.lighter), index_esm/* layout */.bK, index_esm/* space */.Dh);
var ListStyles = {
    List: List,
    ListDivider: ListDivider,
    ListItemContent: ListItemContent,
    ListItemIcon: ListItemIcon,
    ListItemRight: ListItemRight,
    ListItemText: ListItemText,
    ListItemSub: ListItemSub,
    ListItem: ListItem,
    Chevron: Chevron
};
/* harmony default export */ var List_style = (ListStyles);

;// CONCATENATED MODULE: ./src/mosanic/items/List/List.js




function List_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        border-bottom: 1px solid #e7e9ed;\n    "
    ]);
    List_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function List_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    position: relative;\n    \n    ",
        "\n"
    ]);
    List_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var List_List = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(List_style.List, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};
var List_ListItem = function(_param) /*#__PURE__*/ {
    var children = _param.children, chevron = _param.chevron, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "chevron"
    ]);
    return (0,jsx_runtime.jsxs)(List_style.ListItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List_style.Chevron, {
                children: chevron
            })
        ]
    }));
};
var List_ListItemContent = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(List_style.ListItemContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};
var List_ListItemText = function(_param) /*#__PURE__*/ {
    var children = _param.children, _text = _param.text, text = _text === void 0 ? null : _text, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "text"
    ]);
    return (0,jsx_runtime.jsx)(List_style.ListItemText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: text ? text : children
    }));
};
var List_ListItemSub = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(List_style.ListItemSub, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};
var List_ListItemIcon = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(List_style.ListItemIcon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};
var List_ListItemRight = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(List_style.ListItemRight, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};
var ListItemChevron = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(List_style.Chevron, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};
var List_ListDivider = function(_param) /*#__PURE__*/ {
    var children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(List_style.ListDivider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};
var RenderList = function(param) {
    var items = param.items, _size = param.size, size = _size === void 0 ? null : _size, _icons = param.icons, icons = _icons === void 0 ? null : _icons;
    return (0,Arr/* canMap */.is)(items) ? items.map(function(item) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(List_ListItem, {
            active: item === null || item === void 0 ? void 0 : item.active,
            size: size,
            icons: icons,
            children: Boolean(item === null || item === void 0 ? void 0 : item.href) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderLink, {
                item: item
            }) : (item === null || item === void 0 ? void 0 : item.handler) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                onClick: item.handler,
                children: [
                    item === null || item === void 0 ? void 0 : item.icon,
                    item === null || item === void 0 ? void 0 : item.label
                ]
            }) : (0,Text/* isString */.HD)(item) ? item : (item === null || item === void 0 ? void 0 : item.label) ? item.label : item
        }, (item === null || item === void 0 ? void 0 : item.href) + (item === null || item === void 0 ? void 0 : item.label) + (item === null || item === void 0 ? void 0 : item.key));
    }) : null;
};
var Item = (0,styled_components_browser_esm/* default */.ZP)(List_ListItem).withConfig({
    componentId: "sc-ead27d39-0"
})(List_templateObject1(), function(props) {
    return props.divider && (0,styled_components_browser_esm/* css */.iv)(List_templateObject());
});
var ListItems = function(param) {
    var items = param.items, active = param.active, handler = param.handler, drag = param.drag, wrap = param.wrap, header = param.header, controls = param.controls, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _divider = param.divider, divider = _divider === void 0 ? false : _divider;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(List_List, {
        style: {
            width: "100%"
        },
        children: [
            (items === null || items === void 0 ? void 0 : items.length) >= 1 ? items === null || items === void 0 ? void 0 : items.map(function(item) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
                    when: Boolean(drag),
                    wrapper: function(children) {
                        return drag(item, children);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        divider: divider,
                        onClick: handler ? function() {
                            return handler(item);
                        } : null,
                        active: active === (item === null || item === void 0 ? void 0 : item._id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalWrapper/* ConditionalWrapper */.M, {
                            when: Boolean(wrap),
                            wrapper: function(children) {
                                return wrap(children);
                            },
                            children: [
                                header ? header(item) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: (item === null || item === void 0 ? void 0 : item.title) ? item.title : item === null || item === void 0 ? void 0 : item.name
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        item === null || item === void 0 ? void 0 : item.description
                                    ]
                                }),
                                controls && controls(item)
                            ]
                        })
                    }, item === null || item === void 0 ? void 0 : item._id)
                });
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                children: "No results."
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                children: wrap ? wrap(/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeletons/* SkeletonLine */.AU, {})) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeletons/* SkeletonLine */.AU, {})
            })
        ]
    });
};


/***/ }),

/***/ 4093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ LoadingDots; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _LoadingDots_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53407);
/* harmony import */ var _LoadingDots_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_LoadingDots_module_css__WEBPACK_IMPORTED_MODULE_1__);


var LoadingDots = function(param) {
    var _color = param.color, color = _color === void 0 ? "#000" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: (_LoadingDots_module_css__WEBPACK_IMPORTED_MODULE_1___default().loading),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                style: {
                    backgroundColor: color
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                style: {
                    backgroundColor: color
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                style: {
                    backgroundColor: color
                }
            })
        ]
    });
};


/***/ }),

/***/ 2775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ items_MenuList; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/items/List/List.js + 2 modules
var List = __webpack_require__(62035);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(77298);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/mosanic/items/Link/index.js
var Link = __webpack_require__(8152);
// EXTERNAL MODULE: ./src/mosanic/items/Tooltip/index.js + 2 modules
var Tooltip = __webpack_require__(94233);
// EXTERNAL MODULE: ./src/mosanic/items/ControlPanel/Popper.js + 4 modules
var Popper = __webpack_require__(28932);
// EXTERNAL MODULE: ./src/mosanic/items/AdvancedLabel.js
var AdvancedLabel = __webpack_require__(51085);
;// CONCATENATED MODULE: ./src/mosanic/items/MenuList/SubMenuItem.js





var SubMenuItem = function(param) {
    var children = param.children, label = param.label, toggleComponent = param.toggleComponent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popper/* default */.Z, {
        trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* ListItem */.HC, {
            size: "small",
            variant: "text",
            children: [
                toggleComponent,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItemRight */.zK, {
                    variant: "body2",
                    color: "text.secondary",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "15",
                        height: "15",
                        viewBox: "0 0 15 15",
                        fill: "none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
                            fill: "black"
                        })
                    })
                })
            ]
        }),
        placement: "right",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedLabel/* AdvancedLabel */.qv, {
                label: label
            }),
            children
        ]
    });
};
/* harmony default export */ var MenuList_SubMenuItem = (SubMenuItem);

// EXTERNAL MODULE: ./src/features/options/reducer.js + 1 modules
var reducer = __webpack_require__(51331);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/mosanic/items/SideBar/SideBar.style.js
var SideBar_style = __webpack_require__(99022);
// EXTERNAL MODULE: ./src/mosanic/items/Expander/index.js + 1 modules
var Expander = __webpack_require__(56957);
;// CONCATENATED MODULE: ./src/mosanic/items/MenuList/MenuList.js

















function MenuList(_param) {
    var menuMap = _param.menuMap, _iconOnly = _param.iconOnly, iconOnly = _iconOnly === void 0 ? false : _iconOnly, _activate = _param.activate, activate = _activate === void 0 ? null : _activate, _active = _param.active, active = _active === void 0 ? "" : _active, _compact = _param.compact, compact = _compact === void 0 ? false : _compact, other = (0,_object_without_properties/* default */.Z)(_param, [
        "menuMap",
        "iconOnly",
        "activate",
        "active",
        "compact"
    ]);
    var ref = (0,react.useState)(null), sub = ref[0], setSub = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.aV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        p: 0,
        compact: compact,
        children: menuMap.map(function(item, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(MenuListItem, {
                name: item.key,
                item: item,
                type: item === null || item === void 0 ? void 0 : item.type,
                iconOnly: iconOnly,
                active: active,
                activate: activate,
                subIsOpen: sub === null || sub === void 0 ? void 0 : sub[item === null || item === void 0 ? void 0 : item.label],
                toggleSub: function(panel) {
                    return setSub((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sub), (0,_define_property/* default */.Z)({}, panel, (sub === null || sub === void 0 ? void 0 : sub[panel]) ? !(sub === null || sub === void 0 ? void 0 : sub[panel]) : true)));
                }
            }, (item === null || item === void 0 ? void 0 : item.key) ? item.key : index);
        })
    }));
};
var ListItemStyle = {
    height: "40px",
    overflow: "hidden",
    whiteSpace: "nowrap"
};
var ListItemStyleHelp = {
    height: "auto",
    whiteSpace: "wrap"
};
var MenuListItem = function(param) {
    var item = param.item, type = param.type, name = param.name, iconOnly = param.iconOnly, active = param.active, activate = param.activate, subIsOpen = param.subIsOpen, toggleSub = param.toggleSub;
    var isActive = function(item) {
        return "/".concat(active === null || active === void 0 ? void 0 : active.page) === (item === null || item === void 0 ? void 0 : item.href) && (item === null || item === void 0 ? void 0 : item.href) || (active === null || active === void 0 ? void 0 : active.page) === "/app" && (item === null || item === void 0 ? void 0 : item.href) === "/" || (active === null || active === void 0 ? void 0 : active.page) === (item === null || item === void 0 ? void 0 : item.value) && (item === null || item === void 0 ? void 0 : item.value) || // (active?.main === item?.value) ||
        ((active === null || active === void 0 ? void 0 : active.sub) === (item === null || item === void 0 ? void 0 : item.value) && (item === null || item === void 0 ? void 0 : item.value)) ? true : false;
    };
    var helpSideBar = (0,es/* useSelector */.v9)(reducer/* sideBarHelpSelector */.iu) || false;
    var action = item.action, toggle = item.toggle, icon = item.icon, label = item.label, map = item.map, value = item.value, href = item.href, sub_menu = item.sub_menu;
    var hasLinkValue = Boolean(href || value);
    var LinkWrapper = function(param) {
        var children = param.children, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
        return hasLinkValue && !disabled ? (item === null || item === void 0 ? void 0 : item.href) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
            href: item.href,
            action: function() {
                return activate(item);
            },
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            onClick: function() {
                return activate(item);
            },
            children: children
        }) : children;
    };
    var hasTooltip = Boolean(iconOnly && !subIsOpen);
    var TooltipWrapper = function(param) {
        var children = param.children;
        return hasTooltip ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
            title: label,
            placement: "right",
            force: true,
            wrap: true,
            children: children
        }) : children;
    };
    if (type === "divider") return name;
    if (value === "divider") return /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBar_style/* default.Divider */.ZP.Divider, {});
    if (type === "subMenu") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList_SubMenuItem, {
        label: label,
        toggleComponent: toggle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList, {
            menuMap: map,
            compact: true,
            sub: true
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkWrapper, {
            disabled: sub_menu,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* ListItem */.HC, {
                    px: iconOnly ? 0 : 4,
                    w: 100,
                    onClick: action,
                    size: "large",
                    active: isActive(item),
                    style: helpSideBar ? ListItemStyleHelp : ListItemStyle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
                            disabled: !sub_menu,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItemIcon */.Q$, {
                                disabled: !sub_menu,
                                children: icon
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* ListItemContent */.Ek, {
                            children: [
                                !iconOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
                                    disabled: !sub_menu,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItemText */.F_, {
                                        text: item === null || item === void 0 ? void 0 : item.label
                                    })
                                }),
                                (item === null || item === void 0 ? void 0 : item.sub_menu) && /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItemChevron */.no, {
                                    onClick: function() {
                                        return toggleSub(item === null || item === void 0 ? void 0 : item.label);
                                    },
                                    children: !subIsOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronDownIcon */.v4q, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronUpIcon */.g8U, {})
                                })
                            ]
                        }),
                        !iconOnly && helpSideBar && // <LinkWrapper disabled={!sub_menu}>
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItemSub */.oZ, {
                            children: item === null || item === void 0 ? void 0 : item.help
                        }),
                        (item === null || item === void 0 ? void 0 : item.shortcut) && /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* ListItemRight */.zK, {
                            children: item.shortcut
                        })
                    ]
                }),
                sub_menu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Expander/* default */.Z, {
                    expanded: subIsOpen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList, {
                        menuMap: sub_menu,
                        p: 0,
                        m: 0,
                        ml: iconOnly ? 0 : 5,
                        iconOnly: iconOnly,
                        activate: activate,
                        active: active
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/mosanic/items/MenuList/index.js

/* harmony default export */ var items_MenuList = (MenuList);


/***/ }),

/***/ 60630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VZ": function() { return /* binding */ TwoColumns; }
/* harmony export */ });
/* unused harmony export Column */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67324);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68311);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57389);
/* harmony import */ var _JSX__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96344);








var Columns = function(param) {
    var columns = param.columns, _equal = param.equal, equal = _equal === void 0 ? false : _equal, _cols = param.cols, cols = _cols === void 0 ? "auto" : _cols;
    var columnWidth = cols === "auto" ? equal ? "".concat(100 / (columns === null || columns === void 0 ? void 0 : columns.length), "%") : (columns === null || columns === void 0 ? void 0 : columns.length) === 4 ? [
        "30%",
        "25%",
        "25%",
        "20%", 
    ] : (columns === null || columns === void 0 ? void 0 : columns.length) === 3 ? [
        "35%",
        "35%",
        "30%", 
    ] : (columns === null || columns === void 0 ? void 0 : columns.length) === 2 ? [
        "50%",
        "50%"
    ] : (columns === null || columns === void 0 ? void 0 : columns.length) === 1 ? [
        "100%"
    ] : [
        "auto"
    ] : "".concat(100 / cols, "%");
    var desktop = function(i) {
        return (0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(columnWidth) ? columnWidth : columnWidth[i];
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* .Wrap */ .Eq, {
        children: columns === null || columns === void 0 ? void 0 : columns.map(function(column, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                width: [
                    1,
                    1 / 2,
                    1 / 2,
                    desktop(i)
                ],
                py: [
                    2,
                    4
                ],
                px: [
                    0,
                    2,
                    4
                ],
                children: column
            }, i);
        })
    });
};
var Column = function(_param) /*#__PURE__*/ {
    var children = _param.children, _card = _param.card, card = _card === void 0 ? false : _card, padding = _param.padding, width = _param.width, maxWidth = _param.maxWidth, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "card",
        "padding",
        "width",
        "maxWidth"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, padding), {
        width: width,
        maxWidth: maxWidth,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_6__/* .ConditionalWrapper */ .M, {
            when: card,
            wrapper: function(children) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_7__/* .Card */ .Zb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    mb: 4
                }, other), {
                    children: children
                }));
            },
            children: children
        })
    }));
};
var TwoColumns = function(_param) /*#__PURE__*/ {
    var first = _param.first, second = _param.second, after = _param.after, _card = _param.card, card = _card === void 0 ? false : _card, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "first",
        "second",
        "after",
        "card"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_styles__WEBPACK_IMPORTED_MODULE_2__/* .Wrap */ .Eq, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, other), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Column, {
                card: card,
                mr: [
                    0,
                    4
                ],
                padding: {
                    pr: [
                        0,
                        2
                    ]
                },
                width: [
                    1,
                    1 / 2
                ],
                children: first
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Column, {
                card: second && card,
                ml: [
                    0,
                    4
                ],
                padding: {
                    pl: [
                        0,
                        2
                    ]
                },
                width: [
                    1,
                    1 / 2
                ],
                children: second
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (Columns);


/***/ }),

/***/ 69756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57389);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51085);





var DashCard = function(_param) /*#__PURE__*/ {
    var header = _param.header, _label = _param.label, label = _label === void 0 ? "" : _label, _help = _param.help, help = _help === void 0 ? "" : _help, _render = _param.render, render = _render === void 0 ? null : _render, children = _param.children, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "header",
        "label",
        "help",
        "render",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_2__/* .Block */ .gO, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        m: 0,
        mb: 4
    }, other), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_5__/* .AdvancedLabel */ .qv, {
                label: label,
                span: true,
                mb: 2,
                helpText: help
            }),
            render,
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DashCard);


/***/ }),

/***/ 3155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


var MetaHead = function(param) {
    var title = param.title, description = param.description, _keywords = param.keywords, keywords = _keywords === void 0 ? "" : _keywords, _url = param.url, url = _url === void 0 ? "" : _url, _language = param.language, language = _language === void 0 ? null : _language, _locale = param.locale, locale = _locale === void 0 ? null : _locale, localized = param.localized;
    if (localized && (localized === null || localized === void 0 ? void 0 : localized[locale]) && language != locale) {
        var ref, ref1;
        description = (ref = localized[locale]) === null || ref === void 0 ? void 0 : ref.description;
        title = (ref1 = localized[locale]) === null || ref1 === void 0 ? void 0 : ref1.title;
    }
    if (!language && localized) {
        language = locale;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: "#118b92"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: "..."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "..."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "language",
                content: language
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                href: "...".concat(url),
                hrefLang: "nl"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: "#000"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MetaHead);


/***/ }),

/***/ 81099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _JSX__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(706);
/* harmony import */ var _Page_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4851);
/* harmony import */ var _PageNav__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29828);







var Page = function(_param) {
    var _white = _param.white, white = _white === void 0 ? true : _white, _preTitle = _param.preTitle, preTitle = _preTitle === void 0 ? null : _preTitle, _title = _param.title, title = _title === void 0 ? null : _title, _slug = _param.slug, slug = _slug === void 0 ? null : _slug, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _subSlug = _param.subSlug, subSlug = _subSlug === void 0 ? null : _subSlug, _center = _param.center, center = _center === void 0 ? false : _center, children = _param.children, _auth = _param.auth, auth = _auth === void 0 ? false : _auth, _sideLinks = _param.sideLinks, sideLinks = _sideLinks === void 0 ? null : _sideLinks, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "white",
        "preTitle",
        "title",
        "slug",
        "fullWidth",
        "subSlug",
        "center",
        "children",
        "auth",
        "sideLinks"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Page_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Page */ .ZP.Page, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        white: white,
        fullWidth: fullWidth,
        center: center
    }, other), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_5__.If, {
                condition: Boolean(slug),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PageNav__WEBPACK_IMPORTED_MODULE_6__/* .PageNav */ .T, {
                    slug: slug
                })
            }),
            subSlug,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_5__.If, {
                condition: Boolean(title) || Boolean(preTitle),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Page_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Header */ .ZP.Header, {
                    children: [
                        preTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Page_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PreTitle */ .ZP.PreTitle, {
                            children: preTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "title gr-text-4",
                            children: title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Page_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Content */ .ZP.Content, {
                center: center,
                m: 4,
                children: children
            })
        ]
    }));
};


/***/ }),

/***/ 4851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports CoreWrapper, PageStyle */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _mosanic_styles_flex_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5441);
/* harmony import */ var _mosanic_styles_card_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2483);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26021);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78545);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        @media (min-width: 600px){\n            display: flex;\n            flex-wrap: nowrap;\n            flex-direction: row;\n        }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    /* overflow-x: hidden; */\n    padding-top: ",
        "; \n    min-height: 100vh;\n\n    display: flex;\n    height: 100%;\n    direction: ltr;\n    width: 100%;\n    background: red;\n\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    max-width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ",
        " {\n            margin: 0 auto;\n        }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    width: 100%;\n    height: 44px;\n    padding: 6px 5px;\n    background:  ",
        ";\n    border-bottom: 0.5px solid #e5e5e5;\n    \n    font-weight: 600;\n\n    &, & > * {\n        color: ",
        ";\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    font-size: 14px;\n    padding: 4px 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    background: none;\n    border: none;\n    padding: 0;\n    margin: 0 4px;\n    :hover {\n        svg {\n            transform: scale(1.2);\n        }\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    margin: 0 auto;\n    ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        " \n    ",
        "\n    flex-direction: column;\n    flex-wrap: nowrap;\n\n    /* font-size: 24px; */\n    \n    font-weight: 600;\n\n    > :is(h1, h2, h3, h4, h5, h6, p) {\n        display: block;\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    margin-bottom: 7px;\n    font-size: 1em;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ",
        " , ",
        " {\n            /* max-width: 90%; */\n        }\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    ",
        "\n    \n    /* padding-top: 40px; */\n    background: ",
        ";\n    /* props.theme.colors?.bg */\n    /* props.theme.colors.light10 */\n\n\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}





var CoreWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-31ad12ea-0"
})(_templateObject1(), function(props) {
    return props.navbar;
}, function(props) {
    return props.isApp && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
});
var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2());
var Content = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-31ad12ea-1"
})(_templateObject4(), Container, function(props) {
    return props.center && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _mosanic_styles_card_styles__WEBPACK_IMPORTED_MODULE_3__/* .Card */ .Zb);
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
var Nav = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-31ad12ea-2"
})(_templateObject5(), function(props) {
    var ref;
    return (ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.white;
}, function(props) {
    var ref;
    return (ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.text;
});
var NavSlug = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-31ad12ea-3"
})(_templateObject6());
var NavBack = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-31ad12ea-4"
})(_templateObject7());
var NavContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-31ad12ea-5"
})(_templateObject8(), _mosanic_styles_flex_styles__WEBPACK_IMPORTED_MODULE_4__/* .RowWrap */ .xv);
var Header = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-31ad12ea-6"
})(_templateObject9(), Container, _mosanic_styles_flex_styles__WEBPACK_IMPORTED_MODULE_4__/* .CenterCenter */ .IV);
var PreTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-31ad12ea-7"
})(_templateObject10());
var Page = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-31ad12ea-8"
})(_templateObject12(), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh, function(props) {
    var ref;
    return ((ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.white) === "#FFFFFF" ? props.white ? "#F9FBFC" : "#f5f5f5" : "#222";
}, function(props) {
    return props.fullWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject11(), Header, Content);
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_);
var PageStyle = (/* unused pure expression or super */ null && (Page));
var PageStyles = {
    Page: Page,
    Content: Content,
    Header: Header,
    PreTitle: PreTitle,
    Nav: Nav,
    NavSlug: NavSlug,
    NavBack: NavBack,
    NavContent: NavContent
};
/* harmony default export */ __webpack_exports__["ZP"] = (PageStyles);


/***/ }),

/***/ 29828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ PageNav; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68311);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8152);
/* harmony import */ var _Skeletons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86443);
/* harmony import */ var _Page_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4851);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26021);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    font-size: 12px;\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    color: #444;\n    background: #fff;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var SlugPart = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-f5f840c1-0"
})(_templateObject1(), function(props) {
    return props.isLink && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"].util.primary.base */ .ZP.util.primary.base);
});
var Separator = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-f5f840c1-1"
})(_templateObject2());
var PageNav = function(param) {
    var _slug = param.slug, slug = _slug === void 0 ? null : _slug;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Page_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Nav */ .ZP.Nav, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Page_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"].NavContent */ .ZP.NavContent, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Page_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"].NavSlug */ .ZP.NavSlug, {
                children: [
                    router.back && (router === null || router === void 0 ? void 0 : router.asPath) != "/" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Page_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"].NavBack */ .ZP.NavBack, {
                        onClick: function() {
                            return router.back();
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "15",
                            height: "15",
                            fill: "none",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M6.854 3.854a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L3.207 7.5l3.647-3.646Zm6 0a.5.5 0 0 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L9.207 7.5l3.647-3.646Z",
                                fill: "#000"
                            })
                        })
                    }),
                    Array.isArray(slug) ? slug.map(function(s, index) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SlugPart, {
                            isLink: s === null || s === void 0 ? void 0 : s.href,
                            children: [
                                (s === null || s === void 0 ? void 0 : s.loading) || (0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .containsSubstr */ .xX)(s === null || s === void 0 ? void 0 : s.href, "//") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Skeletons__WEBPACK_IMPORTED_MODULE_8__/* .SkeletonLine */ .AU, {}) : (s === null || s === void 0 ? void 0 : s.href) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                    href: s === null || s === void 0 ? void 0 : s.href,
                                    children: s === null || s === void 0 ? void 0 : s.label
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                    children: s.label
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Separator, {
                                    children: (slug === null || slug === void 0 ? void 0 : slug.length) - 1 != index ? " / " : ""
                                })
                            ]
                        }, index);
                    }) : slug
                ]
            })
        })
    });
};


/***/ }),

/***/ 85774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Progress_Progress; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
;// CONCATENATED MODULE: ./src/mosanic/items/Progress/Progress.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    height: ",
        ";\n    background: ",
        ";\n    transition: all ease-in-out 0.3s;\n    border-radius: 4px;\n    overflow: hidden;\n    width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    transition: all ease-in-out 0.3s;\n    height: 100%;\n    width: ",
        ";\n    background: ",
        ";\n    border-radius: 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var Track = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c427bec3-0"
})(_templateObject(), function(props) {
    return props.height + "px";
}, function(props) {
    return props.track;
});
var Progress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c427bec3-1"
})(_templateObject1(), function(props) {
    return props.value + "%";
}, function(props) {
    return props.color;
});
var ProgressStyles = {
    Track: Track,
    Progress: Progress
};
/* harmony default export */ var Progress_styles = (ProgressStyles);

;// CONCATENATED MODULE: ./src/mosanic/items/Progress/Progress.js






var Progress_Progress = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? colors/* default.util.primary.base */.ZP.util.primary.base : _color, _track = _param.track, track = _track === void 0 ? colors/* default.util.gray.lighter */.ZP.util.gray.lighter : _track, _value = _param.value, value = _value === void 0 ? 0 : _value, _height = _param.height, height = _height === void 0 ? 8 : _height, other = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "track",
        "value",
        "height"
    ]);
    return (0,jsx_runtime.jsx)(Progress_styles.Track, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        track: track,
        height: height
    }, other), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress_styles.Progress, {
            color: color,
            value: value
        })
    }));
};


/***/ }),

/***/ 99022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports ListItemIcon, InlineContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2921);
/* harmony import */ var css_in_js_media__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72857);
/* harmony import */ var css_in_js_media__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(css_in_js_media__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8782);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26021);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78545);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    margin: 4px 10px 0px;\n    color: ",
        "!important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    border-bottom: ",
        " 2px solid;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    margin: 2px 0 -5px 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n\n        background: ",
        ";\n        \n        &:hover {\n            background: ",
        ";\n        }\n\n        ",
        " {\n          color: ",
        " !important;\n        }\n        svg path {\n          fill: ",
        ";\n        }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 5px;\n    transition: ease-in-out 0.2s all;\n    display: flex;\n    margin: 0;\n    max-height: 40px;\n    height: 40px;\n    overflow: hidden;\n\n    &:hover {\n        background: ",
        ";\n        cursor: pointer;\n\n        ",
        " svg path {\n            fill: ",
        ";\n        }\n    }\n\n    svg path {\n        fill: ",
        ";\n    }\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ",
        " {\n            color: rgba(0, 0, 0, 0.87);\n            font-weight: 900;\n            font-size: 12px;\n            line-height: 24px;\n        }\n        ",
        " {\n\n        }\n        ",
        " svg {\n            transition: all ease-in-out 0.3s;\n            transform: scale(1.2);\n            transform-origin: center left;\n\n        }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n\n    ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    margin: 0 !important;\n    padding: 0 !important;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        @media (min-width: 600px){\n            span {\n                opacity: 0;\n            }\n        }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    min-height: 45px;\n    height: 45px;\n    background: ",
        ";\n    border-bottom: ",
        " 2px solid;\n    overflow: hidden;\n    ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    transition: all ease-in-out 0.3s;\n    cursor: pointer;\n    position: absolute;\n    margin: 5px 5px 5px 0;\n    padding: 5px;\n\n    right: 5px;\n    top: 0;\n    /* background-color: ",
        "; */\n\n    svg path {\n        fill: ",
        ";\n      }\n    &:hover svg {\n      transform: scale(1.05);\n      path {\n        fill: ",
        ";\n      }\n    }\n\n    ",
        " {\n        font-size: 15px;\n    }\n    ",
        " {\n        font-size: 20px;\n    }\n    ",
        " {\n        font-size: 25px;\n    }\n    ",
        " {\n        font-size: 30px;\n    }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    margin-top: 80px;\n    height: ",
        ";\n    overflow-y: auto;\n\n    ",
        " {\n        /* top: 42px!important; */\n    }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        margin-left: ",
        ";\n        position: fixed;\n        z-index: 2;\n        top: 0;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        margin-left: -355px!important;\n        @media (max-width: 600px){\n            margin-left: -100%!important;\n        }\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        /* height: ",
        "; */\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        width: 324px;\n        margin-left: 170px;\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    box-shadow: none;\n    ",
        "\n    overflow-x: hidden;\n    \n    background: rgba(255,255,255,0.95);\n    background:  ",
        ";\n\n    backdrop-filter: blur(4px) grayscale(100%);\n    border-right: 1px solid #e5e5e5;\n    transition: all ease-in-out 0.35s;\n\n    ",
        "\n\n    /* Get height based if page has subnav */\n    ",
        "\n/* \n    ",
        " */\n\n    /* margin-left: ",
        "; */\n    width: ",
        ";\n    max-width: ",
        ";\n\n\n    @media (max-width: 600px){\n        margin-left: 0;\n        z-index: 4;\n        position: fixed;\n        width: 100%;\n    }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        text-align: center;\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        margin-left: -300px;\n\n        @media (max-width: 600px) {\n            margin-left: -140%;\n        }\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        width: 170px;\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            margin-left: 0;\n            margin-right: -275px;\n        "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        right: 0;\n        position: fixed;\n        border-right: none;\n        border-left: 1px solid #e5e5e5;\n        width: 275px;\n        top: 80px;\n        max-height: calc(100vh - 80px);\n        \n        ",
        "\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        left: 0;\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    ",
        "\n    ",
        "\n    position: relative;\n    top: 0;\n    flex: 0 0 1;\n    width: ",
        ";\n    transition: all ease-in-out 0.35s;\n    ",
        "\n\n    /* max-height: 100vh; */\n    height: 100%;\n    /* width: 100%; */\n    overflow-x: hidden;\n    overflow-y: scroll;\n    background: ",
        ";\n\n    border-right: 1px solid ",
        ";\n    /* border-left: 1px solid #e5e5e5; */ \n    z-index: 3;\n    vertical-align: top;\n    display: inline-block;\n\n    /* margin-top: 40px; */\n\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    & *, ",
        " * {\n        color: #212121!important;\n        font-weight: 400;\n    }\n\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    transition: all ease-in-out 0.3s;\n    overflow: hidden;\n    width: 100%;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        &, ",
        " {\n            width: 45px;\n            min-width: 45px!important;\n        }\n        ",
        ",\n        .nameLabel {\n            opacity: 0;\n        }\n        .nameLabel {\n            display: none;\n        }\n        ",
        " {\n            margin-left: 45px;\n            width: 324px;\n        }\n        \n    "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        position: fixed;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        z-index: 3;\n        margin-top: 80px !important;\n        \n    "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        \n        /* /* content: ''; */\n        @media (max-width: 600px) {\n            position: fixed;\n            top: 0;\n            left: 0;\n            bottom: 0;\n            z-index: 3;\n        }\n        @media (min-width: 601px) { */\n            /* display: inline-block; */\n            min-width: 275px;\n\n    \n        }\n    "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ",
        " {\n            @media (max-width: 600px){\n                width: 100%;\n            }\n        }\n    "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    display: flex;\n    position: relative;\n\n    width: ",
        ";\n    min-width: ",
        ";\n    ",
        " {\n        -ms-overflow-style: none; \n        scrollbar-width: none; \n\n        &::-webkit-scrollbar {\n            display: none; \n        }\n    }\n    /* ",
        " */\n\n    ",
        "\n    \n    \n    /* @media (max-width: 600px) {\n        ",
        " {\n            text-align: center;\n        }\n        ",
        " {\n            margin-left: 25px;\n        }\n    }\n    \n    ",
        " */\n\n/* \n    .sideBarTrigger {\n        cursor: pointer;\n        font-size: 14px;\n        margin: 5px 6px;\n    } */\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}





var navOffset = "40px";
var subNavOffset = "40px";
var combinedOffset = "".concat(parseFloat(navOffset) + parseFloat(subNavOffset) + 2, "px");
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed1f04c6-0"
})(_templateObject(), function(props) {
    var ref;
    return (ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.text;
});
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed1f04c6-1"
})(_templateObject1(), function(props) {
    var ref;
    return (0,polished__WEBPACK_IMPORTED_MODULE_4__/* .lighten */ .$n)(0.05, (ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.lightGray);
});
var ListItemIcon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed1f04c6-2"
})(_templateObject2());
var ListMenuItem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed1f04c6-3"
})(_templateObject4(), function(props) {
    return props.theme.colors.light;
}, ListItemIcon, _mosanic_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"].util.primary.dark */ .ZP.util.primary.dark, function(props) {
    var ref;
    return (ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.text;
}, function(props) {
    return props.active && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), function(props) {
        return props.theme.colors.light;
    }, function(props) {
        var ref;
        return (ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.white;
    }, ListItem, _mosanic_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"].util.primary.base */ .ZP.util.primary.base, _mosanic_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"].util.primary.base */ .ZP.util.primary.base);
});
var List = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed1f04c6-4"
})(_templateObject6(), function(props) {
    return props.large && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), ListItem, ListMenuItem, ListItemIcon);
});
var ListMenu = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed1f04c6-5"
})(_templateObject7());
var ListHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed1f04c6-6"
})(_templateObject9(), function(props) {
    var ref;
    return (ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.white;
}, function(props) {
    var ref;
    return (ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.lightGray;
}, function(props) {
    return props.close && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8());
});
var SideBarToggle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-ed1f04c6-7"
})(_templateObject10(), function(props) {
    var ref;
    return (ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.lightGray;
}, function(props) {
    return props.theme.colors.dark;
}, function(props) {
    return props.theme.colors.dark;
}, css_in_js_media__WEBPACK_IMPORTED_MODULE_1___default()(">desktop"), css_in_js_media__WEBPACK_IMPORTED_MODULE_1___default()("<=desktop", ">tablet"), css_in_js_media__WEBPACK_IMPORTED_MODULE_1___default()("<=tablet", ">phone"), css_in_js_media__WEBPACK_IMPORTED_MODULE_1___default()("<=phone"));
var subNavOffsetStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject11(), "calc(100vh - ".concat(combinedOffset, ")"), SideBarToggle);
var SubSideBar = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed1f04c6-8"
})(_templateObject16(), function(props) {
    return props.fixed && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject12(), props.marginLeft);
}, function(props) {
    var ref;
    return (ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.white;
}, function(props) {
    return props.close && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject13());
}, function(props) {
    return props.subNavBar ? subNavOffsetStyling : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject14(), "calc(100vh - ".concat(navOffset, ")"));
}, function(props) {
    return props.small && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject15());
}, function(props) {
    return props.ml;
}, function(props) {
    return props.width;
}, function(props) {
    return props.width;
});
var SideBar = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed1f04c6-9"
})(_templateObject23(), styled_system__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_, function(props) {
    return props.width;
}, function(props) {
    return props.type === "icon" && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject17());
}, function(props) {
    var ref;
    return (ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.white;
}, function(props) {
    var ref;
    return (ref = props.theme.colors) === null || ref === void 0 ? void 0 : ref.lightGray;
}, function(props) {
    return props.close && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject18());
}, function(props) {
    return props.small && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject19());
}, function(props) {
    return props.right ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject21(), function(props) {
        return props.close && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject20());
    }) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject22());
}, ListItem);
var InlineContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed1f04c6-10"
})(_templateObject24());
var SideBarContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed1f04c6-11"
})(_templateObject29(), function(props) {
    return props.width;
}, function(props) {
    return props.width;
}, SideBar, function(props) {
    return props.iconOnly && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject25(), SideBar, ListItem, SubSideBar);
}, function(props) {
    return props.fixed ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject26()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject27());
}, SideBar, ListItem, function(props) {
    return props.mobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject28(), SideBar);
}, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh);
var SideBarStyles = {
    SideBarContainer: SideBarContainer,
    SideBarToggle: SideBarToggle,
    SubSideBar: SubSideBar,
    SideBar: SideBar,
    List: List,
    ListMenu: ListMenu,
    ListHeader: ListHeader,
    ListItem: ListItem,
    ListMenuItem: ListMenuItem,
    Divider: Divider,
    ListItemIcon: ListItemIcon
};
/* harmony default export */ __webpack_exports__["ZP"] = (SideBarStyles);


/***/ }),

/***/ 86443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Od": function() { return /* binding */ Skeletons_Skeleton; },
  "As": function() { return /* binding */ Skeletons_SkeletonCard; },
  "AU": function() { return /* binding */ Skeletons_SkeletonLine; },
  "eM": function() { return /* binding */ SkeletonList; }
});

// UNUSED EXPORTS: SkeletonCircle

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(78545);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
;// CONCATENATED MODULE: ./src/mosanic/items/Skeletons/Skeleton.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  ",
        "\n  ",
        "\n  margin: 5px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "linear-gradient(-90deg, #C1C1C1 0%, #F8F8F8 50%, #C1C1C1 100%)"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "linear-gradient(-90deg, #F0F0F0 0%, #F8F8F8 50%, #F0F0F0 100%)"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  height: 100%;\n  width: 100%;\n  background: ",
        ";\n  background-size: 400% 400%;\n  animation: pulse 1.2s ease-in-out infinite;\n  @keyframes pulse {\n    0% {\n      background-position: 0% 0%;\n    }\n    100% {\n      background-position: -135% 0%;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  border-radius: 5px;\n\n  &::before {\n    content: "\\00a0";\n  }\n'
    ], [
        '\n  border-radius: 5px;\n\n  &::before {\n    content: "\\\\00a0";\n  }\n'
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 5.5em;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    position: absolute;\n    top:0;\n    bottom: 0;\n    left:0;\n    right:0;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n\n  min-width: 100%;\n  min-height: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  height: ",
        "px;\n  width: ",
        "px;\n  border-radius: 50%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c52e0ed4-0"
})(_templateObject(), index_esm/* layout */.bK, index_esm/* space */.Dh);
var PulseSkeleton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c52e0ed4-1"
})(_templateObject3(), function(props) {
    return props.trans //translucent
     ? (0,styled_components_browser_esm/* css */.iv)(_templateObject1()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
});
var Skeleton = (0,styled_components_browser_esm/* default */.ZP)(PulseSkeleton).withConfig({
    componentId: "sc-c52e0ed4-2"
})(_templateObject4());
var SkeletonLine = (0,styled_components_browser_esm/* default */.ZP)(Skeleton).withConfig({
    componentId: "sc-c52e0ed4-3"
})(_templateObject5());
var SkeletonCard = (0,styled_components_browser_esm/* default */.ZP)(Skeleton).withConfig({
    componentId: "sc-c52e0ed4-4"
})(_templateObject7(), function(props) {
    return props.full && (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
});
var SkeletonCircle = (0,styled_components_browser_esm/* default */.ZP)(Skeleton).withConfig({
    componentId: "sc-c52e0ed4-5"
})(_templateObject8(), function(props) {
    return props.height ? props.height : 30;
}, function(props) {
    return props.width ? props.width : 30;
});
var SkeletonStyles = {
    SkeletonLine: SkeletonLine,
    SkeletonCard: SkeletonCard,
    SkeletonCircle: SkeletonCircle,
    Item: Item
};
/* harmony default export */ var Skeleton_styles = (SkeletonStyles);

// EXTERNAL MODULE: ./src/mosanic/items/Block.js
var Block = __webpack_require__(57389);
;// CONCATENATED MODULE: ./src/mosanic/items/Skeletons/Skeletons.js






var Skeletons_SkeletonLine = function(_param) /*#__PURE__*/ {
    var _trans = _param.trans, trans = _trans === void 0 ? false : _trans, _as = _param.as, as = _as === void 0 ? "span" : _as, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "trans",
        "as"
    ]);
    return (0,jsx_runtime.jsx)(Skeleton_styles.SkeletonLine, (0,src_object_spread/* default */.Z)({
        trans: trans,
        as: as
    }, other));
};
var SkeletonList = function(_param) /*#__PURE__*/ {
    var _trans = _param.trans, trans = _trans === void 0 ? false : _trans, _count = _param.count, count = _count === void 0 ? 5 : _count, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "trans",
        "count"
    ]);
    return (0,jsx_runtime.jsx)("div", {
        style: {
            paddingLeft: "20px"
        },
        children: Array.from({
            length: count
        }, function(_, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_styles.Item, {
                mt: 4,
                as: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_styles.SkeletonLine, (0,src_object_spread/* default */.Z)({
                    trans: trans
                }, other))
            }, i);
        })
    });
};
var Skeletons_SkeletonCard = function(_param) /*#__PURE__*/ {
    var _trans = _param.trans, trans = _trans === void 0 ? false : _trans, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "trans"
    ]);
    return (0,jsx_runtime.jsx)(Block/* Card */.Zb, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, other), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_styles.SkeletonCard, {
            trans: trans
        })
    }));
};
var Skeletons_Skeleton = function(_param) /*#__PURE__*/ {
    var _trans = _param.trans, trans = _trans === void 0 ? false : _trans, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "trans"
    ]);
    return (0,jsx_runtime.jsx)(Skeleton_styles.SkeletonCard, {
        trans: trans,
        as: "div",
        full: true
    });
};
var Skeletons_SkeletonCircle = function(_param) /*#__PURE__*/ {
    var _trans = _param.trans, trans = _trans === void 0 ? false : _trans, other = _object_without_properties(_param, [
        "trans"
    ]);
    return _jsx(s.SkeletonCircle, _object_spread({
        trans: trans
    }, other));
};



/***/ }),

/***/ 36174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2921);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26021);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n	position: relative;\n	margin: 25px auto;\n	padding: 50px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n	top: 20px;\n	left: calc(50% - 20px);\n	position: absolute;\n	width: 40px;\n	height: 40px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n	@keyframes bounce {\n		0%, 100% { \n			transform: scale(0.0);\n			-webkit-transform: scale(0.0);\n		} 50% { \n			transform: scale(1.0);\n			-webkit-transform: scale(1.0);\n		}\n	}\n	width: 100%;\n	height: 100%;\n	border-radius: 50%;\n	background-color: ",
        ";\n	opacity: 0.6;\n	position: absolute;\n	top: 0;\n	left: 0;\n	\n	-webkit-animation: bounce 2.0s infinite ease-in-out;\n	animation: bounce 2.0s infinite ease-in-out;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n	-webkit-animation-delay: -1.0s;\n	animation-delay: -1.0s;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var Container = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5cdde317-0"
})(_templateObject());
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5cdde317-1"
})(_templateObject1());
var BounceOne = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5cdde317-2"
})(_templateObject2(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.primary.base */ .ZP.util.primary.base);
var BounceTwo = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BounceOne).withConfig({
    componentId: "sc-5cdde317-3"
})(_templateObject3());
var Spinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        className: "spinner-container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Loader, {
            className: "spinner",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BounceOne, {
                    className: "bounce1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BounceTwo, {
                    className: "bounce2"
                })
            ]
        })
    });
};


/***/ }),

/***/ 10835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ TooltipSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _mosanic_styles_animations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37971);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26021);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        opacity: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        animation: redNoticeAttention 1s infinite linear;\n        box-shadow: 2px 2px 15px 0 rgba(0,0,0,0.4);\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n        &::before {\n            content: " ";\n            left: 50%;\n            border: solid transparent;\n            height: 0;\n            width: 0;\n            position: absolute;\n            pointer-events: none;\n            border-width: var(--tooltip-arrow-size);\n            margin-left: calc(var(--tooltip-arrow-size) * -1);\n        }\n    '
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    position: absolute;\n    border-radius: 4px;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 6px;\n    color: var(--tooltip-text-color);\n    background: var(--tooltip-background-color);\n    font-size: 10px;\n    font-weight: 600;\n    font-family: sans-serif;\n    line-height: 1;\n    z-index: 9999;\n    white-space: nowrap;\n    opacity: 0;\n    transition: opacity ease-in-out 0.1s;\n\n    svg {   \n        transform: scale(0.8);\n        margin: -1px 0 0 0;\n        path {\n            fill: #fff;\n        }\n    }\n    ",
        "\n    ",
        "\n    \n    ",
        "\n\n    &[data-popper-placement^='top'] {\n        top: calc(var(--tooltip-margin) * -1);\n        &::before {\n            top: 100%;\n            border-top-color: var(--tooltip-background-color);\n        }\n    }\n    &[data-popper-placement^='right'] {\n        left: calc(100% + var(--tooltip-margin));\n        top: 50%;\n        transform: translateX(0) translateY(-50%);\n        &::before {\n            left: calc(var(--tooltip-arrow-size) * -1);\n            top: 50%;\n            transform: translateX(0) translateY(-50%);\n            border-right-color: var(--tooltip-background-color);\n        }\n    }\n    &[data-popper-placement^='bottom'] {\n        bottom: calc(var(--tooltip-margin) * -1);\n        &::before {\n            bottom: 100%;\n            border-bottom-color: var(--tooltip-background-color);\n        }\n    }\n    &[data-popper-placement^='left'] {\n        left: auto;\n        right: calc(100% + var(--tooltip-margin));\n        top: 50%;\n        transform: translateX(0) translateY(-50%);\n        &::before {\n            left: auto;\n            right: calc(var(--tooltip-arrow-size) * -2);\n            top: 50%;\n            transform: translateX(0) translateY(-50%);\n            border-left-color: var(--tooltip-background-color);\n        }\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    /* display: inline-block; */\n    /* position: relative; */\n    /* position: inherit; */\n    /* display: inherit; */\n    display: inline-block;\n\n    &:hover {\n        ",
        " {\n            opacity: 1;\n        }\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Tooltip = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b3d774b7-0"
})(_templateObject3(), _mosanic_styles_animations__WEBPACK_IMPORTED_MODULE_2__/* .redNoticeAttention */ .sF, function(props) {
    return props.active && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());
}, function(props) {
    return props.variant === "notice" && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return props.arrow && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2());
});
var TooltipSelector = Tooltip;
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b3d774b7-1"
})(_templateObject4(), Tooltip);
var TooltipStyle = {
    Wrapper: Wrapper,
    Tooltip: Tooltip
};
/* harmony default export */ __webpack_exports__["Z"] = (TooltipStyle);


/***/ }),

/***/ 94233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ items_Tooltip; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/mosanic/items/Tooltip/Tooltip.style.js
var Tooltip_style = __webpack_require__(10835);
// EXTERNAL MODULE: ./src/mosanic/hooks/useTooltips.js
var useTooltips = __webpack_require__(51925);
// EXTERNAL MODULE: ../../node_modules/react-popper/lib/esm/usePopper.js
var usePopper = __webpack_require__(26194);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ./src/mosanic/fields/Editor/Wrappers.js
var Wrappers = __webpack_require__(77469);
;// CONCATENATED MODULE: ./src/mosanic/utils/placement.js
function isHorizontal(placement) {
    switch(placement){
        case "top":
            return false;
        case "bottom":
            return false;
        case "right":
            return true;
        case "left":
            return true;
    }
}
var isVertical = function(placement) {
    return !isHorizontal(placement);
};

// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
;// CONCATENATED MODULE: ./src/mosanic/items/Tooltip/Tooltip.js











var Tooltip = function(param) {
    var children = param.children, _title = param.title, title = _title === void 0 ? null : _title, _placement = param.placement, placement = _placement === void 0 ? "bottom" : _placement, _variant = param.variant, variant = _variant === void 0 ? null : _variant, _arrow = param.arrow, arrow = _arrow === void 0 ? false : _arrow, _wrap = param.wrap, wrap = _wrap === void 0 ? false : _wrap, _force = param.force, force = _force === void 0 ? false : _force;
    var active = (0,useTooltips/* useTooltips */.N)();
    var ref = (0,react.useRef)(null);
    var popperRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(null), arrowRef = ref1[0], setArrowRef = ref1[1];
    var ref2 = (0,react.useState)(false), view = ref2[0], setView = ref2[1];
    var ref3 = (0,usePopper/* usePopper */.D)(ref === null || ref === void 0 ? void 0 : ref.current, popperRef.current, {
        placement: placement,
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowRef
                }
            },
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        arrow ? 10 : isHorizontal(placement) ? 10 : 5
                    ]
                }
            }
        ]
    }), styles = ref3.styles, attributes = ref3.attributes;
    var childProps = {
        ref: ref,
        onMouseEnter: function() {
            return setView(true);
        },
        onMouseLeave: function() {
            return setView(false);
        }
    };
    var childrenWithProps = react.Children.map(children, function(child) {
        return /*#__PURE__*/ react.isValidElement(child) ? /*#__PURE__*/ react.cloneElement(child, childProps) : child;
    });
    //No tooltip
    if (!force && (!Boolean(title) || !active)) return children;
    // s.Wrapper
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: wrap,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, childProps), {
                children: children
            }));
        },
        children: [
            wrap ? children : childrenWithProps,
            active && view && /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers/* Portal */.h_, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tooltip_style/* default.Tooltip */.Z.Tooltip, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    variant: variant,
                    ref: popperRef,
                    style: styles.popper
                }, attributes.popper), {
                    active: view,
                    arrow: arrow,
                    children: [
                        title,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: setArrowRef,
                            style: styles.arrow
                        })
                    ]
                }))
            })
        ]
    });
};
/* harmony default export */ var Tooltip_Tooltip = (Tooltip);

;// CONCATENATED MODULE: ./src/mosanic/items/Tooltip/index.js

/* harmony default export */ var items_Tooltip = (Tooltip_Tooltip);


/***/ }),

/***/ 61541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ mosanic; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
;// CONCATENATED MODULE: ./src/mosanic/ErrorStrings.js
var register = {
    core: {
        type: "Schema type is not supported.",
        name: "Schema could not be registered. Name is undefined.",
        props: "Schema could not be registered. Props are undefined."
    }
};
var error = {
    register: register
};

;// CONCATENATED MODULE: ./src/mosanic/register.js


var core = error.register.core;
var SUPPORTED_REGISTER_TYPES = [
    "component",
    "fieldset",
    "field"
];
var validateRegister = function(param) {
    var schema = param.schema, type = param.type;
    if (!SUPPORTED_REGISTER_TYPES.includes(type)) console.error(core.type);
    if ((0,Obj/* hasAttr */.B$)(schema, "name")) console.error(core.name);
    if ((0,Obj/* hasAttr */.B$)(schema, "props")) console.error(core.props);
};

;// CONCATENATED MODULE: ./src/mosanic/root.js






var MosanicCore = /*#__PURE__*/ function() {
    "use strict";
    function MosanicCore() {
        (0,_class_call_check/* default */.Z)(this, MosanicCore);
        (0,_define_property/* default */.Z)(this, "components", void 0);
        (0,_define_property/* default */.Z)(this, "fields", void 0);
        (0,_define_property/* default */.Z)(this, "fieldsets", void 0);
        this.components = {};
        this.fields = {};
        this.fieldsets = {};
    }
    (0,_create_class/* default */.Z)(MosanicCore, [
        {
            key: "registerComponent",
            value: function registerComponent(schema) {
                this.components = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.components), (0,_define_property/* default */.Z)({}, schema.name, (0,_object_spread/* default */.Z)({}, schema)));
            }
        },
        {
            key: "registerField",
            value: function registerField(field, schema) {
                validateRegister({
                    schema: schema,
                    type: "field"
                });
                this.fields = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.fields), (0,_define_property/* default */.Z)({}, schema.name, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, schema), {
                    render: field
                })));
            }
        },
        {
            key: "registerFieldset",
            value: function registerFieldset(fieldsetType, schema) {
                this.fieldsets = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this.fieldsets), (0,_define_property/* default */.Z)({}, fieldsetType, (0,_object_spread/* default */.Z)({}, schema)));
            }
        },
        {
            key: "schemas",
            get: function get() {
                return this.components;
            }
        },
        {
            key: "fields",
            get: function get() {
                return this.fields;
            }
        },
        {
            key: "fieldsets",
            get: function get() {
                return this.fieldsets;
            }
        }
    ]);
    return MosanicCore;
}();
var Core = function() {
    var instance;
    return {
        getInstance: function getInstance() {
            if (instance == null) {
                instance = new MosanicCore();
                // Hide the constructor so the returned object can't be new'd...
                instance.constructor = null;
            }
            return instance;
        }
    };
}();
// export const mosanic = MosanicCore.getInstance();
var mosanic = Core.getInstance();
/* harmony default export */ var root = ((/* unused pure expression or super */ null && (mosanic)));


/***/ }),

/***/ 37971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OI": function() { return /* binding */ redNoticeBorders; },
/* harmony export */   "S2": function() { return /* binding */ smoothSpin; },
/* harmony export */   "az": function() { return /* binding */ statusAttention; },
/* harmony export */   "bL": function() { return /* binding */ gradientAttentionBg; },
/* harmony export */   "lS": function() { return /* binding */ smoothAttention; },
/* harmony export */   "sF": function() { return /* binding */ redNoticeAttention; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26021);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  @keyframes smoothAttention {\n    0% {\n      transform: scale(0.9);\n      border-width: 1px;\n    }\n    50% {\n      transform: scale(1.2);\n      border-width: 1.5px;\n    }\n    100% {\n      transform: scale(0.9);\n      border-width: 1px;\n    }\n  } \n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @keyframes gradientAttentionBg {\n    0% {\n      background-position: 100% 0%\n    }\n    100% {\n      background-position: 15% 100%\n    }\n  } \n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  @keyframes redNoticeAttention {\n    0% {\n        background-color: ",
        ";\n    }\n    50% {\n      background-color: ",
        ";\n    }\n    100% {\n      background-color: ",
        ";\n    }\n  } \n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @keyframes status {\n    0% {\n        opacity: 1;\n        transform:scale(.5)\n    }\n\n    to {\n        opacity: 0;\n        transform: scale(3)\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  @keyframes redNoticeBorders {\n    0% {border-color: ",
        ";}\n    50% {border-color: ",
        ";}\n    100% {border-color: ",
        ";}\n  } \n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n  @keyframes smoothSpin {\n    0% {\n      transform: rotate(0deg);\n    }\n    25% {\n      transform: rotate(10deg);;\n    }\n    50% {\n      transform: rotate(-10deg);;\n    }\n    100% {\n      transform: rotate(0deg);\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var smoothAttention = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());
var gradientAttentionBg = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1());
var redNoticeAttention = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2(), _colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.red.base */ .ZP.util.red.base, _colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.red.dark */ .ZP.util.red.dark, _colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.red.base */ .ZP.util.red.base);
var statusAttention = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3());
var redNoticeBorders = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject4(), _colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.red.light */ .ZP.util.red.light, _colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.red.dark */ .ZP.util.red.dark, _colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].util.red.light */ .ZP.util.red.light);
var smoothSpin = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject5());



/***/ }),

/***/ 6554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* binding */ Button; },
  "ZP": function() { return /* binding */ button_styles; }
});

// UNUSED EXPORTS: Buttons

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/mosanic/styles/flex.styles.js
var flex_styles = __webpack_require__(5441);
;// CONCATENATED MODULE: ./src/utils/color/Text.js
function darkText(bgColor) {
    return computeLuminesce(bgColor) > 0.179;
}
function lightText(bgColor) {
    return !darkText(bgColor);
}
function computeLuminesce(bgColor) {
    var colors = hexToRgb(bgColor);
    var components = [
        "r",
        "g",
        "b"
    ];
    for(var i in components){
        var c = components[i];
        colors[c] = colors[c] / 255.0;
        if (colors[c] <= 0.03928) {
            colors[c] = colors[c] / 12.92;
        } else {
            colors[c] = Math.pow((colors[c] + 0.055) / 1.055, 2.4);
        }
    }
    var luminesce = 0.2126 * colors.r + 0.7152 * colors.g + 0.0722 * colors.b;
    return luminesce;
}
function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(78545);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/mosanic/styles/transition.styles.js
var transition_styles = __webpack_require__(39342);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
;// CONCATENATED MODULE: ./src/mosanic/styles/button.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    background-color: ",
        ";\n\n    svg path {\n        fill: ",
        ";\n    }\n\n    &, * {\n        color: ",
        "!important;\n    }\n    &:hover {\n        background-color: ",
        ";\n\n        &, * {\n            color: ",
        "!important;\n        }\n        svg path {\n            fill: ",
        ";\n        }\n    }\n    &:active{\n        background-color: ",
        ";\n\n        &, * {\n            color: ",
        "!important;\n        }\n        svg path {\n            fill: ",
        ";\n        }\n    }\n    \n\n    color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            svg path {\n                fill: ",
        ";\n            }\n            background: transparent;\n            color: ",
        ";\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            ",
        "\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            ",
        "\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            background-color: ",
        ";\n            border: 1px solid ",
        ";\n            color: ",
        ";\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            background-color: ",
        ";\n            border: 1px solid ",
        ";\n            color: ",
        ";\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            background-color: ",
        ";\n            border: 1px solid ",
        ";\n            color: ",
        ";\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            svg path {\n                fill: ",
        ";\n            }\n            background: transparent;\n            color: ",
        ";\n\n\n            &:hover {\n                border: 1px solid  ",
        ";\n                background-color: ",
        ";\n\n                svg path {\n                    fill: ",
        ";\n                }\n            }\n            &:active{\n                background-color: ",
        ";\n\n                &, * {\n                    color: ",
        "!important;\n                }\n                svg path {\n                    fill: ",
        ";\n                }\n            }\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            \n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            background-color: transparent;\n            color: ",
        ";\n            border: 1px solid ",
        ";\n\n            &:hover,\n            &:active{\n                background-color: ",
        ";\n            }\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            padding: 8px 16px;\n            font-size: 14px;\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            padding: 4px 8px;\n            font-size: 12px;\n        "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            padding: 4px 8px;\n            font-size: 12px;\n        "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            margin: 7.5px 10px;\n        "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            margin: 0 5px 5px;\n        "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n\n        svg {\n            ",
        "\n            transform: scale(0.7);\n        }\n        &:hover {\n            svg {\n                transform: scale(0.8);\n            }\n        }\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            box-shadow: 2px 2px 5px 0 rgba(0,0,0,0.25);\n        "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        \n        "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        ",
        "\n        ",
        "\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-color: ",
        ";\n        color: ",
        ";\n        &:focus {\n            ",
        ";\n        }\n        svg path {\n            fill: ",
        ";\n        }   \n        &:hover img ,\n        img {\n            transform: scale(0.95);\n        }\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        font-weight: bold;\n        color: #212121;\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        opacity: 0.6;\n        pointer-events: none;\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        opacity: 0.2;\n        &:hover {\n            opacity: 0.6;\n        }\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        position: absolute!important;\n        right: -10px;\n        transform: scale(0.8);\n        transform-origin: center center;\n    "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        height: 25px !important;\n        max-height: 25px !important;\n        min-height: 25px !important;\n        width: 25px !important;\n        max-width: 25px !important;\n        min-width: 25px !important;\n\n        border-radius: 50%;\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        \n        border: 1px solid ",
        "!important;\n        background: #fff;\n\n        &:hover {\n            transform: scale(0.9);\n            border: 1px solid ",
        "!important;\n\n            svg path {\n                fill: ",
        "!important;\n            }\n        }\n    "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border: none;\n    "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin-top: 5px !important;\n        color: red;\n    "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        text-align: center;\n        flex-wrap: wrap;\n        height: 45px;\n        max-height: 50px !important;\n        font-size: 10px;\n        *:not(svg) {\n            display: block;\n            width: 100%;\n        }\n    "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        text-align: center;\n        flex-wrap: wrap;\n        max-height: none!important;\n        *:not(svg) {\n            display: block;\n            width: 100%;\n        }\n    "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    border: 1px solid  transparent;\n    ",
        "\n    ",
        "\n    ",
        "\n\n\n    ",
        "\n\n    ",
        "\n    \n\n    &:focus {\n        color: ",
        ";\n        /* font-weight: bold; */\n    }\n    \n    img, svg{\n        ",
        "\n        transform: scale(0.8);\n    }\n    svg {\n        margin-right: 2px;\n    }\n    img ,svg {\n        transform-origin: center center;\n    }\n    &:hover,\n    &:active{\n        cursor: pointer;\n\n        img, svg {\n            transform: scale(1);\n        }\n    }\n\n    ",
        "\n\n    ",
        "\n    border-radius: 2px;\n    width: fit-content;\n\n    ",
        "\n\n    ",
        "\n   \n    ",
        "\n\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n\n\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        float: right;\n        margin-left: auto;\n        width: fit-content;\n    "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    ",
        " {\n        display: inline-block;\n    }\n\n    ",
        "\n    \n    ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}







var getTextColor = function(color) {
    return lightText(color) ? colors/* default.util.light */.ZP.util.light : colors/* default.util.dark */.ZP.util.dark;
};
var getStyle = function(theme) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), (ref = colors/* default.util */.ZP.util[theme]) === null || ref === void 0 ? void 0 : ref.base, (ref1 = colors/* default.util */.ZP.util[theme]) === null || ref1 === void 0 ? void 0 : ref1.lighter, getTextColor((ref2 = colors/* default.util */.ZP.util[theme]) === null || ref2 === void 0 ? void 0 : ref2.dark), (0,polished_esm/* darken */._j)(0.15, (ref3 = colors/* default.util */.ZP.util[theme]) === null || ref3 === void 0 ? void 0 : ref3.base), getTextColor((0,polished_esm/* darken */._j)(0.15, (ref4 = colors/* default.util */.ZP.util[theme]) === null || ref4 === void 0 ? void 0 : ref4.base)), (ref5 = colors/* default.util */.ZP.util[theme]) === null || ref5 === void 0 ? void 0 : ref5.light, (0,polished_esm/* darken */._j)(0.2, (ref6 = colors/* default.util */.ZP.util[theme]) === null || ref6 === void 0 ? void 0 : ref6.base), getTextColor((0,polished_esm/* darken */._j)(0.2, (ref7 = colors/* default.util */.ZP.util[theme]) === null || ref7 === void 0 ? void 0 : ref7.base)), (ref8 = colors/* default.util */.ZP.util[theme]) === null || ref8 === void 0 ? void 0 : ref8.lighter, getTextColor(colors/* default.util */.ZP.util[theme].dark));
};
var getTheme = function(theme) {
    if ([
        "red",
        "green",
        "orange"
    ].includes(theme)) {
        var ref;
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), (ref = colors/* default.util */.ZP.util[theme]) === null || ref === void 0 ? void 0 : ref.lighter, getTextColor(colors/* default.util */.ZP.util[theme].dark));
    }
    switch(theme){
        case "ghost":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), getStyle("gray"));
        case "primary":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), getStyle("primary"));
        case "secondary":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), colors/* default.util.secondary.dark */.ZP.util.secondary.dark, colors/* default.util.secondary.base */.ZP.util.secondary.base, getTextColor(colors/* default.util.secondary.dark */.ZP.util.secondary.dark));
        case "dark":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), colors/* default.util.gray.base */.ZP.util.gray.base, colors/* default.util.gray.base */.ZP.util.gray.base, getTextColor(colors/* default.util.gray.dark */.ZP.util.gray.dark));
        case "error":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), colors/* default.util.red.base */.ZP.util.red.base, colors/* default.util.gray.base */.ZP.util.gray.base, getTextColor(colors/* default.util.gray.dark */.ZP.util.gray.dark));
        case "link":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), colors/* default.util.primary.base */.ZP.util.primary.base, colors/* default.util.primary.base */.ZP.util.primary.base, colors/* default.util.gray.light */.ZP.util.gray.light, colors/* default.util.gray.lighter */.ZP.util.gray.lighter, colors/* default.util.primary.dark */.ZP.util.primary.dark, colors/* default.util.gray.light */.ZP.util.gray.light, colors/* default.util.primary.dark */.ZP.util.primary.dark, colors/* default.util.primary.base */.ZP.util.primary.base);
        case "disabled":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject8());
        //Primary
        default:
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), colors/* default.util.dark */.ZP.util.dark, colors/* default.util.dark */.ZP.util.dark, colors/* default.util.gray.lighter */.ZP.util.gray.lighter);
    }
};
var getSize = function(size) {
    switch(size){
        case "large":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject10());
        // case 'large': return css`
        //     padding: 8px 16px;
        //     font-size: 14px;
        // `;
        case "medium":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject11());
        //Small
        default:
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject12());
    }
};
var getOffset = function(offset) {
    switch(offset){
        case "large":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject13());
        //Small
        default:
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject14());
    }
};
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-f112e8eb-0"
})(_templateObject30(), function(props) {
    return getTheme(props === null || props === void 0 ? void 0 : props.theme);
}, function(props) {
    return getOffset(props === null || props === void 0 ? void 0 : props.offset);
}, function(props) {
    return getSize(props === null || props === void 0 ? void 0 : props.sz);
}, function(props) {
    return props.scale && (0,styled_components_browser_esm/* css */.iv)(_templateObject15(), (0,transition_styles/* Transitions */.h)(0.5).easeInOut);
}, function(props) {
    return props.uiButton && (0,styled_components_browser_esm/* css */.iv)(_templateObject18(), getSize("large"), function(props) {
        return props.theme != "ghost" && props.theme != "link" && !props.ghost ? (0,styled_components_browser_esm/* css */.iv)(_templateObject16()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject17());
    });
}, colors/* default.util.primary.base */.ZP.util.primary.base, (0,transition_styles/* Transitions */.h)().easeOut, function(props) {
    return props.active && (0,styled_components_browser_esm/* css */.iv)(_templateObject19(), colors/* default.util.gray.lighter */.ZP.util.gray.lighter, colors/* default.util.primary.base */.ZP.util.primary.base, colors/* default.util.primary.darker */.ZP.util.primary.darker, colors/* default.util.primary.base */.ZP.util.primary.base);
}, (0,transition_styles/* Transitions */.h)().easeOut, function(props) {
    return props.bold && (0,styled_components_browser_esm/* css */.iv)(_templateObject20());
}, function(props) {
    return props.disabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject21());
}, function(props) {
    return props.noVal && (0,styled_components_browser_esm/* css */.iv)(_templateObject22());
}, function(props) {
    return props.float && (0,styled_components_browser_esm/* css */.iv)(_templateObject23());
}, function(props) {
    return props.round && (0,styled_components_browser_esm/* css */.iv)(_templateObject24());
}, function(props) {
    return props.clear && (0,styled_components_browser_esm/* css */.iv)(_templateObject25(), colors/* default.util.red.lighter */.ZP.util.red.lighter, colors/* default.util.bright.red */.ZP.util.bright.red, colors/* default.util.bright.red */.ZP.util.bright.red);
}, function(props) {
    return props.ghost && (0,styled_components_browser_esm/* css */.iv)(_templateObject26());
}, function(props) {
    return props.cell && (0,styled_components_browser_esm/* css */.iv)(_templateObject27());
}, function(props) {
    return props.double && (0,styled_components_browser_esm/* css */.iv)(_templateObject28());
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.lines) >= 2 && (0,styled_components_browser_esm/* css */.iv)(_templateObject29());
}, flex_styles/* CenterCenter */.IV, index_esm/* layout */.bK, index_esm/* space */.Dh, index_esm/* color */.$_);
var Buttons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f112e8eb-1"
})(_templateObject32(), Button, function(props) {
    return props.right && (0,styled_components_browser_esm/* css */.iv)(_templateObject31());
}, index_esm/* layout */.bK, index_esm/* space */.Dh, index_esm/* color */.$_);
var ButtonStyles = {
    Button: Button,
    Buttons: Buttons
};
/* harmony default export */ var button_styles = (ButtonStyles);


/***/ }),

/***/ 2483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zb": function() { return /* binding */ Card; },
/* harmony export */   "kP": function() { return /* binding */ getPlanColor; }
/* harmony export */ });
/* unused harmony exports Wrapper, Tag */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2921);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26021);
/* harmony import */ var _panels__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42895);
/* harmony import */ var _transition_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39342);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78545);
/* harmony import */ var _grid_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67324);
/* harmony import */ var _flex_styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5441);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8782);
/* harmony import */ var _util_Num__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3121);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n\n    transform-origin: top left;\n    transform: scale(0.9);\n    content: 'Limit hit';\n    display: block;\n    position: absolute;\n    font-size: 10px;\n    background: ",
        ";\n    font-weight: 600;\n    /* letter-spacing: 0.5px; */\n    padding: 2.5px 6px;\n    border-radius: 4px;\n    top: 4px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        box-shadow: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        &:hover {\n            pointer: cursor;\n            transform: scale(1.025);\n            & > :is(h1, h2, h3, h4, h5, h6):hover {\n                color: ",
        ";\n            }\n        }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        width: 100%;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        text-align: center;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        display: inline-block;\n        vertical-align:top;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        background: none;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        cursor: pointer;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        border: 2px solid ",
        ";\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    \n    background-color: ",
        "; \n    /* props.theme.colors.white */\n    \n    border-radius: ",
        ";\n    padding: 10px 15px;\n\n    p.small {\n        font-size: 14px;\n    }\n\n    \n    width: 100%;\n\n    ",
        "\n    & > :is(h1, h2, h3, h4, h5, h6) {\n        color: ",
        ";\n        transition: color ease-in-out 0.1s;\n    }\n\n    ",
        "\n\n    ",
        "\n    ",
        "\n    ",
        "\n\n    ",
        "\n    ",
        "\n\n    ",
        "\n\n   \n    \n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n            border: 3px solid ",
        ";\n            box-shadow: 4px 4px 25px 0 ",
        "!important;\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n           /* border: 0.5px dashed ",
        "; */\n        "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n\n        ",
        "\n        &::before {\n            transform-origin: top right;\n            transform: scale(0.8);\n            content: ",
        ";\n            display: block;\n            position: absolute;\n            font-size: 10px;\n            background: ",
        ";\n            color: #fff;\n            font-weight: 600;\n            letter-spacing: 0.5px;\n            padding: 2.5px 6px;\n            border-radius: 4px;\n            top: 4px;\n            right: 3px;\n        }\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n            &::after {\n                ",
        "\n                content: 'Upgrade plan';\n                left: 3px;\n            }\n        "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n            opacity: 0.8;\n            filter: grayscale(0);\n\n            &:hover {\n                transform: scale(1);\n            }\n\n        "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        opacity: 0.5;\n        filter: grayscale(1);\n        transform: scale(0.9);\n\n        &:hover {\n            opacity: 1;\n            filter: grayscale(0.5);\n        }\n\n        ",
        "\n\n        ",
        "\n        \n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        &::after {\n            ",
        "\n            left: 3px;\n        }\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    position: relative;\n    ",
        "\n\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    width: 100%;\n    ",
        " {\n        /* display: inline-block; */\n    }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        float: right;\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        box-shadow: 5px 5px 10px 0 rgba(31, 31, 31, 0.045);\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        &:hover {\n            pointer: cursor; \n            transform: scale(1.025);\n        }\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        transform: scale(0.7);\n        transform-origin: top right;\n        letter-spacing: 1px;\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n            right: 0px;\n            top: 0px;\n       "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n       position: absolute;\n       ",
        "\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        height:25px;\n        border-radius: 50%;\n        svg {\n            transform: scale(0.8);\n        }\n    "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    display: block;\n    font-size: 10px;\n    background-color: ",
        ";\n    color: #fff;\n    border-radius: 4px;\n    padding: 4px 6px;\n    line-height: 100%;\n    height: 20px;\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    position: relative;\n  ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}










var Label = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.light */ .ZP.util.gray.light);
var Card = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-684eb96b-0"
})(_templateObject9(), (0,_transition_styles__WEBPACK_IMPORTED_MODULE_4__/* .Transitions */ .h)().easeOut, function(props) {
    var ref, ref1;
    return props.trans ? "transparent" : props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.light;
}, _panels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].borderRadius */ .Z.borderRadius, function(props) {
    return props.float && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), "5px 5px 15px 0 rgba(31, 31, 31, ".concat((0,_util_Num__WEBPACK_IMPORTED_MODULE_6__/* .isNumber */ .hj)(props.float) ? props.float : 0.045, ")"));
}, function(props) {
    var ref;
    return (ref = props === null || props === void 0 ? void 0 : props.theme.colors) === null || ref === void 0 ? void 0 : ref.text;
}, function(props) {
    return props.clickable && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), function(props) {
        return _colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.primary */ .ZP.util.primary[props.theme.alt];
    });
}, function(props) {
    return props.fullWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3());
}, function(props) {
    return props.center && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4());
}, function(props) {
    return props.inline && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5());
}, function(props) {
    return props.transparent && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6());
}, function(props) {
    return (props.pointer || props.onClick) && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7());
}, function(props) {
    return props.active && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8(), _colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.base */ .ZP.util.gray.base);
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .typography */ .cp, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
var getPlanColor = function(c) {
    var ref;
    return c ? (ref = _colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util */ .ZP.util[c]) === null || ref === void 0 ? void 0 : ref.base : _colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.base */ .ZP.util.gray.base;
};
var MembershipCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(Card).withConfig({
    componentId: "sc-684eb96b-1"
})(_templateObject17(), function(props) {
    return props.current && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject12(), function(props) {
        return !props.header ? (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject10(), function(props) {
            return getPlanColor(props === null || props === void 0 ? void 0 : props.bColor);
        }, function(props) {
            return (0,polished__WEBPACK_IMPORTED_MODULE_7__/* .lighten */ .$n)(0.3, getPlanColor(props === null || props === void 0 ? void 0 : props.bColor));
        }) : (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject11(), function(props) {
            return getPlanColor(props === null || props === void 0 ? void 0 : props.bColor);
        });
    }, function(props) {
        return props.addon ? "Active addon" : "Current plan";
    }, function(props) {
        return getPlanColor(props === null || props === void 0 ? void 0 : props.bColor);
    });
}, function(props) {
    return props.unavailable && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject15(), props.addon && !props.current && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject13(), Label), (props === null || props === void 0 ? void 0 : props.addon) && props.current && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject14()));
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.hitLimit) && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject16(), Label);
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-684eb96b-2"
})(_templateObject18(), _flex_styles__WEBPACK_IMPORTED_MODULE_8__/* .RowWrap */ .xv, (Card, _grid_styles__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .JX));
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-684eb96b-3"
})(_templateObject26(), (0,_transition_styles__WEBPACK_IMPORTED_MODULE_4__/* .Transitions */ .h)().easeOut, function(props) {
    var ref;
    return props.bg ? (ref = _colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util */ .ZP.util[props.bg]) === null || ref === void 0 ? void 0 : ref.dark : _colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].util.gray.darker */ .ZP.util.gray.darker;
}, function(props) {
    return props.right && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject19());
}, function(props) {
    return props.float && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject20());
}, function(props) {
    return props.clickable && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject21());
}, function(props) {
    return props.xs && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject22());
}, function(props) {
    return props.abs && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject24(), function(props) {
        return props.right && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject23());
    });
}, function(props) {
    return props.round && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject25());
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .typography */ .cp, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
var Block = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-684eb96b-4"
})(_templateObject27(), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .typography */ .cp, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
var CardStyles = {
    MembershipCard: MembershipCard,
    Wrapper: Wrapper,
    Card: Card,
    Block: Block,
    Tag: Tag
};
/* harmony default export */ __webpack_exports__["ZP"] = (CardStyles);


/***/ }),

/***/ 2921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C0": function() { return /* binding */ light; },
/* harmony export */   "TD": function() { return /* binding */ getEditorAtrColor; },
/* harmony export */   "TM": function() { return /* binding */ panel; }
/* harmony export */ });
/* unused harmony exports darkColors, utilColors */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96670);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8782);



var skyBlue = "#1082e9";
var skyBlueDark = "#0b5aa2";
var light = {
    primary: skyBlue,
    primaryDark: skyBlueDark
};
var dark = {
    primary: "#fff",
    primaryDark: "#d0d0d0"
};
var utilBase = {
    light: "#fff",
    dark: "#222",
    primary: {
        darkest: "#052543",
        darker: "#083f72",
        dark: light.primaryDark,
        base: light.primary,
        light: "#2A9CFF",
        lighter: "#43B5FF",
        trans: "#067affe1",
        underlay: "rgba(6, 122, 255, 0.128)"
    },
    secondary: {
        darkest: "#2c2d30",
        darker: "#45464a",
        dark: "#5d5f64",
        base: "#7d818d",
        light: "#e7e9ed",
        lighter: "#f4f7fa",
        lightest: "#f8fafc",
        trans: "#fcfdfe"
    },
    green: {
        dark: "#40792E",
        base: "#84B36A",
        light: "#ffffff46",
        lighter: "#EDFADC",
        trans: "#40792ee1",
        underlay: "rgba(97, 164, 98, 0.128)"
    },
    red: {
        dark: "#4b0606",
        base: "#de1e0c",
        light: "#b80f0f",
        lighter: "#e71313",
        trans: "#f36d6d",
        underlay: "#f79c9c"
    },
    orange: {
        dark: "#bb7300",
        base: "#ff9d00",
        light: "#ffffff46",
        lighter: "#f9d291",
        trans: "#f79b06e1",
        underlay: "rgba(255, 157, 0, 0.128)",
        mark: "rgba(255, 157, 0, 0.228)"
    },
    gray: {
        darkest: "#2c2d30",
        darker: "#45464a",
        dark: "#5d5f64",
        base: "#7d818d",
        light: "#e7e9ed",
        lighter: "#f4f7fa",
        lightest: "#f8fafc",
        trans: "#fcfdfe"
    },
    bright: {
        green: "#2bd67b",
        red: "#f41d1d",
        orange: "#ff9d00",
        blue: light.primaryDark,
        primary: light.primary,
        gray: "#7d818d"
    }
};
var genShades = function(base, keep) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, keep), {
        darkest: (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .darken */ ._j)(0.4, base),
        darker: (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .darken */ ._j)(0.2, base),
        dark: (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .darken */ ._j)(0.05, base),
        base: base,
        light: (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .lighten */ .$n)(0.2, base),
        lighter: (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .lighten */ .$n)(0.4, base),
        lightest: (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .lighten */ .$n)(0.5, base),
        trans: (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .rgba */ .m4)((0,polished__WEBPACK_IMPORTED_MODULE_2__/* .lighten */ .$n)(0.4, base), 0.3),
        underlay: (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .rgba */ .m4)((0,polished__WEBPACK_IMPORTED_MODULE_2__/* .lighten */ .$n)(0.4, base), 0.2)
    });
};
var util = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, utilBase), {
    primary: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, utilBase.primary, genShades(utilBase.primary.base, null)),
    red: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, utilBase.red, genShades(utilBase.red.base, null))
});
var panel = {
    light: "#FCFCFD",
    dark: "#222"
};
var colors = {
    light: light,
    dark: dark,
    util: util,
    panel: panel
};
var getEditorAtrColor = function(type) {
    var shade = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "base";
    switch(type){
        case "border":
            return colors.util.primary[shade];
        case "padding":
            return colors.util.green[shade];
        case "margin":
            return colors.util.orange[shade];
        case "docking":
            return colors.util.orange[shade];
        default:
            return colors.util.primary[shade];
    }
};

/* harmony default export */ __webpack_exports__["ZP"] = (colors);


/***/ }),

/***/ 5441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IV": function() { return /* binding */ CenterCenter; },
/* harmony export */   "i9": function() { return /* binding */ SpaceBetween; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "xv": function() { return /* binding */ RowWrap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26021);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: flex-start;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    flex-direction: row;\n    flex-wrap: wrap;\n    width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    justify-content: space-between;\n    align-content: stretch;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    align-items: center; /* y */\n    justify-content: center;  /* x */\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        justify-content: ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var Base = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());
var RowNoWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1(), Base);
var RowWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2(), Base);
var SpaceBetween = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3(), RowNoWrap);
var CenterCenter = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject4(), Base);
var Flex = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7347d6f0-0"
})(_templateObject6(), RowNoWrap, function(props) {
    return props.justify && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject5(), props.justify);
});
var FlexStyles = {
    Base: Base,
    RowNoWrap: RowNoWrap,
    SpaceBetween: SpaceBetween,
    CenterCenter: CenterCenter,
    RowWrap: RowWrap
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (FlexStyles)));



/***/ }),

/***/ 67324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eq": function() { return /* binding */ Wrap; },
/* harmony export */   "JX": function() { return /* binding */ Col; }
/* harmony export */ });
/* unused harmony export Row */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26021);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78545);
/* harmony import */ var _flex_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5441);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    transition: background-color 0.3s ease-out;\n    position: relative;\n    width: 50%;\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n\n    ",
        "\n    ",
        "\n\n    &,\n    & > *,\n    & > :is(h1, h2, h3, h5, h6, p, b, strong, span) {\n        color: ",
        ";\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        background: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    display: flex;\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var Col = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c485bd54-0"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .flexbox */ .GQ, function(props) {
    var ref, ref1;
    return props.background ? "background: ".concat(props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.white, ";") : "";
}, function(props) {
    return props.center && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _flex_styles__WEBPACK_IMPORTED_MODULE_3__/* .CenterCenter */ .IV);
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.text;
});
var Row = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c485bd54-1"
})(_templateObject2(), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .flexbox */ .GQ);
var Wrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c485bd54-2"
})(_templateObject4(), function(props) {
    return props.bg && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), function(props) {
        var ref, ref1;
        return (props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.white) === "#FFFFFF" ? (props === null || props === void 0 ? void 0 : props.white) ? "#F9FBFC" : "#f5f5f5" : "#222";
    });
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .flexbox */ .GQ, _flex_styles__WEBPACK_IMPORTED_MODULE_3__/* .RowWrap */ .xv);
var GridStyles = {
    Col: Col,
    Row: Row,
    Wrap: Wrap
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (GridStyles)));


/***/ }),

/***/ 42895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70865);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2921);


var panelStyles = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    borderRadius: "4px"
}, _colors__WEBPACK_IMPORTED_MODULE_1__/* .panelColors */ .TM);
/* harmony default export */ __webpack_exports__["Z"] = (panelStyles);


/***/ }),

/***/ 39342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Transitions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26021);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "transition: ",
        " ",
        "s cubic-bezier(0.42, 0, 0.58, 1);"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "transition: ",
        " ",
        "s cubic-bezier(0.25, 0.1, 0.25, 1);"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "transition: ",
        " ",
        "s cubic-bezier(0.42, 0, 1, 1);"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "transition: ",
        " ",
        "s cubic-bezier(0, 0, 0.58, 1);"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "transition: ",
        " ",
        "s cubic-bezier(0, 0, 1, 1);"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Transitions = function() {
    var timing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.3, prop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all";
    return {
        easeInOut: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject(), prop, timing),
        ease: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1(), prop, timing),
        easeIn: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2(), prop, timing),
        easeOut: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3(), prop, timing),
        linear: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject4(), prop, timing)
    };
};


/***/ }),

/***/ 5070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ClearBoth; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26021);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    &:after {\n        clear: both;\n        display: block;\n        content: '';\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ClearBoth = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c658ea4e-0"
})(_templateObject());


/***/ }),

/***/ 82583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V5": function() { return /* binding */ toVarCase; },
/* harmony export */   "sn": function() { return /* binding */ getLowCaseElementType; },
/* harmony export */   "vA": function() { return /* binding */ getElementTitle; },
/* harmony export */   "vC": function() { return /* binding */ toClassName; }
/* harmony export */ });
/* unused harmony exports getContainerClass, getInspectorClass, getChildrenCountClass, getGroupType, getElementType */
/* harmony import */ var _mosanic_utils_validate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32646);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68311);


// * Identifiers
var toVarCase = function(string) {
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(string) ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .toLowCase */ .Cc)(string.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9_-]/g, "")) : null;
};
/**
 * Generate unique styling classname
 * @param {*} objType 
 * @param {*} type 
 * @param {*} _id 
 * @param {*} parseId 
 * @returns 
 */ var toClassName = function(objType, type, _id) {
    var parseId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 12;
    if (!objType || !type || !_id) return "";
    if ((0,_mosanic_utils_validate__WEBPACK_IMPORTED_MODULE_1__/* .isComponent */ .pE)(objType)) objType = "cmp";
    var base = objType != type ? "".concat(capRemoveVowels(objType)).concat(capRemoveVowels(type)) : "".concat(capRemoveVowels(objType));
    var parsed_id = "".concat(_id.substring(1, parseId / 2)).concat(_id.substring(_id.length - parseId / 2));
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(_id) ? "".concat(base).concat(parsed_id) : "".concat(base).concat(_id);
};
/**
 * ! local
 * Shorthand remove vowels and capitalize
 * @param {*} string 
 * @returns 
 */ var capRemoveVowels = function(string) {
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .capitalizeFirst */ .Ez)((0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .removeVowels */ .W9)(string));
};
// * Custom classes 
/**
 * Get container item classname
 * @param {*} type 
 * @param {*} className 
 * @returns 
 */ function getContainerClass(type, className) {
    return "draggable ".concat(toLowCase(type), " ").concat(className != undefined ? className : "");
}
/**
 * Get Current inspector state
 * @returns classes (string)
 */ function getInspectorClass(data) {
    var isHovered = data.isHovered, isInspected = data.isInspected, isCloned = data.isCloned;
    var classes = isHovered ? "-hover " : "";
    classes += isInspected ? "-active " : "";
    classes += isCloned ? "-clone " : "";
    var getCurrentState = function() {
        return classes;
    };
    return getCurrentState();
}
/**
 * Used for dropBox empty sizing
 * @param {childCount} length 
 * @returns 
 */ var getChildrenCountClass = function(length) {
    return length ? "childs-" + length : "empty";
};
// * Types
var getGroupType = function(data) {
    return (data === null || data === void 0 ? void 0 : data.type) ? toLowCase(data.type, "s") : "";
};
var getElementType = function(element, map) {
    return (0,_mosanic_utils_validate__WEBPACK_IMPORTED_MODULE_1__/* .isComp */ .Rr)(map === null || map === void 0 ? void 0 : map.type) ? element === null || element === void 0 ? void 0 : element.type : map === null || map === void 0 ? void 0 : map.type;
};
var getLowCaseElementType = function(element, map) {
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .toLowCase */ .Cc)(getElementType(element, map));
};
var getElementTitle = function(element, type) {
    return (element === null || element === void 0 ? void 0 : element.title) ? element.title : (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .capitalizeFirst */ .Ez)(type);
};



/***/ }),

/***/ 73987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Or": function() { return /* binding */ isImage; },
/* harmony export */   "vl": function() { return /* binding */ isExternalImageSrc; },
/* harmony export */   "yO": function() { return /* binding */ parseImageSrc; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66383);
/* harmony import */ var _api_host__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6539);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68311);
/* harmony import */ var _mosanic_fields_Video__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26518);







var isSvgImage = function(url) {
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .containsSubstr */ .xX)(url, ".svg");
};
var getMosanicSrc = function(imageUrl) {
    return (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) && (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.urlMin) ? {
        full: imageUrl.url,
        min: imageUrl.urlMin,
        thumb: isSvgImage(imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) ? imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url : (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.urlThumb) ? imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.urlThumb : imageUrl.urlMin
    } : {
        full: imageUrl,
        min: imageUrl,
        thumb: imageUrl
    };
};
var isWordpressSrc = function(imageUrl) {
    var ref;
    return imageUrl === null || imageUrl === void 0 ? void 0 : (ref = imageUrl.sizes) === null || ref === void 0 ? void 0 : ref.thumbnail;
};
var isExternalImageSrc = function(img) {
    return isWordpressSrc(img) || (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .containsSubstr */ .xX)(img, "https://");
};
var getExternalSrc = function(imageUrl) {
    var ref, ref1;
    return isWordpressSrc(imageUrl) ? {
        full: imageUrl.url,
        min: (ref = imageUrl.sizes) === null || ref === void 0 ? void 0 : ref.medium,
        thumb: imageUrl === null || imageUrl === void 0 ? void 0 : (ref1 = imageUrl.sizes) === null || ref1 === void 0 ? void 0 : ref1.thumbnail
    } : {
        full: imageUrl,
        min: imageUrl,
        thumb: imageUrl
    };
};
var getFullSrc = function(srcset) {
    var full = {};
    Object.entries(srcset).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), size = _param[0], url = _param[1];
        full = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, full), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, size, (0,_api_host__WEBPACK_IMPORTED_MODULE_5__/* .getImageUrl */ .Jn)(url)));
    });
    return full;
};
var isImage = function(url) {
    return url && !(0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .matchSubstrList */ .OV)((0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .toLowCase */ .Cc)(url), [
        ".mp4",
        ".mov"
    ]) && (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .matchSubstrList */ .OV)((0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .toLowCase */ .Cc)(url), ".jpg|.png|.svg|.jpeg|.webp|.svg".split("|"));
};
var parseImageSrc = function(imageUrl) {
    var fullSrc = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var isExternal = isExternalImageSrc(imageUrl);
    var source = isExternal ? getExternalSrc(imageUrl) : getMosanicSrc(imageUrl);
    return isImage(source === null || source === void 0 ? void 0 : source.full) || (0,_mosanic_fields_Video__WEBPACK_IMPORTED_MODULE_6__/* .isVideo */ .Wv)(source === null || source === void 0 ? void 0 : source.full) ? fullSrc && !isExternal ? getFullSrc(source) : source : false;
};


/***/ }),

/***/ 56831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ ObjectID; }
/* harmony export */ });
// import { ObjectId } from "bson";
var ObjectId = function ObjectId() {
    var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    return timestamp + "xxxxxxxxxxxxxxxx".replace(/[x]/g, function() {
        return (Math.random() * 16 | 0).toString(16);
    }).toLowerCase();
};
/**
 * Get a new object ID
 * @returns string
 */ var ObjectID = function() {
    return ObjectId().toString();
};


/***/ }),

/***/ 95048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ getSiteUrl; },
/* harmony export */   "Th": function() { return /* binding */ SiteUrl; },
/* harmony export */   "j5": function() { return /* binding */ getSubDomainUrl; },
/* harmony export */   "jY": function() { return /* binding */ siteSlugUrl; },
/* harmony export */   "z4": function() { return /* binding */ getSiteSlug; }
/* harmony export */ });
/* unused harmony export parseSiteUrl */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50930);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68311);


var defaultHost = "mosanic.io";
var SiteUrl = function(param) {
    var site = param.site;
    return site ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .combineString */ .M7)([
        !(site === null || site === void 0 ? void 0 : site.customDomain) ? site === null || site === void 0 ? void 0 : site.subdomain : "",
        (site === null || site === void 0 ? void 0 : site.customDomain) ? site.customDomain : defaultHost
    ], ".") : "";
};
var getSiteUrl = function(site) {
    return site ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .combineString */ .M7)([
        !(site === null || site === void 0 ? void 0 : site.customDomain) ? site === null || site === void 0 ? void 0 : site.subdomain : "",
        (site === null || site === void 0 ? void 0 : site.customDomain) ? site.customDomain : defaultHost
    ], ".") : "";
};
var getSubDomainUrl = function(site) {
    return site ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .combineString */ .M7)([
        site === null || site === void 0 ? void 0 : site.subdomain,
        defaultHost
    ], ".") : "";
};
var parseSiteUrl = function(siteUrl) {
    if (containsSubstr(siteUrl, ".".concat(defaultHost))) return removePart(siteUrl, ".".concat(defaultHost));
    if (getDotCountInString(siteUrl) >= 2) return {
        subdomain: subStringTill(siteUrl, "."),
        customDomain: subStringFrom(siteUrl, ".")
    };
    return siteUrl;
};
var getSiteSlug = function() {
    var current = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var baseSlug = [
        {
            href: "/",
            label: "Dashboard"
        },
        {
            href: "/site/",
            label: name ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .excerptString */ .dK)(name, 12, "...") : "Site"
        }, 
    ];
    return current ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(baseSlug).concat([
        {
            label: current
        }
    ]) : baseSlug;
};
var siteSlugUrl = function(sub) {
    return sub && sub != "site" ? "/site/".concat(sub) : "/site";
};


/***/ }),

/***/ 32428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ extendClone; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var extendClone = function(props, children) {
    return children && props ? react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function(child) {
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(child) ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, props) : child;
    }) : children;
};


/***/ }),

/***/ 69735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getFieldNames; },
/* harmony export */   "V": function() { return /* binding */ getFields; }
/* harmony export */ });
var getFields = function(schema, fieldType) {
    return schema === null || schema === void 0 ? void 0 : schema.filter(function(f) {
        return (f === null || f === void 0 ? void 0 : f.type) === fieldType;
    });
};
var getFieldNames = function(schema) {
    return schema === null || schema === void 0 ? void 0 : schema.map(function(f) {
        return f.name;
    });
};


/***/ }),

/***/ 12778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XW": function() { return /* binding */ createUpdateEntry; },
/* harmony export */   "oz": function() { return /* binding */ createNewEntry; },
/* harmony export */   "px": function() { return /* binding */ addEntry; }
/* harmony export */ });
/* unused harmony export updateEntry */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50930);
/* harmony import */ var _ObjectID__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56831);






//Entries
var createNewEntry = function(entry, userId) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        date: new Date(),
        updatedAt: new Date(),
        _id: (0,_ObjectID__WEBPACK_IMPORTED_MODULE_1__/* .ObjectID */ .t)(),
        userId: userId
    }, entry);
};
var createUpdateEntry = function(entry) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, entry), {
        updatedAt: new Date()
    });
};
// Collections
var addEntry = function(collection, entry) {
    return (collection === null || collection === void 0 ? void 0 : collection.entries) ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, collection), {
        entries: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(collection.entries).concat([
            entry
        ])
    }) : (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, collection), {
        entries: [
            entry
        ]
    });
};
var updateEntry = function(collection, entry) {
    return _object_spread_props(_object_spread({}, collection), {
        entries: collection.entries.map(function(e) {
            return e._id === entry._id ? _object_spread({}, e, entry) : e;
        })
    });
};


/***/ }),

/***/ 45371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ DataFactory; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _mosanic_constants_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46993);
/* harmony import */ var _mosanic_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40607);
/* harmony import */ var _redux_map_data__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var _transform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2467);







//Get base item data and map
var getItem = function(param) {
    var _type = param.type, type = _type === void 0 ? "column" : _type;
    var item = (0,_mosanic_constants_components__WEBPACK_IMPORTED_MODULE_0__/* .getInitialComponent */ .BT)(type);
    if (!item) return null;
    return (0,_transform__WEBPACK_IMPORTED_MODULE_1__/* .transformInitialItem */ ._3)({
        item: item
    });
};
//Get base items data and map
var getItems = function(param) {
    var _type = param.type, type = _type === void 0 ? "column" : _type, _count = param.count, count = _count === void 0 ? 2 : _count;
    var items = [];
    var item = (0,_mosanic_constants_components__WEBPACK_IMPORTED_MODULE_0__/* .getInitialComponent */ .BT)(type);
    if (!item) return [];
    for(var index = 0; index < count; index++){
        items.push((0,_transform__WEBPACK_IMPORTED_MODULE_1__/* .transformInitialItem */ ._3)({
            item: item
        }));
    }
    return items;
};
//Initialize data of items
var initItems = function(param, dispatch) {
    var items = param.items;
    if (!Array.isArray(items) || items.length <= 0) return;
    items.map(function(item) {
        dispatch(_redux_map_data__WEBPACK_IMPORTED_MODULE_2__/* .dataActions.initDataAction */ .tD.initDataAction({
            component: item.component
        }));
    });
};
//Add items to map
var addItems = function(param) {
    var itemMap = param.itemMap, items = param.items;
    if (!Array.isArray(items) || items.length <= 0) return;
    items.map(function(item, index) {
        itemMap.children = (0,_mosanic_map__WEBPACK_IMPORTED_MODULE_3__/* .addChildToChildren */ .L)({
            children: (itemMap === null || itemMap === void 0 ? void 0 : itemMap.children) ? itemMap.children : [],
            dropPath: [
                index
            ],
            item: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, item.itemMap), {
                path: undefined
            })
        });
    });
    return itemMap;
};
//Automatic factory for columns
var columns = function(param, dispatch) {
    var itemMap = param.itemMap, _count = param.count, count = _count === void 0 ? 2 : _count;
    var items = getItems({
        count: count
    });
    initItems({
        items: items
    }, dispatch);
    return addItems({
        itemMap: itemMap,
        items: items
    });
};
//Automatic factory for wrapper
var wrapper = function(param, dispatch) {
    var itemMap = param.itemMap, type = param.type;
    var wrapperItem = getItem({
        type: type
    });
    initItems({
        items: [
            wrapperItem
        ]
    }, dispatch);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, wrapperItem.itemMap), {
        children: [
            itemMap
        ]
    });
};
var DataFactory = {
    getItem: getItem,
    getItems: getItems,
    initItems: initItems,
    addItems: addItems,
    columns: columns,
    wrapper: wrapper
};


/***/ }),

/***/ 60018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FW": function() { return /* binding */ getOptions; },
/* harmony export */   "et": function() { return /* binding */ useData; }
/* harmony export */ });
/* unused harmony export getVariant */
/* harmony import */ var _mosanic_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91051);
/* harmony import */ var _mosanic_core_Map_Styles_parseAttr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59986);
/* harmony import */ var _mosanic_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15901);




var getOptions = function(options) {
    var parsed = {
        main: (options === null || options === void 0 ? void 0 : options.main) ? options.main : undefined,
        clone: (options === null || options === void 0 ? void 0 : options.clone) ? options.clone : undefined,
        link: (options === null || options === void 0 ? void 0 : options.link) ? options.link : undefined,
        component: (options === null || options === void 0 ? void 0 : options.component) ? options.component : undefined
    };
    return parsed ? parsed : undefined;
};
var getVariant = function(param) {
    var source = param.source, screen = param.screen, field = param.field;
    return !source ? null : hasAttr(source, screen) ? source[screen][field] : hasAttr(source, Variants.BASE) ? source[screen][Variants.BASE] : null;
};
//Get component data by screen variant or other specific variants
var useData = function(param) {
    var component = param.component, _screen = param.screen, screen = _screen === void 0 ? _mosanic_constants__WEBPACK_IMPORTED_MODULE_0__/* .Variants.BASE */ .tr.BASE : _screen, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, applyBase = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, overwrite = arguments.length > 2 ? arguments[2] : void 0;
    var validate = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useValidate */ ._)(component === null || component === void 0 ? void 0 : component.state, screen);
    var data = component === null || component === void 0 ? void 0 : component.data;
    var padding = (0,_mosanic_core_Map_Styles_parseAttr__WEBPACK_IMPORTED_MODULE_2__/* .getAttrGroup */ .np)(data === null || data === void 0 ? void 0 : data.padding, validate);
    var margin = (0,_mosanic_core_Map_Styles_parseAttr__WEBPACK_IMPORTED_MODULE_2__/* .getAttrGroup */ .np)(data === null || data === void 0 ? void 0 : data.margin, validate);
    var corner = (0,_mosanic_core_Map_Styles_parseAttr__WEBPACK_IMPORTED_MODULE_2__/* .getAttrGroup */ .np)(data === null || data === void 0 ? void 0 : data.corner, validate);
    return {
        padding: padding,
        margin: margin,
        corner: corner
    };
};


/***/ }),

/***/ 2467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ci": function() { return /* binding */ transformInitialItemFull; },
/* harmony export */   "_3": function() { return /* binding */ transformInitialItem; },
/* harmony export */   "_B": function() { return /* binding */ copyItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _mosanic_map_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9528);
/* harmony import */ var _mosanic_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56831);
/* harmony import */ var _mosanic_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82583);
/* harmony import */ var _factory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45371);





var transformInitialItem = function(param) {
    var item = param.item;
    var base = (item === null || item === void 0 ? void 0 : item.component) ? item.component : item;
    var ref = {
        itemType: (0,_mosanic_map_type__WEBPACK_IMPORTED_MODULE_0__/* .getItemType */ .YF)(base.type),
        group: (0,_mosanic_map_type__WEBPACK_IMPORTED_MODULE_0__/* .getItemGroup */ .ZA)(base.type),
        _id: (0,_mosanic_utils__WEBPACK_IMPORTED_MODULE_1__/* .ObjectID */ .t)()
    };
    var itemMap = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        type: base.type
    }, ref), {
        // wrapper: base?.wrapper ? base.wrapper : undefined, // automatic 
        children: transformItemChildren(base, ref)
    });
    var component = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, base, ref);
    return {
        itemMap: itemMap,
        component: component
    };
};
var transformInitialItemFull = function(param, dispatch) {
    var item = param.item;
    var ref = transformInitialItem({
        item: item
    }), itemMap = ref.itemMap, component = ref.component;
    if ((0,_mosanic_map_type__WEBPACK_IMPORTED_MODULE_0__/* .isColumns */ .Uw)(component.type) && dispatch) itemMap = _factory__WEBPACK_IMPORTED_MODULE_4__/* .DataFactory.columns */ .x.columns({
        itemMap: itemMap
    }, dispatch);
    return [
        itemMap,
        component
    ];
};
var copyItem = function(param) {
    var item = param.item;
    var ref = {
        itemType: (0,_mosanic_map_type__WEBPACK_IMPORTED_MODULE_0__/* .getItemType */ .YF)(item.type),
        group: (0,_mosanic_map_type__WEBPACK_IMPORTED_MODULE_0__/* .getItemGroup */ .ZA)(item.type),
        _id: (0,_mosanic_utils__WEBPACK_IMPORTED_MODULE_1__/* .ObjectID */ .t)()
    };
    var itemMap = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        type: item.type
    }, ref), {
        // wrapper: base?.wrapper ? base.wrapper : undefined, // automatic 
        children: transformItemChildren(item, ref)
    });
    var component = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, item, ref), {
        className: (0,_mosanic_utils__WEBPACK_IMPORTED_MODULE_5__/* .toClassName */ .vC)(ref.itemType, item === null || item === void 0 ? void 0 : item.type, ref._id),
        sourceItemPath: undefined // todo validate
    });
    return {
        itemMap: itemMap,
        component: component
    };
};
var transformItemChildren = function(base, ref) {
    if (base === null || base === void 0 ? void 0 : base.children) return base.children;
    if ((0,_mosanic_map_type__WEBPACK_IMPORTED_MODULE_0__/* .isContainer */ .Nm)(ref.itemType)) return (base === null || base === void 0 ? void 0 : base.children) ? base.children : [];
    return undefined;
};


/***/ }),

/***/ 24730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D7": function() { return /* binding */ useEntryReplaceUserFields; },
/* harmony export */   "NH": function() { return /* binding */ replaceEntryPageProps; },
/* harmony export */   "Sq": function() { return /* binding */ setDefaultEntryValues; },
/* harmony export */   "XA": function() { return /* binding */ useEntryReplaceSlugField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66383);
/* harmony import */ var _mosanic_cms_Query_public__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74063);
/* harmony import */ var _collection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69735);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68311);
/* harmony import */ var _Site__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95048);
/* harmony import */ var _mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18780);









// ? # Manipulation for rendering 
// --> For data ctx and mailings
var useEntryReplaceUserFields = function(param) {
    var entry = param.entry, schema = param.schema;
    var userRefs = (0,_collection__WEBPACK_IMPORTED_MODULE_0__/* .getFieldNames */ .I)((0,_collection__WEBPACK_IMPORTED_MODULE_0__/* .getFields */ .V)(schema, "user"));
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_mosanic_cms_Query_public__WEBPACK_IMPORTED_MODULE_2__/* .useGetUsersPublic */ .Y)({
        filter: {
            OR: userRefs === null || userRefs === void 0 ? void 0 : userRefs.map(function(fieldName) {
                return {
                    _id: entry === null || entry === void 0 ? void 0 : entry[fieldName]
                };
            })
        }
    }), 3), users = ref[0], loadingUsers = ref[1], errorUsers = ref[2];
    if (!loadingUsers && userRefs) {
        userRefs.map(function(ref) {
            entry = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, ref, users === null || users === void 0 ? void 0 : users.find(function(user) {
                return user._id === entry[ref];
            })));
        });
    }
    return entry;
};
// --> For data ctx and mailings
var useEntryReplaceSlugField = function(param) {
    var entry = param.entry, baseRoute = param.baseRoute, _pointer = param.pointer, pointer = _pointer === void 0 ? "_id" : _pointer;
    var siteId = (0,_mosanic_cms_Query__WEBPACK_IMPORTED_MODULE_6__/* .useSiteId */ .CG)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_mosanic_cms_Query_public__WEBPACK_IMPORTED_MODULE_2__/* .useGetSitesPublic */ .q)({
        siteId: (entry === null || entry === void 0 ? void 0 : entry.siteId) ? entry.siteId : siteId
    }), 3), site = ref[0], loadingSite = ref[1], errorSite = ref[2];
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry), {
        slug: (0,_util_Text__WEBPACK_IMPORTED_MODULE_7__/* .combineString */ .M7)([
            (0,_Site__WEBPACK_IMPORTED_MODULE_8__/* .getSiteUrl */ .$2)(site),
            baseRoute,
            entry[pointer]
        ], "/")
    });
};
// ? # Manipulation for saving 
var getPageProp = function(type, pageProps) {
    if (type === "user" && (pageProps === null || pageProps === void 0 ? void 0 : pageProps.author)) return pageProps.author;
    if (type === "relation" && (pageProps === null || pageProps === void 0 ? void 0 : pageProps.entryId)) return pageProps.entryId;
    return null;
};
var replaceEntryPageProps = function(param) {
    var entry = param.entry, schema = param.schema, pageProps = param.pageProps;
    if (pageProps.author) {
        entry = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry), {
            queryId: pageProps === null || pageProps === void 0 ? void 0 : pageProps.author
        });
    }
    schema.map(function(f) {
        if (f.pageProp) entry = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, f.name, getPageProp(f.type, pageProps)));
        //Todo handle repeaters etc.
        if ((f === null || f === void 0 ? void 0 : f.schema) && f.type === "group") {
            entry = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, f.name, replaceEntryPageProps({
                entry: entry[f.name],
                schema: f.schema,
                pageProps: pageProps
            })));
        }
    });
    return entry;
};
var setDefaultEntryValues = function(param) {
    var entry = param.entry, schema = param.schema;
    schema.map(function(f) {
        if (f.default && !entry[f.name]) entry = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, f.name, f.default));
        //Todo handle repeaters etc.
        if ((f === null || f === void 0 ? void 0 : f.schema) && f.type === "group") entry = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, entry), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, f.name, setDefaultEntryValues({
            entry: entry[f.name],
            schema: f.schema
        })));
    });
    return entry;
};


/***/ }),

/***/ 96346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ convertTemplate; },
  "y": function() { return /* binding */ useEntryMailConversion; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/useDataQuery.js
var useDataQuery = __webpack_require__(49974);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
;// CONCATENATED MODULE: ./src/mosanic/utils/replace.js

function bold(text) {
    var bold = /\*\*(.*?)\*\*/gm;
    return text.replace(bold, "<strong>$1</strong>");
}
function underline(text) {
    var underline = /\_\_\_(.*?)\_\_\_/gm;
    return text.replace(underline, "<u>$1</u>");
}
function strike(text) {
    var underline = /\~\~(.*?)\~\~/gm;
    return text.replace(underline, "<del>$1</del>");
}
function italic(text) {
    var underline = /\_\_(.*?)\_\_/gm;
    return text.replace(underline, "<i>$1</i>");
}
function upper(text) {
    // const upperCase = /\[\[(.*?)\]\]/gm;
    // text = text.replace(underline, upperCase)
    // return text.replace(underline, '$1');     
    return text;
}
function heading(text) {
    var headings = {
        h1: /\h1(.*?)\h1/gm,
        h2: /\h2(.*?)\h2/gm,
        h3: /\h3(.*?)\h3/gm,
        h4: /\h4(.*?)\h4/gm,
        h5: /\h5(.*?)\h5/gm,
        h6: /\h6(.*?)\h6/gm
    };
    Object.entries(headings).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), tag = _param[0], regex = _param[1];
        text = text.replace(regex, "<".concat(tag, ">$1</").concat(tag, ">"));
    });
    return text;
}
var formatText = function(text) {
    return text ? bold(underline(strike(heading(italic(text))))) : text;
};

// EXTERNAL MODULE: ./src/mosanic/utils/value.js + 1 modules
var utils_value = __webpack_require__(11039);
// EXTERNAL MODULE: ./src/mosanic/utils/entry.js
var utils_entry = __webpack_require__(24730);
;// CONCATENATED MODULE: ./src/mosanic/utils/mail.js






var useEntryMailConversion = function(param) {
    var entry = param.entry, template = param.template, schema = param.schema, baseRoute = param.baseRoute;
    entry = (0,useDataQuery/* convertEntry */.ec)(entry ? entry : {});
    entry = (0,utils_entry/* useEntryReplaceUserFields */.D7)({
        entry: entry,
        schema: schema
    });
    entry = (0,utils_entry/* useEntryReplaceSlugField */.XA)({
        entry: entry,
        baseRoute: baseRoute
    });
    return convertTemplate({
        template: template,
        entry: entry
    });
};
var convertTemplate = function(param) {
    var template = param.template, entry = param.entry;
    var replaceValue = function(key, value) {
        return (0,Text/* containsSubstr */.xX)(value, "\n") ? (0,Text/* replaceParts */.oE)(formatText((0,utils_value/* replaceWithSource */.yL)(value, entry)), "\n", "<br/>") : formatText((0,utils_value/* replaceWithSource */.yL)(value, entry));
    };
    return template ? Object.fromEntries(Object.entries(template).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return [
            key,
            replaceValue(key, value)
        ];
    })) : null;
};


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ addChildToChildren; },
/* harmony export */   "i": function() { return /* binding */ handleNewItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50930);
/* harmony import */ var _util_Arr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72393);





var addChildToChildren = function(param) {
    var children = param.children, dropPath = param.dropPath, item = param.item;
    if ((dropPath === null || dropPath === void 0 ? void 0 : dropPath.length) === 1) {
        var dropZoneIndex = Number(dropPath[0]);
        return (0,_util_Arr__WEBPACK_IMPORTED_MODULE_0__/* .insert */ .$T)(children, dropZoneIndex, item);
    }
    var updatedChildren = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(children);
    var curIndex = Number(dropPath.slice(0, 1));
    // Update the specific node's children
    var splitItemChildrenPath = dropPath.slice(1);
    var nodeChildren = updatedChildren[curIndex];
    updatedChildren[curIndex] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, nodeChildren), {
        children: addChildToChildren({
            children: nodeChildren === null || nodeChildren === void 0 ? void 0 : nodeChildren.children,
            dropPath: splitItemChildrenPath,
            item: item
        })
    });
    return updatedChildren;
};
var handleNewItem = function(param) {
    var map = param.map, dropPath = param.dropPath, item = param.item;
    return addChildToChildren({
        children: map,
        dropPath: dropPath,
        item: item
    });
};


/***/ }),

/***/ 28703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OU": function() { return /* binding */ useMapControls; },
/* harmony export */   "cb": function() { return /* binding */ useMapItemDelete; }
/* harmony export */ });
/* unused harmony exports useMapItemCopy, useMapItemPaste, useMapItemCut, useEscAction, useOpenAction */
/* harmony import */ var _mosanic_constants_nav_sub_builder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29667);
/* harmony import */ var _mosanic_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33346);
/* harmony import */ var _redux_map_drop_action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59357);
/* harmony import */ var _redux_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59801);
/* harmony import */ var _util_Device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17629);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64157);






var useMapItemDelete = function() {
    var validate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var del = function() {
        dispatch((0,_redux_map_drop_action__WEBPACK_IMPORTED_MODULE_2__/* .handleDeleteAction */ .j8)({
            item: null
        }));
        notify("Component deleted.", "controls", "success");
    };
    return del;
};
var useMapItemCopy = function() {
    var validate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var copy = function() {
        dispatch((0,_redux_map_drop_action__WEBPACK_IMPORTED_MODULE_2__/* .handleCopyAction */ .Tg)({
            preStore: !(0,_util_Device__WEBPACK_IMPORTED_MODULE_3__/* .isTouchDevice */ .b1)()
        }));
        notify("Component copied, click dropZone to paste.", "controls", "info");
    };
    return copy;
};
var useMapItemPaste = function() {
    var validate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var paste = function() {
        dispatch((0,_redux_map_drop_action__WEBPACK_IMPORTED_MODULE_2__/* .handlePasteAction */ .Um)());
        notify("Component pasted.", "controls", "info");
    };
    return paste;
};
var useMapItemCut = function() {
    var validate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var notify = (0,_mosanic_hooks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    return function() {
        dispatch((0,_redux_map_drop_action__WEBPACK_IMPORTED_MODULE_2__/* .handleCutAction */ .m9)());
        notify("Component cut, click to paste.", "controls", "info");
    };
};
var useEscAction = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var cancel = function() {
        dispatch((0,_redux_map_drop_action__WEBPACK_IMPORTED_MODULE_2__/* .clearPreStoreAction */ .g)());
    };
    return cancel;
};
var useOpenAction = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var open = function() {
        var panel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _mosanic_constants_nav_sub_builder__WEBPACK_IMPORTED_MODULE_4__/* .BuilderSubNav[0] */ .ft[0];
        dispatch((0,_redux_navigation__WEBPACK_IMPORTED_MODULE_5__/* .setSidebarPanelAction */ ._W)({
            panel: panel
        }));
    };
    return open;
};
var useMapControls = function() {
    var validate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var del = useMapItemDelete(validate);
    var copy = useMapItemCopy(validate);
    var paste = useMapItemPaste(validate);
    var cut = useMapItemCut(validate);
    var open = useOpenAction(validate);
    var esc = useEscAction();
    return {
        del: del,
        copy: copy,
        paste: paste,
        esc: esc,
        open: open,
        cut: cut
    };
};


/***/ }),

/***/ 84570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EK": function() { return /* binding */ getItemMapFromActionOrState; },
/* harmony export */   "R9": function() { return /* binding */ getItemByPath; },
/* harmony export */   "fD": function() { return /* binding */ getParentItem; }
/* harmony export */ });
/* unused harmony export getItemByPathInState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _redux_inspect_reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57522);
/* harmony import */ var _redux_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78726);
/* harmony import */ var _paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21634);





var getParentItem = function(param) {
    var map = param.map, itemPath = param.itemPath;
    return getItemByPath({
        map: map,
        path: itemPath.slice(0, -1)
    });
};
//Provide map
var getItemByPath = function(param) {
    var map = param.map, path = param.path;
    if (!map || !path) return null;
    path = Array.isArray(path) ? path : (0,_paths__WEBPACK_IMPORTED_MODULE_0__/* .splitPath */ .uo)(path);
    var item;
    for(var index = 0; index < path.length; index++){
        var itemIndex = path[index] ? Number(path[index]) : null;
        if (index === 0) item = map[itemIndex];
        if (index != 0 && itemIndex != null) item = item === null || item === void 0 ? void 0 : item.children[itemIndex];
    }
    return item;
};
//Get map from state
var getItemByPathInState = function(param) {
    var path = param.path, state = param.state, getState = param.getState;
    if (!state) state = getState();
    return path ? getItemByPath({
        map: (0,_redux_map__WEBPACK_IMPORTED_MODULE_1__/* .mapSelector */ .Od)(state),
        path: path
    }) : null;
};
//Check if action has item, else get inspected by path
var getItemMapFromActionOrState = function(param) {
    var action = param.action, state = param.state;
    var ref, ref1, ref2;
    if (action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.path) return action === null || action === void 0 ? void 0 : (ref2 = action.payload) === null || ref2 === void 0 ? void 0 : ref2.item;
    var path = (0,_redux_inspect_reducer__WEBPACK_IMPORTED_MODULE_2__/* .selectInspectItemPath */ .fP)(state);
    var item = getItemByPathInState({
        path: path,
        state: state
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, item), {
        path: path
    });
};


/***/ }),

/***/ 30415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Br": function() { return /* binding */ isProdMode; },
/* harmony export */   "DH": function() { return /* binding */ isSeoMode; },
/* harmony export */   "Dd": function() { return /* binding */ isUnhandledActionItem; },
/* harmony export */   "RD": function() { return /* binding */ isPreStoreCut; },
/* harmony export */   "X6": function() { return /* binding */ isDevMode; },
/* harmony export */   "eW": function() { return /* binding */ isItemCut; },
/* harmony export */   "v5": function() { return /* binding */ isItemCopied; }
/* harmony export */ });
//Global mode
var isDevMode = function(mode) {
    return mode === "dev" || mode === "layers";
};
var isProdMode = function(mode) {
    return mode === "prod" || mode === "live";
};
var isSeoMode = function(mode) {
    return mode === "seo";
};
var isItemCopied = function(item) {
    return item === null || item === void 0 ? void 0 : item.isCopied;
};
var isItemCut = function(item) {
    return item === null || item === void 0 ? void 0 : item.isCut;
};
var isUnhandledActionItem = function(item) {
    return isItemCopied(item) || isItemCut(item);
};
var isPreStoreCut = function(preStore) {
    return preStore === null || preStore === void 0 ? void 0 : preStore.isCut;
};


/***/ }),

/***/ 49578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getCurrentPath; },
/* harmony export */   "g": function() { return /* binding */ getSiblingPath; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50930);
/* harmony import */ var _paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21634);


var getCurrentPath = function(path, index) {
    return path ? "".concat(path, "-").concat(index) : "".concat(index);
};
var getSiblingPath = function(path) {
    var after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var splittedPath = Array.isArray(path) ? path : (0,_paths__WEBPACK_IMPORTED_MODULE_0__/* .splitPath */ .uo)(path);
    var itemIndex = parseFloat(splittedPath.pop()) + (after ? 1 : -1);
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(splittedPath).concat([
        itemIndex
    ]);
};


/***/ }),

/***/ 21634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ad": function() { return /* binding */ isDiffCol; },
/* harmony export */   "GK": function() { return /* binding */ isDiffParent; },
/* harmony export */   "Rp": function() { return /* binding */ isSameLevel; },
/* harmony export */   "XV": function() { return /* binding */ PATH_SEPARATOR; },
/* harmony export */   "aU": function() { return /* binding */ isDiffRow; },
/* harmony export */   "iS": function() { return /* binding */ getItemIndex; },
/* harmony export */   "pN": function() { return /* binding */ pathToItem; },
/* harmony export */   "uo": function() { return /* binding */ splitPath; }
/* harmony export */ });
/* unused harmony exports extendPath, joinDropZonePath */
var PATH_SEPARATOR = "-";
var hasPaths = function(p1, p2) {
    return p1 && p2;
};
//Main
var splitPath = function(path) {
    return path === null || path === void 0 ? void 0 : path.split(PATH_SEPARATOR);
};
var extendPath = function(path, index) {
    return "".concat(path).concat(PATH_SEPARATOR).concat(index);
};
//Convert
var pathToItem = function(splitPath) {
    return joinDropZonePath(splitPath.slice(0, -1));
};
var joinDropZonePath = function(splitPath) {
    return splitPath.join(PATH_SEPARATOR);
};
//Get
var getItemIndex = function(splitPath) {
    return Number(splitPath.slice(-1)[0]);
};
//Validate
var isDiffRow = function(activePath, itemPath) {
    return !hasPaths(activePath, itemPath) ? true : activePath[0] != itemPath[0];
};
var isDiffCol = function(activePath, itemPath) {
    return !hasPaths(activePath, itemPath) ? true : activePath[1] != itemPath[1];
};
var isSameLevel = function(activePath, itemPath) {
    return !hasPaths(activePath, itemPath) ? true : activePath.length === (itemPath === null || itemPath === void 0 ? void 0 : itemPath.length);
};
var isDiffParent = function(activePath, itemPath) {
    return !hasPaths(activePath, itemPath) ? true : activePath[(activePath === null || activePath === void 0 ? void 0 : activePath.length) - 1] != itemPath[(itemPath === null || itemPath === void 0 ? void 0 : itemPath.length) - 1];
};


/***/ }),

/***/ 67692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "im": function() { return /* binding */ isSlot; },
/* harmony export */   "kq": function() { return /* binding */ hasSlots; },
/* harmony export */   "zZ": function() { return /* binding */ manageSlots; }
/* harmony export */ });
/* unused harmony exports getSlotChildCount, isValidSlot */
/* harmony import */ var _util_Arr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72393);



var isSlot = function(child) {
    return child === "slot" || (child === null || child === void 0 ? void 0 : child.type) === "slot";
};
// export const getSlotCount = render => render.filter(child => isSlot(child))?.length;
var getItemsAfterSlot = function(render, slotIndex) {
    return _to_consumable_array(render).splice(slotIndex + 1, render === null || render === void 0 ? void 0 : render.length);
};
var getSlotChildCount = function(render, slotIndex) {
    var validate = getItemsAfterSlot(render, slotIndex);
    if (!(validate === null || validate === void 0 ? void 0 : validate.length)) return 0;
    var childCount = 0, next = true;
    validate.map(function(c) {
        //If a defined break is setup stop.
        if (isRenderField(c) || isSlot(c)) next = false;
        if (next) childCount++;
    });
    return childCount;
};
var isValidSlot = function(slot, length) {
    if (!(slot === null || slot === void 0 ? void 0 : slot.max)) return true;
    return slot.max >= length;
};
var hasSlots = function(children) {
    var hasSlots = false;
    if ((0,_util_Arr__WEBPACK_IMPORTED_MODULE_0__/* .canMap */ .is)(children)) children === null || children === void 0 ? void 0 : children.map(function(child) {
        if ((child === null || child === void 0 ? void 0 : child.slot) || isSlot(child)) hasSlots = true;
    });
    return hasSlots;
};
var manageSlots = function(children) {
    if (!hasSlots(children)) return false;
    var manageSlots = false;
    if ((0,_util_Arr__WEBPACK_IMPORTED_MODULE_0__/* .canMap */ .is)(children)) children === null || children === void 0 ? void 0 : children.map(function(child) {
        if (((child === null || child === void 0 ? void 0 : child.slot) || isSlot(child)) && (child === null || child === void 0 ? void 0 : child.manage)) manageSlots = true;
    });
    return manageSlots;
};


/***/ }),

/***/ 8374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bf": function() { return /* binding */ getPreSaveLayoutMap; },
/* harmony export */   "YY": function() { return /* binding */ copyAndTransformItemMap; },
/* harmony export */   "_3": function() { return /* binding */ convertItemMap; },
/* harmony export */   "cq": function() { return /* binding */ convertPreSaveLayout; }
/* harmony export */ });
/* unused harmony export loopTroughMap */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _redux_map_data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78364);
/* harmony import */ var _mosanic_utils_data_transform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2467);
/* harmony import */ var _paths__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21634);
/* harmony import */ var _ObjectID__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56831);







;
var loopTroughMap = function(map, components, state) {
    if (map === null || map === void 0 ? void 0 : map.children) map === null || map === void 0 ? void 0 : map.children.map(function(child) {
        if (child === null || child === void 0 ? void 0 : child._id) {
            components = _object_spread_props(_object_spread({}, components), _define_property({}, child._id, itemSelector(state, child)));
        }
        if (child === null || child === void 0 ? void 0 : child.children) components = loopTroughMap(child, components, state);
    });
    return components;
};
var copyAndTransformItemMap = function(itemMap, dispatch) {
    if (!itemMap || !Array.isArray(itemMap)) return itemMap;
    //Recursive copy data method for children
    var convertAndCopyItemMap = function(child) {
        var ref = (0,_mosanic_utils_data_transform__WEBPACK_IMPORTED_MODULE_0__/* .copyItem */ ._B)({
            item: child
        }), _$itemMap = ref.itemMap, component = ref.component;
        dispatch(_redux_map_data__WEBPACK_IMPORTED_MODULE_1__/* .dataActions.copyDataAction */ .tD.copyDataAction({
            component: component
        }, child === null || child === void 0 ? void 0 : child._id, true));
        return _$itemMap;
    };
    //Return first child of the converted itemMap
    return convertItemMap(itemMap, convertAndCopyItemMap)[0];
};
var convertItemMap = function() {
    var children = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, transform = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(child) {
        return child;
    };
    if (Array.isArray(children) && children.length >= 1) {
        return children.map(function(child) {
            if (!(child === null || child === void 0 ? void 0 : child._id)) return child;
            var itemMap = transform(child);
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, itemMap), {
                children: (itemMap === null || itemMap === void 0 ? void 0 : itemMap.children) ? convertItemMap(itemMap.children, transform) : undefined
            });
        });
    }
    return children;
};
var getPreSaveLayoutMap = function(map, path) {
    var splittedPath = (0,_paths__WEBPACK_IMPORTED_MODULE_4__/* .splitPath */ .uo)(path);
    var itemMap = map === null || map === void 0 ? void 0 : map[splittedPath === null || splittedPath === void 0 ? void 0 : splittedPath[0]];
    return itemMap;
};
var convertPreSaveLayout = function(storedData, itemMap) {
    //Local data array
    var local = {};
    var count = 0;
    //Get child from global storage
    var getChild = function(child) {
        var ref;
        return storedData === null || storedData === void 0 ? void 0 : (ref = storedData[child === null || child === void 0 ? void 0 : child.group]) === null || ref === void 0 ? void 0 : ref[child === null || child === void 0 ? void 0 : child._id];
    };
    var addChild = function(child, newId) {
        if (!(child === null || child === void 0 ? void 0 : child.group)) return child;
        local = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, local), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, child.group, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, local === null || local === void 0 ? void 0 : local[child.group]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, newId, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, getChild(child)), {
            _id: newId
        })))));
        return local;
    };
    var convert = function(child) {
        count++;
        var newId = (0,_ObjectID__WEBPACK_IMPORTED_MODULE_6__/* .ObjectID */ .t)();
        //Regenerate a new local data map 
        addChild(child, newId);
        //Return transformed child map
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, child), {
            _id: newId
        });
    };
    var looped = convertItemMap(itemMap === null || itemMap === void 0 ? void 0 : itemMap.children, convert);
    var newId = (0,_ObjectID__WEBPACK_IMPORTED_MODULE_6__/* .ObjectID */ .t)();
    //Get source component by using item map _id and group
    var component = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, getChild(itemMap)), {
        _id: newId
    });
    //Combine new item map with source item map and the new parent _id
    var map = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, itemMap), {
        _id: newId,
        children: looped
    });
    //Finally add the parent component to the local data tree
    var data = addChild(itemMap, newId);
    return [
        map,
        data,
        component,
        count
    ];
};


/***/ }),

/***/ 9528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nm": function() { return /* binding */ isContainer; },
/* harmony export */   "Uw": function() { return /* binding */ isColumns; },
/* harmony export */   "YF": function() { return /* binding */ getItemType; },
/* harmony export */   "ZA": function() { return /* binding */ getItemGroup; },
/* harmony export */   "jC": function() { return /* binding */ isRow; }
/* harmony export */ });
/* harmony import */ var _mosanic_constants_items__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66625);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68311);


var CONTAINERS = [
    _mosanic_constants_items__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ROW */ .ZP.ROW,
    _mosanic_constants_items__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CONTAINER */ .ZP.CONTAINER,
    _mosanic_constants_items__WEBPACK_IMPORTED_MODULE_0__/* ["default"].COLUMN */ .ZP.COLUMN,
    "link"
];
var isColumns = function(componentType) {
    return componentType === "columns";
};
var isRow = function(componentType) {
    return componentType === "row";
};
var isContainer = function(itemType) {
    return CONTAINERS.includes(itemType);
};
//Get item type before initialize
var getItemType = function(componentType) {
    switch(componentType){
        case "container":
            return _mosanic_constants_items__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CONTAINER */ .ZP.CONTAINER;
        case "stack":
            return _mosanic_constants_items__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CONTAINER */ .ZP.CONTAINER;
        case "link":
            return _mosanic_constants_items__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CONTAINER */ .ZP.CONTAINER;
        case "columns":
            return _mosanic_constants_items__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ROW */ .ZP.ROW;
        case "row":
            return _mosanic_constants_items__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ROW */ .ZP.ROW;
        case "column":
            return _mosanic_constants_items__WEBPACK_IMPORTED_MODULE_0__/* ["default"].COLUMN */ .ZP.COLUMN;
        default:
            return _mosanic_constants_items__WEBPACK_IMPORTED_MODULE_0__/* ["default"].COMPONENT */ .ZP.COMPONENT;
    }
    ;
};
var getItemGroup = function(componentType) {
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_1__/* .toLowCase */ .Cc)(getItemType(componentType), "s");
};


/***/ }),

/***/ 25220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MB": function() { return /* binding */ useActiveAddons; },
/* harmony export */   "OW": function() { return /* binding */ useActivePlan; },
/* harmony export */   "WD": function() { return /* binding */ altParsePrice; },
/* harmony export */   "aS": function() { return /* binding */ getPrice; },
/* harmony export */   "iB": function() { return /* binding */ useProduct; },
/* harmony export */   "rn": function() { return /* binding */ useProducts; },
/* harmony export */   "z": function() { return /* binding */ parsePrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_components_Membership_CombineData__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63730);
/* harmony import */ var _mosanic_content_membership__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18453);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36174);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(83482);
/* harmony import */ var _redux_cart_action__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48513);
/* harmony import */ var _redux_cart_reducer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59407);
/* harmony import */ var _util_api_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62459);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64157);














var getPrice = function(prices) {
    var annual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var find = annual ? "year" : "month";
    if (!Array.isArray(prices)) return prices;
    return prices.find(function(p) {
        var ref;
        return ((p === null || p === void 0 ? void 0 : (ref = p.recurring) === null || ref === void 0 ? void 0 : ref.interval) ? p.recurring.interval : p.interval) === find;
    });
};
var parsePrice = function(prices, annual) {
    var ref;
    return (ref = getPrice(prices, annual)) === null || ref === void 0 ? void 0 : ref.price;
};
var altParsePrice = function(prices, annual) {
    var ref;
    var alt = (ref = getPrice(prices, !annual)) === null || ref === void 0 ? void 0 : ref.price;
    return annual ? alt * 12 : alt / 12;
};
var isLower = function(product, active) {
    var ref;
    return _mosanic_content_membership__WEBPACK_IMPORTED_MODULE_4__/* .plans */ .z5[(ref = (0,_mosanic_content_membership__WEBPACK_IMPORTED_MODULE_4__/* .getPlanById */ .Ov)(active)) === null || ref === void 0 ? void 0 : ref.value] > _mosanic_content_membership__WEBPACK_IMPORTED_MODULE_4__/* .plans */ .z5[product === null || product === void 0 ? void 0 : product.value];
};
var isPlan = function(product) {
    var ref;
    return (product === null || product === void 0 ? void 0 : (ref = product.metadata) === null || ref === void 0 ? void 0 : ref.type) === "plan" || (product === null || product === void 0 ? void 0 : product.category) === "plan";
};
var isAddon = function(product) {
    return !isPlan(product) && (product === null || product === void 0 ? void 0 : product.category) === "addon";
};
var isUser = function(product) {
    return !isPlan(product) && !isPlan(product) && (product === null || product === void 0 ? void 0 : product.category) === "user";
};
var parseProductType = function(product) {
    return isPlan(product) ? "plan" : isAddon(product) ? "addon" : isUser(product) ? "user" : "custom";
};
var useProduct = function(product) {
    var annual = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_redux_cart_reducer__WEBPACK_IMPORTED_MODULE_5__/* .annualSelector */ .Am);
    var active = useActivePlan();
    product = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, product), {
        quantity: (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
            return (0,_redux_cart_reducer__WEBPACK_IMPORTED_MODULE_5__/* .productQuantitySelector */ .No)(state, product === null || product === void 0 ? void 0 : product.id);
        })
    });
    switch(parseProductType(product)){
        case "plan":
            product = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, product), {
                plan: true,
                isLower: isLower(product, active)
            });
            break;
        case "addon":
            product = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, product), {
                addon: true
            });
            break;
        case "user":
            product = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, product), {
                user: true
            });
            break;
        default:
            break;
    }
    return product;
};
var useActivePlan = function() {
    var activePlanId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var storePlanId = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_redux_cart_reducer__WEBPACK_IMPORTED_MODULE_5__/* .activeContainProductSelector */ .A4)(state, (0,_redux_cart_reducer__WEBPACK_IMPORTED_MODULE_5__/* .planIdsSelector */ .A5)(state));
    });
    if (!activePlanId) activePlanId = storePlanId;
    var priceData = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_redux_cart_reducer__WEBPACK_IMPORTED_MODULE_5__/* .cartDataSelector */ .TP)(state, "data");
    });
    var plan = activePlanId ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,_mosanic_content_membership__WEBPACK_IMPORTED_MODULE_4__/* .getPlanById */ .Ov)(activePlanId), priceData[activePlanId]) : null;
    return plan ? (0,_mosanic_components_Membership_CombineData__WEBPACK_IMPORTED_MODULE_8__/* .formatProduct */ .il)(plan) : plan;
};
var useActiveAddons = function(addons) {
    var products = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref;
    var storeProducts = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_redux_cart_reducer__WEBPACK_IMPORTED_MODULE_5__/* .productsSelector */ .eV);
    if (!products) products = storeProducts;
    products = (0,_util_Obj__WEBPACK_IMPORTED_MODULE_9__/* .removeUndefined */ .o2)(products);
    var ids = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_redux_cart_reducer__WEBPACK_IMPORTED_MODULE_5__/* .addonIdsSelector */ .rp);
    var priceData = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_redux_cart_reducer__WEBPACK_IMPORTED_MODULE_5__/* .cartDataSelector */ .TP)(state, "data");
    });
    var addonIds = products ? (ref = Object.keys(products)) === null || ref === void 0 ? void 0 : ref.filter(function(id) {
        return ids === null || ids === void 0 ? void 0 : ids.includes(id);
    }) : [];
    return addonIds.map(function(id) {
        return (0,_mosanic_components_Membership_CombineData__WEBPACK_IMPORTED_MODULE_8__/* .formatProduct */ .il)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, addons.find(function(a) {
            return a.id === id;
        }), priceData[id]), {
            count: products[id]
        }));
    });
};
var combineProductPrices = function(products, prices) {
    return products.data.map(function(product) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, product), {
            prices: prices.data.filter(function(price) {
                return price.product === product.id;
            })
        });
    });
};
var getIds = function(products) {
    return products.map(function(p) {
        return p === null || p === void 0 ? void 0 : p.id;
    });
};
var useProducts = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), plans = ref2[0], setPlans = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), addons = ref3[0], setAddons = ref3[1];
    // const getProducts = async () => {
    //     setLoading(true);
    //     await fetchGetJSON('/api/shop/products').then(val => {
    //         const {products, prices} = val;
    //         const data = combineProductPrices(products, prices);
    //         const plans = data.filter(p => p?.metadata?.type === 'plan');
    //         const addons = data.filter(p => p?.metadata?.type != 'plan');
    //         const priceData = toObject(data.map(p => ({
    //             ...p,
    //             point: undefined,
    //             type: p?.metadata?.type === 'plan' ? 'plan' : 'addon'
    //         })), 'id');
    //         dispatch(cartDataAction('plans', getIds(plans)))
    //         dispatch(cartDataAction('addons', getIds(addons)))
    //         dispatch(cartDataAction('data', priceData))
    //         setAddons(addons);
    //         setPlans(plans);
    //     }).catch(err => setError(err));
    //     setLoading(false);
    // }
    // sk_live_wPlFpSrxi1qInTthQaSZa4m3
    // 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
    var getProductsSoo = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return (0,_util_api_helpers__WEBPACK_IMPORTED_MODULE_11__/* .fetchPostJSON */ .Gf)("/api/shop/products", {
                            key: "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"
                        }).then(function(val) {
                            var products = val.products, prices = val.prices;
                            var data = combineProductPrices(products, prices);
                            var plans = data.filter(function(p) {
                                var ref;
                                return (p === null || p === void 0 ? void 0 : (ref = p.metadata) === null || ref === void 0 ? void 0 : ref.type) === "plan";
                            });
                            var addons = data.filter(function(p) {
                                var ref;
                                return (p === null || p === void 0 ? void 0 : (ref = p.metadata) === null || ref === void 0 ? void 0 : ref.type) != "plan";
                            });
                            var priceData = (0,_util_Obj__WEBPACK_IMPORTED_MODULE_9__/* .toObject */ .ru)(data.map(function(p) {
                                var ref;
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, p), {
                                    point: undefined,
                                    type: (p === null || p === void 0 ? void 0 : (ref = p.metadata) === null || ref === void 0 ? void 0 : ref.type) === "plan" ? "plan" : "addon"
                                });
                            }), "id");
                            dispatch((0,_redux_cart_action__WEBPACK_IMPORTED_MODULE_12__/* .cartDataAction */ .Rr)("plans", getIds(plans)));
                            dispatch((0,_redux_cart_action__WEBPACK_IMPORTED_MODULE_12__/* .cartDataAction */ .Rr)("addons", getIds(addons)));
                            dispatch((0,_redux_cart_action__WEBPACK_IMPORTED_MODULE_12__/* .cartDataAction */ .Rr)("data", priceData));
                            setAddons(addons);
                            setPlans(plans);
                        }).catch(function(err) {
                            return setError(err);
                        });
                    case 3:
                        setLoading(false);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getProductsSoo() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // getProducts();
        getProductsSoo();
    }, []);
    return [
        [
            plans,
            addons
        ],
        loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_13__/* .Spinner */ .$, {}) : null,
        error ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_14__/* .ErrorAlert */ .h, {
            errorMessage: error
        }) : null
    ];
};



/***/ }),

/***/ 32064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kq": function() { return /* binding */ useSchemaFieldsRef; },
/* harmony export */   "Lv": function() { return /* binding */ useProductionFieldsRef; },
/* harmony export */   "Rn": function() { return /* binding */ passControlState; },
/* harmony export */   "Xc": function() { return /* binding */ isTabExpand; },
/* harmony export */   "u_": function() { return /* binding */ isSliceExpand; }
/* harmony export */ });
/* unused harmony exports hasExpand, expandType, passCloneState */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _mosanic_hooks_useFieldSource__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68901);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);





var hasExpand = function(schema) {
    return schema === null || schema === void 0 ? void 0 : schema.expand;
};
var expandType = function(schema) {
    var ref;
    return (schema === null || schema === void 0 ? void 0 : (ref = schema.expand) === null || ref === void 0 ? void 0 : ref.type) ? schema.expand.type : schema === null || schema === void 0 ? void 0 : schema.expand;
};
var isSliceExpand = function(schema) {
    return expandType(schema) === "slice";
};
var isTabExpand = function(schema) {
    return expandType(schema) === "tab";
};
var getRef = function(item) {
    return {
        _id: item === null || item === void 0 ? void 0 : item._id,
        type: item === null || item === void 0 ? void 0 : item.type,
        group: item === null || item === void 0 ? void 0 : item.group
    };
};
var useContextRef = function(item, active, prod, clone) {
    return {
        fields: item === null || item === void 0 ? void 0 : item.fields,
        editor: (0,_mosanic_hooks_useFieldSource__WEBPACK_IMPORTED_MODULE_1__/* .useMosanicInlineEditorFields */ .IZ)({
            ref: getRef(item)
        }),
        ref: getRef(item),
        active: active,
        clone: clone
    };
};
var useSchemaFieldsRef = function(param) {
    var item = param.item, active = param.active, _production = param.production, production = _production === void 0 ? false : _production, _clone = param.clone, clone = _clone === void 0 ? null : _clone, _breakpoint = param.breakpoint, breakpoint = _breakpoint === void 0 ? "xl" : _breakpoint;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, useContextRef(item, active, production, clone)), {
        breakpoint: breakpoint
    });
};
var useProductionFieldsRef = function(param) {
    var item = param.item, active = param.active, _clone = param.clone, clone = _clone === void 0 ? null : _clone, _breakpoint = param.breakpoint, breakpoint = _breakpoint === void 0 ? "xl" : _breakpoint;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(item === null || item === void 0 ? void 0 : item.fields), source = ref[0], setSource = ref[1];
    var handler = function(param) {
        var value = param.value, extend = param.extend;
        setSource((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, source), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, extend, value)));
    };
    return {
        fields: item === null || item === void 0 ? void 0 : item.fields,
        editor: {
            source: source,
            handler: handler
        },
        ref: getRef(item),
        active: active,
        clone: clone,
        breakpoint: breakpoint,
        production: true
    };
};
var passControlState = function(param) {
    var children = param.children, controlProps = param.controlProps;
    if (!children) return children;
    var childrenWithControlProps = react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function(child) {
        if (/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(child)) return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
            controlProps: controlProps
        });
        return child;
    });
    return childrenWithControlProps;
};
var passCloneState = function(param) {
    var children = param.children, cloneProps = param.cloneProps;
    if (!children) return children;
    var childrenWithCloneProps = Children.map(children, function(child) {
        if (/*#__PURE__*/ isValidElement(child)) /*#__PURE__*/ cloneElement(child, {
            cloneProps: cloneProps
        });
        return child;
    });
    return childrenWithCloneProps;
};


/***/ }),

/***/ 38380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DG": function() { return /* binding */ getSubdomains; },
/* harmony export */   "IK": function() { return /* binding */ getCustomDomains; },
/* harmony export */   "Je": function() { return /* binding */ getSitesDomainPathMap; },
/* harmony export */   "KI": function() { return /* binding */ getCollectionsPathMap; },
/* harmony export */   "NR": function() { return /* binding */ getDynamicPart; },
/* harmony export */   "Qs": function() { return /* binding */ getIndexPageId; },
/* harmony export */   "xQ": function() { return /* binding */ findPage; }
/* harmony export */ });
/* unused harmony export getPageIndexes */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50930);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62570);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68311);




// * Index paths 
var hasIndexes = function(site) {
    return (site === null || site === void 0 ? void 0 : site.nav) || (site === null || site === void 0 ? void 0 : site.indexes) || (site === null || site === void 0 ? void 0 : site.dynamic);
};
var hasIndex = function(site, type) {
    return (0,_util_Obj__WEBPACK_IMPORTED_MODULE_0__/* .hasAttr */ .B$)(site, type) && Array.isArray(site === null || site === void 0 ? void 0 : site[type]);
};
//Get all sites domains
var getSubdomains = function(sites) {
    return sites === null || sites === void 0 ? void 0 : sites.filter(function(site) {
        return site === null || site === void 0 ? void 0 : site.subdomain;
    });
};
var getCustomDomains = function(sites) {
    return sites === null || sites === void 0 ? void 0 : sites.filter(function(site) {
        return site === null || site === void 0 ? void 0 : site.customDomain;
    });
};
var getSingleSlugParam = function(indexItem, domain) {
    return {
        params: {
            site: domain,
            slug: [
                indexItem === null || indexItem === void 0 ? void 0 : indexItem.slug
            ]
        }
    };
};
//If site has index type attr, get params
var getSlugs = function(site, domainAttr, typeAttr) {
    return !hasIndex(site, typeAttr) ? [] : site[typeAttr].map(function(indexItem) {
        return getSingleSlugParam(indexItem, site[domainAttr]);
    });
};
//Get site indexes map
var getIndexesMap = function(site, domainAttr) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getSlugs(site, domainAttr, "nav")).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getSlugs(site, domainAttr, "indexes")), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getSlugs(site, domainAttr, "dynamic")));
};
//Map trough sites and specific domain attribute [subdomain or customDomain]
var getSitesDomainPathMap = function(sites, domainAttr) {
    return sites.flatMap(function(site) {
        if (!hasIndexes(site)) return [];
        return getIndexesMap(site, domainAttr);
    });
};
// * Collections paths
var isValidPathCollection = function(collection) {
    var ref;
    return Boolean((collection === null || collection === void 0 ? void 0 : collection.baseRoute) && (collection === null || collection === void 0 ? void 0 : (ref = collection.entries) === null || ref === void 0 ? void 0 : ref.length) >= 1 && (collection === null || collection === void 0 ? void 0 : collection.siteId));
};
//Get specific site domain
var getSiteDomain = function(sites, siteId) {
    var site = sites === null || sites === void 0 ? void 0 : sites.find(function(site) {
        return (site === null || site === void 0 ? void 0 : site._id) === siteId;
    });
    //Todo ==> should we validate which is passed in params?
    // * or return just both? as two times path
    return (site === null || site === void 0 ? void 0 : site.subdomain) ? site.subdomain : site === null || site === void 0 ? void 0 : site.customDomain;
};
var getEntrySlug = function(entry, collection) {
    var ref;
    return (0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .slugify */ .lV)((0,_util_Text__WEBPACK_IMPORTED_MODULE_2__/* .toLowCase */ .Cc)(entry[(ref = collection === null || collection === void 0 ? void 0 : collection.schema[0]) === null || ref === void 0 ? void 0 : ref.name]));
};
var getMultiSlugParam = function(slug, domain) {
    return {
        params: {
            site: domain,
            slug: slug
        }
    };
};
var getEntryPaths = function(domain, collection) {
    return collection.entries.map(function(entry) {
        return getMultiSlugParam([
            collection.baseRoute,
            getEntrySlug(entry, collection)
        ], domain);
    });
};
var getCollectionsPathMap = function(sites, collections) {
    return !collections || !Array.isArray(collections) ? [] : collections.flatMap(function(collection) {
        if (!isValidPathCollection(collection)) return [];
        var domain = getSiteDomain(sites, collection.siteId);
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getEntryPaths(domain, collection)).concat([
            getMultiSlugParam([
                collection.baseRoute
            ], domain)
        ]);
    });
};
// * Fallback getStaticProps
var getIndexPageId = function(site) {
    var attr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "404";
    var ref, ref1;
    if (!hasIndex(site, "indexes")) return null;
    return (ref1 = site === null || site === void 0 ? void 0 : (ref = site.indexes) === null || ref === void 0 ? void 0 : ref.find(function(item) {
        return item === null || item === void 0 ? void 0 : item[attr];
    })) === null || ref1 === void 0 ? void 0 : ref1.pageId;
};
var getDynamicPart = function(site, pages) {
    var attr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "header";
    return (site === null || site === void 0 ? void 0 : site[attr]) ? pages === null || pages === void 0 ? void 0 : pages.find(function(p) {
        return (p === null || p === void 0 ? void 0 : p._id) === site[attr];
    }) : null;
};
var findPage = function(pages, pageId) {
    var page = pages === null || pages === void 0 ? void 0 : pages.find(function(p) {
        return (p === null || p === void 0 ? void 0 : p._id) === pageId;
    });
    return page ? page : pages[0];
};
// export const convert
var getPageIndexes = function(site) {
    var ref, ref1, ref2;
    return site ? _to_consumable_array(Array.isArray(site === null || site === void 0 ? void 0 : site.nav) ? site === null || site === void 0 ? void 0 : (ref = site.nav) === null || ref === void 0 ? void 0 : ref.map(function(i) {
        return {
            pageId: i === null || i === void 0 ? void 0 : i.pageId,
            slug: i === null || i === void 0 ? void 0 : i.slug
        };
    }) : []).concat(_to_consumable_array(Array.isArray(site === null || site === void 0 ? void 0 : site.indexes) ? site === null || site === void 0 ? void 0 : (ref1 = site.indexes) === null || ref1 === void 0 ? void 0 : ref1.map(function(i) {
        return {
            pageId: i === null || i === void 0 ? void 0 : i.pageId,
            slug: i === null || i === void 0 ? void 0 : i.slug
        };
    }) : []), _to_consumable_array(Array.isArray(site === null || site === void 0 ? void 0 : site.dynamic) ? site === null || site === void 0 ? void 0 : (ref2 = site.dynamic) === null || ref2 === void 0 ? void 0 : ref2.map(function(i) {
        return {
            pageId: i === null || i === void 0 ? void 0 : i.pageId,
            slug: i === null || i === void 0 ? void 0 : i.slug
        };
    }) : [])) : null;
};


/***/ }),

/***/ 2327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X8": function() { return /* binding */ pathValue; },
/* harmony export */   "qw": function() { return /* binding */ genPath; }
/* harmony export */ });
/* unused harmony exports itemPath, itemPaths, autoPath, pathMetric, metricValue */

//Item selectors
var itemPath = function(_id, group) {
    return {
        _id: _id,
        group: group
    };
};
var itemPaths = function(_ids, group) {
    var paths = [];
    _ids.forEach(function(_id) {
        paths.push({
            _id: _id,
            group: group
        });
    });
    return paths;
};
//Paths
var genPath = function(attr, field, variant) {
    var sub = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return sub ? "data.".concat(attr, ".").concat(field, ".").concat(variant, ".").concat(sub) : "data.".concat(attr, ".").concat(field, ".").concat(variant);
};
var autoPath = function(fields) {
    var path = "";
    fields.forEach(function(field) {
        return path += "".concat(field, ".");
    });
    return removeLastChar(path);
};
//Values
var pathValue = function(param) {
    var path = param.path, value = param.value;
    return {
        value: value,
        path: path
    };
};
var pathMetric = function(param) {
    var path = param.path, value = param.value, metric = param.metric, token = param.token;
    return {
        value: metricValue({
            value: value,
            metric: metric,
            token: token
        }),
        path: path
    };
};
var metricValue = function(param) {
    var value = param.value, metric = param.metric, token = param.token;
    return {
        value: value,
        metric: metric,
        token: token
    };
};



/***/ }),

/***/ 32646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ isCol; },
/* harmony export */   "Rr": function() { return /* binding */ isComp; },
/* harmony export */   "pE": function() { return /* binding */ isComponent; }
/* harmony export */ });
/* unused harmony exports isStackAvailable, isRow, isRepeater, isNotInspectedComp, getClickCheckListValidation */
/* harmony import */ var _mosanic_constants___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66625);

var COLUMN = _mosanic_constants___WEBPACK_IMPORTED_MODULE_0__/* ["default"].COLUMN */ .ZP.COLUMN, COMPONENT = _mosanic_constants___WEBPACK_IMPORTED_MODULE_0__/* ["default"].COMPONENT */ .ZP.COMPONENT, REPEATER = _mosanic_constants___WEBPACK_IMPORTED_MODULE_0__/* ["default"].REPEATER */ .ZP.REPEATER, ROW = _mosanic_constants___WEBPACK_IMPORTED_MODULE_0__/* ["default"].ROW */ .ZP.ROW, STACK = _mosanic_constants___WEBPACK_IMPORTED_MODULE_0__/* ["default"].STACK */ .ZP.STACK, CONTAINER = _mosanic_constants___WEBPACK_IMPORTED_MODULE_0__/* ["default"].CONTAINER */ .ZP.CONTAINER;
var isStackAvailable = function(type) {
    return [
        COLUMN,
        STACK,
        REPEATER
    ].includes(type);
};
var isRow = function(type) {
    return type === ROW;
};
var isCol = function(type) {
    return type === COLUMN;
};
var isComp = function(type) {
    return type === COMPONENT;
};
var isComponent = function(type) {
    return ![
        COLUMN,
        STACK,
        REPEATER,
        STACK,
        ROW
    ].includes(type);
};
var isRepeater = function(type) {
    return type === REPEATER;
};
var isNotInspectedComp = function(isInspected, type) {
    return !isInspected && !isComp(type);
};
var getClickCheckListValidation = function(type) {
    switch(type){
        case COMPONENT:
            return false;
        case STACK:
            return {
                accept: [
                    "stack__dropZone",
                    "stack__label",
                    "stack__flex",
                    "-STACK"
                ]
            };
        case COLUMN:
            return {
                accept: [
                    "column__dropZone",
                    "column",
                    "column__label",
                    "column__flex",
                    "inspectors"
                ]
            };
        case ROW:
            return {
                targetZone: [
                    "row__dropZone"
                ],
                preventZone: [
                    "column__dropZone",
                    "page__dropZone", 
                ],
                accept: [
                    "row__dropZone",
                    "row__add",
                    "columns",
                    "row_col_wrapper",
                    "row_col_container",
                    "row"
                ]
            };
        case REPEATER:
            return {
                accept: [
                    "repeater__dropZone",
                    "repeater__label",
                    "repeater__flex",
                    "-REPEATER"
                ]
            };
        case CONTAINER:
            return {
                accept: [
                    "container"
                ]
            };
        default:
            return false;
    }
};


/***/ }),

/***/ 11039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FG": function() { return /* binding */ evalReplaceValue; },
  "NA": function() { return /* binding */ getValue; },
  "vu": function() { return /* binding */ isClone; },
  "yL": function() { return /* binding */ replaceWithSource; }
});

// UNUSED EXPORTS: getEvaluatedValue, getFuncOptions, replaceValue

// EXTERNAL MODULE: ./src/mosanic/fields/Source/helpers.js
var helpers = __webpack_require__(49272);
// EXTERNAL MODULE: ./src/utils/Boolean.js
var Boolean = __webpack_require__(13365);
// EXTERNAL MODULE: ./src/utils/Date.js
var utils_Date = __webpack_require__(99787);
// EXTERNAL MODULE: ./src/utils/Empty.js
var Empty = __webpack_require__(75276);
// EXTERNAL MODULE: ./src/utils/Round.js
var Round = __webpack_require__(82261);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
;// CONCATENATED MODULE: ../../node_modules/evaluator.js/dist/evaluator.m.js
var symbols = {
  '^': {
    infix: '_POW'
  },
  '*': {
    infix: '_MUL'
  },
  '/': {
    infix: '_DIV'
  },
  '%': {
    infix: '_MOD'
  },
  '+': {
    infix: '_ADD',
    prefix: '_POS'
  },
  '-': {
    infix: '_SUB',
    prefix: '_NEG'
  }
};

var factorial = function (x) { return x >= 0 ? x < 2 ? 1 : x * factorial(x - 1) : NaN; };

var operators = {
  '_POW': {
    name: 'Power',
    precedence: 4,
    associativity: 'right',
    method: function (x, y) { return Math.pow( x, y ); }
  },
  '_POS': {
    name: 'Positive',
    precedence: 3,
    associativity: 'right',
    method: function (x) { return x; }
  },
  '_NEG': {
    name: 'Negative',
    precedence: 3,
    associativity: 'right',
    method: function (x) { return -x; }
  },
  '_MUL': {
    name: 'Multiply',
    precedence: 2,
    associativity: 'left',
    method: function (x, y) { return x * y; }
  },
  '_DIV': {
    name: 'Divide',
    precedence: 2,
    associativity: 'left',
    method: function (x, y) { return x / y; }
  },
  '_MOD': {
    name: 'Modulo',
    precedence: 2,
    associativity: 'left',
    method: function (x, y) { return x % y; }
  },
  '_ADD': {
    name: 'Add',
    precedence: 1,
    associativity: 'left',
    method: function (x, y) { return x + y; }
  },
  '_SUB': {
    name: 'Subtract',
    precedence: 1,
    associativity: 'left',
    method: function (x, y) { return x - y; }
  }
};
var constants = {
  'E': Math.E,
  'LN2': Math.LN2,
  'LN10': Math.LN10,
  'LOG2E': Math.LOG2E,
  'LOG10E': Math.LOG10E,
  'PHI': (1 + Math.sqrt(5)) / 2,
  'PI': Math.PI,
  'SQRT1_2': Math.SQRT1_2,
  'SQRT2': Math.SQRT2,
  'TAU': 2 * Math.PI
};
var methods = {
  'ABS': function (x) { return Math.abs(x); },
  'ACOS': function (x) { return Math.acos(x); },
  'ACOSH': function (x) { return Math.acosh(x); },
  'ADD': function (x, y) { return x + y; },
  'ASIN': function (x) { return Math.asin(x); },
  'ASINH': function (x) { return Math.asinh(x); },
  'ATAN': function (x) { return Math.atan(x); },
  'ATANH': function (x) { return Math.atanh(x); },
  'ATAN2': function (y, x) { return Math.atan2(y, x); },
  'CBRT': function (x) { return Math.cbrt(x); },
  'CEIL': function (x) { return Math.ceil(x); },
  'COS': function (x) { return Math.cos(x); },
  'COSH': function (x) { return Math.cosh(x); },
  'DIVIDE': function (x, y) { return x / y; },
  'EXP': function (x) { return Math.exp(x); },
  'EXPM1': function (x) { return Math.expm1(x); },
  'FACTORIAL': factorial,
  'FLOOR': function (x) { return Math.floor(x); },
  'HYPOT': function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    return Math.hypot.apply(Math, args);
},
  'LOG': function (x) { return Math.log(x); },
  'LOG1P': function (x) { return Math.log1p(x); },
  'LOG10': function (x) { return Math.log10(x); },
  'LOG2': function (x) { return Math.log2(x); },
  'MAX': function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    return Math.max.apply(Math, args);
},
  'MEAN': function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    return [].concat( args ).reduce(function (sum, x) {
    return sum + x;
  }, 0) / [].concat( args ).length;
},
  'MIN': function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    return Math.min.apply(Math, args);
},
  'MOD': function (x, y) { return x % y; },
  'MULTIPLY': function (x, y) { return x * y; },
  'POW': function (x, y) { return Math.pow( x, y ); },
  'SIN': function (x) { return Math.sin(x); },
  'SINH': function (x) { return Math.sinh(x); },
  'SQRT': function (x) { return Math.sqrt(x); },
  'SUBTRACT': function (x, y) { return x - y; },
  'SUM': function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    return [].concat( args ).reduce(function (sum, x) {
    sum += x;
    return sum;
  }, 0);
},
  'TAN': function (x) { return Math.tan(x); },
  'TANH': function (x) { return Math.tanh(x); }
};

var isSymbol = function (token) { return Object.keys(symbols).includes(token); };

var isOperator = function (token) { return Object.keys(operators).includes(token); };

var isMethod = function (token) { return Object.keys(methods).includes(token); };

var isConstant = function (token) { return Object.keys(constants).includes(token); };

var isNumber = function (token) { return /(\d+\.\d*)|(\d*\.\d+)|(\d+)/.test(token); };

var isOpenParenthesis = function (token) { return /\(/.test(token); };

var isCloseParenthesis = function (token) { return /\)/.test(token); };

var isComma = function (token) { return /,/.test(token); };

var isWhitespace = function (token) { return /\s/.test(token); };

var round = function (number, precision) {
  var modifier = Math.pow( 10, precision );
  return !modifier ? Math.round(number) : Math.round(number * modifier) / modifier;
};

function topOperatorHasPrecedence(operatorStack, currentOperatorName) {
  if (!operatorStack.length) { return false; }
  var topToken = operatorStack[operatorStack.length - 1];
  if (!isOperator(topToken)) { return false; }
  var topOperator = operators[topToken];
  var currentOperator = operators[currentOperatorName];
  if (currentOperator.method.length === 1 && topOperator.method.length > 1) { return false; }
  if (topOperator.precedence > currentOperator.precedence) { return true; }
  return topOperator.precedence === currentOperator.precedence && topOperator.associativity === 'left';
}

function determineOperator(token, previousToken) {
  if (previousToken === undefined || isOpenParenthesis(previousToken) || isSymbol(previousToken) || isComma(previousToken)) {
    return symbols[token].prefix;
  }

  if (isCloseParenthesis(previousToken) || isNumber(previousToken) || isConstant(previousToken)) {
    return symbols[token].infix;
  }

  return undefined;
}
/**
 * Takes a string and parses out the array of tokens in infix notation.
 *
 * @param {string} expression The string.
 *
 * @throws {Error} No input.
 *
 * @returns {string[]} The array of tokens in infix notation.
 */


function parse(expression) {
  if (!expression.length) {
    throw Error('No input');
  }

  var pattern = /(\d+\.\d*)|(\d*\.\d+)|(\d+)|([a-zA-Z0-9_]+)|(.)/g;
  var infixExpression = (expression.match(pattern) || []).filter(function (token) { return !isWhitespace(token); }).map(function (token) { return token.toUpperCase(); });
  return infixExpression;
}
/**
 * Takes an array of tokens in infix notation and converts it to postfix notation.
 *
 * @param {string[]} infixExpression The array of tokens in infix notation.
 *
 * @throws {Error} No valid tokens.
 * @throws {Error} Misused operator: <token>.
 * @throws {Error} Mismatched parentheses.
 * @throws {Error} Invalid token: <token>.
 * @throws {Error} Insufficient arguments for method: <token>.
 *
 * @returns {string[]} The array of tokens in postfix notation.
 */


function convert(infixExpression) {
  if (!infixExpression.length) {
    throw Error('No valid tokens');
  }

  var operatorStack = [];
  var arityStack = [];
  var postfixExpression = [];
  var methodIsNewlyDeclared = false;
  infixExpression.forEach(function (token, index) {
    if (methodIsNewlyDeclared && !isOpenParenthesis(token)) {
      throw Error(("Misused method: " + (operatorStack[operatorStack.length - 1])));
    }

    methodIsNewlyDeclared = false;

    if (isMethod(token)) {
      methodIsNewlyDeclared = true;
      operatorStack.push(token);
      arityStack.push(1);
      return;
    }

    if (isConstant(token)) {
      postfixExpression.push(token);
      return;
    }

    if (isNumber(token)) {
      postfixExpression.push(parseFloat(token));
      return;
    }

    if (isSymbol(token)) {
      var operatorName = determineOperator(token, infixExpression[index - 1]);
      var operator = operators[operatorName];

      if (operator === undefined) {
        throw Error(("Misused operator: " + token));
      }

      while (topOperatorHasPrecedence(operatorStack, operatorName)) {
        postfixExpression.push(operatorStack.pop());
      }

      operatorStack.push(operatorName);
      return;
    }

    if (isOpenParenthesis(token)) {
      operatorStack.push(token);
      return;
    }

    if (isComma(token)) {
      arityStack[arityStack.length - 1] += 1;

      while (!isOpenParenthesis(operatorStack[operatorStack.length - 1])) {
        if (!operatorStack.length) {
          throw Error('Invalid token: ,');
        }

        postfixExpression.push(operatorStack.pop());
      }

      return;
    }

    if (isCloseParenthesis(token)) {
      while (!isOpenParenthesis(operatorStack[operatorStack.length - 1])) {
        if (!operatorStack.length) {
          throw Error('Mismatched parentheses');
        }

        postfixExpression.push(operatorStack.pop());
      }

      operatorStack.pop();

      if (isMethod(operatorStack[operatorStack.length - 1])) {
        var method = operatorStack[operatorStack.length - 1];
        var argumentCount = arityStack.pop();

        if (argumentCount < methods[method].length) {
          throw Error(("Insufficient arguments for method: " + method));
        }

        postfixExpression.push(((operatorStack.pop()) + ":" + argumentCount));
      }

      return;
    }

    throw Error(("Invalid token: " + token));
  });

  while (operatorStack.length) {
    var operator = operatorStack[operatorStack.length - 1];

    if (isOpenParenthesis(operator) || isCloseParenthesis(operator)) {
      throw Error('Mismatched parentheses');
    }

    postfixExpression.push(operatorStack.pop());
  }

  return postfixExpression;
}
/**
 * Takes an array of tokens in postfix notation and resolves the result.
 *
 * @param {string[]} postfixExpression The array of tokens in postfix notation.
 *
 * @throws {Error} No operations.
 * @throws {Error} Insufficient arguments for method: <token>.
 * @throws {Error} Insufficient operands for operator: <token>.
 * @throws {Error} Division by zero.
 * @throws {Error} Insufficient operators.
 *
 * @returns {number} The result.
 */


function resolve(postfixExpression) {
  if (!postfixExpression.length) {
    throw Error('No operations');
  }

  var evaluationStack = [];
  postfixExpression.forEach(function (token) {
    if (isMethod(String(token).split(':')[0])) {
      var ref = token.split(':');
      var methodName = ref[0];
      var argumentCount = ref[1];
      var method = methods[methodName];
      var isVariadic = method.length === 0;
      var requiredArguments = isVariadic ? 1 : method.length;

      if (evaluationStack.length < requiredArguments) {
        throw Error(("Insufficient arguments for method: " + token));
      }

      var result$1 = method.apply(void 0, evaluationStack.splice(isVariadic ? -argumentCount : -method.length));
      evaluationStack.push(result$1);
      return;
    }

    if (isConstant(token)) {
      evaluationStack.push(constants[token]);
      return;
    }

    if (isNumber(token)) {
      evaluationStack.push(token);
      return;
    }

    var operator = operators[token];

    if (evaluationStack.length < operator.method.length) {
      throw Error(("Insufficient operands for operator: " + (operator.name)));
    }

    if (token === '_DIV' && evaluationStack[evaluationStack.length - 1] === 0) {
      throw Error('Division by zero');
    }

    var result = operator.method.apply(operator, evaluationStack.splice(-operator.method.length));
    evaluationStack.push(result);
  });

  if (evaluationStack.length > 1) {
    throw Error('Insufficient operators');
  }

  var reduction = evaluationStack[0];
  var result = round(reduction, 8);
  return result;
}
/**
 * Takes a string and evaluates the result.
 *
 * @param {string} expression The string.
 *
 * @throws {Error} No input.
 * @throws {Error} No valid tokens.
 * @throws {Error} Misused operator: <token>.
 * @throws {Error} Mismatched parentheses.
 * @throws {Error} Invalid token: <token>.
 * @throws {Error} No operations.
 * @throws {Error} Insufficient arguments for method: <token>.
 * @throws {Error} Insufficient operands for operator: <token>.
 * @throws {Error} Division by zero.
 * @throws {Error} Insufficient operators.
 *
 * @returns {number} The result.
 */


function index (expression) {
  try {
    var infixExpression = parse(expression);
    var postfixExpression = convert(infixExpression);
    var result = resolve(postfixExpression);
    return result;
  } catch (error) {
    throw error;
  }
}

/* harmony default export */ var evaluator_m = (index);
//# sourceMappingURL=evaluator.m.js.map

;// CONCATENATED MODULE: ./src/mosanic/utils/value.js







var getFuncOptions = function(obj) {
    var base = {
        ".length": "The length data property of an Array instance",
        ".reverse()": "Switch arround",
        "length": "",
        ".slice()": "Skii"
    };
    return base;
};
// Array.isArray(obj) ? [
// ] : [
// ]
var getValue = function(obj, path) {
    var canFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    path = path.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
    path = path.replace(/^\./, ""); // strip a leading dot
    var parts = path.split(".");
    for(var i = 0, n = parts.length; i < n; ++i){
        var ref;
        var part = parts[i];
        //handle func
        if (canFunc && ((ref = Object.keys(getFuncOptions())) === null || ref === void 0 ? void 0 : ref.includes(part))) {
            try {
                var func = new Function("return " + obj + "." + part);
                obj = func();
            } catch (e) {
                return parts;
            }
        }
        //Getter
        if (part in obj) {
            obj = obj[part];
        } else {
            return parts;
        }
    }
    return obj;
};
var splitTokens = function(value) {
    return value ? value === null || value === void 0 ? void 0 : value.split(/[{}]+/).filter(function(e) {
        return e;
    }) : value;
};
/**
 * Replace token values
 * @param {*} value 
 * @param {*} source 
 * @param {*} evaluate 
 * @returns 
 */ var replaceWithSource = function(value, source) {
    var evaluate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref;
    var splitted = splitTokens(value);
    var hasDate = false;
    //No tokens
    if ((splitted === null || splitted === void 0 ? void 0 : splitted.length) === 1 && ((ref = splitted[0]) === null || ref === void 0 ? void 0 : ref.length) === (value === null || value === void 0 ? void 0 : value.length)) return value;
    var parts = Array.isArray(splitted) ? splitted === null || splitted === void 0 ? void 0 : splitted.map(function(part) {
        if ((0,Text/* containsSubstr */.xX)(part, " ") || (part === null || part === void 0 ? void 0 : part.length) <= 2) return part;
        // console.log(part.split('.'), getFieldValue(part.split('.').map(name => ({name})), source, data?.coll))
        part = (0,helpers/* getFieldValue */.oe)(part.split(".").map(function(name) {
            return {
                name: name
            };
        }), source);
        // console.log(part)
        if ((0,utils_Date/* isValidDate */.qb)(part)) {
            hasDate = true;
            return evaluate ? new Date(part) : (0,utils_Date/* getDate */._3)(part);
        }
        return part;
    }) : splitted;
    var combined = (0,Text/* combineString */.M7)(parts, "");
    return evaluate ? getEvaluatedValue(hasDate ? parts : combined) : combined;
};
/**
 * Just value
 */ var replaceValue = function(text, value) {
    return (0,Text/* replaceParts */.oE)(text, "{value}", value);
};
/**
 * @param {*} value 
 * @returns evaluated value
 */ var getEvaluatedValue = function(value) {
    if (Array.isArray(value)) {
        if ((value === null || value === void 0 ? void 0 : value.length) === 3) {
            return (0,Text/* removeSpaces */.I8)(value[1]) === "-" ? Math.floor(((value === null || value === void 0 ? void 0 : value[0]) - (value === null || value === void 0 ? void 0 : value[2])) / 86400000) : Math.floor(((value === null || value === void 0 ? void 0 : value[2]) - (value === null || value === void 0 ? void 0 : value[0])) / 86400000);
        }
        return value;
    }
    try {
        return (0,Round/* roundPrecise */.FK)(evaluator_m(value), 2);
    } catch (error) {
        return value;
    }
};
var splitValue = function(string) {
    return string.split("|");
};
var evalReplaceValue = function() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "{value}", value = arguments.length > 1 ? arguments[1] : void 0, evaluate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (Array.isArray(value)) return "";
    if ((0,Boolean/* default */.Z)(value)) {
        var splitted = splitValue(text);
        if ((splitted === null || splitted === void 0 ? void 0 : splitted.length) === 2) return value ? splitted[0] : splitted[1];
        return value ? text : "no";
    }
    value = value ? replaceValue(text, value) : "";
    var str = "";
    splitValue(value).map(function(part) {
        return str += evaluate && (0,Text/* hasNumber */.Yo)(part) ? getEvaluatedValue(part) : part;
    });
    return str;
};
var isClone = function(clone) {
    return !(0,Empty/* default */.Z)(clone) || clone === 0;
};


/***/ }),

/***/ 77783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "reportWebVitals": function() { return /* binding */ reportWebVitals; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(45460);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/items/Page/Page.js
var Page = __webpack_require__(81099);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/mosanic/routing/Error.js








var ErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, _Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        // Define a state variable to track whether is an error or not
        _this.state = {
            hasError: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                // You can use your own error logging service here
                console.log({
                    error: error,
                    errorInfo: errorInfo
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                // Check if the error is thrown
                if (this.state.hasError) {
                    // You can render any custom fallback UI
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* Page */.T, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Oops, there is an error!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                                type: "button",
                                onClick: function() {
                                    return _this.setState({
                                        hasError: false
                                    });
                                },
                                children: "Try again?"
                            })
                        ]
                    });
                }
                // Return children components in case of no error
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                // Update state so the next render will show the fallback UI
                return {
                    hasError: true
                };
            }
        }
    ]);
    return ErrorBoundary;
}(react.Component);
/* harmony default export */ var Error = (ErrorBoundary);

;// CONCATENATED MODULE: ./src/mosanic/routing/ErrorFallback.js

var ErrorFallback = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "An error occurred;"
    });
};
/* harmony default export */ var routing_ErrorFallback = (ErrorFallback);

// EXTERNAL MODULE: ./src/context/GlobalContext.js + 1 modules
var GlobalContext = __webpack_require__(44855);
;// CONCATENATED MODULE: ./src/hooks/useProviderComposition.js

var composeProviders = function() {
    for(var _len = arguments.length, providers = new Array(_len), _key = 0; _key < _len; _key++){
        providers[_key] = arguments[_key];
    }
    return function(param) {
        var children = param.children;
        return providers.reduceRight(function(child, Provider) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
                children: child
            });
        }, children);
    };
};

;// CONCATENATED MODULE: ./src/mosanic/routing/Core.js


var MosanicCoreProviders = composeProviders(GlobalContext/* GlobalProvider */.R);
/* harmony default export */ var Core = (MosanicCoreProviders);

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/context/CoreContext.js
var CoreContext = __webpack_require__(64178);
;// CONCATENATED MODULE: ./src/mosanic/routing/Builder.js





var BuildersProviders = composeProviders(CoreContext/* CoreProvider */.k, GlobalContext/* GlobalProvider */.R);
var BuilderRouting = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildersProviders, {
        children: children
    });
};
/* harmony default export */ var Builder = (BuilderRouting);

// EXTERNAL MODULE: ./src/features/auth/action.js
var auth_action = __webpack_require__(13213);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ./src/adapters/token.js + 1 modules
var adapters_token = __webpack_require__(94645);
// EXTERNAL MODULE: ./src/mosanic/core/Layout/ThemeWrapper.js + 1 modules
var ThemeWrapper = __webpack_require__(97002);
;// CONCATENATED MODULE: ./src/mosanic/routing/RoutingProvider.js
// const LayoutCore = dynamic(() => import("../core/Layout/Core"))
// const Layout = dynamic(() => import("../components/Layout"))

var Notifications = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4454).then(__webpack_require__.bind(__webpack_require__, 34454));
});
// import LayoutMosanic from "@mosanic/core/Layout/Mosanic";
var LayoutMosanic = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5315).then(__webpack_require__.bind(__webpack_require__, 65315));
});










var RoutingProvider = function(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var match = function(paths) {
        return (0,Text/* matches */.wB)(router.pathname, paths);
    };
    var trackRouter = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var actions = (0,es/* useSelector */.v9)(reducer/* routerSelector */.VF);
    // const token = use
    // useEffect(() => {
    //   const handleRouteChange = () => {
    //     scrollTop();
    //     if(!isServer())  {
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     } else {
    //       console.log('server call')
    //     }
    //     console.log('scroll to top')
    //   }
    //   router.events.on('routeChangeComplete', handleRouteChange)
    // },[router])
    var redirect = (0,react.useRef)(0);
    var isMosanicCore = match("core|builder|app|docs");
    var isAuthPage = match("login|logout|reset|coming|register");
    var isAuth = (0,adapters_token/* isAuthenticated */.$8)();
    // useEffect(() => {
    //   const handleRouteChange = (url) => pageView(url)
    //   trackRouter.events.on('routeChangeComplete', handleRouteChange)
    //   return () => trackRouter.events.off('routeChangeComplete', handleRouteChange)
    // }, [trackRouter.events])
    // useEffect(() => {
    //   const handleRouteChange = url => {
    //     pageView(url, document.title);
    //   };
    //   router.events.on('routeChangeComplete', handleRouteChange);
    //   return () => router.events.off('routeChangeComplete', handleRouteChange);
    // }, []);
    // if(isMosanicCore && !isServer() && !isLogin) {
    (0,react.useEffect)(function() {
        var timer;
        if (isMosanicCore && !isAuthPage && !isAuth) {
            timer = setTimeout(function() {
                dispatch((0,auth_action/* authRevalidate */.Br)("_app"));
            }, 1000);
        } else {
            if (timer) clearTimeout(timer);
        }
        return function() {
            return clearTimeout(timer);
        };
    });
    (0,react.useEffect)(function() {
        if ((actions === null || actions === void 0 ? void 0 : actions.redirect) && isMosanicCore && !isAuthPage) {
            router.push({
                pathname: (actions === null || actions === void 0 ? void 0 : actions.redirect) ? actions === null || actions === void 0 ? void 0 : actions.redirect : "/login"
            });
        }
    }, [
        actions === null || actions === void 0 ? void 0 : actions.redirect,
        router,
        isMosanicCore,
        isAuthPage
    ]);
    if (isAuthPage) {
        // if(match('login|register') && isAuth) {
        //   router.push({
        //     pathname: '/',
        //     query: { type: 'redirect' }
        //   });
        // }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeWrapper/* default */.Z, {
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Notifications, {})
            ]
        });
    }
    if (isMosanicCore) {
        // if(!isServer() && !isAuth && !getToken() && !getSession()) router.push('/login')
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeWrapper/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Builder, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutMosanic, {
                    pageContext: {
                        layout: "core"
                    },
                    routerPath: router.pathname,
                    children: children
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Notifications, {})
        ]
    });
};
/* harmony default export */ var routing_RoutingProvider = (RoutingProvider);

// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(64619);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/context/ApolloContext.js
var context_ApolloContext = __webpack_require__(42370);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/react/context/ApolloProvider.js



var ApolloProvider = function (_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0,context_ApolloContext/* getApolloContext */.K)();
    return (react.createElement(ApolloContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        if (client && context.client !== client) {
            context = Object.assign({}, context, { client: client });
        }
        __DEV__ ? (0,globals/* invariant */.kG)(context.client, 'ApolloProvider was not passed a client instance. Make ' +
            'sure you pass in your client via the "client" prop.') : (0,globals/* invariant */.kG)(context.client, 29);
        return (react.createElement(ApolloContext.Provider, { value: context }, children));
    }));
};
//# sourceMappingURL=ApolloProvider.js.map
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(59775);
// EXTERNAL MODULE: ../../node_modules/redux/es/redux.js
var redux = __webpack_require__(18717);
;// CONCATENATED MODULE: ../../node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var redux_thunk_es = (thunk);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(51171);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
;// CONCATENATED MODULE: ../../node_modules/@redux-devtools/extension/lib/esm/index.js




function extensionComposeStub() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) return undefined;
  if ((0,esm_typeof/* default */.Z)(funcs[0]) === 'object') return redux.compose;
  return redux.compose.apply(void 0, (0,toConsumableArray/* default */.Z)(funcs));
}

var composeWithDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : extensionComposeStub;
var devToolsEnhancer = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
  return function (noop) {
    return noop;
  };
};



// EXTERNAL MODULE: ../../node_modules/redux-undo/lib/index.js
var lib = __webpack_require__(10458);
// EXTERNAL MODULE: ./src/features/bounds/action.js
var bounds_action = __webpack_require__(42159);
// EXTERNAL MODULE: ./src/features/ui/uiAction.js
var uiAction = __webpack_require__(19957);
;// CONCATENATED MODULE: ./src/features/bounds/middleware.js

var isOnMouseLeave = function(meta) {
    return !meta.state;
};
var handleHoverElementFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (action.type === bounds_action/* HANDLE_HOVER */.x3) isOnMouseLeave(action.meta) ? dispatch((0,bounds_action/* toggleLastHover */.N6)(action)) : dispatch((0,bounds_action/* setHoverElement */.nx)(action));
        };
    };
};
var handleResetHoverBounds = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
        // if (action.type === RESET_HO VER_BOUNDS) {
        //   // if(hasScreenBoundsSelector(getState())) dispatch({type: CLEAR_INSPE CT_BOUNDS})
        //   // if(!hasHoverBoundsSelector(getState())) return;
        //   next(action);
        // } else {
        //   next(action);
        // }
        };
    };
};
var boundsMdl = [
    handleHoverElementFlow,
    handleResetHoverBounds
];

;// CONCATENATED MODULE: ./src/features/canvas/middleware.js
var canvasMdl = [];

;// CONCATENATED MODULE: ./src/features/util/validateAction.js
var includesAction = function(action, id) {
    var ref;
    return (action === null || action === void 0 ? void 0 : (ref = action.type) === null || ref === void 0 ? void 0 : ref.includes(id)) && action.type != id;
};
var includesOneAction = function(action, ids) {
    var includes = false;
    ids.map(function(id) {
        if (includesAction(action, id)) includes = true;
    });
    return includes;
};
var isAction = function(action, id) {
    return action.type === id;
};


// EXTERNAL MODULE: ./src/features/modal/action.js
var modal_action = __webpack_require__(39623);
// EXTERNAL MODULE: ./src/features/modal/reducer.js
var modal_reducer = __webpack_require__(18891);
;// CONCATENATED MODULE: ./src/features/modal/middleware.js




var storeModalFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, modal_action/* default.REQUEST */.ZP.REQUEST)) {
                dispatch(modal_action/* modalActions.storeModalAction */.nT.storeModalAction({
                    action: action
                }));
            }
        };
    };
};
var modalSubmitActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (isAction(action, modal_action/* default.SUBMIT */.ZP.SUBMIT)) {
                dispatch(modal_action/* modalActions.clearModalAction */.nT.clearModalAction());
                if (action.payload === "decline") dispatch(modal_action/* modalActions.closeModal */.nT.closeModal());
            }
        };
    };
};
var modalConfirmActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (isAction(action, modal_action/* default.CONFIRM */.ZP.CONFIRM)) {
                var ref;
                var confirmAction = (ref = (0,modal_reducer/* getModalSelector */.SY)(getState())) === null || ref === void 0 ? void 0 : ref.confirmAction;
                dispatch(modal_action/* modalActions.clearModalAction */.nT.clearModalAction());
                if (confirmAction) dispatch(confirmAction);
            }
        };
    };
};
var modalDeclineActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (action && isAction(action, modal_action/* default.DECLINE */.ZP.DECLINE)) {
                var ref;
                var declineAction = (ref = (0,modal_reducer/* getModalSelector */.SY)(getState())) === null || ref === void 0 ? void 0 : ref.declineAction;
                dispatch(modal_action/* modalActions.clearModalAction */.nT.clearModalAction());
                if (declineAction) dispatch(declineAction);
            }
        };
    };
};
var modalMiddleware = [
    // previousModalMdl,
    storeModalFlow,
    modalSubmitActionFlow,
    modalConfirmActionFlow,
    modalDeclineActionFlow
] // export default modalMiddleware;
;

// EXTERNAL MODULE: ./src/mosanic/utils/ObjectID.js
var ObjectID = __webpack_require__(56831);
// EXTERNAL MODULE: ./src/features/notification/action.js
var notification_action = __webpack_require__(64725);
// EXTERNAL MODULE: ./src/features/notification/reducer.js
var notification_reducer = __webpack_require__(91994);
;// CONCATENATED MODULE: ./src/features/notification/middleware.js




var notificationExists = function(notifications, filter) {
    var ref;
    return ((ref = notifications.filter(function(n) {
        return (0,Text/* isStartSubString */.ze)(n === null || n === void 0 ? void 0 : n.message, filter);
    })) === null || ref === void 0 ? void 0 : ref.length) >= 1;
};
/**
 * Notification enricher
 * @returns next action
 */ var notificationMiddleware = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            var ref;
            if (action === null || action === void 0 ? void 0 : (ref = action.type) === null || ref === void 0 ? void 0 : ref.includes(notification_action/* SET_NOTIFICATION */.uP)) {
                var payload = action.payload, meta = action.meta;
                var duration = meta.duration, variant = meta.variant, persist = meta.persist, position = meta.position, delay = meta.delay;
                var _id = (0,ObjectID/* ObjectID */.t)();
                if ((meta === null || meta === void 0 ? void 0 : meta.filter) && notificationExists((0,notification_reducer/* getNotificationsSelector */.S)(getState()), meta.filter)) {
                    return null;
                }
                var notification = {
                    _id: _id,
                    message: payload,
                    duration: duration,
                    variant: variant,
                    persist: persist,
                    position: position,
                    time: new Date()
                };
                setTimeout(function() {
                    next((0,notification_action/* setNotification */.sc)({
                        message: notification,
                        feature: meta.feature
                    }));
                }, delay);
            } else {
                next(action);
            }
        };
    };
};
var notificationMdl = [
    notificationMiddleware
];

;// CONCATENATED MODULE: ./src/features/order/orderAction.js
var CREATE_ORDER = "[order] Create";
var UPDATE_ORDER = "[order] Update";
var SUBMIT_ORDER = "[order] Complete order";
var createOrder = function(data) {
    return {
        type: CREATE_ORDER,
        payload: data
    };
};
var updateOrder = function(data) {
    return {
        type: UPDATE_ORDER,
        payload: data
    };
};
var submitOrder = function(data) {
    return {
        type: SUBMIT_ORDER,
        payload: data
    };
};

;// CONCATENATED MODULE: ./src/features/order/orderMdl.js


// translate to update order action
var layoutOrder = function(param) {
    var dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (action.type === CREATE_ORDER) {
                dispatch(updateOrder({
                    date: new Date(),
                    _id: action.payload
                }));
            }
        };
    };
};
// update action ant notify about completing
var completeOrder = function(param) {
    var dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (action.type === SUBMIT_ORDER) {
                dispatch(updateOrder({
                    data: action.payload
                }));
                dispatch((0,uiAction/* orderComplete */.dv)());
            }
        };
    };
};
var orderMdl = [
    layoutOrder,
    completeOrder
];

;// CONCATENATED MODULE: ./src/features/pages/middleware.js



// import { GET_PAGES, PAGES_ID } from "./action";
// this middleware only care about the getPages action
var getPagesFlow = function(param) {
    var dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
        // if (action.type === GET_PAGES) {
        //   next([
        //     apiRequest('pageMany', PAGES, {}, null, PAGES_ID),
        //     showSpinner({location: 'canvas', feature: 'pages'}),
        //   ]);
        // }
        };
    };
};
var pageMdl = [
    getPagesFlow, 
];

// EXTERNAL MODULE: ./src/features/breakpoints/reducer.js
var breakpoints_reducer = __webpack_require__(95746);
// EXTERNAL MODULE: ./src/features/inspect/action.js
var inspect_action = __webpack_require__(67319);
// EXTERNAL MODULE: ./src/features/map/action.js
var map_action = __webpack_require__(64234);
// EXTERNAL MODULE: ./src/features/screens/action.js
var screens_action = __webpack_require__(21398);
// EXTERNAL MODULE: ./src/features/screens/reducer.js
var screens_reducer = __webpack_require__(45260);
;// CONCATENATED MODULE: ./src/features/screens/transform.js



var transformBreakPointToScreen = function(screen, breakPoint) {
    var previousX = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, removeId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, removeId ? (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, screen), {
        _id: undefined
    }) : screen), {
        size: {
            width: getWidthByBreakPoint(breakPoint),
            minWidth: breakPoint.minWidth,
            maxWidth: breakPoint.maxWidth
        },
        position: {
            x: previousX,
            y: 0
        }
    });
};
var getWidthByBreakPoint = function(breakPoint) {
    return breakPoint.minWidth === 0 ? screens_reducer/* smallestDefaultWidth */.tL : breakPoint.maxWidth === null ? breakPoint.minWidth : breakPoint.maxWidth;
};

;// CONCATENATED MODULE: ./src/features/screens/middleware.js










var Action = screens_action/* default */.ZP;
var handleScreensInitialize = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (action.type === Action.SCREENS_INIT) {
                var screens = (0,screens_reducer/* getScreensSelector */.n7)(getState());
                var previousX = 0;
                var breakPoints = (0,breakpoints_reducer/* getBreakpointsSelector */.Pg)(getState());
                screens.map(function(baseScreen) {
                    var breakPoint = (0,breakpoints_reducer/* getBreakpointIn */.u)(breakPoints, baseScreen.breakPoint);
                    var screen = transformBreakPointToScreen(baseScreen, breakPoint, previousX);
                    previousX += screen.size.width + screens_reducer/* screensOffset */.MS;
                    return dispatch((0,screens_action/* initScreen */.Qg)({
                        screen: screen,
                        bp: screen.breakPoint
                    }));
                });
            }
        };
    };
};
var handleScreenInit = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (action.type.includes(Action.SCREEN_INIT)) {
                var ref, ref1;
                if ((ref = action.payload) === null || ref === void 0 ? void 0 : ref._id) return;
                //Update previous screen meta with new generated id
                return ((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.new) ? dispatch((0,screens_action/* initNewScreen */.Q2)({
                    screen: action.payload,
                    _id: (0,ObjectID/* ObjectID */.t)()
                })) : dispatch((0,screens_action/* updateScreenMeta */.DI)({
                    screen: action.payload,
                    _id: (0,ObjectID/* ObjectID */.t)()
                }));
            }
        };
    };
};
var handleAddNewScreen = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            //Based on breakpoint 
            if (action.type === Action.SCREEN_ADD_NEW) {
                var previousX = (0,screens_reducer/* getTotalScreensWidth */.OD)(getState()) + screens_reducer/* screensOffset */.MS;
                var baseScreen = {
                    name: action.payload.name,
                    breakPoint: action.payload._id,
                    scale: screens_reducer/* baseScreenScale */.DW,
                    new: true
                };
                var screen = transformBreakPointToScreen(baseScreen, action.payload, previousX);
                dispatch((0,screens_action/* initScreen */.Qg)({
                    screen: screen,
                    bp: screen.breakPoint
                }));
            }
        };
    };
};
var handleScreenReordering = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            if (action.type === Action.SCREENS_REORDER) {
                next(action);
                var screens = (0,screens_reducer/* getScreensSelector */.n7)(getState());
                var previousX = 0;
                screens.map(function(screen) {
                    var updatedScreen = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, screen), {
                        position: {
                            y: 0,
                            x: previousX
                        }
                    });
                    previousX += screen.size.width + screens_reducer/* screensOffset */.MS;
                    return dispatch((0,screens_action/* updateScreenMeta */.DI)({
                        screen: updatedScreen
                    }));
                });
            } else {
                next(action);
            }
        };
    };
};
var handleInspectScreenFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (action.type === Action.SCREEN_INSPECT) {
                var _payload = action.payload, component = _payload.component, bounds = _payload.bounds, screen = _payload.screen;
                dispatch((0,inspect_action/* initInspectAction */.Vx)({
                    component: component,
                    screen: screen,
                    bounds: bounds,
                    path: null
                }));
            // dispatch(setInspectScreenBounds(action));
            }
        };
    };
};
var handleChangePageFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (action.type === Action.PAGE_SET) {
                var name = action.payload;
                dispatch((0,bounds_action/* resetBounds */.ZB)());
                dispatch((0,inspect_action/* clearInspectAction */.F_)());
                dispatch((0,map_action/* selectMapAction */.DB)({
                    name: name
                }));
            }
        };
    };
};
// export const handleCanvasResizeFlow = ({getState, dispatch}) => next => action => {
//   if(action.type === HANDLE_CANVAS_RESIZE && !action.meta?.handled){ //HANDLE_CANVAS
//     const breakPoints = getBreakpoints(getState());
//     const updatedCanvas = action.payload;
//     const targetBreakpoint = getBreakPointByWidth(parseFloat(updatedCanvas.width), breakPoints);
//     // dispatch(setCanvasPreview(targetBreakpoint)); //Pass preset offsets
//     dispatch({type: UPDATE_DIMENSIONS, payload: targetBreakpoint})
//     // dispatch({type: SET_CANVAS_BREAKPOINT, payload: targetBreakpoint, meta: {...action.meta, ...breakPoints}});
//     // const newPreviewPoints = generatePreviewPoints(targetBreakpoint, breakPoints);
//     // dispatch({type: SET_PREVIEW_POINTS, payload: newPreviewPoints, meta: action.meta})
//     // dispatch({type: SET_THEME, payload: getScreenTheme(newPreviewPoints), meta: {state: 'Todo'}})
//     dispatch({
//         type: SET_CANVAS,
//         payload: updatedCanvas,
//         meta: {handled: true}
//     })
//   } else {
//     next(action);
//   }
// };
// /**
//  * Main layouts flow
//  * @param {*} param0 
//  * @returns 
//  */
// export const handleDimensionUpdates = ({getState, dispatch}) => next => action => {
//   next(action);
//   if(action.type === UPDATE_DIMENSIONS){ 
//     const breakPoints = getBreakpoints(getState());
//     let targetBreakpoint = action.payload;
//     //Fallback
//     if(!targetBreakpoint){
//       targetBreakpoint = getBreakPointByWidth(parseFloat(window.innerWidth / 1.2), breakPoints);
//     }
//     //Change breakpoint
//     dispatch({type: SET_CANVAS_BREAKPOINT, payload: targetBreakpoint, meta: {...action.meta, ...breakPoints}});
//     //Generate preview break points
//     const newPreviewPoints = generatePreviewPoints(targetBreakpoint, breakPoints);
//     dispatch({type: SET_PREVIEW_POINTS, payload: newPreviewPoints, meta: action.meta})
//     dispatch(resetHoverBounds(CANVAS_ID))
//   }
// };
// export const generatePreviewPoints = (search, breakPoints) => {
//   let clientWidth = window.innerWidth;
//   let newPoints = {};
//   let hit = false;
//   //Check all default breakpoints
//   Object.entries(breakPoints).map(([key, value])=>{
//     //If key is current preview
//     if(!hit && key != search){
//       newPoints[key] = clientWidth - 250;
//     }
//     if(key === search){
//       newPoints[key] = clientWidth - 50;
//       hit = true;
//     }
//     if(hit && key != search){
//       clientWidth = clientWidth + 100;
//       newPoints[key] = clientWidth;
//     }
//   });
//   return newPoints;
// }
var screensMdl = [
    handleScreensInitialize,
    handleAddNewScreen,
    handleScreenInit,
    handleInspectScreenFlow,
    handleScreenReordering,
    handleChangePageFlow, 
];

// EXTERNAL MODULE: ./src/mosanic/utils/Identifiers.js
var Identifiers = __webpack_require__(82583);
// EXTERNAL MODULE: ./src/features/tokens/action.js
var tokens_action = __webpack_require__(24385);
;// CONCATENATED MODULE: ./src/features/tokens/middleware.js





var handleTokenCreationFlow = function() {
    return function(next) {
        return function(action) {
            action.type === tokens_action/* CREATE_DESIGN_TOKEN */.pk ? next((0,tokens_action/* setDesignToken */.gz)({
                token: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, action.payload), {
                    selector: (0,Identifiers/* toVarCase */.V5)(action.payload.label)
                }),
                _id: (0,ObjectID/* ObjectID */.t)()
            })) : next(action);
        };
    };
};
var tokensMdl = [
    handleTokenCreationFlow, 
];

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/mosanic/utils/data/get.js
var get = __webpack_require__(60018);
// EXTERNAL MODULE: ./src/mosanic/_Schemas.js
var _Schemas = __webpack_require__(8515);
// EXTERNAL MODULE: ./src/mosanic/_templates.js
var _templates = __webpack_require__(21286);
;// CONCATENATED MODULE: ./src/mosanic/utils/data/initialize.js
// import {setDesignState, copyDesignState, initDesignState} from './initializeDesign'
//TODO  RENAME PARENT TO: DATA









var baseData = {
    reference: null,
    compRef: null,
    isMain: false,
    isComp: false,
    isCloned: false,
    isLinked: false,
    repeating: false
};
var initialize = function(param) {
    var item = param.item, _setup = param.setup, setup = _setup === void 0 ? null : _setup;
    var className = (0,Identifiers/* toClassName */.vC)(item.itemType, item === null || item === void 0 ? void 0 : item.type, item._id);
    // const parsedItem = parseSideBarItem(item);/
    // const data = parseItemData(item, setup)
    // const design = checkMosanicDesignTemplates(item)
    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, checkMosanicTemplates(item)), {
        className: className,
        options: setup ? setup : undefined
    });
};
var parseItemData = function(sideBarItem, setup) {
    return setup ? _object_spread({}, baseData, sideBarItem.data, setup) : _object_spread({}, baseData, sideBarItem.data);
};
// const parseItemContent = (content) => content.replace(/<([a-z][a-z0-9]*)[^>]*?(\/?)>/si, "");
var parseSideBarItem = function(sideBarItem) {
    return Object.keys(sideBarItem).length >= 3 ? {
        _id: sideBarItem._id,
        type: sideBarItem.type,
        title: sideBarItem.title,
        icon: sideBarItem.icon,
        desc: sideBarItem.desc
    } : {
        _id: sideBarItem._id,
        type: sideBarItem.type,
        title: capitalizeFirst(sideBarItem.type)
    };
};
var checkMosanicDesignTemplates = function(sideBarItem) {
    return {
        default: {}
    };
};
var checkMosanicTemplates = function(item) {
    var type = (0,Text/* toLowCase */.Cc)(item.type);
    var template = (item === null || item === void 0 ? void 0 : item.template) ? _templates/* templates */.z[item.template] : (0,_Schemas/* getMosanicTemplate */.mS)(type);
    var fields = (0,_Schemas/* getMosanicFields */.Fe)(type);
    return template || fields ? (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
        fields: (0,src_object_spread/* default */.Z)({}, item.fields, fields),
        data: (0,src_object_spread/* default */.Z)({}, item.data, template)
    }) : item;
};
// export const initializeNewComponent = (element, isMain=false) => {
//   initializeElement(element);
//   return element;
// }
// export const initializeNewRow = (newRowId, isMain=false, isCloned=false) => {
//   let newRow = { 
//     _id: newRowId, 
//     type: "ROW", 
//     title: "Section",
//     // container: true,
//     layout: {},
//     layouts: {},
//     design: {},
//     repeating: {
// 			collection: 'abcd'
// 		},
//     data: {
// 			reference: 'abcd',
//       isMain: isMain,
//       isCloned: isCloned,
//       isLinked: false,
// 			repeating: true,
// 		},
//   };
//   newRow = initializeElement(newRow, 'default', false);
//   if(newRow?.layout?.display) newRow.layout.display = undefined;
//   return newRow;
// };
// export const initializeNewStack = ({id, state}) => {
//   const stackId = id;
//   const {isMain, isCloned, isLinked} = state;
//   let newStack = {
//     _id: stackId, 
//     type: "STACK", 
//     title: "Stack",
//     layout: {
//       // grid: {
//       //   display:    {xs: true, sm: true, md: true, lg: true, xl: true},
//       // },
//     },
//     layouts: {},
//     design: {},
//     isLocked: false,
//     data: {
// 			reference: 'abcd',
//       isMain: isMain,
//       isCloned: isCloned,
//       isLinked: false,
// 			repeating: true,
// 		},
//   };
//   // newColumn = setColumnDisplay(newColumn);
//   newStack = initializeElement(newStack, 'default', false);
//   return newStack;
// };
// export const initializeNewRepeater = ({id, reference}) => {
//   const repeaterId = id;
//   const mainChild = reference;
//   let newRepeater = {
//     _id: repeaterId, 
//     type: "REPEATER", 
//     title: "Repeater",
//     layout: {},
//     layouts: {},
//     design: {},
//     isLocked: false,
//     layout: {
//     },
//     collection: {
//       source: null, //news
//       filter: '',   //obj? graphql check??
//       sort: '',     //  ""
//       pagination: '',
//     },
//     data: {
// 			mainRef: reference?._id,
//       childType: mainChild.type,
//       clones: [],
// 		},
//   };
//   // newRepeater = setColumnDisplay(newRepeater);
//   newRepeater = initializeElement(newRepeater, 'default', false);
//   return newRepeater;
// };
// export const initializeNewCol = ({id, childType, state}) => {
//   const newColumnId = id;
//   const newComponent = childType
//   const {isMain, isCloned, isLinked} = state;
//   let newColumn = {
//     _id: newColumnId, 
//     type: "COLUMN", 
//     title: "Column",
//     layout: {
//       grid: {
//         responsive: getGridDefaults(newComponent),
//         order:     {xs: null, sm: null, md: null, lg: null, xl: null},
//         offset:     {xs: null, sm: null, md: null, lg: null, xl: null},
//         display:    {xs: true, sm: true, md: true, lg: true, xl: true},
//       },
//     },
//     layouts: {},
//     design: {},
//     isLocked: false,
//     data: {
// 			mainRef: null,
//       isMain: isMain,
//       isCloned: isCloned,
//       isLinked: false,
// 			repeating: false,
// 		},
//   };
//   // newColumn = setColumnDisplay(newColumn);
//   newColumn = initializeElement(newColumn, 'default', false);
//   return newColumn;
// };
var setDefaultLayout = function(element) {
    element = setVisibility(element);
    // element = setDisplay(element);
    if (element.type === "row" || element.type === "ROW") {
        element.layout.container = {
            state: {
                xs: true,
                sm: true,
                md: true,
                lg: true,
                xl: true
            }
        };
    }
    return element;
};
// element = setDisplay(element);
var setDisplay = function(element) {
    var ref, ref1;
    if (!(element === null || element === void 0 ? void 0 : (ref = element.layout) === null || ref === void 0 ? void 0 : (ref1 = ref.display) === null || ref1 === void 0 ? void 0 : ref1.position)) {
        element.layout.display = getEmptyChildDisplayState();
    }
    return element;
};
var setVisibility = function(element) {
    var ref;
    if ((element === null || element === void 0 ? void 0 : element.layout) && (element === null || element === void 0 ? void 0 : (ref = element.layout) === null || ref === void 0 ? void 0 : ref.visibility) === undefined) {
        element.layout.visibility = getEmptyVisibilityState();
    }
    return element;
};
var setColumnDisplay = function(element) {
    var ref;
    if (!(element === null || element === void 0 ? void 0 : (ref = element.layout) === null || ref === void 0 ? void 0 : ref.display)) {
        element.layout.display = {
            displayType: "auto",
            position: "relative",
            flex: {
                direction: "row",
                align: "start",
                justify: "start",
                reverse: false,
                wrap: false
            }
        };
    }
    return element;
};

// EXTERNAL MODULE: ./src/mosanic/utils/map/add.js
var add = __webpack_require__(40607);
// EXTERNAL MODULE: ./src/utils/Arr.js
var Arr = __webpack_require__(72393);
// EXTERNAL MODULE: ./src/mosanic/utils/map/paths.js
var paths = __webpack_require__(21634);
;// CONCATENATED MODULE: ./src/mosanic/utils/map/remove.js





var removeChildFromChildren = function(param) {
    var children = param.children, itemPath = param.itemPath;
    if (!Array.isArray(itemPath)) itemPath = (0,paths/* splitPath */.uo)(itemPath);
    if (itemPath.length === 1 && (children === null || children === void 0 ? void 0 : children.length) >= 1) {
        var itemIndex = Number(itemPath[0]);
        if ((children === null || children === void 0 ? void 0 : children.length) == 1) {
            alert("Last child element removed");
        }
        return (0,Arr/* remove */.Od)(children, itemIndex);
    }
    var updatedChildren = children ? (0,src_to_consumable_array/* default */.Z)(children) : [];
    var curIndex = Number(itemPath.slice(0, 1));
    // Update the specific node's children
    var splitItemChildrenPath = itemPath.slice(1);
    var nodeChildren = updatedChildren[curIndex];
    updatedChildren[curIndex] = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, nodeChildren), {
        children: removeChildFromChildren({
            children: nodeChildren === null || nodeChildren === void 0 ? void 0 : nodeChildren.children,
            itemPath: splitItemChildrenPath
        })
    });
    return updatedChildren;
};

;// CONCATENATED MODULE: ./src/mosanic/utils/map/move.js





var handleMoveToDifferentParent = function(param) {
    var children = param.children, dropPath = param.dropPath, itemPath = param.itemPath, item = param.item;
    // const COLUMN_STRUCTURE = {
    //   type: COLUMN,
    //   _id: columnId,
    //   children: [item]
    // };
    // const ROW_STRUCTURE = {
    //   type: ROW,
    //   _id: rowId
    // };
    switch(dropPath.length){
        case 1:
            {
                break;
            }
        case 2:
            {
                break;
            }
        default:
            {
            // //Inside row?
            // if (item.type === STACK) {
            //   // alert('found container move  -- case DEFAULT WRONG !'+splitDropZonePath.length)
            // }
            // //Move component inside new column
            // newLayoutStructure = item;
            }
    }
    var map = removeChildFromChildren({
        children: children,
        itemPath: itemPath
    });
    // map = handleAddColumDataToRow(updatedLayout, columnId);
    map = (0,add/* addChildToChildren */.L)({
        children: map,
        dropPath: dropPath,
        item: item
    });
    return map;
};
var handleMoveCreate = function(param) {
    var children = param.children, dropPath = param.dropPath, itemPath = param.itemPath, item = param.item;
    //Row is going before previous row
    if (dropPath.length === 1 && dropPath[0] <= itemPath[0]) {
        children = (0,add/* addChildToChildren */.L)({
            children: children,
            dropPath: dropPath,
            item: item
        });
        //Move index of itemPath one up
        var path = [
            parseFloat(itemPath[0]) + 1
        ].concat((0,src_to_consumable_array/* default */.Z)(itemPath.slice(1)));
        children = removeChildFromChildren({
            children: children,
            itemPath: path
        });
    } else {
        //Start with adding (save because no new row)
        children = (0,add/* addChildToChildren */.L)({
            children: children,
            dropPath: dropPath,
            item: item
        });
        children = removeChildFromChildren({
            children: children,
            itemPath: itemPath
        });
    }
    return children;
};

;// CONCATENATED MODULE: ./src/mosanic/utils/map/reorder.js




var reorderChildren = function(param) {
    var children = param.children, dropPath = param.dropPath, itemPath = param.itemPath;
    if (dropPath.length === 1) {
        var dropZoneIndex = Number(dropPath[0]);
        var itemIndex = Number(itemPath[0]);
        return (0,Arr/* reorder */.HP)(children, itemIndex, dropZoneIndex);
    }
    var updatedChildren = (0,src_to_consumable_array/* default */.Z)(children);
    var curIndex = Number(dropPath.slice(0, 1));
    // Update the specific node's children
    var splitDropZoneChildrenPath = dropPath.slice(1);
    var splitItemChildrenPath = itemPath.slice(1);
    var nodeChildren = updatedChildren[curIndex];
    updatedChildren[curIndex] = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, nodeChildren), {
        children: reorderChildren({
            children: nodeChildren.children,
            dropPath: splitDropZoneChildrenPath,
            itemPath: splitItemChildrenPath
        })
    });
    return updatedChildren;
};
var handleMoveWithinParent = function(param) {
    var map = param.map, dropPath = param.dropPath, itemPath = param.itemPath;
    return reorderChildren({
        children: map,
        dropPath: dropPath,
        itemPath: itemPath
    });
};

;// CONCATENATED MODULE: ./src/mosanic/utils/map/validate.js




//Moves
var isPureMove = function(param) {
    var itemPath = param.itemPath, dropPath = param.dropPath;
    return (itemPath === null || itemPath === void 0 ? void 0 : itemPath.length) === (dropPath === null || dropPath === void 0 ? void 0 : dropPath.length);
};
var isMoveWithinParent = function(param) {
    var itemPath = param.itemPath, dropPath = param.dropPath;
    return (0,paths/* pathToItem */.pN)(itemPath) === (0,paths/* pathToItem */.pN)(dropPath);
};
//Validate by schema
var validate = function(param) {
    var item = param.item, children = param.children;
    if (children) return children.map(function(child) {
        return validate({
            item: child
        });
    });
    if (!(item === null || item === void 0 ? void 0 : item.children)) return (0,_Schemas/* validateMosanicItem */.P$)(item);
    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,_Schemas/* validateMosanicItem */.P$)(item)), {
        children: validate({
            children: item === null || item === void 0 ? void 0 : item.children
        })
    });
};

;// CONCATENATED MODULE: ./src/mosanic/utils/map/index.js







var Move = {
    handleNewItem: add/* handleNewItem */.i,
    handleMoveWithinParent: handleMoveWithinParent,
    handleMoveToDifferentParent: handleMoveToDifferentParent,
    handleMoveCreate: handleMoveCreate,
    removeChildFromChildren: removeChildFromChildren
};
var ValidateMove = {
    isPureMove: isPureMove,
    isMoveWithinParent: isMoveWithinParent
};


// EXTERNAL MODULE: ./src/features/artboard/reducer.js
var artboard_reducer = __webpack_require__(41415);
// EXTERNAL MODULE: ./src/features/artboard/action.js
var artboard_action = __webpack_require__(78616);
// EXTERNAL MODULE: ./src/features/map/drop/action.js
var drop_action = __webpack_require__(59357);
// EXTERNAL MODULE: ./src/features/map/reducer.js
var map_reducer = __webpack_require__(78726);
// EXTERNAL MODULE: ./src/features/map/data/action.js
var data_action = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/features/map/validate.js



var isNewAddAction = function(action) {
    return includesAction(action, map_action/* default.MAP_ADD */.ZP.MAP_ADD);
};
//Use this date to validate if modal should be launched
var getValidationData = function(param) {
    var action = param.action;
    return isNewAddAction(action) ? {
        declineAction: (0,data_action/* removeDataAction */.xC)({
            component: action.payload
        }),
        title: "Action required before initializing."
    } : {
        declineAction: null,
        title: "Action required before moving."
    };
};
var isValidated = function(action) {
    var ref, ref1;
    return ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.validated) || (action === null || action === void 0 ? void 0 : (ref1 = action.options) === null || ref1 === void 0 ? void 0 : ref1.validated);
};
var hasWrapper = function(action) {
    var ref, ref1;
    return (action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : ref.wrapper) || (action === null || action === void 0 ? void 0 : (ref1 = action.options) === null || ref1 === void 0 ? void 0 : ref1.wrapper);
};

;// CONCATENATED MODULE: ./src/features/util/action.js


var enlargePayload = function(action, data) {
    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, action), {
        payload: (0,src_object_spread/* default */.Z)({}, action.payload, data)
    });
};
var replacePayload = function(action, data) {
    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, action), {
        payload: data
    });
};
var addOptions = function(action, data) {
    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, action), {
        options: Array.isArray(data) ? data : (0,src_object_spread/* default */.Z)({}, action.options, data)
    });
};
var replaceType = function(action, newType) {
    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, action), {
        type: newType
    });
};

// EXTERNAL MODULE: ./src/mosanic/utils/data/factory.js
var factory = __webpack_require__(45371);
// EXTERNAL MODULE: ./src/features/map/data/selector.js
var selector = __webpack_require__(52478);
// EXTERNAL MODULE: ./src/mosanic/utils/map/transform.js
var transform = __webpack_require__(8374);
// EXTERNAL MODULE: ./src/features/map/data/reducer.js
var data_reducer = __webpack_require__(94718);
;// CONCATENATED MODULE: ./src/features/map/data/middleware.js
// import { initialize } from '@mosanic/data';





















//Initialization of new item
var dataActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, data_action/* default.DATA_INIT */.ZP.DATA_INIT)) {
                var ref;
                var setupData = (0,src_object_spread/* default */.Z)({}, action.payload, (0,get/* getOptions */.FW)(action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : ref.options));
                var component1 = initialize({
                    item: setupData
                });
                dispatch(data_action/* dataActions.addDataAction */.tD.addDataAction({
                    component: component1
                }, true));
            }
        };
    };
};
//Convert to component
var dataConvertFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, data_action/* default.DATA_CONVERT */.ZP.DATA_CONVERT)) {
                var _payload = action.payload, path = _payload.path, target = _payload.target;
                var state = getState();
                //Get copy of original
                var originalItem = (0,selector/* itemSelector */.O1)(state, action.payload);
                //Gen new component id
                var _id = (0,ObjectID/* ObjectID */.t)();
                //Get item map from state
                var itemMap = (0,map_reducer/* itemMapByPathSelector */.Yq)(state, path);
                var storedData = (0,data_reducer/* dataSelector */.Fb)(state);
                var ref = (0,_sliced_to_array/* default */.Z)((0,transform/* convertPreSaveLayout */.cq)(storedData, itemMap), 4), newLayoutMap = ref[0], layoutData = ref[1], parent = ref[2], count = ref[3];
                var artboard = {
                    _id: (0,ObjectID/* ObjectID */.t)(),
                    title: "[local] ".concat(originalItem === null || originalItem === void 0 ? void 0 : originalItem.type, " ").concat(count),
                    saved: false
                };
                //Store component
                if (target != "artboards") {
                    dispatch(data_action/* dataActions.addDataAction */.tD.addDataAction({
                        component: component
                    }, true));
                } else {
                    dispatch((0,artboard_action/* addArtboardAction */.Pg)({
                        artboard: artboard,
                        map: newLayoutMap,
                        data: layoutData
                    }));
                }
                //Compress source item
                var compressedItem = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, originalItem), {
                    refItem: _id,
                    data: {},
                    variants: undefined,
                    states: undefined
                });
                //Update source
                dispatch(data_action/* dataActions.updateDataAction */.tD.updateDataAction({
                    component: compressedItem
                }, true));
            }
        };
    };
};
//Convert to component
var dataExtendFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (isAction(action, data_action/* default.DATA_EXTEND */.ZP.DATA_EXTEND)) {
                var _payload = action.payload, component1 = _payload.component, itemMap = _payload.itemMap, dropPath = _payload.dropPath;
                var state = getState();
                var ref = null;
                var currentPage = (0,screens_reducer/* currentPageName */.K)(state);
                if (currentPage === "artboards") {
                    ref = (0,artboard_reducer/* artboardSelector */.b2)(state);
                    ref = (0,selector/* itemSelector */.O1)(state, ref);
                    //Move item into reference map
                    var newMap = Move.handleNewItem({
                        map: (ref === null || ref === void 0 ? void 0 : ref.map) ? [
                            ref.map
                        ] : [],
                        dropPath: dropPath,
                        item: itemMap
                    });
                    //Update main component and add new item map
                    ref = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, ref), {
                        components: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, ref === null || ref === void 0 ? void 0 : ref.components), (0,_define_property/* default */.Z)({}, itemMap === null || itemMap === void 0 ? void 0 : itemMap._id, itemMap)),
                        map: newMap[0]
                    });
                    dispatch(data_action/* dataActions.updateDataAction */.tD.updateDataAction({
                        component: ref
                    }, true));
                    dispatch((0,uiAction/* hideSpinner */.v3)({
                        location: "canvas",
                        feature: drop_action/* DROP_ID */.H8
                    }));
                } else {
                    // const path = splitPath(dropPath.splice(-1))
                    // ref = itemMapByPathSelector(state, path);
                    // ref = itemSelector(state, ref);
                    // const afterSlotIndex = (parseFloat(dropPath[dropPath.length - 1]) + 1).toString();
                    // const lastRemoved = [...dropPath].splice(0, dropPath.length - 1);
                    // dispatch({type: 'TESTING DROP PATH', payload: {dropPath, afterSlotIndex, lastRemoved, new: [...lastRemoved, afterSlotIndex]}})
                    dispatch(map_action/* mapActions.addMapAction */.nv.addMapAction({
                        itemMap: itemMap,
                        dropPath: dropPath
                    }));
                }
            }
        };
    };
};
var dataCopyFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, data_action/* default.DATA_COPY */.ZP.DATA_COPY)) {
                var ref;
                var item = action.payload;
                var sourceId = (ref = action.meta) === null || ref === void 0 ? void 0 : ref.sourceId;
                var obj = {
                    group: item.group,
                    _id: sourceId
                };
                var component1 = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,selector/* itemSelector */.O1)(getState(), obj)), {
                    _id: item._id
                });
                dispatch(data_action/* dataActions.addDataAction */.tD.addDataAction({
                    component: component1
                }, true));
            }
        };
    };
};
var dataRemoveFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, data_action/* default.DATA_REMOVE */.ZP.DATA_REMOVE)) {
                var ref;
                var item = action.payload;
                var sourceId = (ref = action.meta) === null || ref === void 0 ? void 0 : ref.sourceId;
                var component1 = {
                    group: item.group,
                    _id: sourceId
                };
                dispatch(data_action/* dataActions.removeDataAction */.tD.removeDataAction({
                    component: component1
                }, component1._id, true));
            }
        };
    };
};
//Create wrapper if confirmed
var factoryWrapperFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            if (hasWrapper(action) && isValidated(action)) {
                var itemMap = action.payload.item;
                var options = action.options;
                9;
                var wrapper = factory/* DataFactory.wrapper */.x.wrapper({
                    itemMap: itemMap,
                    type: options.wrapper
                }, dispatch);
                dispatch({
                    type: "WRAPPER ADDED",
                    payload: wrapper
                });
                action = enlargePayload(action, {
                    item: wrapper
                });
                dispatch((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, action), {
                    options: {
                        validated: true
                    }
                }));
            } else {
                next(action);
            }
        };
    };
};
var dataMiddleware = [
    dataActionFlow,
    dataCopyFlow,
    dataConvertFlow,
    dataRemoveFlow,
    factoryWrapperFlow,
    dataExtendFlow
];

// EXTERNAL MODULE: ./src/mosanic/utils/map/get.js
var map_get = __webpack_require__(84570);
;// CONCATENATED MODULE: ./src/features/map/actions/copyMiddleware.js





var copyComponentActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, drop_action/* default.DROP_COPY */.ZP.DROP_COPY)) {
                var state = getState();
                var preStore = action.payload.preStore;
                //Get current inspected item map
                var itemRef = (0,map_get/* getItemMapFromActionOrState */.EK)({
                    action: action,
                    state: state
                });
                //When not pre storing, append as sibling to copied source
                if (!preStore) {
                    dispatch(drop_action/* dropActions.clearPreStoreAction */.to.clearPreStoreAction());
                    dispatch(drop_action/* dropActions.handleAutoPasteAction */.to.handleAutoPasteAction({
                        sourceItemPath: itemRef.path,
                        itemRef: itemRef
                    }));
                } else {
                    dispatch(drop_action/* dropActions.handlePreStoreAction */.to.handlePreStoreAction((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, itemRef), {
                        sourceItemPath: itemRef.path,
                        isCopied: true
                    })));
                }
            }
        };
    };
};
var copyMiddleware = [
    copyComponentActionFlow
];

;// CONCATENATED MODULE: ./src/features/map/actions/cutMiddleware.js







var cutComponentActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, drop_action/* default.DROP_CUT */.ZP.DROP_CUT)) {
                var state = getState();
                //Get inspected for saving reference
                var itemRef = (0,map_get/* getItemMapFromActionOrState */.EK)({
                    action: action,
                    state: state
                });
                //Set cut state
                var component = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,selector/* getItem */.rV)((0,data_reducer/* dataSelector */.Fb)(state), itemRef)), {
                    isCut: true
                });
                dispatch(data_action/* dataActions.updateDataAction */.tD.updateDataAction({
                    component: component
                }, true));
                //Pre store
                dispatch(drop_action/* dropActions.handlePreStoreAction */.to.handlePreStoreAction((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, itemRef), {
                    sourceItemPath: itemRef.path,
                    isCut: true
                })));
            }
        };
    };
};
var cutMiddleware = [
    cutComponentActionFlow
];

// EXTERNAL MODULE: ./src/mosanic/utils/map/path.js
var path = __webpack_require__(49578);
// EXTERNAL MODULE: ./src/features/inspect/reducer.js
var inspect_reducer = __webpack_require__(57522);
// EXTERNAL MODULE: ./src/features/map/drop/reducer.js
var drop_reducer = __webpack_require__(93819);
;// CONCATENATED MODULE: ./src/features/map/actions/pasteMiddleware.js








var pasteComponentActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, drop_action/* default.DROP_PASTE */.ZP.DROP_PASTE)) {
                var state = getState();
                var preStore = (0,drop_reducer/* preDropStoreSelector */.U)(state);
                //Get source
                var item = !Boolean(preStore === null || preStore === void 0 ? void 0 : preStore._id) ? action.payload : preStore;
                var sourceItemPath = (item || {
                    sourceItemPath: null
                }).sourceItemPath;
                if (!sourceItemPath) return;
                //Convert source
                var itemMap = (0,transform/* copyAndTransformItemMap */.YY)([
                    item
                ], dispatch);
                var currentPath = (0,inspect_reducer/* selectInspectItemPath */.fP)(state);
                if (currentPath != sourceItemPath) {
                    (0,notification_action/* setNotification */.sc)({
                        message: "Pasting component on different location",
                        feature: "drop",
                        meta: {
                            duration: 1000,
                            variant: "info"
                        }
                    });
                }
                //Add to map
                var dropPath = (0,path/* getSiblingPath */.g)(currentPath);
                dispatch(map_action/* mapActions.addMapAction */.nv.addMapAction({
                    itemMap: itemMap,
                    dropPath: dropPath
                }));
            }
        };
    };
};
var pasteMiddleware = [
    pasteComponentActionFlow
];

;// CONCATENATED MODULE: ./src/features/map/actions/removeMiddleware.js








var SPINNER = {
    location: "canvas",
    feature: drop_action/* DROP_ID */.H8
};
var removeComponentActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (isAction(action, drop_action/* default.DELETE_HANDLE */.ZP.DELETE_HANDLE)) {
                dispatch((0,uiAction/* showSpinner */.yh)(SPINNER));
                var state = getState();
                var item = (0,map_get/* getItemMapFromActionOrState */.EK)({
                    action: action,
                    state: state
                });
                if (!(item === null || item === void 0 ? void 0 : item.path)) return;
                //Remove item from map first
                dispatch(map_action/* mapActions.removeMapAction */.nv.removeMapAction({
                    item: item
                }));
                //Handler for removing child components
                var returnAndDeleteItemMap = function(child) {
                    dispatch(data_action/* dataActions.removeDataAction */.tD.removeDataAction({
                        component: child
                    }, child === null || child === void 0 ? void 0 : child._id));
                    return child;
                };
                //Recursive delete children
                (0,transform/* convertItemMap */._3)([
                    item
                ], returnAndDeleteItemMap);
                dispatch((0,inspect_action/* resetInspectAction */.bC)());
            }
        };
    };
};
var removeMiddleware = [
    removeComponentActionFlow, 
];

// EXTERNAL MODULE: ./src/mosanic/utils/data/transform.js
var data_transform = __webpack_require__(2467);
// EXTERNAL MODULE: ./src/features/inspect/selector.js
var inspect_selector = __webpack_require__(81903);
// EXTERNAL MODULE: ./src/mosanic/constants/items.js
var items = __webpack_require__(66625);
;// CONCATENATED MODULE: ./src/features/map/drop/validate.js

//Item types
var isNewDropItem = function(type) {
    return [
        items/* SIDEBAR_ITEM */.d8,
        items/* ADD_ITEM */.mj,
        items/* SIDEBAR_LAYOUT */.vo
    ].includes(type);
};
var isNewDropLayout = function(item) {
    return [
        items/* SIDEBAR_LAYOUT */.vo,
        "section"
    ].includes(item === null || item === void 0 ? void 0 : item.layoutType);
};
var isMoveDropItem = function(type) {
    return !isNewDropItem(type) && !isNewDropLayout(type);
};

;// CONCATENATED MODULE: ./src/mosanic/utils/map/drop.js











var drop_SPINNER = {
    location: "canvas",
    feature: drop_action/* DROP_ID */.H8
};
var setStartStateDropAction = function(dispatch) {
    dispatch((0,drop_action/* clearPreStoreAction */.g)());
    dispatch((0,uiAction/* showSpinner */.yh)(drop_SPINNER));
};
var transformDropActionPayload = function(action) {
    var _payload = action.payload, dropZone = _payload.dropZone, item = _payload.item;
    var dropPath = (0,paths/* splitPath */.uo)(dropZone === null || dropZone === void 0 ? void 0 : dropZone.path);
    return [
        dropZone,
        item,
        dropPath
    ];
};
var handleNewItemDropAction = function(param) {
    var dispatch = param.dispatch, item = param.item, dropZone = param.dropZone, dropPath = param.dropPath;
    var ref = (0,_sliced_to_array/* default */.Z)((0,data_transform/* transformInitialItemFull */.Ci)({
        item: item
    }, dispatch), 2), itemMap = ref[0], component = ref[1];
    dispatch(data_action/* dataActions.initDataAction */.tD.initDataAction({
        component: component
    }));
    if (dropZone === null || dropZone === void 0 ? void 0 : dropZone.slot) {
        dispatch(data_action/* dataActions.extendItemDataAction */.tD.extendItemDataAction({
            itemMap: itemMap,
            dropPath: dropPath
        }));
    } else {
        dispatch(map_action/* mapActions.addMapAction */.nv.addMapAction({
            itemMap: itemMap,
            dropPath: dropPath
        }));
    }
};
var handleNewLayoutDropAction = function(param) {
    var dispatch = param.dispatch, item = param.item, dropZone = param.dropZone, dropPath = param.dropPath;
    var ref;
    var getChild = function(child) {
        return item.data[child.group][child._id];
    };
    //Copy the child from the layout data and change the _id of it
    var copyTransform = function(child) {
        // console.log(getChild(child))
        var newId = (0,ObjectID/* ObjectID */.t)();
        var component = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getChild(child)), {
            _id: newId
        });
        console.log({
            newId: newId,
            oldId: child._id
        });
        dispatch(data_action/* dataActions.addDataAction */.tD.addDataAction({
            component: component
        }, true));
        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, child), {
            _id: newId
        });
    };
    //Recursive loop and create a new map
    var itemMap = (ref = (0,transform/* convertItemMap */._3)([
        item.map
    ], copyTransform)) === null || ref === void 0 ? void 0 : ref[0];
    dispatch(map_action/* mapActions.addMapAction */.nv.addMapAction({
        itemMap: itemMap,
        dropPath: dropPath
    }));
    console.log(itemMap);
};
var handleItemMoveDropAction = function(param) {
    var dispatch = param.dispatch, item = param.item, dropPath = param.dropPath;
    var itemPath = (0,paths/* splitPath */.uo)(item.path);
    dispatch(map_action/* mapActions.moveMapAction */.nv.moveMapAction({
        item: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
            path: undefined
        }),
        itemPath: itemPath,
        dropPath: dropPath
    }));
};
var handleAddCopiedItemAction = function(param) {
    var dispatch = param.dispatch, item = param.item, dropPath = param.dropPath;
    //DropZone is clicked, but since the item is from the pre_store:
    //Copy and transform its children to a new item map.
    var copySource = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
        isCopied: undefined,
        sourceItemPath: undefined
    });
    dispatch(map_action/* mapActions.addMapAction */.nv.addMapAction({
        itemMap: (0,transform/* copyAndTransformItemMap */.YY)([
            copySource
        ], dispatch),
        dropPath: dropPath
    }));
};
var handleAddCutItemAction = function(param) {
    var dispatch = param.dispatch, item = param.item, dropPath = param.dropPath;
    //Item exists already, since it has cut state.
    //Just move it to the clicked dropZone
    dispatch(map_action/* mapActions.moveMapAction */.nv.moveMapAction({
        item: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
            isCut: undefined,
            sourceItemPath: undefined
        }),
        itemPath: item.sourceItemPath,
        dropPath: dropPath
    }));
};

// EXTERNAL MODULE: ./src/mosanic/utils/map/mode.js
var mode = __webpack_require__(30415);
;// CONCATENATED MODULE: ./src/features/map/drop/middleware.js





















var middleware_SPINNER = {
    location: "canvas",
    feature: drop_action/* DROP_ID */.H8
};
//Main drop handler
var coreDropActionStartFlow = function(param) {
    var dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, drop_action/* default.DROP_HANDLE */.ZP.DROP_HANDLE)) {
                setStartStateDropAction(dispatch);
                var ref = (0,_sliced_to_array/* default */.Z)(transformDropActionPayload(action), 3), dropZone = ref[0], item = ref[1], dropPath = ref[2];
                if ((0,mode/* isUnhandledActionItem */.Dd)(item)) {
                    if ((0,mode/* isItemCopied */.v5)(item)) handleAddCopiedItemAction({
                        dispatch: dispatch,
                        item: item,
                        dropPath: dropPath
                    });
                    if ((0,mode/* isItemCut */.eW)(item)) handleAddCutItemAction({
                        dispatch: dispatch,
                        item: item,
                        dropPath: dropPath
                    });
                    dispatch(drop_action/* dropActions.clearPreStoreAction */.to.clearPreStoreAction());
                    return;
                }
                if (isNewDropItem(item.type)) {
                    handleNewItemDropAction({
                        dispatch: dispatch,
                        item: item,
                        dropZone: dropZone,
                        dropPath: dropPath
                    });
                    return;
                }
                if (isNewDropLayout(item)) {
                    handleNewLayoutDropAction({
                        dispatch: dispatch,
                        item: item,
                        dropZone: dropZone,
                        dropPath: dropPath
                    });
                    return;
                }
                if (isMoveDropItem(item.type && (item === null || item === void 0 ? void 0 : item.path))) {
                    handleItemMoveDropAction({
                        dispatch: dispatch,
                        item: item,
                        dropPath: dropPath
                    });
                    return;
                }
            }
        };
    };
};
//When wrap action is performed
var dropWrapActionFlow = function(param) {
    var dispatch = param.dispatch, getState = param.getState;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, drop_action/* default.DROP_WRAP */.ZP.DROP_WRAP)) {
                dispatch(drop_action/* dropActions.clearPreStoreAction */.to.clearPreStoreAction());
                dispatch((0,uiAction/* showSpinner */.yh)(middleware_SPINNER));
                var state = getState();
                var _payload = action.payload, item = _payload.item, wrapItem = _payload.wrapItem;
                //Get inspected item to wrap
                var path = (0,inspect_selector/* inspectAttrSelector */.mj)(state, "path");
                var itemRef = path ? (0,map_get/* getItemByPath */.R9)({
                    map: (0,map_reducer/* mapSelector */.Od)(state),
                    path: path
                }) : null;
                if (!path) {
                    dispatch((0,uiAction/* hideSpinner */.v3)(middleware_SPINNER));
                    return;
                }
                //Remove item from map first
                dispatch(map_action/* mapActions.removeMapAction */.nv.removeMapAction({
                    item: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                        path: path
                    })
                }));
                //Create wrapper component
                var ref = (0,_sliced_to_array/* default */.Z)((0,data_transform/* transformInitialItemFull */.Ci)({
                    item: wrapItem
                }, dispatch), 2), itemMap = ref[0], component = ref[1];
                //Store new wrapper compnent
                dispatch(data_action/* dataActions.initDataAction */.tD.initDataAction({
                    component: component
                }));
                dispatch(map_action/* mapActions.addMapAction */.nv.addMapAction({
                    itemMap: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, itemMap), {
                        children: [
                            itemRef
                        ]
                    }),
                    dropPath: path
                }));
            }
        };
    };
};
//Check if clear store should be cleared
var validateClearPreStoreFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            if (isAction(action, drop_action/* default.DROP_CLEAR_STORE */.ZP.DROP_CLEAR_STORE)) {
                var state = getState();
                var preStore = (0,drop_reducer/* preDropStoreSelector */.U)(state);
                //Remove preStore states from data component
                if ((0,mode/* isPreStoreCut */.RD)(preStore)) {
                    var component = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,selector/* getItem */.rV)((0,data_reducer/* dataSelector */.Fb)(state), preStore)), {
                        isCut: undefined
                    });
                    dispatch(data_action/* dataActions.updateDataAction */.tD.updateDataAction({
                        component: component
                    }, true));
                }
                next(action);
            } else {
                next(action);
            }
        };
    };
};
var dropMiddleware = [
    coreDropActionStartFlow
].concat((0,src_to_consumable_array/* default */.Z)(removeMiddleware), (0,src_to_consumable_array/* default */.Z)(pasteMiddleware), (0,src_to_consumable_array/* default */.Z)(copyMiddleware), (0,src_to_consumable_array/* default */.Z)(cutMiddleware), [
    dropWrapActionFlow,
    validateClearPreStoreFlow
]);

// EXTERNAL MODULE: ./src/features/options/reducer.js + 1 modules
var options_reducer = __webpack_require__(51331);
// EXTERNAL MODULE: ./src/features/ui/uiReducer.js
var uiReducer = __webpack_require__(39336);
;// CONCATENATED MODULE: ./src/features/inspect/middleware.js









var shouldOpenInspectSidebar = function(state) {
    return (0,options_reducer/* getAutoOpenInspect */.aX)(state) && !(0,uiReducer/* isInspectorOpen */.xW)(state);
};
var inspectActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, inspect_action/* default.INSPECT_SET */.ZP.INSPECT_SET)) {
                var state = getState();
                var payload = action.payload;
                //Clear
                if (includesAction(action, "(empty)")) dispatch((0,drop_action/* clearPreStoreAction */.g)());
                //Init validated
                dispatch(inspect_action/* inspectActions.initInspectAction */.Ks.initInspectAction((0,src_object_spread/* default */.Z)({}, payload), true));
                dispatch((0,bounds_action/* setInspectBoundsAction */.rz)((0,src_object_spread/* default */.Z)({}, payload)));
                //Open sidebar
                if (shouldOpenInspectSidebar(state)) dispatch((0,uiAction/* openInspectorPanel */.UO)());
                //Already inspected
                if ((0,inspect_reducer/* isInspectedSelector */.QX)(state, payload.component._id)) return;
            }
        };
    };
};
var inspectMiddleware = [
    inspectActionFlow
];

;// CONCATENATED MODULE: ./src/mosanic/utils/map/confirm.js




var shouldConfirm = function(param, action) {
    var map = param.map, dropPath = param.dropPath, itemType = param.itemType;
    dropPath = Array.isArray(dropPath) ? dropPath : (0,paths/* splitPath */.uo)(dropPath);
    var parent = (0,map_get/* getParentItem */.fD)({
        map: map,
        itemPath: dropPath
    });
    //Validate column drop
    if (itemType === items/* default.COLUMN */.ZP.COLUMN) {
        if (dropPath.length === 1) {
            return {
                message: "Columns can only be inside a wrapper, would you like to initialize a new columns wrapper?",
                wrapper: "columns"
            };
        }
        if (dropPath.length >= 2) {
            if (parent.itemType != items/* default.ROW */.ZP.ROW) {
                return {
                    notify: "Columns can only be dropped inside an columns wrapper."
                };
            }
        }
    } else {
        //Validate if item isn't dropped directly into column wrapper
        if (dropPath.length === 2 && parent.itemType === items/* default.ROW */.ZP.ROW) {
            return {
                message: "".concat((0,Text/* toLowCase */.Cc)(itemType), " can't be directly dropped inside an columns wrapper, would you like to initialize a new column?"),
                wrapper: "column"
            };
        }
        //Ask for wrapper init 
        if (dropPath.length === 1 && itemType === items/* default.COMPONENT */.ZP.COMPONENT) {
            return {
                message: "You are dropping a free floating component. \n Would you like to wrap it inside an container?",
                wrapper: "container",
                declineAction: action
            };
        }
    }
    return false;
};

;// CONCATENATED MODULE: ./src/features/map/middleware.js











var mapValidationFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            if (includesOneAction(action, [
                map_action/* default.MAP_ADD */.ZP.MAP_ADD,
                map_action/* default.MAP_MOVE */.ZP.MAP_MOVE
            ]) && !isValidated(action) && !hasWrapper(action) //handle by data middleware
            ) {
                var map = (0,map_reducer/* mapSelector */.Od)(getState());
                action = addOptions(action, {
                    validated: true
                });
                //Destruct payload
                var _payload = action.payload, item = _payload.item, dropPath = _payload.dropPath;
                var itemType = item.itemType;
                //Check for modal
                var modal = shouldConfirm({
                    map: map,
                    dropPath: dropPath,
                    itemType: itemType
                }, action);
                if (!modal) next(action); //Continue with dispatch.
                //Add wrapper if confirmed
                if (modal === null || modal === void 0 ? void 0 : modal.wrapper) action = addOptions(action, {
                    wrapper: modal.wrapper
                });
                //Construct modal
                modal = (0,src_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getValidationData({
                    action: action
                })), {
                    confirmAction: action
                }), modal);
                //Dispatch modals
                if (modal === null || modal === void 0 ? void 0 : modal.message) dispatch(modal_action/* modalActions.confirmationModalAction */.nT.confirmationModalAction(modal));
                if (modal === null || modal === void 0 ? void 0 : modal.notify) dispatch((0,notification_action/* setNotification */.sc)({
                    message: modal.notify,
                    feature: map_action/* MAP_ID */.EG,
                    meta: {
                        variant: "error",
                        persist: true
                    }
                }));
                //Stop spinner since we wait on user input
                dispatch((0,uiAction/* hideSpinner */.v3)({
                    location: "canvas",
                    feature: drop_action/* DROP_ID */.H8
                }));
            } else {
                //Skip
                next(action);
            }
        };
    };
};
//New item addition
var mapAddActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, map_action/* default.MAP_ADD */.ZP.MAP_ADD) && !hasWrapper(action) //handle by data middleware
            ) {
                var map = (0,map_reducer/* mapSelector */.Od)(getState());
                var _payload = action.payload, item = _payload.item, dropPath = _payload.dropPath;
                //Check mosanic component schema
                var validatedItem = validate({
                    item: item
                });
                map = Move.handleNewItem({
                    map: map,
                    dropPath: dropPath,
                    item: validatedItem
                });
                dispatch(map_action/* mapActions.updateMapAction */.nv.updateMapAction({
                    map: map
                }));
                dispatch((0,uiAction/* hideSpinner */.v3)({
                    location: "canvas",
                    feature: drop_action/* DROP_ID */.H8
                }));
            }
        };
    };
};
var mapRemoveActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, map_action/* default.MAP_REMOVE */.ZP.MAP_REMOVE)) {
                var map = (0,map_reducer/* mapSelector */.Od)(getState());
                var item = action.payload;
                var newMap = Move.removeChildFromChildren({
                    children: map,
                    itemPath: item.path
                });
                dispatch(map_action/* mapActions.updateMapAction */.nv.updateMapAction({
                    map: newMap
                }));
                dispatch((0,uiAction/* hideSpinner */.v3)({
                    location: "canvas",
                    feature: drop_action/* DROP_ID */.H8
                }));
            }
        };
    };
};
//Item move
var mapMoveActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, map_action/* default.MAP_MOVE */.ZP.MAP_MOVE) && !hasWrapper(action) //handle by data middleware
            ) {
                var map = (0,map_reducer/* mapSelector */.Od)(getState());
                var _payload = action.payload, item = _payload.item, itemPath = _payload.itemPath, dropPath = _payload.dropPath;
                if (ValidateMove.isPureMove({
                    itemPath: itemPath,
                    dropPath: dropPath
                })) {
                    if (ValidateMove.isMoveWithinParent({
                        itemPath: itemPath,
                        dropPath: dropPath
                    })) {
                        map = Move.handleMoveWithinParent({
                            map: map,
                            dropPath: dropPath,
                            itemPath: itemPath
                        });
                    } else {
                        map = Move.handleMoveToDifferentParent({
                            children: map,
                            dropPath: dropPath,
                            itemPath: itemPath,
                            item: item
                        });
                    }
                } else {
                    map = Move.handleMoveCreate({
                        children: map,
                        dropPath: dropPath,
                        itemPath: itemPath,
                        item: item
                    });
                }
                dispatch(map_action/* mapActions.updateMapAction */.nv.updateMapAction({
                    map: map
                }));
                dispatch((0,uiAction/* hideSpinner */.v3)({
                    location: "canvas",
                    feature: drop_action/* DROP_ID */.H8
                }));
            }
        };
    };
};
var mapUpdateItemActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, map_action/* default.MAP_UPDATE */.ZP.MAP_UPDATE)) {
                var map = (0,map_reducer/* mapSelector */.Od)(getState());
                var _payload = action.payload, itemMap = _payload.itemMap, path = _payload.path;
                var newMap = Move.removeChildFromChildren({
                    children: map,
                    itemPath: path
                });
                newMap = Move.addChildToChildren({
                    children: newMap,
                    dropPath: path,
                    item: itemMap
                });
                dispatch(map_action/* mapActions.updateMapAction */.nv.updateMapAction({
                    map: newMap
                }));
                dispatch((0,uiAction/* hideSpinner */.v3)({
                    location: "canvas",
                    feature: drop_action/* DROP_ID */.H8
                }));
            }
        };
    };
};
var mapMiddleware = [
    mapValidationFlow,
    mapAddActionFlow,
    mapRemoveActionFlow,
    mapMoveActionFlow,
    mapUpdateItemActionFlow
];

;// CONCATENATED MODULE: ./src/features/navigation/middleware.js



var getSubPanelValue = function(panel, activeSub) {
    return (panel === null || panel === void 0 ? void 0 : panel.hasSubPanel) ? Boolean((panel === null || panel === void 0 ? void 0 : panel.subDefault) != activeSub) ? panel.subDefault : null : null;
};
var getLeftPanelValue = function(panel, activeLeft) {
    return Boolean((panel === null || panel === void 0 ? void 0 : panel.value) != null && panel.value.length >= 3) ? panel : null;
};
// (
//     Boolean(panel.value != activeLeft?.value) ?  
//         panel : 
//         null //prevent reset for now 
// ) : null;
var sidebarPanelActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            // if(
            //     action.type === actions.NAV_SET_PANEL &&
            //     !isString(action.payload.panel)
            // ){ 
            //     const state = getState();
            //     const panel = action.payload.panel;
            //     const panels = navSelector(state);
            //     //Handle sub panel
            //     dispatch(setSidebarPanelAction({
            //         value: getSubPanelValue(panel, panels.sub),
            //         panel: 'subLeft'
            //     }));
            //     //Handle sub panel
            //     dispatch(setSidebarPanelAction({
            //         value: getLeftPanelValue(panel, panels.left),
            //         panel: 'left'
            //     }));
            // } else {
            next(action);
        // }
        };
    };
};
var navMiddleware = [
    sidebarPanelActionFlow, 
];

// EXTERNAL MODULE: ../../node_modules/dset/dist/index.mjs
var dist = __webpack_require__(10380);
// EXTERNAL MODULE: ./src/features/update/action.tsx + 1 modules
var update_action = __webpack_require__(94889);
// EXTERNAL MODULE: ./src/mosanic/_Fieldsets.js
var _Fieldsets = __webpack_require__(28585);
;// CONCATENATED MODULE: ./src/mosanic/utils/update/metric.js


var validateMetric = function(param) {
    var metric = param.metric, updated = param.updated;
    //Reset
    if (!(updated === null || updated === void 0 ? void 0 : updated.value) && !(updated === null || updated === void 0 ? void 0 : updated.metric) && !(updated === null || updated === void 0 ? void 0 : updated.token)) return {};
    // Complete
    if ((updated === null || updated === void 0 ? void 0 : updated.metric) && (updated === null || updated === void 0 ? void 0 : updated.value)) {
        return updated;
    }
    if (updated === null || updated === void 0 ? void 0 : updated.token) {
        return {
            token: updated.token
        };
    }
    // Previous has end adornment set
    if (!(updated === null || updated === void 0 ? void 0 : updated.metric) && (metric === null || metric === void 0 ? void 0 : metric.metric)) {
        return {
            value: updated.value,
            metric: metric.metric
        };
    }
    //Fallback set
    if (!(updated === null || updated === void 0 ? void 0 : updated.metric) && !(metric === null || metric === void 0 ? void 0 : metric.metric)) {
        return {
            value: updated.value,
            metric: _Fieldsets/* defaultEndAdornmentValueFallback */.r5
        };
    }
};
/**
 *  Helper methods for metric update paths
 */ var shouldClearAll = function(values) {
    return !values.endValue && !values.newValue && !values.selector //Has no end metric and no selector
    ;
};
var isValueEndRequired = function(values, metric) {
    return values.newValue && !values.valueEnd && !(metric === null || metric === void 0 ? void 0 : metric.metric) && !values.selector;
};
//If selector is updated
var shouldClearNewValue = function(values, metric) {
    return (metric === null || metric === void 0 ? void 0 : metric.value) && values.selector || (metric === null || metric === void 0 ? void 0 : metric.value) && !values.newValue || (metric === null || metric === void 0 ? void 0 : metric.value) && values.newValue === "";
};
var shouldClearValueEnd = function(values, metric) {
    return !values.newValue && (values.selector && (metric === null || metric === void 0 ? void 0 : metric.metric) || (metric === null || metric === void 0 ? void 0 : metric.metric) && !values.endValue);
};
var isSameValueEnd = function(values, metric) {
    return values.valueEnd === (metric === null || metric === void 0 ? void 0 : metric.metric);
};
//If no new selector is passed
var shouldClearSelector = function(values, metric) {
    return !(values === null || values === void 0 ? void 0 : values.selector) && (metric === null || metric === void 0 ? void 0 : metric.selector);
};
var isSameSelector = function(values, metric) {
    return values.selector === (metric === null || metric === void 0 ? void 0 : metric.selector);
};
var formatValues = function(values) {
    return {
        value: values.newValue,
        metric: values.valueEnd,
        selector: values.selector
    };
};
/**
 * Validation before metric update paths
 * @param {array} values [newValue, valueEnd, selector]
 * @param {object} metric full metric field object
 * @param {string} defaultEndValue fallback for valueEnd
 * @returns formatted values
 */ var validateUpdateProps = function(values, metric, defaultEndValue) {
    if (shouldClearAll(values)) return formatValues(values);
    if (isValueEndRequired(values, metric)) values.valueEnd = defaultEndValue;
    else if (isSameValueEnd(values, metric)) values.valueEnd = null;
    if (shouldClearValueEnd(values, metric)) values.valueEnd = "clear";
    if (shouldClearNewValue(values, metric)) values.newValue = "clear";
    if (shouldClearSelector(values, metric)) values.selector = "clear";
    if (isSameSelector(values, metric)) values.selector = null;
    return formatValues(values);
};
// export const getMetricUpdatePaths = (pathFunc, values) => {
//     let pathValues = [];
//     Object.entries(values).map(([fieldKey, value]) => {
//         if(value === 'clear' || value === '') pathValues.push(pathFunc(null, fieldKey));
//         else if(value) pathValues.push(pathFunc(value, fieldKey))
//     })
//     return pathValues;
// }
var getPresetUpdatePaths = function(metricPath, type, field, value, metric) {
    if (!metric) metric = defaultEndAdornmentValueFallback;
    var pvs = [];
    ALL_SIDES.forEach(function(side) {
        if (type != "all") {
            var _pvs, _pvs1;
            if (type === "axis" && getOppositeSide(field) === side) (_pvs = pvs).push.apply(_pvs, _to_consumable_array(metricPath(side, value, metric)));
            if (field === side) (_pvs1 = pvs).push.apply(_pvs1, _to_consumable_array(metricPath(side, value, metric)));
        } else {
            var _pvs2;
            (_pvs2 = pvs).push.apply(_pvs2, _to_consumable_array(metricPath(side, value, metric)));
        }
    });
    return pvs;
};

// EXTERNAL MODULE: ./src/utils/Obj.js
var Obj = __webpack_require__(62570);
// EXTERNAL MODULE: ../../node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(76665);
;// CONCATENATED MODULE: ./src/features/update/middleware.js





var actions = update_action/* updateIds.action */.Fo.action;
var field = update_action/* updateIds.field */.Fo.field;
var item = update_action/* updateIds.item */.Fo.item;








function deepset(obj, path, val) {
    console.log({
        obj: obj,
        path: path,
        val: val
    });
    var copy = klona(obj);
    dset(copy, path, val);
    return copy;
}
var handleUpdateActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, actions.start)) {
                var ref, ref1;
                var state = getState();
                var payload = action.payload;
                var itemPaths = [];
                //Get items
                if (action.meta.item === item.current) {
                    var ref2 = (0,inspect_reducer/* inspectSelector */.G2)(getState()), _id = ref2._id, group = ref2.group;
                    if (_id && group) itemPaths.push({
                        _id: _id,
                        group: group
                    });
                } else if (payload === null || payload === void 0 ? void 0 : (ref = payload.other) === null || ref === void 0 ? void 0 : ref.itemPath) {
                    itemPaths.push(payload.other.itemPath);
                } else if (payload === null || payload === void 0 ? void 0 : (ref1 = payload.other) === null || ref1 === void 0 ? void 0 : ref1.itemPaths) {
                    var _itemPaths;
                    (_itemPaths = itemPaths).push.apply(_itemPaths, (0,src_to_consumable_array/* default */.Z)(payload.other.itemPaths));
                }
                //Next action type
                var HandleActionType = (0,Text/* replacePart */.bA)(action.type, actions.start, actions.handle);
                if (itemPaths.length <= 0) {
                    dispatch((0,notification_action/* setNotification */.sc)({
                        message: "Could not execute update, no items selected.",
                        feature: update_action/* UPDATE_ID */.S5
                    }));
                    return;
                }
                //Update items
                itemPaths.forEach(function(itemPath) {
                    // todo --> item object
                    var component = (0,selector/* itemSelector */.O1)(state, itemPath);
                    // console.log(component)
                    action = replaceType(action, HandleActionType);
                    action = addOptions(action, action.payload);
                    action = replacePayload(action, component);
                    // console.log(action)
                    dispatchUpdateActionFlow(action, dispatch);
                });
            }
        };
    };
};
var checkValue = function(value) {
    return value === "true" ? 1 : value === "false" ? 0 : value === "clear" ? null : value;
};
var dispatchUpdateActionFlow = function(action, dispatch) {
    if (includesAction(action, actions.handle)) {
        var options = action.options;
        var newValue = options.value;
        var component = (0,immer_esm/* default */.ZP)(action.payload, function(draft) {
            if (includesAction(action, actions.update)) {
                //Multiple path values
                if (Array.isArray(options)) {
                    options.forEach(function(pathValue) {
                        (0,dist/* dset */.N)(draft, pathValue.path, checkValue(pathValue.value));
                    });
                } else {
                    //Single
                    //Check if action changes metric
                    if (includesAction(action, field.metric)) {
                        //Check if metric has metric set
                        newValue = validateMetric({
                            metric: (0,Obj/* get */.U2)(draft, options.path),
                            updated: newValue
                        });
                    }
                    //Update
                    // if(draft && get(draft, options.path)){
                    //     console.log(newValue)
                    (0,dist/* dset */.N)(draft, options.path, checkValue(newValue));
                //     // console.log('found get & update [!}')
                // } else {
                //     //Set empty data object
                //     dset(draft, options.path.substr(0, options.path.lastIndexOf(".")), {});
                //     dset(draft, options.path, checkValue(newValue));
                // }
                }
            }
            if (includesAction(action, actions.push)) {}
            if (includesAction(action, actions.pop)) {}
            if (includesAction(action, actions.remove)) {}
            if (includesAction(action, actions.toggle)) {}
            if (includesAction(action, actions.set)) {}
        });
        dispatch(data_action/* dataActions.updateDataAction */.tD.updateDataAction({
            component: component
        }, true));
    }
};
var updateMiddleware = [
    handleUpdateActionFlow
];

// EXTERNAL MODULE: ./src/features/pages/action.js
var pages_action = __webpack_require__(80936);
;// CONCATENATED MODULE: ./src/features/artboard/middleware.js













var artboardActionFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, artboard_action/* default.ARTBOARD_SET */.ZP.ARTBOARD_SET)) {
                var ref = action === null || action === void 0 ? void 0 : action.payload, artboard = ref.artboard, map = ref.map, data = ref.data;
                // if(component?.group === 'components' && !isString(component?.data)){
                //     dispatch(setNotification({message: "Item is not correctly converted to component.", meta: {variant: 'warning'}}));
                //     return;
                // }  
                dispatch((0,pages_action/* setPageAction */.m8)({
                    type: "artboard",
                    _id: "artboard"
                }));
                // if(isString(component?.data)) {
                //     dispatch(initArtboardAction({_id: component?.data, group: 'items'}, true))
                // } else if(component?.group === 'artboards') {
                dispatch((0,artboard_action/* setArtboardPointer */._8)({
                    _id: map === null || map === void 0 ? void 0 : map._id,
                    group: map === null || map === void 0 ? void 0 : map.group
                }, true));
                // }
                dispatch((0,data_action/* replaceFullDataStoreAction */.O$)({
                    data: data
                }));
                dispatch((0,map_action/* updateMapAction */.aZ)({
                    map: [
                        map
                    ]
                }));
            // const state = getState();
            // const payload = action.payload;
            // dispatch(artboardActions.initInspectAction({...payload}, true))
            // dispatch(setInspectBoundsAction({...payload}))
            // if(!isInspectorOpen(state)) dispatch(openInspectorPanel())
            // if(isInspectedSelector(state, payload.component._id)) return;
            }
            if (isAction(action, artboard_action/* default.ARTBOARD_SET */.ZP.ARTBOARD_SET)) {
                dispatch((0,map_action/* clearMapAction */.fv)());
                dispatch((0,screens_action/* setCurrentPage */.D4)({
                    _id: "artboards"
                }));
            }
        };
    };
};
var artboardMiddleware = [
    artboardActionFlow
];

// EXTERNAL MODULE: ./src/utils/color/Convert.js
var Convert = __webpack_require__(49258);
;// CONCATENATED MODULE: ./src/utils/color/Shades.js

var getShades = function(baseColor) {
    var advanced = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, numberOfValues = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 12, initialAlpha = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 4, saturation = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    var output = [];
    //Basic
    //todo --> store each advanced layout
    // ! Advanced select of 12 'preferred'
    //      + change secondary
    //      + change opacity
    //      + change palette
    //      + change display type
    // ! ON Super user --> 'unlimited' preferred'
    //  §  --> future --> drag drop order
    //      + change util colors
    //      + change alert colors
    //      + gradients
    //      + patterns
    // ... on call --> use '6 selected preferred'
    if (advanced) {
        var delta = 1 / numberOfValues; // if number of values was 5 d would represent 1/5 of the base. 
        var outputArray = [];
        var i = 0;
        var current;
        var base = (0,Convert/* hex2hsl */.OF)(baseColor);
        while(i < numberOfValues){
            i++;
            if (i == 1) {
                //...math on base color & incorporate initial alpha
                // alert(pSBC ( d * initialAlpha,  baseColor))
                // alert(getLighter(baseColor, d * initialAlpha))
                current = getValidLightest(baseColor, delta, initialAlpha, saturation);
                base = (0,Convert/* hex2hsl */.OF)(current);
                output.push({
                    type: "10",
                    value: current
                });
            } else {
                var max = 94;
                var start = 23;
                var interval = (max - start) / (numberOfValues - 1);
                current = getLight(base, 100 - interval * i, saturation);
                // console.log((interval * i) +' ---delta---'+(delta* i))
                output.push({
                    type: i + "0",
                    value: current
                });
            // pSBC ( d * initialAlpha, );
            //...math on base color by incrementing d or 1/n
            // outputArray.push("result of math on d base")
            }
        }
    // if(output.find(color => color.value === '#BDBDBD')){
    //     alert('not good')
    // }
    }
    return !advanced ? [
        {
            type: "10",
            value: getLighter(baseColor, 45, saturation)
        },
        {
            type: "20",
            value: getLighter(baseColor, 25, saturation)
        },
        {
            type: "30",
            value: getLighter(baseColor, 10, saturation)
        },
        {
            type: "40",
            value: getDarker(baseColor, 0, saturation)
        },
        {
            type: "50",
            value: getDarker(baseColor, 10, saturation)
        },
        {
            type: "60",
            value: getDarker(baseColor, 25, saturation)
        }, 
    ] : output;
};
var isValid = function(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
//          --green-1: hsl(131, 80%, 90%);
//          --green-2: hsl(131, 80%, 86%);
//          --green-3: hsl(131, 80%, 77%);
//          --green-4: hsl(131, 80%, 68%);
//          --green-5: hsl(131, 80%, 59%);
//          --green-6: hsl(131, 80%, 50%);
//          --green-7: hsl(131, 80%, 41%);
//          --green-8: hsl(131, 80%, 32%);
//          --green-9: hsl(131, 80%, 23%);
var getLight = function(base, light) {
    var saturation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    // let base = hex2hsl(hex);
    // alert(base.l +' light>'+light*10)
    var newHex = (0,Convert/* hsl2Hex */.IT)(base.h, saturation ? saturation : base.s, light);
    return isValid(newHex) ? newHex : "#FFFFFF";
};
var getLighter = function(hex) {
    var change = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10, saturation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var base = (0,Convert/* hex2hsl */.OF)(hex);
    var newL = base.l + change;
    var newHex = (0,Convert/* hsl2Hex */.IT)(base.h, saturation ? saturation : base.s, newL);
    return isValid(newHex) ? newHex : "#FFFFFF";
};
// const getDark = (hex, light) => {
//     let base = hex2hsl(hex);
//     // let newL = (base.l - change)
//     let newHex = hsl2Hex(base.h, base.s, light)
//     return isValid(newHex) ? newHex : '#000000';
// }
var getDarker = function(hex) {
    var change = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10, saturation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var base = (0,Convert/* hex2hsl */.OF)(hex);
    var newL = base.l - change;
    var newHex = (0,Convert/* hsl2Hex */.IT)(base.h, saturation ? saturation : base.s, newL);
    return isValid(newHex) ? newHex : "#000000";
};
var getValidLightest = function(hex) {
    var change = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10, initialAlpha = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, saturation = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var max = 95;
    var start = 3;
    var amount;
    var current = getLighter(hex, start, saturation);
    var darknessIndex = 1;
    for(var index = start; index < max; index++){
        // const element = array[index];
        // darknessIndex++;
        amount = start + darknessIndex;
        // alert('i'+darknessIndex+' >>'+amount)
        current = getLight((0,Convert/* hex2hsl */.OF)(hex), 100 - amount, saturation);
        if (isValid(current) && current != "#FFFFFF") index = 99;
    }
    // while ((!isValid(current) || current === '#FFFFFF') && darknessIndex <= max) {
    //     darknessIndex++;
    //      amount = start + darknessIndex;
    //     // alert('i'+darknessIndex+' >>'+amount)
    //      current = getLight(hex, amount );
    // }
    return current;
};

// EXTERNAL MODULE: ./src/features/colors/action.js
var colors_action = __webpack_require__(32360);
// EXTERNAL MODULE: ./src/features/colors/reducer.js
var colors_reducer = __webpack_require__(74329);
;// CONCATENATED MODULE: ./src/features/colors/middleware.js











var handleColorCreationFlow = function() {
    return function(next) {
        return function(action) {
            action.type === colors_action/* CREATE_DESIGN_COLOR */.eG ? next((0,colors_action/* setDesignColor */.HY)({
                color: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, action.payload), {
                    selector: (0,Identifiers/* toVarCase */.V5)(action.payload.label)
                }),
                _id: (0,ObjectID/* ObjectID */.t)()
            })) : next(action);
        };
    };
};
var handleRegenHueShades = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            if (isAction(action, colors_action/* COLOR_ACTION_IDS.REGENERATE_HUE */.Qc.REGENERATE_HUE)) {
                var _payload = action.payload, hue = _payload.hue, mainShade = _payload.mainShade, saturation = _payload.saturation;
                var advancedMethod = Boolean(hue.colors.length != 6);
                var newShades = getShades(mainShade.value, advancedMethod, hue.colors.length, 4, saturation);
                dispatch((0,colors_action/* updateHueAction */.t8)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, hue), {
                    colors: newShades
                })));
            } else {
                next(action);
            }
        };
    };
};
//! not imported yet
var handleHueSaturation = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            if (isAction(action, colors_action/* COLOR_ACTION_IDS.SET_SATURATION */.Qc.SET_SATURATION)) {
                var _payload = action.payload, saturation = _payload.saturation, index = _payload.index, hue = _payload.hue;
                var state = getState();
                if (!hue) {
                    var colors = (0,colors_reducer/* colorsSelector */.qQ)(state);
                    colors.map(function(hueSet) {
                        dispatch((0,colors_action/* regenerateHueShadesAction */.xi)(hueSet, hueSet.colors[index], saturation));
                    });
                } else {
                    dispatch((0,colors_action/* regenerateHueShadesAction */.xi)(hue, hue.colors[index], saturation));
                }
            } else {
                next(action);
            }
        };
    };
};
var handleShadeCount = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            if (isAction(action, colors_action/* COLOR_ACTION_IDS.SHADE_COUNT */.Qc.SHADE_COUNT)) {
                var ref;
                var _payload = action.payload, hue = _payload.hue, operator = _payload.operator;
                hue = structuredClone(hue);
                var shadeCount = hue === null || hue === void 0 ? void 0 : (ref = hue.colors) === null || ref === void 0 ? void 0 : ref.length;
                //Get new shade based on last
                var newShade = hue === null || hue === void 0 ? void 0 : hue.colors[shadeCount - 1];
                newShade = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, newShade), {
                    type: ((shadeCount + 1) * 10).toString()
                });
                //Update hue
                operator === "-" ? shadeCount > 6 && hue.colors.pop() : hue.colors.push(newShade);
                dispatch((0,colors_action/* updateHueAction */.t8)(hue));
            } else {
                next(action);
            }
        };
    };
};
var colorsMdl = [
    handleColorCreationFlow,
    handleRegenHueShades,
    handleHueSaturation,
    handleShadeCount, 
];

// EXTERNAL MODULE: ./src/features/typography/action.js
var typography_action = __webpack_require__(94860);
// EXTERNAL MODULE: ./src/features/typography/reducer.js + 1 modules
var typography_reducer = __webpack_require__(96117);
;// CONCATENATED MODULE: ./src/features/typography/middleware.js





var handleRegenFontSizes = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            if (isAction(action, typography_action/* TYPE_ACTION_IDS.REGEN_SIZES */.EW.REGEN_SIZES)) {
                var state = getState();
                var ref = (0,typography_reducer/* typesSelector */.UP)(state), fonts = ref.fonts, fontScale = ref.fontScale, baseSize = ref.baseSize;
                var newFontMap = fonts.map(function(font) {
                    return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, font), {
                        shade: "60",
                        size: baseSize && font.size && font.scale ? font.scale != 0 ? getScaled(font, baseSize, fontScale) : baseSize.toString() : font.size
                    });
                });
                dispatch((0,typography_action/* setFontsAction */.vf)({
                    fonts: newFontMap
                }));
            } else {
                next(action);
            }
        };
    };
};
var handleFontChange = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            if (isAction(action, typography_action/* TYPE_ACTION_IDS.SET_CHANGE */.EW.SET_CHANGE)) {
                var state = getState();
                var _payload = action.payload, font = _payload.font, currentItem = _payload.currentItem, addSource = _payload.addSource, fontType = _payload.fontType;
                var ref = (0,typography_reducer/* typesSelector */.UP)(state), fonts = ref.fonts, fontScale = ref.fontScale, baseSize = ref.baseSize;
                if (addSource && (font === null || font === void 0 ? void 0 : font.files)) {
                    Object.entries(font.files).forEach(function(key, value) {
                        dispatch((0,typography_action/* addFontSourceAction */.uf)({
                            family: font.family,
                            type: key,
                            src: value
                        }));
                    });
                }
                if (currentItem) {
                    var newFontMap = fonts.forEach(function(e) {
                        if (e.type != currentItem.type) return e;
                        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, e), {
                            weight: fontType ? fontType : "regular",
                            font: (font === null || font === void 0 ? void 0 : font.family) ? font.family : font.activeFontFamily
                        });
                    });
                    dispatch((0,typography_action/* setFontsAction */.vf)({
                        fonts: newFontMap
                    }));
                // regenerateFontSizes();
                }
            } else {
                next(action);
            }
        };
    };
};
var getScaled = function(font, baseSize, fontScale) {
    var index = 0;
    var copy = baseSize;
    while(index < font.scale){
        copy = (copy * fontScale).toFixed(1);
        index++;
    }
    return copy.toString();
};
var typesMdl = [
    handleRegenFontSizes,
    handleFontChange
];

;// CONCATENATED MODULE: ./src/features/api/action.js
var API_REQUEST = "[API] Request ";
var API_MUTATE = " [API] Mutate ";
var API_DELETE = " [API] Delete ";
var API_SUCCESS = "[API] Success ";
var API_ERROR = "[API] Error ";
// export const apiRequest = (method, url, body, onSuccess, onError) => ({
//     type: `${feature} ${API_REQUEST}`,
//     payload: body,
//     meta: { method, url, onSuccess, onError}
// })
var apiRequest = function(name, query, variables, body, feature) {
    return {
        type: "".concat(feature, " ").concat(API_REQUEST),
        payload: body,
        meta: {
            name: name,
            query: query,
            variables: variables,
            feature: feature
        }
    };
};
//Dep --> //todo fix to new apollo mutation
var apiMutate = function(name, mutation, variables, body, feature) {
    return null;
};
// ({
//     type: `${feature} ${API_MUTATE}`,
//     payload: body,
//     meta: {name, mutation, variables, feature}
// })
var apiSuccess = function(param) {
    var response = param.response, feature = param.feature;
    return {
        type: "".concat(feature, " ").concat(API_SUCCESS),
        payload: response,
        meta: {
            feature: feature
        }
    };
};
var apiError = function(param) {
    var error = param.error, feature = param.feature;
    return {
        type: "".concat(feature, " ").concat(API_ERROR),
        payload: error,
        meta: {
            feature: feature
        }
    };
};
var isSuccesCall = function(action, feature) {
    return action.type === "".concat(feature, " ").concat(API_SUCCESS);
};
var isErrorCall = function(action, feature) {
    return action.type === "".concat(feature, " ").concat(API_ERROR);
};

;// CONCATENATED MODULE: ./src/features/api/adapters.js

/**
 * Run graphql request on client
 * @param {action} action {name, query, variables, feature } = action.meta;
 * @returns dispatched action
 */ var runGQLRequest = function(action) {
    return function(dispatch, _, param) {
        var client = param.client;
        var _meta = action.meta, name = _meta.name, query = _meta.query, variables = _meta.variables, feature = _meta.feature;
        return client({
            query: query,
            variables: variables
        }).then(function(data) {
            return dispatch(apiSuccess({
                response: data === null || data === void 0 ? void 0 : data[name],
                feature: feature
            }));
        }).catch(function(error) {
            return dispatch(apiError({
                error: error,
                feature: feature
            }));
        });
    // .finally(()=> console.log('done'))
    };
};
/**
 * Run graphql mutation on client
 * @param {action} action {name, query, variables, feature } = action.meta;
 * @returns dispatched action
 */ var runGQLMutation = function(action) {
    return function(dispatch, _, param) {
        var client = param.client;
        var _meta = action.meta, name = _meta.name, mutation = _meta.mutation, variables = _meta.variables, feature = _meta.feature;
        return client.mutate(name, mutation, variables).then(function(data) {
            return dispatch(apiSuccess({
                response: data,
                feature: feature
            }));
        }).catch(function(error) {
            return dispatch(apiError({
                error: error,
                feature: feature
            }));
        });
    };
};

;// CONCATENATED MODULE: ./src/features/api/middleware.js




// // this middleware care only for API calls
// export const api = ({dispatch}) => next => action => {
//   if(action.type === API_REQUEST) {
//     const { method, url, onSuccess, onError } = action.meta;
//     fetch(url, { method }).then(response => response.json())
//       .then((data) => dispatch({ type: onSuccess, payload: data }))
//       .catch(error => dispatch({ type: onError, payload: error }))
//   }
//   return next(action)
// };
/**
 * The middleware where we check for GQL calls
 * @param {thunk}
 * @param {dispatch}
 * @param {action}  
 * @returns required action
 */ var apiMiddleware = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (action.type.includes(API_REQUEST)) {
                return dispatch(runGQLRequest(action));
            }
            if (action.type.includes(API_MUTATE)) {
                return dispatch(runGQLMutation(action));
            }
            if (action.type.includes(API_ERROR)) {
                return dispatch((0,notification_action/* setNotification */.sc)({
                    message: (action === null || action === void 0 ? void 0 : action.payload) ? action === null || action === void 0 ? void 0 : action.payload : "no message",
                    feature: action.meta.feature
                }));
            }
        };
    };
}; // export const apiMiddleware = [gqlApi]; //api

;// CONCATENATED MODULE: ./src/features/util/preventMdl.js
/**
 * If there isn't an action dispatched, prevent next.
 * @returns next action
 */ var preventMiddleware = function() {
    return function(next) {
        return function(action) {
            if (!action || !(action === null || action === void 0 ? void 0 : action.type)) return;
            next(action);
        };
    };
};

;// CONCATENATED MODULE: ./src/features/ui/middleware.js





/**
 * Spinner enricher
 * @returns next action
 */ var spinnerMiddleware = function(param) {
    var getState = param.getState;
    return function(next) {
        return function(action) {
            var ref;
            if (action === null || action === void 0 ? void 0 : (ref = action.type) === null || ref === void 0 ? void 0 : ref.includes(uiAction/* SHOW_SPINNER */.kW)) {
                var payload = action.payload, meta = action.meta;
                var _id = (0,ObjectID/* ObjectID */.t)();
                var _obj;
                var spinner = (_obj = {}, (0,_define_property/* default */.Z)(_obj, uiAction/* SPINNER_ID */.ue, _id), (0,_define_property/* default */.Z)(_obj, "location", payload), _obj);
                next((0,uiAction/* showSpinner */.yh)({
                    location: spinner,
                    feature: meta.feature
                }));
                setTimeout(function() {
                    if ((0,uiReducer/* isActive */.zh)(getState(), payload)) {
                        next((0,notification_action/* setNotification */.sc)({
                            message: "Spinner is auto terminated.",
                            feature: uiAction/* UI_ID */.AM,
                            meta: {
                                _id: _id,
                                previous: meta
                            }
                        }));
                        next((0,uiAction/* hideSpinnerById */.$w)({
                            spinnerId: _id,
                            feature: meta.feature
                        }));
                    } else {
                    // next(setNotification({message: 'Spinner is already terminated.', feature: UI_ID, meta: {_id, previous: meta}}))
                    }
                }, uiAction/* TIMING_STOP_SPINNER */.sC);
            } else {
                next(action);
            }
        };
    };
};

;// CONCATENATED MODULE: ./src/features/util/actionSplitter.js
var actionSplitterMiddleware = function() {
    return function(next) {
        return function(action) {
            if (Array.isArray(action)) {
                action.forEach(function(_action) {
                    return next(_action);
                });
            } else {
                next(action);
            }
        };
    };
};

;// CONCATENATED MODULE: ./src/features/util/normalize/action.js
var DATA_NORMALIZED = "normalized";
var DATA_NORMALIZING = "normalizing start";
var dataNormalizing = function(param) {
    var data = param.data, feature = param.feature;
    return {
        type: "".concat(feature, " ").concat(DATA_NORMALIZING),
        payload: data,
        meta: {
            feature: feature
        }
    };
};
var dataNormalized = function(param) {
    var data = param.data, feature = param.feature;
    return {
        type: "".concat(feature, " ").concat(DATA_NORMALIZED),
        payload: data,
        meta: {
            feature: feature
        }
    };
};

;// CONCATENATED MODULE: ./src/features/util/normalize/middleware.js





// import { normalize, schema } from "normalizr";

var normalizeMiddleware = function(param) {
    var dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            var ref, ref1;
            //Handle normalization before set
            if (action.type.includes("SET") && ((action === null || action === void 0 ? void 0 : (ref = action.meta) === null || ref === void 0 ? void 0 : ref.normalizeKey) || Array.isArray(action === null || action === void 0 ? void 0 : (ref1 = action.meta) === null || ref1 === void 0 ? void 0 : ref1.normalize)) && (action === null || action === void 0 ? void 0 : action.payload)) {
                var ref2, ref3, ref4, ref5;
                var identifier = ((ref2 = action.meta) === null || ref2 === void 0 ? void 0 : ref2.type) ? action.meta.type : (ref3 = action.meta) === null || ref3 === void 0 ? void 0 : ref3.feature;
                var data = {}, map = {}, used = "";
                dispatch(dataNormalizing({
                    data: action.payload,
                    feature: identifier
                }));
                if ((action === null || action === void 0 ? void 0 : (ref4 = action.meta) === null || ref4 === void 0 ? void 0 : ref4.bulk) === true) {
                    //Bulk normalize payload
                    if (hasMultipleEntries(action.payload)) {
                        data = getBulkNormalizedData(action);
                        used = "bulk normalized";
                    } else {
                        dispatch(setNotification({
                            message: "Bulk normalizer couldn't find multiple object entries.",
                            feature: identifier
                        }));
                    }
                } else if (Array.isArray(action === null || action === void 0 ? void 0 : (ref5 = action.meta) === null || ref5 === void 0 ? void 0 : ref5.normalize)) {
                    data = getCustomNormalizeSchema({
                        templates: action.meta.normalize,
                        payload: action.payload,
                        normalizeKey: "_id"
                    });
                    used = "custom normalized";
                } else if (identifier != "layout") {
                    //Default array to obj 
                    data = getNormalizedData({
                        payload: action.payload,
                        normalizeKey: action.meta.normalizeKey,
                        identifier: identifier
                    });
                    used = "default normalized";
                } else {
                    data = action.payload;
                    used = "not normalized";
                }
                dispatch(dataNormalized({
                    data: data,
                    feature: identifier
                }));
                next((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, action), {
                    payload: data,
                    normalizeKey: null,
                    meta: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, action.meta), {
                        used: used
                    })
                }));
            } else {
                next(action);
            }
        };
    };
};
var hasMultipleEntries = function(obj) {
    return Object.entries(obj).length >= 2;
};
var getCustomNormalizeSchema = function(data) {
    var templates = data.templates, payload = data.payload, normalizeKey = data.normalizeKey;
    var schemas = {};
    templates.forEach(function(template) {
        var attribute = template.attribute;
    // let newSchema = new schema.Entity(
    //     attribute, {}, { idAttribute: template.normalizeKey }
    // ); 
    // schemas = {
    //     ...schemas,
    //     [template.attribute]: [newSchema]
    // };
    });
    // const dataSchema = new schema.Entity(
    //     'element', {...schemas}, { idAttribute: normalizeKey }
    // );
    var normalizedData = payload; //normalize(payload, dataSchema);
    return normalizedData ? normalizedData : false;
};
var getNormalizedData = function(data) {
    var payload = data.payload, normalizeKey = data.normalizeKey, identifier = data.identifier;
    // const dataSchema = new schema.Entity(identifier, {}, { idAttribute: normalizeKey });
    var normalizedData = payload; //normalize(payload, [dataSchema]);
    return normalizedData ? normalizedData : false;
};
var getBulkNormalizedData = function(action) {
    var data, map;
    Object.entries(action.payload).forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], element = _param[1];
        if ((element === null || element === void 0 ? void 0 : element.length) < 0) {
            data = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), (0,_define_property/* default */.Z)({}, key, {}));
            map = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, map), (0,_define_property/* default */.Z)({}, key, []));
        } else if (key != "layout") {
            var normalizedData = getNormalizedData({
                payload: element,
                normalizeKey: action.meta.normalizeKey,
                identifier: key
            });
            data = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), (0,_define_property/* default */.Z)({}, key, normalizedData === null || normalizedData === void 0 ? void 0 : normalizedData.entities[key]));
            map = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, map), (0,_define_property/* default */.Z)({}, key, normalizedData === null || normalizedData === void 0 ? void 0 : normalizedData.result));
        } else {
            data = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), (0,_define_property/* default */.Z)({}, key, element));
        // map = { ...map, [key]: [] };
        }
    });
    data = {
        entities: data,
        map: map
    };
    return data;
};

// EXTERNAL MODULE: ../../node_modules/redux-persist/lib/storage/createWebStorage.js
var createWebStorage = __webpack_require__(30547);
;// CONCATENATED MODULE: ./src/features/sync_storage.js

var createFallBackStorage = function() {
    return {
        getItem: function getItem(_key) {
            return Promise.resolve(null);
        },
        setItem: function setItem(_key, value) {
            return Promise.resolve(value);
        },
        removeItem: function removeItem(_key) {
            return Promise.resolve();
        }
    };
};
var storage =  true ? (0,createWebStorage/* default */.Z)("local") : 0;
/* harmony default export */ var sync_storage = (storage);

// EXTERNAL MODULE: ./src/adapters/client.js + 4 modules
var client = __webpack_require__(64792);
// EXTERNAL MODULE: ./src/features/bounds/reducer.js
var bounds_reducer = __webpack_require__(40394);
// EXTERNAL MODULE: ./src/features/canvas/reducer.js
var canvas_reducer = __webpack_require__(64386);
// EXTERNAL MODULE: ./src/features/cart/reducer.js
var cart_reducer = __webpack_require__(59407);
// EXTERNAL MODULE: ./src/features/counter/type.js
var type = __webpack_require__(10267);
;// CONCATENATED MODULE: ./src/features/counter/reducer.js




var initialState = {
    server: "",
    client: "",
    counter: 0
};
// Creating the reducer
function reducer_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case es6/* HYDRATE */.ju:
            return (0,src_object_spread/* default */.Z)({}, state, action.payload);
        case type/* INCREMENT_COUNTER */.F:
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                counter: action.payload
            });
        case type/* DECREMENT_COUNTER */.l:
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                counter: action.payload
            });
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/features/navigation/reducer.js
var navigation_reducer = __webpack_require__(12594);
;// CONCATENATED MODULE: ./src/features/order/orderReducer.js



var initOrder = {
    date: null,
    bookId: null,
    email: "test@gmail.com"
};
var orderReducer = function() {
    var order = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initOrder, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case es6/* HYDRATE */.ju:
            return (0,src_object_spread/* default */.Z)({}, order, action.payload);
        case UPDATE_ORDER:
            return (0,src_object_spread/* default */.Z)({}, order, action.payload);
        default:
            return order;
    }
};
/* harmony default export */ var order_orderReducer = (orderReducer);

// EXTERNAL MODULE: ./src/features/pages/reducer.js
var pages_reducer = __webpack_require__(80762);
// EXTERNAL MODULE: ./src/features/theme/reducer.js
var theme_reducer = __webpack_require__(88316);
// EXTERNAL MODULE: ./src/features/tokens/reducer.js
var tokens_reducer = __webpack_require__(80364);
;// CONCATENATED MODULE: ./src/features/update/reducer.js



var reducer_initialState = {};
var updateReducer = function() {
    var update = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    return (0,immer_esm/* produce */.Uy)(update, function(draft) {
        switch(action.type){
            case es6/* HYDRATE */.ju:
                return (0,src_object_spread/* default */.Z)({}, update, action.payload);
            default:
                return update;
        }
        ; //switch
    });
};
/* harmony default export */ var update_reducer = (updateReducer);

;// CONCATENATED MODULE: ./src/features/coreReducer.js


























function allowedDropZoneAction(action, currentState, previousHistory) {
    return action.type === SOME_ACTION;
}
function hasNoFutureState(action, currentState, previousHistory) {
    var past = previousHistory.past, present = previousHistory.present, future = previousHistory.future;
    return future.length === 0;
}
var createReducer = function(asyncReducers) {
    return combineReducers(_object_spread({}, asyncReducers));
};
var coreReducer = (0,redux.combineReducers)({
    ui: uiReducer/* default */.ZP,
    nav: navigation_reducer/* default */.ZP,
    modal: modal_reducer/* default */.ZP,
    notifications: notification_reducer/* notificationsReducer */.e,
    options: options_reducer/* default */.ZP,
    breakpoints: breakpoints_reducer/* default */.ZP,
    screens: screens_reducer/* default */.ZP,
    artboard: artboard_reducer/* default */.ZP,
    canvas: canvas_reducer/* default */.ZP,
    update: update_reducer,
    drop: drop_reducer/* default */.Z,
    data: data_reducer/* default */.ZP,
    map: map_reducer/* default */.ZP,
    inspect: inspect_reducer/* default */.ZP,
    tokens: tokens_reducer/* default */.ZP,
    bounds: bounds_reducer/* default */.ZP,
    theme: theme_reducer/* default */.Z,
    colors: colors_reducer/* default */.ZP,
    types: typography_reducer/* default */.ZP,
    pages: pages_reducer/* pageReducer */.kA,
    order: order_orderReducer,
    auth: reducer/* default */.ZP,
    cart: cart_reducer/* default */.ZP,
    counter: reducer_reducer
});

// EXTERNAL MODULE: ./src/utils/server/session.js
var session = __webpack_require__(81866);
;// CONCATENATED MODULE: ./src/features/auth/middlware.js








var expireValidationFlow = function(exp, dispatch) {
    var expired = (0,adapters_token/* isTokenExpired */.pw)(exp);
    if (expired) dispatch((0,notification_action/* setNotification */.sc)({
        message: "Token expired ".concat(expired, " ago. Login again."),
        feature: "auth",
        meta: {
            variant: "error",
            filter: "Token expired"
        }
    }));
    return expired;
};
var validateAuthFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (isAction(action, auth_action/* default.ACTIVATE */.ZP.ACTIVATE)) {
                var _payload = action.payload, token = _payload.token, remember = _payload.remember;
                var userData = (0,adapters_token/* decodeToken */.TD)(token);
                var expired = expireValidationFlow(userData === null || userData === void 0 ? void 0 : userData.exp, dispatch);
                if (!userData || expired) {
                    (0,adapters_token/* clearSession */.Ov)(token);
                    var reason = !userData ? "No user data" : "Expired token";
                    console.log({
                        type: "Validation failed",
                        payload: {
                            userData: userData,
                            expired: expired,
                            token: token,
                            remember: remember
                        }
                    });
                    dispatch((0,auth_action/* removeAuthAction */.Mc)({
                        redirect: "/login"
                    }, reason));
                    dispatch((0,notification_action/* setNotification */.sc)({
                        message: reason,
                        feature: "[auth]",
                        variant: "error"
                    }));
                    return;
                } else {
                    (0,session/* storeUserDataOnSessionStorage */.jn)(userData);
                    (0,adapters_token/* storeToken */.mB)(token, remember);
                    dispatch((0,auth_action/* storeAuthAction */.D5)((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, action.payload), {
                        userData: userData
                    }), true));
                    dispatch((0,auth_action/* setUserId */.Iv)({
                        userId: userData._id
                    }));
                }
            }
        };
    };
};
var removeAuthFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, auth_action/* default.REMOVE */.ZP.REMOVE)) {
                (0,adapters_token/* clearSession */.Ov)();
                dispatch((0,auth_action/* removeAuthAction */.Mc)({
                    redirect: "/login"
                }, "remove auth flow", true));
            }
        };
    };
};
var revalidateAuthFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            if (isAction(action, auth_action/* default.REVALIDATE */.ZP.REVALIDATE)) {
                var isAuth = (0,adapters_token/* isAuthenticated */.$8)();
                if (!isAuth) dispatch((0,auth_action/* removeAuthAction */.Mc)({
                    redirect: "/login"
                }, "Revalidate flow"));
            } else {
                next(action);
            }
        };
    };
};
var selectSiteFlow = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            next(action);
            if (includesAction(action, auth_action/* default.SET_SITE_ID */.ZP.SET_SITE_ID)) {
                var siteId = action.payload;
                dispatch((0,pages_action/* resetPagesAction */.sD)());
                dispatch((0,auth_action/* setSiteId */.Or)({
                    siteId: siteId
                }, true));
            }
        };
    };
};
var authMdl = [
    removeAuthFlow,
    validateAuthFlow,
    revalidateAuthFlow,
    selectSiteFlow, 
];

;// CONCATENATED MODULE: ./src/features/store.js






































var enhanceOptions = {
    actionsDenylist: [
        bounds_action/* SET_HOVER_ELEMENT */.pB,
        bounds_action/* TOGGLE_LAST_HOVER */.K1,
        bounds_action/* HANDLE_HOVER */.x3,
        uiAction/* END_DRAGGING */.s9,
        uiAction/* START_DRAGGING */.Mk
    ],
    trace: true,
    traceLimit: 25,
    limit: 5
};
var composeEnhancers = composeWithDevTools(enhanceOptions);
/**
 * Add redux dev tools
 */ var bindMiddleware = function(middleware) {
    if (false) {}
    return redux.applyMiddleware.apply(void 0, (0,src_to_consumable_array/* default */.Z)(middleware));
};
var featureMiddleware = // checkDropMiddleware, //feature
(0,src_to_consumable_array/* default */.Z)(inspectMiddleware).concat((0,src_to_consumable_array/* default */.Z)(authMdl), (0,src_to_consumable_array/* default */.Z)(dropMiddleware), (0,src_to_consumable_array/* default */.Z)(dataMiddleware), (0,src_to_consumable_array/* default */.Z)(mapMiddleware), (0,src_to_consumable_array/* default */.Z)(updateMiddleware), (0,src_to_consumable_array/* default */.Z)(artboardMiddleware), (0,src_to_consumable_array/* default */.Z)(canvasMdl), (0,src_to_consumable_array/* default */.Z)(screensMdl), (0,src_to_consumable_array/* default */.Z)(tokensMdl), (0,src_to_consumable_array/* default */.Z)(colorsMdl), (0,src_to_consumable_array/* default */.Z)(typesMdl), (0,src_to_consumable_array/* default */.Z)(boundsMdl), (0,src_to_consumable_array/* default */.Z)(pageMdl), (0,src_to_consumable_array/* default */.Z)(navMiddleware), (0,src_to_consumable_array/* default */.Z)(orderMdl));
var coreMiddleware = [
    actionSplitterMiddleware,
    apiMiddleware,
    normalizeMiddleware
].concat((0,src_to_consumable_array/* default */.Z)(notificationMdl), [
    spinnerMiddleware
], (0,src_to_consumable_array/* default */.Z)(modalMiddleware));
var coreUndo = (0,lib/* default */.ZP)(coreReducer, {
    filter: (0,lib/* includeAction */.an)([
        map_action/* default.MAP_UPDATE */.ZP.MAP_UPDATE,
        data_action/* default.DATA_UPDATE */.ZP.DATA_UPDATE,
        screens_action/* default.SCREENS_UPDATE_META */.ZP.SCREENS_UPDATE_META
    ]),
    limit: 10
});
/**
 * Make global store
 * @param {boolean} isServer 
 * @returns redux store
 */ var makeStore = function(param) {
    var isServer = param.isServer;
    if (isServer) {
        /**
         * Create new server store
         */ return (0,redux.createStore)(// stateFreezer(coreReducer), 
        coreUndo, bindMiddleware([
            redux_thunk_es.withExtraArgument({
                client: client/* default */.ZP
            }),
            preventMiddleware
        ].concat((0,src_to_consumable_array/* default */.Z)(featureMiddleware), (0,src_to_consumable_array/* default */.Z)(coreMiddleware))));
    } else {
        /**
         * Create store on client side
         * This will be a persisted object.
         */ var ref = __webpack_require__(91330), persistStore = ref.persistStore, persistReducer = ref.persistReducer;
        //  const persistStore = dynamic(() => import('redux-persist/es/persistStore'));
        //  const persistReducer = dynamic(() => import('redux-persist/es/persistReducer'));
        var persistConfig = {
            key: "soocore",
            whitelist: [
                "counter",
                "options",
                "tokens",
                "auth"
            ],
            storage: sync_storage
        };
        var persistedCoreReducer = (0,lib/* default */.ZP)(persistReducer(persistConfig, coreReducer), {
            filter: (0,lib/* includeAction */.an)([
                map_action/* default.MAP_UPDATE */.ZP.MAP_UPDATE,
                data_action/* default.DATA_UPDATE */.ZP.DATA_UPDATE,
                screens_action/* default.SCREENS_UPDATE_META */.ZP.SCREENS_UPDATE_META
            ]),
            limit: 10
        });
        var store = (0,redux.createStore)(persistedCoreReducer, bindMiddleware([
            redux_thunk_es.withExtraArgument({
                client: client/* default */.ZP
            }),
            preventMiddleware
        ].concat((0,src_to_consumable_array/* default */.Z)(featureMiddleware), (0,src_to_consumable_array/* default */.Z)(coreMiddleware)))); // Creating the store again
        /**
         * Push new persistor store to __persistor
         * Used to call the syn storage
         */ store.__persistor = persistStore(store);
        return store;
    }
};
/**
 * Export wrapper for _app
 */ var reduxWrapper = (0,es6/* createWrapper */.KV)(makeStore);

// EXTERNAL MODULE: ../../node_modules/nextjs-progressbar/dist/index.js
var nextjs_progressbar_dist = __webpack_require__(7375);
var dist_default = /*#__PURE__*/__webpack_require__.n(nextjs_progressbar_dist);
// EXTERNAL MODULE: ../../node_modules/nextjs-google-analytics/dist/index.js
var nextjs_google_analytics_dist = __webpack_require__(95666);
// EXTERNAL MODULE: ../../node_modules/@animated-burgers/burger-squeeze/dist/styles.css
var styles = __webpack_require__(78717);
// EXTERNAL MODULE: ../../node_modules/normalize.css/normalize.css
var normalize = __webpack_require__(49623);
// EXTERNAL MODULE: ../../node_modules/rc-dialog/assets/index.css
var assets = __webpack_require__(35515);
// EXTERNAL MODULE: ../../node_modules/react-ig-feed/dist/index.css
var react_ig_feed_dist = __webpack_require__(55225);
// EXTERNAL MODULE: ../../node_modules/react-slidedown/lib/slidedown.css
var slidedown = __webpack_require__(53468);
// EXTERNAL MODULE: ./src/scss/main.scss
var main = __webpack_require__(59885);
;// CONCATENATED MODULE: ./src/pages/_app.js
















function reportWebVitals(metric) {
    var id = metric.id, name = metric.name, label = metric.label, value = metric.value;
    (0,nextjs_google_analytics_dist/* event */.B)(name, {
        category: label === "web-vital" ? "Mosanic Web Vitals" : "Mosanic ".concat(label, " metric"),
        value: Math.round(name === "CLS" ? value * 1000 : value),
        label: id,
        nonInteraction: true
    });
}
var MosanicApp = function(param) {
    var Component = param.Component, pageProps = param.pageProps, router = param.router;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Error, {
        FallbackComponent: routing_ErrorFallback,
        suppressHydrationWarning: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ApolloProvider, {
                client: client/* client */.Lp,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                        color: "#e1e1e1",
                        // startPosition={0.3}
                        // stopDelayMs={200}
                        height: 3,
                        showOnShallow: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Core, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(routing_RoutingProvider, {
                            router: router,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(nextjs_google_analytics_dist/* GoogleAnalytics */.Wi, {
                                    gaMeasurementId: (pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.analytics) === null || ref === void 0 ? void 0 : ref.gaMeasurementId) || "G-ZQS1M1QEYL"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pageProps), {
                                    suppressHydrationWarning: true
                                }))
                            ]
                        })
                    })
                ]
            }),
            (pageProps === null || pageProps === void 0 ? void 0 : (ref1 = pageProps.analytics) === null || ref1 === void 0 ? void 0 : ref1.analyticsId) && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                async: true,
                defer: true,
                "data-website-id": pageProps === null || pageProps === void 0 ? void 0 : (ref2 = pageProps.analytics) === null || ref2 === void 0 ? void 0 : ref2.analyticsId,
                src: "https://analytics.mosanic.io/umami.js"
            })
        ]
    });
};
/* harmony default export */ var _app = (reduxWrapper.withRedux(MosanicApp));


/***/ }),

/***/ 72393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ updateItem; },
/* harmony export */   "$T": function() { return /* binding */ insert; },
/* harmony export */   "HP": function() { return /* binding */ reorder; },
/* harmony export */   "Jc": function() { return /* binding */ loopFunc; },
/* harmony export */   "Od": function() { return /* binding */ remove; },
/* harmony export */   "S3": function() { return /* binding */ removeLast; },
/* harmony export */   "VX": function() { return /* binding */ loop; },
/* harmony export */   "is": function() { return /* binding */ canMap; },
/* harmony export */   "s": function() { return /* binding */ getLastItem; },
/* harmony export */   "wy": function() { return /* binding */ areEqual; }
/* harmony export */ });
/* unused harmony exports getIndexByValue, objectToArray, orderByModule, getByValue, chunk, compact, drop, dropRight, removeFirst, removeDuplicates */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50930);



var loop = function() {
    var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 4, item = arguments.length > 1 ? arguments[1] : void 0;
    return Array.from({
        length: count
    }, function(_, i) {
        return item;
    });
};
var loopFunc = function() {
    var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 4, func = arguments.length > 1 ? arguments[1] : void 0;
    return Array.from({
        length: count
    }, function(_, i) {
        return func(i);
    });
};
var areEqual = function(arrA, arrB) {
    var field = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (arrA === arrB) return true;
    if (arrA == null || arrB == null) return false;
    if (arrA.length !== arrB.length) return false;
    for(var i = 0; i < arrA.length; ++i){
        if (!field) {
            if (arrA[i] !== arrB[i]) return false;
        } else {
            if (arrA[i][field] !== arrB[i][field]) return false;
        }
    }
    return true;
};
var canMap = function(arr) {
    return Array.isArray(arr) && (arr === null || arr === void 0 ? void 0 : arr.length) >= 1;
};
/**
 *  Function to reorder the result
 * @param {*} list 
 * @param {*} startIndex 
 * @param {*} endIndex 
 * @returns reordered list
 */ var reorder = function(list, startIndex, endIndex) {
    var result = Array.from(list);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(result.splice(startIndex, 1), 1), removed = ref[0];
    result.splice(endIndex, 0, removed); // inserting task in new index
    return result;
};
/**
 * Remove item from array
 * @param {*} arr 
 * @param {*} index 
 * @returns new array
 */ var remove = function(arr, index) {
    return !arr ? arr : // part of the array before the specified index
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr.slice(0, index)).concat(// part of the array after the specified index
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr.slice(index + 1)));
};
/**
 * Insert new item in array
 * @param {*} arr 
 * @param {*} index 
 * @param {*} newItem 
 * @returns new array
 */ var insert = function(arr, index, newItem) {
    return(// part of the array before the specified index
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr.slice(0, index)).concat([
        // inserted item
        newItem
    ], // part of the array after the specified index
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr.slice(index))));
};
var updateItem = function(arr, index, item) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr.slice(0, index)).concat([
        item
    ], (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr.slice(index + 1, arr.length)));
};
var getIndexByValue = function(arr, value) {
    var atr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "_id";
    var result;
    if (arr) {
        result = arr.findIndex(function(o) {
            return o[atr] == value;
        });
    }
    return result ? result : null; // or undefined
};
var objectToArray = function(obj) {
    return obj ? Object.keys(obj).reduce(function() {
        var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], _id = arguments.length > 1 ? arguments[1] : void 0;
        array.push(obj[_id]);
        return array;
    }, []) : [];
};
var orderByModule = function(array) {
    var get = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all";
    var orderedEvenArray = [];
    var orderedUnEvenArray = [];
    for(var i = 0; i < array.length; i++){
        if (i % 2 === 0) orderedEvenArray.push(array[i]);
        else orderedUnEvenArray.push(array[i]);
    }
    if (get === "all") return _to_consumable_array(orderedEvenArray).concat(_to_consumable_array(orderedUnEvenArray));
    return get === "even" ? orderedEvenArray : orderedUnEvenArray;
};
function getByValue(arr, value) {
    var atr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "_id";
    var result;
    if (Array.isArray(arr)) {
        result = arr.filter(function(o) {
            return o[atr] && o[atr] == value;
        });
    } else {
    // console.trace();
    }
    return result ? result[0] : null; // or undefined
}
var chunk = function(arr) {
    var chunkSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, cache = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var tmp = _to_consumable_array(arr);
    if (chunkSize <= 0) return cache;
    while(tmp.length)cache.push(tmp.splice(0, chunkSize));
    return cache;
};
var compact = function(arr) {
    return [
        0,
        1,
        2
    ].filter(function(x) {
        return !!x;
    });
};
var drop = function(arr) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return arr.slice(n);
};
var dropRight = function(arr) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return arr.slice(0, -n || arr.length);
};
var removeFirst = function(arr) {
    if (!Array.isArray(arr)) return [];
    arr.shift();
    return _to_consumable_array(arr);
};
var removeLast = function(arr) {
    if (!Array.isArray(arr)) return [];
    arr.length = arr.length - 1;
    return arr;
};
var removeDuplicates = function(arr) {
    if (!arr) return [];
    return arr.filter(function(value, index, array) {
        return array.indexOf(value) === index;
    });
};
var getLastItem = function(arr) {
    return Array.isArray(arr) ? arr[arr.length - 1] : null;
};


/***/ }),

/***/ 13365:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var isBoolean = function(value) {
    return typeof value == "boolean";
};
/* harmony default export */ __webpack_exports__["Z"] = (isBoolean);


/***/ }),

/***/ 99787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_3": function() { return /* binding */ getDate; },
/* harmony export */   "mD": function() { return /* binding */ getDif; },
/* harmony export */   "qb": function() { return /* binding */ isValidDate; },
/* harmony export */   "tZ": function() { return /* binding */ getFullTimeStamp; }
/* harmony export */ });
/* unused harmony exports addDays, getTime */
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68311);

var addDays = function(days) {
    var date = new Date(Date.now());
    date.setDate(date.getDate() + days);
    return date;
};
function isValidDate(dateString) {
    if (!dateString || !(0,_Text__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(dateString)) return;
    dateString = dateString.slice(0, 10);
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    return dateString.match(regEx) != null;
}
var getDate = function(date) {
    return !date ? "" : new Date(date).toLocaleDateString("nl-NL", {
        day: "numeric",
        month: "short",
        year: "numeric"
    });
};
var getTime = function(date) {
    if (!date) return "";
    return new Date(date).toLocaleTimeString("nl-NL", {
        hour: "numeric",
        minute: "numeric"
    });
};
var getDif = function(start) {
    var end = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var expires = start;
    var diffTime = Math.abs(end - expires);
    var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    var hours = parseFloat(diffTime / (1000 * 60 * 60));
    var min = parseFloat(diffTime / (1000 * 60));
    var s = parseFloat(diffTime / 1000);
    if (diffDays >= 1) return parseFloat(diffDays) + " days";
    if (hours >= 1) return parseFloat(hours + " hours");
    if (min >= 1) return parseFloat(min + " minutes");
    if (s >= 1) return parseFloat(s + " seconds");
};
var getFullTimeStamp = function(data) {
    return "".concat(getDate(data), " ").concat(getTime(data));
};


/***/ }),

/***/ 17629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AV": function() { return /* binding */ breakpoints; },
/* harmony export */   "b1": function() { return /* binding */ isTouchDevice; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "vl": function() { return /* binding */ getOperatorPlatform; }
/* harmony export */ });
/* unused harmony export device */
var breakpoints = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};
var device = {
    sm: "(min-width: ".concat(breakpoints.sm, "px)"),
    md: "(min-width: ".concat(breakpoints.md, "px)"),
    lg: "(min-width: ".concat(breakpoints.lg, "px)"),
    xl: "(min-width: ".concat(breakpoints.xl, "px)")
};
function isTouchDevice() {
    return  false ? 0 : "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
var getOperatorPlatform = function() {
    var ref;
    return typeof navigator != "undefined" ? navigator === null || navigator === void 0 ? void 0 : (ref = navigator.userAgentData) === null || ref === void 0 ? void 0 : ref.platform : "unknown";
};
var isServer = function() {
    return "object" === "undefined";
};


/***/ }),

/***/ 75276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isEmpty */
var isEmpty = function(value) {
    return (value === undefined || value === null || typeof value === "object" && Object.keys(value).length === 0 || typeof value === "string" && value.trim().length === 0) && typeof value != "number" && typeof value != "boolean";
};
/* harmony default export */ __webpack_exports__["Z"] = (isEmpty);


/***/ }),

/***/ 33434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N5": function() { return /* binding */ isMouseEvent; },
/* harmony export */   "X$": function() { return /* binding */ prevent; },
/* harmony export */   "f7": function() { return /* binding */ isZoomIn; },
/* harmony export */   "z6": function() { return /* binding */ isTouchEvent; }
/* harmony export */ });
/* unused harmony exports isTouchPad, isValidCurrentTarget, isCurrentTarget */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42838);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68311);


function prevent(syntheticEvent) {
    syntheticEvent.preventDefault();
}
function isMouseEvent(syntheticEvent) {
    var nativeEvent = syntheticEvent.nativeEvent;
    return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(nativeEvent, MouseEvent);
}
function isTouchEvent(syntheticEvent) {
    var nativeEvent = syntheticEvent.nativeEvent;
    return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(nativeEvent, TouchEvent);
}
function isTouchPad(syntheticEvent) {
    var e = syntheticEvent;
    return e.wheelDeltaY ? e.wheelDeltaY === -3 * e.deltaY : e.deltaMode === 0;
}
function isValidCurrentTarget(syntheticEvent) {
    var target = syntheticEvent.target, currentTarget = syntheticEvent.currentTarget;
    return target === currentTarget;
}
function isCurrentTarget(syntheticEvent, targetClass) {
    var target = syntheticEvent.target;
    return (0,_Text__WEBPACK_IMPORTED_MODULE_1__/* .containsSubstr */ .xX)(target.className, targetClass);
}
var isZoomIn = function(syntheticEvent) {
    var wheelDeltaY = syntheticEvent.wheelDeltaY;
    return wheelDeltaY > 0;
};
var Event = {
    prevent: prevent,
    isMouseEvent: isMouseEvent,
    isTouchEvent: isTouchEvent,
    isTouchPad: isTouchPad,
    isValidCurrentTarget: isValidCurrentTarget,
    isCurrentTarget: isCurrentTarget,
    isZoomIn: isZoomIn
};

/* harmony default export */ __webpack_exports__["ZP"] = (Event);


/***/ }),

/***/ 3847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ isFunc; }
/* harmony export */ });
var isFunc = function(prop) {
    return typeof prop === "function";
};


/***/ }),

/***/ 3121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ff": function() { return /* binding */ removeNumbers; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "vS": function() { return /* binding */ biteSizeToMb; }
/* harmony export */ });
/* unused harmony export sumNumberArray */
var isNumber = function(value) {
    return typeof value === "number" && isFinite(value);
};
var biteSizeToMb = function(bytes) {
    return bytes ? parseFloat(bytes) / 1000000 : bytes;
};
var sumNumberArray = function(arr) {
    var sum = 0;
    arr.forEach(function(stringNumber) {
        if (isNumber(stringNumber)) {
            sum += stringNumber;
        } else {
            sum += parseFloat(stringNumber);
        }
    });
    return sum;
};
var removeNumbers = function(string) {
    return string ? string.toString().replace(/[0-9]/g, "") : false;
};



/***/ }),

/***/ 62570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ combineAttr; },
/* harmony export */   "B$": function() { return /* binding */ hasAttr; },
/* harmony export */   "Cd": function() { return /* binding */ omitDeep; },
/* harmony export */   "HO": function() { return /* binding */ removeEmpty; },
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "o2": function() { return /* binding */ removeUndefined; },
/* harmony export */   "ru": function() { return /* binding */ toObject; },
/* harmony export */   "t8": function() { return /* binding */ set; },
/* harmony export */   "yD": function() { return /* binding */ isObjectLike; }
/* harmony export */ });
/* unused harmony exports getByPath, merge, arrToObj */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42838);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66383);
/* harmony import */ var dlv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27843);
/* harmony import */ var dlv__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dlv__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var object_path__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47655);
/* harmony import */ var object_path__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(object_path__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var merge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80002);
/* harmony import */ var merge__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(merge__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10380);









function isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
var isObject = function(value) {
    return isObjectLike(value);
};
var merge = function(objA, objB) {
    var empty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!objA || !isObject(objA)) objA = empty;
    if (!isObject(objB)) return objA;
    return merge__WEBPACK_IMPORTED_MODULE_2___default()(objA, objB);
};
var get = function(obj, path) {
    var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined;
    return (0,object_path__WEBPACK_IMPORTED_MODULE_1__.get)(obj, path, defaultValue);
};
var set = function(obj, path) {
    var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined;
    return (0,dset__WEBPACK_IMPORTED_MODULE_3__/* .dset */ .N)(obj, path, defaultValue);
};
var getByPath = function(o, s) {
    s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
    s = s.replace(/^\./, ""); // strip a leading dot
    var a = s.split(".");
    for(var i = 0, n = a.length; i < n; ++i){
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
};
var hasAttr = function(src, attr) {
    var sub = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var ref;
    return !src ? false : sub ? src.hasOwnProperty(attr) && ((ref = src[attr]) === null || ref === void 0 ? void 0 : ref.hasOwnProperty(sub)) : src.hasOwnProperty(attr);
};
var combineAttr = function(obj, other, attr) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, obj), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, attr, other[attr]));
};
function omitDeep(value, key) {
    if (Array.isArray(value)) {
        return value.map(function(i) {
            return omitDeep(i, key);
        });
    }
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(value, Date)) {
        return value;
    } else if (typeof value === "object" && value !== null) {
        return Object.keys(value).reduce(function(newObject, k) {
            if (k == key) return newObject;
            return Object.assign((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, k, omitDeep(value[k], key)), newObject);
        }, {});
    }
    return value;
}
function removeEmpty(obj) {
    return Object.fromEntries(Object.entries(obj).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(param, 2), _ = _param[0], value = _param[1];
        return value != null;
    }).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        return [
            key,
            value === Object(value) && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(!value, Date) ? removeEmpty(value) : value, 
        ];
    }));
}
function toObject(arr) {
    var id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "state";
    var rv = {};
    if (!Array.isArray(arr) || arr.length <= 0) return arr;
    for(var i = 0; i < arr.length; ++i)rv[arr[i][id]] = arr[i];
    return rv;
}
function arrToObj(arr) {
    var obj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!Array.isArray(arr)) return null;
    return arr.reduce(function(accumulator, value) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, accumulator), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, value, obj));
    }, {});
}
var removeUndefined = function(obj) {
    return JSON.parse(JSON.stringify(obj));
};
var Obj = {
    get: get,
    set: set,
    merge: merge,
    hasAttr: hasAttr,
    omitDeep: omitDeep,
    toObject: toObject,
    arrToObj: arrToObj,
    isObjectLike: isObjectLike,
    removeUndefined: removeUndefined
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Obj)));


/***/ }),

/***/ 82261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ roundPrecise; },
/* harmony export */   "Md": function() { return /* binding */ round5; }
/* harmony export */ });
/* unused harmony export roundTo */
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68311);

var roundPrecise = function(number) {
    var decimalPlaces = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    return Number(Math.round(number + "e" + decimalPlaces) + "e-" + decimalPlaces);
};
var round5 = function(number) {
    return Math.ceil(number / 5) * 5;
};
var roundTo = function(number, to) {
    if ((0,_Text__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(number)) number = parseFloat(number);
    if ((0,_Text__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(to)) to = parseFloat(to);
    return Math.ceil(number / to) * to;
};
var Round = {
    round5: round5,
    roundPrecise: roundPrecise,
    roundTo: roundTo
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Round)));


/***/ }),

/***/ 38618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h1": function() { return /* binding */ getTag; }
/* harmony export */ });
/* unused harmony exports TAG_LIST, isHtmlTag */
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68311);

var TAG_LIST = [
    "button",
    "a",
    "div",
    "span",
    "p",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "b",
    "mark",
    "input",
    "textarea",
    "section",
    "article",
    "main",
    "aside",
    "footer",
    "header",
    "figure",
    "caption",
    "img",
    "ul",
    "ol",
    "li"
];
var isHtmlTag = function(stringType) {
    return stringType ? TAG_LIST.includes(toLowCase(stringType)) : false;
};
var getTag = function(stringType) {
    return TAG_LIST.includes((0,_Text__WEBPACK_IMPORTED_MODULE_0__/* .toLowCase */ .Cc)(stringType)) ? (0,_Text__WEBPACK_IMPORTED_MODULE_0__/* .toLowCase */ .Cc)(stringType) : null;
};


/***/ }),

/***/ 68311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CG": function() { return /* binding */ parseNumberString; },
/* harmony export */   "Cc": function() { return /* binding */ toLowCase; },
/* harmony export */   "Ez": function() { return /* binding */ capitalizeFirst; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "Ht": function() { return /* binding */ countWords; },
/* harmony export */   "I8": function() { return /* binding */ removeSpaces; },
/* harmony export */   "J$": function() { return /* binding */ startSubString; },
/* harmony export */   "Lw": function() { return /* binding */ upperCase; },
/* harmony export */   "M7": function() { return /* binding */ combineString; },
/* harmony export */   "Nn": function() { return /* binding */ removeLastChar; },
/* harmony export */   "Nr": function() { return /* binding */ lowCaseStarts; },
/* harmony export */   "OV": function() { return /* binding */ matchSubstrList; },
/* harmony export */   "UY": function() { return /* binding */ revertSnakeCase; },
/* harmony export */   "Uw": function() { return /* binding */ revertDevCases; },
/* harmony export */   "W9": function() { return /* binding */ removeVowels; },
/* harmony export */   "W_": function() { return /* binding */ getSensitizedString; },
/* harmony export */   "Yg": function() { return /* binding */ cssSelector; },
/* harmony export */   "Yo": function() { return /* binding */ hasNumber; },
/* harmony export */   "bA": function() { return /* binding */ replacePart; },
/* harmony export */   "dK": function() { return /* binding */ excerptString; },
/* harmony export */   "dW": function() { return /* binding */ lowCaseContainsSubstr; },
/* harmony export */   "eQ": function() { return /* binding */ removeFirstChar; },
/* harmony export */   "io": function() { return /* binding */ hasOnlyNumbers; },
/* harmony export */   "ke": function() { return /* binding */ isEmptyString; },
/* harmony export */   "kr": function() { return /* binding */ getNumberPartOfString; },
/* harmony export */   "lV": function() { return /* binding */ slugify; },
/* harmony export */   "oE": function() { return /* binding */ replaceParts; },
/* harmony export */   "r6": function() { return /* binding */ oneLineString; },
/* harmony export */   "rn": function() { return /* binding */ revertPascalCase; },
/* harmony export */   "wB": function() { return /* binding */ matches; },
/* harmony export */   "ws": function() { return /* binding */ removePart; },
/* harmony export */   "xX": function() { return /* binding */ containsSubstr; },
/* harmony export */   "ze": function() { return /* binding */ isStartSubString; },
/* harmony export */   "zw": function() { return /* binding */ subStringFromLast; }
/* harmony export */ });
/* unused harmony exports startSubstr, subStringTill, subStringFrom, titleCase, truncate, getLetterPartOfString, getDotCountInString */
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76854);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_0__);

//Text utils
var countWords = function(string) {
    return string.split(" ").length;
};
//Num string Validate
var hasNumber = function(string) {
    return string ? /\d/.test(string.toString()) : false;
};
var hasOnlyNumbers = function(string) {
    return isString(string) ? string ? /^\d+$/.test(string) : true : !isNaN(string);
};
//Validate
var containsSubstr = function(string, subStr) {
    return isString(string) && !isEmptyString(string) && (string.indexOf(subStr) !== -1 || string === subStr);
};
var lowCaseContainsSubstr = function(string, subStr) {
    return containsSubstr(toLowCase(string), toLowCase(subStr));
};
var startSubstr = function(string, subStr) {
    return string.startsWith(subStr);
};
var lowCaseStarts = function(string, subStr) {
    return string && subStr ? startSubstr(toLowCase(string), toLowCase(subStr)) : false;
};
var matchSubstrList = function(string, subStrList) {
    if (isString(string) && !isEmptyString(string) && Array.isArray(subStrList) && subStrList.length >= 1) {
        var found = false;
        subStrList.map(function(subStr) {
            if (containsSubstr(string, subStr)) found = true;
        });
        return found;
    }
    ;
    return false;
};
var matches = function(string, separatedString) {
    var splitChar = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "|";
    return matchSubstrList(string, separatedString.split(splitChar));
};
var isEmptyString = function(string) {
    return !string || string === "" || string === null;
};
var isString = function(string) {
    return typeof string === "string";
};
var isStartSubString = function(string, part) {
    return string ? startSubString(string, part) === part : false;
};
// export const 
//Format
var bulkRemove = function(parts, string) {
    parts.map(function(part) {
        return string = replaceParts(string, part, "");
    });
    return string;
};
var slugify = function(string) {
    return string ? toLowCase(bulkRemove([
        ".",
        ",",
        "'",
        '"',
        "|"
    ], slugify__WEBPACK_IMPORTED_MODULE_0___default()(string))) : "";
};
var cssSelector = function(pascalString) {
    return pascalString.replace(/[A-Z]/g, function(m) {
        return "-" + m.toLowerCase();
    });
};
var excerptString = function(string) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 7, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "...";
    return string && (string === null || string === void 0 ? void 0 : string.length) > max + 2 ? "".concat(string.substring(0, max)).concat(end) : string;
};
var capitalizeFirst = function(string) {
    return isString(string) ? string.charAt(0).toUpperCase() + toLowCase(string.slice(1)) : "";
};
var revertPascalCase = function(string) {
    return combineString(string.split(/(?=[A-Z])/), " ");
};
var revertSnakeCase = function(string) {
    return replaceParts(string, "_", " ");
};
var revertDevCases = function(string) {
    return string ? capitalizeFirst(revertPascalCase(revertSnakeCase(string))) : string;
};
var removeVowels = function(string) {
    return string ? string.replace(/[aeiou]/gi, "") : "";
};
var toLowCase = function(string) {
    var add = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return string ? "".concat(string).concat(add).toLowerCase() : "";
};
var parseNumberString = function(string) {
    var ref;
    return string ? (ref = parseFloat(string)) === null || ref === void 0 ? void 0 : ref.toString() : "0";
};
var oneLineString = function(multiLineString) {
    return multiLineString.replace(/\n/g, "").replace(/\s+/g, " ").trim();
};
var startSubString = function(string, part) {
    return isString(string) ? string.substring(part.length) : string;
};
var subStringTill = function(string, before) {
    return string.substring(0, string.indexOf(before));
};
var subStringFrom = function(string, after) {
    return string.substring(string.indexOf(after));
};
var subStringFromLast = function(string, after) {
    return string.lastIndexOf(after) ? string.substring(string.lastIndexOf(after)) : string;
};
var removePart = function(string, part) {
    return string.replace(part, "");
};
var replacePart = function(string, part, txt) {
    return string ? string.replace(part, txt) : "";
};
var replaceParts = function(string, part, txt) {
    return isString(string) ? string.replaceAll(part, txt) : "";
};
var removeLastChar = function(string) {
    return string ? string.slice(0, -1) : "";
};
var removeFirstChar = function(string) {
    return string ? string.substring(1) : string;
};
var upperCase = function(string) {
    return string ? string.toUpperCase() : "";
};
var removeSpaces = function(string) {
    return string ? string.replace(/\s/g, "") : "";
};
var titleCase = function(str) {
    var splitStr = str.toLowerCase().split(" ");
    for(var i = 0; i < splitStr.length; i++){
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
};
var combineString = function(parts) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
    var string = "";
    if (!Array.isArray(parts)) return "";
    parts.map(function(part) {
        return string = part ? "".concat(string).concat(part).concat(separator) : string;
    });
    return separator ? string.slice(0, -(separator === null || separator === void 0 ? void 0 : separator.length)) : string;
};
var truncate = function(str) {
    var num = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 25, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "...";
    if (str.length <= num) return str;
    return str.slice(0, num) + end;
};
//Getters
var getNumberPartOfString = function(string) {
    return !isEmptyString(string) ? string.toString().match(/\d+/g) : null;
};
var getLetterPartOfString = function(string) {
    return string ? string.match(/[a-zA-Z]+/g) : null;
};
var getSensitizedString = function(string) {
    return string ? string.replace(/[^a-zA-Z0-9 ]/g, "") : null;
};
var getDotCountInString = function(string) {
    return string ? string.match(/\./g).length : 0;
};


/***/ }),

/***/ 98022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ isImageUrl; },
  "C": function() { return /* binding */ isUrl; }
});

;// CONCATENATED MODULE: ../../node_modules/image-extensions/image-extensions.json
var image_extensions_namespaceObject = JSON.parse('["ase","art","bmp","blp","cd5","cit","cpt","cr2","cut","dds","dib","djvu","egt","exif","gif","gpl","grf","icns","ico","iff","jng","jpeg","jpg","jfif","jp2","jps","lbm","max","miff","mng","msp","nitf","ota","pbm","pc1","pc2","pc3","pcf","pcx","pdn","pgm","PI1","PI2","PI3","pict","pct","pnm","pns","ppm","psb","psd","pdd","psp","px","pxm","pxr","qfx","raw","rle","sct","sgi","rgb","int","bw","tga","tiff","tif","vtf","xbm","xcf","xpm","3dv","amf","ai","awg","cgm","cdr","cmx","dxf","e2d","egt","eps","fs","gbr","odg","svg","stl","vrml","x3d","sxd","v2d","vnd","wmf","emf","art","xar","png","webp","jxr","hdp","wdp","cur","ecw","iff","lbm","liff","nrrd","pam","pcx","pgf","sgi","rgb","rgba","bw","int","inta","sid","ras","sun","tga"]');
;// CONCATENATED MODULE: ./src/utils/Url.js
//src: https://github.com/segmentio/is-url

/**
 * RegExps.
 * A URL must match #1 and then at least one of #2/#3.
 * Use two levels of REs to avoid REDOS.
 */ var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
/**
 * Loosely validate a URL `string`.
 *
 * @param {String} string
 * @return {Boolean}
 */ function isUrl(string) {
    if (typeof string !== "string") {
        return false;
    }
    var match = string.match(protocolAndDomainRE);
    if (!match) {
        return false;
    }
    var everythingAfterProtocol = match[1];
    if (!everythingAfterProtocol) {
        return false;
    }
    if (localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol)) {
        return true;
    }
    return false;
}
var isImageUrl = function(url) {
    if (!url) return false;
    if (!isUrl(url)) return false;
    var ext = new URL(url).pathname.split(".").pop();
    return image_extensions_namespaceObject.includes(ext);
};


/***/ }),

/***/ 62459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EE": function() { return /* binding */ fetchGetJSON; },
/* harmony export */   "Gf": function() { return /* binding */ fetchPostJSON; }
/* harmony export */ });
/* unused harmony export postData */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42838);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);



function fetchGetJSON(url) {
    return _fetchGetJSON.apply(this, arguments);
}
function _fetchGetJSON() {
    _fetchGetJSON = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
        var data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch(url, {
                        method: "GET",
                        mode: "cors",
                        cache: "no-cache",
                        // credentials: 'same-origin', // include, *same-origin, omit
                        headers: {
                            "Content-Type": "application/json"
                        },
                        redirect: "follow",
                        referrerPolicy: "no-referrer"
                    }).then(function(res) {
                        return res.json();
                    });
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    if (!(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ctx.t0, Error)) {
                        _ctx.next = 11;
                        break;
                    }
                    throw new Error(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message);
                case 11:
                    throw _ctx.t0;
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return _fetchGetJSON.apply(this, arguments);
}
function fetchPostJSON(url, data) {
    return _fetchPostJSON.apply(this, arguments);
}
function _fetchPostJSON() {
    _fetchPostJSON = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, data) {
        var response;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch(url, {
                        method: "POST",
                        mode: "cors",
                        cache: "no-cache",
                        credentials: "same-origin",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        redirect: "follow",
                        referrerPolicy: "no-referrer",
                        body: JSON.stringify(data || {})
                    });
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json() // parses JSON response into native JavaScript objects
                    ;
                case 6:
                    return _ctx.abrupt("return", _ctx.sent);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    if (!(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ctx.t0, Error)) {
                        _ctx.next = 13;
                        break;
                    }
                    throw new Error(_ctx.t0.message);
                case 13:
                    throw _ctx.t0;
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return _fetchPostJSON.apply(this, arguments);
}
var postData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var url, data, res;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    url = param.url, data = param.data;
                    console.log("posting,", url, data);
                    _ctx.next = 4;
                    return fetch(url, {
                        method: "POST",
                        headers: new Headers({
                            "Content-Type": "application/json"
                        }),
                        credentials: "same-origin",
                        body: JSON.stringify(data)
                    });
                case 4:
                    res = _ctx.sent;
                    if (res.ok) {
                        _ctx.next = 8;
                        break;
                    }
                    console.log("Error in postData", {
                        url: url,
                        data: data,
                        res: res
                    });
                    throw Error(res.statusText);
                case 8:
                    return _ctx.abrupt("return", res.json());
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postData(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 50606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WJ": function() { return /* binding */ getRGB; },
/* harmony export */   "qd": function() { return /* binding */ invertColor; },
/* harmony export */   "uE": function() { return /* binding */ getSaturation; }
/* harmony export */ });
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68311);
/* harmony import */ var _Convert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49258);


var invertColor = function(initialHex, bw) {
    var hex = initialHex || "#FFF";
    hex = hex.toString();
    if ((0,_util_Text__WEBPACK_IMPORTED_MODULE_0__/* .containsSubstr */ .xX)(hex, "rgb")) {
        var split = hex.split(",");
        hex = (0,_Convert__WEBPACK_IMPORTED_MODULE_1__/* .rgb2Hex */ .iC)(split[0], split[1], split[2]);
    }
    if (hex.indexOf("#") === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        // throw new Error('Invalid HEX color.');
        return initialHex;
    }
    var r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
        // https://stackoverflow.com/a/3943023/112731
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return (0,_Convert__WEBPACK_IMPORTED_MODULE_1__/* .rgb2Hex */ .iC)(r, g, b);
// return "#" + padZero(r) + padZero(g) + padZero(b);
};
var getRGB = function(hex, alpha) {
    if (!hex) return;
    hex = hex.toString();
    var r = parseInt(hex.slice(1, 3), 16);
    var g = parseInt(hex.slice(3, 5), 16);
    var b = parseInt(hex.slice(5, 7), 16);
    if (alpha) {
        return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
    }
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
};
var getSaturation = function(color) {
    return (0,_Convert__WEBPACK_IMPORTED_MODULE_1__/* .hex2hsl */ .OF)(color).l;
};


/***/ }),

/***/ 49258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IT": function() { return /* binding */ hsl2Hex; },
/* harmony export */   "OF": function() { return /* binding */ hex2hsl; },
/* harmony export */   "iC": function() { return /* binding */ rgb2Hex; }
/* harmony export */ });
/* unused harmony exports getRGB, hex2Rgb */
var getRGB = function(hex, alpha) {
    if (!hex) return;
    var r = parseInt(hex.slice(1, 3), 16);
    var g = parseInt(hex.slice(3, 5), 16);
    var b = parseInt(hex.slice(5, 7), 16);
    if (alpha) {
        return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
    }
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
};
var hsl2Hex = function(h, s, l) {
    l /= 100;
    var a = s * Math.min(l, 1 - l) / 100;
    var f = function(n) {
        var k = (n + h / 30) % 12;
        var color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color).toString(16).padStart(2, "0"); // convert to Hex and prefix "0" if needed
    };
    return "#".concat(f(0)).concat(f(8)).concat(f(4));
};
var hex2hsl = function(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);
    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) {
        h = s = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    s = s * 100;
    s = Math.round(s);
    l = l * 100;
    l = Math.round(l);
    h = Math.round(360 * h);
    return {
        hsl: "hsl(" + h + ", " + s + "%, " + l + "%)",
        h: h,
        s: s,
        l: l
    };
};
var rgb2Hex = function(red, green, blue) {
    if (!green) {
        var split = red.split(",");
        red = split[0];
        green = split[1];
        blue = split[2];
    }
    var rgb = red << 16 | green << 8 | blue << 0;
    return "#" + (0x1000000 + rgb).toString(16).slice(1);
};
var hex2Rgb = function(hex) {
    var normal = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
    if (normal) return normal.slice(1).map(function(e) {
        return parseInt(e, 16);
    });
    var shorthand = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
    if (shorthand) return shorthand.slice(1).map(function(e) {
        return 0x11 * parseInt(e, 16);
    });
    return null;
};


/***/ }),

/***/ 89450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42838);
/**
 * P1: 
 * * Like Shadow Equal, use Object.is for first-level filtering.
 * 
 * P2: 
 * * Special handling is required for Date and RegExp, 
 * Use Date.prototype.getTime() for Date to get the timestamp and compare
 * Use RegExp.prototype.toString() for RegExp to get string and compare.
 * 
 * P3: Like Shadow Equal, make sure both are objects and return false if either is not.
 * 
 * P4: 
 * * Use WeakMap as a hash table to solve the circular reference problem. 
 * If the two have been compared before, it will return true, 
 * which means that it will not affect the final result.
 * 
 * P5: 
 * * Compared to Shadow Equal, we upgrade to Reflect.ownKeys to get all keys. 
 * Then we also judge the length of the attribute array, 
 * Then loop through all the attribute keys of objA, 
 * Use Reflect.has to judge whether there are the same attributes on objB. 
 * Finally, we upgrade Object.is to recursive processing
 * Constantly judge whether the deep values are equal.
 * 
 * @param {*} objA 
 * @param {*} objB 
 * @param {*} map 
 * @returns 
 */ 
var isEqual = function(objA, objB) {
    var map = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new WeakMap();
    // P1
    if (Object.is(objA, objB)) return true;
    // P2
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(objA, Date) && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(objB, Date)) {
        return objA.getTime() === objB.getTime();
    }
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(objA, RegExp) && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(objB, RegExp)) {
        return objA.toString() === objB.toString();
    }
    // P3
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
        return false;
    }
    // P4
    if (map.get(objA) === objB) return true;
    map.set(objA, objB);
    // P5
    var keysA = Reflect.ownKeys(objA);
    var keysB = Reflect.ownKeys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    for(var i = 0; i < keysA.length; i++){
        if (!Reflect.has(objB, keysA[i]) || !isEqual(objA[keysA[i]], objB[keysA[i]], map)) {
            return false;
        }
    }
    return true;
};
/* harmony default export */ __webpack_exports__["Z"] = (isEqual);


/***/ }),

/***/ 18053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DX": function() { return /* binding */ recoverCookie; },
/* harmony export */   "YB": function() { return /* binding */ saveCookie; },
/* harmony export */   "kT": function() { return /* binding */ deleteCookie; }
/* harmony export */ });
/* harmony import */ var cookie_cutter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14623);
/* harmony import */ var cookie_cutter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookie_cutter__WEBPACK_IMPORTED_MODULE_0__);

// import Cookies from 'cookies'
/**
 * Save data in Client Cookie Storage
 * @param {string} name - key for data
 * @param {string} data - data to store
 */ function saveCookie(name, data) {
    if (!recoverCookie(name)) cookie_cutter__WEBPACK_IMPORTED_MODULE_0___default().set(name, data);
}
/**
 * Recover data from Cookie Storage
 * @param {string} name - key for data to recover
 */ function recoverCookie(name) {
    if (true) {
        return cookie_cutter__WEBPACK_IMPORTED_MODULE_0___default().get(name) ? cookie_cutter__WEBPACK_IMPORTED_MODULE_0___default().get(name) : null;
    } else {}
}
/**
 * Delete all data in Session Storage
 * @param {string} name - key for data to delete
 */ function deleteCookie(name) {
    if (recoverCookie(name)) cookie_cutter__WEBPACK_IMPORTED_MODULE_0___default().set(name, "", {
        expires: new Date(0)
    });
}



/***/ }),

/***/ 81866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aj": function() { return /* binding */ saveSession; },
/* harmony export */   "SO": function() { return /* binding */ deleteSession; },
/* harmony export */   "jn": function() { return /* binding */ storeUserDataOnSessionStorage; },
/* harmony export */   "x7": function() { return /* binding */ recoverSession; }
/* harmony export */ });
/* unused harmony exports recoverUserDataFromSessionStorage, deleteUserDataFromSessionStorage */
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17629);

/**
 * Save data in Session Storage
 * @param {string} name - key for data
 * @param {string} data - data to store
 */ function saveSession(name, data) {
    if ((0,___WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk)()) return;
    sessionStorage.setItem(name, data);
}
/**
 * Recover data from Session Storage
 * @param {string} name - key for data to recover
 */ function recoverSession(name) {
    if (true) {
        return sessionStorage != undefined ? sessionStorage.getItem(name) : null;
    } else {}
}
/**
 * Delete all data in Session Storage
 */ function deleteSession() {
    if ((0,___WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk)()) return;
    sessionStorage.clear();
}
/**
 * Serialize and save user data in Session Storage
 * @param {string|number|Array|Object} data - data to store
 */ function storeUserDataOnSessionStorage(data) {
    var replacer = function(key, value) {
        if (typeof value === "boolean" || typeof value === "number") {
            return String(value);
        }
        return value;
    };
    sessionStorage.setItem("userData", JSON.stringify(data, replacer));
}
/**
 * Recover and unserialize user data from Session Storage
 * @return {Object}
 */ function recoverUserDataFromSessionStorage() {
    var reviver = function(key, value) {
        if (value === "true") {
            return true;
        }
        if (value === "false") {
            return false;
        }
        return value;
    };
    return  true ? JSON.parse(sessionStorage.getItem("userData"), reviver) || {} : 0;
}
/**
 * Delete user data in Session Storage
 */ function deleteUserDataFromSessionStorage() {
    sessionStorage.removeItem("userData");
}



/***/ }),

/***/ 11095:
/***/ (function(module) {

"use strict";
/**
 * Regular expression for email
 * @type {RegExp}
 * @default
 */ 
var regexEmail = new RegExp(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/);
/**
 * Regular expression for password
 * @type {RegExp}
 * @default
 */ var regexPassword = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!*^?+-_@#$%&]{8,}$/);
/**
 * Validate the login form data. This is useful for reduce traffic to backend
 * @param  {string} email
 * @param  {string} password
 * @return {Boolean}                - True means data is valid
 */ var validateLoginForm = function(email, password) {
    var dataIsValid = true;
    //Bernerroos1!9
    if (!email || !password) {
        dataIsValid = false;
    }
    if (!regexEmail.test(email)) {
        dataIsValid = false;
    }
    if (!regexPassword.test(password)) {
        dataIsValid = false;
    }
    return dataIsValid;
};
/**
 * Validate the registration form data
 * @param  {string} email
 * @param  {string} password
 * @param  {string} repeatPassword
 * @return {Boolean}                - True means data is valid
 */ var validateRegisterForm = function(email, password, repeatPassword) {
    var dataIsValid = true;
    if (!email || !password || !repeatPassword) {
        dataIsValid = false;
    }
    if (password !== repeatPassword) {
        dataIsValid = false;
    }
    if (!regexEmail.test(email)) {
        dataIsValid = false;
    }
    if (!regexPassword.test(password)) {
        dataIsValid = false;
    }
    return dataIsValid;
};
module.exports = {
    regexEmail: regexEmail,
    regexPassword: regexPassword,
    validateLoginForm: validateLoginForm,
    validateRegisterForm: validateRegisterForm
};


/***/ }),

/***/ 65253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(36872).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(36497).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 33718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(30195)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(9788)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(30199)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(15154)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(2784));
var _head = _interop_require_default(__webpack_require__(75913));
var _imageConfig = __webpack_require__(18113);
var _useIntersection = __webpack_require__(22030);
var _imageConfigContext = __webpack_require__(20001);
var _utils = __webpack_require__(34750);
var _normalizeTrailingSlash = __webpack_require__(60583);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (experimentalUnoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (false) {}
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
var ref = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false} || {}, _experimentalRemotePatterns = ref.experimentalRemotePatterns, experimentalRemotePatterns = _experimentalRemotePatterns === void 0 ? [] : _experimentalRemotePatterns, experimentalUnoptimized = ref.experimentalUnoptimized;
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 90162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(19178)["default"]);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(15154)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _router = __webpack_require__(29918);
var _addLocale = __webpack_require__(94400);
var _routerContext = __webpack_require__(33220);
var _appRouterContext = __webpack_require__(64069);
var _useIntersection = __webpack_require__(22030);
var _getDomainLocale = __webpack_require__(65253);
var _addBasePath = __webpack_require__(73952);
// @ts-ignore useTransition exist
var hasUseTransition = typeof _react.default.useTransition !== "undefined";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, startTransition) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an AppRouterInstance, then it'll have `softPush` and
        // `softReplace`.
        if ("softPush" in router && "softReplace" in router) {
            // If we're doing a soft navigation, use the soft variants of
            // replace/push.
            var method = soft ? replace ? "softReplace" : "softPush" : replace ? "replace" : "push";
            router[method](href);
        } else {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        }
    };
    if (startTransition) {
        startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, soft = props.soft, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "soft",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var ref = _slicedToArray(hasUseTransition ? // @ts-ignore useTransition exists
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.default.useTransition() : [], 2), /* isPending */ startTransition = ref[1];
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref1 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref1.href, as = ref1.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref2 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref2[0], isVisible = ref2[1], resetVisible = ref2[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, appRouter ? startTransition : undefined);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 36872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(78458).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 22030:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(2784);
var _requestIdleCallback = __webpack_require__(49071);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (unobserve.current) {
                unobserve.current();
                unobserve.current = undefined;
            }
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                unobserve.current = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
            }
            return function() {
                unobserve.current == null ? void 0 : unobserve.current();
                unobserve.current = undefined;
            };
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
var observers = new Map();
var idList = [];
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 64069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 53407:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingDots_loading__VKAL7","spacer":"LoadingDots_spacer__RnhJD","blink":"LoadingDots_blink__fpRfa"};

/***/ }),

/***/ 78717:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 49623:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 99534:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 35515:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 79192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 55225:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 53468:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 59885:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 42351:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={308:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(308);module.exports=r})();

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ }),

/***/ 97729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(75913)


/***/ }),

/***/ 96577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(33718)


/***/ }),

/***/ 39097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90162)


/***/ }),

/***/ 5632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(93642)


/***/ }),

/***/ 45847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20747)


/***/ }),

/***/ 87198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(93542);

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GoogleAnalytics = void 0;
const tslib_1 = __webpack_require__(5163);
const react_1 = tslib_1.__importDefault(__webpack_require__(2784));
const script_1 = tslib_1.__importDefault(__webpack_require__(45847));
const hooks_1 = __webpack_require__(98049);
function GoogleAnalytics({ debugMode = false, gaMeasurementId, gtagUrl = "https://www.googletagmanager.com/gtag/js", strategy = "afterInteractive", defaultConsent = "granted", trackPageViews, nonce, }) {
    var _a;
    const _gaMeasurementId = (_a = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID) !== null && _a !== void 0 ? _a : gaMeasurementId;
    (0, hooks_1.usePageViews)({
        gaMeasurementId: _gaMeasurementId,
        ignoreHashChange: typeof trackPageViews === "object"
            ? trackPageViews === null || trackPageViews === void 0 ? void 0 : trackPageViews.ignoreHashChange
            : false,
        disabled: !trackPageViews,
    });
    if (!_gaMeasurementId) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(script_1.default, { src: `${gtagUrl}?id=${_gaMeasurementId}`, strategy: strategy }),
        react_1.default.createElement(script_1.default, { id: "nextjs-google-analytics", nonce: nonce }, `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            ${defaultConsent === "denied" &&
            `gtag('consent', 'default', {
              'ad_storage': 'denied',
              'analytics_storage': 'denied'
            });`}
            gtag('config', '${_gaMeasurementId}', {
              page_path: window.location.pathname,
              ${debugMode ? `debug_mode: ${debugMode},` : ""}
            });
          `)));
}
exports.GoogleAnalytics = GoogleAnalytics;
//# sourceMappingURL=GoogleAnalytics.js.map

/***/ }),

/***/ 31409:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GoogleAnalytics = void 0;
var GoogleAnalytics_1 = __webpack_require__(87198);
Object.defineProperty(exports, "GoogleAnalytics", ({ enumerable: true, get: function () { return GoogleAnalytics_1.GoogleAnalytics; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 98049:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePageViews = exports.usePagesViews = void 0;
var usePagesViews_1 = __webpack_require__(75369);
Object.defineProperty(exports, "usePagesViews", ({ enumerable: true, get: function () { return usePagesViews_1.usePagesViews; } }));
var usePageViews_1 = __webpack_require__(45776);
Object.defineProperty(exports, "usePageViews", ({ enumerable: true, get: function () { return usePageViews_1.usePageViews; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 45776:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(93542);

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePageViews = void 0;
const react_1 = __webpack_require__(2784);
const router_1 = __webpack_require__(5632);
const interactions_1 = __webpack_require__(61423);
function usePageViews({ gaMeasurementId, ignoreHashChange, disabled, } = {}) {
    (0, react_1.useEffect)(() => {
        if (disabled) {
            return;
        }
        const handleRouteChange = (url) => {
            var _a;
            const _gaMeasurementId = (_a = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID) !== null && _a !== void 0 ? _a : gaMeasurementId;
            (0, interactions_1.pageView)({ path: url.toString() }, _gaMeasurementId);
        };
        router_1.Router.events.on("routeChangeComplete", handleRouteChange);
        if (!ignoreHashChange) {
            router_1.Router.events.on("hashChangeComplete", handleRouteChange);
        }
        return () => {
            router_1.Router.events.off("routeChangeComplete", handleRouteChange);
            if (!ignoreHashChange) {
                router_1.Router.events.off("hashChangeComplete", handleRouteChange);
            }
        };
    }, [router_1.Router.events, gaMeasurementId, ignoreHashChange]);
}
exports.usePageViews = usePageViews;
//# sourceMappingURL=usePageViews.js.map

/***/ }),

/***/ 75369:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePagesViews = void 0;
const usePageViews_1 = __webpack_require__(45776);
function usePagesViews(options) {
    console.warn("Nextjs Google Analytics: The 'usePagesViews' hook is deprecated. Please use 'usePageViews' hook instead. https://github.com/MauricioRobayo/nextjs-google-analytics#readme");
    (0, usePageViews_1.usePageViews)(options);
}
exports.usePagesViews = usePagesViews;
//# sourceMappingURL=usePagesViews.js.map

/***/ }),

/***/ 95666:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = exports.B = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.Wi = void 0;
var components_1 = __webpack_require__(31409);
Object.defineProperty(exports, "Wi", ({ enumerable: true, get: function () { return components_1.GoogleAnalytics; } }));
var hooks_1 = __webpack_require__(98049);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return hooks_1.usePagesViews; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return hooks_1.usePageViews; } });
var interactions_1 = __webpack_require__(61423);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return interactions_1.pageView; } });
Object.defineProperty(exports, "B", ({ enumerable: true, get: function () { return interactions_1.event; } }));
__webpack_unused_export__ = ({ enumerable: true, get: function () { return interactions_1.consent; } });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4376:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.consent = void 0;
function consent({ arg, params }) {
    if (!window.gtag) {
        return;
    }
    window.gtag('consent', arg, params);
}
exports.consent = consent;
//# sourceMappingURL=consent.js.map

/***/ }),

/***/ 16406:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.event = void 0;
const tslib_1 = __webpack_require__(5163);
function event(action, _a = {}) {
    var { category, label, value, nonInteraction, userId } = _a, otherOptions = tslib_1.__rest(_a, ["category", "label", "value", "nonInteraction", "userId"]);
    if (!window.gtag) {
        return;
    }
    const eventOptions = Object.assign({}, otherOptions);
    if (category !== undefined) {
        eventOptions.event_category = category;
    }
    if (label !== undefined) {
        eventOptions.event_label = label;
    }
    if (value !== undefined) {
        eventOptions.value = value;
    }
    if (nonInteraction !== undefined) {
        eventOptions.non_interaction = nonInteraction;
    }
    if (userId !== undefined) {
        eventOptions.user_id = userId;
    }
    window.gtag("event", action, eventOptions);
}
exports.event = event;
//# sourceMappingURL=event.js.map

/***/ }),

/***/ 61423:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.consent = exports.event = exports.pageView = void 0;
var pageView_1 = __webpack_require__(55012);
Object.defineProperty(exports, "pageView", ({ enumerable: true, get: function () { return pageView_1.pageView; } }));
var event_1 = __webpack_require__(16406);
Object.defineProperty(exports, "event", ({ enumerable: true, get: function () { return event_1.event; } }));
var consent_1 = __webpack_require__(4376);
Object.defineProperty(exports, "consent", ({ enumerable: true, get: function () { return consent_1.consent; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 55012:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(93542);

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pageView = void 0;
function pageView({ title, location, path, sendPageView, userId } = {}, measurementId) {
    var _a;
    const gaMeasurementId = (_a = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID) !== null && _a !== void 0 ? _a : measurementId;
    if (!gaMeasurementId || !window.gtag) {
        return;
    }
    const pageViewOptions = {};
    if (title !== undefined) {
        pageViewOptions.page_title = title;
    }
    if (location !== undefined) {
        pageViewOptions.page_location = location;
    }
    if (path !== undefined) {
        pageViewOptions.page_path = path;
    }
    if (sendPageView !== undefined) {
        pageViewOptions.send_page_view = sendPageView;
    }
    if (userId !== undefined) {
        pageViewOptions.user_id = userId;
    }
    window.gtag("config", gaMeasurementId, pageViewOptions);
}
exports.pageView = pageView;
//# sourceMappingURL=pageView.js.map

/***/ }),

/***/ 7375:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var T=Object.create;var p=Object.defineProperty;var k=Object.getOwnPropertyDescriptor;var C=Object.getOwnPropertyNames;var N=Object.getPrototypeOf,v=Object.prototype.hasOwnProperty;var c=e=>p(e,"__esModule",{value:!0}),l=(e,r)=>p(e,"name",{value:r,configurable:!0});var $=(e,r)=>{for(var t in r)p(e,t,{get:r[t],enumerable:!0})},P=(e,r,t,a)=>{if(r&&typeof r=="object"||typeof r=="function")for(let s of C(r))!v.call(e,s)&&(t||s!=="default")&&p(e,s,{get:()=>r[s],enumerable:!(a=k(r,s))||a.enumerable});return e},m=(e,r)=>P(c(p(e!=null?T(N(e)):{},"default",!r&&e&&e.__esModule?{get:()=>e.default,enumerable:!0}:{value:e,enumerable:!0})),e),S=(e=>(r,t)=>e&&e.get(r)||(t=P(c({}),r,1),e&&e.set(r,t),t))(typeof WeakMap!="undefined"?new WeakMap:0);var E={};$(E,{default:()=>d});var i=m(__webpack_require__(5632)),n=m(__webpack_require__(92521)),o=m(__webpack_require__(13980)),f=m(__webpack_require__(2784));function d({color:e="#29D",startPosition:r=.3,stopDelayMs:t=200,height:a=3,showOnShallow:s=!0,options:h,nonce:y}){let u=null;f.useEffect(()=>(h&&n.configure(h),i.default.events.on("routeChangeStart",x),i.default.events.on("routeChangeComplete",g),i.default.events.on("routeChangeError",g),()=>{i.default.events.off("routeChangeStart",x),i.default.events.off("routeChangeComplete",g),i.default.events.off("routeChangeError",g)}),[]);let x=l((w,{shallow:b})=>{(!b||s)&&(n.set(r),n.start())},"routeChangeStart"),g=l((w,{shallow:b})=>{(!b||s)&&(u&&clearTimeout(u),u=setTimeout(()=>{n.done(!0)},t))},"routeChangeEnd");return f.createElement("style",{nonce:y},`
      #nprogress {
        pointer-events: none;
      }
      #nprogress .bar {
        background: ${e};
        position: fixed;
        z-index: 9999;
        top: 0;
        left: 0;
        width: 100%;
        height: ${a}px;
      }
      #nprogress .peg {
        display: block;
        position: absolute;
        right: 0px;
        width: 100px;
        height: 100%;
        box-shadow: 0 0 10px ${e}, 0 0 5px ${e};
        opacity: 1;
        -webkit-transform: rotate(3deg) translate(0px, -4px);
        -ms-transform: rotate(3deg) translate(0px, -4px);
        transform: rotate(3deg) translate(0px, -4px);
      }
      #nprogress .spinner {
        display: block;
        position: fixed;
        z-index: 1031;
        top: 15px;
        right: 15px;
      }
      #nprogress .spinner-icon {
        width: 18px;
        height: 18px;
        box-sizing: border-box;
        border: solid 2px transparent;
        border-top-color: ${e};
        border-left-color: ${e};
        border-radius: 50%;
        -webkit-animation: nprogresss-spinner 400ms linear infinite;
        animation: nprogress-spinner 400ms linear infinite;
      }
      .nprogress-custom-parent {
        overflow: hidden;
        position: relative;
      }
      .nprogress-custom-parent #nprogress .spinner,
      .nprogress-custom-parent #nprogress .bar {
        position: absolute;
      }
      @-webkit-keyframes nprogress-spinner {
        0% {
          -webkit-transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
        }
      }
      @keyframes nprogress-spinner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `)}l(d,"NextNProgress");d.propTypes={color:o.string,startPosition:o.number,stopDelayMs:o.number,height:o.number,showOnShallow:o.bool,options:o.object,nonce:o.string};module.exports=S(E);0&&(0);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 92521:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),

/***/ 47655:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  'use strict'

  /*istanbul ignore next:cant test*/
  if ( true && typeof module.exports === 'object') {
    module.exports = factory()
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else {}
})(this, function () {
  'use strict'

  var toStr = Object.prototype.toString

  function hasOwnProperty (obj, prop) {
    if (obj == null) {
      return false
    }
    //to handle objects with null prototypes (too edge case?)
    return Object.prototype.hasOwnProperty.call(obj, prop)
  }

  function isEmpty (value) {
    if (!value) {
      return true
    }
    if (isArray(value) && value.length === 0) {
      return true
    } else if (typeof value !== 'string') {
      for (var i in value) {
        if (hasOwnProperty(value, i)) {
          return false
        }
      }
      return true
    }
    return false
  }

  function toString (type) {
    return toStr.call(type)
  }

  function isObject (obj) {
    return typeof obj === 'object' && toString(obj) === '[object Object]'
  }

  var isArray = Array.isArray || function (obj) {
    /*istanbul ignore next:cant test*/
    return toStr.call(obj) === '[object Array]'
  }

  function isBoolean (obj) {
    return typeof obj === 'boolean' || toString(obj) === '[object Boolean]'
  }

  function getKey (key) {
    var intKey = parseInt(key)
    if (intKey.toString() === key) {
      return intKey
    }
    return key
  }

  function factory (options) {
    options = options || {}

    var objectPath = function (obj) {
      return Object.keys(objectPath).reduce(function (proxy, prop) {
        if (prop === 'create') {
          return proxy
        }

        /*istanbul ignore else*/
        if (typeof objectPath[prop] === 'function') {
          proxy[prop] = objectPath[prop].bind(objectPath, obj)
        }

        return proxy
      }, {})
    }

    var hasShallowProperty
    if (options.includeInheritedProps) {
      hasShallowProperty = function () {
        return true
      }
    } else {
      hasShallowProperty = function (obj, prop) {
        return (typeof prop === 'number' && Array.isArray(obj)) || hasOwnProperty(obj, prop)
      }
    }

    function getShallowProperty (obj, prop) {
      if (hasShallowProperty(obj, prop)) {
        return obj[prop]
      }
    }

    var getShallowPropertySafely
    if (options.includeInheritedProps) {
      getShallowPropertySafely = function (obj, currentPath) {
        if (typeof currentPath !== 'string' && typeof currentPath !== 'number') {
          currentPath = String(currentPath)
        }
        var currentValue = getShallowProperty(obj, currentPath)
        if (currentPath === '__proto__' || currentPath === 'prototype' ||
          (currentPath === 'constructor' && typeof currentValue === 'function')) {
          throw new Error('For security reasons, object\'s magic properties cannot be set')
        }
        return currentValue
      }
    } else {
      getShallowPropertySafely = function (obj, currentPath) {
        return getShallowProperty(obj, currentPath)
      }
    }

    function set (obj, path, value, doNotReplace) {
      if (typeof path === 'number') {
        path = [path]
      }
      if (!path || path.length === 0) {
        return obj
      }
      if (typeof path === 'string') {
        return set(obj, path.split('.').map(getKey), value, doNotReplace)
      }
      var currentPath = path[0]
      var currentValue = getShallowPropertySafely(obj, currentPath)
      if (path.length === 1) {
        if (currentValue === void 0 || !doNotReplace) {
          obj[currentPath] = value
        }
        return currentValue
      }

      if (currentValue === void 0) {
        //check if we assume an array
        if (typeof path[1] === 'number') {
          obj[currentPath] = []
        } else {
          obj[currentPath] = {}
        }
      }

      return set(obj[currentPath], path.slice(1), value, doNotReplace)
    }

    objectPath.has = function (obj, path) {
      if (typeof path === 'number') {
        path = [path]
      } else if (typeof path === 'string') {
        path = path.split('.')
      }

      if (!path || path.length === 0) {
        return !!obj
      }

      for (var i = 0; i < path.length; i++) {
        var j = getKey(path[i])

        if ((typeof j === 'number' && isArray(obj) && j < obj.length) ||
          (options.includeInheritedProps ? (j in Object(obj)) : hasOwnProperty(obj, j))) {
          obj = obj[j]
        } else {
          return false
        }
      }

      return true
    }

    objectPath.ensureExists = function (obj, path, value) {
      return set(obj, path, value, true)
    }

    objectPath.set = function (obj, path, value, doNotReplace) {
      return set(obj, path, value, doNotReplace)
    }

    objectPath.insert = function (obj, path, value, at) {
      var arr = objectPath.get(obj, path)
      at = ~~at
      if (!isArray(arr)) {
        arr = []
        objectPath.set(obj, path, arr)
      }
      arr.splice(at, 0, value)
    }

    objectPath.empty = function (obj, path) {
      if (isEmpty(path)) {
        return void 0
      }
      if (obj == null) {
        return void 0
      }

      var value, i
      if (!(value = objectPath.get(obj, path))) {
        return void 0
      }

      if (typeof value === 'string') {
        return objectPath.set(obj, path, '')
      } else if (isBoolean(value)) {
        return objectPath.set(obj, path, false)
      } else if (typeof value === 'number') {
        return objectPath.set(obj, path, 0)
      } else if (isArray(value)) {
        value.length = 0
      } else if (isObject(value)) {
        for (i in value) {
          if (hasShallowProperty(value, i)) {
            delete value[i]
          }
        }
      } else {
        return objectPath.set(obj, path, null)
      }
    }

    objectPath.push = function (obj, path /*, values */) {
      var arr = objectPath.get(obj, path)
      if (!isArray(arr)) {
        arr = []
        objectPath.set(obj, path, arr)
      }

      arr.push.apply(arr, Array.prototype.slice.call(arguments, 2))
    }

    objectPath.coalesce = function (obj, paths, defaultValue) {
      var value

      for (var i = 0, len = paths.length; i < len; i++) {
        if ((value = objectPath.get(obj, paths[i])) !== void 0) {
          return value
        }
      }

      return defaultValue
    }

    objectPath.get = function (obj, path, defaultValue) {
      if (typeof path === 'number') {
        path = [path]
      }
      if (!path || path.length === 0) {
        return obj
      }
      if (obj == null) {
        return defaultValue
      }
      if (typeof path === 'string') {
        return objectPath.get(obj, path.split('.'), defaultValue)
      }

      var currentPath = getKey(path[0])
      var nextObj = getShallowPropertySafely(obj, currentPath)
      if (nextObj === void 0) {
        return defaultValue
      }

      if (path.length === 1) {
        return nextObj
      }

      return objectPath.get(obj[currentPath], path.slice(1), defaultValue)
    }

    objectPath.del = function del (obj, path) {
      if (typeof path === 'number') {
        path = [path]
      }

      if (obj == null) {
        return obj
      }

      if (isEmpty(path)) {
        return obj
      }
      if (typeof path === 'string') {
        return objectPath.del(obj, path.split('.'))
      }

      var currentPath = getKey(path[0])
      getShallowPropertySafely(obj, currentPath)
      if (!hasShallowProperty(obj, currentPath)) {
        return obj
      }

      if (path.length === 1) {
        if (isArray(obj)) {
          obj.splice(currentPath, 1)
        } else {
          delete obj[currentPath]
        }
      } else {
        return objectPath.del(obj[currentPath], path.slice(1))
      }

      return obj
    }

    return objectPath
  }

  var mod = factory()
  mod.create = factory
  mod.withInheritedProps = factory({includeInheritedProps: true})
  return mod
})


/***/ }),

/***/ 88438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dP": function() { return /* binding */ dep; },
/* harmony export */   "re": function() { return /* binding */ wrap; }
/* harmony export */ });
/* unused harmony export defaultMakeCacheKey */
/* harmony import */ var _wry_trie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3985);
/* harmony import */ var _wry_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62139);





function defaultDispose() { }
var Cache = /** @class */ (function () {
    function Cache(max, dispose) {
        if (max === void 0) { max = Infinity; }
        if (dispose === void 0) { dispose = defaultDispose; }
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function (key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function (key) {
        var node = this.getNode(key);
        return node && node.value;
    };
    Cache.prototype.getNode = function (key) {
        var node = this.map.get(key);
        if (node && node !== this.newest) {
            var older = node.older, newer = node.newer;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    };
    Cache.prototype.set = function (key, value) {
        var node = this.getNode(key);
        if (node) {
            return node.value = value;
        }
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    };
    Cache.prototype.clean = function () {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    };
    Cache.prototype.delete = function (key) {
        var node = this.map.get(key);
        if (node) {
            if (node === this.newest) {
                this.newest = node.older;
            }
            if (node === this.oldest) {
                this.oldest = node.newer;
            }
            if (node.newer) {
                node.newer.older = node.older;
            }
            if (node.older) {
                node.older.newer = node.newer;
            }
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}());

var parentEntrySlot = new _wry_context__WEBPACK_IMPORTED_MODULE_1__/* .Slot */ .g7();

var _a;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var 
// This Array.from polyfill is restricted to working with Set<any> for now,
// but we can improve the polyfill and add other input types, as needed. Note
// that this fallback implementation will only be used if the host environment
// does not support a native Array.from function. In most modern JS runtimes,
// the toArray function exported here will be === Array.from.
toArray = (_a = Array.from, _a === void 0 ? function (collection) {
    var array = [];
    collection.forEach(function (item) { return array.push(item); });
    return array;
} : _a);
function maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    var len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ (function () {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function () {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            rememberParent(this);
            return this.value[0];
        }
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function (args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this)
            ? reallyRecompute(this, args)
            : valueGet(this.value);
    };
    Entry.prototype.setDirty = function () {
        if (this.dirty)
            return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function () {
        var _this = this;
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        eachParent(this, function (parent, child) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.prototype.forget = function () {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    };
    Entry.prototype.dependOn = function (dep) {
        dep.add(this);
        if (!this.deps) {
            this.deps = emptySetPool.pop() || new Set();
        }
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function () {
        var _this = this;
        if (this.deps) {
            toArray(this.deps).forEach(function (dep) { return dep.delete(_this); });
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}());
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);
    if (maybeSubscribe(entry, args)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    }
    catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    eachParent(child, reportDirtyChild);
}
function reportClean(child) {
    eachParent(child, reportCleanChild);
}
function eachParent(child, callback) {
    var parentCount = child.parents.size;
    if (parentCount) {
        var parents = toArray(child.parents);
        for (var i = 0; i < parentCount; ++i) {
            callback(parents[i], child);
        }
    }
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    var parentWasClean = !mightBeDirty(parent);
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) {
        reportDirty(parent);
    }
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) {
        parent.childValues.forEach(function (_value, child) {
            forgetChild(parent, child);
        });
    }
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

var EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true, // Fully remove parent Entry from LRU cache and computation graph
};
function dep(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) {
                depsByKey.set(key, dep_1 = new Set);
            }
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        var dep = depsByKey.get(key);
        if (dep) {
            var m_1 = (entryMethodName &&
                hasOwnProperty.call(EntryMethods, entryMethodName)) ? entryMethodName : "setDirty";
            // We have to use toArray(dep).forEach instead of dep.forEach, because
            // modifying a Set while iterating over it can cause elements in the Set
            // to be removed from the Set before they've been iterated over.
            toArray(dep).forEach(function (entry) { return entry[m_1](); });
            depsByKey.delete(key);
            maybeUnsubscribe(dep);
        }
    };
    return depend;
}

function makeDefaultMakeCacheKeyFunction() {
    var keyTrie = new _wry_trie__WEBPACK_IMPORTED_MODULE_0__/* .Trie */ .B(typeof WeakMap === "function");
    return function () {
        return keyTrie.lookupArray(arguments);
    };
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var defaultMakeCacheKey = makeDefaultMakeCacheKeyFunction();
var caches = new Set();
function wrap(originalFunction, options) {
    if (options === void 0) { options = Object.create(null); }
    var cache = new Cache(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
    var keyArgs = options.keyArgs;
    var makeCacheKey = options.makeCacheKey ||
        makeDefaultMakeCacheKeyFunction();
    var optimistic = function () {
        var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new Entry(originalFunction));
            entry.subscribe = options.subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = function () { return cache.delete(key); };
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function (cache) { return cache.clean(); });
            caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: function () {
            return cache["map"].size;
        },
        configurable: false,
        enumerable: false,
    });
    function dirtyKey(key) {
        var entry = cache.get(key);
        if (entry) {
            entry.setDirty();
        }
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        var entry = cache.get(key);
        if (entry) {
            return entry.peek();
        }
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return cache.delete(key);
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}


//# sourceMappingURL=bundle.esm.js.map


/***/ }),

/***/ 8782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_j": function() { return /* binding */ curriedDarken$1; },
  "$n": function() { return /* binding */ curriedLighten$1; },
  "m4": function() { return /* binding */ rgba; }
});

// UNUSED EXPORTS: adjustHue, animation, backgroundImages, backgrounds, between, border, borderColor, borderRadius, borderStyle, borderWidth, buttons, clearFix, complement, cover, cssVar, desaturate, directionalProperty, easeIn, easeInOut, easeOut, ellipsis, em, fluidRange, fontFace, getContrast, getLuminance, getValueAndUnit, grayscale, hiDPI, hideText, hideVisually, hsl, hslToColorString, hsla, important, invert, linearGradient, margin, math, meetsContrastGuidelines, mix, modularScale, normalize, opacify, padding, parseToHsl, parseToRgb, position, radialGradient, readableColor, rem, remToPx, retinaImage, rgb, rgbToColorString, saturate, setHue, setLightness, setSaturation, shade, size, stripUnit, textInputs, timingFunctions, tint, toColorString, transitions, transparentize, triangle, wordWrap

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(80753);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(95058);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(88960);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
var isNativeReflectConstruct = __webpack_require__(70352);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if ((0,isNativeReflectConstruct/* default */.Z)()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, (0,getPrototypeOf/* default */.Z)(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,setPrototypeOf/* default */.Z)(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
;// CONCATENATED MODULE: ../../node_modules/polished/dist/polished.esm.js






function last() {
  var _ref;

  return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}

function negation(a) {
  return -a;
}

function addition(a, b) {
  return a + b;
}

function subtraction(a, b) {
  return a - b;
}

function multiplication(a, b) {
  return a * b;
}

function division(a, b) {
  return a / b;
}

function max() {
  return Math.max.apply(Math, arguments);
}

function min() {
  return Math.min.apply(Math, arguments);
}

function comma() {
  return Array.of.apply(Array, arguments);
}

var defaultSymbols = {
  symbols: {
    '*': {
      infix: {
        symbol: '*',
        f: multiplication,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '*',
      regSymbol: '\\*'
    },
    '/': {
      infix: {
        symbol: '/',
        f: division,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '/',
      regSymbol: '/'
    },
    '+': {
      infix: {
        symbol: '+',
        f: addition,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '+',
        f: last,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '+',
      regSymbol: '\\+'
    },
    '-': {
      infix: {
        symbol: '-',
        f: subtraction,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '-',
        f: negation,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '-',
      regSymbol: '-'
    },
    ',': {
      infix: {
        symbol: ',',
        f: comma,
        notation: 'infix',
        precedence: 1,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: ',',
      regSymbol: ','
    },
    '(': {
      prefix: {
        symbol: '(',
        f: last,
        notation: 'prefix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '(',
      regSymbol: '\\('
    },
    ')': {
      postfix: {
        symbol: ')',
        f: undefined,
        notation: 'postfix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: ')',
      regSymbol: '\\)'
    },
    min: {
      func: {
        symbol: 'min',
        f: min,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'min',
      regSymbol: 'min\\b'
    },
    max: {
      func: {
        symbol: 'max',
        f: max,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'max',
      regSymbol: 'max\\b'
    }
  }
};
var defaultSymbolMap = (/* unused pure expression or super */ null && (defaultSymbols));

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError = /*#__PURE__*/function (_Error) {
  (0,inheritsLoose/* default */.Z)(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    if (true) {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else { var _len2, args, _key2; }

    return (0,assertThisInitialized/* default */.Z)(_this);
  }

  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g; // Merges additional math functionality into the defaults.

function mergeSymbolMaps(additionalSymbols) {
  var symbolMap = {};
  symbolMap.symbols = additionalSymbols ? _extends({}, defaultSymbolMap.symbols, additionalSymbols.symbols) : _extends({}, defaultSymbolMap.symbols);
  return symbolMap;
}

function exec(operators, values) {
  var _ref;

  var op = operators.pop();
  values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
  return op.precedence;
}

function calculate(expression, additionalSymbols) {
  var symbolMap = mergeSymbolMaps(additionalSymbols);
  var match;
  var operators = [symbolMap.symbols['('].prefix];
  var values = [];
  var pattern = new RegExp( // Pattern for numbers
  "\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
  Object.keys(symbolMap.symbols).map(function (key) {
    return symbolMap.symbols[key];
  }) // longer symbols should be listed first
  // $FlowFixMe
  .sort(function (a, b) {
    return b.symbol.length - a.symbol.length;
  }) // $FlowFixMe
  .map(function (val) {
    return val.regSymbol;
  }).join('|') + "|(\\S)", 'g');
  pattern.lastIndex = 0; // Reset regular expression object

  var afterValue = false;

  do {
    match = pattern.exec(expression);

    var _ref2 = match || [')', undefined],
        token = _ref2[0],
        bad = _ref2[1];

    var notNumber = symbolMap.symbols[token];
    var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
    var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix; // Check for syntax errors:

    if (bad || (afterValue ? notAfterValue : notNewValue)) {
      throw new PolishedError(37, match ? match.index : expression.length, expression);
    }

    if (afterValue) {
      // We either have an infix or postfix operator (they should be mutually exclusive)
      var curr = notNumber.postfix || notNumber.infix;

      do {
        var prev = operators[operators.length - 1];
        if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break; // Apply previous operator, since it has precedence over current one
      } while (exec(operators, values)); // Exit loop after executing an opening parenthesis or function


      afterValue = curr.notation === 'postfix';

      if (curr.symbol !== ')') {
        operators.push(curr); // Postfix always has precedence over any operator that follows after it

        if (afterValue) exec(operators, values);
      }
    } else if (notNumber) {
      // prefix operator or function
      operators.push(notNumber.prefix || notNumber.func);

      if (notNumber.func) {
        // Require an opening parenthesis
        match = pattern.exec(expression);

        if (!match || match[0] !== '(') {
          throw new PolishedError(38, match ? match.index : expression.length, expression);
        }
      }
    } else {
      // number
      values.push(+token);
      afterValue = true;
    }
  } while (match && operators.length);

  if (operators.length) {
    throw new PolishedError(39, match ? match.index : expression.length, expression);
  } else if (match) {
    throw new PolishedError(40, match ? match.index : expression.length, expression);
  } else {
    return values.pop();
  }
}

function reverseString(str) {
  return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */


function math(formula, additionalSymbols) {
  var reversedFormula = reverseString(formula);
  var formulaMatch = reversedFormula.match(unitRegExp); // Check that all units are the same

  if (formulaMatch && !formulaMatch.every(function (unit) {
    return unit === formulaMatch[0];
  })) {
    throw new PolishedError(41);
  }

  var cleanFormula = reverseString(reversedFormula.replace(unitRegExp, ''));
  return "" + calculate(cleanFormula, additionalSymbols) + (formulaMatch ? reverseString(formulaMatch[0]) : '');
}

var cssVariableRegex = /--[\S]*/g;
/**
 * Fetches the value of a passed CSS Variable in the :root scope, or otherwise returns a defaultValue if provided.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */

function cssVar(cssVariable, defaultValue) {
  if (!cssVariable || !cssVariable.match(cssVariableRegex)) {
    throw new PolishedError(73);
  }

  var variableValue;
  /* eslint-disable */

  /* istanbul ignore next */

  if (typeof document !== 'undefined' && document.documentElement !== null) {
    variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
  }
  /* eslint-enable */


  if (variableValue) {
    return variableValue.trim();
  } else if (defaultValue) {
    return defaultValue;
  }

  throw new PolishedError(74);
}

// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var positionMap$1 = (/* unused pure expression or super */ null && (['Top', 'Right', 'Bottom', 'Left']));

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');

  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return "" + acc + capitalizeString(val);
    });
  }

  var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
  return property === joinedProperty ? "" + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};

  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap$1[i])] = valuesWithDefaults[i];
    }
  }

  return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */


function directionalProperty(property) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === void 0 ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === void 0 ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === void 0 ? secondValue : _values$3;
  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

/**
 * Check if a string ends with something
 * @private
 */
function endsWith(string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

var cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */

function stripUnit(value) {
  if (typeof value !== 'string') return value;
  var matchedValue = value.match(cssRegex$1);
  return matchedValue ? parseFloat(value) : value;
}

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */

var pxtoFactory = function pxtoFactory(to) {
  return function (pxval, base) {
    if (base === void 0) {
      base = '16px';
    }

    var newPxval = pxval;
    var newBase = base;

    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new PolishedError(69, to, pxval);
      }

      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new PolishedError(70, to, base);
      }

      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new PolishedError(71, pxval, to);
    }

    if (typeof newBase === 'string') {
      throw new PolishedError(72, base, to);
    }

    return "" + newPxval / newBase + to;
  };
};

var pixelsto = (/* unused pure expression or super */ null && (pxtoFactory));

/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */

var em = /*#__PURE__*/(/* unused pure expression or super */ null && (pixelsto('em')));
var em$1 = (/* unused pure expression or super */ null && (em));

var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */

function getValueAndUnit(value) {
  if (typeof value !== 'string') return [value, ''];
  var matchedValue = value.match(cssRegex);
  if (matchedValue) return [parseFloat(value), matchedValue[2]];
  return [value, undefined];
}

/**
 * Helper for targeting rules in a style block generated by polished modules that need !important-level specificity. Can optionally specify a rule (or rules) to target specific rules.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...important(cover())
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${important(cover())}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute !important',
 *   'top': '0 !important',
 *   'right: '0 !important',
 *   'bottom': '0 !important',
 *   'left: '0 !important'
 * }
 */

function important(styleBlock, rules) {
  if (typeof styleBlock !== 'object' || styleBlock === null) {
    throw new PolishedError(75, typeof styleBlock);
  }

  var newStyleBlock = {};
  Object.keys(styleBlock).forEach(function (key) {
    if (typeof styleBlock[key] === 'object' && styleBlock[key] !== null) {
      newStyleBlock[key] = important(styleBlock[key], rules);
    } else if (!rules || rules && (rules === key || rules.indexOf(key) >= 0)) {
      newStyleBlock[key] = styleBlock[key] + " !important";
    } else {
      newStyleBlock[key] = styleBlock[key];
    }
  });
  return newStyleBlock;
}

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4
};

function getRatio(ratioName) {
  return ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */


function modularScale(steps, base, ratio) {
  if (base === void 0) {
    base = '1em';
  }

  if (ratio === void 0) {
    ratio = 1.333;
  }

  if (typeof steps !== 'number') {
    throw new PolishedError(42);
  }

  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new PolishedError(43);
  }

  var _ref = typeof base === 'string' ? getValueAndUnit(base) : [base, ''],
      realBase = _ref[0],
      unit = _ref[1];

  var realRatio = typeof ratio === 'string' ? getRatio(ratio) : ratio;

  if (typeof realBase === 'string') {
    throw new PolishedError(44, base);
  }

  return "" + realBase * Math.pow(realRatio, steps) + (unit || '');
}

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */

var rem = /*#__PURE__*/(/* unused pure expression or super */ null && (pixelsto('rem')));
var rem$1 = (/* unused pure expression or super */ null && (rem));

var defaultFontSize = 16;

function convertBase(base) {
  var deconstructedValue = getValueAndUnit(base);

  if (deconstructedValue[1] === 'px') {
    return parseFloat(base);
  }

  if (deconstructedValue[1] === '%') {
    return parseFloat(base) / 100 * defaultFontSize;
  }

  throw new PolishedError(78, deconstructedValue[1]);
}

function getBaseFromDoc() {
  /* eslint-disable */

  /* istanbul ignore next */
  if (typeof document !== 'undefined' && document.documentElement !== null) {
    var rootFontSize = getComputedStyle(document.documentElement).fontSize;
    return rootFontSize ? convertBase(rootFontSize) : defaultFontSize;
  }
  /* eslint-enable */

  /* istanbul ignore next */


  return defaultFontSize;
}
/**
 * Convert rem values to px. By default, the base value is pulled from the font-size property on the root element (if it is set in % or px). It defaults to 16px if not found on the root. You can also override the base value by providing your own base in % or px.
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': remToPx('1.6rem')
 *   'height': remToPx('1.6rem', '10px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${remToPx('1.6rem')}
 *   height: ${remToPx('1.6rem', '10px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '25.6px',
 *   'height': '16px',
 * }
 */


function remToPx(value, base) {
  var deconstructedValue = getValueAndUnit(value);

  if (deconstructedValue[1] !== 'rem' && deconstructedValue[1] !== '') {
    throw new PolishedError(77, deconstructedValue[1]);
  }

  var newBase = base ? convertBase(base) : getBaseFromDoc();
  return deconstructedValue[0] * newBase + "px";
}

var functionsMap$3 = {
  back: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  circ: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  cubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  expo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  quad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  quart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  quint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  sine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeIn('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeIn('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */

function easeIn(functionName) {
  return functionsMap$3[functionName.toLowerCase().trim()];
}

var functionsMap$2 = {
  back: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  circ: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  cubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  expo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  quad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  quart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  quint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  sine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeInOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeInOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
 * }
 */

function easeInOut(functionName) {
  return functionsMap$2[functionName.toLowerCase().trim()];
}

var functionsMap$1 = {
  back: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  cubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  circ: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  expo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  quad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  quart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  quint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  sine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
 * }
 */

function easeOut(functionName) {
  return functionsMap$1[functionName.toLowerCase().trim()];
}

/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */

function between(fromSize, toSize, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }

  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }

  var _getValueAndUnit = getValueAndUnit(fromSize),
      unitlessFromSize = _getValueAndUnit[0],
      fromSizeUnit = _getValueAndUnit[1];

  var _getValueAndUnit2 = getValueAndUnit(toSize),
      unitlessToSize = _getValueAndUnit2[0],
      toSizeUnit = _getValueAndUnit2[1];

  var _getValueAndUnit3 = getValueAndUnit(minScreen),
      unitlessMinScreen = _getValueAndUnit3[0],
      minScreenUnit = _getValueAndUnit3[1];

  var _getValueAndUnit4 = getValueAndUnit(maxScreen),
      unitlessMaxScreen = _getValueAndUnit4[0],
      maxScreenUnit = _getValueAndUnit4[1];

  if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) {
    throw new PolishedError(47);
  }

  if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || fromSizeUnit !== toSizeUnit) {
    throw new PolishedError(48);
  }

  if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) {
    throw new PolishedError(76);
  }

  var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
  var base = unitlessToSize - slope * unitlessMaxScreen;
  return "calc(" + base.toFixed(2) + (fromSizeUnit || '') + " + " + (100 * slope).toFixed(2) + "vw)";
}

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */
function clearFix(parent) {
  var _ref;

  if (parent === void 0) {
    parent = '&';
  }

  var pseudoSelector = parent + "::after";
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */
function cover(offset) {
  if (offset === void 0) {
    offset = 0;
  }

  return {
    position: 'absolute',
    top: offset,
    right: offset,
    bottom: offset,
    left: offset
  };
}

/**
 * CSS to represent truncated text with an ellipsis. You can optionally pass a max-width and number of lines before truncating.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */
function ellipsis(width, lines) {
  if (lines === void 0) {
    lines = 1;
  }

  var styles = {
    display: 'inline-block',
    maxWidth: width || '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
  return lines > 1 ? _extends({}, styles, {
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: lines,
    display: '-webkit-box',
    whiteSpace: 'normal'
  }) : styles;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */
function fluidRange(cssProp, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }

  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }

  if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) {
    throw new PolishedError(49);
  }

  if (Array.isArray(cssProp)) {
    var mediaQueries = {};
    var fallbacks = {};

    for (var _iterator = _createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;) {
      var _extends2, _extends3;

      var obj = _step.value;

      if (!obj.prop || !obj.fromSize || !obj.toSize) {
        throw new PolishedError(50);
      }

      fallbacks[obj.prop] = obj.fromSize;
      mediaQueries["@media (min-width: " + minScreen + ")"] = _extends({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = between(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
      mediaQueries["@media (min-width: " + maxScreen + ")"] = _extends({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
    }

    return _extends({}, fallbacks, mediaQueries);
  } else {
    var _ref, _ref2, _ref3;

    if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) {
      throw new PolishedError(51);
    }

    return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = between(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
  }
}

var dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var formatHintMap = {
  woff: 'woff',
  woff2: 'woff2',
  ttf: 'truetype',
  otf: 'opentype',
  eot: 'embedded-opentype',
  svg: 'svg',
  svgz: 'svg'
};

function generateFormatHint(format, formatHint) {
  if (!formatHint) return '';
  return " format(\"" + formatHintMap[format] + "\")";
}

function isDataURI(fontFilePath) {
  return !!fontFilePath.replace(/\s+/g, ' ').match(dataURIRegex);
}

function generateFileReferences(fontFilePath, fileFormats, formatHint) {
  if (isDataURI(fontFilePath)) {
    return "url(\"" + fontFilePath + "\")" + generateFormatHint(fileFormats[0], formatHint);
  }

  var fileFontReferences = fileFormats.map(function (format) {
    return "url(\"" + fontFilePath + "." + format + "\")" + generateFormatHint(format, formatHint);
  });
  return fileFontReferences.join(', ');
}

function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return "local(\"" + font + "\")";
  });
  return localFontReferences.join(', ');
}

function generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));

  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats, formatHint));
  }

  return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration. Defaults to check for local copies of the font on the user's machine. You can disable this by passing `null` to localFonts.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */


function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
      fontFilePath = _ref.fontFilePath,
      fontStretch = _ref.fontStretch,
      fontStyle = _ref.fontStyle,
      fontVariant = _ref.fontVariant,
      fontWeight = _ref.fontWeight,
      _ref$fileFormats = _ref.fileFormats,
      fileFormats = _ref$fileFormats === void 0 ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
      _ref$formatHint = _ref.formatHint,
      formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint,
      _ref$localFonts = _ref.localFonts,
      localFonts = _ref$localFonts === void 0 ? [fontFamily] : _ref$localFonts,
      unicodeRange = _ref.unicodeRange,
      fontDisplay = _ref.fontDisplay,
      fontVariationSettings = _ref.fontVariationSettings,
      fontFeatureSettings = _ref.fontFeatureSettings;
  // Error Handling
  if (!fontFamily) throw new PolishedError(55);

  if (!fontFilePath && !localFonts) {
    throw new PolishedError(52);
  }

  if (localFonts && !Array.isArray(localFonts)) {
    throw new PolishedError(53);
  }

  if (!Array.isArray(fileFormats)) {
    throw new PolishedError(54);
  }

  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats, formatHint),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight,
      fontDisplay: fontDisplay,
      fontVariationSettings: fontVariationSettings,
      fontFeatureSettings: fontFeatureSettings
    }
  }; // Removes undefined fields for cleaner css object.

  return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */
function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */
function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */
function hiDPI(ratio) {
  if (ratio === void 0) {
    ratio = 1.3;
  }

  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

function constructGradientValue(literals) {
  var template = '';

  for (var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    substitutions[_key - 1] = arguments[_key];
  }

  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i];

    if (i === substitutions.length - 1 && substitutions[i]) {
      var definedValues = substitutions.filter(function (substitute) {
        return !!substitute;
      }); // Adds leading coma if properties preceed color-stops

      if (definedValues.length > 1) {
        template = template.slice(0, -1);
        template += ", " + substitutions[i]; // No trailing space if color-stops is the only param provided
      } else if (definedValues.length === 1) {
        template += "" + substitutions[i];
      }
    } else if (substitutions[i]) {
      template += substitutions[i] + " ";
    }
  }

  return template.trim();
}

var _templateObject$1;

/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */
function linearGradient(_ref) {
  var colorStops = _ref.colorStops,
      fallback = _ref.fallback,
      _ref$toDirection = _ref.toDirection,
      toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;

  if (!colorStops || colorStops.length < 2) {
    throw new PolishedError(56);
  }

  return {
    backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ',').split(' ')[0].replace(/,(?=\S)/g, ', '),
    backgroundImage: constructGradientValue(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["linear-gradient(", "", ")"])), toDirection, colorStops.join(', ').replace(/,(?=\S)/g, ', '))
  };
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize() {
  var _ref;

  return [(_ref = {
    html: {
      lineHeight: '1.15',
      textSizeAdjust: '100%'
    },
    body: {
      margin: '0'
    },
    main: {
      display: 'block'
    },
    h1: {
      fontSize: '2em',
      margin: '0.67em 0'
    },
    hr: {
      boxSizing: 'content-box',
      height: '0',
      overflow: 'visible'
    },
    pre: {
      fontFamily: 'monospace, monospace',
      fontSize: '1em'
    },
    a: {
      backgroundColor: 'transparent'
    },
    'abbr[title]': {
      borderBottom: 'none',
      textDecoration: 'underline'
    }
  }, _ref["b,\n    strong"] = {
    fontWeight: 'bolder'
  }, _ref["code,\n    kbd,\n    samp"] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  }, _ref.small = {
    fontSize: '80%'
  }, _ref["sub,\n    sup"] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
  }, _ref.sub = {
    bottom: '-0.25em'
  }, _ref.sup = {
    top: '-0.5em'
  }, _ref.img = {
    borderStyle: 'none'
  }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: '0'
  }, _ref["button,\n    input"] = {
    overflow: 'visible'
  }, _ref["button,\n    select"] = {
    textTransform: 'none'
  }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
    WebkitAppearance: 'button'
  }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
    borderStyle: 'none',
    padding: '0'
  }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
    outline: '1px dotted ButtonText'
  }, _ref.fieldset = {
    padding: '0.35em 0.625em 0.75em'
  }, _ref.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
  }, _ref.progress = {
    verticalAlign: 'baseline'
  }, _ref.textarea = {
    overflow: 'auto'
  }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
    boxSizing: 'border-box',
    padding: '0'
  }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
    height: 'auto'
  }, _ref['[type="search"]'] = {
    WebkitAppearance: 'textfield',
    outlineOffset: '-2px'
  }, _ref['[type="search"]::-webkit-search-decoration'] = {
    WebkitAppearance: 'none'
  }, _ref['::-webkit-file-upload-button'] = {
    WebkitAppearance: 'button',
    font: 'inherit'
  }, _ref.details = {
    display: 'block'
  }, _ref.summary = {
    display: 'list-item'
  }, _ref.template = {
    display: 'none'
  }, _ref['[hidden]'] = {
    display: 'none'
  }, _ref), {
    'abbr[title]': {
      textDecoration: 'underline dotted'
    }
  }];
}

var _templateObject;

/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */
function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
      _ref$extent = _ref.extent,
      extent = _ref$extent === void 0 ? '' : _ref$extent,
      fallback = _ref.fallback,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? '' : _ref$position,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? '' : _ref$shape;

  if (!colorStops || colorStops.length < 2) {
    throw new PolishedError(57);
  }

  return {
    backgroundColor: fallback || colorStops[0].split(' ')[0],
    backgroundImage: constructGradientValue(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["radial-gradient(", "", "", "", ")"])), position, shape, extent, colorStops.join(', '))
  };
}

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
  var _ref;

  if (extension === void 0) {
    extension = 'png';
  }

  if (retinaSuffix === void 0) {
    retinaSuffix = '_2x';
  }

  if (!filename) {
    throw new PolishedError(58);
  } // Replace the dot at the beginning of the passed extension if one exists


  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
  return _ref = {
    backgroundImage: "url(" + filename + "." + ext + ")"
  }, _ref[hiDPI()] = _extends({
    backgroundImage: "url(" + rFilename + ")"
  }, backgroundSize ? {
    backgroundSize: backgroundSize
  } : {}), _ref;
}

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/* eslint-enable key-spacing */

function getTimingFunction(functionName) {
  return functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @deprecated - This will be deprecated in v5 in favor of `easeIn`, `easeOut`, `easeInOut`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */


function timingFunctions(timingFunction) {
  return getTimingFunction(timingFunction);
}

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  var fullWidth = "" + width[0] + (width[1] || '');
  var halfWidth = "" + width[0] / 2 + (width[1] || '');
  var fullHeight = "" + height[0] + (height[1] || '');
  var halfHeight = "" + height[0] / 2 + (height[1] || '');

  switch (pointingDirection) {
    case 'top':
      return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;

    case 'topLeft':
      return fullWidth + " " + fullHeight + " 0 0";

    case 'left':
      return halfHeight + " " + fullWidth + " " + halfHeight + " 0";

    case 'bottomLeft':
      return fullWidth + " 0 0 " + fullHeight;

    case 'bottom':
      return fullHeight + " " + halfWidth + " 0 " + halfWidth;

    case 'bottomRight':
      return "0 0 " + fullWidth + " " + fullHeight;

    case 'right':
      return halfHeight + " 0 " + halfHeight + " " + fullWidth;

    case 'topRight':
    default:
      return "0 " + fullWidth + " " + fullHeight + " 0";
  }
};

var getBorderColor = function getBorderColor(pointingDirection, foregroundColor) {
  switch (pointingDirection) {
    case 'top':
    case 'bottomRight':
      return {
        borderBottomColor: foregroundColor
      };

    case 'right':
    case 'bottomLeft':
      return {
        borderLeftColor: foregroundColor
      };

    case 'bottom':
    case 'topLeft':
      return {
        borderTopColor: foregroundColor
      };

    case 'left':
    case 'topRight':
      return {
        borderRightColor: foregroundColor
      };

    default:
      throw new PolishedError(59);
  }
};
/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */


function triangle(_ref) {
  var pointingDirection = _ref.pointingDirection,
      height = _ref.height,
      width = _ref.width,
      foregroundColor = _ref.foregroundColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
  var widthAndUnit = getValueAndUnit(width);
  var heightAndUnit = getValueAndUnit(height);

  if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) {
    throw new PolishedError(60);
  }

  return _extends({
    width: '0',
    height: '0',
    borderColor: backgroundColor
  }, getBorderColor(pointingDirection, foregroundColor), {
    borderStyle: 'solid',
    borderWidth: getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
  });
}

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */
function wordWrap(wrap) {
  if (wrap === void 0) {
    wrap = 'break-word';
  }

  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }

  throw new PolishedError(5);
}

function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }

  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;

    case green:
      hue = (blue - red) / delta + 2;
      break;

    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;

  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }

  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

var reduceHexValue$1 = reduceHexValue;

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new PolishedError(1);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }

  throw new PolishedError(2);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new PolishedError(7);
}

var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */


function toColorString(color) {
  if (typeof color !== 'object') throw new PolishedError(8);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);
  throw new PolishedError(8);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare


function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */

function adjustHue(degree, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: hslColor.hue + parseFloat(degree)
  }));
} // prettier-ignore


var curriedAdjustHue = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(adjustHue)));
var curriedAdjustHue$1 = (/* unused pure expression or super */ null && (curriedAdjustHue));

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */

function complement(color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */

function darken(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString((0,esm_extends/* default */.Z)({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDarken = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(darken);
var curriedDarken$1 = curriedDarken;

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */

function desaturate(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDesaturate = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(desaturate)));
var curriedDesaturate$1 = (/* unused pure expression or super */ null && (curriedDesaturate));

/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */

function getLuminance(color) {
  if (color === 'transparent') return 0;
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}

/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */

function getContrast(color1, color2) {
  var luminance1 = getLuminance(color1);
  var luminance2 = getLuminance(color2);
  return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */

function grayscale(color) {
  if (color === 'transparent') return color;
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: 0
  }));
}

/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */
function hslToColorString(color) {
  if (typeof color === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
    if (color.alpha && typeof color.alpha === 'number') {
      return hsla({
        hue: color.hue,
        saturation: color.saturation,
        lightness: color.lightness,
        alpha: color.alpha
      });
    }

    return hsl({
      hue: color.hue,
      saturation: color.saturation,
      lightness: color.lightness
    });
  }

  throw new PolishedError(45);
}

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */

function invert(color) {
  if (color === 'transparent') return color; // parse color string to rgb

  var value = parseToRgb(color);
  return toColorString(_extends({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */

function lighten(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString((0,esm_extends/* default */.Z)({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
} // prettier-ignore


var curriedLighten = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(lighten);
var curriedLighten$1 = curriedLighten;

/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */
function meetsContrastGuidelines(color1, color2) {
  var contrastRatio = getContrast(color1, color2);
  return {
    AA: contrastRatio >= 4.5,
    AALarge: contrastRatio >= 3,
    AAA: contrastRatio >= 7,
    AAALarge: contrastRatio >= 4.5
  };
}

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */

function mix(weight, color, otherColor) {
  if (color === 'transparent') return otherColor;
  if (otherColor === 'transparent') return color;
  if (weight === 0) return otherColor;
  var parsedColor1 = parseToRgb(color);

  var color1 = _extends({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);

  var color2 = _extends({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
  }); // The formula is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method


  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
  };
  return rgba(mixedColor);
} // prettier-ignore


var curriedMix = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string, string> */
(mix)));
var mix$1 = (/* unused pure expression or super */ null && (curriedMix));

/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */

function opacify(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
  });

  return rgba(colorWithAlpha);
} // prettier-ignore


var curriedOpacify = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(opacify)));
var curriedOpacify$1 = (/* unused pure expression or super */ null && (curriedOpacify));

var defaultReturnIfLightColor = '#000';
var defaultReturnIfDarkColor = '#fff';
/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */

function readableColor(color, returnIfLightColor, returnIfDarkColor, strict) {
  if (returnIfLightColor === void 0) {
    returnIfLightColor = defaultReturnIfLightColor;
  }

  if (returnIfDarkColor === void 0) {
    returnIfDarkColor = defaultReturnIfDarkColor;
  }

  if (strict === void 0) {
    strict = true;
  }

  var isColorLight = getLuminance(color) > 0.179;
  var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;

  if (!strict || getContrast(color, preferredReturnColor) >= 4.5) {
    return preferredReturnColor;
  }

  return isColorLight ? defaultReturnIfLightColor : defaultReturnIfDarkColor;
}

/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */
function rgbToColorString(color) {
  if (typeof color === 'object' && typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number') {
    if (typeof color.alpha === 'number') {
      return rgba({
        red: color.red,
        green: color.green,
        blue: color.blue,
        alpha: color.alpha
      });
    }

    return rgb({
      red: color.red,
      green: color.green,
      blue: color.blue
    });
  }

  throw new PolishedError(46);
}

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */

function saturate(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
  }));
} // prettier-ignore


var curriedSaturate = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(saturate)));
var curriedSaturate$1 = (/* unused pure expression or super */ null && (curriedSaturate));

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */

function setHue(hue, color) {
  if (color === 'transparent') return color;
  return toColorString(_extends({}, parseToHsl(color), {
    hue: parseFloat(hue)
  }));
} // prettier-ignore


var curriedSetHue = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(setHue)));
var curriedSetHue$1 = (/* unused pure expression or super */ null && (curriedSetHue));

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */

function setLightness(lightness, color) {
  if (color === 'transparent') return color;
  return toColorString(_extends({}, parseToHsl(color), {
    lightness: parseFloat(lightness)
  }));
} // prettier-ignore


var curriedSetLightness = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(setLightness)));
var curriedSetLightness$1 = (/* unused pure expression or super */ null && (curriedSetLightness));

/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */

function setSaturation(saturation, color) {
  if (color === 'transparent') return color;
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: parseFloat(saturation)
  }));
} // prettier-ignore


var curriedSetSaturation = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(setSaturation)));
var curriedSetSaturation$1 = (/* unused pure expression or super */ null && (curriedSetSaturation));

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  if (color === 'transparent') return color;
  return mix$1(parseFloat(percentage), 'rgb(0, 0, 0)', color);
} // prettier-ignore


var curriedShade = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(shade)));
var curriedShade$1 = (/* unused pure expression or super */ null && (curriedShade));

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  if (color === 'transparent') return color;
  return mix$1(parseFloat(percentage), 'rgb(255, 255, 255)', color);
} // prettier-ignore


var curriedTint = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(tint)));
var curriedTint$1 = (/* unused pure expression or super */ null && (curriedTint));

/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */

function transparentize(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
  });

  return rgba(colorWithAlpha);
} // prettier-ignore


var curriedTransparentize = /*#__PURE__*/(/* unused pure expression or super */ null && (curry
/* ::<number | string, string, string> */
(transparentize)));
var curriedTransparentize$1 = (/* unused pure expression or super */ null && (curriedTransparentize));

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);

  if (!multiMode && args.length > 8) {
    throw new PolishedError(64);
  }

  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new PolishedError(65);
    }

    if (Array.isArray(arg) && arg.length > 8) {
      throw new PolishedError(66);
    }

    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');
  return {
    animation: code
  };
}

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */
function backgroundImages() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    background: properties.join(', ')
  };
}

var sideMap = (/* unused pure expression or super */ null && (['top', 'right', 'bottom', 'left']));
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */

function border(sideKeyword) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (typeof sideKeyword === 'string' && sideMap.indexOf(sideKeyword) >= 0) {
    var _ref;

    return _ref = {}, _ref["border" + capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
  } else {
    values.unshift(sideKeyword);
    return {
      borderWidth: values[0],
      borderStyle: values[1],
      borderColor: values[2]
    };
  }
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */
function borderColor() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderColor'].concat(values));
}

/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */
function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);

  if (!radius && radius !== 0) {
    throw new PolishedError(62);
  }

  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
  }

  throw new PolishedError(63);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */
function borderStyle() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderStyle'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderWidth'].concat(values));
}

function generateSelectors(template, state) {
  var stateSuffix = state ? ":" + state : '';
  return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */


function statefulSelectors(states, template, stateMap) {
  if (!template) throw new PolishedError(67);
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];

  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new PolishedError(68);
    }

    selectors.push(generateSelectors(template, states[i]));
  }

  selectors = selectors.join(',');
  return selectors;
}

var stateMap$1 = (/* unused pure expression or super */ null && ([undefined, null, 'active', 'focus', 'hover']));

function template$1(state) {
  return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */


function buttons() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template$1, stateMap$1);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */
function margin() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['margin'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */
function padding() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['padding'].concat(values));
}

var positionMap = (/* unused pure expression or super */ null && (['absolute', 'fixed', 'relative', 'static', 'sticky']));
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */

function position(firstValue) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (positionMap.indexOf(firstValue) >= 0 && firstValue) {
    return _extends({}, directionalProperty.apply(void 0, [''].concat(values)), {
      position: firstValue
    });
  } else {
    return directionalProperty.apply(void 0, ['', firstValue].concat(values));
  }
}

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */
function size(height, width) {
  if (width === void 0) {
    width = height;
  }

  return {
    height: height,
    width: width
  };
}

var stateMap = (/* unused pure expression or super */ null && ([undefined, null, 'active', 'focus', 'hover']));

function template(state) {
  return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */


function textInputs() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template, stateMap);
}

/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */

function transitions() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  if (Array.isArray(properties[0]) && properties.length === 2) {
    var value = properties[1];

    if (typeof value !== 'string') {
      throw new PolishedError(61);
    }

    var transitionsString = properties[0].map(function (property) {
      return property + " " + value;
    }).join(', ');
    return {
      transition: transitionsString
    };
  } else {
    return {
      transition: properties.join(', ')
    };
  }
}




/***/ }),

/***/ 18267:
/***/ (function() {

Prism.languages.clike = {
	'comment': [
		{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: true,
			greedy: true
		},
		{
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: true,
			greedy: true
		}
	],
	'string': {
		pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
		greedy: true
	},
	'class-name': {
		pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
		lookbehind: true,
		inside: {
			'punctuation': /[.\\]/
		}
	},
	'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
	'boolean': /\b(?:false|true)\b/,
	'function': /\b\w+(?=\()/,
	'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
	'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
	'punctuation': /[{}[\];(),.:]/
};


/***/ }),

/***/ 53712:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/// <reference lib="WebWorker"/>

var _self = (typeof window !== 'undefined')
	? window   // if in browser
	: (
		(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
	);

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */
var Prism = (function (_self) {

	// Private helper vars
	var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
	var uniqueId = 0;

	// The grammar object for plaintext
	var plainTextGrammar = {};


	var _ = {
		/**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		manual: _self.Prism && _self.Prism.manual,
		/**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,

		/**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */
		util: {
			encode: function encode(tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, encode(tokens.content), tokens.alias);
				} else if (Array.isArray(tokens)) {
					return tokens.map(encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},

			/**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */
			type: function (o) {
				return Object.prototype.toString.call(o).slice(8, -1);
			},

			/**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},

			/**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */
			clone: function deepClone(o, visited) {
				visited = visited || {};

				var clone; var id;
				switch (_.util.type(o)) {
					case 'Object':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = /** @type {Record<string, any>} */ ({});
						visited[id] = clone;

						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = deepClone(o[key], visited);
							}
						}

						return /** @type {any} */ (clone);

					case 'Array':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = [];
						visited[id] = clone;

						(/** @type {Array} */(/** @type {any} */(o))).forEach(function (v, i) {
							clone[i] = deepClone(v, visited);
						});

						return /** @type {any} */ (clone);

					default:
						return o;
				}
			},

			/**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */
			getLanguage: function (element) {
				while (element) {
					var m = lang.exec(element.className);
					if (m) {
						return m[1].toLowerCase();
					}
					element = element.parentElement;
				}
				return 'none';
			},

			/**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */
			setLanguage: function (element, language) {
				// remove all `language-xxxx` classes
				// (this might leave behind a leading space)
				element.className = element.className.replace(RegExp(lang, 'gi'), '');

				// add the new `language-xxxx` class
				// (using `classList` will automatically clean up spaces for us)
				element.classList.add('language-' + language);
			},

			/**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */
			currentScript: function () {
				if (typeof document === 'undefined') {
					return null;
				}
				if ('currentScript' in document && 1 < 2 /* hack to trip TS' flow analysis */) {
					return /** @type {any} */ (document.currentScript);
				}

				// IE11 workaround
				// we'll get the src of the current script by parsing IE11's error stack trace
				// this will not work for inline scripts

				try {
					throw new Error();
				} catch (err) {
					// Get file src url from stack. Specifically works with the format of stack traces in IE.
					// A stack will look like this:
					//
					// Error
					//    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
					//    at Global code (http://localhost/components/prism-core.js:606:1)

					var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
					if (src) {
						var scripts = document.getElementsByTagName('script');
						for (var i in scripts) {
							if (scripts[i].src == src) {
								return scripts[i];
							}
						}
					}
					return null;
				}
			},

			/**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */
			isActive: function (element, className, defaultActivation) {
				var no = 'no-' + className;

				while (element) {
					var classList = element.classList;
					if (classList.contains(className)) {
						return true;
					}
					if (classList.contains(no)) {
						return false;
					}
					element = element.parentElement;
				}
				return !!defaultActivation;
			}
		},

		/**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		languages: {
			/**
			 * The grammar for plain, unformatted text.
			 */
			plain: plainTextGrammar,
			plaintext: plainTextGrammar,
			text: plainTextGrammar,
			txt: plainTextGrammar,

			/**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);

				for (var key in redef) {
					lang[key] = redef[key];
				}

				return lang;
			},

			/**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || /** @type {any} */ (_.languages);
				var grammar = root[inside];
				/** @type {Grammar} */
				var ret = {};

				for (var token in grammar) {
					if (grammar.hasOwnProperty(token)) {

						if (token == before) {
							for (var newToken in insert) {
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}

						// Do not insert token which also occur in insert. See #1525
						if (!insert.hasOwnProperty(token)) {
							ret[token] = grammar[token];
						}
					}
				}

				var old = root[inside];
				root[inside] = ret;

				// Update references in other language definitions
				_.languages.DFS(_.languages, function (key, value) {
					if (value === old && key != inside) {
						this[key] = ret;
					}
				});

				return ret;
			},

			// Traverse a language definition with Depth First Search
			DFS: function DFS(o, callback, type, visited) {
				visited = visited || {};

				var objId = _.util.objId;

				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);

						var property = o[i];
						var propertyType = _.util.type(property);

						if (propertyType === 'Object' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, null, visited);
						} else if (propertyType === 'Array' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, i, visited);
						}
					}
				}
			}
		},

		plugins: {},

		/**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */
		highlightAll: function (async, callback) {
			_.highlightAllUnder(document, async, callback);
		},

		/**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */
		highlightAllUnder: function (container, async, callback) {
			var env = {
				callback: callback,
				container: container,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};

			_.hooks.run('before-highlightall', env);

			env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));

			_.hooks.run('before-all-elements-highlight', env);

			for (var i = 0, element; (element = env.elements[i++]);) {
				_.highlightElement(element, async === true, env.callback);
			}
		},

		/**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */
		highlightElement: function (element, async, callback) {
			// Find language
			var language = _.util.getLanguage(element);
			var grammar = _.languages[language];

			// Set language on the element, if not present
			_.util.setLanguage(element, language);

			// Set language on the parent, for styling
			var parent = element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre') {
				_.util.setLanguage(parent, language);
			}

			var code = element.textContent;

			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};

			function insertHighlightedCode(highlightedCode) {
				env.highlightedCode = highlightedCode;

				_.hooks.run('before-insert', env);

				env.element.innerHTML = env.highlightedCode;

				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
			}

			_.hooks.run('before-sanity-check', env);

			// plugins may change/add the parent/element
			parent = env.element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) {
				parent.setAttribute('tabindex', '0');
			}

			if (!env.code) {
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
				return;
			}

			_.hooks.run('before-highlight', env);

			if (!env.grammar) {
				insertHighlightedCode(_.util.encode(env.code));
				return;
			}

			if (async && _self.Worker) {
				var worker = new Worker(_.filename);

				worker.onmessage = function (evt) {
					insertHighlightedCode(evt.data);
				};

				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			} else {
				insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
			}
		},

		/**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			if (!env.grammar) {
				throw new Error('The language "' + env.language + '" has no grammar.');
			}
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},

		/**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */
		tokenize: function (text, grammar) {
			var rest = grammar.rest;
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}

				delete grammar.rest;
			}

			var tokenList = new LinkedList();
			addAfter(tokenList, tokenList.head, text);

			matchGrammar(text, tokenList, grammar, tokenList.head, 0);

			return toArray(tokenList);
		},

		/**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		hooks: {
			all: {},

			/**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */
			add: function (name, callback) {
				var hooks = _.hooks.all;

				hooks[name] = hooks[name] || [];

				hooks[name].push(callback);
			},

			/**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */
			run: function (name, env) {
				var callbacks = _.hooks.all[name];

				if (!callbacks || !callbacks.length) {
					return;
				}

				for (var i = 0, callback; (callback = callbacks[i++]);) {
					callback(env);
				}
			}
		},

		Token: Token
	};
	_self.Prism = _;


	// Typescript note:
	// The following can be used to import the Token type in JSDoc:
	//
	//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token

	/**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */
	function Token(type, content, alias, matchedStr) {
		/**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */
		this.type = type;
		/**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */
		this.content = content;
		/**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || '').length | 0;
	}

	/**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */

	/**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */
	Token.stringify = function stringify(o, language) {
		if (typeof o == 'string') {
			return o;
		}
		if (Array.isArray(o)) {
			var s = '';
			o.forEach(function (e) {
				s += stringify(e, language);
			});
			return s;
		}

		var env = {
			type: o.type,
			content: stringify(o.content, language),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language
		};

		var aliases = o.alias;
		if (aliases) {
			if (Array.isArray(aliases)) {
				Array.prototype.push.apply(env.classes, aliases);
			} else {
				env.classes.push(aliases);
			}
		}

		_.hooks.run('wrap', env);

		var attributes = '';
		for (var name in env.attributes) {
			attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}

		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
	};

	/**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */
	function matchPattern(pattern, pos, text, lookbehind) {
		pattern.lastIndex = pos;
		var match = pattern.exec(text);
		if (match && lookbehind && match[1]) {
			// change the match to remove the text matched by the Prism lookbehind group
			var lookbehindLength = match[1].length;
			match.index += lookbehindLength;
			match[0] = match[0].slice(lookbehindLength);
		}
		return match;
	}

	/**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */
	function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
		for (var token in grammar) {
			if (!grammar.hasOwnProperty(token) || !grammar[token]) {
				continue;
			}

			var patterns = grammar[token];
			patterns = Array.isArray(patterns) ? patterns : [patterns];

			for (var j = 0; j < patterns.length; ++j) {
				if (rematch && rematch.cause == token + ',' + j) {
					return;
				}

				var patternObj = patterns[j];
				var inside = patternObj.inside;
				var lookbehind = !!patternObj.lookbehind;
				var greedy = !!patternObj.greedy;
				var alias = patternObj.alias;

				if (greedy && !patternObj.pattern.global) {
					// Without the global flag, lastIndex won't work
					var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
					patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
				}

				/** @type {RegExp} */
				var pattern = patternObj.pattern || patternObj;

				for ( // iterate the token list and keep track of the current token/string position
					var currentNode = startNode.next, pos = startPos;
					currentNode !== tokenList.tail;
					pos += currentNode.value.length, currentNode = currentNode.next
				) {

					if (rematch && pos >= rematch.reach) {
						break;
					}

					var str = currentNode.value;

					if (tokenList.length > text.length) {
						// Something went terribly wrong, ABORT, ABORT!
						return;
					}

					if (str instanceof Token) {
						continue;
					}

					var removeCount = 1; // this is the to parameter of removeBetween
					var match;

					if (greedy) {
						match = matchPattern(pattern, pos, text, lookbehind);
						if (!match || match.index >= text.length) {
							break;
						}

						var from = match.index;
						var to = match.index + match[0].length;
						var p = pos;

						// find the node that contains the match
						p += currentNode.value.length;
						while (from >= p) {
							currentNode = currentNode.next;
							p += currentNode.value.length;
						}
						// adjust pos (and p)
						p -= currentNode.value.length;
						pos = p;

						// the current node is a Token, then the match starts inside another Token, which is invalid
						if (currentNode.value instanceof Token) {
							continue;
						}

						// find the last node which is affected by this match
						for (
							var k = currentNode;
							k !== tokenList.tail && (p < to || typeof k.value === 'string');
							k = k.next
						) {
							removeCount++;
							p += k.value.length;
						}
						removeCount--;

						// replace with the new match
						str = text.slice(pos, p);
						match.index -= pos;
					} else {
						match = matchPattern(pattern, 0, str, lookbehind);
						if (!match) {
							continue;
						}
					}

					// eslint-disable-next-line no-redeclare
					var from = match.index;
					var matchStr = match[0];
					var before = str.slice(0, from);
					var after = str.slice(from + matchStr.length);

					var reach = pos + str.length;
					if (rematch && reach > rematch.reach) {
						rematch.reach = reach;
					}

					var removeFrom = currentNode.prev;

					if (before) {
						removeFrom = addAfter(tokenList, removeFrom, before);
						pos += before.length;
					}

					removeRange(tokenList, removeFrom, removeCount);

					var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
					currentNode = addAfter(tokenList, removeFrom, wrapped);

					if (after) {
						addAfter(tokenList, currentNode, after);
					}

					if (removeCount > 1) {
						// at least one Token object was removed, so we have to do some rematching
						// this can only happen if the current pattern is greedy

						/** @type {RematchOptions} */
						var nestedRematch = {
							cause: token + ',' + j,
							reach: reach
						};
						matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);

						// the reach might have been extended because of the rematching
						if (rematch && nestedRematch.reach > rematch.reach) {
							rematch.reach = nestedRematch.reach;
						}
					}
				}
			}
		}
	}

	/**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */

	/**
	 * @template T
	 * @private
	 */
	function LinkedList() {
		/** @type {LinkedListNode<T>} */
		var head = { value: null, prev: null, next: null };
		/** @type {LinkedListNode<T>} */
		var tail = { value: null, prev: head, next: null };
		head.next = tail;

		/** @type {LinkedListNode<T>} */
		this.head = head;
		/** @type {LinkedListNode<T>} */
		this.tail = tail;
		this.length = 0;
	}

	/**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */
	function addAfter(list, node, value) {
		// assumes that node != list.tail && values.length >= 0
		var next = node.next;

		var newNode = { value: value, prev: node, next: next };
		node.next = newNode;
		next.prev = newNode;
		list.length++;

		return newNode;
	}
	/**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */
	function removeRange(list, node, count) {
		var next = node.next;
		for (var i = 0; i < count && next !== list.tail; i++) {
			next = next.next;
		}
		node.next = next;
		next.prev = node;
		list.length -= i;
	}
	/**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */
	function toArray(list) {
		var array = [];
		var node = list.head.next;
		while (node !== list.tail) {
			array.push(node.value);
			node = node.next;
		}
		return array;
	}


	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _;
		}

		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data);
				var lang = message.language;
				var code = message.code;
				var immediateClose = message.immediateClose;

				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}

		return _;
	}

	// Get current script and highlight
	var script = _.util.currentScript();

	if (script) {
		_.filename = script.src;

		if (script.hasAttribute('data-manual')) {
			_.manual = true;
		}
	}

	function highlightAutomaticallyCallback() {
		if (!_.manual) {
			_.highlightAll();
		}
	}

	if (!_.manual) {
		// If the document state is "loading", then we'll use DOMContentLoaded.
		// If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
		// DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
		// might take longer one animation frame to execute which can create a race condition where only some plugins have
		// been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
		// See https://github.com/PrismJS/prism/issues/2102
		var readyState = document.readyState;
		if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) {
			document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
		} else {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(highlightAutomaticallyCallback);
			} else {
				window.setTimeout(highlightAutomaticallyCallback, 16);
			}
		}
	}

	return _;

}(_self));

if ( true && module.exports) {
	module.exports = Prism;
}

// hack for components to work correctly in node.js
if (typeof __webpack_require__.g !== 'undefined') {
	__webpack_require__.g.Prism = Prism;
}

// some additional documentation/types

/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */

/**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */

/**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */

/**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */


/***/ }),

/***/ 64883:
/***/ (function() {

Prism.languages.javascript = Prism.languages.extend('clike', {
	'class-name': [
		Prism.languages.clike['class-name'],
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
			lookbehind: true
		}
	],
	'keyword': [
		{
			pattern: /((?:^|\})\s*)catch\b/,
			lookbehind: true
		},
		{
			pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: true
		},
	],
	// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	'number': {
		pattern: RegExp(
			/(^|[^\w$])/.source +
			'(?:' +
			(
				// constant
				/NaN|Infinity/.source +
				'|' +
				// binary integer
				/0[bB][01]+(?:_[01]+)*n?/.source +
				'|' +
				// octal integer
				/0[oO][0-7]+(?:_[0-7]+)*n?/.source +
				'|' +
				// hexadecimal integer
				/0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source +
				'|' +
				// decimal bigint
				/\d+(?:_\d+)*n/.source +
				'|' +
				// decimal number (integer or float) but no bigint
				/(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source
			) +
			')' +
			/(?![\w$])/.source
		),
		lookbehind: true
	},
	'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});

Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;

Prism.languages.insertBefore('javascript', 'keyword', {
	'regex': {
		pattern: RegExp(
			// lookbehind
			// eslint-disable-next-line regexp/no-dupe-characters-character-class
			/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source +
			// Regex pattern:
			// There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
			// classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
			// with the only syntax, so we have to define 2 different regex patterns.
			/\//.source +
			'(?:' +
			/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source +
			'|' +
			// `v` flag syntax. This supports 3 levels of nested character classes.
			/(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source +
			')' +
			// lookahead
			/(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
		),
		lookbehind: true,
		greedy: true,
		inside: {
			'regex-source': {
				pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
				lookbehind: true,
				alias: 'language-regex',
				inside: Prism.languages.regex
			},
			'regex-delimiter': /^\/|\/$/,
			'regex-flags': /^[a-z]+$/,
		}
	},
	// This must be declared before keyword because we use "function" inside the look-forward
	'function-variable': {
		pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
		alias: 'function'
	},
	'parameter': [
		{
			pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		}
	],
	'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});

Prism.languages.insertBefore('javascript', 'string', {
	'hashbang': {
		pattern: /^#!.*/,
		greedy: true,
		alias: 'comment'
	},
	'template-string': {
		pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
		greedy: true,
		inside: {
			'template-punctuation': {
				pattern: /^`|`$/,
				alias: 'string'
			},
			'interpolation': {
				pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
				lookbehind: true,
				inside: {
					'interpolation-punctuation': {
						pattern: /^\$\{|\}$/,
						alias: 'punctuation'
					},
					rest: Prism.languages.javascript
				}
			},
			'string': /[\s\S]+/
		}
	},
	'string-property': {
		pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
		lookbehind: true,
		greedy: true,
		alias: 'property'
	}
});

Prism.languages.insertBefore('javascript', 'operator', {
	'literal-property': {
		pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
		lookbehind: true,
		alias: 'property'
	},
});

if (Prism.languages.markup) {
	Prism.languages.markup.tag.addInlined('script', 'javascript');

	// add attribute support for all DOM events.
	// https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
	Prism.languages.markup.tag.addAttribute(
		/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
		'javascript'
	);
}

Prism.languages.js = Prism.languages.javascript;


/***/ }),

/***/ 62363:
/***/ (function() {

// https://www.json.org/json-en.html
Prism.languages.json = {
	'property': {
		pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
		lookbehind: true,
		greedy: true
	},
	'string': {
		pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
		lookbehind: true,
		greedy: true
	},
	'comment': {
		pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
		greedy: true
	},
	'number': /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
	'punctuation': /[{}[\],]/,
	'operator': /:/,
	'boolean': /\b(?:false|true)\b/,
	'null': {
		pattern: /\bnull\b/,
		alias: 'keyword'
	}
};

Prism.languages.webmanifest = Prism.languages.json;


/***/ }),

/***/ 18476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/* **********************************************
     Begin prism-core.js
********************************************** */

/// <reference lib="WebWorker"/>

var _self = (typeof window !== 'undefined')
	? window   // if in browser
	: (
		(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
	);

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */
var Prism = (function (_self) {

	// Private helper vars
	var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
	var uniqueId = 0;

	// The grammar object for plaintext
	var plainTextGrammar = {};


	var _ = {
		/**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		manual: _self.Prism && _self.Prism.manual,
		/**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,

		/**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */
		util: {
			encode: function encode(tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, encode(tokens.content), tokens.alias);
				} else if (Array.isArray(tokens)) {
					return tokens.map(encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},

			/**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */
			type: function (o) {
				return Object.prototype.toString.call(o).slice(8, -1);
			},

			/**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},

			/**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */
			clone: function deepClone(o, visited) {
				visited = visited || {};

				var clone; var id;
				switch (_.util.type(o)) {
					case 'Object':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = /** @type {Record<string, any>} */ ({});
						visited[id] = clone;

						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = deepClone(o[key], visited);
							}
						}

						return /** @type {any} */ (clone);

					case 'Array':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = [];
						visited[id] = clone;

						(/** @type {Array} */(/** @type {any} */(o))).forEach(function (v, i) {
							clone[i] = deepClone(v, visited);
						});

						return /** @type {any} */ (clone);

					default:
						return o;
				}
			},

			/**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */
			getLanguage: function (element) {
				while (element) {
					var m = lang.exec(element.className);
					if (m) {
						return m[1].toLowerCase();
					}
					element = element.parentElement;
				}
				return 'none';
			},

			/**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */
			setLanguage: function (element, language) {
				// remove all `language-xxxx` classes
				// (this might leave behind a leading space)
				element.className = element.className.replace(RegExp(lang, 'gi'), '');

				// add the new `language-xxxx` class
				// (using `classList` will automatically clean up spaces for us)
				element.classList.add('language-' + language);
			},

			/**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */
			currentScript: function () {
				if (typeof document === 'undefined') {
					return null;
				}
				if ('currentScript' in document && 1 < 2 /* hack to trip TS' flow analysis */) {
					return /** @type {any} */ (document.currentScript);
				}

				// IE11 workaround
				// we'll get the src of the current script by parsing IE11's error stack trace
				// this will not work for inline scripts

				try {
					throw new Error();
				} catch (err) {
					// Get file src url from stack. Specifically works with the format of stack traces in IE.
					// A stack will look like this:
					//
					// Error
					//    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
					//    at Global code (http://localhost/components/prism-core.js:606:1)

					var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
					if (src) {
						var scripts = document.getElementsByTagName('script');
						for (var i in scripts) {
							if (scripts[i].src == src) {
								return scripts[i];
							}
						}
					}
					return null;
				}
			},

			/**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */
			isActive: function (element, className, defaultActivation) {
				var no = 'no-' + className;

				while (element) {
					var classList = element.classList;
					if (classList.contains(className)) {
						return true;
					}
					if (classList.contains(no)) {
						return false;
					}
					element = element.parentElement;
				}
				return !!defaultActivation;
			}
		},

		/**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		languages: {
			/**
			 * The grammar for plain, unformatted text.
			 */
			plain: plainTextGrammar,
			plaintext: plainTextGrammar,
			text: plainTextGrammar,
			txt: plainTextGrammar,

			/**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);

				for (var key in redef) {
					lang[key] = redef[key];
				}

				return lang;
			},

			/**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || /** @type {any} */ (_.languages);
				var grammar = root[inside];
				/** @type {Grammar} */
				var ret = {};

				for (var token in grammar) {
					if (grammar.hasOwnProperty(token)) {

						if (token == before) {
							for (var newToken in insert) {
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}

						// Do not insert token which also occur in insert. See #1525
						if (!insert.hasOwnProperty(token)) {
							ret[token] = grammar[token];
						}
					}
				}

				var old = root[inside];
				root[inside] = ret;

				// Update references in other language definitions
				_.languages.DFS(_.languages, function (key, value) {
					if (value === old && key != inside) {
						this[key] = ret;
					}
				});

				return ret;
			},

			// Traverse a language definition with Depth First Search
			DFS: function DFS(o, callback, type, visited) {
				visited = visited || {};

				var objId = _.util.objId;

				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);

						var property = o[i];
						var propertyType = _.util.type(property);

						if (propertyType === 'Object' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, null, visited);
						} else if (propertyType === 'Array' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, i, visited);
						}
					}
				}
			}
		},

		plugins: {},

		/**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */
		highlightAll: function (async, callback) {
			_.highlightAllUnder(document, async, callback);
		},

		/**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */
		highlightAllUnder: function (container, async, callback) {
			var env = {
				callback: callback,
				container: container,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};

			_.hooks.run('before-highlightall', env);

			env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));

			_.hooks.run('before-all-elements-highlight', env);

			for (var i = 0, element; (element = env.elements[i++]);) {
				_.highlightElement(element, async === true, env.callback);
			}
		},

		/**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */
		highlightElement: function (element, async, callback) {
			// Find language
			var language = _.util.getLanguage(element);
			var grammar = _.languages[language];

			// Set language on the element, if not present
			_.util.setLanguage(element, language);

			// Set language on the parent, for styling
			var parent = element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre') {
				_.util.setLanguage(parent, language);
			}

			var code = element.textContent;

			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};

			function insertHighlightedCode(highlightedCode) {
				env.highlightedCode = highlightedCode;

				_.hooks.run('before-insert', env);

				env.element.innerHTML = env.highlightedCode;

				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
			}

			_.hooks.run('before-sanity-check', env);

			// plugins may change/add the parent/element
			parent = env.element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) {
				parent.setAttribute('tabindex', '0');
			}

			if (!env.code) {
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
				return;
			}

			_.hooks.run('before-highlight', env);

			if (!env.grammar) {
				insertHighlightedCode(_.util.encode(env.code));
				return;
			}

			if (async && _self.Worker) {
				var worker = new Worker(_.filename);

				worker.onmessage = function (evt) {
					insertHighlightedCode(evt.data);
				};

				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			} else {
				insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
			}
		},

		/**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			if (!env.grammar) {
				throw new Error('The language "' + env.language + '" has no grammar.');
			}
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},

		/**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */
		tokenize: function (text, grammar) {
			var rest = grammar.rest;
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}

				delete grammar.rest;
			}

			var tokenList = new LinkedList();
			addAfter(tokenList, tokenList.head, text);

			matchGrammar(text, tokenList, grammar, tokenList.head, 0);

			return toArray(tokenList);
		},

		/**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		hooks: {
			all: {},

			/**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */
			add: function (name, callback) {
				var hooks = _.hooks.all;

				hooks[name] = hooks[name] || [];

				hooks[name].push(callback);
			},

			/**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */
			run: function (name, env) {
				var callbacks = _.hooks.all[name];

				if (!callbacks || !callbacks.length) {
					return;
				}

				for (var i = 0, callback; (callback = callbacks[i++]);) {
					callback(env);
				}
			}
		},

		Token: Token
	};
	_self.Prism = _;


	// Typescript note:
	// The following can be used to import the Token type in JSDoc:
	//
	//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token

	/**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */
	function Token(type, content, alias, matchedStr) {
		/**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */
		this.type = type;
		/**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */
		this.content = content;
		/**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || '').length | 0;
	}

	/**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */

	/**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */
	Token.stringify = function stringify(o, language) {
		if (typeof o == 'string') {
			return o;
		}
		if (Array.isArray(o)) {
			var s = '';
			o.forEach(function (e) {
				s += stringify(e, language);
			});
			return s;
		}

		var env = {
			type: o.type,
			content: stringify(o.content, language),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language
		};

		var aliases = o.alias;
		if (aliases) {
			if (Array.isArray(aliases)) {
				Array.prototype.push.apply(env.classes, aliases);
			} else {
				env.classes.push(aliases);
			}
		}

		_.hooks.run('wrap', env);

		var attributes = '';
		for (var name in env.attributes) {
			attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}

		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
	};

	/**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */
	function matchPattern(pattern, pos, text, lookbehind) {
		pattern.lastIndex = pos;
		var match = pattern.exec(text);
		if (match && lookbehind && match[1]) {
			// change the match to remove the text matched by the Prism lookbehind group
			var lookbehindLength = match[1].length;
			match.index += lookbehindLength;
			match[0] = match[0].slice(lookbehindLength);
		}
		return match;
	}

	/**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */
	function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
		for (var token in grammar) {
			if (!grammar.hasOwnProperty(token) || !grammar[token]) {
				continue;
			}

			var patterns = grammar[token];
			patterns = Array.isArray(patterns) ? patterns : [patterns];

			for (var j = 0; j < patterns.length; ++j) {
				if (rematch && rematch.cause == token + ',' + j) {
					return;
				}

				var patternObj = patterns[j];
				var inside = patternObj.inside;
				var lookbehind = !!patternObj.lookbehind;
				var greedy = !!patternObj.greedy;
				var alias = patternObj.alias;

				if (greedy && !patternObj.pattern.global) {
					// Without the global flag, lastIndex won't work
					var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
					patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
				}

				/** @type {RegExp} */
				var pattern = patternObj.pattern || patternObj;

				for ( // iterate the token list and keep track of the current token/string position
					var currentNode = startNode.next, pos = startPos;
					currentNode !== tokenList.tail;
					pos += currentNode.value.length, currentNode = currentNode.next
				) {

					if (rematch && pos >= rematch.reach) {
						break;
					}

					var str = currentNode.value;

					if (tokenList.length > text.length) {
						// Something went terribly wrong, ABORT, ABORT!
						return;
					}

					if (str instanceof Token) {
						continue;
					}

					var removeCount = 1; // this is the to parameter of removeBetween
					var match;

					if (greedy) {
						match = matchPattern(pattern, pos, text, lookbehind);
						if (!match || match.index >= text.length) {
							break;
						}

						var from = match.index;
						var to = match.index + match[0].length;
						var p = pos;

						// find the node that contains the match
						p += currentNode.value.length;
						while (from >= p) {
							currentNode = currentNode.next;
							p += currentNode.value.length;
						}
						// adjust pos (and p)
						p -= currentNode.value.length;
						pos = p;

						// the current node is a Token, then the match starts inside another Token, which is invalid
						if (currentNode.value instanceof Token) {
							continue;
						}

						// find the last node which is affected by this match
						for (
							var k = currentNode;
							k !== tokenList.tail && (p < to || typeof k.value === 'string');
							k = k.next
						) {
							removeCount++;
							p += k.value.length;
						}
						removeCount--;

						// replace with the new match
						str = text.slice(pos, p);
						match.index -= pos;
					} else {
						match = matchPattern(pattern, 0, str, lookbehind);
						if (!match) {
							continue;
						}
					}

					// eslint-disable-next-line no-redeclare
					var from = match.index;
					var matchStr = match[0];
					var before = str.slice(0, from);
					var after = str.slice(from + matchStr.length);

					var reach = pos + str.length;
					if (rematch && reach > rematch.reach) {
						rematch.reach = reach;
					}

					var removeFrom = currentNode.prev;

					if (before) {
						removeFrom = addAfter(tokenList, removeFrom, before);
						pos += before.length;
					}

					removeRange(tokenList, removeFrom, removeCount);

					var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
					currentNode = addAfter(tokenList, removeFrom, wrapped);

					if (after) {
						addAfter(tokenList, currentNode, after);
					}

					if (removeCount > 1) {
						// at least one Token object was removed, so we have to do some rematching
						// this can only happen if the current pattern is greedy

						/** @type {RematchOptions} */
						var nestedRematch = {
							cause: token + ',' + j,
							reach: reach
						};
						matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);

						// the reach might have been extended because of the rematching
						if (rematch && nestedRematch.reach > rematch.reach) {
							rematch.reach = nestedRematch.reach;
						}
					}
				}
			}
		}
	}

	/**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */

	/**
	 * @template T
	 * @private
	 */
	function LinkedList() {
		/** @type {LinkedListNode<T>} */
		var head = { value: null, prev: null, next: null };
		/** @type {LinkedListNode<T>} */
		var tail = { value: null, prev: head, next: null };
		head.next = tail;

		/** @type {LinkedListNode<T>} */
		this.head = head;
		/** @type {LinkedListNode<T>} */
		this.tail = tail;
		this.length = 0;
	}

	/**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */
	function addAfter(list, node, value) {
		// assumes that node != list.tail && values.length >= 0
		var next = node.next;

		var newNode = { value: value, prev: node, next: next };
		node.next = newNode;
		next.prev = newNode;
		list.length++;

		return newNode;
	}
	/**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */
	function removeRange(list, node, count) {
		var next = node.next;
		for (var i = 0; i < count && next !== list.tail; i++) {
			next = next.next;
		}
		node.next = next;
		next.prev = node;
		list.length -= i;
	}
	/**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */
	function toArray(list) {
		var array = [];
		var node = list.head.next;
		while (node !== list.tail) {
			array.push(node.value);
			node = node.next;
		}
		return array;
	}


	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _;
		}

		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data);
				var lang = message.language;
				var code = message.code;
				var immediateClose = message.immediateClose;

				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}

		return _;
	}

	// Get current script and highlight
	var script = _.util.currentScript();

	if (script) {
		_.filename = script.src;

		if (script.hasAttribute('data-manual')) {
			_.manual = true;
		}
	}

	function highlightAutomaticallyCallback() {
		if (!_.manual) {
			_.highlightAll();
		}
	}

	if (!_.manual) {
		// If the document state is "loading", then we'll use DOMContentLoaded.
		// If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
		// DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
		// might take longer one animation frame to execute which can create a race condition where only some plugins have
		// been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
		// See https://github.com/PrismJS/prism/issues/2102
		var readyState = document.readyState;
		if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) {
			document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
		} else {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(highlightAutomaticallyCallback);
			} else {
				window.setTimeout(highlightAutomaticallyCallback, 16);
			}
		}
	}

	return _;

}(_self));

if ( true && module.exports) {
	module.exports = Prism;
}

// hack for components to work correctly in node.js
if (typeof __webpack_require__.g !== 'undefined') {
	__webpack_require__.g.Prism = Prism;
}

// some additional documentation/types

/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */

/**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */

/**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */

/**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */


/* **********************************************
     Begin prism-markup.js
********************************************** */

Prism.languages.markup = {
	'comment': {
		pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
		greedy: true
	},
	'prolog': {
		pattern: /<\?[\s\S]+?\?>/,
		greedy: true
	},
	'doctype': {
		// https://www.w3.org/TR/xml/#NT-doctypedecl
		pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
		greedy: true,
		inside: {
			'internal-subset': {
				pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
				lookbehind: true,
				greedy: true,
				inside: null // see below
			},
			'string': {
				pattern: /"[^"]*"|'[^']*'/,
				greedy: true
			},
			'punctuation': /^<!|>$|[[\]]/,
			'doctype-tag': /^DOCTYPE/i,
			'name': /[^\s<>'"]+/
		}
	},
	'cdata': {
		pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
		greedy: true
	},
	'tag': {
		pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
		greedy: true,
		inside: {
			'tag': {
				pattern: /^<\/?[^\s>\/]+/,
				inside: {
					'punctuation': /^<\/?/,
					'namespace': /^[^\s>\/:]+:/
				}
			},
			'special-attr': [],
			'attr-value': {
				pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
				inside: {
					'punctuation': [
						{
							pattern: /^=/,
							alias: 'attr-equals'
						},
						/"|'/
					]
				}
			},
			'punctuation': /\/?>/,
			'attr-name': {
				pattern: /[^\s>\/]+/,
				inside: {
					'namespace': /^[^\s>\/:]+:/
				}
			}

		}
	},
	'entity': [
		{
			pattern: /&[\da-z]{1,8};/i,
			alias: 'named-entity'
		},
		/&#x?[\da-f]{1,8};/i
	]
};

Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
	Prism.languages.markup['entity'];
Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;

// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function (env) {

	if (env.type === 'entity') {
		env.attributes['title'] = env.content.replace(/&amp;/, '&');
	}
});

Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
	/**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */
	value: function addInlined(tagName, lang) {
		var includedCdataInside = {};
		includedCdataInside['language-' + lang] = {
			pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
			lookbehind: true,
			inside: Prism.languages[lang]
		};
		includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;

		var inside = {
			'included-cdata': {
				pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
				inside: includedCdataInside
			}
		};
		inside['language-' + lang] = {
			pattern: /[\s\S]+/,
			inside: Prism.languages[lang]
		};

		var def = {};
		def[tagName] = {
			pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () { return tagName; }), 'i'),
			lookbehind: true,
			greedy: true,
			inside: inside
		};

		Prism.languages.insertBefore('markup', 'cdata', def);
	}
});
Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
	/**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */
	value: function (attrName, lang) {
		Prism.languages.markup.tag.inside['special-attr'].push({
			pattern: RegExp(
				/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
				'i'
			),
			lookbehind: true,
			inside: {
				'attr-name': /^[^\s=]+/,
				'attr-value': {
					pattern: /=[\s\S]+/,
					inside: {
						'value': {
							pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
							lookbehind: true,
							alias: [lang, 'language-' + lang],
							inside: Prism.languages[lang]
						},
						'punctuation': [
							{
								pattern: /^=/,
								alias: 'attr-equals'
							},
							/"|'/
						]
					}
				}
			}
		});
	}
});

Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;

Prism.languages.xml = Prism.languages.extend('markup', {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;


/* **********************************************
     Begin prism-css.js
********************************************** */

(function (Prism) {

	var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;

	Prism.languages.css = {
		'comment': /\/\*[\s\S]*?\*\//,
		'atrule': {
			pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
			inside: {
				'rule': /^@[\w-]+/,
				'selector-function-argument': {
					pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
					lookbehind: true,
					alias: 'selector'
				},
				'keyword': {
					pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
					lookbehind: true
				}
				// See rest below
			}
		},
		'url': {
			// https://drafts.csswg.org/css-values-3/#urls
			pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
			greedy: true,
			inside: {
				'function': /^url/i,
				'punctuation': /^\(|\)$/,
				'string': {
					pattern: RegExp('^' + string.source + '$'),
					alias: 'url'
				}
			}
		},
		'selector': {
			pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
			lookbehind: true
		},
		'string': {
			pattern: string,
			greedy: true
		},
		'property': {
			pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
			lookbehind: true
		},
		'important': /!important\b/i,
		'function': {
			pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
			lookbehind: true
		},
		'punctuation': /[(){};:,]/
	};

	Prism.languages.css['atrule'].inside.rest = Prism.languages.css;

	var markup = Prism.languages.markup;
	if (markup) {
		markup.tag.addInlined('style', 'css');
		markup.tag.addAttribute('style', 'css');
	}

}(Prism));


/* **********************************************
     Begin prism-clike.js
********************************************** */

Prism.languages.clike = {
	'comment': [
		{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: true,
			greedy: true
		},
		{
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: true,
			greedy: true
		}
	],
	'string': {
		pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
		greedy: true
	},
	'class-name': {
		pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
		lookbehind: true,
		inside: {
			'punctuation': /[.\\]/
		}
	},
	'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
	'boolean': /\b(?:false|true)\b/,
	'function': /\b\w+(?=\()/,
	'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
	'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
	'punctuation': /[{}[\];(),.:]/
};


/* **********************************************
     Begin prism-javascript.js
********************************************** */

Prism.languages.javascript = Prism.languages.extend('clike', {
	'class-name': [
		Prism.languages.clike['class-name'],
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
			lookbehind: true
		}
	],
	'keyword': [
		{
			pattern: /((?:^|\})\s*)catch\b/,
			lookbehind: true
		},
		{
			pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: true
		},
	],
	// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	'number': {
		pattern: RegExp(
			/(^|[^\w$])/.source +
			'(?:' +
			(
				// constant
				/NaN|Infinity/.source +
				'|' +
				// binary integer
				/0[bB][01]+(?:_[01]+)*n?/.source +
				'|' +
				// octal integer
				/0[oO][0-7]+(?:_[0-7]+)*n?/.source +
				'|' +
				// hexadecimal integer
				/0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source +
				'|' +
				// decimal bigint
				/\d+(?:_\d+)*n/.source +
				'|' +
				// decimal number (integer or float) but no bigint
				/(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source
			) +
			')' +
			/(?![\w$])/.source
		),
		lookbehind: true
	},
	'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});

Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;

Prism.languages.insertBefore('javascript', 'keyword', {
	'regex': {
		pattern: RegExp(
			// lookbehind
			// eslint-disable-next-line regexp/no-dupe-characters-character-class
			/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source +
			// Regex pattern:
			// There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
			// classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
			// with the only syntax, so we have to define 2 different regex patterns.
			/\//.source +
			'(?:' +
			/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source +
			'|' +
			// `v` flag syntax. This supports 3 levels of nested character classes.
			/(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source +
			')' +
			// lookahead
			/(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
		),
		lookbehind: true,
		greedy: true,
		inside: {
			'regex-source': {
				pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
				lookbehind: true,
				alias: 'language-regex',
				inside: Prism.languages.regex
			},
			'regex-delimiter': /^\/|\/$/,
			'regex-flags': /^[a-z]+$/,
		}
	},
	// This must be declared before keyword because we use "function" inside the look-forward
	'function-variable': {
		pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
		alias: 'function'
	},
	'parameter': [
		{
			pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		}
	],
	'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});

Prism.languages.insertBefore('javascript', 'string', {
	'hashbang': {
		pattern: /^#!.*/,
		greedy: true,
		alias: 'comment'
	},
	'template-string': {
		pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
		greedy: true,
		inside: {
			'template-punctuation': {
				pattern: /^`|`$/,
				alias: 'string'
			},
			'interpolation': {
				pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
				lookbehind: true,
				inside: {
					'interpolation-punctuation': {
						pattern: /^\$\{|\}$/,
						alias: 'punctuation'
					},
					rest: Prism.languages.javascript
				}
			},
			'string': /[\s\S]+/
		}
	},
	'string-property': {
		pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
		lookbehind: true,
		greedy: true,
		alias: 'property'
	}
});

Prism.languages.insertBefore('javascript', 'operator', {
	'literal-property': {
		pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
		lookbehind: true,
		alias: 'property'
	},
});

if (Prism.languages.markup) {
	Prism.languages.markup.tag.addInlined('script', 'javascript');

	// add attribute support for all DOM events.
	// https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
	Prism.languages.markup.tag.addAttribute(
		/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
		'javascript'
	);
}

Prism.languages.js = Prism.languages.javascript;


/* **********************************************
     Begin prism-file-highlight.js
********************************************** */

(function () {

	if (typeof Prism === 'undefined' || typeof document === 'undefined') {
		return;
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}

	var LOADING_MESSAGE = 'Loading…';
	var FAILURE_MESSAGE = function (status, message) {
		return '✖ Error ' + status + ' while fetching file: ' + message;
	};
	var FAILURE_EMPTY_MESSAGE = '✖ Error: File does not exist or is empty';

	var EXTENSIONS = {
		'js': 'javascript',
		'py': 'python',
		'rb': 'ruby',
		'ps1': 'powershell',
		'psm1': 'powershell',
		'sh': 'bash',
		'bat': 'batch',
		'h': 'c',
		'tex': 'latex'
	};

	var STATUS_ATTR = 'data-src-status';
	var STATUS_LOADING = 'loading';
	var STATUS_LOADED = 'loaded';
	var STATUS_FAILED = 'failed';

	var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])'
		+ ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';

	/**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */
	function loadFile(src, success, error) {
		var xhr = new XMLHttpRequest();
		xhr.open('GET', src, true);
		xhr.onreadystatechange = function () {
			if (xhr.readyState == 4) {
				if (xhr.status < 400 && xhr.responseText) {
					success(xhr.responseText);
				} else {
					if (xhr.status >= 400) {
						error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
					} else {
						error(FAILURE_EMPTY_MESSAGE);
					}
				}
			}
		};
		xhr.send(null);
	}

	/**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */
	function parseRange(range) {
		var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
		if (m) {
			var start = Number(m[1]);
			var comma = m[2];
			var end = m[3];

			if (!comma) {
				return [start, start];
			}
			if (!end) {
				return [start, undefined];
			}
			return [start, Number(end)];
		}
		return undefined;
	}

	Prism.hooks.add('before-highlightall', function (env) {
		env.selector += ', ' + SELECTOR;
	});

	Prism.hooks.add('before-sanity-check', function (env) {
		var pre = /** @type {HTMLPreElement} */ (env.element);
		if (pre.matches(SELECTOR)) {
			env.code = ''; // fast-path the whole thing and go to complete

			pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading

			// add code element with loading message
			var code = pre.appendChild(document.createElement('CODE'));
			code.textContent = LOADING_MESSAGE;

			var src = pre.getAttribute('data-src');

			var language = env.language;
			if (language === 'none') {
				// the language might be 'none' because there is no language set;
				// in this case, we want to use the extension as the language
				var extension = (/\.(\w+)$/.exec(src) || [, 'none'])[1];
				language = EXTENSIONS[extension] || extension;
			}

			// set language classes
			Prism.util.setLanguage(code, language);
			Prism.util.setLanguage(pre, language);

			// preload the language
			var autoloader = Prism.plugins.autoloader;
			if (autoloader) {
				autoloader.loadLanguages(language);
			}

			// load file
			loadFile(
				src,
				function (text) {
					// mark as loaded
					pre.setAttribute(STATUS_ATTR, STATUS_LOADED);

					// handle data-range
					var range = parseRange(pre.getAttribute('data-range'));
					if (range) {
						var lines = text.split(/\r\n?|\n/g);

						// the range is one-based and inclusive on both ends
						var start = range[0];
						var end = range[1] == null ? lines.length : range[1];

						if (start < 0) { start += lines.length; }
						start = Math.max(0, Math.min(start - 1, lines.length));
						if (end < 0) { end += lines.length; }
						end = Math.max(0, Math.min(end, lines.length));

						text = lines.slice(start, end).join('\n');

						// add data-start for line numbers
						if (!pre.hasAttribute('data-start')) {
							pre.setAttribute('data-start', String(start + 1));
						}
					}

					// highlight code
					code.textContent = text;
					Prism.highlightElement(code);
				},
				function (error) {
					// mark as failed
					pre.setAttribute(STATUS_ATTR, STATUS_FAILED);

					code.textContent = error;
				}
			);
		}
	});

	Prism.plugins.fileHighlight = {
		/**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */
		highlight: function highlight(container) {
			var elements = (container || document).querySelectorAll(SELECTOR);

			for (var i = 0, element; (element = elements[i++]);) {
				Prism.highlightElement(element);
			}
		}
	};

	var logged = false;
	/** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */
	Prism.fileHighlight = function () {
		if (!logged) {
			console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
			logged = true;
		}
		Prism.plugins.fileHighlight.highlight.apply(this, arguments);
	};

}());


/***/ }),

/***/ 68262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(23586);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 13980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(68262)();
}


/***/ }),

/***/ 23586:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 88233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iS": function() { return /* reexport */ common_ColorWrap; },
  "xS": function() { return /* reexport */ sketch_Sketch; }
});

// UNUSED EXPORTS: AlphaPicker, BlockPicker, ChromePicker, CirclePicker, CompactPicker, GithubPicker, GooglePicker, HuePicker, MaterialPicker, PhotoshopPicker, SliderPicker, SwatchesPicker, TwitterPicker, default

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/reactcss/lib/index.js
var lib = __webpack_require__(7151);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/helpers/alpha.js
var calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (hsl.a !== a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (initialA !== _a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};
;// CONCATENATED MODULE: ../../node_modules/react-color/es/helpers/checkboard.js
var checkboardCache = {};

var render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

var get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }

  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/common/Checkboard.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      children = _ref.children;

  var styles = (0,lib["default"])({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });
  return (0,react.isValidElement)(children) ? react.cloneElement(children, _extends({}, children.props, { style: _extends({}, children.props.style, styles.grid) })) : react.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

/* harmony default export */ var common_Checkboard = (Checkboard);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/common/Alpha.js
var Alpha_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Alpha = function (_ref) {
  _inherits(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = (0,lib["default"])({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': Alpha_extends({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return react.createElement(
        'div',
        { style: styles.alpha },
        react.createElement(
          'div',
          { style: styles.checkboard },
          react.createElement(common_Checkboard, { renderers: this.props.renderers })
        ),
        react.createElement('div', { style: styles.gradient }),
        react.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          react.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? react.createElement(this.props.pointer, this.props) : react.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(react.PureComponent || react.Component);

/* harmony default export */ var common_Alpha = (Alpha);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/common/EditableInput.js
var EditableInput_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function EditableInput_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EditableInput_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EditableInput_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DEFAULT_ARROW_OFFSET = 1;

var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
  return Number(String(value).replace(/%/g, ''));
};

var idCounter = 1;

var EditableInput = function (_ref) {
  EditableInput_inherits(EditableInput, _ref);

  function EditableInput(props) {
    EditableInput_classCallCheck(this, EditableInput);

    var _this = EditableInput_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      _this.setUpdatedValue(e.target.value, e);
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var value = getNumberValue(e.target.value);
      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();
        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

        _this.setUpdatedValue(updatedValue, e);
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };

    _this.inputId = 'rc-editable-input-' + idCounter++;
    return _this;
  }

  EditableInput_createClass(EditableInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({ blurValue: String(this.props.value).toUpperCase() });
        } else {
          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'getValueObjectWithLabel',
    value: function getValueObjectWithLabel(value) {
      return _defineProperty({}, this.props.label, value);
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: 'setUpdatedValue',
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);

      this.setState({ value: value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0,lib["default"])({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return react.createElement(
        'div',
        { style: styles.wrap },
        react.createElement('input', {
          id: this.inputId,
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label && !this.props.hideLabel ? react.createElement(
          'label',
          {
            htmlFor: this.inputId,
            style: styles.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(react.PureComponent || react.Component);

/* harmony default export */ var common_EditableInput = (EditableInput);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/helpers/hue.js
var hue_calculateChange = function calculateChange(e, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (hsl.h !== h) {
      return {
        h: h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  }
  return null;
};
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/common/Hue.js
var Hue_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Hue_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Hue_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Hue_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Hue = function (_ref) {
  Hue_inherits(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    Hue_classCallCheck(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Hue_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = hue_calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), Hue_possibleConstructorReturn(_this, _ret);
  }

  Hue_createClass(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = (0,lib["default"])({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return react.createElement(
        'div',
        { style: styles.hue },
        react.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          react.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          react.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? react.createElement(this.props.pointer, this.props) : react.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(react.PureComponent || react.Component);

/* harmony default export */ var common_Hue = (Hue);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ../../node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ var _listCacheClear = (listCacheClear);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/eq.js
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ var lodash_es_eq = (eq);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (lodash_es_eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ var _assocIndexOf = (assocIndexOf);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ var _listCacheDelete = (listCacheDelete);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ var _listCacheGet = (listCacheGet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* harmony default export */ var _listCacheHas = (listCacheHas);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ var _listCacheSet = (listCacheSet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* harmony default export */ var _ListCache = (ListCache);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

/* harmony default export */ var _stackClear = (stackClear);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ var _stackDelete = (stackDelete);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ var _stackGet = (stackGet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ var _stackHas = (stackHas);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_freeGlobal.js
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ var _freeGlobal = (freeGlobal);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

/* harmony default export */ var _root = (root);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var Symbol = _root.Symbol;

/* harmony default export */ var _Symbol = (Symbol);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ var lodash_es_isObject = (isObject);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isFunction.js



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!lodash_es_isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ var lodash_es_isFunction = (isFunction);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_coreJsData.js


/** Used to detect overreaching core-js shims. */
var coreJsData = _root["__core-js_shared__"];

/* harmony default export */ var _coreJsData = (coreJsData);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_isMasked.js


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ var _isMasked = (isMasked);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_toSource.js
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ var _toSource = (toSource);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseIsNative.js





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var _baseIsNative_funcProto = Function.prototype,
    _baseIsNative_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var _baseIsNative_funcToString = _baseIsNative_funcProto.toString;

/** Used to check objects for own properties. */
var _baseIsNative_hasOwnProperty = _baseIsNative_objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  _baseIsNative_funcToString.call(_baseIsNative_hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!lodash_es_isObject(value) || _isMasked(value)) {
    return false;
  }
  var pattern = lodash_es_isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

/* harmony default export */ var _baseIsNative = (baseIsNative);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getValue.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getValue = (getValue);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getNative.js



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

/* harmony default export */ var _getNative = (getNative);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Map.js



/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

/* harmony default export */ var _Map = (Map);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

/* harmony default export */ var _nativeCreate = (nativeCreate);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* harmony default export */ var _hashClear = (hashClear);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _hashDelete = (hashDelete);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var _hashGet_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = _hashGet_objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ var _hashGet = (hashGet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* harmony default export */ var _hashHas = (hashHas);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ var _hashSet = (hashSet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* harmony default export */ var _Hash = (Hash);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

/* harmony default export */ var _mapCacheClear = (mapCacheClear);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ var _isKeyable = (isKeyable);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ var _getMapData = (getMapData);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _mapCacheDelete = (mapCacheDelete);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* harmony default export */ var _mapCacheGet = (mapCacheGet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* harmony default export */ var _mapCacheHas = (mapCacheHas);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ var _mapCacheSet = (mapCacheSet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* harmony default export */ var _MapCache = (MapCache);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ var _stackSet = (stackSet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

/* harmony default export */ var _Stack = (Stack);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_defineProperty.js


var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ var lodash_es_defineProperty = (defineProperty);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseAssignValue.js


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && lodash_es_defineProperty) {
    lodash_es_defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ var _baseAssignValue = (baseAssignValue);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_assignMergeValue.js



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !lodash_es_eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignMergeValue = (assignMergeValue);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_createBaseFor.js
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ var _createBaseFor = (createBaseFor);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseFor.js


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

/* harmony default export */ var _baseFor = (baseFor);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_cloneBuffer.js


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ var _cloneBuffer = (cloneBuffer);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Uint8Array.js


/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

/* harmony default export */ var _Uint8Array = (Uint8Array);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_cloneArrayBuffer.js


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

/* harmony default export */ var _cloneArrayBuffer = (cloneArrayBuffer);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_cloneTypedArray.js


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ var _cloneTypedArray = (cloneTypedArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_copyArray.js
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ var _copyArray = (copyArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseCreate.js


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!lodash_es_isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ var _baseCreate = (baseCreate);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_isPrototype.js
/** Used for built-in method references. */
var _isPrototype_objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || _isPrototype_objectProto;

  return value === proto;
}

/* harmony default export */ var _isPrototype = (isPrototype);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_initCloneObject.js




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

/* harmony default export */ var _initCloneObject = (initCloneObject);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseIsArguments.js



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == argsTag;
}

/* harmony default export */ var _baseIsArguments = (baseIsArguments);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isArguments.js



/** Used for built-in method references. */
var isArguments_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isArguments_hasOwnProperty = isArguments_objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = isArguments_objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return lodash_es_isObjectLike(value) && isArguments_hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ var lodash_es_isArguments = (isArguments);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isArray.js
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ var lodash_es_isArray = (isArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isLength.js
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ var lodash_es_isLength = (isLength);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isArrayLike.js



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && lodash_es_isLength(value.length) && !lodash_es_isFunction(value);
}

/* harmony default export */ var lodash_es_isArrayLike = (isArrayLike);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isArrayLikeObject.js



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return lodash_es_isObjectLike(value) && lodash_es_isArrayLike(value);
}

/* harmony default export */ var lodash_es_isArrayLikeObject = (isArrayLikeObject);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/stubFalse.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ var lodash_es_stubFalse = (stubFalse);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isBuffer.js



/** Detect free variable `exports`. */
var isBuffer_freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var isBuffer_freeModule = isBuffer_freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var isBuffer_moduleExports = isBuffer_freeModule && isBuffer_freeModule.exports === isBuffer_freeExports;

/** Built-in value references. */
var isBuffer_Buffer = isBuffer_moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = isBuffer_Buffer ? isBuffer_Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || lodash_es_stubFalse;

/* harmony default export */ var lodash_es_isBuffer = (isBuffer);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var isPlainObject_funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var isPlainObject_funcToString = isPlainObject_funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = isPlainObject_funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    isPlainObject_funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseIsTypedArray.js




/** `Object#toString` result references. */
var _baseIsTypedArray_argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    _baseIsTypedArray_funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    _baseIsTypedArray_objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[_baseIsTypedArray_argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[_baseIsTypedArray_funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[_baseIsTypedArray_objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return lodash_es_isObjectLike(value) &&
    lodash_es_isLength(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

/* harmony default export */ var _baseIsTypedArray = (baseIsTypedArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseUnary.js
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ var _baseUnary = (baseUnary);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_nodeUtil.js


/** Detect free variable `exports`. */
var _nodeUtil_freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var _nodeUtil_freeModule = _nodeUtil_freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var _nodeUtil_moduleExports = _nodeUtil_freeModule && _nodeUtil_freeModule.exports === _nodeUtil_freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = _nodeUtil_moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = _nodeUtil_freeModule && _nodeUtil_freeModule.require && _nodeUtil_freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ var _nodeUtil = (nodeUtil);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isTypedArray.js




/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

/* harmony default export */ var lodash_es_isTypedArray = (isTypedArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_safeGet.js
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ var _safeGet = (safeGet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_assignValue.js



/** Used for built-in method references. */
var _assignValue_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _assignValue_hasOwnProperty = _assignValue_objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(_assignValue_hasOwnProperty.call(object, key) && lodash_es_eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignValue = (assignValue);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_copyObject.js



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ var _copyObject = (copyObject);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseTimes.js
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ var _baseTimes = (baseTimes);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_isIndex.js
/** Used as references for various `Number` constants. */
var _isIndex_MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? _isIndex_MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ var _isIndex = (isIndex);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_arrayLikeKeys.js







/** Used for built-in method references. */
var _arrayLikeKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _arrayLikeKeys_hasOwnProperty = _arrayLikeKeys_objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = lodash_es_isArray(value),
      isArg = !isArr && lodash_es_isArguments(value),
      isBuff = !isArr && !isArg && lodash_es_isBuffer(value),
      isType = !isArr && !isArg && !isBuff && lodash_es_isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || _arrayLikeKeys_hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _arrayLikeKeys = (arrayLikeKeys);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_nativeKeysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _nativeKeysIn = (nativeKeysIn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseKeysIn.js




/** Used for built-in method references. */
var _baseKeysIn_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeysIn_hasOwnProperty = _baseKeysIn_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!lodash_es_isObject(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !_baseKeysIn_hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeysIn = (baseKeysIn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/keysIn.js




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

/* harmony default export */ var lodash_es_keysIn = (keysIn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/toPlainObject.js



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, lodash_es_keysIn(value));
}

/* harmony default export */ var lodash_es_toPlainObject = (toPlainObject);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseMergeDeep.js
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = lodash_es_isArray(srcValue),
        isBuff = !isArr && lodash_es_isBuffer(srcValue),
        isTyped = !isArr && !isBuff && lodash_es_isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (lodash_es_isArray(objValue)) {
        newValue = objValue;
      }
      else if (lodash_es_isArrayLikeObject(objValue)) {
        newValue = _copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = _cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (lodash_es_isPlainObject(srcValue) || lodash_es_isArguments(srcValue)) {
      newValue = objValue;
      if (lodash_es_isArguments(objValue)) {
        newValue = lodash_es_toPlainObject(objValue);
      }
      else if (!lodash_es_isObject(objValue) || lodash_es_isFunction(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

/* harmony default export */ var _baseMergeDeep = (baseMergeDeep);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseMerge.js








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function(srcValue, key) {
    stack || (stack = new _Stack);
    if (lodash_es_isObject(srcValue)) {
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, lodash_es_keysIn);
}

/* harmony default export */ var _baseMerge = (baseMerge);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/identity.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ var lodash_es_identity = (identity);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_apply.js
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ var _apply = (apply);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_overRest.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

/* harmony default export */ var _overRest = (overRest);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/constant.js
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ var lodash_es_constant = (constant);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseSetToString.js




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !lodash_es_defineProperty ? lodash_es_identity : function(func, string) {
  return lodash_es_defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': lodash_es_constant(string),
    'writable': true
  });
};

/* harmony default export */ var _baseSetToString = (baseSetToString);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_shortOut.js
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ var _shortOut = (shortOut);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_setToString.js



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

/* harmony default export */ var _setToString = (setToString);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseRest.js




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, lodash_es_identity), func + '');
}

/* harmony default export */ var _baseRest = (baseRest);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_isIterateeCall.js





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!lodash_es_isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (lodash_es_isArrayLike(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return lodash_es_eq(object[index], value);
  }
  return false;
}

/* harmony default export */ var _isIterateeCall = (isIterateeCall);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_createAssigner.js



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ var _createAssigner = (createAssigner);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/merge.js



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = _createAssigner(function(object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

/* harmony default export */ var lodash_es_merge = (merge);

;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/common/Raised.js





var Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles;

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, passedStyles), { 'zDepth-1': zDepth === 1 });

  return react.createElement(
    'div',
    { style: styles.wrap },
    react.createElement('div', { style: styles.bg }),
    react.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: (prop_types_default()).string,
  zDepth: prop_types_default().oneOf([0, 1, 2, 3, 4, 5]),
  radius: (prop_types_default()).number,
  styles: (prop_types_default()).object
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2,
  styles: {}
};

/* harmony default export */ var common_Raised = (Raised);
;// CONCATENATED MODULE: ../../node_modules/lodash-es/now.js


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root.Date.now();
};

/* harmony default export */ var lodash_es_now = (now);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_trimmedEndIndex.js
/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/* harmony default export */ var _trimmedEndIndex = (trimmedEndIndex);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseTrim.js


/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

/* harmony default export */ var _baseTrim = (baseTrim);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isSymbol.js



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (lodash_es_isObjectLike(value) && _baseGetTag(value) == symbolTag);
}

/* harmony default export */ var lodash_es_isSymbol = (isSymbol);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/toNumber.js




/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (lodash_es_isSymbol(value)) {
    return NAN;
  }
  if (lodash_es_isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = lodash_es_isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ var lodash_es_toNumber = (toNumber);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/debounce.js




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var debounce_nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = lodash_es_toNumber(wait) || 0;
  if (lodash_es_isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? debounce_nativeMax(lodash_es_toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = lodash_es_now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(lodash_es_now());
  }

  function debounced() {
    var time = lodash_es_now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ var lodash_es_debounce = (debounce);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/throttle.js



/** Error message constants. */
var throttle_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(throttle_FUNC_ERROR_TEXT);
  }
  if (lodash_es_isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return lodash_es_debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/* harmony default export */ var lodash_es_throttle = (throttle);

;// CONCATENATED MODULE: ../../node_modules/react-color/es/helpers/saturation.js
var saturation_calculateChange = function calculateChange(e, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;

  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'hsv'
  };
};
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/common/Saturation.js
var Saturation_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Saturation_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Saturation_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Saturation_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Saturation = function (_ref) {
  Saturation_inherits(Saturation, _ref);

  function Saturation(props) {
    Saturation_classCallCheck(this, Saturation);

    var _this = Saturation_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e) {
      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, saturation_calculateChange(e, _this.props.hsl, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      var renderWindow = _this.getContainerRenderWindow();
      renderWindow.addEventListener('mousemove', _this.handleChange);
      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = lodash_es_throttle(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  Saturation_createClass(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: 'getContainerRenderWindow',
    value: function getContainerRenderWindow() {
      var container = this.container;

      var renderWindow = window;
      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }
      return renderWindow;
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener('mousemove', this.handleChange);
      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = (0,lib["default"])({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return react.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        react.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        react.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          react.createElement('div', { style: styles.black, className: 'saturation-black' }),
          react.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? react.createElement(this.props.pointer, this.props) : react.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(react.PureComponent || react.Component);

/* harmony default export */ var common_Saturation = (Saturation);
;// CONCATENATED MODULE: ../../node_modules/lodash-es/_arrayEach.js
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ var _arrayEach = (arrayEach);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_nativeKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var _nativeKeys = (nativeKeys);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseKeys.js



/** Used for built-in method references. */
var _baseKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeys_hasOwnProperty = _baseKeys_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (_baseKeys_hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeys = (baseKeys);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/keys.js




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

/* harmony default export */ var lodash_es_keys = (keys);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseForOwn.js



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, lodash_es_keys);
}

/* harmony default export */ var _baseForOwn = (baseForOwn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_createBaseEach.js


/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!lodash_es_isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/* harmony default export */ var _createBaseEach = (createBaseEach);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseEach.js



/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = _createBaseEach(_baseForOwn);

/* harmony default export */ var _baseEach = (baseEach);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_castFunction.js


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : lodash_es_identity;
}

/* harmony default export */ var _castFunction = (castFunction);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/forEach.js





/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = lodash_es_isArray(collection) ? _arrayEach : _baseEach;
  return func(collection, _castFunction(iteratee));
}

/* harmony default export */ var lodash_es_forEach = (forEach);

// EXTERNAL MODULE: ../../node_modules/tinycolor2/tinycolor.js
var tinycolor = __webpack_require__(98621);
var tinycolor_default = /*#__PURE__*/__webpack_require__.n(tinycolor);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/helpers/color.js



var simpleCheckForValidColor = function simpleCheckForValidColor(data) {
  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
  var checked = 0;
  var passed = 0;
  lodash_es_forEach(keysToCheck, function (letter) {
    if (data[letter]) {
      checked += 1;
      if (!isNaN(data[letter])) {
        passed += 1;
      }
      if (letter === 's' || letter === 'l') {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data : false;
};

var toState = function toState(data, oldHue) {
  var color = data.hex ? tinycolor_default()(data.hex) : tinycolor_default()(data);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();
  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex === '000000' && rgb.a === 0;

  return {
    hsl: hsl,
    hex: transparent ? 'transparent' : '#' + hex,
    rgb: rgb,
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source
  };
};

var isValidHex = function isValidHex(hex) {
  if (hex === 'transparent') {
    return true;
  }
  // disable hex4 and hex8
  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && tinycolor_default()(hex).isValid();
};

var getContrastingColor = function getContrastingColor(data) {
  if (!data) {
    return '#fff';
  }
  var col = toState(data);
  if (col.hex === 'transparent') {
    return 'rgba(0,0,0,0.4)';
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
};

var red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

var isvalidColorString = function isvalidColorString(string, type) {
  var stringWithoutDegree = string.replace('°', '');
  return tinycolor_default()(type + ' (' + stringWithoutDegree + ')')._ok;
};
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/common/ColorWrap.js
var ColorWrap_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ColorWrap_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ColorWrap_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ColorWrap_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ColorWrap_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    ColorWrap_inherits(ColorPicker, _ref);

    function ColorPicker(props) {
      ColorWrap_classCallCheck(this, ColorPicker);

      var _this = ColorWrap_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = toState(data, data.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = ColorWrap_extends({}, toState(props.color, 0));

      _this.debounce = lodash_es_debounce(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    ColorWrap_createClass(ColorPicker, [{
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return react.createElement(Picker, ColorWrap_extends({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        return ColorWrap_extends({}, toState(nextProps.color, state.oldHue));
      }
    }]);

    return ColorPicker;
  }(react.PureComponent || react.Component);

  ColorPicker.propTypes = ColorWrap_extends({}, Picker.propTypes);

  ColorPicker.defaultProps = ColorWrap_extends({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

/* harmony default export */ var common_ColorWrap = (ColorWrap);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/helpers/interaction.js
var interaction_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var interaction_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function interaction_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function interaction_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function interaction_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-invalid-this */


var handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    interaction_inherits(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      interaction_classCallCheck(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = interaction_possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _temp), interaction_possibleConstructorReturn(_this, _ret);
    }

    interaction_createClass(Focus, [{
      key: 'render',
      value: function render() {
        return react.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          react.createElement(Component, interaction_extends({}, this.props, this.state))
        );
      }
    }]);

    return Focus;
  }(react.Component);
};
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/common/Swatch.js
var Swatch_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var ENTER = 13;

var Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = (0,lib["default"])({
    default: {
      swatch: Swatch_extends({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return react.createElement(
    'div',
    Swatch_extends({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && react.createElement(common_Checkboard, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

/* harmony default export */ var common_Swatch = (handleFocus(Swatch));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/common/index.js








;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/alpha/AlphaPointer.js



var AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0,lib["default"])({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return react.createElement('div', { style: styles.picker });
};

/* harmony default export */ var alpha_AlphaPointer = (AlphaPointer);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/alpha/Alpha.js
var alpha_Alpha_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib["default"])({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });

  return react.createElement(
    'div',
    { style: styles.picker, className: 'alpha-picker ' + className },
    react.createElement(common_Alpha, alpha_Alpha_extends({}, styles.alpha, {
      rgb: rgb,
      hsl: hsl,
      pointer: pointer,
      renderers: renderers,
      onChange: onChange,
      direction: direction
    }))
  );
};

AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: alpha_AlphaPointer
};

/* harmony default export */ var alpha_Alpha = (common_ColorWrap(AlphaPicker));
;// CONCATENATED MODULE: ../../node_modules/lodash-es/_arrayMap.js
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ var _arrayMap = (arrayMap);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_setCacheAdd.js
/** Used to stand-in for `undefined` hash values. */
var _setCacheAdd_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, _setCacheAdd_HASH_UNDEFINED);
  return this;
}

/* harmony default export */ var _setCacheAdd = (setCacheAdd);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_setCacheHas.js
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ var _setCacheHas = (setCacheHas);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_SetCache.js




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

/* harmony default export */ var _SetCache = (SetCache);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_arraySome.js
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ var _arraySome = (arraySome);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_cacheHas.js
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ var _cacheHas = (cacheHas);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_equalArrays.js




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ var _equalArrays = (equalArrays);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_mapToArray.js
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ var _mapToArray = (mapToArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_setToArray.js
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ var _setToArray = (setToArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_equalByTag.js







/** Used to compose bitmasks for value comparisons. */
var _equalByTag_COMPARE_PARTIAL_FLAG = 1,
    _equalByTag_COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var _equalByTag_boolTag = '[object Boolean]',
    _equalByTag_dateTag = '[object Date]',
    _equalByTag_errorTag = '[object Error]',
    _equalByTag_mapTag = '[object Map]',
    _equalByTag_numberTag = '[object Number]',
    _equalByTag_regexpTag = '[object RegExp]',
    _equalByTag_setTag = '[object Set]',
    _equalByTag_stringTag = '[object String]',
    _equalByTag_symbolTag = '[object Symbol]';

var _equalByTag_arrayBufferTag = '[object ArrayBuffer]',
    _equalByTag_dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case _equalByTag_dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case _equalByTag_arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case _equalByTag_boolTag:
    case _equalByTag_dateTag:
    case _equalByTag_numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return lodash_es_eq(+object, +other);

    case _equalByTag_errorTag:
      return object.name == other.name && object.message == other.message;

    case _equalByTag_regexpTag:
    case _equalByTag_stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case _equalByTag_mapTag:
      var convert = _mapToArray;

    case _equalByTag_setTag:
      var isPartial = bitmask & _equalByTag_COMPARE_PARTIAL_FLAG;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= _equalByTag_COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case _equalByTag_symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ var _equalByTag = (equalByTag);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_arrayPush.js
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ var _arrayPush = (arrayPush);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseGetAllKeys.js



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return lodash_es_isArray(object) ? result : _arrayPush(result, symbolsFunc(object));
}

/* harmony default export */ var _baseGetAllKeys = (baseGetAllKeys);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_arrayFilter.js
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ var _arrayFilter = (arrayFilter);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/stubArray.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ var lodash_es_stubArray = (stubArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getSymbols.js



/** Used for built-in method references. */
var _getSymbols_objectProto = Object.prototype;

/** Built-in value references. */
var _getSymbols_propertyIsEnumerable = _getSymbols_objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? lodash_es_stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return _getSymbols_propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ var _getSymbols = (getSymbols);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getAllKeys.js




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, lodash_es_keys, _getSymbols);
}

/* harmony default export */ var _getAllKeys = (getAllKeys);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_equalObjects.js


/** Used to compose bitmasks for value comparisons. */
var _equalObjects_COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var _equalObjects_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _equalObjects_hasOwnProperty = _equalObjects_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & _equalObjects_COMPARE_PARTIAL_FLAG,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : _equalObjects_hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ var _equalObjects = (equalObjects);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_DataView.js



/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

/* harmony default export */ var _DataView = (DataView);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Promise.js



/* Built-in method references that are verified to be native. */
var Promise = _getNative(_root, 'Promise');

/* harmony default export */ var _Promise = (Promise);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Set.js



/* Built-in method references that are verified to be native. */
var Set = _getNative(_root, 'Set');

/* harmony default export */ var _Set = (Set);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_WeakMap.js



/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

/* harmony default export */ var _WeakMap = (WeakMap);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getTag.js








/** `Object#toString` result references. */
var _getTag_mapTag = '[object Map]',
    _getTag_objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    _getTag_setTag = '[object Set]',
    _getTag_weakMapTag = '[object WeakMap]';

var _getTag_dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != _getTag_dataViewTag) ||
    (_Map && getTag(new _Map) != _getTag_mapTag) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != _getTag_setTag) ||
    (_WeakMap && getTag(new _WeakMap) != _getTag_weakMapTag)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == _getTag_objectTag ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return _getTag_dataViewTag;
        case mapCtorString: return _getTag_mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return _getTag_setTag;
        case weakMapCtorString: return _getTag_weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ var _getTag = (getTag);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseIsEqualDeep.js









/** Used to compose bitmasks for value comparisons. */
var _baseIsEqualDeep_COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var _baseIsEqualDeep_argsTag = '[object Arguments]',
    _baseIsEqualDeep_arrayTag = '[object Array]',
    _baseIsEqualDeep_objectTag = '[object Object]';

/** Used for built-in method references. */
var _baseIsEqualDeep_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseIsEqualDeep_hasOwnProperty = _baseIsEqualDeep_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = lodash_es_isArray(object),
      othIsArr = lodash_es_isArray(other),
      objTag = objIsArr ? _baseIsEqualDeep_arrayTag : _getTag(object),
      othTag = othIsArr ? _baseIsEqualDeep_arrayTag : _getTag(other);

  objTag = objTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : objTag;
  othTag = othTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : othTag;

  var objIsObj = objTag == _baseIsEqualDeep_objectTag,
      othIsObj = othTag == _baseIsEqualDeep_objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && lodash_es_isBuffer(object)) {
    if (!lodash_es_isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || lodash_es_isTypedArray(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & _baseIsEqualDeep_COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && _baseIsEqualDeep_hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && _baseIsEqualDeep_hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ var _baseIsEqualDeep = (baseIsEqualDeep);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseIsEqual.js



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!lodash_es_isObjectLike(value) && !lodash_es_isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ var _baseIsEqual = (baseIsEqual);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseIsMatch.js



/** Used to compose bitmasks for value comparisons. */
var _baseIsMatch_COMPARE_PARTIAL_FLAG = 1,
    _baseIsMatch_COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? _baseIsEqual(srcValue, objValue, _baseIsMatch_COMPARE_PARTIAL_FLAG | _baseIsMatch_COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ var _baseIsMatch = (baseIsMatch);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_isStrictComparable.js


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !lodash_es_isObject(value);
}

/* harmony default export */ var _isStrictComparable = (isStrictComparable);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getMatchData.js



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = lodash_es_keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

/* harmony default export */ var _getMatchData = (getMatchData);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_matchesStrictComparable.js
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ var _matchesStrictComparable = (matchesStrictComparable);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseMatches.js




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

/* harmony default export */ var _baseMatches = (baseMatches);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_isKey.js



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (lodash_es_isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || lodash_es_isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ var _isKey = (isKey);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/memoize.js


/** Error message constants. */
var memoize_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(memoize_FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

/* harmony default export */ var lodash_es_memoize = (memoize);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = lodash_es_memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ var _memoizeCapped = (memoizeCapped);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ var _stringToPath = (stringToPath);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseToString.js





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var _baseToString_symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = _baseToString_symbolProto ? _baseToString_symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (lodash_es_isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (lodash_es_isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ var _baseToString = (baseToString);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/toString.js


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString_toString(value) {
  return value == null ? '' : _baseToString(value);
}

/* harmony default export */ var lodash_es_toString = (toString_toString);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_castPath.js





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (lodash_es_isArray(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(lodash_es_toString(value));
}

/* harmony default export */ var _castPath = (castPath);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_toKey.js


/** Used as references for various `Number` constants. */
var _toKey_INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || lodash_es_isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -_toKey_INFINITY) ? '-0' : result;
}

/* harmony default export */ var _toKey = (toKey);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseGet.js



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ var _baseGet = (baseGet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/get.js


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get_get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ var lodash_es_get = (get_get);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseHasIn.js
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ var _baseHasIn = (baseHasIn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_hasPath.js







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && lodash_es_isLength(length) && _isIndex(key, length) &&
    (lodash_es_isArray(object) || lodash_es_isArguments(object));
}

/* harmony default export */ var _hasPath = (hasPath);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/hasIn.js



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

/* harmony default export */ var lodash_es_hasIn = (hasIn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseMatchesProperty.js








/** Used to compose bitmasks for value comparisons. */
var _baseMatchesProperty_COMPARE_PARTIAL_FLAG = 1,
    _baseMatchesProperty_COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (_isKey(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(_toKey(path), srcValue);
  }
  return function(object) {
    var objValue = lodash_es_get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? lodash_es_hasIn(object, path)
      : _baseIsEqual(srcValue, objValue, _baseMatchesProperty_COMPARE_PARTIAL_FLAG | _baseMatchesProperty_COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ var _baseMatchesProperty = (baseMatchesProperty);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseProperty.js
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ var _baseProperty = (baseProperty);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_basePropertyDeep.js


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return _baseGet(object, path);
  };
}

/* harmony default export */ var _basePropertyDeep = (basePropertyDeep);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/property.js





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
}

/* harmony default export */ var lodash_es_property = (property);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseIteratee.js






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return lodash_es_identity;
  }
  if (typeof value == 'object') {
    return lodash_es_isArray(value)
      ? _baseMatchesProperty(value[0], value[1])
      : _baseMatches(value);
  }
  return lodash_es_property(value);
}

/* harmony default export */ var _baseIteratee = (baseIteratee);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseMap.js



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = lodash_es_isArrayLike(collection) ? Array(collection.length) : [];

  _baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/* harmony default export */ var _baseMap = (baseMap);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/map.js





/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = lodash_es_isArray(collection) ? _arrayMap : _baseMap;
  return func(collection, _baseIteratee(iteratee, 3));
}

/* harmony default export */ var lodash_es_map = (map);

;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/block/BlockSwatches.js






var BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0,lib["default"])({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        float: 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return react.createElement(
    'div',
    { style: styles.swatches },
    lodash_es_map(colors, function (c) {
      return react.createElement(common_Swatch, {
        key: c,
        color: c,
        style: styles.swatch,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }),
    react.createElement('div', { style: styles.clear })
  );
};

/* harmony default export */ var block_BlockSwatches = (BlockSwatches);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/block/Block.js









var Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var transparent = hex === 'transparent';
  var handleChange = function handleChange(hexCode, e) {
    isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: getContrastingColor(hex),
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, passedStyles), { 'hide-triangle': triangle === 'hide' });

  return react.createElement(
    'div',
    { style: styles.card, className: 'block-picker ' + className },
    react.createElement('div', { style: styles.triangle }),
    react.createElement(
      'div',
      { style: styles.head },
      transparent && react.createElement(common_Checkboard, { borderRadius: '6px 6px 0 0' }),
      react.createElement(
        'div',
        { style: styles.label },
        hex
      )
    ),
    react.createElement(
      'div',
      { style: styles.body },
      react.createElement(block_BlockSwatches, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
      react.createElement(common_EditableInput, {
        style: { input: styles.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};

Block.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  colors: prop_types_default().arrayOf((prop_types_default()).string),
  triangle: prop_types_default().oneOf(['top', 'hide']),
  styles: (prop_types_default()).object
};

Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top',
  styles: {}
};

/* harmony default export */ var block_Block = (common_ColorWrap(Block));
;// CONCATENATED MODULE: ../../node_modules/material-colors/dist/colors.es2015.js
var colors_es2015_red = {"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"};
var pink = {"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"};
var purple = {"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"};
var deepPurple = {"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"};
var indigo = {"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"};
var blue = {"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"};
var lightBlue = {"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"};
var cyan = {"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"};
var teal = {"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"};
var green = {"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"};
var lightGreen = {"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"};
var lime = {"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"};
var yellow = {"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"};
var amber = {"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"};
var orange = {"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"};
var deepOrange = {"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"};
var brown = {"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"};
var grey = {"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"};
var blueGrey = {"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"};
var darkText = {"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"};
var lightText = {"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"};
var darkIcons = {"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"};
var lightIcons = {"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"};
var white = "#ffffff";
var black = "#000000";

/* harmony default export */ var colors_es2015 = ({
  red: colors_es2015_red,
  pink: pink,
  purple: purple,
  deepPurple: deepPurple,
  indigo: indigo,
  blue: blue,
  lightBlue: lightBlue,
  cyan: cyan,
  teal: teal,
  green: green,
  lightGreen: lightGreen,
  lime: lime,
  yellow: yellow,
  amber: amber,
  orange: orange,
  deepOrange: deepOrange,
  brown: brown,
  grey: grey,
  blueGrey: blueGrey,
  darkText: darkText,
  lightText: lightText,
  darkIcons: darkIcons,
  lightIcons: lightIcons,
  white: white,
  black: black
});

;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/circle/CircleSwatch.js





var CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;

  var styles = (0,lib["default"])({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, { hover: hover, active: active });

  return react.createElement(
    'div',
    { style: styles.swatch },
    react.createElement(common_Swatch, {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
    })
  );
};

CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};

/* harmony default export */ var circle_CircleSwatch = ((0,lib.handleHover)(CircleSwatch));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/circle/Circle.js










var Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(hexCode, e) {
    return onChange({ hex: hexCode, source: 'hex' }, e);
  };

  return react.createElement(
    'div',
    { style: styles.card, className: 'circle-picker ' + className },
    lodash_es_map(colors, function (c) {
      return react.createElement(circle_CircleSwatch, {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize: circleSize,
        circleSpacing: circleSpacing
      });
    })
  );
};

Circle.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  circleSize: (prop_types_default()).number,
  circleSpacing: (prop_types_default()).number,
  styles: (prop_types_default()).object
};

Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [colors_es2015_red[500], pink[500], purple[500], deepPurple[500], indigo[500], blue[500], lightBlue[500], cyan[500], teal[500], green[500], lightGreen[500], lime[500], yellow[500], amber[500], orange[500], deepOrange[500], brown[500], blueGrey[500]],
  styles: {}
};

/* harmony default export */ var circle_Circle = (common_ColorWrap(Circle));
;// CONCATENATED MODULE: ../../node_modules/lodash-es/isUndefined.js
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/* harmony default export */ var lodash_es_isUndefined = (isUndefined);

// EXTERNAL MODULE: ../../node_modules/@icons/material/UnfoldMoreHorizontalIcon.js
var UnfoldMoreHorizontalIcon = __webpack_require__(16331);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/chrome/ChromeFields.js
var ChromeFields_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ChromeFields_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ChromeFields_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ChromeFields_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-did-mount-set-state, no-param-reassign */









var ChromeFields = function (_React$Component) {
  ChromeFields_inherits(ChromeFields, _React$Component);

  function ChromeFields(props) {
    ChromeFields_classCallCheck(this, ChromeFields);

    var _this = ChromeFields_possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));

    _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    };

    _this.handleChange = function (data, e) {
      if (data.hex) {
        isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        // Remove any occurances of '%'.
        if (typeof data.s === 'string' && data.s.includes('%')) {
          data.s = data.s.replace('%', '');
        }
        if (typeof data.l === 'string' && data.l.includes('%')) {
          data.l = data.l.replace('%', '');
        }

        // We store HSL as a unit interval so we need to override the 1 input to 0.01
        if (data.s == 1) {
          data.s = 0.01;
        } else if (data.l == 1) {
          data.l = 0.01;
        }

        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(!lodash_es_isUndefined(data.s) ? data.s : _this.props.hsl.s),
          l: Number(!lodash_es_isUndefined(data.l) ? data.l : _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    };

    _this.showHighlight = function (e) {
      e.currentTarget.style.background = '#eee';
    };

    _this.hideHighlight = function (e) {
      e.currentTarget.style.background = 'transparent';
    };

    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }
    return _this;
  }

  ChromeFields_createClass(ChromeFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0,lib["default"])({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            fill: '#333',
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = react.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = react.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.alpha },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = react.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.field },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.alpha },
            react.createElement(common_EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return react.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        react.createElement(
          'div',
          { style: styles.toggle },
          react.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            react.createElement(UnfoldMoreHorizontalIcon/* default */.Z, {
              style: styles.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
        return { view: 'rgb' };
      }
      return null;
    }
  }]);

  return ChromeFields;
}(react.Component);

ChromeFields.defaultProps = {
  view: "hex"
};

/* harmony default export */ var chrome_ChromeFields = (ChromeFields);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/chrome/ChromePointer.js



var ChromePointer = function ChromePointer() {
  var styles = (0,lib["default"])({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return react.createElement('div', { style: styles.picker });
};

/* harmony default export */ var chrome_ChromePointer = (ChromePointer);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/chrome/ChromePointerCircle.js



var ChromePointerCircle = function ChromePointerCircle() {
  var styles = (0,lib["default"])({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return react.createElement('div', { style: styles.picker });
};

/* harmony default export */ var chrome_ChromePointerCircle = (ChromePointerCircle);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/chrome/Chrome.js










var Chrome = function Chrome(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      defaultView = _ref.defaultView;

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return react.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    react.createElement(
      'div',
      { style: styles.saturation },
      react.createElement(common_Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: chrome_ChromePointerCircle,
        onChange: onChange
      })
    ),
    react.createElement(
      'div',
      { style: styles.body },
      react.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        react.createElement(
          'div',
          { style: styles.color },
          react.createElement(
            'div',
            { style: styles.swatch },
            react.createElement('div', { style: styles.active }),
            react.createElement(common_Checkboard, { renderers: renderers })
          )
        ),
        react.createElement(
          'div',
          { style: styles.toggles },
          react.createElement(
            'div',
            { style: styles.hue },
            react.createElement(common_Hue, {
              style: styles.Hue,
              hsl: hsl,
              pointer: chrome_ChromePointer,
              onChange: onChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.alpha },
            react.createElement(common_Alpha, {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: chrome_ChromePointer,
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      react.createElement(chrome_ChromeFields, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  disableAlpha: (prop_types_default()).bool,
  styles: (prop_types_default()).object,
  defaultView: prop_types_default().oneOf(["hex", "rgb", "hsl"])
};

Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};

/* harmony default export */ var chrome_Chrome = (common_ColorWrap(Chrome));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/compact/CompactColor.js






var CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;

  var styles = (0,lib["default"])({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        float: 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: getContrastingColor(color),
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });

  return react.createElement(
    common_Swatch,
    {
      style: styles.color,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    react.createElement('div', { style: styles.dot })
  );
};

/* harmony default export */ var compact_CompactColor = (CompactColor);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/compact/CompactFields.js





var CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;

  var styles = (0,lib["default"])({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return react.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    react.createElement('div', { style: styles.active }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    })
  );
};

/* harmony default export */ var compact_CompactFields = (CompactFields);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/compact/Compact.js











var Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return react.createElement(
    common_Raised,
    { style: styles.Compact, styles: passedStyles },
    react.createElement(
      'div',
      { style: styles.compact, className: 'compact-picker ' + className },
      react.createElement(
        'div',
        null,
        lodash_es_map(colors, function (c) {
          return react.createElement(compact_CompactColor, {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
          });
        }),
        react.createElement('div', { style: styles.clear })
      ),
      react.createElement(compact_CompactFields, { hex: hex, rgb: rgb, onChange: handleChange })
    )
  );
};

Compact.propTypes = {
  colors: prop_types_default().arrayOf((prop_types_default()).string),
  styles: (prop_types_default()).object
};

Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
  styles: {}
};

/* harmony default export */ var compact_Compact = (common_ColorWrap(Compact));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/github/GithubSwatch.js





var GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };

  var styles = (0,lib["default"])({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, { hover: hover });

  return react.createElement(
    'div',
    { style: styles.swatch },
    react.createElement(common_Swatch, {
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};

/* harmony default export */ var github_GithubSwatch = ((0,lib.handleHover)(GithubSwatch));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/github/Github.js









var Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-left-triangle': {
      triangle: {
        top: '35px',
        left: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        left: '9px',
        transform: 'rotate(180deg)'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-left-triangle': triangle === 'bottom-left',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({ hex: hex, source: 'hex' }, e);
  };

  return react.createElement(
    'div',
    { style: styles.card, className: 'github-picker ' + className },
    react.createElement('div', { style: styles.triangleShadow }),
    react.createElement('div', { style: styles.triangle }),
    lodash_es_map(colors, function (c) {
      return react.createElement(github_GithubSwatch, {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

Github.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  colors: prop_types_default().arrayOf((prop_types_default()).string),
  triangle: prop_types_default().oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
  styles: (prop_types_default()).object
};

Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left',
  styles: {}
};

/* harmony default export */ var github_Github = (common_ColorWrap(Github));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/hue/HuePointer.js



var SliderPointer = function SliderPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0,lib["default"])({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return react.createElement('div', { style: styles.picker });
};

/* harmony default export */ var HuePointer = (SliderPointer);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/hue/Hue.js
var Hue_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  // Overwrite to provide pure hue color
  var handleChange = function handleChange(data) {
    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
  };

  return react.createElement(
    'div',
    { style: styles.picker, className: 'hue-picker ' + className },
    react.createElement(common_Hue, Hue_extends({}, styles.hue, {
      hsl: hsl,
      pointer: pointer,
      onChange: handleChange,
      direction: direction
    }))
  );
};

HuePicker.propTypes = {
  styles: (prop_types_default()).object
};
HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: HuePointer,
  styles: {}
};

/* harmony default export */ var hue_Hue = (common_ColorWrap(HuePicker));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/material/Material.js







var Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return react.createElement(
    common_Raised,
    { styles: passedStyles },
    react.createElement(
      'div',
      { style: styles.material, className: 'material-picker ' + className },
      react.createElement(common_EditableInput, {
        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
        label: 'hex',
        value: hex,
        onChange: handleChange
      }),
      react.createElement(
        'div',
        { style: styles.split, className: 'flexbox-fix' },
        react.createElement(
          'div',
          { style: styles.third },
          react.createElement(common_EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'r', value: rgb.r,
            onChange: handleChange
          })
        ),
        react.createElement(
          'div',
          { style: styles.third },
          react.createElement(common_EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'g',
            value: rgb.g,
            onChange: handleChange
          })
        ),
        react.createElement(
          'div',
          { style: styles.third },
          react.createElement(common_EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'b',
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};

/* harmony default export */ var material_Material = (common_ColorWrap(Material));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/photoshop/PhotoshopFields.js






var PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;

  var styles = (0,lib["default"])({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        top: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      isValidHex(data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return react.createElement(
    'div',
    { style: styles.fields },
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'h',
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 's',
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'v',
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    react.createElement('div', { style: styles.divider }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }),
    react.createElement('div', { style: styles.divider }),
    react.createElement(common_EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: '#',
      value: hex.replace('#', ''),
      onChange: handleChange
    }),
    react.createElement(
      'div',
      { style: styles.fieldSymbols },
      react.createElement(
        'div',
        { style: styles.symbol },
        '\xB0'
      ),
      react.createElement(
        'div',
        { style: styles.symbol },
        '%'
      ),
      react.createElement(
        'div',
        { style: styles.symbol },
        '%'
      )
    )
  );
};

/* harmony default export */ var PhotoshopFields = (PhotoshopPicker);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/photoshop/PhotoshopPointerCircle.js



var PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;

  var styles = (0,lib["default"])({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, { 'black-outline': hsl.l > 0.5 });

  return react.createElement('div', { style: styles.picker });
};

/* harmony default export */ var photoshop_PhotoshopPointerCircle = (PhotoshopPointerCircle);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/photoshop/PhotoshopPointer.js



var PhotoshopPointer_PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = (0,lib["default"])({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },

      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },

      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });

  return react.createElement(
    'div',
    { style: styles.pointer },
    react.createElement(
      'div',
      { style: styles.left },
      react.createElement('div', { style: styles.leftInside })
    ),
    react.createElement(
      'div',
      { style: styles.right },
      react.createElement('div', { style: styles.rightInside })
    )
  );
};

/* harmony default export */ var PhotoshopPointer = (PhotoshopPointer_PhotoshopPointerCircle);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/photoshop/PhotoshopButton.js



var PhotoshopButton = function PhotoshopButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;

  var styles = (0,lib["default"])({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, { active: active });

  return react.createElement(
    'div',
    { style: styles.button, onClick: onClick },
    label || children
  );
};

/* harmony default export */ var photoshop_PhotoshopButton = (PhotoshopButton);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/photoshop/PhotoshopPreviews.js



var PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;

  var styles = (0,lib["default"])({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      new: {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });

  return react.createElement(
    'div',
    null,
    react.createElement(
      'div',
      { style: styles.label },
      'new'
    ),
    react.createElement(
      'div',
      { style: styles.swatches },
      react.createElement('div', { style: styles.new }),
      react.createElement('div', { style: styles.current })
    ),
    react.createElement(
      'div',
      { style: styles.label },
      'current'
    )
  );
};

/* harmony default export */ var photoshop_PhotoshopPreviews = (PhotoshopPreviews);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/photoshop/Photoshop.js
var Photoshop_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Photoshop_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Photoshop_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Photoshop_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Photoshop = function (_React$Component) {
  Photoshop_inherits(Photoshop, _React$Component);

  function Photoshop(props) {
    Photoshop_classCallCheck(this, Photoshop);

    var _this = Photoshop_possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  Photoshop_createClass(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$styles = _props.styles,
          passedStyles = _props$styles === undefined ? {} : _props$styles,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className;

      var styles = (0,lib["default"])(lodash_es_merge({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      }, passedStyles));

      return react.createElement(
        'div',
        { style: styles.picker, className: 'photoshop-picker ' + className },
        react.createElement(
          'div',
          { style: styles.head },
          this.props.header
        ),
        react.createElement(
          'div',
          { style: styles.body, className: 'flexbox-fix' },
          react.createElement(
            'div',
            { style: styles.saturation },
            react.createElement(common_Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: photoshop_PhotoshopPointerCircle,
              onChange: this.props.onChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.hue },
            react.createElement(common_Hue, {
              direction: 'vertical',
              hsl: this.props.hsl,
              pointer: PhotoshopPointer,
              onChange: this.props.onChange
            })
          ),
          react.createElement(
            'div',
            { style: styles.controls },
            react.createElement(
              'div',
              { style: styles.top, className: 'flexbox-fix' },
              react.createElement(
                'div',
                { style: styles.previews },
                react.createElement(photoshop_PhotoshopPreviews, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              react.createElement(
                'div',
                { style: styles.actions },
                react.createElement(photoshop_PhotoshopButton, { label: 'OK', onClick: this.props.onAccept, active: true }),
                react.createElement(photoshop_PhotoshopButton, { label: 'Cancel', onClick: this.props.onCancel }),
                react.createElement(PhotoshopFields, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Photoshop;
}(react.Component);

Photoshop.propTypes = {
  header: (prop_types_default()).string,
  styles: (prop_types_default()).object
};

Photoshop.defaultProps = {
  header: 'Color Picker',
  styles: {}
};

/* harmony default export */ var photoshop_Photoshop = (common_ColorWrap(Photoshop));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/sketch/SketchFields.js
/* eslint-disable no-param-reassign */







var SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;

  var styles = (0,lib["default"])({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      double: {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return react.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    react.createElement(
      'div',
      { style: styles.double },
      react.createElement(common_EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
      })
    ),
    react.createElement(
      'div',
      { style: styles.single },
      react.createElement(common_EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    react.createElement(
      'div',
      { style: styles.single },
      react.createElement(common_EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    react.createElement(
      'div',
      { style: styles.single },
      react.createElement(common_EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    react.createElement(
      'div',
      { style: styles.alpha },
      react.createElement(common_EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
      })
    )
  );
};

/* harmony default export */ var sketch_SketchFields = (SketchFields);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/sketch/SketchPresetColors.js
var SketchPresetColors_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0,lib["default"])({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return react.createElement(
    'div',
    { style: styles.colors, className: 'flexbox-fix' },
    colors.map(function (colorObjOrString) {
      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
      var key = '' + c.color + (c.title || '');
      return react.createElement(
        'div',
        { key: key, style: styles.swatchWrap },
        react.createElement(common_Swatch, SketchPresetColors_extends({}, c, {
          style: styles.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
          }
        }))
      );
    })
  );
};

SketchPresetColors.propTypes = {
  colors: prop_types_default().arrayOf(prop_types_default().oneOfType([(prop_types_default()).string, prop_types_default().shape({
    color: (prop_types_default()).string,
    title: (prop_types_default()).string
  })])).isRequired
};

/* harmony default export */ var sketch_SketchPresetColors = (SketchPresetColors);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/sketch/Sketch.js
var Sketch_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': Sketch_extends({
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },

      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    }, passedStyles),
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return react.createElement(
    'div',
    { style: styles.picker, className: 'sketch-picker ' + className },
    react.createElement(
      'div',
      { style: styles.saturation },
      react.createElement(common_Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
      })
    ),
    react.createElement(
      'div',
      { style: styles.controls, className: 'flexbox-fix' },
      react.createElement(
        'div',
        { style: styles.sliders },
        react.createElement(
          'div',
          { style: styles.hue },
          react.createElement(common_Hue, {
            style: styles.Hue,
            hsl: hsl,
            onChange: onChange
          })
        ),
        react.createElement(
          'div',
          { style: styles.alpha },
          react.createElement(common_Alpha, {
            style: styles.Alpha,
            rgb: rgb,
            hsl: hsl,
            renderers: renderers,
            onChange: onChange
          })
        )
      ),
      react.createElement(
        'div',
        { style: styles.color },
        react.createElement(common_Checkboard, null),
        react.createElement('div', { style: styles.activeColor })
      )
    ),
    react.createElement(sketch_SketchFields, {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      onChange: onChange,
      disableAlpha: disableAlpha
    }),
    react.createElement(sketch_SketchPresetColors, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover: onSwatchHover
    })
  );
};

Sketch.propTypes = {
  disableAlpha: (prop_types_default()).bool,
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  styles: (prop_types_default()).object
};

Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};

/* harmony default export */ var sketch_Sketch = (common_ColorWrap(Sketch));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/slider/SliderSwatch.js



var SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;

  var styles = (0,lib["default"])({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, { active: active, first: first, last: last });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return react.createElement('div', { style: styles.swatch, onClick: handleClick });
};

/* harmony default export */ var slider_SliderSwatch = (SliderSwatch);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/slider/SliderSwatches.js





var SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;

  var styles = (0,lib["default"])({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        float: 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  // Acceptible difference in floating point equality
  var epsilon = 0.1;

  return react.createElement(
    'div',
    { style: styles.swatches },
    react.createElement(
      'div',
      { style: styles.swatch },
      react.createElement(slider_SliderSwatch, {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
      })
    ),
    react.createElement(
      'div',
      { style: styles.swatch },
      react.createElement(slider_SliderSwatch, {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    react.createElement(
      'div',
      { style: styles.swatch },
      react.createElement(slider_SliderSwatch, {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    react.createElement(
      'div',
      { style: styles.swatch },
      react.createElement(slider_SliderSwatch, {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    react.createElement(
      'div',
      { style: styles.swatch },
      react.createElement(slider_SliderSwatch, {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
      })
    ),
    react.createElement('div', { style: styles.clear })
  );
};

/* harmony default export */ var slider_SliderSwatches = (SliderSwatches);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/slider/SliderPointer.js



var SliderPointer_SliderPointer = function SliderPointer() {
  var styles = (0,lib["default"])({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return react.createElement('div', { style: styles.picker });
};

/* harmony default export */ var slider_SliderPointer = (SliderPointer_SliderPointer);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/slider/Slider.js









var Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  return react.createElement(
    'div',
    { style: styles.wrap || {}, className: 'slider-picker ' + className },
    react.createElement(
      'div',
      { style: styles.hue },
      react.createElement(common_Hue, {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
      })
    ),
    react.createElement(
      'div',
      { style: styles.swatches },
      react.createElement(slider_SliderSwatches, { hsl: hsl, onClick: onChange })
    )
  );
};

Slider.propTypes = {
  styles: (prop_types_default()).object
};
Slider.defaultProps = {
  pointer: slider_SliderPointer,
  styles: {}
};

/* harmony default export */ var slider_Slider = (common_ColorWrap(Slider));
// EXTERNAL MODULE: ../../node_modules/@icons/material/CheckIcon.js
var CheckIcon = __webpack_require__(47988);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/swatches/SwatchesColor.js







var SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;

  var styles = (0,lib["default"])({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        color: getContrastingColor(color),
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        color: '#333'
      }
    },
    'transparent': {
      check: {
        color: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });

  return react.createElement(
    common_Swatch,
    {
      color: color,
      style: styles.color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    react.createElement(
      'div',
      { style: styles.check },
      react.createElement(CheckIcon/* default */.Z, null)
    )
  );
};

/* harmony default export */ var swatches_SwatchesColor = (SwatchesColor);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/swatches/SwatchesGroup.js






var SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;

  var styles = (0,lib["default"])({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        float: 'left',
        marginRight: '10px'
      }
    }
  });

  return react.createElement(
    'div',
    { style: styles.group },
    lodash_es_map(group, function (color, i) {
      return react.createElement(swatches_SwatchesColor, {
        key: color,
        color: color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick: onClick,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

/* harmony default export */ var swatches_SwatchesGroup = (SwatchesGroup);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/swatches/Swatches.js










var Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    return onChange({ hex: data, source: 'hex' }, e);
  };

  return react.createElement(
    'div',
    { style: styles.picker, className: 'swatches-picker ' + className },
    react.createElement(
      common_Raised,
      null,
      react.createElement(
        'div',
        { style: styles.overflow },
        react.createElement(
          'div',
          { style: styles.body },
          lodash_es_map(colors, function (group) {
            return react.createElement(swatches_SwatchesGroup, {
              key: group.toString(),
              group: group,
              active: hex,
              onClick: handleChange,
              onSwatchHover: onSwatchHover
            });
          }),
          react.createElement('div', { style: styles.clear })
        )
      )
    )
  );
};

Swatches.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  height: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  colors: prop_types_default().arrayOf(prop_types_default().arrayOf((prop_types_default()).string)),
  styles: (prop_types_default()).object

  /* eslint-disable max-len */
};Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[colors_es2015_red[900], colors_es2015_red[700], colors_es2015_red[500], colors_es2015_red[300], colors_es2015_red[100]], [pink[900], pink[700], pink[500], pink[300], pink[100]], [purple[900], purple[700], purple[500], purple[300], purple[100]], [deepPurple[900], deepPurple[700], deepPurple[500], deepPurple[300], deepPurple[100]], [indigo[900], indigo[700], indigo[500], indigo[300], indigo[100]], [blue[900], blue[700], blue[500], blue[300], blue[100]], [lightBlue[900], lightBlue[700], lightBlue[500], lightBlue[300], lightBlue[100]], [cyan[900], cyan[700], cyan[500], cyan[300], cyan[100]], [teal[900], teal[700], teal[500], teal[300], teal[100]], ['#194D33', green[700], green[500], green[300], green[100]], [lightGreen[900], lightGreen[700], lightGreen[500], lightGreen[300], lightGreen[100]], [lime[900], lime[700], lime[500], lime[300], lime[100]], [yellow[900], yellow[700], yellow[500], yellow[300], yellow[100]], [amber[900], amber[700], amber[500], amber[300], amber[100]], [orange[900], orange[700], orange[500], orange[300], orange[100]], [deepOrange[900], deepOrange[700], deepOrange[500], deepOrange[300], deepOrange[100]], [brown[900], brown[700], brown[500], brown[300], brown[100]], [blueGrey[900], blueGrey[700], blueGrey[500], blueGrey[300], blueGrey[100]], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
  styles: {}
};

/* harmony default export */ var swatches_Swatches = (common_ColorWrap(Swatches));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/twitter/Twitter.js









var Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        float: 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        float: 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        float: 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return react.createElement(
    'div',
    { style: styles.card, className: 'twitter-picker ' + className },
    react.createElement('div', { style: styles.triangleShadow }),
    react.createElement('div', { style: styles.triangle }),
    react.createElement(
      'div',
      { style: styles.body },
      lodash_es_map(colors, function (c, i) {
        return react.createElement(common_Swatch, {
          key: i,
          color: c,
          hex: c,
          style: styles.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: '0 0 4px ' + c
          }
        });
      }),
      react.createElement(
        'div',
        { style: styles.hash },
        '#'
      ),
      react.createElement(common_EditableInput, {
        label: null,
        style: { input: styles.input },
        value: hex.replace('#', ''),
        onChange: handleChange
      }),
      react.createElement('div', { style: styles.clear })
    )
  );
};

Twitter.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  triangle: prop_types_default().oneOf(['hide', 'top-left', 'top-right']),
  colors: prop_types_default().arrayOf((prop_types_default()).string),
  styles: (prop_types_default()).object
};

Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left',
  styles: {}
};

/* harmony default export */ var twitter_Twitter = (common_ColorWrap(Twitter));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/google/GooglePointerCircle.js




var GooglePointerCircle = function GooglePointerCircle(props) {
  var styles = (0,lib["default"])({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        border: '2px #fff solid',
        transform: 'translate(-12px, -13px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
      }
    }
  });

  return react.createElement('div', { style: styles.picker });
};

GooglePointerCircle.propTypes = {
  hsl: prop_types_default().shape({
    h: (prop_types_default()).number,
    s: (prop_types_default()).number,
    l: (prop_types_default()).number,
    a: (prop_types_default()).number
  })
};

GooglePointerCircle.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
};

/* harmony default export */ var google_GooglePointerCircle = (GooglePointerCircle);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/google/GooglePointer.js




var GooglePointer = function GooglePointer(props) {
  var styles = (0,lib["default"])({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        transform: 'translate(-10px, -7px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
        border: '2px white solid'
      }
    }
  });

  return react.createElement('div', { style: styles.picker });
};

GooglePointer.propTypes = {
  hsl: prop_types_default().shape({
    h: (prop_types_default()).number,
    s: (prop_types_default()).number,
    l: (prop_types_default()).number,
    a: (prop_types_default()).number
  })
};

GooglePointer.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
};

/* harmony default export */ var google_GooglePointer = (GooglePointer);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/google/GoogleFields.js





var GoogleFields = function GoogleFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      hsv = _ref.hsv;


  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.rgb) {
      var values = data.rgb.split(',');
      isvalidColorString(data.rgb, 'rgb') && onChange({
        r: values[0],
        g: values[1],
        b: values[2],
        a: 1,
        source: 'rgb'
      }, e);
    } else if (data.hsv) {
      var _values = data.hsv.split(',');
      if (isvalidColorString(data.hsv, 'hsv')) {
        _values[2] = _values[2].replace('%', '');
        _values[1] = _values[1].replace('%', '');
        _values[0] = _values[0].replace('°', '');
        if (_values[1] == 1) {
          _values[1] = 0.01;
        } else if (_values[2] == 1) {
          _values[2] = 0.01;
        }
        onChange({
          h: Number(_values[0]),
          s: Number(_values[1]),
          v: Number(_values[2]),
          source: 'hsv'
        }, e);
      }
    } else if (data.hsl) {
      var _values2 = data.hsl.split(',');
      if (isvalidColorString(data.hsl, 'hsl')) {
        _values2[2] = _values2[2].replace('%', '');
        _values2[1] = _values2[1].replace('%', '');
        _values2[0] = _values2[0].replace('°', '');
        if (hsvValue[1] == 1) {
          hsvValue[1] = 0.01;
        } else if (hsvValue[2] == 1) {
          hsvValue[2] = 0.01;
        }
        onChange({
          h: Number(_values2[0]),
          s: Number(_values2[1]),
          v: Number(_values2[2]),
          source: 'hsl'
        }, e);
      }
    }
  };

  var styles = (0,lib["default"])({
    'default': {
      wrap: {
        display: 'flex',
        height: '100px',
        marginTop: '4px'
      },
      fields: {
        width: '100%'
      },
      column: {
        paddingTop: '10px',
        display: 'flex',
        justifyContent: 'space-between'
      },
      double: {
        padding: '0px 4.4px',
        boxSizing: 'border-box'
      },
      input: {
        width: '100%',
        height: '38px',
        boxSizing: 'border-box',
        padding: '4px 10% 3px',
        textAlign: 'center',
        border: '1px solid #dadce0',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      input2: {
        height: '38px',
        width: '100%',
        border: '1px solid #dadce0',
        boxSizing: 'border-box',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        paddingLeft: '10px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label: {
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '35px',
        top: '-6px',
        left: '0',
        right: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label2: {
        left: '10px',
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '32px',
        top: '-6px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      single: {
        flexGrow: '1',
        margin: '0px 4.4px'
      }
    }
  });

  var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
  var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
  var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';

  return react.createElement(
    'div',
    { style: styles.wrap, className: 'flexbox-fix' },
    react.createElement(
      'div',
      { style: styles.fields },
      react.createElement(
        'div',
        { style: styles.double },
        react.createElement(common_EditableInput, {
          style: { input: styles.input, label: styles.label },
          label: 'hex',
          value: hex,
          onChange: handleChange
        })
      ),
      react.createElement(
        'div',
        { style: styles.column },
        react.createElement(
          'div',
          { style: styles.single },
          react.createElement(common_EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'rgb',
            value: rgbValue,
            onChange: handleChange
          })
        ),
        react.createElement(
          'div',
          { style: styles.single },
          react.createElement(common_EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'hsv',
            value: hsvValue,
            onChange: handleChange
          })
        ),
        react.createElement(
          'div',
          { style: styles.single },
          react.createElement(common_EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'hsl',
            value: hslValue,
            onChange: handleChange
          })
        )
      )
    )
  );
};

/* harmony default export */ var google_GoogleFields = (GoogleFields);
;// CONCATENATED MODULE: ../../node_modules/react-color/es/components/google/Google.js










var Google = function Google(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      header = _ref.header,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0,lib["default"])(lodash_es_merge({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        border: '1px solid #dfe1e5',
        boxSizing: 'initial',
        display: 'flex',
        flexWrap: 'wrap',
        borderRadius: '8px 8px 0px 0px'
      },
      head: {
        height: '57px',
        width: '100%',
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingLeft: '16px',
        fontSize: '20px',
        boxSizing: 'border-box',
        fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
      },
      saturation: {
        width: '70%',
        padding: '0px',
        position: 'relative',
        overflow: 'hidden'
      },
      swatch: {
        width: '30%',
        height: '228px',
        padding: '0px',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
        position: 'relative',
        overflow: 'hidden'
      },
      body: {
        margin: 'auto',
        width: '95%'
      },
      controls: {
        display: 'flex',
        boxSizing: 'border-box',
        height: '52px',
        paddingTop: '22px'
      },
      color: {
        width: '32px'
      },
      hue: {
        height: '8px',
        position: 'relative',
        margin: '0px 16px 0px 16px',
        width: '100%'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));
  return react.createElement(
    'div',
    { style: styles.picker, className: 'google-picker ' + className },
    react.createElement(
      'div',
      { style: styles.head },
      header
    ),
    react.createElement('div', { style: styles.swatch }),
    react.createElement(
      'div',
      { style: styles.saturation },
      react.createElement(common_Saturation, {
        hsl: hsl,
        hsv: hsv,
        pointer: google_GooglePointerCircle,
        onChange: onChange
      })
    ),
    react.createElement(
      'div',
      { style: styles.body },
      react.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        react.createElement(
          'div',
          { style: styles.hue },
          react.createElement(common_Hue, {
            style: styles.Hue,
            hsl: hsl,
            radius: '4px',
            pointer: google_GooglePointer,
            onChange: onChange
          })
        )
      ),
      react.createElement(google_GoogleFields, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
      })
    )
  );
};

Google.propTypes = {
  width: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
  styles: (prop_types_default()).object,
  header: (prop_types_default()).string

};

Google.defaultProps = {
  width: 652,
  styles: {},
  header: 'Color picker'
};

/* harmony default export */ var google_Google = (common_ColorWrap(Google));
;// CONCATENATED MODULE: ../../node_modules/react-color/es/index.js



















/***/ }),

/***/ 51463:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Alpha = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(7151);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _alpha = __webpack_require__(39391);

var alpha = _interopRequireWildcard(_alpha);

var _Checkboard = __webpack_require__(25809);

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alpha = exports.Alpha = function (_ref) {
  _inherits(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = (0, _reactcss2.default)({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return _react2.default.createElement(
        'div',
        { style: styles.alpha },
        _react2.default.createElement(
          'div',
          { style: styles.checkboard },
          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
        ),
        _react2.default.createElement('div', { style: styles.gradient }),
        _react2.default.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(_react.PureComponent || _react.Component);

exports["default"] = Alpha;

/***/ }),

/***/ 25809:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Checkboard = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(7151);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _checkboard = __webpack_require__(26127);

var checkboard = _interopRequireWildcard(_checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkboard = exports.Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      children = _ref.children;

  var styles = (0, _reactcss2.default)({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });
  return (0, _react.isValidElement)(children) ? _react2.default.cloneElement(children, _extends({}, children.props, { style: _extends({}, children.props.style, styles.grid) })) : _react2.default.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

exports["default"] = Checkboard;

/***/ }),

/***/ 52925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ColorWrap = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _debounce = __webpack_require__(54073);

var _debounce2 = _interopRequireDefault(_debounce);

var _color = __webpack_require__(25327);

var color = _interopRequireWildcard(_color);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck(this, ColorPicker);

      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = color.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = color.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = color.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = color.toState(data, data.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends({}, color.toState(props.color, 0));

      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass(ColorPicker, [{
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends({}, color.toState(nextProps.color, state.oldHue));
      }
    }]);

    return ColorPicker;
  }(_react.PureComponent || _react.Component);

  ColorPicker.propTypes = _extends({}, Picker.propTypes);

  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

exports["default"] = ColorWrap;

/***/ }),

/***/ 90066:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.EditableInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(7151);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_ARROW_OFFSET = 1;

var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
  return Number(String(value).replace(/%/g, ''));
};

var idCounter = 1;

var EditableInput = exports.EditableInput = function (_ref) {
  _inherits(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck(this, EditableInput);

    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      _this.setUpdatedValue(e.target.value, e);
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var value = getNumberValue(e.target.value);
      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();
        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

        _this.setUpdatedValue(updatedValue, e);
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };

    _this.inputId = 'rc-editable-input-' + idCounter++;
    return _this;
  }

  _createClass(EditableInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({ blurValue: String(this.props.value).toUpperCase() });
        } else {
          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'getValueObjectWithLabel',
    value: function getValueObjectWithLabel(value) {
      return _defineProperty({}, this.props.label, value);
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: 'setUpdatedValue',
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);

      this.setState({ value: value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return _react2.default.createElement(
        'div',
        { style: styles.wrap },
        _react2.default.createElement('input', {
          id: this.inputId,
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label && !this.props.hideLabel ? _react2.default.createElement(
          'label',
          {
            htmlFor: this.inputId,
            style: styles.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(_react.PureComponent || _react.Component);

exports["default"] = EditableInput;

/***/ }),

/***/ 71780:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Hue = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(7151);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _hue = __webpack_require__(52000);

var hue = _interopRequireWildcard(_hue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hue = exports.Hue = function (_ref) {
  _inherits(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = (0, _reactcss2.default)({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return _react2.default.createElement(
        'div',
        { style: styles.hue },
        _react2.default.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(_react.PureComponent || _react.Component);

exports["default"] = Hue;

/***/ }),

/***/ 64410:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Raised = undefined;

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(7151);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = __webpack_require__(98537);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Raised = exports.Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, passedStyles), { 'zDepth-1': zDepth === 1 });

  return _react2.default.createElement(
    'div',
    { style: styles.wrap },
    _react2.default.createElement('div', { style: styles.bg }),
    _react2.default.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: _propTypes2.default.string,
  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
  radius: _propTypes2.default.number,
  styles: _propTypes2.default.object
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2,
  styles: {}
};

exports["default"] = Raised;

/***/ }),

/***/ 2361:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Saturation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(7151);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _throttle = __webpack_require__(12436);

var _throttle2 = _interopRequireDefault(_throttle);

var _saturation = __webpack_require__(16026);

var saturation = _interopRequireWildcard(_saturation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Saturation = exports.Saturation = function (_ref) {
  _inherits(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck(this, Saturation);

    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e) {
      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, saturation.calculateChange(e, _this.props.hsl, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      var renderWindow = _this.getContainerRenderWindow();
      renderWindow.addEventListener('mousemove', _this.handleChange);
      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: 'getContainerRenderWindow',
    value: function getContainerRenderWindow() {
      var container = this.container;

      var renderWindow = window;
      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }
      return renderWindow;
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener('mousemove', this.handleChange);
      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = (0, _reactcss2.default)({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return _react2.default.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        _react2.default.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        _react2.default.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(_react.PureComponent || _react.Component);

exports["default"] = Saturation;

/***/ }),

/***/ 25923:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Swatch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(7151);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _interaction = __webpack_require__(88888);

var _Checkboard = __webpack_require__(25809);

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER = 13;

var Swatch = exports.Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = (0, _reactcss2.default)({
    default: {
      swatch: _extends({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return _react2.default.createElement(
    'div',
    _extends({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && _react2.default.createElement(_Checkboard2.default, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

exports["default"] = (0, _interaction.handleFocus)(Swatch);

/***/ }),

/***/ 92375:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _Alpha = __webpack_require__(51463);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Checkboard = __webpack_require__(25809);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkboard).default;
  }
});

var _EditableInput = __webpack_require__(90066);

Object.defineProperty(exports, "Vm", ({
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditableInput).default;
  }
}));

var _Hue = __webpack_require__(71780);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Raised = __webpack_require__(64410);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Raised).default;
  }
});

var _Saturation = __webpack_require__(2361);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Saturation).default;
  }
});

var _ColorWrap = __webpack_require__(52925);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Swatch = __webpack_require__(25923);

__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 39391:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var calculateChange = exports.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (hsl.a !== a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (initialA !== _a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};

/***/ }),

/***/ 26127:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var checkboardCache = {};

var render = exports.render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

var get = exports.get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }

  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};

/***/ }),

/***/ 25327:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isvalidColorString = exports.red = exports.getContrastingColor = exports.isValidHex = exports.toState = exports.simpleCheckForValidColor = undefined;

var _each = __webpack_require__(79421);

var _each2 = _interopRequireDefault(_each);

var _tinycolor = __webpack_require__(98621);

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var simpleCheckForValidColor = exports.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
  var checked = 0;
  var passed = 0;
  (0, _each2.default)(keysToCheck, function (letter) {
    if (data[letter]) {
      checked += 1;
      if (!isNaN(data[letter])) {
        passed += 1;
      }
      if (letter === 's' || letter === 'l') {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data : false;
};

var toState = exports.toState = function toState(data, oldHue) {
  var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();
  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex === '000000' && rgb.a === 0;

  return {
    hsl: hsl,
    hex: transparent ? 'transparent' : '#' + hex,
    rgb: rgb,
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source
  };
};

var isValidHex = exports.isValidHex = function isValidHex(hex) {
  if (hex === 'transparent') {
    return true;
  }
  // disable hex4 and hex8
  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
};

var getContrastingColor = exports.getContrastingColor = function getContrastingColor(data) {
  if (!data) {
    return '#fff';
  }
  var col = toState(data);
  if (col.hex === 'transparent') {
    return 'rgba(0,0,0,0.4)';
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
};

var red = exports.red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

var isvalidColorString = exports.isvalidColorString = function isvalidColorString(string, type) {
  var stringWithoutDegree = string.replace('°', '');
  return (0, _tinycolor2.default)(type + ' (' + stringWithoutDegree + ')')._ok;
};

/***/ }),

/***/ 52000:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var calculateChange = exports.calculateChange = function calculateChange(e, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (hsl.h !== h) {
      return {
        h: h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  }
  return null;
};

/***/ }),

/***/ 88888:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.handleFocus = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */


var handleFocus = exports.handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Focus, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          _react2.default.createElement(Component, _extends({}, this.props, this.state))
        );
      }
    }]);

    return Focus;
  }(_react2.default.Component);
};

/***/ }),

/***/ 16026:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var calculateChange = exports.calculateChange = function calculateChange(e, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;

  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'hsv'
  };
};

/***/ }),

/***/ 37726:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(2784),__webpack_require__(13980),__webpack_require__(72779),__webpack_require__(72968),__webpack_require__(4478),__webpack_require__(73053),__webpack_require__(23107),__webpack_require__(20578),__webpack_require__(63761),__webpack_require__(85014),__webpack_require__(28187),__webpack_require__(52946),__webpack_require__(50272),__webpack_require__(75887),__webpack_require__(96913),__webpack_require__(65032),__webpack_require__(94873),__webpack_require__(46318),__webpack_require__(33963),__webpack_require__(34908),__webpack_require__(99994),__webpack_require__(98465),__webpack_require__(35459),__webpack_require__(2800),__webpack_require__(51981),__webpack_require__(81139),__webpack_require__(81914),__webpack_require__(17254),__webpack_require__(8868),__webpack_require__(99791),__webpack_require__(63673),__webpack_require__(22110),__webpack_require__(89968),__webpack_require__(42019),__webpack_require__(97208),__webpack_require__(13621),__webpack_require__(8849),__webpack_require__(92082),__webpack_require__(50356),__webpack_require__(93399),__webpack_require__(10405),__webpack_require__(49122),__webpack_require__(12414),__webpack_require__(73116),__webpack_require__(81290),__webpack_require__(11106),__webpack_require__(10194),__webpack_require__(8548),__webpack_require__(46326),__webpack_require__(82276),__webpack_require__(53009),__webpack_require__(31794),__webpack_require__(80143),__webpack_require__(42598),__webpack_require__(63063),__webpack_require__(1713),__webpack_require__(66700),__webpack_require__(65662),__webpack_require__(31807),__webpack_require__(80185),__webpack_require__(28316),__webpack_require__(94592)):0}(this,(function(e,t,r,a,n,o,s,i,p,l,d,c,u,f,h,m,y,D,v,w,g,k,b,S,C,_,M,P,E,N,x,O,Y,I,T,L,R,F,A,q,W,B,K,H,j,Q,V,U,$,z,G,J,X,Z,ee,te,re,ae,ne,oe,se,ie,pe){"use strict";function le(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var de=le(t),ce=le(a),ue=le(n),fe=le(o),he=le(s),me=le(i),ye=le(p),De=le(l),ve=le(d),we=le(c),ge=le(u),ke=le(m),be=le(y),Se=le(D),Ce=le(v),_e=le(w),Me=le(g),Pe=le(k),Ee=le(b),Ne=le(S),xe=le(C),Oe=le(_),Ye=le(M),Ie=le(P),Te=le(E),Le=le(N),Re=le(x),Fe=le(O),Ae=le(Y),qe=le(I),We=le(T),Be=le(L),Ke=le(R),He=le(F),je=le(A),Qe=le(W),Ve=le(B),Ue=le(K),$e=le(H),ze=le(j),Ge=le(Q),Je=le(V),Xe=le(z),Ze=le(G),et=le(J),tt=le(X),rt=le(Z),at=le(ee),nt=le(te),ot=le(re),st=le(ae),it=le(ne),pt=le(oe),lt=le(se),dt=le(ie);function ct(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,a)}return r}function ut(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?ct(Object(r),!0).forEach((function(t){Dt(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):ct(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function ft(e){return(ft="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ht(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function mt(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function yt(e,t,r){return t&&mt(e.prototype,t),r&&mt(e,r),Object.defineProperty(e,"prototype",{writable:!1}),e}function Dt(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function vt(){return(vt=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var a in r)Object.prototype.hasOwnProperty.call(r,a)&&(e[a]=r[a])}return e}).apply(this,arguments)}function wt(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");Object.defineProperty(e,"prototype",{value:Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),writable:!1}),t&&kt(e,t)}function gt(e){return(gt=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function kt(e,t){return(kt=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function bt(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function St(e,t){if(t&&("object"==typeof t||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return bt(e)}function Ct(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=gt(e);if(t){var n=gt(this).constructor;r=Reflect.construct(a,arguments,n)}else r=a.apply(this,arguments);return St(this,r)}}function _t(e){return function(e){if(Array.isArray(e))return Mt(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return Mt(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return Mt(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Mt(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,a=new Array(t);r<t;r++)a[r]=e[r];return a}function Pt(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function Et(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}var Nt={p:Et,P:function(e,t){var r,a=e.match(/(P+)(p+)?/)||[],n=a[1],o=a[2];if(!o)return Pt(e,t);switch(n){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;case"PPPP":default:r=t.dateTime({width:"full"})}return r.replace("{{date}}",Pt(n,t)).replace("{{time}}",Et(o,t))}},xt=12,Ot=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function Yt(e){var t=e?"string"==typeof e||e instanceof String?pt.default(e):st.default(e):new Date;return Tt(t)?t:null}function It(e,t,r,a,n){var o=null,s=Xt(r)||Xt(Jt()),i=!0;return Array.isArray(t)?(t.forEach((function(t){var p=it.default(e,t,new Date,{locale:s});a&&(i=Tt(p,n)&&e===Lt(p,t,r)),Tt(p,n)&&i&&(o=p)})),o):(o=it.default(e,t,new Date,{locale:s}),a?i=Tt(o)&&e===Lt(o,t,r):Tt(o)||(t=t.match(Ot).map((function(e){var t=e[0];return"p"===t||"P"===t?s?(0,Nt[t])(e,s.formatLong):t:e})).join(""),e.length>0&&(o=it.default(e,t.slice(0,e.length),new Date)),Tt(o)||(o=new Date(e))),Tt(o)&&i?o:null)}function Tt(e,t){return t=t||new Date("1/1/1000"),fe.default(e)&&!nt.default(e,t)}function Lt(e,t,r){if("en"===r)return he.default(e,t,{awareOfUnicodeTokens:!0});var a=Xt(r);return r&&!a&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!a&&Jt()&&Xt(Jt())&&(a=Xt(Jt())),he.default(e,t,{locale:a||null,awareOfUnicodeTokens:!0})}function Rt(e,t){var r=t.dateFormat,a=t.locale;return e&&Lt(e,Array.isArray(r)?r[0]:r,a)||""}function Ft(e,t){var r=t.hour,a=void 0===r?0:r,n=t.minute,o=void 0===n?0:n,s=t.second,i=void 0===s?0:s;return Fe.default(Re.default(Le.default(e,i),o),a)}function At(e,t){var r=t&&Xt(t)||Jt()&&Xt(Jt());return xe.default(e,r?{locale:r}:null)}function qt(e,t){return Lt(e,"ddd",t)}function Wt(e){return Ve.default(e)}function Bt(e,t,r){var a=Xt(t||Jt());return Ue.default(e,{locale:a,weekStartsOn:r})}function Kt(e){return $e.default(e)}function Ht(e){return Ge.default(e)}function jt(e){return ze.default(e)}function Qt(e,t){return e&&t?tt.default(e,t):!e&&!t}function Vt(e,t){return e&&t?et.default(e,t):!e&&!t}function Ut(e,t){return e&&t?rt.default(e,t):!e&&!t}function $t(e,t){return e&&t?Ze.default(e,t):!e&&!t}function zt(e,t){return e&&t?Xe.default(e,t):!e&&!t}function Gt(e,t,r){var a,n=Ve.default(t),o=Je.default(r);try{a=ot.default(e,{start:n,end:o})}catch(e){a=!1}return a}function Jt(){return("undefined"!=typeof window?window:globalThis).__localeId__}function Xt(e){if("string"==typeof e){var t="undefined"!=typeof window?window:globalThis;return t.__localeData__?t.__localeData__[e]:null}return e}function Zt(e,t){return Lt(Ae.default(Yt(),e),"LLLL",t)}function er(e,t){return Lt(Ae.default(Yt(),e),"LLL",t)}function tr(e,t){return Lt(qe.default(Yt(),e),"QQQ",t)}function rr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.excludeDateIntervals,s=t.includeDates,i=t.includeDateIntervals,p=t.filterDate;return lr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return $t(e,t)}))||o&&o.some((function(t){var r=t.start,a=t.end;return ot.default(e,{start:r,end:a})}))||s&&!s.some((function(t){return $t(e,t)}))||i&&!i.some((function(t){var r=t.start,a=t.end;return ot.default(e,{start:r,end:a})}))||p&&!p(Yt(e))||!1}function ar(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates,a=t.excludeDateIntervals;return a&&a.length>0?a.some((function(t){var r=t.start,a=t.end;return ot.default(e,{start:r,end:a})})):r&&r.some((function(t){return $t(e,t)}))||!1}function nr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return lr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Vt(e,t)}))||o&&!o.some((function(t){return Vt(e,t)}))||s&&!s(Yt(e))||!1}function or(e,t,r,a){var n=Ie.default(e),o=Oe.default(e),s=Ie.default(t),i=Oe.default(t),p=Ie.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function sr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return lr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Ut(e,t)}))||o&&!o.some((function(t){return Ut(e,t)}))||s&&!s(Yt(e))||!1}function ir(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=new Date(e,0,1);return lr(n,{minDate:r,maxDate:a})||!1}function pr(e,t,r,a){var n=Ie.default(e),o=Ye.default(e),s=Ie.default(t),i=Ye.default(t),p=Ie.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function lr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate;return r&&He.default(e,r)<0||a&&He.default(e,a)>0}function dr(e,t){return t.some((function(t){return Pe.default(t)===Pe.default(e)&&Me.default(t)===Me.default(e)}))}function cr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,a=t.includeTimes,n=t.filterTime;return r&&dr(e,r)||a&&!dr(e,a)||n&&!n(e)||!1}function ur(e,t){var r=t.minTime,a=t.maxTime;if(!r||!a)throw new Error("Both minTime and maxTime props required");var n,o=Yt(),s=Fe.default(Re.default(o,Me.default(e)),Pe.default(e)),i=Fe.default(Re.default(o,Me.default(r)),Pe.default(r)),p=Fe.default(Re.default(o,Me.default(a)),Pe.default(a));try{n=!ot.default(s,{start:i,end:p})}catch(e){n=!1}return n}function fr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Se.default(e,1);return r&&je.default(r,n)>0||a&&a.every((function(e){return je.default(e,n)>0}))||!1}function hr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=we.default(e,1);return r&&je.default(n,r)>0||a&&a.every((function(e){return je.default(n,e)>0}))||!1}function mr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Ce.default(e,1);return r&&Qe.default(r,n)>0||a&&a.every((function(e){return Qe.default(e,n)>0}))||!1}function yr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=ge.default(e,1);return r&&Qe.default(n,r)>0||a&&a.every((function(e){return Qe.default(n,e)>0}))||!1}function Dr(e){var t=e.minDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return He.default(e,t)>=0}));return Be.default(a)}return r?Be.default(r):t}function vr(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return He.default(e,t)<=0}));return Ke.default(a)}return r?Ke.default(r):t}function wr(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,a=0,n=e.length;a<n;a++){var o=e[a];if(ue.default(o)){var s=Lt(o,"MM.dd.yyyy"),i=r.get(s)||[];i.includes(t)||(i.push(t),r.set(s,i))}else if("object"===ft(o)){var p=Object.keys(o),l=p[0],d=o[p[0]];if("string"==typeof l&&d.constructor===Array)for(var c=0,u=d.length;c<u;c++){var f=Lt(d[c],"MM.dd.yyyy"),h=r.get(f)||[];h.includes(l)||(h.push(l),r.set(f,h))}}}return r}function gr(e,t,r,a,n){for(var o=n.length,s=[],i=0;i<o;i++){var p=me.default(ye.default(e,Pe.default(n[i])),Me.default(n[i])),l=me.default(e,(r+1)*a);at.default(p,t)&&nt.default(p,l)&&s.push(n[i])}return s}function kr(e){return e<10?"0".concat(e):"".concat(e)}function br(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:xt,r=Math.ceil(Ie.default(e)/t)*t,a=r-(t-1);return{startPeriod:a,endPeriod:r}}function Sr(e,t,r,a){for(var n=[],o=0;o<2*t+1;o++){var s=e+t-o,i=!0;r&&(i=Ie.default(r)<=s),a&&i&&(i=Ie.default(a)>=s),i&&n.push(s)}return n}var Cr=function(e){wt(a,e);var r=Ct(a);function a(e){var n;ht(this,a),Dt(bt(n=r.call(this,e)),"renderOptions",(function(){var e=n.props.year,t=n.state.yearsList.map((function(t){return de.default.createElement("div",{className:e===t?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:t,onClick:n.onChange.bind(bt(n),t),"aria-selected":e===t?"true":void 0},e===t?de.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)})),r=n.props.minDate?Ie.default(n.props.minDate):null,a=n.props.maxDate?Ie.default(n.props.maxDate):null;return a&&n.state.yearsList.find((function(e){return e===a}))||t.unshift(de.default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:n.incrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),r&&n.state.yearsList.find((function(e){return e===r}))||t.push(de.default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:n.decrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t})),Dt(bt(n),"onChange",(function(e){n.props.onChange(e)})),Dt(bt(n),"handleClickOutside",(function(){n.props.onCancel()})),Dt(bt(n),"shiftYears",(function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t})})),Dt(bt(n),"incrementYears",(function(){return n.shiftYears(1)})),Dt(bt(n),"decrementYears",(function(){return n.shiftYears(-1)}));var o=e.yearDropdownItemNumber,s=e.scrollableYearDropdown,i=o||(s?10:5);return n.state={yearsList:Sr(n.props.year,i,n.props.minDate,n.props.maxDate)},n.dropdownRef=t.createRef(),n}return yt(a,[{key:"componentDidMount",value:function(){var e=this.dropdownRef.current;e&&(e.scrollTop=e.scrollHeight/2-e.clientHeight/2)}},{key:"render",value:function(){var e=ce.default({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return de.default.createElement("div",{className:e,ref:this.dropdownRef},this.renderOptions())}}]),a}(de.default.Component),_r=lt.default(Cr),Mr=function(e){wt(r,e);var t=Ct(r);function r(){var e;ht(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return Dt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),Dt(bt(e),"renderSelectOptions",(function(){for(var t=e.props.minDate?Ie.default(e.props.minDate):1900,r=e.props.maxDate?Ie.default(e.props.maxDate):2100,a=[],n=t;n<=r;n++)a.push(de.default.createElement("option",{key:n,value:n},n));return a})),Dt(bt(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),Dt(bt(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),Dt(bt(e),"renderReadView",(function(t){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),Dt(bt(e),"renderDropdown",(function(){return de.default.createElement(_r,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),Dt(bt(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),Dt(bt(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t)})),Dt(bt(e),"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t)}))})),Dt(bt(e),"handleYearChange",(function(t,r){e.onSelect(t,r),e.setOpen()})),Dt(bt(e),"onSelect",(function(t,r){e.props.onSelect&&e.props.onSelect(t,r)})),Dt(bt(e),"setOpen",(function(){e.props.setOpen&&e.props.setOpen(!0)})),e}return yt(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Pr=function(e){wt(r,e);var t=Ct(r);function r(){var e;ht(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return Dt(bt(e=t.call.apply(t,[this].concat(n))),"isSelectedMonth",(function(t){return e.props.month===t})),Dt(bt(e),"renderOptions",(function(){return e.props.monthNames.map((function(t,r){return de.default.createElement("div",{className:e.isSelectedMonth(r)?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:t,onClick:e.onChange.bind(bt(e),r),"aria-selected":e.isSelectedMonth(r)?"true":void 0},e.isSelectedMonth(r)?de.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",t)}))})),Dt(bt(e),"onChange",(function(t){return e.props.onChange(t)})),Dt(bt(e),"handleClickOutside",(function(){return e.props.onCancel()})),e}return yt(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}(de.default.Component),Er=lt.default(Pr),Nr=function(e){wt(r,e);var t=Ct(r);function r(){var e;ht(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return Dt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),Dt(bt(e),"renderSelectOptions",(function(e){return e.map((function(e,t){return de.default.createElement("option",{key:t,value:t},e)}))})),Dt(bt(e),"renderSelectMode",(function(t){return de.default.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(t))})),Dt(bt(e),"renderReadView",(function(t,r){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},de.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[e.props.month]))})),Dt(bt(e),"renderDropdown",(function(t){return de.default.createElement(Er,{key:"dropdown",month:e.props.month,monthNames:t,onChange:e.onChange,onCancel:e.toggleDropdown})})),Dt(bt(e),"renderScrollMode",(function(t){var r=e.state.dropdownVisible,a=[e.renderReadView(!r,t)];return r&&a.unshift(e.renderDropdown(t)),a})),Dt(bt(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t)})),Dt(bt(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return yt(r,[{key:"render",value:function(){var e,t=this,r=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return er(e,t.props.locale)}:function(e){return Zt(e,t.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(r);break;case"select":e=this.renderSelectMode(r)}return de.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component);function xr(e,t){for(var r=[],a=Kt(e),n=Kt(t);!at.default(a,n);)r.push(Yt(a)),a=we.default(a,1);return r}var Or=function(e){wt(r,e);var t=Ct(r);function r(e){var a;return ht(this,r),Dt(bt(a=t.call(this,e)),"renderOptions",(function(){return a.state.monthYearsList.map((function(e){var t=Te.default(e),r=Qt(a.props.date,e)&&Vt(a.props.date,e);return de.default.createElement("div",{className:r?"react-datepicker__month-year-option--selected_month-year":"react-datepicker__month-year-option",key:t,onClick:a.onChange.bind(bt(a),t),"aria-selected":r?"true":void 0},r?de.default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Lt(e,a.props.dateFormat,a.props.locale))}))})),Dt(bt(a),"onChange",(function(e){return a.props.onChange(e)})),Dt(bt(a),"handleClickOutside",(function(){a.props.onCancel()})),a.state={monthYearsList:xr(a.props.minDate,a.props.maxDate)},a}return yt(r,[{key:"render",value:function(){var e=ce.default({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),r}(de.default.Component),Yr=lt.default(Or),Ir=function(e){wt(r,e);var t=Ct(r);function r(){var e;ht(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return Dt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),Dt(bt(e),"renderSelectOptions",(function(){for(var t=Kt(e.props.minDate),r=Kt(e.props.maxDate),a=[];!at.default(t,r);){var n=Te.default(t);a.push(de.default.createElement("option",{key:n,value:n},Lt(t,e.props.dateFormat,e.props.locale))),t=we.default(t,1)}return a})),Dt(bt(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),Dt(bt(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:Te.default(Kt(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),Dt(bt(e),"renderReadView",(function(t){var r=Lt(e.props.date,e.props.dateFormat,e.props.locale);return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))})),Dt(bt(e),"renderDropdown",(function(){return de.default.createElement(Yr,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown,locale:e.props.locale})})),Dt(bt(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),Dt(bt(e),"onChange",(function(t){e.toggleDropdown();var r=Yt(parseInt(t));Qt(e.props.date,r)&&Vt(e.props.date,r)||e.props.onChange(r)})),Dt(bt(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return yt(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Tr=function(e){wt(r,e);var t=Ct(r);function r(){var e;ht(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return Dt(bt(e=t.call.apply(t,[this].concat(n))),"dayEl",de.default.createRef()),Dt(bt(e),"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t)})),Dt(bt(e),"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t)})),Dt(bt(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),Dt(bt(e),"isSameDay",(function(t){return $t(e.props.day,t)})),Dt(bt(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!e.isSameDay(e.props.selected)&&e.isSameDay(e.props.preSelection)})),Dt(bt(e),"isDisabled",(function(){return rr(e.props.day,e.props)})),Dt(bt(e),"isExcluded",(function(){return ar(e.props.day,e.props)})),Dt(bt(e),"getHighLightedClass",(function(t){var r=e.props,a=r.day,n=r.highlightDates;if(!n)return!1;var o=Lt(a,"MM.dd.yyyy");return n.get(o)})),Dt(bt(e),"isInRange",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Gt(r,a,n)})),Dt(bt(e),"isInSelectingRange",(function(){var t,r=e.props,a=r.day,n=r.selectsStart,o=r.selectsEnd,s=r.selectsRange,i=r.selectsDisabledDaysInRange,p=r.startDate,l=r.endDate,d=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return!(!(n||o||s)||!d||!i&&e.isDisabled())&&(n&&l&&(nt.default(d,l)||zt(d,l))?Gt(a,d,l):(o&&p&&(at.default(d,p)||zt(d,p))||!(!s||!p||l||!at.default(d,p)&&!zt(d,p)))&&Gt(a,p,d))})),Dt(bt(e),"isSelectingRangeStart",(function(){var t;if(!e.isInSelectingRange())return!1;var r=e.props,a=r.day,n=r.startDate,o=r.selectsStart,s=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return $t(a,o?s:n)})),Dt(bt(e),"isSelectingRangeEnd",(function(){var t;if(!e.isInSelectingRange())return!1;var r=e.props,a=r.day,n=r.endDate,o=r.selectsEnd,s=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return $t(a,o?s:n)})),Dt(bt(e),"isRangeStart",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&$t(a,r)})),Dt(bt(e),"isRangeEnd",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&$t(n,r)})),Dt(bt(e),"isWeekend",(function(){var t=Ee.default(e.props.day);return 0===t||6===t})),Dt(bt(e),"isAfterMonth",(function(){return void 0!==e.props.month&&(e.props.month+1)%12===Oe.default(e.props.day)})),Dt(bt(e),"isBeforeMonth",(function(){return void 0!==e.props.month&&(Oe.default(e.props.day)+1)%12===e.props.month})),Dt(bt(e),"isCurrentDay",(function(){return e.isSameDay(Yt())})),Dt(bt(e),"isSelected",(function(){return e.isSameDay(e.props.selected)})),Dt(bt(e),"getClassNames",(function(t){var r=e.props.dayClassName?e.props.dayClassName(t):void 0;return ce.default("react-datepicker__day",r,"react-datepicker__day--"+qt(e.props.day),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSelected(),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isCurrentDay(),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isAfterMonth()||e.isBeforeMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"))})),Dt(bt(e),"getAriaLabel",(function(){var t=e.props,r=t.day,a=t.ariaLabelPrefixWhenEnabled,n=void 0===a?"Choose":a,o=t.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,i=e.isDisabled()||e.isExcluded()?s:n;return"".concat(i," ").concat(Lt(r,"PPPP",e.props.locale))})),Dt(bt(e),"getTabIndex",(function(t,r){var a=t||e.props.selected,n=r||e.props.preSelection;return e.isKeyboardSelected()||e.isSameDay(a)&&$t(n,a)?0:-1})),Dt(bt(e),"handleFocusDay",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===e.getTabIndex()&&!t.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),e.props.inline&&!e.props.shouldFocusDayInline&&(r=!1),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(r=!0)),r&&e.dayEl.current.focus({preventScroll:!0})})),Dt(bt(e),"renderDayContents",(function(){return e.props.monthShowsDuplicateDaysEnd&&e.isAfterMonth()||e.props.monthShowsDuplicateDaysStart&&e.isBeforeMonth()?null:e.props.renderDayContents?e.props.renderDayContents(Ne.default(e.props.day),e.props.day):Ne.default(e.props.day)})),Dt(bt(e),"render",(function(){return de.default.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.handleMouseEnter,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"option","aria-disabled":e.isDisabled(),"aria-current":e.isCurrentDay()?"date":void 0,"aria-selected":e.isSelected()},e.renderDayContents())})),e}return yt(r,[{key:"componentDidMount",value:function(){this.handleFocusDay()}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e)}}]),r}(de.default.Component),Lr=function(e){wt(r,e);var t=Ct(r);function r(){var e;ht(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return Dt(bt(e=t.call.apply(t,[this].concat(n))),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t)})),e}return yt(r,[{key:"render",value:function(){var e=this.props,t=e.weekNumber,r=e.ariaLabelPrefix,a=void 0===r?"week ":r,n={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!e.onClick};return de.default.createElement("div",{className:ce.default(n),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick},t)}}]),r}(de.default.Component),Rr=function(e){wt(r,e);var t=Ct(r);function r(){var e;ht(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return Dt(bt(e=t.call.apply(t,[this].concat(n))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r)})),Dt(bt(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),Dt(bt(e),"handleWeekClick",(function(t,r,a){"function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,r,a),e.props.shouldCloseOnSelect&&e.props.setOpen(!1)})),Dt(bt(e),"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):At(t)})),Dt(bt(e),"renderDays",(function(){var t=Bt(e.props.day,e.props.locale,e.props.calendarStartDay),r=[],a=e.formatWeekNumber(t);if(e.props.showWeekNumber){var n=e.props.onWeekSelect?e.handleWeekClick.bind(bt(e),t,a):void 0;r.push(de.default.createElement(Lr,{key:"W",weekNumber:a,onClick:n,ariaLabelPrefix:e.props.ariaLabelPrefix}))}return r.concat([0,1,2,3,4,5,6].map((function(r){var a=De.default(t,r);return de.default.createElement(Tr,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:a.valueOf(),day:a,month:e.props.month,onClick:e.handleDayClick.bind(bt(e),a),onMouseEnter:e.handleDayMouseEnter.bind(bt(e),a),minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,excludeDateIntervals:e.props.excludeDateIntervals,includeDates:e.props.includeDates,includeDateIntervals:e.props.includeDateIntervals,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,selectsDisabledDaysInRange:e.props.selectsDisabledDaysInRange,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart,locale:e.props.locale})})))})),e}return yt(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),r}(de.default.Component),Fr=function(e){wt(r,e);var t=Ct(r);function r(){var e;ht(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return Dt(bt(e=t.call.apply(t,[this].concat(n))),"MONTH_REFS",_t(Array(12)).map((function(){return de.default.createRef()}))),Dt(bt(e),"isDisabled",(function(t){return rr(t,e.props)})),Dt(bt(e),"isExcluded",(function(t){return ar(t,e.props)})),Dt(bt(e),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r,e.props.orderInDisplay)})),Dt(bt(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),Dt(bt(e),"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave()})),Dt(bt(e),"isRangeStartMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Vt(Ae.default(a,t),n)})),Dt(bt(e),"isRangeStartQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Ut(qe.default(a,t),n)})),Dt(bt(e),"isRangeEndMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Vt(Ae.default(a,t),o)})),Dt(bt(e),"isRangeEndQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Ut(qe.default(a,t),o)})),Dt(bt(e),"isWeekInMonth",(function(t){var r=e.props.day,a=De.default(t,6);return Vt(t,r)||Vt(a,r)})),Dt(bt(e),"isCurrentMonth",(function(e,t){return Ie.default(e)===Ie.default(Yt())&&t===Oe.default(Yt())})),Dt(bt(e),"isSelectedMonth",(function(e,t,r){return Oe.default(e)===t&&Ie.default(e)===Ie.default(r)})),Dt(bt(e),"isSelectedQuarter",(function(e,t,r){return Ye.default(e)===t&&Ie.default(e)===Ie.default(r)})),Dt(bt(e),"renderWeeks",(function(){for(var t=[],r=e.props.fixedHeight,a=0,n=!1,o=Bt(Kt(e.props.day),e.props.locale,e.props.calendarStartDay);t.push(de.default.createElement(Rr,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:a,day:o,month:Oe.default(e.props.day),onDayClick:e.handleDayClick,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,excludeDateIntervals:e.props.excludeDateIntervals,includeDates:e.props.includeDates,includeDateIntervals:e.props.includeDateIntervals,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,selectsDisabledDaysInRange:e.props.selectsDisabledDaysInRange,showWeekNumber:e.props.showWeekNumbers,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,calendarStartDay:e.props.calendarStartDay,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})),!n;){a++,o=ve.default(o,1);var s=r&&a>=6,i=!r&&!e.isWeekInMonth(o);if(s||i){if(!e.props.peekNextMonth)break;n=!0}}return t})),Dt(bt(e),"onMonthClick",(function(t,r){e.handleDayClick(Kt(Ae.default(e.props.day,r)),t)})),Dt(bt(e),"handleMonthNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.MONTH_REFS[t].current&&e.MONTH_REFS[t].current.focus())})),Dt(bt(e),"onMonthKeyDown",(function(t,r){var a=t.key;if(!e.props.disabledKeyboardNavigation)switch(a){case"Enter":e.onMonthClick(t,r),e.props.setPreSelection(e.props.selected);break;case"ArrowRight":e.handleMonthNavigation(11===r?0:r+1,we.default(e.props.preSelection,1));break;case"ArrowLeft":e.handleMonthNavigation(0===r?11:r-1,Se.default(e.props.preSelection,1))}})),Dt(bt(e),"onQuarterClick",(function(t,r){e.handleDayClick(jt(qe.default(e.props.day,r)),t)})),Dt(bt(e),"getMonthClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,l=r.preSelection,d=r.monthClassName,c=d?d(a):void 0;return ce.default("react-datepicker__month-text","react-datepicker__month-".concat(t),c,{"react-datepicker__month--disabled":(i||p)&&nr(Ae.default(a,t),e.props),"react-datepicker__month--selected":e.isSelectedMonth(a,t,s),"react-datepicker__month-text--keyboard-selected":Oe.default(l)===t,"react-datepicker__month--in-range":or(n,o,t,a),"react-datepicker__month--range-start":e.isRangeStartMonth(t),"react-datepicker__month--range-end":e.isRangeEndMonth(t),"react-datepicker__month-text--today":e.isCurrentMonth(a,t)})})),Dt(bt(e),"getTabIndex",(function(t){var r=Oe.default(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),Dt(bt(e),"getAriaLabel",(function(t){var r=e.props,a=r.chooseDayAriaLabelPrefix,n=void 0===a?"Choose":a,o=r.disabledDayAriaLabelPrefix,s=void 0===o?"Not available":o,i=r.day,p=Ae.default(i,t),l=e.isDisabled(p)||e.isExcluded(p)?s:n;return"".concat(l," ").concat(Lt(p,"MMMM yyyy"))})),Dt(bt(e),"getQuarterClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate;return ce.default("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter--disabled":(i||p)&&sr(qe.default(a,t),e.props),"react-datepicker__quarter--selected":e.isSelectedQuarter(a,t,s),"react-datepicker__quarter--in-range":pr(n,o,t,a),"react-datepicker__quarter--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter--range-end":e.isRangeEndQuarter(t)})})),Dt(bt(e),"renderMonths",(function(){var t=e.props,r=t.showFullMonthYearPicker,a=t.showTwoColumnMonthYearPicker,n=t.showFourColumnMonthYearPicker,o=t.locale,s=t.day,i=t.selected;return(n?[[0,1,2,3],[4,5,6,7],[8,9,10,11]]:a?[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]]:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]]).map((function(t,a){return de.default.createElement("div",{className:"react-datepicker__month-wrapper",key:a},t.map((function(t,a){return de.default.createElement("div",{ref:e.MONTH_REFS[t],key:a,onClick:function(r){e.onMonthClick(r,t)},onKeyDown:function(r){e.onMonthKeyDown(r,t)},tabIndex:e.getTabIndex(t),className:e.getMonthClassNames(t),role:"option","aria-label":e.getAriaLabel(t),"aria-current":e.isCurrentMonth(s,t)?"date":void 0,"aria-selected":e.isSelectedMonth(s,t,i)},r?Zt(t,o):er(t,o))})))}))})),Dt(bt(e),"renderQuarters",(function(){var t=e.props,r=t.day,a=t.selected;return de.default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(t,n){return de.default.createElement("div",{key:n,role:"option",onClick:function(r){e.onQuarterClick(r,t)},className:e.getQuarterClassNames(t),"aria-selected":e.isSelectedQuarter(r,t,a)},tr(t,e.props.locale))})))})),Dt(bt(e),"getClassNames",(function(){var t=e.props;t.day;var r=t.selectingDate,a=t.selectsStart,n=t.selectsEnd,o=t.showMonthYearPicker,s=t.showQuarterYearPicker;return ce.default("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(a||n)},{"react-datepicker__monthPicker":o},{"react-datepicker__quarterPicker":s})})),e}return yt(r,[{key:"render",value:function(){var e=this.props,t=e.showMonthYearPicker,r=e.showQuarterYearPicker,a=e.day,n=e.ariaLabelPrefix,o=void 0===n?"month ":n;return de.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(o," ").concat(Lt(a,"yyyy-MM")),role:"listbox"},t?this.renderMonths():r?this.renderQuarters():this.renderWeeks())}}]),r}(de.default.Component),Ar=function(e){wt(r,e);var t=Ct(r);function r(){var e;ht(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return Dt(bt(e=t.call.apply(t,[this].concat(n))),"state",{height:null}),Dt(bt(e),"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&ur(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&cr(t,e.props)||e.props.onChange(t)})),Dt(bt(e),"isSelectedTime",(function(t,r,a){return e.props.selected&&r===Pe.default(t)&&a===Me.default(t)})),Dt(bt(e),"liClasses",(function(t,r,a){var n=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t,r,a):void 0];return e.isSelectedTime(t,r,a)&&n.push("react-datepicker__time-list-item--selected"),((e.props.minTime||e.props.maxTime)&&ur(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&cr(t,e.props))&&n.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(60*Pe.default(t)+Me.default(t))%e.props.intervals!=0&&n.push("react-datepicker__time-list-item--injected"),n.join(" ")})),Dt(bt(e),"handleOnKeyDown",(function(t,r){" "===t.key&&(t.preventDefault(),t.key="Enter"),"Enter"===t.key&&e.handleClick(r),e.props.handleOnKeyDown(t)})),Dt(bt(e),"renderTimes",(function(){for(var t=[],r=e.props.format?e.props.format:"p",a=e.props.intervals,n=Wt(Yt(e.props.selected)),o=1440/a,s=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),i=e.props.selected||e.props.openToDate||Yt(),p=Pe.default(i),l=Me.default(i),d=Fe.default(Re.default(n,l),p),c=0;c<o;c++){var u=me.default(n,c*a);if(t.push(u),s){var f=gr(n,u,c,a,s);t=t.concat(f)}}return t.map((function(t,a){return de.default.createElement("li",{key:a,onClick:e.handleClick.bind(bt(e),t),className:e.liClasses(t,p,l),ref:function(r){(nt.default(t,d)||zt(t,d))&&(e.centerLi=r)},onKeyDown:function(r){e.handleOnKeyDown(r,t)},tabIndex:"0","aria-selected":e.isSelectedTime(t,p,l)?"true":void 0},Lt(t,r,e.props.locale))}))})),e}return yt(r,[{key:"componentDidMount",value:function(){this.list.scrollTop=r.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,t=this.state.height;return de.default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(t){e.header=t}},de.default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),de.default.createElement("div",{className:"react-datepicker__time"},de.default.createElement("div",{className:"react-datepicker__time-box"},de.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:t?{height:t}:{},tabIndex:"0"},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}(de.default.Component);Dt(Ar,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var qr=function(e){wt(r,e);var t=Ct(r);function r(e){var a;return ht(this,r),Dt(bt(a=t.call(this,e)),"YEAR_REFS",_t(Array(a.props.yearItemNumber)).map((function(){return de.default.createRef()}))),Dt(bt(a),"isDisabled",(function(e){return rr(e,a.props)})),Dt(bt(a),"isExcluded",(function(e){return ar(e,a.props)})),Dt(bt(a),"updateFocusOnPaginate",(function(e){var t=function(){this.YEAR_REFS[e].current.focus()}.bind(bt(a));window.requestAnimationFrame(t)})),Dt(bt(a),"handleYearClick",(function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t)})),Dt(bt(a),"handleYearNavigation",(function(e,t){var r=a.props,n=r.date,o=r.yearItemNumber,s=br(n,o).startPeriod;a.isDisabled(t)||a.isExcluded(t)||(a.props.setPreSelection(t),e-s==-1?a.updateFocusOnPaginate(o-1):e-s===o?a.updateFocusOnPaginate(0):a.YEAR_REFS[e-s].current.focus())})),Dt(bt(a),"isSameDay",(function(e,t){return $t(e,t)})),Dt(bt(a),"isCurrentYear",(function(e){return e===Ie.default(Yt())})),Dt(bt(a),"isKeyboardSelected",(function(e){var t=Ht(We.default(a.props.date,e));return!a.props.disabledKeyboardNavigation&&!a.props.inline&&!$t(t,Ht(a.props.selected))&&$t(t,Ht(a.props.preSelection))})),Dt(bt(a),"onYearClick",(function(e,t){var r=a.props.date;a.handleYearClick(Ht(We.default(r,t)),e)})),Dt(bt(a),"onYearKeyDown",(function(e,t){var r=e.key;if(!a.props.disabledKeyboardNavigation)switch(r){case"Enter":a.onYearClick(e,t),a.props.setPreSelection(a.props.selected);break;case"ArrowRight":a.handleYearNavigation(t+1,ge.default(a.props.preSelection,1));break;case"ArrowLeft":a.handleYearNavigation(t-1,Ce.default(a.props.preSelection,1))}})),Dt(bt(a),"getYearClassNames",(function(e){var t=a.props,r=t.minDate,n=t.maxDate,o=t.selected;return ce.default("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===Ie.default(o),"react-datepicker__year-text--disabled":(r||n)&&ir(e,a.props),"react-datepicker__year-text--keyboard-selected":a.isKeyboardSelected(e),"react-datepicker__year-text--today":a.isCurrentYear(e)})})),Dt(bt(a),"getYearTabIndex",(function(e){return a.props.disabledKeyboardNavigation?"-1":e===Ie.default(a.props.preSelection)?"0":"-1"})),a}return yt(r,[{key:"render",value:function(){for(var e=this,t=[],r=this.props,a=br(r.date,r.yearItemNumber),n=a.startPeriod,o=a.endPeriod,s=function(r){t.push(de.default.createElement("div",{ref:e.YEAR_REFS[r-n],onClick:function(t){e.onYearClick(t,r)},onKeyDown:function(t){e.onYearKeyDown(t,r)},tabIndex:e.getYearTabIndex(r),className:e.getYearClassNames(r),key:r,"aria-current":e.isCurrentYear(r)?"date":void 0},r))},i=n;i<=o;i++)s(i);return de.default.createElement("div",{className:"react-datepicker__year"},de.default.createElement("div",{className:"react-datepicker__year-wrapper"},t))}}]),r}(de.default.Component),Wr=function(e){wt(r,e);var t=Ct(r);function r(e){var a;return ht(this,r),Dt(bt(a=t.call(this,e)),"onTimeChange",(function(e){a.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),a.props.onChange(t)})),Dt(bt(a),"renderTimeInput",(function(){var e=a.state.time,t=a.props,r=t.date,n=t.timeString,o=t.customTimeInput;return o?de.default.cloneElement(o,{date:r,value:e,onChange:a.onTimeChange}):de.default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){a.onTimeChange(e.target.value||n)}})})),a.state={time:a.props.timeString},a}return yt(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__input-time-container"},de.default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),de.default.createElement("div",{className:"react-datepicker-time__input-container"},de.default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),r}(de.default.Component);function Br(e){var t=e.className,r=e.children,a=e.showPopperArrow,n=e.arrowProps,o=void 0===n?{}:n;return de.default.createElement("div",{className:t},a&&de.default.createElement("div",vt({className:"react-datepicker__triangle"},o)),r)}var Kr=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Hr=function(e){wt(r,e);var t=Ct(r);function r(e){var a;return ht(this,r),Dt(bt(a=t.call(this,e)),"handleClickOutside",(function(e){a.props.onClickOutside(e)})),Dt(bt(a),"setClickOutsideRef",(function(){return a.containerRef.current})),Dt(bt(a),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return Kr.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&a.props.onDropdownFocus()})),Dt(bt(a),"getDateInView",(function(){var e=a.props,t=e.preSelection,r=e.selected,n=e.openToDate,o=Dr(a.props),s=vr(a.props),i=Yt(),p=n||r||t;return p||(o&&nt.default(i,o)?o:s&&at.default(i,s)?s:i)})),Dt(bt(a),"increaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:we.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),Dt(bt(a),"decreaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:Se.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),Dt(bt(a),"handleDayClick",(function(e,t,r){a.props.onSelect(e,t,r),a.props.setPreSelection&&a.props.setPreSelection(e)})),Dt(bt(a),"handleDayMouseEnter",(function(e){a.setState({selectingDate:e}),a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e)})),Dt(bt(a),"handleMonthMouseLeave",(function(){a.setState({selectingDate:null}),a.props.onMonthMouseLeave&&a.props.onMonthMouseLeave()})),Dt(bt(a),"handleYearChange",(function(e){a.props.onYearChange&&a.props.onYearChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),Dt(bt(a),"handleMonthChange",(function(e){a.props.onMonthChange&&a.props.onMonthChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),Dt(bt(a),"handleMonthYearChange",(function(e){a.handleYearChange(e),a.handleMonthChange(e)})),Dt(bt(a),"changeYear",(function(e){a.setState((function(t){var r=t.date;return{date:We.default(r,e)}}),(function(){return a.handleYearChange(a.state.date)}))})),Dt(bt(a),"changeMonth",(function(e){a.setState((function(t){var r=t.date;return{date:Ae.default(r,e)}}),(function(){return a.handleMonthChange(a.state.date)}))})),Dt(bt(a),"changeMonthYear",(function(e){a.setState((function(t){var r=t.date;return{date:We.default(Ae.default(r,Oe.default(e)),Ie.default(e))}}),(function(){return a.handleMonthYearChange(a.state.date)}))})),Dt(bt(a),"header",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=Bt(e,a.props.locale,a.props.calendarStartDay),r=[];return a.props.showWeekNumbers&&r.push(de.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},a.props.weekLabel||"#")),r.concat([0,1,2,3,4,5,6].map((function(e){var r=De.default(t,e),n=a.formatWeekday(r,a.props.locale),o=a.props.weekDayClassName?a.props.weekDayClassName(r):void 0;return de.default.createElement("div",{key:e,className:ce.default("react-datepicker__day-name",o)},n)})))})),Dt(bt(a),"formatWeekday",(function(e,t){return a.props.formatWeekDay?function(e,t,r){return t(Lt(e,"EEEE",r))}(e,a.props.formatWeekDay,t):a.props.useWeekdaysShort?function(e,t){return Lt(e,"EEE",t)}(e,t):function(e,t){return Lt(e,"EEEEEE",t)}(e,t)})),Dt(bt(a),"decreaseYear",(function(){a.setState((function(e){var t=e.date;return{date:Ce.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),Dt(bt(a),"renderPreviousButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=mr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.yearItemNumber,n=void 0===a?xt:a,o=br(Ht(Ce.default(e,n)),n).endPeriod,s=r&&Ie.default(r);return s&&s>o||!1}(a.state.date,a.props);break;default:e=fr(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--previous"],r=a.decreaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.decreaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--previous--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.previousMonthButtonLabel,i=o.previousYearButtonLabel,p=a.props,l=p.previousMonthAriaLabel,d=void 0===l?"string"==typeof s?s:"Previous Month":l,c=p.previousYearAriaLabel,u=void 0===c?"string"==typeof i?i:"Previous Year":c;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,onKeyDown:a.props.handleOnKeyDown,"aria-label":n?u:d},de.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--previous"].join(" ")},n?a.props.previousYearButtonLabel:a.props.previousMonthButtonLabel))}}})),Dt(bt(a),"increaseYear",(function(){a.setState((function(e){var t=e.date;return{date:ge.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),Dt(bt(a),"renderNextButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=yr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.yearItemNumber,n=void 0===a?xt:a,o=br(ge.default(e,n),n).startPeriod,s=r&&Ie.default(r);return s&&s<o||!1}(a.state.date,a.props);break;default:e=hr(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--next"];a.props.showTimeSelect&&t.push("react-datepicker__navigation--next--with-time"),a.props.todayButton&&t.push("react-datepicker__navigation--next--with-today-button");var r=a.increaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.increaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--next--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.nextMonthButtonLabel,i=o.nextYearButtonLabel,p=a.props,l=p.nextMonthAriaLabel,d=void 0===l?"string"==typeof s?s:"Next Month":l,c=p.nextYearAriaLabel,u=void 0===c?"string"==typeof i?i:"Next Year":c;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,onKeyDown:a.props.handleOnKeyDown,"aria-label":n?u:d},de.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--next"].join(" ")},n?a.props.nextYearButtonLabel:a.props.nextMonthButtonLabel))}}})),Dt(bt(a),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=["react-datepicker__current-month"];return a.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),a.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),a.props.showMonthYearDropdown&&t.push("react-datepicker__current-month--hasMonthYearDropdown"),de.default.createElement("div",{className:t.join(" ")},Lt(e,a.props.dateFormat,a.props.locale))})),Dt(bt(a),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showYearDropdown&&!e)return de.default.createElement(Mr,{adjustDateOnChange:a.props.adjustDateOnChange,date:a.state.date,onSelect:a.props.onSelect,setOpen:a.props.setOpen,dropdownMode:a.props.dropdownMode,onChange:a.changeYear,minDate:a.props.minDate,maxDate:a.props.maxDate,year:Ie.default(a.state.date),scrollableYearDropdown:a.props.scrollableYearDropdown,yearDropdownItemNumber:a.props.yearDropdownItemNumber})})),Dt(bt(a),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthDropdown&&!e)return de.default.createElement(Nr,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,onChange:a.changeMonth,month:Oe.default(a.state.date),useShortMonthInDropdown:a.props.useShortMonthInDropdown})})),Dt(bt(a),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthYearDropdown&&!e)return de.default.createElement(Ir,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,dateFormat:a.props.dateFormat,onChange:a.changeMonthYear,minDate:a.props.minDate,maxDate:a.props.maxDate,date:a.state.date,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown})})),Dt(bt(a),"renderTodayButton",(function(){if(a.props.todayButton&&!a.props.showTimeSelectOnly)return de.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return a.props.onSelect(Ve.default(Yt()),e)}},a.props.todayButton)})),Dt(bt(a),"renderDefaultHeader",(function(e){var t=e.monthDate,r=e.i;return de.default.createElement("div",{className:"react-datepicker__header ".concat(a.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},a.renderCurrentMonth(t),de.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),onFocus:a.handleDropdownFocus},a.renderMonthDropdown(0!==r),a.renderMonthYearDropdown(0!==r),a.renderYearDropdown(0!==r)),de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),Dt(bt(a),"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.monthDate,r=e.i;if(a.props.showTimeSelect&&!a.state.monthContainer||a.props.showTimeSelectOnly)return null;var n=fr(a.state.date,a.props),o=hr(a.state.date,a.props),s=mr(a.state.date,a.props),i=yr(a.state.date,a.props),p=!a.props.showMonthYearPicker&&!a.props.showQuarterYearPicker&&!a.props.showYearPicker;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:a.props.onDropdownFocus},a.props.renderCustomHeader(ut(ut({},a.state),{},{customHeaderCount:r,monthDate:t,changeMonth:a.changeMonth,changeYear:a.changeYear,decreaseMonth:a.decreaseMonth,increaseMonth:a.increaseMonth,decreaseYear:a.decreaseYear,increaseYear:a.increaseYear,prevMonthButtonDisabled:n,nextMonthButtonDisabled:o,prevYearButtonDisabled:s,nextYearButtonDisabled:i})),p&&de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),Dt(bt(a),"renderYearHeader",(function(){var e=a.state.date,t=a.props,r=t.showYearPicker,n=br(e,t.yearItemNumber),o=n.startPeriod,s=n.endPeriod;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},r?"".concat(o," - ").concat(s):Ie.default(e))})),Dt(bt(a),"renderHeader",(function(e){switch(!0){case void 0!==a.props.renderCustomHeader:return a.renderCustomHeader(e);case a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker:return a.renderYearHeader(e);default:return a.renderDefaultHeader(e)}})),Dt(bt(a),"renderMonths",(function(){if(!a.props.showTimeSelectOnly&&!a.props.showYearPicker){for(var e=[],t=a.props.showPreviousMonths?a.props.monthsShown-1:0,r=Se.default(a.state.date,t),n=0;n<a.props.monthsShown;++n){var o=n-a.props.monthSelectedIn,s=we.default(r,o),i="month-".concat(n),p=n<a.props.monthsShown-1,l=n>0;e.push(de.default.createElement("div",{key:i,ref:function(e){a.monthContainer=e},className:"react-datepicker__month-container"},a.renderHeader({monthDate:s,i:n}),de.default.createElement(Fr,{chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,ariaLabelPrefix:a.props.monthAriaLabelPrefix,onChange:a.changeMonthYear,day:s,dayClassName:a.props.dayClassName,calendarStartDay:a.props.calendarStartDay,monthClassName:a.props.monthClassName,onDayClick:a.handleDayClick,handleOnKeyDown:a.props.handleOnDayKeyDown,onDayMouseEnter:a.handleDayMouseEnter,onMouseLeave:a.handleMonthMouseLeave,onWeekSelect:a.props.onWeekSelect,orderInDisplay:n,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,excludeDateIntervals:a.props.excludeDateIntervals,highlightDates:a.props.highlightDates,selectingDate:a.state.selectingDate,includeDates:a.props.includeDates,includeDateIntervals:a.props.includeDateIntervals,inline:a.props.inline,shouldFocusDayInline:a.props.shouldFocusDayInline,fixedHeight:a.props.fixedHeight,filterDate:a.props.filterDate,preSelection:a.props.preSelection,setPreSelection:a.props.setPreSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,selectsDisabledDaysInRange:a.props.selectsDisabledDaysInRange,showWeekNumbers:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,peekNextMonth:a.props.peekNextMonth,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,renderDayContents:a.props.renderDayContents,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,isInputFocused:a.props.isInputFocused,containerRef:a.containerRef,monthShowsDuplicateDaysEnd:p,monthShowsDuplicateDaysStart:l})))}return e}})),Dt(bt(a),"renderYears",(function(){if(!a.props.showTimeSelectOnly)return a.props.showYearPicker?de.default.createElement("div",{className:"react-datepicker__year--container"},a.renderHeader(),de.default.createElement(qr,vt({onDayClick:a.handleDayClick,date:a.state.date},a.props))):void 0})),Dt(bt(a),"renderTimeSection",(function(){if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return de.default.createElement(Ar,{selected:a.props.selected,openToDate:a.props.openToDate,onChange:a.props.onTimeChange,timeClassName:a.props.timeClassName,format:a.props.timeFormat,includeTimes:a.props.includeTimes,intervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,todayButton:a.props.todayButton,showMonthDropdown:a.props.showMonthDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,monthRef:a.state.monthContainer,injectTimes:a.props.injectTimes,locale:a.props.locale,handleOnKeyDown:a.props.handleOnKeyDown,showTimeSelectOnly:a.props.showTimeSelectOnly})})),Dt(bt(a),"renderInputTimeSection",(function(){var e=new Date(a.props.selected),t=Tt(e)&&Boolean(a.props.selected)?"".concat(kr(e.getHours()),":").concat(kr(e.getMinutes())):"";if(a.props.showTimeInput)return de.default.createElement(Wr,{date:e,timeString:t,timeInputLabel:a.props.timeInputLabel,onChange:a.props.onTimeChange,customTimeInput:a.props.customTimeInput})})),a.containerRef=de.default.createRef(),a.state={date:a.getDateInView(),selectingDate:null,monthContainer:null},a}return yt(r,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!$t(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!$t(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate})}},{key:"render",value:function(){var e=this.props.container||Br;return de.default.createElement("div",{ref:this.containerRef},de.default.createElement(e,{className:ce.default("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}],[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:xt}}}]),r}(de.default.Component),jr=function(e){wt(r,e);var t=Ct(r);function r(e){var a;return ht(this,r),(a=t.call(this,e)).el=document.createElement("div"),a}return yt(r,[{key:"componentDidMount",value:function(){this.portalRoot=(this.props.portalHost||document).getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),(this.props.portalHost||document.body).appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el)}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el)}},{key:"render",value:function(){return dt.default.createPortal(this.props.children,this.el)}}]),r}(de.default.Component),Qr=function(e){return!e.disabled&&-1!==e.tabIndex},Vr=function(e){wt(r,e);var t=Ct(r);function r(e){var a;return ht(this,r),Dt(bt(a=t.call(this,e)),"getTabChildren",(function(){return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(Qr)})),Dt(bt(a),"handleFocusStart",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[t.length-1].focus()})),Dt(bt(a),"handleFocusEnd",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[0].focus()})),a.tabLoopRef=de.default.createRef(),a}return yt(r,[{key:"render",value:function(){return this.props.enableTabLoop?de.default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},de.default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,de.default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}]),r}(de.default.Component),Ur=function(e){wt(r,e);var t=Ct(r);function r(){return ht(this,r),t.apply(this,arguments)}return yt(r,[{key:"render",value:function(){var e,t=this.props,r=t.className,a=t.wrapperClassName,n=t.hidePopper,o=t.popperComponent,s=t.popperModifiers,i=t.popperPlacement,p=t.popperProps,l=t.targetComponent,d=t.enableTabLoop,c=t.popperOnKeyDown,u=t.portalId,f=t.portalHost;if(!n){var h=ce.default("react-datepicker-popper",r);e=de.default.createElement(pe.Popper,vt({modifiers:s,placement:i},p),(function(e){var t=e.ref,r=e.style,a=e.placement,n=e.arrowProps;return de.default.createElement(Vr,{enableTabLoop:d},de.default.createElement("div",{ref:t,style:r,className:h,"data-placement":a,onKeyDown:c},de.default.cloneElement(o,{arrowProps:n})))}))}this.props.popperContainer&&(e=de.default.createElement(this.props.popperContainer,{},e)),u&&!n&&(e=de.default.createElement(jr,{portalId:u,portalHost:f},e));var m=ce.default("react-datepicker-wrapper",a);return de.default.createElement(pe.Manager,{className:"react-datepicker-manager"},de.default.createElement(pe.Reference,null,(function(e){var t=e.ref;return de.default.createElement("div",{ref:t,className:m},l)})),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:[],popperProps:{},popperPlacement:"bottom-start"}}}]),r}(de.default.Component),$r="react-datepicker-ignore-onclickoutside",zr=lt.default(Hr);var Gr="Date input not valid.",Jr=function(e){wt(r,e);var t=Ct(r);function r(e){var a;return ht(this,r),Dt(bt(a=t.call(this,e)),"getPreSelection",(function(){return a.props.openToDate?a.props.openToDate:a.props.selectsEnd&&a.props.startDate?a.props.startDate:a.props.selectsStart&&a.props.endDate?a.props.endDate:Yt()})),Dt(bt(a),"calcInitialState",(function(){var e,t=a.getPreSelection(),r=Dr(a.props),n=vr(a.props),o=r&&nt.default(t,Ve.default(r))?r:n&&at.default(t,Je.default(n))?n:t;return{open:a.props.startOpen||!1,preventFocus:!1,preSelection:null!==(e=a.props.selectsRange?a.props.startDate:a.props.selected)&&void 0!==e?e:o,highlightDates:wr(a.props.highlightDates),focused:!1,shouldFocusDayInline:!1}})),Dt(bt(a),"clearPreventFocusTimeout",(function(){a.preventFocusTimeout&&clearTimeout(a.preventFocusTimeout)})),Dt(bt(a),"setFocus",(function(){a.input&&a.input.focus&&a.input.focus({preventScroll:!0})})),Dt(bt(a),"setBlur",(function(){a.input&&a.input.blur&&a.input.blur(),a.cancelFocusInput()})),Dt(bt(a),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];a.setState({open:e,preSelection:e&&a.state.open?a.state.preSelection:a.calcInitialState().preSelection,lastPreSelectChange:Zr},(function(){e||a.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&a.setBlur(),a.setState({inputValue:null})}))}))})),Dt(bt(a),"inputOk",(function(){return ue.default(a.state.preSelection)})),Dt(bt(a),"isCalendarOpen",(function(){return void 0===a.props.open?a.state.open&&!a.props.disabled&&!a.props.readOnly:a.props.open})),Dt(bt(a),"handleFocus",(function(e){a.state.preventFocus||(a.props.onFocus(e),a.props.preventOpenOnFocus||a.props.readOnly||a.setOpen(!0)),a.setState({focused:!0})})),Dt(bt(a),"cancelFocusInput",(function(){clearTimeout(a.inputFocusTimeout),a.inputFocusTimeout=null})),Dt(bt(a),"deferFocusInput",(function(){a.cancelFocusInput(),a.inputFocusTimeout=setTimeout((function(){return a.setFocus()}),1)})),Dt(bt(a),"handleDropdownFocus",(function(){a.cancelFocusInput()})),Dt(bt(a),"handleBlur",(function(e){(!a.state.open||a.props.withPortal||a.props.showTimeInput)&&a.props.onBlur(e),a.setState({focused:!1})})),Dt(bt(a),"handleCalendarClickOutside",(function(e){a.props.inline||a.setOpen(!1),a.props.onClickOutside(e),a.props.withPortal&&e.preventDefault()})),Dt(bt(a),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!a.props.onChangeRaw||(a.props.onChangeRaw.apply(bt(a),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){a.setState({inputValue:n.target.value,lastPreSelectChange:Xr});var o=It(n.target.value,a.props.dateFormat,a.props.locale,a.props.strictParsing,a.props.minDate);!o&&n.target.value||a.setSelected(o,n,!0)}})),Dt(bt(a),"handleSelect",(function(e,t,r){if(a.setState({preventFocus:!0},(function(){return a.preventFocusTimeout=setTimeout((function(){return a.setState({preventFocus:!1})}),50),a.preventFocusTimeout})),a.props.onChangeRaw&&a.props.onChangeRaw(t),a.setSelected(e,t,!1,r),!a.props.shouldCloseOnSelect||a.props.showTimeSelect)a.setPreSelection(e);else if(!a.props.inline){a.props.selectsRange||a.setOpen(!1);var n=a.props,o=n.startDate,s=n.endDate;!o||s||nt.default(e,o)||a.setOpen(!1)}})),Dt(bt(a),"setSelected",(function(e,t,r,n){var o=e;if(null===o||!rr(o,a.props)){var s=a.props,i=s.onChange,p=s.selectsRange,l=s.startDate,d=s.endDate;if(!zt(a.props.selected,o)||a.props.allowSameDay||p)if(null!==o&&(!a.props.selected||r&&(a.props.showTimeSelect||a.props.showTimeSelectOnly||a.props.showTimeInput)||(o=Ft(o,{hour:Pe.default(a.props.selected),minute:Me.default(a.props.selected),second:_e.default(a.props.selected)})),a.props.inline||a.setState({preSelection:o}),a.props.focusSelectedMonth||a.setState({monthSelectedIn:n})),p){var c=l&&!d,u=l&&d;!l&&!d?i([o,null],t):c&&(nt.default(o,l)?i([o,null],t):i([l,o],t)),u&&i([o,null],t)}else i(o,t);r||(a.props.onSelect(o,t),a.setState({inputValue:null}))}})),Dt(bt(a),"setPreSelection",(function(e){var t=void 0!==a.props.minDate,r=void 0!==a.props.maxDate,n=!0;if(e){var o=Ve.default(e);if(t&&r)n=Gt(e,a.props.minDate,a.props.maxDate);else if(t){var s=Ve.default(a.props.minDate);n=at.default(e,s)||zt(o,s)}else if(r){var i=Je.default(a.props.maxDate);n=nt.default(e,i)||zt(o,i)}}n&&a.setState({preSelection:e})})),Dt(bt(a),"handleTimeChange",(function(e){var t=Ft(a.props.selected?a.props.selected:a.getPreSelection(),{hour:Pe.default(e),minute:Me.default(e)});a.setState({preSelection:t}),a.props.onChange(t),a.props.shouldCloseOnSelect&&a.setOpen(!1),a.props.showTimeInput&&a.setOpen(!0),a.setState({inputValue:null})})),Dt(bt(a),"onInputClick",(function(){a.props.disabled||a.props.readOnly||a.setOpen(!0),a.props.onInputClick()})),Dt(bt(a),"onInputKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key;if(a.state.open||a.props.inline||a.props.preventOpenOnFocus){if(a.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=a.calendar.componentNode&&a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus({preventScroll:!0}))}var n=Yt(a.state.preSelection);"Enter"===t?(e.preventDefault(),a.inputOk()&&a.state.lastPreSelectChange===Zr?(a.handleSelect(n,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(n)):a.setOpen(!1)):"Escape"===t&&(e.preventDefault(),a.setOpen(!1)),a.inputOk()||a.props.onInputError({code:1,msg:Gr})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||a.onInputClick()})),Dt(bt(a),"onDayKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key,r=Yt(a.state.preSelection);if("Enter"===t)e.preventDefault(),a.handleSelect(r,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(r);else if("Escape"===t)e.preventDefault(),a.setOpen(!1),a.inputOk()||a.props.onInputError({code:1,msg:Gr});else if(!a.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=ke.default(r,1);break;case"ArrowRight":n=De.default(r,1);break;case"ArrowUp":n=be.default(r,1);break;case"ArrowDown":n=ve.default(r,1);break;case"PageUp":n=Se.default(r,1);break;case"PageDown":n=we.default(r,1);break;case"Home":n=Ce.default(r,1);break;case"End":n=ge.default(r,1)}if(!n)return void(a.props.onInputError&&a.props.onInputError({code:1,msg:Gr}));if(e.preventDefault(),a.setState({lastPreSelectChange:Zr}),a.props.adjustDateOnChange&&a.setSelected(n),a.setPreSelection(n),a.props.inline){var o=Oe.default(r),s=Oe.default(n),i=Ie.default(r),p=Ie.default(n);o!==s||i!==p?a.setState({shouldFocusDayInline:!0}):a.setState({shouldFocusDayInline:!1})}}})),Dt(bt(a),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),a.setState({preventFocus:!0},(function(){a.setOpen(!1),setTimeout((function(){a.setFocus(),a.setState({preventFocus:!1})}))})))})),Dt(bt(a),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),a.props.selectsRange?a.props.onChange([null,null],e):a.props.onChange(null,e),a.setState({inputValue:null})})),Dt(bt(a),"clear",(function(){a.onClearClick()})),Dt(bt(a),"onScroll",(function(e){"boolean"==typeof a.props.closeOnScroll&&a.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||a.setOpen(!1):"function"==typeof a.props.closeOnScroll&&a.props.closeOnScroll(e)&&a.setOpen(!1)})),Dt(bt(a),"renderCalendar",(function(){return a.props.inline||a.isCalendarOpen()?de.default.createElement(zr,{ref:function(e){a.calendar=e},locale:a.props.locale,calendarStartDay:a.props.calendarStartDay,chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,monthAriaLabelPrefix:a.props.monthAriaLabelPrefix,adjustDateOnChange:a.props.adjustDateOnChange,setOpen:a.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,dateFormat:a.props.dateFormatCalendar,useWeekdaysShort:a.props.useWeekdaysShort,formatWeekDay:a.props.formatWeekDay,dropdownMode:a.props.dropdownMode,selected:a.props.selected,preSelection:a.state.preSelection,onSelect:a.handleSelect,onWeekSelect:a.props.onWeekSelect,openToDate:a.props.openToDate,minDate:a.props.minDate,maxDate:a.props.maxDate,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,startDate:a.props.startDate,endDate:a.props.endDate,excludeDates:a.props.excludeDates,excludeDateIntervals:a.props.excludeDateIntervals,filterDate:a.props.filterDate,onClickOutside:a.handleCalendarClickOutside,formatWeekNumber:a.props.formatWeekNumber,highlightDates:a.state.highlightDates,includeDates:a.props.includeDates,includeDateIntervals:a.props.includeDateIntervals,includeTimes:a.props.includeTimes,injectTimes:a.props.injectTimes,inline:a.props.inline,shouldFocusDayInline:a.state.shouldFocusDayInline,peekNextMonth:a.props.peekNextMonth,showMonthDropdown:a.props.showMonthDropdown,showPreviousMonths:a.props.showPreviousMonths,useShortMonthInDropdown:a.props.useShortMonthInDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showWeekNumbers:a.props.showWeekNumbers,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,forceShowMonthNavigation:a.props.forceShowMonthNavigation,showDisabledMonthNavigation:a.props.showDisabledMonthNavigation,scrollableYearDropdown:a.props.scrollableYearDropdown,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown,todayButton:a.props.todayButton,weekLabel:a.props.weekLabel,outsideClickIgnoreClass:$r,fixedHeight:a.props.fixedHeight,monthsShown:a.props.monthsShown,monthSelectedIn:a.state.monthSelectedIn,onDropdownFocus:a.handleDropdownFocus,onMonthChange:a.props.onMonthChange,onYearChange:a.props.onYearChange,dayClassName:a.props.dayClassName,weekDayClassName:a.props.weekDayClassName,monthClassName:a.props.monthClassName,timeClassName:a.props.timeClassName,showTimeSelect:a.props.showTimeSelect,showTimeSelectOnly:a.props.showTimeSelectOnly,onTimeChange:a.handleTimeChange,timeFormat:a.props.timeFormat,timeIntervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,className:a.props.calendarClassName,container:a.props.calendarContainer,yearItemNumber:a.props.yearItemNumber,yearDropdownItemNumber:a.props.yearDropdownItemNumber,previousMonthAriaLabel:a.props.previousMonthAriaLabel,previousMonthButtonLabel:a.props.previousMonthButtonLabel,nextMonthAriaLabel:a.props.nextMonthAriaLabel,nextMonthButtonLabel:a.props.nextMonthButtonLabel,previousYearAriaLabel:a.props.previousYearAriaLabel,previousYearButtonLabel:a.props.previousYearButtonLabel,nextYearAriaLabel:a.props.nextYearAriaLabel,nextYearButtonLabel:a.props.nextYearButtonLabel,timeInputLabel:a.props.timeInputLabel,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderCustomHeader:a.props.renderCustomHeader,popperProps:a.props.popperProps,renderDayContents:a.props.renderDayContents,onDayMouseEnter:a.props.onDayMouseEnter,onMonthMouseLeave:a.props.onMonthMouseLeave,selectsDisabledDaysInRange:a.props.selectsDisabledDaysInRange,showTimeInput:a.props.showTimeInput,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showPopperArrow:a.props.showPopperArrow,excludeScrollbar:a.props.excludeScrollbar,handleOnKeyDown:a.props.onKeyDown,handleOnDayKeyDown:a.onDayKeyDown,isInputFocused:a.state.focused,customTimeInput:a.props.customTimeInput,setPreSelection:a.setPreSelection},a.props.children):null})),Dt(bt(a),"renderDateInput",(function(){var e,t=ce.default(a.props.className,Dt({},$r,a.state.open)),r=a.props.customInput||de.default.createElement("input",{type:"text"}),n=a.props.customInputRef||"ref",o="string"==typeof a.props.value?a.props.value:"string"==typeof a.state.inputValue?a.state.inputValue:a.props.selectsRange?function(e,t,r){if(!e)return"";var a=Rt(e,r),n=t?Rt(t,r):"";return"".concat(a," - ").concat(n)}(a.props.startDate,a.props.endDate,a.props):Rt(a.props.selected,a.props);return de.default.cloneElement(r,(Dt(e={},n,(function(e){a.input=e})),Dt(e,"value",o),Dt(e,"onBlur",a.handleBlur),Dt(e,"onChange",a.handleChange),Dt(e,"onClick",a.onInputClick),Dt(e,"onFocus",a.handleFocus),Dt(e,"onKeyDown",a.onInputKeyDown),Dt(e,"id",a.props.id),Dt(e,"name",a.props.name),Dt(e,"autoFocus",a.props.autoFocus),Dt(e,"placeholder",a.props.placeholderText),Dt(e,"disabled",a.props.disabled),Dt(e,"autoComplete",a.props.autoComplete),Dt(e,"className",ce.default(r.props.className,t)),Dt(e,"title",a.props.title),Dt(e,"readOnly",a.props.readOnly),Dt(e,"required",a.props.required),Dt(e,"tabIndex",a.props.tabIndex),Dt(e,"aria-describedby",a.props.ariaDescribedBy),Dt(e,"aria-invalid",a.props.ariaInvalid),Dt(e,"aria-labelledby",a.props.ariaLabelledBy),Dt(e,"aria-required",a.props.ariaRequired),e))})),Dt(bt(a),"renderClearButton",(function(){var e=a.props,t=e.isClearable,r=e.selected,n=e.startDate,o=e.endDate,s=e.clearButtonTitle,i=e.clearButtonClassName,p=void 0===i?"":i,l=e.ariaLabelClose,d=void 0===l?"Close":l;return!t||null==r&&null==n&&null==o?null:de.default.createElement("button",{type:"button",className:"react-datepicker__close-icon ".concat(p).trim(),"aria-label":d,onClick:a.onClearClick,title:s,tabIndex:-1})})),a.state=a.calcInitialState(),a}return yt(r,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0)}},{key:"componentDidUpdate",value:function(e,t){var r,a;e.inline&&(r=e.selected,a=this.props.selected,r&&a?Oe.default(r)!==Oe.default(a)||Ie.default(r)!==Ie.default(a):r!==a)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:wr(this.props.highlightDates)}),t.focused||zt(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0)}},{key:"renderInputContainer",value:function(){return de.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton())}},{key:"render",value:function(){var e=this.renderCalendar();if(this.props.inline)return e;if(this.props.withPortal){var t=this.state.open?de.default.createElement("div",{className:"react-datepicker__portal"},e):null;return this.state.open&&this.props.portalId&&(t=de.default.createElement(jr,{portalId:this.props.portalId,portalHost:this.props.portalHost},t)),de.default.createElement("div",null,this.renderInputContainer(),t)}return de.default.createElement(Ur,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,portalHost:this.props.portalHost,popperModifiers:this.props.popperModifiers,targetComponent:this.renderInputContainer(),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}],[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,selectsDisabledDaysInRange:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthAriaLabel:"Previous Month",previousMonthButtonLabel:"Previous Month",nextMonthAriaLabel:"Next Month",nextMonthButtonLabel:"Next Month",previousYearAriaLabel:"Previous Year",previousYearButtonLabel:"Previous Year",nextYearAriaLabel:"Next Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:xt,renderDayContents:function(e){return e},focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null,calendarStartDay:void 0}}}]),r}(de.default.Component),Xr="input",Zr="navigate";e.CalendarContainer=Br,e.default=Jr,e.getDefaultLocale=Jt,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:globalThis;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:globalThis).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));


/***/ }),

/***/ 12005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ DndContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

/**
 * Create the React Context
 */

var DndContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  dragDropManager: undefined
});

/***/ }),

/***/ 64969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ useCollectedProps; }
});

// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(32741);
// EXTERNAL MODULE: ../../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(69378);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useCollector.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




/**
 *
 * @param monitor The monitor to collect state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */

function useCollector(monitor, collect, onUpdate) {
  var _useState = (0,react.useState)(function () {
    return collect(monitor);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      collected = _useState2[0],
      setCollected = _useState2[1];

  var updateCollected = (0,react.useCallback)(function () {
    var nextValue = collect(monitor); // This needs to be a deep-equality check because some monitor-collected values
    // include XYCoord objects that may be equivalent, but do not have instance equality.

    if (!fast_deep_equal_default()(collected, nextValue)) {
      setCollected(nextValue);

      if (onUpdate) {
        onUpdate();
      }
    }
  }, [collected, monitor, onUpdate]); // update the collected properties after react renders.
  // Note that the "Dustbin Stress Test" fails if this is not
  // done when the component updates

  (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(updateCollected);
  return [collected, updateCollected];
}
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useMonitorOutput.js
function useMonitorOutput_slicedToArray(arr, i) { return useMonitorOutput_arrayWithHoles(arr) || useMonitorOutput_iterableToArrayLimit(arr, i) || useMonitorOutput_unsupportedIterableToArray(arr, i) || useMonitorOutput_nonIterableRest(); }

function useMonitorOutput_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function useMonitorOutput_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useMonitorOutput_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useMonitorOutput_arrayLikeToArray(o, minLen); }

function useMonitorOutput_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function useMonitorOutput_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function useMonitorOutput_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



function useMonitorOutput(monitor, collect, onCollect) {
  var _useCollector = useCollector(monitor, collect, onCollect),
      _useCollector2 = useMonitorOutput_slicedToArray(_useCollector, 2),
      collected = _useCollector2[0],
      updateCollected = _useCollector2[1];

  (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function subscribeToMonitorStateChange() {
    var handlerId = monitor.getHandlerId();

    if (handlerId == null) {
      return;
    }

    return monitor.subscribeToStateChange(updateCollected, {
      handlerIds: [handlerId]
    });
  }, [monitor, updateCollected]);
  return collected;
}
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useCollectedProps.js

function useCollectedProps(collector, monitor, connector) {
  return useMonitorOutput(monitor, collector || function () {
    return {};
  }, function () {
    return connector.reconnect();
  });
}

/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ useDrag; }
});

// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/internals/registration.js
var registration = __webpack_require__(690);
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(32741);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrag/DragSourceImpl.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DragSourceImpl = /*#__PURE__*/function () {
  function DragSourceImpl(spec, monitor, connector) {
    _classCallCheck(this, DragSourceImpl);

    _defineProperty(this, "spec", void 0);

    _defineProperty(this, "monitor", void 0);

    _defineProperty(this, "connector", void 0);

    this.spec = spec;
    this.monitor = monitor;
    this.connector = connector;
  }

  _createClass(DragSourceImpl, [{
    key: "beginDrag",
    value: function beginDrag() {
      var _result;

      var spec = this.spec;
      var monitor = this.monitor;
      var result = null;

      if (_typeof(spec.item) === 'object') {
        result = spec.item;
      } else if (typeof spec.item === 'function') {
        result = spec.item(monitor);
      } else {
        result = {};
      }

      return (_result = result) !== null && _result !== void 0 ? _result : null;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (typeof spec.canDrag === 'boolean') {
        return spec.canDrag;
      } else if (typeof spec.canDrag === 'function') {
        return spec.canDrag(monitor);
      } else {
        return true;
      }
    }
  }, {
    key: "isDragging",
    value: function isDragging(globalMonitor, target) {
      var spec = this.spec;
      var monitor = this.monitor;
      var isDragging = spec.isDragging;
      return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function endDrag() {
      var spec = this.spec;
      var monitor = this.monitor;
      var connector = this.connector;
      var end = spec.end;

      if (end) {
        end(monitor.getItem(), monitor);
      }

      connector.reconnect();
    }
  }]);

  return DragSourceImpl;
}();
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrag/useDragSource.js


function useDragSource(spec, monitor, connector) {
  var handler = (0,react.useMemo)(function () {
    return new DragSourceImpl(spec, monitor, connector);
  }, [monitor, connector]);
  (0,react.useEffect)(function () {
    handler.spec = spec;
  }, [spec]);
  return handler;
}
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDragDropManager.js
var useDragDropManager = __webpack_require__(92566);
// EXTERNAL MODULE: ../../node_modules/@react-dnd/invariant/dist/invariant.esm.js
var invariant_esm = __webpack_require__(45293);
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrag/useDragType.js


function useDragType(spec) {
  return (0,react.useMemo)(function () {
    var result = spec.type;
    (0,invariant_esm/* invariant */.k)(result != null, 'spec.type must be defined');
    return result;
  }, [spec]);
}
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrag/useRegisteredDragSource.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






function useRegisteredDragSource(spec, monitor, connector) {
  var manager = (0,useDragDropManager/* useDragDropManager */.N)();
  var handler = useDragSource(spec, monitor, connector);
  var itemType = useDragType(spec);
  (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function registerDragSource() {
    if (itemType != null) {
      var _registerSource = (0,registration/* registerSource */.w)(itemType, handler, manager),
          _registerSource2 = _slicedToArray(_registerSource, 2),
          handlerId = _registerSource2[0],
          unregister = _registerSource2[1];

      monitor.receiveHandlerId(handlerId);
      connector.receiveHandlerId(handlerId);
      return unregister;
    }
  }, [manager, monitor, connector, handler, itemType]);
}
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useOptionalFactory.js
var useOptionalFactory = __webpack_require__(69980);
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/internals/DragSourceMonitorImpl.js
function DragSourceMonitorImpl_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DragSourceMonitorImpl_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DragSourceMonitorImpl_createClass(Constructor, protoProps, staticProps) { if (protoProps) DragSourceMonitorImpl_defineProperties(Constructor.prototype, protoProps); if (staticProps) DragSourceMonitorImpl_defineProperties(Constructor, staticProps); return Constructor; }

function DragSourceMonitorImpl_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var isCallingCanDrag = false;
var isCallingIsDragging = false;
var DragSourceMonitorImpl = /*#__PURE__*/function () {
  function DragSourceMonitorImpl(manager) {
    DragSourceMonitorImpl_classCallCheck(this, DragSourceMonitorImpl);

    DragSourceMonitorImpl_defineProperty(this, "internalMonitor", void 0);

    DragSourceMonitorImpl_defineProperty(this, "sourceId", null);

    this.internalMonitor = manager.getMonitor();
  }

  DragSourceMonitorImpl_createClass(DragSourceMonitorImpl, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(sourceId) {
      this.sourceId = sourceId;
    }
  }, {
    key: "getHandlerId",
    value: function getHandlerId() {
      return this.sourceId;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      (0,invariant_esm/* invariant */.k)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');

      try {
        isCallingCanDrag = true;
        return this.internalMonitor.canDragSource(this.sourceId);
      } finally {
        isCallingCanDrag = false;
      }
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      if (!this.sourceId) {
        return false;
      }

      (0,invariant_esm/* invariant */.k)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');

      try {
        isCallingIsDragging = true;
        return this.internalMonitor.isDraggingSource(this.sourceId);
      } finally {
        isCallingIsDragging = false;
      }
    }
  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    }
  }, {
    key: "isDraggingSource",
    value: function isDraggingSource(sourceId) {
      return this.internalMonitor.isDraggingSource(sourceId);
    }
  }, {
    key: "isOverTarget",
    value: function isOverTarget(targetId, options) {
      return this.internalMonitor.isOverTarget(targetId, options);
    }
  }, {
    key: "getTargetIds",
    value: function getTargetIds() {
      return this.internalMonitor.getTargetIds();
    }
  }, {
    key: "isSourcePublic",
    value: function isSourcePublic() {
      return this.internalMonitor.isSourcePublic();
    }
  }, {
    key: "getSourceId",
    value: function getSourceId() {
      return this.internalMonitor.getSourceId();
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function subscribeToOffsetChange(listener) {
      return this.internalMonitor.subscribeToOffsetChange(listener);
    }
  }, {
    key: "canDragSource",
    value: function canDragSource(sourceId) {
      return this.internalMonitor.canDragSource(sourceId);
    }
  }, {
    key: "canDropOnTarget",
    value: function canDropOnTarget(targetId) {
      return this.internalMonitor.canDropOnTarget(targetId);
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return DragSourceMonitorImpl;
}();
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrag/useDragSourceMonitor.js



function useDragSourceMonitor() {
  var manager = (0,useDragDropManager/* useDragDropManager */.N)();
  return (0,react.useMemo)(function () {
    return new DragSourceMonitorImpl(manager);
  }, [manager]);
}
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/internals/wrapConnectorHooks.js
var wrapConnectorHooks = __webpack_require__(55020);
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/internals/isRef.js
var isRef = __webpack_require__(86337);
// EXTERNAL MODULE: ../../node_modules/@react-dnd/shallowequal/dist/shallowequal.esm.js
var shallowequal_esm = __webpack_require__(57320);
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/internals/SourceConnector.js
function SourceConnector_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SourceConnector_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SourceConnector_createClass(Constructor, protoProps, staticProps) { if (protoProps) SourceConnector_defineProperties(Constructor.prototype, protoProps); if (staticProps) SourceConnector_defineProperties(Constructor, staticProps); return Constructor; }

function SourceConnector_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var SourceConnector = /*#__PURE__*/function () {
  // The drop target may either be attached via ref or connect function
  // The drag preview may either be attached via ref or connect function
  function SourceConnector(backend) {
    var _this = this;

    SourceConnector_classCallCheck(this, SourceConnector);

    SourceConnector_defineProperty(this, "hooks", (0,wrapConnectorHooks/* wrapConnectorHooks */.p)({
      dragSource: function dragSource(node, options) {
        _this.clearDragSource();

        _this.dragSourceOptions = options || null;

        if ((0,isRef/* isRef */.d)(node)) {
          _this.dragSourceRef = node;
        } else {
          _this.dragSourceNode = node;
        }

        _this.reconnectDragSource();
      },
      dragPreview: function dragPreview(node, options) {
        _this.clearDragPreview();

        _this.dragPreviewOptions = options || null;

        if ((0,isRef/* isRef */.d)(node)) {
          _this.dragPreviewRef = node;
        } else {
          _this.dragPreviewNode = node;
        }

        _this.reconnectDragPreview();
      }
    }));

    SourceConnector_defineProperty(this, "handlerId", null);

    SourceConnector_defineProperty(this, "dragSourceRef", null);

    SourceConnector_defineProperty(this, "dragSourceNode", void 0);

    SourceConnector_defineProperty(this, "dragSourceOptionsInternal", null);

    SourceConnector_defineProperty(this, "dragSourceUnsubscribe", void 0);

    SourceConnector_defineProperty(this, "dragPreviewRef", null);

    SourceConnector_defineProperty(this, "dragPreviewNode", void 0);

    SourceConnector_defineProperty(this, "dragPreviewOptionsInternal", null);

    SourceConnector_defineProperty(this, "dragPreviewUnsubscribe", void 0);

    SourceConnector_defineProperty(this, "lastConnectedHandlerId", null);

    SourceConnector_defineProperty(this, "lastConnectedDragSource", null);

    SourceConnector_defineProperty(this, "lastConnectedDragSourceOptions", null);

    SourceConnector_defineProperty(this, "lastConnectedDragPreview", null);

    SourceConnector_defineProperty(this, "lastConnectedDragPreviewOptions", null);

    SourceConnector_defineProperty(this, "backend", void 0);

    this.backend = backend;
  }

  SourceConnector_createClass(SourceConnector, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(newHandlerId) {
      if (this.handlerId === newHandlerId) {
        return;
      }

      this.handlerId = newHandlerId;
      this.reconnect();
    }
  }, {
    key: "connectTarget",
    get: function get() {
      return this.dragSource;
    }
  }, {
    key: "dragSourceOptions",
    get: function get() {
      return this.dragSourceOptionsInternal;
    },
    set: function set(options) {
      this.dragSourceOptionsInternal = options;
    }
  }, {
    key: "dragPreviewOptions",
    get: function get() {
      return this.dragPreviewOptionsInternal;
    },
    set: function set(options) {
      this.dragPreviewOptionsInternal = options;
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      this.reconnectDragSource();
      this.reconnectDragPreview();
    }
  }, {
    key: "reconnectDragSource",
    value: function reconnectDragSource() {
      var dragSource = this.dragSource; // if nothing has changed then don't resubscribe

      var didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();

      if (didChange) {
        this.disconnectDragSource();
      }

      if (!this.handlerId) {
        return;
      }

      if (!dragSource) {
        this.lastConnectedDragSource = dragSource;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDragSource = dragSource;
        this.lastConnectedDragSourceOptions = this.dragSourceOptions;
        this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
      }
    }
  }, {
    key: "reconnectDragPreview",
    value: function reconnectDragPreview() {
      var dragPreview = this.dragPreview; // if nothing has changed then don't resubscribe

      var didChange = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();

      if (didChange) {
        this.disconnectDragPreview();
      }

      if (!this.handlerId) {
        return;
      }

      if (!dragPreview) {
        this.lastConnectedDragPreview = dragPreview;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDragPreview = dragPreview;
        this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
        this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
      }
    }
  }, {
    key: "didHandlerIdChange",
    value: function didHandlerIdChange() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didConnectedDragSourceChange",
    value: function didConnectedDragSourceChange() {
      return this.lastConnectedDragSource !== this.dragSource;
    }
  }, {
    key: "didConnectedDragPreviewChange",
    value: function didConnectedDragPreviewChange() {
      return this.lastConnectedDragPreview !== this.dragPreview;
    }
  }, {
    key: "didDragSourceOptionsChange",
    value: function didDragSourceOptionsChange() {
      return !(0,shallowequal_esm/* shallowEqual */.w)(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
  }, {
    key: "didDragPreviewOptionsChange",
    value: function didDragPreviewOptionsChange() {
      return !(0,shallowequal_esm/* shallowEqual */.w)(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
  }, {
    key: "disconnectDragSource",
    value: function disconnectDragSource() {
      if (this.dragSourceUnsubscribe) {
        this.dragSourceUnsubscribe();
        this.dragSourceUnsubscribe = undefined;
      }
    }
  }, {
    key: "disconnectDragPreview",
    value: function disconnectDragPreview() {
      if (this.dragPreviewUnsubscribe) {
        this.dragPreviewUnsubscribe();
        this.dragPreviewUnsubscribe = undefined;
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
      }
    }
  }, {
    key: "dragSource",
    get: function get() {
      return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
  }, {
    key: "dragPreview",
    get: function get() {
      return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
  }, {
    key: "clearDragSource",
    value: function clearDragSource() {
      this.dragSourceNode = null;
      this.dragSourceRef = null;
    }
  }, {
    key: "clearDragPreview",
    value: function clearDragPreview() {
      this.dragPreviewNode = null;
      this.dragPreviewRef = null;
    }
  }]);

  return SourceConnector;
}();
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrag/useDragSourceConnector.js




function useDragSourceConnector(dragSourceOptions, dragPreviewOptions) {
  var manager = (0,useDragDropManager/* useDragDropManager */.N)();
  var connector = (0,react.useMemo)(function () {
    return new SourceConnector(manager.getBackend());
  }, [manager]);
  (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function () {
    connector.dragSourceOptions = dragSourceOptions || null;
    connector.reconnect();
    return function () {
      return connector.disconnectDragSource();
    };
  }, [connector, dragSourceOptions]);
  (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function () {
    connector.dragPreviewOptions = dragPreviewOptions || null;
    connector.reconnect();
    return function () {
      return connector.disconnectDragPreview();
    };
  }, [connector, dragPreviewOptions]);
  return connector;
}
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useCollectedProps.js + 2 modules
var useCollectedProps = __webpack_require__(64969);
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrag/connectors.js

function useConnectDragSource(connector) {
  return (0,react.useMemo)(function () {
    return connector.hooks.dragSource();
  }, [connector]);
}
function useConnectDragPreview(connector) {
  return (0,react.useMemo)(function () {
    return connector.hooks.dragPreview();
  }, [connector]);
}
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrag/useDrag.js







/**
 * useDragSource hook
 * @param sourceSpec The drag source specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */

function useDrag(specArg, deps) {
  var spec = (0,useOptionalFactory/* useOptionalFactory */.w)(specArg, deps);
  (0,invariant_esm/* invariant */.k)(!spec.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  var monitor = useDragSourceMonitor();
  var connector = useDragSourceConnector(spec.options, spec.previewOptions);
  useRegisteredDragSource(spec, monitor, connector);
  return [(0,useCollectedProps/* useCollectedProps */.J)(spec.collect, monitor, connector), useConnectDragSource(connector), useConnectDragPreview(connector)];
}

/***/ }),

/***/ 92566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useDragDropManager; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _react_dnd_invariant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45293);
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12005);



/**
 * A hook to retrieve the DragDropManager from Context
 */

function useDragDropManager() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_core__WEBPACK_IMPORTED_MODULE_1__/* .DndContext */ .L),
      dragDropManager = _useContext.dragDropManager;

  (0,_react_dnd_invariant__WEBPACK_IMPORTED_MODULE_2__/* .invariant */ .k)(dragDropManager != null, 'Expected drag drop context');
  return dragDropManager;
}

/***/ }),

/***/ 40940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ useDrop; }
});

// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/internals/registration.js
var registration = __webpack_require__(690);
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDragDropManager.js
var useDragDropManager = __webpack_require__(92566);
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(32741);
// EXTERNAL MODULE: ../../node_modules/@react-dnd/invariant/dist/invariant.esm.js
var invariant_esm = __webpack_require__(45293);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrop/useAccept.js


/**
 * Internal utility hook to get an array-version of spec.accept.
 * The main utility here is that we aren't creating a new array on every render if a non-array spec.accept is passed in.
 * @param spec
 */

function useAccept(spec) {
  var accept = spec.accept;
  return (0,react.useMemo)(function () {
    (0,invariant_esm/* invariant */.k)(spec.accept != null, 'accept must be defined');
    return Array.isArray(accept) ? accept : [accept];
  }, [accept]);
}
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrop/DropTargetImpl.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DropTargetImpl = /*#__PURE__*/function () {
  function DropTargetImpl(spec, monitor) {
    _classCallCheck(this, DropTargetImpl);

    _defineProperty(this, "spec", void 0);

    _defineProperty(this, "monitor", void 0);

    this.spec = spec;
    this.monitor = monitor;
  }

  _createClass(DropTargetImpl, [{
    key: "canDrop",
    value: function canDrop() {
      var spec = this.spec;
      var monitor = this.monitor;
      return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
  }, {
    key: "hover",
    value: function hover() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (spec.hover) {
        spec.hover(monitor.getItem(), monitor);
      }
    }
  }, {
    key: "drop",
    value: function drop() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (spec.drop) {
        return spec.drop(monitor.getItem(), monitor);
      }
    }
  }]);

  return DropTargetImpl;
}();
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrop/useDropTarget.js


function useDropTarget(spec, monitor) {
  var dropTarget = (0,react.useMemo)(function () {
    return new DropTargetImpl(spec, monitor);
  }, [monitor]);
  (0,react.useEffect)(function () {
    dropTarget.spec = spec;
  }, [spec]);
  return dropTarget;
}
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrop/useRegisteredDropTarget.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






function useRegisteredDropTarget(spec, monitor, connector) {
  var manager = (0,useDragDropManager/* useDragDropManager */.N)();
  var dropTarget = useDropTarget(spec, monitor);
  var accept = useAccept(spec);
  (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function registerDropTarget() {
    var _registerTarget = (0,registration/* registerTarget */.n)(accept, dropTarget, manager),
        _registerTarget2 = _slicedToArray(_registerTarget, 2),
        handlerId = _registerTarget2[0],
        unregister = _registerTarget2[1];

    monitor.receiveHandlerId(handlerId);
    connector.receiveHandlerId(handlerId);
    return unregister;
  }, [manager, monitor, dropTarget, connector, accept.map(function (a) {
    return a.toString();
  }).join('|')]);
}
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useOptionalFactory.js
var useOptionalFactory = __webpack_require__(69980);
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/internals/DropTargetMonitorImpl.js
function DropTargetMonitorImpl_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DropTargetMonitorImpl_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DropTargetMonitorImpl_createClass(Constructor, protoProps, staticProps) { if (protoProps) DropTargetMonitorImpl_defineProperties(Constructor.prototype, protoProps); if (staticProps) DropTargetMonitorImpl_defineProperties(Constructor, staticProps); return Constructor; }

function DropTargetMonitorImpl_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var isCallingCanDrop = false;
var DropTargetMonitorImpl = /*#__PURE__*/function () {
  function DropTargetMonitorImpl(manager) {
    DropTargetMonitorImpl_classCallCheck(this, DropTargetMonitorImpl);

    DropTargetMonitorImpl_defineProperty(this, "internalMonitor", void 0);

    DropTargetMonitorImpl_defineProperty(this, "targetId", null);

    this.internalMonitor = manager.getMonitor();
  }

  DropTargetMonitorImpl_createClass(DropTargetMonitorImpl, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(targetId) {
      this.targetId = targetId;
    }
  }, {
    key: "getHandlerId",
    value: function getHandlerId() {
      return this.targetId;
    }
  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    }
  }, {
    key: "canDrop",
    value: function canDrop() {
      // Cut out early if the target id has not been set. This should prevent errors
      // where the user has an older version of dnd-core like in
      // https://github.com/react-dnd/react-dnd/issues/1310
      if (!this.targetId) {
        return false;
      }

      (0,invariant_esm/* invariant */.k)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor');

      try {
        isCallingCanDrop = true;
        return this.internalMonitor.canDropOnTarget(this.targetId);
      } finally {
        isCallingCanDrop = false;
      }
    }
  }, {
    key: "isOver",
    value: function isOver(options) {
      if (!this.targetId) {
        return false;
      }

      return this.internalMonitor.isOverTarget(this.targetId, options);
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return DropTargetMonitorImpl;
}();
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrop/useDropTargetMonitor.js



function useDropTargetMonitor() {
  var manager = (0,useDragDropManager/* useDragDropManager */.N)();
  return (0,react.useMemo)(function () {
    return new DropTargetMonitorImpl(manager);
  }, [manager]);
}
// EXTERNAL MODULE: ../../node_modules/@react-dnd/shallowequal/dist/shallowequal.esm.js
var shallowequal_esm = __webpack_require__(57320);
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/internals/wrapConnectorHooks.js
var wrapConnectorHooks = __webpack_require__(55020);
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/internals/isRef.js
var isRef = __webpack_require__(86337);
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/internals/TargetConnector.js
function TargetConnector_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TargetConnector_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TargetConnector_createClass(Constructor, protoProps, staticProps) { if (protoProps) TargetConnector_defineProperties(Constructor.prototype, protoProps); if (staticProps) TargetConnector_defineProperties(Constructor, staticProps); return Constructor; }

function TargetConnector_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var TargetConnector = /*#__PURE__*/function () {
  // The drop target may either be attached via ref or connect function
  function TargetConnector(backend) {
    var _this = this;

    TargetConnector_classCallCheck(this, TargetConnector);

    TargetConnector_defineProperty(this, "hooks", (0,wrapConnectorHooks/* wrapConnectorHooks */.p)({
      dropTarget: function dropTarget(node, options) {
        _this.clearDropTarget();

        _this.dropTargetOptions = options;

        if ((0,isRef/* isRef */.d)(node)) {
          _this.dropTargetRef = node;
        } else {
          _this.dropTargetNode = node;
        }

        _this.reconnect();
      }
    }));

    TargetConnector_defineProperty(this, "handlerId", null);

    TargetConnector_defineProperty(this, "dropTargetRef", null);

    TargetConnector_defineProperty(this, "dropTargetNode", void 0);

    TargetConnector_defineProperty(this, "dropTargetOptionsInternal", null);

    TargetConnector_defineProperty(this, "unsubscribeDropTarget", void 0);

    TargetConnector_defineProperty(this, "lastConnectedHandlerId", null);

    TargetConnector_defineProperty(this, "lastConnectedDropTarget", null);

    TargetConnector_defineProperty(this, "lastConnectedDropTargetOptions", null);

    TargetConnector_defineProperty(this, "backend", void 0);

    this.backend = backend;
  }

  TargetConnector_createClass(TargetConnector, [{
    key: "connectTarget",
    get: function get() {
      return this.dropTarget;
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      // if nothing has changed then don't resubscribe
      var didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();

      if (didChange) {
        this.disconnectDropTarget();
      }

      var dropTarget = this.dropTarget;

      if (!this.handlerId) {
        return;
      }

      if (!dropTarget) {
        this.lastConnectedDropTarget = dropTarget;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDropTarget = dropTarget;
        this.lastConnectedDropTargetOptions = this.dropTargetOptions;
        this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
      }
    }
  }, {
    key: "receiveHandlerId",
    value: function receiveHandlerId(newHandlerId) {
      if (newHandlerId === this.handlerId) {
        return;
      }

      this.handlerId = newHandlerId;
      this.reconnect();
    }
  }, {
    key: "dropTargetOptions",
    get: function get() {
      return this.dropTargetOptionsInternal;
    },
    set: function set(options) {
      this.dropTargetOptionsInternal = options;
    }
  }, {
    key: "didHandlerIdChange",
    value: function didHandlerIdChange() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didDropTargetChange",
    value: function didDropTargetChange() {
      return this.lastConnectedDropTarget !== this.dropTarget;
    }
  }, {
    key: "didOptionsChange",
    value: function didOptionsChange() {
      return !(0,shallowequal_esm/* shallowEqual */.w)(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
  }, {
    key: "disconnectDropTarget",
    value: function disconnectDropTarget() {
      if (this.unsubscribeDropTarget) {
        this.unsubscribeDropTarget();
        this.unsubscribeDropTarget = undefined;
      }
    }
  }, {
    key: "dropTarget",
    get: function get() {
      return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
  }, {
    key: "clearDropTarget",
    value: function clearDropTarget() {
      this.dropTargetRef = null;
      this.dropTargetNode = null;
    }
  }]);

  return TargetConnector;
}();
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrop/useDropTargetConnector.js




function useDropTargetConnector(options) {
  var manager = (0,useDragDropManager/* useDragDropManager */.N)();
  var connector = (0,react.useMemo)(function () {
    return new TargetConnector(manager.getBackend());
  }, [manager]);
  (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function () {
    connector.dropTargetOptions = options || null;
    connector.reconnect();
    return function () {
      return connector.disconnectDropTarget();
    };
  }, [options]);
  return connector;
}
// EXTERNAL MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useCollectedProps.js + 2 modules
var useCollectedProps = __webpack_require__(64969);
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrop/connectors.js

function useConnectDropTarget(connector) {
  return (0,react.useMemo)(function () {
    return connector.hooks.dropTarget();
  }, [connector]);
}
;// CONCATENATED MODULE: ../../node_modules/react-dnd/dist/esm/hooks/useDrop/useDrop.js






/**
 * useDropTarget Hook
 * @param spec The drop target specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */

function useDrop(specArg, deps) {
  var spec = (0,useOptionalFactory/* useOptionalFactory */.w)(specArg, deps);
  var monitor = useDropTargetMonitor();
  var connector = useDropTargetConnector(spec.options);
  useRegisteredDropTarget(spec, monitor, connector);
  return [(0,useCollectedProps/* useCollectedProps */.J)(spec.collect, monitor, connector), useConnectDropTarget(connector)];
}

/***/ }),

/***/ 32741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
 // suppress the useLayoutEffect warning on server side.

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;

/***/ }),

/***/ 69980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ useOptionalFactory; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


function useOptionalFactory(arg, deps) {
  var memoDeps = _toConsumableArray(deps || []);

  if (deps == null && typeof arg !== 'function') {
    memoDeps.push(arg);
  }

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return typeof arg === 'function' ? arg() : arg;
  }, memoDeps);
}

/***/ }),

/***/ 86337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ isRef; }
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isRef(obj) {
  return (// eslint-disable-next-line no-prototype-builtins
    obj !== null && _typeof(obj) === 'object' && Object.prototype.hasOwnProperty.call(obj, 'current')
  );
}

/***/ }),

/***/ 690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ registerTarget; },
/* harmony export */   "w": function() { return /* binding */ registerSource; }
/* harmony export */ });
function registerTarget(type, target, manager) {
  var registry = manager.getRegistry();
  var targetId = registry.addTarget(type, target);
  return [targetId, function () {
    return registry.removeTarget(targetId);
  }];
}
function registerSource(type, source, manager) {
  var registry = manager.getRegistry();
  var sourceId = registry.addSource(type, source);
  return [sourceId, function () {
    return registry.removeSource(sourceId);
  }];
}

/***/ }),

/***/ 55020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ wrapConnectorHooks; }
/* harmony export */ });
/* harmony import */ var _react_dnd_invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45293);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



function throwIfCompositeComponentElement(element) {
  // Custom components can no longer be wrapped directly in React DnD 2.0
  // so that we don't need to depend on findDOMNode() from react-dom.
  if (typeof element.type === 'string') {
    return;
  }

  var displayName = element.type.displayName || element.type.name || 'the component';
  throw new Error('Only native element nodes can now be passed to React DnD connectors.' + "You can either wrap ".concat(displayName, " into a <div>, or turn it into a ") + 'drag source or a drop target itself.');
}

function wrapHookToRecognizeElement(hook) {
  return function () {
    var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    // When passed a node, call the hook straight away.
    if (!(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(elementOrNode)) {
      var node = elementOrNode;
      hook(node, options); // return the node so it can be chained (e.g. when within callback refs
      // <div ref={node => connectDragSource(connectDropTarget(node))}/>

      return node;
    } // If passed a ReactElement, clone it and attach this function as a ref.
    // This helps us achieve a neat API where user doesn't even know that refs
    // are being used under the hood.


    var element = elementOrNode;
    throwIfCompositeComponentElement(element); // When no options are passed, use the hook directly

    var ref = options ? function (node) {
      return hook(node, options);
    } : hook;
    return cloneWithRef(element, ref);
  };
}

function wrapConnectorHooks(hooks) {
  var wrappedHooks = {};
  Object.keys(hooks).forEach(function (key) {
    var hook = hooks[key]; // ref objects should be passed straight through without wrapping

    if (key.endsWith('Ref')) {
      wrappedHooks[key] = hooks[key];
    } else {
      var wrappedHook = wrapHookToRecognizeElement(hook);

      wrappedHooks[key] = function () {
        return wrappedHook;
      };
    }
  });
  return wrappedHooks;
}

function setRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else {
    ref.current = node;
  }
}

function cloneWithRef(element, newRef) {
  var previousRef = element.ref;
  (0,_react_dnd_invariant__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .k)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs');

  if (!previousRef) {
    // When there is no ref on the element, use the new ref directly
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(element, {
      ref: newRef
    });
  } else {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(element, {
      ref: function ref(node) {
        setRef(previousRef, node);
        setRef(newRef, node);
      }
    });
  }
}

/***/ }),

/***/ 11997:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "DraggableCore", ({
  enumerable: true,
  get: function get() {
    return _DraggableCore.default;
  }
}));
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _reactDom = _interopRequireDefault(__webpack_require__(28316));

var _clsx2 = _interopRequireDefault(__webpack_require__(6277));

var _domFns = __webpack_require__(54688);

var _positionFns = __webpack_require__(93585);

var _shims = __webpack_require__(40136);

var _DraggableCore = _interopRequireDefault(__webpack_require__(93816));

var _log = _interopRequireDefault(__webpack_require__(81177));

var _excluded = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
// Define <Draggable>
//
var Draggable = /*#__PURE__*/function (_React$Component) {
  _inherits(Draggable, _React$Component);

  var _super = _createSuper(Draggable);

  function Draggable(props
  /*: DraggableProps*/
  ) {
    var _this;

    _classCallCheck(this, Draggable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e, coreData) {
      (0, _log.default)('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.

      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.


      if (shouldStart === false) return false;

      _this.setState({
        dragging: true,
        dragged: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDrag", function (e, coreData) {
      if (!_this.state.dragging) return false;
      (0, _log.default)('Draggable: onDrag: %j', coreData);
      var uiData = (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData);
      var newState
      /*: $Shape<DraggableState>*/
      = {
        x: uiData.x,
        y: uiData.y
      }; // Keep within bounds.

      if (_this.props.bounds) {
        // Save original x and y.
        var x = newState.x,
            y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.

        newState.x += _this.state.slackX;
        newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.

        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_assertThisInitialized(_this), newState.x, newState.y),
            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
            newStateX = _getBoundPosition2[0],
            newStateY = _getBoundPosition2[1];

        newState.x = newStateX;
        newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.

        newState.slackX = _this.state.slackX + (x - newState.x);
        newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.

        uiData.x = newState.x;
        uiData.y = newState.y;
        uiData.deltaX = newState.x - _this.state.x;
        uiData.deltaY = newState.y - _this.state.y;
      } // Short-circuit if user's callback killed it.


      var shouldUpdate = _this.props.onDrag(e, uiData);

      if (shouldUpdate === false) return false;

      _this.setState(newState);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e, coreData) {
      if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.

      var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData));

      if (shouldContinue === false) return false;
      (0, _log.default)('Draggable: onDragStop: %j', coreData);
      var newState
      /*: $Shape<DraggableState>*/
      = {
        dragging: false,
        slackX: 0,
        slackY: 0
      }; // If this is a controlled component, the result of this operation will be to
      // revert back to the old position. We expect a handler on `onDragStop`, at the least.

      var controlled = Boolean(_this.props.position);

      if (controlled) {
        var _this$props$position = _this.props.position,
            x = _this$props$position.x,
            y = _this$props$position.y;
        newState.x = x;
        newState.y = y;
      }

      _this.setState(newState);
    });

    _this.state = {
      // Whether or not we are currently dragging.
      dragging: false,
      // Whether or not we have been dragged before.
      dragged: false,
      // Current transform x and y.
      x: props.position ? props.position.x : props.defaultPosition.x,
      y: props.position ? props.position.y : props.defaultPosition.y,
      prevPropsPosition: _objectSpread({}, props.position),
      // Used for compensating for out-of-bounds drags
      slackX: 0,
      slackY: 0,
      // Can only determine if SVG after mounting
      isElementSVG: false
    };

    if (props.position && !(props.onDrag || props.onStop)) {
      // eslint-disable-next-line no-console
      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
    }

    return _this;
  }

  _createClass(Draggable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Check to see if the element passed is an instanceof SVGElement
      if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
        this.setState({
          isElementSVG: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        dragging: false
      }); // prevents invariant if unmounted while dragging
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    /*: ?HTMLElement*/
    {
      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;

      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render()
    /*: ReactElement<any>*/
    {
      var _clsx;

      var _this$props2 = this.props,
          axis = _this$props2.axis,
          bounds = _this$props2.bounds,
          children = _this$props2.children,
          defaultPosition = _this$props2.defaultPosition,
          defaultClassName = _this$props2.defaultClassName,
          defaultClassNameDragging = _this$props2.defaultClassNameDragging,
          defaultClassNameDragged = _this$props2.defaultClassNameDragged,
          position = _this$props2.position,
          positionOffset = _this$props2.positionOffset,
          scale = _this$props2.scale,
          draggableCoreProps = _objectWithoutProperties(_this$props2, _excluded);

      var style = {};
      var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.

      var controlled = Boolean(position);
      var draggable = !controlled || this.state.dragging;
      var validPosition = position || defaultPosition;
      var transformOpts = {
        // Set left if horizontal drag is enabled
        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
        // Set top if vertical drag is enabled
        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
      }; // If this element was SVG, we use the `transform` attribute.

      if (this.state.isElementSVG) {
        svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
      } else {
        // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
      } // Mark with class while dragging


      var className = (0, _clsx2.default)(children.props.className || '', defaultClassName, (_clsx = {}, _defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), _defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)

      return /*#__PURE__*/React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /*#__PURE__*/React.cloneElement(React.Children.only(children), {
        className: className,
        style: _objectSpread(_objectSpread({}, children.props.style), style),
        transform: svgTransform
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: // React 16.3+
    // Arity (props, state)
    function getDerivedStateFromProps(_ref, _ref2)
    /*: ?$Shape<DraggableState>*/
    {
      var position = _ref.position;
      var prevPropsPosition = _ref2.prevPropsPosition;

      // Set x/y if a new position is provided in props that is different than the previous.
      if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
        (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
          position: position,
          prevPropsPosition: prevPropsPosition
        });
        return {
          x: position.x,
          y: position.y,
          prevPropsPosition: _objectSpread({}, position)
        };
      }

      return null;
    }
  }]);

  return Draggable;
}(React.Component);

exports["default"] = Draggable;

_defineProperty(Draggable, "displayName", 'Draggable');

_defineProperty(Draggable, "propTypes", _objectSpread(_objectSpread({}, _DraggableCore.default.propTypes), {}, {
  /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */
  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),

  /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
    left: _propTypes.default.number,
    right: _propTypes.default.number,
    top: _propTypes.default.number,
    bottom: _propTypes.default.number
  }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
  defaultClassName: _propTypes.default.string,
  defaultClassNameDragging: _propTypes.default.string,
  defaultClassNameDragged: _propTypes.default.string,

  /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  defaultPosition: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }),
  positionOffset: _propTypes.default.shape({
    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  }),

  /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  position: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }),

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
}));

_defineProperty(Draggable, "defaultProps", _objectSpread(_objectSpread({}, _DraggableCore.default.defaultProps), {}, {
  axis: 'both',
  bounds: false,
  defaultClassName: 'react-draggable',
  defaultClassNameDragging: 'react-draggable-dragging',
  defaultClassNameDragged: 'react-draggable-dragged',
  defaultPosition: {
    x: 0,
    y: 0
  },
  scale: 1
}));

/***/ }),

/***/ 93816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _reactDom = _interopRequireDefault(__webpack_require__(28316));

var _domFns = __webpack_require__(54688);

var _positionFns = __webpack_require__(93585);

var _shims = __webpack_require__(40136);

var _log = _interopRequireDefault(__webpack_require__(81177));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Simple abstraction for dragging events names.
var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
}; // Default to mouse events.

var dragEventFor = eventsFor.mouse;
/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/

/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/

/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/

/*:: export type ControlPosition = {x: number, y: number};*/

/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/

/*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/

/*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/

//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
var DraggableCore = /*#__PURE__*/function (_React$Component) {
  _inherits(DraggableCore, _React$Component);

  var _super = _createSuper(DraggableCore);

  function DraggableCore() {
    var _this;

    _classCallCheck(this, DraggableCore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dragging: false,
      // Used while dragging to determine deltas.
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: null
    });

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
      // Make it possible to attach event handlers on top of this one.
      _this.props.onMouseDown(e); // Only accept left-clicks.


      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)

      var thisNode = _this.findDOMNode();

      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }

      var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.

      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      } // Prevent scrolling on mobile devices, like ipad/iphone.
      // Important that this is after handle/cancel.


      if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.

      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);

      _this.setState({
        touchIdentifier: touchIdentifier
      }); // Get the current drag point from the event. This is used as the offset.


      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return; // not possible but satisfies flow

      var x = position.x,
          y = position.y; // Create an event object with all the data parents need to make a decision here.

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.

      (0, _log.default)('calling', _this.props.onStart);

      var shouldUpdate = _this.props.onStart(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.

      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.

      _this.setState({
        dragging: true,
        lastX: x,
        lastY: y
      }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.


      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y; // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX,
            deltaY = y - _this.state.lastY;

        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);

        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);

        deltaX = _snapToGrid2[0];
        deltaY = _snapToGrid2[1];
        if (!deltaX && !deltaY) return; // skip useless drag

        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.

      var shouldUpdate = _this.props.onDrag(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) {
        try {
          // $FlowIgnore
          _this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          var event = ((document.createEvent('MouseEvents')
          /*: any*/
          )
          /*: MouseTouchEvent*/
          ); // I see why this insanity was deprecated
          // $FlowIgnore

          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

          _this.handleDragStop(event);
        }

        return;
      }

      _this.setState({
        lastX: x,
        lastY: y
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
      if (!_this.state.dragging) return;
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y;
      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y); // Call event handler

      var shouldContinue = _this.props.onStop(e, coreEvent);

      if (shouldContinue === false || _this.mounted === false) return false;

      var thisNode = _this.findDOMNode();

      if (thisNode) {
        // Remove user-select hack
        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }

      (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.

      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });

      if (thisNode) {
        // Remove event handlers
        (0, _log.default)('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStop(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStop(e);
    });

    return _this;
  }

  _createClass(DraggableCore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention

      var thisNode = this.findDOMNode();

      if (thisNode) {
        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.

      var thisNode = this.findDOMNode();

      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    /*: ?HTMLElement*/
    {
      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;

      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render()
    /*: React.Element<any>*/
    {
      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return /*#__PURE__*/React.cloneElement(React.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);

  return DraggableCore;
}(React.Component);

exports["default"] = DraggableCore;

_defineProperty(DraggableCore, "displayName", 'DraggableCore');

_defineProperty(DraggableCore, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes.default.bool,

  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes.default.bool,

  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes.default.bool,

  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function offsetParent(props
  /*: DraggableCoreProps*/
  , propName
  /*: $Keys<DraggableCoreProps>*/
  ) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },

  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes.default.arrayOf(_propTypes.default.number),

  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes.default.string,

  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes.default.string,

  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: _propTypes.default.object,

  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes.default.func,

  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes.default.func,

  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes.default.func,

  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes.default.func,

  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: _propTypes.default.number,

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});

_defineProperty(DraggableCore, "defaultProps", {
  allowAnyClick: false,
  // by default only accept left click
  disabled: false,
  enableUserSelectHack: true,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {},
  scale: 1
});

/***/ }),

/***/ 41327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(11997),
    Draggable = _require.default,
    DraggableCore = _require.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266


module.exports = Draggable;
module.exports["default"] = Draggable;
module.exports.DraggableCore = DraggableCore;

/***/ }),

/***/ 54688:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.matchesSelector = matchesSelector;
exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
exports.addEvent = addEvent;
exports.removeEvent = removeEvent;
exports.outerHeight = outerHeight;
exports.outerWidth = outerWidth;
exports.innerHeight = innerHeight;
exports.innerWidth = innerWidth;
exports.offsetXYFromParent = offsetXYFromParent;
exports.createCSSTransform = createCSSTransform;
exports.createSVGTransform = createSVGTransform;
exports.getTranslation = getTranslation;
exports.getTouch = getTouch;
exports.getTouchIdentifier = getTouchIdentifier;
exports.addUserSelectStyles = addUserSelectStyles;
exports.removeUserSelectStyles = removeUserSelectStyles;
exports.addClassName = addClassName;
exports.removeClassName = removeClassName;

var _shims = __webpack_require__(40136);

var _getPrefix = _interopRequireWildcard(__webpack_require__(92185));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var matchesSelectorFunc = '';

function matchesSelector(el
/*: Node*/
, selector
/*: string*/
)
/*: boolean*/
{
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims.isFunction)(el[method]);
    });
  } // Might not be found entirely (not an Element?) - in that case, bail
  // $FlowIgnore: Doesn't think elements are indexable


  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable

  return el[matchesSelectorFunc](selector);
} // Works up the tree to the draggable itself attempting to match selector.


function matchesSelectorAndParentsTo(el
/*: Node*/
, selector
/*: string*/
, baseNode
/*: Node*/
)
/*: boolean*/
{
  var node = el;

  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);

  return false;
}

function addEvent(el
/*: ?Node*/
, event
/*: string*/
, handler
/*: Function*/
, inputOptions
/*: Object*/
)
/*: void*/
{
  if (!el) return;

  var options = _objectSpread({
    capture: true
  }, inputOptions); // $FlowIgnore[method-unbinding]


  if (el.addEventListener) {
    el.addEventListener(event, handler, options);
  } else if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}

function removeEvent(el
/*: ?Node*/
, event
/*: string*/
, handler
/*: Function*/
, inputOptions
/*: Object*/
)
/*: void*/
{
  if (!el) return;

  var options = _objectSpread({
    capture: true
  }, inputOptions); // $FlowIgnore[method-unbinding]


  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options);
  } else if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}

function outerHeight(node
/*: HTMLElement*/
)
/*: number*/
{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims.int)(computedStyle.borderTopWidth);
  height += (0, _shims.int)(computedStyle.borderBottomWidth);
  return height;
}

function outerWidth(node
/*: HTMLElement*/
)
/*: number*/
{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims.int)(computedStyle.borderLeftWidth);
  width += (0, _shims.int)(computedStyle.borderRightWidth);
  return width;
}

function innerHeight(node
/*: HTMLElement*/
)
/*: number*/
{
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims.int)(computedStyle.paddingTop);
  height -= (0, _shims.int)(computedStyle.paddingBottom);
  return height;
}

function innerWidth(node
/*: HTMLElement*/
)
/*: number*/
{
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims.int)(computedStyle.paddingLeft);
  width -= (0, _shims.int)(computedStyle.paddingRight);
  return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/


// Get from offsetParent
function offsetXYFromParent(evt
/*: EventWithOffset*/
, offsetParent
/*: HTMLElement*/
, scale
/*: number*/
)
/*: ControlPosition*/
{
  var isBody = offsetParent === offsetParent.ownerDocument.body;
  var offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();
  var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
  var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
  return {
    x: x,
    y: y
  };
}

function createCSSTransform(controlPos
/*: ControlPosition*/
, positionOffset
/*: PositionOffsetControlPosition*/
)
/*: Object*/
{
  var translation = getTranslation(controlPos, positionOffset, 'px');
  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default), translation);
}

function createSVGTransform(controlPos
/*: ControlPosition*/
, positionOffset
/*: PositionOffsetControlPosition*/
)
/*: string*/
{
  var translation = getTranslation(controlPos, positionOffset, '');
  return translation;
}

function getTranslation(_ref2, positionOffset
/*: PositionOffsetControlPosition*/
, unitSuffix
/*: string*/
)
/*: string*/
{
  var x = _ref2.x,
      y = _ref2.y;
  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");

  if (positionOffset) {
    var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
    var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }

  return translation;
}

function getTouch(e
/*: MouseTouchEvent*/
, identifier
/*: number*/
)
/*: ?{clientX: number, clientY: number}*/
{
  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
    return identifier === t.identifier;
  });
}

function getTouchIdentifier(e
/*: MouseTouchEvent*/
)
/*: ?number*/
{
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
} // User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed


function addUserSelectStyles(doc
/*: ?Document*/
) {
  if (!doc) return;
  var styleEl = doc.getElementById('react-draggable-style-el');

  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }

  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}

function removeUserSelectStyles(doc
/*: ?Document*/
) {
  if (!doc) return;

  try {
    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE

    if (doc.selection) {
      // $FlowIgnore: IE
      doc.selection.empty();
    } else {
      // Remove selection caused by scroll, unless it's a focused input
      // (we use doc.defaultView in case we're in an iframe)
      var selection = (doc.defaultView || window).getSelection();

      if (selection && selection.type !== 'Caret') {
        selection.removeAllRanges();
      }
    }
  } catch (e) {// probably IE
  }
}

function addClassName(el
/*: HTMLElement*/
, className
/*: string*/
) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
      el.className += " ".concat(className);
    }
  }
}

function removeClassName(el
/*: HTMLElement*/
, className
/*: string*/
) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
  }
}

/***/ }),

/***/ 92185:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getPrefix = getPrefix;
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
exports["default"] = void 0;
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];

function getPrefix()
/*: string*/
{
  var _window$document, _window$document$docu;

  var prop
  /*: string*/
  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
  // Ensure we're running in an environment where there is actually a global
  // `window` obj
  if (typeof window === 'undefined') return ''; // If we're in a pseudo-browser server-side environment, this access
  // path may not exist, so bail out if it doesn't.

  var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
  if (!style) return '';
  if (prop in style) return '';

  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }

  return '';
}

function browserPrefixToKey(prop
/*: string*/
, prefix
/*: string*/
)
/*: string*/
{
  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}

function browserPrefixToStyle(prop
/*: string*/
, prefix
/*: string*/
)
/*: string*/
{
  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}

function kebabToTitleCase(str
/*: string*/
)
/*: string*/
{
  var out = '';
  var shouldCapitalize = true;

  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }

  return out;
} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`


var _default = (getPrefix()
/*: string*/
);

exports["default"] = _default;

/***/ }),

/***/ 81177:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = log;

/*eslint no-console:0*/
function log() {
  var _console;

  if (false) {}
}

/***/ }),

/***/ 93585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getBoundPosition = getBoundPosition;
exports.snapToGrid = snapToGrid;
exports.canDragX = canDragX;
exports.canDragY = canDragY;
exports.getControlPosition = getControlPosition;
exports.createCoreData = createCoreData;
exports.createDraggableData = createDraggableData;

var _shims = __webpack_require__(40136);

var _domFns = __webpack_require__(54688);

function getBoundPosition(draggable
/*: Draggable*/
, x
/*: number*/
, y
/*: number*/
)
/*: [number, number]*/
{
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y]; // Clone new bounds

  var bounds = draggable.props.bounds;
  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);

  if (typeof bounds === 'string') {
    var ownerDocument = node.ownerDocument;
    var ownerWindow = ownerDocument.defaultView;
    var boundNode;

    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }

    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }

    var boundNodeEl
    /*: HTMLElement*/
    = boundNode; // for Flow, can't seem to refine correctly

    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.

    bounds = {
      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
      right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
      bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
    };
  } // Keep x and y below right and bottom limits...


  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.

  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
  return [x, y];
}

function snapToGrid(grid
/*: [number, number]*/
, pendingX
/*: number*/
, pendingY
/*: number*/
)
/*: [number, number]*/
{
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}

function canDragX(draggable
/*: Draggable*/
)
/*: boolean*/
{
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}

function canDragY(draggable
/*: Draggable*/
)
/*: boolean*/
{
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
} // Get {x, y} positions from event.


function getControlPosition(e
/*: MouseTouchEvent*/
, touchIdentifier
/*: ?number*/
, draggableCore
/*: DraggableCore*/
)
/*: ?ControlPosition*/
{
  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch

  var node = findDOMNode(draggableCore); // User can provide an offsetParent if desired.

  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
} // Create an data object exposed by <DraggableCore>'s events


function createCoreData(draggable
/*: DraggableCore*/
, x
/*: number*/
, y
/*: number*/
)
/*: DraggableData*/
{
  var state = draggable.state;
  var isStart = !(0, _shims.isNum)(state.lastX);
  var node = findDOMNode(draggable);

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node: node,
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x: x,
      y: y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node: node,
      deltaX: x - state.lastX,
      deltaY: y - state.lastY,
      lastX: state.lastX,
      lastY: state.lastY,
      x: x,
      y: y
    };
  }
} // Create an data exposed by <Draggable>'s events


function createDraggableData(draggable
/*: Draggable*/
, coreData
/*: DraggableData*/
)
/*: DraggableData*/
{
  var scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
} // A lot faster than stringify/parse


function cloneBounds(bounds
/*: Bounds*/
)
/*: Bounds*/
{
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}

function findDOMNode(draggable
/*: Draggable | DraggableCore*/
)
/*: HTMLElement*/
{
  var node = draggable.findDOMNode();

  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  } // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME


  return node;
}

/***/ }),

/***/ 40136:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.findInArray = findInArray;
exports.isFunction = isFunction;
exports.isNum = isNum;
exports.int = int;
exports.dontSetMe = dontSetMe;

// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array
/*: Array<any> | TouchList*/
, callback
/*: Function*/
)
/*: any*/
{
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}

function isFunction(func
/*: any*/
)
/*: boolean %checks*/
{
  // $FlowIgnore[method-unbinding]
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}

function isNum(num
/*: any*/
)
/*: boolean %checks*/
{
  return typeof num === 'number' && !isNaN(num);
}

function int(a
/*: string*/
)
/*: number*/
{
  return parseInt(a, 10);
}

function dontSetMe(props
/*: Object*/
, propName
/*: string*/
, componentName
/*: string*/
)
/*: ?Error*/
{
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}

/***/ }),

/***/ 78435:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 36732:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(2784);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

___$insertStyle(".image-marker {\n  position: relative;\n  margin: 0 auto;\n}\n.image-marker__image {\n  margin: 0 auto;\n  width: 100%;\n}\n.image-marker__marker {\n  position: absolute;\n}\n.image-marker__marker--default {\n  width: 25px;\n  height: 25px;\n  background-color: brown;\n  border-radius: 50%;\n  color: white;\n  text-align: center;\n}");

var calculateMarkerPosition = function (mousePosition, imagePosition, scrollY, bufferLeft, bufferTop) {
    var pixelsLeft = mousePosition.clientX - imagePosition.left;
    var pixelsTop;
    if (imagePosition.top < 0) {
        pixelsTop = mousePosition.pageY - scrollY + imagePosition.top * -1;
    }
    else {
        pixelsTop = mousePosition.pageY - scrollY - imagePosition.top;
    }
    var top = ((pixelsTop - bufferTop) * 100) / imagePosition.height;
    var left = ((pixelsLeft - bufferLeft) * 100) / imagePosition.width;
    return [top, left];
};

var DEFAULT_BUFFER = 12;
var ImageMarker = function (_a) {
    var src = _a.src, markers = _a.markers, onAddMarker = _a.onAddMarker, MarkerComponent = _a.markerComponent, _b = _a.bufferLeft, bufferLeft = _b === void 0 ? DEFAULT_BUFFER : _b, _c = _a.bufferTop, bufferTop = _c === void 0 ? DEFAULT_BUFFER : _c, _d = _a.alt, alt = _d === void 0 ? 'Markers' : _d, _e = _a.extraClass, extraClass = _e === void 0 ? '' : _e;
    var imageRef = React.useRef(null);
    var handleImageClick = function (event) {
        if (!imageRef.current || !onAddMarker) {
            return;
        }
        var imageDimentions = imageRef.current.getBoundingClientRect();
        var _a = calculateMarkerPosition(event, imageDimentions, window.scrollY, bufferLeft, bufferTop), top = _a[0], left = _a[1];
        onAddMarker({
            top: top,
            left: left,
        });
    };
    var getItemPosition = function (marker) {
        return {
            top: marker.top + "%",
            left: marker.left + "%",
        };
    };
    return (React.createElement("div", { className: "image-marker" },
        React.createElement("img", { src: src, alt: alt, onClick: handleImageClick, className: 'image-marker__image ' + extraClass, ref: imageRef }),
        markers.map(function (marker, itemNumber) { return (React.createElement("div", { className: "image-marker__marker " + (!MarkerComponent && 'image-marker__marker--default'), style: getItemPosition(marker), key: itemNumber, "data-testid": "marker" }, MarkerComponent ? (React.createElement(MarkerComponent, __assign({}, marker, { itemNumber: itemNumber }))) : (itemNumber + 1))); })));
};

exports.Z = ImageMarker;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 43202:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DEFAULT_DATA_URL_KEY = exports.INIT_MAX_NUMBER = exports.DEFAULT_NULL_INDEX = void 0;
exports.DEFAULT_NULL_INDEX = -1;
exports.INIT_MAX_NUMBER = 1000;
exports.DEFAULT_DATA_URL_KEY = 'dataURL';


/***/ }),

/***/ 97802:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(2784));
var utils_1 = __webpack_require__(45487);
var validation_1 = __webpack_require__(31250);
var constants_1 = __webpack_require__(43202);
var ReactImageUploading = function (_a) {
    var _b = _a.value, value = _b === void 0 ? [] : _b, onChange = _a.onChange, onError = _a.onError, children = _a.children, _c = _a.dataURLKey, dataURLKey = _c === void 0 ? constants_1.DEFAULT_DATA_URL_KEY : _c, _d = _a.multiple, multiple = _d === void 0 ? false : _d, _e = _a.maxNumber, maxNumber = _e === void 0 ? constants_1.INIT_MAX_NUMBER : _e, acceptType = _a.acceptType, maxFileSize = _a.maxFileSize, resolutionWidth = _a.resolutionWidth, resolutionHeight = _a.resolutionHeight, resolutionType = _a.resolutionType, _f = _a.inputProps, inputProps = _f === void 0 ? {} : _f, _g = _a.allowNonImageType, allowNonImageType = _g === void 0 ? false : _g;
    var inValue = value || [];
    var inputRef = react_1.useRef(null);
    var _h = react_1.useState(constants_1.DEFAULT_NULL_INDEX), keyUpdate = _h[0], setKeyUpdate = _h[1];
    var _j = react_1.useState(null), errors = _j[0], setErrors = _j[1];
    var _k = react_1.useState(false), isDragging = _k[0], setIsDragging = _k[1];
    var handleClickInput = react_1.useCallback(function () { return utils_1.openFileDialog(inputRef); }, [
        inputRef,
    ]);
    var onImageUpload = react_1.useCallback(function () {
        setKeyUpdate(constants_1.DEFAULT_NULL_INDEX);
        handleClickInput();
    }, [handleClickInput]);
    var onImageRemoveAll = react_1.useCallback(function () {
        onChange === null || onChange === void 0 ? void 0 : onChange([]);
    }, [onChange]);
    var onImageRemove = function (index) {
        var updatedList = __spreadArrays(inValue);
        if (Array.isArray(index)) {
            index.forEach(function (i) {
                updatedList.splice(i, 1);
            });
        }
        else {
            updatedList.splice(index, 1);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedList);
    };
    var onImageUpdate = function (index) {
        setKeyUpdate(index);
        handleClickInput();
    };
    var validate = function (fileList) { return __awaiter(void 0, void 0, void 0, function () {
        var errorsValidation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, validation_1.getErrorValidation({
                        fileList: fileList,
                        maxFileSize: maxFileSize,
                        maxNumber: maxNumber,
                        acceptType: acceptType,
                        keyUpdate: keyUpdate,
                        resolutionType: resolutionType,
                        resolutionWidth: resolutionWidth,
                        resolutionHeight: resolutionHeight,
                        value: inValue,
                        allowNonImageType: allowNonImageType,
                    })];
                case 1:
                    errorsValidation = _a.sent();
                    if (errorsValidation) {
                        setErrors(errorsValidation);
                        onError === null || onError === void 0 ? void 0 : onError(errorsValidation, fileList);
                        return [2 /*return*/, false];
                    }
                    errors && setErrors(null);
                    return [2 /*return*/, true];
            }
        });
    }); };
    var handleChange = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var fileList, checkValidate, updatedFileList, updatedIndexes, firstFile, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!files)
                        return [2 /*return*/];
                    return [4 /*yield*/, utils_1.getListFiles(files, dataURLKey)];
                case 1:
                    fileList = _a.sent();
                    if (!fileList.length)
                        return [2 /*return*/];
                    return [4 /*yield*/, validate(fileList)];
                case 2:
                    checkValidate = _a.sent();
                    if (!checkValidate)
                        return [2 /*return*/];
                    updatedIndexes = [];
                    if (keyUpdate > constants_1.DEFAULT_NULL_INDEX) {
                        firstFile = fileList[0];
                        updatedFileList = __spreadArrays(inValue);
                        updatedFileList[keyUpdate] = firstFile;
                        updatedIndexes.push(keyUpdate);
                    }
                    else if (multiple) {
                        updatedFileList = __spreadArrays(inValue, fileList);
                        for (i = inValue.length; i < updatedFileList.length; i += 1) {
                            updatedIndexes.push(i);
                        }
                    }
                    else {
                        updatedFileList = [fileList[0]];
                        updatedIndexes.push(0);
                    }
                    onChange === null || onChange === void 0 ? void 0 : onChange(updatedFileList, updatedIndexes);
                    return [2 /*return*/];
            }
        });
    }); };
    var onInputChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleChange(e.target.files)];
                case 1:
                    _a.sent();
                    keyUpdate > constants_1.DEFAULT_NULL_INDEX && setKeyUpdate(constants_1.DEFAULT_NULL_INDEX);
                    if (inputRef.current)
                        inputRef.current.value = '';
                    return [2 /*return*/];
            }
        });
    }); };
    var acceptTypeString = react_1.useMemo(function () { return utils_1.getAcceptTypeString(acceptType, allowNonImageType); }, [acceptType, allowNonImageType]);
    var handleDrag = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    var handleDragIn = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragging(true);
        }
    };
    var handleDragOut = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };
    var handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            handleChange(e.dataTransfer.files);
        }
    };
    var handleDragStart = function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.dataTransfer.clearData();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", __assign({ type: "file", accept: acceptTypeString, ref: inputRef, multiple: multiple && keyUpdate === constants_1.DEFAULT_NULL_INDEX, onChange: onInputChange, style: { display: 'none' } }, inputProps)), children === null || children === void 0 ? void 0 :
        children({
            imageList: inValue,
            onImageUpload: onImageUpload,
            onImageRemoveAll: onImageRemoveAll,
            onImageUpdate: onImageUpdate,
            onImageRemove: onImageRemove,
            errors: errors,
            dragProps: {
                onDrop: handleDrop,
                onDragEnter: handleDragIn,
                onDragLeave: handleDragOut,
                onDragOver: handleDrag,
                onDragStart: handleDragStart,
            },
            isDragging: isDragging,
        })));
};
exports["default"] = ReactImageUploading;


/***/ }),

/***/ 45487:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getListFiles = exports.getImage = exports.getBase64 = exports.getAcceptTypeString = exports.openFileDialog = void 0;
exports.openFileDialog = function (inputRef) {
    if (inputRef.current)
        inputRef.current.click();
};
exports.getAcceptTypeString = function (acceptType, allowNonImageType) {
    if (acceptType === null || acceptType === void 0 ? void 0 : acceptType.length)
        return acceptType.map(function (item) { return "." + item; }).join(', ');
    if (allowNonImageType)
        return '';
    return 'image/*';
};
exports.getBase64 = function (file) {
    var reader = new FileReader();
    return new Promise(function (resolve) {
        reader.addEventListener('load', function () { return resolve(String(reader.result)); });
        reader.readAsDataURL(file);
    });
};
exports.getImage = function (file) {
    var image = new Image();
    return new Promise(function (resolve) {
        image.addEventListener('load', function () { return resolve(image); });
        image.src = URL.createObjectURL(file);
    });
};
exports.getListFiles = function (files, dataURLKey) {
    var promiseFiles = [];
    for (var i = 0; i < files.length; i += 1) {
        promiseFiles.push(exports.getBase64(files[i]));
    }
    return Promise.all(promiseFiles).then(function (fileListBase64) {
        var fileList = fileListBase64.map(function (base64, index) {
            var _a;
            return (_a = {},
                _a[dataURLKey] = base64,
                _a.file = files[index],
                _a);
        });
        return fileList;
    });
};


/***/ }),

/***/ 31250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getErrorValidation = exports.isMaxNumberValid = exports.isAcceptTypeValid = exports.isMaxFileSizeValid = exports.isImageValid = exports.isResolutionValid = void 0;
var constants_1 = __webpack_require__(43202);
var utils_1 = __webpack_require__(45487);
exports.isResolutionValid = function (image, resolutionType, resolutionWidth, resolutionHeight) {
    if (resolutionWidth === void 0) { resolutionWidth = 0; }
    if (resolutionHeight === void 0) { resolutionHeight = 1; }
    if (!resolutionWidth || !resolutionHeight || !image.width || !image.height)
        return true;
    switch (resolutionType) {
        case 'absolute': {
            if (image.width === resolutionWidth && image.height === resolutionHeight)
                return true;
            break;
        }
        case 'ratio': {
            var ratio = resolutionWidth / resolutionHeight;
            if (image.width / image.height === ratio)
                return true;
            break;
        }
        case 'less': {
            if (image.width <= resolutionWidth && image.height <= resolutionHeight)
                return true;
            break;
        }
        case 'more': {
            if (image.width >= resolutionWidth && image.height >= resolutionHeight)
                return true;
            break;
        }
        default:
            break;
    }
    return false;
};
exports.isImageValid = function (fileType) {
    if (fileType.includes('image')) {
        return true;
    }
    return false;
};
exports.isMaxFileSizeValid = function (fileSize, maxFileSize) {
    return maxFileSize ? fileSize <= maxFileSize : true;
};
exports.isAcceptTypeValid = function (acceptType, fileName) {
    if (acceptType && acceptType.length > 0) {
        var type_1 = fileName.split('.').pop() || '';
        if (acceptType.findIndex(function (item) { return item.toLowerCase() === type_1.toLowerCase(); }) < 0)
            return false;
    }
    return true;
};
exports.isMaxNumberValid = function (totalNumber, maxNumber, keyUpdate) {
    if (maxNumber !== 0 && !maxNumber)
        return true;
    if (keyUpdate === constants_1.DEFAULT_NULL_INDEX) {
        if (totalNumber <= maxNumber)
            return true;
    }
    else if (totalNumber <= maxNumber + 1)
        return true;
    return false;
};
exports.getErrorValidation = function (_a) {
    var fileList = _a.fileList, value = _a.value, maxNumber = _a.maxNumber, keyUpdate = _a.keyUpdate, acceptType = _a.acceptType, maxFileSize = _a.maxFileSize, resolutionType = _a.resolutionType, resolutionWidth = _a.resolutionWidth, resolutionHeight = _a.resolutionHeight, allowNonImageType = _a.allowNonImageType;
    return __awaiter(void 0, void 0, void 0, function () {
        var newErrors, i, file, image, checkRes;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    newErrors = {};
                    if (!!exports.isMaxNumberValid(fileList.length + value.length, maxNumber, keyUpdate)) return [3 /*break*/, 1];
                    newErrors.maxNumber = true;
                    return [3 /*break*/, 5];
                case 1:
                    i = 0;
                    _b.label = 2;
                case 2:
                    if (!(i < fileList.length)) return [3 /*break*/, 5];
                    file = fileList[i].file;
                    if (!file)
                        return [3 /*break*/, 4];
                    if (!allowNonImageType && !exports.isImageValid(file.type)) {
                        newErrors.acceptType = true;
                        return [3 /*break*/, 5];
                    }
                    if (!exports.isAcceptTypeValid(acceptType, file.name)) {
                        newErrors.acceptType = true;
                        return [3 /*break*/, 5];
                    }
                    if (!exports.isMaxFileSizeValid(file.size, maxFileSize)) {
                        newErrors.maxFileSize = true;
                        return [3 /*break*/, 5];
                    }
                    if (!resolutionType) return [3 /*break*/, 4];
                    return [4 /*yield*/, utils_1.getImage(file)];
                case 3:
                    image = _b.sent();
                    checkRes = exports.isResolutionValid(image, resolutionType, resolutionWidth, resolutionHeight);
                    if (!checkRes) {
                        newErrors.resolution = true;
                        return [3 /*break*/, 5];
                    }
                    _b.label = 4;
                case 4:
                    i += 1;
                    return [3 /*break*/, 2];
                case 5:
                    if (Object.values(newErrors).find(Boolean))
                        return [2 /*return*/, newErrors];
                    return [2 /*return*/, null];
            }
        });
    });
};


/***/ }),

/***/ 26689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _aphrodite = __webpack_require__(32418);

var _reactScrolllock = __webpack_require__(19233);

var _reactScrolllock2 = _interopRequireDefault(_reactScrolllock);

var _theme = __webpack_require__(48219);

var _theme2 = _interopRequireDefault(_theme);

var _Arrow = __webpack_require__(25909);

var _Arrow2 = _interopRequireDefault(_Arrow);

var _Container = __webpack_require__(8382);

var _Container2 = _interopRequireDefault(_Container);

var _Footer = __webpack_require__(4378);

var _Footer2 = _interopRequireDefault(_Footer);

var _Header = __webpack_require__(70441);

var _Header2 = _interopRequireDefault(_Header);

var _PaginatedThumbnails = __webpack_require__(14837);

var _PaginatedThumbnails2 = _interopRequireDefault(_PaginatedThumbnails);

var _Portal = __webpack_require__(72263);

var _Portal2 = _interopRequireDefault(_Portal);

var _Spinner = __webpack_require__(35270);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _util = __webpack_require__(39537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function normalizeSourceSet(data) {
  var sourceSet = data.srcSet || data.srcset;

  if (Array.isArray(sourceSet)) {
    return sourceSet.join();
  }

  return sourceSet;
}

var ThemeContext = _react2.default.createContext({
  theme: _theme2.default,
  toggleTheme: function toggleTheme(newTheme) {}
});

var ImgsViewer = function (_Component) {
  _inherits(ImgsViewer, _Component);

  function ImgsViewer(props) {
    _classCallCheck(this, ImgsViewer);

    var _this = _possibleConstructorReturn(this, (ImgsViewer.__proto__ || Object.getPrototypeOf(ImgsViewer)).call(this, props));

    _this.theme = (0, _util.deepMerge)(_theme2.default, _this.props.theme);
    _this.classes = _aphrodite.StyleSheet.create((0, _util.deepMerge)(defaultStyles, _this.props.theme));
    _this.toggleTheme = function (theme) {
      _this.setState(function () {
        return { theme: theme };
      });
    };
    _this.state = {
      imgLoaded: false,
      theme: _this.theme,
      toggleTheme: _this.toggleTheme
    };

    _util.bindFunctions.call(_this, ["gotoNext", "gotoPrev", "closeBackdrop", "handleKeyboardInput", "handleImgLoaded"]);
    return _this;
  }

  _createClass(ImgsViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        if (this.props.enableKeyboardInput) {
          window.addEventListener("keydown", this.handleKeyboardInput);
        }
        if (typeof this.props.currImg === "number") {
          this.preloadImg(this.props.currImg, this.handleImgLoaded);
        }
      }
    }
    // static getDerivedStateFromProps (nextProps, prevState) {

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!_util.canUseDom) return;

      // const instance = this

      // always to preload imgs with both directions
      // then when user changs direction, img also show quickly
      if (nextProps.preloadNextImg) {
        var nextIdx = nextProps.currImg + 1;
        var prevIdx = nextProps.currImg - 1;
        // debugger
        // if (!this) return null
        this.preloadImg(prevIdx);
        this.preloadImg(nextIdx);
      }
      // preload currImg
      if (this.props.currImg !== nextProps.currImg || !this.props.isOpen && nextProps.isOpen) {
        var img = this.preloadImgData(nextProps.imgs[nextProps.currImg], this.handleImgLoaded);
        if (img) this.setState({
          imgLoaded: img.complete
        });
      }

      // add/remove event listeners
      if (!this.props.isOpen && nextProps.isOpen && nextProps.enableKeyboardInput) {
        window.addEventListener("keydown", this.handleKeyboardInput);
      }
      if (!nextProps.isOpen && nextProps.enableKeyboardInput) {
        window.removeEventListener("keydown", this.handleKeyboardInput);
      }

      return null;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.enableKeyboardInput) {
        window.removeEventListener("keydown", this.handleKeyboardInput);
      }
    }

    // ====================
    // Methods
    // ====================

  }, {
    key: "preloadImg",
    value: function preloadImg(idx, onload) {
      return this.preloadImgData(this.props.imgs[idx], onload);
    }
  }, {
    key: "preloadImgData",
    value: function preloadImgData(data, onload) {
      if (!data) return;

      var img = new Image();
      var sourceSet = normalizeSourceSet(data);

      // Todo: add error handling for missing imgs
      img.onerror = onload;
      img.onload = onload;
      img.src = data.src;

      if (sourceSet) img.srcset = sourceSet;

      return img;
    }
  }, {
    key: "gotoNext",
    value: function gotoNext(event) {
      var _props = this.props,
          currImg = _props.currImg,
          imgs = _props.imgs;
      var imgLoaded = this.state.imgLoaded;


      if (!imgLoaded || currImg === imgs.length - 1) return;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      this.props.onClickNext();
    }
  }, {
    key: "gotoPrev",
    value: function gotoPrev(event) {
      var currImg = this.props.currImg;
      var imgLoaded = this.state.imgLoaded;


      if (!imgLoaded || currImg === 0) return;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      this.props.onClickPrev();
    }
  }, {
    key: "closeBackdrop",
    value: function closeBackdrop(event) {
      if (event.target.id === "viewerBackdrop" || event.target.tagName === "FIGURE") {
        this.props.onClose();
      }
    }
  }, {
    key: "handleKeyboardInput",
    value: function handleKeyboardInput(event) {
      var keyCode = event.keyCode;

      if (keyCode === 37 || keyCode === 33 || keyCode === 38) {
        // left, pageup, up
        this.gotoPrev(event);
        return true;
      } else if (keyCode === 39 || keyCode === 34 || keyCode === 40) {
        // right, pagedown, down
        this.gotoNext(event);
        return true;
      } else if (keyCode === 27 || keyCode === 32) {
        // esc, space
        this.props.onClose();
        return true;
      }
      return false;
    }
  }, {
    key: "handleImgLoaded",
    value: function handleImgLoaded() {
      this.setState({
        imgLoaded: true
      });
    }

    // ====================
    // Renderers
    // ====================

  }, {
    key: "renderArrowPrev",
    value: function renderArrowPrev(theme) {
      if (this.props.currImg === 0) return null;

      return _react2.default.createElement(_Arrow2.default, {
        theme: theme,
        direction: "left",
        icon: "arrowLeft",
        onClick: this.gotoPrev,
        title: this.props.leftArrowTitle,
        type: "button"
      });
    }
  }, {
    key: "renderArrowNext",
    value: function renderArrowNext(theme) {
      if (this.props.currImg === this.props.imgs.length - 1) return null;

      return _react2.default.createElement(_Arrow2.default, {
        theme: theme,
        direction: "right",
        icon: "arrowRight",
        onClick: this.gotoNext,
        title: this.props.rightArrowTitle,
        type: "button"
      });
    }
  }, {
    key: "renderDialog",
    value: function renderDialog(newState) {
      var _this2 = this;

      var _props2 = this.props,
          backdropCloseable = _props2.backdropCloseable,
          isOpen = _props2.isOpen,
          showThumbnails = _props2.showThumbnails,
          width = _props2.width;
      var imgLoaded = this.state.imgLoaded;


      if (!isOpen) return _react2.default.createElement("span", { key: "closed" });

      var offsetThumbnails = showThumbnails ? this.theme.thumbnail.size + this.theme.container.gutter.vertical : 0;

      return _react2.default.createElement(
        ThemeContext.Consumer,
        null,
        function (_ref) {
          var theme = _ref.theme,
              toggleTheme = _ref.toggleTheme;

          theme = newState.theme;
          return _react2.default.createElement(
            _Container2.default,
            {
              theme: theme,
              key: "open",
              onClick: backdropCloseable && _this2.closeBackdrop,
              onTouchEnd: backdropCloseable && _this2.closeBackdrop
            },
            _react2.default.createElement(
              _react.Fragment,
              null,
              _react2.default.createElement(
                "div",
                {
                  className: (0, _aphrodite.css)(_this2.classes.content),
                  style: {
                    marginBottom: offsetThumbnails,
                    maxWidth: width
                  }
                },
                imgLoaded && _this2.renderHeader(theme),
                " ",
                _this2.renderImgs(theme),
                _this2.renderSpinner(),
                " ",
                imgLoaded && _this2.renderFooter(theme)
              ),
              imgLoaded && _this2.renderThumbnails(theme),
              imgLoaded && _this2.renderArrowPrev(theme),
              imgLoaded && _this2.renderArrowNext(theme),
              _this2.props.preventScroll && _react2.default.createElement(_reactScrolllock2.default, null)
            )
          );
        }
      );
    }
  }, {
    key: "renderImgs",
    value: function renderImgs(theme) {
      var _props3 = this.props,
          currImg = _props3.currImg,
          imgs = _props3.imgs,
          onClickImg = _props3.onClickImg,
          showThumbnails = _props3.showThumbnails;
      var imgLoaded = this.state.imgLoaded;


      if (!imgs || !imgs.length) return null;

      var img = imgs[currImg];
      var sourceSet = normalizeSourceSet(img);
      var sizes = sourceSet ? "100vw" : null;

      var thumbnailsSize = showThumbnails ? theme.thumbnail.size : 0;
      var heightOffset = theme.header.height + theme.footer.height + thumbnailsSize + theme.container.gutter.vertical + "px";

      return _react2.default.createElement(
        "figure",
        { className: (0, _aphrodite.css)(this.classes.figure) },
        _react2.default.createElement("img", {
          className: (0, _aphrodite.css)(this.classes.img, imgLoaded && this.classes.imgLoaded),
          onClick: onClickImg,
          sizes: sizes,
          alt: img.alt,
          src: img.src,
          srcSet: sourceSet,
          style: {
            cursor: onClickImg ? "pointer" : "auto",
            maxHeight: "calc(100vh - " + heightOffset
          }
        })
      );
    }
  }, {
    key: "renderThumbnails",
    value: function renderThumbnails(theme) {
      var _props4 = this.props,
          imgs = _props4.imgs,
          currImg = _props4.currImg,
          leftArrowTitle = _props4.leftArrowTitle,
          rightArrowTitle = _props4.rightArrowTitle,
          onClickThumbnail = _props4.onClickThumbnail,
          showThumbnails = _props4.showThumbnails,
          thumbnailOffset = _props4.thumbnailOffset;


      if (!showThumbnails) return null;

      return _react2.default.createElement(_PaginatedThumbnails2.default, {
        theme: theme,
        leftTitle: leftArrowTitle,
        rightTitle: rightArrowTitle,
        currImg: currImg,
        imgs: imgs,
        offset: thumbnailOffset,
        onClickThumbnail: onClickThumbnail
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader(theme) {
      var _props5 = this.props,
          closeBtnTitle = _props5.closeBtnTitle,
          customControls = _props5.customControls,
          onClose = _props5.onClose,
          showCloseBtn = _props5.showCloseBtn;


      return _react2.default.createElement(_Header2.default, {
        theme: theme,
        customControls: customControls,
        onClose: onClose,
        showCloseBtn: showCloseBtn,
        closeBtnTitle: closeBtnTitle
      });
    }
  }, {
    key: "renderFooter",
    value: function renderFooter(theme) {
      var _props6 = this.props,
          currImg = _props6.currImg,
          imgs = _props6.imgs,
          imgCountSeparator = _props6.imgCountSeparator,
          showImgCount = _props6.showImgCount;


      if (!imgs || !imgs.length) return null;

      return _react2.default.createElement(_Footer2.default, {
        theme: theme,
        caption: imgs[currImg].caption,
        countCurr: currImg + 1,
        countSeparator: imgCountSeparator,
        countTotal: imgs.length,
        showCount: showImgCount
      });
    }
  }, {
    key: "renderSpinner",
    value: function renderSpinner() {
      var _props7 = this.props,
          spinner = _props7.spinner,
          spinnerDisabled = _props7.spinnerDisabled,
          spinnerColor = _props7.spinnerColor,
          spinnerSize = _props7.spinnerSize;
      var imgLoaded = this.state.imgLoaded;

      var Spinner = spinner;
      if (spinnerDisabled) return null;
      return _react2.default.createElement(
        "div",
        {
          className: (0, _aphrodite.css)(this.classes.spinner, !imgLoaded && this.classes.spinnerActive)
        },
        _react2.default.createElement(Spinner, { color: spinnerColor, size: spinnerSize })
      );
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        ThemeContext.Provider,
        { value: this.state },
        _react2.default.createElement(
          _Portal2.default,
          null,
          " ",
          this.renderDialog(this.state),
          " "
        )
      );
    }
  }]);

  return ImgsViewer;
}(_react.Component);

ImgsViewer.propTypes = {
  backdropCloseable: _propTypes2.default.bool,
  closeBtnTitle: _propTypes2.default.string,
  currImg: _propTypes2.default.number,
  customControls: _propTypes2.default.arrayOf(_propTypes2.default.node),
  enableKeyboardInput: _propTypes2.default.bool,
  imgCountSeparator: _propTypes2.default.string,
  imgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    src: _propTypes2.default.string.isRequired,
    srcSet: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
    caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    thumbnail: _propTypes2.default.string
  })).isRequired,
  isOpen: _propTypes2.default.bool,
  leftArrowTitle: _propTypes2.default.string,
  onClickImg: _propTypes2.default.func,
  onClickNext: _propTypes2.default.func,
  onClickPrev: _propTypes2.default.func,
  onClickThumbnail: _propTypes2.default.func,
  onClose: _propTypes2.default.func.isRequired,
  preloadNextImg: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  rightArrowTitle: _propTypes2.default.string,
  showCloseBtn: _propTypes2.default.bool,
  showImgCount: _propTypes2.default.bool,
  showThumbnails: _propTypes2.default.bool,
  spinnerDisabled: _propTypes2.default.bool,
  spinner: _propTypes2.default.func,
  spinnerColor: _propTypes2.default.string,
  spinnerSize: _propTypes2.default.number,
  theme: _propTypes2.default.object,
  thumbnailOffset: _propTypes2.default.number,
  width: _propTypes2.default.number
};
ImgsViewer.defaultProps = {
  currImg: 0,
  enableKeyboardInput: true,
  imgCountSeparator: " / ",
  onClickShowNextImg: true,
  preloadNextImg: true,
  preventScroll: true,
  showCloseBtn: true,
  showImgCount: true,
  spinnerDisabled: false,
  spinner: _Spinner2.default,
  spinnerColor: "#fff",
  spinnerSize: 50,
  theme: {},
  thumbnailOffset: 2,
  width: 1024
};

var defaultStyles = {
  content: {
    position: "relative"
  },
  figure: {
    margin: 0 // remove browser default
  },
  img: {
    display: "block", // removes browser default gutter
    height: "auto",
    margin: "0 auto", // main center on very short screens or very narrow img
    maxWidth: "100%",

    // disable user select
    WebkitTouchCallout: "none",
    userSelect: "none",

    // opacity animation on image load
    opacity: 0,
    transition: "opacity .3s"
  },
  imgLoaded: {
    opacity: 1
  },
  spinner: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    // opacity animation to make spinner appear with delay
    opacity: 0,
    transition: "opacity .3s",
    pointerEvents: "none"
  },
  spinnerActive: {
    opacity: 1
  }
};

exports["default"] = ImgsViewer;

/***/ }),

/***/ 25909:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(44884);

var _theme = __webpack_require__(48219);

var _theme2 = _interopRequireDefault(_theme);

var _util = __webpack_require__(39537);

var _Icon = __webpack_require__(32023);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Arrow(_ref) {
  var direction = _ref.direction,
      icon = _ref.icon,
      onClick = _ref.onClick,
      size = _ref.size,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["direction", "icon", "onClick", "size", "theme"]);

  var classes = _noImportant.StyleSheet.create((0, _util.deepMerge)(defaultStyles, theme));

  return _react2.default.createElement(
    "button",
    _extends({
      type: "button" // default: submit
      , className: (0, _noImportant.css)(classes.arrow, classes["arrow__direction__" + direction], size && classes["arrow__size__" + size]),
      onClick: onClick,
      onTouchEnd: onClick
    }, props),
    _react2.default.createElement(_Icon2.default, {
      fill: !!theme.arrow && theme.arrow.fill || _theme2.default.arrow.fill,
      type: icon
    })
  );
}

Arrow.propTypes = {
  theme: _propTypes2.default.object,
  direction: _propTypes2.default.oneOf(["left", "right"]),
  icon: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.oneOf(["medium", "small"]).isRequired
};
Arrow.defaultProps = {
  size: "medium"
};
var defaultStyles = {
  arrow: {
    background: "none",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    outline: "none",
    padding: 10, // increase hit area
    position: "absolute",
    top: "50%",

    // disable user select
    WebkitTouchCallout: "none",
    userSelect: "none"
  },

  // sizes
  arrow__size__medium: {
    height: _theme2.default.arrow.height,
    marginTop: _theme2.default.arrow.height / -2,
    width: 40,

    "@media (min-width: 768px)": {
      width: 70
    }
  },
  arrow__size__small: {
    height: _theme2.default.thumbnail.size,
    marginTop: _theme2.default.thumbnail.size / -2,
    width: 30,

    "@media (min-width: 500px)": {
      width: 40
    }
  },

  // direciton
  arrow__direction__right: {
    right: _theme2.default.container.gutter.horizontal
  },
  arrow__direction__left: {
    left: _theme2.default.container.gutter.horizontal
  }
};

exports["default"] = Arrow;

/***/ }),

/***/ 8382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(44884);

var _theme = __webpack_require__(48219);

var _theme2 = _interopRequireDefault(_theme);

var _util = __webpack_require__(39537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Container(props) {
  var classes = _noImportant.StyleSheet.create((0, _util.deepMerge)(defaultStyles, props.theme));

  return _react2.default.createElement('div', _extends({
    id: 'viewerBackdrop',
    className: (0, _noImportant.css)(classes.container)
  }, props));
}

Container.propTypes = {
  theme: _propTypes2.default.object
};

var defaultStyles = {
  container: {
    alignItems: 'center',
    backdropColor: _theme2.default.container.background,
    boxSizing: 'border-box',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    paddingTop: _theme2.default.container.gutter.vertical,
    paddingRight: _theme2.default.container.gutter.horizontal,
    paddingBottom: _theme2.default.container.gutter.vertical,
    paddingLeft: _theme2.default.container.gutter.horizontal,
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: _theme2.default.container.zIndex
  }
};

exports["default"] = Container;

/***/ }),

/***/ 4378:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(44884);

var _theme = __webpack_require__(48219);

var _theme2 = _interopRequireDefault(_theme);

var _util = __webpack_require__(39537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Footer(_ref) {
  var caption = _ref.caption,
      countCurr = _ref.countCurr,
      countSeparator = _ref.countSeparator,
      countTotal = _ref.countTotal,
      showCount = _ref.showCount,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ['caption', 'countCurr', 'countSeparator', 'countTotal', 'showCount', 'theme']);

  if (!caption && !showCount) return null;

  var classes = _noImportant.StyleSheet.create((0, _util.deepMerge)(defaultStyles, theme));

  var imgCount = showCount ? _react2.default.createElement(
    'div',
    { className: (0, _noImportant.css)(classes.footerCount) },
    countCurr,
    countSeparator,
    countTotal
  ) : _react2.default.createElement('span', null);

  return _react2.default.createElement(
    'div',
    _extends({ className: (0, _noImportant.css)(classes.footer) }, props),
    caption ? _react2.default.createElement(
      'figcaption',
      { className: (0, _noImportant.css)(classes.footerCaption) },
      caption
    ) : _react2.default.createElement('span', null),
    imgCount
  );
}

Footer.propTypes = {
  theme: _propTypes2.default.object,
  caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  countCurr: _propTypes2.default.number,
  countSeparator: _propTypes2.default.string,
  countTotal: _propTypes2.default.number,
  showCount: _propTypes2.default.bool
};

var defaultStyles = {
  footer: {
    boxSizing: 'border-box',
    color: _theme2.default.footer.color,
    cursor: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    left: 0,
    lineHeight: 1.3,
    paddingTop: _theme2.default.footer.gutter.vertical,
    paddingRight: _theme2.default.footer.gutter.horizontal,
    paddingBottom: _theme2.default.footer.gutter.vertical,
    paddingLeft: _theme2.default.footer.gutter.horizontal
  },
  footerCount: {
    color: _theme2.default.footer.count.color,
    fontSize: _theme2.default.footer.count.fontSize,
    paddingLeft: '1em' // add a small gutter for the caption
  },
  footerCaption: {
    flex: '1 1 0'
  }
};

exports["default"] = Footer;

/***/ }),

/***/ 70441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(44884);

var _theme = __webpack_require__(48219);

var _theme2 = _interopRequireDefault(_theme);

var _util = __webpack_require__(39537);

var _Icon = __webpack_require__(32023);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Header(_ref) {
  var customControls = _ref.customControls,
      onClose = _ref.onClose,
      showCloseBtn = _ref.showCloseBtn,
      closeBtnTitle = _ref.closeBtnTitle,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ['customControls', 'onClose', 'showCloseBtn', 'closeBtnTitle', 'theme']);

  var classes = _noImportant.StyleSheet.create((0, _util.deepMerge)(defaultStyles, theme));

  return _react2.default.createElement(
    'div',
    _extends({ className: (0, _noImportant.css)(classes.header) }, props),
    customControls ? customControls : _react2.default.createElement('span', null),
    !!showCloseBtn && _react2.default.createElement(
      'button',
      {
        title: closeBtnTitle,
        className: (0, _noImportant.css)(classes.close),
        onClick: onClose
      },
      _react2.default.createElement(_Icon2.default, { fill: !!theme.close && theme.close.fill || _theme2.default.close.fill, type: 'close' })
    )
  );
}

Header.propTypes = {
  theme: _propTypes2.default.object,
  customControls: _propTypes2.default.array,
  onClose: _propTypes2.default.func.isRequired,
  showCloseBtn: _propTypes2.default.bool,
  closeBtnTitle: _propTypes2.default.string
};

var defaultStyles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    height: _theme2.default.header.height
  },
  close: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    position: 'relative',
    top: 0,
    verticalAlign: 'bottom',
    zIndex: 1,

    // increase hit area
    height: 40,
    marginRight: -10,
    padding: 10,
    width: 40
  }
};

exports["default"] = Header;

/***/ }),

/***/ 32023:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _arrow_left = __webpack_require__(50802);

var _arrow_left2 = _interopRequireDefault(_arrow_left);

var _arrow_right = __webpack_require__(44106);

var _arrow_right2 = _interopRequireDefault(_arrow_right);

var _close = __webpack_require__(85167);

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var icons = { arrowLeft: _arrow_left2.default, arrowRight: _arrow_right2.default, close: _close2.default };

var Icon = function Icon(_ref) {
  var fill = _ref.fill,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["fill", "type"]);

  var icon = icons[type];

  return _react2.default.createElement("span", _extends({ dangerouslySetInnerHTML: { __html: icon(fill) } }, props));
};

Icon.propTypes = {
  fill: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(Object.keys(icons))
};
Icon.defaultProps = {
  fill: "#fff"
};

exports["default"] = Icon;

/***/ }),

/***/ 14837:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(44884);

var _Thumbnail = __webpack_require__(35835);

var _Thumbnail2 = _interopRequireDefault(_Thumbnail);

var _Arrow = __webpack_require__(25909);

var _Arrow2 = _interopRequireDefault(_Arrow);

var _theme = __webpack_require__(48219);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classes = _noImportant.StyleSheet.create({
  paginatedThumbnails: {
    bottom: _theme2.default.container.gutter.vertical,
    height: _theme2.default.thumbnail.size,
    padding: '0 50px',
    position: 'absolute',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    left: '50%',
    transform: 'translateX(-50%)'
  }
});

var arrowStyles = {
  height: _theme2.default.thumbnail.size + _theme2.default.thumbnail.gutter * 2,
  width: 40
};

var PaginatedThumbnails = function (_Component) {
  _inherits(PaginatedThumbnails, _Component);

  function PaginatedThumbnails(props) {
    _classCallCheck(this, PaginatedThumbnails);

    var _this = _possibleConstructorReturn(this, (PaginatedThumbnails.__proto__ || Object.getPrototypeOf(PaginatedThumbnails)).call(this, props));

    _this.state = {
      hasCustomPage: false
    };

    _this.gotoPrev = _this.gotoPrev.bind(_this);
    _this.gotoNext = _this.gotoNext.bind(_this);
    return _this;
  }

  _createClass(PaginatedThumbnails, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.currImg !== this.props.currImg) {
        this.setState({
          hasCustomPage: false
        });
      }
    }

    // ====================
    // Methods
    // ====================

  }, {
    key: 'getFirst',
    value: function getFirst() {
      var _props = this.props,
          currImg = _props.currImg,
          offset = _props.offset;

      if (this.state.hasCustomPage) {
        return this.clampFirst(this.state.first);
      }
      return this.clampFirst(currImg - offset);
    }
  }, {
    key: 'setFirst',
    value: function setFirst(event, newFirst) {
      var first = this.state.first;


      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (first === newFirst) return;

      this.setState({
        hasCustomPage: true,
        first: newFirst
      });
    }
  }, {
    key: 'gotoPrev',
    value: function gotoPrev(event) {
      this.setFirst(event, this.getFirst() - this.props.offset);
    }
  }, {
    key: 'gotoNext',
    value: function gotoNext(event) {
      this.setFirst(event, this.getFirst() + this.props.offset);
    }
  }, {
    key: 'clampFirst',
    value: function clampFirst(value) {
      var _props2 = this.props,
          imgs = _props2.imgs,
          offset = _props2.offset;


      var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side

      if (value < 0) {
        return 0;
      } else if (value + totalCount > imgs.length) {
        // Too far
        return imgs.length - totalCount;
      } else {
        return value;
      }
    }

    // ====================
    // Renderers
    // ====================

  }, {
    key: 'renderArrowPrev',
    value: function renderArrowPrev(theme) {
      var leftTitle = this.props.leftTitle;

      if (this.getFirst() <= 0) return null;

      return _react2.default.createElement(_Arrow2.default, {
        theme: theme,
        direction: 'left',
        size: 'small',
        icon: 'arrowLeft',
        onClick: this.gotoPrev,
        style: arrowStyles,
        title: leftTitle,
        type: 'button'
      });
    }
  }, {
    key: 'renderArrowNext',
    value: function renderArrowNext(theme) {
      var _props3 = this.props,
          offset = _props3.offset,
          imgs = _props3.imgs,
          rightTitle = _props3.rightTitle;

      var totalCount = 2 * offset + 1;
      if (this.getFirst() + totalCount >= imgs.length) return null;

      return _react2.default.createElement(_Arrow2.default, {
        theme: theme,
        direction: 'right',
        size: 'small',
        icon: 'arrowRight',
        onClick: this.gotoNext,
        style: arrowStyles,
        title: rightTitle,
        type: 'button'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          imgs = _props4.imgs,
          currImg = _props4.currImg,
          onClickThumbnail = _props4.onClickThumbnail,
          offset = _props4.offset,
          theme = _props4.theme;


      var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side
      var thumbnails = [];
      var baseOffset = 0;
      if (imgs.length <= totalCount) {
        thumbnails = imgs;
      } else {
        // Try to center current image in list
        baseOffset = this.getFirst();
        thumbnails = imgs.slice(baseOffset, baseOffset + totalCount);
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _noImportant.css)(classes.paginatedThumbnails) },
        this.renderArrowPrev(theme),
        thumbnails.map(function (img, idx) {
          return _react2.default.createElement(_Thumbnail2.default, _extends({
            theme: theme,
            key: baseOffset + idx
          }, img, {
            index: baseOffset + idx,
            onClick: onClickThumbnail,
            active: baseOffset + idx === currImg
          }));
        }),
        this.renderArrowNext(theme)
      );
    }
  }]);

  return PaginatedThumbnails;
}(_react.Component);

exports["default"] = PaginatedThumbnails;


PaginatedThumbnails.propTypes = {
  theme: _propTypes2.default.object,
  leftTitle: _propTypes2.default.string,
  rightTitle: _propTypes2.default.string,
  currImg: _propTypes2.default.number,
  imgs: _propTypes2.default.array,
  offset: _propTypes2.default.number,
  onClickThumbnail: _propTypes2.default.func.isRequired
};

/***/ }),

/***/ 72263:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = __webpack_require__(90752);

var _reactDom = __webpack_require__(28316);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal = function (_Component) {
  _inherits(Portal, _Component);

  function Portal() {
    _classCallCheck(this, Portal);

    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));

    _this.portalElement = null;
    return _this;
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var div = document.createElement('div');
      document.body.appendChild(div);
      this.portalElement = div;
      this.componentDidUpdate();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // Animate fade on mount/unmount
      var duration = 200;
      var styles = '\n\t\t\t\t.fade-enter { opacity: 0.01; }\n\t\t\t\t.fade-enter.fade-enter-active { opacity: 1; transition: opacity ' + duration + 'ms; }\n\t\t\t\t.fade-leave { opacity: 1; }\n\t\t\t\t.fade-leave.fade-leave-active { opacity: .01; transition: opacity ' + duration + 'ms; }\n\t\t';

      (0, _reactDom.render)(_react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'style',
          null,
          styles
        ),
        _react2.default.createElement(
          _reactTransitionGroup.TransitionGroup,
          this.props,
          _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            { timeout: { enter: duration, exit: duration }, className: 'fade' },
            _react2.default.createElement(
              'div',
              null,
              this.props.children
            )
          )
        )
      ), this.portalElement);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _reactDom.unmountComponentAtNode)(this.portalElement);
      document.body.removeChild(this.portalElement);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(_react.Component);

exports["default"] = Portal;


Portal.propTypes = {
  children: _propTypes2.default.arrayOf(_propTypes2.default.any)
};

/***/ }),

/***/ 35270:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(44884);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner(props) {
  var classes = _noImportant.StyleSheet.create(styles(props));

  return _react2.default.createElement(
    'div',
    { className: (0, _noImportant.css)(classes.bouncingLoader) },
    _react2.default.createElement('div', { className: (0, _noImportant.css)(classes.child) }),
    _react2.default.createElement('div', { className: (0, _noImportant.css)(classes.child, classes.child2) }),
    _react2.default.createElement('div', { className: (0, _noImportant.css)(classes.child, classes.child3) })
  );
};

Spinner.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

var bouncingKeyframes = function bouncingKeyframes(size) {
  return {
    '0%': {
      opacity: 1,
      transform: 'translateY(0)'
    },
    '100%': {
      opacity: .1,
      transform: 'translateY(-' + size + 'px)'
    }
  };
};

var styles = function styles(_ref) {
  var color = _ref.color,
      size = _ref.size;
  return {
    bouncingLoader: {
      display: 'flex',
      justifyContent: 'center'
    },
    child: {
      width: size,
      height: size,
      margin: 3 * size + 'px ' + .2 * size + 'px',
      background: color,
      borderRadius: '50%',
      animationName: bouncingKeyframes(size),
      animationDuration: '.6s',
      animationDirection: 'alternate',
      animationIterationCount: 'infinite'
    },
    child2: {
      animationDelay: '0.2s'
    },
    child3: {
      animationDelay: '0.4s'
    }
  };
};

exports["default"] = Spinner;

/***/ }),

/***/ 35835:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _noImportant = __webpack_require__(44884);

var _theme = __webpack_require__(48219);

var _theme2 = _interopRequireDefault(_theme);

var _util = __webpack_require__(39537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Thumbnail(_ref) {
  var index = _ref.index,
      src = _ref.src,
      thumbnail = _ref.thumbnail,
      active = _ref.active,
      _onClick = _ref.onClick,
      theme = _ref.theme;

  var url = thumbnail || src;
  var classes = _noImportant.StyleSheet.create((0, _util.deepMerge)(defaultStyles, theme));

  return _react2.default.createElement('div', {
    className: (0, _noImportant.css)(classes.thumbnail, active && classes.thumbnail__active),
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      _onClick(index);
    },
    style: { backgroundImage: 'url("' + url + '")' }
  });
}

Thumbnail.propTypes = {
  theme: _propTypes2.default.object,
  active: _propTypes2.default.bool,
  index: _propTypes2.default.number,
  onClick: _propTypes2.default.func.isRequired,
  src: _propTypes2.default.string,
  thumbnail: _propTypes2.default.string
};

var defaultStyles = {
  thumbnail: {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    borderRadius: 2,
    boxShadow: 'inset 0 0 0 1px hsla(0, 0%, 100%, .2)',
    cursor: 'pointer',
    display: 'inline-block',
    height: _theme2.default.thumbnail.size,
    margin: _theme2.default.thumbnail.gutter,
    overflow: 'hidden',
    width: _theme2.default.thumbnail.size
  },
  thumbnail__active: {
    boxShadow: 'inset 0 0 0 2px ' + _theme2.default.thumbnail.activeBorderColor
  }
};

exports["default"] = Thumbnail;

/***/ }),

/***/ 50802:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
		value: true
}));

exports["default"] = function (fill) {
		return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n\t\t<path d=\"M213.7,256L213.7,256L213.7,256L380.9,81.9c4.2-4.3,4.1-11.4-0.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-0.2L131.1,247.9 c-2.2,2.2-3.2,5.2-3,8.1c-0.1,3,0.9,5.9,3,8.1l204.2,212.7c4.2,4.3,11.2,4.2,15.5-0.2l29.9-30.6c4.3-4.4,4.4-11.5,0.2-15.8 L213.7,256z\"/>\n\t</svg>";
};

/***/ }),

/***/ 44106:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
		value: true
}));

exports["default"] = function (fill) {
		return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n\t\t<path d=\"M298.3,256L298.3,256L298.3,256L131.1,81.9c-4.2-4.3-4.1-11.4,0.2-15.8l29.9-30.6c4.3-4.4,11.3-4.5,15.5-0.2l204.2,212.7 c2.2,2.2,3.2,5.2,3,8.1c0.1,3-0.9,5.9-3,8.1L176.7,476.8c-4.2,4.3-11.2,4.2-15.5-0.2L131.3,446c-4.3-4.4-4.4-11.5-0.2-15.8 L298.3,256z\"/>\n\t</svg>";
};

/***/ }),

/***/ 85167:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
	value: true
}));

exports["default"] = function (fill) {
	return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\">\n\t\t<path d=\"M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z\"/>\n\t</svg>";
};

/***/ }),

/***/ 48219:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
// ===================
// Theme
// ===================

var theme = {};

// container
theme.container = {
  background: 'rgba(0, 0, 0, .8)',
  gutter: {
    horizontal: 10,
    vertical: 10
  },
  zIndex: 2001

  // header
};theme.header = {
  height: 40
};
theme.close = {
  fill: 'white'

  // footer
};theme.footer = {
  color: '#fff',
  count: {
    color: 'rgba(255, 255, 255, .75)',
    fontSize: '.85em'
  },
  height: 40,
  gutter: {
    horizontal: 0,
    vertical: 5
  }

  // thumbnails
};theme.thumbnail = {
  activeBorderColor: '#fff',
  size: 50,
  gutter: 2

  // arrow
};theme.arrow = {
  background: 'none',
  fill: '#fff',
  height: 120
};

exports["default"] = theme;

/***/ }),

/***/ 39537:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.deepMerge = deepMerge;
exports.bindFunctions = bindFunctions;
function deepMerge(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var extended = _extends({}, target);

  Object.keys(source).forEach(function (key) {
    if (_typeof(source[key]) !== "object" || !source[key]) {
      extended[key] = source[key];
    } else {
      if (!target[key]) {
        extended[key] = source[key];
      } else {
        extended[key] = deepMerge(target[key], source[key]);
      }
    }
  });
  return extended;
}
// export function deepMerge(source, target = {}) {
//   // initialize with source styles
//   const styles = { ...source }

//   // massage in target styles
//   Object.keys(target).forEach(key => {
//     if (source[key]) {
//       styles[key] = (rsCss, props) => {
//         return target[key](source[key](rsCss, props), props)
//       }
//     } else {
//       styles[key] = target[key]
//     }
//   })

//   return styles
// }

var canUseDom = exports.canUseDom = !!(typeof window !== "undefined" && window.document && window.document.createElement);

/**
 * Bind multiple conponent methods:
 * @param {this} context
 * @param {Array} functions
 *
 * constructor() {
 *   ...
 *   bindFunctions.call(this, ['handleClick', 'handleOther'])
 * }
 */
function bindFunctions(functions) {
  var _this = this;

  functions.forEach(function (f) {
    return _this[f] = _this[f].bind(_this);
  });
}

/***/ }),

/***/ 43335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

exports.__esModule = true;
exports["default"] = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1021));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),

/***/ 1021:
/***/ (function(module, exports) {

"use strict";


exports.__esModule = true;
exports["default"] = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),

/***/ 2179:
/***/ (function(module) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ 1927:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(13980));

var _addClass = _interopRequireDefault(__webpack_require__(43335));

var _removeClass = _interopRequireDefault(__webpack_require__(2179));

var _react = _interopRequireDefault(__webpack_require__(2784));

var _Transition = _interopRequireDefault(__webpack_require__(54797));

var _PropTypes = __webpack_require__(77591);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? 0 : {};
var _default = CSSTransition;
exports["default"] = _default;
module.exports = exports["default"];

/***/ }),

/***/ 44807:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _react = _interopRequireDefault(__webpack_require__(2784));

var _reactDom = __webpack_require__(28316);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(79089));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? 0 : {};
var _default = ReplaceTransition;
exports["default"] = _default;
module.exports = exports["default"];

/***/ }),

/***/ 54797:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(13980));

var _react = _interopRequireDefault(__webpack_require__(2784));

var _reactDom = _interopRequireDefault(__webpack_require__(28316));

var _reactLifecyclesCompat = __webpack_require__(46847);

var _PropTypes = __webpack_require__(77591);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? 0 : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports["default"] = _default;

/***/ }),

/***/ 79089:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _react = _interopRequireDefault(__webpack_require__(2784));

var _reactLifecyclesCompat = __webpack_require__(46847);

var _ChildMapping = __webpack_require__(47906);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports["default"] = _default;
module.exports = exports["default"];

/***/ }),

/***/ 90752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(1927));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(44807));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(79089));

var _Transition = _interopRequireDefault(__webpack_require__(54797));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),

/***/ 47906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(2784);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),

/***/ 77591:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? 0 : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? 0 : null;
exports.classNamesShape = classNamesShape;

/***/ }),

/***/ 66866:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};exports.typeOf=v;


/***/ }),

/***/ 48570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(66866);
} else {}


/***/ }),

/***/ 46847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 80185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IGNORE_CLASS_NAME": function() { return /* binding */ IGNORE_CLASS_NAME; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28316);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode)(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WrappedComponent, props);
    };

    return onClickOutside;
  }(react__WEBPACK_IMPORTED_MODULE_0__.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);

/***/ }),

/***/ 94592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Manager": function() { return /* reexport */ Manager; },
  "Popper": function() { return /* reexport */ Popper; },
  "Reference": function() { return /* reexport */ Reference; },
  "usePopper": function() { return /* reexport */ usePopper/* usePopper */.D; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-popper/lib/esm/Manager.js

var ManagerReferenceNodeContext = react.createContext();
var ManagerReferenceNodeSetterContext = react.createContext();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = react.useState(null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  var hasUnmounted = react.useRef(false);
  react.useEffect(function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = react.useCallback(function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/react.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/react.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}
// EXTERNAL MODULE: ../../node_modules/react-popper/lib/esm/utils.js
var utils = __webpack_require__(60855);
// EXTERNAL MODULE: ../../node_modules/react-popper/lib/esm/usePopper.js
var usePopper = __webpack_require__(26194);
;// CONCATENATED MODULE: ../../node_modules/react-popper/lib/esm/Popper.js





var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = react.useContext(ManagerReferenceNodeContext);

  var _React$useState = react.useState(null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = react.useState(null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  react.useEffect(function () {
    (0,utils/* setRef */.k$)(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = react.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = (0,usePopper/* usePopper */.D)(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = react.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return (0,utils/* unwrapArray */.$p)(children)(childrenProps);
}
// EXTERNAL MODULE: ../../node_modules/warning/warning.js
var warning = __webpack_require__(45982);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ../../node_modules/react-popper/lib/esm/Reference.js




function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = react.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = react.useCallback(function (node) {
    (0,utils/* setRef */.k$)(innerRef, node);
    (0,utils/* safeInvoke */.DL)(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps

  react.useEffect(function () {
    return function () {
      return (0,utils/* setRef */.k$)(innerRef, null);
    };
  }, []);
  react.useEffect(function () {
    warning_default()(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return (0,utils/* unwrapArray */.$p)(children)({
    ref: refHandler
  });
}
;// CONCATENATED MODULE: ../../node_modules/react-popper/lib/esm/index.js
// Public components




 // Public types

/***/ }),

/***/ 26194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ usePopper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28316);
/* harmony import */ var _popperjs_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66208);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78435);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_fast_compare__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60855);





var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        react_dom__WEBPACK_IMPORTED_MODULE_1__.flushSync(function () {
          setState({
            styles: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .fromEntries */ .sq)(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .fromEntries */ .sq)(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (react_fast_compare__WEBPACK_IMPORTED_MODULE_2___default()(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .useIsomorphicLayoutEffect */ .LI)(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .useIsomorphicLayoutEffect */ .LI)(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper = options.createPopper || _popperjs_core__WEBPACK_IMPORTED_MODULE_4__/* .createPopper */ .fi;
    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

/***/ }),

/***/ 60855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ unwrapArray; },
/* harmony export */   "DL": function() { return /* binding */ safeInvoke; },
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "k$": function() { return /* binding */ setRef; },
/* harmony export */   "sq": function() { return /* binding */ fromEntries; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;

/***/ }),

/***/ 64157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "$j": function() { return /* reexport */ connect; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, connectAdvanced, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual, useStore

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/components/Context.js

var ReactReduxContext = /*#__PURE__*/react.createContext(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (ReactReduxContext)));
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/components/Provider.js






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react.useMemo)(function () {
    var subscription = createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react.useMemo)(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {}

/* harmony default export */ var components_Provider = (Provider);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ../../node_modules/react-redux/node_modules/react-is/index.js
var react_is = __webpack_require__(63920);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/components/connectAdvanced.js


var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];





 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded);

  if (false) { var customStoreWarningMessage; }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {}

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = (0,esm_extends/* default */.Z)({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? react.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = (0,react.useMemo)(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = (0,react.useMemo)(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && (0,react_is.isContextConsumer)( /*#__PURE__*/react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = (0,react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = (0,react.useMemo)(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = (0,react.useMemo)(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = (0,react.useMemo)(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0,esm_extends/* default */.Z)({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = (0,react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = (0,react.useRef)();
      var lastWrapperProps = (0,react.useRef)(wrapperProps);
      var childPropsFromStoreUpdate = (0,react.useRef)();
      var renderIsScheduled = (0,react.useRef)(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = (0,react.useMemo)(function () {
        return /*#__PURE__*/react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = (0,react.useMemo)(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? react.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = react.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/react.createElement(Connect, (0,esm_extends/* default */.Z)({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics_cjs_default()(forwarded, WrappedComponent);
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/shallowEqual.js
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/selectorFactory.js

var selectorFactory_excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, selectorFactory_excluded);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {}

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/connect.js


var connect_excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];






/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, connect_excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, (0,esm_extends/* default */.Z)({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect = (/*#__PURE__*/createConnect());
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/hooks/useReduxContext.js


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext_useReduxContext() {
  var contextValue = (0,react.useContext)(ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useStore = context === ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/hooks/useSelector.js






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = (0,react.useReducer)(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = (0,react.useMemo)(function () {
    return createSubscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = (0,react.useRef)();
  var latestSelector = (0,react.useRef)();
  var latestStoreState = (0,react.useRef)();
  var latestSelectedState = (0,react.useRef)();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/exports.js









// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/reactBatchedUpdates.js
/* eslint-disable import/no-unresolved */

;// CONCATENATED MODULE: ../../node_modules/react-redux/es/index.js


 // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);


/***/ }),

/***/ 98559:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 63920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(98559);
} else {}


/***/ }),

/***/ 61059:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(85978);

var _utils = __webpack_require__(87033);

var _withTouchListeners = __webpack_require__(32745);

var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);

var _StyleSheet = __webpack_require__(18711);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollLock = function (_PureComponent) {
  _inherits(ScrollLock, _PureComponent);

  function ScrollLock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.getStyles = function () {
      var accountForScrollbars = _this.props.accountForScrollbars;


      var height = (0, _utils.getDocumentHeight)();
      var paddingRight = accountForScrollbars ? (0, _utils.getPadding)() : null;
      var styles = 'body {\n      box-sizing: border-box !important;\n      overflow: hidden !important;\n      position: relative !important;\n      ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n      ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n    }';

      return styles;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScrollLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_exenv.canUseDOM) return;
      this.initialHeight = window.innerHeight;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var offset = window.innerHeight - this.initialHeight;

      // adjust scroll if the window has been resized since the lock was engaged
      // e.g. mobile safari dynamic chrome heights
      if (offset) {
        window.scrollTo(0, window.pageYOffset + offset);
      }

      // reset the initial height in case this scroll lock is used again
      this.initialHeight = window.innerHeight;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_StyleSheet2.default, { styles: this.getStyles() });
    }
  }]);

  return ScrollLock;
}(_react.PureComponent);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};
exports["default"] = (0, _withTouchListeners2.default)(ScrollLock);

/***/ }),

/***/ 18711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(85978);

var _utils = __webpack_require__(87033);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sheet = function (_PureComponent) {
  _inherits(Sheet, _PureComponent);

  function Sheet() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Sheet);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sheet.__proto__ || Object.getPrototypeOf(Sheet)).call.apply(_ref, [this].concat(args))), _this), _this.addSheet = function () {
      var styles = _this.props.styles;


      var sheet = (0, _utils.makeStyleTag)();
      if (!sheet) return;

      (0, _utils.injectStyles)(sheet, styles);
      (0, _utils.insertStyleTag)(sheet);

      _this.sheet = sheet;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Sheet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_exenv.canUseDOM) return;
      this.addSheet();
    }
  }, {
    key: 'removeSheet',
    value: function removeSheet() {
      if (!this.sheet) return;

      // $FlowFixMe
      this.sheet.parentNode.removeChild(this.sheet);
      this.sheet = null;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeSheet();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Sheet;
}(_react.PureComponent);

exports["default"] = Sheet;

/***/ }),

/***/ 19233:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _ScrollLock = __webpack_require__(61059);

Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollLock).default;
  }
}));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 87033:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.preventTouchMove = preventTouchMove;
exports.allowTouchMove = allowTouchMove;
exports.preventInertiaScroll = preventInertiaScroll;
exports.isTouchDevice = isTouchDevice;
exports.getPadding = getPadding;
exports.camelToKebab = camelToKebab;
exports.getWindowHeight = getWindowHeight;
exports.getDocumentHeight = getDocumentHeight;
exports.parse = parse;
exports.makeStyleTag = makeStyleTag;
exports.injectStyles = injectStyles;
exports.insertStyleTag = insertStyleTag;
function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  if (typeof window === 'undefined' || !window) return false;
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function getPadding() {
  if (typeof window === 'undefined' || !window || !document) return 0;

  var currentPadding = parseInt(document.body.paddingRight, 10) || 0;
  var clientWidth = document.body ? document.body.clientWidth : 0;
  var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

  return adjustedPadding;
}

function camelToKebab(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

function getWindowHeight() {
  var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  if (typeof window !== 'undefined' && window && window.innerHeight) {
    return window.innerHeight * multiplier;
  }
}

function getDocumentHeight() {
  if (typeof window !== 'undefined' && document && document.body) {
    return document.body.clientHeight;
  }
}

function parse(val) {
  return isNaN(val) ? val : val + 'px';
}

// ==============================
// Style Sheets
// ==============================

function makeStyleTag(id) {
  var tag = document.createElement('style');
  tag.type = 'text/css';
  tag.setAttribute('data-react-scrolllock', '');

  return tag;
}
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName('head')[0];
  head.appendChild(tag);
}

/***/ }),

/***/ 32745:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports["default"] = withTouchListeners;

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(85978);

var _utils = __webpack_require__(87033);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withTouchListeners(WrappedComponent) {
  return function (_PureComponent) {
    _inherits(TouchProvider, _PureComponent);

    function TouchProvider() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TouchProvider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).call.apply(_ref, [this].concat(args))), _this), _this.listenerOptions = {
        capture: false,
        passive: false
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TouchProvider, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!_exenv.canUseDOM) return;

        var touchScrollTarget = this.props.touchScrollTarget;

        var target = document.body;

        // account for touch devices
        if (target && (0, _utils.isTouchDevice)()) {
          // Mobile Safari ignores { overflow: hidden } declaration on the body.
          target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

          // Allow scroll on provided target
          if (touchScrollTarget) {
            touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (!_exenv.canUseDOM) return;

        var touchScrollTarget = this.props.touchScrollTarget;

        var target = document.body;

        // remove touch listeners
        if (target && (0, _utils.isTouchDevice)()) {
          target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

          if (touchScrollTarget) {
            touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      }
    }]);

    return TouchProvider;
  }(_react.PureComponent);
}

/***/ }),

/***/ 33672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ isTouchCapable; },
  "B": function() { return /* binding */ isMobileDevice; },
  "C": function() { return /* binding */ multiValueAsValue; },
  "D": function() { return /* binding */ singleValueAsValue; },
  "E": function() { return /* binding */ valueTernary; },
  "F": function() { return /* binding */ classNames; },
  "G": function() { return /* binding */ defaultComponents; },
  "H": function() { return /* binding */ notNullish; },
  "I": function() { return /* binding */ isDocumentElement; },
  "J": function() { return /* binding */ cleanValue; },
  "K": function() { return /* binding */ scrollIntoView; },
  "L": function() { return /* binding */ noop; },
  "M": function() { return /* binding */ MenuPlacer; },
  "_": function() { return /* binding */ _createSuper; },
  "a": function() { return /* binding */ _objectSpread2; },
  "b": function() { return /* binding */ clearIndicatorCSS; },
  "d": function() { return /* binding */ containerCSS; },
  "e": function() { return /* binding */ css$1; },
  "f": function() { return /* binding */ dropdownIndicatorCSS; },
  "g": function() { return /* binding */ groupCSS; },
  "h": function() { return /* binding */ groupHeadingCSS; },
  "i": function() { return /* binding */ indicatorsContainerCSS; },
  "j": function() { return /* binding */ indicatorSeparatorCSS; },
  "k": function() { return /* binding */ inputCSS; },
  "l": function() { return /* binding */ loadingIndicatorCSS; },
  "m": function() { return /* binding */ loadingMessageCSS; },
  "n": function() { return /* binding */ menuCSS; },
  "o": function() { return /* binding */ menuListCSS; },
  "p": function() { return /* binding */ menuPortalCSS; },
  "q": function() { return /* binding */ multiValueCSS; },
  "r": function() { return /* binding */ removeProps; },
  "s": function() { return /* binding */ supportsPassiveEvents; },
  "t": function() { return /* binding */ multiValueLabelCSS; },
  "u": function() { return /* binding */ multiValueRemoveCSS; },
  "v": function() { return /* binding */ noOptionsMessageCSS; },
  "w": function() { return /* binding */ optionCSS; },
  "x": function() { return /* binding */ placeholderCSS; },
  "y": function() { return /* binding */ css; },
  "z": function() { return /* binding */ valueContainerCSS; }
});

// UNUSED EXPORTS: N, c

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(12215);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(9249);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(87371);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(45754);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/react-select/dist/index-a7690a33.esm.js













function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var _excluded$3 = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray(value)) return value.filter(Boolean);
  if ((0,esm_typeof/* default */.Z)(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
      props.clearValue;
      props.cx;
      props.getStyles;
      props.getValue;
      props.hasValue;
      props.isMulti;
      props.isRtl;
      props.options;
      props.selectOption;
      props.selectProps;
      props.setValue;
      props.theme;
      var innerProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded$3);

  return _objectSpread2({}, innerProps);
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var _newValue = onInputChange(inputValue, actionMeta);

    if (typeof _newValue === 'string') return _newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }

  return el.clientHeight;
} // Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return document.documentElement;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
} // ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36

var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }

}; // check for SSR

var w = typeof window !== 'undefined' ? window : {};

if (w.addEventListener && w.removeEventListener) {
  w.addEventListener('p', noop, options);
  w.removeEventListener('p', noop, false);
}

var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps(propsObj) {
  for (var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    properties[_key - 1] = arguments[_key];
  }

  var propsMap = Object.entries(propsObj).filter(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
        key = _ref2[0];

    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
        key = _ref4[0],
        val = _ref4[1];

    newProps[key] = val;
    return newProps;
  }, {});
};

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  }

  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, (0,defineProperty/* default */.Z)(_ref3, alignToControl(placement), '100%'), (0,defineProperty/* default */.Z)(_ref3, "backgroundColor", colors.neutral0), (0,defineProperty/* default */.Z)(_ref3, "borderRadius", borderRadius), (0,defineProperty/* default */.Z)(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), (0,defineProperty/* default */.Z)(_ref3, "marginBottom", spacing.menuGutter), (0,defineProperty/* default */.Z)(_ref3, "marginTop", spacing.menuGutter), (0,defineProperty/* default */.Z)(_ref3, "position", 'absolute'), (0,defineProperty/* default */.Z)(_ref3, "width", '100%'), (0,defineProperty/* default */.Z)(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /*#__PURE__*/(0,react.createContext)({
  getPortalPlacement: null
}); // NOTE: internal only

var MenuPlacer = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(MenuPlacer, _Component);

  var _super = _createSuper(MenuPlacer);

  function MenuPlacer() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };
    _this.context = void 0;

    _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    };

    _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread2(_objectSpread2({}, _this.props), {}, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    };

    return _this;
  }

  (0,createClass/* default */.Z)(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(react.Component);
MenuPlacer.contextType = PortalPlacementContext;

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className),
    ref: innerRef
  }, innerProps), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      isMulti = props.isMulti;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /*#__PURE__*/function (_Component2) {
  (0,inherits/* default */.Z)(MenuPortal, _Component2);

  var _super2 = _createSuper(MenuPortal);

  function MenuPortal() {
    var _this2;

    (0,classCallCheck/* default */.Z)(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };

    _this2.getPortalPlacement = function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    };

    return _this2;
  }

  (0,createClass/* default */.Z)(MenuPortal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          className = _this$props2.className,
          controlElement = _this$props2.controlElement,
          cx = _this$props2.cx,
          innerProps = _this$props2.innerProps,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
        css: getStyles('menuPortal', state),
        className: cx({
          'menu-portal': true
        }, className)
      }, innerProps), children);
      return (0,emotion_react_browser_esm/* jsx */.tZ)(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /*#__PURE__*/(0,react_dom.createPortal)(menuWrapper, appendTo) : menuWrapper);
    }
  }]);

  return MenuPortal;
}(react.Component);

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing,
      isMulti = _ref2.isMulti,
      hasValue = _ref2.hasValue,
      controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return {
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      innerProps = props.innerProps,
      isMulti = props.isMulti,
      getStyles = props.getStyles,
      hasValue = props.hasValue;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('valueContainer', props),
    className: cx({
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }, className)
  }, innerProps), children);
}; // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      innerProps = props.innerProps,
      getStyles = props.getStyles;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, innerProps), children);
};

var _templateObject;

var _excluded$2 = ["size"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref2 =  true ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : 0;

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded$2);

  return (0,emotion_react_browser_esm/* jsx */.tZ)("svg", (0,esm_extends/* default */.Z)({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }, innerProps), children || (0,emotion_react_browser_esm/* jsx */.tZ)(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }, innerProps), children || (0,emotion_react_browser_esm/* jsx */.tZ)(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("span", (0,esm_extends/* default */.Z)({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
      offset = _ref6.offset;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    },  true ? "" : 0,  true ? "" : 0)
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }, innerProps), (0,emotion_react_browser_esm/* jsx */.tZ)(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(LoadingDot, {
    delay: 160,
    offset: true
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var _excluded$1 = ["data"];
var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      innerProps = props.innerProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, innerProps), (0,emotion_react_browser_esm/* jsx */.tZ)(Heading, (0,esm_extends/* default */.Z)({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var getStyles = props.getStyles,
      cx = props.cx,
      className = props.className;

  var _cleanCommonProps = cleanCommonProps(props);
      _cleanCommonProps.data;
      var innerProps = (0,objectWithoutProperties/* default */.Z)(_cleanCommonProps, _excluded$1);

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('groupHeading', props),
    className: cx({
      'group-heading': true
    }, className)
  }, innerProps));
};

var _excluded = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      value = _ref.value,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return _objectSpread2({
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80,
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle);
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};

var inputStyle = function inputStyle(isHidden) {
  return _objectSpread2({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};

var Input = function Input(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      value = props.value;

  var _cleanCommonProps = cleanCommonProps(props),
      innerRef = _cleanCommonProps.innerRef,
      isDisabled = _cleanCommonProps.isDisabled,
      isHidden = _cleanCommonProps.isHidden,
      inputClassName = _cleanCommonProps.inputClassName,
      innerProps = (0,objectWithoutProperties/* default */.Z)(_cleanCommonProps, _excluded);

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: cx({
      'input-container': true
    }, className),
    css: getStyles('input', props),
    "data-value": value || ''
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("input", (0,esm_extends/* default */.Z)({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
      innerProps = _ref5.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    role: "button"
  }, innerProps), children || (0,emotion_react_browser_esm/* jsx */.tZ)(CrossIcon, {
    size: 14
  }));
}

var MultiValue = function MultiValue(props) {
  var children = props.children,
      className = props.className,
      components = props.components,
      cx = props.cx,
      data = props.data,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
  var Container = components.Container,
      Label = components.Label,
      Remove = components.Remove;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* ClassNames */.ms, null, function (_ref6) {
    var css = _ref6.css,
        emotionCx = _ref6.cx;
    return (0,emotion_react_browser_esm/* jsx */.tZ)(Container, {
      data: data,
      innerProps: _objectSpread2({
        className: emotionCx(css(getStyles('multiValue', props)), cx({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className))
      }, innerProps),
      selectProps: selectProps
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Label, {
      data: data,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }, className))
      },
      selectProps: selectProps
    }, children), (0,emotion_react_browser_esm/* jsx */.tZ)(Remove, {
      data: data,
      innerProps: _objectSpread2({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }, className)),
        'aria-label': "Remove ".concat(children || 'option')
      }, removeProps),
      selectProps: selectProps
    }));
  });
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};




/***/ }),

/***/ 4883:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var React = __importStar(__webpack_require__(2784));
var KEYCODE_ENTER = 13;
var KEYCODE_TAB = 9;
var KEYCODE_BACKSPACE = 8;
var KEYCODE_Y = 89;
var KEYCODE_Z = 90;
var KEYCODE_M = 77;
var KEYCODE_PARENS = 57;
var KEYCODE_BRACKETS = 219;
var KEYCODE_QUOTE = 222;
var KEYCODE_BACK_QUOTE = 192;
var KEYCODE_ESCAPE = 27;
var HISTORY_LIMIT = 100;
var HISTORY_TIME_GAP = 3000;
var isWindows = typeof window !== 'undefined' &&
    'navigator' in window &&
    /Win/i.test(navigator.platform);
var isMacLike = typeof window !== 'undefined' &&
    'navigator' in window &&
    /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
var className = 'npm__react-simple-code-editor__textarea';
var cssText = /* CSS */ "\n/**\n * Reset the text fill color so that placeholder is visible\n */\n.".concat(className, ":empty {\n  -webkit-text-fill-color: inherit !important;\n}\n\n/**\n * Hack to apply on some CSS on IE10 and IE11\n */\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  /**\n    * IE doesn't support '-webkit-text-fill-color'\n    * So we use 'color: transparent' to make the text transparent on IE\n    * Unlike other browsers, it doesn't affect caret color in IE\n    */\n  .").concat(className, " {\n    color: transparent !important;\n  }\n\n  .").concat(className, "::selection {\n    background-color: #accef7 !important;\n    color: transparent !important;\n  }\n}\n");
var Editor = /** @class */ (function (_super) {
    __extends(Editor, _super);
    function Editor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            capture: true,
        };
        _this._recordCurrentState = function () {
            var input = _this._input;
            if (!input)
                return;
            // Save current state of the input
            var value = input.value, selectionStart = input.selectionStart, selectionEnd = input.selectionEnd;
            _this._recordChange({
                value: value,
                selectionStart: selectionStart,
                selectionEnd: selectionEnd,
            });
        };
        _this._getLines = function (text, position) {
            return text.substring(0, position).split('\n');
        };
        _this._recordChange = function (record, overwrite) {
            var _a, _b, _c;
            if (overwrite === void 0) { overwrite = false; }
            var _d = _this._history, stack = _d.stack, offset = _d.offset;
            if (stack.length && offset > -1) {
                // When something updates, drop the redo operations
                _this._history.stack = stack.slice(0, offset + 1);
                // Limit the number of operations to 100
                var count = _this._history.stack.length;
                if (count > HISTORY_LIMIT) {
                    var extras = count - HISTORY_LIMIT;
                    _this._history.stack = stack.slice(extras, count);
                    _this._history.offset = Math.max(_this._history.offset - extras, 0);
                }
            }
            var timestamp = Date.now();
            if (overwrite) {
                var last = _this._history.stack[_this._history.offset];
                if (last && timestamp - last.timestamp < HISTORY_TIME_GAP) {
                    // A previous entry exists and was in short interval
                    // Match the last word in the line
                    var re = /[^a-z0-9]([a-z0-9]+)$/i;
                    // Get the previous line
                    var previous = (_a = _this._getLines(last.value, last.selectionStart)
                        .pop()) === null || _a === void 0 ? void 0 : _a.match(re);
                    // Get the current line
                    var current = (_b = _this._getLines(record.value, record.selectionStart)
                        .pop()) === null || _b === void 0 ? void 0 : _b.match(re);
                    if ((previous === null || previous === void 0 ? void 0 : previous[1]) && ((_c = current === null || current === void 0 ? void 0 : current[1]) === null || _c === void 0 ? void 0 : _c.startsWith(previous[1]))) {
                        // The last word of the previous line and current line match
                        // Overwrite previous entry so that undo will remove whole word
                        _this._history.stack[_this._history.offset] = __assign(__assign({}, record), { timestamp: timestamp });
                        return;
                    }
                }
            }
            // Add the new operation to the stack
            _this._history.stack.push(__assign(__assign({}, record), { timestamp: timestamp }));
            _this._history.offset++;
        };
        _this._updateInput = function (record) {
            var input = _this._input;
            if (!input)
                return;
            // Update values and selection state
            input.value = record.value;
            input.selectionStart = record.selectionStart;
            input.selectionEnd = record.selectionEnd;
            _this.props.onValueChange(record.value);
        };
        _this._applyEdits = function (record) {
            // Save last selection state
            var input = _this._input;
            var last = _this._history.stack[_this._history.offset];
            if (last && input) {
                _this._history.stack[_this._history.offset] = __assign(__assign({}, last), { selectionStart: input.selectionStart, selectionEnd: input.selectionEnd });
            }
            // Save the changes
            _this._recordChange(record);
            _this._updateInput(record);
        };
        _this._undoEdit = function () {
            var _a = _this._history, stack = _a.stack, offset = _a.offset;
            // Get the previous edit
            var record = stack[offset - 1];
            if (record) {
                // Apply the changes and update the offset
                _this._updateInput(record);
                _this._history.offset = Math.max(offset - 1, 0);
            }
        };
        _this._redoEdit = function () {
            var _a = _this._history, stack = _a.stack, offset = _a.offset;
            // Get the next edit
            var record = stack[offset + 1];
            if (record) {
                // Apply the changes and update the offset
                _this._updateInput(record);
                _this._history.offset = Math.min(offset + 1, stack.length - 1);
            }
        };
        _this._handleKeyDown = function (e) {
            var _a = _this.props, tabSize = _a.tabSize, insertSpaces = _a.insertSpaces, ignoreTabKey = _a.ignoreTabKey, onKeyDown = _a.onKeyDown;
            if (onKeyDown) {
                onKeyDown(e);
                if (e.defaultPrevented) {
                    return;
                }
            }
            if (e.keyCode === KEYCODE_ESCAPE) {
                e.currentTarget.blur();
            }
            var _b = e.currentTarget, value = _b.value, selectionStart = _b.selectionStart, selectionEnd = _b.selectionEnd;
            var tabCharacter = (insertSpaces ? ' ' : '\t').repeat(tabSize);
            if (e.keyCode === KEYCODE_TAB && !ignoreTabKey && _this.state.capture) {
                // Prevent focus change
                e.preventDefault();
                if (e.shiftKey) {
                    // Unindent selected lines
                    var linesBeforeCaret = _this._getLines(value, selectionStart);
                    var startLine_1 = linesBeforeCaret.length - 1;
                    var endLine_1 = _this._getLines(value, selectionEnd).length - 1;
                    var nextValue = value
                        .split('\n')
                        .map(function (line, i) {
                        if (i >= startLine_1 &&
                            i <= endLine_1 &&
                            line.startsWith(tabCharacter)) {
                            return line.substring(tabCharacter.length);
                        }
                        return line;
                    })
                        .join('\n');
                    if (value !== nextValue) {
                        var startLineText = linesBeforeCaret[startLine_1];
                        _this._applyEdits({
                            value: nextValue,
                            // Move the start cursor if first line in selection was modified
                            // It was modified only if it started with a tab
                            selectionStart: (startLineText === null || startLineText === void 0 ? void 0 : startLineText.startsWith(tabCharacter))
                                ? selectionStart - tabCharacter.length
                                : selectionStart,
                            // Move the end cursor by total number of characters removed
                            selectionEnd: selectionEnd - (value.length - nextValue.length),
                        });
                    }
                }
                else if (selectionStart !== selectionEnd) {
                    // Indent selected lines
                    var linesBeforeCaret = _this._getLines(value, selectionStart);
                    var startLine_2 = linesBeforeCaret.length - 1;
                    var endLine_2 = _this._getLines(value, selectionEnd).length - 1;
                    var startLineText = linesBeforeCaret[startLine_2];
                    _this._applyEdits({
                        value: value
                            .split('\n')
                            .map(function (line, i) {
                            if (i >= startLine_2 && i <= endLine_2) {
                                return tabCharacter + line;
                            }
                            return line;
                        })
                            .join('\n'),
                        // Move the start cursor by number of characters added in first line of selection
                        // Don't move it if it there was no text before cursor
                        selectionStart: startLineText && /\S/.test(startLineText)
                            ? selectionStart + tabCharacter.length
                            : selectionStart,
                        // Move the end cursor by total number of characters added
                        selectionEnd: selectionEnd + tabCharacter.length * (endLine_2 - startLine_2 + 1),
                    });
                }
                else {
                    var updatedSelection = selectionStart + tabCharacter.length;
                    _this._applyEdits({
                        // Insert tab character at caret
                        value: value.substring(0, selectionStart) +
                            tabCharacter +
                            value.substring(selectionEnd),
                        // Update caret position
                        selectionStart: updatedSelection,
                        selectionEnd: updatedSelection,
                    });
                }
            }
            else if (e.keyCode === KEYCODE_BACKSPACE) {
                var hasSelection = selectionStart !== selectionEnd;
                var textBeforeCaret = value.substring(0, selectionStart);
                if (textBeforeCaret.endsWith(tabCharacter) && !hasSelection) {
                    // Prevent default delete behaviour
                    e.preventDefault();
                    var updatedSelection = selectionStart - tabCharacter.length;
                    _this._applyEdits({
                        // Remove tab character at caret
                        value: value.substring(0, selectionStart - tabCharacter.length) +
                            value.substring(selectionEnd),
                        // Update caret position
                        selectionStart: updatedSelection,
                        selectionEnd: updatedSelection,
                    });
                }
            }
            else if (e.keyCode === KEYCODE_ENTER) {
                // Ignore selections
                if (selectionStart === selectionEnd) {
                    // Get the current line
                    var line = _this._getLines(value, selectionStart).pop();
                    var matches = line === null || line === void 0 ? void 0 : line.match(/^\s+/);
                    if (matches === null || matches === void 0 ? void 0 : matches[0]) {
                        e.preventDefault();
                        // Preserve indentation on inserting a new line
                        var indent = '\n' + matches[0];
                        var updatedSelection = selectionStart + indent.length;
                        _this._applyEdits({
                            // Insert indentation character at caret
                            value: value.substring(0, selectionStart) +
                                indent +
                                value.substring(selectionEnd),
                            // Update caret position
                            selectionStart: updatedSelection,
                            selectionEnd: updatedSelection,
                        });
                    }
                }
            }
            else if (e.keyCode === KEYCODE_PARENS ||
                e.keyCode === KEYCODE_BRACKETS ||
                e.keyCode === KEYCODE_QUOTE ||
                e.keyCode === KEYCODE_BACK_QUOTE) {
                var chars = void 0;
                if (e.keyCode === KEYCODE_PARENS && e.shiftKey) {
                    chars = ['(', ')'];
                }
                else if (e.keyCode === KEYCODE_BRACKETS) {
                    if (e.shiftKey) {
                        chars = ['{', '}'];
                    }
                    else {
                        chars = ['[', ']'];
                    }
                }
                else if (e.keyCode === KEYCODE_QUOTE) {
                    if (e.shiftKey) {
                        chars = ['"', '"'];
                    }
                    else {
                        chars = ["'", "'"];
                    }
                }
                else if (e.keyCode === KEYCODE_BACK_QUOTE && !e.shiftKey) {
                    chars = ['`', '`'];
                }
                // If text is selected, wrap them in the characters
                if (selectionStart !== selectionEnd && chars) {
                    e.preventDefault();
                    _this._applyEdits({
                        value: value.substring(0, selectionStart) +
                            chars[0] +
                            value.substring(selectionStart, selectionEnd) +
                            chars[1] +
                            value.substring(selectionEnd),
                        // Update caret position
                        selectionStart: selectionStart,
                        selectionEnd: selectionEnd + 2,
                    });
                }
            }
            else if ((isMacLike
                ? // Trigger undo with ⌘+Z on Mac
                    e.metaKey && e.keyCode === KEYCODE_Z
                : // Trigger undo with Ctrl+Z on other platforms
                    e.ctrlKey && e.keyCode === KEYCODE_Z) &&
                !e.shiftKey &&
                !e.altKey) {
                e.preventDefault();
                _this._undoEdit();
            }
            else if ((isMacLike
                ? // Trigger redo with ⌘+Shift+Z on Mac
                    e.metaKey && e.keyCode === KEYCODE_Z && e.shiftKey
                : isWindows
                    ? // Trigger redo with Ctrl+Y on Windows
                        e.ctrlKey && e.keyCode === KEYCODE_Y
                    : // Trigger redo with Ctrl+Shift+Z on other platforms
                        e.ctrlKey && e.keyCode === KEYCODE_Z && e.shiftKey) &&
                !e.altKey) {
                e.preventDefault();
                _this._redoEdit();
            }
            else if (e.keyCode === KEYCODE_M &&
                e.ctrlKey &&
                (isMacLike ? e.shiftKey : true)) {
                e.preventDefault();
                // Toggle capturing tab key so users can focus away
                _this.setState(function (state) { return ({
                    capture: !state.capture,
                }); });
            }
        };
        _this._handleChange = function (e) {
            var _a = e.currentTarget, value = _a.value, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd;
            _this._recordChange({
                value: value,
                selectionStart: selectionStart,
                selectionEnd: selectionEnd,
            }, true);
            _this.props.onValueChange(value);
        };
        _this._history = {
            stack: [],
            offset: -1,
        };
        _this._input = null;
        return _this;
    }
    Editor.prototype.componentDidMount = function () {
        this._recordCurrentState();
    };
    Object.defineProperty(Editor.prototype, "session", {
        get: function () {
            return {
                history: this._history,
            };
        },
        set: function (session) {
            this._history = session.history;
        },
        enumerable: false,
        configurable: true
    });
    Editor.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, style = _a.style, padding = _a.padding, highlight = _a.highlight, textareaId = _a.textareaId, textareaClassName = _a.textareaClassName, autoFocus = _a.autoFocus, disabled = _a.disabled, form = _a.form, maxLength = _a.maxLength, minLength = _a.minLength, name = _a.name, placeholder = _a.placeholder, readOnly = _a.readOnly, required = _a.required, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyUp = _a.onKeyUp, 
        /* eslint-disable @typescript-eslint/no-unused-vars */
        onKeyDown = _a.onKeyDown, onValueChange = _a.onValueChange, tabSize = _a.tabSize, insertSpaces = _a.insertSpaces, ignoreTabKey = _a.ignoreTabKey, 
        /* eslint-enable @typescript-eslint/no-unused-vars */
        preClassName = _a.preClassName, rest = __rest(_a, ["value", "style", "padding", "highlight", "textareaId", "textareaClassName", "autoFocus", "disabled", "form", "maxLength", "minLength", "name", "placeholder", "readOnly", "required", "onClick", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onValueChange", "tabSize", "insertSpaces", "ignoreTabKey", "preClassName"]);
        var contentStyle = {
            paddingTop: padding,
            paddingRight: padding,
            paddingBottom: padding,
            paddingLeft: padding,
        };
        var highlighted = highlight(value);
        return (React.createElement("div", __assign({}, rest, { style: __assign(__assign({}, styles.container), style) }),
            React.createElement("textarea", { ref: function (c) { return (_this._input = c); }, style: __assign(__assign(__assign({}, styles.editor), styles.textarea), contentStyle), className: className + (textareaClassName ? " ".concat(textareaClassName) : ''), id: textareaId, value: value, onChange: this._handleChange, onKeyDown: this._handleKeyDown, onClick: onClick, onKeyUp: onKeyUp, onFocus: onFocus, onBlur: onBlur, disabled: disabled, form: form, maxLength: maxLength, minLength: minLength, name: name, placeholder: placeholder, readOnly: readOnly, required: required, autoFocus: autoFocus, autoCapitalize: "off", autoComplete: "off", autoCorrect: "off", spellCheck: false, "data-gramm": false }),
            React.createElement("pre", __assign({ className: preClassName, "aria-hidden": "true", style: __assign(__assign(__assign({}, styles.editor), styles.highlight), contentStyle) }, (typeof highlighted === 'string'
                ? { dangerouslySetInnerHTML: { __html: highlighted + '<br />' } }
                : { children: highlighted }))),
            React.createElement("style", { type: "text/css", dangerouslySetInnerHTML: { __html: cssText } })));
    };
    Editor.defaultProps = {
        tabSize: 2,
        insertSpaces: true,
        ignoreTabKey: false,
        padding: 0,
    };
    return Editor;
}(React.Component));
exports["default"] = Editor;
var styles = {
    container: {
        position: 'relative',
        textAlign: 'left',
        boxSizing: 'border-box',
        padding: 0,
        overflow: 'hidden',
    },
    textarea: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        resize: 'none',
        color: 'inherit',
        overflow: 'hidden',
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
        WebkitTextFillColor: 'transparent',
    },
    highlight: {
        position: 'relative',
        pointerEvents: 'none',
    },
    editor: {
        margin: 0,
        border: 0,
        background: 'none',
        boxSizing: 'inherit',
        display: 'inherit',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontStyle: 'inherit',
        fontVariantLigatures: 'inherit',
        fontWeight: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: 'inherit',
        tabSize: 'inherit',
        textIndent: 'inherit',
        textRendering: 'inherit',
        textTransform: 'inherit',
        whiteSpace: 'pre-wrap',
        wordBreak: 'keep-all',
        overflowWrap: 'break-word',
    },
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 76631:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.sJ = void 0;
var tslib_1 = __webpack_require__(5163);
var react_1 = (0, tslib_1.__importStar)(__webpack_require__(2784));
var SlideDownContent = (function (_super) {
    (0, tslib_1.__extends)(SlideDownContent, _super);
    function SlideDownContent(props) {
        var _this = _super.call(this, props) || this;
        _this.outerRef = null;
        _this.handleRef = function (ref) {
            _this.outerRef = ref;
            if (_this.props.forwardedRef) {
                if (typeof _this.props.forwardedRef === 'function') {
                    _this.props.forwardedRef(ref);
                }
                else if (typeof _this.props.forwardedRef === 'object') {
                    var forwardedRef = _this.props.forwardedRef;
                    forwardedRef.current = ref;
                }
                else {
                    throw new Error("Invalid forwardedRef ".concat(_this.props.forwardedRef));
                }
            }
        };
        _this.handleTransitionEnd = function (evt) {
            if ((evt.target === _this.outerRef) && (evt.propertyName === 'height')) {
                if (_this.state.childrenLeaving) {
                    _this.setState({ children: null, childrenLeaving: false }, function () { return _this.endTransition(); });
                }
                else {
                    _this.endTransition();
                }
            }
        };
        _this.state = {
            children: props.children,
            childrenLeaving: false
        };
        return _this;
    }
    SlideDownContent.prototype.componentDidMount = function () {
        if (this.outerRef) {
            if (this.props.closed || !this.props.children) {
                this.outerRef.classList.add('closed');
                this.outerRef.style.height = '0px';
            }
            else if (this.props.transitionOnAppear) {
                this.startTransition('0px');
            }
            else {
                this.outerRef.style.height = 'auto';
            }
        }
    };
    SlideDownContent.prototype.getSnapshotBeforeUpdate = function () {
        return this.outerRef ? this.outerRef.getBoundingClientRect().height + 'px' : null;
    };
    SlideDownContent.getDerivedStateFromProps = function (props, state) {
        if (props.children) {
            return {
                children: props.children,
                childrenLeaving: false
            };
        }
        else if (state.children) {
            return {
                children: state.children,
                childrenLeaving: true
            };
        }
        else {
            return null;
        }
    };
    SlideDownContent.prototype.componentDidUpdate = function (_prevProps, _prevState, snapshot) {
        if (this.outerRef) {
            this.startTransition(snapshot);
        }
    };
    SlideDownContent.prototype.startTransition = function (prevHeight) {
        var endHeight = '0px';
        if (!this.props.closed && !this.state.childrenLeaving && this.state.children) {
            this.outerRef.classList.remove('closed');
            this.outerRef.style.height = 'auto';
            endHeight = getComputedStyle(this.outerRef).height;
        }
        if (parseFloat(endHeight).toFixed(2) !== parseFloat(prevHeight).toFixed(2)) {
            this.outerRef.classList.add('transitioning');
            this.outerRef.style.height = prevHeight;
            this.outerRef.offsetHeight;
            this.outerRef.style.transitionProperty = 'height';
            this.outerRef.style.height = endHeight;
        }
    };
    SlideDownContent.prototype.endTransition = function () {
        this.outerRef.classList.remove('transitioning');
        this.outerRef.style.transitionProperty = 'none';
        this.outerRef.style.height = this.props.closed ? '0px' : 'auto';
        if (this.props.closed || !this.state.children) {
            this.outerRef.classList.add('closed');
        }
    };
    SlideDownContent.prototype.render = function () {
        var _a = this.props, _b = _a.as, as = _b === void 0 ? 'div' : _b, children = _a.children, className = _a.className, closed = _a.closed, transitionOnAppear = _a.transitionOnAppear, forwardedRef = _a.forwardedRef, rest = (0, tslib_1.__rest)(_a, ["as", "children", "className", "closed", "transitionOnAppear", "forwardedRef"]);
        var containerClassName = className ? 'react-slidedown ' + className : 'react-slidedown';
        return react_1.default.createElement(as, (0, tslib_1.__assign)({ ref: this.handleRef, className: containerClassName, onTransitionEnd: this.handleTransitionEnd }, rest), this.state.children);
    };
    SlideDownContent.defaultProps = {
        transitionOnAppear: true,
        closed: false
    };
    return SlideDownContent;
}(react_1.Component));
exports.sJ = (0, react_1.forwardRef)(function (props, ref) { return (react_1.default.createElement(SlideDownContent, (0, tslib_1.__assign)({}, props, { forwardedRef: ref }))); });
__webpack_unused_export__ = exports.sJ;
//# sourceMappingURL=slidedown.js.map

/***/ }),

/***/ 41759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: ENTERED, ENTERING, EXITED, EXITING, UNMOUNTED

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
// EXTERNAL MODULE: ../../node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(77008);
;// CONCATENATED MODULE: ../../node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
;// CONCATENATED MODULE: ../../node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext/* default */.Z;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);

/***/ }),

/***/ 77008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));

/***/ }),

/***/ 81167:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.autoprefix = undefined;

var _forOwn2 = __webpack_require__(15253);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports["default"] = autoprefix;

/***/ }),

/***/ 72523:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.active = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2.default.Component);
};

exports["default"] = active;

/***/ }),

/***/ 92106:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.hover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2.default.Component);
};

exports["default"] = hover;

/***/ }),

/***/ 30378:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.flattenNames = undefined;

var _isString2 = __webpack_require__(85505);

var _isString3 = _interopRequireDefault(_isString2);

var _forOwn2 = __webpack_require__(15253);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _isPlainObject2 = __webpack_require__(97030);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _map2 = __webpack_require__(16760);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

exports["default"] = flattenNames;

/***/ }),

/***/ 7151:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;

var _flattenNames = __webpack_require__(30378);

var _flattenNames2 = _interopRequireDefault(_flattenNames);

var _mergeClasses = __webpack_require__(87214);

var _mergeClasses2 = _interopRequireDefault(_mergeClasses);

var _autoprefix = __webpack_require__(81167);

var _autoprefix2 = _interopRequireDefault(_autoprefix);

var _hover2 = __webpack_require__(92106);

var _hover3 = _interopRequireDefault(_hover2);

var _active = __webpack_require__(72523);

var _active2 = _interopRequireDefault(_active);

var _loop2 = __webpack_require__(76983);

var _loop3 = _interopRequireDefault(_loop2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

exports["default"] = ReactCSS;

/***/ }),

/***/ 76983:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

exports["default"] = loopable;

/***/ }),

/***/ 87214:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.mergeClasses = undefined;

var _forOwn2 = __webpack_require__(15253);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _cloneDeep2 = __webpack_require__(9850);

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports["default"] = mergeClasses;

/***/ }),

/***/ 91330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DEFAULT_VERSION": function() { return /* reexport */ DEFAULT_VERSION; },
  "FLUSH": function() { return /* reexport */ FLUSH; },
  "KEY_PREFIX": function() { return /* reexport */ KEY_PREFIX; },
  "PAUSE": function() { return /* reexport */ PAUSE; },
  "PERSIST": function() { return /* reexport */ PERSIST; },
  "PURGE": function() { return /* reexport */ PURGE; },
  "REGISTER": function() { return /* reexport */ REGISTER; },
  "REHYDRATE": function() { return /* reexport */ REHYDRATE; },
  "createMigrate": function() { return /* reexport */ createMigrate; },
  "createPersistoid": function() { return /* reexport */ createPersistoid; },
  "createTransform": function() { return /* reexport */ createTransform; },
  "getStoredState": function() { return /* reexport */ getStoredState_getStoredState; },
  "persistCombineReducers": function() { return /* reexport */ persistCombineReducers; },
  "persistReducer": function() { return /* reexport */ persistReducer; },
  "persistStore": function() { return /* reexport */ persistStore; },
  "purgeStoredState": function() { return /* reexport */ purgeStoredState; }
});

;// CONCATENATED MODULE: ../../node_modules/redux-persist/es/constants.js
var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;
;// CONCATENATED MODULE: ../../node_modules/redux-persist/es/stateReconciler/autoMergeLevel1.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/
function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object


  if (inboundState && _typeof(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (false) {}
        return;
      } // otherwise hard set the new value


      newState[key] = inboundState[key];
    });
  }

  if (false) {}
  return newState;
}
;// CONCATENATED MODULE: ../../node_modules/redux-persist/es/createPersistoid.js

// @TODO remove once flow < 0.63 support is no longer required.
function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  var storage = config.storage;
  var serialize;

  if (config.serialize === false) {
    serialize = function serialize(x) {
      return x;
    };
  } else if (typeof config.serialize === 'function') {
    serialize = config.serialize;
  } else {
    serialize = defaultSerialize;
  }

  var writeFailHandler = config.writeFailHandler || null; // initialize stateful values

  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop

      if (lastState[key] === state[key]) return; // value unchanged? noop

      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop

      keysToProcess.push(key); // add key to queue
    }); //if any key is missing in the new state which was present in the lastState,
    //add it for processing too

    Object.keys(lastState).forEach(function (key) {
      if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) {
        keysToProcess.push(key);
      }
    }); // start the time iterator if not running (read: throttle)

    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);

    if (endState !== undefined) {
      try {
        stagedState[key] = serialize(endState);
      } catch (err) {
        console.error('redux-persist/createPersistoid: error serializing state', err);
      }
    } else {
      //if the endState is undefined, no need to persist the existing serialized content
      delete stagedState[key];
    }

    if (keysToProcess.length === 0) {
      writeStagedState();
    }
  }

  function writeStagedState() {
    // cleanup any removed keys just before write.
    Object.keys(stagedState).forEach(function (key) {
      if (lastState[key] === undefined) {
        delete stagedState[key];
      }
    });
    writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (writeFailHandler) writeFailHandler(err);

    if (err && "production" !== 'production') {}
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }

    return writePromise || Promise.resolve();
  }; // return `persistoid`


  return {
    update: update,
    flush: flush
  };
} // @NOTE in the future this may be exposed via config

function defaultSerialize(data) {
  return JSON.stringify(data);
}
;// CONCATENATED MODULE: ../../node_modules/redux-persist/es/getStoredState.js

function getStoredState_getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  var storage = config.storage;
  var debug = config.debug;
  var deserialize;

  if (config.deserialize === false) {
    deserialize = function deserialize(x) {
      return x;
    };
  } else if (typeof config.deserialize === 'function') {
    deserialize = config.deserialize;
  } else {
    deserialize = defaultDeserialize;
  }

  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) {}
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}
;// CONCATENATED MODULE: ../../node_modules/redux-persist/es/purgeStoredState.js

function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX).concat(config.key);
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {}
}
;// CONCATENATED MODULE: ../../node_modules/redux-persist/es/persistReducer.js
function persistReducer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function persistReducer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { persistReducer_ownKeys(source, true).forEach(function (key) { persistReducer_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { persistReducer_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function persistReducer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/

function persistReducer(config, baseReducer) {
  if (false) {}

  var version = config.version !== undefined ? config.version : DEFAULT_VERSION;
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? autoMergeLevel1 : config.stateReconciler;
  var getStoredState = config.getStoredState || getStoredState_getStoredState;
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;

  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ["_persist"]); // $FlowIgnore need to update State type


    var restState = rest;

    if (action.type === PERSIST) {
      var _sealed = false;

      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (false) {} // only rehydrate if we are not already sealed

        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };

      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
      }, timeout); // @NOTE PERSIST resumes if paused.

      _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set

      if (!_persistoid) _persistoid = createPersistoid(config); // @NOTE PERSIST can be called multiple times, noop after the first

      if (_persist) {
        // We still need to call the base reducer because there might be nested
        // uses of persistReducer which need to be aware of the PERSIST action
        return persistReducer_objectSpread({}, baseReducer(restState, action), {
          _persist: _persist
        });
      }

      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
      action.register(config.key);
      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };

        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (false) {}

          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: {
          version: version,
          rehydrated: false
        }
      });
    } else if (action.type === PURGE) {
      _purge = true;
      action.result(purgeStoredState(config));
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === FLUSH) {
      action.result(_persistoid && _persistoid.flush());
      return persistReducer_objectSpread({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === PAUSE) {
      _paused = true;
    } else if (action.type === REHYDRATE) {
      // noop on restState if purging
      if (_purge) return persistReducer_objectSpread({}, restState, {
        _persist: persistReducer_objectSpread({}, _persist, {
          rehydrated: true
        }) // @NOTE if key does not match, will continue to default else below

      });

      if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined

        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        var _newState = persistReducer_objectSpread({}, reconciledRest, {
          _persist: persistReducer_objectSpread({}, _persist, {
            rehydrated: true
          })
        });

        return conditionalUpdate(_newState);
      }
    } // if we have not already handled PERSIST, straight passthrough


    if (!_persist) return baseReducer(state, action); // run base reducer:
    // is state modified ? return original : return updated

    var newState = baseReducer(restState, action);
    if (newState === restState) return state;
    return conditionalUpdate(persistReducer_objectSpread({}, newState, {
      _persist: _persist
    }));
  };
}
// EXTERNAL MODULE: ../../node_modules/redux/es/redux.js
var redux = __webpack_require__(18717);
;// CONCATENATED MODULE: ../../node_modules/redux-persist/es/stateReconciler/autoMergeLevel2.js
function autoMergeLevel2_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { autoMergeLevel2_typeof = function _typeof(obj) { return typeof obj; }; } else { autoMergeLevel2_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return autoMergeLevel2_typeof(obj); }

function autoMergeLevel2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function autoMergeLevel2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { autoMergeLevel2_ownKeys(source, true).forEach(function (key) { autoMergeLevel2_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { autoMergeLevel2_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function autoMergeLevel2_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/
function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = autoMergeLevel2_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object


  if (inboundState && autoMergeLevel2_typeof(inboundState) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration

      if (originalState[key] !== reducedState[key]) {
        if (false) {}
        return;
      }

      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = autoMergeLevel2_objectSpread({}, newState[key], {}, inboundState[key]);
        return;
      } // otherwise hard set


      newState[key] = inboundState[key];
    });
  }

  if (false) {}
  return newState;
}

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && autoMergeLevel2_typeof(o) === 'object';
}
;// CONCATENATED MODULE: ../../node_modules/redux-persist/es/persistCombineReducers.js



// combineReducers + persistReducer with stateReconciler defaulted to autoMergeLevel2
function persistCombineReducers(config, reducers) {
  config.stateReconciler = config.stateReconciler === undefined ? autoMergeLevel2 : config.stateReconciler;
  return persistReducer(config, (0,redux.combineReducers)(reducers));
}
;// CONCATENATED MODULE: ../../node_modules/redux-persist/es/persistStore.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function persistStore_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function persistStore_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { persistStore_ownKeys(source, true).forEach(function (key) { persistStore_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { persistStore_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function persistStore_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case REGISTER:
      return persistStore_objectSpread({}, state, {
        registry: [].concat(_toConsumableArray(state.registry), [action.key])
      });

    case REHYDRATE:
      var firstIndex = state.registry.indexOf(action.key);

      var registry = _toConsumableArray(state.registry);

      registry.splice(firstIndex, 1);
      return persistStore_objectSpread({}, state, {
        registry: registry,
        bootstrapped: registry.length === 0
      });

    default:
      return state;
  }
};

function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) { var bannedKeys, optionsToTest; }

  var boostrappedCb = cb || false;

  var _pStore = (0,redux.createStore)(persistorReducer, initialState, options && options.enhancer ? options.enhancer : undefined);

  var register = function register(key) {
    _pStore.dispatch({
      type: REGISTER,
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: REHYDRATE,
      payload: payload,
      err: err,
      key: key // dispatch to `store` to rehydrate and `persistor` to track result

    };
    store.dispatch(rehydrateAction);

    _pStore.dispatch(rehydrateAction);

    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  var persistor = persistStore_objectSpread({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: PURGE,
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: FLUSH,
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: PAUSE
      });
    },
    persist: function persist() {
      store.dispatch({
        type: PERSIST,
        register: register,
        rehydrate: rehydrate
      });
    }
  });

  if (!(options && options.manualPersist)) {
    persistor.persist();
  }

  return persistor;
}
;// CONCATENATED MODULE: ../../node_modules/redux-persist/es/createMigrate.js

function createMigrate(migrations, config) {
  var _ref = config || {},
      debug = _ref.debug;

  return function (state, currentVersion) {
    if (!state) {
      if (false) {}
      return Promise.resolve(undefined);
    }

    var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : DEFAULT_VERSION;

    if (inboundVersion === currentVersion) {
      if (false) {}
      return Promise.resolve(state);
    }

    if (inboundVersion > currentVersion) {
      if (false) {}
      return Promise.resolve(state);
    }

    var migrationKeys = Object.keys(migrations).map(function (ver) {
      return parseInt(ver);
    }).filter(function (key) {
      return currentVersion >= key && key > inboundVersion;
    }).sort(function (a, b) {
      return a - b;
    });
    if (false) {}

    try {
      var migratedState = migrationKeys.reduce(function (state, versionKey) {
        if (false) {}
        return migrations[versionKey](state);
      }, state);
      return Promise.resolve(migratedState);
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
;// CONCATENATED MODULE: ../../node_modules/redux-persist/es/createTransform.js
function createTransform( // @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound, // @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
    },
    out: function out(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
    }
  };
}
;// CONCATENATED MODULE: ../../node_modules/redux-persist/es/index.js










/***/ }),

/***/ 30547:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports.Z = createWebStorage;

var _getStorage = _interopRequireDefault(__webpack_require__(32393));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWebStorage(type) {
  var storage = (0, _getStorage.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),

/***/ 32393:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.__esModule = true;
exports["default"] = getStorage;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof self === "undefined" ? "undefined" : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }

  try {
    var storage = self[storageType];
    var testKey = "redux-persist ".concat(storageType, " test");
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) {}
    return false;
  }

  return true;
}

function getStorage(type) {
  var storageType = "".concat(type, "Storage");
  if (hasStorage(storageType)) return self[storageType];else {
    if (false) {}

    return noopStorage;
  }
}

/***/ }),

/***/ 5761:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ActionCreators = exports.ActionTypes = void 0;
var ActionTypes = {
  UNDO: '@@redux-undo/UNDO',
  REDO: '@@redux-undo/REDO',
  JUMP_TO_FUTURE: '@@redux-undo/JUMP_TO_FUTURE',
  JUMP_TO_PAST: '@@redux-undo/JUMP_TO_PAST',
  JUMP: '@@redux-undo/JUMP',
  CLEAR_HISTORY: '@@redux-undo/CLEAR_HISTORY'
};
exports.ActionTypes = ActionTypes;
var ActionCreators = {
  undo: function undo() {
    return {
      type: ActionTypes.UNDO
    };
  },
  redo: function redo() {
    return {
      type: ActionTypes.REDO
    };
  },
  jumpToFuture: function jumpToFuture(index) {
    return {
      type: ActionTypes.JUMP_TO_FUTURE,
      index: index
    };
  },
  jumpToPast: function jumpToPast(index) {
    return {
      type: ActionTypes.JUMP_TO_PAST,
      index: index
    };
  },
  jump: function jump(index) {
    return {
      type: ActionTypes.JUMP,
      index: index
    };
  },
  clearHistory: function clearHistory() {
    return {
      type: ActionTypes.CLEAR_HISTORY
    };
  }
};
exports.ActionCreators = ActionCreators;

/***/ }),

/***/ 65903:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.set = set;
exports.start = start;
exports.end = end;
exports.log = log;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var __DEBUG__;

var displayBuffer;
var colors = {
  prevState: '#9E9E9E',
  action: '#03A9F4',
  nextState: '#4CAF50'
};
/* istanbul ignore next: debug messaging is not tested */

function initBuffer() {
  displayBuffer = {
    header: [],
    prev: [],
    action: [],
    next: [],
    msgs: []
  };
}
/* istanbul ignore next: debug messaging is not tested */


function printBuffer() {
  var _displayBuffer = displayBuffer,
      header = _displayBuffer.header,
      prev = _displayBuffer.prev,
      next = _displayBuffer.next,
      action = _displayBuffer.action,
      msgs = _displayBuffer.msgs;

  if (console.group) {
    var _console, _console2, _console3, _console4, _console5;

    (_console = console).groupCollapsed.apply(_console, _toConsumableArray(header));

    (_console2 = console).log.apply(_console2, _toConsumableArray(prev));

    (_console3 = console).log.apply(_console3, _toConsumableArray(action));

    (_console4 = console).log.apply(_console4, _toConsumableArray(next));

    (_console5 = console).log.apply(_console5, _toConsumableArray(msgs));

    console.groupEnd();
  } else {
    var _console6, _console7, _console8, _console9, _console10;

    (_console6 = console).log.apply(_console6, _toConsumableArray(header));

    (_console7 = console).log.apply(_console7, _toConsumableArray(prev));

    (_console8 = console).log.apply(_console8, _toConsumableArray(action));

    (_console9 = console).log.apply(_console9, _toConsumableArray(next));

    (_console10 = console).log.apply(_console10, _toConsumableArray(msgs));
  }
}
/* istanbul ignore next: debug messaging is not tested */


function colorFormat(text, color, obj) {
  return ["%c".concat(text), "color: ".concat(color, "; font-weight: bold"), obj];
}
/* istanbul ignore next: debug messaging is not tested */


function start(action, state) {
  initBuffer();

  if (__DEBUG__) {
    if (console.group) {
      displayBuffer.header = ['%credux-undo', 'font-style: italic', 'action', action.type];
      displayBuffer.action = colorFormat('action', colors.action, action);
      displayBuffer.prev = colorFormat('prev history', colors.prevState, state);
    } else {
      displayBuffer.header = ['redux-undo action', action.type];
      displayBuffer.action = ['action', action];
      displayBuffer.prev = ['prev history', state];
    }
  }
}
/* istanbul ignore next: debug messaging is not tested */


function end(nextState) {
  if (__DEBUG__) {
    if (console.group) {
      displayBuffer.next = colorFormat('next history', colors.nextState, nextState);
    } else {
      displayBuffer.next = ['next history', nextState];
    }

    printBuffer();
  }
}
/* istanbul ignore next: debug messaging is not tested */


function log() {
  if (__DEBUG__) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    displayBuffer.msgs = displayBuffer.msgs.concat([].concat(args, ['\n']));
  }
}
/* istanbul ignore next: debug messaging is not tested */


function set(debug) {
  __DEBUG__ = debug;
}

/***/ }),

/***/ 79458:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.parseActions = parseActions;
exports.isHistory = isHistory;
exports.includeAction = includeAction;
exports.excludeAction = excludeAction;
exports.combineFilters = combineFilters;
exports.groupByActionTypes = groupByActionTypes;
exports.newHistory = newHistory;

// parseActions helper: takes a string (or array)
//                      and makes it an array if it isn't yet
function parseActions(rawActions) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (Array.isArray(rawActions)) {
    return rawActions;
  } else if (typeof rawActions === 'string') {
    return [rawActions];
  }

  return defaultValue;
} // isHistory helper: check for a valid history object


function isHistory(history) {
  return typeof history.present !== 'undefined' && typeof history.future !== 'undefined' && typeof history.past !== 'undefined' && Array.isArray(history.future) && Array.isArray(history.past);
} // includeAction helper: whitelist actions to be added to the history


function includeAction(rawActions) {
  var actions = parseActions(rawActions);
  return function (action) {
    return actions.indexOf(action.type) >= 0;
  };
} // excludeAction helper: blacklist actions from being added to the history


function excludeAction(rawActions) {
  var actions = parseActions(rawActions);
  return function (action) {
    return actions.indexOf(action.type) < 0;
  };
} // combineFilters helper: combine multiple filters to one


function combineFilters() {
  for (var _len = arguments.length, filters = new Array(_len), _key = 0; _key < _len; _key++) {
    filters[_key] = arguments[_key];
  }

  return filters.reduce(function (prev, curr) {
    return function (action, currentState, previousHistory) {
      return prev(action, currentState, previousHistory) && curr(action, currentState, previousHistory);
    };
  }, function () {
    return true;
  });
}

function groupByActionTypes(rawActions) {
  var actions = parseActions(rawActions);
  return function (action) {
    return actions.indexOf(action.type) >= 0 ? action.type : null;
  };
}

function newHistory(past, present, future) {
  var group = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return {
    past: past,
    present: present,
    future: future,
    group: group,
    _latestUnfiltered: present,
    index: past.length,
    limit: past.length + future.length + 1
  };
}

/***/ }),

/***/ 10458:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _actions.ActionTypes;
  }
});
Object.defineProperty(exports, "zF", ({
  enumerable: true,
  get: function get() {
    return _actions.ActionCreators;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _helpers.parseActions;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _helpers.isHistory;
  }
});
Object.defineProperty(exports, "an", ({
  enumerable: true,
  get: function get() {
    return _helpers.includeAction;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _helpers.excludeAction;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _helpers.combineFilters;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _helpers.groupByActionTypes;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _helpers.newHistory;
  }
});
Object.defineProperty(exports, "ZP", ({
  enumerable: true,
  get: function get() {
    return _reducer["default"];
  }
}));

var _actions = __webpack_require__(5761);

var _helpers = __webpack_require__(79458);

var _reducer = _interopRequireDefault(__webpack_require__(46919));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),

/***/ 46919:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = undoable;

var debug = _interopRequireWildcard(__webpack_require__(65903));

var _actions = __webpack_require__(5761);

var _helpers = __webpack_require__(79458);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function createHistory(state, ignoreInitialState) {
  // ignoreInitialState essentially prevents the user from undoing to the
  // beginning, in the case that the undoable reducer handles initialization
  // in a way that can't be redone simply
  var history = (0, _helpers.newHistory)([], state, []);

  if (ignoreInitialState) {
    history._latestUnfiltered = null;
  }

  return history;
} // insert: insert `state` into history, which means adding the current state
//         into `past`, setting the new `state` as `present` and erasing
//         the `future`.


function insert(history, state, limit, group) {
  var lengthWithoutFuture = history.past.length + 1;
  debug.log('inserting', state);
  debug.log('new free: ', limit - lengthWithoutFuture);
  var past = history.past,
      _latestUnfiltered = history._latestUnfiltered;
  var isHistoryOverflow = limit && limit <= lengthWithoutFuture;
  var pastSliced = past.slice(isHistoryOverflow ? 1 : 0);
  var newPast = _latestUnfiltered != null ? [].concat(_toConsumableArray(pastSliced), [_latestUnfiltered]) : pastSliced;
  return (0, _helpers.newHistory)(newPast, state, [], group);
} // jumpToFuture: jump to requested index in future history


function jumpToFuture(history, index) {
  if (index < 0 || index >= history.future.length) return history;
  var past = history.past,
      future = history.future,
      _latestUnfiltered = history._latestUnfiltered;
  var newPast = [].concat(_toConsumableArray(past), [_latestUnfiltered], _toConsumableArray(future.slice(0, index)));
  var newPresent = future[index];
  var newFuture = future.slice(index + 1);
  return (0, _helpers.newHistory)(newPast, newPresent, newFuture);
} // jumpToPast: jump to requested index in past history


function jumpToPast(history, index) {
  if (index < 0 || index >= history.past.length) return history;
  var past = history.past,
      future = history.future,
      _latestUnfiltered = history._latestUnfiltered;
  var newPast = past.slice(0, index);
  var newFuture = [].concat(_toConsumableArray(past.slice(index + 1)), [_latestUnfiltered], _toConsumableArray(future));
  var newPresent = past[index];
  return (0, _helpers.newHistory)(newPast, newPresent, newFuture);
} // jump: jump n steps in the past or forward


function jump(history, n) {
  if (n > 0) return jumpToFuture(history, n - 1);
  if (n < 0) return jumpToPast(history, history.past.length + n);
  return history;
} // helper to dynamically match in the reducer's switch-case


function actionTypeAmongClearHistoryType(actionType, clearHistoryType) {
  return clearHistoryType.indexOf(actionType) > -1 ? actionType : !actionType;
} // redux-undo higher order reducer


function undoable(reducer) {
  var rawConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  debug.set(rawConfig.debug);

  var config = _objectSpread({
    limit: undefined,
    filter: function filter() {
      return true;
    },
    groupBy: function groupBy() {
      return null;
    },
    undoType: _actions.ActionTypes.UNDO,
    redoType: _actions.ActionTypes.REDO,
    jumpToPastType: _actions.ActionTypes.JUMP_TO_PAST,
    jumpToFutureType: _actions.ActionTypes.JUMP_TO_FUTURE,
    jumpType: _actions.ActionTypes.JUMP,
    neverSkipReducer: false,
    ignoreInitialState: false,
    syncFilter: false
  }, rawConfig, {
    initTypes: (0, _helpers.parseActions)(rawConfig.initTypes, ['@@redux-undo/INIT']),
    clearHistoryType: (0, _helpers.parseActions)(rawConfig.clearHistoryType, [_actions.ActionTypes.CLEAR_HISTORY])
  }); // Allows the user to call the reducer with redux-undo specific actions


  var skipReducer = config.neverSkipReducer ? function (res, action) {
    for (var _len = arguments.length, slices = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      slices[_key - 2] = arguments[_key];
    }

    return _objectSpread({}, res, {
      present: reducer.apply(void 0, [res.present, action].concat(slices))
    });
  } : function (res) {
    return res;
  };
  var initialState;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    debug.start(action, state);
    var history = state;

    for (var _len2 = arguments.length, slices = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      slices[_key2 - 2] = arguments[_key2];
    }

    if (!initialState) {
      debug.log('history is uninitialized');

      if (state === undefined) {
        var createHistoryAction = {
          type: '@@redux-undo/CREATE_HISTORY'
        };
        var start = reducer.apply(void 0, [state, createHistoryAction].concat(slices));
        history = createHistory(start, config.ignoreInitialState);
        debug.log('do not set initialState on probe actions');
        debug.end(history);
        return history;
      } else if ((0, _helpers.isHistory)(state)) {
        history = initialState = config.ignoreInitialState ? state : (0, _helpers.newHistory)(state.past, state.present, state.future);
        debug.log('initialHistory initialized: initialState is a history', initialState);
      } else {
        history = initialState = createHistory(state, config.ignoreInitialState);
        debug.log('initialHistory initialized: initialState is not a history', initialState);
      }
    }

    var res;

    switch (action.type) {
      case undefined:
        return history;

      case config.undoType:
        res = jump(history, -1);
        debug.log('perform undo');
        debug.end(res);
        return skipReducer.apply(void 0, [res, action].concat(slices));

      case config.redoType:
        res = jump(history, 1);
        debug.log('perform redo');
        debug.end(res);
        return skipReducer.apply(void 0, [res, action].concat(slices));

      case config.jumpToPastType:
        res = jumpToPast(history, action.index);
        debug.log("perform jumpToPast to ".concat(action.index));
        debug.end(res);
        return skipReducer.apply(void 0, [res, action].concat(slices));

      case config.jumpToFutureType:
        res = jumpToFuture(history, action.index);
        debug.log("perform jumpToFuture to ".concat(action.index));
        debug.end(res);
        return skipReducer.apply(void 0, [res, action].concat(slices));

      case config.jumpType:
        res = jump(history, action.index);
        debug.log("perform jump to ".concat(action.index));
        debug.end(res);
        return skipReducer.apply(void 0, [res, action].concat(slices));

      case actionTypeAmongClearHistoryType(action.type, config.clearHistoryType):
        res = createHistory(history.present, config.ignoreInitialState);
        debug.log('perform clearHistory');
        debug.end(res);
        return skipReducer.apply(void 0, [res, action].concat(slices));

      default:
        res = reducer.apply(void 0, [history.present, action].concat(slices));

        if (config.initTypes.some(function (actionType) {
          return actionType === action.type;
        })) {
          debug.log('reset history due to init action');
          debug.end(initialState);
          return initialState;
        }

        if (history._latestUnfiltered === res) {
          // Don't handle this action. Do not call debug.end here,
          // because this action should not produce side effects to the console
          return history;
        }
        /* eslint-disable-next-line no-case-declarations */


        var filtered = typeof config.filter === 'function' && !config.filter(action, res, history);

        if (filtered) {
          // if filtering an action, merely update the present
          var filteredState = (0, _helpers.newHistory)(history.past, res, history.future, history.group);

          if (!config.syncFilter) {
            filteredState._latestUnfiltered = history._latestUnfiltered;
          }

          debug.log('filter ignored action, not storing it in past');
          debug.end(filteredState);
          return filteredState;
        }
        /* eslint-disable-next-line no-case-declarations */


        var group = config.groupBy(action, res, history);

        if (group != null && group === history.group) {
          // if grouping with the previous action, only update the present
          var groupedState = (0, _helpers.newHistory)(history.past, res, history.future, history.group);
          debug.log('groupBy grouped the action with the previous action');
          debug.end(groupedState);
          return groupedState;
        } // If the action wasn't filtered or grouped, insert normally


        history = insert(history, res, config.limit, group);
        debug.log('inserted new state into history');
        debug.end(history);
        return history;
    }
  };
}

/***/ }),

/***/ 18717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__DO_NOT_USE__ActionTypes": function() { return /* binding */ ActionTypes; },
/* harmony export */   "applyMiddleware": function() { return /* binding */ applyMiddleware; },
/* harmony export */   "bindActionCreators": function() { return /* binding */ bindActionCreators; },
/* harmony export */   "combineReducers": function() { return /* binding */ combineReducers; },
/* harmony export */   "compose": function() { return /* binding */ compose; },
/* harmony export */   "createStore": function() { return /* binding */ createStore; },
/* harmony export */   "legacy_createStore": function() { return /* binding */ legacy_createStore; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33028);


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = createStore;

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {}




/***/ }),

/***/ 5994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P1": function() { return /* binding */ createSelector; }
});

// UNUSED EXPORTS: createSelectorCreator, createStructuredSelector, defaultEqualityCheck, defaultMemoize

;// CONCATENATED MODULE: ../../node_modules/reselect/es/defaultMemoize.js
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}
;// CONCATENATED MODULE: ../../node_modules/reselect/es/index.js



function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function dependenciesChecker() {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);
// Manual definition of state and output arguments
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
  if (selectorCreator === void 0) {
    selectorCreator = createSelector;
  }

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
  }

  var objectKeys = Object.keys(selectors);
  var resultSelector = selectorCreator( // @ts-ignore
  objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
  return resultSelector;
};

/***/ }),

/***/ 88665:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 67895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CX": function() { return /* binding */ Editable; },
  "F3": function() { return /* binding */ ReactEditor; },
  "mH": function() { return /* binding */ Slate; },
  "UE": function() { return /* binding */ useFocused; },
  "vt": function() { return /* binding */ useSelected; },
  "ui": function() { return /* binding */ useSlate; },
  "_7": function() { return /* binding */ useSlateStatic; },
  "BU": function() { return /* binding */ withReact; }
});

// UNUSED EXPORTS: DefaultElement, DefaultLeaf, useEditor, useReadOnly

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/slate/dist/index.es.js
var index_es = __webpack_require__(203);
;// CONCATENATED MODULE: ../../node_modules/slate-react/node_modules/is-plain-object/index.es.js
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
}

/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}

/* harmony default export */ var is_plain_object_index_es = (isPlainObject);

// EXTERNAL MODULE: ../../node_modules/lodash/throttle.js
var throttle = __webpack_require__(12436);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ../../node_modules/compute-scroll-into-view/dist/index.module.js
function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}/* harmony default export */ function index_module(e,i){var o=window,l=i.scrollMode,d=i.block,u=i.inline,h=i.boundary,a=i.skipOverflowHiddenElements,c="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var f=document.scrollingElement||document.documentElement,s=[],p=e;t(p)&&c(p);){if((p=p.parentElement)===f){s.push(p);break}null!=p&&p===document.body&&n(p)&&!n(document.documentElement)||null!=p&&n(p,a)&&s.push(p)}for(var m=o.visualViewport?o.visualViewport.width:innerWidth,g=o.visualViewport?o.visualViewport.height:innerHeight,w=window.scrollX||pageXOffset,v=window.scrollY||pageYOffset,W=e.getBoundingClientRect(),b=W.height,H=W.width,y=W.top,E=W.right,M=W.bottom,V=W.left,x="start"===d||"nearest"===d?y:"end"===d?M:y+b/2,I="center"===u?V+H/2:"end"===u?E:V,C=[],T=0;T<s.length;T++){var k=s[T],B=k.getBoundingClientRect(),D=B.height,O=B.width,R=B.top,X=B.right,Y=B.bottom,L=B.left;if("if-needed"===l&&y>=0&&V>=0&&M<=g&&E<=m&&y>=R&&M<=Y&&V>=L&&E<=X)return C;var S=getComputedStyle(k),j=parseInt(S.borderLeftWidth,10),q=parseInt(S.borderTopWidth,10),z=parseInt(S.borderRightWidth,10),A=parseInt(S.borderBottomWidth,10),F=0,G=0,J="offsetWidth"in k?k.offsetWidth-k.clientWidth-j-z:0,K="offsetHeight"in k?k.offsetHeight-k.clientHeight-q-A:0;if(f===k)F="start"===d?x:"end"===d?x-g:"nearest"===d?r(v,v+g,g,q,A,v+x,v+x+b,b):x-g/2,G="start"===u?I:"center"===u?I-m/2:"end"===u?I-m:r(w,w+m,m,j,z,w+I,w+I+H,H),F=Math.max(0,F+v),G=Math.max(0,G+w);else{F="start"===d?x-R-q:"end"===d?x-Y+A+K:"nearest"===d?r(R,Y,D,q,A+K,x,x+b,b):x-(R+D/2)+K/2,G="start"===u?I-L-j:"center"===u?I-(L+O/2)+J/2:"end"===u?I-X+z+J:r(L,X,O,j,z+J,I,I+H,H);var N=k.scrollLeft,P=k.scrollTop;x+=P-(F=Math.max(0,Math.min(P+F,k.scrollHeight-D+K))),I+=N-(G=Math.max(0,Math.min(N+G,k.scrollWidth-O+J)))}C.push({el:k,top:F,left:G})}return C}
//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../../node_modules/scroll-into-view-if-needed/es/index.js


function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}

function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }

  var canSmoothScroll = ('scrollBehavior' in document.body.style);
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;

    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}

function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }

  if (isOptionsObject(options)) {
    return options;
  }

  return {
    block: 'start',
    inline: 'nearest'
  };
}

function scrollIntoView(target, options) {
  var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);

  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(isTargetAttached ? index_module(target, options) : []);
  }

  if (!isTargetAttached) {
    return;
  }

  var computeOptions = getOptions(options);
  return defaultBehavior(index_module(target, computeOptions), computeOptions.behavior);
}

/* harmony default export */ var es = (scrollIntoView);
// EXTERNAL MODULE: ../../node_modules/direction/index.js
var direction = __webpack_require__(93636);
var direction_default = /*#__PURE__*/__webpack_require__.n(direction);
// EXTERNAL MODULE: ../../node_modules/slate-react/node_modules/is-hotkey/lib/index.js
var lib = __webpack_require__(17249);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/slate-react/dist/index.es.js









function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var History = {
  /**
   * Check if a value is a `History` object.
   */
  isHistory(value) {
    return is_plain_object_index_es(value) && Array.isArray(value.redos) && Array.isArray(value.undos) && (value.redos.length === 0 || index_es/* Operation.isOperationList */.OX.isOperationList(value.redos[0])) && (value.undos.length === 0 || index_es/* Operation.isOperationList */.OX.isOperationList(value.undos[0]));
  }

};
var SAVING = new WeakMap();
var MERGING = new WeakMap();
var HistoryEditor = {
  /**
   * Check if a value is a `HistoryEditor` object.
   */
  isHistoryEditor(value) {
    return History.isHistory(value.history) && index_es/* Editor.isEditor */.ML.isEditor(value);
  },

  /**
   * Get the merge flag's current value.
   */
  isMerging(editor) {
    return MERGING.get(editor);
  },

  /**
   * Get the saving flag's current value.
   */
  isSaving(editor) {
    return SAVING.get(editor);
  },

  /**
   * Redo to the previous saved state.
   */
  redo(editor) {
    editor.redo();
  },

  /**
   * Undo to the previous saved state.
   */
  undo(editor) {
    editor.undo();
  },

  /**
   * Apply a series of changes inside a synchronous `fn`, without merging any of
   * the new operations into previous save point in the history.
   */
  withoutMerging(editor, fn) {
    var prev = HistoryEditor.isMerging(editor);
    MERGING.set(editor, false);
    fn();
    MERGING.set(editor, prev);
  },

  /**
   * Apply a series of changes inside a synchronous `fn`, without saving any of
   * their operations into the history.
   */
  withoutSaving(editor, fn) {
    var prev = HistoryEditor.isSaving(editor);
    SAVING.set(editor, false);
    fn();
    SAVING.set(editor, prev);
  }

};

/**
 * Leaf content strings.
 */

var index_es_String = props => {
  var {
    isLast,
    leaf,
    parent,
    text
  } = props;
  var editor = useSlateStatic();
  var path = ReactEditor.findPath(editor, text);
  var parentPath = index_es/* Path.parent */.y$.parent(path); // COMPAT: Render text inside void nodes with a zero-width space.
  // So the node can contain selection but the text is not visible.

  if (editor.isVoid(parent)) {
    return /*#__PURE__*/react.createElement(ZeroWidthString, {
      length: index_es/* Node.string */.NB.string(parent).length
    });
  } // COMPAT: If this is the last text node in an empty block, render a zero-
  // width space that will convert into a line break when copying and pasting
  // to support expected plain text.


  if (leaf.text === '' && parent.children[parent.children.length - 1] === text && !editor.isInline(parent) && index_es/* Editor.string */.ML.string(editor, parentPath) === '') {
    return /*#__PURE__*/react.createElement(ZeroWidthString, {
      isLineBreak: true
    });
  } // COMPAT: If the text is empty, it's because it's on the edge of an inline
  // node, so we render a zero-width space so that the selection can be
  // inserted next to it still.


  if (leaf.text === '') {
    return /*#__PURE__*/react.createElement(ZeroWidthString, null);
  } // COMPAT: Browsers will collapse trailing new lines at the end of blocks,
  // so we need to add an extra trailing new lines to prevent that.


  if (isLast && leaf.text.slice(-1) === '\n') {
    return /*#__PURE__*/react.createElement(TextString, {
      isTrailing: true,
      text: leaf.text
    });
  }

  return /*#__PURE__*/react.createElement(TextString, {
    text: leaf.text
  });
};
/**
 * Leaf strings with text in them.
 */


var TextString = props => {
  var {
    text,
    isTrailing = false
  } = props;
  return /*#__PURE__*/react.createElement("span", {
    "data-slate-string": true
  }, text, isTrailing ? '\n' : null);
};
/**
 * Leaf strings without text, render as zero-width strings.
 */


var ZeroWidthString = props => {
  var {
    length = 0,
    isLineBreak = false
  } = props;
  return /*#__PURE__*/react.createElement("span", {
    "data-slate-zero-width": isLineBreak ? 'n' : 'z',
    "data-slate-length": length
  }, '\uFEFF', isLineBreak ? /*#__PURE__*/react.createElement("br", null) : null);
};

/**
 * Two weak maps that allow us rebuild a path given a node. They are populated
 * at render time such that after a render occurs we can always backtrack.
 */
var NODE_TO_INDEX = new WeakMap();
var NODE_TO_PARENT = new WeakMap();
/**
 * Weak maps that allow us to go between Slate nodes and DOM nodes. These
 * are used to resolve DOM event-related logic into Slate actions.
 */

var EDITOR_TO_WINDOW = new WeakMap();
var EDITOR_TO_ELEMENT = new WeakMap();
var ELEMENT_TO_NODE = new WeakMap();
var KEY_TO_ELEMENT = new WeakMap();
var NODE_TO_ELEMENT = new WeakMap();
var NODE_TO_KEY = new WeakMap();
/**
 * Weak maps for storing editor-related state.
 */

var IS_READ_ONLY = new WeakMap();
var IS_FOCUSED = new WeakMap();
/**
 * Weak map for associating the context `onChange` context with the plugin.
 */

var EDITOR_TO_ON_CHANGE = new WeakMap();
/**
 * Symbols.
 */

var PLACEHOLDER_SYMBOL = Symbol('placeholder');

/**
 * Individual leaves in a text node with unique formatting.
 */

var Leaf = props => {
  var {
    leaf,
    isLast,
    text,
    parent,
    renderLeaf = props => /*#__PURE__*/react.createElement(DefaultLeaf, Object.assign({}, props))
  } = props;
  var children = /*#__PURE__*/react.createElement(index_es_String, {
    isLast: isLast,
    leaf: leaf,
    parent: parent,
    text: text
  });

  if (leaf[PLACEHOLDER_SYMBOL]) {
    children = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("span", {
      contentEditable: false,
      style: {
        pointerEvents: 'none',
        display: 'inline-block',
        width: '0',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        opacity: '0.333',
        userSelect: 'none',
        fontStyle: 'normal',
        fontWeight: 'normal',
        textDecoration: 'none'
      }
    }, leaf.placeholder), children);
  } // COMPAT: Having the `data-` attributes on these leaf elements ensures that
  // in certain misbehaving browsers they aren't weirdly cloned/destroyed by
  // contenteditable behaviors. (2019/05/08)


  var attributes = {
    'data-slate-leaf': true
  };
  return renderLeaf({
    attributes,
    children,
    leaf,
    text
  });
};

var MemoizedLeaf = /*#__PURE__*/react.memo(Leaf, (prev, next) => {
  return next.parent === prev.parent && next.isLast === prev.isLast && next.renderLeaf === prev.renderLeaf && next.text === prev.text && index_es/* Text.matches */.xv.matches(next.leaf, prev.leaf);
});
var DefaultLeaf = props => {
  var {
    attributes,
    children
  } = props;
  return /*#__PURE__*/react.createElement("span", Object.assign({}, attributes), children);
};

/**
 * Prevent warning on SSR by falling back to useEffect when window is not defined
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;

/**
 * Text.
 */

var Text = props => {
  var {
    decorations,
    isLast,
    parent,
    renderLeaf,
    text
  } = props;
  var editor = useSlateStatic();
  var ref = (0,react.useRef)(null);
  var leaves = index_es/* Text.decorations */.xv.decorations(text, decorations);
  var key = ReactEditor.findKey(editor, text);
  var children = [];

  for (var i = 0; i < leaves.length; i++) {
    var leaf = leaves[i];
    children.push( /*#__PURE__*/react.createElement(MemoizedLeaf, {
      isLast: isLast && i === leaves.length - 1,
      key: "".concat(key.id, "-").concat(i),
      leaf: leaf,
      text: text,
      parent: parent,
      renderLeaf: renderLeaf
    }));
  } // Update element-related weak maps with the DOM element ref.


  useIsomorphicLayoutEffect(() => {
    if (ref.current) {
      KEY_TO_ELEMENT.set(key, ref.current);
      NODE_TO_ELEMENT.set(text, ref.current);
      ELEMENT_TO_NODE.set(ref.current, text);
    } else {
      KEY_TO_ELEMENT.delete(key);
      NODE_TO_ELEMENT.delete(text);
    }
  });
  return /*#__PURE__*/react.createElement("span", {
    "data-slate-node": "text",
    ref: ref
  }, children);
};

var MemoizedText = /*#__PURE__*/react.memo(Text, (prev, next) => {
  return next.parent === prev.parent && next.isLast === prev.isLast && next.renderLeaf === prev.renderLeaf && next.text === prev.text;
});

/**
 * A React context for sharing the `selected` state of an element.
 */

var SelectedContext = /*#__PURE__*/(0,react.createContext)(false);
/**
 * Get the current `selected` state of an element.
 */

var useSelected = () => {
  return (0,react.useContext)(SelectedContext);
};

/**
 * Element.
 */

var Element = props => {
  var {
    decorate,
    decorations,
    element,
    renderElement = p => /*#__PURE__*/react.createElement(DefaultElement, Object.assign({}, p)),
    renderLeaf,
    selection
  } = props;
  var ref = (0,react.useRef)(null);
  var editor = useSlateStatic();
  var readOnly = useReadOnly();
  var isInline = editor.isInline(element);
  var key = ReactEditor.findKey(editor, element);
  var children = /*#__PURE__*/react.createElement(Children, {
    decorate: decorate,
    decorations: decorations,
    node: element,
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    selection: selection
  }); // Attributes that the developer must mix into the element in their
  // custom node renderer component.

  var attributes = {
    'data-slate-node': 'element',
    ref
  };

  if (isInline) {
    attributes['data-slate-inline'] = true;
  } // If it's a block node with inline children, add the proper `dir` attribute
  // for text direction.


  if (!isInline && index_es/* Editor.hasInlines */.ML.hasInlines(editor, element)) {
    var text = index_es/* Node.string */.NB.string(element);
    var dir = direction_default()(text);

    if (dir === 'rtl') {
      attributes.dir = dir;
    }
  } // If it's a void node, wrap the children in extra void-specific elements.


  if (index_es/* Editor.isVoid */.ML.isVoid(editor, element)) {
    attributes['data-slate-void'] = true;

    if (!readOnly && isInline) {
      attributes.contentEditable = false;
    }

    var Tag = isInline ? 'span' : 'div';
    var [[_text]] = index_es/* Node.texts */.NB.texts(element);
    children = readOnly ? null : /*#__PURE__*/react.createElement(Tag, {
      "data-slate-spacer": true,
      style: {
        height: '0',
        color: 'transparent',
        outline: 'none',
        position: 'absolute'
      }
    }, /*#__PURE__*/react.createElement(MemoizedText, {
      decorations: [],
      isLast: false,
      parent: element,
      text: _text
    }));
    NODE_TO_INDEX.set(_text, 0);
    NODE_TO_PARENT.set(_text, element);
  } // Update element-related weak maps with the DOM element ref.


  useIsomorphicLayoutEffect(() => {
    if (ref.current) {
      KEY_TO_ELEMENT.set(key, ref.current);
      NODE_TO_ELEMENT.set(element, ref.current);
      ELEMENT_TO_NODE.set(ref.current, element);
    } else {
      KEY_TO_ELEMENT.delete(key);
      NODE_TO_ELEMENT.delete(element);
    }
  });
  return /*#__PURE__*/react.createElement(SelectedContext.Provider, {
    value: !!selection
  }, renderElement({
    attributes,
    children,
    element
  }));
};

var MemoizedElement = /*#__PURE__*/react.memo(Element, (prev, next) => {
  return prev.decorate === next.decorate && prev.element === next.element && prev.renderElement === next.renderElement && prev.renderLeaf === next.renderLeaf && isRangeListEqual(prev.decorations, next.decorations) && (prev.selection === next.selection || !!prev.selection && !!next.selection && index_es/* Range.equals */.e6.equals(prev.selection, next.selection));
});
/**
 * The default element renderer.
 */

var DefaultElement = props => {
  var {
    attributes,
    children,
    element
  } = props;
  var editor = useSlateStatic();
  var Tag = editor.isInline(element) ? 'span' : 'div';
  return /*#__PURE__*/react.createElement(Tag, Object.assign({}, attributes, {
    style: {
      position: 'relative'
    }
  }), children);
};
/**
 * Check if a list of ranges is equal to another.
 *
 * PERF: this requires the two lists to also have the ranges inside them in the
 * same order, but this is an okay constraint for us since decorations are
 * kept in order, and the odd case where they aren't is okay to re-render for.
 */

var isRangeListEqual = (list, another) => {
  if (list.length !== another.length) {
    return false;
  }

  for (var i = 0; i < list.length; i++) {
    var range = list[i];
    var other = another[i];

    if (!index_es/* Range.equals */.e6.equals(range, other)) {
      return false;
    }
  }

  return true;
};

/**
 * A React context for sharing the editor object.
 */

var EditorContext = /*#__PURE__*/(0,react.createContext)(null);
/**
 * Get the current editor object from the React context.
 */

var useSlateStatic = () => {
  var editor = (0,react.useContext)(EditorContext);

  if (!editor) {
    throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
  }

  return editor;
};

/**
 * Children.
 */

var Children = props => {
  var {
    decorate,
    decorations,
    node,
    renderElement,
    renderLeaf,
    selection
  } = props;
  var editor = useSlateStatic();
  var path = ReactEditor.findPath(editor, node);
  var children = [];
  var isLeafBlock = index_es/* Element.isElement */.W_.isElement(node) && !editor.isInline(node) && index_es/* Editor.hasInlines */.ML.hasInlines(editor, node);

  for (var i = 0; i < node.children.length; i++) {
    var p = path.concat(i);
    var n = node.children[i];
    var key = ReactEditor.findKey(editor, n);
    var range = index_es/* Editor.range */.ML.range(editor, p);
    var sel = selection && index_es/* Range.intersection */.e6.intersection(range, selection);
    var ds = decorate([n, p]);

    for (var dec of decorations) {
      var d = index_es/* Range.intersection */.e6.intersection(dec, range);

      if (d) {
        ds.push(d);
      }
    }

    if (index_es/* Element.isElement */.W_.isElement(n)) {
      children.push( /*#__PURE__*/react.createElement(MemoizedElement, {
        decorate: decorate,
        decorations: ds,
        element: n,
        key: key.id,
        renderElement: renderElement,
        renderLeaf: renderLeaf,
        selection: sel
      }));
    } else {
      children.push( /*#__PURE__*/react.createElement(MemoizedText, {
        decorations: ds,
        key: key.id,
        isLast: isLeafBlock && i === node.children.length - 1,
        parent: node,
        renderLeaf: renderLeaf,
        text: n
      }));
    }

    NODE_TO_INDEX.set(n, i);
    NODE_TO_PARENT.set(n, node);
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, children);
};

var IS_IOS = typeof navigator !== 'undefined' && typeof window !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var IS_APPLE = typeof navigator !== 'undefined' && /Mac OS X/.test(navigator.userAgent);
var IS_FIREFOX = typeof navigator !== 'undefined' && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
var IS_SAFARI = typeof navigator !== 'undefined' && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent); // "modern" Edge was released at 79.x

var IS_EDGE_LEGACY = typeof navigator !== 'undefined' && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])/i.test(navigator.userAgent); // Native beforeInput events don't work well with react on Chrome 75 and older, Chrome 76+ can use beforeInput

var IS_CHROME_LEGACY = typeof navigator !== 'undefined' && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])/i.test(navigator.userAgent);

/**
 * Hotkey mappings for each platform.
 */

var HOTKEYS = {
  bold: 'mod+b',
  compose: ['down', 'left', 'right', 'up', 'backspace', 'enter'],
  moveBackward: 'left',
  moveForward: 'right',
  moveWordBackward: 'ctrl+left',
  moveWordForward: 'ctrl+right',
  deleteBackward: 'shift?+backspace',
  deleteForward: 'shift?+delete',
  extendBackward: 'shift+left',
  extendForward: 'shift+right',
  italic: 'mod+i',
  splitBlock: 'shift?+enter',
  undo: 'mod+z'
};
var APPLE_HOTKEYS = {
  moveLineBackward: 'opt+up',
  moveLineForward: 'opt+down',
  moveWordBackward: 'opt+left',
  moveWordForward: 'opt+right',
  deleteBackward: ['ctrl+backspace', 'ctrl+h'],
  deleteForward: ['ctrl+delete', 'ctrl+d'],
  deleteLineBackward: 'cmd+shift?+backspace',
  deleteLineForward: ['cmd+shift?+delete', 'ctrl+k'],
  deleteWordBackward: 'opt+shift?+backspace',
  deleteWordForward: 'opt+shift?+delete',
  extendLineBackward: 'opt+shift+up',
  extendLineForward: 'opt+shift+down',
  redo: 'cmd+shift+z',
  transposeCharacter: 'ctrl+t'
};
var WINDOWS_HOTKEYS = {
  deleteWordBackward: 'ctrl+shift?+backspace',
  deleteWordForward: 'ctrl+shift?+delete',
  redo: ['ctrl+y', 'ctrl+shift+z']
};
/**
 * Create a platform-aware hotkey checker.
 */

var create = key => {
  var generic = HOTKEYS[key];
  var apple = APPLE_HOTKEYS[key];
  var windows = WINDOWS_HOTKEYS[key];
  var isGeneric = generic && (0,lib/* isKeyHotkey */.TB)(generic);
  var isApple = apple && (0,lib/* isKeyHotkey */.TB)(apple);
  var isWindows = windows && (0,lib/* isKeyHotkey */.TB)(windows);
  return event => {
    if (isGeneric && isGeneric(event)) return true;
    if (IS_APPLE && isApple && isApple(event)) return true;
    if (!IS_APPLE && isWindows && isWindows(event)) return true;
    return false;
  };
};
/**
 * Hotkeys.
 */


var Hotkeys = {
  isBold: create('bold'),
  isCompose: create('compose'),
  isMoveBackward: create('moveBackward'),
  isMoveForward: create('moveForward'),
  isDeleteBackward: create('deleteBackward'),
  isDeleteForward: create('deleteForward'),
  isDeleteLineBackward: create('deleteLineBackward'),
  isDeleteLineForward: create('deleteLineForward'),
  isDeleteWordBackward: create('deleteWordBackward'),
  isDeleteWordForward: create('deleteWordForward'),
  isExtendBackward: create('extendBackward'),
  isExtendForward: create('extendForward'),
  isExtendLineBackward: create('extendLineBackward'),
  isExtendLineForward: create('extendLineForward'),
  isItalic: create('italic'),
  isMoveLineBackward: create('moveLineBackward'),
  isMoveLineForward: create('moveLineForward'),
  isMoveWordBackward: create('moveWordBackward'),
  isMoveWordForward: create('moveWordForward'),
  isRedo: create('redo'),
  isSplitBlock: create('splitBlock'),
  isTransposeCharacter: create('transposeCharacter'),
  isUndo: create('undo')
};

/**
 * A React context for sharing the `readOnly` state of the editor.
 */

var ReadOnlyContext = /*#__PURE__*/(0,react.createContext)(false);
/**
 * Get the current `readOnly` state of the editor.
 */

var useReadOnly = () => {
  return (0,react.useContext)(ReadOnlyContext);
};

/**
 * A React context for sharing the editor object, in a way that re-renders the
 * context whenever changes occur.
 */

var SlateContext = /*#__PURE__*/(0,react.createContext)(null);
/**
 * Get the current editor object from the React context.
 */

var useSlate = () => {
  var context = (0,react.useContext)(SlateContext);

  if (!context) {
    throw new Error("The `useSlate` hook must be used inside the <SlateProvider> component's context.");
  }

  var [editor] = context;
  return editor;
};

/**
 * Types.
 */
/**
 * Returns the host window of a DOM node
 */

var getDefaultView = value => {
  return value && value.ownerDocument && value.ownerDocument.defaultView || null;
};
/**
 * Check if a DOM node is a comment node.
 */

var isDOMComment = value => {
  return isDOMNode(value) && value.nodeType === 8;
};
/**
 * Check if a DOM node is an element node.
 */

var isDOMElement = value => {
  return isDOMNode(value) && value.nodeType === 1;
};
/**
 * Check if a value is a DOM node.
 */

var isDOMNode = value => {
  var window = getDefaultView(value);
  return !!window && value instanceof window.Node;
};
/**
 * Check if a value is a DOM selection.
 */

var isDOMSelection = value => {
  var window = value && value.anchorNode && getDefaultView(value.anchorNode);
  return !!window && value instanceof window.Selection;
};
/**
 * Check if a DOM node is an element node.
 */

var isDOMText = value => {
  return isDOMNode(value) && value.nodeType === 3;
};
/**
 * Checks whether a paste event is a plaintext-only event.
 */

var isPlainTextOnlyPaste = event => {
  return event.clipboardData && event.clipboardData.getData('text/plain') !== '' && event.clipboardData.types.length === 1;
};
/**
 * Normalize a DOM point so that it always refers to a text node.
 */

var normalizeDOMPoint = domPoint => {
  var [node, offset] = domPoint; // If it's an element node, its offset refers to the index of its children
  // including comment nodes, so try to find the right text child node.

  if (isDOMElement(node) && node.childNodes.length) {
    var isLast = offset === node.childNodes.length;
    var direction = isLast ? 'backward' : 'forward';
    var index = isLast ? offset - 1 : offset;
    node = getEditableChild(node, index, direction); // If the node has children, traverse until we have a leaf node. Leaf nodes
    // can be either text nodes, or other void DOM nodes.

    while (isDOMElement(node) && node.childNodes.length) {
      var i = isLast ? node.childNodes.length - 1 : 0;
      node = getEditableChild(node, i, direction);
    } // Determine the new offset inside the text node.


    offset = isLast && node.textContent != null ? node.textContent.length : 0;
  } // Return the node and offset.


  return [node, offset];
};
/**
 * Get the nearest editable child at `index` in a `parent`, preferring
 * `direction`.
 */

var getEditableChild = (parent, index, direction) => {
  var {
    childNodes
  } = parent;
  var child = childNodes[index];
  var i = index;
  var triedForward = false;
  var triedBackward = false; // While the child is a comment node, or an element node with no children,
  // keep iterating to find a sibling non-void, non-comment node.

  while (isDOMComment(child) || isDOMElement(child) && child.childNodes.length === 0 || isDOMElement(child) && child.getAttribute('contenteditable') === 'false') {
    if (triedForward && triedBackward) {
      break;
    }

    if (i >= childNodes.length) {
      triedForward = true;
      i = index - 1;
      direction = 'backward';
      continue;
    }

    if (i < 0) {
      triedBackward = true;
      i = index + 1;
      direction = 'forward';
      continue;
    }

    child = childNodes[i];
    i += direction === 'forward' ? 1 : -1;
  }

  return child;
};
/**
 * Get a plaintext representation of the content of a node, accounting for block
 * elements which get a newline appended.
 *
 * The domNode must be attached to the DOM.
 */

var getPlainText = domNode => {
  var text = '';

  if (isDOMText(domNode) && domNode.nodeValue) {
    return domNode.nodeValue;
  }

  if (isDOMElement(domNode)) {
    for (var childNode of Array.from(domNode.childNodes)) {
      text += getPlainText(childNode);
    }

    var display = getComputedStyle(domNode).getPropertyValue('display');

    if (display === 'block' || display === 'list' || domNode.tagName === 'BR') {
      text += '\n';
    }
  }

  return text;
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
// Chrome Legacy doesn't support `beforeinput` correctly

var HAS_BEFORE_INPUT_SUPPORT = !(IS_FIREFOX || IS_EDGE_LEGACY || IS_CHROME_LEGACY);
/**
 * Editable.
 */

var Editable = props => {
  var {
    autoFocus,
    decorate = defaultDecorate,
    onDOMBeforeInput: propsOnDOMBeforeInput,
    placeholder,
    readOnly = false,
    renderElement,
    renderLeaf,
    style = {},
    as: Component = 'div'
  } = props,
      attributes = _objectWithoutProperties(props, ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "style", "as"]);

  var editor = useSlate();
  var ref = (0,react.useRef)(null); // Update internal state on each render.

  IS_READ_ONLY.set(editor, readOnly); // Keep track of some state for the event handler logic.

  var state = (0,react.useMemo)(() => ({
    isComposing: false,
    isUpdatingSelection: false,
    latestElement: null
  }), []); // Update element-related weak maps with the DOM element ref.

  useIsomorphicLayoutEffect(() => {
    var window;

    if (ref.current && (window = getDefaultView(ref.current))) {
      EDITOR_TO_WINDOW.set(editor, window);
      EDITOR_TO_ELEMENT.set(editor, ref.current);
      NODE_TO_ELEMENT.set(editor, ref.current);
      ELEMENT_TO_NODE.set(ref.current, editor);
    } else {
      NODE_TO_ELEMENT.delete(editor);
    }
  }); // Whenever the editor updates, make sure the DOM selection state is in sync.

  useIsomorphicLayoutEffect(() => {
    var {
      selection
    } = editor;
    var window = ReactEditor.getWindow(editor);
    var domSelection = window.getSelection();

    if (state.isComposing || !domSelection || !ReactEditor.isFocused(editor)) {
      return;
    }

    var hasDomSelection = domSelection.type !== 'None'; // If the DOM selection is properly unset, we're done.

    if (!selection && !hasDomSelection) {
      return;
    } // verify that the dom selection is in the editor


    var editorElement = EDITOR_TO_ELEMENT.get(editor);
    var hasDomSelectionInEditor = false;

    if (editorElement.contains(domSelection.anchorNode) && editorElement.contains(domSelection.focusNode)) {
      hasDomSelectionInEditor = true;
    } // If the DOM selection is in the editor and the editor selection is already correct, we're done.


    if (hasDomSelection && hasDomSelectionInEditor && selection && index_es/* Range.equals */.e6.equals(ReactEditor.toSlateRange(editor, domSelection), selection)) {
      return;
    } // Otherwise the DOM selection is out of sync, so update it.


    var el = ReactEditor.toDOMNode(editor, editor);
    state.isUpdatingSelection = true;
    var newDomRange = selection && ReactEditor.toDOMRange(editor, selection);

    if (newDomRange) {
      if (index_es/* Range.isBackward */.e6.isBackward(selection)) {
        domSelection.setBaseAndExtent(newDomRange.endContainer, newDomRange.endOffset, newDomRange.startContainer, newDomRange.startOffset);
      } else {
        domSelection.setBaseAndExtent(newDomRange.startContainer, newDomRange.startOffset, newDomRange.endContainer, newDomRange.endOffset);
      }

      var leafEl = newDomRange.startContainer.parentElement;
      es(leafEl, {
        scrollMode: 'if-needed',
        boundary: el
      });
    } else {
      domSelection.removeAllRanges();
    }

    setTimeout(() => {
      // COMPAT: In Firefox, it's not enough to create a range, you also need
      // to focus the contenteditable element too. (2016/11/16)
      if (newDomRange && IS_FIREFOX) {
        el.focus();
      }

      state.isUpdatingSelection = false;
    });
  }); // The autoFocus TextareaHTMLAttribute doesn't do anything on a div, so it
  // needs to be manually focused.

  (0,react.useEffect)(() => {
    if (ref.current && autoFocus) {
      ref.current.focus();
    }
  }, [autoFocus]); // Listen on the native `beforeinput` event to get real "Level 2" events. This
  // is required because React's `beforeinput` is fake and never really attaches
  // to the real event sadly. (2019/11/01)
  // https://github.com/facebook/react/issues/11211

  var onDOMBeforeInput = (0,react.useCallback)(event => {
    if (!readOnly && hasEditableTarget(editor, event.target) && !isDOMEventHandled(event, propsOnDOMBeforeInput)) {
      var {
        selection
      } = editor;
      var {
        inputType: type
      } = event;
      var data = event.dataTransfer || event.data || undefined; // These two types occur while a user is composing text and can't be
      // cancelled. Let them through and wait for the composition to end.

      if (type === 'insertCompositionText' || type === 'deleteCompositionText') {
        return;
      }

      event.preventDefault(); // COMPAT: For the deleting forward/backward input types we don't want
      // to change the selection because it is the range that will be deleted,
      // and those commands determine that for themselves.

      if (!type.startsWith('delete') || type.startsWith('deleteBy')) {
        var [targetRange] = event.getTargetRanges();

        if (targetRange) {
          var range = ReactEditor.toSlateRange(editor, targetRange);

          if (!selection || !index_es/* Range.equals */.e6.equals(selection, range)) {
            index_es/* Transforms.select */.YR.select(editor, range);
          }
        }
      } // COMPAT: If the selection is expanded, even if the command seems like
      // a delete forward/backward command it should delete the selection.


      if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection) && type.startsWith('delete')) {
        index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
        return;
      }

      switch (type) {
        case 'deleteByComposition':
        case 'deleteByCut':
        case 'deleteByDrag':
          {
            index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
            break;
          }

        case 'deleteContent':
        case 'deleteContentForward':
          {
            index_es/* Editor.deleteForward */.ML.deleteForward(editor);
            break;
          }

        case 'deleteContentBackward':
          {
            index_es/* Editor.deleteBackward */.ML.deleteBackward(editor);
            break;
          }

        case 'deleteEntireSoftLine':
          {
            index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
              unit: 'line'
            });
            index_es/* Editor.deleteForward */.ML.deleteForward(editor, {
              unit: 'line'
            });
            break;
          }

        case 'deleteHardLineBackward':
          {
            index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
              unit: 'block'
            });
            break;
          }

        case 'deleteSoftLineBackward':
          {
            index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
              unit: 'line'
            });
            break;
          }

        case 'deleteHardLineForward':
          {
            index_es/* Editor.deleteForward */.ML.deleteForward(editor, {
              unit: 'block'
            });
            break;
          }

        case 'deleteSoftLineForward':
          {
            index_es/* Editor.deleteForward */.ML.deleteForward(editor, {
              unit: 'line'
            });
            break;
          }

        case 'deleteWordBackward':
          {
            index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
              unit: 'word'
            });
            break;
          }

        case 'deleteWordForward':
          {
            index_es/* Editor.deleteForward */.ML.deleteForward(editor, {
              unit: 'word'
            });
            break;
          }

        case 'insertLineBreak':
        case 'insertParagraph':
          {
            index_es/* Editor.insertBreak */.ML.insertBreak(editor);
            break;
          }

        case 'insertFromComposition':
        case 'insertFromDrop':
        case 'insertFromPaste':
        case 'insertFromYank':
        case 'insertReplacementText':
        case 'insertText':
          {
            var window = ReactEditor.getWindow(editor);

            if (data instanceof window.DataTransfer) {
              ReactEditor.insertData(editor, data);
            } else if (typeof data === 'string') {
              index_es/* Editor.insertText */.ML.insertText(editor, data);
            }

            break;
          }
      }
    }
  }, [readOnly, propsOnDOMBeforeInput]); // Attach a native DOM event handler for `beforeinput` events, because React's
  // built-in `onBeforeInput` is actually a leaky polyfill that doesn't expose
  // real `beforeinput` events sadly... (2019/11/04)
  // https://github.com/facebook/react/issues/11211

  useIsomorphicLayoutEffect(() => {
    if (ref.current && HAS_BEFORE_INPUT_SUPPORT) {
      // @ts-ignore The `beforeinput` event isn't recognized.
      ref.current.addEventListener('beforeinput', onDOMBeforeInput);
    }

    return () => {
      if (ref.current && HAS_BEFORE_INPUT_SUPPORT) {
        // @ts-ignore The `beforeinput` event isn't recognized.
        ref.current.removeEventListener('beforeinput', onDOMBeforeInput);
      }
    };
  }, [onDOMBeforeInput]); // Listen on the native `selectionchange` event to be able to update any time
  // the selection changes. This is required because React's `onSelect` is leaky
  // and non-standard so it doesn't fire until after a selection has been
  // released. This causes issues in situations where another change happens
  // while a selection is being dragged.

  var onDOMSelectionChange = (0,react.useCallback)(throttle_default()(() => {
    if (!readOnly && !state.isComposing && !state.isUpdatingSelection) {
      var window = ReactEditor.getWindow(editor);
      var {
        activeElement
      } = window.document;
      var el = ReactEditor.toDOMNode(editor, editor);
      var domSelection = window.getSelection();

      if (activeElement === el) {
        state.latestElement = activeElement;
        IS_FOCUSED.set(editor, true);
      } else {
        IS_FOCUSED.delete(editor);
      }

      if (!domSelection) {
        return index_es/* Transforms.deselect */.YR.deselect(editor);
      }

      var {
        anchorNode,
        focusNode
      } = domSelection;
      var anchorNodeSelectable = hasEditableTarget(editor, anchorNode) || isTargetInsideVoid(editor, anchorNode);
      var focusNodeSelectable = hasEditableTarget(editor, focusNode) || isTargetInsideVoid(editor, focusNode);

      if (anchorNodeSelectable && focusNodeSelectable) {
        var range = ReactEditor.toSlateRange(editor, domSelection);
        index_es/* Transforms.select */.YR.select(editor, range);
      } else {
        index_es/* Transforms.deselect */.YR.deselect(editor);
      }
    }
  }, 100), [readOnly]); // Attach a native DOM event handler for `selectionchange`, because React's
  // built-in `onSelect` handler doesn't fire for all selection changes. It's a
  // leaky polyfill that only fires on keypresses or clicks. Instead, we want to
  // fire for any change to the selection inside the editor. (2019/11/04)
  // https://github.com/facebook/react/issues/5785

  useIsomorphicLayoutEffect(() => {
    var window = ReactEditor.getWindow(editor);
    window.document.addEventListener('selectionchange', onDOMSelectionChange);
    return () => {
      window.document.removeEventListener('selectionchange', onDOMSelectionChange);
    };
  }, [onDOMSelectionChange]);
  var decorations = decorate([editor, []]);

  if (placeholder && editor.children.length === 1 && Array.from(index_es/* Node.texts */.NB.texts(editor)).length === 1 && index_es/* Node.string */.NB.string(editor) === '') {
    var start = index_es/* Editor.start */.ML.start(editor, []);
    decorations.push({
      [PLACEHOLDER_SYMBOL]: true,
      placeholder,
      anchor: start,
      focus: start
    });
  }

  return /*#__PURE__*/react.createElement(ReadOnlyContext.Provider, {
    value: readOnly
  }, /*#__PURE__*/react.createElement(Component // COMPAT: The Grammarly Chrome extension works by changing the DOM
  // out from under `contenteditable` elements, which leads to weird
  // behaviors so we have to disable it like editor. (2017/04/24)
  , Object.assign({
    "data-gramm": false,
    role: readOnly ? undefined : 'textbox'
  }, attributes, {
    // COMPAT: Certain browsers don't support the `beforeinput` event, so we'd
    // have to use hacks to make these replacement-based features work.
    spellCheck: !HAS_BEFORE_INPUT_SUPPORT ? undefined : attributes.spellCheck,
    autoCorrect: !HAS_BEFORE_INPUT_SUPPORT ? undefined : attributes.autoCorrect,
    autoCapitalize: !HAS_BEFORE_INPUT_SUPPORT ? undefined : attributes.autoCapitalize,
    "data-slate-editor": true,
    "data-slate-node": "value",
    contentEditable: readOnly ? undefined : true,
    suppressContentEditableWarning: true,
    ref: ref,
    style: _objectSpread({
      // Prevent the default outline styles.
      outline: 'none',
      // Preserve adjacent whitespace and new lines.
      whiteSpace: 'pre-wrap',
      // Allow words to break if they are too long.
      wordWrap: 'break-word'
    }, style),
    onBeforeInput: (0,react.useCallback)(event => {
      // COMPAT: Certain browsers don't support the `beforeinput` event, so we
      // fall back to React's leaky polyfill instead just for it. It
      // only works for the `insertText` input type.
      if (!HAS_BEFORE_INPUT_SUPPORT && !readOnly && !isEventHandled(event, attributes.onBeforeInput) && hasEditableTarget(editor, event.target)) {
        event.preventDefault();
        var text = event.data;
        index_es/* Editor.insertText */.ML.insertText(editor, text);
      }
    }, [readOnly]),
    onBlur: (0,react.useCallback)(event => {
      if (readOnly || state.isUpdatingSelection || !hasEditableTarget(editor, event.target) || isEventHandled(event, attributes.onBlur)) {
        return;
      }

      var window = ReactEditor.getWindow(editor); // COMPAT: If the current `activeElement` is still the previous
      // one, this is due to the window being blurred when the tab
      // itself becomes unfocused, so we want to abort early to allow to
      // editor to stay focused when the tab becomes focused again.

      if (state.latestElement === window.document.activeElement) {
        return;
      }

      var {
        relatedTarget
      } = event;
      var el = ReactEditor.toDOMNode(editor, editor); // COMPAT: The event should be ignored if the focus is returning
      // to the editor from an embedded editable element (eg. an <input>
      // element inside a void node).

      if (relatedTarget === el) {
        return;
      } // COMPAT: The event should be ignored if the focus is moving from
      // the editor to inside a void node's spacer element.


      if (isDOMElement(relatedTarget) && relatedTarget.hasAttribute('data-slate-spacer')) {
        return;
      } // COMPAT: The event should be ignored if the focus is moving to a
      // non- editable section of an element that isn't a void node (eg.
      // a list item of the check list example).


      if (relatedTarget != null && isDOMNode(relatedTarget) && ReactEditor.hasDOMNode(editor, relatedTarget)) {
        var node = ReactEditor.toSlateNode(editor, relatedTarget);

        if (index_es/* Element.isElement */.W_.isElement(node) && !editor.isVoid(node)) {
          return;
        }
      }

      IS_FOCUSED.delete(editor);
    }, [readOnly, attributes.onBlur]),
    onClick: (0,react.useCallback)(event => {
      if (!readOnly && hasTarget(editor, event.target) && !isEventHandled(event, attributes.onClick) && isDOMNode(event.target)) {
        var node = ReactEditor.toSlateNode(editor, event.target);
        var path = ReactEditor.findPath(editor, node);

        var _start = index_es/* Editor.start */.ML.start(editor, path);

        var end = index_es/* Editor.end */.ML.end(editor, path);
        var startVoid = index_es/* Editor.void */.ML["void"](editor, {
          at: _start
        });
        var endVoid = index_es/* Editor.void */.ML["void"](editor, {
          at: end
        });

        if (startVoid && endVoid && index_es/* Path.equals */.y$.equals(startVoid[1], endVoid[1])) {
          var range = index_es/* Editor.range */.ML.range(editor, _start);
          index_es/* Transforms.select */.YR.select(editor, range);
        }
      }
    }, [readOnly, attributes.onClick]),
    onCompositionEnd: (0,react.useCallback)(event => {
      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionEnd)) {
        state.isComposing = false; // COMPAT: In Chrome, `beforeinput` events for compositions
        // aren't correct and never fire the "insertFromComposition"
        // type that we need. So instead, insert whenever a composition
        // ends since it will already have been committed to the DOM.

        if (!IS_SAFARI && !IS_FIREFOX && event.data) {
          index_es/* Editor.insertText */.ML.insertText(editor, event.data);
        }
      }
    }, [attributes.onCompositionEnd]),
    onCompositionStart: (0,react.useCallback)(event => {
      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionStart)) {
        state.isComposing = true;
      }
    }, [attributes.onCompositionStart]),
    onCopy: (0,react.useCallback)(event => {
      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCopy)) {
        event.preventDefault();
        ReactEditor.setFragmentData(editor, event.clipboardData);
      }
    }, [attributes.onCopy]),
    onCut: (0,react.useCallback)(event => {
      if (!readOnly && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onCut)) {
        event.preventDefault();
        ReactEditor.setFragmentData(editor, event.clipboardData);
        var {
          selection
        } = editor;

        if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
          index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
        }
      }
    }, [readOnly, attributes.onCut]),
    onDragOver: (0,react.useCallback)(event => {
      if (hasTarget(editor, event.target) && !isEventHandled(event, attributes.onDragOver)) {
        // Only when the target is void, call `preventDefault` to signal
        // that drops are allowed. Editable content is droppable by
        // default, and calling `preventDefault` hides the cursor.
        var node = ReactEditor.toSlateNode(editor, event.target);

        if (index_es/* Editor.isVoid */.ML.isVoid(editor, node)) {
          event.preventDefault();
        }
      }
    }, [attributes.onDragOver]),
    onDragStart: (0,react.useCallback)(event => {
      if (hasTarget(editor, event.target) && !isEventHandled(event, attributes.onDragStart)) {
        var node = ReactEditor.toSlateNode(editor, event.target);
        var path = ReactEditor.findPath(editor, node);
        var voidMatch = index_es/* Editor.void */.ML["void"](editor, {
          at: path
        }); // If starting a drag on a void node, make sure it is selected
        // so that it shows up in the selection's fragment.

        if (voidMatch) {
          var range = index_es/* Editor.range */.ML.range(editor, path);
          index_es/* Transforms.select */.YR.select(editor, range);
        }

        ReactEditor.setFragmentData(editor, event.dataTransfer);
      }
    }, [attributes.onDragStart]),
    onDrop: (0,react.useCallback)(event => {
      if (hasTarget(editor, event.target) && !readOnly && !isEventHandled(event, attributes.onDrop)) {
        // COMPAT: Certain browsers don't fire `beforeinput` events at all, and
        // Chromium browsers don't properly fire them for files being
        // dropped into a `contenteditable`. (2019/11/26)
        // https://bugs.chromium.org/p/chromium/issues/detail?id=1028668
        if (!HAS_BEFORE_INPUT_SUPPORT || !IS_SAFARI && event.dataTransfer.files.length > 0) {
          event.preventDefault();
          var range = ReactEditor.findEventRange(editor, event);
          var data = event.dataTransfer;
          index_es/* Transforms.select */.YR.select(editor, range);
          ReactEditor.insertData(editor, data);
        }
      }
    }, [readOnly, attributes.onDrop]),
    onFocus: (0,react.useCallback)(event => {
      if (!readOnly && !state.isUpdatingSelection && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onFocus)) {
        var el = ReactEditor.toDOMNode(editor, editor);
        var window = ReactEditor.getWindow(editor);
        state.latestElement = window.document.activeElement; // COMPAT: If the editor has nested editable elements, the focus
        // can go to them. In Firefox, this must be prevented because it
        // results in issues with keyboard navigation. (2017/03/30)

        if (IS_FIREFOX && event.target !== el) {
          el.focus();
          return;
        }

        IS_FOCUSED.set(editor, true);
      }
    }, [readOnly, attributes.onFocus]),
    onKeyDown: (0,react.useCallback)(event => {
      if (!readOnly && hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onKeyDown)) {
        var {
          nativeEvent
        } = event;
        var {
          selection
        } = editor; // COMPAT: Since we prevent the default behavior on
        // `beforeinput` events, the browser doesn't think there's ever
        // any history stack to undo or redo, so we have to manage these
        // hotkeys ourselves. (2019/11/06)

        if (Hotkeys.isRedo(nativeEvent)) {
          event.preventDefault();

          if (HistoryEditor.isHistoryEditor(editor)) {
            editor.redo();
          }

          return;
        }

        if (Hotkeys.isUndo(nativeEvent)) {
          event.preventDefault();

          if (HistoryEditor.isHistoryEditor(editor)) {
            editor.undo();
          }

          return;
        } // COMPAT: Certain browsers don't handle the selection updates
        // properly. In Chrome, the selection isn't properly extended.
        // And in Firefox, the selection isn't properly collapsed.
        // (2017/10/17)


        if (Hotkeys.isMoveLineBackward(nativeEvent)) {
          event.preventDefault();
          index_es/* Transforms.move */.YR.move(editor, {
            unit: 'line',
            reverse: true
          });
          return;
        }

        if (Hotkeys.isMoveLineForward(nativeEvent)) {
          event.preventDefault();
          index_es/* Transforms.move */.YR.move(editor, {
            unit: 'line'
          });
          return;
        }

        if (Hotkeys.isExtendLineBackward(nativeEvent)) {
          event.preventDefault();
          index_es/* Transforms.move */.YR.move(editor, {
            unit: 'line',
            edge: 'focus',
            reverse: true
          });
          return;
        }

        if (Hotkeys.isExtendLineForward(nativeEvent)) {
          event.preventDefault();
          index_es/* Transforms.move */.YR.move(editor, {
            unit: 'line',
            edge: 'focus'
          });
          return;
        } // COMPAT: If a void node is selected, or a zero-width text node
        // adjacent to an inline is selected, we need to handle these
        // hotkeys manually because browsers won't be able to skip over
        // the void node with the zero-width space not being an empty
        // string.


        if (Hotkeys.isMoveBackward(nativeEvent)) {
          event.preventDefault();

          if (selection && index_es/* Range.isCollapsed */.e6.isCollapsed(selection)) {
            index_es/* Transforms.move */.YR.move(editor, {
              reverse: true
            });
          } else {
            index_es/* Transforms.collapse */.YR.collapse(editor, {
              edge: 'start'
            });
          }

          return;
        }

        if (Hotkeys.isMoveForward(nativeEvent)) {
          event.preventDefault();

          if (selection && index_es/* Range.isCollapsed */.e6.isCollapsed(selection)) {
            index_es/* Transforms.move */.YR.move(editor);
          } else {
            index_es/* Transforms.collapse */.YR.collapse(editor, {
              edge: 'end'
            });
          }

          return;
        }

        if (Hotkeys.isMoveWordBackward(nativeEvent)) {
          event.preventDefault();
          index_es/* Transforms.move */.YR.move(editor, {
            unit: 'word',
            reverse: true
          });
          return;
        }

        if (Hotkeys.isMoveWordForward(nativeEvent)) {
          event.preventDefault();
          index_es/* Transforms.move */.YR.move(editor, {
            unit: 'word'
          });
          return;
        } // COMPAT: Certain browsers don't support the `beforeinput` event, so we
        // fall back to guessing at the input intention for hotkeys.
        // COMPAT: In iOS, some of these hotkeys are handled in the


        if (!HAS_BEFORE_INPUT_SUPPORT) {
          // We don't have a core behavior for these, but they change the
          // DOM if we don't prevent them, so we have to.
          if (Hotkeys.isBold(nativeEvent) || Hotkeys.isItalic(nativeEvent) || Hotkeys.isTransposeCharacter(nativeEvent)) {
            event.preventDefault();
            return;
          }

          if (Hotkeys.isSplitBlock(nativeEvent)) {
            event.preventDefault();
            index_es/* Editor.insertBreak */.ML.insertBreak(editor);
            return;
          }

          if (Hotkeys.isDeleteBackward(nativeEvent)) {
            event.preventDefault();

            if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
              index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
            } else {
              index_es/* Editor.deleteBackward */.ML.deleteBackward(editor);
            }

            return;
          }

          if (Hotkeys.isDeleteForward(nativeEvent)) {
            event.preventDefault();

            if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
              index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
            } else {
              index_es/* Editor.deleteForward */.ML.deleteForward(editor);
            }

            return;
          }

          if (Hotkeys.isDeleteLineBackward(nativeEvent)) {
            event.preventDefault();

            if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
              index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
            } else {
              index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
                unit: 'line'
              });
            }

            return;
          }

          if (Hotkeys.isDeleteLineForward(nativeEvent)) {
            event.preventDefault();

            if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
              index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
            } else {
              index_es/* Editor.deleteForward */.ML.deleteForward(editor, {
                unit: 'line'
              });
            }

            return;
          }

          if (Hotkeys.isDeleteWordBackward(nativeEvent)) {
            event.preventDefault();

            if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
              index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
            } else {
              index_es/* Editor.deleteBackward */.ML.deleteBackward(editor, {
                unit: 'word'
              });
            }

            return;
          }

          if (Hotkeys.isDeleteWordForward(nativeEvent)) {
            event.preventDefault();

            if (selection && index_es/* Range.isExpanded */.e6.isExpanded(selection)) {
              index_es/* Editor.deleteFragment */.ML.deleteFragment(editor);
            } else {
              index_es/* Editor.deleteForward */.ML.deleteForward(editor, {
                unit: 'word'
              });
            }

            return;
          }
        }
      }
    }, [readOnly, attributes.onKeyDown]),
    onPaste: (0,react.useCallback)(event => {
      // COMPAT: Certain browsers don't support the `beforeinput` event, so we
      // fall back to React's `onPaste` here instead.
      // COMPAT: Firefox, Chrome and Safari are not emitting `beforeinput` events
      // when "paste without formatting" option is used.
      // This unfortunately needs to be handled with paste events instead.
      if (hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onPaste) && (!HAS_BEFORE_INPUT_SUPPORT || isPlainTextOnlyPaste(event.nativeEvent)) && !readOnly) {
        event.preventDefault();
        ReactEditor.insertData(editor, event.clipboardData);
      }
    }, [readOnly, attributes.onPaste])
  }), /*#__PURE__*/react.createElement(Children, {
    decorate: decorate,
    decorations: decorations,
    node: editor,
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    selection: editor.selection
  })));
};
/**
 * A default memoized decorate function.
 */

var defaultDecorate = () => [];
/**
 * Check if the target is in the editor.
 */


var hasTarget = (editor, target) => {
  return isDOMNode(target) && ReactEditor.hasDOMNode(editor, target);
};
/**
 * Check if the target is editable and in the editor.
 */


var hasEditableTarget = (editor, target) => {
  return isDOMNode(target) && ReactEditor.hasDOMNode(editor, target, {
    editable: true
  });
};
/**
 * Check if the target is inside void and in the editor.
 */


var isTargetInsideVoid = (editor, target) => {
  var slateNode = hasTarget(editor, target) && ReactEditor.toSlateNode(editor, target);
  return index_es/* Editor.isVoid */.ML.isVoid(editor, slateNode);
};
/**
 * Check if an event is overrided by a handler.
 */


var isEventHandled = (event, handler) => {
  if (!handler) {
    return false;
  }

  handler(event);
  return event.isDefaultPrevented() || event.isPropagationStopped();
};
/**
 * Check if a DOM event is overrided by a handler.
 */


var isDOMEventHandled = (event, handler) => {
  if (!handler) {
    return false;
  }

  handler(event);
  return event.defaultPrevented;
};

/**
 * An auto-incrementing identifier for keys.
 */
var index_es_n = 0;
/**
 * A class that keeps track of a key string. We use a full class here because we
 * want to be able to use them as keys in `WeakMap` objects.
 */

class Key {
  constructor() {
    this.id = "".concat(index_es_n++);
  }

}

var ReactEditor = {
  /**
   * Return the host window of the current editor.
   */
  getWindow(editor) {
    var window = EDITOR_TO_WINDOW.get(editor);

    if (!window) {
      throw new Error('Unable to find a host window element for this editor');
    }

    return window;
  },

  /**
   * Find a key for a Slate node.
   */
  findKey(editor, node) {
    var key = NODE_TO_KEY.get(node);

    if (!key) {
      key = new Key();
      NODE_TO_KEY.set(node, key);
    }

    return key;
  },

  /**
   * Find the path of Slate node.
   */
  findPath(editor, node) {
    var path = [];
    var child = node;

    while (true) {
      var parent = NODE_TO_PARENT.get(child);

      if (parent == null) {
        if (index_es/* Editor.isEditor */.ML.isEditor(child)) {
          return path;
        } else {
          break;
        }
      }

      var i = NODE_TO_INDEX.get(child);

      if (i == null) {
        break;
      }

      path.unshift(i);
      child = parent;
    }

    throw new Error("Unable to find the path for Slate node: ".concat(JSON.stringify(node)));
  },

  /**
   * Check if the editor is focused.
   */
  isFocused(editor) {
    return !!IS_FOCUSED.get(editor);
  },

  /**
   * Check if the editor is in read-only mode.
   */
  isReadOnly(editor) {
    return !!IS_READ_ONLY.get(editor);
  },

  /**
   * Blur the editor.
   */
  blur(editor) {
    var el = ReactEditor.toDOMNode(editor, editor);
    IS_FOCUSED.set(editor, false);
    var window = ReactEditor.getWindow(editor);

    if (window.document.activeElement === el) {
      el.blur();
    }
  },

  /**
   * Focus the editor.
   */
  focus(editor) {
    var el = ReactEditor.toDOMNode(editor, editor);
    IS_FOCUSED.set(editor, true);
    var window = ReactEditor.getWindow(editor);

    if (window.document.activeElement !== el) {
      el.focus({
        preventScroll: true
      });
    }
  },

  /**
   * Deselect the editor.
   */
  deselect(editor) {
    var {
      selection
    } = editor;
    var window = ReactEditor.getWindow(editor);
    var domSelection = window.getSelection();

    if (domSelection && domSelection.rangeCount > 0) {
      domSelection.removeAllRanges();
    }

    if (selection) {
      index_es/* Transforms.deselect */.YR.deselect(editor);
    }
  },

  /**
   * Check if a DOM node is within the editor.
   */
  hasDOMNode(editor, target) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      editable = false
    } = options;
    var editorEl = ReactEditor.toDOMNode(editor, editor);
    var targetEl; // COMPAT: In Firefox, reading `target.nodeType` will throw an error if
    // target is originating from an internal "restricted" element (e.g. a
    // stepper arrow on a number input). (2018/05/04)
    // https://github.com/ianstormtaylor/slate/issues/1819

    try {
      targetEl = isDOMElement(target) ? target : target.parentElement;
    } catch (err) {
      if (!err.message.includes('Permission denied to access property "nodeType"')) {
        throw err;
      }
    }

    if (!targetEl) {
      return false;
    }

    return targetEl.closest("[data-slate-editor]") === editorEl && (!editable || targetEl.isContentEditable || !!targetEl.getAttribute('data-slate-zero-width'));
  },

  /**
   * Insert data from a `DataTransfer` into the editor.
   */
  insertData(editor, data) {
    editor.insertData(data);
  },

  /**
   * Sets data from the currently selected fragment on a `DataTransfer`.
   */
  setFragmentData(editor, data) {
    editor.setFragmentData(data);
  },

  /**
   * Find the native DOM element from a Slate node.
   */
  toDOMNode(editor, node) {
    var domNode = index_es/* Editor.isEditor */.ML.isEditor(node) ? EDITOR_TO_ELEMENT.get(editor) : KEY_TO_ELEMENT.get(ReactEditor.findKey(editor, node));

    if (!domNode) {
      throw new Error("Cannot resolve a DOM node from Slate node: ".concat(JSON.stringify(node)));
    }

    return domNode;
  },

  /**
   * Find a native DOM selection point from a Slate point.
   */
  toDOMPoint(editor, point) {
    var [node] = index_es/* Editor.node */.ML.node(editor, point.path);
    var el = ReactEditor.toDOMNode(editor, node);
    var domPoint; // If we're inside a void node, force the offset to 0, otherwise the zero
    // width spacing character will result in an incorrect offset of 1

    if (index_es/* Editor.void */.ML["void"](editor, {
      at: point
    })) {
      point = {
        path: point.path,
        offset: 0
      };
    } // For each leaf, we need to isolate its content, which means filtering
    // to its direct text and zero-width spans. (We have to filter out any
    // other siblings that may have been rendered alongside them.)


    var selector = "[data-slate-string], [data-slate-zero-width]";
    var texts = Array.from(el.querySelectorAll(selector));
    var start = 0;

    for (var text of texts) {
      var domNode = text.childNodes[0];

      if (domNode == null || domNode.textContent == null) {
        continue;
      }

      var {
        length
      } = domNode.textContent;
      var attr = text.getAttribute('data-slate-length');
      var trueLength = attr == null ? length : parseInt(attr, 10);
      var end = start + trueLength;

      if (point.offset <= end) {
        var offset = Math.min(length, Math.max(0, point.offset - start));
        domPoint = [domNode, offset];
        break;
      }

      start = end;
    }

    if (!domPoint) {
      throw new Error("Cannot resolve a DOM point from Slate point: ".concat(JSON.stringify(point)));
    }

    return domPoint;
  },

  /**
   * Find a native DOM range from a Slate `range`.
   *
   * Notice: the returned range will always be ordinal regardless of the direction of Slate `range` due to DOM API limit.
   *
   * there is no way to create a reverse DOM Range using Range.setStart/setEnd
   * according to https://dom.spec.whatwg.org/#concept-range-bp-set.
   */
  toDOMRange(editor, range) {
    var {
      anchor,
      focus
    } = range;
    var isBackward = index_es/* Range.isBackward */.e6.isBackward(range);
    var domAnchor = ReactEditor.toDOMPoint(editor, anchor);
    var domFocus = index_es/* Range.isCollapsed */.e6.isCollapsed(range) ? domAnchor : ReactEditor.toDOMPoint(editor, focus);
    var window = ReactEditor.getWindow(editor);
    var domRange = window.document.createRange();
    var [startNode, startOffset] = isBackward ? domFocus : domAnchor;
    var [endNode, endOffset] = isBackward ? domAnchor : domFocus; // A slate Point at zero-width Leaf always has an offset of 0 but a native DOM selection at
    // zero-width node has an offset of 1 so we have to check if we are in a zero-width node and
    // adjust the offset accordingly.

    var startEl = isDOMElement(startNode) ? startNode : startNode.parentElement;
    var isStartAtZeroWidth = !!startEl.getAttribute('data-slate-zero-width');
    var endEl = isDOMElement(endNode) ? endNode : endNode.parentElement;
    var isEndAtZeroWidth = !!endEl.getAttribute('data-slate-zero-width');
    domRange.setStart(startNode, isStartAtZeroWidth ? 1 : startOffset);
    domRange.setEnd(endNode, isEndAtZeroWidth ? 1 : endOffset);
    return domRange;
  },

  /**
   * Find a Slate node from a native DOM `element`.
   */
  toSlateNode(editor, domNode) {
    var domEl = isDOMElement(domNode) ? domNode : domNode.parentElement;

    if (domEl && !domEl.hasAttribute('data-slate-node')) {
      domEl = domEl.closest("[data-slate-node]");
    }

    var node = domEl ? ELEMENT_TO_NODE.get(domEl) : null;

    if (!node) {
      throw new Error("Cannot resolve a Slate node from DOM node: ".concat(domEl));
    }

    return node;
  },

  /**
   * Get the target range from a DOM `event`.
   */
  findEventRange(editor, event) {
    if ('nativeEvent' in event) {
      event = event.nativeEvent;
    }

    var {
      clientX: x,
      clientY: y,
      target
    } = event;

    if (x == null || y == null) {
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
    }

    var node = ReactEditor.toSlateNode(editor, event.target);
    var path = ReactEditor.findPath(editor, node); // If the drop target is inside a void node, move it into either the
    // next or previous node, depending on which side the `x` and `y`
    // coordinates are closest to.

    if (index_es/* Editor.isVoid */.ML.isVoid(editor, node)) {
      var rect = target.getBoundingClientRect();
      var isPrev = editor.isInline(node) ? x - rect.left < rect.left + rect.width - x : y - rect.top < rect.top + rect.height - y;
      var edge = index_es/* Editor.point */.ML.point(editor, path, {
        edge: isPrev ? 'start' : 'end'
      });
      var point = isPrev ? index_es/* Editor.before */.ML.before(editor, edge) : index_es/* Editor.after */.ML.after(editor, edge);

      if (point) {
        var _range = index_es/* Editor.range */.ML.range(editor, point);

        return _range;
      }
    } // Else resolve a range from the caret position where the drop occured.


    var domRange;
    var {
      document
    } = window; // COMPAT: In Firefox, `caretRangeFromPoint` doesn't exist. (2016/07/25)

    if (document.caretRangeFromPoint) {
      domRange = document.caretRangeFromPoint(x, y);
    } else {
      var position = document.caretPositionFromPoint(x, y);

      if (position) {
        domRange = document.createRange();
        domRange.setStart(position.offsetNode, position.offset);
        domRange.setEnd(position.offsetNode, position.offset);
      }
    }

    if (!domRange) {
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
    } // Resolve a Slate range from the DOM range.


    var range = ReactEditor.toSlateRange(editor, domRange);
    return range;
  },

  /**
   * Find a Slate point from a DOM selection's `domNode` and `domOffset`.
   */
  toSlatePoint(editor, domPoint) {
    var [nearestNode, nearestOffset] = normalizeDOMPoint(domPoint);
    var parentNode = nearestNode.parentNode;
    var textNode = null;
    var offset = 0;

    if (parentNode) {
      var voidNode = parentNode.closest('[data-slate-void="true"]');
      var leafNode = parentNode.closest('[data-slate-leaf]');
      var domNode = null; // Calculate how far into the text node the `nearestNode` is, so that we
      // can determine what the offset relative to the text node is.

      if (leafNode) {
        textNode = leafNode.closest('[data-slate-node="text"]');

        var _window = ReactEditor.getWindow(editor);

        var range = _window.document.createRange();

        range.setStart(textNode, 0);
        range.setEnd(nearestNode, nearestOffset);
        var contents = range.cloneContents();
        var removals = [...contents.querySelectorAll('[data-slate-zero-width]'), ...contents.querySelectorAll('[contenteditable=false]')];
        removals.forEach(el => {
          el.parentNode.removeChild(el);
        }); // COMPAT: Edge has a bug where Range.prototype.toString() will
        // convert \n into \r\n. The bug causes a loop when slate-react
        // attempts to reposition its cursor to match the native position. Use
        // textContent.length instead.
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10291116/

        offset = contents.textContent.length;
        domNode = textNode;
      } else if (voidNode) {
        // For void nodes, the element with the offset key will be a cousin, not an
        // ancestor, so find it by going down from the nearest void parent.
        leafNode = voidNode.querySelector('[data-slate-leaf]');
        textNode = leafNode.closest('[data-slate-node="text"]');
        domNode = leafNode;
        offset = domNode.textContent.length;
      } // COMPAT: If the parent node is a Slate zero-width space, editor is
      // because the text node should have no characters. However, during IME
      // composition the ASCII characters will be prepended to the zero-width
      // space, so subtract 1 from the offset to account for the zero-width
      // space character.


      if (domNode && offset === domNode.textContent.length && parentNode.hasAttribute('data-slate-zero-width')) {
        offset--;
      }
    }

    if (!textNode) {
      throw new Error("Cannot resolve a Slate point from DOM point: ".concat(domPoint));
    } // COMPAT: If someone is clicking from one Slate editor into another,
    // the select event fires twice, once for the old editor's `element`
    // first, and then afterwards for the correct `element`. (2017/03/03)


    var slateNode = ReactEditor.toSlateNode(editor, textNode);
    var path = ReactEditor.findPath(editor, slateNode);
    return {
      path,
      offset
    };
  },

  /**
   * Find a Slate range from a DOM range or selection.
   */
  toSlateRange(editor, domRange) {
    var el = isDOMSelection(domRange) ? domRange.anchorNode : domRange.startContainer;
    var anchorNode;
    var anchorOffset;
    var focusNode;
    var focusOffset;
    var isCollapsed;

    if (el) {
      if (isDOMSelection(domRange)) {
        anchorNode = domRange.anchorNode;
        anchorOffset = domRange.anchorOffset;
        focusNode = domRange.focusNode;
        focusOffset = domRange.focusOffset;
        isCollapsed = domRange.isCollapsed;
      } else {
        anchorNode = domRange.startContainer;
        anchorOffset = domRange.startOffset;
        focusNode = domRange.endContainer;
        focusOffset = domRange.endOffset;
        isCollapsed = domRange.collapsed;
      }
    }

    if (anchorNode == null || focusNode == null || anchorOffset == null || focusOffset == null) {
      throw new Error("Cannot resolve a Slate range from DOM range: ".concat(domRange));
    }

    var anchor = ReactEditor.toSlatePoint(editor, [anchorNode, anchorOffset]);
    var focus = isCollapsed ? anchor : ReactEditor.toSlatePoint(editor, [focusNode, focusOffset]);
    return {
      anchor,
      focus
    };
  }

};

/**
 * A React context for sharing the `focused` state of the editor.
 */

var FocusedContext = /*#__PURE__*/(0,react.createContext)(false);
/**
 * Get the current `focused` state of the editor.
 */

var useFocused = () => {
  return (0,react.useContext)(FocusedContext);
};

/**
 * A wrapper around the provider to handle `onChange` events, because the editor
 * is a mutable singleton so it won't ever register as "changed" otherwise.
 */

var Slate = props => {
  var {
    editor,
    children,
    onChange,
    value
  } = props,
      rest = _objectWithoutProperties(props, ["editor", "children", "onChange", "value"]);

  var [key, setKey] = (0,react.useState)(0);
  var context = (0,react.useMemo)(() => {
    editor.children = value;
    Object.assign(editor, rest);
    return [editor];
  }, [key, value, ...Object.values(rest)]);
  var onContextChange = (0,react.useCallback)(() => {
    onChange(editor.children);
    setKey(key + 1);
  }, [key, onChange]);
  EDITOR_TO_ON_CHANGE.set(editor, onContextChange);
  (0,react.useEffect)(() => {
    return () => {
      EDITOR_TO_ON_CHANGE.set(editor, () => {});
    };
  }, []);
  return /*#__PURE__*/react.createElement(SlateContext.Provider, {
    value: context
  }, /*#__PURE__*/react.createElement(EditorContext.Provider, {
    value: editor
  }, /*#__PURE__*/react.createElement(FocusedContext.Provider, {
    value: ReactEditor.isFocused(editor)
  }, children)));
};

/**
 * Get the current editor object from the React context.
 * @deprecated Use useSlateStatic instead.
 */

var useEditor = () => {
  var editor = useContext(EditorContext);

  if (!editor) {
    throw new Error("The `useEditor` hook must be used inside the <Slate> component's context.");
  }

  return editor;
};

/**
 * `withReact` adds React and DOM specific behaviors to the editor.
 *
 * If you are using TypeScript, you must extend Slate's CustomTypes to use
 * this plugin.
 *
 * See https://docs.slatejs.org/concepts/11-typescript to learn how.
 */

var withReact = editor => {
  var e = editor;
  var {
    apply,
    onChange
  } = e;

  e.apply = op => {
    var matches = [];

    switch (op.type) {
      case 'insert_text':
      case 'remove_text':
      case 'set_node':
        {
          for (var [node, path] of index_es/* Editor.levels */.ML.levels(e, {
            at: op.path
          })) {
            var key = ReactEditor.findKey(e, node);
            matches.push([path, key]);
          }

          break;
        }

      case 'insert_node':
      case 'remove_node':
      case 'merge_node':
      case 'split_node':
        {
          for (var [_node, _path] of index_es/* Editor.levels */.ML.levels(e, {
            at: index_es/* Path.parent */.y$.parent(op.path)
          })) {
            var _key = ReactEditor.findKey(e, _node);

            matches.push([_path, _key]);
          }

          break;
        }
    }

    apply(op);

    for (var [_path2, _key2] of matches) {
      var [_node2] = index_es/* Editor.node */.ML.node(e, _path2);
      NODE_TO_KEY.set(_node2, _key2);
    }
  };

  e.setFragmentData = data => {
    var {
      selection
    } = e;

    if (!selection) {
      return;
    }

    var [start, end] = index_es/* Range.edges */.e6.edges(selection);
    var startVoid = index_es/* Editor.void */.ML["void"](e, {
      at: start.path
    });
    var endVoid = index_es/* Editor.void */.ML["void"](e, {
      at: end.path
    });

    if (index_es/* Range.isCollapsed */.e6.isCollapsed(selection) && !startVoid) {
      return;
    } // Create a fake selection so that we can add a Base64-encoded copy of the
    // fragment to the HTML, to decode on future pastes.


    var domRange = ReactEditor.toDOMRange(e, selection);
    var contents = domRange.cloneContents();
    var attach = contents.childNodes[0]; // Make sure attach is non-empty, since empty nodes will not get copied.

    contents.childNodes.forEach(node => {
      if (node.textContent && node.textContent.trim() !== '') {
        attach = node;
      }
    }); // COMPAT: If the end node is a void node, we need to move the end of the
    // range from the void node's spacer span, to the end of the void node's
    // content, since the spacer is before void's content in the DOM.

    if (endVoid) {
      var [voidNode] = endVoid;
      var r = domRange.cloneRange();
      var domNode = ReactEditor.toDOMNode(e, voidNode);
      r.setEndAfter(domNode);
      contents = r.cloneContents();
    } // COMPAT: If the start node is a void node, we need to attach the encoded
    // fragment to the void node's content node instead of the spacer, because
    // attaching it to empty `<div>/<span>` nodes will end up having it erased by
    // most browsers. (2018/04/27)


    if (startVoid) {
      attach = contents.querySelector('[data-slate-spacer]');
    } // Remove any zero-width space spans from the cloned DOM so that they don't
    // show up elsewhere when pasted.


    Array.from(contents.querySelectorAll('[data-slate-zero-width]')).forEach(zw => {
      var isNewline = zw.getAttribute('data-slate-zero-width') === 'n';
      zw.textContent = isNewline ? '\n' : '';
    }); // Set a `data-slate-fragment` attribute on a non-empty node, so it shows up
    // in the HTML, and can be used for intra-Slate pasting. If it's a text
    // node, wrap it in a `<span>` so we have something to set an attribute on.

    if (isDOMText(attach)) {
      var span = document.createElement('span'); // COMPAT: In Chrome and Safari, if we don't add the `white-space` style
      // then leading and trailing spaces will be ignored. (2017/09/21)

      span.style.whiteSpace = 'pre';
      span.appendChild(attach);
      contents.appendChild(span);
      attach = span;
    }

    var fragment = e.getFragment();
    var string = JSON.stringify(fragment);
    var encoded = window.btoa(encodeURIComponent(string));
    attach.setAttribute('data-slate-fragment', encoded);
    data.setData('application/x-slate-fragment', encoded); // Add the content to a <div> so that we can get its inner HTML.

    var div = document.createElement('div');
    div.appendChild(contents);
    div.setAttribute('hidden', 'true');
    document.body.appendChild(div);
    data.setData('text/html', div.innerHTML);
    data.setData('text/plain', getPlainText(div));
    document.body.removeChild(div);
  };

  e.insertData = data => {
    var fragment = data.getData('application/x-slate-fragment');

    if (fragment) {
      var decoded = decodeURIComponent(window.atob(fragment));
      var parsed = JSON.parse(decoded);
      e.insertFragment(parsed);
      return;
    }

    var text = data.getData('text/plain');

    if (text) {
      var lines = text.split(/\r\n|\r|\n/);
      var split = false;

      for (var line of lines) {
        if (split) {
          index_es/* Transforms.splitNodes */.YR.splitNodes(e, {
            always: true
          });
        }

        e.insertText(line);
        split = true;
      }
    }
  };

  e.onChange = () => {
    // COMPAT: React doesn't batch `setState` hook calls, which means that the
    // children and selection can get out of sync for one render pass. So we
    // have to use this unstable API to ensure it batches them. (2019/12/03)
    // https://github.com/facebook/react/issues/14259#issuecomment-439702367
    react_dom.unstable_batchedUpdates(() => {
      var onContextChange = EDITOR_TO_ON_CHANGE.get(e);

      if (onContextChange) {
        onContextChange();
      }

      onChange();
    });
  };

  return e;
};


//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ 17249:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

/**
 * Constants.
 */

var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);

var MODIFIERS = {
  alt: 'altKey',
  control: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};

var ALIASES = {
  add: '+',
  break: 'pause',
  cmd: 'meta',
  command: 'meta',
  ctl: 'control',
  ctrl: 'control',
  del: 'delete',
  down: 'arrowdown',
  esc: 'escape',
  ins: 'insert',
  left: 'arrowleft',
  mod: IS_MAC ? 'meta' : 'control',
  opt: 'alt',
  option: 'alt',
  return: 'enter',
  right: 'arrowright',
  space: ' ',
  spacebar: ' ',
  up: 'arrowup',
  win: 'meta',
  windows: 'meta'
};

var CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  ' ': 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  '\'': 222
};

for (var f = 1; f < 20; f++) {
  CODES['f' + f] = 111 + f;
}

/**
 * Is hotkey?
 */

function isHotkey(hotkey, options, event) {
  if (options && !('byKey' in options)) {
    event = options;
    options = null;
  }

  if (!Array.isArray(hotkey)) {
    hotkey = [hotkey];
  }

  var array = hotkey.map(function (string) {
    return parseHotkey(string, options);
  });
  var check = function check(e) {
    return array.some(function (object) {
      return compareHotkey(object, e);
    });
  };
  var ret = event == null ? check : check(event);
  return ret;
}

function isCodeHotkey(hotkey, event) {
  return isHotkey(hotkey, event);
}

function isKeyHotkey(hotkey, event) {
  return isHotkey(hotkey, { byKey: true }, event);
}

/**
 * Parse.
 */

function parseHotkey(hotkey, options) {
  var byKey = options && options.byKey;
  var ret = {};

  // Special case to handle the `+` key since we use it as a separator.
  hotkey = hotkey.replace('++', '+add');
  var values = hotkey.split('+');
  var length = values.length;

  // Ensure that all the modifiers are set to false unless the hotkey has them.

  for (var k in MODIFIERS) {
    ret[MODIFIERS[k]] = false;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;

      var optional = value.endsWith('?') && value.length > 1;

      if (optional) {
        value = value.slice(0, -1);
      }

      var name = toKeyName(value);
      var modifier = MODIFIERS[name];

      if (length === 1 || !modifier) {
        if (byKey) {
          ret.key = name;
        } else {
          ret.which = toKeyCode(value);
        }
      }

      if (modifier) {
        ret[modifier] = optional ? null : true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
}

/**
 * Compare.
 */

function compareHotkey(object, event) {
  for (var key in object) {
    var expected = object[key];
    var actual = void 0;

    if (expected == null) {
      continue;
    }

    if (key === 'key' && event.key != null) {
      actual = event.key.toLowerCase();
    } else if (key === 'which') {
      actual = expected === 91 && event.which === 93 ? 91 : event.which;
    } else {
      actual = event[key];
    }

    if (actual == null && expected === false) {
      continue;
    }

    if (actual !== expected) {
      return false;
    }
  }

  return true;
}

/**
 * Utils.
 */

function toKeyCode(name) {
  name = toKeyName(name);
  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
  return code;
}

function toKeyName(name) {
  name = name.toLowerCase();
  name = ALIASES[name] || name;
  return name;
}

/**
 * Export.
 */

__webpack_unused_export__ = isHotkey;
__webpack_unused_export__ = isHotkey;
__webpack_unused_export__ = isCodeHotkey;
exports.TB = isKeyHotkey;
__webpack_unused_export__ = parseHotkey;
__webpack_unused_export__ = compareHotkey;
__webpack_unused_export__ = toKeyCode;
__webpack_unused_export__ = toKeyName;

/***/ }),

/***/ 203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E9": function() { return /* binding */ Point; },
/* harmony export */   "Jh": function() { return /* binding */ createEditor; },
/* harmony export */   "ML": function() { return /* binding */ Editor; },
/* harmony export */   "NB": function() { return /* binding */ Node; },
/* harmony export */   "OX": function() { return /* binding */ Operation; },
/* harmony export */   "W_": function() { return /* binding */ Element; },
/* harmony export */   "YR": function() { return /* binding */ Transforms; },
/* harmony export */   "e6": function() { return /* binding */ Range; },
/* harmony export */   "xv": function() { return /* binding */ Text; },
/* harmony export */   "y$": function() { return /* binding */ Path; }
/* harmony export */ });
/* unused harmony exports Location, PathRef, PointRef, RangeRef, Span */
/* harmony import */ var is_plain_object__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66439);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76665);



function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DIRTY_PATHS = new WeakMap();
var DIRTY_PATH_KEYS = new WeakMap();
var FLUSHING = new WeakMap();
var NORMALIZING = new WeakMap();
var PATH_REFS = new WeakMap();
var POINT_REFS = new WeakMap();
var RANGE_REFS = new WeakMap();

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Create a new Slate `Editor` object.
 */

var createEditor = () => {
  var editor = {
    children: [],
    operations: [],
    selection: null,
    marks: null,
    isInline: () => false,
    isVoid: () => false,
    onChange: () => {},
    apply: op => {
      for (var ref of Editor.pathRefs(editor)) {
        PathRef.transform(ref, op);
      }

      for (var _ref of Editor.pointRefs(editor)) {
        PointRef.transform(_ref, op);
      }

      for (var _ref2 of Editor.rangeRefs(editor)) {
        RangeRef.transform(_ref2, op);
      }

      var oldDirtyPaths = DIRTY_PATHS.get(editor) || [];
      var oldDirtyPathKeys = DIRTY_PATH_KEYS.get(editor) || new Set();
      var dirtyPaths;
      var dirtyPathKeys;

      var add = path => {
        if (path) {
          var key = path.join(',');

          if (!dirtyPathKeys.has(key)) {
            dirtyPathKeys.add(key);
            dirtyPaths.push(path);
          }
        }
      };

      if (Path.operationCanTransformPath(op)) {
        dirtyPaths = [];
        dirtyPathKeys = new Set();

        for (var path of oldDirtyPaths) {
          var newPath = Path.transform(path, op);
          add(newPath);
        }
      } else {
        dirtyPaths = oldDirtyPaths;
        dirtyPathKeys = oldDirtyPathKeys;
      }

      var newDirtyPaths = getDirtyPaths(op);

      for (var _path of newDirtyPaths) {
        add(_path);
      }

      DIRTY_PATHS.set(editor, dirtyPaths);
      DIRTY_PATH_KEYS.set(editor, dirtyPathKeys);
      Transforms.transform(editor, op);
      editor.operations.push(op);
      Editor.normalize(editor); // Clear any formats applied to the cursor if the selection changes.

      if (op.type === 'set_selection') {
        editor.marks = null;
      }

      if (!FLUSHING.get(editor)) {
        FLUSHING.set(editor, true);
        Promise.resolve().then(() => {
          FLUSHING.set(editor, false);
          editor.onChange();
          editor.operations = [];
        });
      }
    },
    addMark: (key, value) => {
      var {
        selection
      } = editor;

      if (selection) {
        if (Range.isExpanded(selection)) {
          Transforms.setNodes(editor, {
            [key]: value
          }, {
            match: Text.isText,
            split: true
          });
        } else {
          var marks = _objectSpread$9(_objectSpread$9({}, Editor.marks(editor) || {}), {}, {
            [key]: value
          });

          editor.marks = marks;

          if (!FLUSHING.get(editor)) {
            editor.onChange();
          }
        }
      }
    },
    deleteBackward: unit => {
      var {
        selection
      } = editor;

      if (selection && Range.isCollapsed(selection)) {
        Transforms.delete(editor, {
          unit,
          reverse: true
        });
      }
    },
    deleteForward: unit => {
      var {
        selection
      } = editor;

      if (selection && Range.isCollapsed(selection)) {
        Transforms.delete(editor, {
          unit
        });
      }
    },
    deleteFragment: direction => {
      var {
        selection
      } = editor;

      if (selection && Range.isExpanded(selection)) {
        Transforms.delete(editor, {
          reverse: direction === 'backward'
        });
      }
    },
    getFragment: () => {
      var {
        selection
      } = editor;

      if (selection) {
        return Node.fragment(editor, selection);
      }

      return [];
    },
    insertBreak: () => {
      Transforms.splitNodes(editor, {
        always: true
      });
    },
    insertSoftBreak: () => {
      Transforms.splitNodes(editor, {
        always: true
      });
    },
    insertFragment: fragment => {
      Transforms.insertFragment(editor, fragment);
    },
    insertNode: node => {
      Transforms.insertNodes(editor, node);
    },
    insertText: text => {
      var {
        selection,
        marks
      } = editor;

      if (selection) {
        if (marks) {
          var node = _objectSpread$9({
            text
          }, marks);

          Transforms.insertNodes(editor, node);
        } else {
          Transforms.insertText(editor, text);
        }

        editor.marks = null;
      }
    },
    normalizeNode: entry => {
      var [node, path] = entry; // There are no core normalizations for text nodes.

      if (Text.isText(node)) {
        return;
      } // Ensure that block and inline nodes have at least one text child.


      if (Element.isElement(node) && node.children.length === 0) {
        var child = {
          text: ''
        };
        Transforms.insertNodes(editor, child, {
          at: path.concat(0),
          voids: true
        });
        return;
      } // Determine whether the node should have block or inline children.


      var shouldHaveInlines = Editor.isEditor(node) ? false : Element.isElement(node) && (editor.isInline(node) || node.children.length === 0 || Text.isText(node.children[0]) || editor.isInline(node.children[0])); // Since we'll be applying operations while iterating, keep track of an
      // index that accounts for any added/removed nodes.

      var n = 0;

      for (var i = 0; i < node.children.length; i++, n++) {
        var currentNode = Node.get(editor, path);
        if (Text.isText(currentNode)) continue;
        var _child = node.children[i];
        var prev = currentNode.children[n - 1];
        var isLast = i === node.children.length - 1;
        var isInlineOrText = Text.isText(_child) || Element.isElement(_child) && editor.isInline(_child); // Only allow block nodes in the top-level children and parent blocks
        // that only contain block nodes. Similarly, only allow inline nodes in
        // other inline nodes, or parent blocks that only contain inlines and
        // text.

        if (isInlineOrText !== shouldHaveInlines) {
          Transforms.removeNodes(editor, {
            at: path.concat(n),
            voids: true
          });
          n--;
        } else if (Element.isElement(_child)) {
          // Ensure that inline nodes are surrounded by text nodes.
          if (editor.isInline(_child)) {
            if (prev == null || !Text.isText(prev)) {
              var newChild = {
                text: ''
              };
              Transforms.insertNodes(editor, newChild, {
                at: path.concat(n),
                voids: true
              });
              n++;
            } else if (isLast) {
              var _newChild = {
                text: ''
              };
              Transforms.insertNodes(editor, _newChild, {
                at: path.concat(n + 1),
                voids: true
              });
              n++;
            }
          }
        } else {
          // Merge adjacent text nodes that are empty or match.
          if (prev != null && Text.isText(prev)) {
            if (Text.equals(_child, prev, {
              loose: true
            })) {
              Transforms.mergeNodes(editor, {
                at: path.concat(n),
                voids: true
              });
              n--;
            } else if (prev.text === '') {
              Transforms.removeNodes(editor, {
                at: path.concat(n - 1),
                voids: true
              });
              n--;
            } else if (_child.text === '') {
              Transforms.removeNodes(editor, {
                at: path.concat(n),
                voids: true
              });
              n--;
            }
          }
        }
      }
    },
    removeMark: key => {
      var {
        selection
      } = editor;

      if (selection) {
        if (Range.isExpanded(selection)) {
          Transforms.unsetNodes(editor, key, {
            match: Text.isText,
            split: true
          });
        } else {
          var marks = _objectSpread$9({}, Editor.marks(editor) || {});

          delete marks[key];
          editor.marks = marks;

          if (!FLUSHING.get(editor)) {
            editor.onChange();
          }
        }
      }
    }
  };
  return editor;
};
/**
 * Get the "dirty" paths generated from an operation.
 */

var getDirtyPaths = op => {
  switch (op.type) {
    case 'insert_text':
    case 'remove_text':
    case 'set_node':
      {
        var {
          path
        } = op;
        return Path.levels(path);
      }

    case 'insert_node':
      {
        var {
          node,
          path: _path2
        } = op;
        var levels = Path.levels(_path2);
        var descendants = Text.isText(node) ? [] : Array.from(Node.nodes(node), _ref3 => {
          var [, p] = _ref3;
          return _path2.concat(p);
        });
        return [...levels, ...descendants];
      }

    case 'merge_node':
      {
        var {
          path: _path3
        } = op;
        var ancestors = Path.ancestors(_path3);
        var previousPath = Path.previous(_path3);
        return [...ancestors, previousPath];
      }

    case 'move_node':
      {
        var {
          path: _path4,
          newPath
        } = op;

        if (Path.equals(_path4, newPath)) {
          return [];
        }

        var oldAncestors = [];
        var newAncestors = [];

        for (var ancestor of Path.ancestors(_path4)) {
          var p = Path.transform(ancestor, op);
          oldAncestors.push(p);
        }

        for (var _ancestor of Path.ancestors(newPath)) {
          var _p = Path.transform(_ancestor, op);

          newAncestors.push(_p);
        }

        var newParent = newAncestors[newAncestors.length - 1];
        var newIndex = newPath[newPath.length - 1];
        var resultPath = newParent.concat(newIndex);
        return [...oldAncestors, ...newAncestors, resultPath];
      }

    case 'remove_node':
      {
        var {
          path: _path5
        } = op;

        var _ancestors = Path.ancestors(_path5);

        return [..._ancestors];
      }

    case 'split_node':
      {
        var {
          path: _path6
        } = op;

        var _levels = Path.levels(_path6);

        var nextPath = Path.next(_path6);
        return [..._levels, nextPath];
      }

    default:
      {
        return [];
      }
  }
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

// Character (grapheme cluster) boundaries are determined according to
// the default grapheme cluster boundary specification, extended grapheme clusters variant[1].
//
// References:
//
// [1] https://www.unicode.org/reports/tr29/#Default_Grapheme_Cluster_Table
// [2] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakProperty.txt
// [3] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.html
// [4] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.txt

/**
 * Get the distance to the end of the first character in a string of text.
 */
var getCharacterDistance = function getCharacterDistance(str) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isLTR = !isRTL;
  var codepoints = isRTL ? codepointsIteratorRTL(str) : str;
  var left = CodepointType.None;
  var right = CodepointType.None;
  var distance = 0; // Evaluation of these conditions are deferred.

  var gb11 = null; // Is GB11 applicable?

  var gb12Or13 = null; // Is GB12 or GB13 applicable?

  for (var char of codepoints) {
    var code = char.codePointAt(0);
    if (!code) break;
    var type = getCodepointType(char, code);
    [left, right] = isLTR ? [right, type] : [type, left];

    if (intersects(left, CodepointType.ZWJ) && intersects(right, CodepointType.ExtPict)) {
      if (isLTR) {
        gb11 = endsWithEmojiZWJ(str.substring(0, distance));
      } else {
        gb11 = endsWithEmojiZWJ(str.substring(0, str.length - distance));
      }

      if (!gb11) break;
    }

    if (intersects(left, CodepointType.RI) && intersects(right, CodepointType.RI)) {
      if (gb12Or13 !== null) {
        gb12Or13 = !gb12Or13;
      } else {
        if (isLTR) {
          gb12Or13 = true;
        } else {
          gb12Or13 = endsWithOddNumberOfRIs(str.substring(0, str.length - distance));
        }
      }

      if (!gb12Or13) break;
    }

    if (left !== CodepointType.None && right !== CodepointType.None && isBoundaryPair(left, right)) {
      break;
    }

    distance += char.length;
  }

  return distance || 1;
};
var SPACE = /\s/;
var PUNCTUATION = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
var CHAMELEON = /['\u2018\u2019]/;
/**
 * Get the distance to the end of the first word in a string of text.
 */

var getWordDistance = function getWordDistance(text) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var dist = 0;
  var started = false;

  while (text.length > 0) {
    var charDist = getCharacterDistance(text, isRTL);
    var [char, remaining] = splitByCharacterDistance(text, charDist, isRTL);

    if (isWordCharacter(char, remaining, isRTL)) {
      started = true;
      dist += charDist;
    } else if (!started) {
      dist += charDist;
    } else {
      break;
    }

    text = remaining;
  }

  return dist;
};
/**
 * Split a string in two parts at a given distance starting from the end when
 * `isRTL` is set to `true`.
 */

var splitByCharacterDistance = (str, dist, isRTL) => {
  if (isRTL) {
    var at = str.length - dist;
    return [str.slice(at, str.length), str.slice(0, at)];
  }

  return [str.slice(0, dist), str.slice(dist)];
};
/**
 * Check if a character is a word character. The `remaining` argument is used
 * because sometimes you must read subsequent characters to truly determine it.
 */

var isWordCharacter = function isWordCharacter(char, remaining) {
  var isRTL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (SPACE.test(char)) {
    return false;
  } // Chameleons count as word characters as long as they're in a word, so
  // recurse to see if the next one is a word character or not.


  if (CHAMELEON.test(char)) {
    var charDist = getCharacterDistance(remaining, isRTL);
    var [nextChar, nextRemaining] = splitByCharacterDistance(remaining, charDist, isRTL);

    if (isWordCharacter(nextChar, nextRemaining, isRTL)) {
      return true;
    }
  }

  if (PUNCTUATION.test(char)) {
    return false;
  }

  return true;
};
/**
 * Iterate on codepoints from right to left.
 */


var codepointsIteratorRTL = function* codepointsIteratorRTL(str) {
  var end = str.length - 1;

  for (var i = 0; i < str.length; i++) {
    var char1 = str.charAt(end - i);

    if (isLowSurrogate(char1.charCodeAt(0))) {
      var char2 = str.charAt(end - i - 1);

      if (isHighSurrogate(char2.charCodeAt(0))) {
        yield char2 + char1;
        i++;
        continue;
      }
    }

    yield char1;
  }
};
/**
 * Is `charCode` a high surrogate.
 *
 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
 */

var isHighSurrogate = charCode => {
  return charCode >= 0xd800 && charCode <= 0xdbff;
};
/**
 * Is `charCode` a low surrogate.
 *
 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
 */


var isLowSurrogate = charCode => {
  return charCode >= 0xdc00 && charCode <= 0xdfff;
};

var CodepointType;

(function (CodepointType) {
  CodepointType[CodepointType["None"] = 0] = "None";
  CodepointType[CodepointType["Extend"] = 1] = "Extend";
  CodepointType[CodepointType["ZWJ"] = 2] = "ZWJ";
  CodepointType[CodepointType["RI"] = 4] = "RI";
  CodepointType[CodepointType["Prepend"] = 8] = "Prepend";
  CodepointType[CodepointType["SpacingMark"] = 16] = "SpacingMark";
  CodepointType[CodepointType["L"] = 32] = "L";
  CodepointType[CodepointType["V"] = 64] = "V";
  CodepointType[CodepointType["T"] = 128] = "T";
  CodepointType[CodepointType["LV"] = 256] = "LV";
  CodepointType[CodepointType["LVT"] = 512] = "LVT";
  CodepointType[CodepointType["ExtPict"] = 1024] = "ExtPict";
  CodepointType[CodepointType["Any"] = 2048] = "Any";
})(CodepointType || (CodepointType = {}));

var reExtend = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/;
var rePrepend = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/;
var reSpacingMark = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/;
var reL = /^[\u1100-\u115F\uA960-\uA97C]$/;
var reV = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/;
var reT = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/;
var reLV = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/;
var reLVT = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/;
var reExtPict = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/;

var getCodepointType = (char, code) => {
  var type = CodepointType.Any;

  if (char.search(reExtend) !== -1) {
    type |= CodepointType.Extend;
  }

  if (code === 0x200d) {
    type |= CodepointType.ZWJ;
  }

  if (code >= 0x1f1e6 && code <= 0x1f1ff) {
    type |= CodepointType.RI;
  }

  if (char.search(rePrepend) !== -1) {
    type |= CodepointType.Prepend;
  }

  if (char.search(reSpacingMark) !== -1) {
    type |= CodepointType.SpacingMark;
  }

  if (char.search(reL) !== -1) {
    type |= CodepointType.L;
  }

  if (char.search(reV) !== -1) {
    type |= CodepointType.V;
  }

  if (char.search(reT) !== -1) {
    type |= CodepointType.T;
  }

  if (char.search(reLV) !== -1) {
    type |= CodepointType.LV;
  }

  if (char.search(reLVT) !== -1) {
    type |= CodepointType.LVT;
  }

  if (char.search(reExtPict) !== -1) {
    type |= CodepointType.ExtPict;
  }

  return type;
};

function intersects(x, y) {
  return (x & y) !== 0;
}

var NonBoundaryPairs = [// GB6
[CodepointType.L, CodepointType.L | CodepointType.V | CodepointType.LV | CodepointType.LVT], // GB7
[CodepointType.LV | CodepointType.V, CodepointType.V | CodepointType.T], // GB8
[CodepointType.LVT | CodepointType.T, CodepointType.T], // GB9
[CodepointType.Any, CodepointType.Extend | CodepointType.ZWJ], // GB9a
[CodepointType.Any, CodepointType.SpacingMark], // GB9b
[CodepointType.Prepend, CodepointType.Any], // GB11
[CodepointType.ZWJ, CodepointType.ExtPict], // GB12 and GB13
[CodepointType.RI, CodepointType.RI]];

function isBoundaryPair(left, right) {
  return NonBoundaryPairs.findIndex(r => intersects(left, r[0]) && intersects(right, r[1])) === -1;
}

var endingEmojiZWJ = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/;

var endsWithEmojiZWJ = str => {
  return str.search(endingEmojiZWJ) !== -1;
};

var endingRIs = /(?:\uD83C[\uDDE6-\uDDFF])+$/g;

var endsWithOddNumberOfRIs = str => {
  var match = str.match(endingRIs);

  if (match === null) {
    return false;
  } else {
    // A RI is represented by a surrogate pair.
    var numRIs = match[0].length / 2;
    return numRIs % 2 === 1;
  }
};

/**
 * Shared the function with isElementType utility
 */

var isElement = value => {
  return (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value) && Node.isNodeList(value.children) && !Editor.isEditor(value);
};

var Element = {
  /**
   * Check if a value implements the 'Ancestor' interface.
   */
  isAncestor(value) {
    return (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value) && Node.isNodeList(value.children);
  },

  /**
   * Check if a value implements the `Element` interface.
   */
  isElement,

  /**
   * Check if a value is an array of `Element` objects.
   */
  isElementList(value) {
    return Array.isArray(value) && value.every(val => Element.isElement(val));
  },

  /**
   * Check if a set of props is a partial of Element.
   */
  isElementProps(props) {
    return props.children !== undefined;
  },

  /**
   * Check if a value implements the `Element` interface and has elementKey with selected value.
   * Default it check to `type` key value
   */
  isElementType: function isElementType(value, elementVal) {
    var elementKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'type';
    return isElement(value) && value[elementKey] === elementVal;
  },

  /**
   * Check if an element matches set of properties.
   *
   * Note: this checks custom properties, and it does not ensure that any
   * children are equivalent.
   */
  matches(element, props) {
    for (var key in props) {
      if (key === 'children') {
        continue;
      }

      if (element[key] !== props[key]) {
        return false;
      }
    }

    return true;
  }

};

var _excluded$4 = ["text"],
    _excluded2$3 = ["text"];

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var IS_EDITOR_CACHE = new WeakMap();
var Editor = {
  /**
   * Get the ancestor above a location in the document.
   */
  above(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      voids = false,
      mode = 'lowest',
      at = editor.selection,
      match
    } = options;

    if (!at) {
      return;
    }

    var path = Editor.path(editor, at);
    var reverse = mode === 'lowest';

    for (var [n, p] of Editor.levels(editor, {
      at: path,
      voids,
      match,
      reverse
    })) {
      if (!Text.isText(n) && !Path.equals(path, p)) {
        return [n, p];
      }
    }
  },

  /**
   * Add a custom property to the leaf text nodes in the current selection.
   *
   * If the selection is currently collapsed, the marks will be added to the
   * `editor.marks` property instead, and applied when text is inserted next.
   */
  addMark(editor, key, value) {
    editor.addMark(key, value);
  },

  /**
   * Get the point after a location.
   */
  after(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var anchor = Editor.point(editor, at, {
      edge: 'end'
    });
    var focus = Editor.end(editor, []);
    var range = {
      anchor,
      focus
    };
    var {
      distance = 1
    } = options;
    var d = 0;
    var target;

    for (var p of Editor.positions(editor, _objectSpread$8(_objectSpread$8({}, options), {}, {
      at: range
    }))) {
      if (d > distance) {
        break;
      }

      if (d !== 0) {
        target = p;
      }

      d++;
    }

    return target;
  },

  /**
   * Get the point before a location.
   */
  before(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var anchor = Editor.start(editor, []);
    var focus = Editor.point(editor, at, {
      edge: 'start'
    });
    var range = {
      anchor,
      focus
    };
    var {
      distance = 1
    } = options;
    var d = 0;
    var target;

    for (var p of Editor.positions(editor, _objectSpread$8(_objectSpread$8({}, options), {}, {
      at: range,
      reverse: true
    }))) {
      if (d > distance) {
        break;
      }

      if (d !== 0) {
        target = p;
      }

      d++;
    }

    return target;
  },

  /**
   * Delete content in the editor backward from the current selection.
   */
  deleteBackward(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      unit = 'character'
    } = options;
    editor.deleteBackward(unit);
  },

  /**
   * Delete content in the editor forward from the current selection.
   */
  deleteForward(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      unit = 'character'
    } = options;
    editor.deleteForward(unit);
  },

  /**
   * Delete the content in the current selection.
   */
  deleteFragment(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      direction = 'forward'
    } = options;
    editor.deleteFragment(direction);
  },

  /**
   * Get the start and end points of a location.
   */
  edges(editor, at) {
    return [Editor.start(editor, at), Editor.end(editor, at)];
  },

  /**
   * Get the end point of a location.
   */
  end(editor, at) {
    return Editor.point(editor, at, {
      edge: 'end'
    });
  },

  /**
   * Get the first node at a location.
   */
  first(editor, at) {
    var path = Editor.path(editor, at, {
      edge: 'start'
    });
    return Editor.node(editor, path);
  },

  /**
   * Get the fragment at a location.
   */
  fragment(editor, at) {
    var range = Editor.range(editor, at);
    var fragment = Node.fragment(editor, range);
    return fragment;
  },

  /**
   * Check if a node has block children.
   */
  hasBlocks(editor, element) {
    return element.children.some(n => Editor.isBlock(editor, n));
  },

  /**
   * Check if a node has inline and text children.
   */
  hasInlines(editor, element) {
    return element.children.some(n => Text.isText(n) || Editor.isInline(editor, n));
  },

  /**
   * Check if a node has text children.
   */
  hasTexts(editor, element) {
    return element.children.every(n => Text.isText(n));
  },

  /**
   * Insert a block break at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertBreak(editor) {
    editor.insertBreak();
  },

  /**
   * Insert a soft break at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertSoftBreak(editor) {
    editor.insertSoftBreak();
  },

  /**
   * Insert a fragment at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertFragment(editor, fragment) {
    editor.insertFragment(fragment);
  },

  /**
   * Insert a node at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertNode(editor, node) {
    editor.insertNode(node);
  },

  /**
   * Insert text at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertText(editor, text) {
    editor.insertText(text);
  },

  /**
   * Check if a value is a block `Element` object.
   */
  isBlock(editor, value) {
    return Element.isElement(value) && !editor.isInline(value);
  },

  /**
   * Check if a value is an `Editor` object.
   */
  isEditor(value) {
    if (!(0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value)) return false;
    var cachedIsEditor = IS_EDITOR_CACHE.get(value);

    if (cachedIsEditor !== undefined) {
      return cachedIsEditor;
    }

    var isEditor = typeof value.addMark === 'function' && typeof value.apply === 'function' && typeof value.deleteBackward === 'function' && typeof value.deleteForward === 'function' && typeof value.deleteFragment === 'function' && typeof value.insertBreak === 'function' && typeof value.insertSoftBreak === 'function' && typeof value.insertFragment === 'function' && typeof value.insertNode === 'function' && typeof value.insertText === 'function' && typeof value.isInline === 'function' && typeof value.isVoid === 'function' && typeof value.normalizeNode === 'function' && typeof value.onChange === 'function' && typeof value.removeMark === 'function' && (value.marks === null || (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value.marks)) && (value.selection === null || Range.isRange(value.selection)) && Node.isNodeList(value.children) && Operation.isOperationList(value.operations);
    IS_EDITOR_CACHE.set(value, isEditor);
    return isEditor;
  },

  /**
   * Check if a point is the end point of a location.
   */
  isEnd(editor, point, at) {
    var end = Editor.end(editor, at);
    return Point.equals(point, end);
  },

  /**
   * Check if a point is an edge of a location.
   */
  isEdge(editor, point, at) {
    return Editor.isStart(editor, point, at) || Editor.isEnd(editor, point, at);
  },

  /**
   * Check if an element is empty, accounting for void nodes.
   */
  isEmpty(editor, element) {
    var {
      children
    } = element;
    var [first] = children;
    return children.length === 0 || children.length === 1 && Text.isText(first) && first.text === '' && !editor.isVoid(element);
  },

  /**
   * Check if a value is an inline `Element` object.
   */
  isInline(editor, value) {
    return Element.isElement(value) && editor.isInline(value);
  },

  /**
   * Check if the editor is currently normalizing after each operation.
   */
  isNormalizing(editor) {
    var isNormalizing = NORMALIZING.get(editor);
    return isNormalizing === undefined ? true : isNormalizing;
  },

  /**
   * Check if a point is the start point of a location.
   */
  isStart(editor, point, at) {
    // PERF: If the offset isn't `0` we know it's not the start.
    if (point.offset !== 0) {
      return false;
    }

    var start = Editor.start(editor, at);
    return Point.equals(point, start);
  },

  /**
   * Check if a value is a void `Element` object.
   */
  isVoid(editor, value) {
    return Element.isElement(value) && editor.isVoid(value);
  },

  /**
   * Get the last node at a location.
   */
  last(editor, at) {
    var path = Editor.path(editor, at, {
      edge: 'end'
    });
    return Editor.node(editor, path);
  },

  /**
   * Get the leaf text node at a location.
   */
  leaf(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var path = Editor.path(editor, at, options);
    var node = Node.leaf(editor, path);
    return [node, path];
  },

  /**
   * Iterate through all of the levels at a location.
   */
  *levels(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      at = editor.selection,
      reverse = false,
      voids = false
    } = options;
    var {
      match
    } = options;

    if (match == null) {
      match = () => true;
    }

    if (!at) {
      return;
    }

    var levels = [];
    var path = Editor.path(editor, at);

    for (var [n, p] of Node.levels(editor, path)) {
      if (!match(n, p)) {
        continue;
      }

      levels.push([n, p]);

      if (!voids && Editor.isVoid(editor, n)) {
        break;
      }
    }

    if (reverse) {
      levels.reverse();
    }

    yield* levels;
  },

  /**
   * Get the marks that would be added to text at the current selection.
   */
  marks(editor) {
    var {
      marks,
      selection
    } = editor;

    if (!selection) {
      return null;
    }

    if (marks) {
      return marks;
    }

    if (Range.isExpanded(selection)) {
      var [match] = Editor.nodes(editor, {
        match: Text.isText
      });

      if (match) {
        var [_node] = match;

        var _rest = _objectWithoutProperties(_node, _excluded$4);

        return _rest;
      } else {
        return {};
      }
    }

    var {
      anchor
    } = selection;
    var {
      path
    } = anchor;
    var [node] = Editor.leaf(editor, path);

    if (anchor.offset === 0) {
      var prev = Editor.previous(editor, {
        at: path,
        match: Text.isText
      });
      var block = Editor.above(editor, {
        match: n => Editor.isBlock(editor, n)
      });

      if (prev && block) {
        var [prevNode, prevPath] = prev;
        var [, blockPath] = block;

        if (Path.isAncestor(blockPath, prevPath)) {
          node = prevNode;
        }
      }
    }

    var rest = _objectWithoutProperties(node, _excluded2$3);

    return rest;
  },

  /**
   * Get the matching node in the branch of the document after a location.
   */
  next(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      mode = 'lowest',
      voids = false
    } = options;
    var {
      match,
      at = editor.selection
    } = options;

    if (!at) {
      return;
    }

    var pointAfterLocation = Editor.after(editor, at, {
      voids
    });
    if (!pointAfterLocation) return;
    var [, to] = Editor.last(editor, []);
    var span = [pointAfterLocation.path, to];

    if (Path.isPath(at) && at.length === 0) {
      throw new Error("Cannot get the next node from the root node!");
    }

    if (match == null) {
      if (Path.isPath(at)) {
        var [parent] = Editor.parent(editor, at);

        match = n => parent.children.includes(n);
      } else {
        match = () => true;
      }
    }

    var [next] = Editor.nodes(editor, {
      at: span,
      match,
      mode,
      voids
    });
    return next;
  },

  /**
   * Get the node at a location.
   */
  node(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var path = Editor.path(editor, at, options);
    var node = Node.get(editor, path);
    return [node, path];
  },

  /**
   * Iterate through all of the nodes in the Editor.
   */
  *nodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      at = editor.selection,
      mode = 'all',
      universal = false,
      reverse = false,
      voids = false
    } = options;
    var {
      match
    } = options;

    if (!match) {
      match = () => true;
    }

    if (!at) {
      return;
    }

    var from;
    var to;

    if (Span.isSpan(at)) {
      from = at[0];
      to = at[1];
    } else {
      var first = Editor.path(editor, at, {
        edge: 'start'
      });
      var last = Editor.path(editor, at, {
        edge: 'end'
      });
      from = reverse ? last : first;
      to = reverse ? first : last;
    }

    var nodeEntries = Node.nodes(editor, {
      reverse,
      from,
      to,
      pass: _ref => {
        var [n] = _ref;
        return voids ? false : Editor.isVoid(editor, n);
      }
    });
    var matches = [];
    var hit;

    for (var [node, path] of nodeEntries) {
      var isLower = hit && Path.compare(path, hit[1]) === 0; // In highest mode any node lower than the last hit is not a match.

      if (mode === 'highest' && isLower) {
        continue;
      }

      if (!match(node, path)) {
        // If we've arrived at a leaf text node that is not lower than the last
        // hit, then we've found a branch that doesn't include a match, which
        // means the match is not universal.
        if (universal && !isLower && Text.isText(node)) {
          return;
        } else {
          continue;
        }
      } // If there's a match and it's lower than the last, update the hit.


      if (mode === 'lowest' && isLower) {
        hit = [node, path];
        continue;
      } // In lowest mode we emit the last hit, once it's guaranteed lowest.


      var emit = mode === 'lowest' ? hit : [node, path];

      if (emit) {
        if (universal) {
          matches.push(emit);
        } else {
          yield emit;
        }
      }

      hit = [node, path];
    } // Since lowest is always emitting one behind, catch up at the end.


    if (mode === 'lowest' && hit) {
      if (universal) {
        matches.push(hit);
      } else {
        yield hit;
      }
    } // Universal defers to ensure that the match occurs in every branch, so we
    // yield all of the matches after iterating.


    if (universal) {
      yield* matches;
    }
  },

  /**
   * Normalize any dirty objects in the editor.
   */
  normalize(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      force = false
    } = options;

    var getDirtyPaths = editor => {
      return DIRTY_PATHS.get(editor) || [];
    };

    var getDirtyPathKeys = editor => {
      return DIRTY_PATH_KEYS.get(editor) || new Set();
    };

    var popDirtyPath = editor => {
      var path = getDirtyPaths(editor).pop();
      var key = path.join(',');
      getDirtyPathKeys(editor).delete(key);
      return path;
    };

    if (!Editor.isNormalizing(editor)) {
      return;
    }

    if (force) {
      var allPaths = Array.from(Node.nodes(editor), _ref2 => {
        var [, p] = _ref2;
        return p;
      });
      var allPathKeys = new Set(allPaths.map(p => p.join(',')));
      DIRTY_PATHS.set(editor, allPaths);
      DIRTY_PATH_KEYS.set(editor, allPathKeys);
    }

    if (getDirtyPaths(editor).length === 0) {
      return;
    }

    Editor.withoutNormalizing(editor, () => {
      /*
        Fix dirty elements with no children.
        editor.normalizeNode() does fix this, but some normalization fixes also require it to work.
        Running an initial pass avoids the catch-22 race condition.
      */
      for (var dirtyPath of getDirtyPaths(editor)) {
        if (Node.has(editor, dirtyPath)) {
          var entry = Editor.node(editor, dirtyPath);
          var [node, _] = entry;
          /*
            The default normalizer inserts an empty text node in this scenario, but it can be customised.
            So there is some risk here.
                       As long as the normalizer only inserts child nodes for this case it is safe to do in any order;
            by definition adding children to an empty node can't cause other paths to change.
          */

          if (Element.isElement(node) && node.children.length === 0) {
            editor.normalizeNode(entry);
          }
        }
      }

      var max = getDirtyPaths(editor).length * 42; // HACK: better way?

      var m = 0;

      while (getDirtyPaths(editor).length !== 0) {
        if (m > max) {
          throw new Error("\n            Could not completely normalize the editor after ".concat(max, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state.\n          "));
        }

        var _dirtyPath = popDirtyPath(editor); // If the node doesn't exist in the tree, it does not need to be normalized.


        if (Node.has(editor, _dirtyPath)) {
          var _entry = Editor.node(editor, _dirtyPath);

          editor.normalizeNode(_entry);
        }

        m++;
      }
    });
  },

  /**
   * Get the parent node of a location.
   */
  parent(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var path = Editor.path(editor, at, options);
    var parentPath = Path.parent(path);
    var entry = Editor.node(editor, parentPath);
    return entry;
  },

  /**
   * Get the path of a location.
   */
  path(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      depth,
      edge
    } = options;

    if (Path.isPath(at)) {
      if (edge === 'start') {
        var [, firstPath] = Node.first(editor, at);
        at = firstPath;
      } else if (edge === 'end') {
        var [, lastPath] = Node.last(editor, at);
        at = lastPath;
      }
    }

    if (Range.isRange(at)) {
      if (edge === 'start') {
        at = Range.start(at);
      } else if (edge === 'end') {
        at = Range.end(at);
      } else {
        at = Path.common(at.anchor.path, at.focus.path);
      }
    }

    if (Point.isPoint(at)) {
      at = at.path;
    }

    if (depth != null) {
      at = at.slice(0, depth);
    }

    return at;
  },

  hasPath(editor, path) {
    return Node.has(editor, path);
  },

  /**
   * Create a mutable ref for a `Path` object, which will stay in sync as new
   * operations are applied to the editor.
   */
  pathRef(editor, path) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      affinity = 'forward'
    } = options;
    var ref = {
      current: path,
      affinity,

      unref() {
        var {
          current
        } = ref;
        var pathRefs = Editor.pathRefs(editor);
        pathRefs.delete(ref);
        ref.current = null;
        return current;
      }

    };
    var refs = Editor.pathRefs(editor);
    refs.add(ref);
    return ref;
  },

  /**
   * Get the set of currently tracked path refs of the editor.
   */
  pathRefs(editor) {
    var refs = PATH_REFS.get(editor);

    if (!refs) {
      refs = new Set();
      PATH_REFS.set(editor, refs);
    }

    return refs;
  },

  /**
   * Get the start or end point of a location.
   */
  point(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      edge = 'start'
    } = options;

    if (Path.isPath(at)) {
      var path;

      if (edge === 'end') {
        var [, lastPath] = Node.last(editor, at);
        path = lastPath;
      } else {
        var [, firstPath] = Node.first(editor, at);
        path = firstPath;
      }

      var node = Node.get(editor, path);

      if (!Text.isText(node)) {
        throw new Error("Cannot get the ".concat(edge, " point in the node at path [").concat(at, "] because it has no ").concat(edge, " text node."));
      }

      return {
        path,
        offset: edge === 'end' ? node.text.length : 0
      };
    }

    if (Range.isRange(at)) {
      var [start, end] = Range.edges(at);
      return edge === 'start' ? start : end;
    }

    return at;
  },

  /**
   * Create a mutable ref for a `Point` object, which will stay in sync as new
   * operations are applied to the editor.
   */
  pointRef(editor, point) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      affinity = 'forward'
    } = options;
    var ref = {
      current: point,
      affinity,

      unref() {
        var {
          current
        } = ref;
        var pointRefs = Editor.pointRefs(editor);
        pointRefs.delete(ref);
        ref.current = null;
        return current;
      }

    };
    var refs = Editor.pointRefs(editor);
    refs.add(ref);
    return ref;
  },

  /**
   * Get the set of currently tracked point refs of the editor.
   */
  pointRefs(editor) {
    var refs = POINT_REFS.get(editor);

    if (!refs) {
      refs = new Set();
      POINT_REFS.set(editor, refs);
    }

    return refs;
  },

  /**
   * Return all the positions in `at` range where a `Point` can be placed.
   *
   * By default, moves forward by individual offsets at a time, but
   * the `unit` option can be used to to move by character, word, line, or block.
   *
   * The `reverse` option can be used to change iteration direction.
   *
   * Note: By default void nodes are treated as a single point and iteration
   * will not happen inside their content unless you pass in true for the
   * `voids` option, then iteration will occur.
   */
  *positions(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      at = editor.selection,
      unit = 'offset',
      reverse = false,
      voids = false
    } = options;

    if (!at) {
      return;
    }
    /**
     * Algorithm notes:
     *
     * Each step `distance` is dynamic depending on the underlying text
     * and the `unit` specified.  Each step, e.g., a line or word, may
     * span multiple text nodes, so we iterate through the text both on
     * two levels in step-sync:
     *
     * `leafText` stores the text on a text leaf level, and is advanced
     * through using the counters `leafTextOffset` and `leafTextRemaining`.
     *
     * `blockText` stores the text on a block level, and is shortened
     * by `distance` every time it is advanced.
     *
     * We only maintain a window of one blockText and one leafText because
     * a block node always appears before all of its leaf nodes.
     */


    var range = Editor.range(editor, at);
    var [start, end] = Range.edges(range);
    var first = reverse ? end : start;
    var isNewBlock = false;
    var blockText = '';
    var distance = 0; // Distance for leafText to catch up to blockText.

    var leafTextRemaining = 0;
    var leafTextOffset = 0; // Iterate through all nodes in range, grabbing entire textual content
    // of block nodes in blockText, and text nodes in leafText.
    // Exploits the fact that nodes are sequenced in such a way that we first
    // encounter the block node, then all of its text nodes, so when iterating
    // through the blockText and leafText we just need to remember a window of
    // one block node and leaf node, respectively.

    for (var [node, path] of Editor.nodes(editor, {
      at,
      reverse,
      voids
    })) {
      /*
       * ELEMENT NODE - Yield position(s) for voids, collect blockText for blocks
       */
      if (Element.isElement(node)) {
        // Void nodes are a special case, so by default we will always
        // yield their first point. If the `voids` option is set to true,
        // then we will iterate over their content.
        if (!voids && editor.isVoid(node)) {
          yield Editor.start(editor, path); // It's possible the start of the range we're iterating over is in a void, in which case
          // we want to make sure we don't incorrectly yield the start of a subsequent text node for unit !== 'offset'

          isNewBlock = false;
          continue;
        } // Inline element nodes are ignored as they don't themselves
        // contribute to `blockText` or `leafText` - their parent and
        // children do.


        if (editor.isInline(node)) continue; // Block element node - set `blockText` to its text content.

        if (Editor.hasInlines(editor, node)) {
          // We always exhaust block nodes before encountering a new one:
          //   console.assert(blockText === '',
          //     `blockText='${blockText}' - `+
          //     `not exhausted before new block node`, path)
          // Ensure range considered is capped to `range`, in the
          // start/end edge cases where block extends beyond range.
          // Equivalent to this, but presumably more performant:
          //   blockRange = Editor.range(editor, ...Editor.edges(editor, path))
          //   blockRange = Range.intersection(range, blockRange) // intersect
          //   blockText = Editor.string(editor, blockRange, { voids })
          var e = Path.isAncestor(path, end.path) ? end : Editor.end(editor, path);
          var s = Path.isAncestor(path, start.path) ? start : Editor.start(editor, path);
          blockText = Editor.string(editor, {
            anchor: s,
            focus: e
          }, {
            voids
          });
          isNewBlock = true;
        }
      }
      /*
       * TEXT LEAF NODE - Iterate through text content, yielding
       * positions every `distance` offset according to `unit`.
       */


      if (Text.isText(node)) {
        var isFirst = Path.equals(path, first.path); // Proof that we always exhaust text nodes before encountering a new one:
        //   console.assert(leafTextRemaining <= 0,
        //     `leafTextRemaining=${leafTextRemaining} - `+
        //     `not exhausted before new leaf text node`, path)
        // Reset `leafText` counters for new text node.

        if (isFirst) {
          leafTextRemaining = reverse ? first.offset : node.text.length - first.offset;
          leafTextOffset = first.offset; // Works for reverse too.
        } else {
          leafTextRemaining = node.text.length;
          leafTextOffset = reverse ? leafTextRemaining : 0;
        } // Yield position at the start of node (potentially).


        if (isFirst || isNewBlock || unit === 'offset') {
          yield {
            path,
            offset: leafTextOffset
          };
          isNewBlock = false;
        } // Yield positions every (dynamically calculated) `distance` offset.


        while (true) {
          // If `leafText` has caught up with `blockText` (distance=0),
          // and if blockText is exhausted, break to get another block node,
          // otherwise advance blockText forward by the new `distance`.
          if (distance === 0) {
            if (blockText === '') break;
            distance = calcDistance(blockText, unit, reverse); // Split the string at the previously found distance and use the
            // remaining string for the next iteration.

            blockText = splitByCharacterDistance(blockText, distance, reverse)[1];
          } // Advance `leafText` by the current `distance`.


          leafTextOffset = reverse ? leafTextOffset - distance : leafTextOffset + distance;
          leafTextRemaining = leafTextRemaining - distance; // If `leafText` is exhausted, break to get a new leaf node
          // and set distance to the overflow amount, so we'll (maybe)
          // catch up to blockText in the next leaf text node.

          if (leafTextRemaining < 0) {
            distance = -leafTextRemaining;
            break;
          } // Successfully walked `distance` offsets through `leafText`
          // to catch up with `blockText`, so we can reset `distance`
          // and yield this position in this node.


          distance = 0;
          yield {
            path,
            offset: leafTextOffset
          };
        }
      }
    } // Proof that upon completion, we've exahusted both leaf and block text:
    //   console.assert(leafTextRemaining <= 0, "leafText wasn't exhausted")
    //   console.assert(blockText === '', "blockText wasn't exhausted")
    // Helper:
    // Return the distance in offsets for a step of size `unit` on given string.


    function calcDistance(text, unit, reverse) {
      if (unit === 'character') {
        return getCharacterDistance(text, reverse);
      } else if (unit === 'word') {
        return getWordDistance(text, reverse);
      } else if (unit === 'line' || unit === 'block') {
        return text.length;
      }

      return 1;
    }
  },

  /**
   * Get the matching node in the branch of the document before a location.
   */
  previous(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      mode = 'lowest',
      voids = false
    } = options;
    var {
      match,
      at = editor.selection
    } = options;

    if (!at) {
      return;
    }

    var pointBeforeLocation = Editor.before(editor, at, {
      voids
    });

    if (!pointBeforeLocation) {
      return;
    }

    var [, to] = Editor.first(editor, []); // The search location is from the start of the document to the path of
    // the point before the location passed in

    var span = [pointBeforeLocation.path, to];

    if (Path.isPath(at) && at.length === 0) {
      throw new Error("Cannot get the previous node from the root node!");
    }

    if (match == null) {
      if (Path.isPath(at)) {
        var [parent] = Editor.parent(editor, at);

        match = n => parent.children.includes(n);
      } else {
        match = () => true;
      }
    }

    var [previous] = Editor.nodes(editor, {
      reverse: true,
      at: span,
      match,
      mode,
      voids
    });
    return previous;
  },

  /**
   * Get a range of a location.
   */
  range(editor, at, to) {
    if (Range.isRange(at) && !to) {
      return at;
    }

    var start = Editor.start(editor, at);
    var end = Editor.end(editor, to || at);
    return {
      anchor: start,
      focus: end
    };
  },

  /**
   * Create a mutable ref for a `Range` object, which will stay in sync as new
   * operations are applied to the editor.
   */
  rangeRef(editor, range) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      affinity = 'forward'
    } = options;
    var ref = {
      current: range,
      affinity,

      unref() {
        var {
          current
        } = ref;
        var rangeRefs = Editor.rangeRefs(editor);
        rangeRefs.delete(ref);
        ref.current = null;
        return current;
      }

    };
    var refs = Editor.rangeRefs(editor);
    refs.add(ref);
    return ref;
  },

  /**
   * Get the set of currently tracked range refs of the editor.
   */
  rangeRefs(editor) {
    var refs = RANGE_REFS.get(editor);

    if (!refs) {
      refs = new Set();
      RANGE_REFS.set(editor, refs);
    }

    return refs;
  },

  /**
   * Remove a custom property from all of the leaf text nodes in the current
   * selection.
   *
   * If the selection is currently collapsed, the removal will be stored on
   * `editor.marks` and applied to the text inserted next.
   */
  removeMark(editor, key) {
    editor.removeMark(key);
  },

  /**
   * Manually set if the editor should currently be normalizing.
   *
   * Note: Using this incorrectly can leave the editor in an invalid state.
   *
   */
  setNormalizing(editor, isNormalizing) {
    NORMALIZING.set(editor, isNormalizing);
  },

  /**
   * Get the start point of a location.
   */
  start(editor, at) {
    return Editor.point(editor, at, {
      edge: 'start'
    });
  },

  /**
   * Get the text string content of a location.
   *
   * Note: by default the text of void nodes is considered to be an empty
   * string, regardless of content, unless you pass in true for the voids option
   */
  string(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      voids = false
    } = options;
    var range = Editor.range(editor, at);
    var [start, end] = Range.edges(range);
    var text = '';

    for (var [node, path] of Editor.nodes(editor, {
      at: range,
      match: Text.isText,
      voids
    })) {
      var t = node.text;

      if (Path.equals(path, end.path)) {
        t = t.slice(0, end.offset);
      }

      if (Path.equals(path, start.path)) {
        t = t.slice(start.offset);
      }

      text += t;
    }

    return text;
  },

  /**
   * Convert a range into a non-hanging one.
   */
  unhangRange(editor, range) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      voids = false
    } = options;
    var [start, end] = Range.edges(range); // PERF: exit early if we can guarantee that the range isn't hanging.

    if (start.offset !== 0 || end.offset !== 0 || Range.isCollapsed(range)) {
      return range;
    }

    var endBlock = Editor.above(editor, {
      at: end,
      match: n => Editor.isBlock(editor, n)
    });
    var blockPath = endBlock ? endBlock[1] : [];
    var first = Editor.start(editor, start);
    var before = {
      anchor: first,
      focus: end
    };
    var skip = true;

    for (var [node, path] of Editor.nodes(editor, {
      at: before,
      match: Text.isText,
      reverse: true,
      voids
    })) {
      if (skip) {
        skip = false;
        continue;
      }

      if (node.text !== '' || Path.isBefore(path, blockPath)) {
        end = {
          path,
          offset: node.text.length
        };
        break;
      }
    }

    return {
      anchor: start,
      focus: end
    };
  },

  /**
   * Match a void node in the current branch of the editor.
   */
  void(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Editor.above(editor, _objectSpread$8(_objectSpread$8({}, options), {}, {
      match: n => Editor.isVoid(editor, n)
    }));
  },

  /**
   * Call a function, deferring normalization until after it completes.
   */
  withoutNormalizing(editor, fn) {
    var value = Editor.isNormalizing(editor);
    Editor.setNormalizing(editor, false);

    try {
      fn();
    } finally {
      Editor.setNormalizing(editor, value);
    }

    Editor.normalize(editor);
  }

};

var Location = {
  /**
   * Check if a value implements the `Location` interface.
   */
  isLocation(value) {
    return Path.isPath(value) || Point.isPoint(value) || Range.isRange(value);
  }

};
var Span = {
  /**
   * Check if a value implements the `Span` interface.
   */
  isSpan(value) {
    return Array.isArray(value) && value.length === 2 && value.every(Path.isPath);
  }

};

var _excluded$3 = ["children"],
    _excluded2$2 = ["text"];
var IS_NODE_LIST_CACHE = new WeakMap();
var Node = {
  /**
   * Get the node at a specific path, asserting that it's an ancestor node.
   */
  ancestor(root, path) {
    var node = Node.get(root, path);

    if (Text.isText(node)) {
      throw new Error("Cannot get the ancestor node at path [".concat(path, "] because it refers to a text node instead: ").concat(node));
    }

    return node;
  },

  /**
   * Return a generator of all the ancestor nodes above a specific path.
   *
   * By default the order is bottom-up, from lowest to highest ancestor in
   * the tree, but you can pass the `reverse: true` option to go top-down.
   */
  *ancestors(root, path) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    for (var p of Path.ancestors(path, options)) {
      var n = Node.ancestor(root, p);
      var entry = [n, p];
      yield entry;
    }
  },

  /**
   * Get the child of a node at a specific index.
   */
  child(root, index) {
    if (Text.isText(root)) {
      throw new Error("Cannot get the child of a text node: ".concat(JSON.stringify(root)));
    }

    var c = root.children[index];

    if (c == null) {
      throw new Error("Cannot get child at index `".concat(index, "` in node: ").concat(JSON.stringify(root)));
    }

    return c;
  },

  /**
   * Iterate over the children of a node at a specific path.
   */
  *children(root, path) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      reverse = false
    } = options;
    var ancestor = Node.ancestor(root, path);
    var {
      children
    } = ancestor;
    var index = reverse ? children.length - 1 : 0;

    while (reverse ? index >= 0 : index < children.length) {
      var child = Node.child(ancestor, index);
      var childPath = path.concat(index);
      yield [child, childPath];
      index = reverse ? index - 1 : index + 1;
    }
  },

  /**
   * Get an entry for the common ancesetor node of two paths.
   */
  common(root, path, another) {
    var p = Path.common(path, another);
    var n = Node.get(root, p);
    return [n, p];
  },

  /**
   * Get the node at a specific path, asserting that it's a descendant node.
   */
  descendant(root, path) {
    var node = Node.get(root, path);

    if (Editor.isEditor(node)) {
      throw new Error("Cannot get the descendant node at path [".concat(path, "] because it refers to the root editor node instead: ").concat(node));
    }

    return node;
  },

  /**
   * Return a generator of all the descendant node entries inside a root node.
   */
  *descendants(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var [node, path] of Node.nodes(root, options)) {
      if (path.length !== 0) {
        // NOTE: we have to coerce here because checking the path's length does
        // guarantee that `node` is not a `Editor`, but TypeScript doesn't know.
        yield [node, path];
      }
    }
  },

  /**
   * Return a generator of all the element nodes inside a root node. Each iteration
   * will return an `ElementEntry` tuple consisting of `[Element, Path]`. If the
   * root node is an element it will be included in the iteration as well.
   */
  *elements(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var [node, path] of Node.nodes(root, options)) {
      if (Element.isElement(node)) {
        yield [node, path];
      }
    }
  },

  /**
   * Extract props from a Node.
   */
  extractProps(node) {
    if (Element.isAncestor(node)) {
      var properties = _objectWithoutProperties(node, _excluded$3);

      return properties;
    } else {
      var properties = _objectWithoutProperties(node, _excluded2$2);

      return properties;
    }
  },

  /**
   * Get the first node entry in a root node from a path.
   */
  first(root, path) {
    var p = path.slice();
    var n = Node.get(root, p);

    while (n) {
      if (Text.isText(n) || n.children.length === 0) {
        break;
      } else {
        n = n.children[0];
        p.push(0);
      }
    }

    return [n, p];
  },

  /**
   * Get the sliced fragment represented by a range inside a root node.
   */
  fragment(root, range) {
    if (Text.isText(root)) {
      throw new Error("Cannot get a fragment starting from a root text node: ".concat(JSON.stringify(root)));
    }

    var newRoot = (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)({
      children: root.children
    }, r => {
      var [start, end] = Range.edges(range);
      var nodeEntries = Node.nodes(r, {
        reverse: true,
        pass: _ref => {
          var [, path] = _ref;
          return !Range.includes(range, path);
        }
      });

      for (var [, path] of nodeEntries) {
        if (!Range.includes(range, path)) {
          var parent = Node.parent(r, path);
          var index = path[path.length - 1];
          parent.children.splice(index, 1);
        }

        if (Path.equals(path, end.path)) {
          var leaf = Node.leaf(r, path);
          leaf.text = leaf.text.slice(0, end.offset);
        }

        if (Path.equals(path, start.path)) {
          var _leaf = Node.leaf(r, path);

          _leaf.text = _leaf.text.slice(start.offset);
        }
      }

      if (Editor.isEditor(r)) {
        r.selection = null;
      }
    });
    return newRoot.children;
  },

  /**
   * Get the descendant node referred to by a specific path. If the path is an
   * empty array, it refers to the root node itself.
   */
  get(root, path) {
    var node = root;

    for (var i = 0; i < path.length; i++) {
      var p = path[i];

      if (Text.isText(node) || !node.children[p]) {
        throw new Error("Cannot find a descendant at path [".concat(path, "] in node: ").concat(JSON.stringify(root)));
      }

      node = node.children[p];
    }

    return node;
  },

  /**
   * Check if a descendant node exists at a specific path.
   */
  has(root, path) {
    var node = root;

    for (var i = 0; i < path.length; i++) {
      var p = path[i];

      if (Text.isText(node) || !node.children[p]) {
        return false;
      }

      node = node.children[p];
    }

    return true;
  },

  /**
   * Check if a value implements the `Node` interface.
   */
  isNode(value) {
    return Text.isText(value) || Element.isElement(value) || Editor.isEditor(value);
  },

  /**
   * Check if a value is a list of `Node` objects.
   */
  isNodeList(value) {
    if (!Array.isArray(value)) {
      return false;
    }

    var cachedResult = IS_NODE_LIST_CACHE.get(value);

    if (cachedResult !== undefined) {
      return cachedResult;
    }

    var isNodeList = value.every(val => Node.isNode(val));
    IS_NODE_LIST_CACHE.set(value, isNodeList);
    return isNodeList;
  },

  /**
   * Get the last node entry in a root node from a path.
   */
  last(root, path) {
    var p = path.slice();
    var n = Node.get(root, p);

    while (n) {
      if (Text.isText(n) || n.children.length === 0) {
        break;
      } else {
        var i = n.children.length - 1;
        n = n.children[i];
        p.push(i);
      }
    }

    return [n, p];
  },

  /**
   * Get the node at a specific path, ensuring it's a leaf text node.
   */
  leaf(root, path) {
    var node = Node.get(root, path);

    if (!Text.isText(node)) {
      throw new Error("Cannot get the leaf node at path [".concat(path, "] because it refers to a non-leaf node: ").concat(node));
    }

    return node;
  },

  /**
   * Return a generator of the in a branch of the tree, from a specific path.
   *
   * By default the order is top-down, from lowest to highest node in the tree,
   * but you can pass the `reverse: true` option to go bottom-up.
   */
  *levels(root, path) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    for (var p of Path.levels(path, options)) {
      var n = Node.get(root, p);
      yield [n, p];
    }
  },

  /**
   * Check if a node matches a set of props.
   */
  matches(node, props) {
    return Element.isElement(node) && Element.isElementProps(props) && Element.matches(node, props) || Text.isText(node) && Text.isTextProps(props) && Text.matches(node, props);
  },

  /**
   * Return a generator of all the node entries of a root node. Each entry is
   * returned as a `[Node, Path]` tuple, with the path referring to the node's
   * position inside the root node.
   */
  *nodes(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      pass,
      reverse = false
    } = options;
    var {
      from = [],
      to
    } = options;
    var visited = new Set();
    var p = [];
    var n = root;

    while (true) {
      if (to && (reverse ? Path.isBefore(p, to) : Path.isAfter(p, to))) {
        break;
      }

      if (!visited.has(n)) {
        yield [n, p];
      } // If we're allowed to go downward and we haven't descended yet, do.


      if (!visited.has(n) && !Text.isText(n) && n.children.length !== 0 && (pass == null || pass([n, p]) === false)) {
        visited.add(n);
        var nextIndex = reverse ? n.children.length - 1 : 0;

        if (Path.isAncestor(p, from)) {
          nextIndex = from[p.length];
        }

        p = p.concat(nextIndex);
        n = Node.get(root, p);
        continue;
      } // If we're at the root and we can't go down, we're done.


      if (p.length === 0) {
        break;
      } // If we're going forward...


      if (!reverse) {
        var newPath = Path.next(p);

        if (Node.has(root, newPath)) {
          p = newPath;
          n = Node.get(root, p);
          continue;
        }
      } // If we're going backward...


      if (reverse && p[p.length - 1] !== 0) {
        var _newPath = Path.previous(p);

        p = _newPath;
        n = Node.get(root, p);
        continue;
      } // Otherwise we're going upward...


      p = Path.parent(p);
      n = Node.get(root, p);
      visited.add(n);
    }
  },

  /**
   * Get the parent of a node at a specific path.
   */
  parent(root, path) {
    var parentPath = Path.parent(path);
    var p = Node.get(root, parentPath);

    if (Text.isText(p)) {
      throw new Error("Cannot get the parent of path [".concat(path, "] because it does not exist in the root."));
    }

    return p;
  },

  /**
   * Get the concatenated text string of a node's content.
   *
   * Note that this will not include spaces or line breaks between block nodes.
   * It is not a user-facing string, but a string for performing offset-related
   * computations for a node.
   */
  string(node) {
    if (Text.isText(node)) {
      return node.text;
    } else {
      return node.children.map(Node.string).join('');
    }
  },

  /**
   * Return a generator of all leaf text nodes in a root node.
   */
  *texts(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var [node, path] of Node.nodes(root, options)) {
      if (Text.isText(node)) {
        yield [node, path];
      }
    }
  }

};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Operation = {
  /**
   * Check of a value is a `NodeOperation` object.
   */
  isNodeOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith('_node');
  },

  /**
   * Check of a value is an `Operation` object.
   */
  isOperation(value) {
    if (!(0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value)) {
      return false;
    }

    switch (value.type) {
      case 'insert_node':
        return Path.isPath(value.path) && Node.isNode(value.node);

      case 'insert_text':
        return typeof value.offset === 'number' && typeof value.text === 'string' && Path.isPath(value.path);

      case 'merge_node':
        return typeof value.position === 'number' && Path.isPath(value.path) && (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value.properties);

      case 'move_node':
        return Path.isPath(value.path) && Path.isPath(value.newPath);

      case 'remove_node':
        return Path.isPath(value.path) && Node.isNode(value.node);

      case 'remove_text':
        return typeof value.offset === 'number' && typeof value.text === 'string' && Path.isPath(value.path);

      case 'set_node':
        return Path.isPath(value.path) && (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value.properties) && (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value.newProperties);

      case 'set_selection':
        return value.properties === null && Range.isRange(value.newProperties) || value.newProperties === null && Range.isRange(value.properties) || (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value.properties) && (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value.newProperties);

      case 'split_node':
        return Path.isPath(value.path) && typeof value.position === 'number' && (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value.properties);

      default:
        return false;
    }
  },

  /**
   * Check if a value is a list of `Operation` objects.
   */
  isOperationList(value) {
    return Array.isArray(value) && value.every(val => Operation.isOperation(val));
  },

  /**
   * Check of a value is a `SelectionOperation` object.
   */
  isSelectionOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith('_selection');
  },

  /**
   * Check of a value is a `TextOperation` object.
   */
  isTextOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith('_text');
  },

  /**
   * Invert an operation, returning a new operation that will exactly undo the
   * original when applied.
   */
  inverse(op) {
    switch (op.type) {
      case 'insert_node':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'remove_node'
          });
        }

      case 'insert_text':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'remove_text'
          });
        }

      case 'merge_node':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'split_node',
            path: Path.previous(op.path)
          });
        }

      case 'move_node':
        {
          var {
            newPath,
            path
          } = op; // PERF: in this case the move operation is a no-op anyways.

          if (Path.equals(newPath, path)) {
            return op;
          } // If the move happens completely within a single parent the path and
          // newPath are stable with respect to each other.


          if (Path.isSibling(path, newPath)) {
            return _objectSpread$7(_objectSpread$7({}, op), {}, {
              path: newPath,
              newPath: path
            });
          } // If the move does not happen within a single parent it is possible
          // for the move to impact the true path to the location where the node
          // was removed from and where it was inserted. We have to adjust for this
          // and find the original path. We can accomplish this (only in non-sibling)
          // moves by looking at the impact of the move operation on the node
          // after the original move path.


          var inversePath = Path.transform(path, op);
          var inverseNewPath = Path.transform(Path.next(path), op);
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            path: inversePath,
            newPath: inverseNewPath
          });
        }

      case 'remove_node':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'insert_node'
          });
        }

      case 'remove_text':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'insert_text'
          });
        }

      case 'set_node':
        {
          var {
            properties,
            newProperties
          } = op;
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            properties: newProperties,
            newProperties: properties
          });
        }

      case 'set_selection':
        {
          var {
            properties: _properties,
            newProperties: _newProperties
          } = op;

          if (_properties == null) {
            return _objectSpread$7(_objectSpread$7({}, op), {}, {
              properties: _newProperties,
              newProperties: null
            });
          } else if (_newProperties == null) {
            return _objectSpread$7(_objectSpread$7({}, op), {}, {
              properties: null,
              newProperties: _properties
            });
          } else {
            return _objectSpread$7(_objectSpread$7({}, op), {}, {
              properties: _newProperties,
              newProperties: _properties
            });
          }
        }

      case 'split_node':
        {
          return _objectSpread$7(_objectSpread$7({}, op), {}, {
            type: 'merge_node',
            path: Path.next(op.path)
          });
        }
    }
  }

};

var Path = {
  /**
   * Get a list of ancestor paths for a given path.
   *
   * The paths are sorted from deepest to shallowest ancestor. However, if the
   * `reverse: true` option is passed, they are reversed.
   */
  ancestors(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      reverse = false
    } = options;
    var paths = Path.levels(path, options);

    if (reverse) {
      paths = paths.slice(1);
    } else {
      paths = paths.slice(0, -1);
    }

    return paths;
  },

  /**
   * Get the common ancestor path of two paths.
   */
  common(path, another) {
    var common = [];

    for (var i = 0; i < path.length && i < another.length; i++) {
      var av = path[i];
      var bv = another[i];

      if (av !== bv) {
        break;
      }

      common.push(av);
    }

    return common;
  },

  /**
   * Compare a path to another, returning an integer indicating whether the path
   * was before, at, or after the other.
   *
   * Note: Two paths of unequal length can still receive a `0` result if one is
   * directly above or below the other. If you want exact matching, use
   * [[Path.equals]] instead.
   */
  compare(path, another) {
    var min = Math.min(path.length, another.length);

    for (var i = 0; i < min; i++) {
      if (path[i] < another[i]) return -1;
      if (path[i] > another[i]) return 1;
    }

    return 0;
  },

  /**
   * Check if a path ends after one of the indexes in another.
   */
  endsAfter(path, another) {
    var i = path.length - 1;
    var as = path.slice(0, i);
    var bs = another.slice(0, i);
    var av = path[i];
    var bv = another[i];
    return Path.equals(as, bs) && av > bv;
  },

  /**
   * Check if a path ends at one of the indexes in another.
   */
  endsAt(path, another) {
    var i = path.length;
    var as = path.slice(0, i);
    var bs = another.slice(0, i);
    return Path.equals(as, bs);
  },

  /**
   * Check if a path ends before one of the indexes in another.
   */
  endsBefore(path, another) {
    var i = path.length - 1;
    var as = path.slice(0, i);
    var bs = another.slice(0, i);
    var av = path[i];
    var bv = another[i];
    return Path.equals(as, bs) && av < bv;
  },

  /**
   * Check if a path is exactly equal to another.
   */
  equals(path, another) {
    return path.length === another.length && path.every((n, i) => n === another[i]);
  },

  /**
   * Check if the path of previous sibling node exists
   */
  hasPrevious(path) {
    return path[path.length - 1] > 0;
  },

  /**
   * Check if a path is after another.
   */
  isAfter(path, another) {
    return Path.compare(path, another) === 1;
  },

  /**
   * Check if a path is an ancestor of another.
   */
  isAncestor(path, another) {
    return path.length < another.length && Path.compare(path, another) === 0;
  },

  /**
   * Check if a path is before another.
   */
  isBefore(path, another) {
    return Path.compare(path, another) === -1;
  },

  /**
   * Check if a path is a child of another.
   */
  isChild(path, another) {
    return path.length === another.length + 1 && Path.compare(path, another) === 0;
  },

  /**
   * Check if a path is equal to or an ancestor of another.
   */
  isCommon(path, another) {
    return path.length <= another.length && Path.compare(path, another) === 0;
  },

  /**
   * Check if a path is a descendant of another.
   */
  isDescendant(path, another) {
    return path.length > another.length && Path.compare(path, another) === 0;
  },

  /**
   * Check if a path is the parent of another.
   */
  isParent(path, another) {
    return path.length + 1 === another.length && Path.compare(path, another) === 0;
  },

  /**
   * Check is a value implements the `Path` interface.
   */
  isPath(value) {
    return Array.isArray(value) && (value.length === 0 || typeof value[0] === 'number');
  },

  /**
   * Check if a path is a sibling of another.
   */
  isSibling(path, another) {
    if (path.length !== another.length) {
      return false;
    }

    var as = path.slice(0, -1);
    var bs = another.slice(0, -1);
    var al = path[path.length - 1];
    var bl = another[another.length - 1];
    return al !== bl && Path.equals(as, bs);
  },

  /**
   * Get a list of paths at every level down to a path. Note: this is the same
   * as `Path.ancestors`, but including the path itself.
   *
   * The paths are sorted from shallowest to deepest. However, if the `reverse:
   * true` option is passed, they are reversed.
   */
  levels(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      reverse = false
    } = options;
    var list = [];

    for (var i = 0; i <= path.length; i++) {
      list.push(path.slice(0, i));
    }

    if (reverse) {
      list.reverse();
    }

    return list;
  },

  /**
   * Given a path, get the path to the next sibling node.
   */
  next(path) {
    if (path.length === 0) {
      throw new Error("Cannot get the next path of a root path [".concat(path, "], because it has no next index."));
    }

    var last = path[path.length - 1];
    return path.slice(0, -1).concat(last + 1);
  },

  /**
   * Returns whether this operation can affect paths or not. Used as an
   * optimization when updating dirty paths during normalization
   *
   * NOTE: This *must* be kept in sync with the implementation of 'transform'
   * below
   */
  operationCanTransformPath(operation) {
    switch (operation.type) {
      case 'insert_node':
      case 'remove_node':
      case 'merge_node':
      case 'split_node':
      case 'move_node':
        return true;

      default:
        return false;
    }
  },

  /**
   * Given a path, return a new path referring to the parent node above it.
   */
  parent(path) {
    if (path.length === 0) {
      throw new Error("Cannot get the parent path of the root path [".concat(path, "]."));
    }

    return path.slice(0, -1);
  },

  /**
   * Given a path, get the path to the previous sibling node.
   */
  previous(path) {
    if (path.length === 0) {
      throw new Error("Cannot get the previous path of a root path [".concat(path, "], because it has no previous index."));
    }

    var last = path[path.length - 1];

    if (last <= 0) {
      throw new Error("Cannot get the previous path of a first child path [".concat(path, "] because it would result in a negative index."));
    }

    return path.slice(0, -1).concat(last - 1);
  },

  /**
   * Get a path relative to an ancestor.
   */
  relative(path, ancestor) {
    if (!Path.isAncestor(ancestor, path) && !Path.equals(path, ancestor)) {
      throw new Error("Cannot get the relative path of [".concat(path, "] inside ancestor [").concat(ancestor, "], because it is not above or equal to the path."));
    }

    return path.slice(ancestor.length);
  },

  /**
   * Transform a path by an operation.
   */
  transform(path, operation) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)(path, p => {
      var {
        affinity = 'forward'
      } = options; // PERF: Exit early if the operation is guaranteed not to have an effect.

      if (!path || (path === null || path === void 0 ? void 0 : path.length) === 0) {
        return;
      }

      if (p === null) {
        return null;
      }

      switch (operation.type) {
        case 'insert_node':
          {
            var {
              path: op
            } = operation;

            if (Path.equals(op, p) || Path.endsBefore(op, p) || Path.isAncestor(op, p)) {
              p[op.length - 1] += 1;
            }

            break;
          }

        case 'remove_node':
          {
            var {
              path: _op
            } = operation;

            if (Path.equals(_op, p) || Path.isAncestor(_op, p)) {
              return null;
            } else if (Path.endsBefore(_op, p)) {
              p[_op.length - 1] -= 1;
            }

            break;
          }

        case 'merge_node':
          {
            var {
              path: _op2,
              position
            } = operation;

            if (Path.equals(_op2, p) || Path.endsBefore(_op2, p)) {
              p[_op2.length - 1] -= 1;
            } else if (Path.isAncestor(_op2, p)) {
              p[_op2.length - 1] -= 1;
              p[_op2.length] += position;
            }

            break;
          }

        case 'split_node':
          {
            var {
              path: _op3,
              position: _position
            } = operation;

            if (Path.equals(_op3, p)) {
              if (affinity === 'forward') {
                p[p.length - 1] += 1;
              } else if (affinity === 'backward') ; else {
                return null;
              }
            } else if (Path.endsBefore(_op3, p)) {
              p[_op3.length - 1] += 1;
            } else if (Path.isAncestor(_op3, p) && path[_op3.length] >= _position) {
              p[_op3.length - 1] += 1;
              p[_op3.length] -= _position;
            }

            break;
          }

        case 'move_node':
          {
            var {
              path: _op4,
              newPath: onp
            } = operation; // If the old and new path are the same, it's a no-op.

            if (Path.equals(_op4, onp)) {
              return;
            }

            if (Path.isAncestor(_op4, p) || Path.equals(_op4, p)) {
              var copy = onp.slice();

              if (Path.endsBefore(_op4, onp) && _op4.length < onp.length) {
                copy[_op4.length - 1] -= 1;
              }

              return copy.concat(p.slice(_op4.length));
            } else if (Path.isSibling(_op4, onp) && (Path.isAncestor(onp, p) || Path.equals(onp, p))) {
              if (Path.endsBefore(_op4, p)) {
                p[_op4.length - 1] -= 1;
              } else {
                p[_op4.length - 1] += 1;
              }
            } else if (Path.endsBefore(onp, p) || Path.equals(onp, p) || Path.isAncestor(onp, p)) {
              if (Path.endsBefore(_op4, p)) {
                p[_op4.length - 1] -= 1;
              }

              p[onp.length - 1] += 1;
            } else if (Path.endsBefore(_op4, p)) {
              if (Path.equals(onp, p)) {
                p[onp.length - 1] += 1;
              }

              p[_op4.length - 1] -= 1;
            }

            break;
          }
      }
    });
  }

};

var PathRef = {
  /**
   * Transform the path ref's current value by an operation.
   */
  transform(ref, op) {
    var {
      current,
      affinity
    } = ref;

    if (current == null) {
      return;
    }

    var path = Path.transform(current, op, {
      affinity
    });
    ref.current = path;

    if (path == null) {
      ref.unref();
    }
  }

};

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Point = {
  /**
   * Compare a point to another, returning an integer indicating whether the
   * point was before, at, or after the other.
   */
  compare(point, another) {
    var result = Path.compare(point.path, another.path);

    if (result === 0) {
      if (point.offset < another.offset) return -1;
      if (point.offset > another.offset) return 1;
      return 0;
    }

    return result;
  },

  /**
   * Check if a point is after another.
   */
  isAfter(point, another) {
    return Point.compare(point, another) === 1;
  },

  /**
   * Check if a point is before another.
   */
  isBefore(point, another) {
    return Point.compare(point, another) === -1;
  },

  /**
   * Check if a point is exactly equal to another.
   */
  equals(point, another) {
    // PERF: ensure the offsets are equal first since they are cheaper to check.
    return point.offset === another.offset && Path.equals(point.path, another.path);
  },

  /**
   * Check if a value implements the `Point` interface.
   */
  isPoint(value) {
    return (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value) && typeof value.offset === 'number' && Path.isPath(value.path);
  },

  /**
   * Transform a point by an operation.
   */
  transform(point, op) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)(point, p => {
      if (p === null) {
        return null;
      }

      var {
        affinity = 'forward'
      } = options;
      var {
        path,
        offset
      } = p;

      switch (op.type) {
        case 'insert_node':
        case 'move_node':
          {
            p.path = Path.transform(path, op, options);
            break;
          }

        case 'insert_text':
          {
            if (Path.equals(op.path, path) && (op.offset < offset || op.offset === offset && affinity === 'forward')) {
              p.offset += op.text.length;
            }

            break;
          }

        case 'merge_node':
          {
            if (Path.equals(op.path, path)) {
              p.offset += op.position;
            }

            p.path = Path.transform(path, op, options);
            break;
          }

        case 'remove_text':
          {
            if (Path.equals(op.path, path) && op.offset <= offset) {
              p.offset -= Math.min(offset - op.offset, op.text.length);
            }

            break;
          }

        case 'remove_node':
          {
            if (Path.equals(op.path, path) || Path.isAncestor(op.path, path)) {
              return null;
            }

            p.path = Path.transform(path, op, options);
            break;
          }

        case 'split_node':
          {
            if (Path.equals(op.path, path)) {
              if (op.position === offset && affinity == null) {
                return null;
              } else if (op.position < offset || op.position === offset && affinity === 'forward') {
                p.offset -= op.position;
                p.path = Path.transform(path, op, _objectSpread$6(_objectSpread$6({}, options), {}, {
                  affinity: 'forward'
                }));
              }
            } else {
              p.path = Path.transform(path, op, options);
            }

            break;
          }
      }
    });
  }

};

var PointRef = {
  /**
   * Transform the point ref's current value by an operation.
   */
  transform(ref, op) {
    var {
      current,
      affinity
    } = ref;

    if (current == null) {
      return;
    }

    var point = Point.transform(current, op, {
      affinity
    });
    ref.current = point;

    if (point == null) {
      ref.unref();
    }
  }

};

var _excluded$2 = ["anchor", "focus"];

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Range = {
  /**
   * Get the start and end points of a range, in the order in which they appear
   * in the document.
   */
  edges(range) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      reverse = false
    } = options;
    var {
      anchor,
      focus
    } = range;
    return Range.isBackward(range) === reverse ? [anchor, focus] : [focus, anchor];
  },

  /**
   * Get the end point of a range.
   */
  end(range) {
    var [, end] = Range.edges(range);
    return end;
  },

  /**
   * Check if a range is exactly equal to another.
   */
  equals(range, another) {
    return Point.equals(range.anchor, another.anchor) && Point.equals(range.focus, another.focus);
  },

  /**
   * Check if a range includes a path, a point or part of another range.
   */
  includes(range, target) {
    if (Range.isRange(target)) {
      if (Range.includes(range, target.anchor) || Range.includes(range, target.focus)) {
        return true;
      }

      var [rs, re] = Range.edges(range);
      var [ts, te] = Range.edges(target);
      return Point.isBefore(rs, ts) && Point.isAfter(re, te);
    }

    var [start, end] = Range.edges(range);
    var isAfterStart = false;
    var isBeforeEnd = false;

    if (Point.isPoint(target)) {
      isAfterStart = Point.compare(target, start) >= 0;
      isBeforeEnd = Point.compare(target, end) <= 0;
    } else {
      isAfterStart = Path.compare(target, start.path) >= 0;
      isBeforeEnd = Path.compare(target, end.path) <= 0;
    }

    return isAfterStart && isBeforeEnd;
  },

  /**
   * Get the intersection of a range with another.
   */
  intersection(range, another) {
    var rest = _objectWithoutProperties(range, _excluded$2);

    var [s1, e1] = Range.edges(range);
    var [s2, e2] = Range.edges(another);
    var start = Point.isBefore(s1, s2) ? s2 : s1;
    var end = Point.isBefore(e1, e2) ? e1 : e2;

    if (Point.isBefore(end, start)) {
      return null;
    } else {
      return _objectSpread$5({
        anchor: start,
        focus: end
      }, rest);
    }
  },

  /**
   * Check if a range is backward, meaning that its anchor point appears in the
   * document _after_ its focus point.
   */
  isBackward(range) {
    var {
      anchor,
      focus
    } = range;
    return Point.isAfter(anchor, focus);
  },

  /**
   * Check if a range is collapsed, meaning that both its anchor and focus
   * points refer to the exact same position in the document.
   */
  isCollapsed(range) {
    var {
      anchor,
      focus
    } = range;
    return Point.equals(anchor, focus);
  },

  /**
   * Check if a range is expanded.
   *
   * This is the opposite of [[Range.isCollapsed]] and is provided for legibility.
   */
  isExpanded(range) {
    return !Range.isCollapsed(range);
  },

  /**
   * Check if a range is forward.
   *
   * This is the opposite of [[Range.isBackward]] and is provided for legibility.
   */
  isForward(range) {
    return !Range.isBackward(range);
  },

  /**
   * Check if a value implements the [[Range]] interface.
   */
  isRange(value) {
    return (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value) && Point.isPoint(value.anchor) && Point.isPoint(value.focus);
  },

  /**
   * Iterate through all of the point entries in a range.
   */
  *points(range) {
    yield [range.anchor, 'anchor'];
    yield [range.focus, 'focus'];
  },

  /**
   * Get the start point of a range.
   */
  start(range) {
    var [start] = Range.edges(range);
    return start;
  },

  /**
   * Transform a range by an operation.
   */
  transform(range, op) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .produce */ .Uy)(range, r => {
      if (r === null) {
        return null;
      }

      var {
        affinity = 'inward'
      } = options;
      var affinityAnchor;
      var affinityFocus;

      if (affinity === 'inward') {
        // If the range is collapsed, make sure to use the same affinity to
        // avoid the two points passing each other and expanding in the opposite
        // direction
        var isCollapsed = Range.isCollapsed(r);

        if (Range.isForward(r)) {
          affinityAnchor = 'forward';
          affinityFocus = isCollapsed ? affinityAnchor : 'backward';
        } else {
          affinityAnchor = 'backward';
          affinityFocus = isCollapsed ? affinityAnchor : 'forward';
        }
      } else if (affinity === 'outward') {
        if (Range.isForward(r)) {
          affinityAnchor = 'backward';
          affinityFocus = 'forward';
        } else {
          affinityAnchor = 'forward';
          affinityFocus = 'backward';
        }
      } else {
        affinityAnchor = affinity;
        affinityFocus = affinity;
      }

      var anchor = Point.transform(r.anchor, op, {
        affinity: affinityAnchor
      });
      var focus = Point.transform(r.focus, op, {
        affinity: affinityFocus
      });

      if (!anchor || !focus) {
        return null;
      }

      r.anchor = anchor;
      r.focus = focus;
    });
  }

};

var RangeRef = {
  /**
   * Transform the range ref's current value by an operation.
   */
  transform(ref, op) {
    var {
      current,
      affinity
    } = ref;

    if (current == null) {
      return;
    }

    var path = Range.transform(current, op, {
      affinity
    });
    ref.current = path;

    if (path == null) {
      ref.unref();
    }
  }

};

/*
  Custom deep equal comparison for Slate nodes.

  We don't need general purpose deep equality;
  Slate only supports plain values, Arrays, and nested objects.
  Complex values nested inside Arrays are not supported.

  Slate objects are designed to be serialised, so
  missing keys are deliberately normalised to undefined.
 */

var isDeepEqual = (node, another) => {
  for (var key in node) {
    var a = node[key];
    var b = another[key];

    if ((0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(a) && (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(b)) {
      if (!isDeepEqual(a, b)) return false;
    } else if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;

      for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }
    } else if (a !== b) {
      return false;
    }
  }
  /*
    Deep object equality is only necessary in one direction; in the reverse direction
    we are only looking for keys that are missing.
    As above, undefined keys are normalised to missing.
  */


  for (var _key in another) {
    if (node[_key] === undefined && another[_key] !== undefined) {
      return false;
    }
  }

  return true;
};

var _excluded$1 = ["text"],
    _excluded2$1 = ["anchor", "focus"];

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Text = {
  /**
   * Check if two text nodes are equal.
   *
   * When loose is set, the text is not compared. This is
   * used to check whether sibling text nodes can be merged.
   */
  equals(text, another) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      loose = false
    } = options;

    function omitText(obj) {
      var rest = _objectWithoutProperties(obj, _excluded$1);

      return rest;
    }

    return isDeepEqual(loose ? omitText(text) : text, loose ? omitText(another) : another);
  },

  /**
   * Check if a value implements the `Text` interface.
   */
  isText(value) {
    return (0,is_plain_object__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .P)(value) && typeof value.text === 'string';
  },

  /**
   * Check if a value is a list of `Text` objects.
   */
  isTextList(value) {
    return Array.isArray(value) && value.every(val => Text.isText(val));
  },

  /**
   * Check if some props are a partial of Text.
   */
  isTextProps(props) {
    return props.text !== undefined;
  },

  /**
   * Check if an text matches set of properties.
   *
   * Note: this is for matching custom properties, and it does not ensure that
   * the `text` property are two nodes equal.
   */
  matches(text, props) {
    for (var key in props) {
      if (key === 'text') {
        continue;
      }

      if (!text.hasOwnProperty(key) || text[key] !== props[key]) {
        return false;
      }
    }

    return true;
  },

  /**
   * Get the leaves for a text node given decorations.
   */
  decorations(node, decorations) {
    var leaves = [_objectSpread$4({}, node)];

    for (var dec of decorations) {
      var rest = _objectWithoutProperties(dec, _excluded2$1);

      var [start, end] = Range.edges(dec);
      var next = [];
      var o = 0;

      for (var leaf of leaves) {
        var {
          length
        } = leaf.text;
        var offset = o;
        o += length; // If the range encompases the entire leaf, add the range.

        if (start.offset <= offset && end.offset >= o) {
          Object.assign(leaf, rest);
          next.push(leaf);
          continue;
        } // If the range expanded and match the leaf, or starts after, or ends before it, continue.


        if (start.offset !== end.offset && (start.offset === o || end.offset === offset) || start.offset > o || end.offset < offset || end.offset === offset && offset !== 0) {
          next.push(leaf);
          continue;
        } // Otherwise we need to split the leaf, at the start, end, or both,
        // and add the range to the middle intersecting section. Do the end
        // split first since we don't need to update the offset that way.


        var middle = leaf;
        var before = void 0;
        var after = void 0;

        if (end.offset < o) {
          var off = end.offset - offset;
          after = _objectSpread$4(_objectSpread$4({}, middle), {}, {
            text: middle.text.slice(off)
          });
          middle = _objectSpread$4(_objectSpread$4({}, middle), {}, {
            text: middle.text.slice(0, off)
          });
        }

        if (start.offset > offset) {
          var _off = start.offset - offset;

          before = _objectSpread$4(_objectSpread$4({}, middle), {}, {
            text: middle.text.slice(0, _off)
          });
          middle = _objectSpread$4(_objectSpread$4({}, middle), {}, {
            text: middle.text.slice(_off)
          });
        }

        Object.assign(middle, rest);

        if (before) {
          next.push(before);
        }

        next.push(middle);

        if (after) {
          next.push(after);
        }
      }

      leaves = next;
    }

    return leaves;
  }

};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var applyToDraft = (editor, selection, op) => {
  switch (op.type) {
    case 'insert_node':
      {
        var {
          path,
          node
        } = op;
        var parent = Node.parent(editor, path);
        var index = path[path.length - 1];

        if (index > parent.children.length) {
          throw new Error("Cannot apply an \"insert_node\" operation at path [".concat(path, "] because the destination is past the end of the node."));
        }

        parent.children.splice(index, 0, node);

        if (selection) {
          for (var [point, key] of Range.points(selection)) {
            selection[key] = Point.transform(point, op);
          }
        }

        break;
      }

    case 'insert_text':
      {
        var {
          path: _path,
          offset,
          text
        } = op;
        if (text.length === 0) break;

        var _node = Node.leaf(editor, _path);

        var before = _node.text.slice(0, offset);

        var after = _node.text.slice(offset);

        _node.text = before + text + after;

        if (selection) {
          for (var [_point, _key] of Range.points(selection)) {
            selection[_key] = Point.transform(_point, op);
          }
        }

        break;
      }

    case 'merge_node':
      {
        var {
          path: _path2
        } = op;

        var _node2 = Node.get(editor, _path2);

        var prevPath = Path.previous(_path2);
        var prev = Node.get(editor, prevPath);

        var _parent = Node.parent(editor, _path2);

        var _index = _path2[_path2.length - 1];

        if (Text.isText(_node2) && Text.isText(prev)) {
          prev.text += _node2.text;
        } else if (!Text.isText(_node2) && !Text.isText(prev)) {
          prev.children.push(..._node2.children);
        } else {
          throw new Error("Cannot apply a \"merge_node\" operation at path [".concat(_path2, "] to nodes of different interfaces: ").concat(_node2, " ").concat(prev));
        }

        _parent.children.splice(_index, 1);

        if (selection) {
          for (var [_point2, _key2] of Range.points(selection)) {
            selection[_key2] = Point.transform(_point2, op);
          }
        }

        break;
      }

    case 'move_node':
      {
        var {
          path: _path3,
          newPath
        } = op;

        if (Path.isAncestor(_path3, newPath)) {
          throw new Error("Cannot move a path [".concat(_path3, "] to new path [").concat(newPath, "] because the destination is inside itself."));
        }

        var _node3 = Node.get(editor, _path3);

        var _parent2 = Node.parent(editor, _path3);

        var _index2 = _path3[_path3.length - 1]; // This is tricky, but since the `path` and `newPath` both refer to
        // the same snapshot in time, there's a mismatch. After either
        // removing the original position, the second step's path can be out
        // of date. So instead of using the `op.newPath` directly, we
        // transform `op.path` to ascertain what the `newPath` would be after
        // the operation was applied.

        _parent2.children.splice(_index2, 1);

        var truePath = Path.transform(_path3, op);
        var newParent = Node.get(editor, Path.parent(truePath));
        var newIndex = truePath[truePath.length - 1];
        newParent.children.splice(newIndex, 0, _node3);

        if (selection) {
          for (var [_point3, _key3] of Range.points(selection)) {
            selection[_key3] = Point.transform(_point3, op);
          }
        }

        break;
      }

    case 'remove_node':
      {
        var {
          path: _path4
        } = op;
        var _index3 = _path4[_path4.length - 1];

        var _parent3 = Node.parent(editor, _path4);

        _parent3.children.splice(_index3, 1); // Transform all of the points in the value, but if the point was in the
        // node that was removed we need to update the range or remove it.


        if (selection) {
          for (var [_point4, _key4] of Range.points(selection)) {
            var result = Point.transform(_point4, op);

            if (selection != null && result != null) {
              selection[_key4] = result;
            } else {
              var _prev = void 0;

              var next = void 0;

              for (var [n, p] of Node.texts(editor)) {
                if (Path.compare(p, _path4) === -1) {
                  _prev = [n, p];
                } else {
                  next = [n, p];
                  break;
                }
              }

              var preferNext = false;

              if (_prev && next) {
                if (Path.equals(next[1], _path4)) {
                  preferNext = !Path.hasPrevious(next[1]);
                } else {
                  preferNext = Path.common(_prev[1], _path4).length < Path.common(next[1], _path4).length;
                }
              }

              if (_prev && !preferNext) {
                _point4.path = _prev[1];
                _point4.offset = _prev[0].text.length;
              } else if (next) {
                _point4.path = next[1];
                _point4.offset = 0;
              } else {
                selection = null;
              }
            }
          }
        }

        break;
      }

    case 'remove_text':
      {
        var {
          path: _path5,
          offset: _offset,
          text: _text
        } = op;
        if (_text.length === 0) break;

        var _node4 = Node.leaf(editor, _path5);

        var _before = _node4.text.slice(0, _offset);

        var _after = _node4.text.slice(_offset + _text.length);

        _node4.text = _before + _after;

        if (selection) {
          for (var [_point5, _key5] of Range.points(selection)) {
            selection[_key5] = Point.transform(_point5, op);
          }
        }

        break;
      }

    case 'set_node':
      {
        var {
          path: _path6,
          properties,
          newProperties
        } = op;

        if (_path6.length === 0) {
          throw new Error("Cannot set properties on the root node!");
        }

        var _node5 = Node.get(editor, _path6);

        for (var _key6 in newProperties) {
          if (_key6 === 'children' || _key6 === 'text') {
            throw new Error("Cannot set the \"".concat(_key6, "\" property of nodes!"));
          }

          var value = newProperties[_key6];

          if (value == null) {
            delete _node5[_key6];
          } else {
            _node5[_key6] = value;
          }
        } // properties that were previously defined, but are now missing, must be deleted


        for (var _key7 in properties) {
          if (!newProperties.hasOwnProperty(_key7)) {
            delete _node5[_key7];
          }
        }

        break;
      }

    case 'set_selection':
      {
        var {
          newProperties: _newProperties
        } = op;

        if (_newProperties == null) {
          selection = _newProperties;
        } else {
          if (selection == null) {
            if (!Range.isRange(_newProperties)) {
              throw new Error("Cannot apply an incomplete \"set_selection\" operation properties ".concat(JSON.stringify(_newProperties), " when there is no current selection."));
            }

            selection = _objectSpread$3({}, _newProperties);
          }

          for (var _key8 in _newProperties) {
            var _value = _newProperties[_key8];

            if (_value == null) {
              if (_key8 === 'anchor' || _key8 === 'focus') {
                throw new Error("Cannot remove the \"".concat(_key8, "\" selection property"));
              }

              delete selection[_key8];
            } else {
              selection[_key8] = _value;
            }
          }
        }

        break;
      }

    case 'split_node':
      {
        var {
          path: _path7,
          position,
          properties: _properties
        } = op;

        if (_path7.length === 0) {
          throw new Error("Cannot apply a \"split_node\" operation at path [".concat(_path7, "] because the root node cannot be split."));
        }

        var _node6 = Node.get(editor, _path7);

        var _parent4 = Node.parent(editor, _path7);

        var _index4 = _path7[_path7.length - 1];
        var newNode;

        if (Text.isText(_node6)) {
          var _before2 = _node6.text.slice(0, position);

          var _after2 = _node6.text.slice(position);

          _node6.text = _before2;
          newNode = _objectSpread$3(_objectSpread$3({}, _properties), {}, {
            text: _after2
          });
        } else {
          var _before3 = _node6.children.slice(0, position);

          var _after3 = _node6.children.slice(position);

          _node6.children = _before3;
          newNode = _objectSpread$3(_objectSpread$3({}, _properties), {}, {
            children: _after3
          });
        }

        _parent4.children.splice(_index4 + 1, 0, newNode);

        if (selection) {
          for (var [_point6, _key9] of Range.points(selection)) {
            selection[_key9] = Point.transform(_point6, op);
          }
        }

        break;
      }
  }

  return selection;
};

var GeneralTransforms = {
  /**
   * Transform the editor by an operation.
   */
  transform(editor, op) {
    editor.children = (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .createDraft */ .P2)(editor.children);
    var selection = editor.selection && (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .createDraft */ .P2)(editor.selection);

    try {
      selection = applyToDraft(editor, selection, op);
    } finally {
      editor.children = (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .finishDraft */ ._x)(editor.children);

      if (selection) {
        editor.selection = (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .isDraft */ .mv)(selection) ? (0,immer__WEBPACK_IMPORTED_MODULE_1__/* .finishDraft */ ._x)(selection) : selection;
      } else {
        editor.selection = null;
      }
    }
  }

};

var _excluded = ["text"],
    _excluded2 = ["children"];

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var NodeTransforms = {
  /**
   * Insert nodes at a specific location in the Editor.
   */
  insertNodes(editor, nodes) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        hanging = false,
        voids = false,
        mode = 'lowest'
      } = options;
      var {
        at,
        match,
        select
      } = options;

      if (Node.isNode(nodes)) {
        nodes = [nodes];
      }

      if (nodes.length === 0) {
        return;
      }

      var [node] = nodes; // By default, use the selection as the target location. But if there is
      // no selection, insert at the end of the document since that is such a
      // common use case when inserting from a non-selected state.

      if (!at) {
        if (editor.selection) {
          at = editor.selection;
        } else if (editor.children.length > 0) {
          at = Editor.end(editor, []);
        } else {
          at = [0];
        }

        select = true;
      }

      if (select == null) {
        select = false;
      }

      if (Range.isRange(at)) {
        if (!hanging) {
          at = Editor.unhangRange(editor, at);
        }

        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var [, end] = Range.edges(at);
          var pointRef = Editor.pointRef(editor, end);
          Transforms.delete(editor, {
            at
          });
          at = pointRef.unref();
        }
      }

      if (Point.isPoint(at)) {
        if (match == null) {
          if (Text.isText(node)) {
            match = n => Text.isText(n);
          } else if (editor.isInline(node)) {
            match = n => Text.isText(n) || Editor.isInline(editor, n);
          } else {
            match = n => Editor.isBlock(editor, n);
          }
        }

        var [entry] = Editor.nodes(editor, {
          at: at.path,
          match,
          mode,
          voids
        });

        if (entry) {
          var [, _matchPath] = entry;
          var pathRef = Editor.pathRef(editor, _matchPath);
          var isAtEnd = Editor.isEnd(editor, at, _matchPath);
          Transforms.splitNodes(editor, {
            at,
            match,
            mode,
            voids
          });
          var path = pathRef.unref();
          at = isAtEnd ? Path.next(path) : path;
        } else {
          return;
        }
      }

      var parentPath = Path.parent(at);
      var index = at[at.length - 1];

      if (!voids && Editor.void(editor, {
        at: parentPath
      })) {
        return;
      }

      for (var _node of nodes) {
        var _path = parentPath.concat(index);

        index++;
        editor.apply({
          type: 'insert_node',
          path: _path,
          node: _node
        });
        at = Path.next(at);
      }

      at = Path.previous(at);

      if (select) {
        var point = Editor.end(editor, at);

        if (point) {
          Transforms.select(editor, point);
        }
      }
    });
  },

  /**
   * Lift nodes at a specific location upwards in the document tree, splitting
   * their parent in two if necessary.
   */
  liftNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        at = editor.selection,
        mode = 'lowest',
        voids = false
      } = options;
      var {
        match
      } = options;

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : n => Editor.isBlock(editor, n);
      }

      if (!at) {
        return;
      }

      var matches = Editor.nodes(editor, {
        at,
        match,
        mode,
        voids
      });
      var pathRefs = Array.from(matches, _ref => {
        var [, p] = _ref;
        return Editor.pathRef(editor, p);
      });

      for (var pathRef of pathRefs) {
        var path = pathRef.unref();

        if (path.length < 2) {
          throw new Error("Cannot lift node at a path [".concat(path, "] because it has a depth of less than `2`."));
        }

        var parentNodeEntry = Editor.node(editor, Path.parent(path));
        var [parent, parentPath] = parentNodeEntry;
        var index = path[path.length - 1];
        var {
          length
        } = parent.children;

        if (length === 1) {
          var toPath = Path.next(parentPath);
          Transforms.moveNodes(editor, {
            at: path,
            to: toPath,
            voids
          });
          Transforms.removeNodes(editor, {
            at: parentPath,
            voids
          });
        } else if (index === 0) {
          Transforms.moveNodes(editor, {
            at: path,
            to: parentPath,
            voids
          });
        } else if (index === length - 1) {
          var _toPath = Path.next(parentPath);

          Transforms.moveNodes(editor, {
            at: path,
            to: _toPath,
            voids
          });
        } else {
          var splitPath = Path.next(path);

          var _toPath2 = Path.next(parentPath);

          Transforms.splitNodes(editor, {
            at: splitPath,
            voids
          });
          Transforms.moveNodes(editor, {
            at: path,
            to: _toPath2,
            voids
          });
        }
      }
    });
  },

  /**
   * Merge a node at a location with the previous node of the same depth,
   * removing any empty containing nodes after the merge if necessary.
   */
  mergeNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        match,
        at = editor.selection
      } = options;
      var {
        hanging = false,
        voids = false,
        mode = 'lowest'
      } = options;

      if (!at) {
        return;
      }

      if (match == null) {
        if (Path.isPath(at)) {
          var [parent] = Editor.parent(editor, at);

          match = n => parent.children.includes(n);
        } else {
          match = n => Editor.isBlock(editor, n);
        }
      }

      if (!hanging && Range.isRange(at)) {
        at = Editor.unhangRange(editor, at);
      }

      if (Range.isRange(at)) {
        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var [, end] = Range.edges(at);
          var pointRef = Editor.pointRef(editor, end);
          Transforms.delete(editor, {
            at
          });
          at = pointRef.unref();

          if (options.at == null) {
            Transforms.select(editor, at);
          }
        }
      }

      var [current] = Editor.nodes(editor, {
        at,
        match,
        voids,
        mode
      });
      var prev = Editor.previous(editor, {
        at,
        match,
        voids,
        mode
      });

      if (!current || !prev) {
        return;
      }

      var [node, path] = current;
      var [prevNode, prevPath] = prev;

      if (path.length === 0 || prevPath.length === 0) {
        return;
      }

      var newPath = Path.next(prevPath);
      var commonPath = Path.common(path, prevPath);
      var isPreviousSibling = Path.isSibling(path, prevPath);
      var levels = Array.from(Editor.levels(editor, {
        at: path
      }), _ref2 => {
        var [n] = _ref2;
        return n;
      }).slice(commonPath.length).slice(0, -1); // Determine if the merge will leave an ancestor of the path empty as a
      // result, in which case we'll want to remove it after merging.

      var emptyAncestor = Editor.above(editor, {
        at: path,
        mode: 'highest',
        match: n => levels.includes(n) && hasSingleChildNest(editor, n)
      });
      var emptyRef = emptyAncestor && Editor.pathRef(editor, emptyAncestor[1]);
      var properties;
      var position; // Ensure that the nodes are equivalent, and figure out what the position
      // and extra properties of the merge will be.

      if (Text.isText(node) && Text.isText(prevNode)) {
        var rest = _objectWithoutProperties(node, _excluded);

        position = prevNode.text.length;
        properties = rest;
      } else if (Element.isElement(node) && Element.isElement(prevNode)) {
        var rest = _objectWithoutProperties(node, _excluded2);

        position = prevNode.children.length;
        properties = rest;
      } else {
        throw new Error("Cannot merge the node at path [".concat(path, "] with the previous sibling because it is not the same kind: ").concat(JSON.stringify(node), " ").concat(JSON.stringify(prevNode)));
      } // If the node isn't already the next sibling of the previous node, move
      // it so that it is before merging.


      if (!isPreviousSibling) {
        Transforms.moveNodes(editor, {
          at: path,
          to: newPath,
          voids
        });
      } // If there was going to be an empty ancestor of the node that was merged,
      // we remove it from the tree.


      if (emptyRef) {
        Transforms.removeNodes(editor, {
          at: emptyRef.current,
          voids
        });
      } // If the target node that we're merging with is empty, remove it instead
      // of merging the two. This is a common rich text editor behavior to
      // prevent losing formatting when deleting entire nodes when you have a
      // hanging selection.
      // if prevNode is first child in parent,don't remove it.


      if (Element.isElement(prevNode) && Editor.isEmpty(editor, prevNode) || Text.isText(prevNode) && prevNode.text === '' && prevPath[prevPath.length - 1] !== 0) {
        Transforms.removeNodes(editor, {
          at: prevPath,
          voids
        });
      } else {
        editor.apply({
          type: 'merge_node',
          path: newPath,
          position,
          properties
        });
      }

      if (emptyRef) {
        emptyRef.unref();
      }
    });
  },

  /**
   * Move the nodes at a location to a new location.
   */
  moveNodes(editor, options) {
    Editor.withoutNormalizing(editor, () => {
      var {
        to,
        at = editor.selection,
        mode = 'lowest',
        voids = false
      } = options;
      var {
        match
      } = options;

      if (!at) {
        return;
      }

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : n => Editor.isBlock(editor, n);
      }

      var toRef = Editor.pathRef(editor, to);
      var targets = Editor.nodes(editor, {
        at,
        match,
        mode,
        voids
      });
      var pathRefs = Array.from(targets, _ref3 => {
        var [, p] = _ref3;
        return Editor.pathRef(editor, p);
      });

      for (var pathRef of pathRefs) {
        var path = pathRef.unref();
        var newPath = toRef.current;

        if (path.length !== 0) {
          editor.apply({
            type: 'move_node',
            path,
            newPath
          });
        }

        if (toRef.current && Path.isSibling(newPath, path) && Path.isAfter(newPath, path)) {
          // When performing a sibling move to a later index, the path at the destination is shifted
          // to before the insertion point instead of after. To ensure our group of nodes are inserted
          // in the correct order we increment toRef to account for that
          toRef.current = Path.next(toRef.current);
        }
      }

      toRef.unref();
    });
  },

  /**
   * Remove the nodes at a specific location in the document.
   */
  removeNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        hanging = false,
        voids = false,
        mode = 'lowest'
      } = options;
      var {
        at = editor.selection,
        match
      } = options;

      if (!at) {
        return;
      }

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : n => Editor.isBlock(editor, n);
      }

      if (!hanging && Range.isRange(at)) {
        at = Editor.unhangRange(editor, at);
      }

      var depths = Editor.nodes(editor, {
        at,
        match,
        mode,
        voids
      });
      var pathRefs = Array.from(depths, _ref4 => {
        var [, p] = _ref4;
        return Editor.pathRef(editor, p);
      });

      for (var pathRef of pathRefs) {
        var path = pathRef.unref();

        if (path) {
          var [node] = Editor.node(editor, path);
          editor.apply({
            type: 'remove_node',
            path,
            node
          });
        }
      }
    });
  },

  /**
   * Set new properties on the nodes at a location.
   */
  setNodes(editor, props) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        match,
        at = editor.selection,
        compare,
        merge
      } = options;
      var {
        hanging = false,
        mode = 'lowest',
        split = false,
        voids = false
      } = options;

      if (!at) {
        return;
      }

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : n => Editor.isBlock(editor, n);
      }

      if (!hanging && Range.isRange(at)) {
        at = Editor.unhangRange(editor, at);
      }

      if (split && Range.isRange(at)) {
        if (Range.isCollapsed(at) && Editor.leaf(editor, at.anchor)[0].text.length > 0) {
          // If the range is collapsed in a non-empty node and 'split' is true, there's nothing to
          // set that won't get normalized away
          return;
        }

        var rangeRef = Editor.rangeRef(editor, at, {
          affinity: 'inward'
        });
        var [start, end] = Range.edges(at);
        var splitMode = mode === 'lowest' ? 'lowest' : 'highest';
        var endAtEndOfNode = Editor.isEnd(editor, end, end.path);
        Transforms.splitNodes(editor, {
          at: end,
          match,
          mode: splitMode,
          voids,
          always: !endAtEndOfNode
        });
        var startAtStartOfNode = Editor.isStart(editor, start, start.path);
        Transforms.splitNodes(editor, {
          at: start,
          match,
          mode: splitMode,
          voids,
          always: !startAtStartOfNode
        });
        at = rangeRef.unref();

        if (options.at == null) {
          Transforms.select(editor, at);
        }
      }

      if (!compare) {
        compare = (prop, nodeProp) => prop !== nodeProp;
      }

      for (var [node, path] of Editor.nodes(editor, {
        at,
        match,
        mode,
        voids
      })) {
        var properties = {};
        var newProperties = {}; // You can't set properties on the editor node.

        if (path.length === 0) {
          continue;
        }

        var hasChanges = false;

        for (var k in props) {
          if (k === 'children' || k === 'text') {
            continue;
          }

          if (compare(props[k], node[k])) {
            hasChanges = true; // Omit new properties from the old properties list

            if (node.hasOwnProperty(k)) properties[k] = node[k]; // Omit properties that have been removed from the new properties list

            if (merge) {
              if (props[k] != null) newProperties[k] = merge(node[k], props[k]);
            } else {
              if (props[k] != null) newProperties[k] = props[k];
            }
          }
        }

        if (hasChanges) {
          editor.apply({
            type: 'set_node',
            path,
            properties,
            newProperties
          });
        }
      }
    });
  },

  /**
   * Split the nodes at a specific location.
   */
  splitNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        mode = 'lowest',
        voids = false
      } = options;
      var {
        match,
        at = editor.selection,
        height = 0,
        always = false
      } = options;

      if (match == null) {
        match = n => Editor.isBlock(editor, n);
      }

      if (Range.isRange(at)) {
        at = deleteRange(editor, at);
      } // If the target is a path, the default height-skipping and position
      // counters need to account for us potentially splitting at a non-leaf.


      if (Path.isPath(at)) {
        var path = at;
        var point = Editor.point(editor, path);
        var [parent] = Editor.parent(editor, path);

        match = n => n === parent;

        height = point.path.length - path.length + 1;
        at = point;
        always = true;
      }

      if (!at) {
        return;
      }

      var beforeRef = Editor.pointRef(editor, at, {
        affinity: 'backward'
      });
      var afterRef;

      try {
        var [highest] = Editor.nodes(editor, {
          at,
          match,
          mode,
          voids
        });

        if (!highest) {
          return;
        }

        var voidMatch = Editor.void(editor, {
          at,
          mode: 'highest'
        });
        var nudge = 0;

        if (!voids && voidMatch) {
          var [voidNode, voidPath] = voidMatch;

          if (Element.isElement(voidNode) && editor.isInline(voidNode)) {
            var after = Editor.after(editor, voidPath);

            if (!after) {
              var text = {
                text: ''
              };
              var afterPath = Path.next(voidPath);
              Transforms.insertNodes(editor, text, {
                at: afterPath,
                voids
              });
              after = Editor.point(editor, afterPath);
            }

            at = after;
            always = true;
          }

          var siblingHeight = at.path.length - voidPath.length;
          height = siblingHeight + 1;
          always = true;
        }

        afterRef = Editor.pointRef(editor, at);
        var depth = at.path.length - height;
        var [, highestPath] = highest;
        var lowestPath = at.path.slice(0, depth);
        var position = height === 0 ? at.offset : at.path[depth] + nudge;

        for (var [node, _path2] of Editor.levels(editor, {
          at: lowestPath,
          reverse: true,
          voids
        })) {
          var split = false;

          if (_path2.length < highestPath.length || _path2.length === 0 || !voids && Editor.isVoid(editor, node)) {
            break;
          }

          var _point = beforeRef.current;
          var isEnd = Editor.isEnd(editor, _point, _path2);

          if (always || !beforeRef || !Editor.isEdge(editor, _point, _path2)) {
            split = true;
            var properties = Node.extractProps(node);
            editor.apply({
              type: 'split_node',
              path: _path2,
              position,
              properties
            });
          }

          position = _path2[_path2.length - 1] + (split || isEnd ? 1 : 0);
        }

        if (options.at == null) {
          var _point2 = afterRef.current || Editor.end(editor, []);

          Transforms.select(editor, _point2);
        }
      } finally {
        var _afterRef;

        beforeRef.unref();
        (_afterRef = afterRef) === null || _afterRef === void 0 ? void 0 : _afterRef.unref();
      }
    });
  },

  /**
   * Unset properties on the nodes at a location.
   */
  unsetNodes(editor, props) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!Array.isArray(props)) {
      props = [props];
    }

    var obj = {};

    for (var key of props) {
      obj[key] = null;
    }

    Transforms.setNodes(editor, obj, options);
  },

  /**
   * Unwrap the nodes at a location from a parent node, splitting the parent if
   * necessary to ensure that only the content in the range is unwrapped.
   */
  unwrapNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        mode = 'lowest',
        split = false,
        voids = false
      } = options;
      var {
        at = editor.selection,
        match
      } = options;

      if (!at) {
        return;
      }

      if (match == null) {
        match = Path.isPath(at) ? matchPath(editor, at) : n => Editor.isBlock(editor, n);
      }

      if (Path.isPath(at)) {
        at = Editor.range(editor, at);
      }

      var rangeRef = Range.isRange(at) ? Editor.rangeRef(editor, at) : null;
      var matches = Editor.nodes(editor, {
        at,
        match,
        mode,
        voids
      });
      var pathRefs = Array.from(matches, _ref5 => {
        var [, p] = _ref5;
        return Editor.pathRef(editor, p);
      } // unwrapNode will call liftNode which does not support splitting the node when nested.
      // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
      // that wrap target node. So we reverse the order.
      ).reverse();

      var _loop = function _loop(pathRef) {
        var path = pathRef.unref();
        var [node] = Editor.node(editor, path);
        var range = Editor.range(editor, path);

        if (split && rangeRef) {
          range = Range.intersection(rangeRef.current, range);
        }

        Transforms.liftNodes(editor, {
          at: range,
          match: n => Element.isAncestor(node) && node.children.includes(n),
          voids
        });
      };

      for (var pathRef of pathRefs) {
        _loop(pathRef);
      }

      if (rangeRef) {
        rangeRef.unref();
      }
    });
  },

  /**
   * Wrap the nodes at a location in a new container node, splitting the edges
   * of the range first to ensure that only the content in the range is wrapped.
   */
  wrapNodes(editor, element) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        mode = 'lowest',
        split = false,
        voids = false
      } = options;
      var {
        match,
        at = editor.selection
      } = options;

      if (!at) {
        return;
      }

      if (match == null) {
        if (Path.isPath(at)) {
          match = matchPath(editor, at);
        } else if (editor.isInline(element)) {
          match = n => Editor.isInline(editor, n) || Text.isText(n);
        } else {
          match = n => Editor.isBlock(editor, n);
        }
      }

      if (split && Range.isRange(at)) {
        var [start, end] = Range.edges(at);
        var rangeRef = Editor.rangeRef(editor, at, {
          affinity: 'inward'
        });
        Transforms.splitNodes(editor, {
          at: end,
          match,
          voids
        });
        Transforms.splitNodes(editor, {
          at: start,
          match,
          voids
        });
        at = rangeRef.unref();

        if (options.at == null) {
          Transforms.select(editor, at);
        }
      }

      var roots = Array.from(Editor.nodes(editor, {
        at,
        match: editor.isInline(element) ? n => Editor.isBlock(editor, n) : n => Editor.isEditor(n),
        mode: 'lowest',
        voids
      }));

      for (var [, rootPath] of roots) {
        var a = Range.isRange(at) ? Range.intersection(at, Editor.range(editor, rootPath)) : at;

        if (!a) {
          continue;
        }

        var matches = Array.from(Editor.nodes(editor, {
          at: a,
          match,
          mode,
          voids
        }));

        if (matches.length > 0) {
          var _ret = function () {
            var [first] = matches;
            var last = matches[matches.length - 1];
            var [, firstPath] = first;
            var [, lastPath] = last;

            if (firstPath.length === 0 && lastPath.length === 0) {
              // if there's no matching parent - usually means the node is an editor - don't do anything
              return "continue";
            }

            var commonPath = Path.equals(firstPath, lastPath) ? Path.parent(firstPath) : Path.common(firstPath, lastPath);
            var range = Editor.range(editor, firstPath, lastPath);
            var commonNodeEntry = Editor.node(editor, commonPath);
            var [commonNode] = commonNodeEntry;
            var depth = commonPath.length + 1;
            var wrapperPath = Path.next(lastPath.slice(0, depth));

            var wrapper = _objectSpread$2(_objectSpread$2({}, element), {}, {
              children: []
            });

            Transforms.insertNodes(editor, wrapper, {
              at: wrapperPath,
              voids
            });
            Transforms.moveNodes(editor, {
              at: range,
              match: n => Element.isAncestor(commonNode) && commonNode.children.includes(n),
              to: wrapperPath.concat(0),
              voids
            });
          }();

          if (_ret === "continue") continue;
        }
      }
    });
  }

};

var hasSingleChildNest = (editor, node) => {
  if (Element.isElement(node)) {
    var element = node;

    if (Editor.isVoid(editor, node)) {
      return true;
    } else if (element.children.length === 1) {
      return hasSingleChildNest(editor, element.children[0]);
    } else {
      return false;
    }
  } else if (Editor.isEditor(node)) {
    return false;
  } else {
    return true;
  }
};
/**
 * Convert a range into a point by deleting it's content.
 */


var deleteRange = (editor, range) => {
  if (Range.isCollapsed(range)) {
    return range.anchor;
  } else {
    var [, end] = Range.edges(range);
    var pointRef = Editor.pointRef(editor, end);
    Transforms.delete(editor, {
      at: range
    });
    return pointRef.unref();
  }
};

var matchPath = (editor, path) => {
  var [node] = Editor.node(editor, path);
  return n => n === node;
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var SelectionTransforms = {
  /**
   * Collapse the selection.
   */
  collapse(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      edge = 'anchor'
    } = options;
    var {
      selection
    } = editor;

    if (!selection) {
      return;
    } else if (edge === 'anchor') {
      Transforms.select(editor, selection.anchor);
    } else if (edge === 'focus') {
      Transforms.select(editor, selection.focus);
    } else if (edge === 'start') {
      var [start] = Range.edges(selection);
      Transforms.select(editor, start);
    } else if (edge === 'end') {
      var [, end] = Range.edges(selection);
      Transforms.select(editor, end);
    }
  },

  /**
   * Unset the selection.
   */
  deselect(editor) {
    var {
      selection
    } = editor;

    if (selection) {
      editor.apply({
        type: 'set_selection',
        properties: selection,
        newProperties: null
      });
    }
  },

  /**
   * Move the selection's point forward or backward.
   */
  move(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var {
      selection
    } = editor;
    var {
      distance = 1,
      unit = 'character',
      reverse = false
    } = options;
    var {
      edge = null
    } = options;

    if (!selection) {
      return;
    }

    if (edge === 'start') {
      edge = Range.isBackward(selection) ? 'focus' : 'anchor';
    }

    if (edge === 'end') {
      edge = Range.isBackward(selection) ? 'anchor' : 'focus';
    }

    var {
      anchor,
      focus
    } = selection;
    var opts = {
      distance,
      unit
    };
    var props = {};

    if (edge == null || edge === 'anchor') {
      var point = reverse ? Editor.before(editor, anchor, opts) : Editor.after(editor, anchor, opts);

      if (point) {
        props.anchor = point;
      }
    }

    if (edge == null || edge === 'focus') {
      var _point = reverse ? Editor.before(editor, focus, opts) : Editor.after(editor, focus, opts);

      if (_point) {
        props.focus = _point;
      }
    }

    Transforms.setSelection(editor, props);
  },

  /**
   * Set the selection to a new value.
   */
  select(editor, target) {
    var {
      selection
    } = editor;
    target = Editor.range(editor, target);

    if (selection) {
      Transforms.setSelection(editor, target);
      return;
    }

    if (!Range.isRange(target)) {
      throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(JSON.stringify(target)));
    }

    editor.apply({
      type: 'set_selection',
      properties: selection,
      newProperties: target
    });
  },

  /**
   * Set new properties on one of the selection's points.
   */
  setPoint(editor, props) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var {
      selection
    } = editor;
    var {
      edge = 'both'
    } = options;

    if (!selection) {
      return;
    }

    if (edge === 'start') {
      edge = Range.isBackward(selection) ? 'focus' : 'anchor';
    }

    if (edge === 'end') {
      edge = Range.isBackward(selection) ? 'anchor' : 'focus';
    }

    var {
      anchor,
      focus
    } = selection;
    var point = edge === 'anchor' ? anchor : focus;
    Transforms.setSelection(editor, {
      [edge === 'anchor' ? 'anchor' : 'focus']: _objectSpread$1(_objectSpread$1({}, point), props)
    });
  },

  /**
   * Set new properties on the selection.
   */
  setSelection(editor, props) {
    var {
      selection
    } = editor;
    var oldProps = {};
    var newProps = {};

    if (!selection) {
      return;
    }

    for (var k in props) {
      if (k === 'anchor' && props.anchor != null && !Point.equals(props.anchor, selection.anchor) || k === 'focus' && props.focus != null && !Point.equals(props.focus, selection.focus) || k !== 'anchor' && k !== 'focus' && props[k] !== selection[k]) {
        oldProps[k] = selection[k];
        newProps[k] = props[k];
      }
    }

    if (Object.keys(oldProps).length > 0) {
      editor.apply({
        type: 'set_selection',
        properties: oldProps,
        newProperties: newProps
      });
    }
  }

};

var TextTransforms = {
  /**
   * Delete content in the editor.
   */
  delete(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        reverse = false,
        unit = 'character',
        distance = 1,
        voids = false
      } = options;
      var {
        at = editor.selection,
        hanging = false
      } = options;

      if (!at) {
        return;
      }

      if (Range.isRange(at) && Range.isCollapsed(at)) {
        at = at.anchor;
      }

      if (Point.isPoint(at)) {
        var furthestVoid = Editor.void(editor, {
          at,
          mode: 'highest'
        });

        if (!voids && furthestVoid) {
          var [, voidPath] = furthestVoid;
          at = voidPath;
        } else {
          var opts = {
            unit,
            distance
          };
          var target = reverse ? Editor.before(editor, at, opts) || Editor.start(editor, []) : Editor.after(editor, at, opts) || Editor.end(editor, []);
          at = {
            anchor: at,
            focus: target
          };
          hanging = true;
        }
      }

      if (Path.isPath(at)) {
        Transforms.removeNodes(editor, {
          at,
          voids
        });
        return;
      }

      if (Range.isCollapsed(at)) {
        return;
      }

      if (!hanging) {
        var [, _end] = Range.edges(at);
        var endOfDoc = Editor.end(editor, []);

        if (!Point.equals(_end, endOfDoc)) {
          at = Editor.unhangRange(editor, at, {
            voids
          });
        }
      }

      var [start, end] = Range.edges(at);
      var startBlock = Editor.above(editor, {
        match: n => Editor.isBlock(editor, n),
        at: start,
        voids
      });
      var endBlock = Editor.above(editor, {
        match: n => Editor.isBlock(editor, n),
        at: end,
        voids
      });
      var isAcrossBlocks = startBlock && endBlock && !Path.equals(startBlock[1], endBlock[1]);
      var isSingleText = Path.equals(start.path, end.path);
      var startVoid = voids ? null : Editor.void(editor, {
        at: start,
        mode: 'highest'
      });
      var endVoid = voids ? null : Editor.void(editor, {
        at: end,
        mode: 'highest'
      }); // If the start or end points are inside an inline void, nudge them out.

      if (startVoid) {
        var before = Editor.before(editor, start);

        if (before && startBlock && Path.isAncestor(startBlock[1], before.path)) {
          start = before;
        }
      }

      if (endVoid) {
        var after = Editor.after(editor, end);

        if (after && endBlock && Path.isAncestor(endBlock[1], after.path)) {
          end = after;
        }
      } // Get the highest nodes that are completely inside the range, as well as
      // the start and end nodes.


      var matches = [];
      var lastPath;

      for (var entry of Editor.nodes(editor, {
        at,
        voids
      })) {
        var [node, path] = entry;

        if (lastPath && Path.compare(path, lastPath) === 0) {
          continue;
        }

        if (!voids && Editor.isVoid(editor, node) || !Path.isCommon(path, start.path) && !Path.isCommon(path, end.path)) {
          matches.push(entry);
          lastPath = path;
        }
      }

      var pathRefs = Array.from(matches, _ref => {
        var [, p] = _ref;
        return Editor.pathRef(editor, p);
      });
      var startRef = Editor.pointRef(editor, start);
      var endRef = Editor.pointRef(editor, end);

      if (!isSingleText && !startVoid) {
        var _point = startRef.current;
        var [_node] = Editor.leaf(editor, _point);
        var {
          path: _path
        } = _point;
        var {
          offset
        } = start;

        var text = _node.text.slice(offset);

        if (text.length > 0) editor.apply({
          type: 'remove_text',
          path: _path,
          offset,
          text
        });
      }

      for (var pathRef of pathRefs) {
        var _path2 = pathRef.unref();

        Transforms.removeNodes(editor, {
          at: _path2,
          voids
        });
      }

      if (!endVoid) {
        var _point2 = endRef.current;
        var [_node2] = Editor.leaf(editor, _point2);
        var {
          path: _path3
        } = _point2;

        var _offset = isSingleText ? start.offset : 0;

        var _text = _node2.text.slice(_offset, end.offset);

        if (_text.length > 0) editor.apply({
          type: 'remove_text',
          path: _path3,
          offset: _offset,
          text: _text
        });
      }

      if (!isSingleText && isAcrossBlocks && endRef.current && startRef.current) {
        Transforms.mergeNodes(editor, {
          at: endRef.current,
          hanging: true,
          voids
        });
      }

      var startUnref = startRef.unref();
      var endUnref = endRef.unref();
      var point = reverse ? startUnref || endUnref : endUnref || startUnref;

      if (options.at == null && point) {
        Transforms.select(editor, point);
      }
    });
  },

  /**
   * Insert a fragment at a specific location in the editor.
   */
  insertFragment(editor, fragment) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        hanging = false,
        voids = false
      } = options;
      var {
        at = editor.selection
      } = options;

      if (!fragment.length) {
        return;
      }

      if (!at) {
        return;
      } else if (Range.isRange(at)) {
        if (!hanging) {
          at = Editor.unhangRange(editor, at);
        }

        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var [, end] = Range.edges(at);

          if (!voids && Editor.void(editor, {
            at: end
          })) {
            return;
          }

          var pointRef = Editor.pointRef(editor, end);
          Transforms.delete(editor, {
            at
          });
          at = pointRef.unref();
        }
      } else if (Path.isPath(at)) {
        at = Editor.start(editor, at);
      }

      if (!voids && Editor.void(editor, {
        at
      })) {
        return;
      } // If the insert point is at the edge of an inline node, move it outside
      // instead since it will need to be split otherwise.


      var inlineElementMatch = Editor.above(editor, {
        at,
        match: n => Editor.isInline(editor, n),
        mode: 'highest',
        voids
      });

      if (inlineElementMatch) {
        var [, _inlinePath] = inlineElementMatch;

        if (Editor.isEnd(editor, at, _inlinePath)) {
          var after = Editor.after(editor, _inlinePath);
          at = after;
        } else if (Editor.isStart(editor, at, _inlinePath)) {
          var before = Editor.before(editor, _inlinePath);
          at = before;
        }
      }

      var blockMatch = Editor.above(editor, {
        match: n => Editor.isBlock(editor, n),
        at,
        voids
      });
      var [, blockPath] = blockMatch;
      var isBlockStart = Editor.isStart(editor, at, blockPath);
      var isBlockEnd = Editor.isEnd(editor, at, blockPath);
      var isBlockEmpty = isBlockStart && isBlockEnd;
      var mergeStart = !isBlockStart || isBlockStart && isBlockEnd;
      var mergeEnd = !isBlockEnd;
      var [, firstPath] = Node.first({
        children: fragment
      }, []);
      var [, lastPath] = Node.last({
        children: fragment
      }, []);
      var matches = [];

      var matcher = _ref2 => {
        var [n, p] = _ref2;
        var isRoot = p.length === 0;

        if (isRoot) {
          return false;
        }

        if (isBlockEmpty) {
          return true;
        }

        if (mergeStart && Path.isAncestor(p, firstPath) && Element.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) {
          return false;
        }

        if (mergeEnd && Path.isAncestor(p, lastPath) && Element.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) {
          return false;
        }

        return true;
      };

      for (var entry of Node.nodes({
        children: fragment
      }, {
        pass: matcher
      })) {
        if (matcher(entry)) {
          matches.push(entry);
        }
      }

      var starts = [];
      var middles = [];
      var ends = [];
      var starting = true;
      var hasBlocks = false;

      for (var [node] of matches) {
        if (Element.isElement(node) && !editor.isInline(node)) {
          starting = false;
          hasBlocks = true;
          middles.push(node);
        } else if (starting) {
          starts.push(node);
        } else {
          ends.push(node);
        }
      }

      var [inlineMatch] = Editor.nodes(editor, {
        at,
        match: n => Text.isText(n) || Editor.isInline(editor, n),
        mode: 'highest',
        voids
      });
      var [, inlinePath] = inlineMatch;
      var isInlineStart = Editor.isStart(editor, at, inlinePath);
      var isInlineEnd = Editor.isEnd(editor, at, inlinePath);
      var middleRef = Editor.pathRef(editor, isBlockEnd ? Path.next(blockPath) : blockPath);
      var endRef = Editor.pathRef(editor, isInlineEnd ? Path.next(inlinePath) : inlinePath);
      var blockPathRef = Editor.pathRef(editor, blockPath);
      Transforms.splitNodes(editor, {
        at,
        match: n => hasBlocks ? Editor.isBlock(editor, n) : Text.isText(n) || Editor.isInline(editor, n),
        mode: hasBlocks ? 'lowest' : 'highest',
        voids
      });
      var startRef = Editor.pathRef(editor, !isInlineStart || isInlineStart && isInlineEnd ? Path.next(inlinePath) : inlinePath);
      Transforms.insertNodes(editor, starts, {
        at: startRef.current,
        match: n => Text.isText(n) || Editor.isInline(editor, n),
        mode: 'highest',
        voids
      });

      if (isBlockEmpty && middles.length) {
        Transforms.delete(editor, {
          at: blockPathRef.unref(),
          voids
        });
      }

      Transforms.insertNodes(editor, middles, {
        at: middleRef.current,
        match: n => Editor.isBlock(editor, n),
        mode: 'lowest',
        voids
      });
      Transforms.insertNodes(editor, ends, {
        at: endRef.current,
        match: n => Text.isText(n) || Editor.isInline(editor, n),
        mode: 'highest',
        voids
      });

      if (!options.at) {
        var path;

        if (ends.length > 0) {
          path = Path.previous(endRef.current);
        } else if (middles.length > 0) {
          path = Path.previous(middleRef.current);
        } else {
          path = Path.previous(startRef.current);
        }

        var _end2 = Editor.end(editor, path);

        Transforms.select(editor, _end2);
      }

      startRef.unref();
      middleRef.unref();
      endRef.unref();
    });
  },

  /**
   * Insert a string of text in the Editor.
   */
  insertText(editor, text) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        voids = false
      } = options;
      var {
        at = editor.selection
      } = options;

      if (!at) {
        return;
      }

      if (Path.isPath(at)) {
        at = Editor.range(editor, at);
      }

      if (Range.isRange(at)) {
        if (Range.isCollapsed(at)) {
          at = at.anchor;
        } else {
          var end = Range.end(at);

          if (!voids && Editor.void(editor, {
            at: end
          })) {
            return;
          }

          var pointRef = Editor.pointRef(editor, end);
          Transforms.delete(editor, {
            at,
            voids
          });
          at = pointRef.unref();
          Transforms.setSelection(editor, {
            anchor: at,
            focus: at
          });
        }
      }

      if (!voids && Editor.void(editor, {
        at
      })) {
        return;
      }

      var {
        path,
        offset
      } = at;
      if (text.length > 0) editor.apply({
        type: 'insert_text',
        path,
        offset,
        text
      });
    });
  }

};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Transforms = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, GeneralTransforms), NodeTransforms), SelectionTransforms), TextTransforms);


//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ 76854:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch] || charMap[ch] || ch;
        if (appendChar === replacement) {
          appendChar = ' ';
        }
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ }),

/***/ 9839:
/***/ (function(module) {

"use strict";


function hash(str) {
  var hash = 5381,
      i    = str.length;

  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}

module.exports = hash;


/***/ }),

/***/ 26021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f6": function() { return /* binding */ Fe; },
  "iv": function() { return /* binding */ Ce; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; },
  "F4": function() { return /* binding */ Ue; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, __PRIVATE__, createGlobalStyle, isStyledComponent, useTheme, version, withTheme

// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(48570);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(88665);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ../../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ../../node_modules/styled-components/node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

// EXTERNAL MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js
var emotion_is_prop_valid_esm = __webpack_require__(86015);
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(93542);
function v(){return(v=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var g=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},S=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},w=Object.freeze([]),E=Object.freeze({});function b(e){return"function"==typeof e}function _(e){return false||e.displayName||e.name||"Component"}function N(e){return e&&"string"==typeof e.styledComponentId}var A="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C="5.3.6",I="undefined"!=typeof window&&"HTMLElement"in window,P=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production"),O={},R= false?0:{};function D(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function j(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var T=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&j(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),x=new Map,k=new Map,V=1,B=function(e){if(x.has(e))return x.get(e);for(;k.has(V);)V++;var t=V++;return false&&0,x.set(e,t),k.set(t,e),t},z=function(e){return k.get(e)},M=function(e,t){t>=V&&(V=t+1),x.set(e,t),k.set(t,e)},G="style["+A+'][data-styled-version="5.3.6"]',L=new RegExp("^"+A+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),F=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},Y=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(L);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(M(u,c),F(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},q=function(){return true?__webpack_require__.nc:0},H=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(A))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(A,"active"),r.setAttribute("data-styled-version","5.3.6");var i=q();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},$=function(){function e(e){var t=this.element=H(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}j(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),W=function(){function e(e){var t=this.element=H(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),U=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),J=I,X={isServer:!I,useCSSOMInjection:!P},Z=function(){function e(e,t,n){void 0===e&&(e=E),void 0===t&&(t={}),this.options=v({},X,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&I&&J&&(J=!1,function(e){for(var t=document.querySelectorAll(G),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(A)&&(Y(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return B(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(v({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new U(o):r?new $(o):new W(o),new T(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(B(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(B(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(B(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=A+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),K=/(a)(d)/gi,Q=function(e){return String.fromCharCode(e+(e>25?39:97))};function ee(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=Q(t%52)+n;return(Q(t%52)+n).replace(K,"$1-$2")}var te=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},ne=function(e){return te(5381,e)};function re(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(b(n)&&!N(n))return!1}return!0}var oe=ne("5.3.6"),se=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&re(e),this.componentId=t,this.baseHash=te(oe,t),this.baseStyle=n,Z.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=Ne(this.rules,e,t,n).join(""),i=ee(te(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=te(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=Ne(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=te(u,f+d),l+=f}}if(l){var m=ee(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),ie=/^\s*\/\/.*$/gm,ae=[":","[",".","#"];function ce(e){var t,n,r,o,s=void 0===e?E:e,i=s.options,a=void 0===i?E:i,c=s.plugins,u=void 0===c?w:c,l=new stylis_browser_esm(a),d=[],h=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ae.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(ie,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},h,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||j(15),te(e,t.name)}),5381).toString():"",m}var ue=react.createContext(),le=ue.Consumer,de=react.createContext(),he=(de.Consumer,new Z),pe=ce();function fe(){return (0,react.useContext)(ue)||he}function me(){return (0,react.useContext)(de)||pe}function ye(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=fe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ce({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ue.Provider,{value:u},react.createElement(de.Provider,{value:l}, false?0:e.children))}var ve=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=pe);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return j(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=pe),this.name+e.hash},e}(),ge=/([A-Z])/,Se=/([A-Z])/g,we=/^ms-/,Ee=function(e){return"-"+e.toLowerCase()};function be(e){return ge.test(e)?e.replace(Se,Ee).replace(we,"-ms-"):e}var _e=function(e){return null==e||!1===e||""===e};function Ne(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=Ne(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(_e(e))return"";if(N(e))return"."+e.styledComponentId;if(b(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,Ne(u,n,r,o)}var l;return e instanceof ve?r?(e.inject(r,o),e.getName(o)):e:S(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!_e(t[i])&&(Array.isArray(t[i])&&t[i].isCss||b(t[i])?s.push(be(i)+":",t[i],";"):S(t[i])?s.push.apply(s,e(t[i],i)):s.push(be(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ae=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ce(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return b(e)||S(e)?Ae(Ne(g(w,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ae(Ne(g(e,n)))}var Ie=/invalid hook call/i,Pe=new Set,Oe=function(e,t){if(false){ var o, n, r; }},Re=function(e,t,n){return void 0===n&&(n=E),e.theme!==n.theme&&e.theme||t||n.theme},De=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,je=/(^-|-$)/g;function Te(e){return e.replace(De,"-").replace(je,"")}var xe=function(e){return ee(ne(e)>>>0)};function ke(e){return"string"==typeof e&&( true||0)}var Ve=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Be=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];Ve(t)&&Ve(r)?Me(r,t):e[n]=t}function Me(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(Ve(i))for(var a in i)Be(a)&&ze(e,i[a],a)}return e}var Ge=react.createContext(),Le=Ge.Consumer;function Fe(e){var t=(0,react.useContext)(Ge),n=(0,react.useMemo)((function(){return function(e,t){if(!e)return j(14);if(b(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?j(8):t?v({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?react.createElement(Ge.Provider,{value:n},e.children):null}var Ye={};function qe(e,t,n){var o=N(e),i=!ke(e),a=t.attrs,c=void 0===a?w:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":Te(e);Ye[n]=(Ye[n]||0)+1;var r=n+"-"+xe("5.3.6"+n+Ye[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,f=void 0===p?function(e){return ke(e)?"styled."+e:"Styled("+_(e)+")"}(e):p,g=t.displayName&&t.componentId?Te(t.displayName)+"-"+t.componentId:t.componentId||h,S=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new se(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target; false&&0;var f=function(e,t,n){void 0===e&&(e=E);var r=v({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in b(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Re(t,(0,react.useContext)(Ge),a)||E,t,o),y=f[0],g=f[1],S=function(e,t,n,r){var o=fe(),s=me(),i=t?e.generateAndInjectStyles(E,o,s):e.generateAndInjectStyles(n,o,s);return false&&0, false&&0,i}(i,r,y, false?0:void 0),w=n,_=g.$as||t.$as||g.as||t.as||p,N=ke(_),A=g!==t?v({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,emotion_is_prop_valid_esm/* default */.Z,_):!N||(0,emotion_is_prop_valid_esm/* default */.Z)(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=v({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=w,(0,react.createElement)(_,C)}(C,e,t,P)};return O.displayName=f,(C=react.forwardRef(O)).attrs=S,C.componentStyle=I,C.displayName=f,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):w,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(ke(e)?e:Te(_(e)));return qe(e,v({},o,{attrs:S,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Me({},e.defaultProps,t):t}}), false&&(0),C.toString=function(){return"."+C.styledComponentId},i&&hoist_non_react_statics_cjs_default()(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var He=function(e){return function e(t,r,o){if(void 0===o&&(o=E),!(0,react_is.isValidElementType)(r))return j(1,String(r));var s=function(){return t(r,o,Ce.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,v({},o,{},n))},s.attrs=function(n){return e(t,r,v({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(qe,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){He[e]=He(e)}));var $e=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=re(e),Z.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(Ne(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&Z.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function We(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ce.apply(void 0,[e].concat(n)),a="sc-global-"+xe(JSON.stringify(i)),u=new $e(i,a);function l(e){var t=fe(),n=me(),o=s(Ge),l=c(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(l,e,t,o,n),d((function(){if(!t.server)return h(l,e,t,o,n),function(){return u.removeStyles(l,t)}}),[l,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,O,n,o);else{var s=v({},t,{theme:Re(t,r,l.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,r.memo(l)}function Ue(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ce.apply(void 0,[e].concat(n)).join(""),s=xe(o);return new ve(s,o)}var Je=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=q();return"<style "+[n&&'nonce="'+n+'"',A+'="true"','data-styled-version="5.3.6"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?j(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return j(2);var n=((t={})[A]="",t["data-styled-version"]="5.3.6",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=q();return o&&(n.nonce=o),[react.createElement("style",v({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new Z({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?j(2):react.createElement(ye,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return j(3)},e}(),Xe=function(e){var t=r.forwardRef((function(t,n){var o=s(Ge),i=e.defaultProps,a=Re(t,o,i);return false&&0,r.createElement(e,v({},t,{theme:a,ref:n}))}));return y(t,e),t.displayName="WithTheme("+_(e)+")",t},Ze=function(){return s(Ge)},Ke={StyleSheet:Z,masterSheet:he}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (He);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 78545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$_": function() { return /* reexport */ color; },
  "GQ": function() { return /* reexport */ flexbox; },
  "bK": function() { return /* reexport */ layout; },
  "Dh": function() { return /* reexport */ space; },
  "cp": function() { return /* reexport */ typography; }
});

// UNUSED EXPORTS: alignContent, alignItems, alignSelf, background, backgroundImage, backgroundPosition, backgroundRepeat, backgroundSize, border, borderBottom, borderColor, borderLeft, borderRadius, borderRight, borderStyle, borderTop, borderWidth, borders, bottom, boxShadow, buttonStyle, colorStyle, compose, createParser, createStyleFunction, display, flex, flexBasis, flexDirection, flexGrow, flexShrink, flexWrap, fontFamily, fontSize, fontStyle, fontWeight, get, grid, gridArea, gridAutoColumns, gridAutoFlow, gridAutoRows, gridColumn, gridColumnGap, gridGap, gridRow, gridRowGap, gridTemplateAreas, gridTemplateColumns, gridTemplateRows, height, justifyContent, justifyItems, justifySelf, left, letterSpacing, lineHeight, margin, maxHeight, maxWidth, minHeight, minWidth, opacity, order, overflow, overflowX, overflowY, padding, position, right, shadow, size, style, system, textAlign, textShadow, textStyle, top, variant, verticalAlign, width, zIndex

// EXTERNAL MODULE: ../../node_modules/next/dist/build/polyfills/object-assign.js
var object_assign = __webpack_require__(4079);
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);
;// CONCATENATED MODULE: ../../node_modules/@styled-system/core/dist/index.esm.js

var merge = function merge(a, b) {
  var result = object_assign_default()({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    object_assign_default()(result, (_assign = {}, _assign[key] = object_assign_default()(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue = function getValue(n, scale) {
  return get(scale, n, n);
};

var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var index_esm_createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      object_assign_default()(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      object_assign_default()(styles, style);
    } else {
      var _assign2;

      object_assign_default()(styles, (_assign2 = {}, _assign2[media] = object_assign_default()({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      object_assign_default()(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      object_assign_default()(styles, (_assign3 = {}, _assign3[media] = object_assign_default()({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var index_esm_createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = index_esm_createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = index_esm_createStyleFunction(conf);
  });
  var parser = index_esm_createParser(config);
  return parser;
};
var compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    object_assign_default()(config, parser.config);
  });
  var parser = index_esm_createParser(config);
  return parser;
};

;// CONCATENATED MODULE: ../../node_modules/@styled-system/layout/dist/index.esm.js


var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth = function getWidth(n, scale) {
  return get(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + '%');
};

var config = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config);
/* harmony default export */ var index_esm = (layout);

;// CONCATENATED MODULE: ../../node_modules/@styled-system/color/dist/index.esm.js

var index_esm_config = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
index_esm_config.bg = index_esm_config.backgroundColor;
var color = system(index_esm_config);
/* harmony default export */ var dist_index_esm = (color);

;// CONCATENATED MODULE: ../../node_modules/@styled-system/typography/dist/index.esm.js

var index_esm_defaults = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var dist_index_esm_config = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: index_esm_defaults.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography = system(dist_index_esm_config);
/* harmony default export */ var typography_dist_index_esm = (typography);

;// CONCATENATED MODULE: ../../node_modules/@styled-system/flexbox/dist/index.esm.js

var flexbox_dist_index_esm_config = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(flexbox_dist_index_esm_config);
/* harmony default export */ var flexbox_dist_index_esm = (flexbox);

;// CONCATENATED MODULE: ../../node_modules/@styled-system/grid/dist/index.esm.js

var dist_index_esm_defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var grid_dist_index_esm_config = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: dist_index_esm_defaults.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: dist_index_esm_defaults.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: dist_index_esm_defaults.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system(grid_dist_index_esm_config);
/* harmony default export */ var grid_dist_index_esm = (grid);

;// CONCATENATED MODULE: ../../node_modules/@styled-system/border/dist/index.esm.js

var border_dist_index_esm_config = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  }
};
border_dist_index_esm_config.borderTopWidth = {
  property: 'borderTopWidth',
  scale: 'borderWidths'
};
border_dist_index_esm_config.borderTopColor = {
  property: 'borderTopColor',
  scale: 'colors'
};
border_dist_index_esm_config.borderTopStyle = {
  property: 'borderTopStyle',
  scale: 'borderStyles'
};
border_dist_index_esm_config.borderTopLeftRadius = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
};
border_dist_index_esm_config.borderTopRightRadius = {
  property: 'borderTopRightRadius',
  scale: 'radii'
};
border_dist_index_esm_config.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
};
border_dist_index_esm_config.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
};
border_dist_index_esm_config.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
};
border_dist_index_esm_config.borderBottomLeftRadius = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
};
border_dist_index_esm_config.borderBottomRightRadius = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
};
border_dist_index_esm_config.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
};
border_dist_index_esm_config.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
};
border_dist_index_esm_config.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
};
border_dist_index_esm_config.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
};
border_dist_index_esm_config.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
};
border_dist_index_esm_config.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
};
var border = system(border_dist_index_esm_config);
/* harmony default export */ var border_dist_index_esm = (border);

;// CONCATENATED MODULE: ../../node_modules/@styled-system/background/dist/index.esm.js

var background_dist_index_esm_config = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
background_dist_index_esm_config.bgImage = background_dist_index_esm_config.backgroundImage;
background_dist_index_esm_config.bgSize = background_dist_index_esm_config.backgroundSize;
background_dist_index_esm_config.bgPosition = background_dist_index_esm_config.backgroundPosition;
background_dist_index_esm_config.bgRepeat = background_dist_index_esm_config.backgroundRepeat;
var background = system(background_dist_index_esm_config);
/* harmony default export */ var background_dist_index_esm = (background);

;// CONCATENATED MODULE: ../../node_modules/@styled-system/position/dist/index.esm.js

var position_dist_index_esm_defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var position_dist_index_esm_config = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: position_dist_index_esm_defaults.space
  }
};
var position = system(position_dist_index_esm_config);
/* harmony default export */ var position_dist_index_esm = (position);

;// CONCATENATED MODULE: ../../node_modules/@styled-system/space/dist/index.esm.js

var space_dist_index_esm_defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var index_esm_isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getMargin = function getMargin(n, scale) {
  if (!index_esm_isNumber(n)) {
    return get(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get(scale, absolute, absolute);

  if (!index_esm_isNumber(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: space_dist_index_esm_defaults.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: space_dist_index_esm_defaults.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
var space = compose(margin, padding);
/* harmony default export */ var space_dist_index_esm = ((/* unused pure expression or super */ null && (space)));

;// CONCATENATED MODULE: ../../node_modules/@styled-system/shadow/dist/index.esm.js

var shadow = system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});
/* harmony default export */ var shadow_dist_index_esm = ((/* unused pure expression or super */ null && (shadow)));

;// CONCATENATED MODULE: ../../node_modules/@styled-system/css/dist/index.esm.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// based on https://github.com/developit/dlv
var index_esm_get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  outlineColor: 'colors',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return index_esm_get(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = index_esm_get(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = index_esm_get(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};
var css = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends({}, defaultTheme, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(index_esm_get(theme, val))(theme);
        result = _extends({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = index_esm_get(aliases, key, key);
      var scaleName = index_esm_get(scales, prop);
      var scale = index_esm_get(theme, scaleName, index_esm_get(theme, prop, {}));
      var transform = index_esm_get(transforms, prop, index_esm_get);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};
/* harmony default export */ var css_dist_index_esm = (css);

;// CONCATENATED MODULE: ../../node_modules/@styled-system/variant/dist/index.esm.js


var variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return css_dist_index_esm(get(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return get(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = index_esm_createParser(config);
  return parser;
};
/* harmony default export */ var variant_dist_index_esm = ((/* unused pure expression or super */ null && (variant)));
var buttonStyle = variant({
  key: 'buttons'
});
var textStyle = variant({
  key: 'textStyles',
  prop: 'textStyle'
});
var colorStyle = variant({
  key: 'colorStyles',
  prop: 'colors'
});

;// CONCATENATED MODULE: ../../node_modules/styled-system/dist/index.esm.js
 // v4 api shims






















var width = index_esm.width,
    height = index_esm.height,
    minWidth = index_esm.minWidth,
    minHeight = index_esm.minHeight,
    maxWidth = index_esm.maxWidth,
    maxHeight = index_esm.maxHeight,
    size = index_esm.size,
    verticalAlign = index_esm.verticalAlign,
    display = index_esm.display,
    overflow = index_esm.overflow,
    overflowX = index_esm.overflowX,
    overflowY = index_esm.overflowY;
var opacity = dist_index_esm.opacity;
var fontSize = typography_dist_index_esm.fontSize,
    fontFamily = typography_dist_index_esm.fontFamily,
    fontWeight = typography_dist_index_esm.fontWeight,
    lineHeight = typography_dist_index_esm.lineHeight,
    textAlign = typography_dist_index_esm.textAlign,
    fontStyle = typography_dist_index_esm.fontStyle,
    letterSpacing = typography_dist_index_esm.letterSpacing;
var alignItems = flexbox_dist_index_esm.alignItems,
    alignContent = flexbox_dist_index_esm.alignContent,
    justifyItems = flexbox_dist_index_esm.justifyItems,
    justifyContent = flexbox_dist_index_esm.justifyContent,
    flexWrap = flexbox_dist_index_esm.flexWrap,
    flexDirection = flexbox_dist_index_esm.flexDirection,
    flex = flexbox_dist_index_esm.flex,
    flexGrow = flexbox_dist_index_esm.flexGrow,
    flexShrink = flexbox_dist_index_esm.flexShrink,
    flexBasis = flexbox_dist_index_esm.flexBasis,
    justifySelf = flexbox_dist_index_esm.justifySelf,
    alignSelf = flexbox_dist_index_esm.alignSelf,
    order = flexbox_dist_index_esm.order;
var gridGap = grid_dist_index_esm.gridGap,
    gridColumnGap = grid_dist_index_esm.gridColumnGap,
    gridRowGap = grid_dist_index_esm.gridRowGap,
    gridColumn = grid_dist_index_esm.gridColumn,
    gridRow = grid_dist_index_esm.gridRow,
    gridAutoFlow = grid_dist_index_esm.gridAutoFlow,
    gridAutoColumns = grid_dist_index_esm.gridAutoColumns,
    gridAutoRows = grid_dist_index_esm.gridAutoRows,
    gridTemplateColumns = grid_dist_index_esm.gridTemplateColumns,
    gridTemplateRows = grid_dist_index_esm.gridTemplateRows,
    gridTemplateAreas = grid_dist_index_esm.gridTemplateAreas,
    gridArea = grid_dist_index_esm.gridArea;
var borderWidth = border_dist_index_esm.borderWidth,
    borderStyle = border_dist_index_esm.borderStyle,
    borderColor = border_dist_index_esm.borderColor,
    borderTop = border_dist_index_esm.borderTop,
    borderRight = border_dist_index_esm.borderRight,
    borderBottom = border_dist_index_esm.borderBottom,
    borderLeft = border_dist_index_esm.borderLeft,
    borderRadius = border_dist_index_esm.borderRadius;
var backgroundImage = background_dist_index_esm.backgroundImage,
    backgroundSize = background_dist_index_esm.backgroundSize,
    backgroundPosition = background_dist_index_esm.backgroundPosition,
    backgroundRepeat = background_dist_index_esm.backgroundRepeat;
var zIndex = position_dist_index_esm.zIndex,
    index_esm_top = position_dist_index_esm.top,
    right = position_dist_index_esm.right,
    bottom = position_dist_index_esm.bottom,
    left = position_dist_index_esm.left;

 // v4 style API shim

var style = function style(_ref) {
  var prop = _ref.prop,
      cssProperty = _ref.cssProperty,
      alias = _ref.alias,
      key = _ref.key,
      transformValue = _ref.transformValue,
      scale = _ref.scale,
      properties = _ref.properties;
  var config = {};
  config[prop] = createStyleFunction({
    properties: properties,
    property: cssProperty || prop,
    scale: key,
    defaultScale: scale,
    transform: transformValue
  });
  if (alias) config[alias] = config[prop];
  var parse = createParser(config);
  return parse;
};


/***/ }),

/***/ 98621:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if ( true && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {return tinycolor;}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {}

})(Math);


/***/ }),

/***/ 5163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__assign": function() { return /* binding */ __assign; },
/* harmony export */   "__asyncDelegator": function() { return /* binding */ __asyncDelegator; },
/* harmony export */   "__asyncGenerator": function() { return /* binding */ __asyncGenerator; },
/* harmony export */   "__asyncValues": function() { return /* binding */ __asyncValues; },
/* harmony export */   "__await": function() { return /* binding */ __await; },
/* harmony export */   "__awaiter": function() { return /* binding */ __awaiter; },
/* harmony export */   "__classPrivateFieldGet": function() { return /* binding */ __classPrivateFieldGet; },
/* harmony export */   "__classPrivateFieldIn": function() { return /* binding */ __classPrivateFieldIn; },
/* harmony export */   "__classPrivateFieldSet": function() { return /* binding */ __classPrivateFieldSet; },
/* harmony export */   "__createBinding": function() { return /* binding */ __createBinding; },
/* harmony export */   "__decorate": function() { return /* binding */ __decorate; },
/* harmony export */   "__exportStar": function() { return /* binding */ __exportStar; },
/* harmony export */   "__extends": function() { return /* binding */ __extends; },
/* harmony export */   "__generator": function() { return /* binding */ __generator; },
/* harmony export */   "__importDefault": function() { return /* binding */ __importDefault; },
/* harmony export */   "__importStar": function() { return /* binding */ __importStar; },
/* harmony export */   "__makeTemplateObject": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "__metadata": function() { return /* binding */ __metadata; },
/* harmony export */   "__param": function() { return /* binding */ __param; },
/* harmony export */   "__read": function() { return /* binding */ __read; },
/* harmony export */   "__rest": function() { return /* binding */ __rest; },
/* harmony export */   "__spread": function() { return /* binding */ __spread; },
/* harmony export */   "__spreadArray": function() { return /* binding */ __spreadArray; },
/* harmony export */   "__spreadArrays": function() { return /* binding */ __spreadArrays; },
/* harmony export */   "__values": function() { return /* binding */ __values; }
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 20452:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(2784);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 43100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(20452);
} else {}


/***/ }),

/***/ 45982:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 71600:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 69117:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ApolloCache; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5163);
/* harmony import */ var optimism__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88438);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18001);



var ApolloCache = (function () {
    function ApolloCache() {
        this.getFragmentDoc = (0,optimism__WEBPACK_IMPORTED_MODULE_0__/* .wrap */ .re)(_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getFragmentQueryDocument */ .Yk);
    }
    ApolloCache.prototype.batch = function (options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic :
            options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function () { return updateResult = options.update(_this); }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function (transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.identify = function (object) {
        return;
    };
    ApolloCache.prototype.gc = function () {
        return [];
    };
    ApolloCache.prototype.modify = function (options) {
        return false;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, options), { rootId: options.id || 'ROOT_QUERY', optimistic: optimistic }));
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, options), { query: this.getFragmentDoc(options.fragment, options.fragmentName), rootId: options.id, optimistic: optimistic }));
    };
    ApolloCache.prototype.writeQuery = function (_a) {
        var id = _a.id, data = _a.data, options = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__rest)(_a, ["id", "data"]);
        return this.write(Object.assign(options, {
            dataId: id || 'ROOT_QUERY',
            result: data,
        }));
    };
    ApolloCache.prototype.writeFragment = function (_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__rest)(_a, ["id", "data", "fragment", "fragmentName"]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data,
        }));
    };
    ApolloCache.prototype.updateQuery = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeQuery((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, options), { data: data }));
                return data;
            },
        });
    };
    ApolloCache.prototype.updateFragment = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeFragment((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, options), { data: data }));
                return data;
            },
        });
    };
    return ApolloCache;
}());

//# sourceMappingURL=cache.js.map

/***/ }),

/***/ 19814:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ MissingFieldError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5163);

var MissingFieldError = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for (var i = _this.path.length - 1; i >= 0; --i) {
                _this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
            }
        }
        else {
            _this.missing = _this.path;
        }
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error));

//# sourceMappingURL=common.js.map

/***/ }),

/***/ 15397:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ TypeOrFieldNameRegExp; },
/* harmony export */   "E_": function() { return /* binding */ fieldNameFromStoreName; },
/* harmony export */   "Is": function() { return /* binding */ extractFragmentContext; },
/* harmony export */   "RC": function() { return /* binding */ selectionSetMatchesResult; },
/* harmony export */   "RI": function() { return /* binding */ hasOwn; },
/* harmony export */   "ig": function() { return /* binding */ makeProcessedFieldsMerger; },
/* harmony export */   "j": function() { return /* binding */ storeValueIsStoreObject; },
/* harmony export */   "jS": function() { return /* binding */ normalizeConfig; },
/* harmony export */   "jp": function() { return /* binding */ getTypenameFromStoreObject; },
/* harmony export */   "lg": function() { return /* binding */ shouldCanonizeResults; },
/* harmony export */   "uG": function() { return /* binding */ defaultDataIdFromObject; }
/* harmony export */ });
/* unused harmony export isNullish */
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9428);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45931);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43056);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9572);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34529);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18001);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86607);

var hasOwn = Object.prototype.hasOwnProperty;
function isNullish(value) {
    return value === null || value === void 0;
}

function defaultDataIdFromObject(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) {
            context.keyObject =
                !isNullish(id) ? { id: id } :
                    !isNullish(_id) ? { _id: _id } :
                        void 0;
        }
        if (isNullish(id) && !isNullish(_id)) {
            id = _id;
        }
        if (!isNullish(id)) {
            return "".concat(__typename, ":").concat((typeof id === "number" ||
                typeof id === "string") ? id : JSON.stringify(id));
        }
    }
}
var defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    canonizeResults: false,
};
function normalizeConfig(config) {
    return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)(defaultConfig, config);
}
function shouldCanonizeResults(config) {
    var value = config.canonizeResults;
    return value === void 0 ? defaultConfig.canonizeResults : value;
}
function getTypenameFromStoreObject(store, objectOrReference) {
    return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isReference */ .Yk)(objectOrReference)
        ? store.get(objectOrReference.__ref, "__typename")
        : objectOrReference && objectOrReference.__typename;
}
var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function fieldNameFromStoreName(storeFieldName) {
    var match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(result)) {
        return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isArray */ .k)(result)
            ? result.every(function (item) { return selectionSetMatchesResult(selectionSet, item, variables); })
            : selectionSet.selections.every(function (field) {
                if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isField */ .My)(field) && (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_4__/* .shouldInclude */ .LZ)(field, variables)) {
                    var key = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .resultKeyNameFromField */ .u2)(field);
                    return hasOwn.call(result, key) &&
                        (!field.selectionSet ||
                            selectionSetMatchesResult(field.selectionSet, result[key], variables));
                }
                return true;
            });
    }
    return false;
}
function storeValueIsStoreObject(value) {
    return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value) &&
        !(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isReference */ .Yk)(value) &&
        !(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .isArray */ .k)(value);
}
function makeProcessedFieldsMerger() {
    return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .DeepMerger */ .w0;
}
function extractFragmentContext(document, fragments) {
    var fragmentMap = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_6__/* .createFragmentMap */ .F)((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_7__/* .getFragmentDefinitions */ .kU)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function (name) {
            var def = fragmentMap[name];
            if (!def && fragments) {
                def = fragments.lookup(name);
            }
            return def || null;
        },
    };
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 1342:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ InMemoryCache; }
});

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(64619);
// EXTERNAL MODULE: ../../node_modules/optimism/lib/bundle.esm.js
var bundle_esm = __webpack_require__(88438);
// EXTERNAL MODULE: ../../node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(38229);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/core/cache.js
var cache = __webpack_require__(69117);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/core/types/common.js
var common = __webpack_require__(19814);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(72);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/transform.js
var transform = __webpack_require__(11209);
// EXTERNAL MODULE: ../../node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(95115);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(43869);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(9428);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(86607);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeDeep.js
var mergeDeep = __webpack_require__(34529);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(9572);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/fragments.js
var fragments = __webpack_require__(18001);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(23180);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/objects.js
var objects = __webpack_require__(45931);
// EXTERNAL MODULE: ../../node_modules/@wry/trie/lib/trie.esm.js
var trie_esm = __webpack_require__(3985);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/helpers.js
var helpers = __webpack_require__(15397);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/entityStore.js







var DELETE = Object.create(null);
var delModifier = function () { return DELETE; };
var INVALIDATE = Object.create(null);
var EntityStore = (function () {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function (objectOrReference, storeFieldName) { return (0,maybeDeepFreeze/* maybeDeepFreeze */.J)((0,storeUtils/* isReference */.Yk)(objectOrReference)
            ? _this.get(objectOrReference.__ref, storeFieldName)
            : objectOrReference && objectOrReference[storeFieldName]); };
        this.canRead = function (objOrRef) {
            return (0,storeUtils/* isReference */.Yk)(objOrRef)
                ? _this.has(objOrRef.__ref)
                : typeof objOrRef === "object";
        };
        this.toReference = function (objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") {
                return (0,storeUtils/* makeReference */.kQ)(objOrIdOrRef);
            }
            if ((0,storeUtils/* isReference */.Yk)(objOrIdOrRef)) {
                return objOrIdOrRef;
            }
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0,storeUtils/* makeReference */.kQ)(id);
                if (mergeIntoStore) {
                    _this.merge(id, objOrIdOrRef);
                }
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function () {
        return (0,tslib_es6.__assign)({}, this.data);
    };
    EntityStore.prototype.has = function (dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function (dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if (helpers/* hasOwn.call */.RI.call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && helpers/* hasOwn.call */.RI.call(storeObject, fieldName)) {
                return storeObject[fieldName];
            }
        }
        if (fieldName === "__typename" &&
            helpers/* hasOwn.call */.RI.call(this.policies.rootTypenamesById, dataId)) {
            return this.policies.rootTypenamesById[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.get(dataId, fieldName);
        }
    };
    EntityStore.prototype.lookup = function (dataId, dependOnExistence) {
        if (dependOnExistence)
            this.group.depend(dataId, "__exists");
        if (helpers/* hasOwn.call */.RI.call(this.data, dataId)) {
            return this.data[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.lookup(dataId, dependOnExistence);
        }
        if (this.policies.rootTypenamesById[dataId]) {
            return Object.create(null);
        }
    };
    EntityStore.prototype.merge = function (older, newer) {
        var _this = this;
        var dataId;
        if ((0,storeUtils/* isReference */.Yk)(older))
            older = older.__ref;
        if ((0,storeUtils/* isReference */.Yk)(newer))
            newer = newer.__ref;
        var existing = typeof older === "string"
            ? this.lookup(dataId = older)
            : older;
        var incoming = typeof newer === "string"
            ? this.lookup(dataId = newer)
            : newer;
        if (!incoming)
            return;
        __DEV__ ? (0,globals/* invariant */.kG)(typeof dataId === "string", "store.merge expects a string ID") : (0,globals/* invariant */.kG)(typeof dataId === "string", 1);
        var merged = new mergeDeep/* DeepMerger */.w0(storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing)
                    fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function (storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
                        if (fieldName !== storeFieldName &&
                            !_this.policies.hasKeyArgs(merged.__typename, fieldName)) {
                            fieldsToDirty_1[fieldName] = 1;
                        }
                        if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) {
                            delete merged[storeFieldName];
                        }
                    }
                });
                if (fieldsToDirty_1.__typename &&
                    !(existing && existing.__typename) &&
                    this.policies.rootTypenamesById[dataId] === merged.__typename) {
                    delete fieldsToDirty_1.__typename;
                }
                Object.keys(fieldsToDirty_1).forEach(function (fieldName) { return _this.group.dirty(dataId, fieldName); });
            }
        }
    };
    EntityStore.prototype.modify = function (dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: DELETE,
                INVALIDATE: INVALIDATE,
                isReference: storeUtils/* isReference */.Yk,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function (fieldNameOrOptions, from) { return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                    fieldName: fieldNameOrOptions,
                    from: from || (0,storeUtils/* makeReference */.kQ)(dataId),
                } : fieldNameOrOptions, { store: _this }); },
            };
            Object.keys(storeObject).forEach(function (storeFieldName) {
                var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0)
                    return;
                var modify = typeof fields === "function"
                    ? fields
                    : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === delModifier ? DELETE :
                        modify((0,maybeDeepFreeze/* maybeDeepFreeze */.J)(fieldValue), (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, sharedDetails_1), { fieldName: fieldName, storeFieldName: storeFieldName, storage: _this.getStorage(dataId, storeFieldName) }));
                    if (newValue === INVALIDATE) {
                        _this.group.dirty(dataId, storeFieldName);
                    }
                    else {
                        if (newValue === DELETE)
                            newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) {
                    allDeleted_1 = false;
                }
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof Layer) {
                        this.data[dataId] = void 0;
                    }
                    else {
                        delete this.data[dataId];
                    }
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function (dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args
                ? this.policies.getStoreFieldName({ typename: typename, fieldName: fieldName, args: args })
                : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {},
                _a[storeFieldName] = delModifier,
                _a) : delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function (options, limit) {
        var evicted = false;
        if (options.id) {
            if (helpers/* hasOwn.call */.RI.call(this.data, options.id)) {
                evicted = this.delete(options.id, options.fieldName, options.args);
            }
            if (this instanceof Layer && this !== limit) {
                evicted = this.parent.evict(options, limit) || evicted;
            }
            if (options.fieldName || evicted) {
                this.group.dirty(options.id, options.fieldName || "__exists");
            }
        }
        return evicted;
    };
    EntityStore.prototype.clear = function () {
        this.replace(null);
    };
    EntityStore.prototype.extract = function () {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function (id) {
            if (!helpers/* hasOwn.call */.RI.call(_this.policies.rootTypenamesById, id)) {
                extraRootIds.push(id);
            }
        });
        if (extraRootIds.length) {
            obj.__META = { extraRootIds: extraRootIds.sort() };
        }
        return obj;
    };
    EntityStore.prototype.replace = function (newData) {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) {
            if (!(newData && helpers/* hasOwn.call */.RI.call(newData, dataId))) {
                _this.delete(dataId);
            }
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0,tslib_es6.__rest)(newData, ["__META"]);
            Object.keys(rest_1).forEach(function (dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) {
                __META.extraRootIds.forEach(this.retain, this);
            }
        }
    };
    EntityStore.prototype.retain = function (rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function (rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count)
                delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function (ids) {
        if (ids === void 0) { ids = new Set(); }
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) {
            this.parent.getRootIdSet(ids);
        }
        else {
            Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        }
        return ids;
    };
    EntityStore.prototype.gc = function () {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function (id) {
            if (helpers/* hasOwn.call */.RI.call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while (root_1 instanceof Layer)
                root_1 = root_1.parent;
            idsToRemove.forEach(function (id) { return root_1.delete(id); });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function (dataId) {
        if (!helpers/* hasOwn.call */.RI.call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root)
                return found_1;
            var workSet_1 = new Set([root]);
            workSet_1.forEach(function (obj) {
                if ((0,storeUtils/* isReference */.Yk)(obj)) {
                    found_1[obj.__ref] = true;
                }
                if ((0,objects/* isNonNullObject */.s)(obj)) {
                    Object.keys(obj).forEach(function (key) {
                        var child = obj[key];
                        if ((0,objects/* isNonNullObject */.s)(child)) {
                            workSet_1.add(child);
                        }
                    });
                }
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function () {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}());

var CacheGroup = (function () {
    function CacheGroup(caching, parent) {
        if (parent === void 0) { parent = null; }
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function () {
        this.d = this.caching ? (0,bundle_esm/* dep */.dP)() : null;
        this.keyMaker = new trie_esm/* Trie */.B(canUse/* canUseWeakMap */.mr);
    };
    CacheGroup.prototype.depend = function (dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
            if (fieldName !== storeFieldName) {
                this.d(makeDepKey(dataId, fieldName));
            }
            if (this.parent) {
                this.parent.depend(dataId, storeFieldName);
            }
        }
    };
    CacheGroup.prototype.dirty = function (dataId, storeFieldName) {
        if (this.d) {
            this.d.dirty(makeDepKey(dataId, storeFieldName), storeFieldName === "__exists" ? "forget" : "setDirty");
        }
    };
    return CacheGroup;
}());
function makeDepKey(dataId, storeFieldName) {
    return storeFieldName + '#' + dataId;
}
function maybeDependOnExistenceOfEntity(store, entityId) {
    if (supportsResultCaching(store)) {
        store.group.depend(entityId, "__exists");
    }
}
(function (EntityStore) {
    var Root = (function (_super) {
        (0,tslib_es6.__extends)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;
            _this.stump = new Stump(_this);
            _this.storageTrie = new trie_esm/* Trie */.B(canUse/* canUseWeakMap */.mr);
            if (seed)
                _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function (layerId, replay) {
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function () {
            return this;
        };
        Root.prototype.getStorage = function () {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore));
    EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));
var Layer = (function (_super) {
    (0,tslib_es6.__extends)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function (layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function (layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) {
                Object.keys(this.data).forEach(function (dataId) {
                    var ownStoreObject = _this.data[dataId];
                    var parentStoreObject = parent["lookup"](dataId);
                    if (!parentStoreObject) {
                        _this.delete(dataId);
                    }
                    else if (!ownStoreObject) {
                        _this.group.dirty(dataId, "__exists");
                        Object.keys(parentStoreObject).forEach(function (storeFieldName) {
                            _this.group.dirty(dataId, storeFieldName);
                        });
                    }
                    else if (ownStoreObject !== parentStoreObject) {
                        Object.keys(ownStoreObject).forEach(function (storeFieldName) {
                            if (!(0,equality_esm/* equal */.D)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) {
                                _this.group.dirty(dataId, storeFieldName);
                            }
                        });
                    }
                });
            }
            return parent;
        }
        if (parent === this.parent)
            return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function () {
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function (dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return helpers/* hasOwn.call */.RI.call(this.data, dataId) ? (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function () {
        var p = this.parent;
        while (p.parent)
            p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}(EntityStore));
var Stump = (function (_super) {
    (0,tslib_es6.__extends)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function () { }, new CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function () {
        return this;
    };
    Stump.prototype.merge = function () {
        return this.parent.merge.apply(this.parent, arguments);
    };
    return Stump;
}(Layer));
function storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return (0,equality_esm/* equal */.D)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    return !!(store instanceof EntityStore && store.group.caching);
}
//# sourceMappingURL=entityStore.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(43056);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/object-canon.js
var object_canon = __webpack_require__(51420);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/readFromStore.js









;
function execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        options.context.canonizeResults,
    ];
}
var StoreReader = (function () {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.config = (0,compact/* compact */.o)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0,helpers/* shouldCanonizeResults */.lg)(config),
        });
        this.canon = config.canon || new object_canon/* ObjectCanon */.h;
        this.executeSelectionSet = (0,bundle_esm/* wrap */.re)(function (options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = execSelectionSetKeyArgs(options);
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) {
                    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, other), { result: _this.canon.admit(other.result) });
                }
                return other;
            }
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            keyArgs: execSelectionSetKeyArgs,
            makeCacheKey: function (selectionSet, parent, context, canonizeResults) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(selectionSet, (0,storeUtils/* isReference */.Yk)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
                }
            }
        });
        this.executeSubSelectedArray = (0,bundle_esm/* wrap */.re)(function (options) {
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(field, array, context.varString);
                }
            }
        });
    }
    StoreReader.prototype.resetCanon = function () {
        this.canon = new object_canon/* ObjectCanon */.h;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? 'ROOT_QUERY' : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (0,getFromAST/* getDefaultValues */.O4)((0,getFromAST/* getQueryDefinition */.iW)(query))), variables);
        var rootRef = (0,storeUtils/* makeReference */.kQ)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0,getFromAST/* getMainDefinition */.p$)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0,tslib_es6.__assign)({ store: store, query: query, policies: policies, variables: variables, varString: (0,object_canon/* canonicalStringify */.B)(variables), canonizeResults: canonizeResults }, (0,helpers/* extractFragmentContext */.Is)(query, this.config.fragments)),
        });
        var missing;
        if (execResult.missing) {
            missing = [new common/* MissingFieldError */.y(firstMissing(execResult.missing), execResult.missing, query, variables)];
            if (!returnPartialData) {
                throw missing[0];
            }
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing,
        };
    };
    StoreReader.prototype.isFresh = function (result, parent, selectionSet, context) {
        if (supportsResultCaching(context.store) &&
            this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, this.canon.isKnown(result));
            if (latest && result === latest.result) {
                return true;
            }
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0,storeUtils/* isReference */.Yk)(objectOrReference) &&
            !context.policies.rootTypenamesById[objectOrReference.__ref] &&
            !context.store.has(objectOrReference.__ref)) {
            return {
                result: this.canon.empty,
                missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object"),
            };
        }
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new mergeDeep/* DeepMerger */.w0();
        if (this.config.addTypename &&
            typeof typename === "string" &&
            !policies.rootIdsByTypename[typename]) {
            objectsToMerge.push({ __typename: typename });
        }
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            }
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function (selection) {
            var _a, _b;
            if (!(0,directives/* shouldInclude */.LZ)(selection, variables))
                return;
            if ((0,storeUtils/* isField */.My)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference,
                }, context);
                var resultName = (0,storeUtils/* resultKeyNameFromField */.u2)(selection);
                if (fieldValue === void 0) {
                    if (!transform/* addTypenameToDocument.added */.Gw.added(selection)) {
                        missing = missingMerger.merge(missing, (_a = {},
                            _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0,storeUtils/* isReference */.Yk)(objectOrReference)
                                ? objectOrReference.__ref + " object"
                                : "object " + JSON.stringify(objectOrReference, null, 2)),
                            _a));
                    }
                }
                else if ((0,arrays/* isArray */.k)(fieldValue)) {
                    fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context,
                    }), resultName);
                }
                else if (!selection.selectionSet) {
                    if (context.canonizeResults) {
                        fieldValue = _this.canon.pass(fieldValue);
                    }
                }
                else if (fieldValue != null) {
                    fieldValue = handleMissing(_this.executeSelectionSet({
                        selectionSet: selection.selectionSet,
                        objectOrReference: fieldValue,
                        enclosingRef: (0,storeUtils/* isReference */.Yk)(fieldValue) ? fieldValue : enclosingRef,
                        context: context,
                    }), resultName);
                }
                if (fieldValue !== void 0) {
                    objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
                }
            }
            else {
                var fragment = (0,fragments/* getFragmentFromSelection */.hi)(selection, context.lookupFragment);
                if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                    throw __DEV__ ? new globals/* InvariantError */.ej("No fragment named ".concat(selection.name.value)) : new globals/* InvariantError */.ej(5);
                }
                if (fragment && policies.fragmentMatches(fragment, typename)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        var result = (0,mergeDeep/* mergeDeepArray */.bw)(objectsToMerge);
        var finalResult = { result: result, missing: missing };
        var frozen = context.canonizeResults
            ? this.canon.admit(finalResult)
            : (0,maybeDeepFreeze/* maybeDeepFreeze */.J)(finalResult);
        if (frozen.result) {
            this.knownResults.set(frozen.result, selectionSet);
        }
        return frozen;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new mergeDeep/* DeepMerger */.w0();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            }
            return childResult.result;
        }
        if (field.selectionSet) {
            array = array.filter(context.store.canRead);
        }
        array = array.map(function (item, i) {
            if (item === null) {
                return null;
            }
            if ((0,arrays/* isArray */.k)(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    enclosingRef: enclosingRef,
                    context: context,
                }), i);
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    objectOrReference: item,
                    enclosingRef: (0,storeUtils/* isReference */.Yk)(item) ? item : enclosingRef,
                    context: context,
                }), i);
            }
            if (__DEV__) {
                assertSelectionSetForIdValue(context.store, field, item);
            }
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing,
        };
    };
    return StoreReader;
}());

function firstMissing(tree) {
    try {
        JSON.stringify(tree, function (_, value) {
            if (typeof value === "string")
                throw value;
            return value;
        });
    }
    catch (result) {
        return result;
    }
}
function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([fieldValue]);
        workSet_1.forEach(function (value) {
            if ((0,objects/* isNonNullObject */.s)(value)) {
                __DEV__ ? (0,globals/* invariant */.kG)(!(0,storeUtils/* isReference */.Yk)(value), "Missing selection set for object of type ".concat((0,helpers/* getTypenameFromStoreObject */.jp)(store, value), " returned for query field ").concat(field.name.value)) : (0,globals/* invariant */.kG)(!(0,storeUtils/* isReference */.Yk)(value), 6);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}
//# sourceMappingURL=readFromStore.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/cloneDeep.js
var cloneDeep = __webpack_require__(89732);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/makeUniqueId.js
var makeUniqueId = __webpack_require__(99635);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/common/stringifyForDisplay.js

function stringifyForDisplay(value) {
    var undefId = (0,makeUniqueId/* makeUniqueId */.X)("stringifyForDisplay");
    return JSON.stringify(value, function (key, value) {
        return value === void 0 ? undefId : value;
    }).split(JSON.stringify(undefId)).join("<undefined>");
}
//# sourceMappingURL=stringifyForDisplay.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(17600);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/key-extractor.js



var specifierInfoCache = Object.create(null);
function lookupSpecifierInfo(spec) {
    var cacheKey = JSON.stringify(spec);
    return specifierInfoCache[cacheKey] ||
        (specifierInfoCache[cacheKey] = Object.create(null));
}
function keyFieldsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function (object, context) {
        var extract = function (from, key) { return context.readField(key, from); };
        var keyObject = context.keyObject = collectSpecifierPaths(specifier, function (schemaKeyPath) {
            var extracted = extractKeyPath(context.storeObject, schemaKeyPath, extract);
            if (extracted === void 0 &&
                object !== context.storeObject &&
                helpers/* hasOwn.call */.RI.call(object, schemaKeyPath[0])) {
                extracted = extractKeyPath(object, schemaKeyPath, extractKey);
            }
            __DEV__ ? (0,globals/* invariant */.kG)(extracted !== void 0, "Missing field '".concat(schemaKeyPath.join('.'), "' while extracting keyFields from ").concat(JSON.stringify(object))) : (0,globals/* invariant */.kG)(extracted !== void 0, 2);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function keyArgsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function (args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = collectSpecifierPaths(specifier, function (keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0,arrays/* isNonEmptyArray */.O)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    var d = field.directives.find(function (d) { return d.name.value === directiveName_1; });
                    var directiveArgs = d && (0,storeUtils/* argumentsObjectFromField */.NC)(d, variables);
                    return directiveArgs && extractKeyPath(directiveArgs, keyPath.slice(1));
                }
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && helpers/* hasOwn.call */.RI.call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return extractKeyPath(variables, varKeyPath);
                }
                return;
            }
            if (args) {
                return extractKeyPath(args, keyPath);
            }
        });
        var suffix = JSON.stringify(collected);
        if (args || suffix !== "{}") {
            fieldName += ":" + suffix;
        }
        return fieldName;
    });
}
function collectSpecifierPaths(specifier, extractor) {
    var merger = new mergeDeep/* DeepMerger */.w0;
    return getSpecifierPaths(specifier).reduce(function (collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            for (var i = path.length - 1; i >= 0; --i) {
                toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            }
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function getSpecifierPaths(spec) {
    var info = lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function (s, i) {
            if ((0,arrays/* isArray */.k)(s)) {
                getSpecifierPaths(s).forEach(function (p) { return paths_1.push(currentPath_1.concat(p)); });
                currentPath_1.length = 0;
            }
            else {
                currentPath_1.push(s);
                if (!(0,arrays/* isArray */.k)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function extractKey(object, key) {
    return object[key];
}
function extractKeyPath(object, path, extract) {
    extract = extract || extractKey;
    return normalize(path.reduce(function reducer(obj, key) {
        return (0,arrays/* isArray */.k)(obj)
            ? obj.map(function (child) { return reducer(child, key); })
            : obj && extract(obj, key);
    }, object));
}
function normalize(value) {
    if ((0,objects/* isNonNullObject */.s)(value)) {
        if ((0,arrays/* isArray */.k)(value)) {
            return value.map(normalize);
        }
        return collectSpecifierPaths(Object.keys(value).sort(), function (path) { return extractKeyPath(value, path); });
    }
    return value;
}
//# sourceMappingURL=key-extractor.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/policies.js







storeUtils/* getStoreKeyName.setStringify */.PT.setStringify(object_canon/* canonicalStringify */.B);
function argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args :
        spec.field ? (0,storeUtils/* argumentsObjectFromField */.NC)(spec.field, spec.variables) : null;
}
var nullKeyFieldsFn = function () { return void 0; };
var simpleKeyArgsFn = function (_args, context) { return context.fieldName; };
var mergeTrueFn = function (existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var mergeFalseFn = function (_, incoming) { return incoming; };
var Policies = (function () {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0,tslib_es6.__assign)({ dataIdFromObject: helpers/* defaultDataIdFromObject */.uG }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) {
            this.addPossibleTypes(config.possibleTypes);
        }
        if (config.typePolicies) {
            this.addTypePolicies(config.typePolicies);
        }
    }
    Policies.prototype.identify = function (object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename ||
            ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) {
            return ["ROOT_QUERY"];
        }
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, partialContext), { typename: typename, storeObject: storeObject, readField: partialContext && partialContext.readField || function () {
                var options = normalizeReadFieldOptions(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables,
                });
            } });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while (keyFn) {
            var specifierOrId = keyFn(object, context);
            if ((0,arrays/* isArray */.k)(specifierOrId)) {
                keyFn = keyFieldsFnFromSpecifier(specifierOrId);
            }
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [id, context.keyObject] : [id];
    };
    Policies.prototype.addTypePolicies = function (typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function (typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0,tslib_es6.__rest)(_a, ["queryType", "mutationType", "subscriptionType"]);
            if (queryType)
                _this.setRootTypename("Query", typename);
            if (mutationType)
                _this.setRootTypename("Mutation", typename);
            if (subscriptionType)
                _this.setRootTypename("Subscription", typename);
            if (helpers/* hasOwn.call */.RI.call(_this.toBeAdded, typename)) {
                _this.toBeAdded[typename].push(incoming);
            }
            else {
                _this.toBeAdded[typename] = [incoming];
            }
        });
    };
    Policies.prototype.updateTypePolicy = function (typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge =
                typeof merge === "function" ? merge :
                    merge === true ? mergeTrueFn :
                        merge === false ? mergeFalseFn :
                            existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn =
            keyFields === false ? nullKeyFieldsFn :
                (0,arrays/* isArray */.k)(keyFields) ? keyFieldsFnFromSpecifier(keyFields) :
                    typeof keyFields === "function" ? keyFields :
                        existing.keyFn;
        if (fields) {
            Object.keys(fields).forEach(function (fieldName) {
                var existing = _this.getFieldPolicy(typename, fieldName, true);
                var incoming = fields[fieldName];
                if (typeof incoming === "function") {
                    existing.read = incoming;
                }
                else {
                    var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                    existing.keyFn =
                        keyArgs === false ? simpleKeyArgsFn :
                            (0,arrays/* isArray */.k)(keyArgs) ? keyArgsFnFromSpecifier(keyArgs) :
                                typeof keyArgs === "function" ? keyArgs :
                                    existing.keyFn;
                    if (typeof read === "function") {
                        existing.read = read;
                    }
                    setMerge(existing, merge);
                }
                if (existing.read && existing.merge) {
                    existing.keyFn = existing.keyFn || simpleKeyArgsFn;
                }
            });
        }
    };
    Policies.prototype.setRootTypename = function (which, typename) {
        if (typename === void 0) { typename = which; }
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            __DEV__ ? (0,globals/* invariant */.kG)(!old || old === which, "Cannot change root ".concat(which, " __typename more than once")) : (0,globals/* invariant */.kG)(!old || old === which, 3);
            if (old)
                delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function (possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function (supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function (subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match(helpers/* TypeOrFieldNameRegExp */.$O);
                if (!match || match[0] !== subtype) {
                    _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
                }
            });
        });
    };
    Policies.prototype.getTypePolicy = function (typename) {
        var _this = this;
        if (!helpers/* hasOwn.call */.RI.call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes = this.supertypeMap.get(typename);
            if (supertypes && supertypes.size) {
                supertypes.forEach(function (supertype) {
                    var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0,tslib_es6.__rest)(_a, ["fields"]);
                    Object.assign(policy_1, rest);
                    Object.assign(policy_1.fields, fields);
                });
            }
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) {
            inbox.splice(0).forEach(function (policy) {
                _this.updateTypePolicy(typename, policy);
            });
        }
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function (typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || (createIfMissing && (fieldPolicies[fieldName] = Object.create(null)));
        }
    };
    Policies.prototype.getSupertypeSet = function (subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) {
            this.supertypeMap.set(subtype, supertypeSet = new Set());
        }
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function (fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition)
            return true;
        if (!typename)
            return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype)
            return true;
        if (this.usingPossibleTypes &&
            this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [typenameSupertypeSet];
            var maybeEnqueue_1 = function (subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet &&
                    supertypeSet.size &&
                    workQueue_1.indexOf(supertypeSet) < 0) {
                    workQueue_1.push(supertypeSet);
                }
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for (var i = 0; i < workQueue_1.length; ++i) {
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) {
                            __DEV__ && globals/* invariant.warn */.kG.warn("Inferring subtype ".concat(typename, " of supertype ").concat(supertype));
                        }
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes &&
                    i === workQueue_1.length - 1 &&
                    (0,helpers/* selectionSetMatchesResult */.RC)(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function (regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) {
                            maybeEnqueue_1(fuzzyString);
                        }
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function (fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables,
            };
            var args = argsFromFieldSpecifier(fieldSpec);
            while (keyFn) {
                var specifierOrString = keyFn(args, context);
                if ((0,arrays/* isArray */.k)(specifierOrString)) {
                    keyFn = keyArgsFnFromSpecifier(specifierOrString);
                }
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) {
            storeFieldName = fieldSpec.field
                ? (0,storeUtils/* storeKeyNameFromField */.vf)(fieldSpec.field, fieldSpec.variables)
                : (0,storeUtils/* getStoreKeyName */.PT)(fieldName, argsFromFieldSpecifier(fieldSpec));
        }
        if (storeFieldName === false) {
            return fieldName;
        }
        return fieldName === (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName)
            ? storeFieldName
            : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function (options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference)
            return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField)
            return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename)
                options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0,storeUtils/* isReference */.Yk)(objectOrReference)
                ? objectOrReference.__ref
                : objectOrReference, storeFieldName));
            return reactiveVars/* cacheSlot.withValue */.ab.withValue(this.cache, read, [existing, readOptions]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function (parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function (existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === mergeTrueFn) {
            return makeMergeObjectsFunction(context.store)(existing, incoming);
        }
        if (merge === mergeFalseFn) {
            return incoming;
        }
        if (context.overwrite) {
            existing = void 0;
        }
        return merge(existing, incoming, makeFieldFunctionOptions(this, void 0, { typename: typename, fieldName: field.name.value, field: field, variables: context.variables }, context, storage || Object.create(null)));
    };
    return Policies;
}());

function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: storeUtils/* isReference */.Yk,
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function () {
            return policies.readField(normalizeReadFieldOptions(arguments, objectOrReference, variables), context);
        },
        mergeObjects: makeMergeObjectsFunction(context.store),
    };
}
function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") {
        options = {
            fieldName: fieldNameOrOptions,
            from: argc > 1 ? from : objectOrReference,
        };
    }
    else {
        options = (0,tslib_es6.__assign)({}, fieldNameOrOptions);
        if (!helpers/* hasOwn.call */.RI.call(options, "from")) {
            options.from = objectOrReference;
        }
    }
    if (__DEV__ && options.from === void 0) {
        __DEV__ && globals/* invariant.warn */.kG.warn("Undefined 'from' passed to readField with arguments ".concat(stringifyForDisplay(Array.from(readFieldArgs))));
    }
    if (void 0 === options.variables) {
        options.variables = variables;
    }
    return options;
}
function makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0,arrays/* isArray */.k)(existing) || (0,arrays/* isArray */.k)(incoming)) {
            throw __DEV__ ? new globals/* InvariantError */.ej("Cannot automatically merge arrays") : new globals/* InvariantError */.ej(4);
        }
        if ((0,objects/* isNonNullObject */.s)(existing) &&
            (0,objects/* isNonNullObject */.s)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) {
                return incoming;
            }
            if ((0,storeUtils/* isReference */.Yk)(existing) &&
                (0,helpers/* storeValueIsStoreObject */.j)(incoming)) {
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0,helpers/* storeValueIsStoreObject */.j)(existing) &&
                (0,storeUtils/* isReference */.Yk)(incoming)) {
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0,helpers/* storeValueIsStoreObject */.j)(existing) &&
                (0,helpers/* storeValueIsStoreObject */.j)(incoming)) {
                return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, existing), incoming);
            }
        }
        return incoming;
    };
}
//# sourceMappingURL=policies.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/writeToStore.js









;
function getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) {
        context.flavors.set(key, flavored = (context.clientOnly === clientOnly &&
            context.deferred === deferred) ? context : (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { clientOnly: clientOnly, deferred: deferred }));
    }
    return flavored;
}
var StoreWriter = (function () {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function (store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0,getFromAST/* getOperationDefinition */.$H)(query);
        var merger = (0,helpers/* makeProcessedFieldsMerger */.ig)();
        variables = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (0,getFromAST/* getDefaultValues */.O4)(operationDefinition)), variables);
        var context = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({ store: store, written: Object.create(null), merge: function (existing, incoming) {
                return merger.merge(existing, incoming);
            }, variables: variables, varString: (0,object_canon/* canonicalStringify */.B)(variables) }, (0,helpers/* extractFragmentContext */.Is)(query, this.fragments)), { overwrite: !!overwrite, incomingById: new Map, clientOnly: false, deferred: false, flavors: new Map });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: { map: new Map },
            context: context,
        });
        if (!(0,storeUtils/* isReference */.Yk)(ref)) {
            throw __DEV__ ? new globals/* InvariantError */.ej("Could not identify object ".concat(JSON.stringify(result))) : new globals/* InvariantError */.ej(7);
        }
        context.incomingById.forEach(function (_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0,storeUtils/* makeReference */.kQ)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0,storeUtils/* isReference */.Yk)(applied)) {
                    return;
                }
                storeObject = applied;
            }
            if (__DEV__ && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function (field) {
                    if (field.selectionSet) {
                        fieldsWithSelectionSets_1[field.name.value] = true;
                    }
                });
                var hasSelectionSet_1 = function (storeFieldName) {
                    return fieldsWithSelectionSets_1[(0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function (storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function (storeFieldName) {
                    if (hasSelectionSet_1(storeFieldName) &&
                        !hasMergeFunction_1(storeFieldName)) {
                        warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                    }
                });
            }
            store.merge(dataId, storeObject);
        });
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function (_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var incoming = Object.create(null);
        var typename = (dataId && policies.rootTypenamesById[dataId]) ||
            (0,storeUtils/* getTypenameFromResult */.qw)(result, selectionSet, context.fragmentMap) ||
            (dataId && context.store.get(dataId, "__typename"));
        if ("string" === typeof typename) {
            incoming.__typename = typename;
        }
        var readField = function () {
            var options = normalizeReadFieldOptions(arguments, incoming, context.variables);
            if ((0,storeUtils/* isReference */.Yk)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { from: info.storeObject }), context);
                    if (result_1 !== void 0) {
                        return result_1;
                    }
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, context, typename).forEach(function (context, field) {
            var _a;
            var resultFieldKey = (0,storeUtils/* resultKeyNameFromField */.u2)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables,
                });
                var childTree = getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, field.selectionSet
                    ? getContextFlavor(context, false, false)
                    : context, childTree);
                var childTypename = void 0;
                if (field.selectionSet &&
                    ((0,storeUtils/* isReference */.Yk)(incomingValue) ||
                        (0,helpers/* storeValueIsStoreObject */.j)(incomingValue))) {
                    childTypename = readField("__typename", incomingValue);
                }
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) {
                    childTree.info = {
                        field: field,
                        typename: typename,
                        merge: merge,
                    };
                }
                else {
                    maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                }
                incoming = context.merge(incoming, (_a = {},
                    _a[storeFieldName] = incomingValue,
                    _a));
            }
            else if (__DEV__ &&
                !context.clientOnly &&
                !context.deferred &&
                !transform/* addTypenameToDocument.added */.Gw.added(field) &&
                !policies.getReadFunction(typename, field.name.value)) {
                __DEV__ && globals/* invariant.error */.kG.error("Missing field '".concat((0,storeUtils/* resultKeyNameFromField */.u2)(field), "' while writing result ").concat(JSON.stringify(result, null, 2)).substring(0, 1000));
            }
        });
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField,
            }), id = _b[0], keyObject = _b[1];
            dataId = dataId || id;
            if (keyObject) {
                incoming = context.merge(incoming, keyObject);
            }
        }
        catch (e) {
            if (!dataId)
                throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0,storeUtils/* makeReference */.kQ)(dataId);
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0)
                return dataRef;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) {
                return dataRef;
            }
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function (field) { return previous_1.fieldNodeSet.add(field); });
            }
            else {
                context.incomingById.set(dataId, {
                    storeObject: incoming,
                    mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                    fieldNodeSet: fieldNodeSet,
                });
            }
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function (value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) {
            return __DEV__ ? (0,cloneDeep/* cloneDeep */.X)(value) : value;
        }
        if ((0,arrays/* isArray */.k)(value)) {
            return value.map(function (item, i) {
                var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
                maybeRecycleChildMergeTree(mergeTree, i);
                return value;
            });
        }
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree,
        });
    };
    StoreWriter.prototype.flattenFields = function (selectionSet, result, context, typename) {
        if (typename === void 0) { typename = (0,storeUtils/* getTypenameFromResult */.qw)(result, selectionSet, context.fragmentMap); }
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new trie_esm/* Trie */.B(false);
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited)
                return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function (selection) {
                if (!(0,directives/* shouldInclude */.LZ)(selection, context.variables))
                    return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (!(clientOnly && deferred) &&
                    (0,arrays/* isNonEmptyArray */.O)(selection.directives)) {
                    selection.directives.forEach(function (dir) {
                        var name = dir.name.value;
                        if (name === "client")
                            clientOnly = true;
                        if (name === "defer") {
                            var args = (0,storeUtils/* argumentsObjectFromField */.NC)(dir, context.variables);
                            if (!args || args.if !== false) {
                                deferred = true;
                            }
                        }
                    });
                }
                if ((0,storeUtils/* isField */.My)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
                }
                else {
                    var fragment = (0,fragments/* getFragmentFromSelection */.hi)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                        throw __DEV__ ? new globals/* InvariantError */.ej("No fragment named ".concat(selection.name.value)) : new globals/* InvariantError */.ej(8);
                    }
                    if (fragment &&
                        policies.fragmentMatches(fragment, typename, result, context.variables)) {
                        flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
                    }
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function (mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0,storeUtils/* isReference */.Yk)(incoming)) {
            var e_1 = (!(0,arrays/* isArray */.k)(incoming) &&
                ((0,storeUtils/* isReference */.Yk)(existing) || (0,helpers/* storeValueIsStoreObject */.j)(existing))) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) {
                getStorageArgs = [(0,storeUtils/* isReference */.Yk)(e_1) ? e_1.__ref : e_1];
            }
            var changedFields_1;
            var getValue_1 = function (from, name) {
                return (0,arrays/* isArray */.k)(from)
                    ? (typeof name === "number" ? from[name] : void 0)
                    : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function (childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                if (void 0 === iVal)
                    return;
                if (getStorageArgs) {
                    getStorageArgs.push(storeFieldName);
                }
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map;
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) {
                    (0,globals/* invariant */.kG)(getStorageArgs.pop() === storeFieldName);
                }
            });
            if (changedFields_1) {
                incoming = ((0,arrays/* isArray */.k)(i_1) ? i_1.slice(0) : (0,tslib_es6.__assign)({}, i_1));
                changedFields_1.forEach(function (value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) {
            return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        }
        return incoming;
    };
    return StoreWriter;
}());

var emptyMergeTreePool = [];
function getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) {
        map.set(name, emptyMergeTreePool.pop() || { map: new Map });
    }
    return map.get(name);
}
function mergeMergeTrees(left, right) {
    if (left === right || !right || mergeTreeIsEmpty(right))
        return left;
    if (!left || mergeTreeIsEmpty(left))
        return right;
    var info = left.info && right.info ? (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map :
        left.map.size ? left.map : right.map;
    var merged = { info: info, map: map };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function (leftTree, key) {
            merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function (key) {
            merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && mergeTreeIsEmpty(childTree)) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var warnings = new Set();
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function (objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing)
        return;
    var incoming = getChild(incomingObj);
    if (!incoming)
        return;
    if ((0,storeUtils/* isReference */.Yk)(existing))
        return;
    if ((0,equality_esm/* equal */.D)(existing, incoming))
        return;
    if (Object.keys(existing).every(function (key) { return store.getFieldValue(incoming, key) !== void 0; })) {
        return;
    }
    var parentType = store.getFieldValue(existingRef, "__typename") ||
        store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0,helpers/* fieldNameFromStoreName */.E_)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    if (warnings.has(typeDotName))
        return;
    warnings.add(typeDotName);
    var childTypenames = [];
    if (!(0,arrays/* isArray */.k)(existing) &&
        !(0,arrays/* isArray */.k)(incoming)) {
        [existing, incoming].forEach(function (child) {
            var typename = store.getFieldValue(child, "__typename");
            if (typeof typename === "string" &&
                !childTypenames.includes(typename)) {
                childTypenames.push(typename);
            }
        });
    }
    __DEV__ && globals/* invariant.warn */.kG.warn("Cache data may be lost when replacing the ".concat(fieldName, " field of a ").concat(parentType, " object.\n\nTo address this problem (which is not a bug in Apollo Client), ").concat(childTypenames.length
        ? "either ensure all objects of type " +
            childTypenames.join(" and ") + " have an ID or a custom merge function, or "
        : "", "define a custom merge function for the ").concat(typeDotName, " field, so InMemoryCache can safely merge these objects:\n\n  existing: ").concat(JSON.stringify(existing).slice(0, 1000), "\n  incoming: ").concat(JSON.stringify(incoming).slice(0, 1000), "\n\nFor more information about these options, please refer to the documentation:\n\n  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers\n  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects\n"));
}
//# sourceMappingURL=writeToStore.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/inmemory/inMemoryCache.js















var InMemoryCache = (function (_super) {
    (0,tslib_es6.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.makeVar = reactiveVars/* makeVar */.QS;
        _this.txCount = 0;
        _this.config = (0,helpers/* normalizeConfig */.jS)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new Policies({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies,
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function () {
        var rootStore = this.data = new EntityStore.Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching,
        });
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function (resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.storeWriter = new StoreWriter(this, this.storeReader = new StoreReader({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0,helpers/* shouldCanonizeResults */.lg)(this.config),
            canon: resetResultIdentities
                ? void 0
                : previousReader && previousReader.canon,
            fragments: fragments,
        }), fragments);
        this.maybeBroadcastWatch = (0,bundle_esm/* wrap */.re)(function (c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if (supportsResultCaching(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, (0,object_canon/* canonicalStringify */.B)({ optimistic: optimistic, id: id, variables: variables }));
                }
            }
        });
        new Set([
            this.data.group,
            this.optimisticData.group,
        ]).forEach(function (group) { return group.resetCaching(); });
    };
    InMemoryCache.prototype.restore = function (data) {
        this.init();
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function (options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { store: options.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: returnPartialData })).result || null;
        }
        catch (e) {
            if (e instanceof common/* MissingFieldError */.y) {
                return null;
            }
            throw e;
        }
    };
    InMemoryCache.prototype.write = function (options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.modify = function (options) {
        if (helpers/* hasOwn.call */.RI.call(options, "id") && !options.id) {
            return false;
        }
        var store = options.optimistic
            ? this.optimisticData
            : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.diff = function (options) {
        return this.storeReader.diffQueryAgainstStore((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { store: options.optimistic ? this.optimisticData : this.data, rootId: options.id || "ROOT_QUERY", config: this.config }));
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        if (!this.watches.size) {
            (0,reactiveVars/* recallCache */._v)(this);
        }
        this.watches.add(watch);
        if (watch.immediate) {
            this.maybeBroadcastWatch(watch);
        }
        return function () {
            if (_this.watches.delete(watch) && !_this.watches.size) {
                (0,reactiveVars/* forgetCache */.li)(_this);
            }
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function (options) {
        object_canon/* canonicalStringify.reset */.B.reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) {
                this.resetResultCache(options.resetResultIdentities);
            }
            else if (options.resetResultIdentities) {
                this.storeReader.resetCanon();
            }
        }
        return ids;
    };
    InMemoryCache.prototype.retain = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function (object) {
        if ((0,storeUtils/* isReference */.Yk)(object))
            return object.__ref;
        try {
            return this.policies.identify(object)[0];
        }
        catch (e) {
            __DEV__ && globals/* invariant.warn */.kG.warn(e);
        }
    };
    InMemoryCache.prototype.evict = function (options) {
        if (!options.id) {
            if (helpers/* hasOwn.call */.RI.call(options, "id")) {
                return false;
            }
            options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { id: "ROOT_QUERY" });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options, this.data);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.reset = function (options) {
        var _this = this;
        this.init();
        object_canon/* canonicalStringify.reset */.B.reset();
        if (options && options.discardWatches) {
            this.watches.forEach(function (watch) { return _this.maybeBroadcastWatch.forget(watch); });
            this.watches.clear();
            (0,reactiveVars/* forgetCache */.li)(this);
        }
        else {
            this.broadcastWatches();
        }
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function (options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function (layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) {
                _this.data = _this.optimisticData = layer;
            }
            try {
                return updateResult = update(_this);
            }
            finally {
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) {
            this.broadcastWatches((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { onWatchUpdated: function (watch) {
                    alreadyDirty.add(watch);
                    return false;
                } }));
        }
        if (typeof optimistic === 'string') {
            this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        }
        else if (optimistic === false) {
            perform(this.data);
        }
        else {
            perform();
        }
        if (typeof removeOptimistic === "string") {
            this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        }
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { onWatchUpdated: function (watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) {
                        alreadyDirty.delete(watch);
                    }
                    return result;
                } }));
            if (alreadyDirty.size) {
                alreadyDirty.forEach(function (watch) { return _this.maybeBroadcastWatch.dirty(watch); });
            }
        }
        else {
            this.broadcastWatches(options);
        }
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function (update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || (optimisticId !== null),
        });
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0,transform/* addTypenameToDocument */.Gw)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.transformForLink = function (document) {
        var fragments = this.config.fragments;
        return fragments
            ? fragments.transform(document)
            : document;
    };
    InMemoryCache.prototype.broadcastWatches = function (options) {
        var _this = this;
        if (!this.txCount) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c, options); });
        }
    };
    InMemoryCache.prototype.broadcastWatch = function (c, options) {
        var lastDiff = c.lastDiff;
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic &&
                typeof options.optimistic === "string") {
                diff.fromOptimisticTransaction = true;
            }
            if (options.onWatchUpdated &&
                options.onWatchUpdated.call(this, c, diff, lastDiff) === false) {
                return;
            }
        }
        if (!lastDiff || !(0,equality_esm/* equal */.D)(lastDiff.result, diff.result)) {
            c.callback(c.lastDiff = diff, lastDiff);
        }
    };
    return InMemoryCache;
}(cache/* ApolloCache */.R));

//# sourceMappingURL=inMemoryCache.js.map

/***/ }),

/***/ 51420:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ canonicalStringify; },
/* harmony export */   "h": function() { return /* binding */ ObjectCanon; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5163);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);
/* harmony import */ var _wry_trie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3985);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45931);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43869);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43056);





function shallowCopy(value) {
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value)) {
        return (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .isArray */ .k)(value)
            ? value.slice(0)
            : (0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({ __proto__: Object.getPrototypeOf(value) }, value);
    }
    return value;
}
var ObjectCanon = (function () {
    function ObjectCanon() {
        this.known = new (_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .canUseWeakSet */ .sy ? WeakSet : Set)();
        this.pool = new _wry_trie__WEBPACK_IMPORTED_MODULE_1__/* .Trie */ .B(_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .canUseWeakMap */ .mr);
        this.passes = new WeakMap();
        this.keysByJSON = new Map();
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function (value) {
        return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function (value) {
        if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value)) {
            var copy = shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function (value) {
        var _this = this;
        if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value)) {
            var original = this.passes.get(value);
            if (original)
                return original;
            var proto = Object.getPrototypeOf(value);
            switch (proto) {
                case Array.prototype: {
                    if (this.known.has(value))
                        return value;
                    var array = value.map(this.admit, this);
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        if (__DEV__) {
                            Object.freeze(array);
                        }
                    }
                    return node.array;
                }
                case null:
                case Object.prototype: {
                    if (this.known.has(value))
                        return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [proto_1];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function (key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function (key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        if (__DEV__) {
                            Object.freeze(obj_1);
                        }
                    }
                    return node.object;
                }
            }
        }
        return value;
    };
    ObjectCanon.prototype.sortedKeys = function (obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) {
                this.keysByJSON.set(json, node.keys = { sorted: keys, json: json });
            }
        }
        return node.keys;
    };
    return ObjectCanon;
}());

var canonicalStringify = Object.assign(function (value) {
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(value)) {
        if (stringifyCanon === void 0) {
            resetCanonicalStringify();
        }
        var canonical = stringifyCanon.admit(value);
        var json = stringifyCache.get(canonical);
        if (json === void 0) {
            stringifyCache.set(canonical, json = JSON.stringify(canonical));
        }
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: resetCanonicalStringify,
});
var stringifyCanon;
var stringifyCache;
function resetCanonicalStringify() {
    stringifyCanon = new ObjectCanon;
    stringifyCache = new (_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .canUseWeakMap */ .mr ? WeakMap : Map)();
}
//# sourceMappingURL=object-canon.js.map

/***/ }),

/***/ 17600:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ makeVar; },
/* harmony export */   "_v": function() { return /* binding */ recallCache; },
/* harmony export */   "ab": function() { return /* binding */ cacheSlot; },
/* harmony export */   "li": function() { return /* binding */ forgetCache; }
/* harmony export */ });
/* harmony import */ var optimism__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88438);
/* harmony import */ var _wry_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62139);


var cacheSlot = new _wry_context__WEBPACK_IMPORTED_MODULE_1__/* .Slot */ .g7();
var cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    var info = cacheInfoMap.get(cache);
    if (!info) {
        cacheInfoMap.set(cache, info = {
            vars: new Set,
            dep: (0,optimism__WEBPACK_IMPORTED_MODULE_0__/* .dep */ .dP)(),
        });
    }
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.forgetCache(cache); });
}
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.attachCache(cache); });
}
function makeVar(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function (newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function (cache) {
                    getCacheInfo(cache).dep.dirty(rv);
                    broadcast(cache);
                });
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function (listener) { return listener(value); });
            }
        }
        else {
            var cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function (listener) {
        listeners.add(listener);
        return function () {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function (cache) {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function (cache) { return caches.delete(cache); };
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) {
        cache.broadcastWatches();
    }
}
//# sourceMappingURL=reactiveVars.js.map

/***/ }),

/***/ 93069:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ ApolloClient; }
});

// UNUSED EXPORTS: mergeOptions

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(64619);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(33957);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/execute.js
var execute = __webpack_require__(36602);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/version.js
var version = '3.7.10';
//# sourceMappingURL=version.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/HttpLink.js
var HttpLink = __webpack_require__(72558);
// EXTERNAL MODULE: ../../node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(38229);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(43056);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeDeep.js
var mergeDeep = __webpack_require__(34529);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/common/incrementalResult.js


function isExecutionPatchIncrementalResult(value) {
    return "incremental" in value;
}
function isExecutionPatchInitialResult(value) {
    return "hasNext" in value && "data" in value;
}
function isExecutionPatchResult(value) {
    return (isExecutionPatchIncrementalResult(value) ||
        isExecutionPatchInitialResult(value));
}
function mergeIncrementalData(prevResult, result) {
    var mergedData = prevResult;
    var merger = new mergeDeep/* DeepMerger */.w0();
    if (isExecutionPatchIncrementalResult(result) &&
        (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
        result.incremental.forEach(function (_a) {
            var data = _a.data, path = _a.path;
            for (var i = path.length - 1; i >= 0; --i) {
                var key = path[i];
                var isNumericKey = !isNaN(+key);
                var parent_1 = isNumericKey ? [] : {};
                parent_1[key] = data;
                data = parent_1;
            }
            mergedData = merger.merge(mergedData, data);
        });
    }
    return mergedData;
}
//# sourceMappingURL=incrementalResult.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/object-canon.js
var object_canon = __webpack_require__(51420);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(43869);
// EXTERNAL MODULE: ../../node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(12129);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/observables/asyncMap.js

function asyncMap(observable, mapFn, catchFn) {
    return new zen_observable_ts_module/* Observable */.y(function (observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function (callback) {
                return new Promise(function (resolve) { return resolve(callback()); });
            },
        };
        function makeCallback(examiner, delegate) {
            if (examiner) {
                return function (arg) {
                    ++activeCallbackCount;
                    var both = function () { return examiner(arg); };
                    promiseQueue = promiseQueue.then(both, both).then(function (result) {
                        --activeCallbackCount;
                        next && next.call(observer, result);
                        if (completed) {
                            handler.complete();
                        }
                    }, function (error) {
                        --activeCallbackCount;
                        throw error;
                    }).catch(function (caught) {
                        error && error.call(observer, caught);
                    });
                };
            }
            else {
                return function (arg) { return delegate && delegate.call(observer, arg); };
            }
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function () {
                completed = true;
                if (!activeCallbackCount) {
                    complete && complete.call(observer);
                }
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}
//# sourceMappingURL=asyncMap.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/common/errorHandling.js


function graphQLResultHasError(result) {
    var errors = getGraphQLErrorsFromResult(result);
    return (0,arrays/* isNonEmptyArray */.O)(errors);
}
function getGraphQLErrorsFromResult(result) {
    var graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors)
        ? result.errors.slice(0)
        : [];
    if (isExecutionPatchIncrementalResult(result) &&
        (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
        result.incremental.forEach(function (incrementalResult) {
            if (incrementalResult.errors) {
                graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
            }
        });
    }
    return graphQLErrors;
}
//# sourceMappingURL=errorHandling.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(86607);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/transform.js
var transform = __webpack_require__(11209);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(9572);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(72);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/objects.js
var objects = __webpack_require__(45931);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/makeUniqueId.js
var makeUniqueId = __webpack_require__(99635);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/observables/iteration.js
var iteration = __webpack_require__(13287);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/observables/subclassing.js
var subclassing = __webpack_require__(21931);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/observables/Concast.js




function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var Concast = (function (_super) {
    (0,tslib_es6.__extends)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function (observer) {
            _this.addObserver(observer);
            return function () { return _this.removeObserver(observer); };
        }) || this;
        _this.observers = new Set();
        _this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function (result) {
                if (_this.sub !== null) {
                    _this.latest = ["next", result];
                    _this.notify("next", result);
                    (0,iteration/* iterateObserversSafely */.p)(_this.observers, "next", result);
                }
            },
            error: function (error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub)
                        setTimeout(function () { return sub.unsubscribe(); });
                    _this.sub = null;
                    _this.latest = ["error", error];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0,iteration/* iterateObserversSafely */.p)(_this.observers, "error", error);
                }
            },
            complete: function () {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    var value = sources.shift();
                    if (!value) {
                        if (sub)
                            setTimeout(function () { return sub.unsubscribe(); });
                        _this.sub = null;
                        if (_this.latest &&
                            _this.latest[0] === "next") {
                            _this.resolve(_this.latest[1]);
                        }
                        else {
                            _this.resolve();
                        }
                        _this.notify("complete");
                        (0,iteration/* iterateObserversSafely */.p)(_this.observers, "complete");
                    }
                    else if (isPromiseLike(value)) {
                        value.then(function (obs) { return _this.sub = obs.subscribe(_this.handlers); });
                    }
                    else {
                        _this.sub = value.subscribe(_this.handlers);
                    }
                }
            },
        };
        _this.nextResultListeners = new Set();
        _this.cancel = function (reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function (_) { });
        if (typeof sources === "function") {
            sources = [new zen_observable_ts_module/* Observable */.y(sources)];
        }
        if (isPromiseLike(sources)) {
            sources.then(function (iterable) { return _this.start(iterable); }, _this.handlers.error);
        }
        else {
            _this.start(sources);
        }
        return _this;
    }
    Concast.prototype.start = function (sources) {
        if (this.sub !== void 0)
            return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function (observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) {
                method.call(observer, this.latest[1]);
            }
            if (this.sub === null &&
                nextOrError === "next" &&
                observer.complete) {
                observer.complete();
            }
        }
    };
    Concast.prototype.addObserver = function (observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function (observer) {
        if (this.observers.delete(observer) &&
            this.observers.size < 1) {
            this.handlers.complete();
        }
    };
    Concast.prototype.notify = function (method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            this.nextResultListeners = new Set;
            nextResultListeners.forEach(function (listener) { return listener(method, arg); });
        }
    };
    Concast.prototype.beforeNext = function (callback) {
        var called = false;
        this.nextResultListeners.add(function (method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}(zen_observable_ts_module/* Observable */.y));

(0,subclassing/* fixObservableSubclass */.D)(Concast);
//# sourceMappingURL=Concast.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(45832);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/ObservableQuery.js
var ObservableQuery = __webpack_require__(22166);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(64368);
// EXTERNAL MODULE: ../../node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(58867);
// EXTERNAL MODULE: ../../node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(95115);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/predicates.mjs

function isDefinitionNode(node) {
  return (
    isExecutableDefinitionNode(node) ||
    isTypeSystemDefinitionNode(node) ||
    isTypeSystemExtensionNode(node)
  );
}
function isExecutableDefinitionNode(node) {
  return (
    node.kind === Kind.OPERATION_DEFINITION ||
    node.kind === Kind.FRAGMENT_DEFINITION
  );
}
function isSelectionNode(node) {
  return (
    node.kind === kinds/* Kind.FIELD */.h.FIELD ||
    node.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD ||
    node.kind === kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT
  );
}
function isValueNode(node) {
  return (
    node.kind === Kind.VARIABLE ||
    node.kind === Kind.INT ||
    node.kind === Kind.FLOAT ||
    node.kind === Kind.STRING ||
    node.kind === Kind.BOOLEAN ||
    node.kind === Kind.NULL ||
    node.kind === Kind.ENUM ||
    node.kind === Kind.LIST ||
    node.kind === Kind.OBJECT
  );
}
function isConstValueNode(node) {
  return (
    isValueNode(node) &&
    (node.kind === Kind.LIST
      ? node.values.some(isConstValueNode)
      : node.kind === Kind.OBJECT
      ? node.fields.some((field) => isConstValueNode(field.value))
      : node.kind !== Kind.VARIABLE)
  );
}
function isTypeNode(node) {
  return (
    node.kind === Kind.NAMED_TYPE ||
    node.kind === Kind.LIST_TYPE ||
    node.kind === Kind.NON_NULL_TYPE
  );
}
function isTypeSystemDefinitionNode(node) {
  return (
    node.kind === Kind.SCHEMA_DEFINITION ||
    isTypeDefinitionNode(node) ||
    node.kind === Kind.DIRECTIVE_DEFINITION
  );
}
function isTypeDefinitionNode(node) {
  return (
    node.kind === Kind.SCALAR_TYPE_DEFINITION ||
    node.kind === Kind.OBJECT_TYPE_DEFINITION ||
    node.kind === Kind.INTERFACE_TYPE_DEFINITION ||
    node.kind === Kind.UNION_TYPE_DEFINITION ||
    node.kind === Kind.ENUM_TYPE_DEFINITION ||
    node.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION
  );
}
function isTypeSystemExtensionNode(node) {
  return node.kind === Kind.SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
  return (
    node.kind === Kind.SCALAR_TYPE_EXTENSION ||
    node.kind === Kind.OBJECT_TYPE_EXTENSION ||
    node.kind === Kind.INTERFACE_TYPE_EXTENSION ||
    node.kind === Kind.UNION_TYPE_EXTENSION ||
    node.kind === Kind.ENUM_TYPE_EXTENSION ||
    node.kind === Kind.INPUT_OBJECT_TYPE_EXTENSION
  );
}

// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/fragments.js
var graphql_fragments = __webpack_require__(18001);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(17600);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/LocalState.js





var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = (0,mergeDeep/* mergeDeep */.Ee)(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = (0,mergeDeep/* mergeDeep */.Ee)(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, remoteResult), { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if ((0,directives/* hasDirectives */.FS)(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return (0,transform/* removeClientSetsFromDocument */.ob)(document);
    };
    LocalState.prototype.prepareContext = function (context) {
        var cache = this.cache;
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { cache: cache, getCacheKey: function (obj) {
                return cache.identify(obj);
            } });
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return ((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, variables), data.exportedVariables)); })];
                }
                return [2, (0,tslib_es6.__assign)({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        (0,visitor/* visit */.Vn)(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return visitor/* BREAK */.$_;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: (0,transform/* buildQueryFromSelectionSet */.aL)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            return (0,tslib_es6.__generator)(this, function (_b) {
                mainDefinition = (0,getFromAST/* getMainDefinition */.p$)(document);
                fragments = (0,getFromAST/* getFragmentDefinitions */.kU)(document);
                fragmentMap = (0,graphql_fragments/* createFragmentMap */.F)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation
                    ? definitionOperation.charAt(0).toUpperCase() +
                        definitionOperation.slice(1)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { cache: cache, client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                isClientFieldDescendant = false;
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return (0,tslib_es6.__generator)(this, function (_a) {
                        if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) {
                            return [2];
                        }
                        if (!(0,directives/* shouldInclude */.LZ)(selection, variables)) {
                            return [2];
                        }
                        if ((0,storeUtils/* isField */.My)(selection)) {
                            return [2, this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[(0,storeUtils/* resultKeyNameFromField */.u2)(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if ((0,storeUtils/* isInlineFragment */.Ao)(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                            __DEV__ ? (0,globals/* invariant */.kG)(fragment, "No fragment named ".concat(selection.name.value)) : (0,globals/* invariant */.kG)(fragment, 11);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return (0,mergeDeep/* mergeDeepArray */.bw)(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, isClientFieldDescendant, rootValue, execContext) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                if (!rootValue) {
                    return [2, null];
                }
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0,storeUtils/* resultKeyNameFromField */.u2)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(reactiveVars/* cacheSlot.withValue */.ab.withValue(this.cache, resolve, [
                                rootValue,
                                (0,storeUtils/* argumentsObjectFromField */.NC)(field, variables),
                                execContext.context,
                                { field: field, fragmentMap: execContext.fragmentMap },
                            ]));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        var _a, _b;
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function (d) { return d.name.value === 'client'; })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
            }
        }));
    };
    LocalState.prototype.collectSelectionsToResolve = function (mainDefinition, fragmentMap) {
        var isSingleASTNode = function (node) { return !Array.isArray(node); };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0,visitor/* visit */.Vn)(definitionNode, {
                    Directive: function (node, _, __, ___, ancestors) {
                        if (node.name.value === 'client') {
                            ancestors.forEach(function (node) {
                                if (isSingleASTNode(node) && isSelectionNode(node)) {
                                    matches_1.add(node);
                                }
                            });
                        }
                    },
                    FragmentSpread: function (spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        __DEV__ ? (0,globals/* invariant */.kG)(fragment, "No fragment named ".concat(spread.name.value)) : (0,globals/* invariant */.kG)(fragment, 12);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            ancestors.forEach(function (node) {
                                if (isSingleASTNode(node) && isSelectionNode(node)) {
                                    matches_1.add(node);
                                }
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function (selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}());

//# sourceMappingURL=LocalState.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/QueryInfo.js







;
var destructiveMethodCounts = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
function wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") {
        cache[methodName] = function () {
            destructiveMethodCounts.set(cache, (destructiveMethodCounts.get(cache) + 1) % 1e15);
            return original.apply(this, arguments);
        };
    }
}
function cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var QueryInfo = (function () {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) { queryId = queryManager.generateQueryId(); }
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function (query) {
        var networkStatus = query.networkStatus || core_networkStatus/* NetworkStatus.loading */.I.loading;
        if (this.variables &&
            this.networkStatus !== core_networkStatus/* NetworkStatus.loading */.I.loading &&
            !(0,equality_esm/* equal */.D)(this.variables, query.variables)) {
            networkStatus = core_networkStatus/* NetworkStatus.setVariables */.I.setVariables;
        }
        if (!(0,equality_esm/* equal */.D)(query.variables, this.variables)) {
            this.lastDiff = void 0;
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus,
        });
        if (query.observableQuery) {
            this.setObservableQuery(query.observableQuery);
        }
        if (query.lastRequestId) {
            this.lastRequestId = query.lastRequestId;
        }
        return this;
    };
    QueryInfo.prototype.reset = function () {
        cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function (variables) {
        if (variables === void 0) { variables = this.variables; }
        var options = this.getDiffOptions(variables);
        if (this.lastDiff && (0,equality_esm/* equal */.D)(options, this.lastDiff.options)) {
            return this.lastDiff.diff;
        }
        this.updateWatch(this.variables = variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return { complete: false };
        }
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function (diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions(),
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function (variables) {
        var _a;
        if (variables === void 0) { variables = this.variables; }
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults,
        };
    };
    QueryInfo.prototype.setDiff = function (diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty &&
            !(0,equality_esm/* equal */.D)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) {
                this.notifyTimeout = setTimeout(function () { return _this.notify(); }, 0);
            }
        }
    };
    QueryInfo.prototype.setObservableQuery = function (oq) {
        var _this = this;
        if (oq === this.observableQuery)
            return;
        if (this.oqListener) {
            this.listeners.delete(this.oqListener);
        }
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function () {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) {
                    oq["observe"]();
                }
                else {
                    (0,ObservableQuery/* reobserveCacheFirst */.vj)(oq);
                }
            });
        }
        else {
            delete this.oqListener;
        }
    };
    QueryInfo.prototype.notify = function () {
        var _this = this;
        cancelNotifyTimeout(this);
        if (this.shouldNotify()) {
            this.listeners.forEach(function (listener) { return listener(_this); });
        }
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function () {
        if (!this.dirty || !this.listeners.size) {
            return false;
        }
        if ((0,core_networkStatus/* isNetworkRequestInFlight */.O)(this.networkStatus) &&
            this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" &&
                fetchPolicy !== "cache-and-network") {
                return false;
            }
        }
        return true;
    };
    QueryInfo.prototype.stop = function () {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            this.cancel = QueryInfo.prototype.cancel;
            this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
            var oq = this.observableQuery;
            if (oq)
                oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function () { };
    QueryInfo.prototype.updateWatch = function (variables) {
        var _this = this;
        if (variables === void 0) { variables = this.variables; }
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return;
        }
        var watchOptions = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.getDiffOptions(variables)), { watcher: this, callback: function (diff) { return _this.setDiff(diff); } });
        if (!this.lastWatch ||
            !(0,equality_esm/* equal */.D)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function () {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function (result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite &&
            lastWrite.dmCount === destructiveMethodCounts.get(this.cache) &&
            (0,equality_esm/* equal */.D)(variables, lastWrite.variables) &&
            (0,equality_esm/* equal */.D)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function (result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new mergeDeep/* DeepMerger */.w0();
        var graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors)
            ? result.errors.slice(0)
            : [];
        this.reset();
        if ('incremental' in result && (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
            var mergedData = mergeIncrementalData(this.getDiff().result, result);
            result.data = mergedData;
        }
        else if ('hasNext' in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === 'no-cache') {
            this.updateLastDiff({ result: result.data, complete: true }, this.getDiffOptions(options.variables));
        }
        else if (cacheWriteBehavior !== 0) {
            if (shouldWriteResult(result, options.errorPolicy)) {
                this.cache.performTransaction(function (cache) {
                    if (_this.shouldWrite(result, options.variables)) {
                        cache.writeQuery({
                            query: document,
                            data: result.data,
                            variables: options.variables,
                            overwrite: cacheWriteBehavior === 1,
                        });
                        _this.lastWrite = {
                            result: result,
                            variables: options.variables,
                            dmCount: destructiveMethodCounts.get(_this.cache),
                        };
                    }
                    else {
                        if (_this.lastDiff &&
                            _this.lastDiff.diff.complete) {
                            result.data = _this.lastDiff.diff.result;
                            return;
                        }
                    }
                    var diffOptions = _this.getDiffOptions(options.variables);
                    var diff = cache.diff(diffOptions);
                    if (!_this.stopped) {
                        _this.updateWatch(options.variables);
                    }
                    _this.updateLastDiff(diff, diffOptions);
                    if (diff.complete) {
                        result.data = diff.result;
                    }
                });
            }
            else {
                this.lastWrite = void 0;
            }
        }
    };
    QueryInfo.prototype.markReady = function () {
        this.networkError = null;
        return this.networkStatus = core_networkStatus/* NetworkStatus.ready */.I.ready;
    };
    QueryInfo.prototype.markError = function (error) {
        this.networkStatus = core_networkStatus/* NetworkStatus.error */.I.error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) {
            this.graphQLErrors = error.graphQLErrors;
        }
        if (error.networkError) {
            this.networkError = error.networkError;
        }
        return error;
    };
    return QueryInfo;
}());

function shouldWriteResult(result, errorPolicy) {
    if (errorPolicy === void 0) { errorPolicy = "none"; }
    var ignoreErrors = errorPolicy === "ignore" ||
        errorPolicy === "all";
    var writeWithErrors = !graphQLResultHasError(result);
    if (!writeWithErrors && ignoreErrors && result.data) {
        writeWithErrors = true;
    }
    return writeWithErrors;
}
//# sourceMappingURL=QueryInfo.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/QueryManager.js













var QueryManager_hasOwnProperty = Object.prototype.hasOwnProperty;
var QueryManager = (function () {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: cache });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
        if ((this.onBroadcast = onBroadcast)) {
            this.mutationStore = Object.create(null);
        }
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(__DEV__ ? new globals/* InvariantError */.ej('QueryManager stopped while query was in flight') : new globals/* InvariantError */.ej(14));
    };
    QueryManager.prototype.cancelPendingFetches = function (error) {
        this.fetchCancelFns.forEach(function (cancel) { return cancel(error); });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function (_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var mutationId, _h, document, hasClientExports, mutationStoreValue, self;
            return (0,tslib_es6.__generator)(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        __DEV__ ? (0,globals/* invariant */.kG)(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.') : (0,globals/* invariant */.kG)(mutation, 15);
                        __DEV__ ? (0,globals/* invariant */.kG)(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : (0,globals/* invariant */.kG)(fetchPolicy === 'network-only' ||
                            fetchPolicy === 'no-cache', 16);
                        mutationId = this.generateMutationId();
                        _h = this.transform(mutation), document = _h.document, hasClientExports = _h.hasClientExports;
                        mutation = this.cache.transformForLink(document);
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = (_j.sent());
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore &&
                            (this.mutationStore[mutationId] = {
                                mutation: mutation,
                                variables: variables,
                                loading: true,
                                error: null,
                            });
                        if (optimisticResponse) {
                            this.markMutationOptimistic(optimisticResponse, {
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                fetchPolicy: fetchPolicy,
                                errorPolicy: errorPolicy,
                                context: context,
                                updateQueries: updateQueries,
                                update: updateWithProxyFn,
                                keepRootFields: keepRootFields,
                            });
                        }
                        this.broadcastQueries();
                        self = this;
                        return [2, new Promise(function (resolve, reject) {
                                return asyncMap(self.getObservableFromLink(mutation, (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { optimisticResponse: optimisticResponse }), variables, false), function (result) {
                                    if (graphQLResultHasError(result) && errorPolicy === 'none') {
                                        throw new errors/* ApolloError */.c({
                                            graphQLErrors: getGraphQLErrorsFromResult(result),
                                        });
                                    }
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0,tslib_es6.__assign)({}, result);
                                    if (typeof refetchQueries === "function") {
                                        refetchQueries = refetchQueries(storeResult);
                                    }
                                    if (errorPolicy === 'ignore' &&
                                        graphQLResultHasError(storeResult)) {
                                        delete storeResult.errors;
                                    }
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields,
                                    });
                                }).subscribe({
                                    next: function (storeResult) {
                                        self.broadcastQueries();
                                        if (!('hasNext' in storeResult) || storeResult.hasNext === false) {
                                            resolve(storeResult);
                                        }
                                    },
                                    error: function (err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) {
                                            self.cache.removeOptimistic(mutationId);
                                        }
                                        self.broadcastQueries();
                                        reject(err instanceof errors/* ApolloError */.c ? err : new errors/* ApolloError */.c({
                                            networkError: err,
                                        }));
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function (mutation, cache) {
        var _this = this;
        if (cache === void 0) { cache = this.cache; }
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && shouldWriteResult(result, mutation.errorPolicy)) {
            if (!isExecutionPatchIncrementalResult(result)) {
                cacheWrites.push({
                    result: result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables,
                });
            }
            if (isExecutionPatchIncrementalResult(result) && (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    query: this.transform(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true,
                });
                var mergedData = void 0;
                if (diff.result) {
                    mergedData = mergeIncrementalData(diff.result, result);
                }
                if (typeof mergedData !== 'undefined') {
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: 'ROOT_MUTATION',
                        query: mutation.document,
                        variables: mutation.variables,
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                this.queries.forEach(function (_a, queryId) {
                    var observableQuery = _a.observableQuery;
                    var queryName = observableQuery && observableQuery.queryName;
                    if (!queryName || !QueryManager_hasOwnProperty.call(updateQueries_1, queryName)) {
                        return;
                    }
                    var updater = updateQueries_1[queryName];
                    var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                    var _c = cache.diff({
                        query: document,
                        variables: variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _c.result, complete = _c.complete;
                    if (complete && currentQueryResult) {
                        var nextQueryResult = updater(currentQueryResult, {
                            mutationResult: result,
                            queryName: document && (0,getFromAST/* getOperationName */.rY)(document) || void 0,
                            queryVariables: variables,
                        });
                        if (nextQueryResult) {
                            cacheWrites.push({
                                result: nextQueryResult,
                                dataId: 'ROOT_QUERY',
                                query: document,
                                variables: variables,
                            });
                        }
                    }
                });
            }
        }
        if (cacheWrites.length > 0 ||
            mutation.refetchQueries ||
            mutation.update ||
            mutation.onQueryUpdated ||
            mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function (cache) {
                    if (!skipCache) {
                        cacheWrites.forEach(function (write) { return cache.write(write); });
                    }
                    var update = mutation.update;
                    var isFinalResult = !isExecutionPatchResult(result) ||
                        (isExecutionPatchIncrementalResult(result) && !result.hasNext);
                    if (update) {
                        if (!skipCache) {
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                query: _this.transform(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true,
                            });
                            if (diff.complete) {
                                result = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, result), { data: diff.result });
                                if ('incremental' in result) {
                                    delete result.incremental;
                                }
                                if ('hasNext' in result) {
                                    delete result.hasNext;
                                }
                            }
                        }
                        if (isFinalResult) {
                            update(cache, result, {
                                context: mutation.context,
                                variables: mutation.variables,
                            });
                        }
                    }
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) {
                        cache.modify({
                            id: 'ROOT_MUTATION',
                            fields: function (value, _a) {
                                var fieldName = _a.fieldName, DELETE = _a.DELETE;
                                return fieldName === "__typename" ? value : DELETE;
                            },
                        });
                    }
                },
                include: mutation.refetchQueries,
                optimistic: false,
                removeOptimistic: mutation.removeOptimistic,
                onQueryUpdated: mutation.onQueryUpdated || null,
            }).forEach(function (result) { return results_1.push(result); });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) {
                return Promise.all(results_1).then(function () { return result; });
            }
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function (optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function"
            ? optimisticResponse(mutation.variables)
            : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function (cache) {
            try {
                _this.markMutationResult((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, mutation), { result: { data: data } }), cache);
            }
            catch (error) {
                __DEV__ && globals/* invariant.error */.kG.error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function () {
        var store = Object.create(null);
        this.queries.forEach(function (info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors,
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var noConnection = (0,transform/* removeConnectionDirectiveFromDocument */.Fo)(transformed);
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = noConnection && this.localState.serverQuery(noConnection);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0,directives/* hasClientExports */.mj)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0,getFromAST/* getDefaultValues */.O4)((0,getFromAST/* getOperationDefinition */.$H)(transformed)),
                asQuery: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, transformed), { definitions: transformed.definitions.map(function (def) {
                        if (def.kind === "OperationDefinition" &&
                            def.operation !== "query") {
                            return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, def), { operation: "query" });
                        }
                        return def;
                    }) })
            };
            var add = function (doc) {
                if (doc && !transformCache.has(doc)) {
                    transformCache.set(doc, cacheEntry_1);
                }
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options) {
        options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { variables: this.getVariables(options.query, options.variables) });
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var queryInfo = new QueryInfo(this);
        var observable = new ObservableQuery/* ObservableQuery */.ue({
            queryManager: this,
            queryInfo: queryInfo,
            options: options,
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: observable.query,
            observableQuery: observable,
            variables: observable.variables,
        });
        return observable;
    };
    QueryManager.prototype.query = function (options, queryId) {
        var _this = this;
        if (queryId === void 0) { queryId = this.generateQueryId(); }
        __DEV__ ? (0,globals/* invariant */.kG)(options.query, 'query option is required. You must specify your GraphQL document ' +
            'in the query option.') : (0,globals/* invariant */.kG)(options.query, 17);
        __DEV__ ? (0,globals/* invariant */.kG)(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.') : (0,globals/* invariant */.kG)(options.query.kind === 'Document', 18);
        __DEV__ ? (0,globals/* invariant */.kG)(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.') : (0,globals/* invariant */.kG)(!options.returnPartialData, 19);
        __DEV__ ? (0,globals/* invariant */.kG)(!options.pollInterval, 'pollInterval option only supported on watchQuery.') : (0,globals/* invariant */.kG)(!options.pollInterval, 20);
        return this.fetchQuery(queryId, options).finally(function () { return _this.stopQuery(queryId); });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function () {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function () {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo)
            queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function (options) {
        if (options === void 0) { options = {
            discardWatches: true,
        }; }
        this.cancelPendingFetches(__DEV__ ? new globals/* InvariantError */.ej('Store reset while query was in flight (not completed in link chain)') : new globals/* InvariantError */.ej(21));
        this.queries.forEach(function (queryInfo) {
            if (queryInfo.observableQuery) {
                queryInfo.networkStatus = core_networkStatus/* NetworkStatus.loading */.I.loading;
            }
            else {
                queryInfo.stop();
            }
        });
        if (this.mutationStore) {
            this.mutationStore = Object.create(null);
        }
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function (include) {
        var _this = this;
        if (include === void 0) { include = "active"; }
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) {
            include.forEach(function (desc) {
                if (typeof desc === "string") {
                    queryNamesAndDocs.set(desc, false);
                }
                else if ((0,storeUtils/* isDocumentNode */.JW)(desc)) {
                    queryNamesAndDocs.set(_this.transform(desc).document, false);
                }
                else if ((0,objects/* isNonNullObject */.s)(desc) && desc.query) {
                    legacyQueryOptions.add(desc);
                }
            });
        }
        this.queries.forEach(function (_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" ||
                    (include === "active" && !oq.hasObservers())) {
                    return;
                }
                if (include === "active" ||
                    (queryName && queryNamesAndDocs.has(queryName)) ||
                    (document && queryNamesAndDocs.has(document))) {
                    queries.set(queryId, oq);
                    if (queryName)
                        queryNamesAndDocs.set(queryName, true);
                    if (document)
                        queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) {
            legacyQueryOptions.forEach(function (options) {
                var queryId = (0,makeUniqueId/* makeUniqueId */.X)("legacyOneTimeQuery");
                var queryInfo = _this.getQuery(queryId).init({
                    document: options.query,
                    variables: options.variables,
                });
                var oq = new ObservableQuery/* ObservableQuery */.ue({
                    queryManager: _this,
                    queryInfo: queryInfo,
                    options: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { fetchPolicy: "network-only" }),
                });
                (0,globals/* invariant */.kG)(oq.queryId === queryId);
                queryInfo.setObservableQuery(oq);
                queries.set(queryId, oq);
            });
        }
        if (__DEV__ && queryNamesAndDocs.size) {
            queryNamesAndDocs.forEach(function (included, nameOrDoc) {
                if (!included) {
                    __DEV__ && globals/* invariant.warn */.kG.warn("Unknown query ".concat(typeof nameOrDoc === "string" ? "named " : "").concat(JSON.stringify(nameOrDoc, null, 2), " requested in refetchQueries options.include array"));
                }
            });
        }
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function (observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby ||
                (fetchPolicy !== "standby" &&
                    fetchPolicy !== "cache-only")) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function (observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, context, variables).map(function (result) {
                if (fetchPolicy !== 'no-cache') {
                    if (shouldWriteResult(result, errorPolicy)) {
                        _this.cache.write({
                            query: query,
                            result: result.data,
                            dataId: 'ROOT_SUBSCRIPTION',
                            variables: variables,
                        });
                    }
                    _this.broadcastQueries();
                }
                if (graphQLResultHasError(result)) {
                    throw new errors/* ApolloError */.c({
                        graphQLErrors: result.errors,
                    });
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new zen_observable_ts_module/* Observable */.y(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return sub = observable.subscribe(observer); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function () {
        if (this.onBroadcast)
            this.onBroadcast();
        this.queries.forEach(function (info) { return info.notify(); });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) { deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication; }
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0,getFromAST/* getOperationName */.rY)(serverQuery) || void 0,
                context: this.prepareContext((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = (0,object_canon/* canonicalStringify */.B)(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new Concast([
                        (0,execute/* execute */.h)(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.beforeNext(function () {
                        if (byVariables_1.delete(varJson_1) &&
                            byVariables_1.size < 1) {
                            inFlightLinkObservables_1.delete(serverQuery);
                        }
                    });
                }
            }
            else {
                observable = new Concast([
                    (0,execute/* execute */.h)(link, operation)
                ]);
            }
        }
        else {
            observable = new Concast([
                zen_observable_ts_module/* Observable.of */.y.of({ data: {} })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function (queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        var linkDocument = this.cache.transformForLink(this.transform(queryInfo.document).document);
        return asyncMap(this.getObservableFromLink(linkDocument, options.context, options.variables), function (result) {
            var graphQLErrors = getGraphQLErrorsFromResult(result);
            var hasErrors = graphQLErrors.length > 0;
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") {
                    throw queryInfo.markError(new errors/* ApolloError */.c({
                        graphQLErrors: graphQLErrors,
                    }));
                }
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: core_networkStatus/* NetworkStatus.ready */.I.ready,
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = core_networkStatus/* NetworkStatus.error */.I.error;
            }
            return aqr;
        }, function (networkError) {
            var error = (0,errors/* isApolloError */.M)(networkError)
                ? networkError
                : new errors/* ApolloError */.c({ networkError: networkError });
            if (requestId >= queryInfo.lastRequestId) {
                queryInfo.markError(error);
            }
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function (queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) { networkStatus = core_networkStatus/* NetworkStatus.loading */.I.loading; }
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context,
        });
        var fromVariables = function (variables) {
            normalized.variables = variables;
            var concastSources = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (normalized.fetchPolicy !== "standby" &&
                concastSources.length > 0 &&
                queryInfo.observableQuery) {
                queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            }
            return concastSources;
        };
        var cleanupCancelFn = function () { return _this.fetchCancelFns.delete(queryId); };
        this.fetchCancelFns.set(queryId, function (reason) {
            cleanupCancelFn();
            setTimeout(function () { return concast.cancel(reason); });
        });
        var concast = new Concast(this.transform(normalized.query).hasClientExports
            ? this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables)
            : fromVariables(normalized.variables));
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return concast;
    };
    QueryManager.prototype.refetchQueries = function (_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0,makeUniqueId/* makeUniqueId */.X)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) {
            this.getObservableQueries(include).forEach(function (oq, queryId) {
                includedQueriesById.set(queryId, {
                    oq: oq,
                    lastDiff: _this.getQuery(queryId).getDiff(),
                });
            });
        }
        var results = new Map;
        if (updateCache) {
            this.cache.batch({
                update: updateCache,
                optimistic: optimistic && removeOptimistic || false,
                removeOptimistic: removeOptimistic,
                onWatchUpdated: function (watch, diff, lastDiff) {
                    var oq = watch.watcher instanceof QueryInfo &&
                        watch.watcher.observableQuery;
                    if (oq) {
                        if (onQueryUpdated) {
                            includedQueriesById.delete(oq.queryId);
                            var result = onQueryUpdated(oq, diff, lastDiff);
                            if (result === true) {
                                result = oq.refetch();
                            }
                            if (result !== false) {
                                results.set(oq, result);
                            }
                            return result;
                        }
                        if (onQueryUpdated !== null) {
                            includedQueriesById.set(oq.queryId, { oq: oq, lastDiff: lastDiff, diff: diff });
                        }
                    }
                },
            });
        }
        if (includedQueriesById.size) {
            includedQueriesById.forEach(function (_a, queryId) {
                var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
                var result;
                if (onQueryUpdated) {
                    if (!diff) {
                        var info = oq["queryInfo"];
                        info.reset();
                        diff = info.getDiff();
                    }
                    result = onQueryUpdated(oq, diff, lastDiff);
                }
                if (!onQueryUpdated || result === true) {
                    result = oq.refetch();
                }
                if (result !== false) {
                    results.set(oq, result);
                }
                if (queryId.indexOf("legacyOneTimeQuery") >= 0) {
                    _this.stopQueryNoBroadcast(queryId);
                }
            });
        }
        if (removeOptimistic) {
            this.cache.removeOptimistic(removeOptimistic);
        }
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function (queryInfo, _a, networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: this.transform(query).document,
            variables: variables,
            networkStatus: networkStatus,
        });
        var readCache = function () { return queryInfo.getDiff(variables); };
        var resultsFromCache = function (diff, networkStatus) {
            if (networkStatus === void 0) { networkStatus = queryInfo.networkStatus || core_networkStatus/* NetworkStatus.loading */.I.loading; }
            var data = diff.result;
            if (__DEV__ &&
                !returnPartialData &&
                !(0,equality_esm/* equal */.D)(data, {})) {
                (0,ObservableQuery/* logMissingFieldErrors */.DC)(diff.missing);
            }
            var fromData = function (data) { return zen_observable_ts_module/* Observable.of */.y.of((0,tslib_es6.__assign)({ data: data, loading: (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus), networkStatus: networkStatus }, (diff.complete ? null : { partial: true }))); };
            if (data && _this.transform(query).hasForcedResolvers) {
                return _this.localState.runResolvers({
                    document: query,
                    remoteResult: { data: data },
                    context: context,
                    variables: variables,
                    onlyRunForcedResolvers: true,
                }).then(function (resolved) { return fromData(resolved.data || void 0); });
            }
            if (errorPolicy === 'none' &&
                networkStatus === core_networkStatus/* NetworkStatus.refetch */.I.refetch &&
                Array.isArray(diff.missing)) {
                return fromData(void 0);
            }
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 :
            (networkStatus === core_networkStatus/* NetworkStatus.refetch */.I.refetch &&
                refetchWritePolicy !== "merge") ? 1
                : 2;
        var resultsFromLink = function () { return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
            variables: variables,
            context: context,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
        }); };
        var shouldNotify = notifyOnNetworkStatusChange &&
            typeof oldNetworkStatus === "number" &&
            oldNetworkStatus !== networkStatus &&
            (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus);
        switch (fetchPolicy) {
            default:
            case "cache-first": {
                var diff = readCache();
                if (diff.complete) {
                    return [
                        resultsFromCache(diff, queryInfo.markReady()),
                    ];
                }
                if (returnPartialData || shouldNotify) {
                    return [
                        resultsFromCache(diff),
                        resultsFromLink(),
                    ];
                }
                return [
                    resultsFromLink(),
                ];
            }
            case "cache-and-network": {
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) {
                    return [
                        resultsFromCache(diff),
                        resultsFromLink(),
                    ];
                }
                return [
                    resultsFromLink(),
                ];
            }
            case "cache-only":
                return [
                    resultsFromCache(readCache(), queryInfo.markReady()),
                ];
            case "network-only":
                if (shouldNotify) {
                    return [
                        resultsFromCache(readCache()),
                        resultsFromLink(),
                    ];
                }
                return [resultsFromLink()];
            case "no-cache":
                if (shouldNotify) {
                    return [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink(),
                    ];
                }
                return [resultsFromLink()];
            case "standby":
                return [];
        }
    };
    QueryManager.prototype.getQuery = function (queryId) {
        if (queryId && !this.queries.has(queryId)) {
            this.queries.set(queryId, new QueryInfo(this, queryId));
        }
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, newContext), { clientAwareness: this.clientAwareness });
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(58769);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/ApolloClient.js







var hasSuggestedDevtools = false;


var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === 'object' &&
            !window.__APOLLO_CLIENT__ &&
            __DEV__ : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? false : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) {
            link = uri
                ? new HttpLink/* HttpLink */.u({ uri: uri, credentials: credentials, headers: headers })
                : ApolloLink/* ApolloLink.empty */.i.empty();
        }
        if (!cache) {
            throw __DEV__ ? new globals/* InvariantError */.ej("To initialize Apollo Client, you must specify a 'cache' property " +
                "in the options object. \n" +
                "For more information, please visit: https://go.apollo.dev/c/docs") : new globals/* InvariantError */.ej(9);
        }
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === 'object') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && connectToDevTools && __DEV__) {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self &&
                !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                var nav = window.navigator;
                var ua = nav && nav.userAgent;
                var url = void 0;
                if (typeof ua === "string") {
                    if (ua.indexOf("Chrome/") > -1) {
                        url = "https://chrome.google.com/webstore/detail/" +
                            "apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                    }
                    else if (ua.indexOf("Firefox/") > -1) {
                        url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                }
                if (url) {
                    __DEV__ && globals/* invariant.log */.kG.log("Download the Apollo DevTools for a better development " +
                        "experience: " + url);
                }
            }
        }
        this.version = version;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.getQueryStore(),
                            mutations: _this.queryManager.mutationStore || {},
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            } : void 0,
        });
    }
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.watchQuery, options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.query, options);
        }
        __DEV__ ? (0,globals/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 'The cache-and-network fetchPolicy does not work with client.query, because ' +
            'client.query can only return a single result. Please use client.watchQuery ' +
            'to receive multiple results from the cache and the network, or consider ' +
            'using a different fetchPolicy, such as cache-first or network-only.') : (0,globals/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 10);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    };
    ApolloClient.prototype.writeFragment = function (options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return (0,execute/* execute */.h)(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: false,
        }); })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore({
            discardWatches: true,
        }); })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.refetchQueries = function (options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function (result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        result.queries = queries;
        result.results = results;
        result.catch(function (error) {
            __DEV__ && globals/* invariant.debug */.kG.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(error));
        });
        return result;
    };
    ApolloClient.prototype.getObservableQueries = function (include) {
        if (include === void 0) { include = "active"; }
        return this.queryManager.getObservableQueries(include);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function (newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}());

//# sourceMappingURL=ApolloClient.js.map

/***/ }),

/***/ 22166:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DC": function() { return /* binding */ logMissingFieldErrors; },
/* harmony export */   "ue": function() { return /* binding */ ObservableQuery; },
/* harmony export */   "vj": function() { return /* binding */ reobserveCacheFirst; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5163);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);
/* harmony import */ var _wry_equality__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38229);
/* harmony import */ var _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64368);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86607);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89732);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43056);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9428);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13287);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12129);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21931);





var assign = Object.assign, hasOwnProperty = Object.hasOwnProperty;
var ObservableQuery = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function (observer) {
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) {
                    subObserver.error = defaultSubscriptionObserverErrorCallback;
                }
            }
            catch (_a) { }
            var first = !_this.observers.size;
            _this.observers.add(observer);
            var last = _this.last;
            if (last && last.error) {
                observer.error && observer.error(last.error);
            }
            else if (last && last.result) {
                observer.next && observer.next(last.result);
            }
            if (first) {
                _this.reobserve().catch(function () { });
            }
            return function () {
                if (_this.observers.delete(observer) && !_this.observers.size) {
                    _this.tearDownQuery();
                }
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, _f = options.initialFetchPolicy, initialFetchPolicy = _f === void 0 ? (fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy) : _f;
        _this.options = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, options), { initialFetchPolicy: initialFetchPolicy, fetchPolicy: fetchPolicy });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .getOperationDefinition */ .$H)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        get: function () {
            return this.queryManager.transform(this.options.query).document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function () {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var observer = {
                next: function (result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function (saveAsLastResult) {
        if (saveAsLastResult === void 0) { saveAsLastResult = true; }
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus ||
            (lastResult && lastResult.networkStatus) ||
            _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.ready */ .I.ready;
        var result = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, lastResult), { loading: (0,_networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .isNetworkRequestInFlight */ .O)(networkStatus), networkStatus: networkStatus });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (fetchPolicy === 'network-only' ||
            fetchPolicy === 'no-cache' ||
            fetchPolicy === 'standby' ||
            this.queryManager.transform(this.options.query).hasForcedResolvers) {
        }
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) {
                result.data = diff.result;
            }
            if ((0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(result.data, {})) {
                result.data = void 0;
            }
            if (diff.complete) {
                delete result.partial;
                if (diff.complete &&
                    result.networkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.loading */ .I.loading &&
                    (fetchPolicy === 'cache-first' ||
                        fetchPolicy === 'cache-only')) {
                    result.networkStatus = _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.ready */ .I.ready;
                    result.loading = false;
                }
            }
            else {
                result.partial = true;
            }
            if (__DEV__ &&
                !diff.complete &&
                !this.options.partialRefetch &&
                !result.loading &&
                !result.data &&
                !result.error) {
                logMissingFieldErrors(diff.missing);
            }
        }
        if (saveAsLastResult) {
            this.updateLastResult(result);
        }
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult, variables) {
        return (!this.last ||
            !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(this.last.result, newResult) ||
            (variables && !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(this.last.variables, variables)));
    };
    ObservableQuery.prototype.getLast = function (key, variablesMustMatch) {
        var last = this.last;
        if (last &&
            last[key] &&
            (!variablesMustMatch || (0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(last.variables, this.variables))) {
            return last[key];
        }
    };
    ObservableQuery.prototype.getLastResult = function (variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function (variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var _a;
        var reobserveOptions = {
            pollInterval: 0,
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-and-network') {
            reobserveOptions.fetchPolicy = fetchPolicy;
        }
        else if (fetchPolicy === 'no-cache') {
            reobserveOptions.fetchPolicy = 'no-cache';
        }
        else {
            reobserveOptions.fetchPolicy = 'network-only';
        }
        if (__DEV__ && variables && hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_3__/* .getQueryDefinition */ .iW)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function (v) { return v.variable.name.value === "variables"; })) {
                __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.warn */ .kG.warn("Called refetch(".concat(JSON.stringify(variables), ") for query ").concat(((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || JSON.stringify(queryDef), ", which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"));
            }
        }
        if (variables && !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(this.options.variables, variables)) {
            reobserveOptions.variables = this.options.variables = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, this.options.variables), variables);
        }
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.refetch */ .I.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, (fetchMoreOptions.query ? fetchMoreOptions : (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, this.options), { query: this.query }), fetchMoreOptions), { variables: (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, this.options.variables), fetchMoreOptions.variables) }))), { fetchPolicy: "no-cache" });
        var qid = this.queryManager.generateQueryId();
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.fetchMore */ .I.fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.observe();
        }
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.fetchMore */ .I.fetchMore).then(function (fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.fetchMore */ .I.fetchMore) {
                queryInfo.networkStatus = originalNetworkStatus;
            }
            _this.queryManager.cache.batch({
                update: function (cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) {
                        cache.updateQuery({
                            query: _this.query,
                            variables: _this.variables,
                            returnPartialData: true,
                            optimistic: false,
                        }, function (previous) { return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables,
                        }); });
                    }
                    else {
                        cache.writeQuery({
                            query: combinedOptions.query,
                            variables: combinedOptions.variables,
                            data: fetchMoreResult.data,
                        });
                    }
                },
                onWatchUpdated: function (watch) {
                    updatedQuerySet.add(watch.query);
                },
            });
            return fetchMoreResult;
        }).finally(function () {
            if (!updatedQuerySet.has(_this.query)) {
                reobserveCacheFirst(_this);
            }
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.error */ .kG.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function (variables) {
        if ((0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(this.variables, variables)) {
            return this.observers.size
                ? this.result()
                : Promise.resolve();
        }
        this.options.variables = variables;
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.reobserve({
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables,
        }, _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.setVariables */ .I.setVariables);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables,
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables,
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    ObservableQuery.prototype.applyNextFetchPolicy = function (reason, options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") {
            }
            else if (typeof options.nextFetchPolicy === "function") {
                options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                    reason: reason,
                    options: options,
                    observable: this,
                    initialFetchPolicy: initialFetchPolicy,
                });
            }
            else if (reason === "variables-changed") {
                options.fetchPolicy = initialFetchPolicy;
            }
            else {
                options.fetchPolicy = options.nextFetchPolicy;
            }
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function (options, newNetworkStatus) {
        this.queryManager.setObservableQuery(this);
        return this.queryManager.fetchQueryObservable(this.queryId, options, newNetworkStatus);
    };
    ObservableQuery.prototype.updatePolling = function () {
        var _this = this;
        if (this.queryManager.ssrMode) {
            return;
        }
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo &&
            pollingInfo.interval === pollInterval) {
            return;
        }
        __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(pollInterval, 'Attempted to start a polling query without a polling interval.') : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(pollInterval, 13);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function () {
            if (_this.pollingInfo) {
                if (!(0,_networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .isNetworkRequestInFlight */ .O)(_this.queryInfo.networkStatus)) {
                    _this.reobserve({
                        fetchPolicy: _this.options.initialFetchPolicy === 'no-cache' ? 'no-cache' : 'network-only',
                    }, _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.poll */ .I.poll).then(poll, poll);
                }
                else {
                    poll();
                }
            }
            ;
        };
        var poll = function () {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function (newResult, variables) {
        if (variables === void 0) { variables = this.variables; }
        this.last = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, this.last), { result: this.queryManager.assumeImmutableResults
                ? newResult
                : (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .cloneDeep */ .X)(newResult), variables: variables });
        if (!(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_6__/* .isNonEmptyArray */ .O)(newResult.errors)) {
            delete this.last.error;
        }
        return this.last;
    };
    ObservableQuery.prototype.reobserve = function (newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = newNetworkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.refetch */ .I.refetch ||
            newNetworkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.fetchMore */ .I.fetchMore ||
            newNetworkStatus === _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.poll */ .I.poll;
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_7__/* .compact */ .o)(this.options, newOptions || {});
        var options = useDisposableConcast
            ? mergedOptions
            : assign(this.options, mergedOptions);
        if (!useDisposableConcast) {
            this.updatePolling();
            if (newOptions &&
                newOptions.variables &&
                !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(newOptions.variables, oldVariables) &&
                options.fetchPolicy !== "standby" &&
                options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) {
                    newNetworkStatus = _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.setVariables */ .I.setVariables;
                }
            }
        }
        var variables = options.variables && (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, options.variables);
        var concast = this.fetch(options, newNetworkStatus);
        var observer = {
            next: function (result) {
                _this.reportResult(result, variables);
            },
            error: function (error) {
                _this.reportError(error, variables);
            },
        };
        if (!useDisposableConcast) {
            if (this.concast && this.observer) {
                this.concast.removeObserver(this.observer);
            }
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast.promise;
    };
    ObservableQuery.prototype.observe = function () {
        this.reportResult(this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function (result, variables) {
        var lastError = this.getLastError();
        if (lastError || this.isDifferentFromLastResult(result, variables)) {
            if (lastError || !result.partial || this.options.returnPartialData) {
                this.updateLastResult(result, variables);
            }
            (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_8__/* .iterateObserversSafely */ .p)(this.observers, 'next', result);
        }
    };
    ObservableQuery.prototype.reportError = function (error, variables) {
        var errorResult = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, this.getLastResult()), { error: error, errors: error.graphQLErrors, networkStatus: _networkStatus_js__WEBPACK_IMPORTED_MODULE_4__/* .NetworkStatus.error */ .I.error, loading: false });
        this.updateLastResult(errorResult, variables);
        (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_8__/* .iterateObserversSafely */ .p)(this.observers, 'error', this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function () {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        if (this.isTornDown)
            return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    return ObservableQuery;
}(_utilities_index_js__WEBPACK_IMPORTED_MODULE_9__/* .Observable */ .y));

(0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_10__/* .fixObservableSubclass */ .D)(ObservableQuery);
function reobserveCacheFirst(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" ||
        fetchPolicy === "network-only") {
        return obsQuery.reobserve({
            fetchPolicy: "cache-first",
            nextFetchPolicy: function () {
                this.nextFetchPolicy = nextFetchPolicy;
                if (typeof nextFetchPolicy === "function") {
                    return nextFetchPolicy.apply(this, arguments);
                }
                return fetchPolicy;
            },
        });
    }
    return obsQuery.reobserve();
}
function defaultSubscriptionObserverErrorCallback(error) {
    __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.error */ .kG.error('Unhandled error', error.message, error.stack);
}
function logMissingFieldErrors(missing) {
    if (__DEV__ && missing) {
        __DEV__ && _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.debug */ .kG.debug("Missing cache result fields: ".concat(JSON.stringify(missing)), missing);
    }
}
//# sourceMappingURL=ObservableQuery.js.map

/***/ }),

/***/ 54814:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ApolloCache": function() { return /* reexport */ cache/* ApolloCache */.R; },
  "ApolloClient": function() { return /* reexport */ ApolloClient/* ApolloClient */.f; },
  "ApolloError": function() { return /* reexport */ errors/* ApolloError */.c; },
  "ApolloLink": function() { return /* reexport */ ApolloLink/* ApolloLink */.i; },
  "Cache": function() { return /* reexport */ Cache; },
  "HttpLink": function() { return /* reexport */ http.HttpLink; },
  "InMemoryCache": function() { return /* reexport */ inMemoryCache/* InMemoryCache */.h; },
  "MissingFieldError": function() { return /* reexport */ common/* MissingFieldError */.y; },
  "NetworkStatus": function() { return /* reexport */ networkStatus/* NetworkStatus */.I; },
  "Observable": function() { return /* reexport */ zen_observable_ts_module/* Observable */.y; },
  "ObservableQuery": function() { return /* reexport */ ObservableQuery/* ObservableQuery */.ue; },
  "checkFetcher": function() { return /* reexport */ http.checkFetcher; },
  "concat": function() { return /* reexport */ concat; },
  "createHttpLink": function() { return /* reexport */ http.createHttpLink; },
  "createSignalIfSupported": function() { return /* reexport */ http.createSignalIfSupported; },
  "defaultDataIdFromObject": function() { return /* reexport */ helpers/* defaultDataIdFromObject */.uG; },
  "defaultPrinter": function() { return /* reexport */ http.defaultPrinter; },
  "disableExperimentalFragmentVariables": function() { return /* reexport */ lib/* disableExperimentalFragmentVariables */.J9; },
  "disableFragmentWarnings": function() { return /* reexport */ lib/* disableFragmentWarnings */._t; },
  "empty": function() { return /* reexport */ empty; },
  "enableExperimentalFragmentVariables": function() { return /* reexport */ lib/* enableExperimentalFragmentVariables */.wO; },
  "execute": function() { return /* reexport */ execute/* execute */.h; },
  "fallbackHttpConfig": function() { return /* reexport */ http.fallbackHttpConfig; },
  "from": function() { return /* reexport */ from; },
  "fromError": function() { return /* reexport */ fromError/* fromError */.Q; },
  "fromPromise": function() { return /* reexport */ fromPromise; },
  "gql": function() { return /* reexport */ lib/* gql */.Ps; },
  "isApolloError": function() { return /* reexport */ errors/* isApolloError */.M; },
  "isReference": function() { return /* reexport */ storeUtils/* isReference */.Yk; },
  "makeReference": function() { return /* reexport */ storeUtils/* makeReference */.kQ; },
  "makeVar": function() { return /* reexport */ reactiveVars/* makeVar */.QS; },
  "mergeOptions": function() { return /* reexport */ mergeOptions/* mergeOptions */.J; },
  "parseAndCheckHttpResponse": function() { return /* reexport */ http.parseAndCheckHttpResponse; },
  "resetCaches": function() { return /* reexport */ lib/* resetCaches */.HW; },
  "rewriteURIForGET": function() { return /* reexport */ http.rewriteURIForGET; },
  "selectHttpOptionsAndBody": function() { return /* reexport */ http.selectHttpOptionsAndBody; },
  "selectHttpOptionsAndBodyInternal": function() { return /* reexport */ http.selectHttpOptionsAndBodyInternal; },
  "selectURI": function() { return /* reexport */ http.selectURI; },
  "serializeFetchParameter": function() { return /* reexport */ http.serializeFetchParameter; },
  "setLogVerbosity": function() { return /* reexport */ invariant/* setVerbosity */.U6; },
  "split": function() { return /* reexport */ split; },
  "throwServerError": function() { return /* reexport */ throwServerError/* throwServerError */.P; },
  "toPromise": function() { return /* reexport */ toPromise; }
});

// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(64619);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/ApolloClient.js + 9 modules
var ApolloClient = __webpack_require__(93069);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(58769);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/ObservableQuery.js
var ObservableQuery = __webpack_require__(22166);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/networkStatus.js
var networkStatus = __webpack_require__(64368);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(45832);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/cache/core/types/Cache.js
var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/core/cache.js
var cache = __webpack_require__(69117);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 6 modules
var inMemoryCache = __webpack_require__(1342);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/core/types/common.js
var common = __webpack_require__(19814);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/helpers.js
var helpers = __webpack_require__(15397);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(17600);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(33957);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/empty.js

var empty = ApolloLink/* ApolloLink.empty */.i.empty;
//# sourceMappingURL=empty.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/from.js

var from = ApolloLink/* ApolloLink.from */.i.from;
//# sourceMappingURL=from.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/split.js

var split = ApolloLink/* ApolloLink.split */.i.split;
//# sourceMappingURL=split.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/concat.js

var concat = ApolloLink/* ApolloLink.concat */.i.concat;
//# sourceMappingURL=concat.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/core/execute.js
var execute = __webpack_require__(36602);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/index.js








//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/http/index.js
var http = __webpack_require__(2535);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/toPromise.js

function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    __DEV__ && globals/* invariant.warn */.kG.warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
//# sourceMappingURL=toPromise.js.map
// EXTERNAL MODULE: ../../node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(12129);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/fromPromise.js

function fromPromise(promise) {
    return new zen_observable_ts_module/* Observable */.y(function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
//# sourceMappingURL=fromPromise.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/utils/fromError.js
var fromError = __webpack_require__(67163);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = __webpack_require__(46968);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(72);
// EXTERNAL MODULE: ../../node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(35948);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(60138);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/core/index.js














(0,invariant/* setVerbosity */.U6)(globals/* DEV */.Rk ? "log" : "silent");

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 64368:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ NetworkStatus; },
/* harmony export */   "O": function() { return /* binding */ isNetworkRequestInFlight; }
/* harmony export */ });
var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
//# sourceMappingURL=networkStatus.js.map

/***/ }),

/***/ 45832:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ isApolloError; },
/* harmony export */   "c": function() { return /* binding */ ApolloError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5163);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43056);



function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonEmptyArray */ .O)(err.graphQLErrors) || (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonEmptyArray */ .O)(err.clientErrors)) {
        var errors = (err.graphQLErrors || [])
            .concat(err.clientErrors || []);
        errors.forEach(function (error) {
            var errorMessage = error
                ? error.message
                : 'Error message not found.';
            message += "".concat(errorMessage, "\n");
        });
    }
    if (err.networkError) {
        message += "".concat(err.networkError.message, "\n");
    }
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = 'ApolloError';
        _this.graphQLErrors = graphQLErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 33957:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ ApolloLink; }
});

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js + 5 modules
var globals = __webpack_require__(64619);
// EXTERNAL MODULE: ../../node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(12129);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/createOperation.js

function createOperation(starting, operation) {
    var context = (0,tslib_es6.__assign)({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), next(context));
        }
        else {
            context = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, context), next);
        }
    };
    var getContext = function () { return ((0,tslib_es6.__assign)({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    return operation;
}
//# sourceMappingURL=createOperation.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(86607);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/transformOperation.js

function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? (0,getFromAST/* getOperationName */.rY)(transformedOperation.query) || undefined
                : '';
    }
    return transformedOperation;
}
//# sourceMappingURL=transformOperation.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/utils/validateOperation.js

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw __DEV__ ? new globals/* InvariantError */.ej("illegal argument: ".concat(key)) : new globals/* InvariantError */.ej(27);
        }
    }
    return operation;
}
//# sourceMappingURL=validateOperation.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/core/ApolloLink.js




function passthrough(op, forward) {
    return (forward ? forward(op) : zen_observable_ts_module/* Observable.of */.y.of());
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function isTerminating(link) {
    return link.request.length <= 1;
}
var LinkError = (function (_super) {
    (0,tslib_es6.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.empty = function () {
        return new ApolloLink(function () { return zen_observable_ts_module/* Observable.of */.y.of(); });
    };
    ApolloLink.from = function (links) {
        if (links.length === 0)
            return ApolloLink.empty();
        return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
    };
    ApolloLink.split = function (test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) {
            return new ApolloLink(function (operation) {
                return test(operation)
                    ? leftLink.request(operation) || zen_observable_ts_module/* Observable.of */.y.of()
                    : rightLink.request(operation) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return test(operation)
                    ? leftLink.request(operation, forward) || zen_observable_ts_module/* Observable.of */.y.of()
                    : rightLink.request(operation, forward) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
    };
    ApolloLink.execute = function (link, operation) {
        return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || zen_observable_ts_module/* Observable.of */.y.of());
    };
    ApolloLink.concat = function (first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) {
            __DEV__ && globals/* invariant.warn */.kG.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
            return firstLink;
        }
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) {
            return new ApolloLink(function (operation) {
                return firstLink.request(operation, function (op) { return nextLink.request(op) || zen_observable_ts_module/* Observable.of */.y.of(); }) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return (firstLink.request(operation, function (op) {
                    return nextLink.request(op, forward) || zen_observable_ts_module/* Observable.of */.y.of();
                }) || zen_observable_ts_module/* Observable.of */.y.of());
            });
        }
    };
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw __DEV__ ? new globals/* InvariantError */.ej('request is not implemented') : new globals/* InvariantError */.ej(22);
    };
    ApolloLink.prototype.onError = function (error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function (fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}());

//# sourceMappingURL=ApolloLink.js.map

/***/ }),

/***/ 36602:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ execute; }
/* harmony export */ });
/* harmony import */ var _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33957);

var execute = _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink.execute */ .i.execute;
//# sourceMappingURL=execute.js.map

/***/ }),

/***/ 72558:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ HttpLink; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5163);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33957);
/* harmony import */ var _createHttpLink_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86653);



var HttpLink = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, (0,_createHttpLink_js__WEBPACK_IMPORTED_MODULE_1__/* .createHttpLink */ .L)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}(_core_index_js__WEBPACK_IMPORTED_MODULE_2__/* .ApolloLink */ .i));

//# sourceMappingURL=HttpLink.js.map

/***/ }),

/***/ 16173:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ checkFetcher; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);

var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        throw __DEV__ ? new _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    ") : new _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(23);
    }
};
//# sourceMappingURL=checkFetcher.js.map

/***/ }),

/***/ 86653:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ createHttpLink; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5163);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58867);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33957);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9572);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12129);
/* harmony import */ var _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17016);
/* harmony import */ var _selectURI_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52550);
/* harmony import */ var _parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97235);
/* harmony import */ var _checkFetcher_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16173);
/* harmony import */ var _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72115);
/* harmony import */ var _createSignalIfSupported_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62647);
/* harmony import */ var _rewriteURIForGET_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5729);
/* harmony import */ var _utils_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67163);














var backupFetch = (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return fetch; });
var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_1__/* .defaultPrinter */ .sb : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__rest)(linkOptions, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
    if (__DEV__) {
        (0,_checkFetcher_js__WEBPACK_IMPORTED_MODULE_3__/* .checkFetcher */ .U)(preferredFetch || backupFetch);
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions, preserveHeaderCase: preserveHeaderCase },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new _core_index_js__WEBPACK_IMPORTED_MODULE_4__/* .ApolloLink */ .i(function (operation) {
        var chosenURI = (0,_selectURI_js__WEBPACK_IMPORTED_MODULE_5__/* .selectURI */ .r)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = (0,_selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_1__/* .selectHttpOptionsAndBodyInternal */ .ve)(operation, print, _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_1__/* .fallbackHttpConfig */ .SC, linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            var unusedNames_1 = new Set(Object.keys(body.variables));
            (0,graphql__WEBPACK_IMPORTED_MODULE_6__/* .visit */ .Vn)(operation.query, {
                Variable: function (node, _key, parent) {
                    if (parent && parent.kind !== 'VariableDefinition') {
                        unusedNames_1.delete(node.name.value);
                    }
                },
            });
            if (unusedNames_1.size) {
                body.variables = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, body.variables);
                unusedNames_1.forEach(function (name) {
                    delete body.variables[name];
                });
            }
        }
        var controller;
        if (!options.signal) {
            var _c = (0,_createSignalIfSupported_js__WEBPACK_IMPORTED_MODULE_7__/* .createSignalIfSupported */ .$)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_8__/* .hasDirectives */ .FS)(['defer'], operation.query)) {
            options.headers = options.headers || {};
            options.headers.accept = "multipart/mixed; deferSpec=20220824, application/json";
        }
        if (options.method === 'GET') {
            var _d = (0,_rewriteURIForGET_js__WEBPACK_IMPORTED_MODULE_9__/* .rewriteURIForGET */ .H)(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_10__/* .fromError */ .Q)(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = (0,_serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_11__/* .serializeFetchParameter */ .g)(body, 'Payload');
            }
            catch (parseError) {
                return (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_10__/* .fromError */ .Q)(parseError);
            }
        }
        return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_12__/* .Observable */ .y(function (observer) {
            var currentFetch = preferredFetch || (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return fetch; }) || backupFetch;
            currentFetch(chosenURI, options)
                .then(function (response) {
                var _a;
                operation.setContext({ response: response });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) {
                    return (0,_parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_13__/* .readMultipartBody */ .TF)(response, observer);
                }
                else {
                    return (0,_parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_13__/* .readJsonBody */ .Wm)(response, operation, observer);
                }
            })
                .catch(function (err) { return (0,_parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_13__/* .handleError */ .S3)(err, observer); });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
//# sourceMappingURL=createHttpLink.js.map

/***/ }),

/***/ 62647:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ createSignalIfSupported; }
/* harmony export */ });
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
//# sourceMappingURL=createSignalIfSupported.js.map

/***/ }),

/***/ 2535:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HttpLink": function() { return /* reexport safe */ _HttpLink_js__WEBPACK_IMPORTED_MODULE_8__.u; },
/* harmony export */   "checkFetcher": function() { return /* reexport safe */ _checkFetcher_js__WEBPACK_IMPORTED_MODULE_4__.U; },
/* harmony export */   "createHttpLink": function() { return /* reexport safe */ _createHttpLink_js__WEBPACK_IMPORTED_MODULE_7__.L; },
/* harmony export */   "createSignalIfSupported": function() { return /* reexport safe */ _createSignalIfSupported_js__WEBPACK_IMPORTED_MODULE_5__.$; },
/* harmony export */   "defaultPrinter": function() { return /* reexport safe */ _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__.sb; },
/* harmony export */   "fallbackHttpConfig": function() { return /* reexport safe */ _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__.SC; },
/* harmony export */   "parseAndCheckHttpResponse": function() { return /* reexport safe */ _parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_1__.dO; },
/* harmony export */   "rewriteURIForGET": function() { return /* reexport safe */ _rewriteURIForGET_js__WEBPACK_IMPORTED_MODULE_9__.H; },
/* harmony export */   "selectHttpOptionsAndBody": function() { return /* reexport safe */ _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__.E4; },
/* harmony export */   "selectHttpOptionsAndBodyInternal": function() { return /* reexport safe */ _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__.ve; },
/* harmony export */   "selectURI": function() { return /* reexport safe */ _selectURI_js__WEBPACK_IMPORTED_MODULE_6__.r; },
/* harmony export */   "serializeFetchParameter": function() { return /* reexport safe */ _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_2__.g; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);
/* harmony import */ var _parseAndCheckHttpResponse_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97235);
/* harmony import */ var _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17016);
/* harmony import */ var _selectHttpOptionsAndBody_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72115);
/* harmony import */ var _checkFetcher_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16173);
/* harmony import */ var _createSignalIfSupported_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62647);
/* harmony import */ var _selectURI_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52550);
/* harmony import */ var _createHttpLink_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86653);
/* harmony import */ var _HttpLink_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72558);
/* harmony import */ var _rewriteURIForGET_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5729);










//# sourceMappingURL=index.js.map

/***/ }),

/***/ 97235:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S3": function() { return /* binding */ handleError; },
  "dO": function() { return /* binding */ parseAndCheckHttpResponse; },
  "Wm": function() { return /* binding */ readJsonBody; },
  "TF": function() { return /* binding */ readMultipartBody; }
});

// UNUSED EXPORTS: parseHeaders, parseJsonBody

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(43869);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/common/responseIterator.js

function isNodeResponse(value) {
    return !!value.body;
}
function isReadableStream(value) {
    return !!value.getReader;
}
function isAsyncIterableIterator(value) {
    return !!(canUse/* canUseAsyncIteratorSymbol */.DN &&
        value[Symbol.asyncIterator]);
}
function isStreamableBlob(value) {
    return !!value.stream;
}
function isBlob(value) {
    return !!value.arrayBuffer;
}
function isNodeReadableStream(value) {
    return !!value.pipe;
}
//# sourceMappingURL=responseIterator.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/iterators/async.js
function asyncIterator(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
            next: function () {
                return iterator.next();
            }
        },
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a;
}
//# sourceMappingURL=async.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/iterators/nodeStream.js

function nodeStreamIterator(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error)
            return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) {
                return shiftedArr[0]({ value: chunk, done: false });
            }
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[0]({ value: undefined, done: true });
        });
        !cleanup || cleanup();
    }
    cleanup = function () {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function (resolve, reject) {
            if (error)
                return reject(error);
            if (data.length)
                return resolve({ value: data.shift(), done: false });
            if (done)
                return resolve({ value: undefined, done: true });
            waiting.push([resolve, reject]);
        });
    }
    var iterator = {
        next: function () {
            return getNext();
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=nodeStream.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/iterators/promise.js

function promiseIterator(promise) {
    var resolved = false;
    var iterator = {
        next: function () {
            if (resolved)
                return Promise.resolve({
                    value: undefined,
                    done: true,
                });
            resolved = true;
            return new Promise(function (resolve, reject) {
                promise
                    .then(function (value) {
                    resolve({ value: value, done: false });
                })
                    .catch(reject);
            });
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=promise.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/iterators/reader.js

function readerIterator(reader) {
    var iterator = {
        next: function () {
            return reader.read();
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=reader.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/responseIterator.js





function responseIterator(response) {
    var body = response;
    if (isNodeResponse(response))
        body = response.body;
    if (isAsyncIterableIterator(body))
        return asyncIterator(body);
    if (isReadableStream(body))
        return readerIterator(body.getReader());
    if (isStreamableBlob(body)) {
        return readerIterator(body.stream().getReader());
    }
    if (isBlob(body))
        return promiseIterator(body.arrayBuffer());
    if (isNodeReadableStream(body))
        return nodeStreamIterator(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
//# sourceMappingURL=responseIterator.js.map
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = __webpack_require__(46968);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js



var parseAndCheckHttpResponse_hasOwnProperty = Object.prototype.hasOwnProperty;
function readMultipartBody(response, observer) {
    var _a, _b, _c;
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _d, value, done, chunk, bi, message, i, headers, contentType_1, body, result;
        var _e;
        return (0,tslib_es6.__generator)(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (TextDecoder === undefined) {
                        throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    }
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('content-type');
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter))
                        ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim()
                        : "-";
                    boundary = "--".concat(boundaryVal);
                    buffer = "";
                    iterator = responseIterator(response);
                    running = true;
                    _f.label = 1;
                case 1:
                    if (!running) return [3, 3];
                    return [4, iterator.next()];
                case 2:
                    _d = _f.sent(), value = _d.value, done = _d.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary);
                    while (bi > -1) {
                        message = void 0;
                        _e = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length),
                        ], message = _e[0], buffer = _e[1];
                        if (message.trim()) {
                            i = message.indexOf("\r\n\r\n");
                            headers = parseHeaders(message.slice(0, i));
                            contentType_1 = headers["content-type"];
                            if (contentType_1 &&
                                contentType_1.toLowerCase().indexOf("application/json") === -1) {
                                throw new Error("Unsupported patch content type: application/json is required.");
                            }
                            body = message.slice(i);
                            try {
                                result = parseJsonBody(response, body.replace("\r\n", ""));
                                if (Object.keys(result).length > 1 ||
                                    "data" in result ||
                                    "incremental" in result ||
                                    "errors" in result) {
                                    (_b = observer.next) === null || _b === void 0 ? void 0 : _b.call(observer, result);
                                }
                            }
                            catch (err) {
                                handleError(err, observer);
                            }
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [3, 1];
                case 3:
                    (_c = observer.complete) === null || _c === void 0 ? void 0 : _c.call(observer);
                    return [2];
            }
        });
    });
}
function parseHeaders(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function (line) {
        var i = line.indexOf(":");
        if (i > -1) {
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function parseJsonBody(response, bodyText) {
    if (response.status >= 300) {
        var getResult = function () {
            try {
                return JSON.parse(bodyText);
            }
            catch (err) {
                return bodyText;
            }
        };
        (0,throwServerError/* throwServerError */.P)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    }
    catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function handleError(err, observer) {
    var _a, _b;
    if (err.name === "AbortError")
        return;
    if (err.result && err.result.errors && err.result.data) {
        (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, err.result);
    }
    (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, err);
}
function readJsonBody(response, operation, observer) {
    parseAndCheckHttpResponse(operation)(response)
        .then(function (result) {
        var _a, _b;
        (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, result);
        (_b = observer.complete) === null || _b === void 0 ? void 0 : _b.call(observer);
    })
        .catch(function (err) { return handleError(err, observer); });
}
function parseAndCheckHttpResponse(operations) {
    return function (response) {
        return response
            .text()
            .then(function (bodyText) { return parseJsonBody(response, bodyText); })
            .then(function (result) {
            if (response.status >= 300) {
                (0,throwServerError/* throwServerError */.P)(response, result, "Response not successful: Received status code ".concat(response.status));
            }
            if (!Array.isArray(result) &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "data") &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "errors")) {
                (0,throwServerError/* throwServerError */.P)(response, result, "Server response was missing for query '".concat(Array.isArray(operations)
                    ? operations.map(function (op) { return op.operationName; })
                    : operations.operationName, "'."));
            }
            return result;
        });
    };
}
//# sourceMappingURL=parseAndCheckHttpResponse.js.map

/***/ }),

/***/ 5729:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ rewriteURIForGET; }
/* harmony export */ });
/* harmony import */ var _serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17016);

function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0,_serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_0__/* .serializeFetchParameter */ .g)(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0,_serializeFetchParameter_js__WEBPACK_IMPORTED_MODULE_0__/* .serializeFetchParameter */ .g)(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
//# sourceMappingURL=rewriteURIForGET.js.map

/***/ }),

/***/ 72115:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sb": function() { return /* binding */ defaultPrinter; },
  "SC": function() { return /* binding */ fallbackHttpConfig; },
  "E4": function() { return /* binding */ selectHttpOptionsAndBody; },
  "ve": function() { return /* binding */ selectHttpOptionsAndBodyInternal; }
});

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(85717);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

// EXTERNAL MODULE: ../../node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(58867);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return (0,visitor/* visit */.Vn)(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, ' '),
        ],
        ' ',
      ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) =>
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: (
      { name, typeCondition, variableDefinitions, directives, selectionSet }, // Note: fragment variable definitions are experimental and may be changed
    ) =>
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? (0,blockString/* printBlockString */.LZ)(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}

;// CONCATENATED MODULE: ../../node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js


;
var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var defaultPrinter = function (ast, printer) { return printer(ast); };
function selectHttpOptionsAndBody(operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    configs.unshift(fallbackConfig);
    return selectHttpOptionsAndBodyInternal.apply(void 0, (0,tslib_es6.__spreadArray)([operation,
        defaultPrinter], configs, false));
}
function selectHttpOptionsAndBodyInternal(operation, printer) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = {};
    var http = {};
    configs.forEach(function (config) {
        options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options), config.options), { headers: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, options.headers), config.headers) });
        if (config.credentials) {
            options.credentials = config.credentials;
        }
        http = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, http), config.http);
    });
    if (options.headers) {
        options.headers = removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    }
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = printer(query, print);
    return {
        options: options,
        body: body,
    };
}
;
function removeDuplicateHeaders(headers, preserveHeaderCase) {
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function (name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function (name) {
        headerData[name.toLowerCase()] = { originalName: name, value: headers[name] };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function (name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}
//# sourceMappingURL=selectHttpOptionsAndBody.js.map

/***/ }),

/***/ 52550:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ selectURI; }
/* harmony export */ });
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};
//# sourceMappingURL=selectURI.js.map

/***/ }),

/***/ 17016:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ serializeFetchParameter; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);

var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = __DEV__ ? new _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("Network request failed. ".concat(label, " is not serializable: ").concat(e.message)) : new _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(24);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//# sourceMappingURL=serializeFetchParameter.js.map

/***/ }),

/***/ 67163:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ fromError; }
/* harmony export */ });
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12129);

function fromError(errorValue) {
    return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function (observer) {
        observer.error(errorValue);
    });
}
//# sourceMappingURL=fromError.js.map

/***/ }),

/***/ 46968:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ throwServerError; }
/* harmony export */ });
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//# sourceMappingURL=throwServerError.js.map

/***/ }),

/***/ 42370:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getApolloContext; }
/* harmony export */ });
/* unused harmony export resetApolloContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43869);


var contextKey = _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .canUseSymbol */ .aS
    ? Symbol.for('__APOLLO_CONTEXT__')
    : '__APOLLO_CONTEXT__';
function getApolloContext() {
    var context = react__WEBPACK_IMPORTED_MODULE_0__.createContext[contextKey];
    if (!context) {
        Object.defineProperty(react__WEBPACK_IMPORTED_MODULE_0__.createContext, contextKey, {
            value: context = react__WEBPACK_IMPORTED_MODULE_0__.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true,
        });
        context.displayName = 'ApolloContext';
    }
    return context;
}

//# sourceMappingURL=ApolloContext.js.map

/***/ }),

/***/ 56675:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useApolloClient; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _context_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42370);



function useApolloClient(override) {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)((0,_context_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getApolloContext */ .K)());
    var client = override || context.client;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <ApolloProvider>, or pass an ApolloClient ' +
        'instance in via options.') : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!client, 32);
    return client;
}
//# sourceMappingURL=useApolloClient.js.map

/***/ }),

/***/ 33379:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useMutation; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58769);
/* harmony import */ var _wry_equality__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38229);
/* harmony import */ var _parser_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87274);
/* harmony import */ var _errors_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45832);
/* harmony import */ var _useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56675);







function useMutation(mutation, options) {
    var client = (0,_useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__/* .useApolloClient */ .x)(options === null || options === void 0 ? void 0 : options.client);
    (0,_parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .verifyDocumentType */ .Vp)(mutation, _parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .DocumentType.Mutation */ .n_.Mutation);
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    }
    var execute = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({}, options), { mutation: mutation });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) {
            setResult(ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            });
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0,_core_index_js__WEBPACK_IMPORTED_MODULE_5__/* .mergeOptions */ .J)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function (response) {
            var _a;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0
                ? new _errors_index_js__WEBPACK_IMPORTED_MODULE_6__/* .ApolloError */ .c({ graphQLErrors: errors })
                : void 0;
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_1)) {
                    setResult(ref.current.result = result_1);
                }
            }
            var onCompleted = executeOptions.onCompleted || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onCompleted);
            onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(response.data, clientOptions);
            return response;
        }).catch(function (error) {
            var _a;
            if (mutationId === ref.current.mutationId &&
                ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_2)) {
                    setResult(ref.current.result = result_2);
                }
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        if (ref.current.isMounted) {
            setResult({ called: false, loading: false, client: client });
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        ref.current.isMounted = true;
        return function () {
            ref.current.isMounted = false;
        };
    }, []);
    return [execute, (0,tslib__WEBPACK_IMPORTED_MODULE_4__.__assign)({ reset: reset }, result)];
}
//# sourceMappingURL=useMutation.js.map

/***/ }),

/***/ 87274:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vp": function() { return /* binding */ verifyDocumentType; },
/* harmony export */   "n_": function() { return /* binding */ DocumentType; }
/* harmony export */ });
/* unused harmony exports operationName, parser */
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);

var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
    var name;
    switch (type) {
        case DocumentType.Query:
            name = 'Query';
            break;
        case DocumentType.Mutation:
            name = 'Mutation';
            break;
        case DocumentType.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function parser(document) {
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!document && !!document.kind, "Argument of ".concat(document, " passed to parser was not a valid GraphQL ") +
        "DocumentNode. You may need to use 'graphql-tag' or another method " +
        "to convert your operation into a document") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!document && !!document.kind, 33);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for (var _i = 0, _a = document.definitions; _i < _a.length; _i++) {
        var x = _a[_i];
        if (x.kind === 'FragmentDefinition') {
            fragments.push(x);
            continue;
        }
        if (x.kind === 'OperationDefinition') {
            switch (x.operation) {
                case 'query':
                    queries.push(x);
                    break;
                case 'mutation':
                    mutations.push(x);
                    break;
                case 'subscription':
                    subscriptions.push(x);
                    break;
            }
        }
    }
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
        "You must include a query, subscription or mutation as well") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), 34);
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
        "".concat(document, " had ").concat(queries.length, " queries, ").concat(subscriptions.length, " ") +
        "subscriptions and ".concat(mutations.length, " mutations. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queries.length + mutations.length + subscriptions.length <= 1, 35);
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length
        ? queries
        : mutations.length
            ? mutations
            : subscriptions;
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(definitions.length === 1, "react-apollo only supports one definition per HOC. ".concat(document, " had ") +
        "".concat(definitions.length, " definitions. ") +
        "You can use 'compose' to join multiple operation types to a component") : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(definitions.length === 1, 36);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') {
        name = definition.name.value;
    }
    else {
        name = 'data';
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}
function verifyDocumentType(document, type) {
    var operation = parser(document);
    var requiredOperationName = operationName(type);
    var usedOperationName = operationName(operation.type);
    __DEV__ ? (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operation.type === type, "Running a ".concat(requiredOperationName, " requires a graphql ") +
        "".concat(requiredOperationName, ", but a ").concat(usedOperationName, " was used instead.")) : (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operation.type === type, 37);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 43056:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ isNonEmptyArray; },
/* harmony export */   "k": function() { return /* binding */ isArray; }
/* harmony export */ });
var isArray = Array.isArray;
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map

/***/ }),

/***/ 43869:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DN": function() { return /* binding */ canUseAsyncIteratorSymbol; },
/* harmony export */   "JC": function() { return /* binding */ canUseLayoutEffect; },
/* harmony export */   "aS": function() { return /* binding */ canUseSymbol; },
/* harmony export */   "mr": function() { return /* binding */ canUseWeakMap; },
/* harmony export */   "sy": function() { return /* binding */ canUseWeakSet; }
/* harmony export */ });
/* unused harmony export canUseDOM */
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);

var canUseWeakMap = typeof WeakMap === 'function' &&
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.product; }) !== 'ReactNative';
var canUseWeakSet = typeof WeakSet === 'function';
var canUseSymbol = typeof Symbol === 'function' &&
    typeof Symbol.for === 'function';
var canUseAsyncIteratorSymbol = canUseSymbol && Symbol.asyncIterator;
var canUseDOM = typeof (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return window.document.createElement; }) === "function";
var usingJSDOM = (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.userAgent.indexOf("jsdom") >= 0; }) || false;
var canUseLayoutEffect = canUseDOM && !usingJSDOM;
//# sourceMappingURL=canUse.js.map

/***/ }),

/***/ 89732:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ cloneDeep; }
/* harmony export */ });
var toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value);
}
function cloneDeepHelper(val, seen) {
    switch (toString.call(val)) {
        case "[object Array]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}
//# sourceMappingURL=cloneDeep.js.map

/***/ }),

/***/ 9428:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ compact; }
/* harmony export */ });
function compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}
//# sourceMappingURL=compact.js.map

/***/ }),

/***/ 99635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ makeUniqueId; }
/* harmony export */ });
var prefixCounts = new Map();
function makeUniqueId(prefix) {
    var count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}
//# sourceMappingURL=makeUniqueId.js.map

/***/ }),

/***/ 23180:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ maybeDeepFreeze; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45931);


function deepFreeze(value) {
    var workSet = new Set([value]);
    workSet.forEach(function (obj) {
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(obj) && shallowFreeze(obj) === obj) {
            Object.getOwnPropertyNames(obj).forEach(function (name) {
                if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function shallowFreeze(obj) {
    if (__DEV__ && !Object.isFrozen(obj)) {
        try {
            Object.freeze(obj);
        }
        catch (e) {
            if (e instanceof TypeError)
                return null;
            throw e;
        }
    }
    return obj;
}
function maybeDeepFreeze(obj) {
    if (__DEV__) {
        deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

/***/ }),

/***/ 34529:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ mergeDeep; },
/* harmony export */   "bw": function() { return /* binding */ mergeDeepArray; },
/* harmony export */   "w0": function() { return /* binding */ DeepMerger; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5163);
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45931);


var hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new DeepMerger();
        for (var i = 1; i < count; ++i) {
            target = merger.merge(target, sources[i]);
        }
    }
    return target;
}
var defaultReconciler = function (target, source, property) {
    return this.merge(target[property], source[property]);
};
var DeepMerger = (function () {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) { reconciler = defaultReconciler; }
        this.reconciler = reconciler;
        this.isObject = _objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function (target, source) {
        var _this = this;
        var context = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            context[_i - 2] = arguments[_i];
        }
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(source) && (0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(target)) {
            Object.keys(source).forEach(function (sourceKey) {
                if (hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([target, source, sourceKey], context, false));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                }
                else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function (value) {
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) {
                    value = value.slice(0);
                }
                else {
                    value = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({ __proto__: Object.getPrototypeOf(value) }, value);
                }
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}());

//# sourceMappingURL=mergeDeep.js.map

/***/ }),

/***/ 58769:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ mergeOptions; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5163);
/* harmony import */ var _compact_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9428);


function mergeOptions(defaults, options) {
    return (0,_compact_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)(defaults, options, options.variables && {
        variables: (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, (defaults && defaults.variables)), options.variables),
    });
}
//# sourceMappingURL=mergeOptions.js.map

/***/ }),

/***/ 45931:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ isNonNullObject; }
/* harmony export */ });
function isNonNullObject(obj) {
    return obj !== null && typeof obj === 'object';
}
//# sourceMappingURL=objects.js.map

/***/ }),

/***/ 64619:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Rk": function() { return /* reexport */ DEV; },
  "ej": function() { return /* reexport */ invariant/* InvariantError */.ej; },
  "kG": function() { return /* reexport */ invariant/* invariant */.kG; },
  "wY": function() { return /* reexport */ maybe; }
});

// UNUSED EXPORTS: checkDEV, global

// EXTERNAL MODULE: ../../node_modules/ts-invariant/lib/invariant.js
var invariant = __webpack_require__(35948);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/maybe.js
function maybe(thunk) {
    try {
        return thunk();
    }
    catch (_a) { }
}
//# sourceMappingURL=maybe.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/global.js

/* harmony default export */ var globals_global = (maybe(function () { return globalThis; }) ||
    maybe(function () { return window; }) ||
    maybe(function () { return self; }) ||
    maybe(function () { return global; }) || maybe(function () { return maybe.constructor("return this")(); }));
//# sourceMappingURL=global.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/DEV.js


var __ = "__";
var GLOBAL_KEY = [__, __].join("DEV");
function getDEV() {
    try {
        return Boolean(__DEV__);
    }
    catch (_a) {
        Object.defineProperty(globals_global, GLOBAL_KEY, {
            value: maybe(function () { return "production"; }) !== "production",
            enumerable: false,
            configurable: true,
            writable: true,
        });
        return globals_global[GLOBAL_KEY];
    }
}
/* harmony default export */ var DEV = (getDEV());
//# sourceMappingURL=DEV.js.map
;// CONCATENATED MODULE: ../../node_modules/ts-invariant/process/index.js
/* provided dependency */ var process = __webpack_require__(93542);
function process_maybe(thunk) {
  try { return thunk() } catch (_) {}
}

var safeGlobal = (
  process_maybe(function() { return globalThis }) ||
  process_maybe(function() { return window }) ||
  process_maybe(function() { return self }) ||
  process_maybe(function() { return global }) ||
  // We don't expect the Function constructor ever to be invoked at runtime, as
  // long as at least one of globalThis, window, self, or global is defined, so
  // we are under no obligation to make it easy for static analysis tools to
  // detect syntactic usage of the Function constructor. If you think you can
  // improve your static analysis to detect this obfuscation, think again. This
  // is an arms race you cannot win, at least not in JavaScript.
  process_maybe(function() { return process_maybe.constructor("return this")() })
);

var needToRemove = false;

function install() {
  if (safeGlobal &&
      !process_maybe(function() { return "production" }) &&
      !process_maybe(function() { return process })) {
    Object.defineProperty(safeGlobal, "process", {
      value: {
        env: {
          // This default needs to be "production" instead of "development", to
          // avoid the problem https://github.com/graphql/graphql-js/pull/2894
          // will eventually solve, once merged and released.
          NODE_ENV: "production",
        },
      },
      // Let anyone else change global.process as they see fit, but hide it from
      // Object.keys(global) enumeration.
      configurable: true,
      enumerable: false,
      writable: true,
    });
    needToRemove = true;
  }
}

// Call install() at least once, when this module is imported.
install();

function remove() {
  if (needToRemove) {
    delete safeGlobal.process;
    needToRemove = false;
  }
}

// EXTERNAL MODULE: ../../node_modules/graphql/language/source.mjs + 1 modules
var source = __webpack_require__(22744);
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/fix-graphql.js


function removeTemporaryGlobals() {
    return typeof source/* Source */.H === "function" ? remove() : remove();
}
//# sourceMappingURL=fix-graphql.js.map
;// CONCATENATED MODULE: ../../node_modules/@apollo/client/utilities/globals/index.js



function checkDEV() {
    __DEV__ ? (0,invariant/* invariant */.kG)("boolean" === typeof DEV, DEV) : (0,invariant/* invariant */.kG)("boolean" === typeof DEV, 39);
}

removeTemporaryGlobals();



checkDEV();
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9572:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FS": function() { return /* binding */ hasDirectives; },
/* harmony export */   "LZ": function() { return /* binding */ shouldInclude; },
/* harmony export */   "mj": function() { return /* binding */ hasClientExports; }
/* harmony export */ });
/* unused harmony exports getDirectiveNames, hasAnyDirectives, hasAllDirectives, getInclusionDirectives */
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58867);


function shouldInclude(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) {
        return true;
    }
    return getInclusionDirectives(directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables && variables[ifArgument.value.name.value];
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(evaledValue !== void 0, "Invalid variable referenced in @".concat(directive.name.value, " directive.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(evaledValue !== void 0, 40);
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(root) {
    var names = [];
    visit(root, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
var hasAnyDirectives = function (names, root) { return hasDirectives(names, root, false); };
var hasAllDirectives = function (names, root) { return hasDirectives(names, root, true); };
function hasDirectives(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0,graphql__WEBPACK_IMPORTED_MODULE_1__/* .visit */ .Vn)(root, {
        Directive: function (node) {
            if (nameSet.delete(node.name.value) &&
                (!all || !nameSet.size)) {
                return graphql__WEBPACK_IMPORTED_MODULE_1__/* .BREAK */ .$_;
            }
        },
    });
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function hasClientExports(document) {
    return document && hasDirectives(['client', 'export'], document, true);
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    var result = [];
    if (directives && directives.length) {
        directives.forEach(function (directive) {
            if (!isInclusionDirective(directive))
                return;
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @".concat(directiveName, " directive.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(directiveArguments && directiveArguments.length === 1, 41);
            var ifArgument = directiveArguments[0];
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @".concat(directiveName, " directive.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifArgument.name && ifArgument.name.value === 'if', 42);
            var ifValue = ifArgument.value;
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @".concat(directiveName, " directive must be a variable or a boolean value.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 43);
            result.push({ directive: directive, ifArgument: ifArgument });
        });
    }
    return result;
}
//# sourceMappingURL=directives.js.map

/***/ }),

/***/ 18001:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ createFragmentMap; },
/* harmony export */   "Yk": function() { return /* binding */ getFragmentQueryDocument; },
/* harmony export */   "hi": function() { return /* binding */ getFragmentFromSelection; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5163);
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);


function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw __DEV__ ? new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("Found a ".concat(definition.operation, " operation").concat(definition.name ? " named '".concat(definition.name.value, "'") : '', ". ") +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.') : new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(44);
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragments.length === 1, "Found ".concat(fragments.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragments.length === 1, 45);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_1__.__assign)({}, document), { definitions: (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__spreadArray)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions, true) });
    return query;
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getFragmentFromSelection(selection, fragmentMap) {
    switch (selection.kind) {
        case 'InlineFragment':
            return selection;
        case 'FragmentSpread': {
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") {
                return fragmentMap(fragmentName);
            }
            var fragment = fragmentMap && fragmentMap[fragmentName];
            __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragment, "No fragment named ".concat(fragmentName)) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragment, 46);
            return fragment || null;
        }
        default:
            return null;
    }
}
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 86607:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ getOperationDefinition; },
/* harmony export */   "A$": function() { return /* binding */ checkDocument; },
/* harmony export */   "O4": function() { return /* binding */ getDefaultValues; },
/* harmony export */   "iW": function() { return /* binding */ getQueryDefinition; },
/* harmony export */   "kU": function() { return /* binding */ getFragmentDefinitions; },
/* harmony export */   "p$": function() { return /* binding */ getMainDefinition; },
/* harmony export */   "pD": function() { return /* binding */ getFragmentDefinition; },
/* harmony export */   "rY": function() { return /* binding */ getOperationName; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);
/* harmony import */ var _storeUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72);


function checkDocument(doc) {
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc && doc.kind === 'Document', 47);
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw __DEV__ ? new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("Schema type definitions not allowed in queries. Found: \"".concat(definition.kind, "\"")) : new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(48);
        }
        return definition;
    });
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operations.length <= 1, "Ambiguous GraphQL document: contains ".concat(operations.length, " operations")) : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operations.length <= 1, 49);
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && !!definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queryDef && queryDef.operation === 'query', 'Must contain a query definition.') : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queryDef && queryDef.operation === 'query', 50);
    return queryDef;
}
function getFragmentDefinition(doc) {
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.kind === 'Document', 51);
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.definitions.length <= 1, 'Fragment must have exactly one definition.') : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.definitions.length <= 1, 52);
    var fragmentDef = doc.definitions[0];
    __DEV__ ? (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.') : (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragmentDef.kind === 'FragmentDefinition', 53);
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw __DEV__ ? new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.') : new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(54);
}
function getDefaultValues(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) {
        defs.forEach(function (def) {
            if (def.defaultValue) {
                (0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .valueToObjectRepresentation */ .vb)(defaultValues, def.variable.name, def.defaultValue);
            }
        });
    }
    return defaultValues;
}
//# sourceMappingURL=getFromAST.js.map

/***/ }),

/***/ 72:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ao": function() { return /* binding */ isInlineFragment; },
/* harmony export */   "JW": function() { return /* binding */ isDocumentNode; },
/* harmony export */   "My": function() { return /* binding */ isField; },
/* harmony export */   "NC": function() { return /* binding */ argumentsObjectFromField; },
/* harmony export */   "PT": function() { return /* binding */ getStoreKeyName; },
/* harmony export */   "Yk": function() { return /* binding */ isReference; },
/* harmony export */   "kQ": function() { return /* binding */ makeReference; },
/* harmony export */   "qw": function() { return /* binding */ getTypenameFromResult; },
/* harmony export */   "u2": function() { return /* binding */ resultKeyNameFromField; },
/* harmony export */   "vb": function() { return /* binding */ valueToObjectRepresentation; },
/* harmony export */   "vf": function() { return /* binding */ storeKeyNameFromField; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);
/* harmony import */ var _common_objects_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45931);
/* harmony import */ var _fragments_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18001);



function makeReference(id) {
    return { __ref: String(id) };
}
function isReference(obj) {
    return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}
function isDocumentNode(value) {
    return ((0,_common_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value) &&
        value.kind === "Document" &&
        Array.isArray(value.definitions));
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw __DEV__ ? new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej("The inline argument \"".concat(name.value, "\" of kind \"").concat(value.kind, "\"") +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.') : new _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(55);
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
var getStoreKeyName = Object.assign(function (fieldName, args, directives) {
    if (args &&
        directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives['connection']['key'], "(").concat(stringify(filteredArgs_1), ")");
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = stringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@".concat(key, "(").concat(stringify(directives[key]), ")");
            }
            else {
                completeFieldName += "@".concat(key);
            }
        });
    }
    return completeFieldName;
}, {
    setStringify: function (s) {
        var previous = stringify;
        stringify = s;
        return previous;
    },
});
var stringify = function defaultStringify(value) {
    return JSON.stringify(value, stringifyReplacer);
};
function stringifyReplacer(_key, value) {
    if ((0,_common_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value) && !Array.isArray(value)) {
        value = Object.keys(value).sort().reduce(function (copy, key) {
            copy[key] = value[key];
            return copy;
        }, {});
    }
    return value;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    if (typeof result.__typename === 'string') {
        return result.__typename;
    }
    for (var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++) {
        var selection = _a[_i];
        if (isField(selection)) {
            if (selection.name.value === '__typename') {
                return result[resultKeyNameFromField(selection)];
            }
        }
        else {
            var typename = getTypenameFromResult(result, (0,_fragments_js__WEBPACK_IMPORTED_MODULE_2__/* .getFragmentFromSelection */ .hi)(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === 'string') {
                return typename;
            }
        }
    }
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
//# sourceMappingURL=storeUtils.js.map

/***/ }),

/***/ 11209:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fo": function() { return /* binding */ removeConnectionDirectiveFromDocument; },
/* harmony export */   "Gw": function() { return /* binding */ addTypenameToDocument; },
/* harmony export */   "aL": function() { return /* binding */ buildQueryFromSelectionSet; },
/* harmony export */   "ob": function() { return /* binding */ removeClientSetsFromDocument; }
/* harmony export */ });
/* unused harmony exports removeDirectivesFromDocument, removeArgumentsFromDocument, removeFragmentSpreadFromDocument */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5163);
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64619);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95115);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58867);
/* harmony import */ var _getFromAST_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86607);
/* harmony import */ var _storeUtils_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72);
/* harmony import */ var _fragments_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18001);
/* harmony import */ var _common_arrays_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43056);







var TYPENAME_FIELD = {
    kind: graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FIELD */ .h.FIELD,
    name: {
        kind: graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.NAME */ .h.NAME,
        value: '__typename',
    },
};
function isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function (selection) { return selection.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FRAGMENT_SPREAD */ .h.FRAGMENT_SPREAD &&
        isEmpty(fragmentMap[selection.name.value], fragmentMap); });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty((0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getOperationDefinition */ .$H)(doc) || (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getFragmentDefinition */ .pD)(doc), (0,_fragments_js__WEBPACK_IMPORTED_MODULE_3__/* .createFragmentMap */ .F)((0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getFragmentDefinitions */ .kU)(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    var nameSet = new Set();
    var tests = [];
    directives.forEach(function (directive) {
        if (directive.name) {
            nameSet.add(directive.name);
        }
        else if (directive.test) {
            tests.push(directive.test);
        }
    });
    return function (directive) { return (nameSet.has(directive.name.value) ||
        tests.some(function (test) { return test(directive); })); };
}
function makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) { key = defaultKey; }
        var inUse = map.get(key);
        if (!inUse) {
            map.set(key, inUse = {
                variables: new Set,
                fragmentSpreads: new Set,
            });
        }
        return inUse;
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var getInUseByOperationName = makeInUseGetterFunction("");
    var getInUseByFragmentName = makeInUseGetterFunction("");
    var getInUse = function (ancestors) {
        for (var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p) {
            if ((0,_common_arrays_js__WEBPACK_IMPORTED_MODULE_4__/* .isArray */ .k)(ancestor))
                continue;
            if (ancestor.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
                return getInUseByOperationName(ancestor.name && ancestor.name.value);
            }
            if (ancestor.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FRAGMENT_DEFINITION */ .h.FRAGMENT_DEFINITION) {
                return getInUseByFragmentName(ancestor.name.value);
            }
        }
        __DEV__ && _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.error */ .kG.error("Could not find operation or fragment");
        return null;
    };
    var operationCount = 0;
    for (var i = doc.definitions.length - 1; i >= 0; --i) {
        if (doc.definitions[i].kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
            ++operationCount;
        }
    }
    var directiveMatcher = getDirectiveMatcher(directives);
    var hasRemoveDirective = directives.some(function (directive) { return directive.remove; });
    var shouldRemoveField = function (nodeDirectives) { return (hasRemoveDirective &&
        nodeDirectives &&
        nodeDirectives.some(directiveMatcher)); };
    var originalFragmentDefsByPath = new Map();
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function (node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        },
    };
    var docWithoutDirectiveSubtrees = (0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(doc, {
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function () {
                return false;
            },
        },
        Variable: {
            enter: function (node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.variables.add(node.name.value);
                }
            },
        },
        FragmentSpread: {
            enter: function (node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.fragmentSpreads.add(node.name.value);
                }
            },
        },
        FragmentDefinition: {
            enter: function (node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function (node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) {
                    return node;
                }
                if (operationCount > 0 &&
                    node.selectionSet.selections.every(function (selection) { return (selection.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FIELD */ .h.FIELD &&
                        selection.name.value === '__typename'); })) {
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
        Directive: {
            leave: function (node) {
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
    });
    if (!firstVisitMadeChanges) {
        return doc;
    }
    var populateTransitiveVars = function (inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) {
                inUse.fragmentSpreads.forEach(function (childFragmentName) {
                    populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function (varName) {
                        inUse.transitiveVars.add(varName);
                    });
                });
            }
        }
        return inUse;
    };
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function (def) {
        if (def.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
            populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function (childFragmentName) {
                allFragmentNamesUsed.add(childFragmentName);
            });
        }
        else if (def.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FRAGMENT_DEFINITION */ .h.FRAGMENT_DEFINITION &&
            operationCount === 0 &&
            !getInUseByFragmentName(def.name.value).removed) {
            allFragmentNamesUsed.add(def.name.value);
        }
    });
    allFragmentNamesUsed.forEach(function (fragmentName) {
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function (childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function (fragmentName) { return !!(!allFragmentNamesUsed.has(fragmentName) ||
        getInUseByFragmentName(fragmentName).removed); };
    var enterVisitor = {
        enter: function (node) {
            if (fragmentWillBeRemoved(node.name.value)) {
                return null;
            }
        },
    };
    return nullIfDocIsEmpty((0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(docWithoutDirectiveSubtrees, {
        FragmentSpread: enterVisitor,
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function (node) {
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    if (usedVariableNames_1.size < node.variableDefinitions.length) {
                        return (0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)({}, node), { variableDefinitions: node.variableDefinitions.filter(function (varDef) { return usedVariableNames_1.has(varDef.variable.name.value); }) });
                    }
                }
            },
        },
    }));
}
var addTypenameToDocument = Object.assign(function (doc) {
    return (0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(doc, {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return ((0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .isField */ .My)(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if ((0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .isField */ .My)(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return (0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)({}, node), { selections: (0,tslib__WEBPACK_IMPORTED_MODULE_6__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_6__.__spreadArray)([], selections, true), [TYPENAME_FIELD], false) });
            },
        },
    });
}, {
    added: function (field) {
        return field === TYPENAME_FIELD;
    },
});
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                __DEV__ && _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.warn */ .kG.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .checkDocument */ .A$)(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (!!selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === Kind.VARIABLE &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty(visit(doc, {
        OperationDefinition: {
            enter: function (node) {
                return __assign(__assign({}, node), { variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) : [] });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) {
                        node.arguments.forEach(function (arg) {
                            if (argMatcher(arg)) {
                                argMatchCount_1 += 1;
                            }
                        });
                    }
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty(visit(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function buildQueryFromSelectionSet(document) {
    var definition = (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getMainDefinition */ .p$)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = (0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(document, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_6__.__assign)({}, node), { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .checkDocument */ .A$)(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    return modifiedDoc;
}
//# sourceMappingURL=transform.js.map

/***/ }),

/***/ 13287:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ iterateObserversSafely; }
/* harmony export */ });
function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
//# sourceMappingURL=iteration.js.map

/***/ }),

/***/ 21931:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ fixObservableSubclass; }
/* harmony export */ });
/* harmony import */ var _Observable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12129);
/* harmony import */ var _common_canUse_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43869);


function fixObservableSubclass(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, { value: _Observable_js__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y });
    }
    if (_common_canUse_js__WEBPACK_IMPORTED_MODULE_1__/* .canUseSymbol */ .aS && Symbol.species) {
        set(Symbol.species);
    }
    set("@@species");
    return subclass;
}
//# sourceMappingURL=subclassing.js.map

/***/ }),

/***/ 926:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),

/***/ 80753:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),

/***/ 9249:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 87371:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32802);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 56666:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32802);

function _defineProperty(obj, key, value) {
  key = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),

/***/ 7896:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 95058:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 45754:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88960);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 81665:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88960);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 70352:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _isNativeReflectConstruct; }
/* harmony export */ });
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),

/***/ 33028:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread2; }
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56666);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),

/***/ 59740:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31461);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),

/***/ 31461:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 88960:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 12215:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(59147);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 51171:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(926);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(59147);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 32802:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toPropertyKey; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if ((0,esm_typeof/* default */.Z)(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0,esm_typeof/* default */.Z)(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return (0,esm_typeof/* default */.Z)(key) === "symbol" ? key : String(key);
}

/***/ }),

/***/ 86522:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 59147:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(926);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 30630:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 98788:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 90581:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 27805:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ }),

/***/ 45460:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(1899);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && ((0,_type_of/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 47842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 58013:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 64297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ }),

/***/ 42838:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 33579:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 70865:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47842);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 96670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 26297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 66383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 92228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 68875:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ }),

/***/ 50930:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(30630);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 1899:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 15459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30630);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 10380:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ dset; }
/* harmony export */ });
function dset(obj, keys, val) {
	keys.split && (keys=keys.split('.'));
	var i=0, l=keys.length, t=obj, x, k;
	while (i < l) {
		k = keys[i++];
		if (k === '__proto__' || k === 'constructor' || k === 'prototype') break;
		t = t[k] = (i === l) ? val : (typeof(x=t[k])===typeof(keys)) ? x : (keys[i]*0 !== 0 || !!~(''+keys[i]).indexOf('.')) ? {} : [];
	}
}


/***/ }),

/***/ 88660:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ devAssert; }
/* harmony export */ });
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 92277:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ inspect; }
/* harmony export */ });
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 90781:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UG": function() { return /* binding */ isNode; },
/* harmony export */   "WU": function() { return /* binding */ Token; },
/* harmony export */   "Ye": function() { return /* binding */ Location; },
/* harmony export */   "h8": function() { return /* binding */ QueryDocumentKeys; },
/* harmony export */   "ku": function() { return /* binding */ OperationTypeNode; }
/* harmony export */ });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));




/***/ }),

/***/ 85717:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "wv": function() { return /* binding */ dedentBlockStringLines; }
/* harmony export */ });
/* unused harmony export isPrintableAsBlockString */
/* harmony import */ var _characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51591);

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}


/***/ }),

/***/ 51591:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ isWhiteSpace; },
/* harmony export */   "HQ": function() { return /* binding */ isNameContinue; },
/* harmony export */   "LQ": function() { return /* binding */ isNameStart; },
/* harmony export */   "X1": function() { return /* binding */ isDigit; }
/* harmony export */ });
/* unused harmony export isLetter */
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}


/***/ }),

/***/ 95115:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));


/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */


/***/ }),

/***/ 22744:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ Source; },
  "T": function() { return /* binding */ isSource; }
});

// EXTERNAL MODULE: ../../node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(88660);
// EXTERNAL MODULE: ../../node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(92277);
;// CONCATENATED MODULE: ../../node_modules/graphql/jsutils/instanceOf.mjs

/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  // eslint-disable-next-line no-undef
   true
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : 0;

;// CONCATENATED MODULE: ../../node_modules/graphql/language/source.mjs




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      (0,devAssert/* devAssert */.a)(false, `Body must be a string. Received: ${(0,inspect/* inspect */.X)(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf(source, Source);
}


/***/ }),

/***/ 58867:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ BREAK; },
/* harmony export */   "Vn": function() { return /* binding */ visit; }
/* harmony export */ });
/* unused harmony exports visitInParallel, getEnterLeaveForKind, getVisitFn */
/* harmony import */ var _jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88660);
/* harmony import */ var _jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92277);
/* harmony import */ var _ast_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90781);
/* harmony import */ var _kinds_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95115);




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = _ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .QueryDocumentKeys */ .h8) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(_kinds_mjs__WEBPACK_IMPORTED_MODULE_1__/* .Kind */ .h)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(node),
          );

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      (0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(node) || (0,_jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__/* .devAssert */ .a)(false, `Invalid AST Node: ${(0,_jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__/* .inspect */ .X)(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if ((0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(Kind)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}


/***/ }),

/***/ 76665:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P2": function() { return /* binding */ ln; },
/* harmony export */   "Uy": function() { return /* binding */ fn; },
/* harmony export */   "_x": function() { return /* binding */ dn; },
/* harmony export */   "mv": function() { return /* binding */ r; }
/* harmony export */ });
/* unused harmony exports Immer, applyPatches, castDraft, castImmutable, current, enableAllPlugins, enableES5, enableMapSet, enablePatches, freeze, immerable, isDraftable, nothing, original, produceWithPatches, setAutoFreeze, setUseProxies */
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!n.constructor[L]||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?(n.delete(r),n.add(t)):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)?n:(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0),n)}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function O(n){g(n),n.p.forEach(S),n.p=null}function g(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.O=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.g||b("ES5").S(e,r,o),o?(i[Q].P&&(O(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),O(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o;i(3===e.i?new Set(o):o,(function(r,i){return A(n,e,o,r,i,t)})),x(n,o,!1),t&&n.u&&b("Patches").R(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s){if( false&&0,r(c)){var v=M(e,c,s&&i&&3!==i.i&&!u(i.D,a)?s.concat(a):void 0);if(f(o,a,v),!r(v))return;e.m=!1}if(t(c)&&!y(c)){if(!e.h.F&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),n.h.F&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function R(n,r,t){var e=s(r)?b("MapSet").N(r,t):v(r)?b("MapSet").T(r,t):n.g?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function D(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=F(r,c),u.I=!1}else e=F(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function F(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function N(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.O&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:i,o:null,O:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.D,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=""+i[s];0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},R:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.D,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.D,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.D=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=R(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.O&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,D:void 0,t:n,k:this,C:!1,O:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.D.set(n,!0),t.o.set(n,r),t.D.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.D.set(n,!1):r.D.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.D=new Map,i(n.t,(function(r){n.D.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=R(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,O:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{N:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){N(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=R(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.D[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&"number"!=typeof t&&(void 0!==t||r in n.o)||(n.o[r]=t,n.D[r]=!0,!0)},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.D[r]=!1,E(n),k(n)):delete n.D[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.g=B,this.F=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=R(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?O(c):g(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw O(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.F&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=D(e));var i=w(this),o=R(this,e,void 0);return o[Q].C=!0,g(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.F=n},i.setUseProxies=function(r){r&&!B&&n(20),this.g=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ __webpack_exports__["ZP"] = (fn);
//# sourceMappingURL=immer.esm.js.map


/***/ }),

/***/ 66439:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ isPlainObject; }
/* harmony export */ });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject(o) {
  var ctor,prot;

  if (isObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (ctor === undefined) return true;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}




/***/ }),

/***/ 63955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dq": function() { return /* binding */ useFieldArray; },
/* harmony export */   "Gc": function() { return /* binding */ useFormContext; },
/* harmony export */   "Qr": function() { return /* binding */ Controller; },
/* harmony export */   "RV": function() { return /* binding */ FormProvider; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "cI": function() { return /* binding */ useForm; }
/* harmony export */ });
/* unused harmony exports appendErrors, set, useController, useFormState, useWatch */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (!path || !isObject(obj)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
    return isUndefined(result) || result === obj
        ? isUndefined(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = (props) => {
    const { children, ...data } = props;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(HookFormContext.Provider, { value: data }, children));
};

var getProxyFormState = (formState, _proxyFormState, localProxyFormState, isRoot = true) => {
    const result = {};
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (_proxyFormState[_key] !== VALIDATION_MODE.all) {
                    _proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, isRoot) => {
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => exact && signalName
    ? name === signalName
    : !name ||
        !signalName ||
        name === signalName ||
        convertToArrayPayload(name).some((currentName) => currentName &&
            (currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = react__WEBPACK_IMPORTED_MODULE_0__.useRef(props);
    _props.current = props;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const tearDown = (subscription) => {
            if (subscription) {
                subscription.unsubscribe();
            }
        };
        const subscription = !props.disabled &&
            _props.current.subject.subscribe({
                next: _props.current.callback,
            });
        return () => tearDown(subscription);
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._formState);
    const _localProxyFormState = react__WEBPACK_IMPORTED_MODULE_0__.useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    const _mounted = react__WEBPACK_IMPORTED_MODULE_0__.useRef(true);
    _name.current = name;
    const callback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((value) => _mounted.current &&
        shouldSubscribeByName(_name.current, value.name, exact) &&
        shouldRenderFormState(value, _localProxyFormState.current) &&
        updateFormState({
            ...control._formState,
            ...value,
        }), [control, exact]);
    useSubscribe({
        disabled,
        callback,
        subject: control._subjects.state,
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        _mounted.current = true;
        return () => {
            _mounted.current = false;
        };
    }, []);
    return getProxyFormState(formState, control._proxyFormState, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal) => {
    const isArray = Array.isArray(names);
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names);
    }
    if (isArray) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName),
            get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

var isFunction = (value) => typeof value === 'function';

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    _name.current = name;
    const callback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((formState) => {
        if (shouldSubscribeByName(_name.current, formState.name, exact)) {
            const fieldValues = generateWatchOutput(_name.current, control._names, formState.values || control._formValues);
            updateValue(isUndefined(_name.current) ||
                (isObject(fieldValues) && !objectHasFunction(fieldValues))
                ? { ...fieldValues }
                : Array.isArray(fieldValues)
                    ? [...fieldValues]
                    : isUndefined(fieldValues)
                        ? defaultValue
                        : fieldValues);
        }
    }, [control, exact, defaultValue]);
    useSubscribe({
        disabled,
        subject: control._subjects.watch,
        callback,
    });
    const [value, updateValue] = react__WEBPACK_IMPORTED_MODULE_0__.useState(isUndefined(defaultValue)
        ? control._getWatch(name)
        : defaultValue);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        control._removeUnmounted();
    });
    return value;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(control.register(name, {
        ...props.rules,
        value,
    }));
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        return () => {
            const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
            (isArrayField
                ? _shouldUnregisterField && !control._stateFlags.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    return {
        field: {
            name,
            value,
            onChange: react__WEBPACK_IMPORTED_MODULE_0__.useCallback((event) => {
                _registerProps.current.onChange({
                    target: {
                        value: getEventValue(event),
                        name: name,
                    },
                    type: EVENTS.CHANGE,
                });
            }, [name]),
            onBlur: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
                _registerProps.current.onBlur({
                    target: {
                        value: get(control._formValues, name),
                        name: name,
                    },
                    type: EVENTS.BLUR,
                });
            }, [name, control]),
            ref: react__WEBPACK_IMPORTED_MODULE_0__.useCallback((elm) => {
                const field = get(control._fields, name);
                if (elm && field && elm.focus) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            }, [name, control._fields]),
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                get: () => get(formState.errors, name),
            },
        }),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus && isUndefined(_f.ref.focus())) {
                    break;
                }
                else if (_f.refs) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject(currentField)) {
                focusFieldBy(currentField, callback);
            }
        }
    }
};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isBoolean = (value) => typeof value === 'boolean';

var isFileInput = (element) => element.type === 'file';

var isMessage = (value) => isString(value) || react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || ' ');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) && !ref.value) ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || +inputValue;
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            if (isString(maxOutput.value)) {
                exceedMax = valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value)) {
                exceedMin = valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

function append(data, value) {
    return [...data, ...convertToArrayPayload(value)];
}

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        for (const key in data) {
            if (isFunction(data[key])) {
                copy = data;
                break;
            }
            copy[key] = cloneObject(data[key]);
        }
    }
    else {
        return data;
    }
    return copy;
}

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

function prepend(data, value) {
    return [...convertToArrayPayload(value), ...convertToArrayPayload(data)];
}

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    data[indexA] = [data[indexB], (data[indexB] = data[indexA])][0];
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (!isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const updatePath = isKey(path) ? [path] : stringToPath(path);
    const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) {
        delete childObject[key];
    }
    for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
            previousObjRef = object;
        }
        while (++index < currentPaths.length) {
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index &&
                ((isObject(objectRef) && isEmptyObject(objectRef)) ||
                    (Array.isArray(objectRef) && isEmptyArray(objectRef)))) {
                previousObjRef ? delete previousObjRef[item] : delete object[item];
            }
            previousObjRef = objectRef;
        }
    }
    return object;
}

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = react__WEBPACK_IMPORTED_MODULE_0__.useState(control._getFieldArray(name));
    const ids = react__WEBPACK_IMPORTED_MODULE_0__.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fields);
    const _name = react__WEBPACK_IMPORTED_MODULE_0__.useRef(name);
    const _actioned = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules &&
        control.register(name, props.rules);
    const callback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(({ values, name: fieldArrayName, }) => {
        if (fieldArrayName === _name.current || !fieldArrayName) {
            const fieldValues = get(values, _name.current, []);
            setFields(fieldValues);
            ids.current = fieldValues.map(generateId);
        }
    }, []);
    useSubscribe({
        callback,
        subject: control._subjects.array,
    });
    const updateValues = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append$1 = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = append(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = append(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, append, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend$1 = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prepend(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prepend(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prepend, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        control._stateFlags.action = false;
        isWatched(name, control._names) && control._subjects.state.next({});
        if (_actioned.current) {
            if (control._options.resolver) {
                control._executeSchema([name]).then((result) => {
                    const error = get(result.errors, name);
                    const existingError = get(control._formState.errors, name);
                    if (existingError ? !error && existingError.type : error && error.type) {
                        error
                            ? set(control._formState.errors, name, error)
                            : unset(control._formState.errors, name);
                        control._subjects.state.next({
                            errors: control._formState.errors,
                        });
                    }
                });
            }
            else {
                const field = get(control._fields, name);
                const validationModeBeforeSubmit = getValidationModes(control._options.mode);
                if ((!validationModeBeforeSubmit.isOnSubmit ||
                    control._formState.isSubmitted) &&
                    field &&
                    field._f) {
                    validateField(field, get(control._formValues, name), control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error) => !isEmptyObject(error) &&
                        control._subjects.state.next({
                            errors: updateFieldArrayRootError(control._formState.errors, error, name),
                        }));
                }
            }
        }
        control._subjects.watch.next({
            name,
            values: control._formValues,
        });
        control._names.focus &&
            focusFieldBy(control._fields, (key) => key.startsWith(control._names.focus));
        control._names.focus = '';
        control._proxyFormState.isValid && control._updateValid();
    }, [fields, name, control]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        !get(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(swap, [updateValues, name, control]),
        move: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(move, [updateValues, name, control]),
        prepend: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(prepend$1, [updateValues, name, control]),
        append: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(append$1, [updateValues, name, control]),
        remove: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(remove, [updateValues, name, control]),
        insert: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(insert$1, [updateValues, name, control]),
        update: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(update, [updateValues, name, control]),
        replace: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(replace, [updateValues, name, control]),
        fields: react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => fields.map((field, index) => ({
            ...field,
            [keyName]: ids.current[index] || generateId(),
        })), [fields, keyName]),
    };
}

function createSubject() {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isHTMLElement = (value) => {
    const owner = value ? value.ownerDocument : 0;
    const ElementClass = owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement;
    return value instanceof ElementClass;
};

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === '' || isNullOrUndefined(value)
            ? NaN
            : +value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? undefined
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    };
    let _fields = {};
    let _defaultValues = cloneObject(_options.defaultValues) || {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _stateFlags = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    let validateFields = {};
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        watch: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = window.setTimeout(callback, wait);
    };
    const _updateValid = async (shouldSkipRender) => {
        let isValid = false;
        if (_proxyFormState.isValid) {
            isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (!shouldSkipRender && isValid !== _formState.isValid) {
                _formState.isValid = isValid;
                _subjects.state.next({
                    isValid,
                });
            }
        }
        return isValid;
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _stateFlags.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (_proxyFormState.errors &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _stateFlags.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let isFieldDirty = false;
        const output = {
            name,
        };
        const isPreviousFieldTouched = get(_formState.touchedFields, name);
        if (_proxyFormState.isDirty) {
            const isPreviousFormDirty = _formState.isDirty;
            _formState.isDirty = output.isDirty = _getDirty();
            isFieldDirty = isPreviousFormDirty !== output.isDirty;
        }
        if (_proxyFormState.dirtyFields && (!isBlurEvent || shouldDirty)) {
            const isPreviousFieldDirty = get(_formState.dirtyFields, name);
            const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
            isCurrentFieldPristine
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            isFieldDirty =
                isFieldDirty ||
                    isPreviousFieldDirty !== get(_formState.dirtyFields, name);
        }
        if (isBlurEvent && !isPreviousFieldTouched) {
            set(_formState.touchedFields, name, isBlurEvent);
            output.touchedFields = _formState.touchedFields;
            isFieldDirty =
                isFieldDirty ||
                    (_proxyFormState.touchedFields &&
                        isPreviousFieldTouched !== isBlurEvent);
        }
        isFieldDirty && shouldRender && _subjects.state.next(output);
        return isFieldDirty ? output : {};
    };
    const shouldRenderByError = async (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        validateFields[name]--;
        if (_proxyFormState.isValidating &&
            !Object.values(validateFields).some((v) => v)) {
            _subjects.state.next({
                isValidating: false,
            });
            validateFields = {};
        }
    };
    const _executeSchema = async (name) => _options.resolver
        ? await _options.resolver({ ..._formValues }, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation))
        : {};
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema();
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, get(_formValues, _f.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => {
        const fieldValues = {
            ...(_stateFlags.mount
                ? _formValues
                : isUndefined(defaultValue)
                    ? _defaultValues
                    : isString(names)
                        ? { [names]: defaultValue }
                        : defaultValue),
        };
        return generateWatchOutput(names, _names, fieldValues, isGlobal);
    };
    const _getFieldArray = (name) => compact(get(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isWeb && isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((selectRef) => (selectRef.selected = fieldValue.includes(selectRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => !checkboxRef.disabled &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.watch.next({
                            name,
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: _formValues,
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
                _subjects.state.next({
                    name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
            name,
        });
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        const field = get(_fields, name);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type
                ? getFieldValue(field._f)
                : getEventValue(event);
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.watch.next({
                    name,
                    type: event.type,
                });
            if (shouldSkipValidation) {
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({});
            validateFields[name] = validateFields[name] ? +1 : 1;
            _subjects.state.next({
                isValidating: true,
            });
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = isEmptyObject(errors);
            }
            else {
                error = (await validateField(field, get(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isValid = await _updateValid(true);
            }
            field._f.deps &&
                trigger(field._f.deps);
            shouldRenderByError(name, isValid, error, fieldState);
        }
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _subjects.state.next({
            isValidating: true,
        });
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            focusFieldBy(_fields, (key) => get(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_stateFlags.mount ? _formValues : {}),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name
            ? convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName))
            : (_formState.errors = {});
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.watch.subscribe({
            next: (info) => name(_getWatch(undefined, defaultValue), info),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (get(_fields, fieldName)) {
                if (!options.keepValue) {
                    unset(_fields, fieldName);
                    unset(_formValues, fieldName);
                }
                !options.keepError && unset(_formState.errors, fieldName);
                !options.keepDirty && unset(_formState.dirtyFields, fieldName);
                !options.keepTouched && unset(_formState.touchedFields, fieldName);
                !_options.shouldUnregister &&
                    !options.keepDefaultValue &&
                    unset(_defaultValues, fieldName);
            }
        }
        _subjects.watch.next({});
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        field
            ? disabledIsDefined &&
                set(_formValues, name, options.disabled
                    ? undefined
                    : get(_formValues, name, getFieldValue(field._f)))
            : updateValidAndValue(name, true, options.value);
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.shouldUseNativeValidation
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(!!Array.isArray(get(_defaultValues, name))
                                            ? [{}]
                                            : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _stateFlags.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let hasNoPromiseError = true;
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        try {
            if (_options.resolver) {
                const { errors, values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            }
            else {
                await executeBuiltInValidation(_fields);
            }
            if (isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {},
                    isSubmitting: true,
                });
                await onValid(fieldValues, e);
            }
            else {
                if (onInvalid) {
                    await onInvalid({ ..._formState.errors }, e);
                }
                _options.shouldFocusError &&
                    focusFieldBy(_fields, (key) => get(_formState.errors, key), _names.mount);
            }
        }
        catch (err) {
            hasNoPromiseError = false;
            throw err;
        }
        finally {
            _formState.isSubmitted = true;
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && hasNoPromiseError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors,
            });
        }
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, get(_defaultValues, name));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, get(_defaultValues, name))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            try {
                                if (isHTMLElement(fieldReference)) {
                                    fieldReference.closest('form').reset();
                                    break;
                                }
                            }
                            catch (_a) { }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneUpdatedValues;
            _subjects.array.next({
                values,
            });
            _subjects.watch.next({
                values,
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        _stateFlags.mount =
            !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues
                ? _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors
                ? _formState.errors
                : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name)._f;
        const fieldRef = field.refs ? field.refs[0] : field.ref;
        fieldRef.focus();
        options.shouldSelect && fieldRef.select();
    };
    return {
        control: {
            register,
            unregister,
            getFieldState,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _getFieldArray,
            _subjects,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _stateFlags() {
                return _stateFlags;
            },
            set _stateFlags(value) {
                _stateFlags = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {},
    });
    if (_formControl.current) {
        _formControl.current.control._options = props;
    }
    else {
        _formControl.current = {
            ...createFormControl(props),
            formState,
        };
    }
    const control = _formControl.current.control;
    const callback = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((value) => {
        if (shouldRenderFormState(value, control._proxyFormState, true)) {
            control._formState = {
                ...control._formState,
                ...value,
            };
            updateFormState({ ...control._formState });
        }
    }, [control]);
    useSubscribe({
        subject: control._subjects.state,
        callback,
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (!control._stateFlags.mount) {
            control._proxyFormState.isValid && control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = getProxyFormState(formState, control._proxyFormState);
    return _formControl.current;
}


//# sourceMappingURL=index.esm.mjs.map


/***/ }),

/***/ 88932:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ toast; },
/* harmony export */   "Ix": function() { return /* binding */ ToastContainer; }
/* harmony export */ });
/* unused harmony exports Bounce, Flip, Icons, Slide, Zoom, collapseToast, cssTransition, useToast, useToastContainer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6277);



function isNum(v) {
  return typeof v === 'number' && !isNaN(v);
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isStr(v) {
  return typeof v === 'string';
}
function isFn(v) {
  return typeof v === 'function';
}
function parseClassName(v) {
  return isStr(v) || isFn(v) ? v : null;
}
function isToastIdValid(toastId) {
  return toastId != null;
}
function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
function canBeRendered(content) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(content) || isStr(content) || isFn(content) || isNum(content);
}

const POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
const TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default'
};

/**
 * Used to collapse toast after exit animation
 */
function collapseToast(node, done, duration
/* Default.COLLAPSE_DURATION */
) {
  if (duration === void 0) {
    duration = 300;
  }

  const {
    scrollHeight,
    style
  } = node;
  requestAnimationFrame(() => {
    style.minHeight = 'initial';
    style.height = scrollHeight + 'px';
    style.transition = "all " + duration + "ms";
    requestAnimationFrame(() => {
      style.height = '0';
      style.padding = '0';
      style.margin = '0';
      setTimeout(done, duration);
    });
  });
}

/**
 * Css animation that just work.
 * You could use animate.css for instance
 *
 *
 * ```
 * cssTransition({
 *   enter: "animate__animated animate__bounceIn",
 *   exit: "animate__animated animate__bounceOut"
 * })
 * ```
 *
 */

function cssTransition(_ref) {
  let {
    enter,
    exit,
    appendPosition = false,
    collapse = true,
    collapseDuration = 300
    /* Default.COLLAPSE_DURATION */

  } = _ref;
  return function ToastTransition(_ref2) {
    let {
      children,
      position,
      preventExitTransition,
      done,
      nodeRef,
      isIn
    } = _ref2;
    const enterClassName = appendPosition ? enter + "--" + position : enter;
    const exitClassName = appendPosition ? exit + "--" + position : exit;
    const animationStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0
    /* AnimationStep.Enter */
    );
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
      const node = nodeRef.current;
      const classToToken = enterClassName.split(' ');

      const onEntered = e => {
        if (e.target !== nodeRef.current) return;
        node.dispatchEvent(new Event("d"
        /* SyntheticEvent.ENTRANCE_ANIMATION_END */
        ));
        node.removeEventListener('animationend', onEntered);
        node.removeEventListener('animationcancel', onEntered);

        if (animationStep.current === 0
        /* AnimationStep.Enter */
        && e.type !== 'animationcancel') {
          node.classList.remove(...classToToken);
        }
      };

      const onEnter = () => {
        node.classList.add(...classToToken);
        node.addEventListener('animationend', onEntered);
        node.addEventListener('animationcancel', onEntered);
      };

      onEnter();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
      const node = nodeRef.current;

      const onExited = () => {
        node.removeEventListener('animationend', onExited);
        collapse ? collapseToast(node, done, collapseDuration) : done();
      };

      const onExit = () => {
        animationStep.current = 1
        /* AnimationStep.Exit */
        ;
        node.className += " " + exitClassName;
        node.addEventListener('animationend', onExited);
      };

      if (!isIn) preventExitTransition ? onExited() : onExit();
    }, [isIn]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  };
}

function toToastItem(toast, status) {
  return {
    content: toast.content,
    containerId: toast.props.containerId,
    id: toast.props.toastId,
    theme: toast.props.theme,
    type: toast.props.type,
    data: toast.props.data || {},
    isLoading: toast.props.isLoading,
    icon: toast.props.icon,
    status
  };
}

const eventManager = {
  list: new Map(),
  emitQueue: new Map(),

  on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },

  off(event, callback) {
    if (callback) {
      const cb = this.list.get(event).filter(cb => cb !== callback);
      this.list.set(event, cb);
      return this;
    }

    this.list.delete(event);
    return this;
  },

  cancelEmit(event) {
    const timers = this.emitQueue.get(event);

    if (timers) {
      timers.forEach(clearTimeout);
      this.emitQueue.delete(event);
    }

    return this;
  },

  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit(event) {
    this.list.has(event) && this.list.get(event).forEach(callback => {
      const timer = setTimeout(() => {
        // @ts-ignore
        callback(...[].slice.call(arguments, 1));
      }, 0);
      this.emitQueue.has(event) || this.emitQueue.set(event, []);
      this.emitQueue.get(event).push(timer);
    });
  }

};

const Svg = _ref => {
  let {
    theme,
    type,
    ...rest
  } = _ref;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    fill: theme === 'colored' ? 'currentColor' : "var(--toastify-icon-color-" + type + ")",
    ...rest
  });
};

function Warning(props) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Svg, { ...props
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
  }));
}

function Info(props) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Svg, { ...props
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
  }));
}

function Success(props) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Svg, { ...props
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
  }));
}

function Error(props) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Svg, { ...props
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
  }));
}

function Spinner() {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "Toastify"
    /* Default.CSS_NAMESPACE */
    + "__spinner"
  });
}

const Icons = {
  info: Info,
  warning: Warning,
  success: Success,
  error: Error,
  spinner: Spinner
};

const maybeIcon = type => type in Icons;

function getIcon(_ref2) {
  let {
    theme,
    type,
    isLoading,
    icon
  } = _ref2;
  let Icon = null;
  const iconProps = {
    theme,
    type
  };

  if (icon === false) ; else if (isFn(icon)) {
    Icon = icon(iconProps);
  } else if ((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(icon)) {
    Icon = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(icon, iconProps);
  } else if (isStr(icon) || isNum(icon)) {
    Icon = icon;
  } else if (isLoading) {
    Icon = Icons.spinner();
  } else if (maybeIcon(type)) {
    Icon = Icons[type](iconProps);
  }

  return Icon;
}

function useToastContainer(props) {
  const [, forceUpdate] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(x => x + 1, 0);
  const [toastIds, setToastIds] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const toastToRender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Map()).current;

  const isToastActive = id => toastIds.indexOf(id) !== -1;

  const instance = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    toastKey: 1,
    displayedToast: 0,
    count: 0,
    queue: [],
    props,
    containerId: null,
    isToastActive,
    getToast: id => toastToRender.get(id)
  }).current;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(3
    /* Event.WillUnmount */
    ).on(0
    /* Event.Show */
    , buildToast).on(1
    /* Event.Clear */
    , toastId => containerRef.current && removeToast(toastId)).on(5
    /* Event.ClearWaitingQueue */
    , clearWaitingQueue).emit(2
    /* Event.DidMount */
    , instance);
    return () => {
      toastToRender.clear();
      eventManager.emit(3
      /* Event.WillUnmount */
      , instance);
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    instance.props = props;
    instance.isToastActive = isToastActive;
    instance.displayedToast = toastIds.length;
  });

  function clearWaitingQueue(_ref) {
    let {
      containerId
    } = _ref;
    const {
      limit
    } = instance.props;

    if (limit && (!containerId || instance.containerId === containerId)) {
      instance.count -= instance.queue.length;
      instance.queue = [];
    }
  }

  function removeToast(toastId) {
    setToastIds(state => isToastIdValid(toastId) ? state.filter(id => id !== toastId) : []);
  }

  function dequeueToast() {
    const {
      toastContent,
      toastProps,
      staleId
    } = instance.queue.shift();
    appendToast(toastContent, toastProps, staleId);
  }
  /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */


  function isNotValid(options) {
    return !containerRef.current || instance.props.enableMultiContainer && options.containerId !== instance.props.containerId || toastToRender.has(options.toastId) && options.updateId == null;
  } // this function and all the function called inside needs to rely on refs


  function buildToast(content, _ref2) {
    let {
      delay,
      staleId,
      ...options
    } = _ref2;
    if (!canBeRendered(content) || isNotValid(options)) return;
    const {
      toastId,
      updateId,
      data
    } = options;
    const {
      props
    } = instance;

    const closeToast = () => removeToast(toastId);

    const isNotAnUpdate = updateId == null;
    if (isNotAnUpdate) instance.count++;
    const toastProps = {
      toastId,
      updateId,
      data,
      containerId: options.containerId,
      isLoading: options.isLoading,
      theme: options.theme || props.theme,
      icon: options.icon != null ? options.icon : props.icon,
      isIn: false,
      key: options.key || instance.toastKey++,
      type: options.type,
      closeToast: closeToast,
      closeButton: options.closeButton,
      rtl: props.rtl,
      position: options.position || props.position,
      transition: options.transition || props.transition,
      className: parseClassName(options.className || props.toastClassName),
      bodyClassName: parseClassName(options.bodyClassName || props.bodyClassName),
      style: options.style || props.toastStyle,
      bodyStyle: options.bodyStyle || props.bodyStyle,
      onClick: options.onClick || props.onClick,
      pauseOnHover: isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
      pauseOnFocusLoss: isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
      draggable: isBool(options.draggable) ? options.draggable : props.draggable,
      draggablePercent: options.draggablePercent || props.draggablePercent,
      draggableDirection: options.draggableDirection || props.draggableDirection,
      closeOnClick: isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
      progressClassName: parseClassName(options.progressClassName || props.progressClassName),
      progressStyle: options.progressStyle || props.progressStyle,
      autoClose: options.isLoading ? false : getAutoCloseDelay(options.autoClose, props.autoClose),
      hideProgressBar: isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
      progress: options.progress,
      role: options.role || props.role,

      deleteToast() {
        const removed = toToastItem(toastToRender.get(toastId), 'removed');
        toastToRender.delete(toastId);
        eventManager.emit(4
        /* Event.Change */
        , removed);
        const queueLen = instance.queue.length;
        instance.count = isToastIdValid(toastId) ? instance.count - 1 : instance.count - instance.displayedToast;
        if (instance.count < 0) instance.count = 0;

        if (queueLen > 0) {
          const freeSlot = isToastIdValid(toastId) ? 1 : instance.props.limit;

          if (queueLen === 1 || freeSlot === 1) {
            instance.displayedToast++;
            dequeueToast();
          } else {
            const toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
            instance.displayedToast = toDequeue;

            for (let i = 0; i < toDequeue; i++) dequeueToast();
          }
        } else {
          forceUpdate();
        }
      }

    };
    toastProps.iconOut = getIcon(toastProps);
    if (isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
    if (isFn(options.onClose)) toastProps.onClose = options.onClose;
    toastProps.closeButton = props.closeButton;

    if (options.closeButton === false || canBeRendered(options.closeButton)) {
      toastProps.closeButton = options.closeButton;
    } else if (options.closeButton === true) {
      toastProps.closeButton = canBeRendered(props.closeButton) ? props.closeButton : true;
    }

    let toastContent = content;

    if ((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(content) && !isStr(content.type)) {
      toastContent = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(content, {
        closeToast,
        toastProps,
        data
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast,
        toastProps,
        data
      });
    } // not handling limit + delay by design. Waiting for user feedback first


    if (props.limit && props.limit > 0 && instance.count > props.limit && isNotAnUpdate) {
      instance.queue.push({
        toastContent,
        toastProps,
        staleId
      });
    } else if (isNum(delay)) {
      setTimeout(() => {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }

  function appendToast(content, toastProps, staleId) {
    const {
      toastId
    } = toastProps;
    if (staleId) toastToRender.delete(staleId);
    const toast = {
      content,
      props: toastProps
    };
    toastToRender.set(toastId, toast);
    setToastIds(state => [...state, toastId].filter(id => id !== staleId));
    eventManager.emit(4
    /* Event.Change */
    , toToastItem(toast, toast.props.updateId == null ? 'added' : 'updated'));
  }

  function getToastToRender(cb) {
    const toRender = new Map();
    const collection = Array.from(toastToRender.values());
    if (props.newestOnTop) collection.reverse();
    collection.forEach(toast => {
      const {
        position
      } = toast.props;
      toRender.has(position) || toRender.set(position, []);
      toRender.get(position).push(toast);
    });
    return Array.from(toRender, p => cb(p[0], p[1]));
  }

  return {
    getToastToRender,
    containerRef,
    isToastActive
  };
}

function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}

function useToast(props) {
  const [isRunning, setIsRunning] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [preventExitTransition, setPreventExitTransition] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const toastRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const drag = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null,
    didMove: false
  }).current;
  const syncProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(props);
  const {
    autoClose,
    pauseOnHover,
    closeToast,
    onClick,
    closeOnClick
  } = props;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    syncProps.current = props;
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (toastRef.current) toastRef.current.addEventListener("d"
    /* SyntheticEvent.ENTRANCE_ANIMATION_END */
    , playToast, {
      once: true
    });
    if (isFn(props.onOpen)) props.onOpen((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(props.children) && props.children.props);
    return () => {
      const props = syncProps.current;
      if (isFn(props.onClose)) props.onClose((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(props.children) && props.children.props);
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    props.pauseOnFocusLoss && bindFocusEvents();
    return () => {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);

  function onDragStart(e) {
    if (props.draggable) {
      bindDragEvents();
      const toast = toastRef.current;
      drag.canCloseOnClick = true;
      drag.canDrag = true;
      drag.boundingRect = toast.getBoundingClientRect();
      toast.style.transition = '';
      drag.x = getX(e.nativeEvent);
      drag.y = getY(e.nativeEvent);

      if (props.draggableDirection === "x"
      /* Direction.X */
      ) {
        drag.start = drag.x;
        drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
      } else {
        drag.start = drag.y;
        drag.removalDistance = toast.offsetHeight * (props.draggablePercent === 80
        /* Default.DRAGGABLE_PERCENT */
        ? props.draggablePercent * 1.5 : props.draggablePercent / 100);
      }
    }
  }

  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      const {
        top,
        bottom,
        left,
        right
      } = drag.boundingRect;

      if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }

  function playToast() {
    setIsRunning(true);
  }

  function pauseToast() {
    setIsRunning(false);
  }

  function bindFocusEvents() {
    if (!document.hasFocus()) pauseToast();
    window.addEventListener('focus', playToast);
    window.addEventListener('blur', pauseToast);
  }

  function unbindFocusEvents() {
    window.removeEventListener('focus', playToast);
    window.removeEventListener('blur', pauseToast);
  }

  function bindDragEvents() {
    drag.didMove = false;
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchmove', onDragMove);
    document.addEventListener('touchend', onDragEnd);
  }

  function unbindDragEvents() {
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    document.removeEventListener('touchmove', onDragMove);
    document.removeEventListener('touchend', onDragEnd);
  }

  function onDragMove(e) {
    const toast = toastRef.current;

    if (drag.canDrag && toast) {
      drag.didMove = true;
      if (isRunning) pauseToast();
      drag.x = getX(e);
      drag.y = getY(e);

      if (props.draggableDirection === "x"
      /* Direction.X */
      ) {
        drag.delta = drag.x - drag.start;
      } else {
        drag.delta = drag.y - drag.start;
      } // prevent false positif during a toast click


      if (drag.start !== drag.x) drag.canCloseOnClick = false;
      toast.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
      toast.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
    }
  }

  function onDragEnd() {
    unbindDragEvents();
    const toast = toastRef.current;

    if (drag.canDrag && drag.didMove && toast) {
      drag.canDrag = false;

      if (Math.abs(drag.delta) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }

      toast.style.transition = 'transform 0.2s, opacity 0.2s';
      toast.style.transform = "translate" + props.draggableDirection + "(0)";
      toast.style.opacity = '1';
    }
  }

  const eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };

  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  } // prevent toast from closing when user drags the toast


  if (closeOnClick) {
    eventHandlers.onClick = e => {
      onClick && onClick(e);
      drag.canCloseOnClick && closeToast();
    };
  }

  return {
    playToast,
    pauseToast,
    isRunning,
    preventExitTransition,
    toastRef,
    eventHandlers
  };
}

function CloseButton(_ref) {
  let {
    closeToast,
    theme,
    ariaLabel = 'close'
  } = _ref;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    className: "Toastify"
    /* Default.CSS_NAMESPACE */
    + "__close-button " + "Toastify"
    /* Default.CSS_NAMESPACE */
    + "__close-button--" + theme,
    type: "button",
    onClick: e => {
      e.stopPropagation();
      closeToast(e);
    },
    "aria-label": ariaLabel
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}

function ProgressBar(_ref) {
  let {
    delay,
    isRunning,
    closeToast,
    type,
    hide,
    className,
    style: userStyle,
    controlledProgress,
    progress,
    rtl,
    isIn,
    theme
  } = _ref;
  const style = { ...userStyle,
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? 'running' : 'paused',
    opacity: hide ? 0 : 1
  };
  if (controlledProgress) style.transform = "scaleX(" + progress + ")";
  const defaultClassName = (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify"
  /* Default.CSS_NAMESPACE */
  + "__progress-bar", controlledProgress ? "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__progress-bar--controlled" : "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__progress-bar--animated", "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__progress-bar-theme--" + theme, "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__progress-bar--" + type, {
    ["Toastify"
    /* Default.CSS_NAMESPACE */
    + "__progress-bar--rtl"]: rtl
  });
  const classNames = isFn(className) ? className({
    rtl,
    type,
    defaultClassName
  }) : (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])(defaultClassName, className); // 🧐 controlledProgress is derived from progress
  // so if controlledProgress is set
  // it means that this is also the case for progress

  const animationEvent = {
    [controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd']: controlledProgress && progress < 1 ? null : () => {
      isIn && closeToast();
    }
  }; // TODO: add aria-valuenow, aria-valuemax, aria-valuemin

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    role: "progressbar",
    "aria-hidden": hide ? 'true' : 'false',
    "aria-label": "notification timer",
    className: classNames,
    style: style,
    ...animationEvent
  });
}
ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};

const Toast = props => {
  const {
    isRunning,
    preventExitTransition,
    toastRef,
    eventHandlers
  } = useToast(props);
  const {
    closeButton,
    children,
    autoClose,
    onClick,
    type,
    hideProgressBar,
    closeToast,
    transition: Transition,
    position,
    className,
    style,
    bodyClassName,
    bodyStyle,
    progressClassName,
    progressStyle,
    updateId,
    role,
    progress,
    rtl,
    toastId,
    deleteToast,
    isIn,
    isLoading,
    iconOut,
    theme
  } = props;
  const defaultClassName = (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify"
  /* Default.CSS_NAMESPACE */
  + "__toast", "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__toast-theme--" + theme, "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__toast--" + type, {
    ["Toastify"
    /* Default.CSS_NAMESPACE */
    + "__toast--rtl"]: rtl
  });
  const cssClasses = isFn(className) ? className({
    rtl,
    position,
    type,
    defaultClassName
  }) : (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])(defaultClassName, className);
  const isProgressControlled = !!progress;
  const closeButtonProps = {
    closeToast,
    type,
    theme
  };
  let Close = null;

  if (closeButton === false) ; else if (isFn(closeButton)) {
    Close = closeButton(closeButtonProps);
  } else if (react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(closeButton)) {
    Close = react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(closeButton, closeButtonProps);
  } else {
    Close = CloseButton(closeButtonProps);
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Transition, {
    isIn: isIn,
    done: deleteToast,
    position: position,
    preventExitTransition: preventExitTransition,
    nodeRef: toastRef
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    id: toastId,
    onClick: onClick,
    className: cssClasses,
    ...eventHandlers,
    style: style,
    ref: toastRef
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { ...(isIn && {
      role: role
    }),
    className: isFn(bodyClassName) ? bodyClassName({
      type
    }) : (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify"
    /* Default.CSS_NAMESPACE */
    + "__toast-body", bodyClassName),
    style: bodyStyle
  }, iconOut != null && react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify"
    /* Default.CSS_NAMESPACE */
    + "__toast-icon", {
      ["Toastify"
      /* Default.CSS_NAMESPACE */
      + "--animate-icon " + "Toastify"
      /* Default.CSS_NAMESPACE */
      + "__zoom-enter"]: !isLoading
    })
  }, iconOut), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, children)), Close, (autoClose || isProgressControlled) && react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProgressBar, { ...(updateId && !isProgressControlled ? {
      key: "pb-" + updateId
    } : {}),
    rtl: rtl,
    theme: theme,
    delay: autoClose,
    isRunning: isRunning,
    isIn: isIn,
    closeToast: closeToast,
    hide: hideProgressBar,
    type: type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: isProgressControlled,
    progress: progress
  })));
};

const Bounce = cssTransition({
  enter: "Toastify"
  /* Default.CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__bounce-enter",
  exit: "Toastify"
  /* Default.CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__bounce-exit",
  appendPosition: true
});
const Slide = cssTransition({
  enter: "Toastify"
  /* Default.CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__slide-enter",
  exit: "Toastify"
  /* Default.CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__slide-exit",
  appendPosition: true
});
const Zoom = cssTransition({
  enter: "Toastify"
  /* Default.CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__zoom-enter",
  exit: "Toastify"
  /* Default.CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__zoom-exit"
});
const Flip = cssTransition({
  enter: "Toastify"
  /* Default.CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__flip-enter",
  exit: "Toastify"
  /* Default.CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* Default.CSS_NAMESPACE */
  + "__flip-exit"
});

// https://github.com/yannickcr/eslint-plugin-react/issues/3140
const ToastContainer = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => {
  const {
    getToastToRender,
    containerRef,
    isToastActive
  } = useToastContainer(props);
  const {
    className,
    style,
    rtl,
    containerId
  } = props;

  function getClassName(position) {
    const defaultClassName = (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify"
    /* Default.CSS_NAMESPACE */
    + "__toast-container", "Toastify"
    /* Default.CSS_NAMESPACE */
    + "__toast-container--" + position, {
      ["Toastify"
      /* Default.CSS_NAMESPACE */
      + "__toast-container--rtl"]: rtl
    });
    return isFn(className) ? className({
      position,
      rtl,
      defaultClassName
    }) : (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])(defaultClassName, parseClassName(className));
  }

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (ref) {
      ref.current = containerRef.current;
    }
  }, []);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: containerRef,
    className: "Toastify"
    /* Default.CSS_NAMESPACE */
    ,
    id: containerId
  }, getToastToRender((position, toastList) => {
    const containerStyle = !toastList.length ? { ...style,
      pointerEvents: 'none'
    } : { ...style
    };
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: getClassName(position),
      style: containerStyle,
      key: "container-" + position
    }, toastList.map((_ref, i) => {
      let {
        content,
        props: toastProps
      } = _ref;
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Toast, { ...toastProps,
        isIn: isToastActive(toastProps.toastId),
        style: { ...toastProps.style,
          '--nth': i + 1,
          '--len': toastList.length
        },
        key: "toast-" + toastProps.key
      }, content);
    }));
  }));
});
ToastContainer.displayName = 'ToastContainer';
ToastContainer.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80
  /* Default.DRAGGABLE_PERCENT */
  ,
  draggableDirection: "x"
  /* Direction.X */
  ,
  role: 'alert',
  theme: 'light'
};

let containers = new Map();
let latestInstance;
let queue = [];
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */

function getToast(toastId, _ref) {
  let {
    containerId
  } = _ref;
  const container = containers.get(containerId || latestInstance);
  if (!container) return null;
  return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */


function generateToastId() {
  return Math.random().toString(36).substring(2, 9);
}
/**
 * Generate a toastId or use the one provided
 */


function getToastId(options) {
  if (options && (isStr(options.toastId) || isNum(options.toastId))) {
    return options.toastId;
  }

  return generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */


function dispatchToast(content, options) {
  if (containers.size > 0) {
    eventManager.emit(0
    /* Event.Show */
    , content, options);
  } else {
    queue.push({
      content,
      options
    });
  }

  return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */


function mergeOptions(type, options) {
  return { ...options,
    type: options && options.type || type,
    toastId: getToastId(options)
  };
}

function createToastByType(type) {
  return (content, options) => dispatchToast(content, mergeOptions(type, options));
}

function toast(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options));
}

toast.loading = (content, options) => dispatchToast(content, mergeOptions(TYPE.DEFAULT, {
  isLoading: true,
  autoClose: false,
  closeOnClick: false,
  closeButton: false,
  draggable: false,
  ...options
}));

function handlePromise(promise, _ref2, options) {
  let {
    pending,
    error,
    success
  } = _ref2;
  let id;

  if (pending) {
    id = isStr(pending) ? toast.loading(pending, options) : toast.loading(pending.render, { ...options,
      ...pending
    });
  }

  const resetParams = {
    isLoading: null,
    autoClose: null,
    closeOnClick: null,
    closeButton: null,
    draggable: null,
    delay: 100
  };

  const resolver = (type, input, result) => {
    // Remove the toast if the input has not been provided. This prevents the toast from hanging
    // in the pending state if a success/error toast has not been provided.
    if (input == null) {
      toast.dismiss(id);
      return;
    }

    const baseParams = {
      type,
      ...resetParams,
      ...options,
      data: result
    };
    const params = isStr(input) ? {
      render: input
    } : input; // if the id is set we know that it's an update

    if (id) {
      toast.update(id, { ...baseParams,
        ...params
      });
    } else {
      // using toast.promise without loading
      toast(params.render, { ...baseParams,
        ...params
      });
    }

    return result;
  };

  const p = isFn(promise) ? promise() : promise; //call the resolvers only when needed

  p.then(result => resolver('success', success, result)).catch(err => resolver('error', error, err));
  return p;
}

toast.promise = handlePromise;
toast.success = createToastByType(TYPE.SUCCESS);
toast.info = createToastByType(TYPE.INFO);
toast.error = createToastByType(TYPE.ERROR);
toast.warning = createToastByType(TYPE.WARNING);
toast.warn = toast.warning;

toast.dark = (content, options) => dispatchToast(content, mergeOptions(TYPE.DEFAULT, {
  theme: 'dark',
  ...options
}));
/**
 * Remove toast programmaticaly
 */


toast.dismiss = id => {
  if (containers.size > 0) {
    eventManager.emit(1
    /* Event.Clear */
    , id);
  } else {
    queue = queue.filter(t => isToastIdValid(id) && t.options.toastId !== id);
  }
};
/**
 * Clear waiting queue when limit is used
 */


toast.clearWaitingQueue = function (params) {
  if (params === void 0) {
    params = {};
  }

  return eventManager.emit(5
  /* Event.ClearWaitingQueue */
  , params);
};
/**
 * return true if one container is displaying the toast
 */


toast.isActive = id => {
  let isToastActive = false;
  containers.forEach(container => {
    if (container.isToastActive && container.isToastActive(id)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};

toast.update = function (toastId, options) {
  if (options === void 0) {
    options = {};
  }

  // if you call toast and toast.update directly nothing will be displayed
  // this is why I defered the update
  setTimeout(() => {
    const toast = getToast(toastId, options);

    if (toast) {
      const {
        props: oldOptions,
        content: oldContent
      } = toast;
      const nextOptions = { ...oldOptions,
        ...options,
        toastId: options.toastId || toastId,
        updateId: generateToastId()
      };
      if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
      const content = nextOptions.render || oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};
/**
 * Used for controlled progress bar.
 */


toast.done = id => {
  toast.update(id, {
    progress: 1
  });
};
/**
 * Subscribe to change when a toast is added, removed and updated
 *
 * Usage:
 * ```
 * const unsubscribe = toast.onChange((payload) => {
 *   switch (payload.status) {
 *   case "added":
 *     // new toast added
 *     break;
 *   case "updated":
 *     // toast updated
 *     break;
 *   case "removed":
 *     // toast has been removed
 *     break;
 *   }
 * })
 * ```
 */


toast.onChange = callback => {
  eventManager.on(4
  /* Event.Change */
  , callback);
  return () => {
    eventManager.off(4
    /* Event.Change */
    , callback);
  };
};

toast.POSITION = POSITION;
toast.TYPE = TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */

eventManager.on(2
/* Event.DidMount */
, containerInstance => {
  latestInstance = containerInstance.containerId || containerInstance;
  containers.set(latestInstance, containerInstance);
  queue.forEach(item => {
    eventManager.emit(0
    /* Event.Show */
    , item.content, item.options);
  });
  queue = [];
}).on(3
/* Event.WillUnmount */
, containerInstance => {
  containers.delete(containerInstance.containerId || containerInstance);

  if (containers.size === 0) {
    eventManager.off(0
    /* Event.Show */
    ).off(1
    /* Event.Clear */
    ).off(5
    /* Event.ClearWaitingQueue */
    );
  }
});


//# sourceMappingURL=react-toastify.esm.mjs.map


/***/ }),

/***/ 35948:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U6": function() { return /* binding */ setVerbosity; },
/* harmony export */   "ej": function() { return /* binding */ InvariantError; },
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5163);

var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));

function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["debug", "log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name) {
    return function () {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.debug = wrapConsoleMethod("debug");
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (invariant)));
//# sourceMappingURL=invariant.js.map

/***/ }),

/***/ 12129:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ Observable; }
/* harmony export */ });
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(observer, subscriber) {
    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  var _proto = Subscription.prototype;

  _proto.unsubscribe = function unsubscribe() {
    if (this._state !== 'closed') {
      closeSubscription(this);
      cleanupSubscription(this);
    }
  };

  _createClass(Subscription, [{
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = /*#__PURE__*/function () {
  function SubscriptionObserver(subscription) {
    this._subscription = subscription;
  }

  var _proto2 = SubscriptionObserver.prototype;

  _proto2.next = function next(value) {
    onNotify(this._subscription, 'next', value);
  };

  _proto2.error = function error(value) {
    onNotify(this._subscription, 'error', value);
  };

  _proto2.complete = function complete() {
    onNotify(this._subscription, 'complete');
  };

  _createClass(SubscriptionObserver, [{
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = /*#__PURE__*/function () {
  function Observable(subscriber) {
    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  var _proto3 = Observable.prototype;

  _proto3.subscribe = function subscribe(observer) {
    if (typeof observer !== 'object' || observer === null) {
      observer = {
        next: observer,
        error: arguments[1],
        complete: arguments[2]
      };
    }

    return new Subscription(observer, this._subscriber);
  };

  _proto3.forEach = function forEach(fn) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (typeof fn !== 'function') {
        reject(new TypeError(fn + ' is not a function'));
        return;
      }

      function done() {
        subscription.unsubscribe();
        resolve();
      }

      var subscription = _this.subscribe({
        next: function (value) {
          try {
            fn(value, done);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  };

  _proto3.map = function map(fn) {
    var _this2 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this2.subscribe({
        next: function (value) {
          try {
            value = fn(value);
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.filter = function filter(fn) {
    var _this3 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this3.subscribe({
        next: function (value) {
          try {
            if (!fn(value)) return;
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.reduce = function reduce(fn) {
    var _this4 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    var hasSeed = arguments.length > 1;
    var hasValue = false;
    var seed = arguments[1];
    var acc = seed;
    return new C(function (observer) {
      return _this4.subscribe({
        next: function (value) {
          var first = !hasValue;
          hasValue = true;

          if (!first || hasSeed) {
            try {
              acc = fn(acc, value);
            } catch (e) {
              return observer.error(e);
            }
          } else {
            acc = value;
          }
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
          observer.next(acc);
          observer.complete();
        }
      });
    });
  };

  _proto3.concat = function concat() {
    var _this5 = this;

    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
      sources[_key] = arguments[_key];
    }

    var C = getSpecies(this);
    return new C(function (observer) {
      var subscription;
      var index = 0;

      function startNext(next) {
        subscription = next.subscribe({
          next: function (v) {
            observer.next(v);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (index === sources.length) {
              subscription = undefined;
              observer.complete();
            } else {
              startNext(C.from(sources[index++]));
            }
          }
        });
      }

      startNext(_this5);
      return function () {
        if (subscription) {
          subscription.unsubscribe();
          subscription = undefined;
        }
      };
    });
  };

  _proto3.flatMap = function flatMap(fn) {
    var _this6 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      var subscriptions = [];

      var outer = _this6.subscribe({
        next: function (value) {
          if (fn) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
          }

          var inner = C.from(value).subscribe({
            next: function (value) {
              observer.next(value);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              var i = subscriptions.indexOf(inner);
              if (i >= 0) subscriptions.splice(i, 1);
              completeIfDone();
            }
          });
          subscriptions.push(inner);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          completeIfDone();
        }
      });

      function completeIfDone() {
        if (outer.closed && subscriptions.length === 0) observer.complete();
      }

      return function () {
        subscriptions.forEach(function (s) {
          return s.unsubscribe();
        });
        outer.unsubscribe();
      };
    });
  };

  _proto3[SymbolObservable] = function () {
    return this;
  };

  Observable.from = function from(x) {
    var C = typeof this === 'function' ? this : Observable;
    if (x == null) throw new TypeError(x + ' is not an object');
    var method = getMethod(x, SymbolObservable);

    if (method) {
      var observable = method.call(x);
      if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
      if (isObservable(observable) && observable.constructor === C) return observable;
      return new C(function (observer) {
        return observable.subscribe(observer);
      });
    }

    if (hasSymbol('iterator')) {
      method = getMethod(x, SymbolIterator);

      if (method) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var _iterator = _createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;) {
              var item = _step.value;
              observer.next(item);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }
    }

    if (Array.isArray(x)) {
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < x.length; ++i) {
            observer.next(x[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }

    throw new TypeError(x + ' is not observable');
  };

  Observable.of = function of() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }

    var C = typeof this === 'function' ? this : Observable;
    return new C(function (observer) {
      enqueue(function () {
        if (observer.closed) return;

        for (var i = 0; i < items.length; ++i) {
          observer.next(items[i]);
          if (observer.closed) return;
        }

        observer.complete();
      });
    });
  };

  _createClass(Observable, null, [{
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(90283), __webpack_exec__(93642); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);